import { gql } from '@apollo/client';
import * as Apollo from '@apollo/client';
export type Maybe<T> = T | null;
export type InputMaybe<T> = Maybe<T>;
export type Exact<T extends { [key: string]: unknown }> = { [K in keyof T]: T[K] };
export type MakeOptional<T, K extends keyof T> = Omit<T, K> & { [SubKey in K]?: Maybe<T[SubKey]> };
export type MakeMaybe<T, K extends keyof T> = Omit<T, K> & { [SubKey in K]: Maybe<T[SubKey]> };
export type MakeEmpty<T extends { [key: string]: unknown }, K extends keyof T> = { [_ in K]?: never };
export type Incremental<T> = T | { [P in keyof T]?: P extends ' $fragmentName' | '__typename' ? T[P] : never };
const defaultOptions = {} as const;
/** All built-in and custom scalars, mapped to their actual values */
export type Scalars = {
  ID: { input: string; output: string; }
  String: { input: string; output: string; }
  Boolean: { input: boolean; output: boolean; }
  Int: { input: number; output: number; }
  Float: { input: number; output: number; }
  BigInt: { input: any; output: any; }
  Byte: { input: any; output: any; }
  Currency: { input: any; output: any; }
  Date: { input: any; output: any; }
  DateTime: { input: any; output: any; }
  Duration: { input: any; output: any; }
  EmailAddress: { input: any; output: any; }
  GUID: { input: any; output: any; }
  HSL: { input: any; output: any; }
  HSLA: { input: any; output: any; }
  HexColorCode: { input: any; output: any; }
  Hexadecimal: { input: any; output: any; }
  IBAN: { input: any; output: any; }
  IPv4: { input: any; output: any; }
  IPv6: { input: any; output: any; }
  ISBN: { input: any; output: any; }
  ISO8601Duration: { input: any; output: any; }
  JSON: { input: any; output: any; }
  JSONObject: { input: any; output: any; }
  JWT: { input: any; output: any; }
  Latitude: { input: any; output: any; }
  LocalDate: { input: any; output: any; }
  LocalEndTime: { input: any; output: any; }
  LocalTime: { input: any; output: any; }
  Long: { input: any; output: any; }
  Longitude: { input: any; output: any; }
  MAC: { input: any; output: any; }
  NegativeFloat: { input: any; output: any; }
  NegativeInt: { input: any; output: any; }
  NonEmptyString: { input: any; output: any; }
  NonNegativeFloat: { input: number; output: number; }
  NonNegativeInt: { input: number; output: number; }
  NonPositiveFloat: { input: any; output: any; }
  NonPositiveInt: { input: any; output: any; }
  ObjectID: { input: any; output: any; }
  PhoneNumber: { input: any; output: any; }
  Port: { input: any; output: any; }
  PositiveFloat: { input: any; output: any; }
  PositiveInt: { input: any; output: any; }
  PostalCode: { input: any; output: any; }
  RGB: { input: any; output: any; }
  RGBA: { input: any; output: any; }
  SafeInt: { input: any; output: any; }
  Time: { input: any; output: any; }
  Timestamp: { input: number; output: number; }
  URL: { input: any; output: any; }
  USCurrency: { input: any; output: any; }
  UUID: { input: any; output: any; }
  UnsignedFloat: { input: any; output: any; }
  UnsignedInt: { input: any; output: any; }
  UtcOffset: { input: any; output: any; }
  Void: { input: any; output: any; }
};

export type AccountOnboardLinkInput = {
  refreshUrl: Scalars['String']['input'];
  returnUrl: Scalars['String']['input'];
};

/**
 * Acquisition tracking data captured at booking time.
 *
 * Populated by the widget and portal under a "last non-direct click"
 * attribution model (matches GA4 / Google Ads defaults) — the stored record
 * is updated whenever the visitor arrives with a recognized marketing
 * signal; direct/internal navigation does not overwrite.
 *
 * Fields map 1:1 to keys captured from query strings. See the corresponding
 * attribution modules in the widget and portal for capture semantics.
 *
 * The underlying column is JSONB (see `appointments.acquisition_source`),
 * so older records may be missing the click ID and timestamp fields added
 * below — consumers should treat every field as nullable.
 */
export type AcquisitionSource = {
  __typename?: 'AcquisitionSource';
  fbclid?: Maybe<Scalars['String']['output']>;
  first_touch_at?: Maybe<Scalars['NonNegativeInt']['output']>;
  gad_campaignid?: Maybe<Scalars['String']['output']>;
  gad_source?: Maybe<Scalars['String']['output']>;
  gbraid?: Maybe<Scalars['String']['output']>;
  gclid?: Maybe<Scalars['String']['output']>;
  landing_page_url?: Maybe<Scalars['String']['output']>;
  last_touch_at?: Maybe<Scalars['NonNegativeInt']['output']>;
  li_fat_id?: Maybe<Scalars['String']['output']>;
  msclkid?: Maybe<Scalars['String']['output']>;
  referrer_url?: Maybe<Scalars['String']['output']>;
  ttclid?: Maybe<Scalars['String']['output']>;
  twclid?: Maybe<Scalars['String']['output']>;
  utm_campaign?: Maybe<Scalars['String']['output']>;
  utm_content?: Maybe<Scalars['String']['output']>;
  utm_medium?: Maybe<Scalars['String']['output']>;
  utm_source?: Maybe<Scalars['String']['output']>;
  utm_term?: Maybe<Scalars['String']['output']>;
  wbraid?: Maybe<Scalars['String']['output']>;
  yclid?: Maybe<Scalars['String']['output']>;
};

export type AcquisitionSourceInput = {
  fbclid?: InputMaybe<Scalars['String']['input']>;
  first_touch_at?: InputMaybe<Scalars['NonNegativeInt']['input']>;
  gad_campaignid?: InputMaybe<Scalars['String']['input']>;
  gad_source?: InputMaybe<Scalars['String']['input']>;
  gbraid?: InputMaybe<Scalars['String']['input']>;
  gclid?: InputMaybe<Scalars['String']['input']>;
  landing_page_url?: InputMaybe<Scalars['String']['input']>;
  last_touch_at?: InputMaybe<Scalars['NonNegativeInt']['input']>;
  li_fat_id?: InputMaybe<Scalars['String']['input']>;
  msclkid?: InputMaybe<Scalars['String']['input']>;
  referrer_url?: InputMaybe<Scalars['String']['input']>;
  ttclid?: InputMaybe<Scalars['String']['input']>;
  twclid?: InputMaybe<Scalars['String']['input']>;
  utm_campaign?: InputMaybe<Scalars['String']['input']>;
  utm_content?: InputMaybe<Scalars['String']['input']>;
  utm_medium?: InputMaybe<Scalars['String']['input']>;
  utm_source?: InputMaybe<Scalars['String']['input']>;
  utm_term?: InputMaybe<Scalars['String']['input']>;
  wbraid?: InputMaybe<Scalars['String']['input']>;
  yclid?: InputMaybe<Scalars['String']['input']>;
};

export type ActionItem = {
  __typename?: 'ActionItem';
  assignee?: Maybe<User>;
  chat?: Maybe<Chat>;
  client_form?: Maybe<ClientForm>;
  clinic: Clinic;
  created_at: Scalars['Timestamp']['output'];
  description?: Maybe<Scalars['String']['output']>;
  id: Scalars['ID']['output'];
  originating_call?: Maybe<Call>;
  pending_appointment?: Maybe<Appointment>;
  pet_selfie?: Maybe<PetSelfie>;
  prescription?: Maybe<Prescription>;
  prescription_refill_request?: Maybe<PrescriptionRefillRequest>;
  reschedule?: Maybe<Reschedule>;
  status: ActionItemStatus;
  type: ActionItemType;
  updated_at: Scalars['Timestamp']['output'];
};

export enum ActionItemStatus {
  Completed = 'Completed',
  Expired = 'Expired',
  Pending = 'Pending',
  UnderReview = 'UnderReview'
}

export enum ActionItemType {
  Boarding = 'Boarding',
  FormSubmitted = 'FormSubmitted',
  General = 'General',
  MissingClient = 'MissingClient',
  MissingPatient = 'MissingPatient',
  NewChat = 'NewChat',
  OfficeTask = 'OfficeTask',
  PendingAppointment = 'PendingAppointment',
  PetSelfieSubmitted = 'PetSelfieSubmitted',
  Prescription = 'Prescription',
  Reschedule = 'Reschedule'
}

export type AddLoyaltyEarningInput = {
  clinic: Scalars['ID']['input'];
  description?: InputMaybe<Scalars['String']['input']>;
  invoice?: InputMaybe<Scalars['ID']['input']>;
  points_earned: Scalars['Float']['input'];
};

export type AddUserToClinicsAndClinicGroupsInput = {
  admin_permissions?: InputMaybe<AdminPermissionsInput>;
  allow_approving_controlled_substances?: InputMaybe<Scalars['Boolean']['input']>;
  clinicGroupIds: Array<Scalars['ID']['input']>;
  clinicIds: Array<Scalars['ID']['input']>;
  permissions?: InputMaybe<Array<ClinicAdminPermissionInput>>;
  role?: InputMaybe<Scalars['String']['input']>;
  userId: Scalars['ID']['input'];
};

export type AdditionalFees = {
  __typename?: 'AdditionalFees';
  amount: Scalars['NonNegativeInt']['output'];
  name: Scalars['String']['output'];
};

export type AdditionalFeesInput = {
  amount: Scalars['NonNegativeInt']['input'];
  name: Scalars['String']['input'];
};

/** A type that describe an address */
export type Address = {
  __typename?: 'Address';
  city?: Maybe<Scalars['String']['output']>;
  country?: Maybe<Scalars['String']['output']>;
  full_text?: Maybe<Scalars['String']['output']>;
  lat?: Maybe<Scalars['Float']['output']>;
  lng?: Maybe<Scalars['Float']['output']>;
  note?: Maybe<Scalars['String']['output']>;
  state?: Maybe<Scalars['String']['output']>;
  street_a?: Maybe<Scalars['String']['output']>;
  street_b?: Maybe<Scalars['String']['output']>;
  zip?: Maybe<Scalars['String']['output']>;
};

export type AddressInput = {
  city?: InputMaybe<Scalars['String']['input']>;
  country?: InputMaybe<Scalars['String']['input']>;
  full_text?: InputMaybe<Scalars['String']['input']>;
  lat?: InputMaybe<Scalars['Float']['input']>;
  lng?: InputMaybe<Scalars['Float']['input']>;
  note?: InputMaybe<Scalars['String']['input']>;
  state?: InputMaybe<Scalars['String']['input']>;
  street_a?: InputMaybe<Scalars['String']['input']>;
  street_b?: InputMaybe<Scalars['String']['input']>;
  zip?: InputMaybe<Scalars['String']['input']>;
};

export enum AdminPermissionAccessLevel {
  Edit = 'Edit',
  None = 'None',
  View = 'View'
}

export enum AdminPermissionFeature {
  Appointments = 'Appointments',
  BookingSettings = 'BookingSettings',
  BulkMessages = 'BulkMessages',
  Campaigns = 'Campaigns',
  ClientSegments = 'ClientSegments',
  ClinicGroupInfo = 'ClinicGroupInfo',
  ClinicInfo = 'ClinicInfo',
  Clinicians = 'Clinicians',
  DailyHuddle = 'DailyHuddle',
  EmailTemplates = 'EmailTemplates',
  EngagementSettings = 'EngagementSettings',
  Forms = 'Forms',
  GeneralSettings = 'GeneralSettings',
  Goals = 'Goals',
  GroupInitiatives = 'GroupInitiatives',
  GroupKpIs = 'GroupKPIs',
  GroupOnboarding = 'GroupOnboarding',
  GroupReporting = 'GroupReporting',
  GroupTrends = 'GroupTrends',
  GroupUsers = 'GroupUsers',
  GroupWidgets = 'GroupWidgets',
  Loyalty = 'Loyalty',
  MessageLogs = 'MessageLogs',
  MessageTemplates = 'MessageTemplates',
  Messages = 'Messages',
  Notifications = 'Notifications',
  Payments = 'Payments',
  PendingActions = 'PendingActions',
  Reporting = 'Reporting',
  Reviews = 'Reviews',
  Rooms = 'Rooms',
  SchedulingRules = 'SchedulingRules',
  Services = 'Services',
  SyncSettings = 'SyncSettings',
  TeamChat = 'TeamChat',
  Trends = 'Trends',
  Users = 'Users',
  Whiteboard = 'Whiteboard',
  Widgets = 'Widgets'
}

/** One boolean per AdminPermissionFeature value. Mirrors the columns on the admin_permissions table. */
export type AdminPermissions = {
  __typename?: 'AdminPermissions';
  appointments: Scalars['Boolean']['output'];
  booking_settings: Scalars['Boolean']['output'];
  bulk_messages: Scalars['Boolean']['output'];
  campaigns: Scalars['Boolean']['output'];
  client_segments: Scalars['Boolean']['output'];
  clinic_group_info: Scalars['Boolean']['output'];
  clinic_info: Scalars['Boolean']['output'];
  clinicians: Scalars['Boolean']['output'];
  daily_huddle: Scalars['Boolean']['output'];
  email_templates: Scalars['Boolean']['output'];
  engagement_settings: Scalars['Boolean']['output'];
  forms: Scalars['Boolean']['output'];
  general_settings: Scalars['Boolean']['output'];
  goals: Scalars['Boolean']['output'];
  group_initiatives: Scalars['Boolean']['output'];
  group_kpis: Scalars['Boolean']['output'];
  group_onboarding: Scalars['Boolean']['output'];
  group_reporting: Scalars['Boolean']['output'];
  group_trends: Scalars['Boolean']['output'];
  group_users: Scalars['Boolean']['output'];
  group_widgets: Scalars['Boolean']['output'];
  loyalty: Scalars['Boolean']['output'];
  message_logs: Scalars['Boolean']['output'];
  message_templates: Scalars['Boolean']['output'];
  messages: Scalars['Boolean']['output'];
  notifications: Scalars['Boolean']['output'];
  payments: Scalars['Boolean']['output'];
  pending_actions: Scalars['Boolean']['output'];
  reporting: Scalars['Boolean']['output'];
  reviews: Scalars['Boolean']['output'];
  rooms: Scalars['Boolean']['output'];
  scheduling_rules: Scalars['Boolean']['output'];
  services: Scalars['Boolean']['output'];
  sync_settings: Scalars['Boolean']['output'];
  team_chat: Scalars['Boolean']['output'];
  trends: Scalars['Boolean']['output'];
  users: Scalars['Boolean']['output'];
  whiteboard: Scalars['Boolean']['output'];
  widgets: Scalars['Boolean']['output'];
};

/** Partial update for AdminPermissions — only specified booleans are written. */
export type AdminPermissionsInput = {
  appointments?: InputMaybe<Scalars['Boolean']['input']>;
  booking_settings?: InputMaybe<Scalars['Boolean']['input']>;
  bulk_messages?: InputMaybe<Scalars['Boolean']['input']>;
  campaigns?: InputMaybe<Scalars['Boolean']['input']>;
  client_segments?: InputMaybe<Scalars['Boolean']['input']>;
  clinic_group_info?: InputMaybe<Scalars['Boolean']['input']>;
  clinic_info?: InputMaybe<Scalars['Boolean']['input']>;
  clinicians?: InputMaybe<Scalars['Boolean']['input']>;
  daily_huddle?: InputMaybe<Scalars['Boolean']['input']>;
  email_templates?: InputMaybe<Scalars['Boolean']['input']>;
  engagement_settings?: InputMaybe<Scalars['Boolean']['input']>;
  forms?: InputMaybe<Scalars['Boolean']['input']>;
  general_settings?: InputMaybe<Scalars['Boolean']['input']>;
  goals?: InputMaybe<Scalars['Boolean']['input']>;
  group_initiatives?: InputMaybe<Scalars['Boolean']['input']>;
  group_kpis?: InputMaybe<Scalars['Boolean']['input']>;
  group_onboarding?: InputMaybe<Scalars['Boolean']['input']>;
  group_reporting?: InputMaybe<Scalars['Boolean']['input']>;
  group_trends?: InputMaybe<Scalars['Boolean']['input']>;
  group_users?: InputMaybe<Scalars['Boolean']['input']>;
  group_widgets?: InputMaybe<Scalars['Boolean']['input']>;
  loyalty?: InputMaybe<Scalars['Boolean']['input']>;
  message_logs?: InputMaybe<Scalars['Boolean']['input']>;
  message_templates?: InputMaybe<Scalars['Boolean']['input']>;
  messages?: InputMaybe<Scalars['Boolean']['input']>;
  notifications?: InputMaybe<Scalars['Boolean']['input']>;
  payments?: InputMaybe<Scalars['Boolean']['input']>;
  pending_actions?: InputMaybe<Scalars['Boolean']['input']>;
  reporting?: InputMaybe<Scalars['Boolean']['input']>;
  reviews?: InputMaybe<Scalars['Boolean']['input']>;
  rooms?: InputMaybe<Scalars['Boolean']['input']>;
  scheduling_rules?: InputMaybe<Scalars['Boolean']['input']>;
  services?: InputMaybe<Scalars['Boolean']['input']>;
  sync_settings?: InputMaybe<Scalars['Boolean']['input']>;
  team_chat?: InputMaybe<Scalars['Boolean']['input']>;
  trends?: InputMaybe<Scalars['Boolean']['input']>;
  users?: InputMaybe<Scalars['Boolean']['input']>;
  whiteboard?: InputMaybe<Scalars['Boolean']['input']>;
  widgets?: InputMaybe<Scalars['Boolean']['input']>;
};

export enum AggregateFunction {
  Avg = 'Avg',
  Count = 'Count',
  Max = 'Max',
  Min = 'Min',
  Sum = 'Sum'
}

/** Where a taught instruction was saved, i.e. where that agent reads it. */
export enum AiAgentInstructionDestination {
  /** The Custom Instructions setting (Conversation Flow and pre-playbook agents). */
  CustomInstructions = 'CustomInstructions',
  /** The Single Prompt playbook's Clinic details section (live immediately). */
  Playbook = 'Playbook'
}

/**
 * A clinic AI receptionist's prompt. A SinglePrompt agent runs Chckvet's
 * rules (safety, honesty, privacy, booking integrity) around the clinic's
 * playbook, which the clinic edits freely. The composed prompt is
 * re-rendered on every Retell deploy, so edits made directly in the Retell
 * dashboard don't last.
 */
export type AiAgentPrompt = {
  __typename?: 'AiAgentPrompt';
  agent_type: AiCallsAgentType;
  /**
   * Merge tags Chckvet fills on every inbound call, usable in the playbook
   * as {{name}}. Any other tag is only filled if Retell itself provides
   * it; otherwise the agent may say the word "null".
   */
  available_dynamic_variables: Array<Scalars['String']['output']>;
  clinic_id: Scalars['ID']['output'];
  /** Chckvet's current default playbook, for resetting. */
  default_playbook: Scalars['String']['output'];
  /**
   * The complete prompt the agent runs right now. Null for
   * ConversationFlow agents, which run the shared flow instead.
   */
  general_prompt?: Maybe<Scalars['String']['output']>;
  /** True when the clinic runs Chckvet's default playbook (and gets its updates). */
  is_default_playbook: Scalars['Boolean']['output'];
  /**
   * True when a SinglePrompt agent still runs a hand-edited full prompt
   * from before playbooks. Deploys leave it alone; saving the playbook
   * replaces it with Chckvet's rules plus the playbook.
   */
  is_legacy_prompt: Scalars['Boolean']['output'];
  /**
   * The clinic's playbook: its own, or Chckvet's default when
   * is_default_playbook. Null for ConversationFlow agents.
   */
  playbook?: Maybe<Scalars['String']['output']>;
  /** Longest playbook that can be saved, in characters. */
  playbook_max_chars: Scalars['Int']['output'];
};

/**
 * An AI-proposed edit to a Single Prompt clinic's playbook. Nothing is
 * saved; the editor shows it as a diff and the user decides whether to use
 * it.
 */
export type AiAgentPromptSuggestion = {
  __typename?: 'AiAgentPromptSuggestion';
  /** The full playbook with the requested change applied. */
  proposed_playbook: Scalars['String']['output'];
  /** One sentence describing what was changed. */
  summary: Scalars['String']['output'];
  /**
   * Things worth checking before accepting, e.g. merge tags or sections
   * that disappeared, or a big jump in length (longer prompts cost more
   * per minute on Retell).
   */
  warnings: Array<Scalars['String']['output']>;
};

/**
 * How a clinic's AI receptionist agent is driven on Retell. Chosen once,
 * when the agent is initialized.
 */
export enum AiCallsAgentType {
  /**
   * Shared node-graph conversation flow. Updated for every clinic at once
   * by the Retell deploy fan-out.
   */
  ConversationFlow = 'ConversationFlow',
  /**
   * One generic prompt plus a flat tool list (Retell "retell-llm"). Each
   * clinic gets its own copy, so it can be hand-tuned in the Retell
   * dashboard; flow deploys skip it.
   */
  SinglePrompt = 'SinglePrompt'
}

export enum AiCallsAmbientSound {
  CallCenter = 'CallCenter',
  CoffeeShop = 'CoffeeShop',
  ConventionHall = 'ConventionHall',
  MountainOutdoor = 'MountainOutdoor',
  Off = 'Off',
  StaticNoise = 'StaticNoise',
  SummerOutdoor = 'SummerOutdoor'
}

/** One call that raised a prompt suggestion. */
export type AiImprovementEvidence = {
  __typename?: 'AiImprovementEvidence';
  call_id: Scalars['ID']['output'];
  /** When the call started (ms epoch). */
  call_started_at?: Maybe<Scalars['NonNegativeInt']['output']>;
  /** One plain-language line about what happened on the call. */
  evidence?: Maybe<Scalars['String']['output']>;
};

export enum AiImprovementImpact {
  High = 'High',
  Low = 'Low',
  Medium = 'Medium'
}

/**
 * Something a clinic could add to its Single Prompt agent's prompt so the
 * AI handles a recurring kind of call better. Written after each call and
 * deduped by topic: when a topic comes up again, occurrence_count grows
 * and the wording may be refined.
 */
export type AiImprovementItem = {
  __typename?: 'AiImprovementItem';
  clinic_id: Scalars['ID']['output'];
  /** Starting text for the clinic to edit and add. May contain blanks like ___. */
  draft_instruction?: Maybe<Scalars['String']['output']>;
  first_seen_at?: Maybe<Scalars['NonNegativeInt']['output']>;
  id: Scalars['ID']['output'];
  /** Severity, raised as the topic keeps recurring. Sort by priority_score. */
  impact: AiImprovementImpact;
  kind: AiImprovementKind;
  last_seen_at?: Maybe<Scalars['NonNegativeInt']['output']>;
  occurrence_count: Scalars['Int']['output'];
  /** Higher matters more. Combines impact, how often it came up, and how recently. */
  priority_score: Scalars['Float']['output'];
  /** The most recent calls that raised it, newest first. */
  recent_evidence: Array<AiImprovementEvidence>;
  resolved_at?: Maybe<Scalars['NonNegativeInt']['output']>;
  status: AiImprovementStatus;
  /** What callers asked and what the AI was missing. */
  suggestion: Scalars['String']['output'];
  title: Scalars['String']['output'];
};

/**
 * The prompt change drafted for a suggestion, for the clinic to review as
 * a diff before applying it.
 */
export type AiImprovementItemPreview = {
  __typename?: 'AiImprovementItemPreview';
  /** The live playbook the change was drafted against. */
  current_playbook: Scalars['String']['output'];
  /** The full playbook with the change applied. */
  proposed_playbook: Scalars['String']['output'];
  /** One sentence describing what was changed. */
  summary: Scalars['String']['output'];
  /** Things worth checking before applying, e.g. a big jump in length. */
  warnings: Array<Scalars['String']['output']>;
};

/** What a prompt suggestion needs from the clinic. */
export enum AiImprovementKind {
  /** Info only the clinic has, e.g. what they charge for a spay. */
  Question = 'Question',
  /** A change to how the agent handles something, with draft wording. */
  Suggestion = 'Suggestion'
}

export enum AiImprovementStatus {
  Applied = 'Applied',
  Dismissed = 'Dismissed',
  Pending = 'Pending'
}

export type AiPromptSuggestions = {
  __typename?: 'AiPromptSuggestions';
  /**
   * The clinic's agent type. Suggestions are only generated for
   * SinglePrompt agents. Null when the clinic has no agent yet.
   */
  agent_type?: Maybe<AiCallsAgentType>;
  /** Highest priority first. */
  items: Array<AiImprovementItem>;
};

export type AiVoiceOption = {
  __typename?: 'AiVoiceOption';
  avatar_url?: Maybe<Scalars['String']['output']>;
  voice_accent?: Maybe<Scalars['String']['output']>;
  voice_age?: Maybe<Scalars['String']['output']>;
  voice_gender: Scalars['String']['output'];
  voice_id: Scalars['String']['output'];
  voice_name: Scalars['String']['output'];
  voice_preview_url?: Maybe<Scalars['String']['output']>;
};

export type AnalyticsNumbers = {
  __typename?: 'AnalyticsNumbers';
  appointments_count: Scalars['NonNegativeInt']['output'];
  forward_scheduled_patients_count: Scalars['NonNegativeInt']['output'];
  new_appointments_count: Scalars['NonNegativeInt']['output'];
  new_clients_count: Scalars['NonNegativeInt']['output'];
  new_patients_count: Scalars['NonNegativeInt']['output'];
  no_show_count: Scalars['NonNegativeInt']['output'];
  revenue: Scalars['Float']['output'];
  revenue_per_appointment: Scalars['Float']['output'];
  schedule_efficiency: Scalars['Float']['output'];
  transactions_count: Scalars['NonNegativeInt']['output'];
};

export type AnalyticsNumbersByMonth = {
  __typename?: 'AnalyticsNumbersByMonth';
  analytics: AnalyticsNumbers;
  month: Scalars['NonNegativeInt']['output'];
  year: Scalars['NonNegativeInt']['output'];
};

export type Animal = {
  __typename?: 'Animal';
  created_at: Scalars['Timestamp']['output'];
  id: Scalars['ID']['output'];
  image?: Maybe<Scalars['String']['output']>;
  name?: Maybe<Scalars['String']['output']>;
  updated_at: Scalars['Timestamp']['output'];
};

export enum AnimalGender {
  Female = 'Female',
  Male = 'Male',
  Unknown = 'Unknown'
}

export type Appointment = {
  __typename?: 'Appointment';
  acquisition_source?: Maybe<AcquisitionSource>;
  action_items?: Maybe<Array<ActionItem>>;
  appointment_patients?: Maybe<Array<AppointmentPatient>>;
  appt_type_pms_id?: Maybe<Scalars['String']['output']>;
  booking_source?: Maybe<BookingSource>;
  bulk_message?: Maybe<Scalars['String']['output']>;
  cancelled_at?: Maybe<Scalars['NonNegativeInt']['output']>;
  click_id?: Maybe<Scalars['String']['output']>;
  client?: Maybe<Client>;
  client_info?: Maybe<ClientInfo>;
  client_notes?: Maybe<Scalars['String']['output']>;
  client_pms_id?: Maybe<Scalars['String']['output']>;
  client_reason_for_cancellation?: Maybe<Scalars['String']['output']>;
  clients_forms?: Maybe<Array<ClientForm>>;
  clinic?: Maybe<Clinic>;
  clinic_approved_at?: Maybe<Scalars['NonNegativeInt']['output']>;
  clinic_appt_status?: Maybe<ClinicApptStatus>;
  clinic_notes?: Maybe<Scalars['String']['output']>;
  clinician?: Maybe<Clinician>;
  clinician_pms_id?: Maybe<Scalars['String']['output']>;
  confirmation_requested_at?: Maybe<Scalars['NonNegativeInt']['output']>;
  confirmed_at?: Maybe<Scalars['NonNegativeInt']['output']>;
  created_at: Scalars['Timestamp']['output'];
  drop_off_time?: Maybe<Scalars['NonNegativeInt']['output']>;
  end_time: Scalars['NonNegativeInt']['output'];
  from_prompt?: Maybe<AppointmentPrompt>;
  from_widget?: Maybe<Scalars['String']['output']>;
  id: Scalars['ID']['output'];
  index_of_opening?: Maybe<Scalars['NonNegativeInt']['output']>;
  is_clinician_auto_assigned?: Maybe<Scalars['Boolean']['output']>;
  is_confirmed?: Maybe<Scalars['Boolean']['output']>;
  is_deleted?: Maybe<Scalars['Boolean']['output']>;
  is_new_client?: Maybe<Scalars['Boolean']['output']>;
  is_new_patient?: Maybe<Scalars['Boolean']['output']>;
  is_recurring?: Maybe<Scalars['Boolean']['output']>;
  is_time_block?: Maybe<Scalars['Boolean']['output']>;
  minutes: Scalars['NonNegativeInt']['output'];
  new_client_name?: Maybe<Scalars['String']['output']>;
  new_client_phone?: Maybe<Scalars['String']['output']>;
  new_patient_name?: Maybe<Scalars['String']['output']>;
  new_patient_species?: Maybe<Scalars['String']['output']>;
  notif_template?: Maybe<Scalars['String']['output']>;
  origin?: Maybe<EntityOrigin>;
  patient?: Maybe<Patient>;
  patient_history_items?: Maybe<Array<PatientHistoryItem>>;
  patient_info?: Maybe<PatientInfo>;
  patient_pms_id?: Maybe<Scalars['String']['output']>;
  patients_pms_ids?: Maybe<Array<Scalars['String']['output']>>;
  payment?: Maybe<Payment>;
  pms?: Maybe<PracticeManagementSystem>;
  pms_created_at?: Maybe<Scalars['NonNegativeInt']['output']>;
  pms_id?: Maybe<Scalars['String']['output']>;
  reason_for_cancellation?: Maybe<Scalars['String']['output']>;
  recur_end_date?: Maybe<Scalars['NonNegativeInt']['output']>;
  recur_freq?: Maybe<Scalars['NonNegativeInt']['output']>;
  recur_time_unit?: Maybe<TimeUnit>;
  referring_clinic_name?: Maybe<Scalars['String']['output']>;
  requested_prompt?: Maybe<AppointmentPrompt>;
  reschedules?: Maybe<Array<Reschedule>>;
  room?: Maybe<Room>;
  service?: Maybe<Service>;
  service_name?: Maybe<Scalars['String']['output']>;
  should_be_synced?: Maybe<Scalars['Boolean']['output']>;
  start_time: Scalars['NonNegativeInt']['output'];
  status: AppointmentStatus;
  stripe_payment_intent_id?: Maybe<Scalars['String']['output']>;
  time_of_day?: Maybe<TimeOfDay>;
  updated_at: Scalars['Timestamp']['output'];
  widget?: Maybe<Widget>;
  widget_source?: Maybe<Scalars['String']['output']>;
};

/**
 * How an online booking is written into the PMS.
 * Instant: immediate cloud PMS write (and Stripe capture if the service has pricing).
 * ConfirmationRequired: appointment stays pending until staff confirms in Connect; client gets the requested/approved/denied templates.
 * ManualEntry: staff must enter the visit in the PMS themselves; also skips temp-client action items used by Legacy matching.
 */
export enum AppointmentEntryMethod {
  ConfirmationRequired = 'ConfirmationRequired',
  Instant = 'Instant',
  ManualEntry = 'ManualEntry'
}

/**
 * Invoice revenue attributed to one appointment, in cents. See
 * getInvoiceTotalsForAppointments for the attribution rules.
 */
export type AppointmentInvoiceTotal = {
  __typename?: 'AppointmentInvoiceTotal';
  appointment: Scalars['ID']['output'];
  invoice_count: Scalars['NonNegativeInt']['output'];
  total: Scalars['Int']['output'];
  total_paid: Scalars['Int']['output'];
};

export type AppointmentPatient = {
  __typename?: 'AppointmentPatient';
  appointment: Appointment;
  id: Scalars['ID']['output'];
  patient?: Maybe<Patient>;
};

export type AppointmentPrompt = {
  __typename?: 'AppointmentPrompt';
  client?: Maybe<Client>;
  client_notes?: Maybe<Scalars['String']['output']>;
  clinic: Clinic;
  clinic_notes?: Maybe<Scalars['String']['output']>;
  clinician?: Maybe<Clinician>;
  confirmed_at?: Maybe<Scalars['NonNegativeInt']['output']>;
  created_appointment?: Maybe<Appointment>;
  created_at: Scalars['Timestamp']['output'];
  id: Scalars['ID']['output'];
  minutes?: Maybe<Scalars['NonNegativeInt']['output']>;
  patient?: Maybe<Patient>;
  reason_for_denial?: Maybe<Scalars['String']['output']>;
  service?: Maybe<Service>;
  service_name?: Maybe<Scalars['String']['output']>;
  start_time?: Maybe<Scalars['NonNegativeInt']['output']>;
  type: AppointmentPromptType;
  updated_at: Scalars['Timestamp']['output'];
};

export enum AppointmentPromptType {
  FollowUp = 'FollowUp',
  NewAppointment = 'NewAppointment'
}

export enum AppointmentStatus {
  Booked = 'Booked',
  Cancelled = 'Cancelled',
  Completed = 'Completed',
  Confirmed = 'Confirmed',
  Denied = 'Denied',
  Expired = 'Expired',
  NoShow = 'NoShow',
  Pending = 'Pending'
}

export type Attachment = {
  __typename?: 'Attachment';
  filename: Scalars['String']['output'];
  id: Scalars['ID']['output'];
  type: AttachmentType;
  url: Scalars['String']['output'];
};

export type AttachmentInput = {
  file_location: Scalars['String']['input'];
  file_name: Scalars['String']['input'];
  name: Scalars['String']['input'];
  patient_pms_id: Scalars['String']['input'];
};

export enum AttachmentType {
  Image = 'Image',
  Pdf = 'Pdf',
  Video = 'Video'
}

export enum AuthRoles {
  Admin = 'Admin',
  ClinicEmployee = 'ClinicEmployee',
  ClinicManager = 'ClinicManager',
  Custom = 'Custom',
  SuperAdmin = 'SuperAdmin',
  User = 'User'
}

export enum AuthorityLevel {
  Doctor = 'Doctor',
  NonTechnicalStaff = 'NonTechnicalStaff',
  Technician = 'Technician'
}

export type Availability = {
  __typename?: 'Availability';
  date: Scalars['NonNegativeInt']['output'];
  pms_appt_type_pms_id?: Maybe<Scalars['String']['output']>;
  repeat?: Maybe<RepeatAvailability>;
  times: Array<TimeInterval>;
};

export enum AvailabilityDay {
  Friday = 'Friday',
  Monday = 'Monday',
  Saturday = 'Saturday',
  Sunday = 'Sunday',
  Thursday = 'Thursday',
  Tuesday = 'Tuesday',
  Wednesday = 'Wednesday'
}

export type AvailabilityHours = {
  __typename?: 'AvailabilityHours';
  friday?: Maybe<Array<TimeInterval>>;
  monday?: Maybe<Array<TimeInterval>>;
  saturday?: Maybe<Array<TimeInterval>>;
  sunday?: Maybe<Array<TimeInterval>>;
  thursday?: Maybe<Array<TimeInterval>>;
  tuesday?: Maybe<Array<TimeInterval>>;
  wednesday?: Maybe<Array<TimeInterval>>;
};

export type AvailabilityHoursInput = {
  friday?: InputMaybe<Array<TimeIntervalInput>>;
  monday?: InputMaybe<Array<TimeIntervalInput>>;
  saturday?: InputMaybe<Array<TimeIntervalInput>>;
  sunday?: InputMaybe<Array<TimeIntervalInput>>;
  thursday?: InputMaybe<Array<TimeIntervalInput>>;
  tuesday?: InputMaybe<Array<TimeIntervalInput>>;
  wednesday?: InputMaybe<Array<TimeIntervalInput>>;
};

export type AvailabilityInput = {
  date: Scalars['NonNegativeInt']['input'];
  pms_appt_type_pms_id?: InputMaybe<Scalars['String']['input']>;
  repeat?: InputMaybe<RepeatAvailabilityInput>;
  times: Array<TimeIntervalInput>;
};

/**
 * Override options for availability checking.
 * Used to bypass certain scheduling constraints for testing/debugging purposes.
 * Enables a diagnostic workflow: start with all overrides enabled (24/7 availability),
 * then disable them one by one to identify what's blocking time slots.
 */
export type AvailabilityOverrides = {
  /** If true, clinic hours will be treated as 24/7 available (0:00-24:00). */
  override_clinic_hours?: InputMaybe<Scalars['Boolean']['input']>;
  /** If true, clinician/room hours will be treated as 24/7 available (0:00-24:00). */
  override_resource_hours?: InputMaybe<Scalars['Boolean']['input']>;
  /** If true, all adjusted availability entries will be ignored for both clinic and resources. */
  skip_adjusted_availability?: InputMaybe<Scalars['Boolean']['input']>;
  /** If true, existing appointment conflicts will be ignored (double-booking allowed). */
  skip_appointment_collisions?: InputMaybe<Scalars['Boolean']['input']>;
  /** If true, server-side caching will be bypassed for scheduling entities and live PMS availability. */
  skip_cache?: InputMaybe<Scalars['Boolean']['input']>;
  /** If true, the "first appointment of day" restriction will be ignored. */
  skip_first_appointment_check?: InputMaybe<Scalars['Boolean']['input']>;
  /** If true, external PMS availability data will be ignored. */
  skip_pms_availability?: InputMaybe<Scalars['Boolean']['input']>;
  /** If true, min/max scheduling date restrictions will be ignored. */
  skip_scheduling_date_bounds?: InputMaybe<Scalars['Boolean']['input']>;
  /** If true, all scheduling rules will be ignored (they won't block any slots). */
  skip_scheduling_rules?: InputMaybe<Scalars['Boolean']['input']>;
  /** If true, service's max_per_day limit will be ignored. */
  skip_service_max_per_day?: InputMaybe<Scalars['Boolean']['input']>;
  /** If true, service's max_per_hour limit will be ignored. */
  skip_service_max_per_hour?: InputMaybe<Scalars['Boolean']['input']>;
  /** If true, service's max_simultaneous_appointments limit will be ignored. */
  skip_service_max_simultaneous?: InputMaybe<Scalars['Boolean']['input']>;
};

export enum AvailabilityType {
  Additional = 'Additional',
  Break = 'Break',
  Routine = 'Routine'
}

export enum BillableUsageEntity {
  AiChatResponse = 'AiChatResponse',
  BulkMessageSmsSegment = 'BulkMessageSmsSegment',
  PostGridPostcard = 'PostGridPostcard',
  RetellPhoneCall = 'RetellPhoneCall',
  TwilioSms = 'TwilioSms'
}

export type BillableUsageTypeStats = {
  __typename?: 'BillableUsageTypeStats';
  all_time_usage: Scalars['NonNegativeFloat']['output'];
  current_billing_period_usage: Scalars['NonNegativeFloat']['output'];
  entity_type: BillableUsageEntity;
};

export enum BookingAttributionDimension {
  AdPlatform = 'AdPlatform',
  LandingPage = 'LandingPage',
  ReferrerDomain = 'ReferrerDomain',
  UtmCampaign = 'UtmCampaign',
  UtmContent = 'UtmContent',
  UtmMedium = 'UtmMedium',
  UtmSource = 'UtmSource',
  UtmTerm = 'UtmTerm'
}

/**
 * Online bookings (widget + client portal) that share one value of a
 * marketing attribution dimension, e.g. one utm_campaign. Counted from
 * appointments.acquisition_source, which is only captured on appointments,
 * so there are no session or conversion-rate figures here.
 */
export type BookingAttributionStats = {
  __typename?: 'BookingAttributionStats';
  appointments_booked: Scalars['NonNegativeInt']['output'];
  new_client_appointments: Scalars['NonNegativeInt']['output'];
  /**
   * The dimension's value, e.g. "spring-promo". Null groups bookings with
   * no value for the dimension (direct traffic or no tracking captured).
   */
  value?: Maybe<Scalars['String']['output']>;
};

/**
 * Visibility of one Times-First booking filter.
 * Auto: show only when active scheduling rules use that dimension.
 * Show: always show. Hidden: never show.
 */
export enum BookingFilterDisplayMode {
  Auto = 'Auto',
  Hidden = 'Hidden',
  Show = 'Show'
}

export type BookingFlowEvent = {
  __typename?: 'BookingFlowEvent';
  clinic_group_id?: Maybe<Scalars['ID']['output']>;
  clinic_id?: Maybe<Scalars['ID']['output']>;
  created_at: Scalars['Timestamp']['output'];
  duration_ms?: Maybe<Scalars['NonNegativeInt']['output']>;
  event_type: BookingFlowEventType;
  id: Scalars['ID']['output'];
  metadata?: Maybe<Scalars['JSON']['output']>;
  session_id: Scalars['String']['output'];
  source: BookingFlowSource;
  step: BookingFlowStep;
  widget_id?: Maybe<Scalars['ID']['output']>;
};

export type BookingFlowEventFilters = {
  clinic_group_id?: InputMaybe<Scalars['ID']['input']>;
  clinic_id?: InputMaybe<Scalars['ID']['input']>;
  range: UsageTimeRangeInput;
  session_id?: InputMaybe<Scalars['String']['input']>;
  source?: InputMaybe<BookingFlowSource>;
  widget_id?: InputMaybe<Scalars['ID']['input']>;
};

export type BookingFlowEventInput = {
  clinic_group_id?: InputMaybe<Scalars['ID']['input']>;
  clinic_id?: InputMaybe<Scalars['ID']['input']>;
  /** Required for Timing events, not allowed for any other type. */
  duration_ms?: InputMaybe<Scalars['NonNegativeInt']['input']>;
  /** Defaults to StepReached. Only StepReached events advance the session. */
  event_type?: InputMaybe<BookingFlowEventType>;
  metadata?: InputMaybe<Scalars['JSON']['input']>;
  session_id: Scalars['String']['input'];
  source: BookingFlowSource;
  /**
   * For StepReached (the default), the step the visitor just reached. For
   * other event types, the step the visitor was on when it happened.
   */
  step: BookingFlowStep;
  widget_id?: InputMaybe<Scalars['ID']['input']>;
};

export enum BookingFlowEventType {
  Friction = 'Friction',
  StepReached = 'StepReached',
  Timing = 'Timing'
}

export type BookingFlowFunnelFilters = {
  clinic_id?: InputMaybe<Scalars['ID']['input']>;
  clinic_ids?: InputMaybe<Array<Scalars['ID']['input']>>;
  /** Filter sessions where at least one event has matching metadata. */
  is_new_client?: InputMaybe<Scalars['Boolean']['input']>;
  range: UsageTimeRangeInput;
  service_id?: InputMaybe<Scalars['ID']['input']>;
  source?: InputMaybe<BookingFlowSource>;
  widget_id?: InputMaybe<Scalars['ID']['input']>;
};

export type BookingFlowFunnelStep = {
  __typename?: 'BookingFlowFunnelStep';
  /** Booking sessions (see WidgetBookingSourceStats) that reached this step. */
  count: Scalars['NonNegativeInt']['output'];
  step: BookingFlowStep;
};

/**
 * One visitor's pass through the online booking flow (portal or widget).
 * 'client' is set when they matched an existing client, 'lead_contact' when they didn't.
 */
export type BookingFlowSession = {
  __typename?: 'BookingFlowSession';
  appointment?: Maybe<Appointment>;
  client?: Maybe<Client>;
  clinic_id?: Maybe<Scalars['ID']['output']>;
  completed: Scalars['Boolean']['output'];
  created_at: Scalars['Timestamp']['output'];
  furthest_step?: Maybe<BookingFlowStep>;
  id: Scalars['String']['output'];
  is_new_client?: Maybe<Scalars['Boolean']['output']>;
  is_new_patient?: Maybe<Scalars['Boolean']['output']>;
  last_step: BookingFlowStep;
  lead_contact?: Maybe<LeadContact>;
  patient?: Maybe<Patient>;
  service_id?: Maybe<Scalars['ID']['output']>;
  service_name?: Maybe<Scalars['String']['output']>;
  source: BookingFlowSource;
  updated_at: Scalars['Timestamp']['output'];
  widget_id?: Maybe<Scalars['ID']['output']>;
};

export enum BookingFlowSource {
  Portal = 'Portal',
  Widget = 'Widget'
}

export enum BookingFlowStep {
  AppointmentBooked = 'AppointmentBooked',
  ClientInfoEntered = 'ClientInfoEntered',
  FlowStarted = 'FlowStarted',
  FormsStepReached = 'FormsStepReached',
  LocationSelected = 'LocationSelected',
  PatientInfoEntered = 'PatientInfoEntered',
  PaymentStepReached = 'PaymentStepReached',
  ReviewReached = 'ReviewReached',
  ServiceSelected = 'ServiceSelected',
  ServiceTypeSelected = 'ServiceTypeSelected',
  TimeSelected = 'TimeSelected',
  VerificationReached = 'VerificationReached'
}

/**
 * How returning clients identify themselves during online booking.
 * PatientSearch: look up existing patient, then continue.
 * PatientSearchWithVerification: lookup plus phone/email verification.
 * EnterAllInformation: always collect full client/patient fields (no lookup).
 * Legacy: skip modern search; if should_create_clients/patients is false and entry is not ManualEntry, creates temp records plus a staff action item.
 */
export enum BookingMatchProcedure {
  EnterAllInformation = 'EnterAllInformation',
  Legacy = 'Legacy',
  PatientSearch = 'PatientSearch',
  PatientSearchWithVerification = 'PatientSearchWithVerification'
}

/**
 * Hydration payload returned by 'bookingPrefillByClickId'. Populated only
 * when 'status' is 'Available'. The widget/portal uses this to seed
 * 'selectedClientPatient' and 'service' state and skip directly to the
 * time-select step.
 *
 * Resolved server-side from the chclid via:
 *   msg_tracking_events.click_id -> messages.id -> messages.chat -> chats.client
 *   messages.template_data       -> patient_id (when unambiguous)
 *   notification_templates.default_service_id OR clinic_settings.default_reminder_service_id
 *
 * 'client_patient' is the SAME 'ReturningClientPatientResult' shape
 * produced by 'checkMaybeClient' (masked previews, no_previous_appointments
 * flag, etc.) so the widget/portal can drop it straight into
 * 'selectedClientPatient' state with zero client-side mapping. It is
 * null for grouped multi-patient reminders (the widget falls back to the
 * normal patient-pick step in that case).
 */
export type BookingPrefill = {
  __typename?: 'BookingPrefill';
  client_patient?: Maybe<ReturningClientPatientResult>;
  clinic_id: Scalars['ID']['output'];
  default_service_id?: Maybe<Scalars['ID']['output']>;
  expires_at: Scalars['NonNegativeInt']['output'];
};

/**
 * Tagged result for 'bookingPrefillByClickId'. The 'prefill' field is
 * populated iff 'status' is 'Available'; for any other status it is null
 * and the widget/portal should fall back to the normal booking flow.
 */
export type BookingPrefillResult = {
  __typename?: 'BookingPrefillResult';
  prefill?: Maybe<BookingPrefill>;
  status: BookingPrefillStatus;
};

export enum BookingPrefillStatus {
  Available = 'Available',
  ClinicMismatch = 'ClinicMismatch',
  Expired = 'Expired',
  Invalid = 'Invalid',
  NotFound = 'NotFound'
}

export enum BookingQuestions {
  ClientReturningStatus = 'ClientReturningStatus',
  PatientFixedStatus = 'PatientFixedStatus',
  PatientGender = 'PatientGender',
  PatientReturningStatus = 'PatientReturningStatus'
}

export type BookingResourceParams = {
  client_id?: InputMaybe<Scalars['ID']['input']>;
  clinic_species_id?: InputMaybe<Scalars['ID']['input']>;
  fixed_status?: InputMaybe<FixedStatus>;
  is_new_client?: InputMaybe<Scalars['Boolean']['input']>;
  is_new_patient?: InputMaybe<Scalars['Boolean']['input']>;
  patient_gender?: InputMaybe<AnimalGender>;
  patient_id?: InputMaybe<Scalars['ID']['input']>;
  service_ids?: InputMaybe<Array<Scalars['ID']['input']>>;
};

export type BookingServiceParams = {
  client_id?: InputMaybe<Scalars['ID']['input']>;
  clinic_species_id?: InputMaybe<Scalars['ID']['input']>;
  fixed_status?: InputMaybe<FixedStatus>;
  is_new_client?: InputMaybe<Scalars['Boolean']['input']>;
  is_new_patient?: InputMaybe<Scalars['Boolean']['input']>;
  patient_gender?: InputMaybe<AnimalGender>;
  patient_id?: InputMaybe<Scalars['ID']['input']>;
};

export enum BookingSource {
  Facebook = 'Facebook',
  Google = 'Google',
  Instagram = 'Instagram',
  Other = 'Other',
  Website = 'Website'
}

export type BookingSourceAnalytics = {
  __typename?: 'BookingSourceAnalytics';
  /** Every member clinic of the group, including clinics with zero sessions. */
  clinics: Array<ClinicBookingSourceStats>;
  /**
   * Sessions started in the client portal or app without any widget, per
   * member clinic. Only clinics with sessions in the range are listed.
   */
  portal_without_widget: Array<ClinicBookingSourceStats>;
  /**
   * Widgets owned by the group, its direct subgroups, or its member
   * clinics. Includes every active widget that can take bookings (even
   * with zero sessions) plus any other widget that had sessions in the
   * range.
   */
  widgets: Array<WidgetBookingSourceStats>;
};

/** A single row in the booking-source breakdown chart. */
export type BookingSourceBreakdownEntry = {
  __typename?: 'BookingSourceBreakdownEntry';
  count: Scalars['NonNegativeInt']['output'];
  /** 0..1 share of total appointments in scope. */
  percent: Scalars['Float']['output'];
  source: Scalars['String']['output'];
};

export type Breed = {
  __typename?: 'Breed';
  clinic?: Maybe<Clinic>;
  created_at: Scalars['Timestamp']['output'];
  description: Scalars['String']['output'];
  id: Scalars['ID']['output'];
  is_active: Scalars['Boolean']['output'];
  pms_id: Scalars['String']['output'];
  species?: Maybe<Species>;
  species_foreign?: Maybe<ClinicSpecies>;
  updated_at: Scalars['Timestamp']['output'];
};

export type BuildProposedChangeInput = {
  /** Required for create (auth + FK). Optional for update. */
  clinic_id?: InputMaybe<Scalars['ID']['input']>;
  /** Defaults to update when omitted. */
  operation?: InputMaybe<ProposedChangeOperation>;
  patch: Scalars['JSON']['input'];
  side_effects?: InputMaybe<Array<Scalars['String']['input']>>;
  summary?: InputMaybe<Scalars['String']['input']>;
  /** Required for update; omit for create. */
  target_entity_id?: InputMaybe<Scalars['ID']['input']>;
  target_entity_type: Scalars['String']['input'];
};

export type BulkCreateUserInput = {
  clinicGroupId?: InputMaybe<Scalars['ID']['input']>;
  clinicId?: InputMaybe<Scalars['ID']['input']>;
  customRoleId?: InputMaybe<Scalars['ID']['input']>;
  email: Scalars['String']['input'];
  first_name: Scalars['String']['input'];
  last_name: Scalars['String']['input'];
  role?: InputMaybe<AuthRoles>;
};

export type BulkMessageAudienceEstimate = {
  __typename?: 'BulkMessageAudienceEstimate';
  average_sms_segments_per_client: Scalars['NonNegativeFloat']['output'];
  eligible_clients: Scalars['NonNegativeInt']['output'];
  estimated_sms_cost_cents: Scalars['NonNegativeInt']['output'];
  estimated_sms_segments: Scalars['NonNegativeInt']['output'];
  filtered_clients: Scalars['NonNegativeInt']['output'];
  max_sms_segments_per_client: Scalars['NonNegativeInt']['output'];
  min_sms_segments_per_client: Scalars['NonNegativeInt']['output'];
  total_unique_clients: Scalars['NonNegativeInt']['output'];
};

export type BulkMessageAudienceEstimateInput = {
  body?: InputMaybe<Scalars['String']['input']>;
  clinic: Scalars['ID']['input'];
  cta_text?: InputMaybe<Scalars['String']['input']>;
  cta_url?: InputMaybe<Scalars['String']['input']>;
  customer_segment?: InputMaybe<Scalars['ID']['input']>;
  excluded_clients?: InputMaybe<Array<Scalars['ID']['input']>>;
  included_clients?: InputMaybe<Array<Scalars['ID']['input']>>;
  is_marketing?: InputMaybe<Scalars['Boolean']['input']>;
  message_methods?: InputMaybe<Array<MessageMethod>>;
};

/**
 * Clinic-local / archival fields safe to set across many notification
 * templates in one request (activate, preview mode, archive).
 */
export type BulkUpdateNotificationTemplateInput = {
  is_active?: InputMaybe<Scalars['Boolean']['input']>;
  is_archived?: InputMaybe<Scalars['Boolean']['input']>;
  is_preview_mode?: InputMaybe<Scalars['Boolean']['input']>;
};

/**
 * Clinic-local / archival fields safe to set across many bulk messages in one
 * request (e.g. activate every linked clinic copy of a group bulk message).
 */
export type BulkUpdateScheduledBulkMessagesInput = {
  is_active?: InputMaybe<Scalars['Boolean']['input']>;
  is_archived?: InputMaybe<Scalars['Boolean']['input']>;
};

export type Call = {
  __typename?: 'Call';
  caller_name?: Maybe<Scalars['String']['output']>;
  caller_phone?: Maybe<Scalars['String']['output']>;
  client?: Maybe<Client>;
  clinic: Clinic;
  created_at: Scalars['NonNegativeInt']['output'];
  direction?: Maybe<CallDirection>;
  duration?: Maybe<Scalars['NonNegativeInt']['output']>;
  ended_at?: Maybe<Scalars['NonNegativeInt']['output']>;
  failed_reason?: Maybe<Scalars['String']['output']>;
  id: Scalars['ID']['output'];
  is_automated?: Maybe<Scalars['Boolean']['output']>;
  notes?: Maybe<Scalars['String']['output']>;
  provider?: Maybe<PhoneProviderType>;
  recording_url?: Maybe<Scalars['String']['output']>;
  score?: Maybe<Scalars['NonNegativeInt']['output']>;
  score_reasoning?: Maybe<Scalars['String']['output']>;
  sentiment_agent?: Maybe<Scalars['Float']['output']>;
  sentiment_customer?: Maybe<Scalars['Float']['output']>;
  source_id?: Maybe<Scalars['String']['output']>;
  started_at?: Maybe<Scalars['NonNegativeInt']['output']>;
  status: CallStatus;
  to_phone?: Maybe<Scalars['String']['output']>;
  transcription_full_text?: Maybe<Scalars['String']['output']>;
  transcription_received_at?: Maybe<Scalars['NonNegativeInt']['output']>;
  transcription_segments?: Maybe<Scalars['JSON']['output']>;
  transcription_summary?: Maybe<Scalars['String']['output']>;
  updated_at: Scalars['NonNegativeInt']['output'];
};

export enum CallDirection {
  Inbound = 'Inbound',
  Outbound = 'Outbound'
}

export type CallStats = {
  __typename?: 'CallStats';
  appointments_booked: Scalars['NonNegativeInt']['output'];
  automated_calls: Scalars['NonNegativeInt']['output'];
  average_agent_sentiment?: Maybe<Scalars['Float']['output']>;
  average_customer_sentiment?: Maybe<Scalars['Float']['output']>;
  average_score?: Maybe<Scalars['NonNegativeFloat']['output']>;
  average_sentiment?: Maybe<Scalars['Float']['output']>;
  human_calls: Scalars['NonNegativeInt']['output'];
  revenue_created_cents: Scalars['NonNegativeInt']['output'];
  scored_calls: Scalars['NonNegativeInt']['output'];
  time_saved_minutes: Scalars['NonNegativeFloat']['output'];
  total_calls: Scalars['NonNegativeInt']['output'];
  total_duration_seconds: Scalars['NonNegativeInt']['output'];
};

export enum CallStatus {
  Ended = 'Ended',
  Failed = 'Failed',
  InCall = 'InCall',
  Ringing = 'Ringing',
  Unknown = 'Unknown'
}

export type Campaign = {
  __typename?: 'Campaign';
  clinic?: Maybe<Clinic>;
  clinic_group?: Maybe<ClinicGroup>;
  color?: Maybe<Scalars['String']['output']>;
  created_at: Scalars['Timestamp']['output'];
  description?: Maybe<Scalars['String']['output']>;
  end_time?: Maybe<Scalars['NonNegativeInt']['output']>;
  featured_stats: Array<Scalars['String']['output']>;
  id: Scalars['ID']['output'];
  is_active: Scalars['Boolean']['output'];
  is_archived: Scalars['Boolean']['output'];
  name: Scalars['String']['output'];
  notification_featured_stats: Array<Scalars['String']['output']>;
  notification_templates: Array<NotificationTemplate>;
  organization?: Maybe<Organization>;
  scheduled_bulk_message_featured_stats: Array<Scalars['String']['output']>;
  scheduled_bulk_messages: Array<ScheduledBulkMessage>;
  start_time?: Maybe<Scalars['NonNegativeInt']['output']>;
  updated_at: Scalars['Timestamp']['output'];
  widget_featured_stats: Array<Scalars['String']['output']>;
  widgets: Array<Widget>;
};

export type CampaignNotificationStats = {
  __typename?: 'CampaignNotificationStats';
  avg_open_time?: Maybe<Scalars['Float']['output']>;
  bounce_rate?: Maybe<Scalars['Float']['output']>;
  delivery_rate?: Maybe<Scalars['Float']['output']>;
  messages_sent?: Maybe<Scalars['NonNegativeInt']['output']>;
  open_rate?: Maybe<Scalars['Float']['output']>;
  total_recipients?: Maybe<Scalars['NonNegativeInt']['output']>;
};

export type CampaignScheduledBulkMessageStats = {
  __typename?: 'CampaignScheduledBulkMessageStats';
  avg_open_time?: Maybe<Scalars['Float']['output']>;
  bounce_rate?: Maybe<Scalars['Float']['output']>;
  delivery_rate?: Maybe<Scalars['Float']['output']>;
  messages_sent?: Maybe<Scalars['NonNegativeInt']['output']>;
  open_rate?: Maybe<Scalars['Float']['output']>;
  total_recipients?: Maybe<Scalars['NonNegativeInt']['output']>;
};

export type CampaignStats = {
  __typename?: 'CampaignStats';
  active_bulk_messages?: Maybe<Scalars['NonNegativeInt']['output']>;
  active_notif_templates?: Maybe<Scalars['NonNegativeInt']['output']>;
  active_widgets?: Maybe<Scalars['NonNegativeInt']['output']>;
  avg_conversion_rate?: Maybe<Scalars['Float']['output']>;
  avg_interactions_per_message?: Maybe<Scalars['Float']['output']>;
  total_appointments?: Maybe<Scalars['NonNegativeInt']['output']>;
  total_email_message_opens?: Maybe<Scalars['NonNegativeInt']['output']>;
  total_interactions?: Maybe<Scalars['NonNegativeInt']['output']>;
  total_link_clicks?: Maybe<Scalars['NonNegativeInt']['output']>;
  total_messages_sent?: Maybe<Scalars['NonNegativeInt']['output']>;
  total_revenue?: Maybe<Scalars['NonNegativeInt']['output']>;
  total_unique_patients?: Maybe<Scalars['NonNegativeInt']['output']>;
  total_widget_views?: Maybe<Scalars['NonNegativeInt']['output']>;
};

export type CampaignWidgetStats = {
  __typename?: 'CampaignWidgetStats';
  avg_booking_value?: Maybe<Scalars['NonNegativeInt']['output']>;
  avg_time_to_book?: Maybe<Scalars['Float']['output']>;
  bounce_rate?: Maybe<Scalars['Float']['output']>;
  conversion_rate?: Maybe<Scalars['Float']['output']>;
  direct_invoice_amt_total?: Maybe<Scalars['NonNegativeInt']['output']>;
  most_popular_service?: Maybe<Scalars['String']['output']>;
  peak_booking_hour?: Maybe<Scalars['String']['output']>;
  repeat_booking_rate?: Maybe<Scalars['Float']['output']>;
  total_appointments?: Maybe<Scalars['NonNegativeInt']['output']>;
  total_unique_clients?: Maybe<Scalars['NonNegativeInt']['output']>;
  total_unique_patients?: Maybe<Scalars['NonNegativeInt']['output']>;
  total_views?: Maybe<Scalars['NonNegativeInt']['output']>;
};

export type ChangeLog = {
  __typename?: 'ChangeLog';
  created_at: Scalars['Timestamp']['output'];
  entity_id: Scalars['String']['output'];
  entity_table: Scalars['String']['output'];
  id: Scalars['ID']['output'];
  new_values?: Maybe<Scalars['JSON']['output']>;
  old_values?: Maybe<Scalars['JSON']['output']>;
  updated_at: Scalars['Timestamp']['output'];
  user?: Maybe<User>;
};

export type Chat = {
  __typename?: 'Chat';
  assignee?: Maybe<User>;
  chat_status?: Maybe<ChatStatusConfig>;
  client: Client;
  client_last_message?: Maybe<Scalars['String']['output']>;
  client_last_message_time: Scalars['NonNegativeInt']['output'];
  client_last_read: Scalars['NonNegativeInt']['output'];
  client_last_read_count: Scalars['NonNegativeInt']['output'];
  client_message_count: Scalars['NonNegativeInt']['output'];
  client_unread_count: Scalars['NonNegativeInt']['output'];
  clinic: Clinic;
  clinic_last_message?: Maybe<Scalars['String']['output']>;
  clinic_last_message_time: Scalars['NonNegativeInt']['output'];
  clinic_last_read: Scalars['NonNegativeInt']['output'];
  clinic_last_read_count: Scalars['NonNegativeInt']['output'];
  clinic_message_count: Scalars['NonNegativeInt']['output'];
  clinic_unread_count: Scalars['NonNegativeInt']['output'];
  compliance_status?: Maybe<Scalars['String']['output']>;
  /**
   * When the compliance status was last set (server-maintained by
   * updateChat; null when no status is set). Backfilled from change_logs
   * history where available.
   */
  compliance_status_updated_at?: Maybe<Scalars['Timestamp']['output']>;
  /**
   * Who last set the compliance status (server-maintained; null when no
   * status is set or the change was made by the system).
   */
  compliance_status_updated_by?: Maybe<User>;
  created_at: Scalars['Timestamp']['output'];
  id: Scalars['ID']['output'];
  is_hidden: Scalars['Boolean']['output'];
  is_pinned: Scalars['Boolean']['output'];
  last_message?: Maybe<Scalars['String']['output']>;
  last_message_time: Scalars['Timestamp']['output'];
  last_writeback_time?: Maybe<Scalars['NonNegativeInt']['output']>;
  message_count: Scalars['NonNegativeInt']['output'];
  non_system_last_message?: Maybe<Scalars['String']['output']>;
  non_system_last_message_time: Scalars['NonNegativeInt']['output'];
  non_system_message_count: Scalars['NonNegativeInt']['output'];
  status: ChatStatus;
  system_last_message?: Maybe<Scalars['String']['output']>;
  system_last_message_time: Scalars['NonNegativeInt']['output'];
  system_message_count: Scalars['NonNegativeInt']['output'];
  title?: Maybe<Scalars['String']['output']>;
  updated_at: Scalars['Timestamp']['output'];
};

export type ChatQueryResult = {
  __typename?: 'ChatQueryResult';
  chats: Array<Chat>;
  count: Scalars['NonNegativeInt']['output'];
};

export enum ChatStatus {
  Closed = 'Closed',
  HighPriority = 'HighPriority',
  LowPriority = 'LowPriority',
  NormalPriority = 'NormalPriority',
  Open = 'Open'
}

export type ChatStatusConfig = {
  __typename?: 'ChatStatusConfig';
  clinic?: Maybe<Clinic>;
  clinic_group?: Maybe<ClinicGroup>;
  color?: Maybe<Scalars['String']['output']>;
  created_at: Scalars['Timestamp']['output'];
  id: Scalars['ID']['output'];
  is_archived: Scalars['Boolean']['output'];
  name: Scalars['String']['output'];
  sort_order: Scalars['Int']['output'];
  updated_at: Scalars['Timestamp']['output'];
};

export type ChckupMetadata = {
  __typename?: 'ChckupMetadata';
  id: Scalars['String']['output'];
  last_appointment_handled_time: Scalars['NonNegativeInt']['output'];
};

export type ChckupMetadataInput = {
  last_appointment_handled_time?: InputMaybe<Scalars['NonNegativeInt']['input']>;
};

export type CheckIn = {
  __typename?: 'CheckIn';
  clinic: Clinic;
  created_at: Scalars['Timestamp']['output'];
  id: Scalars['ID']['output'];
  status?: Maybe<CheckInStatus>;
  updated_at: Scalars['Timestamp']['output'];
  user: User;
  vehicle?: Maybe<Scalars['String']['output']>;
  visit_reason?: Maybe<VisitReason>;
};

export enum CheckInStatus {
  Cancelled = 'Cancelled',
  Completed = 'Completed',
  Pending = 'Pending'
}

export type Client = {
  __typename?: 'Client';
  address?: Maybe<Address>;
  balance?: Maybe<Scalars['Float']['output']>;
  birthday?: Maybe<Scalars['Float']['output']>;
  chats?: Maybe<Array<Chat>>;
  client_emails?: Maybe<Array<ClientEmail>>;
  client_notes?: Maybe<Array<ClientNote>>;
  client_phones?: Maybe<Array<ClientPhone>>;
  clinic?: Maybe<Clinic>;
  created_at: Scalars['Timestamp']['output'];
  email?: Maybe<Scalars['String']['output']>;
  email_enabled: Scalars['Boolean']['output'];
  first_name?: Maybe<Scalars['String']['output']>;
  /**
   * True if any linked user has launched the native app
   * (users.mobile_app_logged_in_at is non-null). Not based on push tokens.
   */
  has_mobile_app: Scalars['Boolean']['output'];
  has_portal_account: Scalars['Boolean']['output'];
  id: Scalars['ID']['output'];
  is_active?: Maybe<Scalars['Boolean']['output']>;
  is_lead: Scalars['Boolean']['output'];
  is_unsubscribed: Scalars['Boolean']['output'];
  last_appointment?: Maybe<Appointment>;
  last_appt_time?: Maybe<Scalars['NonNegativeInt']['output']>;
  last_contact_time?: Maybe<Scalars['NonNegativeInt']['output']>;
  last_name?: Maybe<Scalars['String']['output']>;
  loyalty_members?: Maybe<Array<Maybe<LoyaltyMember>>>;
  next_appointment?: Maybe<Appointment>;
  next_appt_time?: Maybe<Scalars['NonNegativeInt']['output']>;
  origin?: Maybe<EntityOrigin>;
  patient_count?: Maybe<Scalars['NonNegativeInt']['output']>;
  patients?: Maybe<Array<Patient>>;
  phone?: Maybe<Scalars['String']['output']>;
  pms?: Maybe<PracticeManagementSystem>;
  pms_created_at?: Maybe<Scalars['NonNegativeInt']['output']>;
  pms_db?: Maybe<PmsDb>;
  pms_id?: Maybe<Scalars['String']['output']>;
  pms_status?: Maybe<Scalars['String']['output']>;
  primary_email?: Maybe<Scalars['ID']['output']>;
  primary_phone?: Maybe<Scalars['ID']['output']>;
  secondary_first_name?: Maybe<Scalars['String']['output']>;
  secondary_last_name?: Maybe<Scalars['String']['output']>;
  settings?: Maybe<ClientSettings>;
  sms_enabled: Scalars['Boolean']['output'];
  status?: Maybe<ClientStatus>;
  title?: Maybe<Scalars['String']['output']>;
  updated_at: Scalars['Timestamp']['output'];
  user?: Maybe<User>;
  users: Array<User>;
};

export type ClientAiSummary = {
  __typename?: 'ClientAISummary';
  hasData: Scalars['Boolean']['output'];
  summary: Scalars['String']['output'];
};

export type ClientEmail = {
  __typename?: 'ClientEmail';
  client: Client;
  created_at: Scalars['Timestamp']['output'];
  email: Scalars['String']['output'];
  id: Scalars['ID']['output'];
  is_primary: Scalars['Boolean']['output'];
  updated_at: Scalars['Timestamp']['output'];
};

export type ClientEmailPreview = {
  __typename?: 'ClientEmailPreview';
  email: Scalars['String']['output'];
  id: Scalars['ID']['output'];
  is_primary: Scalars['Boolean']['output'];
};

export type ClientForm = {
  __typename?: 'ClientForm';
  appointment?: Maybe<Appointment>;
  client?: Maybe<Client>;
  client_completed_at?: Maybe<Scalars['NonNegativeInt']['output']>;
  clinic_verified_at?: Maybe<Scalars['NonNegativeInt']['output']>;
  created_at: Scalars['Timestamp']['output'];
  form: Form;
  form_data: FormFields;
  id: Scalars['ID']['output'];
  is_archived: Scalars['Boolean']['output'];
  patient?: Maybe<Patient>;
  pms_id?: Maybe<Scalars['String']['output']>;
  updated_at: Scalars['Timestamp']['output'];
};

export type ClientInfo = {
  __typename?: 'ClientInfo';
  address?: Maybe<Address>;
  email?: Maybe<Scalars['String']['output']>;
  first_name?: Maybe<Scalars['String']['output']>;
  last_name?: Maybe<Scalars['String']['output']>;
  phone?: Maybe<Scalars['String']['output']>;
};

export type ClientInfoInput = {
  address?: InputMaybe<AddressInput>;
  email?: InputMaybe<Scalars['String']['input']>;
  first_name?: InputMaybe<Scalars['String']['input']>;
  last_name?: InputMaybe<Scalars['String']['input']>;
  phone?: InputMaybe<Scalars['String']['input']>;
};

export enum ClientMatchingCriteria {
  Email = 'Email',
  LastNameAndPatientName = 'LastNameAndPatientName',
  Phone = 'Phone'
}

/**
 * General PMS note about a client, synced nightly (Bitwerx: Impromed /
 * Avimark / Cornerstone). Surfaced in the inbox client panel.
 */
export type ClientNote = {
  __typename?: 'ClientNote';
  client?: Maybe<Scalars['ID']['output']>;
  created_at: Scalars['Timestamp']['output'];
  id: Scalars['ID']['output'];
  is_active: Scalars['Boolean']['output'];
  noted_at?: Maybe<Scalars['Timestamp']['output']>;
  pms_id?: Maybe<Scalars['String']['output']>;
  text?: Maybe<Scalars['String']['output']>;
  updated_at: Scalars['Timestamp']['output'];
};

export type ClientPhone = {
  __typename?: 'ClientPhone';
  client: Client;
  country_code?: Maybe<Scalars['String']['output']>;
  created_at: Scalars['Timestamp']['output'];
  id: Scalars['ID']['output'];
  is_active: Scalars['Boolean']['output'];
  is_chckup_primary: Scalars['Boolean']['output'];
  is_mobile: Scalars['Boolean']['output'];
  is_primary: Scalars['Boolean']['output'];
  is_unsubscribed: Scalars['Boolean']['output'];
  name?: Maybe<Scalars['String']['output']>;
  phone: Scalars['String']['output'];
  sms_available: Scalars['Boolean']['output'];
  updated_at: Scalars['Timestamp']['output'];
};

export type ClientPhonePreview = {
  __typename?: 'ClientPhonePreview';
  id: Scalars['ID']['output'];
  is_primary: Scalars['Boolean']['output'];
  phone: Scalars['String']['output'];
};

export type ClientPreview = {
  __typename?: 'ClientPreview';
  client_emails_preview?: Maybe<Array<ClientEmailPreview>>;
  client_phones_preview?: Maybe<Array<ClientPhonePreview>>;
  clinic?: Maybe<Clinic>;
  email_preview: Scalars['String']['output'];
  has_user: Scalars['Boolean']['output'];
  id: Scalars['ID']['output'];
  is_portal_enabled: Scalars['Boolean']['output'];
  name_preview: Scalars['String']['output'];
  phone_preview: Scalars['String']['output'];
};

export type ClientSettings = {
  __typename?: 'ClientSettings';
  client_chckup_email_enabled: Scalars['Boolean']['output'];
  client_chckup_notifications_enabled: Scalars['Boolean']['output'];
  client_chckup_phone_calls_enabled: Scalars['Boolean']['output'];
  client_chckup_sms_enabled: Scalars['Boolean']['output'];
  clinic_chckup_email_enabled: Scalars['Boolean']['output'];
  clinic_chckup_notifications_enabled: Scalars['Boolean']['output'];
  clinic_chckup_phone_calls_enabled: Scalars['Boolean']['output'];
  clinic_chckup_sms_enabled: Scalars['Boolean']['output'];
  is_unsubscribed_from_marketing: Scalars['Boolean']['output'];
  is_unsubscribed_from_marketing_email: Scalars['Boolean']['output'];
  is_unsubscribed_from_marketing_sms: Scalars['Boolean']['output'];
};

export type ClientSettingsInput = {
  client_chckup_email_enabled?: InputMaybe<Scalars['Boolean']['input']>;
  client_chckup_notifications_enabled?: InputMaybe<Scalars['Boolean']['input']>;
  client_chckup_phone_calls_enabled?: InputMaybe<Scalars['Boolean']['input']>;
  client_chckup_sms_enabled?: InputMaybe<Scalars['Boolean']['input']>;
  clinic_chckup_email_enabled?: InputMaybe<Scalars['Boolean']['input']>;
  clinic_chckup_notifications_enabled?: InputMaybe<Scalars['Boolean']['input']>;
  clinic_chckup_phone_calls_enabled?: InputMaybe<Scalars['Boolean']['input']>;
  clinic_chckup_sms_enabled?: InputMaybe<Scalars['Boolean']['input']>;
  is_unsubscribed_from_marketing?: InputMaybe<Scalars['Boolean']['input']>;
  is_unsubscribed_from_marketing_email?: InputMaybe<Scalars['Boolean']['input']>;
  is_unsubscribed_from_marketing_sms?: InputMaybe<Scalars['Boolean']['input']>;
};

export type ClientStatus = {
  __typename?: 'ClientStatus';
  clinic?: Maybe<Clinic>;
  created_at: Scalars['Timestamp']['output'];
  description?: Maybe<Scalars['String']['output']>;
  id: Scalars['ID']['output'];
  name?: Maybe<Scalars['String']['output']>;
  pms?: Maybe<PracticeManagementSystem>;
  pms_id?: Maybe<Scalars['String']['output']>;
  updated_at: Scalars['Timestamp']['output'];
};

export enum ClientTypeEnum {
  New = 'New',
  Returning = 'Returning'
}

export type ClientWithOverduePatient = {
  __typename?: 'ClientWithOverduePatient';
  client: Client;
  overdue_patients: Array<OverduePatient>;
};

export type Clinic = {
  __typename?: 'Clinic';
  address?: Maybe<Address>;
  adjusted_availability?: Maybe<Array<Availability>>;
  animals: Array<Animal>;
  avatar_url?: Maybe<Scalars['String']['output']>;
  clinic_admins: Array<ClinicAdmin>;
  clinic_hours?: Maybe<AvailabilityHours>;
  clinic_species?: Maybe<Array<ClinicSpecies>>;
  created_at: Scalars['Timestamp']['output'];
  custom_roles: Array<CustomRole>;
  description?: Maybe<Scalars['String']['output']>;
  disabled_features?: Maybe<DisabledFeatures>;
  email?: Maybe<Scalars['String']['output']>;
  features?: Maybe<ClinicFeatures>;
  /**
   * Calendar date this clinic went (or will go) live, as YYYY-MM-DD.
   * Stored as epoch ms at UTC midnight (BigInt, like created_at). Written
   * by setClinicGoLiveDate (admin) or setClinicGroupOnboardingGoLiveDate
   * (group manager), not `updateClinic`.
   */
  go_live_date?: Maybe<Scalars['String']['output']>;
  hours?: Maybe<AvailabilityHours>;
  id: Scalars['ID']['output'];
  is_archived: Scalars['Boolean']['output'];
  is_featured?: Maybe<Scalars['Boolean']['output']>;
  is_verified?: Maybe<Scalars['Boolean']['output']>;
  last_sync_times?: Maybe<LastSyncTimes>;
  location?: Maybe<Scalars['String']['output']>;
  mute_until?: Maybe<Scalars['NonNegativeInt']['output']>;
  name?: Maybe<Scalars['String']['output']>;
  offers_emergency_care?: Maybe<Scalars['Boolean']['output']>;
  office_emails?: Maybe<Array<Scalars['String']['output']>>;
  onboarding?: Maybe<ClinicOnboarding>;
  organization?: Maybe<Organization>;
  phone?: Maybe<Scalars['String']['output']>;
  pims_settings?: Maybe<PimsSettings>;
  pms: PracticeManagementSystem;
  pms_additional_key?: Maybe<Scalars['String']['output']>;
  pms_adjusted_availability?: Maybe<Array<Availability>>;
  pms_api_key?: Maybe<Scalars['String']['output']>;
  pms_api_subdomain?: Maybe<Scalars['String']['output']>;
  /** How this clinic's PIMS data reaches us. pms stays the PIMS itself. */
  pms_connector: PmsConnector;
  pms_db?: Maybe<PmsDb>;
  pms_version?: Maybe<Scalars['String']['output']>;
  ratings?: Maybe<ClinicRatings>;
  reply_to_email?: Maybe<Scalars['String']['output']>;
  send_from_email?: Maybe<Scalars['String']['output']>;
  send_from_phone?: Maybe<Scalars['String']['output']>;
  services: Array<Service>;
  settings?: Maybe<ClinicSettings>;
  slug?: Maybe<Scalars['String']['output']>;
  stripe_account_type?: Maybe<Scalars['String']['output']>;
  stripe_accounts_enabled?: Maybe<Array<StripeAccountType>>;
  stripe_connected_account_id?: Maybe<Scalars['String']['output']>;
  stripe_customer_id?: Maybe<Scalars['String']['output']>;
  sync_from?: Maybe<SyncFrom>;
  time_zone?: Maybe<Scalars['String']['output']>;
  /** Per-clinic JSON feature flags. Keys, types, and used-vs-unused notes live in dashboard/src/components/settings/general/tmp-feature-flags/flag-definitions.ts and server/src/supabase/rows.ts. Most flags are only editable from the admin tmp-feature-flags editor. health_check_notes is a short-term key the daily health-check bot reads — promote to a real column later. */
  tmp_feature_flags?: Maybe<Scalars['JSON']['output']>;
  updated_at: Scalars['Timestamp']['output'];
  website?: Maybe<Scalars['String']['output']>;
};

/**
 * Effective role and permissions for one user inside one clinic.
 * Direct clinic membership wins. Otherwise access is derived from a
 * clinic group the user belongs to that contains the clinic.
 */
export type ClinicAccess = {
  __typename?: 'ClinicAccess';
  permissions: Array<ClinicAdminPermission>;
  role: AuthRoles;
  source: ClinicAccessSource;
};

export enum ClinicAccessSource {
  Direct = 'Direct',
  Group = 'Group'
}

export type ClinicAdmin = {
  __typename?: 'ClinicAdmin';
  /** Effective normalised admin permissions (boolean per feature). Same resolution rules as permissions. */
  admin_permissions: AdminPermissions;
  allow_approving_controlled_substances: Scalars['Boolean']['output'];
  are_desktop_notifications_enabled: Scalars['Boolean']['output'];
  are_email_notifications_enabled: Scalars['Boolean']['output'];
  are_sms_notifications_enabled: Scalars['Boolean']['output'];
  clinic: Clinic;
  created_at: Scalars['Timestamp']['output'];
  custom_role?: Maybe<CustomRole>;
  id: Scalars['ID']['output'];
  /** Effective permissions (legacy list shape). Resolved from role defaults, the bound custom role template, or the membership's own admin_permissions row. */
  permissions?: Maybe<Array<ClinicAdminPermission>>;
  role: AuthRoles;
  /** When true, daily huddle financial figures (revenue/earnings) are hidden for this specific user. */
  should_hide_daily_huddle_financials: Scalars['Boolean']['output'];
  updated_at: Scalars['Timestamp']['output'];
  user: User;
};

export type ClinicAdminPermission = {
  __typename?: 'ClinicAdminPermission';
  access_level: AdminPermissionAccessLevel;
  feature: AdminPermissionFeature;
};

export type ClinicAdminPermissionInput = {
  access_level: AdminPermissionAccessLevel;
  feature: AdminPermissionFeature;
};

/**
 * Short-lived delegated read-only GraphQL credential for the clinic agent.
 * The browser does not need this for chat — the server mints per turn —
 * but the dashboard may call `mintClinicAgentSession` to warm / probe access.
 */
export type ClinicAgentSession = {
  __typename?: 'ClinicAgentSession';
  /** Epoch millis when the JWT expires. */
  expiresAt: Scalars['Timestamp']['output'];
  token: Scalars['String']['output'];
};

/**
 * Dashboard screen the clinic user was on when they sent the message.
 * Route-only — not a screenshot. Helps Ask Chckvet answer "where am I /
 * where do I click" questions without guessing.
 */
export type ClinicAgentUiContextInput = {
  /** Route param ids when present (e.g. audience/service/clinician uuid). */
  entityIds?: InputMaybe<Array<Scalars['ID']['input']>>;
  /** Short human label derived from the route, e.g. Booking › Availability Checker. */
  pageLabel?: InputMaybe<Scalars['String']['input']>;
  /** Pathname only, e.g. /booking/availability-checker. */
  pathname: Scalars['String']['input'];
  /** Query string including leading ?, if any. */
  search?: InputMaybe<Scalars['String']['input']>;
};

export enum ClinicAggregateFunction {
  Count = 'count',
  Sum = 'sum'
}

export enum ClinicAggregateGroupBy {
  Client = 'client',
  ClientEmail = 'client_email',
  ClientName = 'client_name',
  Clinician = 'clinician',
  Day = 'day',
  None = 'none',
  Patient = 'patient',
  Service = 'service',
  Status = 'status'
}

export type ClinicAggregateInput = {
  /** Defaults to count. sum is only valid on invoices (total / total_paid). */
  aggregate?: InputMaybe<ClinicAggregateFunction>;
  /** Defaults to id for count, total for invoice sum. */
  aggregateColumn?: InputMaybe<Scalars['String']['input']>;
  clinicId: Scalars['ID']['input'];
  /** Defaults to start_time on appointments, created_at otherwise. */
  dateColumn?: InputMaybe<Scalars['String']['input']>;
  fromDate?: InputMaybe<Scalars['NonNegativeInt']['input']>;
  /**
   * Defaults to none (single clinic total). Use client_name to collapse
   * duplicate PMS client rows for the same person.
   */
  groupBy?: InputMaybe<ClinicAggregateGroupBy>;
  /** Default 10, max 25. */
  limit?: InputMaybe<Scalars['PositiveInt']['input']>;
  table: ClinicAggregateTable;
  toDate?: InputMaybe<Scalars['NonNegativeInt']['input']>;
  /** AND filters on allowlisted columns of `table`. Do not pass clinic. */
  where?: InputMaybe<Array<QueryInput>>;
};

export type ClinicAggregateResult = {
  __typename?: 'ClinicAggregateResult';
  rows: Array<ClinicAggregateRow>;
  /** Number of groups returned after the limit. */
  totalGroups: Scalars['NonNegativeInt']['output'];
};

export type ClinicAggregateRow = {
  __typename?: 'ClinicAggregateRow';
  groupKey: Scalars['String']['output'];
  label: Scalars['String']['output'];
  value: Scalars['Float']['output'];
};

export enum ClinicAggregateTable {
  Appointments = 'appointments',
  Clients = 'clients',
  Invoices = 'invoices',
  Patients = 'patients'
}

export type ClinicAnalytics = {
  __typename?: 'ClinicAnalytics';
  accounts_receivable: Scalars['Float']['output'];
  appointments: Array<Appointment>;
  appointments_count: Scalars['NonNegativeInt']['output'];
  clients_with_negative_balances: Array<Client>;
  clients_with_negative_balances_count: Scalars['NonNegativeInt']['output'];
  forward_scheduled_patients_count: Scalars['NonNegativeInt']['output'];
  last_month_average_revenue_per_appointment: Scalars['Float']['output'];
  monthly_appointments_scheduled: Scalars['NonNegativeInt']['output'];
  monthly_revenue_completed: Scalars['Float']['output'];
  new_appointments_count: Scalars['NonNegativeInt']['output'];
  new_clients_count: Scalars['NonNegativeInt']['output'];
  new_patients_count: Scalars['NonNegativeInt']['output'];
  no_show_count: Scalars['NonNegativeInt']['output'];
  patients_without_reschedules: Array<Patient>;
  revenue: Scalars['Float']['output'];
  revenue_by_clinician: Array<RevenueGroup>;
  revenue_by_type: Array<RevenueGroup>;
  schedule_efficiency: Scalars['Float']['output'];
  transactions_count: Scalars['NonNegativeInt']['output'];
};

export type ClinicAppointmentCount = {
  __typename?: 'ClinicAppointmentCount';
  clinic: Clinic;
  count: Scalars['NonNegativeInt']['output'];
};

export type ClinicApptStatus = {
  __typename?: 'ClinicApptStatus';
  clinic?: Maybe<Clinic>;
  created_at: Scalars['Timestamp']['output'];
  description: Scalars['String']['output'];
  id: Scalars['ID']['output'];
  is_primary: Scalars['Boolean']['output'];
  pms?: Maybe<PracticeManagementSystem>;
  pms_id: Scalars['String']['output'];
  status: AppointmentStatus;
  updated_at: Scalars['Timestamp']['output'];
};

/**
 * Overrides for widget/portal booking-flow copy. Non-empty widget copy wins
 * over clinic; org is the last fallback. Prefer this over the legacy
 * custom_well_description / custom_sick_description strings.
 */
export type ClinicBookingCopy = {
  __typename?: 'ClinicBookingCopy';
  BLOCKLIST_ALERT_DESCRIPTION?: Maybe<Scalars['String']['output']>;
  /** Title shown when a returning client is on blocklist_customer_segment. */
  BLOCKLIST_ALERT_TITLE?: Maybe<Scalars['String']['output']>;
  CLIENT_INFORMATION_SECTION_TITLE?: Maybe<Scalars['String']['output']>;
  CLINIC_HEADER_LOGO_HEIGHT?: Maybe<Scalars['NonNegativeInt']['output']>;
  CONFIRMATION_SCREEN_DESCRIPTION?: Maybe<Scalars['String']['output']>;
  CONFIRMATION_SCREEN_TITLE?: Maybe<Scalars['String']['output']>;
  CONTACT_THE_CLINIC_TEXT?: Maybe<Scalars['String']['output']>;
  CONTACT_THE_CLINIC_TEXT_COLOR?: Maybe<Scalars['String']['output']>;
  CONTACT_THE_CLINIC_TEXT_SIZE?: Maybe<Scalars['String']['output']>;
  /** Other-category description when is_using_detailed_services is false. Overrides custom_other_description. */
  DEFAULT_OTHER_DESCRIPTION?: Maybe<Scalars['String']['output']>;
  /** Other-category title when is_using_detailed_services is false. Overrides custom_other_title. */
  DEFAULT_OTHER_TITLE?: Maybe<Scalars['String']['output']>;
  /** Sick tile description when is_using_detailed_services is false. Overrides custom_sick_description. */
  DEFAULT_SICK_DESCRIPTION?: Maybe<Scalars['String']['output']>;
  /** Wellness tile description when is_using_detailed_services is false. Overrides custom_well_description. */
  DEFAULT_WELLNESS_DESCRIPTION?: Maybe<Scalars['String']['output']>;
  DEPOSIT_FEE_NAME?: Maybe<Scalars['String']['output']>;
  NEGATIVE_RETURNING_CLIENT_ANSWER?: Maybe<Scalars['String']['output']>;
  NEGATIVE_RETURNING_PATIENT_ANSWER?: Maybe<Scalars['String']['output']>;
  /** Message when should_allow_new_clients is false. */
  NEW_CLIENT_BLOCKED_MESSAGE?: Maybe<Scalars['String']['output']>;
  /** Message when should_allow_new_patients is false. */
  NEW_PATIENT_BLOCKED_MESSAGE?: Maybe<Scalars['String']['output']>;
  PATIENT_INFORMATION_SECTION_TITLE?: Maybe<Scalars['String']['output']>;
  PAYMENT_INFORMATION_TITLE?: Maybe<Scalars['String']['output']>;
  POSITIVE_RETURNING_CLIENT_ANSWER?: Maybe<Scalars['String']['output']>;
  POSITIVE_RETURNING_PATIENT_ANSWER?: Maybe<Scalars['String']['output']>;
  PREPAID_SERVICES_LABEL?: Maybe<Scalars['String']['output']>;
  PREVIOUS_OR_REFERRING_CLINIC_QUESTION?: Maybe<Scalars['String']['output']>;
  RETURNING_CLIENT_PATIENT_DESCRIPTION?: Maybe<Scalars['String']['output']>;
  RETURNING_CLIENT_PATIENT_TITLE?: Maybe<Scalars['String']['output']>;
  RETURNING_CLIENT_QUESTION?: Maybe<Scalars['String']['output']>;
  RETURNING_PATIENT_QUESTION?: Maybe<Scalars['String']['output']>;
  REVIEW_NOTES_PROMPT?: Maybe<Scalars['String']['output']>;
  REVIEW_TITLE?: Maybe<Scalars['String']['output']>;
  SELECT_CLINICIAN_NEGATIVE_ANSWER?: Maybe<Scalars['String']['output']>;
  SELECT_CLINICIAN_POSITIVE_ANSWER?: Maybe<Scalars['String']['output']>;
  SELECT_CLINICIAN_TITLE?: Maybe<Scalars['String']['output']>;
  SELECT_TIME_TITLE?: Maybe<Scalars['String']['output']>;
  SERVICE_SECTION_TITLE?: Maybe<Scalars['String']['output']>;
  SERVICE_TYPE_SECTION_HEADING?: Maybe<Scalars['String']['output']>;
  SHOW_CLINIC_HEADER_LOGO?: Maybe<Scalars['Boolean']['output']>;
  STANDARD_SERVICES_LABEL?: Maybe<Scalars['String']['output']>;
  TRIGGER_WORDS_DETECTED_DESCRIPTION?: Maybe<Scalars['String']['output']>;
  TRIGGER_WORDS_DETECTED_HEADER?: Maybe<Scalars['String']['output']>;
  WIDGET_HEADER_TITLE?: Maybe<Scalars['String']['output']>;
};

export type ClinicBookingCopyInput = {
  CLIENT_INFORMATION_SECTION_TITLE?: InputMaybe<Scalars['String']['input']>;
  CLINIC_HEADER_LOGO_HEIGHT?: InputMaybe<Scalars['NonNegativeInt']['input']>;
  CONFIRMATION_SCREEN_DESCRIPTION?: InputMaybe<Scalars['String']['input']>;
  CONFIRMATION_SCREEN_TITLE?: InputMaybe<Scalars['String']['input']>;
  CONTACT_THE_CLINIC_TEXT?: InputMaybe<Scalars['String']['input']>;
  CONTACT_THE_CLINIC_TEXT_COLOR?: InputMaybe<Scalars['String']['input']>;
  CONTACT_THE_CLINIC_TEXT_SIZE?: InputMaybe<Scalars['String']['input']>;
  DEFAULT_OTHER_DESCRIPTION?: InputMaybe<Scalars['String']['input']>;
  DEFAULT_SICK_DESCRIPTION?: InputMaybe<Scalars['String']['input']>;
  DEFAULT_WELLNESS_DESCRIPTION?: InputMaybe<Scalars['String']['input']>;
  DEPOSIT_FEE_NAME?: InputMaybe<Scalars['String']['input']>;
  NEGATIVE_RETURNING_CLIENT_ANSWER?: InputMaybe<Scalars['String']['input']>;
  NEGATIVE_RETURNING_PATIENT_ANSWER?: InputMaybe<Scalars['String']['input']>;
  NEW_CLIENT_BLOCKED_MESSAGE?: InputMaybe<Scalars['String']['input']>;
  NEW_PATIENT_BLOCKED_MESSAGE?: InputMaybe<Scalars['String']['input']>;
  PATIENT_INFORMATION_SECTION_TITLE?: InputMaybe<Scalars['String']['input']>;
  PAYMENT_INFORMATION_TITLE?: InputMaybe<Scalars['String']['input']>;
  POSITIVE_RETURNING_CLIENT_ANSWER?: InputMaybe<Scalars['String']['input']>;
  POSITIVE_RETURNING_PATIENT_ANSWER?: InputMaybe<Scalars['String']['input']>;
  PREPAID_SERVICES_LABEL?: InputMaybe<Scalars['String']['input']>;
  PREVIOUS_OR_REFERRING_CLINIC_QUESTION?: InputMaybe<Scalars['String']['input']>;
  RETURNING_CLIENT_PATIENT_DESCRIPTION?: InputMaybe<Scalars['String']['input']>;
  RETURNING_CLIENT_PATIENT_TITLE?: InputMaybe<Scalars['String']['input']>;
  RETURNING_CLIENT_QUESTION?: InputMaybe<Scalars['String']['input']>;
  RETURNING_PATIENT_QUESTION?: InputMaybe<Scalars['String']['input']>;
  REVIEW_NOTES_PROMPT?: InputMaybe<Scalars['String']['input']>;
  REVIEW_TITLE?: InputMaybe<Scalars['String']['input']>;
  SELECT_CLINICIAN_NEGATIVE_ANSWER?: InputMaybe<Scalars['String']['input']>;
  SELECT_CLINICIAN_POSITIVE_ANSWER?: InputMaybe<Scalars['String']['input']>;
  SELECT_CLINICIAN_TITLE?: InputMaybe<Scalars['String']['input']>;
  SELECT_TIME_TITLE?: InputMaybe<Scalars['String']['input']>;
  SERVICE_SECTION_TITLE?: InputMaybe<Scalars['String']['input']>;
  SERVICE_TYPE_SECTION_HEADING?: InputMaybe<Scalars['String']['input']>;
  SHOW_CLINIC_HEADER_LOGO?: InputMaybe<Scalars['Boolean']['input']>;
  STANDARD_SERVICES_LABEL?: InputMaybe<Scalars['String']['input']>;
  TRIGGER_WORDS_DETECTED_DESCRIPTION?: InputMaybe<Scalars['String']['input']>;
  TRIGGER_WORDS_DETECTED_HEADER?: InputMaybe<Scalars['String']['input']>;
  WIDGET_HEADER_TITLE?: InputMaybe<Scalars['String']['input']>;
};

/**
 * Booking performance of one clinic over a date range, across every widget
 * and the portal, counted in booking sessions (see WidgetBookingSourceStats).
 * Sessions on group widgets only count toward a clinic once the visitor picks
 * that location.
 */
export type ClinicBookingSourceStats = {
  __typename?: 'ClinicBookingSourceStats';
  /** Every booking made in those booking sessions. */
  appointments_booked: Scalars['NonNegativeInt']['output'];
  clinic: Clinic;
  /** Share (0..1) of booking sessions that booked at least once (0 when there are none). */
  conversion_rate: Scalars['Float']['output'];
  /** Booking sessions started in the range. */
  sessions_started: Scalars['NonNegativeInt']['output'];
};

/**
 * One clinic's standardization coverage across every linkable entity type.
 * `total_linked` / `total_parents` exclude ClinicSettings (field-opt-in).
 */
export type ClinicEntityLinkCoverage = {
  __typename?: 'ClinicEntityLinkCoverage';
  clinic_id: Scalars['ID']['output'];
  clinic_name: Scalars['String']['output'];
  /** True when the clinic has an active ClinicSettings entity link */
  has_settings_link: Scalars['Boolean']['output'];
  total_linked: Scalars['NonNegativeInt']['output'];
  total_parents: Scalars['NonNegativeInt']['output'];
  types: Array<EntityLinkTypeCoverage>;
};

export type ClinicFeatures = {
  __typename?: 'ClinicFeatures';
  bulk_messaging_enabled?: Maybe<Scalars['Boolean']['output']>;
  calls_enabled?: Maybe<Scalars['Boolean']['output']>;
  forms_enabled?: Maybe<Scalars['Boolean']['output']>;
  help_enabled?: Maybe<Scalars['Boolean']['output']>;
  huddle_enabled?: Maybe<Scalars['Boolean']['output']>;
  loyalty_enabled?: Maybe<Scalars['Boolean']['output']>;
  medical_history_enabled?: Maybe<Scalars['Boolean']['output']>;
  messaging_enabled?: Maybe<Scalars['Boolean']['output']>;
  notifs_enabled?: Maybe<Scalars['Boolean']['output']>;
  payments_enabled?: Maybe<Scalars['Boolean']['output']>;
  pet_selfies_enabled?: Maybe<Scalars['Boolean']['output']>;
  portal_enabled?: Maybe<Scalars['Boolean']['output']>;
  prescriptions_enabled?: Maybe<Scalars['Boolean']['output']>;
  reviews_enabled?: Maybe<Scalars['Boolean']['output']>;
  scheduling_enabled?: Maybe<Scalars['Boolean']['output']>;
  teamchat_enabled?: Maybe<Scalars['Boolean']['output']>;
  telehealth_enabled?: Maybe<Scalars['Boolean']['output']>;
};

export type ClinicFeaturesInput = {
  bulk_messaging_enabled?: InputMaybe<Scalars['Boolean']['input']>;
  calls_enabled?: InputMaybe<Scalars['Boolean']['input']>;
  forms_enabled?: InputMaybe<Scalars['Boolean']['input']>;
  help_enabled?: InputMaybe<Scalars['Boolean']['input']>;
  huddle_enabled?: InputMaybe<Scalars['Boolean']['input']>;
  loyalty_enabled?: InputMaybe<Scalars['Boolean']['input']>;
  medical_history_enabled?: InputMaybe<Scalars['Boolean']['input']>;
  messaging_enabled?: InputMaybe<Scalars['Boolean']['input']>;
  notifs_enabled?: InputMaybe<Scalars['Boolean']['input']>;
  payments_enabled?: InputMaybe<Scalars['Boolean']['input']>;
  pet_selfies_enabled?: InputMaybe<Scalars['Boolean']['input']>;
  portal_enabled?: InputMaybe<Scalars['Boolean']['input']>;
  prescriptions_enabled?: InputMaybe<Scalars['Boolean']['input']>;
  reviews_enabled?: InputMaybe<Scalars['Boolean']['input']>;
  scheduling_enabled?: InputMaybe<Scalars['Boolean']['input']>;
  teamchat_enabled?: InputMaybe<Scalars['Boolean']['input']>;
  telehealth_enabled?: InputMaybe<Scalars['Boolean']['input']>;
};

export type ClinicFillRateResult = {
  __typename?: 'ClinicFillRateResult';
  clinic_fill_rate?: Maybe<FillRateResult>;
  clinician_fill_rates: Array<FillRateResult>;
  room_fill_rates: Array<FillRateResult>;
};

export type ClinicGoLiveCheck = {
  __typename?: 'ClinicGoLiveCheck';
  blocker_count: Scalars['NonNegativeInt']['output'];
  clinic_id: Scalars['ID']['output'];
  clinic_name: Scalars['String']['output'];
  clinic_slug?: Maybe<Scalars['String']['output']>;
  /** Blockers first, then warnings, then info. */
  findings: Array<GoLiveCheckFinding>;
  generated_at: Scalars['Timestamp']['output'];
  /** Calendar go-live date (YYYY-MM-DD), when set. */
  go_live_date?: Maybe<Scalars['String']['output']>;
  info_count: Scalars['NonNegativeInt']['output'];
  /** True when the clinic has gone live (see went_live_at). Several findings escalate after go-live. */
  is_past_go_live: Scalars['Boolean']['output'];
  pms: PracticeManagementSystem;
  /** One entry per probe requested in the query's probes argument. */
  probe_runs: Array<GoLiveCheckProbeRun>;
  sources_scanned: GoLiveCheckSourcesScanned;
  warning_count: Scalars['NonNegativeInt']['output'];
  /**
   * When the clinic went live: go_live_date when set, otherwise the start of
   * its first sustained run of real reminder sends or widget/portal
   * bookings. Null if it hasn't gone live.
   */
  went_live_at?: Maybe<Scalars['Timestamp']['output']>;
  /** Which signal went_live_at came from. */
  went_live_signal?: Maybe<GoLiveSignal>;
};

export type ClinicGroup = {
  __typename?: 'ClinicGroup';
  clinic_group_clinics: Array<ClinicGroupClinic>;
  clinic_group_users: Array<ClinicGroupUser>;
  clinic_groups: Array<ClinicGroup>;
  created_at: Scalars['Timestamp']['output'];
  custom_roles: Array<CustomRole>;
  id: Scalars['ID']['output'];
  is_archived: Scalars['Boolean']['output'];
  name: Scalars['String']['output'];
  /**
   * Merge tag names every clinic in the group is expected to fill in (e.g.
   * "facebook_url"). Values stay per-clinic in
   * `clinic_settings.custom_merge_tags`; this is the group's standard for
   * WHICH tags should exist, so a tag missing everywhere is still visible.
   */
  onboarding_expected_merge_tags: Array<Scalars['String']['output']>;
  /** Custom onboarding steps tracked for every clinic in this group, in display order. */
  onboarding_steps: Array<ClinicGroupOnboardingStep>;
  /** Rollout cohorts, in display order. Empty for groups that onboard all at once. */
  onboarding_tranches: Array<ClinicGroupOnboardingTranche>;
  parent_clinic_group?: Maybe<ClinicGroup>;
  /**
   * Group-level clinic_settings parent. Linked clinics can inherit these
   * values field-by-field via entity_links (see EntityLinkType.ClinicSettings).
   * Lazily created on first read/update if missing.
   */
  settings?: Maybe<ClinicSettings>;
  slug: Scalars['String']['output'];
  updated_at: Scalars['Timestamp']['output'];
};

export type ClinicGroupClinic = {
  __typename?: 'ClinicGroupClinic';
  clinic: Clinic;
  clinic_group: ClinicGroup;
  created_at: Scalars['Timestamp']['output'];
  id: Scalars['ID']['output'];
  updated_at: Scalars['Timestamp']['output'];
};

export type ClinicGroupClinicLocationInput = {
  latitude: Scalars['Float']['input'];
  longitude: Scalars['Float']['input'];
};

/**
 * A note on one cell of the onboarding report: free text, whether the group
 * has agreed the difference is deliberate, and who the cell is waiting on.
 *
 * `column_id` is the dashboard's report column id (e.g.
 * `s_google_review_link`, `step_Domain Verification`). Ids the dashboard no
 * longer recognises are simply ignored, so renaming a column orphans its notes
 * rather than breaking the report.
 *
 * The top-level fields are the current state. Each save that changes anything
 * prepends the previous state to `history` (newest first), so the
 * conversation accumulates instead of being overwritten.
 *
 * Stored in `clinic_groups.onboarding_exceptions`, which predates notes and
 * waiting-on and keeps its column name to avoid a rename migration.
 */
export type ClinicGroupOnboardingCellNote = {
  __typename?: 'ClinicGroupOnboardingCellNote';
  /**
   * Group admin currently assigned to follow up on this cell. Null means
   * nobody is assigned.
   */
  assigned_to?: Maybe<Scalars['ID']['output']>;
  /** Display name of the current assignee, stamped at write time. */
  assigned_to_name?: Maybe<Scalars['String']['output']>;
  clinic_id: Scalars['ID']['output'];
  column_id: Scalars['String']['output'];
  created_at: Scalars['NonNegativeInt']['output'];
  created_by: Scalars['ID']['output'];
  /**
   * Display name stamped at write time, so Chckvet admins (who aren't on
   * the group's user list) still show up as themselves in the conversation.
   */
  created_by_name?: Maybe<Scalars['String']['output']>;
  /**
   * Previous versions of this note, newest first. Empty until the note has
   * been saved more than once.
   */
  history: Array<ClinicGroupOnboardingCellNoteChange>;
  /**
   * True when the group has agreed this cell is deliberately different,
   * which takes it out of every difference count and colour. A note with
   * this false is commentary only and changes nothing about the comparison.
   */
  is_accepted: Scalars['Boolean']['output'];
  note?: Maybe<Scalars['String']['output']>;
  /** Null means the cell isn't waiting on anyone. */
  waiting_on?: Maybe<ClinicGroupOnboardingWaitingOn>;
};

/**
 * One past version of a cell note: the state that was current before a later
 * save replaced it. Kept so the conversation on a cell stays readable as the
 * note is updated over a rollout.
 */
export type ClinicGroupOnboardingCellNoteChange = {
  __typename?: 'ClinicGroupOnboardingCellNoteChange';
  /**
   * Group admin this note was assigned to at the time of this save.
   * Null means nobody was assigned.
   */
  assigned_to?: Maybe<Scalars['ID']['output']>;
  /**
   * Display name of the assignee, stamped at write time so the conversation
   * still reads if they later leave the group.
   */
  assigned_to_name?: Maybe<Scalars['String']['output']>;
  created_at: Scalars['NonNegativeInt']['output'];
  created_by: Scalars['ID']['output'];
  /**
   * Display name stamped at write time, so Chckvet admins (who aren't on
   * the group's user list) still show up as themselves in the conversation.
   */
  created_by_name?: Maybe<Scalars['String']['output']>;
  is_accepted: Scalars['Boolean']['output'];
  note?: Maybe<Scalars['String']['output']>;
  waiting_on?: Maybe<ClinicGroupOnboardingWaitingOn>;
};

/**
 * Per-column setup for one clinic group's onboarding report. Only columns that
 * DEVIATE from Chckvet's derived default appear here. An absent column is
 * scored the normal way and shown.
 *
 * Hiding and unscoring are deliberately separate. Hiding takes the column out
 * of the table, difference counts, and Aligned — that's how the group curates
 * what it's tracking. Unscoring says "this one is meant to vary": the column
 * stays visible, but it drops out of Aligned and difference highlighting.
 */
export type ClinicGroupOnboardingColumnConfig = {
  __typename?: 'ClinicGroupOnboardingColumnConfig';
  /** The dashboard's report column id, e.g. `s_google_review_link`. */
  column_id: Scalars['String']['output'];
  /** Null means use the default derived from the column's compare mode. */
  criterion?: Maybe<ClinicGroupOnboardingCriterion>;
  /** True hides the column from the table and drops it from Aligned. */
  is_hidden: Scalars['Boolean']['output'];
  /** False takes the column out of the Aligned score. */
  is_scored: Scalars['Boolean']['output'];
};

/**
 * A column's completion rule. `value` is only read by `Equals`,
 * `Contains`, `MatchesPattern` and `AtLeast`; it is stored as text and
 * coerced when evaluated, so `AtLeast` needs a numeric string.
 */
export type ClinicGroupOnboardingCriterion = {
  __typename?: 'ClinicGroupOnboardingCriterion';
  type: ClinicGroupOnboardingCriterionType;
  value?: Maybe<Scalars['String']['output']>;
};

export type ClinicGroupOnboardingCriterionInput = {
  type: ClinicGroupOnboardingCriterionType;
  value?: InputMaybe<Scalars['String']['input']>;
};

/**
 * How a report column is judged complete for the group's "Aligned" score.
 *
 * The first three are what Chckvet derives from a column's compare mode and
 * almost never need overriding. The rest are absolute: they don't depend on
 * what the other clinics have, which is what makes them the answer when the
 * relative default isn't trustworthy, notably across rollout tranches, where
 * "matching" is only ever measured within the tranche on screen.
 */
export enum ClinicGroupOnboardingCriterionType {
  /** A number or count at or above a fixed minimum. */
  AtLeast = 'AtLeast',
  /** Set, and containing a fixed substring. */
  Contains = 'Contains',
  /** Set, and equal to a fixed value. */
  Equals = 'Equals',
  /** A toggle that must be off. */
  IsOff = 'IsOff',
  /** A toggle that must be on. */
  IsOn = 'IsOn',
  /** Set, and matching a regular expression. */
  MatchesPattern = 'MatchesPattern',
  /** Set. Used where the value is per-clinic by nature. */
  NonEmpty = 'NonEmpty',
  /** Set, and equal to the value most clinics in scope have. */
  NonEmptyAndMatching = 'NonEmptyAndMatching',
  /** Set, and different from every other clinic's. */
  NonEmptyAndUnique = 'NonEmptyAndUnique'
}

/**
 * Returned by setClinicGroupOnboardingGoLiveDate so the dashboard can update
 * its cached report row without refetching.
 */
export type ClinicGroupOnboardingGoLiveDate = {
  __typename?: 'ClinicGroupOnboardingGoLiveDate';
  clinic_id: Scalars['ID']['output'];
  /** YYYY-MM-DD, or null when cleared. */
  go_live_date?: Maybe<Scalars['String']['output']>;
};

/**
 * A single custom onboarding step a clinic group tracks for each of its
 * clinics. `key` doubles as the display label (e.g. "Kickoff Call");
 * `options` are the values a clinic can be set to for this step (e.g.
 * ["Not Started", "In Progress", "Complete"]). Per-clinic progress lives in
 * `clinics.group_onboarding_statuses` and is read/written through the
 * enterprise-onboarding queries and mutations.
 */
export type ClinicGroupOnboardingStep = {
  __typename?: 'ClinicGroupOnboardingStep';
  key: Scalars['String']['output'];
  options: Array<Scalars['String']['output']>;
  /** Optional grouping (e.g. "Kickoff") used for the at-a-glance phase columns. */
  phase?: Maybe<Scalars['String']['output']>;
  /**
   * Dropdown vs free-text cell. Legacy JSON without this field is Options.
   * Free-text steps may have an empty options list.
   */
  value_kind: ClinicGroupOnboardingStepValueKind;
};

export type ClinicGroupOnboardingStepInput = {
  key: Scalars['String']['input'];
  options: Array<Scalars['String']['input']>;
  phase?: InputMaybe<Scalars['String']['input']>;
  value_kind?: InputMaybe<ClinicGroupOnboardingStepValueKind>;
};

/**
 * Returned by setClinicGroupOnboardingStepStatus so the dashboard can update
 * its cached report row without refetching.
 */
export type ClinicGroupOnboardingStepStatuses = {
  __typename?: 'ClinicGroupOnboardingStepStatuses';
  clinic_group_id: Scalars['ID']['output'];
  clinic_id: Scalars['ID']['output'];
  /** The clinic's full { [stepKey]: chosenOption } map for this group after the write. */
  step_statuses: Scalars['JSON']['output'];
};

/**
 * How a clinic fills one onboarding-report pipeline cell. `Options` is a
 * dropdown of the step's configured values (last option = complete).
 * `FreeText` is an open cell for links, dates, or notes; any non-empty
 * value counts as complete. Missing `value_kind` on stored JSON is Options.
 */
export enum ClinicGroupOnboardingStepValueKind {
  FreeText = 'FreeText',
  Options = 'Options'
}

/**
 * A rollout cohort for a group that onboards in batches. `key` doubles as the
 * display label (e.g. "Tranche 1"); `is_complete` lets a finished cohort be
 * tucked out of the way so the team can focus on the next one.
 */
export type ClinicGroupOnboardingTranche = {
  __typename?: 'ClinicGroupOnboardingTranche';
  clinic_ids: Array<Scalars['ID']['output']>;
  is_complete: Scalars['Boolean']['output'];
  key: Scalars['String']['output'];
};

export type ClinicGroupOnboardingTrancheInput = {
  clinic_ids: Array<Scalars['ID']['input']>;
  is_complete?: InputMaybe<Scalars['Boolean']['input']>;
  key: Scalars['String']['input'];
};

/**
 * Who owes the next action on one cell of the onboarding report. The point of
 * the report is to consolidate a group's open onboarding questions in one
 * place, and "is this on us or on them?" is the question asked of every one.
 */
export enum ClinicGroupOnboardingWaitingOn {
  /** Chckvet owes the clinic group this one. */
  Chckvet = 'Chckvet',
  /** The clinic group, or the clinic itself, owes us this one. */
  Customer = 'Customer'
}

export type ClinicGroupUser = {
  __typename?: 'ClinicGroupUser';
  /** Effective normalised admin permissions (boolean per feature). Same resolution rules as permissions. */
  admin_permissions: AdminPermissions;
  are_desktop_notifications_enabled: Scalars['Boolean']['output'];
  are_email_notifications_enabled: Scalars['Boolean']['output'];
  are_sms_notifications_enabled: Scalars['Boolean']['output'];
  clinic_group: ClinicGroup;
  created_at: Scalars['Timestamp']['output'];
  custom_role?: Maybe<CustomRole>;
  id: Scalars['ID']['output'];
  /** Effective permissions (legacy list shape). Resolved from role defaults, the bound custom role template, or the membership's own admin_permissions row. */
  permissions?: Maybe<Array<ClinicAdminPermission>>;
  role: AuthRoles;
  updated_at: Scalars['Timestamp']['output'];
  user: User;
};

export type ClinicHealthCheckResult = {
  __typename?: 'ClinicHealthCheckResult';
  clinic_count: Scalars['NonNegativeInt']['output'];
  generated_at: Scalars['Timestamp']['output'];
  /**
   * Pre-filtered clinic snapshots. TypeScript shape is
   * ClinicHealthCheckPayload in clinic-health-check.ts.
   */
  payload: Scalars['JSON']['output'];
  snapshot_date: Scalars['String']['output'];
};

export type ClinicHealthFindingInput = {
  clinic_id: Scalars['ID']['input'];
  clinic_name: Scalars['String']['input'];
  severity: ClinicHealthFindingSeverity;
  why: Scalars['String']['input'];
};

export enum ClinicHealthFindingSeverity {
  High = 'High',
  Medium = 'Medium'
}

/**
 * A clinic the daily health-check bot reported as actually broken and that
 * has not been resolved since. Stays in the next days' payloads (even if the
 * clinic stops tripping the pre-filter) until the bot marks it resolved or
 * stops re-reporting it for a week.
 */
export type ClinicHealthOpenIssue = {
  __typename?: 'ClinicHealthOpenIssue';
  clinic_id: Scalars['ID']['output'];
  clinic_name: Scalars['String']['output'];
  /** Calendar days from first_reported_date through the run's snapshot_date, inclusive. */
  days_open: Scalars['NonNegativeInt']['output'];
  /** yyyy-MM-dd (America/Chicago) of the first report in this streak. */
  first_reported_date: Scalars['String']['output'];
  last_reported_date: Scalars['String']['output'];
  severity: ClinicHealthFindingSeverity;
  /** Distinct days this issue has been reported in the current streak. */
  times_reported: Scalars['NonNegativeInt']['output'];
  /** Latest explanation from the bot. */
  why: Scalars['String']['output'];
};

export type ClinicHealthResolvedIssueInput = {
  clinic_id: Scalars['ID']['input'];
  /** What the bot saw that shows the issue is fixed or explained. */
  why: Scalars['String']['input'];
};

export type ClinicImageMap = {
  __typename?: 'ClinicImageMap';
  clinic_id: Scalars['ID']['output'];
  image_url: Scalars['String']['output'];
};

export type ClinicImageMapInput = {
  clinic_id: Scalars['ID']['input'];
  image_url: Scalars['String']['input'];
};

export type ClinicMessageCount = {
  __typename?: 'ClinicMessageCount';
  clinic: Clinic;
  count: Scalars['NonNegativeInt']['output'];
};

export type ClinicOnboarding = {
  __typename?: 'ClinicOnboarding';
  clinic?: Maybe<Clinic>;
  has_set_hours?: Maybe<Scalars['Boolean']['output']>;
  has_synced_pms?: Maybe<Scalars['Boolean']['output']>;
  has_test_appointment?: Maybe<Scalars['Boolean']['output']>;
  /**
   * Admin onboarding wizard state, opaque to the server:
   * { version, completed_step_ids, last_step_id }. Owned by the
   * dashboard wizard (see dashboard/src/components/admin/onboarding/wizard).
   */
  wizard_progress?: Maybe<Scalars['JSON']['output']>;
};

export type ClinicOnboardingInput = {
  has_set_hours?: InputMaybe<Scalars['Boolean']['input']>;
  has_synced_pms?: InputMaybe<Scalars['Boolean']['input']>;
  wizard_progress?: InputMaybe<Scalars['JSON']['input']>;
};

export type ClinicOrder = {
  __typename?: 'ClinicOrder';
  clinic_id: Scalars['ID']['output'];
  order: Scalars['NonNegativeInt']['output'];
};

export type ClinicOrderInput = {
  clinic_id: Scalars['ID']['input'];
  order: Scalars['NonNegativeInt']['input'];
};

export type ClinicRatings = {
  __typename?: 'ClinicRatings';
  care_rating_count?: Maybe<Scalars['NonNegativeInt']['output']>;
  care_rating_total?: Maybe<Scalars['NonNegativeInt']['output']>;
  overall_rating_count?: Maybe<Scalars['NonNegativeInt']['output']>;
  overall_rating_total?: Maybe<Scalars['NonNegativeInt']['output']>;
  price_rating_count?: Maybe<Scalars['NonNegativeInt']['output']>;
  price_rating_total?: Maybe<Scalars['NonNegativeInt']['output']>;
  time_rating_count?: Maybe<Scalars['NonNegativeInt']['output']>;
  time_rating_total?: Maybe<Scalars['NonNegativeInt']['output']>;
};

export type ClinicReviewsCopy = {
  __typename?: 'ClinicReviewsCopy';
  PRIVATE_REVIEW_BUTTON_HELP_TEXT?: Maybe<Scalars['String']['output']>;
  PRIVATE_REVIEW_BUTTON_TEXT?: Maybe<Scalars['String']['output']>;
  REVIEW_MESSAGE_LABEL?: Maybe<Scalars['String']['output']>;
  /** Description under the review-method page title. Supports appointment merge variables. */
  REVIEW_METHOD_PAGE_DESCRIPTION?: Maybe<Scalars['String']['output']>;
  /** Title on the choose Google / Facebook / private review page. */
  REVIEW_METHOD_PAGE_TITLE?: Maybe<Scalars['String']['output']>;
  REVIEW_PAGE_SUBTITLE?: Maybe<Scalars['String']['output']>;
  REVIEW_PAGE_TITLE?: Maybe<Scalars['String']['output']>;
  REVIEW_SCORE_LABEL?: Maybe<Scalars['String']['output']>;
  REVIEW_SUBMIT_BUTTON_TEXT?: Maybe<Scalars['String']['output']>;
};

export type ClinicReviewsCopyInput = {
  PRIVATE_REVIEW_BUTTON_HELP_TEXT?: InputMaybe<Scalars['String']['input']>;
  PRIVATE_REVIEW_BUTTON_TEXT?: InputMaybe<Scalars['String']['input']>;
  REVIEW_MESSAGE_LABEL?: InputMaybe<Scalars['String']['input']>;
  REVIEW_METHOD_PAGE_DESCRIPTION?: InputMaybe<Scalars['String']['input']>;
  REVIEW_METHOD_PAGE_TITLE?: InputMaybe<Scalars['String']['input']>;
  REVIEW_PAGE_SUBTITLE?: InputMaybe<Scalars['String']['input']>;
  REVIEW_PAGE_TITLE?: InputMaybe<Scalars['String']['input']>;
  REVIEW_SCORE_LABEL?: InputMaybe<Scalars['String']['input']>;
  REVIEW_SUBMIT_BUTTON_TEXT?: InputMaybe<Scalars['String']['input']>;
};

/**
 * Per-clinic configuration. Fields marked @deprecated are stored but unused —
 * changing them has no effect on booking, scheduling, or any other product logic.
 * "No dashboard control" means there is no dedicated Settings / service-editor /
 * portal-customization toggle (enterprise onboarding columns do not count).
 * Many booking fields cascade widget_options → clinic settings → org settings.
 * Dashboard help text and clinic-agent.graphql must not contradict Unused /
 * no-control notes — enforced by settings-copy-drift.spec.ts.
 */
export type ClinicSettings = {
  __typename?: 'ClinicSettings';
  /**
   * Accent brand hex for the same surfaces as primary_color. Also used as
   * the postcard secondary color when set, so secondary_color is only a
   * fallback.
   */
  accent_color?: Maybe<Scalars['String']['output']>;
  /** Freeform extra instructions appended to the AI agent's prompt. */
  ai_agent_custom_instructions?: Maybe<Scalars['String']['output']>;
  /** Personality and speech patterns passed to the AI phone agent as dynamic variables. */
  ai_agent_style?: Maybe<Scalars['String']['output']>;
  /** Inbound Agent/Persona ID for the AI call provider. */
  ai_calls_agent_id?: Maybe<Scalars['String']['output']>;
  /** Background ambience preset for AI calls. Null = platform default. */
  ai_calls_ambient_sound?: Maybe<AiCallsAmbientSound>;
  /**
   * Minimum minutes between AI outbound calls to the same client
   * (default 10080 = 7 days). No dashboard control.
   */
  ai_calls_cooldown_minutes?: Maybe<Scalars['Int']['output']>;
  /** When true, Retell adapts speech rate to the caller. Null = platform default. */
  ai_calls_enable_dynamic_voice_speed?: Maybe<Scalars['Boolean']['output']>;
  /** How quickly the agent yields to the caller (0–1). Null = platform default. */
  ai_calls_interruption_sensitivity?: Maybe<Scalars['Float']['output']>;
  /**
   * Agent/Persona ID for outbound AI calls; overrides ai_calls_agent_id
   * for outbound only. No dashboard control.
   */
  ai_calls_outbound_agent_id?: Maybe<Scalars['String']['output']>;
  /** Caller ID used for automated outbound AI calls. */
  ai_calls_phone_number?: Maybe<Scalars['String']['output']>;
  /** AI call provider, typically Retell. Distinct from phone_provider. */
  ai_calls_provider?: Maybe<PhoneProviderType>;
  /** Voice ID passed to the AI call provider. */
  ai_calls_voice_id?: Maybe<Scalars['String']['output']>;
  /** Voice playback speed multiplier (0.5–2.0). Null = platform default. */
  ai_calls_voice_speed?: Maybe<Scalars['Float']['output']>;
  /**
   * How many days before start a portal client may tap Confirm on a Booked
   * appointment (button shows if start_time is within this many days;
   * default 7). Distinct from confirmation emails (notification templates)
   * and from unused confirmation_days_before. No dashboard control.
   */
  allow_confirmation_days_before?: Maybe<Scalars['Int']['output']>;
  /**
   * Pulse only: when true, Pulse appointment write allows overlapping
   * visits (forceConflictingAppointmentRetryCount 2 vs 1). Does not change
   * Chckvet slot-generation collision logic. No dashboard control.
   */
  allow_double_booking: Scalars['Boolean']['output'];
  /**
   * When false (typical default), scheduling will not offer a slot that
   * would be the first appointment of that clinic day if another booking
   * already occupies the first-slot window. When true, that first-of-day
   * slot may be booked online. Server-side only.
   */
  allow_first_appt_per_day?: Maybe<Scalars['Boolean']['output']>;
  /**
   * Unused. Clients can reschedule online only when the booked service has
   * is_reschedule_allowed true (and the clinic still has scheduling enabled).
   * This clinic flag is never read. No dashboard control.
   * @deprecated Unused. Online reschedule is gated by service.is_reschedule_allowed. Retained for backwards-compat only.
   */
  allow_reschedule?: Maybe<Scalars['Boolean']['output']>;
  /** Loyalty points awarded when a client downloads the app. */
  app_download_loyalty_points?: Maybe<Scalars['Float']['output']>;
  /** Same as client_custom_required_fields, written onto new appointments. */
  appointment_custom_required_fields?: Maybe<Array<CustomBookingField>>;
  /**
   * How an online booking is written into the PMS.
   * Instant: immediate cloud write (and Stripe capture if the service has pricing).
   * ConfirmationRequired: stays pending until staff confirms in Connect; client gets requested/approved/denied templates.
   * ManualEntry: staff enter the visit in the PMS themselves.
   */
  appointment_entry_method?: Maybe<AppointmentEntryMethod>;
  /**
   * When true, cancelling an appointment in Chckup automatically refunds
   * the remaining balance of its successful Stripe payments. PIMS refund
   * posting still follows payment_writeback_enabled per PMS capability.
   */
  auto_refund_on_cancel: Scalars['Boolean']['output'];
  /**
   * When true, an inbound client SMS/chat with no staff reply after ~15
   * minutes gets auto_reply_message during auto_reply_hours.
   */
  auto_reply_enabled: Scalars['Boolean']['output'];
  /**
   * Weekly hours during which auto_reply_message is sent when
   * auto_reply_enabled is true. Same shape as clinic hours.
   */
  auto_reply_hours?: Maybe<AvailabilityHours>;
  /**
   * Auto-reply SMS/chat body sent when auto_reply_enabled is true and
   * auto_reply_hours cover now. Falls back to asking the client to call
   * the clinic phone if empty.
   */
  auto_reply_message?: Maybe<Scalars['String']['output']>;
  /**
   * Default appointment length (minutes) when a service has no duration —
   * used by AI booking tools and by Optimized schedule_method as the grid
   * step. Portal/widget slot requests fall back to time_slot_minutes (then
   * 30), not this field. Per-service duration and room/clinician
   * duration_override win when set (room first for room-scheduled
   * resources).
   */
  base_schedule_duration?: Maybe<Scalars['NonNegativeInt']['output']>;
  /**
   * Audience whose members cannot book online. Widget checks on returning-
   * client match and tells them to call. Distinct from should_allow_new_*.
   * Seeded and assigned on clinic create.
   */
  blocklist_customer_segment?: Maybe<CustomerSegment>;
  /**
   * How returning clients identify themselves during booking.
   * PatientSearch: lookup then continue.
   * PatientSearchWithVerification: lookup plus verification.
   * EnterAllInformation: always collect full fields (no lookup).
   * Legacy: skip modern search; if should_create_* is false and entry is
   * not ManualEntry, creates temp records plus a staff action item.
   */
  booking_match_procedure?: Maybe<BookingMatchProcedure>;
  /**
   * Minimum minutes before the requested start that a non-manager client may
   * cancel (or deny) online. Inside this window the portal cancel button is
   * disabled. Independent of service.is_cancellation_allowed, which is the
   * on/off gate for that service. Clinic managers bypass the buffer.
   */
  cancellation_buffer_minutes?: Maybe<Scalars['NonNegativeInt']['output']>;
  /**
   * PMS clinician id Connect assigns when rewriting a cancellation into
   * the PMS. Optional; can be set without cancellation_service_pms_id.
   * Admin Special Entities.
   */
  cancellation_clinician_pms_id?: Maybe<Scalars['String']['output']>;
  /**
   * PMS appointment-type id Connect rewrites the visit to before cancelling
   * it in the PMS, so cancellations land as a cancellation type rather than
   * leaving the original service on the books. Optional. Admin Special
   * Entities.
   */
  cancellation_service_pms_id?: Maybe<Scalars['String']['output']>;
  /**
   * Percent (0–100) of the Chckvet prescription processing fee billed to
   * the client vs the clinic.
   */
  chckvet_prescription_fee_split_percentage?: Maybe<Scalars['Float']['output']>;
  /**
   * ezyVet custom-field / tag-category defaults written onto new clients
   * at PMS create. Required rows always send default_value or N/A.
   * Not collected in the widget/portal booking form (include_in_booking_form
   * is unused). No dashboard control — admin/ezyVet sync.
   */
  client_custom_required_fields?: Maybe<Array<CustomBookingField>>;
  /**
   * Free-text clinic hours shown to clients and the AI receptionist
   * ({{clinic_hours_display}}). Overrides auto-formatted clinic.hours when
   * set. Display only — does not change slot math or holidays.
   */
  clinic_hours_display?: Maybe<Scalars['String']['output']>;
  /**
   * When true, a daily cron (~5 AM America/Chicago) batch-writes pending
   * conversations into the PMS. Still requires comms_writeback_enabled.
   */
  comms_should_daily_writeback: Scalars['Boolean']['output'];
  /**
   * When buffer/daily/before-appt checks do not trigger, OpenAI decides
   * whether the conversation should be written back. Requires
   * comms_writeback_enabled.
   */
  comms_should_use_ai_writeback: Scalars['Boolean']['output'];
  /**
   * When true, notification/system/bulk messages are included in instant
   * writeback and in the cron last-message timestamp. When false they are
   * skipped.
   */
  comms_should_writeback_notifs: Scalars['Boolean']['output'];
  /**
   * When true (and comms_writeback_enabled), write the conversation to the
   * PMS immediately when a client message is received.
   */
  comms_should_writeback_on_receive: Scalars['Boolean']['output'];
  /**
   * When true (and comms_writeback_enabled), write the conversation to the
   * PMS immediately when staff sends a message.
   */
  comms_should_writeback_on_send: Scalars['Boolean']['output'];
  /**
   * Unused. Writeback format is not switched by this flag.
   * @deprecated Unused. Not read by writeback logic. Retained for backwards-compat only.
   */
  comms_use_pdf_for_writeback: Scalars['Boolean']['output'];
  /**
   * Cron writeback also fires if the client has an appointment starting
   * within this many minutes. -1 disables the upcoming-appointment trigger.
   */
  comms_writeback_before_appt_mins: Scalars['Int']['output'];
  /**
   * Cron writeback waits this many minutes after the last message.
   * -1 disables the time-buffer trigger (does not disable writeback entirely).
   */
  comms_writeback_buffer_minutes: Scalars['Int']['output'];
  /**
   * Master switch for writing SMS/chat conversations into the PMS. Instant
   * writeback on send/receive and the hourly cron both no-op when false.
   */
  comms_writeback_enabled: Scalars['Boolean']['output'];
  /**
   * Allowed reminder-compliance status labels (Compliance Tracker and PMS
   * reminder RPCs). If unset, defaults to Needs Contact, Contacted, Left
   * Message, Booked, Not Interested, No Longer Client, Not Applicable.
   * No settings editor.
   */
  compliance_statuses?: Maybe<Array<Scalars['String']['output']>>;
  /**
   * Unused. Client confirmation emails use notification templates. The
   * portal Confirm button window uses allow_confirmation_days_before.
   * No dashboard control.
   * @deprecated Unused. Portal confirm window uses allow_confirmation_days_before. Retained for backwards-compat only.
   */
  confirmation_days_before?: Maybe<Scalars['NonNegativeInt']['output']>;
  /**
   * PMS appointment-notes template on booking writeback. Supports merge
   * tags such as {{client_name}}, {{patient_name}}, {{appointment_service}}.
   * Service.custom_appointment_notes_template overrides this. Empty falls
   * back to the default Chckvet notes string.
   */
  custom_appointment_notes_template?: Maybe<Scalars['String']['output']>;
  /**
   * Structured overrides for widget/portal booking copy (step titles,
   * returning-client questions, confirmation text, blocklist alerts, etc.).
   * Non-empty widget copy wins over clinic; org is the last fallback.
   * Prefer this over the custom_*_description strings.
   */
  custom_booking_copy?: Maybe<ClinicBookingCopy>;
  /**
   * Clinic-defined email merge tags: JSON array of { template, value }
   * merged into template rendering. No dashboard UI.
   */
  custom_merge_tags?: Maybe<Scalars['JSON']['output']>;
  /**
   * PMS notes template used when a new client is created during booking.
   * Service.custom_new_client_notes_template overrides this.
   */
  custom_new_client_notes_template?: Maybe<Scalars['String']['output']>;
  /**
   * PMS notes template used when a new patient is created during booking.
   * Service.custom_new_patient_notes_template overrides this.
   */
  custom_new_patient_notes_template?: Maybe<Scalars['String']['output']>;
  /**
   * Legacy Other-category description for simple booking. Fallback if
   * custom_booking_copy.DEFAULT_OTHER_DESCRIPTION is unset.
   */
  custom_other_description?: Maybe<Scalars['String']['output']>;
  /**
   * Legacy Other-category title for simple booking. Fallback if
   * custom_booking_copy.DEFAULT_OTHER_TITLE is unset.
   */
  custom_other_title?: Maybe<Scalars['String']['output']>;
  /**
   * Overrides portal review-flow copy (method-page title, private-review
   * button, score/message labels, submit button). Supports appointment
   * merge variables on the method page.
   */
  custom_reviews_copy?: Maybe<ClinicReviewsCopy>;
  /**
   * Legacy sick-visit description for simple booking. Fallback if
   * custom_booking_copy.DEFAULT_SICK_DESCRIPTION is unset. Same cascade
   * as custom_well_description.
   */
  custom_sick_description?: Maybe<Scalars['String']['output']>;
  /**
   * Extra JSON properties merged into tracking events per booking-funnel
   * step. No dashboard control.
   */
  custom_tracking_properties?: Maybe<CustomTrackingProperties>;
  /**
   * Legacy wellness-visit description for simple (non-detailed) booking.
   * Fallback if custom_booking_copy.DEFAULT_WELLNESS_DESCRIPTION is unset.
   * Cascade: widget_options → clinic → org. No clinic-level dashboard
   * control (per-widget branding / custom_booking_copy instead).
   */
  custom_well_description?: Maybe<Scalars['String']['output']>;
  /**
   * Default service pre-selected when a client books from a reminder
   * notification link. Precedence: notification template default_service_id
   * → this clinic setting → none (normal service picker).
   */
  default_reminder_service_id?: Maybe<Scalars['ID']['output']>;
  /**
   * Case-insensitive substrings matched against client booking notes.
   * A hit marks the visit urgent, emails the clinic, and can show urgent
   * UI on the widget. Overridable per widget.
   */
  default_trigger_words?: Maybe<Array<Scalars['String']['output']>>;
  /**
   * When true, new clients must enter a complete street address to continue
   * booking. Enforced in the widget and rejected on server submit.
   */
  does_require_new_client_address?: Maybe<Scalars['Boolean']['output']>;
  /**
   * When true, new clients must enter a birthday to continue booking.
   * Enforced in the widget and on server submit.
   */
  does_require_new_client_birthday?: Maybe<Scalars['Boolean']['output']>;
  /**
   * Unused. Client title (Mr/Ms) is not required from this field during booking. No dashboard control.
   * @deprecated Unused. Not read by booking. Retained for backwards-compat only.
   */
  does_require_new_client_title?: Maybe<Scalars['Boolean']['output']>;
  /**
   * Unused. New-patient color is not required or collected from this field
   * during widget/portal booking. No dashboard control.
   * @deprecated Unused. Not read by booking. Retained for backwards-compat only.
   */
  does_require_patient_color?: Maybe<Scalars['Boolean']['output']>;
  /**
   * Unused. CPR/resuscitate is not required from this field during booking. No dashboard control.
   * @deprecated Unused. Not read by booking. Retained for backwards-compat only.
   */
  does_require_patient_resuscitate?: Maybe<Scalars['Boolean']['output']>;
  /**
   * Unused. Patient weight is not required from this field during booking. No dashboard control.
   * @deprecated Unused. Not read by booking. Retained for backwards-compat only.
   */
  does_require_patient_weight?: Maybe<Scalars['Boolean']['output']>;
  /**
   * Unused. Booking does not require a referring vet from this field.
   * Pulse new-client writes use clinic_settings.primary_referral_pms_id
   * (Covetrus referralOptionKey) — DB-only, not on this GraphQL type.
   * No dashboard control.
   * @deprecated Unused. Not read by booking. Pulse uses clinic_settings.primary_referral_pms_id (DB-only). Retained for backwards-compat only.
   */
  does_require_referral?: Maybe<Scalars['Boolean']['output']>;
  /**
   * When true, the widget inserts a phone/email verification step before
   * submit (defaults to required if unset). Does not replace
   * booking_match_procedure PatientSearchWithVerification, which is the
   * returning-client lookup path.
   */
  does_require_verification?: Maybe<Scalars['Boolean']['output']>;
  /**
   * When true, an approved online reschedule is applied immediately (new time
   * written, old slot released) without a staff confirm/deny step. When false,
   * staff must approve the reschedule request first. Clinic managers bypass
   * this. Distinct from service.is_reschedule_allowed, which gates whether
   * the client can request a reschedule at all.
   */
  does_use_automatic_reschedule?: Maybe<Scalars['Boolean']['output']>;
  /**
   * When true, online scheduling treats clinicians as bookable resources.
   * Time blocks still collide even in room-only clinics (e.g. AVImark
   * clinician block-offs). Pair with does_use_rooms_to_schedule.
   */
  does_use_clinicians_to_schedule?: Maybe<Scalars['Boolean']['output']>;
  /**
   * When true, online scheduling treats rooms as bookable resources
   * (collision detection and required room assignment). Pair with
   * does_use_clinicians_to_schedule: clinician, room, or both. Dashboard:
   * Booking → General → Booking entity. Distinct from is_using_rooms
   * (audience filters only).
   */
  does_use_rooms_to_schedule?: Maybe<Scalars['Boolean']['output']>;
  /** When true, inbox and auto-reply SMS skip the standard Chckvet message wrapper. Notification and bulk SMS always skip the wrapper. */
  exclude_message_wrapper?: Maybe<Scalars['Boolean']['output']>;
  /**
   * Facebook Pixel ID used when GTM is not set. No clinic-level dashboard
   * control; widget can override.
   */
  facebook_pixel_id?: Maybe<Scalars['String']['output']>;
  /**
   * Public Facebook review URL opened after a high rating on the portal review
   * page. Distinct from review_facebook_id, which syncs Facebook reviews into
   * the dashboard.
   */
  facebook_review_link?: Maybe<Scalars['String']['output']>;
  /**
   * Unused. Facebook Pixel event names are not overridden from this field. No dashboard control.
   * @deprecated Unused. Not read by tracking. Retained for backwards-compat only.
   */
  fb_event_name_overrides?: Maybe<GaEventNameOverrides>;
  /**
   * When true, completed client forms are written back into the PMS.
   * Clinic is emailed on failure if notify_clinic_on includes
   * FormWritebackFailure.
   */
  form_writeback_enabled: Scalars['Boolean']['output'];
  /**
   * Remaps gtag event names per booking-funnel step (WidgetOpened,
   * TimeSelectStep, Completion, etc.). No dashboard control.
   */
  ga_event_name_overrides?: Maybe<GaEventNameOverrides>;
  /**
   * GA4 measurement ID used when GTM is not set. No clinic-level dashboard
   * control; widget can override.
   */
  ga_measurement_id?: Maybe<Scalars['String']['output']>;
  /**
   * Public Google review URL opened after a high rating on the portal review
   * page. Distinct from review_google_id, which syncs existing Google reviews
   * into the dashboard Reviews list.
   */
  google_review_link?: Maybe<Scalars['String']['output']>;
  /**
   * Google Tag Manager container ID injected in portal/widget. Booking
   * funnel events push to dataLayer. Per-widget gtm id overrides this.
   */
  gtm_container_id?: Maybe<Scalars['String']['output']>;
  /**
   * When true, widget/portal hides the clinician picker and auto-assigns.
   * OR'd with service.hide_clinician_preference — either true triggers
   * auto-assign. Needs a selected clinician or primary_clinician_pms_id
   * when does_use_clinicians_to_schedule is true. Widget options can override.
   */
  hide_clinician_preference: Scalars['Boolean']['output'];
  /**
   * Unused. The Times-First calendar does not skip closed days from this
   * field.
   * @deprecated Unused. Not read by scheduling or the Times-First calendar. Retained for backwards-compat only.
   */
  hide_closed_days_from_scheduling?: Maybe<Scalars['Boolean']['output']>;
  /** When true, hide historic vaccinations on the portal vaccine list. */
  hide_historic_vaccinations?: Maybe<Scalars['Boolean']['output']>;
  /** When true, the portal patient-details page hides the prescriptions section. */
  hide_portal_prescriptions: Scalars['Boolean']['output'];
  /** When true, the portal patient-details page hides the reminders section. */
  hide_portal_reminders: Scalars['Boolean']['output'];
  /** When true, the portal patient-details page hides the vaccinations section. */
  hide_portal_vaccinations: Scalars['Boolean']['output'];
  /** When true, the portal hides patient weight on pet details. */
  hide_portal_weight: Scalars['Boolean']['output'];
  /**
   * When true, widget/portal skip the read-only Review step and book
   * straight from the last booking step. Client notes are collected on the
   * service step either way, so hiding Review never drops required input.
   */
  hide_review_step?: Maybe<Scalars['Boolean']['output']>;
  /**
   * When true, hide standard-of-care vaccinations on the portal vaccine
   * list. Distinct from hide_portal_vaccinations (hides the whole section).
   */
  hide_soc_vaccinations?: Maybe<Scalars['Boolean']['output']>;
  /** Row id. Used as the child id for entity-link field propagation across a clinic group. */
  id?: Maybe<Scalars['ID']['output']>;
  /**
   * Species this clinic treats online. Filters bookable services, open-slot
   * logic, and AI tool species lists. Empty/unset may allow all synced
   * clinic species depending on the call site.
   */
  included_species?: Maybe<Array<Species>>;
  /**
   * Loyalty points per invoice dollar when should_award_loyalty_for_invoices
   * is true. Invoice totals are stored in cents.
   */
  invoice_loyalty_points_per_dollar?: Maybe<Scalars['Float']['output']>;
  /**
   * When true, clients pick a specific synced service. When false, they pick
   * a Service Category (Wellness/Sick/Other tiles) and matching services are
   * filtered by service_service_categories. Distinct from per-service
   * configuration on the Services page. Does not use service.service_types.
   */
  is_using_detailed_services?: Maybe<Scalars['Boolean']['output']>;
  /**
   * Unused. Client and clinic notifications are not gated by this flag. No dashboard control.
   * @deprecated Unused. Not read by notification logic. Retained for backwards-compat only.
   */
  is_using_notifications?: Maybe<Scalars['Boolean']['output']>;
  /**
   * When true, Room is offered as a customer-segment filter dimension in the
   * dashboard audience builder. Does not enable room-based scheduling —
   * that is does_use_rooms_to_schedule. No booking-settings control.
   */
  is_using_rooms?: Maybe<Scalars['Boolean']['output']>;
  /** Hours between full/long cloud PMS syncs (Firebase cron; default 6). */
  long_sync_interval_hours: Scalars['NonNegativeInt']['output'];
  /**
   * Number of day columns on the Times-First (UrgentCare) calendar.
   * UI-only — does not change availability math. Ignored in GeneralPractice.
   */
  max_booking_columns?: Maybe<Scalars['NonNegativeInt']['output']>;
  /** Max characters allowed in client booking notes on the service step. */
  max_booking_notes_length?: Maybe<Scalars['NonNegativeInt']['output']>;
  /**
   * Portal chat and dashboard session auto-timeout in milliseconds.
   * -1 disables the timeout.
   */
  max_inactivity_duration?: Maybe<Scalars['Int']['output']>;
  /**
   * Unused. Multi-patient visit limits are not enforced from this field. No dashboard control.
   * @deprecated Unused. Not read by booking. Retained for backwards-compat only.
   */
  max_patients_per_visit?: Maybe<Scalars['NonNegativeInt']['output']>;
  /**
   * Private-review ratings at or below this value (typically 1–5, default 4)
   * email the clinic office_emails. Ratings above it skip the alert; the
   * review-method page steers those clients to google_review_link /
   * facebook_review_link instead.
   */
  max_review_rating_for_notif?: Maybe<Scalars['NonNegativeInt']['output']>;
  /**
   * Min characters required in client booking notes on the service step.
   * 0 means notes are optional.
   */
  min_booking_notes_length?: Maybe<Scalars['NonNegativeInt']['output']>;
  /**
   * Invoices with pims_created_at before this Unix-ms timestamp are ignored
   * for invoice loyalty awards. No dashboard control.
   */
  min_invoice_date_for_loyalty?: Maybe<Scalars['NonNegativeInt']['output']>;
  /**
   * When true, inbound client messages (and auto-replies) get an AI
   * estimated inbox priority.
   */
  msgs_auto_priority?: Maybe<Scalars['Boolean']['output']>;
  /**
   * Unused. Nearby-clinic prompt does not use a per-day slot threshold.
   * No dashboard control.
   * @deprecated Unused. Nearby-clinic prompt uses should_suggest_nearby_clinics. Retained for backwards-compat only.
   */
  nearby_clinic_min_day_slots?: Maybe<Scalars['NonNegativeInt']['output']>;
  /**
   * Unused. Nearby-clinic prompt uses should_suggest_nearby_clinics plus a
   * no-times condition; this threshold is never read. No dashboard control.
   * @deprecated Unused. Nearby-clinic prompt uses should_suggest_nearby_clinics. Retained for backwards-compat only.
   */
  nearby_clinic_min_total_slots?: Maybe<Scalars['NonNegativeInt']['output']>;
  /** Client email body when staff approves a ConfirmationRequired booking. */
  new_appt_approved_msg?: Maybe<Scalars['String']['output']>;
  /** Client SMS body when staff approves a ConfirmationRequired booking. */
  new_appt_approved_sms_msg?: Maybe<Scalars['String']['output']>;
  /** Client email body when staff denies a ConfirmationRequired booking. */
  new_appt_denied_msg?: Maybe<Scalars['String']['output']>;
  /**
   * Client email body when a booking is submitted under ConfirmationRequired
   * (appointment requested, not yet in the PMS). Unused for Instant entry.
   */
  new_appt_requested_msg?: Maybe<Scalars['String']['output']>;
  /**
   * Chckvet service IDs whose synced time-block / empty-slot appointments
   * do not collide with other bookings. Typically placeholder PMS appt
   * types. Edited from the service editor (Is non-blocking when empty),
   * stored here at clinic level.
   */
  non_blocking_services: Array<Scalars['ID']['output']>;
  /**
   * Legacy office-email fallback for practice alerts. Per-user prefs live
   * on User.notify_email_on; this list is used only when no clinic user
   * has configured those prefs yet.
   */
  notify_clinic_on?: Maybe<Array<NotifyClinicOn>>;
  /**
   * When true, resource availability comes from PMS adjusted-availability /
   * planning guides (synced pms_adjusted_availability) rather than base
   * hours. Clinic OR service.only_use_adj_avail_guides enables it. Skipped
   * for Cornerstone clinicians and official ezyVet API. Dashboard toggle
   * only shown for ezyVet, Shepherd, Cornerstone.
   */
  only_use_adj_avail_guides: Scalars['Boolean']['output'];
  /** Same as client_custom_required_fields, written onto new patients. */
  patient_custom_required_fields?: Maybe<Array<CustomBookingField>>;
  /**
   * Order of tabs on the portal patient-details page
   * (Reminders, Appointments, Prescriptions, Vaccines, MedicalHistory).
   * Tabs missing from this list are appended.
   */
  patient_details_tab_order: Array<PortalPatientDetailsTab>;
  /**
   * When true, completed Stripe payments are written back into the PMS.
   * After writeback, status_set_on_payment_completed_pms_id can update
   * the linked appointment status.
   */
  payment_writeback_enabled: Scalars['Boolean']['output'];
  /**
   * Voice/PBX provider for inbound call webhooks (MangoVoice, RingCentral,
   * Sinch, Bland, Retell). Distinct from ai_calls_provider (AI receptionist).
   * No dashboard control.
   */
  phone_provider?: Maybe<PhoneProviderType>;
  /**
   * PMS-specific field mappings for writeback (e.g. primary_phone_field,
   * default patient color on Realezv). Not shown in booking UI.
   * No dashboard control.
   */
  pims_custom_fields?: Maybe<PimsCustomFields>;
  /**
   * PMS day end as minutes since midnight in clinic timezone. Used by
   * Connect when editing clinic hours. Distinct from clinic_hours_display.
   */
  pms_end_time?: Maybe<Scalars['PositiveInt']['output']>;
  /**
   * PMS day start as minutes since midnight in clinic timezone. Used by
   * Connect when editing clinic hours. Distinct from clinic_hours_display
   * (client-facing text) and from Chckvet availability hours.
   */
  pms_start_time?: Maybe<Scalars['PositiveInt']['output']>;
  /** Extra {label, url} links shown in portal nav and home quick actions. */
  portal_links?: Maybe<Array<PortalLink>>;
  /**
   * Chckvet service used when booking a prescription pickup appointment
   * after a refill is approved.
   */
  prescription_pickup_service_id?: Maybe<Scalars['ID']['output']>;
  /**
   * Clinic group this location belongs to. Used for nearby-clinic
   * suggestions, AI sibling context, and entity-link field propagation
   * from the primary clinic. Empty means single-location behavior.
   * Distinct from organization.
   */
  primary_clinic_group_id?: Maybe<Scalars['String']['output']>;
  /**
   * PMS clinician id used when booking requires a clinician but the client
   * did not pick one (hide_clinician_preference, or no selection). Throws
   * if clinicians are required and this cannot be resolved.
   */
  primary_clinician_pms_id?: Maybe<Scalars['String']['output']>;
  /**
   * Primary brand hex for portal, widget theme, appointment emails, email
   * builder, postcards, and notification templates. Widget-level colors can
   * override for a specific embed.
   */
  primary_color?: Maybe<Scalars['String']['output']>;
  /**
   * PMS room id used when booking requires a room but none was selected.
   * Same fallback pattern as primary_clinician_pms_id. No dedicated
   * dashboard room picker (clinician has one).
   */
  primary_room_pms_id?: Maybe<Scalars['String']['output']>;
  /**
   * Audience whose members populate the referring-vet dropdown for official
   * ezyVet API clinics. Shepherd uses PMS entities instead.
   */
  referral_customer_segment?: Maybe<CustomerSegment>;
  /** Loyalty points awarded to a newly referred client when a referred appointment is created. */
  referred_loyalty_points?: Maybe<Scalars['Float']['output']>;
  /** Loyalty points awarded to the referring client when a referred appointment is created. */
  referrer_loyalty_points?: Maybe<Scalars['Float']['output']>;
  /**
   * Minutes since local midnight when the reminder cron sends daily
   * reminder batches (hour granularity; default 480 = 8:00 AM). Distinct
   * from notification template content and from should_sync_reminders.
   */
  reminder_send_time_minutes?: Maybe<Scalars['NonNegativeInt']['output']>;
  /**
   * Unused. Portal/widget/server cancel flows do not require a cancellation
   * reason from this field.
   * @deprecated Unused. Not read by cancellation logic. Retained for backwards-compat only.
   */
  require_reason_for_cancellation?: Maybe<Scalars['Boolean']['output']>;
  /**
   * Minimum minutes before the original start that a non-manager client may
   * request a new time. Independent of service.is_reschedule_allowed.
   * Clinic managers bypass the buffer.
   */
  reschedule_buffer_minutes?: Maybe<Scalars['NonNegativeInt']['output']>;
  /**
   * Unused. Chckvet does not charge a reschedule fee from this field.
   * No dashboard control.
   * @deprecated Unused. Not read by any product logic. Retained for backwards-compat only.
   */
  reschedule_fee?: Maybe<Scalars['NonNegativeInt']['output']>;
  /**
   * Unused. The live cutoff is reschedule_buffer_minutes (minutes before the
   * original start). This older field is never read. No dashboard control.
   * @deprecated Unused. Use reschedule_buffer_minutes. Retained for backwards-compat only.
   */
  reschedule_minutes_before?: Maybe<Scalars['NonNegativeInt']['output']>;
  /**
   * When true, an in-place reschedule resets the appointment PMS confirmation
   * status back to Booked (clears Confirmed). When false, the existing status
   * is kept.
   */
  reset_status_to_booked_on_reschedule?: Maybe<Scalars['Boolean']['output']>;
  /**
   * Facebook page ID used to sync Facebook reviews into the dashboard.
   * Distinct from facebook_review_link.
   */
  review_facebook_id?: Maybe<Scalars['String']['output']>;
  /**
   * Google Place ID used to sync Google reviews into the dashboard Reviews
   * list. Distinct from google_review_link (the public URL clients open).
   */
  review_google_id?: Maybe<Scalars['String']['output']>;
  /**
   * Unused. Review notification channels are not driven by this field. No dashboard control.
   * @deprecated Unused. Not read by any product logic. Retained for backwards-compat only.
   */
  review_message_methods?: Maybe<Array<MessageMethod>>;
  /**
   * Internal availability grid style. Optimized steps by
   * base_schedule_duration; Realistic and RealisticOptimized (default) use
   * a 30-minute grid. Distinct from time_slot_minutes (which start times
   * are offered). No dashboard control.
   */
  schedule_method?: Maybe<ScheduleMethod>;
  /**
   * Unused. No scheduling logic reads a clinic-level buffer from this field.
   * Cancel/reschedule cutoffs are cancellation_buffer_minutes and
   * reschedule_buffer_minutes.
   * @deprecated Unused. Not read by scheduling. Retained for backwards-compat only.
   */
  scheduling_buffer_minutes?: Maybe<Scalars['NonNegativeInt']['output']>;
  /**
   * Furthest a client can book, in minutes from now (default ~30 days /
   * 43800 if unset). Cascade: service scheduling_max_minutes_away → widget
   * booking_avail_end → this clinic default.
   */
  scheduling_max_minutes_away?: Maybe<Scalars['NonNegativeInt']['output']>;
  /**
   * Soonest a client can book, in minutes from now. Cascade: service
   * scheduling_min_minutes_away → widget booking_avail_start → this clinic
   * default. Widget/service can only tighten the window.
   */
  scheduling_min_minutes_away?: Maybe<Scalars['NonNegativeInt']['output']>;
  /**
   * Postcard {{secondary_color}} fallback when accent_color is unset.
   * No dashboard control — prefer accent_color.
   */
  secondary_color?: Maybe<Scalars['String']['output']>;
  /**
   * Unused. Confirmation audience is not driven by this field. No dashboard control.
   * @deprecated Unused. Not read by notification logic. Retained for backwards-compat only.
   */
  send_confirmations_to: SendConfirmationsTo;
  /**
   * Unused. New-appointment emails are not gated by this flag.
   * @deprecated Unused. Not read by notification logic. Retained for backwards-compat only.
   */
  send_new_appt_email?: Maybe<Scalars['Boolean']['output']>;
  /**
   * Unused. Review emails always go to clinic office_emails. No dashboard control.
   * @deprecated Unused. Not read by any product logic. Retained for backwards-compat only.
   */
  send_reviews_to?: Maybe<SendConfirmationsTo>;
  /**
   * Unused. Not read by Connect or server sync logic. No dashboard control.
   * @deprecated Unused. Not read by Connect or server sync logic. Retained for backwards-compat only.
   */
  server_syncing_only?: Maybe<Scalars['Boolean']['output']>;
  /**
   * When false, the widget/portal blocks the new-client path and tells the
   * visitor to call. Distinct from should_create_clients (whether a new
   * client is written to the PMS when the path is allowed). Overridable
   * per widget.
   */
  should_allow_new_clients?: Maybe<Scalars['Boolean']['output']>;
  /**
   * When false, the widget/portal blocks the new-patient path. Distinct
   * from should_create_patients. Overridable per widget.
   */
  should_allow_new_patients?: Maybe<Scalars['Boolean']['output']>;
  /**
   * When true, inbound messages auto-assign a patient via AI
   * (getMostLikelyPatientForMessage) if the client has a PMS id. Inbox
   * only — not used in the booking flow.
   */
  should_automatically_assign_patient?: Maybe<Scalars['Boolean']['output']>;
  /**
   * When true, fully paid synced invoices award loyalty points:
   * (invoice total / 100) * invoice_loyalty_points_per_dollar, only if
   * pims_created_at is after min_invoice_date_for_loyalty. Requires clinic
   * loyalty to be enabled.
   */
  should_award_loyalty_for_invoices?: Maybe<Scalars['Boolean']['output']>;
  /**
   * When true, Stripe processing fees are passed through to the client on
   * prescription payments. No dedicated dashboard toggle (API/entity-link).
   */
  should_charge_client_stripe_fees?: Maybe<Scalars['Boolean']['output']>;
  /**
   * Signal for Connect to run a full PMS sync. Connect sets this back to
   * false when the sync finishes. Not the same as sync_interval_minutes
   * (incremental cron cadence). No dashboard control.
   */
  should_complete_sync?: Maybe<Scalars['Boolean']['output']>;
  /**
   * When true, unmatched new clients created during booking are written into
   * the PMS (cloud + Instant). When false with booking_match_procedure Legacy
   * and entry not ManualEntry, creates a temp client plus a staff action item
   * instead. Distinct from should_allow_new_clients (whether the widget
   * offers a new-client path at all).
   */
  should_create_clients?: Maybe<Scalars['Boolean']['output']>;
  /**
   * When true, unmatched new patients created during booking are written into
   * the PMS. Same Legacy/temp-record behavior as should_create_clients.
   * Distinct from should_allow_new_patients.
   */
  should_create_patients?: Maybe<Scalars['Boolean']['output']>;
  /**
   * Default Chckvet marketing-email opt-in for clients with no saved
   * preference. Same first-insert / missing-row behavior as
   * should_default_marketing_sms_on.
   */
  should_default_marketing_email_on: Scalars['Boolean']['output'];
  /**
   * Default Chckvet marketing-SMS opt-in for clients with no saved
   * preference (no client_settings row). Written onto the row on first
   * insert when the caller omits is_unsubscribed_from_marketing_sms.
   * Changing this later does not rewrite existing stored flags.
   */
  should_default_marketing_sms_on: Scalars['Boolean']['output'];
  /**
   * Default PIMS email-opt-in written onto newly created clients (Shepherd,
   * Instinct, ezyVet). Affects PMS notification flags, not Chckvet marketing
   * prefs.
   */
  should_default_pims_emails_on: Scalars['Boolean']['output'];
  /**
   * Default PIMS SMS-opt-in written onto newly created clients. Same PMS
   * notification-flag behavior as should_default_pims_emails_on.
   */
  should_default_pims_sms_on: Scalars['Boolean']['output'];
  /**
   * Master kill switch: widget/portal will not offer online scheduling.
   * Does not block staff-side or Connect-created appointments.
   */
  should_disable_online_scheduling?: Maybe<Scalars['Boolean']['output']>;
  /**
   * Gap-fill: if a candidate start hits a conflict but the open stretch
   * before that conflict is still long enough for the appointment, offer
   * a slot anchored at the last non-conflicting start. No dashboard control.
   */
  should_fit_last_conflict: Scalars['Boolean']['output'];
  /**
   * When true, Daily Huddle hides revenue/earnings for every user in the
   * clinic. Individual clinic admins can also hide huddle financials on
   * their own ClinicAdmin row.
   */
  should_hide_daily_huddle_financials: Scalars['Boolean']['output'];
  /**
   * When true and a booking search finds no times, widget/portal/AI may
   * offer sibling clinics in primary_clinic_group_id. Does not auto-switch
   * the booking. Overridable per widget. Requires a group id.
   */
  should_suggest_nearby_clinics?: Maybe<Scalars['Boolean']['output']>;
  /**
   * When true, PMS reminder records are included in cloud sync. PMS-DB
   * clinics use pims_settings.should_sync_reminders instead. Distinct from
   * Chckvet reminder notification templates.
   */
  should_sync_reminders?: Maybe<Scalars['Boolean']['output']>;
  /**
   * When true, refill-type prescription requests auto-approve and can book
   * pickup without a staff confirm step. Pickup uses
   * prescription_pickup_service_id.
   */
  should_use_instant_prescription_requests?: Maybe<Scalars['Boolean']['output']>;
  /**
   * When true, slot generation intersects Chckvet hours with live PMS
   * availability (Cornerstone, AVImark, Impromed Infinity, official ezyVet).
   * When false, uses synced data + Chckvet hours/adj avail only. No
   * dashboard control.
   */
  should_use_pms_availability?: Maybe<Scalars['Boolean']['output']>;
  /**
   * When true, the portal review page offers an internal Chckvet review
   * (/review/{slug}/private) alongside Google/Facebook buttons. When false
   * and no public links are set, the review page errors.
   */
  should_use_private_reviews?: Maybe<Scalars['Boolean']['output']>;
  /**
   * When true, the dashboard Scheduling Rules page uses the simplified
   * rule editor instead of the advanced one. Super-admin gated. Changes
   * editing UX; availability still comes from the saved rules themselves.
   */
  simple_scheduling_rules_enabled: Scalars['Boolean']['output'];
  /**
   * Phone numbers that must never send or receive SMS for this clinic.
   * Checked on inbound Twilio webhooks and manageable from chat (Block
   * Number). No dedicated settings page.
   */
  sms_block_list?: Maybe<Array<Scalars['String']['output']>>;
  /**
   * PMS appointment-status id set on the linked appointment after a
   * successful payment writeback (deposits). Requires
   * payment_writeback_enabled.
   */
  status_set_on_payment_completed_pms_id?: Maybe<Scalars['String']['output']>;
  /**
   * Minutes between incremental cloud PMS syncs (Firebase cron; default 10).
   * Distinct from long_sync_interval_hours (full sync) and
   * should_complete_sync (one-shot full-sync flag). PMS-DB clinics use
   * pims_settings.sync_interval_minutes instead.
   */
  sync_interval_minutes: Scalars['NonNegativeInt']['output'];
  /**
   * Unused. Monthly revenue is not read from this field. No dashboard control.
   * @deprecated Unused. Not read by any product logic. Retained for backwards-compat only.
   */
  this_month_revenue?: Maybe<Scalars['Float']['output']>;
  /**
   * Grid granularity in minutes for which start times are offered (and for
   * clean-start validation). Precedence: service DB time_slot_minutes →
   * widget_options → this clinic value → default 5. Separate from
   * service.duration (appointment length) and from
   * valid_booking_interval_minutes (allowed minute-of-hour offsets).
   */
  time_slot_minutes: Scalars['NonNegativeInt']['output'];
  /**
   * Per-control visibility of Times-First (UrgentCare) booking filters
   * (service, clinician, species, client/patient status, gender, fixed
   * status). Each control is Auto, Show, or Hidden. Null config = all Auto.
   * Ignored when urgency_type is GeneralPractice. Widget can override.
   */
  times_first_filter_config?: Maybe<TimesFirstFilterConfig>;
  /**
   * When true, a conversation whose client has waited
   * unreplied_message_alert_minutes without a direct reply from a clinic
   * user is set to HighPriority, and the UnrepliedMessage alert is sent
   * to office emails (notify_clinic_on) and opted-in users. Auto-replies,
   * notifications, bulk sends, and internal notes do not count as replies.
   */
  unreplied_message_alert_enabled: Scalars['Boolean']['output'];
  /**
   * Minutes a client message may wait for a clinic user reply before the
   * unreplied-message alert fires. Must be at least 1; checked every 5
   * minutes.
   */
  unreplied_message_alert_minutes: Scalars['NonNegativeInt']['output'];
  /**
   * Times-First booking when UrgentCare: clients pick a time before name/pet.
   * GeneralPractice is client/service then time. Scheduling rules still apply.
   * Times-First filter visibility is times_first_filter_config.
   */
  urgency_type?: Maybe<UrgencyType>;
  /**
   * Per-entity monthly spending caps (JSON keyed by BillableUsageEntity).
   * Hitting a cap blocks that billable action and can email a warning.
   */
  usage_spending_caps?: Maybe<Scalars['JSON']['output']>;
  /**
   * When true, offer fixed-interval starts (startMinute % time_slot_minutes
   * === 0) instead of only conflict-aware gap-fit starts. Collisions, PMS
   * availability, adj-avail guides, and valid_booking_interval_minutes
   * still apply.
   */
  use_basic_timeslots: Scalars['Boolean']['output'];
  /**
   * Allowed minute-of-hour start offsets, e.g. [0, 30] for :00 and :30
   * only. Empty/null means no restriction at clinic level. Clinic, then
   * room/clinician, then service lists must all pass (AND). Distinct from
   * time_slot_minutes (grid step).
   */
  valid_booking_interval_minutes?: Maybe<Array<Scalars['NonNegativeInt']['output']>>;
  /**
   * Audience used as the clinic waitlist. Dashboard client drawer Add to
   * waitlist / Remove from waitlist writes included_clients on this
   * segment. Daily huddle waitlist counts read it too. Not auto-assigned
   * from the public booking flow. Seeded and assigned on clinic create.
   */
  waitlist_customer_segment?: Maybe<CustomerSegment>;
  /**
   * Outbound signed POST endpoints fired on clinic events (see
   * WebhookEventType). Each row has url, secret, enabled, and event list.
   */
  webhooks?: Maybe<Array<WebhookConfig>>;
  /**
   * PMS custom-field key used to read/write patient weight (Pulse, ezyVet).
   * Not collected on the booking form. No dashboard control.
   */
  weight_key_pms_id?: Maybe<Scalars['String']['output']>;
  /**
   * Clinic-level widget chrome (header/footer colors, floating-widget
   * margins). Cascade: widget entity styles → widget_options → clinic → org.
   * Distinct from primary_color/accent_color (Chakra theme).
   */
  widget_styles?: Maybe<WidgetStyles>;
  /**
   * Unused cache. Pulse may still write it, but Daily Huddle revenue is
   * computed live. No dashboard control.
   * @deprecated Unused. Pulse still writes this cache, but huddle revenue is computed live. Retained for backwards-compat only.
   */
  yesterday_revenue?: Maybe<Scalars['Float']['output']>;
};

/**
 * One member clinic's current values for a set of governed clinic settings
 * fields.
 */
export type ClinicSettingsFieldValues = {
  __typename?: 'ClinicSettingsFieldValues';
  clinic_id: Scalars['ID']['output'];
  /**
   * Field name → the clinic's current value. Null when unset, or for every
   * field when the clinic has no settings row.
   */
  values: Scalars['JSON']['output'];
};

/**
 * Write payload for clinic settings. Field meanings match ClinicSettings
 * (read that type's introspection descriptions). Deprecated fields are
 * stored but unused — changing them has no effect on product logic.
 */
export type ClinicSettingsInput = {
  accent_color?: InputMaybe<Scalars['String']['input']>;
  ai_agent_custom_instructions?: InputMaybe<Scalars['String']['input']>;
  ai_agent_style?: InputMaybe<Scalars['String']['input']>;
  ai_calls_agent_id?: InputMaybe<Scalars['String']['input']>;
  ai_calls_ambient_sound?: InputMaybe<AiCallsAmbientSound>;
  ai_calls_cooldown_minutes?: InputMaybe<Scalars['Int']['input']>;
  ai_calls_enable_dynamic_voice_speed?: InputMaybe<Scalars['Boolean']['input']>;
  ai_calls_interruption_sensitivity?: InputMaybe<Scalars['Float']['input']>;
  ai_calls_outbound_agent_id?: InputMaybe<Scalars['String']['input']>;
  ai_calls_phone_number?: InputMaybe<Scalars['String']['input']>;
  ai_calls_provider?: InputMaybe<PhoneProviderType>;
  ai_calls_voice_id?: InputMaybe<Scalars['String']['input']>;
  ai_calls_voice_speed?: InputMaybe<Scalars['Float']['input']>;
  allow_confirmation_days_before?: InputMaybe<Scalars['Int']['input']>;
  allow_first_appt_per_day?: InputMaybe<Scalars['Boolean']['input']>;
  app_download_loyalty_points?: InputMaybe<Scalars['Float']['input']>;
  appointment_custom_required_fields?: InputMaybe<Array<CustomBookingFieldInput>>;
  appointment_entry_method?: InputMaybe<AppointmentEntryMethod>;
  auto_refund_on_cancel?: InputMaybe<Scalars['Boolean']['input']>;
  auto_reply_enabled?: InputMaybe<Scalars['Boolean']['input']>;
  auto_reply_hours?: InputMaybe<AvailabilityHoursInput>;
  auto_reply_message?: InputMaybe<Scalars['String']['input']>;
  base_schedule_duration?: InputMaybe<Scalars['NonNegativeInt']['input']>;
  blocklist_customer_segment?: InputMaybe<Scalars['ID']['input']>;
  booking_match_procedure?: InputMaybe<BookingMatchProcedure>;
  cancellation_buffer_minutes?: InputMaybe<Scalars['NonNegativeInt']['input']>;
  cancellation_clinician_pms_id?: InputMaybe<Scalars['String']['input']>;
  cancellation_service_pms_id?: InputMaybe<Scalars['String']['input']>;
  chckvet_prescription_fee_split_percentage?: InputMaybe<Scalars['Float']['input']>;
  client_custom_required_fields?: InputMaybe<Array<CustomBookingFieldInput>>;
  clinic_hours_display?: InputMaybe<Scalars['String']['input']>;
  comms_should_daily_writeback?: InputMaybe<Scalars['Boolean']['input']>;
  comms_should_use_ai_writeback?: InputMaybe<Scalars['Boolean']['input']>;
  comms_should_writeback_notifs?: InputMaybe<Scalars['Boolean']['input']>;
  comms_should_writeback_on_receive?: InputMaybe<Scalars['Boolean']['input']>;
  comms_should_writeback_on_send?: InputMaybe<Scalars['Boolean']['input']>;
  comms_use_pdf_for_writeback?: InputMaybe<Scalars['Boolean']['input']>;
  comms_writeback_before_appt_mins?: InputMaybe<Scalars['Int']['input']>;
  comms_writeback_buffer_minutes?: InputMaybe<Scalars['Int']['input']>;
  comms_writeback_enabled?: InputMaybe<Scalars['Boolean']['input']>;
  compliance_statuses?: InputMaybe<Array<Scalars['String']['input']>>;
  confirmation_days_before?: InputMaybe<Scalars['NonNegativeInt']['input']>;
  custom_appointment_notes_template?: InputMaybe<Scalars['String']['input']>;
  custom_booking_copy?: InputMaybe<ClinicBookingCopyInput>;
  custom_merge_tags?: InputMaybe<Scalars['JSON']['input']>;
  custom_new_client_notes_template?: InputMaybe<Scalars['String']['input']>;
  custom_new_patient_notes_template?: InputMaybe<Scalars['String']['input']>;
  custom_other_description?: InputMaybe<Scalars['String']['input']>;
  custom_other_title?: InputMaybe<Scalars['String']['input']>;
  custom_reviews_copy?: InputMaybe<ClinicReviewsCopyInput>;
  custom_sick_description?: InputMaybe<Scalars['String']['input']>;
  custom_tracking_properties?: InputMaybe<CustomTrackingPropertiesInput>;
  custom_well_description?: InputMaybe<Scalars['String']['input']>;
  default_reminder_service_id?: InputMaybe<Scalars['ID']['input']>;
  default_trigger_words?: InputMaybe<Array<Scalars['String']['input']>>;
  does_require_new_client_address?: InputMaybe<Scalars['Boolean']['input']>;
  does_require_new_client_birthday?: InputMaybe<Scalars['Boolean']['input']>;
  does_require_new_client_title?: InputMaybe<Scalars['Boolean']['input']>;
  does_require_patient_color?: InputMaybe<Scalars['Boolean']['input']>;
  does_require_patient_resuscitate?: InputMaybe<Scalars['Boolean']['input']>;
  does_require_patient_weight?: InputMaybe<Scalars['Boolean']['input']>;
  does_require_referral?: InputMaybe<Scalars['Boolean']['input']>;
  does_require_verification?: InputMaybe<Scalars['Boolean']['input']>;
  does_use_automatic_reschedule?: InputMaybe<Scalars['Boolean']['input']>;
  does_use_clinicians_to_schedule?: InputMaybe<Scalars['Boolean']['input']>;
  does_use_rooms_to_schedule?: InputMaybe<Scalars['Boolean']['input']>;
  exclude_message_wrapper?: InputMaybe<Scalars['Boolean']['input']>;
  facebook_pixel_id?: InputMaybe<Scalars['String']['input']>;
  facebook_review_link?: InputMaybe<Scalars['String']['input']>;
  fb_event_name_overrides?: InputMaybe<GaEventNameOverridesInput>;
  form_writeback_enabled?: InputMaybe<Scalars['Boolean']['input']>;
  ga_event_name_overrides?: InputMaybe<GaEventNameOverridesInput>;
  ga_measurement_id?: InputMaybe<Scalars['String']['input']>;
  google_review_link?: InputMaybe<Scalars['String']['input']>;
  gtm_container_id?: InputMaybe<Scalars['String']['input']>;
  hide_clinician_preference?: InputMaybe<Scalars['Boolean']['input']>;
  hide_closed_days_from_scheduling?: InputMaybe<Scalars['Boolean']['input']>;
  hide_historic_vaccinations?: InputMaybe<Scalars['Boolean']['input']>;
  hide_portal_prescriptions?: InputMaybe<Scalars['Boolean']['input']>;
  hide_portal_reminders?: InputMaybe<Scalars['Boolean']['input']>;
  hide_portal_vaccinations?: InputMaybe<Scalars['Boolean']['input']>;
  hide_portal_weight?: InputMaybe<Scalars['Boolean']['input']>;
  hide_review_step?: InputMaybe<Scalars['Boolean']['input']>;
  hide_soc_vaccinations?: InputMaybe<Scalars['Boolean']['input']>;
  included_species?: InputMaybe<Array<Species>>;
  invoice_loyalty_points_per_dollar?: InputMaybe<Scalars['Float']['input']>;
  is_using_detailed_services?: InputMaybe<Scalars['Boolean']['input']>;
  is_using_notifications?: InputMaybe<Scalars['Boolean']['input']>;
  is_using_rooms?: InputMaybe<Scalars['Boolean']['input']>;
  long_sync_interval_hours?: InputMaybe<Scalars['NonNegativeInt']['input']>;
  max_booking_columns?: InputMaybe<Scalars['NonNegativeInt']['input']>;
  max_booking_notes_length?: InputMaybe<Scalars['NonNegativeInt']['input']>;
  max_inactivity_duration?: InputMaybe<Scalars['Int']['input']>;
  max_patients_per_visit?: InputMaybe<Scalars['NonNegativeInt']['input']>;
  max_review_rating_for_notif?: InputMaybe<Scalars['NonNegativeInt']['input']>;
  messaging_service_sid?: InputMaybe<Scalars['String']['input']>;
  min_booking_notes_length?: InputMaybe<Scalars['NonNegativeInt']['input']>;
  min_invoice_date_for_loyalty?: InputMaybe<Scalars['NonNegativeInt']['input']>;
  msgs_auto_priority?: InputMaybe<Scalars['Boolean']['input']>;
  nearby_clinic_min_day_slots?: InputMaybe<Scalars['NonNegativeInt']['input']>;
  nearby_clinic_min_total_slots?: InputMaybe<Scalars['NonNegativeInt']['input']>;
  new_appt_approved_msg?: InputMaybe<Scalars['String']['input']>;
  new_appt_approved_sms_msg?: InputMaybe<Scalars['String']['input']>;
  new_appt_denied_msg?: InputMaybe<Scalars['String']['input']>;
  new_appt_requested_msg?: InputMaybe<Scalars['String']['input']>;
  non_blocking_services?: InputMaybe<Array<Scalars['ID']['input']>>;
  notify_clinic_on?: InputMaybe<Array<NotifyClinicOn>>;
  only_use_adj_avail_guides?: InputMaybe<Scalars['Boolean']['input']>;
  patient_custom_required_fields?: InputMaybe<Array<CustomBookingFieldInput>>;
  patient_details_tab_order?: InputMaybe<Array<PortalPatientDetailsTab>>;
  payment_writeback_enabled?: InputMaybe<Scalars['Boolean']['input']>;
  phone_provider?: InputMaybe<PhoneProviderType>;
  pims_custom_fields?: InputMaybe<PimsCustomFieldsInput>;
  pms_end_time?: InputMaybe<Scalars['PositiveInt']['input']>;
  pms_start_time?: InputMaybe<Scalars['PositiveInt']['input']>;
  portal_links?: InputMaybe<Array<PortalLinkInput>>;
  prescription_pickup_service_id?: InputMaybe<Scalars['ID']['input']>;
  primary_clinic_group_id?: InputMaybe<Scalars['String']['input']>;
  primary_clinician_pms_id?: InputMaybe<Scalars['String']['input']>;
  primary_color?: InputMaybe<Scalars['String']['input']>;
  primary_room_pms_id?: InputMaybe<Scalars['String']['input']>;
  referral_customer_segment?: InputMaybe<Scalars['ID']['input']>;
  referred_loyalty_points?: InputMaybe<Scalars['Float']['input']>;
  referrer_loyalty_points?: InputMaybe<Scalars['Float']['input']>;
  reminder_send_time_minutes?: InputMaybe<Scalars['NonNegativeInt']['input']>;
  require_reason_for_cancellation?: InputMaybe<Scalars['Boolean']['input']>;
  reschedule_buffer_minutes?: InputMaybe<Scalars['NonNegativeInt']['input']>;
  reset_status_to_booked_on_reschedule?: InputMaybe<Scalars['Boolean']['input']>;
  review_facebook_id?: InputMaybe<Scalars['String']['input']>;
  review_google_id?: InputMaybe<Scalars['String']['input']>;
  schedule_method?: InputMaybe<ScheduleMethod>;
  scheduling_buffer_minutes?: InputMaybe<Scalars['NonNegativeInt']['input']>;
  scheduling_max_minutes_away?: InputMaybe<Scalars['NonNegativeInt']['input']>;
  scheduling_min_minutes_away?: InputMaybe<Scalars['NonNegativeInt']['input']>;
  /** Postcard secondary color fallback when accent_color is unset. */
  secondary_color?: InputMaybe<Scalars['String']['input']>;
  send_confirmations_to?: InputMaybe<SendConfirmationsTo>;
  send_new_appt_email?: InputMaybe<Scalars['Boolean']['input']>;
  send_reviews_to?: InputMaybe<SendConfirmationsTo>;
  server_syncing_only?: InputMaybe<Scalars['Boolean']['input']>;
  shepherd_reminders_one_to_one?: InputMaybe<Scalars['Boolean']['input']>;
  should_allow_new_clients?: InputMaybe<Scalars['Boolean']['input']>;
  should_allow_new_patients?: InputMaybe<Scalars['Boolean']['input']>;
  should_automatically_assign_patient?: InputMaybe<Scalars['Boolean']['input']>;
  should_award_loyalty_for_invoices?: InputMaybe<Scalars['Boolean']['input']>;
  should_charge_client_stripe_fees?: InputMaybe<Scalars['Boolean']['input']>;
  should_complete_sync?: InputMaybe<Scalars['Boolean']['input']>;
  should_create_clients?: InputMaybe<Scalars['Boolean']['input']>;
  should_create_new_clients?: InputMaybe<Scalars['Boolean']['input']>;
  should_create_new_patients?: InputMaybe<Scalars['Boolean']['input']>;
  should_create_patients?: InputMaybe<Scalars['Boolean']['input']>;
  should_default_marketing_email_on?: InputMaybe<Scalars['Boolean']['input']>;
  should_default_marketing_sms_on?: InputMaybe<Scalars['Boolean']['input']>;
  should_default_pims_emails_on?: InputMaybe<Scalars['Boolean']['input']>;
  should_default_pims_sms_on?: InputMaybe<Scalars['Boolean']['input']>;
  should_disable_online_scheduling?: InputMaybe<Scalars['Boolean']['input']>;
  should_fit_last_conflict?: InputMaybe<Scalars['Boolean']['input']>;
  should_hide_daily_huddle_financials?: InputMaybe<Scalars['Boolean']['input']>;
  should_suggest_nearby_clinics?: InputMaybe<Scalars['Boolean']['input']>;
  should_sync_reminders?: InputMaybe<Scalars['Boolean']['input']>;
  should_use_instant_prescription_requests?: InputMaybe<Scalars['Boolean']['input']>;
  should_use_pms_availability?: InputMaybe<Scalars['Boolean']['input']>;
  should_use_private_reviews?: InputMaybe<Scalars['Boolean']['input']>;
  simple_scheduling_rules_enabled?: InputMaybe<Scalars['Boolean']['input']>;
  sms_block_list?: InputMaybe<Array<Scalars['String']['input']>>;
  status_set_on_payment_completed_pms_id?: InputMaybe<Scalars['String']['input']>;
  sync_interval_minutes?: InputMaybe<Scalars['NonNegativeInt']['input']>;
  this_month_revenue?: InputMaybe<Scalars['Float']['input']>;
  time_slot_minutes?: InputMaybe<Scalars['NonNegativeInt']['input']>;
  times_first_filter_config?: InputMaybe<TimesFirstFilterConfigInput>;
  twilio_account_sid_override?: InputMaybe<Scalars['String']['input']>;
  twilio_api_key_override?: InputMaybe<Scalars['String']['input']>;
  unreplied_message_alert_enabled?: InputMaybe<Scalars['Boolean']['input']>;
  unreplied_message_alert_minutes?: InputMaybe<Scalars['NonNegativeInt']['input']>;
  urgency_type?: InputMaybe<UrgencyType>;
  usage_spending_caps?: InputMaybe<Scalars['JSON']['input']>;
  use_basic_timeslots?: InputMaybe<Scalars['Boolean']['input']>;
  valid_booking_interval_minutes?: InputMaybe<Array<Scalars['NonNegativeInt']['input']>>;
  waitlist_customer_segment?: InputMaybe<Scalars['ID']['input']>;
  webhooks?: InputMaybe<Array<WebhookConfigInput>>;
  weight_key_pms_id?: InputMaybe<Scalars['String']['input']>;
  widget_styles?: InputMaybe<WidgetStylesInput>;
  yesterday_revenue?: InputMaybe<Scalars['Float']['input']>;
};

export type ClinicSex = {
  __typename?: 'ClinicSex';
  animal_gender?: Maybe<AnimalGender>;
  clinic?: Maybe<Clinic>;
  created_at: Scalars['Timestamp']['output'];
  description?: Maybe<Scalars['String']['output']>;
  entity_key: Scalars['String']['output'];
  fixed_statuses: Array<FixedStatus>;
  id: Scalars['ID']['output'];
  included_species: Array<Species>;
  is_active: Scalars['Boolean']['output'];
  name: Scalars['String']['output'];
  pms_id: Scalars['String']['output'];
  sync_error?: Maybe<Scalars['String']['output']>;
  updated_at: Scalars['Timestamp']['output'];
};

export type ClinicSpecies = {
  __typename?: 'ClinicSpecies';
  clinic?: Maybe<Clinic>;
  created_at: Scalars['Timestamp']['output'];
  description: Scalars['String']['output'];
  id: Scalars['ID']['output'];
  is_primary: Scalars['Boolean']['output'];
  pms?: Maybe<PracticeManagementSystem>;
  pms_id: Scalars['String']['output'];
  species: Species;
  updated_at: Scalars['Timestamp']['output'];
  weight_key: Scalars['String']['output'];
};

export type ClinicStats = {
  __typename?: 'ClinicStats';
  booked_appointments: Scalars['NonNegativeInt']['output'];
  cancelled_appointments: Scalars['NonNegativeInt']['output'];
  completed_appointments: Scalars['NonNegativeInt']['output'];
  confirmed_appointments: Scalars['NonNegativeInt']['output'];
  created_at: Scalars['Timestamp']['output'];
  denied_appointments: Scalars['NonNegativeInt']['output'];
  expired_appointments: Scalars['NonNegativeInt']['output'];
  id: Scalars['ID']['output'];
  pending_appointments: Scalars['NonNegativeInt']['output'];
  total_appointments: Scalars['NonNegativeInt']['output'];
  total_website_appointments: Scalars['NonNegativeInt']['output'];
  total_widget_appointments: Scalars['NonNegativeInt']['output'];
  updated_at: Scalars['Timestamp']['output'];
};

/**
 * Typed view of the readable `clinics.tmp_feature_flags` keys. Not taken by
 * any mutation: `updateClinic.tmp_feature_flags` stays `JSON` so the
 * dashboard can keep merging unknown keys. Proposed changes coerce against
 * this input so a flag patch is schema-validated, then merge it onto the
 * stored blob. Keep in sync with `ClinicModel.tmp_feature_flags`.
 * Deliberately omitted: unused flags, `cornerstone_template_days_map`
 * (free-form map), and `statement_descriptor_prefix_override` (Stripe).
 */
export type ClinicTmpFeatureFlagsInput = {
  ai_suggestions_enabled?: InputMaybe<Scalars['Boolean']['input']>;
  ask_chckvet_enabled?: InputMaybe<Scalars['Boolean']['input']>;
  auto_assign_most_available_clinician?: InputMaybe<Scalars['Boolean']['input']>;
  bitwerx_write_medical_notes_as_public?: InputMaybe<Scalars['Boolean']['input']>;
  booking_link_prefill_disabled?: InputMaybe<Scalars['Boolean']['input']>;
  client_names_to_search_for_pulse_patients?: InputMaybe<Array<Scalars['String']['input']>>;
  disable_ai_writeback_summary?: InputMaybe<Scalars['Boolean']['input']>;
  disable_duplicate_booking_popup?: InputMaybe<Scalars['Boolean']['input']>;
  disable_post_appointment_messages?: InputMaybe<Scalars['Boolean']['input']>;
  disable_sms_appointment_confirmation?: InputMaybe<Scalars['Boolean']['input']>;
  enforce_synced_availability?: InputMaybe<Scalars['Boolean']['input']>;
  fetch_pms_db_appointments_for_ezyvet?: InputMaybe<Scalars['Boolean']['input']>;
  form_writeback_line_item_code_enabled?: InputMaybe<Scalars['Boolean']['input']>;
  get_pims_availability_by_provider?: InputMaybe<Scalars['Boolean']['input']>;
  health_check_notes?: InputMaybe<Scalars['String']['input']>;
  hide_timezone_display?: InputMaybe<Scalars['Boolean']['input']>;
  ignore_pms_availability_for_clinician_ids?: InputMaybe<Array<Scalars['ID']['input']>>;
  ignore_pms_comms_settings?: InputMaybe<Scalars['Boolean']['input']>;
  ignore_provider_conflicts?: InputMaybe<Scalars['Boolean']['input']>;
  ignore_sms_character_limit?: InputMaybe<Scalars['Boolean']['input']>;
  log_scheduling_timing?: InputMaybe<Scalars['Boolean']['input']>;
  ondemand_buffer_time?: InputMaybe<Scalars['NonNegativeInt']['input']>;
  ondemand_chunk_days?: InputMaybe<Scalars['NonNegativeInt']['input']>;
  ondemand_sync_months?: InputMaybe<Scalars['NonNegativeInt']['input']>;
  only_sync_preferred_contact_methods?: InputMaybe<Scalars['Boolean']['input']>;
  only_use_this_location?: InputMaybe<Scalars['Boolean']['input']>;
  /** One of PHONE_WRITEBACK_FORMATS, e.g. 999-999-9999. */
  phone_writeback_format?: InputMaybe<Scalars['String']['input']>;
  pms_availability_cache_minutes?: InputMaybe<Scalars['NonNegativeInt']['input']>;
  postcard_back_max_services?: InputMaybe<Scalars['NonNegativeInt']['input']>;
  postcard_front_max_services?: InputMaybe<Scalars['NonNegativeInt']['input']>;
  postcards_enabled?: InputMaybe<Scalars['Boolean']['input']>;
  prevent_pending_appointment_expiration?: InputMaybe<Scalars['Boolean']['input']>;
  require_appointment_for_returning_clients?: InputMaybe<Scalars['Boolean']['input']>;
  should_use_primary_clinic_group_for_booking?: InputMaybe<Scalars['Boolean']['input']>;
  show_google_book_online_button?: InputMaybe<Scalars['Boolean']['input']>;
  show_room_preference?: InputMaybe<Scalars['Boolean']['input']>;
  skip_services_for_urgent?: InputMaybe<Scalars['Boolean']['input']>;
  skip_synced_appointment_conflicts?: InputMaybe<Scalars['Boolean']['input']>;
  skip_trackable_urls?: InputMaybe<Scalars['Boolean']['input']>;
  strip_country_code_for_phone_writeback?: InputMaybe<Scalars['Boolean']['input']>;
  treat_closed_invoices_as_paid?: InputMaybe<Scalars['Boolean']['input']>;
  use_complex_segment_grouping?: InputMaybe<Scalars['Boolean']['input']>;
  use_five_minute_ezyvet_availability?: InputMaybe<Scalars['Boolean']['input']>;
  use_legacy_ezyvet_write?: InputMaybe<Scalars['Boolean']['input']>;
  use_new_ezyvet_reminder_sync?: InputMaybe<Scalars['Boolean']['input']>;
  use_new_pulse_reminder_type_sync?: InputMaybe<Scalars['Boolean']['input']>;
  use_precise_hourly_notif?: InputMaybe<Scalars['Boolean']['input']>;
  writeback_distrust_auto_full_household_tags?: InputMaybe<Scalars['Boolean']['input']>;
  writeback_forms_as_soap?: InputMaybe<Scalars['Boolean']['input']>;
  zero_out_case_owner?: InputMaybe<Scalars['Boolean']['input']>;
};

export type ClinicUsageStats = {
  __typename?: 'ClinicUsageStats';
  appointment_counts: UsageCounts;
  clinic: Clinic;
  concerns?: Maybe<Array<Scalars['String']['output']>>;
  last_sync_times?: Maybe<LastSyncTimes>;
  message_counts: UsageCounts;
  pms_db_last_sync_times?: Maybe<LastSyncTimes>;
};

export type Clinician = {
  __typename?: 'Clinician';
  adjusted_availability?: Maybe<Array<Availability>>;
  authority_level?: Maybe<AuthorityLevel>;
  avatar_url?: Maybe<Scalars['String']['output']>;
  bio?: Maybe<Scalars['String']['output']>;
  clinic?: Maybe<Clinic>;
  clinician_services?: Maybe<Array<ClinicianService>>;
  created_at: Scalars['Timestamp']['output'];
  display_name?: Maybe<Scalars['String']['output']>;
  does_contribute_to_fill_rate?: Maybe<Scalars['Boolean']['output']>;
  excluded_service_ids?: Maybe<Array<Scalars['ID']['output']>>;
  excluded_species?: Maybe<Array<Species>>;
  hours?: Maybe<AvailabilityHours>;
  id: Scalars['ID']['output'];
  initials?: Maybe<Scalars['String']['output']>;
  is_active?: Maybe<Scalars['Boolean']['output']>;
  is_assignable_in_pms?: Maybe<Scalars['Boolean']['output']>;
  location?: Maybe<Scalars['String']['output']>;
  metadata?: Maybe<Scalars['JSON']['output']>;
  name: Scalars['String']['output'];
  pms?: Maybe<PracticeManagementSystem>;
  pms_adjusted_availability?: Maybe<Array<Availability>>;
  pms_db?: Maybe<PmsDb>;
  pms_id?: Maybe<Scalars['String']['output']>;
  pms_is_active: Scalars['Boolean']['output'];
  role?: Maybe<Scalars['String']['output']>;
  stagger_offset_minutes?: Maybe<Scalars['NonNegativeInt']['output']>;
  type: ResourceType;
  updated_at: Scalars['Timestamp']['output'];
  valid_booking_interval_minutes?: Maybe<Array<Scalars['NonNegativeInt']['output']>>;
};

export type ClinicianService = {
  __typename?: 'ClinicianService';
  clinic: Clinic;
  clinician: Clinician;
  created_at: Scalars['Timestamp']['output'];
  duration_override?: Maybe<Scalars['NonNegativeInt']['output']>;
  id: Scalars['ID']['output'];
  is_active: Scalars['Boolean']['output'];
  service: Service;
  updated_at: Scalars['Timestamp']['output'];
};

export type ClinicsScheduleEfficiency = {
  __typename?: 'ClinicsScheduleEfficiency';
  clinic: Clinic;
  schedule_efficiency: Scalars['Float']['output'];
};

export type ComplianceReminderResult = {
  __typename?: 'ComplianceReminderResult';
  chat?: Maybe<Chat>;
  client: Client;
  reminders: Array<PatientReminder>;
};

export type ComplianceReminderResults = {
  __typename?: 'ComplianceReminderResults';
  count: Scalars['NonNegativeInt']['output'];
  results: Array<ComplianceReminderResult>;
};

/**
 * One row of the Compliance Tracker outreach activity report: how many
 * times a user assigned a compliance status on a day (YYYY-MM-DD in the
 * clinic's timezone). user is null for system-made changes.
 */
export type ComplianceStatusActivityRow = {
  __typename?: 'ComplianceStatusActivityRow';
  compliance_status: Scalars['String']['output'];
  count: Scalars['NonNegativeInt']['output'];
  day: Scalars['String']['output'];
  first_name?: Maybe<Scalars['String']['output']>;
  last_name?: Maybe<Scalars['String']['output']>;
  user?: Maybe<Scalars['ID']['output']>;
};

export type ComputeInitiativeValuesParams = {
  scope: TrendReportScope;
  scope_units?: InputMaybe<Scalars['NonNegativeInt']['input']>;
};

export type ComputeKpiGroupValuesOptions = {
  fromDate?: InputMaybe<Scalars['NonNegativeInt']['input']>;
  shouldUsePerDay?: InputMaybe<Scalars['Boolean']['input']>;
  toDate?: InputMaybe<Scalars['NonNegativeInt']['input']>;
};

export type ComputeReportTemplateValuesOptions = {
  entity_structure?: InputMaybe<Array<Scalars['String']['input']>>;
  fromDate?: InputMaybe<Scalars['NonNegativeInt']['input']>;
  toDate?: InputMaybe<Scalars['NonNegativeInt']['input']>;
};

export type ConnectInstallation = {
  __typename?: 'ConnectInstallation';
  clinic: Clinic;
  computer_name?: Maybe<Scalars['String']['output']>;
  computer_uuid?: Maybe<Scalars['String']['output']>;
  connect_server_version?: Maybe<Scalars['String']['output']>;
  connect_ui_version?: Maybe<Scalars['String']['output']>;
  created_at: Scalars['Timestamp']['output'];
  id: Scalars['ID']['output'];
  is_chckup_connected_to_pms?: Maybe<Scalars['Boolean']['output']>;
  is_pms_active?: Maybe<Scalars['Boolean']['output']>;
  is_server?: Maybe<Scalars['Boolean']['output']>;
  is_update_service_active?: Maybe<Scalars['Boolean']['output']>;
  last_ping?: Maybe<Scalars['NonNegativeInt']['output']>;
  updated_at: Scalars['Timestamp']['output'];
  version?: Maybe<Scalars['String']['output']>;
};

/**
 * Input for converting a PDF to form elements.
 * The PDF should be provided as a base64 encoded string.
 */
export type ConvertPdfToFormInput = {
  /** The PDF file content encoded as a base64 string. */
  pdfBase64: Scalars['String']['input'];
};

/** Result of converting a PDF to form elements. */
export type ConvertPdfToFormResult = {
  __typename?: 'ConvertPdfToFormResult';
  /** The converted form elements. Empty if conversion failed. */
  elements: Array<FormElement>;
  /** Error message if conversion failed. */
  error?: Maybe<Scalars['String']['output']>;
  /** Whether the conversion was successful. */
  success: Scalars['Boolean']['output'];
};

export type CopyNotificationTemplateAcrossClinicOptions = {
  copy_client_segment: Scalars['Boolean']['input'];
  copy_in_preview_mode: Scalars['Boolean']['input'];
};

export type CreateActionItemInput = {
  assignee?: InputMaybe<Scalars['ID']['input']>;
  chat?: InputMaybe<Scalars['ID']['input']>;
  client_form?: InputMaybe<Scalars['ID']['input']>;
  clinic: Scalars['ID']['input'];
  description?: InputMaybe<Scalars['String']['input']>;
  originating_call?: InputMaybe<Scalars['ID']['input']>;
  pending_appointment?: InputMaybe<Scalars['ID']['input']>;
  pet_selfie?: InputMaybe<Scalars['ID']['input']>;
  prescription?: InputMaybe<Scalars['ID']['input']>;
  prescription_refill_request?: InputMaybe<Scalars['ID']['input']>;
  reschedule?: InputMaybe<Scalars['ID']['input']>;
  status?: InputMaybe<ActionItemStatus>;
  type: ActionItemType;
};

export type CreateAnimalInput = {
  image?: InputMaybe<Scalars['String']['input']>;
  name?: InputMaybe<Scalars['String']['input']>;
};

export type CreateAppointmentInput = {
  acquisition_source?: InputMaybe<AcquisitionSourceInput>;
  appt_type_pms_id?: InputMaybe<Scalars['String']['input']>;
  booking_source?: InputMaybe<BookingSource>;
  bulk_message?: InputMaybe<Scalars['String']['input']>;
  checksum?: InputMaybe<Scalars['String']['input']>;
  click_id?: InputMaybe<Scalars['String']['input']>;
  client?: InputMaybe<Scalars['ID']['input']>;
  client_info?: InputMaybe<ClientInfoInput>;
  client_notes?: InputMaybe<Scalars['String']['input']>;
  client_pms_id?: InputMaybe<Scalars['String']['input']>;
  client_reason_for_cancellation?: InputMaybe<Scalars['String']['input']>;
  clinic: Scalars['ID']['input'];
  clinic_appt_status?: InputMaybe<Scalars['ID']['input']>;
  clinic_notes?: InputMaybe<Scalars['String']['input']>;
  clinician?: InputMaybe<Scalars['ID']['input']>;
  clinician_pms_id?: InputMaybe<Scalars['String']['input']>;
  confirmed_at?: InputMaybe<Scalars['NonNegativeInt']['input']>;
  drop_off_time?: InputMaybe<Scalars['NonNegativeInt']['input']>;
  from_widget?: InputMaybe<Scalars['String']['input']>;
  index_of_opening?: InputMaybe<Scalars['NonNegativeInt']['input']>;
  is_clinician_auto_assigned?: InputMaybe<Scalars['Boolean']['input']>;
  is_deleted?: InputMaybe<Scalars['Boolean']['input']>;
  is_new_client?: InputMaybe<Scalars['Boolean']['input']>;
  is_new_patient?: InputMaybe<Scalars['Boolean']['input']>;
  is_time_block?: InputMaybe<Scalars['Boolean']['input']>;
  minutes: Scalars['NonNegativeInt']['input'];
  new_client_name?: InputMaybe<Scalars['String']['input']>;
  new_client_phone?: InputMaybe<Scalars['String']['input']>;
  new_patient_name?: InputMaybe<Scalars['String']['input']>;
  new_patient_species?: InputMaybe<Scalars['String']['input']>;
  notif_template?: InputMaybe<Scalars['String']['input']>;
  origin?: InputMaybe<EntityOrigin>;
  patient?: InputMaybe<Scalars['ID']['input']>;
  patient_info?: InputMaybe<PatientInfoInput>;
  patient_pms_id?: InputMaybe<Scalars['String']['input']>;
  patients_pms_ids?: InputMaybe<Array<Scalars['String']['input']>>;
  payment?: InputMaybe<Scalars['ID']['input']>;
  pms?: InputMaybe<PracticeManagementSystem>;
  pms_created_at?: InputMaybe<Scalars['NonNegativeInt']['input']>;
  pms_db?: InputMaybe<Scalars['ID']['input']>;
  pms_id?: InputMaybe<Scalars['String']['input']>;
  reason_for_cancellation?: InputMaybe<Scalars['String']['input']>;
  referring_clinic_name?: InputMaybe<Scalars['String']['input']>;
  room?: InputMaybe<Scalars['ID']['input']>;
  service?: InputMaybe<Scalars['ID']['input']>;
  service_name?: InputMaybe<Scalars['String']['input']>;
  start_time: Scalars['NonNegativeInt']['input'];
  status?: InputMaybe<AppointmentStatus>;
  stripe_payment_intent_id?: InputMaybe<Scalars['String']['input']>;
  time_of_day?: InputMaybe<TimeOfDay>;
  widget?: InputMaybe<Scalars['ID']['input']>;
  widget_source?: InputMaybe<Scalars['String']['input']>;
};

export type CreateAppointmentPromptInput = {
  client?: InputMaybe<Scalars['ID']['input']>;
  client_notes?: InputMaybe<Scalars['String']['input']>;
  clinic: Scalars['ID']['input'];
  clinic_notes?: InputMaybe<Scalars['String']['input']>;
  clinician?: InputMaybe<Scalars['ID']['input']>;
  confirmed_at?: InputMaybe<Scalars['NonNegativeInt']['input']>;
  created_appointment?: InputMaybe<Scalars['ID']['input']>;
  minutes?: InputMaybe<Scalars['NonNegativeInt']['input']>;
  patient?: InputMaybe<Scalars['ID']['input']>;
  reason_for_denial?: InputMaybe<Scalars['String']['input']>;
  service?: InputMaybe<Scalars['ID']['input']>;
  service_name?: InputMaybe<Scalars['String']['input']>;
  start_time?: InputMaybe<Scalars['NonNegativeInt']['input']>;
  type: AppointmentPromptType;
};

export type CreateAttachmentInput = {
  filename: Scalars['String']['input'];
  type: AttachmentType;
  url: Scalars['String']['input'];
};

export type CreateAvailabilitiesInput = {
  date?: InputMaybe<Scalars['NonNegativeInt']['input']>;
  end: Scalars['NonNegativeInt']['input'];
  is_for_booking: Scalars['Boolean']['input'];
  repeat_days_of_month?: InputMaybe<Array<Scalars['NonNegativeInt']['input']>>;
  repeat_days_of_week?: InputMaybe<Array<AvailabilityDay>>;
  repeat_end_date?: InputMaybe<Scalars['NonNegativeInt']['input']>;
  repeat_frequency?: InputMaybe<Scalars['NonNegativeInt']['input']>;
  repeat_unit?: InputMaybe<RepeatUnit>;
  repeat_week_of_month?: InputMaybe<WeekOfMonth>;
  routine_days?: InputMaybe<Array<AvailabilityDay>>;
  start: Scalars['NonNegativeInt']['input'];
  type: AvailabilityType;
  valid_to?: InputMaybe<Scalars['NonNegativeInt']['input']>;
};

export type CreateBreedInput = {
  clinic?: InputMaybe<Scalars['ID']['input']>;
  description: Scalars['String']['input'];
  pms_id: Scalars['String']['input'];
  species?: InputMaybe<Species>;
};

export type CreateCampaignInput = {
  clinic?: InputMaybe<Scalars['ID']['input']>;
  clinic_group?: InputMaybe<Scalars['ID']['input']>;
  color?: InputMaybe<Scalars['String']['input']>;
  description?: InputMaybe<Scalars['String']['input']>;
  end_time?: InputMaybe<Scalars['NonNegativeInt']['input']>;
  featured_stats?: InputMaybe<Array<Scalars['String']['input']>>;
  is_active?: InputMaybe<Scalars['Boolean']['input']>;
  name: Scalars['String']['input'];
  notification_featured_stats?: InputMaybe<Array<Scalars['String']['input']>>;
  scheduled_bulk_message_featured_stats?: InputMaybe<Array<Scalars['String']['input']>>;
  start_time?: InputMaybe<Scalars['NonNegativeInt']['input']>;
  widget_featured_stats?: InputMaybe<Array<Scalars['String']['input']>>;
};

export type CreateChatInput = {
  client: Scalars['ID']['input'];
  clinic: Scalars['ID']['input'];
  is_hidden?: InputMaybe<Scalars['Boolean']['input']>;
  title?: InputMaybe<Scalars['String']['input']>;
};

export type CreateChatStatusInput = {
  clinic?: InputMaybe<Scalars['ID']['input']>;
  clinic_group?: InputMaybe<Scalars['ID']['input']>;
  color?: InputMaybe<Scalars['String']['input']>;
  name: Scalars['String']['input'];
  sort_order?: InputMaybe<Scalars['Int']['input']>;
};

export type CreateChatWithNonClientInput = {
  clinic: Scalars['ID']['input'];
  email?: InputMaybe<Scalars['String']['input']>;
  first_name: Scalars['String']['input'];
  last_name: Scalars['String']['input'];
  phone: Scalars['String']['input'];
};

export type CreateCheckInInput = {
  clinic: Scalars['ID']['input'];
  user: Scalars['ID']['input'];
  vehicle?: InputMaybe<Scalars['String']['input']>;
  visit_reason?: InputMaybe<VisitReason>;
};

export type CreateClientFormInput = {
  appointment?: InputMaybe<Scalars['ID']['input']>;
  client?: InputMaybe<Scalars['ID']['input']>;
  client_completed_at?: InputMaybe<Scalars['NonNegativeInt']['input']>;
  form: Scalars['ID']['input'];
  form_data?: InputMaybe<FormFieldsInput>;
  lookup_email?: InputMaybe<Scalars['String']['input']>;
  /**
   * Name of the patient the submitter entered. Used to disambiguate which
   * patient to assign when an on-demand PIMS lookup returns multiple patients
   * for the client (Bitwerx-backed clinics only).
   */
  lookup_patient_name?: InputMaybe<Scalars['String']['input']>;
  /**
   * Identifying info used to look the submitter up live in the PIMS when no
   * client/patient is linked yet (Bitwerx-backed clinics only). Lets us pull
   * the client/patient in on-demand and assign them, instead of waiting for
   * the nightly sync.
   */
  lookup_phone?: InputMaybe<Scalars['String']['input']>;
  notify_clinic?: InputMaybe<Scalars['Boolean']['input']>;
  patient?: InputMaybe<Scalars['ID']['input']>;
};

export type CreateClientInput = {
  address?: InputMaybe<AddressInput>;
  balance?: InputMaybe<Scalars['Float']['input']>;
  checksum?: InputMaybe<Scalars['String']['input']>;
  clinic?: InputMaybe<Scalars['ID']['input']>;
  email?: InputMaybe<Scalars['String']['input']>;
  email_enabled?: InputMaybe<Scalars['Boolean']['input']>;
  first_name?: InputMaybe<Scalars['String']['input']>;
  is_lead?: InputMaybe<Scalars['Boolean']['input']>;
  is_unsubscribed?: InputMaybe<Scalars['Boolean']['input']>;
  last_appointment?: InputMaybe<Scalars['ID']['input']>;
  last_appt_time?: InputMaybe<Scalars['NonNegativeInt']['input']>;
  last_contact_time?: InputMaybe<Scalars['NonNegativeInt']['input']>;
  last_name?: InputMaybe<Scalars['String']['input']>;
  next_appointment?: InputMaybe<Scalars['ID']['input']>;
  next_appt_time?: InputMaybe<Scalars['NonNegativeInt']['input']>;
  origin?: InputMaybe<EntityOrigin>;
  phone?: InputMaybe<Scalars['String']['input']>;
  pms?: InputMaybe<PracticeManagementSystem>;
  pms_created_at?: InputMaybe<Scalars['NonNegativeInt']['input']>;
  pms_id?: InputMaybe<Scalars['String']['input']>;
  sms_enabled?: InputMaybe<Scalars['Boolean']['input']>;
  status?: InputMaybe<Scalars['ID']['input']>;
  title?: InputMaybe<Scalars['String']['input']>;
  users?: InputMaybe<Array<Scalars['ID']['input']>>;
};

export type CreateClinicAdminInput = {
  admin_permissions?: InputMaybe<AdminPermissionsInput>;
  allow_approving_controlled_substances?: InputMaybe<Scalars['Boolean']['input']>;
  clinic: Scalars['ID']['input'];
  custom_role?: InputMaybe<Scalars['ID']['input']>;
  permissions?: InputMaybe<Array<ClinicAdminPermissionInput>>;
  role: AuthRoles;
  user: Scalars['ID']['input'];
};

export type CreateClinicGroupClinicInput = {
  clinicGroupId: Scalars['ID']['input'];
  clinicId: Scalars['ID']['input'];
};

export type CreateClinicGroupInput = {
  clinic_group_clinics?: InputMaybe<Array<Scalars['ID']['input']>>;
  name: Scalars['String']['input'];
  parent_clinic_group?: InputMaybe<Scalars['ID']['input']>;
};

export type CreateClinicGroupUserInput = {
  admin_permissions?: InputMaybe<AdminPermissionsInput>;
  clinic_group: Scalars['ID']['input'];
  custom_role?: InputMaybe<Scalars['ID']['input']>;
  permissions?: InputMaybe<Array<ClinicAdminPermissionInput>>;
  role: AuthRoles;
  user: Scalars['ID']['input'];
};

export type CreateClinicInput = {
  address?: InputMaybe<AddressInput>;
  adjusted_availability?: InputMaybe<Array<AvailabilityInput>>;
  avatar_url?: InputMaybe<Scalars['String']['input']>;
  description?: InputMaybe<Scalars['String']['input']>;
  email?: InputMaybe<Scalars['String']['input']>;
  features?: InputMaybe<ClinicFeaturesInput>;
  hours?: InputMaybe<AvailabilityHoursInput>;
  is_archived?: InputMaybe<Scalars['Boolean']['input']>;
  is_featured?: InputMaybe<Scalars['Boolean']['input']>;
  is_verified?: InputMaybe<Scalars['Boolean']['input']>;
  last_sync_times?: InputMaybe<LastSyncTimesInput>;
  location?: InputMaybe<Scalars['String']['input']>;
  name?: InputMaybe<Scalars['String']['input']>;
  offers_emergency_care?: InputMaybe<Scalars['Boolean']['input']>;
  office_emails?: InputMaybe<Array<Scalars['String']['input']>>;
  onboarding?: InputMaybe<ClinicOnboardingInput>;
  organization?: InputMaybe<Scalars['ID']['input']>;
  phone?: InputMaybe<Scalars['String']['input']>;
  pms: PracticeManagementSystem;
  pms_additional_key?: InputMaybe<Scalars['String']['input']>;
  pms_api_key?: InputMaybe<Scalars['String']['input']>;
  pms_api_subdomain?: InputMaybe<Scalars['String']['input']>;
  /** Defaults to the PIMS's usual connector when omitted. */
  pms_connector?: InputMaybe<PmsConnector>;
  pms_db?: InputMaybe<Scalars['ID']['input']>;
  pms_version?: InputMaybe<Scalars['String']['input']>;
  reply_to_email?: InputMaybe<Scalars['String']['input']>;
  send_from_email?: InputMaybe<Scalars['String']['input']>;
  send_from_phone?: InputMaybe<Scalars['String']['input']>;
  settings?: InputMaybe<ClinicSettingsInput>;
  slug?: InputMaybe<Scalars['String']['input']>;
  stripe_account_type?: InputMaybe<Scalars['String']['input']>;
  stripe_accounts_enabled?: InputMaybe<Array<StripeAccountType>>;
  stripe_customer_id?: InputMaybe<Scalars['String']['input']>;
  time_zone?: InputMaybe<Scalars['String']['input']>;
  website?: InputMaybe<Scalars['String']['input']>;
};

export type CreateClinicStatsInput = {
  booked_appointments?: InputMaybe<Scalars['NonNegativeInt']['input']>;
  cancelled_appointments?: InputMaybe<Scalars['NonNegativeInt']['input']>;
  completed_appointments?: InputMaybe<Scalars['NonNegativeInt']['input']>;
  confirmed_appointments?: InputMaybe<Scalars['NonNegativeInt']['input']>;
  denied_appointments?: InputMaybe<Scalars['NonNegativeInt']['input']>;
  expired_appointments?: InputMaybe<Scalars['NonNegativeInt']['input']>;
  pending_appointments?: InputMaybe<Scalars['NonNegativeInt']['input']>;
  total_appointments?: InputMaybe<Scalars['NonNegativeInt']['input']>;
  total_website_appointments?: InputMaybe<Scalars['NonNegativeInt']['input']>;
  total_widget_appointments?: InputMaybe<Scalars['NonNegativeInt']['input']>;
};

export type CreateClinicianInput = {
  adjusted_availability?: InputMaybe<Array<AvailabilityInput>>;
  authority_level?: InputMaybe<AuthorityLevel>;
  avatar_url?: InputMaybe<Scalars['String']['input']>;
  bio?: InputMaybe<Scalars['String']['input']>;
  clinic: Scalars['ID']['input'];
  display_name?: InputMaybe<Scalars['String']['input']>;
  does_contribute_to_fill_rate?: InputMaybe<Scalars['Boolean']['input']>;
  excluded_service_ids?: InputMaybe<Array<Scalars['ID']['input']>>;
  excluded_species?: InputMaybe<Array<Species>>;
  hours?: InputMaybe<AvailabilityHoursInput>;
  initials?: InputMaybe<Scalars['String']['input']>;
  is_active?: InputMaybe<Scalars['Boolean']['input']>;
  is_assignable_in_pms?: InputMaybe<Scalars['Boolean']['input']>;
  metadata?: InputMaybe<Scalars['JSON']['input']>;
  name: Scalars['String']['input'];
  pms?: InputMaybe<PracticeManagementSystem>;
  pms_adjusted_availability?: InputMaybe<Array<AvailabilityInput>>;
  pms_id?: InputMaybe<Scalars['String']['input']>;
  role?: InputMaybe<Scalars['String']['input']>;
  stagger_offset_minutes?: InputMaybe<Scalars['NonNegativeInt']['input']>;
  type?: InputMaybe<ResourceType>;
  valid_booking_interval_minutes?: InputMaybe<Array<Scalars['NonNegativeInt']['input']>>;
};

export type CreateClinicianServiceInput = {
  clinic: Scalars['ID']['input'];
  clinician: Scalars['ID']['input'];
  duration_override?: InputMaybe<Scalars['NonNegativeInt']['input']>;
  is_active?: InputMaybe<Scalars['Boolean']['input']>;
  service: Scalars['ID']['input'];
};

export type CreateConnectInstallationInput = {
  clinic: Scalars['ID']['input'];
  computer_name?: InputMaybe<Scalars['String']['input']>;
  computer_uuid?: InputMaybe<Scalars['String']['input']>;
  connect_server_version?: InputMaybe<Scalars['String']['input']>;
  connect_ui_version?: InputMaybe<Scalars['String']['input']>;
  is_chckup_connected_to_pms?: InputMaybe<Scalars['Boolean']['input']>;
  is_pms_active?: InputMaybe<Scalars['Boolean']['input']>;
  is_server?: InputMaybe<Scalars['Boolean']['input']>;
  is_update_service_active?: InputMaybe<Scalars['Boolean']['input']>;
  last_ping?: InputMaybe<Scalars['NonNegativeInt']['input']>;
  version?: InputMaybe<Scalars['String']['input']>;
};

export type CreateCustomRoleInput = {
  /** New boolean shape, written to the admin_permissions table. */
  admin_permissions?: InputMaybe<AdminPermissionsInput>;
  clinic?: InputMaybe<Scalars['ID']['input']>;
  clinic_group?: InputMaybe<Scalars['ID']['input']>;
  description?: InputMaybe<Scalars['String']['input']>;
  is_default?: InputMaybe<Scalars['Boolean']['input']>;
  name: Scalars['String']['input'];
  /** Legacy input shape. Prefer admin_permissions instead. */
  permissions?: InputMaybe<Array<ClinicAdminPermissionInput>>;
};

export type CreateCustomerSegmentInput = {
  all_inclusions?: InputMaybe<Array<SegmentFilterInput>>;
  any_exclusions?: InputMaybe<Array<SegmentFilterInput>>;
  any_inclusions?: InputMaybe<Array<SegmentFilterInput>>;
  any_other_exclusions?: InputMaybe<Array<SegmentFilterInput>>;
  /** Owner: exactly one of clinic / clinic_group must be set */
  clinic?: InputMaybe<Scalars['ID']['input']>;
  /** Group-owned audiences waterfall to linked clinics (see entity_links) */
  clinic_group?: InputMaybe<Scalars['ID']['input']>;
  default_exclusions_options?: InputMaybe<DefaultExclusionsOptionsInput>;
  error_flags?: InputMaybe<Array<CustomerSegmentErrorFlagInput>>;
  excluded_clients?: InputMaybe<Array<Scalars['ID']['input']>>;
  excluded_filters: Array<CustomerSegmentFilterInput>;
  filters: Array<CustomerSegmentFilterInput>;
  group_days_ahead?: InputMaybe<Scalars['NonNegativeInt']['input']>;
  included_clients?: InputMaybe<Array<Scalars['ID']['input']>>;
  is_archived?: InputMaybe<Scalars['Boolean']['input']>;
  is_hourly?: InputMaybe<Scalars['Boolean']['input']>;
  name: Scalars['String']['input'];
  other_result_exclusion_entity?: InputMaybe<Scalars['String']['input']>;
  prevent_grouping_within_segment?: InputMaybe<Scalars['Boolean']['input']>;
  reference_date_params?: InputMaybe<ReferenceDateParamsInput>;
  should_include_all_overdue?: InputMaybe<Scalars['Boolean']['input']>;
  trigger_entity?: InputMaybe<CustomerSegmentTrigger>;
};

export type CreateDailyHuddleInput = {
  attendees?: InputMaybe<Array<Scalars['ID']['input']>>;
  end_time?: InputMaybe<Scalars['NonNegativeInt']['input']>;
  leader?: InputMaybe<Scalars['ID']['input']>;
  notes?: InputMaybe<Scalars['String']['input']>;
  start_time: Scalars['NonNegativeInt']['input'];
};

export type CreateDataChatInput = {
  clinic: Scalars['ID']['input'];
  name?: InputMaybe<Scalars['String']['input']>;
};

export type CreateDiagnosisInput = {
  clinic: Scalars['ID']['input'];
  description?: InputMaybe<Scalars['String']['input']>;
  name: Scalars['String']['input'];
  pms_id: Scalars['String']['input'];
};

export type CreateEntityReportInput = {
  clinic?: InputMaybe<Scalars['ID']['input']>;
  clinician?: InputMaybe<Scalars['ID']['input']>;
  entity_type: ReportEntityType;
  organization_report: Scalars['ID']['input'];
  parent_report?: InputMaybe<Scalars['ID']['input']>;
  product?: InputMaybe<Scalars['ID']['input']>;
  service?: InputMaybe<Scalars['ID']['input']>;
  values: Array<CreateReportValueInput>;
};

export type CreateFamilyInput = {
  name?: InputMaybe<Scalars['String']['input']>;
};

export type CreateFollowUpSettingsInput = {
  days_until_next_appt?: InputMaybe<Scalars['NonNegativeInt']['input']>;
  parent?: InputMaybe<Scalars['ID']['input']>;
  step_number?: InputMaybe<Scalars['NonNegativeInt']['input']>;
};

export type CreateFormInput = {
  /** Owner: exactly one of clinic / clinic_group must be set */
  clinic?: InputMaybe<Scalars['ID']['input']>;
  /** Group-owned forms waterfall to linked clinics (see entity_links) */
  clinic_group?: InputMaybe<Scalars['ID']['input']>;
  does_require_client?: InputMaybe<Scalars['Boolean']['input']>;
  does_require_patient?: InputMaybe<Scalars['Boolean']['input']>;
  form_fields: FormFieldsInput;
  form_file_naming_template?: InputMaybe<Scalars['String']['input']>;
  form_type: FormType;
  is_active?: InputMaybe<Scalars['Boolean']['input']>;
  is_public?: InputMaybe<Scalars['Boolean']['input']>;
  is_using_pdf?: InputMaybe<Scalars['Boolean']['input']>;
  is_writeback_enabled?: InputMaybe<Scalars['Boolean']['input']>;
  name?: InputMaybe<Scalars['String']['input']>;
  pdf_schema?: InputMaybe<Scalars['JSON']['input']>;
  pdf_url?: InputMaybe<Scalars['String']['input']>;
  writeback_code_name?: InputMaybe<Scalars['String']['input']>;
  writeback_code_pms_id?: InputMaybe<Scalars['String']['input']>;
  writeback_to_strictest_entity?: InputMaybe<Scalars['Boolean']['input']>;
};

export type CreateGoalInput = {
  description?: InputMaybe<Scalars['String']['input']>;
  is_active?: InputMaybe<Scalars['Boolean']['input']>;
  is_chckup_modifier?: InputMaybe<Scalars['Boolean']['input']>;
  is_new_modifier?: InputMaybe<Scalars['Boolean']['input']>;
  is_system?: InputMaybe<Scalars['Boolean']['input']>;
  metric_entity: GoalEntity;
  metric_target_amount: Scalars['NonNegativeInt']['input'];
  metric_timespan: GoalTimespan;
};

export type CreateInitiativeInput = {
  clinic?: InputMaybe<Scalars['ID']['input']>;
  clinic_group?: InputMaybe<Scalars['ID']['input']>;
  description?: InputMaybe<Scalars['String']['input']>;
  is_archived?: InputMaybe<Scalars['Boolean']['input']>;
  name: Scalars['String']['input'];
  organization?: InputMaybe<Scalars['ID']['input']>;
  report_metrics?: InputMaybe<Array<Scalars['ID']['input']>>;
  start_time: Scalars['NonNegativeInt']['input'];
};

export type CreateInitiativeMetricInput = {
  initiative: Scalars['ID']['input'];
  order?: InputMaybe<Scalars['Int']['input']>;
  report_metric: Scalars['ID']['input'];
};

export type CreateInternalChatInput = {
  clinic?: InputMaybe<Scalars['ID']['input']>;
  clinicGroup?: InputMaybe<Scalars['ID']['input']>;
  title?: InputMaybe<Scalars['String']['input']>;
  users?: InputMaybe<Array<Scalars['ID']['input']>>;
};

export type CreateInternalChatMessageAttachmentInput = {
  filename: Scalars['String']['input'];
  type: Scalars['String']['input'];
  url: Scalars['String']['input'];
};

export type CreateInternalChatMessageInput = {
  internal_chat: Scalars['ID']['input'];
  internal_chat_messages_attachments?: InputMaybe<Array<CreateInternalChatMessageAttachmentInput>>;
  sender: Scalars['ID']['input'];
  text: Scalars['String']['input'];
};

export type CreateInvoiceInput = {
  appointment?: InputMaybe<Scalars['ID']['input']>;
  balance?: InputMaybe<Scalars['Int']['input']>;
  client?: InputMaybe<Scalars['ID']['input']>;
  clinic?: InputMaybe<Scalars['ID']['input']>;
  clinician?: InputMaybe<Scalars['ID']['input']>;
  currency: Scalars['Currency']['input'];
  description?: InputMaybe<Scalars['String']['input']>;
  discount?: InputMaybe<Scalars['Int']['input']>;
  discount_reason?: InputMaybe<Scalars['String']['input']>;
  entered_by_name?: InputMaybe<Scalars['String']['input']>;
  paid_at?: InputMaybe<Scalars['Timestamp']['input']>;
  patient?: InputMaybe<Scalars['ID']['input']>;
  pims_created_at?: InputMaybe<Scalars['Timestamp']['input']>;
  pms_id: Scalars['String']['input'];
  status: InvoiceStatus;
  subtotal?: InputMaybe<Scalars['Int']['input']>;
  tax?: InputMaybe<Scalars['Int']['input']>;
  total: Scalars['Int']['input'];
};

export type CreateInvoiceItemInput = {
  clinic?: InputMaybe<Scalars['ID']['input']>;
  clinician?: InputMaybe<Scalars['ID']['input']>;
  currency: Scalars['Currency']['input'];
  description?: InputMaybe<Scalars['String']['input']>;
  discount?: InputMaybe<Scalars['Int']['input']>;
  discount_reason?: InputMaybe<Scalars['String']['input']>;
  invoice?: InputMaybe<Scalars['ID']['input']>;
  pims_created_at?: InputMaybe<Scalars['Timestamp']['input']>;
  pms_id: Scalars['String']['input'];
  price?: InputMaybe<Scalars['Int']['input']>;
  product?: InputMaybe<Scalars['ID']['input']>;
  quantity?: InputMaybe<Scalars['NonNegativeFloat']['input']>;
  subtotal?: InputMaybe<Scalars['Int']['input']>;
  tax?: InputMaybe<Scalars['Int']['input']>;
  total: Scalars['Int']['input'];
  type: InvoiceItemType;
};

export type CreateKpiGroupInput = {
  clinic?: InputMaybe<Scalars['ID']['input']>;
  clinic_group?: InputMaybe<Scalars['ID']['input']>;
  description?: InputMaybe<Scalars['String']['input']>;
  name: Scalars['String']['input'];
  report_metrics?: InputMaybe<Array<Scalars['ID']['input']>>;
};

export type CreateKpiGroupMetricInput = {
  goal?: InputMaybe<Scalars['Float']['input']>;
  kpi_group: Scalars['ID']['input'];
  order?: InputMaybe<Scalars['Int']['input']>;
  report_metric: Scalars['ID']['input'];
};

export type CreateLoyaltyMemberInput = {
  all_time_points?: InputMaybe<Scalars['Float']['input']>;
  available_points?: InputMaybe<Scalars['Float']['input']>;
  client: Scalars['ID']['input'];
};

export type CreateLoyaltyRedemptionInput = {
  member: Scalars['ID']['input'];
  reward: Scalars['ID']['input'];
  status?: InputMaybe<LoyaltyRedemptionStatus>;
};

export type CreateLoyaltyRewardInput = {
  clinic: Scalars['ID']['input'];
  description?: InputMaybe<Scalars['String']['input']>;
  image_url?: InputMaybe<Scalars['String']['input']>;
  name: Scalars['String']['input'];
  points_required: Scalars['NonNegativeInt']['input'];
};

export type CreateMessageInput = {
  attachments?: InputMaybe<Array<CreateAttachmentInput>>;
  bulk_message?: InputMaybe<Scalars['ID']['input']>;
  call?: InputMaybe<Scalars['ID']['input']>;
  client?: InputMaybe<Scalars['ID']['input']>;
  client_phone?: InputMaybe<Scalars['ID']['input']>;
  clinic_user?: InputMaybe<Scalars['ID']['input']>;
  cta_text?: InputMaybe<Scalars['String']['input']>;
  cta_url?: InputMaybe<Scalars['String']['input']>;
  dont_update_chat_time?: InputMaybe<Scalars['Boolean']['input']>;
  email_text?: InputMaybe<Scalars['String']['input']>;
  hidden_for_client?: InputMaybe<Scalars['Boolean']['input']>;
  is_preview?: InputMaybe<Scalars['Boolean']['input']>;
  message_methods?: InputMaybe<Array<MessageMethod>>;
  message_origin: MessageOrigin;
  message_type: MessageType;
  notification?: InputMaybe<Scalars['ID']['input']>;
  notification_ids?: InputMaybe<Array<Scalars['ID']['input']>>;
  patient?: InputMaybe<Scalars['ID']['input']>;
  patientIds?: InputMaybe<Array<Scalars['ID']['input']>>;
  postcard_template?: InputMaybe<Scalars['String']['input']>;
  sender_unique_id?: InputMaybe<Scalars['String']['input']>;
  should_change_chat_status_to?: InputMaybe<ChatStatus>;
  subject?: InputMaybe<Scalars['String']['input']>;
  template_data?: InputMaybe<Scalars['JSON']['input']>;
  text: Scalars['String']['input'];
  type?: InputMaybe<NotificationType>;
  written_back_at?: InputMaybe<Scalars['NonNegativeInt']['input']>;
};

export type CreateMessageTemplateInput = {
  body: Scalars['String']['input'];
  /** Owner: exactly one of clinic / clinic_group must be set */
  clinic?: InputMaybe<Scalars['ID']['input']>;
  /** Group-owned templates waterfall to linked clinics (see entity_links) */
  clinic_group?: InputMaybe<Scalars['ID']['input']>;
  name: Scalars['String']['input'];
};

export type CreateNotificationTemplateInput = {
  body: Scalars['String']['input'];
  campaign?: InputMaybe<Scalars['ID']['input']>;
  /** Owner: exactly one of clinic / clinic_group must be set */
  clinic?: InputMaybe<Scalars['ID']['input']>;
  /** Group-owned templates waterfall to linked clinics (see entity_links) */
  clinic_group?: InputMaybe<Scalars['ID']['input']>;
  cta_text?: InputMaybe<Scalars['String']['input']>;
  cta_url?: InputMaybe<Scalars['String']['input']>;
  customer_segment?: InputMaybe<Scalars['ID']['input']>;
  default_service_id?: InputMaybe<Scalars['ID']['input']>;
  email_body?: InputMaybe<Scalars['String']['input']>;
  email_design?: InputMaybe<Scalars['JSON']['input']>;
  email_html?: InputMaybe<Scalars['String']['input']>;
  email_template?: InputMaybe<Scalars['ID']['input']>;
  every_x_hours: Scalars['NonNegativeInt']['input'];
  grouping_method?: InputMaybe<NotificationGroupingMethod>;
  header?: InputMaybe<Scalars['String']['input']>;
  is_active?: InputMaybe<Scalars['Boolean']['input']>;
  is_marketing?: InputMaybe<Scalars['Boolean']['input']>;
  is_preview_mode?: InputMaybe<Scalars['Boolean']['input']>;
  is_system?: InputMaybe<Scalars['Boolean']['input']>;
  message_methods: Array<MessageMethod>;
  name: Scalars['String']['input'];
  notif_attachments?: InputMaybe<Array<CreateAttachmentInput>>;
  postcard_back_html?: InputMaybe<Scalars['String']['input']>;
  postcard_front_html?: InputMaybe<Scalars['String']['input']>;
  postcard_template?: InputMaybe<Scalars['String']['input']>;
  repeating_body?: InputMaybe<Scalars['String']['input']>;
  send_time_minutes?: InputMaybe<Scalars['NonNegativeInt']['input']>;
  subject?: InputMaybe<Scalars['String']['input']>;
  type?: InputMaybe<NotificationType>;
};

export type CreateOrganizationInput = {
  admins?: InputMaybe<Array<Scalars['ID']['input']>>;
  name: Scalars['String']['input'];
  settings?: InputMaybe<OrganizationSettingsInput>;
};

export type CreateOrganizationReportInput = {
  description?: InputMaybe<Scalars['String']['input']>;
  entity_structure: Array<ReportEntityInput>;
  is_hidden?: InputMaybe<Scalars['Boolean']['input']>;
  name: Scalars['String']['input'];
  organization: Scalars['ID']['input'];
  preferred_view_type?: InputMaybe<ReportViewType>;
  report_metrics: Array<ReportMetricInput>;
  report_template?: InputMaybe<Scalars['ID']['input']>;
  time_params: TimeParamsInput;
};

export type CreatePatientHistoryItemInput = {
  appointment?: InputMaybe<Scalars['ID']['input']>;
  clinic: Scalars['ID']['input'];
  clinician?: InputMaybe<Scalars['ID']['input']>;
  diagnosis?: InputMaybe<Scalars['ID']['input']>;
  issued_at: Scalars['Timestamp']['input'];
  patient: Scalars['ID']['input'];
  pms_id?: InputMaybe<Scalars['ID']['input']>;
  product?: InputMaybe<Scalars['ID']['input']>;
};

export type CreatePatientInput = {
  avatar_url?: InputMaybe<Scalars['String']['input']>;
  birthday?: InputMaybe<Scalars['Float']['input']>;
  breed?: InputMaybe<Scalars['String']['input']>;
  checksum?: InputMaybe<Scalars['String']['input']>;
  client_pms_id?: InputMaybe<Scalars['String']['input']>;
  clinic?: InputMaybe<Scalars['ID']['input']>;
  clinic_breed?: InputMaybe<Scalars['ID']['input']>;
  clinic_species?: InputMaybe<Scalars['ID']['input']>;
  fixed_status?: InputMaybe<FixedStatus>;
  gender?: InputMaybe<AnimalGender>;
  is_active?: InputMaybe<Scalars['Boolean']['input']>;
  is_deceased?: InputMaybe<Scalars['Boolean']['input']>;
  last_appointment?: InputMaybe<Scalars['ID']['input']>;
  last_appt_time?: InputMaybe<Scalars['NonNegativeInt']['input']>;
  name?: InputMaybe<Scalars['String']['input']>;
  next_appointment?: InputMaybe<Scalars['ID']['input']>;
  next_appt_time?: InputMaybe<Scalars['NonNegativeInt']['input']>;
  origin?: InputMaybe<EntityOrigin>;
  owner?: InputMaybe<Scalars['ID']['input']>;
  pet?: InputMaybe<Scalars['ID']['input']>;
  pms?: InputMaybe<PracticeManagementSystem>;
  pms_created_at?: InputMaybe<Scalars['NonNegativeInt']['input']>;
  pms_id?: InputMaybe<Scalars['String']['input']>;
  species_pms_id?: InputMaybe<Scalars['String']['input']>;
  status?: InputMaybe<Scalars['ID']['input']>;
  weight?: InputMaybe<Scalars['Float']['input']>;
};

export type CreatePatientRecordInput = {
  appointment?: InputMaybe<Scalars['ID']['input']>;
  assessment?: InputMaybe<Scalars['String']['input']>;
  assisting_clinicians?: InputMaybe<Array<Scalars['String']['input']>>;
  client?: InputMaybe<Scalars['ID']['input']>;
  clinic?: InputMaybe<Scalars['ID']['input']>;
  clinician?: InputMaybe<Scalars['ID']['input']>;
  date?: InputMaybe<Scalars['NonNegativeInt']['input']>;
  master_problem_list?: InputMaybe<Scalars['String']['input']>;
  objective?: InputMaybe<Scalars['String']['input']>;
  patient: Scalars['ID']['input'];
  plan?: InputMaybe<Scalars['String']['input']>;
  public_notes?: InputMaybe<Scalars['String']['input']>;
  service?: InputMaybe<Scalars['ID']['input']>;
  subjective?: InputMaybe<Scalars['String']['input']>;
};

export type CreatePaymentInput = {
  amount: Scalars['PositiveInt']['input'];
  appointment?: InputMaybe<Scalars['ID']['input']>;
  category: PurchaseCategory;
  client: Scalars['ID']['input'];
  clinic: Scalars['ID']['input'];
  currency?: InputMaybe<Scalars['Currency']['input']>;
  date: Scalars['NonNegativeInt']['input'];
  description?: InputMaybe<Scalars['String']['input']>;
  errors?: InputMaybe<Array<PaymentErrorInput>>;
  invoice?: InputMaybe<Scalars['ID']['input']>;
  is_entered_in_pims?: InputMaybe<Scalars['Boolean']['input']>;
  payment_method_id?: InputMaybe<Scalars['String']['input']>;
  processing_fee?: InputMaybe<Scalars['NonNegativeInt']['input']>;
  sales_tax?: InputMaybe<Scalars['NonNegativeInt']['input']>;
  service_fee?: InputMaybe<Scalars['NonNegativeInt']['input']>;
  status: PaymentStatus;
  stripe_payment_intent_id?: InputMaybe<Scalars['String']['input']>;
};

export type CreatePaymentLinkInput = {
  amount: Scalars['PositiveInt']['input'];
  appointment?: InputMaybe<Scalars['ID']['input']>;
  client: Scalars['ID']['input'];
  clinic: Scalars['ID']['input'];
  description: Scalars['String']['input'];
  invoice?: InputMaybe<Scalars['ID']['input']>;
};

export type CreatePetInput = {
  avatar_url?: InputMaybe<Scalars['String']['input']>;
  bio?: InputMaybe<Scalars['String']['input']>;
  birthday?: InputMaybe<Scalars['Float']['input']>;
  breed?: InputMaybe<Scalars['String']['input']>;
  family?: InputMaybe<Scalars['ID']['input']>;
  fixed_status?: InputMaybe<FixedStatus>;
  gender?: InputMaybe<AnimalGender>;
  name?: InputMaybe<Scalars['String']['input']>;
  species?: InputMaybe<Species>;
  weight?: InputMaybe<Scalars['NonNegativeFloat']['input']>;
};

export type CreatePetSelfieInput = {
  allow_public_share: Scalars['Boolean']['input'];
  client: Scalars['ID']['input'];
  clinic: Scalars['ID']['input'];
  display_caption?: InputMaybe<Scalars['String']['input']>;
  duration_ms?: InputMaybe<Scalars['Int']['input']>;
  favorite_activity?: InputMaybe<Scalars['String']['input']>;
  filename?: InputMaybe<Scalars['String']['input']>;
  media_type: PetSelfieMediaType;
  mime_type: Scalars['String']['input'];
  nickname?: InputMaybe<Scalars['String']['input']>;
  patient?: InputMaybe<Scalars['ID']['input']>;
  pet_name?: InputMaybe<Scalars['String']['input']>;
  size_bytes?: InputMaybe<Scalars['Int']['input']>;
  submitted_media_url: Scalars['String']['input'];
  thumbnail_url?: InputMaybe<Scalars['String']['input']>;
  weirdest_thing?: InputMaybe<Scalars['String']['input']>;
};

export type CreatePimsReminderInput = {
  client: Scalars['ID']['input'];
  clinic?: InputMaybe<Scalars['ID']['input']>;
  is_active: Scalars['Boolean']['input'];
  is_completed: Scalars['Boolean']['input'];
  patient: Scalars['ID']['input'];
  pms_id: Scalars['String']['input'];
  reminder_desc?: InputMaybe<Scalars['String']['input']>;
  reminder_type?: InputMaybe<Scalars['ID']['input']>;
  send_date: Scalars['NonNegativeInt']['input'];
};

export type CreatePimsReminderTypeInput = {
  clinic: Scalars['ID']['input'];
  display_name?: InputMaybe<Scalars['String']['input']>;
  is_active: Scalars['Boolean']['input'];
  pms_id: Scalars['String']['input'];
  reminder_type_name: Scalars['String']['input'];
};

export type CreatePimsSettingsInput = {
  access_token?: InputMaybe<Scalars['String']['input']>;
  access_token_expiration?: InputMaybe<Scalars['NonNegativeInt']['input']>;
  additional_key?: InputMaybe<Scalars['String']['input']>;
  api_clinic_id?: InputMaybe<Scalars['String']['input']>;
  api_key?: InputMaybe<Scalars['String']['input']>;
  api_subdomain?: InputMaybe<Scalars['String']['input']>;
  clinic?: InputMaybe<Scalars['ID']['input']>;
  cookie?: InputMaybe<Array<Scalars['String']['input']>>;
  entered_by_pms_id?: InputMaybe<Scalars['String']['input']>;
  ezyvet_client_id?: InputMaybe<Scalars['String']['input']>;
  ezyvet_client_secret?: InputMaybe<Scalars['String']['input']>;
  ezyvet_integration_mode?: InputMaybe<EzyvetIntegrationMode>;
  ezyvet_scopes?: InputMaybe<Scalars['String']['input']>;
  ezyvet_site_uid?: InputMaybe<Scalars['String']['input']>;
  long_sync_interval_hours?: InputMaybe<Scalars['NonNegativeInt']['input']>;
  password?: InputMaybe<Scalars['String']['input']>;
  payment_type_pms_id?: InputMaybe<Scalars['String']['input']>;
  phones_api_key?: InputMaybe<Scalars['String']['input']>;
  phones_secondary_api_key?: InputMaybe<Scalars['String']['input']>;
  pims_version?: InputMaybe<Scalars['String']['input']>;
  pin?: InputMaybe<Scalars['String']['input']>;
  pms_db?: InputMaybe<Scalars['ID']['input']>;
  practice_key?: InputMaybe<Scalars['String']['input']>;
  pulse_ar_report_id?: InputMaybe<Scalars['String']['input']>;
  pulse_clients_report_id?: InputMaybe<Scalars['String']['input']>;
  pulse_patients_report_id?: InputMaybe<Scalars['String']['input']>;
  pulse_reminders_report_id?: InputMaybe<Scalars['String']['input']>;
  pulse_sales_report_id?: InputMaybe<Scalars['String']['input']>;
  pulse_vaccinations_report_id?: InputMaybe<Scalars['String']['input']>;
  refresh_token?: InputMaybe<Scalars['String']['input']>;
  request_verification_token?: InputMaybe<Scalars['String']['input']>;
  should_sync_clinician_hours?: InputMaybe<Scalars['Boolean']['input']>;
  sync_interval_minutes?: InputMaybe<Scalars['NonNegativeInt']['input']>;
  user_key?: InputMaybe<Scalars['String']['input']>;
  username?: InputMaybe<Scalars['String']['input']>;
};

export type CreatePmsApptTypeInput = {
  clinic?: InputMaybe<Scalars['ID']['input']>;
  color?: InputMaybe<Scalars['HexColorCode']['input']>;
  description?: InputMaybe<Scalars['String']['input']>;
  metadata?: InputMaybe<Scalars['JSON']['input']>;
  name: Scalars['String']['input'];
  pms_id: Scalars['String']['input'];
};

export type CreatePmsDbInput = {
  last_sync_times?: InputMaybe<LastSyncTimesInput>;
  name: Scalars['String']['input'];
  pims_settings?: InputMaybe<CreatePimsSettingsInput>;
  pms: PracticeManagementSystem;
  /** Defaults to the PIMS's usual connector when omitted. */
  pms_connector?: InputMaybe<PmsConnector>;
  time_zone: Scalars['String']['input'];
};

export type CreatePrescriptionInput = {
  clinic?: InputMaybe<Scalars['ID']['input']>;
  clinician?: InputMaybe<Scalars['ID']['input']>;
  description?: InputMaybe<Scalars['String']['input']>;
  expiration_date?: InputMaybe<Scalars['Timestamp']['input']>;
  is_active: Scalars['Boolean']['input'];
  last_refill_time?: InputMaybe<Scalars['NonNegativeInt']['input']>;
  name: Scalars['String']['input'];
  patient: Scalars['ID']['input'];
  pms_created_at: Scalars['Timestamp']['input'];
  pms_id: Scalars['String']['input'];
  product?: InputMaybe<Scalars['ID']['input']>;
  product_name?: InputMaybe<Scalars['String']['input']>;
  quantity?: InputMaybe<Scalars['NonNegativeFloat']['input']>;
  refill_count?: InputMaybe<Scalars['NonNegativeInt']['input']>;
  refill_limit?: InputMaybe<Scalars['NonNegativeInt']['input']>;
  remaining?: InputMaybe<Scalars['NonNegativeFloat']['input']>;
};

export type CreatePrescriptionRefillRequestInput = {
  amount?: InputMaybe<Scalars['NonNegativeInt']['input']>;
  client: Scalars['ID']['input'];
  clinic: Scalars['ID']['input'];
  notes?: InputMaybe<Scalars['String']['input']>;
  patient?: InputMaybe<Scalars['ID']['input']>;
  pickup_time?: InputMaybe<Scalars['NonNegativeInt']['input']>;
  prescription?: InputMaybe<Scalars['ID']['input']>;
  stripe_payment_intent_id?: InputMaybe<Scalars['String']['input']>;
  type: PrescriptionRefillRequestType;
};

export type CreatePressItemInput = {
  description?: InputMaybe<Scalars['String']['input']>;
  image?: InputMaybe<Scalars['String']['input']>;
  links?: InputMaybe<Array<LinkInput>>;
  title?: InputMaybe<Scalars['String']['input']>;
};

export type CreateProductInput = {
  additional_fees?: InputMaybe<Array<AdditionalFeesInput>>;
  category: ProductCategory;
  chckvet_price?: InputMaybe<Scalars['Int']['input']>;
  clinic?: InputMaybe<Scalars['ID']['input']>;
  code?: InputMaybe<Scalars['String']['input']>;
  description?: InputMaybe<Scalars['String']['input']>;
  display_name?: InputMaybe<Scalars['String']['input']>;
  is_active: Scalars['Boolean']['input'];
  name: Scalars['String']['input'];
  pims_category?: InputMaybe<Scalars['String']['input']>;
  pms_id: Scalars['String']['input'];
  prescription_fee_split_override?: InputMaybe<Scalars['Float']['input']>;
  price: Scalars['Int']['input'];
  unit?: InputMaybe<Scalars['String']['input']>;
  volume?: InputMaybe<Scalars['String']['input']>;
};

export type CreateProviderAvailabilityInput = {
  clinic?: InputMaybe<Scalars['ID']['input']>;
  clinician?: InputMaybe<Scalars['ID']['input']>;
  date?: InputMaybe<Scalars['NonNegativeInt']['input']>;
  end: Scalars['NonNegativeInt']['input'];
  is_for_booking: Scalars['Boolean']['input'];
  repeat_days_of_month?: InputMaybe<Array<Scalars['NonNegativeInt']['input']>>;
  repeat_days_of_week?: InputMaybe<Array<AvailabilityDay>>;
  repeat_end_date?: InputMaybe<Scalars['NonNegativeInt']['input']>;
  repeat_frequency?: InputMaybe<Scalars['NonNegativeInt']['input']>;
  repeat_unit?: InputMaybe<RepeatUnit>;
  repeat_week_of_month?: InputMaybe<WeekOfMonth>;
  room?: InputMaybe<Scalars['ID']['input']>;
  routine_days?: InputMaybe<Array<AvailabilityDay>>;
  start: Scalars['NonNegativeInt']['input'];
  type: AvailabilityType;
  valid_to?: InputMaybe<Scalars['NonNegativeInt']['input']>;
};

export type CreateReportClinicInput = {
  clinic: Scalars['ID']['input'];
  report: Scalars['ID']['input'];
};

export type CreateReportColumnValueInput = {
  percentile?: InputMaybe<Scalars['NonNegativeFloat']['input']>;
  value: Scalars['Float']['input'];
  value_params: MetricValueParamsInput;
};

export type CreateReportMetricInput = {
  aggregate_field_override?: InputMaybe<Scalars['String']['input']>;
  clinic?: InputMaybe<Scalars['ID']['input']>;
  clinic_group?: InputMaybe<Scalars['ID']['input']>;
  custom_query?: InputMaybe<Scalars['JSON']['input']>;
  definition_override?: InputMaybe<Scalars['String']['input']>;
  description?: InputMaybe<Scalars['String']['input']>;
  field_modifiers?: InputMaybe<Array<ReportMetricModifierInput>>;
  format?: InputMaybe<MetricFormat>;
  inverse_percentile?: InputMaybe<Scalars['Boolean']['input']>;
  is_archived?: InputMaybe<Scalars['Boolean']['input']>;
  name: Scalars['String']['input'];
  order: Scalars['NonNegativeInt']['input'];
  organization_report?: InputMaybe<Scalars['ID']['input']>;
  report_template?: InputMaybe<Scalars['ID']['input']>;
  special_modifier?: InputMaybe<SpecialMetricModifierType>;
  time_field_override?: InputMaybe<Scalars['String']['input']>;
  time_params_overrides?: InputMaybe<TimeParamsInput>;
  type: ReportMetricType;
  value_types: Array<MetricValueParamsInput>;
};

export type CreateReportTemplateInput = {
  clinic?: InputMaybe<Scalars['ID']['input']>;
  clinic_group?: InputMaybe<Scalars['ID']['input']>;
  description?: InputMaybe<Scalars['String']['input']>;
  entity_structure?: InputMaybe<Array<Scalars['String']['input']>>;
  is_active?: InputMaybe<Scalars['Boolean']['input']>;
  name: Scalars['String']['input'];
  preferred_view_type?: InputMaybe<ReportViewType>;
  repeat?: InputMaybe<RepeatParamsInput>;
  report_metrics?: InputMaybe<Array<Scalars['ID']['input']>>;
  template_clinics?: InputMaybe<Array<Scalars['ID']['input']>>;
  time_params?: InputMaybe<TimeParamsInput>;
};

export type CreateReportTemplateMetricInput = {
  order?: InputMaybe<Scalars['Int']['input']>;
  report_metric: Scalars['ID']['input'];
  report_template: Scalars['ID']['input'];
};

export type CreateReportValueInput = {
  column_values: Array<CreateReportColumnValueInput>;
  key: Scalars['String']['input'];
  metric: ReportMetricType;
};

export type CreateRescheduleInput = {
  appointment: Scalars['ID']['input'];
  client_notes?: InputMaybe<Scalars['String']['input']>;
  clinic: Scalars['ID']['input'];
  clinic_notes?: InputMaybe<Scalars['String']['input']>;
  confirmed_at?: InputMaybe<Scalars['NonNegativeInt']['input']>;
  initiated_by: RescheduleInitiatedBy;
  original_clinician?: InputMaybe<Scalars['ID']['input']>;
  original_drop_off_time?: InputMaybe<Scalars['NonNegativeInt']['input']>;
  original_start_time?: InputMaybe<Scalars['NonNegativeInt']['input']>;
  reason_for_denial?: InputMaybe<Scalars['String']['input']>;
  requested_clinician?: InputMaybe<Scalars['ID']['input']>;
  requested_drop_off_time?: InputMaybe<Scalars['NonNegativeInt']['input']>;
  requested_start_time?: InputMaybe<Scalars['NonNegativeInt']['input']>;
  status?: InputMaybe<RescheduleStatus>;
};

export type CreateReviewInput = {
  appointment?: InputMaybe<Scalars['ID']['input']>;
  care_rating?: InputMaybe<Scalars['NonNegativeInt']['input']>;
  client?: InputMaybe<Scalars['ID']['input']>;
  clinic: Scalars['ID']['input'];
  description?: InputMaybe<Scalars['String']['input']>;
  is_anonymous?: InputMaybe<Scalars['Boolean']['input']>;
  nps_rating?: InputMaybe<Scalars['NonNegativeInt']['input']>;
  overall_rating: Scalars['NonNegativeInt']['input'];
  price_rating?: InputMaybe<Scalars['NonNegativeInt']['input']>;
  review_submitted_at?: InputMaybe<Scalars['Timestamp']['input']>;
  time_rating?: InputMaybe<Scalars['NonNegativeInt']['input']>;
};

export type CreateRoomInput = {
  adjusted_availability?: InputMaybe<Array<AvailabilityInput>>;
  clinic: Scalars['ID']['input'];
  concurrent_patients?: InputMaybe<Scalars['NonNegativeInt']['input']>;
  description?: InputMaybe<Scalars['String']['input']>;
  display_name?: InputMaybe<Scalars['String']['input']>;
  does_contribute_to_fill_rate?: InputMaybe<Scalars['Boolean']['input']>;
  hours?: InputMaybe<AvailabilityHoursInput>;
  is_active?: InputMaybe<Scalars['Boolean']['input']>;
  name: Scalars['String']['input'];
  pms: PracticeManagementSystem;
  pms_adjusted_availability?: InputMaybe<Array<AvailabilityInput>>;
  pms_id: Scalars['String']['input'];
  stagger_offset_minutes?: InputMaybe<Scalars['NonNegativeInt']['input']>;
  valid_booking_interval_minutes?: InputMaybe<Array<Scalars['NonNegativeInt']['input']>>;
};

export type CreateRoomServiceInput = {
  clinic: Scalars['ID']['input'];
  duration_override?: InputMaybe<Scalars['NonNegativeInt']['input']>;
  is_active?: InputMaybe<Scalars['Boolean']['input']>;
  room: Scalars['ID']['input'];
  service: Scalars['ID']['input'];
};

export type CreateScheduledBulkMessageInput = {
  body: Scalars['String']['input'];
  campaign?: InputMaybe<Scalars['ID']['input']>;
  /** Owner: exactly one of clinic / clinic_group must be set */
  clinic?: InputMaybe<Scalars['ID']['input']>;
  /** Group-owned bulk messages waterfall to linked clinics (see entity_links) */
  clinic_group?: InputMaybe<Scalars['ID']['input']>;
  cta_text?: InputMaybe<Scalars['String']['input']>;
  cta_url?: InputMaybe<Scalars['String']['input']>;
  customer_segment?: InputMaybe<Scalars['ID']['input']>;
  email_body?: InputMaybe<Scalars['String']['input']>;
  email_design?: InputMaybe<Scalars['JSON']['input']>;
  email_html?: InputMaybe<Scalars['String']['input']>;
  email_template?: InputMaybe<Scalars['ID']['input']>;
  excluded_clients?: InputMaybe<Array<Scalars['ID']['input']>>;
  header?: InputMaybe<Scalars['String']['input']>;
  included_clients?: InputMaybe<Array<Scalars['ID']['input']>>;
  is_active?: InputMaybe<Scalars['Boolean']['input']>;
  is_completed?: InputMaybe<Scalars['Boolean']['input']>;
  is_marketing?: InputMaybe<Scalars['Boolean']['input']>;
  is_system?: InputMaybe<Scalars['Boolean']['input']>;
  message_methods: Array<MessageMethod>;
  name: Scalars['String']['input'];
  notif_attachments?: InputMaybe<Array<CreateAttachmentInput>>;
  send_time?: InputMaybe<Scalars['NonNegativeInt']['input']>;
  subject?: InputMaybe<Scalars['String']['input']>;
};

export type CreateScheduledMessageInput = {
  chat: Scalars['ID']['input'];
  client?: InputMaybe<Scalars['ID']['input']>;
  clinic: Scalars['ID']['input'];
  created_by: Scalars['ID']['input'];
  cta_text?: InputMaybe<Scalars['String']['input']>;
  cta_url?: InputMaybe<Scalars['String']['input']>;
  email_text?: InputMaybe<Scalars['String']['input']>;
  message_attachments?: InputMaybe<Array<CreateAttachmentInput>>;
  message_methods: Array<MessageMethod>;
  send_time: Scalars['NonNegativeInt']['input'];
  subject?: InputMaybe<Scalars['String']['input']>;
  text: Scalars['String']['input'];
};

export type CreateSchedulingRulesInput = {
  adjusted_availability?: InputMaybe<Array<AvailabilityInput>>;
  availability?: InputMaybe<AvailabilityHoursInput>;
  client_type?: InputMaybe<ClientTypeEnum>;
  clinic?: InputMaybe<Scalars['ID']['input']>;
  fixed_status?: InputMaybe<FixedStatus>;
  included_client_audiences?: InputMaybe<Array<Scalars['ID']['input']>>;
  included_clinicians?: InputMaybe<Array<Scalars['ID']['input']>>;
  included_patient_audiences?: InputMaybe<Array<Scalars['ID']['input']>>;
  included_rooms?: InputMaybe<Array<Scalars['ID']['input']>>;
  included_services?: InputMaybe<Array<Scalars['ID']['input']>>;
  included_species?: InputMaybe<Array<Scalars['ID']['input']>>;
  is_active?: InputMaybe<Scalars['Boolean']['input']>;
  is_simple_rule?: InputMaybe<Scalars['Boolean']['input']>;
  max_per_rule?: InputMaybe<Scalars['NonNegativeInt']['input']>;
  only_modifier?: InputMaybe<OnlyModifierEnum>;
  patient_gender?: InputMaybe<AnimalGender>;
  patient_type?: InputMaybe<PatientTypeEnum>;
  widget?: InputMaybe<Scalars['ID']['input']>;
};

export type CreateServiceCategoryInput = {
  clinic: Scalars['ID']['input'];
  confirmation_message?: InputMaybe<Scalars['String']['input']>;
  description: Scalars['String']['input'];
  icon?: InputMaybe<ServiceCategoryIcon>;
  order?: InputMaybe<Scalars['NonNegativeInt']['input']>;
  requires_confirmation?: InputMaybe<Scalars['Boolean']['input']>;
  title: Scalars['String']['input'];
};

export type CreateServiceFormInput = {
  client_type?: InputMaybe<ClientTypeEnum>;
  form: Scalars['ID']['input'];
  is_required_before_booking?: InputMaybe<Scalars['Boolean']['input']>;
  is_required_before_confirming?: InputMaybe<Scalars['Boolean']['input']>;
  service: Scalars['ID']['input'];
};

/**
 * Write payload to create a service. Field meanings match Service (read that
 * type's introspection descriptions). Deprecated fields are stored but unused.
 */
export type CreateServiceInput = {
  action_required_acknowledgement_text?: InputMaybe<Scalars['String']['input']>;
  allow_new?: InputMaybe<Scalars['Boolean']['input']>;
  allow_returning?: InputMaybe<Scalars['Boolean']['input']>;
  allowed_appt_type_pms_ids?: InputMaybe<Array<Scalars['String']['input']>>;
  authorized_levels?: InputMaybe<Array<AuthorityLevel>>;
  availability?: InputMaybe<AvailabilityHoursInput>;
  clinic?: InputMaybe<Scalars['ID']['input']>;
  color?: InputMaybe<Scalars['String']['input']>;
  custom_appointment_notes_template?: InputMaybe<Scalars['String']['input']>;
  custom_new_client_notes_template?: InputMaybe<Scalars['String']['input']>;
  custom_new_patient_notes_template?: InputMaybe<Scalars['String']['input']>;
  /** Optional default room stored on the service and included on Connect appointment payloads. Online booking does not auto-assign from this field. */
  default_room?: InputMaybe<Scalars['ID']['input']>;
  description?: InputMaybe<Scalars['String']['input']>;
  drop_off_hours?: InputMaybe<AvailabilityHoursInput>;
  drop_off_minutes_before?: InputMaybe<Scalars['NonNegativeInt']['input']>;
  drop_off_time?: InputMaybe<Scalars['String']['input']>;
  duration?: InputMaybe<Scalars['NonNegativeInt']['input']>;
  exclude_from_portal?: InputMaybe<Scalars['Boolean']['input']>;
  excluded_species?: InputMaybe<Array<Species>>;
  follow_up_services?: InputMaybe<Array<Scalars['ID']['input']>>;
  follow_up_settings?: InputMaybe<CreateFollowUpSettingsInput>;
  hide_clinician_preference?: InputMaybe<Scalars['Boolean']['input']>;
  is_active?: InputMaybe<Scalars['Boolean']['input']>;
  is_blocking?: InputMaybe<Scalars['Boolean']['input']>;
  is_cancellation_allowed?: InputMaybe<Scalars['Boolean']['input']>;
  is_primary_for_appt_type?: InputMaybe<Scalars['Boolean']['input']>;
  is_reschedule_allowed?: InputMaybe<Scalars['Boolean']['input']>;
  keywords?: InputMaybe<Scalars['String']['input']>;
  max_per_day?: InputMaybe<Scalars['NonNegativeInt']['input']>;
  max_per_hour?: InputMaybe<Scalars['NonNegativeInt']['input']>;
  maximum_patient_age_in_days?: InputMaybe<Scalars['NonNegativeInt']['input']>;
  minimum_patient_age_in_days?: InputMaybe<Scalars['NonNegativeInt']['input']>;
  more_info?: InputMaybe<Scalars['String']['input']>;
  more_info_action_required?: InputMaybe<Scalars['String']['input']>;
  name?: InputMaybe<Scalars['String']['input']>;
  only_use_adj_avail_guides?: InputMaybe<Scalars['Boolean']['input']>;
  order?: InputMaybe<Scalars['NonNegativeInt']['input']>;
  pick_up_time?: InputMaybe<Scalars['String']['input']>;
  pms_appt_type?: InputMaybe<Scalars['ID']['input']>;
  points?: InputMaybe<Scalars['NonNegativeInt']['input']>;
  pre_confirmation_checklist?: InputMaybe<Array<ServicePreConfirmationItemInput>>;
  pricing?: InputMaybe<CreateServicePricingInput>;
  recurring?: InputMaybe<RecurringSettingsInput>;
  required_room?: InputMaybe<Scalars['ID']['input']>;
  reserved_per_day?: InputMaybe<Scalars['NonNegativeInt']['input']>;
  scheduling_buffer_minutes?: InputMaybe<Scalars['NonNegativeInt']['input']>;
  scheduling_max_minutes_away?: InputMaybe<Scalars['NonNegativeInt']['input']>;
  scheduling_min_minutes_away?: InputMaybe<Scalars['NonNegativeInt']['input']>;
  service_category_ids?: InputMaybe<Array<Scalars['ID']['input']>>;
  service_types?: InputMaybe<Array<ServiceType>>;
  use_previous_doctor?: InputMaybe<Scalars['Boolean']['input']>;
  valid_booking_interval_minutes?: InputMaybe<Array<Scalars['NonNegativeInt']['input']>>;
};

export type CreateServicePricingInput = {
  client_type?: InputMaybe<ClientTypeEnum>;
  currency?: InputMaybe<Scalars['Currency']['input']>;
  price: Scalars['PositiveInt']['input'];
  type?: InputMaybe<ServicePricingType>;
};

export type CreateTagCategoryInput = {
  allowed_entities: Array<TagEntity>;
  clinic?: InputMaybe<Scalars['ID']['input']>;
  clinic_group?: InputMaybe<Scalars['ID']['input']>;
  color?: InputMaybe<Scalars['String']['input']>;
  name: Scalars['String']['input'];
};

export type CreateTagInput = {
  entity_id: Scalars['String']['input'];
  entity_type: TagEntity;
  tag_category: Scalars['ID']['input'];
};

export type CreateTemplateClinicInput = {
  clinic: Scalars['ID']['input'];
  report_template: Scalars['ID']['input'];
};

export type CreateTransactionInput = {
  amount?: InputMaybe<Scalars['String']['input']>;
  client_pms_id?: InputMaybe<Scalars['ID']['input']>;
  clinic_id: Scalars['ID']['input'];
  clinician_pms_id?: InputMaybe<Scalars['ID']['input']>;
  date?: InputMaybe<Scalars['NonNegativeInt']['input']>;
  description?: InputMaybe<Scalars['String']['input']>;
  patient_pms_id?: InputMaybe<Scalars['ID']['input']>;
  pms?: InputMaybe<PracticeManagementSystem>;
  pms_id?: InputMaybe<Scalars['String']['input']>;
  service_pms_id?: InputMaybe<Scalars['ID']['input']>;
  type?: InputMaybe<TransactionType>;
};

export type CreateTreatmentInput = {
  description: Scalars['String']['input'];
  pms_id: Scalars['String']['input'];
  price?: InputMaybe<Scalars['Float']['input']>;
};

export type CreateUserInput = {
  address?: InputMaybe<AddressInput>;
  avatar_url?: InputMaybe<Scalars['String']['input']>;
  clinician?: InputMaybe<Scalars['ID']['input']>;
  email?: InputMaybe<Scalars['EmailAddress']['input']>;
  family?: InputMaybe<Scalars['ID']['input']>;
  favorited_clinics?: Array<Scalars['ID']['input']>;
  first_name?: InputMaybe<Scalars['String']['input']>;
  has_agreed_to_terms?: InputMaybe<Scalars['Boolean']['input']>;
  last_name?: InputMaybe<Scalars['String']['input']>;
  phone?: InputMaybe<Scalars['String']['input']>;
  phone_country?: InputMaybe<Scalars['String']['input']>;
  stripe_customer_id?: InputMaybe<Scalars['String']['input']>;
};

export type CreateWidgetInput = {
  average_chat_response_time?: InputMaybe<Scalars['String']['input']>;
  button_color?: InputMaybe<Scalars['String']['input']>;
  button_text?: InputMaybe<Scalars['String']['input']>;
  campaign?: InputMaybe<Scalars['ID']['input']>;
  clinic?: InputMaybe<Scalars['ID']['input']>;
  clinic_group?: InputMaybe<Scalars['ID']['input']>;
  enabled_chat_buttons?: InputMaybe<Array<WidgetMenuButtonType>>;
  featured_reviews?: InputMaybe<Array<FeaturedReviewInput>>;
  is_active?: InputMaybe<Scalars['Boolean']['input']>;
  is_archived?: InputMaybe<Scalars['Boolean']['input']>;
  is_external?: InputMaybe<Scalars['Boolean']['input']>;
  source?: InputMaybe<Scalars['String']['input']>;
  tags?: InputMaybe<Array<Scalars['String']['input']>>;
  text_color?: InputMaybe<Scalars['String']['input']>;
  trigger_type: WidgetTriggerType;
  type: WidgetType;
  widget_name: Scalars['String']['input'];
  widget_styles?: InputMaybe<WidgetStylesInput>;
};

export type CreateWidgetOptionsInput = {
  booking_avail_end?: InputMaybe<Scalars['NonNegativeInt']['input']>;
  booking_avail_start?: InputMaybe<Scalars['NonNegativeInt']['input']>;
  custom_booking_copy?: InputMaybe<ClinicBookingCopyInput>;
  custom_other_description?: InputMaybe<Scalars['String']['input']>;
  custom_other_title?: InputMaybe<Scalars['String']['input']>;
  custom_sick_description?: InputMaybe<Scalars['String']['input']>;
  custom_tracking_properties?: InputMaybe<CustomTrackingPropertiesInput>;
  custom_well_description?: InputMaybe<Scalars['String']['input']>;
  default_trigger_words?: InputMaybe<Array<Scalars['String']['input']>>;
  enabled?: InputMaybe<Scalars['Boolean']['input']>;
  facebook_pixel_id?: InputMaybe<Scalars['String']['input']>;
  fb_event_name_overrides?: InputMaybe<GaEventNameOverridesInput>;
  ga_event_name_overrides?: InputMaybe<GaEventNameOverridesInput>;
  ga_measurement_id?: InputMaybe<Scalars['String']['input']>;
  gtm_container_id?: InputMaybe<Scalars['String']['input']>;
  hide_clinician_preference?: InputMaybe<Scalars['Boolean']['input']>;
  primary_clinic_group_id?: InputMaybe<Scalars['String']['input']>;
  redirect_after_booking_url?: InputMaybe<Scalars['String']['input']>;
  redirect_countdown_seconds?: InputMaybe<Scalars['NonNegativeInt']['input']>;
  scheduling_buffer_minutes?: InputMaybe<Scalars['NonNegativeInt']['input']>;
  scheduling_max_minutes_away?: InputMaybe<Scalars['NonNegativeInt']['input']>;
  scheduling_min_minutes_away?: InputMaybe<Scalars['NonNegativeInt']['input']>;
  should_allow_new_clients?: InputMaybe<Scalars['Boolean']['input']>;
  should_allow_new_patients?: InputMaybe<Scalars['Boolean']['input']>;
  should_allow_returning_clients?: InputMaybe<Scalars['Boolean']['input']>;
  should_allow_returning_patients?: InputMaybe<Scalars['Boolean']['input']>;
  should_suggest_nearby_clinics?: InputMaybe<Scalars['Boolean']['input']>;
  time_slot_minutes?: InputMaybe<Scalars['NonNegativeInt']['input']>;
  times_first_filter_config?: InputMaybe<TimesFirstFilterConfigInput>;
  widget: Scalars['String']['input'];
  widget_access_end_time?: InputMaybe<Scalars['NonNegativeInt']['input']>;
  widget_access_start_time?: InputMaybe<Scalars['NonNegativeInt']['input']>;
  widget_referral_code?: InputMaybe<Scalars['String']['input']>;
  widget_styles?: InputMaybe<WidgetStylesInput>;
};

export type CreateWidgetServiceInput = {
  is_active?: InputMaybe<Scalars['Boolean']['input']>;
  service: Scalars['String']['input'];
  widget: Scalars['String']['input'];
};

export type CreateWidgetSisterLocationInput = {
  clinic: Scalars['ID']['input'];
  is_active: Scalars['Boolean']['input'];
  widget: Scalars['ID']['input'];
};

export type CustSegRpcResult = {
  __typename?: 'CustSegRPCResult';
  count: Scalars['NonNegativeInt']['output'];
  results: Array<CustSegResult>;
};

export type CustSegResult = {
  __typename?: 'CustSegResult';
  appointment?: Maybe<Appointment>;
  /** BookingSessions audiences */
  booking_flow_session?: Maybe<BookingFlowSession>;
  /**
   * Always set for client-based audiences. For LeadContacts / BookingSessions audiences it's
   * set once the person is (or becomes) a client; notification sends always get one.
   */
  client?: Maybe<Client>;
  /** LeadContacts audiences, and BookingSessions whose visitor didn't match a client */
  lead_contact?: Maybe<LeadContact>;
  patient?: Maybe<Patient>;
  patient_history_item?: Maybe<PatientHistoryItem>;
  pims_reminder?: Maybe<PimsReminder>;
  prescription?: Maybe<Prescription>;
};

export type CustomBookingField = {
  __typename?: 'CustomBookingField';
  /**
   * Unused. Widget and portal booking forms do not collect custom PMS fields.
   * @deprecated Unused. Not read by booking. Retained for backwards-compat only.
   */
  booking_description?: Maybe<Scalars['String']['output']>;
  /**
   * Unused. Widget and portal booking forms do not collect custom PMS fields.
   * @deprecated Unused. Not read by booking. Retained for backwards-compat only.
   */
  booking_label?: Maybe<Scalars['String']['output']>;
  /** Value written to ezyVet; optional fields are omitted unless this is set. */
  default_value?: Maybe<Scalars['String']['output']>;
  /**
   * Unused. Widget and portal booking forms do not collect custom PMS fields.
   * @deprecated Unused. Not read by booking. Retained for backwards-compat only.
   */
  include_in_booking_form?: Maybe<Scalars['Boolean']['output']>;
  /** When true, ezyVet write always sends default_value (or "N/A" if unset). */
  is_required: Scalars['Boolean']['output'];
  /** ezyVet tag-category name written on create. */
  name: Scalars['String']['output'];
  /** ezyVet custom-field / tag-category id written on create. */
  pms_id: Scalars['String']['output'];
};

export type CustomBookingFieldInput = {
  booking_description?: InputMaybe<Scalars['String']['input']>;
  booking_label?: InputMaybe<Scalars['String']['input']>;
  default_value?: InputMaybe<Scalars['String']['input']>;
  include_in_booking_form?: InputMaybe<Scalars['Boolean']['input']>;
  is_required: Scalars['Boolean']['input'];
  name: Scalars['String']['input'];
  pms_id: Scalars['String']['input'];
};

export type CustomRole = {
  __typename?: 'CustomRole';
  /** Normalised admin permissions (boolean per feature). Source of truth. */
  admin_permissions: AdminPermissions;
  clinic?: Maybe<Clinic>;
  clinic_group?: Maybe<ClinicGroup>;
  created_at: Scalars['Timestamp']['output'];
  description?: Maybe<Scalars['String']['output']>;
  id: Scalars['ID']['output'];
  is_active: Scalars['Boolean']['output'];
  is_default: Scalars['Boolean']['output'];
  name: Scalars['String']['output'];
  /** Legacy JSON-derived permissions list. Computed from the new admin_permissions row, kept for backwards compatibility. */
  permissions?: Maybe<Array<ClinicAdminPermission>>;
  updated_at: Scalars['Timestamp']['output'];
};

export type CustomTrackingProperties = {
  __typename?: 'CustomTrackingProperties';
  ClientInfoStep?: Maybe<Scalars['JSON']['output']>;
  Completion?: Maybe<Scalars['JSON']['output']>;
  LocationSelected?: Maybe<Scalars['JSON']['output']>;
  PatientInfoStep?: Maybe<Scalars['JSON']['output']>;
  ReviewStep?: Maybe<Scalars['JSON']['output']>;
  ServiceTypeStep?: Maybe<Scalars['JSON']['output']>;
  TimeSelectStep?: Maybe<Scalars['JSON']['output']>;
  VerificationStep?: Maybe<Scalars['JSON']['output']>;
  WidgetOpened?: Maybe<Scalars['JSON']['output']>;
};

export type CustomTrackingPropertiesInput = {
  ClientInfoStep?: InputMaybe<Scalars['JSON']['input']>;
  Completion?: InputMaybe<Scalars['JSON']['input']>;
  LocationSelected?: InputMaybe<Scalars['JSON']['input']>;
  PatientInfoStep?: InputMaybe<Scalars['JSON']['input']>;
  ReviewStep?: InputMaybe<Scalars['JSON']['input']>;
  ServiceTypeStep?: InputMaybe<Scalars['JSON']['input']>;
  TimeSelectStep?: InputMaybe<Scalars['JSON']['input']>;
  VerificationStep?: InputMaybe<Scalars['JSON']['input']>;
  WidgetOpened?: InputMaybe<Scalars['JSON']['input']>;
};

export type CustomerInfoInput = {
  email: Scalars['String']['input'];
  first_name: Scalars['String']['input'];
  last_name: Scalars['String']['input'];
  phone: Scalars['String']['input'];
};

export type CustomerSegment = {
  __typename?: 'CustomerSegment';
  all_inclusions?: Maybe<Array<SegmentFilter>>;
  any_exclusions?: Maybe<Array<SegmentFilter>>;
  any_inclusions?: Maybe<Array<SegmentFilter>>;
  any_other_exclusions?: Maybe<Array<SegmentFilter>>;
  /** Owner: exactly one of clinic / clinic_group is set */
  clinic?: Maybe<Clinic>;
  /** Group-owned segments waterfall to linked clinics (see entity_links) */
  clinic_group?: Maybe<ClinicGroup>;
  created_at: Scalars['Timestamp']['output'];
  default_exclusions_options: DefaultExclusionsOptions;
  error_flags?: Maybe<Array<CustomerSegmentErrorFlag>>;
  excluded_clients?: Maybe<Array<Scalars['ID']['output']>>;
  excluded_filters: Array<CustomerSegmentFilter>;
  filters?: Maybe<Array<CustomerSegmentFilter>>;
  group_days_ahead?: Maybe<Scalars['NonNegativeInt']['output']>;
  id: Scalars['ID']['output'];
  included_clients?: Maybe<Array<Scalars['ID']['output']>>;
  is_archived: Scalars['Boolean']['output'];
  is_hourly?: Maybe<Scalars['Boolean']['output']>;
  name: Scalars['String']['output'];
  notification_templates?: Maybe<Array<NotificationTemplate>>;
  other_result_exclusion_entity?: Maybe<Scalars['String']['output']>;
  prevent_grouping_within_segment?: Maybe<Scalars['Boolean']['output']>;
  reference_date_params?: Maybe<ReferenceDateParams>;
  /** For PIMS Reminder notification audiences: also include all overdue reminders for matched patients */
  should_include_all_overdue?: Maybe<Scalars['Boolean']['output']>;
  trigger_entity?: Maybe<CustomerSegmentTrigger>;
  updated_at: Scalars['Timestamp']['output'];
};

export type CustomerSegmentErrorFlag = {
  __typename?: 'CustomerSegmentErrorFlag';
  filter_column: Scalars['String']['output'];
  filter_index: Scalars['NonNegativeInt']['output'];
  message: Scalars['String']['output'];
  parameter_index: Scalars['NonNegativeInt']['output'];
};

export type CustomerSegmentErrorFlagInput = {
  filter_column: Scalars['String']['input'];
  filter_index: Scalars['NonNegativeInt']['input'];
  message: Scalars['String']['input'];
  parameter_index: Scalars['NonNegativeInt']['input'];
};

export type CustomerSegmentFilter = {
  __typename?: 'CustomerSegmentFilter';
  filters: Array<QueryFilter>;
  only_consider_other_rows?: Maybe<Scalars['Boolean']['output']>;
  type: CustomerSegmentFilterType;
};

export type CustomerSegmentFilterInput = {
  filters: Array<QueryInput>;
  only_consider_other_rows?: InputMaybe<Scalars['Boolean']['input']>;
  type: CustomerSegmentFilterType;
};

export enum CustomerSegmentFilterType {
  Appointment = 'Appointment',
  History = 'History',
  Prescription = 'Prescription'
}

export type CustomerSegmentSearchInput = {
  search_field?: InputMaybe<Scalars['String']['input']>;
  search_value?: InputMaybe<Scalars['String']['input']>;
};

export enum CustomerSegmentTrigger {
  Appointment = 'Appointment',
  BookingSessions = 'BookingSessions',
  ClientPatients = 'ClientPatients',
  Clients = 'Clients',
  LeadContacts = 'LeadContacts',
  PimsReminder = 'PimsReminder',
  Prescription = 'Prescription'
}

export type DailyHuddle = {
  __typename?: 'DailyHuddle';
  attendees?: Maybe<Array<Clinician>>;
  clinic: Clinic;
  created_at: Scalars['Timestamp']['output'];
  end_time?: Maybe<Scalars['NonNegativeInt']['output']>;
  id: Scalars['ID']['output'];
  leader?: Maybe<Clinician>;
  notes?: Maybe<Scalars['String']['output']>;
  start_time: Scalars['NonNegativeInt']['output'];
  updated_at: Scalars['Timestamp']['output'];
};

export type DataChat = {
  __typename?: 'DataChat';
  clinic: Clinic;
  created_at: Scalars['Timestamp']['output'];
  data_chat_prompts: Array<DataChatPrompt>;
  id: Scalars['ID']['output'];
  is_archived: Scalars['Boolean']['output'];
  last_prompt_message?: Maybe<Scalars['String']['output']>;
  name?: Maybe<Scalars['String']['output']>;
  updated_at: Scalars['Timestamp']['output'];
};

export type DataChatAdditionalInfo = {
  __typename?: 'DataChatAdditionalInfo';
  name: Scalars['String']['output'];
  value: Scalars['String']['output'];
};

export type DataChatPrompt = {
  __typename?: 'DataChatPrompt';
  created_at: Scalars['Timestamp']['output'];
  data_chat: DataChat;
  generated_query?: Maybe<Scalars['String']['output']>;
  id: Scalars['ID']['output'];
  prompt: Scalars['String']['output'];
  response_data?: Maybe<Array<DataChatResponseRow>>;
  response_message: Scalars['String']['output'];
  updated_at: Scalars['Timestamp']['output'];
};

export type DataChatPromptInput = {
  data_chat: Scalars['ID']['input'];
  prompt: Scalars['String']['input'];
};

export type DataChatResponseRow = {
  __typename?: 'DataChatResponseRow';
  additional_info?: Maybe<Array<DataChatAdditionalInfo>>;
  appointment?: Maybe<Appointment>;
  breed?: Maybe<Breed>;
  client?: Maybe<Client>;
  clinic_species?: Maybe<ClinicSpecies>;
  clinician?: Maybe<Clinician>;
  invoice?: Maybe<Invoice>;
  invoice_item?: Maybe<InvoiceItem>;
  patient?: Maybe<Patient>;
  service?: Maybe<Service>;
};

export enum DayOfWeek {
  Friday = 'Friday',
  Monday = 'Monday',
  Saturday = 'Saturday',
  Sunday = 'Sunday',
  Thursday = 'Thursday',
  Tuesday = 'Tuesday',
  Wednesday = 'Wednesday'
}

/**
 * Opt-out flags for platform default appointment exclusions.
 * Missing key = platform default (on). Explicit false turns that bucket off.
 * Injected at query time; not stored as any_exclusions rows.
 */
export type DefaultExclusionsOptions = {
  __typename?: 'DefaultExclusionsOptions';
  /** Clinician / room / service / appt-type names matching Cancel or Reschedule. Default true. */
  exclude_cancelled_and_rescheduled_resources?: Maybe<Scalars['Boolean']['output']>;
  /** Clinic and client notes matching euthanasia / QOL / quality of life. Default true. */
  exclude_euthanasia_and_qol_in_appt_notes?: Maybe<Scalars['Boolean']['output']>;
  /** Clinician / room / service / appt-type names matching euthanasia or QOL. Default true. */
  exclude_euthanasia_and_qol_resources?: Maybe<Scalars['Boolean']['output']>;
};

export type DefaultExclusionsOptionsInput = {
  exclude_cancelled_and_rescheduled_resources?: InputMaybe<Scalars['Boolean']['input']>;
  exclude_euthanasia_and_qol_in_appt_notes?: InputMaybe<Scalars['Boolean']['input']>;
  exclude_euthanasia_and_qol_resources?: InputMaybe<Scalars['Boolean']['input']>;
};

export type Diagnosis = {
  __typename?: 'Diagnosis';
  clinic: Clinic;
  created_at: Scalars['Timestamp']['output'];
  description?: Maybe<Scalars['String']['output']>;
  id: Scalars['ID']['output'];
  name: Scalars['String']['output'];
  pms_id: Scalars['String']['output'];
  updated_at: Scalars['Timestamp']['output'];
};

export type DisabledFeatures = {
  __typename?: 'DisabledFeatures';
  is_appt_cancellation_disabled?: Maybe<Scalars['Boolean']['output']>;
  is_appt_confirmation_disabled?: Maybe<Scalars['Boolean']['output']>;
  is_appt_rescheduling_disabled?: Maybe<Scalars['Boolean']['output']>;
  is_client_assignment_disabled?: Maybe<Scalars['Boolean']['output']>;
};

export type DrilldownEntityFilter = {
  entity_id: Scalars['ID']['input'];
  table: Scalars['String']['input'];
};

export type DrilldownRow = {
  __typename?: 'DrilldownRow';
  appointment?: Maybe<Appointment>;
  client?: Maybe<Client>;
  clinician?: Maybe<Clinician>;
  invoice?: Maybe<Invoice>;
  invoice_item?: Maybe<InvoiceItem>;
  patient?: Maybe<Patient>;
};

export type EmailCustomerSegmentCsvInput = {
  customFileName?: InputMaybe<Scalars['String']['input']>;
  customerSegmentId: Scalars['ID']['input'];
  emails: Array<Scalars['String']['input']>;
  includeAppointmentInfo?: InputMaybe<Scalars['Boolean']['input']>;
  includeClientInfo?: InputMaybe<Scalars['Boolean']['input']>;
  includePatientInfo?: InputMaybe<Scalars['Boolean']['input']>;
};

export type EmailTemplate = {
  __typename?: 'EmailTemplate';
  clinic?: Maybe<Clinic>;
  clinic_group?: Maybe<ClinicGroup>;
  created_at: Scalars['NonNegativeInt']['output'];
  design?: Maybe<Scalars['JSON']['output']>;
  html?: Maybe<Scalars['String']['output']>;
  id: Scalars['ID']['output'];
  status: EmailTemplateStatus;
  subject?: Maybe<Scalars['String']['output']>;
  title: Scalars['String']['output'];
  updated_at: Scalars['NonNegativeInt']['output'];
};

export enum EmailTemplateStatus {
  Archived = 'Archived',
  Draft = 'Draft',
  Published = 'Published'
}

/**
 * One row of the enterprise onboarding report: a clinic in the group plus
 * the per-clinic rollups used to compare setup across the group. Settings
 * and feature flags are selected through `clinic { settings { ... }
 * features { ... } }`. Counts are computed server-side as grouped
 * aggregates, so rows stay cheap even for large groups.
 */
export type EnterpriseOnboardingClinicRow = {
  __typename?: 'EnterpriseOnboardingClinicRow';
  /**
   * Clinicians marked active in Chckvet, still active in the PIMS, and
   * assignable — the same default the Clinicians page shows.
   */
  active_clinicians_count: Scalars['NonNegativeInt']['output'];
  /**
   * Rooms with is_active = true — the same default the Rooms page shows.
   * Clinics that schedule on rooms (not clinicians) need this populated.
   */
  active_rooms_count: Scalars['NonNegativeInt']['output'];
  /** Scheduling rules with is_active = true. */
  active_scheduling_rules_count: Scalars['NonNegativeInt']['output'];
  /** Services with is_active = true (the bookable set). */
  active_services_count: Scalars['NonNegativeInt']['output'];
  /** Non-deleted, non-time-block appointments starting in the past 7 days. */
  appointments_last_7_days_count: Scalars['NonNegativeInt']['output'];
  audiences_linked_count: Scalars['NonNegativeInt']['output'];
  audiences_unlinked_count: Scalars['NonNegativeInt']['output'];
  clinic: Clinic;
  email_templates_linked_count: Scalars['NonNegativeInt']['output'];
  email_templates_unlinked_count: Scalars['NonNegativeInt']['output'];
  forms_linked_count: Scalars['NonNegativeInt']['output'];
  forms_unlinked_count: Scalars['NonNegativeInt']['output'];
  message_templates_linked_count: Scalars['NonNegativeInt']['output'];
  message_templates_unlinked_count: Scalars['NonNegativeInt']['output'];
  notifications_linked_count: Scalars['NonNegativeInt']['output'];
  notifications_unlinked_count: Scalars['NonNegativeInt']['output'];
  /**
   * Clinic-settings fields this clinic has opted out of the group
   * waterfall. Empty when the clinic has no settings link or hasn't
   * unlinked anything. Used to catch locations that share messaging but
   * customized branding (banners, emojis, colours).
   */
  settings_unlinked_fields: Array<Scalars['String']['output']>;
  /**
   * The clinic's chosen option per onboarding step for the requested
   * group: { [stepKey]: chosenOption }. Steps without a chosen option are
   * absent.
   */
  step_statuses: Scalars['JSON']['output'];
};

/**
 * One of a clinic's entities in the report's drilldown, with whether it is
 * standardized from the clinic group (actively linked to a group-level
 * parent) or clinic-specific.
 */
export type EnterpriseOnboardingEntity = {
  __typename?: 'EnterpriseOnboardingEntity';
  id: Scalars['ID']['output'];
  is_standardized: Scalars['Boolean']['output'];
  name: Scalars['String']['output'];
};

export type EnterpriseOnboardingReport = {
  __typename?: 'EnterpriseOnboardingReport';
  /**
   * Per-cell notes across the whole group, not just the rows returned, so
   * the dashboard can show them wherever they apply.
   */
  cell_notes: Array<ClinicGroupOnboardingCellNote>;
  clinic_group_id: Scalars['ID']['output'];
  /**
   * Per-column scoring setup for the whole group. Group state rather than a
   * per-browser preference, so the Aligned score means the same thing to
   * everyone looking at it.
   */
  column_config: Array<ClinicGroupOnboardingColumnConfig>;
  /**
   * Merge tag names the group expects every clinic to fill in. The report
   * shows a column per expected tag even when no clinic has set it, which
   * inferring the list from the clinics alone can't do.
   */
  expected_merge_tags: Array<Scalars['String']['output']>;
  /**
   * One row per non-archived clinic in scope, sorted by clinic name. Scope
   * is the whole group unless `tranche_key` narrowed it.
   */
  rows: Array<EnterpriseOnboardingClinicRow>;
  /** The group's onboarding step definitions, in display order. */
  steps: Array<ClinicGroupOnboardingStep>;
  /**
   * Every rollout cohort in the group, regardless of which one was
   * requested, so the dashboard can render the tranche selector without a
   * second query.
   */
  tranches: Array<ClinicGroupOnboardingTranche>;
};

export type EnterpriseOnboardingSetupEntity = {
  __typename?: 'EnterpriseOnboardingSetupEntity';
  id: Scalars['ID']['output'];
  name: Scalars['String']['output'];
};

/**
 * Setup entities the onboarding report can expand into a per-clinic list.
 * These aren't group-standardized via entity_links — the report only
 * counts "active" ones — so the drilldown is just id + display name.
 */
export enum EnterpriseOnboardingSetupKind {
  Clinician = 'Clinician',
  Room = 'Room',
  SchedulingRule = 'SchedulingRule',
  Service = 'Service'
}

/**
 * A link between a group-level parent entity and a clinic-level child copy
 * (see the entity_links table). While the link is active (unlinked_at null)
 * the parent's content waterfalls to the child on every update, except for
 * fields listed in unlinked_fields. Unlinked links are kept as history so
 * the group level can surface "previously but no longer linked" clinics.
 */
export type EntityLink = {
  __typename?: 'EntityLink';
  /** The clinic-level child entity's id (null if the child was deleted) */
  child_id?: Maybe<Scalars['ID']['output']>;
  clinic: Scalars['ID']['output'];
  created_at: Scalars['NonNegativeInt']['output'];
  entity_type: EntityLinkType;
  id: Scalars['ID']['output'];
  /** The group-level parent entity's id */
  parent_id: Scalars['ID']['output'];
  unlinked_at?: Maybe<Scalars['NonNegativeInt']['output']>;
  unlinked_by?: Maybe<Scalars['ID']['output']>;
  /** Child fields opted out of the waterfall (field-level unlink) */
  unlinked_fields: Array<Scalars['String']['output']>;
  updated_at: Scalars['NonNegativeInt']['output'];
};

/**
 * Per-parent drill-down for a clinic's coverage of one shared entity —
 * includes partial-link field opt-outs when status is linked.
 */
export type EntityLinkCoverageDetail = {
  __typename?: 'EntityLinkCoverageDetail';
  child_id?: Maybe<Scalars['ID']['output']>;
  entity_type: EntityLinkType;
  parent_id: Scalars['ID']['output'];
  parent_name: Scalars['String']['output'];
  status: EntityLinkCoverageStatus;
  unlinked_fields: Array<Scalars['String']['output']>;
};

export enum EntityLinkCoverageStatus {
  Linked = 'linked',
  Never = 'never',
  Unlinked = 'unlinked'
}

/** A named bundle of governed fields for opt-in settings linking. */
export type EntityLinkFieldCategory = {
  __typename?: 'EntityLinkFieldCategory';
  fields: Array<Scalars['String']['output']>;
  key: Scalars['String']['output'];
  label: Scalars['String']['output'];
};

/**
 * The static link policy for one entity type, mirroring the server-side
 * entity-link config. Drives the clinic-side UI: which inputs to lock on a
 * linked child, which may be edited without unlinking, and which FK fields
 * are remapped to the clinic's own linked copies.
 */
export type EntityLinkFieldPolicy = {
  __typename?: 'EntityLinkFieldPolicy';
  entity_type: EntityLinkType;
  /**
   * All fields governed by the link: copied from the group parent on every
   * update while linked (unless individually opted out). Includes the
   * remapped FK fields.
   */
  governed_fields: Array<Scalars['String']['output']>;
  /**
   * Named field bundles for the clinic-side customize / settings UI.
   * Clinic settings use these for category-scoped linking; audiences use
   * them to customize Filters as one unit (inclusions + exclusions) rather
   * than each column. Email templates and notifications bundle Unlayer
   * columns (design + HTML / email body + design + HTML) as "Email main
   * content", and notifications also bundle postcard front + back.
   * Empty when the type exposes individual fields.
   */
  link_categories: Array<EntityLinkFieldCategory>;
  /**
   * Governed fields a clinic may edit on a LINKED child without unlinking
   * it — the edit succeeds and the field opts out of the waterfall.
   */
  locally_assignable_fields: Array<Scalars['String']['output']>;
  /**
   * FK fields whose group-level value is resolved to the clinic's own
   * linked copy of the referenced entity when waterfalling.
   */
  remapped_fields: Array<Scalars['String']['output']>;
  /**
   * Whether children unlink field-by-field instead of as a whole entity
   * (clinic settings). The UI should not offer whole-entity unlink here.
   */
  unlinks_per_field: Scalars['Boolean']['output'];
};

/**
 * Group-level rollup for one parent entity: how many clinics are actively
 * linked / previously linked, and which group clinics were never linked
 * (candidates for populateEntityLinkChildren).
 */
export type EntityLinkSummary = {
  __typename?: 'EntityLinkSummary';
  linked_count: Scalars['NonNegativeInt']['output'];
  never_linked_clinic_ids: Array<Scalars['ID']['output']>;
  unlinked_count: Scalars['NonNegativeInt']['output'];
};

export enum EntityLinkType {
  ClinicSettings = 'ClinicSettings',
  CustomRole = 'CustomRole',
  CustomerSegment = 'CustomerSegment',
  EmailTemplate = 'EmailTemplate',
  Form = 'Form',
  MessageTemplate = 'MessageTemplate',
  NotificationTemplate = 'NotificationTemplate',
  ScheduledBulkMessage = 'ScheduledBulkMessage'
}

/**
 * Linked / unlinked counts for one entity type on one clinic, relative to
 * how many group-owned parents of that type exist.
 */
export type EntityLinkTypeCoverage = {
  __typename?: 'EntityLinkTypeCoverage';
  entity_type: EntityLinkType;
  linked_count: Scalars['NonNegativeInt']['output'];
  parent_count: Scalars['NonNegativeInt']['output'];
  unlinked_count: Scalars['NonNegativeInt']['output'];
};

export enum EntityOrigin {
  ChckupAiTool = 'ChckupAiTool',
  ChckupDashboard = 'ChckupDashboard',
  ChckupWebsite = 'ChckupWebsite',
  ChckupWidget = 'ChckupWidget',
  Other = 'Other',
  Pms = 'PMS'
}

export type EntityReport = {
  __typename?: 'EntityReport';
  clinic?: Maybe<Clinic>;
  clinician?: Maybe<Clinician>;
  created_at: Scalars['Timestamp']['output'];
  entity_reports: Array<EntityReport>;
  entity_type: ReportEntityType;
  id: Scalars['ID']['output'];
  organization_report: OrganizationReport;
  parent_report?: Maybe<EntityReport>;
  product?: Maybe<Product>;
  service?: Maybe<Service>;
  updated_at: Scalars['Timestamp']['output'];
  values: Array<ReportValue>;
};

export type ExecuteApprovedChangeInput = {
  captured_before: Scalars['JSON']['input'];
  /** Required for create. Optional for update. */
  clinic_id?: InputMaybe<Scalars['ID']['input']>;
  /** Defaults to update when omitted. */
  operation?: InputMaybe<ProposedChangeOperation>;
  patch: Scalars['JSON']['input'];
  /** Required for update; omit for create. */
  target_entity_id?: InputMaybe<Scalars['ID']['input']>;
  target_entity_type: Scalars['String']['input'];
};

export type ExecuteApprovedChangeResult = {
  __typename?: 'ExecuteApprovedChangeResult';
  applied_fields: Array<Scalars['String']['output']>;
  message: Scalars['String']['output'];
  operation: ProposedChangeOperation;
  success: Scalars['Boolean']['output'];
  /** Updated entity id, or the newly created entity id. */
  target_entity_id: Scalars['ID']['output'];
  target_entity_type: Scalars['String']['output'];
};

export enum EzyvetIntegrationMode {
  Api = 'API',
  ApiWithAddons = 'APIWithAddons',
  Legacy = 'Legacy'
}

export type Family = {
  __typename?: 'Family';
  created_at: Scalars['Timestamp']['output'];
  id: Scalars['ID']['output'];
  name?: Maybe<Scalars['String']['output']>;
  pets?: Maybe<Array<Pet>>;
  updated_at: Scalars['Timestamp']['output'];
  users?: Maybe<Array<User>>;
};

export type FeaturedReview = {
  __typename?: 'FeaturedReview';
  order: Scalars['NonNegativeInt']['output'];
  review: Review;
};

export type FeaturedReviewInput = {
  order: Scalars['NonNegativeInt']['input'];
  review: Scalars['ID']['input'];
};

export type FillRateResult = {
  __typename?: 'FillRateResult';
  clinic_id?: Maybe<Scalars['ID']['output']>;
  clinician_id?: Maybe<Scalars['ID']['output']>;
  fill_rate: Scalars['Float']['output'];
  open_minutes: Scalars['NonNegativeInt']['output'];
  room_id?: Maybe<Scalars['ID']['output']>;
  true_open_minutes?: Maybe<Scalars['NonNegativeInt']['output']>;
  working_minutes: Scalars['NonNegativeInt']['output'];
};

export type FilterAppointmentInput = {
  clinicId?: InputMaybe<Scalars['ID']['input']>;
  page?: InputMaybe<Scalars['NonNegativeInt']['input']>;
  pageSize?: InputMaybe<Scalars['NonNegativeInt']['input']>;
  petId?: InputMaybe<Scalars['ID']['input']>;
  queryString?: InputMaybe<Scalars['String']['input']>;
  status?: InputMaybe<AppointmentStatus>;
};

export enum FilterOp {
  Adj = 'adj',
  Cd = 'cd',
  Cs = 'cs',
  Dow = 'dow',
  Eq = 'eq',
  Fts = 'fts',
  Gt = 'gt',
  Gte = 'gte',
  Ilike = 'ilike',
  In = 'in',
  Is = 'is',
  Like = 'like',
  Lt = 'lt',
  Lte = 'lte',
  Neq = 'neq',
  Nxl = 'nxl',
  Nxr = 'nxr',
  On = 'on',
  Ov = 'ov',
  Phfts = 'phfts',
  Plfts = 'plfts',
  Sl = 'sl',
  Sr = 'sr',
  Wfts = 'wfts'
}

export enum FixedStatus {
  Fixed = 'Fixed',
  Intact = 'Intact',
  Unknown = 'Unknown'
}

export type FloatPercentile = {
  __typename?: 'FloatPercentile';
  percentile: Scalars['Float']['output'];
  value: Scalars['Float']['output'];
};

export type FollowUpSettings = {
  __typename?: 'FollowUpSettings';
  days_until_next_appt?: Maybe<Scalars['NonNegativeInt']['output']>;
  parent?: Maybe<Service>;
  step_number?: Maybe<Scalars['NonNegativeInt']['output']>;
};

export type Form = {
  __typename?: 'Form';
  /** Owner: exactly one of clinic / clinic_group is set */
  clinic?: Maybe<Clinic>;
  /** Group-owned forms waterfall to linked clinics (see entity_links) */
  clinic_group?: Maybe<ClinicGroup>;
  created_at: Scalars['Timestamp']['output'];
  does_require_client: Scalars['Boolean']['output'];
  does_require_patient: Scalars['Boolean']['output'];
  form_fields: FormFields;
  form_file_naming_template?: Maybe<Scalars['String']['output']>;
  form_type: FormType;
  id: Scalars['ID']['output'];
  is_active: Scalars['Boolean']['output'];
  is_archived: Scalars['Boolean']['output'];
  is_public: Scalars['Boolean']['output'];
  is_using_pdf: Scalars['Boolean']['output'];
  /** When true, completed submissions of this form are written back into the PMS (clinic writeback must also be enabled). */
  is_writeback_enabled: Scalars['Boolean']['output'];
  name?: Maybe<Scalars['String']['output']>;
  pdf_schema?: Maybe<Scalars['JSON']['output']>;
  pdf_url?: Maybe<Scalars['String']['output']>;
  updated_at: Scalars['Timestamp']['output'];
  /** Short code for the above (e.g. "PPW"), stored for display only. */
  writeback_code_name?: Maybe<Scalars['String']['output']>;
  /**
   * PMS line item code stamped on this form's writeback (Bitwerx CodeId).
   * Null means the writeback carries no code, which is the existing behavior.
   */
  writeback_code_pms_id?: Maybe<Scalars['String']['output']>;
  writeback_to_strictest_entity: Scalars['Boolean']['output'];
};

/** Analytics for a form: form id, name, and per-field value aggregations for common-answer fields. */
export type FormAnalytics = {
  __typename?: 'FormAnalytics';
  field_analytics: Array<FormAnalyticsFieldResult>;
  form: Form;
};

/**
 * Analytics for one form field: element id, name, type, and aggregated value counts.
 * Only present for "common answer" types (SelectOne, SelectMultiple, Checkbox).
 */
export type FormAnalyticsFieldResult = {
  __typename?: 'FormAnalyticsFieldResult';
  element_id: Scalars['ID']['output'];
  element_name?: Maybe<Scalars['String']['output']>;
  type: FormElementType;
  value_counts: Array<FormFieldValueCount>;
};

export type FormAnalyticsParams = {
  from_date?: InputMaybe<Scalars['NonNegativeInt']['input']>;
  to_date?: InputMaybe<Scalars['NonNegativeInt']['input']>;
};

export type FormElement = {
  __typename?: 'FormElement';
  attachments?: Maybe<Array<FormFileAttachment>>;
  column_order?: Maybe<Scalars['Int']['output']>;
  content?: Maybe<Scalars['String']['output']>;
  field_updates?: Maybe<Array<FormFieldUpdate>>;
  id: Scalars['ID']['output'];
  is_required?: Maybe<Scalars['Boolean']['output']>;
  name?: Maybe<Scalars['String']['output']>;
  options?: Maybe<Array<Scalars['String']['output']>>;
  page_id?: Maybe<Scalars['ID']['output']>;
  row_order?: Maybe<Scalars['Int']['output']>;
  type?: Maybe<FormElementType>;
  value?: Maybe<Scalars['String']['output']>;
};

export type FormElementInput = {
  attachments?: InputMaybe<Array<FormFileAttachmentInput>>;
  column_order?: InputMaybe<Scalars['Int']['input']>;
  content?: InputMaybe<Scalars['String']['input']>;
  field_updates?: InputMaybe<Array<FormFieldUpdateInput>>;
  id: Scalars['ID']['input'];
  is_required?: InputMaybe<Scalars['Boolean']['input']>;
  name?: InputMaybe<Scalars['String']['input']>;
  options?: InputMaybe<Array<Scalars['String']['input']>>;
  page_id?: InputMaybe<Scalars['ID']['input']>;
  row_order?: InputMaybe<Scalars['Int']['input']>;
  type?: InputMaybe<FormElementType>;
  value?: InputMaybe<Scalars['String']['input']>;
};

export enum FormElementType {
  Checkbox = 'Checkbox',
  Column = 'Column',
  FileUpload = 'FileUpload',
  Form = 'Form',
  Header = 'Header',
  MediumHeader = 'MediumHeader',
  ParagraphAnswer = 'ParagraphAnswer',
  Row = 'Row',
  SelectMultiple = 'SelectMultiple',
  SelectOne = 'SelectOne',
  ShortAnswer = 'ShortAnswer',
  Signature = 'Signature',
  Subtitle = 'Subtitle'
}

/**
 * A side-effect applied to the client/patient record being created when this
 * form field is answered. These updates are only applied for booking-required
 * forms completed for NEW clients or NEW patients; updates to existing records
 * are not currently supported.
 *
 * - For boolean fields (PMS_SMS_ALLOWED, PMS_EMAIL_ALLOWED,
 *   CHCKVET_MARKETING_SMS_ALLOWED, CHCKVET_MARKETING_EMAIL_ALLOWED,
 *   and legacy CHCKVET_MARKETING_ALLOWED), `boolean_value` carries the value to write and
 *   `option` is the SelectOne / SelectMultiple option (matching one of the
 *   element's `options`) that triggers the update when selected.
 * - For string fields (PATIENT_COLOR), the value is taken from the form
 *   response text, so `boolean_value` is ignored and `option` is null
 *   (ShortAnswer / ParagraphAnswer elements).
 */
export type FormFieldUpdate = {
  __typename?: 'FormFieldUpdate';
  boolean_value?: Maybe<Scalars['Boolean']['output']>;
  field: FormFieldUpdateField;
  option?: Maybe<Scalars['String']['output']>;
};

/**
 * Client/patient record fields that a form answer can write back to when a
 * booking-required form is completed for a NEW client or NEW patient.
 * Boolean fields (PMS_SMS_ALLOWED, PMS_EMAIL_ALLOWED,
 * CHCKVET_MARKETING_SMS_ALLOWED, CHCKVET_MARKETING_EMAIL_ALLOWED,
 * and legacy CHCKVET_MARKETING_ALLOWED)
 * are eligible for SelectOne / SelectMultiple options; string fields
 * (PATIENT_COLOR) are eligible for ShortAnswer / ParagraphAnswer responses.
 */
export enum FormFieldUpdateField {
  ChckvetMarketingAllowed = 'CHCKVET_MARKETING_ALLOWED',
  ChckvetMarketingEmailAllowed = 'CHCKVET_MARKETING_EMAIL_ALLOWED',
  ChckvetMarketingSmsAllowed = 'CHCKVET_MARKETING_SMS_ALLOWED',
  PatientColor = 'PATIENT_COLOR',
  PmsEmailAllowed = 'PMS_EMAIL_ALLOWED',
  PmsSmsAllowed = 'PMS_SMS_ALLOWED'
}

export type FormFieldUpdateInput = {
  boolean_value?: InputMaybe<Scalars['Boolean']['input']>;
  field: FormFieldUpdateField;
  option?: InputMaybe<Scalars['String']['input']>;
};

/** A single value and its response count for form analytics (e.g. SelectOne / Checkbox / SelectMultiple). */
export type FormFieldValueCount = {
  __typename?: 'FormFieldValueCount';
  count: Scalars['NonNegativeInt']['output'];
  value: Scalars['String']['output'];
};

export type FormFields = {
  __typename?: 'FormFields';
  fields?: Maybe<Array<FormElement>>;
  pages?: Maybe<Array<FormPage>>;
  version?: Maybe<Scalars['Int']['output']>;
};

export type FormFieldsInput = {
  fields?: InputMaybe<Array<FormElementInput>>;
  pages?: InputMaybe<Array<FormPageInput>>;
  version?: InputMaybe<Scalars['Int']['input']>;
};

export type FormFileAttachment = {
  __typename?: 'FormFileAttachment';
  filename?: Maybe<Scalars['String']['output']>;
  id?: Maybe<Scalars['ID']['output']>;
  mime_type?: Maybe<Scalars['String']['output']>;
  size_bytes?: Maybe<Scalars['NonNegativeInt']['output']>;
  thumbnail_url?: Maybe<Scalars['String']['output']>;
  url: Scalars['String']['output'];
};

export type FormFileAttachmentInput = {
  filename?: InputMaybe<Scalars['String']['input']>;
  id?: InputMaybe<Scalars['ID']['input']>;
  mime_type?: InputMaybe<Scalars['String']['input']>;
  size_bytes?: InputMaybe<Scalars['NonNegativeInt']['input']>;
  thumbnail_url?: InputMaybe<Scalars['String']['input']>;
  url: Scalars['String']['input'];
};

export type FormPage = {
  __typename?: 'FormPage';
  description?: Maybe<Scalars['String']['output']>;
  id: Scalars['ID']['output'];
  order?: Maybe<Scalars['Int']['output']>;
  title?: Maybe<Scalars['String']['output']>;
};

export type FormPageInput = {
  description?: InputMaybe<Scalars['String']['input']>;
  id: Scalars['ID']['input'];
  order?: InputMaybe<Scalars['Int']['input']>;
  title?: InputMaybe<Scalars['String']['input']>;
};

export enum FormType {
  Client = 'Client',
  Patient = 'Patient'
}

export type GaEventNameOverrides = {
  __typename?: 'GAEventNameOverrides';
  ClientInfoStep?: Maybe<Scalars['String']['output']>;
  Completion?: Maybe<Scalars['String']['output']>;
  LocationSelected?: Maybe<Scalars['String']['output']>;
  PatientInfoStep?: Maybe<Scalars['String']['output']>;
  ReviewStep?: Maybe<Scalars['String']['output']>;
  ServiceTypeStep?: Maybe<Scalars['String']['output']>;
  TimeSelectStep?: Maybe<Scalars['String']['output']>;
  VerificationStep?: Maybe<Scalars['String']['output']>;
  WidgetOpened?: Maybe<Scalars['String']['output']>;
};

export type GaEventNameOverridesInput = {
  ClientInfoStep?: InputMaybe<Scalars['String']['input']>;
  Completion?: InputMaybe<Scalars['String']['input']>;
  LocationSelected?: InputMaybe<Scalars['String']['input']>;
  PatientInfoStep?: InputMaybe<Scalars['String']['input']>;
  ReviewStep?: InputMaybe<Scalars['String']['input']>;
  ServiceTypeStep?: InputMaybe<Scalars['String']['input']>;
  TimeSelectStep?: InputMaybe<Scalars['String']['input']>;
  VerificationStep?: InputMaybe<Scalars['String']['input']>;
  WidgetOpened?: InputMaybe<Scalars['String']['input']>;
};

export type GetDrilldownEntitiesParams = {
  clinic_ids: Array<Scalars['ID']['input']>;
  entity_filters: Array<DrilldownEntityFilter>;
  from_date?: InputMaybe<Scalars['NonNegativeInt']['input']>;
  orderBy?: InputMaybe<OrderByInput>;
  page?: InputMaybe<Scalars['NonNegativeInt']['input']>;
  pageSize?: InputMaybe<Scalars['NonNegativeInt']['input']>;
  to_date?: InputMaybe<Scalars['NonNegativeInt']['input']>;
  unique_patients?: InputMaybe<Scalars['Boolean']['input']>;
};

export type GetTimeSlotForSchedulingDaysParams = {
  client_id?: InputMaybe<Scalars['ID']['input']>;
  clinic_species_id: Scalars['ID']['input'];
  clinician_preference_id?: InputMaybe<Array<Scalars['ID']['input']>>;
  duration_in_minutes: Scalars['NonNegativeInt']['input'];
  fixed_status?: InputMaybe<FixedStatus>;
  from_date: Scalars['NonNegativeInt']['input'];
  is_for_reschedule?: InputMaybe<Scalars['Boolean']['input']>;
  is_new_client?: InputMaybe<Scalars['Boolean']['input']>;
  is_new_patient: Scalars['Boolean']['input'];
  /** Optional overrides to bypass scheduling constraints. */
  overrides?: InputMaybe<AvailabilityOverrides>;
  patient_gender?: InputMaybe<AnimalGender>;
  patient_id?: InputMaybe<Scalars['ID']['input']>;
  room_id?: InputMaybe<Scalars['ID']['input']>;
  service_ids?: InputMaybe<Array<Scalars['ID']['input']>>;
  to_date: Scalars['NonNegativeInt']['input'];
  widget_id?: InputMaybe<Scalars['ID']['input']>;
};

export enum GoLiveCheckCode {
  ApptTypeNoPrimaryService = 'ApptTypeNoPrimaryService',
  BookingHoursMissing = 'BookingHoursMissing',
  ClinicHoursMissing = 'ClinicHoursMissing',
  ClinicianDuplicateActive = 'ClinicianDuplicateActive',
  ClinicianInactiveInPims = 'ClinicianInactiveInPims',
  ClinicianNoHours = 'ClinicianNoHours',
  CommsWritebackOff = 'CommsWritebackOff',
  ContentHardcodedClientDetail = 'ContentHardcodedClientDetail',
  ContentOtherClinicDetail = 'ContentOtherClinicDetail',
  ContentPlaceholderNotReplaced = 'ContentPlaceholderNotReplaced',
  ContentReviewIncomplete = 'ContentReviewIncomplete',
  ContentVendorBranding = 'ContentVendorBranding',
  DefaultExclusionOptedOut = 'DefaultExclusionOptedOut',
  FormFilledInAnswer = 'FormFilledInAnswer',
  FormSubmissionLeftovers = 'FormSubmissionLeftovers',
  FormWritebackOff = 'FormWritebackOff',
  InClinicStatusMappedAsOpen = 'InClinicStatusMappedAsOpen',
  NoAppointmentStatusesSynced = 'NoAppointmentStatusesSynced',
  NoBookingAlertRecipients = 'NoBookingAlertRecipients',
  NoCancelledStatusMapping = 'NoCancelledStatusMapping',
  NoLiveNotifications = 'NoLiveNotifications',
  NoStaffUsers = 'NoStaffUsers',
  NotificationArchivedAudience = 'NotificationArchivedAudience',
  NotificationInPreview = 'NotificationInPreview',
  NotificationNoAudience = 'NotificationNoAudience',
  PlanningGuidesIgnored = 'PlanningGuidesIgnored',
  PmsAvailabilityOff = 'PmsAvailabilityOff',
  PublishedPhoneNotTextable = 'PublishedPhoneNotTextable',
  SendFromEmailMissing = 'SendFromEmailMissing',
  SendFromPhoneNotCanonical = 'SendFromPhoneNotCanonical',
  SendFromPhoneShared = 'SendFromPhoneShared',
  ServiceApptTypeInactive = 'ServiceApptTypeInactive',
  ServiceApptTypePlaceholder = 'ServiceApptTypePlaceholder',
  ServiceNoApptType = 'ServiceNoApptType',
  TextingNumberCannotSms = 'TextingNumberCannotSms',
  TextingNumberNotOnTwilio = 'TextingNumberNotOnTwilio',
  TextingRepliesNotRouted = 'TextingRepliesNotRouted'
}

export enum GoLiveCheckFamily {
  Availability = 'Availability',
  BookingWriteback = 'BookingWriteback',
  ClientContent = 'ClientContent',
  PhoneEmail = 'PhoneEmail',
  ReminderTargeting = 'ReminderTargeting',
  RemindersOn = 'RemindersOn',
  ServicesResources = 'ServicesResources',
  Staff = 'Staff'
}

/**
 * One problem the go-live check found. Deterministic: the same config always
 * produces the same findings, except ContentReview probe findings, which come
 * from a model and should be confirmed before fixing.
 */
export type GoLiveCheckFinding = {
  __typename?: 'GoLiveCheckFinding';
  code: GoLiveCheckCode;
  entity_id?: Maybe<Scalars['ID']['output']>;
  entity_name?: Maybe<Scalars['String']['output']>;
  /** Table of the entity the finding is about (e.g. notification_templates). Null for clinic-wide findings. */
  entity_type?: Maybe<Scalars['String']['output']>;
  /** Small structured details (ids, counts, values) backing the finding. */
  evidence?: Maybe<Scalars['JSON']['output']>;
  family: GoLiveCheckFamily;
  /** Column the finding is about, when it is about one field. */
  field?: Maybe<Scalars['String']['output']>;
  /** How to fix it, including whether buildProposedChange can propose the fix. */
  propose_hint?: Maybe<Scalars['String']['output']>;
  severity: GoLiveCheckSeverity;
  /** Plain-language explanation of what goes wrong for the clinic or its clients. */
  why: Scalars['String']['output'];
};

export enum GoLiveCheckProbe {
  ContentReview = 'ContentReview',
  TextingRoute = 'TextingRoute'
}

/** How one requested probe went. Findings from a Failed probe are missing, not clean. */
export type GoLiveCheckProbeRun = {
  __typename?: 'GoLiveCheckProbeRun';
  /** Why it was skipped or failed. */
  detail?: Maybe<Scalars['String']['output']>;
  probe: GoLiveCheckProbe;
  status: GoLiveCheckProbeStatus;
};

export enum GoLiveCheckProbeStatus {
  Failed = 'Failed',
  Ran = 'Ran',
  Skipped = 'Skipped'
}

export enum GoLiveCheckSeverity {
  Blocker = 'Blocker',
  Info = 'Info',
  Warning = 'Warning'
}

/**
 * Rows the check read, so an empty findings list can be told apart from a
 * clinic with nothing set up.
 */
export type GoLiveCheckSourcesScanned = {
  __typename?: 'GoLiveCheckSourcesScanned';
  active_forms: Scalars['NonNegativeInt']['output'];
  appointment_statuses: Scalars['NonNegativeInt']['output'];
  /**
   * Templates, forms, message snippets and email designs whose client-facing
   * text was checked (ClientContent findings, and the ContentReview probe).
   */
  client_content: Scalars['NonNegativeInt']['output'];
  clinic_admins: Scalars['NonNegativeInt']['output'];
  clinicians: Scalars['NonNegativeInt']['output'];
  notification_templates: Scalars['NonNegativeInt']['output'];
  services: Scalars['NonNegativeInt']['output'];
};

export enum GoLiveSignal {
  GoLiveDate = 'GoLiveDate',
  SustainedOnlineBookings = 'SustainedOnlineBookings',
  SustainedReminderSends = 'SustainedReminderSends'
}

export type Goal = {
  __typename?: 'Goal';
  clinic: Clinic;
  created_at: Scalars['Timestamp']['output'];
  description?: Maybe<Scalars['String']['output']>;
  id: Scalars['ID']['output'];
  is_active?: Maybe<Scalars['Boolean']['output']>;
  is_chckup_modifier?: Maybe<Scalars['Boolean']['output']>;
  is_new_modifier?: Maybe<Scalars['Boolean']['output']>;
  is_system?: Maybe<Scalars['Boolean']['output']>;
  last_synced_time?: Maybe<Scalars['NonNegativeInt']['output']>;
  metric_current_amount: Scalars['NonNegativeInt']['output'];
  metric_entity: GoalEntity;
  metric_target_amount: Scalars['NonNegativeInt']['output'];
  metric_timespan: GoalTimespan;
  status: GoalStatus;
  updated_at: Scalars['Timestamp']['output'];
};

export enum GoalEntity {
  Appointments = 'Appointments',
  Clients = 'Clients',
  Patients = 'Patients',
  Revenue = 'Revenue'
}

export enum GoalStatus {
  Achieved = 'Achieved',
  Unreached = 'Unreached'
}

export enum GoalTimespan {
  Day = 'Day',
  Month = 'Month',
  Week = 'Week',
  Year = 'Year'
}

export type GroupedNotificationSegment = {
  notification_template: NotificationTemplateInput;
  segment_personalization: SegmentPersonalizationProperties;
};

export type HeartbeatResponse = {
  __typename?: 'HeartbeatResponse';
  last_ping: Scalars['NonNegativeInt']['output'];
  version: Scalars['String']['output'];
};

export type Initiative = {
  __typename?: 'Initiative';
  clinic?: Maybe<Clinic>;
  clinic_group?: Maybe<ClinicGroup>;
  created_at: Scalars['Timestamp']['output'];
  description?: Maybe<Scalars['String']['output']>;
  id: Scalars['ID']['output'];
  initiative_metrics: Array<InitiativeMetric>;
  is_archived: Scalars['Boolean']['output'];
  name: Scalars['String']['output'];
  organization?: Maybe<Organization>;
  start_time: Scalars['NonNegativeInt']['output'];
  updated_at: Scalars['Timestamp']['output'];
};

export type InitiativeMetric = {
  __typename?: 'InitiativeMetric';
  created_at: Scalars['Timestamp']['output'];
  id: Scalars['ID']['output'];
  initiative: Initiative;
  order?: Maybe<Scalars['Int']['output']>;
  report_metric: ReportMetric;
  updated_at: Scalars['Timestamp']['output'];
};

export type InitiativeMetricResult = {
  __typename?: 'InitiativeMetricResult';
  initiative_metric_segments: Array<InitiativeMetricSegment>;
  metric: InitiativeMetric;
};

export type InitiativeMetricSegment = {
  __typename?: 'InitiativeMetricSegment';
  time_range: TrendTimeRange;
  values: Array<Scalars['JSON']['output']>;
};

export type InitiativeResult = {
  __typename?: 'InitiativeResult';
  initiative_metric_results: Array<InitiativeMetricResult>;
  scope: TrendReportScope;
};

export type IntPercentile = {
  __typename?: 'IntPercentile';
  percentile: Scalars['Float']['output'];
  value: Scalars['NonNegativeInt']['output'];
};

export type InternalChat = {
  __typename?: 'InternalChat';
  clinic?: Maybe<Clinic>;
  clinicGroup?: Maybe<ClinicGroup>;
  created_at: Scalars['Timestamp']['output'];
  id: Scalars['ID']['output'];
  internal_chat_users: Array<InternalChatUser>;
  is_deleted: Scalars['Boolean']['output'];
  last_message?: Maybe<Scalars['String']['output']>;
  last_message_time: Scalars['NonNegativeInt']['output'];
  message_count: Scalars['NonNegativeInt']['output'];
  title?: Maybe<Scalars['String']['output']>;
  updated_at: Scalars['Timestamp']['output'];
};

export type InternalChatMessage = {
  __typename?: 'InternalChatMessage';
  created_at: Scalars['Timestamp']['output'];
  id: Scalars['ID']['output'];
  internal_chat: InternalChat;
  internal_chat_messages_attachments?: Maybe<Array<InternalChatMessageAttachment>>;
  sender: InternalChatUser;
  text: Scalars['String']['output'];
  updated_at: Scalars['Timestamp']['output'];
};

export type InternalChatMessageAttachment = {
  __typename?: 'InternalChatMessageAttachment';
  filename: Scalars['String']['output'];
  id: Scalars['ID']['output'];
  type: Scalars['String']['output'];
  url: Scalars['String']['output'];
};

export type InternalChatUser = {
  __typename?: 'InternalChatUser';
  created_at: Scalars['Timestamp']['output'];
  id: Scalars['ID']['output'];
  internal_chat: InternalChat;
  is_removed: Scalars['Boolean']['output'];
  last_message_time: Scalars['NonNegativeInt']['output'];
  last_read_time: Scalars['NonNegativeInt']['output'];
  unread_message_count: Scalars['NonNegativeInt']['output'];
  updated_at: Scalars['Timestamp']['output'];
  user: User;
};

export enum InternalUsageActionType {
  DailyHuddleClosed = 'DailyHuddleClosed',
  DailyHuddleConfirmedAppointmentsClosed = 'DailyHuddleConfirmedAppointmentsClosed',
  DailyHuddleConfirmedAppointmentsOpened = 'DailyHuddleConfirmedAppointmentsOpened',
  DailyHuddleExportToPdf = 'DailyHuddleExportToPDF',
  DailyHuddleForwardScheduleClosed = 'DailyHuddleForwardScheduleClosed',
  DailyHuddleForwardScheduleOpened = 'DailyHuddleForwardScheduleOpened',
  DailyHuddleOpenSlotClosed = 'DailyHuddleOpenSlotClosed',
  DailyHuddleOpenSlotOpened = 'DailyHuddleOpenSlotOpened',
  DailyHuddleOpened = 'DailyHuddleOpened',
  DailyHuddleOverduePaymentsClosed = 'DailyHuddleOverduePaymentsClosed',
  DailyHuddleOverduePaymentsOpened = 'DailyHuddleOverduePaymentsOpened',
  DailyHuddleTodayClosed = 'DailyHuddleTodayClosed',
  DailyHuddleTodayOpened = 'DailyHuddleTodayOpened',
  DailyHuddleTomorrowClosed = 'DailyHuddleTomorrowClosed',
  DailyHuddleTomorrowOpened = 'DailyHuddleTomorrowOpened',
  DailyHuddleUnconfirmedAppointmentsClosed = 'DailyHuddleUnconfirmedAppointmentsClosed',
  DailyHuddleUnconfirmedAppointmentsOpened = 'DailyHuddleUnconfirmedAppointmentsOpened',
  DailyHuddleYesterdayClosed = 'DailyHuddleYesterdayClosed',
  DailyHuddleYesterdayOpened = 'DailyHuddleYesterdayOpened',
  WidgetAppointmentBooked = 'WidgetAppointmentBooked',
  WidgetClientInfoStep = 'WidgetClientInfoStep',
  WidgetClosed = 'WidgetClosed',
  WidgetLocationSelected = 'WidgetLocationSelected',
  WidgetOpened = 'WidgetOpened',
  WidgetPatientInfoStep = 'WidgetPatientInfoStep',
  WidgetReviewStep = 'WidgetReviewStep',
  WidgetServiceTypeStep = 'WidgetServiceTypeStep',
  WidgetTimeSelectStep = 'WidgetTimeSelectStep',
  WidgetVerificationStep = 'WidgetVerificationStep'
}

export type InternalUsageEvent = {
  __typename?: 'InternalUsageEvent';
  action_type: InternalUsageActionType;
  clinic_id?: Maybe<Scalars['ID']['output']>;
  created_at: Scalars['Timestamp']['output'];
  id: Scalars['ID']['output'];
  instance_id?: Maybe<Scalars['ID']['output']>;
  metadata?: Maybe<Scalars['JSON']['output']>;
  updated_at: Scalars['Timestamp']['output'];
  user_id?: Maybe<Scalars['ID']['output']>;
  widget_id?: Maybe<Scalars['ID']['output']>;
};

export type InternalUsageEventFilters = {
  action_types?: InputMaybe<Array<InternalUsageActionType>>;
  clinic_id?: InputMaybe<Scalars['ID']['input']>;
  instance_id?: InputMaybe<Scalars['ID']['input']>;
  range: UsageTimeRangeInput;
  user_id?: InputMaybe<Scalars['ID']['input']>;
  widget_id?: InputMaybe<Scalars['ID']['input']>;
};

export type InternalUsageEventInput = {
  action_type: InternalUsageActionType;
  clinic_id?: InputMaybe<Scalars['ID']['input']>;
  instance_id?: InputMaybe<Scalars['ID']['input']>;
  metadata?: InputMaybe<Scalars['JSON']['input']>;
  user_id?: InputMaybe<Scalars['ID']['input']>;
  widget_id?: InputMaybe<Scalars['ID']['input']>;
};

export type Invoice = {
  __typename?: 'Invoice';
  appointment?: Maybe<Appointment>;
  balance?: Maybe<Scalars['Int']['output']>;
  client?: Maybe<Client>;
  clinic?: Maybe<Clinic>;
  clinician?: Maybe<Clinician>;
  created_at: Scalars['Timestamp']['output'];
  currency: Scalars['Currency']['output'];
  description?: Maybe<Scalars['String']['output']>;
  discount?: Maybe<Scalars['Int']['output']>;
  discount_reason?: Maybe<Scalars['String']['output']>;
  entered_by_name?: Maybe<Scalars['String']['output']>;
  id: Scalars['ID']['output'];
  invoice_items: Array<InvoiceItem>;
  paid_at?: Maybe<Scalars['Timestamp']['output']>;
  patient?: Maybe<Patient>;
  pims_created_at?: Maybe<Scalars['Timestamp']['output']>;
  pms_id: Scalars['String']['output'];
  previous_appt?: Maybe<Appointment>;
  status: InvoiceStatus;
  subtotal?: Maybe<Scalars['Int']['output']>;
  tax?: Maybe<Scalars['Int']['output']>;
  total: Scalars['Int']['output'];
  total_paid?: Maybe<Scalars['Int']['output']>;
  updated_at: Scalars['Timestamp']['output'];
};

export type InvoiceItem = {
  __typename?: 'InvoiceItem';
  clinic?: Maybe<Clinic>;
  clinician?: Maybe<Clinician>;
  created_at: Scalars['Timestamp']['output'];
  currency: Scalars['Currency']['output'];
  description?: Maybe<Scalars['String']['output']>;
  discount?: Maybe<Scalars['Int']['output']>;
  discount_reason?: Maybe<Scalars['String']['output']>;
  id: Scalars['ID']['output'];
  invoice?: Maybe<Invoice>;
  pims_created_at?: Maybe<Scalars['Timestamp']['output']>;
  pms_id: Scalars['String']['output'];
  price?: Maybe<Scalars['Int']['output']>;
  product?: Maybe<Product>;
  quantity?: Maybe<Scalars['NonNegativeFloat']['output']>;
  subtotal?: Maybe<Scalars['Int']['output']>;
  tax?: Maybe<Scalars['Int']['output']>;
  total: Scalars['Int']['output'];
  type: InvoiceItemType;
  updated_at: Scalars['Timestamp']['output'];
};

export enum InvoiceItemType {
  Discount = 'Discount',
  Other = 'Other',
  Payment = 'Payment',
  Prescription = 'Prescription',
  Product = 'Product',
  Service = 'Service',
  VoidedPayment = 'VoidedPayment'
}

export enum InvoiceStatus {
  Active = 'Active',
  Inactive = 'Inactive',
  Paid = 'Paid',
  Unknown = 'Unknown',
  Void = 'Void'
}

export type KpiGroup = {
  __typename?: 'KpiGroup';
  clinic?: Maybe<Clinic>;
  clinic_group?: Maybe<ClinicGroup>;
  created_at: Scalars['Timestamp']['output'];
  description?: Maybe<Scalars['String']['output']>;
  id: Scalars['ID']['output'];
  kpi_group_metrics: Array<KpiGroupMetric>;
  name: Scalars['String']['output'];
  updated_at: Scalars['Timestamp']['output'];
};

export type KpiGroupMetric = {
  __typename?: 'KpiGroupMetric';
  created_at: Scalars['Timestamp']['output'];
  goal?: Maybe<Scalars['Float']['output']>;
  id: Scalars['ID']['output'];
  kpi_group: KpiGroup;
  order?: Maybe<Scalars['Int']['output']>;
  report_metric: ReportMetric;
  updated_at: Scalars['Timestamp']['output'];
};

export type KpiGroupMetricResult = {
  __typename?: 'KpiGroupMetricResult';
  clinic: Clinic;
  value: KpiGroupResultValue;
};

export type KpiGroupResult = {
  __typename?: 'KpiGroupResult';
  metric: KpiGroupMetric;
  value: KpiGroupResultValue;
};

export type KpiGroupResultValue = {
  __typename?: 'KpiGroupResultValue';
  current_value: Scalars['Float']['output'];
};

export type LastSyncTimes = {
  __typename?: 'LastSyncTimes';
  last_full_sync?: Maybe<Scalars['NonNegativeInt']['output']>;
  last_sync_appointments?: Maybe<Scalars['NonNegativeInt']['output']>;
  last_sync_appt_statuses?: Maybe<Scalars['NonNegativeInt']['output']>;
  last_sync_blockoffs?: Maybe<Scalars['NonNegativeInt']['output']>;
  last_sync_breeds?: Maybe<Scalars['NonNegativeInt']['output']>;
  last_sync_clients?: Maybe<Scalars['NonNegativeInt']['output']>;
  last_sync_clinic_sexes?: Maybe<Scalars['NonNegativeInt']['output']>;
  last_sync_clinicians?: Maybe<Scalars['NonNegativeInt']['output']>;
  last_sync_diagnoses?: Maybe<Scalars['NonNegativeInt']['output']>;
  last_sync_history_items?: Maybe<Scalars['NonNegativeInt']['output']>;
  last_sync_invoice_items?: Maybe<Scalars['NonNegativeInt']['output']>;
  last_sync_invoices?: Maybe<Scalars['NonNegativeInt']['output']>;
  last_sync_patients?: Maybe<Scalars['NonNegativeInt']['output']>;
  last_sync_prescriptions?: Maybe<Scalars['NonNegativeInt']['output']>;
  last_sync_products?: Maybe<Scalars['NonNegativeInt']['output']>;
  last_sync_reminder_types?: Maybe<Scalars['NonNegativeInt']['output']>;
  last_sync_reminders?: Maybe<Scalars['NonNegativeInt']['output']>;
  last_sync_reviews?: Maybe<Scalars['NonNegativeInt']['output']>;
  last_sync_rooms?: Maybe<Scalars['NonNegativeInt']['output']>;
  last_sync_services?: Maybe<Scalars['NonNegativeInt']['output']>;
  last_sync_species?: Maybe<Scalars['NonNegativeInt']['output']>;
  last_sync_transactions?: Maybe<Scalars['NonNegativeInt']['output']>;
  last_sync_vaccination_records?: Maybe<Scalars['NonNegativeInt']['output']>;
};

export type LastSyncTimesInput = {
  last_full_sync?: InputMaybe<Scalars['NonNegativeInt']['input']>;
  last_sync_appointments?: InputMaybe<Scalars['NonNegativeInt']['input']>;
  last_sync_appt_statuses?: InputMaybe<Scalars['NonNegativeInt']['input']>;
  last_sync_blockoffs?: InputMaybe<Scalars['NonNegativeInt']['input']>;
  last_sync_breeds?: InputMaybe<Scalars['NonNegativeInt']['input']>;
  last_sync_clients?: InputMaybe<Scalars['NonNegativeInt']['input']>;
  last_sync_clinic_sexes?: InputMaybe<Scalars['NonNegativeInt']['input']>;
  last_sync_clinicians?: InputMaybe<Scalars['NonNegativeInt']['input']>;
  last_sync_diagnoses?: InputMaybe<Scalars['NonNegativeInt']['input']>;
  last_sync_history_items?: InputMaybe<Scalars['NonNegativeInt']['input']>;
  last_sync_invoice_items?: InputMaybe<Scalars['NonNegativeInt']['input']>;
  last_sync_invoices?: InputMaybe<Scalars['NonNegativeInt']['input']>;
  last_sync_patients?: InputMaybe<Scalars['NonNegativeInt']['input']>;
  last_sync_prescriptions?: InputMaybe<Scalars['NonNegativeInt']['input']>;
  last_sync_products?: InputMaybe<Scalars['NonNegativeInt']['input']>;
  last_sync_reminder_types?: InputMaybe<Scalars['NonNegativeInt']['input']>;
  last_sync_reminders?: InputMaybe<Scalars['NonNegativeInt']['input']>;
  last_sync_reviews?: InputMaybe<Scalars['NonNegativeInt']['input']>;
  last_sync_rooms?: InputMaybe<Scalars['NonNegativeInt']['input']>;
  last_sync_services?: InputMaybe<Scalars['NonNegativeInt']['input']>;
  last_sync_species?: InputMaybe<Scalars['NonNegativeInt']['input']>;
  last_sync_transactions?: InputMaybe<Scalars['NonNegativeInt']['input']>;
  last_sync_vaccination_records?: InputMaybe<Scalars['NonNegativeInt']['input']>;
};

export type LeadCapturedInput = {
  /**
   * Marketing attribution captured on the widget/portal (UTMs, fbclid,
   * gclid, every other supported click ID, plus referrer + landing
   * page + first-/last-touch timestamps). Forwarded onto the
   * outbound LeadCaptured webhook payload so partners can attribute
   * leads back to the originating campaign — required for Meta CAPI
   * and other ad-platform conversion APIs that depend on fbclid.
   */
  acquisition_source?: InputMaybe<AcquisitionSourceInput>;
  client_email: Scalars['String']['input'];
  client_first_name: Scalars['String']['input'];
  /**
   * Returning-client match the visitor selected ('ReturningClientPatientResult.client_id').
   * A hint only: the server re-runs the lookup and ignores it unless it still matches.
   */
  client_id?: InputMaybe<Scalars['ID']['input']>;
  client_last_name: Scalars['String']['input'];
  client_phone: Scalars['String']['input'];
  clinic_id: Scalars['ID']['input'];
  is_new_client?: InputMaybe<Scalars['Boolean']['input']>;
  /** Patient from the same returning match; kept only if the lookup returns it for 'client_id'. */
  patient_id?: InputMaybe<Scalars['ID']['input']>;
  patient_name?: InputMaybe<Scalars['String']['input']>;
  patient_species?: InputMaybe<Scalars['String']['input']>;
  /**
   * Booking-flow session ('booking_flow_sessions.id') this lead came from. When set, the
   * server links the session to the matched client, or to a lead contact when there's no
   * match, so an abandoned booking can be followed up. Not forwarded on the webhook payload.
   */
  session_id?: InputMaybe<Scalars['String']['input']>;
  widget_id?: InputMaybe<Scalars['ID']['input']>;
  widget_source?: InputMaybe<Scalars['String']['input']>;
};

/**
 * Someone who gave a clinic their contact info but isn't its client yet (abandoned online
 * booking, uploaded lead list). 'client' is set once they match or become a client.
 */
export type LeadContact = {
  __typename?: 'LeadContact';
  client?: Maybe<Client>;
  clinic: Scalars['ID']['output'];
  converted_at?: Maybe<Scalars['Timestamp']['output']>;
  created_at: Scalars['Timestamp']['output'];
  email?: Maybe<Scalars['String']['output']>;
  first_name?: Maybe<Scalars['String']['output']>;
  id: Scalars['ID']['output'];
  last_name?: Maybe<Scalars['String']['output']>;
  phone?: Maybe<Scalars['String']['output']>;
  source: LeadContactSource;
  updated_at: Scalars['Timestamp']['output'];
};

export enum LeadContactSource {
  AbandonedBooking = 'AbandonedBooking',
  Upload = 'Upload'
}

export type Link = {
  __typename?: 'Link';
  type?: Maybe<LinkType>;
  url?: Maybe<Scalars['String']['output']>;
};

export type LinkInput = {
  type?: InputMaybe<LinkType>;
  url?: InputMaybe<Scalars['String']['input']>;
};

export enum LinkType {
  Anchor = 'Anchor',
  Apple = 'Apple',
  Spotify = 'Spotify',
  Website = 'Website',
  YouTube = 'YouTube'
}

export type LogInput = {
  logTag: Scalars['String']['input'];
  message: Scalars['String']['input'];
};

export enum LogicalOperator {
  And = 'And',
  Or = 'Or'
}

export type LoyaltyEarning = {
  __typename?: 'LoyaltyEarning';
  clinic: Clinic;
  created_at: Scalars['Timestamp']['output'];
  description?: Maybe<Scalars['String']['output']>;
  id: Scalars['ID']['output'];
  invoice?: Maybe<Invoice>;
  member: LoyaltyMember;
  points_earned: Scalars['Float']['output'];
  updated_at: Scalars['Timestamp']['output'];
};

export type LoyaltyMember = {
  __typename?: 'LoyaltyMember';
  all_time_points: Scalars['Float']['output'];
  available_points: Scalars['Float']['output'];
  client: Client;
  clinic: Clinic;
  created_at: Scalars['Timestamp']['output'];
  id: Scalars['ID']['output'];
  loyalty_redemptions: Array<LoyaltyRedemption>;
  updated_at: Scalars['Timestamp']['output'];
};

export type LoyaltyRedemption = {
  __typename?: 'LoyaltyRedemption';
  clinic: Clinic;
  created_at: Scalars['Timestamp']['output'];
  id: Scalars['ID']['output'];
  member: LoyaltyMember;
  reward: LoyaltyReward;
  status: LoyaltyRedemptionStatus;
  updated_at: Scalars['Timestamp']['output'];
};

export enum LoyaltyRedemptionStatus {
  Cancelled = 'Cancelled',
  Completed = 'Completed',
  Pending = 'Pending'
}

export type LoyaltyReward = {
  __typename?: 'LoyaltyReward';
  clinic: Clinic;
  created_at: Scalars['Timestamp']['output'];
  description?: Maybe<Scalars['String']['output']>;
  id: Scalars['ID']['output'];
  image_url?: Maybe<Scalars['String']['output']>;
  is_active: Scalars['Boolean']['output'];
  loyalty_redemptions: Array<LoyaltyRedemption>;
  name: Scalars['String']['output'];
  points_required: Scalars['NonNegativeInt']['output'];
  updated_at: Scalars['Timestamp']['output'];
};

/**
 * Filters shared across all Marketing Hub queries.
 *
 * Field semantics:
 *   - **range** is the *activity* window (when messages were sent / ads were
 *     clicked). Attribution to appointments uses a configurable lookback
 *     window AFTER each activity datapoint — see `attribution_window_days`.
 *   - **clinic_ids** narrows the clinic group to a subset; omit to include
 *     every clinic in the group.
 *   - **notif_template_ids** / **bulk_message_ids** narrow to specific
 *     channels. The marketing hub typically resolves notification-side
 *     filters (segment, type, is_marketing) against the existing
 *     `queryNotificationTemplates` query first and passes the resulting
 *     IDs in here — this keeps the marketing-stats RPC focused on
 *     attribution rather than reimplementing every notification-side
 *     filter.
 *   - **campaign_ids** restricts notif templates / bulk messages /
 *     appointments to those tied to the named campaigns.
 *   - **appointment_statuses** / **is_new_client** /
 *     **exclude_deleted_appointments** apply uniformly across every
 *     appointment-touching count so the KPI tiles stay internally
 *     consistent.
 */
export type MarketingFiltersInput = {
  appointment_statuses?: InputMaybe<Array<Scalars['String']['input']>>;
  attribution_window_days?: InputMaybe<Scalars['NonNegativeInt']['input']>;
  bulk_message_ids?: InputMaybe<Array<Scalars['ID']['input']>>;
  campaign_ids?: InputMaybe<Array<Scalars['ID']['input']>>;
  clinic_group_id?: InputMaybe<Scalars['ID']['input']>;
  clinic_ids?: InputMaybe<Array<Scalars['ID']['input']>>;
  exclude_deleted_appointments?: InputMaybe<Scalars['Boolean']['input']>;
  is_new_client?: InputMaybe<Scalars['Boolean']['input']>;
  message_methods?: InputMaybe<Array<Scalars['String']['input']>>;
  notif_template_ids?: InputMaybe<Array<Scalars['ID']['input']>>;
  range: UsageTimeRangeInput;
};

/**
 * Cross-channel marketing summary used by the Overview tab KPI tiles.
 * Every count uses the same filter set so ratios (open rate, response rate)
 * are internally consistent.
 */
export type MarketingSummaryStats = {
  __typename?: 'MarketingSummaryStats';
  /**
   * True when the row-fetch hit the safety cap; the UI should show a
   * "refine your filters" notice when this is true.
   */
  attribution_row_limit_hit: Scalars['Boolean']['output'];
  attribution_window_days: Scalars['NonNegativeInt']['output'];
  booking_source_breakdown: Array<BookingSourceBreakdownEntry>;
  /** Appointments where notif_template / bulk_message was set at booking. */
  direct_attributed_bookings: Scalars['NonNegativeInt']['output'];
  /** 0..1 — opens divided by successful email sends. */
  email_open_rate: Scalars['Float']['output'];
  existing_client_appointments: Scalars['NonNegativeInt']['output'];
  /**
   * Total attributed minus direct (booked through any channel within the
   * attribution window after receiving the message).
   */
  indirect_attributed_bookings: Scalars['NonNegativeInt']['output'];
  new_client_appointments: Scalars['NonNegativeInt']['output'];
  online_booking_appointments: Scalars['NonNegativeInt']['output'];
  /** 0..1 — total attributed bookings divided by notification sends. */
  response_rate: Scalars['Float']['output'];
  successful_email_sends: Scalars['NonNegativeInt']['output'];
  total_appointments: Scalars['NonNegativeInt']['output'];
  total_attributed_bookings: Scalars['NonNegativeInt']['output'];
  /**
   * Sum of `direct_invoice_amt_total` (cents) across attributed
   * appointment IDs, computed via the existing invoice-rollup RPC.
   */
  total_attributed_revenue: Scalars['NonNegativeInt']['output'];
  total_bulk_message_sends: Scalars['NonNegativeInt']['output'];
  total_email_opens: Scalars['NonNegativeInt']['output'];
  total_messages_sent: Scalars['NonNegativeInt']['output'];
  total_notification_sends: Scalars['NonNegativeInt']['output'];
};

export type MaybeClientInput = {
  email: Scalars['String']['input'];
  first_name: Scalars['String']['input'];
  last_name: Scalars['String']['input'];
  patient_name: Scalars['String']['input'];
  phone: Scalars['String']['input'];
};

export type MedicalReminderFunnel = {
  __typename?: 'MedicalReminderFunnel';
  attribution_window_days: Scalars['NonNegativeInt']['output'];
  counts: MedicalReminderFunnelCounts;
  /** Live medical reminders in scope. Present even when the per-notification breakdown was not requested. */
  notification_count: Scalars['NonNegativeInt']['output'];
  /** Empty unless include_notification_breakdown is true. */
  notifications: Array<MedicalReminderNotificationFunnel>;
  revenue_lookback_days: Scalars['NonNegativeInt']['output'];
};

/**
 * Client-level medical reminder funnel.
 *
 * Opened counts every client who opened the email, plus every client who
 * was sent an SMS (SMS has no open tracking, so it is treated as opened).
 * Booked clients and revenue use the marketing attribution window after
 * the send. Direct appointments were booked from the reminder link.
 * Indirect appointments were booked another way inside that window.
 * Revenue is invoice totals within the revenue lookback of those
 * appointments, in cents.
 */
export type MedicalReminderFunnelCounts = {
  __typename?: 'MedicalReminderFunnelCounts';
  clients_booked: Scalars['NonNegativeInt']['output'];
  clients_clicked: Scalars['NonNegativeInt']['output'];
  clients_opened: Scalars['NonNegativeInt']['output'];
  clients_sent: Scalars['NonNegativeInt']['output'];
  direct_appointments: Scalars['NonNegativeInt']['output'];
  direct_revenue_cents: Scalars['NonNegativeInt']['output'];
  indirect_appointments: Scalars['NonNegativeInt']['output'];
  indirect_revenue_cents: Scalars['NonNegativeInt']['output'];
};

export type MedicalReminderNotificationFunnel = {
  __typename?: 'MedicalReminderNotificationFunnel';
  clinic_id: Scalars['ID']['output'];
  counts: MedicalReminderFunnelCounts;
  name: Scalars['String']['output'];
  notification_template_id: Scalars['ID']['output'];
};

export type Message = {
  __typename?: 'Message';
  attachments?: Maybe<Array<Attachment>>;
  bulk_message?: Maybe<ScheduledBulkMessage>;
  call?: Maybe<Call>;
  chat: Chat;
  client?: Maybe<Client>;
  client_phone?: Maybe<ClientPhone>;
  clinic_user?: Maybe<User>;
  created_at: Scalars['NonNegativeInt']['output'];
  cta_text?: Maybe<Scalars['String']['output']>;
  cta_url?: Maybe<Scalars['String']['output']>;
  email_error?: Maybe<Scalars['String']['output']>;
  email_text?: Maybe<Scalars['String']['output']>;
  hidden_for_client?: Maybe<Scalars['Boolean']['output']>;
  id: Scalars['ID']['output'];
  is_hidden: Scalars['Boolean']['output'];
  is_preview: Scalars['Boolean']['output'];
  message_methods?: Maybe<Array<MessageMethod>>;
  message_notification_templates?: Maybe<Array<MessageNotificationTemplate>>;
  message_origin?: Maybe<MessageOrigin>;
  message_type?: Maybe<MessageType>;
  notification?: Maybe<NotificationTemplate>;
  other_errors?: Maybe<Array<Scalars['String']['output']>>;
  patient?: Maybe<Patient>;
  patients: Array<Patient>;
  phone_call_error?: Maybe<Scalars['String']['output']>;
  postcard_error?: Maybe<Scalars['String']['output']>;
  postcard_template?: Maybe<Scalars['String']['output']>;
  push_error?: Maybe<Scalars['String']['output']>;
  sender_unique_id?: Maybe<Scalars['String']['output']>;
  sms_error?: Maybe<Scalars['String']['output']>;
  template_data?: Maybe<Scalars['JSON']['output']>;
  text: Scalars['String']['output'];
  type?: Maybe<NotificationType>;
  updated_at: Scalars['NonNegativeInt']['output'];
  written_back_at?: Maybe<Scalars['NonNegativeInt']['output']>;
};

export enum MessageMethod {
  Email = 'Email',
  Native = 'Native',
  PhoneCall = 'PhoneCall',
  Postcard = 'Postcard',
  Push = 'Push',
  Sms = 'Sms',
  WhatsApp = 'WhatsApp'
}

export type MessageNotificationTemplate = {
  __typename?: 'MessageNotificationTemplate';
  created_at: Scalars['NonNegativeInt']['output'];
  id: Scalars['ID']['output'];
  message: Message;
  notification_template: NotificationTemplate;
  updated_at: Scalars['NonNegativeInt']['output'];
};

export enum MessageOrigin {
  ChckupDashboard = 'ChckupDashboard',
  ChckupPortal = 'ChckupPortal',
  ChckupWidget = 'ChckupWidget',
  Email = 'Email',
  Sms = 'Sms',
  System = 'System'
}

export type MessageTemplate = {
  __typename?: 'MessageTemplate';
  body: Scalars['String']['output'];
  /** Owner: exactly one of clinic / clinic_group is set */
  clinic?: Maybe<Clinic>;
  /** Group-owned templates waterfall to linked clinics (see entity_links) */
  clinic_group?: Maybe<ClinicGroup>;
  created_at: Scalars['NonNegativeInt']['output'];
  id: Scalars['ID']['output'];
  name: Scalars['String']['output'];
  updated_at: Scalars['NonNegativeInt']['output'];
};

export enum MessageType {
  Clinic = 'Clinic',
  System = 'System',
  User = 'User'
}

export enum MetricFormat {
  Count = 'Count',
  Rate = 'Rate'
}

export enum MetricModifierCategory {
  Appointment = 'Appointment',
  Client = 'Client',
  Invoice = 'Invoice',
  Patient = 'Patient'
}

export type MetricModifierValue = {
  __typename?: 'MetricModifierValue';
  boolean?: Maybe<Scalars['Boolean']['output']>;
  float?: Maybe<Scalars['Float']['output']>;
  string?: Maybe<Scalars['String']['output']>;
  stringArray?: Maybe<Array<Scalars['String']['output']>>;
};

export type MetricModifierValueInput = {
  boolean?: InputMaybe<Scalars['Boolean']['input']>;
  float?: InputMaybe<Scalars['Float']['input']>;
  string?: InputMaybe<Scalars['String']['input']>;
  stringArray?: InputMaybe<Array<Scalars['String']['input']>>;
};

export type MetricValueParams = {
  __typename?: 'MetricValueParams';
  custom_label?: Maybe<Scalars['String']['output']>;
  value_type: MetricValueType;
};

export type MetricValueParamsInput = {
  custom_label?: InputMaybe<Scalars['String']['input']>;
  value_type: MetricValueType;
};

export enum MetricValueType {
  PerAppointment = 'PerAppointment',
  PerClient = 'PerClient',
  PerClinician = 'PerClinician',
  PerDay = 'PerDay',
  PerInvoice = 'PerInvoice',
  PerInvoiceItem = 'PerInvoiceItem',
  PerMonth = 'PerMonth',
  PerPatient = 'PerPatient',
  PerQuarter = 'PerQuarter',
  PerWeek = 'PerWeek',
  PerWorkDay = 'PerWorkDay',
  PerWorkWeek = 'PerWorkWeek',
  PerYear = 'PerYear',
  Total = 'Total'
}

export enum MsgEventTrackingType {
  Click = 'Click',
  Open = 'Open'
}

export type MsgTrackingEvent = {
  __typename?: 'MsgTrackingEvent';
  bulk_message_id?: Maybe<Scalars['ID']['output']>;
  click_id?: Maybe<Scalars['String']['output']>;
  client_id?: Maybe<Scalars['ID']['output']>;
  clinic_id: Scalars['ID']['output'];
  created_at: Scalars['NonNegativeInt']['output'];
  event_type: MsgEventTrackingType;
  event_value?: Maybe<Scalars['String']['output']>;
  id: Scalars['ID']['output'];
  message_id: Scalars['ID']['output'];
  message_method?: Maybe<MessageMethod>;
  notif_template_id?: Maybe<Scalars['ID']['output']>;
  redirect_url?: Maybe<Scalars['String']['output']>;
  updated_at: Scalars['NonNegativeInt']['output'];
};

export type Mutation = {
  __typename?: 'Mutation';
  _empty?: Maybe<Scalars['Void']['output']>;
  /**
   * Teaches the clinic's AI receptionist one instruction (e.g. from a
   * reviewed call), saved wherever that agent reads it. Anyone who can
   * edit the clinic's Custom Instructions can do this.
   */
  addAiAgentInstructionForClinic: AiAgentInstructionDestination;
  addClinicToClient: Client;
  addLoyaltyEarning: LoyaltyEarning;
  addLoyaltyEarningToClient: LoyaltyEarning;
  addPointsToLoyaltyMember: LoyaltyMember;
  addToAppWaitlist?: Maybe<Scalars['Void']['output']>;
  addToEmailList?: Maybe<Scalars['Void']['output']>;
  addUserToClient: Client;
  addUserToClinicsAndClinicGroups?: Maybe<Scalars['Void']['output']>;
  /**
   * Publishes the change drafted by the latest previewAiImprovementItem
   * and marks the item Applied. Fails if the playbook changed since the
   * preview; preview again in that case.
   */
  applyAiImprovementItem: AiImprovementItem;
  approvePrescriptionRefillRequest: PrescriptionRefillRequest;
  approveRedemptionRequest: LoyaltyRedemption;
  /**
   * Approves a reschedule request. Re-checks that the requested slot is still
   * available before writing so an approval can't double-book the calendar.
   * Set skipSchedulingDateBounds when a staff member has explicitly approved
   * booking inside the clinic's scheduling-date window (e.g. the minimum
   * booking lead time); this bypasses only the date-bounds check, never
   * appointment-collision detection.
   */
  approveReschedule: Reschedule;
  archiveCustomerSegment: CustomerSegment;
  archiveNotificationTemplate: NotificationTemplate;
  archiveScheduledBulkMessage: ScheduledBulkMessage;
  assignClientFormToClient: ClientForm;
  assignClientFormToPatient: ClientForm;
  /**
   * Awards app-download loyalty points to all eligible clinics for the authenticated user.
   * Safe to call on every login — silently skips clinics that have already awarded this bonus.
   */
  awardAppDownloadPoints: Array<LoyaltyEarning>;
  bulkCreateUsers: Array<User>;
  /**
   * Applies the same clinic-local / archival fields to many notification
   * templates. Each id is authorized and updated independently (linked
   * children stay linked — `is_active` / `is_preview_mode` are not
   * group-governed; archiving waterfalls from group parents).
   */
  bulkUpdateNotificationTemplates: Array<NotificationTemplate>;
  /**
   * Applies the same clinic-local / archival fields to many bulk messages.
   * Each id is authorized and updated independently (linked children stay
   * linked — `is_active` is not group-governed; archiving waterfalls from
   * group parents).
   */
  bulkUpdateScheduledBulkMessages: Array<ScheduledBulkMessage>;
  cancelPrescriptionRefillRequest: PrescriptionRefillRequest;
  cancelRedemptionRequest: LoyaltyRedemption;
  cancelScheduledMessage: ScheduledMessage;
  /**
   * Removes a cell's note entirely. If it was accepted, the cell starts
   * being counted as a difference again. Returns the group's full note list.
   */
  clearClinicGroupOnboardingCellNote: Array<ClinicGroupOnboardingCellNote>;
  clientCancelAppointment: Appointment;
  clientConfirmAppointment: Appointment;
  confirmAppointment: Scalars['Boolean']['output'];
  /**
   * Converts a PDF form to Chckvet form elements using AI vision analysis.
   * The PDF is analyzed and converted into a structured array of FormElement objects
   * that can be used to create a new form.
   */
  convertPdfToFormElements: ConvertPdfToFormResult;
  copyCustomerSegmentAcrossClinic: CustomerSegment;
  copyEmailTemplateAcrossClinic: EmailTemplate;
  /**
   * Copies a form to a different clinic within the same organization.
   * Form field IDs are deduplicated and the copy is created as inactive.
   */
  copyFormAcrossClinic: Form;
  copyNotificationTemplateAcrossClinic: NotificationTemplate;
  createActionItem: ActionItem;
  createAnimal: Animal;
  createAppointment: Appointment;
  createAppointmentPrompt: AppointmentPrompt;
  createBookingFlowEvent: BookingFlowEvent;
  createCampaign: Campaign;
  createChat: Chat;
  createChatStatus: ChatStatusConfig;
  createChatWithNonClient: Chat;
  createCheckIn: CheckIn;
  createClient: Client;
  createClientForm: ClientForm;
  createClinic: Clinic;
  createClinicAdmin: ClinicAdmin;
  createClinicFeatures: ClinicFeatures;
  createClinicGroup: ClinicGroup;
  createClinicGroupClinic: ClinicGroupClinic;
  createClinicGroupUser: ClinicGroupUser;
  createClinicService: Service;
  createClinicStats: ClinicStats;
  createClinician: Clinician;
  createClinicianService: ClinicianService;
  createConnectInstallation: ConnectInstallation;
  createCustomRole: CustomRole;
  createCustomerSegment: CustomerSegment;
  createDailyHuddle: DailyHuddle;
  createDataChat: DataChat;
  createDiagnosis: Diagnosis;
  createEmailTemplate: EmailTemplate;
  createEntityReport: EntityReport;
  createFamily: Family;
  createForm: Form;
  createGoal: Goal;
  createInitiative: Initiative;
  createInitiativeMetric: InitiativeMetric;
  createInternalChat: InternalChat;
  createInternalChatMessage: InternalChatMessage;
  createInternalChatUser: InternalChatUser;
  createInternalUsageEvent?: Maybe<InternalUsageEvent>;
  createKpiGroup: KpiGroup;
  createKpiGroupMetric: KpiGroupMetric;
  createLoyaltyMember: LoyaltyMember;
  createLoyaltyRedemption: LoyaltyRedemption;
  createLoyaltyReward: LoyaltyReward;
  createMessage: Message;
  createMessageTemplate?: Maybe<MessageTemplate>;
  createNotificationTemplate: NotificationTemplate;
  createOrganization: Organization;
  createOrganizationReport: OrganizationReport;
  createPatient: Patient;
  createPatientHistoryItem: PatientHistoryItem;
  createPatientRecord: PatientRecord;
  createPaymentLink: Payment;
  createPet: Pet;
  createPetSelfie: PetSelfie;
  createPimsSettings: Scalars['Boolean']['output'];
  createPmsApptType: PmsApptType;
  createPmsDb: PmsDb;
  createPrescription: Prescription;
  createPrescriptionRefillRequest: PrescriptionRefillRequest;
  createPressItem: PressItem;
  createPrivateNote: PrivateNote;
  createProduct: Product;
  createProviderAvailabilities?: Maybe<Array<ProviderAvailability>>;
  createProviderAvailability: ProviderAvailability;
  createReportClinic: ReportClinic;
  createReportMetric: ReportMetric;
  createReportTemplate: ReportTemplate;
  createReportTemplateMetric: ReportTemplateMetric;
  createReschedule: Reschedule;
  createReview: Review;
  createRoom: Room;
  createRoomService: RoomService;
  createScheduledBulkMessage: ScheduledBulkMessage;
  createScheduledMessage: ScheduledMessage;
  createSchedulingRules: SchedulingRules;
  createService: Service;
  createServiceCategory: ServiceCategory;
  createServiceForm: ServiceForm;
  createTag: Tag;
  createTagCategory: TagCategory;
  createTemplateClinic: TemplateClinic;
  createTransaction: Transaction;
  createTreatment: Treatment;
  createUser: User;
  createUserTrackingBulkMessage: ScheduledBulkMessage;
  createWidget: Widget;
  createWidgetOptions: WidgetOptions;
  createWidgetService: WidgetService;
  createWidgetSisterLocation: WidgetSisterLocation;
  deleteActionItem?: Maybe<Scalars['Void']['output']>;
  deleteAnimal?: Maybe<Scalars['Void']['output']>;
  deleteAppointment?: Maybe<Scalars['Void']['output']>;
  deleteAppointmentPrompt?: Maybe<Scalars['Void']['output']>;
  deleteChat?: Maybe<Scalars['Void']['output']>;
  deleteChatStatus?: Maybe<Scalars['Void']['output']>;
  deleteClient?: Maybe<Scalars['Void']['output']>;
  deleteClinic?: Maybe<Scalars['Void']['output']>;
  deleteClinicAdmin?: Maybe<Scalars['Void']['output']>;
  deleteClinicFeatures?: Maybe<Scalars['Void']['output']>;
  deleteClinicGroupClinic?: Maybe<Scalars['Void']['output']>;
  deleteClinicGroupUser?: Maybe<Scalars['Void']['output']>;
  deleteClinicService?: Maybe<Scalars['Void']['output']>;
  deleteClinician?: Maybe<Scalars['Void']['output']>;
  deleteClinicianService?: Maybe<Scalars['Void']['output']>;
  deleteConnectInstallation?: Maybe<Scalars['Void']['output']>;
  deleteCustomRole?: Maybe<Scalars['Void']['output']>;
  deleteCustomerSegment?: Maybe<Scalars['Void']['output']>;
  deleteDailyHuddle?: Maybe<Scalars['Void']['output']>;
  deleteDiagnosis?: Maybe<Scalars['Void']['output']>;
  deleteEmailTemplate?: Maybe<Scalars['Void']['output']>;
  deleteFamily?: Maybe<Scalars['Void']['output']>;
  deleteGoal?: Maybe<Scalars['Void']['output']>;
  deleteInitiative?: Maybe<Scalars['Void']['output']>;
  deleteInitiativeMetric?: Maybe<Scalars['Void']['output']>;
  deleteInternalChat?: Maybe<Scalars['Void']['output']>;
  deleteInternalChatMessage?: Maybe<Scalars['Void']['output']>;
  deleteInternalChatUser?: Maybe<Scalars['Void']['output']>;
  deleteKpiGroup?: Maybe<Scalars['Void']['output']>;
  deleteKpiGroupMetric?: Maybe<Scalars['Void']['output']>;
  deleteLoyaltyMember?: Maybe<Scalars['Void']['output']>;
  deleteLoyaltyReward?: Maybe<Scalars['Void']['output']>;
  deleteMessage?: Maybe<Scalars['Void']['output']>;
  deleteMessageTemplate?: Maybe<Scalars['Void']['output']>;
  deleteNotificationTemplate?: Maybe<Scalars['Void']['output']>;
  deleteOrganization?: Maybe<Scalars['Void']['output']>;
  deleteOrganizationReport?: Maybe<Scalars['Void']['output']>;
  deletePatient?: Maybe<Scalars['Void']['output']>;
  deletePatientHistoryItem?: Maybe<Scalars['Void']['output']>;
  deletePatientRecord?: Maybe<Scalars['Void']['output']>;
  deletePet?: Maybe<Scalars['Void']['output']>;
  deletePmsApptType?: Maybe<Scalars['Void']['output']>;
  deletePrescription?: Maybe<Scalars['Void']['output']>;
  deletePressItem?: Maybe<Scalars['Void']['output']>;
  deletePrivateNote?: Maybe<Scalars['Void']['output']>;
  deleteProduct?: Maybe<Scalars['Void']['output']>;
  deleteReportClinic?: Maybe<Scalars['Void']['output']>;
  deleteReportMetric?: Maybe<Scalars['Void']['output']>;
  deleteReportTemplate?: Maybe<Scalars['Void']['output']>;
  deleteReportTemplateMetric?: Maybe<Scalars['Void']['output']>;
  deleteReschedule?: Maybe<Scalars['Void']['output']>;
  deleteReview?: Maybe<Scalars['Void']['output']>;
  deleteRoom?: Maybe<Scalars['Void']['output']>;
  deleteRoomService?: Maybe<Scalars['Void']['output']>;
  /**
   * Deletes a bulk message. For a group-owned bulk message this also
   * deletes every linked clinic copy that has not started sending.
   */
  deleteScheduledBulkMessage?: Maybe<Scalars['Void']['output']>;
  deleteScheduledMessage?: Maybe<Scalars['Void']['output']>;
  deleteSchedulingRules?: Maybe<Scalars['Void']['output']>;
  deleteService?: Maybe<Scalars['Void']['output']>;
  deleteServiceCategory?: Maybe<Scalars['Void']['output']>;
  deleteServiceForm?: Maybe<Scalars['Void']['output']>;
  deleteServiceFormByServiceAndForm?: Maybe<Scalars['Void']['output']>;
  deleteTag?: Maybe<Scalars['Void']['output']>;
  deleteTagCategory?: Maybe<Scalars['Void']['output']>;
  deleteTagsForEntity?: Maybe<Scalars['Void']['output']>;
  deleteTemplateClinic?: Maybe<Scalars['Void']['output']>;
  deleteTransaction?: Maybe<Scalars['Void']['output']>;
  deleteTreatment?: Maybe<Scalars['Void']['output']>;
  deleteUser?: Maybe<Scalars['Void']['output']>;
  /**
   * Permanently removes a notification from the viewer's tray.
   * Used by the per-item dismiss (X) affordance.
   */
  deleteUserNotification: Scalars['Boolean']['output'];
  deleteWidget?: Maybe<Scalars['Void']['output']>;
  deleteWidgetOptions: Scalars['Boolean']['output'];
  deleteWidgetService?: Maybe<Scalars['Void']['output']>;
  deleteWidgetServiceByWidgetAndService?: Maybe<Scalars['Void']['output']>;
  denyPendingAppointment: Appointment;
  denyPrescriptionRefillRequest: PrescriptionRefillRequest;
  denyReschedule: Reschedule;
  /** Hides a suggestion. It comes back if it keeps recurring. */
  dismissAiImprovementItem: AiImprovementItem;
  duplicateEmailTemplate: EmailTemplate;
  emailCustomerSegmentCsv?: Maybe<Scalars['Void']['output']>;
  executeApprovedChange: ExecuteApprovedChangeResult;
  /**
   * Group-side: for clinics that already have an active link to this
   * parent, start inheriting the given fields (remove from
   * `unlinked_fields` and recopy parent values). Clinics with no link or
   * a fully severed link are skipped — use populateEntityLinkChildren for
   * never-linked clinics. Used for per-field settings linking.
   */
  expandEntityLinkFieldsForClinics: Array<EntityLink>;
  forcePasswordReset?: Maybe<Scalars['Void']['output']>;
  /**
   * Provisions the clinic's Retell agent + phone number and Stripe usage
   * billing. Returns the new agent id. agentType defaults to
   * ConversationFlow.
   */
  initializeAiAgentForClinic: Scalars['String']['output'];
  /**
   * Materializes linked copies of EVERY group-level parent entity into one
   * clinic — the "initialize linked entities" option when a clinic joins a
   * clinic group. Optionally restricted to specific entity types. Parents
   * the clinic already has a link for are skipped, so this is idempotent.
   */
  initializeEntityLinksForClinic: Array<EntityLink>;
  /**
   * Materializes linked copies of EVERY group-level parent of one entity
   * type into the given clinics (or every clinic in the group when
   * clinicIds is omitted). Parents a clinic already has a link for are
   * skipped. ClinicSettings is not supported.
   */
  initializeEntityLinksForEntityType: Array<EntityLink>;
  log?: Maybe<Scalars['Void']['output']>;
  makeClientPhonePrimary: Client;
  makePrimaryClinicApptStatus: ClinicApptStatus;
  makePrimaryClinicSpecies: ClinicSpecies;
  markAllMyUserNotificationsAsRead: Scalars['Boolean']['output'];
  markAppointmentAsResolved: Appointment;
  /**
   * Stamps `seen_at` on all currently-unseen notifications for the
   * viewer. Called when the bell tray opens so the badge clears even
   * before each item is individually clicked.
   */
  markMyUserNotificationsAsSeen: Scalars['Boolean']['output'];
  markPetSelfieViewed: PetSelfie;
  markUserNotificationAsRead: UserNotification;
  memberRequestRedemption?: Maybe<Scalars['Void']['output']>;
  mergeChat: Chat;
  /**
   * Mint a short-lived read-only GraphQL JWT for the clinic agent.
   * Rate-limited per user. Primarily for access probing / future client
   * tooling; `sendClinicAgentMessage` mints its own token per turn.
   */
  mintClinicAgentSession: ClinicAgentSession;
  /**
   * Creates linked clinic-level copies of a group-level parent for the
   * given clinics (or every never-linked clinic in the group when
   * clinicIds is omitted). Clinics that already have a link — active or
   * historical — are skipped; relink those instead.
   *
   * For ClinicSettings, `linkedFields` is required: only those fields are
   * copied from the group; every other governed field is seeded into
   * `unlinked_fields` so clinic-local values are preserved.
   */
  populateEntityLinkChildren: Array<EntityLink>;
  /**
   * Drafts the playbook change for a suggestion from the clinic's answer
   * (or edited draft wording) against the LIVE playbook, and stores it on
   * the item for applyAiImprovementItem. Saves nothing to the agent.
   */
  previewAiImprovementItem: AiImprovementItemPreview;
  reassignClinicApptStatus: ClinicApptStatus;
  /**
   * Records the daily health-check bot's verdict so tomorrow's payload
   * knows which clinics are still broken. Idempotent per snapshot_date.
   * SuperAdmin / Admin only.
   */
  recordClinicHealthCheckRun: RecordClinicHealthCheckRunResult;
  /**
   * Sets mobile_app_logged_in_at to now for the authenticated user.
   * Call from the native app on launch; do not send a client timestamp.
   */
  recordMobileAppLoggedIn?: Maybe<Scalars['Void']['output']>;
  refreshGoal: Goal;
  refreshGoalsForClinic: Array<Goal>;
  refundPayment: Payment;
  /**
   * Re-attaches a previously unlinked child (clearing any field-level
   * opt-outs) and re-copies all inheritable values from the group parent.
   */
  relinkEntity: EntityLink;
  /**
   * Re-links previously opted-out fields and immediately re-copies their
   * values from the group parent.
   */
  relinkEntityFields: EntityLink;
  removeFromEmailList?: Maybe<Scalars['Void']['output']>;
  removePaymentMethod: Scalars['Boolean']['output'];
  removeWidgetSisterLocation?: Maybe<Scalars['Void']['output']>;
  requestChangeForPendingAppointment: Appointment;
  resendInviteEmail: Scalars['Boolean']['output'];
  sendAppointmentPrompt: AppointmentPrompt;
  /**
   * Start or continue an Ask Chckvet turn for the given clinic or
   * clinic group. Returns immediately with runId; poll
   * `clinicAgentRunStatus`.
   */
  sendClinicAgentMessage: SupportBotMessageStarted;
  sendDataChatPrompt: DataChat;
  sendNotification?: Maybe<Scalars['Void']['output']>;
  sendPaymentReceipt: Scalars['Boolean']['output'];
  sendScheduledBulkMessage: Scalars['Boolean']['output'];
  /**
   * Start a new (or continue an existing) support-bot conversation
   * turn. Returns immediately with `{runId, conversationId, status: running, conversation}`;
   * the actual assistant response is delivered via subsequent
   * `supportBotRunStatus` polls. If `conversationId` is omitted in
   * the input, starts a new conversation; otherwise continues the
   * existing one (Cursor-SDK `Agent.resume` under the hood — full
   * history and tool context preserved). SuperAdmin only.
   */
  sendSupportBotMessage: SupportBotMessageStarted;
  sendTestEmail?: Maybe<Scalars['Void']['output']>;
  /**
   * Sets (or clears, when go_live_date is null) a clinic's calendar
   * go-live date as YYYY-MM-DD. Admin only. Same column as the enterprise
   * onboarding report; that mutation also checks clinic-group membership.
   */
  setClinicGoLiveDate?: Maybe<Scalars['String']['output']>;
  /**
   * Writes the note on one cell of the report, replacing whatever was there
   * (notes are one per clinic/column pair, so this is a full overwrite of
   * the text, the accepted flag, the waiting-on owner and the assignee
   * together).
   *
   * A call that leaves the cell with no text, no accepted flag, nobody to
   * wait on and nobody assigned deletes the note instead of storing an
   * empty one, so clearing the last field in the editor tidies up after
   * itself.
   *
   * Returns the group's full note list. Caller must be a manager of the
   * clinic group.
   */
  setClinicGroupOnboardingCellNote: Array<ClinicGroupOnboardingCellNote>;
  /**
   * Overrides how one column is judged complete, or clears the override back
   * to the default derived from its compare mode when `criterion` is null.
   * Either way the column becomes scored again, since choosing a rule is how
   * an unscored column is put back into Aligned.
   *
   * Returns the group's full column config. Caller must be a manager of the
   * clinic group.
   */
  setClinicGroupOnboardingColumnCriterion: Array<ClinicGroupOnboardingColumnConfig>;
  /**
   * Hides or restores report columns in bulk: one column from its header, a
   * whole section at once, or everything from the hidden list. A hidden
   * column drops out of the table, difference counts, and Aligned. Restoring
   * it puts it back into the score unless it was also marked unscored.
   *
   * Returns the group's full column config. Caller must be a manager of the
   * clinic group.
   */
  setClinicGroupOnboardingColumnsHidden: Array<ClinicGroupOnboardingColumnConfig>;
  /**
   * Takes report columns out of the Aligned score, or puts them back. The
   * columns stay in the table; their differences just stop being flagged and
   * stop counting. This is for settings that are MEANT to vary per clinic,
   * like brand colours.
   *
   * Returns the group's full column config. Caller must be a manager of the
   * clinic group.
   */
  setClinicGroupOnboardingColumnsScored: Array<ClinicGroupOnboardingColumnConfig>;
  /**
   * Sets (or clears, when go_live_date is null) a clinic's calendar
   * go-live date as YYYY-MM-DD. Caller must be a manager of the clinic
   * group; the clinic must belong to that group.
   */
  setClinicGroupOnboardingGoLiveDate: ClinicGroupOnboardingGoLiveDate;
  /**
   * Sets (or clears, when value is null) a clinic's chosen option for one
   * onboarding step of the given group. Dropdown steps must use one of
   * the step's configured options; free-text steps accept any non-empty
   * string. Caller must be a manager of the clinic group.
   */
  setClinicGroupOnboardingStepStatus: ClinicGroupOnboardingStepStatuses;
  /**
   * Opens or closes a single rollout cohort, so a finished tranche can be
   * tucked away without touching its membership.
   */
  setClinicGroupTrancheComplete: ClinicGroup;
  setDefaultPaymentMethod: Scalars['Boolean']['output'];
  /**
   * Share a pet's vaccine records to an email and/or SMS recipient. Sends
   * the same short-lived, printable link the AI receptionist uses.
   * Authorized for the pet's owner (portal) OR a clinic employee of the
   * pet's clinic (dashboard). At least one of email/phone is required.
   */
  shareVaccineRecords: ShareVaccineRecordsResult;
  submitAppointment: Appointment;
  /**
   * Asks an AI to apply a plain-English change to currentPlaybook (the
   * editor's draft, saved or not) and returns the result for review.
   * Saves nothing. Clinic managers.
   */
  suggestAiAgentPlaybookEdit: AiAgentPromptSuggestion;
  syncAppointmentsForBookableTimes: Array<Appointment>;
  /**
   * Fetches this client live from the clinic's PIMS by its PIMS id and
   * upserts the result into our database. Used for on-demand refreshes
   * when nightly/batch sync lags (especially Bitwerx OnDemand).
   */
  syncIndividualClient: Client;
  /**
   * Fetches this patient live from the clinic's PIMS by its PIMS id and
   * upserts the result into our database. Used for on-demand refreshes
   * when nightly/batch sync lags (especially Bitwerx OnDemand).
   */
  syncIndividualPatient: Patient;
  /**
   * Fetches a client live from the clinic's PIMS by its PIMS id and upserts
   * it, along with every pet it owns there, into our database. Used to pull
   * in records created since the last sync instead of waiting for the
   * nightly.
   */
  syncPimsClientByPmsId: Client;
  /**
   * On-demand sync of PIMS reminders for a single patient. Dispatches to the
   * clinic's PIMS controller (Shepherd, Pulse, Daysmart, Provet, ezyVet).
   */
  syncPimsRemindersForPatient: Scalars['Boolean']['output'];
  syncVaccinationRecordsForPatient: Scalars['Boolean']['output'];
  togglePaymentIsEntered: Payment;
  /**
   * Triggers a lead captured webhook when client enters contact info.
   * Called from widget/portal when client info form is completed.
   */
  triggerLeadCapturedWebhook: TriggerWebhookResult;
  triggerServiceUpdateForClinic: Scalars['Boolean']['output'];
  triggerSyncForClinic: Scalars['Boolean']['output'];
  triggerUpdateServiceRestartForClinic: Scalars['Boolean']['output'];
  /**
   * Triggers a test webhook event with sample data.
   * Used from dashboard to verify webhook configuration.
   */
  triggerWebhookTest: TriggerWebhookResult;
  /**
   * Detaches a clinic-level child from its group parent's waterfall. The
   * link row is kept (with unlinked_at/unlinked_by) so the group level can
   * still see previously linked clinics; the child becomes fully editable.
   */
  unlinkEntity: EntityLink;
  /**
   * Opts individual fields of an actively linked child out of the group
   * waterfall, e.g. "use our own audience for this notification but keep
   * the copy linked".
   */
  unlinkEntityFields: EntityLink;
  /**
   * Group-side: for clinics that already have an active link to this
   * parent, stop inheriting the given fields (add to `unlinked_fields`).
   * Clinics with no link or a fully severed link are skipped. Child values
   * are left as-is — only future parent updates stop applying.
   */
  unlinkEntityFieldsForClinics: Array<EntityLink>;
  /**
   * Public email-only unsubscribe (disables client email channel; SMS is
   * unchanged). Always returns true (does not reveal whether the address
   * was found). Safe for unauthenticated portal use — state is only
   * changed via this mutation, never on page GET/prefetch.
   */
  unsubscribeEmail: Scalars['Boolean']['output'];
  updateActionItem: ActionItem;
  /**
   * Saves a SinglePrompt clinic's playbook and publishes Chckvet's rules
   * plus the playbook to live calls immediately. playbook null resets to
   * Chckvet's default playbook. Fails for ConversationFlow agents.
   * Clinic managers.
   */
  updateAiAgentPlaybookForClinic: AiAgentPrompt;
  updateAnimal: Animal;
  updateAppointment: Appointment;
  updateAppointmentClientPatient: Appointment;
  updateAppointmentPrompt: AppointmentPrompt;
  updateBreed: Breed;
  updateCall: Call;
  updateCampaign: Campaign;
  updateCampaignFeaturedStats: Campaign;
  updateCampaignNotificationFeaturedStats: Campaign;
  updateCampaignScheduledBulkMessageFeaturedStats: Campaign;
  updateCampaignWidgetFeaturedStats: Campaign;
  updateChat: Chat;
  updateChatStatus: ChatStatusConfig;
  updateChckupMetadata?: Maybe<ChckupMetadata>;
  updateCheckIn: CheckIn;
  updateClient: Client;
  updateClientForm: ClientForm;
  updateClientStatus: ClientStatus;
  updateClinic: Clinic;
  updateClinicAdmin: ClinicAdmin;
  updateClinicApptStatus: ClinicApptStatus;
  updateClinicFeatures: ClinicFeatures;
  updateClinicGroup: ClinicGroup;
  /**
   * Replaces the merge tag names the group expects every clinic to fill in.
   * Names are trimmed and de-duplicated. Caller must be a manager of the
   * clinic group.
   */
  updateClinicGroupExpectedMergeTags: ClinicGroup;
  /**
   * Replaces the group's custom onboarding step definitions. Removing a
   * step leaves clinics' stored values for it orphaned (and ignored), so
   * renames are effectively remove + add. Caller must be a manager of the
   * clinic group.
   */
  updateClinicGroupOnboardingSteps: ClinicGroup;
  /**
   * Replaces the group's rollout cohorts. A clinic may belong to at most one
   * tranche; later entries win if ids are repeated. Clinic ids that aren't
   * group members are rejected. Caller must be a manager of the clinic
   * group.
   */
  updateClinicGroupOnboardingTranches: ClinicGroup;
  /**
   * Update the clinic group's shared settings row. Creates the settings
   * row if the group does not have one yet. Changes waterfall to clinics
   * linked via entity_links (honoring each clinic's unlinked_fields).
   */
  updateClinicGroupSettings: ClinicSettings;
  updateClinicGroupUser: ClinicGroupUser;
  updateClinicService: Service;
  updateClinicSex: ClinicSex;
  updateClinicSpecies: ClinicSpecies;
  updateClinician: Clinician;
  updateClinicianService: ClinicianService;
  updateConnectInstallation: ConnectInstallation;
  updateCustomRole: CustomRole;
  updateCustomerSegment: CustomerSegment;
  updateDailyHuddle: DailyHuddle;
  updateDataChat: DataChat;
  updateDiagnosis: Diagnosis;
  updateEmailTemplate: EmailTemplate;
  updateFamily: Family;
  updateForm: Form;
  updateGoal: Goal;
  updateInitiative: Initiative;
  updateInternalChat: InternalChat;
  updateInternalChatMessage: InternalChatMessage;
  updateInternalChatUser: InternalChatUser;
  updateInternalChatUserLastRead: InternalChatUser;
  updateKpiGroup: KpiGroup;
  updateKpiGroupMetric: KpiGroupMetric;
  updateLoyaltyMember: LoyaltyMember;
  updateLoyaltyReward: LoyaltyReward;
  updateMessage: Message;
  updateMessageTemplate?: Maybe<MessageTemplate>;
  updateNotificationTemplate: NotificationTemplate;
  updateOrganization: Organization;
  updateOrganizationReport: OrganizationReport;
  updatePatient: Patient;
  updatePatientHistoryItem: PatientHistoryItem;
  updatePatientRecord: PatientRecord;
  updatePatientStatus: PatientStatus;
  updatePayment: Payment;
  updatePet: Pet;
  updatePetSelfie: PetSelfie;
  updatePimsReminderType: PimsReminderType;
  updatePimsSettings: Scalars['Boolean']['output'];
  updatePmsApptType: PmsApptType;
  updatePmsDb: PmsDb;
  updatePrescription: Prescription;
  updatePrescriptionRefillRequest: PrescriptionRefillRequest;
  updatePressItem: PressItem;
  updatePrivateNote: PrivateNote;
  updateProduct: Product;
  updateProviderAvailability: ProviderAvailability;
  updateReportMetric: ReportMetric;
  updateReportTemplate: ReportTemplate;
  updateReschedule: Reschedule;
  updateRoom: Room;
  updateRoomService: RoomService;
  updateScheduledBulkMessage: ScheduledBulkMessage;
  updateScheduledMessage: ScheduledMessage;
  updateSchedulingRules: SchedulingRules;
  updateService: Service;
  updateServiceCategory: ServiceCategory;
  updateServiceForm: ServiceForm;
  updateTagCategory: TagCategory;
  updateTransaction: Transaction;
  updateTreatment: Treatment;
  updateUser: User;
  updateUserAuthInfo?: Maybe<Scalars['Void']['output']>;
  updateUserDesktopNotificationToken?: Maybe<Scalars['Void']['output']>;
  updateUserPushNotificationToken?: Maybe<Scalars['Void']['output']>;
  updateWidget: Widget;
  updateWidgetOptions: WidgetOptions;
  updateWidgetService: WidgetService;
  updateWidgetSisterLocation: WidgetSisterLocation;
  uploadAttachment?: Maybe<Scalars['Void']['output']>;
  verifyUserPhone?: Maybe<User>;
  writebackChat: Array<Scalars['String']['output']>;
  writebackClientForm?: Maybe<Scalars['Void']['output']>;
};


export type MutationAddAiAgentInstructionForClinicArgs = {
  clinicId: Scalars['ID']['input'];
  instruction: Scalars['String']['input'];
};


export type MutationAddClinicToClientArgs = {
  clientId: Scalars['ID']['input'];
  clinicId: Scalars['ID']['input'];
};


export type MutationAddLoyaltyEarningArgs = {
  data: AddLoyaltyEarningInput;
  memberId: Scalars['ID']['input'];
};


export type MutationAddLoyaltyEarningToClientArgs = {
  clientId: Scalars['ID']['input'];
  data: AddLoyaltyEarningInput;
};


export type MutationAddPointsToLoyaltyMemberArgs = {
  id: Scalars['ID']['input'];
  points: Scalars['NonNegativeInt']['input'];
};


export type MutationAddToAppWaitlistArgs = {
  data: PhoneInput;
};


export type MutationAddToEmailListArgs = {
  email: Scalars['String']['input'];
};


export type MutationAddUserToClientArgs = {
  clientId: Scalars['ID']['input'];
  input: VerifyClientLinkInput;
  userId: Scalars['ID']['input'];
};


export type MutationAddUserToClinicsAndClinicGroupsArgs = {
  data: AddUserToClinicsAndClinicGroupsInput;
};


export type MutationApplyAiImprovementItemArgs = {
  itemId: Scalars['ID']['input'];
};


export type MutationApprovePrescriptionRefillRequestArgs = {
  actionItemId?: InputMaybe<Scalars['ID']['input']>;
  id: Scalars['ID']['input'];
};


export type MutationApproveRedemptionRequestArgs = {
  id: Scalars['ID']['input'];
};


export type MutationApproveRescheduleArgs = {
  id: Scalars['ID']['input'];
  skipSchedulingDateBounds?: InputMaybe<Scalars['Boolean']['input']>;
};


export type MutationArchiveCustomerSegmentArgs = {
  id: Scalars['ID']['input'];
};


export type MutationArchiveNotificationTemplateArgs = {
  notificationTemplateId: Scalars['ID']['input'];
};


export type MutationArchiveScheduledBulkMessageArgs = {
  scheduledBulkMessageId: Scalars['ID']['input'];
};


export type MutationAssignClientFormToClientArgs = {
  clientId: Scalars['ID']['input'];
  id: Scalars['ID']['input'];
};


export type MutationAssignClientFormToPatientArgs = {
  id: Scalars['ID']['input'];
  patientId: Scalars['ID']['input'];
};


export type MutationBulkCreateUsersArgs = {
  users: Array<BulkCreateUserInput>;
};


export type MutationBulkUpdateNotificationTemplatesArgs = {
  data: BulkUpdateNotificationTemplateInput;
  ids: Array<Scalars['ID']['input']>;
};


export type MutationBulkUpdateScheduledBulkMessagesArgs = {
  data: BulkUpdateScheduledBulkMessagesInput;
  ids: Array<Scalars['ID']['input']>;
};


export type MutationCancelPrescriptionRefillRequestArgs = {
  actionItemId?: InputMaybe<Scalars['ID']['input']>;
  id: Scalars['ID']['input'];
};


export type MutationCancelRedemptionRequestArgs = {
  id: Scalars['ID']['input'];
};


export type MutationCancelScheduledMessageArgs = {
  cancelledBy: Scalars['ID']['input'];
  scheduledMessageId: Scalars['ID']['input'];
};


export type MutationClearClinicGroupOnboardingCellNoteArgs = {
  clinic_group_id: Scalars['ID']['input'];
  clinic_id: Scalars['ID']['input'];
  column_id: Scalars['String']['input'];
};


export type MutationClientCancelAppointmentArgs = {
  id: Scalars['ID']['input'];
  reason?: InputMaybe<Scalars['String']['input']>;
};


export type MutationClientConfirmAppointmentArgs = {
  id: Scalars['ID']['input'];
};


export type MutationConfirmAppointmentArgs = {
  id: Scalars['ID']['input'];
};


export type MutationConvertPdfToFormElementsArgs = {
  data: ConvertPdfToFormInput;
};


export type MutationCopyCustomerSegmentAcrossClinicArgs = {
  destinationClinicId: Scalars['ID']['input'];
  id: Scalars['ID']['input'];
};


export type MutationCopyEmailTemplateAcrossClinicArgs = {
  destinationClinicId: Scalars['ID']['input'];
  id: Scalars['ID']['input'];
};


export type MutationCopyFormAcrossClinicArgs = {
  destinationClinicId: Scalars['ID']['input'];
  id: Scalars['ID']['input'];
};


export type MutationCopyNotificationTemplateAcrossClinicArgs = {
  destinationClinicId: Scalars['ID']['input'];
  notificationTemplateId: Scalars['ID']['input'];
  options: CopyNotificationTemplateAcrossClinicOptions;
};


export type MutationCreateActionItemArgs = {
  data: CreateActionItemInput;
};


export type MutationCreateAnimalArgs = {
  data: CreateAnimalInput;
};


export type MutationCreateAppointmentArgs = {
  data: CreateAppointmentInput;
};


export type MutationCreateAppointmentPromptArgs = {
  data: CreateAppointmentPromptInput;
};


export type MutationCreateBookingFlowEventArgs = {
  data: BookingFlowEventInput;
};


export type MutationCreateCampaignArgs = {
  data: CreateCampaignInput;
};


export type MutationCreateChatArgs = {
  data: CreateChatInput;
};


export type MutationCreateChatStatusArgs = {
  data: CreateChatStatusInput;
};


export type MutationCreateChatWithNonClientArgs = {
  data: CreateChatWithNonClientInput;
};


export type MutationCreateCheckInArgs = {
  data: CreateCheckInInput;
};


export type MutationCreateClientArgs = {
  data: CreateClientInput;
};


export type MutationCreateClientFormArgs = {
  data: CreateClientFormInput;
};


export type MutationCreateClinicArgs = {
  data: CreateClinicInput;
  shouldCreateWidget?: InputMaybe<Scalars['Boolean']['input']>;
};


export type MutationCreateClinicAdminArgs = {
  data: CreateClinicAdminInput;
};


export type MutationCreateClinicFeaturesArgs = {
  data: ClinicFeaturesInput;
};


export type MutationCreateClinicGroupArgs = {
  data: CreateClinicGroupInput;
};


export type MutationCreateClinicGroupClinicArgs = {
  data: CreateClinicGroupClinicInput;
};


export type MutationCreateClinicGroupUserArgs = {
  data: CreateClinicGroupUserInput;
};


export type MutationCreateClinicServiceArgs = {
  clinicId: Scalars['ID']['input'];
  data: CreateServiceInput;
};


export type MutationCreateClinicStatsArgs = {
  clinicId: Scalars['ID']['input'];
};


export type MutationCreateClinicianArgs = {
  data: CreateClinicianInput;
};


export type MutationCreateClinicianServiceArgs = {
  data: CreateClinicianServiceInput;
};


export type MutationCreateConnectInstallationArgs = {
  clinicId: Scalars['ID']['input'];
  data: CreateConnectInstallationInput;
  installationId: Scalars['ID']['input'];
};


export type MutationCreateCustomRoleArgs = {
  data: CreateCustomRoleInput;
};


export type MutationCreateCustomerSegmentArgs = {
  data: CreateCustomerSegmentInput;
};


export type MutationCreateDailyHuddleArgs = {
  clinicId: Scalars['ID']['input'];
  data: CreateDailyHuddleInput;
};


export type MutationCreateDataChatArgs = {
  data: CreateDataChatInput;
};


export type MutationCreateDiagnosisArgs = {
  data: CreateDiagnosisInput;
};


export type MutationCreateEmailTemplateArgs = {
  clinic?: InputMaybe<Scalars['ID']['input']>;
  clinicGroup?: InputMaybe<Scalars['ID']['input']>;
};


export type MutationCreateEntityReportArgs = {
  data: CreateEntityReportInput;
};


export type MutationCreateFamilyArgs = {
  data: CreateFamilyInput;
};


export type MutationCreateFormArgs = {
  data: CreateFormInput;
};


export type MutationCreateGoalArgs = {
  clinicId: Scalars['ID']['input'];
  data: CreateGoalInput;
};


export type MutationCreateInitiativeArgs = {
  data: CreateInitiativeInput;
};


export type MutationCreateInitiativeMetricArgs = {
  data: CreateInitiativeMetricInput;
};


export type MutationCreateInternalChatArgs = {
  data: CreateInternalChatInput;
};


export type MutationCreateInternalChatMessageArgs = {
  data: CreateInternalChatMessageInput;
};


export type MutationCreateInternalChatUserArgs = {
  chatId: Scalars['ID']['input'];
  userId: Scalars['ID']['input'];
};


export type MutationCreateInternalUsageEventArgs = {
  data: InternalUsageEventInput;
};


export type MutationCreateKpiGroupArgs = {
  data: CreateKpiGroupInput;
};


export type MutationCreateKpiGroupMetricArgs = {
  data: CreateKpiGroupMetricInput;
};


export type MutationCreateLoyaltyMemberArgs = {
  data: CreateLoyaltyMemberInput;
};


export type MutationCreateLoyaltyRedemptionArgs = {
  data: CreateLoyaltyRedemptionInput;
};


export type MutationCreateLoyaltyRewardArgs = {
  data: CreateLoyaltyRewardInput;
};


export type MutationCreateMessageArgs = {
  chatId: Scalars['ID']['input'];
  data: CreateMessageInput;
};


export type MutationCreateMessageTemplateArgs = {
  input: CreateMessageTemplateInput;
};


export type MutationCreateNotificationTemplateArgs = {
  data: CreateNotificationTemplateInput;
};


export type MutationCreateOrganizationArgs = {
  data: CreateOrganizationInput;
};


export type MutationCreateOrganizationReportArgs = {
  data: CreateOrganizationReportInput;
};


export type MutationCreatePatientArgs = {
  data: CreatePatientInput;
};


export type MutationCreatePatientHistoryItemArgs = {
  data: CreatePatientHistoryItemInput;
};


export type MutationCreatePatientRecordArgs = {
  data: CreatePatientRecordInput;
};


export type MutationCreatePaymentLinkArgs = {
  data: CreatePaymentLinkInput;
};


export type MutationCreatePetArgs = {
  data: CreatePetInput;
};


export type MutationCreatePetSelfieArgs = {
  data: CreatePetSelfieInput;
};


export type MutationCreatePimsSettingsArgs = {
  data: CreatePimsSettingsInput;
};


export type MutationCreatePmsApptTypeArgs = {
  clinicId: Scalars['ID']['input'];
  data: CreatePmsApptTypeInput;
};


export type MutationCreatePmsDbArgs = {
  data: CreatePmsDbInput;
  shouldCreateWidget?: InputMaybe<Scalars['Boolean']['input']>;
};


export type MutationCreatePrescriptionArgs = {
  data: CreatePrescriptionInput;
};


export type MutationCreatePrescriptionRefillRequestArgs = {
  data: CreatePrescriptionRefillRequestInput;
};


export type MutationCreatePressItemArgs = {
  data: CreatePressItemInput;
};


export type MutationCreatePrivateNoteArgs = {
  data: PrivateNoteInput;
  patientRecordId: Scalars['ID']['input'];
};


export type MutationCreateProductArgs = {
  data: CreateProductInput;
};


export type MutationCreateProviderAvailabilitiesArgs = {
  clinicId: Scalars['ID']['input'];
  clinicianId?: InputMaybe<Scalars['ID']['input']>;
  inputs: Array<CreateAvailabilitiesInput>;
  roomId?: InputMaybe<Scalars['ID']['input']>;
};


export type MutationCreateProviderAvailabilityArgs = {
  input: CreateProviderAvailabilityInput;
};


export type MutationCreateReportClinicArgs = {
  data: CreateReportClinicInput;
};


export type MutationCreateReportMetricArgs = {
  data: CreateReportMetricInput;
};


export type MutationCreateReportTemplateArgs = {
  data: CreateReportTemplateInput;
};


export type MutationCreateReportTemplateMetricArgs = {
  data: CreateReportTemplateMetricInput;
};


export type MutationCreateRescheduleArgs = {
  data: CreateRescheduleInput;
};


export type MutationCreateReviewArgs = {
  data: CreateReviewInput;
};


export type MutationCreateRoomArgs = {
  data: CreateRoomInput;
};


export type MutationCreateRoomServiceArgs = {
  data: CreateRoomServiceInput;
};


export type MutationCreateScheduledBulkMessageArgs = {
  data: CreateScheduledBulkMessageInput;
};


export type MutationCreateScheduledMessageArgs = {
  data: CreateScheduledMessageInput;
};


export type MutationCreateSchedulingRulesArgs = {
  data: CreateSchedulingRulesInput;
};


export type MutationCreateServiceArgs = {
  data: CreateServiceInput;
};


export type MutationCreateServiceCategoryArgs = {
  data: CreateServiceCategoryInput;
};


export type MutationCreateServiceFormArgs = {
  data: CreateServiceFormInput;
};


export type MutationCreateTagArgs = {
  data: CreateTagInput;
};


export type MutationCreateTagCategoryArgs = {
  data: CreateTagCategoryInput;
};


export type MutationCreateTemplateClinicArgs = {
  data: CreateTemplateClinicInput;
};


export type MutationCreateTransactionArgs = {
  data: CreateTransactionInput;
};


export type MutationCreateTreatmentArgs = {
  clinicId: Scalars['ID']['input'];
  data: CreateTreatmentInput;
};


export type MutationCreateUserArgs = {
  data: CreateUserInput;
  email: Scalars['String']['input'];
  password: Scalars['String']['input'];
  role?: InputMaybe<Scalars['String']['input']>;
};


export type MutationCreateUserTrackingBulkMessageArgs = {
  clinicId: Scalars['ID']['input'];
  membership: UserTrackingMembership;
  metric: UserTrackingMetric;
};


export type MutationCreateWidgetArgs = {
  data: CreateWidgetInput;
};


export type MutationCreateWidgetOptionsArgs = {
  data: CreateWidgetOptionsInput;
};


export type MutationCreateWidgetServiceArgs = {
  data: CreateWidgetServiceInput;
};


export type MutationCreateWidgetSisterLocationArgs = {
  input: CreateWidgetSisterLocationInput;
};


export type MutationDeleteActionItemArgs = {
  id: Scalars['ID']['input'];
};


export type MutationDeleteAnimalArgs = {
  id: Scalars['ID']['input'];
};


export type MutationDeleteAppointmentArgs = {
  id: Scalars['ID']['input'];
};


export type MutationDeleteAppointmentPromptArgs = {
  id: Scalars['ID']['input'];
};


export type MutationDeleteChatArgs = {
  id: Scalars['ID']['input'];
};


export type MutationDeleteChatStatusArgs = {
  id: Scalars['ID']['input'];
};


export type MutationDeleteClientArgs = {
  id: Scalars['ID']['input'];
};


export type MutationDeleteClinicArgs = {
  id: Scalars['ID']['input'];
};


export type MutationDeleteClinicAdminArgs = {
  clinicId: Scalars['ID']['input'];
  userId: Scalars['ID']['input'];
};


export type MutationDeleteClinicFeaturesArgs = {
  id: Scalars['ID']['input'];
};


export type MutationDeleteClinicGroupClinicArgs = {
  clinicGroupClinicId: Scalars['ID']['input'];
};


export type MutationDeleteClinicGroupUserArgs = {
  clinicGroupUserId: Scalars['ID']['input'];
};


export type MutationDeleteClinicServiceArgs = {
  clinicId: Scalars['ID']['input'];
  id: Scalars['ID']['input'];
};


export type MutationDeleteClinicianArgs = {
  id: Scalars['ID']['input'];
};


export type MutationDeleteClinicianServiceArgs = {
  id: Scalars['ID']['input'];
};


export type MutationDeleteConnectInstallationArgs = {
  clinicId: Scalars['ID']['input'];
  installationId: Scalars['ID']['input'];
};


export type MutationDeleteCustomRoleArgs = {
  id: Scalars['ID']['input'];
};


export type MutationDeleteCustomerSegmentArgs = {
  id: Scalars['ID']['input'];
};


export type MutationDeleteDailyHuddleArgs = {
  clinicId: Scalars['ID']['input'];
  dailyHuddleId: Scalars['ID']['input'];
};


export type MutationDeleteDiagnosisArgs = {
  id: Scalars['ID']['input'];
};


export type MutationDeleteEmailTemplateArgs = {
  id: Scalars['ID']['input'];
};


export type MutationDeleteFamilyArgs = {
  id: Scalars['ID']['input'];
};


export type MutationDeleteGoalArgs = {
  clinicId: Scalars['ID']['input'];
  goalId: Scalars['ID']['input'];
};


export type MutationDeleteInitiativeArgs = {
  id: Scalars['ID']['input'];
};


export type MutationDeleteInitiativeMetricArgs = {
  id: Scalars['ID']['input'];
};


export type MutationDeleteInternalChatArgs = {
  id: Scalars['ID']['input'];
};


export type MutationDeleteInternalChatMessageArgs = {
  id: Scalars['ID']['input'];
};


export type MutationDeleteInternalChatUserArgs = {
  id: Scalars['ID']['input'];
};


export type MutationDeleteKpiGroupArgs = {
  id: Scalars['ID']['input'];
};


export type MutationDeleteKpiGroupMetricArgs = {
  id: Scalars['ID']['input'];
};


export type MutationDeleteLoyaltyMemberArgs = {
  id: Scalars['ID']['input'];
};


export type MutationDeleteLoyaltyRewardArgs = {
  id: Scalars['ID']['input'];
};


export type MutationDeleteMessageArgs = {
  chatId: Scalars['ID']['input'];
  messageId: Scalars['ID']['input'];
};


export type MutationDeleteMessageTemplateArgs = {
  id: Scalars['ID']['input'];
};


export type MutationDeleteNotificationTemplateArgs = {
  notificationTemplateId: Scalars['ID']['input'];
};


export type MutationDeleteOrganizationArgs = {
  id: Scalars['ID']['input'];
};


export type MutationDeleteOrganizationReportArgs = {
  id: Scalars['ID']['input'];
};


export type MutationDeletePatientArgs = {
  id: Scalars['ID']['input'];
};


export type MutationDeletePatientHistoryItemArgs = {
  id: Scalars['ID']['input'];
};


export type MutationDeletePatientRecordArgs = {
  id: Scalars['ID']['input'];
};


export type MutationDeletePetArgs = {
  id: Scalars['ID']['input'];
};


export type MutationDeletePmsApptTypeArgs = {
  clinicId: Scalars['ID']['input'];
  pmsApptTypeId: Scalars['ID']['input'];
};


export type MutationDeletePrescriptionArgs = {
  prescriptionId: Scalars['ID']['input'];
};


export type MutationDeletePressItemArgs = {
  id: Scalars['ID']['input'];
};


export type MutationDeletePrivateNoteArgs = {
  id: Scalars['ID']['input'];
  patientRecordId: Scalars['ID']['input'];
};


export type MutationDeleteProductArgs = {
  productId: Scalars['ID']['input'];
};


export type MutationDeleteReportClinicArgs = {
  id: Scalars['ID']['input'];
};


export type MutationDeleteReportMetricArgs = {
  id: Scalars['ID']['input'];
};


export type MutationDeleteReportTemplateArgs = {
  id: Scalars['ID']['input'];
};


export type MutationDeleteReportTemplateMetricArgs = {
  id: Scalars['ID']['input'];
};


export type MutationDeleteRescheduleArgs = {
  id: Scalars['ID']['input'];
};


export type MutationDeleteReviewArgs = {
  id: Scalars['ID']['input'];
};


export type MutationDeleteRoomArgs = {
  roomId: Scalars['ID']['input'];
};


export type MutationDeleteRoomServiceArgs = {
  id: Scalars['ID']['input'];
};


export type MutationDeleteScheduledBulkMessageArgs = {
  scheduledBulkMessageId: Scalars['ID']['input'];
};


export type MutationDeleteScheduledMessageArgs = {
  scheduledMessageId: Scalars['ID']['input'];
};


export type MutationDeleteSchedulingRulesArgs = {
  schedulingRulesId: Scalars['ID']['input'];
};


export type MutationDeleteServiceArgs = {
  id: Scalars['ID']['input'];
};


export type MutationDeleteServiceCategoryArgs = {
  clinicId: Scalars['ID']['input'];
  id: Scalars['ID']['input'];
};


export type MutationDeleteServiceFormArgs = {
  id: Scalars['ID']['input'];
};


export type MutationDeleteServiceFormByServiceAndFormArgs = {
  formId: Scalars['ID']['input'];
  serviceId: Scalars['ID']['input'];
};


export type MutationDeleteTagArgs = {
  id: Scalars['ID']['input'];
};


export type MutationDeleteTagCategoryArgs = {
  id: Scalars['ID']['input'];
};


export type MutationDeleteTagsForEntityArgs = {
  entityId: Scalars['String']['input'];
  entityType: TagEntity;
};


export type MutationDeleteTemplateClinicArgs = {
  id: Scalars['ID']['input'];
};


export type MutationDeleteTransactionArgs = {
  id: Scalars['ID']['input'];
};


export type MutationDeleteTreatmentArgs = {
  clinicId: Scalars['ID']['input'];
  treatmentId: Scalars['ID']['input'];
};


export type MutationDeleteUserArgs = {
  id: Scalars['ID']['input'];
};


export type MutationDeleteUserNotificationArgs = {
  id: Scalars['ID']['input'];
};


export type MutationDeleteWidgetArgs = {
  id: Scalars['ID']['input'];
};


export type MutationDeleteWidgetOptionsArgs = {
  widgetId: Scalars['ID']['input'];
};


export type MutationDeleteWidgetServiceArgs = {
  id: Scalars['ID']['input'];
};


export type MutationDeleteWidgetServiceByWidgetAndServiceArgs = {
  serviceId: Scalars['ID']['input'];
  widgetId: Scalars['ID']['input'];
};


export type MutationDenyPendingAppointmentArgs = {
  appointmentId: Scalars['ID']['input'];
  message: Scalars['String']['input'];
};


export type MutationDenyPrescriptionRefillRequestArgs = {
  actionItemId?: InputMaybe<Scalars['ID']['input']>;
  id: Scalars['ID']['input'];
  reason: Scalars['String']['input'];
};


export type MutationDenyRescheduleArgs = {
  id: Scalars['ID']['input'];
  reason: Scalars['String']['input'];
};


export type MutationDismissAiImprovementItemArgs = {
  itemId: Scalars['ID']['input'];
};


export type MutationDuplicateEmailTemplateArgs = {
  id: Scalars['ID']['input'];
};


export type MutationEmailCustomerSegmentCsvArgs = {
  data: EmailCustomerSegmentCsvInput;
};


export type MutationExecuteApprovedChangeArgs = {
  input: ExecuteApprovedChangeInput;
};


export type MutationExpandEntityLinkFieldsForClinicsArgs = {
  clinicIds: Array<Scalars['ID']['input']>;
  entityType: EntityLinkType;
  fields: Array<Scalars['String']['input']>;
  parentId: Scalars['ID']['input'];
};


export type MutationForcePasswordResetArgs = {
  clinicGroupId?: InputMaybe<Scalars['ID']['input']>;
  clinicId?: InputMaybe<Scalars['ID']['input']>;
  userId: Scalars['ID']['input'];
};


export type MutationInitializeAiAgentForClinicArgs = {
  agentType?: InputMaybe<AiCallsAgentType>;
  clinicId: Scalars['ID']['input'];
};


export type MutationInitializeEntityLinksForClinicArgs = {
  clinicGroupId: Scalars['ID']['input'];
  clinicId: Scalars['ID']['input'];
  entityTypes?: InputMaybe<Array<EntityLinkType>>;
};


export type MutationInitializeEntityLinksForEntityTypeArgs = {
  clinicGroupId: Scalars['ID']['input'];
  clinicIds?: InputMaybe<Array<Scalars['ID']['input']>>;
  entityType: EntityLinkType;
};


export type MutationLogArgs = {
  data: LogInput;
};


export type MutationMakeClientPhonePrimaryArgs = {
  clientId: Scalars['ID']['input'];
  clinicId: Scalars['ID']['input'];
  phoneId: Scalars['ID']['input'];
};


export type MutationMakePrimaryClinicApptStatusArgs = {
  apptStatusId: Scalars['ID']['input'];
  clinicId: Scalars['ID']['input'];
};


export type MutationMakePrimaryClinicSpeciesArgs = {
  clinicId: Scalars['ID']['input'];
  speciesId: Scalars['ID']['input'];
};


export type MutationMarkAppointmentAsResolvedArgs = {
  id: Scalars['ID']['input'];
  reason?: InputMaybe<ResolveReason>;
};


export type MutationMarkPetSelfieViewedArgs = {
  id: Scalars['ID']['input'];
};


export type MutationMarkUserNotificationAsReadArgs = {
  id: Scalars['ID']['input'];
};


export type MutationMemberRequestRedemptionArgs = {
  memberId: Scalars['ID']['input'];
  rewardId: Scalars['ID']['input'];
};


export type MutationMergeChatArgs = {
  mergeFromChatId: Scalars['ID']['input'];
  mergeIntoChatId: Scalars['ID']['input'];
};


export type MutationMintClinicAgentSessionArgs = {
  clinicGroupId?: InputMaybe<Scalars['ID']['input']>;
  clinicId?: InputMaybe<Scalars['ID']['input']>;
};


export type MutationPopulateEntityLinkChildrenArgs = {
  clinicIds?: InputMaybe<Array<Scalars['ID']['input']>>;
  entityType: EntityLinkType;
  linkedFields?: InputMaybe<Array<Scalars['String']['input']>>;
  parentId: Scalars['ID']['input'];
};


export type MutationPreviewAiImprovementItemArgs = {
  answer: Scalars['String']['input'];
  itemId: Scalars['ID']['input'];
};


export type MutationReassignClinicApptStatusArgs = {
  apptStatusId: Scalars['ID']['input'];
  clinicId: Scalars['ID']['input'];
  newStatus: AppointmentStatus;
};


export type MutationRecordClinicHealthCheckRunArgs = {
  input: RecordClinicHealthCheckRunInput;
};


export type MutationRefreshGoalArgs = {
  clinicId: Scalars['ID']['input'];
  goalId: Scalars['ID']['input'];
};


export type MutationRefreshGoalsForClinicArgs = {
  clinicId: Scalars['ID']['input'];
};


export type MutationRefundPaymentArgs = {
  id: Scalars['ID']['input'];
  refundAmount: Scalars['PositiveInt']['input'];
};


export type MutationRelinkEntityArgs = {
  childId: Scalars['ID']['input'];
  entityType: EntityLinkType;
};


export type MutationRelinkEntityFieldsArgs = {
  childId: Scalars['ID']['input'];
  entityType: EntityLinkType;
  fields: Array<Scalars['String']['input']>;
};


export type MutationRemoveFromEmailListArgs = {
  email: Scalars['String']['input'];
};


export type MutationRemovePaymentMethodArgs = {
  paymentMethodId: Scalars['ID']['input'];
};


export type MutationRemoveWidgetSisterLocationArgs = {
  id: Scalars['ID']['input'];
};


export type MutationRequestChangeForPendingAppointmentArgs = {
  appointmentId: Scalars['ID']['input'];
  message: Scalars['String']['input'];
};


export type MutationResendInviteEmailArgs = {
  clinicGroupId?: InputMaybe<Scalars['ID']['input']>;
  clinicId?: InputMaybe<Scalars['ID']['input']>;
  userId: Scalars['ID']['input'];
};


export type MutationSendAppointmentPromptArgs = {
  data: CreateAppointmentPromptInput;
};


export type MutationSendClinicAgentMessageArgs = {
  input: SendClinicAgentMessageInput;
};


export type MutationSendDataChatPromptArgs = {
  data: DataChatPromptInput;
};


export type MutationSendNotificationArgs = {
  input: SendNotificationInput;
};


export type MutationSendPaymentReceiptArgs = {
  id: Scalars['ID']['input'];
};


export type MutationSendScheduledBulkMessageArgs = {
  scheduledBulkMessageId: Scalars['ID']['input'];
};


export type MutationSendSupportBotMessageArgs = {
  input: SendSupportBotMessageInput;
};


export type MutationSendTestEmailArgs = {
  clinicId: Scalars['ID']['input'];
  content: SendTestEmailContent;
  emails: Array<Scalars['String']['input']>;
};


export type MutationSetClinicGoLiveDateArgs = {
  clinicId: Scalars['ID']['input'];
  go_live_date?: InputMaybe<Scalars['String']['input']>;
};


export type MutationSetClinicGroupOnboardingCellNoteArgs = {
  assigned_to?: InputMaybe<Scalars['ID']['input']>;
  clinic_group_id: Scalars['ID']['input'];
  clinic_id: Scalars['ID']['input'];
  column_id: Scalars['String']['input'];
  is_accepted?: InputMaybe<Scalars['Boolean']['input']>;
  note?: InputMaybe<Scalars['String']['input']>;
  waiting_on?: InputMaybe<ClinicGroupOnboardingWaitingOn>;
};


export type MutationSetClinicGroupOnboardingColumnCriterionArgs = {
  clinic_group_id: Scalars['ID']['input'];
  column_id: Scalars['String']['input'];
  criterion?: InputMaybe<ClinicGroupOnboardingCriterionInput>;
};


export type MutationSetClinicGroupOnboardingColumnsHiddenArgs = {
  clinic_group_id: Scalars['ID']['input'];
  column_ids: Array<Scalars['String']['input']>;
  is_hidden: Scalars['Boolean']['input'];
};


export type MutationSetClinicGroupOnboardingColumnsScoredArgs = {
  clinic_group_id: Scalars['ID']['input'];
  column_ids: Array<Scalars['String']['input']>;
  is_scored: Scalars['Boolean']['input'];
};


export type MutationSetClinicGroupOnboardingGoLiveDateArgs = {
  clinic_group_id: Scalars['ID']['input'];
  clinic_id: Scalars['ID']['input'];
  go_live_date?: InputMaybe<Scalars['String']['input']>;
};


export type MutationSetClinicGroupOnboardingStepStatusArgs = {
  clinic_group_id: Scalars['ID']['input'];
  clinic_id: Scalars['ID']['input'];
  step_key: Scalars['String']['input'];
  value?: InputMaybe<Scalars['String']['input']>;
};


export type MutationSetClinicGroupTrancheCompleteArgs = {
  clinic_group_id: Scalars['ID']['input'];
  is_complete: Scalars['Boolean']['input'];
  tranche_key: Scalars['String']['input'];
};


export type MutationSetDefaultPaymentMethodArgs = {
  paymentMethodId: Scalars['ID']['input'];
};


export type MutationShareVaccineRecordsArgs = {
  input: ShareVaccineRecordsInput;
};


export type MutationSubmitAppointmentArgs = {
  data: SubmitAppointmentInput;
};


export type MutationSuggestAiAgentPlaybookEditArgs = {
  clinicId: Scalars['ID']['input'];
  currentPlaybook: Scalars['String']['input'];
  instruction: Scalars['String']['input'];
};


export type MutationSyncAppointmentsForBookableTimesArgs = {
  clinicId: Scalars['ID']['input'];
};


export type MutationSyncIndividualClientArgs = {
  clientId: Scalars['ID']['input'];
  clinicId: Scalars['ID']['input'];
};


export type MutationSyncIndividualPatientArgs = {
  clinicId: Scalars['ID']['input'];
  patientId: Scalars['ID']['input'];
};


export type MutationSyncPimsClientByPmsIdArgs = {
  clientPmsId: Scalars['String']['input'];
  clinicId: Scalars['ID']['input'];
};


export type MutationSyncPimsRemindersForPatientArgs = {
  patientId: Scalars['ID']['input'];
};


export type MutationSyncVaccinationRecordsForPatientArgs = {
  patientId: Scalars['ID']['input'];
};


export type MutationTogglePaymentIsEnteredArgs = {
  id: Scalars['ID']['input'];
};


export type MutationTriggerLeadCapturedWebhookArgs = {
  data: LeadCapturedInput;
};


export type MutationTriggerServiceUpdateForClinicArgs = {
  clinicId: Scalars['ID']['input'];
};


export type MutationTriggerSyncForClinicArgs = {
  clinicId: Scalars['ID']['input'];
  isFullSync: Scalars['Boolean']['input'];
};


export type MutationTriggerUpdateServiceRestartForClinicArgs = {
  clinicId: Scalars['ID']['input'];
};


export type MutationTriggerWebhookTestArgs = {
  data: TriggerWebhookInput;
};


export type MutationUnlinkEntityArgs = {
  childId: Scalars['ID']['input'];
  entityType: EntityLinkType;
};


export type MutationUnlinkEntityFieldsArgs = {
  childId: Scalars['ID']['input'];
  entityType: EntityLinkType;
  fields: Array<Scalars['String']['input']>;
};


export type MutationUnlinkEntityFieldsForClinicsArgs = {
  clinicIds: Array<Scalars['ID']['input']>;
  entityType: EntityLinkType;
  fields: Array<Scalars['String']['input']>;
  parentId: Scalars['ID']['input'];
};


export type MutationUnsubscribeEmailArgs = {
  email: Scalars['String']['input'];
};


export type MutationUpdateActionItemArgs = {
  data: UpdateActionItemInput;
  id: Scalars['ID']['input'];
};


export type MutationUpdateAiAgentPlaybookForClinicArgs = {
  clinicId: Scalars['ID']['input'];
  playbook?: InputMaybe<Scalars['String']['input']>;
};


export type MutationUpdateAnimalArgs = {
  data: UpdateAnimalInput;
  id: Scalars['ID']['input'];
};


export type MutationUpdateAppointmentArgs = {
  data: UpdateAppointmentInput;
  id: Scalars['ID']['input'];
};


export type MutationUpdateAppointmentClientPatientArgs = {
  clientId?: InputMaybe<Scalars['ID']['input']>;
  id: Scalars['ID']['input'];
  patientId?: InputMaybe<Scalars['ID']['input']>;
};


export type MutationUpdateAppointmentPromptArgs = {
  data: UpdateAppointmentPromptInput;
  id: Scalars['ID']['input'];
};


export type MutationUpdateBreedArgs = {
  breedId: Scalars['String']['input'];
  clinicId: Scalars['ID']['input'];
  data: UpdateBreedInput;
};


export type MutationUpdateCallArgs = {
  id: Scalars['ID']['input'];
  input: UpdateCallInput;
};


export type MutationUpdateCampaignArgs = {
  data: UpdateCampaignInput;
  id: Scalars['ID']['input'];
};


export type MutationUpdateCampaignFeaturedStatsArgs = {
  featured: Array<Scalars['String']['input']>;
  id: Scalars['ID']['input'];
};


export type MutationUpdateCampaignNotificationFeaturedStatsArgs = {
  featured: Array<Scalars['String']['input']>;
  id: Scalars['ID']['input'];
};


export type MutationUpdateCampaignScheduledBulkMessageFeaturedStatsArgs = {
  featured: Array<Scalars['String']['input']>;
  id: Scalars['ID']['input'];
};


export type MutationUpdateCampaignWidgetFeaturedStatsArgs = {
  featured: Array<Scalars['String']['input']>;
  id: Scalars['ID']['input'];
};


export type MutationUpdateChatArgs = {
  data: UpdateChatInput;
  id: Scalars['ID']['input'];
};


export type MutationUpdateChatStatusArgs = {
  data: UpdateChatStatusInput;
  id: Scalars['ID']['input'];
};


export type MutationUpdateChckupMetadataArgs = {
  data: ChckupMetadataInput;
};


export type MutationUpdateCheckInArgs = {
  data: UpdateCheckInInput;
  id: Scalars['ID']['input'];
};


export type MutationUpdateClientArgs = {
  data: UpdateClientInput;
  id: Scalars['ID']['input'];
};


export type MutationUpdateClientFormArgs = {
  data: UpdateClientFormInput;
  id: Scalars['ID']['input'];
};


export type MutationUpdateClientStatusArgs = {
  clientStatusId: Scalars['ID']['input'];
  clinicId: Scalars['ID']['input'];
  data: UpdateClientStatusInput;
};


export type MutationUpdateClinicArgs = {
  data: UpdateClinicInput;
  id: Scalars['ID']['input'];
};


export type MutationUpdateClinicAdminArgs = {
  clinicId: Scalars['ID']['input'];
  data: UpdateClinicAdminInput;
  userId: Scalars['ID']['input'];
};


export type MutationUpdateClinicApptStatusArgs = {
  apptStatusId: Scalars['ID']['input'];
  clinicId: Scalars['ID']['input'];
  data: UpdateClinicApptStatusInput;
};


export type MutationUpdateClinicFeaturesArgs = {
  data: ClinicFeaturesInput;
  id: Scalars['ID']['input'];
};


export type MutationUpdateClinicGroupArgs = {
  data: UpdateClinicGroupInput;
  id: Scalars['ID']['input'];
};


export type MutationUpdateClinicGroupExpectedMergeTagsArgs = {
  clinic_group_id: Scalars['ID']['input'];
  merge_tags: Array<Scalars['String']['input']>;
};


export type MutationUpdateClinicGroupOnboardingStepsArgs = {
  clinic_group_id: Scalars['ID']['input'];
  steps: Array<ClinicGroupOnboardingStepInput>;
};


export type MutationUpdateClinicGroupOnboardingTranchesArgs = {
  clinic_group_id: Scalars['ID']['input'];
  tranches: Array<ClinicGroupOnboardingTrancheInput>;
};


export type MutationUpdateClinicGroupSettingsArgs = {
  clinicGroupId: Scalars['ID']['input'];
  settings: ClinicSettingsInput;
};


export type MutationUpdateClinicGroupUserArgs = {
  clinicGroupUserId: Scalars['ID']['input'];
  data: UpdateClinicGroupUserInput;
};


export type MutationUpdateClinicServiceArgs = {
  clinicId: Scalars['ID']['input'];
  data: UpdateServiceInput;
  id: Scalars['ID']['input'];
};


export type MutationUpdateClinicSexArgs = {
  data: UpdateClinicSexInput;
  id: Scalars['ID']['input'];
};


export type MutationUpdateClinicSpeciesArgs = {
  clinicId: Scalars['ID']['input'];
  data: UpdateClinicSpeciesInput;
  speciesId: Scalars['ID']['input'];
};


export type MutationUpdateClinicianArgs = {
  data: UpdateClinicianInput;
  id: Scalars['ID']['input'];
};


export type MutationUpdateClinicianServiceArgs = {
  data: UpdateClinicianServiceInput;
  id: Scalars['ID']['input'];
};


export type MutationUpdateConnectInstallationArgs = {
  clinicId: Scalars['ID']['input'];
  data: UpdateConnectInstallationInput;
  installationId: Scalars['ID']['input'];
};


export type MutationUpdateCustomRoleArgs = {
  data: UpdateCustomRoleInput;
  id: Scalars['ID']['input'];
};


export type MutationUpdateCustomerSegmentArgs = {
  data: UpdateCustomerSegmentInput;
  id: Scalars['ID']['input'];
};


export type MutationUpdateDailyHuddleArgs = {
  clinicId: Scalars['ID']['input'];
  dailyHuddleId: Scalars['ID']['input'];
  data: UpdateDailyHuddleInput;
};


export type MutationUpdateDataChatArgs = {
  data: UpdateDataChatInput;
  id: Scalars['ID']['input'];
};


export type MutationUpdateDiagnosisArgs = {
  data: UpdateDiagnosisInput;
  id: Scalars['ID']['input'];
};


export type MutationUpdateEmailTemplateArgs = {
  id: Scalars['ID']['input'];
  input: UpdateEmailTemplateInput;
};


export type MutationUpdateFamilyArgs = {
  data: UpdateFamilyInput;
  id: Scalars['ID']['input'];
};


export type MutationUpdateFormArgs = {
  data: UpdateFormInput;
  id: Scalars['ID']['input'];
};


export type MutationUpdateGoalArgs = {
  clinicId: Scalars['ID']['input'];
  data: UpdateGoalInput;
  goalId: Scalars['ID']['input'];
};


export type MutationUpdateInitiativeArgs = {
  data: UpdateInitiativeInput;
  id: Scalars['ID']['input'];
};


export type MutationUpdateInternalChatArgs = {
  data: UpdateInternalChatInput;
  id: Scalars['ID']['input'];
};


export type MutationUpdateInternalChatMessageArgs = {
  data: UpdateInternalChatMessageInput;
  id: Scalars['ID']['input'];
};


export type MutationUpdateInternalChatUserArgs = {
  data: UpdateInternalChatUserInput;
  id: Scalars['ID']['input'];
};


export type MutationUpdateInternalChatUserLastReadArgs = {
  chatId: Scalars['ID']['input'];
  lastReadTime: Scalars['NonNegativeInt']['input'];
  userId: Scalars['ID']['input'];
};


export type MutationUpdateKpiGroupArgs = {
  data: UpdateKpiGroupInput;
  id: Scalars['ID']['input'];
};


export type MutationUpdateKpiGroupMetricArgs = {
  data: UpdateKpiGroupMetricInput;
  id: Scalars['ID']['input'];
};


export type MutationUpdateLoyaltyMemberArgs = {
  data: UpdateLoyaltyMemberInput;
  id: Scalars['ID']['input'];
};


export type MutationUpdateLoyaltyRewardArgs = {
  data: UpdateLoyaltyRewardInput;
  id: Scalars['ID']['input'];
};


export type MutationUpdateMessageArgs = {
  chatId: Scalars['ID']['input'];
  data: UpdateMessageInput;
  messageId: Scalars['ID']['input'];
};


export type MutationUpdateMessageTemplateArgs = {
  id: Scalars['ID']['input'];
  input: UpdateMessageTemplateInput;
};


export type MutationUpdateNotificationTemplateArgs = {
  data: UpdateNotificationTemplateInput;
  notificationTemplateId: Scalars['ID']['input'];
};


export type MutationUpdateOrganizationArgs = {
  data: UpdateOrganizationInput;
  id: Scalars['ID']['input'];
};


export type MutationUpdateOrganizationReportArgs = {
  data: UpdateOrganizationReportInput;
  id: Scalars['ID']['input'];
};


export type MutationUpdatePatientArgs = {
  data: UpdatePatientInput;
  id: Scalars['ID']['input'];
};


export type MutationUpdatePatientHistoryItemArgs = {
  data: UpdatePatientHistoryItemInput;
  id: Scalars['ID']['input'];
};


export type MutationUpdatePatientRecordArgs = {
  data: UpdatePatientRecordInput;
  id: Scalars['ID']['input'];
};


export type MutationUpdatePatientStatusArgs = {
  clinicId: Scalars['ID']['input'];
  data: UpdatePatientStatusInput;
  patientStatusId: Scalars['ID']['input'];
};


export type MutationUpdatePaymentArgs = {
  data: UpdatePaymentInput;
  id: Scalars['ID']['input'];
};


export type MutationUpdatePetArgs = {
  data: UpdatePetInput;
  id: Scalars['ID']['input'];
};


export type MutationUpdatePetSelfieArgs = {
  data: UpdatePetSelfieInput;
  id: Scalars['ID']['input'];
};


export type MutationUpdatePimsReminderTypeArgs = {
  id: Scalars['ID']['input'];
  input: UpdatePimsReminderTypeInput;
};


export type MutationUpdatePimsSettingsArgs = {
  clinicId: Scalars['ID']['input'];
  data: UpdatePimsSettingsInput;
};


export type MutationUpdatePmsApptTypeArgs = {
  clinicId: Scalars['ID']['input'];
  data: UpdatePmsApptTypeInput;
  pmsApptTypeId: Scalars['ID']['input'];
};


export type MutationUpdatePmsDbArgs = {
  data: UpdatePmsDbInput;
  id: Scalars['ID']['input'];
};


export type MutationUpdatePrescriptionArgs = {
  data: UpdatePrescriptionInput;
  prescriptionId: Scalars['ID']['input'];
};


export type MutationUpdatePrescriptionRefillRequestArgs = {
  data: UpdatePrescriptionRefillRequestInput;
  id: Scalars['ID']['input'];
};


export type MutationUpdatePressItemArgs = {
  data: UpdatePressItemInput;
  id: Scalars['ID']['input'];
};


export type MutationUpdatePrivateNoteArgs = {
  data: PrivateNoteInput;
  id: Scalars['ID']['input'];
  patientRecordId: Scalars['ID']['input'];
};


export type MutationUpdateProductArgs = {
  data: UpdateProductInput;
  productId: Scalars['ID']['input'];
};


export type MutationUpdateProviderAvailabilityArgs = {
  id: Scalars['ID']['input'];
  input: UpdateProviderAvailabilityInput;
};


export type MutationUpdateReportMetricArgs = {
  data: UpdateReportMetricInput;
  id: Scalars['ID']['input'];
};


export type MutationUpdateReportTemplateArgs = {
  data: UpdateReportTemplateInput;
  id: Scalars['ID']['input'];
};


export type MutationUpdateRescheduleArgs = {
  data: UpdateRescheduleInput;
  id: Scalars['ID']['input'];
};


export type MutationUpdateRoomArgs = {
  data: UpdateRoomInput;
  roomId: Scalars['ID']['input'];
};


export type MutationUpdateRoomServiceArgs = {
  data: UpdateRoomServiceInput;
  id: Scalars['ID']['input'];
};


export type MutationUpdateScheduledBulkMessageArgs = {
  data: UpdateScheduledBulkMessageInput;
  scheduledBulkMessageId: Scalars['ID']['input'];
};


export type MutationUpdateScheduledMessageArgs = {
  data: UpdateScheduledMessageInput;
  scheduledMessageId: Scalars['ID']['input'];
};


export type MutationUpdateSchedulingRulesArgs = {
  data: UpdateSchedulingRulesInput;
  schedulingRulesId: Scalars['ID']['input'];
};


export type MutationUpdateServiceArgs = {
  data: UpdateServiceInput;
  id: Scalars['ID']['input'];
};


export type MutationUpdateServiceCategoryArgs = {
  clinicId: Scalars['ID']['input'];
  data: UpdateServiceCategoryInput;
  id: Scalars['ID']['input'];
};


export type MutationUpdateServiceFormArgs = {
  data: UpdateServiceFormInput;
  id: Scalars['ID']['input'];
};


export type MutationUpdateTagCategoryArgs = {
  data: UpdateTagCategoryInput;
  id: Scalars['ID']['input'];
};


export type MutationUpdateTransactionArgs = {
  data: UpdateTransactionInput;
  id: Scalars['ID']['input'];
};


export type MutationUpdateTreatmentArgs = {
  clinicId: Scalars['ID']['input'];
  data: UpdateTreatmentInput;
  treatmentId: Scalars['ID']['input'];
};


export type MutationUpdateUserArgs = {
  data: UpdateUserInput;
  id: Scalars['ID']['input'];
};


export type MutationUpdateUserAuthInfoArgs = {
  data: UpdateUserAuthInfoInput;
  id: Scalars['ID']['input'];
};


export type MutationUpdateUserDesktopNotificationTokenArgs = {
  id: Scalars['ID']['input'];
  token: Scalars['String']['input'];
};


export type MutationUpdateUserPushNotificationTokenArgs = {
  id: Scalars['ID']['input'];
  token: Scalars['String']['input'];
};


export type MutationUpdateWidgetArgs = {
  data: UpdateWidgetInput;
  id: Scalars['ID']['input'];
};


export type MutationUpdateWidgetOptionsArgs = {
  data: UpdateWidgetOptionsInput;
  widgetId: Scalars['ID']['input'];
};


export type MutationUpdateWidgetServiceArgs = {
  data: UpdateWidgetServiceInput;
  id: Scalars['ID']['input'];
};


export type MutationUpdateWidgetSisterLocationArgs = {
  id: Scalars['ID']['input'];
  input: UpdateWidgetSisterLocationInput;
};


export type MutationUploadAttachmentArgs = {
  clinicId: Scalars['ID']['input'];
  data: AttachmentInput;
};


export type MutationVerifyUserPhoneArgs = {
  code: Scalars['String']['input'];
  id: Scalars['ID']['input'];
  phone: Scalars['String']['input'];
};


export type MutationWritebackChatArgs = {
  chatId: Scalars['ID']['input'];
  isManualWriteback?: InputMaybe<Scalars['Boolean']['input']>;
  messageIds: Array<Scalars['ID']['input']>;
};


export type MutationWritebackClientFormArgs = {
  id: Scalars['ID']['input'];
  isManualWriteback?: InputMaybe<Scalars['Boolean']['input']>;
};

export type NotificationAnalytics = {
  __typename?: 'NotificationAnalytics';
  categories: Array<NotificationCategoryEngagement>;
  notifications: Array<NotificationEngagement>;
};

export enum NotificationAnalyticsCategory {
  AppointmentReminders = 'AppointmentReminders',
  MedicalReminders = 'MedicalReminders',
  Other = 'Other'
}

export type NotificationCategoryEngagement = {
  __typename?: 'NotificationCategoryEngagement';
  category: NotificationAnalyticsCategory;
  notification_count: Scalars['NonNegativeInt']['output'];
  stats: NotificationEngagementStats;
};

export type NotificationEngagement = {
  __typename?: 'NotificationEngagement';
  audience_name?: Maybe<Scalars['String']['output']>;
  category: NotificationAnalyticsCategory;
  clinic_id: Scalars['ID']['output'];
  message_methods: Array<MessageMethod>;
  name: Scalars['String']['output'];
  notification_template_id: Scalars['ID']['output'];
  stats: NotificationEngagementStats;
};

/**
 * Send / open / click counts for messages sent in the selected range.
 * Rates are 0..1. Open rate is email-only. Click rate covers emails and texts.
 */
export type NotificationEngagementStats = {
  __typename?: 'NotificationEngagementStats';
  click_rate: Scalars['Float']['output'];
  email_unique_opens: Scalars['NonNegativeInt']['output'];
  emails_sent: Scalars['NonNegativeInt']['output'];
  messages_sent: Scalars['NonNegativeInt']['output'];
  open_rate: Scalars['Float']['output'];
  sms_sent: Scalars['NonNegativeInt']['output'];
  unique_clicks: Scalars['NonNegativeInt']['output'];
};

export enum NotificationGroupingMethod {
  EntireMessage = 'EntireMessage',
  None = 'None',
  RepeatedMessage = 'RepeatedMessage'
}

export type NotificationMessageInput = {
  body: Scalars['String']['input'];
  ctaText: Scalars['String']['input'];
  ctaUrl: Scalars['String']['input'];
  emailBody: Scalars['String']['input'];
  html?: InputMaybe<Scalars['String']['input']>;
  messageMethods: Array<MessageMethod>;
  subject: Scalars['String']['input'];
};

export type NotificationMessagesByReferencePeriodResult = {
  __typename?: 'NotificationMessagesByReferencePeriodResult';
  buckets: Array<NotificationReferencePeriodMessageBucket>;
  end_date: Scalars['NonNegativeInt']['output'];
  notification_id: Scalars['ID']['output'];
  start_date: Scalars['NonNegativeInt']['output'];
  total_messages: Scalars['NonNegativeInt']['output'];
};

export type NotificationReferencePeriodMessageBucket = {
  __typename?: 'NotificationReferencePeriodMessageBucket';
  count: Scalars['NonNegativeInt']['output'];
  email_click_rate: Scalars['Float']['output'];
  email_clicks: Scalars['NonNegativeInt']['output'];
  email_open_rate: Scalars['Float']['output'];
  email_opens: Scalars['NonNegativeInt']['output'];
  email_unique_click_rate: Scalars['Float']['output'];
  email_unique_clicks: Scalars['NonNegativeInt']['output'];
  email_unique_open_rate: Scalars['Float']['output'];
  email_unique_opens: Scalars['NonNegativeInt']['output'];
  emails_sent: Scalars['NonNegativeInt']['output'];
  message_ids: Array<Scalars['ID']['output']>;
  reference_period: ReferencePeriod;
  reference_period_key: Scalars['String']['output'];
  sms_click_rate: Scalars['Float']['output'];
  sms_clicks: Scalars['NonNegativeInt']['output'];
  sms_sent: Scalars['NonNegativeInt']['output'];
  sms_unique_click_rate: Scalars['Float']['output'];
  sms_unique_clicks: Scalars['NonNegativeInt']['output'];
};

export type NotificationTemplate = {
  __typename?: 'NotificationTemplate';
  body?: Maybe<Scalars['String']['output']>;
  campaign?: Maybe<Campaign>;
  /** Owner: exactly one of clinic / clinic_group is set */
  clinic?: Maybe<Clinic>;
  /** Group-owned templates waterfall to linked clinics (see entity_links) */
  clinic_group?: Maybe<ClinicGroup>;
  created_at: Scalars['NonNegativeInt']['output'];
  cta_text?: Maybe<Scalars['String']['output']>;
  cta_url?: Maybe<Scalars['String']['output']>;
  customer_segment?: Maybe<CustomerSegment>;
  default_service_id?: Maybe<Scalars['ID']['output']>;
  email_body?: Maybe<Scalars['String']['output']>;
  email_design?: Maybe<Scalars['JSON']['output']>;
  email_html?: Maybe<Scalars['String']['output']>;
  email_template?: Maybe<EmailTemplate>;
  every_x_hours: Scalars['NonNegativeInt']['output'];
  grouping_method: NotificationGroupingMethod;
  header?: Maybe<Scalars['String']['output']>;
  id: Scalars['ID']['output'];
  is_active: Scalars['Boolean']['output'];
  is_archived: Scalars['Boolean']['output'];
  is_marketing: Scalars['Boolean']['output'];
  is_preview_mode: Scalars['Boolean']['output'];
  is_system: Scalars['Boolean']['output'];
  message_methods: Array<MessageMethod>;
  name: Scalars['String']['output'];
  notif_attachments?: Maybe<Array<Attachment>>;
  postcard_back_html?: Maybe<Scalars['String']['output']>;
  postcard_front_html?: Maybe<Scalars['String']['output']>;
  postcard_template?: Maybe<Scalars['String']['output']>;
  repeating_body?: Maybe<Scalars['String']['output']>;
  revenue_generated?: Maybe<Scalars['Float']['output']>;
  send_time_minutes?: Maybe<Scalars['NonNegativeInt']['output']>;
  subject?: Maybe<Scalars['String']['output']>;
  type: NotificationType;
  updated_at: Scalars['NonNegativeInt']['output'];
};

export type NotificationTemplateInput = {
  template_body?: InputMaybe<Scalars['String']['input']>;
  template_cta_text?: InputMaybe<Scalars['String']['input']>;
  template_cta_url?: InputMaybe<Scalars['String']['input']>;
  template_email_body?: InputMaybe<Scalars['String']['input']>;
  template_grouping_method?: InputMaybe<NotificationGroupingMethod>;
  template_id: Scalars['ID']['input'];
  template_is_preview_mode: Scalars['Boolean']['input'];
  template_message_methods: Array<MessageMethod>;
  template_postcard_template?: InputMaybe<Scalars['String']['input']>;
  template_repeating_body?: InputMaybe<Scalars['String']['input']>;
  template_subject?: InputMaybe<Scalars['String']['input']>;
};

export type NotificationTemplateTrackingStats = {
  __typename?: 'NotificationTemplateTrackingStats';
  conversion_rate: Scalars['Float']['output'];
  direct_appointments: Scalars['NonNegativeInt']['output'];
  email_click_rate: Scalars['Float']['output'];
  email_clicks: Scalars['NonNegativeInt']['output'];
  email_open_rate: Scalars['Float']['output'];
  email_opens: Scalars['NonNegativeInt']['output'];
  email_unique_click_rate: Scalars['Float']['output'];
  email_unique_clicks: Scalars['NonNegativeInt']['output'];
  email_unique_open_rate: Scalars['Float']['output'];
  email_unique_opens: Scalars['NonNegativeInt']['output'];
  emails_sent: Scalars['NonNegativeInt']['output'];
  indirect_appointments: Scalars['NonNegativeInt']['output'];
  messages_sent: Scalars['NonNegativeInt']['output'];
  postcard_direct_appointments: Scalars['NonNegativeInt']['output'];
  postcard_direct_revenue_cents: Scalars['NonNegativeInt']['output'];
  postcard_indirect_appointments: Scalars['NonNegativeInt']['output'];
  postcard_indirect_revenue_cents: Scalars['NonNegativeInt']['output'];
  postcard_qr_scans: Scalars['NonNegativeInt']['output'];
  postcard_revenue_cents: Scalars['NonNegativeInt']['output'];
  postcard_roi: Scalars['Float']['output'];
  postcard_spend_cents: Scalars['NonNegativeInt']['output'];
  postcard_unique_qr_scans: Scalars['NonNegativeInt']['output'];
  postcards_failed: Scalars['NonNegativeInt']['output'];
  postcards_sent: Scalars['NonNegativeInt']['output'];
  revenue_by_appt: Scalars['Float']['output'];
  sms_click_rate: Scalars['Float']['output'];
  sms_clicks: Scalars['NonNegativeInt']['output'];
  sms_sent: Scalars['NonNegativeInt']['output'];
  sms_unique_click_rate: Scalars['Float']['output'];
  sms_unique_clicks: Scalars['NonNegativeInt']['output'];
  unique_clients: Scalars['NonNegativeInt']['output'];
};

export enum NotificationTrigger {
  Recurring = 'Recurring'
}

export enum NotificationType {
  Confirmation = 'Confirmation',
  Custom = 'Custom',
  Message1 = 'Message1',
  Message2 = 'Message2',
  Message3 = 'Message3',
  Review = 'Review'
}

/**
 * Clinic-facing alert events. Each value is opt-in; omitting it means that
 * event does not email the clinic. Distinct from client notification templates.
 */
export enum NotifyClinicOn {
  AiCallCompleted = 'AiCallCompleted',
  ApptConfirmed = 'ApptConfirmed',
  Cancellation = 'Cancellation',
  ChckupNewAppt = 'ChckupNewAppt',
  FormSubmitted = 'FormSubmitted',
  FormWritebackFailure = 'FormWritebackFailure',
  NewMessage = 'NewMessage',
  PaymentSubmitted = 'PaymentSubmitted',
  PaymentWritebackFailure = 'PaymentWritebackFailure',
  Reschedule = 'Reschedule',
  /** A client message has waited unreplied_message_alert_minutes for a clinic user reply. Only fires when unreplied_message_alert_enabled is true. */
  UnrepliedMessage = 'UnrepliedMessage'
}

export type OnDemandClinician = {
  __typename?: 'OnDemandClinician';
  display_name?: Maybe<Scalars['String']['output']>;
  first_name?: Maybe<Scalars['String']['output']>;
  is_active?: Maybe<Scalars['Boolean']['output']>;
  is_provider?: Maybe<Scalars['Boolean']['output']>;
  last_name?: Maybe<Scalars['String']['output']>;
  pms_id?: Maybe<Scalars['String']['output']>;
};

export type OnDemandPaymentType = {
  __typename?: 'OnDemandPaymentType';
  description?: Maybe<Scalars['String']['output']>;
  is_credit_card?: Maybe<Scalars['Boolean']['output']>;
  is_inactive?: Maybe<Scalars['Boolean']['output']>;
  pms_id: Scalars['String']['output'];
};

export enum OnlyModifierEnum {
  Client = 'Client',
  ClientAudience = 'ClientAudience',
  Clinician = 'Clinician',
  FixedStatus = 'FixedStatus',
  Gender = 'Gender',
  MaxPerRule = 'MaxPerRule',
  Patient = 'Patient',
  PatientAudience = 'PatientAudience',
  Room = 'Room',
  Service = 'Service',
  Species = 'Species',
  Time = 'Time'
}

export type OpenSlot = {
  __typename?: 'OpenSlot';
  clinicians: Array<Clinician>;
  display_time?: Maybe<Scalars['NonNegativeInt']['output']>;
  rooms: Array<Room>;
  start_time: Scalars['NonNegativeInt']['output'];
};

export type OrderByInput = {
  column: Scalars['String']['input'];
  foreignTable?: InputMaybe<Scalars['String']['input']>;
  isAscending?: InputMaybe<Scalars['Boolean']['input']>;
};

export enum OrderDirection {
  Asc = 'Asc',
  Desc = 'Desc'
}

/** Per-scheduled-bulk-message rollup for the Channels tab. */
export type OrgBulkMessageStats = {
  __typename?: 'OrgBulkMessageStats';
  bulk_message_id: Scalars['ID']['output'];
  bulk_message_name: Scalars['String']['output'];
  campaign_id?: Maybe<Scalars['ID']['output']>;
  clinic_id?: Maybe<Scalars['ID']['output']>;
  direct_attributed_bookings: Scalars['NonNegativeInt']['output'];
  email_open_rate: Scalars['Float']['output'];
  indirect_attributed_bookings: Scalars['NonNegativeInt']['output'];
  is_active?: Maybe<Scalars['Boolean']['output']>;
  response_rate: Scalars['Float']['output'];
  successful_email_sends: Scalars['NonNegativeInt']['output'];
  total_attributed_bookings: Scalars['NonNegativeInt']['output'];
  total_attributed_revenue: Scalars['NonNegativeInt']['output'];
  total_email_opens: Scalars['NonNegativeInt']['output'];
  total_messages_sent: Scalars['NonNegativeInt']['output'];
};

/** Per-campaign rollup for the Channels tab "Campaigns" sub-table. */
export type OrgCampaignStats = {
  __typename?: 'OrgCampaignStats';
  campaign_id: Scalars['ID']['output'];
  campaign_name: Scalars['String']['output'];
  clinic_group_id?: Maybe<Scalars['ID']['output']>;
  clinic_id?: Maybe<Scalars['ID']['output']>;
  direct_attributed_bookings: Scalars['NonNegativeInt']['output'];
  email_open_rate: Scalars['Float']['output'];
  indirect_attributed_bookings: Scalars['NonNegativeInt']['output'];
  successful_email_sends: Scalars['NonNegativeInt']['output'];
  total_attributed_bookings: Scalars['NonNegativeInt']['output'];
  total_attributed_revenue: Scalars['NonNegativeInt']['output'];
  total_email_opens: Scalars['NonNegativeInt']['output'];
  total_messages_sent: Scalars['NonNegativeInt']['output'];
};

/** Per-notification-template rollup for the Channels tab. */
export type OrgNotificationStats = {
  __typename?: 'OrgNotificationStats';
  campaign_id?: Maybe<Scalars['ID']['output']>;
  clinic_id?: Maybe<Scalars['ID']['output']>;
  direct_attributed_bookings: Scalars['NonNegativeInt']['output'];
  email_open_rate: Scalars['Float']['output'];
  indirect_attributed_bookings: Scalars['NonNegativeInt']['output'];
  is_active?: Maybe<Scalars['Boolean']['output']>;
  notif_template_id: Scalars['ID']['output'];
  notif_template_name: Scalars['String']['output'];
  /**
   * Total attributed bookings divided by sends — meaningful at the
   * per-template level since the denominator is unambiguous.
   */
  response_rate: Scalars['Float']['output'];
  successful_email_sends: Scalars['NonNegativeInt']['output'];
  total_attributed_bookings: Scalars['NonNegativeInt']['output'];
  total_attributed_revenue: Scalars['NonNegativeInt']['output'];
  total_email_opens: Scalars['NonNegativeInt']['output'];
  total_messages_sent: Scalars['NonNegativeInt']['output'];
};

export type Organization = {
  __typename?: 'Organization';
  admins: Array<User>;
  clinics: Array<Clinic>;
  created_at: Scalars['Timestamp']['output'];
  id: Scalars['ID']['output'];
  name: Scalars['String']['output'];
  settings?: Maybe<OrganizationSettings>;
  slug?: Maybe<Scalars['String']['output']>;
  updated_at: Scalars['Timestamp']['output'];
};

export type OrganizationAnalytics = {
  __typename?: 'OrganizationAnalytics';
  analytics: ClinicAnalytics;
  clinic: Clinic;
};

export type OrganizationAnalyticsNumbers = {
  __typename?: 'OrganizationAnalyticsNumbers';
  analytic_numbers: OrganizationClinicAnalyticsNumbers;
  clinic: Clinic;
};

export type OrganizationAnalyticsNumbersByMonth = {
  __typename?: 'OrganizationAnalyticsNumbersByMonth';
  analytic_numbers: Array<AnalyticsNumbersByMonth>;
  clinic: Clinic;
};

export type OrganizationClinicAnalyticsNumbers = {
  __typename?: 'OrganizationClinicAnalyticsNumbers';
  appointments_count: IntPercentile;
  forward_scheduled_patients_count: IntPercentile;
  new_appointments_count: IntPercentile;
  new_clients_count: IntPercentile;
  new_patients_count: IntPercentile;
  no_show_count: IntPercentile;
  revenue: FloatPercentile;
  revenue_per_appointment: FloatPercentile;
  schedule_efficiency: FloatPercentile;
  transactions_count: IntPercentile;
};

export type OrganizationReport = {
  __typename?: 'OrganizationReport';
  created_at: Scalars['Timestamp']['output'];
  description?: Maybe<Scalars['String']['output']>;
  entity_reports: Array<EntityReport>;
  entity_structure: Array<ReportEntity>;
  id: Scalars['ID']['output'];
  is_hidden: Scalars['Boolean']['output'];
  name: Scalars['String']['output'];
  organization?: Maybe<Organization>;
  preferred_view_type: ReportViewType;
  report_clinics: Array<ReportClinic>;
  report_metrics: Array<ReportMetric>;
  report_template?: Maybe<ReportTemplate>;
  time_params: TimeParams;
  updated_at: Scalars['Timestamp']['output'];
};

export type OrganizationRevenueByMonth = {
  __typename?: 'OrganizationRevenueByMonth';
  clinic: Clinic;
  revenue: Array<RevenueByMonth>;
};

export type OrganizationScheduleEfficiency = {
  __typename?: 'OrganizationScheduleEfficiency';
  average: Scalars['Float']['output'];
  per_clinic: Array<ClinicsScheduleEfficiency>;
};

export type OrganizationSettings = {
  __typename?: 'OrganizationSettings';
  accent_color?: Maybe<Scalars['String']['output']>;
  custom_booking_copy?: Maybe<ClinicBookingCopy>;
  custom_other_description?: Maybe<Scalars['String']['output']>;
  custom_other_title?: Maybe<Scalars['String']['output']>;
  custom_sick_description?: Maybe<Scalars['String']['output']>;
  custom_well_description?: Maybe<Scalars['String']['output']>;
  primary_color?: Maybe<Scalars['String']['output']>;
  widget_styles?: Maybe<WidgetStyles>;
};

export type OrganizationSettingsInput = {
  accent_color?: InputMaybe<Scalars['String']['input']>;
  custom_booking_copy?: InputMaybe<ClinicBookingCopyInput>;
  custom_other_description?: InputMaybe<Scalars['String']['input']>;
  custom_other_title?: InputMaybe<Scalars['String']['input']>;
  custom_sick_description?: InputMaybe<Scalars['String']['input']>;
  custom_well_description?: InputMaybe<Scalars['String']['input']>;
  primary_color?: InputMaybe<Scalars['String']['input']>;
  widget_styles?: InputMaybe<WidgetStylesInput>;
};

export type OverduePatient = {
  __typename?: 'OverduePatient';
  last_appointment: Appointment;
  patient: Patient;
};

export type OverduePatientOptions = {
  gtMonths?: InputMaybe<Scalars['NonNegativeInt']['input']>;
  ltMonths?: InputMaybe<Scalars['NonNegativeInt']['input']>;
  page?: InputMaybe<Scalars['NonNegativeInt']['input']>;
  pageSize?: InputMaybe<Scalars['NonNegativeInt']['input']>;
};

export type PaginationParams = {
  page?: InputMaybe<Scalars['NonNegativeInt']['input']>;
  pageSize?: InputMaybe<Scalars['NonNegativeInt']['input']>;
};

export type Patient = {
  __typename?: 'Patient';
  avatar_url?: Maybe<Scalars['String']['output']>;
  birthday?: Maybe<Scalars['Float']['output']>;
  breed?: Maybe<Scalars['String']['output']>;
  client_pms_id?: Maybe<Scalars['String']['output']>;
  clinic?: Maybe<Clinic>;
  clinic_breed?: Maybe<Breed>;
  clinic_species?: Maybe<ClinicSpecies>;
  color?: Maybe<Scalars['String']['output']>;
  created_at: Scalars['Timestamp']['output'];
  fixed_status?: Maybe<FixedStatus>;
  gender?: Maybe<Scalars['String']['output']>;
  id: Scalars['ID']['output'];
  is_active?: Maybe<Scalars['Boolean']['output']>;
  is_deceased?: Maybe<Scalars['Boolean']['output']>;
  last_appointment?: Maybe<Appointment>;
  last_appt_time?: Maybe<Scalars['NonNegativeInt']['output']>;
  last_vaccination_sync_time?: Maybe<Scalars['NonNegativeInt']['output']>;
  name?: Maybe<Scalars['String']['output']>;
  next_appointment?: Maybe<Appointment>;
  next_appt_time?: Maybe<Scalars['NonNegativeInt']['output']>;
  origin?: Maybe<EntityOrigin>;
  owner?: Maybe<Client>;
  patient_notes?: Maybe<Array<PatientNote>>;
  patient_vaccination_records?: Maybe<Array<PatientVaccinationRecord>>;
  pet?: Maybe<Pet>;
  pms?: Maybe<PracticeManagementSystem>;
  pms_created_at?: Maybe<Scalars['NonNegativeInt']['output']>;
  pms_id?: Maybe<Scalars['String']['output']>;
  resuscitate?: Maybe<Scalars['Boolean']['output']>;
  species_pms_id?: Maybe<Scalars['String']['output']>;
  status?: Maybe<PatientStatus>;
  updated_at: Scalars['Timestamp']['output'];
  weight?: Maybe<Scalars['Float']['output']>;
};

/** A patient's ongoing medical problem / concern (problem list entry). */
export type PatientConcern = {
  __typename?: 'PatientConcern';
  created_at: Scalars['Timestamp']['output'];
  description?: Maybe<Scalars['String']['output']>;
  established_at?: Maybe<Scalars['Timestamp']['output']>;
  id: Scalars['ID']['output'];
  is_active: Scalars['Boolean']['output'];
  name: Scalars['String']['output'];
  patient?: Maybe<Scalars['ID']['output']>;
  pms_id?: Maybe<Scalars['String']['output']>;
  resolved_at?: Maybe<Scalars['Timestamp']['output']>;
  status: PatientConcernStatus;
  updated_at: Scalars['Timestamp']['output'];
};

export enum PatientConcernStatus {
  Active = 'Active',
  Inactive = 'Inactive',
  Resolved = 'Resolved'
}

export type PatientHistoryItem = {
  __typename?: 'PatientHistoryItem';
  appointment?: Maybe<Appointment>;
  clinic: Clinic;
  clinician?: Maybe<Clinician>;
  computed_id: Scalars['String']['output'];
  created_at: Scalars['Timestamp']['output'];
  diagnosis?: Maybe<Diagnosis>;
  id: Scalars['ID']['output'];
  issued_at: Scalars['Timestamp']['output'];
  item_type?: Maybe<Scalars['String']['output']>;
  note?: Maybe<Scalars['String']['output']>;
  patient: Patient;
  pms_id?: Maybe<Scalars['ID']['output']>;
  product?: Maybe<Product>;
  updated_at: Scalars['Timestamp']['output'];
};

export type PatientInfo = {
  __typename?: 'PatientInfo';
  patient_birthday?: Maybe<Scalars['Float']['output']>;
  patient_breed?: Maybe<Scalars['String']['output']>;
  patient_clinic_breed?: Maybe<Scalars['ID']['output']>;
  patient_clinic_species?: Maybe<Scalars['ID']['output']>;
  patient_gender?: Maybe<AnimalGender>;
  patient_is_fixed?: Maybe<Scalars['Boolean']['output']>;
  patient_name?: Maybe<Scalars['String']['output']>;
};

export type PatientInfoInput = {
  patient_birthday?: InputMaybe<Scalars['Float']['input']>;
  patient_breed?: InputMaybe<Scalars['String']['input']>;
  patient_clinic_breed?: InputMaybe<Scalars['ID']['input']>;
  patient_clinic_species?: InputMaybe<Scalars['ID']['input']>;
  patient_gender?: InputMaybe<AnimalGender>;
  patient_is_fixed?: InputMaybe<Scalars['Boolean']['input']>;
  patient_name?: InputMaybe<Scalars['String']['input']>;
};

/**
 * General PMS note about a patient, synced nightly (Bitwerx: Impromed /
 * Avimark / Cornerstone). Surfaced in the inbox client panel alongside
 * client notes. is_internal flags notes the practice marked internal-only.
 */
export type PatientNote = {
  __typename?: 'PatientNote';
  created_at: Scalars['Timestamp']['output'];
  id: Scalars['ID']['output'];
  is_active: Scalars['Boolean']['output'];
  is_internal: Scalars['Boolean']['output'];
  noted_at?: Maybe<Scalars['Timestamp']['output']>;
  patient?: Maybe<Scalars['ID']['output']>;
  pms_id?: Maybe<Scalars['String']['output']>;
  text?: Maybe<Scalars['String']['output']>;
  updated_at: Scalars['Timestamp']['output'];
};

export type PatientRecord = {
  __typename?: 'PatientRecord';
  appointment?: Maybe<Appointment>;
  assessment?: Maybe<Scalars['String']['output']>;
  assisting_clinicians?: Maybe<Array<Scalars['String']['output']>>;
  client?: Maybe<Client>;
  clinic?: Maybe<Clinic>;
  clinician?: Maybe<Clinician>;
  created_at: Scalars['Timestamp']['output'];
  date?: Maybe<Scalars['NonNegativeInt']['output']>;
  id: Scalars['ID']['output'];
  master_problem_list?: Maybe<Scalars['String']['output']>;
  objective?: Maybe<Scalars['String']['output']>;
  patient: Patient;
  plan?: Maybe<Scalars['String']['output']>;
  public_notes?: Maybe<Scalars['String']['output']>;
  service?: Maybe<Scalars['String']['output']>;
  subjective?: Maybe<Scalars['String']['output']>;
  updated_at: Scalars['Timestamp']['output'];
};

export type PatientReminder = {
  __typename?: 'PatientReminder';
  patient?: Maybe<Patient>;
  pims_reminder: PimsReminder;
};

export type PatientStatus = {
  __typename?: 'PatientStatus';
  clinic?: Maybe<Clinic>;
  created_at: Scalars['Timestamp']['output'];
  description?: Maybe<Scalars['String']['output']>;
  id: Scalars['ID']['output'];
  name?: Maybe<Scalars['String']['output']>;
  pms?: Maybe<PracticeManagementSystem>;
  pms_id?: Maybe<Scalars['String']['output']>;
  updated_at: Scalars['Timestamp']['output'];
};

export enum PatientTypeEnum {
  New = 'New',
  Returning = 'Returning'
}

export type PatientVaccinationRecord = {
  __typename?: 'PatientVaccinationRecord';
  administered_date?: Maybe<Scalars['NonNegativeInt']['output']>;
  created_at: Scalars['Timestamp']['output'];
  due_date?: Maybe<Scalars['NonNegativeInt']['output']>;
  id: Scalars['ID']['output'];
  is_active: Scalars['Boolean']['output'];
  is_rabies_vaccine?: Maybe<Scalars['Boolean']['output']>;
  is_soc: Scalars['Boolean']['output'];
  lot_number?: Maybe<Scalars['String']['output']>;
  manufacturer?: Maybe<Scalars['String']['output']>;
  patient?: Maybe<Patient>;
  pims_reminders?: Maybe<Array<PimsReminder>>;
  pms_id?: Maybe<Scalars['String']['output']>;
  product?: Maybe<Product>;
  rabies_tag?: Maybe<Scalars['String']['output']>;
  updated_at: Scalars['Timestamp']['output'];
  vaccine_name?: Maybe<Scalars['String']['output']>;
};

export type Payment = {
  __typename?: 'Payment';
  amount: Scalars['PositiveInt']['output'];
  amount_refunded?: Maybe<Scalars['PositiveInt']['output']>;
  appointment?: Maybe<Appointment>;
  category: PurchaseCategory;
  client: Client;
  clinic: Clinic;
  created_at: Scalars['Timestamp']['output'];
  currency: Scalars['Currency']['output'];
  date: Scalars['NonNegativeInt']['output'];
  description?: Maybe<Scalars['String']['output']>;
  errors: Array<PaymentError>;
  id: Scalars['ID']['output'];
  invoice?: Maybe<Invoice>;
  is_entered_in_pims: Scalars['Boolean']['output'];
  payment_method_id?: Maybe<Scalars['String']['output']>;
  pms_id?: Maybe<Scalars['String']['output']>;
  processing_fee: Scalars['NonNegativeInt']['output'];
  refund_entered_in_pims: Scalars['Boolean']['output'];
  refund_issued_at?: Maybe<Scalars['Timestamp']['output']>;
  sales_tax: Scalars['NonNegativeInt']['output'];
  service_fee: Scalars['NonNegativeInt']['output'];
  status: PaymentStatus;
  stripe_account_id?: Maybe<Scalars['String']['output']>;
  stripe_checkout_session_url?: Maybe<Scalars['String']['output']>;
  stripe_payment_id?: Maybe<Scalars['String']['output']>;
  stripe_payment_intent_id?: Maybe<Scalars['String']['output']>;
  stripe_payment_link?: Maybe<Scalars['String']['output']>;
  updated_at: Scalars['Timestamp']['output'];
  writeback_time_started?: Maybe<Scalars['Timestamp']['output']>;
};

export type PaymentError = {
  __typename?: 'PaymentError';
  code?: Maybe<Scalars['String']['output']>;
  message: Scalars['String']['output'];
  type?: Maybe<Scalars['String']['output']>;
};

export type PaymentErrorInput = {
  code?: InputMaybe<Scalars['String']['input']>;
  message: Scalars['String']['input'];
  type?: InputMaybe<Scalars['String']['input']>;
};

export enum PaymentStatus {
  Cancelled = 'Cancelled',
  Failed = 'Failed',
  Pending = 'Pending',
  Refunded = 'Refunded',
  Success = 'Success'
}

export enum PeriodType {
  Day = 'Day',
  Month = 'Month',
  Quarter = 'Quarter',
  Week = 'Week',
  Year = 'Year'
}

export type Pet = {
  __typename?: 'Pet';
  avatar_url?: Maybe<Scalars['String']['output']>;
  bio?: Maybe<Scalars['String']['output']>;
  birthday?: Maybe<Scalars['Float']['output']>;
  breed?: Maybe<Scalars['String']['output']>;
  created_at: Scalars['Timestamp']['output'];
  family?: Maybe<Family>;
  fixed_status?: Maybe<FixedStatus>;
  gender?: Maybe<AnimalGender>;
  id: Scalars['ID']['output'];
  name?: Maybe<Scalars['String']['output']>;
  patients: Array<Patient>;
  species?: Maybe<Species>;
  updated_at: Scalars['Timestamp']['output'];
  weight?: Maybe<Scalars['NonNegativeFloat']['output']>;
};

export type PetSelfie = {
  __typename?: 'PetSelfie';
  allow_public_share: Scalars['Boolean']['output'];
  client: Client;
  clinic: Clinic;
  created_at: Scalars['Timestamp']['output'];
  display_caption?: Maybe<Scalars['String']['output']>;
  display_media_url?: Maybe<Scalars['String']['output']>;
  duration_ms?: Maybe<Scalars['Int']['output']>;
  favorite_activity?: Maybe<Scalars['String']['output']>;
  filename?: Maybe<Scalars['String']['output']>;
  first_viewed_at?: Maybe<Scalars['Timestamp']['output']>;
  first_viewed_by?: Maybe<Scalars['ID']['output']>;
  id: Scalars['ID']['output'];
  in_gallery: Scalars['Boolean']['output'];
  in_portal_carousel: Scalars['Boolean']['output'];
  in_slideshow: Scalars['Boolean']['output'];
  is_archived: Scalars['Boolean']['output'];
  is_excluded: Scalars['Boolean']['output'];
  media_type: PetSelfieMediaType;
  mime_type: Scalars['String']['output'];
  nickname?: Maybe<Scalars['String']['output']>;
  patient?: Maybe<Patient>;
  pet_name?: Maybe<Scalars['String']['output']>;
  public_share_authorization_version?: Maybe<Scalars['String']['output']>;
  public_share_authorized_at?: Maybe<Scalars['Timestamp']['output']>;
  reaction_message?: Maybe<Scalars['String']['output']>;
  reaction_message_id?: Maybe<Scalars['ID']['output']>;
  reaction_sent_at?: Maybe<Scalars['Timestamp']['output']>;
  size_bytes?: Maybe<Scalars['Int']['output']>;
  submitted_media_url: Scalars['String']['output'];
  thumbnail_url?: Maybe<Scalars['String']['output']>;
  updated_at: Scalars['Timestamp']['output'];
  weirdest_thing?: Maybe<Scalars['String']['output']>;
};

export enum PetSelfieMediaType {
  Image = 'Image',
  Video = 'Video'
}

export type PhoneInput = {
  is_android?: InputMaybe<Scalars['Boolean']['input']>;
  phone: Scalars['String']['input'];
};

export enum PhoneProviderType {
  Bland = 'Bland',
  MangoVoice = 'MangoVoice',
  Retell = 'Retell',
  RingCentral = 'RingCentral',
  Sinch = 'Sinch'
}

export type PimsCustomFields = {
  __typename?: 'PimsCustomFields';
  primary_phone_field?: Maybe<Scalars['String']['output']>;
};

export type PimsCustomFieldsInput = {
  primary_phone_field?: InputMaybe<Scalars['String']['input']>;
};

/**
 * A client found live in the clinic's PIMS by a dashboard lookup. Mirrors the
 * PIMS record, not our database — `client_id` is the only field that
 * reflects local state.
 */
export type PimsLookupClient = {
  __typename?: 'PimsLookupClient';
  /** Single-line address preview, as stored in the PIMS. */
  address?: Maybe<Scalars['String']['output']>;
  /**
   * Id of the matching client in our database, or null when this client has
   * not been synced in yet.
   */
  client_id?: Maybe<Scalars['ID']['output']>;
  email?: Maybe<Scalars['String']['output']>;
  first_name: Scalars['String']['output'];
  is_active: Scalars['Boolean']['output'];
  last_name: Scalars['String']['output'];
  patients: Array<PimsLookupPatient>;
  phone?: Maybe<Scalars['String']['output']>;
  pms_id: Scalars['String']['output'];
};

export type PimsLookupInput = {
  email?: InputMaybe<Scalars['String']['input']>;
  first_name?: InputMaybe<Scalars['String']['input']>;
  last_name?: InputMaybe<Scalars['String']['input']>;
  patient_name?: InputMaybe<Scalars['String']['input']>;
  phone?: InputMaybe<Scalars['String']['input']>;
};

/**
 * A pet found live in the clinic's PIMS by a dashboard lookup. Mirrors the
 * PIMS record, not our database — `patient_id` is the only field that
 * reflects local state.
 */
export type PimsLookupPatient = {
  __typename?: 'PimsLookupPatient';
  birthday?: Maybe<Scalars['Float']['output']>;
  breed?: Maybe<Scalars['String']['output']>;
  is_active: Scalars['Boolean']['output'];
  is_deceased: Scalars['Boolean']['output'];
  name: Scalars['String']['output'];
  /**
   * Id of the matching patient in our database, or null when this pet has
   * not been synced in yet.
   */
  patient_id?: Maybe<Scalars['ID']['output']>;
  pms_id: Scalars['String']['output'];
  sex?: Maybe<Scalars['String']['output']>;
  species?: Maybe<Scalars['String']['output']>;
};

export type PimsReminder = {
  __typename?: 'PimsReminder';
  client: Client;
  clinic?: Maybe<Clinic>;
  display_due_date?: Maybe<Scalars['NonNegativeInt']['output']>;
  id: Scalars['ID']['output'];
  is_active: Scalars['Boolean']['output'];
  is_completed: Scalars['Boolean']['output'];
  patient?: Maybe<Patient>;
  pms_id: Scalars['String']['output'];
  reminder_desc?: Maybe<Scalars['String']['output']>;
  reminder_type?: Maybe<PimsReminderType>;
  send_date: Scalars['NonNegativeInt']['output'];
};

export type PimsReminderType = {
  __typename?: 'PimsReminderType';
  all_reminder_names?: Maybe<Array<Scalars['String']['output']>>;
  clinic: Clinic;
  created_at: Scalars['Timestamp']['output'];
  display_name?: Maybe<Scalars['String']['output']>;
  id: Scalars['ID']['output'];
  is_active: Scalars['Boolean']['output'];
  pms_id: Scalars['String']['output'];
  reminder_type_name: Scalars['String']['output'];
  updated_at: Scalars['Timestamp']['output'];
};

export type PimsReminderTypeSearchResult = {
  __typename?: 'PimsReminderTypeSearchResult';
  count: Scalars['NonNegativeInt']['output'];
  pims_reminder_types: Array<PimsReminderType>;
};

export type PimsSettings = {
  __typename?: 'PimsSettings';
  access_token?: Maybe<Scalars['String']['output']>;
  access_token_expiration?: Maybe<Scalars['NonNegativeInt']['output']>;
  additional_key?: Maybe<Scalars['String']['output']>;
  api_clinic_id?: Maybe<Scalars['String']['output']>;
  api_key?: Maybe<Scalars['String']['output']>;
  api_subdomain?: Maybe<Scalars['String']['output']>;
  clinic?: Maybe<Clinic>;
  cookie: Array<Scalars['String']['output']>;
  /** DataHub Registry invitation sent to this clinic's site. */
  datahub_invitation_id?: Maybe<Scalars['String']['output']>;
  /**
   * DataHub practice UUID, sent as X-Practice-Id. Written by the DataHub
   * Registry linker once the invited site accepts, and only present on the
   * data source that owns the practice's data.
   */
  datahub_practice_id?: Maybe<Scalars['String']['output']>;
  /** DataHub site this clinic was linked to; its location once connected through DataHub. */
  datahub_site_id?: Maybe<Scalars['String']['output']>;
  entered_by_pms_id?: Maybe<Scalars['String']['output']>;
  ezyvet_client_id?: Maybe<Scalars['String']['output']>;
  ezyvet_client_secret?: Maybe<Scalars['String']['output']>;
  ezyvet_integration_mode?: Maybe<EzyvetIntegrationMode>;
  ezyvet_scopes?: Maybe<Scalars['String']['output']>;
  ezyvet_site_uid?: Maybe<Scalars['String']['output']>;
  long_sync_interval_hours?: Maybe<Scalars['NonNegativeInt']['output']>;
  other_access_tokens: Array<Scalars['String']['output']>;
  password?: Maybe<Scalars['String']['output']>;
  /**
   * PMS payment-type id used on Bitwerx payment writeback. Admins pick
   * it from OnDemand payment types (getOnDemandPaymentTypesForClinic).
   */
  payment_type_pms_id?: Maybe<Scalars['String']['output']>;
  phones_api_key?: Maybe<Scalars['String']['output']>;
  phones_secondary_api_key?: Maybe<Scalars['String']['output']>;
  pims_version?: Maybe<Scalars['String']['output']>;
  pin?: Maybe<Scalars['String']['output']>;
  pms_db?: Maybe<PmsDb>;
  practice_key?: Maybe<Scalars['String']['output']>;
  pulse_ar_report_id?: Maybe<Scalars['String']['output']>;
  pulse_clients_report_id?: Maybe<Scalars['String']['output']>;
  pulse_patients_report_id?: Maybe<Scalars['String']['output']>;
  pulse_reminders_report_id?: Maybe<Scalars['String']['output']>;
  pulse_sales_report_id?: Maybe<Scalars['String']['output']>;
  pulse_vaccinations_report_id?: Maybe<Scalars['String']['output']>;
  refresh_token?: Maybe<Scalars['String']['output']>;
  request_verification_token?: Maybe<Scalars['String']['output']>;
  /**
   * When true, clinician hours are synced from the PMS (e.g. Shepherd)
   * and manual edits in the dashboard will be overridden on the next
   * sync. Turn off to manage hours manually.
   */
  should_sync_clinician_hours?: Maybe<Scalars['Boolean']['output']>;
  sync_interval_minutes?: Maybe<Scalars['NonNegativeInt']['output']>;
  user_key?: Maybe<Scalars['String']['output']>;
  username?: Maybe<Scalars['String']['output']>;
};

export type PmsApptType = {
  __typename?: 'PmsApptType';
  clinic?: Maybe<Clinic>;
  color?: Maybe<Scalars['HexColorCode']['output']>;
  created_at: Scalars['Timestamp']['output'];
  description?: Maybe<Scalars['String']['output']>;
  id: Scalars['ID']['output'];
  metadata?: Maybe<Scalars['JSON']['output']>;
  name: Scalars['String']['output'];
  pms_id: Scalars['String']['output'];
  pms_is_active: Scalars['Boolean']['output'];
  updated_at: Scalars['Timestamp']['output'];
};

/**
 * A code from the practice's PMS catalog. Broader than Product: covers
 * inventory items, services, diagnoses, and labs. `code_name` is the
 * practice's short code (e.g. "PPW"); `pms_id` is what gets written back.
 * Only active codes are returned.
 */
export type PmsCode = {
  __typename?: 'PmsCode';
  code_name: Scalars['String']['output'];
  description: Scalars['String']['output'];
  pms_id: Scalars['String']['output'];
  /** Which catalog the code came from — service, inventory, diagnosis, lab. */
  type: Scalars['String']['output'];
};

export enum PmsConnector {
  Bitwerx = 'Bitwerx',
  DataHub = 'DataHub',
  Direct = 'Direct'
}

export type PmsDb = {
  __typename?: 'PmsDb';
  created_at: Scalars['Timestamp']['output'];
  id: Scalars['ID']['output'];
  last_sync_times?: Maybe<LastSyncTimes>;
  name: Scalars['String']['output'];
  pims_settings?: Maybe<PimsSettings>;
  pms: PracticeManagementSystem;
  /** How this database's PIMS data reaches us. pms stays the PIMS itself. */
  pms_connector: PmsConnector;
  sync_from?: Maybe<SyncFrom>;
  time_zone?: Maybe<Scalars['String']['output']>;
  updated_at: Scalars['Timestamp']['output'];
};

export enum PmsOtherEntitiesType {
  ShepherdReferralSource = 'ShepherdReferralSource'
}

export type PmsOtherEntity = {
  __typename?: 'PmsOtherEntity';
  clinic?: Maybe<Clinic>;
  created_at: Scalars['Timestamp']['output'];
  id: Scalars['ID']['output'];
  metadata?: Maybe<Scalars['JSON']['output']>;
  name: Scalars['String']['output'];
  pms_created_at?: Maybe<Scalars['Timestamp']['output']>;
  pms_db?: Maybe<PmsDb>;
  pms_id: Scalars['String']['output'];
  pms_is_active: Scalars['Boolean']['output'];
  type: PmsOtherEntitiesType;
  updated_at: Scalars['Timestamp']['output'];
};

export type PmsTag = {
  __typename?: 'PmsTag';
  client?: Maybe<Client>;
  client_pms_id?: Maybe<Scalars['String']['output']>;
  clinic?: Maybe<Clinic>;
  created_at: Scalars['Timestamp']['output'];
  id: Scalars['ID']['output'];
  last_synced_time?: Maybe<Scalars['Timestamp']['output']>;
  name: Scalars['String']['output'];
  patient?: Maybe<Patient>;
  patient_pms_id?: Maybe<Scalars['String']['output']>;
  pms_created_at?: Maybe<Scalars['Timestamp']['output']>;
  pms_db?: Maybe<PmsDb>;
  pms_id: Scalars['String']['output'];
  pms_is_active: Scalars['Boolean']['output'];
  pms_tag_category?: Maybe<PmsTagCategory>;
  pms_tag_category_pms_id?: Maybe<Scalars['String']['output']>;
  updated_at: Scalars['Timestamp']['output'];
};

export type PmsTagCategory = {
  __typename?: 'PmsTagCategory';
  clinic?: Maybe<Clinic>;
  created_at: Scalars['Timestamp']['output'];
  id: Scalars['ID']['output'];
  last_synced_time?: Maybe<Scalars['Timestamp']['output']>;
  name: Scalars['String']['output'];
  pms_created_at?: Maybe<Scalars['Timestamp']['output']>;
  pms_db?: Maybe<PmsDb>;
  pms_id: Scalars['String']['output'];
  pms_is_active: Scalars['Boolean']['output'];
  pms_tags: Array<PmsTag>;
  updated_at: Scalars['Timestamp']['output'];
};

export type PortalLink = {
  __typename?: 'PortalLink';
  label: Scalars['String']['output'];
  url: Scalars['String']['output'];
};

export type PortalLinkInput = {
  label: Scalars['String']['input'];
  url: Scalars['String']['input'];
};

export enum PortalPatientDetailsTab {
  Appointments = 'Appointments',
  MedicalHistory = 'MedicalHistory',
  Prescriptions = 'Prescriptions',
  Reminders = 'Reminders',
  Vaccines = 'Vaccines'
}

export type PotentialClinic = {
  __typename?: 'PotentialClinic';
  client_email_preview: Scalars['String']['output'];
  client_id: Scalars['ID']['output'];
  client_name_preview: Scalars['String']['output'];
  client_phone_preview: Scalars['String']['output'];
  clinic: Clinic;
};

export type PotentialClinicInput = {
  email?: InputMaybe<Scalars['String']['input']>;
  phone?: InputMaybe<Scalars['String']['input']>;
};

export enum PracticeManagementSystem {
  AvImark = 'AVImark',
  BwAvimark = 'BwAvimark',
  Cornerstone = 'Cornerstone',
  Daysmart = 'Daysmart',
  EzyVet = 'EzyVet',
  ImpromedInfinity = 'ImpromedInfinity',
  Instinct = 'Instinct',
  NectarVet = 'NectarVet',
  Provet = 'Provet',
  Pulse = 'Pulse',
  Rhapsody = 'Rhapsody',
  Shepherd = 'Shepherd'
}

export type Prescription = {
  __typename?: 'Prescription';
  clinic?: Maybe<Clinic>;
  clinician?: Maybe<Clinician>;
  created_at: Scalars['Timestamp']['output'];
  description?: Maybe<Scalars['String']['output']>;
  expiration_date?: Maybe<Scalars['Timestamp']['output']>;
  id: Scalars['ID']['output'];
  is_active: Scalars['Boolean']['output'];
  last_refill_time?: Maybe<Scalars['NonNegativeInt']['output']>;
  name?: Maybe<Scalars['String']['output']>;
  patient: Patient;
  pms_created_at: Scalars['Timestamp']['output'];
  pms_id: Scalars['String']['output'];
  product?: Maybe<Product>;
  product_name?: Maybe<Scalars['String']['output']>;
  quantity?: Maybe<Scalars['NonNegativeFloat']['output']>;
  refill_count?: Maybe<Scalars['NonNegativeInt']['output']>;
  refill_limit?: Maybe<Scalars['NonNegativeInt']['output']>;
  remaining?: Maybe<Scalars['NonNegativeFloat']['output']>;
  updated_at: Scalars['Timestamp']['output'];
};

export type PrescriptionPricing = {
  __typename?: 'PrescriptionPricing';
  amountBeforeStripeFee: Scalars['NonNegativeInt']['output'];
  chckvetFeeClientPortion: Scalars['NonNegativeInt']['output'];
  chckvetFeeClinicPortion: Scalars['NonNegativeInt']['output'];
  chckvetFeeSplitPercentage: Scalars['Float']['output'];
  chckvetFeeTotal: Scalars['NonNegativeInt']['output'];
  isStripeFeeChargedToClient: Scalars['Boolean']['output'];
  items: Array<PrescriptionPricingItem>;
  productId: Scalars['ID']['output'];
  stripeFee: Scalars['NonNegativeInt']['output'];
  subtotal: Scalars['NonNegativeInt']['output'];
  unitPrice: Scalars['NonNegativeInt']['output'];
  units: Scalars['NonNegativeFloat']['output'];
};

export type PrescriptionPricingItem = {
  __typename?: 'PrescriptionPricingItem';
  amount: Scalars['NonNegativeInt']['output'];
  kind: PrescriptionPricingItemKind;
  label: Scalars['String']['output'];
};

export enum PrescriptionPricingItemKind {
  AdditionalFee = 'additional_fee',
  ChckvetFee = 'chckvet_fee',
  Product = 'product',
  StripeFee = 'stripe_fee'
}

export type PrescriptionRefillRequest = {
  __typename?: 'PrescriptionRefillRequest';
  amount?: Maybe<Scalars['NonNegativeInt']['output']>;
  appointment?: Maybe<Appointment>;
  approved_at?: Maybe<Scalars['Timestamp']['output']>;
  client: Client;
  clinic: Clinic;
  created_at: Scalars['Timestamp']['output'];
  denial_reason?: Maybe<Scalars['String']['output']>;
  denied_at?: Maybe<Scalars['Timestamp']['output']>;
  id: Scalars['ID']['output'];
  notes?: Maybe<Scalars['String']['output']>;
  patient?: Maybe<Patient>;
  pickup_time?: Maybe<Scalars['NonNegativeInt']['output']>;
  prescription?: Maybe<Prescription>;
  status: PrescriptionRefillRequestStatus;
  stripe_payment_intent_id?: Maybe<Scalars['String']['output']>;
  type: PrescriptionRefillRequestType;
  updated_at: Scalars['Timestamp']['output'];
};

export enum PrescriptionRefillRequestStatus {
  Approved = 'Approved',
  Cancelled = 'Cancelled',
  Denied = 'Denied',
  Pending = 'Pending'
}

export enum PrescriptionRefillRequestType {
  Refill = 'Refill',
  Renewal = 'Renewal'
}

export type PressItem = {
  __typename?: 'PressItem';
  created_at: Scalars['Timestamp']['output'];
  description?: Maybe<Scalars['String']['output']>;
  id: Scalars['ID']['output'];
  image?: Maybe<Scalars['String']['output']>;
  links?: Maybe<Array<Link>>;
  title?: Maybe<Scalars['String']['output']>;
  updated_at: Scalars['Timestamp']['output'];
};

export type PrivateNote = {
  __typename?: 'PrivateNote';
  clinic: Clinic;
  created_at: Scalars['Timestamp']['output'];
  id: Scalars['ID']['output'];
  notes: Scalars['String']['output'];
  updated_at: Scalars['Timestamp']['output'];
};

export type PrivateNoteInput = {
  clinic: Scalars['ID']['input'];
  notes: Scalars['String']['input'];
};

export type Product = {
  __typename?: 'Product';
  additional_fees?: Maybe<Array<AdditionalFees>>;
  category: ProductCategory;
  chckvet_price?: Maybe<Scalars['Int']['output']>;
  clinic?: Maybe<Clinic>;
  code?: Maybe<Scalars['String']['output']>;
  cost?: Maybe<Scalars['Int']['output']>;
  created_at: Scalars['Timestamp']['output'];
  description?: Maybe<Scalars['String']['output']>;
  display_name?: Maybe<Scalars['String']['output']>;
  id: Scalars['ID']['output'];
  is_active: Scalars['Boolean']['output'];
  is_controlled: Scalars['Boolean']['output'];
  name: Scalars['String']['output'];
  pims_category?: Maybe<Scalars['String']['output']>;
  pms_id: Scalars['String']['output'];
  prescription_fee_split_override?: Maybe<Scalars['Float']['output']>;
  price: Scalars['Int']['output'];
  unit?: Maybe<Scalars['String']['output']>;
  updated_at: Scalars['Timestamp']['output'];
  volume?: Maybe<Scalars['String']['output']>;
};

export enum ProductCategory {
  Food = 'Food',
  Medicine = 'Medicine',
  Other = 'Other',
  Product = 'Product',
  Service = 'Service',
  Vaccines = 'Vaccines'
}

/**
 * A validated, ready-to-approve config change. The bot emits `block`
 * verbatim; the dashboard parses it into an approval card. Everything
 * except the `execute` half of the block is display-only.
 */
export type ProposedChange = {
  __typename?: 'ProposedChange';
  /**
   * Fully-wrapped `%= propose_change =%` block to emit verbatim in
   * the assistant reply.
   */
  block: Scalars['String']['output'];
  captured_before: Scalars['JSON']['output'];
  /** Clinic that owns the target. Required for creates; usually set for updates. */
  clinic_id?: Maybe<Scalars['ID']['output']>;
  entity_display_name: Scalars['String']['output'];
  field_diff: Array<ProposedChangeFieldDiff>;
  operation: ProposedChangeOperation;
  patch: Scalars['JSON']['output'];
  risk_tier: Scalars['String']['output'];
  side_effects: Array<Scalars['String']['output']>;
  summary?: Maybe<Scalars['String']['output']>;
  /** Present for updates; null for creates (no row yet). */
  target_entity_id?: Maybe<Scalars['ID']['output']>;
  target_entity_type: Scalars['String']['output'];
};

export type ProposedChangeFieldDiff = {
  __typename?: 'ProposedChangeFieldDiff';
  after?: Maybe<Scalars['JSON']['output']>;
  before?: Maybe<Scalars['JSON']['output']>;
  field: Scalars['String']['output'];
};

export enum ProposedChangeOperation {
  Create = 'create',
  Update = 'update'
}

export type ProviderAvailability = {
  __typename?: 'ProviderAvailability';
  clinic: Clinic;
  clinician?: Maybe<Clinician>;
  created_at: Scalars['NonNegativeInt']['output'];
  date?: Maybe<Scalars['NonNegativeInt']['output']>;
  end: Scalars['NonNegativeInt']['output'];
  id: Scalars['ID']['output'];
  is_for_booking: Scalars['Boolean']['output'];
  repeat_days_of_month?: Maybe<Array<Scalars['NonNegativeInt']['output']>>;
  repeat_days_of_week?: Maybe<Array<AvailabilityDay>>;
  repeat_end_date?: Maybe<Scalars['NonNegativeInt']['output']>;
  repeat_frequency?: Maybe<Scalars['NonNegativeInt']['output']>;
  repeat_unit?: Maybe<RepeatUnit>;
  repeat_week_of_month?: Maybe<WeekOfMonth>;
  room?: Maybe<Room>;
  routine_days?: Maybe<Array<AvailabilityDay>>;
  start: Scalars['NonNegativeInt']['output'];
  type: AvailabilityType;
  updated_at: Scalars['NonNegativeInt']['output'];
  valid_from: Scalars['NonNegativeInt']['output'];
  valid_to?: Maybe<Scalars['NonNegativeInt']['output']>;
};

export type PublicAppointmentTime = {
  __typename?: 'PublicAppointmentTime';
  clinician_id?: Maybe<Scalars['ID']['output']>;
  is_time_block?: Maybe<Scalars['Boolean']['output']>;
  minutes: Scalars['NonNegativeInt']['output'];
  room_id?: Maybe<Scalars['ID']['output']>;
  start_time: Scalars['NonNegativeInt']['output'];
};

export enum PurchaseCategory {
  Appointment = 'Appointment',
  General = 'General',
  Prescription = 'Prescription'
}

export type Query = {
  __typename?: 'Query';
  _empty?: Maybe<Scalars['Void']['output']>;
  actionItem: ActionItem;
  /**
   * Clinic-scoped ranking / count. Ask Chckvet uses this for questions
   * like "highest bookers" or "how many appointments does Joe have"
   * across duplicate client rows. `clinicId` must be inside the
   * session (its clinic, or a constituent clinic of an enterprise
   * session); callers cannot supply SQL or a reporting `query_override`.
   */
  aggregateClinicData: ClinicAggregateResult;
  allClinics: Array<Clinic>;
  allServicesByClinicId: Array<Service>;
  animal: Animal;
  appointment: Appointment;
  appointmentGoogleCalendarLink: Scalars['String']['output'];
  appointmentPrompt: AppointmentPrompt;
  appointmentsByClient: Array<Appointment>;
  appointmentsByClinicAndRange: Array<Appointment>;
  appointmentsByUser: Array<Appointment>;
  appointmentsCountByClinic: Array<ClinicAppointmentCount>;
  apptStatus: ClinicApptStatus;
  billableUsageStatsByType: Array<BillableUsageTypeStats>;
  /**
   * Online bookings across a clinic group, grouped by one marketing
   * attribution dimension. Sorted by appointments booked, descending.
   */
  bookingAttributionAnalytics: Array<BookingAttributionStats>;
  /**
   * Public (unauthenticated) booking/form-fill lookup of the forms for a
   * SINGLE client, whose id comes from the booking/form match flow. Always
   * constrained to `client = clientId` server-side, so it cannot enumerate
   * the table. Used by the public form-fill page.
   */
  bookingClientForms: Array<ClientForm>;
  /**
   * Public (unauthenticated) booking-flow lookup: the bookable patients for
   * a SINGLE client, whose id is obtained during the booking match flow.
   * Always constrained to `owner = clientId` server-side, so it can only
   * ever return that one client's patients and never enumerate the table.
   * Used by the embedded booking widget and the portal booking form, both
   * of which run before the caller is authenticated.
   */
  bookingClientPatients: Array<Patient>;
  bookingFlowEvents: Array<BookingFlowEvent>;
  bookingFlowFunnel: Array<BookingFlowFunnelStep>;
  /**
   * Resolves a tracked-link click into pre-fillable booking context
   * (client, optional patient, default service) so the widget/portal
   * can land the client on the time-select step.
   * Unauthenticated; security relies on possession of the random
   * 'chclid' and a 90-day server-side expiry.
   */
  bookingPrefillByClickId: BookingPrefillResult;
  /** Per-widget and per-clinic booking performance across a clinic group. */
  bookingSourceAnalytics: BookingSourceAnalytics;
  breed: Breed;
  buildProposedChange: ProposedChange;
  bulkMessageAudienceEstimate: BulkMessageAudienceEstimate;
  calculateClinicValuesForKpiGroupMetric: Array<KpiGroupMetricResult>;
  call: Call;
  callsByClient: Array<Call>;
  callsByClinic: Array<Call>;
  campaign: Campaign;
  campaignNotificationStats: CampaignNotificationStats;
  campaignScheduledBulkMessageStats: CampaignScheduledBulkMessageStats;
  campaignStats: CampaignStats;
  campaignWidgetStats: CampaignWidgetStats;
  chat: Chat;
  chatStatus: ChatStatusConfig;
  chatStatuses: Array<ChatStatusConfig>;
  chatStatusesByClinicGroup: Array<ChatStatusConfig>;
  checkClientFormsForConfirmation?: Maybe<Array<ClientForm>>;
  checkEmailList?: Maybe<Scalars['Boolean']['output']>;
  checkExistingClient?: Maybe<Array<Client>>;
  checkExistingClients: Array<Client>;
  checkExistingPatient?: Maybe<Patient>;
  checkForDuplicateAppointment?: Maybe<Appointment>;
  checkForUserByEmail?: Maybe<Array<User>>;
  checkIfClientIsBlocklisted: Scalars['Boolean']['output'];
  checkIfServerRunning: Scalars['Boolean']['output'];
  checkIn: CheckIn;
  checkMaybeClient: Array<ReturningClientPatientResult>;
  checkReturningClientPatient: Array<ReturningClientPatientResult>;
  checkTimeSlotAvailability: Array<Scalars['String']['output']>;
  checkUserDesktopNotificationToken?: Maybe<Scalars['Boolean']['output']>;
  checkUserPushNotificationToken?: Maybe<Scalars['Boolean']['output']>;
  client: Client;
  clientForm: ClientForm;
  clientPreview: ClientPreview;
  clientStatus: ClientStatus;
  clinic: Clinic;
  /** Effective clinic role and permissions, including group-derived access. Null when the user cannot open the clinic. Direct membership wins. */
  clinicAccessForUser?: Maybe<ClinicAccess>;
  clinicAdjustedAvailability?: Maybe<Array<ProviderAvailability>>;
  clinicAdmin?: Maybe<ClinicAdmin>;
  /**
   * Fetch one of the caller's clinic-agent conversations. Returns null
   * if missing or not owned by the caller for this clinic / group.
   */
  clinicAgentConversation?: Maybe<SupportBotConversation>;
  /**
   * True when Ask Chckvet is available and the caller is a staff member
   * of this clinic, or of this clinic group with at least one
   * constituent clinic Ask Chckvet can act on (any role). Pass exactly
   * one of clinicId / clinicGroupId. Safe to call for UI gating — does
   * not throw on deny; returns false instead.
   */
  clinicAgentEnabled: Scalars['Boolean']['output'];
  /**
   * Poll an in-flight clinic-agent run. Same polled-streaming contract
   * as `supportBotRunStatus`, but owner-scoped to the caller.
   */
  clinicAgentRunStatus: SupportBotRunSnapshot;
  /** 'bookingAttributionAnalytics' for one clinic's online bookings. */
  clinicBookingAttributionAnalytics: Array<BookingAttributionStats>;
  /**
   * 'bookingSourceAnalytics' for one clinic: only sessions at this clinic
   * count. Widgets are the clinic's own plus any other widget (e.g. a group
   * widget) with sessions here; 'clinics' holds just this clinic.
   */
  clinicBookingSourceAnalytics: BookingSourceAnalytics;
  clinicBySlug: Clinic;
  clinicCallStats: CallStats;
  clinicFeatures: ClinicFeatures;
  /**
   * Read-only, deterministic check of a clinic's setup for the problems
   * clinics most often hit right after going live (texting number,
   * reminders left off or in preview, PIMS availability settings, service
   * and status mapping, clinician roster, staff access, writeback, and
   * client-facing template and form text).
   * Admin / SuperAdmin only. See support-bot/docs/go-live-check-research.md.
   * Pass probes to also run live checks against outside systems (slower):
   * TextingRoute asks Twilio, ContentReview has a cheap model read the text.
   */
  clinicGoLiveCheck: ClinicGoLiveCheck;
  clinicGroup: ClinicGroup;
  /**
   * Public booking lookup of a single non-archived clinic group by its
   * unique slug. Slug-scoped so it cannot be used to enumerate clinic
   * groups (unlike `queryClinicGroups`, which is staff-only).
   */
  clinicGroupBySlug?: Maybe<ClinicGroup>;
  clinicGroupMedicalReminderFunnel: MedicalReminderFunnel;
  clinicGroupNotificationAnalytics: NotificationAnalytics;
  clinicGroupUser?: Maybe<ClinicGroupUser>;
  clinicGroupUserByGroupAndUser?: Maybe<ClinicGroupUser>;
  /**
   * Daily clinic health-check snapshot for the support bot. Raw 1d/7d/30d
   * Chckvet-booked + total appt counts, per-widget conversion, per-active-template sends,
   * SMS/email delivery, and short-sync times, plus trimmed prior days and
   * any still-open issues, sorted by priority. SuperAdmin / Admin only.
   * Today's snapshot is computed once per day; open issues are always fresh.
   */
  clinicHealthCheckPayload: ClinicHealthCheckResult;
  clinicMedicalReminderFunnel: MedicalReminderFunnel;
  clinicNotificationAnalytics: NotificationAnalytics;
  clinicOnboarding?: Maybe<ClinicOnboarding>;
  clinicRoutineAvailability?: Maybe<Array<ProviderAvailability>>;
  /**
   * Each member clinic's current values for the given clinic settings
   * fields, so the group can see what a clinic uses before linking a
   * shared setting to it. Only link-governed fields may be requested.
   */
  clinicSettingsFieldValuesForClinicGroup: Array<ClinicSettingsFieldValues>;
  clinicStats: ClinicStats;
  clinician: Clinician;
  clinicianAdjustedAvailability?: Maybe<Array<ProviderAvailability>>;
  clinicianRoutineAvailability?: Maybe<Array<ProviderAvailability>>;
  cloudClinics: Array<Clinic>;
  /**
   * Outreach activity report for the Compliance Tracker: per-day,
   * per-user, per-status counts of statuses assigned in the date range
   * (ms timestamps). Sourced from the change_logs history.
   */
  complianceStatusActivity: Array<ComplianceStatusActivityRow>;
  computeInitiativeValues: InitiativeResult;
  computeKpiGroupValues: Array<KpiGroupResult>;
  computeReportTemplateValues: Array<ReportTemplateResult>;
  confirmationAppointments: Array<Appointment>;
  connectInstallation: ConnectInstallation;
  countActionItems: Scalars['NonNegativeInt']['output'];
  countAllClinicAdmins: Scalars['NonNegativeInt']['output'];
  countAppointments: Scalars['NonNegativeInt']['output'];
  countBookingClientPatients: Scalars['NonNegativeInt']['output'];
  countBreeds: Scalars['NonNegativeInt']['output'];
  countCalls: Scalars['NonNegativeInt']['output'];
  countCampaigns: Scalars['NonNegativeInt']['output'];
  countChats: Scalars['NonNegativeInt']['output'];
  countClientForms: Scalars['NonNegativeInt']['output'];
  countClientStatuses: Scalars['NonNegativeInt']['output'];
  countClients: Scalars['NonNegativeInt']['output'];
  /** Count of clinics a user can open, optionally filtered by clinic columns. Direct memberships and group clinics are counted once. */
  countClinicAdminClinics: Scalars['NonNegativeInt']['output'];
  countClinicAdmins: Scalars['NonNegativeInt']['output'];
  countClinicApptStatuses: Scalars['NonNegativeInt']['output'];
  countClinicClients: Scalars['NonNegativeInt']['output'];
  countClinicEmailTemplates?: Maybe<Scalars['NonNegativeInt']['output']>;
  countClinicGroupClinics: Scalars['NonNegativeInt']['output'];
  countClinicGroupEmailTemplates?: Maybe<Scalars['NonNegativeInt']['output']>;
  countClinicGroupMessageTemplates?: Maybe<Scalars['NonNegativeInt']['output']>;
  countClinicGroupUsers: Scalars['NonNegativeInt']['output'];
  countClinicGroups: Scalars['NonNegativeInt']['output'];
  /** Count of the clinic groups a user belongs to, optionally filtered by clinic group columns. */
  countClinicGroupsForUser: Scalars['NonNegativeInt']['output'];
  countClinicMessageTemplates?: Maybe<Scalars['NonNegativeInt']['output']>;
  countClinicPatients: Scalars['NonNegativeInt']['output'];
  countClinicSexes: Scalars['NonNegativeInt']['output'];
  countClinicSpecies: Scalars['NonNegativeInt']['output'];
  countClinicians: Scalars['NonNegativeInt']['output'];
  countClinics: Scalars['NonNegativeInt']['output'];
  countClinicsForUserAdmin: Scalars['NonNegativeInt']['output'];
  countDiagnoses: Scalars['NonNegativeInt']['output'];
  countDrilldownEntities: Scalars['NonNegativeInt']['output'];
  countForms: Scalars['NonNegativeInt']['output'];
  countInitiatives: Scalars['NonNegativeInt']['output'];
  countInternalChatUsers: Scalars['NonNegativeInt']['output'];
  countInternalUsageEvents: Scalars['NonNegativeInt']['output'];
  countInvoiceItems: Scalars['NonNegativeInt']['output'];
  countInvoices: Scalars['NonNegativeInt']['output'];
  countKpiGroups: Scalars['NonNegativeInt']['output'];
  countLoyaltyEarnings: Scalars['NonNegativeInt']['output'];
  countLoyaltyMembers: Scalars['NonNegativeInt']['output'];
  countLoyaltyRedemptions: Scalars['NonNegativeInt']['output'];
  countLoyaltyRewards: Scalars['NonNegativeInt']['output'];
  countMessages: Scalars['NonNegativeInt']['output'];
  countMsgTrackingEvents: Scalars['NonNegativeInt']['output'];
  countMyAppointments: Scalars['NonNegativeInt']['output'];
  countMyChats: Scalars['NonNegativeInt']['output'];
  countMyClientForms: Scalars['NonNegativeInt']['output'];
  countMyLoyaltyMembers: Scalars['NonNegativeInt']['output'];
  countMyPatientConcerns: Scalars['NonNegativeInt']['output'];
  countMyPatientHistoryItems: Scalars['NonNegativeInt']['output'];
  countMyPatients: Scalars['NonNegativeInt']['output'];
  countMyPetSelfies: Scalars['NonNegativeInt']['output'];
  countMyPrescriptionRefillRequests: Scalars['NonNegativeInt']['output'];
  countMyPrescriptions: Scalars['NonNegativeInt']['output'];
  /**
   * Number of unread (not-yet-marked-as-read) notifications for the
   * current viewer. Drives the unread badge on the bell icon.
   */
  countMyUnreadUserNotifications: Scalars['NonNegativeInt']['output'];
  countMyVisits: Scalars['NonNegativeInt']['output'];
  countNotificationTemplates: Scalars['NonNegativeInt']['output'];
  countOrganizationReports: Scalars['NonNegativeInt']['output'];
  countOrganizations: Scalars['NonNegativeInt']['output'];
  countOverduePatients: Scalars['NonNegativeInt']['output'];
  countPatientHistoryItems: Scalars['NonNegativeInt']['output'];
  countPatientStatuses: Scalars['NonNegativeInt']['output'];
  countPatientVaccinationRecords: Scalars['NonNegativeInt']['output'];
  countPatientVaccinationRecordsByPatient: Scalars['NonNegativeInt']['output'];
  countPatients: Scalars['NonNegativeInt']['output'];
  countPatientsFromOtherClinics: Scalars['NonNegativeInt']['output'];
  countPayments: Scalars['NonNegativeInt']['output'];
  countPetSelfies: Scalars['NonNegativeInt']['output'];
  countPetsByUserId?: Maybe<Scalars['NonNegativeInt']['output']>;
  countPimsReminderTypes: Scalars['NonNegativeInt']['output'];
  countPimsReminders: Scalars['NonNegativeInt']['output'];
  countPimsRemindersByPatient: Scalars['NonNegativeInt']['output'];
  countPmsDbs: Scalars['NonNegativeInt']['output'];
  countPmsOtherEntities: Scalars['NonNegativeInt']['output'];
  countPmsTagCategories: Scalars['NonNegativeInt']['output'];
  countPmsTags: Scalars['NonNegativeInt']['output'];
  countPotentialClinicsForUser: Scalars['NonNegativeInt']['output'];
  countPrescriptionRefillRequests: Scalars['NonNegativeInt']['output'];
  countPrescriptions: Scalars['NonNegativeInt']['output'];
  countPreviousClinicsForUser: Scalars['NonNegativeInt']['output'];
  countProducts: Scalars['NonNegativeInt']['output'];
  countProviderAvailability: Scalars['NonNegativeInt']['output'];
  countReportMetrics: Scalars['NonNegativeInt']['output'];
  countReportTemplates: Scalars['NonNegativeInt']['output'];
  countReschedules: Scalars['NonNegativeInt']['output'];
  countReviews: Scalars['NonNegativeInt']['output'];
  countRooms: Scalars['NonNegativeInt']['output'];
  countScheduledBulkMessages: Scalars['NonNegativeInt']['output'];
  countScheduledMessages: Scalars['NonNegativeInt']['output'];
  countSchedulingRules: Scalars['NonNegativeInt']['output'];
  countSchedulingRulesForClinic: Scalars['NonNegativeInt']['output'];
  countServiceForms: Scalars['NonNegativeInt']['output'];
  countServices: Scalars['NonNegativeInt']['output'];
  countUserClients: Scalars['NonNegativeInt']['output'];
  countUsers: Scalars['NonNegativeInt']['output'];
  countWidgets: Scalars['NonNegativeInt']['output'];
  createWalletSetupIntent: WalletSetupIntent;
  customRole?: Maybe<CustomRole>;
  customerSegment: CustomerSegment;
  dailyHuddle: DailyHuddle;
  dataChat: DataChat;
  /**
   * Public read of the synthetic default-portal widget for a clinic (null if none).
   * Used by portal/app booking when no widget ?id= is present.
   */
  defaultPortalWidget?: Maybe<Widget>;
  diagnosis: Diagnosis;
  /**
   * Renders the {{ due_patient_reminders }} merge tag for a single client:
   * a repeated list of their patients' due reminders, filtered by the
   * default due-reminders config (±30 day window, active/non-deceased
   * patients, no appointment in the next 60 days). Returns an empty string
   * when there are no matching reminders. `referenceDate` defaults to now.
   */
  duePatientReminders: Scalars['String']['output'];
  emailTemplate: EmailTemplate;
  emailTemplatesForClinic: Array<EmailTemplate>;
  /**
   * Returns the synthetic default-portal widget for a clinic, creating it if needed.
   * Dashboard-only; requires clinic employee auth.
   */
  ensureDefaultPortalWidget: Widget;
  /**
   * The individual entities behind one clinic's standardized/clinic-specific
   * counts, for expanding a cell on the onboarding report. Only the
   * content types the report counts are supported (notifications,
   * audiences, forms, message templates, email templates).
   */
  enterpriseOnboardingEntities: Array<EnterpriseOnboardingEntity>;
  /**
   * The enterprise onboarding spreadsheet: one row per clinic in the group
   * with settings, feature flags, activity counts, onboarding step
   * statuses and linked/unlinked content counts. Caller must be a member
   * of the clinic group (or its parent).
   */
  enterpriseOnboardingReport: EnterpriseOnboardingReport;
  /**
   * The individual active services, clinicians, rooms, or scheduling
   * rules behind one clinic's Setup Entities counts on the onboarding
   * report.
   */
  enterpriseOnboardingSetupEntities: Array<EnterpriseOnboardingSetupEntity>;
  /**
   * Per-parent link details for one clinic — which shared entities are
   * linked, unlinked by the clinic, or never received, plus any field
   * opt-outs on active links.
   */
  entityLinkCoverageDetailsForClinic: Array<EntityLinkCoverageDetail>;
  /**
   * Clinic × entity-type coverage matrix for a clinic group — how many
   * shared parents each member clinic has actively linked, previously
   * unlinked, or never received.
   */
  entityLinkCoverageForClinicGroup: Array<ClinicEntityLinkCoverage>;
  /**
   * The static link field policies for every linkable entity type. Constant
   * config data (no tenant scoping) — fetch once and cache client-side.
   */
  entityLinkFieldPolicies: Array<EntityLinkFieldPolicy>;
  /**
   * Previews which fields saving `data` (the entity's update input) onto
   * a linked clinic copy would stop inheriting from the group: governed
   * fields the copy still inherits whose values would change, expanded to
   * their unlink bundles. Values are compared normalized so re-serialized
   * JSON isn't a change. Empty when the copy isn't actively linked.
   */
  entityLinkFieldsChangedByUpdate: Array<Scalars['String']['output']>;
  /** The link of a clinic-level child entity, or null if never linked */
  entityLinkForChild?: Maybe<EntityLink>;
  /** Linked / unlinked / never-linked counts for a group-level parent */
  entityLinkSummary: EntityLinkSummary;
  /**
   * All links of one entity type for a clinic (active and historical), so
   * list views can resolve link status for every row in one query.
   */
  entityLinksForClinic: Array<EntityLink>;
  /** All links (active and historical) of a group-level parent entity */
  entityLinksForParent: Array<EntityLink>;
  family?: Maybe<Family>;
  filterAppointments: Array<Appointment>;
  findPotentialClientsForUser: Array<Client>;
  findPotentialClinicsForUser: Array<PotentialClinic>;
  form: Form;
  generateIntercomJwt?: Maybe<Scalars['String']['output']>;
  getAccountsReceivable: Scalars['Float']['output'];
  /**
   * Active, incomplete reminders for the given patients. Pages past the
   * PostgREST 1000-row cap so callers do not have to paginate.
   */
  getActivePimsRemindersByPatients: Array<PimsReminder>;
  getActiveServicesForBooking: Array<Service>;
  getAiAgentPromptForClinic: AiAgentPrompt;
  /** Prompt suggestions for the clinic's AI receptionist. Status defaults to Pending. */
  getAiPromptSuggestionsForClinic: AiPromptSuggestions;
  getAllClientsForUserClinic: Array<Client>;
  /** Returns analytics for the given forms: value counts per field for SelectOne, SelectMultiple, and Checkbox elements. */
  getAnalyticsForForms: Array<FormAnalytics>;
  getAnalyticsNumbersByMonthsForOrganization: Array<OrganizationAnalyticsNumbersByMonth>;
  getAppointmentCountByWidgetId: Scalars['NonNegativeInt']['output'];
  /** @deprecated use getAppointmentCountByWidgetId */
  getAppointmentCountByWidgetSource: Scalars['NonNegativeInt']['output'];
  /** Only appointments with at least one attributed invoice are returned. */
  getAppointmentInvoiceTotals: Array<AppointmentInvoiceTotal>;
  getAverageRatingForRecentReviews: ReviewTotals;
  getAverageRatingForRecentReviewsForClinics: ReviewTotals;
  getBookingQuestionsFromSchedulingRules: Array<BookingQuestions>;
  getBreedsByClinic: Array<Breed>;
  getChangeLogsByEntityId: Array<ChangeLog>;
  getChatByClientAndClinic?: Maybe<Chat>;
  getChatMessagesByChatId: Array<Message>;
  getChatsByClientId: Array<Chat>;
  getChatsByClinicId: Array<Chat>;
  getChckupMetadata?: Maybe<ChckupMetadata>;
  getCheckInsByClinic: Array<CheckIn>;
  getCheckInsByUser: Array<CheckIn>;
  getClientAISummary: ClientAiSummary;
  getClientCountForClinic: Scalars['NonNegativeInt']['output'];
  getClientForUserClinic?: Maybe<Client>;
  getClientFormsForClinic: Array<ClientForm>;
  getClientStatusesByClinic: Array<ClientStatus>;
  getClients: Array<Client>;
  getClientsByCustomerSegment: Array<CustSegResult>;
  getClientsByCustomerSegmentRPC: CustSegRpcResult;
  getClientsCountByCustomerSegment: Scalars['NonNegativeInt']['output'];
  getClientsForClinic: Array<Client>;
  getClientsWithNegativeBalancesForClinic: Array<Client>;
  getClientsWithOverduePatients: Array<ClientWithOverduePatient>;
  getClientsWithoutApptOverDaysForClinic: Array<Client>;
  getClinicAdmin?: Maybe<ClinicAdmin>;
  getClinicAdminsByClinic: Array<ClinicAdmin>;
  getClinicAdminsByUser: Array<ClinicAdmin>;
  getClinicApptStatusesByClinic: Array<ClinicApptStatus>;
  getClinicAvailability?: Maybe<Array<ProviderAvailability>>;
  getClinicGroupClinicsByLocation: Array<ClinicGroupClinic>;
  getClinicGroupsForUser: Array<ClinicGroup>;
  getClinicSpeciesByClinic: Array<ClinicSpecies>;
  getClinicUsageStats: Array<ClinicUsageStats>;
  getClinicianAvailability?: Maybe<Array<ProviderAvailability>>;
  getClinicianService: ClinicianService;
  getClinicianServicesByClinic: Array<ClinicianService>;
  getClinicianServicesByClinician: Array<ClinicianService>;
  getClinicianServicesByService: Array<ClinicianService>;
  getCliniciansByClinic: Array<Clinician>;
  getCliniciansForBooking: Array<Clinician>;
  getClinics: Array<Clinic>;
  getClinicsForOrganization?: Maybe<Array<Clinic>>;
  getClinicsForUserAdmin: Array<Clinic>;
  getClinicsWithConcerns: Array<ClinicUsageStats>;
  getConnectInstallationsByClinic: Array<ConnectInstallation>;
  getCustomRolesByClinic: Array<CustomRole>;
  getCustomRolesByClinicGroup: Array<CustomRole>;
  getCustomerSegmentsForClinic: Array<CustomerSegment>;
  getDailyHuddlesByClinic: Array<DailyHuddle>;
  getDrilldownEntities: Array<DrilldownRow>;
  getEmailList?: Maybe<Array<Scalars['String']['output']>>;
  getFillRateForClinicianTimeRange: FillRateResult;
  getFillRateForRoomTimeRange: FillRateResult;
  getFillRateForTimeRange: ClinicFillRateResult;
  getFormsForClinic: Array<Form>;
  getGoalsByClinic: Array<Goal>;
  getGoalsByClinicAndStatus: Array<Goal>;
  getLastServerHeartbeatForClinic?: Maybe<HeartbeatResponse>;
  getLoyaltyMembersForClinic: Array<LoyaltyMember>;
  getLoyaltyRedemptionsForClinic: Array<LoyaltyRedemption>;
  getLoyaltyRewardsForClinic: Array<LoyaltyReward>;
  getMaybeClients: Array<Client>;
  getMessagesByChatId: Array<Message>;
  getMostRecentDoctorForPatient?: Maybe<Clinician>;
  getNewAppointmentsForClinic: Scalars['NonNegativeInt']['output'];
  getNewClientsForClinic: Scalars['NonNegativeInt']['output'];
  getNewPatientsForClinic: Scalars['NonNegativeInt']['output'];
  getNextAvailableDay?: Maybe<Scalars['NonNegativeInt']['output']>;
  getNotificationTemplatesByClinicId: Array<NotificationTemplate>;
  getNumberOfCompletedAppointmentsForTimeRange: Scalars['NonNegativeInt']['output'];
  getOnDemandCliniciansForClinic: Array<OnDemandClinician>;
  getOnDemandPaymentTypesForClinic: Array<OnDemandPaymentType>;
  getOutstandingBalanceForClinic: Scalars['Float']['output'];
  getOverduePatients: Array<OverduePatient>;
  getPatientRecordsForPatient: Array<PatientRecord>;
  getPatientStatusesByClinic: Array<PatientStatus>;
  getPatientsByClient: Array<Patient>;
  getPatientsByClients: Array<Patient>;
  getPatientsFromOtherClinics: Array<Patient>;
  getPatientsWithoutApptOverDaysForClinic: Array<Patient>;
  getPatientsWithoutRescheduledAppointmentsForTimeRange: Array<Patient>;
  getPaymentsByClinicId: Array<Payment>;
  getPdfUrlForClientForm: Scalars['String']['output'];
  getPdfUrlForForm: Scalars['String']['output'];
  getPetsByUserId: Array<Pet>;
  getPmsApptTypesForClinic: Array<PmsApptType>;
  /**
   * The clinic's PMS code catalog. Returns [] for non-Bitwerx clinics.
   * `query` filters to codes whose short code name contains it.
   */
  getPmsCodesForClinic: Array<PmsCode>;
  getPreviousClinicsForUser: Array<Clinic>;
  getPrimaryClinicApptStatus?: Maybe<ClinicApptStatus>;
  getPrimaryClinicSpecies?: Maybe<ClinicSpecies>;
  getPrivateNotes: Array<PrivateNote>;
  getRealTimeReport: OrganizationReport;
  getReferralOptionsForClinic: Array<ReferringVet>;
  getRevenueByMonthsForClinic: Array<RevenueByMonth>;
  getRevenueByMonthsForOrganization: Array<OrganizationRevenueByMonth>;
  getRevenueForTimeRange: Scalars['Float']['output'];
  getRevenuesByClinicianForTimeRange: Array<RevenueGroup>;
  getRevenuesByTypeForTimeRange: Array<RevenueGroup>;
  getReviewsForClinic: Array<Review>;
  getRoomAvailability?: Maybe<Array<ProviderAvailability>>;
  getRoomService: RoomService;
  getRoomServicesByClinic: Array<RoomService>;
  getRoomServicesByRoom: Array<RoomService>;
  getRoomServicesByService: Array<RoomService>;
  getRoomsByClinic: Array<Room>;
  getRoomsForBooking: Array<Room>;
  getScheduledBulkMessagesByClinicId: Array<ScheduledBulkMessage>;
  /**
   * Categorizes scheduling rules based on how they apply to the given booking criteria.
   * Useful for debugging and understanding which rules affect availability.
   */
  getSchedulingRulesCategorized: SchedulingRulesCategorized;
  getServiceFormsForClinic: Array<ServiceForm>;
  getServicesForBooking: Array<Service>;
  getShepherdClinicsForReminders: Array<Clinic>;
  getSumOfInvoices: Scalars['Int']['output'];
  getSyncedCloudClinics: Array<Clinic>;
  getSyncedCloudPmsDbs: Array<PmsDb>;
  getTemplatesForClinicReports: Array<TemplateClinic>;
  getTimeSlotsForClinicForDay: Array<OpenSlot>;
  getTimeSlotsForSchedulingDay: Array<TimeSlot>;
  getTimeSlotsForSchedulingDays: Array<TimeSlot>;
  getTimesFirstBookingFilters: TimesFirstBookingFilters;
  getTotalRevenueForClinicBetweenTimes: Scalars['Float']['output'];
  getTransactionsByClinic: Array<Transaction>;
  getTransactionsByClinicAndRange: Array<Transaction>;
  getTreatmentsByClinic: Array<Treatment>;
  getTrendReport: TrendReport;
  /**
   * Public booking-flow lookup: upcoming, still-active appointments for a
   * known patient (or client + pet name) at a single clinic. Used to warn
   * patrons they already have a visit on the books. Requires clinicId plus
   * patientId and/or clientId — never enumerates the appointments table.
   */
  getUpcomingAppointmentsForBooking: Array<Appointment>;
  getWidgetsByClinic: Array<Widget>;
  getWidgetsByClinicGroup: Array<Widget>;
  getWidgetsByOrganization?: Maybe<Array<Widget>>;
  goal: Goal;
  initiative: Initiative;
  internalChat: InternalChat;
  internalChatMessages: Array<InternalChatMessage>;
  internalChatUsers: Array<InternalChatUser>;
  internalUsageEvents: Array<InternalUsageEvent>;
  invoice: Invoice;
  invoiceItem: InvoiceItem;
  isPatientActiveInPims: Scalars['Boolean']['output'];
  kpiGroup: KpiGroup;
  listAiVoiceOptions: Array<AiVoiceOption>;
  /**
   * Searches the clinic's PIMS live for clients matching the supplied
   * terms, returning each match with the pets it owns there and whether we
   * already hold those records.
   *
   * At least one search term is required. Only supported for PIMSes whose
   * API can filter clients this way; errors with PIMS_LOOKUP_UNSUPPORTED
   * otherwise.
   */
  lookupPimsClients: Array<PimsLookupClient>;
  loyaltyEarning: LoyaltyEarning;
  loyaltyMember: LoyaltyMember;
  loyaltyRedemption: LoyaltyRedemption;
  loyaltyReward: LoyaltyReward;
  marketingSummaryStats: MarketingSummaryStats;
  messageTemplate: MessageTemplate;
  /**
   * The caller's recent Ask Chckvet conversations for this clinic or
   * clinic group, newest first. Owner-scoped only.
   */
  myClinicAgentConversations: Array<SupportBotConversation>;
  myPaymentMethods: Array<SavedPaymentMethod>;
  /**
   * List the current SuperAdmin's recent support-bot conversations,
   * newest first. Capped at the last `limit` entries (default 50,
   * max 200). SuperAdmin only.
   */
  mySupportBotConversations: Array<SupportBotConversation>;
  notificationMessagesByReferencePeriod: NotificationMessagesByReferencePeriodResult;
  notificationTemplate: NotificationTemplate;
  notificationTemplateTrackingStats: NotificationTemplateTrackingStats;
  organization: Organization;
  organizationAnalytics: Array<OrganizationAnalytics>;
  organizationAnalyticsNumbers: Array<OrganizationAnalyticsNumbers>;
  organizationBulkMessageStats: Array<OrgBulkMessageStats>;
  organizationBySlug: Organization;
  organizationCampaignStats: Array<OrgCampaignStats>;
  organizationNotificationStats: Array<OrgNotificationStats>;
  organizationReport: OrganizationReport;
  organizationScheduleEfficiency: OrganizationScheduleEfficiency;
  patient: Patient;
  patientHistoryItem: PatientHistoryItem;
  patientRecord: PatientRecord;
  patientStatus: PatientStatus;
  patientVaccinationRecord: PatientVaccinationRecord;
  patientVaccinationRecordsByPatient: Array<PatientVaccinationRecord>;
  payment?: Maybe<Payment>;
  paymentIntentFromPrescription: StripePaymentIntent;
  paymentIntentFromPrescriptionWithSavedCard: StripePaymentIntent;
  paymentIntentFromService: StripePaymentIntent;
  paymentIntentFromServiceWithSavedCard: StripePaymentIntent;
  pet?: Maybe<Pet>;
  petSelfie: PetSelfie;
  pimsReminder: PimsReminder;
  pimsRemindersByPatient: Array<PimsReminder>;
  pimsRemindersBySendDate: Array<PimsReminder>;
  pimsSettings: PimsSettings;
  pmsApptType: PmsApptType;
  pmsDb: PmsDb;
  pmsOtherEntity: PmsOtherEntity;
  pmsTag: PmsTag;
  pmsTagCategory: PmsTagCategory;
  prescription: Prescription;
  prescriptionPricing: PrescriptionPricing;
  prescriptionRefillRequest: PrescriptionRefillRequest;
  pressItem: PressItem;
  product: Product;
  publicAppointmentTimes?: Maybe<Array<PublicAppointmentTime>>;
  queryActionItems: Array<ActionItem>;
  queryAllClinicAdmins: Array<ClinicAdmin>;
  queryAppointmentPrompts: Array<AppointmentPrompt>;
  queryAppointments: Array<Appointment>;
  queryBreeds: Array<Breed>;
  queryCampaigns: Array<Campaign>;
  queryChats: Array<Chat>;
  /** @deprecated This function is deprecated; use either queryClientFormsForClinic or queryClientFormsForClient instead */
  queryClientForms: Array<ClientForm>;
  queryClientFormsForClient: Array<ClientForm>;
  queryClientFormsForClinic: Array<ClientForm>;
  queryClientStatuses: Array<ClientStatus>;
  queryClients: Array<Client>;
  queryClientsPatients: QueryClientsPatientsResults;
  /** Clinics a user can open: direct memberships plus clinics in their groups. `where`/`orderBy` columns refer to clinic columns (e.g. `name`). Each clinic is returned once. */
  queryClinicAdminClinics: Array<Clinic>;
  queryClinicAdmins: Array<ClinicAdmin>;
  queryClinicAppointments: Array<Appointment>;
  queryClinicApptStatuses: Array<ClinicApptStatus>;
  queryClinicCalls: Array<Call>;
  queryClinicChats: Array<Chat>;
  queryClinicClients: Array<Client>;
  queryClinicDataChats: Array<DataChat>;
  queryClinicEmailTemplates?: Maybe<Array<EmailTemplate>>;
  queryClinicGroupClinics: Array<ClinicGroupClinic>;
  queryClinicGroupEmailTemplates?: Maybe<Array<EmailTemplate>>;
  queryClinicGroupMessageTemplates?: Maybe<Array<MessageTemplate>>;
  queryClinicGroupUsers: Array<ClinicGroupUser>;
  queryClinicGroups: Array<ClinicGroup>;
  /** The clinic groups a user belongs to. `where`/`orderBy` columns refer to clinic group columns (e.g. `name`). */
  queryClinicGroupsForUser: Array<ClinicGroup>;
  queryClinicMessageTemplates?: Maybe<Array<MessageTemplate>>;
  queryClinicMessages: Array<Message>;
  queryClinicPatients: Array<Patient>;
  queryClinicSexes: Array<ClinicSex>;
  queryClinicSpecies: Array<ClinicSpecies>;
  queryClinicians: Array<Clinician>;
  queryClinics: Array<Clinic>;
  queryComplianceReminders: ComplianceReminderResults;
  queryConnectInstallations: Array<ConnectInstallation>;
  queryCustomerSegments: Array<CustomerSegment>;
  queryDiagnoses: Array<Diagnosis>;
  queryDistinctPimsReminderTypeNames: Array<Scalars['String']['output']>;
  queryEntityReports: Array<EntityReport>;
  queryForms: Array<Form>;
  queryInitiatives: Array<Initiative>;
  queryInternalChatUsers: Array<InternalChatUser>;
  queryInvoiceItems: Array<InvoiceItem>;
  queryInvoices: Array<Invoice>;
  queryKpiGroups: Array<KpiGroup>;
  queryLoyaltyEarnings: Array<LoyaltyEarning>;
  queryLoyaltyMembers: Array<LoyaltyMember>;
  queryLoyaltyRedemptions: Array<LoyaltyRedemption>;
  queryLoyaltyRewards: Array<LoyaltyReward>;
  /** @deprecated Use queryClinicMessages instead. */
  queryMessages: Array<Message>;
  queryMsgTrackingEvents: Array<MsgTrackingEvent>;
  /**
   * Portal (pet-owner) scoped variants. Always constrained to the
   * authenticated caller's own clients, regardless of client-supplied
   * filters.
   */
  queryMyAppointments: Array<Appointment>;
  /**
   * Portal (pet-owner) scoped variants. Always constrained to the
   * authenticated caller's own clients.
   */
  queryMyChats: Array<Chat>;
  /**
   * Portal (pet-owner) scoped variants. Always constrained to the
   * authenticated caller's own clients.
   */
  queryMyClientForms: Array<ClientForm>;
  /**
   * Portal (pet-owner) scoped variants. Always constrained to loyalty
   * memberships belonging to the authenticated caller's own clients.
   */
  queryMyLoyaltyMembers: Array<LoyaltyMember>;
  /**
   * Portal (pet-owner) scoped variant. Always constrained to redemptions
   * belonging to the authenticated caller's own loyalty memberships.
   */
  queryMyLoyaltyRedemptions: Array<LoyaltyRedemption>;
  /**
   * Portal (pet-owner) scoped patient concerns (problem list). Always
   * constrained to the authenticated caller's own patients.
   */
  queryMyPatientConcerns: Array<PatientConcern>;
  /**
   * Portal (pet-owner) scoped patient history items (services/treatments and
   * discharge instructions). Always constrained to the authenticated
   * caller's own patients.
   */
  queryMyPatientHistoryItems: Array<PatientHistoryItem>;
  /**
   * Portal (pet-owner) scoped variant of queryPatients. Results are always
   * constrained to patients owned by the authenticated caller's linked
   * clients, regardless of any client-supplied filters.
   */
  queryMyPatients: Array<Patient>;
  /**
   * Portal (pet-owner) scoped variants. Always constrained to the
   * authenticated caller's own clients.
   */
  queryMyPetSelfies: Array<PetSelfie>;
  /**
   * Portal (pet-owner) scoped variant. Always constrained to reminders for
   * the authenticated caller's own patients.
   */
  queryMyPimsReminders: Array<PimsReminder>;
  /**
   * Portal (pet-owner) scoped variants. Always constrained to the
   * authenticated caller's own clients.
   */
  queryMyPrescriptionRefillRequests: Array<PrescriptionRefillRequest>;
  /**
   * Portal (pet-owner) scoped variants. Always constrained to prescriptions
   * for the authenticated caller's own patients.
   */
  queryMyPrescriptions: Array<Prescription>;
  /** Notifications for the current viewer, newest first. Paginated. */
  queryMyUserNotifications: Array<UserNotification>;
  /**
   * Portal (pet-owner) scoped visit concerns (per-visit diagnoses). Always
   * constrained to the authenticated caller's own patients.
   */
  queryMyVisitConcerns: Array<VisitConcern>;
  /**
   * Portal (pet-owner) scoped visits. Always constrained to the
   * authenticated caller's own patients.
   */
  queryMyVisits: Array<Visit>;
  queryNotificationTemplates: Array<NotificationTemplate>;
  queryOrganizationReports: Array<OrganizationReport>;
  queryOrganizations: Array<Organization>;
  queryPatientHistoryItems: Array<PatientHistoryItem>;
  queryPatientStatuses: Array<PatientStatus>;
  queryPatientVaccinationRecords: Array<PatientVaccinationRecord>;
  queryPatients: Array<Patient>;
  queryPatientsOwners: QueryPatientsOwnersResults;
  queryPayments: Array<Payment>;
  queryPetSelfies: Array<PetSelfie>;
  queryPimsReminderTypes: Array<PimsReminderType>;
  queryPimsReminders: Array<PimsReminder>;
  queryPmsApptTypes: Array<PmsApptType>;
  queryPmsDbs: Array<PmsDb>;
  queryPmsOtherEntities: Array<PmsOtherEntity>;
  queryPmsTagCategories: Array<PmsTagCategory>;
  queryPmsTags: Array<PmsTag>;
  queryPrescriptionRefillRequests: Array<PrescriptionRefillRequest>;
  queryPrescriptions: Array<Prescription>;
  queryProducts: Array<Product>;
  queryProviderAvailability?: Maybe<Array<ProviderAvailability>>;
  queryReportMetrics: Array<ReportMetric>;
  queryReportTemplates: Array<ReportTemplate>;
  queryReschedules: Array<Reschedule>;
  queryReviews: Array<Review>;
  queryRooms: Array<Room>;
  queryScheduledBulkMessages: Array<ScheduledBulkMessage>;
  queryScheduledMessages: Array<ScheduledMessage>;
  querySchedulingRules: Array<SchedulingRules>;
  queryServiceForms: Array<ServiceForm>;
  queryServices: Array<Service>;
  queryUserAppointments: Array<Appointment>;
  queryUserChats: Array<Chat>;
  queryUsers: Array<User>;
  queryWidgets: Array<Widget>;
  reminderAttributedAppointmentIds: ReminderAttributedAppointmentIds;
  reportMetric: ReportMetric;
  reportTemplate: ReportTemplate;
  reschedule: Reschedule;
  review: Review;
  /** Per-source counts and ratings plus review-request conversion. Every clinic id must be in the caller's scope. */
  reviewAnalytics: ReviewAnalytics;
  room: Room;
  roomAdjustedAvailability?: Maybe<Array<ProviderAvailability>>;
  roomRoutineAvailability?: Maybe<Array<ProviderAvailability>>;
  scheduledBulkMessage: ScheduledBulkMessage;
  scheduledBulkMessageTrackingStats: ScheduledBulkMessageTrackingStats;
  scheduledMessage: ScheduledMessage;
  schedulingRule?: Maybe<SchedulingRules>;
  schedulingRulesForClinic?: Maybe<Array<SchedulingRules>>;
  schedulingRulesForWidget?: Maybe<Array<SchedulingRules>>;
  searchAppointments: Array<Appointment>;
  searchClinicProducts: SearchClinicProductsResult;
  searchClinicians: Array<Clinician>;
  searchPimsReminderTypesForClinic: PimsReminderTypeSearchResult;
  searchUsers: Array<User>;
  sendClientLinkVerificationCode?: Maybe<Scalars['Void']['output']>;
  service: Service;
  serviceCategories: Array<ServiceCategory>;
  serviceCategory: ServiceCategory;
  serviceForm: ServiceForm;
  serviceFormByServiceAndForm?: Maybe<ServiceForm>;
  species: ClinicSpecies;
  stripeAccountCheck: Scalars['Boolean']['output'];
  stripeAccountInfo: StripeAccountInfo;
  stripeAccountLoginLink: Scalars['URL']['output'];
  stripeAccountOnboardLink: Scalars['URL']['output'];
  suggestChatResponse: SuggestedResponse;
  /**
   * Fetch a single conversation by id, including full message history.
   * Any SuperAdmin may fetch any conversation — this is what powers
   * shareable links between SuperAdmins. Returns null if it doesn't
   * exist. SuperAdmin only.
   */
  supportBotConversation?: Maybe<SupportBotConversation>;
  /**
   * Distinct creators of stored conversations, for the dashboard's
   * "filter by user" dropdown. Sorted by display name. SuperAdmin only.
   */
  supportBotConversationOwners: Array<SupportBotConversationOwner>;
  /**
   * List conversations across ALL SuperAdmins, newest first. Optionally
   * restrict to a single creator via `filterUserId` (drives the
   * dashboard's "filter by user" control). `limit` defaults to 50
   * (max 200); `offset` paginates. SuperAdmin only.
   */
  supportBotConversations: Array<SupportBotConversation>;
  /**
   * Poll the status of an agent run started via `sendSupportBotMessage`.
   * Designed for client-side polling at ~1.5s intervals; the snapshot
   * includes `assistantTextSoFar` for live text rendering. When the
   * snapshot's `status` becomes terminal, the server idempotently
   * appends the assistant message (or error marker) to the conversation
   * and clears `pendingRunId`. SuperAdmin only.
   */
  supportBotRunStatus: SupportBotRunSnapshot;
  /** Connectors a clinic or PMS database on this PIMS can use, its default first. */
  supportedPmsConnectors: Array<PmsConnector>;
  tag: Tag;
  tagCategories: Array<TagCategory>;
  tagCategoriesByClinicGroup: Array<TagCategory>;
  tagCategory: TagCategory;
  tagsForEntity: Array<Tag>;
  todayAnalytics: TodayAnalytics;
  tomorrowAnalytics: TomorrowAnalytics;
  transaction: Transaction;
  treatment: Treatment;
  upcomingAppointmentsByPet: Array<Appointment>;
  user?: Maybe<User>;
  userTrackingClients: UserTrackingClientPage;
  userTrackingSummary: UserTrackingSummary;
  /**
   * Public, token-gated read of a single pet's vaccine records. The token
   * is minted by the AI receptionist's send_vaccine_records tool and
   * delivered out-of-band (SMS/email); possession is the capability, so no
   * auth is required. Returns null when the token is invalid, expired, or
   * tampered.
   */
  vaccineRecordsByToken?: Maybe<VaccineRecordsView>;
  validateClientPhone: Scalars['Boolean']['output'];
  widget: Widget;
  widgetOptions: WidgetOptions;
  widgetOptionsForWidget?: Maybe<WidgetOptions>;
  widgetService: WidgetService;
  widgetServicesForWidget: Array<WidgetService>;
  widgetSisterLocation: WidgetSisterLocation;
  widgetSisterLocations: Array<WidgetSisterLocation>;
  yesterdayAnalytics: YesterdayAnalytics;
};


export type QueryActionItemArgs = {
  id: Scalars['ID']['input'];
};


export type QueryAggregateClinicDataArgs = {
  input: ClinicAggregateInput;
};


export type QueryAllClinicsArgs = {
  page?: InputMaybe<Scalars['NonNegativeInt']['input']>;
  pageSize?: InputMaybe<Scalars['NonNegativeInt']['input']>;
};


export type QueryAllServicesByClinicIdArgs = {
  id: Scalars['ID']['input'];
};


export type QueryAnimalArgs = {
  id: Scalars['ID']['input'];
};


export type QueryAppointmentArgs = {
  id: Scalars['ID']['input'];
};


export type QueryAppointmentGoogleCalendarLinkArgs = {
  appointmentId: Scalars['ID']['input'];
};


export type QueryAppointmentPromptArgs = {
  id: Scalars['ID']['input'];
};


export type QueryAppointmentsByClientArgs = {
  clientId: Scalars['ID']['input'];
};


export type QueryAppointmentsByClinicAndRangeArgs = {
  clinicId: Scalars['ID']['input'];
  end_time: Scalars['NonNegativeInt']['input'];
  start_time: Scalars['NonNegativeInt']['input'];
};


export type QueryAppointmentsByUserArgs = {
  userId: Scalars['ID']['input'];
};


export type QueryAppointmentsCountByClinicArgs = {
  where?: InputMaybe<Array<QueryInput>>;
};


export type QueryApptStatusArgs = {
  apptStatusId: Scalars['ID']['input'];
  clinicId: Scalars['ID']['input'];
};


export type QueryBillableUsageStatsByTypeArgs = {
  clinicId: Scalars['ID']['input'];
  endDate?: InputMaybe<Scalars['NonNegativeInt']['input']>;
  startDate?: InputMaybe<Scalars['NonNegativeInt']['input']>;
};


export type QueryBookingAttributionAnalyticsArgs = {
  clinic_group_id: Scalars['ID']['input'];
  dimension: BookingAttributionDimension;
  range: UsageTimeRangeInput;
};


export type QueryBookingClientFormsArgs = {
  clientId: Scalars['ID']['input'];
  orderBy?: InputMaybe<OrderByInput>;
  page?: InputMaybe<Scalars['NonNegativeInt']['input']>;
  pageSize?: InputMaybe<Scalars['NonNegativeInt']['input']>;
  where?: InputMaybe<Array<QueryInput>>;
};


export type QueryBookingClientPatientsArgs = {
  clientId: Scalars['ID']['input'];
  orderBy?: InputMaybe<OrderByInput>;
  page?: InputMaybe<Scalars['NonNegativeInt']['input']>;
  pageSize?: InputMaybe<Scalars['NonNegativeInt']['input']>;
  where?: InputMaybe<Array<QueryInput>>;
};


export type QueryBookingFlowEventsArgs = {
  filters: BookingFlowEventFilters;
};


export type QueryBookingFlowFunnelArgs = {
  filters: BookingFlowFunnelFilters;
};


export type QueryBookingPrefillByClickIdArgs = {
  clickId: Scalars['String']['input'];
};


export type QueryBookingSourceAnalyticsArgs = {
  clinic_group_id: Scalars['ID']['input'];
  range: UsageTimeRangeInput;
};


export type QueryBreedArgs = {
  breedId: Scalars['String']['input'];
  clinicId: Scalars['ID']['input'];
};


export type QueryBuildProposedChangeArgs = {
  input: BuildProposedChangeInput;
};


export type QueryBulkMessageAudienceEstimateArgs = {
  data: BulkMessageAudienceEstimateInput;
};


export type QueryCalculateClinicValuesForKpiGroupMetricArgs = {
  id: Scalars['ID']['input'];
  options?: InputMaybe<ComputeKpiGroupValuesOptions>;
};


export type QueryCallArgs = {
  id: Scalars['ID']['input'];
};


export type QueryCallsByClientArgs = {
  clientId: Scalars['ID']['input'];
};


export type QueryCallsByClinicArgs = {
  clinicId: Scalars['ID']['input'];
};


export type QueryCampaignArgs = {
  id: Scalars['ID']['input'];
};


export type QueryCampaignNotificationStatsArgs = {
  clinicId: Scalars['ID']['input'];
  notificationId: Scalars['ID']['input'];
};


export type QueryCampaignScheduledBulkMessageStatsArgs = {
  bulkMessageId: Scalars['ID']['input'];
  clinicId: Scalars['ID']['input'];
};


export type QueryCampaignStatsArgs = {
  campaignId: Scalars['ID']['input'];
  clinicId: Scalars['ID']['input'];
};


export type QueryCampaignWidgetStatsArgs = {
  clinicId: Scalars['ID']['input'];
  widgetId: Scalars['ID']['input'];
};


export type QueryChatArgs = {
  id: Scalars['ID']['input'];
};


export type QueryChatStatusArgs = {
  id: Scalars['ID']['input'];
};


export type QueryChatStatusesArgs = {
  clinicId: Scalars['ID']['input'];
};


export type QueryChatStatusesByClinicGroupArgs = {
  clinicGroupId: Scalars['ID']['input'];
};


export type QueryCheckClientFormsForConfirmationArgs = {
  appointmentId: Scalars['ID']['input'];
};


export type QueryCheckEmailListArgs = {
  email: Scalars['String']['input'];
};


export type QueryCheckExistingClientArgs = {
  clinicId: Scalars['ID']['input'];
  email?: InputMaybe<Scalars['String']['input']>;
  firstName: Scalars['String']['input'];
  lastName: Scalars['String']['input'];
  phone: Scalars['String']['input'];
};


export type QueryCheckExistingClientsArgs = {
  email?: InputMaybe<Scalars['String']['input']>;
  phone?: InputMaybe<Scalars['String']['input']>;
};


export type QueryCheckExistingPatientArgs = {
  clientId: Scalars['ID']['input'];
  clinicId: Scalars['ID']['input'];
  name: Scalars['String']['input'];
};


export type QueryCheckForDuplicateAppointmentArgs = {
  data: SubmitAppointmentInput;
};


export type QueryCheckForUserByEmailArgs = {
  email: Scalars['String']['input'];
};


export type QueryCheckIfClientIsBlocklistedArgs = {
  clientId?: InputMaybe<Scalars['ID']['input']>;
  clinicId: Scalars['ID']['input'];
  identity?: InputMaybe<MaybeClientInput>;
};


export type QueryCheckIfServerRunningArgs = {
  clinicId: Scalars['ID']['input'];
};


export type QueryCheckInArgs = {
  id: Scalars['ID']['input'];
};


export type QueryCheckMaybeClientArgs = {
  clinicId: Scalars['ID']['input'];
  input: MaybeClientInput;
  isNewPatient?: InputMaybe<Scalars['Boolean']['input']>;
};


export type QueryCheckReturningClientPatientArgs = {
  clinicId: Scalars['ID']['input'];
  searchInput: Scalars['String']['input'];
};


export type QueryCheckTimeSlotAvailabilityArgs = {
  clinicId: Scalars['ID']['input'];
  params: TimeSlotParams;
  time: Scalars['NonNegativeInt']['input'];
  widgetId?: InputMaybe<Scalars['ID']['input']>;
};


export type QueryCheckUserDesktopNotificationTokenArgs = {
  id: Scalars['ID']['input'];
  token: Scalars['String']['input'];
};


export type QueryCheckUserPushNotificationTokenArgs = {
  id: Scalars['ID']['input'];
  token: Scalars['String']['input'];
};


export type QueryClientArgs = {
  id: Scalars['ID']['input'];
};


export type QueryClientFormArgs = {
  id: Scalars['ID']['input'];
};


export type QueryClientPreviewArgs = {
  id: Scalars['ID']['input'];
};


export type QueryClientStatusArgs = {
  id: Scalars['ID']['input'];
};


export type QueryClinicArgs = {
  id: Scalars['ID']['input'];
};


export type QueryClinicAccessForUserArgs = {
  clinicId: Scalars['ID']['input'];
  userId: Scalars['ID']['input'];
};


export type QueryClinicAdjustedAvailabilityArgs = {
  clinicId: Scalars['ID']['input'];
};


export type QueryClinicAdminArgs = {
  id: Scalars['ID']['input'];
};


export type QueryClinicAgentConversationArgs = {
  clinicGroupId?: InputMaybe<Scalars['ID']['input']>;
  clinicId?: InputMaybe<Scalars['ID']['input']>;
  id: Scalars['ID']['input'];
};


export type QueryClinicAgentEnabledArgs = {
  clinicGroupId?: InputMaybe<Scalars['ID']['input']>;
  clinicId?: InputMaybe<Scalars['ID']['input']>;
};


export type QueryClinicAgentRunStatusArgs = {
  clinicGroupId?: InputMaybe<Scalars['ID']['input']>;
  clinicId?: InputMaybe<Scalars['ID']['input']>;
  runId: Scalars['ID']['input'];
};


export type QueryClinicBookingAttributionAnalyticsArgs = {
  clinic_id: Scalars['ID']['input'];
  dimension: BookingAttributionDimension;
  range: UsageTimeRangeInput;
};


export type QueryClinicBookingSourceAnalyticsArgs = {
  clinic_id: Scalars['ID']['input'];
  range: UsageTimeRangeInput;
};


export type QueryClinicBySlugArgs = {
  slug: Scalars['String']['input'];
};


export type QueryClinicCallStatsArgs = {
  clinicId: Scalars['ID']['input'];
  where?: InputMaybe<Array<QueryInput>>;
};


export type QueryClinicFeaturesArgs = {
  id: Scalars['ID']['input'];
};


export type QueryClinicGoLiveCheckArgs = {
  clinicId: Scalars['ID']['input'];
  probes?: InputMaybe<Array<GoLiveCheckProbe>>;
};


export type QueryClinicGroupArgs = {
  id: Scalars['ID']['input'];
};


export type QueryClinicGroupBySlugArgs = {
  slug: Scalars['String']['input'];
};


export type QueryClinicGroupMedicalReminderFunnelArgs = {
  clinic_group_id: Scalars['ID']['input'];
  clinic_ids?: InputMaybe<Array<Scalars['ID']['input']>>;
  include_notification_breakdown?: InputMaybe<Scalars['Boolean']['input']>;
  range: UsageTimeRangeInput;
};


export type QueryClinicGroupNotificationAnalyticsArgs = {
  clinic_group_id: Scalars['ID']['input'];
  clinic_ids?: InputMaybe<Array<Scalars['ID']['input']>>;
  range: UsageTimeRangeInput;
};


export type QueryClinicGroupUserArgs = {
  id: Scalars['ID']['input'];
};


export type QueryClinicGroupUserByGroupAndUserArgs = {
  clinicGroupId: Scalars['ID']['input'];
  userId: Scalars['ID']['input'];
};


export type QueryClinicMedicalReminderFunnelArgs = {
  clinic_id: Scalars['ID']['input'];
  include_notification_breakdown?: InputMaybe<Scalars['Boolean']['input']>;
  range: UsageTimeRangeInput;
};


export type QueryClinicNotificationAnalyticsArgs = {
  clinic_id: Scalars['ID']['input'];
  range: UsageTimeRangeInput;
};


export type QueryClinicOnboardingArgs = {
  clinicId: Scalars['ID']['input'];
};


export type QueryClinicRoutineAvailabilityArgs = {
  clinicId: Scalars['ID']['input'];
};


export type QueryClinicSettingsFieldValuesForClinicGroupArgs = {
  clinicGroupId: Scalars['ID']['input'];
  fields: Array<Scalars['String']['input']>;
};


export type QueryClinicStatsArgs = {
  clinicId: Scalars['ID']['input'];
};


export type QueryClinicianArgs = {
  id: Scalars['ID']['input'];
};


export type QueryClinicianAdjustedAvailabilityArgs = {
  clinicId: Scalars['ID']['input'];
  clinicianId: Scalars['ID']['input'];
};


export type QueryClinicianRoutineAvailabilityArgs = {
  clinicId: Scalars['ID']['input'];
  clinicianId: Scalars['ID']['input'];
};


export type QueryComplianceStatusActivityArgs = {
  clinicIds: Array<Scalars['ID']['input']>;
  endDate: Scalars['NonNegativeInt']['input'];
  startDate: Scalars['NonNegativeInt']['input'];
};


export type QueryComputeInitiativeValuesArgs = {
  id: Scalars['ID']['input'];
  params: ComputeInitiativeValuesParams;
};


export type QueryComputeKpiGroupValuesArgs = {
  id: Scalars['ID']['input'];
  options?: InputMaybe<ComputeKpiGroupValuesOptions>;
};


export type QueryComputeReportTemplateValuesArgs = {
  id: Scalars['ID']['input'];
  options?: InputMaybe<ComputeReportTemplateValuesOptions>;
};


export type QueryConfirmationAppointmentsArgs = {
  id: Scalars['ID']['input'];
};


export type QueryConnectInstallationArgs = {
  clinicId: Scalars['ID']['input'];
  installationId: Scalars['ID']['input'];
};


export type QueryCountActionItemsArgs = {
  where?: InputMaybe<Array<QueryInput>>;
};


export type QueryCountAllClinicAdminsArgs = {
  where?: InputMaybe<Array<QueryInput>>;
};


export type QueryCountAppointmentsArgs = {
  where?: InputMaybe<Array<QueryInput>>;
};


export type QueryCountBookingClientPatientsArgs = {
  clientId: Scalars['ID']['input'];
  where?: InputMaybe<Array<QueryInput>>;
};


export type QueryCountBreedsArgs = {
  where?: InputMaybe<Array<QueryInput>>;
};


export type QueryCountCallsArgs = {
  where?: InputMaybe<Array<QueryInput>>;
};


export type QueryCountCampaignsArgs = {
  where?: InputMaybe<Array<QueryInput>>;
};


export type QueryCountChatsArgs = {
  where?: InputMaybe<Array<QueryInput>>;
};


export type QueryCountClientFormsArgs = {
  where?: InputMaybe<Array<QueryInput>>;
};


export type QueryCountClientStatusesArgs = {
  where?: InputMaybe<Array<QueryInput>>;
};


export type QueryCountClientsArgs = {
  where?: InputMaybe<Array<QueryInput>>;
};


export type QueryCountClinicAdminClinicsArgs = {
  userId: Scalars['ID']['input'];
  where?: InputMaybe<Array<QueryInput>>;
};


export type QueryCountClinicAdminsArgs = {
  clinicId: Scalars['ID']['input'];
  where?: InputMaybe<Array<QueryInput>>;
};


export type QueryCountClinicApptStatusesArgs = {
  where?: InputMaybe<Array<QueryInput>>;
};


export type QueryCountClinicClientsArgs = {
  clinicId: Scalars['ID']['input'];
  where?: InputMaybe<Array<QueryInput>>;
};


export type QueryCountClinicEmailTemplatesArgs = {
  clinicId: Scalars['ID']['input'];
  where?: InputMaybe<Array<QueryInput>>;
};


export type QueryCountClinicGroupClinicsArgs = {
  where?: InputMaybe<Array<QueryInput>>;
};


export type QueryCountClinicGroupEmailTemplatesArgs = {
  clinicGroupId: Scalars['ID']['input'];
  where?: InputMaybe<Array<QueryInput>>;
};


export type QueryCountClinicGroupMessageTemplatesArgs = {
  clinicGroupId: Scalars['ID']['input'];
  where?: InputMaybe<Array<QueryInput>>;
};


export type QueryCountClinicGroupUsersArgs = {
  clinicGroupId: Scalars['ID']['input'];
  where?: InputMaybe<Array<QueryInput>>;
};


export type QueryCountClinicGroupsArgs = {
  where?: InputMaybe<Array<QueryInput>>;
};


export type QueryCountClinicGroupsForUserArgs = {
  userId: Scalars['ID']['input'];
  where?: InputMaybe<Array<QueryInput>>;
};


export type QueryCountClinicMessageTemplatesArgs = {
  clinicId: Scalars['ID']['input'];
  where?: InputMaybe<Array<QueryInput>>;
};


export type QueryCountClinicPatientsArgs = {
  clinicId: Scalars['ID']['input'];
  where?: InputMaybe<Array<QueryInput>>;
};


export type QueryCountClinicSexesArgs = {
  where?: InputMaybe<Array<QueryInput>>;
};


export type QueryCountClinicSpeciesArgs = {
  where?: InputMaybe<Array<QueryInput>>;
};


export type QueryCountCliniciansArgs = {
  where?: InputMaybe<Array<QueryInput>>;
};


export type QueryCountClinicsArgs = {
  where?: InputMaybe<Array<QueryInput>>;
};


export type QueryCountClinicsForUserAdminArgs = {
  userId: Scalars['ID']['input'];
};


export type QueryCountDiagnosesArgs = {
  where?: InputMaybe<Array<QueryInput>>;
};


export type QueryCountDrilldownEntitiesArgs = {
  metricId: Scalars['ID']['input'];
  params: GetDrilldownEntitiesParams;
};


export type QueryCountFormsArgs = {
  where?: InputMaybe<Array<QueryInput>>;
};


export type QueryCountInitiativesArgs = {
  where?: InputMaybe<Array<QueryInput>>;
};


export type QueryCountInternalChatUsersArgs = {
  where?: InputMaybe<Array<QueryInput>>;
};


export type QueryCountInternalUsageEventsArgs = {
  filters: InternalUsageEventFilters;
};


export type QueryCountInvoiceItemsArgs = {
  where?: InputMaybe<Array<QueryInput>>;
};


export type QueryCountInvoicesArgs = {
  where?: InputMaybe<Array<QueryInput>>;
};


export type QueryCountKpiGroupsArgs = {
  where?: InputMaybe<Array<QueryInput>>;
};


export type QueryCountLoyaltyEarningsArgs = {
  where?: InputMaybe<Array<QueryInput>>;
};


export type QueryCountLoyaltyMembersArgs = {
  where?: InputMaybe<Array<QueryInput>>;
};


export type QueryCountLoyaltyRedemptionsArgs = {
  where?: InputMaybe<Array<QueryInput>>;
};


export type QueryCountLoyaltyRewardsArgs = {
  where?: InputMaybe<Array<QueryInput>>;
};


export type QueryCountMessagesArgs = {
  clinicId: Scalars['ID']['input'];
  notificationTemplateIds?: InputMaybe<Array<Scalars['ID']['input']>>;
  patientIds?: InputMaybe<Array<Scalars['ID']['input']>>;
  where?: InputMaybe<Array<QueryInput>>;
};


export type QueryCountMsgTrackingEventsArgs = {
  where?: InputMaybe<Array<QueryInput>>;
};


export type QueryCountMyAppointmentsArgs = {
  where?: InputMaybe<Array<QueryInput>>;
};


export type QueryCountMyChatsArgs = {
  where?: InputMaybe<Array<QueryInput>>;
};


export type QueryCountMyClientFormsArgs = {
  where?: InputMaybe<Array<QueryInput>>;
};


export type QueryCountMyLoyaltyMembersArgs = {
  where?: InputMaybe<Array<QueryInput>>;
};


export type QueryCountMyPatientConcernsArgs = {
  where?: InputMaybe<Array<QueryInput>>;
};


export type QueryCountMyPatientHistoryItemsArgs = {
  where?: InputMaybe<Array<QueryInput>>;
};


export type QueryCountMyPatientsArgs = {
  where?: InputMaybe<Array<QueryInput>>;
};


export type QueryCountMyPetSelfiesArgs = {
  where?: InputMaybe<Array<QueryInput>>;
};


export type QueryCountMyPrescriptionRefillRequestsArgs = {
  where?: InputMaybe<Array<QueryInput>>;
};


export type QueryCountMyPrescriptionsArgs = {
  where?: InputMaybe<Array<QueryInput>>;
};


export type QueryCountMyVisitsArgs = {
  where?: InputMaybe<Array<QueryInput>>;
};


export type QueryCountNotificationTemplatesArgs = {
  where?: InputMaybe<Array<QueryInput>>;
};


export type QueryCountOrganizationReportsArgs = {
  where?: InputMaybe<Array<QueryInput>>;
};


export type QueryCountOrganizationsArgs = {
  where?: InputMaybe<Array<QueryInput>>;
};


export type QueryCountOverduePatientsArgs = {
  clinicId: Scalars['ID']['input'];
  options?: InputMaybe<OverduePatientOptions>;
};


export type QueryCountPatientHistoryItemsArgs = {
  where?: InputMaybe<Array<QueryInput>>;
};


export type QueryCountPatientStatusesArgs = {
  where?: InputMaybe<Array<QueryInput>>;
};


export type QueryCountPatientVaccinationRecordsArgs = {
  where?: InputMaybe<Array<QueryInput>>;
};


export type QueryCountPatientVaccinationRecordsByPatientArgs = {
  hideHistoric?: InputMaybe<Scalars['Boolean']['input']>;
  hideSoc?: InputMaybe<Scalars['Boolean']['input']>;
  patientId: Scalars['ID']['input'];
  showInactive?: InputMaybe<Scalars['Boolean']['input']>;
};


export type QueryCountPatientsArgs = {
  where?: InputMaybe<Array<QueryInput>>;
};


export type QueryCountPatientsFromOtherClinicsArgs = {
  clinicId: Scalars['ID']['input'];
  userId: Scalars['ID']['input'];
};


export type QueryCountPaymentsArgs = {
  where?: InputMaybe<Array<QueryInput>>;
};


export type QueryCountPetSelfiesArgs = {
  where?: InputMaybe<Array<QueryInput>>;
};


export type QueryCountPetsByUserIdArgs = {
  userId: Scalars['ID']['input'];
};


export type QueryCountPimsReminderTypesArgs = {
  where?: InputMaybe<Array<QueryInput>>;
};


export type QueryCountPimsRemindersArgs = {
  where?: InputMaybe<Array<QueryInput>>;
};


export type QueryCountPimsRemindersByPatientArgs = {
  clinicId: Scalars['ID']['input'];
  patientPmsId: Scalars['String']['input'];
};


export type QueryCountPmsDbsArgs = {
  where?: InputMaybe<Array<QueryInput>>;
};


export type QueryCountPmsOtherEntitiesArgs = {
  where?: InputMaybe<Array<QueryInput>>;
};


export type QueryCountPmsTagCategoriesArgs = {
  where?: InputMaybe<Array<QueryInput>>;
};


export type QueryCountPmsTagsArgs = {
  where?: InputMaybe<Array<QueryInput>>;
};


export type QueryCountPotentialClinicsForUserArgs = {
  input: PotentialClinicInput;
};


export type QueryCountPrescriptionRefillRequestsArgs = {
  where?: InputMaybe<Array<QueryInput>>;
};


export type QueryCountPrescriptionsArgs = {
  where?: InputMaybe<Array<QueryInput>>;
};


export type QueryCountPreviousClinicsForUserArgs = {
  userId: Scalars['ID']['input'];
};


export type QueryCountProductsArgs = {
  where?: InputMaybe<Array<QueryInput>>;
};


export type QueryCountProviderAvailabilityArgs = {
  clinicId: Scalars['ID']['input'];
  where: Array<QueryInput>;
};


export type QueryCountReportMetricsArgs = {
  where?: InputMaybe<Array<QueryInput>>;
};


export type QueryCountReportTemplatesArgs = {
  where?: InputMaybe<Array<QueryInput>>;
};


export type QueryCountReschedulesArgs = {
  where?: InputMaybe<Array<QueryInput>>;
};


export type QueryCountReviewsArgs = {
  where?: InputMaybe<Array<QueryInput>>;
};


export type QueryCountRoomsArgs = {
  where?: InputMaybe<Array<QueryInput>>;
};


export type QueryCountScheduledBulkMessagesArgs = {
  where?: InputMaybe<Array<QueryInput>>;
};


export type QueryCountScheduledMessagesArgs = {
  where?: InputMaybe<Array<QueryInput>>;
};


export type QueryCountSchedulingRulesArgs = {
  where?: InputMaybe<Array<QueryInput>>;
};


export type QueryCountSchedulingRulesForClinicArgs = {
  clinicId: Scalars['ID']['input'];
};


export type QueryCountServiceFormsArgs = {
  where?: InputMaybe<Array<QueryInput>>;
};


export type QueryCountServicesArgs = {
  where?: InputMaybe<Array<QueryInput>>;
};


export type QueryCountUserClientsArgs = {
  userId: Scalars['ID']['input'];
};


export type QueryCountUsersArgs = {
  where?: InputMaybe<Array<QueryInput>>;
};


export type QueryCountWidgetsArgs = {
  where?: InputMaybe<Array<QueryInput>>;
};


export type QueryCustomRoleArgs = {
  id: Scalars['ID']['input'];
};


export type QueryCustomerSegmentArgs = {
  id: Scalars['ID']['input'];
};


export type QueryDailyHuddleArgs = {
  clinicId: Scalars['ID']['input'];
  dailyHuddleId: Scalars['ID']['input'];
};


export type QueryDataChatArgs = {
  id: Scalars['ID']['input'];
};


export type QueryDefaultPortalWidgetArgs = {
  clinicId: Scalars['ID']['input'];
};


export type QueryDiagnosisArgs = {
  id: Scalars['ID']['input'];
};


export type QueryDuePatientRemindersArgs = {
  clientId: Scalars['ID']['input'];
  clinicId: Scalars['ID']['input'];
  referenceDate?: InputMaybe<Scalars['NonNegativeInt']['input']>;
};


export type QueryEmailTemplateArgs = {
  id: Scalars['ID']['input'];
};


export type QueryEmailTemplatesForClinicArgs = {
  clinic: Scalars['ID']['input'];
  status?: InputMaybe<Array<EmailTemplateStatus>>;
};


export type QueryEnsureDefaultPortalWidgetArgs = {
  clinicId: Scalars['ID']['input'];
};


export type QueryEnterpriseOnboardingEntitiesArgs = {
  clinic_group_id: Scalars['ID']['input'];
  clinic_id: Scalars['ID']['input'];
  entity_type: EntityLinkType;
};


export type QueryEnterpriseOnboardingReportArgs = {
  clinic_group_id: Scalars['ID']['input'];
  tranche_key?: InputMaybe<Scalars['String']['input']>;
};


export type QueryEnterpriseOnboardingSetupEntitiesArgs = {
  clinic_group_id: Scalars['ID']['input'];
  clinic_id: Scalars['ID']['input'];
  kind: EnterpriseOnboardingSetupKind;
};


export type QueryEntityLinkCoverageDetailsForClinicArgs = {
  clinicGroupId: Scalars['ID']['input'];
  clinicId: Scalars['ID']['input'];
  entityTypes?: InputMaybe<Array<EntityLinkType>>;
};


export type QueryEntityLinkCoverageForClinicGroupArgs = {
  clinicGroupId: Scalars['ID']['input'];
};


export type QueryEntityLinkFieldsChangedByUpdateArgs = {
  childId: Scalars['ID']['input'];
  data: Scalars['JSON']['input'];
  entityType: EntityLinkType;
};


export type QueryEntityLinkForChildArgs = {
  childId: Scalars['ID']['input'];
  entityType: EntityLinkType;
};


export type QueryEntityLinkSummaryArgs = {
  entityType: EntityLinkType;
  parentId: Scalars['ID']['input'];
};


export type QueryEntityLinksForClinicArgs = {
  clinicId: Scalars['ID']['input'];
  entityType: EntityLinkType;
};


export type QueryEntityLinksForParentArgs = {
  entityType: EntityLinkType;
  parentId: Scalars['ID']['input'];
};


export type QueryFamilyArgs = {
  id: Scalars['ID']['input'];
};


export type QueryFilterAppointmentsArgs = {
  filters: FilterAppointmentInput;
  userId: Scalars['ID']['input'];
};


export type QueryFindPotentialClientsForUserArgs = {
  input: PotentialClinicInput;
  page?: InputMaybe<Scalars['NonNegativeInt']['input']>;
  pageSize?: InputMaybe<Scalars['NonNegativeInt']['input']>;
  userId?: InputMaybe<Scalars['ID']['input']>;
};


export type QueryFindPotentialClinicsForUserArgs = {
  input: PotentialClinicInput;
  page?: InputMaybe<Scalars['NonNegativeInt']['input']>;
  pageSize?: InputMaybe<Scalars['NonNegativeInt']['input']>;
};


export type QueryFormArgs = {
  id: Scalars['ID']['input'];
};


export type QueryGetAccountsReceivableArgs = {
  clinicId: Scalars['ID']['input'];
};


export type QueryGetActivePimsRemindersByPatientsArgs = {
  patientIds: Array<Scalars['ID']['input']>;
};


export type QueryGetActiveServicesForBookingArgs = {
  clinicId: Scalars['ID']['input'];
  widgetId?: InputMaybe<Scalars['ID']['input']>;
};


export type QueryGetAiAgentPromptForClinicArgs = {
  clinicId: Scalars['ID']['input'];
};


export type QueryGetAiPromptSuggestionsForClinicArgs = {
  clinicId: Scalars['ID']['input'];
  status?: InputMaybe<AiImprovementStatus>;
};


export type QueryGetAllClientsForUserClinicArgs = {
  clinicId: Scalars['ID']['input'];
  userId: Scalars['ID']['input'];
};


export type QueryGetAnalyticsForFormsArgs = {
  formIds: Array<Scalars['ID']['input']>;
  params?: InputMaybe<FormAnalyticsParams>;
};


export type QueryGetAnalyticsNumbersByMonthsForOrganizationArgs = {
  numMonths: Scalars['NonNegativeInt']['input'];
  organizationId: Scalars['ID']['input'];
};


export type QueryGetAppointmentCountByWidgetIdArgs = {
  clinicId: Scalars['ID']['input'];
  widgetId: Scalars['String']['input'];
};


export type QueryGetAppointmentCountByWidgetSourceArgs = {
  clinicId: Scalars['ID']['input'];
  widgetSource: Scalars['String']['input'];
};


export type QueryGetAppointmentInvoiceTotalsArgs = {
  appointmentIds: Array<Scalars['ID']['input']>;
};


export type QueryGetAverageRatingForRecentReviewsArgs = {
  clinicId: Scalars['ID']['input'];
  maxCount?: InputMaybe<Scalars['PositiveInt']['input']>;
};


export type QueryGetAverageRatingForRecentReviewsForClinicsArgs = {
  clinicIds: Array<Scalars['ID']['input']>;
  maxCount?: InputMaybe<Scalars['PositiveInt']['input']>;
};


export type QueryGetBookingQuestionsFromSchedulingRulesArgs = {
  clinicId: Scalars['ID']['input'];
  widgetId?: InputMaybe<Scalars['ID']['input']>;
};


export type QueryGetBreedsByClinicArgs = {
  clinicId: Scalars['ID']['input'];
};


export type QueryGetChangeLogsByEntityIdArgs = {
  entityId: Scalars['String']['input'];
  params?: InputMaybe<PaginationParams>;
};


export type QueryGetChatByClientAndClinicArgs = {
  clientId: Scalars['ID']['input'];
  clinicId: Scalars['ID']['input'];
};


export type QueryGetChatMessagesByChatIdArgs = {
  chatId: Scalars['ID']['input'];
  isClientChat?: InputMaybe<Scalars['Boolean']['input']>;
  page?: InputMaybe<Scalars['NonNegativeInt']['input']>;
  pageSize?: InputMaybe<Scalars['NonNegativeInt']['input']>;
  patientIds?: InputMaybe<Array<Scalars['ID']['input']>>;
  showSystemMessages?: InputMaybe<Scalars['Boolean']['input']>;
};


export type QueryGetChatsByClientIdArgs = {
  clientId: Scalars['ID']['input'];
  page?: InputMaybe<Scalars['NonNegativeInt']['input']>;
  pageSize?: InputMaybe<Scalars['NonNegativeInt']['input']>;
};


export type QueryGetChatsByClinicIdArgs = {
  clinicId: Scalars['ID']['input'];
  page?: InputMaybe<Scalars['NonNegativeInt']['input']>;
  pageSize?: InputMaybe<Scalars['NonNegativeInt']['input']>;
};


export type QueryGetCheckInsByClinicArgs = {
  clinicId: Scalars['ID']['input'];
};


export type QueryGetCheckInsByUserArgs = {
  userId: Scalars['ID']['input'];
};


export type QueryGetClientAiSummaryArgs = {
  clientId: Scalars['ID']['input'];
  includeCalls?: InputMaybe<Scalars['Boolean']['input']>;
  includeReviews?: InputMaybe<Scalars['Boolean']['input']>;
  promptOverride?: InputMaybe<Scalars['String']['input']>;
};


export type QueryGetClientCountForClinicArgs = {
  clinicId: Scalars['ID']['input'];
};


export type QueryGetClientForUserClinicArgs = {
  clinicId: Scalars['ID']['input'];
  userId: Scalars['ID']['input'];
};


export type QueryGetClientFormsForClinicArgs = {
  clinicId: Scalars['ID']['input'];
};


export type QueryGetClientStatusesByClinicArgs = {
  clinicId: Scalars['ID']['input'];
};


export type QueryGetClientsArgs = {
  clientIds: Array<Scalars['ID']['input']>;
  clinicId: Scalars['String']['input'];
};


export type QueryGetClientsByCustomerSegmentArgs = {
  id: Scalars['ID']['input'];
  page?: InputMaybe<Scalars['NonNegativeInt']['input']>;
  pageSize?: InputMaybe<Scalars['NonNegativeInt']['input']>;
  referenceDate?: InputMaybe<Scalars['NonNegativeInt']['input']>;
};


export type QueryGetClientsByCustomerSegmentRpcArgs = {
  clinicId?: InputMaybe<Scalars['ID']['input']>;
  id: Scalars['ID']['input'];
  isForNotification?: InputMaybe<Scalars['Boolean']['input']>;
  notificationTemplateId?: InputMaybe<Scalars['ID']['input']>;
  page?: InputMaybe<Scalars['NonNegativeInt']['input']>;
  pageSize?: InputMaybe<Scalars['NonNegativeInt']['input']>;
  referenceDate?: InputMaybe<Scalars['NonNegativeInt']['input']>;
  search?: InputMaybe<CustomerSegmentSearchInput>;
  startingDateOverride?: InputMaybe<Scalars['NonNegativeInt']['input']>;
  usingPreciseHourly?: InputMaybe<Scalars['Boolean']['input']>;
};


export type QueryGetClientsCountByCustomerSegmentArgs = {
  id: Scalars['ID']['input'];
};


export type QueryGetClientsForClinicArgs = {
  clinicId: Scalars['ID']['input'];
  page?: InputMaybe<Scalars['NonNegativeInt']['input']>;
  pageSize?: InputMaybe<Scalars['NonNegativeInt']['input']>;
};


export type QueryGetClientsWithNegativeBalancesForClinicArgs = {
  clinicId: Scalars['ID']['input'];
};


export type QueryGetClientsWithOverduePatientsArgs = {
  clinicId: Scalars['ID']['input'];
  page?: InputMaybe<Scalars['NonNegativeInt']['input']>;
  pageSize?: InputMaybe<Scalars['NonNegativeInt']['input']>;
};


export type QueryGetClientsWithoutApptOverDaysForClinicArgs = {
  clinicId: Scalars['ID']['input'];
  days: Scalars['NonNegativeInt']['input'];
};


export type QueryGetClinicAdminArgs = {
  clinicId: Scalars['ID']['input'];
  userId: Scalars['ID']['input'];
};


export type QueryGetClinicAdminsByClinicArgs = {
  clinicId: Scalars['ID']['input'];
};


export type QueryGetClinicAdminsByUserArgs = {
  userId: Scalars['ID']['input'];
};


export type QueryGetClinicApptStatusesByClinicArgs = {
  clinicId: Scalars['ID']['input'];
};


export type QueryGetClinicAvailabilityArgs = {
  clinicId: Scalars['ID']['input'];
};


export type QueryGetClinicGroupClinicsByLocationArgs = {
  clinicGroupId: Scalars['ID']['input'];
  excludeClinicIds?: InputMaybe<Array<Scalars['ID']['input']>>;
  location?: InputMaybe<ClinicGroupClinicLocationInput>;
  numberOfClinics?: InputMaybe<Scalars['NonNegativeInt']['input']>;
};


export type QueryGetClinicGroupsForUserArgs = {
  page?: InputMaybe<Scalars['NonNegativeInt']['input']>;
  pageSize?: InputMaybe<Scalars['NonNegativeInt']['input']>;
  userId: Scalars['ID']['input'];
};


export type QueryGetClinicSpeciesByClinicArgs = {
  clinicId: Scalars['ID']['input'];
};


export type QueryGetClinicUsageStatsArgs = {
  orderBy?: InputMaybe<OrderByInput>;
  page?: InputMaybe<Scalars['NonNegativeInt']['input']>;
  pageSize?: InputMaybe<Scalars['NonNegativeInt']['input']>;
  where?: InputMaybe<Array<QueryInput>>;
};


export type QueryGetClinicianAvailabilityArgs = {
  clinicId: Scalars['ID']['input'];
  clinicianId: Scalars['ID']['input'];
};


export type QueryGetClinicianServiceArgs = {
  id: Scalars['ID']['input'];
};


export type QueryGetClinicianServicesByClinicArgs = {
  clinicId: Scalars['ID']['input'];
};


export type QueryGetClinicianServicesByClinicianArgs = {
  clinicianId: Scalars['ID']['input'];
};


export type QueryGetClinicianServicesByServiceArgs = {
  serviceId: Scalars['ID']['input'];
};


export type QueryGetCliniciansByClinicArgs = {
  clinicId: Scalars['ID']['input'];
  onlyAvailable?: InputMaybe<Scalars['Boolean']['input']>;
  pms?: InputMaybe<PracticeManagementSystem>;
  usingRooms?: InputMaybe<Scalars['Boolean']['input']>;
};


export type QueryGetCliniciansForBookingArgs = {
  clinicId: Scalars['ID']['input'];
  params: BookingResourceParams;
  widgetId?: InputMaybe<Scalars['ID']['input']>;
};


export type QueryGetClinicsArgs = {
  ids: Array<Scalars['ID']['input']>;
};


export type QueryGetClinicsForOrganizationArgs = {
  organizationId: Scalars['ID']['input'];
};


export type QueryGetClinicsForUserAdminArgs = {
  userId: Scalars['ID']['input'];
};


export type QueryGetClinicsWithConcernsArgs = {
  momApptWarning?: InputMaybe<Scalars['Int']['input']>;
  momNotifWarning?: InputMaybe<Scalars['Int']['input']>;
  wowApptWarning?: InputMaybe<Scalars['Int']['input']>;
  wowNotifWarning?: InputMaybe<Scalars['Int']['input']>;
};


export type QueryGetConnectInstallationsByClinicArgs = {
  clinicId: Scalars['ID']['input'];
};


export type QueryGetCustomRolesByClinicArgs = {
  clinicId: Scalars['ID']['input'];
};


export type QueryGetCustomRolesByClinicGroupArgs = {
  clinicGroupId: Scalars['ID']['input'];
};


export type QueryGetCustomerSegmentsForClinicArgs = {
  clinicId: Scalars['ID']['input'];
  page?: InputMaybe<Scalars['NonNegativeInt']['input']>;
  pageSize?: InputMaybe<Scalars['NonNegativeInt']['input']>;
};


export type QueryGetDailyHuddlesByClinicArgs = {
  clinicId: Scalars['ID']['input'];
};


export type QueryGetDrilldownEntitiesArgs = {
  metricId: Scalars['ID']['input'];
  params: GetDrilldownEntitiesParams;
};


export type QueryGetFillRateForClinicianTimeRangeArgs = {
  clinicianId: Scalars['ID']['input'];
  endTime: Scalars['NonNegativeInt']['input'];
  startTime: Scalars['NonNegativeInt']['input'];
};


export type QueryGetFillRateForRoomTimeRangeArgs = {
  endTime: Scalars['NonNegativeInt']['input'];
  roomId: Scalars['ID']['input'];
  startTime: Scalars['NonNegativeInt']['input'];
};


export type QueryGetFillRateForTimeRangeArgs = {
  clinicId: Scalars['ID']['input'];
  endTime: Scalars['NonNegativeInt']['input'];
  startTime: Scalars['NonNegativeInt']['input'];
};


export type QueryGetFormsForClinicArgs = {
  clinicId: Scalars['ID']['input'];
};


export type QueryGetGoalsByClinicArgs = {
  clinicId: Scalars['ID']['input'];
};


export type QueryGetGoalsByClinicAndStatusArgs = {
  clinicId: Scalars['ID']['input'];
  status: GoalStatus;
};


export type QueryGetLastServerHeartbeatForClinicArgs = {
  clinicId: Scalars['ID']['input'];
};


export type QueryGetLoyaltyMembersForClinicArgs = {
  clinicId: Scalars['ID']['input'];
};


export type QueryGetLoyaltyRedemptionsForClinicArgs = {
  clinicId: Scalars['ID']['input'];
};


export type QueryGetLoyaltyRewardsForClinicArgs = {
  clinicId: Scalars['ID']['input'];
  showInactive?: InputMaybe<Scalars['Boolean']['input']>;
};


export type QueryGetMaybeClientsArgs = {
  clinicId: Scalars['ID']['input'];
  input: MaybeClientInput;
};


export type QueryGetMessagesByChatIdArgs = {
  chatId: Scalars['ID']['input'];
  isClientChat?: InputMaybe<Scalars['Boolean']['input']>;
  page?: InputMaybe<Scalars['NonNegativeInt']['input']>;
  pageSize?: InputMaybe<Scalars['NonNegativeInt']['input']>;
  patientIds?: InputMaybe<Array<Scalars['ID']['input']>>;
};


export type QueryGetMostRecentDoctorForPatientArgs = {
  clinicId: Scalars['ID']['input'];
  patientId: Scalars['ID']['input'];
};


export type QueryGetNewAppointmentsForClinicArgs = {
  clinicId: Scalars['ID']['input'];
  fromPmsCreatedAt: Scalars['NonNegativeInt']['input'];
  toPmsCreatedAt: Scalars['NonNegativeInt']['input'];
};


export type QueryGetNewClientsForClinicArgs = {
  clinicId: Scalars['ID']['input'];
  fromPmsCreatedAt: Scalars['NonNegativeInt']['input'];
  toPmsCreatedAt: Scalars['NonNegativeInt']['input'];
};


export type QueryGetNewPatientsForClinicArgs = {
  clinicId: Scalars['ID']['input'];
  fromPmsCreatedAt: Scalars['NonNegativeInt']['input'];
  toPmsCreatedAt: Scalars['NonNegativeInt']['input'];
};


export type QueryGetNextAvailableDayArgs = {
  clinicId: Scalars['ID']['input'];
  params: TimeSlotParams;
  widgetId?: InputMaybe<Scalars['ID']['input']>;
};


export type QueryGetNotificationTemplatesByClinicIdArgs = {
  clinicId: Scalars['ID']['input'];
  page?: InputMaybe<Scalars['NonNegativeInt']['input']>;
  pageSize?: InputMaybe<Scalars['NonNegativeInt']['input']>;
};


export type QueryGetNumberOfCompletedAppointmentsForTimeRangeArgs = {
  clinicId: Scalars['ID']['input'];
  end_time: Scalars['NonNegativeInt']['input'];
  start_time: Scalars['NonNegativeInt']['input'];
};


export type QueryGetOnDemandCliniciansForClinicArgs = {
  clinicId: Scalars['ID']['input'];
};


export type QueryGetOnDemandPaymentTypesForClinicArgs = {
  clinicId: Scalars['ID']['input'];
};


export type QueryGetOutstandingBalanceForClinicArgs = {
  activeClientsOnly?: InputMaybe<Scalars['Boolean']['input']>;
  clinicId: Scalars['ID']['input'];
};


export type QueryGetOverduePatientsArgs = {
  clinicId: Scalars['ID']['input'];
  options?: InputMaybe<OverduePatientOptions>;
};


export type QueryGetPatientRecordsForPatientArgs = {
  patientId: Scalars['ID']['input'];
};


export type QueryGetPatientStatusesByClinicArgs = {
  clinicId: Scalars['ID']['input'];
};


export type QueryGetPatientsByClientArgs = {
  clientId: Scalars['ID']['input'];
};


export type QueryGetPatientsByClientsArgs = {
  clientIds: Array<Scalars['ID']['input']>;
};


export type QueryGetPatientsFromOtherClinicsArgs = {
  clinicId: Scalars['ID']['input'];
  userId: Scalars['ID']['input'];
};


export type QueryGetPatientsWithoutApptOverDaysForClinicArgs = {
  clinicId: Scalars['ID']['input'];
  days: Scalars['NonNegativeInt']['input'];
};


export type QueryGetPatientsWithoutRescheduledAppointmentsForTimeRangeArgs = {
  clinicId: Scalars['ID']['input'];
  end_time: Scalars['NonNegativeInt']['input'];
  start_time: Scalars['NonNegativeInt']['input'];
};


export type QueryGetPaymentsByClinicIdArgs = {
  clinicId: Scalars['ID']['input'];
};


export type QueryGetPdfUrlForClientFormArgs = {
  clientFormId: Scalars['ID']['input'];
};


export type QueryGetPdfUrlForFormArgs = {
  formId: Scalars['ID']['input'];
};


export type QueryGetPetsByUserIdArgs = {
  page?: InputMaybe<Scalars['NonNegativeInt']['input']>;
  pageSize?: InputMaybe<Scalars['NonNegativeInt']['input']>;
  userId: Scalars['ID']['input'];
};


export type QueryGetPmsApptTypesForClinicArgs = {
  clinicId: Scalars['ID']['input'];
};


export type QueryGetPmsCodesForClinicArgs = {
  clinicId: Scalars['ID']['input'];
  query?: InputMaybe<Scalars['String']['input']>;
};


export type QueryGetPreviousClinicsForUserArgs = {
  orderBy?: InputMaybe<OrderByInput>;
  page?: InputMaybe<Scalars['NonNegativeInt']['input']>;
  pageSize?: InputMaybe<Scalars['NonNegativeInt']['input']>;
  userId: Scalars['ID']['input'];
};


export type QueryGetPrimaryClinicApptStatusArgs = {
  clinicId: Scalars['ID']['input'];
  status: AppointmentStatus;
};


export type QueryGetPrimaryClinicSpeciesArgs = {
  clinicId: Scalars['ID']['input'];
  species: Species;
};


export type QueryGetPrivateNotesArgs = {
  clinicId: Scalars['ID']['input'];
  patientRecordId: Scalars['ID']['input'];
};


export type QueryGetRealTimeReportArgs = {
  params: RealTimeReportParams;
};


export type QueryGetReferralOptionsForClinicArgs = {
  clinicId: Scalars['ID']['input'];
  search?: InputMaybe<Scalars['String']['input']>;
};


export type QueryGetRevenueByMonthsForClinicArgs = {
  clinicId: Scalars['ID']['input'];
  numMonths: Scalars['NonNegativeInt']['input'];
};


export type QueryGetRevenueByMonthsForOrganizationArgs = {
  numMonths: Scalars['NonNegativeInt']['input'];
  organizationId: Scalars['ID']['input'];
};


export type QueryGetRevenueForTimeRangeArgs = {
  clinicId: Scalars['ID']['input'];
  end_time: Scalars['NonNegativeInt']['input'];
  start_time: Scalars['NonNegativeInt']['input'];
};


export type QueryGetRevenuesByClinicianForTimeRangeArgs = {
  clinicId: Scalars['ID']['input'];
  end_time: Scalars['NonNegativeInt']['input'];
  start_time: Scalars['NonNegativeInt']['input'];
};


export type QueryGetRevenuesByTypeForTimeRangeArgs = {
  clinicId: Scalars['ID']['input'];
  end_time: Scalars['NonNegativeInt']['input'];
  start_time: Scalars['NonNegativeInt']['input'];
};


export type QueryGetReviewsForClinicArgs = {
  clinicId: Scalars['ID']['input'];
};


export type QueryGetRoomAvailabilityArgs = {
  clinicId: Scalars['ID']['input'];
  roomId: Scalars['ID']['input'];
};


export type QueryGetRoomServiceArgs = {
  id: Scalars['ID']['input'];
};


export type QueryGetRoomServicesByClinicArgs = {
  clinicId: Scalars['ID']['input'];
};


export type QueryGetRoomServicesByRoomArgs = {
  roomId: Scalars['ID']['input'];
};


export type QueryGetRoomServicesByServiceArgs = {
  serviceId: Scalars['ID']['input'];
};


export type QueryGetRoomsByClinicArgs = {
  clinicId: Scalars['ID']['input'];
};


export type QueryGetRoomsForBookingArgs = {
  clinicId: Scalars['ID']['input'];
  params: BookingResourceParams;
  widgetId?: InputMaybe<Scalars['ID']['input']>;
};


export type QueryGetScheduledBulkMessagesByClinicIdArgs = {
  clinicId: Scalars['ID']['input'];
  page?: InputMaybe<Scalars['NonNegativeInt']['input']>;
  pageSize?: InputMaybe<Scalars['NonNegativeInt']['input']>;
};


export type QueryGetSchedulingRulesCategorizedArgs = {
  clinicId: Scalars['ID']['input'];
  params: SchedulingRulesCategorizedParams;
  widgetId?: InputMaybe<Scalars['ID']['input']>;
};


export type QueryGetServiceFormsForClinicArgs = {
  clinicId: Scalars['ID']['input'];
};


export type QueryGetServicesForBookingArgs = {
  clinicId: Scalars['ID']['input'];
  params: BookingServiceParams;
  widgetId?: InputMaybe<Scalars['ID']['input']>;
};


export type QueryGetSumOfInvoicesArgs = {
  where?: InputMaybe<Array<QueryInput>>;
};


export type QueryGetTemplatesForClinicReportsArgs = {
  clinic: Scalars['ID']['input'];
};


export type QueryGetTimeSlotsForClinicForDayArgs = {
  clinicId: Scalars['ID']['input'];
  date: Scalars['NonNegativeInt']['input'];
};


export type QueryGetTimeSlotsForSchedulingDayArgs = {
  clinicId: Scalars['ID']['input'];
  params: TimeSlotParams;
  widgetId?: InputMaybe<Scalars['ID']['input']>;
};


export type QueryGetTimeSlotsForSchedulingDaysArgs = {
  clinicId: Scalars['ID']['input'];
  params: GetTimeSlotForSchedulingDaysParams;
};


export type QueryGetTimesFirstBookingFiltersArgs = {
  clinicId: Scalars['ID']['input'];
  widgetId?: InputMaybe<Scalars['ID']['input']>;
};


export type QueryGetTotalRevenueForClinicBetweenTimesArgs = {
  clinicId: Scalars['ID']['input'];
  endTime: Scalars['NonNegativeInt']['input'];
  startTime: Scalars['NonNegativeInt']['input'];
};


export type QueryGetTransactionsByClinicArgs = {
  clinicId: Scalars['ID']['input'];
  pms?: InputMaybe<PracticeManagementSystem>;
};


export type QueryGetTransactionsByClinicAndRangeArgs = {
  clinicId: Scalars['ID']['input'];
  end_time: Scalars['NonNegativeInt']['input'];
  pms?: InputMaybe<PracticeManagementSystem>;
  start_time: Scalars['NonNegativeInt']['input'];
};


export type QueryGetTreatmentsByClinicArgs = {
  clinicId: Scalars['ID']['input'];
};


export type QueryGetTrendReportArgs = {
  params: TrendReportParams;
};


export type QueryGetUpcomingAppointmentsForBookingArgs = {
  clientId?: InputMaybe<Scalars['ID']['input']>;
  clinicId: Scalars['ID']['input'];
  patientId?: InputMaybe<Scalars['ID']['input']>;
  patientName?: InputMaybe<Scalars['String']['input']>;
};


export type QueryGetWidgetsByClinicArgs = {
  clinicId: Scalars['ID']['input'];
};


export type QueryGetWidgetsByClinicGroupArgs = {
  clinicGroupId: Scalars['ID']['input'];
  includeSubgroups?: InputMaybe<Scalars['Boolean']['input']>;
};


export type QueryGetWidgetsByOrganizationArgs = {
  organizationId: Scalars['ID']['input'];
};


export type QueryGoalArgs = {
  clinicId: Scalars['ID']['input'];
  goalId: Scalars['ID']['input'];
};


export type QueryInitiativeArgs = {
  id: Scalars['ID']['input'];
};


export type QueryInternalChatArgs = {
  id: Scalars['ID']['input'];
};


export type QueryInternalChatMessagesArgs = {
  chatId: Scalars['ID']['input'];
  page?: InputMaybe<Scalars['NonNegativeInt']['input']>;
  pageSize?: InputMaybe<Scalars['NonNegativeInt']['input']>;
};


export type QueryInternalChatUsersArgs = {
  chatId: Scalars['ID']['input'];
};


export type QueryInternalUsageEventsArgs = {
  filters: InternalUsageEventFilters;
};


export type QueryInvoiceArgs = {
  id: Scalars['ID']['input'];
};


export type QueryInvoiceItemArgs = {
  id: Scalars['ID']['input'];
};


export type QueryIsPatientActiveInPimsArgs = {
  clinicId: Scalars['ID']['input'];
  patientPmsId: Scalars['String']['input'];
};


export type QueryKpiGroupArgs = {
  id: Scalars['ID']['input'];
};


export type QueryLookupPimsClientsArgs = {
  clinicId: Scalars['ID']['input'];
  input: PimsLookupInput;
};


export type QueryLoyaltyEarningArgs = {
  id: Scalars['ID']['input'];
};


export type QueryLoyaltyMemberArgs = {
  id: Scalars['ID']['input'];
};


export type QueryLoyaltyRedemptionArgs = {
  id: Scalars['ID']['input'];
};


export type QueryLoyaltyRewardArgs = {
  id: Scalars['ID']['input'];
};


export type QueryMarketingSummaryStatsArgs = {
  filters: MarketingFiltersInput;
};


export type QueryMessageTemplateArgs = {
  id: Scalars['ID']['input'];
};


export type QueryMyClinicAgentConversationsArgs = {
  clinicGroupId?: InputMaybe<Scalars['ID']['input']>;
  clinicId?: InputMaybe<Scalars['ID']['input']>;
  limit?: InputMaybe<Scalars['NonNegativeInt']['input']>;
};


export type QueryMySupportBotConversationsArgs = {
  limit?: InputMaybe<Scalars['NonNegativeInt']['input']>;
};


export type QueryNotificationMessagesByReferencePeriodArgs = {
  endDate: Scalars['NonNegativeInt']['input'];
  includePreview?: InputMaybe<Scalars['Boolean']['input']>;
  notificationId: Scalars['ID']['input'];
  startDate: Scalars['NonNegativeInt']['input'];
};


export type QueryNotificationTemplateArgs = {
  notificationTemplateId: Scalars['ID']['input'];
};


export type QueryNotificationTemplateTrackingStatsArgs = {
  endDate?: InputMaybe<Scalars['NonNegativeInt']['input']>;
  notificationTemplateId: Scalars['ID']['input'];
  startDate?: InputMaybe<Scalars['NonNegativeInt']['input']>;
};


export type QueryOrganizationArgs = {
  id: Scalars['ID']['input'];
};


export type QueryOrganizationAnalyticsArgs = {
  fromDate: Scalars['NonNegativeInt']['input'];
  organizationId: Scalars['ID']['input'];
  toDate: Scalars['NonNegativeInt']['input'];
};


export type QueryOrganizationAnalyticsNumbersArgs = {
  fromDate: Scalars['NonNegativeInt']['input'];
  organizationId: Scalars['ID']['input'];
  toDate: Scalars['NonNegativeInt']['input'];
};


export type QueryOrganizationBulkMessageStatsArgs = {
  filters: MarketingFiltersInput;
};


export type QueryOrganizationBySlugArgs = {
  slug: Scalars['String']['input'];
};


export type QueryOrganizationCampaignStatsArgs = {
  filters: MarketingFiltersInput;
};


export type QueryOrganizationNotificationStatsArgs = {
  filters: MarketingFiltersInput;
};


export type QueryOrganizationReportArgs = {
  id: Scalars['ID']['input'];
};


export type QueryOrganizationScheduleEfficiencyArgs = {
  fromDate: Scalars['NonNegativeInt']['input'];
  organizationId: Scalars['ID']['input'];
  toDate: Scalars['NonNegativeInt']['input'];
};


export type QueryPatientArgs = {
  id: Scalars['ID']['input'];
};


export type QueryPatientHistoryItemArgs = {
  id: Scalars['ID']['input'];
};


export type QueryPatientRecordArgs = {
  id: Scalars['ID']['input'];
};


export type QueryPatientStatusArgs = {
  id: Scalars['ID']['input'];
};


export type QueryPatientVaccinationRecordArgs = {
  id: Scalars['ID']['input'];
};


export type QueryPatientVaccinationRecordsByPatientArgs = {
  hideHistoric?: InputMaybe<Scalars['Boolean']['input']>;
  hideSoc?: InputMaybe<Scalars['Boolean']['input']>;
  orderBy?: InputMaybe<OrderByInput>;
  page?: InputMaybe<Scalars['NonNegativeInt']['input']>;
  pageSize?: InputMaybe<Scalars['PositiveInt']['input']>;
  patientId: Scalars['ID']['input'];
  showInactive?: InputMaybe<Scalars['Boolean']['input']>;
};


export type QueryPaymentArgs = {
  id: Scalars['ID']['input'];
};


export type QueryPaymentIntentFromPrescriptionArgs = {
  clinicId: Scalars['ID']['input'];
  customerInfo: CustomerInfoInput;
  prescriptionId: Scalars['ID']['input'];
};


export type QueryPaymentIntentFromPrescriptionWithSavedCardArgs = {
  clinicId: Scalars['ID']['input'];
  paymentMethodId: Scalars['ID']['input'];
  prescriptionId: Scalars['ID']['input'];
};


export type QueryPaymentIntentFromServiceArgs = {
  clinicId: Scalars['ID']['input'];
  customerInfo: CustomerInfoInput;
  serviceId: Scalars['ID']['input'];
};


export type QueryPaymentIntentFromServiceWithSavedCardArgs = {
  clinicId: Scalars['ID']['input'];
  paymentMethodId: Scalars['ID']['input'];
  serviceId: Scalars['ID']['input'];
};


export type QueryPetArgs = {
  id: Scalars['ID']['input'];
};


export type QueryPetSelfieArgs = {
  id: Scalars['ID']['input'];
};


export type QueryPimsReminderArgs = {
  id: Scalars['ID']['input'];
};


export type QueryPimsRemindersByPatientArgs = {
  clinicId: Scalars['ID']['input'];
  orderBy?: InputMaybe<OrderByInput>;
  page?: InputMaybe<Scalars['NonNegativeInt']['input']>;
  pageSize?: InputMaybe<Scalars['NonNegativeInt']['input']>;
  patientPmsId: Scalars['String']['input'];
};


export type QueryPimsRemindersBySendDateArgs = {
  sendDate: Scalars['NonNegativeInt']['input'];
};


export type QueryPimsSettingsArgs = {
  clinicId: Scalars['ID']['input'];
};


export type QueryPmsApptTypeArgs = {
  clinicId: Scalars['ID']['input'];
  pmsApptTypeId: Scalars['ID']['input'];
};


export type QueryPmsDbArgs = {
  id: Scalars['ID']['input'];
};


export type QueryPmsOtherEntityArgs = {
  id: Scalars['ID']['input'];
};


export type QueryPmsTagArgs = {
  id: Scalars['ID']['input'];
};


export type QueryPmsTagCategoryArgs = {
  id: Scalars['ID']['input'];
};


export type QueryPrescriptionArgs = {
  prescriptionId: Scalars['ID']['input'];
};


export type QueryPrescriptionPricingArgs = {
  clinicId?: InputMaybe<Scalars['ID']['input']>;
  feeSplitPercentageOverride?: InputMaybe<Scalars['Float']['input']>;
  productId: Scalars['ID']['input'];
  unitPriceOverride?: InputMaybe<Scalars['NonNegativeInt']['input']>;
  units: Scalars['NonNegativeFloat']['input'];
};


export type QueryPrescriptionRefillRequestArgs = {
  id: Scalars['ID']['input'];
};


export type QueryPressItemArgs = {
  id: Scalars['ID']['input'];
};


export type QueryProductArgs = {
  productId: Scalars['ID']['input'];
};


export type QueryPublicAppointmentTimesArgs = {
  searchInput: SearchAppointmentsInput;
};


export type QueryQueryActionItemsArgs = {
  orderBy?: InputMaybe<OrderByInput>;
  page?: InputMaybe<Scalars['NonNegativeInt']['input']>;
  pageSize?: InputMaybe<Scalars['NonNegativeInt']['input']>;
  where?: InputMaybe<Array<QueryInput>>;
};


export type QueryQueryAllClinicAdminsArgs = {
  orderBy?: InputMaybe<OrderByInput>;
  page?: InputMaybe<Scalars['NonNegativeInt']['input']>;
  pageSize?: InputMaybe<Scalars['NonNegativeInt']['input']>;
  where?: InputMaybe<Array<QueryInput>>;
};


export type QueryQueryAppointmentPromptsArgs = {
  orderBy?: InputMaybe<OrderByInput>;
  page?: InputMaybe<Scalars['NonNegativeInt']['input']>;
  pageSize?: InputMaybe<Scalars['NonNegativeInt']['input']>;
  where?: InputMaybe<Array<QueryInput>>;
};


export type QueryQueryAppointmentsArgs = {
  orderBy?: InputMaybe<OrderByInput>;
  page?: InputMaybe<Scalars['NonNegativeInt']['input']>;
  pageSize?: InputMaybe<Scalars['NonNegativeInt']['input']>;
  where?: InputMaybe<Array<QueryInput>>;
};


export type QueryQueryBreedsArgs = {
  orderBy?: InputMaybe<OrderByInput>;
  page?: InputMaybe<Scalars['NonNegativeInt']['input']>;
  pageSize?: InputMaybe<Scalars['NonNegativeInt']['input']>;
  where?: InputMaybe<Array<QueryInput>>;
};


export type QueryQueryCampaignsArgs = {
  orderBy?: InputMaybe<OrderByInput>;
  page?: InputMaybe<Scalars['NonNegativeInt']['input']>;
  pageSize?: InputMaybe<Scalars['NonNegativeInt']['input']>;
  where?: InputMaybe<Array<QueryInput>>;
};


export type QueryQueryChatsArgs = {
  orderBy?: InputMaybe<OrderByInput>;
  page?: InputMaybe<Scalars['NonNegativeInt']['input']>;
  pageSize?: InputMaybe<Scalars['NonNegativeInt']['input']>;
  where?: InputMaybe<Array<QueryInput>>;
};


export type QueryQueryClientFormsArgs = {
  orderBy?: InputMaybe<OrderByInput>;
  page?: InputMaybe<Scalars['NonNegativeInt']['input']>;
  pageSize?: InputMaybe<Scalars['NonNegativeInt']['input']>;
  where?: InputMaybe<Array<QueryInput>>;
};


export type QueryQueryClientFormsForClientArgs = {
  clientId: Scalars['ID']['input'];
  orderBy?: InputMaybe<OrderByInput>;
  page?: InputMaybe<Scalars['NonNegativeInt']['input']>;
  pageSize?: InputMaybe<Scalars['NonNegativeInt']['input']>;
  where?: InputMaybe<Array<QueryInput>>;
};


export type QueryQueryClientFormsForClinicArgs = {
  clinicId: Scalars['ID']['input'];
  orderBy?: InputMaybe<OrderByInput>;
  page?: InputMaybe<Scalars['NonNegativeInt']['input']>;
  pageSize?: InputMaybe<Scalars['NonNegativeInt']['input']>;
  where?: InputMaybe<Array<QueryInput>>;
};


export type QueryQueryClientStatusesArgs = {
  orderBy?: InputMaybe<OrderByInput>;
  page?: InputMaybe<Scalars['NonNegativeInt']['input']>;
  pageSize?: InputMaybe<Scalars['NonNegativeInt']['input']>;
  where?: InputMaybe<Array<QueryInput>>;
};


export type QueryQueryClientsArgs = {
  orderBy?: InputMaybe<OrderByInput>;
  page?: InputMaybe<Scalars['NonNegativeInt']['input']>;
  pageSize?: InputMaybe<Scalars['NonNegativeInt']['input']>;
  where?: InputMaybe<Array<QueryInput>>;
};


export type QueryQueryClientsPatientsArgs = {
  clinicId: Scalars['ID']['input'];
  orderBy?: InputMaybe<OrderByInput>;
  page?: InputMaybe<Scalars['NonNegativeInt']['input']>;
  pageSize?: InputMaybe<Scalars['NonNegativeInt']['input']>;
  where?: InputMaybe<Array<QueryInput>>;
};


export type QueryQueryClinicAdminClinicsArgs = {
  orderBy?: InputMaybe<OrderByInput>;
  page?: InputMaybe<Scalars['NonNegativeInt']['input']>;
  pageSize?: InputMaybe<Scalars['NonNegativeInt']['input']>;
  userId: Scalars['ID']['input'];
  where?: InputMaybe<Array<QueryInput>>;
};


export type QueryQueryClinicAdminsArgs = {
  clinicId: Scalars['ID']['input'];
  orderBy?: InputMaybe<OrderByInput>;
  page?: InputMaybe<Scalars['NonNegativeInt']['input']>;
  pageSize?: InputMaybe<Scalars['NonNegativeInt']['input']>;
  where?: InputMaybe<Array<QueryInput>>;
};


export type QueryQueryClinicAppointmentsArgs = {
  clinicId: Scalars['ID']['input'];
  orderBy?: InputMaybe<OrderByInput>;
  page?: InputMaybe<Scalars['NonNegativeInt']['input']>;
  pageSize?: InputMaybe<Scalars['NonNegativeInt']['input']>;
  where?: InputMaybe<Array<QueryInput>>;
};


export type QueryQueryClinicApptStatusesArgs = {
  orderBy?: InputMaybe<OrderByInput>;
  page?: InputMaybe<Scalars['NonNegativeInt']['input']>;
  pageSize?: InputMaybe<Scalars['NonNegativeInt']['input']>;
  where?: InputMaybe<Array<QueryInput>>;
};


export type QueryQueryClinicCallsArgs = {
  clinicId: Scalars['ID']['input'];
  orderBy?: InputMaybe<OrderByInput>;
  page?: InputMaybe<Scalars['NonNegativeInt']['input']>;
  pageSize?: InputMaybe<Scalars['NonNegativeInt']['input']>;
  where?: InputMaybe<Array<QueryInput>>;
};


export type QueryQueryClinicChatsArgs = {
  clinicId: Scalars['ID']['input'];
  orderBy?: InputMaybe<OrderByInput>;
  page?: InputMaybe<Scalars['NonNegativeInt']['input']>;
  pageSize?: InputMaybe<Scalars['NonNegativeInt']['input']>;
  where?: InputMaybe<Array<QueryInput>>;
};


export type QueryQueryClinicClientsArgs = {
  clinicId: Scalars['ID']['input'];
  orderBy?: InputMaybe<OrderByInput>;
  page?: InputMaybe<Scalars['NonNegativeInt']['input']>;
  pageSize?: InputMaybe<Scalars['NonNegativeInt']['input']>;
  where?: InputMaybe<Array<QueryInput>>;
};


export type QueryQueryClinicDataChatsArgs = {
  clinicId: Scalars['ID']['input'];
  params?: InputMaybe<QueryParams>;
};


export type QueryQueryClinicEmailTemplatesArgs = {
  clinicId: Scalars['ID']['input'];
  orderBy?: InputMaybe<OrderByInput>;
  page?: InputMaybe<Scalars['NonNegativeInt']['input']>;
  pageSize?: InputMaybe<Scalars['NonNegativeInt']['input']>;
  where?: InputMaybe<Array<QueryInput>>;
};


export type QueryQueryClinicGroupClinicsArgs = {
  orderBy?: InputMaybe<OrderByInput>;
  page?: InputMaybe<Scalars['NonNegativeInt']['input']>;
  pageSize?: InputMaybe<Scalars['NonNegativeInt']['input']>;
  where?: InputMaybe<Array<QueryInput>>;
};


export type QueryQueryClinicGroupEmailTemplatesArgs = {
  clinicGroupId: Scalars['ID']['input'];
  orderBy?: InputMaybe<OrderByInput>;
  page?: InputMaybe<Scalars['NonNegativeInt']['input']>;
  pageSize?: InputMaybe<Scalars['NonNegativeInt']['input']>;
  where?: InputMaybe<Array<QueryInput>>;
};


export type QueryQueryClinicGroupMessageTemplatesArgs = {
  clinicGroupId: Scalars['ID']['input'];
  orderBy?: InputMaybe<OrderByInput>;
  page?: InputMaybe<Scalars['NonNegativeInt']['input']>;
  pageSize?: InputMaybe<Scalars['NonNegativeInt']['input']>;
  where?: InputMaybe<Array<QueryInput>>;
};


export type QueryQueryClinicGroupUsersArgs = {
  clinicGroupId: Scalars['ID']['input'];
  orderBy?: InputMaybe<OrderByInput>;
  page?: InputMaybe<Scalars['NonNegativeInt']['input']>;
  pageSize?: InputMaybe<Scalars['NonNegativeInt']['input']>;
  where?: InputMaybe<Array<QueryInput>>;
};


export type QueryQueryClinicGroupsArgs = {
  orderBy?: InputMaybe<OrderByInput>;
  page?: InputMaybe<Scalars['NonNegativeInt']['input']>;
  pageSize?: InputMaybe<Scalars['NonNegativeInt']['input']>;
  where?: InputMaybe<Array<QueryInput>>;
};


export type QueryQueryClinicGroupsForUserArgs = {
  orderBy?: InputMaybe<OrderByInput>;
  page?: InputMaybe<Scalars['NonNegativeInt']['input']>;
  pageSize?: InputMaybe<Scalars['NonNegativeInt']['input']>;
  userId: Scalars['ID']['input'];
  where?: InputMaybe<Array<QueryInput>>;
};


export type QueryQueryClinicMessageTemplatesArgs = {
  clinicId: Scalars['ID']['input'];
  orderBy?: InputMaybe<OrderByInput>;
  page?: InputMaybe<Scalars['NonNegativeInt']['input']>;
  pageSize?: InputMaybe<Scalars['NonNegativeInt']['input']>;
  where?: InputMaybe<Array<QueryInput>>;
};


export type QueryQueryClinicMessagesArgs = {
  clinicId: Scalars['ID']['input'];
  notificationTemplateIds?: InputMaybe<Array<Scalars['ID']['input']>>;
  orderBy?: InputMaybe<OrderByInput>;
  page?: InputMaybe<Scalars['NonNegativeInt']['input']>;
  pageSize?: InputMaybe<Scalars['NonNegativeInt']['input']>;
  patientIds?: InputMaybe<Array<Scalars['ID']['input']>>;
  where?: InputMaybe<Array<QueryInput>>;
};


export type QueryQueryClinicPatientsArgs = {
  clinicId: Scalars['ID']['input'];
  orderBy?: InputMaybe<OrderByInput>;
  page?: InputMaybe<Scalars['NonNegativeInt']['input']>;
  pageSize?: InputMaybe<Scalars['NonNegativeInt']['input']>;
  where?: InputMaybe<Array<QueryInput>>;
};


export type QueryQueryClinicSexesArgs = {
  orderBy?: InputMaybe<OrderByInput>;
  page?: InputMaybe<Scalars['NonNegativeInt']['input']>;
  pageSize?: InputMaybe<Scalars['NonNegativeInt']['input']>;
  where?: InputMaybe<Array<QueryInput>>;
};


export type QueryQueryClinicSpeciesArgs = {
  orderBy?: InputMaybe<OrderByInput>;
  page?: InputMaybe<Scalars['NonNegativeInt']['input']>;
  pageSize?: InputMaybe<Scalars['NonNegativeInt']['input']>;
  where?: InputMaybe<Array<QueryInput>>;
};


export type QueryQueryCliniciansArgs = {
  orderBy?: InputMaybe<OrderByInput>;
  page?: InputMaybe<Scalars['NonNegativeInt']['input']>;
  pageSize?: InputMaybe<Scalars['NonNegativeInt']['input']>;
  where?: InputMaybe<Array<QueryInput>>;
};


export type QueryQueryClinicsArgs = {
  orderBy?: InputMaybe<OrderByInput>;
  page?: InputMaybe<Scalars['NonNegativeInt']['input']>;
  pageSize?: InputMaybe<Scalars['NonNegativeInt']['input']>;
  where?: InputMaybe<Array<QueryInput>>;
};


export type QueryQueryComplianceRemindersArgs = {
  assigneeIds?: InputMaybe<Array<Scalars['ID']['input']>>;
  clinicIds: Array<Scalars['ID']['input']>;
  complianceStatuses?: InputMaybe<Array<Scalars['String']['input']>>;
  endDate: Scalars['NonNegativeInt']['input'];
  excludeDeceasedPatients?: InputMaybe<Scalars['Boolean']['input']>;
  excludeFutureAppts?: InputMaybe<Scalars['Boolean']['input']>;
  excludedClientIds?: InputMaybe<Array<Scalars['ID']['input']>>;
  includeCompleted?: InputMaybe<Scalars['Boolean']['input']>;
  includeInactiveClients?: InputMaybe<Scalars['Boolean']['input']>;
  includeInactiveReminders?: InputMaybe<Scalars['Boolean']['input']>;
  includeUnsetComplianceStatus?: InputMaybe<Scalars['Boolean']['input']>;
  lastSeenAfter?: InputMaybe<Scalars['NonNegativeInt']['input']>;
  orderAsc?: InputMaybe<Scalars['Boolean']['input']>;
  orderColumn?: InputMaybe<Scalars['String']['input']>;
  page?: InputMaybe<Scalars['NonNegativeInt']['input']>;
  pageSize?: InputMaybe<Scalars['NonNegativeInt']['input']>;
  reminderTypeIds?: InputMaybe<Array<Scalars['ID']['input']>>;
  searchQuery?: InputMaybe<Scalars['String']['input']>;
  speciesIds?: InputMaybe<Array<Scalars['ID']['input']>>;
  startDate: Scalars['NonNegativeInt']['input'];
  statusUpdatedBefore?: InputMaybe<Scalars['NonNegativeInt']['input']>;
};


export type QueryQueryConnectInstallationsArgs = {
  orderBy?: InputMaybe<OrderByInput>;
  page?: InputMaybe<Scalars['NonNegativeInt']['input']>;
  pageSize?: InputMaybe<Scalars['NonNegativeInt']['input']>;
  where?: InputMaybe<Array<QueryInput>>;
};


export type QueryQueryCustomerSegmentsArgs = {
  orderBy?: InputMaybe<OrderByInput>;
  page?: InputMaybe<Scalars['NonNegativeInt']['input']>;
  pageSize?: InputMaybe<Scalars['NonNegativeInt']['input']>;
  where?: InputMaybe<Array<QueryInput>>;
};


export type QueryQueryDiagnosesArgs = {
  orderBy?: InputMaybe<OrderByInput>;
  page?: InputMaybe<Scalars['NonNegativeInt']['input']>;
  pageSize?: InputMaybe<Scalars['NonNegativeInt']['input']>;
  where?: InputMaybe<Array<QueryInput>>;
};


export type QueryQueryDistinctPimsReminderTypeNamesArgs = {
  orderBy?: InputMaybe<OrderByInput>;
  page?: InputMaybe<Scalars['NonNegativeInt']['input']>;
  pageSize?: InputMaybe<Scalars['NonNegativeInt']['input']>;
  where?: InputMaybe<Array<QueryInput>>;
};


export type QueryQueryEntityReportsArgs = {
  orderBy?: InputMaybe<OrderByInput>;
  page?: InputMaybe<Scalars['NonNegativeInt']['input']>;
  pageSize?: InputMaybe<Scalars['NonNegativeInt']['input']>;
  where?: InputMaybe<Array<QueryInput>>;
};


export type QueryQueryFormsArgs = {
  orderBy?: InputMaybe<OrderByInput>;
  page?: InputMaybe<Scalars['NonNegativeInt']['input']>;
  pageSize?: InputMaybe<Scalars['NonNegativeInt']['input']>;
  where?: InputMaybe<Array<QueryInput>>;
};


export type QueryQueryInitiativesArgs = {
  orderBy?: InputMaybe<OrderByInput>;
  page?: InputMaybe<Scalars['NonNegativeInt']['input']>;
  pageSize?: InputMaybe<Scalars['NonNegativeInt']['input']>;
  where?: InputMaybe<Array<QueryInput>>;
};


export type QueryQueryInternalChatUsersArgs = {
  orderBy?: InputMaybe<OrderByInput>;
  page?: InputMaybe<Scalars['NonNegativeInt']['input']>;
  pageSize?: InputMaybe<Scalars['NonNegativeInt']['input']>;
  where?: InputMaybe<Array<QueryInput>>;
};


export type QueryQueryInvoiceItemsArgs = {
  orderBy?: InputMaybe<OrderByInput>;
  page?: InputMaybe<Scalars['NonNegativeInt']['input']>;
  pageSize?: InputMaybe<Scalars['NonNegativeInt']['input']>;
  where?: InputMaybe<Array<QueryInput>>;
};


export type QueryQueryInvoicesArgs = {
  orderBy?: InputMaybe<OrderByInput>;
  page?: InputMaybe<Scalars['NonNegativeInt']['input']>;
  pageSize?: InputMaybe<Scalars['NonNegativeInt']['input']>;
  where?: InputMaybe<Array<QueryInput>>;
};


export type QueryQueryKpiGroupsArgs = {
  orderBy?: InputMaybe<OrderByInput>;
  page?: InputMaybe<Scalars['NonNegativeInt']['input']>;
  pageSize?: InputMaybe<Scalars['NonNegativeInt']['input']>;
  where?: InputMaybe<Array<QueryInput>>;
};


export type QueryQueryLoyaltyEarningsArgs = {
  orderBy?: InputMaybe<OrderByInput>;
  page?: InputMaybe<Scalars['NonNegativeInt']['input']>;
  pageSize?: InputMaybe<Scalars['NonNegativeInt']['input']>;
  where?: InputMaybe<Array<QueryInput>>;
};


export type QueryQueryLoyaltyMembersArgs = {
  orderBy?: InputMaybe<OrderByInput>;
  page?: InputMaybe<Scalars['NonNegativeInt']['input']>;
  pageSize?: InputMaybe<Scalars['NonNegativeInt']['input']>;
  where?: InputMaybe<Array<QueryInput>>;
};


export type QueryQueryLoyaltyRedemptionsArgs = {
  orderBy?: InputMaybe<OrderByInput>;
  page?: InputMaybe<Scalars['NonNegativeInt']['input']>;
  pageSize?: InputMaybe<Scalars['NonNegativeInt']['input']>;
  where?: InputMaybe<Array<QueryInput>>;
};


export type QueryQueryLoyaltyRewardsArgs = {
  orderBy?: InputMaybe<OrderByInput>;
  page?: InputMaybe<Scalars['NonNegativeInt']['input']>;
  pageSize?: InputMaybe<Scalars['NonNegativeInt']['input']>;
  where?: InputMaybe<Array<QueryInput>>;
};


export type QueryQueryMessagesArgs = {
  orderBy?: InputMaybe<OrderByInput>;
  page?: InputMaybe<Scalars['NonNegativeInt']['input']>;
  pageSize?: InputMaybe<Scalars['NonNegativeInt']['input']>;
  where?: InputMaybe<Array<QueryInput>>;
};


export type QueryQueryMsgTrackingEventsArgs = {
  orderBy?: InputMaybe<OrderByInput>;
  page?: InputMaybe<Scalars['NonNegativeInt']['input']>;
  pageSize?: InputMaybe<Scalars['NonNegativeInt']['input']>;
  where?: InputMaybe<Array<QueryInput>>;
};


export type QueryQueryMyAppointmentsArgs = {
  orderBy?: InputMaybe<OrderByInput>;
  page?: InputMaybe<Scalars['NonNegativeInt']['input']>;
  pageSize?: InputMaybe<Scalars['NonNegativeInt']['input']>;
  where?: InputMaybe<Array<QueryInput>>;
};


export type QueryQueryMyChatsArgs = {
  orderBy?: InputMaybe<OrderByInput>;
  page?: InputMaybe<Scalars['NonNegativeInt']['input']>;
  pageSize?: InputMaybe<Scalars['NonNegativeInt']['input']>;
  where?: InputMaybe<Array<QueryInput>>;
};


export type QueryQueryMyClientFormsArgs = {
  orderBy?: InputMaybe<OrderByInput>;
  page?: InputMaybe<Scalars['NonNegativeInt']['input']>;
  pageSize?: InputMaybe<Scalars['NonNegativeInt']['input']>;
  where?: InputMaybe<Array<QueryInput>>;
};


export type QueryQueryMyLoyaltyMembersArgs = {
  orderBy?: InputMaybe<OrderByInput>;
  page?: InputMaybe<Scalars['NonNegativeInt']['input']>;
  pageSize?: InputMaybe<Scalars['NonNegativeInt']['input']>;
  where?: InputMaybe<Array<QueryInput>>;
};


export type QueryQueryMyLoyaltyRedemptionsArgs = {
  orderBy?: InputMaybe<OrderByInput>;
  page?: InputMaybe<Scalars['NonNegativeInt']['input']>;
  pageSize?: InputMaybe<Scalars['NonNegativeInt']['input']>;
  where?: InputMaybe<Array<QueryInput>>;
};


export type QueryQueryMyPatientConcernsArgs = {
  orderBy?: InputMaybe<OrderByInput>;
  page?: InputMaybe<Scalars['NonNegativeInt']['input']>;
  pageSize?: InputMaybe<Scalars['NonNegativeInt']['input']>;
  where?: InputMaybe<Array<QueryInput>>;
};


export type QueryQueryMyPatientHistoryItemsArgs = {
  orderBy?: InputMaybe<OrderByInput>;
  page?: InputMaybe<Scalars['NonNegativeInt']['input']>;
  pageSize?: InputMaybe<Scalars['NonNegativeInt']['input']>;
  where?: InputMaybe<Array<QueryInput>>;
};


export type QueryQueryMyPatientsArgs = {
  orderBy?: InputMaybe<OrderByInput>;
  page?: InputMaybe<Scalars['NonNegativeInt']['input']>;
  pageSize?: InputMaybe<Scalars['NonNegativeInt']['input']>;
  where?: InputMaybe<Array<QueryInput>>;
};


export type QueryQueryMyPetSelfiesArgs = {
  orderBy?: InputMaybe<OrderByInput>;
  page?: InputMaybe<Scalars['NonNegativeInt']['input']>;
  pageSize?: InputMaybe<Scalars['NonNegativeInt']['input']>;
  where?: InputMaybe<Array<QueryInput>>;
};


export type QueryQueryMyPimsRemindersArgs = {
  orderBy?: InputMaybe<OrderByInput>;
  page?: InputMaybe<Scalars['NonNegativeInt']['input']>;
  pageSize?: InputMaybe<Scalars['NonNegativeInt']['input']>;
  where?: InputMaybe<Array<QueryInput>>;
};


export type QueryQueryMyPrescriptionRefillRequestsArgs = {
  orderBy?: InputMaybe<OrderByInput>;
  page?: InputMaybe<Scalars['NonNegativeInt']['input']>;
  pageSize?: InputMaybe<Scalars['NonNegativeInt']['input']>;
  where?: InputMaybe<Array<QueryInput>>;
};


export type QueryQueryMyPrescriptionsArgs = {
  orderBy?: InputMaybe<OrderByInput>;
  page?: InputMaybe<Scalars['NonNegativeInt']['input']>;
  pageSize?: InputMaybe<Scalars['NonNegativeInt']['input']>;
  where?: InputMaybe<Array<QueryInput>>;
};


export type QueryQueryMyUserNotificationsArgs = {
  page?: InputMaybe<Scalars['NonNegativeInt']['input']>;
  pageSize?: InputMaybe<Scalars['NonNegativeInt']['input']>;
};


export type QueryQueryMyVisitConcernsArgs = {
  orderBy?: InputMaybe<OrderByInput>;
  page?: InputMaybe<Scalars['NonNegativeInt']['input']>;
  pageSize?: InputMaybe<Scalars['NonNegativeInt']['input']>;
  where?: InputMaybe<Array<QueryInput>>;
};


export type QueryQueryMyVisitsArgs = {
  orderBy?: InputMaybe<OrderByInput>;
  page?: InputMaybe<Scalars['NonNegativeInt']['input']>;
  pageSize?: InputMaybe<Scalars['NonNegativeInt']['input']>;
  where?: InputMaybe<Array<QueryInput>>;
};


export type QueryQueryNotificationTemplatesArgs = {
  orderBy?: InputMaybe<OrderByInput>;
  page?: InputMaybe<Scalars['NonNegativeInt']['input']>;
  pageSize?: InputMaybe<Scalars['NonNegativeInt']['input']>;
  where?: InputMaybe<Array<QueryInput>>;
};


export type QueryQueryOrganizationReportsArgs = {
  orderBy?: InputMaybe<OrderByInput>;
  page?: InputMaybe<Scalars['NonNegativeInt']['input']>;
  pageSize?: InputMaybe<Scalars['NonNegativeInt']['input']>;
  where?: InputMaybe<Array<QueryInput>>;
};


export type QueryQueryOrganizationsArgs = {
  orderBy?: InputMaybe<OrderByInput>;
  page?: InputMaybe<Scalars['NonNegativeInt']['input']>;
  pageSize?: InputMaybe<Scalars['NonNegativeInt']['input']>;
  where?: InputMaybe<Array<QueryInput>>;
};


export type QueryQueryPatientHistoryItemsArgs = {
  orderBy?: InputMaybe<OrderByInput>;
  page?: InputMaybe<Scalars['NonNegativeInt']['input']>;
  pageSize?: InputMaybe<Scalars['NonNegativeInt']['input']>;
  where?: InputMaybe<Array<QueryInput>>;
};


export type QueryQueryPatientStatusesArgs = {
  orderBy?: InputMaybe<OrderByInput>;
  page?: InputMaybe<Scalars['NonNegativeInt']['input']>;
  pageSize?: InputMaybe<Scalars['NonNegativeInt']['input']>;
  where?: InputMaybe<Array<QueryInput>>;
};


export type QueryQueryPatientVaccinationRecordsArgs = {
  orderBy?: InputMaybe<OrderByInput>;
  page?: InputMaybe<Scalars['NonNegativeInt']['input']>;
  pageSize?: InputMaybe<Scalars['PositiveInt']['input']>;
  where?: InputMaybe<Array<QueryInput>>;
};


export type QueryQueryPatientsArgs = {
  orderBy?: InputMaybe<OrderByInput>;
  page?: InputMaybe<Scalars['NonNegativeInt']['input']>;
  pageSize?: InputMaybe<Scalars['NonNegativeInt']['input']>;
  where?: InputMaybe<Array<QueryInput>>;
};


export type QueryQueryPatientsOwnersArgs = {
  clinicId: Scalars['ID']['input'];
  orderBy?: InputMaybe<OrderByInput>;
  page?: InputMaybe<Scalars['NonNegativeInt']['input']>;
  pageSize?: InputMaybe<Scalars['NonNegativeInt']['input']>;
  where?: InputMaybe<Array<QueryInput>>;
};


export type QueryQueryPaymentsArgs = {
  orderBy?: InputMaybe<OrderByInput>;
  page?: InputMaybe<Scalars['NonNegativeInt']['input']>;
  pageSize?: InputMaybe<Scalars['NonNegativeInt']['input']>;
  where?: InputMaybe<Array<QueryInput>>;
};


export type QueryQueryPetSelfiesArgs = {
  orderBy?: InputMaybe<OrderByInput>;
  page?: InputMaybe<Scalars['NonNegativeInt']['input']>;
  pageSize?: InputMaybe<Scalars['NonNegativeInt']['input']>;
  where?: InputMaybe<Array<QueryInput>>;
};


export type QueryQueryPimsReminderTypesArgs = {
  orderBy?: InputMaybe<OrderByInput>;
  page?: InputMaybe<Scalars['NonNegativeInt']['input']>;
  pageSize?: InputMaybe<Scalars['NonNegativeInt']['input']>;
  where?: InputMaybe<Array<QueryInput>>;
};


export type QueryQueryPimsRemindersArgs = {
  orderBy?: InputMaybe<OrderByInput>;
  page?: InputMaybe<Scalars['NonNegativeInt']['input']>;
  pageSize?: InputMaybe<Scalars['NonNegativeInt']['input']>;
  where?: InputMaybe<Array<QueryInput>>;
};


export type QueryQueryPmsApptTypesArgs = {
  orderBy?: InputMaybe<OrderByInput>;
  page?: InputMaybe<Scalars['NonNegativeInt']['input']>;
  pageSize?: InputMaybe<Scalars['NonNegativeInt']['input']>;
  where?: InputMaybe<Array<QueryInput>>;
};


export type QueryQueryPmsDbsArgs = {
  orderBy?: InputMaybe<OrderByInput>;
  page?: InputMaybe<Scalars['NonNegativeInt']['input']>;
  pageSize?: InputMaybe<Scalars['NonNegativeInt']['input']>;
  where?: InputMaybe<Array<QueryInput>>;
};


export type QueryQueryPmsOtherEntitiesArgs = {
  orderBy?: InputMaybe<OrderByInput>;
  page?: InputMaybe<Scalars['NonNegativeInt']['input']>;
  pageSize?: InputMaybe<Scalars['NonNegativeInt']['input']>;
  where?: InputMaybe<Array<QueryInput>>;
};


export type QueryQueryPmsTagCategoriesArgs = {
  orderBy?: InputMaybe<OrderByInput>;
  page?: InputMaybe<Scalars['NonNegativeInt']['input']>;
  pageSize?: InputMaybe<Scalars['NonNegativeInt']['input']>;
  where?: InputMaybe<Array<QueryInput>>;
};


export type QueryQueryPmsTagsArgs = {
  orderBy?: InputMaybe<OrderByInput>;
  page?: InputMaybe<Scalars['NonNegativeInt']['input']>;
  pageSize?: InputMaybe<Scalars['NonNegativeInt']['input']>;
  where?: InputMaybe<Array<QueryInput>>;
};


export type QueryQueryPrescriptionRefillRequestsArgs = {
  orderBy?: InputMaybe<OrderByInput>;
  page?: InputMaybe<Scalars['NonNegativeInt']['input']>;
  pageSize?: InputMaybe<Scalars['NonNegativeInt']['input']>;
  where?: InputMaybe<Array<QueryInput>>;
};


export type QueryQueryPrescriptionsArgs = {
  orderBy?: InputMaybe<OrderByInput>;
  page?: InputMaybe<Scalars['NonNegativeInt']['input']>;
  pageSize?: InputMaybe<Scalars['NonNegativeInt']['input']>;
  where?: InputMaybe<Array<QueryInput>>;
};


export type QueryQueryProductsArgs = {
  orderBy?: InputMaybe<OrderByInput>;
  page?: InputMaybe<Scalars['NonNegativeInt']['input']>;
  pageSize?: InputMaybe<Scalars['NonNegativeInt']['input']>;
  where?: InputMaybe<Array<QueryInput>>;
};


export type QueryQueryProviderAvailabilityArgs = {
  clinicId: Scalars['ID']['input'];
  orderBy?: InputMaybe<OrderByInput>;
  page?: InputMaybe<Scalars['NonNegativeInt']['input']>;
  pageSize?: InputMaybe<Scalars['NonNegativeInt']['input']>;
  where: Array<QueryInput>;
};


export type QueryQueryReportMetricsArgs = {
  orderBy?: InputMaybe<OrderByInput>;
  page?: InputMaybe<Scalars['NonNegativeInt']['input']>;
  pageSize?: InputMaybe<Scalars['NonNegativeInt']['input']>;
  where?: InputMaybe<Array<QueryInput>>;
};


export type QueryQueryReportTemplatesArgs = {
  orderBy?: InputMaybe<OrderByInput>;
  page?: InputMaybe<Scalars['NonNegativeInt']['input']>;
  pageSize?: InputMaybe<Scalars['NonNegativeInt']['input']>;
  where?: InputMaybe<Array<QueryInput>>;
};


export type QueryQueryReschedulesArgs = {
  orderBy?: InputMaybe<OrderByInput>;
  page?: InputMaybe<Scalars['NonNegativeInt']['input']>;
  pageSize?: InputMaybe<Scalars['NonNegativeInt']['input']>;
  where?: InputMaybe<Array<QueryInput>>;
};


export type QueryQueryReviewsArgs = {
  orderBy?: InputMaybe<OrderByInput>;
  page?: InputMaybe<Scalars['NonNegativeInt']['input']>;
  pageSize?: InputMaybe<Scalars['NonNegativeInt']['input']>;
  where?: InputMaybe<Array<QueryInput>>;
};


export type QueryQueryRoomsArgs = {
  orderBy?: InputMaybe<OrderByInput>;
  page?: InputMaybe<Scalars['NonNegativeInt']['input']>;
  pageSize?: InputMaybe<Scalars['NonNegativeInt']['input']>;
  where?: InputMaybe<Array<QueryInput>>;
};


export type QueryQueryScheduledBulkMessagesArgs = {
  orderBy?: InputMaybe<OrderByInput>;
  page?: InputMaybe<Scalars['NonNegativeInt']['input']>;
  pageSize?: InputMaybe<Scalars['NonNegativeInt']['input']>;
  where?: InputMaybe<Array<QueryInput>>;
};


export type QueryQueryScheduledMessagesArgs = {
  orderBy?: InputMaybe<OrderByInput>;
  page?: InputMaybe<Scalars['NonNegativeInt']['input']>;
  pageSize?: InputMaybe<Scalars['NonNegativeInt']['input']>;
  where?: InputMaybe<Array<QueryInput>>;
};


export type QueryQuerySchedulingRulesArgs = {
  orderBy?: InputMaybe<OrderByInput>;
  page?: InputMaybe<Scalars['NonNegativeInt']['input']>;
  pageSize?: InputMaybe<Scalars['NonNegativeInt']['input']>;
  where?: InputMaybe<Array<QueryInput>>;
};


export type QueryQueryServiceFormsArgs = {
  orderBy?: InputMaybe<OrderByInput>;
  page?: InputMaybe<Scalars['NonNegativeInt']['input']>;
  pageSize?: InputMaybe<Scalars['NonNegativeInt']['input']>;
  where?: InputMaybe<Array<QueryInput>>;
};


export type QueryQueryServicesArgs = {
  orderBy?: InputMaybe<OrderByInput>;
  page?: InputMaybe<Scalars['NonNegativeInt']['input']>;
  pageSize?: InputMaybe<Scalars['NonNegativeInt']['input']>;
  where?: InputMaybe<Array<QueryInput>>;
};


export type QueryQueryUserAppointmentsArgs = {
  orderBy?: InputMaybe<OrderByInput>;
  page?: InputMaybe<Scalars['NonNegativeInt']['input']>;
  pageSize?: InputMaybe<Scalars['NonNegativeInt']['input']>;
  userId: Scalars['ID']['input'];
  where?: InputMaybe<Array<QueryInput>>;
};


export type QueryQueryUserChatsArgs = {
  orderBy?: InputMaybe<OrderByInput>;
  page?: InputMaybe<Scalars['NonNegativeInt']['input']>;
  pageSize?: InputMaybe<Scalars['NonNegativeInt']['input']>;
  userId: Scalars['ID']['input'];
  where?: InputMaybe<Array<QueryInput>>;
};


export type QueryQueryUsersArgs = {
  orderBy?: InputMaybe<OrderByInput>;
  page?: InputMaybe<Scalars['NonNegativeInt']['input']>;
  pageSize?: InputMaybe<Scalars['NonNegativeInt']['input']>;
  where?: InputMaybe<Array<QueryInput>>;
};


export type QueryQueryWidgetsArgs = {
  orderBy?: InputMaybe<OrderByInput>;
  page?: InputMaybe<Scalars['NonNegativeInt']['input']>;
  pageSize?: InputMaybe<Scalars['NonNegativeInt']['input']>;
  where?: InputMaybe<Array<QueryInput>>;
};


export type QueryReminderAttributedAppointmentIdsArgs = {
  filters: MarketingFiltersInput;
};


export type QueryReportMetricArgs = {
  id: Scalars['ID']['input'];
};


export type QueryReportTemplateArgs = {
  id: Scalars['ID']['input'];
};


export type QueryRescheduleArgs = {
  id: Scalars['ID']['input'];
};


export type QueryReviewArgs = {
  id: Scalars['ID']['input'];
};


export type QueryReviewAnalyticsArgs = {
  clinicIds: Array<Scalars['ID']['input']>;
};


export type QueryRoomArgs = {
  roomId: Scalars['ID']['input'];
};


export type QueryRoomAdjustedAvailabilityArgs = {
  clinicId: Scalars['ID']['input'];
  roomId: Scalars['ID']['input'];
};


export type QueryRoomRoutineAvailabilityArgs = {
  clinicId: Scalars['ID']['input'];
  roomId: Scalars['ID']['input'];
};


export type QueryScheduledBulkMessageArgs = {
  scheduledBulkMessageId: Scalars['ID']['input'];
};


export type QueryScheduledBulkMessageTrackingStatsArgs = {
  endDate?: InputMaybe<Scalars['NonNegativeInt']['input']>;
  scheduledBulkMessageId: Scalars['ID']['input'];
  startDate?: InputMaybe<Scalars['NonNegativeInt']['input']>;
};


export type QueryScheduledMessageArgs = {
  scheduledMessageId: Scalars['ID']['input'];
};


export type QuerySchedulingRuleArgs = {
  schedulingRulesId: Scalars['ID']['input'];
};


export type QuerySchedulingRulesForClinicArgs = {
  clinicId: Scalars['ID']['input'];
  page?: InputMaybe<Scalars['NonNegativeInt']['input']>;
  pageSize?: InputMaybe<Scalars['NonNegativeInt']['input']>;
};


export type QuerySchedulingRulesForWidgetArgs = {
  page?: InputMaybe<Scalars['NonNegativeInt']['input']>;
  pageSize?: InputMaybe<Scalars['NonNegativeInt']['input']>;
  widgetId: Scalars['ID']['input'];
};


export type QuerySearchAppointmentsArgs = {
  searchInput: SearchAppointmentsInput;
};


export type QuerySearchClinicProductsArgs = {
  clinicId: Scalars['ID']['input'];
  options?: InputMaybe<SearchClinicProductsOptions>;
};


export type QuerySearchCliniciansArgs = {
  searchInput: SearchCliniciansInput;
};


export type QuerySearchPimsReminderTypesForClinicArgs = {
  clinicId: Scalars['ID']['input'];
  options?: InputMaybe<SearchPimsReminderTypesForClinicOptions>;
};


export type QuerySearchUsersArgs = {
  limit?: InputMaybe<Scalars['NonNegativeInt']['input']>;
  roles?: InputMaybe<Array<AuthRoles>>;
  startAtId?: InputMaybe<Scalars['String']['input']>;
};


export type QuerySendClientLinkVerificationCodeArgs = {
  input: SendClientLinkInput;
};


export type QueryServiceArgs = {
  id: Scalars['ID']['input'];
};


export type QueryServiceCategoriesArgs = {
  clinicId: Scalars['ID']['input'];
};


export type QueryServiceCategoryArgs = {
  id: Scalars['ID']['input'];
};


export type QueryServiceFormArgs = {
  id: Scalars['ID']['input'];
};


export type QueryServiceFormByServiceAndFormArgs = {
  formId: Scalars['ID']['input'];
  serviceId: Scalars['ID']['input'];
};


export type QuerySpeciesArgs = {
  clinicId: Scalars['ID']['input'];
  speciesId: Scalars['ID']['input'];
};


export type QueryStripeAccountCheckArgs = {
  clinicId: Scalars['ID']['input'];
};


export type QueryStripeAccountInfoArgs = {
  accountType?: InputMaybe<StripeAccountType>;
  callbackUrls: AccountOnboardLinkInput;
  clinicId: Scalars['ID']['input'];
};


export type QueryStripeAccountLoginLinkArgs = {
  clinicId: Scalars['ID']['input'];
};


export type QueryStripeAccountOnboardLinkArgs = {
  clinicId: Scalars['ID']['input'];
  data: AccountOnboardLinkInput;
};


export type QuerySuggestChatResponseArgs = {
  chatId: Scalars['ID']['input'];
  existingText?: InputMaybe<Scalars['String']['input']>;
};


export type QuerySupportBotConversationArgs = {
  id: Scalars['ID']['input'];
};


export type QuerySupportBotConversationsArgs = {
  filterUserId?: InputMaybe<Scalars['ID']['input']>;
  limit?: InputMaybe<Scalars['NonNegativeInt']['input']>;
  offset?: InputMaybe<Scalars['NonNegativeInt']['input']>;
};


export type QuerySupportBotRunStatusArgs = {
  runId: Scalars['ID']['input'];
};


export type QuerySupportedPmsConnectorsArgs = {
  pms: PracticeManagementSystem;
};


export type QueryTagArgs = {
  id: Scalars['ID']['input'];
};


export type QueryTagCategoriesArgs = {
  clinicId: Scalars['ID']['input'];
};


export type QueryTagCategoriesByClinicGroupArgs = {
  clinicGroupId: Scalars['ID']['input'];
};


export type QueryTagCategoryArgs = {
  id: Scalars['ID']['input'];
};


export type QueryTagsForEntityArgs = {
  entityId: Scalars['String']['input'];
  entityType: TagEntity;
};


export type QueryTodayAnalyticsArgs = {
  clinicId: Scalars['ID']['input'];
  fromDate: Scalars['NonNegativeInt']['input'];
  toDate: Scalars['NonNegativeInt']['input'];
};


export type QueryTomorrowAnalyticsArgs = {
  clinicId: Scalars['ID']['input'];
  fromDate: Scalars['NonNegativeInt']['input'];
  toDate: Scalars['NonNegativeInt']['input'];
};


export type QueryTransactionArgs = {
  id: Scalars['ID']['input'];
};


export type QueryTreatmentArgs = {
  clinicId: Scalars['ID']['input'];
  treatmentId: Scalars['ID']['input'];
};


export type QueryUpcomingAppointmentsByPetArgs = {
  petId: Scalars['ID']['input'];
};


export type QueryUserArgs = {
  id: Scalars['ID']['input'];
};


export type QueryUserTrackingClientsArgs = {
  clinicId: Scalars['ID']['input'];
  membership: UserTrackingMembership;
  metric: UserTrackingMetric;
  page?: InputMaybe<Scalars['NonNegativeInt']['input']>;
  pageSize?: InputMaybe<Scalars['NonNegativeInt']['input']>;
  search?: InputMaybe<Scalars['String']['input']>;
};


export type QueryUserTrackingSummaryArgs = {
  clinicId: Scalars['ID']['input'];
};


export type QueryVaccineRecordsByTokenArgs = {
  token: Scalars['String']['input'];
};


export type QueryValidateClientPhoneArgs = {
  clientId: Scalars['ID']['input'];
  phoneInput: Scalars['String']['input'];
};


export type QueryWidgetArgs = {
  id: Scalars['ID']['input'];
};


export type QueryWidgetOptionsArgs = {
  id: Scalars['ID']['input'];
};


export type QueryWidgetOptionsForWidgetArgs = {
  widgetId: Scalars['ID']['input'];
};


export type QueryWidgetServiceArgs = {
  id: Scalars['ID']['input'];
};


export type QueryWidgetServicesForWidgetArgs = {
  widgetId: Scalars['ID']['input'];
};


export type QueryWidgetSisterLocationArgs = {
  id: Scalars['ID']['input'];
};


export type QueryWidgetSisterLocationsArgs = {
  widgetId: Scalars['ID']['input'];
};


export type QueryYesterdayAnalyticsArgs = {
  clinicId: Scalars['ID']['input'];
  fromDate: Scalars['NonNegativeInt']['input'];
  toDate: Scalars['NonNegativeInt']['input'];
};

export type QueryClientsPatientsResult = {
  __typename?: 'QueryClientsPatientsResult';
  client?: Maybe<Client>;
  matchingText: Scalars['String']['output'];
  patients: Array<Patient>;
};

export type QueryClientsPatientsResults = {
  __typename?: 'QueryClientsPatientsResults';
  count: Scalars['NonNegativeInt']['output'];
  results: Array<QueryClientsPatientsResult>;
};

export type QueryFilter = {
  __typename?: 'QueryFilter';
  column: Scalars['String']['output'];
  filterOp: FilterOp;
  not?: Maybe<Scalars['Boolean']['output']>;
  value: QueryFilterValue;
};

export type QueryFilterValue = {
  __typename?: 'QueryFilterValue';
  boolean?: Maybe<Scalars['Boolean']['output']>;
  booleanArray?: Maybe<Array<Scalars['Boolean']['output']>>;
  float?: Maybe<Scalars['Float']['output']>;
  floatArray?: Maybe<Array<Scalars['Float']['output']>>;
  intArray?: Maybe<Array<Scalars['Int']['output']>>;
  millisFromNow?: Maybe<Scalars['Float']['output']>;
  relativeTime?: Maybe<RelativeTime>;
  string?: Maybe<Scalars['String']['output']>;
  stringArray?: Maybe<Array<Scalars['String']['output']>>;
};

export type QueryInput = {
  column: Scalars['String']['input'];
  filterOp: FilterOp;
  not?: InputMaybe<Scalars['Boolean']['input']>;
  value: QueryInputValue;
};

export type QueryInputValue = {
  boolean?: InputMaybe<Scalars['Boolean']['input']>;
  booleanArray?: InputMaybe<Array<Scalars['Boolean']['input']>>;
  float?: InputMaybe<Scalars['Float']['input']>;
  floatArray?: InputMaybe<Array<Scalars['Float']['input']>>;
  intArray?: InputMaybe<Array<Scalars['Int']['input']>>;
  millisFromNow?: InputMaybe<Scalars['Float']['input']>;
  relativeTime?: InputMaybe<RelativeTimeInput>;
  string?: InputMaybe<Scalars['String']['input']>;
  stringArray?: InputMaybe<Array<Scalars['String']['input']>>;
};

export type QueryParams = {
  orderBy?: InputMaybe<OrderByInput>;
  page?: InputMaybe<Scalars['NonNegativeInt']['input']>;
  pageSize?: InputMaybe<Scalars['NonNegativeInt']['input']>;
  where?: InputMaybe<Array<QueryInput>>;
};

export type QueryPatientsOwnersResults = {
  __typename?: 'QueryPatientsOwnersResults';
  count: Scalars['NonNegativeInt']['output'];
  /**
   * True when more patients match than count. Patient search stops counting
   * at a limit (100, or the end of the requested page if further) to stay fast.
   */
  isCountCapped: Scalars['Boolean']['output'];
  patients: Array<Patient>;
};

export type RealTimeReportParams = {
  end_time: Scalars['NonNegativeInt']['input'];
  report_template: Scalars['ID']['input'];
  start_time: Scalars['NonNegativeInt']['input'];
};

export type RecordClinicHealthCheckRunInput = {
  findings: Array<ClinicHealthFindingInput>;
  resolved: Array<ClinicHealthResolvedIssueInput>;
  /** snapshot_date from the clinicHealthCheckPayload the bot reviewed. */
  snapshot_date: Scalars['String']['input'];
};

export type RecordClinicHealthCheckRunResult = {
  __typename?: 'RecordClinicHealthCheckRunResult';
  /** One entry per finding, with its streak after this run. */
  reported: Array<ClinicHealthOpenIssue>;
  /** Previously open issues this run closed, as they were before closing. */
  resolved: Array<ClinicHealthOpenIssue>;
};

export type RecurringSettings = {
  __typename?: 'RecurringSettings';
  expires_after_days?: Maybe<Scalars['NonNegativeInt']['output']>;
  recur_after_days?: Maybe<Scalars['NonNegativeInt']['output']>;
};

export type RecurringSettingsInput = {
  expires_after_days?: InputMaybe<Scalars['NonNegativeInt']['input']>;
  recur_after_days?: InputMaybe<Scalars['NonNegativeInt']['input']>;
};

export type ReferenceDateParams = {
  __typename?: 'ReferenceDateParams';
  field: Scalars['String']['output'];
  reference_periods?: Maybe<Array<ReferencePeriod>>;
};

export type ReferenceDateParamsInput = {
  field: Scalars['String']['input'];
  reference_periods?: InputMaybe<Array<ReferencePeriodInput>>;
};

export enum ReferenceDirection {
  After = 'After',
  Before = 'Before'
}

export type ReferencePeriod = {
  __typename?: 'ReferencePeriod';
  direction: ReferenceDirection;
  quantity: Scalars['NonNegativeInt']['output'];
  unit: TimeUnit;
};

export type ReferencePeriodInput = {
  direction: ReferenceDirection;
  quantity: Scalars['NonNegativeInt']['input'];
  unit: TimeUnit;
};

export type ReferrerInput = {
  client_id?: InputMaybe<Scalars['ID']['input']>;
  email?: InputMaybe<Scalars['String']['input']>;
  first_name?: InputMaybe<Scalars['String']['input']>;
  last_name?: InputMaybe<Scalars['String']['input']>;
  phone?: InputMaybe<Scalars['String']['input']>;
};

export type ReferringVet = {
  __typename?: 'ReferringVet';
  id: Scalars['ID']['output'];
  name: Scalars['String']['output'];
  pms_id: Scalars['String']['output'];
};

export type RelativeTime = {
  __typename?: 'RelativeTime';
  direction: ReferenceDirection;
  quantity: Scalars['NonNegativeInt']['output'];
  unit: TimeUnit;
};

export type RelativeTimeInput = {
  direction: ReferenceDirection;
  quantity: Scalars['NonNegativeInt']['input'];
  unit: TimeUnit;
};

/**
 * Returns the appointment IDs attributed to a set of notification templates
 * and/or bulk messages under the given window. Use this when you need to
 * compose with `queryAppointments` to display paginated rows or apply
 * additional appointment-side filters (clinician, service, UTM, etc.).
 * For just a count, use the `marketingSummaryStats` query instead — it's
 * cheaper.
 */
export type ReminderAttributedAppointmentIds = {
  __typename?: 'ReminderAttributedAppointmentIds';
  appointment_ids: Array<Scalars['ID']['output']>;
  /** True when the row-fetch hit the safety cap. */
  limit_hit: Scalars['Boolean']['output'];
};

export enum ReminderType {
  Appointment = 'Appointment',
  Other = 'Other',
  Product = 'Product'
}

export type RepeatAvailability = {
  __typename?: 'RepeatAvailability';
  daysOfMonth?: Maybe<Array<Scalars['Int']['output']>>;
  daysOfWeek?: Maybe<Array<DayOfWeek>>;
  end_date?: Maybe<Scalars['NonNegativeInt']['output']>;
  frequency: Scalars['PositiveInt']['output'];
  unit: RepeatUnit;
  weekOfMonth?: Maybe<WeekOfMonth>;
};

export type RepeatAvailabilityInput = {
  daysOfMonth?: InputMaybe<Array<Scalars['Int']['input']>>;
  daysOfWeek?: InputMaybe<Array<DayOfWeek>>;
  end_date?: InputMaybe<Scalars['NonNegativeInt']['input']>;
  frequency: Scalars['PositiveInt']['input'];
  unit: RepeatUnit;
  weekOfMonth?: InputMaybe<WeekOfMonth>;
};

export type RepeatParams = {
  __typename?: 'RepeatParams';
  daysOfMonth?: Maybe<Array<Scalars['Int']['output']>>;
  daysOfWeek?: Maybe<Array<DayOfWeek>>;
  frequency: Scalars['PositiveInt']['output'];
  unit: RepeatUnit;
  weekOfMonth?: Maybe<WeekOfMonth>;
};

export type RepeatParamsInput = {
  daysOfMonth?: InputMaybe<Array<Scalars['Int']['input']>>;
  daysOfWeek?: InputMaybe<Array<DayOfWeek>>;
  frequency: Scalars['PositiveInt']['input'];
  unit: RepeatUnit;
  weekOfMonth?: InputMaybe<WeekOfMonth>;
};

export enum RepeatUnit {
  Day = 'day',
  Month = 'month',
  Week = 'week'
}

export type ReportClinic = {
  __typename?: 'ReportClinic';
  clinic: Clinic;
  id: Scalars['ID']['output'];
  report: OrganizationReport;
};

export type ReportColumnValue = {
  __typename?: 'ReportColumnValue';
  percentile?: Maybe<Scalars['NonNegativeFloat']['output']>;
  value?: Maybe<Scalars['Float']['output']>;
  value_params: MetricValueParams;
};

export type ReportEntity = {
  __typename?: 'ReportEntity';
  child_entities?: Maybe<Array<ReportEntity>>;
  entity_type: ReportEntityType;
};

export type ReportEntityInput = {
  child_entities?: InputMaybe<Array<ReportEntityInput>>;
  entity_type: ReportEntityType;
};

export enum ReportEntityType {
  Clinic = 'Clinic',
  Clinician = 'Clinician',
  Product = 'Product',
  Service = 'Service'
}

export type ReportMetric = {
  __typename?: 'ReportMetric';
  aggregate_field_override?: Maybe<Scalars['String']['output']>;
  clinic?: Maybe<Clinic>;
  clinic_group?: Maybe<ClinicGroup>;
  custom_query?: Maybe<Scalars['JSON']['output']>;
  definition_override?: Maybe<Scalars['String']['output']>;
  description?: Maybe<Scalars['String']['output']>;
  field_modifiers: Array<ReportMetricModifier>;
  format?: Maybe<MetricFormat>;
  id: Scalars['ID']['output'];
  initiative_metrics: Array<InitiativeMetric>;
  inverse_percentile?: Maybe<Scalars['Boolean']['output']>;
  is_archived: Scalars['Boolean']['output'];
  key: Scalars['String']['output'];
  kpi_group_metrics: Array<KpiGroupMetric>;
  name: Scalars['String']['output'];
  order: Scalars['NonNegativeInt']['output'];
  organization_report?: Maybe<OrganizationReport>;
  report_template?: Maybe<ReportTemplate>;
  report_template_metrics: Array<ReportTemplateMetric>;
  special_modifier?: Maybe<SpecialMetricModifierType>;
  time_field_override?: Maybe<Scalars['String']['output']>;
  time_params_overrides?: Maybe<TimeParams>;
  type: ReportMetricType;
  value_types: Array<MetricValueParams>;
};

export type ReportMetricInput = {
  aggregate_field_override?: InputMaybe<Scalars['String']['input']>;
  custom_query?: InputMaybe<Scalars['JSON']['input']>;
  definition_override?: InputMaybe<Scalars['String']['input']>;
  description?: InputMaybe<Scalars['String']['input']>;
  field_modifiers?: InputMaybe<Array<ReportMetricModifierInput>>;
  format?: InputMaybe<MetricFormat>;
  id?: InputMaybe<Scalars['ID']['input']>;
  inverse_percentile?: InputMaybe<Scalars['Boolean']['input']>;
  is_archived?: InputMaybe<Scalars['Boolean']['input']>;
  name: Scalars['String']['input'];
  order: Scalars['NonNegativeInt']['input'];
  organization_report?: InputMaybe<Scalars['ID']['input']>;
  report_template?: InputMaybe<Scalars['ID']['input']>;
  special_modifier?: InputMaybe<SpecialMetricModifierType>;
  time_field_override?: InputMaybe<Scalars['String']['input']>;
  time_params_overrides?: InputMaybe<TimeParamsInput>;
  type: ReportMetricType;
  value_types: Array<MetricValueParamsInput>;
};

export type ReportMetricModifier = {
  __typename?: 'ReportMetricModifier';
  category: MetricModifierCategory;
  column: Scalars['String']['output'];
  filterOp: FilterOp;
  not?: Maybe<Scalars['Boolean']['output']>;
  value: MetricModifierValue;
};

export type ReportMetricModifierInput = {
  category: MetricModifierCategory;
  column: Scalars['String']['input'];
  filterOp: FilterOp;
  not?: InputMaybe<Scalars['Boolean']['input']>;
  value: MetricModifierValueInput;
};

export enum ReportMetricType {
  AppointmentRate = 'AppointmentRate',
  AppointmentsCount = 'AppointmentsCount',
  AppointmentsScheduledCount = 'AppointmentsScheduledCount',
  FillRate = 'FillRate',
  ForwardScheduleRate = 'ForwardScheduleRate',
  ForwardScheduledPatients = 'ForwardScheduledPatients',
  InvoiceItemsCount = 'InvoiceItemsCount',
  InvoiceItemsTotal = 'InvoiceItemsTotal',
  InvoicesCount = 'InvoicesCount',
  InvoicesTotal = 'InvoicesTotal',
  NewClients = 'NewClients',
  NewPatients = 'NewPatients',
  NonForwardScheduledPatients = 'NonForwardScheduledPatients',
  ReturningClients = 'ReturningClients',
  ReturningPatients = 'ReturningPatients',
  ShowRate = 'ShowRate',
  UniqueClients = 'UniqueClients',
  UniquePatients = 'UniquePatients'
}

export type ReportTemplate = {
  __typename?: 'ReportTemplate';
  clinic?: Maybe<Clinic>;
  clinic_group?: Maybe<ClinicGroup>;
  created_at: Scalars['Timestamp']['output'];
  description?: Maybe<Scalars['String']['output']>;
  entity_structure?: Maybe<Array<Scalars['String']['output']>>;
  id: Scalars['ID']['output'];
  is_active: Scalars['Boolean']['output'];
  last_run?: Maybe<Scalars['Timestamp']['output']>;
  name: Scalars['String']['output'];
  next_run?: Maybe<Scalars['Timestamp']['output']>;
  organization?: Maybe<Organization>;
  organization_reports: Array<OrganizationReport>;
  preferred_view_type?: Maybe<ReportViewType>;
  repeat?: Maybe<RepeatParams>;
  report_template_metrics: Array<ReportTemplateMetric>;
  template_clinics: Array<TemplateClinic>;
  time_params?: Maybe<TimeParams>;
  updated_at: Scalars['Timestamp']['output'];
};

export type ReportTemplateMetric = {
  __typename?: 'ReportTemplateMetric';
  created_at: Scalars['Timestamp']['output'];
  id: Scalars['ID']['output'];
  order?: Maybe<Scalars['Int']['output']>;
  report_metric: ReportMetric;
  report_template: ReportTemplate;
  updated_at: Scalars['Timestamp']['output'];
};

export type ReportTemplateResult = {
  __typename?: 'ReportTemplateResult';
  metric: ReportTemplateMetric;
  values: Array<Scalars['JSON']['output']>;
};

export type ReportValue = {
  __typename?: 'ReportValue';
  column_values: Array<ReportColumnValue>;
  key: Scalars['String']['output'];
  metric: ReportMetricType;
};

export enum ReportViewType {
  BarChart = 'BarChart',
  PieChart = 'PieChart',
  Table = 'Table'
}

export type Reschedule = {
  __typename?: 'Reschedule';
  action_items?: Maybe<Array<ActionItem>>;
  appointment: Appointment;
  client_notes?: Maybe<Scalars['String']['output']>;
  clinic: Clinic;
  clinic_notes?: Maybe<Scalars['String']['output']>;
  confirmed_at?: Maybe<Scalars['NonNegativeInt']['output']>;
  created_at: Scalars['Timestamp']['output'];
  id: Scalars['ID']['output'];
  initiated_by: RescheduleInitiatedBy;
  original_clinician?: Maybe<Clinician>;
  original_drop_off_time?: Maybe<Scalars['NonNegativeInt']['output']>;
  original_start_time?: Maybe<Scalars['NonNegativeInt']['output']>;
  reason_for_denial?: Maybe<Scalars['String']['output']>;
  requested_clinician?: Maybe<Clinician>;
  requested_drop_off_time?: Maybe<Scalars['NonNegativeInt']['output']>;
  requested_start_time?: Maybe<Scalars['NonNegativeInt']['output']>;
  status: RescheduleStatus;
  updated_at: Scalars['Timestamp']['output'];
};

export enum RescheduleInitiatedBy {
  Client = 'Client',
  Clinic = 'Clinic'
}

export enum RescheduleStatus {
  Approved = 'Approved',
  AwaitingClinicApproval = 'AwaitingClinicApproval',
  Denied = 'Denied',
  Expired = 'Expired',
  Requested = 'Requested'
}

export enum ResolveReason {
  EnteredManually = 'EnteredManually',
  Resolved = 'Resolved'
}

export enum ResourceType {
  Clinician = 'Clinician',
  Room = 'Room'
}

export type ReturningClientPatientResult = {
  __typename?: 'ReturningClientPatientResult';
  client_email_preview: Scalars['String']['output'];
  client_id: Scalars['ID']['output'];
  client_name_preview: Scalars['String']['output'];
  client_no_previous_appointments?: Maybe<Scalars['Boolean']['output']>;
  client_phone_preview: Scalars['String']['output'];
  no_previous_appointments?: Maybe<Scalars['Boolean']['output']>;
  patient_birthday?: Maybe<Scalars['Float']['output']>;
  patient_clinic_species?: Maybe<Scalars['ID']['output']>;
  patient_fixed_status?: Maybe<FixedStatus>;
  patient_gender?: Maybe<AnimalGender>;
  patient_id: Scalars['ID']['output'];
  patient_name: Scalars['String']['output'];
  patient_no_previous_appointments?: Maybe<Scalars['Boolean']['output']>;
};

export type RevenueByClinician = {
  __typename?: 'RevenueByClinician';
  clinician: Clinician;
  revenue: Scalars['Float']['output'];
};

export type RevenueByMonth = {
  __typename?: 'RevenueByMonth';
  month: Scalars['NonNegativeInt']['output'];
  revenue: Scalars['Float']['output'];
  year: Scalars['NonNegativeInt']['output'];
};

export type RevenueGroup = {
  __typename?: 'RevenueGroup';
  amount: Scalars['Float']['output'];
  group: Scalars['String']['output'];
};

export type Review = {
  __typename?: 'Review';
  appointment?: Maybe<Appointment>;
  care_rating?: Maybe<Scalars['NonNegativeInt']['output']>;
  client?: Maybe<Client>;
  clinic: Clinic;
  created_at: Scalars['Timestamp']['output'];
  description?: Maybe<Scalars['String']['output']>;
  external_author_image?: Maybe<Scalars['String']['output']>;
  external_author_name?: Maybe<Scalars['String']['output']>;
  external_id?: Maybe<Scalars['String']['output']>;
  external_owner_response?: Maybe<Scalars['String']['output']>;
  external_owner_response_timestamp?: Maybe<Scalars['Timestamp']['output']>;
  external_rating?: Maybe<Scalars['NonNegativeInt']['output']>;
  external_review_url?: Maybe<Scalars['String']['output']>;
  external_text?: Maybe<Scalars['String']['output']>;
  external_timestamp?: Maybe<Scalars['Timestamp']['output']>;
  id: Scalars['ID']['output'];
  is_anonymous?: Maybe<Scalars['Boolean']['output']>;
  is_nps?: Maybe<Scalars['Boolean']['output']>;
  nps_rating?: Maybe<Scalars['NonNegativeInt']['output']>;
  overall_rating: Scalars['NonNegativeInt']['output'];
  price_rating?: Maybe<Scalars['NonNegativeInt']['output']>;
  review_source: ReviewSource;
  review_submitted_at?: Maybe<Scalars['Timestamp']['output']>;
  time_rating?: Maybe<Scalars['NonNegativeInt']['output']>;
  updated_at: Scalars['Timestamp']['output'];
};

/** All-time review performance across a set of clinics. */
export type ReviewAnalytics = {
  __typename?: 'ReviewAnalytics';
  /** Mean overall_rating (1-5) across every source (0 when there are no reviews). */
  average_rating: Scalars['Float']['output'];
  request_conversion: ReviewRequestConversion;
  review_count: Scalars['NonNegativeInt']['output'];
  /** Only sources with at least one review, most reviews first. */
  sources: Array<ReviewSourceStats>;
};

/**
 * How many clients who were sent a review request went on to leave a review.
 * Counted per clinic, then summed, so a client shared by two clinics counts
 * once for each clinic that asked them.
 */
export type ReviewRequestConversion = {
  __typename?: 'ReviewRequestConversion';
  /** Distinct clients sent at least one non-preview message by a Review-type notification. */
  clients_requested: Scalars['NonNegativeInt']['output'];
  /** Of clients_requested, those who submitted a review to the same clinic on or after a review request. */
  clients_reviewed: Scalars['NonNegativeInt']['output'];
  /** clients_reviewed / clients_requested as a 0..1 ratio (0 when no one was requested). */
  conversion_rate: Scalars['Float']['output'];
};

export enum ReviewSource {
  Facebook = 'Facebook',
  Google = 'Google',
  Internal = 'Internal'
}

/** Review volume and average overall rating for one review source. */
export type ReviewSourceStats = {
  __typename?: 'ReviewSourceStats';
  /** Mean overall_rating (1-5) across review_count reviews. */
  average_rating: Scalars['Float']['output'];
  review_count: Scalars['NonNegativeInt']['output'];
  review_source: ReviewSource;
};

export type ReviewTotals = {
  __typename?: 'ReviewTotals';
  count: Scalars['NonNegativeInt']['output'];
  total: Scalars['NonNegativeInt']['output'];
};

export type Room = {
  __typename?: 'Room';
  adjusted_availability?: Maybe<Array<Availability>>;
  clinic?: Maybe<Clinic>;
  concurrent_patients?: Maybe<Scalars['NonNegativeInt']['output']>;
  created_at: Scalars['Timestamp']['output'];
  description?: Maybe<Scalars['String']['output']>;
  display_name?: Maybe<Scalars['String']['output']>;
  does_contribute_to_fill_rate?: Maybe<Scalars['Boolean']['output']>;
  hours?: Maybe<AvailabilityHours>;
  id: Scalars['ID']['output'];
  is_active: Scalars['Boolean']['output'];
  name: Scalars['String']['output'];
  pms: PracticeManagementSystem;
  pms_adjusted_availability?: Maybe<Array<Availability>>;
  pms_id: Scalars['String']['output'];
  room_services?: Maybe<Array<RoomService>>;
  stagger_offset_minutes?: Maybe<Scalars['NonNegativeInt']['output']>;
  updated_at: Scalars['Timestamp']['output'];
  valid_booking_interval_minutes?: Maybe<Array<Scalars['NonNegativeInt']['output']>>;
};

export type RoomService = {
  __typename?: 'RoomService';
  clinic: Clinic;
  created_at: Scalars['Timestamp']['output'];
  duration_override?: Maybe<Scalars['NonNegativeInt']['output']>;
  id: Scalars['ID']['output'];
  is_active: Scalars['Boolean']['output'];
  room: Room;
  service: Service;
  updated_at: Scalars['Timestamp']['output'];
};

export type SavedPaymentMethod = {
  __typename?: 'SavedPaymentMethod';
  brand: Scalars['String']['output'];
  exp_month: Scalars['Int']['output'];
  exp_year: Scalars['Int']['output'];
  id: Scalars['ID']['output'];
  is_default: Scalars['Boolean']['output'];
  last4: Scalars['String']['output'];
};

/**
 * Internal slot-grid style for availability math. Not shown to clients.
 * Optimized steps the grid by base_schedule_duration; Realistic and
 * RealisticOptimized (default) use a 30-minute grid. Distinct from
 * time_slot_minutes, which controls which start times are offered.
 */
export enum ScheduleMethod {
  Optimized = 'Optimized',
  Realistic = 'Realistic',
  RealisticOptimized = 'RealisticOptimized'
}

export type ScheduledBulkMessage = {
  __typename?: 'ScheduledBulkMessage';
  body?: Maybe<Scalars['String']['output']>;
  campaign?: Maybe<Campaign>;
  /** Owner: exactly one of clinic / clinic_group is set */
  clinic?: Maybe<Clinic>;
  /**
   * Group-owned bulk messages never send themselves — they waterfall to
   * linked clinic copies (see entity_links), which send individually
   */
  clinic_group?: Maybe<ClinicGroup>;
  created_at: Scalars['NonNegativeInt']['output'];
  cta_text?: Maybe<Scalars['String']['output']>;
  cta_url?: Maybe<Scalars['String']['output']>;
  customer_segment?: Maybe<CustomerSegment>;
  email_body?: Maybe<Scalars['String']['output']>;
  email_design?: Maybe<Scalars['JSON']['output']>;
  email_html?: Maybe<Scalars['String']['output']>;
  email_template?: Maybe<EmailTemplate>;
  excluded_clients?: Maybe<Array<Scalars['ID']['output']>>;
  header?: Maybe<Scalars['String']['output']>;
  id: Scalars['ID']['output'];
  included_clients?: Maybe<Array<Scalars['ID']['output']>>;
  is_active: Scalars['Boolean']['output'];
  is_archived: Scalars['Boolean']['output'];
  is_completed: Scalars['Boolean']['output'];
  is_marketing: Scalars['Boolean']['output'];
  is_system: Scalars['Boolean']['output'];
  message_methods: Array<MessageMethod>;
  name: Scalars['String']['output'];
  notif_attachments?: Maybe<Array<Attachment>>;
  one_per_client: Scalars['Boolean']['output'];
  send_time?: Maybe<Scalars['NonNegativeInt']['output']>;
  started_at?: Maybe<Scalars['NonNegativeInt']['output']>;
  subject?: Maybe<Scalars['String']['output']>;
  updated_at: Scalars['NonNegativeInt']['output'];
};

export type ScheduledBulkMessageTrackingStats = {
  __typename?: 'ScheduledBulkMessageTrackingStats';
  conversion_rate: Scalars['Float']['output'];
  direct_appointments: Scalars['NonNegativeInt']['output'];
  email_click_rate: Scalars['Float']['output'];
  email_clicks: Scalars['NonNegativeInt']['output'];
  email_open_rate: Scalars['Float']['output'];
  email_opens: Scalars['NonNegativeInt']['output'];
  email_unique_click_rate: Scalars['Float']['output'];
  email_unique_clicks: Scalars['NonNegativeInt']['output'];
  email_unique_open_rate: Scalars['Float']['output'];
  email_unique_opens: Scalars['NonNegativeInt']['output'];
  emails_sent: Scalars['NonNegativeInt']['output'];
  indirect_appointments: Scalars['NonNegativeInt']['output'];
  messages_sent: Scalars['NonNegativeInt']['output'];
  revenue_by_appt: Scalars['Float']['output'];
  sms_click_rate: Scalars['Float']['output'];
  sms_clicks: Scalars['NonNegativeInt']['output'];
  sms_sent: Scalars['NonNegativeInt']['output'];
  sms_unique_click_rate: Scalars['Float']['output'];
  sms_unique_clicks: Scalars['NonNegativeInt']['output'];
  unique_clients: Scalars['NonNegativeInt']['output'];
};

export type ScheduledMessage = {
  __typename?: 'ScheduledMessage';
  cancelled_at?: Maybe<Scalars['NonNegativeInt']['output']>;
  cancelled_by?: Maybe<Scalars['String']['output']>;
  chat: Chat;
  client?: Maybe<Client>;
  clinic: Clinic;
  created_at: Scalars['NonNegativeInt']['output'];
  created_by: User;
  cta_text?: Maybe<Scalars['String']['output']>;
  cta_url?: Maybe<Scalars['String']['output']>;
  email_text?: Maybe<Scalars['String']['output']>;
  error?: Maybe<Scalars['String']['output']>;
  id: Scalars['ID']['output'];
  message_attachments?: Maybe<Array<Attachment>>;
  message_methods: Array<MessageMethod>;
  send_time: Scalars['NonNegativeInt']['output'];
  sent_at?: Maybe<Scalars['NonNegativeInt']['output']>;
  sent_message?: Maybe<Scalars['ID']['output']>;
  status: ScheduledMessageStatus;
  subject?: Maybe<Scalars['String']['output']>;
  text: Scalars['String']['output'];
  updated_at: Scalars['NonNegativeInt']['output'];
};

export enum ScheduledMessageStatus {
  Cancelled = 'Cancelled',
  Failed = 'Failed',
  Pending = 'Pending',
  Sending = 'Sending',
  Sent = 'Sent'
}

export type SchedulingRules = {
  __typename?: 'SchedulingRules';
  adjusted_availability?: Maybe<Array<Availability>>;
  availability?: Maybe<AvailabilityHours>;
  client_type?: Maybe<ClientTypeEnum>;
  clinic?: Maybe<Clinic>;
  created_at: Scalars['Timestamp']['output'];
  fixed_status?: Maybe<FixedStatus>;
  id: Scalars['ID']['output'];
  included_client_audiences?: Maybe<Array<CustomerSegment>>;
  included_clinicians?: Maybe<Array<Clinician>>;
  included_patient_audiences?: Maybe<Array<CustomerSegment>>;
  included_rooms?: Maybe<Array<Room>>;
  included_services?: Maybe<Array<Service>>;
  included_species?: Maybe<Array<ClinicSpecies>>;
  is_active: Scalars['Boolean']['output'];
  is_simple_rule: Scalars['Boolean']['output'];
  max_per_rule?: Maybe<Scalars['NonNegativeInt']['output']>;
  only_modifier?: Maybe<OnlyModifierEnum>;
  patient_gender?: Maybe<AnimalGender>;
  patient_type?: Maybe<PatientTypeEnum>;
  updated_at: Scalars['Timestamp']['output'];
  widget?: Maybe<Widget>;
};

/**
 * Categorized scheduling rules based on how they apply to the booking criteria.
 * Used for debugging/availability checking to understand which rules affect scheduling.
 */
export type SchedulingRulesCategorized = {
  __typename?: 'SchedulingRulesCategorized';
  /** Rules that match criteria but would block/restrict the slot (prerequisites met, only modifier fails). */
  applicable_but_not_passed_rule_ids: Array<Scalars['ID']['output']>;
  /** Rules that exist but don't match the booking criteria (prerequisites not met). */
  not_applicable_rule_ids: Array<Scalars['ID']['output']>;
  /** Rules that apply AND the booking satisfies them (prerequisites met, only modifier passes). */
  passed_rule_ids: Array<Scalars['ID']['output']>;
};

/**
 * Input params for getSchedulingRulesCategorized query.
 * Uses the same booking criteria fields as TimeSlotParams.
 */
export type SchedulingRulesCategorizedParams = {
  clinic_species_id: Scalars['ID']['input'];
  clinician_preference_id?: InputMaybe<Array<Scalars['ID']['input']>>;
  /**
   * Date to check for time-based rules and max_per_rule evaluation.
   * If not provided, time-based rules will show as passed/not_applicable per their only_modifier status.
   */
  date?: InputMaybe<Scalars['NonNegativeInt']['input']>;
  /**
   * Duration in minutes for time slot evaluation.
   * Used with date to determine the time window for time-based rules.
   */
  duration_in_minutes?: InputMaybe<Scalars['NonNegativeInt']['input']>;
  fixed_status?: InputMaybe<FixedStatus>;
  is_new_client?: InputMaybe<Scalars['Boolean']['input']>;
  is_new_patient: Scalars['Boolean']['input'];
  patient_gender?: InputMaybe<AnimalGender>;
  room_id?: InputMaybe<Scalars['ID']['input']>;
  service_ids?: InputMaybe<Array<Scalars['ID']['input']>>;
};

export type SearchAppointmentsInput = {
  clientId?: InputMaybe<Scalars['ID']['input']>;
  clinicId?: InputMaybe<Scalars['ID']['input']>;
  clinicianId?: InputMaybe<Scalars['ID']['input']>;
  cursor_id?: InputMaybe<Scalars['String']['input']>;
  end_date?: InputMaybe<Scalars['NonNegativeInt']['input']>;
  is_native_origin?: InputMaybe<Scalars['Boolean']['input']>;
  is_time_block?: InputMaybe<Scalars['Boolean']['input']>;
  limit?: InputMaybe<Scalars['NonNegativeInt']['input']>;
  origin?: InputMaybe<EntityOrigin>;
  pms?: InputMaybe<PracticeManagementSystem>;
  pms_id?: InputMaybe<Scalars['String']['input']>;
  should_be_synced?: InputMaybe<Scalars['Boolean']['input']>;
  start_date?: InputMaybe<Scalars['NonNegativeInt']['input']>;
  start_time?: InputMaybe<Scalars['NonNegativeInt']['input']>;
  start_time_ordering?: InputMaybe<StartTimeOrdering>;
  status?: InputMaybe<AppointmentStatus>;
  time_of_day?: InputMaybe<TimeOfDay>;
  updated_from?: InputMaybe<Scalars['NonNegativeInt']['input']>;
};

export type SearchClinicProductsOptions = {
  categories?: InputMaybe<Array<ProductCategory>>;
  onlyActive?: InputMaybe<Scalars['Boolean']['input']>;
  orderBy?: InputMaybe<OrderByInput>;
  page?: InputMaybe<Scalars['NonNegativeInt']['input']>;
  pageSize?: InputMaybe<Scalars['NonNegativeInt']['input']>;
  searchString?: InputMaybe<Scalars['String']['input']>;
};

export type SearchClinicProductsResult = {
  __typename?: 'SearchClinicProductsResult';
  count: Scalars['NonNegativeInt']['output'];
  products: Array<Product>;
};

export type SearchCliniciansInput = {
  authority_level?: InputMaybe<AuthorityLevel>;
  clinic_id?: InputMaybe<Scalars['ID']['input']>;
  is_active?: InputMaybe<Scalars['Boolean']['input']>;
  name?: InputMaybe<Scalars['String']['input']>;
  pms?: InputMaybe<PracticeManagementSystem>;
  pms_id?: InputMaybe<Scalars['String']['input']>;
};

export type SearchPimsReminderTypesForClinicOptions = {
  onlyActive?: InputMaybe<Scalars['Boolean']['input']>;
  orderBy?: InputMaybe<OrderByInput>;
  page?: InputMaybe<Scalars['NonNegativeInt']['input']>;
  pageSize?: InputMaybe<Scalars['NonNegativeInt']['input']>;
  searchString?: InputMaybe<Scalars['String']['input']>;
};

export type SegmentFilter = {
  __typename?: 'SegmentFilter';
  foreign_table?: Maybe<Scalars['String']['output']>;
  group?: Maybe<Scalars['String']['output']>;
  parameters: Array<QueryFilter>;
};

export type SegmentFilterInput = {
  foreign_table?: InputMaybe<Scalars['String']['input']>;
  group?: InputMaybe<Scalars['String']['input']>;
  parameters: Array<QueryInput>;
};

export type SegmentPersonalizationProperties = {
  accent_color?: InputMaybe<Scalars['String']['input']>;
  appointment_clinician_name?: InputMaybe<Scalars['String']['input']>;
  appointment_drop_off_time?: InputMaybe<Scalars['NonNegativeInt']['input']>;
  appointment_id?: InputMaybe<Scalars['ID']['input']>;
  appointment_minutes?: InputMaybe<Scalars['NonNegativeInt']['input']>;
  appointment_service_name?: InputMaybe<Scalars['String']['input']>;
  appointment_start_time?: InputMaybe<Scalars['NonNegativeInt']['input']>;
  appointment_time?: InputMaybe<Scalars['String']['input']>;
  client_address?: InputMaybe<Scalars['String']['input']>;
  client_email?: InputMaybe<Scalars['String']['input']>;
  client_first_name?: InputMaybe<Scalars['String']['input']>;
  client_id?: InputMaybe<Scalars['ID']['input']>;
  client_last_name?: InputMaybe<Scalars['String']['input']>;
  client_phone?: InputMaybe<Scalars['String']['input']>;
  client_previous_doctor?: InputMaybe<Scalars['String']['input']>;
  clinic_address?: InputMaybe<Scalars['String']['input']>;
  clinic_color?: InputMaybe<Scalars['String']['input']>;
  clinic_email?: InputMaybe<Scalars['String']['input']>;
  clinic_logo?: InputMaybe<Scalars['String']['input']>;
  clinic_name?: InputMaybe<Scalars['String']['input']>;
  clinic_phone?: InputMaybe<Scalars['String']['input']>;
  clinic_slug?: InputMaybe<Scalars['String']['input']>;
  clinic_website?: InputMaybe<Scalars['String']['input']>;
  custom_merge_tags?: InputMaybe<Scalars['JSON']['input']>;
  patient_gender?: InputMaybe<AnimalGender>;
  patient_id?: InputMaybe<Scalars['ID']['input']>;
  patient_names?: InputMaybe<Array<Scalars['String']['input']>>;
  patient_previous_doctor?: InputMaybe<Scalars['String']['input']>;
  pims_reminder_description?: InputMaybe<Scalars['String']['input']>;
  pims_reminder_due_date?: InputMaybe<Scalars['NonNegativeInt']['input']>;
  primary_color?: InputMaybe<Scalars['String']['input']>;
  product_name?: InputMaybe<Scalars['String']['input']>;
};

export type SendClientLinkInput = {
  client_id: Scalars['ID']['input'];
  email_id?: InputMaybe<Scalars['ID']['input']>;
  method: VerificationMethod;
  phone_id?: InputMaybe<Scalars['ID']['input']>;
};

export type SendClinicAgentMessageInput = {
  /** Enterprise tenant: act on this group's constituent clinics. */
  clinicGroupId?: InputMaybe<Scalars['ID']['input']>;
  /** Clinic tenant. Pass exactly one of clinicId / clinicGroupId. */
  clinicId?: InputMaybe<Scalars['ID']['input']>;
  /** Omit on the first turn; pass back to continue. */
  conversationId?: InputMaybe<Scalars['ID']['input']>;
  /** User's prompt. Must be non-empty. */
  message: Scalars['String']['input'];
  /** Optional current dashboard screen context. */
  uiContext?: InputMaybe<ClinicAgentUiContextInput>;
};

export enum SendConfirmationsTo {
  All = 'All',
  ChckupApptsOnly = 'ChckupApptsOnly',
  None = 'None'
}

export type SendNotificationInput = {
  chat_id: Scalars['ID']['input'];
  clinic_timezone: Scalars['String']['input'];
  segments: Array<GroupedNotificationSegment>;
};

export type SendSupportBotMessageInput = {
  /**
   * Optional file attachments. See SupportBotMessageAttachmentInput.
   * Empty / omitted is the no-attachments code path. When non-empty,
   * `message` may be empty.
   */
  attachments?: InputMaybe<Array<SupportBotMessageAttachmentInput>>;
  /**
   * Omit on the first turn. To continue an existing conversation, pass
   * the id from a prior `SupportBotMessageStarted.conversationId` (or
   * from `mySupportBotConversations`).
   */
  conversationId?: InputMaybe<Scalars['ID']['input']>;
  /**
   * User's prompt text. May be the empty string when at least one
   * attachment is provided ("look at this screenshot"-style turns).
   */
  message: Scalars['String']['input'];
  /**
   * Optional per-turn Cursor model. See SupportBotModelInput.
   * Omitted → the bot's committed default (currently Grok 4.6 High Fast).
   */
  model?: InputMaybe<SupportBotModelInput>;
  /** Optional per-turn cutoff overrides. See SupportBotTimeoutOverridesInput. */
  timeoutOverrides?: InputMaybe<SupportBotTimeoutOverridesInput>;
};

export type SendTestEmailContent = {
  body: Scalars['String']['input'];
  repeating_body?: InputMaybe<Scalars['String']['input']>;
  subject: Scalars['String']['input'];
};

/**
 * Bookable clinic service. Fields marked @deprecated are stored but unused —
 * changing them has no effect on booking or scheduling.
 * "No dashboard control" means there is no dedicated service-editor toggle.
 * New-vs-returning and species gating use scheduling rules, not the
 * deprecated allow_new / allow_returning / excluded_species fields.
 */
export type Service = {
  __typename?: 'Service';
  /**
   * Overrides the consent-step checkbox label for
   * more_info_action_required (default: I have read and agree…).
   */
  action_required_acknowledgement_text?: Maybe<Scalars['String']['output']>;
  /** @deprecated No longer read by booking logic. New-vs-returning gating is handled entirely by scheduling rules (client_type/patient_type). Retained for backwards-compat only. */
  allow_new?: Maybe<Scalars['Boolean']['output']>;
  /** @deprecated No longer read by booking logic. New-vs-returning gating is handled entirely by scheduling rules (client_type/patient_type). Retained for backwards-compat only. */
  allow_returning?: Maybe<Scalars['Boolean']['output']>;
  /**
   * Extra PMS appointment-type ids this service may book into (planning
   * guides / adjusted availability), merged with pms_appt_type.pms_id.
   * Dashboard control shown for ezyVet, Shepherd, Cornerstone.
   */
  allowed_appt_type_pms_ids?: Maybe<Array<Scalars['String']['output']>>;
  /**
   * Unused. Clinician authority-level gating is not read from this field.
   * @deprecated Unused. Not read by booking. Retained for backwards-compat only.
   */
  authorized_levels?: Maybe<Array<AuthorityLevel>>;
  /**
   * Unused. Service-level hours are not used for slot generation.
   * Availability comes from clinic/clinician/room hours, drop_off_hours,
   * and PMS adj-avail / planning guides.
   * @deprecated Unused. Not read by scheduling. Retained for backwards-compat only.
   */
  availability?: Maybe<AvailabilityHours>;
  /** Clinic that owns this service. */
  clinic?: Maybe<Clinic>;
  /**
   * Dashboard calendar/schedule color for appointments of this service.
   * Does not change the PMS appointment-reason color.
   */
  color?: Maybe<Scalars['String']['output']>;
  created_at: Scalars['Timestamp']['output'];
  /**
   * PMS appointment-notes template for this service. Overrides
   * clinic.custom_appointment_notes_template. No service-editor UI —
   * clinic-level templates live in Booking Settings.
   */
  custom_appointment_notes_template?: Maybe<Scalars['String']['output']>;
  /**
   * PMS new-client notes template for this service. Overrides
   * clinic.custom_new_client_notes_template. No service-editor UI.
   */
  custom_new_client_notes_template?: Maybe<Scalars['String']['output']>;
  /**
   * PMS new-patient notes template for this service. Overrides
   * clinic.custom_new_patient_notes_template. No service-editor UI.
   */
  custom_new_patient_notes_template?: Maybe<Scalars['String']['output']>;
  /**
   * Optional room stored on the service and included on Connect appointment
   * payloads so the PMS calendar can land in that room after write.
   * Online booking does not auto-assign from this field — clients still
   * go through clinician/room preference when those resources are in use.
   */
  default_room?: Maybe<Room>;
  /**
   * Optional short description. Not shown in portal/widget booking UI.
   * Used as dashboard search subtitle and AI tool context. No editor field
   * except on duplicate.
   */
  description?: Maybe<Scalars['String']['output']>;
  /**
   * When set, the client picks a drop-off time from 15-minute intervals
   * inside these hours; the clinic assigns the actual appointment time.
   * If enabled but a day has no valid drop-off times, that day returns no
   * slots. Distinct from display-only drop_off_time / pick_up_time strings.
   */
  drop_off_hours?: Maybe<AvailabilityHours>;
  /**
   * Unused. Drop-off lead time is not read from this field. No dashboard control.
   * @deprecated Unused. Not read by booking. Retained for backwards-compat only.
   */
  drop_off_minutes_before?: Maybe<Scalars['NonNegativeInt']['output']>;
  /** Display-only drop-off time shown on appointment details (e.g. 8:30 AM). Not scheduling logic — use drop_off_hours for that. */
  drop_off_time?: Maybe<Scalars['String']['output']>;
  /**
   * Appointment length in minutes — drives conflict detection, slot
   * spacing, and appointment.minutes. Per-room duration_override wins
   * for room-scheduled resources, then per-clinician duration_override,
   * in v2 scheduling. Portal/widget fallback if unset:
   * clinic.time_slot_minutes then 30. AI tools fall back to
   * clinic.base_schedule_duration. Distinct from time_slot_minutes (grid).
   */
  duration?: Maybe<Scalars['NonNegativeInt']['output']>;
  /**
   * When true, appointments of this service are hidden from the
   * pet-owner portal (home next-visit card, appointments list, pet
   * appointments tab) and from the confirm-attendance page's
   * other-appointments carousel. Direct links to a specific appointment
   * still resolve. Distinct from is_active (online booking) and from
   * reminder exclusions (customer segments).
   */
  exclude_from_portal: Scalars['Boolean']['output'];
  /**
   * Unused. Species gating is handled by scheduling rules, not this field.
   * @deprecated Unused. Species gating is handled by scheduling rules. Retained for backwards-compat only.
   */
  excluded_species?: Maybe<Array<Species>>;
  /**
   * Unused. Follow-up chaining is not driven by this field. No dashboard control.
   * @deprecated Unused. Not read by booking. Retained for backwards-compat only.
   */
  follow_up_services?: Maybe<Array<Service>>;
  /**
   * Unused. Follow-up step timing is not driven by this field. No dashboard control.
   * @deprecated Unused. Not read by booking. Retained for backwards-compat only.
   */
  follow_up_settings?: Maybe<FollowUpSettings>;
  /**
   * When true, hide clinician preference for this service and auto-assign.
   * OR'd with clinic.hide_clinician_preference — either true is enough.
   */
  hide_clinician_preference: Scalars['Boolean']['output'];
  /** Service row id. */
  id: Scalars['ID']['output'];
  /**
   * When false, hidden from normal online booking. Widget service
   * allowlists can still surface an inactive service on a specific embed.
   * Reschedule also requires is_active (and is_reschedule_allowed).
   */
  is_active?: Maybe<Scalars['Boolean']['output']>;
  /**
   * When true, appointments and time blocks of this service count as closed
   * for fill-rate and block other bookings. Hardcoded blocking names also
   * apply. Clinic.non_blocking_services can exempt empty/time-block rows
   * of listed services (edited via Is non-blocking when empty on this
   * service — that writes the clinic list, not this flag).
   */
  is_blocking: Scalars['Boolean']['output'];
  /**
   * When false, clients cannot cancel this service online. Clinic
   * cancellation_buffer_minutes is a separate time cutoff that disables
   * the button near start.
   */
  is_cancellation_allowed: Scalars['Boolean']['output'];
  /**
   * When multiple services share a PMS appt type, the primary wins on
   * inbound PMS sync for this clinic. Important for multi-location /
   * shared PMS DBs so the wrong-clinic service is not assigned.
   */
  is_primary_for_appt_type: Scalars['Boolean']['output'];
  /**
   * When false, clients cannot reschedule this service online (portal and
   * server both check). Also requires is_active, clinic scheduling enabled,
   * and appointment not cancelled/past. Clinic.reschedule_buffer_minutes
   * is a separate time cutoff. Distinct from unused clinic.allow_reschedule.
   */
  is_reschedule_allowed: Scalars['Boolean']['output'];
  /**
   * Unused. Not read by booking or search. No dashboard control.
   * @deprecated Unused. Not read by booking or search. Retained for backwards-compat only.
   */
  keywords?: Maybe<Scalars['String']['output']>;
  /**
   * Max appointments of this service per clinic calendar day (0 = unlimited).
   * When reached, that day returns no slots. Skipped when re-checking slots
   * during a reschedule of an existing visit of this service.
   */
  max_per_day?: Maybe<Scalars['NonNegativeInt']['output']>;
  /**
   * Max appointments of this service starting in the same clock hour
   * (12:45 counts toward the 12:00 bucket). 0/unset = unlimited.
   * No service-editor UI — GraphQL/DB only. Can be skipped via scheduling
   * override skip_service_max_per_hour.
   */
  max_per_hour?: Maybe<Scalars['NonNegativeInt']['output']>;
  /**
   * Patient must be at most this many days old to book (0 = no maximum).
   * Same enforcement as minimum_patient_age_in_days.
   */
  maximum_patient_age_in_days?: Maybe<Scalars['NonNegativeInt']['output']>;
  /**
   * Patient must be at least this many days old to book (0 = no minimum).
   * Portal disables the service card; AI booking requirements also enforce.
   * Uses patient DOB when available.
   */
  minimum_patient_age_in_days?: Maybe<Scalars['NonNegativeInt']['output']>;
  /**
   * Extra rich-text info shown when the client selects this service and
   * again on the review step.
   */
  more_info?: Maybe<Scalars['String']['output']>;
  /**
   * Consent/terms the client must agree to before completing booking.
   * Inserts a Consent step. Distinct from pre_confirmation_checklist
   * (used later on the appointment confirm-attendance page).
   */
  more_info_action_required?: Maybe<Scalars['String']['output']>;
  /**
   * Client-facing label in the booking service picker, appointment details,
   * PMS notes ({{appointment_service}}), and AI tools. Copied onto
   * appointment.service_name at book time — renaming later does not
   * rewrite existing appointments.
   */
  name?: Maybe<Scalars['String']['output']>;
  /**
   * When true, only book this service into PMS adjusted-availability /
   * planning guides. OR'd with clinic.only_use_adj_avail_guides. Toggle in
   * the service editor for ezyVet, Shepherd, and Cornerstone (clinic toggle
   * in Booking Settings). Skipped for Cornerstone clinicians and official
   * ezyVet API.
   */
  only_use_adj_avail_guides: Scalars['Boolean']['output'];
  /**
   * Intended display sort (lower first). Not read by the dashboard services
   * list (sorts by name) or by booking UI (categories have their own order).
   * No service-editor control.
   */
  order?: Maybe<Scalars['NonNegativeInt']['output']>;
  /** Display-only pick-up time shown on appointment details (e.g. 5:00 PM). Not scheduling logic. */
  pick_up_time?: Maybe<Scalars['String']['output']>;
  /**
   * Primary PMS appointment type/reason written when this service is booked
   * and used to map inbound sync appointments to this service. Combined
   * with allowed_appt_type_pms_ids when fetching planning-guide
   * availability. Required for some PMS writes (e.g. Instinct).
   */
  pms_appt_type?: Maybe<PmsApptType>;
  /**
   * Loyalty points awarded when an appointment of this service completes,
   * if clinic loyalty is enabled. Distinct from invoice loyalty
   * (clinic.should_award_loyalty_for_invoices).
   */
  points: Scalars['NonNegativeInt']['output'];
  /**
   * Checklist on the appointment confirmation (confirm attendance) page.
   * Required items must be acknowledged before the client can confirm.
   * Not shown during initial booking.
   */
  pre_confirmation_checklist?: Maybe<Array<ServicePreConfirmationItem>>;
  /**
   * Optional deposit/price charged before booking can complete. Price is
   * in cents. client_type null = all clients must pay; New/Returning
   * scopes who is charged. Adds a Payment step; Instant entry captures
   * Stripe when price is set.
   */
  pricing?: Maybe<ServicePricing>;
  /**
   * Unused. Recurring-service scheduling is not driven by this field. No dashboard control.
   * @deprecated Unused. Not read by booking or scheduling. Retained for backwards-compat only.
   */
  recurring?: Maybe<RecurringSettings>;
  /**
   * Unused. Required-room is not enforced during booking or PMS write.
   * @deprecated Unused. Not read by booking or PMS write. Retained for backwards-compat only.
   */
  required_room?: Maybe<Room>;
  /**
   * Unused. Reserved daily slots are not enforced from this field.
   * @deprecated Unused. Not read by scheduling. Retained for backwards-compat only.
   */
  reserved_per_day?: Maybe<Scalars['NonNegativeInt']['output']>;
  /**
   * Unused. No scheduling logic reads a service-level buffer from this field.
   * @deprecated Unused. Not read by scheduling. Retained for backwards-compat only.
   */
  scheduling_buffer_minutes?: Maybe<Scalars['NonNegativeInt']['output']>;
  /**
   * Furthest this service can be booked, in minutes from now. Overrides
   * clinic (and widget) defaults. Same cascade as min.
   */
  scheduling_max_minutes_away?: Maybe<Scalars['NonNegativeInt']['output']>;
  /**
   * Soonest this service can be booked, in minutes from now. Overrides
   * clinic (and widget) defaults. Cascade: service → widget → clinic →
   * defaults.
   */
  scheduling_min_minutes_away?: Maybe<Scalars['NonNegativeInt']['output']>;
  /**
   * Categories this service belongs to. Simple mode: which category tile
   * lists this service. Detailed mode: optional category filter before
   * picking the service. Clinic.is_using_detailed_services chooses the mode.
   */
  service_service_categories?: Maybe<Array<ServiceServiceCategory>>;
  /**
   * Legacy Healthy/Sick/Other tags. Not read by current booking or
   * scheduling. Simple (non-detailed) mode filters by
   * service_service_categories under clinic.is_using_detailed_services
   * false. Dashboard Types UI is commented out; still saved as a default.
   * @deprecated Unused. Simple booking uses service categories (service_service_categories), not these tags. Retained for backwards-compat only.
   */
  service_types: Array<ServiceType>;
  /**
   * Forms the client must complete when booking this service. Inserts a
   * Forms step; submit stays disabled until required forms are done.
   */
  services_forms?: Maybe<Array<ServiceForm>>;
  updated_at: Scalars['Timestamp']['output'];
  /**
   * When true and a patient is already selected, pre-select that patient's
   * most recent clinician at this clinic.
   */
  use_previous_doctor: Scalars['Boolean']['output'];
  /**
   * Allowed minute-of-hour start offsets for this service (e.g. [0, 30]).
   * ANDed with clinic and room/clinician lists — all configured lists
   * must pass. Empty = no extra restriction at service level.
   */
  valid_booking_interval_minutes?: Maybe<Array<Scalars['NonNegativeInt']['output']>>;
};

export type ServiceCategory = {
  __typename?: 'ServiceCategory';
  clinic: Clinic;
  confirmation_message?: Maybe<Scalars['String']['output']>;
  created_at: Scalars['NonNegativeInt']['output'];
  description: Scalars['String']['output'];
  icon?: Maybe<ServiceCategoryIcon>;
  id: Scalars['ID']['output'];
  order: Scalars['NonNegativeInt']['output'];
  requires_confirmation: Scalars['Boolean']['output'];
  title: Scalars['String']['output'];
  updated_at: Scalars['NonNegativeInt']['output'];
};

export enum ServiceCategoryIcon {
  Bandage = 'Bandage',
  Heart = 'Heart',
  House = 'House',
  Mask = 'Mask',
  Paw = 'Paw',
  Stethoscope = 'Stethoscope',
  Syringe = 'Syringe'
}

export type ServiceForm = {
  __typename?: 'ServiceForm';
  client_type?: Maybe<ClientTypeEnum>;
  created_at: Scalars['Timestamp']['output'];
  form: Form;
  id: Scalars['ID']['output'];
  is_required_before_booking: Scalars['Boolean']['output'];
  is_required_before_confirming: Scalars['Boolean']['output'];
  service: Service;
  updated_at: Scalars['Timestamp']['output'];
};

export type ServiceOrder = {
  __typename?: 'ServiceOrder';
  order: Scalars['NonNegativeInt']['output'];
  service_id: Scalars['ID']['output'];
};

export type ServiceOrderInput = {
  order: Scalars['NonNegativeInt']['input'];
  service_id: Scalars['ID']['input'];
};

export type ServicePreConfirmationItem = {
  __typename?: 'ServicePreConfirmationItem';
  description?: Maybe<Scalars['String']['output']>;
  required?: Maybe<Scalars['Boolean']['output']>;
  title: Scalars['String']['output'];
};

export type ServicePreConfirmationItemInput = {
  description?: InputMaybe<Scalars['String']['input']>;
  required?: InputMaybe<Scalars['Boolean']['input']>;
  title: Scalars['String']['input'];
};

export type ServicePricing = {
  __typename?: 'ServicePricing';
  /** Who must pay this price. Null = all clients; New or Returning scopes the deposit. */
  client_type?: Maybe<ClientTypeEnum>;
  currency: Scalars['Currency']['output'];
  /** Amount in cents. */
  price: Scalars['PositiveInt']['output'];
  /** OneTime (typical deposit) vs PerDay. */
  type: ServicePricingType;
};

export enum ServicePricingType {
  OneTime = 'OneTime',
  PerDay = 'PerDay'
}

export type ServiceServiceCategory = {
  __typename?: 'ServiceServiceCategory';
  created_at: Scalars['NonNegativeInt']['output'];
  id: Scalars['ID']['output'];
  service: Service;
  service_category: ServiceCategory;
  updated_at: Scalars['NonNegativeInt']['output'];
};

export enum ServiceType {
  Healthy = 'Healthy',
  Other = 'Other',
  Sick = 'Sick'
}

export type ShareVaccineRecordsInput = {
  /** Recipient email (a groomer, boarder, or anyone asking). */
  email?: InputMaybe<Scalars['String']['input']>;
  patientId: Scalars['ID']['input'];
  /** Recipient SMS number. */
  phone?: InputMaybe<Scalars['String']['input']>;
};

export type ShareVaccineRecordsResult = {
  __typename?: 'ShareVaccineRecordsResult';
  /** Delivery channel when sent: "sms", "email", or "sms_and_email". */
  channel?: Maybe<Scalars['String']['output']>;
  overdue_count?: Maybe<Scalars['Int']['output']>;
  record_count?: Maybe<Scalars['Int']['output']>;
  /** # One of: "sent", "no_records", "failed". */
  status: Scalars['String']['output'];
};

export enum SpecialMetricModifierType {
  NewClients = 'NewClients',
  NewPatients = 'NewPatients',
  ReturningClients = 'ReturningClients',
  ReturningPatients = 'ReturningPatients'
}

export enum Species {
  Amphibian = 'Amphibian',
  Bird = 'Bird',
  Cat = 'Cat',
  Cow = 'Cow',
  Deer = 'Deer',
  Dog = 'Dog',
  Donkey = 'Donkey',
  Ferret = 'Ferret',
  Fish = 'Fish',
  Goat = 'Goat',
  Horse = 'Horse',
  Lion = 'Lion',
  Lizard = 'Lizard',
  Marsupial = 'Marsupial',
  Other = 'Other',
  Panther = 'Panther',
  Pig = 'Pig',
  PocketPet = 'PocketPet',
  Primate = 'Primate',
  Rabbit = 'Rabbit',
  Reptile = 'Reptile',
  Rodent = 'Rodent',
  Sheep = 'Sheep',
  Snake = 'Snake',
  Turtle = 'Turtle',
  Wolf = 'Wolf'
}

export enum StartTimeOrdering {
  Asc = 'asc',
  Desc = 'desc'
}

export type StripeAccountInfo = {
  __typename?: 'StripeAccountInfo';
  future_requirements?: Maybe<StripeAccountRequirements>;
  is_onboarded: Scalars['Boolean']['output'];
  login_link?: Maybe<Scalars['URL']['output']>;
  onboarding_link?: Maybe<Scalars['URL']['output']>;
  requirements?: Maybe<StripeAccountRequirements>;
};

export type StripeAccountRequirements = {
  __typename?: 'StripeAccountRequirements';
  current_deadline?: Maybe<Scalars['NonNegativeInt']['output']>;
  currently_due?: Maybe<Array<Maybe<Scalars['String']['output']>>>;
  disabled_reason?: Maybe<Scalars['String']['output']>;
  eventually_due?: Maybe<Array<Maybe<Scalars['String']['output']>>>;
  past_due?: Maybe<Array<Maybe<Scalars['String']['output']>>>;
  pending_verification?: Maybe<Array<Maybe<Scalars['String']['output']>>>;
};

export enum StripeAccountType {
  Custom = 'custom',
  Express = 'express',
  Standard = 'standard'
}

export type StripePaymentIntent = {
  __typename?: 'StripePaymentIntent';
  amount: Scalars['Int']['output'];
  client_secret?: Maybe<Scalars['String']['output']>;
  id: Scalars['ID']['output'];
};

export type SubmitAppointmentInput = {
  acquisition_source?: InputMaybe<AcquisitionSourceInput>;
  /**
   * Booking-flow session ('booking_flow_sessions.id') this booking came from. The server marks
   * it completed and marks the session's lead contact (if any) converted.
   */
  booking_flow_session_id?: InputMaybe<Scalars['String']['input']>;
  click_id?: InputMaybe<Scalars['String']['input']>;
  client_address?: InputMaybe<AddressInput>;
  client_birthday?: InputMaybe<Scalars['Float']['input']>;
  client_email?: InputMaybe<Scalars['String']['input']>;
  client_first_name?: InputMaybe<Scalars['String']['input']>;
  client_forms?: InputMaybe<Array<CreateClientFormInput>>;
  client_id?: InputMaybe<Scalars['ID']['input']>;
  client_last_name?: InputMaybe<Scalars['String']['input']>;
  client_notes?: InputMaybe<Scalars['String']['input']>;
  client_phone?: InputMaybe<Scalars['String']['input']>;
  client_title?: InputMaybe<Scalars['String']['input']>;
  clinic: Scalars['ID']['input'];
  clinician?: InputMaybe<Scalars['ID']['input']>;
  drop_off_time?: InputMaybe<Scalars['NonNegativeInt']['input']>;
  from_widget?: InputMaybe<Scalars['String']['input']>;
  is_clinician_auto_assigned?: InputMaybe<Scalars['Boolean']['input']>;
  is_new_client?: InputMaybe<Scalars['Boolean']['input']>;
  is_new_patient?: InputMaybe<Scalars['Boolean']['input']>;
  minutes: Scalars['NonNegativeInt']['input'];
  origin: EntityOrigin;
  patient_birthday?: InputMaybe<Scalars['Float']['input']>;
  patient_breed?: InputMaybe<Scalars['String']['input']>;
  patient_clinic_breed?: InputMaybe<Scalars['ID']['input']>;
  patient_clinic_species?: InputMaybe<Scalars['ID']['input']>;
  patient_color?: InputMaybe<Scalars['String']['input']>;
  patient_gender?: InputMaybe<AnimalGender>;
  patient_id?: InputMaybe<Scalars['ID']['input']>;
  patient_is_fixed?: InputMaybe<Scalars['Boolean']['input']>;
  patient_name?: InputMaybe<Scalars['String']['input']>;
  patient_resuscitate?: InputMaybe<Scalars['Boolean']['input']>;
  patient_weight?: InputMaybe<Scalars['NonNegativeFloat']['input']>;
  previous_clinic_name?: InputMaybe<Scalars['String']['input']>;
  referrer?: InputMaybe<ReferrerInput>;
  referring_vet_pms_id?: InputMaybe<Scalars['String']['input']>;
  room?: InputMaybe<Scalars['ID']['input']>;
  service?: InputMaybe<Scalars['ID']['input']>;
  service_name?: InputMaybe<Scalars['String']['input']>;
  start_time: Scalars['NonNegativeInt']['input'];
  stripe_payment_intent_id?: InputMaybe<Scalars['String']['input']>;
  widget?: InputMaybe<Scalars['ID']['input']>;
  widget_source?: InputMaybe<Scalars['String']['input']>;
};

export type SuggestedResponse = {
  __typename?: 'SuggestedResponse';
  response: Scalars['String']['output'];
  responses_left: Scalars['Int']['output'];
};

export enum SupabaseTableGql {
  Appointments = 'Appointments',
  Breeds = 'Breeds',
  Clients = 'Clients',
  ClinicSpecies = 'ClinicSpecies',
  Clinicians = 'Clinicians',
  InvoiceItems = 'InvoiceItems',
  Invoices = 'Invoices',
  Patients = 'Patients',
  Services = 'Services'
}

/**
 * Kind of file attached to a support-bot message. Currently `image` is
 * the only supported value — kept as an enum (not a String) so adding new
 * kinds requires a schema bump that downstream clients have to handle
 * explicitly rather than silently encountering an unknown discriminator.
 */
export enum SupportBotAttachmentKind {
  Image = 'image'
}

/**
 * A persisted conversation between a SuperAdmin and the support bot.
 * Mirrored to Redis with a sliding TTL (default 7 days from last activity);
 * expired conversations disappear from `mySupportBotConversations` and
 * return null from `supportBotConversation`.
 */
export type SupportBotConversation = {
  __typename?: 'SupportBotConversation';
  createdAt: Scalars['Timestamp']['output'];
  id: Scalars['ID']['output'];
  messages: Array<SupportBotMessage>;
  /**
   * Identity of the SuperAdmin who created this conversation. Used by the
   * dashboard to label whose chat it is and to drive the "filter by user"
   * control. Null only if the owner record can't be resolved.
   */
  owner?: Maybe<SupportBotConversationOwner>;
  /**
   * Set while an agent turn is in flight: the runId of the unfinished
   * run. The dashboard polls `supportBotRunStatus` for this value
   * until the run terminates. Cleared by the server once the run
   * reaches a terminal state and the assistant message (or error
   * marker) has been appended to `messages`.
   *
   * Persists across browser sessions, so a user who closes the tab
   * mid-flight and re-opens the conversation later automatically
   * resumes polling and sees the result.
   */
  pendingRunId?: Maybe<Scalars['ID']['output']>;
  /**
   * Auto-derived from the first user message; used as the list-row label
   * on the dashboard.
   */
  title: Scalars['String']['output'];
  /** Bumped on every turn; drives newest-first ordering of the list. */
  updatedAt: Scalars['Timestamp']['output'];
};

/**
 * The creator of a SupportBotConversation, resolved from the users table.
 * Lets the dashboard show whose chat it is and build the user filter.
 */
export type SupportBotConversationOwner = {
  __typename?: 'SupportBotConversationOwner';
  /** Null when no email is on file. */
  email?: Maybe<Scalars['String']['output']>;
  /** The owner's uid (users.id). */
  id: Scalars['ID']['output'];
  /** Display name (first + last); null when no name is on file. */
  name?: Maybe<Scalars['String']['output']>;
};

/**
 * A single message in a SupportBotConversation. Tool calls and intermediate
 * "thinking" messages are NOT stored — only the user-visible turn.
 */
export type SupportBotMessage = {
  __typename?: 'SupportBotMessage';
  /**
   * Files the user attached to this turn. Empty for assistant messages
   * and for legacy user records persisted before image upload shipped.
   * Currently image-only; the kind field makes it easy to extend
   * without a breaking change.
   */
  attachments: Array<SupportBotMessageAttachment>;
  content: Scalars['String']['output'];
  /**
   * When `status: partial`, the reason the cutoff fired. Currently
   * `soft_deadline_time` or `soft_deadline_tokens`. Null otherwise.
   * Returned as a String (not enum) so adding new cutoff reasons on the
   * bot side doesn't break old clients.
   */
  cutoffReason?: Maybe<Scalars['String']['output']>;
  role: SupportBotMessageRole;
  /**
   * Status of this message. `completed` is the happy path. `partial`
   * means the bot's soft deadline / token budget fired and the response
   * is a checkpoint summary; the user can send "continue" to resume.
   * Only meaningful on assistant messages. Null on user messages and on
   * legacy records persisted before the soft-deadline feature shipped
   * (treat null as `completed` for backward compat).
   */
  status?: Maybe<SupportBotMessageStatus>;
  timestamp: Scalars['Timestamp']['output'];
};

/**
 * One file attached to a user message. Stored as a publicly-fetchable
 * URL (Firebase Storage in the current deploy) rather than inline bytes
 * so the conversation history stays small and the Cursor SDK can
 * dereference the URL server-side when constructing the agent's
 * multimodal input.
 */
export type SupportBotMessageAttachment = {
  __typename?: 'SupportBotMessageAttachment';
  /**
   * Original filename. For diagnostics / display only; the agent
   * fetches the URL, not by filename.
   */
  filename?: Maybe<Scalars['String']['output']>;
  /** Pixel height, when known. See `width`. */
  height?: Maybe<Scalars['Int']['output']>;
  /**
   * Discriminator for the kind of attachment. Today always `image`;
   * future kinds (audio, pdf) widen this enum.
   */
  kind: SupportBotAttachmentKind;
  /**
   * MIME type of the underlying file (e.g. `image/png`). Validated
   * server-side against an allow-list of supported types.
   */
  mimeType: Scalars['String']['output'];
  /**
   * Publicly-fetchable URL the support bot will GET when invoking the
   * agent. Today this is always a Firebase Storage download URL with
   * an embedded access token.
   */
  url: Scalars['String']['output'];
  /**
   * Pixel width, when known. Captured at upload time so the dashboard
   * can lay out thumbnails without an extra network hop.
   */
  width?: Maybe<Scalars['Int']['output']>;
};

/**
 * One file attached to an outgoing user message. The dashboard uploads
 * the bytes to a publicly-fetchable storage location (Firebase Storage
 * today) BEFORE calling this mutation and passes only the resulting
 * download URL here — the server never sees the raw bytes, which keeps
 * the GraphQL request body small and avoids bloating Redis with image
 * payloads.
 *
 * Limits enforced by the server: max 5 attachments per turn, max 10 MB
 * per file (the dashboard validates before uploading), allow-list of
 * MIME types image/png|jpeg|webp|gif.
 */
export type SupportBotMessageAttachmentInput = {
  /** Original filename; trimmed to 255 chars by the server. */
  filename?: InputMaybe<Scalars['String']['input']>;
  /** Pixel height, when known. See `width`. */
  height?: InputMaybe<Scalars['Int']['input']>;
  /** Discriminator. Today always `image`. */
  kind: SupportBotAttachmentKind;
  /**
   * MIME of the underlying file. Validated against the server's
   * allow-list before forwarding to the bot.
   */
  mimeType: Scalars['String']['input'];
  /**
   * Publicly-fetchable URL of the uploaded file. Must reach the
   * bot's host allow-list (currently `firebasestorage.googleapis.com`).
   */
  url: Scalars['String']['input'];
  /**
   * Pixel width, when known. Optional but recommended — the bot
   * forwards it to the Cursor SDK as a layout hint.
   */
  width?: InputMaybe<Scalars['Int']['input']>;
};

export enum SupportBotMessageRole {
  Assistant = 'assistant',
  User = 'user'
}

/**
 * Result of a successful `sendSupportBotMessage` mutation. The actual
 * assistant text comes later via `supportBotRunStatus` polling — this
 * response just gives the dashboard the identifiers it needs to start
 * polling and the conversation record reflecting the just-appended user
 * message.
 */
export type SupportBotMessageStarted = {
  __typename?: 'SupportBotMessageStarted';
  /**
   * Conversation record AS OF the user-message append. Includes the
   * new `pendingRunId` so the dashboard can render the pending state
   * without an extra round trip.
   */
  conversation: SupportBotConversation;
  /**
   * Cursor-SDK conversation id. Stable across the conversation; pass
   * it back to `sendSupportBotMessage` (in `SendSupportBotMessageInput.conversationId`)
   * to continue this conversation on the next turn.
   */
  conversationId: Scalars['ID']['output'];
  /** Run id to feed into `supportBotRunStatus` until terminal. */
  runId: Scalars['ID']['output'];
  /**
   * Always `running` on a successful start. Present so the dashboard
   * can switch on a single status field uniformly across mutation +
   * snapshot responses.
   */
  status: SupportBotRunStatus;
};

export enum SupportBotMessageStatus {
  Completed = 'completed',
  Partial = 'partial'
}

/**
 * Per-turn Cursor model override. `id` must be a base catalog id
 * (e.g. `grok-4.6`, `composer-2.5`) — IDE picker slugs like
 * `cursor-grok-4.6-high-fast` are rejected by the bot. Omit to use
 * the bot's committed default.
 */
export type SupportBotModelInput = {
  /**
   * Cursor base model id. Any catalog id is accepted; the SDK
   * rejects unknown ids at Agent.create / resume time.
   */
  id: Scalars['String']['input'];
  /**
   * Optional parameter pairs (effort, fast, reasoning, context, …).
   * Different models expose different params — send only what that
   * model accepts.
   */
  params?: InputMaybe<Array<SupportBotModelParamInput>>;
};

/**
 * One Cursor model parameter (`effort=high`, `fast=true`, …).
 * Valid `id` / `value` pairs come from the bot's `yarn list-models`.
 */
export type SupportBotModelParamInput = {
  id: Scalars['String']['input'];
  value: Scalars['String']['input'];
};

/**
 * Snapshot of an agent run, returned on every `supportBotRunStatus`
 * poll. Designed so the dashboard renders identically from a single
 * record while the run is in flight ("polled streaming") and after it
 * terminates.
 *
 * Field availability by status:
 *   - `running`:    runId, conversationId, status, startedAt,
 *                     assistantTextSoFar, toolCallCount, approxTokens
 *   - `completed`:  + response, durationMs, finishedAt, conversation
 *   - `partial`:    + response, durationMs, finishedAt, cutoffReason,
 *                     conversation
 *   - `run_error` /
 *     `timeout` /
 *     `not_found`:  + errorMessage, durationMs, finishedAt, conversation
 *
 * `conversation` is only set on terminal polls (where the server has
 * just modified the conversation record). On `running` polls it's null
 * — the dashboard already has the up-to-date conversation from the
 * initial mutation response.
 */
export type SupportBotRunSnapshot = {
  __typename?: 'SupportBotRunSnapshot';
  /**
   * Approximate token count derived from streamed content lengths.
   * Heuristic; not a precise billing figure.
   */
  approxTokens: Scalars['Int']['output'];
  /**
   * Assistant text accumulated from the agent's stream so far. Empty
   * string until the agent emits its first text. Monotonic; final
   * value when terminal but `response` is preferred for the
   * canonical text on `completed` / `partial`.
   */
  assistantTextSoFar: Scalars['String']['output'];
  /**
   * The conversation as it stands AFTER any side effects this poll
   * applied (assistant-message append on terminal completion,
   * `pendingRunId` clear on terminal error). Null on `running`
   * polls.
   */
  conversation?: Maybe<SupportBotConversation>;
  conversationId: Scalars['ID']['output'];
  /**
   * Cursor SDK `Run.id`. For log correlation. May be unset on
   * `not_found` snapshots (the bot has no record of the run).
   */
  cursorRunId?: Maybe<Scalars['String']['output']>;
  /**
   * Set when `status` is `partial`. Same semantics as
   * `SupportBotMessage.cutoffReason`.
   */
  cutoffReason?: Maybe<Scalars['String']['output']>;
  /** Set when `status` is not `running`. `finishedAt - startedAt`. */
  durationMs?: Maybe<Scalars['Int']['output']>;
  /**
   * Set when `status` is `run_error`, `timeout`, or
   * `not_found`. Human-readable diagnostic.
   */
  errorMessage?: Maybe<Scalars['String']['output']>;
  /**
   * Set when `status` is not `running`. Epoch millis at which the
   * run terminated.
   */
  finishedAt?: Maybe<Scalars['Timestamp']['output']>;
  /**
   * Canonical assistant response. Set when `status` is `completed`
   * or `partial`. Prefer this over `assistantTextSoFar` when
   * rendering the final answer — it includes any final text the
   * stream missed.
   */
  response?: Maybe<Scalars['String']['output']>;
  runId: Scalars['ID']['output'];
  startedAt: Scalars['Timestamp']['output'];
  status: SupportBotRunStatus;
  /** Number of tool calls observed with status `completed`. Diagnostic. */
  toolCallCount: Scalars['Int']['output'];
};

/**
 * Lifecycle status of an agent run. Starts as `running`, transitions
 * exactly once to a terminal value:
 *
 * - `completed`: stream ended naturally; the assistant produced a
 *   finished response.
 * - `partial`: the bot paused at a soft deadline / token budget and
 *   the response is a checkpoint summary. The dashboard offers a
 *   "Continue" affordance.
 * - `run_error`: the agent run finished but reported an error, or the
 *   stream consumption itself threw. `errorMessage` carries the detail.
 * - `timeout`: the agent run exceeded its hard timeout.
 * - `not_found`: the run is unknown to the bot, typically because the
 *   bot was restarted after the run was started. The user should
 *   re-send their message.
 */
export enum SupportBotRunStatus {
  Completed = 'completed',
  NotFound = 'not_found',
  Partial = 'partial',
  RunError = 'run_error',
  Running = 'running',
  Timeout = 'timeout'
}

/**
 * Per-turn overrides for the bot's deadline / token-budget cutoffs. All
 * fields optional; omitted fields fall back to the bot's configured
 * defaults (typically 2 min soft / 10 min hard / 2M token cap).
 *
 * The bot enforces an absolute upper bound on `hardTimeoutMs` server-
 * side (default 1 hour); requests beyond that are silently clamped down,
 * not rejected.
 *
 * Use to relax cutoffs for a complex investigation that should run to
 * completion ("take 30 min if you need to") or, more rarely, tighten
 * them for a fast question where waiting is more annoying than a
 * partial answer.
 */
export type SupportBotTimeoutOverridesInput = {
  /**
   * When true, removes BOTH the time and token-budget components of
   * the soft cutoff for this turn. The agent runs straight through
   * to either completion or `hardTimeoutMs` (whichever effective
   * value applies after overrides). Use for "take as long as you
   * need to answer this completely" investigations.
   */
  disableSoftCutoff?: InputMaybe<Scalars['Boolean']['input']>;
  /**
   * Override the bot's hard timeout (ms). Default ~10 min. Capped
   * server-side at the bot's AGENT_HARD_TIMEOUT_MAX_MS setting
   * (default 1 hour) — values past the cap are silently clamped.
   */
  hardTimeoutMs?: InputMaybe<Scalars['Int']['input']>;
  /**
   * Override the bot's soft cutoff time (ms). Default ~2 min. Ignored
   * when `disableSoftCutoff` is true.
   */
  softDeadlineMs?: InputMaybe<Scalars['Int']['input']>;
  /**
   * Override the bot's soft token-budget cutoff. Default ~2M.
   * Ignored when `disableSoftCutoff` is true.
   */
  softMaxTokens?: InputMaybe<Scalars['Int']['input']>;
};

export type SyncFrom = {
  __typename?: 'SyncFrom';
  appointments?: Maybe<Scalars['NonNegativeInt']['output']>;
  clinic: Clinic;
  created_at: Scalars['Timestamp']['output'];
  patients?: Maybe<Scalars['NonNegativeInt']['output']>;
  updated_at: Scalars['Timestamp']['output'];
};

export type Tag = {
  __typename?: 'Tag';
  created_at: Scalars['Timestamp']['output'];
  entity_id: Scalars['String']['output'];
  entity_type: TagEntity;
  id: Scalars['ID']['output'];
  tag_category: TagCategory;
};

export type TagCategory = {
  __typename?: 'TagCategory';
  allowed_entities: Array<TagEntity>;
  clinic?: Maybe<Clinic>;
  clinic_group?: Maybe<ClinicGroup>;
  color?: Maybe<Scalars['String']['output']>;
  created_at: Scalars['Timestamp']['output'];
  id: Scalars['ID']['output'];
  is_archived: Scalars['Boolean']['output'];
  name: Scalars['String']['output'];
  tags: Array<Tag>;
  updated_at: Scalars['Timestamp']['output'];
};

export enum TagEntity {
  Chats = 'Chats',
  Clients = 'Clients',
  CustomerSegments = 'CustomerSegments',
  LeadContacts = 'LeadContacts',
  NotificationTemplates = 'NotificationTemplates',
  Patients = 'Patients'
}

export type TemplateClinic = {
  __typename?: 'TemplateClinic';
  clinic: Clinic;
  created_at: Scalars['Timestamp']['output'];
  id: Scalars['ID']['output'];
  report_template: ReportTemplate;
  updated_at: Scalars['Timestamp']['output'];
};

export type TimeInterval = {
  __typename?: 'TimeInterval';
  end?: Maybe<Scalars['NonNegativeFloat']['output']>;
  start?: Maybe<Scalars['NonNegativeFloat']['output']>;
};

export type TimeIntervalInput = {
  end?: InputMaybe<Scalars['NonNegativeFloat']['input']>;
  start?: InputMaybe<Scalars['NonNegativeFloat']['input']>;
};

export enum TimeOfDay {
  Afternoon = 'Afternoon',
  EarlyMorning = 'EarlyMorning',
  LateAfternoon = 'LateAfternoon',
  Morning = 'Morning'
}

export enum TimeParamType {
  RelativeMillisTimeRange = 'RelativeMillisTimeRange',
  RelativePeriodTimeRange = 'RelativePeriodTimeRange',
  SetTimeRange = 'SetTimeRange'
}

export type TimeParams = {
  __typename?: 'TimeParams';
  end?: Maybe<Scalars['Timestamp']['output']>;
  from_millis_ago?: Maybe<Scalars['Long']['output']>;
  from_periods_ago?: Maybe<Scalars['NonNegativeInt']['output']>;
  period_type?: Maybe<PeriodType>;
  start?: Maybe<Scalars['Timestamp']['output']>;
  to_millis_ago?: Maybe<Scalars['Long']['output']>;
  to_periods_ago?: Maybe<Scalars['NonNegativeInt']['output']>;
  type: TimeParamType;
};

export type TimeParamsInput = {
  end?: InputMaybe<Scalars['Timestamp']['input']>;
  from_millis_ago?: InputMaybe<Scalars['Long']['input']>;
  from_periods_ago?: InputMaybe<Scalars['NonNegativeInt']['input']>;
  period_type?: InputMaybe<PeriodType>;
  start?: InputMaybe<Scalars['Timestamp']['input']>;
  to_millis_ago?: InputMaybe<Scalars['Long']['input']>;
  to_periods_ago?: InputMaybe<Scalars['NonNegativeInt']['input']>;
  type: TimeParamType;
};

export type TimeSlot = {
  __typename?: 'TimeSlot';
  display_time?: Maybe<Scalars['NonNegativeInt']['output']>;
  selections: Array<TimeSlotSelection>;
  start_time: Scalars['NonNegativeInt']['output'];
};

export type TimeSlotParams = {
  client_id?: InputMaybe<Scalars['ID']['input']>;
  clinic_species_id: Scalars['ID']['input'];
  clinician_preference_id?: InputMaybe<Array<Scalars['ID']['input']>>;
  date: Scalars['NonNegativeInt']['input'];
  duration_in_minutes: Scalars['NonNegativeInt']['input'];
  fixed_status?: InputMaybe<FixedStatus>;
  is_new_client?: InputMaybe<Scalars['Boolean']['input']>;
  is_new_patient: Scalars['Boolean']['input'];
  patient_gender?: InputMaybe<AnimalGender>;
  patient_id?: InputMaybe<Scalars['ID']['input']>;
  room_id?: InputMaybe<Scalars['ID']['input']>;
  service_ids?: InputMaybe<Array<Scalars['ID']['input']>>;
};

export type TimeSlotSelection = {
  __typename?: 'TimeSlotSelection';
  clinicians: Array<Clinician>;
  rooms: Array<Room>;
  service_id?: Maybe<Scalars['ID']['output']>;
};

export enum TimeUnit {
  Day = 'Day',
  Hour = 'Hour',
  Month = 'Month',
  Week = 'Week',
  Year = 'Year'
}

/**
 * The resolved set of Times-First booking filter controls that should be
 * displayed for a clinic/widget. Each field is true when that control should
 * be rendered (after applying scheduling-rule auto-detection and any clinic /
 * widget override config).
 */
export type TimesFirstBookingFilters = {
  __typename?: 'TimesFirstBookingFilters';
  client_status: Scalars['Boolean']['output'];
  clinician: Scalars['Boolean']['output'];
  fixed_status: Scalars['Boolean']['output'];
  patient_gender: Scalars['Boolean']['output'];
  patient_status: Scalars['Boolean']['output'];
  service: Scalars['Boolean']['output'];
  species: Scalars['Boolean']['output'];
};

/**
 * Per-control override for which filters are shown on the Times-First
 * (UrgentCare) booking calendar. Null config means every control is Auto.
 * Ignored when urgency_type is GeneralPractice.
 */
export type TimesFirstFilterConfig = {
  __typename?: 'TimesFirstFilterConfig';
  /** New vs returning client filter. Auto/Show/Hidden. */
  client_status?: Maybe<BookingFilterDisplayMode>;
  /** Clinician filter on the Times-First calendar. Auto/Show/Hidden. */
  clinician?: Maybe<BookingFilterDisplayMode>;
  /** Fixed/spay-neuter status filter. Auto/Show/Hidden. */
  fixed_status?: Maybe<BookingFilterDisplayMode>;
  /** Patient gender filter. Auto/Show/Hidden. */
  patient_gender?: Maybe<BookingFilterDisplayMode>;
  /** New vs returning patient filter. Auto/Show/Hidden. */
  patient_status?: Maybe<BookingFilterDisplayMode>;
  /** Service filter on the Times-First calendar. Auto/Show/Hidden. */
  service?: Maybe<BookingFilterDisplayMode>;
  /** Species filter on the Times-First calendar. Auto/Show/Hidden. */
  species?: Maybe<BookingFilterDisplayMode>;
};

export type TimesFirstFilterConfigInput = {
  client_status?: InputMaybe<BookingFilterDisplayMode>;
  clinician?: InputMaybe<BookingFilterDisplayMode>;
  fixed_status?: InputMaybe<BookingFilterDisplayMode>;
  patient_gender?: InputMaybe<BookingFilterDisplayMode>;
  patient_status?: InputMaybe<BookingFilterDisplayMode>;
  service?: InputMaybe<BookingFilterDisplayMode>;
  species?: InputMaybe<BookingFilterDisplayMode>;
};

export type TodayAnalytics = {
  __typename?: 'TodayAnalytics';
  appointments: Array<Appointment>;
  unpaid_invoices_count: Scalars['NonNegativeInt']['output'];
  unpaid_invoices_total: Scalars['Float']['output'];
};

export type TomorrowAnalytics = {
  __typename?: 'TomorrowAnalytics';
  appointments: Array<Appointment>;
};

export type Transaction = {
  __typename?: 'Transaction';
  amount?: Maybe<Scalars['String']['output']>;
  client_pms_id?: Maybe<Client>;
  clinic_id: Scalars['ID']['output'];
  clinician_pms_id?: Maybe<Clinician>;
  created_at: Scalars['Timestamp']['output'];
  date?: Maybe<Scalars['NonNegativeInt']['output']>;
  description?: Maybe<Scalars['String']['output']>;
  id: Scalars['ID']['output'];
  patient_pms_id?: Maybe<Patient>;
  pms?: Maybe<PracticeManagementSystem>;
  pms_id?: Maybe<Scalars['String']['output']>;
  service_pms_id?: Maybe<Scalars['ID']['output']>;
  type?: Maybe<TransactionType>;
  updated_at: Scalars['Timestamp']['output'];
};

export enum TransactionType {
  Medical = 'Medical',
  Otc = 'OTC',
  Other = 'Other',
  Payment = 'Payment'
}

export type Treatment = {
  __typename?: 'Treatment';
  clinic: Clinic;
  created_at: Scalars['Timestamp']['output'];
  description: Scalars['String']['output'];
  id: Scalars['ID']['output'];
  pms_id: Scalars['String']['output'];
  price?: Maybe<Scalars['Float']['output']>;
  updated_at: Scalars['Timestamp']['output'];
};

export enum TrendLineType {
  Entity = 'Entity',
  Metric = 'Metric'
}

export type TrendReport = {
  __typename?: 'TrendReport';
  scope: TrendReportScope;
  trend_segments: Array<TrendSegment>;
};

export type TrendReportParams = {
  clinic_ids: Array<Scalars['ID']['input']>;
  from_date: Scalars['NonNegativeInt']['input'];
  line_type: TrendLineType;
  scope: TrendReportScope;
  selected_metric: Scalars['ID']['input'];
  to_date: Scalars['NonNegativeInt']['input'];
};

export enum TrendReportScope {
  DayOverDay = 'DayOverDay',
  MonthOverMonth = 'MonthOverMonth',
  QuarterOverQuarter = 'QuarterOverQuarter',
  WeekOverWeek = 'WeekOverWeek',
  YearOverYear = 'YearOverYear'
}

export type TrendSegment = {
  __typename?: 'TrendSegment';
  time_range: TrendTimeRange;
  values: Array<Scalars['JSON']['output']>;
};

export type TrendTimeRange = {
  __typename?: 'TrendTimeRange';
  end_time: Scalars['Timestamp']['output'];
  label: Scalars['String']['output'];
  start_time: Scalars['Timestamp']['output'];
};

export type TriggerWebhookInput = {
  clinic_id: Scalars['ID']['input'];
  event: WebhookEventType;
  is_test?: InputMaybe<Scalars['Boolean']['input']>;
};

export type TriggerWebhookResult = {
  __typename?: 'TriggerWebhookResult';
  success: Scalars['Boolean']['output'];
  webhooks_triggered: Scalars['Int']['output'];
};

export type UpdateActionItemInput = {
  assignee?: InputMaybe<Scalars['ID']['input']>;
  description?: InputMaybe<Scalars['String']['input']>;
  status?: InputMaybe<ActionItemStatus>;
  type?: InputMaybe<ActionItemType>;
};

export type UpdateAnimalInput = {
  image?: InputMaybe<Scalars['String']['input']>;
  name?: InputMaybe<Scalars['String']['input']>;
};

export type UpdateAppointmentInput = {
  appt_type_pms_id?: InputMaybe<Scalars['String']['input']>;
  booking_source?: InputMaybe<BookingSource>;
  cancelled_at?: InputMaybe<Scalars['NonNegativeInt']['input']>;
  checksum?: InputMaybe<Scalars['String']['input']>;
  client?: InputMaybe<Scalars['ID']['input']>;
  client_info?: InputMaybe<ClientInfoInput>;
  client_notes?: InputMaybe<Scalars['String']['input']>;
  client_pms_id?: InputMaybe<Scalars['String']['input']>;
  client_reason_for_cancellation?: InputMaybe<Scalars['String']['input']>;
  clinic?: InputMaybe<Scalars['ID']['input']>;
  clinic_approved_at?: InputMaybe<Scalars['NonNegativeInt']['input']>;
  clinic_appt_status?: InputMaybe<Scalars['ID']['input']>;
  clinic_notes?: InputMaybe<Scalars['String']['input']>;
  clinician?: InputMaybe<Scalars['ID']['input']>;
  clinician_pms_id?: InputMaybe<Scalars['String']['input']>;
  confirmation_requested_at?: InputMaybe<Scalars['NonNegativeInt']['input']>;
  confirmed_at?: InputMaybe<Scalars['NonNegativeInt']['input']>;
  drop_off_time?: InputMaybe<Scalars['NonNegativeInt']['input']>;
  index_of_opening?: InputMaybe<Scalars['NonNegativeInt']['input']>;
  is_deleted?: InputMaybe<Scalars['Boolean']['input']>;
  is_new_client?: InputMaybe<Scalars['Boolean']['input']>;
  is_new_patient?: InputMaybe<Scalars['Boolean']['input']>;
  is_time_block?: InputMaybe<Scalars['Boolean']['input']>;
  minutes?: InputMaybe<Scalars['NonNegativeInt']['input']>;
  new_client_name?: InputMaybe<Scalars['String']['input']>;
  new_client_phone?: InputMaybe<Scalars['String']['input']>;
  new_patient_name?: InputMaybe<Scalars['String']['input']>;
  new_patient_species?: InputMaybe<Scalars['String']['input']>;
  origin?: InputMaybe<EntityOrigin>;
  patient?: InputMaybe<Scalars['ID']['input']>;
  patient_info?: InputMaybe<PatientInfoInput>;
  patient_pms_id?: InputMaybe<Scalars['String']['input']>;
  patients_pms_ids?: InputMaybe<Array<Scalars['String']['input']>>;
  payment?: InputMaybe<Scalars['ID']['input']>;
  pms?: InputMaybe<PracticeManagementSystem>;
  pms_created_at?: InputMaybe<Scalars['NonNegativeInt']['input']>;
  pms_id?: InputMaybe<Scalars['String']['input']>;
  reason_for_cancellation?: InputMaybe<Scalars['String']['input']>;
  referring_clinic_name?: InputMaybe<Scalars['String']['input']>;
  requested_prompt?: InputMaybe<Scalars['ID']['input']>;
  room?: InputMaybe<Scalars['ID']['input']>;
  service?: InputMaybe<Scalars['ID']['input']>;
  service_name?: InputMaybe<Scalars['String']['input']>;
  should_be_synced?: InputMaybe<Scalars['Boolean']['input']>;
  start_time?: InputMaybe<Scalars['NonNegativeInt']['input']>;
  status?: InputMaybe<AppointmentStatus>;
  stripe_payment_intent_id?: InputMaybe<Scalars['String']['input']>;
  time_of_day?: InputMaybe<TimeOfDay>;
};

export type UpdateAppointmentPromptInput = {
  client?: InputMaybe<Scalars['ID']['input']>;
  client_notes?: InputMaybe<Scalars['String']['input']>;
  clinic?: InputMaybe<Scalars['ID']['input']>;
  clinic_notes?: InputMaybe<Scalars['String']['input']>;
  clinician?: InputMaybe<Scalars['ID']['input']>;
  confirmed_at?: InputMaybe<Scalars['NonNegativeInt']['input']>;
  created_appointment?: InputMaybe<Scalars['ID']['input']>;
  minutes?: InputMaybe<Scalars['NonNegativeInt']['input']>;
  patient?: InputMaybe<Scalars['ID']['input']>;
  reason_for_denial?: InputMaybe<Scalars['String']['input']>;
  service?: InputMaybe<Scalars['ID']['input']>;
  service_name?: InputMaybe<Scalars['String']['input']>;
  start_time?: InputMaybe<Scalars['NonNegativeInt']['input']>;
  type?: InputMaybe<AppointmentPromptType>;
};

export type UpdateBreedInput = {
  description?: InputMaybe<Scalars['String']['input']>;
  pms_id?: InputMaybe<Scalars['String']['input']>;
  species?: InputMaybe<Species>;
};

export type UpdateCallInput = {
  notes?: InputMaybe<Scalars['String']['input']>;
  status?: InputMaybe<CallStatus>;
};

export type UpdateCampaignInput = {
  color?: InputMaybe<Scalars['String']['input']>;
  description?: InputMaybe<Scalars['String']['input']>;
  end_time?: InputMaybe<Scalars['NonNegativeInt']['input']>;
  featured_stats?: InputMaybe<Array<Scalars['String']['input']>>;
  is_active?: InputMaybe<Scalars['Boolean']['input']>;
  is_archived?: InputMaybe<Scalars['Boolean']['input']>;
  name?: InputMaybe<Scalars['String']['input']>;
  notification_featured_stats?: InputMaybe<Array<Scalars['String']['input']>>;
  scheduled_bulk_message_featured_stats?: InputMaybe<Array<Scalars['String']['input']>>;
  start_time?: InputMaybe<Scalars['NonNegativeInt']['input']>;
  widget_featured_stats?: InputMaybe<Array<Scalars['String']['input']>>;
};

export type UpdateChatInput = {
  assignee?: InputMaybe<Scalars['ID']['input']>;
  chat_status?: InputMaybe<Scalars['ID']['input']>;
  client_last_read?: InputMaybe<Scalars['NonNegativeInt']['input']>;
  client_last_read_count?: InputMaybe<Scalars['NonNegativeInt']['input']>;
  client_message_count?: InputMaybe<Scalars['NonNegativeInt']['input']>;
  client_unread_count?: InputMaybe<Scalars['NonNegativeInt']['input']>;
  clinic_last_read?: InputMaybe<Scalars['NonNegativeInt']['input']>;
  clinic_last_read_count?: InputMaybe<Scalars['NonNegativeInt']['input']>;
  clinic_message_count?: InputMaybe<Scalars['NonNegativeInt']['input']>;
  clinic_unread_count?: InputMaybe<Scalars['NonNegativeInt']['input']>;
  compliance_status?: InputMaybe<Scalars['String']['input']>;
  is_hidden?: InputMaybe<Scalars['Boolean']['input']>;
  is_pinned?: InputMaybe<Scalars['Boolean']['input']>;
  last_message?: InputMaybe<Scalars['String']['input']>;
  last_message_time?: InputMaybe<Scalars['Timestamp']['input']>;
  last_writeback_time?: InputMaybe<Scalars['NonNegativeInt']['input']>;
  message_count?: InputMaybe<Scalars['NonNegativeInt']['input']>;
  status?: InputMaybe<ChatStatus>;
  title?: InputMaybe<Scalars['String']['input']>;
};

export type UpdateChatStatusInput = {
  color?: InputMaybe<Scalars['String']['input']>;
  is_archived?: InputMaybe<Scalars['Boolean']['input']>;
  name?: InputMaybe<Scalars['String']['input']>;
  sort_order?: InputMaybe<Scalars['Int']['input']>;
};

export type UpdateCheckInInput = {
  status?: InputMaybe<CheckInStatus>;
  vehicle?: InputMaybe<Scalars['String']['input']>;
  visit_reason?: InputMaybe<VisitReason>;
};

export type UpdateClientFormInput = {
  client_completed_at?: InputMaybe<Scalars['NonNegativeInt']['input']>;
  clinic_verified_at?: InputMaybe<Scalars['NonNegativeInt']['input']>;
  form_data?: InputMaybe<FormFieldsInput>;
  is_archived?: InputMaybe<Scalars['Boolean']['input']>;
  notify_clinic?: InputMaybe<Scalars['Boolean']['input']>;
};

export type UpdateClientInput = {
  address?: InputMaybe<AddressInput>;
  balance?: InputMaybe<Scalars['Float']['input']>;
  checksum?: InputMaybe<Scalars['String']['input']>;
  clinic?: InputMaybe<Scalars['ID']['input']>;
  email?: InputMaybe<Scalars['String']['input']>;
  email_enabled?: InputMaybe<Scalars['Boolean']['input']>;
  first_name?: InputMaybe<Scalars['String']['input']>;
  is_lead?: InputMaybe<Scalars['Boolean']['input']>;
  is_temp_client?: InputMaybe<Scalars['Boolean']['input']>;
  is_unsubscribed?: InputMaybe<Scalars['Boolean']['input']>;
  last_appointment?: InputMaybe<Scalars['ID']['input']>;
  last_appt_time?: InputMaybe<Scalars['NonNegativeInt']['input']>;
  last_contact_time?: InputMaybe<Scalars['NonNegativeInt']['input']>;
  last_name?: InputMaybe<Scalars['String']['input']>;
  next_appointment?: InputMaybe<Scalars['ID']['input']>;
  next_appt_time?: InputMaybe<Scalars['NonNegativeInt']['input']>;
  origin?: InputMaybe<EntityOrigin>;
  phone?: InputMaybe<Scalars['String']['input']>;
  pms?: InputMaybe<PracticeManagementSystem>;
  pms_created_at?: InputMaybe<Scalars['NonNegativeInt']['input']>;
  pms_id?: InputMaybe<Scalars['String']['input']>;
  secondary_pms_id?: InputMaybe<Scalars['String']['input']>;
  settings?: InputMaybe<ClientSettingsInput>;
  sms_enabled?: InputMaybe<Scalars['Boolean']['input']>;
  status?: InputMaybe<Scalars['ID']['input']>;
  title?: InputMaybe<Scalars['String']['input']>;
  users?: InputMaybe<Array<Scalars['ID']['input']>>;
};

export type UpdateClientStatusInput = {
  description?: InputMaybe<Scalars['String']['input']>;
  name?: InputMaybe<Scalars['String']['input']>;
  pms?: InputMaybe<PracticeManagementSystem>;
  pms_id?: InputMaybe<Scalars['String']['input']>;
};

export type UpdateClinicAdminInput = {
  /** New boolean shape, written to the admin_permissions table. */
  admin_permissions?: InputMaybe<AdminPermissionsInput>;
  allow_approving_controlled_substances?: InputMaybe<Scalars['Boolean']['input']>;
  are_desktop_notifications_enabled?: InputMaybe<Scalars['Boolean']['input']>;
  are_email_notifications_enabled?: InputMaybe<Scalars['Boolean']['input']>;
  are_sms_notifications_enabled?: InputMaybe<Scalars['Boolean']['input']>;
  custom_role?: InputMaybe<Scalars['ID']['input']>;
  /** Legacy input shape. Prefer admin_permissions instead. */
  permissions?: InputMaybe<Array<ClinicAdminPermissionInput>>;
  role?: InputMaybe<AuthRoles>;
  should_hide_daily_huddle_financials?: InputMaybe<Scalars['Boolean']['input']>;
};

export type UpdateClinicApptStatusInput = {
  description?: InputMaybe<Scalars['String']['input']>;
  is_primary?: InputMaybe<Scalars['Boolean']['input']>;
  pms?: InputMaybe<PracticeManagementSystem>;
  pms_id?: InputMaybe<Scalars['String']['input']>;
  status?: InputMaybe<AppointmentStatus>;
};

export type UpdateClinicGroupInput = {
  clinic_group_clinics?: InputMaybe<Array<Scalars['ID']['input']>>;
  is_archived?: InputMaybe<Scalars['Boolean']['input']>;
  name: Scalars['String']['input'];
};

export type UpdateClinicGroupUserInput = {
  /** New boolean shape, written to the admin_permissions table. */
  admin_permissions?: InputMaybe<AdminPermissionsInput>;
  are_desktop_notifications_enabled?: InputMaybe<Scalars['Boolean']['input']>;
  are_email_notifications_enabled?: InputMaybe<Scalars['Boolean']['input']>;
  are_sms_notifications_enabled?: InputMaybe<Scalars['Boolean']['input']>;
  custom_role?: InputMaybe<Scalars['ID']['input']>;
  /** Legacy input shape. Prefer admin_permissions instead. */
  permissions?: InputMaybe<Array<ClinicAdminPermissionInput>>;
  role?: InputMaybe<AuthRoles>;
};

export type UpdateClinicInput = {
  address?: InputMaybe<AddressInput>;
  adjusted_availability?: InputMaybe<Array<AvailabilityInput>>;
  animals?: InputMaybe<Array<Scalars['ID']['input']>>;
  avatar_url?: InputMaybe<Scalars['String']['input']>;
  clinic_hours?: InputMaybe<AvailabilityHoursInput>;
  description?: InputMaybe<Scalars['String']['input']>;
  email?: InputMaybe<Scalars['String']['input']>;
  features?: InputMaybe<ClinicFeaturesInput>;
  hours?: InputMaybe<AvailabilityHoursInput>;
  is_archived?: InputMaybe<Scalars['Boolean']['input']>;
  is_featured?: InputMaybe<Scalars['Boolean']['input']>;
  is_verified?: InputMaybe<Scalars['Boolean']['input']>;
  last_sync_times?: InputMaybe<LastSyncTimesInput>;
  location?: InputMaybe<Scalars['String']['input']>;
  mute_until?: InputMaybe<Scalars['NonNegativeInt']['input']>;
  name?: InputMaybe<Scalars['String']['input']>;
  offers_emergency_care?: InputMaybe<Scalars['Boolean']['input']>;
  office_emails?: InputMaybe<Array<Scalars['String']['input']>>;
  onboarding?: InputMaybe<ClinicOnboardingInput>;
  organization?: InputMaybe<Scalars['ID']['input']>;
  phone?: InputMaybe<Scalars['String']['input']>;
  pms?: InputMaybe<PracticeManagementSystem>;
  pms_additional_key?: InputMaybe<Scalars['String']['input']>;
  pms_api_key?: InputMaybe<Scalars['String']['input']>;
  pms_api_subdomain?: InputMaybe<Scalars['String']['input']>;
  /**
   * Can only change before the clinic's first sync. Moving an already-synced
   * clinic between connectors re-keys its PIMS ids, which the DataHub
   * conversion scripts handle.
   */
  pms_connector?: InputMaybe<PmsConnector>;
  pms_db?: InputMaybe<Scalars['ID']['input']>;
  pms_version?: InputMaybe<Scalars['String']['input']>;
  reply_to_email?: InputMaybe<Scalars['String']['input']>;
  send_from_email?: InputMaybe<Scalars['String']['input']>;
  send_from_phone?: InputMaybe<Scalars['String']['input']>;
  services?: InputMaybe<Array<Scalars['ID']['input']>>;
  settings?: InputMaybe<ClinicSettingsInput>;
  stripe_account_type?: InputMaybe<Scalars['String']['input']>;
  stripe_accounts_enabled?: InputMaybe<Array<StripeAccountType>>;
  stripe_connected_account_id?: InputMaybe<Scalars['String']['input']>;
  stripe_customer_id?: InputMaybe<Scalars['String']['input']>;
  time_zone?: InputMaybe<Scalars['String']['input']>;
  tmp_feature_flags?: InputMaybe<Scalars['JSON']['input']>;
  website?: InputMaybe<Scalars['String']['input']>;
};

export type UpdateClinicSexInput = {
  animal_gender?: InputMaybe<AnimalGender>;
  description?: InputMaybe<Scalars['String']['input']>;
  fixed_statuses?: InputMaybe<Array<FixedStatus>>;
  included_species?: InputMaybe<Array<Species>>;
  is_active?: InputMaybe<Scalars['Boolean']['input']>;
  name?: InputMaybe<Scalars['String']['input']>;
};

export type UpdateClinicSpeciesInput = {
  description?: InputMaybe<Scalars['String']['input']>;
  is_primary?: InputMaybe<Scalars['Boolean']['input']>;
  pms?: InputMaybe<PracticeManagementSystem>;
  pms_id?: InputMaybe<Scalars['String']['input']>;
  species?: InputMaybe<Species>;
  weight_key?: InputMaybe<Scalars['String']['input']>;
};

export type UpdateClinicStatsInput = {
  booked_appointments?: InputMaybe<Scalars['NonNegativeInt']['input']>;
  cancelled_appointments?: InputMaybe<Scalars['NonNegativeInt']['input']>;
  completed_appointments?: InputMaybe<Scalars['NonNegativeInt']['input']>;
  confirmed_appointments?: InputMaybe<Scalars['NonNegativeInt']['input']>;
  denied_appointments?: InputMaybe<Scalars['NonNegativeInt']['input']>;
  expired_appointments?: InputMaybe<Scalars['NonNegativeInt']['input']>;
  pending_appointments?: InputMaybe<Scalars['NonNegativeInt']['input']>;
  total_appointments?: InputMaybe<Scalars['NonNegativeInt']['input']>;
  total_website_appointments?: InputMaybe<Scalars['NonNegativeInt']['input']>;
  total_widget_appointments?: InputMaybe<Scalars['NonNegativeInt']['input']>;
};

export type UpdateClinicianInput = {
  adjusted_availability?: InputMaybe<Array<AvailabilityInput>>;
  authority_level?: InputMaybe<AuthorityLevel>;
  avatar_url?: InputMaybe<Scalars['String']['input']>;
  bio?: InputMaybe<Scalars['String']['input']>;
  clinic?: InputMaybe<Scalars['ID']['input']>;
  display_name?: InputMaybe<Scalars['String']['input']>;
  does_contribute_to_fill_rate?: InputMaybe<Scalars['Boolean']['input']>;
  excluded_service_ids?: InputMaybe<Array<Scalars['ID']['input']>>;
  excluded_species?: InputMaybe<Array<Species>>;
  hours?: InputMaybe<AvailabilityHoursInput>;
  initials?: InputMaybe<Scalars['String']['input']>;
  is_active?: InputMaybe<Scalars['Boolean']['input']>;
  is_assignable_in_pms?: InputMaybe<Scalars['Boolean']['input']>;
  metadata?: InputMaybe<Scalars['JSON']['input']>;
  name?: InputMaybe<Scalars['String']['input']>;
  pms?: InputMaybe<PracticeManagementSystem>;
  pms_adjusted_availability?: InputMaybe<Array<AvailabilityInput>>;
  pms_id?: InputMaybe<Scalars['String']['input']>;
  role?: InputMaybe<Scalars['String']['input']>;
  stagger_offset_minutes?: InputMaybe<Scalars['NonNegativeInt']['input']>;
  type?: InputMaybe<ResourceType>;
  valid_booking_interval_minutes?: InputMaybe<Array<Scalars['NonNegativeInt']['input']>>;
};

export type UpdateClinicianServiceInput = {
  clinician?: InputMaybe<Scalars['ID']['input']>;
  duration_override?: InputMaybe<Scalars['NonNegativeInt']['input']>;
  is_active?: InputMaybe<Scalars['Boolean']['input']>;
  service?: InputMaybe<Scalars['ID']['input']>;
};

export type UpdateConnectInstallationInput = {
  clinic?: InputMaybe<Scalars['ID']['input']>;
  computer_name?: InputMaybe<Scalars['String']['input']>;
  computer_uuid?: InputMaybe<Scalars['String']['input']>;
  connect_server_version?: InputMaybe<Scalars['String']['input']>;
  connect_ui_version?: InputMaybe<Scalars['String']['input']>;
  is_chckup_connected_to_pms?: InputMaybe<Scalars['Boolean']['input']>;
  is_pms_active?: InputMaybe<Scalars['Boolean']['input']>;
  is_server?: InputMaybe<Scalars['Boolean']['input']>;
  is_update_service_active?: InputMaybe<Scalars['Boolean']['input']>;
  last_ping?: InputMaybe<Scalars['NonNegativeInt']['input']>;
  version?: InputMaybe<Scalars['String']['input']>;
};

export type UpdateCustomRoleInput = {
  /** New boolean shape, written to the admin_permissions table. */
  admin_permissions?: InputMaybe<AdminPermissionsInput>;
  description?: InputMaybe<Scalars['String']['input']>;
  is_active?: InputMaybe<Scalars['Boolean']['input']>;
  is_default?: InputMaybe<Scalars['Boolean']['input']>;
  name?: InputMaybe<Scalars['String']['input']>;
  /** Legacy input shape. Prefer admin_permissions instead. */
  permissions?: InputMaybe<Array<ClinicAdminPermissionInput>>;
};

export type UpdateCustomerSegmentInput = {
  all_inclusions?: InputMaybe<Array<SegmentFilterInput>>;
  any_exclusions?: InputMaybe<Array<SegmentFilterInput>>;
  any_inclusions?: InputMaybe<Array<SegmentFilterInput>>;
  any_other_exclusions?: InputMaybe<Array<SegmentFilterInput>>;
  default_exclusions_options?: InputMaybe<DefaultExclusionsOptionsInput>;
  error_flags?: InputMaybe<Array<CustomerSegmentErrorFlagInput>>;
  excluded_clients?: InputMaybe<Array<Scalars['ID']['input']>>;
  excluded_filters?: InputMaybe<Array<CustomerSegmentFilterInput>>;
  filters?: InputMaybe<Array<CustomerSegmentFilterInput>>;
  group_days_ahead?: InputMaybe<Scalars['NonNegativeInt']['input']>;
  included_clients?: InputMaybe<Array<Scalars['ID']['input']>>;
  is_archived?: InputMaybe<Scalars['Boolean']['input']>;
  is_hourly?: InputMaybe<Scalars['Boolean']['input']>;
  name?: InputMaybe<Scalars['String']['input']>;
  other_result_exclusion_entity?: InputMaybe<Scalars['String']['input']>;
  prevent_grouping_within_segment?: InputMaybe<Scalars['Boolean']['input']>;
  reference_date_params?: InputMaybe<ReferenceDateParamsInput>;
  should_include_all_overdue?: InputMaybe<Scalars['Boolean']['input']>;
  trigger_entity?: InputMaybe<CustomerSegmentTrigger>;
};

export type UpdateDailyHuddleInput = {
  attendees?: InputMaybe<Array<Scalars['ID']['input']>>;
  end_time?: InputMaybe<Scalars['NonNegativeInt']['input']>;
  leader?: InputMaybe<Scalars['ID']['input']>;
  notes?: InputMaybe<Scalars['String']['input']>;
  start_time?: InputMaybe<Scalars['NonNegativeInt']['input']>;
};

export type UpdateDataChatInput = {
  is_archived?: InputMaybe<Scalars['Boolean']['input']>;
  last_prompt_message?: InputMaybe<Scalars['String']['input']>;
  name?: InputMaybe<Scalars['String']['input']>;
};

export type UpdateDiagnosisInput = {
  description?: InputMaybe<Scalars['String']['input']>;
  name?: InputMaybe<Scalars['String']['input']>;
};

export type UpdateEmailTemplateInput = {
  design?: InputMaybe<Scalars['JSON']['input']>;
  html?: InputMaybe<Scalars['String']['input']>;
  status?: InputMaybe<EmailTemplateStatus>;
  subject?: InputMaybe<Scalars['String']['input']>;
  title?: InputMaybe<Scalars['String']['input']>;
};

export type UpdateEntityReportInput = {
  clinic?: InputMaybe<Scalars['ID']['input']>;
  clinician?: InputMaybe<Scalars['ID']['input']>;
  entity_report?: InputMaybe<Scalars['ID']['input']>;
  entity_type?: InputMaybe<ReportEntityType>;
  organization_report?: InputMaybe<Scalars['ID']['input']>;
  product?: InputMaybe<Scalars['ID']['input']>;
  service?: InputMaybe<Scalars['ID']['input']>;
  values?: InputMaybe<Array<UpdateReportValueInput>>;
};

export type UpdateFamilyInput = {
  name?: InputMaybe<Scalars['String']['input']>;
};

export type UpdateFollowUpSettingsInput = {
  days_until_next_appt?: InputMaybe<Scalars['NonNegativeInt']['input']>;
  step_number?: InputMaybe<Scalars['NonNegativeInt']['input']>;
};

export type UpdateFormInput = {
  does_require_client?: InputMaybe<Scalars['Boolean']['input']>;
  does_require_patient?: InputMaybe<Scalars['Boolean']['input']>;
  form_fields?: InputMaybe<FormFieldsInput>;
  form_file_naming_template?: InputMaybe<Scalars['String']['input']>;
  form_type?: InputMaybe<FormType>;
  is_active?: InputMaybe<Scalars['Boolean']['input']>;
  is_archived?: InputMaybe<Scalars['Boolean']['input']>;
  is_public?: InputMaybe<Scalars['Boolean']['input']>;
  is_using_pdf?: InputMaybe<Scalars['Boolean']['input']>;
  is_writeback_enabled?: InputMaybe<Scalars['Boolean']['input']>;
  name?: InputMaybe<Scalars['String']['input']>;
  pdf_schema?: InputMaybe<Scalars['JSON']['input']>;
  pdf_url?: InputMaybe<Scalars['String']['input']>;
  writeback_code_name?: InputMaybe<Scalars['String']['input']>;
  writeback_code_pms_id?: InputMaybe<Scalars['String']['input']>;
  writeback_to_strictest_entity?: InputMaybe<Scalars['Boolean']['input']>;
};

export type UpdateGoalInput = {
  description?: InputMaybe<Scalars['String']['input']>;
  is_active?: InputMaybe<Scalars['Boolean']['input']>;
  is_chckup_modifier?: InputMaybe<Scalars['Boolean']['input']>;
  is_new_modifier?: InputMaybe<Scalars['Boolean']['input']>;
  last_synced_time?: InputMaybe<Scalars['NonNegativeInt']['input']>;
  metric_current_amount?: InputMaybe<Scalars['NonNegativeInt']['input']>;
  metric_entity?: InputMaybe<GoalEntity>;
  metric_target_amount?: InputMaybe<Scalars['NonNegativeInt']['input']>;
  metric_timespan?: InputMaybe<GoalTimespan>;
  status?: InputMaybe<GoalStatus>;
};

export type UpdateInitiativeInput = {
  description?: InputMaybe<Scalars['String']['input']>;
  is_archived?: InputMaybe<Scalars['Boolean']['input']>;
  name?: InputMaybe<Scalars['String']['input']>;
  report_metrics?: InputMaybe<Array<Scalars['ID']['input']>>;
  start_time?: InputMaybe<Scalars['NonNegativeInt']['input']>;
};

export type UpdateInternalChatInput = {
  last_message?: InputMaybe<Scalars['String']['input']>;
  last_message_time?: InputMaybe<Scalars['NonNegativeInt']['input']>;
  title?: InputMaybe<Scalars['String']['input']>;
};

export type UpdateInternalChatMessageInput = {
  text?: InputMaybe<Scalars['String']['input']>;
};

export type UpdateInternalChatUserInput = {
  last_message_time?: InputMaybe<Scalars['NonNegativeInt']['input']>;
  last_read_time?: InputMaybe<Scalars['NonNegativeInt']['input']>;
  unread_message_count?: InputMaybe<Scalars['NonNegativeInt']['input']>;
};

export type UpdateInvoiceInput = {
  appointment?: InputMaybe<Scalars['ID']['input']>;
  balance?: InputMaybe<Scalars['Int']['input']>;
  client?: InputMaybe<Scalars['ID']['input']>;
  clinician?: InputMaybe<Scalars['ID']['input']>;
  currency?: InputMaybe<Scalars['Currency']['input']>;
  description?: InputMaybe<Scalars['String']['input']>;
  discount?: InputMaybe<Scalars['Int']['input']>;
  discount_reason?: InputMaybe<Scalars['String']['input']>;
  entered_by_name?: InputMaybe<Scalars['String']['input']>;
  paid_at?: InputMaybe<Scalars['Timestamp']['input']>;
  patient?: InputMaybe<Scalars['ID']['input']>;
  pims_created_at?: InputMaybe<Scalars['Timestamp']['input']>;
  status?: InputMaybe<InvoiceStatus>;
  subtotal?: InputMaybe<Scalars['Int']['input']>;
  tax?: InputMaybe<Scalars['Int']['input']>;
  total?: InputMaybe<Scalars['Int']['input']>;
};

export type UpdateInvoiceItemInput = {
  clinician?: InputMaybe<Scalars['ID']['input']>;
  currency?: InputMaybe<Scalars['Currency']['input']>;
  description?: InputMaybe<Scalars['String']['input']>;
  discount?: InputMaybe<Scalars['Int']['input']>;
  discount_reason?: InputMaybe<Scalars['String']['input']>;
  pims_created_at?: InputMaybe<Scalars['Timestamp']['input']>;
  price?: InputMaybe<Scalars['Int']['input']>;
  product?: InputMaybe<Scalars['ID']['input']>;
  quantity?: InputMaybe<Scalars['NonNegativeFloat']['input']>;
  subtotal?: InputMaybe<Scalars['Int']['input']>;
  tax?: InputMaybe<Scalars['Int']['input']>;
  total?: InputMaybe<Scalars['Int']['input']>;
  type?: InputMaybe<InvoiceItemType>;
};

export type UpdateKpiGroupInput = {
  description?: InputMaybe<Scalars['String']['input']>;
  name?: InputMaybe<Scalars['String']['input']>;
  report_metrics?: InputMaybe<Array<Scalars['ID']['input']>>;
};

export type UpdateKpiGroupMetricInput = {
  goal?: InputMaybe<Scalars['Float']['input']>;
  order?: InputMaybe<Scalars['Int']['input']>;
};

export type UpdateLoyaltyMemberInput = {
  all_time_points?: InputMaybe<Scalars['Float']['input']>;
  available_points?: InputMaybe<Scalars['Float']['input']>;
};

export type UpdateLoyaltyRewardInput = {
  description?: InputMaybe<Scalars['String']['input']>;
  image_url?: InputMaybe<Scalars['String']['input']>;
  is_active?: InputMaybe<Scalars['Boolean']['input']>;
  name?: InputMaybe<Scalars['String']['input']>;
  points_required?: InputMaybe<Scalars['NonNegativeInt']['input']>;
};

export type UpdateMessageInput = {
  chat?: InputMaybe<Scalars['ID']['input']>;
  hidden_for_client?: InputMaybe<Scalars['Boolean']['input']>;
  is_hidden?: InputMaybe<Scalars['Boolean']['input']>;
  patient?: InputMaybe<Scalars['ID']['input']>;
  patientIds?: InputMaybe<Array<Scalars['ID']['input']>>;
};

export type UpdateMessageTemplateInput = {
  body?: InputMaybe<Scalars['String']['input']>;
  name?: InputMaybe<Scalars['String']['input']>;
};

export type UpdateNotificationTemplateInput = {
  body?: InputMaybe<Scalars['String']['input']>;
  campaign?: InputMaybe<Scalars['ID']['input']>;
  cta_text?: InputMaybe<Scalars['String']['input']>;
  cta_url?: InputMaybe<Scalars['String']['input']>;
  customer_segment?: InputMaybe<Scalars['ID']['input']>;
  default_service_id?: InputMaybe<Scalars['ID']['input']>;
  email_body?: InputMaybe<Scalars['String']['input']>;
  email_design?: InputMaybe<Scalars['JSON']['input']>;
  email_html?: InputMaybe<Scalars['String']['input']>;
  email_template?: InputMaybe<Scalars['ID']['input']>;
  every_x_hours?: InputMaybe<Scalars['NonNegativeInt']['input']>;
  grouping_method?: InputMaybe<NotificationGroupingMethod>;
  header?: InputMaybe<Scalars['String']['input']>;
  is_active?: InputMaybe<Scalars['Boolean']['input']>;
  is_archived?: InputMaybe<Scalars['Boolean']['input']>;
  is_marketing?: InputMaybe<Scalars['Boolean']['input']>;
  is_preview_mode?: InputMaybe<Scalars['Boolean']['input']>;
  message_methods?: InputMaybe<Array<MessageMethod>>;
  name?: InputMaybe<Scalars['String']['input']>;
  notif_attachments?: InputMaybe<Array<CreateAttachmentInput>>;
  postcard_back_html?: InputMaybe<Scalars['String']['input']>;
  postcard_front_html?: InputMaybe<Scalars['String']['input']>;
  postcard_template?: InputMaybe<Scalars['String']['input']>;
  repeating_body?: InputMaybe<Scalars['String']['input']>;
  send_time_minutes?: InputMaybe<Scalars['NonNegativeInt']['input']>;
  subject?: InputMaybe<Scalars['String']['input']>;
  type?: InputMaybe<NotificationType>;
};

export type UpdateOrganizationInput = {
  admins?: InputMaybe<Array<Scalars['ID']['input']>>;
  name?: InputMaybe<Scalars['String']['input']>;
  settings?: InputMaybe<OrganizationSettingsInput>;
};

export type UpdateOrganizationReportInput = {
  description?: InputMaybe<Scalars['String']['input']>;
  is_hidden?: InputMaybe<Scalars['Boolean']['input']>;
  metrics?: InputMaybe<Array<ReportMetricInput>>;
  name?: InputMaybe<Scalars['String']['input']>;
  preferred_view_type?: InputMaybe<ReportViewType>;
  time_params?: InputMaybe<TimeParamsInput>;
};

export type UpdatePatientHistoryItemInput = {
  appointment?: InputMaybe<Scalars['ID']['input']>;
  clinician?: InputMaybe<Scalars['ID']['input']>;
  diagnosis?: InputMaybe<Scalars['ID']['input']>;
  issued_at?: InputMaybe<Scalars['Timestamp']['input']>;
  pms_id?: InputMaybe<Scalars['ID']['input']>;
  product?: InputMaybe<Scalars['ID']['input']>;
};

export type UpdatePatientInput = {
  avatar_url?: InputMaybe<Scalars['String']['input']>;
  birthday?: InputMaybe<Scalars['Float']['input']>;
  breed?: InputMaybe<Scalars['String']['input']>;
  checksum?: InputMaybe<Scalars['String']['input']>;
  client_pms_id?: InputMaybe<Scalars['String']['input']>;
  clinic?: InputMaybe<Scalars['ID']['input']>;
  clinic_breed?: InputMaybe<Scalars['ID']['input']>;
  clinic_species?: InputMaybe<Scalars['ID']['input']>;
  fixed_status?: InputMaybe<FixedStatus>;
  gender?: InputMaybe<AnimalGender>;
  is_active?: InputMaybe<Scalars['Boolean']['input']>;
  is_deceased?: InputMaybe<Scalars['Boolean']['input']>;
  last_appointment?: InputMaybe<Scalars['ID']['input']>;
  last_appt_time?: InputMaybe<Scalars['NonNegativeInt']['input']>;
  name?: InputMaybe<Scalars['String']['input']>;
  next_appointment?: InputMaybe<Scalars['ID']['input']>;
  next_appt_time?: InputMaybe<Scalars['NonNegativeInt']['input']>;
  origin?: InputMaybe<EntityOrigin>;
  owner?: InputMaybe<Scalars['ID']['input']>;
  pet?: InputMaybe<Scalars['ID']['input']>;
  pms?: InputMaybe<PracticeManagementSystem>;
  pms_created_at?: InputMaybe<Scalars['NonNegativeInt']['input']>;
  pms_id?: InputMaybe<Scalars['String']['input']>;
  species_pms_id?: InputMaybe<Scalars['String']['input']>;
  status?: InputMaybe<Scalars['ID']['input']>;
  weight?: InputMaybe<Scalars['Float']['input']>;
};

export type UpdatePatientRecordInput = {
  appointment?: InputMaybe<Scalars['ID']['input']>;
  assessment?: InputMaybe<Scalars['String']['input']>;
  assisting_clinicians?: InputMaybe<Array<Scalars['String']['input']>>;
  client?: InputMaybe<Scalars['ID']['input']>;
  clinic?: InputMaybe<Scalars['ID']['input']>;
  clinician?: InputMaybe<Scalars['ID']['input']>;
  date?: InputMaybe<Scalars['NonNegativeInt']['input']>;
  master_problem_list?: InputMaybe<Scalars['String']['input']>;
  objective?: InputMaybe<Scalars['String']['input']>;
  patient?: InputMaybe<Scalars['ID']['input']>;
  plan?: InputMaybe<Scalars['String']['input']>;
  public_notes?: InputMaybe<Scalars['String']['input']>;
  service?: InputMaybe<Scalars['ID']['input']>;
  subjective?: InputMaybe<Scalars['String']['input']>;
};

export type UpdatePatientStatusInput = {
  description?: InputMaybe<Scalars['String']['input']>;
  name?: InputMaybe<Scalars['String']['input']>;
  pms?: InputMaybe<PracticeManagementSystem>;
  pms_id?: InputMaybe<Scalars['String']['input']>;
};

export type UpdatePaymentInput = {
  amount?: InputMaybe<Scalars['PositiveInt']['input']>;
  client?: InputMaybe<Scalars['ID']['input']>;
  currency?: InputMaybe<Scalars['Currency']['input']>;
  errors?: InputMaybe<Array<PaymentErrorInput>>;
  is_entered_in_pims?: InputMaybe<Scalars['Boolean']['input']>;
  payment_method_id?: InputMaybe<Scalars['String']['input']>;
  processing_fee?: InputMaybe<Scalars['NonNegativeInt']['input']>;
  refund_entered_in_pims?: InputMaybe<Scalars['Boolean']['input']>;
  sales_tax?: InputMaybe<Scalars['NonNegativeInt']['input']>;
  service_fee?: InputMaybe<Scalars['NonNegativeInt']['input']>;
  status?: InputMaybe<PaymentStatus>;
  stripe_payment_intent_id?: InputMaybe<Scalars['String']['input']>;
};

export type UpdatePetInput = {
  avatar_url?: InputMaybe<Scalars['String']['input']>;
  bio?: InputMaybe<Scalars['String']['input']>;
  birthday?: InputMaybe<Scalars['Float']['input']>;
  breed?: InputMaybe<Scalars['String']['input']>;
  family?: InputMaybe<Scalars['ID']['input']>;
  fixed_status?: InputMaybe<FixedStatus>;
  gender?: InputMaybe<AnimalGender>;
  name?: InputMaybe<Scalars['String']['input']>;
  species?: InputMaybe<Species>;
  weight?: InputMaybe<Scalars['NonNegativeFloat']['input']>;
};

export type UpdatePetSelfieInput = {
  allow_public_share?: InputMaybe<Scalars['Boolean']['input']>;
  display_caption?: InputMaybe<Scalars['String']['input']>;
  display_media_url?: InputMaybe<Scalars['String']['input']>;
  favorite_activity?: InputMaybe<Scalars['String']['input']>;
  in_gallery?: InputMaybe<Scalars['Boolean']['input']>;
  in_portal_carousel?: InputMaybe<Scalars['Boolean']['input']>;
  in_slideshow?: InputMaybe<Scalars['Boolean']['input']>;
  is_archived?: InputMaybe<Scalars['Boolean']['input']>;
  is_excluded?: InputMaybe<Scalars['Boolean']['input']>;
  nickname?: InputMaybe<Scalars['String']['input']>;
  patient?: InputMaybe<Scalars['ID']['input']>;
  pet_name?: InputMaybe<Scalars['String']['input']>;
  thumbnail_url?: InputMaybe<Scalars['String']['input']>;
  weirdest_thing?: InputMaybe<Scalars['String']['input']>;
};

export type UpdatePimsReminderInput = {
  is_active?: InputMaybe<Scalars['Boolean']['input']>;
  is_completed?: InputMaybe<Scalars['Boolean']['input']>;
  pms_id?: InputMaybe<Scalars['String']['input']>;
  reminder_desc?: InputMaybe<Scalars['String']['input']>;
  reminder_pms_id?: InputMaybe<Scalars['String']['input']>;
  reminder_type?: InputMaybe<Scalars['ID']['input']>;
  send_date?: InputMaybe<Scalars['NonNegativeInt']['input']>;
};

export type UpdatePimsReminderTypeInput = {
  display_name?: InputMaybe<Scalars['String']['input']>;
  is_active?: InputMaybe<Scalars['Boolean']['input']>;
  reminder_type_name?: InputMaybe<Scalars['String']['input']>;
};

export type UpdatePimsSettingsInput = {
  access_token?: InputMaybe<Scalars['String']['input']>;
  access_token_expiration?: InputMaybe<Scalars['NonNegativeInt']['input']>;
  additional_key?: InputMaybe<Scalars['String']['input']>;
  api_clinic_id?: InputMaybe<Scalars['String']['input']>;
  api_key?: InputMaybe<Scalars['String']['input']>;
  api_subdomain?: InputMaybe<Scalars['String']['input']>;
  cookie?: InputMaybe<Array<Scalars['String']['input']>>;
  entered_by_pms_id?: InputMaybe<Scalars['String']['input']>;
  ezyvet_client_id?: InputMaybe<Scalars['String']['input']>;
  ezyvet_client_secret?: InputMaybe<Scalars['String']['input']>;
  ezyvet_integration_mode?: InputMaybe<EzyvetIntegrationMode>;
  ezyvet_scopes?: InputMaybe<Scalars['String']['input']>;
  ezyvet_site_uid?: InputMaybe<Scalars['String']['input']>;
  long_sync_interval_hours?: InputMaybe<Scalars['NonNegativeInt']['input']>;
  other_access_tokens?: InputMaybe<Array<Scalars['String']['input']>>;
  password?: InputMaybe<Scalars['String']['input']>;
  payment_type_pms_id?: InputMaybe<Scalars['String']['input']>;
  phones_api_key?: InputMaybe<Scalars['String']['input']>;
  phones_secondary_api_key?: InputMaybe<Scalars['String']['input']>;
  pims_version?: InputMaybe<Scalars['String']['input']>;
  pin?: InputMaybe<Scalars['String']['input']>;
  practice_key?: InputMaybe<Scalars['String']['input']>;
  pulse_ar_report_id?: InputMaybe<Scalars['String']['input']>;
  pulse_clients_report_id?: InputMaybe<Scalars['String']['input']>;
  pulse_patients_report_id?: InputMaybe<Scalars['String']['input']>;
  pulse_reminders_report_id?: InputMaybe<Scalars['String']['input']>;
  pulse_sales_report_id?: InputMaybe<Scalars['String']['input']>;
  pulse_vaccinations_report_id?: InputMaybe<Scalars['String']['input']>;
  refresh_token?: InputMaybe<Scalars['String']['input']>;
  request_verification_token?: InputMaybe<Scalars['String']['input']>;
  should_sync_clinician_hours?: InputMaybe<Scalars['Boolean']['input']>;
  sync_interval_minutes?: InputMaybe<Scalars['NonNegativeInt']['input']>;
  user_key?: InputMaybe<Scalars['String']['input']>;
  username?: InputMaybe<Scalars['String']['input']>;
};

export type UpdatePmsApptTypeInput = {
  color?: InputMaybe<Scalars['HexColorCode']['input']>;
  description?: InputMaybe<Scalars['String']['input']>;
  metadata?: InputMaybe<Scalars['JSON']['input']>;
  name?: InputMaybe<Scalars['String']['input']>;
};

export type UpdatePmsDbInput = {
  last_sync_times?: InputMaybe<LastSyncTimesInput>;
  name?: InputMaybe<Scalars['String']['input']>;
  pims_settings?: InputMaybe<UpdatePimsSettingsInput>;
  pms?: InputMaybe<PracticeManagementSystem>;
  /** Can only change before the database's first sync. */
  pms_connector?: InputMaybe<PmsConnector>;
  time_zone?: InputMaybe<Scalars['String']['input']>;
};

export type UpdatePrescriptionInput = {
  clinician?: InputMaybe<Scalars['ID']['input']>;
  description?: InputMaybe<Scalars['String']['input']>;
  expiration_date?: InputMaybe<Scalars['Timestamp']['input']>;
  is_active?: InputMaybe<Scalars['Boolean']['input']>;
  last_refill_time?: InputMaybe<Scalars['NonNegativeInt']['input']>;
  name?: InputMaybe<Scalars['String']['input']>;
  patient?: InputMaybe<Scalars['ID']['input']>;
  pms_created_at?: InputMaybe<Scalars['Timestamp']['input']>;
  pms_id?: InputMaybe<Scalars['String']['input']>;
  product?: InputMaybe<Scalars['ID']['input']>;
  product_name?: InputMaybe<Scalars['String']['input']>;
  quantity?: InputMaybe<Scalars['NonNegativeFloat']['input']>;
  refill_count?: InputMaybe<Scalars['NonNegativeInt']['input']>;
  refill_limit?: InputMaybe<Scalars['NonNegativeInt']['input']>;
  remaining?: InputMaybe<Scalars['NonNegativeFloat']['input']>;
};

export type UpdatePrescriptionRefillRequestInput = {
  amount?: InputMaybe<Scalars['NonNegativeInt']['input']>;
  appointment?: InputMaybe<Scalars['ID']['input']>;
  denial_reason?: InputMaybe<Scalars['String']['input']>;
  notes?: InputMaybe<Scalars['String']['input']>;
  patient?: InputMaybe<Scalars['ID']['input']>;
  pickup_time?: InputMaybe<Scalars['NonNegativeInt']['input']>;
  prescription?: InputMaybe<Scalars['ID']['input']>;
  status?: InputMaybe<PrescriptionRefillRequestStatus>;
  stripe_payment_intent_id?: InputMaybe<Scalars['String']['input']>;
  type?: InputMaybe<PrescriptionRefillRequestType>;
};

export type UpdatePressItemInput = {
  description?: InputMaybe<Scalars['String']['input']>;
  image?: InputMaybe<Scalars['String']['input']>;
  links?: InputMaybe<Array<LinkInput>>;
  title?: InputMaybe<Scalars['String']['input']>;
};

export type UpdateProductInput = {
  additional_fees?: InputMaybe<Array<AdditionalFeesInput>>;
  category?: InputMaybe<ProductCategory>;
  chckvet_price?: InputMaybe<Scalars['Int']['input']>;
  code?: InputMaybe<Scalars['String']['input']>;
  description?: InputMaybe<Scalars['String']['input']>;
  display_name?: InputMaybe<Scalars['String']['input']>;
  is_active?: InputMaybe<Scalars['Boolean']['input']>;
  name?: InputMaybe<Scalars['String']['input']>;
  pims_category?: InputMaybe<Scalars['String']['input']>;
  prescription_fee_split_override?: InputMaybe<Scalars['Float']['input']>;
  price?: InputMaybe<Scalars['Int']['input']>;
  unit?: InputMaybe<Scalars['String']['input']>;
  volume?: InputMaybe<Scalars['String']['input']>;
};

export type UpdateProviderAvailabilityInput = {
  date?: InputMaybe<Scalars['NonNegativeInt']['input']>;
  end?: InputMaybe<Scalars['NonNegativeInt']['input']>;
  is_for_booking?: InputMaybe<Scalars['Boolean']['input']>;
  repeat_days_of_month?: InputMaybe<Array<Scalars['NonNegativeInt']['input']>>;
  repeat_days_of_week?: InputMaybe<Array<AvailabilityDay>>;
  repeat_end_date?: InputMaybe<Scalars['NonNegativeInt']['input']>;
  repeat_frequency?: InputMaybe<Scalars['NonNegativeInt']['input']>;
  repeat_unit?: InputMaybe<RepeatUnit>;
  repeat_week_of_month?: InputMaybe<WeekOfMonth>;
  routine_days?: InputMaybe<Array<InputMaybe<AvailabilityDay>>>;
  start?: InputMaybe<Scalars['NonNegativeInt']['input']>;
  type?: InputMaybe<AvailabilityType>;
  valid_to?: InputMaybe<Scalars['NonNegativeInt']['input']>;
};

export type UpdateReportColumnValueInput = {
  percentile?: InputMaybe<Scalars['NonNegativeFloat']['input']>;
  value?: InputMaybe<Scalars['Float']['input']>;
  value_params?: InputMaybe<MetricValueParamsInput>;
};

export type UpdateReportMetricInput = {
  aggregate_field_override?: InputMaybe<Scalars['String']['input']>;
  custom_query?: InputMaybe<Scalars['JSON']['input']>;
  field_modifiers?: InputMaybe<Array<ReportMetricModifierInput>>;
  format?: InputMaybe<MetricFormat>;
  inverse_percentile?: InputMaybe<Scalars['Boolean']['input']>;
  is_archived?: InputMaybe<Scalars['Boolean']['input']>;
  name?: InputMaybe<Scalars['String']['input']>;
  order?: InputMaybe<Scalars['NonNegativeInt']['input']>;
  organization_report?: InputMaybe<Scalars['ID']['input']>;
  report_template?: InputMaybe<Scalars['ID']['input']>;
  special_modifier?: InputMaybe<SpecialMetricModifierType>;
  time_field_override?: InputMaybe<Scalars['String']['input']>;
  time_params_overrides?: InputMaybe<TimeParamsInput>;
  type?: InputMaybe<ReportMetricType>;
  value_types?: InputMaybe<Array<MetricValueParamsInput>>;
};

export type UpdateReportTemplateInput = {
  description?: InputMaybe<Scalars['String']['input']>;
  entity_structure?: InputMaybe<Array<Scalars['String']['input']>>;
  is_active?: InputMaybe<Scalars['Boolean']['input']>;
  name?: InputMaybe<Scalars['String']['input']>;
  preferred_view_type?: InputMaybe<ReportViewType>;
  repeat?: InputMaybe<RepeatParamsInput>;
  report_metrics?: InputMaybe<Array<Scalars['ID']['input']>>;
  time_params?: InputMaybe<TimeParamsInput>;
};

export type UpdateReportValueInput = {
  column_values?: InputMaybe<Array<UpdateReportColumnValueInput>>;
  key?: InputMaybe<Scalars['String']['input']>;
  metric?: InputMaybe<ReportMetricType>;
};

export type UpdateRescheduleInput = {
  appointment?: InputMaybe<Scalars['ID']['input']>;
  client_notes?: InputMaybe<Scalars['String']['input']>;
  clinic?: InputMaybe<Scalars['ID']['input']>;
  clinic_notes?: InputMaybe<Scalars['String']['input']>;
  confirmed_at?: InputMaybe<Scalars['NonNegativeInt']['input']>;
  initiated_by?: InputMaybe<RescheduleInitiatedBy>;
  original_clinician?: InputMaybe<Scalars['ID']['input']>;
  original_drop_off_time?: InputMaybe<Scalars['NonNegativeInt']['input']>;
  original_start_time?: InputMaybe<Scalars['NonNegativeInt']['input']>;
  reason_for_denial?: InputMaybe<Scalars['String']['input']>;
  requested_clinician?: InputMaybe<Scalars['ID']['input']>;
  requested_drop_off_time?: InputMaybe<Scalars['NonNegativeInt']['input']>;
  requested_start_time?: InputMaybe<Scalars['NonNegativeInt']['input']>;
  status?: InputMaybe<RescheduleStatus>;
};

export type UpdateRoomInput = {
  adjusted_availability?: InputMaybe<Array<AvailabilityInput>>;
  concurrent_patients?: InputMaybe<Scalars['NonNegativeInt']['input']>;
  description?: InputMaybe<Scalars['String']['input']>;
  display_name?: InputMaybe<Scalars['String']['input']>;
  does_contribute_to_fill_rate?: InputMaybe<Scalars['Boolean']['input']>;
  hours?: InputMaybe<AvailabilityHoursInput>;
  is_active?: InputMaybe<Scalars['Boolean']['input']>;
  name?: InputMaybe<Scalars['String']['input']>;
  pms_adjusted_availability?: InputMaybe<Array<AvailabilityInput>>;
  stagger_offset_minutes?: InputMaybe<Scalars['NonNegativeInt']['input']>;
  valid_booking_interval_minutes?: InputMaybe<Array<Scalars['NonNegativeInt']['input']>>;
};

export type UpdateRoomServiceInput = {
  duration_override?: InputMaybe<Scalars['NonNegativeInt']['input']>;
  is_active?: InputMaybe<Scalars['Boolean']['input']>;
  room?: InputMaybe<Scalars['ID']['input']>;
  service?: InputMaybe<Scalars['ID']['input']>;
};

/**
 * Partial update — omitted fields are left unchanged. (No input defaults:
 * a defaulted `is_active` would silently activate a linked clinic copy on
 * an unrelated edit such as staggering its send time.)
 */
export type UpdateScheduledBulkMessageInput = {
  body?: InputMaybe<Scalars['String']['input']>;
  campaign?: InputMaybe<Scalars['ID']['input']>;
  cta_text?: InputMaybe<Scalars['String']['input']>;
  cta_url?: InputMaybe<Scalars['String']['input']>;
  customer_segment?: InputMaybe<Scalars['ID']['input']>;
  email_body?: InputMaybe<Scalars['String']['input']>;
  email_design?: InputMaybe<Scalars['JSON']['input']>;
  email_html?: InputMaybe<Scalars['String']['input']>;
  email_template?: InputMaybe<Scalars['ID']['input']>;
  excluded_clients?: InputMaybe<Array<Scalars['ID']['input']>>;
  header?: InputMaybe<Scalars['String']['input']>;
  included_clients?: InputMaybe<Array<Scalars['ID']['input']>>;
  is_active?: InputMaybe<Scalars['Boolean']['input']>;
  is_archived?: InputMaybe<Scalars['Boolean']['input']>;
  is_completed?: InputMaybe<Scalars['Boolean']['input']>;
  is_marketing?: InputMaybe<Scalars['Boolean']['input']>;
  is_system?: InputMaybe<Scalars['Boolean']['input']>;
  message_methods?: InputMaybe<Array<MessageMethod>>;
  name?: InputMaybe<Scalars['String']['input']>;
  notif_attachments?: InputMaybe<Array<CreateAttachmentInput>>;
  send_time?: InputMaybe<Scalars['NonNegativeInt']['input']>;
  started_at?: InputMaybe<Scalars['NonNegativeInt']['input']>;
  subject?: InputMaybe<Scalars['String']['input']>;
};

export type UpdateScheduledMessageInput = {
  cta_text?: InputMaybe<Scalars['String']['input']>;
  cta_url?: InputMaybe<Scalars['String']['input']>;
  email_text?: InputMaybe<Scalars['String']['input']>;
  message_attachments?: InputMaybe<Array<CreateAttachmentInput>>;
  message_methods?: InputMaybe<Array<MessageMethod>>;
  send_time?: InputMaybe<Scalars['NonNegativeInt']['input']>;
  subject?: InputMaybe<Scalars['String']['input']>;
  text?: InputMaybe<Scalars['String']['input']>;
};

export type UpdateSchedulingRulesInput = {
  adjusted_availability?: InputMaybe<Array<AvailabilityInput>>;
  availability?: InputMaybe<AvailabilityHoursInput>;
  client_type?: InputMaybe<ClientTypeEnum>;
  fixed_status?: InputMaybe<FixedStatus>;
  included_client_audiences?: InputMaybe<Array<Scalars['ID']['input']>>;
  included_clinicians?: InputMaybe<Array<Scalars['ID']['input']>>;
  included_patient_audiences?: InputMaybe<Array<Scalars['ID']['input']>>;
  included_rooms?: InputMaybe<Array<Scalars['ID']['input']>>;
  included_services?: InputMaybe<Array<Scalars['ID']['input']>>;
  included_species?: InputMaybe<Array<Scalars['ID']['input']>>;
  is_active?: InputMaybe<Scalars['Boolean']['input']>;
  is_simple_rule?: InputMaybe<Scalars['Boolean']['input']>;
  max_per_rule?: InputMaybe<Scalars['NonNegativeInt']['input']>;
  only_modifier?: InputMaybe<OnlyModifierEnum>;
  patient_gender?: InputMaybe<AnimalGender>;
  patient_type?: InputMaybe<PatientTypeEnum>;
};

export type UpdateServiceCategoryInput = {
  confirmation_message?: InputMaybe<Scalars['String']['input']>;
  description?: InputMaybe<Scalars['String']['input']>;
  icon?: InputMaybe<ServiceCategoryIcon>;
  order?: InputMaybe<Scalars['NonNegativeInt']['input']>;
  requires_confirmation?: InputMaybe<Scalars['Boolean']['input']>;
  title?: InputMaybe<Scalars['String']['input']>;
};

export type UpdateServiceFormInput = {
  client_type?: InputMaybe<ClientTypeEnum>;
  form?: InputMaybe<Scalars['ID']['input']>;
  is_required_before_booking?: InputMaybe<Scalars['Boolean']['input']>;
  is_required_before_confirming?: InputMaybe<Scalars['Boolean']['input']>;
  service?: InputMaybe<Scalars['ID']['input']>;
};

/**
 * Write payload to update a service. Field meanings match Service (read that
 * type's introspection descriptions). Deprecated fields are stored but unused.
 */
export type UpdateServiceInput = {
  action_required_acknowledgement_text?: InputMaybe<Scalars['String']['input']>;
  allow_new?: InputMaybe<Scalars['Boolean']['input']>;
  allow_returning?: InputMaybe<Scalars['Boolean']['input']>;
  allowed_appt_type_pms_ids?: InputMaybe<Array<Scalars['String']['input']>>;
  authorized_levels?: InputMaybe<Array<AuthorityLevel>>;
  availability?: InputMaybe<AvailabilityHoursInput>;
  clinic?: InputMaybe<Scalars['ID']['input']>;
  color?: InputMaybe<Scalars['String']['input']>;
  custom_appointment_notes_template?: InputMaybe<Scalars['String']['input']>;
  custom_new_client_notes_template?: InputMaybe<Scalars['String']['input']>;
  custom_new_patient_notes_template?: InputMaybe<Scalars['String']['input']>;
  /** Optional default room stored on the service and included on Connect appointment payloads. Online booking does not auto-assign from this field. */
  default_room?: InputMaybe<Scalars['ID']['input']>;
  description?: InputMaybe<Scalars['String']['input']>;
  drop_off_hours?: InputMaybe<AvailabilityHoursInput>;
  drop_off_minutes_before?: InputMaybe<Scalars['NonNegativeInt']['input']>;
  drop_off_time?: InputMaybe<Scalars['String']['input']>;
  duration?: InputMaybe<Scalars['NonNegativeInt']['input']>;
  exclude_from_portal?: InputMaybe<Scalars['Boolean']['input']>;
  excluded_species?: InputMaybe<Array<Species>>;
  follow_up_services?: InputMaybe<Array<Scalars['ID']['input']>>;
  follow_up_settings?: InputMaybe<UpdateFollowUpSettingsInput>;
  hide_clinician_preference?: InputMaybe<Scalars['Boolean']['input']>;
  is_active?: InputMaybe<Scalars['Boolean']['input']>;
  is_blocking?: InputMaybe<Scalars['Boolean']['input']>;
  is_cancellation_allowed?: InputMaybe<Scalars['Boolean']['input']>;
  is_primary_for_appt_type?: InputMaybe<Scalars['Boolean']['input']>;
  is_reschedule_allowed?: InputMaybe<Scalars['Boolean']['input']>;
  keywords?: InputMaybe<Scalars['String']['input']>;
  max_per_day?: InputMaybe<Scalars['NonNegativeInt']['input']>;
  max_per_hour?: InputMaybe<Scalars['NonNegativeInt']['input']>;
  maximum_patient_age_in_days?: InputMaybe<Scalars['NonNegativeInt']['input']>;
  minimum_patient_age_in_days?: InputMaybe<Scalars['NonNegativeInt']['input']>;
  more_info?: InputMaybe<Scalars['String']['input']>;
  more_info_action_required?: InputMaybe<Scalars['String']['input']>;
  name?: InputMaybe<Scalars['String']['input']>;
  only_use_adj_avail_guides?: InputMaybe<Scalars['Boolean']['input']>;
  order?: InputMaybe<Scalars['NonNegativeInt']['input']>;
  pick_up_time?: InputMaybe<Scalars['String']['input']>;
  pms_appt_type?: InputMaybe<Scalars['ID']['input']>;
  points?: InputMaybe<Scalars['NonNegativeInt']['input']>;
  pre_confirmation_checklist?: InputMaybe<Array<ServicePreConfirmationItemInput>>;
  pricing?: InputMaybe<UpdateServicePricingInput>;
  recurring?: InputMaybe<RecurringSettingsInput>;
  required_room?: InputMaybe<Scalars['ID']['input']>;
  reserved_per_day?: InputMaybe<Scalars['NonNegativeInt']['input']>;
  scheduling_buffer_minutes?: InputMaybe<Scalars['NonNegativeInt']['input']>;
  scheduling_max_minutes_away?: InputMaybe<Scalars['NonNegativeInt']['input']>;
  scheduling_min_minutes_away?: InputMaybe<Scalars['NonNegativeInt']['input']>;
  service_category_ids?: InputMaybe<Array<Scalars['ID']['input']>>;
  service_types?: InputMaybe<Array<ServiceType>>;
  use_previous_doctor?: InputMaybe<Scalars['Boolean']['input']>;
  valid_booking_interval_minutes?: InputMaybe<Array<Scalars['NonNegativeInt']['input']>>;
};

export type UpdateServicePricingInput = {
  client_type?: InputMaybe<ClientTypeEnum>;
  currency?: InputMaybe<Scalars['Currency']['input']>;
  price?: InputMaybe<Scalars['PositiveInt']['input']>;
  type?: InputMaybe<ServicePricingType>;
};

export type UpdateTagCategoryInput = {
  allowed_entities?: InputMaybe<Array<TagEntity>>;
  color?: InputMaybe<Scalars['String']['input']>;
  is_archived?: InputMaybe<Scalars['Boolean']['input']>;
  name?: InputMaybe<Scalars['String']['input']>;
};

export type UpdateTransactionInput = {
  amount?: InputMaybe<Scalars['String']['input']>;
  client_pms_id?: InputMaybe<Scalars['ID']['input']>;
  clinician_pms_id?: InputMaybe<Scalars['ID']['input']>;
  date?: InputMaybe<Scalars['NonNegativeInt']['input']>;
  description?: InputMaybe<Scalars['String']['input']>;
  patient_pms_id?: InputMaybe<Scalars['ID']['input']>;
  pms?: InputMaybe<PracticeManagementSystem>;
  pms_id?: InputMaybe<Scalars['String']['input']>;
  service_pms_id?: InputMaybe<Scalars['ID']['input']>;
  type?: InputMaybe<TransactionType>;
};

export type UpdateTreatmentInput = {
  description?: InputMaybe<Scalars['String']['input']>;
  pms_id?: InputMaybe<Scalars['String']['input']>;
  price?: InputMaybe<Scalars['Float']['input']>;
};

export type UpdateUserAuthInfoInput = {
  clinicGroupId?: InputMaybe<Scalars['ID']['input']>;
  clinicId?: InputMaybe<Scalars['ID']['input']>;
  email?: InputMaybe<Scalars['String']['input']>;
  password?: InputMaybe<Scalars['String']['input']>;
};

export type UpdateUserInput = {
  address?: InputMaybe<AddressInput>;
  avatar_url?: InputMaybe<Scalars['String']['input']>;
  clinician?: InputMaybe<Scalars['ID']['input']>;
  email?: InputMaybe<Scalars['EmailAddress']['input']>;
  enabled_notification_sounds?: InputMaybe<Array<UserNotificationSound>>;
  family?: InputMaybe<Scalars['ID']['input']>;
  favorited_clinics?: InputMaybe<Array<Scalars['ID']['input']>>;
  first_name?: InputMaybe<Scalars['String']['input']>;
  has_agreed_to_terms?: InputMaybe<Scalars['Boolean']['input']>;
  has_verified_email?: InputMaybe<Scalars['Boolean']['input']>;
  has_verified_phone?: InputMaybe<Scalars['Boolean']['input']>;
  invitation_status?: InputMaybe<UserInvitationStatus>;
  last_name?: InputMaybe<Scalars['String']['input']>;
  must_reset_password?: InputMaybe<Scalars['Boolean']['input']>;
  notify_desktop_on?: InputMaybe<Array<NotifyClinicOn>>;
  notify_email_on?: InputMaybe<Array<NotifyClinicOn>>;
  notify_sound_on?: InputMaybe<Array<NotifyClinicOn>>;
  phone?: InputMaybe<Scalars['String']['input']>;
  phone_country?: InputMaybe<Scalars['String']['input']>;
  role?: InputMaybe<AuthRoles>;
  stripe_customer_id?: InputMaybe<Scalars['String']['input']>;
};

export type UpdateWidgetInput = {
  average_chat_response_time?: InputMaybe<Scalars['String']['input']>;
  button_color?: InputMaybe<Scalars['String']['input']>;
  button_text?: InputMaybe<Scalars['String']['input']>;
  campaign?: InputMaybe<Scalars['ID']['input']>;
  clinic?: InputMaybe<Scalars['ID']['input']>;
  enabled_chat_buttons?: InputMaybe<Array<WidgetMenuButtonType>>;
  featured_reviews?: InputMaybe<Array<FeaturedReviewInput>>;
  is_active?: InputMaybe<Scalars['Boolean']['input']>;
  is_archived?: InputMaybe<Scalars['Boolean']['input']>;
  is_external?: InputMaybe<Scalars['Boolean']['input']>;
  organization?: InputMaybe<Scalars['ID']['input']>;
  source?: InputMaybe<Scalars['String']['input']>;
  tags?: InputMaybe<Array<Scalars['String']['input']>>;
  text_color?: InputMaybe<Scalars['String']['input']>;
  trigger_type?: InputMaybe<WidgetTriggerType>;
  type?: InputMaybe<WidgetType>;
  widget_name?: InputMaybe<Scalars['String']['input']>;
  widget_styles?: InputMaybe<WidgetStylesInput>;
};

export type UpdateWidgetOptionsInput = {
  booking_avail_end?: InputMaybe<Scalars['NonNegativeInt']['input']>;
  booking_avail_start?: InputMaybe<Scalars['NonNegativeInt']['input']>;
  custom_booking_copy?: InputMaybe<ClinicBookingCopyInput>;
  custom_other_description?: InputMaybe<Scalars['String']['input']>;
  custom_other_title?: InputMaybe<Scalars['String']['input']>;
  custom_sick_description?: InputMaybe<Scalars['String']['input']>;
  custom_tracking_properties?: InputMaybe<CustomTrackingPropertiesInput>;
  custom_well_description?: InputMaybe<Scalars['String']['input']>;
  default_trigger_words?: InputMaybe<Array<Scalars['String']['input']>>;
  enabled?: InputMaybe<Scalars['Boolean']['input']>;
  facebook_pixel_id?: InputMaybe<Scalars['String']['input']>;
  fb_event_name_overrides?: InputMaybe<GaEventNameOverridesInput>;
  ga_event_name_overrides?: InputMaybe<GaEventNameOverridesInput>;
  ga_measurement_id?: InputMaybe<Scalars['String']['input']>;
  gtm_container_id?: InputMaybe<Scalars['String']['input']>;
  hide_clinician_preference?: InputMaybe<Scalars['Boolean']['input']>;
  primary_clinic_group_id?: InputMaybe<Scalars['String']['input']>;
  redirect_after_booking_url?: InputMaybe<Scalars['String']['input']>;
  redirect_countdown_seconds?: InputMaybe<Scalars['NonNegativeInt']['input']>;
  scheduling_buffer_minutes?: InputMaybe<Scalars['NonNegativeInt']['input']>;
  scheduling_max_minutes_away?: InputMaybe<Scalars['NonNegativeInt']['input']>;
  scheduling_min_minutes_away?: InputMaybe<Scalars['NonNegativeInt']['input']>;
  should_allow_new_clients?: InputMaybe<Scalars['Boolean']['input']>;
  should_allow_new_patients?: InputMaybe<Scalars['Boolean']['input']>;
  should_allow_returning_clients?: InputMaybe<Scalars['Boolean']['input']>;
  should_allow_returning_patients?: InputMaybe<Scalars['Boolean']['input']>;
  should_suggest_nearby_clinics?: InputMaybe<Scalars['Boolean']['input']>;
  time_slot_minutes?: InputMaybe<Scalars['NonNegativeInt']['input']>;
  times_first_filter_config?: InputMaybe<TimesFirstFilterConfigInput>;
  widget?: InputMaybe<Scalars['String']['input']>;
  widget_access_end_time?: InputMaybe<Scalars['NonNegativeInt']['input']>;
  widget_access_start_time?: InputMaybe<Scalars['NonNegativeInt']['input']>;
  widget_referral_code?: InputMaybe<Scalars['String']['input']>;
  widget_styles?: InputMaybe<WidgetStylesInput>;
};

export type UpdateWidgetServiceInput = {
  is_active?: InputMaybe<Scalars['Boolean']['input']>;
  service?: InputMaybe<Scalars['String']['input']>;
  widget?: InputMaybe<Scalars['String']['input']>;
};

export type UpdateWidgetSisterLocationInput = {
  is_active: Scalars['Boolean']['input'];
};

/**
 * Booking-flow order. UrgentCare is Times-First (time before name/pet).
 * GeneralPractice is client/service then time. Scheduling rules still apply
 * in both modes. Times-First filter visibility is times_first_filter_config.
 */
export enum UrgencyType {
  GeneralPractice = 'GeneralPractice',
  UrgentCare = 'UrgentCare'
}

export type UsageCounts = {
  __typename?: 'UsageCounts';
  all_time: Scalars['NonNegativeInt']['output'];
  last_24h: Scalars['NonNegativeInt']['output'];
  last_month: Scalars['NonNegativeInt']['output'];
  last_week: Scalars['NonNegativeInt']['output'];
  previous_month: Scalars['NonNegativeInt']['output'];
  previous_week: Scalars['NonNegativeInt']['output'];
};

export type UsageTimeRangeInput = {
  end: Scalars['NonNegativeInt']['input'];
  start: Scalars['NonNegativeInt']['input'];
};

export type User = {
  __typename?: 'User';
  address?: Maybe<Address>;
  avatar_url?: Maybe<Scalars['String']['output']>;
  clients: Array<Client>;
  clinician?: Maybe<Clinician>;
  created_at: Scalars['Timestamp']['output'];
  desktop_notification_token?: Maybe<Scalars['String']['output']>;
  email?: Maybe<Scalars['EmailAddress']['output']>;
  enabled_notification_sounds?: Maybe<Array<UserNotificationSound>>;
  family?: Maybe<Family>;
  favorited_clinics?: Maybe<Array<Clinic>>;
  first_name?: Maybe<Scalars['String']['output']>;
  has_agreed_to_terms?: Maybe<Scalars['Boolean']['output']>;
  has_verified_email?: Maybe<Scalars['Boolean']['output']>;
  has_verified_phone?: Maybe<Scalars['Boolean']['output']>;
  id: Scalars['ID']['output'];
  invitation_status?: Maybe<UserInvitationStatus>;
  invited_at?: Maybe<Scalars['Timestamp']['output']>;
  last_name?: Maybe<Scalars['String']['output']>;
  /**
   * Last native mobile app launch. Null if this user has never opened the
   * Capacitor app. Updated by recordMobileAppLoggedIn.
   */
  mobile_app_logged_in_at?: Maybe<Scalars['Timestamp']['output']>;
  must_reset_password?: Maybe<Scalars['Boolean']['output']>;
  /**
   * Practice events reserved for the desktop notifier. Stored now so we
   * can wire the notifier without another preference migration.
   */
  notify_desktop_on?: Maybe<Array<NotifyClinicOn>>;
  /**
   * Practice events this user wants emailed to their user email.
   * Distinct from clinic.settings.notify_clinic_on (office-email fallback).
   * Null means unset — senders still use the clinic office-email list.
   */
  notify_email_on?: Maybe<Array<NotifyClinicOn>>;
  /**
   * Practice events that should play an in-app sound for this user.
   * NewMessage is kept in sync with enabled_notification_sounds Inbox.
   */
  notify_sound_on?: Maybe<Array<NotifyClinicOn>>;
  phone?: Maybe<Scalars['String']['output']>;
  phone_country?: Maybe<Scalars['String']['output']>;
  push_notification_token?: Maybe<Scalars['String']['output']>;
  role?: Maybe<AuthRoles>;
  stripe_customer_id?: Maybe<Scalars['String']['output']>;
  updated_at: Scalars['Timestamp']['output'];
};

export enum UserInvitationStatus {
  Accepted = 'Accepted',
  Pending = 'Pending'
}

/**
 * A single in-app notification surfaced in the dashboard bell tray.
 * Carries a typed `payload` so different notification kinds can attach
 * their own identifiers without changing the schema.
 */
export type UserNotification = {
  __typename?: 'UserNotification';
  body?: Maybe<Scalars['String']['output']>;
  clinic?: Maybe<Clinic>;
  created_at: Scalars['Timestamp']['output'];
  created_by_user?: Maybe<User>;
  id: Scalars['ID']['output'];
  link_url?: Maybe<Scalars['String']['output']>;
  payload?: Maybe<Scalars['JSON']['output']>;
  read_at?: Maybe<Scalars['Timestamp']['output']>;
  recipient_user: User;
  seen_at?: Maybe<Scalars['Timestamp']['output']>;
  title: Scalars['String']['output'];
  type: UserNotificationType;
  updated_at: Scalars['Timestamp']['output'];
};

export enum UserNotificationSound {
  Inbox = 'Inbox',
  PendingActions = 'PendingActions',
  TeamChat = 'TeamChat'
}

export enum UserNotificationType {
  MentionedInInternalNote = 'MentionedInInternalNote',
  MentionedInTeamChat = 'MentionedInTeamChat'
}

export type UserTrackingClient = {
  __typename?: 'UserTrackingClient';
  client: Client;
  has_mobile_app: Scalars['Boolean']['output'];
  has_portal_account: Scalars['Boolean']['output'];
};

export type UserTrackingClientPage = {
  __typename?: 'UserTrackingClientPage';
  count: Scalars['NonNegativeInt']['output'];
  results: Array<UserTrackingClient>;
};

export enum UserTrackingMembership {
  Matching = 'Matching',
  NotMatching = 'NotMatching'
}

export enum UserTrackingMetric {
  AppAdoption = 'AppAdoption',
  AppConversion = 'AppConversion',
  PortalAdoption = 'PortalAdoption'
}

export type UserTrackingMetricResult = {
  __typename?: 'UserTrackingMetricResult';
  denominator_count: Scalars['NonNegativeInt']['output'];
  metric: UserTrackingMetric;
  numerator_count: Scalars['NonNegativeInt']['output'];
  percentage?: Maybe<Scalars['NonNegativeFloat']['output']>;
};

export type UserTrackingSummary = {
  __typename?: 'UserTrackingSummary';
  app_adoption: UserTrackingMetricResult;
  app_conversion: UserTrackingMetricResult;
  portal_adoption: UserTrackingMetricResult;
};

export type VaccineRecordItem = {
  __typename?: 'VaccineRecordItem';
  administered_date?: Maybe<Scalars['NonNegativeInt']['output']>;
  due_date?: Maybe<Scalars['NonNegativeInt']['output']>;
  id: Scalars['ID']['output'];
  is_rabies_vaccine?: Maybe<Scalars['Boolean']['output']>;
  rabies_tag?: Maybe<Scalars['String']['output']>;
  vaccine_name?: Maybe<Scalars['String']['output']>;
};

export type VaccineRecordsView = {
  __typename?: 'VaccineRecordsView';
  /**
   * Online-booking deep link for this clinic, already env-resolved and
   * attribution-tagged. Null when the clinic has online scheduling
   * disabled or no slug — the page hides the booking CTA in that case.
   */
  booking_url?: Maybe<Scalars['String']['output']>;
  clinic_address?: Maybe<Scalars['String']['output']>;
  clinic_avatar_url?: Maybe<Scalars['String']['output']>;
  clinic_name: Scalars['String']['output'];
  clinic_phone?: Maybe<Scalars['String']['output']>;
  clinic_primary_color?: Maybe<Scalars['String']['output']>;
  clinic_time_zone?: Maybe<Scalars['String']['output']>;
  clinic_website?: Maybe<Scalars['String']['output']>;
  pet_birthday?: Maybe<Scalars['Float']['output']>;
  pet_breed?: Maybe<Scalars['String']['output']>;
  pet_fixed_status?: Maybe<Scalars['String']['output']>;
  pet_name: Scalars['String']['output'];
  pet_sex?: Maybe<Scalars['String']['output']>;
  records: Array<VaccineRecordItem>;
};

export enum VerificationMethod {
  Email = 'EMAIL',
  Sms = 'SMS'
}

export type VerifyClientLinkInput = {
  client_id: Scalars['ID']['input'];
  code: Scalars['String']['input'];
  email_id?: InputMaybe<Scalars['ID']['input']>;
  method: VerificationMethod;
  phone_id?: InputMaybe<Scalars['ID']['input']>;
};

/** A vet visit / consult (SOAP) synced from the PMS. */
export type Visit = {
  __typename?: 'Visit';
  appointment?: Maybe<Scalars['ID']['output']>;
  assessment?: Maybe<Scalars['String']['output']>;
  assisted_by?: Maybe<Scalars['String']['output']>;
  check_in_time?: Maybe<Scalars['Timestamp']['output']>;
  check_out_time?: Maybe<Scalars['Timestamp']['output']>;
  clinic?: Maybe<Scalars['ID']['output']>;
  clinician?: Maybe<Scalars['ID']['output']>;
  completed_at?: Maybe<Scalars['Timestamp']['output']>;
  created_at: Scalars['Timestamp']['output'];
  id: Scalars['ID']['output'];
  is_internal: Scalars['Boolean']['output'];
  notes?: Maybe<Scalars['String']['output']>;
  objective?: Maybe<Scalars['String']['output']>;
  patient?: Maybe<Scalars['ID']['output']>;
  plan?: Maybe<Scalars['String']['output']>;
  pms_id?: Maybe<Scalars['String']['output']>;
  reason?: Maybe<Scalars['String']['output']>;
  status?: Maybe<VisitStatus>;
  subjective?: Maybe<Scalars['String']['output']>;
  title?: Maybe<Scalars['String']['output']>;
  type?: Maybe<Scalars['String']['output']>;
  updated_at: Scalars['Timestamp']['output'];
  visit_date?: Maybe<Scalars['Timestamp']['output']>;
};

/**
 * A diagnosis / finding recorded on a specific visit. Links a visit to a
 * patient concern.
 */
export type VisitConcern = {
  __typename?: 'VisitConcern';
  assessment?: Maybe<Scalars['String']['output']>;
  created_at: Scalars['Timestamp']['output'];
  id: Scalars['ID']['output'];
  name?: Maybe<Scalars['String']['output']>;
  patient?: Maybe<Scalars['ID']['output']>;
  patient_concern?: Maybe<Scalars['ID']['output']>;
  plan?: Maybe<Scalars['String']['output']>;
  pms_id?: Maybe<Scalars['String']['output']>;
  sort_order?: Maybe<Scalars['Int']['output']>;
  updated_at: Scalars['Timestamp']['output'];
  visit?: Maybe<Scalars['ID']['output']>;
};

export enum VisitReason {
  AdmissionForProcedure = 'AdmissionForProcedure',
  DayAdmission = 'DayAdmission',
  MedicationOrFoodPickUp = 'MedicationOrFoodPickUp',
  Other = 'Other',
  OutpatientAppointmentWithNurse = 'OutpatientAppointmentWithNurse',
  PatientPickUp = 'PatientPickUp',
  RecheckExam = 'RecheckExam',
  SickVisit = 'SickVisit',
  WellnessVisit = 'WellnessVisit'
}

export enum VisitStatus {
  Cancelled = 'Cancelled',
  Completed = 'Completed',
  InProgress = 'InProgress'
}

export type WalletSetupIntent = {
  __typename?: 'WalletSetupIntent';
  client_secret: Scalars['String']['output'];
};

export type WebhookConfig = {
  __typename?: 'WebhookConfig';
  enabled: Scalars['Boolean']['output'];
  events: Array<WebhookEventType>;
  id: Scalars['ID']['output'];
  name: Scalars['String']['output'];
  secret?: Maybe<Scalars['String']['output']>;
  url: Scalars['String']['output'];
};

export type WebhookConfigInput = {
  enabled: Scalars['Boolean']['input'];
  events: Array<WebhookEventType>;
  id: Scalars['ID']['input'];
  name: Scalars['String']['input'];
  secret?: InputMaybe<Scalars['String']['input']>;
  url: Scalars['String']['input'];
};

export enum WebhookEventType {
  AppointmentSubmit = 'AppointmentSubmit',
  LeadCaptured = 'LeadCaptured'
}

export enum WeekOfMonth {
  First = 'first',
  Fourth = 'fourth',
  Last = 'last',
  Second = 'second',
  Third = 'third'
}

export type Widget = {
  __typename?: 'Widget';
  average_chat_response_time?: Maybe<Scalars['String']['output']>;
  button_color?: Maybe<Scalars['String']['output']>;
  button_text?: Maybe<Scalars['String']['output']>;
  campaign?: Maybe<Campaign>;
  clinic?: Maybe<Clinic>;
  clinic_group?: Maybe<ClinicGroup>;
  created_at: Scalars['Timestamp']['output'];
  enabled_chat_buttons?: Maybe<Array<WidgetMenuButtonType>>;
  featured_reviews?: Maybe<Array<FeaturedReview>>;
  id: Scalars['ID']['output'];
  is_active: Scalars['Boolean']['output'];
  is_archived: Scalars['Boolean']['output'];
  is_default_portal: Scalars['Boolean']['output'];
  is_external: Scalars['Boolean']['output'];
  organization?: Maybe<Organization>;
  source?: Maybe<Scalars['String']['output']>;
  tags?: Maybe<Array<Scalars['String']['output']>>;
  text_color?: Maybe<Scalars['String']['output']>;
  trigger_type: WidgetTriggerType;
  type: WidgetType;
  updated_at: Scalars['Timestamp']['output'];
  widget_name: Scalars['String']['output'];
  widget_options?: Maybe<WidgetOptions>;
  widget_styles?: Maybe<WidgetStyles>;
  widgets_services?: Maybe<Array<WidgetService>>;
};

/**
 * Booking performance of one widget over a date range, counted in booking
 * sessions: visits where someone had a real chance to book. Booking links
 * and booking pages count once booking is in view for 5+ seconds or tapped;
 * widgets embedded on other pages count once tapped; bots and internal
 * traffic never count; one visitor's sessions under 30 minutes apart count
 * once.
 */
export type WidgetBookingSourceStats = {
  __typename?: 'WidgetBookingSourceStats';
  /** Every booking made in those booking sessions. */
  appointments_booked: Scalars['NonNegativeInt']['output'];
  /** Share (0..1) of booking sessions that booked at least once (0 when there are none). */
  conversion_rate: Scalars['Float']['output'];
  /** Booking sessions started in the range. */
  sessions_started: Scalars['NonNegativeInt']['output'];
  widget: Widget;
};

export enum WidgetHeadingFont {
  Bold = 'Bold',
  Fun = 'Fun',
  Refined = 'Refined',
  Simple = 'Simple'
}

export enum WidgetMenuButtonType {
  Boarding = 'Boarding',
  BookAppointment = 'BookAppointment',
  Grooming = 'Grooming',
  PrescriptionRefill = 'PrescriptionRefill',
  RescheduleAppointment = 'RescheduleAppointment',
  StartConversation = 'StartConversation'
}

export type WidgetOptions = {
  __typename?: 'WidgetOptions';
  booking_avail_end?: Maybe<Scalars['NonNegativeInt']['output']>;
  booking_avail_start?: Maybe<Scalars['NonNegativeInt']['output']>;
  created_at: Scalars['Timestamp']['output'];
  custom_booking_copy?: Maybe<ClinicBookingCopy>;
  custom_other_description?: Maybe<Scalars['String']['output']>;
  custom_other_title?: Maybe<Scalars['String']['output']>;
  custom_sick_description?: Maybe<Scalars['String']['output']>;
  custom_tracking_properties?: Maybe<CustomTrackingProperties>;
  custom_well_description?: Maybe<Scalars['String']['output']>;
  default_trigger_words?: Maybe<Array<Scalars['String']['output']>>;
  enabled: Scalars['Boolean']['output'];
  facebook_pixel_id?: Maybe<Scalars['String']['output']>;
  fb_event_name_overrides?: Maybe<GaEventNameOverrides>;
  ga_event_name_overrides?: Maybe<GaEventNameOverrides>;
  ga_measurement_id?: Maybe<Scalars['String']['output']>;
  gtm_container_id?: Maybe<Scalars['String']['output']>;
  hide_clinician_preference?: Maybe<Scalars['Boolean']['output']>;
  id: Scalars['ID']['output'];
  primary_clinic_group_id?: Maybe<Scalars['String']['output']>;
  redirect_after_booking_url?: Maybe<Scalars['String']['output']>;
  redirect_countdown_seconds?: Maybe<Scalars['NonNegativeInt']['output']>;
  scheduling_buffer_minutes?: Maybe<Scalars['NonNegativeInt']['output']>;
  scheduling_max_minutes_away?: Maybe<Scalars['NonNegativeInt']['output']>;
  scheduling_min_minutes_away?: Maybe<Scalars['NonNegativeInt']['output']>;
  should_allow_new_clients?: Maybe<Scalars['Boolean']['output']>;
  should_allow_new_patients?: Maybe<Scalars['Boolean']['output']>;
  should_allow_returning_clients?: Maybe<Scalars['Boolean']['output']>;
  should_allow_returning_patients?: Maybe<Scalars['Boolean']['output']>;
  should_suggest_nearby_clinics?: Maybe<Scalars['Boolean']['output']>;
  time_slot_minutes?: Maybe<Scalars['NonNegativeInt']['output']>;
  times_first_filter_config?: Maybe<TimesFirstFilterConfig>;
  updated_at: Scalars['Timestamp']['output'];
  widget: Widget;
  widget_access_end_time?: Maybe<Scalars['NonNegativeInt']['output']>;
  widget_access_start_time?: Maybe<Scalars['NonNegativeInt']['output']>;
  widget_referral_code?: Maybe<Scalars['String']['output']>;
  widget_styles?: Maybe<WidgetStyles>;
};

export type WidgetService = {
  __typename?: 'WidgetService';
  created_at: Scalars['Timestamp']['output'];
  id: Scalars['ID']['output'];
  is_active: Scalars['Boolean']['output'];
  service: Service;
  updated_at: Scalars['Timestamp']['output'];
  widget: Widget;
};

export type WidgetSisterLocation = {
  __typename?: 'WidgetSisterLocation';
  clinic: Clinic;
  created_at: Scalars['Timestamp']['output'];
  id: Scalars['ID']['output'];
  is_active: Scalars['Boolean']['output'];
  updated_at: Scalars['Timestamp']['output'];
  widget: Widget;
};

export type WidgetStyles = {
  __typename?: 'WidgetStyles';
  background_color?: Maybe<Scalars['String']['output']>;
  button_color?: Maybe<Scalars['String']['output']>;
  button_text_color?: Maybe<Scalars['String']['output']>;
  card_color?: Maybe<Scalars['String']['output']>;
  clinic_image_map?: Maybe<Array<ClinicImageMap>>;
  clinic_order?: Maybe<Array<ClinicOrder>>;
  floating_margin_bottom?: Maybe<Scalars['NonNegativeInt']['output']>;
  floating_margin_right?: Maybe<Scalars['NonNegativeInt']['output']>;
  footer_color?: Maybe<Scalars['String']['output']>;
  footer_text_color?: Maybe<Scalars['String']['output']>;
  header_color?: Maybe<Scalars['String']['output']>;
  header_text_color?: Maybe<Scalars['String']['output']>;
  heading_color?: Maybe<Scalars['String']['output']>;
  heading_font?: Maybe<WidgetHeadingFont>;
  include_service_categories_with_custom_order?: Maybe<Scalars['Boolean']['output']>;
  reviews_arrow_background?: Maybe<Scalars['String']['output']>;
  reviews_arrow_color?: Maybe<Scalars['String']['output']>;
  reviews_date_color?: Maybe<Scalars['String']['output']>;
  reviews_name_color?: Maybe<Scalars['String']['output']>;
  reviews_stars_color?: Maybe<Scalars['String']['output']>;
  reviews_text_color?: Maybe<Scalars['String']['output']>;
  reviews_title_text?: Maybe<Scalars['String']['output']>;
  service_order?: Maybe<Array<ServiceOrder>>;
  text_color?: Maybe<Scalars['String']['output']>;
};

export type WidgetStylesInput = {
  background_color?: InputMaybe<Scalars['String']['input']>;
  button_color?: InputMaybe<Scalars['String']['input']>;
  button_text_color?: InputMaybe<Scalars['String']['input']>;
  card_color?: InputMaybe<Scalars['String']['input']>;
  clinic_image_map?: InputMaybe<Array<ClinicImageMapInput>>;
  clinic_order?: InputMaybe<Array<ClinicOrderInput>>;
  floating_margin_bottom?: InputMaybe<Scalars['NonNegativeInt']['input']>;
  floating_margin_right?: InputMaybe<Scalars['NonNegativeInt']['input']>;
  footer_color?: InputMaybe<Scalars['String']['input']>;
  footer_text_color?: InputMaybe<Scalars['String']['input']>;
  header_color?: InputMaybe<Scalars['String']['input']>;
  header_text_color?: InputMaybe<Scalars['String']['input']>;
  heading_color?: InputMaybe<Scalars['String']['input']>;
  heading_font?: InputMaybe<WidgetHeadingFont>;
  include_service_categories_with_custom_order?: InputMaybe<Scalars['Boolean']['input']>;
  reviews_arrow_background?: InputMaybe<Scalars['String']['input']>;
  reviews_arrow_color?: InputMaybe<Scalars['String']['input']>;
  reviews_date_color?: InputMaybe<Scalars['String']['input']>;
  reviews_name_color?: InputMaybe<Scalars['String']['input']>;
  reviews_stars_color?: InputMaybe<Scalars['String']['input']>;
  reviews_text_color?: InputMaybe<Scalars['String']['input']>;
  reviews_title_text?: InputMaybe<Scalars['String']['input']>;
  service_order?: InputMaybe<Array<ServiceOrderInput>>;
  text_color?: InputMaybe<Scalars['String']['input']>;
};

export enum WidgetTriggerType {
  Button = 'Button',
  Floating = 'Floating',
  Inline = 'Inline',
  Modal = 'Modal',
  Tab = 'Tab'
}

export enum WidgetType {
  Booking = 'Booking',
  Chat = 'Chat',
  Link = 'Link',
  Reviews = 'Reviews',
  TodaysAvailability = 'TodaysAvailability'
}

export type YesterdayAnalytics = {
  __typename?: 'YesterdayAnalytics';
  appointments: Array<Appointment>;
  last_month_average_revenue_per_appointment: Scalars['Float']['output'];
  monthly_appointments_scheduled: Scalars['NonNegativeInt']['output'];
  monthly_revenue_completed: Scalars['Float']['output'];
  new_clients_count: Scalars['NonNegativeInt']['output'];
  new_patients_count: Scalars['NonNegativeInt']['output'];
  non_forward_scheduled_patients: Array<Patient>;
  revenue: Scalars['Float']['output'];
  revenue_by_clinician: Array<RevenueByClinician>;
  schedule_efficiency: Scalars['Float']['output'];
};

export type Result = {
  __typename?: 'result';
  res?: Maybe<Scalars['String']['output']>;
};

export type UserBasicInfoFragment = { __typename?: 'User', id: string, avatar_url?: string | null, first_name?: string | null, last_name?: string | null };

export type ActionItemBaseFieldsFragment = { __typename?: 'ActionItem', id: string, type: ActionItemType, status: ActionItemStatus, description?: string | null, created_at: number, updated_at: number, assignee?: { __typename?: 'User', id: string, avatar_url?: string | null, first_name?: string | null, last_name?: string | null } | null, clinic: { __typename?: 'Clinic', id: string } };

export type ActionItemFieldsFragment = { __typename?: 'ActionItem', id: string, type: ActionItemType, status: ActionItemStatus, description?: string | null, created_at: number, updated_at: number, pending_appointment?: { __typename?: 'Appointment', id: string, pms_id?: string | null, pms?: PracticeManagementSystem | null, client_pms_id?: string | null, is_new_client?: boolean | null, start_time: number, drop_off_time?: number | null, minutes: number, is_new_patient?: boolean | null, is_clinician_auto_assigned?: boolean | null, patient_pms_id?: string | null, referring_clinic_name?: string | null, client_notes?: string | null, clinic_notes?: string | null, service_name?: string | null, status: AppointmentStatus, is_time_block?: boolean | null, is_confirmed?: boolean | null, origin?: EntityOrigin | null, reason_for_cancellation?: string | null, client_reason_for_cancellation?: string | null, new_client_name?: string | null, new_client_phone?: string | null, new_patient_name?: string | null, new_patient_species?: string | null, confirmed_at?: number | null, widget_source?: string | null, from_widget?: string | null, is_deleted?: boolean | null, created_at: number, updated_at: number, pms_created_at?: number | null, clinic?: { __typename?: 'Clinic', id: string, name?: string | null, slug?: string | null, address?: { __typename?: 'Address', country?: string | null } | null, pms_db?: { __typename?: 'PmsDb', id: string } | null } | null, client?: { __typename?: 'Client', id: string, first_name?: string | null, last_name?: string | null, phone?: string | null, email?: string | null, is_active?: boolean | null, address?: { __typename?: 'Address', street_a?: string | null, street_b?: string | null, city?: string | null, state?: string | null, zip?: string | null, country?: string | null } | null } | null, clinician?: { __typename?: 'Clinician', id: string, name: string, display_name?: string | null, avatar_url?: string | null, initials?: string | null } | null, room?: { __typename?: 'Room', id: string, name: string } | null, service?: { __typename?: 'Service', id: string, name?: string | null, color?: string | null } | null, patient?: { __typename?: 'Patient', id: string, name?: string | null, breed?: string | null, avatar_url?: string | null, birthday?: number | null, weight?: number | null, gender?: string | null, fixed_status?: FixedStatus | null, is_active?: boolean | null, is_deceased?: boolean | null, clinic_species?: { __typename?: 'ClinicSpecies', id: string, species: Species, description: string } | null, clinic_breed?: { __typename?: 'Breed', id: string, description: string } | null } | null, clinic_appt_status?: { __typename?: 'ClinicApptStatus', id: string, description: string, status: AppointmentStatus } | null, client_info?: { __typename?: 'ClientInfo', first_name?: string | null, last_name?: string | null, email?: string | null, phone?: string | null } | null, patient_info?: { __typename?: 'PatientInfo', patient_name?: string | null, patient_breed?: string | null, patient_clinic_species?: string | null, patient_clinic_breed?: string | null } | null } | null, reschedule?: { __typename?: 'Reschedule', id: string, requested_start_time?: number | null, original_start_time?: number | null, clinic_notes?: string | null, client_notes?: string | null, reason_for_denial?: string | null, status: RescheduleStatus, initiated_by: RescheduleInitiatedBy, confirmed_at?: number | null, created_at: number, updated_at: number, appointment: { __typename?: 'Appointment', id: string, pms_id?: string | null, pms?: PracticeManagementSystem | null, client_pms_id?: string | null, is_new_client?: boolean | null, start_time: number, drop_off_time?: number | null, minutes: number, is_new_patient?: boolean | null, is_clinician_auto_assigned?: boolean | null, patient_pms_id?: string | null, referring_clinic_name?: string | null, client_notes?: string | null, clinic_notes?: string | null, service_name?: string | null, status: AppointmentStatus, is_time_block?: boolean | null, is_confirmed?: boolean | null, origin?: EntityOrigin | null, reason_for_cancellation?: string | null, client_reason_for_cancellation?: string | null, new_client_name?: string | null, new_client_phone?: string | null, new_patient_name?: string | null, new_patient_species?: string | null, confirmed_at?: number | null, widget_source?: string | null, from_widget?: string | null, is_deleted?: boolean | null, created_at: number, updated_at: number, pms_created_at?: number | null, clinic?: { __typename?: 'Clinic', id: string, name?: string | null, slug?: string | null, address?: { __typename?: 'Address', country?: string | null } | null, pms_db?: { __typename?: 'PmsDb', id: string } | null } | null, client?: { __typename?: 'Client', id: string, first_name?: string | null, last_name?: string | null, phone?: string | null, email?: string | null, is_active?: boolean | null, address?: { __typename?: 'Address', street_a?: string | null, street_b?: string | null, city?: string | null, state?: string | null, zip?: string | null, country?: string | null } | null } | null, clinician?: { __typename?: 'Clinician', id: string, name: string, display_name?: string | null, avatar_url?: string | null, initials?: string | null } | null, room?: { __typename?: 'Room', id: string, name: string } | null, service?: { __typename?: 'Service', id: string, name?: string | null, color?: string | null } | null, patient?: { __typename?: 'Patient', id: string, name?: string | null, breed?: string | null, avatar_url?: string | null, birthday?: number | null, weight?: number | null, gender?: string | null, fixed_status?: FixedStatus | null, is_active?: boolean | null, is_deceased?: boolean | null, clinic_species?: { __typename?: 'ClinicSpecies', id: string, species: Species, description: string } | null, clinic_breed?: { __typename?: 'Breed', id: string, description: string } | null } | null, clinic_appt_status?: { __typename?: 'ClinicApptStatus', id: string, description: string, status: AppointmentStatus } | null, client_info?: { __typename?: 'ClientInfo', first_name?: string | null, last_name?: string | null, email?: string | null, phone?: string | null } | null, patient_info?: { __typename?: 'PatientInfo', patient_name?: string | null, patient_breed?: string | null, patient_clinic_species?: string | null, patient_clinic_breed?: string | null } | null }, requested_clinician?: { __typename?: 'Clinician', id: string, name: string } | null, original_clinician?: { __typename?: 'Clinician', id: string, name: string } | null } | null, chat?: { __typename?: 'Chat', id: string, title?: string | null, clinic_unread_count: number, last_message?: string | null, last_message_time: number, client_last_message?: string | null, client_last_message_time: number, client_message_count: number, clinic_last_message?: string | null, clinic_last_message_time: number, non_system_last_message?: string | null, non_system_last_message_time: number, system_last_message?: string | null, system_last_message_time: number, status: ChatStatus, is_pinned: boolean, clinic: { __typename?: 'Clinic', id: string, pms: PracticeManagementSystem, name?: string | null }, client: { __typename?: 'Client', id: string, first_name?: string | null, last_name?: string | null, patients?: Array<{ __typename?: 'Patient', id: string, name?: string | null, pms_id?: string | null, is_deceased?: boolean | null, is_active?: boolean | null }> | null }, assignee?: { __typename?: 'User', id: string, avatar_url?: string | null, first_name?: string | null, last_name?: string | null } | null, chat_status?: { __typename?: 'ChatStatusConfig', id: string, name: string, color?: string | null } | null } | null, client_form?: { __typename?: 'ClientForm', id: string, client_completed_at?: number | null, clinic_verified_at?: number | null, is_archived: boolean, pms_id?: string | null, created_at: number, updated_at: number, client?: { __typename?: 'Client', id: string, first_name?: string | null, last_name?: string | null, phone?: string | null, email?: string | null, address?: { __typename?: 'Address', street_a?: string | null, city?: string | null, state?: string | null, zip?: string | null, country?: string | null } | null } | null, patient?: { __typename?: 'Patient', id: string, name?: string | null, is_active?: boolean | null, is_deceased?: boolean | null, birthday?: number | null, weight?: number | null, avatar_url?: string | null, gender?: string | null, owner?: { __typename?: 'Client', first_name?: string | null, last_name?: string | null } | null, clinic_species?: { __typename?: 'ClinicSpecies', id: string, species: Species, description: string, weight_key: string } | null, clinic_breed?: { __typename?: 'Breed', id: string, description: string } | null } | null, form: { __typename?: 'Form', id: string, name?: string | null, form_type: FormType, is_writeback_enabled: boolean, form_file_naming_template?: string | null }, form_data: { __typename?: 'FormFields', pages?: Array<{ __typename?: 'FormPage', id: string, title?: string | null, description?: string | null, order?: number | null }> | null, fields?: Array<{ __typename?: 'FormElement', id: string, type?: FormElementType | null, content?: string | null, name?: string | null, column_order?: number | null, row_order?: number | null, page_id?: string | null, options?: Array<string> | null, is_required?: boolean | null, value?: string | null, attachments?: Array<{ __typename?: 'FormFileAttachment', id?: string | null, filename?: string | null, mime_type?: string | null, size_bytes?: number | null, thumbnail_url?: string | null, url: string }> | null, field_updates?: Array<{ __typename?: 'FormFieldUpdate', field: FormFieldUpdateField, boolean_value?: boolean | null, option?: string | null }> | null }> | null }, appointment?: { __typename?: 'Appointment', start_time: number, drop_off_time?: number | null, clinic?: { __typename?: 'Clinic', name?: string | null, slug?: string | null, phone?: string | null, email?: string | null, address?: { __typename?: 'Address', street_a?: string | null, city?: string | null, state?: string | null, zip?: string | null, country?: string | null } | null } | null, clinician?: { __typename?: 'Clinician', name: string, display_name?: string | null } | null, service?: { __typename?: 'Service', name?: string | null } | null } | null } | null, prescription_refill_request?: { __typename?: 'PrescriptionRefillRequest', id: string, pickup_time?: number | null, stripe_payment_intent_id?: string | null, amount?: number | null, status: PrescriptionRefillRequestStatus, type: PrescriptionRefillRequestType, notes?: string | null, denial_reason?: string | null, approved_at?: number | null, denied_at?: number | null, created_at: number, updated_at: number, clinic: { __typename?: 'Clinic', id: string }, client: { __typename?: 'Client', id: string, first_name?: string | null, last_name?: string | null, secondary_first_name?: string | null, secondary_last_name?: string | null, phone?: string | null, email?: string | null, pms_id?: string | null, is_active?: boolean | null, is_unsubscribed: boolean, sms_enabled: boolean, email_enabled: boolean, balance?: number | null, last_appt_time?: number | null, created_at: number, updated_at: number, last_appointment?: { __typename?: 'Appointment', clinician?: { __typename?: 'Clinician', name: string, display_name?: string | null } | null } | null, address?: { __typename?: 'Address', street_a?: string | null, street_b?: string | null, city?: string | null, state?: string | null, zip?: string | null, country?: string | null } | null, clinic?: { __typename?: 'Clinic', id: string } | null, user?: { __typename?: 'User', avatar_url?: string | null } | null, patients?: Array<{ __typename?: 'Patient', id: string, name?: string | null, gender?: string | null, pms_id?: string | null, is_deceased?: boolean | null, is_active?: boolean | null, clinic_species?: { __typename?: 'ClinicSpecies', id: string, species: Species } | null, clinic_breed?: { __typename?: 'Breed', id: string, description: string } | null, last_appointment?: { __typename?: 'Appointment', clinician?: { __typename?: 'Clinician', name: string, display_name?: string | null } | null } | null }> | null, settings?: { __typename?: 'ClientSettings', clinic_chckup_notifications_enabled: boolean, clinic_chckup_sms_enabled: boolean, clinic_chckup_email_enabled: boolean, client_chckup_notifications_enabled: boolean, client_chckup_sms_enabled: boolean, client_chckup_email_enabled: boolean, is_unsubscribed_from_marketing: boolean, is_unsubscribed_from_marketing_sms: boolean, is_unsubscribed_from_marketing_email: boolean } | null }, patient?: { __typename?: 'Patient', id: string, pms_id?: string | null, name?: string | null, breed?: string | null, is_active?: boolean | null, is_deceased?: boolean | null, avatar_url?: string | null, gender?: string | null, fixed_status?: FixedStatus | null, birthday?: number | null, weight?: number | null, owner?: { __typename?: 'Client', id: string, first_name?: string | null, last_name?: string | null, secondary_first_name?: string | null, secondary_last_name?: string | null, phone?: string | null, email?: string | null } | null, clinic_species?: { __typename?: 'ClinicSpecies', id: string, species: Species, description: string, weight_key: string } | null, clinic_breed?: { __typename?: 'Breed', id: string, description: string } | null } | null, prescription?: { __typename?: 'Prescription', id: string, name?: string | null, product_name?: string | null, quantity?: number | null, refill_count?: number | null, refill_limit?: number | null, product?: { __typename?: 'Product', id: string, name: string, price: number, chckvet_price?: number | null, unit?: string | null, volume?: string | null, additional_fees?: Array<{ __typename?: 'AdditionalFees', name: string, amount: number }> | null } | null } | null, appointment?: { __typename?: 'Appointment', id: string, start_time: number, status: AppointmentStatus } | null } | null, pet_selfie?: { __typename?: 'PetSelfie', id: string, submitted_media_url: string, display_media_url?: string | null, media_type: PetSelfieMediaType, mime_type: string, filename?: string | null, size_bytes?: number | null, thumbnail_url?: string | null, pet_name?: string | null, nickname?: string | null, favorite_activity?: string | null, weirdest_thing?: string | null, display_caption?: string | null, allow_public_share: boolean, public_share_authorized_at?: number | null, first_viewed_at?: number | null, first_viewed_by?: string | null, in_slideshow: boolean, in_portal_carousel: boolean, in_gallery: boolean, is_excluded: boolean, is_archived: boolean, reaction_sent_at?: number | null, reaction_message?: string | null, created_at: number, updated_at: number, clinic: { __typename?: 'Clinic', id: string }, client: { __typename?: 'Client', id: string, first_name?: string | null, last_name?: string | null, secondary_first_name?: string | null, secondary_last_name?: string | null, phone?: string | null, email?: string | null, pms_id?: string | null, is_active?: boolean | null, is_unsubscribed: boolean, sms_enabled: boolean, email_enabled: boolean, balance?: number | null, last_appt_time?: number | null, created_at: number, updated_at: number, last_appointment?: { __typename?: 'Appointment', clinician?: { __typename?: 'Clinician', name: string, display_name?: string | null } | null } | null, address?: { __typename?: 'Address', street_a?: string | null, street_b?: string | null, city?: string | null, state?: string | null, zip?: string | null, country?: string | null } | null, clinic?: { __typename?: 'Clinic', id: string } | null, user?: { __typename?: 'User', avatar_url?: string | null } | null, patients?: Array<{ __typename?: 'Patient', id: string, name?: string | null, gender?: string | null, pms_id?: string | null, is_deceased?: boolean | null, is_active?: boolean | null, clinic_species?: { __typename?: 'ClinicSpecies', id: string, species: Species } | null, clinic_breed?: { __typename?: 'Breed', id: string, description: string } | null, last_appointment?: { __typename?: 'Appointment', clinician?: { __typename?: 'Clinician', name: string, display_name?: string | null } | null } | null }> | null, settings?: { __typename?: 'ClientSettings', clinic_chckup_notifications_enabled: boolean, clinic_chckup_sms_enabled: boolean, clinic_chckup_email_enabled: boolean, client_chckup_notifications_enabled: boolean, client_chckup_sms_enabled: boolean, client_chckup_email_enabled: boolean, is_unsubscribed_from_marketing: boolean, is_unsubscribed_from_marketing_sms: boolean, is_unsubscribed_from_marketing_email: boolean } | null }, patient?: { __typename?: 'Patient', id: string, pms_id?: string | null, name?: string | null, breed?: string | null, is_active?: boolean | null, is_deceased?: boolean | null, avatar_url?: string | null, gender?: string | null, fixed_status?: FixedStatus | null, birthday?: number | null, weight?: number | null, owner?: { __typename?: 'Client', id: string, first_name?: string | null, last_name?: string | null, secondary_first_name?: string | null, secondary_last_name?: string | null, phone?: string | null, email?: string | null } | null, clinic_species?: { __typename?: 'ClinicSpecies', id: string, species: Species, description: string, weight_key: string } | null, clinic_breed?: { __typename?: 'Breed', id: string, description: string } | null } | null } | null, originating_call?: { __typename?: 'Call', id: string, status: CallStatus, direction?: CallDirection | null, is_automated?: boolean | null, caller_name?: string | null, caller_phone?: string | null, to_phone?: string | null, duration?: number | null, recording_url?: string | null, transcription_full_text?: string | null, transcription_summary?: string | null, notes?: string | null, score?: number | null, score_reasoning?: string | null, sentiment_customer?: number | null, sentiment_agent?: number | null, created_at: number, updated_at: number, client?: { __typename?: 'Client', first_name?: string | null, last_name?: string | null, phone?: string | null } | null } | null, assignee?: { __typename?: 'User', id: string, avatar_url?: string | null, first_name?: string | null, last_name?: string | null } | null, clinic: { __typename?: 'Clinic', id: string } };

export type ActionItemRescheduleFieldsFragment = { __typename?: 'Reschedule', id: string, requested_start_time?: number | null, original_start_time?: number | null, clinic_notes?: string | null, client_notes?: string | null, reason_for_denial?: string | null, status: RescheduleStatus, initiated_by: RescheduleInitiatedBy, confirmed_at?: number | null, created_at: number, updated_at: number, appointment: { __typename?: 'Appointment', id: string, pms_id?: string | null, pms?: PracticeManagementSystem | null, client_pms_id?: string | null, is_new_client?: boolean | null, start_time: number, drop_off_time?: number | null, minutes: number, is_new_patient?: boolean | null, is_clinician_auto_assigned?: boolean | null, patient_pms_id?: string | null, referring_clinic_name?: string | null, client_notes?: string | null, clinic_notes?: string | null, service_name?: string | null, status: AppointmentStatus, is_time_block?: boolean | null, is_confirmed?: boolean | null, origin?: EntityOrigin | null, reason_for_cancellation?: string | null, client_reason_for_cancellation?: string | null, new_client_name?: string | null, new_client_phone?: string | null, new_patient_name?: string | null, new_patient_species?: string | null, confirmed_at?: number | null, widget_source?: string | null, from_widget?: string | null, is_deleted?: boolean | null, created_at: number, updated_at: number, pms_created_at?: number | null, clinic?: { __typename?: 'Clinic', id: string, name?: string | null, slug?: string | null, address?: { __typename?: 'Address', country?: string | null } | null, pms_db?: { __typename?: 'PmsDb', id: string } | null } | null, client?: { __typename?: 'Client', id: string, first_name?: string | null, last_name?: string | null, phone?: string | null, email?: string | null, is_active?: boolean | null, address?: { __typename?: 'Address', street_a?: string | null, street_b?: string | null, city?: string | null, state?: string | null, zip?: string | null, country?: string | null } | null } | null, clinician?: { __typename?: 'Clinician', id: string, name: string, display_name?: string | null, avatar_url?: string | null, initials?: string | null } | null, room?: { __typename?: 'Room', id: string, name: string } | null, service?: { __typename?: 'Service', id: string, name?: string | null, color?: string | null } | null, patient?: { __typename?: 'Patient', id: string, name?: string | null, breed?: string | null, avatar_url?: string | null, birthday?: number | null, weight?: number | null, gender?: string | null, fixed_status?: FixedStatus | null, is_active?: boolean | null, is_deceased?: boolean | null, clinic_species?: { __typename?: 'ClinicSpecies', id: string, species: Species, description: string } | null, clinic_breed?: { __typename?: 'Breed', id: string, description: string } | null } | null, clinic_appt_status?: { __typename?: 'ClinicApptStatus', id: string, description: string, status: AppointmentStatus } | null, client_info?: { __typename?: 'ClientInfo', first_name?: string | null, last_name?: string | null, email?: string | null, phone?: string | null } | null, patient_info?: { __typename?: 'PatientInfo', patient_name?: string | null, patient_breed?: string | null, patient_clinic_species?: string | null, patient_clinic_breed?: string | null } | null }, requested_clinician?: { __typename?: 'Clinician', id: string, name: string } | null, original_clinician?: { __typename?: 'Clinician', id: string, name: string } | null };

export type PendingAppointmentPreviewFieldsFragment = { __typename?: 'Appointment', id: string, pms_id?: string | null, pms?: PracticeManagementSystem | null, client_pms_id?: string | null, is_new_client?: boolean | null, start_time: number, drop_off_time?: number | null, minutes: number, is_new_patient?: boolean | null, is_clinician_auto_assigned?: boolean | null, patient_pms_id?: string | null, referring_clinic_name?: string | null, client_notes?: string | null, clinic_notes?: string | null, service_name?: string | null, status: AppointmentStatus, is_time_block?: boolean | null, is_confirmed?: boolean | null, origin?: EntityOrigin | null, reason_for_cancellation?: string | null, client_reason_for_cancellation?: string | null, new_client_name?: string | null, new_client_phone?: string | null, new_patient_name?: string | null, new_patient_species?: string | null, confirmed_at?: number | null, widget_source?: string | null, from_widget?: string | null, is_deleted?: boolean | null, created_at: number, updated_at: number, pms_created_at?: number | null, clinic?: { __typename?: 'Clinic', id: string, name?: string | null, slug?: string | null, address?: { __typename?: 'Address', country?: string | null } | null, pms_db?: { __typename?: 'PmsDb', id: string } | null } | null, client?: { __typename?: 'Client', id: string, first_name?: string | null, last_name?: string | null, phone?: string | null, email?: string | null, is_active?: boolean | null, address?: { __typename?: 'Address', street_a?: string | null, street_b?: string | null, city?: string | null, state?: string | null, zip?: string | null, country?: string | null } | null } | null, clinician?: { __typename?: 'Clinician', id: string, name: string, display_name?: string | null, avatar_url?: string | null, initials?: string | null } | null, room?: { __typename?: 'Room', id: string, name: string } | null, service?: { __typename?: 'Service', id: string, name?: string | null, color?: string | null } | null, patient?: { __typename?: 'Patient', id: string, name?: string | null, breed?: string | null, avatar_url?: string | null, birthday?: number | null, weight?: number | null, gender?: string | null, fixed_status?: FixedStatus | null, is_active?: boolean | null, is_deceased?: boolean | null, clinic_species?: { __typename?: 'ClinicSpecies', id: string, species: Species, description: string } | null, clinic_breed?: { __typename?: 'Breed', id: string, description: string } | null } | null, clinic_appt_status?: { __typename?: 'ClinicApptStatus', id: string, description: string, status: AppointmentStatus } | null, client_info?: { __typename?: 'ClientInfo', first_name?: string | null, last_name?: string | null, email?: string | null, phone?: string | null } | null, patient_info?: { __typename?: 'PatientInfo', patient_name?: string | null, patient_breed?: string | null, patient_clinic_species?: string | null, patient_clinic_breed?: string | null } | null };

export type AppointmentWithActionItemsFieldsFragment = { __typename?: 'Appointment', action_items?: Array<{ __typename?: 'ActionItem', id: string, type: ActionItemType, status: ActionItemStatus, description?: string | null, created_at: number, updated_at: number, pending_appointment?: { __typename?: 'Appointment', id: string, pms_id?: string | null, pms?: PracticeManagementSystem | null, client_pms_id?: string | null, is_new_client?: boolean | null, start_time: number, drop_off_time?: number | null, minutes: number, is_new_patient?: boolean | null, is_clinician_auto_assigned?: boolean | null, patient_pms_id?: string | null, referring_clinic_name?: string | null, client_notes?: string | null, clinic_notes?: string | null, service_name?: string | null, status: AppointmentStatus, is_time_block?: boolean | null, is_confirmed?: boolean | null, origin?: EntityOrigin | null, reason_for_cancellation?: string | null, client_reason_for_cancellation?: string | null, new_client_name?: string | null, new_client_phone?: string | null, new_patient_name?: string | null, new_patient_species?: string | null, confirmed_at?: number | null, widget_source?: string | null, from_widget?: string | null, is_deleted?: boolean | null, created_at: number, updated_at: number, pms_created_at?: number | null, clinic?: { __typename?: 'Clinic', id: string, name?: string | null, slug?: string | null, address?: { __typename?: 'Address', country?: string | null } | null, pms_db?: { __typename?: 'PmsDb', id: string } | null } | null, client?: { __typename?: 'Client', id: string, first_name?: string | null, last_name?: string | null, phone?: string | null, email?: string | null, is_active?: boolean | null, address?: { __typename?: 'Address', street_a?: string | null, street_b?: string | null, city?: string | null, state?: string | null, zip?: string | null, country?: string | null } | null } | null, clinician?: { __typename?: 'Clinician', id: string, name: string, display_name?: string | null, avatar_url?: string | null, initials?: string | null } | null, room?: { __typename?: 'Room', id: string, name: string } | null, service?: { __typename?: 'Service', id: string, name?: string | null, color?: string | null } | null, patient?: { __typename?: 'Patient', id: string, name?: string | null, breed?: string | null, avatar_url?: string | null, birthday?: number | null, weight?: number | null, gender?: string | null, fixed_status?: FixedStatus | null, is_active?: boolean | null, is_deceased?: boolean | null, clinic_species?: { __typename?: 'ClinicSpecies', id: string, species: Species, description: string } | null, clinic_breed?: { __typename?: 'Breed', id: string, description: string } | null } | null, clinic_appt_status?: { __typename?: 'ClinicApptStatus', id: string, description: string, status: AppointmentStatus } | null, client_info?: { __typename?: 'ClientInfo', first_name?: string | null, last_name?: string | null, email?: string | null, phone?: string | null } | null, patient_info?: { __typename?: 'PatientInfo', patient_name?: string | null, patient_breed?: string | null, patient_clinic_species?: string | null, patient_clinic_breed?: string | null } | null } | null, assignee?: { __typename?: 'User', id: string, avatar_url?: string | null, first_name?: string | null, last_name?: string | null } | null, clinic: { __typename?: 'Clinic', id: string } }> | null };

export type RescheduleWithActionItemsFieldsFragment = { __typename?: 'Reschedule', action_items?: Array<{ __typename?: 'ActionItem', id: string, type: ActionItemType, status: ActionItemStatus, description?: string | null, created_at: number, updated_at: number, reschedule?: { __typename?: 'Reschedule', id: string, requested_start_time?: number | null, original_start_time?: number | null, clinic_notes?: string | null, client_notes?: string | null, reason_for_denial?: string | null, status: RescheduleStatus, initiated_by: RescheduleInitiatedBy, confirmed_at?: number | null, created_at: number, updated_at: number, appointment: { __typename?: 'Appointment', id: string, pms?: PracticeManagementSystem | null, client_pms_id?: string | null, is_new_client?: boolean | null, start_time: number, drop_off_time?: number | null, minutes: number, is_new_patient?: boolean | null, is_clinician_auto_assigned?: boolean | null, patient_pms_id?: string | null, referring_clinic_name?: string | null, client_notes?: string | null, clinic_notes?: string | null, service_name?: string | null, status: AppointmentStatus, is_time_block?: boolean | null, is_confirmed?: boolean | null, origin?: EntityOrigin | null, reason_for_cancellation?: string | null, client_reason_for_cancellation?: string | null, new_client_name?: string | null, new_client_phone?: string | null, new_patient_name?: string | null, new_patient_species?: string | null, confirmed_at?: number | null, widget_source?: string | null, from_widget?: string | null, is_deleted?: boolean | null, created_at: number, updated_at: number, pms_created_at?: number | null, clinic?: { __typename?: 'Clinic', id: string, name?: string | null, slug?: string | null, pms_db?: { __typename?: 'PmsDb', id: string } | null, address?: { __typename?: 'Address', country?: string | null } | null } | null, client?: { __typename?: 'Client', id: string, first_name?: string | null, last_name?: string | null, secondary_first_name?: string | null, secondary_last_name?: string | null, phone?: string | null, email?: string | null, pms?: PracticeManagementSystem | null, pms_id?: string | null, last_appt_time?: number | null, last_contact_time?: number | null, email_enabled: boolean, sms_enabled: boolean, balance?: number | null, is_active?: boolean | null, is_unsubscribed: boolean, created_at: number, updated_at: number, client_phones?: Array<{ __typename?: 'ClientPhone', id: string, phone: string, country_code?: string | null, is_primary: boolean, is_chckup_primary: boolean, is_mobile: boolean, sms_available: boolean, is_unsubscribed: boolean, is_active: boolean, name?: string | null }> | null, client_emails?: Array<{ __typename?: 'ClientEmail', id: string, email: string, is_primary: boolean }> | null, clinic?: { __typename?: 'Clinic', id: string } | null, patients?: Array<{ __typename?: 'Patient', id: string, pms?: PracticeManagementSystem | null, pms_id?: string | null, name?: string | null, breed?: string | null, avatar_url?: string | null, last_appt_time?: number | null, gender?: string | null, fixed_status?: FixedStatus | null, weight?: number | null, birthday?: number | null, is_active?: boolean | null, is_deceased?: boolean | null, pms_created_at?: number | null, created_at: number, updated_at: number, owner?: { __typename?: 'Client', id: string, first_name?: string | null, last_name?: string | null, email?: string | null, phone?: string | null, address?: { __typename?: 'Address', country?: string | null } | null } | null, clinic_species?: { __typename?: 'ClinicSpecies', id: string, pms_id: string, description: string, is_primary: boolean, species: Species, weight_key: string, created_at: number, updated_at: number } | null, clinic?: { __typename?: 'Clinic', id: string } | null, clinic_breed?: { __typename?: 'Breed', id: string, description: string } | null, patient_vaccination_records?: Array<{ __typename?: 'PatientVaccinationRecord', id: string, vaccine_name?: string | null, manufacturer?: string | null, lot_number?: string | null, administered_date?: number | null, due_date?: number | null, rabies_tag?: string | null, is_rabies_vaccine?: boolean | null, is_soc: boolean, is_active: boolean, product?: { __typename?: 'Product', id: string, display_name?: string | null, name: string } | null }> | null, last_appointment?: { __typename?: 'Appointment', clinician?: { __typename?: 'Clinician', name: string, display_name?: string | null } | null } | null }> | null, address?: { __typename?: 'Address', street_a?: string | null, street_b?: string | null, city?: string | null, state?: string | null, zip?: string | null, country?: string | null } | null, user?: { __typename?: 'User', avatar_url?: string | null } | null, loyalty_members?: Array<{ __typename?: 'LoyaltyMember', id: string, available_points: number } | null> | null, settings?: { __typename?: 'ClientSettings', clinic_chckup_notifications_enabled: boolean, clinic_chckup_sms_enabled: boolean, clinic_chckup_email_enabled: boolean, client_chckup_notifications_enabled: boolean, client_chckup_sms_enabled: boolean, client_chckup_email_enabled: boolean, is_unsubscribed_from_marketing: boolean, is_unsubscribed_from_marketing_sms: boolean, is_unsubscribed_from_marketing_email: boolean } | null, last_appointment?: { __typename?: 'Appointment', clinician?: { __typename?: 'Clinician', name: string, display_name?: string | null } | null } | null } | null, clinician?: { __typename?: 'Clinician', id: string, name: string, display_name?: string | null, bio?: string | null, avatar_url?: string | null, initials?: string | null, excluded_species?: Array<Species> | null, excluded_service_ids?: Array<string> | null, authority_level?: AuthorityLevel | null, type: ResourceType, is_active?: boolean | null, is_assignable_in_pms?: boolean | null, does_contribute_to_fill_rate?: boolean | null, pms_id?: string | null, location?: string | null, pms_is_active: boolean, valid_booking_interval_minutes?: Array<number> | null, created_at: number, updated_at: number, clinic?: { __typename?: 'Clinic', id: string, name?: string | null } | null, pms_db?: { __typename?: 'PmsDb', id: string } | null, hours?: { __typename?: 'AvailabilityHours', monday?: Array<{ __typename?: 'TimeInterval', start?: number | null, end?: number | null }> | null, tuesday?: Array<{ __typename?: 'TimeInterval', start?: number | null, end?: number | null }> | null, wednesday?: Array<{ __typename?: 'TimeInterval', start?: number | null, end?: number | null }> | null, thursday?: Array<{ __typename?: 'TimeInterval', start?: number | null, end?: number | null }> | null, friday?: Array<{ __typename?: 'TimeInterval', start?: number | null, end?: number | null }> | null, saturday?: Array<{ __typename?: 'TimeInterval', start?: number | null, end?: number | null }> | null, sunday?: Array<{ __typename?: 'TimeInterval', start?: number | null, end?: number | null }> | null } | null, adjusted_availability?: Array<{ __typename?: 'Availability', date: number, pms_appt_type_pms_id?: string | null, times: Array<{ __typename?: 'TimeInterval', start?: number | null, end?: number | null }>, repeat?: { __typename?: 'RepeatAvailability', daysOfMonth?: Array<number> | null, daysOfWeek?: Array<DayOfWeek> | null, weekOfMonth?: WeekOfMonth | null, frequency: any, unit: RepeatUnit, end_date?: number | null } | null }> | null, pms_adjusted_availability?: Array<{ __typename?: 'Availability', date: number, pms_appt_type_pms_id?: string | null, times: Array<{ __typename?: 'TimeInterval', start?: number | null, end?: number | null }>, repeat?: { __typename?: 'RepeatAvailability', daysOfMonth?: Array<number> | null, daysOfWeek?: Array<DayOfWeek> | null, weekOfMonth?: WeekOfMonth | null, frequency: any, unit: RepeatUnit, end_date?: number | null } | null }> | null } | null, room?: { __typename?: 'Room', id: string, pms_id: string, name: string, display_name?: string | null, description?: string | null, concurrent_patients?: number | null, is_active: boolean, does_contribute_to_fill_rate?: boolean | null, valid_booking_interval_minutes?: Array<number> | null, created_at: number, updated_at: number, clinic?: { __typename?: 'Clinic', pms: PracticeManagementSystem, id: string, name?: string | null, time_zone?: string | null } | null, hours?: { __typename?: 'AvailabilityHours', monday?: Array<{ __typename?: 'TimeInterval', start?: number | null, end?: number | null }> | null, tuesday?: Array<{ __typename?: 'TimeInterval', start?: number | null, end?: number | null }> | null, wednesday?: Array<{ __typename?: 'TimeInterval', start?: number | null, end?: number | null }> | null, thursday?: Array<{ __typename?: 'TimeInterval', start?: number | null, end?: number | null }> | null, friday?: Array<{ __typename?: 'TimeInterval', start?: number | null, end?: number | null }> | null, saturday?: Array<{ __typename?: 'TimeInterval', start?: number | null, end?: number | null }> | null, sunday?: Array<{ __typename?: 'TimeInterval', start?: number | null, end?: number | null }> | null } | null, adjusted_availability?: Array<{ __typename?: 'Availability', date: number, pms_appt_type_pms_id?: string | null, times: Array<{ __typename?: 'TimeInterval', start?: number | null, end?: number | null }>, repeat?: { __typename?: 'RepeatAvailability', daysOfMonth?: Array<number> | null, daysOfWeek?: Array<DayOfWeek> | null, weekOfMonth?: WeekOfMonth | null, frequency: any, unit: RepeatUnit, end_date?: number | null } | null }> | null, pms_adjusted_availability?: Array<{ __typename?: 'Availability', date: number, pms_appt_type_pms_id?: string | null, times: Array<{ __typename?: 'TimeInterval', start?: number | null, end?: number | null }>, repeat?: { __typename?: 'RepeatAvailability', daysOfMonth?: Array<number> | null, daysOfWeek?: Array<DayOfWeek> | null, weekOfMonth?: WeekOfMonth | null, frequency: any, unit: RepeatUnit, end_date?: number | null } | null }> | null } | null, service?: { __typename?: 'Service', id: string, name?: string | null, color?: string | null } | null, patient?: { __typename?: 'Patient', id: string, pms?: PracticeManagementSystem | null, pms_id?: string | null, name?: string | null, breed?: string | null, avatar_url?: string | null, last_appt_time?: number | null, gender?: string | null, fixed_status?: FixedStatus | null, weight?: number | null, birthday?: number | null, is_active?: boolean | null, is_deceased?: boolean | null, pms_created_at?: number | null, created_at: number, updated_at: number, owner?: { __typename?: 'Client', id: string, first_name?: string | null, last_name?: string | null, email?: string | null, phone?: string | null, address?: { __typename?: 'Address', country?: string | null } | null } | null, clinic_species?: { __typename?: 'ClinicSpecies', id: string, pms_id: string, description: string, is_primary: boolean, species: Species, weight_key: string, created_at: number, updated_at: number } | null, clinic?: { __typename?: 'Clinic', id: string } | null, clinic_breed?: { __typename?: 'Breed', id: string, description: string } | null, patient_vaccination_records?: Array<{ __typename?: 'PatientVaccinationRecord', id: string, vaccine_name?: string | null, manufacturer?: string | null, lot_number?: string | null, administered_date?: number | null, due_date?: number | null, rabies_tag?: string | null, is_rabies_vaccine?: boolean | null, is_soc: boolean, is_active: boolean, product?: { __typename?: 'Product', id: string, display_name?: string | null, name: string } | null }> | null, last_appointment?: { __typename?: 'Appointment', clinician?: { __typename?: 'Clinician', name: string, display_name?: string | null } | null } | null } | null, clinic_appt_status?: { __typename?: 'ClinicApptStatus', id: string, description: string, status: AppointmentStatus } | null, client_info?: { __typename?: 'ClientInfo', first_name?: string | null, last_name?: string | null, email?: string | null, phone?: string | null } | null, patient_info?: { __typename?: 'PatientInfo', patient_name?: string | null, patient_breed?: string | null, patient_clinic_species?: string | null, patient_clinic_breed?: string | null } | null, clients_forms?: Array<{ __typename?: 'ClientForm', id: string, client_completed_at?: number | null, clinic_verified_at?: number | null, is_archived: boolean, pms_id?: string | null, created_at: number, updated_at: number, client?: { __typename?: 'Client', id: string, first_name?: string | null, last_name?: string | null, phone?: string | null, email?: string | null, address?: { __typename?: 'Address', street_a?: string | null, city?: string | null, state?: string | null, zip?: string | null, country?: string | null } | null } | null, patient?: { __typename?: 'Patient', id: string, name?: string | null, is_active?: boolean | null, is_deceased?: boolean | null, birthday?: number | null, weight?: number | null, avatar_url?: string | null, gender?: string | null, owner?: { __typename?: 'Client', first_name?: string | null, last_name?: string | null } | null, clinic_species?: { __typename?: 'ClinicSpecies', id: string, species: Species, description: string, weight_key: string } | null, clinic_breed?: { __typename?: 'Breed', id: string, description: string } | null } | null, form: { __typename?: 'Form', id: string, name?: string | null, form_type: FormType, is_writeback_enabled: boolean, form_file_naming_template?: string | null }, form_data: { __typename?: 'FormFields', pages?: Array<{ __typename?: 'FormPage', id: string, title?: string | null, description?: string | null, order?: number | null }> | null, fields?: Array<{ __typename?: 'FormElement', id: string, type?: FormElementType | null, content?: string | null, name?: string | null, column_order?: number | null, row_order?: number | null, page_id?: string | null, options?: Array<string> | null, is_required?: boolean | null, value?: string | null, attachments?: Array<{ __typename?: 'FormFileAttachment', id?: string | null, filename?: string | null, mime_type?: string | null, size_bytes?: number | null, thumbnail_url?: string | null, url: string }> | null, field_updates?: Array<{ __typename?: 'FormFieldUpdate', field: FormFieldUpdateField, boolean_value?: boolean | null, option?: string | null }> | null }> | null }, appointment?: { __typename?: 'Appointment', start_time: number, drop_off_time?: number | null, clinic?: { __typename?: 'Clinic', name?: string | null, slug?: string | null, phone?: string | null, email?: string | null, address?: { __typename?: 'Address', street_a?: string | null, city?: string | null, state?: string | null, zip?: string | null, country?: string | null } | null } | null, clinician?: { __typename?: 'Clinician', name: string, display_name?: string | null } | null, service?: { __typename?: 'Service', name?: string | null } | null } | null }> | null, widget?: { __typename?: 'Widget', id: string, widget_name: string } | null }, requested_clinician?: { __typename?: 'Clinician', id: string, name: string } | null, original_clinician?: { __typename?: 'Clinician', id: string, name: string } | null } | null, assignee?: { __typename?: 'User', id: string, avatar_url?: string | null, first_name?: string | null, last_name?: string | null } | null, clinic: { __typename?: 'Clinic', id: string } }> | null };

export type GetActionItemQueryVariables = Exact<{
  id: Scalars['ID']['input'];
}>;


export type GetActionItemQuery = { __typename?: 'Query', actionItem: { __typename?: 'ActionItem', id: string, type: ActionItemType, status: ActionItemStatus, description?: string | null, created_at: number, updated_at: number, pending_appointment?: { __typename?: 'Appointment', id: string, pms_id?: string | null, pms?: PracticeManagementSystem | null, client_pms_id?: string | null, is_new_client?: boolean | null, start_time: number, drop_off_time?: number | null, minutes: number, is_new_patient?: boolean | null, is_clinician_auto_assigned?: boolean | null, patient_pms_id?: string | null, referring_clinic_name?: string | null, client_notes?: string | null, clinic_notes?: string | null, service_name?: string | null, status: AppointmentStatus, is_time_block?: boolean | null, is_confirmed?: boolean | null, origin?: EntityOrigin | null, reason_for_cancellation?: string | null, client_reason_for_cancellation?: string | null, new_client_name?: string | null, new_client_phone?: string | null, new_patient_name?: string | null, new_patient_species?: string | null, confirmed_at?: number | null, widget_source?: string | null, from_widget?: string | null, is_deleted?: boolean | null, created_at: number, updated_at: number, pms_created_at?: number | null, clinic?: { __typename?: 'Clinic', id: string, name?: string | null, slug?: string | null, address?: { __typename?: 'Address', country?: string | null } | null, pms_db?: { __typename?: 'PmsDb', id: string } | null } | null, client?: { __typename?: 'Client', id: string, first_name?: string | null, last_name?: string | null, phone?: string | null, email?: string | null, is_active?: boolean | null, address?: { __typename?: 'Address', street_a?: string | null, street_b?: string | null, city?: string | null, state?: string | null, zip?: string | null, country?: string | null } | null } | null, clinician?: { __typename?: 'Clinician', id: string, name: string, display_name?: string | null, avatar_url?: string | null, initials?: string | null } | null, room?: { __typename?: 'Room', id: string, name: string } | null, service?: { __typename?: 'Service', id: string, name?: string | null, color?: string | null } | null, patient?: { __typename?: 'Patient', id: string, name?: string | null, breed?: string | null, avatar_url?: string | null, birthday?: number | null, weight?: number | null, gender?: string | null, fixed_status?: FixedStatus | null, is_active?: boolean | null, is_deceased?: boolean | null, clinic_species?: { __typename?: 'ClinicSpecies', id: string, species: Species, description: string } | null, clinic_breed?: { __typename?: 'Breed', id: string, description: string } | null } | null, clinic_appt_status?: { __typename?: 'ClinicApptStatus', id: string, description: string, status: AppointmentStatus } | null, client_info?: { __typename?: 'ClientInfo', first_name?: string | null, last_name?: string | null, email?: string | null, phone?: string | null } | null, patient_info?: { __typename?: 'PatientInfo', patient_name?: string | null, patient_breed?: string | null, patient_clinic_species?: string | null, patient_clinic_breed?: string | null } | null } | null, reschedule?: { __typename?: 'Reschedule', id: string, requested_start_time?: number | null, original_start_time?: number | null, clinic_notes?: string | null, client_notes?: string | null, reason_for_denial?: string | null, status: RescheduleStatus, initiated_by: RescheduleInitiatedBy, confirmed_at?: number | null, created_at: number, updated_at: number, appointment: { __typename?: 'Appointment', id: string, pms_id?: string | null, pms?: PracticeManagementSystem | null, client_pms_id?: string | null, is_new_client?: boolean | null, start_time: number, drop_off_time?: number | null, minutes: number, is_new_patient?: boolean | null, is_clinician_auto_assigned?: boolean | null, patient_pms_id?: string | null, referring_clinic_name?: string | null, client_notes?: string | null, clinic_notes?: string | null, service_name?: string | null, status: AppointmentStatus, is_time_block?: boolean | null, is_confirmed?: boolean | null, origin?: EntityOrigin | null, reason_for_cancellation?: string | null, client_reason_for_cancellation?: string | null, new_client_name?: string | null, new_client_phone?: string | null, new_patient_name?: string | null, new_patient_species?: string | null, confirmed_at?: number | null, widget_source?: string | null, from_widget?: string | null, is_deleted?: boolean | null, created_at: number, updated_at: number, pms_created_at?: number | null, clinic?: { __typename?: 'Clinic', id: string, name?: string | null, slug?: string | null, address?: { __typename?: 'Address', country?: string | null } | null, pms_db?: { __typename?: 'PmsDb', id: string } | null } | null, client?: { __typename?: 'Client', id: string, first_name?: string | null, last_name?: string | null, phone?: string | null, email?: string | null, is_active?: boolean | null, address?: { __typename?: 'Address', street_a?: string | null, street_b?: string | null, city?: string | null, state?: string | null, zip?: string | null, country?: string | null } | null } | null, clinician?: { __typename?: 'Clinician', id: string, name: string, display_name?: string | null, avatar_url?: string | null, initials?: string | null } | null, room?: { __typename?: 'Room', id: string, name: string } | null, service?: { __typename?: 'Service', id: string, name?: string | null, color?: string | null } | null, patient?: { __typename?: 'Patient', id: string, name?: string | null, breed?: string | null, avatar_url?: string | null, birthday?: number | null, weight?: number | null, gender?: string | null, fixed_status?: FixedStatus | null, is_active?: boolean | null, is_deceased?: boolean | null, clinic_species?: { __typename?: 'ClinicSpecies', id: string, species: Species, description: string } | null, clinic_breed?: { __typename?: 'Breed', id: string, description: string } | null } | null, clinic_appt_status?: { __typename?: 'ClinicApptStatus', id: string, description: string, status: AppointmentStatus } | null, client_info?: { __typename?: 'ClientInfo', first_name?: string | null, last_name?: string | null, email?: string | null, phone?: string | null } | null, patient_info?: { __typename?: 'PatientInfo', patient_name?: string | null, patient_breed?: string | null, patient_clinic_species?: string | null, patient_clinic_breed?: string | null } | null }, requested_clinician?: { __typename?: 'Clinician', id: string, name: string } | null, original_clinician?: { __typename?: 'Clinician', id: string, name: string } | null } | null, chat?: { __typename?: 'Chat', id: string, title?: string | null, clinic_unread_count: number, last_message?: string | null, last_message_time: number, client_last_message?: string | null, client_last_message_time: number, client_message_count: number, clinic_last_message?: string | null, clinic_last_message_time: number, non_system_last_message?: string | null, non_system_last_message_time: number, system_last_message?: string | null, system_last_message_time: number, status: ChatStatus, is_pinned: boolean, clinic: { __typename?: 'Clinic', id: string, pms: PracticeManagementSystem, name?: string | null }, client: { __typename?: 'Client', id: string, first_name?: string | null, last_name?: string | null, patients?: Array<{ __typename?: 'Patient', id: string, name?: string | null, pms_id?: string | null, is_deceased?: boolean | null, is_active?: boolean | null }> | null }, assignee?: { __typename?: 'User', id: string, avatar_url?: string | null, first_name?: string | null, last_name?: string | null } | null, chat_status?: { __typename?: 'ChatStatusConfig', id: string, name: string, color?: string | null } | null } | null, client_form?: { __typename?: 'ClientForm', id: string, client_completed_at?: number | null, clinic_verified_at?: number | null, is_archived: boolean, pms_id?: string | null, created_at: number, updated_at: number, client?: { __typename?: 'Client', id: string, first_name?: string | null, last_name?: string | null, phone?: string | null, email?: string | null, address?: { __typename?: 'Address', street_a?: string | null, city?: string | null, state?: string | null, zip?: string | null, country?: string | null } | null } | null, patient?: { __typename?: 'Patient', id: string, name?: string | null, is_active?: boolean | null, is_deceased?: boolean | null, birthday?: number | null, weight?: number | null, avatar_url?: string | null, gender?: string | null, owner?: { __typename?: 'Client', first_name?: string | null, last_name?: string | null } | null, clinic_species?: { __typename?: 'ClinicSpecies', id: string, species: Species, description: string, weight_key: string } | null, clinic_breed?: { __typename?: 'Breed', id: string, description: string } | null } | null, form: { __typename?: 'Form', id: string, name?: string | null, form_type: FormType, is_writeback_enabled: boolean, form_file_naming_template?: string | null }, form_data: { __typename?: 'FormFields', pages?: Array<{ __typename?: 'FormPage', id: string, title?: string | null, description?: string | null, order?: number | null }> | null, fields?: Array<{ __typename?: 'FormElement', id: string, type?: FormElementType | null, content?: string | null, name?: string | null, column_order?: number | null, row_order?: number | null, page_id?: string | null, options?: Array<string> | null, is_required?: boolean | null, value?: string | null, attachments?: Array<{ __typename?: 'FormFileAttachment', id?: string | null, filename?: string | null, mime_type?: string | null, size_bytes?: number | null, thumbnail_url?: string | null, url: string }> | null, field_updates?: Array<{ __typename?: 'FormFieldUpdate', field: FormFieldUpdateField, boolean_value?: boolean | null, option?: string | null }> | null }> | null }, appointment?: { __typename?: 'Appointment', start_time: number, drop_off_time?: number | null, clinic?: { __typename?: 'Clinic', name?: string | null, slug?: string | null, phone?: string | null, email?: string | null, address?: { __typename?: 'Address', street_a?: string | null, city?: string | null, state?: string | null, zip?: string | null, country?: string | null } | null } | null, clinician?: { __typename?: 'Clinician', name: string, display_name?: string | null } | null, service?: { __typename?: 'Service', name?: string | null } | null } | null } | null, prescription_refill_request?: { __typename?: 'PrescriptionRefillRequest', id: string, pickup_time?: number | null, stripe_payment_intent_id?: string | null, amount?: number | null, status: PrescriptionRefillRequestStatus, type: PrescriptionRefillRequestType, notes?: string | null, denial_reason?: string | null, approved_at?: number | null, denied_at?: number | null, created_at: number, updated_at: number, clinic: { __typename?: 'Clinic', id: string }, client: { __typename?: 'Client', id: string, first_name?: string | null, last_name?: string | null, secondary_first_name?: string | null, secondary_last_name?: string | null, phone?: string | null, email?: string | null, pms_id?: string | null, is_active?: boolean | null, is_unsubscribed: boolean, sms_enabled: boolean, email_enabled: boolean, balance?: number | null, last_appt_time?: number | null, created_at: number, updated_at: number, last_appointment?: { __typename?: 'Appointment', clinician?: { __typename?: 'Clinician', name: string, display_name?: string | null } | null } | null, address?: { __typename?: 'Address', street_a?: string | null, street_b?: string | null, city?: string | null, state?: string | null, zip?: string | null, country?: string | null } | null, clinic?: { __typename?: 'Clinic', id: string } | null, user?: { __typename?: 'User', avatar_url?: string | null } | null, patients?: Array<{ __typename?: 'Patient', id: string, name?: string | null, gender?: string | null, pms_id?: string | null, is_deceased?: boolean | null, is_active?: boolean | null, clinic_species?: { __typename?: 'ClinicSpecies', id: string, species: Species } | null, clinic_breed?: { __typename?: 'Breed', id: string, description: string } | null, last_appointment?: { __typename?: 'Appointment', clinician?: { __typename?: 'Clinician', name: string, display_name?: string | null } | null } | null }> | null, settings?: { __typename?: 'ClientSettings', clinic_chckup_notifications_enabled: boolean, clinic_chckup_sms_enabled: boolean, clinic_chckup_email_enabled: boolean, client_chckup_notifications_enabled: boolean, client_chckup_sms_enabled: boolean, client_chckup_email_enabled: boolean, is_unsubscribed_from_marketing: boolean, is_unsubscribed_from_marketing_sms: boolean, is_unsubscribed_from_marketing_email: boolean } | null }, patient?: { __typename?: 'Patient', id: string, pms_id?: string | null, name?: string | null, breed?: string | null, is_active?: boolean | null, is_deceased?: boolean | null, avatar_url?: string | null, gender?: string | null, fixed_status?: FixedStatus | null, birthday?: number | null, weight?: number | null, owner?: { __typename?: 'Client', id: string, first_name?: string | null, last_name?: string | null, secondary_first_name?: string | null, secondary_last_name?: string | null, phone?: string | null, email?: string | null } | null, clinic_species?: { __typename?: 'ClinicSpecies', id: string, species: Species, description: string, weight_key: string } | null, clinic_breed?: { __typename?: 'Breed', id: string, description: string } | null } | null, prescription?: { __typename?: 'Prescription', id: string, name?: string | null, product_name?: string | null, quantity?: number | null, refill_count?: number | null, refill_limit?: number | null, product?: { __typename?: 'Product', id: string, name: string, price: number, chckvet_price?: number | null, unit?: string | null, volume?: string | null, additional_fees?: Array<{ __typename?: 'AdditionalFees', name: string, amount: number }> | null } | null } | null, appointment?: { __typename?: 'Appointment', id: string, start_time: number, status: AppointmentStatus } | null } | null, pet_selfie?: { __typename?: 'PetSelfie', id: string, submitted_media_url: string, display_media_url?: string | null, media_type: PetSelfieMediaType, mime_type: string, filename?: string | null, size_bytes?: number | null, thumbnail_url?: string | null, pet_name?: string | null, nickname?: string | null, favorite_activity?: string | null, weirdest_thing?: string | null, display_caption?: string | null, allow_public_share: boolean, public_share_authorized_at?: number | null, first_viewed_at?: number | null, first_viewed_by?: string | null, in_slideshow: boolean, in_portal_carousel: boolean, in_gallery: boolean, is_excluded: boolean, is_archived: boolean, reaction_sent_at?: number | null, reaction_message?: string | null, created_at: number, updated_at: number, clinic: { __typename?: 'Clinic', id: string }, client: { __typename?: 'Client', id: string, first_name?: string | null, last_name?: string | null, secondary_first_name?: string | null, secondary_last_name?: string | null, phone?: string | null, email?: string | null, pms_id?: string | null, is_active?: boolean | null, is_unsubscribed: boolean, sms_enabled: boolean, email_enabled: boolean, balance?: number | null, last_appt_time?: number | null, created_at: number, updated_at: number, last_appointment?: { __typename?: 'Appointment', clinician?: { __typename?: 'Clinician', name: string, display_name?: string | null } | null } | null, address?: { __typename?: 'Address', street_a?: string | null, street_b?: string | null, city?: string | null, state?: string | null, zip?: string | null, country?: string | null } | null, clinic?: { __typename?: 'Clinic', id: string } | null, user?: { __typename?: 'User', avatar_url?: string | null } | null, patients?: Array<{ __typename?: 'Patient', id: string, name?: string | null, gender?: string | null, pms_id?: string | null, is_deceased?: boolean | null, is_active?: boolean | null, clinic_species?: { __typename?: 'ClinicSpecies', id: string, species: Species } | null, clinic_breed?: { __typename?: 'Breed', id: string, description: string } | null, last_appointment?: { __typename?: 'Appointment', clinician?: { __typename?: 'Clinician', name: string, display_name?: string | null } | null } | null }> | null, settings?: { __typename?: 'ClientSettings', clinic_chckup_notifications_enabled: boolean, clinic_chckup_sms_enabled: boolean, clinic_chckup_email_enabled: boolean, client_chckup_notifications_enabled: boolean, client_chckup_sms_enabled: boolean, client_chckup_email_enabled: boolean, is_unsubscribed_from_marketing: boolean, is_unsubscribed_from_marketing_sms: boolean, is_unsubscribed_from_marketing_email: boolean } | null }, patient?: { __typename?: 'Patient', id: string, pms_id?: string | null, name?: string | null, breed?: string | null, is_active?: boolean | null, is_deceased?: boolean | null, avatar_url?: string | null, gender?: string | null, fixed_status?: FixedStatus | null, birthday?: number | null, weight?: number | null, owner?: { __typename?: 'Client', id: string, first_name?: string | null, last_name?: string | null, secondary_first_name?: string | null, secondary_last_name?: string | null, phone?: string | null, email?: string | null } | null, clinic_species?: { __typename?: 'ClinicSpecies', id: string, species: Species, description: string, weight_key: string } | null, clinic_breed?: { __typename?: 'Breed', id: string, description: string } | null } | null } | null, originating_call?: { __typename?: 'Call', id: string, status: CallStatus, direction?: CallDirection | null, is_automated?: boolean | null, caller_name?: string | null, caller_phone?: string | null, to_phone?: string | null, duration?: number | null, recording_url?: string | null, transcription_full_text?: string | null, transcription_summary?: string | null, notes?: string | null, score?: number | null, score_reasoning?: string | null, sentiment_customer?: number | null, sentiment_agent?: number | null, created_at: number, updated_at: number, client?: { __typename?: 'Client', first_name?: string | null, last_name?: string | null, phone?: string | null } | null } | null, assignee?: { __typename?: 'User', id: string, avatar_url?: string | null, first_name?: string | null, last_name?: string | null } | null, clinic: { __typename?: 'Clinic', id: string } } };

export type QueryActionItemsQueryVariables = Exact<{
  where?: InputMaybe<Array<QueryInput> | QueryInput>;
  page?: InputMaybe<Scalars['NonNegativeInt']['input']>;
  pageSize?: InputMaybe<Scalars['NonNegativeInt']['input']>;
  orderBy?: InputMaybe<OrderByInput>;
}>;


export type QueryActionItemsQuery = { __typename?: 'Query', queryActionItems: Array<{ __typename?: 'ActionItem', id: string, type: ActionItemType, status: ActionItemStatus, description?: string | null, created_at: number, updated_at: number, pending_appointment?: { __typename?: 'Appointment', id: string, pms_id?: string | null, pms?: PracticeManagementSystem | null, client_pms_id?: string | null, is_new_client?: boolean | null, start_time: number, drop_off_time?: number | null, minutes: number, is_new_patient?: boolean | null, is_clinician_auto_assigned?: boolean | null, patient_pms_id?: string | null, referring_clinic_name?: string | null, client_notes?: string | null, clinic_notes?: string | null, service_name?: string | null, status: AppointmentStatus, is_time_block?: boolean | null, is_confirmed?: boolean | null, origin?: EntityOrigin | null, reason_for_cancellation?: string | null, client_reason_for_cancellation?: string | null, new_client_name?: string | null, new_client_phone?: string | null, new_patient_name?: string | null, new_patient_species?: string | null, confirmed_at?: number | null, widget_source?: string | null, from_widget?: string | null, is_deleted?: boolean | null, created_at: number, updated_at: number, pms_created_at?: number | null, clinic?: { __typename?: 'Clinic', id: string, name?: string | null, slug?: string | null, address?: { __typename?: 'Address', country?: string | null } | null, pms_db?: { __typename?: 'PmsDb', id: string } | null } | null, client?: { __typename?: 'Client', id: string, first_name?: string | null, last_name?: string | null, phone?: string | null, email?: string | null, is_active?: boolean | null, address?: { __typename?: 'Address', street_a?: string | null, street_b?: string | null, city?: string | null, state?: string | null, zip?: string | null, country?: string | null } | null } | null, clinician?: { __typename?: 'Clinician', id: string, name: string, display_name?: string | null, avatar_url?: string | null, initials?: string | null } | null, room?: { __typename?: 'Room', id: string, name: string } | null, service?: { __typename?: 'Service', id: string, name?: string | null, color?: string | null } | null, patient?: { __typename?: 'Patient', id: string, name?: string | null, breed?: string | null, avatar_url?: string | null, birthday?: number | null, weight?: number | null, gender?: string | null, fixed_status?: FixedStatus | null, is_active?: boolean | null, is_deceased?: boolean | null, clinic_species?: { __typename?: 'ClinicSpecies', id: string, species: Species, description: string } | null, clinic_breed?: { __typename?: 'Breed', id: string, description: string } | null } | null, clinic_appt_status?: { __typename?: 'ClinicApptStatus', id: string, description: string, status: AppointmentStatus } | null, client_info?: { __typename?: 'ClientInfo', first_name?: string | null, last_name?: string | null, email?: string | null, phone?: string | null } | null, patient_info?: { __typename?: 'PatientInfo', patient_name?: string | null, patient_breed?: string | null, patient_clinic_species?: string | null, patient_clinic_breed?: string | null } | null } | null, reschedule?: { __typename?: 'Reschedule', id: string, requested_start_time?: number | null, original_start_time?: number | null, clinic_notes?: string | null, client_notes?: string | null, reason_for_denial?: string | null, status: RescheduleStatus, initiated_by: RescheduleInitiatedBy, confirmed_at?: number | null, created_at: number, updated_at: number, appointment: { __typename?: 'Appointment', id: string, pms_id?: string | null, pms?: PracticeManagementSystem | null, client_pms_id?: string | null, is_new_client?: boolean | null, start_time: number, drop_off_time?: number | null, minutes: number, is_new_patient?: boolean | null, is_clinician_auto_assigned?: boolean | null, patient_pms_id?: string | null, referring_clinic_name?: string | null, client_notes?: string | null, clinic_notes?: string | null, service_name?: string | null, status: AppointmentStatus, is_time_block?: boolean | null, is_confirmed?: boolean | null, origin?: EntityOrigin | null, reason_for_cancellation?: string | null, client_reason_for_cancellation?: string | null, new_client_name?: string | null, new_client_phone?: string | null, new_patient_name?: string | null, new_patient_species?: string | null, confirmed_at?: number | null, widget_source?: string | null, from_widget?: string | null, is_deleted?: boolean | null, created_at: number, updated_at: number, pms_created_at?: number | null, clinic?: { __typename?: 'Clinic', id: string, name?: string | null, slug?: string | null, address?: { __typename?: 'Address', country?: string | null } | null, pms_db?: { __typename?: 'PmsDb', id: string } | null } | null, client?: { __typename?: 'Client', id: string, first_name?: string | null, last_name?: string | null, phone?: string | null, email?: string | null, is_active?: boolean | null, address?: { __typename?: 'Address', street_a?: string | null, street_b?: string | null, city?: string | null, state?: string | null, zip?: string | null, country?: string | null } | null } | null, clinician?: { __typename?: 'Clinician', id: string, name: string, display_name?: string | null, avatar_url?: string | null, initials?: string | null } | null, room?: { __typename?: 'Room', id: string, name: string } | null, service?: { __typename?: 'Service', id: string, name?: string | null, color?: string | null } | null, patient?: { __typename?: 'Patient', id: string, name?: string | null, breed?: string | null, avatar_url?: string | null, birthday?: number | null, weight?: number | null, gender?: string | null, fixed_status?: FixedStatus | null, is_active?: boolean | null, is_deceased?: boolean | null, clinic_species?: { __typename?: 'ClinicSpecies', id: string, species: Species, description: string } | null, clinic_breed?: { __typename?: 'Breed', id: string, description: string } | null } | null, clinic_appt_status?: { __typename?: 'ClinicApptStatus', id: string, description: string, status: AppointmentStatus } | null, client_info?: { __typename?: 'ClientInfo', first_name?: string | null, last_name?: string | null, email?: string | null, phone?: string | null } | null, patient_info?: { __typename?: 'PatientInfo', patient_name?: string | null, patient_breed?: string | null, patient_clinic_species?: string | null, patient_clinic_breed?: string | null } | null }, requested_clinician?: { __typename?: 'Clinician', id: string, name: string } | null, original_clinician?: { __typename?: 'Clinician', id: string, name: string } | null } | null, chat?: { __typename?: 'Chat', id: string, title?: string | null, clinic_unread_count: number, last_message?: string | null, last_message_time: number, client_last_message?: string | null, client_last_message_time: number, client_message_count: number, clinic_last_message?: string | null, clinic_last_message_time: number, non_system_last_message?: string | null, non_system_last_message_time: number, system_last_message?: string | null, system_last_message_time: number, status: ChatStatus, is_pinned: boolean, clinic: { __typename?: 'Clinic', id: string, pms: PracticeManagementSystem, name?: string | null }, client: { __typename?: 'Client', id: string, first_name?: string | null, last_name?: string | null, patients?: Array<{ __typename?: 'Patient', id: string, name?: string | null, pms_id?: string | null, is_deceased?: boolean | null, is_active?: boolean | null }> | null }, assignee?: { __typename?: 'User', id: string, avatar_url?: string | null, first_name?: string | null, last_name?: string | null } | null, chat_status?: { __typename?: 'ChatStatusConfig', id: string, name: string, color?: string | null } | null } | null, client_form?: { __typename?: 'ClientForm', id: string, client_completed_at?: number | null, clinic_verified_at?: number | null, is_archived: boolean, pms_id?: string | null, created_at: number, updated_at: number, client?: { __typename?: 'Client', id: string, first_name?: string | null, last_name?: string | null, phone?: string | null, email?: string | null, address?: { __typename?: 'Address', street_a?: string | null, city?: string | null, state?: string | null, zip?: string | null, country?: string | null } | null } | null, patient?: { __typename?: 'Patient', id: string, name?: string | null, is_active?: boolean | null, is_deceased?: boolean | null, birthday?: number | null, weight?: number | null, avatar_url?: string | null, gender?: string | null, owner?: { __typename?: 'Client', first_name?: string | null, last_name?: string | null } | null, clinic_species?: { __typename?: 'ClinicSpecies', id: string, species: Species, description: string, weight_key: string } | null, clinic_breed?: { __typename?: 'Breed', id: string, description: string } | null } | null, form: { __typename?: 'Form', id: string, name?: string | null, form_type: FormType, is_writeback_enabled: boolean, form_file_naming_template?: string | null }, form_data: { __typename?: 'FormFields', pages?: Array<{ __typename?: 'FormPage', id: string, title?: string | null, description?: string | null, order?: number | null }> | null, fields?: Array<{ __typename?: 'FormElement', id: string, type?: FormElementType | null, content?: string | null, name?: string | null, column_order?: number | null, row_order?: number | null, page_id?: string | null, options?: Array<string> | null, is_required?: boolean | null, value?: string | null, attachments?: Array<{ __typename?: 'FormFileAttachment', id?: string | null, filename?: string | null, mime_type?: string | null, size_bytes?: number | null, thumbnail_url?: string | null, url: string }> | null, field_updates?: Array<{ __typename?: 'FormFieldUpdate', field: FormFieldUpdateField, boolean_value?: boolean | null, option?: string | null }> | null }> | null }, appointment?: { __typename?: 'Appointment', start_time: number, drop_off_time?: number | null, clinic?: { __typename?: 'Clinic', name?: string | null, slug?: string | null, phone?: string | null, email?: string | null, address?: { __typename?: 'Address', street_a?: string | null, city?: string | null, state?: string | null, zip?: string | null, country?: string | null } | null } | null, clinician?: { __typename?: 'Clinician', name: string, display_name?: string | null } | null, service?: { __typename?: 'Service', name?: string | null } | null } | null } | null, prescription_refill_request?: { __typename?: 'PrescriptionRefillRequest', id: string, pickup_time?: number | null, stripe_payment_intent_id?: string | null, amount?: number | null, status: PrescriptionRefillRequestStatus, type: PrescriptionRefillRequestType, notes?: string | null, denial_reason?: string | null, approved_at?: number | null, denied_at?: number | null, created_at: number, updated_at: number, clinic: { __typename?: 'Clinic', id: string }, client: { __typename?: 'Client', id: string, first_name?: string | null, last_name?: string | null, secondary_first_name?: string | null, secondary_last_name?: string | null, phone?: string | null, email?: string | null, pms_id?: string | null, is_active?: boolean | null, is_unsubscribed: boolean, sms_enabled: boolean, email_enabled: boolean, balance?: number | null, last_appt_time?: number | null, created_at: number, updated_at: number, last_appointment?: { __typename?: 'Appointment', clinician?: { __typename?: 'Clinician', name: string, display_name?: string | null } | null } | null, address?: { __typename?: 'Address', street_a?: string | null, street_b?: string | null, city?: string | null, state?: string | null, zip?: string | null, country?: string | null } | null, clinic?: { __typename?: 'Clinic', id: string } | null, user?: { __typename?: 'User', avatar_url?: string | null } | null, patients?: Array<{ __typename?: 'Patient', id: string, name?: string | null, gender?: string | null, pms_id?: string | null, is_deceased?: boolean | null, is_active?: boolean | null, clinic_species?: { __typename?: 'ClinicSpecies', id: string, species: Species } | null, clinic_breed?: { __typename?: 'Breed', id: string, description: string } | null, last_appointment?: { __typename?: 'Appointment', clinician?: { __typename?: 'Clinician', name: string, display_name?: string | null } | null } | null }> | null, settings?: { __typename?: 'ClientSettings', clinic_chckup_notifications_enabled: boolean, clinic_chckup_sms_enabled: boolean, clinic_chckup_email_enabled: boolean, client_chckup_notifications_enabled: boolean, client_chckup_sms_enabled: boolean, client_chckup_email_enabled: boolean, is_unsubscribed_from_marketing: boolean, is_unsubscribed_from_marketing_sms: boolean, is_unsubscribed_from_marketing_email: boolean } | null }, patient?: { __typename?: 'Patient', id: string, pms_id?: string | null, name?: string | null, breed?: string | null, is_active?: boolean | null, is_deceased?: boolean | null, avatar_url?: string | null, gender?: string | null, fixed_status?: FixedStatus | null, birthday?: number | null, weight?: number | null, owner?: { __typename?: 'Client', id: string, first_name?: string | null, last_name?: string | null, secondary_first_name?: string | null, secondary_last_name?: string | null, phone?: string | null, email?: string | null } | null, clinic_species?: { __typename?: 'ClinicSpecies', id: string, species: Species, description: string, weight_key: string } | null, clinic_breed?: { __typename?: 'Breed', id: string, description: string } | null } | null, prescription?: { __typename?: 'Prescription', id: string, name?: string | null, product_name?: string | null, quantity?: number | null, refill_count?: number | null, refill_limit?: number | null, product?: { __typename?: 'Product', id: string, name: string, price: number, chckvet_price?: number | null, unit?: string | null, volume?: string | null, additional_fees?: Array<{ __typename?: 'AdditionalFees', name: string, amount: number }> | null } | null } | null, appointment?: { __typename?: 'Appointment', id: string, start_time: number, status: AppointmentStatus } | null } | null, pet_selfie?: { __typename?: 'PetSelfie', id: string, submitted_media_url: string, display_media_url?: string | null, media_type: PetSelfieMediaType, mime_type: string, filename?: string | null, size_bytes?: number | null, thumbnail_url?: string | null, pet_name?: string | null, nickname?: string | null, favorite_activity?: string | null, weirdest_thing?: string | null, display_caption?: string | null, allow_public_share: boolean, public_share_authorized_at?: number | null, first_viewed_at?: number | null, first_viewed_by?: string | null, in_slideshow: boolean, in_portal_carousel: boolean, in_gallery: boolean, is_excluded: boolean, is_archived: boolean, reaction_sent_at?: number | null, reaction_message?: string | null, created_at: number, updated_at: number, clinic: { __typename?: 'Clinic', id: string }, client: { __typename?: 'Client', id: string, first_name?: string | null, last_name?: string | null, secondary_first_name?: string | null, secondary_last_name?: string | null, phone?: string | null, email?: string | null, pms_id?: string | null, is_active?: boolean | null, is_unsubscribed: boolean, sms_enabled: boolean, email_enabled: boolean, balance?: number | null, last_appt_time?: number | null, created_at: number, updated_at: number, last_appointment?: { __typename?: 'Appointment', clinician?: { __typename?: 'Clinician', name: string, display_name?: string | null } | null } | null, address?: { __typename?: 'Address', street_a?: string | null, street_b?: string | null, city?: string | null, state?: string | null, zip?: string | null, country?: string | null } | null, clinic?: { __typename?: 'Clinic', id: string } | null, user?: { __typename?: 'User', avatar_url?: string | null } | null, patients?: Array<{ __typename?: 'Patient', id: string, name?: string | null, gender?: string | null, pms_id?: string | null, is_deceased?: boolean | null, is_active?: boolean | null, clinic_species?: { __typename?: 'ClinicSpecies', id: string, species: Species } | null, clinic_breed?: { __typename?: 'Breed', id: string, description: string } | null, last_appointment?: { __typename?: 'Appointment', clinician?: { __typename?: 'Clinician', name: string, display_name?: string | null } | null } | null }> | null, settings?: { __typename?: 'ClientSettings', clinic_chckup_notifications_enabled: boolean, clinic_chckup_sms_enabled: boolean, clinic_chckup_email_enabled: boolean, client_chckup_notifications_enabled: boolean, client_chckup_sms_enabled: boolean, client_chckup_email_enabled: boolean, is_unsubscribed_from_marketing: boolean, is_unsubscribed_from_marketing_sms: boolean, is_unsubscribed_from_marketing_email: boolean } | null }, patient?: { __typename?: 'Patient', id: string, pms_id?: string | null, name?: string | null, breed?: string | null, is_active?: boolean | null, is_deceased?: boolean | null, avatar_url?: string | null, gender?: string | null, fixed_status?: FixedStatus | null, birthday?: number | null, weight?: number | null, owner?: { __typename?: 'Client', id: string, first_name?: string | null, last_name?: string | null, secondary_first_name?: string | null, secondary_last_name?: string | null, phone?: string | null, email?: string | null } | null, clinic_species?: { __typename?: 'ClinicSpecies', id: string, species: Species, description: string, weight_key: string } | null, clinic_breed?: { __typename?: 'Breed', id: string, description: string } | null } | null } | null, originating_call?: { __typename?: 'Call', id: string, status: CallStatus, direction?: CallDirection | null, is_automated?: boolean | null, caller_name?: string | null, caller_phone?: string | null, to_phone?: string | null, duration?: number | null, recording_url?: string | null, transcription_full_text?: string | null, transcription_summary?: string | null, notes?: string | null, score?: number | null, score_reasoning?: string | null, sentiment_customer?: number | null, sentiment_agent?: number | null, created_at: number, updated_at: number, client?: { __typename?: 'Client', first_name?: string | null, last_name?: string | null, phone?: string | null } | null } | null, assignee?: { __typename?: 'User', id: string, avatar_url?: string | null, first_name?: string | null, last_name?: string | null } | null, clinic: { __typename?: 'Clinic', id: string } }> };

export type CountActionItemsQueryVariables = Exact<{
  where?: InputMaybe<Array<QueryInput> | QueryInput>;
}>;


export type CountActionItemsQuery = { __typename?: 'Query', countActionItems: number };

export type QueryAppointmentActionItemsQueryVariables = Exact<{
  where?: InputMaybe<Array<QueryInput> | QueryInput>;
  page?: InputMaybe<Scalars['NonNegativeInt']['input']>;
  pageSize?: InputMaybe<Scalars['NonNegativeInt']['input']>;
  orderBy?: InputMaybe<OrderByInput>;
}>;


export type QueryAppointmentActionItemsQuery = { __typename?: 'Query', queryAppointments: Array<{ __typename?: 'Appointment', action_items?: Array<{ __typename?: 'ActionItem', id: string, type: ActionItemType, status: ActionItemStatus, description?: string | null, created_at: number, updated_at: number, pending_appointment?: { __typename?: 'Appointment', id: string, pms_id?: string | null, pms?: PracticeManagementSystem | null, client_pms_id?: string | null, is_new_client?: boolean | null, start_time: number, drop_off_time?: number | null, minutes: number, is_new_patient?: boolean | null, is_clinician_auto_assigned?: boolean | null, patient_pms_id?: string | null, referring_clinic_name?: string | null, client_notes?: string | null, clinic_notes?: string | null, service_name?: string | null, status: AppointmentStatus, is_time_block?: boolean | null, is_confirmed?: boolean | null, origin?: EntityOrigin | null, reason_for_cancellation?: string | null, client_reason_for_cancellation?: string | null, new_client_name?: string | null, new_client_phone?: string | null, new_patient_name?: string | null, new_patient_species?: string | null, confirmed_at?: number | null, widget_source?: string | null, from_widget?: string | null, is_deleted?: boolean | null, created_at: number, updated_at: number, pms_created_at?: number | null, clinic?: { __typename?: 'Clinic', id: string, name?: string | null, slug?: string | null, address?: { __typename?: 'Address', country?: string | null } | null, pms_db?: { __typename?: 'PmsDb', id: string } | null } | null, client?: { __typename?: 'Client', id: string, first_name?: string | null, last_name?: string | null, phone?: string | null, email?: string | null, is_active?: boolean | null, address?: { __typename?: 'Address', street_a?: string | null, street_b?: string | null, city?: string | null, state?: string | null, zip?: string | null, country?: string | null } | null } | null, clinician?: { __typename?: 'Clinician', id: string, name: string, display_name?: string | null, avatar_url?: string | null, initials?: string | null } | null, room?: { __typename?: 'Room', id: string, name: string } | null, service?: { __typename?: 'Service', id: string, name?: string | null, color?: string | null } | null, patient?: { __typename?: 'Patient', id: string, name?: string | null, breed?: string | null, avatar_url?: string | null, birthday?: number | null, weight?: number | null, gender?: string | null, fixed_status?: FixedStatus | null, is_active?: boolean | null, is_deceased?: boolean | null, clinic_species?: { __typename?: 'ClinicSpecies', id: string, species: Species, description: string } | null, clinic_breed?: { __typename?: 'Breed', id: string, description: string } | null } | null, clinic_appt_status?: { __typename?: 'ClinicApptStatus', id: string, description: string, status: AppointmentStatus } | null, client_info?: { __typename?: 'ClientInfo', first_name?: string | null, last_name?: string | null, email?: string | null, phone?: string | null } | null, patient_info?: { __typename?: 'PatientInfo', patient_name?: string | null, patient_breed?: string | null, patient_clinic_species?: string | null, patient_clinic_breed?: string | null } | null } | null, assignee?: { __typename?: 'User', id: string, avatar_url?: string | null, first_name?: string | null, last_name?: string | null } | null, clinic: { __typename?: 'Clinic', id: string } }> | null }> };

export type QueryRescheduleActionItemsQueryVariables = Exact<{
  where?: InputMaybe<Array<QueryInput> | QueryInput>;
  page?: InputMaybe<Scalars['NonNegativeInt']['input']>;
  pageSize?: InputMaybe<Scalars['NonNegativeInt']['input']>;
  orderBy?: InputMaybe<OrderByInput>;
}>;


export type QueryRescheduleActionItemsQuery = { __typename?: 'Query', queryReschedules: Array<{ __typename?: 'Reschedule', action_items?: Array<{ __typename?: 'ActionItem', id: string, type: ActionItemType, status: ActionItemStatus, description?: string | null, created_at: number, updated_at: number, reschedule?: { __typename?: 'Reschedule', id: string, requested_start_time?: number | null, original_start_time?: number | null, clinic_notes?: string | null, client_notes?: string | null, reason_for_denial?: string | null, status: RescheduleStatus, initiated_by: RescheduleInitiatedBy, confirmed_at?: number | null, created_at: number, updated_at: number, appointment: { __typename?: 'Appointment', id: string, pms?: PracticeManagementSystem | null, client_pms_id?: string | null, is_new_client?: boolean | null, start_time: number, drop_off_time?: number | null, minutes: number, is_new_patient?: boolean | null, is_clinician_auto_assigned?: boolean | null, patient_pms_id?: string | null, referring_clinic_name?: string | null, client_notes?: string | null, clinic_notes?: string | null, service_name?: string | null, status: AppointmentStatus, is_time_block?: boolean | null, is_confirmed?: boolean | null, origin?: EntityOrigin | null, reason_for_cancellation?: string | null, client_reason_for_cancellation?: string | null, new_client_name?: string | null, new_client_phone?: string | null, new_patient_name?: string | null, new_patient_species?: string | null, confirmed_at?: number | null, widget_source?: string | null, from_widget?: string | null, is_deleted?: boolean | null, created_at: number, updated_at: number, pms_created_at?: number | null, clinic?: { __typename?: 'Clinic', id: string, name?: string | null, slug?: string | null, pms_db?: { __typename?: 'PmsDb', id: string } | null, address?: { __typename?: 'Address', country?: string | null } | null } | null, client?: { __typename?: 'Client', id: string, first_name?: string | null, last_name?: string | null, secondary_first_name?: string | null, secondary_last_name?: string | null, phone?: string | null, email?: string | null, pms?: PracticeManagementSystem | null, pms_id?: string | null, last_appt_time?: number | null, last_contact_time?: number | null, email_enabled: boolean, sms_enabled: boolean, balance?: number | null, is_active?: boolean | null, is_unsubscribed: boolean, created_at: number, updated_at: number, client_phones?: Array<{ __typename?: 'ClientPhone', id: string, phone: string, country_code?: string | null, is_primary: boolean, is_chckup_primary: boolean, is_mobile: boolean, sms_available: boolean, is_unsubscribed: boolean, is_active: boolean, name?: string | null }> | null, client_emails?: Array<{ __typename?: 'ClientEmail', id: string, email: string, is_primary: boolean }> | null, clinic?: { __typename?: 'Clinic', id: string } | null, patients?: Array<{ __typename?: 'Patient', id: string, pms?: PracticeManagementSystem | null, pms_id?: string | null, name?: string | null, breed?: string | null, avatar_url?: string | null, last_appt_time?: number | null, gender?: string | null, fixed_status?: FixedStatus | null, weight?: number | null, birthday?: number | null, is_active?: boolean | null, is_deceased?: boolean | null, pms_created_at?: number | null, created_at: number, updated_at: number, owner?: { __typename?: 'Client', id: string, first_name?: string | null, last_name?: string | null, email?: string | null, phone?: string | null, address?: { __typename?: 'Address', country?: string | null } | null } | null, clinic_species?: { __typename?: 'ClinicSpecies', id: string, pms_id: string, description: string, is_primary: boolean, species: Species, weight_key: string, created_at: number, updated_at: number } | null, clinic?: { __typename?: 'Clinic', id: string } | null, clinic_breed?: { __typename?: 'Breed', id: string, description: string } | null, patient_vaccination_records?: Array<{ __typename?: 'PatientVaccinationRecord', id: string, vaccine_name?: string | null, manufacturer?: string | null, lot_number?: string | null, administered_date?: number | null, due_date?: number | null, rabies_tag?: string | null, is_rabies_vaccine?: boolean | null, is_soc: boolean, is_active: boolean, product?: { __typename?: 'Product', id: string, display_name?: string | null, name: string } | null }> | null, last_appointment?: { __typename?: 'Appointment', clinician?: { __typename?: 'Clinician', name: string, display_name?: string | null } | null } | null }> | null, address?: { __typename?: 'Address', street_a?: string | null, street_b?: string | null, city?: string | null, state?: string | null, zip?: string | null, country?: string | null } | null, user?: { __typename?: 'User', avatar_url?: string | null } | null, loyalty_members?: Array<{ __typename?: 'LoyaltyMember', id: string, available_points: number } | null> | null, settings?: { __typename?: 'ClientSettings', clinic_chckup_notifications_enabled: boolean, clinic_chckup_sms_enabled: boolean, clinic_chckup_email_enabled: boolean, client_chckup_notifications_enabled: boolean, client_chckup_sms_enabled: boolean, client_chckup_email_enabled: boolean, is_unsubscribed_from_marketing: boolean, is_unsubscribed_from_marketing_sms: boolean, is_unsubscribed_from_marketing_email: boolean } | null, last_appointment?: { __typename?: 'Appointment', clinician?: { __typename?: 'Clinician', name: string, display_name?: string | null } | null } | null } | null, clinician?: { __typename?: 'Clinician', id: string, name: string, display_name?: string | null, bio?: string | null, avatar_url?: string | null, initials?: string | null, excluded_species?: Array<Species> | null, excluded_service_ids?: Array<string> | null, authority_level?: AuthorityLevel | null, type: ResourceType, is_active?: boolean | null, is_assignable_in_pms?: boolean | null, does_contribute_to_fill_rate?: boolean | null, pms_id?: string | null, location?: string | null, pms_is_active: boolean, valid_booking_interval_minutes?: Array<number> | null, created_at: number, updated_at: number, clinic?: { __typename?: 'Clinic', id: string, name?: string | null } | null, pms_db?: { __typename?: 'PmsDb', id: string } | null, hours?: { __typename?: 'AvailabilityHours', monday?: Array<{ __typename?: 'TimeInterval', start?: number | null, end?: number | null }> | null, tuesday?: Array<{ __typename?: 'TimeInterval', start?: number | null, end?: number | null }> | null, wednesday?: Array<{ __typename?: 'TimeInterval', start?: number | null, end?: number | null }> | null, thursday?: Array<{ __typename?: 'TimeInterval', start?: number | null, end?: number | null }> | null, friday?: Array<{ __typename?: 'TimeInterval', start?: number | null, end?: number | null }> | null, saturday?: Array<{ __typename?: 'TimeInterval', start?: number | null, end?: number | null }> | null, sunday?: Array<{ __typename?: 'TimeInterval', start?: number | null, end?: number | null }> | null } | null, adjusted_availability?: Array<{ __typename?: 'Availability', date: number, pms_appt_type_pms_id?: string | null, times: Array<{ __typename?: 'TimeInterval', start?: number | null, end?: number | null }>, repeat?: { __typename?: 'RepeatAvailability', daysOfMonth?: Array<number> | null, daysOfWeek?: Array<DayOfWeek> | null, weekOfMonth?: WeekOfMonth | null, frequency: any, unit: RepeatUnit, end_date?: number | null } | null }> | null, pms_adjusted_availability?: Array<{ __typename?: 'Availability', date: number, pms_appt_type_pms_id?: string | null, times: Array<{ __typename?: 'TimeInterval', start?: number | null, end?: number | null }>, repeat?: { __typename?: 'RepeatAvailability', daysOfMonth?: Array<number> | null, daysOfWeek?: Array<DayOfWeek> | null, weekOfMonth?: WeekOfMonth | null, frequency: any, unit: RepeatUnit, end_date?: number | null } | null }> | null } | null, room?: { __typename?: 'Room', id: string, pms_id: string, name: string, display_name?: string | null, description?: string | null, concurrent_patients?: number | null, is_active: boolean, does_contribute_to_fill_rate?: boolean | null, valid_booking_interval_minutes?: Array<number> | null, created_at: number, updated_at: number, clinic?: { __typename?: 'Clinic', pms: PracticeManagementSystem, id: string, name?: string | null, time_zone?: string | null } | null, hours?: { __typename?: 'AvailabilityHours', monday?: Array<{ __typename?: 'TimeInterval', start?: number | null, end?: number | null }> | null, tuesday?: Array<{ __typename?: 'TimeInterval', start?: number | null, end?: number | null }> | null, wednesday?: Array<{ __typename?: 'TimeInterval', start?: number | null, end?: number | null }> | null, thursday?: Array<{ __typename?: 'TimeInterval', start?: number | null, end?: number | null }> | null, friday?: Array<{ __typename?: 'TimeInterval', start?: number | null, end?: number | null }> | null, saturday?: Array<{ __typename?: 'TimeInterval', start?: number | null, end?: number | null }> | null, sunday?: Array<{ __typename?: 'TimeInterval', start?: number | null, end?: number | null }> | null } | null, adjusted_availability?: Array<{ __typename?: 'Availability', date: number, pms_appt_type_pms_id?: string | null, times: Array<{ __typename?: 'TimeInterval', start?: number | null, end?: number | null }>, repeat?: { __typename?: 'RepeatAvailability', daysOfMonth?: Array<number> | null, daysOfWeek?: Array<DayOfWeek> | null, weekOfMonth?: WeekOfMonth | null, frequency: any, unit: RepeatUnit, end_date?: number | null } | null }> | null, pms_adjusted_availability?: Array<{ __typename?: 'Availability', date: number, pms_appt_type_pms_id?: string | null, times: Array<{ __typename?: 'TimeInterval', start?: number | null, end?: number | null }>, repeat?: { __typename?: 'RepeatAvailability', daysOfMonth?: Array<number> | null, daysOfWeek?: Array<DayOfWeek> | null, weekOfMonth?: WeekOfMonth | null, frequency: any, unit: RepeatUnit, end_date?: number | null } | null }> | null } | null, service?: { __typename?: 'Service', id: string, name?: string | null, color?: string | null } | null, patient?: { __typename?: 'Patient', id: string, pms?: PracticeManagementSystem | null, pms_id?: string | null, name?: string | null, breed?: string | null, avatar_url?: string | null, last_appt_time?: number | null, gender?: string | null, fixed_status?: FixedStatus | null, weight?: number | null, birthday?: number | null, is_active?: boolean | null, is_deceased?: boolean | null, pms_created_at?: number | null, created_at: number, updated_at: number, owner?: { __typename?: 'Client', id: string, first_name?: string | null, last_name?: string | null, email?: string | null, phone?: string | null, address?: { __typename?: 'Address', country?: string | null } | null } | null, clinic_species?: { __typename?: 'ClinicSpecies', id: string, pms_id: string, description: string, is_primary: boolean, species: Species, weight_key: string, created_at: number, updated_at: number } | null, clinic?: { __typename?: 'Clinic', id: string } | null, clinic_breed?: { __typename?: 'Breed', id: string, description: string } | null, patient_vaccination_records?: Array<{ __typename?: 'PatientVaccinationRecord', id: string, vaccine_name?: string | null, manufacturer?: string | null, lot_number?: string | null, administered_date?: number | null, due_date?: number | null, rabies_tag?: string | null, is_rabies_vaccine?: boolean | null, is_soc: boolean, is_active: boolean, product?: { __typename?: 'Product', id: string, display_name?: string | null, name: string } | null }> | null, last_appointment?: { __typename?: 'Appointment', clinician?: { __typename?: 'Clinician', name: string, display_name?: string | null } | null } | null } | null, clinic_appt_status?: { __typename?: 'ClinicApptStatus', id: string, description: string, status: AppointmentStatus } | null, client_info?: { __typename?: 'ClientInfo', first_name?: string | null, last_name?: string | null, email?: string | null, phone?: string | null } | null, patient_info?: { __typename?: 'PatientInfo', patient_name?: string | null, patient_breed?: string | null, patient_clinic_species?: string | null, patient_clinic_breed?: string | null } | null, clients_forms?: Array<{ __typename?: 'ClientForm', id: string, client_completed_at?: number | null, clinic_verified_at?: number | null, is_archived: boolean, pms_id?: string | null, created_at: number, updated_at: number, client?: { __typename?: 'Client', id: string, first_name?: string | null, last_name?: string | null, phone?: string | null, email?: string | null, address?: { __typename?: 'Address', street_a?: string | null, city?: string | null, state?: string | null, zip?: string | null, country?: string | null } | null } | null, patient?: { __typename?: 'Patient', id: string, name?: string | null, is_active?: boolean | null, is_deceased?: boolean | null, birthday?: number | null, weight?: number | null, avatar_url?: string | null, gender?: string | null, owner?: { __typename?: 'Client', first_name?: string | null, last_name?: string | null } | null, clinic_species?: { __typename?: 'ClinicSpecies', id: string, species: Species, description: string, weight_key: string } | null, clinic_breed?: { __typename?: 'Breed', id: string, description: string } | null } | null, form: { __typename?: 'Form', id: string, name?: string | null, form_type: FormType, is_writeback_enabled: boolean, form_file_naming_template?: string | null }, form_data: { __typename?: 'FormFields', pages?: Array<{ __typename?: 'FormPage', id: string, title?: string | null, description?: string | null, order?: number | null }> | null, fields?: Array<{ __typename?: 'FormElement', id: string, type?: FormElementType | null, content?: string | null, name?: string | null, column_order?: number | null, row_order?: number | null, page_id?: string | null, options?: Array<string> | null, is_required?: boolean | null, value?: string | null, attachments?: Array<{ __typename?: 'FormFileAttachment', id?: string | null, filename?: string | null, mime_type?: string | null, size_bytes?: number | null, thumbnail_url?: string | null, url: string }> | null, field_updates?: Array<{ __typename?: 'FormFieldUpdate', field: FormFieldUpdateField, boolean_value?: boolean | null, option?: string | null }> | null }> | null }, appointment?: { __typename?: 'Appointment', start_time: number, drop_off_time?: number | null, clinic?: { __typename?: 'Clinic', name?: string | null, slug?: string | null, phone?: string | null, email?: string | null, address?: { __typename?: 'Address', street_a?: string | null, city?: string | null, state?: string | null, zip?: string | null, country?: string | null } | null } | null, clinician?: { __typename?: 'Clinician', name: string, display_name?: string | null } | null, service?: { __typename?: 'Service', name?: string | null } | null } | null }> | null, widget?: { __typename?: 'Widget', id: string, widget_name: string } | null }, requested_clinician?: { __typename?: 'Clinician', id: string, name: string } | null, original_clinician?: { __typename?: 'Clinician', id: string, name: string } | null } | null, assignee?: { __typename?: 'User', id: string, avatar_url?: string | null, first_name?: string | null, last_name?: string | null } | null, clinic: { __typename?: 'Clinic', id: string } }> | null }> };

export type UpdateActionItemMutationVariables = Exact<{
  id: Scalars['ID']['input'];
  data: UpdateActionItemInput;
}>;


export type UpdateActionItemMutation = { __typename?: 'Mutation', updateActionItem: { __typename?: 'ActionItem', id: string, type: ActionItemType, status: ActionItemStatus, description?: string | null, created_at: number, updated_at: number, pending_appointment?: { __typename?: 'Appointment', id: string, pms_id?: string | null, pms?: PracticeManagementSystem | null, client_pms_id?: string | null, is_new_client?: boolean | null, start_time: number, drop_off_time?: number | null, minutes: number, is_new_patient?: boolean | null, is_clinician_auto_assigned?: boolean | null, patient_pms_id?: string | null, referring_clinic_name?: string | null, client_notes?: string | null, clinic_notes?: string | null, service_name?: string | null, status: AppointmentStatus, is_time_block?: boolean | null, is_confirmed?: boolean | null, origin?: EntityOrigin | null, reason_for_cancellation?: string | null, client_reason_for_cancellation?: string | null, new_client_name?: string | null, new_client_phone?: string | null, new_patient_name?: string | null, new_patient_species?: string | null, confirmed_at?: number | null, widget_source?: string | null, from_widget?: string | null, is_deleted?: boolean | null, created_at: number, updated_at: number, pms_created_at?: number | null, clinic?: { __typename?: 'Clinic', id: string, name?: string | null, slug?: string | null, address?: { __typename?: 'Address', country?: string | null } | null, pms_db?: { __typename?: 'PmsDb', id: string } | null } | null, client?: { __typename?: 'Client', id: string, first_name?: string | null, last_name?: string | null, phone?: string | null, email?: string | null, is_active?: boolean | null, address?: { __typename?: 'Address', street_a?: string | null, street_b?: string | null, city?: string | null, state?: string | null, zip?: string | null, country?: string | null } | null } | null, clinician?: { __typename?: 'Clinician', id: string, name: string, display_name?: string | null, avatar_url?: string | null, initials?: string | null } | null, room?: { __typename?: 'Room', id: string, name: string } | null, service?: { __typename?: 'Service', id: string, name?: string | null, color?: string | null } | null, patient?: { __typename?: 'Patient', id: string, name?: string | null, breed?: string | null, avatar_url?: string | null, birthday?: number | null, weight?: number | null, gender?: string | null, fixed_status?: FixedStatus | null, is_active?: boolean | null, is_deceased?: boolean | null, clinic_species?: { __typename?: 'ClinicSpecies', id: string, species: Species, description: string } | null, clinic_breed?: { __typename?: 'Breed', id: string, description: string } | null } | null, clinic_appt_status?: { __typename?: 'ClinicApptStatus', id: string, description: string, status: AppointmentStatus } | null, client_info?: { __typename?: 'ClientInfo', first_name?: string | null, last_name?: string | null, email?: string | null, phone?: string | null } | null, patient_info?: { __typename?: 'PatientInfo', patient_name?: string | null, patient_breed?: string | null, patient_clinic_species?: string | null, patient_clinic_breed?: string | null } | null } | null, reschedule?: { __typename?: 'Reschedule', id: string, requested_start_time?: number | null, original_start_time?: number | null, clinic_notes?: string | null, client_notes?: string | null, reason_for_denial?: string | null, status: RescheduleStatus, initiated_by: RescheduleInitiatedBy, confirmed_at?: number | null, created_at: number, updated_at: number, appointment: { __typename?: 'Appointment', id: string, pms_id?: string | null, pms?: PracticeManagementSystem | null, client_pms_id?: string | null, is_new_client?: boolean | null, start_time: number, drop_off_time?: number | null, minutes: number, is_new_patient?: boolean | null, is_clinician_auto_assigned?: boolean | null, patient_pms_id?: string | null, referring_clinic_name?: string | null, client_notes?: string | null, clinic_notes?: string | null, service_name?: string | null, status: AppointmentStatus, is_time_block?: boolean | null, is_confirmed?: boolean | null, origin?: EntityOrigin | null, reason_for_cancellation?: string | null, client_reason_for_cancellation?: string | null, new_client_name?: string | null, new_client_phone?: string | null, new_patient_name?: string | null, new_patient_species?: string | null, confirmed_at?: number | null, widget_source?: string | null, from_widget?: string | null, is_deleted?: boolean | null, created_at: number, updated_at: number, pms_created_at?: number | null, clinic?: { __typename?: 'Clinic', id: string, name?: string | null, slug?: string | null, address?: { __typename?: 'Address', country?: string | null } | null, pms_db?: { __typename?: 'PmsDb', id: string } | null } | null, client?: { __typename?: 'Client', id: string, first_name?: string | null, last_name?: string | null, phone?: string | null, email?: string | null, is_active?: boolean | null, address?: { __typename?: 'Address', street_a?: string | null, street_b?: string | null, city?: string | null, state?: string | null, zip?: string | null, country?: string | null } | null } | null, clinician?: { __typename?: 'Clinician', id: string, name: string, display_name?: string | null, avatar_url?: string | null, initials?: string | null } | null, room?: { __typename?: 'Room', id: string, name: string } | null, service?: { __typename?: 'Service', id: string, name?: string | null, color?: string | null } | null, patient?: { __typename?: 'Patient', id: string, name?: string | null, breed?: string | null, avatar_url?: string | null, birthday?: number | null, weight?: number | null, gender?: string | null, fixed_status?: FixedStatus | null, is_active?: boolean | null, is_deceased?: boolean | null, clinic_species?: { __typename?: 'ClinicSpecies', id: string, species: Species, description: string } | null, clinic_breed?: { __typename?: 'Breed', id: string, description: string } | null } | null, clinic_appt_status?: { __typename?: 'ClinicApptStatus', id: string, description: string, status: AppointmentStatus } | null, client_info?: { __typename?: 'ClientInfo', first_name?: string | null, last_name?: string | null, email?: string | null, phone?: string | null } | null, patient_info?: { __typename?: 'PatientInfo', patient_name?: string | null, patient_breed?: string | null, patient_clinic_species?: string | null, patient_clinic_breed?: string | null } | null }, requested_clinician?: { __typename?: 'Clinician', id: string, name: string } | null, original_clinician?: { __typename?: 'Clinician', id: string, name: string } | null } | null, chat?: { __typename?: 'Chat', id: string, title?: string | null, clinic_unread_count: number, last_message?: string | null, last_message_time: number, client_last_message?: string | null, client_last_message_time: number, client_message_count: number, clinic_last_message?: string | null, clinic_last_message_time: number, non_system_last_message?: string | null, non_system_last_message_time: number, system_last_message?: string | null, system_last_message_time: number, status: ChatStatus, is_pinned: boolean, clinic: { __typename?: 'Clinic', id: string, pms: PracticeManagementSystem, name?: string | null }, client: { __typename?: 'Client', id: string, first_name?: string | null, last_name?: string | null, patients?: Array<{ __typename?: 'Patient', id: string, name?: string | null, pms_id?: string | null, is_deceased?: boolean | null, is_active?: boolean | null }> | null }, assignee?: { __typename?: 'User', id: string, avatar_url?: string | null, first_name?: string | null, last_name?: string | null } | null, chat_status?: { __typename?: 'ChatStatusConfig', id: string, name: string, color?: string | null } | null } | null, client_form?: { __typename?: 'ClientForm', id: string, client_completed_at?: number | null, clinic_verified_at?: number | null, is_archived: boolean, pms_id?: string | null, created_at: number, updated_at: number, client?: { __typename?: 'Client', id: string, first_name?: string | null, last_name?: string | null, phone?: string | null, email?: string | null, address?: { __typename?: 'Address', street_a?: string | null, city?: string | null, state?: string | null, zip?: string | null, country?: string | null } | null } | null, patient?: { __typename?: 'Patient', id: string, name?: string | null, is_active?: boolean | null, is_deceased?: boolean | null, birthday?: number | null, weight?: number | null, avatar_url?: string | null, gender?: string | null, owner?: { __typename?: 'Client', first_name?: string | null, last_name?: string | null } | null, clinic_species?: { __typename?: 'ClinicSpecies', id: string, species: Species, description: string, weight_key: string } | null, clinic_breed?: { __typename?: 'Breed', id: string, description: string } | null } | null, form: { __typename?: 'Form', id: string, name?: string | null, form_type: FormType, is_writeback_enabled: boolean, form_file_naming_template?: string | null }, form_data: { __typename?: 'FormFields', pages?: Array<{ __typename?: 'FormPage', id: string, title?: string | null, description?: string | null, order?: number | null }> | null, fields?: Array<{ __typename?: 'FormElement', id: string, type?: FormElementType | null, content?: string | null, name?: string | null, column_order?: number | null, row_order?: number | null, page_id?: string | null, options?: Array<string> | null, is_required?: boolean | null, value?: string | null, attachments?: Array<{ __typename?: 'FormFileAttachment', id?: string | null, filename?: string | null, mime_type?: string | null, size_bytes?: number | null, thumbnail_url?: string | null, url: string }> | null, field_updates?: Array<{ __typename?: 'FormFieldUpdate', field: FormFieldUpdateField, boolean_value?: boolean | null, option?: string | null }> | null }> | null }, appointment?: { __typename?: 'Appointment', start_time: number, drop_off_time?: number | null, clinic?: { __typename?: 'Clinic', name?: string | null, slug?: string | null, phone?: string | null, email?: string | null, address?: { __typename?: 'Address', street_a?: string | null, city?: string | null, state?: string | null, zip?: string | null, country?: string | null } | null } | null, clinician?: { __typename?: 'Clinician', name: string, display_name?: string | null } | null, service?: { __typename?: 'Service', name?: string | null } | null } | null } | null, prescription_refill_request?: { __typename?: 'PrescriptionRefillRequest', id: string, pickup_time?: number | null, stripe_payment_intent_id?: string | null, amount?: number | null, status: PrescriptionRefillRequestStatus, type: PrescriptionRefillRequestType, notes?: string | null, denial_reason?: string | null, approved_at?: number | null, denied_at?: number | null, created_at: number, updated_at: number, clinic: { __typename?: 'Clinic', id: string }, client: { __typename?: 'Client', id: string, first_name?: string | null, last_name?: string | null, secondary_first_name?: string | null, secondary_last_name?: string | null, phone?: string | null, email?: string | null, pms_id?: string | null, is_active?: boolean | null, is_unsubscribed: boolean, sms_enabled: boolean, email_enabled: boolean, balance?: number | null, last_appt_time?: number | null, created_at: number, updated_at: number, last_appointment?: { __typename?: 'Appointment', clinician?: { __typename?: 'Clinician', name: string, display_name?: string | null } | null } | null, address?: { __typename?: 'Address', street_a?: string | null, street_b?: string | null, city?: string | null, state?: string | null, zip?: string | null, country?: string | null } | null, clinic?: { __typename?: 'Clinic', id: string } | null, user?: { __typename?: 'User', avatar_url?: string | null } | null, patients?: Array<{ __typename?: 'Patient', id: string, name?: string | null, gender?: string | null, pms_id?: string | null, is_deceased?: boolean | null, is_active?: boolean | null, clinic_species?: { __typename?: 'ClinicSpecies', id: string, species: Species } | null, clinic_breed?: { __typename?: 'Breed', id: string, description: string } | null, last_appointment?: { __typename?: 'Appointment', clinician?: { __typename?: 'Clinician', name: string, display_name?: string | null } | null } | null }> | null, settings?: { __typename?: 'ClientSettings', clinic_chckup_notifications_enabled: boolean, clinic_chckup_sms_enabled: boolean, clinic_chckup_email_enabled: boolean, client_chckup_notifications_enabled: boolean, client_chckup_sms_enabled: boolean, client_chckup_email_enabled: boolean, is_unsubscribed_from_marketing: boolean, is_unsubscribed_from_marketing_sms: boolean, is_unsubscribed_from_marketing_email: boolean } | null }, patient?: { __typename?: 'Patient', id: string, pms_id?: string | null, name?: string | null, breed?: string | null, is_active?: boolean | null, is_deceased?: boolean | null, avatar_url?: string | null, gender?: string | null, fixed_status?: FixedStatus | null, birthday?: number | null, weight?: number | null, owner?: { __typename?: 'Client', id: string, first_name?: string | null, last_name?: string | null, secondary_first_name?: string | null, secondary_last_name?: string | null, phone?: string | null, email?: string | null } | null, clinic_species?: { __typename?: 'ClinicSpecies', id: string, species: Species, description: string, weight_key: string } | null, clinic_breed?: { __typename?: 'Breed', id: string, description: string } | null } | null, prescription?: { __typename?: 'Prescription', id: string, name?: string | null, product_name?: string | null, quantity?: number | null, refill_count?: number | null, refill_limit?: number | null, product?: { __typename?: 'Product', id: string, name: string, price: number, chckvet_price?: number | null, unit?: string | null, volume?: string | null, additional_fees?: Array<{ __typename?: 'AdditionalFees', name: string, amount: number }> | null } | null } | null, appointment?: { __typename?: 'Appointment', id: string, start_time: number, status: AppointmentStatus } | null } | null, pet_selfie?: { __typename?: 'PetSelfie', id: string, submitted_media_url: string, display_media_url?: string | null, media_type: PetSelfieMediaType, mime_type: string, filename?: string | null, size_bytes?: number | null, thumbnail_url?: string | null, pet_name?: string | null, nickname?: string | null, favorite_activity?: string | null, weirdest_thing?: string | null, display_caption?: string | null, allow_public_share: boolean, public_share_authorized_at?: number | null, first_viewed_at?: number | null, first_viewed_by?: string | null, in_slideshow: boolean, in_portal_carousel: boolean, in_gallery: boolean, is_excluded: boolean, is_archived: boolean, reaction_sent_at?: number | null, reaction_message?: string | null, created_at: number, updated_at: number, clinic: { __typename?: 'Clinic', id: string }, client: { __typename?: 'Client', id: string, first_name?: string | null, last_name?: string | null, secondary_first_name?: string | null, secondary_last_name?: string | null, phone?: string | null, email?: string | null, pms_id?: string | null, is_active?: boolean | null, is_unsubscribed: boolean, sms_enabled: boolean, email_enabled: boolean, balance?: number | null, last_appt_time?: number | null, created_at: number, updated_at: number, last_appointment?: { __typename?: 'Appointment', clinician?: { __typename?: 'Clinician', name: string, display_name?: string | null } | null } | null, address?: { __typename?: 'Address', street_a?: string | null, street_b?: string | null, city?: string | null, state?: string | null, zip?: string | null, country?: string | null } | null, clinic?: { __typename?: 'Clinic', id: string } | null, user?: { __typename?: 'User', avatar_url?: string | null } | null, patients?: Array<{ __typename?: 'Patient', id: string, name?: string | null, gender?: string | null, pms_id?: string | null, is_deceased?: boolean | null, is_active?: boolean | null, clinic_species?: { __typename?: 'ClinicSpecies', id: string, species: Species } | null, clinic_breed?: { __typename?: 'Breed', id: string, description: string } | null, last_appointment?: { __typename?: 'Appointment', clinician?: { __typename?: 'Clinician', name: string, display_name?: string | null } | null } | null }> | null, settings?: { __typename?: 'ClientSettings', clinic_chckup_notifications_enabled: boolean, clinic_chckup_sms_enabled: boolean, clinic_chckup_email_enabled: boolean, client_chckup_notifications_enabled: boolean, client_chckup_sms_enabled: boolean, client_chckup_email_enabled: boolean, is_unsubscribed_from_marketing: boolean, is_unsubscribed_from_marketing_sms: boolean, is_unsubscribed_from_marketing_email: boolean } | null }, patient?: { __typename?: 'Patient', id: string, pms_id?: string | null, name?: string | null, breed?: string | null, is_active?: boolean | null, is_deceased?: boolean | null, avatar_url?: string | null, gender?: string | null, fixed_status?: FixedStatus | null, birthday?: number | null, weight?: number | null, owner?: { __typename?: 'Client', id: string, first_name?: string | null, last_name?: string | null, secondary_first_name?: string | null, secondary_last_name?: string | null, phone?: string | null, email?: string | null } | null, clinic_species?: { __typename?: 'ClinicSpecies', id: string, species: Species, description: string, weight_key: string } | null, clinic_breed?: { __typename?: 'Breed', id: string, description: string } | null } | null } | null, originating_call?: { __typename?: 'Call', id: string, status: CallStatus, direction?: CallDirection | null, is_automated?: boolean | null, caller_name?: string | null, caller_phone?: string | null, to_phone?: string | null, duration?: number | null, recording_url?: string | null, transcription_full_text?: string | null, transcription_summary?: string | null, notes?: string | null, score?: number | null, score_reasoning?: string | null, sentiment_customer?: number | null, sentiment_agent?: number | null, created_at: number, updated_at: number, client?: { __typename?: 'Client', first_name?: string | null, last_name?: string | null, phone?: string | null } | null } | null, assignee?: { __typename?: 'User', id: string, avatar_url?: string | null, first_name?: string | null, last_name?: string | null } | null, clinic: { __typename?: 'Clinic', id: string } } };

export type AiVoiceOptionFieldsFragment = { __typename?: 'AiVoiceOption', voice_id: string, voice_name: string, voice_gender: string, voice_accent?: string | null, voice_age?: string | null, voice_preview_url?: string | null, avatar_url?: string | null };

export type ListAiVoiceOptionsQueryVariables = Exact<{ [key: string]: never; }>;


export type ListAiVoiceOptionsQuery = { __typename?: 'Query', listAiVoiceOptions: Array<{ __typename?: 'AiVoiceOption', voice_id: string, voice_name: string, voice_gender: string, voice_accent?: string | null, voice_age?: string | null, voice_preview_url?: string | null, avatar_url?: string | null }> };

export type AiAgentPromptFieldsFragment = { __typename?: 'AiAgentPrompt', clinic_id: string, agent_type: AiCallsAgentType, playbook?: string | null, is_default_playbook: boolean, default_playbook: string, playbook_max_chars: number, general_prompt?: string | null, is_legacy_prompt: boolean, available_dynamic_variables: Array<string> };

export type GetAiAgentPromptForClinicQueryVariables = Exact<{
  clinicId: Scalars['ID']['input'];
}>;


export type GetAiAgentPromptForClinicQuery = { __typename?: 'Query', getAiAgentPromptForClinic: { __typename?: 'AiAgentPrompt', clinic_id: string, agent_type: AiCallsAgentType, playbook?: string | null, is_default_playbook: boolean, default_playbook: string, playbook_max_chars: number, general_prompt?: string | null, is_legacy_prompt: boolean, available_dynamic_variables: Array<string> } };

export type UpdateAiAgentPlaybookForClinicMutationVariables = Exact<{
  clinicId: Scalars['ID']['input'];
  playbook?: InputMaybe<Scalars['String']['input']>;
}>;


export type UpdateAiAgentPlaybookForClinicMutation = { __typename?: 'Mutation', updateAiAgentPlaybookForClinic: { __typename?: 'AiAgentPrompt', clinic_id: string, agent_type: AiCallsAgentType, playbook?: string | null, is_default_playbook: boolean, default_playbook: string, playbook_max_chars: number, general_prompt?: string | null, is_legacy_prompt: boolean, available_dynamic_variables: Array<string> } };

export type SuggestAiAgentPlaybookEditMutationVariables = Exact<{
  clinicId: Scalars['ID']['input'];
  instruction: Scalars['String']['input'];
  currentPlaybook: Scalars['String']['input'];
}>;


export type SuggestAiAgentPlaybookEditMutation = { __typename?: 'Mutation', suggestAiAgentPlaybookEdit: { __typename?: 'AiAgentPromptSuggestion', proposed_playbook: string, summary: string, warnings: Array<string> } };

export type AiImprovementItemFieldsFragment = { __typename?: 'AiImprovementItem', id: string, clinic_id: string, kind: AiImprovementKind, title: string, suggestion: string, draft_instruction?: string | null, impact: AiImprovementImpact, priority_score: number, occurrence_count: number, first_seen_at?: number | null, last_seen_at?: number | null, status: AiImprovementStatus, resolved_at?: number | null, recent_evidence: Array<{ __typename?: 'AiImprovementEvidence', call_id: string, call_started_at?: number | null, evidence?: string | null }> };

export type GetAiPromptSuggestionsForClinicQueryVariables = Exact<{
  clinicId: Scalars['ID']['input'];
  status?: InputMaybe<AiImprovementStatus>;
}>;


export type GetAiPromptSuggestionsForClinicQuery = { __typename?: 'Query', getAiPromptSuggestionsForClinic: { __typename?: 'AiPromptSuggestions', agent_type?: AiCallsAgentType | null, items: Array<{ __typename?: 'AiImprovementItem', id: string, clinic_id: string, kind: AiImprovementKind, title: string, suggestion: string, draft_instruction?: string | null, impact: AiImprovementImpact, priority_score: number, occurrence_count: number, first_seen_at?: number | null, last_seen_at?: number | null, status: AiImprovementStatus, resolved_at?: number | null, recent_evidence: Array<{ __typename?: 'AiImprovementEvidence', call_id: string, call_started_at?: number | null, evidence?: string | null }> }> } };

export type PreviewAiImprovementItemMutationVariables = Exact<{
  itemId: Scalars['ID']['input'];
  answer: Scalars['String']['input'];
}>;


export type PreviewAiImprovementItemMutation = { __typename?: 'Mutation', previewAiImprovementItem: { __typename?: 'AiImprovementItemPreview', current_playbook: string, proposed_playbook: string, summary: string, warnings: Array<string> } };

export type ApplyAiImprovementItemMutationVariables = Exact<{
  itemId: Scalars['ID']['input'];
}>;


export type ApplyAiImprovementItemMutation = { __typename?: 'Mutation', applyAiImprovementItem: { __typename?: 'AiImprovementItem', id: string, clinic_id: string, kind: AiImprovementKind, title: string, suggestion: string, draft_instruction?: string | null, impact: AiImprovementImpact, priority_score: number, occurrence_count: number, first_seen_at?: number | null, last_seen_at?: number | null, status: AiImprovementStatus, resolved_at?: number | null, recent_evidence: Array<{ __typename?: 'AiImprovementEvidence', call_id: string, call_started_at?: number | null, evidence?: string | null }> } };

export type DismissAiImprovementItemMutationVariables = Exact<{
  itemId: Scalars['ID']['input'];
}>;


export type DismissAiImprovementItemMutation = { __typename?: 'Mutation', dismissAiImprovementItem: { __typename?: 'AiImprovementItem', id: string, clinic_id: string, kind: AiImprovementKind, title: string, suggestion: string, draft_instruction?: string | null, impact: AiImprovementImpact, priority_score: number, occurrence_count: number, first_seen_at?: number | null, last_seen_at?: number | null, status: AiImprovementStatus, resolved_at?: number | null, recent_evidence: Array<{ __typename?: 'AiImprovementEvidence', call_id: string, call_started_at?: number | null, evidence?: string | null }> } };

export type AddAiAgentInstructionForClinicMutationVariables = Exact<{
  clinicId: Scalars['ID']['input'];
  instruction: Scalars['String']['input'];
}>;


export type AddAiAgentInstructionForClinicMutation = { __typename?: 'Mutation', addAiAgentInstructionForClinic: AiAgentInstructionDestination };

export type InitializeAiAgentForClinicMutationVariables = Exact<{
  clinicId: Scalars['ID']['input'];
  agentType?: InputMaybe<AiCallsAgentType>;
}>;


export type InitializeAiAgentForClinicMutation = { __typename?: 'Mutation', initializeAiAgentForClinic: string };

export type AnimalFieldsFragment = { __typename?: 'Animal', id: string, name?: string | null, image?: string | null, created_at: number, updated_at: number };

export type CreateAnimalMutationVariables = Exact<{
  data: CreateAnimalInput;
}>;


export type CreateAnimalMutation = { __typename?: 'Mutation', createAnimal: { __typename?: 'Animal', id: string, name?: string | null, image?: string | null, created_at: number, updated_at: number } };

export type UpdateAnimalMutationVariables = Exact<{
  id: Scalars['ID']['input'];
  data: UpdateAnimalInput;
}>;


export type UpdateAnimalMutation = { __typename?: 'Mutation', updateAnimal: { __typename?: 'Animal', id: string, name?: string | null, image?: string | null, created_at: number, updated_at: number } };

export type DeleteAnimalMutationVariables = Exact<{
  id: Scalars['ID']['input'];
}>;


export type DeleteAnimalMutation = { __typename?: 'Mutation', deleteAnimal?: any | null };

export type AppointmentPromptFieldsFragment = { __typename?: 'AppointmentPrompt', id: string, client_notes?: string | null, clinic_notes?: string | null, confirmed_at?: number | null, minutes?: number | null, reason_for_denial?: string | null, service_name?: string | null, start_time?: number | null, type: AppointmentPromptType, created_at: number, updated_at: number, clinic: { __typename?: 'Clinic', id: string, name?: string | null }, client?: { __typename?: 'Client', id: string, first_name?: string | null, last_name?: string | null, secondary_first_name?: string | null, secondary_last_name?: string | null, phone?: string | null, email?: string | null, pms?: PracticeManagementSystem | null, pms_id?: string | null, last_appt_time?: number | null, last_contact_time?: number | null, email_enabled: boolean, sms_enabled: boolean, balance?: number | null, is_active?: boolean | null, is_unsubscribed: boolean, created_at: number, updated_at: number, client_phones?: Array<{ __typename?: 'ClientPhone', id: string, phone: string, country_code?: string | null, is_primary: boolean, is_chckup_primary: boolean, is_mobile: boolean, sms_available: boolean, is_unsubscribed: boolean, is_active: boolean, name?: string | null }> | null, client_emails?: Array<{ __typename?: 'ClientEmail', id: string, email: string, is_primary: boolean }> | null, clinic?: { __typename?: 'Clinic', id: string } | null, patients?: Array<{ __typename?: 'Patient', id: string, pms?: PracticeManagementSystem | null, pms_id?: string | null, name?: string | null, breed?: string | null, avatar_url?: string | null, last_appt_time?: number | null, gender?: string | null, fixed_status?: FixedStatus | null, weight?: number | null, birthday?: number | null, is_active?: boolean | null, is_deceased?: boolean | null, pms_created_at?: number | null, created_at: number, updated_at: number, owner?: { __typename?: 'Client', id: string, first_name?: string | null, last_name?: string | null, email?: string | null, phone?: string | null, address?: { __typename?: 'Address', country?: string | null } | null } | null, clinic_species?: { __typename?: 'ClinicSpecies', id: string, pms_id: string, description: string, is_primary: boolean, species: Species, weight_key: string, created_at: number, updated_at: number } | null, clinic?: { __typename?: 'Clinic', id: string } | null, clinic_breed?: { __typename?: 'Breed', id: string, description: string } | null, patient_vaccination_records?: Array<{ __typename?: 'PatientVaccinationRecord', id: string, vaccine_name?: string | null, manufacturer?: string | null, lot_number?: string | null, administered_date?: number | null, due_date?: number | null, rabies_tag?: string | null, is_rabies_vaccine?: boolean | null, is_soc: boolean, is_active: boolean, product?: { __typename?: 'Product', id: string, display_name?: string | null, name: string } | null }> | null, last_appointment?: { __typename?: 'Appointment', clinician?: { __typename?: 'Clinician', name: string, display_name?: string | null } | null } | null }> | null, address?: { __typename?: 'Address', street_a?: string | null, street_b?: string | null, city?: string | null, state?: string | null, zip?: string | null, country?: string | null } | null, user?: { __typename?: 'User', avatar_url?: string | null } | null, loyalty_members?: Array<{ __typename?: 'LoyaltyMember', id: string, available_points: number } | null> | null, settings?: { __typename?: 'ClientSettings', clinic_chckup_notifications_enabled: boolean, clinic_chckup_sms_enabled: boolean, clinic_chckup_email_enabled: boolean, client_chckup_notifications_enabled: boolean, client_chckup_sms_enabled: boolean, client_chckup_email_enabled: boolean, is_unsubscribed_from_marketing: boolean, is_unsubscribed_from_marketing_sms: boolean, is_unsubscribed_from_marketing_email: boolean } | null, last_appointment?: { __typename?: 'Appointment', clinician?: { __typename?: 'Clinician', name: string, display_name?: string | null } | null } | null } | null, clinician?: { __typename?: 'Clinician', id: string, name: string, display_name?: string | null, bio?: string | null, avatar_url?: string | null, initials?: string | null, excluded_species?: Array<Species> | null, excluded_service_ids?: Array<string> | null, authority_level?: AuthorityLevel | null, type: ResourceType, is_active?: boolean | null, is_assignable_in_pms?: boolean | null, does_contribute_to_fill_rate?: boolean | null, pms_id?: string | null, location?: string | null, pms_is_active: boolean, valid_booking_interval_minutes?: Array<number> | null, created_at: number, updated_at: number, clinic?: { __typename?: 'Clinic', id: string, name?: string | null } | null, pms_db?: { __typename?: 'PmsDb', id: string } | null, hours?: { __typename?: 'AvailabilityHours', monday?: Array<{ __typename?: 'TimeInterval', start?: number | null, end?: number | null }> | null, tuesday?: Array<{ __typename?: 'TimeInterval', start?: number | null, end?: number | null }> | null, wednesday?: Array<{ __typename?: 'TimeInterval', start?: number | null, end?: number | null }> | null, thursday?: Array<{ __typename?: 'TimeInterval', start?: number | null, end?: number | null }> | null, friday?: Array<{ __typename?: 'TimeInterval', start?: number | null, end?: number | null }> | null, saturday?: Array<{ __typename?: 'TimeInterval', start?: number | null, end?: number | null }> | null, sunday?: Array<{ __typename?: 'TimeInterval', start?: number | null, end?: number | null }> | null } | null, adjusted_availability?: Array<{ __typename?: 'Availability', date: number, pms_appt_type_pms_id?: string | null, times: Array<{ __typename?: 'TimeInterval', start?: number | null, end?: number | null }>, repeat?: { __typename?: 'RepeatAvailability', daysOfMonth?: Array<number> | null, daysOfWeek?: Array<DayOfWeek> | null, weekOfMonth?: WeekOfMonth | null, frequency: any, unit: RepeatUnit, end_date?: number | null } | null }> | null, pms_adjusted_availability?: Array<{ __typename?: 'Availability', date: number, pms_appt_type_pms_id?: string | null, times: Array<{ __typename?: 'TimeInterval', start?: number | null, end?: number | null }>, repeat?: { __typename?: 'RepeatAvailability', daysOfMonth?: Array<number> | null, daysOfWeek?: Array<DayOfWeek> | null, weekOfMonth?: WeekOfMonth | null, frequency: any, unit: RepeatUnit, end_date?: number | null } | null }> | null } | null, patient?: { __typename?: 'Patient', id: string, pms?: PracticeManagementSystem | null, pms_id?: string | null, name?: string | null, breed?: string | null, avatar_url?: string | null, last_appt_time?: number | null, gender?: string | null, fixed_status?: FixedStatus | null, weight?: number | null, birthday?: number | null, is_active?: boolean | null, is_deceased?: boolean | null, pms_created_at?: number | null, created_at: number, updated_at: number, owner?: { __typename?: 'Client', id: string, first_name?: string | null, last_name?: string | null, email?: string | null, phone?: string | null, address?: { __typename?: 'Address', country?: string | null } | null } | null, clinic_species?: { __typename?: 'ClinicSpecies', id: string, pms_id: string, description: string, is_primary: boolean, species: Species, weight_key: string, created_at: number, updated_at: number } | null, clinic?: { __typename?: 'Clinic', id: string } | null, clinic_breed?: { __typename?: 'Breed', id: string, description: string } | null, patient_vaccination_records?: Array<{ __typename?: 'PatientVaccinationRecord', id: string, vaccine_name?: string | null, manufacturer?: string | null, lot_number?: string | null, administered_date?: number | null, due_date?: number | null, rabies_tag?: string | null, is_rabies_vaccine?: boolean | null, is_soc: boolean, is_active: boolean, product?: { __typename?: 'Product', id: string, display_name?: string | null, name: string } | null }> | null, last_appointment?: { __typename?: 'Appointment', clinician?: { __typename?: 'Clinician', name: string, display_name?: string | null } | null } | null } | null, service?: { __typename?: 'Service', id: string, name?: string | null, order?: number | null, keywords?: string | null, service_types: Array<ServiceType>, is_active?: boolean | null, allow_new?: boolean | null, color?: string | null, description?: string | null, duration?: number | null, allow_returning?: boolean | null, max_per_day?: number | null, max_per_hour?: number | null, excluded_species?: Array<Species> | null, reserved_per_day?: number | null, authorized_levels?: Array<AuthorityLevel> | null, scheduling_buffer_minutes?: number | null, scheduling_min_minutes_away?: number | null, scheduling_max_minutes_away?: number | null, minimum_patient_age_in_days?: number | null, maximum_patient_age_in_days?: number | null, more_info?: string | null, more_info_action_required?: string | null, action_required_acknowledgement_text?: string | null, points: number, drop_off_time?: string | null, pick_up_time?: string | null, is_blocking: boolean, is_reschedule_allowed: boolean, is_cancellation_allowed: boolean, is_primary_for_appt_type: boolean, hide_clinician_preference: boolean, use_previous_doctor: boolean, allowed_appt_type_pms_ids?: Array<string> | null, valid_booking_interval_minutes?: Array<number> | null, only_use_adj_avail_guides: boolean, exclude_from_portal: boolean, created_at: number, updated_at: number, clinic?: { __typename?: 'Clinic', id: string, name?: string | null } | null, service_service_categories?: Array<{ __typename?: 'ServiceServiceCategory', service_category: { __typename?: 'ServiceCategory', id: string, order: number, icon?: ServiceCategoryIcon | null, title: string, description: string, requires_confirmation: boolean, confirmation_message?: string | null, created_at: number, updated_at: number } }> | null, pricing?: { __typename?: 'ServicePricing', price: any, currency: any, type: ServicePricingType, client_type?: ClientTypeEnum | null } | null, pms_appt_type?: { __typename?: 'PmsApptType', id: string, name: string, pms_id: string, description?: string | null, color?: any | null, pms_is_active: boolean } | null, required_room?: { __typename?: 'Room', id: string, pms_id: string, name: string, display_name?: string | null, description?: string | null, concurrent_patients?: number | null, is_active: boolean, does_contribute_to_fill_rate?: boolean | null, valid_booking_interval_minutes?: Array<number> | null, created_at: number, updated_at: number, clinic?: { __typename?: 'Clinic', pms: PracticeManagementSystem, id: string, name?: string | null, time_zone?: string | null } | null, hours?: { __typename?: 'AvailabilityHours', monday?: Array<{ __typename?: 'TimeInterval', start?: number | null, end?: number | null }> | null, tuesday?: Array<{ __typename?: 'TimeInterval', start?: number | null, end?: number | null }> | null, wednesday?: Array<{ __typename?: 'TimeInterval', start?: number | null, end?: number | null }> | null, thursday?: Array<{ __typename?: 'TimeInterval', start?: number | null, end?: number | null }> | null, friday?: Array<{ __typename?: 'TimeInterval', start?: number | null, end?: number | null }> | null, saturday?: Array<{ __typename?: 'TimeInterval', start?: number | null, end?: number | null }> | null, sunday?: Array<{ __typename?: 'TimeInterval', start?: number | null, end?: number | null }> | null } | null, adjusted_availability?: Array<{ __typename?: 'Availability', date: number, pms_appt_type_pms_id?: string | null, times: Array<{ __typename?: 'TimeInterval', start?: number | null, end?: number | null }>, repeat?: { __typename?: 'RepeatAvailability', daysOfMonth?: Array<number> | null, daysOfWeek?: Array<DayOfWeek> | null, weekOfMonth?: WeekOfMonth | null, frequency: any, unit: RepeatUnit, end_date?: number | null } | null }> | null, pms_adjusted_availability?: Array<{ __typename?: 'Availability', date: number, pms_appt_type_pms_id?: string | null, times: Array<{ __typename?: 'TimeInterval', start?: number | null, end?: number | null }>, repeat?: { __typename?: 'RepeatAvailability', daysOfMonth?: Array<number> | null, daysOfWeek?: Array<DayOfWeek> | null, weekOfMonth?: WeekOfMonth | null, frequency: any, unit: RepeatUnit, end_date?: number | null } | null }> | null } | null, default_room?: { __typename?: 'Room', id: string, pms_id: string, name: string, display_name?: string | null, description?: string | null, concurrent_patients?: number | null, is_active: boolean, does_contribute_to_fill_rate?: boolean | null, valid_booking_interval_minutes?: Array<number> | null, created_at: number, updated_at: number, clinic?: { __typename?: 'Clinic', pms: PracticeManagementSystem, id: string, name?: string | null, time_zone?: string | null } | null, hours?: { __typename?: 'AvailabilityHours', monday?: Array<{ __typename?: 'TimeInterval', start?: number | null, end?: number | null }> | null, tuesday?: Array<{ __typename?: 'TimeInterval', start?: number | null, end?: number | null }> | null, wednesday?: Array<{ __typename?: 'TimeInterval', start?: number | null, end?: number | null }> | null, thursday?: Array<{ __typename?: 'TimeInterval', start?: number | null, end?: number | null }> | null, friday?: Array<{ __typename?: 'TimeInterval', start?: number | null, end?: number | null }> | null, saturday?: Array<{ __typename?: 'TimeInterval', start?: number | null, end?: number | null }> | null, sunday?: Array<{ __typename?: 'TimeInterval', start?: number | null, end?: number | null }> | null } | null, adjusted_availability?: Array<{ __typename?: 'Availability', date: number, pms_appt_type_pms_id?: string | null, times: Array<{ __typename?: 'TimeInterval', start?: number | null, end?: number | null }>, repeat?: { __typename?: 'RepeatAvailability', daysOfMonth?: Array<number> | null, daysOfWeek?: Array<DayOfWeek> | null, weekOfMonth?: WeekOfMonth | null, frequency: any, unit: RepeatUnit, end_date?: number | null } | null }> | null, pms_adjusted_availability?: Array<{ __typename?: 'Availability', date: number, pms_appt_type_pms_id?: string | null, times: Array<{ __typename?: 'TimeInterval', start?: number | null, end?: number | null }>, repeat?: { __typename?: 'RepeatAvailability', daysOfMonth?: Array<number> | null, daysOfWeek?: Array<DayOfWeek> | null, weekOfMonth?: WeekOfMonth | null, frequency: any, unit: RepeatUnit, end_date?: number | null } | null }> | null } | null, availability?: { __typename?: 'AvailabilityHours', monday?: Array<{ __typename?: 'TimeInterval', start?: number | null, end?: number | null }> | null, tuesday?: Array<{ __typename?: 'TimeInterval', start?: number | null, end?: number | null }> | null, wednesday?: Array<{ __typename?: 'TimeInterval', start?: number | null, end?: number | null }> | null, thursday?: Array<{ __typename?: 'TimeInterval', start?: number | null, end?: number | null }> | null, friday?: Array<{ __typename?: 'TimeInterval', start?: number | null, end?: number | null }> | null, saturday?: Array<{ __typename?: 'TimeInterval', start?: number | null, end?: number | null }> | null, sunday?: Array<{ __typename?: 'TimeInterval', start?: number | null, end?: number | null }> | null } | null, drop_off_hours?: { __typename?: 'AvailabilityHours', monday?: Array<{ __typename?: 'TimeInterval', start?: number | null, end?: number | null }> | null, tuesday?: Array<{ __typename?: 'TimeInterval', start?: number | null, end?: number | null }> | null, wednesday?: Array<{ __typename?: 'TimeInterval', start?: number | null, end?: number | null }> | null, thursday?: Array<{ __typename?: 'TimeInterval', start?: number | null, end?: number | null }> | null, friday?: Array<{ __typename?: 'TimeInterval', start?: number | null, end?: number | null }> | null, saturday?: Array<{ __typename?: 'TimeInterval', start?: number | null, end?: number | null }> | null, sunday?: Array<{ __typename?: 'TimeInterval', start?: number | null, end?: number | null }> | null } | null, pre_confirmation_checklist?: Array<{ __typename?: 'ServicePreConfirmationItem', title: string, description?: string | null, required?: boolean | null }> | null } | null };

export type GetAppointmentPromptQueryVariables = Exact<{
  id: Scalars['ID']['input'];
}>;


export type GetAppointmentPromptQuery = { __typename?: 'Query', appointmentPrompt: { __typename?: 'AppointmentPrompt', id: string, client_notes?: string | null, clinic_notes?: string | null, confirmed_at?: number | null, minutes?: number | null, reason_for_denial?: string | null, service_name?: string | null, start_time?: number | null, type: AppointmentPromptType, created_at: number, updated_at: number, clinic: { __typename?: 'Clinic', id: string, name?: string | null }, client?: { __typename?: 'Client', id: string, first_name?: string | null, last_name?: string | null, secondary_first_name?: string | null, secondary_last_name?: string | null, phone?: string | null, email?: string | null, pms?: PracticeManagementSystem | null, pms_id?: string | null, last_appt_time?: number | null, last_contact_time?: number | null, email_enabled: boolean, sms_enabled: boolean, balance?: number | null, is_active?: boolean | null, is_unsubscribed: boolean, created_at: number, updated_at: number, client_phones?: Array<{ __typename?: 'ClientPhone', id: string, phone: string, country_code?: string | null, is_primary: boolean, is_chckup_primary: boolean, is_mobile: boolean, sms_available: boolean, is_unsubscribed: boolean, is_active: boolean, name?: string | null }> | null, client_emails?: Array<{ __typename?: 'ClientEmail', id: string, email: string, is_primary: boolean }> | null, clinic?: { __typename?: 'Clinic', id: string } | null, patients?: Array<{ __typename?: 'Patient', id: string, pms?: PracticeManagementSystem | null, pms_id?: string | null, name?: string | null, breed?: string | null, avatar_url?: string | null, last_appt_time?: number | null, gender?: string | null, fixed_status?: FixedStatus | null, weight?: number | null, birthday?: number | null, is_active?: boolean | null, is_deceased?: boolean | null, pms_created_at?: number | null, created_at: number, updated_at: number, owner?: { __typename?: 'Client', id: string, first_name?: string | null, last_name?: string | null, email?: string | null, phone?: string | null, address?: { __typename?: 'Address', country?: string | null } | null } | null, clinic_species?: { __typename?: 'ClinicSpecies', id: string, pms_id: string, description: string, is_primary: boolean, species: Species, weight_key: string, created_at: number, updated_at: number } | null, clinic?: { __typename?: 'Clinic', id: string } | null, clinic_breed?: { __typename?: 'Breed', id: string, description: string } | null, patient_vaccination_records?: Array<{ __typename?: 'PatientVaccinationRecord', id: string, vaccine_name?: string | null, manufacturer?: string | null, lot_number?: string | null, administered_date?: number | null, due_date?: number | null, rabies_tag?: string | null, is_rabies_vaccine?: boolean | null, is_soc: boolean, is_active: boolean, product?: { __typename?: 'Product', id: string, display_name?: string | null, name: string } | null }> | null, last_appointment?: { __typename?: 'Appointment', clinician?: { __typename?: 'Clinician', name: string, display_name?: string | null } | null } | null }> | null, address?: { __typename?: 'Address', street_a?: string | null, street_b?: string | null, city?: string | null, state?: string | null, zip?: string | null, country?: string | null } | null, user?: { __typename?: 'User', avatar_url?: string | null } | null, loyalty_members?: Array<{ __typename?: 'LoyaltyMember', id: string, available_points: number } | null> | null, settings?: { __typename?: 'ClientSettings', clinic_chckup_notifications_enabled: boolean, clinic_chckup_sms_enabled: boolean, clinic_chckup_email_enabled: boolean, client_chckup_notifications_enabled: boolean, client_chckup_sms_enabled: boolean, client_chckup_email_enabled: boolean, is_unsubscribed_from_marketing: boolean, is_unsubscribed_from_marketing_sms: boolean, is_unsubscribed_from_marketing_email: boolean } | null, last_appointment?: { __typename?: 'Appointment', clinician?: { __typename?: 'Clinician', name: string, display_name?: string | null } | null } | null } | null, clinician?: { __typename?: 'Clinician', id: string, name: string, display_name?: string | null, bio?: string | null, avatar_url?: string | null, initials?: string | null, excluded_species?: Array<Species> | null, excluded_service_ids?: Array<string> | null, authority_level?: AuthorityLevel | null, type: ResourceType, is_active?: boolean | null, is_assignable_in_pms?: boolean | null, does_contribute_to_fill_rate?: boolean | null, pms_id?: string | null, location?: string | null, pms_is_active: boolean, valid_booking_interval_minutes?: Array<number> | null, created_at: number, updated_at: number, clinic?: { __typename?: 'Clinic', id: string, name?: string | null } | null, pms_db?: { __typename?: 'PmsDb', id: string } | null, hours?: { __typename?: 'AvailabilityHours', monday?: Array<{ __typename?: 'TimeInterval', start?: number | null, end?: number | null }> | null, tuesday?: Array<{ __typename?: 'TimeInterval', start?: number | null, end?: number | null }> | null, wednesday?: Array<{ __typename?: 'TimeInterval', start?: number | null, end?: number | null }> | null, thursday?: Array<{ __typename?: 'TimeInterval', start?: number | null, end?: number | null }> | null, friday?: Array<{ __typename?: 'TimeInterval', start?: number | null, end?: number | null }> | null, saturday?: Array<{ __typename?: 'TimeInterval', start?: number | null, end?: number | null }> | null, sunday?: Array<{ __typename?: 'TimeInterval', start?: number | null, end?: number | null }> | null } | null, adjusted_availability?: Array<{ __typename?: 'Availability', date: number, pms_appt_type_pms_id?: string | null, times: Array<{ __typename?: 'TimeInterval', start?: number | null, end?: number | null }>, repeat?: { __typename?: 'RepeatAvailability', daysOfMonth?: Array<number> | null, daysOfWeek?: Array<DayOfWeek> | null, weekOfMonth?: WeekOfMonth | null, frequency: any, unit: RepeatUnit, end_date?: number | null } | null }> | null, pms_adjusted_availability?: Array<{ __typename?: 'Availability', date: number, pms_appt_type_pms_id?: string | null, times: Array<{ __typename?: 'TimeInterval', start?: number | null, end?: number | null }>, repeat?: { __typename?: 'RepeatAvailability', daysOfMonth?: Array<number> | null, daysOfWeek?: Array<DayOfWeek> | null, weekOfMonth?: WeekOfMonth | null, frequency: any, unit: RepeatUnit, end_date?: number | null } | null }> | null } | null, patient?: { __typename?: 'Patient', id: string, pms?: PracticeManagementSystem | null, pms_id?: string | null, name?: string | null, breed?: string | null, avatar_url?: string | null, last_appt_time?: number | null, gender?: string | null, fixed_status?: FixedStatus | null, weight?: number | null, birthday?: number | null, is_active?: boolean | null, is_deceased?: boolean | null, pms_created_at?: number | null, created_at: number, updated_at: number, owner?: { __typename?: 'Client', id: string, first_name?: string | null, last_name?: string | null, email?: string | null, phone?: string | null, address?: { __typename?: 'Address', country?: string | null } | null } | null, clinic_species?: { __typename?: 'ClinicSpecies', id: string, pms_id: string, description: string, is_primary: boolean, species: Species, weight_key: string, created_at: number, updated_at: number } | null, clinic?: { __typename?: 'Clinic', id: string } | null, clinic_breed?: { __typename?: 'Breed', id: string, description: string } | null, patient_vaccination_records?: Array<{ __typename?: 'PatientVaccinationRecord', id: string, vaccine_name?: string | null, manufacturer?: string | null, lot_number?: string | null, administered_date?: number | null, due_date?: number | null, rabies_tag?: string | null, is_rabies_vaccine?: boolean | null, is_soc: boolean, is_active: boolean, product?: { __typename?: 'Product', id: string, display_name?: string | null, name: string } | null }> | null, last_appointment?: { __typename?: 'Appointment', clinician?: { __typename?: 'Clinician', name: string, display_name?: string | null } | null } | null } | null, service?: { __typename?: 'Service', id: string, name?: string | null, order?: number | null, keywords?: string | null, service_types: Array<ServiceType>, is_active?: boolean | null, allow_new?: boolean | null, color?: string | null, description?: string | null, duration?: number | null, allow_returning?: boolean | null, max_per_day?: number | null, max_per_hour?: number | null, excluded_species?: Array<Species> | null, reserved_per_day?: number | null, authorized_levels?: Array<AuthorityLevel> | null, scheduling_buffer_minutes?: number | null, scheduling_min_minutes_away?: number | null, scheduling_max_minutes_away?: number | null, minimum_patient_age_in_days?: number | null, maximum_patient_age_in_days?: number | null, more_info?: string | null, more_info_action_required?: string | null, action_required_acknowledgement_text?: string | null, points: number, drop_off_time?: string | null, pick_up_time?: string | null, is_blocking: boolean, is_reschedule_allowed: boolean, is_cancellation_allowed: boolean, is_primary_for_appt_type: boolean, hide_clinician_preference: boolean, use_previous_doctor: boolean, allowed_appt_type_pms_ids?: Array<string> | null, valid_booking_interval_minutes?: Array<number> | null, only_use_adj_avail_guides: boolean, exclude_from_portal: boolean, created_at: number, updated_at: number, clinic?: { __typename?: 'Clinic', id: string, name?: string | null } | null, service_service_categories?: Array<{ __typename?: 'ServiceServiceCategory', service_category: { __typename?: 'ServiceCategory', id: string, order: number, icon?: ServiceCategoryIcon | null, title: string, description: string, requires_confirmation: boolean, confirmation_message?: string | null, created_at: number, updated_at: number } }> | null, pricing?: { __typename?: 'ServicePricing', price: any, currency: any, type: ServicePricingType, client_type?: ClientTypeEnum | null } | null, pms_appt_type?: { __typename?: 'PmsApptType', id: string, name: string, pms_id: string, description?: string | null, color?: any | null, pms_is_active: boolean } | null, required_room?: { __typename?: 'Room', id: string, pms_id: string, name: string, display_name?: string | null, description?: string | null, concurrent_patients?: number | null, is_active: boolean, does_contribute_to_fill_rate?: boolean | null, valid_booking_interval_minutes?: Array<number> | null, created_at: number, updated_at: number, clinic?: { __typename?: 'Clinic', pms: PracticeManagementSystem, id: string, name?: string | null, time_zone?: string | null } | null, hours?: { __typename?: 'AvailabilityHours', monday?: Array<{ __typename?: 'TimeInterval', start?: number | null, end?: number | null }> | null, tuesday?: Array<{ __typename?: 'TimeInterval', start?: number | null, end?: number | null }> | null, wednesday?: Array<{ __typename?: 'TimeInterval', start?: number | null, end?: number | null }> | null, thursday?: Array<{ __typename?: 'TimeInterval', start?: number | null, end?: number | null }> | null, friday?: Array<{ __typename?: 'TimeInterval', start?: number | null, end?: number | null }> | null, saturday?: Array<{ __typename?: 'TimeInterval', start?: number | null, end?: number | null }> | null, sunday?: Array<{ __typename?: 'TimeInterval', start?: number | null, end?: number | null }> | null } | null, adjusted_availability?: Array<{ __typename?: 'Availability', date: number, pms_appt_type_pms_id?: string | null, times: Array<{ __typename?: 'TimeInterval', start?: number | null, end?: number | null }>, repeat?: { __typename?: 'RepeatAvailability', daysOfMonth?: Array<number> | null, daysOfWeek?: Array<DayOfWeek> | null, weekOfMonth?: WeekOfMonth | null, frequency: any, unit: RepeatUnit, end_date?: number | null } | null }> | null, pms_adjusted_availability?: Array<{ __typename?: 'Availability', date: number, pms_appt_type_pms_id?: string | null, times: Array<{ __typename?: 'TimeInterval', start?: number | null, end?: number | null }>, repeat?: { __typename?: 'RepeatAvailability', daysOfMonth?: Array<number> | null, daysOfWeek?: Array<DayOfWeek> | null, weekOfMonth?: WeekOfMonth | null, frequency: any, unit: RepeatUnit, end_date?: number | null } | null }> | null } | null, default_room?: { __typename?: 'Room', id: string, pms_id: string, name: string, display_name?: string | null, description?: string | null, concurrent_patients?: number | null, is_active: boolean, does_contribute_to_fill_rate?: boolean | null, valid_booking_interval_minutes?: Array<number> | null, created_at: number, updated_at: number, clinic?: { __typename?: 'Clinic', pms: PracticeManagementSystem, id: string, name?: string | null, time_zone?: string | null } | null, hours?: { __typename?: 'AvailabilityHours', monday?: Array<{ __typename?: 'TimeInterval', start?: number | null, end?: number | null }> | null, tuesday?: Array<{ __typename?: 'TimeInterval', start?: number | null, end?: number | null }> | null, wednesday?: Array<{ __typename?: 'TimeInterval', start?: number | null, end?: number | null }> | null, thursday?: Array<{ __typename?: 'TimeInterval', start?: number | null, end?: number | null }> | null, friday?: Array<{ __typename?: 'TimeInterval', start?: number | null, end?: number | null }> | null, saturday?: Array<{ __typename?: 'TimeInterval', start?: number | null, end?: number | null }> | null, sunday?: Array<{ __typename?: 'TimeInterval', start?: number | null, end?: number | null }> | null } | null, adjusted_availability?: Array<{ __typename?: 'Availability', date: number, pms_appt_type_pms_id?: string | null, times: Array<{ __typename?: 'TimeInterval', start?: number | null, end?: number | null }>, repeat?: { __typename?: 'RepeatAvailability', daysOfMonth?: Array<number> | null, daysOfWeek?: Array<DayOfWeek> | null, weekOfMonth?: WeekOfMonth | null, frequency: any, unit: RepeatUnit, end_date?: number | null } | null }> | null, pms_adjusted_availability?: Array<{ __typename?: 'Availability', date: number, pms_appt_type_pms_id?: string | null, times: Array<{ __typename?: 'TimeInterval', start?: number | null, end?: number | null }>, repeat?: { __typename?: 'RepeatAvailability', daysOfMonth?: Array<number> | null, daysOfWeek?: Array<DayOfWeek> | null, weekOfMonth?: WeekOfMonth | null, frequency: any, unit: RepeatUnit, end_date?: number | null } | null }> | null } | null, availability?: { __typename?: 'AvailabilityHours', monday?: Array<{ __typename?: 'TimeInterval', start?: number | null, end?: number | null }> | null, tuesday?: Array<{ __typename?: 'TimeInterval', start?: number | null, end?: number | null }> | null, wednesday?: Array<{ __typename?: 'TimeInterval', start?: number | null, end?: number | null }> | null, thursday?: Array<{ __typename?: 'TimeInterval', start?: number | null, end?: number | null }> | null, friday?: Array<{ __typename?: 'TimeInterval', start?: number | null, end?: number | null }> | null, saturday?: Array<{ __typename?: 'TimeInterval', start?: number | null, end?: number | null }> | null, sunday?: Array<{ __typename?: 'TimeInterval', start?: number | null, end?: number | null }> | null } | null, drop_off_hours?: { __typename?: 'AvailabilityHours', monday?: Array<{ __typename?: 'TimeInterval', start?: number | null, end?: number | null }> | null, tuesday?: Array<{ __typename?: 'TimeInterval', start?: number | null, end?: number | null }> | null, wednesday?: Array<{ __typename?: 'TimeInterval', start?: number | null, end?: number | null }> | null, thursday?: Array<{ __typename?: 'TimeInterval', start?: number | null, end?: number | null }> | null, friday?: Array<{ __typename?: 'TimeInterval', start?: number | null, end?: number | null }> | null, saturday?: Array<{ __typename?: 'TimeInterval', start?: number | null, end?: number | null }> | null, sunday?: Array<{ __typename?: 'TimeInterval', start?: number | null, end?: number | null }> | null } | null, pre_confirmation_checklist?: Array<{ __typename?: 'ServicePreConfirmationItem', title: string, description?: string | null, required?: boolean | null }> | null } | null } };

export type QueryAppointmentPromptsQueryVariables = Exact<{
  where?: InputMaybe<Array<QueryInput> | QueryInput>;
  page?: InputMaybe<Scalars['NonNegativeInt']['input']>;
  pageSize?: InputMaybe<Scalars['NonNegativeInt']['input']>;
  orderBy?: InputMaybe<OrderByInput>;
}>;


export type QueryAppointmentPromptsQuery = { __typename?: 'Query', queryAppointmentPrompts: Array<{ __typename?: 'AppointmentPrompt', id: string, client_notes?: string | null, clinic_notes?: string | null, confirmed_at?: number | null, minutes?: number | null, reason_for_denial?: string | null, service_name?: string | null, start_time?: number | null, type: AppointmentPromptType, created_at: number, updated_at: number, clinic: { __typename?: 'Clinic', id: string, name?: string | null }, client?: { __typename?: 'Client', id: string, first_name?: string | null, last_name?: string | null, secondary_first_name?: string | null, secondary_last_name?: string | null, phone?: string | null, email?: string | null, pms?: PracticeManagementSystem | null, pms_id?: string | null, last_appt_time?: number | null, last_contact_time?: number | null, email_enabled: boolean, sms_enabled: boolean, balance?: number | null, is_active?: boolean | null, is_unsubscribed: boolean, created_at: number, updated_at: number, client_phones?: Array<{ __typename?: 'ClientPhone', id: string, phone: string, country_code?: string | null, is_primary: boolean, is_chckup_primary: boolean, is_mobile: boolean, sms_available: boolean, is_unsubscribed: boolean, is_active: boolean, name?: string | null }> | null, client_emails?: Array<{ __typename?: 'ClientEmail', id: string, email: string, is_primary: boolean }> | null, clinic?: { __typename?: 'Clinic', id: string } | null, patients?: Array<{ __typename?: 'Patient', id: string, pms?: PracticeManagementSystem | null, pms_id?: string | null, name?: string | null, breed?: string | null, avatar_url?: string | null, last_appt_time?: number | null, gender?: string | null, fixed_status?: FixedStatus | null, weight?: number | null, birthday?: number | null, is_active?: boolean | null, is_deceased?: boolean | null, pms_created_at?: number | null, created_at: number, updated_at: number, owner?: { __typename?: 'Client', id: string, first_name?: string | null, last_name?: string | null, email?: string | null, phone?: string | null, address?: { __typename?: 'Address', country?: string | null } | null } | null, clinic_species?: { __typename?: 'ClinicSpecies', id: string, pms_id: string, description: string, is_primary: boolean, species: Species, weight_key: string, created_at: number, updated_at: number } | null, clinic?: { __typename?: 'Clinic', id: string } | null, clinic_breed?: { __typename?: 'Breed', id: string, description: string } | null, patient_vaccination_records?: Array<{ __typename?: 'PatientVaccinationRecord', id: string, vaccine_name?: string | null, manufacturer?: string | null, lot_number?: string | null, administered_date?: number | null, due_date?: number | null, rabies_tag?: string | null, is_rabies_vaccine?: boolean | null, is_soc: boolean, is_active: boolean, product?: { __typename?: 'Product', id: string, display_name?: string | null, name: string } | null }> | null, last_appointment?: { __typename?: 'Appointment', clinician?: { __typename?: 'Clinician', name: string, display_name?: string | null } | null } | null }> | null, address?: { __typename?: 'Address', street_a?: string | null, street_b?: string | null, city?: string | null, state?: string | null, zip?: string | null, country?: string | null } | null, user?: { __typename?: 'User', avatar_url?: string | null } | null, loyalty_members?: Array<{ __typename?: 'LoyaltyMember', id: string, available_points: number } | null> | null, settings?: { __typename?: 'ClientSettings', clinic_chckup_notifications_enabled: boolean, clinic_chckup_sms_enabled: boolean, clinic_chckup_email_enabled: boolean, client_chckup_notifications_enabled: boolean, client_chckup_sms_enabled: boolean, client_chckup_email_enabled: boolean, is_unsubscribed_from_marketing: boolean, is_unsubscribed_from_marketing_sms: boolean, is_unsubscribed_from_marketing_email: boolean } | null, last_appointment?: { __typename?: 'Appointment', clinician?: { __typename?: 'Clinician', name: string, display_name?: string | null } | null } | null } | null, clinician?: { __typename?: 'Clinician', id: string, name: string, display_name?: string | null, bio?: string | null, avatar_url?: string | null, initials?: string | null, excluded_species?: Array<Species> | null, excluded_service_ids?: Array<string> | null, authority_level?: AuthorityLevel | null, type: ResourceType, is_active?: boolean | null, is_assignable_in_pms?: boolean | null, does_contribute_to_fill_rate?: boolean | null, pms_id?: string | null, location?: string | null, pms_is_active: boolean, valid_booking_interval_minutes?: Array<number> | null, created_at: number, updated_at: number, clinic?: { __typename?: 'Clinic', id: string, name?: string | null } | null, pms_db?: { __typename?: 'PmsDb', id: string } | null, hours?: { __typename?: 'AvailabilityHours', monday?: Array<{ __typename?: 'TimeInterval', start?: number | null, end?: number | null }> | null, tuesday?: Array<{ __typename?: 'TimeInterval', start?: number | null, end?: number | null }> | null, wednesday?: Array<{ __typename?: 'TimeInterval', start?: number | null, end?: number | null }> | null, thursday?: Array<{ __typename?: 'TimeInterval', start?: number | null, end?: number | null }> | null, friday?: Array<{ __typename?: 'TimeInterval', start?: number | null, end?: number | null }> | null, saturday?: Array<{ __typename?: 'TimeInterval', start?: number | null, end?: number | null }> | null, sunday?: Array<{ __typename?: 'TimeInterval', start?: number | null, end?: number | null }> | null } | null, adjusted_availability?: Array<{ __typename?: 'Availability', date: number, pms_appt_type_pms_id?: string | null, times: Array<{ __typename?: 'TimeInterval', start?: number | null, end?: number | null }>, repeat?: { __typename?: 'RepeatAvailability', daysOfMonth?: Array<number> | null, daysOfWeek?: Array<DayOfWeek> | null, weekOfMonth?: WeekOfMonth | null, frequency: any, unit: RepeatUnit, end_date?: number | null } | null }> | null, pms_adjusted_availability?: Array<{ __typename?: 'Availability', date: number, pms_appt_type_pms_id?: string | null, times: Array<{ __typename?: 'TimeInterval', start?: number | null, end?: number | null }>, repeat?: { __typename?: 'RepeatAvailability', daysOfMonth?: Array<number> | null, daysOfWeek?: Array<DayOfWeek> | null, weekOfMonth?: WeekOfMonth | null, frequency: any, unit: RepeatUnit, end_date?: number | null } | null }> | null } | null, patient?: { __typename?: 'Patient', id: string, pms?: PracticeManagementSystem | null, pms_id?: string | null, name?: string | null, breed?: string | null, avatar_url?: string | null, last_appt_time?: number | null, gender?: string | null, fixed_status?: FixedStatus | null, weight?: number | null, birthday?: number | null, is_active?: boolean | null, is_deceased?: boolean | null, pms_created_at?: number | null, created_at: number, updated_at: number, owner?: { __typename?: 'Client', id: string, first_name?: string | null, last_name?: string | null, email?: string | null, phone?: string | null, address?: { __typename?: 'Address', country?: string | null } | null } | null, clinic_species?: { __typename?: 'ClinicSpecies', id: string, pms_id: string, description: string, is_primary: boolean, species: Species, weight_key: string, created_at: number, updated_at: number } | null, clinic?: { __typename?: 'Clinic', id: string } | null, clinic_breed?: { __typename?: 'Breed', id: string, description: string } | null, patient_vaccination_records?: Array<{ __typename?: 'PatientVaccinationRecord', id: string, vaccine_name?: string | null, manufacturer?: string | null, lot_number?: string | null, administered_date?: number | null, due_date?: number | null, rabies_tag?: string | null, is_rabies_vaccine?: boolean | null, is_soc: boolean, is_active: boolean, product?: { __typename?: 'Product', id: string, display_name?: string | null, name: string } | null }> | null, last_appointment?: { __typename?: 'Appointment', clinician?: { __typename?: 'Clinician', name: string, display_name?: string | null } | null } | null } | null, service?: { __typename?: 'Service', id: string, name?: string | null, order?: number | null, keywords?: string | null, service_types: Array<ServiceType>, is_active?: boolean | null, allow_new?: boolean | null, color?: string | null, description?: string | null, duration?: number | null, allow_returning?: boolean | null, max_per_day?: number | null, max_per_hour?: number | null, excluded_species?: Array<Species> | null, reserved_per_day?: number | null, authorized_levels?: Array<AuthorityLevel> | null, scheduling_buffer_minutes?: number | null, scheduling_min_minutes_away?: number | null, scheduling_max_minutes_away?: number | null, minimum_patient_age_in_days?: number | null, maximum_patient_age_in_days?: number | null, more_info?: string | null, more_info_action_required?: string | null, action_required_acknowledgement_text?: string | null, points: number, drop_off_time?: string | null, pick_up_time?: string | null, is_blocking: boolean, is_reschedule_allowed: boolean, is_cancellation_allowed: boolean, is_primary_for_appt_type: boolean, hide_clinician_preference: boolean, use_previous_doctor: boolean, allowed_appt_type_pms_ids?: Array<string> | null, valid_booking_interval_minutes?: Array<number> | null, only_use_adj_avail_guides: boolean, exclude_from_portal: boolean, created_at: number, updated_at: number, clinic?: { __typename?: 'Clinic', id: string, name?: string | null } | null, service_service_categories?: Array<{ __typename?: 'ServiceServiceCategory', service_category: { __typename?: 'ServiceCategory', id: string, order: number, icon?: ServiceCategoryIcon | null, title: string, description: string, requires_confirmation: boolean, confirmation_message?: string | null, created_at: number, updated_at: number } }> | null, pricing?: { __typename?: 'ServicePricing', price: any, currency: any, type: ServicePricingType, client_type?: ClientTypeEnum | null } | null, pms_appt_type?: { __typename?: 'PmsApptType', id: string, name: string, pms_id: string, description?: string | null, color?: any | null, pms_is_active: boolean } | null, required_room?: { __typename?: 'Room', id: string, pms_id: string, name: string, display_name?: string | null, description?: string | null, concurrent_patients?: number | null, is_active: boolean, does_contribute_to_fill_rate?: boolean | null, valid_booking_interval_minutes?: Array<number> | null, created_at: number, updated_at: number, clinic?: { __typename?: 'Clinic', pms: PracticeManagementSystem, id: string, name?: string | null, time_zone?: string | null } | null, hours?: { __typename?: 'AvailabilityHours', monday?: Array<{ __typename?: 'TimeInterval', start?: number | null, end?: number | null }> | null, tuesday?: Array<{ __typename?: 'TimeInterval', start?: number | null, end?: number | null }> | null, wednesday?: Array<{ __typename?: 'TimeInterval', start?: number | null, end?: number | null }> | null, thursday?: Array<{ __typename?: 'TimeInterval', start?: number | null, end?: number | null }> | null, friday?: Array<{ __typename?: 'TimeInterval', start?: number | null, end?: number | null }> | null, saturday?: Array<{ __typename?: 'TimeInterval', start?: number | null, end?: number | null }> | null, sunday?: Array<{ __typename?: 'TimeInterval', start?: number | null, end?: number | null }> | null } | null, adjusted_availability?: Array<{ __typename?: 'Availability', date: number, pms_appt_type_pms_id?: string | null, times: Array<{ __typename?: 'TimeInterval', start?: number | null, end?: number | null }>, repeat?: { __typename?: 'RepeatAvailability', daysOfMonth?: Array<number> | null, daysOfWeek?: Array<DayOfWeek> | null, weekOfMonth?: WeekOfMonth | null, frequency: any, unit: RepeatUnit, end_date?: number | null } | null }> | null, pms_adjusted_availability?: Array<{ __typename?: 'Availability', date: number, pms_appt_type_pms_id?: string | null, times: Array<{ __typename?: 'TimeInterval', start?: number | null, end?: number | null }>, repeat?: { __typename?: 'RepeatAvailability', daysOfMonth?: Array<number> | null, daysOfWeek?: Array<DayOfWeek> | null, weekOfMonth?: WeekOfMonth | null, frequency: any, unit: RepeatUnit, end_date?: number | null } | null }> | null } | null, default_room?: { __typename?: 'Room', id: string, pms_id: string, name: string, display_name?: string | null, description?: string | null, concurrent_patients?: number | null, is_active: boolean, does_contribute_to_fill_rate?: boolean | null, valid_booking_interval_minutes?: Array<number> | null, created_at: number, updated_at: number, clinic?: { __typename?: 'Clinic', pms: PracticeManagementSystem, id: string, name?: string | null, time_zone?: string | null } | null, hours?: { __typename?: 'AvailabilityHours', monday?: Array<{ __typename?: 'TimeInterval', start?: number | null, end?: number | null }> | null, tuesday?: Array<{ __typename?: 'TimeInterval', start?: number | null, end?: number | null }> | null, wednesday?: Array<{ __typename?: 'TimeInterval', start?: number | null, end?: number | null }> | null, thursday?: Array<{ __typename?: 'TimeInterval', start?: number | null, end?: number | null }> | null, friday?: Array<{ __typename?: 'TimeInterval', start?: number | null, end?: number | null }> | null, saturday?: Array<{ __typename?: 'TimeInterval', start?: number | null, end?: number | null }> | null, sunday?: Array<{ __typename?: 'TimeInterval', start?: number | null, end?: number | null }> | null } | null, adjusted_availability?: Array<{ __typename?: 'Availability', date: number, pms_appt_type_pms_id?: string | null, times: Array<{ __typename?: 'TimeInterval', start?: number | null, end?: number | null }>, repeat?: { __typename?: 'RepeatAvailability', daysOfMonth?: Array<number> | null, daysOfWeek?: Array<DayOfWeek> | null, weekOfMonth?: WeekOfMonth | null, frequency: any, unit: RepeatUnit, end_date?: number | null } | null }> | null, pms_adjusted_availability?: Array<{ __typename?: 'Availability', date: number, pms_appt_type_pms_id?: string | null, times: Array<{ __typename?: 'TimeInterval', start?: number | null, end?: number | null }>, repeat?: { __typename?: 'RepeatAvailability', daysOfMonth?: Array<number> | null, daysOfWeek?: Array<DayOfWeek> | null, weekOfMonth?: WeekOfMonth | null, frequency: any, unit: RepeatUnit, end_date?: number | null } | null }> | null } | null, availability?: { __typename?: 'AvailabilityHours', monday?: Array<{ __typename?: 'TimeInterval', start?: number | null, end?: number | null }> | null, tuesday?: Array<{ __typename?: 'TimeInterval', start?: number | null, end?: number | null }> | null, wednesday?: Array<{ __typename?: 'TimeInterval', start?: number | null, end?: number | null }> | null, thursday?: Array<{ __typename?: 'TimeInterval', start?: number | null, end?: number | null }> | null, friday?: Array<{ __typename?: 'TimeInterval', start?: number | null, end?: number | null }> | null, saturday?: Array<{ __typename?: 'TimeInterval', start?: number | null, end?: number | null }> | null, sunday?: Array<{ __typename?: 'TimeInterval', start?: number | null, end?: number | null }> | null } | null, drop_off_hours?: { __typename?: 'AvailabilityHours', monday?: Array<{ __typename?: 'TimeInterval', start?: number | null, end?: number | null }> | null, tuesday?: Array<{ __typename?: 'TimeInterval', start?: number | null, end?: number | null }> | null, wednesday?: Array<{ __typename?: 'TimeInterval', start?: number | null, end?: number | null }> | null, thursday?: Array<{ __typename?: 'TimeInterval', start?: number | null, end?: number | null }> | null, friday?: Array<{ __typename?: 'TimeInterval', start?: number | null, end?: number | null }> | null, saturday?: Array<{ __typename?: 'TimeInterval', start?: number | null, end?: number | null }> | null, sunday?: Array<{ __typename?: 'TimeInterval', start?: number | null, end?: number | null }> | null } | null, pre_confirmation_checklist?: Array<{ __typename?: 'ServicePreConfirmationItem', title: string, description?: string | null, required?: boolean | null }> | null } | null }> };

export type CreateAppointmentPromptMutationVariables = Exact<{
  data: CreateAppointmentPromptInput;
}>;


export type CreateAppointmentPromptMutation = { __typename?: 'Mutation', createAppointmentPrompt: { __typename?: 'AppointmentPrompt', id: string, client_notes?: string | null, clinic_notes?: string | null, confirmed_at?: number | null, minutes?: number | null, reason_for_denial?: string | null, service_name?: string | null, start_time?: number | null, type: AppointmentPromptType, created_at: number, updated_at: number, clinic: { __typename?: 'Clinic', id: string, name?: string | null }, client?: { __typename?: 'Client', id: string, first_name?: string | null, last_name?: string | null, secondary_first_name?: string | null, secondary_last_name?: string | null, phone?: string | null, email?: string | null, pms?: PracticeManagementSystem | null, pms_id?: string | null, last_appt_time?: number | null, last_contact_time?: number | null, email_enabled: boolean, sms_enabled: boolean, balance?: number | null, is_active?: boolean | null, is_unsubscribed: boolean, created_at: number, updated_at: number, client_phones?: Array<{ __typename?: 'ClientPhone', id: string, phone: string, country_code?: string | null, is_primary: boolean, is_chckup_primary: boolean, is_mobile: boolean, sms_available: boolean, is_unsubscribed: boolean, is_active: boolean, name?: string | null }> | null, client_emails?: Array<{ __typename?: 'ClientEmail', id: string, email: string, is_primary: boolean }> | null, clinic?: { __typename?: 'Clinic', id: string } | null, patients?: Array<{ __typename?: 'Patient', id: string, pms?: PracticeManagementSystem | null, pms_id?: string | null, name?: string | null, breed?: string | null, avatar_url?: string | null, last_appt_time?: number | null, gender?: string | null, fixed_status?: FixedStatus | null, weight?: number | null, birthday?: number | null, is_active?: boolean | null, is_deceased?: boolean | null, pms_created_at?: number | null, created_at: number, updated_at: number, owner?: { __typename?: 'Client', id: string, first_name?: string | null, last_name?: string | null, email?: string | null, phone?: string | null, address?: { __typename?: 'Address', country?: string | null } | null } | null, clinic_species?: { __typename?: 'ClinicSpecies', id: string, pms_id: string, description: string, is_primary: boolean, species: Species, weight_key: string, created_at: number, updated_at: number } | null, clinic?: { __typename?: 'Clinic', id: string } | null, clinic_breed?: { __typename?: 'Breed', id: string, description: string } | null, patient_vaccination_records?: Array<{ __typename?: 'PatientVaccinationRecord', id: string, vaccine_name?: string | null, manufacturer?: string | null, lot_number?: string | null, administered_date?: number | null, due_date?: number | null, rabies_tag?: string | null, is_rabies_vaccine?: boolean | null, is_soc: boolean, is_active: boolean, product?: { __typename?: 'Product', id: string, display_name?: string | null, name: string } | null }> | null, last_appointment?: { __typename?: 'Appointment', clinician?: { __typename?: 'Clinician', name: string, display_name?: string | null } | null } | null }> | null, address?: { __typename?: 'Address', street_a?: string | null, street_b?: string | null, city?: string | null, state?: string | null, zip?: string | null, country?: string | null } | null, user?: { __typename?: 'User', avatar_url?: string | null } | null, loyalty_members?: Array<{ __typename?: 'LoyaltyMember', id: string, available_points: number } | null> | null, settings?: { __typename?: 'ClientSettings', clinic_chckup_notifications_enabled: boolean, clinic_chckup_sms_enabled: boolean, clinic_chckup_email_enabled: boolean, client_chckup_notifications_enabled: boolean, client_chckup_sms_enabled: boolean, client_chckup_email_enabled: boolean, is_unsubscribed_from_marketing: boolean, is_unsubscribed_from_marketing_sms: boolean, is_unsubscribed_from_marketing_email: boolean } | null, last_appointment?: { __typename?: 'Appointment', clinician?: { __typename?: 'Clinician', name: string, display_name?: string | null } | null } | null } | null, clinician?: { __typename?: 'Clinician', id: string, name: string, display_name?: string | null, bio?: string | null, avatar_url?: string | null, initials?: string | null, excluded_species?: Array<Species> | null, excluded_service_ids?: Array<string> | null, authority_level?: AuthorityLevel | null, type: ResourceType, is_active?: boolean | null, is_assignable_in_pms?: boolean | null, does_contribute_to_fill_rate?: boolean | null, pms_id?: string | null, location?: string | null, pms_is_active: boolean, valid_booking_interval_minutes?: Array<number> | null, created_at: number, updated_at: number, clinic?: { __typename?: 'Clinic', id: string, name?: string | null } | null, pms_db?: { __typename?: 'PmsDb', id: string } | null, hours?: { __typename?: 'AvailabilityHours', monday?: Array<{ __typename?: 'TimeInterval', start?: number | null, end?: number | null }> | null, tuesday?: Array<{ __typename?: 'TimeInterval', start?: number | null, end?: number | null }> | null, wednesday?: Array<{ __typename?: 'TimeInterval', start?: number | null, end?: number | null }> | null, thursday?: Array<{ __typename?: 'TimeInterval', start?: number | null, end?: number | null }> | null, friday?: Array<{ __typename?: 'TimeInterval', start?: number | null, end?: number | null }> | null, saturday?: Array<{ __typename?: 'TimeInterval', start?: number | null, end?: number | null }> | null, sunday?: Array<{ __typename?: 'TimeInterval', start?: number | null, end?: number | null }> | null } | null, adjusted_availability?: Array<{ __typename?: 'Availability', date: number, pms_appt_type_pms_id?: string | null, times: Array<{ __typename?: 'TimeInterval', start?: number | null, end?: number | null }>, repeat?: { __typename?: 'RepeatAvailability', daysOfMonth?: Array<number> | null, daysOfWeek?: Array<DayOfWeek> | null, weekOfMonth?: WeekOfMonth | null, frequency: any, unit: RepeatUnit, end_date?: number | null } | null }> | null, pms_adjusted_availability?: Array<{ __typename?: 'Availability', date: number, pms_appt_type_pms_id?: string | null, times: Array<{ __typename?: 'TimeInterval', start?: number | null, end?: number | null }>, repeat?: { __typename?: 'RepeatAvailability', daysOfMonth?: Array<number> | null, daysOfWeek?: Array<DayOfWeek> | null, weekOfMonth?: WeekOfMonth | null, frequency: any, unit: RepeatUnit, end_date?: number | null } | null }> | null } | null, patient?: { __typename?: 'Patient', id: string, pms?: PracticeManagementSystem | null, pms_id?: string | null, name?: string | null, breed?: string | null, avatar_url?: string | null, last_appt_time?: number | null, gender?: string | null, fixed_status?: FixedStatus | null, weight?: number | null, birthday?: number | null, is_active?: boolean | null, is_deceased?: boolean | null, pms_created_at?: number | null, created_at: number, updated_at: number, owner?: { __typename?: 'Client', id: string, first_name?: string | null, last_name?: string | null, email?: string | null, phone?: string | null, address?: { __typename?: 'Address', country?: string | null } | null } | null, clinic_species?: { __typename?: 'ClinicSpecies', id: string, pms_id: string, description: string, is_primary: boolean, species: Species, weight_key: string, created_at: number, updated_at: number } | null, clinic?: { __typename?: 'Clinic', id: string } | null, clinic_breed?: { __typename?: 'Breed', id: string, description: string } | null, patient_vaccination_records?: Array<{ __typename?: 'PatientVaccinationRecord', id: string, vaccine_name?: string | null, manufacturer?: string | null, lot_number?: string | null, administered_date?: number | null, due_date?: number | null, rabies_tag?: string | null, is_rabies_vaccine?: boolean | null, is_soc: boolean, is_active: boolean, product?: { __typename?: 'Product', id: string, display_name?: string | null, name: string } | null }> | null, last_appointment?: { __typename?: 'Appointment', clinician?: { __typename?: 'Clinician', name: string, display_name?: string | null } | null } | null } | null, service?: { __typename?: 'Service', id: string, name?: string | null, order?: number | null, keywords?: string | null, service_types: Array<ServiceType>, is_active?: boolean | null, allow_new?: boolean | null, color?: string | null, description?: string | null, duration?: number | null, allow_returning?: boolean | null, max_per_day?: number | null, max_per_hour?: number | null, excluded_species?: Array<Species> | null, reserved_per_day?: number | null, authorized_levels?: Array<AuthorityLevel> | null, scheduling_buffer_minutes?: number | null, scheduling_min_minutes_away?: number | null, scheduling_max_minutes_away?: number | null, minimum_patient_age_in_days?: number | null, maximum_patient_age_in_days?: number | null, more_info?: string | null, more_info_action_required?: string | null, action_required_acknowledgement_text?: string | null, points: number, drop_off_time?: string | null, pick_up_time?: string | null, is_blocking: boolean, is_reschedule_allowed: boolean, is_cancellation_allowed: boolean, is_primary_for_appt_type: boolean, hide_clinician_preference: boolean, use_previous_doctor: boolean, allowed_appt_type_pms_ids?: Array<string> | null, valid_booking_interval_minutes?: Array<number> | null, only_use_adj_avail_guides: boolean, exclude_from_portal: boolean, created_at: number, updated_at: number, clinic?: { __typename?: 'Clinic', id: string, name?: string | null } | null, service_service_categories?: Array<{ __typename?: 'ServiceServiceCategory', service_category: { __typename?: 'ServiceCategory', id: string, order: number, icon?: ServiceCategoryIcon | null, title: string, description: string, requires_confirmation: boolean, confirmation_message?: string | null, created_at: number, updated_at: number } }> | null, pricing?: { __typename?: 'ServicePricing', price: any, currency: any, type: ServicePricingType, client_type?: ClientTypeEnum | null } | null, pms_appt_type?: { __typename?: 'PmsApptType', id: string, name: string, pms_id: string, description?: string | null, color?: any | null, pms_is_active: boolean } | null, required_room?: { __typename?: 'Room', id: string, pms_id: string, name: string, display_name?: string | null, description?: string | null, concurrent_patients?: number | null, is_active: boolean, does_contribute_to_fill_rate?: boolean | null, valid_booking_interval_minutes?: Array<number> | null, created_at: number, updated_at: number, clinic?: { __typename?: 'Clinic', pms: PracticeManagementSystem, id: string, name?: string | null, time_zone?: string | null } | null, hours?: { __typename?: 'AvailabilityHours', monday?: Array<{ __typename?: 'TimeInterval', start?: number | null, end?: number | null }> | null, tuesday?: Array<{ __typename?: 'TimeInterval', start?: number | null, end?: number | null }> | null, wednesday?: Array<{ __typename?: 'TimeInterval', start?: number | null, end?: number | null }> | null, thursday?: Array<{ __typename?: 'TimeInterval', start?: number | null, end?: number | null }> | null, friday?: Array<{ __typename?: 'TimeInterval', start?: number | null, end?: number | null }> | null, saturday?: Array<{ __typename?: 'TimeInterval', start?: number | null, end?: number | null }> | null, sunday?: Array<{ __typename?: 'TimeInterval', start?: number | null, end?: number | null }> | null } | null, adjusted_availability?: Array<{ __typename?: 'Availability', date: number, pms_appt_type_pms_id?: string | null, times: Array<{ __typename?: 'TimeInterval', start?: number | null, end?: number | null }>, repeat?: { __typename?: 'RepeatAvailability', daysOfMonth?: Array<number> | null, daysOfWeek?: Array<DayOfWeek> | null, weekOfMonth?: WeekOfMonth | null, frequency: any, unit: RepeatUnit, end_date?: number | null } | null }> | null, pms_adjusted_availability?: Array<{ __typename?: 'Availability', date: number, pms_appt_type_pms_id?: string | null, times: Array<{ __typename?: 'TimeInterval', start?: number | null, end?: number | null }>, repeat?: { __typename?: 'RepeatAvailability', daysOfMonth?: Array<number> | null, daysOfWeek?: Array<DayOfWeek> | null, weekOfMonth?: WeekOfMonth | null, frequency: any, unit: RepeatUnit, end_date?: number | null } | null }> | null } | null, default_room?: { __typename?: 'Room', id: string, pms_id: string, name: string, display_name?: string | null, description?: string | null, concurrent_patients?: number | null, is_active: boolean, does_contribute_to_fill_rate?: boolean | null, valid_booking_interval_minutes?: Array<number> | null, created_at: number, updated_at: number, clinic?: { __typename?: 'Clinic', pms: PracticeManagementSystem, id: string, name?: string | null, time_zone?: string | null } | null, hours?: { __typename?: 'AvailabilityHours', monday?: Array<{ __typename?: 'TimeInterval', start?: number | null, end?: number | null }> | null, tuesday?: Array<{ __typename?: 'TimeInterval', start?: number | null, end?: number | null }> | null, wednesday?: Array<{ __typename?: 'TimeInterval', start?: number | null, end?: number | null }> | null, thursday?: Array<{ __typename?: 'TimeInterval', start?: number | null, end?: number | null }> | null, friday?: Array<{ __typename?: 'TimeInterval', start?: number | null, end?: number | null }> | null, saturday?: Array<{ __typename?: 'TimeInterval', start?: number | null, end?: number | null }> | null, sunday?: Array<{ __typename?: 'TimeInterval', start?: number | null, end?: number | null }> | null } | null, adjusted_availability?: Array<{ __typename?: 'Availability', date: number, pms_appt_type_pms_id?: string | null, times: Array<{ __typename?: 'TimeInterval', start?: number | null, end?: number | null }>, repeat?: { __typename?: 'RepeatAvailability', daysOfMonth?: Array<number> | null, daysOfWeek?: Array<DayOfWeek> | null, weekOfMonth?: WeekOfMonth | null, frequency: any, unit: RepeatUnit, end_date?: number | null } | null }> | null, pms_adjusted_availability?: Array<{ __typename?: 'Availability', date: number, pms_appt_type_pms_id?: string | null, times: Array<{ __typename?: 'TimeInterval', start?: number | null, end?: number | null }>, repeat?: { __typename?: 'RepeatAvailability', daysOfMonth?: Array<number> | null, daysOfWeek?: Array<DayOfWeek> | null, weekOfMonth?: WeekOfMonth | null, frequency: any, unit: RepeatUnit, end_date?: number | null } | null }> | null } | null, availability?: { __typename?: 'AvailabilityHours', monday?: Array<{ __typename?: 'TimeInterval', start?: number | null, end?: number | null }> | null, tuesday?: Array<{ __typename?: 'TimeInterval', start?: number | null, end?: number | null }> | null, wednesday?: Array<{ __typename?: 'TimeInterval', start?: number | null, end?: number | null }> | null, thursday?: Array<{ __typename?: 'TimeInterval', start?: number | null, end?: number | null }> | null, friday?: Array<{ __typename?: 'TimeInterval', start?: number | null, end?: number | null }> | null, saturday?: Array<{ __typename?: 'TimeInterval', start?: number | null, end?: number | null }> | null, sunday?: Array<{ __typename?: 'TimeInterval', start?: number | null, end?: number | null }> | null } | null, drop_off_hours?: { __typename?: 'AvailabilityHours', monday?: Array<{ __typename?: 'TimeInterval', start?: number | null, end?: number | null }> | null, tuesday?: Array<{ __typename?: 'TimeInterval', start?: number | null, end?: number | null }> | null, wednesday?: Array<{ __typename?: 'TimeInterval', start?: number | null, end?: number | null }> | null, thursday?: Array<{ __typename?: 'TimeInterval', start?: number | null, end?: number | null }> | null, friday?: Array<{ __typename?: 'TimeInterval', start?: number | null, end?: number | null }> | null, saturday?: Array<{ __typename?: 'TimeInterval', start?: number | null, end?: number | null }> | null, sunday?: Array<{ __typename?: 'TimeInterval', start?: number | null, end?: number | null }> | null } | null, pre_confirmation_checklist?: Array<{ __typename?: 'ServicePreConfirmationItem', title: string, description?: string | null, required?: boolean | null }> | null } | null } };

export type SendAppointmentPromptMutationVariables = Exact<{
  data: CreateAppointmentPromptInput;
}>;


export type SendAppointmentPromptMutation = { __typename?: 'Mutation', sendAppointmentPrompt: { __typename?: 'AppointmentPrompt', id: string, client_notes?: string | null, clinic_notes?: string | null, confirmed_at?: number | null, minutes?: number | null, reason_for_denial?: string | null, service_name?: string | null, start_time?: number | null, type: AppointmentPromptType, created_at: number, updated_at: number, clinic: { __typename?: 'Clinic', id: string, name?: string | null }, client?: { __typename?: 'Client', id: string, first_name?: string | null, last_name?: string | null, secondary_first_name?: string | null, secondary_last_name?: string | null, phone?: string | null, email?: string | null, pms?: PracticeManagementSystem | null, pms_id?: string | null, last_appt_time?: number | null, last_contact_time?: number | null, email_enabled: boolean, sms_enabled: boolean, balance?: number | null, is_active?: boolean | null, is_unsubscribed: boolean, created_at: number, updated_at: number, client_phones?: Array<{ __typename?: 'ClientPhone', id: string, phone: string, country_code?: string | null, is_primary: boolean, is_chckup_primary: boolean, is_mobile: boolean, sms_available: boolean, is_unsubscribed: boolean, is_active: boolean, name?: string | null }> | null, client_emails?: Array<{ __typename?: 'ClientEmail', id: string, email: string, is_primary: boolean }> | null, clinic?: { __typename?: 'Clinic', id: string } | null, patients?: Array<{ __typename?: 'Patient', id: string, pms?: PracticeManagementSystem | null, pms_id?: string | null, name?: string | null, breed?: string | null, avatar_url?: string | null, last_appt_time?: number | null, gender?: string | null, fixed_status?: FixedStatus | null, weight?: number | null, birthday?: number | null, is_active?: boolean | null, is_deceased?: boolean | null, pms_created_at?: number | null, created_at: number, updated_at: number, owner?: { __typename?: 'Client', id: string, first_name?: string | null, last_name?: string | null, email?: string | null, phone?: string | null, address?: { __typename?: 'Address', country?: string | null } | null } | null, clinic_species?: { __typename?: 'ClinicSpecies', id: string, pms_id: string, description: string, is_primary: boolean, species: Species, weight_key: string, created_at: number, updated_at: number } | null, clinic?: { __typename?: 'Clinic', id: string } | null, clinic_breed?: { __typename?: 'Breed', id: string, description: string } | null, patient_vaccination_records?: Array<{ __typename?: 'PatientVaccinationRecord', id: string, vaccine_name?: string | null, manufacturer?: string | null, lot_number?: string | null, administered_date?: number | null, due_date?: number | null, rabies_tag?: string | null, is_rabies_vaccine?: boolean | null, is_soc: boolean, is_active: boolean, product?: { __typename?: 'Product', id: string, display_name?: string | null, name: string } | null }> | null, last_appointment?: { __typename?: 'Appointment', clinician?: { __typename?: 'Clinician', name: string, display_name?: string | null } | null } | null }> | null, address?: { __typename?: 'Address', street_a?: string | null, street_b?: string | null, city?: string | null, state?: string | null, zip?: string | null, country?: string | null } | null, user?: { __typename?: 'User', avatar_url?: string | null } | null, loyalty_members?: Array<{ __typename?: 'LoyaltyMember', id: string, available_points: number } | null> | null, settings?: { __typename?: 'ClientSettings', clinic_chckup_notifications_enabled: boolean, clinic_chckup_sms_enabled: boolean, clinic_chckup_email_enabled: boolean, client_chckup_notifications_enabled: boolean, client_chckup_sms_enabled: boolean, client_chckup_email_enabled: boolean, is_unsubscribed_from_marketing: boolean, is_unsubscribed_from_marketing_sms: boolean, is_unsubscribed_from_marketing_email: boolean } | null, last_appointment?: { __typename?: 'Appointment', clinician?: { __typename?: 'Clinician', name: string, display_name?: string | null } | null } | null } | null, clinician?: { __typename?: 'Clinician', id: string, name: string, display_name?: string | null, bio?: string | null, avatar_url?: string | null, initials?: string | null, excluded_species?: Array<Species> | null, excluded_service_ids?: Array<string> | null, authority_level?: AuthorityLevel | null, type: ResourceType, is_active?: boolean | null, is_assignable_in_pms?: boolean | null, does_contribute_to_fill_rate?: boolean | null, pms_id?: string | null, location?: string | null, pms_is_active: boolean, valid_booking_interval_minutes?: Array<number> | null, created_at: number, updated_at: number, clinic?: { __typename?: 'Clinic', id: string, name?: string | null } | null, pms_db?: { __typename?: 'PmsDb', id: string } | null, hours?: { __typename?: 'AvailabilityHours', monday?: Array<{ __typename?: 'TimeInterval', start?: number | null, end?: number | null }> | null, tuesday?: Array<{ __typename?: 'TimeInterval', start?: number | null, end?: number | null }> | null, wednesday?: Array<{ __typename?: 'TimeInterval', start?: number | null, end?: number | null }> | null, thursday?: Array<{ __typename?: 'TimeInterval', start?: number | null, end?: number | null }> | null, friday?: Array<{ __typename?: 'TimeInterval', start?: number | null, end?: number | null }> | null, saturday?: Array<{ __typename?: 'TimeInterval', start?: number | null, end?: number | null }> | null, sunday?: Array<{ __typename?: 'TimeInterval', start?: number | null, end?: number | null }> | null } | null, adjusted_availability?: Array<{ __typename?: 'Availability', date: number, pms_appt_type_pms_id?: string | null, times: Array<{ __typename?: 'TimeInterval', start?: number | null, end?: number | null }>, repeat?: { __typename?: 'RepeatAvailability', daysOfMonth?: Array<number> | null, daysOfWeek?: Array<DayOfWeek> | null, weekOfMonth?: WeekOfMonth | null, frequency: any, unit: RepeatUnit, end_date?: number | null } | null }> | null, pms_adjusted_availability?: Array<{ __typename?: 'Availability', date: number, pms_appt_type_pms_id?: string | null, times: Array<{ __typename?: 'TimeInterval', start?: number | null, end?: number | null }>, repeat?: { __typename?: 'RepeatAvailability', daysOfMonth?: Array<number> | null, daysOfWeek?: Array<DayOfWeek> | null, weekOfMonth?: WeekOfMonth | null, frequency: any, unit: RepeatUnit, end_date?: number | null } | null }> | null } | null, patient?: { __typename?: 'Patient', id: string, pms?: PracticeManagementSystem | null, pms_id?: string | null, name?: string | null, breed?: string | null, avatar_url?: string | null, last_appt_time?: number | null, gender?: string | null, fixed_status?: FixedStatus | null, weight?: number | null, birthday?: number | null, is_active?: boolean | null, is_deceased?: boolean | null, pms_created_at?: number | null, created_at: number, updated_at: number, owner?: { __typename?: 'Client', id: string, first_name?: string | null, last_name?: string | null, email?: string | null, phone?: string | null, address?: { __typename?: 'Address', country?: string | null } | null } | null, clinic_species?: { __typename?: 'ClinicSpecies', id: string, pms_id: string, description: string, is_primary: boolean, species: Species, weight_key: string, created_at: number, updated_at: number } | null, clinic?: { __typename?: 'Clinic', id: string } | null, clinic_breed?: { __typename?: 'Breed', id: string, description: string } | null, patient_vaccination_records?: Array<{ __typename?: 'PatientVaccinationRecord', id: string, vaccine_name?: string | null, manufacturer?: string | null, lot_number?: string | null, administered_date?: number | null, due_date?: number | null, rabies_tag?: string | null, is_rabies_vaccine?: boolean | null, is_soc: boolean, is_active: boolean, product?: { __typename?: 'Product', id: string, display_name?: string | null, name: string } | null }> | null, last_appointment?: { __typename?: 'Appointment', clinician?: { __typename?: 'Clinician', name: string, display_name?: string | null } | null } | null } | null, service?: { __typename?: 'Service', id: string, name?: string | null, order?: number | null, keywords?: string | null, service_types: Array<ServiceType>, is_active?: boolean | null, allow_new?: boolean | null, color?: string | null, description?: string | null, duration?: number | null, allow_returning?: boolean | null, max_per_day?: number | null, max_per_hour?: number | null, excluded_species?: Array<Species> | null, reserved_per_day?: number | null, authorized_levels?: Array<AuthorityLevel> | null, scheduling_buffer_minutes?: number | null, scheduling_min_minutes_away?: number | null, scheduling_max_minutes_away?: number | null, minimum_patient_age_in_days?: number | null, maximum_patient_age_in_days?: number | null, more_info?: string | null, more_info_action_required?: string | null, action_required_acknowledgement_text?: string | null, points: number, drop_off_time?: string | null, pick_up_time?: string | null, is_blocking: boolean, is_reschedule_allowed: boolean, is_cancellation_allowed: boolean, is_primary_for_appt_type: boolean, hide_clinician_preference: boolean, use_previous_doctor: boolean, allowed_appt_type_pms_ids?: Array<string> | null, valid_booking_interval_minutes?: Array<number> | null, only_use_adj_avail_guides: boolean, exclude_from_portal: boolean, created_at: number, updated_at: number, clinic?: { __typename?: 'Clinic', id: string, name?: string | null } | null, service_service_categories?: Array<{ __typename?: 'ServiceServiceCategory', service_category: { __typename?: 'ServiceCategory', id: string, order: number, icon?: ServiceCategoryIcon | null, title: string, description: string, requires_confirmation: boolean, confirmation_message?: string | null, created_at: number, updated_at: number } }> | null, pricing?: { __typename?: 'ServicePricing', price: any, currency: any, type: ServicePricingType, client_type?: ClientTypeEnum | null } | null, pms_appt_type?: { __typename?: 'PmsApptType', id: string, name: string, pms_id: string, description?: string | null, color?: any | null, pms_is_active: boolean } | null, required_room?: { __typename?: 'Room', id: string, pms_id: string, name: string, display_name?: string | null, description?: string | null, concurrent_patients?: number | null, is_active: boolean, does_contribute_to_fill_rate?: boolean | null, valid_booking_interval_minutes?: Array<number> | null, created_at: number, updated_at: number, clinic?: { __typename?: 'Clinic', pms: PracticeManagementSystem, id: string, name?: string | null, time_zone?: string | null } | null, hours?: { __typename?: 'AvailabilityHours', monday?: Array<{ __typename?: 'TimeInterval', start?: number | null, end?: number | null }> | null, tuesday?: Array<{ __typename?: 'TimeInterval', start?: number | null, end?: number | null }> | null, wednesday?: Array<{ __typename?: 'TimeInterval', start?: number | null, end?: number | null }> | null, thursday?: Array<{ __typename?: 'TimeInterval', start?: number | null, end?: number | null }> | null, friday?: Array<{ __typename?: 'TimeInterval', start?: number | null, end?: number | null }> | null, saturday?: Array<{ __typename?: 'TimeInterval', start?: number | null, end?: number | null }> | null, sunday?: Array<{ __typename?: 'TimeInterval', start?: number | null, end?: number | null }> | null } | null, adjusted_availability?: Array<{ __typename?: 'Availability', date: number, pms_appt_type_pms_id?: string | null, times: Array<{ __typename?: 'TimeInterval', start?: number | null, end?: number | null }>, repeat?: { __typename?: 'RepeatAvailability', daysOfMonth?: Array<number> | null, daysOfWeek?: Array<DayOfWeek> | null, weekOfMonth?: WeekOfMonth | null, frequency: any, unit: RepeatUnit, end_date?: number | null } | null }> | null, pms_adjusted_availability?: Array<{ __typename?: 'Availability', date: number, pms_appt_type_pms_id?: string | null, times: Array<{ __typename?: 'TimeInterval', start?: number | null, end?: number | null }>, repeat?: { __typename?: 'RepeatAvailability', daysOfMonth?: Array<number> | null, daysOfWeek?: Array<DayOfWeek> | null, weekOfMonth?: WeekOfMonth | null, frequency: any, unit: RepeatUnit, end_date?: number | null } | null }> | null } | null, default_room?: { __typename?: 'Room', id: string, pms_id: string, name: string, display_name?: string | null, description?: string | null, concurrent_patients?: number | null, is_active: boolean, does_contribute_to_fill_rate?: boolean | null, valid_booking_interval_minutes?: Array<number> | null, created_at: number, updated_at: number, clinic?: { __typename?: 'Clinic', pms: PracticeManagementSystem, id: string, name?: string | null, time_zone?: string | null } | null, hours?: { __typename?: 'AvailabilityHours', monday?: Array<{ __typename?: 'TimeInterval', start?: number | null, end?: number | null }> | null, tuesday?: Array<{ __typename?: 'TimeInterval', start?: number | null, end?: number | null }> | null, wednesday?: Array<{ __typename?: 'TimeInterval', start?: number | null, end?: number | null }> | null, thursday?: Array<{ __typename?: 'TimeInterval', start?: number | null, end?: number | null }> | null, friday?: Array<{ __typename?: 'TimeInterval', start?: number | null, end?: number | null }> | null, saturday?: Array<{ __typename?: 'TimeInterval', start?: number | null, end?: number | null }> | null, sunday?: Array<{ __typename?: 'TimeInterval', start?: number | null, end?: number | null }> | null } | null, adjusted_availability?: Array<{ __typename?: 'Availability', date: number, pms_appt_type_pms_id?: string | null, times: Array<{ __typename?: 'TimeInterval', start?: number | null, end?: number | null }>, repeat?: { __typename?: 'RepeatAvailability', daysOfMonth?: Array<number> | null, daysOfWeek?: Array<DayOfWeek> | null, weekOfMonth?: WeekOfMonth | null, frequency: any, unit: RepeatUnit, end_date?: number | null } | null }> | null, pms_adjusted_availability?: Array<{ __typename?: 'Availability', date: number, pms_appt_type_pms_id?: string | null, times: Array<{ __typename?: 'TimeInterval', start?: number | null, end?: number | null }>, repeat?: { __typename?: 'RepeatAvailability', daysOfMonth?: Array<number> | null, daysOfWeek?: Array<DayOfWeek> | null, weekOfMonth?: WeekOfMonth | null, frequency: any, unit: RepeatUnit, end_date?: number | null } | null }> | null } | null, availability?: { __typename?: 'AvailabilityHours', monday?: Array<{ __typename?: 'TimeInterval', start?: number | null, end?: number | null }> | null, tuesday?: Array<{ __typename?: 'TimeInterval', start?: number | null, end?: number | null }> | null, wednesday?: Array<{ __typename?: 'TimeInterval', start?: number | null, end?: number | null }> | null, thursday?: Array<{ __typename?: 'TimeInterval', start?: number | null, end?: number | null }> | null, friday?: Array<{ __typename?: 'TimeInterval', start?: number | null, end?: number | null }> | null, saturday?: Array<{ __typename?: 'TimeInterval', start?: number | null, end?: number | null }> | null, sunday?: Array<{ __typename?: 'TimeInterval', start?: number | null, end?: number | null }> | null } | null, drop_off_hours?: { __typename?: 'AvailabilityHours', monday?: Array<{ __typename?: 'TimeInterval', start?: number | null, end?: number | null }> | null, tuesday?: Array<{ __typename?: 'TimeInterval', start?: number | null, end?: number | null }> | null, wednesday?: Array<{ __typename?: 'TimeInterval', start?: number | null, end?: number | null }> | null, thursday?: Array<{ __typename?: 'TimeInterval', start?: number | null, end?: number | null }> | null, friday?: Array<{ __typename?: 'TimeInterval', start?: number | null, end?: number | null }> | null, saturday?: Array<{ __typename?: 'TimeInterval', start?: number | null, end?: number | null }> | null, sunday?: Array<{ __typename?: 'TimeInterval', start?: number | null, end?: number | null }> | null } | null, pre_confirmation_checklist?: Array<{ __typename?: 'ServicePreConfirmationItem', title: string, description?: string | null, required?: boolean | null }> | null } | null } };

export type UpdateAppointmentPromptMutationVariables = Exact<{
  id: Scalars['ID']['input'];
  data: UpdateAppointmentPromptInput;
}>;


export type UpdateAppointmentPromptMutation = { __typename?: 'Mutation', updateAppointmentPrompt: { __typename?: 'AppointmentPrompt', id: string, client_notes?: string | null, clinic_notes?: string | null, confirmed_at?: number | null, minutes?: number | null, reason_for_denial?: string | null, service_name?: string | null, start_time?: number | null, type: AppointmentPromptType, created_at: number, updated_at: number, clinic: { __typename?: 'Clinic', id: string, name?: string | null }, client?: { __typename?: 'Client', id: string, first_name?: string | null, last_name?: string | null, secondary_first_name?: string | null, secondary_last_name?: string | null, phone?: string | null, email?: string | null, pms?: PracticeManagementSystem | null, pms_id?: string | null, last_appt_time?: number | null, last_contact_time?: number | null, email_enabled: boolean, sms_enabled: boolean, balance?: number | null, is_active?: boolean | null, is_unsubscribed: boolean, created_at: number, updated_at: number, client_phones?: Array<{ __typename?: 'ClientPhone', id: string, phone: string, country_code?: string | null, is_primary: boolean, is_chckup_primary: boolean, is_mobile: boolean, sms_available: boolean, is_unsubscribed: boolean, is_active: boolean, name?: string | null }> | null, client_emails?: Array<{ __typename?: 'ClientEmail', id: string, email: string, is_primary: boolean }> | null, clinic?: { __typename?: 'Clinic', id: string } | null, patients?: Array<{ __typename?: 'Patient', id: string, pms?: PracticeManagementSystem | null, pms_id?: string | null, name?: string | null, breed?: string | null, avatar_url?: string | null, last_appt_time?: number | null, gender?: string | null, fixed_status?: FixedStatus | null, weight?: number | null, birthday?: number | null, is_active?: boolean | null, is_deceased?: boolean | null, pms_created_at?: number | null, created_at: number, updated_at: number, owner?: { __typename?: 'Client', id: string, first_name?: string | null, last_name?: string | null, email?: string | null, phone?: string | null, address?: { __typename?: 'Address', country?: string | null } | null } | null, clinic_species?: { __typename?: 'ClinicSpecies', id: string, pms_id: string, description: string, is_primary: boolean, species: Species, weight_key: string, created_at: number, updated_at: number } | null, clinic?: { __typename?: 'Clinic', id: string } | null, clinic_breed?: { __typename?: 'Breed', id: string, description: string } | null, patient_vaccination_records?: Array<{ __typename?: 'PatientVaccinationRecord', id: string, vaccine_name?: string | null, manufacturer?: string | null, lot_number?: string | null, administered_date?: number | null, due_date?: number | null, rabies_tag?: string | null, is_rabies_vaccine?: boolean | null, is_soc: boolean, is_active: boolean, product?: { __typename?: 'Product', id: string, display_name?: string | null, name: string } | null }> | null, last_appointment?: { __typename?: 'Appointment', clinician?: { __typename?: 'Clinician', name: string, display_name?: string | null } | null } | null }> | null, address?: { __typename?: 'Address', street_a?: string | null, street_b?: string | null, city?: string | null, state?: string | null, zip?: string | null, country?: string | null } | null, user?: { __typename?: 'User', avatar_url?: string | null } | null, loyalty_members?: Array<{ __typename?: 'LoyaltyMember', id: string, available_points: number } | null> | null, settings?: { __typename?: 'ClientSettings', clinic_chckup_notifications_enabled: boolean, clinic_chckup_sms_enabled: boolean, clinic_chckup_email_enabled: boolean, client_chckup_notifications_enabled: boolean, client_chckup_sms_enabled: boolean, client_chckup_email_enabled: boolean, is_unsubscribed_from_marketing: boolean, is_unsubscribed_from_marketing_sms: boolean, is_unsubscribed_from_marketing_email: boolean } | null, last_appointment?: { __typename?: 'Appointment', clinician?: { __typename?: 'Clinician', name: string, display_name?: string | null } | null } | null } | null, clinician?: { __typename?: 'Clinician', id: string, name: string, display_name?: string | null, bio?: string | null, avatar_url?: string | null, initials?: string | null, excluded_species?: Array<Species> | null, excluded_service_ids?: Array<string> | null, authority_level?: AuthorityLevel | null, type: ResourceType, is_active?: boolean | null, is_assignable_in_pms?: boolean | null, does_contribute_to_fill_rate?: boolean | null, pms_id?: string | null, location?: string | null, pms_is_active: boolean, valid_booking_interval_minutes?: Array<number> | null, created_at: number, updated_at: number, clinic?: { __typename?: 'Clinic', id: string, name?: string | null } | null, pms_db?: { __typename?: 'PmsDb', id: string } | null, hours?: { __typename?: 'AvailabilityHours', monday?: Array<{ __typename?: 'TimeInterval', start?: number | null, end?: number | null }> | null, tuesday?: Array<{ __typename?: 'TimeInterval', start?: number | null, end?: number | null }> | null, wednesday?: Array<{ __typename?: 'TimeInterval', start?: number | null, end?: number | null }> | null, thursday?: Array<{ __typename?: 'TimeInterval', start?: number | null, end?: number | null }> | null, friday?: Array<{ __typename?: 'TimeInterval', start?: number | null, end?: number | null }> | null, saturday?: Array<{ __typename?: 'TimeInterval', start?: number | null, end?: number | null }> | null, sunday?: Array<{ __typename?: 'TimeInterval', start?: number | null, end?: number | null }> | null } | null, adjusted_availability?: Array<{ __typename?: 'Availability', date: number, pms_appt_type_pms_id?: string | null, times: Array<{ __typename?: 'TimeInterval', start?: number | null, end?: number | null }>, repeat?: { __typename?: 'RepeatAvailability', daysOfMonth?: Array<number> | null, daysOfWeek?: Array<DayOfWeek> | null, weekOfMonth?: WeekOfMonth | null, frequency: any, unit: RepeatUnit, end_date?: number | null } | null }> | null, pms_adjusted_availability?: Array<{ __typename?: 'Availability', date: number, pms_appt_type_pms_id?: string | null, times: Array<{ __typename?: 'TimeInterval', start?: number | null, end?: number | null }>, repeat?: { __typename?: 'RepeatAvailability', daysOfMonth?: Array<number> | null, daysOfWeek?: Array<DayOfWeek> | null, weekOfMonth?: WeekOfMonth | null, frequency: any, unit: RepeatUnit, end_date?: number | null } | null }> | null } | null, patient?: { __typename?: 'Patient', id: string, pms?: PracticeManagementSystem | null, pms_id?: string | null, name?: string | null, breed?: string | null, avatar_url?: string | null, last_appt_time?: number | null, gender?: string | null, fixed_status?: FixedStatus | null, weight?: number | null, birthday?: number | null, is_active?: boolean | null, is_deceased?: boolean | null, pms_created_at?: number | null, created_at: number, updated_at: number, owner?: { __typename?: 'Client', id: string, first_name?: string | null, last_name?: string | null, email?: string | null, phone?: string | null, address?: { __typename?: 'Address', country?: string | null } | null } | null, clinic_species?: { __typename?: 'ClinicSpecies', id: string, pms_id: string, description: string, is_primary: boolean, species: Species, weight_key: string, created_at: number, updated_at: number } | null, clinic?: { __typename?: 'Clinic', id: string } | null, clinic_breed?: { __typename?: 'Breed', id: string, description: string } | null, patient_vaccination_records?: Array<{ __typename?: 'PatientVaccinationRecord', id: string, vaccine_name?: string | null, manufacturer?: string | null, lot_number?: string | null, administered_date?: number | null, due_date?: number | null, rabies_tag?: string | null, is_rabies_vaccine?: boolean | null, is_soc: boolean, is_active: boolean, product?: { __typename?: 'Product', id: string, display_name?: string | null, name: string } | null }> | null, last_appointment?: { __typename?: 'Appointment', clinician?: { __typename?: 'Clinician', name: string, display_name?: string | null } | null } | null } | null, service?: { __typename?: 'Service', id: string, name?: string | null, order?: number | null, keywords?: string | null, service_types: Array<ServiceType>, is_active?: boolean | null, allow_new?: boolean | null, color?: string | null, description?: string | null, duration?: number | null, allow_returning?: boolean | null, max_per_day?: number | null, max_per_hour?: number | null, excluded_species?: Array<Species> | null, reserved_per_day?: number | null, authorized_levels?: Array<AuthorityLevel> | null, scheduling_buffer_minutes?: number | null, scheduling_min_minutes_away?: number | null, scheduling_max_minutes_away?: number | null, minimum_patient_age_in_days?: number | null, maximum_patient_age_in_days?: number | null, more_info?: string | null, more_info_action_required?: string | null, action_required_acknowledgement_text?: string | null, points: number, drop_off_time?: string | null, pick_up_time?: string | null, is_blocking: boolean, is_reschedule_allowed: boolean, is_cancellation_allowed: boolean, is_primary_for_appt_type: boolean, hide_clinician_preference: boolean, use_previous_doctor: boolean, allowed_appt_type_pms_ids?: Array<string> | null, valid_booking_interval_minutes?: Array<number> | null, only_use_adj_avail_guides: boolean, exclude_from_portal: boolean, created_at: number, updated_at: number, clinic?: { __typename?: 'Clinic', id: string, name?: string | null } | null, service_service_categories?: Array<{ __typename?: 'ServiceServiceCategory', service_category: { __typename?: 'ServiceCategory', id: string, order: number, icon?: ServiceCategoryIcon | null, title: string, description: string, requires_confirmation: boolean, confirmation_message?: string | null, created_at: number, updated_at: number } }> | null, pricing?: { __typename?: 'ServicePricing', price: any, currency: any, type: ServicePricingType, client_type?: ClientTypeEnum | null } | null, pms_appt_type?: { __typename?: 'PmsApptType', id: string, name: string, pms_id: string, description?: string | null, color?: any | null, pms_is_active: boolean } | null, required_room?: { __typename?: 'Room', id: string, pms_id: string, name: string, display_name?: string | null, description?: string | null, concurrent_patients?: number | null, is_active: boolean, does_contribute_to_fill_rate?: boolean | null, valid_booking_interval_minutes?: Array<number> | null, created_at: number, updated_at: number, clinic?: { __typename?: 'Clinic', pms: PracticeManagementSystem, id: string, name?: string | null, time_zone?: string | null } | null, hours?: { __typename?: 'AvailabilityHours', monday?: Array<{ __typename?: 'TimeInterval', start?: number | null, end?: number | null }> | null, tuesday?: Array<{ __typename?: 'TimeInterval', start?: number | null, end?: number | null }> | null, wednesday?: Array<{ __typename?: 'TimeInterval', start?: number | null, end?: number | null }> | null, thursday?: Array<{ __typename?: 'TimeInterval', start?: number | null, end?: number | null }> | null, friday?: Array<{ __typename?: 'TimeInterval', start?: number | null, end?: number | null }> | null, saturday?: Array<{ __typename?: 'TimeInterval', start?: number | null, end?: number | null }> | null, sunday?: Array<{ __typename?: 'TimeInterval', start?: number | null, end?: number | null }> | null } | null, adjusted_availability?: Array<{ __typename?: 'Availability', date: number, pms_appt_type_pms_id?: string | null, times: Array<{ __typename?: 'TimeInterval', start?: number | null, end?: number | null }>, repeat?: { __typename?: 'RepeatAvailability', daysOfMonth?: Array<number> | null, daysOfWeek?: Array<DayOfWeek> | null, weekOfMonth?: WeekOfMonth | null, frequency: any, unit: RepeatUnit, end_date?: number | null } | null }> | null, pms_adjusted_availability?: Array<{ __typename?: 'Availability', date: number, pms_appt_type_pms_id?: string | null, times: Array<{ __typename?: 'TimeInterval', start?: number | null, end?: number | null }>, repeat?: { __typename?: 'RepeatAvailability', daysOfMonth?: Array<number> | null, daysOfWeek?: Array<DayOfWeek> | null, weekOfMonth?: WeekOfMonth | null, frequency: any, unit: RepeatUnit, end_date?: number | null } | null }> | null } | null, default_room?: { __typename?: 'Room', id: string, pms_id: string, name: string, display_name?: string | null, description?: string | null, concurrent_patients?: number | null, is_active: boolean, does_contribute_to_fill_rate?: boolean | null, valid_booking_interval_minutes?: Array<number> | null, created_at: number, updated_at: number, clinic?: { __typename?: 'Clinic', pms: PracticeManagementSystem, id: string, name?: string | null, time_zone?: string | null } | null, hours?: { __typename?: 'AvailabilityHours', monday?: Array<{ __typename?: 'TimeInterval', start?: number | null, end?: number | null }> | null, tuesday?: Array<{ __typename?: 'TimeInterval', start?: number | null, end?: number | null }> | null, wednesday?: Array<{ __typename?: 'TimeInterval', start?: number | null, end?: number | null }> | null, thursday?: Array<{ __typename?: 'TimeInterval', start?: number | null, end?: number | null }> | null, friday?: Array<{ __typename?: 'TimeInterval', start?: number | null, end?: number | null }> | null, saturday?: Array<{ __typename?: 'TimeInterval', start?: number | null, end?: number | null }> | null, sunday?: Array<{ __typename?: 'TimeInterval', start?: number | null, end?: number | null }> | null } | null, adjusted_availability?: Array<{ __typename?: 'Availability', date: number, pms_appt_type_pms_id?: string | null, times: Array<{ __typename?: 'TimeInterval', start?: number | null, end?: number | null }>, repeat?: { __typename?: 'RepeatAvailability', daysOfMonth?: Array<number> | null, daysOfWeek?: Array<DayOfWeek> | null, weekOfMonth?: WeekOfMonth | null, frequency: any, unit: RepeatUnit, end_date?: number | null } | null }> | null, pms_adjusted_availability?: Array<{ __typename?: 'Availability', date: number, pms_appt_type_pms_id?: string | null, times: Array<{ __typename?: 'TimeInterval', start?: number | null, end?: number | null }>, repeat?: { __typename?: 'RepeatAvailability', daysOfMonth?: Array<number> | null, daysOfWeek?: Array<DayOfWeek> | null, weekOfMonth?: WeekOfMonth | null, frequency: any, unit: RepeatUnit, end_date?: number | null } | null }> | null } | null, availability?: { __typename?: 'AvailabilityHours', monday?: Array<{ __typename?: 'TimeInterval', start?: number | null, end?: number | null }> | null, tuesday?: Array<{ __typename?: 'TimeInterval', start?: number | null, end?: number | null }> | null, wednesday?: Array<{ __typename?: 'TimeInterval', start?: number | null, end?: number | null }> | null, thursday?: Array<{ __typename?: 'TimeInterval', start?: number | null, end?: number | null }> | null, friday?: Array<{ __typename?: 'TimeInterval', start?: number | null, end?: number | null }> | null, saturday?: Array<{ __typename?: 'TimeInterval', start?: number | null, end?: number | null }> | null, sunday?: Array<{ __typename?: 'TimeInterval', start?: number | null, end?: number | null }> | null } | null, drop_off_hours?: { __typename?: 'AvailabilityHours', monday?: Array<{ __typename?: 'TimeInterval', start?: number | null, end?: number | null }> | null, tuesday?: Array<{ __typename?: 'TimeInterval', start?: number | null, end?: number | null }> | null, wednesday?: Array<{ __typename?: 'TimeInterval', start?: number | null, end?: number | null }> | null, thursday?: Array<{ __typename?: 'TimeInterval', start?: number | null, end?: number | null }> | null, friday?: Array<{ __typename?: 'TimeInterval', start?: number | null, end?: number | null }> | null, saturday?: Array<{ __typename?: 'TimeInterval', start?: number | null, end?: number | null }> | null, sunday?: Array<{ __typename?: 'TimeInterval', start?: number | null, end?: number | null }> | null } | null, pre_confirmation_checklist?: Array<{ __typename?: 'ServicePreConfirmationItem', title: string, description?: string | null, required?: boolean | null }> | null } | null } };

export type AppointmentBaseFieldsFragment = { __typename?: 'Appointment', id: string };

export type AppointmentPreviewFieldsFragment = { __typename?: 'Appointment', id: string, service_name?: string | null, status: AppointmentStatus, start_time: number, drop_off_time?: number | null, minutes: number, service?: { __typename?: 'Service', name?: string | null } | null, clinician?: { __typename?: 'Clinician', name: string, display_name?: string | null } | null, client?: { __typename?: 'Client', first_name?: string | null, last_name?: string | null } | null, patient?: { __typename?: 'Patient', name?: string | null } | null };

export type AppointmentDailyHuddleFieldsFragment = { __typename?: 'Appointment', id: string, pms_id?: string | null, status: AppointmentStatus, service_name?: string | null, start_time: number, drop_off_time?: number | null, minutes: number, is_deleted?: boolean | null, is_time_block?: boolean | null, is_new_patient?: boolean | null, is_new_client?: boolean | null, is_confirmed?: boolean | null, new_patient_species?: string | null, reason_for_cancellation?: string | null, client_reason_for_cancellation?: string | null, confirmed_at?: number | null, is_clinician_auto_assigned?: boolean | null, client_notes?: string | null, clinic_notes?: string | null, referring_clinic_name?: string | null, widget_source?: string | null, from_widget?: string | null, pms_created_at?: number | null, clinic_appt_status?: { __typename?: 'ClinicApptStatus', id: string, status: AppointmentStatus, description: string } | null, service?: { __typename?: 'Service', id: string, color?: string | null, name?: string | null } | null, clinician?: { __typename?: 'Clinician', id: string, name: string, display_name?: string | null } | null, room?: { __typename?: 'Room', id: string, name: string } | null, clinic?: { __typename?: 'Clinic', id: string, name?: string | null, slug?: string | null, pms_db?: { __typename?: 'PmsDb', id: string } | null } | null, client?: { __typename?: 'Client', id: string, first_name?: string | null, last_name?: string | null, email?: string | null, phone?: string | null, is_active?: boolean | null, address?: { __typename?: 'Address', street_a?: string | null, country?: string | null } | null } | null, patient?: { __typename?: 'Patient', id: string, pms_id?: string | null, name?: string | null, breed?: string | null, is_active?: boolean | null, is_deceased?: boolean | null, avatar_url?: string | null, gender?: string | null, fixed_status?: FixedStatus | null, birthday?: number | null, weight?: number | null, owner?: { __typename?: 'Client', id: string, first_name?: string | null, last_name?: string | null, secondary_first_name?: string | null, secondary_last_name?: string | null, phone?: string | null, email?: string | null } | null, clinic_species?: { __typename?: 'ClinicSpecies', id: string, species: Species, description: string, weight_key: string } | null, clinic_breed?: { __typename?: 'Breed', id: string, description: string } | null } | null, widget?: { __typename?: 'Widget', id: string, widget_name: string } | null };

export type AppointmentDailyHuddleUserTrackingFieldsFragment = { __typename?: 'Appointment', client?: { __typename?: 'Client', id: string, has_portal_account: boolean, has_mobile_app: boolean } | null };

export type AppointmentSchedulePreviewFieldsFragment = { __typename?: 'Appointment', id: string, service_name?: string | null, reason_for_cancellation?: string | null, start_time: number, drop_off_time?: number | null, minutes: number, client_notes?: string | null, status: AppointmentStatus, is_deleted?: boolean | null, is_time_block?: boolean | null, is_clinician_auto_assigned?: boolean | null, client_pms_id?: string | null, patient_pms_id?: string | null, is_new_client?: boolean | null, is_new_patient?: boolean | null, new_client_name?: string | null, new_client_phone?: string | null, new_patient_name?: string | null, pms_created_at?: number | null, service?: { __typename?: 'Service', id: string, color?: string | null, name?: string | null } | null, clinician?: { __typename?: 'Clinician', id: string, name: string, display_name?: string | null, pms_id?: string | null } | null, room?: { __typename?: 'Room', id: string, name: string } | null, client?: { __typename?: 'Client', id: string, first_name?: string | null, last_name?: string | null, email?: string | null, phone?: string | null } | null, patient?: { __typename?: 'Patient', id: string, name?: string | null, avatar_url?: string | null, clinic_breed?: { __typename?: 'Breed', id: string, description: string } | null } | null, clinic?: { __typename?: 'Clinic', address?: { __typename?: 'Address', country?: string | null } | null } | null, clinic_appt_status?: { __typename?: 'ClinicApptStatus', id: string, description: string, status: AppointmentStatus } | null };

export type AppointmentFieldsFragment = { __typename?: 'Appointment', id: string, pms?: PracticeManagementSystem | null, client_pms_id?: string | null, is_new_client?: boolean | null, start_time: number, drop_off_time?: number | null, minutes: number, is_new_patient?: boolean | null, is_clinician_auto_assigned?: boolean | null, patient_pms_id?: string | null, referring_clinic_name?: string | null, client_notes?: string | null, clinic_notes?: string | null, service_name?: string | null, status: AppointmentStatus, is_time_block?: boolean | null, is_confirmed?: boolean | null, origin?: EntityOrigin | null, reason_for_cancellation?: string | null, client_reason_for_cancellation?: string | null, new_client_name?: string | null, new_client_phone?: string | null, new_patient_name?: string | null, new_patient_species?: string | null, confirmed_at?: number | null, widget_source?: string | null, from_widget?: string | null, is_deleted?: boolean | null, created_at: number, updated_at: number, pms_created_at?: number | null, clinic?: { __typename?: 'Clinic', id: string, name?: string | null, slug?: string | null, pms_db?: { __typename?: 'PmsDb', id: string } | null, address?: { __typename?: 'Address', country?: string | null } | null } | null, client?: { __typename?: 'Client', id: string, first_name?: string | null, last_name?: string | null, secondary_first_name?: string | null, secondary_last_name?: string | null, phone?: string | null, email?: string | null, pms?: PracticeManagementSystem | null, pms_id?: string | null, last_appt_time?: number | null, last_contact_time?: number | null, email_enabled: boolean, sms_enabled: boolean, balance?: number | null, is_active?: boolean | null, is_unsubscribed: boolean, created_at: number, updated_at: number, client_phones?: Array<{ __typename?: 'ClientPhone', id: string, phone: string, country_code?: string | null, is_primary: boolean, is_chckup_primary: boolean, is_mobile: boolean, sms_available: boolean, is_unsubscribed: boolean, is_active: boolean, name?: string | null }> | null, client_emails?: Array<{ __typename?: 'ClientEmail', id: string, email: string, is_primary: boolean }> | null, clinic?: { __typename?: 'Clinic', id: string } | null, patients?: Array<{ __typename?: 'Patient', id: string, pms?: PracticeManagementSystem | null, pms_id?: string | null, name?: string | null, breed?: string | null, avatar_url?: string | null, last_appt_time?: number | null, gender?: string | null, fixed_status?: FixedStatus | null, weight?: number | null, birthday?: number | null, is_active?: boolean | null, is_deceased?: boolean | null, pms_created_at?: number | null, created_at: number, updated_at: number, owner?: { __typename?: 'Client', id: string, first_name?: string | null, last_name?: string | null, email?: string | null, phone?: string | null, address?: { __typename?: 'Address', country?: string | null } | null } | null, clinic_species?: { __typename?: 'ClinicSpecies', id: string, pms_id: string, description: string, is_primary: boolean, species: Species, weight_key: string, created_at: number, updated_at: number } | null, clinic?: { __typename?: 'Clinic', id: string } | null, clinic_breed?: { __typename?: 'Breed', id: string, description: string } | null, patient_vaccination_records?: Array<{ __typename?: 'PatientVaccinationRecord', id: string, vaccine_name?: string | null, manufacturer?: string | null, lot_number?: string | null, administered_date?: number | null, due_date?: number | null, rabies_tag?: string | null, is_rabies_vaccine?: boolean | null, is_soc: boolean, is_active: boolean, product?: { __typename?: 'Product', id: string, display_name?: string | null, name: string } | null }> | null, last_appointment?: { __typename?: 'Appointment', clinician?: { __typename?: 'Clinician', name: string, display_name?: string | null } | null } | null }> | null, address?: { __typename?: 'Address', street_a?: string | null, street_b?: string | null, city?: string | null, state?: string | null, zip?: string | null, country?: string | null } | null, user?: { __typename?: 'User', avatar_url?: string | null } | null, loyalty_members?: Array<{ __typename?: 'LoyaltyMember', id: string, available_points: number } | null> | null, settings?: { __typename?: 'ClientSettings', clinic_chckup_notifications_enabled: boolean, clinic_chckup_sms_enabled: boolean, clinic_chckup_email_enabled: boolean, client_chckup_notifications_enabled: boolean, client_chckup_sms_enabled: boolean, client_chckup_email_enabled: boolean, is_unsubscribed_from_marketing: boolean, is_unsubscribed_from_marketing_sms: boolean, is_unsubscribed_from_marketing_email: boolean } | null, last_appointment?: { __typename?: 'Appointment', clinician?: { __typename?: 'Clinician', name: string, display_name?: string | null } | null } | null } | null, clinician?: { __typename?: 'Clinician', id: string, name: string, display_name?: string | null, bio?: string | null, avatar_url?: string | null, initials?: string | null, excluded_species?: Array<Species> | null, excluded_service_ids?: Array<string> | null, authority_level?: AuthorityLevel | null, type: ResourceType, is_active?: boolean | null, is_assignable_in_pms?: boolean | null, does_contribute_to_fill_rate?: boolean | null, pms_id?: string | null, location?: string | null, pms_is_active: boolean, valid_booking_interval_minutes?: Array<number> | null, created_at: number, updated_at: number, clinic?: { __typename?: 'Clinic', id: string, name?: string | null } | null, pms_db?: { __typename?: 'PmsDb', id: string } | null, hours?: { __typename?: 'AvailabilityHours', monday?: Array<{ __typename?: 'TimeInterval', start?: number | null, end?: number | null }> | null, tuesday?: Array<{ __typename?: 'TimeInterval', start?: number | null, end?: number | null }> | null, wednesday?: Array<{ __typename?: 'TimeInterval', start?: number | null, end?: number | null }> | null, thursday?: Array<{ __typename?: 'TimeInterval', start?: number | null, end?: number | null }> | null, friday?: Array<{ __typename?: 'TimeInterval', start?: number | null, end?: number | null }> | null, saturday?: Array<{ __typename?: 'TimeInterval', start?: number | null, end?: number | null }> | null, sunday?: Array<{ __typename?: 'TimeInterval', start?: number | null, end?: number | null }> | null } | null, adjusted_availability?: Array<{ __typename?: 'Availability', date: number, pms_appt_type_pms_id?: string | null, times: Array<{ __typename?: 'TimeInterval', start?: number | null, end?: number | null }>, repeat?: { __typename?: 'RepeatAvailability', daysOfMonth?: Array<number> | null, daysOfWeek?: Array<DayOfWeek> | null, weekOfMonth?: WeekOfMonth | null, frequency: any, unit: RepeatUnit, end_date?: number | null } | null }> | null, pms_adjusted_availability?: Array<{ __typename?: 'Availability', date: number, pms_appt_type_pms_id?: string | null, times: Array<{ __typename?: 'TimeInterval', start?: number | null, end?: number | null }>, repeat?: { __typename?: 'RepeatAvailability', daysOfMonth?: Array<number> | null, daysOfWeek?: Array<DayOfWeek> | null, weekOfMonth?: WeekOfMonth | null, frequency: any, unit: RepeatUnit, end_date?: number | null } | null }> | null } | null, room?: { __typename?: 'Room', id: string, pms_id: string, name: string, display_name?: string | null, description?: string | null, concurrent_patients?: number | null, is_active: boolean, does_contribute_to_fill_rate?: boolean | null, valid_booking_interval_minutes?: Array<number> | null, created_at: number, updated_at: number, clinic?: { __typename?: 'Clinic', pms: PracticeManagementSystem, id: string, name?: string | null, time_zone?: string | null } | null, hours?: { __typename?: 'AvailabilityHours', monday?: Array<{ __typename?: 'TimeInterval', start?: number | null, end?: number | null }> | null, tuesday?: Array<{ __typename?: 'TimeInterval', start?: number | null, end?: number | null }> | null, wednesday?: Array<{ __typename?: 'TimeInterval', start?: number | null, end?: number | null }> | null, thursday?: Array<{ __typename?: 'TimeInterval', start?: number | null, end?: number | null }> | null, friday?: Array<{ __typename?: 'TimeInterval', start?: number | null, end?: number | null }> | null, saturday?: Array<{ __typename?: 'TimeInterval', start?: number | null, end?: number | null }> | null, sunday?: Array<{ __typename?: 'TimeInterval', start?: number | null, end?: number | null }> | null } | null, adjusted_availability?: Array<{ __typename?: 'Availability', date: number, pms_appt_type_pms_id?: string | null, times: Array<{ __typename?: 'TimeInterval', start?: number | null, end?: number | null }>, repeat?: { __typename?: 'RepeatAvailability', daysOfMonth?: Array<number> | null, daysOfWeek?: Array<DayOfWeek> | null, weekOfMonth?: WeekOfMonth | null, frequency: any, unit: RepeatUnit, end_date?: number | null } | null }> | null, pms_adjusted_availability?: Array<{ __typename?: 'Availability', date: number, pms_appt_type_pms_id?: string | null, times: Array<{ __typename?: 'TimeInterval', start?: number | null, end?: number | null }>, repeat?: { __typename?: 'RepeatAvailability', daysOfMonth?: Array<number> | null, daysOfWeek?: Array<DayOfWeek> | null, weekOfMonth?: WeekOfMonth | null, frequency: any, unit: RepeatUnit, end_date?: number | null } | null }> | null } | null, service?: { __typename?: 'Service', id: string, name?: string | null, color?: string | null } | null, patient?: { __typename?: 'Patient', id: string, pms?: PracticeManagementSystem | null, pms_id?: string | null, name?: string | null, breed?: string | null, avatar_url?: string | null, last_appt_time?: number | null, gender?: string | null, fixed_status?: FixedStatus | null, weight?: number | null, birthday?: number | null, is_active?: boolean | null, is_deceased?: boolean | null, pms_created_at?: number | null, created_at: number, updated_at: number, owner?: { __typename?: 'Client', id: string, first_name?: string | null, last_name?: string | null, email?: string | null, phone?: string | null, address?: { __typename?: 'Address', country?: string | null } | null } | null, clinic_species?: { __typename?: 'ClinicSpecies', id: string, pms_id: string, description: string, is_primary: boolean, species: Species, weight_key: string, created_at: number, updated_at: number } | null, clinic?: { __typename?: 'Clinic', id: string } | null, clinic_breed?: { __typename?: 'Breed', id: string, description: string } | null, patient_vaccination_records?: Array<{ __typename?: 'PatientVaccinationRecord', id: string, vaccine_name?: string | null, manufacturer?: string | null, lot_number?: string | null, administered_date?: number | null, due_date?: number | null, rabies_tag?: string | null, is_rabies_vaccine?: boolean | null, is_soc: boolean, is_active: boolean, product?: { __typename?: 'Product', id: string, display_name?: string | null, name: string } | null }> | null, last_appointment?: { __typename?: 'Appointment', clinician?: { __typename?: 'Clinician', name: string, display_name?: string | null } | null } | null } | null, clinic_appt_status?: { __typename?: 'ClinicApptStatus', id: string, description: string, status: AppointmentStatus } | null, client_info?: { __typename?: 'ClientInfo', first_name?: string | null, last_name?: string | null, email?: string | null, phone?: string | null } | null, patient_info?: { __typename?: 'PatientInfo', patient_name?: string | null, patient_breed?: string | null, patient_clinic_species?: string | null, patient_clinic_breed?: string | null } | null, clients_forms?: Array<{ __typename?: 'ClientForm', id: string, client_completed_at?: number | null, clinic_verified_at?: number | null, is_archived: boolean, pms_id?: string | null, created_at: number, updated_at: number, client?: { __typename?: 'Client', id: string, first_name?: string | null, last_name?: string | null, phone?: string | null, email?: string | null, address?: { __typename?: 'Address', street_a?: string | null, city?: string | null, state?: string | null, zip?: string | null, country?: string | null } | null } | null, patient?: { __typename?: 'Patient', id: string, name?: string | null, is_active?: boolean | null, is_deceased?: boolean | null, birthday?: number | null, weight?: number | null, avatar_url?: string | null, gender?: string | null, owner?: { __typename?: 'Client', first_name?: string | null, last_name?: string | null } | null, clinic_species?: { __typename?: 'ClinicSpecies', id: string, species: Species, description: string, weight_key: string } | null, clinic_breed?: { __typename?: 'Breed', id: string, description: string } | null } | null, form: { __typename?: 'Form', id: string, name?: string | null, form_type: FormType, is_writeback_enabled: boolean, form_file_naming_template?: string | null }, form_data: { __typename?: 'FormFields', pages?: Array<{ __typename?: 'FormPage', id: string, title?: string | null, description?: string | null, order?: number | null }> | null, fields?: Array<{ __typename?: 'FormElement', id: string, type?: FormElementType | null, content?: string | null, name?: string | null, column_order?: number | null, row_order?: number | null, page_id?: string | null, options?: Array<string> | null, is_required?: boolean | null, value?: string | null, attachments?: Array<{ __typename?: 'FormFileAttachment', id?: string | null, filename?: string | null, mime_type?: string | null, size_bytes?: number | null, thumbnail_url?: string | null, url: string }> | null, field_updates?: Array<{ __typename?: 'FormFieldUpdate', field: FormFieldUpdateField, boolean_value?: boolean | null, option?: string | null }> | null }> | null }, appointment?: { __typename?: 'Appointment', start_time: number, drop_off_time?: number | null, clinic?: { __typename?: 'Clinic', name?: string | null, slug?: string | null, phone?: string | null, email?: string | null, address?: { __typename?: 'Address', street_a?: string | null, city?: string | null, state?: string | null, zip?: string | null, country?: string | null } | null } | null, clinician?: { __typename?: 'Clinician', name: string, display_name?: string | null } | null, service?: { __typename?: 'Service', name?: string | null } | null } | null }> | null, widget?: { __typename?: 'Widget', id: string, widget_name: string } | null };

export type PublicAppointmentTimeFieldsFragment = { __typename?: 'PublicAppointmentTime', start_time: number, minutes: number, clinician_id?: string | null, room_id?: string | null, is_time_block?: boolean | null };

export type TimeSlotClinicianFieldsFragment = { __typename?: 'Clinician', id: string, name: string };

export type TimeSlotFieldsFragment = { __typename?: 'OpenSlot', start_time: number, clinicians: Array<{ __typename?: 'Clinician', id: string, name: string }> };

export type ClientInfoFieldsFragment = { __typename?: 'ClientInfo', first_name?: string | null, last_name?: string | null, email?: string | null, phone?: string | null };

export type PatientInfoFieldsFragment = { __typename?: 'PatientInfo', patient_name?: string | null, patient_breed?: string | null, patient_clinic_species?: string | null, patient_clinic_breed?: string | null };

export type TimeSlotSchedulingFieldsFragment = { __typename?: 'TimeSlot', start_time: number, display_time?: number | null, selections: Array<{ __typename?: 'TimeSlotSelection', service_id?: string | null, clinicians: Array<{ __typename?: 'Clinician', id: string, name: string }>, rooms: Array<{ __typename?: 'Room', id: string, name: string }> }> };

export type GetPublicAppointmentTimesQueryVariables = Exact<{
  searchInput: SearchAppointmentsInput;
}>;


export type GetPublicAppointmentTimesQuery = { __typename?: 'Query', publicAppointmentTimes?: Array<{ __typename?: 'PublicAppointmentTime', start_time: number, minutes: number, clinician_id?: string | null, room_id?: string | null, is_time_block?: boolean | null }> | null };

export type GetAppointmentQueryVariables = Exact<{
  id: Scalars['ID']['input'];
}>;


export type GetAppointmentQuery = { __typename?: 'Query', appointment: { __typename?: 'Appointment', id: string, pms?: PracticeManagementSystem | null, client_pms_id?: string | null, is_new_client?: boolean | null, start_time: number, drop_off_time?: number | null, minutes: number, is_new_patient?: boolean | null, is_clinician_auto_assigned?: boolean | null, patient_pms_id?: string | null, referring_clinic_name?: string | null, client_notes?: string | null, clinic_notes?: string | null, service_name?: string | null, status: AppointmentStatus, is_time_block?: boolean | null, is_confirmed?: boolean | null, origin?: EntityOrigin | null, reason_for_cancellation?: string | null, client_reason_for_cancellation?: string | null, new_client_name?: string | null, new_client_phone?: string | null, new_patient_name?: string | null, new_patient_species?: string | null, confirmed_at?: number | null, widget_source?: string | null, from_widget?: string | null, is_deleted?: boolean | null, created_at: number, updated_at: number, pms_created_at?: number | null, clinic?: { __typename?: 'Clinic', id: string, name?: string | null, slug?: string | null, pms_db?: { __typename?: 'PmsDb', id: string } | null, address?: { __typename?: 'Address', country?: string | null } | null } | null, client?: { __typename?: 'Client', id: string, first_name?: string | null, last_name?: string | null, secondary_first_name?: string | null, secondary_last_name?: string | null, phone?: string | null, email?: string | null, pms?: PracticeManagementSystem | null, pms_id?: string | null, last_appt_time?: number | null, last_contact_time?: number | null, email_enabled: boolean, sms_enabled: boolean, balance?: number | null, is_active?: boolean | null, is_unsubscribed: boolean, created_at: number, updated_at: number, client_phones?: Array<{ __typename?: 'ClientPhone', id: string, phone: string, country_code?: string | null, is_primary: boolean, is_chckup_primary: boolean, is_mobile: boolean, sms_available: boolean, is_unsubscribed: boolean, is_active: boolean, name?: string | null }> | null, client_emails?: Array<{ __typename?: 'ClientEmail', id: string, email: string, is_primary: boolean }> | null, clinic?: { __typename?: 'Clinic', id: string } | null, patients?: Array<{ __typename?: 'Patient', id: string, pms?: PracticeManagementSystem | null, pms_id?: string | null, name?: string | null, breed?: string | null, avatar_url?: string | null, last_appt_time?: number | null, gender?: string | null, fixed_status?: FixedStatus | null, weight?: number | null, birthday?: number | null, is_active?: boolean | null, is_deceased?: boolean | null, pms_created_at?: number | null, created_at: number, updated_at: number, owner?: { __typename?: 'Client', id: string, first_name?: string | null, last_name?: string | null, email?: string | null, phone?: string | null, address?: { __typename?: 'Address', country?: string | null } | null } | null, clinic_species?: { __typename?: 'ClinicSpecies', id: string, pms_id: string, description: string, is_primary: boolean, species: Species, weight_key: string, created_at: number, updated_at: number } | null, clinic?: { __typename?: 'Clinic', id: string } | null, clinic_breed?: { __typename?: 'Breed', id: string, description: string } | null, patient_vaccination_records?: Array<{ __typename?: 'PatientVaccinationRecord', id: string, vaccine_name?: string | null, manufacturer?: string | null, lot_number?: string | null, administered_date?: number | null, due_date?: number | null, rabies_tag?: string | null, is_rabies_vaccine?: boolean | null, is_soc: boolean, is_active: boolean, product?: { __typename?: 'Product', id: string, display_name?: string | null, name: string } | null }> | null, last_appointment?: { __typename?: 'Appointment', clinician?: { __typename?: 'Clinician', name: string, display_name?: string | null } | null } | null }> | null, address?: { __typename?: 'Address', street_a?: string | null, street_b?: string | null, city?: string | null, state?: string | null, zip?: string | null, country?: string | null } | null, user?: { __typename?: 'User', avatar_url?: string | null } | null, loyalty_members?: Array<{ __typename?: 'LoyaltyMember', id: string, available_points: number } | null> | null, settings?: { __typename?: 'ClientSettings', clinic_chckup_notifications_enabled: boolean, clinic_chckup_sms_enabled: boolean, clinic_chckup_email_enabled: boolean, client_chckup_notifications_enabled: boolean, client_chckup_sms_enabled: boolean, client_chckup_email_enabled: boolean, is_unsubscribed_from_marketing: boolean, is_unsubscribed_from_marketing_sms: boolean, is_unsubscribed_from_marketing_email: boolean } | null, last_appointment?: { __typename?: 'Appointment', clinician?: { __typename?: 'Clinician', name: string, display_name?: string | null } | null } | null } | null, clinician?: { __typename?: 'Clinician', id: string, name: string, display_name?: string | null, bio?: string | null, avatar_url?: string | null, initials?: string | null, excluded_species?: Array<Species> | null, excluded_service_ids?: Array<string> | null, authority_level?: AuthorityLevel | null, type: ResourceType, is_active?: boolean | null, is_assignable_in_pms?: boolean | null, does_contribute_to_fill_rate?: boolean | null, pms_id?: string | null, location?: string | null, pms_is_active: boolean, valid_booking_interval_minutes?: Array<number> | null, created_at: number, updated_at: number, clinic?: { __typename?: 'Clinic', id: string, name?: string | null } | null, pms_db?: { __typename?: 'PmsDb', id: string } | null, hours?: { __typename?: 'AvailabilityHours', monday?: Array<{ __typename?: 'TimeInterval', start?: number | null, end?: number | null }> | null, tuesday?: Array<{ __typename?: 'TimeInterval', start?: number | null, end?: number | null }> | null, wednesday?: Array<{ __typename?: 'TimeInterval', start?: number | null, end?: number | null }> | null, thursday?: Array<{ __typename?: 'TimeInterval', start?: number | null, end?: number | null }> | null, friday?: Array<{ __typename?: 'TimeInterval', start?: number | null, end?: number | null }> | null, saturday?: Array<{ __typename?: 'TimeInterval', start?: number | null, end?: number | null }> | null, sunday?: Array<{ __typename?: 'TimeInterval', start?: number | null, end?: number | null }> | null } | null, adjusted_availability?: Array<{ __typename?: 'Availability', date: number, pms_appt_type_pms_id?: string | null, times: Array<{ __typename?: 'TimeInterval', start?: number | null, end?: number | null }>, repeat?: { __typename?: 'RepeatAvailability', daysOfMonth?: Array<number> | null, daysOfWeek?: Array<DayOfWeek> | null, weekOfMonth?: WeekOfMonth | null, frequency: any, unit: RepeatUnit, end_date?: number | null } | null }> | null, pms_adjusted_availability?: Array<{ __typename?: 'Availability', date: number, pms_appt_type_pms_id?: string | null, times: Array<{ __typename?: 'TimeInterval', start?: number | null, end?: number | null }>, repeat?: { __typename?: 'RepeatAvailability', daysOfMonth?: Array<number> | null, daysOfWeek?: Array<DayOfWeek> | null, weekOfMonth?: WeekOfMonth | null, frequency: any, unit: RepeatUnit, end_date?: number | null } | null }> | null } | null, room?: { __typename?: 'Room', id: string, pms_id: string, name: string, display_name?: string | null, description?: string | null, concurrent_patients?: number | null, is_active: boolean, does_contribute_to_fill_rate?: boolean | null, valid_booking_interval_minutes?: Array<number> | null, created_at: number, updated_at: number, clinic?: { __typename?: 'Clinic', pms: PracticeManagementSystem, id: string, name?: string | null, time_zone?: string | null } | null, hours?: { __typename?: 'AvailabilityHours', monday?: Array<{ __typename?: 'TimeInterval', start?: number | null, end?: number | null }> | null, tuesday?: Array<{ __typename?: 'TimeInterval', start?: number | null, end?: number | null }> | null, wednesday?: Array<{ __typename?: 'TimeInterval', start?: number | null, end?: number | null }> | null, thursday?: Array<{ __typename?: 'TimeInterval', start?: number | null, end?: number | null }> | null, friday?: Array<{ __typename?: 'TimeInterval', start?: number | null, end?: number | null }> | null, saturday?: Array<{ __typename?: 'TimeInterval', start?: number | null, end?: number | null }> | null, sunday?: Array<{ __typename?: 'TimeInterval', start?: number | null, end?: number | null }> | null } | null, adjusted_availability?: Array<{ __typename?: 'Availability', date: number, pms_appt_type_pms_id?: string | null, times: Array<{ __typename?: 'TimeInterval', start?: number | null, end?: number | null }>, repeat?: { __typename?: 'RepeatAvailability', daysOfMonth?: Array<number> | null, daysOfWeek?: Array<DayOfWeek> | null, weekOfMonth?: WeekOfMonth | null, frequency: any, unit: RepeatUnit, end_date?: number | null } | null }> | null, pms_adjusted_availability?: Array<{ __typename?: 'Availability', date: number, pms_appt_type_pms_id?: string | null, times: Array<{ __typename?: 'TimeInterval', start?: number | null, end?: number | null }>, repeat?: { __typename?: 'RepeatAvailability', daysOfMonth?: Array<number> | null, daysOfWeek?: Array<DayOfWeek> | null, weekOfMonth?: WeekOfMonth | null, frequency: any, unit: RepeatUnit, end_date?: number | null } | null }> | null } | null, service?: { __typename?: 'Service', id: string, name?: string | null, color?: string | null } | null, patient?: { __typename?: 'Patient', id: string, pms?: PracticeManagementSystem | null, pms_id?: string | null, name?: string | null, breed?: string | null, avatar_url?: string | null, last_appt_time?: number | null, gender?: string | null, fixed_status?: FixedStatus | null, weight?: number | null, birthday?: number | null, is_active?: boolean | null, is_deceased?: boolean | null, pms_created_at?: number | null, created_at: number, updated_at: number, owner?: { __typename?: 'Client', id: string, first_name?: string | null, last_name?: string | null, email?: string | null, phone?: string | null, address?: { __typename?: 'Address', country?: string | null } | null } | null, clinic_species?: { __typename?: 'ClinicSpecies', id: string, pms_id: string, description: string, is_primary: boolean, species: Species, weight_key: string, created_at: number, updated_at: number } | null, clinic?: { __typename?: 'Clinic', id: string } | null, clinic_breed?: { __typename?: 'Breed', id: string, description: string } | null, patient_vaccination_records?: Array<{ __typename?: 'PatientVaccinationRecord', id: string, vaccine_name?: string | null, manufacturer?: string | null, lot_number?: string | null, administered_date?: number | null, due_date?: number | null, rabies_tag?: string | null, is_rabies_vaccine?: boolean | null, is_soc: boolean, is_active: boolean, product?: { __typename?: 'Product', id: string, display_name?: string | null, name: string } | null }> | null, last_appointment?: { __typename?: 'Appointment', clinician?: { __typename?: 'Clinician', name: string, display_name?: string | null } | null } | null } | null, clinic_appt_status?: { __typename?: 'ClinicApptStatus', id: string, description: string, status: AppointmentStatus } | null, client_info?: { __typename?: 'ClientInfo', first_name?: string | null, last_name?: string | null, email?: string | null, phone?: string | null } | null, patient_info?: { __typename?: 'PatientInfo', patient_name?: string | null, patient_breed?: string | null, patient_clinic_species?: string | null, patient_clinic_breed?: string | null } | null, clients_forms?: Array<{ __typename?: 'ClientForm', id: string, client_completed_at?: number | null, clinic_verified_at?: number | null, is_archived: boolean, pms_id?: string | null, created_at: number, updated_at: number, client?: { __typename?: 'Client', id: string, first_name?: string | null, last_name?: string | null, phone?: string | null, email?: string | null, address?: { __typename?: 'Address', street_a?: string | null, city?: string | null, state?: string | null, zip?: string | null, country?: string | null } | null } | null, patient?: { __typename?: 'Patient', id: string, name?: string | null, is_active?: boolean | null, is_deceased?: boolean | null, birthday?: number | null, weight?: number | null, avatar_url?: string | null, gender?: string | null, owner?: { __typename?: 'Client', first_name?: string | null, last_name?: string | null } | null, clinic_species?: { __typename?: 'ClinicSpecies', id: string, species: Species, description: string, weight_key: string } | null, clinic_breed?: { __typename?: 'Breed', id: string, description: string } | null } | null, form: { __typename?: 'Form', id: string, name?: string | null, form_type: FormType, is_writeback_enabled: boolean, form_file_naming_template?: string | null }, form_data: { __typename?: 'FormFields', pages?: Array<{ __typename?: 'FormPage', id: string, title?: string | null, description?: string | null, order?: number | null }> | null, fields?: Array<{ __typename?: 'FormElement', id: string, type?: FormElementType | null, content?: string | null, name?: string | null, column_order?: number | null, row_order?: number | null, page_id?: string | null, options?: Array<string> | null, is_required?: boolean | null, value?: string | null, attachments?: Array<{ __typename?: 'FormFileAttachment', id?: string | null, filename?: string | null, mime_type?: string | null, size_bytes?: number | null, thumbnail_url?: string | null, url: string }> | null, field_updates?: Array<{ __typename?: 'FormFieldUpdate', field: FormFieldUpdateField, boolean_value?: boolean | null, option?: string | null }> | null }> | null }, appointment?: { __typename?: 'Appointment', start_time: number, drop_off_time?: number | null, clinic?: { __typename?: 'Clinic', name?: string | null, slug?: string | null, phone?: string | null, email?: string | null, address?: { __typename?: 'Address', street_a?: string | null, city?: string | null, state?: string | null, zip?: string | null, country?: string | null } | null } | null, clinician?: { __typename?: 'Clinician', name: string, display_name?: string | null } | null, service?: { __typename?: 'Service', name?: string | null } | null } | null }> | null, widget?: { __typename?: 'Widget', id: string, widget_name: string } | null } };

export type SearchAppointmentsQueryVariables = Exact<{
  searchInput: SearchAppointmentsInput;
}>;


export type SearchAppointmentsQuery = { __typename?: 'Query', searchAppointments: Array<{ __typename?: 'Appointment', id: string, pms?: PracticeManagementSystem | null, client_pms_id?: string | null, is_new_client?: boolean | null, start_time: number, drop_off_time?: number | null, minutes: number, is_new_patient?: boolean | null, is_clinician_auto_assigned?: boolean | null, patient_pms_id?: string | null, referring_clinic_name?: string | null, client_notes?: string | null, clinic_notes?: string | null, service_name?: string | null, status: AppointmentStatus, is_time_block?: boolean | null, is_confirmed?: boolean | null, origin?: EntityOrigin | null, reason_for_cancellation?: string | null, client_reason_for_cancellation?: string | null, new_client_name?: string | null, new_client_phone?: string | null, new_patient_name?: string | null, new_patient_species?: string | null, confirmed_at?: number | null, widget_source?: string | null, from_widget?: string | null, is_deleted?: boolean | null, created_at: number, updated_at: number, pms_created_at?: number | null, clinic?: { __typename?: 'Clinic', id: string, name?: string | null, slug?: string | null, pms_db?: { __typename?: 'PmsDb', id: string } | null, address?: { __typename?: 'Address', country?: string | null } | null } | null, client?: { __typename?: 'Client', id: string, first_name?: string | null, last_name?: string | null, secondary_first_name?: string | null, secondary_last_name?: string | null, phone?: string | null, email?: string | null, pms?: PracticeManagementSystem | null, pms_id?: string | null, last_appt_time?: number | null, last_contact_time?: number | null, email_enabled: boolean, sms_enabled: boolean, balance?: number | null, is_active?: boolean | null, is_unsubscribed: boolean, created_at: number, updated_at: number, client_phones?: Array<{ __typename?: 'ClientPhone', id: string, phone: string, country_code?: string | null, is_primary: boolean, is_chckup_primary: boolean, is_mobile: boolean, sms_available: boolean, is_unsubscribed: boolean, is_active: boolean, name?: string | null }> | null, client_emails?: Array<{ __typename?: 'ClientEmail', id: string, email: string, is_primary: boolean }> | null, clinic?: { __typename?: 'Clinic', id: string } | null, patients?: Array<{ __typename?: 'Patient', id: string, pms?: PracticeManagementSystem | null, pms_id?: string | null, name?: string | null, breed?: string | null, avatar_url?: string | null, last_appt_time?: number | null, gender?: string | null, fixed_status?: FixedStatus | null, weight?: number | null, birthday?: number | null, is_active?: boolean | null, is_deceased?: boolean | null, pms_created_at?: number | null, created_at: number, updated_at: number, owner?: { __typename?: 'Client', id: string, first_name?: string | null, last_name?: string | null, email?: string | null, phone?: string | null, address?: { __typename?: 'Address', country?: string | null } | null } | null, clinic_species?: { __typename?: 'ClinicSpecies', id: string, pms_id: string, description: string, is_primary: boolean, species: Species, weight_key: string, created_at: number, updated_at: number } | null, clinic?: { __typename?: 'Clinic', id: string } | null, clinic_breed?: { __typename?: 'Breed', id: string, description: string } | null, patient_vaccination_records?: Array<{ __typename?: 'PatientVaccinationRecord', id: string, vaccine_name?: string | null, manufacturer?: string | null, lot_number?: string | null, administered_date?: number | null, due_date?: number | null, rabies_tag?: string | null, is_rabies_vaccine?: boolean | null, is_soc: boolean, is_active: boolean, product?: { __typename?: 'Product', id: string, display_name?: string | null, name: string } | null }> | null, last_appointment?: { __typename?: 'Appointment', clinician?: { __typename?: 'Clinician', name: string, display_name?: string | null } | null } | null }> | null, address?: { __typename?: 'Address', street_a?: string | null, street_b?: string | null, city?: string | null, state?: string | null, zip?: string | null, country?: string | null } | null, user?: { __typename?: 'User', avatar_url?: string | null } | null, loyalty_members?: Array<{ __typename?: 'LoyaltyMember', id: string, available_points: number } | null> | null, settings?: { __typename?: 'ClientSettings', clinic_chckup_notifications_enabled: boolean, clinic_chckup_sms_enabled: boolean, clinic_chckup_email_enabled: boolean, client_chckup_notifications_enabled: boolean, client_chckup_sms_enabled: boolean, client_chckup_email_enabled: boolean, is_unsubscribed_from_marketing: boolean, is_unsubscribed_from_marketing_sms: boolean, is_unsubscribed_from_marketing_email: boolean } | null, last_appointment?: { __typename?: 'Appointment', clinician?: { __typename?: 'Clinician', name: string, display_name?: string | null } | null } | null } | null, clinician?: { __typename?: 'Clinician', id: string, name: string, display_name?: string | null, bio?: string | null, avatar_url?: string | null, initials?: string | null, excluded_species?: Array<Species> | null, excluded_service_ids?: Array<string> | null, authority_level?: AuthorityLevel | null, type: ResourceType, is_active?: boolean | null, is_assignable_in_pms?: boolean | null, does_contribute_to_fill_rate?: boolean | null, pms_id?: string | null, location?: string | null, pms_is_active: boolean, valid_booking_interval_minutes?: Array<number> | null, created_at: number, updated_at: number, clinic?: { __typename?: 'Clinic', id: string, name?: string | null } | null, pms_db?: { __typename?: 'PmsDb', id: string } | null, hours?: { __typename?: 'AvailabilityHours', monday?: Array<{ __typename?: 'TimeInterval', start?: number | null, end?: number | null }> | null, tuesday?: Array<{ __typename?: 'TimeInterval', start?: number | null, end?: number | null }> | null, wednesday?: Array<{ __typename?: 'TimeInterval', start?: number | null, end?: number | null }> | null, thursday?: Array<{ __typename?: 'TimeInterval', start?: number | null, end?: number | null }> | null, friday?: Array<{ __typename?: 'TimeInterval', start?: number | null, end?: number | null }> | null, saturday?: Array<{ __typename?: 'TimeInterval', start?: number | null, end?: number | null }> | null, sunday?: Array<{ __typename?: 'TimeInterval', start?: number | null, end?: number | null }> | null } | null, adjusted_availability?: Array<{ __typename?: 'Availability', date: number, pms_appt_type_pms_id?: string | null, times: Array<{ __typename?: 'TimeInterval', start?: number | null, end?: number | null }>, repeat?: { __typename?: 'RepeatAvailability', daysOfMonth?: Array<number> | null, daysOfWeek?: Array<DayOfWeek> | null, weekOfMonth?: WeekOfMonth | null, frequency: any, unit: RepeatUnit, end_date?: number | null } | null }> | null, pms_adjusted_availability?: Array<{ __typename?: 'Availability', date: number, pms_appt_type_pms_id?: string | null, times: Array<{ __typename?: 'TimeInterval', start?: number | null, end?: number | null }>, repeat?: { __typename?: 'RepeatAvailability', daysOfMonth?: Array<number> | null, daysOfWeek?: Array<DayOfWeek> | null, weekOfMonth?: WeekOfMonth | null, frequency: any, unit: RepeatUnit, end_date?: number | null } | null }> | null } | null, room?: { __typename?: 'Room', id: string, pms_id: string, name: string, display_name?: string | null, description?: string | null, concurrent_patients?: number | null, is_active: boolean, does_contribute_to_fill_rate?: boolean | null, valid_booking_interval_minutes?: Array<number> | null, created_at: number, updated_at: number, clinic?: { __typename?: 'Clinic', pms: PracticeManagementSystem, id: string, name?: string | null, time_zone?: string | null } | null, hours?: { __typename?: 'AvailabilityHours', monday?: Array<{ __typename?: 'TimeInterval', start?: number | null, end?: number | null }> | null, tuesday?: Array<{ __typename?: 'TimeInterval', start?: number | null, end?: number | null }> | null, wednesday?: Array<{ __typename?: 'TimeInterval', start?: number | null, end?: number | null }> | null, thursday?: Array<{ __typename?: 'TimeInterval', start?: number | null, end?: number | null }> | null, friday?: Array<{ __typename?: 'TimeInterval', start?: number | null, end?: number | null }> | null, saturday?: Array<{ __typename?: 'TimeInterval', start?: number | null, end?: number | null }> | null, sunday?: Array<{ __typename?: 'TimeInterval', start?: number | null, end?: number | null }> | null } | null, adjusted_availability?: Array<{ __typename?: 'Availability', date: number, pms_appt_type_pms_id?: string | null, times: Array<{ __typename?: 'TimeInterval', start?: number | null, end?: number | null }>, repeat?: { __typename?: 'RepeatAvailability', daysOfMonth?: Array<number> | null, daysOfWeek?: Array<DayOfWeek> | null, weekOfMonth?: WeekOfMonth | null, frequency: any, unit: RepeatUnit, end_date?: number | null } | null }> | null, pms_adjusted_availability?: Array<{ __typename?: 'Availability', date: number, pms_appt_type_pms_id?: string | null, times: Array<{ __typename?: 'TimeInterval', start?: number | null, end?: number | null }>, repeat?: { __typename?: 'RepeatAvailability', daysOfMonth?: Array<number> | null, daysOfWeek?: Array<DayOfWeek> | null, weekOfMonth?: WeekOfMonth | null, frequency: any, unit: RepeatUnit, end_date?: number | null } | null }> | null } | null, service?: { __typename?: 'Service', id: string, name?: string | null, color?: string | null } | null, patient?: { __typename?: 'Patient', id: string, pms?: PracticeManagementSystem | null, pms_id?: string | null, name?: string | null, breed?: string | null, avatar_url?: string | null, last_appt_time?: number | null, gender?: string | null, fixed_status?: FixedStatus | null, weight?: number | null, birthday?: number | null, is_active?: boolean | null, is_deceased?: boolean | null, pms_created_at?: number | null, created_at: number, updated_at: number, owner?: { __typename?: 'Client', id: string, first_name?: string | null, last_name?: string | null, email?: string | null, phone?: string | null, address?: { __typename?: 'Address', country?: string | null } | null } | null, clinic_species?: { __typename?: 'ClinicSpecies', id: string, pms_id: string, description: string, is_primary: boolean, species: Species, weight_key: string, created_at: number, updated_at: number } | null, clinic?: { __typename?: 'Clinic', id: string } | null, clinic_breed?: { __typename?: 'Breed', id: string, description: string } | null, patient_vaccination_records?: Array<{ __typename?: 'PatientVaccinationRecord', id: string, vaccine_name?: string | null, manufacturer?: string | null, lot_number?: string | null, administered_date?: number | null, due_date?: number | null, rabies_tag?: string | null, is_rabies_vaccine?: boolean | null, is_soc: boolean, is_active: boolean, product?: { __typename?: 'Product', id: string, display_name?: string | null, name: string } | null }> | null, last_appointment?: { __typename?: 'Appointment', clinician?: { __typename?: 'Clinician', name: string, display_name?: string | null } | null } | null } | null, clinic_appt_status?: { __typename?: 'ClinicApptStatus', id: string, description: string, status: AppointmentStatus } | null, client_info?: { __typename?: 'ClientInfo', first_name?: string | null, last_name?: string | null, email?: string | null, phone?: string | null } | null, patient_info?: { __typename?: 'PatientInfo', patient_name?: string | null, patient_breed?: string | null, patient_clinic_species?: string | null, patient_clinic_breed?: string | null } | null, clients_forms?: Array<{ __typename?: 'ClientForm', id: string, client_completed_at?: number | null, clinic_verified_at?: number | null, is_archived: boolean, pms_id?: string | null, created_at: number, updated_at: number, client?: { __typename?: 'Client', id: string, first_name?: string | null, last_name?: string | null, phone?: string | null, email?: string | null, address?: { __typename?: 'Address', street_a?: string | null, city?: string | null, state?: string | null, zip?: string | null, country?: string | null } | null } | null, patient?: { __typename?: 'Patient', id: string, name?: string | null, is_active?: boolean | null, is_deceased?: boolean | null, birthday?: number | null, weight?: number | null, avatar_url?: string | null, gender?: string | null, owner?: { __typename?: 'Client', first_name?: string | null, last_name?: string | null } | null, clinic_species?: { __typename?: 'ClinicSpecies', id: string, species: Species, description: string, weight_key: string } | null, clinic_breed?: { __typename?: 'Breed', id: string, description: string } | null } | null, form: { __typename?: 'Form', id: string, name?: string | null, form_type: FormType, is_writeback_enabled: boolean, form_file_naming_template?: string | null }, form_data: { __typename?: 'FormFields', pages?: Array<{ __typename?: 'FormPage', id: string, title?: string | null, description?: string | null, order?: number | null }> | null, fields?: Array<{ __typename?: 'FormElement', id: string, type?: FormElementType | null, content?: string | null, name?: string | null, column_order?: number | null, row_order?: number | null, page_id?: string | null, options?: Array<string> | null, is_required?: boolean | null, value?: string | null, attachments?: Array<{ __typename?: 'FormFileAttachment', id?: string | null, filename?: string | null, mime_type?: string | null, size_bytes?: number | null, thumbnail_url?: string | null, url: string }> | null, field_updates?: Array<{ __typename?: 'FormFieldUpdate', field: FormFieldUpdateField, boolean_value?: boolean | null, option?: string | null }> | null }> | null }, appointment?: { __typename?: 'Appointment', start_time: number, drop_off_time?: number | null, clinic?: { __typename?: 'Clinic', name?: string | null, slug?: string | null, phone?: string | null, email?: string | null, address?: { __typename?: 'Address', street_a?: string | null, city?: string | null, state?: string | null, zip?: string | null, country?: string | null } | null } | null, clinician?: { __typename?: 'Clinician', name: string, display_name?: string | null } | null, service?: { __typename?: 'Service', name?: string | null } | null } | null }> | null, widget?: { __typename?: 'Widget', id: string, widget_name: string } | null }> };

export type QueryAppointmentsQueryVariables = Exact<{
  where?: InputMaybe<Array<QueryInput> | QueryInput>;
  page?: InputMaybe<Scalars['NonNegativeInt']['input']>;
  pageSize?: InputMaybe<Scalars['NonNegativeInt']['input']>;
  orderBy?: InputMaybe<OrderByInput>;
}>;


export type QueryAppointmentsQuery = { __typename?: 'Query', queryAppointments: Array<{ __typename?: 'Appointment', id: string, pms?: PracticeManagementSystem | null, client_pms_id?: string | null, is_new_client?: boolean | null, start_time: number, drop_off_time?: number | null, minutes: number, is_new_patient?: boolean | null, is_clinician_auto_assigned?: boolean | null, patient_pms_id?: string | null, referring_clinic_name?: string | null, client_notes?: string | null, clinic_notes?: string | null, service_name?: string | null, status: AppointmentStatus, is_time_block?: boolean | null, is_confirmed?: boolean | null, origin?: EntityOrigin | null, reason_for_cancellation?: string | null, client_reason_for_cancellation?: string | null, new_client_name?: string | null, new_client_phone?: string | null, new_patient_name?: string | null, new_patient_species?: string | null, confirmed_at?: number | null, widget_source?: string | null, from_widget?: string | null, is_deleted?: boolean | null, created_at: number, updated_at: number, pms_created_at?: number | null, clinic?: { __typename?: 'Clinic', id: string, name?: string | null, slug?: string | null, pms_db?: { __typename?: 'PmsDb', id: string } | null, address?: { __typename?: 'Address', country?: string | null } | null } | null, client?: { __typename?: 'Client', id: string, first_name?: string | null, last_name?: string | null, secondary_first_name?: string | null, secondary_last_name?: string | null, phone?: string | null, email?: string | null, pms?: PracticeManagementSystem | null, pms_id?: string | null, last_appt_time?: number | null, last_contact_time?: number | null, email_enabled: boolean, sms_enabled: boolean, balance?: number | null, is_active?: boolean | null, is_unsubscribed: boolean, created_at: number, updated_at: number, client_phones?: Array<{ __typename?: 'ClientPhone', id: string, phone: string, country_code?: string | null, is_primary: boolean, is_chckup_primary: boolean, is_mobile: boolean, sms_available: boolean, is_unsubscribed: boolean, is_active: boolean, name?: string | null }> | null, client_emails?: Array<{ __typename?: 'ClientEmail', id: string, email: string, is_primary: boolean }> | null, clinic?: { __typename?: 'Clinic', id: string } | null, patients?: Array<{ __typename?: 'Patient', id: string, pms?: PracticeManagementSystem | null, pms_id?: string | null, name?: string | null, breed?: string | null, avatar_url?: string | null, last_appt_time?: number | null, gender?: string | null, fixed_status?: FixedStatus | null, weight?: number | null, birthday?: number | null, is_active?: boolean | null, is_deceased?: boolean | null, pms_created_at?: number | null, created_at: number, updated_at: number, owner?: { __typename?: 'Client', id: string, first_name?: string | null, last_name?: string | null, email?: string | null, phone?: string | null, address?: { __typename?: 'Address', country?: string | null } | null } | null, clinic_species?: { __typename?: 'ClinicSpecies', id: string, pms_id: string, description: string, is_primary: boolean, species: Species, weight_key: string, created_at: number, updated_at: number } | null, clinic?: { __typename?: 'Clinic', id: string } | null, clinic_breed?: { __typename?: 'Breed', id: string, description: string } | null, patient_vaccination_records?: Array<{ __typename?: 'PatientVaccinationRecord', id: string, vaccine_name?: string | null, manufacturer?: string | null, lot_number?: string | null, administered_date?: number | null, due_date?: number | null, rabies_tag?: string | null, is_rabies_vaccine?: boolean | null, is_soc: boolean, is_active: boolean, product?: { __typename?: 'Product', id: string, display_name?: string | null, name: string } | null }> | null, last_appointment?: { __typename?: 'Appointment', clinician?: { __typename?: 'Clinician', name: string, display_name?: string | null } | null } | null }> | null, address?: { __typename?: 'Address', street_a?: string | null, street_b?: string | null, city?: string | null, state?: string | null, zip?: string | null, country?: string | null } | null, user?: { __typename?: 'User', avatar_url?: string | null } | null, loyalty_members?: Array<{ __typename?: 'LoyaltyMember', id: string, available_points: number } | null> | null, settings?: { __typename?: 'ClientSettings', clinic_chckup_notifications_enabled: boolean, clinic_chckup_sms_enabled: boolean, clinic_chckup_email_enabled: boolean, client_chckup_notifications_enabled: boolean, client_chckup_sms_enabled: boolean, client_chckup_email_enabled: boolean, is_unsubscribed_from_marketing: boolean, is_unsubscribed_from_marketing_sms: boolean, is_unsubscribed_from_marketing_email: boolean } | null, last_appointment?: { __typename?: 'Appointment', clinician?: { __typename?: 'Clinician', name: string, display_name?: string | null } | null } | null } | null, clinician?: { __typename?: 'Clinician', id: string, name: string, display_name?: string | null, bio?: string | null, avatar_url?: string | null, initials?: string | null, excluded_species?: Array<Species> | null, excluded_service_ids?: Array<string> | null, authority_level?: AuthorityLevel | null, type: ResourceType, is_active?: boolean | null, is_assignable_in_pms?: boolean | null, does_contribute_to_fill_rate?: boolean | null, pms_id?: string | null, location?: string | null, pms_is_active: boolean, valid_booking_interval_minutes?: Array<number> | null, created_at: number, updated_at: number, clinic?: { __typename?: 'Clinic', id: string, name?: string | null } | null, pms_db?: { __typename?: 'PmsDb', id: string } | null, hours?: { __typename?: 'AvailabilityHours', monday?: Array<{ __typename?: 'TimeInterval', start?: number | null, end?: number | null }> | null, tuesday?: Array<{ __typename?: 'TimeInterval', start?: number | null, end?: number | null }> | null, wednesday?: Array<{ __typename?: 'TimeInterval', start?: number | null, end?: number | null }> | null, thursday?: Array<{ __typename?: 'TimeInterval', start?: number | null, end?: number | null }> | null, friday?: Array<{ __typename?: 'TimeInterval', start?: number | null, end?: number | null }> | null, saturday?: Array<{ __typename?: 'TimeInterval', start?: number | null, end?: number | null }> | null, sunday?: Array<{ __typename?: 'TimeInterval', start?: number | null, end?: number | null }> | null } | null, adjusted_availability?: Array<{ __typename?: 'Availability', date: number, pms_appt_type_pms_id?: string | null, times: Array<{ __typename?: 'TimeInterval', start?: number | null, end?: number | null }>, repeat?: { __typename?: 'RepeatAvailability', daysOfMonth?: Array<number> | null, daysOfWeek?: Array<DayOfWeek> | null, weekOfMonth?: WeekOfMonth | null, frequency: any, unit: RepeatUnit, end_date?: number | null } | null }> | null, pms_adjusted_availability?: Array<{ __typename?: 'Availability', date: number, pms_appt_type_pms_id?: string | null, times: Array<{ __typename?: 'TimeInterval', start?: number | null, end?: number | null }>, repeat?: { __typename?: 'RepeatAvailability', daysOfMonth?: Array<number> | null, daysOfWeek?: Array<DayOfWeek> | null, weekOfMonth?: WeekOfMonth | null, frequency: any, unit: RepeatUnit, end_date?: number | null } | null }> | null } | null, room?: { __typename?: 'Room', id: string, pms_id: string, name: string, display_name?: string | null, description?: string | null, concurrent_patients?: number | null, is_active: boolean, does_contribute_to_fill_rate?: boolean | null, valid_booking_interval_minutes?: Array<number> | null, created_at: number, updated_at: number, clinic?: { __typename?: 'Clinic', pms: PracticeManagementSystem, id: string, name?: string | null, time_zone?: string | null } | null, hours?: { __typename?: 'AvailabilityHours', monday?: Array<{ __typename?: 'TimeInterval', start?: number | null, end?: number | null }> | null, tuesday?: Array<{ __typename?: 'TimeInterval', start?: number | null, end?: number | null }> | null, wednesday?: Array<{ __typename?: 'TimeInterval', start?: number | null, end?: number | null }> | null, thursday?: Array<{ __typename?: 'TimeInterval', start?: number | null, end?: number | null }> | null, friday?: Array<{ __typename?: 'TimeInterval', start?: number | null, end?: number | null }> | null, saturday?: Array<{ __typename?: 'TimeInterval', start?: number | null, end?: number | null }> | null, sunday?: Array<{ __typename?: 'TimeInterval', start?: number | null, end?: number | null }> | null } | null, adjusted_availability?: Array<{ __typename?: 'Availability', date: number, pms_appt_type_pms_id?: string | null, times: Array<{ __typename?: 'TimeInterval', start?: number | null, end?: number | null }>, repeat?: { __typename?: 'RepeatAvailability', daysOfMonth?: Array<number> | null, daysOfWeek?: Array<DayOfWeek> | null, weekOfMonth?: WeekOfMonth | null, frequency: any, unit: RepeatUnit, end_date?: number | null } | null }> | null, pms_adjusted_availability?: Array<{ __typename?: 'Availability', date: number, pms_appt_type_pms_id?: string | null, times: Array<{ __typename?: 'TimeInterval', start?: number | null, end?: number | null }>, repeat?: { __typename?: 'RepeatAvailability', daysOfMonth?: Array<number> | null, daysOfWeek?: Array<DayOfWeek> | null, weekOfMonth?: WeekOfMonth | null, frequency: any, unit: RepeatUnit, end_date?: number | null } | null }> | null } | null, service?: { __typename?: 'Service', id: string, name?: string | null, color?: string | null } | null, patient?: { __typename?: 'Patient', id: string, pms?: PracticeManagementSystem | null, pms_id?: string | null, name?: string | null, breed?: string | null, avatar_url?: string | null, last_appt_time?: number | null, gender?: string | null, fixed_status?: FixedStatus | null, weight?: number | null, birthday?: number | null, is_active?: boolean | null, is_deceased?: boolean | null, pms_created_at?: number | null, created_at: number, updated_at: number, owner?: { __typename?: 'Client', id: string, first_name?: string | null, last_name?: string | null, email?: string | null, phone?: string | null, address?: { __typename?: 'Address', country?: string | null } | null } | null, clinic_species?: { __typename?: 'ClinicSpecies', id: string, pms_id: string, description: string, is_primary: boolean, species: Species, weight_key: string, created_at: number, updated_at: number } | null, clinic?: { __typename?: 'Clinic', id: string } | null, clinic_breed?: { __typename?: 'Breed', id: string, description: string } | null, patient_vaccination_records?: Array<{ __typename?: 'PatientVaccinationRecord', id: string, vaccine_name?: string | null, manufacturer?: string | null, lot_number?: string | null, administered_date?: number | null, due_date?: number | null, rabies_tag?: string | null, is_rabies_vaccine?: boolean | null, is_soc: boolean, is_active: boolean, product?: { __typename?: 'Product', id: string, display_name?: string | null, name: string } | null }> | null, last_appointment?: { __typename?: 'Appointment', clinician?: { __typename?: 'Clinician', name: string, display_name?: string | null } | null } | null } | null, clinic_appt_status?: { __typename?: 'ClinicApptStatus', id: string, description: string, status: AppointmentStatus } | null, client_info?: { __typename?: 'ClientInfo', first_name?: string | null, last_name?: string | null, email?: string | null, phone?: string | null } | null, patient_info?: { __typename?: 'PatientInfo', patient_name?: string | null, patient_breed?: string | null, patient_clinic_species?: string | null, patient_clinic_breed?: string | null } | null, clients_forms?: Array<{ __typename?: 'ClientForm', id: string, client_completed_at?: number | null, clinic_verified_at?: number | null, is_archived: boolean, pms_id?: string | null, created_at: number, updated_at: number, client?: { __typename?: 'Client', id: string, first_name?: string | null, last_name?: string | null, phone?: string | null, email?: string | null, address?: { __typename?: 'Address', street_a?: string | null, city?: string | null, state?: string | null, zip?: string | null, country?: string | null } | null } | null, patient?: { __typename?: 'Patient', id: string, name?: string | null, is_active?: boolean | null, is_deceased?: boolean | null, birthday?: number | null, weight?: number | null, avatar_url?: string | null, gender?: string | null, owner?: { __typename?: 'Client', first_name?: string | null, last_name?: string | null } | null, clinic_species?: { __typename?: 'ClinicSpecies', id: string, species: Species, description: string, weight_key: string } | null, clinic_breed?: { __typename?: 'Breed', id: string, description: string } | null } | null, form: { __typename?: 'Form', id: string, name?: string | null, form_type: FormType, is_writeback_enabled: boolean, form_file_naming_template?: string | null }, form_data: { __typename?: 'FormFields', pages?: Array<{ __typename?: 'FormPage', id: string, title?: string | null, description?: string | null, order?: number | null }> | null, fields?: Array<{ __typename?: 'FormElement', id: string, type?: FormElementType | null, content?: string | null, name?: string | null, column_order?: number | null, row_order?: number | null, page_id?: string | null, options?: Array<string> | null, is_required?: boolean | null, value?: string | null, attachments?: Array<{ __typename?: 'FormFileAttachment', id?: string | null, filename?: string | null, mime_type?: string | null, size_bytes?: number | null, thumbnail_url?: string | null, url: string }> | null, field_updates?: Array<{ __typename?: 'FormFieldUpdate', field: FormFieldUpdateField, boolean_value?: boolean | null, option?: string | null }> | null }> | null }, appointment?: { __typename?: 'Appointment', start_time: number, drop_off_time?: number | null, clinic?: { __typename?: 'Clinic', name?: string | null, slug?: string | null, phone?: string | null, email?: string | null, address?: { __typename?: 'Address', street_a?: string | null, city?: string | null, state?: string | null, zip?: string | null, country?: string | null } | null } | null, clinician?: { __typename?: 'Clinician', name: string, display_name?: string | null } | null, service?: { __typename?: 'Service', name?: string | null } | null } | null }> | null, widget?: { __typename?: 'Widget', id: string, widget_name: string } | null }> };

export type QueryAppointmentScheduleQueryVariables = Exact<{
  where?: InputMaybe<Array<QueryInput> | QueryInput>;
  page?: InputMaybe<Scalars['NonNegativeInt']['input']>;
  pageSize?: InputMaybe<Scalars['NonNegativeInt']['input']>;
  orderBy?: InputMaybe<OrderByInput>;
}>;


export type QueryAppointmentScheduleQuery = { __typename?: 'Query', queryAppointments: Array<{ __typename?: 'Appointment', id: string, service_name?: string | null, reason_for_cancellation?: string | null, start_time: number, drop_off_time?: number | null, minutes: number, client_notes?: string | null, status: AppointmentStatus, is_deleted?: boolean | null, is_time_block?: boolean | null, is_clinician_auto_assigned?: boolean | null, client_pms_id?: string | null, patient_pms_id?: string | null, is_new_client?: boolean | null, is_new_patient?: boolean | null, new_client_name?: string | null, new_client_phone?: string | null, new_patient_name?: string | null, pms_created_at?: number | null, service?: { __typename?: 'Service', id: string, color?: string | null, name?: string | null } | null, clinician?: { __typename?: 'Clinician', id: string, name: string, display_name?: string | null, pms_id?: string | null } | null, room?: { __typename?: 'Room', id: string, name: string } | null, client?: { __typename?: 'Client', id: string, first_name?: string | null, last_name?: string | null, email?: string | null, phone?: string | null } | null, patient?: { __typename?: 'Patient', id: string, name?: string | null, avatar_url?: string | null, clinic_breed?: { __typename?: 'Breed', id: string, description: string } | null } | null, clinic?: { __typename?: 'Clinic', address?: { __typename?: 'Address', country?: string | null } | null } | null, clinic_appt_status?: { __typename?: 'ClinicApptStatus', id: string, description: string, status: AppointmentStatus } | null }> };

export type QueryClinicAppointmentsQueryVariables = Exact<{
  where?: InputMaybe<Array<QueryInput> | QueryInput>;
  page?: InputMaybe<Scalars['NonNegativeInt']['input']>;
  pageSize?: InputMaybe<Scalars['NonNegativeInt']['input']>;
  orderBy?: InputMaybe<OrderByInput>;
  clinicId: Scalars['ID']['input'];
}>;


export type QueryClinicAppointmentsQuery = { __typename?: 'Query', queryClinicAppointments: Array<{ __typename?: 'Appointment', id: string, pms?: PracticeManagementSystem | null, client_pms_id?: string | null, is_new_client?: boolean | null, start_time: number, drop_off_time?: number | null, minutes: number, is_new_patient?: boolean | null, is_clinician_auto_assigned?: boolean | null, patient_pms_id?: string | null, referring_clinic_name?: string | null, client_notes?: string | null, clinic_notes?: string | null, service_name?: string | null, status: AppointmentStatus, is_time_block?: boolean | null, is_confirmed?: boolean | null, origin?: EntityOrigin | null, reason_for_cancellation?: string | null, client_reason_for_cancellation?: string | null, new_client_name?: string | null, new_client_phone?: string | null, new_patient_name?: string | null, new_patient_species?: string | null, confirmed_at?: number | null, widget_source?: string | null, from_widget?: string | null, is_deleted?: boolean | null, created_at: number, updated_at: number, pms_created_at?: number | null, clinic?: { __typename?: 'Clinic', id: string, name?: string | null, slug?: string | null, pms_db?: { __typename?: 'PmsDb', id: string } | null, address?: { __typename?: 'Address', country?: string | null } | null } | null, client?: { __typename?: 'Client', id: string, first_name?: string | null, last_name?: string | null, secondary_first_name?: string | null, secondary_last_name?: string | null, phone?: string | null, email?: string | null, pms?: PracticeManagementSystem | null, pms_id?: string | null, last_appt_time?: number | null, last_contact_time?: number | null, email_enabled: boolean, sms_enabled: boolean, balance?: number | null, is_active?: boolean | null, is_unsubscribed: boolean, created_at: number, updated_at: number, client_phones?: Array<{ __typename?: 'ClientPhone', id: string, phone: string, country_code?: string | null, is_primary: boolean, is_chckup_primary: boolean, is_mobile: boolean, sms_available: boolean, is_unsubscribed: boolean, is_active: boolean, name?: string | null }> | null, client_emails?: Array<{ __typename?: 'ClientEmail', id: string, email: string, is_primary: boolean }> | null, clinic?: { __typename?: 'Clinic', id: string } | null, patients?: Array<{ __typename?: 'Patient', id: string, pms?: PracticeManagementSystem | null, pms_id?: string | null, name?: string | null, breed?: string | null, avatar_url?: string | null, last_appt_time?: number | null, gender?: string | null, fixed_status?: FixedStatus | null, weight?: number | null, birthday?: number | null, is_active?: boolean | null, is_deceased?: boolean | null, pms_created_at?: number | null, created_at: number, updated_at: number, owner?: { __typename?: 'Client', id: string, first_name?: string | null, last_name?: string | null, email?: string | null, phone?: string | null, address?: { __typename?: 'Address', country?: string | null } | null } | null, clinic_species?: { __typename?: 'ClinicSpecies', id: string, pms_id: string, description: string, is_primary: boolean, species: Species, weight_key: string, created_at: number, updated_at: number } | null, clinic?: { __typename?: 'Clinic', id: string } | null, clinic_breed?: { __typename?: 'Breed', id: string, description: string } | null, patient_vaccination_records?: Array<{ __typename?: 'PatientVaccinationRecord', id: string, vaccine_name?: string | null, manufacturer?: string | null, lot_number?: string | null, administered_date?: number | null, due_date?: number | null, rabies_tag?: string | null, is_rabies_vaccine?: boolean | null, is_soc: boolean, is_active: boolean, product?: { __typename?: 'Product', id: string, display_name?: string | null, name: string } | null }> | null, last_appointment?: { __typename?: 'Appointment', clinician?: { __typename?: 'Clinician', name: string, display_name?: string | null } | null } | null }> | null, address?: { __typename?: 'Address', street_a?: string | null, street_b?: string | null, city?: string | null, state?: string | null, zip?: string | null, country?: string | null } | null, user?: { __typename?: 'User', avatar_url?: string | null } | null, loyalty_members?: Array<{ __typename?: 'LoyaltyMember', id: string, available_points: number } | null> | null, settings?: { __typename?: 'ClientSettings', clinic_chckup_notifications_enabled: boolean, clinic_chckup_sms_enabled: boolean, clinic_chckup_email_enabled: boolean, client_chckup_notifications_enabled: boolean, client_chckup_sms_enabled: boolean, client_chckup_email_enabled: boolean, is_unsubscribed_from_marketing: boolean, is_unsubscribed_from_marketing_sms: boolean, is_unsubscribed_from_marketing_email: boolean } | null, last_appointment?: { __typename?: 'Appointment', clinician?: { __typename?: 'Clinician', name: string, display_name?: string | null } | null } | null } | null, clinician?: { __typename?: 'Clinician', id: string, name: string, display_name?: string | null, bio?: string | null, avatar_url?: string | null, initials?: string | null, excluded_species?: Array<Species> | null, excluded_service_ids?: Array<string> | null, authority_level?: AuthorityLevel | null, type: ResourceType, is_active?: boolean | null, is_assignable_in_pms?: boolean | null, does_contribute_to_fill_rate?: boolean | null, pms_id?: string | null, location?: string | null, pms_is_active: boolean, valid_booking_interval_minutes?: Array<number> | null, created_at: number, updated_at: number, clinic?: { __typename?: 'Clinic', id: string, name?: string | null } | null, pms_db?: { __typename?: 'PmsDb', id: string } | null, hours?: { __typename?: 'AvailabilityHours', monday?: Array<{ __typename?: 'TimeInterval', start?: number | null, end?: number | null }> | null, tuesday?: Array<{ __typename?: 'TimeInterval', start?: number | null, end?: number | null }> | null, wednesday?: Array<{ __typename?: 'TimeInterval', start?: number | null, end?: number | null }> | null, thursday?: Array<{ __typename?: 'TimeInterval', start?: number | null, end?: number | null }> | null, friday?: Array<{ __typename?: 'TimeInterval', start?: number | null, end?: number | null }> | null, saturday?: Array<{ __typename?: 'TimeInterval', start?: number | null, end?: number | null }> | null, sunday?: Array<{ __typename?: 'TimeInterval', start?: number | null, end?: number | null }> | null } | null, adjusted_availability?: Array<{ __typename?: 'Availability', date: number, pms_appt_type_pms_id?: string | null, times: Array<{ __typename?: 'TimeInterval', start?: number | null, end?: number | null }>, repeat?: { __typename?: 'RepeatAvailability', daysOfMonth?: Array<number> | null, daysOfWeek?: Array<DayOfWeek> | null, weekOfMonth?: WeekOfMonth | null, frequency: any, unit: RepeatUnit, end_date?: number | null } | null }> | null, pms_adjusted_availability?: Array<{ __typename?: 'Availability', date: number, pms_appt_type_pms_id?: string | null, times: Array<{ __typename?: 'TimeInterval', start?: number | null, end?: number | null }>, repeat?: { __typename?: 'RepeatAvailability', daysOfMonth?: Array<number> | null, daysOfWeek?: Array<DayOfWeek> | null, weekOfMonth?: WeekOfMonth | null, frequency: any, unit: RepeatUnit, end_date?: number | null } | null }> | null } | null, room?: { __typename?: 'Room', id: string, pms_id: string, name: string, display_name?: string | null, description?: string | null, concurrent_patients?: number | null, is_active: boolean, does_contribute_to_fill_rate?: boolean | null, valid_booking_interval_minutes?: Array<number> | null, created_at: number, updated_at: number, clinic?: { __typename?: 'Clinic', pms: PracticeManagementSystem, id: string, name?: string | null, time_zone?: string | null } | null, hours?: { __typename?: 'AvailabilityHours', monday?: Array<{ __typename?: 'TimeInterval', start?: number | null, end?: number | null }> | null, tuesday?: Array<{ __typename?: 'TimeInterval', start?: number | null, end?: number | null }> | null, wednesday?: Array<{ __typename?: 'TimeInterval', start?: number | null, end?: number | null }> | null, thursday?: Array<{ __typename?: 'TimeInterval', start?: number | null, end?: number | null }> | null, friday?: Array<{ __typename?: 'TimeInterval', start?: number | null, end?: number | null }> | null, saturday?: Array<{ __typename?: 'TimeInterval', start?: number | null, end?: number | null }> | null, sunday?: Array<{ __typename?: 'TimeInterval', start?: number | null, end?: number | null }> | null } | null, adjusted_availability?: Array<{ __typename?: 'Availability', date: number, pms_appt_type_pms_id?: string | null, times: Array<{ __typename?: 'TimeInterval', start?: number | null, end?: number | null }>, repeat?: { __typename?: 'RepeatAvailability', daysOfMonth?: Array<number> | null, daysOfWeek?: Array<DayOfWeek> | null, weekOfMonth?: WeekOfMonth | null, frequency: any, unit: RepeatUnit, end_date?: number | null } | null }> | null, pms_adjusted_availability?: Array<{ __typename?: 'Availability', date: number, pms_appt_type_pms_id?: string | null, times: Array<{ __typename?: 'TimeInterval', start?: number | null, end?: number | null }>, repeat?: { __typename?: 'RepeatAvailability', daysOfMonth?: Array<number> | null, daysOfWeek?: Array<DayOfWeek> | null, weekOfMonth?: WeekOfMonth | null, frequency: any, unit: RepeatUnit, end_date?: number | null } | null }> | null } | null, service?: { __typename?: 'Service', id: string, name?: string | null, color?: string | null } | null, patient?: { __typename?: 'Patient', id: string, pms?: PracticeManagementSystem | null, pms_id?: string | null, name?: string | null, breed?: string | null, avatar_url?: string | null, last_appt_time?: number | null, gender?: string | null, fixed_status?: FixedStatus | null, weight?: number | null, birthday?: number | null, is_active?: boolean | null, is_deceased?: boolean | null, pms_created_at?: number | null, created_at: number, updated_at: number, owner?: { __typename?: 'Client', id: string, first_name?: string | null, last_name?: string | null, email?: string | null, phone?: string | null, address?: { __typename?: 'Address', country?: string | null } | null } | null, clinic_species?: { __typename?: 'ClinicSpecies', id: string, pms_id: string, description: string, is_primary: boolean, species: Species, weight_key: string, created_at: number, updated_at: number } | null, clinic?: { __typename?: 'Clinic', id: string } | null, clinic_breed?: { __typename?: 'Breed', id: string, description: string } | null, patient_vaccination_records?: Array<{ __typename?: 'PatientVaccinationRecord', id: string, vaccine_name?: string | null, manufacturer?: string | null, lot_number?: string | null, administered_date?: number | null, due_date?: number | null, rabies_tag?: string | null, is_rabies_vaccine?: boolean | null, is_soc: boolean, is_active: boolean, product?: { __typename?: 'Product', id: string, display_name?: string | null, name: string } | null }> | null, last_appointment?: { __typename?: 'Appointment', clinician?: { __typename?: 'Clinician', name: string, display_name?: string | null } | null } | null } | null, clinic_appt_status?: { __typename?: 'ClinicApptStatus', id: string, description: string, status: AppointmentStatus } | null, client_info?: { __typename?: 'ClientInfo', first_name?: string | null, last_name?: string | null, email?: string | null, phone?: string | null } | null, patient_info?: { __typename?: 'PatientInfo', patient_name?: string | null, patient_breed?: string | null, patient_clinic_species?: string | null, patient_clinic_breed?: string | null } | null, clients_forms?: Array<{ __typename?: 'ClientForm', id: string, client_completed_at?: number | null, clinic_verified_at?: number | null, is_archived: boolean, pms_id?: string | null, created_at: number, updated_at: number, client?: { __typename?: 'Client', id: string, first_name?: string | null, last_name?: string | null, phone?: string | null, email?: string | null, address?: { __typename?: 'Address', street_a?: string | null, city?: string | null, state?: string | null, zip?: string | null, country?: string | null } | null } | null, patient?: { __typename?: 'Patient', id: string, name?: string | null, is_active?: boolean | null, is_deceased?: boolean | null, birthday?: number | null, weight?: number | null, avatar_url?: string | null, gender?: string | null, owner?: { __typename?: 'Client', first_name?: string | null, last_name?: string | null } | null, clinic_species?: { __typename?: 'ClinicSpecies', id: string, species: Species, description: string, weight_key: string } | null, clinic_breed?: { __typename?: 'Breed', id: string, description: string } | null } | null, form: { __typename?: 'Form', id: string, name?: string | null, form_type: FormType, is_writeback_enabled: boolean, form_file_naming_template?: string | null }, form_data: { __typename?: 'FormFields', pages?: Array<{ __typename?: 'FormPage', id: string, title?: string | null, description?: string | null, order?: number | null }> | null, fields?: Array<{ __typename?: 'FormElement', id: string, type?: FormElementType | null, content?: string | null, name?: string | null, column_order?: number | null, row_order?: number | null, page_id?: string | null, options?: Array<string> | null, is_required?: boolean | null, value?: string | null, attachments?: Array<{ __typename?: 'FormFileAttachment', id?: string | null, filename?: string | null, mime_type?: string | null, size_bytes?: number | null, thumbnail_url?: string | null, url: string }> | null, field_updates?: Array<{ __typename?: 'FormFieldUpdate', field: FormFieldUpdateField, boolean_value?: boolean | null, option?: string | null }> | null }> | null }, appointment?: { __typename?: 'Appointment', start_time: number, drop_off_time?: number | null, clinic?: { __typename?: 'Clinic', name?: string | null, slug?: string | null, phone?: string | null, email?: string | null, address?: { __typename?: 'Address', street_a?: string | null, city?: string | null, state?: string | null, zip?: string | null, country?: string | null } | null } | null, clinician?: { __typename?: 'Clinician', name: string, display_name?: string | null } | null, service?: { __typename?: 'Service', name?: string | null } | null } | null }> | null, widget?: { __typename?: 'Widget', id: string, widget_name: string } | null }> };

export type CountAppointmentsQueryVariables = Exact<{
  where?: InputMaybe<Array<QueryInput> | QueryInput>;
}>;


export type CountAppointmentsQuery = { __typename?: 'Query', countAppointments: number };

export type SearchAppointmentsStatusQueryVariables = Exact<{
  searchInput: SearchAppointmentsInput;
}>;


export type SearchAppointmentsStatusQuery = { __typename?: 'Query', searchAppointments: Array<{ __typename?: 'Appointment', id: string, status: AppointmentStatus }> };

export type GetNewAppointmentsForClinicQueryVariables = Exact<{
  clinicId: Scalars['ID']['input'];
  fromPmsCreatedAt: Scalars['NonNegativeInt']['input'];
  toPmsCreatedAt: Scalars['NonNegativeInt']['input'];
}>;


export type GetNewAppointmentsForClinicQuery = { __typename?: 'Query', getNewAppointmentsForClinic: number };

export type GetAppointmentsByClinicAndRangeQueryVariables = Exact<{
  clinicId: Scalars['ID']['input'];
  start_time: Scalars['NonNegativeInt']['input'];
  end_time: Scalars['NonNegativeInt']['input'];
}>;


export type GetAppointmentsByClinicAndRangeQuery = { __typename?: 'Query', appointmentsByClinicAndRange: Array<{ __typename?: 'Appointment', id: string, pms?: PracticeManagementSystem | null, client_pms_id?: string | null, is_new_client?: boolean | null, start_time: number, drop_off_time?: number | null, minutes: number, is_new_patient?: boolean | null, is_clinician_auto_assigned?: boolean | null, patient_pms_id?: string | null, referring_clinic_name?: string | null, client_notes?: string | null, clinic_notes?: string | null, service_name?: string | null, status: AppointmentStatus, is_time_block?: boolean | null, is_confirmed?: boolean | null, origin?: EntityOrigin | null, reason_for_cancellation?: string | null, client_reason_for_cancellation?: string | null, new_client_name?: string | null, new_client_phone?: string | null, new_patient_name?: string | null, new_patient_species?: string | null, confirmed_at?: number | null, widget_source?: string | null, from_widget?: string | null, is_deleted?: boolean | null, created_at: number, updated_at: number, pms_created_at?: number | null, clinic?: { __typename?: 'Clinic', id: string, name?: string | null, slug?: string | null, pms_db?: { __typename?: 'PmsDb', id: string } | null, address?: { __typename?: 'Address', country?: string | null } | null } | null, client?: { __typename?: 'Client', id: string, first_name?: string | null, last_name?: string | null, secondary_first_name?: string | null, secondary_last_name?: string | null, phone?: string | null, email?: string | null, pms?: PracticeManagementSystem | null, pms_id?: string | null, last_appt_time?: number | null, last_contact_time?: number | null, email_enabled: boolean, sms_enabled: boolean, balance?: number | null, is_active?: boolean | null, is_unsubscribed: boolean, created_at: number, updated_at: number, client_phones?: Array<{ __typename?: 'ClientPhone', id: string, phone: string, country_code?: string | null, is_primary: boolean, is_chckup_primary: boolean, is_mobile: boolean, sms_available: boolean, is_unsubscribed: boolean, is_active: boolean, name?: string | null }> | null, client_emails?: Array<{ __typename?: 'ClientEmail', id: string, email: string, is_primary: boolean }> | null, clinic?: { __typename?: 'Clinic', id: string } | null, patients?: Array<{ __typename?: 'Patient', id: string, pms?: PracticeManagementSystem | null, pms_id?: string | null, name?: string | null, breed?: string | null, avatar_url?: string | null, last_appt_time?: number | null, gender?: string | null, fixed_status?: FixedStatus | null, weight?: number | null, birthday?: number | null, is_active?: boolean | null, is_deceased?: boolean | null, pms_created_at?: number | null, created_at: number, updated_at: number, owner?: { __typename?: 'Client', id: string, first_name?: string | null, last_name?: string | null, email?: string | null, phone?: string | null, address?: { __typename?: 'Address', country?: string | null } | null } | null, clinic_species?: { __typename?: 'ClinicSpecies', id: string, pms_id: string, description: string, is_primary: boolean, species: Species, weight_key: string, created_at: number, updated_at: number } | null, clinic?: { __typename?: 'Clinic', id: string } | null, clinic_breed?: { __typename?: 'Breed', id: string, description: string } | null, patient_vaccination_records?: Array<{ __typename?: 'PatientVaccinationRecord', id: string, vaccine_name?: string | null, manufacturer?: string | null, lot_number?: string | null, administered_date?: number | null, due_date?: number | null, rabies_tag?: string | null, is_rabies_vaccine?: boolean | null, is_soc: boolean, is_active: boolean, product?: { __typename?: 'Product', id: string, display_name?: string | null, name: string } | null }> | null, last_appointment?: { __typename?: 'Appointment', clinician?: { __typename?: 'Clinician', name: string, display_name?: string | null } | null } | null }> | null, address?: { __typename?: 'Address', street_a?: string | null, street_b?: string | null, city?: string | null, state?: string | null, zip?: string | null, country?: string | null } | null, user?: { __typename?: 'User', avatar_url?: string | null } | null, loyalty_members?: Array<{ __typename?: 'LoyaltyMember', id: string, available_points: number } | null> | null, settings?: { __typename?: 'ClientSettings', clinic_chckup_notifications_enabled: boolean, clinic_chckup_sms_enabled: boolean, clinic_chckup_email_enabled: boolean, client_chckup_notifications_enabled: boolean, client_chckup_sms_enabled: boolean, client_chckup_email_enabled: boolean, is_unsubscribed_from_marketing: boolean, is_unsubscribed_from_marketing_sms: boolean, is_unsubscribed_from_marketing_email: boolean } | null, last_appointment?: { __typename?: 'Appointment', clinician?: { __typename?: 'Clinician', name: string, display_name?: string | null } | null } | null } | null, clinician?: { __typename?: 'Clinician', id: string, name: string, display_name?: string | null, bio?: string | null, avatar_url?: string | null, initials?: string | null, excluded_species?: Array<Species> | null, excluded_service_ids?: Array<string> | null, authority_level?: AuthorityLevel | null, type: ResourceType, is_active?: boolean | null, is_assignable_in_pms?: boolean | null, does_contribute_to_fill_rate?: boolean | null, pms_id?: string | null, location?: string | null, pms_is_active: boolean, valid_booking_interval_minutes?: Array<number> | null, created_at: number, updated_at: number, clinic?: { __typename?: 'Clinic', id: string, name?: string | null } | null, pms_db?: { __typename?: 'PmsDb', id: string } | null, hours?: { __typename?: 'AvailabilityHours', monday?: Array<{ __typename?: 'TimeInterval', start?: number | null, end?: number | null }> | null, tuesday?: Array<{ __typename?: 'TimeInterval', start?: number | null, end?: number | null }> | null, wednesday?: Array<{ __typename?: 'TimeInterval', start?: number | null, end?: number | null }> | null, thursday?: Array<{ __typename?: 'TimeInterval', start?: number | null, end?: number | null }> | null, friday?: Array<{ __typename?: 'TimeInterval', start?: number | null, end?: number | null }> | null, saturday?: Array<{ __typename?: 'TimeInterval', start?: number | null, end?: number | null }> | null, sunday?: Array<{ __typename?: 'TimeInterval', start?: number | null, end?: number | null }> | null } | null, adjusted_availability?: Array<{ __typename?: 'Availability', date: number, pms_appt_type_pms_id?: string | null, times: Array<{ __typename?: 'TimeInterval', start?: number | null, end?: number | null }>, repeat?: { __typename?: 'RepeatAvailability', daysOfMonth?: Array<number> | null, daysOfWeek?: Array<DayOfWeek> | null, weekOfMonth?: WeekOfMonth | null, frequency: any, unit: RepeatUnit, end_date?: number | null } | null }> | null, pms_adjusted_availability?: Array<{ __typename?: 'Availability', date: number, pms_appt_type_pms_id?: string | null, times: Array<{ __typename?: 'TimeInterval', start?: number | null, end?: number | null }>, repeat?: { __typename?: 'RepeatAvailability', daysOfMonth?: Array<number> | null, daysOfWeek?: Array<DayOfWeek> | null, weekOfMonth?: WeekOfMonth | null, frequency: any, unit: RepeatUnit, end_date?: number | null } | null }> | null } | null, room?: { __typename?: 'Room', id: string, pms_id: string, name: string, display_name?: string | null, description?: string | null, concurrent_patients?: number | null, is_active: boolean, does_contribute_to_fill_rate?: boolean | null, valid_booking_interval_minutes?: Array<number> | null, created_at: number, updated_at: number, clinic?: { __typename?: 'Clinic', pms: PracticeManagementSystem, id: string, name?: string | null, time_zone?: string | null } | null, hours?: { __typename?: 'AvailabilityHours', monday?: Array<{ __typename?: 'TimeInterval', start?: number | null, end?: number | null }> | null, tuesday?: Array<{ __typename?: 'TimeInterval', start?: number | null, end?: number | null }> | null, wednesday?: Array<{ __typename?: 'TimeInterval', start?: number | null, end?: number | null }> | null, thursday?: Array<{ __typename?: 'TimeInterval', start?: number | null, end?: number | null }> | null, friday?: Array<{ __typename?: 'TimeInterval', start?: number | null, end?: number | null }> | null, saturday?: Array<{ __typename?: 'TimeInterval', start?: number | null, end?: number | null }> | null, sunday?: Array<{ __typename?: 'TimeInterval', start?: number | null, end?: number | null }> | null } | null, adjusted_availability?: Array<{ __typename?: 'Availability', date: number, pms_appt_type_pms_id?: string | null, times: Array<{ __typename?: 'TimeInterval', start?: number | null, end?: number | null }>, repeat?: { __typename?: 'RepeatAvailability', daysOfMonth?: Array<number> | null, daysOfWeek?: Array<DayOfWeek> | null, weekOfMonth?: WeekOfMonth | null, frequency: any, unit: RepeatUnit, end_date?: number | null } | null }> | null, pms_adjusted_availability?: Array<{ __typename?: 'Availability', date: number, pms_appt_type_pms_id?: string | null, times: Array<{ __typename?: 'TimeInterval', start?: number | null, end?: number | null }>, repeat?: { __typename?: 'RepeatAvailability', daysOfMonth?: Array<number> | null, daysOfWeek?: Array<DayOfWeek> | null, weekOfMonth?: WeekOfMonth | null, frequency: any, unit: RepeatUnit, end_date?: number | null } | null }> | null } | null, service?: { __typename?: 'Service', id: string, name?: string | null, color?: string | null } | null, patient?: { __typename?: 'Patient', id: string, pms?: PracticeManagementSystem | null, pms_id?: string | null, name?: string | null, breed?: string | null, avatar_url?: string | null, last_appt_time?: number | null, gender?: string | null, fixed_status?: FixedStatus | null, weight?: number | null, birthday?: number | null, is_active?: boolean | null, is_deceased?: boolean | null, pms_created_at?: number | null, created_at: number, updated_at: number, owner?: { __typename?: 'Client', id: string, first_name?: string | null, last_name?: string | null, email?: string | null, phone?: string | null, address?: { __typename?: 'Address', country?: string | null } | null } | null, clinic_species?: { __typename?: 'ClinicSpecies', id: string, pms_id: string, description: string, is_primary: boolean, species: Species, weight_key: string, created_at: number, updated_at: number } | null, clinic?: { __typename?: 'Clinic', id: string } | null, clinic_breed?: { __typename?: 'Breed', id: string, description: string } | null, patient_vaccination_records?: Array<{ __typename?: 'PatientVaccinationRecord', id: string, vaccine_name?: string | null, manufacturer?: string | null, lot_number?: string | null, administered_date?: number | null, due_date?: number | null, rabies_tag?: string | null, is_rabies_vaccine?: boolean | null, is_soc: boolean, is_active: boolean, product?: { __typename?: 'Product', id: string, display_name?: string | null, name: string } | null }> | null, last_appointment?: { __typename?: 'Appointment', clinician?: { __typename?: 'Clinician', name: string, display_name?: string | null } | null } | null } | null, clinic_appt_status?: { __typename?: 'ClinicApptStatus', id: string, description: string, status: AppointmentStatus } | null, client_info?: { __typename?: 'ClientInfo', first_name?: string | null, last_name?: string | null, email?: string | null, phone?: string | null } | null, patient_info?: { __typename?: 'PatientInfo', patient_name?: string | null, patient_breed?: string | null, patient_clinic_species?: string | null, patient_clinic_breed?: string | null } | null, clients_forms?: Array<{ __typename?: 'ClientForm', id: string, client_completed_at?: number | null, clinic_verified_at?: number | null, is_archived: boolean, pms_id?: string | null, created_at: number, updated_at: number, client?: { __typename?: 'Client', id: string, first_name?: string | null, last_name?: string | null, phone?: string | null, email?: string | null, address?: { __typename?: 'Address', street_a?: string | null, city?: string | null, state?: string | null, zip?: string | null, country?: string | null } | null } | null, patient?: { __typename?: 'Patient', id: string, name?: string | null, is_active?: boolean | null, is_deceased?: boolean | null, birthday?: number | null, weight?: number | null, avatar_url?: string | null, gender?: string | null, owner?: { __typename?: 'Client', first_name?: string | null, last_name?: string | null } | null, clinic_species?: { __typename?: 'ClinicSpecies', id: string, species: Species, description: string, weight_key: string } | null, clinic_breed?: { __typename?: 'Breed', id: string, description: string } | null } | null, form: { __typename?: 'Form', id: string, name?: string | null, form_type: FormType, is_writeback_enabled: boolean, form_file_naming_template?: string | null }, form_data: { __typename?: 'FormFields', pages?: Array<{ __typename?: 'FormPage', id: string, title?: string | null, description?: string | null, order?: number | null }> | null, fields?: Array<{ __typename?: 'FormElement', id: string, type?: FormElementType | null, content?: string | null, name?: string | null, column_order?: number | null, row_order?: number | null, page_id?: string | null, options?: Array<string> | null, is_required?: boolean | null, value?: string | null, attachments?: Array<{ __typename?: 'FormFileAttachment', id?: string | null, filename?: string | null, mime_type?: string | null, size_bytes?: number | null, thumbnail_url?: string | null, url: string }> | null, field_updates?: Array<{ __typename?: 'FormFieldUpdate', field: FormFieldUpdateField, boolean_value?: boolean | null, option?: string | null }> | null }> | null }, appointment?: { __typename?: 'Appointment', start_time: number, drop_off_time?: number | null, clinic?: { __typename?: 'Clinic', name?: string | null, slug?: string | null, phone?: string | null, email?: string | null, address?: { __typename?: 'Address', street_a?: string | null, city?: string | null, state?: string | null, zip?: string | null, country?: string | null } | null } | null, clinician?: { __typename?: 'Clinician', name: string, display_name?: string | null } | null, service?: { __typename?: 'Service', name?: string | null } | null } | null }> | null, widget?: { __typename?: 'Widget', id: string, widget_name: string } | null }> };

export type GetTimeSlotsForClinicForDayQueryVariables = Exact<{
  clinicId: Scalars['ID']['input'];
  date: Scalars['NonNegativeInt']['input'];
}>;


export type GetTimeSlotsForClinicForDayQuery = { __typename?: 'Query', getTimeSlotsForClinicForDay: Array<{ __typename?: 'OpenSlot', start_time: number, clinicians: Array<{ __typename?: 'Clinician', id: string, name: string }> }> };

export type GetTimeSlotsForSchedulingDaysQueryVariables = Exact<{
  clinicId: Scalars['ID']['input'];
  params: GetTimeSlotForSchedulingDaysParams;
}>;


export type GetTimeSlotsForSchedulingDaysQuery = { __typename?: 'Query', getTimeSlotsForSchedulingDays: Array<{ __typename?: 'TimeSlot', start_time: number, display_time?: number | null, selections: Array<{ __typename?: 'TimeSlotSelection', service_id?: string | null, clinicians: Array<{ __typename?: 'Clinician', id: string, name: string }>, rooms: Array<{ __typename?: 'Room', id: string, name: string }> }> }> };

export type GetAppointmentsCountByClinicQueryVariables = Exact<{
  where?: InputMaybe<Array<QueryInput> | QueryInput>;
}>;


export type GetAppointmentsCountByClinicQuery = { __typename?: 'Query', appointmentsCountByClinic: Array<{ __typename?: 'ClinicAppointmentCount', count: number, clinic: { __typename?: 'Clinic', id: string, name?: string | null, last_sync_times?: { __typename?: 'LastSyncTimes', last_sync_appointments?: number | null, last_sync_clients?: number | null, last_sync_patients?: number | null, last_full_sync?: number | null } | null } }> };

export type CreateAppointmentMutationVariables = Exact<{
  data: CreateAppointmentInput;
}>;


export type CreateAppointmentMutation = { __typename?: 'Mutation', createAppointment: { __typename?: 'Appointment', id: string, pms?: PracticeManagementSystem | null, client_pms_id?: string | null, is_new_client?: boolean | null, start_time: number, drop_off_time?: number | null, minutes: number, is_new_patient?: boolean | null, is_clinician_auto_assigned?: boolean | null, patient_pms_id?: string | null, referring_clinic_name?: string | null, client_notes?: string | null, clinic_notes?: string | null, service_name?: string | null, status: AppointmentStatus, is_time_block?: boolean | null, is_confirmed?: boolean | null, origin?: EntityOrigin | null, reason_for_cancellation?: string | null, client_reason_for_cancellation?: string | null, new_client_name?: string | null, new_client_phone?: string | null, new_patient_name?: string | null, new_patient_species?: string | null, confirmed_at?: number | null, widget_source?: string | null, from_widget?: string | null, is_deleted?: boolean | null, created_at: number, updated_at: number, pms_created_at?: number | null, clinic?: { __typename?: 'Clinic', id: string, name?: string | null, slug?: string | null, pms_db?: { __typename?: 'PmsDb', id: string } | null, address?: { __typename?: 'Address', country?: string | null } | null } | null, client?: { __typename?: 'Client', id: string, first_name?: string | null, last_name?: string | null, secondary_first_name?: string | null, secondary_last_name?: string | null, phone?: string | null, email?: string | null, pms?: PracticeManagementSystem | null, pms_id?: string | null, last_appt_time?: number | null, last_contact_time?: number | null, email_enabled: boolean, sms_enabled: boolean, balance?: number | null, is_active?: boolean | null, is_unsubscribed: boolean, created_at: number, updated_at: number, client_phones?: Array<{ __typename?: 'ClientPhone', id: string, phone: string, country_code?: string | null, is_primary: boolean, is_chckup_primary: boolean, is_mobile: boolean, sms_available: boolean, is_unsubscribed: boolean, is_active: boolean, name?: string | null }> | null, client_emails?: Array<{ __typename?: 'ClientEmail', id: string, email: string, is_primary: boolean }> | null, clinic?: { __typename?: 'Clinic', id: string } | null, patients?: Array<{ __typename?: 'Patient', id: string, pms?: PracticeManagementSystem | null, pms_id?: string | null, name?: string | null, breed?: string | null, avatar_url?: string | null, last_appt_time?: number | null, gender?: string | null, fixed_status?: FixedStatus | null, weight?: number | null, birthday?: number | null, is_active?: boolean | null, is_deceased?: boolean | null, pms_created_at?: number | null, created_at: number, updated_at: number, owner?: { __typename?: 'Client', id: string, first_name?: string | null, last_name?: string | null, email?: string | null, phone?: string | null, address?: { __typename?: 'Address', country?: string | null } | null } | null, clinic_species?: { __typename?: 'ClinicSpecies', id: string, pms_id: string, description: string, is_primary: boolean, species: Species, weight_key: string, created_at: number, updated_at: number } | null, clinic?: { __typename?: 'Clinic', id: string } | null, clinic_breed?: { __typename?: 'Breed', id: string, description: string } | null, patient_vaccination_records?: Array<{ __typename?: 'PatientVaccinationRecord', id: string, vaccine_name?: string | null, manufacturer?: string | null, lot_number?: string | null, administered_date?: number | null, due_date?: number | null, rabies_tag?: string | null, is_rabies_vaccine?: boolean | null, is_soc: boolean, is_active: boolean, product?: { __typename?: 'Product', id: string, display_name?: string | null, name: string } | null }> | null, last_appointment?: { __typename?: 'Appointment', clinician?: { __typename?: 'Clinician', name: string, display_name?: string | null } | null } | null }> | null, address?: { __typename?: 'Address', street_a?: string | null, street_b?: string | null, city?: string | null, state?: string | null, zip?: string | null, country?: string | null } | null, user?: { __typename?: 'User', avatar_url?: string | null } | null, loyalty_members?: Array<{ __typename?: 'LoyaltyMember', id: string, available_points: number } | null> | null, settings?: { __typename?: 'ClientSettings', clinic_chckup_notifications_enabled: boolean, clinic_chckup_sms_enabled: boolean, clinic_chckup_email_enabled: boolean, client_chckup_notifications_enabled: boolean, client_chckup_sms_enabled: boolean, client_chckup_email_enabled: boolean, is_unsubscribed_from_marketing: boolean, is_unsubscribed_from_marketing_sms: boolean, is_unsubscribed_from_marketing_email: boolean } | null, last_appointment?: { __typename?: 'Appointment', clinician?: { __typename?: 'Clinician', name: string, display_name?: string | null } | null } | null } | null, clinician?: { __typename?: 'Clinician', id: string, name: string, display_name?: string | null, bio?: string | null, avatar_url?: string | null, initials?: string | null, excluded_species?: Array<Species> | null, excluded_service_ids?: Array<string> | null, authority_level?: AuthorityLevel | null, type: ResourceType, is_active?: boolean | null, is_assignable_in_pms?: boolean | null, does_contribute_to_fill_rate?: boolean | null, pms_id?: string | null, location?: string | null, pms_is_active: boolean, valid_booking_interval_minutes?: Array<number> | null, created_at: number, updated_at: number, clinic?: { __typename?: 'Clinic', id: string, name?: string | null } | null, pms_db?: { __typename?: 'PmsDb', id: string } | null, hours?: { __typename?: 'AvailabilityHours', monday?: Array<{ __typename?: 'TimeInterval', start?: number | null, end?: number | null }> | null, tuesday?: Array<{ __typename?: 'TimeInterval', start?: number | null, end?: number | null }> | null, wednesday?: Array<{ __typename?: 'TimeInterval', start?: number | null, end?: number | null }> | null, thursday?: Array<{ __typename?: 'TimeInterval', start?: number | null, end?: number | null }> | null, friday?: Array<{ __typename?: 'TimeInterval', start?: number | null, end?: number | null }> | null, saturday?: Array<{ __typename?: 'TimeInterval', start?: number | null, end?: number | null }> | null, sunday?: Array<{ __typename?: 'TimeInterval', start?: number | null, end?: number | null }> | null } | null, adjusted_availability?: Array<{ __typename?: 'Availability', date: number, pms_appt_type_pms_id?: string | null, times: Array<{ __typename?: 'TimeInterval', start?: number | null, end?: number | null }>, repeat?: { __typename?: 'RepeatAvailability', daysOfMonth?: Array<number> | null, daysOfWeek?: Array<DayOfWeek> | null, weekOfMonth?: WeekOfMonth | null, frequency: any, unit: RepeatUnit, end_date?: number | null } | null }> | null, pms_adjusted_availability?: Array<{ __typename?: 'Availability', date: number, pms_appt_type_pms_id?: string | null, times: Array<{ __typename?: 'TimeInterval', start?: number | null, end?: number | null }>, repeat?: { __typename?: 'RepeatAvailability', daysOfMonth?: Array<number> | null, daysOfWeek?: Array<DayOfWeek> | null, weekOfMonth?: WeekOfMonth | null, frequency: any, unit: RepeatUnit, end_date?: number | null } | null }> | null } | null, room?: { __typename?: 'Room', id: string, pms_id: string, name: string, display_name?: string | null, description?: string | null, concurrent_patients?: number | null, is_active: boolean, does_contribute_to_fill_rate?: boolean | null, valid_booking_interval_minutes?: Array<number> | null, created_at: number, updated_at: number, clinic?: { __typename?: 'Clinic', pms: PracticeManagementSystem, id: string, name?: string | null, time_zone?: string | null } | null, hours?: { __typename?: 'AvailabilityHours', monday?: Array<{ __typename?: 'TimeInterval', start?: number | null, end?: number | null }> | null, tuesday?: Array<{ __typename?: 'TimeInterval', start?: number | null, end?: number | null }> | null, wednesday?: Array<{ __typename?: 'TimeInterval', start?: number | null, end?: number | null }> | null, thursday?: Array<{ __typename?: 'TimeInterval', start?: number | null, end?: number | null }> | null, friday?: Array<{ __typename?: 'TimeInterval', start?: number | null, end?: number | null }> | null, saturday?: Array<{ __typename?: 'TimeInterval', start?: number | null, end?: number | null }> | null, sunday?: Array<{ __typename?: 'TimeInterval', start?: number | null, end?: number | null }> | null } | null, adjusted_availability?: Array<{ __typename?: 'Availability', date: number, pms_appt_type_pms_id?: string | null, times: Array<{ __typename?: 'TimeInterval', start?: number | null, end?: number | null }>, repeat?: { __typename?: 'RepeatAvailability', daysOfMonth?: Array<number> | null, daysOfWeek?: Array<DayOfWeek> | null, weekOfMonth?: WeekOfMonth | null, frequency: any, unit: RepeatUnit, end_date?: number | null } | null }> | null, pms_adjusted_availability?: Array<{ __typename?: 'Availability', date: number, pms_appt_type_pms_id?: string | null, times: Array<{ __typename?: 'TimeInterval', start?: number | null, end?: number | null }>, repeat?: { __typename?: 'RepeatAvailability', daysOfMonth?: Array<number> | null, daysOfWeek?: Array<DayOfWeek> | null, weekOfMonth?: WeekOfMonth | null, frequency: any, unit: RepeatUnit, end_date?: number | null } | null }> | null } | null, service?: { __typename?: 'Service', id: string, name?: string | null, color?: string | null } | null, patient?: { __typename?: 'Patient', id: string, pms?: PracticeManagementSystem | null, pms_id?: string | null, name?: string | null, breed?: string | null, avatar_url?: string | null, last_appt_time?: number | null, gender?: string | null, fixed_status?: FixedStatus | null, weight?: number | null, birthday?: number | null, is_active?: boolean | null, is_deceased?: boolean | null, pms_created_at?: number | null, created_at: number, updated_at: number, owner?: { __typename?: 'Client', id: string, first_name?: string | null, last_name?: string | null, email?: string | null, phone?: string | null, address?: { __typename?: 'Address', country?: string | null } | null } | null, clinic_species?: { __typename?: 'ClinicSpecies', id: string, pms_id: string, description: string, is_primary: boolean, species: Species, weight_key: string, created_at: number, updated_at: number } | null, clinic?: { __typename?: 'Clinic', id: string } | null, clinic_breed?: { __typename?: 'Breed', id: string, description: string } | null, patient_vaccination_records?: Array<{ __typename?: 'PatientVaccinationRecord', id: string, vaccine_name?: string | null, manufacturer?: string | null, lot_number?: string | null, administered_date?: number | null, due_date?: number | null, rabies_tag?: string | null, is_rabies_vaccine?: boolean | null, is_soc: boolean, is_active: boolean, product?: { __typename?: 'Product', id: string, display_name?: string | null, name: string } | null }> | null, last_appointment?: { __typename?: 'Appointment', clinician?: { __typename?: 'Clinician', name: string, display_name?: string | null } | null } | null } | null, clinic_appt_status?: { __typename?: 'ClinicApptStatus', id: string, description: string, status: AppointmentStatus } | null, client_info?: { __typename?: 'ClientInfo', first_name?: string | null, last_name?: string | null, email?: string | null, phone?: string | null } | null, patient_info?: { __typename?: 'PatientInfo', patient_name?: string | null, patient_breed?: string | null, patient_clinic_species?: string | null, patient_clinic_breed?: string | null } | null, clients_forms?: Array<{ __typename?: 'ClientForm', id: string, client_completed_at?: number | null, clinic_verified_at?: number | null, is_archived: boolean, pms_id?: string | null, created_at: number, updated_at: number, client?: { __typename?: 'Client', id: string, first_name?: string | null, last_name?: string | null, phone?: string | null, email?: string | null, address?: { __typename?: 'Address', street_a?: string | null, city?: string | null, state?: string | null, zip?: string | null, country?: string | null } | null } | null, patient?: { __typename?: 'Patient', id: string, name?: string | null, is_active?: boolean | null, is_deceased?: boolean | null, birthday?: number | null, weight?: number | null, avatar_url?: string | null, gender?: string | null, owner?: { __typename?: 'Client', first_name?: string | null, last_name?: string | null } | null, clinic_species?: { __typename?: 'ClinicSpecies', id: string, species: Species, description: string, weight_key: string } | null, clinic_breed?: { __typename?: 'Breed', id: string, description: string } | null } | null, form: { __typename?: 'Form', id: string, name?: string | null, form_type: FormType, is_writeback_enabled: boolean, form_file_naming_template?: string | null }, form_data: { __typename?: 'FormFields', pages?: Array<{ __typename?: 'FormPage', id: string, title?: string | null, description?: string | null, order?: number | null }> | null, fields?: Array<{ __typename?: 'FormElement', id: string, type?: FormElementType | null, content?: string | null, name?: string | null, column_order?: number | null, row_order?: number | null, page_id?: string | null, options?: Array<string> | null, is_required?: boolean | null, value?: string | null, attachments?: Array<{ __typename?: 'FormFileAttachment', id?: string | null, filename?: string | null, mime_type?: string | null, size_bytes?: number | null, thumbnail_url?: string | null, url: string }> | null, field_updates?: Array<{ __typename?: 'FormFieldUpdate', field: FormFieldUpdateField, boolean_value?: boolean | null, option?: string | null }> | null }> | null }, appointment?: { __typename?: 'Appointment', start_time: number, drop_off_time?: number | null, clinic?: { __typename?: 'Clinic', name?: string | null, slug?: string | null, phone?: string | null, email?: string | null, address?: { __typename?: 'Address', street_a?: string | null, city?: string | null, state?: string | null, zip?: string | null, country?: string | null } | null } | null, clinician?: { __typename?: 'Clinician', name: string, display_name?: string | null } | null, service?: { __typename?: 'Service', name?: string | null } | null } | null }> | null, widget?: { __typename?: 'Widget', id: string, widget_name: string } | null } };

export type UpdateAppointmentMutationVariables = Exact<{
  id: Scalars['ID']['input'];
  data: UpdateAppointmentInput;
}>;


export type UpdateAppointmentMutation = { __typename?: 'Mutation', updateAppointment: { __typename?: 'Appointment', id: string, pms?: PracticeManagementSystem | null, client_pms_id?: string | null, is_new_client?: boolean | null, start_time: number, drop_off_time?: number | null, minutes: number, is_new_patient?: boolean | null, is_clinician_auto_assigned?: boolean | null, patient_pms_id?: string | null, referring_clinic_name?: string | null, client_notes?: string | null, clinic_notes?: string | null, service_name?: string | null, status: AppointmentStatus, is_time_block?: boolean | null, is_confirmed?: boolean | null, origin?: EntityOrigin | null, reason_for_cancellation?: string | null, client_reason_for_cancellation?: string | null, new_client_name?: string | null, new_client_phone?: string | null, new_patient_name?: string | null, new_patient_species?: string | null, confirmed_at?: number | null, widget_source?: string | null, from_widget?: string | null, is_deleted?: boolean | null, created_at: number, updated_at: number, pms_created_at?: number | null, clinic?: { __typename?: 'Clinic', id: string, name?: string | null, slug?: string | null, pms_db?: { __typename?: 'PmsDb', id: string } | null, address?: { __typename?: 'Address', country?: string | null } | null } | null, client?: { __typename?: 'Client', id: string, first_name?: string | null, last_name?: string | null, secondary_first_name?: string | null, secondary_last_name?: string | null, phone?: string | null, email?: string | null, pms?: PracticeManagementSystem | null, pms_id?: string | null, last_appt_time?: number | null, last_contact_time?: number | null, email_enabled: boolean, sms_enabled: boolean, balance?: number | null, is_active?: boolean | null, is_unsubscribed: boolean, created_at: number, updated_at: number, client_phones?: Array<{ __typename?: 'ClientPhone', id: string, phone: string, country_code?: string | null, is_primary: boolean, is_chckup_primary: boolean, is_mobile: boolean, sms_available: boolean, is_unsubscribed: boolean, is_active: boolean, name?: string | null }> | null, client_emails?: Array<{ __typename?: 'ClientEmail', id: string, email: string, is_primary: boolean }> | null, clinic?: { __typename?: 'Clinic', id: string } | null, patients?: Array<{ __typename?: 'Patient', id: string, pms?: PracticeManagementSystem | null, pms_id?: string | null, name?: string | null, breed?: string | null, avatar_url?: string | null, last_appt_time?: number | null, gender?: string | null, fixed_status?: FixedStatus | null, weight?: number | null, birthday?: number | null, is_active?: boolean | null, is_deceased?: boolean | null, pms_created_at?: number | null, created_at: number, updated_at: number, owner?: { __typename?: 'Client', id: string, first_name?: string | null, last_name?: string | null, email?: string | null, phone?: string | null, address?: { __typename?: 'Address', country?: string | null } | null } | null, clinic_species?: { __typename?: 'ClinicSpecies', id: string, pms_id: string, description: string, is_primary: boolean, species: Species, weight_key: string, created_at: number, updated_at: number } | null, clinic?: { __typename?: 'Clinic', id: string } | null, clinic_breed?: { __typename?: 'Breed', id: string, description: string } | null, patient_vaccination_records?: Array<{ __typename?: 'PatientVaccinationRecord', id: string, vaccine_name?: string | null, manufacturer?: string | null, lot_number?: string | null, administered_date?: number | null, due_date?: number | null, rabies_tag?: string | null, is_rabies_vaccine?: boolean | null, is_soc: boolean, is_active: boolean, product?: { __typename?: 'Product', id: string, display_name?: string | null, name: string } | null }> | null, last_appointment?: { __typename?: 'Appointment', clinician?: { __typename?: 'Clinician', name: string, display_name?: string | null } | null } | null }> | null, address?: { __typename?: 'Address', street_a?: string | null, street_b?: string | null, city?: string | null, state?: string | null, zip?: string | null, country?: string | null } | null, user?: { __typename?: 'User', avatar_url?: string | null } | null, loyalty_members?: Array<{ __typename?: 'LoyaltyMember', id: string, available_points: number } | null> | null, settings?: { __typename?: 'ClientSettings', clinic_chckup_notifications_enabled: boolean, clinic_chckup_sms_enabled: boolean, clinic_chckup_email_enabled: boolean, client_chckup_notifications_enabled: boolean, client_chckup_sms_enabled: boolean, client_chckup_email_enabled: boolean, is_unsubscribed_from_marketing: boolean, is_unsubscribed_from_marketing_sms: boolean, is_unsubscribed_from_marketing_email: boolean } | null, last_appointment?: { __typename?: 'Appointment', clinician?: { __typename?: 'Clinician', name: string, display_name?: string | null } | null } | null } | null, clinician?: { __typename?: 'Clinician', id: string, name: string, display_name?: string | null, bio?: string | null, avatar_url?: string | null, initials?: string | null, excluded_species?: Array<Species> | null, excluded_service_ids?: Array<string> | null, authority_level?: AuthorityLevel | null, type: ResourceType, is_active?: boolean | null, is_assignable_in_pms?: boolean | null, does_contribute_to_fill_rate?: boolean | null, pms_id?: string | null, location?: string | null, pms_is_active: boolean, valid_booking_interval_minutes?: Array<number> | null, created_at: number, updated_at: number, clinic?: { __typename?: 'Clinic', id: string, name?: string | null } | null, pms_db?: { __typename?: 'PmsDb', id: string } | null, hours?: { __typename?: 'AvailabilityHours', monday?: Array<{ __typename?: 'TimeInterval', start?: number | null, end?: number | null }> | null, tuesday?: Array<{ __typename?: 'TimeInterval', start?: number | null, end?: number | null }> | null, wednesday?: Array<{ __typename?: 'TimeInterval', start?: number | null, end?: number | null }> | null, thursday?: Array<{ __typename?: 'TimeInterval', start?: number | null, end?: number | null }> | null, friday?: Array<{ __typename?: 'TimeInterval', start?: number | null, end?: number | null }> | null, saturday?: Array<{ __typename?: 'TimeInterval', start?: number | null, end?: number | null }> | null, sunday?: Array<{ __typename?: 'TimeInterval', start?: number | null, end?: number | null }> | null } | null, adjusted_availability?: Array<{ __typename?: 'Availability', date: number, pms_appt_type_pms_id?: string | null, times: Array<{ __typename?: 'TimeInterval', start?: number | null, end?: number | null }>, repeat?: { __typename?: 'RepeatAvailability', daysOfMonth?: Array<number> | null, daysOfWeek?: Array<DayOfWeek> | null, weekOfMonth?: WeekOfMonth | null, frequency: any, unit: RepeatUnit, end_date?: number | null } | null }> | null, pms_adjusted_availability?: Array<{ __typename?: 'Availability', date: number, pms_appt_type_pms_id?: string | null, times: Array<{ __typename?: 'TimeInterval', start?: number | null, end?: number | null }>, repeat?: { __typename?: 'RepeatAvailability', daysOfMonth?: Array<number> | null, daysOfWeek?: Array<DayOfWeek> | null, weekOfMonth?: WeekOfMonth | null, frequency: any, unit: RepeatUnit, end_date?: number | null } | null }> | null } | null, room?: { __typename?: 'Room', id: string, pms_id: string, name: string, display_name?: string | null, description?: string | null, concurrent_patients?: number | null, is_active: boolean, does_contribute_to_fill_rate?: boolean | null, valid_booking_interval_minutes?: Array<number> | null, created_at: number, updated_at: number, clinic?: { __typename?: 'Clinic', pms: PracticeManagementSystem, id: string, name?: string | null, time_zone?: string | null } | null, hours?: { __typename?: 'AvailabilityHours', monday?: Array<{ __typename?: 'TimeInterval', start?: number | null, end?: number | null }> | null, tuesday?: Array<{ __typename?: 'TimeInterval', start?: number | null, end?: number | null }> | null, wednesday?: Array<{ __typename?: 'TimeInterval', start?: number | null, end?: number | null }> | null, thursday?: Array<{ __typename?: 'TimeInterval', start?: number | null, end?: number | null }> | null, friday?: Array<{ __typename?: 'TimeInterval', start?: number | null, end?: number | null }> | null, saturday?: Array<{ __typename?: 'TimeInterval', start?: number | null, end?: number | null }> | null, sunday?: Array<{ __typename?: 'TimeInterval', start?: number | null, end?: number | null }> | null } | null, adjusted_availability?: Array<{ __typename?: 'Availability', date: number, pms_appt_type_pms_id?: string | null, times: Array<{ __typename?: 'TimeInterval', start?: number | null, end?: number | null }>, repeat?: { __typename?: 'RepeatAvailability', daysOfMonth?: Array<number> | null, daysOfWeek?: Array<DayOfWeek> | null, weekOfMonth?: WeekOfMonth | null, frequency: any, unit: RepeatUnit, end_date?: number | null } | null }> | null, pms_adjusted_availability?: Array<{ __typename?: 'Availability', date: number, pms_appt_type_pms_id?: string | null, times: Array<{ __typename?: 'TimeInterval', start?: number | null, end?: number | null }>, repeat?: { __typename?: 'RepeatAvailability', daysOfMonth?: Array<number> | null, daysOfWeek?: Array<DayOfWeek> | null, weekOfMonth?: WeekOfMonth | null, frequency: any, unit: RepeatUnit, end_date?: number | null } | null }> | null } | null, service?: { __typename?: 'Service', id: string, name?: string | null, color?: string | null } | null, patient?: { __typename?: 'Patient', id: string, pms?: PracticeManagementSystem | null, pms_id?: string | null, name?: string | null, breed?: string | null, avatar_url?: string | null, last_appt_time?: number | null, gender?: string | null, fixed_status?: FixedStatus | null, weight?: number | null, birthday?: number | null, is_active?: boolean | null, is_deceased?: boolean | null, pms_created_at?: number | null, created_at: number, updated_at: number, owner?: { __typename?: 'Client', id: string, first_name?: string | null, last_name?: string | null, email?: string | null, phone?: string | null, address?: { __typename?: 'Address', country?: string | null } | null } | null, clinic_species?: { __typename?: 'ClinicSpecies', id: string, pms_id: string, description: string, is_primary: boolean, species: Species, weight_key: string, created_at: number, updated_at: number } | null, clinic?: { __typename?: 'Clinic', id: string } | null, clinic_breed?: { __typename?: 'Breed', id: string, description: string } | null, patient_vaccination_records?: Array<{ __typename?: 'PatientVaccinationRecord', id: string, vaccine_name?: string | null, manufacturer?: string | null, lot_number?: string | null, administered_date?: number | null, due_date?: number | null, rabies_tag?: string | null, is_rabies_vaccine?: boolean | null, is_soc: boolean, is_active: boolean, product?: { __typename?: 'Product', id: string, display_name?: string | null, name: string } | null }> | null, last_appointment?: { __typename?: 'Appointment', clinician?: { __typename?: 'Clinician', name: string, display_name?: string | null } | null } | null } | null, clinic_appt_status?: { __typename?: 'ClinicApptStatus', id: string, description: string, status: AppointmentStatus } | null, client_info?: { __typename?: 'ClientInfo', first_name?: string | null, last_name?: string | null, email?: string | null, phone?: string | null } | null, patient_info?: { __typename?: 'PatientInfo', patient_name?: string | null, patient_breed?: string | null, patient_clinic_species?: string | null, patient_clinic_breed?: string | null } | null, clients_forms?: Array<{ __typename?: 'ClientForm', id: string, client_completed_at?: number | null, clinic_verified_at?: number | null, is_archived: boolean, pms_id?: string | null, created_at: number, updated_at: number, client?: { __typename?: 'Client', id: string, first_name?: string | null, last_name?: string | null, phone?: string | null, email?: string | null, address?: { __typename?: 'Address', street_a?: string | null, city?: string | null, state?: string | null, zip?: string | null, country?: string | null } | null } | null, patient?: { __typename?: 'Patient', id: string, name?: string | null, is_active?: boolean | null, is_deceased?: boolean | null, birthday?: number | null, weight?: number | null, avatar_url?: string | null, gender?: string | null, owner?: { __typename?: 'Client', first_name?: string | null, last_name?: string | null } | null, clinic_species?: { __typename?: 'ClinicSpecies', id: string, species: Species, description: string, weight_key: string } | null, clinic_breed?: { __typename?: 'Breed', id: string, description: string } | null } | null, form: { __typename?: 'Form', id: string, name?: string | null, form_type: FormType, is_writeback_enabled: boolean, form_file_naming_template?: string | null }, form_data: { __typename?: 'FormFields', pages?: Array<{ __typename?: 'FormPage', id: string, title?: string | null, description?: string | null, order?: number | null }> | null, fields?: Array<{ __typename?: 'FormElement', id: string, type?: FormElementType | null, content?: string | null, name?: string | null, column_order?: number | null, row_order?: number | null, page_id?: string | null, options?: Array<string> | null, is_required?: boolean | null, value?: string | null, attachments?: Array<{ __typename?: 'FormFileAttachment', id?: string | null, filename?: string | null, mime_type?: string | null, size_bytes?: number | null, thumbnail_url?: string | null, url: string }> | null, field_updates?: Array<{ __typename?: 'FormFieldUpdate', field: FormFieldUpdateField, boolean_value?: boolean | null, option?: string | null }> | null }> | null }, appointment?: { __typename?: 'Appointment', start_time: number, drop_off_time?: number | null, clinic?: { __typename?: 'Clinic', name?: string | null, slug?: string | null, phone?: string | null, email?: string | null, address?: { __typename?: 'Address', street_a?: string | null, city?: string | null, state?: string | null, zip?: string | null, country?: string | null } | null } | null, clinician?: { __typename?: 'Clinician', name: string, display_name?: string | null } | null, service?: { __typename?: 'Service', name?: string | null } | null } | null }> | null, widget?: { __typename?: 'Widget', id: string, widget_name: string } | null } };

export type MarkAppointmentAsResolvedMutationVariables = Exact<{
  id: Scalars['ID']['input'];
  reason?: InputMaybe<ResolveReason>;
}>;


export type MarkAppointmentAsResolvedMutation = { __typename?: 'Mutation', markAppointmentAsResolved: { __typename?: 'Appointment', id: string, pms?: PracticeManagementSystem | null, client_pms_id?: string | null, is_new_client?: boolean | null, start_time: number, drop_off_time?: number | null, minutes: number, is_new_patient?: boolean | null, is_clinician_auto_assigned?: boolean | null, patient_pms_id?: string | null, referring_clinic_name?: string | null, client_notes?: string | null, clinic_notes?: string | null, service_name?: string | null, status: AppointmentStatus, is_time_block?: boolean | null, is_confirmed?: boolean | null, origin?: EntityOrigin | null, reason_for_cancellation?: string | null, client_reason_for_cancellation?: string | null, new_client_name?: string | null, new_client_phone?: string | null, new_patient_name?: string | null, new_patient_species?: string | null, confirmed_at?: number | null, widget_source?: string | null, from_widget?: string | null, is_deleted?: boolean | null, created_at: number, updated_at: number, pms_created_at?: number | null, clinic?: { __typename?: 'Clinic', id: string, name?: string | null, slug?: string | null, pms_db?: { __typename?: 'PmsDb', id: string } | null, address?: { __typename?: 'Address', country?: string | null } | null } | null, client?: { __typename?: 'Client', id: string, first_name?: string | null, last_name?: string | null, secondary_first_name?: string | null, secondary_last_name?: string | null, phone?: string | null, email?: string | null, pms?: PracticeManagementSystem | null, pms_id?: string | null, last_appt_time?: number | null, last_contact_time?: number | null, email_enabled: boolean, sms_enabled: boolean, balance?: number | null, is_active?: boolean | null, is_unsubscribed: boolean, created_at: number, updated_at: number, client_phones?: Array<{ __typename?: 'ClientPhone', id: string, phone: string, country_code?: string | null, is_primary: boolean, is_chckup_primary: boolean, is_mobile: boolean, sms_available: boolean, is_unsubscribed: boolean, is_active: boolean, name?: string | null }> | null, client_emails?: Array<{ __typename?: 'ClientEmail', id: string, email: string, is_primary: boolean }> | null, clinic?: { __typename?: 'Clinic', id: string } | null, patients?: Array<{ __typename?: 'Patient', id: string, pms?: PracticeManagementSystem | null, pms_id?: string | null, name?: string | null, breed?: string | null, avatar_url?: string | null, last_appt_time?: number | null, gender?: string | null, fixed_status?: FixedStatus | null, weight?: number | null, birthday?: number | null, is_active?: boolean | null, is_deceased?: boolean | null, pms_created_at?: number | null, created_at: number, updated_at: number, owner?: { __typename?: 'Client', id: string, first_name?: string | null, last_name?: string | null, email?: string | null, phone?: string | null, address?: { __typename?: 'Address', country?: string | null } | null } | null, clinic_species?: { __typename?: 'ClinicSpecies', id: string, pms_id: string, description: string, is_primary: boolean, species: Species, weight_key: string, created_at: number, updated_at: number } | null, clinic?: { __typename?: 'Clinic', id: string } | null, clinic_breed?: { __typename?: 'Breed', id: string, description: string } | null, patient_vaccination_records?: Array<{ __typename?: 'PatientVaccinationRecord', id: string, vaccine_name?: string | null, manufacturer?: string | null, lot_number?: string | null, administered_date?: number | null, due_date?: number | null, rabies_tag?: string | null, is_rabies_vaccine?: boolean | null, is_soc: boolean, is_active: boolean, product?: { __typename?: 'Product', id: string, display_name?: string | null, name: string } | null }> | null, last_appointment?: { __typename?: 'Appointment', clinician?: { __typename?: 'Clinician', name: string, display_name?: string | null } | null } | null }> | null, address?: { __typename?: 'Address', street_a?: string | null, street_b?: string | null, city?: string | null, state?: string | null, zip?: string | null, country?: string | null } | null, user?: { __typename?: 'User', avatar_url?: string | null } | null, loyalty_members?: Array<{ __typename?: 'LoyaltyMember', id: string, available_points: number } | null> | null, settings?: { __typename?: 'ClientSettings', clinic_chckup_notifications_enabled: boolean, clinic_chckup_sms_enabled: boolean, clinic_chckup_email_enabled: boolean, client_chckup_notifications_enabled: boolean, client_chckup_sms_enabled: boolean, client_chckup_email_enabled: boolean, is_unsubscribed_from_marketing: boolean, is_unsubscribed_from_marketing_sms: boolean, is_unsubscribed_from_marketing_email: boolean } | null, last_appointment?: { __typename?: 'Appointment', clinician?: { __typename?: 'Clinician', name: string, display_name?: string | null } | null } | null } | null, clinician?: { __typename?: 'Clinician', id: string, name: string, display_name?: string | null, bio?: string | null, avatar_url?: string | null, initials?: string | null, excluded_species?: Array<Species> | null, excluded_service_ids?: Array<string> | null, authority_level?: AuthorityLevel | null, type: ResourceType, is_active?: boolean | null, is_assignable_in_pms?: boolean | null, does_contribute_to_fill_rate?: boolean | null, pms_id?: string | null, location?: string | null, pms_is_active: boolean, valid_booking_interval_minutes?: Array<number> | null, created_at: number, updated_at: number, clinic?: { __typename?: 'Clinic', id: string, name?: string | null } | null, pms_db?: { __typename?: 'PmsDb', id: string } | null, hours?: { __typename?: 'AvailabilityHours', monday?: Array<{ __typename?: 'TimeInterval', start?: number | null, end?: number | null }> | null, tuesday?: Array<{ __typename?: 'TimeInterval', start?: number | null, end?: number | null }> | null, wednesday?: Array<{ __typename?: 'TimeInterval', start?: number | null, end?: number | null }> | null, thursday?: Array<{ __typename?: 'TimeInterval', start?: number | null, end?: number | null }> | null, friday?: Array<{ __typename?: 'TimeInterval', start?: number | null, end?: number | null }> | null, saturday?: Array<{ __typename?: 'TimeInterval', start?: number | null, end?: number | null }> | null, sunday?: Array<{ __typename?: 'TimeInterval', start?: number | null, end?: number | null }> | null } | null, adjusted_availability?: Array<{ __typename?: 'Availability', date: number, pms_appt_type_pms_id?: string | null, times: Array<{ __typename?: 'TimeInterval', start?: number | null, end?: number | null }>, repeat?: { __typename?: 'RepeatAvailability', daysOfMonth?: Array<number> | null, daysOfWeek?: Array<DayOfWeek> | null, weekOfMonth?: WeekOfMonth | null, frequency: any, unit: RepeatUnit, end_date?: number | null } | null }> | null, pms_adjusted_availability?: Array<{ __typename?: 'Availability', date: number, pms_appt_type_pms_id?: string | null, times: Array<{ __typename?: 'TimeInterval', start?: number | null, end?: number | null }>, repeat?: { __typename?: 'RepeatAvailability', daysOfMonth?: Array<number> | null, daysOfWeek?: Array<DayOfWeek> | null, weekOfMonth?: WeekOfMonth | null, frequency: any, unit: RepeatUnit, end_date?: number | null } | null }> | null } | null, room?: { __typename?: 'Room', id: string, pms_id: string, name: string, display_name?: string | null, description?: string | null, concurrent_patients?: number | null, is_active: boolean, does_contribute_to_fill_rate?: boolean | null, valid_booking_interval_minutes?: Array<number> | null, created_at: number, updated_at: number, clinic?: { __typename?: 'Clinic', pms: PracticeManagementSystem, id: string, name?: string | null, time_zone?: string | null } | null, hours?: { __typename?: 'AvailabilityHours', monday?: Array<{ __typename?: 'TimeInterval', start?: number | null, end?: number | null }> | null, tuesday?: Array<{ __typename?: 'TimeInterval', start?: number | null, end?: number | null }> | null, wednesday?: Array<{ __typename?: 'TimeInterval', start?: number | null, end?: number | null }> | null, thursday?: Array<{ __typename?: 'TimeInterval', start?: number | null, end?: number | null }> | null, friday?: Array<{ __typename?: 'TimeInterval', start?: number | null, end?: number | null }> | null, saturday?: Array<{ __typename?: 'TimeInterval', start?: number | null, end?: number | null }> | null, sunday?: Array<{ __typename?: 'TimeInterval', start?: number | null, end?: number | null }> | null } | null, adjusted_availability?: Array<{ __typename?: 'Availability', date: number, pms_appt_type_pms_id?: string | null, times: Array<{ __typename?: 'TimeInterval', start?: number | null, end?: number | null }>, repeat?: { __typename?: 'RepeatAvailability', daysOfMonth?: Array<number> | null, daysOfWeek?: Array<DayOfWeek> | null, weekOfMonth?: WeekOfMonth | null, frequency: any, unit: RepeatUnit, end_date?: number | null } | null }> | null, pms_adjusted_availability?: Array<{ __typename?: 'Availability', date: number, pms_appt_type_pms_id?: string | null, times: Array<{ __typename?: 'TimeInterval', start?: number | null, end?: number | null }>, repeat?: { __typename?: 'RepeatAvailability', daysOfMonth?: Array<number> | null, daysOfWeek?: Array<DayOfWeek> | null, weekOfMonth?: WeekOfMonth | null, frequency: any, unit: RepeatUnit, end_date?: number | null } | null }> | null } | null, service?: { __typename?: 'Service', id: string, name?: string | null, color?: string | null } | null, patient?: { __typename?: 'Patient', id: string, pms?: PracticeManagementSystem | null, pms_id?: string | null, name?: string | null, breed?: string | null, avatar_url?: string | null, last_appt_time?: number | null, gender?: string | null, fixed_status?: FixedStatus | null, weight?: number | null, birthday?: number | null, is_active?: boolean | null, is_deceased?: boolean | null, pms_created_at?: number | null, created_at: number, updated_at: number, owner?: { __typename?: 'Client', id: string, first_name?: string | null, last_name?: string | null, email?: string | null, phone?: string | null, address?: { __typename?: 'Address', country?: string | null } | null } | null, clinic_species?: { __typename?: 'ClinicSpecies', id: string, pms_id: string, description: string, is_primary: boolean, species: Species, weight_key: string, created_at: number, updated_at: number } | null, clinic?: { __typename?: 'Clinic', id: string } | null, clinic_breed?: { __typename?: 'Breed', id: string, description: string } | null, patient_vaccination_records?: Array<{ __typename?: 'PatientVaccinationRecord', id: string, vaccine_name?: string | null, manufacturer?: string | null, lot_number?: string | null, administered_date?: number | null, due_date?: number | null, rabies_tag?: string | null, is_rabies_vaccine?: boolean | null, is_soc: boolean, is_active: boolean, product?: { __typename?: 'Product', id: string, display_name?: string | null, name: string } | null }> | null, last_appointment?: { __typename?: 'Appointment', clinician?: { __typename?: 'Clinician', name: string, display_name?: string | null } | null } | null } | null, clinic_appt_status?: { __typename?: 'ClinicApptStatus', id: string, description: string, status: AppointmentStatus } | null, client_info?: { __typename?: 'ClientInfo', first_name?: string | null, last_name?: string | null, email?: string | null, phone?: string | null } | null, patient_info?: { __typename?: 'PatientInfo', patient_name?: string | null, patient_breed?: string | null, patient_clinic_species?: string | null, patient_clinic_breed?: string | null } | null, clients_forms?: Array<{ __typename?: 'ClientForm', id: string, client_completed_at?: number | null, clinic_verified_at?: number | null, is_archived: boolean, pms_id?: string | null, created_at: number, updated_at: number, client?: { __typename?: 'Client', id: string, first_name?: string | null, last_name?: string | null, phone?: string | null, email?: string | null, address?: { __typename?: 'Address', street_a?: string | null, city?: string | null, state?: string | null, zip?: string | null, country?: string | null } | null } | null, patient?: { __typename?: 'Patient', id: string, name?: string | null, is_active?: boolean | null, is_deceased?: boolean | null, birthday?: number | null, weight?: number | null, avatar_url?: string | null, gender?: string | null, owner?: { __typename?: 'Client', first_name?: string | null, last_name?: string | null } | null, clinic_species?: { __typename?: 'ClinicSpecies', id: string, species: Species, description: string, weight_key: string } | null, clinic_breed?: { __typename?: 'Breed', id: string, description: string } | null } | null, form: { __typename?: 'Form', id: string, name?: string | null, form_type: FormType, is_writeback_enabled: boolean, form_file_naming_template?: string | null }, form_data: { __typename?: 'FormFields', pages?: Array<{ __typename?: 'FormPage', id: string, title?: string | null, description?: string | null, order?: number | null }> | null, fields?: Array<{ __typename?: 'FormElement', id: string, type?: FormElementType | null, content?: string | null, name?: string | null, column_order?: number | null, row_order?: number | null, page_id?: string | null, options?: Array<string> | null, is_required?: boolean | null, value?: string | null, attachments?: Array<{ __typename?: 'FormFileAttachment', id?: string | null, filename?: string | null, mime_type?: string | null, size_bytes?: number | null, thumbnail_url?: string | null, url: string }> | null, field_updates?: Array<{ __typename?: 'FormFieldUpdate', field: FormFieldUpdateField, boolean_value?: boolean | null, option?: string | null }> | null }> | null }, appointment?: { __typename?: 'Appointment', start_time: number, drop_off_time?: number | null, clinic?: { __typename?: 'Clinic', name?: string | null, slug?: string | null, phone?: string | null, email?: string | null, address?: { __typename?: 'Address', street_a?: string | null, city?: string | null, state?: string | null, zip?: string | null, country?: string | null } | null } | null, clinician?: { __typename?: 'Clinician', name: string, display_name?: string | null } | null, service?: { __typename?: 'Service', name?: string | null } | null } | null }> | null, widget?: { __typename?: 'Widget', id: string, widget_name: string } | null } };

export type ConfirmAppointmentMutationVariables = Exact<{
  id: Scalars['ID']['input'];
}>;


export type ConfirmAppointmentMutation = { __typename?: 'Mutation', confirmAppointment: boolean };

export type UpdateAppointmentClientPatientMutationVariables = Exact<{
  id: Scalars['ID']['input'];
  clientId?: InputMaybe<Scalars['ID']['input']>;
  patientId?: InputMaybe<Scalars['ID']['input']>;
}>;


export type UpdateAppointmentClientPatientMutation = { __typename?: 'Mutation', updateAppointmentClientPatient: { __typename?: 'Appointment', id: string, pms?: PracticeManagementSystem | null, client_pms_id?: string | null, is_new_client?: boolean | null, start_time: number, drop_off_time?: number | null, minutes: number, is_new_patient?: boolean | null, is_clinician_auto_assigned?: boolean | null, patient_pms_id?: string | null, referring_clinic_name?: string | null, client_notes?: string | null, clinic_notes?: string | null, service_name?: string | null, status: AppointmentStatus, is_time_block?: boolean | null, is_confirmed?: boolean | null, origin?: EntityOrigin | null, reason_for_cancellation?: string | null, client_reason_for_cancellation?: string | null, new_client_name?: string | null, new_client_phone?: string | null, new_patient_name?: string | null, new_patient_species?: string | null, confirmed_at?: number | null, widget_source?: string | null, from_widget?: string | null, is_deleted?: boolean | null, created_at: number, updated_at: number, pms_created_at?: number | null, clinic?: { __typename?: 'Clinic', id: string, name?: string | null, slug?: string | null, pms_db?: { __typename?: 'PmsDb', id: string } | null, address?: { __typename?: 'Address', country?: string | null } | null } | null, client?: { __typename?: 'Client', id: string, first_name?: string | null, last_name?: string | null, secondary_first_name?: string | null, secondary_last_name?: string | null, phone?: string | null, email?: string | null, pms?: PracticeManagementSystem | null, pms_id?: string | null, last_appt_time?: number | null, last_contact_time?: number | null, email_enabled: boolean, sms_enabled: boolean, balance?: number | null, is_active?: boolean | null, is_unsubscribed: boolean, created_at: number, updated_at: number, client_phones?: Array<{ __typename?: 'ClientPhone', id: string, phone: string, country_code?: string | null, is_primary: boolean, is_chckup_primary: boolean, is_mobile: boolean, sms_available: boolean, is_unsubscribed: boolean, is_active: boolean, name?: string | null }> | null, client_emails?: Array<{ __typename?: 'ClientEmail', id: string, email: string, is_primary: boolean }> | null, clinic?: { __typename?: 'Clinic', id: string } | null, patients?: Array<{ __typename?: 'Patient', id: string, pms?: PracticeManagementSystem | null, pms_id?: string | null, name?: string | null, breed?: string | null, avatar_url?: string | null, last_appt_time?: number | null, gender?: string | null, fixed_status?: FixedStatus | null, weight?: number | null, birthday?: number | null, is_active?: boolean | null, is_deceased?: boolean | null, pms_created_at?: number | null, created_at: number, updated_at: number, owner?: { __typename?: 'Client', id: string, first_name?: string | null, last_name?: string | null, email?: string | null, phone?: string | null, address?: { __typename?: 'Address', country?: string | null } | null } | null, clinic_species?: { __typename?: 'ClinicSpecies', id: string, pms_id: string, description: string, is_primary: boolean, species: Species, weight_key: string, created_at: number, updated_at: number } | null, clinic?: { __typename?: 'Clinic', id: string } | null, clinic_breed?: { __typename?: 'Breed', id: string, description: string } | null, patient_vaccination_records?: Array<{ __typename?: 'PatientVaccinationRecord', id: string, vaccine_name?: string | null, manufacturer?: string | null, lot_number?: string | null, administered_date?: number | null, due_date?: number | null, rabies_tag?: string | null, is_rabies_vaccine?: boolean | null, is_soc: boolean, is_active: boolean, product?: { __typename?: 'Product', id: string, display_name?: string | null, name: string } | null }> | null, last_appointment?: { __typename?: 'Appointment', clinician?: { __typename?: 'Clinician', name: string, display_name?: string | null } | null } | null }> | null, address?: { __typename?: 'Address', street_a?: string | null, street_b?: string | null, city?: string | null, state?: string | null, zip?: string | null, country?: string | null } | null, user?: { __typename?: 'User', avatar_url?: string | null } | null, loyalty_members?: Array<{ __typename?: 'LoyaltyMember', id: string, available_points: number } | null> | null, settings?: { __typename?: 'ClientSettings', clinic_chckup_notifications_enabled: boolean, clinic_chckup_sms_enabled: boolean, clinic_chckup_email_enabled: boolean, client_chckup_notifications_enabled: boolean, client_chckup_sms_enabled: boolean, client_chckup_email_enabled: boolean, is_unsubscribed_from_marketing: boolean, is_unsubscribed_from_marketing_sms: boolean, is_unsubscribed_from_marketing_email: boolean } | null, last_appointment?: { __typename?: 'Appointment', clinician?: { __typename?: 'Clinician', name: string, display_name?: string | null } | null } | null } | null, clinician?: { __typename?: 'Clinician', id: string, name: string, display_name?: string | null, bio?: string | null, avatar_url?: string | null, initials?: string | null, excluded_species?: Array<Species> | null, excluded_service_ids?: Array<string> | null, authority_level?: AuthorityLevel | null, type: ResourceType, is_active?: boolean | null, is_assignable_in_pms?: boolean | null, does_contribute_to_fill_rate?: boolean | null, pms_id?: string | null, location?: string | null, pms_is_active: boolean, valid_booking_interval_minutes?: Array<number> | null, created_at: number, updated_at: number, clinic?: { __typename?: 'Clinic', id: string, name?: string | null } | null, pms_db?: { __typename?: 'PmsDb', id: string } | null, hours?: { __typename?: 'AvailabilityHours', monday?: Array<{ __typename?: 'TimeInterval', start?: number | null, end?: number | null }> | null, tuesday?: Array<{ __typename?: 'TimeInterval', start?: number | null, end?: number | null }> | null, wednesday?: Array<{ __typename?: 'TimeInterval', start?: number | null, end?: number | null }> | null, thursday?: Array<{ __typename?: 'TimeInterval', start?: number | null, end?: number | null }> | null, friday?: Array<{ __typename?: 'TimeInterval', start?: number | null, end?: number | null }> | null, saturday?: Array<{ __typename?: 'TimeInterval', start?: number | null, end?: number | null }> | null, sunday?: Array<{ __typename?: 'TimeInterval', start?: number | null, end?: number | null }> | null } | null, adjusted_availability?: Array<{ __typename?: 'Availability', date: number, pms_appt_type_pms_id?: string | null, times: Array<{ __typename?: 'TimeInterval', start?: number | null, end?: number | null }>, repeat?: { __typename?: 'RepeatAvailability', daysOfMonth?: Array<number> | null, daysOfWeek?: Array<DayOfWeek> | null, weekOfMonth?: WeekOfMonth | null, frequency: any, unit: RepeatUnit, end_date?: number | null } | null }> | null, pms_adjusted_availability?: Array<{ __typename?: 'Availability', date: number, pms_appt_type_pms_id?: string | null, times: Array<{ __typename?: 'TimeInterval', start?: number | null, end?: number | null }>, repeat?: { __typename?: 'RepeatAvailability', daysOfMonth?: Array<number> | null, daysOfWeek?: Array<DayOfWeek> | null, weekOfMonth?: WeekOfMonth | null, frequency: any, unit: RepeatUnit, end_date?: number | null } | null }> | null } | null, room?: { __typename?: 'Room', id: string, pms_id: string, name: string, display_name?: string | null, description?: string | null, concurrent_patients?: number | null, is_active: boolean, does_contribute_to_fill_rate?: boolean | null, valid_booking_interval_minutes?: Array<number> | null, created_at: number, updated_at: number, clinic?: { __typename?: 'Clinic', pms: PracticeManagementSystem, id: string, name?: string | null, time_zone?: string | null } | null, hours?: { __typename?: 'AvailabilityHours', monday?: Array<{ __typename?: 'TimeInterval', start?: number | null, end?: number | null }> | null, tuesday?: Array<{ __typename?: 'TimeInterval', start?: number | null, end?: number | null }> | null, wednesday?: Array<{ __typename?: 'TimeInterval', start?: number | null, end?: number | null }> | null, thursday?: Array<{ __typename?: 'TimeInterval', start?: number | null, end?: number | null }> | null, friday?: Array<{ __typename?: 'TimeInterval', start?: number | null, end?: number | null }> | null, saturday?: Array<{ __typename?: 'TimeInterval', start?: number | null, end?: number | null }> | null, sunday?: Array<{ __typename?: 'TimeInterval', start?: number | null, end?: number | null }> | null } | null, adjusted_availability?: Array<{ __typename?: 'Availability', date: number, pms_appt_type_pms_id?: string | null, times: Array<{ __typename?: 'TimeInterval', start?: number | null, end?: number | null }>, repeat?: { __typename?: 'RepeatAvailability', daysOfMonth?: Array<number> | null, daysOfWeek?: Array<DayOfWeek> | null, weekOfMonth?: WeekOfMonth | null, frequency: any, unit: RepeatUnit, end_date?: number | null } | null }> | null, pms_adjusted_availability?: Array<{ __typename?: 'Availability', date: number, pms_appt_type_pms_id?: string | null, times: Array<{ __typename?: 'TimeInterval', start?: number | null, end?: number | null }>, repeat?: { __typename?: 'RepeatAvailability', daysOfMonth?: Array<number> | null, daysOfWeek?: Array<DayOfWeek> | null, weekOfMonth?: WeekOfMonth | null, frequency: any, unit: RepeatUnit, end_date?: number | null } | null }> | null } | null, service?: { __typename?: 'Service', id: string, name?: string | null, color?: string | null } | null, patient?: { __typename?: 'Patient', id: string, pms?: PracticeManagementSystem | null, pms_id?: string | null, name?: string | null, breed?: string | null, avatar_url?: string | null, last_appt_time?: number | null, gender?: string | null, fixed_status?: FixedStatus | null, weight?: number | null, birthday?: number | null, is_active?: boolean | null, is_deceased?: boolean | null, pms_created_at?: number | null, created_at: number, updated_at: number, owner?: { __typename?: 'Client', id: string, first_name?: string | null, last_name?: string | null, email?: string | null, phone?: string | null, address?: { __typename?: 'Address', country?: string | null } | null } | null, clinic_species?: { __typename?: 'ClinicSpecies', id: string, pms_id: string, description: string, is_primary: boolean, species: Species, weight_key: string, created_at: number, updated_at: number } | null, clinic?: { __typename?: 'Clinic', id: string } | null, clinic_breed?: { __typename?: 'Breed', id: string, description: string } | null, patient_vaccination_records?: Array<{ __typename?: 'PatientVaccinationRecord', id: string, vaccine_name?: string | null, manufacturer?: string | null, lot_number?: string | null, administered_date?: number | null, due_date?: number | null, rabies_tag?: string | null, is_rabies_vaccine?: boolean | null, is_soc: boolean, is_active: boolean, product?: { __typename?: 'Product', id: string, display_name?: string | null, name: string } | null }> | null, last_appointment?: { __typename?: 'Appointment', clinician?: { __typename?: 'Clinician', name: string, display_name?: string | null } | null } | null } | null, clinic_appt_status?: { __typename?: 'ClinicApptStatus', id: string, description: string, status: AppointmentStatus } | null, client_info?: { __typename?: 'ClientInfo', first_name?: string | null, last_name?: string | null, email?: string | null, phone?: string | null } | null, patient_info?: { __typename?: 'PatientInfo', patient_name?: string | null, patient_breed?: string | null, patient_clinic_species?: string | null, patient_clinic_breed?: string | null } | null, clients_forms?: Array<{ __typename?: 'ClientForm', id: string, client_completed_at?: number | null, clinic_verified_at?: number | null, is_archived: boolean, pms_id?: string | null, created_at: number, updated_at: number, client?: { __typename?: 'Client', id: string, first_name?: string | null, last_name?: string | null, phone?: string | null, email?: string | null, address?: { __typename?: 'Address', street_a?: string | null, city?: string | null, state?: string | null, zip?: string | null, country?: string | null } | null } | null, patient?: { __typename?: 'Patient', id: string, name?: string | null, is_active?: boolean | null, is_deceased?: boolean | null, birthday?: number | null, weight?: number | null, avatar_url?: string | null, gender?: string | null, owner?: { __typename?: 'Client', first_name?: string | null, last_name?: string | null } | null, clinic_species?: { __typename?: 'ClinicSpecies', id: string, species: Species, description: string, weight_key: string } | null, clinic_breed?: { __typename?: 'Breed', id: string, description: string } | null } | null, form: { __typename?: 'Form', id: string, name?: string | null, form_type: FormType, is_writeback_enabled: boolean, form_file_naming_template?: string | null }, form_data: { __typename?: 'FormFields', pages?: Array<{ __typename?: 'FormPage', id: string, title?: string | null, description?: string | null, order?: number | null }> | null, fields?: Array<{ __typename?: 'FormElement', id: string, type?: FormElementType | null, content?: string | null, name?: string | null, column_order?: number | null, row_order?: number | null, page_id?: string | null, options?: Array<string> | null, is_required?: boolean | null, value?: string | null, attachments?: Array<{ __typename?: 'FormFileAttachment', id?: string | null, filename?: string | null, mime_type?: string | null, size_bytes?: number | null, thumbnail_url?: string | null, url: string }> | null, field_updates?: Array<{ __typename?: 'FormFieldUpdate', field: FormFieldUpdateField, boolean_value?: boolean | null, option?: string | null }> | null }> | null }, appointment?: { __typename?: 'Appointment', start_time: number, drop_off_time?: number | null, clinic?: { __typename?: 'Clinic', name?: string | null, slug?: string | null, phone?: string | null, email?: string | null, address?: { __typename?: 'Address', street_a?: string | null, city?: string | null, state?: string | null, zip?: string | null, country?: string | null } | null } | null, clinician?: { __typename?: 'Clinician', name: string, display_name?: string | null } | null, service?: { __typename?: 'Service', name?: string | null } | null } | null }> | null, widget?: { __typename?: 'Widget', id: string, widget_name: string } | null } };

export type ClientConfirmAppointmentMutationVariables = Exact<{
  id: Scalars['ID']['input'];
}>;


export type ClientConfirmAppointmentMutation = { __typename?: 'Mutation', clientConfirmAppointment: { __typename?: 'Appointment', id: string, pms?: PracticeManagementSystem | null, client_pms_id?: string | null, is_new_client?: boolean | null, start_time: number, drop_off_time?: number | null, minutes: number, is_new_patient?: boolean | null, is_clinician_auto_assigned?: boolean | null, patient_pms_id?: string | null, referring_clinic_name?: string | null, client_notes?: string | null, clinic_notes?: string | null, service_name?: string | null, status: AppointmentStatus, is_time_block?: boolean | null, is_confirmed?: boolean | null, origin?: EntityOrigin | null, reason_for_cancellation?: string | null, client_reason_for_cancellation?: string | null, new_client_name?: string | null, new_client_phone?: string | null, new_patient_name?: string | null, new_patient_species?: string | null, confirmed_at?: number | null, widget_source?: string | null, from_widget?: string | null, is_deleted?: boolean | null, created_at: number, updated_at: number, pms_created_at?: number | null, clinic?: { __typename?: 'Clinic', id: string, name?: string | null, slug?: string | null, pms_db?: { __typename?: 'PmsDb', id: string } | null, address?: { __typename?: 'Address', country?: string | null } | null } | null, client?: { __typename?: 'Client', id: string, first_name?: string | null, last_name?: string | null, secondary_first_name?: string | null, secondary_last_name?: string | null, phone?: string | null, email?: string | null, pms?: PracticeManagementSystem | null, pms_id?: string | null, last_appt_time?: number | null, last_contact_time?: number | null, email_enabled: boolean, sms_enabled: boolean, balance?: number | null, is_active?: boolean | null, is_unsubscribed: boolean, created_at: number, updated_at: number, client_phones?: Array<{ __typename?: 'ClientPhone', id: string, phone: string, country_code?: string | null, is_primary: boolean, is_chckup_primary: boolean, is_mobile: boolean, sms_available: boolean, is_unsubscribed: boolean, is_active: boolean, name?: string | null }> | null, client_emails?: Array<{ __typename?: 'ClientEmail', id: string, email: string, is_primary: boolean }> | null, clinic?: { __typename?: 'Clinic', id: string } | null, patients?: Array<{ __typename?: 'Patient', id: string, pms?: PracticeManagementSystem | null, pms_id?: string | null, name?: string | null, breed?: string | null, avatar_url?: string | null, last_appt_time?: number | null, gender?: string | null, fixed_status?: FixedStatus | null, weight?: number | null, birthday?: number | null, is_active?: boolean | null, is_deceased?: boolean | null, pms_created_at?: number | null, created_at: number, updated_at: number, owner?: { __typename?: 'Client', id: string, first_name?: string | null, last_name?: string | null, email?: string | null, phone?: string | null, address?: { __typename?: 'Address', country?: string | null } | null } | null, clinic_species?: { __typename?: 'ClinicSpecies', id: string, pms_id: string, description: string, is_primary: boolean, species: Species, weight_key: string, created_at: number, updated_at: number } | null, clinic?: { __typename?: 'Clinic', id: string } | null, clinic_breed?: { __typename?: 'Breed', id: string, description: string } | null, patient_vaccination_records?: Array<{ __typename?: 'PatientVaccinationRecord', id: string, vaccine_name?: string | null, manufacturer?: string | null, lot_number?: string | null, administered_date?: number | null, due_date?: number | null, rabies_tag?: string | null, is_rabies_vaccine?: boolean | null, is_soc: boolean, is_active: boolean, product?: { __typename?: 'Product', id: string, display_name?: string | null, name: string } | null }> | null, last_appointment?: { __typename?: 'Appointment', clinician?: { __typename?: 'Clinician', name: string, display_name?: string | null } | null } | null }> | null, address?: { __typename?: 'Address', street_a?: string | null, street_b?: string | null, city?: string | null, state?: string | null, zip?: string | null, country?: string | null } | null, user?: { __typename?: 'User', avatar_url?: string | null } | null, loyalty_members?: Array<{ __typename?: 'LoyaltyMember', id: string, available_points: number } | null> | null, settings?: { __typename?: 'ClientSettings', clinic_chckup_notifications_enabled: boolean, clinic_chckup_sms_enabled: boolean, clinic_chckup_email_enabled: boolean, client_chckup_notifications_enabled: boolean, client_chckup_sms_enabled: boolean, client_chckup_email_enabled: boolean, is_unsubscribed_from_marketing: boolean, is_unsubscribed_from_marketing_sms: boolean, is_unsubscribed_from_marketing_email: boolean } | null, last_appointment?: { __typename?: 'Appointment', clinician?: { __typename?: 'Clinician', name: string, display_name?: string | null } | null } | null } | null, clinician?: { __typename?: 'Clinician', id: string, name: string, display_name?: string | null, bio?: string | null, avatar_url?: string | null, initials?: string | null, excluded_species?: Array<Species> | null, excluded_service_ids?: Array<string> | null, authority_level?: AuthorityLevel | null, type: ResourceType, is_active?: boolean | null, is_assignable_in_pms?: boolean | null, does_contribute_to_fill_rate?: boolean | null, pms_id?: string | null, location?: string | null, pms_is_active: boolean, valid_booking_interval_minutes?: Array<number> | null, created_at: number, updated_at: number, clinic?: { __typename?: 'Clinic', id: string, name?: string | null } | null, pms_db?: { __typename?: 'PmsDb', id: string } | null, hours?: { __typename?: 'AvailabilityHours', monday?: Array<{ __typename?: 'TimeInterval', start?: number | null, end?: number | null }> | null, tuesday?: Array<{ __typename?: 'TimeInterval', start?: number | null, end?: number | null }> | null, wednesday?: Array<{ __typename?: 'TimeInterval', start?: number | null, end?: number | null }> | null, thursday?: Array<{ __typename?: 'TimeInterval', start?: number | null, end?: number | null }> | null, friday?: Array<{ __typename?: 'TimeInterval', start?: number | null, end?: number | null }> | null, saturday?: Array<{ __typename?: 'TimeInterval', start?: number | null, end?: number | null }> | null, sunday?: Array<{ __typename?: 'TimeInterval', start?: number | null, end?: number | null }> | null } | null, adjusted_availability?: Array<{ __typename?: 'Availability', date: number, pms_appt_type_pms_id?: string | null, times: Array<{ __typename?: 'TimeInterval', start?: number | null, end?: number | null }>, repeat?: { __typename?: 'RepeatAvailability', daysOfMonth?: Array<number> | null, daysOfWeek?: Array<DayOfWeek> | null, weekOfMonth?: WeekOfMonth | null, frequency: any, unit: RepeatUnit, end_date?: number | null } | null }> | null, pms_adjusted_availability?: Array<{ __typename?: 'Availability', date: number, pms_appt_type_pms_id?: string | null, times: Array<{ __typename?: 'TimeInterval', start?: number | null, end?: number | null }>, repeat?: { __typename?: 'RepeatAvailability', daysOfMonth?: Array<number> | null, daysOfWeek?: Array<DayOfWeek> | null, weekOfMonth?: WeekOfMonth | null, frequency: any, unit: RepeatUnit, end_date?: number | null } | null }> | null } | null, room?: { __typename?: 'Room', id: string, pms_id: string, name: string, display_name?: string | null, description?: string | null, concurrent_patients?: number | null, is_active: boolean, does_contribute_to_fill_rate?: boolean | null, valid_booking_interval_minutes?: Array<number> | null, created_at: number, updated_at: number, clinic?: { __typename?: 'Clinic', pms: PracticeManagementSystem, id: string, name?: string | null, time_zone?: string | null } | null, hours?: { __typename?: 'AvailabilityHours', monday?: Array<{ __typename?: 'TimeInterval', start?: number | null, end?: number | null }> | null, tuesday?: Array<{ __typename?: 'TimeInterval', start?: number | null, end?: number | null }> | null, wednesday?: Array<{ __typename?: 'TimeInterval', start?: number | null, end?: number | null }> | null, thursday?: Array<{ __typename?: 'TimeInterval', start?: number | null, end?: number | null }> | null, friday?: Array<{ __typename?: 'TimeInterval', start?: number | null, end?: number | null }> | null, saturday?: Array<{ __typename?: 'TimeInterval', start?: number | null, end?: number | null }> | null, sunday?: Array<{ __typename?: 'TimeInterval', start?: number | null, end?: number | null }> | null } | null, adjusted_availability?: Array<{ __typename?: 'Availability', date: number, pms_appt_type_pms_id?: string | null, times: Array<{ __typename?: 'TimeInterval', start?: number | null, end?: number | null }>, repeat?: { __typename?: 'RepeatAvailability', daysOfMonth?: Array<number> | null, daysOfWeek?: Array<DayOfWeek> | null, weekOfMonth?: WeekOfMonth | null, frequency: any, unit: RepeatUnit, end_date?: number | null } | null }> | null, pms_adjusted_availability?: Array<{ __typename?: 'Availability', date: number, pms_appt_type_pms_id?: string | null, times: Array<{ __typename?: 'TimeInterval', start?: number | null, end?: number | null }>, repeat?: { __typename?: 'RepeatAvailability', daysOfMonth?: Array<number> | null, daysOfWeek?: Array<DayOfWeek> | null, weekOfMonth?: WeekOfMonth | null, frequency: any, unit: RepeatUnit, end_date?: number | null } | null }> | null } | null, service?: { __typename?: 'Service', id: string, name?: string | null, color?: string | null } | null, patient?: { __typename?: 'Patient', id: string, pms?: PracticeManagementSystem | null, pms_id?: string | null, name?: string | null, breed?: string | null, avatar_url?: string | null, last_appt_time?: number | null, gender?: string | null, fixed_status?: FixedStatus | null, weight?: number | null, birthday?: number | null, is_active?: boolean | null, is_deceased?: boolean | null, pms_created_at?: number | null, created_at: number, updated_at: number, owner?: { __typename?: 'Client', id: string, first_name?: string | null, last_name?: string | null, email?: string | null, phone?: string | null, address?: { __typename?: 'Address', country?: string | null } | null } | null, clinic_species?: { __typename?: 'ClinicSpecies', id: string, pms_id: string, description: string, is_primary: boolean, species: Species, weight_key: string, created_at: number, updated_at: number } | null, clinic?: { __typename?: 'Clinic', id: string } | null, clinic_breed?: { __typename?: 'Breed', id: string, description: string } | null, patient_vaccination_records?: Array<{ __typename?: 'PatientVaccinationRecord', id: string, vaccine_name?: string | null, manufacturer?: string | null, lot_number?: string | null, administered_date?: number | null, due_date?: number | null, rabies_tag?: string | null, is_rabies_vaccine?: boolean | null, is_soc: boolean, is_active: boolean, product?: { __typename?: 'Product', id: string, display_name?: string | null, name: string } | null }> | null, last_appointment?: { __typename?: 'Appointment', clinician?: { __typename?: 'Clinician', name: string, display_name?: string | null } | null } | null } | null, clinic_appt_status?: { __typename?: 'ClinicApptStatus', id: string, description: string, status: AppointmentStatus } | null, client_info?: { __typename?: 'ClientInfo', first_name?: string | null, last_name?: string | null, email?: string | null, phone?: string | null } | null, patient_info?: { __typename?: 'PatientInfo', patient_name?: string | null, patient_breed?: string | null, patient_clinic_species?: string | null, patient_clinic_breed?: string | null } | null, clients_forms?: Array<{ __typename?: 'ClientForm', id: string, client_completed_at?: number | null, clinic_verified_at?: number | null, is_archived: boolean, pms_id?: string | null, created_at: number, updated_at: number, client?: { __typename?: 'Client', id: string, first_name?: string | null, last_name?: string | null, phone?: string | null, email?: string | null, address?: { __typename?: 'Address', street_a?: string | null, city?: string | null, state?: string | null, zip?: string | null, country?: string | null } | null } | null, patient?: { __typename?: 'Patient', id: string, name?: string | null, is_active?: boolean | null, is_deceased?: boolean | null, birthday?: number | null, weight?: number | null, avatar_url?: string | null, gender?: string | null, owner?: { __typename?: 'Client', first_name?: string | null, last_name?: string | null } | null, clinic_species?: { __typename?: 'ClinicSpecies', id: string, species: Species, description: string, weight_key: string } | null, clinic_breed?: { __typename?: 'Breed', id: string, description: string } | null } | null, form: { __typename?: 'Form', id: string, name?: string | null, form_type: FormType, is_writeback_enabled: boolean, form_file_naming_template?: string | null }, form_data: { __typename?: 'FormFields', pages?: Array<{ __typename?: 'FormPage', id: string, title?: string | null, description?: string | null, order?: number | null }> | null, fields?: Array<{ __typename?: 'FormElement', id: string, type?: FormElementType | null, content?: string | null, name?: string | null, column_order?: number | null, row_order?: number | null, page_id?: string | null, options?: Array<string> | null, is_required?: boolean | null, value?: string | null, attachments?: Array<{ __typename?: 'FormFileAttachment', id?: string | null, filename?: string | null, mime_type?: string | null, size_bytes?: number | null, thumbnail_url?: string | null, url: string }> | null, field_updates?: Array<{ __typename?: 'FormFieldUpdate', field: FormFieldUpdateField, boolean_value?: boolean | null, option?: string | null }> | null }> | null }, appointment?: { __typename?: 'Appointment', start_time: number, drop_off_time?: number | null, clinic?: { __typename?: 'Clinic', name?: string | null, slug?: string | null, phone?: string | null, email?: string | null, address?: { __typename?: 'Address', street_a?: string | null, city?: string | null, state?: string | null, zip?: string | null, country?: string | null } | null } | null, clinician?: { __typename?: 'Clinician', name: string, display_name?: string | null } | null, service?: { __typename?: 'Service', name?: string | null } | null } | null }> | null, widget?: { __typename?: 'Widget', id: string, widget_name: string } | null } };

export type DeleteAppointmentMutationVariables = Exact<{
  id: Scalars['ID']['input'];
}>;


export type DeleteAppointmentMutation = { __typename?: 'Mutation', deleteAppointment?: any | null };

export type DenyPendingAppointmentMutationVariables = Exact<{
  appointmentId: Scalars['ID']['input'];
  message: Scalars['String']['input'];
}>;


export type DenyPendingAppointmentMutation = { __typename?: 'Mutation', denyPendingAppointment: { __typename?: 'Appointment', id: string } };

export type RequestChangeForPendingAppointmentMutationVariables = Exact<{
  appointmentId: Scalars['ID']['input'];
  message: Scalars['String']['input'];
}>;


export type RequestChangeForPendingAppointmentMutation = { __typename?: 'Mutation', requestChangeForPendingAppointment: { __typename?: 'Appointment', id: string } };

export type ClinicGroupAppointmentFieldsFragment = { __typename?: 'Appointment', id: string, start_time: number, created_at: number, origin?: EntityOrigin | null, status: AppointmentStatus, minutes: number, is_new_client?: boolean | null, is_new_patient?: boolean | null, client_notes?: string | null, clinic_notes?: string | null, notif_template?: string | null, bulk_message?: string | null, clinic?: { __typename?: 'Clinic', id: string, name?: string | null } | null, client?: { __typename?: 'Client', id: string, first_name?: string | null, last_name?: string | null, email?: string | null, phone?: string | null, address?: { __typename?: 'Address', street_a?: string | null, street_b?: string | null, city?: string | null, state?: string | null, zip?: string | null } | null } | null, patient?: { __typename?: 'Patient', id: string, name?: string | null } | null, service?: { __typename?: 'Service', id: string, name?: string | null } | null, clinician?: { __typename?: 'Clinician', id: string, name: string, display_name?: string | null } | null, room?: { __typename?: 'Room', id: string, name: string } | null, widget?: { __typename?: 'Widget', id: string, widget_name: string } | null, clinic_appt_status?: { __typename?: 'ClinicApptStatus', id: string, status: AppointmentStatus, description: string } | null, acquisition_source?: { __typename?: 'AcquisitionSource', utm_source?: string | null, utm_medium?: string | null, utm_campaign?: string | null, utm_term?: string | null, utm_content?: string | null, gclid?: string | null, gbraid?: string | null, wbraid?: string | null, gad_source?: string | null, gad_campaignid?: string | null, fbclid?: string | null, msclkid?: string | null, ttclid?: string | null, li_fat_id?: string | null, twclid?: string | null, yclid?: string | null, referrer_url?: string | null, landing_page_url?: string | null, first_touch_at?: number | null, last_touch_at?: number | null } | null };

export type QueryClinicGroupAppointmentsQueryVariables = Exact<{
  where?: InputMaybe<Array<QueryInput> | QueryInput>;
  page?: InputMaybe<Scalars['NonNegativeInt']['input']>;
  pageSize?: InputMaybe<Scalars['NonNegativeInt']['input']>;
  orderBy?: InputMaybe<OrderByInput>;
}>;


export type QueryClinicGroupAppointmentsQuery = { __typename?: 'Query', queryAppointments: Array<{ __typename?: 'Appointment', id: string, start_time: number, created_at: number, origin?: EntityOrigin | null, status: AppointmentStatus, minutes: number, is_new_client?: boolean | null, is_new_patient?: boolean | null, client_notes?: string | null, clinic_notes?: string | null, notif_template?: string | null, bulk_message?: string | null, clinic?: { __typename?: 'Clinic', id: string, name?: string | null } | null, client?: { __typename?: 'Client', id: string, first_name?: string | null, last_name?: string | null, email?: string | null, phone?: string | null, address?: { __typename?: 'Address', street_a?: string | null, street_b?: string | null, city?: string | null, state?: string | null, zip?: string | null } | null } | null, patient?: { __typename?: 'Patient', id: string, name?: string | null } | null, service?: { __typename?: 'Service', id: string, name?: string | null } | null, clinician?: { __typename?: 'Clinician', id: string, name: string, display_name?: string | null } | null, room?: { __typename?: 'Room', id: string, name: string } | null, widget?: { __typename?: 'Widget', id: string, widget_name: string } | null, clinic_appt_status?: { __typename?: 'ClinicApptStatus', id: string, status: AppointmentStatus, description: string } | null, acquisition_source?: { __typename?: 'AcquisitionSource', utm_source?: string | null, utm_medium?: string | null, utm_campaign?: string | null, utm_term?: string | null, utm_content?: string | null, gclid?: string | null, gbraid?: string | null, wbraid?: string | null, gad_source?: string | null, gad_campaignid?: string | null, fbclid?: string | null, msclkid?: string | null, ttclid?: string | null, li_fat_id?: string | null, twclid?: string | null, yclid?: string | null, referrer_url?: string | null, landing_page_url?: string | null, first_touch_at?: number | null, last_touch_at?: number | null } | null }> };

export type AppointmentCsvExportFieldsFragment = { __typename?: 'Appointment', id: string, start_time: number, status: AppointmentStatus, created_at: number, updated_at: number, clinic?: { __typename?: 'Clinic', id: string, name?: string | null } | null, client?: { __typename?: 'Client', id: string, first_name?: string | null, last_name?: string | null, phone?: string | null, email?: string | null, address?: { __typename?: 'Address', street_a?: string | null, street_b?: string | null, city?: string | null, state?: string | null, zip?: string | null, country?: string | null } | null } | null, patient?: { __typename?: 'Patient', id: string, name?: string | null, birthday?: number | null, gender?: string | null, clinic_species?: { __typename?: 'ClinicSpecies', species: Species } | null, clinic_breed?: { __typename?: 'Breed', description: string } | null } | null, service?: { __typename?: 'Service', id: string, name?: string | null } | null, clinician?: { __typename?: 'Clinician', id: string, name: string, display_name?: string | null } | null };

export type QueryAppointmentsForCsvExportQueryVariables = Exact<{
  where?: InputMaybe<Array<QueryInput> | QueryInput>;
  page?: InputMaybe<Scalars['NonNegativeInt']['input']>;
  pageSize?: InputMaybe<Scalars['NonNegativeInt']['input']>;
  orderBy?: InputMaybe<OrderByInput>;
}>;


export type QueryAppointmentsForCsvExportQuery = { __typename?: 'Query', queryAppointments: Array<{ __typename?: 'Appointment', id: string, start_time: number, status: AppointmentStatus, created_at: number, updated_at: number, clinic?: { __typename?: 'Clinic', id: string, name?: string | null } | null, client?: { __typename?: 'Client', id: string, first_name?: string | null, last_name?: string | null, phone?: string | null, email?: string | null, address?: { __typename?: 'Address', street_a?: string | null, street_b?: string | null, city?: string | null, state?: string | null, zip?: string | null, country?: string | null } | null } | null, patient?: { __typename?: 'Patient', id: string, name?: string | null, birthday?: number | null, gender?: string | null, clinic_species?: { __typename?: 'ClinicSpecies', species: Species } | null, clinic_breed?: { __typename?: 'Breed', description: string } | null } | null, service?: { __typename?: 'Service', id: string, name?: string | null } | null, clinician?: { __typename?: 'Clinician', id: string, name: string, display_name?: string | null } | null }> };

export type GetBillableUsageStatsByTypeQueryVariables = Exact<{
  clinicId: Scalars['ID']['input'];
  startDate?: InputMaybe<Scalars['NonNegativeInt']['input']>;
  endDate?: InputMaybe<Scalars['NonNegativeInt']['input']>;
}>;


export type GetBillableUsageStatsByTypeQuery = { __typename?: 'Query', billableUsageStatsByType: Array<{ __typename?: 'BillableUsageTypeStats', entity_type: BillableUsageEntity, current_billing_period_usage: number, all_time_usage: number }> };

export type BookingFlowFunnelStepFieldsFragment = { __typename?: 'BookingFlowFunnelStep', step: BookingFlowStep, count: number };

export type GetBookingFlowFunnelQueryVariables = Exact<{
  filters: BookingFlowFunnelFilters;
}>;


export type GetBookingFlowFunnelQuery = { __typename?: 'Query', bookingFlowFunnel: Array<{ __typename?: 'BookingFlowFunnelStep', step: BookingFlowStep, count: number }> };

export type WidgetBookingSourceStatsFieldsFragment = { __typename?: 'WidgetBookingSourceStats', sessions_started: number, appointments_booked: number, conversion_rate: number, widget: { __typename?: 'Widget', id: string, widget_name: string, type: WidgetType, is_active: boolean, is_archived: boolean, is_default_portal: boolean, clinic?: { __typename?: 'Clinic', id: string, name?: string | null } | null, clinic_group?: { __typename?: 'ClinicGroup', id: string, name: string } | null } };

export type ClinicBookingSourceStatsFieldsFragment = { __typename?: 'ClinicBookingSourceStats', sessions_started: number, appointments_booked: number, conversion_rate: number, clinic: { __typename?: 'Clinic', id: string, name?: string | null } };

export type GetBookingSourceAnalyticsQueryVariables = Exact<{
  clinicGroupId: Scalars['ID']['input'];
  range: UsageTimeRangeInput;
}>;


export type GetBookingSourceAnalyticsQuery = { __typename?: 'Query', bookingSourceAnalytics: { __typename?: 'BookingSourceAnalytics', widgets: Array<{ __typename?: 'WidgetBookingSourceStats', sessions_started: number, appointments_booked: number, conversion_rate: number, widget: { __typename?: 'Widget', id: string, widget_name: string, type: WidgetType, is_active: boolean, is_archived: boolean, is_default_portal: boolean, clinic?: { __typename?: 'Clinic', id: string, name?: string | null } | null, clinic_group?: { __typename?: 'ClinicGroup', id: string, name: string } | null } }>, portal_without_widget: Array<{ __typename?: 'ClinicBookingSourceStats', sessions_started: number, appointments_booked: number, conversion_rate: number, clinic: { __typename?: 'Clinic', id: string, name?: string | null } }>, clinics: Array<{ __typename?: 'ClinicBookingSourceStats', sessions_started: number, appointments_booked: number, conversion_rate: number, clinic: { __typename?: 'Clinic', id: string, name?: string | null } }> } };

export type GetClinicBookingSourceAnalyticsQueryVariables = Exact<{
  clinicId: Scalars['ID']['input'];
  range: UsageTimeRangeInput;
}>;


export type GetClinicBookingSourceAnalyticsQuery = { __typename?: 'Query', clinicBookingSourceAnalytics: { __typename?: 'BookingSourceAnalytics', widgets: Array<{ __typename?: 'WidgetBookingSourceStats', sessions_started: number, appointments_booked: number, conversion_rate: number, widget: { __typename?: 'Widget', id: string, widget_name: string, type: WidgetType, is_active: boolean, is_archived: boolean, is_default_portal: boolean, clinic?: { __typename?: 'Clinic', id: string, name?: string | null } | null, clinic_group?: { __typename?: 'ClinicGroup', id: string, name: string } | null } }>, portal_without_widget: Array<{ __typename?: 'ClinicBookingSourceStats', sessions_started: number, appointments_booked: number, conversion_rate: number, clinic: { __typename?: 'Clinic', id: string, name?: string | null } }>, clinics: Array<{ __typename?: 'ClinicBookingSourceStats', sessions_started: number, appointments_booked: number, conversion_rate: number, clinic: { __typename?: 'Clinic', id: string, name?: string | null } }> } };

export type BookingAttributionStatsFieldsFragment = { __typename?: 'BookingAttributionStats', value?: string | null, appointments_booked: number, new_client_appointments: number };

export type GetBookingAttributionAnalyticsQueryVariables = Exact<{
  clinicGroupId: Scalars['ID']['input'];
  range: UsageTimeRangeInput;
  dimension: BookingAttributionDimension;
}>;


export type GetBookingAttributionAnalyticsQuery = { __typename?: 'Query', bookingAttributionAnalytics: Array<{ __typename?: 'BookingAttributionStats', value?: string | null, appointments_booked: number, new_client_appointments: number }> };

export type GetClinicBookingAttributionAnalyticsQueryVariables = Exact<{
  clinicId: Scalars['ID']['input'];
  range: UsageTimeRangeInput;
  dimension: BookingAttributionDimension;
}>;


export type GetClinicBookingAttributionAnalyticsQuery = { __typename?: 'Query', clinicBookingAttributionAnalytics: Array<{ __typename?: 'BookingAttributionStats', value?: string | null, appointments_booked: number, new_client_appointments: number }> };

export type BreedFieldsFragment = { __typename?: 'Breed', id: string, pms_id: string, species?: Species | null, description: string };

export type BreedDisplayFieldsFragment = { __typename?: 'Breed', id: string, species?: Species | null, description: string, species_foreign?: { __typename?: 'ClinicSpecies', id: string, description: string } | null };

export type GetBreedsByClinicQueryVariables = Exact<{
  clinicId: Scalars['ID']['input'];
}>;


export type GetBreedsByClinicQuery = { __typename?: 'Query', getBreedsByClinic: Array<{ __typename?: 'Breed', id: string, pms_id: string, species?: Species | null, description: string }> };

export type QueryBreedsQueryVariables = Exact<{
  where?: InputMaybe<Array<QueryInput> | QueryInput>;
  page?: InputMaybe<Scalars['NonNegativeInt']['input']>;
  pageSize?: InputMaybe<Scalars['NonNegativeInt']['input']>;
  orderBy?: InputMaybe<OrderByInput>;
}>;


export type QueryBreedsQuery = { __typename?: 'Query', queryBreeds: Array<{ __typename?: 'Breed', id: string, pms_id: string, species?: Species | null, description: string }> };

export type CallFieldsFragment = { __typename?: 'Call', id: string, status: CallStatus, direction?: CallDirection | null, is_automated?: boolean | null, caller_name?: string | null, caller_phone?: string | null, to_phone?: string | null, duration?: number | null, recording_url?: string | null, transcription_full_text?: string | null, transcription_summary?: string | null, notes?: string | null, score?: number | null, score_reasoning?: string | null, sentiment_customer?: number | null, sentiment_agent?: number | null, created_at: number, updated_at: number, client?: { __typename?: 'Client', first_name?: string | null, last_name?: string | null, phone?: string | null } | null };

export type QueryClinicCallsQueryVariables = Exact<{
  where?: InputMaybe<Array<QueryInput> | QueryInput>;
  page?: InputMaybe<Scalars['NonNegativeInt']['input']>;
  pageSize?: InputMaybe<Scalars['NonNegativeInt']['input']>;
  orderBy?: InputMaybe<OrderByInput>;
  clinicId: Scalars['ID']['input'];
}>;


export type QueryClinicCallsQuery = { __typename?: 'Query', queryClinicCalls: Array<{ __typename?: 'Call', id: string, status: CallStatus, direction?: CallDirection | null, is_automated?: boolean | null, caller_name?: string | null, caller_phone?: string | null, to_phone?: string | null, duration?: number | null, recording_url?: string | null, transcription_full_text?: string | null, transcription_summary?: string | null, notes?: string | null, score?: number | null, score_reasoning?: string | null, sentiment_customer?: number | null, sentiment_agent?: number | null, created_at: number, updated_at: number, client?: { __typename?: 'Client', first_name?: string | null, last_name?: string | null, phone?: string | null } | null }> };

export type CountCallsQueryVariables = Exact<{
  where?: InputMaybe<Array<QueryInput> | QueryInput>;
}>;


export type CountCallsQuery = { __typename?: 'Query', countCalls: number };

export type ClinicCallStatsQueryVariables = Exact<{
  clinicId: Scalars['ID']['input'];
  where?: InputMaybe<Array<QueryInput> | QueryInput>;
}>;


export type ClinicCallStatsQuery = { __typename?: 'Query', clinicCallStats: { __typename?: 'CallStats', total_calls: number, automated_calls: number, appointments_booked: number, revenue_created_cents: number, time_saved_minutes: number, average_score?: number | null, average_sentiment?: number | null } };

export type UpdateCallMutationVariables = Exact<{
  id: Scalars['ID']['input'];
  input: UpdateCallInput;
}>;


export type UpdateCallMutation = { __typename?: 'Mutation', updateCall: { __typename?: 'Call', id: string, status: CallStatus, direction?: CallDirection | null, is_automated?: boolean | null, caller_name?: string | null, caller_phone?: string | null, to_phone?: string | null, duration?: number | null, recording_url?: string | null, transcription_full_text?: string | null, transcription_summary?: string | null, notes?: string | null, score?: number | null, score_reasoning?: string | null, sentiment_customer?: number | null, sentiment_agent?: number | null, created_at: number, updated_at: number, client?: { __typename?: 'Client', first_name?: string | null, last_name?: string | null, phone?: string | null } | null } };

export type CampaignStatsFieldsFragment = { __typename?: 'CampaignStats', total_revenue?: number | null, total_appointments?: number | null, total_unique_patients?: number | null, total_messages_sent?: number | null, total_email_message_opens?: number | null, total_link_clicks?: number | null, avg_conversion_rate?: number | null, avg_interactions_per_message?: number | null, total_widget_views?: number | null, total_interactions?: number | null, active_widgets?: number | null, active_bulk_messages?: number | null, active_notif_templates?: number | null };

export type CampaignStatsQueryVariables = Exact<{
  clinicId: Scalars['ID']['input'];
  campaignId: Scalars['ID']['input'];
}>;


export type CampaignStatsQuery = { __typename?: 'Query', campaignStats: { __typename?: 'CampaignStats', total_revenue?: number | null, total_appointments?: number | null, total_unique_patients?: number | null, total_messages_sent?: number | null, total_email_message_opens?: number | null, total_link_clicks?: number | null, avg_conversion_rate?: number | null, avg_interactions_per_message?: number | null, total_widget_views?: number | null, total_interactions?: number | null, active_widgets?: number | null, active_bulk_messages?: number | null, active_notif_templates?: number | null } };

export type CampaignWidgetStatFieldsFragment = { __typename?: 'CampaignWidgetStats', total_appointments?: number | null, total_unique_clients?: number | null, total_unique_patients?: number | null, direct_invoice_amt_total?: number | null, conversion_rate?: number | null, avg_booking_value?: number | null, total_views?: number | null, bounce_rate?: number | null, avg_time_to_book?: number | null, peak_booking_hour?: string | null, most_popular_service?: string | null, repeat_booking_rate?: number | null };

export type CampaignNotificationStatFieldsFragment = { __typename?: 'CampaignNotificationStats', total_recipients?: number | null, messages_sent?: number | null, delivery_rate?: number | null, bounce_rate?: number | null, open_rate?: number | null, avg_open_time?: number | null };

export type CampaignBulkMessageStatFieldsFragment = { __typename?: 'CampaignScheduledBulkMessageStats', total_recipients?: number | null, messages_sent?: number | null, delivery_rate?: number | null, bounce_rate?: number | null, open_rate?: number | null, avg_open_time?: number | null };

export type GetCampaignWidgetStatsQueryVariables = Exact<{
  clinicId: Scalars['ID']['input'];
  widgetId: Scalars['ID']['input'];
}>;


export type GetCampaignWidgetStatsQuery = { __typename?: 'Query', campaignWidgetStats: { __typename?: 'CampaignWidgetStats', total_appointments?: number | null, total_unique_clients?: number | null, total_unique_patients?: number | null, direct_invoice_amt_total?: number | null, conversion_rate?: number | null, avg_booking_value?: number | null, total_views?: number | null, bounce_rate?: number | null, avg_time_to_book?: number | null, peak_booking_hour?: string | null, most_popular_service?: string | null, repeat_booking_rate?: number | null } };

export type GetCampaignNotificationStatsQueryVariables = Exact<{
  clinicId: Scalars['ID']['input'];
  notificationId: Scalars['ID']['input'];
}>;


export type GetCampaignNotificationStatsQuery = { __typename?: 'Query', campaignNotificationStats: { __typename?: 'CampaignNotificationStats', total_recipients?: number | null, messages_sent?: number | null, delivery_rate?: number | null, bounce_rate?: number | null, open_rate?: number | null, avg_open_time?: number | null } };

export type GetCampaignBulkMessageStatsQueryVariables = Exact<{
  clinicId: Scalars['ID']['input'];
  bulkMessageId: Scalars['ID']['input'];
}>;


export type GetCampaignBulkMessageStatsQuery = { __typename?: 'Query', campaignScheduledBulkMessageStats: { __typename?: 'CampaignScheduledBulkMessageStats', total_recipients?: number | null, messages_sent?: number | null, delivery_rate?: number | null, bounce_rate?: number | null, open_rate?: number | null, avg_open_time?: number | null } };

export type CampaignFieldsFragment = { __typename?: 'Campaign', id: string, name: string, description?: string | null, start_time?: number | null, end_time?: number | null, is_active: boolean, is_archived: boolean, featured_stats: Array<string>, widget_featured_stats: Array<string>, notification_featured_stats: Array<string>, scheduled_bulk_message_featured_stats: Array<string>, created_at: number, updated_at: number, clinic?: { __typename?: 'Clinic', id: string, name?: string | null } | null, clinic_group?: { __typename?: 'ClinicGroup', id: string, name: string } | null, widgets: Array<{ __typename?: 'Widget', id: string, widget_name: string }>, notification_templates: Array<{ __typename?: 'NotificationTemplate', id: string, name: string }>, scheduled_bulk_messages: Array<{ __typename?: 'ScheduledBulkMessage', id: string, name: string }> };

export type CampaignPreviewFieldsFragment = { __typename?: 'Campaign', id: string, name: string, color?: string | null, description?: string | null };

export type GetCampaignQueryVariables = Exact<{
  id: Scalars['ID']['input'];
}>;


export type GetCampaignQuery = { __typename?: 'Query', campaign: { __typename?: 'Campaign', id: string, name: string, description?: string | null, start_time?: number | null, end_time?: number | null, is_active: boolean, is_archived: boolean, featured_stats: Array<string>, widget_featured_stats: Array<string>, notification_featured_stats: Array<string>, scheduled_bulk_message_featured_stats: Array<string>, created_at: number, updated_at: number, clinic?: { __typename?: 'Clinic', id: string, name?: string | null } | null, clinic_group?: { __typename?: 'ClinicGroup', id: string, name: string } | null, widgets: Array<{ __typename?: 'Widget', id: string, widget_name: string }>, notification_templates: Array<{ __typename?: 'NotificationTemplate', id: string, name: string }>, scheduled_bulk_messages: Array<{ __typename?: 'ScheduledBulkMessage', id: string, name: string }> } };

export type QueryCampaignsQueryVariables = Exact<{
  where?: InputMaybe<Array<QueryInput> | QueryInput>;
  page?: InputMaybe<Scalars['NonNegativeInt']['input']>;
  pageSize?: InputMaybe<Scalars['NonNegativeInt']['input']>;
  orderBy?: InputMaybe<OrderByInput>;
}>;


export type QueryCampaignsQuery = { __typename?: 'Query', queryCampaigns: Array<{ __typename?: 'Campaign', id: string, name: string, description?: string | null, start_time?: number | null, end_time?: number | null, is_active: boolean, is_archived: boolean, featured_stats: Array<string>, widget_featured_stats: Array<string>, notification_featured_stats: Array<string>, scheduled_bulk_message_featured_stats: Array<string>, created_at: number, updated_at: number, clinic?: { __typename?: 'Clinic', id: string, name?: string | null } | null, clinic_group?: { __typename?: 'ClinicGroup', id: string, name: string } | null, widgets: Array<{ __typename?: 'Widget', id: string, widget_name: string }>, notification_templates: Array<{ __typename?: 'NotificationTemplate', id: string, name: string }>, scheduled_bulk_messages: Array<{ __typename?: 'ScheduledBulkMessage', id: string, name: string }> }> };

export type CountCampaignsQueryVariables = Exact<{
  where?: InputMaybe<Array<QueryInput> | QueryInput>;
}>;


export type CountCampaignsQuery = { __typename?: 'Query', countCampaigns: number };

export type CreateCampaignMutationVariables = Exact<{
  data: CreateCampaignInput;
}>;


export type CreateCampaignMutation = { __typename?: 'Mutation', createCampaign: { __typename?: 'Campaign', id: string, name: string, description?: string | null, start_time?: number | null, end_time?: number | null, is_active: boolean, is_archived: boolean, featured_stats: Array<string>, widget_featured_stats: Array<string>, notification_featured_stats: Array<string>, scheduled_bulk_message_featured_stats: Array<string>, created_at: number, updated_at: number, clinic?: { __typename?: 'Clinic', id: string, name?: string | null } | null, clinic_group?: { __typename?: 'ClinicGroup', id: string, name: string } | null, widgets: Array<{ __typename?: 'Widget', id: string, widget_name: string }>, notification_templates: Array<{ __typename?: 'NotificationTemplate', id: string, name: string }>, scheduled_bulk_messages: Array<{ __typename?: 'ScheduledBulkMessage', id: string, name: string }> } };

export type UpdateCampaignMutationVariables = Exact<{
  id: Scalars['ID']['input'];
  data: UpdateCampaignInput;
}>;


export type UpdateCampaignMutation = { __typename?: 'Mutation', updateCampaign: { __typename?: 'Campaign', id: string, name: string, description?: string | null, start_time?: number | null, end_time?: number | null, is_active: boolean, is_archived: boolean, featured_stats: Array<string>, widget_featured_stats: Array<string>, notification_featured_stats: Array<string>, scheduled_bulk_message_featured_stats: Array<string>, created_at: number, updated_at: number, clinic?: { __typename?: 'Clinic', id: string, name?: string | null } | null, clinic_group?: { __typename?: 'ClinicGroup', id: string, name: string } | null, widgets: Array<{ __typename?: 'Widget', id: string, widget_name: string }>, notification_templates: Array<{ __typename?: 'NotificationTemplate', id: string, name: string }>, scheduled_bulk_messages: Array<{ __typename?: 'ScheduledBulkMessage', id: string, name: string }> } };

export type UpdateCampaignFeaturedStatsMutationVariables = Exact<{
  id: Scalars['ID']['input'];
  featured: Array<Scalars['String']['input']> | Scalars['String']['input'];
}>;


export type UpdateCampaignFeaturedStatsMutation = { __typename?: 'Mutation', updateCampaignFeaturedStats: { __typename?: 'Campaign', id: string, name: string, description?: string | null, start_time?: number | null, end_time?: number | null, is_active: boolean, is_archived: boolean, featured_stats: Array<string>, widget_featured_stats: Array<string>, notification_featured_stats: Array<string>, scheduled_bulk_message_featured_stats: Array<string>, created_at: number, updated_at: number, clinic?: { __typename?: 'Clinic', id: string, name?: string | null } | null, clinic_group?: { __typename?: 'ClinicGroup', id: string, name: string } | null, widgets: Array<{ __typename?: 'Widget', id: string, widget_name: string }>, notification_templates: Array<{ __typename?: 'NotificationTemplate', id: string, name: string }>, scheduled_bulk_messages: Array<{ __typename?: 'ScheduledBulkMessage', id: string, name: string }> } };

export type UpdateCampaignWidgetFeaturedStatsMutationVariables = Exact<{
  id: Scalars['ID']['input'];
  featured: Array<Scalars['String']['input']> | Scalars['String']['input'];
}>;


export type UpdateCampaignWidgetFeaturedStatsMutation = { __typename?: 'Mutation', updateCampaignWidgetFeaturedStats: { __typename?: 'Campaign', id: string, name: string, description?: string | null, start_time?: number | null, end_time?: number | null, is_active: boolean, is_archived: boolean, featured_stats: Array<string>, widget_featured_stats: Array<string>, notification_featured_stats: Array<string>, scheduled_bulk_message_featured_stats: Array<string>, created_at: number, updated_at: number, clinic?: { __typename?: 'Clinic', id: string, name?: string | null } | null, clinic_group?: { __typename?: 'ClinicGroup', id: string, name: string } | null, widgets: Array<{ __typename?: 'Widget', id: string, widget_name: string }>, notification_templates: Array<{ __typename?: 'NotificationTemplate', id: string, name: string }>, scheduled_bulk_messages: Array<{ __typename?: 'ScheduledBulkMessage', id: string, name: string }> } };

export type UpdateCampaignNotificationFeaturedStatsMutationVariables = Exact<{
  id: Scalars['ID']['input'];
  featured: Array<Scalars['String']['input']> | Scalars['String']['input'];
}>;


export type UpdateCampaignNotificationFeaturedStatsMutation = { __typename?: 'Mutation', updateCampaignNotificationFeaturedStats: { __typename?: 'Campaign', id: string, name: string, description?: string | null, start_time?: number | null, end_time?: number | null, is_active: boolean, is_archived: boolean, featured_stats: Array<string>, widget_featured_stats: Array<string>, notification_featured_stats: Array<string>, scheduled_bulk_message_featured_stats: Array<string>, created_at: number, updated_at: number, clinic?: { __typename?: 'Clinic', id: string, name?: string | null } | null, clinic_group?: { __typename?: 'ClinicGroup', id: string, name: string } | null, widgets: Array<{ __typename?: 'Widget', id: string, widget_name: string }>, notification_templates: Array<{ __typename?: 'NotificationTemplate', id: string, name: string }>, scheduled_bulk_messages: Array<{ __typename?: 'ScheduledBulkMessage', id: string, name: string }> } };

export type UpdateCampaignScheduledBulkMessageFeaturedStatsMutationVariables = Exact<{
  id: Scalars['ID']['input'];
  featured: Array<Scalars['String']['input']> | Scalars['String']['input'];
}>;


export type UpdateCampaignScheduledBulkMessageFeaturedStatsMutation = { __typename?: 'Mutation', updateCampaignScheduledBulkMessageFeaturedStats: { __typename?: 'Campaign', id: string, name: string, description?: string | null, start_time?: number | null, end_time?: number | null, is_active: boolean, is_archived: boolean, featured_stats: Array<string>, widget_featured_stats: Array<string>, notification_featured_stats: Array<string>, scheduled_bulk_message_featured_stats: Array<string>, created_at: number, updated_at: number, clinic?: { __typename?: 'Clinic', id: string, name?: string | null } | null, clinic_group?: { __typename?: 'ClinicGroup', id: string, name: string } | null, widgets: Array<{ __typename?: 'Widget', id: string, widget_name: string }>, notification_templates: Array<{ __typename?: 'NotificationTemplate', id: string, name: string }>, scheduled_bulk_messages: Array<{ __typename?: 'ScheduledBulkMessage', id: string, name: string }> } };

export type ChangeLogFieldsFragment = { __typename?: 'ChangeLog', id: string, old_values?: any | null, new_values?: any | null, created_at: number, user?: { __typename?: 'User', id: string, first_name?: string | null, last_name?: string | null } | null };

export type GetChangeLogsByEntityIdQueryVariables = Exact<{
  entityId: Scalars['String']['input'];
  params?: InputMaybe<PaginationParams>;
}>;


export type GetChangeLogsByEntityIdQuery = { __typename?: 'Query', getChangeLogsByEntityId: Array<{ __typename?: 'ChangeLog', id: string, old_values?: any | null, new_values?: any | null, created_at: number, user?: { __typename?: 'User', id: string, first_name?: string | null, last_name?: string | null } | null }> };

export type ChatStatusFieldsFragment = { __typename?: 'ChatStatusConfig', id: string, name: string, color?: string | null, sort_order: number, is_archived: boolean, created_at: number, updated_at: number, clinic?: { __typename?: 'Clinic', id: string } | null, clinic_group?: { __typename?: 'ClinicGroup', id: string } | null };

export type ChatStatusesQueryVariables = Exact<{
  clinicId: Scalars['ID']['input'];
}>;


export type ChatStatusesQuery = { __typename?: 'Query', chatStatuses: Array<{ __typename?: 'ChatStatusConfig', id: string, name: string, color?: string | null, sort_order: number, is_archived: boolean, created_at: number, updated_at: number, clinic?: { __typename?: 'Clinic', id: string } | null, clinic_group?: { __typename?: 'ClinicGroup', id: string } | null }> };

export type CreateChatStatusMutationVariables = Exact<{
  data: CreateChatStatusInput;
}>;


export type CreateChatStatusMutation = { __typename?: 'Mutation', createChatStatus: { __typename?: 'ChatStatusConfig', id: string, name: string, color?: string | null, sort_order: number, is_archived: boolean, created_at: number, updated_at: number, clinic?: { __typename?: 'Clinic', id: string } | null, clinic_group?: { __typename?: 'ClinicGroup', id: string } | null } };

export type UpdateChatStatusMutationVariables = Exact<{
  id: Scalars['ID']['input'];
  data: UpdateChatStatusInput;
}>;


export type UpdateChatStatusMutation = { __typename?: 'Mutation', updateChatStatus: { __typename?: 'ChatStatusConfig', id: string, name: string, color?: string | null, sort_order: number, is_archived: boolean, created_at: number, updated_at: number, clinic?: { __typename?: 'Clinic', id: string } | null, clinic_group?: { __typename?: 'ClinicGroup', id: string } | null } };

export type DeleteChatStatusMutationVariables = Exact<{
  id: Scalars['ID']['input'];
}>;


export type DeleteChatStatusMutation = { __typename?: 'Mutation', deleteChatStatus?: any | null };

export type ChatFieldsFragment = { __typename?: 'Chat', id: string, title?: string | null, client_last_message?: string | null, client_last_read: number, client_last_read_count: number, client_unread_count: number, client_message_count: number, client_last_message_time: number, clinic_last_message?: string | null, clinic_unread_count: number, clinic_last_read: number, clinic_last_read_count: number, clinic_message_count: number, clinic_last_message_time: number, non_system_last_message?: string | null, non_system_last_message_time: number, system_message_count: number, system_last_message?: string | null, system_last_message_time: number, message_count: number, last_message?: string | null, last_message_time: number, status: ChatStatus, is_hidden: boolean, is_pinned: boolean, compliance_status?: string | null, created_at: number, updated_at: number, clinic: { __typename?: 'Clinic', id: string, name?: string | null, slug?: string | null, phone?: string | null, email?: string | null, website?: string | null, avatar_url?: string | null, time_zone?: string | null, pms: PracticeManagementSystem, tmp_feature_flags?: any | null, address?: { __typename?: 'Address', street_a?: string | null, street_b?: string | null, city?: string | null, state?: string | null, zip?: string | null, country?: string | null } | null, settings?: { __typename?: 'ClinicSettings', id?: string | null, primary_color?: string | null, portal_links?: Array<{ __typename?: 'PortalLink', label: string, url: string }> | null } | null, pms_db?: { __typename?: 'PmsDb', id: string } | null }, client: { __typename?: 'Client', email_enabled: boolean, sms_enabled: boolean, id: string, first_name?: string | null, last_name?: string | null, secondary_first_name?: string | null, secondary_last_name?: string | null, phone?: string | null, email?: string | null, pms_id?: string | null, is_active?: boolean | null, is_unsubscribed: boolean, balance?: number | null, last_appt_time?: number | null, created_at: number, updated_at: number, client_phones?: Array<{ __typename?: 'ClientPhone', id: string, phone: string, country_code?: string | null, is_primary: boolean, is_chckup_primary: boolean, is_mobile: boolean, sms_available: boolean, is_unsubscribed: boolean, is_active: boolean, name?: string | null }> | null, last_appointment?: { __typename?: 'Appointment', clinician?: { __typename?: 'Clinician', name: string, display_name?: string | null } | null } | null, address?: { __typename?: 'Address', street_a?: string | null, street_b?: string | null, city?: string | null, state?: string | null, zip?: string | null, country?: string | null } | null, clinic?: { __typename?: 'Clinic', id: string } | null, user?: { __typename?: 'User', avatar_url?: string | null } | null, patients?: Array<{ __typename?: 'Patient', id: string, name?: string | null, gender?: string | null, pms_id?: string | null, is_deceased?: boolean | null, is_active?: boolean | null, clinic_species?: { __typename?: 'ClinicSpecies', id: string, species: Species } | null, clinic_breed?: { __typename?: 'Breed', id: string, description: string } | null, last_appointment?: { __typename?: 'Appointment', clinician?: { __typename?: 'Clinician', name: string, display_name?: string | null } | null } | null }> | null, settings?: { __typename?: 'ClientSettings', clinic_chckup_notifications_enabled: boolean, clinic_chckup_sms_enabled: boolean, clinic_chckup_email_enabled: boolean, client_chckup_notifications_enabled: boolean, client_chckup_sms_enabled: boolean, client_chckup_email_enabled: boolean, is_unsubscribed_from_marketing: boolean, is_unsubscribed_from_marketing_sms: boolean, is_unsubscribed_from_marketing_email: boolean } | null }, assignee?: { __typename?: 'User', id: string, avatar_url?: string | null, first_name?: string | null, last_name?: string | null } | null, chat_status?: { __typename?: 'ChatStatusConfig', id: string, name: string, color?: string | null } | null };

export type ChatClinicFieldsFragment = { __typename?: 'Clinic', id: string, name?: string | null, slug?: string | null, phone?: string | null, email?: string | null, website?: string | null, avatar_url?: string | null, time_zone?: string | null, pms: PracticeManagementSystem, tmp_feature_flags?: any | null, address?: { __typename?: 'Address', street_a?: string | null, street_b?: string | null, city?: string | null, state?: string | null, zip?: string | null, country?: string | null } | null, settings?: { __typename?: 'ClinicSettings', id?: string | null, primary_color?: string | null, portal_links?: Array<{ __typename?: 'PortalLink', label: string, url: string }> | null } | null, pms_db?: { __typename?: 'PmsDb', id: string } | null };

export type ChatPreviewFieldsFragment = { __typename?: 'Chat', id: string, title?: string | null, clinic_unread_count: number, last_message?: string | null, last_message_time: number, client_last_message?: string | null, client_last_message_time: number, client_message_count: number, clinic_last_message?: string | null, clinic_last_message_time: number, non_system_last_message?: string | null, non_system_last_message_time: number, system_last_message?: string | null, system_last_message_time: number, status: ChatStatus, is_pinned: boolean, clinic: { __typename?: 'Clinic', id: string, pms: PracticeManagementSystem, name?: string | null }, client: { __typename?: 'Client', id: string, first_name?: string | null, last_name?: string | null, patients?: Array<{ __typename?: 'Patient', id: string, name?: string | null, pms_id?: string | null, is_deceased?: boolean | null, is_active?: boolean | null }> | null }, assignee?: { __typename?: 'User', id: string, avatar_url?: string | null, first_name?: string | null, last_name?: string | null } | null, chat_status?: { __typename?: 'ChatStatusConfig', id: string, name: string, color?: string | null } | null };

export type ChatBasicInfoFieldsFragment = { __typename?: 'Chat', id: string, client: { __typename?: 'Client', id: string } };

export type GetChatQueryVariables = Exact<{
  id: Scalars['ID']['input'];
}>;


export type GetChatQuery = { __typename?: 'Query', chat: { __typename?: 'Chat', id: string, title?: string | null, client_last_message?: string | null, client_last_read: number, client_last_read_count: number, client_unread_count: number, client_message_count: number, client_last_message_time: number, clinic_last_message?: string | null, clinic_unread_count: number, clinic_last_read: number, clinic_last_read_count: number, clinic_message_count: number, clinic_last_message_time: number, non_system_last_message?: string | null, non_system_last_message_time: number, system_message_count: number, system_last_message?: string | null, system_last_message_time: number, message_count: number, last_message?: string | null, last_message_time: number, status: ChatStatus, is_hidden: boolean, is_pinned: boolean, compliance_status?: string | null, created_at: number, updated_at: number, clinic: { __typename?: 'Clinic', id: string, name?: string | null, slug?: string | null, phone?: string | null, email?: string | null, website?: string | null, avatar_url?: string | null, time_zone?: string | null, pms: PracticeManagementSystem, tmp_feature_flags?: any | null, address?: { __typename?: 'Address', street_a?: string | null, street_b?: string | null, city?: string | null, state?: string | null, zip?: string | null, country?: string | null } | null, settings?: { __typename?: 'ClinicSettings', id?: string | null, primary_color?: string | null, portal_links?: Array<{ __typename?: 'PortalLink', label: string, url: string }> | null } | null, pms_db?: { __typename?: 'PmsDb', id: string } | null }, client: { __typename?: 'Client', email_enabled: boolean, sms_enabled: boolean, id: string, first_name?: string | null, last_name?: string | null, secondary_first_name?: string | null, secondary_last_name?: string | null, phone?: string | null, email?: string | null, pms_id?: string | null, is_active?: boolean | null, is_unsubscribed: boolean, balance?: number | null, last_appt_time?: number | null, created_at: number, updated_at: number, client_phones?: Array<{ __typename?: 'ClientPhone', id: string, phone: string, country_code?: string | null, is_primary: boolean, is_chckup_primary: boolean, is_mobile: boolean, sms_available: boolean, is_unsubscribed: boolean, is_active: boolean, name?: string | null }> | null, last_appointment?: { __typename?: 'Appointment', clinician?: { __typename?: 'Clinician', name: string, display_name?: string | null } | null } | null, address?: { __typename?: 'Address', street_a?: string | null, street_b?: string | null, city?: string | null, state?: string | null, zip?: string | null, country?: string | null } | null, clinic?: { __typename?: 'Clinic', id: string } | null, user?: { __typename?: 'User', avatar_url?: string | null } | null, patients?: Array<{ __typename?: 'Patient', id: string, name?: string | null, gender?: string | null, pms_id?: string | null, is_deceased?: boolean | null, is_active?: boolean | null, clinic_species?: { __typename?: 'ClinicSpecies', id: string, species: Species } | null, clinic_breed?: { __typename?: 'Breed', id: string, description: string } | null, last_appointment?: { __typename?: 'Appointment', clinician?: { __typename?: 'Clinician', name: string, display_name?: string | null } | null } | null }> | null, settings?: { __typename?: 'ClientSettings', clinic_chckup_notifications_enabled: boolean, clinic_chckup_sms_enabled: boolean, clinic_chckup_email_enabled: boolean, client_chckup_notifications_enabled: boolean, client_chckup_sms_enabled: boolean, client_chckup_email_enabled: boolean, is_unsubscribed_from_marketing: boolean, is_unsubscribed_from_marketing_sms: boolean, is_unsubscribed_from_marketing_email: boolean } | null }, assignee?: { __typename?: 'User', id: string, avatar_url?: string | null, first_name?: string | null, last_name?: string | null } | null, chat_status?: { __typename?: 'ChatStatusConfig', id: string, name: string, color?: string | null } | null } };

export type GetChatsByClientIdQueryVariables = Exact<{
  clientId: Scalars['ID']['input'];
}>;


export type GetChatsByClientIdQuery = { __typename?: 'Query', getChatsByClientId: Array<{ __typename?: 'Chat', id: string, title?: string | null, client_last_message?: string | null, client_last_read: number, client_last_read_count: number, client_unread_count: number, client_message_count: number, client_last_message_time: number, clinic_last_message?: string | null, clinic_unread_count: number, clinic_last_read: number, clinic_last_read_count: number, clinic_message_count: number, clinic_last_message_time: number, non_system_last_message?: string | null, non_system_last_message_time: number, system_message_count: number, system_last_message?: string | null, system_last_message_time: number, message_count: number, last_message?: string | null, last_message_time: number, status: ChatStatus, is_hidden: boolean, is_pinned: boolean, compliance_status?: string | null, created_at: number, updated_at: number, clinic: { __typename?: 'Clinic', id: string, name?: string | null, slug?: string | null, phone?: string | null, email?: string | null, website?: string | null, avatar_url?: string | null, time_zone?: string | null, pms: PracticeManagementSystem, tmp_feature_flags?: any | null, address?: { __typename?: 'Address', street_a?: string | null, street_b?: string | null, city?: string | null, state?: string | null, zip?: string | null, country?: string | null } | null, settings?: { __typename?: 'ClinicSettings', id?: string | null, primary_color?: string | null, portal_links?: Array<{ __typename?: 'PortalLink', label: string, url: string }> | null } | null, pms_db?: { __typename?: 'PmsDb', id: string } | null }, client: { __typename?: 'Client', email_enabled: boolean, sms_enabled: boolean, id: string, first_name?: string | null, last_name?: string | null, secondary_first_name?: string | null, secondary_last_name?: string | null, phone?: string | null, email?: string | null, pms_id?: string | null, is_active?: boolean | null, is_unsubscribed: boolean, balance?: number | null, last_appt_time?: number | null, created_at: number, updated_at: number, client_phones?: Array<{ __typename?: 'ClientPhone', id: string, phone: string, country_code?: string | null, is_primary: boolean, is_chckup_primary: boolean, is_mobile: boolean, sms_available: boolean, is_unsubscribed: boolean, is_active: boolean, name?: string | null }> | null, last_appointment?: { __typename?: 'Appointment', clinician?: { __typename?: 'Clinician', name: string, display_name?: string | null } | null } | null, address?: { __typename?: 'Address', street_a?: string | null, street_b?: string | null, city?: string | null, state?: string | null, zip?: string | null, country?: string | null } | null, clinic?: { __typename?: 'Clinic', id: string } | null, user?: { __typename?: 'User', avatar_url?: string | null } | null, patients?: Array<{ __typename?: 'Patient', id: string, name?: string | null, gender?: string | null, pms_id?: string | null, is_deceased?: boolean | null, is_active?: boolean | null, clinic_species?: { __typename?: 'ClinicSpecies', id: string, species: Species } | null, clinic_breed?: { __typename?: 'Breed', id: string, description: string } | null, last_appointment?: { __typename?: 'Appointment', clinician?: { __typename?: 'Clinician', name: string, display_name?: string | null } | null } | null }> | null, settings?: { __typename?: 'ClientSettings', clinic_chckup_notifications_enabled: boolean, clinic_chckup_sms_enabled: boolean, clinic_chckup_email_enabled: boolean, client_chckup_notifications_enabled: boolean, client_chckup_sms_enabled: boolean, client_chckup_email_enabled: boolean, is_unsubscribed_from_marketing: boolean, is_unsubscribed_from_marketing_sms: boolean, is_unsubscribed_from_marketing_email: boolean } | null }, assignee?: { __typename?: 'User', id: string, avatar_url?: string | null, first_name?: string | null, last_name?: string | null } | null, chat_status?: { __typename?: 'ChatStatusConfig', id: string, name: string, color?: string | null } | null }> };

export type GetChatsByClinicIdQueryVariables = Exact<{
  clinicId: Scalars['ID']['input'];
  page?: InputMaybe<Scalars['NonNegativeInt']['input']>;
  pageSize?: InputMaybe<Scalars['NonNegativeInt']['input']>;
}>;


export type GetChatsByClinicIdQuery = { __typename?: 'Query', getChatsByClinicId: Array<{ __typename?: 'Chat', id: string, title?: string | null, client_last_message?: string | null, client_last_read: number, client_last_read_count: number, client_unread_count: number, client_message_count: number, client_last_message_time: number, clinic_last_message?: string | null, clinic_unread_count: number, clinic_last_read: number, clinic_last_read_count: number, clinic_message_count: number, clinic_last_message_time: number, non_system_last_message?: string | null, non_system_last_message_time: number, system_message_count: number, system_last_message?: string | null, system_last_message_time: number, message_count: number, last_message?: string | null, last_message_time: number, status: ChatStatus, is_hidden: boolean, is_pinned: boolean, compliance_status?: string | null, created_at: number, updated_at: number, clinic: { __typename?: 'Clinic', id: string, name?: string | null, slug?: string | null, phone?: string | null, email?: string | null, website?: string | null, avatar_url?: string | null, time_zone?: string | null, pms: PracticeManagementSystem, tmp_feature_flags?: any | null, address?: { __typename?: 'Address', street_a?: string | null, street_b?: string | null, city?: string | null, state?: string | null, zip?: string | null, country?: string | null } | null, settings?: { __typename?: 'ClinicSettings', id?: string | null, primary_color?: string | null, portal_links?: Array<{ __typename?: 'PortalLink', label: string, url: string }> | null } | null, pms_db?: { __typename?: 'PmsDb', id: string } | null }, client: { __typename?: 'Client', email_enabled: boolean, sms_enabled: boolean, id: string, first_name?: string | null, last_name?: string | null, secondary_first_name?: string | null, secondary_last_name?: string | null, phone?: string | null, email?: string | null, pms_id?: string | null, is_active?: boolean | null, is_unsubscribed: boolean, balance?: number | null, last_appt_time?: number | null, created_at: number, updated_at: number, client_phones?: Array<{ __typename?: 'ClientPhone', id: string, phone: string, country_code?: string | null, is_primary: boolean, is_chckup_primary: boolean, is_mobile: boolean, sms_available: boolean, is_unsubscribed: boolean, is_active: boolean, name?: string | null }> | null, last_appointment?: { __typename?: 'Appointment', clinician?: { __typename?: 'Clinician', name: string, display_name?: string | null } | null } | null, address?: { __typename?: 'Address', street_a?: string | null, street_b?: string | null, city?: string | null, state?: string | null, zip?: string | null, country?: string | null } | null, clinic?: { __typename?: 'Clinic', id: string } | null, user?: { __typename?: 'User', avatar_url?: string | null } | null, patients?: Array<{ __typename?: 'Patient', id: string, name?: string | null, gender?: string | null, pms_id?: string | null, is_deceased?: boolean | null, is_active?: boolean | null, clinic_species?: { __typename?: 'ClinicSpecies', id: string, species: Species } | null, clinic_breed?: { __typename?: 'Breed', id: string, description: string } | null, last_appointment?: { __typename?: 'Appointment', clinician?: { __typename?: 'Clinician', name: string, display_name?: string | null } | null } | null }> | null, settings?: { __typename?: 'ClientSettings', clinic_chckup_notifications_enabled: boolean, clinic_chckup_sms_enabled: boolean, clinic_chckup_email_enabled: boolean, client_chckup_notifications_enabled: boolean, client_chckup_sms_enabled: boolean, client_chckup_email_enabled: boolean, is_unsubscribed_from_marketing: boolean, is_unsubscribed_from_marketing_sms: boolean, is_unsubscribed_from_marketing_email: boolean } | null }, assignee?: { __typename?: 'User', id: string, avatar_url?: string | null, first_name?: string | null, last_name?: string | null } | null, chat_status?: { __typename?: 'ChatStatusConfig', id: string, name: string, color?: string | null } | null }> };

export type QueryChatsQueryVariables = Exact<{
  where?: InputMaybe<Array<QueryInput> | QueryInput>;
  page?: InputMaybe<Scalars['NonNegativeInt']['input']>;
  pageSize?: InputMaybe<Scalars['NonNegativeInt']['input']>;
  orderBy?: InputMaybe<OrderByInput>;
}>;


export type QueryChatsQuery = { __typename?: 'Query', queryChats: Array<{ __typename?: 'Chat', id: string, title?: string | null, client_last_message?: string | null, client_last_read: number, client_last_read_count: number, client_unread_count: number, client_message_count: number, client_last_message_time: number, clinic_last_message?: string | null, clinic_unread_count: number, clinic_last_read: number, clinic_last_read_count: number, clinic_message_count: number, clinic_last_message_time: number, non_system_last_message?: string | null, non_system_last_message_time: number, system_message_count: number, system_last_message?: string | null, system_last_message_time: number, message_count: number, last_message?: string | null, last_message_time: number, status: ChatStatus, is_hidden: boolean, is_pinned: boolean, compliance_status?: string | null, created_at: number, updated_at: number, clinic: { __typename?: 'Clinic', id: string, name?: string | null, slug?: string | null, phone?: string | null, email?: string | null, website?: string | null, avatar_url?: string | null, time_zone?: string | null, pms: PracticeManagementSystem, tmp_feature_flags?: any | null, address?: { __typename?: 'Address', street_a?: string | null, street_b?: string | null, city?: string | null, state?: string | null, zip?: string | null, country?: string | null } | null, settings?: { __typename?: 'ClinicSettings', id?: string | null, primary_color?: string | null, portal_links?: Array<{ __typename?: 'PortalLink', label: string, url: string }> | null } | null, pms_db?: { __typename?: 'PmsDb', id: string } | null }, client: { __typename?: 'Client', email_enabled: boolean, sms_enabled: boolean, id: string, first_name?: string | null, last_name?: string | null, secondary_first_name?: string | null, secondary_last_name?: string | null, phone?: string | null, email?: string | null, pms_id?: string | null, is_active?: boolean | null, is_unsubscribed: boolean, balance?: number | null, last_appt_time?: number | null, created_at: number, updated_at: number, client_phones?: Array<{ __typename?: 'ClientPhone', id: string, phone: string, country_code?: string | null, is_primary: boolean, is_chckup_primary: boolean, is_mobile: boolean, sms_available: boolean, is_unsubscribed: boolean, is_active: boolean, name?: string | null }> | null, last_appointment?: { __typename?: 'Appointment', clinician?: { __typename?: 'Clinician', name: string, display_name?: string | null } | null } | null, address?: { __typename?: 'Address', street_a?: string | null, street_b?: string | null, city?: string | null, state?: string | null, zip?: string | null, country?: string | null } | null, clinic?: { __typename?: 'Clinic', id: string } | null, user?: { __typename?: 'User', avatar_url?: string | null } | null, patients?: Array<{ __typename?: 'Patient', id: string, name?: string | null, gender?: string | null, pms_id?: string | null, is_deceased?: boolean | null, is_active?: boolean | null, clinic_species?: { __typename?: 'ClinicSpecies', id: string, species: Species } | null, clinic_breed?: { __typename?: 'Breed', id: string, description: string } | null, last_appointment?: { __typename?: 'Appointment', clinician?: { __typename?: 'Clinician', name: string, display_name?: string | null } | null } | null }> | null, settings?: { __typename?: 'ClientSettings', clinic_chckup_notifications_enabled: boolean, clinic_chckup_sms_enabled: boolean, clinic_chckup_email_enabled: boolean, client_chckup_notifications_enabled: boolean, client_chckup_sms_enabled: boolean, client_chckup_email_enabled: boolean, is_unsubscribed_from_marketing: boolean, is_unsubscribed_from_marketing_sms: boolean, is_unsubscribed_from_marketing_email: boolean } | null }, assignee?: { __typename?: 'User', id: string, avatar_url?: string | null, first_name?: string | null, last_name?: string | null } | null, chat_status?: { __typename?: 'ChatStatusConfig', id: string, name: string, color?: string | null } | null }> };

export type QueryChatPreviewsQueryVariables = Exact<{
  where?: InputMaybe<Array<QueryInput> | QueryInput>;
  page?: InputMaybe<Scalars['NonNegativeInt']['input']>;
  pageSize?: InputMaybe<Scalars['NonNegativeInt']['input']>;
  orderBy?: InputMaybe<OrderByInput>;
}>;


export type QueryChatPreviewsQuery = { __typename?: 'Query', queryChats: Array<{ __typename?: 'Chat', id: string, title?: string | null, clinic_unread_count: number, last_message?: string | null, last_message_time: number, client_last_message?: string | null, client_last_message_time: number, client_message_count: number, clinic_last_message?: string | null, clinic_last_message_time: number, non_system_last_message?: string | null, non_system_last_message_time: number, system_last_message?: string | null, system_last_message_time: number, status: ChatStatus, is_pinned: boolean, clinic: { __typename?: 'Clinic', id: string, pms: PracticeManagementSystem, name?: string | null }, client: { __typename?: 'Client', id: string, first_name?: string | null, last_name?: string | null, patients?: Array<{ __typename?: 'Patient', id: string, name?: string | null, pms_id?: string | null, is_deceased?: boolean | null, is_active?: boolean | null }> | null }, assignee?: { __typename?: 'User', id: string, avatar_url?: string | null, first_name?: string | null, last_name?: string | null } | null, chat_status?: { __typename?: 'ChatStatusConfig', id: string, name: string, color?: string | null } | null }> };

export type QueryClinicChatsQueryVariables = Exact<{
  where?: InputMaybe<Array<QueryInput> | QueryInput>;
  page?: InputMaybe<Scalars['NonNegativeInt']['input']>;
  pageSize?: InputMaybe<Scalars['NonNegativeInt']['input']>;
  orderBy?: InputMaybe<OrderByInput>;
  clinicId: Scalars['ID']['input'];
}>;


export type QueryClinicChatsQuery = { __typename?: 'Query', queryClinicChats: Array<{ __typename?: 'Chat', id: string, title?: string | null, client_last_message?: string | null, client_last_read: number, client_last_read_count: number, client_unread_count: number, client_message_count: number, client_last_message_time: number, clinic_last_message?: string | null, clinic_unread_count: number, clinic_last_read: number, clinic_last_read_count: number, clinic_message_count: number, clinic_last_message_time: number, non_system_last_message?: string | null, non_system_last_message_time: number, system_message_count: number, system_last_message?: string | null, system_last_message_time: number, message_count: number, last_message?: string | null, last_message_time: number, status: ChatStatus, is_hidden: boolean, is_pinned: boolean, compliance_status?: string | null, created_at: number, updated_at: number, clinic: { __typename?: 'Clinic', id: string, name?: string | null, slug?: string | null, phone?: string | null, email?: string | null, website?: string | null, avatar_url?: string | null, time_zone?: string | null, pms: PracticeManagementSystem, tmp_feature_flags?: any | null, address?: { __typename?: 'Address', street_a?: string | null, street_b?: string | null, city?: string | null, state?: string | null, zip?: string | null, country?: string | null } | null, settings?: { __typename?: 'ClinicSettings', id?: string | null, primary_color?: string | null, portal_links?: Array<{ __typename?: 'PortalLink', label: string, url: string }> | null } | null, pms_db?: { __typename?: 'PmsDb', id: string } | null }, client: { __typename?: 'Client', email_enabled: boolean, sms_enabled: boolean, id: string, first_name?: string | null, last_name?: string | null, secondary_first_name?: string | null, secondary_last_name?: string | null, phone?: string | null, email?: string | null, pms_id?: string | null, is_active?: boolean | null, is_unsubscribed: boolean, balance?: number | null, last_appt_time?: number | null, created_at: number, updated_at: number, client_phones?: Array<{ __typename?: 'ClientPhone', id: string, phone: string, country_code?: string | null, is_primary: boolean, is_chckup_primary: boolean, is_mobile: boolean, sms_available: boolean, is_unsubscribed: boolean, is_active: boolean, name?: string | null }> | null, last_appointment?: { __typename?: 'Appointment', clinician?: { __typename?: 'Clinician', name: string, display_name?: string | null } | null } | null, address?: { __typename?: 'Address', street_a?: string | null, street_b?: string | null, city?: string | null, state?: string | null, zip?: string | null, country?: string | null } | null, clinic?: { __typename?: 'Clinic', id: string } | null, user?: { __typename?: 'User', avatar_url?: string | null } | null, patients?: Array<{ __typename?: 'Patient', id: string, name?: string | null, gender?: string | null, pms_id?: string | null, is_deceased?: boolean | null, is_active?: boolean | null, clinic_species?: { __typename?: 'ClinicSpecies', id: string, species: Species } | null, clinic_breed?: { __typename?: 'Breed', id: string, description: string } | null, last_appointment?: { __typename?: 'Appointment', clinician?: { __typename?: 'Clinician', name: string, display_name?: string | null } | null } | null }> | null, settings?: { __typename?: 'ClientSettings', clinic_chckup_notifications_enabled: boolean, clinic_chckup_sms_enabled: boolean, clinic_chckup_email_enabled: boolean, client_chckup_notifications_enabled: boolean, client_chckup_sms_enabled: boolean, client_chckup_email_enabled: boolean, is_unsubscribed_from_marketing: boolean, is_unsubscribed_from_marketing_sms: boolean, is_unsubscribed_from_marketing_email: boolean } | null }, assignee?: { __typename?: 'User', id: string, avatar_url?: string | null, first_name?: string | null, last_name?: string | null } | null, chat_status?: { __typename?: 'ChatStatusConfig', id: string, name: string, color?: string | null } | null }> };

export type QueryClinicChatPreviewsQueryVariables = Exact<{
  where?: InputMaybe<Array<QueryInput> | QueryInput>;
  page?: InputMaybe<Scalars['NonNegativeInt']['input']>;
  pageSize?: InputMaybe<Scalars['NonNegativeInt']['input']>;
  orderBy?: InputMaybe<OrderByInput>;
  clinicId: Scalars['ID']['input'];
}>;


export type QueryClinicChatPreviewsQuery = { __typename?: 'Query', queryClinicChats: Array<{ __typename?: 'Chat', id: string, title?: string | null, clinic_unread_count: number, last_message?: string | null, last_message_time: number, client_last_message?: string | null, client_last_message_time: number, client_message_count: number, clinic_last_message?: string | null, clinic_last_message_time: number, non_system_last_message?: string | null, non_system_last_message_time: number, system_last_message?: string | null, system_last_message_time: number, status: ChatStatus, is_pinned: boolean, clinic: { __typename?: 'Clinic', id: string, pms: PracticeManagementSystem, name?: string | null }, client: { __typename?: 'Client', id: string, first_name?: string | null, last_name?: string | null, patients?: Array<{ __typename?: 'Patient', id: string, name?: string | null, pms_id?: string | null, is_deceased?: boolean | null, is_active?: boolean | null }> | null }, assignee?: { __typename?: 'User', id: string, avatar_url?: string | null, first_name?: string | null, last_name?: string | null } | null, chat_status?: { __typename?: 'ChatStatusConfig', id: string, name: string, color?: string | null } | null }> };

export type CountChatsQueryVariables = Exact<{
  where?: InputMaybe<Array<QueryInput> | QueryInput>;
}>;


export type CountChatsQuery = { __typename?: 'Query', countChats: number };

export type GetChatByClientAndClinicQueryVariables = Exact<{
  clientId: Scalars['ID']['input'];
  clinicId: Scalars['ID']['input'];
}>;


export type GetChatByClientAndClinicQuery = { __typename?: 'Query', getChatByClientAndClinic?: { __typename?: 'Chat', id: string, title?: string | null, client_last_message?: string | null, client_last_read: number, client_last_read_count: number, client_unread_count: number, client_message_count: number, client_last_message_time: number, clinic_last_message?: string | null, clinic_unread_count: number, clinic_last_read: number, clinic_last_read_count: number, clinic_message_count: number, clinic_last_message_time: number, non_system_last_message?: string | null, non_system_last_message_time: number, system_message_count: number, system_last_message?: string | null, system_last_message_time: number, message_count: number, last_message?: string | null, last_message_time: number, status: ChatStatus, is_hidden: boolean, is_pinned: boolean, compliance_status?: string | null, created_at: number, updated_at: number, clinic: { __typename?: 'Clinic', id: string, name?: string | null, slug?: string | null, phone?: string | null, email?: string | null, website?: string | null, avatar_url?: string | null, time_zone?: string | null, pms: PracticeManagementSystem, tmp_feature_flags?: any | null, address?: { __typename?: 'Address', street_a?: string | null, street_b?: string | null, city?: string | null, state?: string | null, zip?: string | null, country?: string | null } | null, settings?: { __typename?: 'ClinicSettings', id?: string | null, primary_color?: string | null, portal_links?: Array<{ __typename?: 'PortalLink', label: string, url: string }> | null } | null, pms_db?: { __typename?: 'PmsDb', id: string } | null }, client: { __typename?: 'Client', email_enabled: boolean, sms_enabled: boolean, id: string, first_name?: string | null, last_name?: string | null, secondary_first_name?: string | null, secondary_last_name?: string | null, phone?: string | null, email?: string | null, pms_id?: string | null, is_active?: boolean | null, is_unsubscribed: boolean, balance?: number | null, last_appt_time?: number | null, created_at: number, updated_at: number, client_phones?: Array<{ __typename?: 'ClientPhone', id: string, phone: string, country_code?: string | null, is_primary: boolean, is_chckup_primary: boolean, is_mobile: boolean, sms_available: boolean, is_unsubscribed: boolean, is_active: boolean, name?: string | null }> | null, last_appointment?: { __typename?: 'Appointment', clinician?: { __typename?: 'Clinician', name: string, display_name?: string | null } | null } | null, address?: { __typename?: 'Address', street_a?: string | null, street_b?: string | null, city?: string | null, state?: string | null, zip?: string | null, country?: string | null } | null, clinic?: { __typename?: 'Clinic', id: string } | null, user?: { __typename?: 'User', avatar_url?: string | null } | null, patients?: Array<{ __typename?: 'Patient', id: string, name?: string | null, gender?: string | null, pms_id?: string | null, is_deceased?: boolean | null, is_active?: boolean | null, clinic_species?: { __typename?: 'ClinicSpecies', id: string, species: Species } | null, clinic_breed?: { __typename?: 'Breed', id: string, description: string } | null, last_appointment?: { __typename?: 'Appointment', clinician?: { __typename?: 'Clinician', name: string, display_name?: string | null } | null } | null }> | null, settings?: { __typename?: 'ClientSettings', clinic_chckup_notifications_enabled: boolean, clinic_chckup_sms_enabled: boolean, clinic_chckup_email_enabled: boolean, client_chckup_notifications_enabled: boolean, client_chckup_sms_enabled: boolean, client_chckup_email_enabled: boolean, is_unsubscribed_from_marketing: boolean, is_unsubscribed_from_marketing_sms: boolean, is_unsubscribed_from_marketing_email: boolean } | null }, assignee?: { __typename?: 'User', id: string, avatar_url?: string | null, first_name?: string | null, last_name?: string | null } | null, chat_status?: { __typename?: 'ChatStatusConfig', id: string, name: string, color?: string | null } | null } | null };

export type GetChatIdByClientAndClinicQueryVariables = Exact<{
  clientId: Scalars['ID']['input'];
  clinicId: Scalars['ID']['input'];
}>;


export type GetChatIdByClientAndClinicQuery = { __typename?: 'Query', getChatByClientAndClinic?: { __typename?: 'Chat', id: string } | null };

export type CreateChatMutationVariables = Exact<{
  data: CreateChatInput;
}>;


export type CreateChatMutation = { __typename?: 'Mutation', createChat: { __typename?: 'Chat', id: string, title?: string | null, client_last_message?: string | null, client_last_read: number, client_last_read_count: number, client_unread_count: number, client_message_count: number, client_last_message_time: number, clinic_last_message?: string | null, clinic_unread_count: number, clinic_last_read: number, clinic_last_read_count: number, clinic_message_count: number, clinic_last_message_time: number, non_system_last_message?: string | null, non_system_last_message_time: number, system_message_count: number, system_last_message?: string | null, system_last_message_time: number, message_count: number, last_message?: string | null, last_message_time: number, status: ChatStatus, is_hidden: boolean, is_pinned: boolean, compliance_status?: string | null, created_at: number, updated_at: number, clinic: { __typename?: 'Clinic', id: string, name?: string | null, slug?: string | null, phone?: string | null, email?: string | null, website?: string | null, avatar_url?: string | null, time_zone?: string | null, pms: PracticeManagementSystem, tmp_feature_flags?: any | null, address?: { __typename?: 'Address', street_a?: string | null, street_b?: string | null, city?: string | null, state?: string | null, zip?: string | null, country?: string | null } | null, settings?: { __typename?: 'ClinicSettings', id?: string | null, primary_color?: string | null, portal_links?: Array<{ __typename?: 'PortalLink', label: string, url: string }> | null } | null, pms_db?: { __typename?: 'PmsDb', id: string } | null }, client: { __typename?: 'Client', email_enabled: boolean, sms_enabled: boolean, id: string, first_name?: string | null, last_name?: string | null, secondary_first_name?: string | null, secondary_last_name?: string | null, phone?: string | null, email?: string | null, pms_id?: string | null, is_active?: boolean | null, is_unsubscribed: boolean, balance?: number | null, last_appt_time?: number | null, created_at: number, updated_at: number, client_phones?: Array<{ __typename?: 'ClientPhone', id: string, phone: string, country_code?: string | null, is_primary: boolean, is_chckup_primary: boolean, is_mobile: boolean, sms_available: boolean, is_unsubscribed: boolean, is_active: boolean, name?: string | null }> | null, last_appointment?: { __typename?: 'Appointment', clinician?: { __typename?: 'Clinician', name: string, display_name?: string | null } | null } | null, address?: { __typename?: 'Address', street_a?: string | null, street_b?: string | null, city?: string | null, state?: string | null, zip?: string | null, country?: string | null } | null, clinic?: { __typename?: 'Clinic', id: string } | null, user?: { __typename?: 'User', avatar_url?: string | null } | null, patients?: Array<{ __typename?: 'Patient', id: string, name?: string | null, gender?: string | null, pms_id?: string | null, is_deceased?: boolean | null, is_active?: boolean | null, clinic_species?: { __typename?: 'ClinicSpecies', id: string, species: Species } | null, clinic_breed?: { __typename?: 'Breed', id: string, description: string } | null, last_appointment?: { __typename?: 'Appointment', clinician?: { __typename?: 'Clinician', name: string, display_name?: string | null } | null } | null }> | null, settings?: { __typename?: 'ClientSettings', clinic_chckup_notifications_enabled: boolean, clinic_chckup_sms_enabled: boolean, clinic_chckup_email_enabled: boolean, client_chckup_notifications_enabled: boolean, client_chckup_sms_enabled: boolean, client_chckup_email_enabled: boolean, is_unsubscribed_from_marketing: boolean, is_unsubscribed_from_marketing_sms: boolean, is_unsubscribed_from_marketing_email: boolean } | null }, assignee?: { __typename?: 'User', id: string, avatar_url?: string | null, first_name?: string | null, last_name?: string | null } | null, chat_status?: { __typename?: 'ChatStatusConfig', id: string, name: string, color?: string | null } | null } };

export type CreateChatWithNonClientMutationVariables = Exact<{
  data: CreateChatWithNonClientInput;
}>;


export type CreateChatWithNonClientMutation = { __typename?: 'Mutation', createChatWithNonClient: { __typename?: 'Chat', id: string, client: { __typename?: 'Client', id: string } } };

export type UpdateChatMutationVariables = Exact<{
  id: Scalars['ID']['input'];
  data: UpdateChatInput;
}>;


export type UpdateChatMutation = { __typename?: 'Mutation', updateChat: { __typename?: 'Chat', compliance_status_updated_at?: number | null, id: string, title?: string | null, client_last_message?: string | null, client_last_read: number, client_last_read_count: number, client_unread_count: number, client_message_count: number, client_last_message_time: number, clinic_last_message?: string | null, clinic_unread_count: number, clinic_last_read: number, clinic_last_read_count: number, clinic_message_count: number, clinic_last_message_time: number, non_system_last_message?: string | null, non_system_last_message_time: number, system_message_count: number, system_last_message?: string | null, system_last_message_time: number, message_count: number, last_message?: string | null, last_message_time: number, status: ChatStatus, is_hidden: boolean, is_pinned: boolean, compliance_status?: string | null, created_at: number, updated_at: number, compliance_status_updated_by?: { __typename?: 'User', id: string, avatar_url?: string | null, first_name?: string | null, last_name?: string | null } | null, clinic: { __typename?: 'Clinic', id: string, name?: string | null, slug?: string | null, phone?: string | null, email?: string | null, website?: string | null, avatar_url?: string | null, time_zone?: string | null, pms: PracticeManagementSystem, tmp_feature_flags?: any | null, address?: { __typename?: 'Address', street_a?: string | null, street_b?: string | null, city?: string | null, state?: string | null, zip?: string | null, country?: string | null } | null, settings?: { __typename?: 'ClinicSettings', id?: string | null, primary_color?: string | null, portal_links?: Array<{ __typename?: 'PortalLink', label: string, url: string }> | null } | null, pms_db?: { __typename?: 'PmsDb', id: string } | null }, client: { __typename?: 'Client', email_enabled: boolean, sms_enabled: boolean, id: string, first_name?: string | null, last_name?: string | null, secondary_first_name?: string | null, secondary_last_name?: string | null, phone?: string | null, email?: string | null, pms_id?: string | null, is_active?: boolean | null, is_unsubscribed: boolean, balance?: number | null, last_appt_time?: number | null, created_at: number, updated_at: number, client_phones?: Array<{ __typename?: 'ClientPhone', id: string, phone: string, country_code?: string | null, is_primary: boolean, is_chckup_primary: boolean, is_mobile: boolean, sms_available: boolean, is_unsubscribed: boolean, is_active: boolean, name?: string | null }> | null, last_appointment?: { __typename?: 'Appointment', clinician?: { __typename?: 'Clinician', name: string, display_name?: string | null } | null } | null, address?: { __typename?: 'Address', street_a?: string | null, street_b?: string | null, city?: string | null, state?: string | null, zip?: string | null, country?: string | null } | null, clinic?: { __typename?: 'Clinic', id: string } | null, user?: { __typename?: 'User', avatar_url?: string | null } | null, patients?: Array<{ __typename?: 'Patient', id: string, name?: string | null, gender?: string | null, pms_id?: string | null, is_deceased?: boolean | null, is_active?: boolean | null, clinic_species?: { __typename?: 'ClinicSpecies', id: string, species: Species } | null, clinic_breed?: { __typename?: 'Breed', id: string, description: string } | null, last_appointment?: { __typename?: 'Appointment', clinician?: { __typename?: 'Clinician', name: string, display_name?: string | null } | null } | null }> | null, settings?: { __typename?: 'ClientSettings', clinic_chckup_notifications_enabled: boolean, clinic_chckup_sms_enabled: boolean, clinic_chckup_email_enabled: boolean, client_chckup_notifications_enabled: boolean, client_chckup_sms_enabled: boolean, client_chckup_email_enabled: boolean, is_unsubscribed_from_marketing: boolean, is_unsubscribed_from_marketing_sms: boolean, is_unsubscribed_from_marketing_email: boolean } | null }, assignee?: { __typename?: 'User', id: string, avatar_url?: string | null, first_name?: string | null, last_name?: string | null } | null, chat_status?: { __typename?: 'ChatStatusConfig', id: string, name: string, color?: string | null } | null } };

export type UploadAttachmentMutationVariables = Exact<{
  clinicId: Scalars['ID']['input'];
  data: AttachmentInput;
}>;


export type UploadAttachmentMutation = { __typename?: 'Mutation', uploadAttachment?: any | null };

export type WritebackChatMutationVariables = Exact<{
  chatId: Scalars['ID']['input'];
  messageIds: Array<Scalars['ID']['input']> | Scalars['ID']['input'];
  isManualWriteback?: InputMaybe<Scalars['Boolean']['input']>;
}>;


export type WritebackChatMutation = { __typename?: 'Mutation', writebackChat: Array<string> };

export type MergeChatMutationVariables = Exact<{
  mergeFromChatId: Scalars['ID']['input'];
  mergeIntoChatId: Scalars['ID']['input'];
}>;


export type MergeChatMutation = { __typename?: 'Mutation', mergeChat: { __typename?: 'Chat', id: string, client: { __typename?: 'Client', id: string } } };

export type CheckInFieldsFragment = { __typename?: 'CheckIn', id: string, status?: CheckInStatus | null, vehicle?: string | null, visit_reason?: VisitReason | null, created_at: number, updated_at: number, user: { __typename?: 'User', id: string, first_name?: string | null, last_name?: string | null, avatar_url?: string | null }, clinic: { __typename?: 'Clinic', id: string, name?: string | null, avatar_url?: string | null } };

export type GetCheckInQueryVariables = Exact<{
  id: Scalars['ID']['input'];
}>;


export type GetCheckInQuery = { __typename?: 'Query', checkIn: { __typename?: 'CheckIn', id: string, status?: CheckInStatus | null, vehicle?: string | null, visit_reason?: VisitReason | null, created_at: number, updated_at: number, user: { __typename?: 'User', id: string, first_name?: string | null, last_name?: string | null, avatar_url?: string | null }, clinic: { __typename?: 'Clinic', id: string, name?: string | null, avatar_url?: string | null } } };

export type GetCheckInsByUserQueryVariables = Exact<{
  userId: Scalars['ID']['input'];
}>;


export type GetCheckInsByUserQuery = { __typename?: 'Query', getCheckInsByUser: Array<{ __typename?: 'CheckIn', id: string, status?: CheckInStatus | null, vehicle?: string | null, visit_reason?: VisitReason | null, created_at: number, updated_at: number, user: { __typename?: 'User', id: string, first_name?: string | null, last_name?: string | null, avatar_url?: string | null }, clinic: { __typename?: 'Clinic', id: string, name?: string | null, avatar_url?: string | null } }> };

export type GetCheckInsByClinicQueryVariables = Exact<{
  clinicId: Scalars['ID']['input'];
}>;


export type GetCheckInsByClinicQuery = { __typename?: 'Query', getCheckInsByClinic: Array<{ __typename?: 'CheckIn', id: string, status?: CheckInStatus | null, vehicle?: string | null, visit_reason?: VisitReason | null, created_at: number, updated_at: number, user: { __typename?: 'User', id: string, first_name?: string | null, last_name?: string | null, avatar_url?: string | null }, clinic: { __typename?: 'Clinic', id: string, name?: string | null, avatar_url?: string | null } }> };

export type CreateCheckInMutationVariables = Exact<{
  data: CreateCheckInInput;
}>;


export type CreateCheckInMutation = { __typename?: 'Mutation', createCheckIn: { __typename?: 'CheckIn', id: string, status?: CheckInStatus | null, vehicle?: string | null, visit_reason?: VisitReason | null, created_at: number, updated_at: number, user: { __typename?: 'User', id: string, first_name?: string | null, last_name?: string | null, avatar_url?: string | null }, clinic: { __typename?: 'Clinic', id: string, name?: string | null, avatar_url?: string | null } } };

export type UpdateCheckInMutationVariables = Exact<{
  id: Scalars['ID']['input'];
  data: UpdateCheckInInput;
}>;


export type UpdateCheckInMutation = { __typename?: 'Mutation', updateCheckIn: { __typename?: 'CheckIn', id: string, status?: CheckInStatus | null, vehicle?: string | null, visit_reason?: VisitReason | null, created_at: number, updated_at: number, user: { __typename?: 'User', id: string, first_name?: string | null, last_name?: string | null, avatar_url?: string | null }, clinic: { __typename?: 'Clinic', id: string, name?: string | null, avatar_url?: string | null } } };

export type ClientFormFieldsFragment = { __typename?: 'ClientForm', id: string, client_completed_at?: number | null, clinic_verified_at?: number | null, is_archived: boolean, pms_id?: string | null, created_at: number, updated_at: number, client?: { __typename?: 'Client', id: string, first_name?: string | null, last_name?: string | null, phone?: string | null, email?: string | null, address?: { __typename?: 'Address', street_a?: string | null, city?: string | null, state?: string | null, zip?: string | null, country?: string | null } | null } | null, patient?: { __typename?: 'Patient', id: string, name?: string | null, is_active?: boolean | null, is_deceased?: boolean | null, birthday?: number | null, weight?: number | null, avatar_url?: string | null, gender?: string | null, owner?: { __typename?: 'Client', first_name?: string | null, last_name?: string | null } | null, clinic_species?: { __typename?: 'ClinicSpecies', id: string, species: Species, description: string, weight_key: string } | null, clinic_breed?: { __typename?: 'Breed', id: string, description: string } | null } | null, form: { __typename?: 'Form', id: string, name?: string | null, form_type: FormType, is_writeback_enabled: boolean, form_file_naming_template?: string | null }, form_data: { __typename?: 'FormFields', pages?: Array<{ __typename?: 'FormPage', id: string, title?: string | null, description?: string | null, order?: number | null }> | null, fields?: Array<{ __typename?: 'FormElement', id: string, type?: FormElementType | null, content?: string | null, name?: string | null, column_order?: number | null, row_order?: number | null, page_id?: string | null, options?: Array<string> | null, is_required?: boolean | null, value?: string | null, attachments?: Array<{ __typename?: 'FormFileAttachment', id?: string | null, filename?: string | null, mime_type?: string | null, size_bytes?: number | null, thumbnail_url?: string | null, url: string }> | null, field_updates?: Array<{ __typename?: 'FormFieldUpdate', field: FormFieldUpdateField, boolean_value?: boolean | null, option?: string | null }> | null }> | null }, appointment?: { __typename?: 'Appointment', start_time: number, drop_off_time?: number | null, clinic?: { __typename?: 'Clinic', name?: string | null, slug?: string | null, phone?: string | null, email?: string | null, address?: { __typename?: 'Address', street_a?: string | null, city?: string | null, state?: string | null, zip?: string | null, country?: string | null } | null } | null, clinician?: { __typename?: 'Clinician', name: string, display_name?: string | null } | null, service?: { __typename?: 'Service', name?: string | null } | null } | null };

export type ClientFormBasicInfoFieldsFragment = { __typename?: 'ClientForm', id: string, client_completed_at?: number | null, created_at: number, client?: { __typename?: 'Client', id: string, first_name?: string | null, last_name?: string | null } | null, patient?: { __typename?: 'Patient', id: string, name?: string | null } | null, form: { __typename?: 'Form', id: string, name?: string | null } };

export type ClientFormQueryVariables = Exact<{
  id: Scalars['ID']['input'];
}>;


export type ClientFormQuery = { __typename?: 'Query', clientForm: { __typename?: 'ClientForm', id: string, client_completed_at?: number | null, clinic_verified_at?: number | null, is_archived: boolean, pms_id?: string | null, created_at: number, updated_at: number, client?: { __typename?: 'Client', id: string, first_name?: string | null, last_name?: string | null, phone?: string | null, email?: string | null, address?: { __typename?: 'Address', street_a?: string | null, city?: string | null, state?: string | null, zip?: string | null, country?: string | null } | null } | null, patient?: { __typename?: 'Patient', id: string, name?: string | null, is_active?: boolean | null, is_deceased?: boolean | null, birthday?: number | null, weight?: number | null, avatar_url?: string | null, gender?: string | null, owner?: { __typename?: 'Client', first_name?: string | null, last_name?: string | null } | null, clinic_species?: { __typename?: 'ClinicSpecies', id: string, species: Species, description: string, weight_key: string } | null, clinic_breed?: { __typename?: 'Breed', id: string, description: string } | null } | null, form: { __typename?: 'Form', id: string, name?: string | null, form_type: FormType, is_writeback_enabled: boolean, form_file_naming_template?: string | null }, form_data: { __typename?: 'FormFields', pages?: Array<{ __typename?: 'FormPage', id: string, title?: string | null, description?: string | null, order?: number | null }> | null, fields?: Array<{ __typename?: 'FormElement', id: string, type?: FormElementType | null, content?: string | null, name?: string | null, column_order?: number | null, row_order?: number | null, page_id?: string | null, options?: Array<string> | null, is_required?: boolean | null, value?: string | null, attachments?: Array<{ __typename?: 'FormFileAttachment', id?: string | null, filename?: string | null, mime_type?: string | null, size_bytes?: number | null, thumbnail_url?: string | null, url: string }> | null, field_updates?: Array<{ __typename?: 'FormFieldUpdate', field: FormFieldUpdateField, boolean_value?: boolean | null, option?: string | null }> | null }> | null }, appointment?: { __typename?: 'Appointment', start_time: number, drop_off_time?: number | null, clinic?: { __typename?: 'Clinic', name?: string | null, slug?: string | null, phone?: string | null, email?: string | null, address?: { __typename?: 'Address', street_a?: string | null, city?: string | null, state?: string | null, zip?: string | null, country?: string | null } | null } | null, clinician?: { __typename?: 'Clinician', name: string, display_name?: string | null } | null, service?: { __typename?: 'Service', name?: string | null } | null } | null } };

export type QueryClientFormsQueryVariables = Exact<{
  where?: InputMaybe<Array<QueryInput> | QueryInput>;
  page?: InputMaybe<Scalars['NonNegativeInt']['input']>;
  pageSize?: InputMaybe<Scalars['NonNegativeInt']['input']>;
  orderBy?: InputMaybe<OrderByInput>;
}>;


export type QueryClientFormsQuery = { __typename?: 'Query', queryClientForms: Array<{ __typename?: 'ClientForm', id: string, client_completed_at?: number | null, clinic_verified_at?: number | null, is_archived: boolean, pms_id?: string | null, created_at: number, updated_at: number, client?: { __typename?: 'Client', id: string, first_name?: string | null, last_name?: string | null, phone?: string | null, email?: string | null, address?: { __typename?: 'Address', street_a?: string | null, city?: string | null, state?: string | null, zip?: string | null, country?: string | null } | null } | null, patient?: { __typename?: 'Patient', id: string, name?: string | null, is_active?: boolean | null, is_deceased?: boolean | null, birthday?: number | null, weight?: number | null, avatar_url?: string | null, gender?: string | null, owner?: { __typename?: 'Client', first_name?: string | null, last_name?: string | null } | null, clinic_species?: { __typename?: 'ClinicSpecies', id: string, species: Species, description: string, weight_key: string } | null, clinic_breed?: { __typename?: 'Breed', id: string, description: string } | null } | null, form: { __typename?: 'Form', id: string, name?: string | null, form_type: FormType, is_writeback_enabled: boolean, form_file_naming_template?: string | null }, form_data: { __typename?: 'FormFields', pages?: Array<{ __typename?: 'FormPage', id: string, title?: string | null, description?: string | null, order?: number | null }> | null, fields?: Array<{ __typename?: 'FormElement', id: string, type?: FormElementType | null, content?: string | null, name?: string | null, column_order?: number | null, row_order?: number | null, page_id?: string | null, options?: Array<string> | null, is_required?: boolean | null, value?: string | null, attachments?: Array<{ __typename?: 'FormFileAttachment', id?: string | null, filename?: string | null, mime_type?: string | null, size_bytes?: number | null, thumbnail_url?: string | null, url: string }> | null, field_updates?: Array<{ __typename?: 'FormFieldUpdate', field: FormFieldUpdateField, boolean_value?: boolean | null, option?: string | null }> | null }> | null }, appointment?: { __typename?: 'Appointment', start_time: number, drop_off_time?: number | null, clinic?: { __typename?: 'Clinic', name?: string | null, slug?: string | null, phone?: string | null, email?: string | null, address?: { __typename?: 'Address', street_a?: string | null, city?: string | null, state?: string | null, zip?: string | null, country?: string | null } | null } | null, clinician?: { __typename?: 'Clinician', name: string, display_name?: string | null } | null, service?: { __typename?: 'Service', name?: string | null } | null } | null }> };

export type CountClientFormsQueryVariables = Exact<{
  where?: InputMaybe<Array<QueryInput> | QueryInput>;
}>;


export type CountClientFormsQuery = { __typename?: 'Query', countClientForms: number };

export type GetPdfUrlForClientFormQueryVariables = Exact<{
  clientFormId: Scalars['ID']['input'];
}>;


export type GetPdfUrlForClientFormQuery = { __typename?: 'Query', getPdfUrlForClientForm: string };

export type CreateClientFormMutationVariables = Exact<{
  data: CreateClientFormInput;
}>;


export type CreateClientFormMutation = { __typename?: 'Mutation', createClientForm: { __typename?: 'ClientForm', id: string, client_completed_at?: number | null, clinic_verified_at?: number | null, is_archived: boolean, pms_id?: string | null, created_at: number, updated_at: number, client?: { __typename?: 'Client', id: string, first_name?: string | null, last_name?: string | null, phone?: string | null, email?: string | null, address?: { __typename?: 'Address', street_a?: string | null, city?: string | null, state?: string | null, zip?: string | null, country?: string | null } | null } | null, patient?: { __typename?: 'Patient', id: string, name?: string | null, is_active?: boolean | null, is_deceased?: boolean | null, birthday?: number | null, weight?: number | null, avatar_url?: string | null, gender?: string | null, owner?: { __typename?: 'Client', first_name?: string | null, last_name?: string | null } | null, clinic_species?: { __typename?: 'ClinicSpecies', id: string, species: Species, description: string, weight_key: string } | null, clinic_breed?: { __typename?: 'Breed', id: string, description: string } | null } | null, form: { __typename?: 'Form', id: string, name?: string | null, form_type: FormType, is_writeback_enabled: boolean, form_file_naming_template?: string | null }, form_data: { __typename?: 'FormFields', pages?: Array<{ __typename?: 'FormPage', id: string, title?: string | null, description?: string | null, order?: number | null }> | null, fields?: Array<{ __typename?: 'FormElement', id: string, type?: FormElementType | null, content?: string | null, name?: string | null, column_order?: number | null, row_order?: number | null, page_id?: string | null, options?: Array<string> | null, is_required?: boolean | null, value?: string | null, attachments?: Array<{ __typename?: 'FormFileAttachment', id?: string | null, filename?: string | null, mime_type?: string | null, size_bytes?: number | null, thumbnail_url?: string | null, url: string }> | null, field_updates?: Array<{ __typename?: 'FormFieldUpdate', field: FormFieldUpdateField, boolean_value?: boolean | null, option?: string | null }> | null }> | null }, appointment?: { __typename?: 'Appointment', start_time: number, drop_off_time?: number | null, clinic?: { __typename?: 'Clinic', name?: string | null, slug?: string | null, phone?: string | null, email?: string | null, address?: { __typename?: 'Address', street_a?: string | null, city?: string | null, state?: string | null, zip?: string | null, country?: string | null } | null } | null, clinician?: { __typename?: 'Clinician', name: string, display_name?: string | null } | null, service?: { __typename?: 'Service', name?: string | null } | null } | null } };

export type UpdateClientFormMutationVariables = Exact<{
  id: Scalars['ID']['input'];
  data: UpdateClientFormInput;
}>;


export type UpdateClientFormMutation = { __typename?: 'Mutation', updateClientForm: { __typename?: 'ClientForm', id: string, client_completed_at?: number | null, clinic_verified_at?: number | null, is_archived: boolean, pms_id?: string | null, created_at: number, updated_at: number, client?: { __typename?: 'Client', id: string, first_name?: string | null, last_name?: string | null, phone?: string | null, email?: string | null, address?: { __typename?: 'Address', street_a?: string | null, city?: string | null, state?: string | null, zip?: string | null, country?: string | null } | null } | null, patient?: { __typename?: 'Patient', id: string, name?: string | null, is_active?: boolean | null, is_deceased?: boolean | null, birthday?: number | null, weight?: number | null, avatar_url?: string | null, gender?: string | null, owner?: { __typename?: 'Client', first_name?: string | null, last_name?: string | null } | null, clinic_species?: { __typename?: 'ClinicSpecies', id: string, species: Species, description: string, weight_key: string } | null, clinic_breed?: { __typename?: 'Breed', id: string, description: string } | null } | null, form: { __typename?: 'Form', id: string, name?: string | null, form_type: FormType, is_writeback_enabled: boolean, form_file_naming_template?: string | null }, form_data: { __typename?: 'FormFields', pages?: Array<{ __typename?: 'FormPage', id: string, title?: string | null, description?: string | null, order?: number | null }> | null, fields?: Array<{ __typename?: 'FormElement', id: string, type?: FormElementType | null, content?: string | null, name?: string | null, column_order?: number | null, row_order?: number | null, page_id?: string | null, options?: Array<string> | null, is_required?: boolean | null, value?: string | null, attachments?: Array<{ __typename?: 'FormFileAttachment', id?: string | null, filename?: string | null, mime_type?: string | null, size_bytes?: number | null, thumbnail_url?: string | null, url: string }> | null, field_updates?: Array<{ __typename?: 'FormFieldUpdate', field: FormFieldUpdateField, boolean_value?: boolean | null, option?: string | null }> | null }> | null }, appointment?: { __typename?: 'Appointment', start_time: number, drop_off_time?: number | null, clinic?: { __typename?: 'Clinic', name?: string | null, slug?: string | null, phone?: string | null, email?: string | null, address?: { __typename?: 'Address', street_a?: string | null, city?: string | null, state?: string | null, zip?: string | null, country?: string | null } | null } | null, clinician?: { __typename?: 'Clinician', name: string, display_name?: string | null } | null, service?: { __typename?: 'Service', name?: string | null } | null } | null } };

export type AssignClientFormToClientMutationVariables = Exact<{
  id: Scalars['ID']['input'];
  clientId: Scalars['ID']['input'];
}>;


export type AssignClientFormToClientMutation = { __typename?: 'Mutation', assignClientFormToClient: { __typename?: 'ClientForm', id: string, client_completed_at?: number | null, clinic_verified_at?: number | null, is_archived: boolean, pms_id?: string | null, created_at: number, updated_at: number, client?: { __typename?: 'Client', id: string, first_name?: string | null, last_name?: string | null, phone?: string | null, email?: string | null, address?: { __typename?: 'Address', street_a?: string | null, city?: string | null, state?: string | null, zip?: string | null, country?: string | null } | null } | null, patient?: { __typename?: 'Patient', id: string, name?: string | null, is_active?: boolean | null, is_deceased?: boolean | null, birthday?: number | null, weight?: number | null, avatar_url?: string | null, gender?: string | null, owner?: { __typename?: 'Client', first_name?: string | null, last_name?: string | null } | null, clinic_species?: { __typename?: 'ClinicSpecies', id: string, species: Species, description: string, weight_key: string } | null, clinic_breed?: { __typename?: 'Breed', id: string, description: string } | null } | null, form: { __typename?: 'Form', id: string, name?: string | null, form_type: FormType, is_writeback_enabled: boolean, form_file_naming_template?: string | null }, form_data: { __typename?: 'FormFields', pages?: Array<{ __typename?: 'FormPage', id: string, title?: string | null, description?: string | null, order?: number | null }> | null, fields?: Array<{ __typename?: 'FormElement', id: string, type?: FormElementType | null, content?: string | null, name?: string | null, column_order?: number | null, row_order?: number | null, page_id?: string | null, options?: Array<string> | null, is_required?: boolean | null, value?: string | null, attachments?: Array<{ __typename?: 'FormFileAttachment', id?: string | null, filename?: string | null, mime_type?: string | null, size_bytes?: number | null, thumbnail_url?: string | null, url: string }> | null, field_updates?: Array<{ __typename?: 'FormFieldUpdate', field: FormFieldUpdateField, boolean_value?: boolean | null, option?: string | null }> | null }> | null }, appointment?: { __typename?: 'Appointment', start_time: number, drop_off_time?: number | null, clinic?: { __typename?: 'Clinic', name?: string | null, slug?: string | null, phone?: string | null, email?: string | null, address?: { __typename?: 'Address', street_a?: string | null, city?: string | null, state?: string | null, zip?: string | null, country?: string | null } | null } | null, clinician?: { __typename?: 'Clinician', name: string, display_name?: string | null } | null, service?: { __typename?: 'Service', name?: string | null } | null } | null } };

export type AssignClientFormToPatientMutationVariables = Exact<{
  id: Scalars['ID']['input'];
  patientId: Scalars['ID']['input'];
}>;


export type AssignClientFormToPatientMutation = { __typename?: 'Mutation', assignClientFormToPatient: { __typename?: 'ClientForm', id: string, client_completed_at?: number | null, clinic_verified_at?: number | null, is_archived: boolean, pms_id?: string | null, created_at: number, updated_at: number, client?: { __typename?: 'Client', id: string, first_name?: string | null, last_name?: string | null, phone?: string | null, email?: string | null, address?: { __typename?: 'Address', street_a?: string | null, city?: string | null, state?: string | null, zip?: string | null, country?: string | null } | null } | null, patient?: { __typename?: 'Patient', id: string, name?: string | null, is_active?: boolean | null, is_deceased?: boolean | null, birthday?: number | null, weight?: number | null, avatar_url?: string | null, gender?: string | null, owner?: { __typename?: 'Client', first_name?: string | null, last_name?: string | null } | null, clinic_species?: { __typename?: 'ClinicSpecies', id: string, species: Species, description: string, weight_key: string } | null, clinic_breed?: { __typename?: 'Breed', id: string, description: string } | null } | null, form: { __typename?: 'Form', id: string, name?: string | null, form_type: FormType, is_writeback_enabled: boolean, form_file_naming_template?: string | null }, form_data: { __typename?: 'FormFields', pages?: Array<{ __typename?: 'FormPage', id: string, title?: string | null, description?: string | null, order?: number | null }> | null, fields?: Array<{ __typename?: 'FormElement', id: string, type?: FormElementType | null, content?: string | null, name?: string | null, column_order?: number | null, row_order?: number | null, page_id?: string | null, options?: Array<string> | null, is_required?: boolean | null, value?: string | null, attachments?: Array<{ __typename?: 'FormFileAttachment', id?: string | null, filename?: string | null, mime_type?: string | null, size_bytes?: number | null, thumbnail_url?: string | null, url: string }> | null, field_updates?: Array<{ __typename?: 'FormFieldUpdate', field: FormFieldUpdateField, boolean_value?: boolean | null, option?: string | null }> | null }> | null }, appointment?: { __typename?: 'Appointment', start_time: number, drop_off_time?: number | null, clinic?: { __typename?: 'Clinic', name?: string | null, slug?: string | null, phone?: string | null, email?: string | null, address?: { __typename?: 'Address', street_a?: string | null, city?: string | null, state?: string | null, zip?: string | null, country?: string | null } | null } | null, clinician?: { __typename?: 'Clinician', name: string, display_name?: string | null } | null, service?: { __typename?: 'Service', name?: string | null } | null } | null } };

export type WritebackClientFormMutationVariables = Exact<{
  id: Scalars['ID']['input'];
  isManualWriteback?: InputMaybe<Scalars['Boolean']['input']>;
}>;


export type WritebackClientFormMutation = { __typename?: 'Mutation', writebackClientForm?: any | null };

export type ClientFieldsFragment = { __typename?: 'Client', id: string, first_name?: string | null, last_name?: string | null, secondary_first_name?: string | null, secondary_last_name?: string | null, phone?: string | null, email?: string | null, pms?: PracticeManagementSystem | null, pms_id?: string | null, last_appt_time?: number | null, last_contact_time?: number | null, email_enabled: boolean, sms_enabled: boolean, balance?: number | null, is_active?: boolean | null, is_unsubscribed: boolean, created_at: number, updated_at: number, client_phones?: Array<{ __typename?: 'ClientPhone', id: string, phone: string, country_code?: string | null, is_primary: boolean, is_chckup_primary: boolean, is_mobile: boolean, sms_available: boolean, is_unsubscribed: boolean, is_active: boolean, name?: string | null }> | null, client_emails?: Array<{ __typename?: 'ClientEmail', id: string, email: string, is_primary: boolean }> | null, clinic?: { __typename?: 'Clinic', id: string } | null, patients?: Array<{ __typename?: 'Patient', id: string, pms?: PracticeManagementSystem | null, pms_id?: string | null, name?: string | null, breed?: string | null, avatar_url?: string | null, last_appt_time?: number | null, gender?: string | null, fixed_status?: FixedStatus | null, weight?: number | null, birthday?: number | null, is_active?: boolean | null, is_deceased?: boolean | null, pms_created_at?: number | null, created_at: number, updated_at: number, owner?: { __typename?: 'Client', id: string, first_name?: string | null, last_name?: string | null, email?: string | null, phone?: string | null, address?: { __typename?: 'Address', country?: string | null } | null } | null, clinic_species?: { __typename?: 'ClinicSpecies', id: string, pms_id: string, description: string, is_primary: boolean, species: Species, weight_key: string, created_at: number, updated_at: number } | null, clinic?: { __typename?: 'Clinic', id: string } | null, clinic_breed?: { __typename?: 'Breed', id: string, description: string } | null, patient_vaccination_records?: Array<{ __typename?: 'PatientVaccinationRecord', id: string, vaccine_name?: string | null, manufacturer?: string | null, lot_number?: string | null, administered_date?: number | null, due_date?: number | null, rabies_tag?: string | null, is_rabies_vaccine?: boolean | null, is_soc: boolean, is_active: boolean, product?: { __typename?: 'Product', id: string, display_name?: string | null, name: string } | null }> | null, last_appointment?: { __typename?: 'Appointment', clinician?: { __typename?: 'Clinician', name: string, display_name?: string | null } | null } | null }> | null, address?: { __typename?: 'Address', street_a?: string | null, street_b?: string | null, city?: string | null, state?: string | null, zip?: string | null, country?: string | null } | null, user?: { __typename?: 'User', avatar_url?: string | null } | null, loyalty_members?: Array<{ __typename?: 'LoyaltyMember', id: string, available_points: number } | null> | null, settings?: { __typename?: 'ClientSettings', clinic_chckup_notifications_enabled: boolean, clinic_chckup_sms_enabled: boolean, clinic_chckup_email_enabled: boolean, client_chckup_notifications_enabled: boolean, client_chckup_sms_enabled: boolean, client_chckup_email_enabled: boolean, is_unsubscribed_from_marketing: boolean, is_unsubscribed_from_marketing_sms: boolean, is_unsubscribed_from_marketing_email: boolean } | null, last_appointment?: { __typename?: 'Appointment', clinician?: { __typename?: 'Clinician', name: string, display_name?: string | null } | null } | null };

export type ClientPortalAppFieldsFragment = { __typename?: 'Client', has_portal_account: boolean, has_mobile_app: boolean };

export type ClientPreviewFieldsFragment = { __typename?: 'Client', id: string, first_name?: string | null, last_name?: string | null, secondary_first_name?: string | null, secondary_last_name?: string | null, phone?: string | null, email?: string | null, pms_id?: string | null, is_active?: boolean | null, is_unsubscribed: boolean, sms_enabled: boolean, email_enabled: boolean, balance?: number | null, last_appt_time?: number | null, created_at: number, updated_at: number, last_appointment?: { __typename?: 'Appointment', clinician?: { __typename?: 'Clinician', name: string, display_name?: string | null } | null } | null, address?: { __typename?: 'Address', street_a?: string | null, street_b?: string | null, city?: string | null, state?: string | null, zip?: string | null, country?: string | null } | null, clinic?: { __typename?: 'Clinic', id: string } | null, user?: { __typename?: 'User', avatar_url?: string | null } | null, patients?: Array<{ __typename?: 'Patient', id: string, name?: string | null, gender?: string | null, pms_id?: string | null, is_deceased?: boolean | null, is_active?: boolean | null, clinic_species?: { __typename?: 'ClinicSpecies', id: string, species: Species } | null, clinic_breed?: { __typename?: 'Breed', id: string, description: string } | null, last_appointment?: { __typename?: 'Appointment', clinician?: { __typename?: 'Clinician', name: string, display_name?: string | null } | null } | null }> | null, settings?: { __typename?: 'ClientSettings', clinic_chckup_notifications_enabled: boolean, clinic_chckup_sms_enabled: boolean, clinic_chckup_email_enabled: boolean, client_chckup_notifications_enabled: boolean, client_chckup_sms_enabled: boolean, client_chckup_email_enabled: boolean, is_unsubscribed_from_marketing: boolean, is_unsubscribed_from_marketing_sms: boolean, is_unsubscribed_from_marketing_email: boolean } | null };

export type ClientBasicInfoFieldsFragment = { __typename?: 'Client', id: string, first_name?: string | null, last_name?: string | null, phone?: string | null, email?: string | null, address?: { __typename?: 'Address', street_a?: string | null, street_b?: string | null, city?: string | null, state?: string | null, zip?: string | null, country?: string | null } | null };

export type ClientSettingsFieldsFragment = { __typename?: 'ClientSettings', clinic_chckup_notifications_enabled: boolean, clinic_chckup_sms_enabled: boolean, clinic_chckup_email_enabled: boolean, client_chckup_notifications_enabled: boolean, client_chckup_sms_enabled: boolean, client_chckup_email_enabled: boolean, is_unsubscribed_from_marketing: boolean, is_unsubscribed_from_marketing_sms: boolean, is_unsubscribed_from_marketing_email: boolean };

export type ClientLoyaltyMemberFieldsFragment = { __typename?: 'LoyaltyMember', id: string, available_points: number };

export type ClientPhoneFieldsFragment = { __typename?: 'ClientPhone', id: string, phone: string, country_code?: string | null, is_primary: boolean, is_chckup_primary: boolean, is_mobile: boolean, sms_available: boolean, is_unsubscribed: boolean, is_active: boolean, name?: string | null };

export type ClientEmailFieldsFragment = { __typename?: 'ClientEmail', id: string, email: string, is_primary: boolean };

export type ClientNoteFieldsFragment = { __typename?: 'ClientNote', id: string, text?: string | null, noted_at?: number | null, is_active: boolean, created_at: number, updated_at: number };

export type GetClientQueryVariables = Exact<{
  id: Scalars['ID']['input'];
}>;


export type GetClientQuery = { __typename?: 'Query', client: { __typename?: 'Client', id: string, first_name?: string | null, last_name?: string | null, secondary_first_name?: string | null, secondary_last_name?: string | null, phone?: string | null, email?: string | null, pms?: PracticeManagementSystem | null, pms_id?: string | null, last_appt_time?: number | null, last_contact_time?: number | null, email_enabled: boolean, sms_enabled: boolean, balance?: number | null, is_active?: boolean | null, is_unsubscribed: boolean, created_at: number, updated_at: number, has_portal_account: boolean, has_mobile_app: boolean, client_phones?: Array<{ __typename?: 'ClientPhone', id: string, phone: string, country_code?: string | null, is_primary: boolean, is_chckup_primary: boolean, is_mobile: boolean, sms_available: boolean, is_unsubscribed: boolean, is_active: boolean, name?: string | null }> | null, client_emails?: Array<{ __typename?: 'ClientEmail', id: string, email: string, is_primary: boolean }> | null, clinic?: { __typename?: 'Clinic', id: string } | null, patients?: Array<{ __typename?: 'Patient', id: string, pms?: PracticeManagementSystem | null, pms_id?: string | null, name?: string | null, breed?: string | null, avatar_url?: string | null, last_appt_time?: number | null, gender?: string | null, fixed_status?: FixedStatus | null, weight?: number | null, birthday?: number | null, is_active?: boolean | null, is_deceased?: boolean | null, pms_created_at?: number | null, created_at: number, updated_at: number, owner?: { __typename?: 'Client', id: string, first_name?: string | null, last_name?: string | null, email?: string | null, phone?: string | null, address?: { __typename?: 'Address', country?: string | null } | null } | null, clinic_species?: { __typename?: 'ClinicSpecies', id: string, pms_id: string, description: string, is_primary: boolean, species: Species, weight_key: string, created_at: number, updated_at: number } | null, clinic?: { __typename?: 'Clinic', id: string } | null, clinic_breed?: { __typename?: 'Breed', id: string, description: string } | null, patient_vaccination_records?: Array<{ __typename?: 'PatientVaccinationRecord', id: string, vaccine_name?: string | null, manufacturer?: string | null, lot_number?: string | null, administered_date?: number | null, due_date?: number | null, rabies_tag?: string | null, is_rabies_vaccine?: boolean | null, is_soc: boolean, is_active: boolean, product?: { __typename?: 'Product', id: string, display_name?: string | null, name: string } | null }> | null, last_appointment?: { __typename?: 'Appointment', clinician?: { __typename?: 'Clinician', name: string, display_name?: string | null } | null } | null }> | null, address?: { __typename?: 'Address', street_a?: string | null, street_b?: string | null, city?: string | null, state?: string | null, zip?: string | null, country?: string | null } | null, user?: { __typename?: 'User', avatar_url?: string | null } | null, loyalty_members?: Array<{ __typename?: 'LoyaltyMember', id: string, available_points: number } | null> | null, settings?: { __typename?: 'ClientSettings', clinic_chckup_notifications_enabled: boolean, clinic_chckup_sms_enabled: boolean, clinic_chckup_email_enabled: boolean, client_chckup_notifications_enabled: boolean, client_chckup_sms_enabled: boolean, client_chckup_email_enabled: boolean, is_unsubscribed_from_marketing: boolean, is_unsubscribed_from_marketing_sms: boolean, is_unsubscribed_from_marketing_email: boolean } | null, last_appointment?: { __typename?: 'Appointment', clinician?: { __typename?: 'Clinician', name: string, display_name?: string | null } | null } | null } };

export type GetClientNotesQueryVariables = Exact<{
  id: Scalars['ID']['input'];
}>;


export type GetClientNotesQuery = { __typename?: 'Query', client: { __typename?: 'Client', id: string, client_notes?: Array<{ __typename?: 'ClientNote', id: string, text?: string | null, noted_at?: number | null, is_active: boolean, created_at: number, updated_at: number }> | null, patients?: Array<{ __typename?: 'Patient', id: string, name?: string | null, patient_notes?: Array<{ __typename?: 'PatientNote', id: string, text?: string | null, noted_at?: number | null, is_internal: boolean, is_active: boolean, created_at: number, updated_at: number }> | null }> | null } };

export type GetClientsQueryVariables = Exact<{
  clinicId: Scalars['String']['input'];
  clientIds: Array<Scalars['ID']['input']> | Scalars['ID']['input'];
}>;


export type GetClientsQuery = { __typename?: 'Query', getClients: Array<{ __typename?: 'Client', id: string, first_name?: string | null, last_name?: string | null, secondary_first_name?: string | null, secondary_last_name?: string | null, phone?: string | null, email?: string | null, pms_id?: string | null, is_active?: boolean | null, is_unsubscribed: boolean, sms_enabled: boolean, email_enabled: boolean, balance?: number | null, last_appt_time?: number | null, created_at: number, updated_at: number, last_appointment?: { __typename?: 'Appointment', clinician?: { __typename?: 'Clinician', name: string, display_name?: string | null } | null } | null, address?: { __typename?: 'Address', street_a?: string | null, street_b?: string | null, city?: string | null, state?: string | null, zip?: string | null, country?: string | null } | null, clinic?: { __typename?: 'Clinic', id: string } | null, user?: { __typename?: 'User', avatar_url?: string | null } | null, patients?: Array<{ __typename?: 'Patient', id: string, name?: string | null, gender?: string | null, pms_id?: string | null, is_deceased?: boolean | null, is_active?: boolean | null, clinic_species?: { __typename?: 'ClinicSpecies', id: string, species: Species } | null, clinic_breed?: { __typename?: 'Breed', id: string, description: string } | null, last_appointment?: { __typename?: 'Appointment', clinician?: { __typename?: 'Clinician', name: string, display_name?: string | null } | null } | null }> | null, settings?: { __typename?: 'ClientSettings', clinic_chckup_notifications_enabled: boolean, clinic_chckup_sms_enabled: boolean, clinic_chckup_email_enabled: boolean, client_chckup_notifications_enabled: boolean, client_chckup_sms_enabled: boolean, client_chckup_email_enabled: boolean, is_unsubscribed_from_marketing: boolean, is_unsubscribed_from_marketing_sms: boolean, is_unsubscribed_from_marketing_email: boolean } | null }> };

export type CheckExistingClientsQueryVariables = Exact<{
  email?: InputMaybe<Scalars['String']['input']>;
  phone?: InputMaybe<Scalars['String']['input']>;
}>;


export type CheckExistingClientsQuery = { __typename?: 'Query', checkExistingClients: Array<{ __typename?: 'Client', id: string, first_name?: string | null, last_name?: string | null, secondary_first_name?: string | null, secondary_last_name?: string | null, phone?: string | null, email?: string | null, pms?: PracticeManagementSystem | null, pms_id?: string | null, last_appt_time?: number | null, last_contact_time?: number | null, email_enabled: boolean, sms_enabled: boolean, balance?: number | null, is_active?: boolean | null, is_unsubscribed: boolean, created_at: number, updated_at: number, client_phones?: Array<{ __typename?: 'ClientPhone', id: string, phone: string, country_code?: string | null, is_primary: boolean, is_chckup_primary: boolean, is_mobile: boolean, sms_available: boolean, is_unsubscribed: boolean, is_active: boolean, name?: string | null }> | null, client_emails?: Array<{ __typename?: 'ClientEmail', id: string, email: string, is_primary: boolean }> | null, clinic?: { __typename?: 'Clinic', id: string } | null, patients?: Array<{ __typename?: 'Patient', id: string, pms?: PracticeManagementSystem | null, pms_id?: string | null, name?: string | null, breed?: string | null, avatar_url?: string | null, last_appt_time?: number | null, gender?: string | null, fixed_status?: FixedStatus | null, weight?: number | null, birthday?: number | null, is_active?: boolean | null, is_deceased?: boolean | null, pms_created_at?: number | null, created_at: number, updated_at: number, owner?: { __typename?: 'Client', id: string, first_name?: string | null, last_name?: string | null, email?: string | null, phone?: string | null, address?: { __typename?: 'Address', country?: string | null } | null } | null, clinic_species?: { __typename?: 'ClinicSpecies', id: string, pms_id: string, description: string, is_primary: boolean, species: Species, weight_key: string, created_at: number, updated_at: number } | null, clinic?: { __typename?: 'Clinic', id: string } | null, clinic_breed?: { __typename?: 'Breed', id: string, description: string } | null, patient_vaccination_records?: Array<{ __typename?: 'PatientVaccinationRecord', id: string, vaccine_name?: string | null, manufacturer?: string | null, lot_number?: string | null, administered_date?: number | null, due_date?: number | null, rabies_tag?: string | null, is_rabies_vaccine?: boolean | null, is_soc: boolean, is_active: boolean, product?: { __typename?: 'Product', id: string, display_name?: string | null, name: string } | null }> | null, last_appointment?: { __typename?: 'Appointment', clinician?: { __typename?: 'Clinician', name: string, display_name?: string | null } | null } | null }> | null, address?: { __typename?: 'Address', street_a?: string | null, street_b?: string | null, city?: string | null, state?: string | null, zip?: string | null, country?: string | null } | null, user?: { __typename?: 'User', avatar_url?: string | null } | null, loyalty_members?: Array<{ __typename?: 'LoyaltyMember', id: string, available_points: number } | null> | null, settings?: { __typename?: 'ClientSettings', clinic_chckup_notifications_enabled: boolean, clinic_chckup_sms_enabled: boolean, clinic_chckup_email_enabled: boolean, client_chckup_notifications_enabled: boolean, client_chckup_sms_enabled: boolean, client_chckup_email_enabled: boolean, is_unsubscribed_from_marketing: boolean, is_unsubscribed_from_marketing_sms: boolean, is_unsubscribed_from_marketing_email: boolean } | null, last_appointment?: { __typename?: 'Appointment', clinician?: { __typename?: 'Clinician', name: string, display_name?: string | null } | null } | null }> };

export type CheckExistingClientQueryVariables = Exact<{
  clinicId: Scalars['ID']['input'];
  firstName: Scalars['String']['input'];
  lastName: Scalars['String']['input'];
  email?: InputMaybe<Scalars['String']['input']>;
  phone: Scalars['String']['input'];
}>;


export type CheckExistingClientQuery = { __typename?: 'Query', checkExistingClient?: Array<{ __typename?: 'Client', id: string, first_name?: string | null, last_name?: string | null, secondary_first_name?: string | null, secondary_last_name?: string | null, phone?: string | null, email?: string | null, pms?: PracticeManagementSystem | null, pms_id?: string | null, last_appt_time?: number | null, last_contact_time?: number | null, email_enabled: boolean, sms_enabled: boolean, balance?: number | null, is_active?: boolean | null, is_unsubscribed: boolean, created_at: number, updated_at: number, client_phones?: Array<{ __typename?: 'ClientPhone', id: string, phone: string, country_code?: string | null, is_primary: boolean, is_chckup_primary: boolean, is_mobile: boolean, sms_available: boolean, is_unsubscribed: boolean, is_active: boolean, name?: string | null }> | null, client_emails?: Array<{ __typename?: 'ClientEmail', id: string, email: string, is_primary: boolean }> | null, clinic?: { __typename?: 'Clinic', id: string } | null, patients?: Array<{ __typename?: 'Patient', id: string, pms?: PracticeManagementSystem | null, pms_id?: string | null, name?: string | null, breed?: string | null, avatar_url?: string | null, last_appt_time?: number | null, gender?: string | null, fixed_status?: FixedStatus | null, weight?: number | null, birthday?: number | null, is_active?: boolean | null, is_deceased?: boolean | null, pms_created_at?: number | null, created_at: number, updated_at: number, owner?: { __typename?: 'Client', id: string, first_name?: string | null, last_name?: string | null, email?: string | null, phone?: string | null, address?: { __typename?: 'Address', country?: string | null } | null } | null, clinic_species?: { __typename?: 'ClinicSpecies', id: string, pms_id: string, description: string, is_primary: boolean, species: Species, weight_key: string, created_at: number, updated_at: number } | null, clinic?: { __typename?: 'Clinic', id: string } | null, clinic_breed?: { __typename?: 'Breed', id: string, description: string } | null, patient_vaccination_records?: Array<{ __typename?: 'PatientVaccinationRecord', id: string, vaccine_name?: string | null, manufacturer?: string | null, lot_number?: string | null, administered_date?: number | null, due_date?: number | null, rabies_tag?: string | null, is_rabies_vaccine?: boolean | null, is_soc: boolean, is_active: boolean, product?: { __typename?: 'Product', id: string, display_name?: string | null, name: string } | null }> | null, last_appointment?: { __typename?: 'Appointment', clinician?: { __typename?: 'Clinician', name: string, display_name?: string | null } | null } | null }> | null, address?: { __typename?: 'Address', street_a?: string | null, street_b?: string | null, city?: string | null, state?: string | null, zip?: string | null, country?: string | null } | null, user?: { __typename?: 'User', avatar_url?: string | null } | null, loyalty_members?: Array<{ __typename?: 'LoyaltyMember', id: string, available_points: number } | null> | null, settings?: { __typename?: 'ClientSettings', clinic_chckup_notifications_enabled: boolean, clinic_chckup_sms_enabled: boolean, clinic_chckup_email_enabled: boolean, client_chckup_notifications_enabled: boolean, client_chckup_sms_enabled: boolean, client_chckup_email_enabled: boolean, is_unsubscribed_from_marketing: boolean, is_unsubscribed_from_marketing_sms: boolean, is_unsubscribed_from_marketing_email: boolean } | null, last_appointment?: { __typename?: 'Appointment', clinician?: { __typename?: 'Clinician', name: string, display_name?: string | null } | null } | null }> | null };

export type GetMaybeClientsQueryVariables = Exact<{
  clinicId: Scalars['ID']['input'];
  input: MaybeClientInput;
}>;


export type GetMaybeClientsQuery = { __typename?: 'Query', getMaybeClients: Array<{ __typename?: 'Client', id: string, first_name?: string | null, last_name?: string | null, secondary_first_name?: string | null, secondary_last_name?: string | null, phone?: string | null, email?: string | null, pms?: PracticeManagementSystem | null, pms_id?: string | null, last_appt_time?: number | null, last_contact_time?: number | null, email_enabled: boolean, sms_enabled: boolean, balance?: number | null, is_active?: boolean | null, is_unsubscribed: boolean, created_at: number, updated_at: number, client_phones?: Array<{ __typename?: 'ClientPhone', id: string, phone: string, country_code?: string | null, is_primary: boolean, is_chckup_primary: boolean, is_mobile: boolean, sms_available: boolean, is_unsubscribed: boolean, is_active: boolean, name?: string | null }> | null, client_emails?: Array<{ __typename?: 'ClientEmail', id: string, email: string, is_primary: boolean }> | null, clinic?: { __typename?: 'Clinic', id: string } | null, patients?: Array<{ __typename?: 'Patient', id: string, pms?: PracticeManagementSystem | null, pms_id?: string | null, name?: string | null, breed?: string | null, avatar_url?: string | null, last_appt_time?: number | null, gender?: string | null, fixed_status?: FixedStatus | null, weight?: number | null, birthday?: number | null, is_active?: boolean | null, is_deceased?: boolean | null, pms_created_at?: number | null, created_at: number, updated_at: number, owner?: { __typename?: 'Client', id: string, first_name?: string | null, last_name?: string | null, email?: string | null, phone?: string | null, address?: { __typename?: 'Address', country?: string | null } | null } | null, clinic_species?: { __typename?: 'ClinicSpecies', id: string, pms_id: string, description: string, is_primary: boolean, species: Species, weight_key: string, created_at: number, updated_at: number } | null, clinic?: { __typename?: 'Clinic', id: string } | null, clinic_breed?: { __typename?: 'Breed', id: string, description: string } | null, patient_vaccination_records?: Array<{ __typename?: 'PatientVaccinationRecord', id: string, vaccine_name?: string | null, manufacturer?: string | null, lot_number?: string | null, administered_date?: number | null, due_date?: number | null, rabies_tag?: string | null, is_rabies_vaccine?: boolean | null, is_soc: boolean, is_active: boolean, product?: { __typename?: 'Product', id: string, display_name?: string | null, name: string } | null }> | null, last_appointment?: { __typename?: 'Appointment', clinician?: { __typename?: 'Clinician', name: string, display_name?: string | null } | null } | null }> | null, address?: { __typename?: 'Address', street_a?: string | null, street_b?: string | null, city?: string | null, state?: string | null, zip?: string | null, country?: string | null } | null, user?: { __typename?: 'User', avatar_url?: string | null } | null, loyalty_members?: Array<{ __typename?: 'LoyaltyMember', id: string, available_points: number } | null> | null, settings?: { __typename?: 'ClientSettings', clinic_chckup_notifications_enabled: boolean, clinic_chckup_sms_enabled: boolean, clinic_chckup_email_enabled: boolean, client_chckup_notifications_enabled: boolean, client_chckup_sms_enabled: boolean, client_chckup_email_enabled: boolean, is_unsubscribed_from_marketing: boolean, is_unsubscribed_from_marketing_sms: boolean, is_unsubscribed_from_marketing_email: boolean } | null, last_appointment?: { __typename?: 'Appointment', clinician?: { __typename?: 'Clinician', name: string, display_name?: string | null } | null } | null }> };

export type GetClientsWithNegativeBalancesForClinicQueryVariables = Exact<{
  clinicId: Scalars['ID']['input'];
}>;


export type GetClientsWithNegativeBalancesForClinicQuery = { __typename?: 'Query', getClientsWithNegativeBalancesForClinic: Array<{ __typename?: 'Client', id: string, first_name?: string | null, last_name?: string | null, secondary_first_name?: string | null, secondary_last_name?: string | null, phone?: string | null, email?: string | null, pms?: PracticeManagementSystem | null, pms_id?: string | null, last_appt_time?: number | null, last_contact_time?: number | null, email_enabled: boolean, sms_enabled: boolean, balance?: number | null, is_active?: boolean | null, is_unsubscribed: boolean, created_at: number, updated_at: number, client_phones?: Array<{ __typename?: 'ClientPhone', id: string, phone: string, country_code?: string | null, is_primary: boolean, is_chckup_primary: boolean, is_mobile: boolean, sms_available: boolean, is_unsubscribed: boolean, is_active: boolean, name?: string | null }> | null, client_emails?: Array<{ __typename?: 'ClientEmail', id: string, email: string, is_primary: boolean }> | null, clinic?: { __typename?: 'Clinic', id: string } | null, patients?: Array<{ __typename?: 'Patient', id: string, pms?: PracticeManagementSystem | null, pms_id?: string | null, name?: string | null, breed?: string | null, avatar_url?: string | null, last_appt_time?: number | null, gender?: string | null, fixed_status?: FixedStatus | null, weight?: number | null, birthday?: number | null, is_active?: boolean | null, is_deceased?: boolean | null, pms_created_at?: number | null, created_at: number, updated_at: number, owner?: { __typename?: 'Client', id: string, first_name?: string | null, last_name?: string | null, email?: string | null, phone?: string | null, address?: { __typename?: 'Address', country?: string | null } | null } | null, clinic_species?: { __typename?: 'ClinicSpecies', id: string, pms_id: string, description: string, is_primary: boolean, species: Species, weight_key: string, created_at: number, updated_at: number } | null, clinic?: { __typename?: 'Clinic', id: string } | null, clinic_breed?: { __typename?: 'Breed', id: string, description: string } | null, patient_vaccination_records?: Array<{ __typename?: 'PatientVaccinationRecord', id: string, vaccine_name?: string | null, manufacturer?: string | null, lot_number?: string | null, administered_date?: number | null, due_date?: number | null, rabies_tag?: string | null, is_rabies_vaccine?: boolean | null, is_soc: boolean, is_active: boolean, product?: { __typename?: 'Product', id: string, display_name?: string | null, name: string } | null }> | null, last_appointment?: { __typename?: 'Appointment', clinician?: { __typename?: 'Clinician', name: string, display_name?: string | null } | null } | null }> | null, address?: { __typename?: 'Address', street_a?: string | null, street_b?: string | null, city?: string | null, state?: string | null, zip?: string | null, country?: string | null } | null, user?: { __typename?: 'User', avatar_url?: string | null } | null, loyalty_members?: Array<{ __typename?: 'LoyaltyMember', id: string, available_points: number } | null> | null, settings?: { __typename?: 'ClientSettings', clinic_chckup_notifications_enabled: boolean, clinic_chckup_sms_enabled: boolean, clinic_chckup_email_enabled: boolean, client_chckup_notifications_enabled: boolean, client_chckup_sms_enabled: boolean, client_chckup_email_enabled: boolean, is_unsubscribed_from_marketing: boolean, is_unsubscribed_from_marketing_sms: boolean, is_unsubscribed_from_marketing_email: boolean } | null, last_appointment?: { __typename?: 'Appointment', clinician?: { __typename?: 'Clinician', name: string, display_name?: string | null } | null } | null }> };

export type GetClientsWithoutApptOverDaysForClinicQueryVariables = Exact<{
  clinicId: Scalars['ID']['input'];
  days: Scalars['NonNegativeInt']['input'];
}>;


export type GetClientsWithoutApptOverDaysForClinicQuery = { __typename?: 'Query', getClientsWithoutApptOverDaysForClinic: Array<{ __typename?: 'Client', id: string, first_name?: string | null, last_name?: string | null, secondary_first_name?: string | null, secondary_last_name?: string | null, phone?: string | null, email?: string | null, pms?: PracticeManagementSystem | null, pms_id?: string | null, last_appt_time?: number | null, last_contact_time?: number | null, email_enabled: boolean, sms_enabled: boolean, balance?: number | null, is_active?: boolean | null, is_unsubscribed: boolean, created_at: number, updated_at: number, client_phones?: Array<{ __typename?: 'ClientPhone', id: string, phone: string, country_code?: string | null, is_primary: boolean, is_chckup_primary: boolean, is_mobile: boolean, sms_available: boolean, is_unsubscribed: boolean, is_active: boolean, name?: string | null }> | null, client_emails?: Array<{ __typename?: 'ClientEmail', id: string, email: string, is_primary: boolean }> | null, clinic?: { __typename?: 'Clinic', id: string } | null, patients?: Array<{ __typename?: 'Patient', id: string, pms?: PracticeManagementSystem | null, pms_id?: string | null, name?: string | null, breed?: string | null, avatar_url?: string | null, last_appt_time?: number | null, gender?: string | null, fixed_status?: FixedStatus | null, weight?: number | null, birthday?: number | null, is_active?: boolean | null, is_deceased?: boolean | null, pms_created_at?: number | null, created_at: number, updated_at: number, owner?: { __typename?: 'Client', id: string, first_name?: string | null, last_name?: string | null, email?: string | null, phone?: string | null, address?: { __typename?: 'Address', country?: string | null } | null } | null, clinic_species?: { __typename?: 'ClinicSpecies', id: string, pms_id: string, description: string, is_primary: boolean, species: Species, weight_key: string, created_at: number, updated_at: number } | null, clinic?: { __typename?: 'Clinic', id: string } | null, clinic_breed?: { __typename?: 'Breed', id: string, description: string } | null, patient_vaccination_records?: Array<{ __typename?: 'PatientVaccinationRecord', id: string, vaccine_name?: string | null, manufacturer?: string | null, lot_number?: string | null, administered_date?: number | null, due_date?: number | null, rabies_tag?: string | null, is_rabies_vaccine?: boolean | null, is_soc: boolean, is_active: boolean, product?: { __typename?: 'Product', id: string, display_name?: string | null, name: string } | null }> | null, last_appointment?: { __typename?: 'Appointment', clinician?: { __typename?: 'Clinician', name: string, display_name?: string | null } | null } | null }> | null, address?: { __typename?: 'Address', street_a?: string | null, street_b?: string | null, city?: string | null, state?: string | null, zip?: string | null, country?: string | null } | null, user?: { __typename?: 'User', avatar_url?: string | null } | null, loyalty_members?: Array<{ __typename?: 'LoyaltyMember', id: string, available_points: number } | null> | null, settings?: { __typename?: 'ClientSettings', clinic_chckup_notifications_enabled: boolean, clinic_chckup_sms_enabled: boolean, clinic_chckup_email_enabled: boolean, client_chckup_notifications_enabled: boolean, client_chckup_sms_enabled: boolean, client_chckup_email_enabled: boolean, is_unsubscribed_from_marketing: boolean, is_unsubscribed_from_marketing_sms: boolean, is_unsubscribed_from_marketing_email: boolean } | null, last_appointment?: { __typename?: 'Appointment', clinician?: { __typename?: 'Clinician', name: string, display_name?: string | null } | null } | null }> };

export type GetOutstandingBalanceForClinicQueryVariables = Exact<{
  clinicId: Scalars['ID']['input'];
  activeClientsOnly?: InputMaybe<Scalars['Boolean']['input']>;
}>;


export type GetOutstandingBalanceForClinicQuery = { __typename?: 'Query', getOutstandingBalanceForClinic: number };

export type GetNewClientsForClinicQueryVariables = Exact<{
  clinicId: Scalars['ID']['input'];
  fromPmsCreatedAt: Scalars['NonNegativeInt']['input'];
  toPmsCreatedAt: Scalars['NonNegativeInt']['input'];
}>;


export type GetNewClientsForClinicQuery = { __typename?: 'Query', getNewClientsForClinic: number };

export type QueryClientsQueryVariables = Exact<{
  where?: InputMaybe<Array<QueryInput> | QueryInput>;
  page?: InputMaybe<Scalars['NonNegativeInt']['input']>;
  pageSize?: InputMaybe<Scalars['NonNegativeInt']['input']>;
  orderBy?: InputMaybe<OrderByInput>;
}>;


export type QueryClientsQuery = { __typename?: 'Query', queryClients: Array<{ __typename?: 'Client', id: string, first_name?: string | null, last_name?: string | null, secondary_first_name?: string | null, secondary_last_name?: string | null, phone?: string | null, email?: string | null, pms_id?: string | null, is_active?: boolean | null, is_unsubscribed: boolean, sms_enabled: boolean, email_enabled: boolean, balance?: number | null, last_appt_time?: number | null, created_at: number, updated_at: number, last_appointment?: { __typename?: 'Appointment', clinician?: { __typename?: 'Clinician', name: string, display_name?: string | null } | null } | null, address?: { __typename?: 'Address', street_a?: string | null, street_b?: string | null, city?: string | null, state?: string | null, zip?: string | null, country?: string | null } | null, clinic?: { __typename?: 'Clinic', id: string } | null, user?: { __typename?: 'User', avatar_url?: string | null } | null, patients?: Array<{ __typename?: 'Patient', id: string, name?: string | null, gender?: string | null, pms_id?: string | null, is_deceased?: boolean | null, is_active?: boolean | null, clinic_species?: { __typename?: 'ClinicSpecies', id: string, species: Species } | null, clinic_breed?: { __typename?: 'Breed', id: string, description: string } | null, last_appointment?: { __typename?: 'Appointment', clinician?: { __typename?: 'Clinician', name: string, display_name?: string | null } | null } | null }> | null, settings?: { __typename?: 'ClientSettings', clinic_chckup_notifications_enabled: boolean, clinic_chckup_sms_enabled: boolean, clinic_chckup_email_enabled: boolean, client_chckup_notifications_enabled: boolean, client_chckup_sms_enabled: boolean, client_chckup_email_enabled: boolean, is_unsubscribed_from_marketing: boolean, is_unsubscribed_from_marketing_sms: boolean, is_unsubscribed_from_marketing_email: boolean } | null }> };

export type QueryClinicClientsQueryVariables = Exact<{
  where?: InputMaybe<Array<QueryInput> | QueryInput>;
  page?: InputMaybe<Scalars['NonNegativeInt']['input']>;
  pageSize?: InputMaybe<Scalars['NonNegativeInt']['input']>;
  orderBy?: InputMaybe<OrderByInput>;
  clinicId: Scalars['ID']['input'];
}>;


export type QueryClinicClientsQuery = { __typename?: 'Query', queryClinicClients: Array<{ __typename?: 'Client', id: string, first_name?: string | null, last_name?: string | null, secondary_first_name?: string | null, secondary_last_name?: string | null, phone?: string | null, email?: string | null, pms_id?: string | null, is_active?: boolean | null, is_unsubscribed: boolean, sms_enabled: boolean, email_enabled: boolean, balance?: number | null, last_appt_time?: number | null, created_at: number, updated_at: number, last_appointment?: { __typename?: 'Appointment', clinician?: { __typename?: 'Clinician', name: string, display_name?: string | null } | null } | null, address?: { __typename?: 'Address', street_a?: string | null, street_b?: string | null, city?: string | null, state?: string | null, zip?: string | null, country?: string | null } | null, clinic?: { __typename?: 'Clinic', id: string } | null, user?: { __typename?: 'User', avatar_url?: string | null } | null, patients?: Array<{ __typename?: 'Patient', id: string, name?: string | null, gender?: string | null, pms_id?: string | null, is_deceased?: boolean | null, is_active?: boolean | null, clinic_species?: { __typename?: 'ClinicSpecies', id: string, species: Species } | null, clinic_breed?: { __typename?: 'Breed', id: string, description: string } | null, last_appointment?: { __typename?: 'Appointment', clinician?: { __typename?: 'Clinician', name: string, display_name?: string | null } | null } | null }> | null, settings?: { __typename?: 'ClientSettings', clinic_chckup_notifications_enabled: boolean, clinic_chckup_sms_enabled: boolean, clinic_chckup_email_enabled: boolean, client_chckup_notifications_enabled: boolean, client_chckup_sms_enabled: boolean, client_chckup_email_enabled: boolean, is_unsubscribed_from_marketing: boolean, is_unsubscribed_from_marketing_sms: boolean, is_unsubscribed_from_marketing_email: boolean } | null }> };

export type QueryClientsPatientsQueryVariables = Exact<{
  where?: InputMaybe<Array<QueryInput> | QueryInput>;
  page?: InputMaybe<Scalars['NonNegativeInt']['input']>;
  pageSize?: InputMaybe<Scalars['NonNegativeInt']['input']>;
  orderBy?: InputMaybe<OrderByInput>;
  clinicId: Scalars['ID']['input'];
}>;


export type QueryClientsPatientsQuery = { __typename?: 'Query', queryClientsPatients: { __typename?: 'QueryClientsPatientsResults', count: number, results: Array<{ __typename?: 'QueryClientsPatientsResult', client?: { __typename?: 'Client', id: string, first_name?: string | null, last_name?: string | null, secondary_first_name?: string | null, secondary_last_name?: string | null, phone?: string | null, email?: string | null, pms_id?: string | null, is_active?: boolean | null, is_unsubscribed: boolean, sms_enabled: boolean, email_enabled: boolean, balance?: number | null, last_appt_time?: number | null, created_at: number, updated_at: number, has_portal_account: boolean, has_mobile_app: boolean, last_appointment?: { __typename?: 'Appointment', clinician?: { __typename?: 'Clinician', name: string, display_name?: string | null } | null } | null, address?: { __typename?: 'Address', street_a?: string | null, street_b?: string | null, city?: string | null, state?: string | null, zip?: string | null, country?: string | null } | null, clinic?: { __typename?: 'Clinic', id: string } | null, user?: { __typename?: 'User', avatar_url?: string | null } | null, patients?: Array<{ __typename?: 'Patient', id: string, name?: string | null, gender?: string | null, pms_id?: string | null, is_deceased?: boolean | null, is_active?: boolean | null, clinic_species?: { __typename?: 'ClinicSpecies', id: string, species: Species } | null, clinic_breed?: { __typename?: 'Breed', id: string, description: string } | null, last_appointment?: { __typename?: 'Appointment', clinician?: { __typename?: 'Clinician', name: string, display_name?: string | null } | null } | null }> | null, settings?: { __typename?: 'ClientSettings', clinic_chckup_notifications_enabled: boolean, clinic_chckup_sms_enabled: boolean, clinic_chckup_email_enabled: boolean, client_chckup_notifications_enabled: boolean, client_chckup_sms_enabled: boolean, client_chckup_email_enabled: boolean, is_unsubscribed_from_marketing: boolean, is_unsubscribed_from_marketing_sms: boolean, is_unsubscribed_from_marketing_email: boolean } | null } | null, patients: Array<{ __typename?: 'Patient', id: string, name?: string | null, pms_id?: string | null, is_deceased?: boolean | null, is_active?: boolean | null }> }> } };

export type CountClinicClientsQueryVariables = Exact<{
  clinicId: Scalars['ID']['input'];
  where?: InputMaybe<Array<QueryInput> | QueryInput>;
}>;


export type CountClinicClientsQuery = { __typename?: 'Query', countClinicClients: number };

export type CountClientsQueryVariables = Exact<{
  where?: InputMaybe<Array<QueryInput> | QueryInput>;
}>;


export type CountClientsQuery = { __typename?: 'Query', countClients: number };

export type CreateClientMutationVariables = Exact<{
  data: CreateClientInput;
}>;


export type CreateClientMutation = { __typename?: 'Mutation', createClient: { __typename?: 'Client', id: string, first_name?: string | null, last_name?: string | null, secondary_first_name?: string | null, secondary_last_name?: string | null, phone?: string | null, email?: string | null, pms?: PracticeManagementSystem | null, pms_id?: string | null, last_appt_time?: number | null, last_contact_time?: number | null, email_enabled: boolean, sms_enabled: boolean, balance?: number | null, is_active?: boolean | null, is_unsubscribed: boolean, created_at: number, updated_at: number, client_phones?: Array<{ __typename?: 'ClientPhone', id: string, phone: string, country_code?: string | null, is_primary: boolean, is_chckup_primary: boolean, is_mobile: boolean, sms_available: boolean, is_unsubscribed: boolean, is_active: boolean, name?: string | null }> | null, client_emails?: Array<{ __typename?: 'ClientEmail', id: string, email: string, is_primary: boolean }> | null, clinic?: { __typename?: 'Clinic', id: string } | null, patients?: Array<{ __typename?: 'Patient', id: string, pms?: PracticeManagementSystem | null, pms_id?: string | null, name?: string | null, breed?: string | null, avatar_url?: string | null, last_appt_time?: number | null, gender?: string | null, fixed_status?: FixedStatus | null, weight?: number | null, birthday?: number | null, is_active?: boolean | null, is_deceased?: boolean | null, pms_created_at?: number | null, created_at: number, updated_at: number, owner?: { __typename?: 'Client', id: string, first_name?: string | null, last_name?: string | null, email?: string | null, phone?: string | null, address?: { __typename?: 'Address', country?: string | null } | null } | null, clinic_species?: { __typename?: 'ClinicSpecies', id: string, pms_id: string, description: string, is_primary: boolean, species: Species, weight_key: string, created_at: number, updated_at: number } | null, clinic?: { __typename?: 'Clinic', id: string } | null, clinic_breed?: { __typename?: 'Breed', id: string, description: string } | null, patient_vaccination_records?: Array<{ __typename?: 'PatientVaccinationRecord', id: string, vaccine_name?: string | null, manufacturer?: string | null, lot_number?: string | null, administered_date?: number | null, due_date?: number | null, rabies_tag?: string | null, is_rabies_vaccine?: boolean | null, is_soc: boolean, is_active: boolean, product?: { __typename?: 'Product', id: string, display_name?: string | null, name: string } | null }> | null, last_appointment?: { __typename?: 'Appointment', clinician?: { __typename?: 'Clinician', name: string, display_name?: string | null } | null } | null }> | null, address?: { __typename?: 'Address', street_a?: string | null, street_b?: string | null, city?: string | null, state?: string | null, zip?: string | null, country?: string | null } | null, user?: { __typename?: 'User', avatar_url?: string | null } | null, loyalty_members?: Array<{ __typename?: 'LoyaltyMember', id: string, available_points: number } | null> | null, settings?: { __typename?: 'ClientSettings', clinic_chckup_notifications_enabled: boolean, clinic_chckup_sms_enabled: boolean, clinic_chckup_email_enabled: boolean, client_chckup_notifications_enabled: boolean, client_chckup_sms_enabled: boolean, client_chckup_email_enabled: boolean, is_unsubscribed_from_marketing: boolean, is_unsubscribed_from_marketing_sms: boolean, is_unsubscribed_from_marketing_email: boolean } | null, last_appointment?: { __typename?: 'Appointment', clinician?: { __typename?: 'Clinician', name: string, display_name?: string | null } | null } | null } };

export type UpdateClientMutationVariables = Exact<{
  id: Scalars['ID']['input'];
  data: UpdateClientInput;
}>;


export type UpdateClientMutation = { __typename?: 'Mutation', updateClient: { __typename?: 'Client', id: string, first_name?: string | null, last_name?: string | null, secondary_first_name?: string | null, secondary_last_name?: string | null, phone?: string | null, email?: string | null, pms?: PracticeManagementSystem | null, pms_id?: string | null, last_appt_time?: number | null, last_contact_time?: number | null, email_enabled: boolean, sms_enabled: boolean, balance?: number | null, is_active?: boolean | null, is_unsubscribed: boolean, created_at: number, updated_at: number, client_phones?: Array<{ __typename?: 'ClientPhone', id: string, phone: string, country_code?: string | null, is_primary: boolean, is_chckup_primary: boolean, is_mobile: boolean, sms_available: boolean, is_unsubscribed: boolean, is_active: boolean, name?: string | null }> | null, client_emails?: Array<{ __typename?: 'ClientEmail', id: string, email: string, is_primary: boolean }> | null, clinic?: { __typename?: 'Clinic', id: string } | null, patients?: Array<{ __typename?: 'Patient', id: string, pms?: PracticeManagementSystem | null, pms_id?: string | null, name?: string | null, breed?: string | null, avatar_url?: string | null, last_appt_time?: number | null, gender?: string | null, fixed_status?: FixedStatus | null, weight?: number | null, birthday?: number | null, is_active?: boolean | null, is_deceased?: boolean | null, pms_created_at?: number | null, created_at: number, updated_at: number, owner?: { __typename?: 'Client', id: string, first_name?: string | null, last_name?: string | null, email?: string | null, phone?: string | null, address?: { __typename?: 'Address', country?: string | null } | null } | null, clinic_species?: { __typename?: 'ClinicSpecies', id: string, pms_id: string, description: string, is_primary: boolean, species: Species, weight_key: string, created_at: number, updated_at: number } | null, clinic?: { __typename?: 'Clinic', id: string } | null, clinic_breed?: { __typename?: 'Breed', id: string, description: string } | null, patient_vaccination_records?: Array<{ __typename?: 'PatientVaccinationRecord', id: string, vaccine_name?: string | null, manufacturer?: string | null, lot_number?: string | null, administered_date?: number | null, due_date?: number | null, rabies_tag?: string | null, is_rabies_vaccine?: boolean | null, is_soc: boolean, is_active: boolean, product?: { __typename?: 'Product', id: string, display_name?: string | null, name: string } | null }> | null, last_appointment?: { __typename?: 'Appointment', clinician?: { __typename?: 'Clinician', name: string, display_name?: string | null } | null } | null }> | null, address?: { __typename?: 'Address', street_a?: string | null, street_b?: string | null, city?: string | null, state?: string | null, zip?: string | null, country?: string | null } | null, user?: { __typename?: 'User', avatar_url?: string | null } | null, loyalty_members?: Array<{ __typename?: 'LoyaltyMember', id: string, available_points: number } | null> | null, settings?: { __typename?: 'ClientSettings', clinic_chckup_notifications_enabled: boolean, clinic_chckup_sms_enabled: boolean, clinic_chckup_email_enabled: boolean, client_chckup_notifications_enabled: boolean, client_chckup_sms_enabled: boolean, client_chckup_email_enabled: boolean, is_unsubscribed_from_marketing: boolean, is_unsubscribed_from_marketing_sms: boolean, is_unsubscribed_from_marketing_email: boolean } | null, last_appointment?: { __typename?: 'Appointment', clinician?: { __typename?: 'Clinician', name: string, display_name?: string | null } | null } | null } };

export type DeleteClientMutationVariables = Exact<{
  id: Scalars['ID']['input'];
}>;


export type DeleteClientMutation = { __typename?: 'Mutation', deleteClient?: any | null };

export type AddClinicToClientMutationVariables = Exact<{
  clinicId: Scalars['ID']['input'];
  clientId: Scalars['ID']['input'];
}>;


export type AddClinicToClientMutation = { __typename?: 'Mutation', addClinicToClient: { __typename?: 'Client', id: string, first_name?: string | null, last_name?: string | null, secondary_first_name?: string | null, secondary_last_name?: string | null, phone?: string | null, email?: string | null, pms?: PracticeManagementSystem | null, pms_id?: string | null, last_appt_time?: number | null, last_contact_time?: number | null, email_enabled: boolean, sms_enabled: boolean, balance?: number | null, is_active?: boolean | null, is_unsubscribed: boolean, created_at: number, updated_at: number, client_phones?: Array<{ __typename?: 'ClientPhone', id: string, phone: string, country_code?: string | null, is_primary: boolean, is_chckup_primary: boolean, is_mobile: boolean, sms_available: boolean, is_unsubscribed: boolean, is_active: boolean, name?: string | null }> | null, client_emails?: Array<{ __typename?: 'ClientEmail', id: string, email: string, is_primary: boolean }> | null, clinic?: { __typename?: 'Clinic', id: string } | null, patients?: Array<{ __typename?: 'Patient', id: string, pms?: PracticeManagementSystem | null, pms_id?: string | null, name?: string | null, breed?: string | null, avatar_url?: string | null, last_appt_time?: number | null, gender?: string | null, fixed_status?: FixedStatus | null, weight?: number | null, birthday?: number | null, is_active?: boolean | null, is_deceased?: boolean | null, pms_created_at?: number | null, created_at: number, updated_at: number, owner?: { __typename?: 'Client', id: string, first_name?: string | null, last_name?: string | null, email?: string | null, phone?: string | null, address?: { __typename?: 'Address', country?: string | null } | null } | null, clinic_species?: { __typename?: 'ClinicSpecies', id: string, pms_id: string, description: string, is_primary: boolean, species: Species, weight_key: string, created_at: number, updated_at: number } | null, clinic?: { __typename?: 'Clinic', id: string } | null, clinic_breed?: { __typename?: 'Breed', id: string, description: string } | null, patient_vaccination_records?: Array<{ __typename?: 'PatientVaccinationRecord', id: string, vaccine_name?: string | null, manufacturer?: string | null, lot_number?: string | null, administered_date?: number | null, due_date?: number | null, rabies_tag?: string | null, is_rabies_vaccine?: boolean | null, is_soc: boolean, is_active: boolean, product?: { __typename?: 'Product', id: string, display_name?: string | null, name: string } | null }> | null, last_appointment?: { __typename?: 'Appointment', clinician?: { __typename?: 'Clinician', name: string, display_name?: string | null } | null } | null }> | null, address?: { __typename?: 'Address', street_a?: string | null, street_b?: string | null, city?: string | null, state?: string | null, zip?: string | null, country?: string | null } | null, user?: { __typename?: 'User', avatar_url?: string | null } | null, loyalty_members?: Array<{ __typename?: 'LoyaltyMember', id: string, available_points: number } | null> | null, settings?: { __typename?: 'ClientSettings', clinic_chckup_notifications_enabled: boolean, clinic_chckup_sms_enabled: boolean, clinic_chckup_email_enabled: boolean, client_chckup_notifications_enabled: boolean, client_chckup_sms_enabled: boolean, client_chckup_email_enabled: boolean, is_unsubscribed_from_marketing: boolean, is_unsubscribed_from_marketing_sms: boolean, is_unsubscribed_from_marketing_email: boolean } | null, last_appointment?: { __typename?: 'Appointment', clinician?: { __typename?: 'Clinician', name: string, display_name?: string | null } | null } | null } };

export type MakeClientPhonePrimaryMutationVariables = Exact<{
  clinicId: Scalars['ID']['input'];
  clientId: Scalars['ID']['input'];
  phoneId: Scalars['ID']['input'];
}>;


export type MakeClientPhonePrimaryMutation = { __typename?: 'Mutation', makeClientPhonePrimary: { __typename?: 'Client', id: string, first_name?: string | null, last_name?: string | null, secondary_first_name?: string | null, secondary_last_name?: string | null, phone?: string | null, email?: string | null, pms?: PracticeManagementSystem | null, pms_id?: string | null, last_appt_time?: number | null, last_contact_time?: number | null, email_enabled: boolean, sms_enabled: boolean, balance?: number | null, is_active?: boolean | null, is_unsubscribed: boolean, created_at: number, updated_at: number, client_phones?: Array<{ __typename?: 'ClientPhone', id: string, phone: string, country_code?: string | null, is_primary: boolean, is_chckup_primary: boolean, is_mobile: boolean, sms_available: boolean, is_unsubscribed: boolean, is_active: boolean, name?: string | null }> | null, client_emails?: Array<{ __typename?: 'ClientEmail', id: string, email: string, is_primary: boolean }> | null, clinic?: { __typename?: 'Clinic', id: string } | null, patients?: Array<{ __typename?: 'Patient', id: string, pms?: PracticeManagementSystem | null, pms_id?: string | null, name?: string | null, breed?: string | null, avatar_url?: string | null, last_appt_time?: number | null, gender?: string | null, fixed_status?: FixedStatus | null, weight?: number | null, birthday?: number | null, is_active?: boolean | null, is_deceased?: boolean | null, pms_created_at?: number | null, created_at: number, updated_at: number, owner?: { __typename?: 'Client', id: string, first_name?: string | null, last_name?: string | null, email?: string | null, phone?: string | null, address?: { __typename?: 'Address', country?: string | null } | null } | null, clinic_species?: { __typename?: 'ClinicSpecies', id: string, pms_id: string, description: string, is_primary: boolean, species: Species, weight_key: string, created_at: number, updated_at: number } | null, clinic?: { __typename?: 'Clinic', id: string } | null, clinic_breed?: { __typename?: 'Breed', id: string, description: string } | null, patient_vaccination_records?: Array<{ __typename?: 'PatientVaccinationRecord', id: string, vaccine_name?: string | null, manufacturer?: string | null, lot_number?: string | null, administered_date?: number | null, due_date?: number | null, rabies_tag?: string | null, is_rabies_vaccine?: boolean | null, is_soc: boolean, is_active: boolean, product?: { __typename?: 'Product', id: string, display_name?: string | null, name: string } | null }> | null, last_appointment?: { __typename?: 'Appointment', clinician?: { __typename?: 'Clinician', name: string, display_name?: string | null } | null } | null }> | null, address?: { __typename?: 'Address', street_a?: string | null, street_b?: string | null, city?: string | null, state?: string | null, zip?: string | null, country?: string | null } | null, user?: { __typename?: 'User', avatar_url?: string | null } | null, loyalty_members?: Array<{ __typename?: 'LoyaltyMember', id: string, available_points: number } | null> | null, settings?: { __typename?: 'ClientSettings', clinic_chckup_notifications_enabled: boolean, clinic_chckup_sms_enabled: boolean, clinic_chckup_email_enabled: boolean, client_chckup_notifications_enabled: boolean, client_chckup_sms_enabled: boolean, client_chckup_email_enabled: boolean, is_unsubscribed_from_marketing: boolean, is_unsubscribed_from_marketing_sms: boolean, is_unsubscribed_from_marketing_email: boolean } | null, last_appointment?: { __typename?: 'Appointment', clinician?: { __typename?: 'Clinician', name: string, display_name?: string | null } | null } | null } };

export type SyncIndividualClientMutationVariables = Exact<{
  clientId: Scalars['ID']['input'];
  clinicId: Scalars['ID']['input'];
}>;


export type SyncIndividualClientMutation = { __typename?: 'Mutation', syncIndividualClient: { __typename?: 'Client', id: string, first_name?: string | null, last_name?: string | null, secondary_first_name?: string | null, secondary_last_name?: string | null, phone?: string | null, email?: string | null, pms?: PracticeManagementSystem | null, pms_id?: string | null, last_appt_time?: number | null, last_contact_time?: number | null, email_enabled: boolean, sms_enabled: boolean, balance?: number | null, is_active?: boolean | null, is_unsubscribed: boolean, created_at: number, updated_at: number, client_phones?: Array<{ __typename?: 'ClientPhone', id: string, phone: string, country_code?: string | null, is_primary: boolean, is_chckup_primary: boolean, is_mobile: boolean, sms_available: boolean, is_unsubscribed: boolean, is_active: boolean, name?: string | null }> | null, client_emails?: Array<{ __typename?: 'ClientEmail', id: string, email: string, is_primary: boolean }> | null, clinic?: { __typename?: 'Clinic', id: string } | null, patients?: Array<{ __typename?: 'Patient', id: string, pms?: PracticeManagementSystem | null, pms_id?: string | null, name?: string | null, breed?: string | null, avatar_url?: string | null, last_appt_time?: number | null, gender?: string | null, fixed_status?: FixedStatus | null, weight?: number | null, birthday?: number | null, is_active?: boolean | null, is_deceased?: boolean | null, pms_created_at?: number | null, created_at: number, updated_at: number, owner?: { __typename?: 'Client', id: string, first_name?: string | null, last_name?: string | null, email?: string | null, phone?: string | null, address?: { __typename?: 'Address', country?: string | null } | null } | null, clinic_species?: { __typename?: 'ClinicSpecies', id: string, pms_id: string, description: string, is_primary: boolean, species: Species, weight_key: string, created_at: number, updated_at: number } | null, clinic?: { __typename?: 'Clinic', id: string } | null, clinic_breed?: { __typename?: 'Breed', id: string, description: string } | null, patient_vaccination_records?: Array<{ __typename?: 'PatientVaccinationRecord', id: string, vaccine_name?: string | null, manufacturer?: string | null, lot_number?: string | null, administered_date?: number | null, due_date?: number | null, rabies_tag?: string | null, is_rabies_vaccine?: boolean | null, is_soc: boolean, is_active: boolean, product?: { __typename?: 'Product', id: string, display_name?: string | null, name: string } | null }> | null, last_appointment?: { __typename?: 'Appointment', clinician?: { __typename?: 'Clinician', name: string, display_name?: string | null } | null } | null }> | null, address?: { __typename?: 'Address', street_a?: string | null, street_b?: string | null, city?: string | null, state?: string | null, zip?: string | null, country?: string | null } | null, user?: { __typename?: 'User', avatar_url?: string | null } | null, loyalty_members?: Array<{ __typename?: 'LoyaltyMember', id: string, available_points: number } | null> | null, settings?: { __typename?: 'ClientSettings', clinic_chckup_notifications_enabled: boolean, clinic_chckup_sms_enabled: boolean, clinic_chckup_email_enabled: boolean, client_chckup_notifications_enabled: boolean, client_chckup_sms_enabled: boolean, client_chckup_email_enabled: boolean, is_unsubscribed_from_marketing: boolean, is_unsubscribed_from_marketing_sms: boolean, is_unsubscribed_from_marketing_email: boolean } | null, last_appointment?: { __typename?: 'Appointment', clinician?: { __typename?: 'Clinician', name: string, display_name?: string | null } | null } | null } };

export type GetClientAiSummaryQueryVariables = Exact<{
  clientId: Scalars['ID']['input'];
  includeReviews?: InputMaybe<Scalars['Boolean']['input']>;
  includeCalls?: InputMaybe<Scalars['Boolean']['input']>;
}>;


export type GetClientAiSummaryQuery = { __typename?: 'Query', getClientAISummary: { __typename?: 'ClientAISummary', summary: string, hasData: boolean } };

export type ClinicAdminFieldsFragment = { __typename?: 'ClinicAdmin', id: string, role: AuthRoles, are_email_notifications_enabled: boolean, are_sms_notifications_enabled: boolean, are_desktop_notifications_enabled: boolean, should_hide_daily_huddle_financials: boolean, created_at: number, updated_at: number, clinic: { __typename?: 'Clinic', id: string, name?: string | null, slug?: string | null, avatar_url?: string | null, is_verified?: boolean | null, is_archived: boolean, description?: string | null, pms: PracticeManagementSystem, time_zone?: string | null, last_sync_times?: { __typename?: 'LastSyncTimes', last_full_sync?: number | null } | null, clinic_admins: Array<{ __typename?: 'ClinicAdmin', id: string }>, organization?: { __typename?: 'Organization', id: string } | null, address?: { __typename?: 'Address', street_a?: string | null, street_b?: string | null, city?: string | null, state?: string | null, zip?: string | null, country?: string | null, lat?: number | null, lng?: number | null } | null }, user: { __typename?: 'User', id: string, first_name?: string | null, last_name?: string | null, email?: any | null, phone?: string | null, phone_country?: string | null, avatar_url?: string | null, role?: AuthRoles | null, enabled_notification_sounds?: Array<UserNotificationSound> | null, notify_email_on?: Array<NotifyClinicOn> | null, notify_sound_on?: Array<NotifyClinicOn> | null, notify_desktop_on?: Array<NotifyClinicOn> | null, must_reset_password?: boolean | null, invitation_status?: UserInvitationStatus | null, invited_at?: number | null, created_at: number, updated_at: number }, custom_role?: { __typename?: 'CustomRole', id: string, name: string } | null, permissions?: Array<{ __typename?: 'ClinicAdminPermission', feature: AdminPermissionFeature, access_level: AdminPermissionAccessLevel }> | null };

export type ClinicAdminPermissionFieldsFragment = { __typename?: 'ClinicAdminPermission', feature: AdminPermissionFeature, access_level: AdminPermissionAccessLevel };

export type ClinicAdminFieldsForLoginFragment = { __typename?: 'ClinicAdmin', id: string, clinic: { __typename?: 'Clinic', id: string, slug?: string | null, name?: string | null, description?: string | null, email?: string | null, phone?: string | null, send_from_phone?: string | null, send_from_email?: string | null, reply_to_email?: string | null, website?: string | null, pms: PracticeManagementSystem, pms_connector: PmsConnector, pms_api_key?: string | null, pms_additional_key?: string | null, office_emails?: Array<string> | null, stripe_accounts_enabled?: Array<StripeAccountType> | null, stripe_account_type?: string | null, stripe_customer_id?: string | null, avatar_url?: string | null, go_live_date?: string | null, time_zone?: string | null, is_archived: boolean, location?: string | null, tmp_feature_flags?: any | null, mute_until?: number | null, created_at: number, updated_at: number, pms_db?: { __typename?: 'PmsDb', id: string, name: string, last_sync_times?: { __typename?: 'LastSyncTimes', last_full_sync?: number | null, last_sync_appointments?: number | null, last_sync_clients?: number | null, last_sync_patients?: number | null, last_sync_clinicians?: number | null, last_sync_services?: number | null, last_sync_transactions?: number | null, last_sync_invoices?: number | null, last_sync_history_items?: number | null, last_sync_diagnoses?: number | null, last_sync_prescriptions?: number | null, last_sync_products?: number | null, last_sync_rooms?: number | null, last_sync_species?: number | null, last_sync_breeds?: number | null, last_sync_reminders?: number | null, last_sync_reminder_types?: number | null, last_sync_vaccination_records?: number | null, last_sync_clinic_sexes?: number | null, last_sync_appt_statuses?: number | null, last_sync_blockoffs?: number | null, last_sync_invoice_items?: number | null } | null } | null, clinic_admins: Array<{ __typename?: 'ClinicAdmin', id: string, role: AuthRoles, are_email_notifications_enabled: boolean, are_sms_notifications_enabled: boolean, are_desktop_notifications_enabled: boolean, should_hide_daily_huddle_financials: boolean, created_at: number, updated_at: number, clinic: { __typename?: 'Clinic', id: string, name?: string | null, slug?: string | null, avatar_url?: string | null, is_verified?: boolean | null, is_archived: boolean, description?: string | null, pms: PracticeManagementSystem, time_zone?: string | null, last_sync_times?: { __typename?: 'LastSyncTimes', last_full_sync?: number | null } | null, clinic_admins: Array<{ __typename?: 'ClinicAdmin', id: string }>, organization?: { __typename?: 'Organization', id: string } | null, address?: { __typename?: 'Address', street_a?: string | null, street_b?: string | null, city?: string | null, state?: string | null, zip?: string | null, country?: string | null, lat?: number | null, lng?: number | null } | null }, user: { __typename?: 'User', id: string, first_name?: string | null, last_name?: string | null, email?: any | null, phone?: string | null, phone_country?: string | null, avatar_url?: string | null, role?: AuthRoles | null, enabled_notification_sounds?: Array<UserNotificationSound> | null, notify_email_on?: Array<NotifyClinicOn> | null, notify_sound_on?: Array<NotifyClinicOn> | null, notify_desktop_on?: Array<NotifyClinicOn> | null, must_reset_password?: boolean | null, invitation_status?: UserInvitationStatus | null, invited_at?: number | null, created_at: number, updated_at: number }, custom_role?: { __typename?: 'CustomRole', id: string, name: string } | null, permissions?: Array<{ __typename?: 'ClinicAdminPermission', feature: AdminPermissionFeature, access_level: AdminPermissionAccessLevel }> | null }>, address?: { __typename?: 'Address', street_a?: string | null, street_b?: string | null, city?: string | null, state?: string | null, zip?: string | null, country?: string | null } | null, services: Array<{ __typename?: 'Service', id: string, name?: string | null }>, settings?: { __typename?: 'ClinicSettings', id?: string | null, does_require_verification?: boolean | null, does_use_automatic_reschedule?: boolean | null, reset_status_to_booked_on_reschedule?: boolean | null, is_using_detailed_services?: boolean | null, hide_review_step?: boolean | null, is_using_rooms?: boolean | null, pms_start_time?: any | null, pms_end_time?: any | null, primary_color?: string | null, accent_color?: string | null, secondary_color?: string | null, new_appt_requested_msg?: string | null, new_appt_approved_msg?: string | null, new_appt_approved_sms_msg?: string | null, new_appt_denied_msg?: string | null, schedule_method?: ScheduleMethod | null, scheduling_buffer_minutes?: number | null, base_schedule_duration?: number | null, does_require_referral?: boolean | null, appointment_entry_method?: AppointmentEntryMethod | null, scheduling_min_minutes_away?: number | null, scheduling_max_minutes_away?: number | null, included_species?: Array<Species> | null, max_patients_per_visit?: number | null, should_complete_sync?: boolean | null, server_syncing_only?: boolean | null, confirmation_days_before?: number | null, send_confirmations_to: SendConfirmationsTo, send_new_appt_email?: boolean | null, send_reviews_to?: SendConfirmationsTo | null, max_review_rating_for_notif?: number | null, google_review_link?: string | null, facebook_review_link?: string | null, non_blocking_services: Array<string>, yesterday_revenue?: number | null, this_month_revenue?: number | null, hide_clinician_preference: boolean, does_use_rooms_to_schedule?: boolean | null, primary_room_pms_id?: string | null, should_default_pims_emails_on: boolean, should_default_pims_sms_on: boolean, should_default_marketing_sms_on: boolean, should_default_marketing_email_on: boolean, does_use_clinicians_to_schedule?: boolean | null, time_slot_minutes: number, sync_interval_minutes: number, long_sync_interval_hours: number, primary_clinician_pms_id?: string | null, cancellation_clinician_pms_id?: string | null, cancellation_service_pms_id?: string | null, allow_first_appt_per_day?: boolean | null, custom_well_description?: string | null, custom_sick_description?: string | null, custom_other_title?: string | null, custom_other_description?: string | null, default_trigger_words?: Array<string> | null, should_use_private_reviews?: boolean | null, notify_clinic_on?: Array<NotifyClinicOn> | null, reminder_send_time_minutes?: number | null, does_require_new_client_address?: boolean | null, does_require_new_client_birthday?: boolean | null, should_allow_new_clients?: boolean | null, should_allow_new_patients?: boolean | null, should_create_clients?: boolean | null, should_create_patients?: boolean | null, msgs_auto_priority?: boolean | null, booking_match_procedure?: BookingMatchProcedure | null, urgency_type?: UrgencyType | null, max_booking_columns?: number | null, hide_closed_days_from_scheduling?: boolean | null, should_sync_reminders?: boolean | null, auto_reply_enabled: boolean, auto_reply_message?: string | null, unreplied_message_alert_enabled: boolean, unreplied_message_alert_minutes: number, comms_writeback_enabled: boolean, comms_should_daily_writeback: boolean, comms_use_pdf_for_writeback: boolean, comms_writeback_buffer_minutes: number, comms_writeback_before_appt_mins: number, comms_should_writeback_on_send: boolean, comms_should_writeback_on_receive: boolean, comms_should_writeback_notifs: boolean, comms_should_use_ai_writeback: boolean, form_writeback_enabled: boolean, should_award_loyalty_for_invoices?: boolean | null, invoice_loyalty_points_per_dollar?: number | null, app_download_loyalty_points?: number | null, referrer_loyalty_points?: number | null, referred_loyalty_points?: number | null, custom_appointment_notes_template?: string | null, custom_new_client_notes_template?: string | null, custom_new_patient_notes_template?: string | null, max_inactivity_duration?: number | null, hide_portal_vaccinations: boolean, hide_portal_reminders: boolean, hide_portal_prescriptions: boolean, hide_portal_weight: boolean, hide_soc_vaccinations?: boolean | null, hide_historic_vaccinations?: boolean | null, should_hide_daily_huddle_financials: boolean, patient_details_tab_order: Array<PortalPatientDetailsTab>, clinic_hours_display?: string | null, reschedule_buffer_minutes?: number | null, cancellation_buffer_minutes?: number | null, require_reason_for_cancellation?: boolean | null, should_automatically_assign_patient?: boolean | null, payment_writeback_enabled: boolean, auto_refund_on_cancel: boolean, status_set_on_payment_completed_pms_id?: string | null, max_booking_notes_length?: number | null, min_booking_notes_length?: number | null, primary_clinic_group_id?: string | null, should_suggest_nearby_clinics?: boolean | null, sms_block_list?: Array<string> | null, exclude_message_wrapper?: boolean | null, should_charge_client_stripe_fees?: boolean | null, chckvet_prescription_fee_split_percentage?: number | null, gtm_container_id?: string | null, review_google_id?: string | null, review_facebook_id?: string | null, only_use_adj_avail_guides: boolean, use_basic_timeslots: boolean, valid_booking_interval_minutes?: Array<number> | null, should_disable_online_scheduling?: boolean | null, simple_scheduling_rules_enabled: boolean, compliance_statuses?: Array<string> | null, should_use_instant_prescription_requests?: boolean | null, prescription_pickup_service_id?: string | null, default_reminder_service_id?: string | null, ai_calls_provider?: PhoneProviderType | null, ai_calls_phone_number?: string | null, ai_calls_voice_id?: string | null, ai_calls_agent_id?: string | null, ai_agent_style?: string | null, ai_agent_custom_instructions?: string | null, ai_calls_ambient_sound?: AiCallsAmbientSound | null, ai_calls_voice_speed?: number | null, ai_calls_interruption_sensitivity?: number | null, ai_calls_enable_dynamic_voice_speed?: boolean | null, usage_spending_caps?: any | null, custom_merge_tags?: any | null, custom_booking_copy?: { __typename?: 'ClinicBookingCopy', WIDGET_HEADER_TITLE?: string | null, SHOW_CLINIC_HEADER_LOGO?: boolean | null, CLINIC_HEADER_LOGO_HEIGHT?: number | null, SERVICE_TYPE_SECTION_HEADING?: string | null, DEFAULT_WELLNESS_DESCRIPTION?: string | null, DEFAULT_SICK_DESCRIPTION?: string | null, DEFAULT_OTHER_DESCRIPTION?: string | null, RETURNING_PATIENT_QUESTION?: string | null, POSITIVE_RETURNING_PATIENT_ANSWER?: string | null, NEGATIVE_RETURNING_PATIENT_ANSWER?: string | null, RETURNING_CLIENT_QUESTION?: string | null, POSITIVE_RETURNING_CLIENT_ANSWER?: string | null, NEGATIVE_RETURNING_CLIENT_ANSWER?: string | null, CLIENT_INFORMATION_SECTION_TITLE?: string | null, PATIENT_INFORMATION_SECTION_TITLE?: string | null, RETURNING_CLIENT_PATIENT_TITLE?: string | null, RETURNING_CLIENT_PATIENT_DESCRIPTION?: string | null, SERVICE_SECTION_TITLE?: string | null, PREPAID_SERVICES_LABEL?: string | null, STANDARD_SERVICES_LABEL?: string | null, DEPOSIT_FEE_NAME?: string | null, PREVIOUS_OR_REFERRING_CLINIC_QUESTION?: string | null, CONTACT_THE_CLINIC_TEXT?: string | null, CONTACT_THE_CLINIC_TEXT_COLOR?: string | null, CONTACT_THE_CLINIC_TEXT_SIZE?: string | null, SELECT_CLINICIAN_TITLE?: string | null, SELECT_CLINICIAN_POSITIVE_ANSWER?: string | null, SELECT_CLINICIAN_NEGATIVE_ANSWER?: string | null, SELECT_TIME_TITLE?: string | null, REVIEW_TITLE?: string | null, REVIEW_NOTES_PROMPT?: string | null, PAYMENT_INFORMATION_TITLE?: string | null, TRIGGER_WORDS_DETECTED_HEADER?: string | null, TRIGGER_WORDS_DETECTED_DESCRIPTION?: string | null, CONFIRMATION_SCREEN_TITLE?: string | null, CONFIRMATION_SCREEN_DESCRIPTION?: string | null, NEW_CLIENT_BLOCKED_MESSAGE?: string | null, NEW_PATIENT_BLOCKED_MESSAGE?: string | null } | null, auto_reply_hours?: { __typename?: 'AvailabilityHours', monday?: Array<{ __typename?: 'TimeInterval', start?: number | null, end?: number | null }> | null, tuesday?: Array<{ __typename?: 'TimeInterval', start?: number | null, end?: number | null }> | null, wednesday?: Array<{ __typename?: 'TimeInterval', start?: number | null, end?: number | null }> | null, thursday?: Array<{ __typename?: 'TimeInterval', start?: number | null, end?: number | null }> | null, friday?: Array<{ __typename?: 'TimeInterval', start?: number | null, end?: number | null }> | null, saturday?: Array<{ __typename?: 'TimeInterval', start?: number | null, end?: number | null }> | null, sunday?: Array<{ __typename?: 'TimeInterval', start?: number | null, end?: number | null }> | null } | null, portal_links?: Array<{ __typename?: 'PortalLink', label: string, url: string }> | null, custom_reviews_copy?: { __typename?: 'ClinicReviewsCopy', REVIEW_METHOD_PAGE_TITLE?: string | null, REVIEW_METHOD_PAGE_DESCRIPTION?: string | null, PRIVATE_REVIEW_BUTTON_HELP_TEXT?: string | null, PRIVATE_REVIEW_BUTTON_TEXT?: string | null, REVIEW_PAGE_TITLE?: string | null, REVIEW_PAGE_SUBTITLE?: string | null, REVIEW_SCORE_LABEL?: string | null, REVIEW_MESSAGE_LABEL?: string | null, REVIEW_SUBMIT_BUTTON_TEXT?: string | null } | null, waitlist_customer_segment?: { __typename?: 'CustomerSegment', id: string, name: string, trigger_entity?: CustomerSegmentTrigger | null, is_archived: boolean, updated_at: number, notification_templates?: Array<{ __typename?: 'NotificationTemplate', id: string, name: string, is_active: boolean, is_archived: boolean, message_methods: Array<MessageMethod> }> | null, error_flags?: Array<{ __typename?: 'CustomerSegmentErrorFlag', filter_column: string, filter_index: number, parameter_index: number, message: string }> | null, all_inclusions?: Array<{ __typename?: 'SegmentFilter', foreign_table?: string | null, group?: string | null, parameters: Array<{ __typename?: 'QueryFilter', column: string, filterOp: FilterOp, value: { __typename?: 'QueryFilterValue', string?: string | null, float?: number | null, boolean?: boolean | null, stringArray?: Array<string> | null, floatArray?: Array<number> | null, millisFromNow?: number | null, relativeTime?: { __typename?: 'RelativeTime', quantity: number, unit: TimeUnit, direction: ReferenceDirection } | null } }> }> | null, any_inclusions?: Array<{ __typename?: 'SegmentFilter', foreign_table?: string | null, group?: string | null, parameters: Array<{ __typename?: 'QueryFilter', column: string, filterOp: FilterOp, value: { __typename?: 'QueryFilterValue', string?: string | null, float?: number | null, boolean?: boolean | null, stringArray?: Array<string> | null, floatArray?: Array<number> | null, millisFromNow?: number | null, relativeTime?: { __typename?: 'RelativeTime', quantity: number, unit: TimeUnit, direction: ReferenceDirection } | null } }> }> | null, any_exclusions?: Array<{ __typename?: 'SegmentFilter', foreign_table?: string | null, group?: string | null, parameters: Array<{ __typename?: 'QueryFilter', column: string, filterOp: FilterOp, value: { __typename?: 'QueryFilterValue', string?: string | null, float?: number | null, boolean?: boolean | null, stringArray?: Array<string> | null, floatArray?: Array<number> | null, millisFromNow?: number | null, relativeTime?: { __typename?: 'RelativeTime', quantity: number, unit: TimeUnit, direction: ReferenceDirection } | null } }> }> | null, any_other_exclusions?: Array<{ __typename?: 'SegmentFilter', foreign_table?: string | null, group?: string | null, parameters: Array<{ __typename?: 'QueryFilter', column: string, filterOp: FilterOp, value: { __typename?: 'QueryFilterValue', string?: string | null, float?: number | null, boolean?: boolean | null, stringArray?: Array<string> | null, floatArray?: Array<number> | null, millisFromNow?: number | null, relativeTime?: { __typename?: 'RelativeTime', quantity: number, unit: TimeUnit, direction: ReferenceDirection } | null } }> }> | null, filters?: Array<{ __typename?: 'CustomerSegmentFilter', filters: Array<{ __typename?: 'QueryFilter', column: string, filterOp: FilterOp, value: { __typename?: 'QueryFilterValue', string?: string | null, float?: number | null, boolean?: boolean | null, stringArray?: Array<string> | null, floatArray?: Array<number> | null, millisFromNow?: number | null, relativeTime?: { __typename?: 'RelativeTime', quantity: number, unit: TimeUnit, direction: ReferenceDirection } | null } }> }> | null, excluded_filters: Array<{ __typename?: 'CustomerSegmentFilter', filters: Array<{ __typename?: 'QueryFilter', column: string, filterOp: FilterOp, value: { __typename?: 'QueryFilterValue', string?: string | null, float?: number | null, boolean?: boolean | null, stringArray?: Array<string> | null, floatArray?: Array<number> | null, millisFromNow?: number | null, relativeTime?: { __typename?: 'RelativeTime', quantity: number, unit: TimeUnit, direction: ReferenceDirection } | null } }> }> } | null, blocklist_customer_segment?: { __typename?: 'CustomerSegment', id: string, name: string, trigger_entity?: CustomerSegmentTrigger | null, is_archived: boolean, updated_at: number, notification_templates?: Array<{ __typename?: 'NotificationTemplate', id: string, name: string, is_active: boolean, is_archived: boolean, message_methods: Array<MessageMethod> }> | null, error_flags?: Array<{ __typename?: 'CustomerSegmentErrorFlag', filter_column: string, filter_index: number, parameter_index: number, message: string }> | null, all_inclusions?: Array<{ __typename?: 'SegmentFilter', foreign_table?: string | null, group?: string | null, parameters: Array<{ __typename?: 'QueryFilter', column: string, filterOp: FilterOp, value: { __typename?: 'QueryFilterValue', string?: string | null, float?: number | null, boolean?: boolean | null, stringArray?: Array<string> | null, floatArray?: Array<number> | null, millisFromNow?: number | null, relativeTime?: { __typename?: 'RelativeTime', quantity: number, unit: TimeUnit, direction: ReferenceDirection } | null } }> }> | null, any_inclusions?: Array<{ __typename?: 'SegmentFilter', foreign_table?: string | null, group?: string | null, parameters: Array<{ __typename?: 'QueryFilter', column: string, filterOp: FilterOp, value: { __typename?: 'QueryFilterValue', string?: string | null, float?: number | null, boolean?: boolean | null, stringArray?: Array<string> | null, floatArray?: Array<number> | null, millisFromNow?: number | null, relativeTime?: { __typename?: 'RelativeTime', quantity: number, unit: TimeUnit, direction: ReferenceDirection } | null } }> }> | null, any_exclusions?: Array<{ __typename?: 'SegmentFilter', foreign_table?: string | null, group?: string | null, parameters: Array<{ __typename?: 'QueryFilter', column: string, filterOp: FilterOp, value: { __typename?: 'QueryFilterValue', string?: string | null, float?: number | null, boolean?: boolean | null, stringArray?: Array<string> | null, floatArray?: Array<number> | null, millisFromNow?: number | null, relativeTime?: { __typename?: 'RelativeTime', quantity: number, unit: TimeUnit, direction: ReferenceDirection } | null } }> }> | null, any_other_exclusions?: Array<{ __typename?: 'SegmentFilter', foreign_table?: string | null, group?: string | null, parameters: Array<{ __typename?: 'QueryFilter', column: string, filterOp: FilterOp, value: { __typename?: 'QueryFilterValue', string?: string | null, float?: number | null, boolean?: boolean | null, stringArray?: Array<string> | null, floatArray?: Array<number> | null, millisFromNow?: number | null, relativeTime?: { __typename?: 'RelativeTime', quantity: number, unit: TimeUnit, direction: ReferenceDirection } | null } }> }> | null, filters?: Array<{ __typename?: 'CustomerSegmentFilter', filters: Array<{ __typename?: 'QueryFilter', column: string, filterOp: FilterOp, value: { __typename?: 'QueryFilterValue', string?: string | null, float?: number | null, boolean?: boolean | null, stringArray?: Array<string> | null, floatArray?: Array<number> | null, millisFromNow?: number | null, relativeTime?: { __typename?: 'RelativeTime', quantity: number, unit: TimeUnit, direction: ReferenceDirection } | null } }> }> | null, excluded_filters: Array<{ __typename?: 'CustomerSegmentFilter', filters: Array<{ __typename?: 'QueryFilter', column: string, filterOp: FilterOp, value: { __typename?: 'QueryFilterValue', string?: string | null, float?: number | null, boolean?: boolean | null, stringArray?: Array<string> | null, floatArray?: Array<number> | null, millisFromNow?: number | null, relativeTime?: { __typename?: 'RelativeTime', quantity: number, unit: TimeUnit, direction: ReferenceDirection } | null } }> }> } | null, referral_customer_segment?: { __typename?: 'CustomerSegment', id: string, name: string, trigger_entity?: CustomerSegmentTrigger | null, is_archived: boolean, updated_at: number, notification_templates?: Array<{ __typename?: 'NotificationTemplate', id: string, name: string, is_active: boolean, is_archived: boolean, message_methods: Array<MessageMethod> }> | null, error_flags?: Array<{ __typename?: 'CustomerSegmentErrorFlag', filter_column: string, filter_index: number, parameter_index: number, message: string }> | null, all_inclusions?: Array<{ __typename?: 'SegmentFilter', foreign_table?: string | null, group?: string | null, parameters: Array<{ __typename?: 'QueryFilter', column: string, filterOp: FilterOp, value: { __typename?: 'QueryFilterValue', string?: string | null, float?: number | null, boolean?: boolean | null, stringArray?: Array<string> | null, floatArray?: Array<number> | null, millisFromNow?: number | null, relativeTime?: { __typename?: 'RelativeTime', quantity: number, unit: TimeUnit, direction: ReferenceDirection } | null } }> }> | null, any_inclusions?: Array<{ __typename?: 'SegmentFilter', foreign_table?: string | null, group?: string | null, parameters: Array<{ __typename?: 'QueryFilter', column: string, filterOp: FilterOp, value: { __typename?: 'QueryFilterValue', string?: string | null, float?: number | null, boolean?: boolean | null, stringArray?: Array<string> | null, floatArray?: Array<number> | null, millisFromNow?: number | null, relativeTime?: { __typename?: 'RelativeTime', quantity: number, unit: TimeUnit, direction: ReferenceDirection } | null } }> }> | null, any_exclusions?: Array<{ __typename?: 'SegmentFilter', foreign_table?: string | null, group?: string | null, parameters: Array<{ __typename?: 'QueryFilter', column: string, filterOp: FilterOp, value: { __typename?: 'QueryFilterValue', string?: string | null, float?: number | null, boolean?: boolean | null, stringArray?: Array<string> | null, floatArray?: Array<number> | null, millisFromNow?: number | null, relativeTime?: { __typename?: 'RelativeTime', quantity: number, unit: TimeUnit, direction: ReferenceDirection } | null } }> }> | null, any_other_exclusions?: Array<{ __typename?: 'SegmentFilter', foreign_table?: string | null, group?: string | null, parameters: Array<{ __typename?: 'QueryFilter', column: string, filterOp: FilterOp, value: { __typename?: 'QueryFilterValue', string?: string | null, float?: number | null, boolean?: boolean | null, stringArray?: Array<string> | null, floatArray?: Array<number> | null, millisFromNow?: number | null, relativeTime?: { __typename?: 'RelativeTime', quantity: number, unit: TimeUnit, direction: ReferenceDirection } | null } }> }> | null, filters?: Array<{ __typename?: 'CustomerSegmentFilter', filters: Array<{ __typename?: 'QueryFilter', column: string, filterOp: FilterOp, value: { __typename?: 'QueryFilterValue', string?: string | null, float?: number | null, boolean?: boolean | null, stringArray?: Array<string> | null, floatArray?: Array<number> | null, millisFromNow?: number | null, relativeTime?: { __typename?: 'RelativeTime', quantity: number, unit: TimeUnit, direction: ReferenceDirection } | null } }> }> | null, excluded_filters: Array<{ __typename?: 'CustomerSegmentFilter', filters: Array<{ __typename?: 'QueryFilter', column: string, filterOp: FilterOp, value: { __typename?: 'QueryFilterValue', string?: string | null, float?: number | null, boolean?: boolean | null, stringArray?: Array<string> | null, floatArray?: Array<number> | null, millisFromNow?: number | null, relativeTime?: { __typename?: 'RelativeTime', quantity: number, unit: TimeUnit, direction: ReferenceDirection } | null } }> }> } | null, webhooks?: Array<{ __typename?: 'WebhookConfig', id: string, name: string, url: string, events: Array<WebhookEventType>, secret?: string | null, enabled: boolean }> | null, times_first_filter_config?: { __typename?: 'TimesFirstFilterConfig', service?: BookingFilterDisplayMode | null, clinician?: BookingFilterDisplayMode | null, species?: BookingFilterDisplayMode | null, client_status?: BookingFilterDisplayMode | null, patient_status?: BookingFilterDisplayMode | null, patient_gender?: BookingFilterDisplayMode | null, fixed_status?: BookingFilterDisplayMode | null } | null } | null, onboarding?: { __typename?: 'ClinicOnboarding', has_set_hours?: boolean | null, has_synced_pms?: boolean | null } | null, organization?: { __typename?: 'Organization', id: string } | null, features?: { __typename?: 'ClinicFeatures', scheduling_enabled?: boolean | null, huddle_enabled?: boolean | null, payments_enabled?: boolean | null, messaging_enabled?: boolean | null, reviews_enabled?: boolean | null, loyalty_enabled?: boolean | null, notifs_enabled?: boolean | null, forms_enabled?: boolean | null, help_enabled?: boolean | null, bulk_messaging_enabled?: boolean | null, portal_enabled?: boolean | null, calls_enabled?: boolean | null, teamchat_enabled?: boolean | null, prescriptions_enabled?: boolean | null, medical_history_enabled?: boolean | null, pet_selfies_enabled?: boolean | null } | null, hours?: { __typename?: 'AvailabilityHours', monday?: Array<{ __typename?: 'TimeInterval', start?: number | null, end?: number | null }> | null, tuesday?: Array<{ __typename?: 'TimeInterval', start?: number | null, end?: number | null }> | null, wednesday?: Array<{ __typename?: 'TimeInterval', start?: number | null, end?: number | null }> | null, thursday?: Array<{ __typename?: 'TimeInterval', start?: number | null, end?: number | null }> | null, friday?: Array<{ __typename?: 'TimeInterval', start?: number | null, end?: number | null }> | null, saturday?: Array<{ __typename?: 'TimeInterval', start?: number | null, end?: number | null }> | null, sunday?: Array<{ __typename?: 'TimeInterval', start?: number | null, end?: number | null }> | null } | null, clinic_hours?: { __typename?: 'AvailabilityHours', monday?: Array<{ __typename?: 'TimeInterval', start?: number | null, end?: number | null }> | null, tuesday?: Array<{ __typename?: 'TimeInterval', start?: number | null, end?: number | null }> | null, wednesday?: Array<{ __typename?: 'TimeInterval', start?: number | null, end?: number | null }> | null, thursday?: Array<{ __typename?: 'TimeInterval', start?: number | null, end?: number | null }> | null, friday?: Array<{ __typename?: 'TimeInterval', start?: number | null, end?: number | null }> | null, saturday?: Array<{ __typename?: 'TimeInterval', start?: number | null, end?: number | null }> | null, sunday?: Array<{ __typename?: 'TimeInterval', start?: number | null, end?: number | null }> | null } | null, adjusted_availability?: Array<{ __typename?: 'Availability', date: number, pms_appt_type_pms_id?: string | null, times: Array<{ __typename?: 'TimeInterval', start?: number | null, end?: number | null }>, repeat?: { __typename?: 'RepeatAvailability', daysOfMonth?: Array<number> | null, daysOfWeek?: Array<DayOfWeek> | null, weekOfMonth?: WeekOfMonth | null, frequency: any, unit: RepeatUnit, end_date?: number | null } | null }> | null, pms_adjusted_availability?: Array<{ __typename?: 'Availability', date: number, pms_appt_type_pms_id?: string | null, times: Array<{ __typename?: 'TimeInterval', start?: number | null, end?: number | null }>, repeat?: { __typename?: 'RepeatAvailability', daysOfMonth?: Array<number> | null, daysOfWeek?: Array<DayOfWeek> | null, weekOfMonth?: WeekOfMonth | null, frequency: any, unit: RepeatUnit, end_date?: number | null } | null }> | null, last_sync_times?: { __typename?: 'LastSyncTimes', last_full_sync?: number | null, last_sync_appointments?: number | null, last_sync_clients?: number | null, last_sync_patients?: number | null, last_sync_clinicians?: number | null, last_sync_services?: number | null, last_sync_transactions?: number | null, last_sync_invoices?: number | null, last_sync_history_items?: number | null, last_sync_diagnoses?: number | null, last_sync_prescriptions?: number | null, last_sync_products?: number | null, last_sync_rooms?: number | null, last_sync_species?: number | null, last_sync_breeds?: number | null, last_sync_reminders?: number | null, last_sync_reminder_types?: number | null, last_sync_vaccination_records?: number | null, last_sync_clinic_sexes?: number | null, last_sync_appt_statuses?: number | null, last_sync_blockoffs?: number | null, last_sync_invoice_items?: number | null } | null, pims_settings?: { __typename?: 'PimsSettings', ezyvet_integration_mode?: EzyvetIntegrationMode | null, entered_by_pms_id?: string | null } | null } };

export type GetClinicAdminByIdQueryVariables = Exact<{
  id: Scalars['ID']['input'];
}>;


export type GetClinicAdminByIdQuery = { __typename?: 'Query', clinicAdmin?: { __typename?: 'ClinicAdmin', id: string, role: AuthRoles, are_email_notifications_enabled: boolean, are_sms_notifications_enabled: boolean, are_desktop_notifications_enabled: boolean, should_hide_daily_huddle_financials: boolean, created_at: number, updated_at: number, clinic: { __typename?: 'Clinic', id: string, name?: string | null, slug?: string | null, avatar_url?: string | null, is_verified?: boolean | null, is_archived: boolean, description?: string | null, pms: PracticeManagementSystem, time_zone?: string | null, last_sync_times?: { __typename?: 'LastSyncTimes', last_full_sync?: number | null } | null, clinic_admins: Array<{ __typename?: 'ClinicAdmin', id: string }>, organization?: { __typename?: 'Organization', id: string } | null, address?: { __typename?: 'Address', street_a?: string | null, street_b?: string | null, city?: string | null, state?: string | null, zip?: string | null, country?: string | null, lat?: number | null, lng?: number | null } | null }, user: { __typename?: 'User', id: string, first_name?: string | null, last_name?: string | null, email?: any | null, phone?: string | null, phone_country?: string | null, avatar_url?: string | null, role?: AuthRoles | null, enabled_notification_sounds?: Array<UserNotificationSound> | null, notify_email_on?: Array<NotifyClinicOn> | null, notify_sound_on?: Array<NotifyClinicOn> | null, notify_desktop_on?: Array<NotifyClinicOn> | null, must_reset_password?: boolean | null, invitation_status?: UserInvitationStatus | null, invited_at?: number | null, created_at: number, updated_at: number }, custom_role?: { __typename?: 'CustomRole', id: string, name: string } | null, permissions?: Array<{ __typename?: 'ClinicAdminPermission', feature: AdminPermissionFeature, access_level: AdminPermissionAccessLevel }> | null } | null };

export type GetClinicAdminQueryVariables = Exact<{
  clinicId: Scalars['ID']['input'];
  userId: Scalars['ID']['input'];
}>;


export type GetClinicAdminQuery = { __typename?: 'Query', getClinicAdmin?: { __typename?: 'ClinicAdmin', id: string, role: AuthRoles, are_email_notifications_enabled: boolean, are_sms_notifications_enabled: boolean, are_desktop_notifications_enabled: boolean, should_hide_daily_huddle_financials: boolean, created_at: number, updated_at: number, clinic: { __typename?: 'Clinic', id: string, name?: string | null, slug?: string | null, avatar_url?: string | null, is_verified?: boolean | null, is_archived: boolean, description?: string | null, pms: PracticeManagementSystem, time_zone?: string | null, last_sync_times?: { __typename?: 'LastSyncTimes', last_full_sync?: number | null } | null, clinic_admins: Array<{ __typename?: 'ClinicAdmin', id: string }>, organization?: { __typename?: 'Organization', id: string } | null, address?: { __typename?: 'Address', street_a?: string | null, street_b?: string | null, city?: string | null, state?: string | null, zip?: string | null, country?: string | null, lat?: number | null, lng?: number | null } | null }, user: { __typename?: 'User', id: string, first_name?: string | null, last_name?: string | null, email?: any | null, phone?: string | null, phone_country?: string | null, avatar_url?: string | null, role?: AuthRoles | null, enabled_notification_sounds?: Array<UserNotificationSound> | null, notify_email_on?: Array<NotifyClinicOn> | null, notify_sound_on?: Array<NotifyClinicOn> | null, notify_desktop_on?: Array<NotifyClinicOn> | null, must_reset_password?: boolean | null, invitation_status?: UserInvitationStatus | null, invited_at?: number | null, created_at: number, updated_at: number }, custom_role?: { __typename?: 'CustomRole', id: string, name: string } | null, permissions?: Array<{ __typename?: 'ClinicAdminPermission', feature: AdminPermissionFeature, access_level: AdminPermissionAccessLevel }> | null } | null };

export type GetClinicAdminsByClinicQueryVariables = Exact<{
  clinicId: Scalars['ID']['input'];
}>;


export type GetClinicAdminsByClinicQuery = { __typename?: 'Query', getClinicAdminsByClinic: Array<{ __typename?: 'ClinicAdmin', id: string, role: AuthRoles, are_email_notifications_enabled: boolean, are_sms_notifications_enabled: boolean, are_desktop_notifications_enabled: boolean, should_hide_daily_huddle_financials: boolean, created_at: number, updated_at: number, clinic: { __typename?: 'Clinic', id: string, name?: string | null, slug?: string | null, avatar_url?: string | null, is_verified?: boolean | null, is_archived: boolean, description?: string | null, pms: PracticeManagementSystem, time_zone?: string | null, last_sync_times?: { __typename?: 'LastSyncTimes', last_full_sync?: number | null } | null, clinic_admins: Array<{ __typename?: 'ClinicAdmin', id: string }>, organization?: { __typename?: 'Organization', id: string } | null, address?: { __typename?: 'Address', street_a?: string | null, street_b?: string | null, city?: string | null, state?: string | null, zip?: string | null, country?: string | null, lat?: number | null, lng?: number | null } | null }, user: { __typename?: 'User', id: string, first_name?: string | null, last_name?: string | null, email?: any | null, phone?: string | null, phone_country?: string | null, avatar_url?: string | null, role?: AuthRoles | null, enabled_notification_sounds?: Array<UserNotificationSound> | null, notify_email_on?: Array<NotifyClinicOn> | null, notify_sound_on?: Array<NotifyClinicOn> | null, notify_desktop_on?: Array<NotifyClinicOn> | null, must_reset_password?: boolean | null, invitation_status?: UserInvitationStatus | null, invited_at?: number | null, created_at: number, updated_at: number }, custom_role?: { __typename?: 'CustomRole', id: string, name: string } | null, permissions?: Array<{ __typename?: 'ClinicAdminPermission', feature: AdminPermissionFeature, access_level: AdminPermissionAccessLevel }> | null }> };

export type GetClinicAdminsAssigneeOptionsQueryVariables = Exact<{
  clinicId: Scalars['ID']['input'];
}>;


export type GetClinicAdminsAssigneeOptionsQuery = { __typename?: 'Query', getClinicAdminsByClinic: Array<{ __typename?: 'ClinicAdmin', user: { __typename?: 'User', id: string, avatar_url?: string | null, first_name?: string | null, last_name?: string | null } }> };

export type GetClinicAdminsByUserQueryVariables = Exact<{
  userId: Scalars['ID']['input'];
}>;


export type GetClinicAdminsByUserQuery = { __typename?: 'Query', getClinicAdminsByUser: Array<{ __typename?: 'ClinicAdmin', id: string, role: AuthRoles, are_email_notifications_enabled: boolean, are_sms_notifications_enabled: boolean, are_desktop_notifications_enabled: boolean, should_hide_daily_huddle_financials: boolean, created_at: number, updated_at: number, clinic: { __typename?: 'Clinic', id: string, name?: string | null, slug?: string | null, avatar_url?: string | null, is_verified?: boolean | null, is_archived: boolean, description?: string | null, pms: PracticeManagementSystem, time_zone?: string | null, last_sync_times?: { __typename?: 'LastSyncTimes', last_full_sync?: number | null } | null, clinic_admins: Array<{ __typename?: 'ClinicAdmin', id: string }>, organization?: { __typename?: 'Organization', id: string } | null, address?: { __typename?: 'Address', street_a?: string | null, street_b?: string | null, city?: string | null, state?: string | null, zip?: string | null, country?: string | null, lat?: number | null, lng?: number | null } | null }, user: { __typename?: 'User', id: string, first_name?: string | null, last_name?: string | null, email?: any | null, phone?: string | null, phone_country?: string | null, avatar_url?: string | null, role?: AuthRoles | null, enabled_notification_sounds?: Array<UserNotificationSound> | null, notify_email_on?: Array<NotifyClinicOn> | null, notify_sound_on?: Array<NotifyClinicOn> | null, notify_desktop_on?: Array<NotifyClinicOn> | null, must_reset_password?: boolean | null, invitation_status?: UserInvitationStatus | null, invited_at?: number | null, created_at: number, updated_at: number }, custom_role?: { __typename?: 'CustomRole', id: string, name: string } | null, permissions?: Array<{ __typename?: 'ClinicAdminPermission', feature: AdminPermissionFeature, access_level: AdminPermissionAccessLevel }> | null }> };

export type GetClinicAdminsForLoginQueryVariables = Exact<{
  userId: Scalars['ID']['input'];
}>;


export type GetClinicAdminsForLoginQuery = { __typename?: 'Query', getClinicAdminsByUser: Array<{ __typename?: 'ClinicAdmin', id: string, clinic: { __typename?: 'Clinic', id: string, slug?: string | null, name?: string | null, description?: string | null, email?: string | null, phone?: string | null, send_from_phone?: string | null, send_from_email?: string | null, reply_to_email?: string | null, website?: string | null, pms: PracticeManagementSystem, pms_connector: PmsConnector, pms_api_key?: string | null, pms_additional_key?: string | null, office_emails?: Array<string> | null, stripe_accounts_enabled?: Array<StripeAccountType> | null, stripe_account_type?: string | null, stripe_customer_id?: string | null, avatar_url?: string | null, go_live_date?: string | null, time_zone?: string | null, is_archived: boolean, location?: string | null, tmp_feature_flags?: any | null, mute_until?: number | null, created_at: number, updated_at: number, pms_db?: { __typename?: 'PmsDb', id: string, name: string, last_sync_times?: { __typename?: 'LastSyncTimes', last_full_sync?: number | null, last_sync_appointments?: number | null, last_sync_clients?: number | null, last_sync_patients?: number | null, last_sync_clinicians?: number | null, last_sync_services?: number | null, last_sync_transactions?: number | null, last_sync_invoices?: number | null, last_sync_history_items?: number | null, last_sync_diagnoses?: number | null, last_sync_prescriptions?: number | null, last_sync_products?: number | null, last_sync_rooms?: number | null, last_sync_species?: number | null, last_sync_breeds?: number | null, last_sync_reminders?: number | null, last_sync_reminder_types?: number | null, last_sync_vaccination_records?: number | null, last_sync_clinic_sexes?: number | null, last_sync_appt_statuses?: number | null, last_sync_blockoffs?: number | null, last_sync_invoice_items?: number | null } | null } | null, clinic_admins: Array<{ __typename?: 'ClinicAdmin', id: string, role: AuthRoles, are_email_notifications_enabled: boolean, are_sms_notifications_enabled: boolean, are_desktop_notifications_enabled: boolean, should_hide_daily_huddle_financials: boolean, created_at: number, updated_at: number, clinic: { __typename?: 'Clinic', id: string, name?: string | null, slug?: string | null, avatar_url?: string | null, is_verified?: boolean | null, is_archived: boolean, description?: string | null, pms: PracticeManagementSystem, time_zone?: string | null, last_sync_times?: { __typename?: 'LastSyncTimes', last_full_sync?: number | null } | null, clinic_admins: Array<{ __typename?: 'ClinicAdmin', id: string }>, organization?: { __typename?: 'Organization', id: string } | null, address?: { __typename?: 'Address', street_a?: string | null, street_b?: string | null, city?: string | null, state?: string | null, zip?: string | null, country?: string | null, lat?: number | null, lng?: number | null } | null }, user: { __typename?: 'User', id: string, first_name?: string | null, last_name?: string | null, email?: any | null, phone?: string | null, phone_country?: string | null, avatar_url?: string | null, role?: AuthRoles | null, enabled_notification_sounds?: Array<UserNotificationSound> | null, notify_email_on?: Array<NotifyClinicOn> | null, notify_sound_on?: Array<NotifyClinicOn> | null, notify_desktop_on?: Array<NotifyClinicOn> | null, must_reset_password?: boolean | null, invitation_status?: UserInvitationStatus | null, invited_at?: number | null, created_at: number, updated_at: number }, custom_role?: { __typename?: 'CustomRole', id: string, name: string } | null, permissions?: Array<{ __typename?: 'ClinicAdminPermission', feature: AdminPermissionFeature, access_level: AdminPermissionAccessLevel }> | null }>, address?: { __typename?: 'Address', street_a?: string | null, street_b?: string | null, city?: string | null, state?: string | null, zip?: string | null, country?: string | null } | null, services: Array<{ __typename?: 'Service', id: string, name?: string | null }>, settings?: { __typename?: 'ClinicSettings', id?: string | null, does_require_verification?: boolean | null, does_use_automatic_reschedule?: boolean | null, reset_status_to_booked_on_reschedule?: boolean | null, is_using_detailed_services?: boolean | null, hide_review_step?: boolean | null, is_using_rooms?: boolean | null, pms_start_time?: any | null, pms_end_time?: any | null, primary_color?: string | null, accent_color?: string | null, secondary_color?: string | null, new_appt_requested_msg?: string | null, new_appt_approved_msg?: string | null, new_appt_approved_sms_msg?: string | null, new_appt_denied_msg?: string | null, schedule_method?: ScheduleMethod | null, scheduling_buffer_minutes?: number | null, base_schedule_duration?: number | null, does_require_referral?: boolean | null, appointment_entry_method?: AppointmentEntryMethod | null, scheduling_min_minutes_away?: number | null, scheduling_max_minutes_away?: number | null, included_species?: Array<Species> | null, max_patients_per_visit?: number | null, should_complete_sync?: boolean | null, server_syncing_only?: boolean | null, confirmation_days_before?: number | null, send_confirmations_to: SendConfirmationsTo, send_new_appt_email?: boolean | null, send_reviews_to?: SendConfirmationsTo | null, max_review_rating_for_notif?: number | null, google_review_link?: string | null, facebook_review_link?: string | null, non_blocking_services: Array<string>, yesterday_revenue?: number | null, this_month_revenue?: number | null, hide_clinician_preference: boolean, does_use_rooms_to_schedule?: boolean | null, primary_room_pms_id?: string | null, should_default_pims_emails_on: boolean, should_default_pims_sms_on: boolean, should_default_marketing_sms_on: boolean, should_default_marketing_email_on: boolean, does_use_clinicians_to_schedule?: boolean | null, time_slot_minutes: number, sync_interval_minutes: number, long_sync_interval_hours: number, primary_clinician_pms_id?: string | null, cancellation_clinician_pms_id?: string | null, cancellation_service_pms_id?: string | null, allow_first_appt_per_day?: boolean | null, custom_well_description?: string | null, custom_sick_description?: string | null, custom_other_title?: string | null, custom_other_description?: string | null, default_trigger_words?: Array<string> | null, should_use_private_reviews?: boolean | null, notify_clinic_on?: Array<NotifyClinicOn> | null, reminder_send_time_minutes?: number | null, does_require_new_client_address?: boolean | null, does_require_new_client_birthday?: boolean | null, should_allow_new_clients?: boolean | null, should_allow_new_patients?: boolean | null, should_create_clients?: boolean | null, should_create_patients?: boolean | null, msgs_auto_priority?: boolean | null, booking_match_procedure?: BookingMatchProcedure | null, urgency_type?: UrgencyType | null, max_booking_columns?: number | null, hide_closed_days_from_scheduling?: boolean | null, should_sync_reminders?: boolean | null, auto_reply_enabled: boolean, auto_reply_message?: string | null, unreplied_message_alert_enabled: boolean, unreplied_message_alert_minutes: number, comms_writeback_enabled: boolean, comms_should_daily_writeback: boolean, comms_use_pdf_for_writeback: boolean, comms_writeback_buffer_minutes: number, comms_writeback_before_appt_mins: number, comms_should_writeback_on_send: boolean, comms_should_writeback_on_receive: boolean, comms_should_writeback_notifs: boolean, comms_should_use_ai_writeback: boolean, form_writeback_enabled: boolean, should_award_loyalty_for_invoices?: boolean | null, invoice_loyalty_points_per_dollar?: number | null, app_download_loyalty_points?: number | null, referrer_loyalty_points?: number | null, referred_loyalty_points?: number | null, custom_appointment_notes_template?: string | null, custom_new_client_notes_template?: string | null, custom_new_patient_notes_template?: string | null, max_inactivity_duration?: number | null, hide_portal_vaccinations: boolean, hide_portal_reminders: boolean, hide_portal_prescriptions: boolean, hide_portal_weight: boolean, hide_soc_vaccinations?: boolean | null, hide_historic_vaccinations?: boolean | null, should_hide_daily_huddle_financials: boolean, patient_details_tab_order: Array<PortalPatientDetailsTab>, clinic_hours_display?: string | null, reschedule_buffer_minutes?: number | null, cancellation_buffer_minutes?: number | null, require_reason_for_cancellation?: boolean | null, should_automatically_assign_patient?: boolean | null, payment_writeback_enabled: boolean, auto_refund_on_cancel: boolean, status_set_on_payment_completed_pms_id?: string | null, max_booking_notes_length?: number | null, min_booking_notes_length?: number | null, primary_clinic_group_id?: string | null, should_suggest_nearby_clinics?: boolean | null, sms_block_list?: Array<string> | null, exclude_message_wrapper?: boolean | null, should_charge_client_stripe_fees?: boolean | null, chckvet_prescription_fee_split_percentage?: number | null, gtm_container_id?: string | null, review_google_id?: string | null, review_facebook_id?: string | null, only_use_adj_avail_guides: boolean, use_basic_timeslots: boolean, valid_booking_interval_minutes?: Array<number> | null, should_disable_online_scheduling?: boolean | null, simple_scheduling_rules_enabled: boolean, compliance_statuses?: Array<string> | null, should_use_instant_prescription_requests?: boolean | null, prescription_pickup_service_id?: string | null, default_reminder_service_id?: string | null, ai_calls_provider?: PhoneProviderType | null, ai_calls_phone_number?: string | null, ai_calls_voice_id?: string | null, ai_calls_agent_id?: string | null, ai_agent_style?: string | null, ai_agent_custom_instructions?: string | null, ai_calls_ambient_sound?: AiCallsAmbientSound | null, ai_calls_voice_speed?: number | null, ai_calls_interruption_sensitivity?: number | null, ai_calls_enable_dynamic_voice_speed?: boolean | null, usage_spending_caps?: any | null, custom_merge_tags?: any | null, custom_booking_copy?: { __typename?: 'ClinicBookingCopy', WIDGET_HEADER_TITLE?: string | null, SHOW_CLINIC_HEADER_LOGO?: boolean | null, CLINIC_HEADER_LOGO_HEIGHT?: number | null, SERVICE_TYPE_SECTION_HEADING?: string | null, DEFAULT_WELLNESS_DESCRIPTION?: string | null, DEFAULT_SICK_DESCRIPTION?: string | null, DEFAULT_OTHER_DESCRIPTION?: string | null, RETURNING_PATIENT_QUESTION?: string | null, POSITIVE_RETURNING_PATIENT_ANSWER?: string | null, NEGATIVE_RETURNING_PATIENT_ANSWER?: string | null, RETURNING_CLIENT_QUESTION?: string | null, POSITIVE_RETURNING_CLIENT_ANSWER?: string | null, NEGATIVE_RETURNING_CLIENT_ANSWER?: string | null, CLIENT_INFORMATION_SECTION_TITLE?: string | null, PATIENT_INFORMATION_SECTION_TITLE?: string | null, RETURNING_CLIENT_PATIENT_TITLE?: string | null, RETURNING_CLIENT_PATIENT_DESCRIPTION?: string | null, SERVICE_SECTION_TITLE?: string | null, PREPAID_SERVICES_LABEL?: string | null, STANDARD_SERVICES_LABEL?: string | null, DEPOSIT_FEE_NAME?: string | null, PREVIOUS_OR_REFERRING_CLINIC_QUESTION?: string | null, CONTACT_THE_CLINIC_TEXT?: string | null, CONTACT_THE_CLINIC_TEXT_COLOR?: string | null, CONTACT_THE_CLINIC_TEXT_SIZE?: string | null, SELECT_CLINICIAN_TITLE?: string | null, SELECT_CLINICIAN_POSITIVE_ANSWER?: string | null, SELECT_CLINICIAN_NEGATIVE_ANSWER?: string | null, SELECT_TIME_TITLE?: string | null, REVIEW_TITLE?: string | null, REVIEW_NOTES_PROMPT?: string | null, PAYMENT_INFORMATION_TITLE?: string | null, TRIGGER_WORDS_DETECTED_HEADER?: string | null, TRIGGER_WORDS_DETECTED_DESCRIPTION?: string | null, CONFIRMATION_SCREEN_TITLE?: string | null, CONFIRMATION_SCREEN_DESCRIPTION?: string | null, NEW_CLIENT_BLOCKED_MESSAGE?: string | null, NEW_PATIENT_BLOCKED_MESSAGE?: string | null } | null, auto_reply_hours?: { __typename?: 'AvailabilityHours', monday?: Array<{ __typename?: 'TimeInterval', start?: number | null, end?: number | null }> | null, tuesday?: Array<{ __typename?: 'TimeInterval', start?: number | null, end?: number | null }> | null, wednesday?: Array<{ __typename?: 'TimeInterval', start?: number | null, end?: number | null }> | null, thursday?: Array<{ __typename?: 'TimeInterval', start?: number | null, end?: number | null }> | null, friday?: Array<{ __typename?: 'TimeInterval', start?: number | null, end?: number | null }> | null, saturday?: Array<{ __typename?: 'TimeInterval', start?: number | null, end?: number | null }> | null, sunday?: Array<{ __typename?: 'TimeInterval', start?: number | null, end?: number | null }> | null } | null, portal_links?: Array<{ __typename?: 'PortalLink', label: string, url: string }> | null, custom_reviews_copy?: { __typename?: 'ClinicReviewsCopy', REVIEW_METHOD_PAGE_TITLE?: string | null, REVIEW_METHOD_PAGE_DESCRIPTION?: string | null, PRIVATE_REVIEW_BUTTON_HELP_TEXT?: string | null, PRIVATE_REVIEW_BUTTON_TEXT?: string | null, REVIEW_PAGE_TITLE?: string | null, REVIEW_PAGE_SUBTITLE?: string | null, REVIEW_SCORE_LABEL?: string | null, REVIEW_MESSAGE_LABEL?: string | null, REVIEW_SUBMIT_BUTTON_TEXT?: string | null } | null, waitlist_customer_segment?: { __typename?: 'CustomerSegment', id: string, name: string, trigger_entity?: CustomerSegmentTrigger | null, is_archived: boolean, updated_at: number, notification_templates?: Array<{ __typename?: 'NotificationTemplate', id: string, name: string, is_active: boolean, is_archived: boolean, message_methods: Array<MessageMethod> }> | null, error_flags?: Array<{ __typename?: 'CustomerSegmentErrorFlag', filter_column: string, filter_index: number, parameter_index: number, message: string }> | null, all_inclusions?: Array<{ __typename?: 'SegmentFilter', foreign_table?: string | null, group?: string | null, parameters: Array<{ __typename?: 'QueryFilter', column: string, filterOp: FilterOp, value: { __typename?: 'QueryFilterValue', string?: string | null, float?: number | null, boolean?: boolean | null, stringArray?: Array<string> | null, floatArray?: Array<number> | null, millisFromNow?: number | null, relativeTime?: { __typename?: 'RelativeTime', quantity: number, unit: TimeUnit, direction: ReferenceDirection } | null } }> }> | null, any_inclusions?: Array<{ __typename?: 'SegmentFilter', foreign_table?: string | null, group?: string | null, parameters: Array<{ __typename?: 'QueryFilter', column: string, filterOp: FilterOp, value: { __typename?: 'QueryFilterValue', string?: string | null, float?: number | null, boolean?: boolean | null, stringArray?: Array<string> | null, floatArray?: Array<number> | null, millisFromNow?: number | null, relativeTime?: { __typename?: 'RelativeTime', quantity: number, unit: TimeUnit, direction: ReferenceDirection } | null } }> }> | null, any_exclusions?: Array<{ __typename?: 'SegmentFilter', foreign_table?: string | null, group?: string | null, parameters: Array<{ __typename?: 'QueryFilter', column: string, filterOp: FilterOp, value: { __typename?: 'QueryFilterValue', string?: string | null, float?: number | null, boolean?: boolean | null, stringArray?: Array<string> | null, floatArray?: Array<number> | null, millisFromNow?: number | null, relativeTime?: { __typename?: 'RelativeTime', quantity: number, unit: TimeUnit, direction: ReferenceDirection } | null } }> }> | null, any_other_exclusions?: Array<{ __typename?: 'SegmentFilter', foreign_table?: string | null, group?: string | null, parameters: Array<{ __typename?: 'QueryFilter', column: string, filterOp: FilterOp, value: { __typename?: 'QueryFilterValue', string?: string | null, float?: number | null, boolean?: boolean | null, stringArray?: Array<string> | null, floatArray?: Array<number> | null, millisFromNow?: number | null, relativeTime?: { __typename?: 'RelativeTime', quantity: number, unit: TimeUnit, direction: ReferenceDirection } | null } }> }> | null, filters?: Array<{ __typename?: 'CustomerSegmentFilter', filters: Array<{ __typename?: 'QueryFilter', column: string, filterOp: FilterOp, value: { __typename?: 'QueryFilterValue', string?: string | null, float?: number | null, boolean?: boolean | null, stringArray?: Array<string> | null, floatArray?: Array<number> | null, millisFromNow?: number | null, relativeTime?: { __typename?: 'RelativeTime', quantity: number, unit: TimeUnit, direction: ReferenceDirection } | null } }> }> | null, excluded_filters: Array<{ __typename?: 'CustomerSegmentFilter', filters: Array<{ __typename?: 'QueryFilter', column: string, filterOp: FilterOp, value: { __typename?: 'QueryFilterValue', string?: string | null, float?: number | null, boolean?: boolean | null, stringArray?: Array<string> | null, floatArray?: Array<number> | null, millisFromNow?: number | null, relativeTime?: { __typename?: 'RelativeTime', quantity: number, unit: TimeUnit, direction: ReferenceDirection } | null } }> }> } | null, blocklist_customer_segment?: { __typename?: 'CustomerSegment', id: string, name: string, trigger_entity?: CustomerSegmentTrigger | null, is_archived: boolean, updated_at: number, notification_templates?: Array<{ __typename?: 'NotificationTemplate', id: string, name: string, is_active: boolean, is_archived: boolean, message_methods: Array<MessageMethod> }> | null, error_flags?: Array<{ __typename?: 'CustomerSegmentErrorFlag', filter_column: string, filter_index: number, parameter_index: number, message: string }> | null, all_inclusions?: Array<{ __typename?: 'SegmentFilter', foreign_table?: string | null, group?: string | null, parameters: Array<{ __typename?: 'QueryFilter', column: string, filterOp: FilterOp, value: { __typename?: 'QueryFilterValue', string?: string | null, float?: number | null, boolean?: boolean | null, stringArray?: Array<string> | null, floatArray?: Array<number> | null, millisFromNow?: number | null, relativeTime?: { __typename?: 'RelativeTime', quantity: number, unit: TimeUnit, direction: ReferenceDirection } | null } }> }> | null, any_inclusions?: Array<{ __typename?: 'SegmentFilter', foreign_table?: string | null, group?: string | null, parameters: Array<{ __typename?: 'QueryFilter', column: string, filterOp: FilterOp, value: { __typename?: 'QueryFilterValue', string?: string | null, float?: number | null, boolean?: boolean | null, stringArray?: Array<string> | null, floatArray?: Array<number> | null, millisFromNow?: number | null, relativeTime?: { __typename?: 'RelativeTime', quantity: number, unit: TimeUnit, direction: ReferenceDirection } | null } }> }> | null, any_exclusions?: Array<{ __typename?: 'SegmentFilter', foreign_table?: string | null, group?: string | null, parameters: Array<{ __typename?: 'QueryFilter', column: string, filterOp: FilterOp, value: { __typename?: 'QueryFilterValue', string?: string | null, float?: number | null, boolean?: boolean | null, stringArray?: Array<string> | null, floatArray?: Array<number> | null, millisFromNow?: number | null, relativeTime?: { __typename?: 'RelativeTime', quantity: number, unit: TimeUnit, direction: ReferenceDirection } | null } }> }> | null, any_other_exclusions?: Array<{ __typename?: 'SegmentFilter', foreign_table?: string | null, group?: string | null, parameters: Array<{ __typename?: 'QueryFilter', column: string, filterOp: FilterOp, value: { __typename?: 'QueryFilterValue', string?: string | null, float?: number | null, boolean?: boolean | null, stringArray?: Array<string> | null, floatArray?: Array<number> | null, millisFromNow?: number | null, relativeTime?: { __typename?: 'RelativeTime', quantity: number, unit: TimeUnit, direction: ReferenceDirection } | null } }> }> | null, filters?: Array<{ __typename?: 'CustomerSegmentFilter', filters: Array<{ __typename?: 'QueryFilter', column: string, filterOp: FilterOp, value: { __typename?: 'QueryFilterValue', string?: string | null, float?: number | null, boolean?: boolean | null, stringArray?: Array<string> | null, floatArray?: Array<number> | null, millisFromNow?: number | null, relativeTime?: { __typename?: 'RelativeTime', quantity: number, unit: TimeUnit, direction: ReferenceDirection } | null } }> }> | null, excluded_filters: Array<{ __typename?: 'CustomerSegmentFilter', filters: Array<{ __typename?: 'QueryFilter', column: string, filterOp: FilterOp, value: { __typename?: 'QueryFilterValue', string?: string | null, float?: number | null, boolean?: boolean | null, stringArray?: Array<string> | null, floatArray?: Array<number> | null, millisFromNow?: number | null, relativeTime?: { __typename?: 'RelativeTime', quantity: number, unit: TimeUnit, direction: ReferenceDirection } | null } }> }> } | null, referral_customer_segment?: { __typename?: 'CustomerSegment', id: string, name: string, trigger_entity?: CustomerSegmentTrigger | null, is_archived: boolean, updated_at: number, notification_templates?: Array<{ __typename?: 'NotificationTemplate', id: string, name: string, is_active: boolean, is_archived: boolean, message_methods: Array<MessageMethod> }> | null, error_flags?: Array<{ __typename?: 'CustomerSegmentErrorFlag', filter_column: string, filter_index: number, parameter_index: number, message: string }> | null, all_inclusions?: Array<{ __typename?: 'SegmentFilter', foreign_table?: string | null, group?: string | null, parameters: Array<{ __typename?: 'QueryFilter', column: string, filterOp: FilterOp, value: { __typename?: 'QueryFilterValue', string?: string | null, float?: number | null, boolean?: boolean | null, stringArray?: Array<string> | null, floatArray?: Array<number> | null, millisFromNow?: number | null, relativeTime?: { __typename?: 'RelativeTime', quantity: number, unit: TimeUnit, direction: ReferenceDirection } | null } }> }> | null, any_inclusions?: Array<{ __typename?: 'SegmentFilter', foreign_table?: string | null, group?: string | null, parameters: Array<{ __typename?: 'QueryFilter', column: string, filterOp: FilterOp, value: { __typename?: 'QueryFilterValue', string?: string | null, float?: number | null, boolean?: boolean | null, stringArray?: Array<string> | null, floatArray?: Array<number> | null, millisFromNow?: number | null, relativeTime?: { __typename?: 'RelativeTime', quantity: number, unit: TimeUnit, direction: ReferenceDirection } | null } }> }> | null, any_exclusions?: Array<{ __typename?: 'SegmentFilter', foreign_table?: string | null, group?: string | null, parameters: Array<{ __typename?: 'QueryFilter', column: string, filterOp: FilterOp, value: { __typename?: 'QueryFilterValue', string?: string | null, float?: number | null, boolean?: boolean | null, stringArray?: Array<string> | null, floatArray?: Array<number> | null, millisFromNow?: number | null, relativeTime?: { __typename?: 'RelativeTime', quantity: number, unit: TimeUnit, direction: ReferenceDirection } | null } }> }> | null, any_other_exclusions?: Array<{ __typename?: 'SegmentFilter', foreign_table?: string | null, group?: string | null, parameters: Array<{ __typename?: 'QueryFilter', column: string, filterOp: FilterOp, value: { __typename?: 'QueryFilterValue', string?: string | null, float?: number | null, boolean?: boolean | null, stringArray?: Array<string> | null, floatArray?: Array<number> | null, millisFromNow?: number | null, relativeTime?: { __typename?: 'RelativeTime', quantity: number, unit: TimeUnit, direction: ReferenceDirection } | null } }> }> | null, filters?: Array<{ __typename?: 'CustomerSegmentFilter', filters: Array<{ __typename?: 'QueryFilter', column: string, filterOp: FilterOp, value: { __typename?: 'QueryFilterValue', string?: string | null, float?: number | null, boolean?: boolean | null, stringArray?: Array<string> | null, floatArray?: Array<number> | null, millisFromNow?: number | null, relativeTime?: { __typename?: 'RelativeTime', quantity: number, unit: TimeUnit, direction: ReferenceDirection } | null } }> }> | null, excluded_filters: Array<{ __typename?: 'CustomerSegmentFilter', filters: Array<{ __typename?: 'QueryFilter', column: string, filterOp: FilterOp, value: { __typename?: 'QueryFilterValue', string?: string | null, float?: number | null, boolean?: boolean | null, stringArray?: Array<string> | null, floatArray?: Array<number> | null, millisFromNow?: number | null, relativeTime?: { __typename?: 'RelativeTime', quantity: number, unit: TimeUnit, direction: ReferenceDirection } | null } }> }> } | null, webhooks?: Array<{ __typename?: 'WebhookConfig', id: string, name: string, url: string, events: Array<WebhookEventType>, secret?: string | null, enabled: boolean }> | null, times_first_filter_config?: { __typename?: 'TimesFirstFilterConfig', service?: BookingFilterDisplayMode | null, clinician?: BookingFilterDisplayMode | null, species?: BookingFilterDisplayMode | null, client_status?: BookingFilterDisplayMode | null, patient_status?: BookingFilterDisplayMode | null, patient_gender?: BookingFilterDisplayMode | null, fixed_status?: BookingFilterDisplayMode | null } | null } | null, onboarding?: { __typename?: 'ClinicOnboarding', has_set_hours?: boolean | null, has_synced_pms?: boolean | null } | null, organization?: { __typename?: 'Organization', id: string } | null, features?: { __typename?: 'ClinicFeatures', scheduling_enabled?: boolean | null, huddle_enabled?: boolean | null, payments_enabled?: boolean | null, messaging_enabled?: boolean | null, reviews_enabled?: boolean | null, loyalty_enabled?: boolean | null, notifs_enabled?: boolean | null, forms_enabled?: boolean | null, help_enabled?: boolean | null, bulk_messaging_enabled?: boolean | null, portal_enabled?: boolean | null, calls_enabled?: boolean | null, teamchat_enabled?: boolean | null, prescriptions_enabled?: boolean | null, medical_history_enabled?: boolean | null, pet_selfies_enabled?: boolean | null } | null, hours?: { __typename?: 'AvailabilityHours', monday?: Array<{ __typename?: 'TimeInterval', start?: number | null, end?: number | null }> | null, tuesday?: Array<{ __typename?: 'TimeInterval', start?: number | null, end?: number | null }> | null, wednesday?: Array<{ __typename?: 'TimeInterval', start?: number | null, end?: number | null }> | null, thursday?: Array<{ __typename?: 'TimeInterval', start?: number | null, end?: number | null }> | null, friday?: Array<{ __typename?: 'TimeInterval', start?: number | null, end?: number | null }> | null, saturday?: Array<{ __typename?: 'TimeInterval', start?: number | null, end?: number | null }> | null, sunday?: Array<{ __typename?: 'TimeInterval', start?: number | null, end?: number | null }> | null } | null, clinic_hours?: { __typename?: 'AvailabilityHours', monday?: Array<{ __typename?: 'TimeInterval', start?: number | null, end?: number | null }> | null, tuesday?: Array<{ __typename?: 'TimeInterval', start?: number | null, end?: number | null }> | null, wednesday?: Array<{ __typename?: 'TimeInterval', start?: number | null, end?: number | null }> | null, thursday?: Array<{ __typename?: 'TimeInterval', start?: number | null, end?: number | null }> | null, friday?: Array<{ __typename?: 'TimeInterval', start?: number | null, end?: number | null }> | null, saturday?: Array<{ __typename?: 'TimeInterval', start?: number | null, end?: number | null }> | null, sunday?: Array<{ __typename?: 'TimeInterval', start?: number | null, end?: number | null }> | null } | null, adjusted_availability?: Array<{ __typename?: 'Availability', date: number, pms_appt_type_pms_id?: string | null, times: Array<{ __typename?: 'TimeInterval', start?: number | null, end?: number | null }>, repeat?: { __typename?: 'RepeatAvailability', daysOfMonth?: Array<number> | null, daysOfWeek?: Array<DayOfWeek> | null, weekOfMonth?: WeekOfMonth | null, frequency: any, unit: RepeatUnit, end_date?: number | null } | null }> | null, pms_adjusted_availability?: Array<{ __typename?: 'Availability', date: number, pms_appt_type_pms_id?: string | null, times: Array<{ __typename?: 'TimeInterval', start?: number | null, end?: number | null }>, repeat?: { __typename?: 'RepeatAvailability', daysOfMonth?: Array<number> | null, daysOfWeek?: Array<DayOfWeek> | null, weekOfMonth?: WeekOfMonth | null, frequency: any, unit: RepeatUnit, end_date?: number | null } | null }> | null, last_sync_times?: { __typename?: 'LastSyncTimes', last_full_sync?: number | null, last_sync_appointments?: number | null, last_sync_clients?: number | null, last_sync_patients?: number | null, last_sync_clinicians?: number | null, last_sync_services?: number | null, last_sync_transactions?: number | null, last_sync_invoices?: number | null, last_sync_history_items?: number | null, last_sync_diagnoses?: number | null, last_sync_prescriptions?: number | null, last_sync_products?: number | null, last_sync_rooms?: number | null, last_sync_species?: number | null, last_sync_breeds?: number | null, last_sync_reminders?: number | null, last_sync_reminder_types?: number | null, last_sync_vaccination_records?: number | null, last_sync_clinic_sexes?: number | null, last_sync_appt_statuses?: number | null, last_sync_blockoffs?: number | null, last_sync_invoice_items?: number | null } | null, pims_settings?: { __typename?: 'PimsSettings', ezyvet_integration_mode?: EzyvetIntegrationMode | null, entered_by_pms_id?: string | null } | null } }> };

export type QueryClinicAdminsQueryVariables = Exact<{
  clinicId: Scalars['ID']['input'];
  where?: InputMaybe<Array<QueryInput> | QueryInput>;
  page?: InputMaybe<Scalars['NonNegativeInt']['input']>;
  pageSize?: InputMaybe<Scalars['NonNegativeInt']['input']>;
  orderBy?: InputMaybe<OrderByInput>;
}>;


export type QueryClinicAdminsQuery = { __typename?: 'Query', queryClinicAdmins: Array<{ __typename?: 'ClinicAdmin', id: string, role: AuthRoles, are_email_notifications_enabled: boolean, are_sms_notifications_enabled: boolean, are_desktop_notifications_enabled: boolean, should_hide_daily_huddle_financials: boolean, created_at: number, updated_at: number, clinic: { __typename?: 'Clinic', id: string, name?: string | null, slug?: string | null, avatar_url?: string | null, is_verified?: boolean | null, is_archived: boolean, description?: string | null, pms: PracticeManagementSystem, time_zone?: string | null, last_sync_times?: { __typename?: 'LastSyncTimes', last_full_sync?: number | null } | null, clinic_admins: Array<{ __typename?: 'ClinicAdmin', id: string }>, organization?: { __typename?: 'Organization', id: string } | null, address?: { __typename?: 'Address', street_a?: string | null, street_b?: string | null, city?: string | null, state?: string | null, zip?: string | null, country?: string | null, lat?: number | null, lng?: number | null } | null }, user: { __typename?: 'User', id: string, first_name?: string | null, last_name?: string | null, email?: any | null, phone?: string | null, phone_country?: string | null, avatar_url?: string | null, role?: AuthRoles | null, enabled_notification_sounds?: Array<UserNotificationSound> | null, notify_email_on?: Array<NotifyClinicOn> | null, notify_sound_on?: Array<NotifyClinicOn> | null, notify_desktop_on?: Array<NotifyClinicOn> | null, must_reset_password?: boolean | null, invitation_status?: UserInvitationStatus | null, invited_at?: number | null, created_at: number, updated_at: number }, custom_role?: { __typename?: 'CustomRole', id: string, name: string } | null, permissions?: Array<{ __typename?: 'ClinicAdminPermission', feature: AdminPermissionFeature, access_level: AdminPermissionAccessLevel }> | null }> };

export type QueryAllClinicAdminsQueryVariables = Exact<{
  where?: InputMaybe<Array<QueryInput> | QueryInput>;
  page?: InputMaybe<Scalars['NonNegativeInt']['input']>;
  pageSize?: InputMaybe<Scalars['NonNegativeInt']['input']>;
  orderBy?: InputMaybe<OrderByInput>;
}>;


export type QueryAllClinicAdminsQuery = { __typename?: 'Query', queryAllClinicAdmins: Array<{ __typename?: 'ClinicAdmin', id: string, role: AuthRoles, are_email_notifications_enabled: boolean, are_sms_notifications_enabled: boolean, are_desktop_notifications_enabled: boolean, should_hide_daily_huddle_financials: boolean, created_at: number, updated_at: number, clinic: { __typename?: 'Clinic', id: string, name?: string | null, slug?: string | null, avatar_url?: string | null, is_verified?: boolean | null, is_archived: boolean, description?: string | null, pms: PracticeManagementSystem, time_zone?: string | null, last_sync_times?: { __typename?: 'LastSyncTimes', last_full_sync?: number | null } | null, clinic_admins: Array<{ __typename?: 'ClinicAdmin', id: string }>, organization?: { __typename?: 'Organization', id: string } | null, address?: { __typename?: 'Address', street_a?: string | null, street_b?: string | null, city?: string | null, state?: string | null, zip?: string | null, country?: string | null, lat?: number | null, lng?: number | null } | null }, user: { __typename?: 'User', id: string, first_name?: string | null, last_name?: string | null, email?: any | null, phone?: string | null, phone_country?: string | null, avatar_url?: string | null, role?: AuthRoles | null, enabled_notification_sounds?: Array<UserNotificationSound> | null, notify_email_on?: Array<NotifyClinicOn> | null, notify_sound_on?: Array<NotifyClinicOn> | null, notify_desktop_on?: Array<NotifyClinicOn> | null, must_reset_password?: boolean | null, invitation_status?: UserInvitationStatus | null, invited_at?: number | null, created_at: number, updated_at: number }, custom_role?: { __typename?: 'CustomRole', id: string, name: string } | null, permissions?: Array<{ __typename?: 'ClinicAdminPermission', feature: AdminPermissionFeature, access_level: AdminPermissionAccessLevel }> | null }> };

export type CountAllClinicAdminsQueryVariables = Exact<{
  where?: InputMaybe<Array<QueryInput> | QueryInput>;
}>;


export type CountAllClinicAdminsQuery = { __typename?: 'Query', countAllClinicAdmins: number };

export type CountClinicAdminsQueryVariables = Exact<{
  clinicId: Scalars['ID']['input'];
  where?: InputMaybe<Array<QueryInput> | QueryInput>;
}>;


export type CountClinicAdminsQuery = { __typename?: 'Query', countClinicAdmins: number };

export type CreateClinicAdminMutationVariables = Exact<{
  data: CreateClinicAdminInput;
}>;


export type CreateClinicAdminMutation = { __typename?: 'Mutation', createClinicAdmin: { __typename?: 'ClinicAdmin', id: string, role: AuthRoles, are_email_notifications_enabled: boolean, are_sms_notifications_enabled: boolean, are_desktop_notifications_enabled: boolean, should_hide_daily_huddle_financials: boolean, created_at: number, updated_at: number, clinic: { __typename?: 'Clinic', id: string, name?: string | null, slug?: string | null, avatar_url?: string | null, is_verified?: boolean | null, is_archived: boolean, description?: string | null, pms: PracticeManagementSystem, time_zone?: string | null, last_sync_times?: { __typename?: 'LastSyncTimes', last_full_sync?: number | null } | null, clinic_admins: Array<{ __typename?: 'ClinicAdmin', id: string }>, organization?: { __typename?: 'Organization', id: string } | null, address?: { __typename?: 'Address', street_a?: string | null, street_b?: string | null, city?: string | null, state?: string | null, zip?: string | null, country?: string | null, lat?: number | null, lng?: number | null } | null }, user: { __typename?: 'User', id: string, first_name?: string | null, last_name?: string | null, email?: any | null, phone?: string | null, phone_country?: string | null, avatar_url?: string | null, role?: AuthRoles | null, enabled_notification_sounds?: Array<UserNotificationSound> | null, notify_email_on?: Array<NotifyClinicOn> | null, notify_sound_on?: Array<NotifyClinicOn> | null, notify_desktop_on?: Array<NotifyClinicOn> | null, must_reset_password?: boolean | null, invitation_status?: UserInvitationStatus | null, invited_at?: number | null, created_at: number, updated_at: number }, custom_role?: { __typename?: 'CustomRole', id: string, name: string } | null, permissions?: Array<{ __typename?: 'ClinicAdminPermission', feature: AdminPermissionFeature, access_level: AdminPermissionAccessLevel }> | null } };

export type UpdateClinicAdminMutationVariables = Exact<{
  clinicId: Scalars['ID']['input'];
  userId: Scalars['ID']['input'];
  data: UpdateClinicAdminInput;
}>;


export type UpdateClinicAdminMutation = { __typename?: 'Mutation', updateClinicAdmin: { __typename?: 'ClinicAdmin', id: string, role: AuthRoles, are_email_notifications_enabled: boolean, are_sms_notifications_enabled: boolean, are_desktop_notifications_enabled: boolean, should_hide_daily_huddle_financials: boolean, created_at: number, updated_at: number, clinic: { __typename?: 'Clinic', id: string, name?: string | null, slug?: string | null, avatar_url?: string | null, is_verified?: boolean | null, is_archived: boolean, description?: string | null, pms: PracticeManagementSystem, time_zone?: string | null, last_sync_times?: { __typename?: 'LastSyncTimes', last_full_sync?: number | null } | null, clinic_admins: Array<{ __typename?: 'ClinicAdmin', id: string }>, organization?: { __typename?: 'Organization', id: string } | null, address?: { __typename?: 'Address', street_a?: string | null, street_b?: string | null, city?: string | null, state?: string | null, zip?: string | null, country?: string | null, lat?: number | null, lng?: number | null } | null }, user: { __typename?: 'User', id: string, first_name?: string | null, last_name?: string | null, email?: any | null, phone?: string | null, phone_country?: string | null, avatar_url?: string | null, role?: AuthRoles | null, enabled_notification_sounds?: Array<UserNotificationSound> | null, notify_email_on?: Array<NotifyClinicOn> | null, notify_sound_on?: Array<NotifyClinicOn> | null, notify_desktop_on?: Array<NotifyClinicOn> | null, must_reset_password?: boolean | null, invitation_status?: UserInvitationStatus | null, invited_at?: number | null, created_at: number, updated_at: number }, custom_role?: { __typename?: 'CustomRole', id: string, name: string } | null, permissions?: Array<{ __typename?: 'ClinicAdminPermission', feature: AdminPermissionFeature, access_level: AdminPermissionAccessLevel }> | null } };

export type DeleteClinicAdminMutationVariables = Exact<{
  clinicId: Scalars['ID']['input'];
  userId: Scalars['ID']['input'];
}>;


export type DeleteClinicAdminMutation = { __typename?: 'Mutation', deleteClinicAdmin?: any | null };

export type AddUserToClinicsAndClinicGroupsMutationVariables = Exact<{
  data: AddUserToClinicsAndClinicGroupsInput;
}>;


export type AddUserToClinicsAndClinicGroupsMutation = { __typename?: 'Mutation', addUserToClinicsAndClinicGroups?: any | null };

export type QueryClinicAdminClinicsQueryVariables = Exact<{
  userId: Scalars['ID']['input'];
  where?: InputMaybe<Array<QueryInput> | QueryInput>;
  page?: InputMaybe<Scalars['NonNegativeInt']['input']>;
  pageSize?: InputMaybe<Scalars['NonNegativeInt']['input']>;
  orderBy?: InputMaybe<OrderByInput>;
}>;


export type QueryClinicAdminClinicsQuery = { __typename?: 'Query', queryClinicAdminClinics: Array<{ __typename?: 'Clinic', id: string, slug?: string | null, name?: string | null, description?: string | null, email?: string | null, phone?: string | null, send_from_phone?: string | null, send_from_email?: string | null, reply_to_email?: string | null, website?: string | null, pms: PracticeManagementSystem, pms_connector: PmsConnector, pms_api_key?: string | null, pms_additional_key?: string | null, office_emails?: Array<string> | null, stripe_accounts_enabled?: Array<StripeAccountType> | null, stripe_account_type?: string | null, stripe_customer_id?: string | null, avatar_url?: string | null, go_live_date?: string | null, time_zone?: string | null, is_archived: boolean, location?: string | null, tmp_feature_flags?: any | null, mute_until?: number | null, created_at: number, updated_at: number, pms_db?: { __typename?: 'PmsDb', id: string, name: string, last_sync_times?: { __typename?: 'LastSyncTimes', last_full_sync?: number | null, last_sync_appointments?: number | null, last_sync_clients?: number | null, last_sync_patients?: number | null, last_sync_clinicians?: number | null, last_sync_services?: number | null, last_sync_transactions?: number | null, last_sync_invoices?: number | null, last_sync_history_items?: number | null, last_sync_diagnoses?: number | null, last_sync_prescriptions?: number | null, last_sync_products?: number | null, last_sync_rooms?: number | null, last_sync_species?: number | null, last_sync_breeds?: number | null, last_sync_reminders?: number | null, last_sync_reminder_types?: number | null, last_sync_vaccination_records?: number | null, last_sync_clinic_sexes?: number | null, last_sync_appt_statuses?: number | null, last_sync_blockoffs?: number | null, last_sync_invoice_items?: number | null } | null } | null, clinic_admins: Array<{ __typename?: 'ClinicAdmin', id: string, role: AuthRoles, are_email_notifications_enabled: boolean, are_sms_notifications_enabled: boolean, are_desktop_notifications_enabled: boolean, should_hide_daily_huddle_financials: boolean, created_at: number, updated_at: number, clinic: { __typename?: 'Clinic', id: string, name?: string | null, slug?: string | null, avatar_url?: string | null, is_verified?: boolean | null, is_archived: boolean, description?: string | null, pms: PracticeManagementSystem, time_zone?: string | null, last_sync_times?: { __typename?: 'LastSyncTimes', last_full_sync?: number | null } | null, clinic_admins: Array<{ __typename?: 'ClinicAdmin', id: string }>, organization?: { __typename?: 'Organization', id: string } | null, address?: { __typename?: 'Address', street_a?: string | null, street_b?: string | null, city?: string | null, state?: string | null, zip?: string | null, country?: string | null, lat?: number | null, lng?: number | null } | null }, user: { __typename?: 'User', id: string, first_name?: string | null, last_name?: string | null, email?: any | null, phone?: string | null, phone_country?: string | null, avatar_url?: string | null, role?: AuthRoles | null, enabled_notification_sounds?: Array<UserNotificationSound> | null, notify_email_on?: Array<NotifyClinicOn> | null, notify_sound_on?: Array<NotifyClinicOn> | null, notify_desktop_on?: Array<NotifyClinicOn> | null, must_reset_password?: boolean | null, invitation_status?: UserInvitationStatus | null, invited_at?: number | null, created_at: number, updated_at: number }, custom_role?: { __typename?: 'CustomRole', id: string, name: string } | null, permissions?: Array<{ __typename?: 'ClinicAdminPermission', feature: AdminPermissionFeature, access_level: AdminPermissionAccessLevel }> | null }>, address?: { __typename?: 'Address', street_a?: string | null, street_b?: string | null, city?: string | null, state?: string | null, zip?: string | null, country?: string | null } | null, services: Array<{ __typename?: 'Service', id: string, name?: string | null }>, settings?: { __typename?: 'ClinicSettings', id?: string | null, does_require_verification?: boolean | null, does_use_automatic_reschedule?: boolean | null, reset_status_to_booked_on_reschedule?: boolean | null, is_using_detailed_services?: boolean | null, hide_review_step?: boolean | null, is_using_rooms?: boolean | null, pms_start_time?: any | null, pms_end_time?: any | null, primary_color?: string | null, accent_color?: string | null, secondary_color?: string | null, new_appt_requested_msg?: string | null, new_appt_approved_msg?: string | null, new_appt_approved_sms_msg?: string | null, new_appt_denied_msg?: string | null, schedule_method?: ScheduleMethod | null, scheduling_buffer_minutes?: number | null, base_schedule_duration?: number | null, does_require_referral?: boolean | null, appointment_entry_method?: AppointmentEntryMethod | null, scheduling_min_minutes_away?: number | null, scheduling_max_minutes_away?: number | null, included_species?: Array<Species> | null, max_patients_per_visit?: number | null, should_complete_sync?: boolean | null, server_syncing_only?: boolean | null, confirmation_days_before?: number | null, send_confirmations_to: SendConfirmationsTo, send_new_appt_email?: boolean | null, send_reviews_to?: SendConfirmationsTo | null, max_review_rating_for_notif?: number | null, google_review_link?: string | null, facebook_review_link?: string | null, non_blocking_services: Array<string>, yesterday_revenue?: number | null, this_month_revenue?: number | null, hide_clinician_preference: boolean, does_use_rooms_to_schedule?: boolean | null, primary_room_pms_id?: string | null, should_default_pims_emails_on: boolean, should_default_pims_sms_on: boolean, should_default_marketing_sms_on: boolean, should_default_marketing_email_on: boolean, does_use_clinicians_to_schedule?: boolean | null, time_slot_minutes: number, sync_interval_minutes: number, long_sync_interval_hours: number, primary_clinician_pms_id?: string | null, cancellation_clinician_pms_id?: string | null, cancellation_service_pms_id?: string | null, allow_first_appt_per_day?: boolean | null, custom_well_description?: string | null, custom_sick_description?: string | null, custom_other_title?: string | null, custom_other_description?: string | null, default_trigger_words?: Array<string> | null, should_use_private_reviews?: boolean | null, notify_clinic_on?: Array<NotifyClinicOn> | null, reminder_send_time_minutes?: number | null, does_require_new_client_address?: boolean | null, does_require_new_client_birthday?: boolean | null, should_allow_new_clients?: boolean | null, should_allow_new_patients?: boolean | null, should_create_clients?: boolean | null, should_create_patients?: boolean | null, msgs_auto_priority?: boolean | null, booking_match_procedure?: BookingMatchProcedure | null, urgency_type?: UrgencyType | null, max_booking_columns?: number | null, hide_closed_days_from_scheduling?: boolean | null, should_sync_reminders?: boolean | null, auto_reply_enabled: boolean, auto_reply_message?: string | null, unreplied_message_alert_enabled: boolean, unreplied_message_alert_minutes: number, comms_writeback_enabled: boolean, comms_should_daily_writeback: boolean, comms_use_pdf_for_writeback: boolean, comms_writeback_buffer_minutes: number, comms_writeback_before_appt_mins: number, comms_should_writeback_on_send: boolean, comms_should_writeback_on_receive: boolean, comms_should_writeback_notifs: boolean, comms_should_use_ai_writeback: boolean, form_writeback_enabled: boolean, should_award_loyalty_for_invoices?: boolean | null, invoice_loyalty_points_per_dollar?: number | null, app_download_loyalty_points?: number | null, referrer_loyalty_points?: number | null, referred_loyalty_points?: number | null, custom_appointment_notes_template?: string | null, custom_new_client_notes_template?: string | null, custom_new_patient_notes_template?: string | null, max_inactivity_duration?: number | null, hide_portal_vaccinations: boolean, hide_portal_reminders: boolean, hide_portal_prescriptions: boolean, hide_portal_weight: boolean, hide_soc_vaccinations?: boolean | null, hide_historic_vaccinations?: boolean | null, should_hide_daily_huddle_financials: boolean, patient_details_tab_order: Array<PortalPatientDetailsTab>, clinic_hours_display?: string | null, reschedule_buffer_minutes?: number | null, cancellation_buffer_minutes?: number | null, require_reason_for_cancellation?: boolean | null, should_automatically_assign_patient?: boolean | null, payment_writeback_enabled: boolean, auto_refund_on_cancel: boolean, status_set_on_payment_completed_pms_id?: string | null, max_booking_notes_length?: number | null, min_booking_notes_length?: number | null, primary_clinic_group_id?: string | null, should_suggest_nearby_clinics?: boolean | null, sms_block_list?: Array<string> | null, exclude_message_wrapper?: boolean | null, should_charge_client_stripe_fees?: boolean | null, chckvet_prescription_fee_split_percentage?: number | null, gtm_container_id?: string | null, review_google_id?: string | null, review_facebook_id?: string | null, only_use_adj_avail_guides: boolean, use_basic_timeslots: boolean, valid_booking_interval_minutes?: Array<number> | null, should_disable_online_scheduling?: boolean | null, simple_scheduling_rules_enabled: boolean, compliance_statuses?: Array<string> | null, should_use_instant_prescription_requests?: boolean | null, prescription_pickup_service_id?: string | null, default_reminder_service_id?: string | null, ai_calls_provider?: PhoneProviderType | null, ai_calls_phone_number?: string | null, ai_calls_voice_id?: string | null, ai_calls_agent_id?: string | null, ai_agent_style?: string | null, ai_agent_custom_instructions?: string | null, ai_calls_ambient_sound?: AiCallsAmbientSound | null, ai_calls_voice_speed?: number | null, ai_calls_interruption_sensitivity?: number | null, ai_calls_enable_dynamic_voice_speed?: boolean | null, usage_spending_caps?: any | null, custom_merge_tags?: any | null, custom_booking_copy?: { __typename?: 'ClinicBookingCopy', WIDGET_HEADER_TITLE?: string | null, SHOW_CLINIC_HEADER_LOGO?: boolean | null, CLINIC_HEADER_LOGO_HEIGHT?: number | null, SERVICE_TYPE_SECTION_HEADING?: string | null, DEFAULT_WELLNESS_DESCRIPTION?: string | null, DEFAULT_SICK_DESCRIPTION?: string | null, DEFAULT_OTHER_DESCRIPTION?: string | null, RETURNING_PATIENT_QUESTION?: string | null, POSITIVE_RETURNING_PATIENT_ANSWER?: string | null, NEGATIVE_RETURNING_PATIENT_ANSWER?: string | null, RETURNING_CLIENT_QUESTION?: string | null, POSITIVE_RETURNING_CLIENT_ANSWER?: string | null, NEGATIVE_RETURNING_CLIENT_ANSWER?: string | null, CLIENT_INFORMATION_SECTION_TITLE?: string | null, PATIENT_INFORMATION_SECTION_TITLE?: string | null, RETURNING_CLIENT_PATIENT_TITLE?: string | null, RETURNING_CLIENT_PATIENT_DESCRIPTION?: string | null, SERVICE_SECTION_TITLE?: string | null, PREPAID_SERVICES_LABEL?: string | null, STANDARD_SERVICES_LABEL?: string | null, DEPOSIT_FEE_NAME?: string | null, PREVIOUS_OR_REFERRING_CLINIC_QUESTION?: string | null, CONTACT_THE_CLINIC_TEXT?: string | null, CONTACT_THE_CLINIC_TEXT_COLOR?: string | null, CONTACT_THE_CLINIC_TEXT_SIZE?: string | null, SELECT_CLINICIAN_TITLE?: string | null, SELECT_CLINICIAN_POSITIVE_ANSWER?: string | null, SELECT_CLINICIAN_NEGATIVE_ANSWER?: string | null, SELECT_TIME_TITLE?: string | null, REVIEW_TITLE?: string | null, REVIEW_NOTES_PROMPT?: string | null, PAYMENT_INFORMATION_TITLE?: string | null, TRIGGER_WORDS_DETECTED_HEADER?: string | null, TRIGGER_WORDS_DETECTED_DESCRIPTION?: string | null, CONFIRMATION_SCREEN_TITLE?: string | null, CONFIRMATION_SCREEN_DESCRIPTION?: string | null, NEW_CLIENT_BLOCKED_MESSAGE?: string | null, NEW_PATIENT_BLOCKED_MESSAGE?: string | null } | null, auto_reply_hours?: { __typename?: 'AvailabilityHours', monday?: Array<{ __typename?: 'TimeInterval', start?: number | null, end?: number | null }> | null, tuesday?: Array<{ __typename?: 'TimeInterval', start?: number | null, end?: number | null }> | null, wednesday?: Array<{ __typename?: 'TimeInterval', start?: number | null, end?: number | null }> | null, thursday?: Array<{ __typename?: 'TimeInterval', start?: number | null, end?: number | null }> | null, friday?: Array<{ __typename?: 'TimeInterval', start?: number | null, end?: number | null }> | null, saturday?: Array<{ __typename?: 'TimeInterval', start?: number | null, end?: number | null }> | null, sunday?: Array<{ __typename?: 'TimeInterval', start?: number | null, end?: number | null }> | null } | null, portal_links?: Array<{ __typename?: 'PortalLink', label: string, url: string }> | null, custom_reviews_copy?: { __typename?: 'ClinicReviewsCopy', REVIEW_METHOD_PAGE_TITLE?: string | null, REVIEW_METHOD_PAGE_DESCRIPTION?: string | null, PRIVATE_REVIEW_BUTTON_HELP_TEXT?: string | null, PRIVATE_REVIEW_BUTTON_TEXT?: string | null, REVIEW_PAGE_TITLE?: string | null, REVIEW_PAGE_SUBTITLE?: string | null, REVIEW_SCORE_LABEL?: string | null, REVIEW_MESSAGE_LABEL?: string | null, REVIEW_SUBMIT_BUTTON_TEXT?: string | null } | null, waitlist_customer_segment?: { __typename?: 'CustomerSegment', id: string, name: string, trigger_entity?: CustomerSegmentTrigger | null, is_archived: boolean, updated_at: number, notification_templates?: Array<{ __typename?: 'NotificationTemplate', id: string, name: string, is_active: boolean, is_archived: boolean, message_methods: Array<MessageMethod> }> | null, error_flags?: Array<{ __typename?: 'CustomerSegmentErrorFlag', filter_column: string, filter_index: number, parameter_index: number, message: string }> | null, all_inclusions?: Array<{ __typename?: 'SegmentFilter', foreign_table?: string | null, group?: string | null, parameters: Array<{ __typename?: 'QueryFilter', column: string, filterOp: FilterOp, value: { __typename?: 'QueryFilterValue', string?: string | null, float?: number | null, boolean?: boolean | null, stringArray?: Array<string> | null, floatArray?: Array<number> | null, millisFromNow?: number | null, relativeTime?: { __typename?: 'RelativeTime', quantity: number, unit: TimeUnit, direction: ReferenceDirection } | null } }> }> | null, any_inclusions?: Array<{ __typename?: 'SegmentFilter', foreign_table?: string | null, group?: string | null, parameters: Array<{ __typename?: 'QueryFilter', column: string, filterOp: FilterOp, value: { __typename?: 'QueryFilterValue', string?: string | null, float?: number | null, boolean?: boolean | null, stringArray?: Array<string> | null, floatArray?: Array<number> | null, millisFromNow?: number | null, relativeTime?: { __typename?: 'RelativeTime', quantity: number, unit: TimeUnit, direction: ReferenceDirection } | null } }> }> | null, any_exclusions?: Array<{ __typename?: 'SegmentFilter', foreign_table?: string | null, group?: string | null, parameters: Array<{ __typename?: 'QueryFilter', column: string, filterOp: FilterOp, value: { __typename?: 'QueryFilterValue', string?: string | null, float?: number | null, boolean?: boolean | null, stringArray?: Array<string> | null, floatArray?: Array<number> | null, millisFromNow?: number | null, relativeTime?: { __typename?: 'RelativeTime', quantity: number, unit: TimeUnit, direction: ReferenceDirection } | null } }> }> | null, any_other_exclusions?: Array<{ __typename?: 'SegmentFilter', foreign_table?: string | null, group?: string | null, parameters: Array<{ __typename?: 'QueryFilter', column: string, filterOp: FilterOp, value: { __typename?: 'QueryFilterValue', string?: string | null, float?: number | null, boolean?: boolean | null, stringArray?: Array<string> | null, floatArray?: Array<number> | null, millisFromNow?: number | null, relativeTime?: { __typename?: 'RelativeTime', quantity: number, unit: TimeUnit, direction: ReferenceDirection } | null } }> }> | null, filters?: Array<{ __typename?: 'CustomerSegmentFilter', filters: Array<{ __typename?: 'QueryFilter', column: string, filterOp: FilterOp, value: { __typename?: 'QueryFilterValue', string?: string | null, float?: number | null, boolean?: boolean | null, stringArray?: Array<string> | null, floatArray?: Array<number> | null, millisFromNow?: number | null, relativeTime?: { __typename?: 'RelativeTime', quantity: number, unit: TimeUnit, direction: ReferenceDirection } | null } }> }> | null, excluded_filters: Array<{ __typename?: 'CustomerSegmentFilter', filters: Array<{ __typename?: 'QueryFilter', column: string, filterOp: FilterOp, value: { __typename?: 'QueryFilterValue', string?: string | null, float?: number | null, boolean?: boolean | null, stringArray?: Array<string> | null, floatArray?: Array<number> | null, millisFromNow?: number | null, relativeTime?: { __typename?: 'RelativeTime', quantity: number, unit: TimeUnit, direction: ReferenceDirection } | null } }> }> } | null, blocklist_customer_segment?: { __typename?: 'CustomerSegment', id: string, name: string, trigger_entity?: CustomerSegmentTrigger | null, is_archived: boolean, updated_at: number, notification_templates?: Array<{ __typename?: 'NotificationTemplate', id: string, name: string, is_active: boolean, is_archived: boolean, message_methods: Array<MessageMethod> }> | null, error_flags?: Array<{ __typename?: 'CustomerSegmentErrorFlag', filter_column: string, filter_index: number, parameter_index: number, message: string }> | null, all_inclusions?: Array<{ __typename?: 'SegmentFilter', foreign_table?: string | null, group?: string | null, parameters: Array<{ __typename?: 'QueryFilter', column: string, filterOp: FilterOp, value: { __typename?: 'QueryFilterValue', string?: string | null, float?: number | null, boolean?: boolean | null, stringArray?: Array<string> | null, floatArray?: Array<number> | null, millisFromNow?: number | null, relativeTime?: { __typename?: 'RelativeTime', quantity: number, unit: TimeUnit, direction: ReferenceDirection } | null } }> }> | null, any_inclusions?: Array<{ __typename?: 'SegmentFilter', foreign_table?: string | null, group?: string | null, parameters: Array<{ __typename?: 'QueryFilter', column: string, filterOp: FilterOp, value: { __typename?: 'QueryFilterValue', string?: string | null, float?: number | null, boolean?: boolean | null, stringArray?: Array<string> | null, floatArray?: Array<number> | null, millisFromNow?: number | null, relativeTime?: { __typename?: 'RelativeTime', quantity: number, unit: TimeUnit, direction: ReferenceDirection } | null } }> }> | null, any_exclusions?: Array<{ __typename?: 'SegmentFilter', foreign_table?: string | null, group?: string | null, parameters: Array<{ __typename?: 'QueryFilter', column: string, filterOp: FilterOp, value: { __typename?: 'QueryFilterValue', string?: string | null, float?: number | null, boolean?: boolean | null, stringArray?: Array<string> | null, floatArray?: Array<number> | null, millisFromNow?: number | null, relativeTime?: { __typename?: 'RelativeTime', quantity: number, unit: TimeUnit, direction: ReferenceDirection } | null } }> }> | null, any_other_exclusions?: Array<{ __typename?: 'SegmentFilter', foreign_table?: string | null, group?: string | null, parameters: Array<{ __typename?: 'QueryFilter', column: string, filterOp: FilterOp, value: { __typename?: 'QueryFilterValue', string?: string | null, float?: number | null, boolean?: boolean | null, stringArray?: Array<string> | null, floatArray?: Array<number> | null, millisFromNow?: number | null, relativeTime?: { __typename?: 'RelativeTime', quantity: number, unit: TimeUnit, direction: ReferenceDirection } | null } }> }> | null, filters?: Array<{ __typename?: 'CustomerSegmentFilter', filters: Array<{ __typename?: 'QueryFilter', column: string, filterOp: FilterOp, value: { __typename?: 'QueryFilterValue', string?: string | null, float?: number | null, boolean?: boolean | null, stringArray?: Array<string> | null, floatArray?: Array<number> | null, millisFromNow?: number | null, relativeTime?: { __typename?: 'RelativeTime', quantity: number, unit: TimeUnit, direction: ReferenceDirection } | null } }> }> | null, excluded_filters: Array<{ __typename?: 'CustomerSegmentFilter', filters: Array<{ __typename?: 'QueryFilter', column: string, filterOp: FilterOp, value: { __typename?: 'QueryFilterValue', string?: string | null, float?: number | null, boolean?: boolean | null, stringArray?: Array<string> | null, floatArray?: Array<number> | null, millisFromNow?: number | null, relativeTime?: { __typename?: 'RelativeTime', quantity: number, unit: TimeUnit, direction: ReferenceDirection } | null } }> }> } | null, referral_customer_segment?: { __typename?: 'CustomerSegment', id: string, name: string, trigger_entity?: CustomerSegmentTrigger | null, is_archived: boolean, updated_at: number, notification_templates?: Array<{ __typename?: 'NotificationTemplate', id: string, name: string, is_active: boolean, is_archived: boolean, message_methods: Array<MessageMethod> }> | null, error_flags?: Array<{ __typename?: 'CustomerSegmentErrorFlag', filter_column: string, filter_index: number, parameter_index: number, message: string }> | null, all_inclusions?: Array<{ __typename?: 'SegmentFilter', foreign_table?: string | null, group?: string | null, parameters: Array<{ __typename?: 'QueryFilter', column: string, filterOp: FilterOp, value: { __typename?: 'QueryFilterValue', string?: string | null, float?: number | null, boolean?: boolean | null, stringArray?: Array<string> | null, floatArray?: Array<number> | null, millisFromNow?: number | null, relativeTime?: { __typename?: 'RelativeTime', quantity: number, unit: TimeUnit, direction: ReferenceDirection } | null } }> }> | null, any_inclusions?: Array<{ __typename?: 'SegmentFilter', foreign_table?: string | null, group?: string | null, parameters: Array<{ __typename?: 'QueryFilter', column: string, filterOp: FilterOp, value: { __typename?: 'QueryFilterValue', string?: string | null, float?: number | null, boolean?: boolean | null, stringArray?: Array<string> | null, floatArray?: Array<number> | null, millisFromNow?: number | null, relativeTime?: { __typename?: 'RelativeTime', quantity: number, unit: TimeUnit, direction: ReferenceDirection } | null } }> }> | null, any_exclusions?: Array<{ __typename?: 'SegmentFilter', foreign_table?: string | null, group?: string | null, parameters: Array<{ __typename?: 'QueryFilter', column: string, filterOp: FilterOp, value: { __typename?: 'QueryFilterValue', string?: string | null, float?: number | null, boolean?: boolean | null, stringArray?: Array<string> | null, floatArray?: Array<number> | null, millisFromNow?: number | null, relativeTime?: { __typename?: 'RelativeTime', quantity: number, unit: TimeUnit, direction: ReferenceDirection } | null } }> }> | null, any_other_exclusions?: Array<{ __typename?: 'SegmentFilter', foreign_table?: string | null, group?: string | null, parameters: Array<{ __typename?: 'QueryFilter', column: string, filterOp: FilterOp, value: { __typename?: 'QueryFilterValue', string?: string | null, float?: number | null, boolean?: boolean | null, stringArray?: Array<string> | null, floatArray?: Array<number> | null, millisFromNow?: number | null, relativeTime?: { __typename?: 'RelativeTime', quantity: number, unit: TimeUnit, direction: ReferenceDirection } | null } }> }> | null, filters?: Array<{ __typename?: 'CustomerSegmentFilter', filters: Array<{ __typename?: 'QueryFilter', column: string, filterOp: FilterOp, value: { __typename?: 'QueryFilterValue', string?: string | null, float?: number | null, boolean?: boolean | null, stringArray?: Array<string> | null, floatArray?: Array<number> | null, millisFromNow?: number | null, relativeTime?: { __typename?: 'RelativeTime', quantity: number, unit: TimeUnit, direction: ReferenceDirection } | null } }> }> | null, excluded_filters: Array<{ __typename?: 'CustomerSegmentFilter', filters: Array<{ __typename?: 'QueryFilter', column: string, filterOp: FilterOp, value: { __typename?: 'QueryFilterValue', string?: string | null, float?: number | null, boolean?: boolean | null, stringArray?: Array<string> | null, floatArray?: Array<number> | null, millisFromNow?: number | null, relativeTime?: { __typename?: 'RelativeTime', quantity: number, unit: TimeUnit, direction: ReferenceDirection } | null } }> }> } | null, webhooks?: Array<{ __typename?: 'WebhookConfig', id: string, name: string, url: string, events: Array<WebhookEventType>, secret?: string | null, enabled: boolean }> | null, times_first_filter_config?: { __typename?: 'TimesFirstFilterConfig', service?: BookingFilterDisplayMode | null, clinician?: BookingFilterDisplayMode | null, species?: BookingFilterDisplayMode | null, client_status?: BookingFilterDisplayMode | null, patient_status?: BookingFilterDisplayMode | null, patient_gender?: BookingFilterDisplayMode | null, fixed_status?: BookingFilterDisplayMode | null } | null } | null, onboarding?: { __typename?: 'ClinicOnboarding', has_set_hours?: boolean | null, has_synced_pms?: boolean | null } | null, organization?: { __typename?: 'Organization', id: string } | null, features?: { __typename?: 'ClinicFeatures', scheduling_enabled?: boolean | null, huddle_enabled?: boolean | null, payments_enabled?: boolean | null, messaging_enabled?: boolean | null, reviews_enabled?: boolean | null, loyalty_enabled?: boolean | null, notifs_enabled?: boolean | null, forms_enabled?: boolean | null, help_enabled?: boolean | null, bulk_messaging_enabled?: boolean | null, portal_enabled?: boolean | null, calls_enabled?: boolean | null, teamchat_enabled?: boolean | null, prescriptions_enabled?: boolean | null, medical_history_enabled?: boolean | null, pet_selfies_enabled?: boolean | null } | null, hours?: { __typename?: 'AvailabilityHours', monday?: Array<{ __typename?: 'TimeInterval', start?: number | null, end?: number | null }> | null, tuesday?: Array<{ __typename?: 'TimeInterval', start?: number | null, end?: number | null }> | null, wednesday?: Array<{ __typename?: 'TimeInterval', start?: number | null, end?: number | null }> | null, thursday?: Array<{ __typename?: 'TimeInterval', start?: number | null, end?: number | null }> | null, friday?: Array<{ __typename?: 'TimeInterval', start?: number | null, end?: number | null }> | null, saturday?: Array<{ __typename?: 'TimeInterval', start?: number | null, end?: number | null }> | null, sunday?: Array<{ __typename?: 'TimeInterval', start?: number | null, end?: number | null }> | null } | null, clinic_hours?: { __typename?: 'AvailabilityHours', monday?: Array<{ __typename?: 'TimeInterval', start?: number | null, end?: number | null }> | null, tuesday?: Array<{ __typename?: 'TimeInterval', start?: number | null, end?: number | null }> | null, wednesday?: Array<{ __typename?: 'TimeInterval', start?: number | null, end?: number | null }> | null, thursday?: Array<{ __typename?: 'TimeInterval', start?: number | null, end?: number | null }> | null, friday?: Array<{ __typename?: 'TimeInterval', start?: number | null, end?: number | null }> | null, saturday?: Array<{ __typename?: 'TimeInterval', start?: number | null, end?: number | null }> | null, sunday?: Array<{ __typename?: 'TimeInterval', start?: number | null, end?: number | null }> | null } | null, adjusted_availability?: Array<{ __typename?: 'Availability', date: number, pms_appt_type_pms_id?: string | null, times: Array<{ __typename?: 'TimeInterval', start?: number | null, end?: number | null }>, repeat?: { __typename?: 'RepeatAvailability', daysOfMonth?: Array<number> | null, daysOfWeek?: Array<DayOfWeek> | null, weekOfMonth?: WeekOfMonth | null, frequency: any, unit: RepeatUnit, end_date?: number | null } | null }> | null, pms_adjusted_availability?: Array<{ __typename?: 'Availability', date: number, pms_appt_type_pms_id?: string | null, times: Array<{ __typename?: 'TimeInterval', start?: number | null, end?: number | null }>, repeat?: { __typename?: 'RepeatAvailability', daysOfMonth?: Array<number> | null, daysOfWeek?: Array<DayOfWeek> | null, weekOfMonth?: WeekOfMonth | null, frequency: any, unit: RepeatUnit, end_date?: number | null } | null }> | null, last_sync_times?: { __typename?: 'LastSyncTimes', last_full_sync?: number | null, last_sync_appointments?: number | null, last_sync_clients?: number | null, last_sync_patients?: number | null, last_sync_clinicians?: number | null, last_sync_services?: number | null, last_sync_transactions?: number | null, last_sync_invoices?: number | null, last_sync_history_items?: number | null, last_sync_diagnoses?: number | null, last_sync_prescriptions?: number | null, last_sync_products?: number | null, last_sync_rooms?: number | null, last_sync_species?: number | null, last_sync_breeds?: number | null, last_sync_reminders?: number | null, last_sync_reminder_types?: number | null, last_sync_vaccination_records?: number | null, last_sync_clinic_sexes?: number | null, last_sync_appt_statuses?: number | null, last_sync_blockoffs?: number | null, last_sync_invoice_items?: number | null } | null, pims_settings?: { __typename?: 'PimsSettings', ezyvet_integration_mode?: EzyvetIntegrationMode | null, entered_by_pms_id?: string | null } | null }> };

export type CountClinicAdminClinicsQueryVariables = Exact<{
  userId: Scalars['ID']['input'];
  where?: InputMaybe<Array<QueryInput> | QueryInput>;
}>;


export type CountClinicAdminClinicsQuery = { __typename?: 'Query', countClinicAdminClinics: number };

export type GetClinicAccessForUserQueryVariables = Exact<{
  clinicId: Scalars['ID']['input'];
  userId: Scalars['ID']['input'];
}>;


export type GetClinicAccessForUserQuery = { __typename?: 'Query', clinicAccessForUser?: { __typename?: 'ClinicAccess', role: AuthRoles, source: ClinicAccessSource, permissions: Array<{ __typename?: 'ClinicAdminPermission', feature: AdminPermissionFeature, access_level: AdminPermissionAccessLevel }> } | null };

export type ClinicAgentEnabledQueryVariables = Exact<{
  clinicId: Scalars['ID']['input'];
}>;


export type ClinicAgentEnabledQuery = { __typename?: 'Query', clinicAgentEnabled: boolean };

export type MyClinicAgentConversationsQueryVariables = Exact<{
  clinicId: Scalars['ID']['input'];
  limit?: InputMaybe<Scalars['NonNegativeInt']['input']>;
}>;


export type MyClinicAgentConversationsQuery = { __typename?: 'Query', myClinicAgentConversations: Array<{ __typename?: 'SupportBotConversation', id: string, title: string, createdAt: number, updatedAt: number, pendingRunId?: string | null, owner?: { __typename?: 'SupportBotConversationOwner', id: string, name?: string | null, email?: string | null } | null, messages: Array<{ __typename?: 'SupportBotMessage', role: SupportBotMessageRole, content: string, timestamp: number, status?: SupportBotMessageStatus | null, cutoffReason?: string | null, attachments: Array<{ __typename?: 'SupportBotMessageAttachment', url: string, kind: SupportBotAttachmentKind, mimeType: string, width?: number | null, height?: number | null, filename?: string | null }> }> }> };

export type ClinicAgentConversationQueryVariables = Exact<{
  clinicId: Scalars['ID']['input'];
  id: Scalars['ID']['input'];
}>;


export type ClinicAgentConversationQuery = { __typename?: 'Query', clinicAgentConversation?: { __typename?: 'SupportBotConversation', id: string, title: string, createdAt: number, updatedAt: number, pendingRunId?: string | null, owner?: { __typename?: 'SupportBotConversationOwner', id: string, name?: string | null, email?: string | null } | null, messages: Array<{ __typename?: 'SupportBotMessage', role: SupportBotMessageRole, content: string, timestamp: number, status?: SupportBotMessageStatus | null, cutoffReason?: string | null, attachments: Array<{ __typename?: 'SupportBotMessageAttachment', url: string, kind: SupportBotAttachmentKind, mimeType: string, width?: number | null, height?: number | null, filename?: string | null }> }> } | null };

export type ClinicAgentRunStatusQueryVariables = Exact<{
  clinicId: Scalars['ID']['input'];
  runId: Scalars['ID']['input'];
}>;


export type ClinicAgentRunStatusQuery = { __typename?: 'Query', clinicAgentRunStatus: { __typename?: 'SupportBotRunSnapshot', runId: string, conversationId: string, status: SupportBotRunStatus, startedAt: number, assistantTextSoFar: string, toolCallCount: number, approxTokens: number, finishedAt?: number | null, durationMs?: number | null, response?: string | null, cutoffReason?: string | null, errorMessage?: string | null, cursorRunId?: string | null, conversation?: { __typename?: 'SupportBotConversation', id: string, title: string, createdAt: number, updatedAt: number, pendingRunId?: string | null, owner?: { __typename?: 'SupportBotConversationOwner', id: string, name?: string | null, email?: string | null } | null, messages: Array<{ __typename?: 'SupportBotMessage', role: SupportBotMessageRole, content: string, timestamp: number, status?: SupportBotMessageStatus | null, cutoffReason?: string | null, attachments: Array<{ __typename?: 'SupportBotMessageAttachment', url: string, kind: SupportBotAttachmentKind, mimeType: string, width?: number | null, height?: number | null, filename?: string | null }> }> } | null } };

export type MintClinicAgentSessionMutationVariables = Exact<{
  clinicId: Scalars['ID']['input'];
}>;


export type MintClinicAgentSessionMutation = { __typename?: 'Mutation', mintClinicAgentSession: { __typename?: 'ClinicAgentSession', token: string, expiresAt: number } };

export type SendClinicAgentMessageMutationVariables = Exact<{
  input: SendClinicAgentMessageInput;
}>;


export type SendClinicAgentMessageMutation = { __typename?: 'Mutation', sendClinicAgentMessage: { __typename?: 'SupportBotMessageStarted', runId: string, conversationId: string, status: SupportBotRunStatus, conversation: { __typename?: 'SupportBotConversation', id: string, title: string, createdAt: number, updatedAt: number, pendingRunId?: string | null, owner?: { __typename?: 'SupportBotConversationOwner', id: string, name?: string | null, email?: string | null } | null, messages: Array<{ __typename?: 'SupportBotMessage', role: SupportBotMessageRole, content: string, timestamp: number, status?: SupportBotMessageStatus | null, cutoffReason?: string | null, attachments: Array<{ __typename?: 'SupportBotMessageAttachment', url: string, kind: SupportBotAttachmentKind, mimeType: string, width?: number | null, height?: number | null, filename?: string | null }> }> } } };

export type YesterdayAnalyticsFieldsFragment = { __typename?: 'YesterdayAnalytics', revenue: number, new_clients_count: number, new_patients_count: number, schedule_efficiency: number, monthly_revenue_completed: number, monthly_appointments_scheduled: number, last_month_average_revenue_per_appointment: number, appointments: Array<{ __typename?: 'Appointment', id: string, pms_id?: string | null, status: AppointmentStatus, service_name?: string | null, start_time: number, drop_off_time?: number | null, minutes: number, is_deleted?: boolean | null, is_time_block?: boolean | null, is_new_patient?: boolean | null, is_new_client?: boolean | null, is_confirmed?: boolean | null, new_patient_species?: string | null, reason_for_cancellation?: string | null, client_reason_for_cancellation?: string | null, confirmed_at?: number | null, is_clinician_auto_assigned?: boolean | null, client_notes?: string | null, clinic_notes?: string | null, referring_clinic_name?: string | null, widget_source?: string | null, from_widget?: string | null, pms_created_at?: number | null, clinic_appt_status?: { __typename?: 'ClinicApptStatus', id: string, status: AppointmentStatus, description: string } | null, service?: { __typename?: 'Service', id: string, color?: string | null, name?: string | null } | null, clinician?: { __typename?: 'Clinician', id: string, name: string, display_name?: string | null } | null, room?: { __typename?: 'Room', id: string, name: string } | null, clinic?: { __typename?: 'Clinic', id: string, name?: string | null, slug?: string | null, pms_db?: { __typename?: 'PmsDb', id: string } | null } | null, client?: { __typename?: 'Client', id: string, first_name?: string | null, last_name?: string | null, email?: string | null, phone?: string | null, is_active?: boolean | null, address?: { __typename?: 'Address', street_a?: string | null, country?: string | null } | null } | null, patient?: { __typename?: 'Patient', id: string, pms_id?: string | null, name?: string | null, breed?: string | null, is_active?: boolean | null, is_deceased?: boolean | null, avatar_url?: string | null, gender?: string | null, fixed_status?: FixedStatus | null, birthday?: number | null, weight?: number | null, owner?: { __typename?: 'Client', id: string, first_name?: string | null, last_name?: string | null, secondary_first_name?: string | null, secondary_last_name?: string | null, phone?: string | null, email?: string | null } | null, clinic_species?: { __typename?: 'ClinicSpecies', id: string, species: Species, description: string, weight_key: string } | null, clinic_breed?: { __typename?: 'Breed', id: string, description: string } | null } | null, widget?: { __typename?: 'Widget', id: string, widget_name: string } | null }>, non_forward_scheduled_patients: Array<{ __typename?: 'Patient', id: string, pms?: PracticeManagementSystem | null, pms_id?: string | null, name?: string | null, breed?: string | null, avatar_url?: string | null, last_appt_time?: number | null, gender?: string | null, fixed_status?: FixedStatus | null, weight?: number | null, birthday?: number | null, is_active?: boolean | null, is_deceased?: boolean | null, pms_created_at?: number | null, created_at: number, updated_at: number, owner?: { __typename?: 'Client', id: string, first_name?: string | null, last_name?: string | null, email?: string | null, phone?: string | null, address?: { __typename?: 'Address', country?: string | null } | null } | null, clinic_species?: { __typename?: 'ClinicSpecies', id: string, pms_id: string, description: string, is_primary: boolean, species: Species, weight_key: string, created_at: number, updated_at: number } | null, clinic?: { __typename?: 'Clinic', id: string } | null, clinic_breed?: { __typename?: 'Breed', id: string, description: string } | null, patient_vaccination_records?: Array<{ __typename?: 'PatientVaccinationRecord', id: string, vaccine_name?: string | null, manufacturer?: string | null, lot_number?: string | null, administered_date?: number | null, due_date?: number | null, rabies_tag?: string | null, is_rabies_vaccine?: boolean | null, is_soc: boolean, is_active: boolean, product?: { __typename?: 'Product', id: string, display_name?: string | null, name: string } | null }> | null, last_appointment?: { __typename?: 'Appointment', clinician?: { __typename?: 'Clinician', name: string, display_name?: string | null } | null } | null }>, revenue_by_clinician: Array<{ __typename?: 'RevenueByClinician', revenue: number, clinician: { __typename?: 'Clinician', id: string, name: string } }> };

export type RevenueByClinicianFieldsFragment = { __typename?: 'RevenueByClinician', revenue: number, clinician: { __typename?: 'Clinician', id: string, name: string } };

export type TodayAnalyticsFieldsFragment = { __typename?: 'TodayAnalytics', unpaid_invoices_total: number, unpaid_invoices_count: number, appointments: Array<{ __typename?: 'Appointment', id: string, pms_id?: string | null, status: AppointmentStatus, service_name?: string | null, start_time: number, drop_off_time?: number | null, minutes: number, is_deleted?: boolean | null, is_time_block?: boolean | null, is_new_patient?: boolean | null, is_new_client?: boolean | null, is_confirmed?: boolean | null, new_patient_species?: string | null, reason_for_cancellation?: string | null, client_reason_for_cancellation?: string | null, confirmed_at?: number | null, is_clinician_auto_assigned?: boolean | null, client_notes?: string | null, clinic_notes?: string | null, referring_clinic_name?: string | null, widget_source?: string | null, from_widget?: string | null, pms_created_at?: number | null, clinic_appt_status?: { __typename?: 'ClinicApptStatus', id: string, status: AppointmentStatus, description: string } | null, service?: { __typename?: 'Service', id: string, color?: string | null, name?: string | null } | null, clinician?: { __typename?: 'Clinician', id: string, name: string, display_name?: string | null } | null, room?: { __typename?: 'Room', id: string, name: string } | null, clinic?: { __typename?: 'Clinic', id: string, name?: string | null, slug?: string | null, pms_db?: { __typename?: 'PmsDb', id: string } | null } | null, client?: { __typename?: 'Client', id: string, first_name?: string | null, last_name?: string | null, email?: string | null, phone?: string | null, is_active?: boolean | null, has_portal_account: boolean, has_mobile_app: boolean, address?: { __typename?: 'Address', street_a?: string | null, country?: string | null } | null } | null, patient?: { __typename?: 'Patient', id: string, pms_id?: string | null, name?: string | null, breed?: string | null, is_active?: boolean | null, is_deceased?: boolean | null, avatar_url?: string | null, gender?: string | null, fixed_status?: FixedStatus | null, birthday?: number | null, weight?: number | null, owner?: { __typename?: 'Client', id: string, first_name?: string | null, last_name?: string | null, secondary_first_name?: string | null, secondary_last_name?: string | null, phone?: string | null, email?: string | null } | null, clinic_species?: { __typename?: 'ClinicSpecies', id: string, species: Species, description: string, weight_key: string } | null, clinic_breed?: { __typename?: 'Breed', id: string, description: string } | null } | null, widget?: { __typename?: 'Widget', id: string, widget_name: string } | null }> };

export type TomorrowAnalyticsFieldsFragment = { __typename?: 'TomorrowAnalytics', appointments: Array<{ __typename?: 'Appointment', id: string, pms_id?: string | null, status: AppointmentStatus, service_name?: string | null, start_time: number, drop_off_time?: number | null, minutes: number, is_deleted?: boolean | null, is_time_block?: boolean | null, is_new_patient?: boolean | null, is_new_client?: boolean | null, is_confirmed?: boolean | null, new_patient_species?: string | null, reason_for_cancellation?: string | null, client_reason_for_cancellation?: string | null, confirmed_at?: number | null, is_clinician_auto_assigned?: boolean | null, client_notes?: string | null, clinic_notes?: string | null, referring_clinic_name?: string | null, widget_source?: string | null, from_widget?: string | null, pms_created_at?: number | null, clinic_appt_status?: { __typename?: 'ClinicApptStatus', id: string, status: AppointmentStatus, description: string } | null, service?: { __typename?: 'Service', id: string, color?: string | null, name?: string | null } | null, clinician?: { __typename?: 'Clinician', id: string, name: string, display_name?: string | null } | null, room?: { __typename?: 'Room', id: string, name: string } | null, clinic?: { __typename?: 'Clinic', id: string, name?: string | null, slug?: string | null, pms_db?: { __typename?: 'PmsDb', id: string } | null } | null, client?: { __typename?: 'Client', id: string, first_name?: string | null, last_name?: string | null, email?: string | null, phone?: string | null, is_active?: boolean | null, has_portal_account: boolean, has_mobile_app: boolean, address?: { __typename?: 'Address', street_a?: string | null, country?: string | null } | null } | null, patient?: { __typename?: 'Patient', id: string, pms_id?: string | null, name?: string | null, breed?: string | null, is_active?: boolean | null, is_deceased?: boolean | null, avatar_url?: string | null, gender?: string | null, fixed_status?: FixedStatus | null, birthday?: number | null, weight?: number | null, owner?: { __typename?: 'Client', id: string, first_name?: string | null, last_name?: string | null, secondary_first_name?: string | null, secondary_last_name?: string | null, phone?: string | null, email?: string | null } | null, clinic_species?: { __typename?: 'ClinicSpecies', id: string, species: Species, description: string, weight_key: string } | null, clinic_breed?: { __typename?: 'Breed', id: string, description: string } | null } | null, widget?: { __typename?: 'Widget', id: string, widget_name: string } | null }> };

export type GetYesterdayAnalyticsQueryVariables = Exact<{
  clinicId: Scalars['ID']['input'];
  fromDate: Scalars['NonNegativeInt']['input'];
  toDate: Scalars['NonNegativeInt']['input'];
}>;


export type GetYesterdayAnalyticsQuery = { __typename?: 'Query', yesterdayAnalytics: { __typename?: 'YesterdayAnalytics', revenue: number, new_clients_count: number, new_patients_count: number, schedule_efficiency: number, monthly_revenue_completed: number, monthly_appointments_scheduled: number, last_month_average_revenue_per_appointment: number, appointments: Array<{ __typename?: 'Appointment', id: string, pms_id?: string | null, status: AppointmentStatus, service_name?: string | null, start_time: number, drop_off_time?: number | null, minutes: number, is_deleted?: boolean | null, is_time_block?: boolean | null, is_new_patient?: boolean | null, is_new_client?: boolean | null, is_confirmed?: boolean | null, new_patient_species?: string | null, reason_for_cancellation?: string | null, client_reason_for_cancellation?: string | null, confirmed_at?: number | null, is_clinician_auto_assigned?: boolean | null, client_notes?: string | null, clinic_notes?: string | null, referring_clinic_name?: string | null, widget_source?: string | null, from_widget?: string | null, pms_created_at?: number | null, clinic_appt_status?: { __typename?: 'ClinicApptStatus', id: string, status: AppointmentStatus, description: string } | null, service?: { __typename?: 'Service', id: string, color?: string | null, name?: string | null } | null, clinician?: { __typename?: 'Clinician', id: string, name: string, display_name?: string | null } | null, room?: { __typename?: 'Room', id: string, name: string } | null, clinic?: { __typename?: 'Clinic', id: string, name?: string | null, slug?: string | null, pms_db?: { __typename?: 'PmsDb', id: string } | null } | null, client?: { __typename?: 'Client', id: string, first_name?: string | null, last_name?: string | null, email?: string | null, phone?: string | null, is_active?: boolean | null, address?: { __typename?: 'Address', street_a?: string | null, country?: string | null } | null } | null, patient?: { __typename?: 'Patient', id: string, pms_id?: string | null, name?: string | null, breed?: string | null, is_active?: boolean | null, is_deceased?: boolean | null, avatar_url?: string | null, gender?: string | null, fixed_status?: FixedStatus | null, birthday?: number | null, weight?: number | null, owner?: { __typename?: 'Client', id: string, first_name?: string | null, last_name?: string | null, secondary_first_name?: string | null, secondary_last_name?: string | null, phone?: string | null, email?: string | null } | null, clinic_species?: { __typename?: 'ClinicSpecies', id: string, species: Species, description: string, weight_key: string } | null, clinic_breed?: { __typename?: 'Breed', id: string, description: string } | null } | null, widget?: { __typename?: 'Widget', id: string, widget_name: string } | null }>, non_forward_scheduled_patients: Array<{ __typename?: 'Patient', id: string, pms?: PracticeManagementSystem | null, pms_id?: string | null, name?: string | null, breed?: string | null, avatar_url?: string | null, last_appt_time?: number | null, gender?: string | null, fixed_status?: FixedStatus | null, weight?: number | null, birthday?: number | null, is_active?: boolean | null, is_deceased?: boolean | null, pms_created_at?: number | null, created_at: number, updated_at: number, owner?: { __typename?: 'Client', id: string, first_name?: string | null, last_name?: string | null, email?: string | null, phone?: string | null, address?: { __typename?: 'Address', country?: string | null } | null } | null, clinic_species?: { __typename?: 'ClinicSpecies', id: string, pms_id: string, description: string, is_primary: boolean, species: Species, weight_key: string, created_at: number, updated_at: number } | null, clinic?: { __typename?: 'Clinic', id: string } | null, clinic_breed?: { __typename?: 'Breed', id: string, description: string } | null, patient_vaccination_records?: Array<{ __typename?: 'PatientVaccinationRecord', id: string, vaccine_name?: string | null, manufacturer?: string | null, lot_number?: string | null, administered_date?: number | null, due_date?: number | null, rabies_tag?: string | null, is_rabies_vaccine?: boolean | null, is_soc: boolean, is_active: boolean, product?: { __typename?: 'Product', id: string, display_name?: string | null, name: string } | null }> | null, last_appointment?: { __typename?: 'Appointment', clinician?: { __typename?: 'Clinician', name: string, display_name?: string | null } | null } | null }>, revenue_by_clinician: Array<{ __typename?: 'RevenueByClinician', revenue: number, clinician: { __typename?: 'Clinician', id: string, name: string } }> } };

export type GetTodayAnalyticsQueryVariables = Exact<{
  clinicId: Scalars['ID']['input'];
  fromDate: Scalars['NonNegativeInt']['input'];
  toDate: Scalars['NonNegativeInt']['input'];
}>;


export type GetTodayAnalyticsQuery = { __typename?: 'Query', todayAnalytics: { __typename?: 'TodayAnalytics', unpaid_invoices_total: number, unpaid_invoices_count: number, appointments: Array<{ __typename?: 'Appointment', id: string, pms_id?: string | null, status: AppointmentStatus, service_name?: string | null, start_time: number, drop_off_time?: number | null, minutes: number, is_deleted?: boolean | null, is_time_block?: boolean | null, is_new_patient?: boolean | null, is_new_client?: boolean | null, is_confirmed?: boolean | null, new_patient_species?: string | null, reason_for_cancellation?: string | null, client_reason_for_cancellation?: string | null, confirmed_at?: number | null, is_clinician_auto_assigned?: boolean | null, client_notes?: string | null, clinic_notes?: string | null, referring_clinic_name?: string | null, widget_source?: string | null, from_widget?: string | null, pms_created_at?: number | null, clinic_appt_status?: { __typename?: 'ClinicApptStatus', id: string, status: AppointmentStatus, description: string } | null, service?: { __typename?: 'Service', id: string, color?: string | null, name?: string | null } | null, clinician?: { __typename?: 'Clinician', id: string, name: string, display_name?: string | null } | null, room?: { __typename?: 'Room', id: string, name: string } | null, clinic?: { __typename?: 'Clinic', id: string, name?: string | null, slug?: string | null, pms_db?: { __typename?: 'PmsDb', id: string } | null } | null, client?: { __typename?: 'Client', id: string, first_name?: string | null, last_name?: string | null, email?: string | null, phone?: string | null, is_active?: boolean | null, has_portal_account: boolean, has_mobile_app: boolean, address?: { __typename?: 'Address', street_a?: string | null, country?: string | null } | null } | null, patient?: { __typename?: 'Patient', id: string, pms_id?: string | null, name?: string | null, breed?: string | null, is_active?: boolean | null, is_deceased?: boolean | null, avatar_url?: string | null, gender?: string | null, fixed_status?: FixedStatus | null, birthday?: number | null, weight?: number | null, owner?: { __typename?: 'Client', id: string, first_name?: string | null, last_name?: string | null, secondary_first_name?: string | null, secondary_last_name?: string | null, phone?: string | null, email?: string | null } | null, clinic_species?: { __typename?: 'ClinicSpecies', id: string, species: Species, description: string, weight_key: string } | null, clinic_breed?: { __typename?: 'Breed', id: string, description: string } | null } | null, widget?: { __typename?: 'Widget', id: string, widget_name: string } | null }> } };

export type GetTomorrowAnalyticsQueryVariables = Exact<{
  clinicId: Scalars['ID']['input'];
  fromDate: Scalars['NonNegativeInt']['input'];
  toDate: Scalars['NonNegativeInt']['input'];
}>;


export type GetTomorrowAnalyticsQuery = { __typename?: 'Query', tomorrowAnalytics: { __typename?: 'TomorrowAnalytics', appointments: Array<{ __typename?: 'Appointment', id: string, pms_id?: string | null, status: AppointmentStatus, service_name?: string | null, start_time: number, drop_off_time?: number | null, minutes: number, is_deleted?: boolean | null, is_time_block?: boolean | null, is_new_patient?: boolean | null, is_new_client?: boolean | null, is_confirmed?: boolean | null, new_patient_species?: string | null, reason_for_cancellation?: string | null, client_reason_for_cancellation?: string | null, confirmed_at?: number | null, is_clinician_auto_assigned?: boolean | null, client_notes?: string | null, clinic_notes?: string | null, referring_clinic_name?: string | null, widget_source?: string | null, from_widget?: string | null, pms_created_at?: number | null, clinic_appt_status?: { __typename?: 'ClinicApptStatus', id: string, status: AppointmentStatus, description: string } | null, service?: { __typename?: 'Service', id: string, color?: string | null, name?: string | null } | null, clinician?: { __typename?: 'Clinician', id: string, name: string, display_name?: string | null } | null, room?: { __typename?: 'Room', id: string, name: string } | null, clinic?: { __typename?: 'Clinic', id: string, name?: string | null, slug?: string | null, pms_db?: { __typename?: 'PmsDb', id: string } | null } | null, client?: { __typename?: 'Client', id: string, first_name?: string | null, last_name?: string | null, email?: string | null, phone?: string | null, is_active?: boolean | null, has_portal_account: boolean, has_mobile_app: boolean, address?: { __typename?: 'Address', street_a?: string | null, country?: string | null } | null } | null, patient?: { __typename?: 'Patient', id: string, pms_id?: string | null, name?: string | null, breed?: string | null, is_active?: boolean | null, is_deceased?: boolean | null, avatar_url?: string | null, gender?: string | null, fixed_status?: FixedStatus | null, birthday?: number | null, weight?: number | null, owner?: { __typename?: 'Client', id: string, first_name?: string | null, last_name?: string | null, secondary_first_name?: string | null, secondary_last_name?: string | null, phone?: string | null, email?: string | null } | null, clinic_species?: { __typename?: 'ClinicSpecies', id: string, species: Species, description: string, weight_key: string } | null, clinic_breed?: { __typename?: 'Breed', id: string, description: string } | null } | null, widget?: { __typename?: 'Widget', id: string, widget_name: string } | null }> } };

export type ClinicAnalyticsFieldsFragment = { __typename?: 'ClinicAnalytics', appointments_count: number, no_show_count: number, revenue: number, transactions_count: number, accounts_receivable: number, clients_with_negative_balances_count: number, monthly_revenue_completed: number, monthly_appointments_scheduled: number, last_month_average_revenue_per_appointment: number, new_clients_count: number, new_patients_count: number, new_appointments_count: number, schedule_efficiency: number, forward_scheduled_patients_count: number, appointments: Array<{ __typename?: 'Appointment', id: string, pms?: PracticeManagementSystem | null, client_pms_id?: string | null, is_new_client?: boolean | null, start_time: number, drop_off_time?: number | null, minutes: number, is_new_patient?: boolean | null, is_clinician_auto_assigned?: boolean | null, patient_pms_id?: string | null, referring_clinic_name?: string | null, client_notes?: string | null, clinic_notes?: string | null, service_name?: string | null, status: AppointmentStatus, is_time_block?: boolean | null, is_confirmed?: boolean | null, origin?: EntityOrigin | null, reason_for_cancellation?: string | null, client_reason_for_cancellation?: string | null, new_client_name?: string | null, new_client_phone?: string | null, new_patient_name?: string | null, new_patient_species?: string | null, confirmed_at?: number | null, widget_source?: string | null, from_widget?: string | null, is_deleted?: boolean | null, created_at: number, updated_at: number, pms_created_at?: number | null, clinic?: { __typename?: 'Clinic', id: string, name?: string | null, slug?: string | null, pms_db?: { __typename?: 'PmsDb', id: string } | null, address?: { __typename?: 'Address', country?: string | null } | null } | null, client?: { __typename?: 'Client', id: string, first_name?: string | null, last_name?: string | null, secondary_first_name?: string | null, secondary_last_name?: string | null, phone?: string | null, email?: string | null, pms?: PracticeManagementSystem | null, pms_id?: string | null, last_appt_time?: number | null, last_contact_time?: number | null, email_enabled: boolean, sms_enabled: boolean, balance?: number | null, is_active?: boolean | null, is_unsubscribed: boolean, created_at: number, updated_at: number, client_phones?: Array<{ __typename?: 'ClientPhone', id: string, phone: string, country_code?: string | null, is_primary: boolean, is_chckup_primary: boolean, is_mobile: boolean, sms_available: boolean, is_unsubscribed: boolean, is_active: boolean, name?: string | null }> | null, client_emails?: Array<{ __typename?: 'ClientEmail', id: string, email: string, is_primary: boolean }> | null, clinic?: { __typename?: 'Clinic', id: string } | null, patients?: Array<{ __typename?: 'Patient', id: string, pms?: PracticeManagementSystem | null, pms_id?: string | null, name?: string | null, breed?: string | null, avatar_url?: string | null, last_appt_time?: number | null, gender?: string | null, fixed_status?: FixedStatus | null, weight?: number | null, birthday?: number | null, is_active?: boolean | null, is_deceased?: boolean | null, pms_created_at?: number | null, created_at: number, updated_at: number, owner?: { __typename?: 'Client', id: string, first_name?: string | null, last_name?: string | null, email?: string | null, phone?: string | null, address?: { __typename?: 'Address', country?: string | null } | null } | null, clinic_species?: { __typename?: 'ClinicSpecies', id: string, pms_id: string, description: string, is_primary: boolean, species: Species, weight_key: string, created_at: number, updated_at: number } | null, clinic?: { __typename?: 'Clinic', id: string } | null, clinic_breed?: { __typename?: 'Breed', id: string, description: string } | null, patient_vaccination_records?: Array<{ __typename?: 'PatientVaccinationRecord', id: string, vaccine_name?: string | null, manufacturer?: string | null, lot_number?: string | null, administered_date?: number | null, due_date?: number | null, rabies_tag?: string | null, is_rabies_vaccine?: boolean | null, is_soc: boolean, is_active: boolean, product?: { __typename?: 'Product', id: string, display_name?: string | null, name: string } | null }> | null, last_appointment?: { __typename?: 'Appointment', clinician?: { __typename?: 'Clinician', name: string, display_name?: string | null } | null } | null }> | null, address?: { __typename?: 'Address', street_a?: string | null, street_b?: string | null, city?: string | null, state?: string | null, zip?: string | null, country?: string | null } | null, user?: { __typename?: 'User', avatar_url?: string | null } | null, loyalty_members?: Array<{ __typename?: 'LoyaltyMember', id: string, available_points: number } | null> | null, settings?: { __typename?: 'ClientSettings', clinic_chckup_notifications_enabled: boolean, clinic_chckup_sms_enabled: boolean, clinic_chckup_email_enabled: boolean, client_chckup_notifications_enabled: boolean, client_chckup_sms_enabled: boolean, client_chckup_email_enabled: boolean, is_unsubscribed_from_marketing: boolean, is_unsubscribed_from_marketing_sms: boolean, is_unsubscribed_from_marketing_email: boolean } | null, last_appointment?: { __typename?: 'Appointment', clinician?: { __typename?: 'Clinician', name: string, display_name?: string | null } | null } | null } | null, clinician?: { __typename?: 'Clinician', id: string, name: string, display_name?: string | null, bio?: string | null, avatar_url?: string | null, initials?: string | null, excluded_species?: Array<Species> | null, excluded_service_ids?: Array<string> | null, authority_level?: AuthorityLevel | null, type: ResourceType, is_active?: boolean | null, is_assignable_in_pms?: boolean | null, does_contribute_to_fill_rate?: boolean | null, pms_id?: string | null, location?: string | null, pms_is_active: boolean, valid_booking_interval_minutes?: Array<number> | null, created_at: number, updated_at: number, clinic?: { __typename?: 'Clinic', id: string, name?: string | null } | null, pms_db?: { __typename?: 'PmsDb', id: string } | null, hours?: { __typename?: 'AvailabilityHours', monday?: Array<{ __typename?: 'TimeInterval', start?: number | null, end?: number | null }> | null, tuesday?: Array<{ __typename?: 'TimeInterval', start?: number | null, end?: number | null }> | null, wednesday?: Array<{ __typename?: 'TimeInterval', start?: number | null, end?: number | null }> | null, thursday?: Array<{ __typename?: 'TimeInterval', start?: number | null, end?: number | null }> | null, friday?: Array<{ __typename?: 'TimeInterval', start?: number | null, end?: number | null }> | null, saturday?: Array<{ __typename?: 'TimeInterval', start?: number | null, end?: number | null }> | null, sunday?: Array<{ __typename?: 'TimeInterval', start?: number | null, end?: number | null }> | null } | null, adjusted_availability?: Array<{ __typename?: 'Availability', date: number, pms_appt_type_pms_id?: string | null, times: Array<{ __typename?: 'TimeInterval', start?: number | null, end?: number | null }>, repeat?: { __typename?: 'RepeatAvailability', daysOfMonth?: Array<number> | null, daysOfWeek?: Array<DayOfWeek> | null, weekOfMonth?: WeekOfMonth | null, frequency: any, unit: RepeatUnit, end_date?: number | null } | null }> | null, pms_adjusted_availability?: Array<{ __typename?: 'Availability', date: number, pms_appt_type_pms_id?: string | null, times: Array<{ __typename?: 'TimeInterval', start?: number | null, end?: number | null }>, repeat?: { __typename?: 'RepeatAvailability', daysOfMonth?: Array<number> | null, daysOfWeek?: Array<DayOfWeek> | null, weekOfMonth?: WeekOfMonth | null, frequency: any, unit: RepeatUnit, end_date?: number | null } | null }> | null } | null, room?: { __typename?: 'Room', id: string, pms_id: string, name: string, display_name?: string | null, description?: string | null, concurrent_patients?: number | null, is_active: boolean, does_contribute_to_fill_rate?: boolean | null, valid_booking_interval_minutes?: Array<number> | null, created_at: number, updated_at: number, clinic?: { __typename?: 'Clinic', pms: PracticeManagementSystem, id: string, name?: string | null, time_zone?: string | null } | null, hours?: { __typename?: 'AvailabilityHours', monday?: Array<{ __typename?: 'TimeInterval', start?: number | null, end?: number | null }> | null, tuesday?: Array<{ __typename?: 'TimeInterval', start?: number | null, end?: number | null }> | null, wednesday?: Array<{ __typename?: 'TimeInterval', start?: number | null, end?: number | null }> | null, thursday?: Array<{ __typename?: 'TimeInterval', start?: number | null, end?: number | null }> | null, friday?: Array<{ __typename?: 'TimeInterval', start?: number | null, end?: number | null }> | null, saturday?: Array<{ __typename?: 'TimeInterval', start?: number | null, end?: number | null }> | null, sunday?: Array<{ __typename?: 'TimeInterval', start?: number | null, end?: number | null }> | null } | null, adjusted_availability?: Array<{ __typename?: 'Availability', date: number, pms_appt_type_pms_id?: string | null, times: Array<{ __typename?: 'TimeInterval', start?: number | null, end?: number | null }>, repeat?: { __typename?: 'RepeatAvailability', daysOfMonth?: Array<number> | null, daysOfWeek?: Array<DayOfWeek> | null, weekOfMonth?: WeekOfMonth | null, frequency: any, unit: RepeatUnit, end_date?: number | null } | null }> | null, pms_adjusted_availability?: Array<{ __typename?: 'Availability', date: number, pms_appt_type_pms_id?: string | null, times: Array<{ __typename?: 'TimeInterval', start?: number | null, end?: number | null }>, repeat?: { __typename?: 'RepeatAvailability', daysOfMonth?: Array<number> | null, daysOfWeek?: Array<DayOfWeek> | null, weekOfMonth?: WeekOfMonth | null, frequency: any, unit: RepeatUnit, end_date?: number | null } | null }> | null } | null, service?: { __typename?: 'Service', id: string, name?: string | null, color?: string | null } | null, patient?: { __typename?: 'Patient', id: string, pms?: PracticeManagementSystem | null, pms_id?: string | null, name?: string | null, breed?: string | null, avatar_url?: string | null, last_appt_time?: number | null, gender?: string | null, fixed_status?: FixedStatus | null, weight?: number | null, birthday?: number | null, is_active?: boolean | null, is_deceased?: boolean | null, pms_created_at?: number | null, created_at: number, updated_at: number, owner?: { __typename?: 'Client', id: string, first_name?: string | null, last_name?: string | null, email?: string | null, phone?: string | null, address?: { __typename?: 'Address', country?: string | null } | null } | null, clinic_species?: { __typename?: 'ClinicSpecies', id: string, pms_id: string, description: string, is_primary: boolean, species: Species, weight_key: string, created_at: number, updated_at: number } | null, clinic?: { __typename?: 'Clinic', id: string } | null, clinic_breed?: { __typename?: 'Breed', id: string, description: string } | null, patient_vaccination_records?: Array<{ __typename?: 'PatientVaccinationRecord', id: string, vaccine_name?: string | null, manufacturer?: string | null, lot_number?: string | null, administered_date?: number | null, due_date?: number | null, rabies_tag?: string | null, is_rabies_vaccine?: boolean | null, is_soc: boolean, is_active: boolean, product?: { __typename?: 'Product', id: string, display_name?: string | null, name: string } | null }> | null, last_appointment?: { __typename?: 'Appointment', clinician?: { __typename?: 'Clinician', name: string, display_name?: string | null } | null } | null } | null, clinic_appt_status?: { __typename?: 'ClinicApptStatus', id: string, description: string, status: AppointmentStatus } | null, client_info?: { __typename?: 'ClientInfo', first_name?: string | null, last_name?: string | null, email?: string | null, phone?: string | null } | null, patient_info?: { __typename?: 'PatientInfo', patient_name?: string | null, patient_breed?: string | null, patient_clinic_species?: string | null, patient_clinic_breed?: string | null } | null, clients_forms?: Array<{ __typename?: 'ClientForm', id: string, client_completed_at?: number | null, clinic_verified_at?: number | null, is_archived: boolean, pms_id?: string | null, created_at: number, updated_at: number, client?: { __typename?: 'Client', id: string, first_name?: string | null, last_name?: string | null, phone?: string | null, email?: string | null, address?: { __typename?: 'Address', street_a?: string | null, city?: string | null, state?: string | null, zip?: string | null, country?: string | null } | null } | null, patient?: { __typename?: 'Patient', id: string, name?: string | null, is_active?: boolean | null, is_deceased?: boolean | null, birthday?: number | null, weight?: number | null, avatar_url?: string | null, gender?: string | null, owner?: { __typename?: 'Client', first_name?: string | null, last_name?: string | null } | null, clinic_species?: { __typename?: 'ClinicSpecies', id: string, species: Species, description: string, weight_key: string } | null, clinic_breed?: { __typename?: 'Breed', id: string, description: string } | null } | null, form: { __typename?: 'Form', id: string, name?: string | null, form_type: FormType, is_writeback_enabled: boolean, form_file_naming_template?: string | null }, form_data: { __typename?: 'FormFields', pages?: Array<{ __typename?: 'FormPage', id: string, title?: string | null, description?: string | null, order?: number | null }> | null, fields?: Array<{ __typename?: 'FormElement', id: string, type?: FormElementType | null, content?: string | null, name?: string | null, column_order?: number | null, row_order?: number | null, page_id?: string | null, options?: Array<string> | null, is_required?: boolean | null, value?: string | null, attachments?: Array<{ __typename?: 'FormFileAttachment', id?: string | null, filename?: string | null, mime_type?: string | null, size_bytes?: number | null, thumbnail_url?: string | null, url: string }> | null, field_updates?: Array<{ __typename?: 'FormFieldUpdate', field: FormFieldUpdateField, boolean_value?: boolean | null, option?: string | null }> | null }> | null }, appointment?: { __typename?: 'Appointment', start_time: number, drop_off_time?: number | null, clinic?: { __typename?: 'Clinic', name?: string | null, slug?: string | null, phone?: string | null, email?: string | null, address?: { __typename?: 'Address', street_a?: string | null, city?: string | null, state?: string | null, zip?: string | null, country?: string | null } | null } | null, clinician?: { __typename?: 'Clinician', name: string, display_name?: string | null } | null, service?: { __typename?: 'Service', name?: string | null } | null } | null }> | null, widget?: { __typename?: 'Widget', id: string, widget_name: string } | null }>, revenue_by_type: Array<{ __typename?: 'RevenueGroup', group: string, amount: number }>, revenue_by_clinician: Array<{ __typename?: 'RevenueGroup', group: string, amount: number }>, clients_with_negative_balances: Array<{ __typename?: 'Client', id: string, first_name?: string | null, last_name?: string | null, secondary_first_name?: string | null, secondary_last_name?: string | null, phone?: string | null, email?: string | null, pms?: PracticeManagementSystem | null, pms_id?: string | null, last_appt_time?: number | null, last_contact_time?: number | null, email_enabled: boolean, sms_enabled: boolean, balance?: number | null, is_active?: boolean | null, is_unsubscribed: boolean, created_at: number, updated_at: number, client_phones?: Array<{ __typename?: 'ClientPhone', id: string, phone: string, country_code?: string | null, is_primary: boolean, is_chckup_primary: boolean, is_mobile: boolean, sms_available: boolean, is_unsubscribed: boolean, is_active: boolean, name?: string | null }> | null, client_emails?: Array<{ __typename?: 'ClientEmail', id: string, email: string, is_primary: boolean }> | null, clinic?: { __typename?: 'Clinic', id: string } | null, patients?: Array<{ __typename?: 'Patient', id: string, pms?: PracticeManagementSystem | null, pms_id?: string | null, name?: string | null, breed?: string | null, avatar_url?: string | null, last_appt_time?: number | null, gender?: string | null, fixed_status?: FixedStatus | null, weight?: number | null, birthday?: number | null, is_active?: boolean | null, is_deceased?: boolean | null, pms_created_at?: number | null, created_at: number, updated_at: number, owner?: { __typename?: 'Client', id: string, first_name?: string | null, last_name?: string | null, email?: string | null, phone?: string | null, address?: { __typename?: 'Address', country?: string | null } | null } | null, clinic_species?: { __typename?: 'ClinicSpecies', id: string, pms_id: string, description: string, is_primary: boolean, species: Species, weight_key: string, created_at: number, updated_at: number } | null, clinic?: { __typename?: 'Clinic', id: string } | null, clinic_breed?: { __typename?: 'Breed', id: string, description: string } | null, patient_vaccination_records?: Array<{ __typename?: 'PatientVaccinationRecord', id: string, vaccine_name?: string | null, manufacturer?: string | null, lot_number?: string | null, administered_date?: number | null, due_date?: number | null, rabies_tag?: string | null, is_rabies_vaccine?: boolean | null, is_soc: boolean, is_active: boolean, product?: { __typename?: 'Product', id: string, display_name?: string | null, name: string } | null }> | null, last_appointment?: { __typename?: 'Appointment', clinician?: { __typename?: 'Clinician', name: string, display_name?: string | null } | null } | null }> | null, address?: { __typename?: 'Address', street_a?: string | null, street_b?: string | null, city?: string | null, state?: string | null, zip?: string | null, country?: string | null } | null, user?: { __typename?: 'User', avatar_url?: string | null } | null, loyalty_members?: Array<{ __typename?: 'LoyaltyMember', id: string, available_points: number } | null> | null, settings?: { __typename?: 'ClientSettings', clinic_chckup_notifications_enabled: boolean, clinic_chckup_sms_enabled: boolean, clinic_chckup_email_enabled: boolean, client_chckup_notifications_enabled: boolean, client_chckup_sms_enabled: boolean, client_chckup_email_enabled: boolean, is_unsubscribed_from_marketing: boolean, is_unsubscribed_from_marketing_sms: boolean, is_unsubscribed_from_marketing_email: boolean } | null, last_appointment?: { __typename?: 'Appointment', clinician?: { __typename?: 'Clinician', name: string, display_name?: string | null } | null } | null }>, patients_without_reschedules: Array<{ __typename?: 'Patient', id: string, pms?: PracticeManagementSystem | null, pms_id?: string | null, name?: string | null, breed?: string | null, avatar_url?: string | null, last_appt_time?: number | null, gender?: string | null, fixed_status?: FixedStatus | null, weight?: number | null, birthday?: number | null, is_active?: boolean | null, is_deceased?: boolean | null, pms_created_at?: number | null, created_at: number, updated_at: number, owner?: { __typename?: 'Client', id: string, first_name?: string | null, last_name?: string | null, email?: string | null, phone?: string | null, address?: { __typename?: 'Address', country?: string | null } | null } | null, clinic_species?: { __typename?: 'ClinicSpecies', id: string, pms_id: string, description: string, is_primary: boolean, species: Species, weight_key: string, created_at: number, updated_at: number } | null, clinic?: { __typename?: 'Clinic', id: string } | null, clinic_breed?: { __typename?: 'Breed', id: string, description: string } | null, patient_vaccination_records?: Array<{ __typename?: 'PatientVaccinationRecord', id: string, vaccine_name?: string | null, manufacturer?: string | null, lot_number?: string | null, administered_date?: number | null, due_date?: number | null, rabies_tag?: string | null, is_rabies_vaccine?: boolean | null, is_soc: boolean, is_active: boolean, product?: { __typename?: 'Product', id: string, display_name?: string | null, name: string } | null }> | null, last_appointment?: { __typename?: 'Appointment', clinician?: { __typename?: 'Clinician', name: string, display_name?: string | null } | null } | null }> };

export type AnalyticsNumbersFieldsFragment = { __typename?: 'AnalyticsNumbers', appointments_count: number, no_show_count: number, revenue: number, transactions_count: number, revenue_per_appointment: number, new_clients_count: number, new_patients_count: number, new_appointments_count: number, schedule_efficiency: number, forward_scheduled_patients_count: number };

export type GetRevenueByMonthsForClinicQueryVariables = Exact<{
  clinicId: Scalars['ID']['input'];
  numMonths: Scalars['NonNegativeInt']['input'];
}>;


export type GetRevenueByMonthsForClinicQuery = { __typename?: 'Query', getRevenueByMonthsForClinic: Array<{ __typename?: 'RevenueByMonth', month: number, year: number, revenue: number }> };

export type ClinicApptStatusFieldsFragment = { __typename?: 'ClinicApptStatus', id: string, pms_id: string, is_primary: boolean, description: string, status: AppointmentStatus, created_at: number, updated_at: number, clinic?: { __typename?: 'Clinic', id: string, name?: string | null, time_zone?: string | null } | null };

export type ClinicApptStatusBasicInfoFieldsFragment = { __typename?: 'ClinicApptStatus', id: string, description: string, is_primary: boolean, status: AppointmentStatus, created_at: number };

export type GetClinicApptStatusesByClinicQueryVariables = Exact<{
  clinicId: Scalars['ID']['input'];
}>;


export type GetClinicApptStatusesByClinicQuery = { __typename?: 'Query', getClinicApptStatusesByClinic: Array<{ __typename?: 'ClinicApptStatus', id: string, pms_id: string, is_primary: boolean, description: string, status: AppointmentStatus, created_at: number, updated_at: number, clinic?: { __typename?: 'Clinic', id: string, name?: string | null, time_zone?: string | null } | null }> };

export type QueryClinicApptStatusesQueryVariables = Exact<{
  where?: InputMaybe<Array<QueryInput> | QueryInput>;
  page?: InputMaybe<Scalars['NonNegativeInt']['input']>;
  pageSize?: InputMaybe<Scalars['NonNegativeInt']['input']>;
  orderBy?: InputMaybe<OrderByInput>;
}>;


export type QueryClinicApptStatusesQuery = { __typename?: 'Query', queryClinicApptStatuses: Array<{ __typename?: 'ClinicApptStatus', id: string, pms_id: string, is_primary: boolean, description: string, status: AppointmentStatus, created_at: number, updated_at: number, clinic?: { __typename?: 'Clinic', id: string, name?: string | null, time_zone?: string | null } | null }> };

export type CountClinicApptStatusesQueryVariables = Exact<{
  where?: InputMaybe<Array<QueryInput> | QueryInput>;
}>;


export type CountClinicApptStatusesQuery = { __typename?: 'Query', countClinicApptStatuses: number };

export type ReassignClinicApptStatusMutationVariables = Exact<{
  clinicId: Scalars['ID']['input'];
  statusId: Scalars['ID']['input'];
  newStatus: AppointmentStatus;
}>;


export type ReassignClinicApptStatusMutation = { __typename?: 'Mutation', reassignClinicApptStatus: { __typename?: 'ClinicApptStatus', id: string, pms_id: string, is_primary: boolean, description: string, status: AppointmentStatus, created_at: number, updated_at: number, clinic?: { __typename?: 'Clinic', id: string, name?: string | null, time_zone?: string | null } | null } };

export type MakePrimaryClinicApptStatusMutationVariables = Exact<{
  clinicId: Scalars['ID']['input'];
  statusId: Scalars['ID']['input'];
}>;


export type MakePrimaryClinicApptStatusMutation = { __typename?: 'Mutation', makePrimaryClinicApptStatus: { __typename?: 'ClinicApptStatus', id: string, pms_id: string, is_primary: boolean, description: string, status: AppointmentStatus, created_at: number, updated_at: number, clinic?: { __typename?: 'Clinic', id: string, name?: string | null, time_zone?: string | null } | null } };

export type UpdateClinicApptStatusMutationVariables = Exact<{
  clinicId: Scalars['ID']['input'];
  statusId: Scalars['ID']['input'];
  data: UpdateClinicApptStatusInput;
}>;


export type UpdateClinicApptStatusMutation = { __typename?: 'Mutation', updateClinicApptStatus: { __typename?: 'ClinicApptStatus', id: string, pms_id: string, is_primary: boolean, description: string, status: AppointmentStatus, created_at: number, updated_at: number, clinic?: { __typename?: 'Clinic', id: string, name?: string | null, time_zone?: string | null } | null } };

export type ClinicGroupPreviewFieldsFragment = { __typename?: 'ClinicGroup', id: string, name: string, slug: string, clinic_group_clinics: Array<{ __typename?: 'ClinicGroupClinic', id: string, created_at: number, clinic: { __typename?: 'Clinic', id: string, name?: string | null, slug?: string | null, avatar_url?: string | null, time_zone?: string | null, is_archived: boolean, address?: { __typename?: 'Address', street_a?: string | null, street_b?: string | null, city?: string | null, state?: string | null, zip?: string | null, country?: string | null } | null, pms_db?: { __typename?: 'PmsDb', id: string } | null } }> };

export type CgcClinicFieldsFragment = { __typename?: 'Clinic', id: string, name?: string | null, slug?: string | null, avatar_url?: string | null, time_zone?: string | null, is_archived: boolean, address?: { __typename?: 'Address', street_a?: string | null, street_b?: string | null, city?: string | null, state?: string | null, zip?: string | null, country?: string | null } | null, pms_db?: { __typename?: 'PmsDb', id: string } | null };

export type ClinicGroupClinicFieldsFragment = { __typename?: 'ClinicGroupClinic', id: string, created_at: number, clinic: { __typename?: 'Clinic', id: string, name?: string | null, slug?: string | null, avatar_url?: string | null, time_zone?: string | null, is_archived: boolean, address?: { __typename?: 'Address', street_a?: string | null, street_b?: string | null, city?: string | null, state?: string | null, zip?: string | null, country?: string | null } | null, pms_db?: { __typename?: 'PmsDb', id: string } | null } };

export type CguUserFieldsFragment = { __typename?: 'User', id: string, email?: any | null, first_name?: string | null, last_name?: string | null, avatar_url?: string | null, invitation_status?: UserInvitationStatus | null };

export type ClinicGroupUserFieldsFragment = { __typename?: 'ClinicGroupUser', id: string, role: AuthRoles, are_email_notifications_enabled: boolean, are_sms_notifications_enabled: boolean, are_desktop_notifications_enabled: boolean, created_at: number, clinic_group: { __typename?: 'ClinicGroup', id: string }, user: { __typename?: 'User', id: string, email?: any | null, first_name?: string | null, last_name?: string | null, avatar_url?: string | null, invitation_status?: UserInvitationStatus | null }, custom_role?: { __typename?: 'CustomRole', id: string, name: string } | null, permissions?: Array<{ __typename?: 'ClinicAdminPermission', feature: AdminPermissionFeature, access_level: AdminPermissionAccessLevel }> | null };

export type SubClinicGroupFieldsFragment = { __typename?: 'ClinicGroup', id: string, name: string, slug: string, is_archived: boolean, clinic_group_clinics: Array<{ __typename?: 'ClinicGroupClinic', id: string, created_at: number, clinic: { __typename?: 'Clinic', id: string, name?: string | null, slug?: string | null, avatar_url?: string | null, time_zone?: string | null, is_archived: boolean, address?: { __typename?: 'Address', street_a?: string | null, street_b?: string | null, city?: string | null, state?: string | null, zip?: string | null, country?: string | null } | null, pms_db?: { __typename?: 'PmsDb', id: string } | null } }> };

export type ClinicGroupFieldsFragment = { __typename?: 'ClinicGroup', id: string, name: string, slug: string, is_archived: boolean, created_at: number, updated_at: number, settings?: { __typename?: 'ClinicSettings', id?: string | null, does_require_verification?: boolean | null, does_use_automatic_reschedule?: boolean | null, reset_status_to_booked_on_reschedule?: boolean | null, is_using_detailed_services?: boolean | null, hide_review_step?: boolean | null, is_using_rooms?: boolean | null, pms_start_time?: any | null, pms_end_time?: any | null, primary_color?: string | null, accent_color?: string | null, secondary_color?: string | null, new_appt_requested_msg?: string | null, new_appt_approved_msg?: string | null, new_appt_approved_sms_msg?: string | null, new_appt_denied_msg?: string | null, schedule_method?: ScheduleMethod | null, scheduling_buffer_minutes?: number | null, base_schedule_duration?: number | null, does_require_referral?: boolean | null, appointment_entry_method?: AppointmentEntryMethod | null, scheduling_min_minutes_away?: number | null, scheduling_max_minutes_away?: number | null, included_species?: Array<Species> | null, max_patients_per_visit?: number | null, should_complete_sync?: boolean | null, server_syncing_only?: boolean | null, confirmation_days_before?: number | null, send_confirmations_to: SendConfirmationsTo, send_new_appt_email?: boolean | null, send_reviews_to?: SendConfirmationsTo | null, max_review_rating_for_notif?: number | null, google_review_link?: string | null, facebook_review_link?: string | null, non_blocking_services: Array<string>, yesterday_revenue?: number | null, this_month_revenue?: number | null, hide_clinician_preference: boolean, does_use_rooms_to_schedule?: boolean | null, primary_room_pms_id?: string | null, should_default_pims_emails_on: boolean, should_default_pims_sms_on: boolean, should_default_marketing_sms_on: boolean, should_default_marketing_email_on: boolean, does_use_clinicians_to_schedule?: boolean | null, time_slot_minutes: number, sync_interval_minutes: number, long_sync_interval_hours: number, primary_clinician_pms_id?: string | null, cancellation_clinician_pms_id?: string | null, cancellation_service_pms_id?: string | null, allow_first_appt_per_day?: boolean | null, custom_well_description?: string | null, custom_sick_description?: string | null, custom_other_title?: string | null, custom_other_description?: string | null, default_trigger_words?: Array<string> | null, should_use_private_reviews?: boolean | null, notify_clinic_on?: Array<NotifyClinicOn> | null, reminder_send_time_minutes?: number | null, does_require_new_client_address?: boolean | null, does_require_new_client_birthday?: boolean | null, should_allow_new_clients?: boolean | null, should_allow_new_patients?: boolean | null, should_create_clients?: boolean | null, should_create_patients?: boolean | null, msgs_auto_priority?: boolean | null, booking_match_procedure?: BookingMatchProcedure | null, urgency_type?: UrgencyType | null, max_booking_columns?: number | null, hide_closed_days_from_scheduling?: boolean | null, should_sync_reminders?: boolean | null, auto_reply_enabled: boolean, auto_reply_message?: string | null, unreplied_message_alert_enabled: boolean, unreplied_message_alert_minutes: number, comms_writeback_enabled: boolean, comms_should_daily_writeback: boolean, comms_use_pdf_for_writeback: boolean, comms_writeback_buffer_minutes: number, comms_writeback_before_appt_mins: number, comms_should_writeback_on_send: boolean, comms_should_writeback_on_receive: boolean, comms_should_writeback_notifs: boolean, comms_should_use_ai_writeback: boolean, form_writeback_enabled: boolean, should_award_loyalty_for_invoices?: boolean | null, invoice_loyalty_points_per_dollar?: number | null, app_download_loyalty_points?: number | null, referrer_loyalty_points?: number | null, referred_loyalty_points?: number | null, custom_appointment_notes_template?: string | null, custom_new_client_notes_template?: string | null, custom_new_patient_notes_template?: string | null, max_inactivity_duration?: number | null, hide_portal_vaccinations: boolean, hide_portal_reminders: boolean, hide_portal_prescriptions: boolean, hide_portal_weight: boolean, hide_soc_vaccinations?: boolean | null, hide_historic_vaccinations?: boolean | null, should_hide_daily_huddle_financials: boolean, patient_details_tab_order: Array<PortalPatientDetailsTab>, clinic_hours_display?: string | null, reschedule_buffer_minutes?: number | null, cancellation_buffer_minutes?: number | null, require_reason_for_cancellation?: boolean | null, should_automatically_assign_patient?: boolean | null, payment_writeback_enabled: boolean, auto_refund_on_cancel: boolean, status_set_on_payment_completed_pms_id?: string | null, max_booking_notes_length?: number | null, min_booking_notes_length?: number | null, primary_clinic_group_id?: string | null, should_suggest_nearby_clinics?: boolean | null, sms_block_list?: Array<string> | null, exclude_message_wrapper?: boolean | null, should_charge_client_stripe_fees?: boolean | null, chckvet_prescription_fee_split_percentage?: number | null, gtm_container_id?: string | null, review_google_id?: string | null, review_facebook_id?: string | null, only_use_adj_avail_guides: boolean, use_basic_timeslots: boolean, valid_booking_interval_minutes?: Array<number> | null, should_disable_online_scheduling?: boolean | null, simple_scheduling_rules_enabled: boolean, compliance_statuses?: Array<string> | null, should_use_instant_prescription_requests?: boolean | null, prescription_pickup_service_id?: string | null, default_reminder_service_id?: string | null, ai_calls_provider?: PhoneProviderType | null, ai_calls_phone_number?: string | null, ai_calls_voice_id?: string | null, ai_calls_agent_id?: string | null, ai_agent_style?: string | null, ai_agent_custom_instructions?: string | null, ai_calls_ambient_sound?: AiCallsAmbientSound | null, ai_calls_voice_speed?: number | null, ai_calls_interruption_sensitivity?: number | null, ai_calls_enable_dynamic_voice_speed?: boolean | null, usage_spending_caps?: any | null, custom_merge_tags?: any | null, custom_booking_copy?: { __typename?: 'ClinicBookingCopy', WIDGET_HEADER_TITLE?: string | null, SHOW_CLINIC_HEADER_LOGO?: boolean | null, CLINIC_HEADER_LOGO_HEIGHT?: number | null, SERVICE_TYPE_SECTION_HEADING?: string | null, DEFAULT_WELLNESS_DESCRIPTION?: string | null, DEFAULT_SICK_DESCRIPTION?: string | null, DEFAULT_OTHER_DESCRIPTION?: string | null, RETURNING_PATIENT_QUESTION?: string | null, POSITIVE_RETURNING_PATIENT_ANSWER?: string | null, NEGATIVE_RETURNING_PATIENT_ANSWER?: string | null, RETURNING_CLIENT_QUESTION?: string | null, POSITIVE_RETURNING_CLIENT_ANSWER?: string | null, NEGATIVE_RETURNING_CLIENT_ANSWER?: string | null, CLIENT_INFORMATION_SECTION_TITLE?: string | null, PATIENT_INFORMATION_SECTION_TITLE?: string | null, RETURNING_CLIENT_PATIENT_TITLE?: string | null, RETURNING_CLIENT_PATIENT_DESCRIPTION?: string | null, SERVICE_SECTION_TITLE?: string | null, PREPAID_SERVICES_LABEL?: string | null, STANDARD_SERVICES_LABEL?: string | null, DEPOSIT_FEE_NAME?: string | null, PREVIOUS_OR_REFERRING_CLINIC_QUESTION?: string | null, CONTACT_THE_CLINIC_TEXT?: string | null, CONTACT_THE_CLINIC_TEXT_COLOR?: string | null, CONTACT_THE_CLINIC_TEXT_SIZE?: string | null, SELECT_CLINICIAN_TITLE?: string | null, SELECT_CLINICIAN_POSITIVE_ANSWER?: string | null, SELECT_CLINICIAN_NEGATIVE_ANSWER?: string | null, SELECT_TIME_TITLE?: string | null, REVIEW_TITLE?: string | null, REVIEW_NOTES_PROMPT?: string | null, PAYMENT_INFORMATION_TITLE?: string | null, TRIGGER_WORDS_DETECTED_HEADER?: string | null, TRIGGER_WORDS_DETECTED_DESCRIPTION?: string | null, CONFIRMATION_SCREEN_TITLE?: string | null, CONFIRMATION_SCREEN_DESCRIPTION?: string | null, NEW_CLIENT_BLOCKED_MESSAGE?: string | null, NEW_PATIENT_BLOCKED_MESSAGE?: string | null } | null, auto_reply_hours?: { __typename?: 'AvailabilityHours', monday?: Array<{ __typename?: 'TimeInterval', start?: number | null, end?: number | null }> | null, tuesday?: Array<{ __typename?: 'TimeInterval', start?: number | null, end?: number | null }> | null, wednesday?: Array<{ __typename?: 'TimeInterval', start?: number | null, end?: number | null }> | null, thursday?: Array<{ __typename?: 'TimeInterval', start?: number | null, end?: number | null }> | null, friday?: Array<{ __typename?: 'TimeInterval', start?: number | null, end?: number | null }> | null, saturday?: Array<{ __typename?: 'TimeInterval', start?: number | null, end?: number | null }> | null, sunday?: Array<{ __typename?: 'TimeInterval', start?: number | null, end?: number | null }> | null } | null, portal_links?: Array<{ __typename?: 'PortalLink', label: string, url: string }> | null, custom_reviews_copy?: { __typename?: 'ClinicReviewsCopy', REVIEW_METHOD_PAGE_TITLE?: string | null, REVIEW_METHOD_PAGE_DESCRIPTION?: string | null, PRIVATE_REVIEW_BUTTON_HELP_TEXT?: string | null, PRIVATE_REVIEW_BUTTON_TEXT?: string | null, REVIEW_PAGE_TITLE?: string | null, REVIEW_PAGE_SUBTITLE?: string | null, REVIEW_SCORE_LABEL?: string | null, REVIEW_MESSAGE_LABEL?: string | null, REVIEW_SUBMIT_BUTTON_TEXT?: string | null } | null, waitlist_customer_segment?: { __typename?: 'CustomerSegment', id: string, name: string, trigger_entity?: CustomerSegmentTrigger | null, is_archived: boolean, updated_at: number, notification_templates?: Array<{ __typename?: 'NotificationTemplate', id: string, name: string, is_active: boolean, is_archived: boolean, message_methods: Array<MessageMethod> }> | null, error_flags?: Array<{ __typename?: 'CustomerSegmentErrorFlag', filter_column: string, filter_index: number, parameter_index: number, message: string }> | null, all_inclusions?: Array<{ __typename?: 'SegmentFilter', foreign_table?: string | null, group?: string | null, parameters: Array<{ __typename?: 'QueryFilter', column: string, filterOp: FilterOp, value: { __typename?: 'QueryFilterValue', string?: string | null, float?: number | null, boolean?: boolean | null, stringArray?: Array<string> | null, floatArray?: Array<number> | null, millisFromNow?: number | null, relativeTime?: { __typename?: 'RelativeTime', quantity: number, unit: TimeUnit, direction: ReferenceDirection } | null } }> }> | null, any_inclusions?: Array<{ __typename?: 'SegmentFilter', foreign_table?: string | null, group?: string | null, parameters: Array<{ __typename?: 'QueryFilter', column: string, filterOp: FilterOp, value: { __typename?: 'QueryFilterValue', string?: string | null, float?: number | null, boolean?: boolean | null, stringArray?: Array<string> | null, floatArray?: Array<number> | null, millisFromNow?: number | null, relativeTime?: { __typename?: 'RelativeTime', quantity: number, unit: TimeUnit, direction: ReferenceDirection } | null } }> }> | null, any_exclusions?: Array<{ __typename?: 'SegmentFilter', foreign_table?: string | null, group?: string | null, parameters: Array<{ __typename?: 'QueryFilter', column: string, filterOp: FilterOp, value: { __typename?: 'QueryFilterValue', string?: string | null, float?: number | null, boolean?: boolean | null, stringArray?: Array<string> | null, floatArray?: Array<number> | null, millisFromNow?: number | null, relativeTime?: { __typename?: 'RelativeTime', quantity: number, unit: TimeUnit, direction: ReferenceDirection } | null } }> }> | null, any_other_exclusions?: Array<{ __typename?: 'SegmentFilter', foreign_table?: string | null, group?: string | null, parameters: Array<{ __typename?: 'QueryFilter', column: string, filterOp: FilterOp, value: { __typename?: 'QueryFilterValue', string?: string | null, float?: number | null, boolean?: boolean | null, stringArray?: Array<string> | null, floatArray?: Array<number> | null, millisFromNow?: number | null, relativeTime?: { __typename?: 'RelativeTime', quantity: number, unit: TimeUnit, direction: ReferenceDirection } | null } }> }> | null, filters?: Array<{ __typename?: 'CustomerSegmentFilter', filters: Array<{ __typename?: 'QueryFilter', column: string, filterOp: FilterOp, value: { __typename?: 'QueryFilterValue', string?: string | null, float?: number | null, boolean?: boolean | null, stringArray?: Array<string> | null, floatArray?: Array<number> | null, millisFromNow?: number | null, relativeTime?: { __typename?: 'RelativeTime', quantity: number, unit: TimeUnit, direction: ReferenceDirection } | null } }> }> | null, excluded_filters: Array<{ __typename?: 'CustomerSegmentFilter', filters: Array<{ __typename?: 'QueryFilter', column: string, filterOp: FilterOp, value: { __typename?: 'QueryFilterValue', string?: string | null, float?: number | null, boolean?: boolean | null, stringArray?: Array<string> | null, floatArray?: Array<number> | null, millisFromNow?: number | null, relativeTime?: { __typename?: 'RelativeTime', quantity: number, unit: TimeUnit, direction: ReferenceDirection } | null } }> }> } | null, blocklist_customer_segment?: { __typename?: 'CustomerSegment', id: string, name: string, trigger_entity?: CustomerSegmentTrigger | null, is_archived: boolean, updated_at: number, notification_templates?: Array<{ __typename?: 'NotificationTemplate', id: string, name: string, is_active: boolean, is_archived: boolean, message_methods: Array<MessageMethod> }> | null, error_flags?: Array<{ __typename?: 'CustomerSegmentErrorFlag', filter_column: string, filter_index: number, parameter_index: number, message: string }> | null, all_inclusions?: Array<{ __typename?: 'SegmentFilter', foreign_table?: string | null, group?: string | null, parameters: Array<{ __typename?: 'QueryFilter', column: string, filterOp: FilterOp, value: { __typename?: 'QueryFilterValue', string?: string | null, float?: number | null, boolean?: boolean | null, stringArray?: Array<string> | null, floatArray?: Array<number> | null, millisFromNow?: number | null, relativeTime?: { __typename?: 'RelativeTime', quantity: number, unit: TimeUnit, direction: ReferenceDirection } | null } }> }> | null, any_inclusions?: Array<{ __typename?: 'SegmentFilter', foreign_table?: string | null, group?: string | null, parameters: Array<{ __typename?: 'QueryFilter', column: string, filterOp: FilterOp, value: { __typename?: 'QueryFilterValue', string?: string | null, float?: number | null, boolean?: boolean | null, stringArray?: Array<string> | null, floatArray?: Array<number> | null, millisFromNow?: number | null, relativeTime?: { __typename?: 'RelativeTime', quantity: number, unit: TimeUnit, direction: ReferenceDirection } | null } }> }> | null, any_exclusions?: Array<{ __typename?: 'SegmentFilter', foreign_table?: string | null, group?: string | null, parameters: Array<{ __typename?: 'QueryFilter', column: string, filterOp: FilterOp, value: { __typename?: 'QueryFilterValue', string?: string | null, float?: number | null, boolean?: boolean | null, stringArray?: Array<string> | null, floatArray?: Array<number> | null, millisFromNow?: number | null, relativeTime?: { __typename?: 'RelativeTime', quantity: number, unit: TimeUnit, direction: ReferenceDirection } | null } }> }> | null, any_other_exclusions?: Array<{ __typename?: 'SegmentFilter', foreign_table?: string | null, group?: string | null, parameters: Array<{ __typename?: 'QueryFilter', column: string, filterOp: FilterOp, value: { __typename?: 'QueryFilterValue', string?: string | null, float?: number | null, boolean?: boolean | null, stringArray?: Array<string> | null, floatArray?: Array<number> | null, millisFromNow?: number | null, relativeTime?: { __typename?: 'RelativeTime', quantity: number, unit: TimeUnit, direction: ReferenceDirection } | null } }> }> | null, filters?: Array<{ __typename?: 'CustomerSegmentFilter', filters: Array<{ __typename?: 'QueryFilter', column: string, filterOp: FilterOp, value: { __typename?: 'QueryFilterValue', string?: string | null, float?: number | null, boolean?: boolean | null, stringArray?: Array<string> | null, floatArray?: Array<number> | null, millisFromNow?: number | null, relativeTime?: { __typename?: 'RelativeTime', quantity: number, unit: TimeUnit, direction: ReferenceDirection } | null } }> }> | null, excluded_filters: Array<{ __typename?: 'CustomerSegmentFilter', filters: Array<{ __typename?: 'QueryFilter', column: string, filterOp: FilterOp, value: { __typename?: 'QueryFilterValue', string?: string | null, float?: number | null, boolean?: boolean | null, stringArray?: Array<string> | null, floatArray?: Array<number> | null, millisFromNow?: number | null, relativeTime?: { __typename?: 'RelativeTime', quantity: number, unit: TimeUnit, direction: ReferenceDirection } | null } }> }> } | null, referral_customer_segment?: { __typename?: 'CustomerSegment', id: string, name: string, trigger_entity?: CustomerSegmentTrigger | null, is_archived: boolean, updated_at: number, notification_templates?: Array<{ __typename?: 'NotificationTemplate', id: string, name: string, is_active: boolean, is_archived: boolean, message_methods: Array<MessageMethod> }> | null, error_flags?: Array<{ __typename?: 'CustomerSegmentErrorFlag', filter_column: string, filter_index: number, parameter_index: number, message: string }> | null, all_inclusions?: Array<{ __typename?: 'SegmentFilter', foreign_table?: string | null, group?: string | null, parameters: Array<{ __typename?: 'QueryFilter', column: string, filterOp: FilterOp, value: { __typename?: 'QueryFilterValue', string?: string | null, float?: number | null, boolean?: boolean | null, stringArray?: Array<string> | null, floatArray?: Array<number> | null, millisFromNow?: number | null, relativeTime?: { __typename?: 'RelativeTime', quantity: number, unit: TimeUnit, direction: ReferenceDirection } | null } }> }> | null, any_inclusions?: Array<{ __typename?: 'SegmentFilter', foreign_table?: string | null, group?: string | null, parameters: Array<{ __typename?: 'QueryFilter', column: string, filterOp: FilterOp, value: { __typename?: 'QueryFilterValue', string?: string | null, float?: number | null, boolean?: boolean | null, stringArray?: Array<string> | null, floatArray?: Array<number> | null, millisFromNow?: number | null, relativeTime?: { __typename?: 'RelativeTime', quantity: number, unit: TimeUnit, direction: ReferenceDirection } | null } }> }> | null, any_exclusions?: Array<{ __typename?: 'SegmentFilter', foreign_table?: string | null, group?: string | null, parameters: Array<{ __typename?: 'QueryFilter', column: string, filterOp: FilterOp, value: { __typename?: 'QueryFilterValue', string?: string | null, float?: number | null, boolean?: boolean | null, stringArray?: Array<string> | null, floatArray?: Array<number> | null, millisFromNow?: number | null, relativeTime?: { __typename?: 'RelativeTime', quantity: number, unit: TimeUnit, direction: ReferenceDirection } | null } }> }> | null, any_other_exclusions?: Array<{ __typename?: 'SegmentFilter', foreign_table?: string | null, group?: string | null, parameters: Array<{ __typename?: 'QueryFilter', column: string, filterOp: FilterOp, value: { __typename?: 'QueryFilterValue', string?: string | null, float?: number | null, boolean?: boolean | null, stringArray?: Array<string> | null, floatArray?: Array<number> | null, millisFromNow?: number | null, relativeTime?: { __typename?: 'RelativeTime', quantity: number, unit: TimeUnit, direction: ReferenceDirection } | null } }> }> | null, filters?: Array<{ __typename?: 'CustomerSegmentFilter', filters: Array<{ __typename?: 'QueryFilter', column: string, filterOp: FilterOp, value: { __typename?: 'QueryFilterValue', string?: string | null, float?: number | null, boolean?: boolean | null, stringArray?: Array<string> | null, floatArray?: Array<number> | null, millisFromNow?: number | null, relativeTime?: { __typename?: 'RelativeTime', quantity: number, unit: TimeUnit, direction: ReferenceDirection } | null } }> }> | null, excluded_filters: Array<{ __typename?: 'CustomerSegmentFilter', filters: Array<{ __typename?: 'QueryFilter', column: string, filterOp: FilterOp, value: { __typename?: 'QueryFilterValue', string?: string | null, float?: number | null, boolean?: boolean | null, stringArray?: Array<string> | null, floatArray?: Array<number> | null, millisFromNow?: number | null, relativeTime?: { __typename?: 'RelativeTime', quantity: number, unit: TimeUnit, direction: ReferenceDirection } | null } }> }> } | null, webhooks?: Array<{ __typename?: 'WebhookConfig', id: string, name: string, url: string, events: Array<WebhookEventType>, secret?: string | null, enabled: boolean }> | null, times_first_filter_config?: { __typename?: 'TimesFirstFilterConfig', service?: BookingFilterDisplayMode | null, clinician?: BookingFilterDisplayMode | null, species?: BookingFilterDisplayMode | null, client_status?: BookingFilterDisplayMode | null, patient_status?: BookingFilterDisplayMode | null, patient_gender?: BookingFilterDisplayMode | null, fixed_status?: BookingFilterDisplayMode | null } | null } | null, clinic_group_clinics: Array<{ __typename?: 'ClinicGroupClinic', id: string, created_at: number, clinic: { __typename?: 'Clinic', id: string, name?: string | null, slug?: string | null, avatar_url?: string | null, time_zone?: string | null, is_archived: boolean, address?: { __typename?: 'Address', street_a?: string | null, street_b?: string | null, city?: string | null, state?: string | null, zip?: string | null, country?: string | null } | null, pms_db?: { __typename?: 'PmsDb', id: string } | null } }>, clinic_group_users: Array<{ __typename?: 'ClinicGroupUser', id: string, role: AuthRoles, are_email_notifications_enabled: boolean, are_sms_notifications_enabled: boolean, are_desktop_notifications_enabled: boolean, created_at: number, clinic_group: { __typename?: 'ClinicGroup', id: string }, user: { __typename?: 'User', id: string, email?: any | null, first_name?: string | null, last_name?: string | null, avatar_url?: string | null, invitation_status?: UserInvitationStatus | null }, custom_role?: { __typename?: 'CustomRole', id: string, name: string } | null, permissions?: Array<{ __typename?: 'ClinicAdminPermission', feature: AdminPermissionFeature, access_level: AdminPermissionAccessLevel }> | null }>, parent_clinic_group?: { __typename?: 'ClinicGroup', id: string, name: string } | null, clinic_groups: Array<{ __typename?: 'ClinicGroup', id: string, name: string, slug: string, is_archived: boolean, clinic_group_clinics: Array<{ __typename?: 'ClinicGroupClinic', id: string, created_at: number, clinic: { __typename?: 'Clinic', id: string, name?: string | null, slug?: string | null, avatar_url?: string | null, time_zone?: string | null, is_archived: boolean, address?: { __typename?: 'Address', street_a?: string | null, street_b?: string | null, city?: string | null, state?: string | null, zip?: string | null, country?: string | null } | null, pms_db?: { __typename?: 'PmsDb', id: string } | null } }> }> };

export type GetClinicGroupQueryVariables = Exact<{
  id: Scalars['ID']['input'];
}>;


export type GetClinicGroupQuery = { __typename?: 'Query', clinicGroup: { __typename?: 'ClinicGroup', id: string, name: string, slug: string, is_archived: boolean, created_at: number, updated_at: number, settings?: { __typename?: 'ClinicSettings', id?: string | null, does_require_verification?: boolean | null, does_use_automatic_reschedule?: boolean | null, reset_status_to_booked_on_reschedule?: boolean | null, is_using_detailed_services?: boolean | null, hide_review_step?: boolean | null, is_using_rooms?: boolean | null, pms_start_time?: any | null, pms_end_time?: any | null, primary_color?: string | null, accent_color?: string | null, secondary_color?: string | null, new_appt_requested_msg?: string | null, new_appt_approved_msg?: string | null, new_appt_approved_sms_msg?: string | null, new_appt_denied_msg?: string | null, schedule_method?: ScheduleMethod | null, scheduling_buffer_minutes?: number | null, base_schedule_duration?: number | null, does_require_referral?: boolean | null, appointment_entry_method?: AppointmentEntryMethod | null, scheduling_min_minutes_away?: number | null, scheduling_max_minutes_away?: number | null, included_species?: Array<Species> | null, max_patients_per_visit?: number | null, should_complete_sync?: boolean | null, server_syncing_only?: boolean | null, confirmation_days_before?: number | null, send_confirmations_to: SendConfirmationsTo, send_new_appt_email?: boolean | null, send_reviews_to?: SendConfirmationsTo | null, max_review_rating_for_notif?: number | null, google_review_link?: string | null, facebook_review_link?: string | null, non_blocking_services: Array<string>, yesterday_revenue?: number | null, this_month_revenue?: number | null, hide_clinician_preference: boolean, does_use_rooms_to_schedule?: boolean | null, primary_room_pms_id?: string | null, should_default_pims_emails_on: boolean, should_default_pims_sms_on: boolean, should_default_marketing_sms_on: boolean, should_default_marketing_email_on: boolean, does_use_clinicians_to_schedule?: boolean | null, time_slot_minutes: number, sync_interval_minutes: number, long_sync_interval_hours: number, primary_clinician_pms_id?: string | null, cancellation_clinician_pms_id?: string | null, cancellation_service_pms_id?: string | null, allow_first_appt_per_day?: boolean | null, custom_well_description?: string | null, custom_sick_description?: string | null, custom_other_title?: string | null, custom_other_description?: string | null, default_trigger_words?: Array<string> | null, should_use_private_reviews?: boolean | null, notify_clinic_on?: Array<NotifyClinicOn> | null, reminder_send_time_minutes?: number | null, does_require_new_client_address?: boolean | null, does_require_new_client_birthday?: boolean | null, should_allow_new_clients?: boolean | null, should_allow_new_patients?: boolean | null, should_create_clients?: boolean | null, should_create_patients?: boolean | null, msgs_auto_priority?: boolean | null, booking_match_procedure?: BookingMatchProcedure | null, urgency_type?: UrgencyType | null, max_booking_columns?: number | null, hide_closed_days_from_scheduling?: boolean | null, should_sync_reminders?: boolean | null, auto_reply_enabled: boolean, auto_reply_message?: string | null, unreplied_message_alert_enabled: boolean, unreplied_message_alert_minutes: number, comms_writeback_enabled: boolean, comms_should_daily_writeback: boolean, comms_use_pdf_for_writeback: boolean, comms_writeback_buffer_minutes: number, comms_writeback_before_appt_mins: number, comms_should_writeback_on_send: boolean, comms_should_writeback_on_receive: boolean, comms_should_writeback_notifs: boolean, comms_should_use_ai_writeback: boolean, form_writeback_enabled: boolean, should_award_loyalty_for_invoices?: boolean | null, invoice_loyalty_points_per_dollar?: number | null, app_download_loyalty_points?: number | null, referrer_loyalty_points?: number | null, referred_loyalty_points?: number | null, custom_appointment_notes_template?: string | null, custom_new_client_notes_template?: string | null, custom_new_patient_notes_template?: string | null, max_inactivity_duration?: number | null, hide_portal_vaccinations: boolean, hide_portal_reminders: boolean, hide_portal_prescriptions: boolean, hide_portal_weight: boolean, hide_soc_vaccinations?: boolean | null, hide_historic_vaccinations?: boolean | null, should_hide_daily_huddle_financials: boolean, patient_details_tab_order: Array<PortalPatientDetailsTab>, clinic_hours_display?: string | null, reschedule_buffer_minutes?: number | null, cancellation_buffer_minutes?: number | null, require_reason_for_cancellation?: boolean | null, should_automatically_assign_patient?: boolean | null, payment_writeback_enabled: boolean, auto_refund_on_cancel: boolean, status_set_on_payment_completed_pms_id?: string | null, max_booking_notes_length?: number | null, min_booking_notes_length?: number | null, primary_clinic_group_id?: string | null, should_suggest_nearby_clinics?: boolean | null, sms_block_list?: Array<string> | null, exclude_message_wrapper?: boolean | null, should_charge_client_stripe_fees?: boolean | null, chckvet_prescription_fee_split_percentage?: number | null, gtm_container_id?: string | null, review_google_id?: string | null, review_facebook_id?: string | null, only_use_adj_avail_guides: boolean, use_basic_timeslots: boolean, valid_booking_interval_minutes?: Array<number> | null, should_disable_online_scheduling?: boolean | null, simple_scheduling_rules_enabled: boolean, compliance_statuses?: Array<string> | null, should_use_instant_prescription_requests?: boolean | null, prescription_pickup_service_id?: string | null, default_reminder_service_id?: string | null, ai_calls_provider?: PhoneProviderType | null, ai_calls_phone_number?: string | null, ai_calls_voice_id?: string | null, ai_calls_agent_id?: string | null, ai_agent_style?: string | null, ai_agent_custom_instructions?: string | null, ai_calls_ambient_sound?: AiCallsAmbientSound | null, ai_calls_voice_speed?: number | null, ai_calls_interruption_sensitivity?: number | null, ai_calls_enable_dynamic_voice_speed?: boolean | null, usage_spending_caps?: any | null, custom_merge_tags?: any | null, custom_booking_copy?: { __typename?: 'ClinicBookingCopy', WIDGET_HEADER_TITLE?: string | null, SHOW_CLINIC_HEADER_LOGO?: boolean | null, CLINIC_HEADER_LOGO_HEIGHT?: number | null, SERVICE_TYPE_SECTION_HEADING?: string | null, DEFAULT_WELLNESS_DESCRIPTION?: string | null, DEFAULT_SICK_DESCRIPTION?: string | null, DEFAULT_OTHER_DESCRIPTION?: string | null, RETURNING_PATIENT_QUESTION?: string | null, POSITIVE_RETURNING_PATIENT_ANSWER?: string | null, NEGATIVE_RETURNING_PATIENT_ANSWER?: string | null, RETURNING_CLIENT_QUESTION?: string | null, POSITIVE_RETURNING_CLIENT_ANSWER?: string | null, NEGATIVE_RETURNING_CLIENT_ANSWER?: string | null, CLIENT_INFORMATION_SECTION_TITLE?: string | null, PATIENT_INFORMATION_SECTION_TITLE?: string | null, RETURNING_CLIENT_PATIENT_TITLE?: string | null, RETURNING_CLIENT_PATIENT_DESCRIPTION?: string | null, SERVICE_SECTION_TITLE?: string | null, PREPAID_SERVICES_LABEL?: string | null, STANDARD_SERVICES_LABEL?: string | null, DEPOSIT_FEE_NAME?: string | null, PREVIOUS_OR_REFERRING_CLINIC_QUESTION?: string | null, CONTACT_THE_CLINIC_TEXT?: string | null, CONTACT_THE_CLINIC_TEXT_COLOR?: string | null, CONTACT_THE_CLINIC_TEXT_SIZE?: string | null, SELECT_CLINICIAN_TITLE?: string | null, SELECT_CLINICIAN_POSITIVE_ANSWER?: string | null, SELECT_CLINICIAN_NEGATIVE_ANSWER?: string | null, SELECT_TIME_TITLE?: string | null, REVIEW_TITLE?: string | null, REVIEW_NOTES_PROMPT?: string | null, PAYMENT_INFORMATION_TITLE?: string | null, TRIGGER_WORDS_DETECTED_HEADER?: string | null, TRIGGER_WORDS_DETECTED_DESCRIPTION?: string | null, CONFIRMATION_SCREEN_TITLE?: string | null, CONFIRMATION_SCREEN_DESCRIPTION?: string | null, NEW_CLIENT_BLOCKED_MESSAGE?: string | null, NEW_PATIENT_BLOCKED_MESSAGE?: string | null } | null, auto_reply_hours?: { __typename?: 'AvailabilityHours', monday?: Array<{ __typename?: 'TimeInterval', start?: number | null, end?: number | null }> | null, tuesday?: Array<{ __typename?: 'TimeInterval', start?: number | null, end?: number | null }> | null, wednesday?: Array<{ __typename?: 'TimeInterval', start?: number | null, end?: number | null }> | null, thursday?: Array<{ __typename?: 'TimeInterval', start?: number | null, end?: number | null }> | null, friday?: Array<{ __typename?: 'TimeInterval', start?: number | null, end?: number | null }> | null, saturday?: Array<{ __typename?: 'TimeInterval', start?: number | null, end?: number | null }> | null, sunday?: Array<{ __typename?: 'TimeInterval', start?: number | null, end?: number | null }> | null } | null, portal_links?: Array<{ __typename?: 'PortalLink', label: string, url: string }> | null, custom_reviews_copy?: { __typename?: 'ClinicReviewsCopy', REVIEW_METHOD_PAGE_TITLE?: string | null, REVIEW_METHOD_PAGE_DESCRIPTION?: string | null, PRIVATE_REVIEW_BUTTON_HELP_TEXT?: string | null, PRIVATE_REVIEW_BUTTON_TEXT?: string | null, REVIEW_PAGE_TITLE?: string | null, REVIEW_PAGE_SUBTITLE?: string | null, REVIEW_SCORE_LABEL?: string | null, REVIEW_MESSAGE_LABEL?: string | null, REVIEW_SUBMIT_BUTTON_TEXT?: string | null } | null, waitlist_customer_segment?: { __typename?: 'CustomerSegment', id: string, name: string, trigger_entity?: CustomerSegmentTrigger | null, is_archived: boolean, updated_at: number, notification_templates?: Array<{ __typename?: 'NotificationTemplate', id: string, name: string, is_active: boolean, is_archived: boolean, message_methods: Array<MessageMethod> }> | null, error_flags?: Array<{ __typename?: 'CustomerSegmentErrorFlag', filter_column: string, filter_index: number, parameter_index: number, message: string }> | null, all_inclusions?: Array<{ __typename?: 'SegmentFilter', foreign_table?: string | null, group?: string | null, parameters: Array<{ __typename?: 'QueryFilter', column: string, filterOp: FilterOp, value: { __typename?: 'QueryFilterValue', string?: string | null, float?: number | null, boolean?: boolean | null, stringArray?: Array<string> | null, floatArray?: Array<number> | null, millisFromNow?: number | null, relativeTime?: { __typename?: 'RelativeTime', quantity: number, unit: TimeUnit, direction: ReferenceDirection } | null } }> }> | null, any_inclusions?: Array<{ __typename?: 'SegmentFilter', foreign_table?: string | null, group?: string | null, parameters: Array<{ __typename?: 'QueryFilter', column: string, filterOp: FilterOp, value: { __typename?: 'QueryFilterValue', string?: string | null, float?: number | null, boolean?: boolean | null, stringArray?: Array<string> | null, floatArray?: Array<number> | null, millisFromNow?: number | null, relativeTime?: { __typename?: 'RelativeTime', quantity: number, unit: TimeUnit, direction: ReferenceDirection } | null } }> }> | null, any_exclusions?: Array<{ __typename?: 'SegmentFilter', foreign_table?: string | null, group?: string | null, parameters: Array<{ __typename?: 'QueryFilter', column: string, filterOp: FilterOp, value: { __typename?: 'QueryFilterValue', string?: string | null, float?: number | null, boolean?: boolean | null, stringArray?: Array<string> | null, floatArray?: Array<number> | null, millisFromNow?: number | null, relativeTime?: { __typename?: 'RelativeTime', quantity: number, unit: TimeUnit, direction: ReferenceDirection } | null } }> }> | null, any_other_exclusions?: Array<{ __typename?: 'SegmentFilter', foreign_table?: string | null, group?: string | null, parameters: Array<{ __typename?: 'QueryFilter', column: string, filterOp: FilterOp, value: { __typename?: 'QueryFilterValue', string?: string | null, float?: number | null, boolean?: boolean | null, stringArray?: Array<string> | null, floatArray?: Array<number> | null, millisFromNow?: number | null, relativeTime?: { __typename?: 'RelativeTime', quantity: number, unit: TimeUnit, direction: ReferenceDirection } | null } }> }> | null, filters?: Array<{ __typename?: 'CustomerSegmentFilter', filters: Array<{ __typename?: 'QueryFilter', column: string, filterOp: FilterOp, value: { __typename?: 'QueryFilterValue', string?: string | null, float?: number | null, boolean?: boolean | null, stringArray?: Array<string> | null, floatArray?: Array<number> | null, millisFromNow?: number | null, relativeTime?: { __typename?: 'RelativeTime', quantity: number, unit: TimeUnit, direction: ReferenceDirection } | null } }> }> | null, excluded_filters: Array<{ __typename?: 'CustomerSegmentFilter', filters: Array<{ __typename?: 'QueryFilter', column: string, filterOp: FilterOp, value: { __typename?: 'QueryFilterValue', string?: string | null, float?: number | null, boolean?: boolean | null, stringArray?: Array<string> | null, floatArray?: Array<number> | null, millisFromNow?: number | null, relativeTime?: { __typename?: 'RelativeTime', quantity: number, unit: TimeUnit, direction: ReferenceDirection } | null } }> }> } | null, blocklist_customer_segment?: { __typename?: 'CustomerSegment', id: string, name: string, trigger_entity?: CustomerSegmentTrigger | null, is_archived: boolean, updated_at: number, notification_templates?: Array<{ __typename?: 'NotificationTemplate', id: string, name: string, is_active: boolean, is_archived: boolean, message_methods: Array<MessageMethod> }> | null, error_flags?: Array<{ __typename?: 'CustomerSegmentErrorFlag', filter_column: string, filter_index: number, parameter_index: number, message: string }> | null, all_inclusions?: Array<{ __typename?: 'SegmentFilter', foreign_table?: string | null, group?: string | null, parameters: Array<{ __typename?: 'QueryFilter', column: string, filterOp: FilterOp, value: { __typename?: 'QueryFilterValue', string?: string | null, float?: number | null, boolean?: boolean | null, stringArray?: Array<string> | null, floatArray?: Array<number> | null, millisFromNow?: number | null, relativeTime?: { __typename?: 'RelativeTime', quantity: number, unit: TimeUnit, direction: ReferenceDirection } | null } }> }> | null, any_inclusions?: Array<{ __typename?: 'SegmentFilter', foreign_table?: string | null, group?: string | null, parameters: Array<{ __typename?: 'QueryFilter', column: string, filterOp: FilterOp, value: { __typename?: 'QueryFilterValue', string?: string | null, float?: number | null, boolean?: boolean | null, stringArray?: Array<string> | null, floatArray?: Array<number> | null, millisFromNow?: number | null, relativeTime?: { __typename?: 'RelativeTime', quantity: number, unit: TimeUnit, direction: ReferenceDirection } | null } }> }> | null, any_exclusions?: Array<{ __typename?: 'SegmentFilter', foreign_table?: string | null, group?: string | null, parameters: Array<{ __typename?: 'QueryFilter', column: string, filterOp: FilterOp, value: { __typename?: 'QueryFilterValue', string?: string | null, float?: number | null, boolean?: boolean | null, stringArray?: Array<string> | null, floatArray?: Array<number> | null, millisFromNow?: number | null, relativeTime?: { __typename?: 'RelativeTime', quantity: number, unit: TimeUnit, direction: ReferenceDirection } | null } }> }> | null, any_other_exclusions?: Array<{ __typename?: 'SegmentFilter', foreign_table?: string | null, group?: string | null, parameters: Array<{ __typename?: 'QueryFilter', column: string, filterOp: FilterOp, value: { __typename?: 'QueryFilterValue', string?: string | null, float?: number | null, boolean?: boolean | null, stringArray?: Array<string> | null, floatArray?: Array<number> | null, millisFromNow?: number | null, relativeTime?: { __typename?: 'RelativeTime', quantity: number, unit: TimeUnit, direction: ReferenceDirection } | null } }> }> | null, filters?: Array<{ __typename?: 'CustomerSegmentFilter', filters: Array<{ __typename?: 'QueryFilter', column: string, filterOp: FilterOp, value: { __typename?: 'QueryFilterValue', string?: string | null, float?: number | null, boolean?: boolean | null, stringArray?: Array<string> | null, floatArray?: Array<number> | null, millisFromNow?: number | null, relativeTime?: { __typename?: 'RelativeTime', quantity: number, unit: TimeUnit, direction: ReferenceDirection } | null } }> }> | null, excluded_filters: Array<{ __typename?: 'CustomerSegmentFilter', filters: Array<{ __typename?: 'QueryFilter', column: string, filterOp: FilterOp, value: { __typename?: 'QueryFilterValue', string?: string | null, float?: number | null, boolean?: boolean | null, stringArray?: Array<string> | null, floatArray?: Array<number> | null, millisFromNow?: number | null, relativeTime?: { __typename?: 'RelativeTime', quantity: number, unit: TimeUnit, direction: ReferenceDirection } | null } }> }> } | null, referral_customer_segment?: { __typename?: 'CustomerSegment', id: string, name: string, trigger_entity?: CustomerSegmentTrigger | null, is_archived: boolean, updated_at: number, notification_templates?: Array<{ __typename?: 'NotificationTemplate', id: string, name: string, is_active: boolean, is_archived: boolean, message_methods: Array<MessageMethod> }> | null, error_flags?: Array<{ __typename?: 'CustomerSegmentErrorFlag', filter_column: string, filter_index: number, parameter_index: number, message: string }> | null, all_inclusions?: Array<{ __typename?: 'SegmentFilter', foreign_table?: string | null, group?: string | null, parameters: Array<{ __typename?: 'QueryFilter', column: string, filterOp: FilterOp, value: { __typename?: 'QueryFilterValue', string?: string | null, float?: number | null, boolean?: boolean | null, stringArray?: Array<string> | null, floatArray?: Array<number> | null, millisFromNow?: number | null, relativeTime?: { __typename?: 'RelativeTime', quantity: number, unit: TimeUnit, direction: ReferenceDirection } | null } }> }> | null, any_inclusions?: Array<{ __typename?: 'SegmentFilter', foreign_table?: string | null, group?: string | null, parameters: Array<{ __typename?: 'QueryFilter', column: string, filterOp: FilterOp, value: { __typename?: 'QueryFilterValue', string?: string | null, float?: number | null, boolean?: boolean | null, stringArray?: Array<string> | null, floatArray?: Array<number> | null, millisFromNow?: number | null, relativeTime?: { __typename?: 'RelativeTime', quantity: number, unit: TimeUnit, direction: ReferenceDirection } | null } }> }> | null, any_exclusions?: Array<{ __typename?: 'SegmentFilter', foreign_table?: string | null, group?: string | null, parameters: Array<{ __typename?: 'QueryFilter', column: string, filterOp: FilterOp, value: { __typename?: 'QueryFilterValue', string?: string | null, float?: number | null, boolean?: boolean | null, stringArray?: Array<string> | null, floatArray?: Array<number> | null, millisFromNow?: number | null, relativeTime?: { __typename?: 'RelativeTime', quantity: number, unit: TimeUnit, direction: ReferenceDirection } | null } }> }> | null, any_other_exclusions?: Array<{ __typename?: 'SegmentFilter', foreign_table?: string | null, group?: string | null, parameters: Array<{ __typename?: 'QueryFilter', column: string, filterOp: FilterOp, value: { __typename?: 'QueryFilterValue', string?: string | null, float?: number | null, boolean?: boolean | null, stringArray?: Array<string> | null, floatArray?: Array<number> | null, millisFromNow?: number | null, relativeTime?: { __typename?: 'RelativeTime', quantity: number, unit: TimeUnit, direction: ReferenceDirection } | null } }> }> | null, filters?: Array<{ __typename?: 'CustomerSegmentFilter', filters: Array<{ __typename?: 'QueryFilter', column: string, filterOp: FilterOp, value: { __typename?: 'QueryFilterValue', string?: string | null, float?: number | null, boolean?: boolean | null, stringArray?: Array<string> | null, floatArray?: Array<number> | null, millisFromNow?: number | null, relativeTime?: { __typename?: 'RelativeTime', quantity: number, unit: TimeUnit, direction: ReferenceDirection } | null } }> }> | null, excluded_filters: Array<{ __typename?: 'CustomerSegmentFilter', filters: Array<{ __typename?: 'QueryFilter', column: string, filterOp: FilterOp, value: { __typename?: 'QueryFilterValue', string?: string | null, float?: number | null, boolean?: boolean | null, stringArray?: Array<string> | null, floatArray?: Array<number> | null, millisFromNow?: number | null, relativeTime?: { __typename?: 'RelativeTime', quantity: number, unit: TimeUnit, direction: ReferenceDirection } | null } }> }> } | null, webhooks?: Array<{ __typename?: 'WebhookConfig', id: string, name: string, url: string, events: Array<WebhookEventType>, secret?: string | null, enabled: boolean }> | null, times_first_filter_config?: { __typename?: 'TimesFirstFilterConfig', service?: BookingFilterDisplayMode | null, clinician?: BookingFilterDisplayMode | null, species?: BookingFilterDisplayMode | null, client_status?: BookingFilterDisplayMode | null, patient_status?: BookingFilterDisplayMode | null, patient_gender?: BookingFilterDisplayMode | null, fixed_status?: BookingFilterDisplayMode | null } | null } | null, clinic_group_clinics: Array<{ __typename?: 'ClinicGroupClinic', id: string, created_at: number, clinic: { __typename?: 'Clinic', id: string, name?: string | null, slug?: string | null, avatar_url?: string | null, time_zone?: string | null, is_archived: boolean, address?: { __typename?: 'Address', street_a?: string | null, street_b?: string | null, city?: string | null, state?: string | null, zip?: string | null, country?: string | null } | null, pms_db?: { __typename?: 'PmsDb', id: string } | null } }>, clinic_group_users: Array<{ __typename?: 'ClinicGroupUser', id: string, role: AuthRoles, are_email_notifications_enabled: boolean, are_sms_notifications_enabled: boolean, are_desktop_notifications_enabled: boolean, created_at: number, clinic_group: { __typename?: 'ClinicGroup', id: string }, user: { __typename?: 'User', id: string, email?: any | null, first_name?: string | null, last_name?: string | null, avatar_url?: string | null, invitation_status?: UserInvitationStatus | null }, custom_role?: { __typename?: 'CustomRole', id: string, name: string } | null, permissions?: Array<{ __typename?: 'ClinicAdminPermission', feature: AdminPermissionFeature, access_level: AdminPermissionAccessLevel }> | null }>, parent_clinic_group?: { __typename?: 'ClinicGroup', id: string, name: string } | null, clinic_groups: Array<{ __typename?: 'ClinicGroup', id: string, name: string, slug: string, is_archived: boolean, clinic_group_clinics: Array<{ __typename?: 'ClinicGroupClinic', id: string, created_at: number, clinic: { __typename?: 'Clinic', id: string, name?: string | null, slug?: string | null, avatar_url?: string | null, time_zone?: string | null, is_archived: boolean, address?: { __typename?: 'Address', street_a?: string | null, street_b?: string | null, city?: string | null, state?: string | null, zip?: string | null, country?: string | null } | null, pms_db?: { __typename?: 'PmsDb', id: string } | null } }> }> } };

export type GetClinicGroupUsersQueryVariables = Exact<{
  id: Scalars['ID']['input'];
}>;


export type GetClinicGroupUsersQuery = { __typename?: 'Query', clinicGroup: { __typename?: 'ClinicGroup', clinic_group_users: Array<{ __typename?: 'ClinicGroupUser', id: string, role: AuthRoles, are_email_notifications_enabled: boolean, are_sms_notifications_enabled: boolean, are_desktop_notifications_enabled: boolean, created_at: number, clinic_group: { __typename?: 'ClinicGroup', id: string }, user: { __typename?: 'User', id: string, email?: any | null, first_name?: string | null, last_name?: string | null, avatar_url?: string | null, invitation_status?: UserInvitationStatus | null }, custom_role?: { __typename?: 'CustomRole', id: string, name: string } | null, permissions?: Array<{ __typename?: 'ClinicAdminPermission', feature: AdminPermissionFeature, access_level: AdminPermissionAccessLevel }> | null }> } };

export type GetClinicGroupUserQueryVariables = Exact<{
  id: Scalars['ID']['input'];
}>;


export type GetClinicGroupUserQuery = { __typename?: 'Query', clinicGroupUser?: { __typename?: 'ClinicGroupUser', id: string, role: AuthRoles, are_email_notifications_enabled: boolean, are_sms_notifications_enabled: boolean, are_desktop_notifications_enabled: boolean, created_at: number, clinic_group: { __typename?: 'ClinicGroup', id: string }, user: { __typename?: 'User', id: string, email?: any | null, first_name?: string | null, last_name?: string | null, avatar_url?: string | null, invitation_status?: UserInvitationStatus | null }, custom_role?: { __typename?: 'CustomRole', id: string, name: string } | null, permissions?: Array<{ __typename?: 'ClinicAdminPermission', feature: AdminPermissionFeature, access_level: AdminPermissionAccessLevel }> | null } | null };

export type GetClinicGroupUserByGroupAndUserQueryVariables = Exact<{
  clinicGroupId: Scalars['ID']['input'];
  userId: Scalars['ID']['input'];
}>;


export type GetClinicGroupUserByGroupAndUserQuery = { __typename?: 'Query', clinicGroupUserByGroupAndUser?: { __typename?: 'ClinicGroupUser', id: string, role: AuthRoles, are_email_notifications_enabled: boolean, are_sms_notifications_enabled: boolean, are_desktop_notifications_enabled: boolean, created_at: number, clinic_group: { __typename?: 'ClinicGroup', id: string }, user: { __typename?: 'User', id: string, email?: any | null, first_name?: string | null, last_name?: string | null, avatar_url?: string | null, invitation_status?: UserInvitationStatus | null }, custom_role?: { __typename?: 'CustomRole', id: string, name: string } | null, permissions?: Array<{ __typename?: 'ClinicAdminPermission', feature: AdminPermissionFeature, access_level: AdminPermissionAccessLevel }> | null } | null };

export type QueryClinicGroupUsersQueryVariables = Exact<{
  clinicGroupId: Scalars['ID']['input'];
  where?: InputMaybe<Array<QueryInput> | QueryInput>;
  page?: InputMaybe<Scalars['NonNegativeInt']['input']>;
  pageSize?: InputMaybe<Scalars['NonNegativeInt']['input']>;
  orderBy?: InputMaybe<OrderByInput>;
}>;


export type QueryClinicGroupUsersQuery = { __typename?: 'Query', queryClinicGroupUsers: Array<{ __typename?: 'ClinicGroupUser', id: string, role: AuthRoles, are_email_notifications_enabled: boolean, are_sms_notifications_enabled: boolean, are_desktop_notifications_enabled: boolean, created_at: number, clinic_group: { __typename?: 'ClinicGroup', id: string }, user: { __typename?: 'User', id: string, email?: any | null, first_name?: string | null, last_name?: string | null, avatar_url?: string | null, invitation_status?: UserInvitationStatus | null }, custom_role?: { __typename?: 'CustomRole', id: string, name: string } | null, permissions?: Array<{ __typename?: 'ClinicAdminPermission', feature: AdminPermissionFeature, access_level: AdminPermissionAccessLevel }> | null }> };

export type CountClinicGroupUsersQueryVariables = Exact<{
  clinicGroupId: Scalars['ID']['input'];
  where?: InputMaybe<Array<QueryInput> | QueryInput>;
}>;


export type CountClinicGroupUsersQuery = { __typename?: 'Query', countClinicGroupUsers: number };

export type QueryClinicGroupClinicsQueryVariables = Exact<{
  where?: InputMaybe<Array<QueryInput> | QueryInput>;
  page?: InputMaybe<Scalars['NonNegativeInt']['input']>;
  pageSize?: InputMaybe<Scalars['NonNegativeInt']['input']>;
  orderBy?: InputMaybe<OrderByInput>;
}>;


export type QueryClinicGroupClinicsQuery = { __typename?: 'Query', queryClinicGroupClinics: Array<{ __typename?: 'ClinicGroupClinic', id: string, created_at: number, clinic_group: { __typename?: 'ClinicGroup', id: string, name: string, slug: string, clinic_group_clinics: Array<{ __typename?: 'ClinicGroupClinic', id: string, created_at: number, clinic: { __typename?: 'Clinic', id: string, name?: string | null, slug?: string | null, avatar_url?: string | null, time_zone?: string | null, is_archived: boolean, address?: { __typename?: 'Address', street_a?: string | null, street_b?: string | null, city?: string | null, state?: string | null, zip?: string | null, country?: string | null } | null, pms_db?: { __typename?: 'PmsDb', id: string } | null } }> }, clinic: { __typename?: 'Clinic', id: string, name?: string | null, slug?: string | null, avatar_url?: string | null, time_zone?: string | null, is_archived: boolean, address?: { __typename?: 'Address', street_a?: string | null, street_b?: string | null, city?: string | null, state?: string | null, zip?: string | null, country?: string | null } | null, pms_db?: { __typename?: 'PmsDb', id: string } | null } }> };

export type CountClinicGroupClinicsQueryVariables = Exact<{
  where?: InputMaybe<Array<QueryInput> | QueryInput>;
}>;


export type CountClinicGroupClinicsQuery = { __typename?: 'Query', countClinicGroupClinics: number };

export type GetClinicGroupsForUserQueryVariables = Exact<{
  userId: Scalars['ID']['input'];
  page?: InputMaybe<Scalars['NonNegativeInt']['input']>;
  pageSize?: InputMaybe<Scalars['NonNegativeInt']['input']>;
}>;


export type GetClinicGroupsForUserQuery = { __typename?: 'Query', getClinicGroupsForUser: Array<{ __typename?: 'ClinicGroup', id: string, name: string, slug: string, is_archived: boolean, created_at: number, updated_at: number, settings?: { __typename?: 'ClinicSettings', id?: string | null, does_require_verification?: boolean | null, does_use_automatic_reschedule?: boolean | null, reset_status_to_booked_on_reschedule?: boolean | null, is_using_detailed_services?: boolean | null, hide_review_step?: boolean | null, is_using_rooms?: boolean | null, pms_start_time?: any | null, pms_end_time?: any | null, primary_color?: string | null, accent_color?: string | null, secondary_color?: string | null, new_appt_requested_msg?: string | null, new_appt_approved_msg?: string | null, new_appt_approved_sms_msg?: string | null, new_appt_denied_msg?: string | null, schedule_method?: ScheduleMethod | null, scheduling_buffer_minutes?: number | null, base_schedule_duration?: number | null, does_require_referral?: boolean | null, appointment_entry_method?: AppointmentEntryMethod | null, scheduling_min_minutes_away?: number | null, scheduling_max_minutes_away?: number | null, included_species?: Array<Species> | null, max_patients_per_visit?: number | null, should_complete_sync?: boolean | null, server_syncing_only?: boolean | null, confirmation_days_before?: number | null, send_confirmations_to: SendConfirmationsTo, send_new_appt_email?: boolean | null, send_reviews_to?: SendConfirmationsTo | null, max_review_rating_for_notif?: number | null, google_review_link?: string | null, facebook_review_link?: string | null, non_blocking_services: Array<string>, yesterday_revenue?: number | null, this_month_revenue?: number | null, hide_clinician_preference: boolean, does_use_rooms_to_schedule?: boolean | null, primary_room_pms_id?: string | null, should_default_pims_emails_on: boolean, should_default_pims_sms_on: boolean, should_default_marketing_sms_on: boolean, should_default_marketing_email_on: boolean, does_use_clinicians_to_schedule?: boolean | null, time_slot_minutes: number, sync_interval_minutes: number, long_sync_interval_hours: number, primary_clinician_pms_id?: string | null, cancellation_clinician_pms_id?: string | null, cancellation_service_pms_id?: string | null, allow_first_appt_per_day?: boolean | null, custom_well_description?: string | null, custom_sick_description?: string | null, custom_other_title?: string | null, custom_other_description?: string | null, default_trigger_words?: Array<string> | null, should_use_private_reviews?: boolean | null, notify_clinic_on?: Array<NotifyClinicOn> | null, reminder_send_time_minutes?: number | null, does_require_new_client_address?: boolean | null, does_require_new_client_birthday?: boolean | null, should_allow_new_clients?: boolean | null, should_allow_new_patients?: boolean | null, should_create_clients?: boolean | null, should_create_patients?: boolean | null, msgs_auto_priority?: boolean | null, booking_match_procedure?: BookingMatchProcedure | null, urgency_type?: UrgencyType | null, max_booking_columns?: number | null, hide_closed_days_from_scheduling?: boolean | null, should_sync_reminders?: boolean | null, auto_reply_enabled: boolean, auto_reply_message?: string | null, unreplied_message_alert_enabled: boolean, unreplied_message_alert_minutes: number, comms_writeback_enabled: boolean, comms_should_daily_writeback: boolean, comms_use_pdf_for_writeback: boolean, comms_writeback_buffer_minutes: number, comms_writeback_before_appt_mins: number, comms_should_writeback_on_send: boolean, comms_should_writeback_on_receive: boolean, comms_should_writeback_notifs: boolean, comms_should_use_ai_writeback: boolean, form_writeback_enabled: boolean, should_award_loyalty_for_invoices?: boolean | null, invoice_loyalty_points_per_dollar?: number | null, app_download_loyalty_points?: number | null, referrer_loyalty_points?: number | null, referred_loyalty_points?: number | null, custom_appointment_notes_template?: string | null, custom_new_client_notes_template?: string | null, custom_new_patient_notes_template?: string | null, max_inactivity_duration?: number | null, hide_portal_vaccinations: boolean, hide_portal_reminders: boolean, hide_portal_prescriptions: boolean, hide_portal_weight: boolean, hide_soc_vaccinations?: boolean | null, hide_historic_vaccinations?: boolean | null, should_hide_daily_huddle_financials: boolean, patient_details_tab_order: Array<PortalPatientDetailsTab>, clinic_hours_display?: string | null, reschedule_buffer_minutes?: number | null, cancellation_buffer_minutes?: number | null, require_reason_for_cancellation?: boolean | null, should_automatically_assign_patient?: boolean | null, payment_writeback_enabled: boolean, auto_refund_on_cancel: boolean, status_set_on_payment_completed_pms_id?: string | null, max_booking_notes_length?: number | null, min_booking_notes_length?: number | null, primary_clinic_group_id?: string | null, should_suggest_nearby_clinics?: boolean | null, sms_block_list?: Array<string> | null, exclude_message_wrapper?: boolean | null, should_charge_client_stripe_fees?: boolean | null, chckvet_prescription_fee_split_percentage?: number | null, gtm_container_id?: string | null, review_google_id?: string | null, review_facebook_id?: string | null, only_use_adj_avail_guides: boolean, use_basic_timeslots: boolean, valid_booking_interval_minutes?: Array<number> | null, should_disable_online_scheduling?: boolean | null, simple_scheduling_rules_enabled: boolean, compliance_statuses?: Array<string> | null, should_use_instant_prescription_requests?: boolean | null, prescription_pickup_service_id?: string | null, default_reminder_service_id?: string | null, ai_calls_provider?: PhoneProviderType | null, ai_calls_phone_number?: string | null, ai_calls_voice_id?: string | null, ai_calls_agent_id?: string | null, ai_agent_style?: string | null, ai_agent_custom_instructions?: string | null, ai_calls_ambient_sound?: AiCallsAmbientSound | null, ai_calls_voice_speed?: number | null, ai_calls_interruption_sensitivity?: number | null, ai_calls_enable_dynamic_voice_speed?: boolean | null, usage_spending_caps?: any | null, custom_merge_tags?: any | null, custom_booking_copy?: { __typename?: 'ClinicBookingCopy', WIDGET_HEADER_TITLE?: string | null, SHOW_CLINIC_HEADER_LOGO?: boolean | null, CLINIC_HEADER_LOGO_HEIGHT?: number | null, SERVICE_TYPE_SECTION_HEADING?: string | null, DEFAULT_WELLNESS_DESCRIPTION?: string | null, DEFAULT_SICK_DESCRIPTION?: string | null, DEFAULT_OTHER_DESCRIPTION?: string | null, RETURNING_PATIENT_QUESTION?: string | null, POSITIVE_RETURNING_PATIENT_ANSWER?: string | null, NEGATIVE_RETURNING_PATIENT_ANSWER?: string | null, RETURNING_CLIENT_QUESTION?: string | null, POSITIVE_RETURNING_CLIENT_ANSWER?: string | null, NEGATIVE_RETURNING_CLIENT_ANSWER?: string | null, CLIENT_INFORMATION_SECTION_TITLE?: string | null, PATIENT_INFORMATION_SECTION_TITLE?: string | null, RETURNING_CLIENT_PATIENT_TITLE?: string | null, RETURNING_CLIENT_PATIENT_DESCRIPTION?: string | null, SERVICE_SECTION_TITLE?: string | null, PREPAID_SERVICES_LABEL?: string | null, STANDARD_SERVICES_LABEL?: string | null, DEPOSIT_FEE_NAME?: string | null, PREVIOUS_OR_REFERRING_CLINIC_QUESTION?: string | null, CONTACT_THE_CLINIC_TEXT?: string | null, CONTACT_THE_CLINIC_TEXT_COLOR?: string | null, CONTACT_THE_CLINIC_TEXT_SIZE?: string | null, SELECT_CLINICIAN_TITLE?: string | null, SELECT_CLINICIAN_POSITIVE_ANSWER?: string | null, SELECT_CLINICIAN_NEGATIVE_ANSWER?: string | null, SELECT_TIME_TITLE?: string | null, REVIEW_TITLE?: string | null, REVIEW_NOTES_PROMPT?: string | null, PAYMENT_INFORMATION_TITLE?: string | null, TRIGGER_WORDS_DETECTED_HEADER?: string | null, TRIGGER_WORDS_DETECTED_DESCRIPTION?: string | null, CONFIRMATION_SCREEN_TITLE?: string | null, CONFIRMATION_SCREEN_DESCRIPTION?: string | null, NEW_CLIENT_BLOCKED_MESSAGE?: string | null, NEW_PATIENT_BLOCKED_MESSAGE?: string | null } | null, auto_reply_hours?: { __typename?: 'AvailabilityHours', monday?: Array<{ __typename?: 'TimeInterval', start?: number | null, end?: number | null }> | null, tuesday?: Array<{ __typename?: 'TimeInterval', start?: number | null, end?: number | null }> | null, wednesday?: Array<{ __typename?: 'TimeInterval', start?: number | null, end?: number | null }> | null, thursday?: Array<{ __typename?: 'TimeInterval', start?: number | null, end?: number | null }> | null, friday?: Array<{ __typename?: 'TimeInterval', start?: number | null, end?: number | null }> | null, saturday?: Array<{ __typename?: 'TimeInterval', start?: number | null, end?: number | null }> | null, sunday?: Array<{ __typename?: 'TimeInterval', start?: number | null, end?: number | null }> | null } | null, portal_links?: Array<{ __typename?: 'PortalLink', label: string, url: string }> | null, custom_reviews_copy?: { __typename?: 'ClinicReviewsCopy', REVIEW_METHOD_PAGE_TITLE?: string | null, REVIEW_METHOD_PAGE_DESCRIPTION?: string | null, PRIVATE_REVIEW_BUTTON_HELP_TEXT?: string | null, PRIVATE_REVIEW_BUTTON_TEXT?: string | null, REVIEW_PAGE_TITLE?: string | null, REVIEW_PAGE_SUBTITLE?: string | null, REVIEW_SCORE_LABEL?: string | null, REVIEW_MESSAGE_LABEL?: string | null, REVIEW_SUBMIT_BUTTON_TEXT?: string | null } | null, waitlist_customer_segment?: { __typename?: 'CustomerSegment', id: string, name: string, trigger_entity?: CustomerSegmentTrigger | null, is_archived: boolean, updated_at: number, notification_templates?: Array<{ __typename?: 'NotificationTemplate', id: string, name: string, is_active: boolean, is_archived: boolean, message_methods: Array<MessageMethod> }> | null, error_flags?: Array<{ __typename?: 'CustomerSegmentErrorFlag', filter_column: string, filter_index: number, parameter_index: number, message: string }> | null, all_inclusions?: Array<{ __typename?: 'SegmentFilter', foreign_table?: string | null, group?: string | null, parameters: Array<{ __typename?: 'QueryFilter', column: string, filterOp: FilterOp, value: { __typename?: 'QueryFilterValue', string?: string | null, float?: number | null, boolean?: boolean | null, stringArray?: Array<string> | null, floatArray?: Array<number> | null, millisFromNow?: number | null, relativeTime?: { __typename?: 'RelativeTime', quantity: number, unit: TimeUnit, direction: ReferenceDirection } | null } }> }> | null, any_inclusions?: Array<{ __typename?: 'SegmentFilter', foreign_table?: string | null, group?: string | null, parameters: Array<{ __typename?: 'QueryFilter', column: string, filterOp: FilterOp, value: { __typename?: 'QueryFilterValue', string?: string | null, float?: number | null, boolean?: boolean | null, stringArray?: Array<string> | null, floatArray?: Array<number> | null, millisFromNow?: number | null, relativeTime?: { __typename?: 'RelativeTime', quantity: number, unit: TimeUnit, direction: ReferenceDirection } | null } }> }> | null, any_exclusions?: Array<{ __typename?: 'SegmentFilter', foreign_table?: string | null, group?: string | null, parameters: Array<{ __typename?: 'QueryFilter', column: string, filterOp: FilterOp, value: { __typename?: 'QueryFilterValue', string?: string | null, float?: number | null, boolean?: boolean | null, stringArray?: Array<string> | null, floatArray?: Array<number> | null, millisFromNow?: number | null, relativeTime?: { __typename?: 'RelativeTime', quantity: number, unit: TimeUnit, direction: ReferenceDirection } | null } }> }> | null, any_other_exclusions?: Array<{ __typename?: 'SegmentFilter', foreign_table?: string | null, group?: string | null, parameters: Array<{ __typename?: 'QueryFilter', column: string, filterOp: FilterOp, value: { __typename?: 'QueryFilterValue', string?: string | null, float?: number | null, boolean?: boolean | null, stringArray?: Array<string> | null, floatArray?: Array<number> | null, millisFromNow?: number | null, relativeTime?: { __typename?: 'RelativeTime', quantity: number, unit: TimeUnit, direction: ReferenceDirection } | null } }> }> | null, filters?: Array<{ __typename?: 'CustomerSegmentFilter', filters: Array<{ __typename?: 'QueryFilter', column: string, filterOp: FilterOp, value: { __typename?: 'QueryFilterValue', string?: string | null, float?: number | null, boolean?: boolean | null, stringArray?: Array<string> | null, floatArray?: Array<number> | null, millisFromNow?: number | null, relativeTime?: { __typename?: 'RelativeTime', quantity: number, unit: TimeUnit, direction: ReferenceDirection } | null } }> }> | null, excluded_filters: Array<{ __typename?: 'CustomerSegmentFilter', filters: Array<{ __typename?: 'QueryFilter', column: string, filterOp: FilterOp, value: { __typename?: 'QueryFilterValue', string?: string | null, float?: number | null, boolean?: boolean | null, stringArray?: Array<string> | null, floatArray?: Array<number> | null, millisFromNow?: number | null, relativeTime?: { __typename?: 'RelativeTime', quantity: number, unit: TimeUnit, direction: ReferenceDirection } | null } }> }> } | null, blocklist_customer_segment?: { __typename?: 'CustomerSegment', id: string, name: string, trigger_entity?: CustomerSegmentTrigger | null, is_archived: boolean, updated_at: number, notification_templates?: Array<{ __typename?: 'NotificationTemplate', id: string, name: string, is_active: boolean, is_archived: boolean, message_methods: Array<MessageMethod> }> | null, error_flags?: Array<{ __typename?: 'CustomerSegmentErrorFlag', filter_column: string, filter_index: number, parameter_index: number, message: string }> | null, all_inclusions?: Array<{ __typename?: 'SegmentFilter', foreign_table?: string | null, group?: string | null, parameters: Array<{ __typename?: 'QueryFilter', column: string, filterOp: FilterOp, value: { __typename?: 'QueryFilterValue', string?: string | null, float?: number | null, boolean?: boolean | null, stringArray?: Array<string> | null, floatArray?: Array<number> | null, millisFromNow?: number | null, relativeTime?: { __typename?: 'RelativeTime', quantity: number, unit: TimeUnit, direction: ReferenceDirection } | null } }> }> | null, any_inclusions?: Array<{ __typename?: 'SegmentFilter', foreign_table?: string | null, group?: string | null, parameters: Array<{ __typename?: 'QueryFilter', column: string, filterOp: FilterOp, value: { __typename?: 'QueryFilterValue', string?: string | null, float?: number | null, boolean?: boolean | null, stringArray?: Array<string> | null, floatArray?: Array<number> | null, millisFromNow?: number | null, relativeTime?: { __typename?: 'RelativeTime', quantity: number, unit: TimeUnit, direction: ReferenceDirection } | null } }> }> | null, any_exclusions?: Array<{ __typename?: 'SegmentFilter', foreign_table?: string | null, group?: string | null, parameters: Array<{ __typename?: 'QueryFilter', column: string, filterOp: FilterOp, value: { __typename?: 'QueryFilterValue', string?: string | null, float?: number | null, boolean?: boolean | null, stringArray?: Array<string> | null, floatArray?: Array<number> | null, millisFromNow?: number | null, relativeTime?: { __typename?: 'RelativeTime', quantity: number, unit: TimeUnit, direction: ReferenceDirection } | null } }> }> | null, any_other_exclusions?: Array<{ __typename?: 'SegmentFilter', foreign_table?: string | null, group?: string | null, parameters: Array<{ __typename?: 'QueryFilter', column: string, filterOp: FilterOp, value: { __typename?: 'QueryFilterValue', string?: string | null, float?: number | null, boolean?: boolean | null, stringArray?: Array<string> | null, floatArray?: Array<number> | null, millisFromNow?: number | null, relativeTime?: { __typename?: 'RelativeTime', quantity: number, unit: TimeUnit, direction: ReferenceDirection } | null } }> }> | null, filters?: Array<{ __typename?: 'CustomerSegmentFilter', filters: Array<{ __typename?: 'QueryFilter', column: string, filterOp: FilterOp, value: { __typename?: 'QueryFilterValue', string?: string | null, float?: number | null, boolean?: boolean | null, stringArray?: Array<string> | null, floatArray?: Array<number> | null, millisFromNow?: number | null, relativeTime?: { __typename?: 'RelativeTime', quantity: number, unit: TimeUnit, direction: ReferenceDirection } | null } }> }> | null, excluded_filters: Array<{ __typename?: 'CustomerSegmentFilter', filters: Array<{ __typename?: 'QueryFilter', column: string, filterOp: FilterOp, value: { __typename?: 'QueryFilterValue', string?: string | null, float?: number | null, boolean?: boolean | null, stringArray?: Array<string> | null, floatArray?: Array<number> | null, millisFromNow?: number | null, relativeTime?: { __typename?: 'RelativeTime', quantity: number, unit: TimeUnit, direction: ReferenceDirection } | null } }> }> } | null, referral_customer_segment?: { __typename?: 'CustomerSegment', id: string, name: string, trigger_entity?: CustomerSegmentTrigger | null, is_archived: boolean, updated_at: number, notification_templates?: Array<{ __typename?: 'NotificationTemplate', id: string, name: string, is_active: boolean, is_archived: boolean, message_methods: Array<MessageMethod> }> | null, error_flags?: Array<{ __typename?: 'CustomerSegmentErrorFlag', filter_column: string, filter_index: number, parameter_index: number, message: string }> | null, all_inclusions?: Array<{ __typename?: 'SegmentFilter', foreign_table?: string | null, group?: string | null, parameters: Array<{ __typename?: 'QueryFilter', column: string, filterOp: FilterOp, value: { __typename?: 'QueryFilterValue', string?: string | null, float?: number | null, boolean?: boolean | null, stringArray?: Array<string> | null, floatArray?: Array<number> | null, millisFromNow?: number | null, relativeTime?: { __typename?: 'RelativeTime', quantity: number, unit: TimeUnit, direction: ReferenceDirection } | null } }> }> | null, any_inclusions?: Array<{ __typename?: 'SegmentFilter', foreign_table?: string | null, group?: string | null, parameters: Array<{ __typename?: 'QueryFilter', column: string, filterOp: FilterOp, value: { __typename?: 'QueryFilterValue', string?: string | null, float?: number | null, boolean?: boolean | null, stringArray?: Array<string> | null, floatArray?: Array<number> | null, millisFromNow?: number | null, relativeTime?: { __typename?: 'RelativeTime', quantity: number, unit: TimeUnit, direction: ReferenceDirection } | null } }> }> | null, any_exclusions?: Array<{ __typename?: 'SegmentFilter', foreign_table?: string | null, group?: string | null, parameters: Array<{ __typename?: 'QueryFilter', column: string, filterOp: FilterOp, value: { __typename?: 'QueryFilterValue', string?: string | null, float?: number | null, boolean?: boolean | null, stringArray?: Array<string> | null, floatArray?: Array<number> | null, millisFromNow?: number | null, relativeTime?: { __typename?: 'RelativeTime', quantity: number, unit: TimeUnit, direction: ReferenceDirection } | null } }> }> | null, any_other_exclusions?: Array<{ __typename?: 'SegmentFilter', foreign_table?: string | null, group?: string | null, parameters: Array<{ __typename?: 'QueryFilter', column: string, filterOp: FilterOp, value: { __typename?: 'QueryFilterValue', string?: string | null, float?: number | null, boolean?: boolean | null, stringArray?: Array<string> | null, floatArray?: Array<number> | null, millisFromNow?: number | null, relativeTime?: { __typename?: 'RelativeTime', quantity: number, unit: TimeUnit, direction: ReferenceDirection } | null } }> }> | null, filters?: Array<{ __typename?: 'CustomerSegmentFilter', filters: Array<{ __typename?: 'QueryFilter', column: string, filterOp: FilterOp, value: { __typename?: 'QueryFilterValue', string?: string | null, float?: number | null, boolean?: boolean | null, stringArray?: Array<string> | null, floatArray?: Array<number> | null, millisFromNow?: number | null, relativeTime?: { __typename?: 'RelativeTime', quantity: number, unit: TimeUnit, direction: ReferenceDirection } | null } }> }> | null, excluded_filters: Array<{ __typename?: 'CustomerSegmentFilter', filters: Array<{ __typename?: 'QueryFilter', column: string, filterOp: FilterOp, value: { __typename?: 'QueryFilterValue', string?: string | null, float?: number | null, boolean?: boolean | null, stringArray?: Array<string> | null, floatArray?: Array<number> | null, millisFromNow?: number | null, relativeTime?: { __typename?: 'RelativeTime', quantity: number, unit: TimeUnit, direction: ReferenceDirection } | null } }> }> } | null, webhooks?: Array<{ __typename?: 'WebhookConfig', id: string, name: string, url: string, events: Array<WebhookEventType>, secret?: string | null, enabled: boolean }> | null, times_first_filter_config?: { __typename?: 'TimesFirstFilterConfig', service?: BookingFilterDisplayMode | null, clinician?: BookingFilterDisplayMode | null, species?: BookingFilterDisplayMode | null, client_status?: BookingFilterDisplayMode | null, patient_status?: BookingFilterDisplayMode | null, patient_gender?: BookingFilterDisplayMode | null, fixed_status?: BookingFilterDisplayMode | null } | null } | null, clinic_group_clinics: Array<{ __typename?: 'ClinicGroupClinic', id: string, created_at: number, clinic: { __typename?: 'Clinic', id: string, name?: string | null, slug?: string | null, avatar_url?: string | null, time_zone?: string | null, is_archived: boolean, address?: { __typename?: 'Address', street_a?: string | null, street_b?: string | null, city?: string | null, state?: string | null, zip?: string | null, country?: string | null } | null, pms_db?: { __typename?: 'PmsDb', id: string } | null } }>, clinic_group_users: Array<{ __typename?: 'ClinicGroupUser', id: string, role: AuthRoles, are_email_notifications_enabled: boolean, are_sms_notifications_enabled: boolean, are_desktop_notifications_enabled: boolean, created_at: number, clinic_group: { __typename?: 'ClinicGroup', id: string }, user: { __typename?: 'User', id: string, email?: any | null, first_name?: string | null, last_name?: string | null, avatar_url?: string | null, invitation_status?: UserInvitationStatus | null }, custom_role?: { __typename?: 'CustomRole', id: string, name: string } | null, permissions?: Array<{ __typename?: 'ClinicAdminPermission', feature: AdminPermissionFeature, access_level: AdminPermissionAccessLevel }> | null }>, parent_clinic_group?: { __typename?: 'ClinicGroup', id: string, name: string } | null, clinic_groups: Array<{ __typename?: 'ClinicGroup', id: string, name: string, slug: string, is_archived: boolean, clinic_group_clinics: Array<{ __typename?: 'ClinicGroupClinic', id: string, created_at: number, clinic: { __typename?: 'Clinic', id: string, name?: string | null, slug?: string | null, avatar_url?: string | null, time_zone?: string | null, is_archived: boolean, address?: { __typename?: 'Address', street_a?: string | null, street_b?: string | null, city?: string | null, state?: string | null, zip?: string | null, country?: string | null } | null, pms_db?: { __typename?: 'PmsDb', id: string } | null } }> }> }> };

export type QueryClinicGroupsForUserQueryVariables = Exact<{
  userId: Scalars['ID']['input'];
  where?: InputMaybe<Array<QueryInput> | QueryInput>;
  page?: InputMaybe<Scalars['NonNegativeInt']['input']>;
  pageSize?: InputMaybe<Scalars['NonNegativeInt']['input']>;
  orderBy?: InputMaybe<OrderByInput>;
}>;


export type QueryClinicGroupsForUserQuery = { __typename?: 'Query', queryClinicGroupsForUser: Array<{ __typename?: 'ClinicGroup', id: string, name: string, slug: string, is_archived: boolean, created_at: number, updated_at: number, settings?: { __typename?: 'ClinicSettings', id?: string | null, does_require_verification?: boolean | null, does_use_automatic_reschedule?: boolean | null, reset_status_to_booked_on_reschedule?: boolean | null, is_using_detailed_services?: boolean | null, hide_review_step?: boolean | null, is_using_rooms?: boolean | null, pms_start_time?: any | null, pms_end_time?: any | null, primary_color?: string | null, accent_color?: string | null, secondary_color?: string | null, new_appt_requested_msg?: string | null, new_appt_approved_msg?: string | null, new_appt_approved_sms_msg?: string | null, new_appt_denied_msg?: string | null, schedule_method?: ScheduleMethod | null, scheduling_buffer_minutes?: number | null, base_schedule_duration?: number | null, does_require_referral?: boolean | null, appointment_entry_method?: AppointmentEntryMethod | null, scheduling_min_minutes_away?: number | null, scheduling_max_minutes_away?: number | null, included_species?: Array<Species> | null, max_patients_per_visit?: number | null, should_complete_sync?: boolean | null, server_syncing_only?: boolean | null, confirmation_days_before?: number | null, send_confirmations_to: SendConfirmationsTo, send_new_appt_email?: boolean | null, send_reviews_to?: SendConfirmationsTo | null, max_review_rating_for_notif?: number | null, google_review_link?: string | null, facebook_review_link?: string | null, non_blocking_services: Array<string>, yesterday_revenue?: number | null, this_month_revenue?: number | null, hide_clinician_preference: boolean, does_use_rooms_to_schedule?: boolean | null, primary_room_pms_id?: string | null, should_default_pims_emails_on: boolean, should_default_pims_sms_on: boolean, should_default_marketing_sms_on: boolean, should_default_marketing_email_on: boolean, does_use_clinicians_to_schedule?: boolean | null, time_slot_minutes: number, sync_interval_minutes: number, long_sync_interval_hours: number, primary_clinician_pms_id?: string | null, cancellation_clinician_pms_id?: string | null, cancellation_service_pms_id?: string | null, allow_first_appt_per_day?: boolean | null, custom_well_description?: string | null, custom_sick_description?: string | null, custom_other_title?: string | null, custom_other_description?: string | null, default_trigger_words?: Array<string> | null, should_use_private_reviews?: boolean | null, notify_clinic_on?: Array<NotifyClinicOn> | null, reminder_send_time_minutes?: number | null, does_require_new_client_address?: boolean | null, does_require_new_client_birthday?: boolean | null, should_allow_new_clients?: boolean | null, should_allow_new_patients?: boolean | null, should_create_clients?: boolean | null, should_create_patients?: boolean | null, msgs_auto_priority?: boolean | null, booking_match_procedure?: BookingMatchProcedure | null, urgency_type?: UrgencyType | null, max_booking_columns?: number | null, hide_closed_days_from_scheduling?: boolean | null, should_sync_reminders?: boolean | null, auto_reply_enabled: boolean, auto_reply_message?: string | null, unreplied_message_alert_enabled: boolean, unreplied_message_alert_minutes: number, comms_writeback_enabled: boolean, comms_should_daily_writeback: boolean, comms_use_pdf_for_writeback: boolean, comms_writeback_buffer_minutes: number, comms_writeback_before_appt_mins: number, comms_should_writeback_on_send: boolean, comms_should_writeback_on_receive: boolean, comms_should_writeback_notifs: boolean, comms_should_use_ai_writeback: boolean, form_writeback_enabled: boolean, should_award_loyalty_for_invoices?: boolean | null, invoice_loyalty_points_per_dollar?: number | null, app_download_loyalty_points?: number | null, referrer_loyalty_points?: number | null, referred_loyalty_points?: number | null, custom_appointment_notes_template?: string | null, custom_new_client_notes_template?: string | null, custom_new_patient_notes_template?: string | null, max_inactivity_duration?: number | null, hide_portal_vaccinations: boolean, hide_portal_reminders: boolean, hide_portal_prescriptions: boolean, hide_portal_weight: boolean, hide_soc_vaccinations?: boolean | null, hide_historic_vaccinations?: boolean | null, should_hide_daily_huddle_financials: boolean, patient_details_tab_order: Array<PortalPatientDetailsTab>, clinic_hours_display?: string | null, reschedule_buffer_minutes?: number | null, cancellation_buffer_minutes?: number | null, require_reason_for_cancellation?: boolean | null, should_automatically_assign_patient?: boolean | null, payment_writeback_enabled: boolean, auto_refund_on_cancel: boolean, status_set_on_payment_completed_pms_id?: string | null, max_booking_notes_length?: number | null, min_booking_notes_length?: number | null, primary_clinic_group_id?: string | null, should_suggest_nearby_clinics?: boolean | null, sms_block_list?: Array<string> | null, exclude_message_wrapper?: boolean | null, should_charge_client_stripe_fees?: boolean | null, chckvet_prescription_fee_split_percentage?: number | null, gtm_container_id?: string | null, review_google_id?: string | null, review_facebook_id?: string | null, only_use_adj_avail_guides: boolean, use_basic_timeslots: boolean, valid_booking_interval_minutes?: Array<number> | null, should_disable_online_scheduling?: boolean | null, simple_scheduling_rules_enabled: boolean, compliance_statuses?: Array<string> | null, should_use_instant_prescription_requests?: boolean | null, prescription_pickup_service_id?: string | null, default_reminder_service_id?: string | null, ai_calls_provider?: PhoneProviderType | null, ai_calls_phone_number?: string | null, ai_calls_voice_id?: string | null, ai_calls_agent_id?: string | null, ai_agent_style?: string | null, ai_agent_custom_instructions?: string | null, ai_calls_ambient_sound?: AiCallsAmbientSound | null, ai_calls_voice_speed?: number | null, ai_calls_interruption_sensitivity?: number | null, ai_calls_enable_dynamic_voice_speed?: boolean | null, usage_spending_caps?: any | null, custom_merge_tags?: any | null, custom_booking_copy?: { __typename?: 'ClinicBookingCopy', WIDGET_HEADER_TITLE?: string | null, SHOW_CLINIC_HEADER_LOGO?: boolean | null, CLINIC_HEADER_LOGO_HEIGHT?: number | null, SERVICE_TYPE_SECTION_HEADING?: string | null, DEFAULT_WELLNESS_DESCRIPTION?: string | null, DEFAULT_SICK_DESCRIPTION?: string | null, DEFAULT_OTHER_DESCRIPTION?: string | null, RETURNING_PATIENT_QUESTION?: string | null, POSITIVE_RETURNING_PATIENT_ANSWER?: string | null, NEGATIVE_RETURNING_PATIENT_ANSWER?: string | null, RETURNING_CLIENT_QUESTION?: string | null, POSITIVE_RETURNING_CLIENT_ANSWER?: string | null, NEGATIVE_RETURNING_CLIENT_ANSWER?: string | null, CLIENT_INFORMATION_SECTION_TITLE?: string | null, PATIENT_INFORMATION_SECTION_TITLE?: string | null, RETURNING_CLIENT_PATIENT_TITLE?: string | null, RETURNING_CLIENT_PATIENT_DESCRIPTION?: string | null, SERVICE_SECTION_TITLE?: string | null, PREPAID_SERVICES_LABEL?: string | null, STANDARD_SERVICES_LABEL?: string | null, DEPOSIT_FEE_NAME?: string | null, PREVIOUS_OR_REFERRING_CLINIC_QUESTION?: string | null, CONTACT_THE_CLINIC_TEXT?: string | null, CONTACT_THE_CLINIC_TEXT_COLOR?: string | null, CONTACT_THE_CLINIC_TEXT_SIZE?: string | null, SELECT_CLINICIAN_TITLE?: string | null, SELECT_CLINICIAN_POSITIVE_ANSWER?: string | null, SELECT_CLINICIAN_NEGATIVE_ANSWER?: string | null, SELECT_TIME_TITLE?: string | null, REVIEW_TITLE?: string | null, REVIEW_NOTES_PROMPT?: string | null, PAYMENT_INFORMATION_TITLE?: string | null, TRIGGER_WORDS_DETECTED_HEADER?: string | null, TRIGGER_WORDS_DETECTED_DESCRIPTION?: string | null, CONFIRMATION_SCREEN_TITLE?: string | null, CONFIRMATION_SCREEN_DESCRIPTION?: string | null, NEW_CLIENT_BLOCKED_MESSAGE?: string | null, NEW_PATIENT_BLOCKED_MESSAGE?: string | null } | null, auto_reply_hours?: { __typename?: 'AvailabilityHours', monday?: Array<{ __typename?: 'TimeInterval', start?: number | null, end?: number | null }> | null, tuesday?: Array<{ __typename?: 'TimeInterval', start?: number | null, end?: number | null }> | null, wednesday?: Array<{ __typename?: 'TimeInterval', start?: number | null, end?: number | null }> | null, thursday?: Array<{ __typename?: 'TimeInterval', start?: number | null, end?: number | null }> | null, friday?: Array<{ __typename?: 'TimeInterval', start?: number | null, end?: number | null }> | null, saturday?: Array<{ __typename?: 'TimeInterval', start?: number | null, end?: number | null }> | null, sunday?: Array<{ __typename?: 'TimeInterval', start?: number | null, end?: number | null }> | null } | null, portal_links?: Array<{ __typename?: 'PortalLink', label: string, url: string }> | null, custom_reviews_copy?: { __typename?: 'ClinicReviewsCopy', REVIEW_METHOD_PAGE_TITLE?: string | null, REVIEW_METHOD_PAGE_DESCRIPTION?: string | null, PRIVATE_REVIEW_BUTTON_HELP_TEXT?: string | null, PRIVATE_REVIEW_BUTTON_TEXT?: string | null, REVIEW_PAGE_TITLE?: string | null, REVIEW_PAGE_SUBTITLE?: string | null, REVIEW_SCORE_LABEL?: string | null, REVIEW_MESSAGE_LABEL?: string | null, REVIEW_SUBMIT_BUTTON_TEXT?: string | null } | null, waitlist_customer_segment?: { __typename?: 'CustomerSegment', id: string, name: string, trigger_entity?: CustomerSegmentTrigger | null, is_archived: boolean, updated_at: number, notification_templates?: Array<{ __typename?: 'NotificationTemplate', id: string, name: string, is_active: boolean, is_archived: boolean, message_methods: Array<MessageMethod> }> | null, error_flags?: Array<{ __typename?: 'CustomerSegmentErrorFlag', filter_column: string, filter_index: number, parameter_index: number, message: string }> | null, all_inclusions?: Array<{ __typename?: 'SegmentFilter', foreign_table?: string | null, group?: string | null, parameters: Array<{ __typename?: 'QueryFilter', column: string, filterOp: FilterOp, value: { __typename?: 'QueryFilterValue', string?: string | null, float?: number | null, boolean?: boolean | null, stringArray?: Array<string> | null, floatArray?: Array<number> | null, millisFromNow?: number | null, relativeTime?: { __typename?: 'RelativeTime', quantity: number, unit: TimeUnit, direction: ReferenceDirection } | null } }> }> | null, any_inclusions?: Array<{ __typename?: 'SegmentFilter', foreign_table?: string | null, group?: string | null, parameters: Array<{ __typename?: 'QueryFilter', column: string, filterOp: FilterOp, value: { __typename?: 'QueryFilterValue', string?: string | null, float?: number | null, boolean?: boolean | null, stringArray?: Array<string> | null, floatArray?: Array<number> | null, millisFromNow?: number | null, relativeTime?: { __typename?: 'RelativeTime', quantity: number, unit: TimeUnit, direction: ReferenceDirection } | null } }> }> | null, any_exclusions?: Array<{ __typename?: 'SegmentFilter', foreign_table?: string | null, group?: string | null, parameters: Array<{ __typename?: 'QueryFilter', column: string, filterOp: FilterOp, value: { __typename?: 'QueryFilterValue', string?: string | null, float?: number | null, boolean?: boolean | null, stringArray?: Array<string> | null, floatArray?: Array<number> | null, millisFromNow?: number | null, relativeTime?: { __typename?: 'RelativeTime', quantity: number, unit: TimeUnit, direction: ReferenceDirection } | null } }> }> | null, any_other_exclusions?: Array<{ __typename?: 'SegmentFilter', foreign_table?: string | null, group?: string | null, parameters: Array<{ __typename?: 'QueryFilter', column: string, filterOp: FilterOp, value: { __typename?: 'QueryFilterValue', string?: string | null, float?: number | null, boolean?: boolean | null, stringArray?: Array<string> | null, floatArray?: Array<number> | null, millisFromNow?: number | null, relativeTime?: { __typename?: 'RelativeTime', quantity: number, unit: TimeUnit, direction: ReferenceDirection } | null } }> }> | null, filters?: Array<{ __typename?: 'CustomerSegmentFilter', filters: Array<{ __typename?: 'QueryFilter', column: string, filterOp: FilterOp, value: { __typename?: 'QueryFilterValue', string?: string | null, float?: number | null, boolean?: boolean | null, stringArray?: Array<string> | null, floatArray?: Array<number> | null, millisFromNow?: number | null, relativeTime?: { __typename?: 'RelativeTime', quantity: number, unit: TimeUnit, direction: ReferenceDirection } | null } }> }> | null, excluded_filters: Array<{ __typename?: 'CustomerSegmentFilter', filters: Array<{ __typename?: 'QueryFilter', column: string, filterOp: FilterOp, value: { __typename?: 'QueryFilterValue', string?: string | null, float?: number | null, boolean?: boolean | null, stringArray?: Array<string> | null, floatArray?: Array<number> | null, millisFromNow?: number | null, relativeTime?: { __typename?: 'RelativeTime', quantity: number, unit: TimeUnit, direction: ReferenceDirection } | null } }> }> } | null, blocklist_customer_segment?: { __typename?: 'CustomerSegment', id: string, name: string, trigger_entity?: CustomerSegmentTrigger | null, is_archived: boolean, updated_at: number, notification_templates?: Array<{ __typename?: 'NotificationTemplate', id: string, name: string, is_active: boolean, is_archived: boolean, message_methods: Array<MessageMethod> }> | null, error_flags?: Array<{ __typename?: 'CustomerSegmentErrorFlag', filter_column: string, filter_index: number, parameter_index: number, message: string }> | null, all_inclusions?: Array<{ __typename?: 'SegmentFilter', foreign_table?: string | null, group?: string | null, parameters: Array<{ __typename?: 'QueryFilter', column: string, filterOp: FilterOp, value: { __typename?: 'QueryFilterValue', string?: string | null, float?: number | null, boolean?: boolean | null, stringArray?: Array<string> | null, floatArray?: Array<number> | null, millisFromNow?: number | null, relativeTime?: { __typename?: 'RelativeTime', quantity: number, unit: TimeUnit, direction: ReferenceDirection } | null } }> }> | null, any_inclusions?: Array<{ __typename?: 'SegmentFilter', foreign_table?: string | null, group?: string | null, parameters: Array<{ __typename?: 'QueryFilter', column: string, filterOp: FilterOp, value: { __typename?: 'QueryFilterValue', string?: string | null, float?: number | null, boolean?: boolean | null, stringArray?: Array<string> | null, floatArray?: Array<number> | null, millisFromNow?: number | null, relativeTime?: { __typename?: 'RelativeTime', quantity: number, unit: TimeUnit, direction: ReferenceDirection } | null } }> }> | null, any_exclusions?: Array<{ __typename?: 'SegmentFilter', foreign_table?: string | null, group?: string | null, parameters: Array<{ __typename?: 'QueryFilter', column: string, filterOp: FilterOp, value: { __typename?: 'QueryFilterValue', string?: string | null, float?: number | null, boolean?: boolean | null, stringArray?: Array<string> | null, floatArray?: Array<number> | null, millisFromNow?: number | null, relativeTime?: { __typename?: 'RelativeTime', quantity: number, unit: TimeUnit, direction: ReferenceDirection } | null } }> }> | null, any_other_exclusions?: Array<{ __typename?: 'SegmentFilter', foreign_table?: string | null, group?: string | null, parameters: Array<{ __typename?: 'QueryFilter', column: string, filterOp: FilterOp, value: { __typename?: 'QueryFilterValue', string?: string | null, float?: number | null, boolean?: boolean | null, stringArray?: Array<string> | null, floatArray?: Array<number> | null, millisFromNow?: number | null, relativeTime?: { __typename?: 'RelativeTime', quantity: number, unit: TimeUnit, direction: ReferenceDirection } | null } }> }> | null, filters?: Array<{ __typename?: 'CustomerSegmentFilter', filters: Array<{ __typename?: 'QueryFilter', column: string, filterOp: FilterOp, value: { __typename?: 'QueryFilterValue', string?: string | null, float?: number | null, boolean?: boolean | null, stringArray?: Array<string> | null, floatArray?: Array<number> | null, millisFromNow?: number | null, relativeTime?: { __typename?: 'RelativeTime', quantity: number, unit: TimeUnit, direction: ReferenceDirection } | null } }> }> | null, excluded_filters: Array<{ __typename?: 'CustomerSegmentFilter', filters: Array<{ __typename?: 'QueryFilter', column: string, filterOp: FilterOp, value: { __typename?: 'QueryFilterValue', string?: string | null, float?: number | null, boolean?: boolean | null, stringArray?: Array<string> | null, floatArray?: Array<number> | null, millisFromNow?: number | null, relativeTime?: { __typename?: 'RelativeTime', quantity: number, unit: TimeUnit, direction: ReferenceDirection } | null } }> }> } | null, referral_customer_segment?: { __typename?: 'CustomerSegment', id: string, name: string, trigger_entity?: CustomerSegmentTrigger | null, is_archived: boolean, updated_at: number, notification_templates?: Array<{ __typename?: 'NotificationTemplate', id: string, name: string, is_active: boolean, is_archived: boolean, message_methods: Array<MessageMethod> }> | null, error_flags?: Array<{ __typename?: 'CustomerSegmentErrorFlag', filter_column: string, filter_index: number, parameter_index: number, message: string }> | null, all_inclusions?: Array<{ __typename?: 'SegmentFilter', foreign_table?: string | null, group?: string | null, parameters: Array<{ __typename?: 'QueryFilter', column: string, filterOp: FilterOp, value: { __typename?: 'QueryFilterValue', string?: string | null, float?: number | null, boolean?: boolean | null, stringArray?: Array<string> | null, floatArray?: Array<number> | null, millisFromNow?: number | null, relativeTime?: { __typename?: 'RelativeTime', quantity: number, unit: TimeUnit, direction: ReferenceDirection } | null } }> }> | null, any_inclusions?: Array<{ __typename?: 'SegmentFilter', foreign_table?: string | null, group?: string | null, parameters: Array<{ __typename?: 'QueryFilter', column: string, filterOp: FilterOp, value: { __typename?: 'QueryFilterValue', string?: string | null, float?: number | null, boolean?: boolean | null, stringArray?: Array<string> | null, floatArray?: Array<number> | null, millisFromNow?: number | null, relativeTime?: { __typename?: 'RelativeTime', quantity: number, unit: TimeUnit, direction: ReferenceDirection } | null } }> }> | null, any_exclusions?: Array<{ __typename?: 'SegmentFilter', foreign_table?: string | null, group?: string | null, parameters: Array<{ __typename?: 'QueryFilter', column: string, filterOp: FilterOp, value: { __typename?: 'QueryFilterValue', string?: string | null, float?: number | null, boolean?: boolean | null, stringArray?: Array<string> | null, floatArray?: Array<number> | null, millisFromNow?: number | null, relativeTime?: { __typename?: 'RelativeTime', quantity: number, unit: TimeUnit, direction: ReferenceDirection } | null } }> }> | null, any_other_exclusions?: Array<{ __typename?: 'SegmentFilter', foreign_table?: string | null, group?: string | null, parameters: Array<{ __typename?: 'QueryFilter', column: string, filterOp: FilterOp, value: { __typename?: 'QueryFilterValue', string?: string | null, float?: number | null, boolean?: boolean | null, stringArray?: Array<string> | null, floatArray?: Array<number> | null, millisFromNow?: number | null, relativeTime?: { __typename?: 'RelativeTime', quantity: number, unit: TimeUnit, direction: ReferenceDirection } | null } }> }> | null, filters?: Array<{ __typename?: 'CustomerSegmentFilter', filters: Array<{ __typename?: 'QueryFilter', column: string, filterOp: FilterOp, value: { __typename?: 'QueryFilterValue', string?: string | null, float?: number | null, boolean?: boolean | null, stringArray?: Array<string> | null, floatArray?: Array<number> | null, millisFromNow?: number | null, relativeTime?: { __typename?: 'RelativeTime', quantity: number, unit: TimeUnit, direction: ReferenceDirection } | null } }> }> | null, excluded_filters: Array<{ __typename?: 'CustomerSegmentFilter', filters: Array<{ __typename?: 'QueryFilter', column: string, filterOp: FilterOp, value: { __typename?: 'QueryFilterValue', string?: string | null, float?: number | null, boolean?: boolean | null, stringArray?: Array<string> | null, floatArray?: Array<number> | null, millisFromNow?: number | null, relativeTime?: { __typename?: 'RelativeTime', quantity: number, unit: TimeUnit, direction: ReferenceDirection } | null } }> }> } | null, webhooks?: Array<{ __typename?: 'WebhookConfig', id: string, name: string, url: string, events: Array<WebhookEventType>, secret?: string | null, enabled: boolean }> | null, times_first_filter_config?: { __typename?: 'TimesFirstFilterConfig', service?: BookingFilterDisplayMode | null, clinician?: BookingFilterDisplayMode | null, species?: BookingFilterDisplayMode | null, client_status?: BookingFilterDisplayMode | null, patient_status?: BookingFilterDisplayMode | null, patient_gender?: BookingFilterDisplayMode | null, fixed_status?: BookingFilterDisplayMode | null } | null } | null, clinic_group_clinics: Array<{ __typename?: 'ClinicGroupClinic', id: string, created_at: number, clinic: { __typename?: 'Clinic', id: string, name?: string | null, slug?: string | null, avatar_url?: string | null, time_zone?: string | null, is_archived: boolean, address?: { __typename?: 'Address', street_a?: string | null, street_b?: string | null, city?: string | null, state?: string | null, zip?: string | null, country?: string | null } | null, pms_db?: { __typename?: 'PmsDb', id: string } | null } }>, clinic_group_users: Array<{ __typename?: 'ClinicGroupUser', id: string, role: AuthRoles, are_email_notifications_enabled: boolean, are_sms_notifications_enabled: boolean, are_desktop_notifications_enabled: boolean, created_at: number, clinic_group: { __typename?: 'ClinicGroup', id: string }, user: { __typename?: 'User', id: string, email?: any | null, first_name?: string | null, last_name?: string | null, avatar_url?: string | null, invitation_status?: UserInvitationStatus | null }, custom_role?: { __typename?: 'CustomRole', id: string, name: string } | null, permissions?: Array<{ __typename?: 'ClinicAdminPermission', feature: AdminPermissionFeature, access_level: AdminPermissionAccessLevel }> | null }>, parent_clinic_group?: { __typename?: 'ClinicGroup', id: string, name: string } | null, clinic_groups: Array<{ __typename?: 'ClinicGroup', id: string, name: string, slug: string, is_archived: boolean, clinic_group_clinics: Array<{ __typename?: 'ClinicGroupClinic', id: string, created_at: number, clinic: { __typename?: 'Clinic', id: string, name?: string | null, slug?: string | null, avatar_url?: string | null, time_zone?: string | null, is_archived: boolean, address?: { __typename?: 'Address', street_a?: string | null, street_b?: string | null, city?: string | null, state?: string | null, zip?: string | null, country?: string | null } | null, pms_db?: { __typename?: 'PmsDb', id: string } | null } }> }> }> };

export type CountClinicGroupsForUserQueryVariables = Exact<{
  userId: Scalars['ID']['input'];
  where?: InputMaybe<Array<QueryInput> | QueryInput>;
}>;


export type CountClinicGroupsForUserQuery = { __typename?: 'Query', countClinicGroupsForUser: number };

export type CountClinicGroupsQueryVariables = Exact<{
  where?: InputMaybe<Array<QueryInput> | QueryInput>;
}>;


export type CountClinicGroupsQuery = { __typename?: 'Query', countClinicGroups: number };

export type QueryClinicGroupsQueryVariables = Exact<{
  where?: InputMaybe<Array<QueryInput> | QueryInput>;
  page?: InputMaybe<Scalars['NonNegativeInt']['input']>;
  pageSize?: InputMaybe<Scalars['NonNegativeInt']['input']>;
  orderBy?: InputMaybe<OrderByInput>;
}>;


export type QueryClinicGroupsQuery = { __typename?: 'Query', queryClinicGroups: Array<{ __typename?: 'ClinicGroup', id: string, name: string, slug: string, is_archived: boolean, created_at: number, updated_at: number, settings?: { __typename?: 'ClinicSettings', id?: string | null, does_require_verification?: boolean | null, does_use_automatic_reschedule?: boolean | null, reset_status_to_booked_on_reschedule?: boolean | null, is_using_detailed_services?: boolean | null, hide_review_step?: boolean | null, is_using_rooms?: boolean | null, pms_start_time?: any | null, pms_end_time?: any | null, primary_color?: string | null, accent_color?: string | null, secondary_color?: string | null, new_appt_requested_msg?: string | null, new_appt_approved_msg?: string | null, new_appt_approved_sms_msg?: string | null, new_appt_denied_msg?: string | null, schedule_method?: ScheduleMethod | null, scheduling_buffer_minutes?: number | null, base_schedule_duration?: number | null, does_require_referral?: boolean | null, appointment_entry_method?: AppointmentEntryMethod | null, scheduling_min_minutes_away?: number | null, scheduling_max_minutes_away?: number | null, included_species?: Array<Species> | null, max_patients_per_visit?: number | null, should_complete_sync?: boolean | null, server_syncing_only?: boolean | null, confirmation_days_before?: number | null, send_confirmations_to: SendConfirmationsTo, send_new_appt_email?: boolean | null, send_reviews_to?: SendConfirmationsTo | null, max_review_rating_for_notif?: number | null, google_review_link?: string | null, facebook_review_link?: string | null, non_blocking_services: Array<string>, yesterday_revenue?: number | null, this_month_revenue?: number | null, hide_clinician_preference: boolean, does_use_rooms_to_schedule?: boolean | null, primary_room_pms_id?: string | null, should_default_pims_emails_on: boolean, should_default_pims_sms_on: boolean, should_default_marketing_sms_on: boolean, should_default_marketing_email_on: boolean, does_use_clinicians_to_schedule?: boolean | null, time_slot_minutes: number, sync_interval_minutes: number, long_sync_interval_hours: number, primary_clinician_pms_id?: string | null, cancellation_clinician_pms_id?: string | null, cancellation_service_pms_id?: string | null, allow_first_appt_per_day?: boolean | null, custom_well_description?: string | null, custom_sick_description?: string | null, custom_other_title?: string | null, custom_other_description?: string | null, default_trigger_words?: Array<string> | null, should_use_private_reviews?: boolean | null, notify_clinic_on?: Array<NotifyClinicOn> | null, reminder_send_time_minutes?: number | null, does_require_new_client_address?: boolean | null, does_require_new_client_birthday?: boolean | null, should_allow_new_clients?: boolean | null, should_allow_new_patients?: boolean | null, should_create_clients?: boolean | null, should_create_patients?: boolean | null, msgs_auto_priority?: boolean | null, booking_match_procedure?: BookingMatchProcedure | null, urgency_type?: UrgencyType | null, max_booking_columns?: number | null, hide_closed_days_from_scheduling?: boolean | null, should_sync_reminders?: boolean | null, auto_reply_enabled: boolean, auto_reply_message?: string | null, unreplied_message_alert_enabled: boolean, unreplied_message_alert_minutes: number, comms_writeback_enabled: boolean, comms_should_daily_writeback: boolean, comms_use_pdf_for_writeback: boolean, comms_writeback_buffer_minutes: number, comms_writeback_before_appt_mins: number, comms_should_writeback_on_send: boolean, comms_should_writeback_on_receive: boolean, comms_should_writeback_notifs: boolean, comms_should_use_ai_writeback: boolean, form_writeback_enabled: boolean, should_award_loyalty_for_invoices?: boolean | null, invoice_loyalty_points_per_dollar?: number | null, app_download_loyalty_points?: number | null, referrer_loyalty_points?: number | null, referred_loyalty_points?: number | null, custom_appointment_notes_template?: string | null, custom_new_client_notes_template?: string | null, custom_new_patient_notes_template?: string | null, max_inactivity_duration?: number | null, hide_portal_vaccinations: boolean, hide_portal_reminders: boolean, hide_portal_prescriptions: boolean, hide_portal_weight: boolean, hide_soc_vaccinations?: boolean | null, hide_historic_vaccinations?: boolean | null, should_hide_daily_huddle_financials: boolean, patient_details_tab_order: Array<PortalPatientDetailsTab>, clinic_hours_display?: string | null, reschedule_buffer_minutes?: number | null, cancellation_buffer_minutes?: number | null, require_reason_for_cancellation?: boolean | null, should_automatically_assign_patient?: boolean | null, payment_writeback_enabled: boolean, auto_refund_on_cancel: boolean, status_set_on_payment_completed_pms_id?: string | null, max_booking_notes_length?: number | null, min_booking_notes_length?: number | null, primary_clinic_group_id?: string | null, should_suggest_nearby_clinics?: boolean | null, sms_block_list?: Array<string> | null, exclude_message_wrapper?: boolean | null, should_charge_client_stripe_fees?: boolean | null, chckvet_prescription_fee_split_percentage?: number | null, gtm_container_id?: string | null, review_google_id?: string | null, review_facebook_id?: string | null, only_use_adj_avail_guides: boolean, use_basic_timeslots: boolean, valid_booking_interval_minutes?: Array<number> | null, should_disable_online_scheduling?: boolean | null, simple_scheduling_rules_enabled: boolean, compliance_statuses?: Array<string> | null, should_use_instant_prescription_requests?: boolean | null, prescription_pickup_service_id?: string | null, default_reminder_service_id?: string | null, ai_calls_provider?: PhoneProviderType | null, ai_calls_phone_number?: string | null, ai_calls_voice_id?: string | null, ai_calls_agent_id?: string | null, ai_agent_style?: string | null, ai_agent_custom_instructions?: string | null, ai_calls_ambient_sound?: AiCallsAmbientSound | null, ai_calls_voice_speed?: number | null, ai_calls_interruption_sensitivity?: number | null, ai_calls_enable_dynamic_voice_speed?: boolean | null, usage_spending_caps?: any | null, custom_merge_tags?: any | null, custom_booking_copy?: { __typename?: 'ClinicBookingCopy', WIDGET_HEADER_TITLE?: string | null, SHOW_CLINIC_HEADER_LOGO?: boolean | null, CLINIC_HEADER_LOGO_HEIGHT?: number | null, SERVICE_TYPE_SECTION_HEADING?: string | null, DEFAULT_WELLNESS_DESCRIPTION?: string | null, DEFAULT_SICK_DESCRIPTION?: string | null, DEFAULT_OTHER_DESCRIPTION?: string | null, RETURNING_PATIENT_QUESTION?: string | null, POSITIVE_RETURNING_PATIENT_ANSWER?: string | null, NEGATIVE_RETURNING_PATIENT_ANSWER?: string | null, RETURNING_CLIENT_QUESTION?: string | null, POSITIVE_RETURNING_CLIENT_ANSWER?: string | null, NEGATIVE_RETURNING_CLIENT_ANSWER?: string | null, CLIENT_INFORMATION_SECTION_TITLE?: string | null, PATIENT_INFORMATION_SECTION_TITLE?: string | null, RETURNING_CLIENT_PATIENT_TITLE?: string | null, RETURNING_CLIENT_PATIENT_DESCRIPTION?: string | null, SERVICE_SECTION_TITLE?: string | null, PREPAID_SERVICES_LABEL?: string | null, STANDARD_SERVICES_LABEL?: string | null, DEPOSIT_FEE_NAME?: string | null, PREVIOUS_OR_REFERRING_CLINIC_QUESTION?: string | null, CONTACT_THE_CLINIC_TEXT?: string | null, CONTACT_THE_CLINIC_TEXT_COLOR?: string | null, CONTACT_THE_CLINIC_TEXT_SIZE?: string | null, SELECT_CLINICIAN_TITLE?: string | null, SELECT_CLINICIAN_POSITIVE_ANSWER?: string | null, SELECT_CLINICIAN_NEGATIVE_ANSWER?: string | null, SELECT_TIME_TITLE?: string | null, REVIEW_TITLE?: string | null, REVIEW_NOTES_PROMPT?: string | null, PAYMENT_INFORMATION_TITLE?: string | null, TRIGGER_WORDS_DETECTED_HEADER?: string | null, TRIGGER_WORDS_DETECTED_DESCRIPTION?: string | null, CONFIRMATION_SCREEN_TITLE?: string | null, CONFIRMATION_SCREEN_DESCRIPTION?: string | null, NEW_CLIENT_BLOCKED_MESSAGE?: string | null, NEW_PATIENT_BLOCKED_MESSAGE?: string | null } | null, auto_reply_hours?: { __typename?: 'AvailabilityHours', monday?: Array<{ __typename?: 'TimeInterval', start?: number | null, end?: number | null }> | null, tuesday?: Array<{ __typename?: 'TimeInterval', start?: number | null, end?: number | null }> | null, wednesday?: Array<{ __typename?: 'TimeInterval', start?: number | null, end?: number | null }> | null, thursday?: Array<{ __typename?: 'TimeInterval', start?: number | null, end?: number | null }> | null, friday?: Array<{ __typename?: 'TimeInterval', start?: number | null, end?: number | null }> | null, saturday?: Array<{ __typename?: 'TimeInterval', start?: number | null, end?: number | null }> | null, sunday?: Array<{ __typename?: 'TimeInterval', start?: number | null, end?: number | null }> | null } | null, portal_links?: Array<{ __typename?: 'PortalLink', label: string, url: string }> | null, custom_reviews_copy?: { __typename?: 'ClinicReviewsCopy', REVIEW_METHOD_PAGE_TITLE?: string | null, REVIEW_METHOD_PAGE_DESCRIPTION?: string | null, PRIVATE_REVIEW_BUTTON_HELP_TEXT?: string | null, PRIVATE_REVIEW_BUTTON_TEXT?: string | null, REVIEW_PAGE_TITLE?: string | null, REVIEW_PAGE_SUBTITLE?: string | null, REVIEW_SCORE_LABEL?: string | null, REVIEW_MESSAGE_LABEL?: string | null, REVIEW_SUBMIT_BUTTON_TEXT?: string | null } | null, waitlist_customer_segment?: { __typename?: 'CustomerSegment', id: string, name: string, trigger_entity?: CustomerSegmentTrigger | null, is_archived: boolean, updated_at: number, notification_templates?: Array<{ __typename?: 'NotificationTemplate', id: string, name: string, is_active: boolean, is_archived: boolean, message_methods: Array<MessageMethod> }> | null, error_flags?: Array<{ __typename?: 'CustomerSegmentErrorFlag', filter_column: string, filter_index: number, parameter_index: number, message: string }> | null, all_inclusions?: Array<{ __typename?: 'SegmentFilter', foreign_table?: string | null, group?: string | null, parameters: Array<{ __typename?: 'QueryFilter', column: string, filterOp: FilterOp, value: { __typename?: 'QueryFilterValue', string?: string | null, float?: number | null, boolean?: boolean | null, stringArray?: Array<string> | null, floatArray?: Array<number> | null, millisFromNow?: number | null, relativeTime?: { __typename?: 'RelativeTime', quantity: number, unit: TimeUnit, direction: ReferenceDirection } | null } }> }> | null, any_inclusions?: Array<{ __typename?: 'SegmentFilter', foreign_table?: string | null, group?: string | null, parameters: Array<{ __typename?: 'QueryFilter', column: string, filterOp: FilterOp, value: { __typename?: 'QueryFilterValue', string?: string | null, float?: number | null, boolean?: boolean | null, stringArray?: Array<string> | null, floatArray?: Array<number> | null, millisFromNow?: number | null, relativeTime?: { __typename?: 'RelativeTime', quantity: number, unit: TimeUnit, direction: ReferenceDirection } | null } }> }> | null, any_exclusions?: Array<{ __typename?: 'SegmentFilter', foreign_table?: string | null, group?: string | null, parameters: Array<{ __typename?: 'QueryFilter', column: string, filterOp: FilterOp, value: { __typename?: 'QueryFilterValue', string?: string | null, float?: number | null, boolean?: boolean | null, stringArray?: Array<string> | null, floatArray?: Array<number> | null, millisFromNow?: number | null, relativeTime?: { __typename?: 'RelativeTime', quantity: number, unit: TimeUnit, direction: ReferenceDirection } | null } }> }> | null, any_other_exclusions?: Array<{ __typename?: 'SegmentFilter', foreign_table?: string | null, group?: string | null, parameters: Array<{ __typename?: 'QueryFilter', column: string, filterOp: FilterOp, value: { __typename?: 'QueryFilterValue', string?: string | null, float?: number | null, boolean?: boolean | null, stringArray?: Array<string> | null, floatArray?: Array<number> | null, millisFromNow?: number | null, relativeTime?: { __typename?: 'RelativeTime', quantity: number, unit: TimeUnit, direction: ReferenceDirection } | null } }> }> | null, filters?: Array<{ __typename?: 'CustomerSegmentFilter', filters: Array<{ __typename?: 'QueryFilter', column: string, filterOp: FilterOp, value: { __typename?: 'QueryFilterValue', string?: string | null, float?: number | null, boolean?: boolean | null, stringArray?: Array<string> | null, floatArray?: Array<number> | null, millisFromNow?: number | null, relativeTime?: { __typename?: 'RelativeTime', quantity: number, unit: TimeUnit, direction: ReferenceDirection } | null } }> }> | null, excluded_filters: Array<{ __typename?: 'CustomerSegmentFilter', filters: Array<{ __typename?: 'QueryFilter', column: string, filterOp: FilterOp, value: { __typename?: 'QueryFilterValue', string?: string | null, float?: number | null, boolean?: boolean | null, stringArray?: Array<string> | null, floatArray?: Array<number> | null, millisFromNow?: number | null, relativeTime?: { __typename?: 'RelativeTime', quantity: number, unit: TimeUnit, direction: ReferenceDirection } | null } }> }> } | null, blocklist_customer_segment?: { __typename?: 'CustomerSegment', id: string, name: string, trigger_entity?: CustomerSegmentTrigger | null, is_archived: boolean, updated_at: number, notification_templates?: Array<{ __typename?: 'NotificationTemplate', id: string, name: string, is_active: boolean, is_archived: boolean, message_methods: Array<MessageMethod> }> | null, error_flags?: Array<{ __typename?: 'CustomerSegmentErrorFlag', filter_column: string, filter_index: number, parameter_index: number, message: string }> | null, all_inclusions?: Array<{ __typename?: 'SegmentFilter', foreign_table?: string | null, group?: string | null, parameters: Array<{ __typename?: 'QueryFilter', column: string, filterOp: FilterOp, value: { __typename?: 'QueryFilterValue', string?: string | null, float?: number | null, boolean?: boolean | null, stringArray?: Array<string> | null, floatArray?: Array<number> | null, millisFromNow?: number | null, relativeTime?: { __typename?: 'RelativeTime', quantity: number, unit: TimeUnit, direction: ReferenceDirection } | null } }> }> | null, any_inclusions?: Array<{ __typename?: 'SegmentFilter', foreign_table?: string | null, group?: string | null, parameters: Array<{ __typename?: 'QueryFilter', column: string, filterOp: FilterOp, value: { __typename?: 'QueryFilterValue', string?: string | null, float?: number | null, boolean?: boolean | null, stringArray?: Array<string> | null, floatArray?: Array<number> | null, millisFromNow?: number | null, relativeTime?: { __typename?: 'RelativeTime', quantity: number, unit: TimeUnit, direction: ReferenceDirection } | null } }> }> | null, any_exclusions?: Array<{ __typename?: 'SegmentFilter', foreign_table?: string | null, group?: string | null, parameters: Array<{ __typename?: 'QueryFilter', column: string, filterOp: FilterOp, value: { __typename?: 'QueryFilterValue', string?: string | null, float?: number | null, boolean?: boolean | null, stringArray?: Array<string> | null, floatArray?: Array<number> | null, millisFromNow?: number | null, relativeTime?: { __typename?: 'RelativeTime', quantity: number, unit: TimeUnit, direction: ReferenceDirection } | null } }> }> | null, any_other_exclusions?: Array<{ __typename?: 'SegmentFilter', foreign_table?: string | null, group?: string | null, parameters: Array<{ __typename?: 'QueryFilter', column: string, filterOp: FilterOp, value: { __typename?: 'QueryFilterValue', string?: string | null, float?: number | null, boolean?: boolean | null, stringArray?: Array<string> | null, floatArray?: Array<number> | null, millisFromNow?: number | null, relativeTime?: { __typename?: 'RelativeTime', quantity: number, unit: TimeUnit, direction: ReferenceDirection } | null } }> }> | null, filters?: Array<{ __typename?: 'CustomerSegmentFilter', filters: Array<{ __typename?: 'QueryFilter', column: string, filterOp: FilterOp, value: { __typename?: 'QueryFilterValue', string?: string | null, float?: number | null, boolean?: boolean | null, stringArray?: Array<string> | null, floatArray?: Array<number> | null, millisFromNow?: number | null, relativeTime?: { __typename?: 'RelativeTime', quantity: number, unit: TimeUnit, direction: ReferenceDirection } | null } }> }> | null, excluded_filters: Array<{ __typename?: 'CustomerSegmentFilter', filters: Array<{ __typename?: 'QueryFilter', column: string, filterOp: FilterOp, value: { __typename?: 'QueryFilterValue', string?: string | null, float?: number | null, boolean?: boolean | null, stringArray?: Array<string> | null, floatArray?: Array<number> | null, millisFromNow?: number | null, relativeTime?: { __typename?: 'RelativeTime', quantity: number, unit: TimeUnit, direction: ReferenceDirection } | null } }> }> } | null, referral_customer_segment?: { __typename?: 'CustomerSegment', id: string, name: string, trigger_entity?: CustomerSegmentTrigger | null, is_archived: boolean, updated_at: number, notification_templates?: Array<{ __typename?: 'NotificationTemplate', id: string, name: string, is_active: boolean, is_archived: boolean, message_methods: Array<MessageMethod> }> | null, error_flags?: Array<{ __typename?: 'CustomerSegmentErrorFlag', filter_column: string, filter_index: number, parameter_index: number, message: string }> | null, all_inclusions?: Array<{ __typename?: 'SegmentFilter', foreign_table?: string | null, group?: string | null, parameters: Array<{ __typename?: 'QueryFilter', column: string, filterOp: FilterOp, value: { __typename?: 'QueryFilterValue', string?: string | null, float?: number | null, boolean?: boolean | null, stringArray?: Array<string> | null, floatArray?: Array<number> | null, millisFromNow?: number | null, relativeTime?: { __typename?: 'RelativeTime', quantity: number, unit: TimeUnit, direction: ReferenceDirection } | null } }> }> | null, any_inclusions?: Array<{ __typename?: 'SegmentFilter', foreign_table?: string | null, group?: string | null, parameters: Array<{ __typename?: 'QueryFilter', column: string, filterOp: FilterOp, value: { __typename?: 'QueryFilterValue', string?: string | null, float?: number | null, boolean?: boolean | null, stringArray?: Array<string> | null, floatArray?: Array<number> | null, millisFromNow?: number | null, relativeTime?: { __typename?: 'RelativeTime', quantity: number, unit: TimeUnit, direction: ReferenceDirection } | null } }> }> | null, any_exclusions?: Array<{ __typename?: 'SegmentFilter', foreign_table?: string | null, group?: string | null, parameters: Array<{ __typename?: 'QueryFilter', column: string, filterOp: FilterOp, value: { __typename?: 'QueryFilterValue', string?: string | null, float?: number | null, boolean?: boolean | null, stringArray?: Array<string> | null, floatArray?: Array<number> | null, millisFromNow?: number | null, relativeTime?: { __typename?: 'RelativeTime', quantity: number, unit: TimeUnit, direction: ReferenceDirection } | null } }> }> | null, any_other_exclusions?: Array<{ __typename?: 'SegmentFilter', foreign_table?: string | null, group?: string | null, parameters: Array<{ __typename?: 'QueryFilter', column: string, filterOp: FilterOp, value: { __typename?: 'QueryFilterValue', string?: string | null, float?: number | null, boolean?: boolean | null, stringArray?: Array<string> | null, floatArray?: Array<number> | null, millisFromNow?: number | null, relativeTime?: { __typename?: 'RelativeTime', quantity: number, unit: TimeUnit, direction: ReferenceDirection } | null } }> }> | null, filters?: Array<{ __typename?: 'CustomerSegmentFilter', filters: Array<{ __typename?: 'QueryFilter', column: string, filterOp: FilterOp, value: { __typename?: 'QueryFilterValue', string?: string | null, float?: number | null, boolean?: boolean | null, stringArray?: Array<string> | null, floatArray?: Array<number> | null, millisFromNow?: number | null, relativeTime?: { __typename?: 'RelativeTime', quantity: number, unit: TimeUnit, direction: ReferenceDirection } | null } }> }> | null, excluded_filters: Array<{ __typename?: 'CustomerSegmentFilter', filters: Array<{ __typename?: 'QueryFilter', column: string, filterOp: FilterOp, value: { __typename?: 'QueryFilterValue', string?: string | null, float?: number | null, boolean?: boolean | null, stringArray?: Array<string> | null, floatArray?: Array<number> | null, millisFromNow?: number | null, relativeTime?: { __typename?: 'RelativeTime', quantity: number, unit: TimeUnit, direction: ReferenceDirection } | null } }> }> } | null, webhooks?: Array<{ __typename?: 'WebhookConfig', id: string, name: string, url: string, events: Array<WebhookEventType>, secret?: string | null, enabled: boolean }> | null, times_first_filter_config?: { __typename?: 'TimesFirstFilterConfig', service?: BookingFilterDisplayMode | null, clinician?: BookingFilterDisplayMode | null, species?: BookingFilterDisplayMode | null, client_status?: BookingFilterDisplayMode | null, patient_status?: BookingFilterDisplayMode | null, patient_gender?: BookingFilterDisplayMode | null, fixed_status?: BookingFilterDisplayMode | null } | null } | null, clinic_group_clinics: Array<{ __typename?: 'ClinicGroupClinic', id: string, created_at: number, clinic: { __typename?: 'Clinic', id: string, name?: string | null, slug?: string | null, avatar_url?: string | null, time_zone?: string | null, is_archived: boolean, address?: { __typename?: 'Address', street_a?: string | null, street_b?: string | null, city?: string | null, state?: string | null, zip?: string | null, country?: string | null } | null, pms_db?: { __typename?: 'PmsDb', id: string } | null } }>, clinic_group_users: Array<{ __typename?: 'ClinicGroupUser', id: string, role: AuthRoles, are_email_notifications_enabled: boolean, are_sms_notifications_enabled: boolean, are_desktop_notifications_enabled: boolean, created_at: number, clinic_group: { __typename?: 'ClinicGroup', id: string }, user: { __typename?: 'User', id: string, email?: any | null, first_name?: string | null, last_name?: string | null, avatar_url?: string | null, invitation_status?: UserInvitationStatus | null }, custom_role?: { __typename?: 'CustomRole', id: string, name: string } | null, permissions?: Array<{ __typename?: 'ClinicAdminPermission', feature: AdminPermissionFeature, access_level: AdminPermissionAccessLevel }> | null }>, parent_clinic_group?: { __typename?: 'ClinicGroup', id: string, name: string } | null, clinic_groups: Array<{ __typename?: 'ClinicGroup', id: string, name: string, slug: string, is_archived: boolean, clinic_group_clinics: Array<{ __typename?: 'ClinicGroupClinic', id: string, created_at: number, clinic: { __typename?: 'Clinic', id: string, name?: string | null, slug?: string | null, avatar_url?: string | null, time_zone?: string | null, is_archived: boolean, address?: { __typename?: 'Address', street_a?: string | null, street_b?: string | null, city?: string | null, state?: string | null, zip?: string | null, country?: string | null } | null, pms_db?: { __typename?: 'PmsDb', id: string } | null } }> }> }> };

export type CreateClinicGroupMutationVariables = Exact<{
  data: CreateClinicGroupInput;
}>;


export type CreateClinicGroupMutation = { __typename?: 'Mutation', createClinicGroup: { __typename?: 'ClinicGroup', id: string, name: string, slug: string, is_archived: boolean, created_at: number, updated_at: number, settings?: { __typename?: 'ClinicSettings', id?: string | null, does_require_verification?: boolean | null, does_use_automatic_reschedule?: boolean | null, reset_status_to_booked_on_reschedule?: boolean | null, is_using_detailed_services?: boolean | null, hide_review_step?: boolean | null, is_using_rooms?: boolean | null, pms_start_time?: any | null, pms_end_time?: any | null, primary_color?: string | null, accent_color?: string | null, secondary_color?: string | null, new_appt_requested_msg?: string | null, new_appt_approved_msg?: string | null, new_appt_approved_sms_msg?: string | null, new_appt_denied_msg?: string | null, schedule_method?: ScheduleMethod | null, scheduling_buffer_minutes?: number | null, base_schedule_duration?: number | null, does_require_referral?: boolean | null, appointment_entry_method?: AppointmentEntryMethod | null, scheduling_min_minutes_away?: number | null, scheduling_max_minutes_away?: number | null, included_species?: Array<Species> | null, max_patients_per_visit?: number | null, should_complete_sync?: boolean | null, server_syncing_only?: boolean | null, confirmation_days_before?: number | null, send_confirmations_to: SendConfirmationsTo, send_new_appt_email?: boolean | null, send_reviews_to?: SendConfirmationsTo | null, max_review_rating_for_notif?: number | null, google_review_link?: string | null, facebook_review_link?: string | null, non_blocking_services: Array<string>, yesterday_revenue?: number | null, this_month_revenue?: number | null, hide_clinician_preference: boolean, does_use_rooms_to_schedule?: boolean | null, primary_room_pms_id?: string | null, should_default_pims_emails_on: boolean, should_default_pims_sms_on: boolean, should_default_marketing_sms_on: boolean, should_default_marketing_email_on: boolean, does_use_clinicians_to_schedule?: boolean | null, time_slot_minutes: number, sync_interval_minutes: number, long_sync_interval_hours: number, primary_clinician_pms_id?: string | null, cancellation_clinician_pms_id?: string | null, cancellation_service_pms_id?: string | null, allow_first_appt_per_day?: boolean | null, custom_well_description?: string | null, custom_sick_description?: string | null, custom_other_title?: string | null, custom_other_description?: string | null, default_trigger_words?: Array<string> | null, should_use_private_reviews?: boolean | null, notify_clinic_on?: Array<NotifyClinicOn> | null, reminder_send_time_minutes?: number | null, does_require_new_client_address?: boolean | null, does_require_new_client_birthday?: boolean | null, should_allow_new_clients?: boolean | null, should_allow_new_patients?: boolean | null, should_create_clients?: boolean | null, should_create_patients?: boolean | null, msgs_auto_priority?: boolean | null, booking_match_procedure?: BookingMatchProcedure | null, urgency_type?: UrgencyType | null, max_booking_columns?: number | null, hide_closed_days_from_scheduling?: boolean | null, should_sync_reminders?: boolean | null, auto_reply_enabled: boolean, auto_reply_message?: string | null, unreplied_message_alert_enabled: boolean, unreplied_message_alert_minutes: number, comms_writeback_enabled: boolean, comms_should_daily_writeback: boolean, comms_use_pdf_for_writeback: boolean, comms_writeback_buffer_minutes: number, comms_writeback_before_appt_mins: number, comms_should_writeback_on_send: boolean, comms_should_writeback_on_receive: boolean, comms_should_writeback_notifs: boolean, comms_should_use_ai_writeback: boolean, form_writeback_enabled: boolean, should_award_loyalty_for_invoices?: boolean | null, invoice_loyalty_points_per_dollar?: number | null, app_download_loyalty_points?: number | null, referrer_loyalty_points?: number | null, referred_loyalty_points?: number | null, custom_appointment_notes_template?: string | null, custom_new_client_notes_template?: string | null, custom_new_patient_notes_template?: string | null, max_inactivity_duration?: number | null, hide_portal_vaccinations: boolean, hide_portal_reminders: boolean, hide_portal_prescriptions: boolean, hide_portal_weight: boolean, hide_soc_vaccinations?: boolean | null, hide_historic_vaccinations?: boolean | null, should_hide_daily_huddle_financials: boolean, patient_details_tab_order: Array<PortalPatientDetailsTab>, clinic_hours_display?: string | null, reschedule_buffer_minutes?: number | null, cancellation_buffer_minutes?: number | null, require_reason_for_cancellation?: boolean | null, should_automatically_assign_patient?: boolean | null, payment_writeback_enabled: boolean, auto_refund_on_cancel: boolean, status_set_on_payment_completed_pms_id?: string | null, max_booking_notes_length?: number | null, min_booking_notes_length?: number | null, primary_clinic_group_id?: string | null, should_suggest_nearby_clinics?: boolean | null, sms_block_list?: Array<string> | null, exclude_message_wrapper?: boolean | null, should_charge_client_stripe_fees?: boolean | null, chckvet_prescription_fee_split_percentage?: number | null, gtm_container_id?: string | null, review_google_id?: string | null, review_facebook_id?: string | null, only_use_adj_avail_guides: boolean, use_basic_timeslots: boolean, valid_booking_interval_minutes?: Array<number> | null, should_disable_online_scheduling?: boolean | null, simple_scheduling_rules_enabled: boolean, compliance_statuses?: Array<string> | null, should_use_instant_prescription_requests?: boolean | null, prescription_pickup_service_id?: string | null, default_reminder_service_id?: string | null, ai_calls_provider?: PhoneProviderType | null, ai_calls_phone_number?: string | null, ai_calls_voice_id?: string | null, ai_calls_agent_id?: string | null, ai_agent_style?: string | null, ai_agent_custom_instructions?: string | null, ai_calls_ambient_sound?: AiCallsAmbientSound | null, ai_calls_voice_speed?: number | null, ai_calls_interruption_sensitivity?: number | null, ai_calls_enable_dynamic_voice_speed?: boolean | null, usage_spending_caps?: any | null, custom_merge_tags?: any | null, custom_booking_copy?: { __typename?: 'ClinicBookingCopy', WIDGET_HEADER_TITLE?: string | null, SHOW_CLINIC_HEADER_LOGO?: boolean | null, CLINIC_HEADER_LOGO_HEIGHT?: number | null, SERVICE_TYPE_SECTION_HEADING?: string | null, DEFAULT_WELLNESS_DESCRIPTION?: string | null, DEFAULT_SICK_DESCRIPTION?: string | null, DEFAULT_OTHER_DESCRIPTION?: string | null, RETURNING_PATIENT_QUESTION?: string | null, POSITIVE_RETURNING_PATIENT_ANSWER?: string | null, NEGATIVE_RETURNING_PATIENT_ANSWER?: string | null, RETURNING_CLIENT_QUESTION?: string | null, POSITIVE_RETURNING_CLIENT_ANSWER?: string | null, NEGATIVE_RETURNING_CLIENT_ANSWER?: string | null, CLIENT_INFORMATION_SECTION_TITLE?: string | null, PATIENT_INFORMATION_SECTION_TITLE?: string | null, RETURNING_CLIENT_PATIENT_TITLE?: string | null, RETURNING_CLIENT_PATIENT_DESCRIPTION?: string | null, SERVICE_SECTION_TITLE?: string | null, PREPAID_SERVICES_LABEL?: string | null, STANDARD_SERVICES_LABEL?: string | null, DEPOSIT_FEE_NAME?: string | null, PREVIOUS_OR_REFERRING_CLINIC_QUESTION?: string | null, CONTACT_THE_CLINIC_TEXT?: string | null, CONTACT_THE_CLINIC_TEXT_COLOR?: string | null, CONTACT_THE_CLINIC_TEXT_SIZE?: string | null, SELECT_CLINICIAN_TITLE?: string | null, SELECT_CLINICIAN_POSITIVE_ANSWER?: string | null, SELECT_CLINICIAN_NEGATIVE_ANSWER?: string | null, SELECT_TIME_TITLE?: string | null, REVIEW_TITLE?: string | null, REVIEW_NOTES_PROMPT?: string | null, PAYMENT_INFORMATION_TITLE?: string | null, TRIGGER_WORDS_DETECTED_HEADER?: string | null, TRIGGER_WORDS_DETECTED_DESCRIPTION?: string | null, CONFIRMATION_SCREEN_TITLE?: string | null, CONFIRMATION_SCREEN_DESCRIPTION?: string | null, NEW_CLIENT_BLOCKED_MESSAGE?: string | null, NEW_PATIENT_BLOCKED_MESSAGE?: string | null } | null, auto_reply_hours?: { __typename?: 'AvailabilityHours', monday?: Array<{ __typename?: 'TimeInterval', start?: number | null, end?: number | null }> | null, tuesday?: Array<{ __typename?: 'TimeInterval', start?: number | null, end?: number | null }> | null, wednesday?: Array<{ __typename?: 'TimeInterval', start?: number | null, end?: number | null }> | null, thursday?: Array<{ __typename?: 'TimeInterval', start?: number | null, end?: number | null }> | null, friday?: Array<{ __typename?: 'TimeInterval', start?: number | null, end?: number | null }> | null, saturday?: Array<{ __typename?: 'TimeInterval', start?: number | null, end?: number | null }> | null, sunday?: Array<{ __typename?: 'TimeInterval', start?: number | null, end?: number | null }> | null } | null, portal_links?: Array<{ __typename?: 'PortalLink', label: string, url: string }> | null, custom_reviews_copy?: { __typename?: 'ClinicReviewsCopy', REVIEW_METHOD_PAGE_TITLE?: string | null, REVIEW_METHOD_PAGE_DESCRIPTION?: string | null, PRIVATE_REVIEW_BUTTON_HELP_TEXT?: string | null, PRIVATE_REVIEW_BUTTON_TEXT?: string | null, REVIEW_PAGE_TITLE?: string | null, REVIEW_PAGE_SUBTITLE?: string | null, REVIEW_SCORE_LABEL?: string | null, REVIEW_MESSAGE_LABEL?: string | null, REVIEW_SUBMIT_BUTTON_TEXT?: string | null } | null, waitlist_customer_segment?: { __typename?: 'CustomerSegment', id: string, name: string, trigger_entity?: CustomerSegmentTrigger | null, is_archived: boolean, updated_at: number, notification_templates?: Array<{ __typename?: 'NotificationTemplate', id: string, name: string, is_active: boolean, is_archived: boolean, message_methods: Array<MessageMethod> }> | null, error_flags?: Array<{ __typename?: 'CustomerSegmentErrorFlag', filter_column: string, filter_index: number, parameter_index: number, message: string }> | null, all_inclusions?: Array<{ __typename?: 'SegmentFilter', foreign_table?: string | null, group?: string | null, parameters: Array<{ __typename?: 'QueryFilter', column: string, filterOp: FilterOp, value: { __typename?: 'QueryFilterValue', string?: string | null, float?: number | null, boolean?: boolean | null, stringArray?: Array<string> | null, floatArray?: Array<number> | null, millisFromNow?: number | null, relativeTime?: { __typename?: 'RelativeTime', quantity: number, unit: TimeUnit, direction: ReferenceDirection } | null } }> }> | null, any_inclusions?: Array<{ __typename?: 'SegmentFilter', foreign_table?: string | null, group?: string | null, parameters: Array<{ __typename?: 'QueryFilter', column: string, filterOp: FilterOp, value: { __typename?: 'QueryFilterValue', string?: string | null, float?: number | null, boolean?: boolean | null, stringArray?: Array<string> | null, floatArray?: Array<number> | null, millisFromNow?: number | null, relativeTime?: { __typename?: 'RelativeTime', quantity: number, unit: TimeUnit, direction: ReferenceDirection } | null } }> }> | null, any_exclusions?: Array<{ __typename?: 'SegmentFilter', foreign_table?: string | null, group?: string | null, parameters: Array<{ __typename?: 'QueryFilter', column: string, filterOp: FilterOp, value: { __typename?: 'QueryFilterValue', string?: string | null, float?: number | null, boolean?: boolean | null, stringArray?: Array<string> | null, floatArray?: Array<number> | null, millisFromNow?: number | null, relativeTime?: { __typename?: 'RelativeTime', quantity: number, unit: TimeUnit, direction: ReferenceDirection } | null } }> }> | null, any_other_exclusions?: Array<{ __typename?: 'SegmentFilter', foreign_table?: string | null, group?: string | null, parameters: Array<{ __typename?: 'QueryFilter', column: string, filterOp: FilterOp, value: { __typename?: 'QueryFilterValue', string?: string | null, float?: number | null, boolean?: boolean | null, stringArray?: Array<string> | null, floatArray?: Array<number> | null, millisFromNow?: number | null, relativeTime?: { __typename?: 'RelativeTime', quantity: number, unit: TimeUnit, direction: ReferenceDirection } | null } }> }> | null, filters?: Array<{ __typename?: 'CustomerSegmentFilter', filters: Array<{ __typename?: 'QueryFilter', column: string, filterOp: FilterOp, value: { __typename?: 'QueryFilterValue', string?: string | null, float?: number | null, boolean?: boolean | null, stringArray?: Array<string> | null, floatArray?: Array<number> | null, millisFromNow?: number | null, relativeTime?: { __typename?: 'RelativeTime', quantity: number, unit: TimeUnit, direction: ReferenceDirection } | null } }> }> | null, excluded_filters: Array<{ __typename?: 'CustomerSegmentFilter', filters: Array<{ __typename?: 'QueryFilter', column: string, filterOp: FilterOp, value: { __typename?: 'QueryFilterValue', string?: string | null, float?: number | null, boolean?: boolean | null, stringArray?: Array<string> | null, floatArray?: Array<number> | null, millisFromNow?: number | null, relativeTime?: { __typename?: 'RelativeTime', quantity: number, unit: TimeUnit, direction: ReferenceDirection } | null } }> }> } | null, blocklist_customer_segment?: { __typename?: 'CustomerSegment', id: string, name: string, trigger_entity?: CustomerSegmentTrigger | null, is_archived: boolean, updated_at: number, notification_templates?: Array<{ __typename?: 'NotificationTemplate', id: string, name: string, is_active: boolean, is_archived: boolean, message_methods: Array<MessageMethod> }> | null, error_flags?: Array<{ __typename?: 'CustomerSegmentErrorFlag', filter_column: string, filter_index: number, parameter_index: number, message: string }> | null, all_inclusions?: Array<{ __typename?: 'SegmentFilter', foreign_table?: string | null, group?: string | null, parameters: Array<{ __typename?: 'QueryFilter', column: string, filterOp: FilterOp, value: { __typename?: 'QueryFilterValue', string?: string | null, float?: number | null, boolean?: boolean | null, stringArray?: Array<string> | null, floatArray?: Array<number> | null, millisFromNow?: number | null, relativeTime?: { __typename?: 'RelativeTime', quantity: number, unit: TimeUnit, direction: ReferenceDirection } | null } }> }> | null, any_inclusions?: Array<{ __typename?: 'SegmentFilter', foreign_table?: string | null, group?: string | null, parameters: Array<{ __typename?: 'QueryFilter', column: string, filterOp: FilterOp, value: { __typename?: 'QueryFilterValue', string?: string | null, float?: number | null, boolean?: boolean | null, stringArray?: Array<string> | null, floatArray?: Array<number> | null, millisFromNow?: number | null, relativeTime?: { __typename?: 'RelativeTime', quantity: number, unit: TimeUnit, direction: ReferenceDirection } | null } }> }> | null, any_exclusions?: Array<{ __typename?: 'SegmentFilter', foreign_table?: string | null, group?: string | null, parameters: Array<{ __typename?: 'QueryFilter', column: string, filterOp: FilterOp, value: { __typename?: 'QueryFilterValue', string?: string | null, float?: number | null, boolean?: boolean | null, stringArray?: Array<string> | null, floatArray?: Array<number> | null, millisFromNow?: number | null, relativeTime?: { __typename?: 'RelativeTime', quantity: number, unit: TimeUnit, direction: ReferenceDirection } | null } }> }> | null, any_other_exclusions?: Array<{ __typename?: 'SegmentFilter', foreign_table?: string | null, group?: string | null, parameters: Array<{ __typename?: 'QueryFilter', column: string, filterOp: FilterOp, value: { __typename?: 'QueryFilterValue', string?: string | null, float?: number | null, boolean?: boolean | null, stringArray?: Array<string> | null, floatArray?: Array<number> | null, millisFromNow?: number | null, relativeTime?: { __typename?: 'RelativeTime', quantity: number, unit: TimeUnit, direction: ReferenceDirection } | null } }> }> | null, filters?: Array<{ __typename?: 'CustomerSegmentFilter', filters: Array<{ __typename?: 'QueryFilter', column: string, filterOp: FilterOp, value: { __typename?: 'QueryFilterValue', string?: string | null, float?: number | null, boolean?: boolean | null, stringArray?: Array<string> | null, floatArray?: Array<number> | null, millisFromNow?: number | null, relativeTime?: { __typename?: 'RelativeTime', quantity: number, unit: TimeUnit, direction: ReferenceDirection } | null } }> }> | null, excluded_filters: Array<{ __typename?: 'CustomerSegmentFilter', filters: Array<{ __typename?: 'QueryFilter', column: string, filterOp: FilterOp, value: { __typename?: 'QueryFilterValue', string?: string | null, float?: number | null, boolean?: boolean | null, stringArray?: Array<string> | null, floatArray?: Array<number> | null, millisFromNow?: number | null, relativeTime?: { __typename?: 'RelativeTime', quantity: number, unit: TimeUnit, direction: ReferenceDirection } | null } }> }> } | null, referral_customer_segment?: { __typename?: 'CustomerSegment', id: string, name: string, trigger_entity?: CustomerSegmentTrigger | null, is_archived: boolean, updated_at: number, notification_templates?: Array<{ __typename?: 'NotificationTemplate', id: string, name: string, is_active: boolean, is_archived: boolean, message_methods: Array<MessageMethod> }> | null, error_flags?: Array<{ __typename?: 'CustomerSegmentErrorFlag', filter_column: string, filter_index: number, parameter_index: number, message: string }> | null, all_inclusions?: Array<{ __typename?: 'SegmentFilter', foreign_table?: string | null, group?: string | null, parameters: Array<{ __typename?: 'QueryFilter', column: string, filterOp: FilterOp, value: { __typename?: 'QueryFilterValue', string?: string | null, float?: number | null, boolean?: boolean | null, stringArray?: Array<string> | null, floatArray?: Array<number> | null, millisFromNow?: number | null, relativeTime?: { __typename?: 'RelativeTime', quantity: number, unit: TimeUnit, direction: ReferenceDirection } | null } }> }> | null, any_inclusions?: Array<{ __typename?: 'SegmentFilter', foreign_table?: string | null, group?: string | null, parameters: Array<{ __typename?: 'QueryFilter', column: string, filterOp: FilterOp, value: { __typename?: 'QueryFilterValue', string?: string | null, float?: number | null, boolean?: boolean | null, stringArray?: Array<string> | null, floatArray?: Array<number> | null, millisFromNow?: number | null, relativeTime?: { __typename?: 'RelativeTime', quantity: number, unit: TimeUnit, direction: ReferenceDirection } | null } }> }> | null, any_exclusions?: Array<{ __typename?: 'SegmentFilter', foreign_table?: string | null, group?: string | null, parameters: Array<{ __typename?: 'QueryFilter', column: string, filterOp: FilterOp, value: { __typename?: 'QueryFilterValue', string?: string | null, float?: number | null, boolean?: boolean | null, stringArray?: Array<string> | null, floatArray?: Array<number> | null, millisFromNow?: number | null, relativeTime?: { __typename?: 'RelativeTime', quantity: number, unit: TimeUnit, direction: ReferenceDirection } | null } }> }> | null, any_other_exclusions?: Array<{ __typename?: 'SegmentFilter', foreign_table?: string | null, group?: string | null, parameters: Array<{ __typename?: 'QueryFilter', column: string, filterOp: FilterOp, value: { __typename?: 'QueryFilterValue', string?: string | null, float?: number | null, boolean?: boolean | null, stringArray?: Array<string> | null, floatArray?: Array<number> | null, millisFromNow?: number | null, relativeTime?: { __typename?: 'RelativeTime', quantity: number, unit: TimeUnit, direction: ReferenceDirection } | null } }> }> | null, filters?: Array<{ __typename?: 'CustomerSegmentFilter', filters: Array<{ __typename?: 'QueryFilter', column: string, filterOp: FilterOp, value: { __typename?: 'QueryFilterValue', string?: string | null, float?: number | null, boolean?: boolean | null, stringArray?: Array<string> | null, floatArray?: Array<number> | null, millisFromNow?: number | null, relativeTime?: { __typename?: 'RelativeTime', quantity: number, unit: TimeUnit, direction: ReferenceDirection } | null } }> }> | null, excluded_filters: Array<{ __typename?: 'CustomerSegmentFilter', filters: Array<{ __typename?: 'QueryFilter', column: string, filterOp: FilterOp, value: { __typename?: 'QueryFilterValue', string?: string | null, float?: number | null, boolean?: boolean | null, stringArray?: Array<string> | null, floatArray?: Array<number> | null, millisFromNow?: number | null, relativeTime?: { __typename?: 'RelativeTime', quantity: number, unit: TimeUnit, direction: ReferenceDirection } | null } }> }> } | null, webhooks?: Array<{ __typename?: 'WebhookConfig', id: string, name: string, url: string, events: Array<WebhookEventType>, secret?: string | null, enabled: boolean }> | null, times_first_filter_config?: { __typename?: 'TimesFirstFilterConfig', service?: BookingFilterDisplayMode | null, clinician?: BookingFilterDisplayMode | null, species?: BookingFilterDisplayMode | null, client_status?: BookingFilterDisplayMode | null, patient_status?: BookingFilterDisplayMode | null, patient_gender?: BookingFilterDisplayMode | null, fixed_status?: BookingFilterDisplayMode | null } | null } | null, clinic_group_clinics: Array<{ __typename?: 'ClinicGroupClinic', id: string, created_at: number, clinic: { __typename?: 'Clinic', id: string, name?: string | null, slug?: string | null, avatar_url?: string | null, time_zone?: string | null, is_archived: boolean, address?: { __typename?: 'Address', street_a?: string | null, street_b?: string | null, city?: string | null, state?: string | null, zip?: string | null, country?: string | null } | null, pms_db?: { __typename?: 'PmsDb', id: string } | null } }>, clinic_group_users: Array<{ __typename?: 'ClinicGroupUser', id: string, role: AuthRoles, are_email_notifications_enabled: boolean, are_sms_notifications_enabled: boolean, are_desktop_notifications_enabled: boolean, created_at: number, clinic_group: { __typename?: 'ClinicGroup', id: string }, user: { __typename?: 'User', id: string, email?: any | null, first_name?: string | null, last_name?: string | null, avatar_url?: string | null, invitation_status?: UserInvitationStatus | null }, custom_role?: { __typename?: 'CustomRole', id: string, name: string } | null, permissions?: Array<{ __typename?: 'ClinicAdminPermission', feature: AdminPermissionFeature, access_level: AdminPermissionAccessLevel }> | null }>, parent_clinic_group?: { __typename?: 'ClinicGroup', id: string, name: string } | null, clinic_groups: Array<{ __typename?: 'ClinicGroup', id: string, name: string, slug: string, is_archived: boolean, clinic_group_clinics: Array<{ __typename?: 'ClinicGroupClinic', id: string, created_at: number, clinic: { __typename?: 'Clinic', id: string, name?: string | null, slug?: string | null, avatar_url?: string | null, time_zone?: string | null, is_archived: boolean, address?: { __typename?: 'Address', street_a?: string | null, street_b?: string | null, city?: string | null, state?: string | null, zip?: string | null, country?: string | null } | null, pms_db?: { __typename?: 'PmsDb', id: string } | null } }> }> } };

export type UpdateClinicGroupMutationVariables = Exact<{
  id: Scalars['ID']['input'];
  data: UpdateClinicGroupInput;
}>;


export type UpdateClinicGroupMutation = { __typename?: 'Mutation', updateClinicGroup: { __typename?: 'ClinicGroup', id: string, name: string, slug: string, is_archived: boolean, created_at: number, updated_at: number, settings?: { __typename?: 'ClinicSettings', id?: string | null, does_require_verification?: boolean | null, does_use_automatic_reschedule?: boolean | null, reset_status_to_booked_on_reschedule?: boolean | null, is_using_detailed_services?: boolean | null, hide_review_step?: boolean | null, is_using_rooms?: boolean | null, pms_start_time?: any | null, pms_end_time?: any | null, primary_color?: string | null, accent_color?: string | null, secondary_color?: string | null, new_appt_requested_msg?: string | null, new_appt_approved_msg?: string | null, new_appt_approved_sms_msg?: string | null, new_appt_denied_msg?: string | null, schedule_method?: ScheduleMethod | null, scheduling_buffer_minutes?: number | null, base_schedule_duration?: number | null, does_require_referral?: boolean | null, appointment_entry_method?: AppointmentEntryMethod | null, scheduling_min_minutes_away?: number | null, scheduling_max_minutes_away?: number | null, included_species?: Array<Species> | null, max_patients_per_visit?: number | null, should_complete_sync?: boolean | null, server_syncing_only?: boolean | null, confirmation_days_before?: number | null, send_confirmations_to: SendConfirmationsTo, send_new_appt_email?: boolean | null, send_reviews_to?: SendConfirmationsTo | null, max_review_rating_for_notif?: number | null, google_review_link?: string | null, facebook_review_link?: string | null, non_blocking_services: Array<string>, yesterday_revenue?: number | null, this_month_revenue?: number | null, hide_clinician_preference: boolean, does_use_rooms_to_schedule?: boolean | null, primary_room_pms_id?: string | null, should_default_pims_emails_on: boolean, should_default_pims_sms_on: boolean, should_default_marketing_sms_on: boolean, should_default_marketing_email_on: boolean, does_use_clinicians_to_schedule?: boolean | null, time_slot_minutes: number, sync_interval_minutes: number, long_sync_interval_hours: number, primary_clinician_pms_id?: string | null, cancellation_clinician_pms_id?: string | null, cancellation_service_pms_id?: string | null, allow_first_appt_per_day?: boolean | null, custom_well_description?: string | null, custom_sick_description?: string | null, custom_other_title?: string | null, custom_other_description?: string | null, default_trigger_words?: Array<string> | null, should_use_private_reviews?: boolean | null, notify_clinic_on?: Array<NotifyClinicOn> | null, reminder_send_time_minutes?: number | null, does_require_new_client_address?: boolean | null, does_require_new_client_birthday?: boolean | null, should_allow_new_clients?: boolean | null, should_allow_new_patients?: boolean | null, should_create_clients?: boolean | null, should_create_patients?: boolean | null, msgs_auto_priority?: boolean | null, booking_match_procedure?: BookingMatchProcedure | null, urgency_type?: UrgencyType | null, max_booking_columns?: number | null, hide_closed_days_from_scheduling?: boolean | null, should_sync_reminders?: boolean | null, auto_reply_enabled: boolean, auto_reply_message?: string | null, unreplied_message_alert_enabled: boolean, unreplied_message_alert_minutes: number, comms_writeback_enabled: boolean, comms_should_daily_writeback: boolean, comms_use_pdf_for_writeback: boolean, comms_writeback_buffer_minutes: number, comms_writeback_before_appt_mins: number, comms_should_writeback_on_send: boolean, comms_should_writeback_on_receive: boolean, comms_should_writeback_notifs: boolean, comms_should_use_ai_writeback: boolean, form_writeback_enabled: boolean, should_award_loyalty_for_invoices?: boolean | null, invoice_loyalty_points_per_dollar?: number | null, app_download_loyalty_points?: number | null, referrer_loyalty_points?: number | null, referred_loyalty_points?: number | null, custom_appointment_notes_template?: string | null, custom_new_client_notes_template?: string | null, custom_new_patient_notes_template?: string | null, max_inactivity_duration?: number | null, hide_portal_vaccinations: boolean, hide_portal_reminders: boolean, hide_portal_prescriptions: boolean, hide_portal_weight: boolean, hide_soc_vaccinations?: boolean | null, hide_historic_vaccinations?: boolean | null, should_hide_daily_huddle_financials: boolean, patient_details_tab_order: Array<PortalPatientDetailsTab>, clinic_hours_display?: string | null, reschedule_buffer_minutes?: number | null, cancellation_buffer_minutes?: number | null, require_reason_for_cancellation?: boolean | null, should_automatically_assign_patient?: boolean | null, payment_writeback_enabled: boolean, auto_refund_on_cancel: boolean, status_set_on_payment_completed_pms_id?: string | null, max_booking_notes_length?: number | null, min_booking_notes_length?: number | null, primary_clinic_group_id?: string | null, should_suggest_nearby_clinics?: boolean | null, sms_block_list?: Array<string> | null, exclude_message_wrapper?: boolean | null, should_charge_client_stripe_fees?: boolean | null, chckvet_prescription_fee_split_percentage?: number | null, gtm_container_id?: string | null, review_google_id?: string | null, review_facebook_id?: string | null, only_use_adj_avail_guides: boolean, use_basic_timeslots: boolean, valid_booking_interval_minutes?: Array<number> | null, should_disable_online_scheduling?: boolean | null, simple_scheduling_rules_enabled: boolean, compliance_statuses?: Array<string> | null, should_use_instant_prescription_requests?: boolean | null, prescription_pickup_service_id?: string | null, default_reminder_service_id?: string | null, ai_calls_provider?: PhoneProviderType | null, ai_calls_phone_number?: string | null, ai_calls_voice_id?: string | null, ai_calls_agent_id?: string | null, ai_agent_style?: string | null, ai_agent_custom_instructions?: string | null, ai_calls_ambient_sound?: AiCallsAmbientSound | null, ai_calls_voice_speed?: number | null, ai_calls_interruption_sensitivity?: number | null, ai_calls_enable_dynamic_voice_speed?: boolean | null, usage_spending_caps?: any | null, custom_merge_tags?: any | null, custom_booking_copy?: { __typename?: 'ClinicBookingCopy', WIDGET_HEADER_TITLE?: string | null, SHOW_CLINIC_HEADER_LOGO?: boolean | null, CLINIC_HEADER_LOGO_HEIGHT?: number | null, SERVICE_TYPE_SECTION_HEADING?: string | null, DEFAULT_WELLNESS_DESCRIPTION?: string | null, DEFAULT_SICK_DESCRIPTION?: string | null, DEFAULT_OTHER_DESCRIPTION?: string | null, RETURNING_PATIENT_QUESTION?: string | null, POSITIVE_RETURNING_PATIENT_ANSWER?: string | null, NEGATIVE_RETURNING_PATIENT_ANSWER?: string | null, RETURNING_CLIENT_QUESTION?: string | null, POSITIVE_RETURNING_CLIENT_ANSWER?: string | null, NEGATIVE_RETURNING_CLIENT_ANSWER?: string | null, CLIENT_INFORMATION_SECTION_TITLE?: string | null, PATIENT_INFORMATION_SECTION_TITLE?: string | null, RETURNING_CLIENT_PATIENT_TITLE?: string | null, RETURNING_CLIENT_PATIENT_DESCRIPTION?: string | null, SERVICE_SECTION_TITLE?: string | null, PREPAID_SERVICES_LABEL?: string | null, STANDARD_SERVICES_LABEL?: string | null, DEPOSIT_FEE_NAME?: string | null, PREVIOUS_OR_REFERRING_CLINIC_QUESTION?: string | null, CONTACT_THE_CLINIC_TEXT?: string | null, CONTACT_THE_CLINIC_TEXT_COLOR?: string | null, CONTACT_THE_CLINIC_TEXT_SIZE?: string | null, SELECT_CLINICIAN_TITLE?: string | null, SELECT_CLINICIAN_POSITIVE_ANSWER?: string | null, SELECT_CLINICIAN_NEGATIVE_ANSWER?: string | null, SELECT_TIME_TITLE?: string | null, REVIEW_TITLE?: string | null, REVIEW_NOTES_PROMPT?: string | null, PAYMENT_INFORMATION_TITLE?: string | null, TRIGGER_WORDS_DETECTED_HEADER?: string | null, TRIGGER_WORDS_DETECTED_DESCRIPTION?: string | null, CONFIRMATION_SCREEN_TITLE?: string | null, CONFIRMATION_SCREEN_DESCRIPTION?: string | null, NEW_CLIENT_BLOCKED_MESSAGE?: string | null, NEW_PATIENT_BLOCKED_MESSAGE?: string | null } | null, auto_reply_hours?: { __typename?: 'AvailabilityHours', monday?: Array<{ __typename?: 'TimeInterval', start?: number | null, end?: number | null }> | null, tuesday?: Array<{ __typename?: 'TimeInterval', start?: number | null, end?: number | null }> | null, wednesday?: Array<{ __typename?: 'TimeInterval', start?: number | null, end?: number | null }> | null, thursday?: Array<{ __typename?: 'TimeInterval', start?: number | null, end?: number | null }> | null, friday?: Array<{ __typename?: 'TimeInterval', start?: number | null, end?: number | null }> | null, saturday?: Array<{ __typename?: 'TimeInterval', start?: number | null, end?: number | null }> | null, sunday?: Array<{ __typename?: 'TimeInterval', start?: number | null, end?: number | null }> | null } | null, portal_links?: Array<{ __typename?: 'PortalLink', label: string, url: string }> | null, custom_reviews_copy?: { __typename?: 'ClinicReviewsCopy', REVIEW_METHOD_PAGE_TITLE?: string | null, REVIEW_METHOD_PAGE_DESCRIPTION?: string | null, PRIVATE_REVIEW_BUTTON_HELP_TEXT?: string | null, PRIVATE_REVIEW_BUTTON_TEXT?: string | null, REVIEW_PAGE_TITLE?: string | null, REVIEW_PAGE_SUBTITLE?: string | null, REVIEW_SCORE_LABEL?: string | null, REVIEW_MESSAGE_LABEL?: string | null, REVIEW_SUBMIT_BUTTON_TEXT?: string | null } | null, waitlist_customer_segment?: { __typename?: 'CustomerSegment', id: string, name: string, trigger_entity?: CustomerSegmentTrigger | null, is_archived: boolean, updated_at: number, notification_templates?: Array<{ __typename?: 'NotificationTemplate', id: string, name: string, is_active: boolean, is_archived: boolean, message_methods: Array<MessageMethod> }> | null, error_flags?: Array<{ __typename?: 'CustomerSegmentErrorFlag', filter_column: string, filter_index: number, parameter_index: number, message: string }> | null, all_inclusions?: Array<{ __typename?: 'SegmentFilter', foreign_table?: string | null, group?: string | null, parameters: Array<{ __typename?: 'QueryFilter', column: string, filterOp: FilterOp, value: { __typename?: 'QueryFilterValue', string?: string | null, float?: number | null, boolean?: boolean | null, stringArray?: Array<string> | null, floatArray?: Array<number> | null, millisFromNow?: number | null, relativeTime?: { __typename?: 'RelativeTime', quantity: number, unit: TimeUnit, direction: ReferenceDirection } | null } }> }> | null, any_inclusions?: Array<{ __typename?: 'SegmentFilter', foreign_table?: string | null, group?: string | null, parameters: Array<{ __typename?: 'QueryFilter', column: string, filterOp: FilterOp, value: { __typename?: 'QueryFilterValue', string?: string | null, float?: number | null, boolean?: boolean | null, stringArray?: Array<string> | null, floatArray?: Array<number> | null, millisFromNow?: number | null, relativeTime?: { __typename?: 'RelativeTime', quantity: number, unit: TimeUnit, direction: ReferenceDirection } | null } }> }> | null, any_exclusions?: Array<{ __typename?: 'SegmentFilter', foreign_table?: string | null, group?: string | null, parameters: Array<{ __typename?: 'QueryFilter', column: string, filterOp: FilterOp, value: { __typename?: 'QueryFilterValue', string?: string | null, float?: number | null, boolean?: boolean | null, stringArray?: Array<string> | null, floatArray?: Array<number> | null, millisFromNow?: number | null, relativeTime?: { __typename?: 'RelativeTime', quantity: number, unit: TimeUnit, direction: ReferenceDirection } | null } }> }> | null, any_other_exclusions?: Array<{ __typename?: 'SegmentFilter', foreign_table?: string | null, group?: string | null, parameters: Array<{ __typename?: 'QueryFilter', column: string, filterOp: FilterOp, value: { __typename?: 'QueryFilterValue', string?: string | null, float?: number | null, boolean?: boolean | null, stringArray?: Array<string> | null, floatArray?: Array<number> | null, millisFromNow?: number | null, relativeTime?: { __typename?: 'RelativeTime', quantity: number, unit: TimeUnit, direction: ReferenceDirection } | null } }> }> | null, filters?: Array<{ __typename?: 'CustomerSegmentFilter', filters: Array<{ __typename?: 'QueryFilter', column: string, filterOp: FilterOp, value: { __typename?: 'QueryFilterValue', string?: string | null, float?: number | null, boolean?: boolean | null, stringArray?: Array<string> | null, floatArray?: Array<number> | null, millisFromNow?: number | null, relativeTime?: { __typename?: 'RelativeTime', quantity: number, unit: TimeUnit, direction: ReferenceDirection } | null } }> }> | null, excluded_filters: Array<{ __typename?: 'CustomerSegmentFilter', filters: Array<{ __typename?: 'QueryFilter', column: string, filterOp: FilterOp, value: { __typename?: 'QueryFilterValue', string?: string | null, float?: number | null, boolean?: boolean | null, stringArray?: Array<string> | null, floatArray?: Array<number> | null, millisFromNow?: number | null, relativeTime?: { __typename?: 'RelativeTime', quantity: number, unit: TimeUnit, direction: ReferenceDirection } | null } }> }> } | null, blocklist_customer_segment?: { __typename?: 'CustomerSegment', id: string, name: string, trigger_entity?: CustomerSegmentTrigger | null, is_archived: boolean, updated_at: number, notification_templates?: Array<{ __typename?: 'NotificationTemplate', id: string, name: string, is_active: boolean, is_archived: boolean, message_methods: Array<MessageMethod> }> | null, error_flags?: Array<{ __typename?: 'CustomerSegmentErrorFlag', filter_column: string, filter_index: number, parameter_index: number, message: string }> | null, all_inclusions?: Array<{ __typename?: 'SegmentFilter', foreign_table?: string | null, group?: string | null, parameters: Array<{ __typename?: 'QueryFilter', column: string, filterOp: FilterOp, value: { __typename?: 'QueryFilterValue', string?: string | null, float?: number | null, boolean?: boolean | null, stringArray?: Array<string> | null, floatArray?: Array<number> | null, millisFromNow?: number | null, relativeTime?: { __typename?: 'RelativeTime', quantity: number, unit: TimeUnit, direction: ReferenceDirection } | null } }> }> | null, any_inclusions?: Array<{ __typename?: 'SegmentFilter', foreign_table?: string | null, group?: string | null, parameters: Array<{ __typename?: 'QueryFilter', column: string, filterOp: FilterOp, value: { __typename?: 'QueryFilterValue', string?: string | null, float?: number | null, boolean?: boolean | null, stringArray?: Array<string> | null, floatArray?: Array<number> | null, millisFromNow?: number | null, relativeTime?: { __typename?: 'RelativeTime', quantity: number, unit: TimeUnit, direction: ReferenceDirection } | null } }> }> | null, any_exclusions?: Array<{ __typename?: 'SegmentFilter', foreign_table?: string | null, group?: string | null, parameters: Array<{ __typename?: 'QueryFilter', column: string, filterOp: FilterOp, value: { __typename?: 'QueryFilterValue', string?: string | null, float?: number | null, boolean?: boolean | null, stringArray?: Array<string> | null, floatArray?: Array<number> | null, millisFromNow?: number | null, relativeTime?: { __typename?: 'RelativeTime', quantity: number, unit: TimeUnit, direction: ReferenceDirection } | null } }> }> | null, any_other_exclusions?: Array<{ __typename?: 'SegmentFilter', foreign_table?: string | null, group?: string | null, parameters: Array<{ __typename?: 'QueryFilter', column: string, filterOp: FilterOp, value: { __typename?: 'QueryFilterValue', string?: string | null, float?: number | null, boolean?: boolean | null, stringArray?: Array<string> | null, floatArray?: Array<number> | null, millisFromNow?: number | null, relativeTime?: { __typename?: 'RelativeTime', quantity: number, unit: TimeUnit, direction: ReferenceDirection } | null } }> }> | null, filters?: Array<{ __typename?: 'CustomerSegmentFilter', filters: Array<{ __typename?: 'QueryFilter', column: string, filterOp: FilterOp, value: { __typename?: 'QueryFilterValue', string?: string | null, float?: number | null, boolean?: boolean | null, stringArray?: Array<string> | null, floatArray?: Array<number> | null, millisFromNow?: number | null, relativeTime?: { __typename?: 'RelativeTime', quantity: number, unit: TimeUnit, direction: ReferenceDirection } | null } }> }> | null, excluded_filters: Array<{ __typename?: 'CustomerSegmentFilter', filters: Array<{ __typename?: 'QueryFilter', column: string, filterOp: FilterOp, value: { __typename?: 'QueryFilterValue', string?: string | null, float?: number | null, boolean?: boolean | null, stringArray?: Array<string> | null, floatArray?: Array<number> | null, millisFromNow?: number | null, relativeTime?: { __typename?: 'RelativeTime', quantity: number, unit: TimeUnit, direction: ReferenceDirection } | null } }> }> } | null, referral_customer_segment?: { __typename?: 'CustomerSegment', id: string, name: string, trigger_entity?: CustomerSegmentTrigger | null, is_archived: boolean, updated_at: number, notification_templates?: Array<{ __typename?: 'NotificationTemplate', id: string, name: string, is_active: boolean, is_archived: boolean, message_methods: Array<MessageMethod> }> | null, error_flags?: Array<{ __typename?: 'CustomerSegmentErrorFlag', filter_column: string, filter_index: number, parameter_index: number, message: string }> | null, all_inclusions?: Array<{ __typename?: 'SegmentFilter', foreign_table?: string | null, group?: string | null, parameters: Array<{ __typename?: 'QueryFilter', column: string, filterOp: FilterOp, value: { __typename?: 'QueryFilterValue', string?: string | null, float?: number | null, boolean?: boolean | null, stringArray?: Array<string> | null, floatArray?: Array<number> | null, millisFromNow?: number | null, relativeTime?: { __typename?: 'RelativeTime', quantity: number, unit: TimeUnit, direction: ReferenceDirection } | null } }> }> | null, any_inclusions?: Array<{ __typename?: 'SegmentFilter', foreign_table?: string | null, group?: string | null, parameters: Array<{ __typename?: 'QueryFilter', column: string, filterOp: FilterOp, value: { __typename?: 'QueryFilterValue', string?: string | null, float?: number | null, boolean?: boolean | null, stringArray?: Array<string> | null, floatArray?: Array<number> | null, millisFromNow?: number | null, relativeTime?: { __typename?: 'RelativeTime', quantity: number, unit: TimeUnit, direction: ReferenceDirection } | null } }> }> | null, any_exclusions?: Array<{ __typename?: 'SegmentFilter', foreign_table?: string | null, group?: string | null, parameters: Array<{ __typename?: 'QueryFilter', column: string, filterOp: FilterOp, value: { __typename?: 'QueryFilterValue', string?: string | null, float?: number | null, boolean?: boolean | null, stringArray?: Array<string> | null, floatArray?: Array<number> | null, millisFromNow?: number | null, relativeTime?: { __typename?: 'RelativeTime', quantity: number, unit: TimeUnit, direction: ReferenceDirection } | null } }> }> | null, any_other_exclusions?: Array<{ __typename?: 'SegmentFilter', foreign_table?: string | null, group?: string | null, parameters: Array<{ __typename?: 'QueryFilter', column: string, filterOp: FilterOp, value: { __typename?: 'QueryFilterValue', string?: string | null, float?: number | null, boolean?: boolean | null, stringArray?: Array<string> | null, floatArray?: Array<number> | null, millisFromNow?: number | null, relativeTime?: { __typename?: 'RelativeTime', quantity: number, unit: TimeUnit, direction: ReferenceDirection } | null } }> }> | null, filters?: Array<{ __typename?: 'CustomerSegmentFilter', filters: Array<{ __typename?: 'QueryFilter', column: string, filterOp: FilterOp, value: { __typename?: 'QueryFilterValue', string?: string | null, float?: number | null, boolean?: boolean | null, stringArray?: Array<string> | null, floatArray?: Array<number> | null, millisFromNow?: number | null, relativeTime?: { __typename?: 'RelativeTime', quantity: number, unit: TimeUnit, direction: ReferenceDirection } | null } }> }> | null, excluded_filters: Array<{ __typename?: 'CustomerSegmentFilter', filters: Array<{ __typename?: 'QueryFilter', column: string, filterOp: FilterOp, value: { __typename?: 'QueryFilterValue', string?: string | null, float?: number | null, boolean?: boolean | null, stringArray?: Array<string> | null, floatArray?: Array<number> | null, millisFromNow?: number | null, relativeTime?: { __typename?: 'RelativeTime', quantity: number, unit: TimeUnit, direction: ReferenceDirection } | null } }> }> } | null, webhooks?: Array<{ __typename?: 'WebhookConfig', id: string, name: string, url: string, events: Array<WebhookEventType>, secret?: string | null, enabled: boolean }> | null, times_first_filter_config?: { __typename?: 'TimesFirstFilterConfig', service?: BookingFilterDisplayMode | null, clinician?: BookingFilterDisplayMode | null, species?: BookingFilterDisplayMode | null, client_status?: BookingFilterDisplayMode | null, patient_status?: BookingFilterDisplayMode | null, patient_gender?: BookingFilterDisplayMode | null, fixed_status?: BookingFilterDisplayMode | null } | null } | null, clinic_group_clinics: Array<{ __typename?: 'ClinicGroupClinic', id: string, created_at: number, clinic: { __typename?: 'Clinic', id: string, name?: string | null, slug?: string | null, avatar_url?: string | null, time_zone?: string | null, is_archived: boolean, address?: { __typename?: 'Address', street_a?: string | null, street_b?: string | null, city?: string | null, state?: string | null, zip?: string | null, country?: string | null } | null, pms_db?: { __typename?: 'PmsDb', id: string } | null } }>, clinic_group_users: Array<{ __typename?: 'ClinicGroupUser', id: string, role: AuthRoles, are_email_notifications_enabled: boolean, are_sms_notifications_enabled: boolean, are_desktop_notifications_enabled: boolean, created_at: number, clinic_group: { __typename?: 'ClinicGroup', id: string }, user: { __typename?: 'User', id: string, email?: any | null, first_name?: string | null, last_name?: string | null, avatar_url?: string | null, invitation_status?: UserInvitationStatus | null }, custom_role?: { __typename?: 'CustomRole', id: string, name: string } | null, permissions?: Array<{ __typename?: 'ClinicAdminPermission', feature: AdminPermissionFeature, access_level: AdminPermissionAccessLevel }> | null }>, parent_clinic_group?: { __typename?: 'ClinicGroup', id: string, name: string } | null, clinic_groups: Array<{ __typename?: 'ClinicGroup', id: string, name: string, slug: string, is_archived: boolean, clinic_group_clinics: Array<{ __typename?: 'ClinicGroupClinic', id: string, created_at: number, clinic: { __typename?: 'Clinic', id: string, name?: string | null, slug?: string | null, avatar_url?: string | null, time_zone?: string | null, is_archived: boolean, address?: { __typename?: 'Address', street_a?: string | null, street_b?: string | null, city?: string | null, state?: string | null, zip?: string | null, country?: string | null } | null, pms_db?: { __typename?: 'PmsDb', id: string } | null } }> }> } };

export type UpdateClinicGroupSettingsMutationVariables = Exact<{
  clinicGroupId: Scalars['ID']['input'];
  settings: ClinicSettingsInput;
}>;


export type UpdateClinicGroupSettingsMutation = { __typename?: 'Mutation', updateClinicGroupSettings: { __typename?: 'ClinicSettings', id?: string | null, does_require_verification?: boolean | null, does_use_automatic_reschedule?: boolean | null, reset_status_to_booked_on_reschedule?: boolean | null, is_using_detailed_services?: boolean | null, hide_review_step?: boolean | null, is_using_rooms?: boolean | null, pms_start_time?: any | null, pms_end_time?: any | null, primary_color?: string | null, accent_color?: string | null, secondary_color?: string | null, new_appt_requested_msg?: string | null, new_appt_approved_msg?: string | null, new_appt_approved_sms_msg?: string | null, new_appt_denied_msg?: string | null, schedule_method?: ScheduleMethod | null, scheduling_buffer_minutes?: number | null, base_schedule_duration?: number | null, does_require_referral?: boolean | null, appointment_entry_method?: AppointmentEntryMethod | null, scheduling_min_minutes_away?: number | null, scheduling_max_minutes_away?: number | null, included_species?: Array<Species> | null, max_patients_per_visit?: number | null, should_complete_sync?: boolean | null, server_syncing_only?: boolean | null, confirmation_days_before?: number | null, send_confirmations_to: SendConfirmationsTo, send_new_appt_email?: boolean | null, send_reviews_to?: SendConfirmationsTo | null, max_review_rating_for_notif?: number | null, google_review_link?: string | null, facebook_review_link?: string | null, non_blocking_services: Array<string>, yesterday_revenue?: number | null, this_month_revenue?: number | null, hide_clinician_preference: boolean, does_use_rooms_to_schedule?: boolean | null, primary_room_pms_id?: string | null, should_default_pims_emails_on: boolean, should_default_pims_sms_on: boolean, should_default_marketing_sms_on: boolean, should_default_marketing_email_on: boolean, does_use_clinicians_to_schedule?: boolean | null, time_slot_minutes: number, sync_interval_minutes: number, long_sync_interval_hours: number, primary_clinician_pms_id?: string | null, cancellation_clinician_pms_id?: string | null, cancellation_service_pms_id?: string | null, allow_first_appt_per_day?: boolean | null, custom_well_description?: string | null, custom_sick_description?: string | null, custom_other_title?: string | null, custom_other_description?: string | null, default_trigger_words?: Array<string> | null, should_use_private_reviews?: boolean | null, notify_clinic_on?: Array<NotifyClinicOn> | null, reminder_send_time_minutes?: number | null, does_require_new_client_address?: boolean | null, does_require_new_client_birthday?: boolean | null, should_allow_new_clients?: boolean | null, should_allow_new_patients?: boolean | null, should_create_clients?: boolean | null, should_create_patients?: boolean | null, msgs_auto_priority?: boolean | null, booking_match_procedure?: BookingMatchProcedure | null, urgency_type?: UrgencyType | null, max_booking_columns?: number | null, hide_closed_days_from_scheduling?: boolean | null, should_sync_reminders?: boolean | null, auto_reply_enabled: boolean, auto_reply_message?: string | null, unreplied_message_alert_enabled: boolean, unreplied_message_alert_minutes: number, comms_writeback_enabled: boolean, comms_should_daily_writeback: boolean, comms_use_pdf_for_writeback: boolean, comms_writeback_buffer_minutes: number, comms_writeback_before_appt_mins: number, comms_should_writeback_on_send: boolean, comms_should_writeback_on_receive: boolean, comms_should_writeback_notifs: boolean, comms_should_use_ai_writeback: boolean, form_writeback_enabled: boolean, should_award_loyalty_for_invoices?: boolean | null, invoice_loyalty_points_per_dollar?: number | null, app_download_loyalty_points?: number | null, referrer_loyalty_points?: number | null, referred_loyalty_points?: number | null, custom_appointment_notes_template?: string | null, custom_new_client_notes_template?: string | null, custom_new_patient_notes_template?: string | null, max_inactivity_duration?: number | null, hide_portal_vaccinations: boolean, hide_portal_reminders: boolean, hide_portal_prescriptions: boolean, hide_portal_weight: boolean, hide_soc_vaccinations?: boolean | null, hide_historic_vaccinations?: boolean | null, should_hide_daily_huddle_financials: boolean, patient_details_tab_order: Array<PortalPatientDetailsTab>, clinic_hours_display?: string | null, reschedule_buffer_minutes?: number | null, cancellation_buffer_minutes?: number | null, require_reason_for_cancellation?: boolean | null, should_automatically_assign_patient?: boolean | null, payment_writeback_enabled: boolean, auto_refund_on_cancel: boolean, status_set_on_payment_completed_pms_id?: string | null, max_booking_notes_length?: number | null, min_booking_notes_length?: number | null, primary_clinic_group_id?: string | null, should_suggest_nearby_clinics?: boolean | null, sms_block_list?: Array<string> | null, exclude_message_wrapper?: boolean | null, should_charge_client_stripe_fees?: boolean | null, chckvet_prescription_fee_split_percentage?: number | null, gtm_container_id?: string | null, review_google_id?: string | null, review_facebook_id?: string | null, only_use_adj_avail_guides: boolean, use_basic_timeslots: boolean, valid_booking_interval_minutes?: Array<number> | null, should_disable_online_scheduling?: boolean | null, simple_scheduling_rules_enabled: boolean, compliance_statuses?: Array<string> | null, should_use_instant_prescription_requests?: boolean | null, prescription_pickup_service_id?: string | null, default_reminder_service_id?: string | null, ai_calls_provider?: PhoneProviderType | null, ai_calls_phone_number?: string | null, ai_calls_voice_id?: string | null, ai_calls_agent_id?: string | null, ai_agent_style?: string | null, ai_agent_custom_instructions?: string | null, ai_calls_ambient_sound?: AiCallsAmbientSound | null, ai_calls_voice_speed?: number | null, ai_calls_interruption_sensitivity?: number | null, ai_calls_enable_dynamic_voice_speed?: boolean | null, usage_spending_caps?: any | null, custom_merge_tags?: any | null, custom_booking_copy?: { __typename?: 'ClinicBookingCopy', WIDGET_HEADER_TITLE?: string | null, SHOW_CLINIC_HEADER_LOGO?: boolean | null, CLINIC_HEADER_LOGO_HEIGHT?: number | null, SERVICE_TYPE_SECTION_HEADING?: string | null, DEFAULT_WELLNESS_DESCRIPTION?: string | null, DEFAULT_SICK_DESCRIPTION?: string | null, DEFAULT_OTHER_DESCRIPTION?: string | null, RETURNING_PATIENT_QUESTION?: string | null, POSITIVE_RETURNING_PATIENT_ANSWER?: string | null, NEGATIVE_RETURNING_PATIENT_ANSWER?: string | null, RETURNING_CLIENT_QUESTION?: string | null, POSITIVE_RETURNING_CLIENT_ANSWER?: string | null, NEGATIVE_RETURNING_CLIENT_ANSWER?: string | null, CLIENT_INFORMATION_SECTION_TITLE?: string | null, PATIENT_INFORMATION_SECTION_TITLE?: string | null, RETURNING_CLIENT_PATIENT_TITLE?: string | null, RETURNING_CLIENT_PATIENT_DESCRIPTION?: string | null, SERVICE_SECTION_TITLE?: string | null, PREPAID_SERVICES_LABEL?: string | null, STANDARD_SERVICES_LABEL?: string | null, DEPOSIT_FEE_NAME?: string | null, PREVIOUS_OR_REFERRING_CLINIC_QUESTION?: string | null, CONTACT_THE_CLINIC_TEXT?: string | null, CONTACT_THE_CLINIC_TEXT_COLOR?: string | null, CONTACT_THE_CLINIC_TEXT_SIZE?: string | null, SELECT_CLINICIAN_TITLE?: string | null, SELECT_CLINICIAN_POSITIVE_ANSWER?: string | null, SELECT_CLINICIAN_NEGATIVE_ANSWER?: string | null, SELECT_TIME_TITLE?: string | null, REVIEW_TITLE?: string | null, REVIEW_NOTES_PROMPT?: string | null, PAYMENT_INFORMATION_TITLE?: string | null, TRIGGER_WORDS_DETECTED_HEADER?: string | null, TRIGGER_WORDS_DETECTED_DESCRIPTION?: string | null, CONFIRMATION_SCREEN_TITLE?: string | null, CONFIRMATION_SCREEN_DESCRIPTION?: string | null, NEW_CLIENT_BLOCKED_MESSAGE?: string | null, NEW_PATIENT_BLOCKED_MESSAGE?: string | null } | null, auto_reply_hours?: { __typename?: 'AvailabilityHours', monday?: Array<{ __typename?: 'TimeInterval', start?: number | null, end?: number | null }> | null, tuesday?: Array<{ __typename?: 'TimeInterval', start?: number | null, end?: number | null }> | null, wednesday?: Array<{ __typename?: 'TimeInterval', start?: number | null, end?: number | null }> | null, thursday?: Array<{ __typename?: 'TimeInterval', start?: number | null, end?: number | null }> | null, friday?: Array<{ __typename?: 'TimeInterval', start?: number | null, end?: number | null }> | null, saturday?: Array<{ __typename?: 'TimeInterval', start?: number | null, end?: number | null }> | null, sunday?: Array<{ __typename?: 'TimeInterval', start?: number | null, end?: number | null }> | null } | null, portal_links?: Array<{ __typename?: 'PortalLink', label: string, url: string }> | null, custom_reviews_copy?: { __typename?: 'ClinicReviewsCopy', REVIEW_METHOD_PAGE_TITLE?: string | null, REVIEW_METHOD_PAGE_DESCRIPTION?: string | null, PRIVATE_REVIEW_BUTTON_HELP_TEXT?: string | null, PRIVATE_REVIEW_BUTTON_TEXT?: string | null, REVIEW_PAGE_TITLE?: string | null, REVIEW_PAGE_SUBTITLE?: string | null, REVIEW_SCORE_LABEL?: string | null, REVIEW_MESSAGE_LABEL?: string | null, REVIEW_SUBMIT_BUTTON_TEXT?: string | null } | null, waitlist_customer_segment?: { __typename?: 'CustomerSegment', id: string, name: string, trigger_entity?: CustomerSegmentTrigger | null, is_archived: boolean, updated_at: number, notification_templates?: Array<{ __typename?: 'NotificationTemplate', id: string, name: string, is_active: boolean, is_archived: boolean, message_methods: Array<MessageMethod> }> | null, error_flags?: Array<{ __typename?: 'CustomerSegmentErrorFlag', filter_column: string, filter_index: number, parameter_index: number, message: string }> | null, all_inclusions?: Array<{ __typename?: 'SegmentFilter', foreign_table?: string | null, group?: string | null, parameters: Array<{ __typename?: 'QueryFilter', column: string, filterOp: FilterOp, value: { __typename?: 'QueryFilterValue', string?: string | null, float?: number | null, boolean?: boolean | null, stringArray?: Array<string> | null, floatArray?: Array<number> | null, millisFromNow?: number | null, relativeTime?: { __typename?: 'RelativeTime', quantity: number, unit: TimeUnit, direction: ReferenceDirection } | null } }> }> | null, any_inclusions?: Array<{ __typename?: 'SegmentFilter', foreign_table?: string | null, group?: string | null, parameters: Array<{ __typename?: 'QueryFilter', column: string, filterOp: FilterOp, value: { __typename?: 'QueryFilterValue', string?: string | null, float?: number | null, boolean?: boolean | null, stringArray?: Array<string> | null, floatArray?: Array<number> | null, millisFromNow?: number | null, relativeTime?: { __typename?: 'RelativeTime', quantity: number, unit: TimeUnit, direction: ReferenceDirection } | null } }> }> | null, any_exclusions?: Array<{ __typename?: 'SegmentFilter', foreign_table?: string | null, group?: string | null, parameters: Array<{ __typename?: 'QueryFilter', column: string, filterOp: FilterOp, value: { __typename?: 'QueryFilterValue', string?: string | null, float?: number | null, boolean?: boolean | null, stringArray?: Array<string> | null, floatArray?: Array<number> | null, millisFromNow?: number | null, relativeTime?: { __typename?: 'RelativeTime', quantity: number, unit: TimeUnit, direction: ReferenceDirection } | null } }> }> | null, any_other_exclusions?: Array<{ __typename?: 'SegmentFilter', foreign_table?: string | null, group?: string | null, parameters: Array<{ __typename?: 'QueryFilter', column: string, filterOp: FilterOp, value: { __typename?: 'QueryFilterValue', string?: string | null, float?: number | null, boolean?: boolean | null, stringArray?: Array<string> | null, floatArray?: Array<number> | null, millisFromNow?: number | null, relativeTime?: { __typename?: 'RelativeTime', quantity: number, unit: TimeUnit, direction: ReferenceDirection } | null } }> }> | null, filters?: Array<{ __typename?: 'CustomerSegmentFilter', filters: Array<{ __typename?: 'QueryFilter', column: string, filterOp: FilterOp, value: { __typename?: 'QueryFilterValue', string?: string | null, float?: number | null, boolean?: boolean | null, stringArray?: Array<string> | null, floatArray?: Array<number> | null, millisFromNow?: number | null, relativeTime?: { __typename?: 'RelativeTime', quantity: number, unit: TimeUnit, direction: ReferenceDirection } | null } }> }> | null, excluded_filters: Array<{ __typename?: 'CustomerSegmentFilter', filters: Array<{ __typename?: 'QueryFilter', column: string, filterOp: FilterOp, value: { __typename?: 'QueryFilterValue', string?: string | null, float?: number | null, boolean?: boolean | null, stringArray?: Array<string> | null, floatArray?: Array<number> | null, millisFromNow?: number | null, relativeTime?: { __typename?: 'RelativeTime', quantity: number, unit: TimeUnit, direction: ReferenceDirection } | null } }> }> } | null, blocklist_customer_segment?: { __typename?: 'CustomerSegment', id: string, name: string, trigger_entity?: CustomerSegmentTrigger | null, is_archived: boolean, updated_at: number, notification_templates?: Array<{ __typename?: 'NotificationTemplate', id: string, name: string, is_active: boolean, is_archived: boolean, message_methods: Array<MessageMethod> }> | null, error_flags?: Array<{ __typename?: 'CustomerSegmentErrorFlag', filter_column: string, filter_index: number, parameter_index: number, message: string }> | null, all_inclusions?: Array<{ __typename?: 'SegmentFilter', foreign_table?: string | null, group?: string | null, parameters: Array<{ __typename?: 'QueryFilter', column: string, filterOp: FilterOp, value: { __typename?: 'QueryFilterValue', string?: string | null, float?: number | null, boolean?: boolean | null, stringArray?: Array<string> | null, floatArray?: Array<number> | null, millisFromNow?: number | null, relativeTime?: { __typename?: 'RelativeTime', quantity: number, unit: TimeUnit, direction: ReferenceDirection } | null } }> }> | null, any_inclusions?: Array<{ __typename?: 'SegmentFilter', foreign_table?: string | null, group?: string | null, parameters: Array<{ __typename?: 'QueryFilter', column: string, filterOp: FilterOp, value: { __typename?: 'QueryFilterValue', string?: string | null, float?: number | null, boolean?: boolean | null, stringArray?: Array<string> | null, floatArray?: Array<number> | null, millisFromNow?: number | null, relativeTime?: { __typename?: 'RelativeTime', quantity: number, unit: TimeUnit, direction: ReferenceDirection } | null } }> }> | null, any_exclusions?: Array<{ __typename?: 'SegmentFilter', foreign_table?: string | null, group?: string | null, parameters: Array<{ __typename?: 'QueryFilter', column: string, filterOp: FilterOp, value: { __typename?: 'QueryFilterValue', string?: string | null, float?: number | null, boolean?: boolean | null, stringArray?: Array<string> | null, floatArray?: Array<number> | null, millisFromNow?: number | null, relativeTime?: { __typename?: 'RelativeTime', quantity: number, unit: TimeUnit, direction: ReferenceDirection } | null } }> }> | null, any_other_exclusions?: Array<{ __typename?: 'SegmentFilter', foreign_table?: string | null, group?: string | null, parameters: Array<{ __typename?: 'QueryFilter', column: string, filterOp: FilterOp, value: { __typename?: 'QueryFilterValue', string?: string | null, float?: number | null, boolean?: boolean | null, stringArray?: Array<string> | null, floatArray?: Array<number> | null, millisFromNow?: number | null, relativeTime?: { __typename?: 'RelativeTime', quantity: number, unit: TimeUnit, direction: ReferenceDirection } | null } }> }> | null, filters?: Array<{ __typename?: 'CustomerSegmentFilter', filters: Array<{ __typename?: 'QueryFilter', column: string, filterOp: FilterOp, value: { __typename?: 'QueryFilterValue', string?: string | null, float?: number | null, boolean?: boolean | null, stringArray?: Array<string> | null, floatArray?: Array<number> | null, millisFromNow?: number | null, relativeTime?: { __typename?: 'RelativeTime', quantity: number, unit: TimeUnit, direction: ReferenceDirection } | null } }> }> | null, excluded_filters: Array<{ __typename?: 'CustomerSegmentFilter', filters: Array<{ __typename?: 'QueryFilter', column: string, filterOp: FilterOp, value: { __typename?: 'QueryFilterValue', string?: string | null, float?: number | null, boolean?: boolean | null, stringArray?: Array<string> | null, floatArray?: Array<number> | null, millisFromNow?: number | null, relativeTime?: { __typename?: 'RelativeTime', quantity: number, unit: TimeUnit, direction: ReferenceDirection } | null } }> }> } | null, referral_customer_segment?: { __typename?: 'CustomerSegment', id: string, name: string, trigger_entity?: CustomerSegmentTrigger | null, is_archived: boolean, updated_at: number, notification_templates?: Array<{ __typename?: 'NotificationTemplate', id: string, name: string, is_active: boolean, is_archived: boolean, message_methods: Array<MessageMethod> }> | null, error_flags?: Array<{ __typename?: 'CustomerSegmentErrorFlag', filter_column: string, filter_index: number, parameter_index: number, message: string }> | null, all_inclusions?: Array<{ __typename?: 'SegmentFilter', foreign_table?: string | null, group?: string | null, parameters: Array<{ __typename?: 'QueryFilter', column: string, filterOp: FilterOp, value: { __typename?: 'QueryFilterValue', string?: string | null, float?: number | null, boolean?: boolean | null, stringArray?: Array<string> | null, floatArray?: Array<number> | null, millisFromNow?: number | null, relativeTime?: { __typename?: 'RelativeTime', quantity: number, unit: TimeUnit, direction: ReferenceDirection } | null } }> }> | null, any_inclusions?: Array<{ __typename?: 'SegmentFilter', foreign_table?: string | null, group?: string | null, parameters: Array<{ __typename?: 'QueryFilter', column: string, filterOp: FilterOp, value: { __typename?: 'QueryFilterValue', string?: string | null, float?: number | null, boolean?: boolean | null, stringArray?: Array<string> | null, floatArray?: Array<number> | null, millisFromNow?: number | null, relativeTime?: { __typename?: 'RelativeTime', quantity: number, unit: TimeUnit, direction: ReferenceDirection } | null } }> }> | null, any_exclusions?: Array<{ __typename?: 'SegmentFilter', foreign_table?: string | null, group?: string | null, parameters: Array<{ __typename?: 'QueryFilter', column: string, filterOp: FilterOp, value: { __typename?: 'QueryFilterValue', string?: string | null, float?: number | null, boolean?: boolean | null, stringArray?: Array<string> | null, floatArray?: Array<number> | null, millisFromNow?: number | null, relativeTime?: { __typename?: 'RelativeTime', quantity: number, unit: TimeUnit, direction: ReferenceDirection } | null } }> }> | null, any_other_exclusions?: Array<{ __typename?: 'SegmentFilter', foreign_table?: string | null, group?: string | null, parameters: Array<{ __typename?: 'QueryFilter', column: string, filterOp: FilterOp, value: { __typename?: 'QueryFilterValue', string?: string | null, float?: number | null, boolean?: boolean | null, stringArray?: Array<string> | null, floatArray?: Array<number> | null, millisFromNow?: number | null, relativeTime?: { __typename?: 'RelativeTime', quantity: number, unit: TimeUnit, direction: ReferenceDirection } | null } }> }> | null, filters?: Array<{ __typename?: 'CustomerSegmentFilter', filters: Array<{ __typename?: 'QueryFilter', column: string, filterOp: FilterOp, value: { __typename?: 'QueryFilterValue', string?: string | null, float?: number | null, boolean?: boolean | null, stringArray?: Array<string> | null, floatArray?: Array<number> | null, millisFromNow?: number | null, relativeTime?: { __typename?: 'RelativeTime', quantity: number, unit: TimeUnit, direction: ReferenceDirection } | null } }> }> | null, excluded_filters: Array<{ __typename?: 'CustomerSegmentFilter', filters: Array<{ __typename?: 'QueryFilter', column: string, filterOp: FilterOp, value: { __typename?: 'QueryFilterValue', string?: string | null, float?: number | null, boolean?: boolean | null, stringArray?: Array<string> | null, floatArray?: Array<number> | null, millisFromNow?: number | null, relativeTime?: { __typename?: 'RelativeTime', quantity: number, unit: TimeUnit, direction: ReferenceDirection } | null } }> }> } | null, webhooks?: Array<{ __typename?: 'WebhookConfig', id: string, name: string, url: string, events: Array<WebhookEventType>, secret?: string | null, enabled: boolean }> | null, times_first_filter_config?: { __typename?: 'TimesFirstFilterConfig', service?: BookingFilterDisplayMode | null, clinician?: BookingFilterDisplayMode | null, species?: BookingFilterDisplayMode | null, client_status?: BookingFilterDisplayMode | null, patient_status?: BookingFilterDisplayMode | null, patient_gender?: BookingFilterDisplayMode | null, fixed_status?: BookingFilterDisplayMode | null } | null } };

export type CreateClinicGroupClinicMutationVariables = Exact<{
  data: CreateClinicGroupClinicInput;
}>;


export type CreateClinicGroupClinicMutation = { __typename?: 'Mutation', createClinicGroupClinic: { __typename?: 'ClinicGroupClinic', id: string } };

export type DeleteClinicGroupClinicMutationVariables = Exact<{
  clinicGroupClinicId: Scalars['ID']['input'];
}>;


export type DeleteClinicGroupClinicMutation = { __typename?: 'Mutation', deleteClinicGroupClinic?: any | null };

export type CreateClinicGroupUserMutationVariables = Exact<{
  data: CreateClinicGroupUserInput;
}>;


export type CreateClinicGroupUserMutation = { __typename?: 'Mutation', createClinicGroupUser: { __typename?: 'ClinicGroupUser', id: string } };

export type UpdateClinicGroupUserMutationVariables = Exact<{
  clinicGroupUserId: Scalars['ID']['input'];
  data: UpdateClinicGroupUserInput;
}>;


export type UpdateClinicGroupUserMutation = { __typename?: 'Mutation', updateClinicGroupUser: { __typename?: 'ClinicGroupUser', id: string } };

export type DeleteClinicGroupUserMutationVariables = Exact<{
  clinicGroupUserId: Scalars['ID']['input'];
}>;


export type DeleteClinicGroupUserMutation = { __typename?: 'Mutation', deleteClinicGroupUser?: any | null };

export type ClinicSexFieldsFragment = { __typename?: 'ClinicSex', id: string, pms_id: string, name: string, description?: string | null, animal_gender?: AnimalGender | null, fixed_statuses: Array<FixedStatus>, included_species: Array<Species>, is_active: boolean };

export type QueryClinicSexesQueryVariables = Exact<{
  where?: InputMaybe<Array<QueryInput> | QueryInput>;
  page?: InputMaybe<Scalars['NonNegativeInt']['input']>;
  pageSize?: InputMaybe<Scalars['NonNegativeInt']['input']>;
  orderBy?: InputMaybe<OrderByInput>;
}>;


export type QueryClinicSexesQuery = { __typename?: 'Query', queryClinicSexes: Array<{ __typename?: 'ClinicSex', id: string, pms_id: string, name: string, description?: string | null, animal_gender?: AnimalGender | null, fixed_statuses: Array<FixedStatus>, included_species: Array<Species>, is_active: boolean }> };

export type CountClinicSexesQueryVariables = Exact<{
  where?: InputMaybe<Array<QueryInput> | QueryInput>;
}>;


export type CountClinicSexesQuery = { __typename?: 'Query', countClinicSexes: number };

export type UpdateClinicSexMutationVariables = Exact<{
  id: Scalars['ID']['input'];
  data: UpdateClinicSexInput;
}>;


export type UpdateClinicSexMutation = { __typename?: 'Mutation', updateClinicSex: { __typename?: 'ClinicSex', id: string, pms_id: string, name: string, description?: string | null, animal_gender?: AnimalGender | null, fixed_statuses: Array<FixedStatus>, included_species: Array<Species>, is_active: boolean } };

export type ClinicSpeciesFieldsFragment = { __typename?: 'ClinicSpecies', id: string, pms_id: string, description: string, is_primary: boolean, species: Species, weight_key: string, created_at: number, updated_at: number };

export type GetClinicSpeciesByClinicQueryVariables = Exact<{
  clinicId: Scalars['ID']['input'];
}>;


export type GetClinicSpeciesByClinicQuery = { __typename?: 'Query', getClinicSpeciesByClinic: Array<{ __typename?: 'ClinicSpecies', id: string, pms_id: string, description: string, is_primary: boolean, species: Species, weight_key: string, created_at: number, updated_at: number }> };

export type QueryClinicSpeciesQueryVariables = Exact<{
  where?: InputMaybe<Array<QueryInput> | QueryInput>;
  page?: InputMaybe<Scalars['NonNegativeInt']['input']>;
  pageSize?: InputMaybe<Scalars['NonNegativeInt']['input']>;
  orderBy?: InputMaybe<OrderByInput>;
}>;


export type QueryClinicSpeciesQuery = { __typename?: 'Query', queryClinicSpecies: Array<{ __typename?: 'ClinicSpecies', id: string, pms_id: string, description: string, is_primary: boolean, species: Species, weight_key: string, created_at: number, updated_at: number }> };

export type MakePrimaryClinicSpeciesMutationVariables = Exact<{
  clinicId: Scalars['ID']['input'];
  speciesId: Scalars['ID']['input'];
}>;


export type MakePrimaryClinicSpeciesMutation = { __typename?: 'Mutation', makePrimaryClinicSpecies: { __typename?: 'ClinicSpecies', id: string, pms_id: string, description: string, is_primary: boolean, species: Species, weight_key: string, created_at: number, updated_at: number } };

export type UpdateClinicSpeciesMutationVariables = Exact<{
  clinicId: Scalars['ID']['input'];
  speciesId: Scalars['ID']['input'];
  data: UpdateClinicSpeciesInput;
}>;


export type UpdateClinicSpeciesMutation = { __typename?: 'Mutation', updateClinicSpecies: { __typename?: 'ClinicSpecies', id: string, pms_id: string, description: string, is_primary: boolean, species: Species, weight_key: string, created_at: number, updated_at: number } };

export type GetRevenueForTimeRangeQueryVariables = Exact<{
  clinicId: Scalars['ID']['input'];
  start_time: Scalars['NonNegativeInt']['input'];
  end_time: Scalars['NonNegativeInt']['input'];
}>;


export type GetRevenueForTimeRangeQuery = { __typename?: 'Query', getRevenueForTimeRange: number };

export type GetRevenuesByTypeForTimeRangeQueryVariables = Exact<{
  clinicId: Scalars['ID']['input'];
  start_time: Scalars['NonNegativeInt']['input'];
  end_time: Scalars['NonNegativeInt']['input'];
}>;


export type GetRevenuesByTypeForTimeRangeQuery = { __typename?: 'Query', getRevenuesByTypeForTimeRange: Array<{ __typename?: 'RevenueGroup', group: string, amount: number }> };

export type GetRevenuesByClinicianForTimeRangeQueryVariables = Exact<{
  clinicId: Scalars['ID']['input'];
  start_time: Scalars['NonNegativeInt']['input'];
  end_time: Scalars['NonNegativeInt']['input'];
}>;


export type GetRevenuesByClinicianForTimeRangeQuery = { __typename?: 'Query', getRevenuesByClinicianForTimeRange: Array<{ __typename?: 'RevenueGroup', group: string, amount: number }> };

export type GetAccountsReceivableQueryVariables = Exact<{
  clinicId: Scalars['ID']['input'];
}>;


export type GetAccountsReceivableQuery = { __typename?: 'Query', getAccountsReceivable: number };

export type ClinicianServiceFieldsFragment = { __typename?: 'ClinicianService', id: string, duration_override?: number | null, created_at: number, updated_at: number, clinician: { __typename?: 'Clinician', id: string, name: string }, service: { __typename?: 'Service', id: string } };

export type GetClinicianServicesByServiceQueryVariables = Exact<{
  serviceId: Scalars['ID']['input'];
}>;


export type GetClinicianServicesByServiceQuery = { __typename?: 'Query', getClinicianServicesByService: Array<{ __typename?: 'ClinicianService', id: string, duration_override?: number | null, created_at: number, updated_at: number, clinician: { __typename?: 'Clinician', id: string, name: string }, service: { __typename?: 'Service', id: string } }> };

export type CreateClinicianServiceMutationVariables = Exact<{
  data: CreateClinicianServiceInput;
}>;


export type CreateClinicianServiceMutation = { __typename?: 'Mutation', createClinicianService: { __typename?: 'ClinicianService', id: string, duration_override?: number | null, created_at: number, updated_at: number, clinician: { __typename?: 'Clinician', id: string, name: string }, service: { __typename?: 'Service', id: string } } };

export type UpdateClinicianServiceMutationVariables = Exact<{
  id: Scalars['ID']['input'];
  data: UpdateClinicianServiceInput;
}>;


export type UpdateClinicianServiceMutation = { __typename?: 'Mutation', updateClinicianService: { __typename?: 'ClinicianService', id: string, duration_override?: number | null, created_at: number, updated_at: number, clinician: { __typename?: 'Clinician', id: string, name: string }, service: { __typename?: 'Service', id: string } } };

export type DeleteClinicianServiceMutationVariables = Exact<{
  id: Scalars['ID']['input'];
}>;


export type DeleteClinicianServiceMutation = { __typename?: 'Mutation', deleteClinicianService?: any | null };

export type AvailabilityDayFieldsFragment = { __typename?: 'AvailabilityHours', monday?: Array<{ __typename?: 'TimeInterval', start?: number | null, end?: number | null }> | null, tuesday?: Array<{ __typename?: 'TimeInterval', start?: number | null, end?: number | null }> | null, wednesday?: Array<{ __typename?: 'TimeInterval', start?: number | null, end?: number | null }> | null, thursday?: Array<{ __typename?: 'TimeInterval', start?: number | null, end?: number | null }> | null, friday?: Array<{ __typename?: 'TimeInterval', start?: number | null, end?: number | null }> | null, saturday?: Array<{ __typename?: 'TimeInterval', start?: number | null, end?: number | null }> | null, sunday?: Array<{ __typename?: 'TimeInterval', start?: number | null, end?: number | null }> | null };

export type AdjustedAvailabilityFieldsFragment = { __typename?: 'Availability', date: number, pms_appt_type_pms_id?: string | null, times: Array<{ __typename?: 'TimeInterval', start?: number | null, end?: number | null }>, repeat?: { __typename?: 'RepeatAvailability', daysOfMonth?: Array<number> | null, daysOfWeek?: Array<DayOfWeek> | null, weekOfMonth?: WeekOfMonth | null, frequency: any, unit: RepeatUnit, end_date?: number | null } | null };

export type ClinicianFieldsFragment = { __typename?: 'Clinician', id: string, name: string, display_name?: string | null, bio?: string | null, avatar_url?: string | null, initials?: string | null, excluded_species?: Array<Species> | null, excluded_service_ids?: Array<string> | null, authority_level?: AuthorityLevel | null, type: ResourceType, is_active?: boolean | null, is_assignable_in_pms?: boolean | null, does_contribute_to_fill_rate?: boolean | null, pms_id?: string | null, location?: string | null, pms_is_active: boolean, valid_booking_interval_minutes?: Array<number> | null, created_at: number, updated_at: number, clinic?: { __typename?: 'Clinic', id: string, name?: string | null } | null, pms_db?: { __typename?: 'PmsDb', id: string } | null, hours?: { __typename?: 'AvailabilityHours', monday?: Array<{ __typename?: 'TimeInterval', start?: number | null, end?: number | null }> | null, tuesday?: Array<{ __typename?: 'TimeInterval', start?: number | null, end?: number | null }> | null, wednesday?: Array<{ __typename?: 'TimeInterval', start?: number | null, end?: number | null }> | null, thursday?: Array<{ __typename?: 'TimeInterval', start?: number | null, end?: number | null }> | null, friday?: Array<{ __typename?: 'TimeInterval', start?: number | null, end?: number | null }> | null, saturday?: Array<{ __typename?: 'TimeInterval', start?: number | null, end?: number | null }> | null, sunday?: Array<{ __typename?: 'TimeInterval', start?: number | null, end?: number | null }> | null } | null, adjusted_availability?: Array<{ __typename?: 'Availability', date: number, pms_appt_type_pms_id?: string | null, times: Array<{ __typename?: 'TimeInterval', start?: number | null, end?: number | null }>, repeat?: { __typename?: 'RepeatAvailability', daysOfMonth?: Array<number> | null, daysOfWeek?: Array<DayOfWeek> | null, weekOfMonth?: WeekOfMonth | null, frequency: any, unit: RepeatUnit, end_date?: number | null } | null }> | null, pms_adjusted_availability?: Array<{ __typename?: 'Availability', date: number, pms_appt_type_pms_id?: string | null, times: Array<{ __typename?: 'TimeInterval', start?: number | null, end?: number | null }>, repeat?: { __typename?: 'RepeatAvailability', daysOfMonth?: Array<number> | null, daysOfWeek?: Array<DayOfWeek> | null, weekOfMonth?: WeekOfMonth | null, frequency: any, unit: RepeatUnit, end_date?: number | null } | null }> | null };

export type ClinicianPreviewFieldsFragment = { __typename?: 'Clinician', id: string, display_name?: string | null, name: string, initials?: string | null, avatar_url?: string | null };

export type OnDemandClinicianFieldsFragment = { __typename?: 'OnDemandClinician', pms_id?: string | null, display_name?: string | null, first_name?: string | null, last_name?: string | null };

export type GetClinicianQueryVariables = Exact<{
  id: Scalars['ID']['input'];
}>;


export type GetClinicianQuery = { __typename?: 'Query', clinician: { __typename?: 'Clinician', id: string, name: string, display_name?: string | null, bio?: string | null, avatar_url?: string | null, initials?: string | null, excluded_species?: Array<Species> | null, excluded_service_ids?: Array<string> | null, authority_level?: AuthorityLevel | null, type: ResourceType, is_active?: boolean | null, is_assignable_in_pms?: boolean | null, does_contribute_to_fill_rate?: boolean | null, pms_id?: string | null, location?: string | null, pms_is_active: boolean, valid_booking_interval_minutes?: Array<number> | null, created_at: number, updated_at: number, clinic?: { __typename?: 'Clinic', id: string, name?: string | null } | null, pms_db?: { __typename?: 'PmsDb', id: string } | null, hours?: { __typename?: 'AvailabilityHours', monday?: Array<{ __typename?: 'TimeInterval', start?: number | null, end?: number | null }> | null, tuesday?: Array<{ __typename?: 'TimeInterval', start?: number | null, end?: number | null }> | null, wednesday?: Array<{ __typename?: 'TimeInterval', start?: number | null, end?: number | null }> | null, thursday?: Array<{ __typename?: 'TimeInterval', start?: number | null, end?: number | null }> | null, friday?: Array<{ __typename?: 'TimeInterval', start?: number | null, end?: number | null }> | null, saturday?: Array<{ __typename?: 'TimeInterval', start?: number | null, end?: number | null }> | null, sunday?: Array<{ __typename?: 'TimeInterval', start?: number | null, end?: number | null }> | null } | null, adjusted_availability?: Array<{ __typename?: 'Availability', date: number, pms_appt_type_pms_id?: string | null, times: Array<{ __typename?: 'TimeInterval', start?: number | null, end?: number | null }>, repeat?: { __typename?: 'RepeatAvailability', daysOfMonth?: Array<number> | null, daysOfWeek?: Array<DayOfWeek> | null, weekOfMonth?: WeekOfMonth | null, frequency: any, unit: RepeatUnit, end_date?: number | null } | null }> | null, pms_adjusted_availability?: Array<{ __typename?: 'Availability', date: number, pms_appt_type_pms_id?: string | null, times: Array<{ __typename?: 'TimeInterval', start?: number | null, end?: number | null }>, repeat?: { __typename?: 'RepeatAvailability', daysOfMonth?: Array<number> | null, daysOfWeek?: Array<DayOfWeek> | null, weekOfMonth?: WeekOfMonth | null, frequency: any, unit: RepeatUnit, end_date?: number | null } | null }> | null } };

export type GetCliniciansByClinicQueryVariables = Exact<{
  clinicId: Scalars['ID']['input'];
  onlyAvailable?: InputMaybe<Scalars['Boolean']['input']>;
}>;


export type GetCliniciansByClinicQuery = { __typename?: 'Query', getCliniciansByClinic: Array<{ __typename?: 'Clinician', id: string, name: string, display_name?: string | null, bio?: string | null, avatar_url?: string | null, initials?: string | null, excluded_species?: Array<Species> | null, excluded_service_ids?: Array<string> | null, authority_level?: AuthorityLevel | null, type: ResourceType, is_active?: boolean | null, is_assignable_in_pms?: boolean | null, does_contribute_to_fill_rate?: boolean | null, pms_id?: string | null, location?: string | null, pms_is_active: boolean, valid_booking_interval_minutes?: Array<number> | null, created_at: number, updated_at: number, clinic?: { __typename?: 'Clinic', id: string, name?: string | null } | null, pms_db?: { __typename?: 'PmsDb', id: string } | null, hours?: { __typename?: 'AvailabilityHours', monday?: Array<{ __typename?: 'TimeInterval', start?: number | null, end?: number | null }> | null, tuesday?: Array<{ __typename?: 'TimeInterval', start?: number | null, end?: number | null }> | null, wednesday?: Array<{ __typename?: 'TimeInterval', start?: number | null, end?: number | null }> | null, thursday?: Array<{ __typename?: 'TimeInterval', start?: number | null, end?: number | null }> | null, friday?: Array<{ __typename?: 'TimeInterval', start?: number | null, end?: number | null }> | null, saturday?: Array<{ __typename?: 'TimeInterval', start?: number | null, end?: number | null }> | null, sunday?: Array<{ __typename?: 'TimeInterval', start?: number | null, end?: number | null }> | null } | null, adjusted_availability?: Array<{ __typename?: 'Availability', date: number, pms_appt_type_pms_id?: string | null, times: Array<{ __typename?: 'TimeInterval', start?: number | null, end?: number | null }>, repeat?: { __typename?: 'RepeatAvailability', daysOfMonth?: Array<number> | null, daysOfWeek?: Array<DayOfWeek> | null, weekOfMonth?: WeekOfMonth | null, frequency: any, unit: RepeatUnit, end_date?: number | null } | null }> | null, pms_adjusted_availability?: Array<{ __typename?: 'Availability', date: number, pms_appt_type_pms_id?: string | null, times: Array<{ __typename?: 'TimeInterval', start?: number | null, end?: number | null }>, repeat?: { __typename?: 'RepeatAvailability', daysOfMonth?: Array<number> | null, daysOfWeek?: Array<DayOfWeek> | null, weekOfMonth?: WeekOfMonth | null, frequency: any, unit: RepeatUnit, end_date?: number | null } | null }> | null }> };

export type QueryCliniciansQueryVariables = Exact<{
  where?: InputMaybe<Array<QueryInput> | QueryInput>;
  page?: InputMaybe<Scalars['NonNegativeInt']['input']>;
  pageSize?: InputMaybe<Scalars['NonNegativeInt']['input']>;
  orderBy?: InputMaybe<OrderByInput>;
}>;


export type QueryCliniciansQuery = { __typename?: 'Query', queryClinicians: Array<{ __typename?: 'Clinician', id: string, name: string, display_name?: string | null, bio?: string | null, avatar_url?: string | null, initials?: string | null, excluded_species?: Array<Species> | null, excluded_service_ids?: Array<string> | null, authority_level?: AuthorityLevel | null, type: ResourceType, is_active?: boolean | null, is_assignable_in_pms?: boolean | null, does_contribute_to_fill_rate?: boolean | null, pms_id?: string | null, location?: string | null, pms_is_active: boolean, valid_booking_interval_minutes?: Array<number> | null, created_at: number, updated_at: number, clinic?: { __typename?: 'Clinic', id: string, name?: string | null } | null, pms_db?: { __typename?: 'PmsDb', id: string } | null, hours?: { __typename?: 'AvailabilityHours', monday?: Array<{ __typename?: 'TimeInterval', start?: number | null, end?: number | null }> | null, tuesday?: Array<{ __typename?: 'TimeInterval', start?: number | null, end?: number | null }> | null, wednesday?: Array<{ __typename?: 'TimeInterval', start?: number | null, end?: number | null }> | null, thursday?: Array<{ __typename?: 'TimeInterval', start?: number | null, end?: number | null }> | null, friday?: Array<{ __typename?: 'TimeInterval', start?: number | null, end?: number | null }> | null, saturday?: Array<{ __typename?: 'TimeInterval', start?: number | null, end?: number | null }> | null, sunday?: Array<{ __typename?: 'TimeInterval', start?: number | null, end?: number | null }> | null } | null, adjusted_availability?: Array<{ __typename?: 'Availability', date: number, pms_appt_type_pms_id?: string | null, times: Array<{ __typename?: 'TimeInterval', start?: number | null, end?: number | null }>, repeat?: { __typename?: 'RepeatAvailability', daysOfMonth?: Array<number> | null, daysOfWeek?: Array<DayOfWeek> | null, weekOfMonth?: WeekOfMonth | null, frequency: any, unit: RepeatUnit, end_date?: number | null } | null }> | null, pms_adjusted_availability?: Array<{ __typename?: 'Availability', date: number, pms_appt_type_pms_id?: string | null, times: Array<{ __typename?: 'TimeInterval', start?: number | null, end?: number | null }>, repeat?: { __typename?: 'RepeatAvailability', daysOfMonth?: Array<number> | null, daysOfWeek?: Array<DayOfWeek> | null, weekOfMonth?: WeekOfMonth | null, frequency: any, unit: RepeatUnit, end_date?: number | null } | null }> | null }> };

export type QueryPreviewCliniciansQueryVariables = Exact<{
  where?: InputMaybe<Array<QueryInput> | QueryInput>;
  page?: InputMaybe<Scalars['NonNegativeInt']['input']>;
  pageSize?: InputMaybe<Scalars['NonNegativeInt']['input']>;
  orderBy?: InputMaybe<OrderByInput>;
}>;


export type QueryPreviewCliniciansQuery = { __typename?: 'Query', queryClinicians: Array<{ __typename?: 'Clinician', id: string, display_name?: string | null, name: string, initials?: string | null, avatar_url?: string | null }> };

export type CountCliniciansQueryVariables = Exact<{
  where?: InputMaybe<Array<QueryInput> | QueryInput>;
}>;


export type CountCliniciansQuery = { __typename?: 'Query', countClinicians: number };

export type GetOnDemandCliniciansForClinicQueryVariables = Exact<{
  clinicId: Scalars['ID']['input'];
}>;


export type GetOnDemandCliniciansForClinicQuery = { __typename?: 'Query', getOnDemandCliniciansForClinic: Array<{ __typename?: 'OnDemandClinician', pms_id?: string | null, display_name?: string | null, first_name?: string | null, last_name?: string | null }> };

export type CreateClinicianMutationVariables = Exact<{
  data: CreateClinicianInput;
}>;


export type CreateClinicianMutation = { __typename?: 'Mutation', createClinician: { __typename?: 'Clinician', id: string, name: string, display_name?: string | null, bio?: string | null, avatar_url?: string | null, initials?: string | null, excluded_species?: Array<Species> | null, excluded_service_ids?: Array<string> | null, authority_level?: AuthorityLevel | null, type: ResourceType, is_active?: boolean | null, is_assignable_in_pms?: boolean | null, does_contribute_to_fill_rate?: boolean | null, pms_id?: string | null, location?: string | null, pms_is_active: boolean, valid_booking_interval_minutes?: Array<number> | null, created_at: number, updated_at: number, clinic?: { __typename?: 'Clinic', id: string, name?: string | null } | null, pms_db?: { __typename?: 'PmsDb', id: string } | null, hours?: { __typename?: 'AvailabilityHours', monday?: Array<{ __typename?: 'TimeInterval', start?: number | null, end?: number | null }> | null, tuesday?: Array<{ __typename?: 'TimeInterval', start?: number | null, end?: number | null }> | null, wednesday?: Array<{ __typename?: 'TimeInterval', start?: number | null, end?: number | null }> | null, thursday?: Array<{ __typename?: 'TimeInterval', start?: number | null, end?: number | null }> | null, friday?: Array<{ __typename?: 'TimeInterval', start?: number | null, end?: number | null }> | null, saturday?: Array<{ __typename?: 'TimeInterval', start?: number | null, end?: number | null }> | null, sunday?: Array<{ __typename?: 'TimeInterval', start?: number | null, end?: number | null }> | null } | null, adjusted_availability?: Array<{ __typename?: 'Availability', date: number, pms_appt_type_pms_id?: string | null, times: Array<{ __typename?: 'TimeInterval', start?: number | null, end?: number | null }>, repeat?: { __typename?: 'RepeatAvailability', daysOfMonth?: Array<number> | null, daysOfWeek?: Array<DayOfWeek> | null, weekOfMonth?: WeekOfMonth | null, frequency: any, unit: RepeatUnit, end_date?: number | null } | null }> | null, pms_adjusted_availability?: Array<{ __typename?: 'Availability', date: number, pms_appt_type_pms_id?: string | null, times: Array<{ __typename?: 'TimeInterval', start?: number | null, end?: number | null }>, repeat?: { __typename?: 'RepeatAvailability', daysOfMonth?: Array<number> | null, daysOfWeek?: Array<DayOfWeek> | null, weekOfMonth?: WeekOfMonth | null, frequency: any, unit: RepeatUnit, end_date?: number | null } | null }> | null } };

export type UpdateClinicianMutationVariables = Exact<{
  id: Scalars['ID']['input'];
  data: UpdateClinicianInput;
}>;


export type UpdateClinicianMutation = { __typename?: 'Mutation', updateClinician: { __typename?: 'Clinician', id: string, name: string, display_name?: string | null, bio?: string | null, avatar_url?: string | null, initials?: string | null, excluded_species?: Array<Species> | null, excluded_service_ids?: Array<string> | null, authority_level?: AuthorityLevel | null, type: ResourceType, is_active?: boolean | null, is_assignable_in_pms?: boolean | null, does_contribute_to_fill_rate?: boolean | null, pms_id?: string | null, location?: string | null, pms_is_active: boolean, valid_booking_interval_minutes?: Array<number> | null, created_at: number, updated_at: number, clinic?: { __typename?: 'Clinic', id: string, name?: string | null } | null, pms_db?: { __typename?: 'PmsDb', id: string } | null, hours?: { __typename?: 'AvailabilityHours', monday?: Array<{ __typename?: 'TimeInterval', start?: number | null, end?: number | null }> | null, tuesday?: Array<{ __typename?: 'TimeInterval', start?: number | null, end?: number | null }> | null, wednesday?: Array<{ __typename?: 'TimeInterval', start?: number | null, end?: number | null }> | null, thursday?: Array<{ __typename?: 'TimeInterval', start?: number | null, end?: number | null }> | null, friday?: Array<{ __typename?: 'TimeInterval', start?: number | null, end?: number | null }> | null, saturday?: Array<{ __typename?: 'TimeInterval', start?: number | null, end?: number | null }> | null, sunday?: Array<{ __typename?: 'TimeInterval', start?: number | null, end?: number | null }> | null } | null, adjusted_availability?: Array<{ __typename?: 'Availability', date: number, pms_appt_type_pms_id?: string | null, times: Array<{ __typename?: 'TimeInterval', start?: number | null, end?: number | null }>, repeat?: { __typename?: 'RepeatAvailability', daysOfMonth?: Array<number> | null, daysOfWeek?: Array<DayOfWeek> | null, weekOfMonth?: WeekOfMonth | null, frequency: any, unit: RepeatUnit, end_date?: number | null } | null }> | null, pms_adjusted_availability?: Array<{ __typename?: 'Availability', date: number, pms_appt_type_pms_id?: string | null, times: Array<{ __typename?: 'TimeInterval', start?: number | null, end?: number | null }>, repeat?: { __typename?: 'RepeatAvailability', daysOfMonth?: Array<number> | null, daysOfWeek?: Array<DayOfWeek> | null, weekOfMonth?: WeekOfMonth | null, frequency: any, unit: RepeatUnit, end_date?: number | null } | null }> | null } };

export type DeleteClinicianMutationVariables = Exact<{
  id: Scalars['ID']['input'];
}>;


export type DeleteClinicianMutation = { __typename?: 'Mutation', deleteClinician?: any | null };

export type AddressFieldsFragment = { __typename?: 'Address', street_a?: string | null, street_b?: string | null, city?: string | null, state?: string | null, zip?: string | null, country?: string | null };

export type ClinicFieldsFragment = { __typename?: 'Clinic', id: string, slug?: string | null, name?: string | null, description?: string | null, email?: string | null, phone?: string | null, send_from_phone?: string | null, send_from_email?: string | null, reply_to_email?: string | null, website?: string | null, pms: PracticeManagementSystem, pms_connector: PmsConnector, pms_api_key?: string | null, pms_additional_key?: string | null, office_emails?: Array<string> | null, stripe_accounts_enabled?: Array<StripeAccountType> | null, stripe_account_type?: string | null, stripe_customer_id?: string | null, avatar_url?: string | null, go_live_date?: string | null, time_zone?: string | null, is_archived: boolean, location?: string | null, tmp_feature_flags?: any | null, mute_until?: number | null, created_at: number, updated_at: number, pms_db?: { __typename?: 'PmsDb', id: string, name: string, last_sync_times?: { __typename?: 'LastSyncTimes', last_full_sync?: number | null, last_sync_appointments?: number | null, last_sync_clients?: number | null, last_sync_patients?: number | null, last_sync_clinicians?: number | null, last_sync_services?: number | null, last_sync_transactions?: number | null, last_sync_invoices?: number | null, last_sync_history_items?: number | null, last_sync_diagnoses?: number | null, last_sync_prescriptions?: number | null, last_sync_products?: number | null, last_sync_rooms?: number | null, last_sync_species?: number | null, last_sync_breeds?: number | null, last_sync_reminders?: number | null, last_sync_reminder_types?: number | null, last_sync_vaccination_records?: number | null, last_sync_clinic_sexes?: number | null, last_sync_appt_statuses?: number | null, last_sync_blockoffs?: number | null, last_sync_invoice_items?: number | null } | null } | null, clinic_admins: Array<{ __typename?: 'ClinicAdmin', id: string, role: AuthRoles, are_email_notifications_enabled: boolean, are_sms_notifications_enabled: boolean, are_desktop_notifications_enabled: boolean, should_hide_daily_huddle_financials: boolean, created_at: number, updated_at: number, clinic: { __typename?: 'Clinic', id: string, name?: string | null, slug?: string | null, avatar_url?: string | null, is_verified?: boolean | null, is_archived: boolean, description?: string | null, pms: PracticeManagementSystem, time_zone?: string | null, last_sync_times?: { __typename?: 'LastSyncTimes', last_full_sync?: number | null } | null, clinic_admins: Array<{ __typename?: 'ClinicAdmin', id: string }>, organization?: { __typename?: 'Organization', id: string } | null, address?: { __typename?: 'Address', street_a?: string | null, street_b?: string | null, city?: string | null, state?: string | null, zip?: string | null, country?: string | null, lat?: number | null, lng?: number | null } | null }, user: { __typename?: 'User', id: string, first_name?: string | null, last_name?: string | null, email?: any | null, phone?: string | null, phone_country?: string | null, avatar_url?: string | null, role?: AuthRoles | null, enabled_notification_sounds?: Array<UserNotificationSound> | null, notify_email_on?: Array<NotifyClinicOn> | null, notify_sound_on?: Array<NotifyClinicOn> | null, notify_desktop_on?: Array<NotifyClinicOn> | null, must_reset_password?: boolean | null, invitation_status?: UserInvitationStatus | null, invited_at?: number | null, created_at: number, updated_at: number }, custom_role?: { __typename?: 'CustomRole', id: string, name: string } | null, permissions?: Array<{ __typename?: 'ClinicAdminPermission', feature: AdminPermissionFeature, access_level: AdminPermissionAccessLevel }> | null }>, address?: { __typename?: 'Address', street_a?: string | null, street_b?: string | null, city?: string | null, state?: string | null, zip?: string | null, country?: string | null } | null, services: Array<{ __typename?: 'Service', id: string, name?: string | null }>, settings?: { __typename?: 'ClinicSettings', id?: string | null, does_require_verification?: boolean | null, does_use_automatic_reschedule?: boolean | null, reset_status_to_booked_on_reschedule?: boolean | null, is_using_detailed_services?: boolean | null, hide_review_step?: boolean | null, is_using_rooms?: boolean | null, pms_start_time?: any | null, pms_end_time?: any | null, primary_color?: string | null, accent_color?: string | null, secondary_color?: string | null, new_appt_requested_msg?: string | null, new_appt_approved_msg?: string | null, new_appt_approved_sms_msg?: string | null, new_appt_denied_msg?: string | null, schedule_method?: ScheduleMethod | null, scheduling_buffer_minutes?: number | null, base_schedule_duration?: number | null, does_require_referral?: boolean | null, appointment_entry_method?: AppointmentEntryMethod | null, scheduling_min_minutes_away?: number | null, scheduling_max_minutes_away?: number | null, included_species?: Array<Species> | null, max_patients_per_visit?: number | null, should_complete_sync?: boolean | null, server_syncing_only?: boolean | null, confirmation_days_before?: number | null, send_confirmations_to: SendConfirmationsTo, send_new_appt_email?: boolean | null, send_reviews_to?: SendConfirmationsTo | null, max_review_rating_for_notif?: number | null, google_review_link?: string | null, facebook_review_link?: string | null, non_blocking_services: Array<string>, yesterday_revenue?: number | null, this_month_revenue?: number | null, hide_clinician_preference: boolean, does_use_rooms_to_schedule?: boolean | null, primary_room_pms_id?: string | null, should_default_pims_emails_on: boolean, should_default_pims_sms_on: boolean, should_default_marketing_sms_on: boolean, should_default_marketing_email_on: boolean, does_use_clinicians_to_schedule?: boolean | null, time_slot_minutes: number, sync_interval_minutes: number, long_sync_interval_hours: number, primary_clinician_pms_id?: string | null, cancellation_clinician_pms_id?: string | null, cancellation_service_pms_id?: string | null, allow_first_appt_per_day?: boolean | null, custom_well_description?: string | null, custom_sick_description?: string | null, custom_other_title?: string | null, custom_other_description?: string | null, default_trigger_words?: Array<string> | null, should_use_private_reviews?: boolean | null, notify_clinic_on?: Array<NotifyClinicOn> | null, reminder_send_time_minutes?: number | null, does_require_new_client_address?: boolean | null, does_require_new_client_birthday?: boolean | null, should_allow_new_clients?: boolean | null, should_allow_new_patients?: boolean | null, should_create_clients?: boolean | null, should_create_patients?: boolean | null, msgs_auto_priority?: boolean | null, booking_match_procedure?: BookingMatchProcedure | null, urgency_type?: UrgencyType | null, max_booking_columns?: number | null, hide_closed_days_from_scheduling?: boolean | null, should_sync_reminders?: boolean | null, auto_reply_enabled: boolean, auto_reply_message?: string | null, unreplied_message_alert_enabled: boolean, unreplied_message_alert_minutes: number, comms_writeback_enabled: boolean, comms_should_daily_writeback: boolean, comms_use_pdf_for_writeback: boolean, comms_writeback_buffer_minutes: number, comms_writeback_before_appt_mins: number, comms_should_writeback_on_send: boolean, comms_should_writeback_on_receive: boolean, comms_should_writeback_notifs: boolean, comms_should_use_ai_writeback: boolean, form_writeback_enabled: boolean, should_award_loyalty_for_invoices?: boolean | null, invoice_loyalty_points_per_dollar?: number | null, app_download_loyalty_points?: number | null, referrer_loyalty_points?: number | null, referred_loyalty_points?: number | null, custom_appointment_notes_template?: string | null, custom_new_client_notes_template?: string | null, custom_new_patient_notes_template?: string | null, max_inactivity_duration?: number | null, hide_portal_vaccinations: boolean, hide_portal_reminders: boolean, hide_portal_prescriptions: boolean, hide_portal_weight: boolean, hide_soc_vaccinations?: boolean | null, hide_historic_vaccinations?: boolean | null, should_hide_daily_huddle_financials: boolean, patient_details_tab_order: Array<PortalPatientDetailsTab>, clinic_hours_display?: string | null, reschedule_buffer_minutes?: number | null, cancellation_buffer_minutes?: number | null, require_reason_for_cancellation?: boolean | null, should_automatically_assign_patient?: boolean | null, payment_writeback_enabled: boolean, auto_refund_on_cancel: boolean, status_set_on_payment_completed_pms_id?: string | null, max_booking_notes_length?: number | null, min_booking_notes_length?: number | null, primary_clinic_group_id?: string | null, should_suggest_nearby_clinics?: boolean | null, sms_block_list?: Array<string> | null, exclude_message_wrapper?: boolean | null, should_charge_client_stripe_fees?: boolean | null, chckvet_prescription_fee_split_percentage?: number | null, gtm_container_id?: string | null, review_google_id?: string | null, review_facebook_id?: string | null, only_use_adj_avail_guides: boolean, use_basic_timeslots: boolean, valid_booking_interval_minutes?: Array<number> | null, should_disable_online_scheduling?: boolean | null, simple_scheduling_rules_enabled: boolean, compliance_statuses?: Array<string> | null, should_use_instant_prescription_requests?: boolean | null, prescription_pickup_service_id?: string | null, default_reminder_service_id?: string | null, ai_calls_provider?: PhoneProviderType | null, ai_calls_phone_number?: string | null, ai_calls_voice_id?: string | null, ai_calls_agent_id?: string | null, ai_agent_style?: string | null, ai_agent_custom_instructions?: string | null, ai_calls_ambient_sound?: AiCallsAmbientSound | null, ai_calls_voice_speed?: number | null, ai_calls_interruption_sensitivity?: number | null, ai_calls_enable_dynamic_voice_speed?: boolean | null, usage_spending_caps?: any | null, custom_merge_tags?: any | null, custom_booking_copy?: { __typename?: 'ClinicBookingCopy', WIDGET_HEADER_TITLE?: string | null, SHOW_CLINIC_HEADER_LOGO?: boolean | null, CLINIC_HEADER_LOGO_HEIGHT?: number | null, SERVICE_TYPE_SECTION_HEADING?: string | null, DEFAULT_WELLNESS_DESCRIPTION?: string | null, DEFAULT_SICK_DESCRIPTION?: string | null, DEFAULT_OTHER_DESCRIPTION?: string | null, RETURNING_PATIENT_QUESTION?: string | null, POSITIVE_RETURNING_PATIENT_ANSWER?: string | null, NEGATIVE_RETURNING_PATIENT_ANSWER?: string | null, RETURNING_CLIENT_QUESTION?: string | null, POSITIVE_RETURNING_CLIENT_ANSWER?: string | null, NEGATIVE_RETURNING_CLIENT_ANSWER?: string | null, CLIENT_INFORMATION_SECTION_TITLE?: string | null, PATIENT_INFORMATION_SECTION_TITLE?: string | null, RETURNING_CLIENT_PATIENT_TITLE?: string | null, RETURNING_CLIENT_PATIENT_DESCRIPTION?: string | null, SERVICE_SECTION_TITLE?: string | null, PREPAID_SERVICES_LABEL?: string | null, STANDARD_SERVICES_LABEL?: string | null, DEPOSIT_FEE_NAME?: string | null, PREVIOUS_OR_REFERRING_CLINIC_QUESTION?: string | null, CONTACT_THE_CLINIC_TEXT?: string | null, CONTACT_THE_CLINIC_TEXT_COLOR?: string | null, CONTACT_THE_CLINIC_TEXT_SIZE?: string | null, SELECT_CLINICIAN_TITLE?: string | null, SELECT_CLINICIAN_POSITIVE_ANSWER?: string | null, SELECT_CLINICIAN_NEGATIVE_ANSWER?: string | null, SELECT_TIME_TITLE?: string | null, REVIEW_TITLE?: string | null, REVIEW_NOTES_PROMPT?: string | null, PAYMENT_INFORMATION_TITLE?: string | null, TRIGGER_WORDS_DETECTED_HEADER?: string | null, TRIGGER_WORDS_DETECTED_DESCRIPTION?: string | null, CONFIRMATION_SCREEN_TITLE?: string | null, CONFIRMATION_SCREEN_DESCRIPTION?: string | null, NEW_CLIENT_BLOCKED_MESSAGE?: string | null, NEW_PATIENT_BLOCKED_MESSAGE?: string | null } | null, auto_reply_hours?: { __typename?: 'AvailabilityHours', monday?: Array<{ __typename?: 'TimeInterval', start?: number | null, end?: number | null }> | null, tuesday?: Array<{ __typename?: 'TimeInterval', start?: number | null, end?: number | null }> | null, wednesday?: Array<{ __typename?: 'TimeInterval', start?: number | null, end?: number | null }> | null, thursday?: Array<{ __typename?: 'TimeInterval', start?: number | null, end?: number | null }> | null, friday?: Array<{ __typename?: 'TimeInterval', start?: number | null, end?: number | null }> | null, saturday?: Array<{ __typename?: 'TimeInterval', start?: number | null, end?: number | null }> | null, sunday?: Array<{ __typename?: 'TimeInterval', start?: number | null, end?: number | null }> | null } | null, portal_links?: Array<{ __typename?: 'PortalLink', label: string, url: string }> | null, custom_reviews_copy?: { __typename?: 'ClinicReviewsCopy', REVIEW_METHOD_PAGE_TITLE?: string | null, REVIEW_METHOD_PAGE_DESCRIPTION?: string | null, PRIVATE_REVIEW_BUTTON_HELP_TEXT?: string | null, PRIVATE_REVIEW_BUTTON_TEXT?: string | null, REVIEW_PAGE_TITLE?: string | null, REVIEW_PAGE_SUBTITLE?: string | null, REVIEW_SCORE_LABEL?: string | null, REVIEW_MESSAGE_LABEL?: string | null, REVIEW_SUBMIT_BUTTON_TEXT?: string | null } | null, waitlist_customer_segment?: { __typename?: 'CustomerSegment', id: string, name: string, trigger_entity?: CustomerSegmentTrigger | null, is_archived: boolean, updated_at: number, notification_templates?: Array<{ __typename?: 'NotificationTemplate', id: string, name: string, is_active: boolean, is_archived: boolean, message_methods: Array<MessageMethod> }> | null, error_flags?: Array<{ __typename?: 'CustomerSegmentErrorFlag', filter_column: string, filter_index: number, parameter_index: number, message: string }> | null, all_inclusions?: Array<{ __typename?: 'SegmentFilter', foreign_table?: string | null, group?: string | null, parameters: Array<{ __typename?: 'QueryFilter', column: string, filterOp: FilterOp, value: { __typename?: 'QueryFilterValue', string?: string | null, float?: number | null, boolean?: boolean | null, stringArray?: Array<string> | null, floatArray?: Array<number> | null, millisFromNow?: number | null, relativeTime?: { __typename?: 'RelativeTime', quantity: number, unit: TimeUnit, direction: ReferenceDirection } | null } }> }> | null, any_inclusions?: Array<{ __typename?: 'SegmentFilter', foreign_table?: string | null, group?: string | null, parameters: Array<{ __typename?: 'QueryFilter', column: string, filterOp: FilterOp, value: { __typename?: 'QueryFilterValue', string?: string | null, float?: number | null, boolean?: boolean | null, stringArray?: Array<string> | null, floatArray?: Array<number> | null, millisFromNow?: number | null, relativeTime?: { __typename?: 'RelativeTime', quantity: number, unit: TimeUnit, direction: ReferenceDirection } | null } }> }> | null, any_exclusions?: Array<{ __typename?: 'SegmentFilter', foreign_table?: string | null, group?: string | null, parameters: Array<{ __typename?: 'QueryFilter', column: string, filterOp: FilterOp, value: { __typename?: 'QueryFilterValue', string?: string | null, float?: number | null, boolean?: boolean | null, stringArray?: Array<string> | null, floatArray?: Array<number> | null, millisFromNow?: number | null, relativeTime?: { __typename?: 'RelativeTime', quantity: number, unit: TimeUnit, direction: ReferenceDirection } | null } }> }> | null, any_other_exclusions?: Array<{ __typename?: 'SegmentFilter', foreign_table?: string | null, group?: string | null, parameters: Array<{ __typename?: 'QueryFilter', column: string, filterOp: FilterOp, value: { __typename?: 'QueryFilterValue', string?: string | null, float?: number | null, boolean?: boolean | null, stringArray?: Array<string> | null, floatArray?: Array<number> | null, millisFromNow?: number | null, relativeTime?: { __typename?: 'RelativeTime', quantity: number, unit: TimeUnit, direction: ReferenceDirection } | null } }> }> | null, filters?: Array<{ __typename?: 'CustomerSegmentFilter', filters: Array<{ __typename?: 'QueryFilter', column: string, filterOp: FilterOp, value: { __typename?: 'QueryFilterValue', string?: string | null, float?: number | null, boolean?: boolean | null, stringArray?: Array<string> | null, floatArray?: Array<number> | null, millisFromNow?: number | null, relativeTime?: { __typename?: 'RelativeTime', quantity: number, unit: TimeUnit, direction: ReferenceDirection } | null } }> }> | null, excluded_filters: Array<{ __typename?: 'CustomerSegmentFilter', filters: Array<{ __typename?: 'QueryFilter', column: string, filterOp: FilterOp, value: { __typename?: 'QueryFilterValue', string?: string | null, float?: number | null, boolean?: boolean | null, stringArray?: Array<string> | null, floatArray?: Array<number> | null, millisFromNow?: number | null, relativeTime?: { __typename?: 'RelativeTime', quantity: number, unit: TimeUnit, direction: ReferenceDirection } | null } }> }> } | null, blocklist_customer_segment?: { __typename?: 'CustomerSegment', id: string, name: string, trigger_entity?: CustomerSegmentTrigger | null, is_archived: boolean, updated_at: number, notification_templates?: Array<{ __typename?: 'NotificationTemplate', id: string, name: string, is_active: boolean, is_archived: boolean, message_methods: Array<MessageMethod> }> | null, error_flags?: Array<{ __typename?: 'CustomerSegmentErrorFlag', filter_column: string, filter_index: number, parameter_index: number, message: string }> | null, all_inclusions?: Array<{ __typename?: 'SegmentFilter', foreign_table?: string | null, group?: string | null, parameters: Array<{ __typename?: 'QueryFilter', column: string, filterOp: FilterOp, value: { __typename?: 'QueryFilterValue', string?: string | null, float?: number | null, boolean?: boolean | null, stringArray?: Array<string> | null, floatArray?: Array<number> | null, millisFromNow?: number | null, relativeTime?: { __typename?: 'RelativeTime', quantity: number, unit: TimeUnit, direction: ReferenceDirection } | null } }> }> | null, any_inclusions?: Array<{ __typename?: 'SegmentFilter', foreign_table?: string | null, group?: string | null, parameters: Array<{ __typename?: 'QueryFilter', column: string, filterOp: FilterOp, value: { __typename?: 'QueryFilterValue', string?: string | null, float?: number | null, boolean?: boolean | null, stringArray?: Array<string> | null, floatArray?: Array<number> | null, millisFromNow?: number | null, relativeTime?: { __typename?: 'RelativeTime', quantity: number, unit: TimeUnit, direction: ReferenceDirection } | null } }> }> | null, any_exclusions?: Array<{ __typename?: 'SegmentFilter', foreign_table?: string | null, group?: string | null, parameters: Array<{ __typename?: 'QueryFilter', column: string, filterOp: FilterOp, value: { __typename?: 'QueryFilterValue', string?: string | null, float?: number | null, boolean?: boolean | null, stringArray?: Array<string> | null, floatArray?: Array<number> | null, millisFromNow?: number | null, relativeTime?: { __typename?: 'RelativeTime', quantity: number, unit: TimeUnit, direction: ReferenceDirection } | null } }> }> | null, any_other_exclusions?: Array<{ __typename?: 'SegmentFilter', foreign_table?: string | null, group?: string | null, parameters: Array<{ __typename?: 'QueryFilter', column: string, filterOp: FilterOp, value: { __typename?: 'QueryFilterValue', string?: string | null, float?: number | null, boolean?: boolean | null, stringArray?: Array<string> | null, floatArray?: Array<number> | null, millisFromNow?: number | null, relativeTime?: { __typename?: 'RelativeTime', quantity: number, unit: TimeUnit, direction: ReferenceDirection } | null } }> }> | null, filters?: Array<{ __typename?: 'CustomerSegmentFilter', filters: Array<{ __typename?: 'QueryFilter', column: string, filterOp: FilterOp, value: { __typename?: 'QueryFilterValue', string?: string | null, float?: number | null, boolean?: boolean | null, stringArray?: Array<string> | null, floatArray?: Array<number> | null, millisFromNow?: number | null, relativeTime?: { __typename?: 'RelativeTime', quantity: number, unit: TimeUnit, direction: ReferenceDirection } | null } }> }> | null, excluded_filters: Array<{ __typename?: 'CustomerSegmentFilter', filters: Array<{ __typename?: 'QueryFilter', column: string, filterOp: FilterOp, value: { __typename?: 'QueryFilterValue', string?: string | null, float?: number | null, boolean?: boolean | null, stringArray?: Array<string> | null, floatArray?: Array<number> | null, millisFromNow?: number | null, relativeTime?: { __typename?: 'RelativeTime', quantity: number, unit: TimeUnit, direction: ReferenceDirection } | null } }> }> } | null, referral_customer_segment?: { __typename?: 'CustomerSegment', id: string, name: string, trigger_entity?: CustomerSegmentTrigger | null, is_archived: boolean, updated_at: number, notification_templates?: Array<{ __typename?: 'NotificationTemplate', id: string, name: string, is_active: boolean, is_archived: boolean, message_methods: Array<MessageMethod> }> | null, error_flags?: Array<{ __typename?: 'CustomerSegmentErrorFlag', filter_column: string, filter_index: number, parameter_index: number, message: string }> | null, all_inclusions?: Array<{ __typename?: 'SegmentFilter', foreign_table?: string | null, group?: string | null, parameters: Array<{ __typename?: 'QueryFilter', column: string, filterOp: FilterOp, value: { __typename?: 'QueryFilterValue', string?: string | null, float?: number | null, boolean?: boolean | null, stringArray?: Array<string> | null, floatArray?: Array<number> | null, millisFromNow?: number | null, relativeTime?: { __typename?: 'RelativeTime', quantity: number, unit: TimeUnit, direction: ReferenceDirection } | null } }> }> | null, any_inclusions?: Array<{ __typename?: 'SegmentFilter', foreign_table?: string | null, group?: string | null, parameters: Array<{ __typename?: 'QueryFilter', column: string, filterOp: FilterOp, value: { __typename?: 'QueryFilterValue', string?: string | null, float?: number | null, boolean?: boolean | null, stringArray?: Array<string> | null, floatArray?: Array<number> | null, millisFromNow?: number | null, relativeTime?: { __typename?: 'RelativeTime', quantity: number, unit: TimeUnit, direction: ReferenceDirection } | null } }> }> | null, any_exclusions?: Array<{ __typename?: 'SegmentFilter', foreign_table?: string | null, group?: string | null, parameters: Array<{ __typename?: 'QueryFilter', column: string, filterOp: FilterOp, value: { __typename?: 'QueryFilterValue', string?: string | null, float?: number | null, boolean?: boolean | null, stringArray?: Array<string> | null, floatArray?: Array<number> | null, millisFromNow?: number | null, relativeTime?: { __typename?: 'RelativeTime', quantity: number, unit: TimeUnit, direction: ReferenceDirection } | null } }> }> | null, any_other_exclusions?: Array<{ __typename?: 'SegmentFilter', foreign_table?: string | null, group?: string | null, parameters: Array<{ __typename?: 'QueryFilter', column: string, filterOp: FilterOp, value: { __typename?: 'QueryFilterValue', string?: string | null, float?: number | null, boolean?: boolean | null, stringArray?: Array<string> | null, floatArray?: Array<number> | null, millisFromNow?: number | null, relativeTime?: { __typename?: 'RelativeTime', quantity: number, unit: TimeUnit, direction: ReferenceDirection } | null } }> }> | null, filters?: Array<{ __typename?: 'CustomerSegmentFilter', filters: Array<{ __typename?: 'QueryFilter', column: string, filterOp: FilterOp, value: { __typename?: 'QueryFilterValue', string?: string | null, float?: number | null, boolean?: boolean | null, stringArray?: Array<string> | null, floatArray?: Array<number> | null, millisFromNow?: number | null, relativeTime?: { __typename?: 'RelativeTime', quantity: number, unit: TimeUnit, direction: ReferenceDirection } | null } }> }> | null, excluded_filters: Array<{ __typename?: 'CustomerSegmentFilter', filters: Array<{ __typename?: 'QueryFilter', column: string, filterOp: FilterOp, value: { __typename?: 'QueryFilterValue', string?: string | null, float?: number | null, boolean?: boolean | null, stringArray?: Array<string> | null, floatArray?: Array<number> | null, millisFromNow?: number | null, relativeTime?: { __typename?: 'RelativeTime', quantity: number, unit: TimeUnit, direction: ReferenceDirection } | null } }> }> } | null, webhooks?: Array<{ __typename?: 'WebhookConfig', id: string, name: string, url: string, events: Array<WebhookEventType>, secret?: string | null, enabled: boolean }> | null, times_first_filter_config?: { __typename?: 'TimesFirstFilterConfig', service?: BookingFilterDisplayMode | null, clinician?: BookingFilterDisplayMode | null, species?: BookingFilterDisplayMode | null, client_status?: BookingFilterDisplayMode | null, patient_status?: BookingFilterDisplayMode | null, patient_gender?: BookingFilterDisplayMode | null, fixed_status?: BookingFilterDisplayMode | null } | null } | null, onboarding?: { __typename?: 'ClinicOnboarding', has_set_hours?: boolean | null, has_synced_pms?: boolean | null } | null, organization?: { __typename?: 'Organization', id: string } | null, features?: { __typename?: 'ClinicFeatures', scheduling_enabled?: boolean | null, huddle_enabled?: boolean | null, payments_enabled?: boolean | null, messaging_enabled?: boolean | null, reviews_enabled?: boolean | null, loyalty_enabled?: boolean | null, notifs_enabled?: boolean | null, forms_enabled?: boolean | null, help_enabled?: boolean | null, bulk_messaging_enabled?: boolean | null, portal_enabled?: boolean | null, calls_enabled?: boolean | null, teamchat_enabled?: boolean | null, prescriptions_enabled?: boolean | null, medical_history_enabled?: boolean | null, pet_selfies_enabled?: boolean | null } | null, hours?: { __typename?: 'AvailabilityHours', monday?: Array<{ __typename?: 'TimeInterval', start?: number | null, end?: number | null }> | null, tuesday?: Array<{ __typename?: 'TimeInterval', start?: number | null, end?: number | null }> | null, wednesday?: Array<{ __typename?: 'TimeInterval', start?: number | null, end?: number | null }> | null, thursday?: Array<{ __typename?: 'TimeInterval', start?: number | null, end?: number | null }> | null, friday?: Array<{ __typename?: 'TimeInterval', start?: number | null, end?: number | null }> | null, saturday?: Array<{ __typename?: 'TimeInterval', start?: number | null, end?: number | null }> | null, sunday?: Array<{ __typename?: 'TimeInterval', start?: number | null, end?: number | null }> | null } | null, clinic_hours?: { __typename?: 'AvailabilityHours', monday?: Array<{ __typename?: 'TimeInterval', start?: number | null, end?: number | null }> | null, tuesday?: Array<{ __typename?: 'TimeInterval', start?: number | null, end?: number | null }> | null, wednesday?: Array<{ __typename?: 'TimeInterval', start?: number | null, end?: number | null }> | null, thursday?: Array<{ __typename?: 'TimeInterval', start?: number | null, end?: number | null }> | null, friday?: Array<{ __typename?: 'TimeInterval', start?: number | null, end?: number | null }> | null, saturday?: Array<{ __typename?: 'TimeInterval', start?: number | null, end?: number | null }> | null, sunday?: Array<{ __typename?: 'TimeInterval', start?: number | null, end?: number | null }> | null } | null, adjusted_availability?: Array<{ __typename?: 'Availability', date: number, pms_appt_type_pms_id?: string | null, times: Array<{ __typename?: 'TimeInterval', start?: number | null, end?: number | null }>, repeat?: { __typename?: 'RepeatAvailability', daysOfMonth?: Array<number> | null, daysOfWeek?: Array<DayOfWeek> | null, weekOfMonth?: WeekOfMonth | null, frequency: any, unit: RepeatUnit, end_date?: number | null } | null }> | null, pms_adjusted_availability?: Array<{ __typename?: 'Availability', date: number, pms_appt_type_pms_id?: string | null, times: Array<{ __typename?: 'TimeInterval', start?: number | null, end?: number | null }>, repeat?: { __typename?: 'RepeatAvailability', daysOfMonth?: Array<number> | null, daysOfWeek?: Array<DayOfWeek> | null, weekOfMonth?: WeekOfMonth | null, frequency: any, unit: RepeatUnit, end_date?: number | null } | null }> | null, last_sync_times?: { __typename?: 'LastSyncTimes', last_full_sync?: number | null, last_sync_appointments?: number | null, last_sync_clients?: number | null, last_sync_patients?: number | null, last_sync_clinicians?: number | null, last_sync_services?: number | null, last_sync_transactions?: number | null, last_sync_invoices?: number | null, last_sync_history_items?: number | null, last_sync_diagnoses?: number | null, last_sync_prescriptions?: number | null, last_sync_products?: number | null, last_sync_rooms?: number | null, last_sync_species?: number | null, last_sync_breeds?: number | null, last_sync_reminders?: number | null, last_sync_reminder_types?: number | null, last_sync_vaccination_records?: number | null, last_sync_clinic_sexes?: number | null, last_sync_appt_statuses?: number | null, last_sync_blockoffs?: number | null, last_sync_invoice_items?: number | null } | null, pims_settings?: { __typename?: 'PimsSettings', ezyvet_integration_mode?: EzyvetIntegrationMode | null, entered_by_pms_id?: string | null } | null };

export type ClinicFeatureFieldsFragment = { __typename?: 'ClinicFeatures', scheduling_enabled?: boolean | null, huddle_enabled?: boolean | null, payments_enabled?: boolean | null, messaging_enabled?: boolean | null, reviews_enabled?: boolean | null, loyalty_enabled?: boolean | null, notifs_enabled?: boolean | null, forms_enabled?: boolean | null, help_enabled?: boolean | null, bulk_messaging_enabled?: boolean | null, portal_enabled?: boolean | null, calls_enabled?: boolean | null, teamchat_enabled?: boolean | null, prescriptions_enabled?: boolean | null, medical_history_enabled?: boolean | null, pet_selfies_enabled?: boolean | null };

export type ClinicSettingsFieldsFragment = { __typename?: 'ClinicSettings', id?: string | null, does_require_verification?: boolean | null, does_use_automatic_reschedule?: boolean | null, reset_status_to_booked_on_reschedule?: boolean | null, is_using_detailed_services?: boolean | null, hide_review_step?: boolean | null, is_using_rooms?: boolean | null, pms_start_time?: any | null, pms_end_time?: any | null, primary_color?: string | null, accent_color?: string | null, secondary_color?: string | null, new_appt_requested_msg?: string | null, new_appt_approved_msg?: string | null, new_appt_approved_sms_msg?: string | null, new_appt_denied_msg?: string | null, schedule_method?: ScheduleMethod | null, scheduling_buffer_minutes?: number | null, base_schedule_duration?: number | null, does_require_referral?: boolean | null, appointment_entry_method?: AppointmentEntryMethod | null, scheduling_min_minutes_away?: number | null, scheduling_max_minutes_away?: number | null, included_species?: Array<Species> | null, max_patients_per_visit?: number | null, should_complete_sync?: boolean | null, server_syncing_only?: boolean | null, confirmation_days_before?: number | null, send_confirmations_to: SendConfirmationsTo, send_new_appt_email?: boolean | null, send_reviews_to?: SendConfirmationsTo | null, max_review_rating_for_notif?: number | null, google_review_link?: string | null, facebook_review_link?: string | null, non_blocking_services: Array<string>, yesterday_revenue?: number | null, this_month_revenue?: number | null, hide_clinician_preference: boolean, does_use_rooms_to_schedule?: boolean | null, primary_room_pms_id?: string | null, should_default_pims_emails_on: boolean, should_default_pims_sms_on: boolean, should_default_marketing_sms_on: boolean, should_default_marketing_email_on: boolean, does_use_clinicians_to_schedule?: boolean | null, time_slot_minutes: number, sync_interval_minutes: number, long_sync_interval_hours: number, primary_clinician_pms_id?: string | null, cancellation_clinician_pms_id?: string | null, cancellation_service_pms_id?: string | null, allow_first_appt_per_day?: boolean | null, custom_well_description?: string | null, custom_sick_description?: string | null, custom_other_title?: string | null, custom_other_description?: string | null, default_trigger_words?: Array<string> | null, should_use_private_reviews?: boolean | null, notify_clinic_on?: Array<NotifyClinicOn> | null, reminder_send_time_minutes?: number | null, does_require_new_client_address?: boolean | null, does_require_new_client_birthday?: boolean | null, should_allow_new_clients?: boolean | null, should_allow_new_patients?: boolean | null, should_create_clients?: boolean | null, should_create_patients?: boolean | null, msgs_auto_priority?: boolean | null, booking_match_procedure?: BookingMatchProcedure | null, urgency_type?: UrgencyType | null, max_booking_columns?: number | null, hide_closed_days_from_scheduling?: boolean | null, should_sync_reminders?: boolean | null, auto_reply_enabled: boolean, auto_reply_message?: string | null, unreplied_message_alert_enabled: boolean, unreplied_message_alert_minutes: number, comms_writeback_enabled: boolean, comms_should_daily_writeback: boolean, comms_use_pdf_for_writeback: boolean, comms_writeback_buffer_minutes: number, comms_writeback_before_appt_mins: number, comms_should_writeback_on_send: boolean, comms_should_writeback_on_receive: boolean, comms_should_writeback_notifs: boolean, comms_should_use_ai_writeback: boolean, form_writeback_enabled: boolean, should_award_loyalty_for_invoices?: boolean | null, invoice_loyalty_points_per_dollar?: number | null, app_download_loyalty_points?: number | null, referrer_loyalty_points?: number | null, referred_loyalty_points?: number | null, custom_appointment_notes_template?: string | null, custom_new_client_notes_template?: string | null, custom_new_patient_notes_template?: string | null, max_inactivity_duration?: number | null, hide_portal_vaccinations: boolean, hide_portal_reminders: boolean, hide_portal_prescriptions: boolean, hide_portal_weight: boolean, hide_soc_vaccinations?: boolean | null, hide_historic_vaccinations?: boolean | null, should_hide_daily_huddle_financials: boolean, patient_details_tab_order: Array<PortalPatientDetailsTab>, clinic_hours_display?: string | null, reschedule_buffer_minutes?: number | null, cancellation_buffer_minutes?: number | null, require_reason_for_cancellation?: boolean | null, should_automatically_assign_patient?: boolean | null, payment_writeback_enabled: boolean, auto_refund_on_cancel: boolean, status_set_on_payment_completed_pms_id?: string | null, max_booking_notes_length?: number | null, min_booking_notes_length?: number | null, primary_clinic_group_id?: string | null, should_suggest_nearby_clinics?: boolean | null, sms_block_list?: Array<string> | null, exclude_message_wrapper?: boolean | null, should_charge_client_stripe_fees?: boolean | null, chckvet_prescription_fee_split_percentage?: number | null, gtm_container_id?: string | null, review_google_id?: string | null, review_facebook_id?: string | null, only_use_adj_avail_guides: boolean, use_basic_timeslots: boolean, valid_booking_interval_minutes?: Array<number> | null, should_disable_online_scheduling?: boolean | null, simple_scheduling_rules_enabled: boolean, compliance_statuses?: Array<string> | null, should_use_instant_prescription_requests?: boolean | null, prescription_pickup_service_id?: string | null, default_reminder_service_id?: string | null, ai_calls_provider?: PhoneProviderType | null, ai_calls_phone_number?: string | null, ai_calls_voice_id?: string | null, ai_calls_agent_id?: string | null, ai_agent_style?: string | null, ai_agent_custom_instructions?: string | null, ai_calls_ambient_sound?: AiCallsAmbientSound | null, ai_calls_voice_speed?: number | null, ai_calls_interruption_sensitivity?: number | null, ai_calls_enable_dynamic_voice_speed?: boolean | null, usage_spending_caps?: any | null, custom_merge_tags?: any | null, custom_booking_copy?: { __typename?: 'ClinicBookingCopy', WIDGET_HEADER_TITLE?: string | null, SHOW_CLINIC_HEADER_LOGO?: boolean | null, CLINIC_HEADER_LOGO_HEIGHT?: number | null, SERVICE_TYPE_SECTION_HEADING?: string | null, DEFAULT_WELLNESS_DESCRIPTION?: string | null, DEFAULT_SICK_DESCRIPTION?: string | null, DEFAULT_OTHER_DESCRIPTION?: string | null, RETURNING_PATIENT_QUESTION?: string | null, POSITIVE_RETURNING_PATIENT_ANSWER?: string | null, NEGATIVE_RETURNING_PATIENT_ANSWER?: string | null, RETURNING_CLIENT_QUESTION?: string | null, POSITIVE_RETURNING_CLIENT_ANSWER?: string | null, NEGATIVE_RETURNING_CLIENT_ANSWER?: string | null, CLIENT_INFORMATION_SECTION_TITLE?: string | null, PATIENT_INFORMATION_SECTION_TITLE?: string | null, RETURNING_CLIENT_PATIENT_TITLE?: string | null, RETURNING_CLIENT_PATIENT_DESCRIPTION?: string | null, SERVICE_SECTION_TITLE?: string | null, PREPAID_SERVICES_LABEL?: string | null, STANDARD_SERVICES_LABEL?: string | null, DEPOSIT_FEE_NAME?: string | null, PREVIOUS_OR_REFERRING_CLINIC_QUESTION?: string | null, CONTACT_THE_CLINIC_TEXT?: string | null, CONTACT_THE_CLINIC_TEXT_COLOR?: string | null, CONTACT_THE_CLINIC_TEXT_SIZE?: string | null, SELECT_CLINICIAN_TITLE?: string | null, SELECT_CLINICIAN_POSITIVE_ANSWER?: string | null, SELECT_CLINICIAN_NEGATIVE_ANSWER?: string | null, SELECT_TIME_TITLE?: string | null, REVIEW_TITLE?: string | null, REVIEW_NOTES_PROMPT?: string | null, PAYMENT_INFORMATION_TITLE?: string | null, TRIGGER_WORDS_DETECTED_HEADER?: string | null, TRIGGER_WORDS_DETECTED_DESCRIPTION?: string | null, CONFIRMATION_SCREEN_TITLE?: string | null, CONFIRMATION_SCREEN_DESCRIPTION?: string | null, NEW_CLIENT_BLOCKED_MESSAGE?: string | null, NEW_PATIENT_BLOCKED_MESSAGE?: string | null } | null, auto_reply_hours?: { __typename?: 'AvailabilityHours', monday?: Array<{ __typename?: 'TimeInterval', start?: number | null, end?: number | null }> | null, tuesday?: Array<{ __typename?: 'TimeInterval', start?: number | null, end?: number | null }> | null, wednesday?: Array<{ __typename?: 'TimeInterval', start?: number | null, end?: number | null }> | null, thursday?: Array<{ __typename?: 'TimeInterval', start?: number | null, end?: number | null }> | null, friday?: Array<{ __typename?: 'TimeInterval', start?: number | null, end?: number | null }> | null, saturday?: Array<{ __typename?: 'TimeInterval', start?: number | null, end?: number | null }> | null, sunday?: Array<{ __typename?: 'TimeInterval', start?: number | null, end?: number | null }> | null } | null, portal_links?: Array<{ __typename?: 'PortalLink', label: string, url: string }> | null, custom_reviews_copy?: { __typename?: 'ClinicReviewsCopy', REVIEW_METHOD_PAGE_TITLE?: string | null, REVIEW_METHOD_PAGE_DESCRIPTION?: string | null, PRIVATE_REVIEW_BUTTON_HELP_TEXT?: string | null, PRIVATE_REVIEW_BUTTON_TEXT?: string | null, REVIEW_PAGE_TITLE?: string | null, REVIEW_PAGE_SUBTITLE?: string | null, REVIEW_SCORE_LABEL?: string | null, REVIEW_MESSAGE_LABEL?: string | null, REVIEW_SUBMIT_BUTTON_TEXT?: string | null } | null, waitlist_customer_segment?: { __typename?: 'CustomerSegment', id: string, name: string, trigger_entity?: CustomerSegmentTrigger | null, is_archived: boolean, updated_at: number, notification_templates?: Array<{ __typename?: 'NotificationTemplate', id: string, name: string, is_active: boolean, is_archived: boolean, message_methods: Array<MessageMethod> }> | null, error_flags?: Array<{ __typename?: 'CustomerSegmentErrorFlag', filter_column: string, filter_index: number, parameter_index: number, message: string }> | null, all_inclusions?: Array<{ __typename?: 'SegmentFilter', foreign_table?: string | null, group?: string | null, parameters: Array<{ __typename?: 'QueryFilter', column: string, filterOp: FilterOp, value: { __typename?: 'QueryFilterValue', string?: string | null, float?: number | null, boolean?: boolean | null, stringArray?: Array<string> | null, floatArray?: Array<number> | null, millisFromNow?: number | null, relativeTime?: { __typename?: 'RelativeTime', quantity: number, unit: TimeUnit, direction: ReferenceDirection } | null } }> }> | null, any_inclusions?: Array<{ __typename?: 'SegmentFilter', foreign_table?: string | null, group?: string | null, parameters: Array<{ __typename?: 'QueryFilter', column: string, filterOp: FilterOp, value: { __typename?: 'QueryFilterValue', string?: string | null, float?: number | null, boolean?: boolean | null, stringArray?: Array<string> | null, floatArray?: Array<number> | null, millisFromNow?: number | null, relativeTime?: { __typename?: 'RelativeTime', quantity: number, unit: TimeUnit, direction: ReferenceDirection } | null } }> }> | null, any_exclusions?: Array<{ __typename?: 'SegmentFilter', foreign_table?: string | null, group?: string | null, parameters: Array<{ __typename?: 'QueryFilter', column: string, filterOp: FilterOp, value: { __typename?: 'QueryFilterValue', string?: string | null, float?: number | null, boolean?: boolean | null, stringArray?: Array<string> | null, floatArray?: Array<number> | null, millisFromNow?: number | null, relativeTime?: { __typename?: 'RelativeTime', quantity: number, unit: TimeUnit, direction: ReferenceDirection } | null } }> }> | null, any_other_exclusions?: Array<{ __typename?: 'SegmentFilter', foreign_table?: string | null, group?: string | null, parameters: Array<{ __typename?: 'QueryFilter', column: string, filterOp: FilterOp, value: { __typename?: 'QueryFilterValue', string?: string | null, float?: number | null, boolean?: boolean | null, stringArray?: Array<string> | null, floatArray?: Array<number> | null, millisFromNow?: number | null, relativeTime?: { __typename?: 'RelativeTime', quantity: number, unit: TimeUnit, direction: ReferenceDirection } | null } }> }> | null, filters?: Array<{ __typename?: 'CustomerSegmentFilter', filters: Array<{ __typename?: 'QueryFilter', column: string, filterOp: FilterOp, value: { __typename?: 'QueryFilterValue', string?: string | null, float?: number | null, boolean?: boolean | null, stringArray?: Array<string> | null, floatArray?: Array<number> | null, millisFromNow?: number | null, relativeTime?: { __typename?: 'RelativeTime', quantity: number, unit: TimeUnit, direction: ReferenceDirection } | null } }> }> | null, excluded_filters: Array<{ __typename?: 'CustomerSegmentFilter', filters: Array<{ __typename?: 'QueryFilter', column: string, filterOp: FilterOp, value: { __typename?: 'QueryFilterValue', string?: string | null, float?: number | null, boolean?: boolean | null, stringArray?: Array<string> | null, floatArray?: Array<number> | null, millisFromNow?: number | null, relativeTime?: { __typename?: 'RelativeTime', quantity: number, unit: TimeUnit, direction: ReferenceDirection } | null } }> }> } | null, blocklist_customer_segment?: { __typename?: 'CustomerSegment', id: string, name: string, trigger_entity?: CustomerSegmentTrigger | null, is_archived: boolean, updated_at: number, notification_templates?: Array<{ __typename?: 'NotificationTemplate', id: string, name: string, is_active: boolean, is_archived: boolean, message_methods: Array<MessageMethod> }> | null, error_flags?: Array<{ __typename?: 'CustomerSegmentErrorFlag', filter_column: string, filter_index: number, parameter_index: number, message: string }> | null, all_inclusions?: Array<{ __typename?: 'SegmentFilter', foreign_table?: string | null, group?: string | null, parameters: Array<{ __typename?: 'QueryFilter', column: string, filterOp: FilterOp, value: { __typename?: 'QueryFilterValue', string?: string | null, float?: number | null, boolean?: boolean | null, stringArray?: Array<string> | null, floatArray?: Array<number> | null, millisFromNow?: number | null, relativeTime?: { __typename?: 'RelativeTime', quantity: number, unit: TimeUnit, direction: ReferenceDirection } | null } }> }> | null, any_inclusions?: Array<{ __typename?: 'SegmentFilter', foreign_table?: string | null, group?: string | null, parameters: Array<{ __typename?: 'QueryFilter', column: string, filterOp: FilterOp, value: { __typename?: 'QueryFilterValue', string?: string | null, float?: number | null, boolean?: boolean | null, stringArray?: Array<string> | null, floatArray?: Array<number> | null, millisFromNow?: number | null, relativeTime?: { __typename?: 'RelativeTime', quantity: number, unit: TimeUnit, direction: ReferenceDirection } | null } }> }> | null, any_exclusions?: Array<{ __typename?: 'SegmentFilter', foreign_table?: string | null, group?: string | null, parameters: Array<{ __typename?: 'QueryFilter', column: string, filterOp: FilterOp, value: { __typename?: 'QueryFilterValue', string?: string | null, float?: number | null, boolean?: boolean | null, stringArray?: Array<string> | null, floatArray?: Array<number> | null, millisFromNow?: number | null, relativeTime?: { __typename?: 'RelativeTime', quantity: number, unit: TimeUnit, direction: ReferenceDirection } | null } }> }> | null, any_other_exclusions?: Array<{ __typename?: 'SegmentFilter', foreign_table?: string | null, group?: string | null, parameters: Array<{ __typename?: 'QueryFilter', column: string, filterOp: FilterOp, value: { __typename?: 'QueryFilterValue', string?: string | null, float?: number | null, boolean?: boolean | null, stringArray?: Array<string> | null, floatArray?: Array<number> | null, millisFromNow?: number | null, relativeTime?: { __typename?: 'RelativeTime', quantity: number, unit: TimeUnit, direction: ReferenceDirection } | null } }> }> | null, filters?: Array<{ __typename?: 'CustomerSegmentFilter', filters: Array<{ __typename?: 'QueryFilter', column: string, filterOp: FilterOp, value: { __typename?: 'QueryFilterValue', string?: string | null, float?: number | null, boolean?: boolean | null, stringArray?: Array<string> | null, floatArray?: Array<number> | null, millisFromNow?: number | null, relativeTime?: { __typename?: 'RelativeTime', quantity: number, unit: TimeUnit, direction: ReferenceDirection } | null } }> }> | null, excluded_filters: Array<{ __typename?: 'CustomerSegmentFilter', filters: Array<{ __typename?: 'QueryFilter', column: string, filterOp: FilterOp, value: { __typename?: 'QueryFilterValue', string?: string | null, float?: number | null, boolean?: boolean | null, stringArray?: Array<string> | null, floatArray?: Array<number> | null, millisFromNow?: number | null, relativeTime?: { __typename?: 'RelativeTime', quantity: number, unit: TimeUnit, direction: ReferenceDirection } | null } }> }> } | null, referral_customer_segment?: { __typename?: 'CustomerSegment', id: string, name: string, trigger_entity?: CustomerSegmentTrigger | null, is_archived: boolean, updated_at: number, notification_templates?: Array<{ __typename?: 'NotificationTemplate', id: string, name: string, is_active: boolean, is_archived: boolean, message_methods: Array<MessageMethod> }> | null, error_flags?: Array<{ __typename?: 'CustomerSegmentErrorFlag', filter_column: string, filter_index: number, parameter_index: number, message: string }> | null, all_inclusions?: Array<{ __typename?: 'SegmentFilter', foreign_table?: string | null, group?: string | null, parameters: Array<{ __typename?: 'QueryFilter', column: string, filterOp: FilterOp, value: { __typename?: 'QueryFilterValue', string?: string | null, float?: number | null, boolean?: boolean | null, stringArray?: Array<string> | null, floatArray?: Array<number> | null, millisFromNow?: number | null, relativeTime?: { __typename?: 'RelativeTime', quantity: number, unit: TimeUnit, direction: ReferenceDirection } | null } }> }> | null, any_inclusions?: Array<{ __typename?: 'SegmentFilter', foreign_table?: string | null, group?: string | null, parameters: Array<{ __typename?: 'QueryFilter', column: string, filterOp: FilterOp, value: { __typename?: 'QueryFilterValue', string?: string | null, float?: number | null, boolean?: boolean | null, stringArray?: Array<string> | null, floatArray?: Array<number> | null, millisFromNow?: number | null, relativeTime?: { __typename?: 'RelativeTime', quantity: number, unit: TimeUnit, direction: ReferenceDirection } | null } }> }> | null, any_exclusions?: Array<{ __typename?: 'SegmentFilter', foreign_table?: string | null, group?: string | null, parameters: Array<{ __typename?: 'QueryFilter', column: string, filterOp: FilterOp, value: { __typename?: 'QueryFilterValue', string?: string | null, float?: number | null, boolean?: boolean | null, stringArray?: Array<string> | null, floatArray?: Array<number> | null, millisFromNow?: number | null, relativeTime?: { __typename?: 'RelativeTime', quantity: number, unit: TimeUnit, direction: ReferenceDirection } | null } }> }> | null, any_other_exclusions?: Array<{ __typename?: 'SegmentFilter', foreign_table?: string | null, group?: string | null, parameters: Array<{ __typename?: 'QueryFilter', column: string, filterOp: FilterOp, value: { __typename?: 'QueryFilterValue', string?: string | null, float?: number | null, boolean?: boolean | null, stringArray?: Array<string> | null, floatArray?: Array<number> | null, millisFromNow?: number | null, relativeTime?: { __typename?: 'RelativeTime', quantity: number, unit: TimeUnit, direction: ReferenceDirection } | null } }> }> | null, filters?: Array<{ __typename?: 'CustomerSegmentFilter', filters: Array<{ __typename?: 'QueryFilter', column: string, filterOp: FilterOp, value: { __typename?: 'QueryFilterValue', string?: string | null, float?: number | null, boolean?: boolean | null, stringArray?: Array<string> | null, floatArray?: Array<number> | null, millisFromNow?: number | null, relativeTime?: { __typename?: 'RelativeTime', quantity: number, unit: TimeUnit, direction: ReferenceDirection } | null } }> }> | null, excluded_filters: Array<{ __typename?: 'CustomerSegmentFilter', filters: Array<{ __typename?: 'QueryFilter', column: string, filterOp: FilterOp, value: { __typename?: 'QueryFilterValue', string?: string | null, float?: number | null, boolean?: boolean | null, stringArray?: Array<string> | null, floatArray?: Array<number> | null, millisFromNow?: number | null, relativeTime?: { __typename?: 'RelativeTime', quantity: number, unit: TimeUnit, direction: ReferenceDirection } | null } }> }> } | null, webhooks?: Array<{ __typename?: 'WebhookConfig', id: string, name: string, url: string, events: Array<WebhookEventType>, secret?: string | null, enabled: boolean }> | null, times_first_filter_config?: { __typename?: 'TimesFirstFilterConfig', service?: BookingFilterDisplayMode | null, clinician?: BookingFilterDisplayMode | null, species?: BookingFilterDisplayMode | null, client_status?: BookingFilterDisplayMode | null, patient_status?: BookingFilterDisplayMode | null, patient_gender?: BookingFilterDisplayMode | null, fixed_status?: BookingFilterDisplayMode | null } | null };

export type PortalLinkFieldsFragment = { __typename?: 'PortalLink', label: string, url: string };

export type ClinicBookingCopyFieldsFragment = { __typename?: 'ClinicBookingCopy', WIDGET_HEADER_TITLE?: string | null, SHOW_CLINIC_HEADER_LOGO?: boolean | null, CLINIC_HEADER_LOGO_HEIGHT?: number | null, SERVICE_TYPE_SECTION_HEADING?: string | null, DEFAULT_WELLNESS_DESCRIPTION?: string | null, DEFAULT_SICK_DESCRIPTION?: string | null, DEFAULT_OTHER_DESCRIPTION?: string | null, RETURNING_PATIENT_QUESTION?: string | null, POSITIVE_RETURNING_PATIENT_ANSWER?: string | null, NEGATIVE_RETURNING_PATIENT_ANSWER?: string | null, RETURNING_CLIENT_QUESTION?: string | null, POSITIVE_RETURNING_CLIENT_ANSWER?: string | null, NEGATIVE_RETURNING_CLIENT_ANSWER?: string | null, CLIENT_INFORMATION_SECTION_TITLE?: string | null, PATIENT_INFORMATION_SECTION_TITLE?: string | null, RETURNING_CLIENT_PATIENT_TITLE?: string | null, RETURNING_CLIENT_PATIENT_DESCRIPTION?: string | null, SERVICE_SECTION_TITLE?: string | null, PREPAID_SERVICES_LABEL?: string | null, STANDARD_SERVICES_LABEL?: string | null, DEPOSIT_FEE_NAME?: string | null, PREVIOUS_OR_REFERRING_CLINIC_QUESTION?: string | null, CONTACT_THE_CLINIC_TEXT?: string | null, CONTACT_THE_CLINIC_TEXT_COLOR?: string | null, CONTACT_THE_CLINIC_TEXT_SIZE?: string | null, SELECT_CLINICIAN_TITLE?: string | null, SELECT_CLINICIAN_POSITIVE_ANSWER?: string | null, SELECT_CLINICIAN_NEGATIVE_ANSWER?: string | null, SELECT_TIME_TITLE?: string | null, REVIEW_TITLE?: string | null, REVIEW_NOTES_PROMPT?: string | null, PAYMENT_INFORMATION_TITLE?: string | null, TRIGGER_WORDS_DETECTED_HEADER?: string | null, TRIGGER_WORDS_DETECTED_DESCRIPTION?: string | null, CONFIRMATION_SCREEN_TITLE?: string | null, CONFIRMATION_SCREEN_DESCRIPTION?: string | null, NEW_CLIENT_BLOCKED_MESSAGE?: string | null, NEW_PATIENT_BLOCKED_MESSAGE?: string | null };

export type ClinicReviewsCopyFieldsFragment = { __typename?: 'ClinicReviewsCopy', REVIEW_METHOD_PAGE_TITLE?: string | null, REVIEW_METHOD_PAGE_DESCRIPTION?: string | null, PRIVATE_REVIEW_BUTTON_HELP_TEXT?: string | null, PRIVATE_REVIEW_BUTTON_TEXT?: string | null, REVIEW_PAGE_TITLE?: string | null, REVIEW_PAGE_SUBTITLE?: string | null, REVIEW_SCORE_LABEL?: string | null, REVIEW_MESSAGE_LABEL?: string | null, REVIEW_SUBMIT_BUTTON_TEXT?: string | null };

export type ClinicPreviewFieldsFragment = { __typename?: 'Clinic', id: string, name?: string | null, slug?: string | null, avatar_url?: string | null, is_verified?: boolean | null, is_archived: boolean, description?: string | null, pms: PracticeManagementSystem, time_zone?: string | null, last_sync_times?: { __typename?: 'LastSyncTimes', last_full_sync?: number | null } | null, clinic_admins: Array<{ __typename?: 'ClinicAdmin', id: string }>, organization?: { __typename?: 'Organization', id: string } | null, address?: { __typename?: 'Address', street_a?: string | null, street_b?: string | null, city?: string | null, state?: string | null, zip?: string | null, country?: string | null, lat?: number | null, lng?: number | null } | null };

export type ClinicDisplayFieldsFragment = { __typename?: 'Clinic', id: string, name?: string | null };

export type ClinicUsageFieldsFragment = { __typename?: 'Clinic', id: string, name?: string | null, last_sync_times?: { __typename?: 'LastSyncTimes', last_sync_appointments?: number | null, last_sync_clients?: number | null, last_sync_patients?: number | null, last_full_sync?: number | null } | null };

export type UsageCountsFieldsFragment = { __typename?: 'UsageCounts', last_24h: number, last_week: number, previous_week: number, last_month: number, previous_month: number, all_time: number };

export type LastSyncTimesFieldsFragment = { __typename?: 'LastSyncTimes', last_full_sync?: number | null, last_sync_appointments?: number | null, last_sync_clients?: number | null, last_sync_patients?: number | null };

export type ClinicUsageStatsFieldsFragment = { __typename?: 'ClinicUsageStats', concerns?: Array<string> | null, clinic: { __typename?: 'Clinic', id: string, name?: string | null, pms: PracticeManagementSystem, mute_until?: number | null }, appointment_counts: { __typename?: 'UsageCounts', last_24h: number, last_week: number, previous_week: number, last_month: number, previous_month: number, all_time: number }, message_counts: { __typename?: 'UsageCounts', last_24h: number, last_week: number, previous_week: number, last_month: number, previous_month: number, all_time: number }, last_sync_times?: { __typename?: 'LastSyncTimes', last_full_sync?: number | null, last_sync_appointments?: number | null, last_sync_clients?: number | null, last_sync_patients?: number | null } | null, pms_db_last_sync_times?: { __typename?: 'LastSyncTimes', last_full_sync?: number | null, last_sync_appointments?: number | null, last_sync_clients?: number | null, last_sync_patients?: number | null } | null };

export type GetClinicUsageStatsQueryVariables = Exact<{
  where?: InputMaybe<Array<QueryInput> | QueryInput>;
  page?: InputMaybe<Scalars['NonNegativeInt']['input']>;
  pageSize?: InputMaybe<Scalars['NonNegativeInt']['input']>;
  orderBy?: InputMaybe<OrderByInput>;
}>;


export type GetClinicUsageStatsQuery = { __typename?: 'Query', getClinicUsageStats: Array<{ __typename?: 'ClinicUsageStats', concerns?: Array<string> | null, clinic: { __typename?: 'Clinic', id: string, name?: string | null, pms: PracticeManagementSystem, mute_until?: number | null }, appointment_counts: { __typename?: 'UsageCounts', last_24h: number, last_week: number, previous_week: number, last_month: number, previous_month: number, all_time: number }, message_counts: { __typename?: 'UsageCounts', last_24h: number, last_week: number, previous_week: number, last_month: number, previous_month: number, all_time: number }, last_sync_times?: { __typename?: 'LastSyncTimes', last_full_sync?: number | null, last_sync_appointments?: number | null, last_sync_clients?: number | null, last_sync_patients?: number | null } | null, pms_db_last_sync_times?: { __typename?: 'LastSyncTimes', last_full_sync?: number | null, last_sync_appointments?: number | null, last_sync_clients?: number | null, last_sync_patients?: number | null } | null }> };

export type GetClinicsWithConcernsQueryVariables = Exact<{
  wowApptWarning?: InputMaybe<Scalars['Int']['input']>;
  momApptWarning?: InputMaybe<Scalars['Int']['input']>;
  wowNotifWarning?: InputMaybe<Scalars['Int']['input']>;
  momNotifWarning?: InputMaybe<Scalars['Int']['input']>;
}>;


export type GetClinicsWithConcernsQuery = { __typename?: 'Query', getClinicsWithConcerns: Array<{ __typename?: 'ClinicUsageStats', concerns?: Array<string> | null, clinic: { __typename?: 'Clinic', id: string, name?: string | null, pms: PracticeManagementSystem, mute_until?: number | null }, appointment_counts: { __typename?: 'UsageCounts', last_24h: number, last_week: number, previous_week: number, last_month: number, previous_month: number, all_time: number }, message_counts: { __typename?: 'UsageCounts', last_24h: number, last_week: number, previous_week: number, last_month: number, previous_month: number, all_time: number }, last_sync_times?: { __typename?: 'LastSyncTimes', last_full_sync?: number | null, last_sync_appointments?: number | null, last_sync_clients?: number | null, last_sync_patients?: number | null } | null, pms_db_last_sync_times?: { __typename?: 'LastSyncTimes', last_full_sync?: number | null, last_sync_appointments?: number | null, last_sync_clients?: number | null, last_sync_patients?: number | null } | null }> };

export type ClinicStatsFieldsFragment = { __typename?: 'ClinicStats', completed_appointments: number, confirmed_appointments: number, booked_appointments: number, pending_appointments: number, cancelled_appointments: number, denied_appointments: number, expired_appointments: number, total_appointments: number, total_website_appointments: number, total_widget_appointments: number };

export type ClinicOnboardingClinicFieldsFragment = { __typename?: 'Clinic', name?: string | null, pms: PracticeManagementSystem, avatar_url?: string | null, email?: string | null, phone?: string | null, send_from_phone?: string | null, office_emails?: Array<string> | null, settings?: { __typename?: 'ClinicSettings', appointment_entry_method?: AppointmentEntryMethod | null, booking_match_procedure?: BookingMatchProcedure | null, is_using_detailed_services?: boolean | null, does_use_rooms_to_schedule?: boolean | null, does_use_clinicians_to_schedule?: boolean | null, should_allow_new_clients?: boolean | null, should_allow_new_patients?: boolean | null, urgency_type?: UrgencyType | null, should_sync_reminders?: boolean | null, primary_color?: string | null, primary_clinician_pms_id?: string | null, primary_room_pms_id?: string | null, allow_first_appt_per_day?: boolean | null } | null, last_sync_times?: { __typename?: 'LastSyncTimes', last_full_sync?: number | null } | null };

export type ClinicBasicInfoFieldsFragment = { __typename?: 'Clinic', id: string, name?: string | null, time_zone?: string | null };

export type ClinicOnboardingFieldsFragment = { __typename?: 'ClinicOnboarding', has_test_appointment?: boolean | null, clinic?: { __typename?: 'Clinic', name?: string | null, pms: PracticeManagementSystem, avatar_url?: string | null, email?: string | null, phone?: string | null, send_from_phone?: string | null, office_emails?: Array<string> | null, settings?: { __typename?: 'ClinicSettings', appointment_entry_method?: AppointmentEntryMethod | null, booking_match_procedure?: BookingMatchProcedure | null, is_using_detailed_services?: boolean | null, does_use_rooms_to_schedule?: boolean | null, does_use_clinicians_to_schedule?: boolean | null, should_allow_new_clients?: boolean | null, should_allow_new_patients?: boolean | null, urgency_type?: UrgencyType | null, should_sync_reminders?: boolean | null, primary_color?: string | null, primary_clinician_pms_id?: string | null, primary_room_pms_id?: string | null, allow_first_appt_per_day?: boolean | null } | null, last_sync_times?: { __typename?: 'LastSyncTimes', last_full_sync?: number | null } | null } | null };

export type GetClinicQueryVariables = Exact<{
  id: Scalars['ID']['input'];
}>;


export type GetClinicQuery = { __typename?: 'Query', clinic: { __typename?: 'Clinic', id: string, slug?: string | null, name?: string | null, description?: string | null, email?: string | null, phone?: string | null, send_from_phone?: string | null, send_from_email?: string | null, reply_to_email?: string | null, website?: string | null, pms: PracticeManagementSystem, pms_connector: PmsConnector, pms_api_key?: string | null, pms_additional_key?: string | null, office_emails?: Array<string> | null, stripe_accounts_enabled?: Array<StripeAccountType> | null, stripe_account_type?: string | null, stripe_customer_id?: string | null, avatar_url?: string | null, go_live_date?: string | null, time_zone?: string | null, is_archived: boolean, location?: string | null, tmp_feature_flags?: any | null, mute_until?: number | null, created_at: number, updated_at: number, pms_db?: { __typename?: 'PmsDb', id: string, name: string, last_sync_times?: { __typename?: 'LastSyncTimes', last_full_sync?: number | null, last_sync_appointments?: number | null, last_sync_clients?: number | null, last_sync_patients?: number | null, last_sync_clinicians?: number | null, last_sync_services?: number | null, last_sync_transactions?: number | null, last_sync_invoices?: number | null, last_sync_history_items?: number | null, last_sync_diagnoses?: number | null, last_sync_prescriptions?: number | null, last_sync_products?: number | null, last_sync_rooms?: number | null, last_sync_species?: number | null, last_sync_breeds?: number | null, last_sync_reminders?: number | null, last_sync_reminder_types?: number | null, last_sync_vaccination_records?: number | null, last_sync_clinic_sexes?: number | null, last_sync_appt_statuses?: number | null, last_sync_blockoffs?: number | null, last_sync_invoice_items?: number | null } | null } | null, clinic_admins: Array<{ __typename?: 'ClinicAdmin', id: string, role: AuthRoles, are_email_notifications_enabled: boolean, are_sms_notifications_enabled: boolean, are_desktop_notifications_enabled: boolean, should_hide_daily_huddle_financials: boolean, created_at: number, updated_at: number, clinic: { __typename?: 'Clinic', id: string, name?: string | null, slug?: string | null, avatar_url?: string | null, is_verified?: boolean | null, is_archived: boolean, description?: string | null, pms: PracticeManagementSystem, time_zone?: string | null, last_sync_times?: { __typename?: 'LastSyncTimes', last_full_sync?: number | null } | null, clinic_admins: Array<{ __typename?: 'ClinicAdmin', id: string }>, organization?: { __typename?: 'Organization', id: string } | null, address?: { __typename?: 'Address', street_a?: string | null, street_b?: string | null, city?: string | null, state?: string | null, zip?: string | null, country?: string | null, lat?: number | null, lng?: number | null } | null }, user: { __typename?: 'User', id: string, first_name?: string | null, last_name?: string | null, email?: any | null, phone?: string | null, phone_country?: string | null, avatar_url?: string | null, role?: AuthRoles | null, enabled_notification_sounds?: Array<UserNotificationSound> | null, notify_email_on?: Array<NotifyClinicOn> | null, notify_sound_on?: Array<NotifyClinicOn> | null, notify_desktop_on?: Array<NotifyClinicOn> | null, must_reset_password?: boolean | null, invitation_status?: UserInvitationStatus | null, invited_at?: number | null, created_at: number, updated_at: number }, custom_role?: { __typename?: 'CustomRole', id: string, name: string } | null, permissions?: Array<{ __typename?: 'ClinicAdminPermission', feature: AdminPermissionFeature, access_level: AdminPermissionAccessLevel }> | null }>, address?: { __typename?: 'Address', street_a?: string | null, street_b?: string | null, city?: string | null, state?: string | null, zip?: string | null, country?: string | null } | null, services: Array<{ __typename?: 'Service', id: string, name?: string | null }>, settings?: { __typename?: 'ClinicSettings', id?: string | null, does_require_verification?: boolean | null, does_use_automatic_reschedule?: boolean | null, reset_status_to_booked_on_reschedule?: boolean | null, is_using_detailed_services?: boolean | null, hide_review_step?: boolean | null, is_using_rooms?: boolean | null, pms_start_time?: any | null, pms_end_time?: any | null, primary_color?: string | null, accent_color?: string | null, secondary_color?: string | null, new_appt_requested_msg?: string | null, new_appt_approved_msg?: string | null, new_appt_approved_sms_msg?: string | null, new_appt_denied_msg?: string | null, schedule_method?: ScheduleMethod | null, scheduling_buffer_minutes?: number | null, base_schedule_duration?: number | null, does_require_referral?: boolean | null, appointment_entry_method?: AppointmentEntryMethod | null, scheduling_min_minutes_away?: number | null, scheduling_max_minutes_away?: number | null, included_species?: Array<Species> | null, max_patients_per_visit?: number | null, should_complete_sync?: boolean | null, server_syncing_only?: boolean | null, confirmation_days_before?: number | null, send_confirmations_to: SendConfirmationsTo, send_new_appt_email?: boolean | null, send_reviews_to?: SendConfirmationsTo | null, max_review_rating_for_notif?: number | null, google_review_link?: string | null, facebook_review_link?: string | null, non_blocking_services: Array<string>, yesterday_revenue?: number | null, this_month_revenue?: number | null, hide_clinician_preference: boolean, does_use_rooms_to_schedule?: boolean | null, primary_room_pms_id?: string | null, should_default_pims_emails_on: boolean, should_default_pims_sms_on: boolean, should_default_marketing_sms_on: boolean, should_default_marketing_email_on: boolean, does_use_clinicians_to_schedule?: boolean | null, time_slot_minutes: number, sync_interval_minutes: number, long_sync_interval_hours: number, primary_clinician_pms_id?: string | null, cancellation_clinician_pms_id?: string | null, cancellation_service_pms_id?: string | null, allow_first_appt_per_day?: boolean | null, custom_well_description?: string | null, custom_sick_description?: string | null, custom_other_title?: string | null, custom_other_description?: string | null, default_trigger_words?: Array<string> | null, should_use_private_reviews?: boolean | null, notify_clinic_on?: Array<NotifyClinicOn> | null, reminder_send_time_minutes?: number | null, does_require_new_client_address?: boolean | null, does_require_new_client_birthday?: boolean | null, should_allow_new_clients?: boolean | null, should_allow_new_patients?: boolean | null, should_create_clients?: boolean | null, should_create_patients?: boolean | null, msgs_auto_priority?: boolean | null, booking_match_procedure?: BookingMatchProcedure | null, urgency_type?: UrgencyType | null, max_booking_columns?: number | null, hide_closed_days_from_scheduling?: boolean | null, should_sync_reminders?: boolean | null, auto_reply_enabled: boolean, auto_reply_message?: string | null, unreplied_message_alert_enabled: boolean, unreplied_message_alert_minutes: number, comms_writeback_enabled: boolean, comms_should_daily_writeback: boolean, comms_use_pdf_for_writeback: boolean, comms_writeback_buffer_minutes: number, comms_writeback_before_appt_mins: number, comms_should_writeback_on_send: boolean, comms_should_writeback_on_receive: boolean, comms_should_writeback_notifs: boolean, comms_should_use_ai_writeback: boolean, form_writeback_enabled: boolean, should_award_loyalty_for_invoices?: boolean | null, invoice_loyalty_points_per_dollar?: number | null, app_download_loyalty_points?: number | null, referrer_loyalty_points?: number | null, referred_loyalty_points?: number | null, custom_appointment_notes_template?: string | null, custom_new_client_notes_template?: string | null, custom_new_patient_notes_template?: string | null, max_inactivity_duration?: number | null, hide_portal_vaccinations: boolean, hide_portal_reminders: boolean, hide_portal_prescriptions: boolean, hide_portal_weight: boolean, hide_soc_vaccinations?: boolean | null, hide_historic_vaccinations?: boolean | null, should_hide_daily_huddle_financials: boolean, patient_details_tab_order: Array<PortalPatientDetailsTab>, clinic_hours_display?: string | null, reschedule_buffer_minutes?: number | null, cancellation_buffer_minutes?: number | null, require_reason_for_cancellation?: boolean | null, should_automatically_assign_patient?: boolean | null, payment_writeback_enabled: boolean, auto_refund_on_cancel: boolean, status_set_on_payment_completed_pms_id?: string | null, max_booking_notes_length?: number | null, min_booking_notes_length?: number | null, primary_clinic_group_id?: string | null, should_suggest_nearby_clinics?: boolean | null, sms_block_list?: Array<string> | null, exclude_message_wrapper?: boolean | null, should_charge_client_stripe_fees?: boolean | null, chckvet_prescription_fee_split_percentage?: number | null, gtm_container_id?: string | null, review_google_id?: string | null, review_facebook_id?: string | null, only_use_adj_avail_guides: boolean, use_basic_timeslots: boolean, valid_booking_interval_minutes?: Array<number> | null, should_disable_online_scheduling?: boolean | null, simple_scheduling_rules_enabled: boolean, compliance_statuses?: Array<string> | null, should_use_instant_prescription_requests?: boolean | null, prescription_pickup_service_id?: string | null, default_reminder_service_id?: string | null, ai_calls_provider?: PhoneProviderType | null, ai_calls_phone_number?: string | null, ai_calls_voice_id?: string | null, ai_calls_agent_id?: string | null, ai_agent_style?: string | null, ai_agent_custom_instructions?: string | null, ai_calls_ambient_sound?: AiCallsAmbientSound | null, ai_calls_voice_speed?: number | null, ai_calls_interruption_sensitivity?: number | null, ai_calls_enable_dynamic_voice_speed?: boolean | null, usage_spending_caps?: any | null, custom_merge_tags?: any | null, custom_booking_copy?: { __typename?: 'ClinicBookingCopy', WIDGET_HEADER_TITLE?: string | null, SHOW_CLINIC_HEADER_LOGO?: boolean | null, CLINIC_HEADER_LOGO_HEIGHT?: number | null, SERVICE_TYPE_SECTION_HEADING?: string | null, DEFAULT_WELLNESS_DESCRIPTION?: string | null, DEFAULT_SICK_DESCRIPTION?: string | null, DEFAULT_OTHER_DESCRIPTION?: string | null, RETURNING_PATIENT_QUESTION?: string | null, POSITIVE_RETURNING_PATIENT_ANSWER?: string | null, NEGATIVE_RETURNING_PATIENT_ANSWER?: string | null, RETURNING_CLIENT_QUESTION?: string | null, POSITIVE_RETURNING_CLIENT_ANSWER?: string | null, NEGATIVE_RETURNING_CLIENT_ANSWER?: string | null, CLIENT_INFORMATION_SECTION_TITLE?: string | null, PATIENT_INFORMATION_SECTION_TITLE?: string | null, RETURNING_CLIENT_PATIENT_TITLE?: string | null, RETURNING_CLIENT_PATIENT_DESCRIPTION?: string | null, SERVICE_SECTION_TITLE?: string | null, PREPAID_SERVICES_LABEL?: string | null, STANDARD_SERVICES_LABEL?: string | null, DEPOSIT_FEE_NAME?: string | null, PREVIOUS_OR_REFERRING_CLINIC_QUESTION?: string | null, CONTACT_THE_CLINIC_TEXT?: string | null, CONTACT_THE_CLINIC_TEXT_COLOR?: string | null, CONTACT_THE_CLINIC_TEXT_SIZE?: string | null, SELECT_CLINICIAN_TITLE?: string | null, SELECT_CLINICIAN_POSITIVE_ANSWER?: string | null, SELECT_CLINICIAN_NEGATIVE_ANSWER?: string | null, SELECT_TIME_TITLE?: string | null, REVIEW_TITLE?: string | null, REVIEW_NOTES_PROMPT?: string | null, PAYMENT_INFORMATION_TITLE?: string | null, TRIGGER_WORDS_DETECTED_HEADER?: string | null, TRIGGER_WORDS_DETECTED_DESCRIPTION?: string | null, CONFIRMATION_SCREEN_TITLE?: string | null, CONFIRMATION_SCREEN_DESCRIPTION?: string | null, NEW_CLIENT_BLOCKED_MESSAGE?: string | null, NEW_PATIENT_BLOCKED_MESSAGE?: string | null } | null, auto_reply_hours?: { __typename?: 'AvailabilityHours', monday?: Array<{ __typename?: 'TimeInterval', start?: number | null, end?: number | null }> | null, tuesday?: Array<{ __typename?: 'TimeInterval', start?: number | null, end?: number | null }> | null, wednesday?: Array<{ __typename?: 'TimeInterval', start?: number | null, end?: number | null }> | null, thursday?: Array<{ __typename?: 'TimeInterval', start?: number | null, end?: number | null }> | null, friday?: Array<{ __typename?: 'TimeInterval', start?: number | null, end?: number | null }> | null, saturday?: Array<{ __typename?: 'TimeInterval', start?: number | null, end?: number | null }> | null, sunday?: Array<{ __typename?: 'TimeInterval', start?: number | null, end?: number | null }> | null } | null, portal_links?: Array<{ __typename?: 'PortalLink', label: string, url: string }> | null, custom_reviews_copy?: { __typename?: 'ClinicReviewsCopy', REVIEW_METHOD_PAGE_TITLE?: string | null, REVIEW_METHOD_PAGE_DESCRIPTION?: string | null, PRIVATE_REVIEW_BUTTON_HELP_TEXT?: string | null, PRIVATE_REVIEW_BUTTON_TEXT?: string | null, REVIEW_PAGE_TITLE?: string | null, REVIEW_PAGE_SUBTITLE?: string | null, REVIEW_SCORE_LABEL?: string | null, REVIEW_MESSAGE_LABEL?: string | null, REVIEW_SUBMIT_BUTTON_TEXT?: string | null } | null, waitlist_customer_segment?: { __typename?: 'CustomerSegment', id: string, name: string, trigger_entity?: CustomerSegmentTrigger | null, is_archived: boolean, updated_at: number, notification_templates?: Array<{ __typename?: 'NotificationTemplate', id: string, name: string, is_active: boolean, is_archived: boolean, message_methods: Array<MessageMethod> }> | null, error_flags?: Array<{ __typename?: 'CustomerSegmentErrorFlag', filter_column: string, filter_index: number, parameter_index: number, message: string }> | null, all_inclusions?: Array<{ __typename?: 'SegmentFilter', foreign_table?: string | null, group?: string | null, parameters: Array<{ __typename?: 'QueryFilter', column: string, filterOp: FilterOp, value: { __typename?: 'QueryFilterValue', string?: string | null, float?: number | null, boolean?: boolean | null, stringArray?: Array<string> | null, floatArray?: Array<number> | null, millisFromNow?: number | null, relativeTime?: { __typename?: 'RelativeTime', quantity: number, unit: TimeUnit, direction: ReferenceDirection } | null } }> }> | null, any_inclusions?: Array<{ __typename?: 'SegmentFilter', foreign_table?: string | null, group?: string | null, parameters: Array<{ __typename?: 'QueryFilter', column: string, filterOp: FilterOp, value: { __typename?: 'QueryFilterValue', string?: string | null, float?: number | null, boolean?: boolean | null, stringArray?: Array<string> | null, floatArray?: Array<number> | null, millisFromNow?: number | null, relativeTime?: { __typename?: 'RelativeTime', quantity: number, unit: TimeUnit, direction: ReferenceDirection } | null } }> }> | null, any_exclusions?: Array<{ __typename?: 'SegmentFilter', foreign_table?: string | null, group?: string | null, parameters: Array<{ __typename?: 'QueryFilter', column: string, filterOp: FilterOp, value: { __typename?: 'QueryFilterValue', string?: string | null, float?: number | null, boolean?: boolean | null, stringArray?: Array<string> | null, floatArray?: Array<number> | null, millisFromNow?: number | null, relativeTime?: { __typename?: 'RelativeTime', quantity: number, unit: TimeUnit, direction: ReferenceDirection } | null } }> }> | null, any_other_exclusions?: Array<{ __typename?: 'SegmentFilter', foreign_table?: string | null, group?: string | null, parameters: Array<{ __typename?: 'QueryFilter', column: string, filterOp: FilterOp, value: { __typename?: 'QueryFilterValue', string?: string | null, float?: number | null, boolean?: boolean | null, stringArray?: Array<string> | null, floatArray?: Array<number> | null, millisFromNow?: number | null, relativeTime?: { __typename?: 'RelativeTime', quantity: number, unit: TimeUnit, direction: ReferenceDirection } | null } }> }> | null, filters?: Array<{ __typename?: 'CustomerSegmentFilter', filters: Array<{ __typename?: 'QueryFilter', column: string, filterOp: FilterOp, value: { __typename?: 'QueryFilterValue', string?: string | null, float?: number | null, boolean?: boolean | null, stringArray?: Array<string> | null, floatArray?: Array<number> | null, millisFromNow?: number | null, relativeTime?: { __typename?: 'RelativeTime', quantity: number, unit: TimeUnit, direction: ReferenceDirection } | null } }> }> | null, excluded_filters: Array<{ __typename?: 'CustomerSegmentFilter', filters: Array<{ __typename?: 'QueryFilter', column: string, filterOp: FilterOp, value: { __typename?: 'QueryFilterValue', string?: string | null, float?: number | null, boolean?: boolean | null, stringArray?: Array<string> | null, floatArray?: Array<number> | null, millisFromNow?: number | null, relativeTime?: { __typename?: 'RelativeTime', quantity: number, unit: TimeUnit, direction: ReferenceDirection } | null } }> }> } | null, blocklist_customer_segment?: { __typename?: 'CustomerSegment', id: string, name: string, trigger_entity?: CustomerSegmentTrigger | null, is_archived: boolean, updated_at: number, notification_templates?: Array<{ __typename?: 'NotificationTemplate', id: string, name: string, is_active: boolean, is_archived: boolean, message_methods: Array<MessageMethod> }> | null, error_flags?: Array<{ __typename?: 'CustomerSegmentErrorFlag', filter_column: string, filter_index: number, parameter_index: number, message: string }> | null, all_inclusions?: Array<{ __typename?: 'SegmentFilter', foreign_table?: string | null, group?: string | null, parameters: Array<{ __typename?: 'QueryFilter', column: string, filterOp: FilterOp, value: { __typename?: 'QueryFilterValue', string?: string | null, float?: number | null, boolean?: boolean | null, stringArray?: Array<string> | null, floatArray?: Array<number> | null, millisFromNow?: number | null, relativeTime?: { __typename?: 'RelativeTime', quantity: number, unit: TimeUnit, direction: ReferenceDirection } | null } }> }> | null, any_inclusions?: Array<{ __typename?: 'SegmentFilter', foreign_table?: string | null, group?: string | null, parameters: Array<{ __typename?: 'QueryFilter', column: string, filterOp: FilterOp, value: { __typename?: 'QueryFilterValue', string?: string | null, float?: number | null, boolean?: boolean | null, stringArray?: Array<string> | null, floatArray?: Array<number> | null, millisFromNow?: number | null, relativeTime?: { __typename?: 'RelativeTime', quantity: number, unit: TimeUnit, direction: ReferenceDirection } | null } }> }> | null, any_exclusions?: Array<{ __typename?: 'SegmentFilter', foreign_table?: string | null, group?: string | null, parameters: Array<{ __typename?: 'QueryFilter', column: string, filterOp: FilterOp, value: { __typename?: 'QueryFilterValue', string?: string | null, float?: number | null, boolean?: boolean | null, stringArray?: Array<string> | null, floatArray?: Array<number> | null, millisFromNow?: number | null, relativeTime?: { __typename?: 'RelativeTime', quantity: number, unit: TimeUnit, direction: ReferenceDirection } | null } }> }> | null, any_other_exclusions?: Array<{ __typename?: 'SegmentFilter', foreign_table?: string | null, group?: string | null, parameters: Array<{ __typename?: 'QueryFilter', column: string, filterOp: FilterOp, value: { __typename?: 'QueryFilterValue', string?: string | null, float?: number | null, boolean?: boolean | null, stringArray?: Array<string> | null, floatArray?: Array<number> | null, millisFromNow?: number | null, relativeTime?: { __typename?: 'RelativeTime', quantity: number, unit: TimeUnit, direction: ReferenceDirection } | null } }> }> | null, filters?: Array<{ __typename?: 'CustomerSegmentFilter', filters: Array<{ __typename?: 'QueryFilter', column: string, filterOp: FilterOp, value: { __typename?: 'QueryFilterValue', string?: string | null, float?: number | null, boolean?: boolean | null, stringArray?: Array<string> | null, floatArray?: Array<number> | null, millisFromNow?: number | null, relativeTime?: { __typename?: 'RelativeTime', quantity: number, unit: TimeUnit, direction: ReferenceDirection } | null } }> }> | null, excluded_filters: Array<{ __typename?: 'CustomerSegmentFilter', filters: Array<{ __typename?: 'QueryFilter', column: string, filterOp: FilterOp, value: { __typename?: 'QueryFilterValue', string?: string | null, float?: number | null, boolean?: boolean | null, stringArray?: Array<string> | null, floatArray?: Array<number> | null, millisFromNow?: number | null, relativeTime?: { __typename?: 'RelativeTime', quantity: number, unit: TimeUnit, direction: ReferenceDirection } | null } }> }> } | null, referral_customer_segment?: { __typename?: 'CustomerSegment', id: string, name: string, trigger_entity?: CustomerSegmentTrigger | null, is_archived: boolean, updated_at: number, notification_templates?: Array<{ __typename?: 'NotificationTemplate', id: string, name: string, is_active: boolean, is_archived: boolean, message_methods: Array<MessageMethod> }> | null, error_flags?: Array<{ __typename?: 'CustomerSegmentErrorFlag', filter_column: string, filter_index: number, parameter_index: number, message: string }> | null, all_inclusions?: Array<{ __typename?: 'SegmentFilter', foreign_table?: string | null, group?: string | null, parameters: Array<{ __typename?: 'QueryFilter', column: string, filterOp: FilterOp, value: { __typename?: 'QueryFilterValue', string?: string | null, float?: number | null, boolean?: boolean | null, stringArray?: Array<string> | null, floatArray?: Array<number> | null, millisFromNow?: number | null, relativeTime?: { __typename?: 'RelativeTime', quantity: number, unit: TimeUnit, direction: ReferenceDirection } | null } }> }> | null, any_inclusions?: Array<{ __typename?: 'SegmentFilter', foreign_table?: string | null, group?: string | null, parameters: Array<{ __typename?: 'QueryFilter', column: string, filterOp: FilterOp, value: { __typename?: 'QueryFilterValue', string?: string | null, float?: number | null, boolean?: boolean | null, stringArray?: Array<string> | null, floatArray?: Array<number> | null, millisFromNow?: number | null, relativeTime?: { __typename?: 'RelativeTime', quantity: number, unit: TimeUnit, direction: ReferenceDirection } | null } }> }> | null, any_exclusions?: Array<{ __typename?: 'SegmentFilter', foreign_table?: string | null, group?: string | null, parameters: Array<{ __typename?: 'QueryFilter', column: string, filterOp: FilterOp, value: { __typename?: 'QueryFilterValue', string?: string | null, float?: number | null, boolean?: boolean | null, stringArray?: Array<string> | null, floatArray?: Array<number> | null, millisFromNow?: number | null, relativeTime?: { __typename?: 'RelativeTime', quantity: number, unit: TimeUnit, direction: ReferenceDirection } | null } }> }> | null, any_other_exclusions?: Array<{ __typename?: 'SegmentFilter', foreign_table?: string | null, group?: string | null, parameters: Array<{ __typename?: 'QueryFilter', column: string, filterOp: FilterOp, value: { __typename?: 'QueryFilterValue', string?: string | null, float?: number | null, boolean?: boolean | null, stringArray?: Array<string> | null, floatArray?: Array<number> | null, millisFromNow?: number | null, relativeTime?: { __typename?: 'RelativeTime', quantity: number, unit: TimeUnit, direction: ReferenceDirection } | null } }> }> | null, filters?: Array<{ __typename?: 'CustomerSegmentFilter', filters: Array<{ __typename?: 'QueryFilter', column: string, filterOp: FilterOp, value: { __typename?: 'QueryFilterValue', string?: string | null, float?: number | null, boolean?: boolean | null, stringArray?: Array<string> | null, floatArray?: Array<number> | null, millisFromNow?: number | null, relativeTime?: { __typename?: 'RelativeTime', quantity: number, unit: TimeUnit, direction: ReferenceDirection } | null } }> }> | null, excluded_filters: Array<{ __typename?: 'CustomerSegmentFilter', filters: Array<{ __typename?: 'QueryFilter', column: string, filterOp: FilterOp, value: { __typename?: 'QueryFilterValue', string?: string | null, float?: number | null, boolean?: boolean | null, stringArray?: Array<string> | null, floatArray?: Array<number> | null, millisFromNow?: number | null, relativeTime?: { __typename?: 'RelativeTime', quantity: number, unit: TimeUnit, direction: ReferenceDirection } | null } }> }> } | null, webhooks?: Array<{ __typename?: 'WebhookConfig', id: string, name: string, url: string, events: Array<WebhookEventType>, secret?: string | null, enabled: boolean }> | null, times_first_filter_config?: { __typename?: 'TimesFirstFilterConfig', service?: BookingFilterDisplayMode | null, clinician?: BookingFilterDisplayMode | null, species?: BookingFilterDisplayMode | null, client_status?: BookingFilterDisplayMode | null, patient_status?: BookingFilterDisplayMode | null, patient_gender?: BookingFilterDisplayMode | null, fixed_status?: BookingFilterDisplayMode | null } | null } | null, onboarding?: { __typename?: 'ClinicOnboarding', has_set_hours?: boolean | null, has_synced_pms?: boolean | null } | null, organization?: { __typename?: 'Organization', id: string } | null, features?: { __typename?: 'ClinicFeatures', scheduling_enabled?: boolean | null, huddle_enabled?: boolean | null, payments_enabled?: boolean | null, messaging_enabled?: boolean | null, reviews_enabled?: boolean | null, loyalty_enabled?: boolean | null, notifs_enabled?: boolean | null, forms_enabled?: boolean | null, help_enabled?: boolean | null, bulk_messaging_enabled?: boolean | null, portal_enabled?: boolean | null, calls_enabled?: boolean | null, teamchat_enabled?: boolean | null, prescriptions_enabled?: boolean | null, medical_history_enabled?: boolean | null, pet_selfies_enabled?: boolean | null } | null, hours?: { __typename?: 'AvailabilityHours', monday?: Array<{ __typename?: 'TimeInterval', start?: number | null, end?: number | null }> | null, tuesday?: Array<{ __typename?: 'TimeInterval', start?: number | null, end?: number | null }> | null, wednesday?: Array<{ __typename?: 'TimeInterval', start?: number | null, end?: number | null }> | null, thursday?: Array<{ __typename?: 'TimeInterval', start?: number | null, end?: number | null }> | null, friday?: Array<{ __typename?: 'TimeInterval', start?: number | null, end?: number | null }> | null, saturday?: Array<{ __typename?: 'TimeInterval', start?: number | null, end?: number | null }> | null, sunday?: Array<{ __typename?: 'TimeInterval', start?: number | null, end?: number | null }> | null } | null, clinic_hours?: { __typename?: 'AvailabilityHours', monday?: Array<{ __typename?: 'TimeInterval', start?: number | null, end?: number | null }> | null, tuesday?: Array<{ __typename?: 'TimeInterval', start?: number | null, end?: number | null }> | null, wednesday?: Array<{ __typename?: 'TimeInterval', start?: number | null, end?: number | null }> | null, thursday?: Array<{ __typename?: 'TimeInterval', start?: number | null, end?: number | null }> | null, friday?: Array<{ __typename?: 'TimeInterval', start?: number | null, end?: number | null }> | null, saturday?: Array<{ __typename?: 'TimeInterval', start?: number | null, end?: number | null }> | null, sunday?: Array<{ __typename?: 'TimeInterval', start?: number | null, end?: number | null }> | null } | null, adjusted_availability?: Array<{ __typename?: 'Availability', date: number, pms_appt_type_pms_id?: string | null, times: Array<{ __typename?: 'TimeInterval', start?: number | null, end?: number | null }>, repeat?: { __typename?: 'RepeatAvailability', daysOfMonth?: Array<number> | null, daysOfWeek?: Array<DayOfWeek> | null, weekOfMonth?: WeekOfMonth | null, frequency: any, unit: RepeatUnit, end_date?: number | null } | null }> | null, pms_adjusted_availability?: Array<{ __typename?: 'Availability', date: number, pms_appt_type_pms_id?: string | null, times: Array<{ __typename?: 'TimeInterval', start?: number | null, end?: number | null }>, repeat?: { __typename?: 'RepeatAvailability', daysOfMonth?: Array<number> | null, daysOfWeek?: Array<DayOfWeek> | null, weekOfMonth?: WeekOfMonth | null, frequency: any, unit: RepeatUnit, end_date?: number | null } | null }> | null, last_sync_times?: { __typename?: 'LastSyncTimes', last_full_sync?: number | null, last_sync_appointments?: number | null, last_sync_clients?: number | null, last_sync_patients?: number | null, last_sync_clinicians?: number | null, last_sync_services?: number | null, last_sync_transactions?: number | null, last_sync_invoices?: number | null, last_sync_history_items?: number | null, last_sync_diagnoses?: number | null, last_sync_prescriptions?: number | null, last_sync_products?: number | null, last_sync_rooms?: number | null, last_sync_species?: number | null, last_sync_breeds?: number | null, last_sync_reminders?: number | null, last_sync_reminder_types?: number | null, last_sync_vaccination_records?: number | null, last_sync_clinic_sexes?: number | null, last_sync_appt_statuses?: number | null, last_sync_blockoffs?: number | null, last_sync_invoice_items?: number | null } | null, pims_settings?: { __typename?: 'PimsSettings', ezyvet_integration_mode?: EzyvetIntegrationMode | null, entered_by_pms_id?: string | null } | null } };

export type GetSupportedPmsConnectorsQueryVariables = Exact<{
  pms: PracticeManagementSystem;
}>;


export type GetSupportedPmsConnectorsQuery = { __typename?: 'Query', supportedPmsConnectors: Array<PmsConnector> };

export type GetClientsForClinicQueryVariables = Exact<{
  clinicId: Scalars['ID']['input'];
  page?: InputMaybe<Scalars['NonNegativeInt']['input']>;
  pageSize?: InputMaybe<Scalars['NonNegativeInt']['input']>;
}>;


export type GetClientsForClinicQuery = { __typename?: 'Query', getClientsForClinic: Array<{ __typename?: 'Client', id: string, first_name?: string | null, last_name?: string | null, secondary_first_name?: string | null, secondary_last_name?: string | null, phone?: string | null, email?: string | null, pms?: PracticeManagementSystem | null, pms_id?: string | null, last_appt_time?: number | null, last_contact_time?: number | null, email_enabled: boolean, sms_enabled: boolean, balance?: number | null, is_active?: boolean | null, is_unsubscribed: boolean, created_at: number, updated_at: number, client_phones?: Array<{ __typename?: 'ClientPhone', id: string, phone: string, country_code?: string | null, is_primary: boolean, is_chckup_primary: boolean, is_mobile: boolean, sms_available: boolean, is_unsubscribed: boolean, is_active: boolean, name?: string | null }> | null, client_emails?: Array<{ __typename?: 'ClientEmail', id: string, email: string, is_primary: boolean }> | null, clinic?: { __typename?: 'Clinic', id: string } | null, patients?: Array<{ __typename?: 'Patient', id: string, pms?: PracticeManagementSystem | null, pms_id?: string | null, name?: string | null, breed?: string | null, avatar_url?: string | null, last_appt_time?: number | null, gender?: string | null, fixed_status?: FixedStatus | null, weight?: number | null, birthday?: number | null, is_active?: boolean | null, is_deceased?: boolean | null, pms_created_at?: number | null, created_at: number, updated_at: number, owner?: { __typename?: 'Client', id: string, first_name?: string | null, last_name?: string | null, email?: string | null, phone?: string | null, address?: { __typename?: 'Address', country?: string | null } | null } | null, clinic_species?: { __typename?: 'ClinicSpecies', id: string, pms_id: string, description: string, is_primary: boolean, species: Species, weight_key: string, created_at: number, updated_at: number } | null, clinic?: { __typename?: 'Clinic', id: string } | null, clinic_breed?: { __typename?: 'Breed', id: string, description: string } | null, patient_vaccination_records?: Array<{ __typename?: 'PatientVaccinationRecord', id: string, vaccine_name?: string | null, manufacturer?: string | null, lot_number?: string | null, administered_date?: number | null, due_date?: number | null, rabies_tag?: string | null, is_rabies_vaccine?: boolean | null, is_soc: boolean, is_active: boolean, product?: { __typename?: 'Product', id: string, display_name?: string | null, name: string } | null }> | null, last_appointment?: { __typename?: 'Appointment', clinician?: { __typename?: 'Clinician', name: string, display_name?: string | null } | null } | null }> | null, address?: { __typename?: 'Address', street_a?: string | null, street_b?: string | null, city?: string | null, state?: string | null, zip?: string | null, country?: string | null } | null, user?: { __typename?: 'User', avatar_url?: string | null } | null, loyalty_members?: Array<{ __typename?: 'LoyaltyMember', id: string, available_points: number } | null> | null, settings?: { __typename?: 'ClientSettings', clinic_chckup_notifications_enabled: boolean, clinic_chckup_sms_enabled: boolean, clinic_chckup_email_enabled: boolean, client_chckup_notifications_enabled: boolean, client_chckup_sms_enabled: boolean, client_chckup_email_enabled: boolean, is_unsubscribed_from_marketing: boolean, is_unsubscribed_from_marketing_sms: boolean, is_unsubscribed_from_marketing_email: boolean } | null, last_appointment?: { __typename?: 'Appointment', clinician?: { __typename?: 'Clinician', name: string, display_name?: string | null } | null } | null }> };

export type GetClientCountForClinicQueryVariables = Exact<{
  clinicId: Scalars['ID']['input'];
}>;


export type GetClientCountForClinicQuery = { __typename?: 'Query', getClientCountForClinic: number };

export type GetClinicsForUserAdminQueryVariables = Exact<{
  userId: Scalars['ID']['input'];
}>;


export type GetClinicsForUserAdminQuery = { __typename?: 'Query', getClinicsForUserAdmin: Array<{ __typename?: 'Clinic', id: string, slug?: string | null, name?: string | null, description?: string | null, email?: string | null, phone?: string | null, send_from_phone?: string | null, send_from_email?: string | null, reply_to_email?: string | null, website?: string | null, pms: PracticeManagementSystem, pms_connector: PmsConnector, pms_api_key?: string | null, pms_additional_key?: string | null, office_emails?: Array<string> | null, stripe_accounts_enabled?: Array<StripeAccountType> | null, stripe_account_type?: string | null, stripe_customer_id?: string | null, avatar_url?: string | null, go_live_date?: string | null, time_zone?: string | null, is_archived: boolean, location?: string | null, tmp_feature_flags?: any | null, mute_until?: number | null, created_at: number, updated_at: number, pms_db?: { __typename?: 'PmsDb', id: string, name: string, last_sync_times?: { __typename?: 'LastSyncTimes', last_full_sync?: number | null, last_sync_appointments?: number | null, last_sync_clients?: number | null, last_sync_patients?: number | null, last_sync_clinicians?: number | null, last_sync_services?: number | null, last_sync_transactions?: number | null, last_sync_invoices?: number | null, last_sync_history_items?: number | null, last_sync_diagnoses?: number | null, last_sync_prescriptions?: number | null, last_sync_products?: number | null, last_sync_rooms?: number | null, last_sync_species?: number | null, last_sync_breeds?: number | null, last_sync_reminders?: number | null, last_sync_reminder_types?: number | null, last_sync_vaccination_records?: number | null, last_sync_clinic_sexes?: number | null, last_sync_appt_statuses?: number | null, last_sync_blockoffs?: number | null, last_sync_invoice_items?: number | null } | null } | null, clinic_admins: Array<{ __typename?: 'ClinicAdmin', id: string, role: AuthRoles, are_email_notifications_enabled: boolean, are_sms_notifications_enabled: boolean, are_desktop_notifications_enabled: boolean, should_hide_daily_huddle_financials: boolean, created_at: number, updated_at: number, clinic: { __typename?: 'Clinic', id: string, name?: string | null, slug?: string | null, avatar_url?: string | null, is_verified?: boolean | null, is_archived: boolean, description?: string | null, pms: PracticeManagementSystem, time_zone?: string | null, last_sync_times?: { __typename?: 'LastSyncTimes', last_full_sync?: number | null } | null, clinic_admins: Array<{ __typename?: 'ClinicAdmin', id: string }>, organization?: { __typename?: 'Organization', id: string } | null, address?: { __typename?: 'Address', street_a?: string | null, street_b?: string | null, city?: string | null, state?: string | null, zip?: string | null, country?: string | null, lat?: number | null, lng?: number | null } | null }, user: { __typename?: 'User', id: string, first_name?: string | null, last_name?: string | null, email?: any | null, phone?: string | null, phone_country?: string | null, avatar_url?: string | null, role?: AuthRoles | null, enabled_notification_sounds?: Array<UserNotificationSound> | null, notify_email_on?: Array<NotifyClinicOn> | null, notify_sound_on?: Array<NotifyClinicOn> | null, notify_desktop_on?: Array<NotifyClinicOn> | null, must_reset_password?: boolean | null, invitation_status?: UserInvitationStatus | null, invited_at?: number | null, created_at: number, updated_at: number }, custom_role?: { __typename?: 'CustomRole', id: string, name: string } | null, permissions?: Array<{ __typename?: 'ClinicAdminPermission', feature: AdminPermissionFeature, access_level: AdminPermissionAccessLevel }> | null }>, address?: { __typename?: 'Address', street_a?: string | null, street_b?: string | null, city?: string | null, state?: string | null, zip?: string | null, country?: string | null } | null, services: Array<{ __typename?: 'Service', id: string, name?: string | null }>, settings?: { __typename?: 'ClinicSettings', id?: string | null, does_require_verification?: boolean | null, does_use_automatic_reschedule?: boolean | null, reset_status_to_booked_on_reschedule?: boolean | null, is_using_detailed_services?: boolean | null, hide_review_step?: boolean | null, is_using_rooms?: boolean | null, pms_start_time?: any | null, pms_end_time?: any | null, primary_color?: string | null, accent_color?: string | null, secondary_color?: string | null, new_appt_requested_msg?: string | null, new_appt_approved_msg?: string | null, new_appt_approved_sms_msg?: string | null, new_appt_denied_msg?: string | null, schedule_method?: ScheduleMethod | null, scheduling_buffer_minutes?: number | null, base_schedule_duration?: number | null, does_require_referral?: boolean | null, appointment_entry_method?: AppointmentEntryMethod | null, scheduling_min_minutes_away?: number | null, scheduling_max_minutes_away?: number | null, included_species?: Array<Species> | null, max_patients_per_visit?: number | null, should_complete_sync?: boolean | null, server_syncing_only?: boolean | null, confirmation_days_before?: number | null, send_confirmations_to: SendConfirmationsTo, send_new_appt_email?: boolean | null, send_reviews_to?: SendConfirmationsTo | null, max_review_rating_for_notif?: number | null, google_review_link?: string | null, facebook_review_link?: string | null, non_blocking_services: Array<string>, yesterday_revenue?: number | null, this_month_revenue?: number | null, hide_clinician_preference: boolean, does_use_rooms_to_schedule?: boolean | null, primary_room_pms_id?: string | null, should_default_pims_emails_on: boolean, should_default_pims_sms_on: boolean, should_default_marketing_sms_on: boolean, should_default_marketing_email_on: boolean, does_use_clinicians_to_schedule?: boolean | null, time_slot_minutes: number, sync_interval_minutes: number, long_sync_interval_hours: number, primary_clinician_pms_id?: string | null, cancellation_clinician_pms_id?: string | null, cancellation_service_pms_id?: string | null, allow_first_appt_per_day?: boolean | null, custom_well_description?: string | null, custom_sick_description?: string | null, custom_other_title?: string | null, custom_other_description?: string | null, default_trigger_words?: Array<string> | null, should_use_private_reviews?: boolean | null, notify_clinic_on?: Array<NotifyClinicOn> | null, reminder_send_time_minutes?: number | null, does_require_new_client_address?: boolean | null, does_require_new_client_birthday?: boolean | null, should_allow_new_clients?: boolean | null, should_allow_new_patients?: boolean | null, should_create_clients?: boolean | null, should_create_patients?: boolean | null, msgs_auto_priority?: boolean | null, booking_match_procedure?: BookingMatchProcedure | null, urgency_type?: UrgencyType | null, max_booking_columns?: number | null, hide_closed_days_from_scheduling?: boolean | null, should_sync_reminders?: boolean | null, auto_reply_enabled: boolean, auto_reply_message?: string | null, unreplied_message_alert_enabled: boolean, unreplied_message_alert_minutes: number, comms_writeback_enabled: boolean, comms_should_daily_writeback: boolean, comms_use_pdf_for_writeback: boolean, comms_writeback_buffer_minutes: number, comms_writeback_before_appt_mins: number, comms_should_writeback_on_send: boolean, comms_should_writeback_on_receive: boolean, comms_should_writeback_notifs: boolean, comms_should_use_ai_writeback: boolean, form_writeback_enabled: boolean, should_award_loyalty_for_invoices?: boolean | null, invoice_loyalty_points_per_dollar?: number | null, app_download_loyalty_points?: number | null, referrer_loyalty_points?: number | null, referred_loyalty_points?: number | null, custom_appointment_notes_template?: string | null, custom_new_client_notes_template?: string | null, custom_new_patient_notes_template?: string | null, max_inactivity_duration?: number | null, hide_portal_vaccinations: boolean, hide_portal_reminders: boolean, hide_portal_prescriptions: boolean, hide_portal_weight: boolean, hide_soc_vaccinations?: boolean | null, hide_historic_vaccinations?: boolean | null, should_hide_daily_huddle_financials: boolean, patient_details_tab_order: Array<PortalPatientDetailsTab>, clinic_hours_display?: string | null, reschedule_buffer_minutes?: number | null, cancellation_buffer_minutes?: number | null, require_reason_for_cancellation?: boolean | null, should_automatically_assign_patient?: boolean | null, payment_writeback_enabled: boolean, auto_refund_on_cancel: boolean, status_set_on_payment_completed_pms_id?: string | null, max_booking_notes_length?: number | null, min_booking_notes_length?: number | null, primary_clinic_group_id?: string | null, should_suggest_nearby_clinics?: boolean | null, sms_block_list?: Array<string> | null, exclude_message_wrapper?: boolean | null, should_charge_client_stripe_fees?: boolean | null, chckvet_prescription_fee_split_percentage?: number | null, gtm_container_id?: string | null, review_google_id?: string | null, review_facebook_id?: string | null, only_use_adj_avail_guides: boolean, use_basic_timeslots: boolean, valid_booking_interval_minutes?: Array<number> | null, should_disable_online_scheduling?: boolean | null, simple_scheduling_rules_enabled: boolean, compliance_statuses?: Array<string> | null, should_use_instant_prescription_requests?: boolean | null, prescription_pickup_service_id?: string | null, default_reminder_service_id?: string | null, ai_calls_provider?: PhoneProviderType | null, ai_calls_phone_number?: string | null, ai_calls_voice_id?: string | null, ai_calls_agent_id?: string | null, ai_agent_style?: string | null, ai_agent_custom_instructions?: string | null, ai_calls_ambient_sound?: AiCallsAmbientSound | null, ai_calls_voice_speed?: number | null, ai_calls_interruption_sensitivity?: number | null, ai_calls_enable_dynamic_voice_speed?: boolean | null, usage_spending_caps?: any | null, custom_merge_tags?: any | null, custom_booking_copy?: { __typename?: 'ClinicBookingCopy', WIDGET_HEADER_TITLE?: string | null, SHOW_CLINIC_HEADER_LOGO?: boolean | null, CLINIC_HEADER_LOGO_HEIGHT?: number | null, SERVICE_TYPE_SECTION_HEADING?: string | null, DEFAULT_WELLNESS_DESCRIPTION?: string | null, DEFAULT_SICK_DESCRIPTION?: string | null, DEFAULT_OTHER_DESCRIPTION?: string | null, RETURNING_PATIENT_QUESTION?: string | null, POSITIVE_RETURNING_PATIENT_ANSWER?: string | null, NEGATIVE_RETURNING_PATIENT_ANSWER?: string | null, RETURNING_CLIENT_QUESTION?: string | null, POSITIVE_RETURNING_CLIENT_ANSWER?: string | null, NEGATIVE_RETURNING_CLIENT_ANSWER?: string | null, CLIENT_INFORMATION_SECTION_TITLE?: string | null, PATIENT_INFORMATION_SECTION_TITLE?: string | null, RETURNING_CLIENT_PATIENT_TITLE?: string | null, RETURNING_CLIENT_PATIENT_DESCRIPTION?: string | null, SERVICE_SECTION_TITLE?: string | null, PREPAID_SERVICES_LABEL?: string | null, STANDARD_SERVICES_LABEL?: string | null, DEPOSIT_FEE_NAME?: string | null, PREVIOUS_OR_REFERRING_CLINIC_QUESTION?: string | null, CONTACT_THE_CLINIC_TEXT?: string | null, CONTACT_THE_CLINIC_TEXT_COLOR?: string | null, CONTACT_THE_CLINIC_TEXT_SIZE?: string | null, SELECT_CLINICIAN_TITLE?: string | null, SELECT_CLINICIAN_POSITIVE_ANSWER?: string | null, SELECT_CLINICIAN_NEGATIVE_ANSWER?: string | null, SELECT_TIME_TITLE?: string | null, REVIEW_TITLE?: string | null, REVIEW_NOTES_PROMPT?: string | null, PAYMENT_INFORMATION_TITLE?: string | null, TRIGGER_WORDS_DETECTED_HEADER?: string | null, TRIGGER_WORDS_DETECTED_DESCRIPTION?: string | null, CONFIRMATION_SCREEN_TITLE?: string | null, CONFIRMATION_SCREEN_DESCRIPTION?: string | null, NEW_CLIENT_BLOCKED_MESSAGE?: string | null, NEW_PATIENT_BLOCKED_MESSAGE?: string | null } | null, auto_reply_hours?: { __typename?: 'AvailabilityHours', monday?: Array<{ __typename?: 'TimeInterval', start?: number | null, end?: number | null }> | null, tuesday?: Array<{ __typename?: 'TimeInterval', start?: number | null, end?: number | null }> | null, wednesday?: Array<{ __typename?: 'TimeInterval', start?: number | null, end?: number | null }> | null, thursday?: Array<{ __typename?: 'TimeInterval', start?: number | null, end?: number | null }> | null, friday?: Array<{ __typename?: 'TimeInterval', start?: number | null, end?: number | null }> | null, saturday?: Array<{ __typename?: 'TimeInterval', start?: number | null, end?: number | null }> | null, sunday?: Array<{ __typename?: 'TimeInterval', start?: number | null, end?: number | null }> | null } | null, portal_links?: Array<{ __typename?: 'PortalLink', label: string, url: string }> | null, custom_reviews_copy?: { __typename?: 'ClinicReviewsCopy', REVIEW_METHOD_PAGE_TITLE?: string | null, REVIEW_METHOD_PAGE_DESCRIPTION?: string | null, PRIVATE_REVIEW_BUTTON_HELP_TEXT?: string | null, PRIVATE_REVIEW_BUTTON_TEXT?: string | null, REVIEW_PAGE_TITLE?: string | null, REVIEW_PAGE_SUBTITLE?: string | null, REVIEW_SCORE_LABEL?: string | null, REVIEW_MESSAGE_LABEL?: string | null, REVIEW_SUBMIT_BUTTON_TEXT?: string | null } | null, waitlist_customer_segment?: { __typename?: 'CustomerSegment', id: string, name: string, trigger_entity?: CustomerSegmentTrigger | null, is_archived: boolean, updated_at: number, notification_templates?: Array<{ __typename?: 'NotificationTemplate', id: string, name: string, is_active: boolean, is_archived: boolean, message_methods: Array<MessageMethod> }> | null, error_flags?: Array<{ __typename?: 'CustomerSegmentErrorFlag', filter_column: string, filter_index: number, parameter_index: number, message: string }> | null, all_inclusions?: Array<{ __typename?: 'SegmentFilter', foreign_table?: string | null, group?: string | null, parameters: Array<{ __typename?: 'QueryFilter', column: string, filterOp: FilterOp, value: { __typename?: 'QueryFilterValue', string?: string | null, float?: number | null, boolean?: boolean | null, stringArray?: Array<string> | null, floatArray?: Array<number> | null, millisFromNow?: number | null, relativeTime?: { __typename?: 'RelativeTime', quantity: number, unit: TimeUnit, direction: ReferenceDirection } | null } }> }> | null, any_inclusions?: Array<{ __typename?: 'SegmentFilter', foreign_table?: string | null, group?: string | null, parameters: Array<{ __typename?: 'QueryFilter', column: string, filterOp: FilterOp, value: { __typename?: 'QueryFilterValue', string?: string | null, float?: number | null, boolean?: boolean | null, stringArray?: Array<string> | null, floatArray?: Array<number> | null, millisFromNow?: number | null, relativeTime?: { __typename?: 'RelativeTime', quantity: number, unit: TimeUnit, direction: ReferenceDirection } | null } }> }> | null, any_exclusions?: Array<{ __typename?: 'SegmentFilter', foreign_table?: string | null, group?: string | null, parameters: Array<{ __typename?: 'QueryFilter', column: string, filterOp: FilterOp, value: { __typename?: 'QueryFilterValue', string?: string | null, float?: number | null, boolean?: boolean | null, stringArray?: Array<string> | null, floatArray?: Array<number> | null, millisFromNow?: number | null, relativeTime?: { __typename?: 'RelativeTime', quantity: number, unit: TimeUnit, direction: ReferenceDirection } | null } }> }> | null, any_other_exclusions?: Array<{ __typename?: 'SegmentFilter', foreign_table?: string | null, group?: string | null, parameters: Array<{ __typename?: 'QueryFilter', column: string, filterOp: FilterOp, value: { __typename?: 'QueryFilterValue', string?: string | null, float?: number | null, boolean?: boolean | null, stringArray?: Array<string> | null, floatArray?: Array<number> | null, millisFromNow?: number | null, relativeTime?: { __typename?: 'RelativeTime', quantity: number, unit: TimeUnit, direction: ReferenceDirection } | null } }> }> | null, filters?: Array<{ __typename?: 'CustomerSegmentFilter', filters: Array<{ __typename?: 'QueryFilter', column: string, filterOp: FilterOp, value: { __typename?: 'QueryFilterValue', string?: string | null, float?: number | null, boolean?: boolean | null, stringArray?: Array<string> | null, floatArray?: Array<number> | null, millisFromNow?: number | null, relativeTime?: { __typename?: 'RelativeTime', quantity: number, unit: TimeUnit, direction: ReferenceDirection } | null } }> }> | null, excluded_filters: Array<{ __typename?: 'CustomerSegmentFilter', filters: Array<{ __typename?: 'QueryFilter', column: string, filterOp: FilterOp, value: { __typename?: 'QueryFilterValue', string?: string | null, float?: number | null, boolean?: boolean | null, stringArray?: Array<string> | null, floatArray?: Array<number> | null, millisFromNow?: number | null, relativeTime?: { __typename?: 'RelativeTime', quantity: number, unit: TimeUnit, direction: ReferenceDirection } | null } }> }> } | null, blocklist_customer_segment?: { __typename?: 'CustomerSegment', id: string, name: string, trigger_entity?: CustomerSegmentTrigger | null, is_archived: boolean, updated_at: number, notification_templates?: Array<{ __typename?: 'NotificationTemplate', id: string, name: string, is_active: boolean, is_archived: boolean, message_methods: Array<MessageMethod> }> | null, error_flags?: Array<{ __typename?: 'CustomerSegmentErrorFlag', filter_column: string, filter_index: number, parameter_index: number, message: string }> | null, all_inclusions?: Array<{ __typename?: 'SegmentFilter', foreign_table?: string | null, group?: string | null, parameters: Array<{ __typename?: 'QueryFilter', column: string, filterOp: FilterOp, value: { __typename?: 'QueryFilterValue', string?: string | null, float?: number | null, boolean?: boolean | null, stringArray?: Array<string> | null, floatArray?: Array<number> | null, millisFromNow?: number | null, relativeTime?: { __typename?: 'RelativeTime', quantity: number, unit: TimeUnit, direction: ReferenceDirection } | null } }> }> | null, any_inclusions?: Array<{ __typename?: 'SegmentFilter', foreign_table?: string | null, group?: string | null, parameters: Array<{ __typename?: 'QueryFilter', column: string, filterOp: FilterOp, value: { __typename?: 'QueryFilterValue', string?: string | null, float?: number | null, boolean?: boolean | null, stringArray?: Array<string> | null, floatArray?: Array<number> | null, millisFromNow?: number | null, relativeTime?: { __typename?: 'RelativeTime', quantity: number, unit: TimeUnit, direction: ReferenceDirection } | null } }> }> | null, any_exclusions?: Array<{ __typename?: 'SegmentFilter', foreign_table?: string | null, group?: string | null, parameters: Array<{ __typename?: 'QueryFilter', column: string, filterOp: FilterOp, value: { __typename?: 'QueryFilterValue', string?: string | null, float?: number | null, boolean?: boolean | null, stringArray?: Array<string> | null, floatArray?: Array<number> | null, millisFromNow?: number | null, relativeTime?: { __typename?: 'RelativeTime', quantity: number, unit: TimeUnit, direction: ReferenceDirection } | null } }> }> | null, any_other_exclusions?: Array<{ __typename?: 'SegmentFilter', foreign_table?: string | null, group?: string | null, parameters: Array<{ __typename?: 'QueryFilter', column: string, filterOp: FilterOp, value: { __typename?: 'QueryFilterValue', string?: string | null, float?: number | null, boolean?: boolean | null, stringArray?: Array<string> | null, floatArray?: Array<number> | null, millisFromNow?: number | null, relativeTime?: { __typename?: 'RelativeTime', quantity: number, unit: TimeUnit, direction: ReferenceDirection } | null } }> }> | null, filters?: Array<{ __typename?: 'CustomerSegmentFilter', filters: Array<{ __typename?: 'QueryFilter', column: string, filterOp: FilterOp, value: { __typename?: 'QueryFilterValue', string?: string | null, float?: number | null, boolean?: boolean | null, stringArray?: Array<string> | null, floatArray?: Array<number> | null, millisFromNow?: number | null, relativeTime?: { __typename?: 'RelativeTime', quantity: number, unit: TimeUnit, direction: ReferenceDirection } | null } }> }> | null, excluded_filters: Array<{ __typename?: 'CustomerSegmentFilter', filters: Array<{ __typename?: 'QueryFilter', column: string, filterOp: FilterOp, value: { __typename?: 'QueryFilterValue', string?: string | null, float?: number | null, boolean?: boolean | null, stringArray?: Array<string> | null, floatArray?: Array<number> | null, millisFromNow?: number | null, relativeTime?: { __typename?: 'RelativeTime', quantity: number, unit: TimeUnit, direction: ReferenceDirection } | null } }> }> } | null, referral_customer_segment?: { __typename?: 'CustomerSegment', id: string, name: string, trigger_entity?: CustomerSegmentTrigger | null, is_archived: boolean, updated_at: number, notification_templates?: Array<{ __typename?: 'NotificationTemplate', id: string, name: string, is_active: boolean, is_archived: boolean, message_methods: Array<MessageMethod> }> | null, error_flags?: Array<{ __typename?: 'CustomerSegmentErrorFlag', filter_column: string, filter_index: number, parameter_index: number, message: string }> | null, all_inclusions?: Array<{ __typename?: 'SegmentFilter', foreign_table?: string | null, group?: string | null, parameters: Array<{ __typename?: 'QueryFilter', column: string, filterOp: FilterOp, value: { __typename?: 'QueryFilterValue', string?: string | null, float?: number | null, boolean?: boolean | null, stringArray?: Array<string> | null, floatArray?: Array<number> | null, millisFromNow?: number | null, relativeTime?: { __typename?: 'RelativeTime', quantity: number, unit: TimeUnit, direction: ReferenceDirection } | null } }> }> | null, any_inclusions?: Array<{ __typename?: 'SegmentFilter', foreign_table?: string | null, group?: string | null, parameters: Array<{ __typename?: 'QueryFilter', column: string, filterOp: FilterOp, value: { __typename?: 'QueryFilterValue', string?: string | null, float?: number | null, boolean?: boolean | null, stringArray?: Array<string> | null, floatArray?: Array<number> | null, millisFromNow?: number | null, relativeTime?: { __typename?: 'RelativeTime', quantity: number, unit: TimeUnit, direction: ReferenceDirection } | null } }> }> | null, any_exclusions?: Array<{ __typename?: 'SegmentFilter', foreign_table?: string | null, group?: string | null, parameters: Array<{ __typename?: 'QueryFilter', column: string, filterOp: FilterOp, value: { __typename?: 'QueryFilterValue', string?: string | null, float?: number | null, boolean?: boolean | null, stringArray?: Array<string> | null, floatArray?: Array<number> | null, millisFromNow?: number | null, relativeTime?: { __typename?: 'RelativeTime', quantity: number, unit: TimeUnit, direction: ReferenceDirection } | null } }> }> | null, any_other_exclusions?: Array<{ __typename?: 'SegmentFilter', foreign_table?: string | null, group?: string | null, parameters: Array<{ __typename?: 'QueryFilter', column: string, filterOp: FilterOp, value: { __typename?: 'QueryFilterValue', string?: string | null, float?: number | null, boolean?: boolean | null, stringArray?: Array<string> | null, floatArray?: Array<number> | null, millisFromNow?: number | null, relativeTime?: { __typename?: 'RelativeTime', quantity: number, unit: TimeUnit, direction: ReferenceDirection } | null } }> }> | null, filters?: Array<{ __typename?: 'CustomerSegmentFilter', filters: Array<{ __typename?: 'QueryFilter', column: string, filterOp: FilterOp, value: { __typename?: 'QueryFilterValue', string?: string | null, float?: number | null, boolean?: boolean | null, stringArray?: Array<string> | null, floatArray?: Array<number> | null, millisFromNow?: number | null, relativeTime?: { __typename?: 'RelativeTime', quantity: number, unit: TimeUnit, direction: ReferenceDirection } | null } }> }> | null, excluded_filters: Array<{ __typename?: 'CustomerSegmentFilter', filters: Array<{ __typename?: 'QueryFilter', column: string, filterOp: FilterOp, value: { __typename?: 'QueryFilterValue', string?: string | null, float?: number | null, boolean?: boolean | null, stringArray?: Array<string> | null, floatArray?: Array<number> | null, millisFromNow?: number | null, relativeTime?: { __typename?: 'RelativeTime', quantity: number, unit: TimeUnit, direction: ReferenceDirection } | null } }> }> } | null, webhooks?: Array<{ __typename?: 'WebhookConfig', id: string, name: string, url: string, events: Array<WebhookEventType>, secret?: string | null, enabled: boolean }> | null, times_first_filter_config?: { __typename?: 'TimesFirstFilterConfig', service?: BookingFilterDisplayMode | null, clinician?: BookingFilterDisplayMode | null, species?: BookingFilterDisplayMode | null, client_status?: BookingFilterDisplayMode | null, patient_status?: BookingFilterDisplayMode | null, patient_gender?: BookingFilterDisplayMode | null, fixed_status?: BookingFilterDisplayMode | null } | null } | null, onboarding?: { __typename?: 'ClinicOnboarding', has_set_hours?: boolean | null, has_synced_pms?: boolean | null } | null, organization?: { __typename?: 'Organization', id: string } | null, features?: { __typename?: 'ClinicFeatures', scheduling_enabled?: boolean | null, huddle_enabled?: boolean | null, payments_enabled?: boolean | null, messaging_enabled?: boolean | null, reviews_enabled?: boolean | null, loyalty_enabled?: boolean | null, notifs_enabled?: boolean | null, forms_enabled?: boolean | null, help_enabled?: boolean | null, bulk_messaging_enabled?: boolean | null, portal_enabled?: boolean | null, calls_enabled?: boolean | null, teamchat_enabled?: boolean | null, prescriptions_enabled?: boolean | null, medical_history_enabled?: boolean | null, pet_selfies_enabled?: boolean | null } | null, hours?: { __typename?: 'AvailabilityHours', monday?: Array<{ __typename?: 'TimeInterval', start?: number | null, end?: number | null }> | null, tuesday?: Array<{ __typename?: 'TimeInterval', start?: number | null, end?: number | null }> | null, wednesday?: Array<{ __typename?: 'TimeInterval', start?: number | null, end?: number | null }> | null, thursday?: Array<{ __typename?: 'TimeInterval', start?: number | null, end?: number | null }> | null, friday?: Array<{ __typename?: 'TimeInterval', start?: number | null, end?: number | null }> | null, saturday?: Array<{ __typename?: 'TimeInterval', start?: number | null, end?: number | null }> | null, sunday?: Array<{ __typename?: 'TimeInterval', start?: number | null, end?: number | null }> | null } | null, clinic_hours?: { __typename?: 'AvailabilityHours', monday?: Array<{ __typename?: 'TimeInterval', start?: number | null, end?: number | null }> | null, tuesday?: Array<{ __typename?: 'TimeInterval', start?: number | null, end?: number | null }> | null, wednesday?: Array<{ __typename?: 'TimeInterval', start?: number | null, end?: number | null }> | null, thursday?: Array<{ __typename?: 'TimeInterval', start?: number | null, end?: number | null }> | null, friday?: Array<{ __typename?: 'TimeInterval', start?: number | null, end?: number | null }> | null, saturday?: Array<{ __typename?: 'TimeInterval', start?: number | null, end?: number | null }> | null, sunday?: Array<{ __typename?: 'TimeInterval', start?: number | null, end?: number | null }> | null } | null, adjusted_availability?: Array<{ __typename?: 'Availability', date: number, pms_appt_type_pms_id?: string | null, times: Array<{ __typename?: 'TimeInterval', start?: number | null, end?: number | null }>, repeat?: { __typename?: 'RepeatAvailability', daysOfMonth?: Array<number> | null, daysOfWeek?: Array<DayOfWeek> | null, weekOfMonth?: WeekOfMonth | null, frequency: any, unit: RepeatUnit, end_date?: number | null } | null }> | null, pms_adjusted_availability?: Array<{ __typename?: 'Availability', date: number, pms_appt_type_pms_id?: string | null, times: Array<{ __typename?: 'TimeInterval', start?: number | null, end?: number | null }>, repeat?: { __typename?: 'RepeatAvailability', daysOfMonth?: Array<number> | null, daysOfWeek?: Array<DayOfWeek> | null, weekOfMonth?: WeekOfMonth | null, frequency: any, unit: RepeatUnit, end_date?: number | null } | null }> | null, last_sync_times?: { __typename?: 'LastSyncTimes', last_full_sync?: number | null, last_sync_appointments?: number | null, last_sync_clients?: number | null, last_sync_patients?: number | null, last_sync_clinicians?: number | null, last_sync_services?: number | null, last_sync_transactions?: number | null, last_sync_invoices?: number | null, last_sync_history_items?: number | null, last_sync_diagnoses?: number | null, last_sync_prescriptions?: number | null, last_sync_products?: number | null, last_sync_rooms?: number | null, last_sync_species?: number | null, last_sync_breeds?: number | null, last_sync_reminders?: number | null, last_sync_reminder_types?: number | null, last_sync_vaccination_records?: number | null, last_sync_clinic_sexes?: number | null, last_sync_appt_statuses?: number | null, last_sync_blockoffs?: number | null, last_sync_invoice_items?: number | null } | null, pims_settings?: { __typename?: 'PimsSettings', ezyvet_integration_mode?: EzyvetIntegrationMode | null, entered_by_pms_id?: string | null } | null }> };

export type CountClinicsForUserAdminQueryVariables = Exact<{
  userId: Scalars['ID']['input'];
}>;


export type CountClinicsForUserAdminQuery = { __typename?: 'Query', countClinicsForUserAdmin: number };

export type QueryClinicsQueryVariables = Exact<{
  where?: InputMaybe<Array<QueryInput> | QueryInput>;
  page?: InputMaybe<Scalars['NonNegativeInt']['input']>;
  pageSize?: InputMaybe<Scalars['NonNegativeInt']['input']>;
  orderBy?: InputMaybe<OrderByInput>;
}>;


export type QueryClinicsQuery = { __typename?: 'Query', queryClinics: Array<{ __typename?: 'Clinic', id: string, slug?: string | null, name?: string | null, description?: string | null, email?: string | null, phone?: string | null, send_from_phone?: string | null, send_from_email?: string | null, reply_to_email?: string | null, website?: string | null, pms: PracticeManagementSystem, pms_connector: PmsConnector, pms_api_key?: string | null, pms_additional_key?: string | null, office_emails?: Array<string> | null, stripe_accounts_enabled?: Array<StripeAccountType> | null, stripe_account_type?: string | null, stripe_customer_id?: string | null, avatar_url?: string | null, go_live_date?: string | null, time_zone?: string | null, is_archived: boolean, location?: string | null, tmp_feature_flags?: any | null, mute_until?: number | null, created_at: number, updated_at: number, pms_db?: { __typename?: 'PmsDb', id: string, name: string, last_sync_times?: { __typename?: 'LastSyncTimes', last_full_sync?: number | null, last_sync_appointments?: number | null, last_sync_clients?: number | null, last_sync_patients?: number | null, last_sync_clinicians?: number | null, last_sync_services?: number | null, last_sync_transactions?: number | null, last_sync_invoices?: number | null, last_sync_history_items?: number | null, last_sync_diagnoses?: number | null, last_sync_prescriptions?: number | null, last_sync_products?: number | null, last_sync_rooms?: number | null, last_sync_species?: number | null, last_sync_breeds?: number | null, last_sync_reminders?: number | null, last_sync_reminder_types?: number | null, last_sync_vaccination_records?: number | null, last_sync_clinic_sexes?: number | null, last_sync_appt_statuses?: number | null, last_sync_blockoffs?: number | null, last_sync_invoice_items?: number | null } | null } | null, clinic_admins: Array<{ __typename?: 'ClinicAdmin', id: string, role: AuthRoles, are_email_notifications_enabled: boolean, are_sms_notifications_enabled: boolean, are_desktop_notifications_enabled: boolean, should_hide_daily_huddle_financials: boolean, created_at: number, updated_at: number, clinic: { __typename?: 'Clinic', id: string, name?: string | null, slug?: string | null, avatar_url?: string | null, is_verified?: boolean | null, is_archived: boolean, description?: string | null, pms: PracticeManagementSystem, time_zone?: string | null, last_sync_times?: { __typename?: 'LastSyncTimes', last_full_sync?: number | null } | null, clinic_admins: Array<{ __typename?: 'ClinicAdmin', id: string }>, organization?: { __typename?: 'Organization', id: string } | null, address?: { __typename?: 'Address', street_a?: string | null, street_b?: string | null, city?: string | null, state?: string | null, zip?: string | null, country?: string | null, lat?: number | null, lng?: number | null } | null }, user: { __typename?: 'User', id: string, first_name?: string | null, last_name?: string | null, email?: any | null, phone?: string | null, phone_country?: string | null, avatar_url?: string | null, role?: AuthRoles | null, enabled_notification_sounds?: Array<UserNotificationSound> | null, notify_email_on?: Array<NotifyClinicOn> | null, notify_sound_on?: Array<NotifyClinicOn> | null, notify_desktop_on?: Array<NotifyClinicOn> | null, must_reset_password?: boolean | null, invitation_status?: UserInvitationStatus | null, invited_at?: number | null, created_at: number, updated_at: number }, custom_role?: { __typename?: 'CustomRole', id: string, name: string } | null, permissions?: Array<{ __typename?: 'ClinicAdminPermission', feature: AdminPermissionFeature, access_level: AdminPermissionAccessLevel }> | null }>, address?: { __typename?: 'Address', street_a?: string | null, street_b?: string | null, city?: string | null, state?: string | null, zip?: string | null, country?: string | null } | null, services: Array<{ __typename?: 'Service', id: string, name?: string | null }>, settings?: { __typename?: 'ClinicSettings', id?: string | null, does_require_verification?: boolean | null, does_use_automatic_reschedule?: boolean | null, reset_status_to_booked_on_reschedule?: boolean | null, is_using_detailed_services?: boolean | null, hide_review_step?: boolean | null, is_using_rooms?: boolean | null, pms_start_time?: any | null, pms_end_time?: any | null, primary_color?: string | null, accent_color?: string | null, secondary_color?: string | null, new_appt_requested_msg?: string | null, new_appt_approved_msg?: string | null, new_appt_approved_sms_msg?: string | null, new_appt_denied_msg?: string | null, schedule_method?: ScheduleMethod | null, scheduling_buffer_minutes?: number | null, base_schedule_duration?: number | null, does_require_referral?: boolean | null, appointment_entry_method?: AppointmentEntryMethod | null, scheduling_min_minutes_away?: number | null, scheduling_max_minutes_away?: number | null, included_species?: Array<Species> | null, max_patients_per_visit?: number | null, should_complete_sync?: boolean | null, server_syncing_only?: boolean | null, confirmation_days_before?: number | null, send_confirmations_to: SendConfirmationsTo, send_new_appt_email?: boolean | null, send_reviews_to?: SendConfirmationsTo | null, max_review_rating_for_notif?: number | null, google_review_link?: string | null, facebook_review_link?: string | null, non_blocking_services: Array<string>, yesterday_revenue?: number | null, this_month_revenue?: number | null, hide_clinician_preference: boolean, does_use_rooms_to_schedule?: boolean | null, primary_room_pms_id?: string | null, should_default_pims_emails_on: boolean, should_default_pims_sms_on: boolean, should_default_marketing_sms_on: boolean, should_default_marketing_email_on: boolean, does_use_clinicians_to_schedule?: boolean | null, time_slot_minutes: number, sync_interval_minutes: number, long_sync_interval_hours: number, primary_clinician_pms_id?: string | null, cancellation_clinician_pms_id?: string | null, cancellation_service_pms_id?: string | null, allow_first_appt_per_day?: boolean | null, custom_well_description?: string | null, custom_sick_description?: string | null, custom_other_title?: string | null, custom_other_description?: string | null, default_trigger_words?: Array<string> | null, should_use_private_reviews?: boolean | null, notify_clinic_on?: Array<NotifyClinicOn> | null, reminder_send_time_minutes?: number | null, does_require_new_client_address?: boolean | null, does_require_new_client_birthday?: boolean | null, should_allow_new_clients?: boolean | null, should_allow_new_patients?: boolean | null, should_create_clients?: boolean | null, should_create_patients?: boolean | null, msgs_auto_priority?: boolean | null, booking_match_procedure?: BookingMatchProcedure | null, urgency_type?: UrgencyType | null, max_booking_columns?: number | null, hide_closed_days_from_scheduling?: boolean | null, should_sync_reminders?: boolean | null, auto_reply_enabled: boolean, auto_reply_message?: string | null, unreplied_message_alert_enabled: boolean, unreplied_message_alert_minutes: number, comms_writeback_enabled: boolean, comms_should_daily_writeback: boolean, comms_use_pdf_for_writeback: boolean, comms_writeback_buffer_minutes: number, comms_writeback_before_appt_mins: number, comms_should_writeback_on_send: boolean, comms_should_writeback_on_receive: boolean, comms_should_writeback_notifs: boolean, comms_should_use_ai_writeback: boolean, form_writeback_enabled: boolean, should_award_loyalty_for_invoices?: boolean | null, invoice_loyalty_points_per_dollar?: number | null, app_download_loyalty_points?: number | null, referrer_loyalty_points?: number | null, referred_loyalty_points?: number | null, custom_appointment_notes_template?: string | null, custom_new_client_notes_template?: string | null, custom_new_patient_notes_template?: string | null, max_inactivity_duration?: number | null, hide_portal_vaccinations: boolean, hide_portal_reminders: boolean, hide_portal_prescriptions: boolean, hide_portal_weight: boolean, hide_soc_vaccinations?: boolean | null, hide_historic_vaccinations?: boolean | null, should_hide_daily_huddle_financials: boolean, patient_details_tab_order: Array<PortalPatientDetailsTab>, clinic_hours_display?: string | null, reschedule_buffer_minutes?: number | null, cancellation_buffer_minutes?: number | null, require_reason_for_cancellation?: boolean | null, should_automatically_assign_patient?: boolean | null, payment_writeback_enabled: boolean, auto_refund_on_cancel: boolean, status_set_on_payment_completed_pms_id?: string | null, max_booking_notes_length?: number | null, min_booking_notes_length?: number | null, primary_clinic_group_id?: string | null, should_suggest_nearby_clinics?: boolean | null, sms_block_list?: Array<string> | null, exclude_message_wrapper?: boolean | null, should_charge_client_stripe_fees?: boolean | null, chckvet_prescription_fee_split_percentage?: number | null, gtm_container_id?: string | null, review_google_id?: string | null, review_facebook_id?: string | null, only_use_adj_avail_guides: boolean, use_basic_timeslots: boolean, valid_booking_interval_minutes?: Array<number> | null, should_disable_online_scheduling?: boolean | null, simple_scheduling_rules_enabled: boolean, compliance_statuses?: Array<string> | null, should_use_instant_prescription_requests?: boolean | null, prescription_pickup_service_id?: string | null, default_reminder_service_id?: string | null, ai_calls_provider?: PhoneProviderType | null, ai_calls_phone_number?: string | null, ai_calls_voice_id?: string | null, ai_calls_agent_id?: string | null, ai_agent_style?: string | null, ai_agent_custom_instructions?: string | null, ai_calls_ambient_sound?: AiCallsAmbientSound | null, ai_calls_voice_speed?: number | null, ai_calls_interruption_sensitivity?: number | null, ai_calls_enable_dynamic_voice_speed?: boolean | null, usage_spending_caps?: any | null, custom_merge_tags?: any | null, custom_booking_copy?: { __typename?: 'ClinicBookingCopy', WIDGET_HEADER_TITLE?: string | null, SHOW_CLINIC_HEADER_LOGO?: boolean | null, CLINIC_HEADER_LOGO_HEIGHT?: number | null, SERVICE_TYPE_SECTION_HEADING?: string | null, DEFAULT_WELLNESS_DESCRIPTION?: string | null, DEFAULT_SICK_DESCRIPTION?: string | null, DEFAULT_OTHER_DESCRIPTION?: string | null, RETURNING_PATIENT_QUESTION?: string | null, POSITIVE_RETURNING_PATIENT_ANSWER?: string | null, NEGATIVE_RETURNING_PATIENT_ANSWER?: string | null, RETURNING_CLIENT_QUESTION?: string | null, POSITIVE_RETURNING_CLIENT_ANSWER?: string | null, NEGATIVE_RETURNING_CLIENT_ANSWER?: string | null, CLIENT_INFORMATION_SECTION_TITLE?: string | null, PATIENT_INFORMATION_SECTION_TITLE?: string | null, RETURNING_CLIENT_PATIENT_TITLE?: string | null, RETURNING_CLIENT_PATIENT_DESCRIPTION?: string | null, SERVICE_SECTION_TITLE?: string | null, PREPAID_SERVICES_LABEL?: string | null, STANDARD_SERVICES_LABEL?: string | null, DEPOSIT_FEE_NAME?: string | null, PREVIOUS_OR_REFERRING_CLINIC_QUESTION?: string | null, CONTACT_THE_CLINIC_TEXT?: string | null, CONTACT_THE_CLINIC_TEXT_COLOR?: string | null, CONTACT_THE_CLINIC_TEXT_SIZE?: string | null, SELECT_CLINICIAN_TITLE?: string | null, SELECT_CLINICIAN_POSITIVE_ANSWER?: string | null, SELECT_CLINICIAN_NEGATIVE_ANSWER?: string | null, SELECT_TIME_TITLE?: string | null, REVIEW_TITLE?: string | null, REVIEW_NOTES_PROMPT?: string | null, PAYMENT_INFORMATION_TITLE?: string | null, TRIGGER_WORDS_DETECTED_HEADER?: string | null, TRIGGER_WORDS_DETECTED_DESCRIPTION?: string | null, CONFIRMATION_SCREEN_TITLE?: string | null, CONFIRMATION_SCREEN_DESCRIPTION?: string | null, NEW_CLIENT_BLOCKED_MESSAGE?: string | null, NEW_PATIENT_BLOCKED_MESSAGE?: string | null } | null, auto_reply_hours?: { __typename?: 'AvailabilityHours', monday?: Array<{ __typename?: 'TimeInterval', start?: number | null, end?: number | null }> | null, tuesday?: Array<{ __typename?: 'TimeInterval', start?: number | null, end?: number | null }> | null, wednesday?: Array<{ __typename?: 'TimeInterval', start?: number | null, end?: number | null }> | null, thursday?: Array<{ __typename?: 'TimeInterval', start?: number | null, end?: number | null }> | null, friday?: Array<{ __typename?: 'TimeInterval', start?: number | null, end?: number | null }> | null, saturday?: Array<{ __typename?: 'TimeInterval', start?: number | null, end?: number | null }> | null, sunday?: Array<{ __typename?: 'TimeInterval', start?: number | null, end?: number | null }> | null } | null, portal_links?: Array<{ __typename?: 'PortalLink', label: string, url: string }> | null, custom_reviews_copy?: { __typename?: 'ClinicReviewsCopy', REVIEW_METHOD_PAGE_TITLE?: string | null, REVIEW_METHOD_PAGE_DESCRIPTION?: string | null, PRIVATE_REVIEW_BUTTON_HELP_TEXT?: string | null, PRIVATE_REVIEW_BUTTON_TEXT?: string | null, REVIEW_PAGE_TITLE?: string | null, REVIEW_PAGE_SUBTITLE?: string | null, REVIEW_SCORE_LABEL?: string | null, REVIEW_MESSAGE_LABEL?: string | null, REVIEW_SUBMIT_BUTTON_TEXT?: string | null } | null, waitlist_customer_segment?: { __typename?: 'CustomerSegment', id: string, name: string, trigger_entity?: CustomerSegmentTrigger | null, is_archived: boolean, updated_at: number, notification_templates?: Array<{ __typename?: 'NotificationTemplate', id: string, name: string, is_active: boolean, is_archived: boolean, message_methods: Array<MessageMethod> }> | null, error_flags?: Array<{ __typename?: 'CustomerSegmentErrorFlag', filter_column: string, filter_index: number, parameter_index: number, message: string }> | null, all_inclusions?: Array<{ __typename?: 'SegmentFilter', foreign_table?: string | null, group?: string | null, parameters: Array<{ __typename?: 'QueryFilter', column: string, filterOp: FilterOp, value: { __typename?: 'QueryFilterValue', string?: string | null, float?: number | null, boolean?: boolean | null, stringArray?: Array<string> | null, floatArray?: Array<number> | null, millisFromNow?: number | null, relativeTime?: { __typename?: 'RelativeTime', quantity: number, unit: TimeUnit, direction: ReferenceDirection } | null } }> }> | null, any_inclusions?: Array<{ __typename?: 'SegmentFilter', foreign_table?: string | null, group?: string | null, parameters: Array<{ __typename?: 'QueryFilter', column: string, filterOp: FilterOp, value: { __typename?: 'QueryFilterValue', string?: string | null, float?: number | null, boolean?: boolean | null, stringArray?: Array<string> | null, floatArray?: Array<number> | null, millisFromNow?: number | null, relativeTime?: { __typename?: 'RelativeTime', quantity: number, unit: TimeUnit, direction: ReferenceDirection } | null } }> }> | null, any_exclusions?: Array<{ __typename?: 'SegmentFilter', foreign_table?: string | null, group?: string | null, parameters: Array<{ __typename?: 'QueryFilter', column: string, filterOp: FilterOp, value: { __typename?: 'QueryFilterValue', string?: string | null, float?: number | null, boolean?: boolean | null, stringArray?: Array<string> | null, floatArray?: Array<number> | null, millisFromNow?: number | null, relativeTime?: { __typename?: 'RelativeTime', quantity: number, unit: TimeUnit, direction: ReferenceDirection } | null } }> }> | null, any_other_exclusions?: Array<{ __typename?: 'SegmentFilter', foreign_table?: string | null, group?: string | null, parameters: Array<{ __typename?: 'QueryFilter', column: string, filterOp: FilterOp, value: { __typename?: 'QueryFilterValue', string?: string | null, float?: number | null, boolean?: boolean | null, stringArray?: Array<string> | null, floatArray?: Array<number> | null, millisFromNow?: number | null, relativeTime?: { __typename?: 'RelativeTime', quantity: number, unit: TimeUnit, direction: ReferenceDirection } | null } }> }> | null, filters?: Array<{ __typename?: 'CustomerSegmentFilter', filters: Array<{ __typename?: 'QueryFilter', column: string, filterOp: FilterOp, value: { __typename?: 'QueryFilterValue', string?: string | null, float?: number | null, boolean?: boolean | null, stringArray?: Array<string> | null, floatArray?: Array<number> | null, millisFromNow?: number | null, relativeTime?: { __typename?: 'RelativeTime', quantity: number, unit: TimeUnit, direction: ReferenceDirection } | null } }> }> | null, excluded_filters: Array<{ __typename?: 'CustomerSegmentFilter', filters: Array<{ __typename?: 'QueryFilter', column: string, filterOp: FilterOp, value: { __typename?: 'QueryFilterValue', string?: string | null, float?: number | null, boolean?: boolean | null, stringArray?: Array<string> | null, floatArray?: Array<number> | null, millisFromNow?: number | null, relativeTime?: { __typename?: 'RelativeTime', quantity: number, unit: TimeUnit, direction: ReferenceDirection } | null } }> }> } | null, blocklist_customer_segment?: { __typename?: 'CustomerSegment', id: string, name: string, trigger_entity?: CustomerSegmentTrigger | null, is_archived: boolean, updated_at: number, notification_templates?: Array<{ __typename?: 'NotificationTemplate', id: string, name: string, is_active: boolean, is_archived: boolean, message_methods: Array<MessageMethod> }> | null, error_flags?: Array<{ __typename?: 'CustomerSegmentErrorFlag', filter_column: string, filter_index: number, parameter_index: number, message: string }> | null, all_inclusions?: Array<{ __typename?: 'SegmentFilter', foreign_table?: string | null, group?: string | null, parameters: Array<{ __typename?: 'QueryFilter', column: string, filterOp: FilterOp, value: { __typename?: 'QueryFilterValue', string?: string | null, float?: number | null, boolean?: boolean | null, stringArray?: Array<string> | null, floatArray?: Array<number> | null, millisFromNow?: number | null, relativeTime?: { __typename?: 'RelativeTime', quantity: number, unit: TimeUnit, direction: ReferenceDirection } | null } }> }> | null, any_inclusions?: Array<{ __typename?: 'SegmentFilter', foreign_table?: string | null, group?: string | null, parameters: Array<{ __typename?: 'QueryFilter', column: string, filterOp: FilterOp, value: { __typename?: 'QueryFilterValue', string?: string | null, float?: number | null, boolean?: boolean | null, stringArray?: Array<string> | null, floatArray?: Array<number> | null, millisFromNow?: number | null, relativeTime?: { __typename?: 'RelativeTime', quantity: number, unit: TimeUnit, direction: ReferenceDirection } | null } }> }> | null, any_exclusions?: Array<{ __typename?: 'SegmentFilter', foreign_table?: string | null, group?: string | null, parameters: Array<{ __typename?: 'QueryFilter', column: string, filterOp: FilterOp, value: { __typename?: 'QueryFilterValue', string?: string | null, float?: number | null, boolean?: boolean | null, stringArray?: Array<string> | null, floatArray?: Array<number> | null, millisFromNow?: number | null, relativeTime?: { __typename?: 'RelativeTime', quantity: number, unit: TimeUnit, direction: ReferenceDirection } | null } }> }> | null, any_other_exclusions?: Array<{ __typename?: 'SegmentFilter', foreign_table?: string | null, group?: string | null, parameters: Array<{ __typename?: 'QueryFilter', column: string, filterOp: FilterOp, value: { __typename?: 'QueryFilterValue', string?: string | null, float?: number | null, boolean?: boolean | null, stringArray?: Array<string> | null, floatArray?: Array<number> | null, millisFromNow?: number | null, relativeTime?: { __typename?: 'RelativeTime', quantity: number, unit: TimeUnit, direction: ReferenceDirection } | null } }> }> | null, filters?: Array<{ __typename?: 'CustomerSegmentFilter', filters: Array<{ __typename?: 'QueryFilter', column: string, filterOp: FilterOp, value: { __typename?: 'QueryFilterValue', string?: string | null, float?: number | null, boolean?: boolean | null, stringArray?: Array<string> | null, floatArray?: Array<number> | null, millisFromNow?: number | null, relativeTime?: { __typename?: 'RelativeTime', quantity: number, unit: TimeUnit, direction: ReferenceDirection } | null } }> }> | null, excluded_filters: Array<{ __typename?: 'CustomerSegmentFilter', filters: Array<{ __typename?: 'QueryFilter', column: string, filterOp: FilterOp, value: { __typename?: 'QueryFilterValue', string?: string | null, float?: number | null, boolean?: boolean | null, stringArray?: Array<string> | null, floatArray?: Array<number> | null, millisFromNow?: number | null, relativeTime?: { __typename?: 'RelativeTime', quantity: number, unit: TimeUnit, direction: ReferenceDirection } | null } }> }> } | null, referral_customer_segment?: { __typename?: 'CustomerSegment', id: string, name: string, trigger_entity?: CustomerSegmentTrigger | null, is_archived: boolean, updated_at: number, notification_templates?: Array<{ __typename?: 'NotificationTemplate', id: string, name: string, is_active: boolean, is_archived: boolean, message_methods: Array<MessageMethod> }> | null, error_flags?: Array<{ __typename?: 'CustomerSegmentErrorFlag', filter_column: string, filter_index: number, parameter_index: number, message: string }> | null, all_inclusions?: Array<{ __typename?: 'SegmentFilter', foreign_table?: string | null, group?: string | null, parameters: Array<{ __typename?: 'QueryFilter', column: string, filterOp: FilterOp, value: { __typename?: 'QueryFilterValue', string?: string | null, float?: number | null, boolean?: boolean | null, stringArray?: Array<string> | null, floatArray?: Array<number> | null, millisFromNow?: number | null, relativeTime?: { __typename?: 'RelativeTime', quantity: number, unit: TimeUnit, direction: ReferenceDirection } | null } }> }> | null, any_inclusions?: Array<{ __typename?: 'SegmentFilter', foreign_table?: string | null, group?: string | null, parameters: Array<{ __typename?: 'QueryFilter', column: string, filterOp: FilterOp, value: { __typename?: 'QueryFilterValue', string?: string | null, float?: number | null, boolean?: boolean | null, stringArray?: Array<string> | null, floatArray?: Array<number> | null, millisFromNow?: number | null, relativeTime?: { __typename?: 'RelativeTime', quantity: number, unit: TimeUnit, direction: ReferenceDirection } | null } }> }> | null, any_exclusions?: Array<{ __typename?: 'SegmentFilter', foreign_table?: string | null, group?: string | null, parameters: Array<{ __typename?: 'QueryFilter', column: string, filterOp: FilterOp, value: { __typename?: 'QueryFilterValue', string?: string | null, float?: number | null, boolean?: boolean | null, stringArray?: Array<string> | null, floatArray?: Array<number> | null, millisFromNow?: number | null, relativeTime?: { __typename?: 'RelativeTime', quantity: number, unit: TimeUnit, direction: ReferenceDirection } | null } }> }> | null, any_other_exclusions?: Array<{ __typename?: 'SegmentFilter', foreign_table?: string | null, group?: string | null, parameters: Array<{ __typename?: 'QueryFilter', column: string, filterOp: FilterOp, value: { __typename?: 'QueryFilterValue', string?: string | null, float?: number | null, boolean?: boolean | null, stringArray?: Array<string> | null, floatArray?: Array<number> | null, millisFromNow?: number | null, relativeTime?: { __typename?: 'RelativeTime', quantity: number, unit: TimeUnit, direction: ReferenceDirection } | null } }> }> | null, filters?: Array<{ __typename?: 'CustomerSegmentFilter', filters: Array<{ __typename?: 'QueryFilter', column: string, filterOp: FilterOp, value: { __typename?: 'QueryFilterValue', string?: string | null, float?: number | null, boolean?: boolean | null, stringArray?: Array<string> | null, floatArray?: Array<number> | null, millisFromNow?: number | null, relativeTime?: { __typename?: 'RelativeTime', quantity: number, unit: TimeUnit, direction: ReferenceDirection } | null } }> }> | null, excluded_filters: Array<{ __typename?: 'CustomerSegmentFilter', filters: Array<{ __typename?: 'QueryFilter', column: string, filterOp: FilterOp, value: { __typename?: 'QueryFilterValue', string?: string | null, float?: number | null, boolean?: boolean | null, stringArray?: Array<string> | null, floatArray?: Array<number> | null, millisFromNow?: number | null, relativeTime?: { __typename?: 'RelativeTime', quantity: number, unit: TimeUnit, direction: ReferenceDirection } | null } }> }> } | null, webhooks?: Array<{ __typename?: 'WebhookConfig', id: string, name: string, url: string, events: Array<WebhookEventType>, secret?: string | null, enabled: boolean }> | null, times_first_filter_config?: { __typename?: 'TimesFirstFilterConfig', service?: BookingFilterDisplayMode | null, clinician?: BookingFilterDisplayMode | null, species?: BookingFilterDisplayMode | null, client_status?: BookingFilterDisplayMode | null, patient_status?: BookingFilterDisplayMode | null, patient_gender?: BookingFilterDisplayMode | null, fixed_status?: BookingFilterDisplayMode | null } | null } | null, onboarding?: { __typename?: 'ClinicOnboarding', has_set_hours?: boolean | null, has_synced_pms?: boolean | null } | null, organization?: { __typename?: 'Organization', id: string } | null, features?: { __typename?: 'ClinicFeatures', scheduling_enabled?: boolean | null, huddle_enabled?: boolean | null, payments_enabled?: boolean | null, messaging_enabled?: boolean | null, reviews_enabled?: boolean | null, loyalty_enabled?: boolean | null, notifs_enabled?: boolean | null, forms_enabled?: boolean | null, help_enabled?: boolean | null, bulk_messaging_enabled?: boolean | null, portal_enabled?: boolean | null, calls_enabled?: boolean | null, teamchat_enabled?: boolean | null, prescriptions_enabled?: boolean | null, medical_history_enabled?: boolean | null, pet_selfies_enabled?: boolean | null } | null, hours?: { __typename?: 'AvailabilityHours', monday?: Array<{ __typename?: 'TimeInterval', start?: number | null, end?: number | null }> | null, tuesday?: Array<{ __typename?: 'TimeInterval', start?: number | null, end?: number | null }> | null, wednesday?: Array<{ __typename?: 'TimeInterval', start?: number | null, end?: number | null }> | null, thursday?: Array<{ __typename?: 'TimeInterval', start?: number | null, end?: number | null }> | null, friday?: Array<{ __typename?: 'TimeInterval', start?: number | null, end?: number | null }> | null, saturday?: Array<{ __typename?: 'TimeInterval', start?: number | null, end?: number | null }> | null, sunday?: Array<{ __typename?: 'TimeInterval', start?: number | null, end?: number | null }> | null } | null, clinic_hours?: { __typename?: 'AvailabilityHours', monday?: Array<{ __typename?: 'TimeInterval', start?: number | null, end?: number | null }> | null, tuesday?: Array<{ __typename?: 'TimeInterval', start?: number | null, end?: number | null }> | null, wednesday?: Array<{ __typename?: 'TimeInterval', start?: number | null, end?: number | null }> | null, thursday?: Array<{ __typename?: 'TimeInterval', start?: number | null, end?: number | null }> | null, friday?: Array<{ __typename?: 'TimeInterval', start?: number | null, end?: number | null }> | null, saturday?: Array<{ __typename?: 'TimeInterval', start?: number | null, end?: number | null }> | null, sunday?: Array<{ __typename?: 'TimeInterval', start?: number | null, end?: number | null }> | null } | null, adjusted_availability?: Array<{ __typename?: 'Availability', date: number, pms_appt_type_pms_id?: string | null, times: Array<{ __typename?: 'TimeInterval', start?: number | null, end?: number | null }>, repeat?: { __typename?: 'RepeatAvailability', daysOfMonth?: Array<number> | null, daysOfWeek?: Array<DayOfWeek> | null, weekOfMonth?: WeekOfMonth | null, frequency: any, unit: RepeatUnit, end_date?: number | null } | null }> | null, pms_adjusted_availability?: Array<{ __typename?: 'Availability', date: number, pms_appt_type_pms_id?: string | null, times: Array<{ __typename?: 'TimeInterval', start?: number | null, end?: number | null }>, repeat?: { __typename?: 'RepeatAvailability', daysOfMonth?: Array<number> | null, daysOfWeek?: Array<DayOfWeek> | null, weekOfMonth?: WeekOfMonth | null, frequency: any, unit: RepeatUnit, end_date?: number | null } | null }> | null, last_sync_times?: { __typename?: 'LastSyncTimes', last_full_sync?: number | null, last_sync_appointments?: number | null, last_sync_clients?: number | null, last_sync_patients?: number | null, last_sync_clinicians?: number | null, last_sync_services?: number | null, last_sync_transactions?: number | null, last_sync_invoices?: number | null, last_sync_history_items?: number | null, last_sync_diagnoses?: number | null, last_sync_prescriptions?: number | null, last_sync_products?: number | null, last_sync_rooms?: number | null, last_sync_species?: number | null, last_sync_breeds?: number | null, last_sync_reminders?: number | null, last_sync_reminder_types?: number | null, last_sync_vaccination_records?: number | null, last_sync_clinic_sexes?: number | null, last_sync_appt_statuses?: number | null, last_sync_blockoffs?: number | null, last_sync_invoice_items?: number | null } | null, pims_settings?: { __typename?: 'PimsSettings', ezyvet_integration_mode?: EzyvetIntegrationMode | null, entered_by_pms_id?: string | null } | null }> };

export type CountClinicsQueryVariables = Exact<{
  where?: InputMaybe<Array<QueryInput> | QueryInput>;
}>;


export type CountClinicsQuery = { __typename?: 'Query', countClinics: number };

export type ClinicStatsQueryVariables = Exact<{
  clinicId: Scalars['ID']['input'];
}>;


export type ClinicStatsQuery = { __typename?: 'Query', clinicStats: { __typename?: 'ClinicStats', completed_appointments: number, confirmed_appointments: number, booked_appointments: number, pending_appointments: number, cancelled_appointments: number, denied_appointments: number, expired_appointments: number, total_appointments: number, total_website_appointments: number, total_widget_appointments: number } };

export type GetTotalRevenueForClinicBetweenTimesQueryVariables = Exact<{
  clinicId: Scalars['ID']['input'];
  endTime: Scalars['NonNegativeInt']['input'];
  startTime: Scalars['NonNegativeInt']['input'];
}>;


export type GetTotalRevenueForClinicBetweenTimesQuery = { __typename?: 'Query', getTotalRevenueForClinicBetweenTimes: number };

export type GetClinicOnboardingQueryVariables = Exact<{
  clinicId: Scalars['ID']['input'];
}>;


export type GetClinicOnboardingQuery = { __typename?: 'Query', clinicOnboarding?: { __typename?: 'ClinicOnboarding', has_test_appointment?: boolean | null, clinic?: { __typename?: 'Clinic', name?: string | null, pms: PracticeManagementSystem, avatar_url?: string | null, email?: string | null, phone?: string | null, send_from_phone?: string | null, office_emails?: Array<string> | null, settings?: { __typename?: 'ClinicSettings', appointment_entry_method?: AppointmentEntryMethod | null, booking_match_procedure?: BookingMatchProcedure | null, is_using_detailed_services?: boolean | null, does_use_rooms_to_schedule?: boolean | null, does_use_clinicians_to_schedule?: boolean | null, should_allow_new_clients?: boolean | null, should_allow_new_patients?: boolean | null, urgency_type?: UrgencyType | null, should_sync_reminders?: boolean | null, primary_color?: string | null, primary_clinician_pms_id?: string | null, primary_room_pms_id?: string | null, allow_first_appt_per_day?: boolean | null } | null, last_sync_times?: { __typename?: 'LastSyncTimes', last_full_sync?: number | null } | null } | null } | null };

export type GetOnboardingWizardProgressQueryVariables = Exact<{
  clinicId: Scalars['ID']['input'];
}>;


export type GetOnboardingWizardProgressQuery = { __typename?: 'Query', clinicOnboarding?: { __typename?: 'ClinicOnboarding', wizard_progress?: any | null } | null };

export type SaveOnboardingWizardProgressMutationVariables = Exact<{
  clinicId: Scalars['ID']['input'];
  progress?: InputMaybe<Scalars['JSON']['input']>;
}>;


export type SaveOnboardingWizardProgressMutation = { __typename?: 'Mutation', updateClinic: { __typename?: 'Clinic', id: string } };

export type CreateClinicMutationVariables = Exact<{
  data: CreateClinicInput;
  shouldCreateWidget?: InputMaybe<Scalars['Boolean']['input']>;
}>;


export type CreateClinicMutation = { __typename?: 'Mutation', createClinic: { __typename?: 'Clinic', id: string, slug?: string | null, name?: string | null, description?: string | null, email?: string | null, phone?: string | null, send_from_phone?: string | null, send_from_email?: string | null, reply_to_email?: string | null, website?: string | null, pms: PracticeManagementSystem, pms_connector: PmsConnector, pms_api_key?: string | null, pms_additional_key?: string | null, office_emails?: Array<string> | null, stripe_accounts_enabled?: Array<StripeAccountType> | null, stripe_account_type?: string | null, stripe_customer_id?: string | null, avatar_url?: string | null, go_live_date?: string | null, time_zone?: string | null, is_archived: boolean, location?: string | null, tmp_feature_flags?: any | null, mute_until?: number | null, created_at: number, updated_at: number, pms_db?: { __typename?: 'PmsDb', id: string, name: string, last_sync_times?: { __typename?: 'LastSyncTimes', last_full_sync?: number | null, last_sync_appointments?: number | null, last_sync_clients?: number | null, last_sync_patients?: number | null, last_sync_clinicians?: number | null, last_sync_services?: number | null, last_sync_transactions?: number | null, last_sync_invoices?: number | null, last_sync_history_items?: number | null, last_sync_diagnoses?: number | null, last_sync_prescriptions?: number | null, last_sync_products?: number | null, last_sync_rooms?: number | null, last_sync_species?: number | null, last_sync_breeds?: number | null, last_sync_reminders?: number | null, last_sync_reminder_types?: number | null, last_sync_vaccination_records?: number | null, last_sync_clinic_sexes?: number | null, last_sync_appt_statuses?: number | null, last_sync_blockoffs?: number | null, last_sync_invoice_items?: number | null } | null } | null, clinic_admins: Array<{ __typename?: 'ClinicAdmin', id: string, role: AuthRoles, are_email_notifications_enabled: boolean, are_sms_notifications_enabled: boolean, are_desktop_notifications_enabled: boolean, should_hide_daily_huddle_financials: boolean, created_at: number, updated_at: number, clinic: { __typename?: 'Clinic', id: string, name?: string | null, slug?: string | null, avatar_url?: string | null, is_verified?: boolean | null, is_archived: boolean, description?: string | null, pms: PracticeManagementSystem, time_zone?: string | null, last_sync_times?: { __typename?: 'LastSyncTimes', last_full_sync?: number | null } | null, clinic_admins: Array<{ __typename?: 'ClinicAdmin', id: string }>, organization?: { __typename?: 'Organization', id: string } | null, address?: { __typename?: 'Address', street_a?: string | null, street_b?: string | null, city?: string | null, state?: string | null, zip?: string | null, country?: string | null, lat?: number | null, lng?: number | null } | null }, user: { __typename?: 'User', id: string, first_name?: string | null, last_name?: string | null, email?: any | null, phone?: string | null, phone_country?: string | null, avatar_url?: string | null, role?: AuthRoles | null, enabled_notification_sounds?: Array<UserNotificationSound> | null, notify_email_on?: Array<NotifyClinicOn> | null, notify_sound_on?: Array<NotifyClinicOn> | null, notify_desktop_on?: Array<NotifyClinicOn> | null, must_reset_password?: boolean | null, invitation_status?: UserInvitationStatus | null, invited_at?: number | null, created_at: number, updated_at: number }, custom_role?: { __typename?: 'CustomRole', id: string, name: string } | null, permissions?: Array<{ __typename?: 'ClinicAdminPermission', feature: AdminPermissionFeature, access_level: AdminPermissionAccessLevel }> | null }>, address?: { __typename?: 'Address', street_a?: string | null, street_b?: string | null, city?: string | null, state?: string | null, zip?: string | null, country?: string | null } | null, services: Array<{ __typename?: 'Service', id: string, name?: string | null }>, settings?: { __typename?: 'ClinicSettings', id?: string | null, does_require_verification?: boolean | null, does_use_automatic_reschedule?: boolean | null, reset_status_to_booked_on_reschedule?: boolean | null, is_using_detailed_services?: boolean | null, hide_review_step?: boolean | null, is_using_rooms?: boolean | null, pms_start_time?: any | null, pms_end_time?: any | null, primary_color?: string | null, accent_color?: string | null, secondary_color?: string | null, new_appt_requested_msg?: string | null, new_appt_approved_msg?: string | null, new_appt_approved_sms_msg?: string | null, new_appt_denied_msg?: string | null, schedule_method?: ScheduleMethod | null, scheduling_buffer_minutes?: number | null, base_schedule_duration?: number | null, does_require_referral?: boolean | null, appointment_entry_method?: AppointmentEntryMethod | null, scheduling_min_minutes_away?: number | null, scheduling_max_minutes_away?: number | null, included_species?: Array<Species> | null, max_patients_per_visit?: number | null, should_complete_sync?: boolean | null, server_syncing_only?: boolean | null, confirmation_days_before?: number | null, send_confirmations_to: SendConfirmationsTo, send_new_appt_email?: boolean | null, send_reviews_to?: SendConfirmationsTo | null, max_review_rating_for_notif?: number | null, google_review_link?: string | null, facebook_review_link?: string | null, non_blocking_services: Array<string>, yesterday_revenue?: number | null, this_month_revenue?: number | null, hide_clinician_preference: boolean, does_use_rooms_to_schedule?: boolean | null, primary_room_pms_id?: string | null, should_default_pims_emails_on: boolean, should_default_pims_sms_on: boolean, should_default_marketing_sms_on: boolean, should_default_marketing_email_on: boolean, does_use_clinicians_to_schedule?: boolean | null, time_slot_minutes: number, sync_interval_minutes: number, long_sync_interval_hours: number, primary_clinician_pms_id?: string | null, cancellation_clinician_pms_id?: string | null, cancellation_service_pms_id?: string | null, allow_first_appt_per_day?: boolean | null, custom_well_description?: string | null, custom_sick_description?: string | null, custom_other_title?: string | null, custom_other_description?: string | null, default_trigger_words?: Array<string> | null, should_use_private_reviews?: boolean | null, notify_clinic_on?: Array<NotifyClinicOn> | null, reminder_send_time_minutes?: number | null, does_require_new_client_address?: boolean | null, does_require_new_client_birthday?: boolean | null, should_allow_new_clients?: boolean | null, should_allow_new_patients?: boolean | null, should_create_clients?: boolean | null, should_create_patients?: boolean | null, msgs_auto_priority?: boolean | null, booking_match_procedure?: BookingMatchProcedure | null, urgency_type?: UrgencyType | null, max_booking_columns?: number | null, hide_closed_days_from_scheduling?: boolean | null, should_sync_reminders?: boolean | null, auto_reply_enabled: boolean, auto_reply_message?: string | null, unreplied_message_alert_enabled: boolean, unreplied_message_alert_minutes: number, comms_writeback_enabled: boolean, comms_should_daily_writeback: boolean, comms_use_pdf_for_writeback: boolean, comms_writeback_buffer_minutes: number, comms_writeback_before_appt_mins: number, comms_should_writeback_on_send: boolean, comms_should_writeback_on_receive: boolean, comms_should_writeback_notifs: boolean, comms_should_use_ai_writeback: boolean, form_writeback_enabled: boolean, should_award_loyalty_for_invoices?: boolean | null, invoice_loyalty_points_per_dollar?: number | null, app_download_loyalty_points?: number | null, referrer_loyalty_points?: number | null, referred_loyalty_points?: number | null, custom_appointment_notes_template?: string | null, custom_new_client_notes_template?: string | null, custom_new_patient_notes_template?: string | null, max_inactivity_duration?: number | null, hide_portal_vaccinations: boolean, hide_portal_reminders: boolean, hide_portal_prescriptions: boolean, hide_portal_weight: boolean, hide_soc_vaccinations?: boolean | null, hide_historic_vaccinations?: boolean | null, should_hide_daily_huddle_financials: boolean, patient_details_tab_order: Array<PortalPatientDetailsTab>, clinic_hours_display?: string | null, reschedule_buffer_minutes?: number | null, cancellation_buffer_minutes?: number | null, require_reason_for_cancellation?: boolean | null, should_automatically_assign_patient?: boolean | null, payment_writeback_enabled: boolean, auto_refund_on_cancel: boolean, status_set_on_payment_completed_pms_id?: string | null, max_booking_notes_length?: number | null, min_booking_notes_length?: number | null, primary_clinic_group_id?: string | null, should_suggest_nearby_clinics?: boolean | null, sms_block_list?: Array<string> | null, exclude_message_wrapper?: boolean | null, should_charge_client_stripe_fees?: boolean | null, chckvet_prescription_fee_split_percentage?: number | null, gtm_container_id?: string | null, review_google_id?: string | null, review_facebook_id?: string | null, only_use_adj_avail_guides: boolean, use_basic_timeslots: boolean, valid_booking_interval_minutes?: Array<number> | null, should_disable_online_scheduling?: boolean | null, simple_scheduling_rules_enabled: boolean, compliance_statuses?: Array<string> | null, should_use_instant_prescription_requests?: boolean | null, prescription_pickup_service_id?: string | null, default_reminder_service_id?: string | null, ai_calls_provider?: PhoneProviderType | null, ai_calls_phone_number?: string | null, ai_calls_voice_id?: string | null, ai_calls_agent_id?: string | null, ai_agent_style?: string | null, ai_agent_custom_instructions?: string | null, ai_calls_ambient_sound?: AiCallsAmbientSound | null, ai_calls_voice_speed?: number | null, ai_calls_interruption_sensitivity?: number | null, ai_calls_enable_dynamic_voice_speed?: boolean | null, usage_spending_caps?: any | null, custom_merge_tags?: any | null, custom_booking_copy?: { __typename?: 'ClinicBookingCopy', WIDGET_HEADER_TITLE?: string | null, SHOW_CLINIC_HEADER_LOGO?: boolean | null, CLINIC_HEADER_LOGO_HEIGHT?: number | null, SERVICE_TYPE_SECTION_HEADING?: string | null, DEFAULT_WELLNESS_DESCRIPTION?: string | null, DEFAULT_SICK_DESCRIPTION?: string | null, DEFAULT_OTHER_DESCRIPTION?: string | null, RETURNING_PATIENT_QUESTION?: string | null, POSITIVE_RETURNING_PATIENT_ANSWER?: string | null, NEGATIVE_RETURNING_PATIENT_ANSWER?: string | null, RETURNING_CLIENT_QUESTION?: string | null, POSITIVE_RETURNING_CLIENT_ANSWER?: string | null, NEGATIVE_RETURNING_CLIENT_ANSWER?: string | null, CLIENT_INFORMATION_SECTION_TITLE?: string | null, PATIENT_INFORMATION_SECTION_TITLE?: string | null, RETURNING_CLIENT_PATIENT_TITLE?: string | null, RETURNING_CLIENT_PATIENT_DESCRIPTION?: string | null, SERVICE_SECTION_TITLE?: string | null, PREPAID_SERVICES_LABEL?: string | null, STANDARD_SERVICES_LABEL?: string | null, DEPOSIT_FEE_NAME?: string | null, PREVIOUS_OR_REFERRING_CLINIC_QUESTION?: string | null, CONTACT_THE_CLINIC_TEXT?: string | null, CONTACT_THE_CLINIC_TEXT_COLOR?: string | null, CONTACT_THE_CLINIC_TEXT_SIZE?: string | null, SELECT_CLINICIAN_TITLE?: string | null, SELECT_CLINICIAN_POSITIVE_ANSWER?: string | null, SELECT_CLINICIAN_NEGATIVE_ANSWER?: string | null, SELECT_TIME_TITLE?: string | null, REVIEW_TITLE?: string | null, REVIEW_NOTES_PROMPT?: string | null, PAYMENT_INFORMATION_TITLE?: string | null, TRIGGER_WORDS_DETECTED_HEADER?: string | null, TRIGGER_WORDS_DETECTED_DESCRIPTION?: string | null, CONFIRMATION_SCREEN_TITLE?: string | null, CONFIRMATION_SCREEN_DESCRIPTION?: string | null, NEW_CLIENT_BLOCKED_MESSAGE?: string | null, NEW_PATIENT_BLOCKED_MESSAGE?: string | null } | null, auto_reply_hours?: { __typename?: 'AvailabilityHours', monday?: Array<{ __typename?: 'TimeInterval', start?: number | null, end?: number | null }> | null, tuesday?: Array<{ __typename?: 'TimeInterval', start?: number | null, end?: number | null }> | null, wednesday?: Array<{ __typename?: 'TimeInterval', start?: number | null, end?: number | null }> | null, thursday?: Array<{ __typename?: 'TimeInterval', start?: number | null, end?: number | null }> | null, friday?: Array<{ __typename?: 'TimeInterval', start?: number | null, end?: number | null }> | null, saturday?: Array<{ __typename?: 'TimeInterval', start?: number | null, end?: number | null }> | null, sunday?: Array<{ __typename?: 'TimeInterval', start?: number | null, end?: number | null }> | null } | null, portal_links?: Array<{ __typename?: 'PortalLink', label: string, url: string }> | null, custom_reviews_copy?: { __typename?: 'ClinicReviewsCopy', REVIEW_METHOD_PAGE_TITLE?: string | null, REVIEW_METHOD_PAGE_DESCRIPTION?: string | null, PRIVATE_REVIEW_BUTTON_HELP_TEXT?: string | null, PRIVATE_REVIEW_BUTTON_TEXT?: string | null, REVIEW_PAGE_TITLE?: string | null, REVIEW_PAGE_SUBTITLE?: string | null, REVIEW_SCORE_LABEL?: string | null, REVIEW_MESSAGE_LABEL?: string | null, REVIEW_SUBMIT_BUTTON_TEXT?: string | null } | null, waitlist_customer_segment?: { __typename?: 'CustomerSegment', id: string, name: string, trigger_entity?: CustomerSegmentTrigger | null, is_archived: boolean, updated_at: number, notification_templates?: Array<{ __typename?: 'NotificationTemplate', id: string, name: string, is_active: boolean, is_archived: boolean, message_methods: Array<MessageMethod> }> | null, error_flags?: Array<{ __typename?: 'CustomerSegmentErrorFlag', filter_column: string, filter_index: number, parameter_index: number, message: string }> | null, all_inclusions?: Array<{ __typename?: 'SegmentFilter', foreign_table?: string | null, group?: string | null, parameters: Array<{ __typename?: 'QueryFilter', column: string, filterOp: FilterOp, value: { __typename?: 'QueryFilterValue', string?: string | null, float?: number | null, boolean?: boolean | null, stringArray?: Array<string> | null, floatArray?: Array<number> | null, millisFromNow?: number | null, relativeTime?: { __typename?: 'RelativeTime', quantity: number, unit: TimeUnit, direction: ReferenceDirection } | null } }> }> | null, any_inclusions?: Array<{ __typename?: 'SegmentFilter', foreign_table?: string | null, group?: string | null, parameters: Array<{ __typename?: 'QueryFilter', column: string, filterOp: FilterOp, value: { __typename?: 'QueryFilterValue', string?: string | null, float?: number | null, boolean?: boolean | null, stringArray?: Array<string> | null, floatArray?: Array<number> | null, millisFromNow?: number | null, relativeTime?: { __typename?: 'RelativeTime', quantity: number, unit: TimeUnit, direction: ReferenceDirection } | null } }> }> | null, any_exclusions?: Array<{ __typename?: 'SegmentFilter', foreign_table?: string | null, group?: string | null, parameters: Array<{ __typename?: 'QueryFilter', column: string, filterOp: FilterOp, value: { __typename?: 'QueryFilterValue', string?: string | null, float?: number | null, boolean?: boolean | null, stringArray?: Array<string> | null, floatArray?: Array<number> | null, millisFromNow?: number | null, relativeTime?: { __typename?: 'RelativeTime', quantity: number, unit: TimeUnit, direction: ReferenceDirection } | null } }> }> | null, any_other_exclusions?: Array<{ __typename?: 'SegmentFilter', foreign_table?: string | null, group?: string | null, parameters: Array<{ __typename?: 'QueryFilter', column: string, filterOp: FilterOp, value: { __typename?: 'QueryFilterValue', string?: string | null, float?: number | null, boolean?: boolean | null, stringArray?: Array<string> | null, floatArray?: Array<number> | null, millisFromNow?: number | null, relativeTime?: { __typename?: 'RelativeTime', quantity: number, unit: TimeUnit, direction: ReferenceDirection } | null } }> }> | null, filters?: Array<{ __typename?: 'CustomerSegmentFilter', filters: Array<{ __typename?: 'QueryFilter', column: string, filterOp: FilterOp, value: { __typename?: 'QueryFilterValue', string?: string | null, float?: number | null, boolean?: boolean | null, stringArray?: Array<string> | null, floatArray?: Array<number> | null, millisFromNow?: number | null, relativeTime?: { __typename?: 'RelativeTime', quantity: number, unit: TimeUnit, direction: ReferenceDirection } | null } }> }> | null, excluded_filters: Array<{ __typename?: 'CustomerSegmentFilter', filters: Array<{ __typename?: 'QueryFilter', column: string, filterOp: FilterOp, value: { __typename?: 'QueryFilterValue', string?: string | null, float?: number | null, boolean?: boolean | null, stringArray?: Array<string> | null, floatArray?: Array<number> | null, millisFromNow?: number | null, relativeTime?: { __typename?: 'RelativeTime', quantity: number, unit: TimeUnit, direction: ReferenceDirection } | null } }> }> } | null, blocklist_customer_segment?: { __typename?: 'CustomerSegment', id: string, name: string, trigger_entity?: CustomerSegmentTrigger | null, is_archived: boolean, updated_at: number, notification_templates?: Array<{ __typename?: 'NotificationTemplate', id: string, name: string, is_active: boolean, is_archived: boolean, message_methods: Array<MessageMethod> }> | null, error_flags?: Array<{ __typename?: 'CustomerSegmentErrorFlag', filter_column: string, filter_index: number, parameter_index: number, message: string }> | null, all_inclusions?: Array<{ __typename?: 'SegmentFilter', foreign_table?: string | null, group?: string | null, parameters: Array<{ __typename?: 'QueryFilter', column: string, filterOp: FilterOp, value: { __typename?: 'QueryFilterValue', string?: string | null, float?: number | null, boolean?: boolean | null, stringArray?: Array<string> | null, floatArray?: Array<number> | null, millisFromNow?: number | null, relativeTime?: { __typename?: 'RelativeTime', quantity: number, unit: TimeUnit, direction: ReferenceDirection } | null } }> }> | null, any_inclusions?: Array<{ __typename?: 'SegmentFilter', foreign_table?: string | null, group?: string | null, parameters: Array<{ __typename?: 'QueryFilter', column: string, filterOp: FilterOp, value: { __typename?: 'QueryFilterValue', string?: string | null, float?: number | null, boolean?: boolean | null, stringArray?: Array<string> | null, floatArray?: Array<number> | null, millisFromNow?: number | null, relativeTime?: { __typename?: 'RelativeTime', quantity: number, unit: TimeUnit, direction: ReferenceDirection } | null } }> }> | null, any_exclusions?: Array<{ __typename?: 'SegmentFilter', foreign_table?: string | null, group?: string | null, parameters: Array<{ __typename?: 'QueryFilter', column: string, filterOp: FilterOp, value: { __typename?: 'QueryFilterValue', string?: string | null, float?: number | null, boolean?: boolean | null, stringArray?: Array<string> | null, floatArray?: Array<number> | null, millisFromNow?: number | null, relativeTime?: { __typename?: 'RelativeTime', quantity: number, unit: TimeUnit, direction: ReferenceDirection } | null } }> }> | null, any_other_exclusions?: Array<{ __typename?: 'SegmentFilter', foreign_table?: string | null, group?: string | null, parameters: Array<{ __typename?: 'QueryFilter', column: string, filterOp: FilterOp, value: { __typename?: 'QueryFilterValue', string?: string | null, float?: number | null, boolean?: boolean | null, stringArray?: Array<string> | null, floatArray?: Array<number> | null, millisFromNow?: number | null, relativeTime?: { __typename?: 'RelativeTime', quantity: number, unit: TimeUnit, direction: ReferenceDirection } | null } }> }> | null, filters?: Array<{ __typename?: 'CustomerSegmentFilter', filters: Array<{ __typename?: 'QueryFilter', column: string, filterOp: FilterOp, value: { __typename?: 'QueryFilterValue', string?: string | null, float?: number | null, boolean?: boolean | null, stringArray?: Array<string> | null, floatArray?: Array<number> | null, millisFromNow?: number | null, relativeTime?: { __typename?: 'RelativeTime', quantity: number, unit: TimeUnit, direction: ReferenceDirection } | null } }> }> | null, excluded_filters: Array<{ __typename?: 'CustomerSegmentFilter', filters: Array<{ __typename?: 'QueryFilter', column: string, filterOp: FilterOp, value: { __typename?: 'QueryFilterValue', string?: string | null, float?: number | null, boolean?: boolean | null, stringArray?: Array<string> | null, floatArray?: Array<number> | null, millisFromNow?: number | null, relativeTime?: { __typename?: 'RelativeTime', quantity: number, unit: TimeUnit, direction: ReferenceDirection } | null } }> }> } | null, referral_customer_segment?: { __typename?: 'CustomerSegment', id: string, name: string, trigger_entity?: CustomerSegmentTrigger | null, is_archived: boolean, updated_at: number, notification_templates?: Array<{ __typename?: 'NotificationTemplate', id: string, name: string, is_active: boolean, is_archived: boolean, message_methods: Array<MessageMethod> }> | null, error_flags?: Array<{ __typename?: 'CustomerSegmentErrorFlag', filter_column: string, filter_index: number, parameter_index: number, message: string }> | null, all_inclusions?: Array<{ __typename?: 'SegmentFilter', foreign_table?: string | null, group?: string | null, parameters: Array<{ __typename?: 'QueryFilter', column: string, filterOp: FilterOp, value: { __typename?: 'QueryFilterValue', string?: string | null, float?: number | null, boolean?: boolean | null, stringArray?: Array<string> | null, floatArray?: Array<number> | null, millisFromNow?: number | null, relativeTime?: { __typename?: 'RelativeTime', quantity: number, unit: TimeUnit, direction: ReferenceDirection } | null } }> }> | null, any_inclusions?: Array<{ __typename?: 'SegmentFilter', foreign_table?: string | null, group?: string | null, parameters: Array<{ __typename?: 'QueryFilter', column: string, filterOp: FilterOp, value: { __typename?: 'QueryFilterValue', string?: string | null, float?: number | null, boolean?: boolean | null, stringArray?: Array<string> | null, floatArray?: Array<number> | null, millisFromNow?: number | null, relativeTime?: { __typename?: 'RelativeTime', quantity: number, unit: TimeUnit, direction: ReferenceDirection } | null } }> }> | null, any_exclusions?: Array<{ __typename?: 'SegmentFilter', foreign_table?: string | null, group?: string | null, parameters: Array<{ __typename?: 'QueryFilter', column: string, filterOp: FilterOp, value: { __typename?: 'QueryFilterValue', string?: string | null, float?: number | null, boolean?: boolean | null, stringArray?: Array<string> | null, floatArray?: Array<number> | null, millisFromNow?: number | null, relativeTime?: { __typename?: 'RelativeTime', quantity: number, unit: TimeUnit, direction: ReferenceDirection } | null } }> }> | null, any_other_exclusions?: Array<{ __typename?: 'SegmentFilter', foreign_table?: string | null, group?: string | null, parameters: Array<{ __typename?: 'QueryFilter', column: string, filterOp: FilterOp, value: { __typename?: 'QueryFilterValue', string?: string | null, float?: number | null, boolean?: boolean | null, stringArray?: Array<string> | null, floatArray?: Array<number> | null, millisFromNow?: number | null, relativeTime?: { __typename?: 'RelativeTime', quantity: number, unit: TimeUnit, direction: ReferenceDirection } | null } }> }> | null, filters?: Array<{ __typename?: 'CustomerSegmentFilter', filters: Array<{ __typename?: 'QueryFilter', column: string, filterOp: FilterOp, value: { __typename?: 'QueryFilterValue', string?: string | null, float?: number | null, boolean?: boolean | null, stringArray?: Array<string> | null, floatArray?: Array<number> | null, millisFromNow?: number | null, relativeTime?: { __typename?: 'RelativeTime', quantity: number, unit: TimeUnit, direction: ReferenceDirection } | null } }> }> | null, excluded_filters: Array<{ __typename?: 'CustomerSegmentFilter', filters: Array<{ __typename?: 'QueryFilter', column: string, filterOp: FilterOp, value: { __typename?: 'QueryFilterValue', string?: string | null, float?: number | null, boolean?: boolean | null, stringArray?: Array<string> | null, floatArray?: Array<number> | null, millisFromNow?: number | null, relativeTime?: { __typename?: 'RelativeTime', quantity: number, unit: TimeUnit, direction: ReferenceDirection } | null } }> }> } | null, webhooks?: Array<{ __typename?: 'WebhookConfig', id: string, name: string, url: string, events: Array<WebhookEventType>, secret?: string | null, enabled: boolean }> | null, times_first_filter_config?: { __typename?: 'TimesFirstFilterConfig', service?: BookingFilterDisplayMode | null, clinician?: BookingFilterDisplayMode | null, species?: BookingFilterDisplayMode | null, client_status?: BookingFilterDisplayMode | null, patient_status?: BookingFilterDisplayMode | null, patient_gender?: BookingFilterDisplayMode | null, fixed_status?: BookingFilterDisplayMode | null } | null } | null, onboarding?: { __typename?: 'ClinicOnboarding', has_set_hours?: boolean | null, has_synced_pms?: boolean | null } | null, organization?: { __typename?: 'Organization', id: string } | null, features?: { __typename?: 'ClinicFeatures', scheduling_enabled?: boolean | null, huddle_enabled?: boolean | null, payments_enabled?: boolean | null, messaging_enabled?: boolean | null, reviews_enabled?: boolean | null, loyalty_enabled?: boolean | null, notifs_enabled?: boolean | null, forms_enabled?: boolean | null, help_enabled?: boolean | null, bulk_messaging_enabled?: boolean | null, portal_enabled?: boolean | null, calls_enabled?: boolean | null, teamchat_enabled?: boolean | null, prescriptions_enabled?: boolean | null, medical_history_enabled?: boolean | null, pet_selfies_enabled?: boolean | null } | null, hours?: { __typename?: 'AvailabilityHours', monday?: Array<{ __typename?: 'TimeInterval', start?: number | null, end?: number | null }> | null, tuesday?: Array<{ __typename?: 'TimeInterval', start?: number | null, end?: number | null }> | null, wednesday?: Array<{ __typename?: 'TimeInterval', start?: number | null, end?: number | null }> | null, thursday?: Array<{ __typename?: 'TimeInterval', start?: number | null, end?: number | null }> | null, friday?: Array<{ __typename?: 'TimeInterval', start?: number | null, end?: number | null }> | null, saturday?: Array<{ __typename?: 'TimeInterval', start?: number | null, end?: number | null }> | null, sunday?: Array<{ __typename?: 'TimeInterval', start?: number | null, end?: number | null }> | null } | null, clinic_hours?: { __typename?: 'AvailabilityHours', monday?: Array<{ __typename?: 'TimeInterval', start?: number | null, end?: number | null }> | null, tuesday?: Array<{ __typename?: 'TimeInterval', start?: number | null, end?: number | null }> | null, wednesday?: Array<{ __typename?: 'TimeInterval', start?: number | null, end?: number | null }> | null, thursday?: Array<{ __typename?: 'TimeInterval', start?: number | null, end?: number | null }> | null, friday?: Array<{ __typename?: 'TimeInterval', start?: number | null, end?: number | null }> | null, saturday?: Array<{ __typename?: 'TimeInterval', start?: number | null, end?: number | null }> | null, sunday?: Array<{ __typename?: 'TimeInterval', start?: number | null, end?: number | null }> | null } | null, adjusted_availability?: Array<{ __typename?: 'Availability', date: number, pms_appt_type_pms_id?: string | null, times: Array<{ __typename?: 'TimeInterval', start?: number | null, end?: number | null }>, repeat?: { __typename?: 'RepeatAvailability', daysOfMonth?: Array<number> | null, daysOfWeek?: Array<DayOfWeek> | null, weekOfMonth?: WeekOfMonth | null, frequency: any, unit: RepeatUnit, end_date?: number | null } | null }> | null, pms_adjusted_availability?: Array<{ __typename?: 'Availability', date: number, pms_appt_type_pms_id?: string | null, times: Array<{ __typename?: 'TimeInterval', start?: number | null, end?: number | null }>, repeat?: { __typename?: 'RepeatAvailability', daysOfMonth?: Array<number> | null, daysOfWeek?: Array<DayOfWeek> | null, weekOfMonth?: WeekOfMonth | null, frequency: any, unit: RepeatUnit, end_date?: number | null } | null }> | null, last_sync_times?: { __typename?: 'LastSyncTimes', last_full_sync?: number | null, last_sync_appointments?: number | null, last_sync_clients?: number | null, last_sync_patients?: number | null, last_sync_clinicians?: number | null, last_sync_services?: number | null, last_sync_transactions?: number | null, last_sync_invoices?: number | null, last_sync_history_items?: number | null, last_sync_diagnoses?: number | null, last_sync_prescriptions?: number | null, last_sync_products?: number | null, last_sync_rooms?: number | null, last_sync_species?: number | null, last_sync_breeds?: number | null, last_sync_reminders?: number | null, last_sync_reminder_types?: number | null, last_sync_vaccination_records?: number | null, last_sync_clinic_sexes?: number | null, last_sync_appt_statuses?: number | null, last_sync_blockoffs?: number | null, last_sync_invoice_items?: number | null } | null, pims_settings?: { __typename?: 'PimsSettings', ezyvet_integration_mode?: EzyvetIntegrationMode | null, entered_by_pms_id?: string | null } | null } };

export type SetClinicGoLiveDateMutationVariables = Exact<{
  clinicId: Scalars['ID']['input'];
  goLiveDate?: InputMaybe<Scalars['String']['input']>;
}>;


export type SetClinicGoLiveDateMutation = { __typename?: 'Mutation', setClinicGoLiveDate?: string | null };

export type UpdateClinicMutationVariables = Exact<{
  id: Scalars['ID']['input'];
  data: UpdateClinicInput;
}>;


export type UpdateClinicMutation = { __typename?: 'Mutation', updateClinic: { __typename?: 'Clinic', id: string, slug?: string | null, name?: string | null, description?: string | null, email?: string | null, phone?: string | null, send_from_phone?: string | null, send_from_email?: string | null, reply_to_email?: string | null, website?: string | null, pms: PracticeManagementSystem, pms_connector: PmsConnector, pms_api_key?: string | null, pms_additional_key?: string | null, office_emails?: Array<string> | null, stripe_accounts_enabled?: Array<StripeAccountType> | null, stripe_account_type?: string | null, stripe_customer_id?: string | null, avatar_url?: string | null, go_live_date?: string | null, time_zone?: string | null, is_archived: boolean, location?: string | null, tmp_feature_flags?: any | null, mute_until?: number | null, created_at: number, updated_at: number, pms_db?: { __typename?: 'PmsDb', id: string, name: string, last_sync_times?: { __typename?: 'LastSyncTimes', last_full_sync?: number | null, last_sync_appointments?: number | null, last_sync_clients?: number | null, last_sync_patients?: number | null, last_sync_clinicians?: number | null, last_sync_services?: number | null, last_sync_transactions?: number | null, last_sync_invoices?: number | null, last_sync_history_items?: number | null, last_sync_diagnoses?: number | null, last_sync_prescriptions?: number | null, last_sync_products?: number | null, last_sync_rooms?: number | null, last_sync_species?: number | null, last_sync_breeds?: number | null, last_sync_reminders?: number | null, last_sync_reminder_types?: number | null, last_sync_vaccination_records?: number | null, last_sync_clinic_sexes?: number | null, last_sync_appt_statuses?: number | null, last_sync_blockoffs?: number | null, last_sync_invoice_items?: number | null } | null } | null, clinic_admins: Array<{ __typename?: 'ClinicAdmin', id: string, role: AuthRoles, are_email_notifications_enabled: boolean, are_sms_notifications_enabled: boolean, are_desktop_notifications_enabled: boolean, should_hide_daily_huddle_financials: boolean, created_at: number, updated_at: number, clinic: { __typename?: 'Clinic', id: string, name?: string | null, slug?: string | null, avatar_url?: string | null, is_verified?: boolean | null, is_archived: boolean, description?: string | null, pms: PracticeManagementSystem, time_zone?: string | null, last_sync_times?: { __typename?: 'LastSyncTimes', last_full_sync?: number | null } | null, clinic_admins: Array<{ __typename?: 'ClinicAdmin', id: string }>, organization?: { __typename?: 'Organization', id: string } | null, address?: { __typename?: 'Address', street_a?: string | null, street_b?: string | null, city?: string | null, state?: string | null, zip?: string | null, country?: string | null, lat?: number | null, lng?: number | null } | null }, user: { __typename?: 'User', id: string, first_name?: string | null, last_name?: string | null, email?: any | null, phone?: string | null, phone_country?: string | null, avatar_url?: string | null, role?: AuthRoles | null, enabled_notification_sounds?: Array<UserNotificationSound> | null, notify_email_on?: Array<NotifyClinicOn> | null, notify_sound_on?: Array<NotifyClinicOn> | null, notify_desktop_on?: Array<NotifyClinicOn> | null, must_reset_password?: boolean | null, invitation_status?: UserInvitationStatus | null, invited_at?: number | null, created_at: number, updated_at: number }, custom_role?: { __typename?: 'CustomRole', id: string, name: string } | null, permissions?: Array<{ __typename?: 'ClinicAdminPermission', feature: AdminPermissionFeature, access_level: AdminPermissionAccessLevel }> | null }>, address?: { __typename?: 'Address', street_a?: string | null, street_b?: string | null, city?: string | null, state?: string | null, zip?: string | null, country?: string | null } | null, services: Array<{ __typename?: 'Service', id: string, name?: string | null }>, settings?: { __typename?: 'ClinicSettings', id?: string | null, does_require_verification?: boolean | null, does_use_automatic_reschedule?: boolean | null, reset_status_to_booked_on_reschedule?: boolean | null, is_using_detailed_services?: boolean | null, hide_review_step?: boolean | null, is_using_rooms?: boolean | null, pms_start_time?: any | null, pms_end_time?: any | null, primary_color?: string | null, accent_color?: string | null, secondary_color?: string | null, new_appt_requested_msg?: string | null, new_appt_approved_msg?: string | null, new_appt_approved_sms_msg?: string | null, new_appt_denied_msg?: string | null, schedule_method?: ScheduleMethod | null, scheduling_buffer_minutes?: number | null, base_schedule_duration?: number | null, does_require_referral?: boolean | null, appointment_entry_method?: AppointmentEntryMethod | null, scheduling_min_minutes_away?: number | null, scheduling_max_minutes_away?: number | null, included_species?: Array<Species> | null, max_patients_per_visit?: number | null, should_complete_sync?: boolean | null, server_syncing_only?: boolean | null, confirmation_days_before?: number | null, send_confirmations_to: SendConfirmationsTo, send_new_appt_email?: boolean | null, send_reviews_to?: SendConfirmationsTo | null, max_review_rating_for_notif?: number | null, google_review_link?: string | null, facebook_review_link?: string | null, non_blocking_services: Array<string>, yesterday_revenue?: number | null, this_month_revenue?: number | null, hide_clinician_preference: boolean, does_use_rooms_to_schedule?: boolean | null, primary_room_pms_id?: string | null, should_default_pims_emails_on: boolean, should_default_pims_sms_on: boolean, should_default_marketing_sms_on: boolean, should_default_marketing_email_on: boolean, does_use_clinicians_to_schedule?: boolean | null, time_slot_minutes: number, sync_interval_minutes: number, long_sync_interval_hours: number, primary_clinician_pms_id?: string | null, cancellation_clinician_pms_id?: string | null, cancellation_service_pms_id?: string | null, allow_first_appt_per_day?: boolean | null, custom_well_description?: string | null, custom_sick_description?: string | null, custom_other_title?: string | null, custom_other_description?: string | null, default_trigger_words?: Array<string> | null, should_use_private_reviews?: boolean | null, notify_clinic_on?: Array<NotifyClinicOn> | null, reminder_send_time_minutes?: number | null, does_require_new_client_address?: boolean | null, does_require_new_client_birthday?: boolean | null, should_allow_new_clients?: boolean | null, should_allow_new_patients?: boolean | null, should_create_clients?: boolean | null, should_create_patients?: boolean | null, msgs_auto_priority?: boolean | null, booking_match_procedure?: BookingMatchProcedure | null, urgency_type?: UrgencyType | null, max_booking_columns?: number | null, hide_closed_days_from_scheduling?: boolean | null, should_sync_reminders?: boolean | null, auto_reply_enabled: boolean, auto_reply_message?: string | null, unreplied_message_alert_enabled: boolean, unreplied_message_alert_minutes: number, comms_writeback_enabled: boolean, comms_should_daily_writeback: boolean, comms_use_pdf_for_writeback: boolean, comms_writeback_buffer_minutes: number, comms_writeback_before_appt_mins: number, comms_should_writeback_on_send: boolean, comms_should_writeback_on_receive: boolean, comms_should_writeback_notifs: boolean, comms_should_use_ai_writeback: boolean, form_writeback_enabled: boolean, should_award_loyalty_for_invoices?: boolean | null, invoice_loyalty_points_per_dollar?: number | null, app_download_loyalty_points?: number | null, referrer_loyalty_points?: number | null, referred_loyalty_points?: number | null, custom_appointment_notes_template?: string | null, custom_new_client_notes_template?: string | null, custom_new_patient_notes_template?: string | null, max_inactivity_duration?: number | null, hide_portal_vaccinations: boolean, hide_portal_reminders: boolean, hide_portal_prescriptions: boolean, hide_portal_weight: boolean, hide_soc_vaccinations?: boolean | null, hide_historic_vaccinations?: boolean | null, should_hide_daily_huddle_financials: boolean, patient_details_tab_order: Array<PortalPatientDetailsTab>, clinic_hours_display?: string | null, reschedule_buffer_minutes?: number | null, cancellation_buffer_minutes?: number | null, require_reason_for_cancellation?: boolean | null, should_automatically_assign_patient?: boolean | null, payment_writeback_enabled: boolean, auto_refund_on_cancel: boolean, status_set_on_payment_completed_pms_id?: string | null, max_booking_notes_length?: number | null, min_booking_notes_length?: number | null, primary_clinic_group_id?: string | null, should_suggest_nearby_clinics?: boolean | null, sms_block_list?: Array<string> | null, exclude_message_wrapper?: boolean | null, should_charge_client_stripe_fees?: boolean | null, chckvet_prescription_fee_split_percentage?: number | null, gtm_container_id?: string | null, review_google_id?: string | null, review_facebook_id?: string | null, only_use_adj_avail_guides: boolean, use_basic_timeslots: boolean, valid_booking_interval_minutes?: Array<number> | null, should_disable_online_scheduling?: boolean | null, simple_scheduling_rules_enabled: boolean, compliance_statuses?: Array<string> | null, should_use_instant_prescription_requests?: boolean | null, prescription_pickup_service_id?: string | null, default_reminder_service_id?: string | null, ai_calls_provider?: PhoneProviderType | null, ai_calls_phone_number?: string | null, ai_calls_voice_id?: string | null, ai_calls_agent_id?: string | null, ai_agent_style?: string | null, ai_agent_custom_instructions?: string | null, ai_calls_ambient_sound?: AiCallsAmbientSound | null, ai_calls_voice_speed?: number | null, ai_calls_interruption_sensitivity?: number | null, ai_calls_enable_dynamic_voice_speed?: boolean | null, usage_spending_caps?: any | null, custom_merge_tags?: any | null, custom_booking_copy?: { __typename?: 'ClinicBookingCopy', WIDGET_HEADER_TITLE?: string | null, SHOW_CLINIC_HEADER_LOGO?: boolean | null, CLINIC_HEADER_LOGO_HEIGHT?: number | null, SERVICE_TYPE_SECTION_HEADING?: string | null, DEFAULT_WELLNESS_DESCRIPTION?: string | null, DEFAULT_SICK_DESCRIPTION?: string | null, DEFAULT_OTHER_DESCRIPTION?: string | null, RETURNING_PATIENT_QUESTION?: string | null, POSITIVE_RETURNING_PATIENT_ANSWER?: string | null, NEGATIVE_RETURNING_PATIENT_ANSWER?: string | null, RETURNING_CLIENT_QUESTION?: string | null, POSITIVE_RETURNING_CLIENT_ANSWER?: string | null, NEGATIVE_RETURNING_CLIENT_ANSWER?: string | null, CLIENT_INFORMATION_SECTION_TITLE?: string | null, PATIENT_INFORMATION_SECTION_TITLE?: string | null, RETURNING_CLIENT_PATIENT_TITLE?: string | null, RETURNING_CLIENT_PATIENT_DESCRIPTION?: string | null, SERVICE_SECTION_TITLE?: string | null, PREPAID_SERVICES_LABEL?: string | null, STANDARD_SERVICES_LABEL?: string | null, DEPOSIT_FEE_NAME?: string | null, PREVIOUS_OR_REFERRING_CLINIC_QUESTION?: string | null, CONTACT_THE_CLINIC_TEXT?: string | null, CONTACT_THE_CLINIC_TEXT_COLOR?: string | null, CONTACT_THE_CLINIC_TEXT_SIZE?: string | null, SELECT_CLINICIAN_TITLE?: string | null, SELECT_CLINICIAN_POSITIVE_ANSWER?: string | null, SELECT_CLINICIAN_NEGATIVE_ANSWER?: string | null, SELECT_TIME_TITLE?: string | null, REVIEW_TITLE?: string | null, REVIEW_NOTES_PROMPT?: string | null, PAYMENT_INFORMATION_TITLE?: string | null, TRIGGER_WORDS_DETECTED_HEADER?: string | null, TRIGGER_WORDS_DETECTED_DESCRIPTION?: string | null, CONFIRMATION_SCREEN_TITLE?: string | null, CONFIRMATION_SCREEN_DESCRIPTION?: string | null, NEW_CLIENT_BLOCKED_MESSAGE?: string | null, NEW_PATIENT_BLOCKED_MESSAGE?: string | null } | null, auto_reply_hours?: { __typename?: 'AvailabilityHours', monday?: Array<{ __typename?: 'TimeInterval', start?: number | null, end?: number | null }> | null, tuesday?: Array<{ __typename?: 'TimeInterval', start?: number | null, end?: number | null }> | null, wednesday?: Array<{ __typename?: 'TimeInterval', start?: number | null, end?: number | null }> | null, thursday?: Array<{ __typename?: 'TimeInterval', start?: number | null, end?: number | null }> | null, friday?: Array<{ __typename?: 'TimeInterval', start?: number | null, end?: number | null }> | null, saturday?: Array<{ __typename?: 'TimeInterval', start?: number | null, end?: number | null }> | null, sunday?: Array<{ __typename?: 'TimeInterval', start?: number | null, end?: number | null }> | null } | null, portal_links?: Array<{ __typename?: 'PortalLink', label: string, url: string }> | null, custom_reviews_copy?: { __typename?: 'ClinicReviewsCopy', REVIEW_METHOD_PAGE_TITLE?: string | null, REVIEW_METHOD_PAGE_DESCRIPTION?: string | null, PRIVATE_REVIEW_BUTTON_HELP_TEXT?: string | null, PRIVATE_REVIEW_BUTTON_TEXT?: string | null, REVIEW_PAGE_TITLE?: string | null, REVIEW_PAGE_SUBTITLE?: string | null, REVIEW_SCORE_LABEL?: string | null, REVIEW_MESSAGE_LABEL?: string | null, REVIEW_SUBMIT_BUTTON_TEXT?: string | null } | null, waitlist_customer_segment?: { __typename?: 'CustomerSegment', id: string, name: string, trigger_entity?: CustomerSegmentTrigger | null, is_archived: boolean, updated_at: number, notification_templates?: Array<{ __typename?: 'NotificationTemplate', id: string, name: string, is_active: boolean, is_archived: boolean, message_methods: Array<MessageMethod> }> | null, error_flags?: Array<{ __typename?: 'CustomerSegmentErrorFlag', filter_column: string, filter_index: number, parameter_index: number, message: string }> | null, all_inclusions?: Array<{ __typename?: 'SegmentFilter', foreign_table?: string | null, group?: string | null, parameters: Array<{ __typename?: 'QueryFilter', column: string, filterOp: FilterOp, value: { __typename?: 'QueryFilterValue', string?: string | null, float?: number | null, boolean?: boolean | null, stringArray?: Array<string> | null, floatArray?: Array<number> | null, millisFromNow?: number | null, relativeTime?: { __typename?: 'RelativeTime', quantity: number, unit: TimeUnit, direction: ReferenceDirection } | null } }> }> | null, any_inclusions?: Array<{ __typename?: 'SegmentFilter', foreign_table?: string | null, group?: string | null, parameters: Array<{ __typename?: 'QueryFilter', column: string, filterOp: FilterOp, value: { __typename?: 'QueryFilterValue', string?: string | null, float?: number | null, boolean?: boolean | null, stringArray?: Array<string> | null, floatArray?: Array<number> | null, millisFromNow?: number | null, relativeTime?: { __typename?: 'RelativeTime', quantity: number, unit: TimeUnit, direction: ReferenceDirection } | null } }> }> | null, any_exclusions?: Array<{ __typename?: 'SegmentFilter', foreign_table?: string | null, group?: string | null, parameters: Array<{ __typename?: 'QueryFilter', column: string, filterOp: FilterOp, value: { __typename?: 'QueryFilterValue', string?: string | null, float?: number | null, boolean?: boolean | null, stringArray?: Array<string> | null, floatArray?: Array<number> | null, millisFromNow?: number | null, relativeTime?: { __typename?: 'RelativeTime', quantity: number, unit: TimeUnit, direction: ReferenceDirection } | null } }> }> | null, any_other_exclusions?: Array<{ __typename?: 'SegmentFilter', foreign_table?: string | null, group?: string | null, parameters: Array<{ __typename?: 'QueryFilter', column: string, filterOp: FilterOp, value: { __typename?: 'QueryFilterValue', string?: string | null, float?: number | null, boolean?: boolean | null, stringArray?: Array<string> | null, floatArray?: Array<number> | null, millisFromNow?: number | null, relativeTime?: { __typename?: 'RelativeTime', quantity: number, unit: TimeUnit, direction: ReferenceDirection } | null } }> }> | null, filters?: Array<{ __typename?: 'CustomerSegmentFilter', filters: Array<{ __typename?: 'QueryFilter', column: string, filterOp: FilterOp, value: { __typename?: 'QueryFilterValue', string?: string | null, float?: number | null, boolean?: boolean | null, stringArray?: Array<string> | null, floatArray?: Array<number> | null, millisFromNow?: number | null, relativeTime?: { __typename?: 'RelativeTime', quantity: number, unit: TimeUnit, direction: ReferenceDirection } | null } }> }> | null, excluded_filters: Array<{ __typename?: 'CustomerSegmentFilter', filters: Array<{ __typename?: 'QueryFilter', column: string, filterOp: FilterOp, value: { __typename?: 'QueryFilterValue', string?: string | null, float?: number | null, boolean?: boolean | null, stringArray?: Array<string> | null, floatArray?: Array<number> | null, millisFromNow?: number | null, relativeTime?: { __typename?: 'RelativeTime', quantity: number, unit: TimeUnit, direction: ReferenceDirection } | null } }> }> } | null, blocklist_customer_segment?: { __typename?: 'CustomerSegment', id: string, name: string, trigger_entity?: CustomerSegmentTrigger | null, is_archived: boolean, updated_at: number, notification_templates?: Array<{ __typename?: 'NotificationTemplate', id: string, name: string, is_active: boolean, is_archived: boolean, message_methods: Array<MessageMethod> }> | null, error_flags?: Array<{ __typename?: 'CustomerSegmentErrorFlag', filter_column: string, filter_index: number, parameter_index: number, message: string }> | null, all_inclusions?: Array<{ __typename?: 'SegmentFilter', foreign_table?: string | null, group?: string | null, parameters: Array<{ __typename?: 'QueryFilter', column: string, filterOp: FilterOp, value: { __typename?: 'QueryFilterValue', string?: string | null, float?: number | null, boolean?: boolean | null, stringArray?: Array<string> | null, floatArray?: Array<number> | null, millisFromNow?: number | null, relativeTime?: { __typename?: 'RelativeTime', quantity: number, unit: TimeUnit, direction: ReferenceDirection } | null } }> }> | null, any_inclusions?: Array<{ __typename?: 'SegmentFilter', foreign_table?: string | null, group?: string | null, parameters: Array<{ __typename?: 'QueryFilter', column: string, filterOp: FilterOp, value: { __typename?: 'QueryFilterValue', string?: string | null, float?: number | null, boolean?: boolean | null, stringArray?: Array<string> | null, floatArray?: Array<number> | null, millisFromNow?: number | null, relativeTime?: { __typename?: 'RelativeTime', quantity: number, unit: TimeUnit, direction: ReferenceDirection } | null } }> }> | null, any_exclusions?: Array<{ __typename?: 'SegmentFilter', foreign_table?: string | null, group?: string | null, parameters: Array<{ __typename?: 'QueryFilter', column: string, filterOp: FilterOp, value: { __typename?: 'QueryFilterValue', string?: string | null, float?: number | null, boolean?: boolean | null, stringArray?: Array<string> | null, floatArray?: Array<number> | null, millisFromNow?: number | null, relativeTime?: { __typename?: 'RelativeTime', quantity: number, unit: TimeUnit, direction: ReferenceDirection } | null } }> }> | null, any_other_exclusions?: Array<{ __typename?: 'SegmentFilter', foreign_table?: string | null, group?: string | null, parameters: Array<{ __typename?: 'QueryFilter', column: string, filterOp: FilterOp, value: { __typename?: 'QueryFilterValue', string?: string | null, float?: number | null, boolean?: boolean | null, stringArray?: Array<string> | null, floatArray?: Array<number> | null, millisFromNow?: number | null, relativeTime?: { __typename?: 'RelativeTime', quantity: number, unit: TimeUnit, direction: ReferenceDirection } | null } }> }> | null, filters?: Array<{ __typename?: 'CustomerSegmentFilter', filters: Array<{ __typename?: 'QueryFilter', column: string, filterOp: FilterOp, value: { __typename?: 'QueryFilterValue', string?: string | null, float?: number | null, boolean?: boolean | null, stringArray?: Array<string> | null, floatArray?: Array<number> | null, millisFromNow?: number | null, relativeTime?: { __typename?: 'RelativeTime', quantity: number, unit: TimeUnit, direction: ReferenceDirection } | null } }> }> | null, excluded_filters: Array<{ __typename?: 'CustomerSegmentFilter', filters: Array<{ __typename?: 'QueryFilter', column: string, filterOp: FilterOp, value: { __typename?: 'QueryFilterValue', string?: string | null, float?: number | null, boolean?: boolean | null, stringArray?: Array<string> | null, floatArray?: Array<number> | null, millisFromNow?: number | null, relativeTime?: { __typename?: 'RelativeTime', quantity: number, unit: TimeUnit, direction: ReferenceDirection } | null } }> }> } | null, referral_customer_segment?: { __typename?: 'CustomerSegment', id: string, name: string, trigger_entity?: CustomerSegmentTrigger | null, is_archived: boolean, updated_at: number, notification_templates?: Array<{ __typename?: 'NotificationTemplate', id: string, name: string, is_active: boolean, is_archived: boolean, message_methods: Array<MessageMethod> }> | null, error_flags?: Array<{ __typename?: 'CustomerSegmentErrorFlag', filter_column: string, filter_index: number, parameter_index: number, message: string }> | null, all_inclusions?: Array<{ __typename?: 'SegmentFilter', foreign_table?: string | null, group?: string | null, parameters: Array<{ __typename?: 'QueryFilter', column: string, filterOp: FilterOp, value: { __typename?: 'QueryFilterValue', string?: string | null, float?: number | null, boolean?: boolean | null, stringArray?: Array<string> | null, floatArray?: Array<number> | null, millisFromNow?: number | null, relativeTime?: { __typename?: 'RelativeTime', quantity: number, unit: TimeUnit, direction: ReferenceDirection } | null } }> }> | null, any_inclusions?: Array<{ __typename?: 'SegmentFilter', foreign_table?: string | null, group?: string | null, parameters: Array<{ __typename?: 'QueryFilter', column: string, filterOp: FilterOp, value: { __typename?: 'QueryFilterValue', string?: string | null, float?: number | null, boolean?: boolean | null, stringArray?: Array<string> | null, floatArray?: Array<number> | null, millisFromNow?: number | null, relativeTime?: { __typename?: 'RelativeTime', quantity: number, unit: TimeUnit, direction: ReferenceDirection } | null } }> }> | null, any_exclusions?: Array<{ __typename?: 'SegmentFilter', foreign_table?: string | null, group?: string | null, parameters: Array<{ __typename?: 'QueryFilter', column: string, filterOp: FilterOp, value: { __typename?: 'QueryFilterValue', string?: string | null, float?: number | null, boolean?: boolean | null, stringArray?: Array<string> | null, floatArray?: Array<number> | null, millisFromNow?: number | null, relativeTime?: { __typename?: 'RelativeTime', quantity: number, unit: TimeUnit, direction: ReferenceDirection } | null } }> }> | null, any_other_exclusions?: Array<{ __typename?: 'SegmentFilter', foreign_table?: string | null, group?: string | null, parameters: Array<{ __typename?: 'QueryFilter', column: string, filterOp: FilterOp, value: { __typename?: 'QueryFilterValue', string?: string | null, float?: number | null, boolean?: boolean | null, stringArray?: Array<string> | null, floatArray?: Array<number> | null, millisFromNow?: number | null, relativeTime?: { __typename?: 'RelativeTime', quantity: number, unit: TimeUnit, direction: ReferenceDirection } | null } }> }> | null, filters?: Array<{ __typename?: 'CustomerSegmentFilter', filters: Array<{ __typename?: 'QueryFilter', column: string, filterOp: FilterOp, value: { __typename?: 'QueryFilterValue', string?: string | null, float?: number | null, boolean?: boolean | null, stringArray?: Array<string> | null, floatArray?: Array<number> | null, millisFromNow?: number | null, relativeTime?: { __typename?: 'RelativeTime', quantity: number, unit: TimeUnit, direction: ReferenceDirection } | null } }> }> | null, excluded_filters: Array<{ __typename?: 'CustomerSegmentFilter', filters: Array<{ __typename?: 'QueryFilter', column: string, filterOp: FilterOp, value: { __typename?: 'QueryFilterValue', string?: string | null, float?: number | null, boolean?: boolean | null, stringArray?: Array<string> | null, floatArray?: Array<number> | null, millisFromNow?: number | null, relativeTime?: { __typename?: 'RelativeTime', quantity: number, unit: TimeUnit, direction: ReferenceDirection } | null } }> }> } | null, webhooks?: Array<{ __typename?: 'WebhookConfig', id: string, name: string, url: string, events: Array<WebhookEventType>, secret?: string | null, enabled: boolean }> | null, times_first_filter_config?: { __typename?: 'TimesFirstFilterConfig', service?: BookingFilterDisplayMode | null, clinician?: BookingFilterDisplayMode | null, species?: BookingFilterDisplayMode | null, client_status?: BookingFilterDisplayMode | null, patient_status?: BookingFilterDisplayMode | null, patient_gender?: BookingFilterDisplayMode | null, fixed_status?: BookingFilterDisplayMode | null } | null } | null, onboarding?: { __typename?: 'ClinicOnboarding', has_set_hours?: boolean | null, has_synced_pms?: boolean | null } | null, organization?: { __typename?: 'Organization', id: string } | null, features?: { __typename?: 'ClinicFeatures', scheduling_enabled?: boolean | null, huddle_enabled?: boolean | null, payments_enabled?: boolean | null, messaging_enabled?: boolean | null, reviews_enabled?: boolean | null, loyalty_enabled?: boolean | null, notifs_enabled?: boolean | null, forms_enabled?: boolean | null, help_enabled?: boolean | null, bulk_messaging_enabled?: boolean | null, portal_enabled?: boolean | null, calls_enabled?: boolean | null, teamchat_enabled?: boolean | null, prescriptions_enabled?: boolean | null, medical_history_enabled?: boolean | null, pet_selfies_enabled?: boolean | null } | null, hours?: { __typename?: 'AvailabilityHours', monday?: Array<{ __typename?: 'TimeInterval', start?: number | null, end?: number | null }> | null, tuesday?: Array<{ __typename?: 'TimeInterval', start?: number | null, end?: number | null }> | null, wednesday?: Array<{ __typename?: 'TimeInterval', start?: number | null, end?: number | null }> | null, thursday?: Array<{ __typename?: 'TimeInterval', start?: number | null, end?: number | null }> | null, friday?: Array<{ __typename?: 'TimeInterval', start?: number | null, end?: number | null }> | null, saturday?: Array<{ __typename?: 'TimeInterval', start?: number | null, end?: number | null }> | null, sunday?: Array<{ __typename?: 'TimeInterval', start?: number | null, end?: number | null }> | null } | null, clinic_hours?: { __typename?: 'AvailabilityHours', monday?: Array<{ __typename?: 'TimeInterval', start?: number | null, end?: number | null }> | null, tuesday?: Array<{ __typename?: 'TimeInterval', start?: number | null, end?: number | null }> | null, wednesday?: Array<{ __typename?: 'TimeInterval', start?: number | null, end?: number | null }> | null, thursday?: Array<{ __typename?: 'TimeInterval', start?: number | null, end?: number | null }> | null, friday?: Array<{ __typename?: 'TimeInterval', start?: number | null, end?: number | null }> | null, saturday?: Array<{ __typename?: 'TimeInterval', start?: number | null, end?: number | null }> | null, sunday?: Array<{ __typename?: 'TimeInterval', start?: number | null, end?: number | null }> | null } | null, adjusted_availability?: Array<{ __typename?: 'Availability', date: number, pms_appt_type_pms_id?: string | null, times: Array<{ __typename?: 'TimeInterval', start?: number | null, end?: number | null }>, repeat?: { __typename?: 'RepeatAvailability', daysOfMonth?: Array<number> | null, daysOfWeek?: Array<DayOfWeek> | null, weekOfMonth?: WeekOfMonth | null, frequency: any, unit: RepeatUnit, end_date?: number | null } | null }> | null, pms_adjusted_availability?: Array<{ __typename?: 'Availability', date: number, pms_appt_type_pms_id?: string | null, times: Array<{ __typename?: 'TimeInterval', start?: number | null, end?: number | null }>, repeat?: { __typename?: 'RepeatAvailability', daysOfMonth?: Array<number> | null, daysOfWeek?: Array<DayOfWeek> | null, weekOfMonth?: WeekOfMonth | null, frequency: any, unit: RepeatUnit, end_date?: number | null } | null }> | null, last_sync_times?: { __typename?: 'LastSyncTimes', last_full_sync?: number | null, last_sync_appointments?: number | null, last_sync_clients?: number | null, last_sync_patients?: number | null, last_sync_clinicians?: number | null, last_sync_services?: number | null, last_sync_transactions?: number | null, last_sync_invoices?: number | null, last_sync_history_items?: number | null, last_sync_diagnoses?: number | null, last_sync_prescriptions?: number | null, last_sync_products?: number | null, last_sync_rooms?: number | null, last_sync_species?: number | null, last_sync_breeds?: number | null, last_sync_reminders?: number | null, last_sync_reminder_types?: number | null, last_sync_vaccination_records?: number | null, last_sync_clinic_sexes?: number | null, last_sync_appt_statuses?: number | null, last_sync_blockoffs?: number | null, last_sync_invoice_items?: number | null } | null, pims_settings?: { __typename?: 'PimsSettings', ezyvet_integration_mode?: EzyvetIntegrationMode | null, entered_by_pms_id?: string | null } | null } };

export type DeleteClinicMutationVariables = Exact<{
  id: Scalars['ID']['input'];
}>;


export type DeleteClinicMutation = { __typename?: 'Mutation', deleteClinic?: any | null };

export type ConnectInstallationFieldsFragment = { __typename?: 'ConnectInstallation', id: string, computer_name?: string | null, last_ping?: number | null, is_server?: boolean | null, version?: string | null, connect_ui_version?: string | null, connect_server_version?: string | null, created_at: number, updated_at: number };

export type GetConnectInstallationQueryVariables = Exact<{
  clinicId: Scalars['ID']['input'];
  installationId: Scalars['ID']['input'];
}>;


export type GetConnectInstallationQuery = { __typename?: 'Query', connectInstallation: { __typename?: 'ConnectInstallation', id: string, computer_name?: string | null, last_ping?: number | null, is_server?: boolean | null, version?: string | null, connect_ui_version?: string | null, connect_server_version?: string | null, created_at: number, updated_at: number } };

export type GetConnectInstallationsByClinicQueryVariables = Exact<{
  clinicId: Scalars['ID']['input'];
}>;


export type GetConnectInstallationsByClinicQuery = { __typename?: 'Query', getConnectInstallationsByClinic: Array<{ __typename?: 'ConnectInstallation', id: string, computer_name?: string | null, last_ping?: number | null, is_server?: boolean | null, version?: string | null, connect_ui_version?: string | null, connect_server_version?: string | null, created_at: number, updated_at: number }> };

export type CheckIfServerRunningQueryVariables = Exact<{
  clinicId: Scalars['ID']['input'];
}>;


export type CheckIfServerRunningQuery = { __typename?: 'Query', checkIfServerRunning: boolean };

export type GetLastServerHeartbeatForClinicQueryVariables = Exact<{
  clinicId: Scalars['ID']['input'];
}>;


export type GetLastServerHeartbeatForClinicQuery = { __typename?: 'Query', getLastServerHeartbeatForClinic?: { __typename?: 'HeartbeatResponse', version: string, last_ping: number } | null };

export type TriggerServiceUpdateMutationVariables = Exact<{
  clinicId: Scalars['ID']['input'];
}>;


export type TriggerServiceUpdateMutation = { __typename?: 'Mutation', triggerServiceUpdateForClinic: boolean };

export type CreateConnectInstallationMutationVariables = Exact<{
  clinicId: Scalars['ID']['input'];
  installationId: Scalars['ID']['input'];
  data: CreateConnectInstallationInput;
}>;


export type CreateConnectInstallationMutation = { __typename?: 'Mutation', createConnectInstallation: { __typename?: 'ConnectInstallation', id: string, computer_name?: string | null, last_ping?: number | null, is_server?: boolean | null, version?: string | null, connect_ui_version?: string | null, connect_server_version?: string | null, created_at: number, updated_at: number } };

export type UpdateConnectInstallationMutationVariables = Exact<{
  clinicId: Scalars['ID']['input'];
  installationId: Scalars['ID']['input'];
  data: UpdateConnectInstallationInput;
}>;


export type UpdateConnectInstallationMutation = { __typename?: 'Mutation', updateConnectInstallation: { __typename?: 'ConnectInstallation', id: string, computer_name?: string | null, last_ping?: number | null, is_server?: boolean | null, version?: string | null, connect_ui_version?: string | null, connect_server_version?: string | null, created_at: number, updated_at: number } };

export type DeleteConnectInstallationMutationVariables = Exact<{
  clinicId: Scalars['ID']['input'];
  installationId: Scalars['ID']['input'];
}>;


export type DeleteConnectInstallationMutation = { __typename?: 'Mutation', deleteConnectInstallation?: any | null };

export type CustomRoleFieldsFragment = { __typename?: 'CustomRole', id: string, name: string, description?: string | null, is_default: boolean, is_active: boolean, created_at: number, updated_at: number, permissions?: Array<{ __typename?: 'ClinicAdminPermission', feature: AdminPermissionFeature, access_level: AdminPermissionAccessLevel }> | null };

export type CustomRoleWithRelationsFieldsFragment = { __typename?: 'CustomRole', id: string, name: string, description?: string | null, is_default: boolean, is_active: boolean, created_at: number, updated_at: number, clinic?: { __typename?: 'Clinic', id: string, name?: string | null } | null, clinic_group?: { __typename?: 'ClinicGroup', id: string, name: string } | null, permissions?: Array<{ __typename?: 'ClinicAdminPermission', feature: AdminPermissionFeature, access_level: AdminPermissionAccessLevel }> | null };

export type CustomRoleQueryVariables = Exact<{
  id: Scalars['ID']['input'];
}>;


export type CustomRoleQuery = { __typename?: 'Query', customRole?: { __typename?: 'CustomRole', id: string, name: string, description?: string | null, is_default: boolean, is_active: boolean, created_at: number, updated_at: number, clinic?: { __typename?: 'Clinic', id: string, name?: string | null } | null, clinic_group?: { __typename?: 'ClinicGroup', id: string, name: string } | null, permissions?: Array<{ __typename?: 'ClinicAdminPermission', feature: AdminPermissionFeature, access_level: AdminPermissionAccessLevel }> | null } | null };

export type GetCustomRolesByClinicQueryVariables = Exact<{
  clinicId: Scalars['ID']['input'];
}>;


export type GetCustomRolesByClinicQuery = { __typename?: 'Query', getCustomRolesByClinic: Array<{ __typename?: 'CustomRole', id: string, name: string, description?: string | null, is_default: boolean, is_active: boolean, created_at: number, updated_at: number, permissions?: Array<{ __typename?: 'ClinicAdminPermission', feature: AdminPermissionFeature, access_level: AdminPermissionAccessLevel }> | null }> };

export type GetCustomRolesByClinicGroupQueryVariables = Exact<{
  clinicGroupId: Scalars['ID']['input'];
}>;


export type GetCustomRolesByClinicGroupQuery = { __typename?: 'Query', getCustomRolesByClinicGroup: Array<{ __typename?: 'CustomRole', id: string, name: string, description?: string | null, is_default: boolean, is_active: boolean, created_at: number, updated_at: number, permissions?: Array<{ __typename?: 'ClinicAdminPermission', feature: AdminPermissionFeature, access_level: AdminPermissionAccessLevel }> | null }> };

export type CreateCustomRoleMutationVariables = Exact<{
  data: CreateCustomRoleInput;
}>;


export type CreateCustomRoleMutation = { __typename?: 'Mutation', createCustomRole: { __typename?: 'CustomRole', id: string, name: string, description?: string | null, is_default: boolean, is_active: boolean, created_at: number, updated_at: number, permissions?: Array<{ __typename?: 'ClinicAdminPermission', feature: AdminPermissionFeature, access_level: AdminPermissionAccessLevel }> | null } };

export type UpdateCustomRoleMutationVariables = Exact<{
  id: Scalars['ID']['input'];
  data: UpdateCustomRoleInput;
}>;


export type UpdateCustomRoleMutation = { __typename?: 'Mutation', updateCustomRole: { __typename?: 'CustomRole', id: string, name: string, description?: string | null, is_default: boolean, is_active: boolean, created_at: number, updated_at: number, permissions?: Array<{ __typename?: 'ClinicAdminPermission', feature: AdminPermissionFeature, access_level: AdminPermissionAccessLevel }> | null } };

export type DeleteCustomRoleMutationVariables = Exact<{
  id: Scalars['ID']['input'];
}>;


export type DeleteCustomRoleMutation = { __typename?: 'Mutation', deleteCustomRole?: any | null };

export type QueryFilterFieldsFragment = { __typename?: 'QueryFilter', column: string, filterOp: FilterOp, value: { __typename?: 'QueryFilterValue', string?: string | null, float?: number | null, boolean?: boolean | null, stringArray?: Array<string> | null, floatArray?: Array<number> | null, millisFromNow?: number | null, relativeTime?: { __typename?: 'RelativeTime', quantity: number, unit: TimeUnit, direction: ReferenceDirection } | null } };

export type CustomerSegmentPreviewFieldsFragment = { __typename?: 'CustomerSegment', id: string, name: string, trigger_entity?: CustomerSegmentTrigger | null, is_archived: boolean, updated_at: number, notification_templates?: Array<{ __typename?: 'NotificationTemplate', id: string, name: string, is_active: boolean, is_archived: boolean, message_methods: Array<MessageMethod> }> | null, error_flags?: Array<{ __typename?: 'CustomerSegmentErrorFlag', filter_column: string, filter_index: number, parameter_index: number, message: string }> | null, all_inclusions?: Array<{ __typename?: 'SegmentFilter', foreign_table?: string | null, group?: string | null, parameters: Array<{ __typename?: 'QueryFilter', column: string, filterOp: FilterOp, value: { __typename?: 'QueryFilterValue', string?: string | null, float?: number | null, boolean?: boolean | null, stringArray?: Array<string> | null, floatArray?: Array<number> | null, millisFromNow?: number | null, relativeTime?: { __typename?: 'RelativeTime', quantity: number, unit: TimeUnit, direction: ReferenceDirection } | null } }> }> | null, any_inclusions?: Array<{ __typename?: 'SegmentFilter', foreign_table?: string | null, group?: string | null, parameters: Array<{ __typename?: 'QueryFilter', column: string, filterOp: FilterOp, value: { __typename?: 'QueryFilterValue', string?: string | null, float?: number | null, boolean?: boolean | null, stringArray?: Array<string> | null, floatArray?: Array<number> | null, millisFromNow?: number | null, relativeTime?: { __typename?: 'RelativeTime', quantity: number, unit: TimeUnit, direction: ReferenceDirection } | null } }> }> | null, any_exclusions?: Array<{ __typename?: 'SegmentFilter', foreign_table?: string | null, group?: string | null, parameters: Array<{ __typename?: 'QueryFilter', column: string, filterOp: FilterOp, value: { __typename?: 'QueryFilterValue', string?: string | null, float?: number | null, boolean?: boolean | null, stringArray?: Array<string> | null, floatArray?: Array<number> | null, millisFromNow?: number | null, relativeTime?: { __typename?: 'RelativeTime', quantity: number, unit: TimeUnit, direction: ReferenceDirection } | null } }> }> | null, any_other_exclusions?: Array<{ __typename?: 'SegmentFilter', foreign_table?: string | null, group?: string | null, parameters: Array<{ __typename?: 'QueryFilter', column: string, filterOp: FilterOp, value: { __typename?: 'QueryFilterValue', string?: string | null, float?: number | null, boolean?: boolean | null, stringArray?: Array<string> | null, floatArray?: Array<number> | null, millisFromNow?: number | null, relativeTime?: { __typename?: 'RelativeTime', quantity: number, unit: TimeUnit, direction: ReferenceDirection } | null } }> }> | null, filters?: Array<{ __typename?: 'CustomerSegmentFilter', filters: Array<{ __typename?: 'QueryFilter', column: string, filterOp: FilterOp, value: { __typename?: 'QueryFilterValue', string?: string | null, float?: number | null, boolean?: boolean | null, stringArray?: Array<string> | null, floatArray?: Array<number> | null, millisFromNow?: number | null, relativeTime?: { __typename?: 'RelativeTime', quantity: number, unit: TimeUnit, direction: ReferenceDirection } | null } }> }> | null, excluded_filters: Array<{ __typename?: 'CustomerSegmentFilter', filters: Array<{ __typename?: 'QueryFilter', column: string, filterOp: FilterOp, value: { __typename?: 'QueryFilterValue', string?: string | null, float?: number | null, boolean?: boolean | null, stringArray?: Array<string> | null, floatArray?: Array<number> | null, millisFromNow?: number | null, relativeTime?: { __typename?: 'RelativeTime', quantity: number, unit: TimeUnit, direction: ReferenceDirection } | null } }> }> };

export type CustomerSegmentBaseInfoFieldsFragment = { __typename?: 'CustomerSegment', id: string, name: string, trigger_entity?: CustomerSegmentTrigger | null, is_archived: boolean };

export type CustomerSegmentFieldsFragment = { __typename?: 'CustomerSegment', id: string, name: string, trigger_entity?: CustomerSegmentTrigger | null, is_hourly?: boolean | null, group_days_ahead?: number | null, should_include_all_overdue?: boolean | null, included_clients?: Array<string> | null, excluded_clients?: Array<string> | null, other_result_exclusion_entity?: string | null, is_archived: boolean, created_at: number, updated_at: number, filters?: Array<{ __typename?: 'CustomerSegmentFilter', type: CustomerSegmentFilterType, only_consider_other_rows?: boolean | null, filters: Array<{ __typename?: 'QueryFilter', column: string, filterOp: FilterOp, value: { __typename?: 'QueryFilterValue', string?: string | null, float?: number | null, boolean?: boolean | null, stringArray?: Array<string> | null, floatArray?: Array<number> | null, millisFromNow?: number | null, relativeTime?: { __typename?: 'RelativeTime', quantity: number, unit: TimeUnit, direction: ReferenceDirection } | null } }> }> | null, excluded_filters: Array<{ __typename?: 'CustomerSegmentFilter', type: CustomerSegmentFilterType, only_consider_other_rows?: boolean | null, filters: Array<{ __typename?: 'QueryFilter', column: string, filterOp: FilterOp, value: { __typename?: 'QueryFilterValue', string?: string | null, float?: number | null, boolean?: boolean | null, stringArray?: Array<string> | null, floatArray?: Array<number> | null, millisFromNow?: number | null, relativeTime?: { __typename?: 'RelativeTime', quantity: number, unit: TimeUnit, direction: ReferenceDirection } | null } }> }>, all_inclusions?: Array<{ __typename?: 'SegmentFilter', foreign_table?: string | null, group?: string | null, parameters: Array<{ __typename?: 'QueryFilter', column: string, filterOp: FilterOp, value: { __typename?: 'QueryFilterValue', string?: string | null, float?: number | null, boolean?: boolean | null, stringArray?: Array<string> | null, floatArray?: Array<number> | null, millisFromNow?: number | null, relativeTime?: { __typename?: 'RelativeTime', quantity: number, unit: TimeUnit, direction: ReferenceDirection } | null } }> }> | null, any_inclusions?: Array<{ __typename?: 'SegmentFilter', foreign_table?: string | null, group?: string | null, parameters: Array<{ __typename?: 'QueryFilter', column: string, filterOp: FilterOp, value: { __typename?: 'QueryFilterValue', string?: string | null, float?: number | null, boolean?: boolean | null, stringArray?: Array<string> | null, floatArray?: Array<number> | null, millisFromNow?: number | null, relativeTime?: { __typename?: 'RelativeTime', quantity: number, unit: TimeUnit, direction: ReferenceDirection } | null } }> }> | null, any_exclusions?: Array<{ __typename?: 'SegmentFilter', foreign_table?: string | null, group?: string | null, parameters: Array<{ __typename?: 'QueryFilter', column: string, filterOp: FilterOp, value: { __typename?: 'QueryFilterValue', string?: string | null, float?: number | null, boolean?: boolean | null, stringArray?: Array<string> | null, floatArray?: Array<number> | null, millisFromNow?: number | null, relativeTime?: { __typename?: 'RelativeTime', quantity: number, unit: TimeUnit, direction: ReferenceDirection } | null } }> }> | null, any_other_exclusions?: Array<{ __typename?: 'SegmentFilter', foreign_table?: string | null, group?: string | null, parameters: Array<{ __typename?: 'QueryFilter', column: string, filterOp: FilterOp, value: { __typename?: 'QueryFilterValue', string?: string | null, float?: number | null, boolean?: boolean | null, stringArray?: Array<string> | null, floatArray?: Array<number> | null, millisFromNow?: number | null, relativeTime?: { __typename?: 'RelativeTime', quantity: number, unit: TimeUnit, direction: ReferenceDirection } | null } }> }> | null, default_exclusions_options: { __typename?: 'DefaultExclusionsOptions', exclude_cancelled_and_rescheduled_resources?: boolean | null, exclude_euthanasia_and_qol_resources?: boolean | null, exclude_euthanasia_and_qol_in_appt_notes?: boolean | null }, reference_date_params?: { __typename?: 'ReferenceDateParams', field: string, reference_periods?: Array<{ __typename?: 'ReferencePeriod', quantity: number, unit: TimeUnit, direction: ReferenceDirection }> | null } | null, notification_templates?: Array<{ __typename?: 'NotificationTemplate', id: string, name: string, is_active: boolean, is_archived: boolean, message_methods: Array<MessageMethod> }> | null, error_flags?: Array<{ __typename?: 'CustomerSegmentErrorFlag', filter_column: string, filter_index: number, parameter_index: number, message: string }> | null };

export type CustomerSegmentErrorFlagFieldsFragment = { __typename?: 'CustomerSegmentErrorFlag', filter_column: string, filter_index: number, parameter_index: number, message: string };

export type SegmentFilterFieldsFragment = { __typename?: 'SegmentFilter', foreign_table?: string | null, group?: string | null, parameters: Array<{ __typename?: 'QueryFilter', column: string, filterOp: FilterOp, value: { __typename?: 'QueryFilterValue', string?: string | null, float?: number | null, boolean?: boolean | null, stringArray?: Array<string> | null, floatArray?: Array<number> | null, millisFromNow?: number | null, relativeTime?: { __typename?: 'RelativeTime', quantity: number, unit: TimeUnit, direction: ReferenceDirection } | null } }> };

export type ReferenceDateParamsFieldsFragment = { __typename?: 'ReferenceDateParams', field: string, reference_periods?: Array<{ __typename?: 'ReferencePeriod', quantity: number, unit: TimeUnit, direction: ReferenceDirection }> | null };

export type ReferencePeriodFieldsFragment = { __typename?: 'ReferencePeriod', quantity: number, unit: TimeUnit, direction: ReferenceDirection };

export type CustomerSegmentQueryVariables = Exact<{
  id: Scalars['ID']['input'];
}>;


export type CustomerSegmentQuery = { __typename?: 'Query', customerSegment: { __typename?: 'CustomerSegment', id: string, name: string, trigger_entity?: CustomerSegmentTrigger | null, is_hourly?: boolean | null, group_days_ahead?: number | null, should_include_all_overdue?: boolean | null, included_clients?: Array<string> | null, excluded_clients?: Array<string> | null, other_result_exclusion_entity?: string | null, is_archived: boolean, created_at: number, updated_at: number, filters?: Array<{ __typename?: 'CustomerSegmentFilter', type: CustomerSegmentFilterType, only_consider_other_rows?: boolean | null, filters: Array<{ __typename?: 'QueryFilter', column: string, filterOp: FilterOp, value: { __typename?: 'QueryFilterValue', string?: string | null, float?: number | null, boolean?: boolean | null, stringArray?: Array<string> | null, floatArray?: Array<number> | null, millisFromNow?: number | null, relativeTime?: { __typename?: 'RelativeTime', quantity: number, unit: TimeUnit, direction: ReferenceDirection } | null } }> }> | null, excluded_filters: Array<{ __typename?: 'CustomerSegmentFilter', type: CustomerSegmentFilterType, only_consider_other_rows?: boolean | null, filters: Array<{ __typename?: 'QueryFilter', column: string, filterOp: FilterOp, value: { __typename?: 'QueryFilterValue', string?: string | null, float?: number | null, boolean?: boolean | null, stringArray?: Array<string> | null, floatArray?: Array<number> | null, millisFromNow?: number | null, relativeTime?: { __typename?: 'RelativeTime', quantity: number, unit: TimeUnit, direction: ReferenceDirection } | null } }> }>, all_inclusions?: Array<{ __typename?: 'SegmentFilter', foreign_table?: string | null, group?: string | null, parameters: Array<{ __typename?: 'QueryFilter', column: string, filterOp: FilterOp, value: { __typename?: 'QueryFilterValue', string?: string | null, float?: number | null, boolean?: boolean | null, stringArray?: Array<string> | null, floatArray?: Array<number> | null, millisFromNow?: number | null, relativeTime?: { __typename?: 'RelativeTime', quantity: number, unit: TimeUnit, direction: ReferenceDirection } | null } }> }> | null, any_inclusions?: Array<{ __typename?: 'SegmentFilter', foreign_table?: string | null, group?: string | null, parameters: Array<{ __typename?: 'QueryFilter', column: string, filterOp: FilterOp, value: { __typename?: 'QueryFilterValue', string?: string | null, float?: number | null, boolean?: boolean | null, stringArray?: Array<string> | null, floatArray?: Array<number> | null, millisFromNow?: number | null, relativeTime?: { __typename?: 'RelativeTime', quantity: number, unit: TimeUnit, direction: ReferenceDirection } | null } }> }> | null, any_exclusions?: Array<{ __typename?: 'SegmentFilter', foreign_table?: string | null, group?: string | null, parameters: Array<{ __typename?: 'QueryFilter', column: string, filterOp: FilterOp, value: { __typename?: 'QueryFilterValue', string?: string | null, float?: number | null, boolean?: boolean | null, stringArray?: Array<string> | null, floatArray?: Array<number> | null, millisFromNow?: number | null, relativeTime?: { __typename?: 'RelativeTime', quantity: number, unit: TimeUnit, direction: ReferenceDirection } | null } }> }> | null, any_other_exclusions?: Array<{ __typename?: 'SegmentFilter', foreign_table?: string | null, group?: string | null, parameters: Array<{ __typename?: 'QueryFilter', column: string, filterOp: FilterOp, value: { __typename?: 'QueryFilterValue', string?: string | null, float?: number | null, boolean?: boolean | null, stringArray?: Array<string> | null, floatArray?: Array<number> | null, millisFromNow?: number | null, relativeTime?: { __typename?: 'RelativeTime', quantity: number, unit: TimeUnit, direction: ReferenceDirection } | null } }> }> | null, default_exclusions_options: { __typename?: 'DefaultExclusionsOptions', exclude_cancelled_and_rescheduled_resources?: boolean | null, exclude_euthanasia_and_qol_resources?: boolean | null, exclude_euthanasia_and_qol_in_appt_notes?: boolean | null }, reference_date_params?: { __typename?: 'ReferenceDateParams', field: string, reference_periods?: Array<{ __typename?: 'ReferencePeriod', quantity: number, unit: TimeUnit, direction: ReferenceDirection }> | null } | null, notification_templates?: Array<{ __typename?: 'NotificationTemplate', id: string, name: string, is_active: boolean, is_archived: boolean, message_methods: Array<MessageMethod> }> | null, error_flags?: Array<{ __typename?: 'CustomerSegmentErrorFlag', filter_column: string, filter_index: number, parameter_index: number, message: string }> | null } };

export type GetCustomerSegmentsForClinicQueryVariables = Exact<{
  clinicId: Scalars['ID']['input'];
  page?: InputMaybe<Scalars['NonNegativeInt']['input']>;
  pageSize?: InputMaybe<Scalars['NonNegativeInt']['input']>;
}>;


export type GetCustomerSegmentsForClinicQuery = { __typename?: 'Query', getCustomerSegmentsForClinic: Array<{ __typename?: 'CustomerSegment', id: string, name: string, trigger_entity?: CustomerSegmentTrigger | null, is_archived: boolean, updated_at: number, notification_templates?: Array<{ __typename?: 'NotificationTemplate', id: string, name: string, is_active: boolean, is_archived: boolean, message_methods: Array<MessageMethod> }> | null, error_flags?: Array<{ __typename?: 'CustomerSegmentErrorFlag', filter_column: string, filter_index: number, parameter_index: number, message: string }> | null, all_inclusions?: Array<{ __typename?: 'SegmentFilter', foreign_table?: string | null, group?: string | null, parameters: Array<{ __typename?: 'QueryFilter', column: string, filterOp: FilterOp, value: { __typename?: 'QueryFilterValue', string?: string | null, float?: number | null, boolean?: boolean | null, stringArray?: Array<string> | null, floatArray?: Array<number> | null, millisFromNow?: number | null, relativeTime?: { __typename?: 'RelativeTime', quantity: number, unit: TimeUnit, direction: ReferenceDirection } | null } }> }> | null, any_inclusions?: Array<{ __typename?: 'SegmentFilter', foreign_table?: string | null, group?: string | null, parameters: Array<{ __typename?: 'QueryFilter', column: string, filterOp: FilterOp, value: { __typename?: 'QueryFilterValue', string?: string | null, float?: number | null, boolean?: boolean | null, stringArray?: Array<string> | null, floatArray?: Array<number> | null, millisFromNow?: number | null, relativeTime?: { __typename?: 'RelativeTime', quantity: number, unit: TimeUnit, direction: ReferenceDirection } | null } }> }> | null, any_exclusions?: Array<{ __typename?: 'SegmentFilter', foreign_table?: string | null, group?: string | null, parameters: Array<{ __typename?: 'QueryFilter', column: string, filterOp: FilterOp, value: { __typename?: 'QueryFilterValue', string?: string | null, float?: number | null, boolean?: boolean | null, stringArray?: Array<string> | null, floatArray?: Array<number> | null, millisFromNow?: number | null, relativeTime?: { __typename?: 'RelativeTime', quantity: number, unit: TimeUnit, direction: ReferenceDirection } | null } }> }> | null, any_other_exclusions?: Array<{ __typename?: 'SegmentFilter', foreign_table?: string | null, group?: string | null, parameters: Array<{ __typename?: 'QueryFilter', column: string, filterOp: FilterOp, value: { __typename?: 'QueryFilterValue', string?: string | null, float?: number | null, boolean?: boolean | null, stringArray?: Array<string> | null, floatArray?: Array<number> | null, millisFromNow?: number | null, relativeTime?: { __typename?: 'RelativeTime', quantity: number, unit: TimeUnit, direction: ReferenceDirection } | null } }> }> | null, filters?: Array<{ __typename?: 'CustomerSegmentFilter', filters: Array<{ __typename?: 'QueryFilter', column: string, filterOp: FilterOp, value: { __typename?: 'QueryFilterValue', string?: string | null, float?: number | null, boolean?: boolean | null, stringArray?: Array<string> | null, floatArray?: Array<number> | null, millisFromNow?: number | null, relativeTime?: { __typename?: 'RelativeTime', quantity: number, unit: TimeUnit, direction: ReferenceDirection } | null } }> }> | null, excluded_filters: Array<{ __typename?: 'CustomerSegmentFilter', filters: Array<{ __typename?: 'QueryFilter', column: string, filterOp: FilterOp, value: { __typename?: 'QueryFilterValue', string?: string | null, float?: number | null, boolean?: boolean | null, stringArray?: Array<string> | null, floatArray?: Array<number> | null, millisFromNow?: number | null, relativeTime?: { __typename?: 'RelativeTime', quantity: number, unit: TimeUnit, direction: ReferenceDirection } | null } }> }> }> };

export type QueryCustomerSegmentsQueryVariables = Exact<{
  where?: InputMaybe<Array<QueryInput> | QueryInput>;
  page?: InputMaybe<Scalars['NonNegativeInt']['input']>;
  pageSize?: InputMaybe<Scalars['NonNegativeInt']['input']>;
  orderBy?: InputMaybe<OrderByInput>;
}>;


export type QueryCustomerSegmentsQuery = { __typename?: 'Query', queryCustomerSegments: Array<{ __typename?: 'CustomerSegment', id: string, name: string, trigger_entity?: CustomerSegmentTrigger | null, is_archived: boolean, updated_at: number, notification_templates?: Array<{ __typename?: 'NotificationTemplate', id: string, name: string, is_active: boolean, is_archived: boolean, message_methods: Array<MessageMethod> }> | null, error_flags?: Array<{ __typename?: 'CustomerSegmentErrorFlag', filter_column: string, filter_index: number, parameter_index: number, message: string }> | null, all_inclusions?: Array<{ __typename?: 'SegmentFilter', foreign_table?: string | null, group?: string | null, parameters: Array<{ __typename?: 'QueryFilter', column: string, filterOp: FilterOp, value: { __typename?: 'QueryFilterValue', string?: string | null, float?: number | null, boolean?: boolean | null, stringArray?: Array<string> | null, floatArray?: Array<number> | null, millisFromNow?: number | null, relativeTime?: { __typename?: 'RelativeTime', quantity: number, unit: TimeUnit, direction: ReferenceDirection } | null } }> }> | null, any_inclusions?: Array<{ __typename?: 'SegmentFilter', foreign_table?: string | null, group?: string | null, parameters: Array<{ __typename?: 'QueryFilter', column: string, filterOp: FilterOp, value: { __typename?: 'QueryFilterValue', string?: string | null, float?: number | null, boolean?: boolean | null, stringArray?: Array<string> | null, floatArray?: Array<number> | null, millisFromNow?: number | null, relativeTime?: { __typename?: 'RelativeTime', quantity: number, unit: TimeUnit, direction: ReferenceDirection } | null } }> }> | null, any_exclusions?: Array<{ __typename?: 'SegmentFilter', foreign_table?: string | null, group?: string | null, parameters: Array<{ __typename?: 'QueryFilter', column: string, filterOp: FilterOp, value: { __typename?: 'QueryFilterValue', string?: string | null, float?: number | null, boolean?: boolean | null, stringArray?: Array<string> | null, floatArray?: Array<number> | null, millisFromNow?: number | null, relativeTime?: { __typename?: 'RelativeTime', quantity: number, unit: TimeUnit, direction: ReferenceDirection } | null } }> }> | null, any_other_exclusions?: Array<{ __typename?: 'SegmentFilter', foreign_table?: string | null, group?: string | null, parameters: Array<{ __typename?: 'QueryFilter', column: string, filterOp: FilterOp, value: { __typename?: 'QueryFilterValue', string?: string | null, float?: number | null, boolean?: boolean | null, stringArray?: Array<string> | null, floatArray?: Array<number> | null, millisFromNow?: number | null, relativeTime?: { __typename?: 'RelativeTime', quantity: number, unit: TimeUnit, direction: ReferenceDirection } | null } }> }> | null, filters?: Array<{ __typename?: 'CustomerSegmentFilter', filters: Array<{ __typename?: 'QueryFilter', column: string, filterOp: FilterOp, value: { __typename?: 'QueryFilterValue', string?: string | null, float?: number | null, boolean?: boolean | null, stringArray?: Array<string> | null, floatArray?: Array<number> | null, millisFromNow?: number | null, relativeTime?: { __typename?: 'RelativeTime', quantity: number, unit: TimeUnit, direction: ReferenceDirection } | null } }> }> | null, excluded_filters: Array<{ __typename?: 'CustomerSegmentFilter', filters: Array<{ __typename?: 'QueryFilter', column: string, filterOp: FilterOp, value: { __typename?: 'QueryFilterValue', string?: string | null, float?: number | null, boolean?: boolean | null, stringArray?: Array<string> | null, floatArray?: Array<number> | null, millisFromNow?: number | null, relativeTime?: { __typename?: 'RelativeTime', quantity: number, unit: TimeUnit, direction: ReferenceDirection } | null } }> }> }> };

export type CustomerSegmentResultFieldsFragment = { __typename?: 'CustSegResult', client?: { __typename?: 'Client', id: string, first_name?: string | null, last_name?: string | null, secondary_first_name?: string | null, secondary_last_name?: string | null, phone?: string | null, email?: string | null, pms_id?: string | null, is_active?: boolean | null, is_unsubscribed: boolean, sms_enabled: boolean, email_enabled: boolean, balance?: number | null, last_appt_time?: number | null, created_at: number, updated_at: number, last_appointment?: { __typename?: 'Appointment', clinician?: { __typename?: 'Clinician', name: string, display_name?: string | null } | null } | null, address?: { __typename?: 'Address', street_a?: string | null, street_b?: string | null, city?: string | null, state?: string | null, zip?: string | null, country?: string | null } | null, clinic?: { __typename?: 'Clinic', id: string } | null, user?: { __typename?: 'User', avatar_url?: string | null } | null, patients?: Array<{ __typename?: 'Patient', id: string, name?: string | null, gender?: string | null, pms_id?: string | null, is_deceased?: boolean | null, is_active?: boolean | null, clinic_species?: { __typename?: 'ClinicSpecies', id: string, species: Species } | null, clinic_breed?: { __typename?: 'Breed', id: string, description: string } | null, last_appointment?: { __typename?: 'Appointment', clinician?: { __typename?: 'Clinician', name: string, display_name?: string | null } | null } | null }> | null, settings?: { __typename?: 'ClientSettings', clinic_chckup_notifications_enabled: boolean, clinic_chckup_sms_enabled: boolean, clinic_chckup_email_enabled: boolean, client_chckup_notifications_enabled: boolean, client_chckup_sms_enabled: boolean, client_chckup_email_enabled: boolean, is_unsubscribed_from_marketing: boolean, is_unsubscribed_from_marketing_sms: boolean, is_unsubscribed_from_marketing_email: boolean } | null } | null, appointment?: { __typename?: 'Appointment', id: string, service_name?: string | null, status: AppointmentStatus, start_time: number, drop_off_time?: number | null, minutes: number, service?: { __typename?: 'Service', name?: string | null } | null, clinician?: { __typename?: 'Clinician', name: string, display_name?: string | null } | null, client?: { __typename?: 'Client', first_name?: string | null, last_name?: string | null } | null, patient?: { __typename?: 'Patient', name?: string | null } | null } | null, patient?: { __typename?: 'Patient', id: string, pms_id?: string | null, name?: string | null, breed?: string | null, is_active?: boolean | null, is_deceased?: boolean | null, avatar_url?: string | null, gender?: string | null, fixed_status?: FixedStatus | null, birthday?: number | null, weight?: number | null, owner?: { __typename?: 'Client', id: string, first_name?: string | null, last_name?: string | null, secondary_first_name?: string | null, secondary_last_name?: string | null, phone?: string | null, email?: string | null } | null, clinic_species?: { __typename?: 'ClinicSpecies', id: string, species: Species, description: string, weight_key: string } | null, clinic_breed?: { __typename?: 'Breed', id: string, description: string } | null } | null, pims_reminder?: { __typename?: 'PimsReminder', id: string, send_date: number, display_due_date?: number | null, reminder_desc?: string | null, reminder_type?: { __typename?: 'PimsReminderType', id: string, display_name?: string | null, is_active: boolean, reminder_type_name: string, all_reminder_names?: Array<string> | null } | null } | null, lead_contact?: { __typename?: 'LeadContact', id: string, first_name?: string | null, last_name?: string | null, email?: string | null, phone?: string | null, source: LeadContactSource, created_at: number } | null, booking_flow_session?: { __typename?: 'BookingFlowSession', id: string, source: BookingFlowSource, furthest_step?: BookingFlowStep | null, last_step: BookingFlowStep, service_name?: string | null, is_new_client?: boolean | null, updated_at: number } | null };

export type LeadContactPreviewFieldsFragment = { __typename?: 'LeadContact', id: string, first_name?: string | null, last_name?: string | null, email?: string | null, phone?: string | null, source: LeadContactSource, created_at: number };

export type BookingFlowSessionPreviewFieldsFragment = { __typename?: 'BookingFlowSession', id: string, source: BookingFlowSource, furthest_step?: BookingFlowStep | null, last_step: BookingFlowStep, service_name?: string | null, is_new_client?: boolean | null, updated_at: number };

export type GetClientsByCustomerSegmentRpcQueryVariables = Exact<{
  id: Scalars['ID']['input'];
  page?: InputMaybe<Scalars['NonNegativeInt']['input']>;
  pageSize?: InputMaybe<Scalars['NonNegativeInt']['input']>;
  notificationTemplateId?: InputMaybe<Scalars['ID']['input']>;
  startingDateOverride?: InputMaybe<Scalars['NonNegativeInt']['input']>;
}>;


export type GetClientsByCustomerSegmentRpcQuery = { __typename?: 'Query', getClientsByCustomerSegmentRPC: { __typename?: 'CustSegRPCResult', count: number, results: Array<{ __typename?: 'CustSegResult', client?: { __typename?: 'Client', id: string, first_name?: string | null, last_name?: string | null, secondary_first_name?: string | null, secondary_last_name?: string | null, phone?: string | null, email?: string | null, pms_id?: string | null, is_active?: boolean | null, is_unsubscribed: boolean, sms_enabled: boolean, email_enabled: boolean, balance?: number | null, last_appt_time?: number | null, created_at: number, updated_at: number, last_appointment?: { __typename?: 'Appointment', clinician?: { __typename?: 'Clinician', name: string, display_name?: string | null } | null } | null, address?: { __typename?: 'Address', street_a?: string | null, street_b?: string | null, city?: string | null, state?: string | null, zip?: string | null, country?: string | null } | null, clinic?: { __typename?: 'Clinic', id: string } | null, user?: { __typename?: 'User', avatar_url?: string | null } | null, patients?: Array<{ __typename?: 'Patient', id: string, name?: string | null, gender?: string | null, pms_id?: string | null, is_deceased?: boolean | null, is_active?: boolean | null, clinic_species?: { __typename?: 'ClinicSpecies', id: string, species: Species } | null, clinic_breed?: { __typename?: 'Breed', id: string, description: string } | null, last_appointment?: { __typename?: 'Appointment', clinician?: { __typename?: 'Clinician', name: string, display_name?: string | null } | null } | null }> | null, settings?: { __typename?: 'ClientSettings', clinic_chckup_notifications_enabled: boolean, clinic_chckup_sms_enabled: boolean, clinic_chckup_email_enabled: boolean, client_chckup_notifications_enabled: boolean, client_chckup_sms_enabled: boolean, client_chckup_email_enabled: boolean, is_unsubscribed_from_marketing: boolean, is_unsubscribed_from_marketing_sms: boolean, is_unsubscribed_from_marketing_email: boolean } | null } | null, appointment?: { __typename?: 'Appointment', id: string, service_name?: string | null, status: AppointmentStatus, start_time: number, drop_off_time?: number | null, minutes: number, service?: { __typename?: 'Service', name?: string | null } | null, clinician?: { __typename?: 'Clinician', name: string, display_name?: string | null } | null, client?: { __typename?: 'Client', first_name?: string | null, last_name?: string | null } | null, patient?: { __typename?: 'Patient', name?: string | null } | null } | null, patient?: { __typename?: 'Patient', id: string, pms_id?: string | null, name?: string | null, breed?: string | null, is_active?: boolean | null, is_deceased?: boolean | null, avatar_url?: string | null, gender?: string | null, fixed_status?: FixedStatus | null, birthday?: number | null, weight?: number | null, owner?: { __typename?: 'Client', id: string, first_name?: string | null, last_name?: string | null, secondary_first_name?: string | null, secondary_last_name?: string | null, phone?: string | null, email?: string | null } | null, clinic_species?: { __typename?: 'ClinicSpecies', id: string, species: Species, description: string, weight_key: string } | null, clinic_breed?: { __typename?: 'Breed', id: string, description: string } | null } | null, pims_reminder?: { __typename?: 'PimsReminder', id: string, send_date: number, display_due_date?: number | null, reminder_desc?: string | null, reminder_type?: { __typename?: 'PimsReminderType', id: string, display_name?: string | null, is_active: boolean, reminder_type_name: string, all_reminder_names?: Array<string> | null } | null } | null, lead_contact?: { __typename?: 'LeadContact', id: string, first_name?: string | null, last_name?: string | null, email?: string | null, phone?: string | null, source: LeadContactSource, created_at: number } | null, booking_flow_session?: { __typename?: 'BookingFlowSession', id: string, source: BookingFlowSource, furthest_step?: BookingFlowStep | null, last_step: BookingFlowStep, service_name?: string | null, is_new_client?: boolean | null, updated_at: number } | null }> } };

export type CreateCustomerSegmentMutationVariables = Exact<{
  data: CreateCustomerSegmentInput;
}>;


export type CreateCustomerSegmentMutation = { __typename?: 'Mutation', createCustomerSegment: { __typename?: 'CustomerSegment', id: string, name: string, trigger_entity?: CustomerSegmentTrigger | null, is_hourly?: boolean | null, group_days_ahead?: number | null, should_include_all_overdue?: boolean | null, included_clients?: Array<string> | null, excluded_clients?: Array<string> | null, other_result_exclusion_entity?: string | null, is_archived: boolean, created_at: number, updated_at: number, filters?: Array<{ __typename?: 'CustomerSegmentFilter', type: CustomerSegmentFilterType, only_consider_other_rows?: boolean | null, filters: Array<{ __typename?: 'QueryFilter', column: string, filterOp: FilterOp, value: { __typename?: 'QueryFilterValue', string?: string | null, float?: number | null, boolean?: boolean | null, stringArray?: Array<string> | null, floatArray?: Array<number> | null, millisFromNow?: number | null, relativeTime?: { __typename?: 'RelativeTime', quantity: number, unit: TimeUnit, direction: ReferenceDirection } | null } }> }> | null, excluded_filters: Array<{ __typename?: 'CustomerSegmentFilter', type: CustomerSegmentFilterType, only_consider_other_rows?: boolean | null, filters: Array<{ __typename?: 'QueryFilter', column: string, filterOp: FilterOp, value: { __typename?: 'QueryFilterValue', string?: string | null, float?: number | null, boolean?: boolean | null, stringArray?: Array<string> | null, floatArray?: Array<number> | null, millisFromNow?: number | null, relativeTime?: { __typename?: 'RelativeTime', quantity: number, unit: TimeUnit, direction: ReferenceDirection } | null } }> }>, all_inclusions?: Array<{ __typename?: 'SegmentFilter', foreign_table?: string | null, group?: string | null, parameters: Array<{ __typename?: 'QueryFilter', column: string, filterOp: FilterOp, value: { __typename?: 'QueryFilterValue', string?: string | null, float?: number | null, boolean?: boolean | null, stringArray?: Array<string> | null, floatArray?: Array<number> | null, millisFromNow?: number | null, relativeTime?: { __typename?: 'RelativeTime', quantity: number, unit: TimeUnit, direction: ReferenceDirection } | null } }> }> | null, any_inclusions?: Array<{ __typename?: 'SegmentFilter', foreign_table?: string | null, group?: string | null, parameters: Array<{ __typename?: 'QueryFilter', column: string, filterOp: FilterOp, value: { __typename?: 'QueryFilterValue', string?: string | null, float?: number | null, boolean?: boolean | null, stringArray?: Array<string> | null, floatArray?: Array<number> | null, millisFromNow?: number | null, relativeTime?: { __typename?: 'RelativeTime', quantity: number, unit: TimeUnit, direction: ReferenceDirection } | null } }> }> | null, any_exclusions?: Array<{ __typename?: 'SegmentFilter', foreign_table?: string | null, group?: string | null, parameters: Array<{ __typename?: 'QueryFilter', column: string, filterOp: FilterOp, value: { __typename?: 'QueryFilterValue', string?: string | null, float?: number | null, boolean?: boolean | null, stringArray?: Array<string> | null, floatArray?: Array<number> | null, millisFromNow?: number | null, relativeTime?: { __typename?: 'RelativeTime', quantity: number, unit: TimeUnit, direction: ReferenceDirection } | null } }> }> | null, any_other_exclusions?: Array<{ __typename?: 'SegmentFilter', foreign_table?: string | null, group?: string | null, parameters: Array<{ __typename?: 'QueryFilter', column: string, filterOp: FilterOp, value: { __typename?: 'QueryFilterValue', string?: string | null, float?: number | null, boolean?: boolean | null, stringArray?: Array<string> | null, floatArray?: Array<number> | null, millisFromNow?: number | null, relativeTime?: { __typename?: 'RelativeTime', quantity: number, unit: TimeUnit, direction: ReferenceDirection } | null } }> }> | null, default_exclusions_options: { __typename?: 'DefaultExclusionsOptions', exclude_cancelled_and_rescheduled_resources?: boolean | null, exclude_euthanasia_and_qol_resources?: boolean | null, exclude_euthanasia_and_qol_in_appt_notes?: boolean | null }, reference_date_params?: { __typename?: 'ReferenceDateParams', field: string, reference_periods?: Array<{ __typename?: 'ReferencePeriod', quantity: number, unit: TimeUnit, direction: ReferenceDirection }> | null } | null, notification_templates?: Array<{ __typename?: 'NotificationTemplate', id: string, name: string, is_active: boolean, is_archived: boolean, message_methods: Array<MessageMethod> }> | null, error_flags?: Array<{ __typename?: 'CustomerSegmentErrorFlag', filter_column: string, filter_index: number, parameter_index: number, message: string }> | null } };

export type UpdateCustomerSegmentMutationVariables = Exact<{
  id: Scalars['ID']['input'];
  data: UpdateCustomerSegmentInput;
}>;


export type UpdateCustomerSegmentMutation = { __typename?: 'Mutation', updateCustomerSegment: { __typename?: 'CustomerSegment', id: string, name: string, trigger_entity?: CustomerSegmentTrigger | null, is_hourly?: boolean | null, group_days_ahead?: number | null, should_include_all_overdue?: boolean | null, included_clients?: Array<string> | null, excluded_clients?: Array<string> | null, other_result_exclusion_entity?: string | null, is_archived: boolean, created_at: number, updated_at: number, filters?: Array<{ __typename?: 'CustomerSegmentFilter', type: CustomerSegmentFilterType, only_consider_other_rows?: boolean | null, filters: Array<{ __typename?: 'QueryFilter', column: string, filterOp: FilterOp, value: { __typename?: 'QueryFilterValue', string?: string | null, float?: number | null, boolean?: boolean | null, stringArray?: Array<string> | null, floatArray?: Array<number> | null, millisFromNow?: number | null, relativeTime?: { __typename?: 'RelativeTime', quantity: number, unit: TimeUnit, direction: ReferenceDirection } | null } }> }> | null, excluded_filters: Array<{ __typename?: 'CustomerSegmentFilter', type: CustomerSegmentFilterType, only_consider_other_rows?: boolean | null, filters: Array<{ __typename?: 'QueryFilter', column: string, filterOp: FilterOp, value: { __typename?: 'QueryFilterValue', string?: string | null, float?: number | null, boolean?: boolean | null, stringArray?: Array<string> | null, floatArray?: Array<number> | null, millisFromNow?: number | null, relativeTime?: { __typename?: 'RelativeTime', quantity: number, unit: TimeUnit, direction: ReferenceDirection } | null } }> }>, all_inclusions?: Array<{ __typename?: 'SegmentFilter', foreign_table?: string | null, group?: string | null, parameters: Array<{ __typename?: 'QueryFilter', column: string, filterOp: FilterOp, value: { __typename?: 'QueryFilterValue', string?: string | null, float?: number | null, boolean?: boolean | null, stringArray?: Array<string> | null, floatArray?: Array<number> | null, millisFromNow?: number | null, relativeTime?: { __typename?: 'RelativeTime', quantity: number, unit: TimeUnit, direction: ReferenceDirection } | null } }> }> | null, any_inclusions?: Array<{ __typename?: 'SegmentFilter', foreign_table?: string | null, group?: string | null, parameters: Array<{ __typename?: 'QueryFilter', column: string, filterOp: FilterOp, value: { __typename?: 'QueryFilterValue', string?: string | null, float?: number | null, boolean?: boolean | null, stringArray?: Array<string> | null, floatArray?: Array<number> | null, millisFromNow?: number | null, relativeTime?: { __typename?: 'RelativeTime', quantity: number, unit: TimeUnit, direction: ReferenceDirection } | null } }> }> | null, any_exclusions?: Array<{ __typename?: 'SegmentFilter', foreign_table?: string | null, group?: string | null, parameters: Array<{ __typename?: 'QueryFilter', column: string, filterOp: FilterOp, value: { __typename?: 'QueryFilterValue', string?: string | null, float?: number | null, boolean?: boolean | null, stringArray?: Array<string> | null, floatArray?: Array<number> | null, millisFromNow?: number | null, relativeTime?: { __typename?: 'RelativeTime', quantity: number, unit: TimeUnit, direction: ReferenceDirection } | null } }> }> | null, any_other_exclusions?: Array<{ __typename?: 'SegmentFilter', foreign_table?: string | null, group?: string | null, parameters: Array<{ __typename?: 'QueryFilter', column: string, filterOp: FilterOp, value: { __typename?: 'QueryFilterValue', string?: string | null, float?: number | null, boolean?: boolean | null, stringArray?: Array<string> | null, floatArray?: Array<number> | null, millisFromNow?: number | null, relativeTime?: { __typename?: 'RelativeTime', quantity: number, unit: TimeUnit, direction: ReferenceDirection } | null } }> }> | null, default_exclusions_options: { __typename?: 'DefaultExclusionsOptions', exclude_cancelled_and_rescheduled_resources?: boolean | null, exclude_euthanasia_and_qol_resources?: boolean | null, exclude_euthanasia_and_qol_in_appt_notes?: boolean | null }, reference_date_params?: { __typename?: 'ReferenceDateParams', field: string, reference_periods?: Array<{ __typename?: 'ReferencePeriod', quantity: number, unit: TimeUnit, direction: ReferenceDirection }> | null } | null, notification_templates?: Array<{ __typename?: 'NotificationTemplate', id: string, name: string, is_active: boolean, is_archived: boolean, message_methods: Array<MessageMethod> }> | null, error_flags?: Array<{ __typename?: 'CustomerSegmentErrorFlag', filter_column: string, filter_index: number, parameter_index: number, message: string }> | null } };

export type ArchiveCustomerSegmentMutationVariables = Exact<{
  id: Scalars['ID']['input'];
}>;


export type ArchiveCustomerSegmentMutation = { __typename?: 'Mutation', archiveCustomerSegment: { __typename?: 'CustomerSegment', id: string, name: string, trigger_entity?: CustomerSegmentTrigger | null, is_hourly?: boolean | null, group_days_ahead?: number | null, should_include_all_overdue?: boolean | null, included_clients?: Array<string> | null, excluded_clients?: Array<string> | null, other_result_exclusion_entity?: string | null, is_archived: boolean, created_at: number, updated_at: number, filters?: Array<{ __typename?: 'CustomerSegmentFilter', type: CustomerSegmentFilterType, only_consider_other_rows?: boolean | null, filters: Array<{ __typename?: 'QueryFilter', column: string, filterOp: FilterOp, value: { __typename?: 'QueryFilterValue', string?: string | null, float?: number | null, boolean?: boolean | null, stringArray?: Array<string> | null, floatArray?: Array<number> | null, millisFromNow?: number | null, relativeTime?: { __typename?: 'RelativeTime', quantity: number, unit: TimeUnit, direction: ReferenceDirection } | null } }> }> | null, excluded_filters: Array<{ __typename?: 'CustomerSegmentFilter', type: CustomerSegmentFilterType, only_consider_other_rows?: boolean | null, filters: Array<{ __typename?: 'QueryFilter', column: string, filterOp: FilterOp, value: { __typename?: 'QueryFilterValue', string?: string | null, float?: number | null, boolean?: boolean | null, stringArray?: Array<string> | null, floatArray?: Array<number> | null, millisFromNow?: number | null, relativeTime?: { __typename?: 'RelativeTime', quantity: number, unit: TimeUnit, direction: ReferenceDirection } | null } }> }>, all_inclusions?: Array<{ __typename?: 'SegmentFilter', foreign_table?: string | null, group?: string | null, parameters: Array<{ __typename?: 'QueryFilter', column: string, filterOp: FilterOp, value: { __typename?: 'QueryFilterValue', string?: string | null, float?: number | null, boolean?: boolean | null, stringArray?: Array<string> | null, floatArray?: Array<number> | null, millisFromNow?: number | null, relativeTime?: { __typename?: 'RelativeTime', quantity: number, unit: TimeUnit, direction: ReferenceDirection } | null } }> }> | null, any_inclusions?: Array<{ __typename?: 'SegmentFilter', foreign_table?: string | null, group?: string | null, parameters: Array<{ __typename?: 'QueryFilter', column: string, filterOp: FilterOp, value: { __typename?: 'QueryFilterValue', string?: string | null, float?: number | null, boolean?: boolean | null, stringArray?: Array<string> | null, floatArray?: Array<number> | null, millisFromNow?: number | null, relativeTime?: { __typename?: 'RelativeTime', quantity: number, unit: TimeUnit, direction: ReferenceDirection } | null } }> }> | null, any_exclusions?: Array<{ __typename?: 'SegmentFilter', foreign_table?: string | null, group?: string | null, parameters: Array<{ __typename?: 'QueryFilter', column: string, filterOp: FilterOp, value: { __typename?: 'QueryFilterValue', string?: string | null, float?: number | null, boolean?: boolean | null, stringArray?: Array<string> | null, floatArray?: Array<number> | null, millisFromNow?: number | null, relativeTime?: { __typename?: 'RelativeTime', quantity: number, unit: TimeUnit, direction: ReferenceDirection } | null } }> }> | null, any_other_exclusions?: Array<{ __typename?: 'SegmentFilter', foreign_table?: string | null, group?: string | null, parameters: Array<{ __typename?: 'QueryFilter', column: string, filterOp: FilterOp, value: { __typename?: 'QueryFilterValue', string?: string | null, float?: number | null, boolean?: boolean | null, stringArray?: Array<string> | null, floatArray?: Array<number> | null, millisFromNow?: number | null, relativeTime?: { __typename?: 'RelativeTime', quantity: number, unit: TimeUnit, direction: ReferenceDirection } | null } }> }> | null, default_exclusions_options: { __typename?: 'DefaultExclusionsOptions', exclude_cancelled_and_rescheduled_resources?: boolean | null, exclude_euthanasia_and_qol_resources?: boolean | null, exclude_euthanasia_and_qol_in_appt_notes?: boolean | null }, reference_date_params?: { __typename?: 'ReferenceDateParams', field: string, reference_periods?: Array<{ __typename?: 'ReferencePeriod', quantity: number, unit: TimeUnit, direction: ReferenceDirection }> | null } | null, notification_templates?: Array<{ __typename?: 'NotificationTemplate', id: string, name: string, is_active: boolean, is_archived: boolean, message_methods: Array<MessageMethod> }> | null, error_flags?: Array<{ __typename?: 'CustomerSegmentErrorFlag', filter_column: string, filter_index: number, parameter_index: number, message: string }> | null } };

export type DeleteCustomerSegmentMutationVariables = Exact<{
  id: Scalars['ID']['input'];
}>;


export type DeleteCustomerSegmentMutation = { __typename?: 'Mutation', deleteCustomerSegment?: any | null };

export type CopyCustomerSegmentAcrossClinicMutationVariables = Exact<{
  id: Scalars['ID']['input'];
  destinationClinicId: Scalars['ID']['input'];
}>;


export type CopyCustomerSegmentAcrossClinicMutation = { __typename?: 'Mutation', copyCustomerSegmentAcrossClinic: { __typename?: 'CustomerSegment', id: string, name: string, trigger_entity?: CustomerSegmentTrigger | null, is_hourly?: boolean | null, group_days_ahead?: number | null, should_include_all_overdue?: boolean | null, included_clients?: Array<string> | null, excluded_clients?: Array<string> | null, other_result_exclusion_entity?: string | null, is_archived: boolean, created_at: number, updated_at: number, filters?: Array<{ __typename?: 'CustomerSegmentFilter', type: CustomerSegmentFilterType, only_consider_other_rows?: boolean | null, filters: Array<{ __typename?: 'QueryFilter', column: string, filterOp: FilterOp, value: { __typename?: 'QueryFilterValue', string?: string | null, float?: number | null, boolean?: boolean | null, stringArray?: Array<string> | null, floatArray?: Array<number> | null, millisFromNow?: number | null, relativeTime?: { __typename?: 'RelativeTime', quantity: number, unit: TimeUnit, direction: ReferenceDirection } | null } }> }> | null, excluded_filters: Array<{ __typename?: 'CustomerSegmentFilter', type: CustomerSegmentFilterType, only_consider_other_rows?: boolean | null, filters: Array<{ __typename?: 'QueryFilter', column: string, filterOp: FilterOp, value: { __typename?: 'QueryFilterValue', string?: string | null, float?: number | null, boolean?: boolean | null, stringArray?: Array<string> | null, floatArray?: Array<number> | null, millisFromNow?: number | null, relativeTime?: { __typename?: 'RelativeTime', quantity: number, unit: TimeUnit, direction: ReferenceDirection } | null } }> }>, all_inclusions?: Array<{ __typename?: 'SegmentFilter', foreign_table?: string | null, group?: string | null, parameters: Array<{ __typename?: 'QueryFilter', column: string, filterOp: FilterOp, value: { __typename?: 'QueryFilterValue', string?: string | null, float?: number | null, boolean?: boolean | null, stringArray?: Array<string> | null, floatArray?: Array<number> | null, millisFromNow?: number | null, relativeTime?: { __typename?: 'RelativeTime', quantity: number, unit: TimeUnit, direction: ReferenceDirection } | null } }> }> | null, any_inclusions?: Array<{ __typename?: 'SegmentFilter', foreign_table?: string | null, group?: string | null, parameters: Array<{ __typename?: 'QueryFilter', column: string, filterOp: FilterOp, value: { __typename?: 'QueryFilterValue', string?: string | null, float?: number | null, boolean?: boolean | null, stringArray?: Array<string> | null, floatArray?: Array<number> | null, millisFromNow?: number | null, relativeTime?: { __typename?: 'RelativeTime', quantity: number, unit: TimeUnit, direction: ReferenceDirection } | null } }> }> | null, any_exclusions?: Array<{ __typename?: 'SegmentFilter', foreign_table?: string | null, group?: string | null, parameters: Array<{ __typename?: 'QueryFilter', column: string, filterOp: FilterOp, value: { __typename?: 'QueryFilterValue', string?: string | null, float?: number | null, boolean?: boolean | null, stringArray?: Array<string> | null, floatArray?: Array<number> | null, millisFromNow?: number | null, relativeTime?: { __typename?: 'RelativeTime', quantity: number, unit: TimeUnit, direction: ReferenceDirection } | null } }> }> | null, any_other_exclusions?: Array<{ __typename?: 'SegmentFilter', foreign_table?: string | null, group?: string | null, parameters: Array<{ __typename?: 'QueryFilter', column: string, filterOp: FilterOp, value: { __typename?: 'QueryFilterValue', string?: string | null, float?: number | null, boolean?: boolean | null, stringArray?: Array<string> | null, floatArray?: Array<number> | null, millisFromNow?: number | null, relativeTime?: { __typename?: 'RelativeTime', quantity: number, unit: TimeUnit, direction: ReferenceDirection } | null } }> }> | null, default_exclusions_options: { __typename?: 'DefaultExclusionsOptions', exclude_cancelled_and_rescheduled_resources?: boolean | null, exclude_euthanasia_and_qol_resources?: boolean | null, exclude_euthanasia_and_qol_in_appt_notes?: boolean | null }, reference_date_params?: { __typename?: 'ReferenceDateParams', field: string, reference_periods?: Array<{ __typename?: 'ReferencePeriod', quantity: number, unit: TimeUnit, direction: ReferenceDirection }> | null } | null, notification_templates?: Array<{ __typename?: 'NotificationTemplate', id: string, name: string, is_active: boolean, is_archived: boolean, message_methods: Array<MessageMethod> }> | null, error_flags?: Array<{ __typename?: 'CustomerSegmentErrorFlag', filter_column: string, filter_index: number, parameter_index: number, message: string }> | null } };

export type DailyHuddleFieldsFragment = { __typename?: 'DailyHuddle', id: string, notes?: string | null, start_time: number, end_time?: number | null, created_at: number, updated_at: number, leader?: { __typename?: 'Clinician', id: string, name: string } | null, attendees?: Array<{ __typename?: 'Clinician', id: string, name: string }> | null };

export type GetDailyHuddleQueryVariables = Exact<{
  clinicId: Scalars['ID']['input'];
  dailyHuddleId: Scalars['ID']['input'];
}>;


export type GetDailyHuddleQuery = { __typename?: 'Query', dailyHuddle: { __typename?: 'DailyHuddle', id: string, notes?: string | null, start_time: number, end_time?: number | null, created_at: number, updated_at: number, leader?: { __typename?: 'Clinician', id: string, name: string } | null, attendees?: Array<{ __typename?: 'Clinician', id: string, name: string }> | null } };

export type GetDailyHuddlesByClinicQueryVariables = Exact<{
  clinicId: Scalars['ID']['input'];
}>;


export type GetDailyHuddlesByClinicQuery = { __typename?: 'Query', getDailyHuddlesByClinic: Array<{ __typename?: 'DailyHuddle', id: string, notes?: string | null, start_time: number, end_time?: number | null, created_at: number, updated_at: number, leader?: { __typename?: 'Clinician', id: string, name: string } | null, attendees?: Array<{ __typename?: 'Clinician', id: string, name: string }> | null }> };

export type CreateDailyHuddleMutationVariables = Exact<{
  clinicId: Scalars['ID']['input'];
  data: CreateDailyHuddleInput;
}>;


export type CreateDailyHuddleMutation = { __typename?: 'Mutation', createDailyHuddle: { __typename?: 'DailyHuddle', id: string, notes?: string | null, start_time: number, end_time?: number | null, created_at: number, updated_at: number, leader?: { __typename?: 'Clinician', id: string, name: string } | null, attendees?: Array<{ __typename?: 'Clinician', id: string, name: string }> | null } };

export type UpdateDailyHuddleMutationVariables = Exact<{
  clinicId: Scalars['ID']['input'];
  dailyHuddleId: Scalars['ID']['input'];
  data: UpdateDailyHuddleInput;
}>;


export type UpdateDailyHuddleMutation = { __typename?: 'Mutation', updateDailyHuddle: { __typename?: 'DailyHuddle', id: string, notes?: string | null, start_time: number, end_time?: number | null, created_at: number, updated_at: number, leader?: { __typename?: 'Clinician', id: string, name: string } | null, attendees?: Array<{ __typename?: 'Clinician', id: string, name: string }> | null } };

export type DataChatPreviewFieldsFragment = { __typename?: 'DataChat', id: string, name?: string | null, last_prompt_message?: string | null, updated_at: number };

export type DataChatFieldsFragment = { __typename?: 'DataChat', id: string, name?: string | null, data_chat_prompts: Array<{ __typename?: 'DataChatPrompt', id: string, prompt: string, response_message: string, created_at: number, response_data?: Array<{ __typename?: 'DataChatResponseRow', appointment?: { __typename?: 'Appointment', id: string, start_time: number, status: AppointmentStatus, service?: { __typename?: 'Service', id: string, name?: string | null } | null, patient?: { __typename?: 'Patient', id: string, name?: string | null } | null, client?: { __typename?: 'Client', id: string } | null, clinician?: { __typename?: 'Clinician', id: string, name: string } | null } | null, client?: { __typename?: 'Client', id: string, first_name?: string | null, last_name?: string | null, phone?: string | null, email?: string | null } | null, additional_info?: Array<{ __typename?: 'DataChatAdditionalInfo', name: string, value: string }> | null }> | null }> };

export type DataChatPromptFieldsFragment = { __typename?: 'DataChatPrompt', id: string, prompt: string, response_message: string, created_at: number, response_data?: Array<{ __typename?: 'DataChatResponseRow', appointment?: { __typename?: 'Appointment', id: string, start_time: number, status: AppointmentStatus, service?: { __typename?: 'Service', id: string, name?: string | null } | null, patient?: { __typename?: 'Patient', id: string, name?: string | null } | null, client?: { __typename?: 'Client', id: string } | null, clinician?: { __typename?: 'Clinician', id: string, name: string } | null } | null, client?: { __typename?: 'Client', id: string, first_name?: string | null, last_name?: string | null, phone?: string | null, email?: string | null } | null, additional_info?: Array<{ __typename?: 'DataChatAdditionalInfo', name: string, value: string }> | null }> | null };

export type DataChatResponseRowFieldsFragment = { __typename?: 'DataChatResponseRow', appointment?: { __typename?: 'Appointment', id: string, start_time: number, status: AppointmentStatus, service?: { __typename?: 'Service', id: string, name?: string | null } | null, patient?: { __typename?: 'Patient', id: string, name?: string | null } | null, client?: { __typename?: 'Client', id: string } | null, clinician?: { __typename?: 'Clinician', id: string, name: string } | null } | null, client?: { __typename?: 'Client', id: string, first_name?: string | null, last_name?: string | null, phone?: string | null, email?: string | null } | null, additional_info?: Array<{ __typename?: 'DataChatAdditionalInfo', name: string, value: string }> | null };

export type DataChatResponseAppointmentFieldsFragment = { __typename?: 'Appointment', id: string, start_time: number, status: AppointmentStatus, service?: { __typename?: 'Service', id: string, name?: string | null } | null, patient?: { __typename?: 'Patient', id: string, name?: string | null } | null, client?: { __typename?: 'Client', id: string } | null, clinician?: { __typename?: 'Clinician', id: string, name: string } | null };

export type DataChatResponseClientFieldsFragment = { __typename?: 'Client', id: string, first_name?: string | null, last_name?: string | null, phone?: string | null, email?: string | null };

export type GetDataChatQueryVariables = Exact<{
  id: Scalars['ID']['input'];
}>;


export type GetDataChatQuery = { __typename?: 'Query', dataChat: { __typename?: 'DataChat', id: string, name?: string | null, data_chat_prompts: Array<{ __typename?: 'DataChatPrompt', id: string, prompt: string, response_message: string, created_at: number, response_data?: Array<{ __typename?: 'DataChatResponseRow', appointment?: { __typename?: 'Appointment', id: string, start_time: number, status: AppointmentStatus, service?: { __typename?: 'Service', id: string, name?: string | null } | null, patient?: { __typename?: 'Patient', id: string, name?: string | null } | null, client?: { __typename?: 'Client', id: string } | null, clinician?: { __typename?: 'Clinician', id: string, name: string } | null } | null, client?: { __typename?: 'Client', id: string, first_name?: string | null, last_name?: string | null, phone?: string | null, email?: string | null } | null, additional_info?: Array<{ __typename?: 'DataChatAdditionalInfo', name: string, value: string }> | null }> | null }> } };

export type QueryClinicDataChatsQueryVariables = Exact<{
  clinicId: Scalars['ID']['input'];
  params?: InputMaybe<QueryParams>;
}>;


export type QueryClinicDataChatsQuery = { __typename?: 'Query', queryClinicDataChats: Array<{ __typename?: 'DataChat', id: string, name?: string | null, last_prompt_message?: string | null, updated_at: number }> };

export type CreateDataChatMutationVariables = Exact<{
  data: CreateDataChatInput;
}>;


export type CreateDataChatMutation = { __typename?: 'Mutation', createDataChat: { __typename?: 'DataChat', id: string, name?: string | null, data_chat_prompts: Array<{ __typename?: 'DataChatPrompt', id: string, prompt: string, response_message: string, created_at: number, response_data?: Array<{ __typename?: 'DataChatResponseRow', appointment?: { __typename?: 'Appointment', id: string, start_time: number, status: AppointmentStatus, service?: { __typename?: 'Service', id: string, name?: string | null } | null, patient?: { __typename?: 'Patient', id: string, name?: string | null } | null, client?: { __typename?: 'Client', id: string } | null, clinician?: { __typename?: 'Clinician', id: string, name: string } | null } | null, client?: { __typename?: 'Client', id: string, first_name?: string | null, last_name?: string | null, phone?: string | null, email?: string | null } | null, additional_info?: Array<{ __typename?: 'DataChatAdditionalInfo', name: string, value: string }> | null }> | null }> } };

export type UpdateDataChatMutationVariables = Exact<{
  id: Scalars['ID']['input'];
  data: UpdateDataChatInput;
}>;


export type UpdateDataChatMutation = { __typename?: 'Mutation', updateDataChat: { __typename?: 'DataChat', id: string, name?: string | null, data_chat_prompts: Array<{ __typename?: 'DataChatPrompt', id: string, prompt: string, response_message: string, created_at: number, response_data?: Array<{ __typename?: 'DataChatResponseRow', appointment?: { __typename?: 'Appointment', id: string, start_time: number, status: AppointmentStatus, service?: { __typename?: 'Service', id: string, name?: string | null } | null, patient?: { __typename?: 'Patient', id: string, name?: string | null } | null, client?: { __typename?: 'Client', id: string } | null, clinician?: { __typename?: 'Clinician', id: string, name: string } | null } | null, client?: { __typename?: 'Client', id: string, first_name?: string | null, last_name?: string | null, phone?: string | null, email?: string | null } | null, additional_info?: Array<{ __typename?: 'DataChatAdditionalInfo', name: string, value: string }> | null }> | null }> } };

export type SendDataChatPromptMutationVariables = Exact<{
  data: DataChatPromptInput;
}>;


export type SendDataChatPromptMutation = { __typename?: 'Mutation', sendDataChatPrompt: { __typename?: 'DataChat', id: string, name?: string | null, data_chat_prompts: Array<{ __typename?: 'DataChatPrompt', id: string, prompt: string, response_message: string, created_at: number, response_data?: Array<{ __typename?: 'DataChatResponseRow', appointment?: { __typename?: 'Appointment', id: string, start_time: number, status: AppointmentStatus, service?: { __typename?: 'Service', id: string, name?: string | null } | null, patient?: { __typename?: 'Patient', id: string, name?: string | null } | null, client?: { __typename?: 'Client', id: string } | null, clinician?: { __typename?: 'Clinician', id: string, name: string } | null } | null, client?: { __typename?: 'Client', id: string, first_name?: string | null, last_name?: string | null, phone?: string | null, email?: string | null } | null, additional_info?: Array<{ __typename?: 'DataChatAdditionalInfo', name: string, value: string }> | null }> | null }> } };

export type EmailCustomerSegmentCsvMutationVariables = Exact<{
  data: EmailCustomerSegmentCsvInput;
}>;


export type EmailCustomerSegmentCsvMutation = { __typename?: 'Mutation', emailCustomerSegmentCsv?: any | null };

export type DiagnosisFieldsFragment = { __typename?: 'Diagnosis', id: string, pms_id: string, name: string };

export type QueryDiagnosesQueryVariables = Exact<{
  where?: InputMaybe<Array<QueryInput> | QueryInput>;
  page?: InputMaybe<Scalars['NonNegativeInt']['input']>;
  pageSize?: InputMaybe<Scalars['NonNegativeInt']['input']>;
  orderBy?: InputMaybe<OrderByInput>;
}>;


export type QueryDiagnosesQuery = { __typename?: 'Query', queryDiagnoses: Array<{ __typename?: 'Diagnosis', id: string, pms_id: string, name: string }> };

export type EmailTemplateFieldsFragment = { __typename?: 'EmailTemplate', id: string, title: string, subject?: string | null, design?: any | null, html?: string | null, status: EmailTemplateStatus, created_at: number, updated_at: number, clinic?: { __typename?: 'Clinic', id: string } | null, clinic_group?: { __typename?: 'ClinicGroup', id: string, name: string } | null };

export type GetEmailTemplateQueryVariables = Exact<{
  id: Scalars['ID']['input'];
}>;


export type GetEmailTemplateQuery = { __typename?: 'Query', emailTemplate: { __typename?: 'EmailTemplate', id: string, title: string, subject?: string | null, design?: any | null, html?: string | null, status: EmailTemplateStatus, created_at: number, updated_at: number, clinic?: { __typename?: 'Clinic', id: string } | null, clinic_group?: { __typename?: 'ClinicGroup', id: string, name: string } | null } };

export type GetEmailTemplatesForClinicQueryVariables = Exact<{
  clinic: Scalars['ID']['input'];
  status?: InputMaybe<Array<EmailTemplateStatus> | EmailTemplateStatus>;
}>;


export type GetEmailTemplatesForClinicQuery = { __typename?: 'Query', emailTemplatesForClinic: Array<{ __typename?: 'EmailTemplate', id: string, title: string, subject?: string | null, design?: any | null, html?: string | null, status: EmailTemplateStatus, created_at: number, updated_at: number, clinic?: { __typename?: 'Clinic', id: string } | null, clinic_group?: { __typename?: 'ClinicGroup', id: string, name: string } | null }> };

export type QueryClinicEmailTemplatesQueryVariables = Exact<{
  clinicId: Scalars['ID']['input'];
  where?: InputMaybe<Array<QueryInput> | QueryInput>;
  page?: InputMaybe<Scalars['NonNegativeInt']['input']>;
  pageSize?: InputMaybe<Scalars['NonNegativeInt']['input']>;
  orderBy?: InputMaybe<OrderByInput>;
}>;


export type QueryClinicEmailTemplatesQuery = { __typename?: 'Query', queryClinicEmailTemplates?: Array<{ __typename?: 'EmailTemplate', id: string, title: string, subject?: string | null, design?: any | null, html?: string | null, status: EmailTemplateStatus, created_at: number, updated_at: number, clinic?: { __typename?: 'Clinic', id: string } | null, clinic_group?: { __typename?: 'ClinicGroup', id: string, name: string } | null }> | null };

export type CountClinicEmailTemplatesQueryVariables = Exact<{
  clinicId: Scalars['ID']['input'];
  where?: InputMaybe<Array<QueryInput> | QueryInput>;
}>;


export type CountClinicEmailTemplatesQuery = { __typename?: 'Query', countClinicEmailTemplates?: number | null };

export type QueryClinicGroupEmailTemplatesQueryVariables = Exact<{
  clinicGroupId: Scalars['ID']['input'];
  where?: InputMaybe<Array<QueryInput> | QueryInput>;
  page?: InputMaybe<Scalars['NonNegativeInt']['input']>;
  pageSize?: InputMaybe<Scalars['NonNegativeInt']['input']>;
  orderBy?: InputMaybe<OrderByInput>;
}>;


export type QueryClinicGroupEmailTemplatesQuery = { __typename?: 'Query', queryClinicGroupEmailTemplates?: Array<{ __typename?: 'EmailTemplate', id: string, title: string, subject?: string | null, design?: any | null, html?: string | null, status: EmailTemplateStatus, created_at: number, updated_at: number, clinic?: { __typename?: 'Clinic', id: string } | null, clinic_group?: { __typename?: 'ClinicGroup', id: string, name: string } | null }> | null };

export type CountClinicGroupEmailTemplatesQueryVariables = Exact<{
  clinicGroupId: Scalars['ID']['input'];
  where?: InputMaybe<Array<QueryInput> | QueryInput>;
}>;


export type CountClinicGroupEmailTemplatesQuery = { __typename?: 'Query', countClinicGroupEmailTemplates?: number | null };

export type CreateEmailTemplateMutationVariables = Exact<{
  clinic?: InputMaybe<Scalars['ID']['input']>;
  clinicGroup?: InputMaybe<Scalars['ID']['input']>;
}>;


export type CreateEmailTemplateMutation = { __typename?: 'Mutation', createEmailTemplate: { __typename?: 'EmailTemplate', id: string, title: string, subject?: string | null, design?: any | null, html?: string | null, status: EmailTemplateStatus, created_at: number, updated_at: number, clinic?: { __typename?: 'Clinic', id: string } | null, clinic_group?: { __typename?: 'ClinicGroup', id: string, name: string } | null } };

export type DuplicateEmailTemplateMutationVariables = Exact<{
  id: Scalars['ID']['input'];
}>;


export type DuplicateEmailTemplateMutation = { __typename?: 'Mutation', duplicateEmailTemplate: { __typename?: 'EmailTemplate', id: string, title: string, subject?: string | null, design?: any | null, html?: string | null, status: EmailTemplateStatus, created_at: number, updated_at: number, clinic?: { __typename?: 'Clinic', id: string } | null, clinic_group?: { __typename?: 'ClinicGroup', id: string, name: string } | null } };

export type UpdateEmailTemplateMutationVariables = Exact<{
  id: Scalars['ID']['input'];
  input: UpdateEmailTemplateInput;
}>;


export type UpdateEmailTemplateMutation = { __typename?: 'Mutation', updateEmailTemplate: { __typename?: 'EmailTemplate', id: string, title: string, subject?: string | null, design?: any | null, html?: string | null, status: EmailTemplateStatus, created_at: number, updated_at: number, clinic?: { __typename?: 'Clinic', id: string } | null, clinic_group?: { __typename?: 'ClinicGroup', id: string, name: string } | null } };

export type DeleteEmailTemplateMutationVariables = Exact<{
  id: Scalars['ID']['input'];
}>;


export type DeleteEmailTemplateMutation = { __typename?: 'Mutation', deleteEmailTemplate?: any | null };

export type SendTestEmailMutationVariables = Exact<{
  clinicId: Scalars['ID']['input'];
  emails: Array<Scalars['String']['input']> | Scalars['String']['input'];
  content: SendTestEmailContent;
}>;


export type SendTestEmailMutation = { __typename?: 'Mutation', sendTestEmail?: any | null };

export type CopyEmailTemplateAcrossClinicMutationVariables = Exact<{
  id: Scalars['ID']['input'];
  destinationClinicId: Scalars['ID']['input'];
}>;


export type CopyEmailTemplateAcrossClinicMutation = { __typename?: 'Mutation', copyEmailTemplateAcrossClinic: { __typename?: 'EmailTemplate', id: string, title: string, subject?: string | null, design?: any | null, html?: string | null, status: EmailTemplateStatus, created_at: number, updated_at: number, clinic?: { __typename?: 'Clinic', id: string } | null, clinic_group?: { __typename?: 'ClinicGroup', id: string, name: string } | null } };

export type ClinicGroupOnboardingStepFieldsFragment = { __typename?: 'ClinicGroupOnboardingStep', key: string, options: Array<string>, phase?: string | null, value_kind: ClinicGroupOnboardingStepValueKind };

export type ClinicGroupOnboardingTrancheFieldsFragment = { __typename?: 'ClinicGroupOnboardingTranche', key: string, is_complete: boolean, clinic_ids: Array<string> };

export type ClinicGroupOnboardingColumnConfigFieldsFragment = { __typename?: 'ClinicGroupOnboardingColumnConfig', column_id: string, is_scored: boolean, is_hidden: boolean, criterion?: { __typename?: 'ClinicGroupOnboardingCriterion', type: ClinicGroupOnboardingCriterionType, value?: string | null } | null };

export type ClinicGroupOnboardingCellNoteChangeFieldsFragment = { __typename?: 'ClinicGroupOnboardingCellNoteChange', note?: string | null, is_accepted: boolean, waiting_on?: ClinicGroupOnboardingWaitingOn | null, assigned_to?: string | null, assigned_to_name?: string | null, created_by: string, created_by_name?: string | null, created_at: number };

export type ClinicGroupOnboardingCellNoteFieldsFragment = { __typename?: 'ClinicGroupOnboardingCellNote', column_id: string, clinic_id: string, note?: string | null, is_accepted: boolean, waiting_on?: ClinicGroupOnboardingWaitingOn | null, assigned_to?: string | null, assigned_to_name?: string | null, created_by: string, created_by_name?: string | null, created_at: number, history: Array<{ __typename?: 'ClinicGroupOnboardingCellNoteChange', note?: string | null, is_accepted: boolean, waiting_on?: ClinicGroupOnboardingWaitingOn | null, assigned_to?: string | null, assigned_to_name?: string | null, created_by: string, created_by_name?: string | null, created_at: number }> };

export type OnboardingClinicSettingsFieldsFragment = { __typename?: 'ClinicSettings', google_review_link?: string | null, facebook_review_link?: string | null, review_google_id?: string | null, review_facebook_id?: string | null, send_reviews_to?: SendConfirmationsTo | null, review_message_methods?: Array<MessageMethod> | null, max_review_rating_for_notif?: number | null, should_use_private_reviews?: boolean | null, should_disable_online_scheduling?: boolean | null, appointment_entry_method?: AppointmentEntryMethod | null, schedule_method?: ScheduleMethod | null, is_using_detailed_services?: boolean | null, is_using_rooms?: boolean | null, does_use_rooms_to_schedule?: boolean | null, does_use_clinicians_to_schedule?: boolean | null, hide_clinician_preference: boolean, allow_first_appt_per_day?: boolean | null, allow_double_booking: boolean, base_schedule_duration?: number | null, time_slot_minutes: number, use_basic_timeslots: boolean, valid_booking_interval_minutes?: Array<number> | null, should_fit_last_conflict: boolean, only_use_adj_avail_guides: boolean, should_use_pms_availability?: boolean | null, scheduling_buffer_minutes?: number | null, cancellation_buffer_minutes?: number | null, reschedule_buffer_minutes?: number | null, scheduling_min_minutes_away?: number | null, scheduling_max_minutes_away?: number | null, max_patients_per_visit?: number | null, max_booking_columns?: number | null, max_booking_notes_length?: number | null, min_booking_notes_length?: number | null, simple_scheduling_rules_enabled: boolean, hide_closed_days_from_scheduling?: boolean | null, should_suggest_nearby_clinics?: boolean | null, nearby_clinic_min_total_slots?: number | null, nearby_clinic_min_day_slots?: number | null, included_species?: Array<Species> | null, non_blocking_services: Array<string>, does_require_verification?: boolean | null, does_require_referral?: boolean | null, should_automatically_assign_patient?: boolean | null, allow_reschedule?: boolean | null, reschedule_minutes_before?: number | null, reschedule_fee?: number | null, does_use_automatic_reschedule?: boolean | null, require_reason_for_cancellation?: boolean | null, cancellation_service_pms_id?: string | null, cancellation_clinician_pms_id?: string | null, should_allow_new_clients?: boolean | null, should_allow_new_patients?: boolean | null, should_create_clients?: boolean | null, should_create_patients?: boolean | null, does_require_new_client_address?: boolean | null, does_require_new_client_birthday?: boolean | null, does_require_new_client_title?: boolean | null, does_require_patient_color?: boolean | null, does_require_patient_weight?: boolean | null, does_require_patient_resuscitate?: boolean | null, booking_match_procedure?: BookingMatchProcedure | null, urgency_type?: UrgencyType | null, send_confirmations_to: SendConfirmationsTo, confirmation_days_before?: number | null, allow_confirmation_days_before?: number | null, send_new_appt_email?: boolean | null, notify_clinic_on?: Array<NotifyClinicOn> | null, is_using_notifications?: boolean | null, reminder_send_time_minutes?: number | null, should_sync_reminders?: boolean | null, default_reminder_service_id?: string | null, msgs_auto_priority?: boolean | null, auto_reply_enabled: boolean, auto_reply_message?: string | null, exclude_message_wrapper?: boolean | null, default_trigger_words?: Array<string> | null, sms_block_list?: Array<string> | null, comms_writeback_enabled: boolean, comms_should_daily_writeback: boolean, comms_use_pdf_for_writeback: boolean, comms_writeback_buffer_minutes: number, comms_writeback_before_appt_mins: number, comms_should_writeback_on_send: boolean, comms_should_writeback_on_receive: boolean, comms_should_writeback_notifs: boolean, comms_should_use_ai_writeback: boolean, form_writeback_enabled: boolean, payment_writeback_enabled: boolean, should_complete_sync?: boolean | null, server_syncing_only?: boolean | null, sync_interval_minutes: number, long_sync_interval_hours: number, pms_start_time?: any | null, pms_end_time?: any | null, should_default_pims_emails_on: boolean, should_default_pims_sms_on: boolean, should_default_marketing_sms_on: boolean, should_default_marketing_email_on: boolean, primary_clinician_pms_id?: string | null, primary_room_pms_id?: string | null, weight_key_pms_id?: string | null, status_set_on_payment_completed_pms_id?: string | null, primary_color?: string | null, accent_color?: string | null, custom_well_description?: string | null, custom_sick_description?: string | null, custom_other_title?: string | null, custom_other_description?: string | null, custom_appointment_notes_template?: string | null, custom_new_client_notes_template?: string | null, custom_new_patient_notes_template?: string | null, new_appt_requested_msg?: string | null, new_appt_approved_msg?: string | null, new_appt_approved_sms_msg?: string | null, new_appt_denied_msg?: string | null, clinic_hours_display?: string | null, hide_portal_vaccinations: boolean, hide_portal_reminders: boolean, hide_portal_prescriptions: boolean, hide_portal_weight: boolean, hide_soc_vaccinations?: boolean | null, hide_historic_vaccinations?: boolean | null, patient_details_tab_order: Array<PortalPatientDetailsTab>, should_award_loyalty_for_invoices?: boolean | null, invoice_loyalty_points_per_dollar?: number | null, app_download_loyalty_points?: number | null, referrer_loyalty_points?: number | null, referred_loyalty_points?: number | null, should_charge_client_stripe_fees?: boolean | null, chckvet_prescription_fee_split_percentage?: number | null, should_use_instant_prescription_requests?: boolean | null, prescription_pickup_service_id?: string | null, usage_spending_caps?: any | null, gtm_container_id?: string | null, ga_measurement_id?: string | null, facebook_pixel_id?: string | null, phone_provider?: PhoneProviderType | null, ai_calls_provider?: PhoneProviderType | null, ai_calls_phone_number?: string | null, ai_calls_voice_id?: string | null, ai_calls_agent_id?: string | null, ai_calls_outbound_agent_id?: string | null, ai_calls_cooldown_minutes?: number | null, ai_agent_style?: string | null, ai_agent_custom_instructions?: string | null, ai_calls_ambient_sound?: AiCallsAmbientSound | null, ai_calls_voice_speed?: number | null, ai_calls_interruption_sensitivity?: number | null, ai_calls_enable_dynamic_voice_speed?: boolean | null, should_hide_daily_huddle_financials: boolean, max_inactivity_duration?: number | null, compliance_statuses?: Array<string> | null, primary_clinic_group_id?: string | null, custom_merge_tags?: any | null };

export type OnboardingClinicFeatureFieldsFragment = { __typename?: 'ClinicFeatures', scheduling_enabled?: boolean | null, huddle_enabled?: boolean | null, payments_enabled?: boolean | null, telehealth_enabled?: boolean | null, messaging_enabled?: boolean | null, reviews_enabled?: boolean | null, loyalty_enabled?: boolean | null, forms_enabled?: boolean | null, help_enabled?: boolean | null, notifs_enabled?: boolean | null, bulk_messaging_enabled?: boolean | null, portal_enabled?: boolean | null, calls_enabled?: boolean | null, teamchat_enabled?: boolean | null, prescriptions_enabled?: boolean | null, medical_history_enabled?: boolean | null };

export type EnterpriseOnboardingRowFieldsFragment = { __typename?: 'EnterpriseOnboardingClinicRow', step_statuses: any, active_services_count: number, active_scheduling_rules_count: number, active_clinicians_count: number, settings_unlinked_fields: Array<string>, notifications_linked_count: number, notifications_unlinked_count: number, audiences_linked_count: number, audiences_unlinked_count: number, forms_linked_count: number, forms_unlinked_count: number, message_templates_linked_count: number, message_templates_unlinked_count: number, email_templates_linked_count: number, email_templates_unlinked_count: number, clinic: { __typename?: 'Clinic', id: string, name?: string | null, pms: PracticeManagementSystem, slug?: string | null, go_live_date?: string | null, tmp_feature_flags?: any | null, address?: { __typename?: 'Address', street_a?: string | null, city?: string | null, zip?: string | null } | null, settings?: { __typename?: 'ClinicSettings', google_review_link?: string | null, facebook_review_link?: string | null, review_google_id?: string | null, review_facebook_id?: string | null, send_reviews_to?: SendConfirmationsTo | null, review_message_methods?: Array<MessageMethod> | null, max_review_rating_for_notif?: number | null, should_use_private_reviews?: boolean | null, should_disable_online_scheduling?: boolean | null, appointment_entry_method?: AppointmentEntryMethod | null, schedule_method?: ScheduleMethod | null, is_using_detailed_services?: boolean | null, is_using_rooms?: boolean | null, does_use_rooms_to_schedule?: boolean | null, does_use_clinicians_to_schedule?: boolean | null, hide_clinician_preference: boolean, allow_first_appt_per_day?: boolean | null, allow_double_booking: boolean, base_schedule_duration?: number | null, time_slot_minutes: number, use_basic_timeslots: boolean, valid_booking_interval_minutes?: Array<number> | null, should_fit_last_conflict: boolean, only_use_adj_avail_guides: boolean, should_use_pms_availability?: boolean | null, scheduling_buffer_minutes?: number | null, cancellation_buffer_minutes?: number | null, reschedule_buffer_minutes?: number | null, scheduling_min_minutes_away?: number | null, scheduling_max_minutes_away?: number | null, max_patients_per_visit?: number | null, max_booking_columns?: number | null, max_booking_notes_length?: number | null, min_booking_notes_length?: number | null, simple_scheduling_rules_enabled: boolean, hide_closed_days_from_scheduling?: boolean | null, should_suggest_nearby_clinics?: boolean | null, nearby_clinic_min_total_slots?: number | null, nearby_clinic_min_day_slots?: number | null, included_species?: Array<Species> | null, non_blocking_services: Array<string>, does_require_verification?: boolean | null, does_require_referral?: boolean | null, should_automatically_assign_patient?: boolean | null, allow_reschedule?: boolean | null, reschedule_minutes_before?: number | null, reschedule_fee?: number | null, does_use_automatic_reschedule?: boolean | null, require_reason_for_cancellation?: boolean | null, cancellation_service_pms_id?: string | null, cancellation_clinician_pms_id?: string | null, should_allow_new_clients?: boolean | null, should_allow_new_patients?: boolean | null, should_create_clients?: boolean | null, should_create_patients?: boolean | null, does_require_new_client_address?: boolean | null, does_require_new_client_birthday?: boolean | null, does_require_new_client_title?: boolean | null, does_require_patient_color?: boolean | null, does_require_patient_weight?: boolean | null, does_require_patient_resuscitate?: boolean | null, booking_match_procedure?: BookingMatchProcedure | null, urgency_type?: UrgencyType | null, send_confirmations_to: SendConfirmationsTo, confirmation_days_before?: number | null, allow_confirmation_days_before?: number | null, send_new_appt_email?: boolean | null, notify_clinic_on?: Array<NotifyClinicOn> | null, is_using_notifications?: boolean | null, reminder_send_time_minutes?: number | null, should_sync_reminders?: boolean | null, default_reminder_service_id?: string | null, msgs_auto_priority?: boolean | null, auto_reply_enabled: boolean, auto_reply_message?: string | null, exclude_message_wrapper?: boolean | null, default_trigger_words?: Array<string> | null, sms_block_list?: Array<string> | null, comms_writeback_enabled: boolean, comms_should_daily_writeback: boolean, comms_use_pdf_for_writeback: boolean, comms_writeback_buffer_minutes: number, comms_writeback_before_appt_mins: number, comms_should_writeback_on_send: boolean, comms_should_writeback_on_receive: boolean, comms_should_writeback_notifs: boolean, comms_should_use_ai_writeback: boolean, form_writeback_enabled: boolean, payment_writeback_enabled: boolean, should_complete_sync?: boolean | null, server_syncing_only?: boolean | null, sync_interval_minutes: number, long_sync_interval_hours: number, pms_start_time?: any | null, pms_end_time?: any | null, should_default_pims_emails_on: boolean, should_default_pims_sms_on: boolean, should_default_marketing_sms_on: boolean, should_default_marketing_email_on: boolean, primary_clinician_pms_id?: string | null, primary_room_pms_id?: string | null, weight_key_pms_id?: string | null, status_set_on_payment_completed_pms_id?: string | null, primary_color?: string | null, accent_color?: string | null, custom_well_description?: string | null, custom_sick_description?: string | null, custom_other_title?: string | null, custom_other_description?: string | null, custom_appointment_notes_template?: string | null, custom_new_client_notes_template?: string | null, custom_new_patient_notes_template?: string | null, new_appt_requested_msg?: string | null, new_appt_approved_msg?: string | null, new_appt_approved_sms_msg?: string | null, new_appt_denied_msg?: string | null, clinic_hours_display?: string | null, hide_portal_vaccinations: boolean, hide_portal_reminders: boolean, hide_portal_prescriptions: boolean, hide_portal_weight: boolean, hide_soc_vaccinations?: boolean | null, hide_historic_vaccinations?: boolean | null, patient_details_tab_order: Array<PortalPatientDetailsTab>, should_award_loyalty_for_invoices?: boolean | null, invoice_loyalty_points_per_dollar?: number | null, app_download_loyalty_points?: number | null, referrer_loyalty_points?: number | null, referred_loyalty_points?: number | null, should_charge_client_stripe_fees?: boolean | null, chckvet_prescription_fee_split_percentage?: number | null, should_use_instant_prescription_requests?: boolean | null, prescription_pickup_service_id?: string | null, usage_spending_caps?: any | null, gtm_container_id?: string | null, ga_measurement_id?: string | null, facebook_pixel_id?: string | null, phone_provider?: PhoneProviderType | null, ai_calls_provider?: PhoneProviderType | null, ai_calls_phone_number?: string | null, ai_calls_voice_id?: string | null, ai_calls_agent_id?: string | null, ai_calls_outbound_agent_id?: string | null, ai_calls_cooldown_minutes?: number | null, ai_agent_style?: string | null, ai_agent_custom_instructions?: string | null, ai_calls_ambient_sound?: AiCallsAmbientSound | null, ai_calls_voice_speed?: number | null, ai_calls_interruption_sensitivity?: number | null, ai_calls_enable_dynamic_voice_speed?: boolean | null, should_hide_daily_huddle_financials: boolean, max_inactivity_duration?: number | null, compliance_statuses?: Array<string> | null, primary_clinic_group_id?: string | null, custom_merge_tags?: any | null } | null, features?: { __typename?: 'ClinicFeatures', scheduling_enabled?: boolean | null, huddle_enabled?: boolean | null, payments_enabled?: boolean | null, telehealth_enabled?: boolean | null, messaging_enabled?: boolean | null, reviews_enabled?: boolean | null, loyalty_enabled?: boolean | null, forms_enabled?: boolean | null, help_enabled?: boolean | null, notifs_enabled?: boolean | null, bulk_messaging_enabled?: boolean | null, portal_enabled?: boolean | null, calls_enabled?: boolean | null, teamchat_enabled?: boolean | null, prescriptions_enabled?: boolean | null, medical_history_enabled?: boolean | null } | null } };

export type GetEnterpriseOnboardingReportQueryVariables = Exact<{
  clinicGroupId: Scalars['ID']['input'];
  trancheKey?: InputMaybe<Scalars['String']['input']>;
}>;


export type GetEnterpriseOnboardingReportQuery = { __typename?: 'Query', enterpriseOnboardingReport: { __typename?: 'EnterpriseOnboardingReport', clinic_group_id: string, expected_merge_tags: Array<string>, steps: Array<{ __typename?: 'ClinicGroupOnboardingStep', key: string, options: Array<string>, phase?: string | null, value_kind: ClinicGroupOnboardingStepValueKind }>, tranches: Array<{ __typename?: 'ClinicGroupOnboardingTranche', key: string, is_complete: boolean, clinic_ids: Array<string> }>, cell_notes: Array<{ __typename?: 'ClinicGroupOnboardingCellNote', column_id: string, clinic_id: string, note?: string | null, is_accepted: boolean, waiting_on?: ClinicGroupOnboardingWaitingOn | null, assigned_to?: string | null, assigned_to_name?: string | null, created_by: string, created_by_name?: string | null, created_at: number, history: Array<{ __typename?: 'ClinicGroupOnboardingCellNoteChange', note?: string | null, is_accepted: boolean, waiting_on?: ClinicGroupOnboardingWaitingOn | null, assigned_to?: string | null, assigned_to_name?: string | null, created_by: string, created_by_name?: string | null, created_at: number }> }>, column_config: Array<{ __typename?: 'ClinicGroupOnboardingColumnConfig', column_id: string, is_scored: boolean, is_hidden: boolean, criterion?: { __typename?: 'ClinicGroupOnboardingCriterion', type: ClinicGroupOnboardingCriterionType, value?: string | null } | null }>, rows: Array<{ __typename?: 'EnterpriseOnboardingClinicRow', step_statuses: any, active_services_count: number, active_scheduling_rules_count: number, active_clinicians_count: number, settings_unlinked_fields: Array<string>, notifications_linked_count: number, notifications_unlinked_count: number, audiences_linked_count: number, audiences_unlinked_count: number, forms_linked_count: number, forms_unlinked_count: number, message_templates_linked_count: number, message_templates_unlinked_count: number, email_templates_linked_count: number, email_templates_unlinked_count: number, clinic: { __typename?: 'Clinic', id: string, name?: string | null, pms: PracticeManagementSystem, slug?: string | null, go_live_date?: string | null, tmp_feature_flags?: any | null, address?: { __typename?: 'Address', street_a?: string | null, city?: string | null, zip?: string | null } | null, settings?: { __typename?: 'ClinicSettings', google_review_link?: string | null, facebook_review_link?: string | null, review_google_id?: string | null, review_facebook_id?: string | null, send_reviews_to?: SendConfirmationsTo | null, review_message_methods?: Array<MessageMethod> | null, max_review_rating_for_notif?: number | null, should_use_private_reviews?: boolean | null, should_disable_online_scheduling?: boolean | null, appointment_entry_method?: AppointmentEntryMethod | null, schedule_method?: ScheduleMethod | null, is_using_detailed_services?: boolean | null, is_using_rooms?: boolean | null, does_use_rooms_to_schedule?: boolean | null, does_use_clinicians_to_schedule?: boolean | null, hide_clinician_preference: boolean, allow_first_appt_per_day?: boolean | null, allow_double_booking: boolean, base_schedule_duration?: number | null, time_slot_minutes: number, use_basic_timeslots: boolean, valid_booking_interval_minutes?: Array<number> | null, should_fit_last_conflict: boolean, only_use_adj_avail_guides: boolean, should_use_pms_availability?: boolean | null, scheduling_buffer_minutes?: number | null, cancellation_buffer_minutes?: number | null, reschedule_buffer_minutes?: number | null, scheduling_min_minutes_away?: number | null, scheduling_max_minutes_away?: number | null, max_patients_per_visit?: number | null, max_booking_columns?: number | null, max_booking_notes_length?: number | null, min_booking_notes_length?: number | null, simple_scheduling_rules_enabled: boolean, hide_closed_days_from_scheduling?: boolean | null, should_suggest_nearby_clinics?: boolean | null, nearby_clinic_min_total_slots?: number | null, nearby_clinic_min_day_slots?: number | null, included_species?: Array<Species> | null, non_blocking_services: Array<string>, does_require_verification?: boolean | null, does_require_referral?: boolean | null, should_automatically_assign_patient?: boolean | null, allow_reschedule?: boolean | null, reschedule_minutes_before?: number | null, reschedule_fee?: number | null, does_use_automatic_reschedule?: boolean | null, require_reason_for_cancellation?: boolean | null, cancellation_service_pms_id?: string | null, cancellation_clinician_pms_id?: string | null, should_allow_new_clients?: boolean | null, should_allow_new_patients?: boolean | null, should_create_clients?: boolean | null, should_create_patients?: boolean | null, does_require_new_client_address?: boolean | null, does_require_new_client_birthday?: boolean | null, does_require_new_client_title?: boolean | null, does_require_patient_color?: boolean | null, does_require_patient_weight?: boolean | null, does_require_patient_resuscitate?: boolean | null, booking_match_procedure?: BookingMatchProcedure | null, urgency_type?: UrgencyType | null, send_confirmations_to: SendConfirmationsTo, confirmation_days_before?: number | null, allow_confirmation_days_before?: number | null, send_new_appt_email?: boolean | null, notify_clinic_on?: Array<NotifyClinicOn> | null, is_using_notifications?: boolean | null, reminder_send_time_minutes?: number | null, should_sync_reminders?: boolean | null, default_reminder_service_id?: string | null, msgs_auto_priority?: boolean | null, auto_reply_enabled: boolean, auto_reply_message?: string | null, exclude_message_wrapper?: boolean | null, default_trigger_words?: Array<string> | null, sms_block_list?: Array<string> | null, comms_writeback_enabled: boolean, comms_should_daily_writeback: boolean, comms_use_pdf_for_writeback: boolean, comms_writeback_buffer_minutes: number, comms_writeback_before_appt_mins: number, comms_should_writeback_on_send: boolean, comms_should_writeback_on_receive: boolean, comms_should_writeback_notifs: boolean, comms_should_use_ai_writeback: boolean, form_writeback_enabled: boolean, payment_writeback_enabled: boolean, should_complete_sync?: boolean | null, server_syncing_only?: boolean | null, sync_interval_minutes: number, long_sync_interval_hours: number, pms_start_time?: any | null, pms_end_time?: any | null, should_default_pims_emails_on: boolean, should_default_pims_sms_on: boolean, should_default_marketing_sms_on: boolean, should_default_marketing_email_on: boolean, primary_clinician_pms_id?: string | null, primary_room_pms_id?: string | null, weight_key_pms_id?: string | null, status_set_on_payment_completed_pms_id?: string | null, primary_color?: string | null, accent_color?: string | null, custom_well_description?: string | null, custom_sick_description?: string | null, custom_other_title?: string | null, custom_other_description?: string | null, custom_appointment_notes_template?: string | null, custom_new_client_notes_template?: string | null, custom_new_patient_notes_template?: string | null, new_appt_requested_msg?: string | null, new_appt_approved_msg?: string | null, new_appt_approved_sms_msg?: string | null, new_appt_denied_msg?: string | null, clinic_hours_display?: string | null, hide_portal_vaccinations: boolean, hide_portal_reminders: boolean, hide_portal_prescriptions: boolean, hide_portal_weight: boolean, hide_soc_vaccinations?: boolean | null, hide_historic_vaccinations?: boolean | null, patient_details_tab_order: Array<PortalPatientDetailsTab>, should_award_loyalty_for_invoices?: boolean | null, invoice_loyalty_points_per_dollar?: number | null, app_download_loyalty_points?: number | null, referrer_loyalty_points?: number | null, referred_loyalty_points?: number | null, should_charge_client_stripe_fees?: boolean | null, chckvet_prescription_fee_split_percentage?: number | null, should_use_instant_prescription_requests?: boolean | null, prescription_pickup_service_id?: string | null, usage_spending_caps?: any | null, gtm_container_id?: string | null, ga_measurement_id?: string | null, facebook_pixel_id?: string | null, phone_provider?: PhoneProviderType | null, ai_calls_provider?: PhoneProviderType | null, ai_calls_phone_number?: string | null, ai_calls_voice_id?: string | null, ai_calls_agent_id?: string | null, ai_calls_outbound_agent_id?: string | null, ai_calls_cooldown_minutes?: number | null, ai_agent_style?: string | null, ai_agent_custom_instructions?: string | null, ai_calls_ambient_sound?: AiCallsAmbientSound | null, ai_calls_voice_speed?: number | null, ai_calls_interruption_sensitivity?: number | null, ai_calls_enable_dynamic_voice_speed?: boolean | null, should_hide_daily_huddle_financials: boolean, max_inactivity_duration?: number | null, compliance_statuses?: Array<string> | null, primary_clinic_group_id?: string | null, custom_merge_tags?: any | null } | null, features?: { __typename?: 'ClinicFeatures', scheduling_enabled?: boolean | null, huddle_enabled?: boolean | null, payments_enabled?: boolean | null, telehealth_enabled?: boolean | null, messaging_enabled?: boolean | null, reviews_enabled?: boolean | null, loyalty_enabled?: boolean | null, forms_enabled?: boolean | null, help_enabled?: boolean | null, notifs_enabled?: boolean | null, bulk_messaging_enabled?: boolean | null, portal_enabled?: boolean | null, calls_enabled?: boolean | null, teamchat_enabled?: boolean | null, prescriptions_enabled?: boolean | null, medical_history_enabled?: boolean | null } | null } }> } };

export type GetEnterpriseOnboardingEntitiesQueryVariables = Exact<{
  clinicGroupId: Scalars['ID']['input'];
  clinicId: Scalars['ID']['input'];
  entityType: EntityLinkType;
}>;


export type GetEnterpriseOnboardingEntitiesQuery = { __typename?: 'Query', enterpriseOnboardingEntities: Array<{ __typename?: 'EnterpriseOnboardingEntity', id: string, name: string, is_standardized: boolean }> };

export type GetEnterpriseOnboardingSetupEntitiesQueryVariables = Exact<{
  clinicGroupId: Scalars['ID']['input'];
  clinicId: Scalars['ID']['input'];
  kind: EnterpriseOnboardingSetupKind;
}>;


export type GetEnterpriseOnboardingSetupEntitiesQuery = { __typename?: 'Query', enterpriseOnboardingSetupEntities: Array<{ __typename?: 'EnterpriseOnboardingSetupEntity', id: string, name: string }> };

export type UpdateClinicGroupOnboardingStepsMutationVariables = Exact<{
  clinicGroupId: Scalars['ID']['input'];
  steps: Array<ClinicGroupOnboardingStepInput> | ClinicGroupOnboardingStepInput;
}>;


export type UpdateClinicGroupOnboardingStepsMutation = { __typename?: 'Mutation', updateClinicGroupOnboardingSteps: { __typename?: 'ClinicGroup', id: string, onboarding_steps: Array<{ __typename?: 'ClinicGroupOnboardingStep', key: string, options: Array<string>, phase?: string | null, value_kind: ClinicGroupOnboardingStepValueKind }> } };

export type UpdateClinicGroupOnboardingTranchesMutationVariables = Exact<{
  clinicGroupId: Scalars['ID']['input'];
  tranches: Array<ClinicGroupOnboardingTrancheInput> | ClinicGroupOnboardingTrancheInput;
}>;


export type UpdateClinicGroupOnboardingTranchesMutation = { __typename?: 'Mutation', updateClinicGroupOnboardingTranches: { __typename?: 'ClinicGroup', id: string, onboarding_tranches: Array<{ __typename?: 'ClinicGroupOnboardingTranche', key: string, is_complete: boolean, clinic_ids: Array<string> }> } };

export type SetClinicGroupTrancheCompleteMutationVariables = Exact<{
  clinicGroupId: Scalars['ID']['input'];
  trancheKey: Scalars['String']['input'];
  isComplete: Scalars['Boolean']['input'];
}>;


export type SetClinicGroupTrancheCompleteMutation = { __typename?: 'Mutation', setClinicGroupTrancheComplete: { __typename?: 'ClinicGroup', id: string, onboarding_tranches: Array<{ __typename?: 'ClinicGroupOnboardingTranche', key: string, is_complete: boolean, clinic_ids: Array<string> }> } };

export type GetClinicGroupExpectedMergeTagsQueryVariables = Exact<{
  clinicGroupId: Scalars['ID']['input'];
}>;


export type GetClinicGroupExpectedMergeTagsQuery = { __typename?: 'Query', clinicGroup: { __typename?: 'ClinicGroup', id: string, name: string, onboarding_expected_merge_tags: Array<string> } };

export type GetClinicGroupMergeTagEditorQueryVariables = Exact<{
  clinicGroupId: Scalars['ID']['input'];
}>;


export type GetClinicGroupMergeTagEditorQuery = { __typename?: 'Query', clinicGroup: { __typename?: 'ClinicGroup', id: string, name: string, onboarding_expected_merge_tags: Array<string>, clinic_group_clinics: Array<{ __typename?: 'ClinicGroupClinic', id: string, clinic: { __typename?: 'Clinic', id: string, name?: string | null, is_archived: boolean, settings?: { __typename?: 'ClinicSettings', custom_merge_tags?: any | null } | null } }> } };

export type UpdateClinicCustomMergeTagsMutationVariables = Exact<{
  clinicId: Scalars['ID']['input'];
  customMergeTags: Scalars['JSON']['input'];
}>;


export type UpdateClinicCustomMergeTagsMutation = { __typename?: 'Mutation', updateClinic: { __typename?: 'Clinic', id: string, settings?: { __typename?: 'ClinicSettings', custom_merge_tags?: any | null } | null } };

export type UpdateClinicGroupExpectedMergeTagsMutationVariables = Exact<{
  clinicGroupId: Scalars['ID']['input'];
  mergeTags: Array<Scalars['String']['input']> | Scalars['String']['input'];
}>;


export type UpdateClinicGroupExpectedMergeTagsMutation = { __typename?: 'Mutation', updateClinicGroupExpectedMergeTags: { __typename?: 'ClinicGroup', id: string, onboarding_expected_merge_tags: Array<string> } };

export type SetClinicGroupOnboardingCellNoteMutationVariables = Exact<{
  clinicGroupId: Scalars['ID']['input'];
  clinicId: Scalars['ID']['input'];
  columnId: Scalars['String']['input'];
  note?: InputMaybe<Scalars['String']['input']>;
  isAccepted?: InputMaybe<Scalars['Boolean']['input']>;
  waitingOn?: InputMaybe<ClinicGroupOnboardingWaitingOn>;
  assignedTo?: InputMaybe<Scalars['ID']['input']>;
}>;


export type SetClinicGroupOnboardingCellNoteMutation = { __typename?: 'Mutation', setClinicGroupOnboardingCellNote: Array<{ __typename?: 'ClinicGroupOnboardingCellNote', column_id: string, clinic_id: string, note?: string | null, is_accepted: boolean, waiting_on?: ClinicGroupOnboardingWaitingOn | null, assigned_to?: string | null, assigned_to_name?: string | null, created_by: string, created_by_name?: string | null, created_at: number, history: Array<{ __typename?: 'ClinicGroupOnboardingCellNoteChange', note?: string | null, is_accepted: boolean, waiting_on?: ClinicGroupOnboardingWaitingOn | null, assigned_to?: string | null, assigned_to_name?: string | null, created_by: string, created_by_name?: string | null, created_at: number }> }> };

export type ClearClinicGroupOnboardingCellNoteMutationVariables = Exact<{
  clinicGroupId: Scalars['ID']['input'];
  clinicId: Scalars['ID']['input'];
  columnId: Scalars['String']['input'];
}>;


export type ClearClinicGroupOnboardingCellNoteMutation = { __typename?: 'Mutation', clearClinicGroupOnboardingCellNote: Array<{ __typename?: 'ClinicGroupOnboardingCellNote', column_id: string, clinic_id: string, note?: string | null, is_accepted: boolean, waiting_on?: ClinicGroupOnboardingWaitingOn | null, assigned_to?: string | null, assigned_to_name?: string | null, created_by: string, created_by_name?: string | null, created_at: number, history: Array<{ __typename?: 'ClinicGroupOnboardingCellNoteChange', note?: string | null, is_accepted: boolean, waiting_on?: ClinicGroupOnboardingWaitingOn | null, assigned_to?: string | null, assigned_to_name?: string | null, created_by: string, created_by_name?: string | null, created_at: number }> }> };

export type SetClinicGroupOnboardingColumnsHiddenMutationVariables = Exact<{
  clinicGroupId: Scalars['ID']['input'];
  columnIds: Array<Scalars['String']['input']> | Scalars['String']['input'];
  isHidden: Scalars['Boolean']['input'];
}>;


export type SetClinicGroupOnboardingColumnsHiddenMutation = { __typename?: 'Mutation', setClinicGroupOnboardingColumnsHidden: Array<{ __typename?: 'ClinicGroupOnboardingColumnConfig', column_id: string, is_scored: boolean, is_hidden: boolean, criterion?: { __typename?: 'ClinicGroupOnboardingCriterion', type: ClinicGroupOnboardingCriterionType, value?: string | null } | null }> };

export type SetClinicGroupOnboardingColumnsScoredMutationVariables = Exact<{
  clinicGroupId: Scalars['ID']['input'];
  columnIds: Array<Scalars['String']['input']> | Scalars['String']['input'];
  isScored: Scalars['Boolean']['input'];
}>;


export type SetClinicGroupOnboardingColumnsScoredMutation = { __typename?: 'Mutation', setClinicGroupOnboardingColumnsScored: Array<{ __typename?: 'ClinicGroupOnboardingColumnConfig', column_id: string, is_scored: boolean, is_hidden: boolean, criterion?: { __typename?: 'ClinicGroupOnboardingCriterion', type: ClinicGroupOnboardingCriterionType, value?: string | null } | null }> };

export type SetClinicGroupOnboardingColumnCriterionMutationVariables = Exact<{
  clinicGroupId: Scalars['ID']['input'];
  columnId: Scalars['String']['input'];
  criterion?: InputMaybe<ClinicGroupOnboardingCriterionInput>;
}>;


export type SetClinicGroupOnboardingColumnCriterionMutation = { __typename?: 'Mutation', setClinicGroupOnboardingColumnCriterion: Array<{ __typename?: 'ClinicGroupOnboardingColumnConfig', column_id: string, is_scored: boolean, is_hidden: boolean, criterion?: { __typename?: 'ClinicGroupOnboardingCriterion', type: ClinicGroupOnboardingCriterionType, value?: string | null } | null }> };

export type SetClinicGroupOnboardingStepStatusMutationVariables = Exact<{
  clinicGroupId: Scalars['ID']['input'];
  clinicId: Scalars['ID']['input'];
  stepKey: Scalars['String']['input'];
  value?: InputMaybe<Scalars['String']['input']>;
}>;


export type SetClinicGroupOnboardingStepStatusMutation = { __typename?: 'Mutation', setClinicGroupOnboardingStepStatus: { __typename?: 'ClinicGroupOnboardingStepStatuses', clinic_id: string, clinic_group_id: string, step_statuses: any } };

export type SetClinicGroupOnboardingGoLiveDateMutationVariables = Exact<{
  clinicGroupId: Scalars['ID']['input'];
  clinicId: Scalars['ID']['input'];
  goLiveDate?: InputMaybe<Scalars['String']['input']>;
}>;


export type SetClinicGroupOnboardingGoLiveDateMutation = { __typename?: 'Mutation', setClinicGroupOnboardingGoLiveDate: { __typename?: 'ClinicGroupOnboardingGoLiveDate', clinic_id: string, go_live_date?: string | null } };

export type DrilldownRowFieldsFragment = { __typename?: 'DrilldownRow', appointment?: { __typename?: 'Appointment', id: string, pms?: PracticeManagementSystem | null, client_pms_id?: string | null, is_new_client?: boolean | null, start_time: number, drop_off_time?: number | null, minutes: number, is_new_patient?: boolean | null, is_clinician_auto_assigned?: boolean | null, patient_pms_id?: string | null, referring_clinic_name?: string | null, client_notes?: string | null, clinic_notes?: string | null, service_name?: string | null, status: AppointmentStatus, is_time_block?: boolean | null, is_confirmed?: boolean | null, origin?: EntityOrigin | null, reason_for_cancellation?: string | null, client_reason_for_cancellation?: string | null, new_client_name?: string | null, new_client_phone?: string | null, new_patient_name?: string | null, new_patient_species?: string | null, confirmed_at?: number | null, widget_source?: string | null, from_widget?: string | null, is_deleted?: boolean | null, created_at: number, updated_at: number, pms_created_at?: number | null, clinic?: { __typename?: 'Clinic', id: string, name?: string | null, slug?: string | null, pms_db?: { __typename?: 'PmsDb', id: string } | null, address?: { __typename?: 'Address', country?: string | null } | null } | null, client?: { __typename?: 'Client', id: string, first_name?: string | null, last_name?: string | null, secondary_first_name?: string | null, secondary_last_name?: string | null, phone?: string | null, email?: string | null, pms?: PracticeManagementSystem | null, pms_id?: string | null, last_appt_time?: number | null, last_contact_time?: number | null, email_enabled: boolean, sms_enabled: boolean, balance?: number | null, is_active?: boolean | null, is_unsubscribed: boolean, created_at: number, updated_at: number, client_phones?: Array<{ __typename?: 'ClientPhone', id: string, phone: string, country_code?: string | null, is_primary: boolean, is_chckup_primary: boolean, is_mobile: boolean, sms_available: boolean, is_unsubscribed: boolean, is_active: boolean, name?: string | null }> | null, client_emails?: Array<{ __typename?: 'ClientEmail', id: string, email: string, is_primary: boolean }> | null, clinic?: { __typename?: 'Clinic', id: string } | null, patients?: Array<{ __typename?: 'Patient', id: string, pms?: PracticeManagementSystem | null, pms_id?: string | null, name?: string | null, breed?: string | null, avatar_url?: string | null, last_appt_time?: number | null, gender?: string | null, fixed_status?: FixedStatus | null, weight?: number | null, birthday?: number | null, is_active?: boolean | null, is_deceased?: boolean | null, pms_created_at?: number | null, created_at: number, updated_at: number, owner?: { __typename?: 'Client', id: string, first_name?: string | null, last_name?: string | null, email?: string | null, phone?: string | null, address?: { __typename?: 'Address', country?: string | null } | null } | null, clinic_species?: { __typename?: 'ClinicSpecies', id: string, pms_id: string, description: string, is_primary: boolean, species: Species, weight_key: string, created_at: number, updated_at: number } | null, clinic?: { __typename?: 'Clinic', id: string } | null, clinic_breed?: { __typename?: 'Breed', id: string, description: string } | null, patient_vaccination_records?: Array<{ __typename?: 'PatientVaccinationRecord', id: string, vaccine_name?: string | null, manufacturer?: string | null, lot_number?: string | null, administered_date?: number | null, due_date?: number | null, rabies_tag?: string | null, is_rabies_vaccine?: boolean | null, is_soc: boolean, is_active: boolean, product?: { __typename?: 'Product', id: string, display_name?: string | null, name: string } | null }> | null, last_appointment?: { __typename?: 'Appointment', clinician?: { __typename?: 'Clinician', name: string, display_name?: string | null } | null } | null }> | null, address?: { __typename?: 'Address', street_a?: string | null, street_b?: string | null, city?: string | null, state?: string | null, zip?: string | null, country?: string | null } | null, user?: { __typename?: 'User', avatar_url?: string | null } | null, loyalty_members?: Array<{ __typename?: 'LoyaltyMember', id: string, available_points: number } | null> | null, settings?: { __typename?: 'ClientSettings', clinic_chckup_notifications_enabled: boolean, clinic_chckup_sms_enabled: boolean, clinic_chckup_email_enabled: boolean, client_chckup_notifications_enabled: boolean, client_chckup_sms_enabled: boolean, client_chckup_email_enabled: boolean, is_unsubscribed_from_marketing: boolean, is_unsubscribed_from_marketing_sms: boolean, is_unsubscribed_from_marketing_email: boolean } | null, last_appointment?: { __typename?: 'Appointment', clinician?: { __typename?: 'Clinician', name: string, display_name?: string | null } | null } | null } | null, clinician?: { __typename?: 'Clinician', id: string, name: string, display_name?: string | null, bio?: string | null, avatar_url?: string | null, initials?: string | null, excluded_species?: Array<Species> | null, excluded_service_ids?: Array<string> | null, authority_level?: AuthorityLevel | null, type: ResourceType, is_active?: boolean | null, is_assignable_in_pms?: boolean | null, does_contribute_to_fill_rate?: boolean | null, pms_id?: string | null, location?: string | null, pms_is_active: boolean, valid_booking_interval_minutes?: Array<number> | null, created_at: number, updated_at: number, clinic?: { __typename?: 'Clinic', id: string, name?: string | null } | null, pms_db?: { __typename?: 'PmsDb', id: string } | null, hours?: { __typename?: 'AvailabilityHours', monday?: Array<{ __typename?: 'TimeInterval', start?: number | null, end?: number | null }> | null, tuesday?: Array<{ __typename?: 'TimeInterval', start?: number | null, end?: number | null }> | null, wednesday?: Array<{ __typename?: 'TimeInterval', start?: number | null, end?: number | null }> | null, thursday?: Array<{ __typename?: 'TimeInterval', start?: number | null, end?: number | null }> | null, friday?: Array<{ __typename?: 'TimeInterval', start?: number | null, end?: number | null }> | null, saturday?: Array<{ __typename?: 'TimeInterval', start?: number | null, end?: number | null }> | null, sunday?: Array<{ __typename?: 'TimeInterval', start?: number | null, end?: number | null }> | null } | null, adjusted_availability?: Array<{ __typename?: 'Availability', date: number, pms_appt_type_pms_id?: string | null, times: Array<{ __typename?: 'TimeInterval', start?: number | null, end?: number | null }>, repeat?: { __typename?: 'RepeatAvailability', daysOfMonth?: Array<number> | null, daysOfWeek?: Array<DayOfWeek> | null, weekOfMonth?: WeekOfMonth | null, frequency: any, unit: RepeatUnit, end_date?: number | null } | null }> | null, pms_adjusted_availability?: Array<{ __typename?: 'Availability', date: number, pms_appt_type_pms_id?: string | null, times: Array<{ __typename?: 'TimeInterval', start?: number | null, end?: number | null }>, repeat?: { __typename?: 'RepeatAvailability', daysOfMonth?: Array<number> | null, daysOfWeek?: Array<DayOfWeek> | null, weekOfMonth?: WeekOfMonth | null, frequency: any, unit: RepeatUnit, end_date?: number | null } | null }> | null } | null, room?: { __typename?: 'Room', id: string, pms_id: string, name: string, display_name?: string | null, description?: string | null, concurrent_patients?: number | null, is_active: boolean, does_contribute_to_fill_rate?: boolean | null, valid_booking_interval_minutes?: Array<number> | null, created_at: number, updated_at: number, clinic?: { __typename?: 'Clinic', pms: PracticeManagementSystem, id: string, name?: string | null, time_zone?: string | null } | null, hours?: { __typename?: 'AvailabilityHours', monday?: Array<{ __typename?: 'TimeInterval', start?: number | null, end?: number | null }> | null, tuesday?: Array<{ __typename?: 'TimeInterval', start?: number | null, end?: number | null }> | null, wednesday?: Array<{ __typename?: 'TimeInterval', start?: number | null, end?: number | null }> | null, thursday?: Array<{ __typename?: 'TimeInterval', start?: number | null, end?: number | null }> | null, friday?: Array<{ __typename?: 'TimeInterval', start?: number | null, end?: number | null }> | null, saturday?: Array<{ __typename?: 'TimeInterval', start?: number | null, end?: number | null }> | null, sunday?: Array<{ __typename?: 'TimeInterval', start?: number | null, end?: number | null }> | null } | null, adjusted_availability?: Array<{ __typename?: 'Availability', date: number, pms_appt_type_pms_id?: string | null, times: Array<{ __typename?: 'TimeInterval', start?: number | null, end?: number | null }>, repeat?: { __typename?: 'RepeatAvailability', daysOfMonth?: Array<number> | null, daysOfWeek?: Array<DayOfWeek> | null, weekOfMonth?: WeekOfMonth | null, frequency: any, unit: RepeatUnit, end_date?: number | null } | null }> | null, pms_adjusted_availability?: Array<{ __typename?: 'Availability', date: number, pms_appt_type_pms_id?: string | null, times: Array<{ __typename?: 'TimeInterval', start?: number | null, end?: number | null }>, repeat?: { __typename?: 'RepeatAvailability', daysOfMonth?: Array<number> | null, daysOfWeek?: Array<DayOfWeek> | null, weekOfMonth?: WeekOfMonth | null, frequency: any, unit: RepeatUnit, end_date?: number | null } | null }> | null } | null, service?: { __typename?: 'Service', id: string, name?: string | null, color?: string | null } | null, patient?: { __typename?: 'Patient', id: string, pms?: PracticeManagementSystem | null, pms_id?: string | null, name?: string | null, breed?: string | null, avatar_url?: string | null, last_appt_time?: number | null, gender?: string | null, fixed_status?: FixedStatus | null, weight?: number | null, birthday?: number | null, is_active?: boolean | null, is_deceased?: boolean | null, pms_created_at?: number | null, created_at: number, updated_at: number, owner?: { __typename?: 'Client', id: string, first_name?: string | null, last_name?: string | null, email?: string | null, phone?: string | null, address?: { __typename?: 'Address', country?: string | null } | null } | null, clinic_species?: { __typename?: 'ClinicSpecies', id: string, pms_id: string, description: string, is_primary: boolean, species: Species, weight_key: string, created_at: number, updated_at: number } | null, clinic?: { __typename?: 'Clinic', id: string } | null, clinic_breed?: { __typename?: 'Breed', id: string, description: string } | null, patient_vaccination_records?: Array<{ __typename?: 'PatientVaccinationRecord', id: string, vaccine_name?: string | null, manufacturer?: string | null, lot_number?: string | null, administered_date?: number | null, due_date?: number | null, rabies_tag?: string | null, is_rabies_vaccine?: boolean | null, is_soc: boolean, is_active: boolean, product?: { __typename?: 'Product', id: string, display_name?: string | null, name: string } | null }> | null, last_appointment?: { __typename?: 'Appointment', clinician?: { __typename?: 'Clinician', name: string, display_name?: string | null } | null } | null } | null, clinic_appt_status?: { __typename?: 'ClinicApptStatus', id: string, description: string, status: AppointmentStatus } | null, client_info?: { __typename?: 'ClientInfo', first_name?: string | null, last_name?: string | null, email?: string | null, phone?: string | null } | null, patient_info?: { __typename?: 'PatientInfo', patient_name?: string | null, patient_breed?: string | null, patient_clinic_species?: string | null, patient_clinic_breed?: string | null } | null, clients_forms?: Array<{ __typename?: 'ClientForm', id: string, client_completed_at?: number | null, clinic_verified_at?: number | null, is_archived: boolean, pms_id?: string | null, created_at: number, updated_at: number, client?: { __typename?: 'Client', id: string, first_name?: string | null, last_name?: string | null, phone?: string | null, email?: string | null, address?: { __typename?: 'Address', street_a?: string | null, city?: string | null, state?: string | null, zip?: string | null, country?: string | null } | null } | null, patient?: { __typename?: 'Patient', id: string, name?: string | null, is_active?: boolean | null, is_deceased?: boolean | null, birthday?: number | null, weight?: number | null, avatar_url?: string | null, gender?: string | null, owner?: { __typename?: 'Client', first_name?: string | null, last_name?: string | null } | null, clinic_species?: { __typename?: 'ClinicSpecies', id: string, species: Species, description: string, weight_key: string } | null, clinic_breed?: { __typename?: 'Breed', id: string, description: string } | null } | null, form: { __typename?: 'Form', id: string, name?: string | null, form_type: FormType, is_writeback_enabled: boolean, form_file_naming_template?: string | null }, form_data: { __typename?: 'FormFields', pages?: Array<{ __typename?: 'FormPage', id: string, title?: string | null, description?: string | null, order?: number | null }> | null, fields?: Array<{ __typename?: 'FormElement', id: string, type?: FormElementType | null, content?: string | null, name?: string | null, column_order?: number | null, row_order?: number | null, page_id?: string | null, options?: Array<string> | null, is_required?: boolean | null, value?: string | null, attachments?: Array<{ __typename?: 'FormFileAttachment', id?: string | null, filename?: string | null, mime_type?: string | null, size_bytes?: number | null, thumbnail_url?: string | null, url: string }> | null, field_updates?: Array<{ __typename?: 'FormFieldUpdate', field: FormFieldUpdateField, boolean_value?: boolean | null, option?: string | null }> | null }> | null }, appointment?: { __typename?: 'Appointment', start_time: number, drop_off_time?: number | null, clinic?: { __typename?: 'Clinic', name?: string | null, slug?: string | null, phone?: string | null, email?: string | null, address?: { __typename?: 'Address', street_a?: string | null, city?: string | null, state?: string | null, zip?: string | null, country?: string | null } | null } | null, clinician?: { __typename?: 'Clinician', name: string, display_name?: string | null } | null, service?: { __typename?: 'Service', name?: string | null } | null } | null }> | null, widget?: { __typename?: 'Widget', id: string, widget_name: string } | null } | null, client?: { __typename?: 'Client', id: string, first_name?: string | null, last_name?: string | null, secondary_first_name?: string | null, secondary_last_name?: string | null, phone?: string | null, email?: string | null, pms?: PracticeManagementSystem | null, pms_id?: string | null, last_appt_time?: number | null, last_contact_time?: number | null, email_enabled: boolean, sms_enabled: boolean, balance?: number | null, is_active?: boolean | null, is_unsubscribed: boolean, created_at: number, updated_at: number, client_phones?: Array<{ __typename?: 'ClientPhone', id: string, phone: string, country_code?: string | null, is_primary: boolean, is_chckup_primary: boolean, is_mobile: boolean, sms_available: boolean, is_unsubscribed: boolean, is_active: boolean, name?: string | null }> | null, client_emails?: Array<{ __typename?: 'ClientEmail', id: string, email: string, is_primary: boolean }> | null, clinic?: { __typename?: 'Clinic', id: string } | null, patients?: Array<{ __typename?: 'Patient', id: string, pms?: PracticeManagementSystem | null, pms_id?: string | null, name?: string | null, breed?: string | null, avatar_url?: string | null, last_appt_time?: number | null, gender?: string | null, fixed_status?: FixedStatus | null, weight?: number | null, birthday?: number | null, is_active?: boolean | null, is_deceased?: boolean | null, pms_created_at?: number | null, created_at: number, updated_at: number, owner?: { __typename?: 'Client', id: string, first_name?: string | null, last_name?: string | null, email?: string | null, phone?: string | null, address?: { __typename?: 'Address', country?: string | null } | null } | null, clinic_species?: { __typename?: 'ClinicSpecies', id: string, pms_id: string, description: string, is_primary: boolean, species: Species, weight_key: string, created_at: number, updated_at: number } | null, clinic?: { __typename?: 'Clinic', id: string } | null, clinic_breed?: { __typename?: 'Breed', id: string, description: string } | null, patient_vaccination_records?: Array<{ __typename?: 'PatientVaccinationRecord', id: string, vaccine_name?: string | null, manufacturer?: string | null, lot_number?: string | null, administered_date?: number | null, due_date?: number | null, rabies_tag?: string | null, is_rabies_vaccine?: boolean | null, is_soc: boolean, is_active: boolean, product?: { __typename?: 'Product', id: string, display_name?: string | null, name: string } | null }> | null, last_appointment?: { __typename?: 'Appointment', clinician?: { __typename?: 'Clinician', name: string, display_name?: string | null } | null } | null }> | null, address?: { __typename?: 'Address', street_a?: string | null, street_b?: string | null, city?: string | null, state?: string | null, zip?: string | null, country?: string | null } | null, user?: { __typename?: 'User', avatar_url?: string | null } | null, loyalty_members?: Array<{ __typename?: 'LoyaltyMember', id: string, available_points: number } | null> | null, settings?: { __typename?: 'ClientSettings', clinic_chckup_notifications_enabled: boolean, clinic_chckup_sms_enabled: boolean, clinic_chckup_email_enabled: boolean, client_chckup_notifications_enabled: boolean, client_chckup_sms_enabled: boolean, client_chckup_email_enabled: boolean, is_unsubscribed_from_marketing: boolean, is_unsubscribed_from_marketing_sms: boolean, is_unsubscribed_from_marketing_email: boolean } | null, last_appointment?: { __typename?: 'Appointment', clinician?: { __typename?: 'Clinician', name: string, display_name?: string | null } | null } | null } | null, patient?: { __typename?: 'Patient', id: string, pms?: PracticeManagementSystem | null, pms_id?: string | null, name?: string | null, breed?: string | null, avatar_url?: string | null, last_appt_time?: number | null, gender?: string | null, fixed_status?: FixedStatus | null, weight?: number | null, birthday?: number | null, is_active?: boolean | null, is_deceased?: boolean | null, pms_created_at?: number | null, created_at: number, updated_at: number, owner?: { __typename?: 'Client', id: string, first_name?: string | null, last_name?: string | null, email?: string | null, phone?: string | null, address?: { __typename?: 'Address', country?: string | null } | null } | null, clinic_species?: { __typename?: 'ClinicSpecies', id: string, pms_id: string, description: string, is_primary: boolean, species: Species, weight_key: string, created_at: number, updated_at: number } | null, clinic?: { __typename?: 'Clinic', id: string } | null, clinic_breed?: { __typename?: 'Breed', id: string, description: string } | null, patient_vaccination_records?: Array<{ __typename?: 'PatientVaccinationRecord', id: string, vaccine_name?: string | null, manufacturer?: string | null, lot_number?: string | null, administered_date?: number | null, due_date?: number | null, rabies_tag?: string | null, is_rabies_vaccine?: boolean | null, is_soc: boolean, is_active: boolean, product?: { __typename?: 'Product', id: string, display_name?: string | null, name: string } | null }> | null, last_appointment?: { __typename?: 'Appointment', clinician?: { __typename?: 'Clinician', name: string, display_name?: string | null } | null } | null } | null, clinician?: { __typename?: 'Clinician', id: string, name: string, display_name?: string | null, bio?: string | null, avatar_url?: string | null, initials?: string | null, excluded_species?: Array<Species> | null, excluded_service_ids?: Array<string> | null, authority_level?: AuthorityLevel | null, type: ResourceType, is_active?: boolean | null, is_assignable_in_pms?: boolean | null, does_contribute_to_fill_rate?: boolean | null, pms_id?: string | null, location?: string | null, pms_is_active: boolean, valid_booking_interval_minutes?: Array<number> | null, created_at: number, updated_at: number, clinic?: { __typename?: 'Clinic', id: string, name?: string | null } | null, pms_db?: { __typename?: 'PmsDb', id: string } | null, hours?: { __typename?: 'AvailabilityHours', monday?: Array<{ __typename?: 'TimeInterval', start?: number | null, end?: number | null }> | null, tuesday?: Array<{ __typename?: 'TimeInterval', start?: number | null, end?: number | null }> | null, wednesday?: Array<{ __typename?: 'TimeInterval', start?: number | null, end?: number | null }> | null, thursday?: Array<{ __typename?: 'TimeInterval', start?: number | null, end?: number | null }> | null, friday?: Array<{ __typename?: 'TimeInterval', start?: number | null, end?: number | null }> | null, saturday?: Array<{ __typename?: 'TimeInterval', start?: number | null, end?: number | null }> | null, sunday?: Array<{ __typename?: 'TimeInterval', start?: number | null, end?: number | null }> | null } | null, adjusted_availability?: Array<{ __typename?: 'Availability', date: number, pms_appt_type_pms_id?: string | null, times: Array<{ __typename?: 'TimeInterval', start?: number | null, end?: number | null }>, repeat?: { __typename?: 'RepeatAvailability', daysOfMonth?: Array<number> | null, daysOfWeek?: Array<DayOfWeek> | null, weekOfMonth?: WeekOfMonth | null, frequency: any, unit: RepeatUnit, end_date?: number | null } | null }> | null, pms_adjusted_availability?: Array<{ __typename?: 'Availability', date: number, pms_appt_type_pms_id?: string | null, times: Array<{ __typename?: 'TimeInterval', start?: number | null, end?: number | null }>, repeat?: { __typename?: 'RepeatAvailability', daysOfMonth?: Array<number> | null, daysOfWeek?: Array<DayOfWeek> | null, weekOfMonth?: WeekOfMonth | null, frequency: any, unit: RepeatUnit, end_date?: number | null } | null }> | null } | null, invoice?: { __typename?: 'Invoice', id: string, pms_id: string, status: InvoiceStatus, entered_by_name?: string | null, description?: string | null, discount?: number | null, discount_reason?: string | null, subtotal?: number | null, tax?: number | null, total: number, total_paid?: number | null, balance?: number | null, currency: any, pims_created_at?: number | null, paid_at?: number | null, created_at: number, updated_at: number, clinic?: { __typename?: 'Clinic', id: string, name?: string | null } | null, appointment?: { __typename?: 'Appointment', id: string, service_name?: string | null, status: AppointmentStatus, start_time: number, drop_off_time?: number | null, minutes: number, service?: { __typename?: 'Service', name?: string | null } | null, clinician?: { __typename?: 'Clinician', name: string, display_name?: string | null } | null, client?: { __typename?: 'Client', first_name?: string | null, last_name?: string | null } | null, patient?: { __typename?: 'Patient', name?: string | null } | null } | null, previous_appt?: { __typename?: 'Appointment', id: string, service_name?: string | null, status: AppointmentStatus, start_time: number, drop_off_time?: number | null, minutes: number, service?: { __typename?: 'Service', name?: string | null } | null, clinician?: { __typename?: 'Clinician', name: string, display_name?: string | null } | null, client?: { __typename?: 'Client', first_name?: string | null, last_name?: string | null } | null, patient?: { __typename?: 'Patient', name?: string | null } | null } | null, client?: { __typename?: 'Client', id: string, first_name?: string | null, last_name?: string | null, email?: string | null, phone?: string | null } | null, patient?: { __typename?: 'Patient', id: string, name?: string | null } | null, clinician?: { __typename?: 'Clinician', id: string, name: string } | null } | null, invoice_item?: { __typename?: 'InvoiceItem', id: string, description?: string | null, quantity?: number | null, price?: number | null, total: number, subtotal?: number | null, tax?: number | null, discount?: number | null, pims_created_at?: number | null, clinician?: { __typename?: 'Clinician', id: string, name: string } | null, invoice?: { __typename?: 'Invoice', id: string, total: number, client?: { __typename?: 'Client', id: string, first_name?: string | null, last_name?: string | null } | null } | null } | null };

export type CountDrilldownEntitiesQueryVariables = Exact<{
  metricId: Scalars['ID']['input'];
  params: GetDrilldownEntitiesParams;
}>;


export type CountDrilldownEntitiesQuery = { __typename?: 'Query', countDrilldownEntities: number };

export type GetDrilldownEntitiesQueryVariables = Exact<{
  metricId: Scalars['ID']['input'];
  params: GetDrilldownEntitiesParams;
}>;


export type GetDrilldownEntitiesQuery = { __typename?: 'Query', getDrilldownEntities: Array<{ __typename?: 'DrilldownRow', appointment?: { __typename?: 'Appointment', id: string, pms?: PracticeManagementSystem | null, client_pms_id?: string | null, is_new_client?: boolean | null, start_time: number, drop_off_time?: number | null, minutes: number, is_new_patient?: boolean | null, is_clinician_auto_assigned?: boolean | null, patient_pms_id?: string | null, referring_clinic_name?: string | null, client_notes?: string | null, clinic_notes?: string | null, service_name?: string | null, status: AppointmentStatus, is_time_block?: boolean | null, is_confirmed?: boolean | null, origin?: EntityOrigin | null, reason_for_cancellation?: string | null, client_reason_for_cancellation?: string | null, new_client_name?: string | null, new_client_phone?: string | null, new_patient_name?: string | null, new_patient_species?: string | null, confirmed_at?: number | null, widget_source?: string | null, from_widget?: string | null, is_deleted?: boolean | null, created_at: number, updated_at: number, pms_created_at?: number | null, clinic?: { __typename?: 'Clinic', id: string, name?: string | null, slug?: string | null, pms_db?: { __typename?: 'PmsDb', id: string } | null, address?: { __typename?: 'Address', country?: string | null } | null } | null, client?: { __typename?: 'Client', id: string, first_name?: string | null, last_name?: string | null, secondary_first_name?: string | null, secondary_last_name?: string | null, phone?: string | null, email?: string | null, pms?: PracticeManagementSystem | null, pms_id?: string | null, last_appt_time?: number | null, last_contact_time?: number | null, email_enabled: boolean, sms_enabled: boolean, balance?: number | null, is_active?: boolean | null, is_unsubscribed: boolean, created_at: number, updated_at: number, client_phones?: Array<{ __typename?: 'ClientPhone', id: string, phone: string, country_code?: string | null, is_primary: boolean, is_chckup_primary: boolean, is_mobile: boolean, sms_available: boolean, is_unsubscribed: boolean, is_active: boolean, name?: string | null }> | null, client_emails?: Array<{ __typename?: 'ClientEmail', id: string, email: string, is_primary: boolean }> | null, clinic?: { __typename?: 'Clinic', id: string } | null, patients?: Array<{ __typename?: 'Patient', id: string, pms?: PracticeManagementSystem | null, pms_id?: string | null, name?: string | null, breed?: string | null, avatar_url?: string | null, last_appt_time?: number | null, gender?: string | null, fixed_status?: FixedStatus | null, weight?: number | null, birthday?: number | null, is_active?: boolean | null, is_deceased?: boolean | null, pms_created_at?: number | null, created_at: number, updated_at: number, owner?: { __typename?: 'Client', id: string, first_name?: string | null, last_name?: string | null, email?: string | null, phone?: string | null, address?: { __typename?: 'Address', country?: string | null } | null } | null, clinic_species?: { __typename?: 'ClinicSpecies', id: string, pms_id: string, description: string, is_primary: boolean, species: Species, weight_key: string, created_at: number, updated_at: number } | null, clinic?: { __typename?: 'Clinic', id: string } | null, clinic_breed?: { __typename?: 'Breed', id: string, description: string } | null, patient_vaccination_records?: Array<{ __typename?: 'PatientVaccinationRecord', id: string, vaccine_name?: string | null, manufacturer?: string | null, lot_number?: string | null, administered_date?: number | null, due_date?: number | null, rabies_tag?: string | null, is_rabies_vaccine?: boolean | null, is_soc: boolean, is_active: boolean, product?: { __typename?: 'Product', id: string, display_name?: string | null, name: string } | null }> | null, last_appointment?: { __typename?: 'Appointment', clinician?: { __typename?: 'Clinician', name: string, display_name?: string | null } | null } | null }> | null, address?: { __typename?: 'Address', street_a?: string | null, street_b?: string | null, city?: string | null, state?: string | null, zip?: string | null, country?: string | null } | null, user?: { __typename?: 'User', avatar_url?: string | null } | null, loyalty_members?: Array<{ __typename?: 'LoyaltyMember', id: string, available_points: number } | null> | null, settings?: { __typename?: 'ClientSettings', clinic_chckup_notifications_enabled: boolean, clinic_chckup_sms_enabled: boolean, clinic_chckup_email_enabled: boolean, client_chckup_notifications_enabled: boolean, client_chckup_sms_enabled: boolean, client_chckup_email_enabled: boolean, is_unsubscribed_from_marketing: boolean, is_unsubscribed_from_marketing_sms: boolean, is_unsubscribed_from_marketing_email: boolean } | null, last_appointment?: { __typename?: 'Appointment', clinician?: { __typename?: 'Clinician', name: string, display_name?: string | null } | null } | null } | null, clinician?: { __typename?: 'Clinician', id: string, name: string, display_name?: string | null, bio?: string | null, avatar_url?: string | null, initials?: string | null, excluded_species?: Array<Species> | null, excluded_service_ids?: Array<string> | null, authority_level?: AuthorityLevel | null, type: ResourceType, is_active?: boolean | null, is_assignable_in_pms?: boolean | null, does_contribute_to_fill_rate?: boolean | null, pms_id?: string | null, location?: string | null, pms_is_active: boolean, valid_booking_interval_minutes?: Array<number> | null, created_at: number, updated_at: number, clinic?: { __typename?: 'Clinic', id: string, name?: string | null } | null, pms_db?: { __typename?: 'PmsDb', id: string } | null, hours?: { __typename?: 'AvailabilityHours', monday?: Array<{ __typename?: 'TimeInterval', start?: number | null, end?: number | null }> | null, tuesday?: Array<{ __typename?: 'TimeInterval', start?: number | null, end?: number | null }> | null, wednesday?: Array<{ __typename?: 'TimeInterval', start?: number | null, end?: number | null }> | null, thursday?: Array<{ __typename?: 'TimeInterval', start?: number | null, end?: number | null }> | null, friday?: Array<{ __typename?: 'TimeInterval', start?: number | null, end?: number | null }> | null, saturday?: Array<{ __typename?: 'TimeInterval', start?: number | null, end?: number | null }> | null, sunday?: Array<{ __typename?: 'TimeInterval', start?: number | null, end?: number | null }> | null } | null, adjusted_availability?: Array<{ __typename?: 'Availability', date: number, pms_appt_type_pms_id?: string | null, times: Array<{ __typename?: 'TimeInterval', start?: number | null, end?: number | null }>, repeat?: { __typename?: 'RepeatAvailability', daysOfMonth?: Array<number> | null, daysOfWeek?: Array<DayOfWeek> | null, weekOfMonth?: WeekOfMonth | null, frequency: any, unit: RepeatUnit, end_date?: number | null } | null }> | null, pms_adjusted_availability?: Array<{ __typename?: 'Availability', date: number, pms_appt_type_pms_id?: string | null, times: Array<{ __typename?: 'TimeInterval', start?: number | null, end?: number | null }>, repeat?: { __typename?: 'RepeatAvailability', daysOfMonth?: Array<number> | null, daysOfWeek?: Array<DayOfWeek> | null, weekOfMonth?: WeekOfMonth | null, frequency: any, unit: RepeatUnit, end_date?: number | null } | null }> | null } | null, room?: { __typename?: 'Room', id: string, pms_id: string, name: string, display_name?: string | null, description?: string | null, concurrent_patients?: number | null, is_active: boolean, does_contribute_to_fill_rate?: boolean | null, valid_booking_interval_minutes?: Array<number> | null, created_at: number, updated_at: number, clinic?: { __typename?: 'Clinic', pms: PracticeManagementSystem, id: string, name?: string | null, time_zone?: string | null } | null, hours?: { __typename?: 'AvailabilityHours', monday?: Array<{ __typename?: 'TimeInterval', start?: number | null, end?: number | null }> | null, tuesday?: Array<{ __typename?: 'TimeInterval', start?: number | null, end?: number | null }> | null, wednesday?: Array<{ __typename?: 'TimeInterval', start?: number | null, end?: number | null }> | null, thursday?: Array<{ __typename?: 'TimeInterval', start?: number | null, end?: number | null }> | null, friday?: Array<{ __typename?: 'TimeInterval', start?: number | null, end?: number | null }> | null, saturday?: Array<{ __typename?: 'TimeInterval', start?: number | null, end?: number | null }> | null, sunday?: Array<{ __typename?: 'TimeInterval', start?: number | null, end?: number | null }> | null } | null, adjusted_availability?: Array<{ __typename?: 'Availability', date: number, pms_appt_type_pms_id?: string | null, times: Array<{ __typename?: 'TimeInterval', start?: number | null, end?: number | null }>, repeat?: { __typename?: 'RepeatAvailability', daysOfMonth?: Array<number> | null, daysOfWeek?: Array<DayOfWeek> | null, weekOfMonth?: WeekOfMonth | null, frequency: any, unit: RepeatUnit, end_date?: number | null } | null }> | null, pms_adjusted_availability?: Array<{ __typename?: 'Availability', date: number, pms_appt_type_pms_id?: string | null, times: Array<{ __typename?: 'TimeInterval', start?: number | null, end?: number | null }>, repeat?: { __typename?: 'RepeatAvailability', daysOfMonth?: Array<number> | null, daysOfWeek?: Array<DayOfWeek> | null, weekOfMonth?: WeekOfMonth | null, frequency: any, unit: RepeatUnit, end_date?: number | null } | null }> | null } | null, service?: { __typename?: 'Service', id: string, name?: string | null, color?: string | null } | null, patient?: { __typename?: 'Patient', id: string, pms?: PracticeManagementSystem | null, pms_id?: string | null, name?: string | null, breed?: string | null, avatar_url?: string | null, last_appt_time?: number | null, gender?: string | null, fixed_status?: FixedStatus | null, weight?: number | null, birthday?: number | null, is_active?: boolean | null, is_deceased?: boolean | null, pms_created_at?: number | null, created_at: number, updated_at: number, owner?: { __typename?: 'Client', id: string, first_name?: string | null, last_name?: string | null, email?: string | null, phone?: string | null, address?: { __typename?: 'Address', country?: string | null } | null } | null, clinic_species?: { __typename?: 'ClinicSpecies', id: string, pms_id: string, description: string, is_primary: boolean, species: Species, weight_key: string, created_at: number, updated_at: number } | null, clinic?: { __typename?: 'Clinic', id: string } | null, clinic_breed?: { __typename?: 'Breed', id: string, description: string } | null, patient_vaccination_records?: Array<{ __typename?: 'PatientVaccinationRecord', id: string, vaccine_name?: string | null, manufacturer?: string | null, lot_number?: string | null, administered_date?: number | null, due_date?: number | null, rabies_tag?: string | null, is_rabies_vaccine?: boolean | null, is_soc: boolean, is_active: boolean, product?: { __typename?: 'Product', id: string, display_name?: string | null, name: string } | null }> | null, last_appointment?: { __typename?: 'Appointment', clinician?: { __typename?: 'Clinician', name: string, display_name?: string | null } | null } | null } | null, clinic_appt_status?: { __typename?: 'ClinicApptStatus', id: string, description: string, status: AppointmentStatus } | null, client_info?: { __typename?: 'ClientInfo', first_name?: string | null, last_name?: string | null, email?: string | null, phone?: string | null } | null, patient_info?: { __typename?: 'PatientInfo', patient_name?: string | null, patient_breed?: string | null, patient_clinic_species?: string | null, patient_clinic_breed?: string | null } | null, clients_forms?: Array<{ __typename?: 'ClientForm', id: string, client_completed_at?: number | null, clinic_verified_at?: number | null, is_archived: boolean, pms_id?: string | null, created_at: number, updated_at: number, client?: { __typename?: 'Client', id: string, first_name?: string | null, last_name?: string | null, phone?: string | null, email?: string | null, address?: { __typename?: 'Address', street_a?: string | null, city?: string | null, state?: string | null, zip?: string | null, country?: string | null } | null } | null, patient?: { __typename?: 'Patient', id: string, name?: string | null, is_active?: boolean | null, is_deceased?: boolean | null, birthday?: number | null, weight?: number | null, avatar_url?: string | null, gender?: string | null, owner?: { __typename?: 'Client', first_name?: string | null, last_name?: string | null } | null, clinic_species?: { __typename?: 'ClinicSpecies', id: string, species: Species, description: string, weight_key: string } | null, clinic_breed?: { __typename?: 'Breed', id: string, description: string } | null } | null, form: { __typename?: 'Form', id: string, name?: string | null, form_type: FormType, is_writeback_enabled: boolean, form_file_naming_template?: string | null }, form_data: { __typename?: 'FormFields', pages?: Array<{ __typename?: 'FormPage', id: string, title?: string | null, description?: string | null, order?: number | null }> | null, fields?: Array<{ __typename?: 'FormElement', id: string, type?: FormElementType | null, content?: string | null, name?: string | null, column_order?: number | null, row_order?: number | null, page_id?: string | null, options?: Array<string> | null, is_required?: boolean | null, value?: string | null, attachments?: Array<{ __typename?: 'FormFileAttachment', id?: string | null, filename?: string | null, mime_type?: string | null, size_bytes?: number | null, thumbnail_url?: string | null, url: string }> | null, field_updates?: Array<{ __typename?: 'FormFieldUpdate', field: FormFieldUpdateField, boolean_value?: boolean | null, option?: string | null }> | null }> | null }, appointment?: { __typename?: 'Appointment', start_time: number, drop_off_time?: number | null, clinic?: { __typename?: 'Clinic', name?: string | null, slug?: string | null, phone?: string | null, email?: string | null, address?: { __typename?: 'Address', street_a?: string | null, city?: string | null, state?: string | null, zip?: string | null, country?: string | null } | null } | null, clinician?: { __typename?: 'Clinician', name: string, display_name?: string | null } | null, service?: { __typename?: 'Service', name?: string | null } | null } | null }> | null, widget?: { __typename?: 'Widget', id: string, widget_name: string } | null } | null, client?: { __typename?: 'Client', id: string, first_name?: string | null, last_name?: string | null, secondary_first_name?: string | null, secondary_last_name?: string | null, phone?: string | null, email?: string | null, pms?: PracticeManagementSystem | null, pms_id?: string | null, last_appt_time?: number | null, last_contact_time?: number | null, email_enabled: boolean, sms_enabled: boolean, balance?: number | null, is_active?: boolean | null, is_unsubscribed: boolean, created_at: number, updated_at: number, client_phones?: Array<{ __typename?: 'ClientPhone', id: string, phone: string, country_code?: string | null, is_primary: boolean, is_chckup_primary: boolean, is_mobile: boolean, sms_available: boolean, is_unsubscribed: boolean, is_active: boolean, name?: string | null }> | null, client_emails?: Array<{ __typename?: 'ClientEmail', id: string, email: string, is_primary: boolean }> | null, clinic?: { __typename?: 'Clinic', id: string } | null, patients?: Array<{ __typename?: 'Patient', id: string, pms?: PracticeManagementSystem | null, pms_id?: string | null, name?: string | null, breed?: string | null, avatar_url?: string | null, last_appt_time?: number | null, gender?: string | null, fixed_status?: FixedStatus | null, weight?: number | null, birthday?: number | null, is_active?: boolean | null, is_deceased?: boolean | null, pms_created_at?: number | null, created_at: number, updated_at: number, owner?: { __typename?: 'Client', id: string, first_name?: string | null, last_name?: string | null, email?: string | null, phone?: string | null, address?: { __typename?: 'Address', country?: string | null } | null } | null, clinic_species?: { __typename?: 'ClinicSpecies', id: string, pms_id: string, description: string, is_primary: boolean, species: Species, weight_key: string, created_at: number, updated_at: number } | null, clinic?: { __typename?: 'Clinic', id: string } | null, clinic_breed?: { __typename?: 'Breed', id: string, description: string } | null, patient_vaccination_records?: Array<{ __typename?: 'PatientVaccinationRecord', id: string, vaccine_name?: string | null, manufacturer?: string | null, lot_number?: string | null, administered_date?: number | null, due_date?: number | null, rabies_tag?: string | null, is_rabies_vaccine?: boolean | null, is_soc: boolean, is_active: boolean, product?: { __typename?: 'Product', id: string, display_name?: string | null, name: string } | null }> | null, last_appointment?: { __typename?: 'Appointment', clinician?: { __typename?: 'Clinician', name: string, display_name?: string | null } | null } | null }> | null, address?: { __typename?: 'Address', street_a?: string | null, street_b?: string | null, city?: string | null, state?: string | null, zip?: string | null, country?: string | null } | null, user?: { __typename?: 'User', avatar_url?: string | null } | null, loyalty_members?: Array<{ __typename?: 'LoyaltyMember', id: string, available_points: number } | null> | null, settings?: { __typename?: 'ClientSettings', clinic_chckup_notifications_enabled: boolean, clinic_chckup_sms_enabled: boolean, clinic_chckup_email_enabled: boolean, client_chckup_notifications_enabled: boolean, client_chckup_sms_enabled: boolean, client_chckup_email_enabled: boolean, is_unsubscribed_from_marketing: boolean, is_unsubscribed_from_marketing_sms: boolean, is_unsubscribed_from_marketing_email: boolean } | null, last_appointment?: { __typename?: 'Appointment', clinician?: { __typename?: 'Clinician', name: string, display_name?: string | null } | null } | null } | null, patient?: { __typename?: 'Patient', id: string, pms?: PracticeManagementSystem | null, pms_id?: string | null, name?: string | null, breed?: string | null, avatar_url?: string | null, last_appt_time?: number | null, gender?: string | null, fixed_status?: FixedStatus | null, weight?: number | null, birthday?: number | null, is_active?: boolean | null, is_deceased?: boolean | null, pms_created_at?: number | null, created_at: number, updated_at: number, owner?: { __typename?: 'Client', id: string, first_name?: string | null, last_name?: string | null, email?: string | null, phone?: string | null, address?: { __typename?: 'Address', country?: string | null } | null } | null, clinic_species?: { __typename?: 'ClinicSpecies', id: string, pms_id: string, description: string, is_primary: boolean, species: Species, weight_key: string, created_at: number, updated_at: number } | null, clinic?: { __typename?: 'Clinic', id: string } | null, clinic_breed?: { __typename?: 'Breed', id: string, description: string } | null, patient_vaccination_records?: Array<{ __typename?: 'PatientVaccinationRecord', id: string, vaccine_name?: string | null, manufacturer?: string | null, lot_number?: string | null, administered_date?: number | null, due_date?: number | null, rabies_tag?: string | null, is_rabies_vaccine?: boolean | null, is_soc: boolean, is_active: boolean, product?: { __typename?: 'Product', id: string, display_name?: string | null, name: string } | null }> | null, last_appointment?: { __typename?: 'Appointment', clinician?: { __typename?: 'Clinician', name: string, display_name?: string | null } | null } | null } | null, clinician?: { __typename?: 'Clinician', id: string, name: string, display_name?: string | null, bio?: string | null, avatar_url?: string | null, initials?: string | null, excluded_species?: Array<Species> | null, excluded_service_ids?: Array<string> | null, authority_level?: AuthorityLevel | null, type: ResourceType, is_active?: boolean | null, is_assignable_in_pms?: boolean | null, does_contribute_to_fill_rate?: boolean | null, pms_id?: string | null, location?: string | null, pms_is_active: boolean, valid_booking_interval_minutes?: Array<number> | null, created_at: number, updated_at: number, clinic?: { __typename?: 'Clinic', id: string, name?: string | null } | null, pms_db?: { __typename?: 'PmsDb', id: string } | null, hours?: { __typename?: 'AvailabilityHours', monday?: Array<{ __typename?: 'TimeInterval', start?: number | null, end?: number | null }> | null, tuesday?: Array<{ __typename?: 'TimeInterval', start?: number | null, end?: number | null }> | null, wednesday?: Array<{ __typename?: 'TimeInterval', start?: number | null, end?: number | null }> | null, thursday?: Array<{ __typename?: 'TimeInterval', start?: number | null, end?: number | null }> | null, friday?: Array<{ __typename?: 'TimeInterval', start?: number | null, end?: number | null }> | null, saturday?: Array<{ __typename?: 'TimeInterval', start?: number | null, end?: number | null }> | null, sunday?: Array<{ __typename?: 'TimeInterval', start?: number | null, end?: number | null }> | null } | null, adjusted_availability?: Array<{ __typename?: 'Availability', date: number, pms_appt_type_pms_id?: string | null, times: Array<{ __typename?: 'TimeInterval', start?: number | null, end?: number | null }>, repeat?: { __typename?: 'RepeatAvailability', daysOfMonth?: Array<number> | null, daysOfWeek?: Array<DayOfWeek> | null, weekOfMonth?: WeekOfMonth | null, frequency: any, unit: RepeatUnit, end_date?: number | null } | null }> | null, pms_adjusted_availability?: Array<{ __typename?: 'Availability', date: number, pms_appt_type_pms_id?: string | null, times: Array<{ __typename?: 'TimeInterval', start?: number | null, end?: number | null }>, repeat?: { __typename?: 'RepeatAvailability', daysOfMonth?: Array<number> | null, daysOfWeek?: Array<DayOfWeek> | null, weekOfMonth?: WeekOfMonth | null, frequency: any, unit: RepeatUnit, end_date?: number | null } | null }> | null } | null, invoice?: { __typename?: 'Invoice', id: string, pms_id: string, status: InvoiceStatus, entered_by_name?: string | null, description?: string | null, discount?: number | null, discount_reason?: string | null, subtotal?: number | null, tax?: number | null, total: number, total_paid?: number | null, balance?: number | null, currency: any, pims_created_at?: number | null, paid_at?: number | null, created_at: number, updated_at: number, clinic?: { __typename?: 'Clinic', id: string, name?: string | null } | null, appointment?: { __typename?: 'Appointment', id: string, service_name?: string | null, status: AppointmentStatus, start_time: number, drop_off_time?: number | null, minutes: number, service?: { __typename?: 'Service', name?: string | null } | null, clinician?: { __typename?: 'Clinician', name: string, display_name?: string | null } | null, client?: { __typename?: 'Client', first_name?: string | null, last_name?: string | null } | null, patient?: { __typename?: 'Patient', name?: string | null } | null } | null, previous_appt?: { __typename?: 'Appointment', id: string, service_name?: string | null, status: AppointmentStatus, start_time: number, drop_off_time?: number | null, minutes: number, service?: { __typename?: 'Service', name?: string | null } | null, clinician?: { __typename?: 'Clinician', name: string, display_name?: string | null } | null, client?: { __typename?: 'Client', first_name?: string | null, last_name?: string | null } | null, patient?: { __typename?: 'Patient', name?: string | null } | null } | null, client?: { __typename?: 'Client', id: string, first_name?: string | null, last_name?: string | null, email?: string | null, phone?: string | null } | null, patient?: { __typename?: 'Patient', id: string, name?: string | null } | null, clinician?: { __typename?: 'Clinician', id: string, name: string } | null } | null, invoice_item?: { __typename?: 'InvoiceItem', id: string, description?: string | null, quantity?: number | null, price?: number | null, total: number, subtotal?: number | null, tax?: number | null, discount?: number | null, pims_created_at?: number | null, clinician?: { __typename?: 'Clinician', id: string, name: string } | null, invoice?: { __typename?: 'Invoice', id: string, total: number, client?: { __typename?: 'Client', id: string, first_name?: string | null, last_name?: string | null } | null } | null } | null }> };

export type EntityReportSharedFieldsFragment = { __typename?: 'EntityReport', id: string, entity_type: ReportEntityType, clinic?: { __typename?: 'Clinic', id: string, name?: string | null, time_zone?: string | null, slug?: string | null, address?: { __typename?: 'Address', street_a?: string | null, street_b?: string | null, city?: string | null, state?: string | null, zip?: string | null, country?: string | null } | null, hours?: { __typename?: 'AvailabilityHours', monday?: Array<{ __typename?: 'TimeInterval', start?: number | null, end?: number | null }> | null, tuesday?: Array<{ __typename?: 'TimeInterval', start?: number | null, end?: number | null }> | null, wednesday?: Array<{ __typename?: 'TimeInterval', start?: number | null, end?: number | null }> | null, thursday?: Array<{ __typename?: 'TimeInterval', start?: number | null, end?: number | null }> | null, friday?: Array<{ __typename?: 'TimeInterval', start?: number | null, end?: number | null }> | null, saturday?: Array<{ __typename?: 'TimeInterval', start?: number | null, end?: number | null }> | null, sunday?: Array<{ __typename?: 'TimeInterval', start?: number | null, end?: number | null }> | null } | null } | null, clinician?: { __typename?: 'Clinician', id: string, pms_id?: string | null, name: string } | null, service?: { __typename?: 'Service', id: string, name?: string | null } | null, product?: { __typename?: 'Product', id: string, name: string } | null, values: Array<{ __typename?: 'ReportValue', metric: ReportMetricType, key: string, column_values: Array<{ __typename?: 'ReportColumnValue', value?: number | null, percentile?: number | null, value_params: { __typename?: 'MetricValueParams', custom_label?: string | null, value_type: MetricValueType } }> }> };

export type EntityReportFieldsFragment = { __typename?: 'EntityReport', id: string, entity_type: ReportEntityType, entity_reports: Array<{ __typename?: 'EntityReport', id: string, entity_type: ReportEntityType, entity_reports: Array<{ __typename?: 'EntityReport', id: string, entity_type: ReportEntityType, clinic?: { __typename?: 'Clinic', id: string, name?: string | null, time_zone?: string | null, slug?: string | null, address?: { __typename?: 'Address', street_a?: string | null, street_b?: string | null, city?: string | null, state?: string | null, zip?: string | null, country?: string | null } | null, hours?: { __typename?: 'AvailabilityHours', monday?: Array<{ __typename?: 'TimeInterval', start?: number | null, end?: number | null }> | null, tuesday?: Array<{ __typename?: 'TimeInterval', start?: number | null, end?: number | null }> | null, wednesday?: Array<{ __typename?: 'TimeInterval', start?: number | null, end?: number | null }> | null, thursday?: Array<{ __typename?: 'TimeInterval', start?: number | null, end?: number | null }> | null, friday?: Array<{ __typename?: 'TimeInterval', start?: number | null, end?: number | null }> | null, saturday?: Array<{ __typename?: 'TimeInterval', start?: number | null, end?: number | null }> | null, sunday?: Array<{ __typename?: 'TimeInterval', start?: number | null, end?: number | null }> | null } | null } | null, clinician?: { __typename?: 'Clinician', id: string, pms_id?: string | null, name: string } | null, service?: { __typename?: 'Service', id: string, name?: string | null } | null, product?: { __typename?: 'Product', id: string, name: string } | null, values: Array<{ __typename?: 'ReportValue', metric: ReportMetricType, key: string, column_values: Array<{ __typename?: 'ReportColumnValue', value?: number | null, percentile?: number | null, value_params: { __typename?: 'MetricValueParams', custom_label?: string | null, value_type: MetricValueType } }> }> }>, clinic?: { __typename?: 'Clinic', id: string, name?: string | null, time_zone?: string | null, slug?: string | null, address?: { __typename?: 'Address', street_a?: string | null, street_b?: string | null, city?: string | null, state?: string | null, zip?: string | null, country?: string | null } | null, hours?: { __typename?: 'AvailabilityHours', monday?: Array<{ __typename?: 'TimeInterval', start?: number | null, end?: number | null }> | null, tuesday?: Array<{ __typename?: 'TimeInterval', start?: number | null, end?: number | null }> | null, wednesday?: Array<{ __typename?: 'TimeInterval', start?: number | null, end?: number | null }> | null, thursday?: Array<{ __typename?: 'TimeInterval', start?: number | null, end?: number | null }> | null, friday?: Array<{ __typename?: 'TimeInterval', start?: number | null, end?: number | null }> | null, saturday?: Array<{ __typename?: 'TimeInterval', start?: number | null, end?: number | null }> | null, sunday?: Array<{ __typename?: 'TimeInterval', start?: number | null, end?: number | null }> | null } | null } | null, clinician?: { __typename?: 'Clinician', id: string, pms_id?: string | null, name: string } | null, service?: { __typename?: 'Service', id: string, name?: string | null } | null, product?: { __typename?: 'Product', id: string, name: string } | null, values: Array<{ __typename?: 'ReportValue', metric: ReportMetricType, key: string, column_values: Array<{ __typename?: 'ReportColumnValue', value?: number | null, percentile?: number | null, value_params: { __typename?: 'MetricValueParams', custom_label?: string | null, value_type: MetricValueType } }> }> }>, clinic?: { __typename?: 'Clinic', id: string, name?: string | null, time_zone?: string | null, slug?: string | null, address?: { __typename?: 'Address', street_a?: string | null, street_b?: string | null, city?: string | null, state?: string | null, zip?: string | null, country?: string | null } | null, hours?: { __typename?: 'AvailabilityHours', monday?: Array<{ __typename?: 'TimeInterval', start?: number | null, end?: number | null }> | null, tuesday?: Array<{ __typename?: 'TimeInterval', start?: number | null, end?: number | null }> | null, wednesday?: Array<{ __typename?: 'TimeInterval', start?: number | null, end?: number | null }> | null, thursday?: Array<{ __typename?: 'TimeInterval', start?: number | null, end?: number | null }> | null, friday?: Array<{ __typename?: 'TimeInterval', start?: number | null, end?: number | null }> | null, saturday?: Array<{ __typename?: 'TimeInterval', start?: number | null, end?: number | null }> | null, sunday?: Array<{ __typename?: 'TimeInterval', start?: number | null, end?: number | null }> | null } | null } | null, clinician?: { __typename?: 'Clinician', id: string, pms_id?: string | null, name: string } | null, service?: { __typename?: 'Service', id: string, name?: string | null } | null, product?: { __typename?: 'Product', id: string, name: string } | null, values: Array<{ __typename?: 'ReportValue', metric: ReportMetricType, key: string, column_values: Array<{ __typename?: 'ReportColumnValue', value?: number | null, percentile?: number | null, value_params: { __typename?: 'MetricValueParams', custom_label?: string | null, value_type: MetricValueType } }> }> };

export type FirstChildReportFieldsFragment = { __typename?: 'EntityReport', id: string, entity_type: ReportEntityType, entity_reports: Array<{ __typename?: 'EntityReport', id: string, entity_type: ReportEntityType, clinic?: { __typename?: 'Clinic', id: string, name?: string | null, time_zone?: string | null, slug?: string | null, address?: { __typename?: 'Address', street_a?: string | null, street_b?: string | null, city?: string | null, state?: string | null, zip?: string | null, country?: string | null } | null, hours?: { __typename?: 'AvailabilityHours', monday?: Array<{ __typename?: 'TimeInterval', start?: number | null, end?: number | null }> | null, tuesday?: Array<{ __typename?: 'TimeInterval', start?: number | null, end?: number | null }> | null, wednesday?: Array<{ __typename?: 'TimeInterval', start?: number | null, end?: number | null }> | null, thursday?: Array<{ __typename?: 'TimeInterval', start?: number | null, end?: number | null }> | null, friday?: Array<{ __typename?: 'TimeInterval', start?: number | null, end?: number | null }> | null, saturday?: Array<{ __typename?: 'TimeInterval', start?: number | null, end?: number | null }> | null, sunday?: Array<{ __typename?: 'TimeInterval', start?: number | null, end?: number | null }> | null } | null } | null, clinician?: { __typename?: 'Clinician', id: string, pms_id?: string | null, name: string } | null, service?: { __typename?: 'Service', id: string, name?: string | null } | null, product?: { __typename?: 'Product', id: string, name: string } | null, values: Array<{ __typename?: 'ReportValue', metric: ReportMetricType, key: string, column_values: Array<{ __typename?: 'ReportColumnValue', value?: number | null, percentile?: number | null, value_params: { __typename?: 'MetricValueParams', custom_label?: string | null, value_type: MetricValueType } }> }> }>, clinic?: { __typename?: 'Clinic', id: string, name?: string | null, time_zone?: string | null, slug?: string | null, address?: { __typename?: 'Address', street_a?: string | null, street_b?: string | null, city?: string | null, state?: string | null, zip?: string | null, country?: string | null } | null, hours?: { __typename?: 'AvailabilityHours', monday?: Array<{ __typename?: 'TimeInterval', start?: number | null, end?: number | null }> | null, tuesday?: Array<{ __typename?: 'TimeInterval', start?: number | null, end?: number | null }> | null, wednesday?: Array<{ __typename?: 'TimeInterval', start?: number | null, end?: number | null }> | null, thursday?: Array<{ __typename?: 'TimeInterval', start?: number | null, end?: number | null }> | null, friday?: Array<{ __typename?: 'TimeInterval', start?: number | null, end?: number | null }> | null, saturday?: Array<{ __typename?: 'TimeInterval', start?: number | null, end?: number | null }> | null, sunday?: Array<{ __typename?: 'TimeInterval', start?: number | null, end?: number | null }> | null } | null } | null, clinician?: { __typename?: 'Clinician', id: string, pms_id?: string | null, name: string } | null, service?: { __typename?: 'Service', id: string, name?: string | null } | null, product?: { __typename?: 'Product', id: string, name: string } | null, values: Array<{ __typename?: 'ReportValue', metric: ReportMetricType, key: string, column_values: Array<{ __typename?: 'ReportColumnValue', value?: number | null, percentile?: number | null, value_params: { __typename?: 'MetricValueParams', custom_label?: string | null, value_type: MetricValueType } }> }> };

export type SecondChildReportFieldsFragment = { __typename?: 'EntityReport', id: string, entity_type: ReportEntityType, clinic?: { __typename?: 'Clinic', id: string, name?: string | null, time_zone?: string | null, slug?: string | null, address?: { __typename?: 'Address', street_a?: string | null, street_b?: string | null, city?: string | null, state?: string | null, zip?: string | null, country?: string | null } | null, hours?: { __typename?: 'AvailabilityHours', monday?: Array<{ __typename?: 'TimeInterval', start?: number | null, end?: number | null }> | null, tuesday?: Array<{ __typename?: 'TimeInterval', start?: number | null, end?: number | null }> | null, wednesday?: Array<{ __typename?: 'TimeInterval', start?: number | null, end?: number | null }> | null, thursday?: Array<{ __typename?: 'TimeInterval', start?: number | null, end?: number | null }> | null, friday?: Array<{ __typename?: 'TimeInterval', start?: number | null, end?: number | null }> | null, saturday?: Array<{ __typename?: 'TimeInterval', start?: number | null, end?: number | null }> | null, sunday?: Array<{ __typename?: 'TimeInterval', start?: number | null, end?: number | null }> | null } | null } | null, clinician?: { __typename?: 'Clinician', id: string, pms_id?: string | null, name: string } | null, service?: { __typename?: 'Service', id: string, name?: string | null } | null, product?: { __typename?: 'Product', id: string, name: string } | null, values: Array<{ __typename?: 'ReportValue', metric: ReportMetricType, key: string, column_values: Array<{ __typename?: 'ReportColumnValue', value?: number | null, percentile?: number | null, value_params: { __typename?: 'MetricValueParams', custom_label?: string | null, value_type: MetricValueType } }> }> };

export type ReportValueFieldsFragment = { __typename?: 'ReportValue', metric: ReportMetricType, key: string, column_values: Array<{ __typename?: 'ReportColumnValue', value?: number | null, percentile?: number | null, value_params: { __typename?: 'MetricValueParams', custom_label?: string | null, value_type: MetricValueType } }> };

export type EntityReportClinicianFieldsFragment = { __typename?: 'Clinician', id: string, pms_id?: string | null, name: string };

export type EntityReportServiceFieldsFragment = { __typename?: 'Service', id: string, name?: string | null };

export type EntityReportProductFieldsFragment = { __typename?: 'Product', id: string, name: string };

export type QueryEntityReportsQueryVariables = Exact<{
  where?: InputMaybe<Array<QueryInput> | QueryInput>;
  page?: InputMaybe<Scalars['NonNegativeInt']['input']>;
  pageSize?: InputMaybe<Scalars['NonNegativeInt']['input']>;
  orderBy?: InputMaybe<OrderByInput>;
}>;


export type QueryEntityReportsQuery = { __typename?: 'Query', queryEntityReports: Array<{ __typename?: 'EntityReport', id: string, entity_type: ReportEntityType, entity_reports: Array<{ __typename?: 'EntityReport', id: string, entity_type: ReportEntityType, entity_reports: Array<{ __typename?: 'EntityReport', id: string, entity_type: ReportEntityType, clinic?: { __typename?: 'Clinic', id: string, name?: string | null, time_zone?: string | null, slug?: string | null, address?: { __typename?: 'Address', street_a?: string | null, street_b?: string | null, city?: string | null, state?: string | null, zip?: string | null, country?: string | null } | null, hours?: { __typename?: 'AvailabilityHours', monday?: Array<{ __typename?: 'TimeInterval', start?: number | null, end?: number | null }> | null, tuesday?: Array<{ __typename?: 'TimeInterval', start?: number | null, end?: number | null }> | null, wednesday?: Array<{ __typename?: 'TimeInterval', start?: number | null, end?: number | null }> | null, thursday?: Array<{ __typename?: 'TimeInterval', start?: number | null, end?: number | null }> | null, friday?: Array<{ __typename?: 'TimeInterval', start?: number | null, end?: number | null }> | null, saturday?: Array<{ __typename?: 'TimeInterval', start?: number | null, end?: number | null }> | null, sunday?: Array<{ __typename?: 'TimeInterval', start?: number | null, end?: number | null }> | null } | null } | null, clinician?: { __typename?: 'Clinician', id: string, pms_id?: string | null, name: string } | null, service?: { __typename?: 'Service', id: string, name?: string | null } | null, product?: { __typename?: 'Product', id: string, name: string } | null, values: Array<{ __typename?: 'ReportValue', metric: ReportMetricType, key: string, column_values: Array<{ __typename?: 'ReportColumnValue', value?: number | null, percentile?: number | null, value_params: { __typename?: 'MetricValueParams', custom_label?: string | null, value_type: MetricValueType } }> }> }>, clinic?: { __typename?: 'Clinic', id: string, name?: string | null, time_zone?: string | null, slug?: string | null, address?: { __typename?: 'Address', street_a?: string | null, street_b?: string | null, city?: string | null, state?: string | null, zip?: string | null, country?: string | null } | null, hours?: { __typename?: 'AvailabilityHours', monday?: Array<{ __typename?: 'TimeInterval', start?: number | null, end?: number | null }> | null, tuesday?: Array<{ __typename?: 'TimeInterval', start?: number | null, end?: number | null }> | null, wednesday?: Array<{ __typename?: 'TimeInterval', start?: number | null, end?: number | null }> | null, thursday?: Array<{ __typename?: 'TimeInterval', start?: number | null, end?: number | null }> | null, friday?: Array<{ __typename?: 'TimeInterval', start?: number | null, end?: number | null }> | null, saturday?: Array<{ __typename?: 'TimeInterval', start?: number | null, end?: number | null }> | null, sunday?: Array<{ __typename?: 'TimeInterval', start?: number | null, end?: number | null }> | null } | null } | null, clinician?: { __typename?: 'Clinician', id: string, pms_id?: string | null, name: string } | null, service?: { __typename?: 'Service', id: string, name?: string | null } | null, product?: { __typename?: 'Product', id: string, name: string } | null, values: Array<{ __typename?: 'ReportValue', metric: ReportMetricType, key: string, column_values: Array<{ __typename?: 'ReportColumnValue', value?: number | null, percentile?: number | null, value_params: { __typename?: 'MetricValueParams', custom_label?: string | null, value_type: MetricValueType } }> }> }>, clinic?: { __typename?: 'Clinic', id: string, name?: string | null, time_zone?: string | null, slug?: string | null, address?: { __typename?: 'Address', street_a?: string | null, street_b?: string | null, city?: string | null, state?: string | null, zip?: string | null, country?: string | null } | null, hours?: { __typename?: 'AvailabilityHours', monday?: Array<{ __typename?: 'TimeInterval', start?: number | null, end?: number | null }> | null, tuesday?: Array<{ __typename?: 'TimeInterval', start?: number | null, end?: number | null }> | null, wednesday?: Array<{ __typename?: 'TimeInterval', start?: number | null, end?: number | null }> | null, thursday?: Array<{ __typename?: 'TimeInterval', start?: number | null, end?: number | null }> | null, friday?: Array<{ __typename?: 'TimeInterval', start?: number | null, end?: number | null }> | null, saturday?: Array<{ __typename?: 'TimeInterval', start?: number | null, end?: number | null }> | null, sunday?: Array<{ __typename?: 'TimeInterval', start?: number | null, end?: number | null }> | null } | null } | null, clinician?: { __typename?: 'Clinician', id: string, pms_id?: string | null, name: string } | null, service?: { __typename?: 'Service', id: string, name?: string | null } | null, product?: { __typename?: 'Product', id: string, name: string } | null, values: Array<{ __typename?: 'ReportValue', metric: ReportMetricType, key: string, column_values: Array<{ __typename?: 'ReportColumnValue', value?: number | null, percentile?: number | null, value_params: { __typename?: 'MetricValueParams', custom_label?: string | null, value_type: MetricValueType } }> }> }> };

export type InitiativeFieldsFragment = { __typename?: 'Initiative', id: string, name: string, description?: string | null, start_time: number, is_archived: boolean, created_at: number, updated_at: number, initiative_metrics: Array<{ __typename?: 'InitiativeMetric', id: string, order?: number | null, initiative: { __typename?: 'Initiative', id: string, name: string, description?: string | null, start_time: number, is_archived: boolean }, report_metric: { __typename?: 'ReportMetric', id: string, key: string, type: ReportMetricType, name: string, description?: string | null, definition_override?: string | null, custom_query?: any | null, special_modifier?: SpecialMetricModifierType | null, inverse_percentile?: boolean | null, format?: MetricFormat | null, time_field_override?: string | null, aggregate_field_override?: string | null, order: number, is_archived: boolean, time_params_overrides?: { __typename?: 'TimeParams', type: TimeParamType, from_millis_ago?: any | null, to_millis_ago?: any | null, period_type?: PeriodType | null, from_periods_ago?: number | null, to_periods_ago?: number | null, start?: number | null, end?: number | null } | null, field_modifiers: Array<{ __typename?: 'ReportMetricModifier', category: MetricModifierCategory, column: string, not?: boolean | null, filterOp: FilterOp, value: { __typename?: 'MetricModifierValue', string?: string | null, stringArray?: Array<string> | null, float?: number | null, boolean?: boolean | null } }>, value_types: Array<{ __typename?: 'MetricValueParams', custom_label?: string | null, value_type: MetricValueType }>, report_template_metrics: Array<{ __typename?: 'ReportTemplateMetric', id: string, report_template: { __typename?: 'ReportTemplate', id: string, name: string, description?: string | null, is_active: boolean } }>, initiative_metrics: Array<{ __typename?: 'InitiativeMetric', id: string, initiative: { __typename?: 'Initiative', id: string, name: string, description?: string | null, start_time: number, is_archived: boolean } }>, kpi_group_metrics: Array<{ __typename?: 'KpiGroupMetric', id: string, kpi_group: { __typename?: 'KpiGroup', id: string, name: string, description?: string | null } }> } }> };

export type InitiativePreviewFieldsFragment = { __typename?: 'Initiative', id: string, name: string, description?: string | null, start_time: number, is_archived: boolean };

export type InitiativeMetricFieldsFragment = { __typename?: 'InitiativeMetric', id: string, order?: number | null, initiative: { __typename?: 'Initiative', id: string, name: string, description?: string | null, start_time: number, is_archived: boolean }, report_metric: { __typename?: 'ReportMetric', id: string, key: string, type: ReportMetricType, name: string, description?: string | null, definition_override?: string | null, custom_query?: any | null, special_modifier?: SpecialMetricModifierType | null, inverse_percentile?: boolean | null, format?: MetricFormat | null, time_field_override?: string | null, aggregate_field_override?: string | null, order: number, is_archived: boolean, time_params_overrides?: { __typename?: 'TimeParams', type: TimeParamType, from_millis_ago?: any | null, to_millis_ago?: any | null, period_type?: PeriodType | null, from_periods_ago?: number | null, to_periods_ago?: number | null, start?: number | null, end?: number | null } | null, field_modifiers: Array<{ __typename?: 'ReportMetricModifier', category: MetricModifierCategory, column: string, not?: boolean | null, filterOp: FilterOp, value: { __typename?: 'MetricModifierValue', string?: string | null, stringArray?: Array<string> | null, float?: number | null, boolean?: boolean | null } }>, value_types: Array<{ __typename?: 'MetricValueParams', custom_label?: string | null, value_type: MetricValueType }>, report_template_metrics: Array<{ __typename?: 'ReportTemplateMetric', id: string, report_template: { __typename?: 'ReportTemplate', id: string, name: string, description?: string | null, is_active: boolean } }>, initiative_metrics: Array<{ __typename?: 'InitiativeMetric', id: string, initiative: { __typename?: 'Initiative', id: string, name: string, description?: string | null, start_time: number, is_archived: boolean } }>, kpi_group_metrics: Array<{ __typename?: 'KpiGroupMetric', id: string, kpi_group: { __typename?: 'KpiGroup', id: string, name: string, description?: string | null } }> } };

export type InitiativeResultFieldsFragment = { __typename?: 'InitiativeResult', scope: TrendReportScope, initiative_metric_results: Array<{ __typename?: 'InitiativeMetricResult', metric: { __typename?: 'InitiativeMetric', id: string, order?: number | null, report_metric: { __typename?: 'ReportMetric', custom_query?: any | null, id: string, name: string, type: ReportMetricType, inverse_percentile?: boolean | null, format?: MetricFormat | null } }, initiative_metric_segments: Array<{ __typename?: 'InitiativeMetricSegment', values: Array<any>, time_range: { __typename?: 'TrendTimeRange', label: string, start_time: number, end_time: number } }> }> };

export type InitiativeMetricResultFieldsFragment = { __typename?: 'InitiativeMetricResult', metric: { __typename?: 'InitiativeMetric', id: string, order?: number | null, report_metric: { __typename?: 'ReportMetric', custom_query?: any | null, id: string, name: string, type: ReportMetricType, inverse_percentile?: boolean | null, format?: MetricFormat | null } }, initiative_metric_segments: Array<{ __typename?: 'InitiativeMetricSegment', values: Array<any>, time_range: { __typename?: 'TrendTimeRange', label: string, start_time: number, end_time: number } }> };

export type InitiativeMetricSegmentFieldsFragment = { __typename?: 'InitiativeMetricSegment', values: Array<any>, time_range: { __typename?: 'TrendTimeRange', label: string, start_time: number, end_time: number } };

export type QueryInitiativesQueryVariables = Exact<{
  where?: InputMaybe<Array<QueryInput> | QueryInput>;
  page?: InputMaybe<Scalars['NonNegativeInt']['input']>;
  pageSize?: InputMaybe<Scalars['NonNegativeInt']['input']>;
  orderBy?: InputMaybe<OrderByInput>;
}>;


export type QueryInitiativesQuery = { __typename?: 'Query', queryInitiatives: Array<{ __typename?: 'Initiative', id: string, name: string, description?: string | null, start_time: number, is_archived: boolean, created_at: number, updated_at: number, initiative_metrics: Array<{ __typename?: 'InitiativeMetric', id: string, order?: number | null, initiative: { __typename?: 'Initiative', id: string, name: string, description?: string | null, start_time: number, is_archived: boolean }, report_metric: { __typename?: 'ReportMetric', id: string, key: string, type: ReportMetricType, name: string, description?: string | null, definition_override?: string | null, custom_query?: any | null, special_modifier?: SpecialMetricModifierType | null, inverse_percentile?: boolean | null, format?: MetricFormat | null, time_field_override?: string | null, aggregate_field_override?: string | null, order: number, is_archived: boolean, time_params_overrides?: { __typename?: 'TimeParams', type: TimeParamType, from_millis_ago?: any | null, to_millis_ago?: any | null, period_type?: PeriodType | null, from_periods_ago?: number | null, to_periods_ago?: number | null, start?: number | null, end?: number | null } | null, field_modifiers: Array<{ __typename?: 'ReportMetricModifier', category: MetricModifierCategory, column: string, not?: boolean | null, filterOp: FilterOp, value: { __typename?: 'MetricModifierValue', string?: string | null, stringArray?: Array<string> | null, float?: number | null, boolean?: boolean | null } }>, value_types: Array<{ __typename?: 'MetricValueParams', custom_label?: string | null, value_type: MetricValueType }>, report_template_metrics: Array<{ __typename?: 'ReportTemplateMetric', id: string, report_template: { __typename?: 'ReportTemplate', id: string, name: string, description?: string | null, is_active: boolean } }>, initiative_metrics: Array<{ __typename?: 'InitiativeMetric', id: string, initiative: { __typename?: 'Initiative', id: string, name: string, description?: string | null, start_time: number, is_archived: boolean } }>, kpi_group_metrics: Array<{ __typename?: 'KpiGroupMetric', id: string, kpi_group: { __typename?: 'KpiGroup', id: string, name: string, description?: string | null } }> } }> }> };

export type CreateInitiativeMutationVariables = Exact<{
  data: CreateInitiativeInput;
}>;


export type CreateInitiativeMutation = { __typename?: 'Mutation', createInitiative: { __typename?: 'Initiative', id: string, name: string, description?: string | null, start_time: number, is_archived: boolean, created_at: number, updated_at: number, initiative_metrics: Array<{ __typename?: 'InitiativeMetric', id: string, order?: number | null, initiative: { __typename?: 'Initiative', id: string, name: string, description?: string | null, start_time: number, is_archived: boolean }, report_metric: { __typename?: 'ReportMetric', id: string, key: string, type: ReportMetricType, name: string, description?: string | null, definition_override?: string | null, custom_query?: any | null, special_modifier?: SpecialMetricModifierType | null, inverse_percentile?: boolean | null, format?: MetricFormat | null, time_field_override?: string | null, aggregate_field_override?: string | null, order: number, is_archived: boolean, time_params_overrides?: { __typename?: 'TimeParams', type: TimeParamType, from_millis_ago?: any | null, to_millis_ago?: any | null, period_type?: PeriodType | null, from_periods_ago?: number | null, to_periods_ago?: number | null, start?: number | null, end?: number | null } | null, field_modifiers: Array<{ __typename?: 'ReportMetricModifier', category: MetricModifierCategory, column: string, not?: boolean | null, filterOp: FilterOp, value: { __typename?: 'MetricModifierValue', string?: string | null, stringArray?: Array<string> | null, float?: number | null, boolean?: boolean | null } }>, value_types: Array<{ __typename?: 'MetricValueParams', custom_label?: string | null, value_type: MetricValueType }>, report_template_metrics: Array<{ __typename?: 'ReportTemplateMetric', id: string, report_template: { __typename?: 'ReportTemplate', id: string, name: string, description?: string | null, is_active: boolean } }>, initiative_metrics: Array<{ __typename?: 'InitiativeMetric', id: string, initiative: { __typename?: 'Initiative', id: string, name: string, description?: string | null, start_time: number, is_archived: boolean } }>, kpi_group_metrics: Array<{ __typename?: 'KpiGroupMetric', id: string, kpi_group: { __typename?: 'KpiGroup', id: string, name: string, description?: string | null } }> } }> } };

export type UpdateInitiativeMutationVariables = Exact<{
  id: Scalars['ID']['input'];
  data: UpdateInitiativeInput;
}>;


export type UpdateInitiativeMutation = { __typename?: 'Mutation', updateInitiative: { __typename?: 'Initiative', id: string, name: string, description?: string | null, start_time: number, is_archived: boolean, created_at: number, updated_at: number, initiative_metrics: Array<{ __typename?: 'InitiativeMetric', id: string, order?: number | null, initiative: { __typename?: 'Initiative', id: string, name: string, description?: string | null, start_time: number, is_archived: boolean }, report_metric: { __typename?: 'ReportMetric', id: string, key: string, type: ReportMetricType, name: string, description?: string | null, definition_override?: string | null, custom_query?: any | null, special_modifier?: SpecialMetricModifierType | null, inverse_percentile?: boolean | null, format?: MetricFormat | null, time_field_override?: string | null, aggregate_field_override?: string | null, order: number, is_archived: boolean, time_params_overrides?: { __typename?: 'TimeParams', type: TimeParamType, from_millis_ago?: any | null, to_millis_ago?: any | null, period_type?: PeriodType | null, from_periods_ago?: number | null, to_periods_ago?: number | null, start?: number | null, end?: number | null } | null, field_modifiers: Array<{ __typename?: 'ReportMetricModifier', category: MetricModifierCategory, column: string, not?: boolean | null, filterOp: FilterOp, value: { __typename?: 'MetricModifierValue', string?: string | null, stringArray?: Array<string> | null, float?: number | null, boolean?: boolean | null } }>, value_types: Array<{ __typename?: 'MetricValueParams', custom_label?: string | null, value_type: MetricValueType }>, report_template_metrics: Array<{ __typename?: 'ReportTemplateMetric', id: string, report_template: { __typename?: 'ReportTemplate', id: string, name: string, description?: string | null, is_active: boolean } }>, initiative_metrics: Array<{ __typename?: 'InitiativeMetric', id: string, initiative: { __typename?: 'Initiative', id: string, name: string, description?: string | null, start_time: number, is_archived: boolean } }>, kpi_group_metrics: Array<{ __typename?: 'KpiGroupMetric', id: string, kpi_group: { __typename?: 'KpiGroup', id: string, name: string, description?: string | null } }> } }> } };

export type GetInitiativeQueryVariables = Exact<{
  id: Scalars['ID']['input'];
}>;


export type GetInitiativeQuery = { __typename?: 'Query', initiative: { __typename?: 'Initiative', id: string, name: string, description?: string | null, start_time: number, is_archived: boolean, created_at: number, updated_at: number, initiative_metrics: Array<{ __typename?: 'InitiativeMetric', id: string, order?: number | null, initiative: { __typename?: 'Initiative', id: string, name: string, description?: string | null, start_time: number, is_archived: boolean }, report_metric: { __typename?: 'ReportMetric', id: string, key: string, type: ReportMetricType, name: string, description?: string | null, definition_override?: string | null, custom_query?: any | null, special_modifier?: SpecialMetricModifierType | null, inverse_percentile?: boolean | null, format?: MetricFormat | null, time_field_override?: string | null, aggregate_field_override?: string | null, order: number, is_archived: boolean, time_params_overrides?: { __typename?: 'TimeParams', type: TimeParamType, from_millis_ago?: any | null, to_millis_ago?: any | null, period_type?: PeriodType | null, from_periods_ago?: number | null, to_periods_ago?: number | null, start?: number | null, end?: number | null } | null, field_modifiers: Array<{ __typename?: 'ReportMetricModifier', category: MetricModifierCategory, column: string, not?: boolean | null, filterOp: FilterOp, value: { __typename?: 'MetricModifierValue', string?: string | null, stringArray?: Array<string> | null, float?: number | null, boolean?: boolean | null } }>, value_types: Array<{ __typename?: 'MetricValueParams', custom_label?: string | null, value_type: MetricValueType }>, report_template_metrics: Array<{ __typename?: 'ReportTemplateMetric', id: string, report_template: { __typename?: 'ReportTemplate', id: string, name: string, description?: string | null, is_active: boolean } }>, initiative_metrics: Array<{ __typename?: 'InitiativeMetric', id: string, initiative: { __typename?: 'Initiative', id: string, name: string, description?: string | null, start_time: number, is_archived: boolean } }>, kpi_group_metrics: Array<{ __typename?: 'KpiGroupMetric', id: string, kpi_group: { __typename?: 'KpiGroup', id: string, name: string, description?: string | null } }> } }> } };

export type ComputeInitiativeValuesQueryVariables = Exact<{
  id: Scalars['ID']['input'];
  params: ComputeInitiativeValuesParams;
}>;


export type ComputeInitiativeValuesQuery = { __typename?: 'Query', computeInitiativeValues: { __typename?: 'InitiativeResult', scope: TrendReportScope, initiative_metric_results: Array<{ __typename?: 'InitiativeMetricResult', metric: { __typename?: 'InitiativeMetric', id: string, order?: number | null, report_metric: { __typename?: 'ReportMetric', custom_query?: any | null, id: string, name: string, type: ReportMetricType, inverse_percentile?: boolean | null, format?: MetricFormat | null } }, initiative_metric_segments: Array<{ __typename?: 'InitiativeMetricSegment', values: Array<any>, time_range: { __typename?: 'TrendTimeRange', label: string, start_time: number, end_time: number } }> }> } };

export type KpiGroupPreviewFieldsFragment = { __typename?: 'KpiGroup', id: string, name: string, description?: string | null };

export type KpiGroupFieldsFragment = { __typename?: 'KpiGroup', id: string, name: string, description?: string | null, created_at: number, updated_at: number, kpi_group_metrics: Array<{ __typename?: 'KpiGroupMetric', id: string, goal?: number | null, order?: number | null, kpi_group: { __typename?: 'KpiGroup', id: string, name: string, description?: string | null }, report_metric: { __typename?: 'ReportMetric', id: string, key: string, type: ReportMetricType, name: string, description?: string | null, definition_override?: string | null, custom_query?: any | null, special_modifier?: SpecialMetricModifierType | null, inverse_percentile?: boolean | null, format?: MetricFormat | null, time_field_override?: string | null, aggregate_field_override?: string | null, order: number, is_archived: boolean, time_params_overrides?: { __typename?: 'TimeParams', type: TimeParamType, from_millis_ago?: any | null, to_millis_ago?: any | null, period_type?: PeriodType | null, from_periods_ago?: number | null, to_periods_ago?: number | null, start?: number | null, end?: number | null } | null, field_modifiers: Array<{ __typename?: 'ReportMetricModifier', category: MetricModifierCategory, column: string, not?: boolean | null, filterOp: FilterOp, value: { __typename?: 'MetricModifierValue', string?: string | null, stringArray?: Array<string> | null, float?: number | null, boolean?: boolean | null } }>, value_types: Array<{ __typename?: 'MetricValueParams', custom_label?: string | null, value_type: MetricValueType }>, report_template_metrics: Array<{ __typename?: 'ReportTemplateMetric', id: string, report_template: { __typename?: 'ReportTemplate', id: string, name: string, description?: string | null, is_active: boolean } }>, initiative_metrics: Array<{ __typename?: 'InitiativeMetric', id: string, initiative: { __typename?: 'Initiative', id: string, name: string, description?: string | null, start_time: number, is_archived: boolean } }>, kpi_group_metrics: Array<{ __typename?: 'KpiGroupMetric', id: string, kpi_group: { __typename?: 'KpiGroup', id: string, name: string, description?: string | null } }> } }> };

export type KpiGroupMetricFieldsFragment = { __typename?: 'KpiGroupMetric', id: string, goal?: number | null, order?: number | null, kpi_group: { __typename?: 'KpiGroup', id: string, name: string, description?: string | null }, report_metric: { __typename?: 'ReportMetric', id: string, key: string, type: ReportMetricType, name: string, description?: string | null, definition_override?: string | null, custom_query?: any | null, special_modifier?: SpecialMetricModifierType | null, inverse_percentile?: boolean | null, format?: MetricFormat | null, time_field_override?: string | null, aggregate_field_override?: string | null, order: number, is_archived: boolean, time_params_overrides?: { __typename?: 'TimeParams', type: TimeParamType, from_millis_ago?: any | null, to_millis_ago?: any | null, period_type?: PeriodType | null, from_periods_ago?: number | null, to_periods_ago?: number | null, start?: number | null, end?: number | null } | null, field_modifiers: Array<{ __typename?: 'ReportMetricModifier', category: MetricModifierCategory, column: string, not?: boolean | null, filterOp: FilterOp, value: { __typename?: 'MetricModifierValue', string?: string | null, stringArray?: Array<string> | null, float?: number | null, boolean?: boolean | null } }>, value_types: Array<{ __typename?: 'MetricValueParams', custom_label?: string | null, value_type: MetricValueType }>, report_template_metrics: Array<{ __typename?: 'ReportTemplateMetric', id: string, report_template: { __typename?: 'ReportTemplate', id: string, name: string, description?: string | null, is_active: boolean } }>, initiative_metrics: Array<{ __typename?: 'InitiativeMetric', id: string, initiative: { __typename?: 'Initiative', id: string, name: string, description?: string | null, start_time: number, is_archived: boolean } }>, kpi_group_metrics: Array<{ __typename?: 'KpiGroupMetric', id: string, kpi_group: { __typename?: 'KpiGroup', id: string, name: string, description?: string | null } }> } };

export type KpiGroupResultValueFieldsFragment = { __typename?: 'KpiGroupResultValue', current_value: number };

export type KpiGroupResultFieldsFragment = { __typename?: 'KpiGroupResult', metric: { __typename?: 'KpiGroupMetric', id: string, goal?: number | null, order?: number | null, report_metric: { __typename?: 'ReportMetric', custom_query?: any | null, id: string, name: string, type: ReportMetricType, inverse_percentile?: boolean | null, format?: MetricFormat | null } }, value: { __typename?: 'KpiGroupResultValue', current_value: number } };

export type KpiGroupMetricResultFieldsFragment = { __typename?: 'KpiGroupMetricResult', clinic: { __typename?: 'Clinic', id: string, name?: string | null }, value: { __typename?: 'KpiGroupResultValue', current_value: number } };

export type GetKpiGroupQueryVariables = Exact<{
  id: Scalars['ID']['input'];
}>;


export type GetKpiGroupQuery = { __typename?: 'Query', kpiGroup: { __typename?: 'KpiGroup', id: string, name: string, description?: string | null, created_at: number, updated_at: number, kpi_group_metrics: Array<{ __typename?: 'KpiGroupMetric', id: string, goal?: number | null, order?: number | null, kpi_group: { __typename?: 'KpiGroup', id: string, name: string, description?: string | null }, report_metric: { __typename?: 'ReportMetric', id: string, key: string, type: ReportMetricType, name: string, description?: string | null, definition_override?: string | null, custom_query?: any | null, special_modifier?: SpecialMetricModifierType | null, inverse_percentile?: boolean | null, format?: MetricFormat | null, time_field_override?: string | null, aggregate_field_override?: string | null, order: number, is_archived: boolean, time_params_overrides?: { __typename?: 'TimeParams', type: TimeParamType, from_millis_ago?: any | null, to_millis_ago?: any | null, period_type?: PeriodType | null, from_periods_ago?: number | null, to_periods_ago?: number | null, start?: number | null, end?: number | null } | null, field_modifiers: Array<{ __typename?: 'ReportMetricModifier', category: MetricModifierCategory, column: string, not?: boolean | null, filterOp: FilterOp, value: { __typename?: 'MetricModifierValue', string?: string | null, stringArray?: Array<string> | null, float?: number | null, boolean?: boolean | null } }>, value_types: Array<{ __typename?: 'MetricValueParams', custom_label?: string | null, value_type: MetricValueType }>, report_template_metrics: Array<{ __typename?: 'ReportTemplateMetric', id: string, report_template: { __typename?: 'ReportTemplate', id: string, name: string, description?: string | null, is_active: boolean } }>, initiative_metrics: Array<{ __typename?: 'InitiativeMetric', id: string, initiative: { __typename?: 'Initiative', id: string, name: string, description?: string | null, start_time: number, is_archived: boolean } }>, kpi_group_metrics: Array<{ __typename?: 'KpiGroupMetric', id: string, kpi_group: { __typename?: 'KpiGroup', id: string, name: string, description?: string | null } }> } }> } };

export type QueryKpiGroupsQueryVariables = Exact<{
  where?: InputMaybe<Array<QueryInput> | QueryInput>;
  page?: InputMaybe<Scalars['NonNegativeInt']['input']>;
  pageSize?: InputMaybe<Scalars['NonNegativeInt']['input']>;
  orderBy?: InputMaybe<OrderByInput>;
}>;


export type QueryKpiGroupsQuery = { __typename?: 'Query', queryKpiGroups: Array<{ __typename?: 'KpiGroup', id: string, name: string, description?: string | null, created_at: number, updated_at: number, kpi_group_metrics: Array<{ __typename?: 'KpiGroupMetric', id: string, goal?: number | null, order?: number | null, kpi_group: { __typename?: 'KpiGroup', id: string, name: string, description?: string | null }, report_metric: { __typename?: 'ReportMetric', id: string, key: string, type: ReportMetricType, name: string, description?: string | null, definition_override?: string | null, custom_query?: any | null, special_modifier?: SpecialMetricModifierType | null, inverse_percentile?: boolean | null, format?: MetricFormat | null, time_field_override?: string | null, aggregate_field_override?: string | null, order: number, is_archived: boolean, time_params_overrides?: { __typename?: 'TimeParams', type: TimeParamType, from_millis_ago?: any | null, to_millis_ago?: any | null, period_type?: PeriodType | null, from_periods_ago?: number | null, to_periods_ago?: number | null, start?: number | null, end?: number | null } | null, field_modifiers: Array<{ __typename?: 'ReportMetricModifier', category: MetricModifierCategory, column: string, not?: boolean | null, filterOp: FilterOp, value: { __typename?: 'MetricModifierValue', string?: string | null, stringArray?: Array<string> | null, float?: number | null, boolean?: boolean | null } }>, value_types: Array<{ __typename?: 'MetricValueParams', custom_label?: string | null, value_type: MetricValueType }>, report_template_metrics: Array<{ __typename?: 'ReportTemplateMetric', id: string, report_template: { __typename?: 'ReportTemplate', id: string, name: string, description?: string | null, is_active: boolean } }>, initiative_metrics: Array<{ __typename?: 'InitiativeMetric', id: string, initiative: { __typename?: 'Initiative', id: string, name: string, description?: string | null, start_time: number, is_archived: boolean } }>, kpi_group_metrics: Array<{ __typename?: 'KpiGroupMetric', id: string, kpi_group: { __typename?: 'KpiGroup', id: string, name: string, description?: string | null } }> } }> }> };

export type CountKpiGroupsQueryVariables = Exact<{
  where?: InputMaybe<Array<QueryInput> | QueryInput>;
}>;


export type CountKpiGroupsQuery = { __typename?: 'Query', countKpiGroups: number };

export type CreateKpiGroupMutationVariables = Exact<{
  data: CreateKpiGroupInput;
}>;


export type CreateKpiGroupMutation = { __typename?: 'Mutation', createKpiGroup: { __typename?: 'KpiGroup', id: string, name: string, description?: string | null, created_at: number, updated_at: number, kpi_group_metrics: Array<{ __typename?: 'KpiGroupMetric', id: string, goal?: number | null, order?: number | null, kpi_group: { __typename?: 'KpiGroup', id: string, name: string, description?: string | null }, report_metric: { __typename?: 'ReportMetric', id: string, key: string, type: ReportMetricType, name: string, description?: string | null, definition_override?: string | null, custom_query?: any | null, special_modifier?: SpecialMetricModifierType | null, inverse_percentile?: boolean | null, format?: MetricFormat | null, time_field_override?: string | null, aggregate_field_override?: string | null, order: number, is_archived: boolean, time_params_overrides?: { __typename?: 'TimeParams', type: TimeParamType, from_millis_ago?: any | null, to_millis_ago?: any | null, period_type?: PeriodType | null, from_periods_ago?: number | null, to_periods_ago?: number | null, start?: number | null, end?: number | null } | null, field_modifiers: Array<{ __typename?: 'ReportMetricModifier', category: MetricModifierCategory, column: string, not?: boolean | null, filterOp: FilterOp, value: { __typename?: 'MetricModifierValue', string?: string | null, stringArray?: Array<string> | null, float?: number | null, boolean?: boolean | null } }>, value_types: Array<{ __typename?: 'MetricValueParams', custom_label?: string | null, value_type: MetricValueType }>, report_template_metrics: Array<{ __typename?: 'ReportTemplateMetric', id: string, report_template: { __typename?: 'ReportTemplate', id: string, name: string, description?: string | null, is_active: boolean } }>, initiative_metrics: Array<{ __typename?: 'InitiativeMetric', id: string, initiative: { __typename?: 'Initiative', id: string, name: string, description?: string | null, start_time: number, is_archived: boolean } }>, kpi_group_metrics: Array<{ __typename?: 'KpiGroupMetric', id: string, kpi_group: { __typename?: 'KpiGroup', id: string, name: string, description?: string | null } }> } }> } };

export type UpdateKpiGroupMutationVariables = Exact<{
  id: Scalars['ID']['input'];
  data: UpdateKpiGroupInput;
}>;


export type UpdateKpiGroupMutation = { __typename?: 'Mutation', updateKpiGroup: { __typename?: 'KpiGroup', id: string, name: string, description?: string | null, created_at: number, updated_at: number, kpi_group_metrics: Array<{ __typename?: 'KpiGroupMetric', id: string, goal?: number | null, order?: number | null, kpi_group: { __typename?: 'KpiGroup', id: string, name: string, description?: string | null }, report_metric: { __typename?: 'ReportMetric', id: string, key: string, type: ReportMetricType, name: string, description?: string | null, definition_override?: string | null, custom_query?: any | null, special_modifier?: SpecialMetricModifierType | null, inverse_percentile?: boolean | null, format?: MetricFormat | null, time_field_override?: string | null, aggregate_field_override?: string | null, order: number, is_archived: boolean, time_params_overrides?: { __typename?: 'TimeParams', type: TimeParamType, from_millis_ago?: any | null, to_millis_ago?: any | null, period_type?: PeriodType | null, from_periods_ago?: number | null, to_periods_ago?: number | null, start?: number | null, end?: number | null } | null, field_modifiers: Array<{ __typename?: 'ReportMetricModifier', category: MetricModifierCategory, column: string, not?: boolean | null, filterOp: FilterOp, value: { __typename?: 'MetricModifierValue', string?: string | null, stringArray?: Array<string> | null, float?: number | null, boolean?: boolean | null } }>, value_types: Array<{ __typename?: 'MetricValueParams', custom_label?: string | null, value_type: MetricValueType }>, report_template_metrics: Array<{ __typename?: 'ReportTemplateMetric', id: string, report_template: { __typename?: 'ReportTemplate', id: string, name: string, description?: string | null, is_active: boolean } }>, initiative_metrics: Array<{ __typename?: 'InitiativeMetric', id: string, initiative: { __typename?: 'Initiative', id: string, name: string, description?: string | null, start_time: number, is_archived: boolean } }>, kpi_group_metrics: Array<{ __typename?: 'KpiGroupMetric', id: string, kpi_group: { __typename?: 'KpiGroup', id: string, name: string, description?: string | null } }> } }> } };

export type UpdateKpiGroupMetricMutationVariables = Exact<{
  id: Scalars['ID']['input'];
  data: UpdateKpiGroupMetricInput;
}>;


export type UpdateKpiGroupMetricMutation = { __typename?: 'Mutation', updateKpiGroupMetric: { __typename?: 'KpiGroupMetric', id: string, goal?: number | null, order?: number | null, kpi_group: { __typename?: 'KpiGroup', id: string, name: string, description?: string | null }, report_metric: { __typename?: 'ReportMetric', id: string, key: string, type: ReportMetricType, name: string, description?: string | null, definition_override?: string | null, custom_query?: any | null, special_modifier?: SpecialMetricModifierType | null, inverse_percentile?: boolean | null, format?: MetricFormat | null, time_field_override?: string | null, aggregate_field_override?: string | null, order: number, is_archived: boolean, time_params_overrides?: { __typename?: 'TimeParams', type: TimeParamType, from_millis_ago?: any | null, to_millis_ago?: any | null, period_type?: PeriodType | null, from_periods_ago?: number | null, to_periods_ago?: number | null, start?: number | null, end?: number | null } | null, field_modifiers: Array<{ __typename?: 'ReportMetricModifier', category: MetricModifierCategory, column: string, not?: boolean | null, filterOp: FilterOp, value: { __typename?: 'MetricModifierValue', string?: string | null, stringArray?: Array<string> | null, float?: number | null, boolean?: boolean | null } }>, value_types: Array<{ __typename?: 'MetricValueParams', custom_label?: string | null, value_type: MetricValueType }>, report_template_metrics: Array<{ __typename?: 'ReportTemplateMetric', id: string, report_template: { __typename?: 'ReportTemplate', id: string, name: string, description?: string | null, is_active: boolean } }>, initiative_metrics: Array<{ __typename?: 'InitiativeMetric', id: string, initiative: { __typename?: 'Initiative', id: string, name: string, description?: string | null, start_time: number, is_archived: boolean } }>, kpi_group_metrics: Array<{ __typename?: 'KpiGroupMetric', id: string, kpi_group: { __typename?: 'KpiGroup', id: string, name: string, description?: string | null } }> } } };

export type ComputeKpiGroupValuesQueryVariables = Exact<{
  id: Scalars['ID']['input'];
  options?: InputMaybe<ComputeKpiGroupValuesOptions>;
}>;


export type ComputeKpiGroupValuesQuery = { __typename?: 'Query', computeKpiGroupValues: Array<{ __typename?: 'KpiGroupResult', metric: { __typename?: 'KpiGroupMetric', id: string, goal?: number | null, order?: number | null, report_metric: { __typename?: 'ReportMetric', custom_query?: any | null, id: string, name: string, type: ReportMetricType, inverse_percentile?: boolean | null, format?: MetricFormat | null } }, value: { __typename?: 'KpiGroupResultValue', current_value: number } }> };

export type CalculateClinicValuesForKpiGroupMetricQueryVariables = Exact<{
  id: Scalars['ID']['input'];
  options?: InputMaybe<ComputeKpiGroupValuesOptions>;
}>;


export type CalculateClinicValuesForKpiGroupMetricQuery = { __typename?: 'Query', calculateClinicValuesForKpiGroupMetric: Array<{ __typename?: 'KpiGroupMetricResult', clinic: { __typename?: 'Clinic', id: string, name?: string | null }, value: { __typename?: 'KpiGroupResultValue', current_value: number } }> };

export type OrganizationReportFieldsFragment = { __typename?: 'OrganizationReport', id: string, name: string, description?: string | null, preferred_view_type: ReportViewType, is_hidden: boolean, created_at: number, updated_at: number, organization?: { __typename?: 'Organization', id: string, name: string } | null, report_clinics: Array<{ __typename?: 'ReportClinic', id: string, clinic: { __typename?: 'Clinic', id: string, name?: string | null, slug?: string | null, address?: { __typename?: 'Address', street_a?: string | null, street_b?: string | null, city?: string | null, state?: string | null, zip?: string | null, country?: string | null } | null } }>, report_metrics: Array<{ __typename?: 'ReportMetric', id: string, key: string, type: ReportMetricType, name: string, description?: string | null, definition_override?: string | null, custom_query?: any | null, special_modifier?: SpecialMetricModifierType | null, inverse_percentile?: boolean | null, format?: MetricFormat | null, time_field_override?: string | null, aggregate_field_override?: string | null, order: number, is_archived: boolean, time_params_overrides?: { __typename?: 'TimeParams', type: TimeParamType, from_millis_ago?: any | null, to_millis_ago?: any | null, period_type?: PeriodType | null, from_periods_ago?: number | null, to_periods_ago?: number | null, start?: number | null, end?: number | null } | null, field_modifiers: Array<{ __typename?: 'ReportMetricModifier', category: MetricModifierCategory, column: string, not?: boolean | null, filterOp: FilterOp, value: { __typename?: 'MetricModifierValue', string?: string | null, stringArray?: Array<string> | null, float?: number | null, boolean?: boolean | null } }>, value_types: Array<{ __typename?: 'MetricValueParams', custom_label?: string | null, value_type: MetricValueType }>, report_template_metrics: Array<{ __typename?: 'ReportTemplateMetric', id: string, report_template: { __typename?: 'ReportTemplate', id: string, name: string, description?: string | null, is_active: boolean } }>, initiative_metrics: Array<{ __typename?: 'InitiativeMetric', id: string, initiative: { __typename?: 'Initiative', id: string, name: string, description?: string | null, start_time: number, is_archived: boolean } }>, kpi_group_metrics: Array<{ __typename?: 'KpiGroupMetric', id: string, kpi_group: { __typename?: 'KpiGroup', id: string, name: string, description?: string | null } }> }>, entity_structure: Array<{ __typename?: 'ReportEntity', entity_type: ReportEntityType, child_entities?: Array<{ __typename?: 'ReportEntity', entity_type: ReportEntityType, child_entities?: Array<{ __typename?: 'ReportEntity', entity_type: ReportEntityType, child_entities?: Array<{ __typename?: 'ReportEntity', entity_type: ReportEntityType }> | null }> | null }> | null }>, entity_reports: Array<{ __typename?: 'EntityReport', id: string, entity_type: ReportEntityType, entity_reports: Array<{ __typename?: 'EntityReport', id: string, entity_type: ReportEntityType, entity_reports: Array<{ __typename?: 'EntityReport', id: string, entity_type: ReportEntityType, clinic?: { __typename?: 'Clinic', id: string, name?: string | null, time_zone?: string | null, slug?: string | null, address?: { __typename?: 'Address', street_a?: string | null, street_b?: string | null, city?: string | null, state?: string | null, zip?: string | null, country?: string | null } | null, hours?: { __typename?: 'AvailabilityHours', monday?: Array<{ __typename?: 'TimeInterval', start?: number | null, end?: number | null }> | null, tuesday?: Array<{ __typename?: 'TimeInterval', start?: number | null, end?: number | null }> | null, wednesday?: Array<{ __typename?: 'TimeInterval', start?: number | null, end?: number | null }> | null, thursday?: Array<{ __typename?: 'TimeInterval', start?: number | null, end?: number | null }> | null, friday?: Array<{ __typename?: 'TimeInterval', start?: number | null, end?: number | null }> | null, saturday?: Array<{ __typename?: 'TimeInterval', start?: number | null, end?: number | null }> | null, sunday?: Array<{ __typename?: 'TimeInterval', start?: number | null, end?: number | null }> | null } | null } | null, clinician?: { __typename?: 'Clinician', id: string, pms_id?: string | null, name: string } | null, service?: { __typename?: 'Service', id: string, name?: string | null } | null, product?: { __typename?: 'Product', id: string, name: string } | null, values: Array<{ __typename?: 'ReportValue', metric: ReportMetricType, key: string, column_values: Array<{ __typename?: 'ReportColumnValue', value?: number | null, percentile?: number | null, value_params: { __typename?: 'MetricValueParams', custom_label?: string | null, value_type: MetricValueType } }> }> }>, clinic?: { __typename?: 'Clinic', id: string, name?: string | null, time_zone?: string | null, slug?: string | null, address?: { __typename?: 'Address', street_a?: string | null, street_b?: string | null, city?: string | null, state?: string | null, zip?: string | null, country?: string | null } | null, hours?: { __typename?: 'AvailabilityHours', monday?: Array<{ __typename?: 'TimeInterval', start?: number | null, end?: number | null }> | null, tuesday?: Array<{ __typename?: 'TimeInterval', start?: number | null, end?: number | null }> | null, wednesday?: Array<{ __typename?: 'TimeInterval', start?: number | null, end?: number | null }> | null, thursday?: Array<{ __typename?: 'TimeInterval', start?: number | null, end?: number | null }> | null, friday?: Array<{ __typename?: 'TimeInterval', start?: number | null, end?: number | null }> | null, saturday?: Array<{ __typename?: 'TimeInterval', start?: number | null, end?: number | null }> | null, sunday?: Array<{ __typename?: 'TimeInterval', start?: number | null, end?: number | null }> | null } | null } | null, clinician?: { __typename?: 'Clinician', id: string, pms_id?: string | null, name: string } | null, service?: { __typename?: 'Service', id: string, name?: string | null } | null, product?: { __typename?: 'Product', id: string, name: string } | null, values: Array<{ __typename?: 'ReportValue', metric: ReportMetricType, key: string, column_values: Array<{ __typename?: 'ReportColumnValue', value?: number | null, percentile?: number | null, value_params: { __typename?: 'MetricValueParams', custom_label?: string | null, value_type: MetricValueType } }> }> }>, clinic?: { __typename?: 'Clinic', id: string, name?: string | null, time_zone?: string | null, slug?: string | null, address?: { __typename?: 'Address', street_a?: string | null, street_b?: string | null, city?: string | null, state?: string | null, zip?: string | null, country?: string | null } | null, hours?: { __typename?: 'AvailabilityHours', monday?: Array<{ __typename?: 'TimeInterval', start?: number | null, end?: number | null }> | null, tuesday?: Array<{ __typename?: 'TimeInterval', start?: number | null, end?: number | null }> | null, wednesday?: Array<{ __typename?: 'TimeInterval', start?: number | null, end?: number | null }> | null, thursday?: Array<{ __typename?: 'TimeInterval', start?: number | null, end?: number | null }> | null, friday?: Array<{ __typename?: 'TimeInterval', start?: number | null, end?: number | null }> | null, saturday?: Array<{ __typename?: 'TimeInterval', start?: number | null, end?: number | null }> | null, sunday?: Array<{ __typename?: 'TimeInterval', start?: number | null, end?: number | null }> | null } | null } | null, clinician?: { __typename?: 'Clinician', id: string, pms_id?: string | null, name: string } | null, service?: { __typename?: 'Service', id: string, name?: string | null } | null, product?: { __typename?: 'Product', id: string, name: string } | null, values: Array<{ __typename?: 'ReportValue', metric: ReportMetricType, key: string, column_values: Array<{ __typename?: 'ReportColumnValue', value?: number | null, percentile?: number | null, value_params: { __typename?: 'MetricValueParams', custom_label?: string | null, value_type: MetricValueType } }> }> }>, report_template?: { __typename?: 'ReportTemplate', id: string } | null, time_params: { __typename?: 'TimeParams', type: TimeParamType, from_millis_ago?: any | null, to_millis_ago?: any | null, period_type?: PeriodType | null, from_periods_ago?: number | null, to_periods_ago?: number | null, start?: number | null, end?: number | null } };

export type OrganizationReportPreviewFieldsFragment = { __typename?: 'OrganizationReport', id: string, name: string, description?: string | null, is_hidden: boolean, created_at: number, report_clinics: Array<{ __typename?: 'ReportClinic', id: string, clinic: { __typename?: 'Clinic', name?: string | null } }>, report_metrics: Array<{ __typename?: 'ReportMetric', id: string, name: string, type: ReportMetricType }>, report_template?: { __typename?: 'ReportTemplate', id: string, name: string } | null };

export type GetOrganizationReportQueryVariables = Exact<{
  id: Scalars['ID']['input'];
}>;


export type GetOrganizationReportQuery = { __typename?: 'Query', organizationReport: { __typename?: 'OrganizationReport', id: string, name: string, description?: string | null, preferred_view_type: ReportViewType, is_hidden: boolean, created_at: number, updated_at: number, organization?: { __typename?: 'Organization', id: string, name: string } | null, report_clinics: Array<{ __typename?: 'ReportClinic', id: string, clinic: { __typename?: 'Clinic', id: string, name?: string | null, slug?: string | null, address?: { __typename?: 'Address', street_a?: string | null, street_b?: string | null, city?: string | null, state?: string | null, zip?: string | null, country?: string | null } | null } }>, report_metrics: Array<{ __typename?: 'ReportMetric', id: string, key: string, type: ReportMetricType, name: string, description?: string | null, definition_override?: string | null, custom_query?: any | null, special_modifier?: SpecialMetricModifierType | null, inverse_percentile?: boolean | null, format?: MetricFormat | null, time_field_override?: string | null, aggregate_field_override?: string | null, order: number, is_archived: boolean, time_params_overrides?: { __typename?: 'TimeParams', type: TimeParamType, from_millis_ago?: any | null, to_millis_ago?: any | null, period_type?: PeriodType | null, from_periods_ago?: number | null, to_periods_ago?: number | null, start?: number | null, end?: number | null } | null, field_modifiers: Array<{ __typename?: 'ReportMetricModifier', category: MetricModifierCategory, column: string, not?: boolean | null, filterOp: FilterOp, value: { __typename?: 'MetricModifierValue', string?: string | null, stringArray?: Array<string> | null, float?: number | null, boolean?: boolean | null } }>, value_types: Array<{ __typename?: 'MetricValueParams', custom_label?: string | null, value_type: MetricValueType }>, report_template_metrics: Array<{ __typename?: 'ReportTemplateMetric', id: string, report_template: { __typename?: 'ReportTemplate', id: string, name: string, description?: string | null, is_active: boolean } }>, initiative_metrics: Array<{ __typename?: 'InitiativeMetric', id: string, initiative: { __typename?: 'Initiative', id: string, name: string, description?: string | null, start_time: number, is_archived: boolean } }>, kpi_group_metrics: Array<{ __typename?: 'KpiGroupMetric', id: string, kpi_group: { __typename?: 'KpiGroup', id: string, name: string, description?: string | null } }> }>, entity_structure: Array<{ __typename?: 'ReportEntity', entity_type: ReportEntityType, child_entities?: Array<{ __typename?: 'ReportEntity', entity_type: ReportEntityType, child_entities?: Array<{ __typename?: 'ReportEntity', entity_type: ReportEntityType, child_entities?: Array<{ __typename?: 'ReportEntity', entity_type: ReportEntityType }> | null }> | null }> | null }>, entity_reports: Array<{ __typename?: 'EntityReport', id: string, entity_type: ReportEntityType, entity_reports: Array<{ __typename?: 'EntityReport', id: string, entity_type: ReportEntityType, entity_reports: Array<{ __typename?: 'EntityReport', id: string, entity_type: ReportEntityType, clinic?: { __typename?: 'Clinic', id: string, name?: string | null, time_zone?: string | null, slug?: string | null, address?: { __typename?: 'Address', street_a?: string | null, street_b?: string | null, city?: string | null, state?: string | null, zip?: string | null, country?: string | null } | null, hours?: { __typename?: 'AvailabilityHours', monday?: Array<{ __typename?: 'TimeInterval', start?: number | null, end?: number | null }> | null, tuesday?: Array<{ __typename?: 'TimeInterval', start?: number | null, end?: number | null }> | null, wednesday?: Array<{ __typename?: 'TimeInterval', start?: number | null, end?: number | null }> | null, thursday?: Array<{ __typename?: 'TimeInterval', start?: number | null, end?: number | null }> | null, friday?: Array<{ __typename?: 'TimeInterval', start?: number | null, end?: number | null }> | null, saturday?: Array<{ __typename?: 'TimeInterval', start?: number | null, end?: number | null }> | null, sunday?: Array<{ __typename?: 'TimeInterval', start?: number | null, end?: number | null }> | null } | null } | null, clinician?: { __typename?: 'Clinician', id: string, pms_id?: string | null, name: string } | null, service?: { __typename?: 'Service', id: string, name?: string | null } | null, product?: { __typename?: 'Product', id: string, name: string } | null, values: Array<{ __typename?: 'ReportValue', metric: ReportMetricType, key: string, column_values: Array<{ __typename?: 'ReportColumnValue', value?: number | null, percentile?: number | null, value_params: { __typename?: 'MetricValueParams', custom_label?: string | null, value_type: MetricValueType } }> }> }>, clinic?: { __typename?: 'Clinic', id: string, name?: string | null, time_zone?: string | null, slug?: string | null, address?: { __typename?: 'Address', street_a?: string | null, street_b?: string | null, city?: string | null, state?: string | null, zip?: string | null, country?: string | null } | null, hours?: { __typename?: 'AvailabilityHours', monday?: Array<{ __typename?: 'TimeInterval', start?: number | null, end?: number | null }> | null, tuesday?: Array<{ __typename?: 'TimeInterval', start?: number | null, end?: number | null }> | null, wednesday?: Array<{ __typename?: 'TimeInterval', start?: number | null, end?: number | null }> | null, thursday?: Array<{ __typename?: 'TimeInterval', start?: number | null, end?: number | null }> | null, friday?: Array<{ __typename?: 'TimeInterval', start?: number | null, end?: number | null }> | null, saturday?: Array<{ __typename?: 'TimeInterval', start?: number | null, end?: number | null }> | null, sunday?: Array<{ __typename?: 'TimeInterval', start?: number | null, end?: number | null }> | null } | null } | null, clinician?: { __typename?: 'Clinician', id: string, pms_id?: string | null, name: string } | null, service?: { __typename?: 'Service', id: string, name?: string | null } | null, product?: { __typename?: 'Product', id: string, name: string } | null, values: Array<{ __typename?: 'ReportValue', metric: ReportMetricType, key: string, column_values: Array<{ __typename?: 'ReportColumnValue', value?: number | null, percentile?: number | null, value_params: { __typename?: 'MetricValueParams', custom_label?: string | null, value_type: MetricValueType } }> }> }>, clinic?: { __typename?: 'Clinic', id: string, name?: string | null, time_zone?: string | null, slug?: string | null, address?: { __typename?: 'Address', street_a?: string | null, street_b?: string | null, city?: string | null, state?: string | null, zip?: string | null, country?: string | null } | null, hours?: { __typename?: 'AvailabilityHours', monday?: Array<{ __typename?: 'TimeInterval', start?: number | null, end?: number | null }> | null, tuesday?: Array<{ __typename?: 'TimeInterval', start?: number | null, end?: number | null }> | null, wednesday?: Array<{ __typename?: 'TimeInterval', start?: number | null, end?: number | null }> | null, thursday?: Array<{ __typename?: 'TimeInterval', start?: number | null, end?: number | null }> | null, friday?: Array<{ __typename?: 'TimeInterval', start?: number | null, end?: number | null }> | null, saturday?: Array<{ __typename?: 'TimeInterval', start?: number | null, end?: number | null }> | null, sunday?: Array<{ __typename?: 'TimeInterval', start?: number | null, end?: number | null }> | null } | null } | null, clinician?: { __typename?: 'Clinician', id: string, pms_id?: string | null, name: string } | null, service?: { __typename?: 'Service', id: string, name?: string | null } | null, product?: { __typename?: 'Product', id: string, name: string } | null, values: Array<{ __typename?: 'ReportValue', metric: ReportMetricType, key: string, column_values: Array<{ __typename?: 'ReportColumnValue', value?: number | null, percentile?: number | null, value_params: { __typename?: 'MetricValueParams', custom_label?: string | null, value_type: MetricValueType } }> }> }>, report_template?: { __typename?: 'ReportTemplate', id: string } | null, time_params: { __typename?: 'TimeParams', type: TimeParamType, from_millis_ago?: any | null, to_millis_ago?: any | null, period_type?: PeriodType | null, from_periods_ago?: number | null, to_periods_ago?: number | null, start?: number | null, end?: number | null } } };

export type GetRealTimeReportQueryVariables = Exact<{
  params: RealTimeReportParams;
}>;


export type GetRealTimeReportQuery = { __typename?: 'Query', getRealTimeReport: { __typename?: 'OrganizationReport', id: string, name: string, description?: string | null, preferred_view_type: ReportViewType, is_hidden: boolean, created_at: number, updated_at: number, organization?: { __typename?: 'Organization', id: string, name: string } | null, report_clinics: Array<{ __typename?: 'ReportClinic', id: string, clinic: { __typename?: 'Clinic', id: string, name?: string | null, slug?: string | null, address?: { __typename?: 'Address', street_a?: string | null, street_b?: string | null, city?: string | null, state?: string | null, zip?: string | null, country?: string | null } | null } }>, report_metrics: Array<{ __typename?: 'ReportMetric', id: string, key: string, type: ReportMetricType, name: string, description?: string | null, definition_override?: string | null, custom_query?: any | null, special_modifier?: SpecialMetricModifierType | null, inverse_percentile?: boolean | null, format?: MetricFormat | null, time_field_override?: string | null, aggregate_field_override?: string | null, order: number, is_archived: boolean, time_params_overrides?: { __typename?: 'TimeParams', type: TimeParamType, from_millis_ago?: any | null, to_millis_ago?: any | null, period_type?: PeriodType | null, from_periods_ago?: number | null, to_periods_ago?: number | null, start?: number | null, end?: number | null } | null, field_modifiers: Array<{ __typename?: 'ReportMetricModifier', category: MetricModifierCategory, column: string, not?: boolean | null, filterOp: FilterOp, value: { __typename?: 'MetricModifierValue', string?: string | null, stringArray?: Array<string> | null, float?: number | null, boolean?: boolean | null } }>, value_types: Array<{ __typename?: 'MetricValueParams', custom_label?: string | null, value_type: MetricValueType }>, report_template_metrics: Array<{ __typename?: 'ReportTemplateMetric', id: string, report_template: { __typename?: 'ReportTemplate', id: string, name: string, description?: string | null, is_active: boolean } }>, initiative_metrics: Array<{ __typename?: 'InitiativeMetric', id: string, initiative: { __typename?: 'Initiative', id: string, name: string, description?: string | null, start_time: number, is_archived: boolean } }>, kpi_group_metrics: Array<{ __typename?: 'KpiGroupMetric', id: string, kpi_group: { __typename?: 'KpiGroup', id: string, name: string, description?: string | null } }> }>, entity_structure: Array<{ __typename?: 'ReportEntity', entity_type: ReportEntityType, child_entities?: Array<{ __typename?: 'ReportEntity', entity_type: ReportEntityType, child_entities?: Array<{ __typename?: 'ReportEntity', entity_type: ReportEntityType, child_entities?: Array<{ __typename?: 'ReportEntity', entity_type: ReportEntityType }> | null }> | null }> | null }>, entity_reports: Array<{ __typename?: 'EntityReport', id: string, entity_type: ReportEntityType, entity_reports: Array<{ __typename?: 'EntityReport', id: string, entity_type: ReportEntityType, entity_reports: Array<{ __typename?: 'EntityReport', id: string, entity_type: ReportEntityType, clinic?: { __typename?: 'Clinic', id: string, name?: string | null, time_zone?: string | null, slug?: string | null, address?: { __typename?: 'Address', street_a?: string | null, street_b?: string | null, city?: string | null, state?: string | null, zip?: string | null, country?: string | null } | null, hours?: { __typename?: 'AvailabilityHours', monday?: Array<{ __typename?: 'TimeInterval', start?: number | null, end?: number | null }> | null, tuesday?: Array<{ __typename?: 'TimeInterval', start?: number | null, end?: number | null }> | null, wednesday?: Array<{ __typename?: 'TimeInterval', start?: number | null, end?: number | null }> | null, thursday?: Array<{ __typename?: 'TimeInterval', start?: number | null, end?: number | null }> | null, friday?: Array<{ __typename?: 'TimeInterval', start?: number | null, end?: number | null }> | null, saturday?: Array<{ __typename?: 'TimeInterval', start?: number | null, end?: number | null }> | null, sunday?: Array<{ __typename?: 'TimeInterval', start?: number | null, end?: number | null }> | null } | null } | null, clinician?: { __typename?: 'Clinician', id: string, pms_id?: string | null, name: string } | null, service?: { __typename?: 'Service', id: string, name?: string | null } | null, product?: { __typename?: 'Product', id: string, name: string } | null, values: Array<{ __typename?: 'ReportValue', metric: ReportMetricType, key: string, column_values: Array<{ __typename?: 'ReportColumnValue', value?: number | null, percentile?: number | null, value_params: { __typename?: 'MetricValueParams', custom_label?: string | null, value_type: MetricValueType } }> }> }>, clinic?: { __typename?: 'Clinic', id: string, name?: string | null, time_zone?: string | null, slug?: string | null, address?: { __typename?: 'Address', street_a?: string | null, street_b?: string | null, city?: string | null, state?: string | null, zip?: string | null, country?: string | null } | null, hours?: { __typename?: 'AvailabilityHours', monday?: Array<{ __typename?: 'TimeInterval', start?: number | null, end?: number | null }> | null, tuesday?: Array<{ __typename?: 'TimeInterval', start?: number | null, end?: number | null }> | null, wednesday?: Array<{ __typename?: 'TimeInterval', start?: number | null, end?: number | null }> | null, thursday?: Array<{ __typename?: 'TimeInterval', start?: number | null, end?: number | null }> | null, friday?: Array<{ __typename?: 'TimeInterval', start?: number | null, end?: number | null }> | null, saturday?: Array<{ __typename?: 'TimeInterval', start?: number | null, end?: number | null }> | null, sunday?: Array<{ __typename?: 'TimeInterval', start?: number | null, end?: number | null }> | null } | null } | null, clinician?: { __typename?: 'Clinician', id: string, pms_id?: string | null, name: string } | null, service?: { __typename?: 'Service', id: string, name?: string | null } | null, product?: { __typename?: 'Product', id: string, name: string } | null, values: Array<{ __typename?: 'ReportValue', metric: ReportMetricType, key: string, column_values: Array<{ __typename?: 'ReportColumnValue', value?: number | null, percentile?: number | null, value_params: { __typename?: 'MetricValueParams', custom_label?: string | null, value_type: MetricValueType } }> }> }>, clinic?: { __typename?: 'Clinic', id: string, name?: string | null, time_zone?: string | null, slug?: string | null, address?: { __typename?: 'Address', street_a?: string | null, street_b?: string | null, city?: string | null, state?: string | null, zip?: string | null, country?: string | null } | null, hours?: { __typename?: 'AvailabilityHours', monday?: Array<{ __typename?: 'TimeInterval', start?: number | null, end?: number | null }> | null, tuesday?: Array<{ __typename?: 'TimeInterval', start?: number | null, end?: number | null }> | null, wednesday?: Array<{ __typename?: 'TimeInterval', start?: number | null, end?: number | null }> | null, thursday?: Array<{ __typename?: 'TimeInterval', start?: number | null, end?: number | null }> | null, friday?: Array<{ __typename?: 'TimeInterval', start?: number | null, end?: number | null }> | null, saturday?: Array<{ __typename?: 'TimeInterval', start?: number | null, end?: number | null }> | null, sunday?: Array<{ __typename?: 'TimeInterval', start?: number | null, end?: number | null }> | null } | null } | null, clinician?: { __typename?: 'Clinician', id: string, pms_id?: string | null, name: string } | null, service?: { __typename?: 'Service', id: string, name?: string | null } | null, product?: { __typename?: 'Product', id: string, name: string } | null, values: Array<{ __typename?: 'ReportValue', metric: ReportMetricType, key: string, column_values: Array<{ __typename?: 'ReportColumnValue', value?: number | null, percentile?: number | null, value_params: { __typename?: 'MetricValueParams', custom_label?: string | null, value_type: MetricValueType } }> }> }>, report_template?: { __typename?: 'ReportTemplate', id: string } | null, time_params: { __typename?: 'TimeParams', type: TimeParamType, from_millis_ago?: any | null, to_millis_ago?: any | null, period_type?: PeriodType | null, from_periods_ago?: number | null, to_periods_ago?: number | null, start?: number | null, end?: number | null } } };

export type QueryOrganizationReportsQueryVariables = Exact<{
  where?: InputMaybe<Array<QueryInput> | QueryInput>;
  page?: InputMaybe<Scalars['NonNegativeInt']['input']>;
  pageSize?: InputMaybe<Scalars['NonNegativeInt']['input']>;
  orderBy?: InputMaybe<OrderByInput>;
}>;


export type QueryOrganizationReportsQuery = { __typename?: 'Query', queryOrganizationReports: Array<{ __typename?: 'OrganizationReport', id: string, name: string, description?: string | null, preferred_view_type: ReportViewType, is_hidden: boolean, created_at: number, updated_at: number, organization?: { __typename?: 'Organization', id: string, name: string } | null, report_clinics: Array<{ __typename?: 'ReportClinic', id: string, clinic: { __typename?: 'Clinic', id: string, name?: string | null, slug?: string | null, address?: { __typename?: 'Address', street_a?: string | null, street_b?: string | null, city?: string | null, state?: string | null, zip?: string | null, country?: string | null } | null } }>, report_metrics: Array<{ __typename?: 'ReportMetric', id: string, key: string, type: ReportMetricType, name: string, description?: string | null, definition_override?: string | null, custom_query?: any | null, special_modifier?: SpecialMetricModifierType | null, inverse_percentile?: boolean | null, format?: MetricFormat | null, time_field_override?: string | null, aggregate_field_override?: string | null, order: number, is_archived: boolean, time_params_overrides?: { __typename?: 'TimeParams', type: TimeParamType, from_millis_ago?: any | null, to_millis_ago?: any | null, period_type?: PeriodType | null, from_periods_ago?: number | null, to_periods_ago?: number | null, start?: number | null, end?: number | null } | null, field_modifiers: Array<{ __typename?: 'ReportMetricModifier', category: MetricModifierCategory, column: string, not?: boolean | null, filterOp: FilterOp, value: { __typename?: 'MetricModifierValue', string?: string | null, stringArray?: Array<string> | null, float?: number | null, boolean?: boolean | null } }>, value_types: Array<{ __typename?: 'MetricValueParams', custom_label?: string | null, value_type: MetricValueType }>, report_template_metrics: Array<{ __typename?: 'ReportTemplateMetric', id: string, report_template: { __typename?: 'ReportTemplate', id: string, name: string, description?: string | null, is_active: boolean } }>, initiative_metrics: Array<{ __typename?: 'InitiativeMetric', id: string, initiative: { __typename?: 'Initiative', id: string, name: string, description?: string | null, start_time: number, is_archived: boolean } }>, kpi_group_metrics: Array<{ __typename?: 'KpiGroupMetric', id: string, kpi_group: { __typename?: 'KpiGroup', id: string, name: string, description?: string | null } }> }>, entity_structure: Array<{ __typename?: 'ReportEntity', entity_type: ReportEntityType, child_entities?: Array<{ __typename?: 'ReportEntity', entity_type: ReportEntityType, child_entities?: Array<{ __typename?: 'ReportEntity', entity_type: ReportEntityType, child_entities?: Array<{ __typename?: 'ReportEntity', entity_type: ReportEntityType }> | null }> | null }> | null }>, entity_reports: Array<{ __typename?: 'EntityReport', id: string, entity_type: ReportEntityType, entity_reports: Array<{ __typename?: 'EntityReport', id: string, entity_type: ReportEntityType, entity_reports: Array<{ __typename?: 'EntityReport', id: string, entity_type: ReportEntityType, clinic?: { __typename?: 'Clinic', id: string, name?: string | null, time_zone?: string | null, slug?: string | null, address?: { __typename?: 'Address', street_a?: string | null, street_b?: string | null, city?: string | null, state?: string | null, zip?: string | null, country?: string | null } | null, hours?: { __typename?: 'AvailabilityHours', monday?: Array<{ __typename?: 'TimeInterval', start?: number | null, end?: number | null }> | null, tuesday?: Array<{ __typename?: 'TimeInterval', start?: number | null, end?: number | null }> | null, wednesday?: Array<{ __typename?: 'TimeInterval', start?: number | null, end?: number | null }> | null, thursday?: Array<{ __typename?: 'TimeInterval', start?: number | null, end?: number | null }> | null, friday?: Array<{ __typename?: 'TimeInterval', start?: number | null, end?: number | null }> | null, saturday?: Array<{ __typename?: 'TimeInterval', start?: number | null, end?: number | null }> | null, sunday?: Array<{ __typename?: 'TimeInterval', start?: number | null, end?: number | null }> | null } | null } | null, clinician?: { __typename?: 'Clinician', id: string, pms_id?: string | null, name: string } | null, service?: { __typename?: 'Service', id: string, name?: string | null } | null, product?: { __typename?: 'Product', id: string, name: string } | null, values: Array<{ __typename?: 'ReportValue', metric: ReportMetricType, key: string, column_values: Array<{ __typename?: 'ReportColumnValue', value?: number | null, percentile?: number | null, value_params: { __typename?: 'MetricValueParams', custom_label?: string | null, value_type: MetricValueType } }> }> }>, clinic?: { __typename?: 'Clinic', id: string, name?: string | null, time_zone?: string | null, slug?: string | null, address?: { __typename?: 'Address', street_a?: string | null, street_b?: string | null, city?: string | null, state?: string | null, zip?: string | null, country?: string | null } | null, hours?: { __typename?: 'AvailabilityHours', monday?: Array<{ __typename?: 'TimeInterval', start?: number | null, end?: number | null }> | null, tuesday?: Array<{ __typename?: 'TimeInterval', start?: number | null, end?: number | null }> | null, wednesday?: Array<{ __typename?: 'TimeInterval', start?: number | null, end?: number | null }> | null, thursday?: Array<{ __typename?: 'TimeInterval', start?: number | null, end?: number | null }> | null, friday?: Array<{ __typename?: 'TimeInterval', start?: number | null, end?: number | null }> | null, saturday?: Array<{ __typename?: 'TimeInterval', start?: number | null, end?: number | null }> | null, sunday?: Array<{ __typename?: 'TimeInterval', start?: number | null, end?: number | null }> | null } | null } | null, clinician?: { __typename?: 'Clinician', id: string, pms_id?: string | null, name: string } | null, service?: { __typename?: 'Service', id: string, name?: string | null } | null, product?: { __typename?: 'Product', id: string, name: string } | null, values: Array<{ __typename?: 'ReportValue', metric: ReportMetricType, key: string, column_values: Array<{ __typename?: 'ReportColumnValue', value?: number | null, percentile?: number | null, value_params: { __typename?: 'MetricValueParams', custom_label?: string | null, value_type: MetricValueType } }> }> }>, clinic?: { __typename?: 'Clinic', id: string, name?: string | null, time_zone?: string | null, slug?: string | null, address?: { __typename?: 'Address', street_a?: string | null, street_b?: string | null, city?: string | null, state?: string | null, zip?: string | null, country?: string | null } | null, hours?: { __typename?: 'AvailabilityHours', monday?: Array<{ __typename?: 'TimeInterval', start?: number | null, end?: number | null }> | null, tuesday?: Array<{ __typename?: 'TimeInterval', start?: number | null, end?: number | null }> | null, wednesday?: Array<{ __typename?: 'TimeInterval', start?: number | null, end?: number | null }> | null, thursday?: Array<{ __typename?: 'TimeInterval', start?: number | null, end?: number | null }> | null, friday?: Array<{ __typename?: 'TimeInterval', start?: number | null, end?: number | null }> | null, saturday?: Array<{ __typename?: 'TimeInterval', start?: number | null, end?: number | null }> | null, sunday?: Array<{ __typename?: 'TimeInterval', start?: number | null, end?: number | null }> | null } | null } | null, clinician?: { __typename?: 'Clinician', id: string, pms_id?: string | null, name: string } | null, service?: { __typename?: 'Service', id: string, name?: string | null } | null, product?: { __typename?: 'Product', id: string, name: string } | null, values: Array<{ __typename?: 'ReportValue', metric: ReportMetricType, key: string, column_values: Array<{ __typename?: 'ReportColumnValue', value?: number | null, percentile?: number | null, value_params: { __typename?: 'MetricValueParams', custom_label?: string | null, value_type: MetricValueType } }> }> }>, report_template?: { __typename?: 'ReportTemplate', id: string } | null, time_params: { __typename?: 'TimeParams', type: TimeParamType, from_millis_ago?: any | null, to_millis_ago?: any | null, period_type?: PeriodType | null, from_periods_ago?: number | null, to_periods_ago?: number | null, start?: number | null, end?: number | null } }> };

export type QueryOrganizationReportPreviewsQueryVariables = Exact<{
  where?: InputMaybe<Array<QueryInput> | QueryInput>;
  page?: InputMaybe<Scalars['NonNegativeInt']['input']>;
  pageSize?: InputMaybe<Scalars['NonNegativeInt']['input']>;
  orderBy?: InputMaybe<OrderByInput>;
}>;


export type QueryOrganizationReportPreviewsQuery = { __typename?: 'Query', queryOrganizationReports: Array<{ __typename?: 'OrganizationReport', id: string, name: string, description?: string | null, is_hidden: boolean, created_at: number, report_clinics: Array<{ __typename?: 'ReportClinic', id: string, clinic: { __typename?: 'Clinic', name?: string | null } }>, report_metrics: Array<{ __typename?: 'ReportMetric', id: string, name: string, type: ReportMetricType }>, report_template?: { __typename?: 'ReportTemplate', id: string, name: string } | null }> };

export type ReportClinicClinicFieldsFragment = { __typename?: 'Clinic', id: string, name?: string | null, slug?: string | null, address?: { __typename?: 'Address', street_a?: string | null, street_b?: string | null, city?: string | null, state?: string | null, zip?: string | null, country?: string | null } | null };

export type ReportClinicFieldsFragment = { __typename?: 'ReportClinic', id: string, clinic: { __typename?: 'Clinic', id: string, name?: string | null, slug?: string | null, address?: { __typename?: 'Address', street_a?: string | null, street_b?: string | null, city?: string | null, state?: string | null, zip?: string | null, country?: string | null } | null } };

export type CreateReportClinicMutationVariables = Exact<{
  data: CreateReportClinicInput;
}>;


export type CreateReportClinicMutation = { __typename?: 'Mutation', createReportClinic: { __typename?: 'ReportClinic', id: string, clinic: { __typename?: 'Clinic', id: string, name?: string | null, slug?: string | null, address?: { __typename?: 'Address', street_a?: string | null, street_b?: string | null, city?: string | null, state?: string | null, zip?: string | null, country?: string | null } | null } } };

export type DeleteReportClinicMutationVariables = Exact<{
  id: Scalars['ID']['input'];
}>;


export type DeleteReportClinicMutation = { __typename?: 'Mutation', deleteReportClinic?: any | null };

export type ReportMetricFieldsFragment = { __typename?: 'ReportMetric', id: string, key: string, type: ReportMetricType, name: string, description?: string | null, definition_override?: string | null, custom_query?: any | null, special_modifier?: SpecialMetricModifierType | null, inverse_percentile?: boolean | null, format?: MetricFormat | null, time_field_override?: string | null, aggregate_field_override?: string | null, order: number, is_archived: boolean, time_params_overrides?: { __typename?: 'TimeParams', type: TimeParamType, from_millis_ago?: any | null, to_millis_ago?: any | null, period_type?: PeriodType | null, from_periods_ago?: number | null, to_periods_ago?: number | null, start?: number | null, end?: number | null } | null, field_modifiers: Array<{ __typename?: 'ReportMetricModifier', category: MetricModifierCategory, column: string, not?: boolean | null, filterOp: FilterOp, value: { __typename?: 'MetricModifierValue', string?: string | null, stringArray?: Array<string> | null, float?: number | null, boolean?: boolean | null } }>, value_types: Array<{ __typename?: 'MetricValueParams', custom_label?: string | null, value_type: MetricValueType }>, report_template_metrics: Array<{ __typename?: 'ReportTemplateMetric', id: string, report_template: { __typename?: 'ReportTemplate', id: string, name: string, description?: string | null, is_active: boolean } }>, initiative_metrics: Array<{ __typename?: 'InitiativeMetric', id: string, initiative: { __typename?: 'Initiative', id: string, name: string, description?: string | null, start_time: number, is_archived: boolean } }>, kpi_group_metrics: Array<{ __typename?: 'KpiGroupMetric', id: string, kpi_group: { __typename?: 'KpiGroup', id: string, name: string, description?: string | null } }> };

export type ReportMetricPreviewFieldsFragment = { __typename?: 'ReportMetric', id: string, name: string, type: ReportMetricType, inverse_percentile?: boolean | null, format?: MetricFormat | null };

export type TimeParamFieldsFragment = { __typename?: 'TimeParams', type: TimeParamType, from_millis_ago?: any | null, to_millis_ago?: any | null, period_type?: PeriodType | null, from_periods_ago?: number | null, to_periods_ago?: number | null, start?: number | null, end?: number | null };

export type MetricValueParamsFieldsFragment = { __typename?: 'MetricValueParams', custom_label?: string | null, value_type: MetricValueType };

export type ReportMetricModifierFieldsFragment = { __typename?: 'ReportMetricModifier', category: MetricModifierCategory, column: string, not?: boolean | null, filterOp: FilterOp, value: { __typename?: 'MetricModifierValue', string?: string | null, stringArray?: Array<string> | null, float?: number | null, boolean?: boolean | null } };

export type GetReportMetricQueryVariables = Exact<{
  id: Scalars['ID']['input'];
}>;


export type GetReportMetricQuery = { __typename?: 'Query', reportMetric: { __typename?: 'ReportMetric', id: string, key: string, type: ReportMetricType, name: string, description?: string | null, definition_override?: string | null, custom_query?: any | null, special_modifier?: SpecialMetricModifierType | null, inverse_percentile?: boolean | null, format?: MetricFormat | null, time_field_override?: string | null, aggregate_field_override?: string | null, order: number, is_archived: boolean, time_params_overrides?: { __typename?: 'TimeParams', type: TimeParamType, from_millis_ago?: any | null, to_millis_ago?: any | null, period_type?: PeriodType | null, from_periods_ago?: number | null, to_periods_ago?: number | null, start?: number | null, end?: number | null } | null, field_modifiers: Array<{ __typename?: 'ReportMetricModifier', category: MetricModifierCategory, column: string, not?: boolean | null, filterOp: FilterOp, value: { __typename?: 'MetricModifierValue', string?: string | null, stringArray?: Array<string> | null, float?: number | null, boolean?: boolean | null } }>, value_types: Array<{ __typename?: 'MetricValueParams', custom_label?: string | null, value_type: MetricValueType }>, report_template_metrics: Array<{ __typename?: 'ReportTemplateMetric', id: string, report_template: { __typename?: 'ReportTemplate', id: string, name: string, description?: string | null, is_active: boolean } }>, initiative_metrics: Array<{ __typename?: 'InitiativeMetric', id: string, initiative: { __typename?: 'Initiative', id: string, name: string, description?: string | null, start_time: number, is_archived: boolean } }>, kpi_group_metrics: Array<{ __typename?: 'KpiGroupMetric', id: string, kpi_group: { __typename?: 'KpiGroup', id: string, name: string, description?: string | null } }> } };

export type QueryReportMetricsQueryVariables = Exact<{
  where?: InputMaybe<Array<QueryInput> | QueryInput>;
  page?: InputMaybe<Scalars['NonNegativeInt']['input']>;
  pageSize?: InputMaybe<Scalars['NonNegativeInt']['input']>;
  orderBy?: InputMaybe<OrderByInput>;
}>;


export type QueryReportMetricsQuery = { __typename?: 'Query', queryReportMetrics: Array<{ __typename?: 'ReportMetric', id: string, key: string, type: ReportMetricType, name: string, description?: string | null, definition_override?: string | null, custom_query?: any | null, special_modifier?: SpecialMetricModifierType | null, inverse_percentile?: boolean | null, format?: MetricFormat | null, time_field_override?: string | null, aggregate_field_override?: string | null, order: number, is_archived: boolean, time_params_overrides?: { __typename?: 'TimeParams', type: TimeParamType, from_millis_ago?: any | null, to_millis_ago?: any | null, period_type?: PeriodType | null, from_periods_ago?: number | null, to_periods_ago?: number | null, start?: number | null, end?: number | null } | null, field_modifiers: Array<{ __typename?: 'ReportMetricModifier', category: MetricModifierCategory, column: string, not?: boolean | null, filterOp: FilterOp, value: { __typename?: 'MetricModifierValue', string?: string | null, stringArray?: Array<string> | null, float?: number | null, boolean?: boolean | null } }>, value_types: Array<{ __typename?: 'MetricValueParams', custom_label?: string | null, value_type: MetricValueType }>, report_template_metrics: Array<{ __typename?: 'ReportTemplateMetric', id: string, report_template: { __typename?: 'ReportTemplate', id: string, name: string, description?: string | null, is_active: boolean } }>, initiative_metrics: Array<{ __typename?: 'InitiativeMetric', id: string, initiative: { __typename?: 'Initiative', id: string, name: string, description?: string | null, start_time: number, is_archived: boolean } }>, kpi_group_metrics: Array<{ __typename?: 'KpiGroupMetric', id: string, kpi_group: { __typename?: 'KpiGroup', id: string, name: string, description?: string | null } }> }> };

export type CountReportMetricsQueryVariables = Exact<{
  where?: InputMaybe<Array<QueryInput> | QueryInput>;
}>;


export type CountReportMetricsQuery = { __typename?: 'Query', countReportMetrics: number };

export type CreateReportMetricMutationVariables = Exact<{
  data: CreateReportMetricInput;
}>;


export type CreateReportMetricMutation = { __typename?: 'Mutation', createReportMetric: { __typename?: 'ReportMetric', id: string, key: string, type: ReportMetricType, name: string, description?: string | null, definition_override?: string | null, custom_query?: any | null, special_modifier?: SpecialMetricModifierType | null, inverse_percentile?: boolean | null, format?: MetricFormat | null, time_field_override?: string | null, aggregate_field_override?: string | null, order: number, is_archived: boolean, time_params_overrides?: { __typename?: 'TimeParams', type: TimeParamType, from_millis_ago?: any | null, to_millis_ago?: any | null, period_type?: PeriodType | null, from_periods_ago?: number | null, to_periods_ago?: number | null, start?: number | null, end?: number | null } | null, field_modifiers: Array<{ __typename?: 'ReportMetricModifier', category: MetricModifierCategory, column: string, not?: boolean | null, filterOp: FilterOp, value: { __typename?: 'MetricModifierValue', string?: string | null, stringArray?: Array<string> | null, float?: number | null, boolean?: boolean | null } }>, value_types: Array<{ __typename?: 'MetricValueParams', custom_label?: string | null, value_type: MetricValueType }>, report_template_metrics: Array<{ __typename?: 'ReportTemplateMetric', id: string, report_template: { __typename?: 'ReportTemplate', id: string, name: string, description?: string | null, is_active: boolean } }>, initiative_metrics: Array<{ __typename?: 'InitiativeMetric', id: string, initiative: { __typename?: 'Initiative', id: string, name: string, description?: string | null, start_time: number, is_archived: boolean } }>, kpi_group_metrics: Array<{ __typename?: 'KpiGroupMetric', id: string, kpi_group: { __typename?: 'KpiGroup', id: string, name: string, description?: string | null } }> } };

export type UpdateReportMetricMutationVariables = Exact<{
  id: Scalars['ID']['input'];
  data: UpdateReportMetricInput;
}>;


export type UpdateReportMetricMutation = { __typename?: 'Mutation', updateReportMetric: { __typename?: 'ReportMetric', id: string, key: string, type: ReportMetricType, name: string, description?: string | null, definition_override?: string | null, custom_query?: any | null, special_modifier?: SpecialMetricModifierType | null, inverse_percentile?: boolean | null, format?: MetricFormat | null, time_field_override?: string | null, aggregate_field_override?: string | null, order: number, is_archived: boolean, time_params_overrides?: { __typename?: 'TimeParams', type: TimeParamType, from_millis_ago?: any | null, to_millis_ago?: any | null, period_type?: PeriodType | null, from_periods_ago?: number | null, to_periods_ago?: number | null, start?: number | null, end?: number | null } | null, field_modifiers: Array<{ __typename?: 'ReportMetricModifier', category: MetricModifierCategory, column: string, not?: boolean | null, filterOp: FilterOp, value: { __typename?: 'MetricModifierValue', string?: string | null, stringArray?: Array<string> | null, float?: number | null, boolean?: boolean | null } }>, value_types: Array<{ __typename?: 'MetricValueParams', custom_label?: string | null, value_type: MetricValueType }>, report_template_metrics: Array<{ __typename?: 'ReportTemplateMetric', id: string, report_template: { __typename?: 'ReportTemplate', id: string, name: string, description?: string | null, is_active: boolean } }>, initiative_metrics: Array<{ __typename?: 'InitiativeMetric', id: string, initiative: { __typename?: 'Initiative', id: string, name: string, description?: string | null, start_time: number, is_archived: boolean } }>, kpi_group_metrics: Array<{ __typename?: 'KpiGroupMetric', id: string, kpi_group: { __typename?: 'KpiGroup', id: string, name: string, description?: string | null } }> } };

export type ReportTemplateFieldsFragment = { __typename?: 'ReportTemplate', id: string, name: string, description?: string | null, preferred_view_type?: ReportViewType | null, entity_structure?: Array<string> | null, last_run?: number | null, next_run?: number | null, is_active: boolean, created_at: number, updated_at: number, organization?: { __typename?: 'Organization', id: string } | null, template_clinics: Array<{ __typename?: 'TemplateClinic', id: string, clinic: { __typename?: 'Clinic', id: string, name?: string | null, time_zone?: string | null, slug?: string | null, address?: { __typename?: 'Address', street_a?: string | null, street_b?: string | null, city?: string | null, state?: string | null, zip?: string | null, country?: string | null } | null, hours?: { __typename?: 'AvailabilityHours', monday?: Array<{ __typename?: 'TimeInterval', start?: number | null, end?: number | null }> | null, tuesday?: Array<{ __typename?: 'TimeInterval', start?: number | null, end?: number | null }> | null, wednesday?: Array<{ __typename?: 'TimeInterval', start?: number | null, end?: number | null }> | null, thursday?: Array<{ __typename?: 'TimeInterval', start?: number | null, end?: number | null }> | null, friday?: Array<{ __typename?: 'TimeInterval', start?: number | null, end?: number | null }> | null, saturday?: Array<{ __typename?: 'TimeInterval', start?: number | null, end?: number | null }> | null, sunday?: Array<{ __typename?: 'TimeInterval', start?: number | null, end?: number | null }> | null } | null } }>, report_template_metrics: Array<{ __typename?: 'ReportTemplateMetric', id: string, order?: number | null, report_template: { __typename?: 'ReportTemplate', id: string, name: string, description?: string | null, is_active: boolean }, report_metric: { __typename?: 'ReportMetric', id: string, key: string, type: ReportMetricType, name: string, description?: string | null, definition_override?: string | null, custom_query?: any | null, special_modifier?: SpecialMetricModifierType | null, inverse_percentile?: boolean | null, format?: MetricFormat | null, time_field_override?: string | null, aggregate_field_override?: string | null, order: number, is_archived: boolean, time_params_overrides?: { __typename?: 'TimeParams', type: TimeParamType, from_millis_ago?: any | null, to_millis_ago?: any | null, period_type?: PeriodType | null, from_periods_ago?: number | null, to_periods_ago?: number | null, start?: number | null, end?: number | null } | null, field_modifiers: Array<{ __typename?: 'ReportMetricModifier', category: MetricModifierCategory, column: string, not?: boolean | null, filterOp: FilterOp, value: { __typename?: 'MetricModifierValue', string?: string | null, stringArray?: Array<string> | null, float?: number | null, boolean?: boolean | null } }>, value_types: Array<{ __typename?: 'MetricValueParams', custom_label?: string | null, value_type: MetricValueType }>, report_template_metrics: Array<{ __typename?: 'ReportTemplateMetric', id: string, report_template: { __typename?: 'ReportTemplate', id: string, name: string, description?: string | null, is_active: boolean } }>, initiative_metrics: Array<{ __typename?: 'InitiativeMetric', id: string, initiative: { __typename?: 'Initiative', id: string, name: string, description?: string | null, start_time: number, is_archived: boolean } }>, kpi_group_metrics: Array<{ __typename?: 'KpiGroupMetric', id: string, kpi_group: { __typename?: 'KpiGroup', id: string, name: string, description?: string | null } }> } }>, repeat?: { __typename?: 'RepeatParams', frequency: any, unit: RepeatUnit, daysOfWeek?: Array<DayOfWeek> | null, daysOfMonth?: Array<number> | null, weekOfMonth?: WeekOfMonth | null } | null, organization_reports: Array<{ __typename?: 'OrganizationReport', id: string }>, time_params?: { __typename?: 'TimeParams', type: TimeParamType, from_millis_ago?: any | null, to_millis_ago?: any | null, period_type?: PeriodType | null, from_periods_ago?: number | null, to_periods_ago?: number | null, start?: number | null, end?: number | null } | null };

export type ReportTemplatePreviewFieldsFragment = { __typename?: 'ReportTemplate', id: string, name: string, description?: string | null, is_active: boolean };

export type ReportTemplateMetricFieldsFragment = { __typename?: 'ReportTemplateMetric', id: string, order?: number | null, report_template: { __typename?: 'ReportTemplate', id: string, name: string, description?: string | null, is_active: boolean }, report_metric: { __typename?: 'ReportMetric', id: string, key: string, type: ReportMetricType, name: string, description?: string | null, definition_override?: string | null, custom_query?: any | null, special_modifier?: SpecialMetricModifierType | null, inverse_percentile?: boolean | null, format?: MetricFormat | null, time_field_override?: string | null, aggregate_field_override?: string | null, order: number, is_archived: boolean, time_params_overrides?: { __typename?: 'TimeParams', type: TimeParamType, from_millis_ago?: any | null, to_millis_ago?: any | null, period_type?: PeriodType | null, from_periods_ago?: number | null, to_periods_ago?: number | null, start?: number | null, end?: number | null } | null, field_modifiers: Array<{ __typename?: 'ReportMetricModifier', category: MetricModifierCategory, column: string, not?: boolean | null, filterOp: FilterOp, value: { __typename?: 'MetricModifierValue', string?: string | null, stringArray?: Array<string> | null, float?: number | null, boolean?: boolean | null } }>, value_types: Array<{ __typename?: 'MetricValueParams', custom_label?: string | null, value_type: MetricValueType }>, report_template_metrics: Array<{ __typename?: 'ReportTemplateMetric', id: string, report_template: { __typename?: 'ReportTemplate', id: string, name: string, description?: string | null, is_active: boolean } }>, initiative_metrics: Array<{ __typename?: 'InitiativeMetric', id: string, initiative: { __typename?: 'Initiative', id: string, name: string, description?: string | null, start_time: number, is_archived: boolean } }>, kpi_group_metrics: Array<{ __typename?: 'KpiGroupMetric', id: string, kpi_group: { __typename?: 'KpiGroup', id: string, name: string, description?: string | null } }> } };

export type ReportEntityFieldsFragment = { __typename?: 'ReportEntity', entity_type: ReportEntityType, child_entities?: Array<{ __typename?: 'ReportEntity', entity_type: ReportEntityType, child_entities?: Array<{ __typename?: 'ReportEntity', entity_type: ReportEntityType, child_entities?: Array<{ __typename?: 'ReportEntity', entity_type: ReportEntityType }> | null }> | null }> | null };

export type ChildReportEntityFieldsFragment = { __typename?: 'ReportEntity', entity_type: ReportEntityType, child_entities?: Array<{ __typename?: 'ReportEntity', entity_type: ReportEntityType, child_entities?: Array<{ __typename?: 'ReportEntity', entity_type: ReportEntityType }> | null }> | null };

export type SecondChildReportEntityFieldsFragment = { __typename?: 'ReportEntity', entity_type: ReportEntityType, child_entities?: Array<{ __typename?: 'ReportEntity', entity_type: ReportEntityType }> | null };

export type RepeatParamsFieldsFragment = { __typename?: 'RepeatParams', frequency: any, unit: RepeatUnit, daysOfWeek?: Array<DayOfWeek> | null, daysOfMonth?: Array<number> | null, weekOfMonth?: WeekOfMonth | null };

export type ReportTemplateResultFieldsFragment = { __typename?: 'ReportTemplateResult', values: Array<any>, metric: { __typename?: 'ReportTemplateMetric', order?: number | null, report_metric: { __typename?: 'ReportMetric', id: string, name: string, type: ReportMetricType, inverse_percentile?: boolean | null, format?: MetricFormat | null } } };

export type GetReportTemplateQueryVariables = Exact<{
  id: Scalars['ID']['input'];
}>;


export type GetReportTemplateQuery = { __typename?: 'Query', reportTemplate: { __typename?: 'ReportTemplate', id: string, name: string, description?: string | null, preferred_view_type?: ReportViewType | null, entity_structure?: Array<string> | null, last_run?: number | null, next_run?: number | null, is_active: boolean, created_at: number, updated_at: number, organization?: { __typename?: 'Organization', id: string } | null, template_clinics: Array<{ __typename?: 'TemplateClinic', id: string, clinic: { __typename?: 'Clinic', id: string, name?: string | null, time_zone?: string | null, slug?: string | null, address?: { __typename?: 'Address', street_a?: string | null, street_b?: string | null, city?: string | null, state?: string | null, zip?: string | null, country?: string | null } | null, hours?: { __typename?: 'AvailabilityHours', monday?: Array<{ __typename?: 'TimeInterval', start?: number | null, end?: number | null }> | null, tuesday?: Array<{ __typename?: 'TimeInterval', start?: number | null, end?: number | null }> | null, wednesday?: Array<{ __typename?: 'TimeInterval', start?: number | null, end?: number | null }> | null, thursday?: Array<{ __typename?: 'TimeInterval', start?: number | null, end?: number | null }> | null, friday?: Array<{ __typename?: 'TimeInterval', start?: number | null, end?: number | null }> | null, saturday?: Array<{ __typename?: 'TimeInterval', start?: number | null, end?: number | null }> | null, sunday?: Array<{ __typename?: 'TimeInterval', start?: number | null, end?: number | null }> | null } | null } }>, report_template_metrics: Array<{ __typename?: 'ReportTemplateMetric', id: string, order?: number | null, report_template: { __typename?: 'ReportTemplate', id: string, name: string, description?: string | null, is_active: boolean }, report_metric: { __typename?: 'ReportMetric', id: string, key: string, type: ReportMetricType, name: string, description?: string | null, definition_override?: string | null, custom_query?: any | null, special_modifier?: SpecialMetricModifierType | null, inverse_percentile?: boolean | null, format?: MetricFormat | null, time_field_override?: string | null, aggregate_field_override?: string | null, order: number, is_archived: boolean, time_params_overrides?: { __typename?: 'TimeParams', type: TimeParamType, from_millis_ago?: any | null, to_millis_ago?: any | null, period_type?: PeriodType | null, from_periods_ago?: number | null, to_periods_ago?: number | null, start?: number | null, end?: number | null } | null, field_modifiers: Array<{ __typename?: 'ReportMetricModifier', category: MetricModifierCategory, column: string, not?: boolean | null, filterOp: FilterOp, value: { __typename?: 'MetricModifierValue', string?: string | null, stringArray?: Array<string> | null, float?: number | null, boolean?: boolean | null } }>, value_types: Array<{ __typename?: 'MetricValueParams', custom_label?: string | null, value_type: MetricValueType }>, report_template_metrics: Array<{ __typename?: 'ReportTemplateMetric', id: string, report_template: { __typename?: 'ReportTemplate', id: string, name: string, description?: string | null, is_active: boolean } }>, initiative_metrics: Array<{ __typename?: 'InitiativeMetric', id: string, initiative: { __typename?: 'Initiative', id: string, name: string, description?: string | null, start_time: number, is_archived: boolean } }>, kpi_group_metrics: Array<{ __typename?: 'KpiGroupMetric', id: string, kpi_group: { __typename?: 'KpiGroup', id: string, name: string, description?: string | null } }> } }>, repeat?: { __typename?: 'RepeatParams', frequency: any, unit: RepeatUnit, daysOfWeek?: Array<DayOfWeek> | null, daysOfMonth?: Array<number> | null, weekOfMonth?: WeekOfMonth | null } | null, organization_reports: Array<{ __typename?: 'OrganizationReport', id: string }>, time_params?: { __typename?: 'TimeParams', type: TimeParamType, from_millis_ago?: any | null, to_millis_ago?: any | null, period_type?: PeriodType | null, from_periods_ago?: number | null, to_periods_ago?: number | null, start?: number | null, end?: number | null } | null } };

export type QueryReportTemplatesQueryVariables = Exact<{
  where?: InputMaybe<Array<QueryInput> | QueryInput>;
  page?: InputMaybe<Scalars['NonNegativeInt']['input']>;
  pageSize?: InputMaybe<Scalars['NonNegativeInt']['input']>;
  orderBy?: InputMaybe<OrderByInput>;
}>;


export type QueryReportTemplatesQuery = { __typename?: 'Query', queryReportTemplates: Array<{ __typename?: 'ReportTemplate', id: string, name: string, description?: string | null, preferred_view_type?: ReportViewType | null, entity_structure?: Array<string> | null, last_run?: number | null, next_run?: number | null, is_active: boolean, created_at: number, updated_at: number, organization?: { __typename?: 'Organization', id: string } | null, template_clinics: Array<{ __typename?: 'TemplateClinic', id: string, clinic: { __typename?: 'Clinic', id: string, name?: string | null, time_zone?: string | null, slug?: string | null, address?: { __typename?: 'Address', street_a?: string | null, street_b?: string | null, city?: string | null, state?: string | null, zip?: string | null, country?: string | null } | null, hours?: { __typename?: 'AvailabilityHours', monday?: Array<{ __typename?: 'TimeInterval', start?: number | null, end?: number | null }> | null, tuesday?: Array<{ __typename?: 'TimeInterval', start?: number | null, end?: number | null }> | null, wednesday?: Array<{ __typename?: 'TimeInterval', start?: number | null, end?: number | null }> | null, thursday?: Array<{ __typename?: 'TimeInterval', start?: number | null, end?: number | null }> | null, friday?: Array<{ __typename?: 'TimeInterval', start?: number | null, end?: number | null }> | null, saturday?: Array<{ __typename?: 'TimeInterval', start?: number | null, end?: number | null }> | null, sunday?: Array<{ __typename?: 'TimeInterval', start?: number | null, end?: number | null }> | null } | null } }>, report_template_metrics: Array<{ __typename?: 'ReportTemplateMetric', id: string, order?: number | null, report_template: { __typename?: 'ReportTemplate', id: string, name: string, description?: string | null, is_active: boolean }, report_metric: { __typename?: 'ReportMetric', id: string, key: string, type: ReportMetricType, name: string, description?: string | null, definition_override?: string | null, custom_query?: any | null, special_modifier?: SpecialMetricModifierType | null, inverse_percentile?: boolean | null, format?: MetricFormat | null, time_field_override?: string | null, aggregate_field_override?: string | null, order: number, is_archived: boolean, time_params_overrides?: { __typename?: 'TimeParams', type: TimeParamType, from_millis_ago?: any | null, to_millis_ago?: any | null, period_type?: PeriodType | null, from_periods_ago?: number | null, to_periods_ago?: number | null, start?: number | null, end?: number | null } | null, field_modifiers: Array<{ __typename?: 'ReportMetricModifier', category: MetricModifierCategory, column: string, not?: boolean | null, filterOp: FilterOp, value: { __typename?: 'MetricModifierValue', string?: string | null, stringArray?: Array<string> | null, float?: number | null, boolean?: boolean | null } }>, value_types: Array<{ __typename?: 'MetricValueParams', custom_label?: string | null, value_type: MetricValueType }>, report_template_metrics: Array<{ __typename?: 'ReportTemplateMetric', id: string, report_template: { __typename?: 'ReportTemplate', id: string, name: string, description?: string | null, is_active: boolean } }>, initiative_metrics: Array<{ __typename?: 'InitiativeMetric', id: string, initiative: { __typename?: 'Initiative', id: string, name: string, description?: string | null, start_time: number, is_archived: boolean } }>, kpi_group_metrics: Array<{ __typename?: 'KpiGroupMetric', id: string, kpi_group: { __typename?: 'KpiGroup', id: string, name: string, description?: string | null } }> } }>, repeat?: { __typename?: 'RepeatParams', frequency: any, unit: RepeatUnit, daysOfWeek?: Array<DayOfWeek> | null, daysOfMonth?: Array<number> | null, weekOfMonth?: WeekOfMonth | null } | null, organization_reports: Array<{ __typename?: 'OrganizationReport', id: string }>, time_params?: { __typename?: 'TimeParams', type: TimeParamType, from_millis_ago?: any | null, to_millis_ago?: any | null, period_type?: PeriodType | null, from_periods_ago?: number | null, to_periods_ago?: number | null, start?: number | null, end?: number | null } | null }> };

export type ComputeReportTemplateValuesQueryVariables = Exact<{
  id: Scalars['ID']['input'];
  options?: InputMaybe<ComputeReportTemplateValuesOptions>;
}>;


export type ComputeReportTemplateValuesQuery = { __typename?: 'Query', computeReportTemplateValues: Array<{ __typename?: 'ReportTemplateResult', values: Array<any>, metric: { __typename?: 'ReportTemplateMetric', order?: number | null, report_metric: { __typename?: 'ReportMetric', id: string, name: string, type: ReportMetricType, inverse_percentile?: boolean | null, format?: MetricFormat | null } } }> };

export type CreateReportTemplateMutationVariables = Exact<{
  data: CreateReportTemplateInput;
}>;


export type CreateReportTemplateMutation = { __typename?: 'Mutation', createReportTemplate: { __typename?: 'ReportTemplate', id: string, name: string, description?: string | null, preferred_view_type?: ReportViewType | null, entity_structure?: Array<string> | null, last_run?: number | null, next_run?: number | null, is_active: boolean, created_at: number, updated_at: number, organization?: { __typename?: 'Organization', id: string } | null, template_clinics: Array<{ __typename?: 'TemplateClinic', id: string, clinic: { __typename?: 'Clinic', id: string, name?: string | null, time_zone?: string | null, slug?: string | null, address?: { __typename?: 'Address', street_a?: string | null, street_b?: string | null, city?: string | null, state?: string | null, zip?: string | null, country?: string | null } | null, hours?: { __typename?: 'AvailabilityHours', monday?: Array<{ __typename?: 'TimeInterval', start?: number | null, end?: number | null }> | null, tuesday?: Array<{ __typename?: 'TimeInterval', start?: number | null, end?: number | null }> | null, wednesday?: Array<{ __typename?: 'TimeInterval', start?: number | null, end?: number | null }> | null, thursday?: Array<{ __typename?: 'TimeInterval', start?: number | null, end?: number | null }> | null, friday?: Array<{ __typename?: 'TimeInterval', start?: number | null, end?: number | null }> | null, saturday?: Array<{ __typename?: 'TimeInterval', start?: number | null, end?: number | null }> | null, sunday?: Array<{ __typename?: 'TimeInterval', start?: number | null, end?: number | null }> | null } | null } }>, report_template_metrics: Array<{ __typename?: 'ReportTemplateMetric', id: string, order?: number | null, report_template: { __typename?: 'ReportTemplate', id: string, name: string, description?: string | null, is_active: boolean }, report_metric: { __typename?: 'ReportMetric', id: string, key: string, type: ReportMetricType, name: string, description?: string | null, definition_override?: string | null, custom_query?: any | null, special_modifier?: SpecialMetricModifierType | null, inverse_percentile?: boolean | null, format?: MetricFormat | null, time_field_override?: string | null, aggregate_field_override?: string | null, order: number, is_archived: boolean, time_params_overrides?: { __typename?: 'TimeParams', type: TimeParamType, from_millis_ago?: any | null, to_millis_ago?: any | null, period_type?: PeriodType | null, from_periods_ago?: number | null, to_periods_ago?: number | null, start?: number | null, end?: number | null } | null, field_modifiers: Array<{ __typename?: 'ReportMetricModifier', category: MetricModifierCategory, column: string, not?: boolean | null, filterOp: FilterOp, value: { __typename?: 'MetricModifierValue', string?: string | null, stringArray?: Array<string> | null, float?: number | null, boolean?: boolean | null } }>, value_types: Array<{ __typename?: 'MetricValueParams', custom_label?: string | null, value_type: MetricValueType }>, report_template_metrics: Array<{ __typename?: 'ReportTemplateMetric', id: string, report_template: { __typename?: 'ReportTemplate', id: string, name: string, description?: string | null, is_active: boolean } }>, initiative_metrics: Array<{ __typename?: 'InitiativeMetric', id: string, initiative: { __typename?: 'Initiative', id: string, name: string, description?: string | null, start_time: number, is_archived: boolean } }>, kpi_group_metrics: Array<{ __typename?: 'KpiGroupMetric', id: string, kpi_group: { __typename?: 'KpiGroup', id: string, name: string, description?: string | null } }> } }>, repeat?: { __typename?: 'RepeatParams', frequency: any, unit: RepeatUnit, daysOfWeek?: Array<DayOfWeek> | null, daysOfMonth?: Array<number> | null, weekOfMonth?: WeekOfMonth | null } | null, organization_reports: Array<{ __typename?: 'OrganizationReport', id: string }>, time_params?: { __typename?: 'TimeParams', type: TimeParamType, from_millis_ago?: any | null, to_millis_ago?: any | null, period_type?: PeriodType | null, from_periods_ago?: number | null, to_periods_ago?: number | null, start?: number | null, end?: number | null } | null } };

export type UpdateReportTemplateMutationVariables = Exact<{
  id: Scalars['ID']['input'];
  data: UpdateReportTemplateInput;
}>;


export type UpdateReportTemplateMutation = { __typename?: 'Mutation', updateReportTemplate: { __typename?: 'ReportTemplate', id: string, name: string, description?: string | null, preferred_view_type?: ReportViewType | null, entity_structure?: Array<string> | null, last_run?: number | null, next_run?: number | null, is_active: boolean, created_at: number, updated_at: number, organization?: { __typename?: 'Organization', id: string } | null, template_clinics: Array<{ __typename?: 'TemplateClinic', id: string, clinic: { __typename?: 'Clinic', id: string, name?: string | null, time_zone?: string | null, slug?: string | null, address?: { __typename?: 'Address', street_a?: string | null, street_b?: string | null, city?: string | null, state?: string | null, zip?: string | null, country?: string | null } | null, hours?: { __typename?: 'AvailabilityHours', monday?: Array<{ __typename?: 'TimeInterval', start?: number | null, end?: number | null }> | null, tuesday?: Array<{ __typename?: 'TimeInterval', start?: number | null, end?: number | null }> | null, wednesday?: Array<{ __typename?: 'TimeInterval', start?: number | null, end?: number | null }> | null, thursday?: Array<{ __typename?: 'TimeInterval', start?: number | null, end?: number | null }> | null, friday?: Array<{ __typename?: 'TimeInterval', start?: number | null, end?: number | null }> | null, saturday?: Array<{ __typename?: 'TimeInterval', start?: number | null, end?: number | null }> | null, sunday?: Array<{ __typename?: 'TimeInterval', start?: number | null, end?: number | null }> | null } | null } }>, report_template_metrics: Array<{ __typename?: 'ReportTemplateMetric', id: string, order?: number | null, report_template: { __typename?: 'ReportTemplate', id: string, name: string, description?: string | null, is_active: boolean }, report_metric: { __typename?: 'ReportMetric', id: string, key: string, type: ReportMetricType, name: string, description?: string | null, definition_override?: string | null, custom_query?: any | null, special_modifier?: SpecialMetricModifierType | null, inverse_percentile?: boolean | null, format?: MetricFormat | null, time_field_override?: string | null, aggregate_field_override?: string | null, order: number, is_archived: boolean, time_params_overrides?: { __typename?: 'TimeParams', type: TimeParamType, from_millis_ago?: any | null, to_millis_ago?: any | null, period_type?: PeriodType | null, from_periods_ago?: number | null, to_periods_ago?: number | null, start?: number | null, end?: number | null } | null, field_modifiers: Array<{ __typename?: 'ReportMetricModifier', category: MetricModifierCategory, column: string, not?: boolean | null, filterOp: FilterOp, value: { __typename?: 'MetricModifierValue', string?: string | null, stringArray?: Array<string> | null, float?: number | null, boolean?: boolean | null } }>, value_types: Array<{ __typename?: 'MetricValueParams', custom_label?: string | null, value_type: MetricValueType }>, report_template_metrics: Array<{ __typename?: 'ReportTemplateMetric', id: string, report_template: { __typename?: 'ReportTemplate', id: string, name: string, description?: string | null, is_active: boolean } }>, initiative_metrics: Array<{ __typename?: 'InitiativeMetric', id: string, initiative: { __typename?: 'Initiative', id: string, name: string, description?: string | null, start_time: number, is_archived: boolean } }>, kpi_group_metrics: Array<{ __typename?: 'KpiGroupMetric', id: string, kpi_group: { __typename?: 'KpiGroup', id: string, name: string, description?: string | null } }> } }>, repeat?: { __typename?: 'RepeatParams', frequency: any, unit: RepeatUnit, daysOfWeek?: Array<DayOfWeek> | null, daysOfMonth?: Array<number> | null, weekOfMonth?: WeekOfMonth | null } | null, organization_reports: Array<{ __typename?: 'OrganizationReport', id: string }>, time_params?: { __typename?: 'TimeParams', type: TimeParamType, from_millis_ago?: any | null, to_millis_ago?: any | null, period_type?: PeriodType | null, from_periods_ago?: number | null, to_periods_ago?: number | null, start?: number | null, end?: number | null } | null } };

export type TemplateClinicClinicFieldsFragment = { __typename?: 'Clinic', id: string, name?: string | null, time_zone?: string | null, slug?: string | null, address?: { __typename?: 'Address', street_a?: string | null, street_b?: string | null, city?: string | null, state?: string | null, zip?: string | null, country?: string | null } | null, hours?: { __typename?: 'AvailabilityHours', monday?: Array<{ __typename?: 'TimeInterval', start?: number | null, end?: number | null }> | null, tuesday?: Array<{ __typename?: 'TimeInterval', start?: number | null, end?: number | null }> | null, wednesday?: Array<{ __typename?: 'TimeInterval', start?: number | null, end?: number | null }> | null, thursday?: Array<{ __typename?: 'TimeInterval', start?: number | null, end?: number | null }> | null, friday?: Array<{ __typename?: 'TimeInterval', start?: number | null, end?: number | null }> | null, saturday?: Array<{ __typename?: 'TimeInterval', start?: number | null, end?: number | null }> | null, sunday?: Array<{ __typename?: 'TimeInterval', start?: number | null, end?: number | null }> | null } | null };

export type TemplateClinicFieldsFragment = { __typename?: 'TemplateClinic', id: string, clinic: { __typename?: 'Clinic', id: string, name?: string | null, time_zone?: string | null, slug?: string | null, address?: { __typename?: 'Address', street_a?: string | null, street_b?: string | null, city?: string | null, state?: string | null, zip?: string | null, country?: string | null } | null, hours?: { __typename?: 'AvailabilityHours', monday?: Array<{ __typename?: 'TimeInterval', start?: number | null, end?: number | null }> | null, tuesday?: Array<{ __typename?: 'TimeInterval', start?: number | null, end?: number | null }> | null, wednesday?: Array<{ __typename?: 'TimeInterval', start?: number | null, end?: number | null }> | null, thursday?: Array<{ __typename?: 'TimeInterval', start?: number | null, end?: number | null }> | null, friday?: Array<{ __typename?: 'TimeInterval', start?: number | null, end?: number | null }> | null, saturday?: Array<{ __typename?: 'TimeInterval', start?: number | null, end?: number | null }> | null, sunday?: Array<{ __typename?: 'TimeInterval', start?: number | null, end?: number | null }> | null } | null } };

export type ClinicReportTemplateFieldsFragment = { __typename?: 'TemplateClinic', report_template: { __typename?: 'ReportTemplate', id: string, name: string, description?: string | null, preferred_view_type?: ReportViewType | null, entity_structure?: Array<string> | null, last_run?: number | null, next_run?: number | null, is_active: boolean, created_at: number, updated_at: number, organization?: { __typename?: 'Organization', id: string } | null, template_clinics: Array<{ __typename?: 'TemplateClinic', id: string, clinic: { __typename?: 'Clinic', id: string, name?: string | null, time_zone?: string | null, slug?: string | null, address?: { __typename?: 'Address', street_a?: string | null, street_b?: string | null, city?: string | null, state?: string | null, zip?: string | null, country?: string | null } | null, hours?: { __typename?: 'AvailabilityHours', monday?: Array<{ __typename?: 'TimeInterval', start?: number | null, end?: number | null }> | null, tuesday?: Array<{ __typename?: 'TimeInterval', start?: number | null, end?: number | null }> | null, wednesday?: Array<{ __typename?: 'TimeInterval', start?: number | null, end?: number | null }> | null, thursday?: Array<{ __typename?: 'TimeInterval', start?: number | null, end?: number | null }> | null, friday?: Array<{ __typename?: 'TimeInterval', start?: number | null, end?: number | null }> | null, saturday?: Array<{ __typename?: 'TimeInterval', start?: number | null, end?: number | null }> | null, sunday?: Array<{ __typename?: 'TimeInterval', start?: number | null, end?: number | null }> | null } | null } }>, report_template_metrics: Array<{ __typename?: 'ReportTemplateMetric', id: string, order?: number | null, report_template: { __typename?: 'ReportTemplate', id: string, name: string, description?: string | null, is_active: boolean }, report_metric: { __typename?: 'ReportMetric', id: string, key: string, type: ReportMetricType, name: string, description?: string | null, definition_override?: string | null, custom_query?: any | null, special_modifier?: SpecialMetricModifierType | null, inverse_percentile?: boolean | null, format?: MetricFormat | null, time_field_override?: string | null, aggregate_field_override?: string | null, order: number, is_archived: boolean, time_params_overrides?: { __typename?: 'TimeParams', type: TimeParamType, from_millis_ago?: any | null, to_millis_ago?: any | null, period_type?: PeriodType | null, from_periods_ago?: number | null, to_periods_ago?: number | null, start?: number | null, end?: number | null } | null, field_modifiers: Array<{ __typename?: 'ReportMetricModifier', category: MetricModifierCategory, column: string, not?: boolean | null, filterOp: FilterOp, value: { __typename?: 'MetricModifierValue', string?: string | null, stringArray?: Array<string> | null, float?: number | null, boolean?: boolean | null } }>, value_types: Array<{ __typename?: 'MetricValueParams', custom_label?: string | null, value_type: MetricValueType }>, report_template_metrics: Array<{ __typename?: 'ReportTemplateMetric', id: string, report_template: { __typename?: 'ReportTemplate', id: string, name: string, description?: string | null, is_active: boolean } }>, initiative_metrics: Array<{ __typename?: 'InitiativeMetric', id: string, initiative: { __typename?: 'Initiative', id: string, name: string, description?: string | null, start_time: number, is_archived: boolean } }>, kpi_group_metrics: Array<{ __typename?: 'KpiGroupMetric', id: string, kpi_group: { __typename?: 'KpiGroup', id: string, name: string, description?: string | null } }> } }>, repeat?: { __typename?: 'RepeatParams', frequency: any, unit: RepeatUnit, daysOfWeek?: Array<DayOfWeek> | null, daysOfMonth?: Array<number> | null, weekOfMonth?: WeekOfMonth | null } | null, organization_reports: Array<{ __typename?: 'OrganizationReport', id: string }>, time_params?: { __typename?: 'TimeParams', type: TimeParamType, from_millis_ago?: any | null, to_millis_ago?: any | null, period_type?: PeriodType | null, from_periods_ago?: number | null, to_periods_ago?: number | null, start?: number | null, end?: number | null } | null } };

export type GetTemplatesForClinicReportsQueryVariables = Exact<{
  clinic: Scalars['ID']['input'];
}>;


export type GetTemplatesForClinicReportsQuery = { __typename?: 'Query', getTemplatesForClinicReports: Array<{ __typename?: 'TemplateClinic', report_template: { __typename?: 'ReportTemplate', id: string, name: string, description?: string | null, preferred_view_type?: ReportViewType | null, entity_structure?: Array<string> | null, last_run?: number | null, next_run?: number | null, is_active: boolean, created_at: number, updated_at: number, organization?: { __typename?: 'Organization', id: string } | null, template_clinics: Array<{ __typename?: 'TemplateClinic', id: string, clinic: { __typename?: 'Clinic', id: string, name?: string | null, time_zone?: string | null, slug?: string | null, address?: { __typename?: 'Address', street_a?: string | null, street_b?: string | null, city?: string | null, state?: string | null, zip?: string | null, country?: string | null } | null, hours?: { __typename?: 'AvailabilityHours', monday?: Array<{ __typename?: 'TimeInterval', start?: number | null, end?: number | null }> | null, tuesday?: Array<{ __typename?: 'TimeInterval', start?: number | null, end?: number | null }> | null, wednesday?: Array<{ __typename?: 'TimeInterval', start?: number | null, end?: number | null }> | null, thursday?: Array<{ __typename?: 'TimeInterval', start?: number | null, end?: number | null }> | null, friday?: Array<{ __typename?: 'TimeInterval', start?: number | null, end?: number | null }> | null, saturday?: Array<{ __typename?: 'TimeInterval', start?: number | null, end?: number | null }> | null, sunday?: Array<{ __typename?: 'TimeInterval', start?: number | null, end?: number | null }> | null } | null } }>, report_template_metrics: Array<{ __typename?: 'ReportTemplateMetric', id: string, order?: number | null, report_template: { __typename?: 'ReportTemplate', id: string, name: string, description?: string | null, is_active: boolean }, report_metric: { __typename?: 'ReportMetric', id: string, key: string, type: ReportMetricType, name: string, description?: string | null, definition_override?: string | null, custom_query?: any | null, special_modifier?: SpecialMetricModifierType | null, inverse_percentile?: boolean | null, format?: MetricFormat | null, time_field_override?: string | null, aggregate_field_override?: string | null, order: number, is_archived: boolean, time_params_overrides?: { __typename?: 'TimeParams', type: TimeParamType, from_millis_ago?: any | null, to_millis_ago?: any | null, period_type?: PeriodType | null, from_periods_ago?: number | null, to_periods_ago?: number | null, start?: number | null, end?: number | null } | null, field_modifiers: Array<{ __typename?: 'ReportMetricModifier', category: MetricModifierCategory, column: string, not?: boolean | null, filterOp: FilterOp, value: { __typename?: 'MetricModifierValue', string?: string | null, stringArray?: Array<string> | null, float?: number | null, boolean?: boolean | null } }>, value_types: Array<{ __typename?: 'MetricValueParams', custom_label?: string | null, value_type: MetricValueType }>, report_template_metrics: Array<{ __typename?: 'ReportTemplateMetric', id: string, report_template: { __typename?: 'ReportTemplate', id: string, name: string, description?: string | null, is_active: boolean } }>, initiative_metrics: Array<{ __typename?: 'InitiativeMetric', id: string, initiative: { __typename?: 'Initiative', id: string, name: string, description?: string | null, start_time: number, is_archived: boolean } }>, kpi_group_metrics: Array<{ __typename?: 'KpiGroupMetric', id: string, kpi_group: { __typename?: 'KpiGroup', id: string, name: string, description?: string | null } }> } }>, repeat?: { __typename?: 'RepeatParams', frequency: any, unit: RepeatUnit, daysOfWeek?: Array<DayOfWeek> | null, daysOfMonth?: Array<number> | null, weekOfMonth?: WeekOfMonth | null } | null, organization_reports: Array<{ __typename?: 'OrganizationReport', id: string }>, time_params?: { __typename?: 'TimeParams', type: TimeParamType, from_millis_ago?: any | null, to_millis_ago?: any | null, period_type?: PeriodType | null, from_periods_ago?: number | null, to_periods_ago?: number | null, start?: number | null, end?: number | null } | null } }> };

export type CreateTemplateClinicMutationVariables = Exact<{
  data: CreateTemplateClinicInput;
}>;


export type CreateTemplateClinicMutation = { __typename?: 'Mutation', createTemplateClinic: { __typename?: 'TemplateClinic', id: string, clinic: { __typename?: 'Clinic', id: string, name?: string | null, time_zone?: string | null, slug?: string | null, address?: { __typename?: 'Address', street_a?: string | null, street_b?: string | null, city?: string | null, state?: string | null, zip?: string | null, country?: string | null } | null, hours?: { __typename?: 'AvailabilityHours', monday?: Array<{ __typename?: 'TimeInterval', start?: number | null, end?: number | null }> | null, tuesday?: Array<{ __typename?: 'TimeInterval', start?: number | null, end?: number | null }> | null, wednesday?: Array<{ __typename?: 'TimeInterval', start?: number | null, end?: number | null }> | null, thursday?: Array<{ __typename?: 'TimeInterval', start?: number | null, end?: number | null }> | null, friday?: Array<{ __typename?: 'TimeInterval', start?: number | null, end?: number | null }> | null, saturday?: Array<{ __typename?: 'TimeInterval', start?: number | null, end?: number | null }> | null, sunday?: Array<{ __typename?: 'TimeInterval', start?: number | null, end?: number | null }> | null } | null } } };

export type DeleteTemplateClinicMutationVariables = Exact<{
  id: Scalars['ID']['input'];
}>;


export type DeleteTemplateClinicMutation = { __typename?: 'Mutation', deleteTemplateClinic?: any | null };

export type TrendReportFieldsFragment = { __typename?: 'TrendReport', scope: TrendReportScope, trend_segments: Array<{ __typename?: 'TrendSegment', values: Array<any>, time_range: { __typename?: 'TrendTimeRange', label: string, start_time: number, end_time: number } }> };

export type TrendTimeRangeFieldsFragment = { __typename?: 'TrendTimeRange', label: string, start_time: number, end_time: number };

export type TrendSegmentFieldsFragment = { __typename?: 'TrendSegment', values: Array<any>, time_range: { __typename?: 'TrendTimeRange', label: string, start_time: number, end_time: number } };

export type GetTrendReportQueryVariables = Exact<{
  params: TrendReportParams;
}>;


export type GetTrendReportQuery = { __typename?: 'Query', getTrendReport: { __typename?: 'TrendReport', scope: TrendReportScope, trend_segments: Array<{ __typename?: 'TrendSegment', values: Array<any>, time_range: { __typename?: 'TrendTimeRange', label: string, start_time: number, end_time: number } }> } };

export type GetTrendClinicItemQueryVariables = Exact<{
  id: Scalars['ID']['input'];
}>;


export type GetTrendClinicItemQuery = { __typename?: 'Query', clinic: { __typename?: 'Clinic', id: string, name?: string | null, slug?: string | null } };

export type EntityLinkFieldsFragment = { __typename?: 'EntityLink', id: string, entity_type: EntityLinkType, clinic: string, parent_id: string, child_id?: string | null, unlinked_at?: number | null, unlinked_by?: string | null, unlinked_fields: Array<string>, created_at: number, updated_at: number };

export type EntityLinksForParentQueryVariables = Exact<{
  entityType: EntityLinkType;
  parentId: Scalars['ID']['input'];
}>;


export type EntityLinksForParentQuery = { __typename?: 'Query', entityLinksForParent: Array<{ __typename?: 'EntityLink', id: string, entity_type: EntityLinkType, clinic: string, parent_id: string, child_id?: string | null, unlinked_at?: number | null, unlinked_by?: string | null, unlinked_fields: Array<string>, created_at: number, updated_at: number }> };

export type EntityLinkSummaryQueryVariables = Exact<{
  entityType: EntityLinkType;
  parentId: Scalars['ID']['input'];
}>;


export type EntityLinkSummaryQuery = { __typename?: 'Query', entityLinkSummary: { __typename?: 'EntityLinkSummary', linked_count: number, unlinked_count: number, never_linked_clinic_ids: Array<string> } };

export type EntityLinkForChildQueryVariables = Exact<{
  entityType: EntityLinkType;
  childId: Scalars['ID']['input'];
}>;


export type EntityLinkForChildQuery = { __typename?: 'Query', entityLinkForChild?: { __typename?: 'EntityLink', id: string, entity_type: EntityLinkType, clinic: string, parent_id: string, child_id?: string | null, unlinked_at?: number | null, unlinked_by?: string | null, unlinked_fields: Array<string>, created_at: number, updated_at: number } | null };

export type EntityLinkFieldsChangedByUpdateQueryVariables = Exact<{
  entityType: EntityLinkType;
  childId: Scalars['ID']['input'];
  data: Scalars['JSON']['input'];
}>;


export type EntityLinkFieldsChangedByUpdateQuery = { __typename?: 'Query', entityLinkFieldsChangedByUpdate: Array<string> };

export type EntityLinksForClinicQueryVariables = Exact<{
  entityType: EntityLinkType;
  clinicId: Scalars['ID']['input'];
}>;


export type EntityLinksForClinicQuery = { __typename?: 'Query', entityLinksForClinic: Array<{ __typename?: 'EntityLink', id: string, entity_type: EntityLinkType, clinic: string, parent_id: string, child_id?: string | null, unlinked_at?: number | null, unlinked_by?: string | null, unlinked_fields: Array<string>, created_at: number, updated_at: number }> };

export type EntityLinkFieldPoliciesQueryVariables = Exact<{ [key: string]: never; }>;


export type EntityLinkFieldPoliciesQuery = { __typename?: 'Query', entityLinkFieldPolicies: Array<{ __typename?: 'EntityLinkFieldPolicy', entity_type: EntityLinkType, governed_fields: Array<string>, locally_assignable_fields: Array<string>, remapped_fields: Array<string>, unlinks_per_field: boolean, link_categories: Array<{ __typename?: 'EntityLinkFieldCategory', key: string, label: string, fields: Array<string> }> }> };

export type ClinicSettingsFieldValuesForClinicGroupQueryVariables = Exact<{
  clinicGroupId: Scalars['ID']['input'];
  fields: Array<Scalars['String']['input']> | Scalars['String']['input'];
}>;


export type ClinicSettingsFieldValuesForClinicGroupQuery = { __typename?: 'Query', clinicSettingsFieldValuesForClinicGroup: Array<{ __typename?: 'ClinicSettingsFieldValues', clinic_id: string, values: any }> };

export type EntityLinkCoverageForClinicGroupQueryVariables = Exact<{
  clinicGroupId: Scalars['ID']['input'];
}>;


export type EntityLinkCoverageForClinicGroupQuery = { __typename?: 'Query', entityLinkCoverageForClinicGroup: Array<{ __typename?: 'ClinicEntityLinkCoverage', clinic_id: string, clinic_name: string, total_linked: number, total_parents: number, has_settings_link: boolean, types: Array<{ __typename?: 'EntityLinkTypeCoverage', entity_type: EntityLinkType, parent_count: number, linked_count: number, unlinked_count: number }> }> };

export type EntityLinkCoverageDetailsForClinicQueryVariables = Exact<{
  clinicGroupId: Scalars['ID']['input'];
  clinicId: Scalars['ID']['input'];
  entityTypes?: InputMaybe<Array<EntityLinkType> | EntityLinkType>;
}>;


export type EntityLinkCoverageDetailsForClinicQuery = { __typename?: 'Query', entityLinkCoverageDetailsForClinic: Array<{ __typename?: 'EntityLinkCoverageDetail', entity_type: EntityLinkType, parent_id: string, parent_name: string, status: EntityLinkCoverageStatus, unlinked_fields: Array<string>, child_id?: string | null }> };

export type UnlinkEntityMutationVariables = Exact<{
  entityType: EntityLinkType;
  childId: Scalars['ID']['input'];
}>;


export type UnlinkEntityMutation = { __typename?: 'Mutation', unlinkEntity: { __typename?: 'EntityLink', id: string, entity_type: EntityLinkType, clinic: string, parent_id: string, child_id?: string | null, unlinked_at?: number | null, unlinked_by?: string | null, unlinked_fields: Array<string>, created_at: number, updated_at: number } };

export type RelinkEntityMutationVariables = Exact<{
  entityType: EntityLinkType;
  childId: Scalars['ID']['input'];
}>;


export type RelinkEntityMutation = { __typename?: 'Mutation', relinkEntity: { __typename?: 'EntityLink', id: string, entity_type: EntityLinkType, clinic: string, parent_id: string, child_id?: string | null, unlinked_at?: number | null, unlinked_by?: string | null, unlinked_fields: Array<string>, created_at: number, updated_at: number } };

export type UnlinkEntityFieldsMutationVariables = Exact<{
  entityType: EntityLinkType;
  childId: Scalars['ID']['input'];
  fields: Array<Scalars['String']['input']> | Scalars['String']['input'];
}>;


export type UnlinkEntityFieldsMutation = { __typename?: 'Mutation', unlinkEntityFields: { __typename?: 'EntityLink', id: string, entity_type: EntityLinkType, clinic: string, parent_id: string, child_id?: string | null, unlinked_at?: number | null, unlinked_by?: string | null, unlinked_fields: Array<string>, created_at: number, updated_at: number } };

export type RelinkEntityFieldsMutationVariables = Exact<{
  entityType: EntityLinkType;
  childId: Scalars['ID']['input'];
  fields: Array<Scalars['String']['input']> | Scalars['String']['input'];
}>;


export type RelinkEntityFieldsMutation = { __typename?: 'Mutation', relinkEntityFields: { __typename?: 'EntityLink', id: string, entity_type: EntityLinkType, clinic: string, parent_id: string, child_id?: string | null, unlinked_at?: number | null, unlinked_by?: string | null, unlinked_fields: Array<string>, created_at: number, updated_at: number } };

export type PopulateEntityLinkChildrenMutationVariables = Exact<{
  entityType: EntityLinkType;
  parentId: Scalars['ID']['input'];
  clinicIds?: InputMaybe<Array<Scalars['ID']['input']> | Scalars['ID']['input']>;
  linkedFields?: InputMaybe<Array<Scalars['String']['input']> | Scalars['String']['input']>;
}>;


export type PopulateEntityLinkChildrenMutation = { __typename?: 'Mutation', populateEntityLinkChildren: Array<{ __typename?: 'EntityLink', id: string, entity_type: EntityLinkType, clinic: string, parent_id: string, child_id?: string | null, unlinked_at?: number | null, unlinked_by?: string | null, unlinked_fields: Array<string>, created_at: number, updated_at: number }> };

export type ExpandEntityLinkFieldsForClinicsMutationVariables = Exact<{
  entityType: EntityLinkType;
  parentId: Scalars['ID']['input'];
  clinicIds: Array<Scalars['ID']['input']> | Scalars['ID']['input'];
  fields: Array<Scalars['String']['input']> | Scalars['String']['input'];
}>;


export type ExpandEntityLinkFieldsForClinicsMutation = { __typename?: 'Mutation', expandEntityLinkFieldsForClinics: Array<{ __typename?: 'EntityLink', id: string, entity_type: EntityLinkType, clinic: string, parent_id: string, child_id?: string | null, unlinked_at?: number | null, unlinked_by?: string | null, unlinked_fields: Array<string>, created_at: number, updated_at: number }> };

export type UnlinkEntityFieldsForClinicsMutationVariables = Exact<{
  entityType: EntityLinkType;
  parentId: Scalars['ID']['input'];
  clinicIds: Array<Scalars['ID']['input']> | Scalars['ID']['input'];
  fields: Array<Scalars['String']['input']> | Scalars['String']['input'];
}>;


export type UnlinkEntityFieldsForClinicsMutation = { __typename?: 'Mutation', unlinkEntityFieldsForClinics: Array<{ __typename?: 'EntityLink', id: string, entity_type: EntityLinkType, clinic: string, parent_id: string, child_id?: string | null, unlinked_at?: number | null, unlinked_by?: string | null, unlinked_fields: Array<string>, created_at: number, updated_at: number }> };

export type InitializeEntityLinksForClinicMutationVariables = Exact<{
  clinicGroupId: Scalars['ID']['input'];
  clinicId: Scalars['ID']['input'];
  entityTypes?: InputMaybe<Array<EntityLinkType> | EntityLinkType>;
}>;


export type InitializeEntityLinksForClinicMutation = { __typename?: 'Mutation', initializeEntityLinksForClinic: Array<{ __typename?: 'EntityLink', id: string, entity_type: EntityLinkType, clinic: string, parent_id: string, child_id?: string | null, unlinked_at?: number | null, unlinked_by?: string | null, unlinked_fields: Array<string>, created_at: number, updated_at: number }> };

export type InitializeEntityLinksForEntityTypeMutationVariables = Exact<{
  clinicGroupId: Scalars['ID']['input'];
  entityType: EntityLinkType;
  clinicIds?: InputMaybe<Array<Scalars['ID']['input']> | Scalars['ID']['input']>;
}>;


export type InitializeEntityLinksForEntityTypeMutation = { __typename?: 'Mutation', initializeEntityLinksForEntityType: Array<{ __typename?: 'EntityLink', id: string, entity_type: EntityLinkType, clinic: string, parent_id: string, child_id?: string | null, unlinked_at?: number | null, unlinked_by?: string | null, unlinked_fields: Array<string>, created_at: number, updated_at: number }> };

export type FormElementFieldsFragment = { __typename?: 'FormElement', id: string, type?: FormElementType | null, content?: string | null, name?: string | null, column_order?: number | null, row_order?: number | null, page_id?: string | null, options?: Array<string> | null, is_required?: boolean | null, value?: string | null, attachments?: Array<{ __typename?: 'FormFileAttachment', id?: string | null, filename?: string | null, mime_type?: string | null, size_bytes?: number | null, thumbnail_url?: string | null, url: string }> | null, field_updates?: Array<{ __typename?: 'FormFieldUpdate', field: FormFieldUpdateField, boolean_value?: boolean | null, option?: string | null }> | null };

export type FormPageFieldsFragment = { __typename?: 'FormPage', id: string, title?: string | null, description?: string | null, order?: number | null };

export type FormFieldsFragment = { __typename?: 'Form', id: string, name?: string | null, form_type: FormType, is_public: boolean, is_active: boolean, is_archived: boolean, does_require_client: boolean, does_require_patient: boolean, writeback_to_strictest_entity: boolean, is_writeback_enabled: boolean, writeback_code_pms_id?: string | null, writeback_code_name?: string | null, form_file_naming_template?: string | null, created_at: number, updated_at: number, clinic?: { __typename?: 'Clinic', id: string } | null, form_fields: { __typename?: 'FormFields', pages?: Array<{ __typename?: 'FormPage', id: string, title?: string | null, description?: string | null, order?: number | null }> | null, fields?: Array<{ __typename?: 'FormElement', id: string, type?: FormElementType | null, content?: string | null, name?: string | null, column_order?: number | null, row_order?: number | null, page_id?: string | null, options?: Array<string> | null, is_required?: boolean | null, value?: string | null, attachments?: Array<{ __typename?: 'FormFileAttachment', id?: string | null, filename?: string | null, mime_type?: string | null, size_bytes?: number | null, thumbnail_url?: string | null, url: string }> | null, field_updates?: Array<{ __typename?: 'FormFieldUpdate', field: FormFieldUpdateField, boolean_value?: boolean | null, option?: string | null }> | null }> | null } };

export type FormPreviewFieldsFragment = { __typename?: 'Form', id: string, name?: string | null };

export type FormAnalyticsFieldsFragment = { __typename?: 'FormAnalytics', form: { __typename?: 'Form', id: string, name?: string | null }, field_analytics: Array<{ __typename?: 'FormAnalyticsFieldResult', element_id: string, element_name?: string | null, type: FormElementType, value_counts: Array<{ __typename?: 'FormFieldValueCount', value: string, count: number }> }> };

export type GetFormQueryVariables = Exact<{
  id: Scalars['ID']['input'];
}>;


export type GetFormQuery = { __typename?: 'Query', form: { __typename?: 'Form', id: string, name?: string | null, form_type: FormType, is_public: boolean, is_active: boolean, is_archived: boolean, does_require_client: boolean, does_require_patient: boolean, writeback_to_strictest_entity: boolean, is_writeback_enabled: boolean, writeback_code_pms_id?: string | null, writeback_code_name?: string | null, form_file_naming_template?: string | null, created_at: number, updated_at: number, clinic?: { __typename?: 'Clinic', id: string } | null, form_fields: { __typename?: 'FormFields', pages?: Array<{ __typename?: 'FormPage', id: string, title?: string | null, description?: string | null, order?: number | null }> | null, fields?: Array<{ __typename?: 'FormElement', id: string, type?: FormElementType | null, content?: string | null, name?: string | null, column_order?: number | null, row_order?: number | null, page_id?: string | null, options?: Array<string> | null, is_required?: boolean | null, value?: string | null, attachments?: Array<{ __typename?: 'FormFileAttachment', id?: string | null, filename?: string | null, mime_type?: string | null, size_bytes?: number | null, thumbnail_url?: string | null, url: string }> | null, field_updates?: Array<{ __typename?: 'FormFieldUpdate', field: FormFieldUpdateField, boolean_value?: boolean | null, option?: string | null }> | null }> | null } } };

export type QueryFormsQueryVariables = Exact<{
  where?: InputMaybe<Array<QueryInput> | QueryInput>;
  page?: InputMaybe<Scalars['NonNegativeInt']['input']>;
  pageSize?: InputMaybe<Scalars['NonNegativeInt']['input']>;
  orderBy?: InputMaybe<OrderByInput>;
}>;


export type QueryFormsQuery = { __typename?: 'Query', queryForms: Array<{ __typename?: 'Form', id: string, name?: string | null, form_type: FormType, is_public: boolean, is_active: boolean, is_archived: boolean, does_require_client: boolean, does_require_patient: boolean, writeback_to_strictest_entity: boolean, is_writeback_enabled: boolean, writeback_code_pms_id?: string | null, writeback_code_name?: string | null, form_file_naming_template?: string | null, created_at: number, updated_at: number, clinic?: { __typename?: 'Clinic', id: string } | null, form_fields: { __typename?: 'FormFields', pages?: Array<{ __typename?: 'FormPage', id: string, title?: string | null, description?: string | null, order?: number | null }> | null, fields?: Array<{ __typename?: 'FormElement', id: string, type?: FormElementType | null, content?: string | null, name?: string | null, column_order?: number | null, row_order?: number | null, page_id?: string | null, options?: Array<string> | null, is_required?: boolean | null, value?: string | null, attachments?: Array<{ __typename?: 'FormFileAttachment', id?: string | null, filename?: string | null, mime_type?: string | null, size_bytes?: number | null, thumbnail_url?: string | null, url: string }> | null, field_updates?: Array<{ __typename?: 'FormFieldUpdate', field: FormFieldUpdateField, boolean_value?: boolean | null, option?: string | null }> | null }> | null } }> };

export type CountFormsQueryVariables = Exact<{
  where?: InputMaybe<Array<QueryInput> | QueryInput>;
}>;


export type CountFormsQuery = { __typename?: 'Query', countForms: number };

export type GetPdfUrlForFormQueryVariables = Exact<{
  formId: Scalars['ID']['input'];
}>;


export type GetPdfUrlForFormQuery = { __typename?: 'Query', getPdfUrlForForm: string };

export type CreateFormMutationVariables = Exact<{
  data: CreateFormInput;
}>;


export type CreateFormMutation = { __typename?: 'Mutation', createForm: { __typename?: 'Form', id: string, name?: string | null, form_type: FormType, is_public: boolean, is_active: boolean, is_archived: boolean, does_require_client: boolean, does_require_patient: boolean, writeback_to_strictest_entity: boolean, is_writeback_enabled: boolean, writeback_code_pms_id?: string | null, writeback_code_name?: string | null, form_file_naming_template?: string | null, created_at: number, updated_at: number, clinic?: { __typename?: 'Clinic', id: string } | null, form_fields: { __typename?: 'FormFields', pages?: Array<{ __typename?: 'FormPage', id: string, title?: string | null, description?: string | null, order?: number | null }> | null, fields?: Array<{ __typename?: 'FormElement', id: string, type?: FormElementType | null, content?: string | null, name?: string | null, column_order?: number | null, row_order?: number | null, page_id?: string | null, options?: Array<string> | null, is_required?: boolean | null, value?: string | null, attachments?: Array<{ __typename?: 'FormFileAttachment', id?: string | null, filename?: string | null, mime_type?: string | null, size_bytes?: number | null, thumbnail_url?: string | null, url: string }> | null, field_updates?: Array<{ __typename?: 'FormFieldUpdate', field: FormFieldUpdateField, boolean_value?: boolean | null, option?: string | null }> | null }> | null } } };

export type UpdateFormMutationVariables = Exact<{
  id: Scalars['ID']['input'];
  data: UpdateFormInput;
}>;


export type UpdateFormMutation = { __typename?: 'Mutation', updateForm: { __typename?: 'Form', id: string, name?: string | null, form_type: FormType, is_public: boolean, is_active: boolean, is_archived: boolean, does_require_client: boolean, does_require_patient: boolean, writeback_to_strictest_entity: boolean, is_writeback_enabled: boolean, writeback_code_pms_id?: string | null, writeback_code_name?: string | null, form_file_naming_template?: string | null, created_at: number, updated_at: number, clinic?: { __typename?: 'Clinic', id: string } | null, form_fields: { __typename?: 'FormFields', pages?: Array<{ __typename?: 'FormPage', id: string, title?: string | null, description?: string | null, order?: number | null }> | null, fields?: Array<{ __typename?: 'FormElement', id: string, type?: FormElementType | null, content?: string | null, name?: string | null, column_order?: number | null, row_order?: number | null, page_id?: string | null, options?: Array<string> | null, is_required?: boolean | null, value?: string | null, attachments?: Array<{ __typename?: 'FormFileAttachment', id?: string | null, filename?: string | null, mime_type?: string | null, size_bytes?: number | null, thumbnail_url?: string | null, url: string }> | null, field_updates?: Array<{ __typename?: 'FormFieldUpdate', field: FormFieldUpdateField, boolean_value?: boolean | null, option?: string | null }> | null }> | null } } };

export type GetFormsForClinicQueryVariables = Exact<{
  clinicId: Scalars['ID']['input'];
}>;


export type GetFormsForClinicQuery = { __typename?: 'Query', getFormsForClinic: Array<{ __typename?: 'Form', id: string, name?: string | null, form_type: FormType, is_public: boolean, is_active: boolean, is_archived: boolean, does_require_client: boolean, does_require_patient: boolean, writeback_to_strictest_entity: boolean, is_writeback_enabled: boolean, writeback_code_pms_id?: string | null, writeback_code_name?: string | null, form_file_naming_template?: string | null, created_at: number, updated_at: number, clinic?: { __typename?: 'Clinic', id: string } | null, form_fields: { __typename?: 'FormFields', pages?: Array<{ __typename?: 'FormPage', id: string, title?: string | null, description?: string | null, order?: number | null }> | null, fields?: Array<{ __typename?: 'FormElement', id: string, type?: FormElementType | null, content?: string | null, name?: string | null, column_order?: number | null, row_order?: number | null, page_id?: string | null, options?: Array<string> | null, is_required?: boolean | null, value?: string | null, attachments?: Array<{ __typename?: 'FormFileAttachment', id?: string | null, filename?: string | null, mime_type?: string | null, size_bytes?: number | null, thumbnail_url?: string | null, url: string }> | null, field_updates?: Array<{ __typename?: 'FormFieldUpdate', field: FormFieldUpdateField, boolean_value?: boolean | null, option?: string | null }> | null }> | null } }> };

export type GetAnalyticsForFormsQueryVariables = Exact<{
  formIds: Array<Scalars['ID']['input']> | Scalars['ID']['input'];
  params?: InputMaybe<FormAnalyticsParams>;
}>;


export type GetAnalyticsForFormsQuery = { __typename?: 'Query', getAnalyticsForForms: Array<{ __typename?: 'FormAnalytics', form: { __typename?: 'Form', id: string, name?: string | null }, field_analytics: Array<{ __typename?: 'FormAnalyticsFieldResult', element_id: string, element_name?: string | null, type: FormElementType, value_counts: Array<{ __typename?: 'FormFieldValueCount', value: string, count: number }> }> }> };

export type ConvertPdfToFormElementsMutationVariables = Exact<{
  data: ConvertPdfToFormInput;
}>;


export type ConvertPdfToFormElementsMutation = { __typename?: 'Mutation', convertPdfToFormElements: { __typename?: 'ConvertPdfToFormResult', success: boolean, error?: string | null, elements: Array<{ __typename?: 'FormElement', id: string, type?: FormElementType | null, content?: string | null, name?: string | null, column_order?: number | null, row_order?: number | null, page_id?: string | null, options?: Array<string> | null, is_required?: boolean | null, value?: string | null, attachments?: Array<{ __typename?: 'FormFileAttachment', id?: string | null, filename?: string | null, mime_type?: string | null, size_bytes?: number | null, thumbnail_url?: string | null, url: string }> | null, field_updates?: Array<{ __typename?: 'FormFieldUpdate', field: FormFieldUpdateField, boolean_value?: boolean | null, option?: string | null }> | null }> } };

export type GoalsFieldsFragment = { __typename?: 'Goal', id: string, description?: string | null, created_at: number, is_active?: boolean | null, is_chckup_modifier?: boolean | null, is_new_modifier?: boolean | null, is_system?: boolean | null, last_synced_time?: number | null, metric_current_amount: number, metric_entity: GoalEntity, metric_target_amount: number, metric_timespan: GoalTimespan, status: GoalStatus, updated_at: number, clinic: { __typename?: 'Clinic', id: string } };

export type GetGoalByClinicAndIdQueryVariables = Exact<{
  clinicId: Scalars['ID']['input'];
  goalId: Scalars['ID']['input'];
}>;


export type GetGoalByClinicAndIdQuery = { __typename?: 'Query', goal: { __typename?: 'Goal', id: string, description?: string | null, created_at: number, is_active?: boolean | null, is_chckup_modifier?: boolean | null, is_new_modifier?: boolean | null, is_system?: boolean | null, last_synced_time?: number | null, metric_current_amount: number, metric_entity: GoalEntity, metric_target_amount: number, metric_timespan: GoalTimespan, status: GoalStatus, updated_at: number, clinic: { __typename?: 'Clinic', id: string } } };

export type GetGoalsByClinicQueryVariables = Exact<{
  clinicId: Scalars['ID']['input'];
}>;


export type GetGoalsByClinicQuery = { __typename?: 'Query', getGoalsByClinic: Array<{ __typename?: 'Goal', id: string, description?: string | null, created_at: number, is_active?: boolean | null, is_chckup_modifier?: boolean | null, is_new_modifier?: boolean | null, is_system?: boolean | null, last_synced_time?: number | null, metric_current_amount: number, metric_entity: GoalEntity, metric_target_amount: number, metric_timespan: GoalTimespan, status: GoalStatus, updated_at: number, clinic: { __typename?: 'Clinic', id: string } }> };

export type CreateGoalMutationVariables = Exact<{
  clinicId: Scalars['ID']['input'];
  data: CreateGoalInput;
}>;


export type CreateGoalMutation = { __typename?: 'Mutation', createGoal: { __typename?: 'Goal', id: string, description?: string | null, created_at: number, is_active?: boolean | null, is_chckup_modifier?: boolean | null, is_new_modifier?: boolean | null, is_system?: boolean | null, last_synced_time?: number | null, metric_current_amount: number, metric_entity: GoalEntity, metric_target_amount: number, metric_timespan: GoalTimespan, status: GoalStatus, updated_at: number, clinic: { __typename?: 'Clinic', id: string } } };

export type UpdateGoalMutationVariables = Exact<{
  clinicId: Scalars['ID']['input'];
  goalId: Scalars['ID']['input'];
  data: UpdateGoalInput;
}>;


export type UpdateGoalMutation = { __typename?: 'Mutation', updateGoal: { __typename?: 'Goal', id: string, description?: string | null, created_at: number, is_active?: boolean | null, is_chckup_modifier?: boolean | null, is_new_modifier?: boolean | null, is_system?: boolean | null, last_synced_time?: number | null, metric_current_amount: number, metric_entity: GoalEntity, metric_target_amount: number, metric_timespan: GoalTimespan, status: GoalStatus, updated_at: number, clinic: { __typename?: 'Clinic', id: string } } };

export type DeleteGoalMutationVariables = Exact<{
  clinicId: Scalars['ID']['input'];
  goalId: Scalars['ID']['input'];
}>;


export type DeleteGoalMutation = { __typename?: 'Mutation', deleteGoal?: any | null };

export type InternalChatMessageAttachmentFieldsFragment = { __typename?: 'InternalChatMessageAttachment', id: string, url: string, filename: string, type: string };

export type InternalChatMessageFieldsFragment = { __typename?: 'InternalChatMessage', id: string, text: string, created_at: number, updated_at: number, internal_chat: { __typename?: 'InternalChat', id: string, title?: string | null }, sender: { __typename?: 'InternalChatUser', user: { __typename?: 'User', id: string, first_name?: string | null, last_name?: string | null, email?: any | null, phone?: string | null, avatar_url?: string | null }, internal_chat: { __typename?: 'InternalChat', id: string } }, internal_chat_messages_attachments?: Array<{ __typename?: 'InternalChatMessageAttachment', id: string, url: string, filename: string, type: string }> | null };

export type InternalChatMessagesQueryVariables = Exact<{
  chatId: Scalars['ID']['input'];
  page?: InputMaybe<Scalars['NonNegativeInt']['input']>;
  pageSize?: InputMaybe<Scalars['NonNegativeInt']['input']>;
}>;


export type InternalChatMessagesQuery = { __typename?: 'Query', internalChatMessages: Array<{ __typename?: 'InternalChatMessage', id: string, text: string, created_at: number, updated_at: number, internal_chat: { __typename?: 'InternalChat', id: string, title?: string | null }, sender: { __typename?: 'InternalChatUser', user: { __typename?: 'User', id: string, first_name?: string | null, last_name?: string | null, email?: any | null, phone?: string | null, avatar_url?: string | null }, internal_chat: { __typename?: 'InternalChat', id: string } }, internal_chat_messages_attachments?: Array<{ __typename?: 'InternalChatMessageAttachment', id: string, url: string, filename: string, type: string }> | null }> };

export type CreateInternalChatMessageMutationVariables = Exact<{
  data: CreateInternalChatMessageInput;
}>;


export type CreateInternalChatMessageMutation = { __typename?: 'Mutation', createInternalChatMessage: { __typename?: 'InternalChatMessage', id: string, text: string, created_at: number, updated_at: number, internal_chat: { __typename?: 'InternalChat', id: string, title?: string | null }, sender: { __typename?: 'InternalChatUser', user: { __typename?: 'User', id: string, first_name?: string | null, last_name?: string | null, email?: any | null, phone?: string | null, avatar_url?: string | null }, internal_chat: { __typename?: 'InternalChat', id: string } }, internal_chat_messages_attachments?: Array<{ __typename?: 'InternalChatMessageAttachment', id: string, url: string, filename: string, type: string }> | null } };

export type UpdateInternalChatMessageMutationVariables = Exact<{
  id: Scalars['ID']['input'];
  data: UpdateInternalChatMessageInput;
}>;


export type UpdateInternalChatMessageMutation = { __typename?: 'Mutation', updateInternalChatMessage: { __typename?: 'InternalChatMessage', id: string, text: string, created_at: number, updated_at: number, internal_chat: { __typename?: 'InternalChat', id: string, title?: string | null }, sender: { __typename?: 'InternalChatUser', user: { __typename?: 'User', id: string, first_name?: string | null, last_name?: string | null, email?: any | null, phone?: string | null, avatar_url?: string | null }, internal_chat: { __typename?: 'InternalChat', id: string } }, internal_chat_messages_attachments?: Array<{ __typename?: 'InternalChatMessageAttachment', id: string, url: string, filename: string, type: string }> | null } };

export type DeleteInternalChatMessageMutationVariables = Exact<{
  id: Scalars['ID']['input'];
}>;


export type DeleteInternalChatMessageMutation = { __typename?: 'Mutation', deleteInternalChatMessage?: any | null };

export type InternalChatUserFieldsFragment = { __typename?: 'InternalChatUser', id: string, last_read_time: number, last_message_time: number, unread_message_count: number, is_removed: boolean, created_at: number, updated_at: number, user: { __typename?: 'User', id: string, first_name?: string | null, last_name?: string | null, email?: any | null, phone?: string | null, avatar_url?: string | null }, internal_chat: { __typename?: 'InternalChat', id: string, title?: string | null, message_count: number, last_message?: string | null, last_message_time: number, is_deleted: boolean, created_at: number, updated_at: number, clinic?: { __typename?: 'Clinic', id: string, name?: string | null, avatar_url?: string | null } | null, clinicGroup?: { __typename?: 'ClinicGroup', id: string, name: string } | null, internal_chat_users: Array<{ __typename?: 'InternalChatUser', id: string, last_read_time: number, last_message_time: number, unread_message_count: number, is_removed: boolean, created_at: number, updated_at: number, user: { __typename?: 'User', id: string, first_name?: string | null, last_name?: string | null, avatar_url?: string | null } }> } };

export type InternalChatUserPreviewFieldsFragment = { __typename?: 'InternalChatUser', id: string, last_read_time: number, last_message_time: number, unread_message_count: number, is_removed: boolean, created_at: number, updated_at: number, user: { __typename?: 'User', id: string, first_name?: string | null, last_name?: string | null, avatar_url?: string | null } };

export type InternalChatUsersQueryVariables = Exact<{
  chatId: Scalars['ID']['input'];
}>;


export type InternalChatUsersQuery = { __typename?: 'Query', internalChatUsers: Array<{ __typename?: 'InternalChatUser', id: string, last_read_time: number, last_message_time: number, unread_message_count: number, is_removed: boolean, created_at: number, updated_at: number, user: { __typename?: 'User', id: string, first_name?: string | null, last_name?: string | null, email?: any | null, phone?: string | null, avatar_url?: string | null }, internal_chat: { __typename?: 'InternalChat', id: string, title?: string | null, message_count: number, last_message?: string | null, last_message_time: number, is_deleted: boolean, created_at: number, updated_at: number, clinic?: { __typename?: 'Clinic', id: string, name?: string | null, avatar_url?: string | null } | null, clinicGroup?: { __typename?: 'ClinicGroup', id: string, name: string } | null, internal_chat_users: Array<{ __typename?: 'InternalChatUser', id: string, last_read_time: number, last_message_time: number, unread_message_count: number, is_removed: boolean, created_at: number, updated_at: number, user: { __typename?: 'User', id: string, first_name?: string | null, last_name?: string | null, avatar_url?: string | null } }> } }> };

export type QueryInternalChatUsersQueryVariables = Exact<{
  where?: InputMaybe<Array<QueryInput> | QueryInput>;
  page?: InputMaybe<Scalars['NonNegativeInt']['input']>;
  pageSize?: InputMaybe<Scalars['NonNegativeInt']['input']>;
  orderBy?: InputMaybe<OrderByInput>;
}>;


export type QueryInternalChatUsersQuery = { __typename?: 'Query', queryInternalChatUsers: Array<{ __typename?: 'InternalChatUser', id: string, last_read_time: number, last_message_time: number, unread_message_count: number, is_removed: boolean, created_at: number, updated_at: number, user: { __typename?: 'User', id: string, first_name?: string | null, last_name?: string | null, email?: any | null, phone?: string | null, avatar_url?: string | null }, internal_chat: { __typename?: 'InternalChat', id: string, title?: string | null, message_count: number, last_message?: string | null, last_message_time: number, is_deleted: boolean, created_at: number, updated_at: number, clinic?: { __typename?: 'Clinic', id: string, name?: string | null, avatar_url?: string | null } | null, clinicGroup?: { __typename?: 'ClinicGroup', id: string, name: string } | null, internal_chat_users: Array<{ __typename?: 'InternalChatUser', id: string, last_read_time: number, last_message_time: number, unread_message_count: number, is_removed: boolean, created_at: number, updated_at: number, user: { __typename?: 'User', id: string, first_name?: string | null, last_name?: string | null, avatar_url?: string | null } }> } }> };

export type CountInternalChatUsersQueryVariables = Exact<{
  where?: InputMaybe<Array<QueryInput> | QueryInput>;
}>;


export type CountInternalChatUsersQuery = { __typename?: 'Query', countInternalChatUsers: number };

export type CreateInternalChatUserMutationVariables = Exact<{
  chatId: Scalars['ID']['input'];
  userId: Scalars['ID']['input'];
}>;


export type CreateInternalChatUserMutation = { __typename?: 'Mutation', createInternalChatUser: { __typename?: 'InternalChatUser', id: string, last_read_time: number, last_message_time: number, unread_message_count: number, is_removed: boolean, created_at: number, updated_at: number, user: { __typename?: 'User', id: string, first_name?: string | null, last_name?: string | null, email?: any | null, phone?: string | null, avatar_url?: string | null }, internal_chat: { __typename?: 'InternalChat', id: string, title?: string | null, message_count: number, last_message?: string | null, last_message_time: number, is_deleted: boolean, created_at: number, updated_at: number, clinic?: { __typename?: 'Clinic', id: string, name?: string | null, avatar_url?: string | null } | null, clinicGroup?: { __typename?: 'ClinicGroup', id: string, name: string } | null, internal_chat_users: Array<{ __typename?: 'InternalChatUser', id: string, last_read_time: number, last_message_time: number, unread_message_count: number, is_removed: boolean, created_at: number, updated_at: number, user: { __typename?: 'User', id: string, first_name?: string | null, last_name?: string | null, avatar_url?: string | null } }> } } };

export type UpdateInternalChatUserMutationVariables = Exact<{
  id: Scalars['ID']['input'];
  data: UpdateInternalChatUserInput;
}>;


export type UpdateInternalChatUserMutation = { __typename?: 'Mutation', updateInternalChatUser: { __typename?: 'InternalChatUser', id: string, last_read_time: number, last_message_time: number, unread_message_count: number, is_removed: boolean, created_at: number, updated_at: number, user: { __typename?: 'User', id: string, first_name?: string | null, last_name?: string | null, email?: any | null, phone?: string | null, avatar_url?: string | null }, internal_chat: { __typename?: 'InternalChat', id: string, title?: string | null, message_count: number, last_message?: string | null, last_message_time: number, is_deleted: boolean, created_at: number, updated_at: number, clinic?: { __typename?: 'Clinic', id: string, name?: string | null, avatar_url?: string | null } | null, clinicGroup?: { __typename?: 'ClinicGroup', id: string, name: string } | null, internal_chat_users: Array<{ __typename?: 'InternalChatUser', id: string, last_read_time: number, last_message_time: number, unread_message_count: number, is_removed: boolean, created_at: number, updated_at: number, user: { __typename?: 'User', id: string, first_name?: string | null, last_name?: string | null, avatar_url?: string | null } }> } } };

export type UpdateInternalChatUserLastReadMutationVariables = Exact<{
  chatId: Scalars['ID']['input'];
  userId: Scalars['ID']['input'];
  lastReadTime: Scalars['NonNegativeInt']['input'];
}>;


export type UpdateInternalChatUserLastReadMutation = { __typename?: 'Mutation', updateInternalChatUserLastRead: { __typename?: 'InternalChatUser', id: string, last_read_time: number, last_message_time: number, unread_message_count: number, is_removed: boolean, created_at: number, updated_at: number, user: { __typename?: 'User', id: string, first_name?: string | null, last_name?: string | null, email?: any | null, phone?: string | null, avatar_url?: string | null }, internal_chat: { __typename?: 'InternalChat', id: string, title?: string | null, message_count: number, last_message?: string | null, last_message_time: number, is_deleted: boolean, created_at: number, updated_at: number, clinic?: { __typename?: 'Clinic', id: string, name?: string | null, avatar_url?: string | null } | null, clinicGroup?: { __typename?: 'ClinicGroup', id: string, name: string } | null, internal_chat_users: Array<{ __typename?: 'InternalChatUser', id: string, last_read_time: number, last_message_time: number, unread_message_count: number, is_removed: boolean, created_at: number, updated_at: number, user: { __typename?: 'User', id: string, first_name?: string | null, last_name?: string | null, avatar_url?: string | null } }> } } };

export type DeleteInternalChatUserMutationVariables = Exact<{
  id: Scalars['ID']['input'];
}>;


export type DeleteInternalChatUserMutation = { __typename?: 'Mutation', deleteInternalChatUser?: any | null };

export type InternalChatFieldsFragment = { __typename?: 'InternalChat', id: string, title?: string | null, message_count: number, last_message?: string | null, last_message_time: number, is_deleted: boolean, created_at: number, updated_at: number, clinic?: { __typename?: 'Clinic', id: string, name?: string | null, avatar_url?: string | null } | null, clinicGroup?: { __typename?: 'ClinicGroup', id: string, name: string } | null, internal_chat_users: Array<{ __typename?: 'InternalChatUser', id: string, last_read_time: number, last_message_time: number, unread_message_count: number, is_removed: boolean, created_at: number, updated_at: number, user: { __typename?: 'User', id: string, first_name?: string | null, last_name?: string | null, avatar_url?: string | null } }> };

export type InternalChatQueryVariables = Exact<{
  id: Scalars['ID']['input'];
}>;


export type InternalChatQuery = { __typename?: 'Query', internalChat: { __typename?: 'InternalChat', id: string, title?: string | null, message_count: number, last_message?: string | null, last_message_time: number, is_deleted: boolean, created_at: number, updated_at: number, clinic?: { __typename?: 'Clinic', id: string, name?: string | null, avatar_url?: string | null } | null, clinicGroup?: { __typename?: 'ClinicGroup', id: string, name: string } | null, internal_chat_users: Array<{ __typename?: 'InternalChatUser', id: string, last_read_time: number, last_message_time: number, unread_message_count: number, is_removed: boolean, created_at: number, updated_at: number, user: { __typename?: 'User', id: string, first_name?: string | null, last_name?: string | null, avatar_url?: string | null } }> } };

export type CreateInternalChatMutationVariables = Exact<{
  data: CreateInternalChatInput;
}>;


export type CreateInternalChatMutation = { __typename?: 'Mutation', createInternalChat: { __typename?: 'InternalChat', id: string, title?: string | null, message_count: number, last_message?: string | null, last_message_time: number, is_deleted: boolean, created_at: number, updated_at: number, clinic?: { __typename?: 'Clinic', id: string, name?: string | null, avatar_url?: string | null } | null, clinicGroup?: { __typename?: 'ClinicGroup', id: string, name: string } | null, internal_chat_users: Array<{ __typename?: 'InternalChatUser', id: string, last_read_time: number, last_message_time: number, unread_message_count: number, is_removed: boolean, created_at: number, updated_at: number, user: { __typename?: 'User', id: string, first_name?: string | null, last_name?: string | null, avatar_url?: string | null } }> } };

export type UpdateInternalChatMutationVariables = Exact<{
  id: Scalars['ID']['input'];
  data: UpdateInternalChatInput;
}>;


export type UpdateInternalChatMutation = { __typename?: 'Mutation', updateInternalChat: { __typename?: 'InternalChat', id: string, title?: string | null, message_count: number, last_message?: string | null, last_message_time: number, is_deleted: boolean, created_at: number, updated_at: number, clinic?: { __typename?: 'Clinic', id: string, name?: string | null, avatar_url?: string | null } | null, clinicGroup?: { __typename?: 'ClinicGroup', id: string, name: string } | null, internal_chat_users: Array<{ __typename?: 'InternalChatUser', id: string, last_read_time: number, last_message_time: number, unread_message_count: number, is_removed: boolean, created_at: number, updated_at: number, user: { __typename?: 'User', id: string, first_name?: string | null, last_name?: string | null, avatar_url?: string | null } }> } };

export type DeleteInternalChatMutationVariables = Exact<{
  id: Scalars['ID']['input'];
}>;


export type DeleteInternalChatMutation = { __typename?: 'Mutation', deleteInternalChat?: any | null };

export type InternalUsageEventFieldsFragment = { __typename?: 'InternalUsageEvent', id: string, action_type: InternalUsageActionType, clinic_id?: string | null, user_id?: string | null, widget_id?: string | null, instance_id?: string | null, metadata?: any | null, created_at: number };

export type InternalUsageClinicFieldsFragment = { __typename?: 'Clinic', id: string, name?: string | null, avatar_url?: string | null };

export type InternalUsageUserFieldsFragment = { __typename?: 'User', id: string, first_name?: string | null, last_name?: string | null, email?: any | null };

export type GetInternalUsageEventsQueryVariables = Exact<{
  filters: InternalUsageEventFilters;
}>;


export type GetInternalUsageEventsQuery = { __typename?: 'Query', internalUsageEvents: Array<{ __typename?: 'InternalUsageEvent', id: string, action_type: InternalUsageActionType, clinic_id?: string | null, user_id?: string | null, widget_id?: string | null, instance_id?: string | null, metadata?: any | null, created_at: number }> };

export type CountInternalUsageEventsQueryVariables = Exact<{
  filters: InternalUsageEventFilters;
}>;


export type CountInternalUsageEventsQuery = { __typename?: 'Query', countInternalUsageEvents: number };

export type ClinicForInternalUsageEventQueryVariables = Exact<{
  clinicId: Scalars['ID']['input'];
}>;


export type ClinicForInternalUsageEventQuery = { __typename?: 'Query', clinic: { __typename?: 'Clinic', id: string, name?: string | null, avatar_url?: string | null } };

export type UserForInternalUsageEventQueryVariables = Exact<{
  userId: Scalars['ID']['input'];
}>;


export type UserForInternalUsageEventQuery = { __typename?: 'Query', user?: { __typename?: 'User', id: string, first_name?: string | null, last_name?: string | null, email?: any | null } | null };

export type CreateInternalUsageEventMutationVariables = Exact<{
  data: InternalUsageEventInput;
}>;


export type CreateInternalUsageEventMutation = { __typename?: 'Mutation', createInternalUsageEvent?: { __typename?: 'InternalUsageEvent', id: string, action_type: InternalUsageActionType, clinic_id?: string | null, user_id?: string | null, widget_id?: string | null, instance_id?: string | null, metadata?: any | null, created_at: number } | null };

export type InvoiceFieldsFragment = { __typename?: 'Invoice', id: string, pms_id: string, status: InvoiceStatus, entered_by_name?: string | null, description?: string | null, discount?: number | null, discount_reason?: string | null, subtotal?: number | null, tax?: number | null, total: number, total_paid?: number | null, balance?: number | null, currency: any, pims_created_at?: number | null, paid_at?: number | null, created_at: number, updated_at: number, clinic?: { __typename?: 'Clinic', id: string, name?: string | null } | null, appointment?: { __typename?: 'Appointment', id: string, service_name?: string | null, status: AppointmentStatus, start_time: number, drop_off_time?: number | null, minutes: number, service?: { __typename?: 'Service', name?: string | null } | null, clinician?: { __typename?: 'Clinician', name: string, display_name?: string | null } | null, client?: { __typename?: 'Client', first_name?: string | null, last_name?: string | null } | null, patient?: { __typename?: 'Patient', name?: string | null } | null } | null, previous_appt?: { __typename?: 'Appointment', id: string, service_name?: string | null, status: AppointmentStatus, start_time: number, drop_off_time?: number | null, minutes: number, service?: { __typename?: 'Service', name?: string | null } | null, clinician?: { __typename?: 'Clinician', name: string, display_name?: string | null } | null, client?: { __typename?: 'Client', first_name?: string | null, last_name?: string | null } | null, patient?: { __typename?: 'Patient', name?: string | null } | null } | null, client?: { __typename?: 'Client', id: string, first_name?: string | null, last_name?: string | null, email?: string | null, phone?: string | null } | null, patient?: { __typename?: 'Patient', id: string, name?: string | null } | null, clinician?: { __typename?: 'Clinician', id: string, name: string } | null };

export type InvoicePreviewFieldsFragment = { __typename?: 'Invoice', id: string, status: InvoiceStatus, discount?: number | null, total: number, total_paid?: number | null, balance?: number | null, paid_at?: number | null, pims_created_at?: number | null, client?: { __typename?: 'Client', id: string, first_name?: string | null, last_name?: string | null } | null, clinician?: { __typename?: 'Clinician', id: string, name: string } | null };

export type InvoiceItemFieldsFragment = { __typename?: 'InvoiceItem', id: string, description?: string | null, quantity?: number | null, price?: number | null, total: number, subtotal?: number | null, tax?: number | null, discount?: number | null, pims_created_at?: number | null, clinician?: { __typename?: 'Clinician', id: string, name: string } | null, invoice?: { __typename?: 'Invoice', id: string, total: number, client?: { __typename?: 'Client', id: string, first_name?: string | null, last_name?: string | null } | null } | null };

export type DetailedInvoiceFieldsFragment = { __typename?: 'Invoice', id: string, pms_id: string, status: InvoiceStatus, entered_by_name?: string | null, description?: string | null, discount?: number | null, discount_reason?: string | null, subtotal?: number | null, tax?: number | null, total: number, total_paid?: number | null, balance?: number | null, currency: any, pims_created_at?: number | null, paid_at?: number | null, created_at: number, updated_at: number, invoice_items: Array<{ __typename?: 'InvoiceItem', id: string, description?: string | null, quantity?: number | null, price?: number | null, total: number }>, client?: { __typename?: 'Client', id: string, first_name?: string | null, last_name?: string | null, email?: string | null, phone?: string | null, secondary_first_name?: string | null, secondary_last_name?: string | null, pms?: PracticeManagementSystem | null, pms_id?: string | null, last_appt_time?: number | null, last_contact_time?: number | null, email_enabled: boolean, sms_enabled: boolean, balance?: number | null, is_active?: boolean | null, is_unsubscribed: boolean, created_at: number, updated_at: number, client_phones?: Array<{ __typename?: 'ClientPhone', id: string, phone: string, country_code?: string | null, is_primary: boolean, is_chckup_primary: boolean, is_mobile: boolean, sms_available: boolean, is_unsubscribed: boolean, is_active: boolean, name?: string | null }> | null, client_emails?: Array<{ __typename?: 'ClientEmail', id: string, email: string, is_primary: boolean }> | null, clinic?: { __typename?: 'Clinic', id: string } | null, patients?: Array<{ __typename?: 'Patient', id: string, pms?: PracticeManagementSystem | null, pms_id?: string | null, name?: string | null, breed?: string | null, avatar_url?: string | null, last_appt_time?: number | null, gender?: string | null, fixed_status?: FixedStatus | null, weight?: number | null, birthday?: number | null, is_active?: boolean | null, is_deceased?: boolean | null, pms_created_at?: number | null, created_at: number, updated_at: number, owner?: { __typename?: 'Client', id: string, first_name?: string | null, last_name?: string | null, email?: string | null, phone?: string | null, address?: { __typename?: 'Address', country?: string | null } | null } | null, clinic_species?: { __typename?: 'ClinicSpecies', id: string, pms_id: string, description: string, is_primary: boolean, species: Species, weight_key: string, created_at: number, updated_at: number } | null, clinic?: { __typename?: 'Clinic', id: string } | null, clinic_breed?: { __typename?: 'Breed', id: string, description: string } | null, patient_vaccination_records?: Array<{ __typename?: 'PatientVaccinationRecord', id: string, vaccine_name?: string | null, manufacturer?: string | null, lot_number?: string | null, administered_date?: number | null, due_date?: number | null, rabies_tag?: string | null, is_rabies_vaccine?: boolean | null, is_soc: boolean, is_active: boolean, product?: { __typename?: 'Product', id: string, display_name?: string | null, name: string } | null }> | null, last_appointment?: { __typename?: 'Appointment', clinician?: { __typename?: 'Clinician', name: string, display_name?: string | null } | null } | null }> | null, address?: { __typename?: 'Address', street_a?: string | null, street_b?: string | null, city?: string | null, state?: string | null, zip?: string | null, country?: string | null } | null, user?: { __typename?: 'User', avatar_url?: string | null } | null, loyalty_members?: Array<{ __typename?: 'LoyaltyMember', id: string, available_points: number } | null> | null, settings?: { __typename?: 'ClientSettings', clinic_chckup_notifications_enabled: boolean, clinic_chckup_sms_enabled: boolean, clinic_chckup_email_enabled: boolean, client_chckup_notifications_enabled: boolean, client_chckup_sms_enabled: boolean, client_chckup_email_enabled: boolean, is_unsubscribed_from_marketing: boolean, is_unsubscribed_from_marketing_sms: boolean, is_unsubscribed_from_marketing_email: boolean } | null, last_appointment?: { __typename?: 'Appointment', clinician?: { __typename?: 'Clinician', name: string, display_name?: string | null } | null } | null } | null, patient?: { __typename?: 'Patient', id: string, name?: string | null, pms?: PracticeManagementSystem | null, pms_id?: string | null, breed?: string | null, avatar_url?: string | null, last_appt_time?: number | null, gender?: string | null, fixed_status?: FixedStatus | null, weight?: number | null, birthday?: number | null, is_active?: boolean | null, is_deceased?: boolean | null, pms_created_at?: number | null, created_at: number, updated_at: number, owner?: { __typename?: 'Client', id: string, first_name?: string | null, last_name?: string | null, email?: string | null, phone?: string | null, address?: { __typename?: 'Address', country?: string | null } | null } | null, clinic_species?: { __typename?: 'ClinicSpecies', id: string, pms_id: string, description: string, is_primary: boolean, species: Species, weight_key: string, created_at: number, updated_at: number } | null, clinic?: { __typename?: 'Clinic', id: string } | null, clinic_breed?: { __typename?: 'Breed', id: string, description: string } | null, patient_vaccination_records?: Array<{ __typename?: 'PatientVaccinationRecord', id: string, vaccine_name?: string | null, manufacturer?: string | null, lot_number?: string | null, administered_date?: number | null, due_date?: number | null, rabies_tag?: string | null, is_rabies_vaccine?: boolean | null, is_soc: boolean, is_active: boolean, product?: { __typename?: 'Product', id: string, display_name?: string | null, name: string } | null }> | null, last_appointment?: { __typename?: 'Appointment', clinician?: { __typename?: 'Clinician', name: string, display_name?: string | null } | null } | null } | null, clinic?: { __typename?: 'Clinic', id: string, name?: string | null } | null, appointment?: { __typename?: 'Appointment', id: string, service_name?: string | null, status: AppointmentStatus, start_time: number, drop_off_time?: number | null, minutes: number, service?: { __typename?: 'Service', name?: string | null } | null, clinician?: { __typename?: 'Clinician', name: string, display_name?: string | null } | null, client?: { __typename?: 'Client', first_name?: string | null, last_name?: string | null } | null, patient?: { __typename?: 'Patient', name?: string | null } | null } | null, previous_appt?: { __typename?: 'Appointment', id: string, service_name?: string | null, status: AppointmentStatus, start_time: number, drop_off_time?: number | null, minutes: number, service?: { __typename?: 'Service', name?: string | null } | null, clinician?: { __typename?: 'Clinician', name: string, display_name?: string | null } | null, client?: { __typename?: 'Client', first_name?: string | null, last_name?: string | null } | null, patient?: { __typename?: 'Patient', name?: string | null } | null } | null, clinician?: { __typename?: 'Clinician', id: string, name: string } | null };

export type QueryInvoicesQueryVariables = Exact<{
  where?: InputMaybe<Array<QueryInput> | QueryInput>;
  page?: InputMaybe<Scalars['NonNegativeInt']['input']>;
  pageSize?: InputMaybe<Scalars['NonNegativeInt']['input']>;
  orderBy?: InputMaybe<OrderByInput>;
}>;


export type QueryInvoicesQuery = { __typename?: 'Query', queryInvoices: Array<{ __typename?: 'Invoice', id: string, pms_id: string, status: InvoiceStatus, entered_by_name?: string | null, description?: string | null, discount?: number | null, discount_reason?: string | null, subtotal?: number | null, tax?: number | null, total: number, total_paid?: number | null, balance?: number | null, currency: any, pims_created_at?: number | null, paid_at?: number | null, created_at: number, updated_at: number, clinic?: { __typename?: 'Clinic', id: string, name?: string | null } | null, appointment?: { __typename?: 'Appointment', id: string, service_name?: string | null, status: AppointmentStatus, start_time: number, drop_off_time?: number | null, minutes: number, service?: { __typename?: 'Service', name?: string | null } | null, clinician?: { __typename?: 'Clinician', name: string, display_name?: string | null } | null, client?: { __typename?: 'Client', first_name?: string | null, last_name?: string | null } | null, patient?: { __typename?: 'Patient', name?: string | null } | null } | null, previous_appt?: { __typename?: 'Appointment', id: string, service_name?: string | null, status: AppointmentStatus, start_time: number, drop_off_time?: number | null, minutes: number, service?: { __typename?: 'Service', name?: string | null } | null, clinician?: { __typename?: 'Clinician', name: string, display_name?: string | null } | null, client?: { __typename?: 'Client', first_name?: string | null, last_name?: string | null } | null, patient?: { __typename?: 'Patient', name?: string | null } | null } | null, client?: { __typename?: 'Client', id: string, first_name?: string | null, last_name?: string | null, email?: string | null, phone?: string | null } | null, patient?: { __typename?: 'Patient', id: string, name?: string | null } | null, clinician?: { __typename?: 'Clinician', id: string, name: string } | null }> };

export type CountInvoicesQueryVariables = Exact<{
  where?: InputMaybe<Array<QueryInput> | QueryInput>;
}>;


export type CountInvoicesQuery = { __typename?: 'Query', countInvoices: number };

export type GetAppointmentInvoiceTotalsQueryVariables = Exact<{
  appointmentIds: Array<Scalars['ID']['input']> | Scalars['ID']['input'];
}>;


export type GetAppointmentInvoiceTotalsQuery = { __typename?: 'Query', getAppointmentInvoiceTotals: Array<{ __typename?: 'AppointmentInvoiceTotal', appointment: string, total: number, total_paid: number, invoice_count: number }> };

export type GetInvoiceQueryVariables = Exact<{
  id: Scalars['ID']['input'];
}>;


export type GetInvoiceQuery = { __typename?: 'Query', invoice: { __typename?: 'Invoice', id: string, pms_id: string, status: InvoiceStatus, entered_by_name?: string | null, description?: string | null, discount?: number | null, discount_reason?: string | null, subtotal?: number | null, tax?: number | null, total: number, total_paid?: number | null, balance?: number | null, currency: any, pims_created_at?: number | null, paid_at?: number | null, created_at: number, updated_at: number, invoice_items: Array<{ __typename?: 'InvoiceItem', id: string, description?: string | null, quantity?: number | null, price?: number | null, total: number }>, client?: { __typename?: 'Client', id: string, first_name?: string | null, last_name?: string | null, email?: string | null, phone?: string | null, secondary_first_name?: string | null, secondary_last_name?: string | null, pms?: PracticeManagementSystem | null, pms_id?: string | null, last_appt_time?: number | null, last_contact_time?: number | null, email_enabled: boolean, sms_enabled: boolean, balance?: number | null, is_active?: boolean | null, is_unsubscribed: boolean, created_at: number, updated_at: number, client_phones?: Array<{ __typename?: 'ClientPhone', id: string, phone: string, country_code?: string | null, is_primary: boolean, is_chckup_primary: boolean, is_mobile: boolean, sms_available: boolean, is_unsubscribed: boolean, is_active: boolean, name?: string | null }> | null, client_emails?: Array<{ __typename?: 'ClientEmail', id: string, email: string, is_primary: boolean }> | null, clinic?: { __typename?: 'Clinic', id: string } | null, patients?: Array<{ __typename?: 'Patient', id: string, pms?: PracticeManagementSystem | null, pms_id?: string | null, name?: string | null, breed?: string | null, avatar_url?: string | null, last_appt_time?: number | null, gender?: string | null, fixed_status?: FixedStatus | null, weight?: number | null, birthday?: number | null, is_active?: boolean | null, is_deceased?: boolean | null, pms_created_at?: number | null, created_at: number, updated_at: number, owner?: { __typename?: 'Client', id: string, first_name?: string | null, last_name?: string | null, email?: string | null, phone?: string | null, address?: { __typename?: 'Address', country?: string | null } | null } | null, clinic_species?: { __typename?: 'ClinicSpecies', id: string, pms_id: string, description: string, is_primary: boolean, species: Species, weight_key: string, created_at: number, updated_at: number } | null, clinic?: { __typename?: 'Clinic', id: string } | null, clinic_breed?: { __typename?: 'Breed', id: string, description: string } | null, patient_vaccination_records?: Array<{ __typename?: 'PatientVaccinationRecord', id: string, vaccine_name?: string | null, manufacturer?: string | null, lot_number?: string | null, administered_date?: number | null, due_date?: number | null, rabies_tag?: string | null, is_rabies_vaccine?: boolean | null, is_soc: boolean, is_active: boolean, product?: { __typename?: 'Product', id: string, display_name?: string | null, name: string } | null }> | null, last_appointment?: { __typename?: 'Appointment', clinician?: { __typename?: 'Clinician', name: string, display_name?: string | null } | null } | null }> | null, address?: { __typename?: 'Address', street_a?: string | null, street_b?: string | null, city?: string | null, state?: string | null, zip?: string | null, country?: string | null } | null, user?: { __typename?: 'User', avatar_url?: string | null } | null, loyalty_members?: Array<{ __typename?: 'LoyaltyMember', id: string, available_points: number } | null> | null, settings?: { __typename?: 'ClientSettings', clinic_chckup_notifications_enabled: boolean, clinic_chckup_sms_enabled: boolean, clinic_chckup_email_enabled: boolean, client_chckup_notifications_enabled: boolean, client_chckup_sms_enabled: boolean, client_chckup_email_enabled: boolean, is_unsubscribed_from_marketing: boolean, is_unsubscribed_from_marketing_sms: boolean, is_unsubscribed_from_marketing_email: boolean } | null, last_appointment?: { __typename?: 'Appointment', clinician?: { __typename?: 'Clinician', name: string, display_name?: string | null } | null } | null } | null, patient?: { __typename?: 'Patient', id: string, name?: string | null, pms?: PracticeManagementSystem | null, pms_id?: string | null, breed?: string | null, avatar_url?: string | null, last_appt_time?: number | null, gender?: string | null, fixed_status?: FixedStatus | null, weight?: number | null, birthday?: number | null, is_active?: boolean | null, is_deceased?: boolean | null, pms_created_at?: number | null, created_at: number, updated_at: number, owner?: { __typename?: 'Client', id: string, first_name?: string | null, last_name?: string | null, email?: string | null, phone?: string | null, address?: { __typename?: 'Address', country?: string | null } | null } | null, clinic_species?: { __typename?: 'ClinicSpecies', id: string, pms_id: string, description: string, is_primary: boolean, species: Species, weight_key: string, created_at: number, updated_at: number } | null, clinic?: { __typename?: 'Clinic', id: string } | null, clinic_breed?: { __typename?: 'Breed', id: string, description: string } | null, patient_vaccination_records?: Array<{ __typename?: 'PatientVaccinationRecord', id: string, vaccine_name?: string | null, manufacturer?: string | null, lot_number?: string | null, administered_date?: number | null, due_date?: number | null, rabies_tag?: string | null, is_rabies_vaccine?: boolean | null, is_soc: boolean, is_active: boolean, product?: { __typename?: 'Product', id: string, display_name?: string | null, name: string } | null }> | null, last_appointment?: { __typename?: 'Appointment', clinician?: { __typename?: 'Clinician', name: string, display_name?: string | null } | null } | null } | null, clinic?: { __typename?: 'Clinic', id: string, name?: string | null } | null, appointment?: { __typename?: 'Appointment', id: string, service_name?: string | null, status: AppointmentStatus, start_time: number, drop_off_time?: number | null, minutes: number, service?: { __typename?: 'Service', name?: string | null } | null, clinician?: { __typename?: 'Clinician', name: string, display_name?: string | null } | null, client?: { __typename?: 'Client', first_name?: string | null, last_name?: string | null } | null, patient?: { __typename?: 'Patient', name?: string | null } | null } | null, previous_appt?: { __typename?: 'Appointment', id: string, service_name?: string | null, status: AppointmentStatus, start_time: number, drop_off_time?: number | null, minutes: number, service?: { __typename?: 'Service', name?: string | null } | null, clinician?: { __typename?: 'Clinician', name: string, display_name?: string | null } | null, client?: { __typename?: 'Client', first_name?: string | null, last_name?: string | null } | null, patient?: { __typename?: 'Patient', name?: string | null } | null } | null, clinician?: { __typename?: 'Clinician', id: string, name: string } | null } };

export type LoyaltyClientFieldsFragment = { __typename?: 'Client', id: string, first_name?: string | null, last_name?: string | null, phone?: string | null, address?: { __typename?: 'Address', country?: string | null } | null };

export type LoyaltyMemberFieldsFragment = { __typename?: 'LoyaltyMember', id: string, available_points: number, all_time_points: number, client: { __typename?: 'Client', id: string, first_name?: string | null, last_name?: string | null, phone?: string | null, address?: { __typename?: 'Address', country?: string | null } | null } };

export type LoyaltyRewardFieldsFragment = { __typename?: 'LoyaltyReward', id: string, name: string, description?: string | null, points_required: number, is_active: boolean, image_url?: string | null, created_at: number, updated_at: number };

export type LoyaltyRedemptionFieldsFragment = { __typename?: 'LoyaltyRedemption', id: string, status: LoyaltyRedemptionStatus, created_at: number, updated_at: number, member: { __typename?: 'LoyaltyMember', id: string, available_points: number, all_time_points: number, client: { __typename?: 'Client', id: string, first_name?: string | null, last_name?: string | null, phone?: string | null, address?: { __typename?: 'Address', country?: string | null } | null } }, reward: { __typename?: 'LoyaltyReward', id: string, name: string, description?: string | null, points_required: number, is_active: boolean, image_url?: string | null, created_at: number, updated_at: number } };

export type LoyaltyEarningFieldsFragment = { __typename?: 'LoyaltyEarning', id: string, points_earned: number, created_at: number, member: { __typename?: 'LoyaltyMember', id: string, available_points: number, all_time_points: number, client: { __typename?: 'Client', id: string, first_name?: string | null, last_name?: string | null, phone?: string | null, address?: { __typename?: 'Address', country?: string | null } | null } }, invoice?: { __typename?: 'Invoice', id: string, pims_created_at?: number | null } | null };

export type GetLoyaltyRewardsForClinicQueryVariables = Exact<{
  clinicId: Scalars['ID']['input'];
  showInactive?: InputMaybe<Scalars['Boolean']['input']>;
}>;


export type GetLoyaltyRewardsForClinicQuery = { __typename?: 'Query', getLoyaltyRewardsForClinic: Array<{ __typename?: 'LoyaltyReward', id: string, name: string, description?: string | null, points_required: number, is_active: boolean, image_url?: string | null, created_at: number, updated_at: number }> };

export type GetLoyaltyMemberFromClientQueryVariables = Exact<{
  clientId: Scalars['ID']['input'];
}>;


export type GetLoyaltyMemberFromClientQuery = { __typename?: 'Query', client: { __typename?: 'Client', loyalty_members?: Array<{ __typename?: 'LoyaltyMember', id: string, available_points: number, all_time_points: number } | null> | null } };

export type GetLoyaltyMemberQueryVariables = Exact<{
  id: Scalars['ID']['input'];
}>;


export type GetLoyaltyMemberQuery = { __typename?: 'Query', loyaltyMember: { __typename?: 'LoyaltyMember', id: string, available_points: number, all_time_points: number, client: { __typename?: 'Client', id: string, first_name?: string | null, last_name?: string | null, phone?: string | null, address?: { __typename?: 'Address', country?: string | null } | null } } };

export type GetLoyaltyRewardQueryVariables = Exact<{
  id: Scalars['ID']['input'];
}>;


export type GetLoyaltyRewardQuery = { __typename?: 'Query', loyaltyReward: { __typename?: 'LoyaltyReward', id: string, name: string, description?: string | null, points_required: number, is_active: boolean, image_url?: string | null, created_at: number, updated_at: number } };

export type CreateLoyaltyRewardMutationVariables = Exact<{
  data: CreateLoyaltyRewardInput;
}>;


export type CreateLoyaltyRewardMutation = { __typename?: 'Mutation', createLoyaltyReward: { __typename?: 'LoyaltyReward', id: string, name: string, description?: string | null, points_required: number, is_active: boolean, image_url?: string | null, created_at: number, updated_at: number } };

export type UpdateLoyaltyRewardMutationVariables = Exact<{
  id: Scalars['ID']['input'];
  data: UpdateLoyaltyRewardInput;
}>;


export type UpdateLoyaltyRewardMutation = { __typename?: 'Mutation', updateLoyaltyReward: { __typename?: 'LoyaltyReward', id: string, name: string, description?: string | null, points_required: number, is_active: boolean, image_url?: string | null, created_at: number, updated_at: number } };

export type DeleteLoyaltyRewardMutationVariables = Exact<{
  id: Scalars['ID']['input'];
}>;


export type DeleteLoyaltyRewardMutation = { __typename?: 'Mutation', deleteLoyaltyReward?: any | null };

export type CreateLoyaltyMemberMutationVariables = Exact<{
  data: CreateLoyaltyMemberInput;
}>;


export type CreateLoyaltyMemberMutation = { __typename?: 'Mutation', createLoyaltyMember: { __typename?: 'LoyaltyMember', id: string, available_points: number, all_time_points: number, client: { __typename?: 'Client', id: string, first_name?: string | null, last_name?: string | null, phone?: string | null, address?: { __typename?: 'Address', country?: string | null } | null } } };

export type UpdateLoyaltyMemberMutationVariables = Exact<{
  id: Scalars['ID']['input'];
  data: UpdateLoyaltyMemberInput;
}>;


export type UpdateLoyaltyMemberMutation = { __typename?: 'Mutation', updateLoyaltyMember: { __typename?: 'LoyaltyMember', id: string, available_points: number, all_time_points: number, client: { __typename?: 'Client', id: string, first_name?: string | null, last_name?: string | null, phone?: string | null, address?: { __typename?: 'Address', country?: string | null } | null } } };

export type AddPointsToLoyaltyMemberMutationVariables = Exact<{
  id: Scalars['ID']['input'];
  points: Scalars['NonNegativeInt']['input'];
}>;


export type AddPointsToLoyaltyMemberMutation = { __typename?: 'Mutation', addPointsToLoyaltyMember: { __typename?: 'LoyaltyMember', id: string, available_points: number, all_time_points: number, client: { __typename?: 'Client', id: string, first_name?: string | null, last_name?: string | null, phone?: string | null, address?: { __typename?: 'Address', country?: string | null } | null } } };

export type QueryLoyaltyRedemptionsQueryVariables = Exact<{
  where?: InputMaybe<Array<QueryInput> | QueryInput>;
  page?: InputMaybe<Scalars['NonNegativeInt']['input']>;
  pageSize?: InputMaybe<Scalars['NonNegativeInt']['input']>;
  orderBy?: InputMaybe<OrderByInput>;
}>;


export type QueryLoyaltyRedemptionsQuery = { __typename?: 'Query', queryLoyaltyRedemptions: Array<{ __typename?: 'LoyaltyRedemption', id: string, status: LoyaltyRedemptionStatus, created_at: number, updated_at: number, member: { __typename?: 'LoyaltyMember', id: string, available_points: number, all_time_points: number, client: { __typename?: 'Client', id: string, first_name?: string | null, last_name?: string | null, phone?: string | null, address?: { __typename?: 'Address', country?: string | null } | null } }, reward: { __typename?: 'LoyaltyReward', id: string, name: string, description?: string | null, points_required: number, is_active: boolean, image_url?: string | null, created_at: number, updated_at: number } }> };

export type CountLoyaltyRedemptionsQueryVariables = Exact<{
  where?: InputMaybe<Array<QueryInput> | QueryInput>;
}>;


export type CountLoyaltyRedemptionsQuery = { __typename?: 'Query', countLoyaltyRedemptions: number };

export type CreateLoyaltyRedemptionMutationVariables = Exact<{
  data: CreateLoyaltyRedemptionInput;
}>;


export type CreateLoyaltyRedemptionMutation = { __typename?: 'Mutation', createLoyaltyRedemption: { __typename?: 'LoyaltyRedemption', id: string, status: LoyaltyRedemptionStatus, created_at: number, updated_at: number, member: { __typename?: 'LoyaltyMember', id: string, available_points: number, all_time_points: number, client: { __typename?: 'Client', id: string, first_name?: string | null, last_name?: string | null, phone?: string | null, address?: { __typename?: 'Address', country?: string | null } | null } }, reward: { __typename?: 'LoyaltyReward', id: string, name: string, description?: string | null, points_required: number, is_active: boolean, image_url?: string | null, created_at: number, updated_at: number } } };

export type ApproveRedemptionRequestMutationVariables = Exact<{
  id: Scalars['ID']['input'];
}>;


export type ApproveRedemptionRequestMutation = { __typename?: 'Mutation', approveRedemptionRequest: { __typename?: 'LoyaltyRedemption', id: string, status: LoyaltyRedemptionStatus, created_at: number, updated_at: number, member: { __typename?: 'LoyaltyMember', id: string, available_points: number, all_time_points: number, client: { __typename?: 'Client', id: string, first_name?: string | null, last_name?: string | null, phone?: string | null, address?: { __typename?: 'Address', country?: string | null } | null } }, reward: { __typename?: 'LoyaltyReward', id: string, name: string, description?: string | null, points_required: number, is_active: boolean, image_url?: string | null, created_at: number, updated_at: number } } };

export type CancelRedemptionRequestMutationVariables = Exact<{
  id: Scalars['ID']['input'];
}>;


export type CancelRedemptionRequestMutation = { __typename?: 'Mutation', cancelRedemptionRequest: { __typename?: 'LoyaltyRedemption', id: string, status: LoyaltyRedemptionStatus, created_at: number, updated_at: number, member: { __typename?: 'LoyaltyMember', id: string, available_points: number, all_time_points: number, client: { __typename?: 'Client', id: string, first_name?: string | null, last_name?: string | null, phone?: string | null, address?: { __typename?: 'Address', country?: string | null } | null } }, reward: { __typename?: 'LoyaltyReward', id: string, name: string, description?: string | null, points_required: number, is_active: boolean, image_url?: string | null, created_at: number, updated_at: number } } };

export type QueryLoyaltyEarningsQueryVariables = Exact<{
  where?: InputMaybe<Array<QueryInput> | QueryInput>;
  page?: InputMaybe<Scalars['NonNegativeInt']['input']>;
  pageSize?: InputMaybe<Scalars['NonNegativeInt']['input']>;
  orderBy?: InputMaybe<OrderByInput>;
}>;


export type QueryLoyaltyEarningsQuery = { __typename?: 'Query', queryLoyaltyEarnings: Array<{ __typename?: 'LoyaltyEarning', id: string, points_earned: number, created_at: number, member: { __typename?: 'LoyaltyMember', id: string, available_points: number, all_time_points: number, client: { __typename?: 'Client', id: string, first_name?: string | null, last_name?: string | null, phone?: string | null, address?: { __typename?: 'Address', country?: string | null } | null } }, invoice?: { __typename?: 'Invoice', id: string, pims_created_at?: number | null } | null }> };

export type CountLoyaltyEarningsQueryVariables = Exact<{
  where?: InputMaybe<Array<QueryInput> | QueryInput>;
}>;


export type CountLoyaltyEarningsQuery = { __typename?: 'Query', countLoyaltyEarnings: number };

export type BookingSourceBreakdownFieldsFragment = { __typename?: 'BookingSourceBreakdownEntry', source: string, count: number, percent: number };

export type MarketingSummaryStatsFieldsFragment = { __typename?: 'MarketingSummaryStats', total_appointments: number, online_booking_appointments: number, new_client_appointments: number, existing_client_appointments: number, total_messages_sent: number, total_notification_sends: number, total_bulk_message_sends: number, successful_email_sends: number, total_email_opens: number, email_open_rate: number, direct_attributed_bookings: number, indirect_attributed_bookings: number, total_attributed_bookings: number, response_rate: number, total_attributed_revenue: number, attribution_window_days: number, attribution_row_limit_hit: boolean, booking_source_breakdown: Array<{ __typename?: 'BookingSourceBreakdownEntry', source: string, count: number, percent: number }> };

export type OrgCampaignStatsFieldsFragment = { __typename?: 'OrgCampaignStats', campaign_id: string, campaign_name: string, clinic_id?: string | null, clinic_group_id?: string | null, total_messages_sent: number, successful_email_sends: number, total_email_opens: number, email_open_rate: number, direct_attributed_bookings: number, indirect_attributed_bookings: number, total_attributed_bookings: number, total_attributed_revenue: number };

export type OrgNotificationStatsFieldsFragment = { __typename?: 'OrgNotificationStats', notif_template_id: string, notif_template_name: string, clinic_id?: string | null, campaign_id?: string | null, is_active?: boolean | null, total_messages_sent: number, successful_email_sends: number, total_email_opens: number, email_open_rate: number, response_rate: number, direct_attributed_bookings: number, indirect_attributed_bookings: number, total_attributed_bookings: number, total_attributed_revenue: number };

export type OrgBulkMessageStatsFieldsFragment = { __typename?: 'OrgBulkMessageStats', bulk_message_id: string, bulk_message_name: string, clinic_id?: string | null, campaign_id?: string | null, is_active?: boolean | null, total_messages_sent: number, successful_email_sends: number, total_email_opens: number, email_open_rate: number, response_rate: number, direct_attributed_bookings: number, indirect_attributed_bookings: number, total_attributed_bookings: number, total_attributed_revenue: number };

export type ReminderAttributedAppointmentIdsFieldsFragment = { __typename?: 'ReminderAttributedAppointmentIds', appointment_ids: Array<string>, limit_hit: boolean };

export type GetMarketingSummaryStatsQueryVariables = Exact<{
  filters: MarketingFiltersInput;
}>;


export type GetMarketingSummaryStatsQuery = { __typename?: 'Query', marketingSummaryStats: { __typename?: 'MarketingSummaryStats', total_appointments: number, online_booking_appointments: number, new_client_appointments: number, existing_client_appointments: number, total_messages_sent: number, total_notification_sends: number, total_bulk_message_sends: number, successful_email_sends: number, total_email_opens: number, email_open_rate: number, direct_attributed_bookings: number, indirect_attributed_bookings: number, total_attributed_bookings: number, response_rate: number, total_attributed_revenue: number, attribution_window_days: number, attribution_row_limit_hit: boolean, booking_source_breakdown: Array<{ __typename?: 'BookingSourceBreakdownEntry', source: string, count: number, percent: number }> } };

export type GetOrganizationCampaignStatsQueryVariables = Exact<{
  filters: MarketingFiltersInput;
}>;


export type GetOrganizationCampaignStatsQuery = { __typename?: 'Query', organizationCampaignStats: Array<{ __typename?: 'OrgCampaignStats', campaign_id: string, campaign_name: string, clinic_id?: string | null, clinic_group_id?: string | null, total_messages_sent: number, successful_email_sends: number, total_email_opens: number, email_open_rate: number, direct_attributed_bookings: number, indirect_attributed_bookings: number, total_attributed_bookings: number, total_attributed_revenue: number }> };

export type GetOrganizationNotificationStatsQueryVariables = Exact<{
  filters: MarketingFiltersInput;
}>;


export type GetOrganizationNotificationStatsQuery = { __typename?: 'Query', organizationNotificationStats: Array<{ __typename?: 'OrgNotificationStats', notif_template_id: string, notif_template_name: string, clinic_id?: string | null, campaign_id?: string | null, is_active?: boolean | null, total_messages_sent: number, successful_email_sends: number, total_email_opens: number, email_open_rate: number, response_rate: number, direct_attributed_bookings: number, indirect_attributed_bookings: number, total_attributed_bookings: number, total_attributed_revenue: number }> };

export type GetOrganizationBulkMessageStatsQueryVariables = Exact<{
  filters: MarketingFiltersInput;
}>;


export type GetOrganizationBulkMessageStatsQuery = { __typename?: 'Query', organizationBulkMessageStats: Array<{ __typename?: 'OrgBulkMessageStats', bulk_message_id: string, bulk_message_name: string, clinic_id?: string | null, campaign_id?: string | null, is_active?: boolean | null, total_messages_sent: number, successful_email_sends: number, total_email_opens: number, email_open_rate: number, response_rate: number, direct_attributed_bookings: number, indirect_attributed_bookings: number, total_attributed_bookings: number, total_attributed_revenue: number }> };

export type GetReminderAttributedAppointmentIdsQueryVariables = Exact<{
  filters: MarketingFiltersInput;
}>;


export type GetReminderAttributedAppointmentIdsQuery = { __typename?: 'Query', reminderAttributedAppointmentIds: { __typename?: 'ReminderAttributedAppointmentIds', appointment_ids: Array<string>, limit_hit: boolean } };

export type MessageTemplateFieldsFragment = { __typename?: 'MessageTemplate', id: string, name: string, body: string, created_at: number, updated_at: number };

export type GetMessageTemplateQueryVariables = Exact<{
  id: Scalars['ID']['input'];
}>;


export type GetMessageTemplateQuery = { __typename?: 'Query', messageTemplate: { __typename?: 'MessageTemplate', id: string, name: string, body: string, created_at: number, updated_at: number } };

export type QueryClinicMessageTemplatesQueryVariables = Exact<{
  clinicId: Scalars['ID']['input'];
  where?: InputMaybe<Array<QueryInput> | QueryInput>;
  page?: InputMaybe<Scalars['NonNegativeInt']['input']>;
  pageSize?: InputMaybe<Scalars['NonNegativeInt']['input']>;
  orderBy?: InputMaybe<OrderByInput>;
}>;


export type QueryClinicMessageTemplatesQuery = { __typename?: 'Query', queryClinicMessageTemplates?: Array<{ __typename?: 'MessageTemplate', id: string, name: string, body: string, created_at: number, updated_at: number }> | null };

export type CountClinicMessageTemplatesQueryVariables = Exact<{
  clinicId: Scalars['ID']['input'];
  where?: InputMaybe<Array<QueryInput> | QueryInput>;
}>;


export type CountClinicMessageTemplatesQuery = { __typename?: 'Query', countClinicMessageTemplates?: number | null };

export type QueryClinicGroupMessageTemplatesQueryVariables = Exact<{
  clinicGroupId: Scalars['ID']['input'];
  where?: InputMaybe<Array<QueryInput> | QueryInput>;
  page?: InputMaybe<Scalars['NonNegativeInt']['input']>;
  pageSize?: InputMaybe<Scalars['NonNegativeInt']['input']>;
  orderBy?: InputMaybe<OrderByInput>;
}>;


export type QueryClinicGroupMessageTemplatesQuery = { __typename?: 'Query', queryClinicGroupMessageTemplates?: Array<{ __typename?: 'MessageTemplate', id: string, name: string, body: string, created_at: number, updated_at: number }> | null };

export type CountClinicGroupMessageTemplatesQueryVariables = Exact<{
  clinicGroupId: Scalars['ID']['input'];
  where?: InputMaybe<Array<QueryInput> | QueryInput>;
}>;


export type CountClinicGroupMessageTemplatesQuery = { __typename?: 'Query', countClinicGroupMessageTemplates?: number | null };

export type CreateMessageTemplateMutationVariables = Exact<{
  input: CreateMessageTemplateInput;
}>;


export type CreateMessageTemplateMutation = { __typename?: 'Mutation', createMessageTemplate?: { __typename?: 'MessageTemplate', id: string, name: string, body: string, created_at: number, updated_at: number } | null };

export type UpdateMessageTemplateMutationVariables = Exact<{
  id: Scalars['ID']['input'];
  input: UpdateMessageTemplateInput;
}>;


export type UpdateMessageTemplateMutation = { __typename?: 'Mutation', updateMessageTemplate?: { __typename?: 'MessageTemplate', id: string, name: string, body: string, created_at: number, updated_at: number } | null };

export type DeleteMessageTemplateMutationVariables = Exact<{
  id: Scalars['ID']['input'];
}>;


export type DeleteMessageTemplateMutation = { __typename?: 'Mutation', deleteMessageTemplate?: any | null };

export type AttachmentFieldsFragment = { __typename?: 'Attachment', id: string, url: string, filename: string, type: AttachmentType };

export type MessagePatientFieldsFragment = { __typename?: 'Patient', id: string, name?: string | null, pms_id?: string | null };

export type MessageNotificationTemplateFieldsFragment = { __typename?: 'MessageNotificationTemplate', notification_template: { __typename?: 'NotificationTemplate', id: string, name: string, email_body?: string | null, body?: string | null, subject?: string | null, postcard_template?: string | null, postcard_front_html?: string | null, postcard_back_html?: string | null } };

export type MessageFieldsFragment = { __typename?: 'Message', id: string, text: string, email_text?: string | null, postcard_template?: string | null, message_methods?: Array<MessageMethod> | null, message_type?: MessageType | null, message_origin?: MessageOrigin | null, hidden_for_client?: boolean | null, cta_text?: string | null, cta_url?: string | null, email_error?: string | null, sms_error?: string | null, push_error?: string | null, postcard_error?: string | null, other_errors?: Array<string> | null, is_preview: boolean, written_back_at?: number | null, template_data?: any | null, created_at: number, updated_at: number, client?: { __typename?: 'Client', id: string, first_name?: string | null, last_name?: string | null, phone?: string | null, email?: string | null } | null, chat: { __typename?: 'Chat', id: string, client: { __typename?: 'Client', id: string, first_name?: string | null, last_name?: string | null, phone?: string | null, email?: string | null }, clinic: { __typename?: 'Clinic', id: string, address?: { __typename?: 'Address', street_a?: string | null, street_b?: string | null, city?: string | null, state?: string | null, zip?: string | null, country?: string | null } | null } }, patient?: { __typename?: 'Patient', id: string, name?: string | null, pms_id?: string | null } | null, patients: Array<{ __typename?: 'Patient', id: string, name?: string | null, pms_id?: string | null }>, clinic_user?: { __typename?: 'User', id: string, first_name?: string | null, last_name?: string | null } | null, attachments?: Array<{ __typename?: 'Attachment', id: string, url: string, filename: string, type: AttachmentType }> | null, notification?: { __typename?: 'NotificationTemplate', id: string, name: string, subject?: string | null, body?: string | null, email_body?: string | null, postcard_template?: string | null, postcard_front_html?: string | null, postcard_back_html?: string | null } | null, bulk_message?: { __typename?: 'ScheduledBulkMessage', id: string, name: string, subject?: string | null, body?: string | null, email_body?: string | null } | null, message_notification_templates?: Array<{ __typename?: 'MessageNotificationTemplate', notification_template: { __typename?: 'NotificationTemplate', id: string, name: string, email_body?: string | null, body?: string | null, subject?: string | null, postcard_template?: string | null, postcard_front_html?: string | null, postcard_back_html?: string | null } }> | null, client_phone?: { __typename?: 'ClientPhone', id: string, phone: string, country_code?: string | null, is_primary: boolean, is_chckup_primary: boolean, is_mobile: boolean, sms_available: boolean, is_unsubscribed: boolean, is_active: boolean, name?: string | null } | null };

export type NotificationLogMessageFieldsFragment = { __typename?: 'Message', id: string, text: string, postcard_template?: string | null, message_methods?: Array<MessageMethod> | null, message_type?: MessageType | null, email_error?: string | null, sms_error?: string | null, postcard_error?: string | null, other_errors?: Array<string> | null, is_preview: boolean, template_data?: any | null, created_at: number, client?: { __typename?: 'Client', id: string } | null, chat: { __typename?: 'Chat', id: string, client: { __typename?: 'Client', id: string, first_name?: string | null, last_name?: string | null } }, notification?: { __typename?: 'NotificationTemplate', id: string, name: string, postcard_template?: string | null } | null, bulk_message?: { __typename?: 'ScheduledBulkMessage', id: string, name: string } | null, message_notification_templates?: Array<{ __typename?: 'MessageNotificationTemplate', notification_template: { __typename?: 'NotificationTemplate', id: string, name: string, postcard_template?: string | null } }> | null };

export type ChatMessageFieldsFragment = { __typename?: 'Message', id: string, text: string, email_text?: string | null, postcard_template?: string | null, message_methods?: Array<MessageMethod> | null, message_type?: MessageType | null, message_origin?: MessageOrigin | null, hidden_for_client?: boolean | null, cta_text?: string | null, cta_url?: string | null, email_error?: string | null, sms_error?: string | null, push_error?: string | null, postcard_error?: string | null, other_errors?: Array<string> | null, is_preview: boolean, written_back_at?: number | null, template_data?: any | null, created_at: number, updated_at: number, client?: { __typename?: 'Client', id: string, first_name?: string | null, last_name?: string | null, phone?: string | null, email?: string | null } | null, chat: { __typename?: 'Chat', id: string, clinic: { __typename?: 'Clinic', id: string, name?: string | null } }, patient?: { __typename?: 'Patient', id: string, name?: string | null, pms_id?: string | null } | null, patients: Array<{ __typename?: 'Patient', id: string, name?: string | null, pms_id?: string | null }>, clinic_user?: { __typename?: 'User', id: string, first_name?: string | null, last_name?: string | null } | null, notification?: { __typename?: 'NotificationTemplate', id: string, name: string, subject?: string | null, body?: string | null, email_body?: string | null, postcard_template?: string | null, postcard_front_html?: string | null, postcard_back_html?: string | null } | null, bulk_message?: { __typename?: 'ScheduledBulkMessage', id: string, name: string, subject?: string | null, body?: string | null, email_body?: string | null } | null, call?: { __typename?: 'Call', id: string, status: CallStatus, direction?: CallDirection | null, is_automated?: boolean | null, caller_name?: string | null, caller_phone?: string | null, to_phone?: string | null, duration?: number | null, recording_url?: string | null, transcription_full_text?: string | null, transcription_summary?: string | null, notes?: string | null, score?: number | null, score_reasoning?: string | null, sentiment_customer?: number | null, sentiment_agent?: number | null, created_at: number, updated_at: number, client?: { __typename?: 'Client', first_name?: string | null, last_name?: string | null, phone?: string | null } | null } | null, attachments?: Array<{ __typename?: 'Attachment', id: string, url: string, filename: string, type: AttachmentType }> | null, client_phone?: { __typename?: 'ClientPhone', id: string, phone: string, country_code?: string | null, is_primary: boolean, is_chckup_primary: boolean, is_mobile: boolean, sms_available: boolean, is_unsubscribed: boolean, is_active: boolean, name?: string | null } | null, message_notification_templates?: Array<{ __typename?: 'MessageNotificationTemplate', notification_template: { __typename?: 'NotificationTemplate', id: string, name: string, email_body?: string | null, body?: string | null, subject?: string | null, postcard_template?: string | null, postcard_front_html?: string | null, postcard_back_html?: string | null } }> | null };

export type GetMessagesByChatIdQueryVariables = Exact<{
  chatId: Scalars['ID']['input'];
  page?: InputMaybe<Scalars['NonNegativeInt']['input']>;
  pageSize?: InputMaybe<Scalars['NonNegativeInt']['input']>;
  patientIds?: InputMaybe<Array<Scalars['ID']['input']> | Scalars['ID']['input']>;
}>;


export type GetMessagesByChatIdQuery = { __typename?: 'Query', getMessagesByChatId: Array<{ __typename?: 'Message', id: string, text: string, email_text?: string | null, postcard_template?: string | null, message_methods?: Array<MessageMethod> | null, message_type?: MessageType | null, message_origin?: MessageOrigin | null, hidden_for_client?: boolean | null, cta_text?: string | null, cta_url?: string | null, email_error?: string | null, sms_error?: string | null, push_error?: string | null, postcard_error?: string | null, other_errors?: Array<string> | null, is_preview: boolean, written_back_at?: number | null, template_data?: any | null, created_at: number, updated_at: number, client?: { __typename?: 'Client', id: string, first_name?: string | null, last_name?: string | null, phone?: string | null, email?: string | null } | null, chat: { __typename?: 'Chat', id: string, clinic: { __typename?: 'Clinic', id: string, name?: string | null } }, patient?: { __typename?: 'Patient', id: string, name?: string | null, pms_id?: string | null } | null, patients: Array<{ __typename?: 'Patient', id: string, name?: string | null, pms_id?: string | null }>, clinic_user?: { __typename?: 'User', id: string, first_name?: string | null, last_name?: string | null } | null, notification?: { __typename?: 'NotificationTemplate', id: string, name: string, subject?: string | null, body?: string | null, email_body?: string | null, postcard_template?: string | null, postcard_front_html?: string | null, postcard_back_html?: string | null } | null, bulk_message?: { __typename?: 'ScheduledBulkMessage', id: string, name: string, subject?: string | null, body?: string | null, email_body?: string | null } | null, call?: { __typename?: 'Call', id: string, status: CallStatus, direction?: CallDirection | null, is_automated?: boolean | null, caller_name?: string | null, caller_phone?: string | null, to_phone?: string | null, duration?: number | null, recording_url?: string | null, transcription_full_text?: string | null, transcription_summary?: string | null, notes?: string | null, score?: number | null, score_reasoning?: string | null, sentiment_customer?: number | null, sentiment_agent?: number | null, created_at: number, updated_at: number, client?: { __typename?: 'Client', first_name?: string | null, last_name?: string | null, phone?: string | null } | null } | null, attachments?: Array<{ __typename?: 'Attachment', id: string, url: string, filename: string, type: AttachmentType }> | null, client_phone?: { __typename?: 'ClientPhone', id: string, phone: string, country_code?: string | null, is_primary: boolean, is_chckup_primary: boolean, is_mobile: boolean, sms_available: boolean, is_unsubscribed: boolean, is_active: boolean, name?: string | null } | null, message_notification_templates?: Array<{ __typename?: 'MessageNotificationTemplate', notification_template: { __typename?: 'NotificationTemplate', id: string, name: string, email_body?: string | null, body?: string | null, subject?: string | null, postcard_template?: string | null, postcard_front_html?: string | null, postcard_back_html?: string | null } }> | null }> };

export type GetChatMessagesByChatIdQueryVariables = Exact<{
  chatId: Scalars['ID']['input'];
  page?: InputMaybe<Scalars['NonNegativeInt']['input']>;
  pageSize?: InputMaybe<Scalars['NonNegativeInt']['input']>;
  patientIds?: InputMaybe<Array<Scalars['ID']['input']> | Scalars['ID']['input']>;
  showSystemMessages?: InputMaybe<Scalars['Boolean']['input']>;
}>;


export type GetChatMessagesByChatIdQuery = { __typename?: 'Query', getChatMessagesByChatId: Array<{ __typename?: 'Message', id: string, text: string, email_text?: string | null, postcard_template?: string | null, message_methods?: Array<MessageMethod> | null, message_type?: MessageType | null, message_origin?: MessageOrigin | null, hidden_for_client?: boolean | null, cta_text?: string | null, cta_url?: string | null, email_error?: string | null, sms_error?: string | null, push_error?: string | null, postcard_error?: string | null, other_errors?: Array<string> | null, is_preview: boolean, written_back_at?: number | null, template_data?: any | null, created_at: number, updated_at: number, client?: { __typename?: 'Client', id: string, first_name?: string | null, last_name?: string | null, phone?: string | null, email?: string | null } | null, chat: { __typename?: 'Chat', id: string, clinic: { __typename?: 'Clinic', id: string, name?: string | null } }, patient?: { __typename?: 'Patient', id: string, name?: string | null, pms_id?: string | null } | null, patients: Array<{ __typename?: 'Patient', id: string, name?: string | null, pms_id?: string | null }>, clinic_user?: { __typename?: 'User', id: string, first_name?: string | null, last_name?: string | null } | null, notification?: { __typename?: 'NotificationTemplate', id: string, name: string, subject?: string | null, body?: string | null, email_body?: string | null, postcard_template?: string | null, postcard_front_html?: string | null, postcard_back_html?: string | null } | null, bulk_message?: { __typename?: 'ScheduledBulkMessage', id: string, name: string, subject?: string | null, body?: string | null, email_body?: string | null } | null, call?: { __typename?: 'Call', id: string, status: CallStatus, direction?: CallDirection | null, is_automated?: boolean | null, caller_name?: string | null, caller_phone?: string | null, to_phone?: string | null, duration?: number | null, recording_url?: string | null, transcription_full_text?: string | null, transcription_summary?: string | null, notes?: string | null, score?: number | null, score_reasoning?: string | null, sentiment_customer?: number | null, sentiment_agent?: number | null, created_at: number, updated_at: number, client?: { __typename?: 'Client', first_name?: string | null, last_name?: string | null, phone?: string | null } | null } | null, attachments?: Array<{ __typename?: 'Attachment', id: string, url: string, filename: string, type: AttachmentType }> | null, client_phone?: { __typename?: 'ClientPhone', id: string, phone: string, country_code?: string | null, is_primary: boolean, is_chckup_primary: boolean, is_mobile: boolean, sms_available: boolean, is_unsubscribed: boolean, is_active: boolean, name?: string | null } | null, message_notification_templates?: Array<{ __typename?: 'MessageNotificationTemplate', notification_template: { __typename?: 'NotificationTemplate', id: string, name: string, email_body?: string | null, body?: string | null, subject?: string | null, postcard_template?: string | null, postcard_front_html?: string | null, postcard_back_html?: string | null } }> | null }> };

export type QueryMessagesQueryVariables = Exact<{
  where?: InputMaybe<Array<QueryInput> | QueryInput>;
  page?: InputMaybe<Scalars['NonNegativeInt']['input']>;
  pageSize?: InputMaybe<Scalars['NonNegativeInt']['input']>;
  orderBy?: InputMaybe<OrderByInput>;
}>;


export type QueryMessagesQuery = { __typename?: 'Query', queryMessages: Array<{ __typename?: 'Message', id: string, text: string, email_text?: string | null, postcard_template?: string | null, message_methods?: Array<MessageMethod> | null, message_type?: MessageType | null, message_origin?: MessageOrigin | null, hidden_for_client?: boolean | null, cta_text?: string | null, cta_url?: string | null, email_error?: string | null, sms_error?: string | null, push_error?: string | null, postcard_error?: string | null, other_errors?: Array<string> | null, is_preview: boolean, written_back_at?: number | null, template_data?: any | null, created_at: number, updated_at: number, client?: { __typename?: 'Client', id: string, first_name?: string | null, last_name?: string | null, phone?: string | null, email?: string | null } | null, chat: { __typename?: 'Chat', id: string, clinic: { __typename?: 'Clinic', id: string, name?: string | null } }, patient?: { __typename?: 'Patient', id: string, name?: string | null, pms_id?: string | null } | null, patients: Array<{ __typename?: 'Patient', id: string, name?: string | null, pms_id?: string | null }>, clinic_user?: { __typename?: 'User', id: string, first_name?: string | null, last_name?: string | null } | null, notification?: { __typename?: 'NotificationTemplate', id: string, name: string, subject?: string | null, body?: string | null, email_body?: string | null, postcard_template?: string | null, postcard_front_html?: string | null, postcard_back_html?: string | null } | null, bulk_message?: { __typename?: 'ScheduledBulkMessage', id: string, name: string, subject?: string | null, body?: string | null, email_body?: string | null } | null, call?: { __typename?: 'Call', id: string, status: CallStatus, direction?: CallDirection | null, is_automated?: boolean | null, caller_name?: string | null, caller_phone?: string | null, to_phone?: string | null, duration?: number | null, recording_url?: string | null, transcription_full_text?: string | null, transcription_summary?: string | null, notes?: string | null, score?: number | null, score_reasoning?: string | null, sentiment_customer?: number | null, sentiment_agent?: number | null, created_at: number, updated_at: number, client?: { __typename?: 'Client', first_name?: string | null, last_name?: string | null, phone?: string | null } | null } | null, attachments?: Array<{ __typename?: 'Attachment', id: string, url: string, filename: string, type: AttachmentType }> | null, client_phone?: { __typename?: 'ClientPhone', id: string, phone: string, country_code?: string | null, is_primary: boolean, is_chckup_primary: boolean, is_mobile: boolean, sms_available: boolean, is_unsubscribed: boolean, is_active: boolean, name?: string | null } | null, message_notification_templates?: Array<{ __typename?: 'MessageNotificationTemplate', notification_template: { __typename?: 'NotificationTemplate', id: string, name: string, email_body?: string | null, body?: string | null, subject?: string | null, postcard_template?: string | null, postcard_front_html?: string | null, postcard_back_html?: string | null } }> | null }> };

export type QueryClinicMessagesQueryVariables = Exact<{
  clinicId: Scalars['ID']['input'];
  where?: InputMaybe<Array<QueryInput> | QueryInput>;
  page?: InputMaybe<Scalars['NonNegativeInt']['input']>;
  pageSize?: InputMaybe<Scalars['NonNegativeInt']['input']>;
  orderBy?: InputMaybe<OrderByInput>;
  notificationTemplateIds?: InputMaybe<Array<Scalars['ID']['input']> | Scalars['ID']['input']>;
  patientIds?: InputMaybe<Array<Scalars['ID']['input']> | Scalars['ID']['input']>;
}>;


export type QueryClinicMessagesQuery = { __typename?: 'Query', queryClinicMessages: Array<{ __typename?: 'Message', id: string, text: string, email_text?: string | null, postcard_template?: string | null, message_methods?: Array<MessageMethod> | null, message_type?: MessageType | null, message_origin?: MessageOrigin | null, hidden_for_client?: boolean | null, cta_text?: string | null, cta_url?: string | null, email_error?: string | null, sms_error?: string | null, push_error?: string | null, postcard_error?: string | null, other_errors?: Array<string> | null, is_preview: boolean, written_back_at?: number | null, template_data?: any | null, created_at: number, updated_at: number, client?: { __typename?: 'Client', id: string, first_name?: string | null, last_name?: string | null, phone?: string | null, email?: string | null } | null, chat: { __typename?: 'Chat', id: string, client: { __typename?: 'Client', id: string, first_name?: string | null, last_name?: string | null, phone?: string | null, email?: string | null }, clinic: { __typename?: 'Clinic', id: string, address?: { __typename?: 'Address', street_a?: string | null, street_b?: string | null, city?: string | null, state?: string | null, zip?: string | null, country?: string | null } | null } }, patient?: { __typename?: 'Patient', id: string, name?: string | null, pms_id?: string | null } | null, patients: Array<{ __typename?: 'Patient', id: string, name?: string | null, pms_id?: string | null }>, clinic_user?: { __typename?: 'User', id: string, first_name?: string | null, last_name?: string | null } | null, attachments?: Array<{ __typename?: 'Attachment', id: string, url: string, filename: string, type: AttachmentType }> | null, notification?: { __typename?: 'NotificationTemplate', id: string, name: string, subject?: string | null, body?: string | null, email_body?: string | null, postcard_template?: string | null, postcard_front_html?: string | null, postcard_back_html?: string | null } | null, bulk_message?: { __typename?: 'ScheduledBulkMessage', id: string, name: string, subject?: string | null, body?: string | null, email_body?: string | null } | null, message_notification_templates?: Array<{ __typename?: 'MessageNotificationTemplate', notification_template: { __typename?: 'NotificationTemplate', id: string, name: string, email_body?: string | null, body?: string | null, subject?: string | null, postcard_template?: string | null, postcard_front_html?: string | null, postcard_back_html?: string | null } }> | null, client_phone?: { __typename?: 'ClientPhone', id: string, phone: string, country_code?: string | null, is_primary: boolean, is_chckup_primary: boolean, is_mobile: boolean, sms_available: boolean, is_unsubscribed: boolean, is_active: boolean, name?: string | null } | null }> };

export type QueryClinicNotificationLogMessagesQueryVariables = Exact<{
  clinicId: Scalars['ID']['input'];
  where?: InputMaybe<Array<QueryInput> | QueryInput>;
  page?: InputMaybe<Scalars['NonNegativeInt']['input']>;
  pageSize?: InputMaybe<Scalars['NonNegativeInt']['input']>;
  orderBy?: InputMaybe<OrderByInput>;
  notificationTemplateIds?: InputMaybe<Array<Scalars['ID']['input']> | Scalars['ID']['input']>;
}>;


export type QueryClinicNotificationLogMessagesQuery = { __typename?: 'Query', queryClinicMessages: Array<{ __typename?: 'Message', id: string, text: string, postcard_template?: string | null, message_methods?: Array<MessageMethod> | null, message_type?: MessageType | null, email_error?: string | null, sms_error?: string | null, postcard_error?: string | null, other_errors?: Array<string> | null, is_preview: boolean, template_data?: any | null, created_at: number, client?: { __typename?: 'Client', id: string } | null, chat: { __typename?: 'Chat', id: string, client: { __typename?: 'Client', id: string, first_name?: string | null, last_name?: string | null } }, notification?: { __typename?: 'NotificationTemplate', id: string, name: string, postcard_template?: string | null } | null, bulk_message?: { __typename?: 'ScheduledBulkMessage', id: string, name: string } | null, message_notification_templates?: Array<{ __typename?: 'MessageNotificationTemplate', notification_template: { __typename?: 'NotificationTemplate', id: string, name: string, postcard_template?: string | null } }> | null }> };

export type CountMessagesQueryVariables = Exact<{
  clinicId: Scalars['ID']['input'];
  where?: InputMaybe<Array<QueryInput> | QueryInput>;
  notificationTemplateIds?: InputMaybe<Array<Scalars['ID']['input']> | Scalars['ID']['input']>;
  patientIds?: InputMaybe<Array<Scalars['ID']['input']> | Scalars['ID']['input']>;
}>;


export type CountMessagesQuery = { __typename?: 'Query', countMessages: number };

export type SuggestChatResponseQueryVariables = Exact<{
  chatId: Scalars['ID']['input'];
  existingText?: InputMaybe<Scalars['String']['input']>;
}>;


export type SuggestChatResponseQuery = { __typename?: 'Query', suggestChatResponse: { __typename?: 'SuggestedResponse', response: string, responses_left: number } };

export type CreateMessageMutationVariables = Exact<{
  chatId: Scalars['ID']['input'];
  data: CreateMessageInput;
}>;


export type CreateMessageMutation = { __typename?: 'Mutation', createMessage: { __typename?: 'Message', id: string, text: string, email_text?: string | null, postcard_template?: string | null, message_methods?: Array<MessageMethod> | null, message_type?: MessageType | null, message_origin?: MessageOrigin | null, hidden_for_client?: boolean | null, cta_text?: string | null, cta_url?: string | null, email_error?: string | null, sms_error?: string | null, push_error?: string | null, postcard_error?: string | null, other_errors?: Array<string> | null, is_preview: boolean, written_back_at?: number | null, template_data?: any | null, created_at: number, updated_at: number, client?: { __typename?: 'Client', id: string, first_name?: string | null, last_name?: string | null, phone?: string | null, email?: string | null } | null, chat: { __typename?: 'Chat', id: string, client: { __typename?: 'Client', id: string, first_name?: string | null, last_name?: string | null, phone?: string | null, email?: string | null }, clinic: { __typename?: 'Clinic', id: string, address?: { __typename?: 'Address', street_a?: string | null, street_b?: string | null, city?: string | null, state?: string | null, zip?: string | null, country?: string | null } | null } }, patient?: { __typename?: 'Patient', id: string, name?: string | null, pms_id?: string | null } | null, patients: Array<{ __typename?: 'Patient', id: string, name?: string | null, pms_id?: string | null }>, clinic_user?: { __typename?: 'User', id: string, first_name?: string | null, last_name?: string | null } | null, attachments?: Array<{ __typename?: 'Attachment', id: string, url: string, filename: string, type: AttachmentType }> | null, notification?: { __typename?: 'NotificationTemplate', id: string, name: string, subject?: string | null, body?: string | null, email_body?: string | null, postcard_template?: string | null, postcard_front_html?: string | null, postcard_back_html?: string | null } | null, bulk_message?: { __typename?: 'ScheduledBulkMessage', id: string, name: string, subject?: string | null, body?: string | null, email_body?: string | null } | null, message_notification_templates?: Array<{ __typename?: 'MessageNotificationTemplate', notification_template: { __typename?: 'NotificationTemplate', id: string, name: string, email_body?: string | null, body?: string | null, subject?: string | null, postcard_template?: string | null, postcard_front_html?: string | null, postcard_back_html?: string | null } }> | null, client_phone?: { __typename?: 'ClientPhone', id: string, phone: string, country_code?: string | null, is_primary: boolean, is_chckup_primary: boolean, is_mobile: boolean, sms_available: boolean, is_unsubscribed: boolean, is_active: boolean, name?: string | null } | null } };

export type UpdateMessageMutationVariables = Exact<{
  chatId: Scalars['ID']['input'];
  messageId: Scalars['ID']['input'];
  data: UpdateMessageInput;
}>;


export type UpdateMessageMutation = { __typename?: 'Mutation', updateMessage: { __typename?: 'Message', id: string, text: string, email_text?: string | null, postcard_template?: string | null, message_methods?: Array<MessageMethod> | null, message_type?: MessageType | null, message_origin?: MessageOrigin | null, hidden_for_client?: boolean | null, cta_text?: string | null, cta_url?: string | null, email_error?: string | null, sms_error?: string | null, push_error?: string | null, postcard_error?: string | null, other_errors?: Array<string> | null, is_preview: boolean, written_back_at?: number | null, template_data?: any | null, created_at: number, updated_at: number, client?: { __typename?: 'Client', id: string, first_name?: string | null, last_name?: string | null, phone?: string | null, email?: string | null } | null, chat: { __typename?: 'Chat', id: string, client: { __typename?: 'Client', id: string, first_name?: string | null, last_name?: string | null, phone?: string | null, email?: string | null }, clinic: { __typename?: 'Clinic', id: string, address?: { __typename?: 'Address', street_a?: string | null, street_b?: string | null, city?: string | null, state?: string | null, zip?: string | null, country?: string | null } | null } }, patient?: { __typename?: 'Patient', id: string, name?: string | null, pms_id?: string | null } | null, patients: Array<{ __typename?: 'Patient', id: string, name?: string | null, pms_id?: string | null }>, clinic_user?: { __typename?: 'User', id: string, first_name?: string | null, last_name?: string | null } | null, attachments?: Array<{ __typename?: 'Attachment', id: string, url: string, filename: string, type: AttachmentType }> | null, notification?: { __typename?: 'NotificationTemplate', id: string, name: string, subject?: string | null, body?: string | null, email_body?: string | null, postcard_template?: string | null, postcard_front_html?: string | null, postcard_back_html?: string | null } | null, bulk_message?: { __typename?: 'ScheduledBulkMessage', id: string, name: string, subject?: string | null, body?: string | null, email_body?: string | null } | null, message_notification_templates?: Array<{ __typename?: 'MessageNotificationTemplate', notification_template: { __typename?: 'NotificationTemplate', id: string, name: string, email_body?: string | null, body?: string | null, subject?: string | null, postcard_template?: string | null, postcard_front_html?: string | null, postcard_back_html?: string | null } }> | null, client_phone?: { __typename?: 'ClientPhone', id: string, phone: string, country_code?: string | null, is_primary: boolean, is_chckup_primary: boolean, is_mobile: boolean, sms_available: boolean, is_unsubscribed: boolean, is_active: boolean, name?: string | null } | null } };

export type DeleteMessageMutationVariables = Exact<{
  chatId: Scalars['ID']['input'];
  messageId: Scalars['ID']['input'];
}>;


export type DeleteMessageMutation = { __typename?: 'Mutation', deleteMessage?: any | null };

export type MsgTrackingEventFieldsFragment = { __typename?: 'MsgTrackingEvent', id: string, message_id: string, clinic_id: string, event_type: MsgEventTrackingType, event_value?: string | null, click_id?: string | null, notif_template_id?: string | null, bulk_message_id?: string | null, client_id?: string | null, message_method?: MessageMethod | null, redirect_url?: string | null, created_at: number, updated_at: number };

export type QueryMsgTrackingEventsQueryVariables = Exact<{
  where?: InputMaybe<Array<QueryInput> | QueryInput>;
  page?: InputMaybe<Scalars['NonNegativeInt']['input']>;
  pageSize?: InputMaybe<Scalars['NonNegativeInt']['input']>;
  orderBy?: InputMaybe<OrderByInput>;
}>;


export type QueryMsgTrackingEventsQuery = { __typename?: 'Query', queryMsgTrackingEvents: Array<{ __typename?: 'MsgTrackingEvent', id: string, message_id: string, clinic_id: string, event_type: MsgEventTrackingType, event_value?: string | null, click_id?: string | null, notif_template_id?: string | null, bulk_message_id?: string | null, client_id?: string | null, message_method?: MessageMethod | null, redirect_url?: string | null, created_at: number, updated_at: number }> };

export type CountMsgTrackingEventsQueryVariables = Exact<{
  where?: InputMaybe<Array<QueryInput> | QueryInput>;
}>;


export type CountMsgTrackingEventsQuery = { __typename?: 'Query', countMsgTrackingEvents: number };

export type NotificationEngagementStatsFieldsFragment = { __typename?: 'NotificationEngagementStats', messages_sent: number, emails_sent: number, sms_sent: number, email_unique_opens: number, unique_clicks: number, open_rate: number, click_rate: number };

export type NotificationEngagementFieldsFragment = { __typename?: 'NotificationEngagement', notification_template_id: string, name: string, clinic_id: string, message_methods: Array<MessageMethod>, audience_name?: string | null, category: NotificationAnalyticsCategory, stats: { __typename?: 'NotificationEngagementStats', messages_sent: number, emails_sent: number, sms_sent: number, email_unique_opens: number, unique_clicks: number, open_rate: number, click_rate: number } };

export type NotificationCategoryEngagementFieldsFragment = { __typename?: 'NotificationCategoryEngagement', category: NotificationAnalyticsCategory, notification_count: number, stats: { __typename?: 'NotificationEngagementStats', messages_sent: number, emails_sent: number, sms_sent: number, email_unique_opens: number, unique_clicks: number, open_rate: number, click_rate: number } };

export type GetClinicGroupNotificationAnalyticsQueryVariables = Exact<{
  clinicGroupId: Scalars['ID']['input'];
  clinicIds?: InputMaybe<Array<Scalars['ID']['input']> | Scalars['ID']['input']>;
  range: UsageTimeRangeInput;
}>;


export type GetClinicGroupNotificationAnalyticsQuery = { __typename?: 'Query', clinicGroupNotificationAnalytics: { __typename?: 'NotificationAnalytics', categories: Array<{ __typename?: 'NotificationCategoryEngagement', category: NotificationAnalyticsCategory, notification_count: number, stats: { __typename?: 'NotificationEngagementStats', messages_sent: number, emails_sent: number, sms_sent: number, email_unique_opens: number, unique_clicks: number, open_rate: number, click_rate: number } }>, notifications: Array<{ __typename?: 'NotificationEngagement', notification_template_id: string, name: string, clinic_id: string, message_methods: Array<MessageMethod>, audience_name?: string | null, category: NotificationAnalyticsCategory, stats: { __typename?: 'NotificationEngagementStats', messages_sent: number, emails_sent: number, sms_sent: number, email_unique_opens: number, unique_clicks: number, open_rate: number, click_rate: number } }> } };

export type GetClinicNotificationAnalyticsQueryVariables = Exact<{
  clinicId: Scalars['ID']['input'];
  range: UsageTimeRangeInput;
}>;


export type GetClinicNotificationAnalyticsQuery = { __typename?: 'Query', clinicNotificationAnalytics: { __typename?: 'NotificationAnalytics', categories: Array<{ __typename?: 'NotificationCategoryEngagement', category: NotificationAnalyticsCategory, notification_count: number, stats: { __typename?: 'NotificationEngagementStats', messages_sent: number, emails_sent: number, sms_sent: number, email_unique_opens: number, unique_clicks: number, open_rate: number, click_rate: number } }>, notifications: Array<{ __typename?: 'NotificationEngagement', notification_template_id: string, name: string, clinic_id: string, message_methods: Array<MessageMethod>, audience_name?: string | null, category: NotificationAnalyticsCategory, stats: { __typename?: 'NotificationEngagementStats', messages_sent: number, emails_sent: number, sms_sent: number, email_unique_opens: number, unique_clicks: number, open_rate: number, click_rate: number } }> } };

export type MedicalReminderFunnelCountsFieldsFragment = { __typename?: 'MedicalReminderFunnelCounts', clients_sent: number, clients_opened: number, clients_clicked: number, clients_booked: number, direct_appointments: number, indirect_appointments: number, direct_revenue_cents: number, indirect_revenue_cents: number };

export type MedicalReminderNotificationFunnelFieldsFragment = { __typename?: 'MedicalReminderNotificationFunnel', notification_template_id: string, name: string, clinic_id: string, counts: { __typename?: 'MedicalReminderFunnelCounts', clients_sent: number, clients_opened: number, clients_clicked: number, clients_booked: number, direct_appointments: number, indirect_appointments: number, direct_revenue_cents: number, indirect_revenue_cents: number } };

export type MedicalReminderFunnelFieldsFragment = { __typename?: 'MedicalReminderFunnel', attribution_window_days: number, revenue_lookback_days: number, notification_count: number, counts: { __typename?: 'MedicalReminderFunnelCounts', clients_sent: number, clients_opened: number, clients_clicked: number, clients_booked: number, direct_appointments: number, indirect_appointments: number, direct_revenue_cents: number, indirect_revenue_cents: number }, notifications: Array<{ __typename?: 'MedicalReminderNotificationFunnel', notification_template_id: string, name: string, clinic_id: string, counts: { __typename?: 'MedicalReminderFunnelCounts', clients_sent: number, clients_opened: number, clients_clicked: number, clients_booked: number, direct_appointments: number, indirect_appointments: number, direct_revenue_cents: number, indirect_revenue_cents: number } }> };

export type GetClinicGroupMedicalReminderFunnelQueryVariables = Exact<{
  clinicGroupId: Scalars['ID']['input'];
  clinicIds?: InputMaybe<Array<Scalars['ID']['input']> | Scalars['ID']['input']>;
  range: UsageTimeRangeInput;
  includeNotificationBreakdown?: InputMaybe<Scalars['Boolean']['input']>;
}>;


export type GetClinicGroupMedicalReminderFunnelQuery = { __typename?: 'Query', clinicGroupMedicalReminderFunnel: { __typename?: 'MedicalReminderFunnel', attribution_window_days: number, revenue_lookback_days: number, notification_count: number, counts: { __typename?: 'MedicalReminderFunnelCounts', clients_sent: number, clients_opened: number, clients_clicked: number, clients_booked: number, direct_appointments: number, indirect_appointments: number, direct_revenue_cents: number, indirect_revenue_cents: number }, notifications: Array<{ __typename?: 'MedicalReminderNotificationFunnel', notification_template_id: string, name: string, clinic_id: string, counts: { __typename?: 'MedicalReminderFunnelCounts', clients_sent: number, clients_opened: number, clients_clicked: number, clients_booked: number, direct_appointments: number, indirect_appointments: number, direct_revenue_cents: number, indirect_revenue_cents: number } }> } };

export type GetClinicMedicalReminderFunnelQueryVariables = Exact<{
  clinicId: Scalars['ID']['input'];
  range: UsageTimeRangeInput;
  includeNotificationBreakdown?: InputMaybe<Scalars['Boolean']['input']>;
}>;


export type GetClinicMedicalReminderFunnelQuery = { __typename?: 'Query', clinicMedicalReminderFunnel: { __typename?: 'MedicalReminderFunnel', attribution_window_days: number, revenue_lookback_days: number, notification_count: number, counts: { __typename?: 'MedicalReminderFunnelCounts', clients_sent: number, clients_opened: number, clients_clicked: number, clients_booked: number, direct_appointments: number, indirect_appointments: number, direct_revenue_cents: number, indirect_revenue_cents: number }, notifications: Array<{ __typename?: 'MedicalReminderNotificationFunnel', notification_template_id: string, name: string, clinic_id: string, counts: { __typename?: 'MedicalReminderFunnelCounts', clients_sent: number, clients_opened: number, clients_clicked: number, clients_booked: number, direct_appointments: number, indirect_appointments: number, direct_revenue_cents: number, indirect_revenue_cents: number } }> } };

export type NotificationTemplateFieldsFragment = { __typename?: 'NotificationTemplate', id: string, name: string, every_x_hours: number, send_time_minutes?: number | null, body?: string | null, email_body?: string | null, email_design?: any | null, email_html?: string | null, repeating_body?: string | null, grouping_method: NotificationGroupingMethod, message_methods: Array<MessageMethod>, is_marketing: boolean, is_active: boolean, is_system: boolean, subject?: string | null, cta_text?: string | null, cta_url?: string | null, default_service_id?: string | null, postcard_template?: string | null, postcard_front_html?: string | null, postcard_back_html?: string | null, is_archived: boolean, is_preview_mode: boolean, updated_at: number, created_at: number, email_template?: { __typename?: 'EmailTemplate', id: string, title: string, subject?: string | null, design?: any | null, html?: string | null, status: EmailTemplateStatus, created_at: number, updated_at: number, clinic?: { __typename?: 'Clinic', id: string } | null, clinic_group?: { __typename?: 'ClinicGroup', id: string, name: string } | null } | null, notif_attachments?: Array<{ __typename?: 'Attachment', id: string, filename: string, type: AttachmentType, url: string }> | null, customer_segment?: { __typename?: 'CustomerSegment', id: string, name: string, trigger_entity?: CustomerSegmentTrigger | null, is_hourly?: boolean | null, group_days_ahead?: number | null, should_include_all_overdue?: boolean | null, included_clients?: Array<string> | null, excluded_clients?: Array<string> | null, other_result_exclusion_entity?: string | null, is_archived: boolean, created_at: number, updated_at: number, filters?: Array<{ __typename?: 'CustomerSegmentFilter', type: CustomerSegmentFilterType, only_consider_other_rows?: boolean | null, filters: Array<{ __typename?: 'QueryFilter', column: string, filterOp: FilterOp, value: { __typename?: 'QueryFilterValue', string?: string | null, float?: number | null, boolean?: boolean | null, stringArray?: Array<string> | null, floatArray?: Array<number> | null, millisFromNow?: number | null, relativeTime?: { __typename?: 'RelativeTime', quantity: number, unit: TimeUnit, direction: ReferenceDirection } | null } }> }> | null, excluded_filters: Array<{ __typename?: 'CustomerSegmentFilter', type: CustomerSegmentFilterType, only_consider_other_rows?: boolean | null, filters: Array<{ __typename?: 'QueryFilter', column: string, filterOp: FilterOp, value: { __typename?: 'QueryFilterValue', string?: string | null, float?: number | null, boolean?: boolean | null, stringArray?: Array<string> | null, floatArray?: Array<number> | null, millisFromNow?: number | null, relativeTime?: { __typename?: 'RelativeTime', quantity: number, unit: TimeUnit, direction: ReferenceDirection } | null } }> }>, all_inclusions?: Array<{ __typename?: 'SegmentFilter', foreign_table?: string | null, group?: string | null, parameters: Array<{ __typename?: 'QueryFilter', column: string, filterOp: FilterOp, value: { __typename?: 'QueryFilterValue', string?: string | null, float?: number | null, boolean?: boolean | null, stringArray?: Array<string> | null, floatArray?: Array<number> | null, millisFromNow?: number | null, relativeTime?: { __typename?: 'RelativeTime', quantity: number, unit: TimeUnit, direction: ReferenceDirection } | null } }> }> | null, any_inclusions?: Array<{ __typename?: 'SegmentFilter', foreign_table?: string | null, group?: string | null, parameters: Array<{ __typename?: 'QueryFilter', column: string, filterOp: FilterOp, value: { __typename?: 'QueryFilterValue', string?: string | null, float?: number | null, boolean?: boolean | null, stringArray?: Array<string> | null, floatArray?: Array<number> | null, millisFromNow?: number | null, relativeTime?: { __typename?: 'RelativeTime', quantity: number, unit: TimeUnit, direction: ReferenceDirection } | null } }> }> | null, any_exclusions?: Array<{ __typename?: 'SegmentFilter', foreign_table?: string | null, group?: string | null, parameters: Array<{ __typename?: 'QueryFilter', column: string, filterOp: FilterOp, value: { __typename?: 'QueryFilterValue', string?: string | null, float?: number | null, boolean?: boolean | null, stringArray?: Array<string> | null, floatArray?: Array<number> | null, millisFromNow?: number | null, relativeTime?: { __typename?: 'RelativeTime', quantity: number, unit: TimeUnit, direction: ReferenceDirection } | null } }> }> | null, any_other_exclusions?: Array<{ __typename?: 'SegmentFilter', foreign_table?: string | null, group?: string | null, parameters: Array<{ __typename?: 'QueryFilter', column: string, filterOp: FilterOp, value: { __typename?: 'QueryFilterValue', string?: string | null, float?: number | null, boolean?: boolean | null, stringArray?: Array<string> | null, floatArray?: Array<number> | null, millisFromNow?: number | null, relativeTime?: { __typename?: 'RelativeTime', quantity: number, unit: TimeUnit, direction: ReferenceDirection } | null } }> }> | null, default_exclusions_options: { __typename?: 'DefaultExclusionsOptions', exclude_cancelled_and_rescheduled_resources?: boolean | null, exclude_euthanasia_and_qol_resources?: boolean | null, exclude_euthanasia_and_qol_in_appt_notes?: boolean | null }, reference_date_params?: { __typename?: 'ReferenceDateParams', field: string, reference_periods?: Array<{ __typename?: 'ReferencePeriod', quantity: number, unit: TimeUnit, direction: ReferenceDirection }> | null } | null, notification_templates?: Array<{ __typename?: 'NotificationTemplate', id: string, name: string, is_active: boolean, is_archived: boolean, message_methods: Array<MessageMethod> }> | null, error_flags?: Array<{ __typename?: 'CustomerSegmentErrorFlag', filter_column: string, filter_index: number, parameter_index: number, message: string }> | null } | null, clinic?: { __typename?: 'Clinic', id: string, name?: string | null } | null, campaign?: { __typename?: 'Campaign', id: string, name: string, color?: string | null, description?: string | null } | null };

export type NotificationTemplatePreviewFieldsFragment = { __typename?: 'NotificationTemplate', id: string, name: string, is_active: boolean, is_archived: boolean, message_methods: Array<MessageMethod> };

export type NotificationTemplateQueryVariables = Exact<{
  notificationTemplateId: Scalars['ID']['input'];
}>;


export type NotificationTemplateQuery = { __typename?: 'Query', notificationTemplate: { __typename?: 'NotificationTemplate', id: string, name: string, every_x_hours: number, send_time_minutes?: number | null, body?: string | null, email_body?: string | null, email_design?: any | null, email_html?: string | null, repeating_body?: string | null, grouping_method: NotificationGroupingMethod, message_methods: Array<MessageMethod>, is_marketing: boolean, is_active: boolean, is_system: boolean, subject?: string | null, cta_text?: string | null, cta_url?: string | null, default_service_id?: string | null, postcard_template?: string | null, postcard_front_html?: string | null, postcard_back_html?: string | null, is_archived: boolean, is_preview_mode: boolean, updated_at: number, created_at: number, email_template?: { __typename?: 'EmailTemplate', id: string, title: string, subject?: string | null, design?: any | null, html?: string | null, status: EmailTemplateStatus, created_at: number, updated_at: number, clinic?: { __typename?: 'Clinic', id: string } | null, clinic_group?: { __typename?: 'ClinicGroup', id: string, name: string } | null } | null, notif_attachments?: Array<{ __typename?: 'Attachment', id: string, filename: string, type: AttachmentType, url: string }> | null, customer_segment?: { __typename?: 'CustomerSegment', id: string, name: string, trigger_entity?: CustomerSegmentTrigger | null, is_hourly?: boolean | null, group_days_ahead?: number | null, should_include_all_overdue?: boolean | null, included_clients?: Array<string> | null, excluded_clients?: Array<string> | null, other_result_exclusion_entity?: string | null, is_archived: boolean, created_at: number, updated_at: number, filters?: Array<{ __typename?: 'CustomerSegmentFilter', type: CustomerSegmentFilterType, only_consider_other_rows?: boolean | null, filters: Array<{ __typename?: 'QueryFilter', column: string, filterOp: FilterOp, value: { __typename?: 'QueryFilterValue', string?: string | null, float?: number | null, boolean?: boolean | null, stringArray?: Array<string> | null, floatArray?: Array<number> | null, millisFromNow?: number | null, relativeTime?: { __typename?: 'RelativeTime', quantity: number, unit: TimeUnit, direction: ReferenceDirection } | null } }> }> | null, excluded_filters: Array<{ __typename?: 'CustomerSegmentFilter', type: CustomerSegmentFilterType, only_consider_other_rows?: boolean | null, filters: Array<{ __typename?: 'QueryFilter', column: string, filterOp: FilterOp, value: { __typename?: 'QueryFilterValue', string?: string | null, float?: number | null, boolean?: boolean | null, stringArray?: Array<string> | null, floatArray?: Array<number> | null, millisFromNow?: number | null, relativeTime?: { __typename?: 'RelativeTime', quantity: number, unit: TimeUnit, direction: ReferenceDirection } | null } }> }>, all_inclusions?: Array<{ __typename?: 'SegmentFilter', foreign_table?: string | null, group?: string | null, parameters: Array<{ __typename?: 'QueryFilter', column: string, filterOp: FilterOp, value: { __typename?: 'QueryFilterValue', string?: string | null, float?: number | null, boolean?: boolean | null, stringArray?: Array<string> | null, floatArray?: Array<number> | null, millisFromNow?: number | null, relativeTime?: { __typename?: 'RelativeTime', quantity: number, unit: TimeUnit, direction: ReferenceDirection } | null } }> }> | null, any_inclusions?: Array<{ __typename?: 'SegmentFilter', foreign_table?: string | null, group?: string | null, parameters: Array<{ __typename?: 'QueryFilter', column: string, filterOp: FilterOp, value: { __typename?: 'QueryFilterValue', string?: string | null, float?: number | null, boolean?: boolean | null, stringArray?: Array<string> | null, floatArray?: Array<number> | null, millisFromNow?: number | null, relativeTime?: { __typename?: 'RelativeTime', quantity: number, unit: TimeUnit, direction: ReferenceDirection } | null } }> }> | null, any_exclusions?: Array<{ __typename?: 'SegmentFilter', foreign_table?: string | null, group?: string | null, parameters: Array<{ __typename?: 'QueryFilter', column: string, filterOp: FilterOp, value: { __typename?: 'QueryFilterValue', string?: string | null, float?: number | null, boolean?: boolean | null, stringArray?: Array<string> | null, floatArray?: Array<number> | null, millisFromNow?: number | null, relativeTime?: { __typename?: 'RelativeTime', quantity: number, unit: TimeUnit, direction: ReferenceDirection } | null } }> }> | null, any_other_exclusions?: Array<{ __typename?: 'SegmentFilter', foreign_table?: string | null, group?: string | null, parameters: Array<{ __typename?: 'QueryFilter', column: string, filterOp: FilterOp, value: { __typename?: 'QueryFilterValue', string?: string | null, float?: number | null, boolean?: boolean | null, stringArray?: Array<string> | null, floatArray?: Array<number> | null, millisFromNow?: number | null, relativeTime?: { __typename?: 'RelativeTime', quantity: number, unit: TimeUnit, direction: ReferenceDirection } | null } }> }> | null, default_exclusions_options: { __typename?: 'DefaultExclusionsOptions', exclude_cancelled_and_rescheduled_resources?: boolean | null, exclude_euthanasia_and_qol_resources?: boolean | null, exclude_euthanasia_and_qol_in_appt_notes?: boolean | null }, reference_date_params?: { __typename?: 'ReferenceDateParams', field: string, reference_periods?: Array<{ __typename?: 'ReferencePeriod', quantity: number, unit: TimeUnit, direction: ReferenceDirection }> | null } | null, notification_templates?: Array<{ __typename?: 'NotificationTemplate', id: string, name: string, is_active: boolean, is_archived: boolean, message_methods: Array<MessageMethod> }> | null, error_flags?: Array<{ __typename?: 'CustomerSegmentErrorFlag', filter_column: string, filter_index: number, parameter_index: number, message: string }> | null } | null, clinic?: { __typename?: 'Clinic', id: string, name?: string | null } | null, campaign?: { __typename?: 'Campaign', id: string, name: string, color?: string | null, description?: string | null } | null } };

export type GetNotificationTemplatesByClinicIdQueryVariables = Exact<{
  clinicId: Scalars['ID']['input'];
}>;


export type GetNotificationTemplatesByClinicIdQuery = { __typename?: 'Query', getNotificationTemplatesByClinicId: Array<{ __typename?: 'NotificationTemplate', id: string, name: string, every_x_hours: number, send_time_minutes?: number | null, body?: string | null, email_body?: string | null, email_design?: any | null, email_html?: string | null, repeating_body?: string | null, grouping_method: NotificationGroupingMethod, message_methods: Array<MessageMethod>, is_marketing: boolean, is_active: boolean, is_system: boolean, subject?: string | null, cta_text?: string | null, cta_url?: string | null, default_service_id?: string | null, postcard_template?: string | null, postcard_front_html?: string | null, postcard_back_html?: string | null, is_archived: boolean, is_preview_mode: boolean, updated_at: number, created_at: number, email_template?: { __typename?: 'EmailTemplate', id: string, title: string, subject?: string | null, design?: any | null, html?: string | null, status: EmailTemplateStatus, created_at: number, updated_at: number, clinic?: { __typename?: 'Clinic', id: string } | null, clinic_group?: { __typename?: 'ClinicGroup', id: string, name: string } | null } | null, notif_attachments?: Array<{ __typename?: 'Attachment', id: string, filename: string, type: AttachmentType, url: string }> | null, customer_segment?: { __typename?: 'CustomerSegment', id: string, name: string, trigger_entity?: CustomerSegmentTrigger | null, is_hourly?: boolean | null, group_days_ahead?: number | null, should_include_all_overdue?: boolean | null, included_clients?: Array<string> | null, excluded_clients?: Array<string> | null, other_result_exclusion_entity?: string | null, is_archived: boolean, created_at: number, updated_at: number, filters?: Array<{ __typename?: 'CustomerSegmentFilter', type: CustomerSegmentFilterType, only_consider_other_rows?: boolean | null, filters: Array<{ __typename?: 'QueryFilter', column: string, filterOp: FilterOp, value: { __typename?: 'QueryFilterValue', string?: string | null, float?: number | null, boolean?: boolean | null, stringArray?: Array<string> | null, floatArray?: Array<number> | null, millisFromNow?: number | null, relativeTime?: { __typename?: 'RelativeTime', quantity: number, unit: TimeUnit, direction: ReferenceDirection } | null } }> }> | null, excluded_filters: Array<{ __typename?: 'CustomerSegmentFilter', type: CustomerSegmentFilterType, only_consider_other_rows?: boolean | null, filters: Array<{ __typename?: 'QueryFilter', column: string, filterOp: FilterOp, value: { __typename?: 'QueryFilterValue', string?: string | null, float?: number | null, boolean?: boolean | null, stringArray?: Array<string> | null, floatArray?: Array<number> | null, millisFromNow?: number | null, relativeTime?: { __typename?: 'RelativeTime', quantity: number, unit: TimeUnit, direction: ReferenceDirection } | null } }> }>, all_inclusions?: Array<{ __typename?: 'SegmentFilter', foreign_table?: string | null, group?: string | null, parameters: Array<{ __typename?: 'QueryFilter', column: string, filterOp: FilterOp, value: { __typename?: 'QueryFilterValue', string?: string | null, float?: number | null, boolean?: boolean | null, stringArray?: Array<string> | null, floatArray?: Array<number> | null, millisFromNow?: number | null, relativeTime?: { __typename?: 'RelativeTime', quantity: number, unit: TimeUnit, direction: ReferenceDirection } | null } }> }> | null, any_inclusions?: Array<{ __typename?: 'SegmentFilter', foreign_table?: string | null, group?: string | null, parameters: Array<{ __typename?: 'QueryFilter', column: string, filterOp: FilterOp, value: { __typename?: 'QueryFilterValue', string?: string | null, float?: number | null, boolean?: boolean | null, stringArray?: Array<string> | null, floatArray?: Array<number> | null, millisFromNow?: number | null, relativeTime?: { __typename?: 'RelativeTime', quantity: number, unit: TimeUnit, direction: ReferenceDirection } | null } }> }> | null, any_exclusions?: Array<{ __typename?: 'SegmentFilter', foreign_table?: string | null, group?: string | null, parameters: Array<{ __typename?: 'QueryFilter', column: string, filterOp: FilterOp, value: { __typename?: 'QueryFilterValue', string?: string | null, float?: number | null, boolean?: boolean | null, stringArray?: Array<string> | null, floatArray?: Array<number> | null, millisFromNow?: number | null, relativeTime?: { __typename?: 'RelativeTime', quantity: number, unit: TimeUnit, direction: ReferenceDirection } | null } }> }> | null, any_other_exclusions?: Array<{ __typename?: 'SegmentFilter', foreign_table?: string | null, group?: string | null, parameters: Array<{ __typename?: 'QueryFilter', column: string, filterOp: FilterOp, value: { __typename?: 'QueryFilterValue', string?: string | null, float?: number | null, boolean?: boolean | null, stringArray?: Array<string> | null, floatArray?: Array<number> | null, millisFromNow?: number | null, relativeTime?: { __typename?: 'RelativeTime', quantity: number, unit: TimeUnit, direction: ReferenceDirection } | null } }> }> | null, default_exclusions_options: { __typename?: 'DefaultExclusionsOptions', exclude_cancelled_and_rescheduled_resources?: boolean | null, exclude_euthanasia_and_qol_resources?: boolean | null, exclude_euthanasia_and_qol_in_appt_notes?: boolean | null }, reference_date_params?: { __typename?: 'ReferenceDateParams', field: string, reference_periods?: Array<{ __typename?: 'ReferencePeriod', quantity: number, unit: TimeUnit, direction: ReferenceDirection }> | null } | null, notification_templates?: Array<{ __typename?: 'NotificationTemplate', id: string, name: string, is_active: boolean, is_archived: boolean, message_methods: Array<MessageMethod> }> | null, error_flags?: Array<{ __typename?: 'CustomerSegmentErrorFlag', filter_column: string, filter_index: number, parameter_index: number, message: string }> | null } | null, clinic?: { __typename?: 'Clinic', id: string, name?: string | null } | null, campaign?: { __typename?: 'Campaign', id: string, name: string, color?: string | null, description?: string | null } | null }> };

export type QueryNotificationTemplatesQueryVariables = Exact<{
  where?: InputMaybe<Array<QueryInput> | QueryInput>;
  page?: InputMaybe<Scalars['NonNegativeInt']['input']>;
  pageSize?: InputMaybe<Scalars['NonNegativeInt']['input']>;
  orderBy?: InputMaybe<OrderByInput>;
}>;


export type QueryNotificationTemplatesQuery = { __typename?: 'Query', queryNotificationTemplates: Array<{ __typename?: 'NotificationTemplate', id: string, name: string, every_x_hours: number, send_time_minutes?: number | null, body?: string | null, email_body?: string | null, email_design?: any | null, email_html?: string | null, repeating_body?: string | null, grouping_method: NotificationGroupingMethod, message_methods: Array<MessageMethod>, is_marketing: boolean, is_active: boolean, is_system: boolean, subject?: string | null, cta_text?: string | null, cta_url?: string | null, default_service_id?: string | null, postcard_template?: string | null, postcard_front_html?: string | null, postcard_back_html?: string | null, is_archived: boolean, is_preview_mode: boolean, updated_at: number, created_at: number, email_template?: { __typename?: 'EmailTemplate', id: string, title: string, subject?: string | null, design?: any | null, html?: string | null, status: EmailTemplateStatus, created_at: number, updated_at: number, clinic?: { __typename?: 'Clinic', id: string } | null, clinic_group?: { __typename?: 'ClinicGroup', id: string, name: string } | null } | null, notif_attachments?: Array<{ __typename?: 'Attachment', id: string, filename: string, type: AttachmentType, url: string }> | null, customer_segment?: { __typename?: 'CustomerSegment', id: string, name: string, trigger_entity?: CustomerSegmentTrigger | null, is_hourly?: boolean | null, group_days_ahead?: number | null, should_include_all_overdue?: boolean | null, included_clients?: Array<string> | null, excluded_clients?: Array<string> | null, other_result_exclusion_entity?: string | null, is_archived: boolean, created_at: number, updated_at: number, filters?: Array<{ __typename?: 'CustomerSegmentFilter', type: CustomerSegmentFilterType, only_consider_other_rows?: boolean | null, filters: Array<{ __typename?: 'QueryFilter', column: string, filterOp: FilterOp, value: { __typename?: 'QueryFilterValue', string?: string | null, float?: number | null, boolean?: boolean | null, stringArray?: Array<string> | null, floatArray?: Array<number> | null, millisFromNow?: number | null, relativeTime?: { __typename?: 'RelativeTime', quantity: number, unit: TimeUnit, direction: ReferenceDirection } | null } }> }> | null, excluded_filters: Array<{ __typename?: 'CustomerSegmentFilter', type: CustomerSegmentFilterType, only_consider_other_rows?: boolean | null, filters: Array<{ __typename?: 'QueryFilter', column: string, filterOp: FilterOp, value: { __typename?: 'QueryFilterValue', string?: string | null, float?: number | null, boolean?: boolean | null, stringArray?: Array<string> | null, floatArray?: Array<number> | null, millisFromNow?: number | null, relativeTime?: { __typename?: 'RelativeTime', quantity: number, unit: TimeUnit, direction: ReferenceDirection } | null } }> }>, all_inclusions?: Array<{ __typename?: 'SegmentFilter', foreign_table?: string | null, group?: string | null, parameters: Array<{ __typename?: 'QueryFilter', column: string, filterOp: FilterOp, value: { __typename?: 'QueryFilterValue', string?: string | null, float?: number | null, boolean?: boolean | null, stringArray?: Array<string> | null, floatArray?: Array<number> | null, millisFromNow?: number | null, relativeTime?: { __typename?: 'RelativeTime', quantity: number, unit: TimeUnit, direction: ReferenceDirection } | null } }> }> | null, any_inclusions?: Array<{ __typename?: 'SegmentFilter', foreign_table?: string | null, group?: string | null, parameters: Array<{ __typename?: 'QueryFilter', column: string, filterOp: FilterOp, value: { __typename?: 'QueryFilterValue', string?: string | null, float?: number | null, boolean?: boolean | null, stringArray?: Array<string> | null, floatArray?: Array<number> | null, millisFromNow?: number | null, relativeTime?: { __typename?: 'RelativeTime', quantity: number, unit: TimeUnit, direction: ReferenceDirection } | null } }> }> | null, any_exclusions?: Array<{ __typename?: 'SegmentFilter', foreign_table?: string | null, group?: string | null, parameters: Array<{ __typename?: 'QueryFilter', column: string, filterOp: FilterOp, value: { __typename?: 'QueryFilterValue', string?: string | null, float?: number | null, boolean?: boolean | null, stringArray?: Array<string> | null, floatArray?: Array<number> | null, millisFromNow?: number | null, relativeTime?: { __typename?: 'RelativeTime', quantity: number, unit: TimeUnit, direction: ReferenceDirection } | null } }> }> | null, any_other_exclusions?: Array<{ __typename?: 'SegmentFilter', foreign_table?: string | null, group?: string | null, parameters: Array<{ __typename?: 'QueryFilter', column: string, filterOp: FilterOp, value: { __typename?: 'QueryFilterValue', string?: string | null, float?: number | null, boolean?: boolean | null, stringArray?: Array<string> | null, floatArray?: Array<number> | null, millisFromNow?: number | null, relativeTime?: { __typename?: 'RelativeTime', quantity: number, unit: TimeUnit, direction: ReferenceDirection } | null } }> }> | null, default_exclusions_options: { __typename?: 'DefaultExclusionsOptions', exclude_cancelled_and_rescheduled_resources?: boolean | null, exclude_euthanasia_and_qol_resources?: boolean | null, exclude_euthanasia_and_qol_in_appt_notes?: boolean | null }, reference_date_params?: { __typename?: 'ReferenceDateParams', field: string, reference_periods?: Array<{ __typename?: 'ReferencePeriod', quantity: number, unit: TimeUnit, direction: ReferenceDirection }> | null } | null, notification_templates?: Array<{ __typename?: 'NotificationTemplate', id: string, name: string, is_active: boolean, is_archived: boolean, message_methods: Array<MessageMethod> }> | null, error_flags?: Array<{ __typename?: 'CustomerSegmentErrorFlag', filter_column: string, filter_index: number, parameter_index: number, message: string }> | null } | null, clinic?: { __typename?: 'Clinic', id: string, name?: string | null } | null, campaign?: { __typename?: 'Campaign', id: string, name: string, color?: string | null, description?: string | null } | null }> };

export type CountNotificationTemplatesQueryVariables = Exact<{
  where?: InputMaybe<Array<QueryInput> | QueryInput>;
}>;


export type CountNotificationTemplatesQuery = { __typename?: 'Query', countNotificationTemplates: number };

export type GetNotificationTemplateStatsQueryVariables = Exact<{
  id: Scalars['ID']['input'];
}>;


export type GetNotificationTemplateStatsQuery = { __typename?: 'Query', notificationTemplateTrackingStats: { __typename?: 'NotificationTemplateTrackingStats', unique_clients: number, messages_sent: number, emails_sent: number, sms_sent: number, email_opens: number, email_open_rate: number, email_unique_opens: number, email_unique_open_rate: number, email_clicks: number, email_click_rate: number, email_unique_clicks: number, email_unique_click_rate: number, sms_clicks: number, sms_click_rate: number, sms_unique_clicks: number, sms_unique_click_rate: number, conversion_rate: number, direct_appointments: number, indirect_appointments: number, revenue_by_appt: number, postcards_sent: number, postcards_failed: number, postcard_qr_scans: number, postcard_unique_qr_scans: number, postcard_spend_cents: number, postcard_direct_appointments: number, postcard_indirect_appointments: number, postcard_direct_revenue_cents: number, postcard_indirect_revenue_cents: number, postcard_revenue_cents: number, postcard_roi: number } };

export type NotificationMessagesByReferencePeriodQueryVariables = Exact<{
  notificationId: Scalars['ID']['input'];
  startDate: Scalars['NonNegativeInt']['input'];
  endDate: Scalars['NonNegativeInt']['input'];
  includePreview?: InputMaybe<Scalars['Boolean']['input']>;
}>;


export type NotificationMessagesByReferencePeriodQuery = { __typename?: 'Query', notificationMessagesByReferencePeriod: { __typename?: 'NotificationMessagesByReferencePeriodResult', notification_id: string, start_date: number, end_date: number, total_messages: number, buckets: Array<{ __typename?: 'NotificationReferencePeriodMessageBucket', reference_period_key: string, count: number, message_ids: Array<string>, emails_sent: number, sms_sent: number, email_opens: number, email_open_rate: number, email_unique_opens: number, email_unique_open_rate: number, email_clicks: number, email_click_rate: number, email_unique_clicks: number, email_unique_click_rate: number, sms_clicks: number, sms_click_rate: number, sms_unique_clicks: number, sms_unique_click_rate: number, reference_period: { __typename?: 'ReferencePeriod', quantity: number, unit: TimeUnit, direction: ReferenceDirection } }> } };

export type CreateNotificationTemplateMutationVariables = Exact<{
  data: CreateNotificationTemplateInput;
}>;


export type CreateNotificationTemplateMutation = { __typename?: 'Mutation', createNotificationTemplate: { __typename?: 'NotificationTemplate', id: string, name: string, every_x_hours: number, send_time_minutes?: number | null, body?: string | null, email_body?: string | null, email_design?: any | null, email_html?: string | null, repeating_body?: string | null, grouping_method: NotificationGroupingMethod, message_methods: Array<MessageMethod>, is_marketing: boolean, is_active: boolean, is_system: boolean, subject?: string | null, cta_text?: string | null, cta_url?: string | null, default_service_id?: string | null, postcard_template?: string | null, postcard_front_html?: string | null, postcard_back_html?: string | null, is_archived: boolean, is_preview_mode: boolean, updated_at: number, created_at: number, email_template?: { __typename?: 'EmailTemplate', id: string, title: string, subject?: string | null, design?: any | null, html?: string | null, status: EmailTemplateStatus, created_at: number, updated_at: number, clinic?: { __typename?: 'Clinic', id: string } | null, clinic_group?: { __typename?: 'ClinicGroup', id: string, name: string } | null } | null, notif_attachments?: Array<{ __typename?: 'Attachment', id: string, filename: string, type: AttachmentType, url: string }> | null, customer_segment?: { __typename?: 'CustomerSegment', id: string, name: string, trigger_entity?: CustomerSegmentTrigger | null, is_hourly?: boolean | null, group_days_ahead?: number | null, should_include_all_overdue?: boolean | null, included_clients?: Array<string> | null, excluded_clients?: Array<string> | null, other_result_exclusion_entity?: string | null, is_archived: boolean, created_at: number, updated_at: number, filters?: Array<{ __typename?: 'CustomerSegmentFilter', type: CustomerSegmentFilterType, only_consider_other_rows?: boolean | null, filters: Array<{ __typename?: 'QueryFilter', column: string, filterOp: FilterOp, value: { __typename?: 'QueryFilterValue', string?: string | null, float?: number | null, boolean?: boolean | null, stringArray?: Array<string> | null, floatArray?: Array<number> | null, millisFromNow?: number | null, relativeTime?: { __typename?: 'RelativeTime', quantity: number, unit: TimeUnit, direction: ReferenceDirection } | null } }> }> | null, excluded_filters: Array<{ __typename?: 'CustomerSegmentFilter', type: CustomerSegmentFilterType, only_consider_other_rows?: boolean | null, filters: Array<{ __typename?: 'QueryFilter', column: string, filterOp: FilterOp, value: { __typename?: 'QueryFilterValue', string?: string | null, float?: number | null, boolean?: boolean | null, stringArray?: Array<string> | null, floatArray?: Array<number> | null, millisFromNow?: number | null, relativeTime?: { __typename?: 'RelativeTime', quantity: number, unit: TimeUnit, direction: ReferenceDirection } | null } }> }>, all_inclusions?: Array<{ __typename?: 'SegmentFilter', foreign_table?: string | null, group?: string | null, parameters: Array<{ __typename?: 'QueryFilter', column: string, filterOp: FilterOp, value: { __typename?: 'QueryFilterValue', string?: string | null, float?: number | null, boolean?: boolean | null, stringArray?: Array<string> | null, floatArray?: Array<number> | null, millisFromNow?: number | null, relativeTime?: { __typename?: 'RelativeTime', quantity: number, unit: TimeUnit, direction: ReferenceDirection } | null } }> }> | null, any_inclusions?: Array<{ __typename?: 'SegmentFilter', foreign_table?: string | null, group?: string | null, parameters: Array<{ __typename?: 'QueryFilter', column: string, filterOp: FilterOp, value: { __typename?: 'QueryFilterValue', string?: string | null, float?: number | null, boolean?: boolean | null, stringArray?: Array<string> | null, floatArray?: Array<number> | null, millisFromNow?: number | null, relativeTime?: { __typename?: 'RelativeTime', quantity: number, unit: TimeUnit, direction: ReferenceDirection } | null } }> }> | null, any_exclusions?: Array<{ __typename?: 'SegmentFilter', foreign_table?: string | null, group?: string | null, parameters: Array<{ __typename?: 'QueryFilter', column: string, filterOp: FilterOp, value: { __typename?: 'QueryFilterValue', string?: string | null, float?: number | null, boolean?: boolean | null, stringArray?: Array<string> | null, floatArray?: Array<number> | null, millisFromNow?: number | null, relativeTime?: { __typename?: 'RelativeTime', quantity: number, unit: TimeUnit, direction: ReferenceDirection } | null } }> }> | null, any_other_exclusions?: Array<{ __typename?: 'SegmentFilter', foreign_table?: string | null, group?: string | null, parameters: Array<{ __typename?: 'QueryFilter', column: string, filterOp: FilterOp, value: { __typename?: 'QueryFilterValue', string?: string | null, float?: number | null, boolean?: boolean | null, stringArray?: Array<string> | null, floatArray?: Array<number> | null, millisFromNow?: number | null, relativeTime?: { __typename?: 'RelativeTime', quantity: number, unit: TimeUnit, direction: ReferenceDirection } | null } }> }> | null, default_exclusions_options: { __typename?: 'DefaultExclusionsOptions', exclude_cancelled_and_rescheduled_resources?: boolean | null, exclude_euthanasia_and_qol_resources?: boolean | null, exclude_euthanasia_and_qol_in_appt_notes?: boolean | null }, reference_date_params?: { __typename?: 'ReferenceDateParams', field: string, reference_periods?: Array<{ __typename?: 'ReferencePeriod', quantity: number, unit: TimeUnit, direction: ReferenceDirection }> | null } | null, notification_templates?: Array<{ __typename?: 'NotificationTemplate', id: string, name: string, is_active: boolean, is_archived: boolean, message_methods: Array<MessageMethod> }> | null, error_flags?: Array<{ __typename?: 'CustomerSegmentErrorFlag', filter_column: string, filter_index: number, parameter_index: number, message: string }> | null } | null, clinic?: { __typename?: 'Clinic', id: string, name?: string | null } | null, campaign?: { __typename?: 'Campaign', id: string, name: string, color?: string | null, description?: string | null } | null } };

export type UpdateNotificationTemplateMutationVariables = Exact<{
  notificationTemplateId: Scalars['ID']['input'];
  data: UpdateNotificationTemplateInput;
}>;


export type UpdateNotificationTemplateMutation = { __typename?: 'Mutation', updateNotificationTemplate: { __typename?: 'NotificationTemplate', id: string, name: string, every_x_hours: number, send_time_minutes?: number | null, body?: string | null, email_body?: string | null, email_design?: any | null, email_html?: string | null, repeating_body?: string | null, grouping_method: NotificationGroupingMethod, message_methods: Array<MessageMethod>, is_marketing: boolean, is_active: boolean, is_system: boolean, subject?: string | null, cta_text?: string | null, cta_url?: string | null, default_service_id?: string | null, postcard_template?: string | null, postcard_front_html?: string | null, postcard_back_html?: string | null, is_archived: boolean, is_preview_mode: boolean, updated_at: number, created_at: number, email_template?: { __typename?: 'EmailTemplate', id: string, title: string, subject?: string | null, design?: any | null, html?: string | null, status: EmailTemplateStatus, created_at: number, updated_at: number, clinic?: { __typename?: 'Clinic', id: string } | null, clinic_group?: { __typename?: 'ClinicGroup', id: string, name: string } | null } | null, notif_attachments?: Array<{ __typename?: 'Attachment', id: string, filename: string, type: AttachmentType, url: string }> | null, customer_segment?: { __typename?: 'CustomerSegment', id: string, name: string, trigger_entity?: CustomerSegmentTrigger | null, is_hourly?: boolean | null, group_days_ahead?: number | null, should_include_all_overdue?: boolean | null, included_clients?: Array<string> | null, excluded_clients?: Array<string> | null, other_result_exclusion_entity?: string | null, is_archived: boolean, created_at: number, updated_at: number, filters?: Array<{ __typename?: 'CustomerSegmentFilter', type: CustomerSegmentFilterType, only_consider_other_rows?: boolean | null, filters: Array<{ __typename?: 'QueryFilter', column: string, filterOp: FilterOp, value: { __typename?: 'QueryFilterValue', string?: string | null, float?: number | null, boolean?: boolean | null, stringArray?: Array<string> | null, floatArray?: Array<number> | null, millisFromNow?: number | null, relativeTime?: { __typename?: 'RelativeTime', quantity: number, unit: TimeUnit, direction: ReferenceDirection } | null } }> }> | null, excluded_filters: Array<{ __typename?: 'CustomerSegmentFilter', type: CustomerSegmentFilterType, only_consider_other_rows?: boolean | null, filters: Array<{ __typename?: 'QueryFilter', column: string, filterOp: FilterOp, value: { __typename?: 'QueryFilterValue', string?: string | null, float?: number | null, boolean?: boolean | null, stringArray?: Array<string> | null, floatArray?: Array<number> | null, millisFromNow?: number | null, relativeTime?: { __typename?: 'RelativeTime', quantity: number, unit: TimeUnit, direction: ReferenceDirection } | null } }> }>, all_inclusions?: Array<{ __typename?: 'SegmentFilter', foreign_table?: string | null, group?: string | null, parameters: Array<{ __typename?: 'QueryFilter', column: string, filterOp: FilterOp, value: { __typename?: 'QueryFilterValue', string?: string | null, float?: number | null, boolean?: boolean | null, stringArray?: Array<string> | null, floatArray?: Array<number> | null, millisFromNow?: number | null, relativeTime?: { __typename?: 'RelativeTime', quantity: number, unit: TimeUnit, direction: ReferenceDirection } | null } }> }> | null, any_inclusions?: Array<{ __typename?: 'SegmentFilter', foreign_table?: string | null, group?: string | null, parameters: Array<{ __typename?: 'QueryFilter', column: string, filterOp: FilterOp, value: { __typename?: 'QueryFilterValue', string?: string | null, float?: number | null, boolean?: boolean | null, stringArray?: Array<string> | null, floatArray?: Array<number> | null, millisFromNow?: number | null, relativeTime?: { __typename?: 'RelativeTime', quantity: number, unit: TimeUnit, direction: ReferenceDirection } | null } }> }> | null, any_exclusions?: Array<{ __typename?: 'SegmentFilter', foreign_table?: string | null, group?: string | null, parameters: Array<{ __typename?: 'QueryFilter', column: string, filterOp: FilterOp, value: { __typename?: 'QueryFilterValue', string?: string | null, float?: number | null, boolean?: boolean | null, stringArray?: Array<string> | null, floatArray?: Array<number> | null, millisFromNow?: number | null, relativeTime?: { __typename?: 'RelativeTime', quantity: number, unit: TimeUnit, direction: ReferenceDirection } | null } }> }> | null, any_other_exclusions?: Array<{ __typename?: 'SegmentFilter', foreign_table?: string | null, group?: string | null, parameters: Array<{ __typename?: 'QueryFilter', column: string, filterOp: FilterOp, value: { __typename?: 'QueryFilterValue', string?: string | null, float?: number | null, boolean?: boolean | null, stringArray?: Array<string> | null, floatArray?: Array<number> | null, millisFromNow?: number | null, relativeTime?: { __typename?: 'RelativeTime', quantity: number, unit: TimeUnit, direction: ReferenceDirection } | null } }> }> | null, default_exclusions_options: { __typename?: 'DefaultExclusionsOptions', exclude_cancelled_and_rescheduled_resources?: boolean | null, exclude_euthanasia_and_qol_resources?: boolean | null, exclude_euthanasia_and_qol_in_appt_notes?: boolean | null }, reference_date_params?: { __typename?: 'ReferenceDateParams', field: string, reference_periods?: Array<{ __typename?: 'ReferencePeriod', quantity: number, unit: TimeUnit, direction: ReferenceDirection }> | null } | null, notification_templates?: Array<{ __typename?: 'NotificationTemplate', id: string, name: string, is_active: boolean, is_archived: boolean, message_methods: Array<MessageMethod> }> | null, error_flags?: Array<{ __typename?: 'CustomerSegmentErrorFlag', filter_column: string, filter_index: number, parameter_index: number, message: string }> | null } | null, clinic?: { __typename?: 'Clinic', id: string, name?: string | null } | null, campaign?: { __typename?: 'Campaign', id: string, name: string, color?: string | null, description?: string | null } | null } };

export type BulkUpdateNotificationTemplatesMutationVariables = Exact<{
  ids: Array<Scalars['ID']['input']> | Scalars['ID']['input'];
  data: BulkUpdateNotificationTemplateInput;
}>;


export type BulkUpdateNotificationTemplatesMutation = { __typename?: 'Mutation', bulkUpdateNotificationTemplates: Array<{ __typename?: 'NotificationTemplate', id: string, name: string, every_x_hours: number, send_time_minutes?: number | null, body?: string | null, email_body?: string | null, email_design?: any | null, email_html?: string | null, repeating_body?: string | null, grouping_method: NotificationGroupingMethod, message_methods: Array<MessageMethod>, is_marketing: boolean, is_active: boolean, is_system: boolean, subject?: string | null, cta_text?: string | null, cta_url?: string | null, default_service_id?: string | null, postcard_template?: string | null, postcard_front_html?: string | null, postcard_back_html?: string | null, is_archived: boolean, is_preview_mode: boolean, updated_at: number, created_at: number, email_template?: { __typename?: 'EmailTemplate', id: string, title: string, subject?: string | null, design?: any | null, html?: string | null, status: EmailTemplateStatus, created_at: number, updated_at: number, clinic?: { __typename?: 'Clinic', id: string } | null, clinic_group?: { __typename?: 'ClinicGroup', id: string, name: string } | null } | null, notif_attachments?: Array<{ __typename?: 'Attachment', id: string, filename: string, type: AttachmentType, url: string }> | null, customer_segment?: { __typename?: 'CustomerSegment', id: string, name: string, trigger_entity?: CustomerSegmentTrigger | null, is_hourly?: boolean | null, group_days_ahead?: number | null, should_include_all_overdue?: boolean | null, included_clients?: Array<string> | null, excluded_clients?: Array<string> | null, other_result_exclusion_entity?: string | null, is_archived: boolean, created_at: number, updated_at: number, filters?: Array<{ __typename?: 'CustomerSegmentFilter', type: CustomerSegmentFilterType, only_consider_other_rows?: boolean | null, filters: Array<{ __typename?: 'QueryFilter', column: string, filterOp: FilterOp, value: { __typename?: 'QueryFilterValue', string?: string | null, float?: number | null, boolean?: boolean | null, stringArray?: Array<string> | null, floatArray?: Array<number> | null, millisFromNow?: number | null, relativeTime?: { __typename?: 'RelativeTime', quantity: number, unit: TimeUnit, direction: ReferenceDirection } | null } }> }> | null, excluded_filters: Array<{ __typename?: 'CustomerSegmentFilter', type: CustomerSegmentFilterType, only_consider_other_rows?: boolean | null, filters: Array<{ __typename?: 'QueryFilter', column: string, filterOp: FilterOp, value: { __typename?: 'QueryFilterValue', string?: string | null, float?: number | null, boolean?: boolean | null, stringArray?: Array<string> | null, floatArray?: Array<number> | null, millisFromNow?: number | null, relativeTime?: { __typename?: 'RelativeTime', quantity: number, unit: TimeUnit, direction: ReferenceDirection } | null } }> }>, all_inclusions?: Array<{ __typename?: 'SegmentFilter', foreign_table?: string | null, group?: string | null, parameters: Array<{ __typename?: 'QueryFilter', column: string, filterOp: FilterOp, value: { __typename?: 'QueryFilterValue', string?: string | null, float?: number | null, boolean?: boolean | null, stringArray?: Array<string> | null, floatArray?: Array<number> | null, millisFromNow?: number | null, relativeTime?: { __typename?: 'RelativeTime', quantity: number, unit: TimeUnit, direction: ReferenceDirection } | null } }> }> | null, any_inclusions?: Array<{ __typename?: 'SegmentFilter', foreign_table?: string | null, group?: string | null, parameters: Array<{ __typename?: 'QueryFilter', column: string, filterOp: FilterOp, value: { __typename?: 'QueryFilterValue', string?: string | null, float?: number | null, boolean?: boolean | null, stringArray?: Array<string> | null, floatArray?: Array<number> | null, millisFromNow?: number | null, relativeTime?: { __typename?: 'RelativeTime', quantity: number, unit: TimeUnit, direction: ReferenceDirection } | null } }> }> | null, any_exclusions?: Array<{ __typename?: 'SegmentFilter', foreign_table?: string | null, group?: string | null, parameters: Array<{ __typename?: 'QueryFilter', column: string, filterOp: FilterOp, value: { __typename?: 'QueryFilterValue', string?: string | null, float?: number | null, boolean?: boolean | null, stringArray?: Array<string> | null, floatArray?: Array<number> | null, millisFromNow?: number | null, relativeTime?: { __typename?: 'RelativeTime', quantity: number, unit: TimeUnit, direction: ReferenceDirection } | null } }> }> | null, any_other_exclusions?: Array<{ __typename?: 'SegmentFilter', foreign_table?: string | null, group?: string | null, parameters: Array<{ __typename?: 'QueryFilter', column: string, filterOp: FilterOp, value: { __typename?: 'QueryFilterValue', string?: string | null, float?: number | null, boolean?: boolean | null, stringArray?: Array<string> | null, floatArray?: Array<number> | null, millisFromNow?: number | null, relativeTime?: { __typename?: 'RelativeTime', quantity: number, unit: TimeUnit, direction: ReferenceDirection } | null } }> }> | null, default_exclusions_options: { __typename?: 'DefaultExclusionsOptions', exclude_cancelled_and_rescheduled_resources?: boolean | null, exclude_euthanasia_and_qol_resources?: boolean | null, exclude_euthanasia_and_qol_in_appt_notes?: boolean | null }, reference_date_params?: { __typename?: 'ReferenceDateParams', field: string, reference_periods?: Array<{ __typename?: 'ReferencePeriod', quantity: number, unit: TimeUnit, direction: ReferenceDirection }> | null } | null, notification_templates?: Array<{ __typename?: 'NotificationTemplate', id: string, name: string, is_active: boolean, is_archived: boolean, message_methods: Array<MessageMethod> }> | null, error_flags?: Array<{ __typename?: 'CustomerSegmentErrorFlag', filter_column: string, filter_index: number, parameter_index: number, message: string }> | null } | null, clinic?: { __typename?: 'Clinic', id: string, name?: string | null } | null, campaign?: { __typename?: 'Campaign', id: string, name: string, color?: string | null, description?: string | null } | null }> };

export type ArchiveNotificationTemplateMutationVariables = Exact<{
  notificationTemplateId: Scalars['ID']['input'];
}>;


export type ArchiveNotificationTemplateMutation = { __typename?: 'Mutation', archiveNotificationTemplate: { __typename?: 'NotificationTemplate', id: string, name: string, every_x_hours: number, send_time_minutes?: number | null, body?: string | null, email_body?: string | null, email_design?: any | null, email_html?: string | null, repeating_body?: string | null, grouping_method: NotificationGroupingMethod, message_methods: Array<MessageMethod>, is_marketing: boolean, is_active: boolean, is_system: boolean, subject?: string | null, cta_text?: string | null, cta_url?: string | null, default_service_id?: string | null, postcard_template?: string | null, postcard_front_html?: string | null, postcard_back_html?: string | null, is_archived: boolean, is_preview_mode: boolean, updated_at: number, created_at: number, email_template?: { __typename?: 'EmailTemplate', id: string, title: string, subject?: string | null, design?: any | null, html?: string | null, status: EmailTemplateStatus, created_at: number, updated_at: number, clinic?: { __typename?: 'Clinic', id: string } | null, clinic_group?: { __typename?: 'ClinicGroup', id: string, name: string } | null } | null, notif_attachments?: Array<{ __typename?: 'Attachment', id: string, filename: string, type: AttachmentType, url: string }> | null, customer_segment?: { __typename?: 'CustomerSegment', id: string, name: string, trigger_entity?: CustomerSegmentTrigger | null, is_hourly?: boolean | null, group_days_ahead?: number | null, should_include_all_overdue?: boolean | null, included_clients?: Array<string> | null, excluded_clients?: Array<string> | null, other_result_exclusion_entity?: string | null, is_archived: boolean, created_at: number, updated_at: number, filters?: Array<{ __typename?: 'CustomerSegmentFilter', type: CustomerSegmentFilterType, only_consider_other_rows?: boolean | null, filters: Array<{ __typename?: 'QueryFilter', column: string, filterOp: FilterOp, value: { __typename?: 'QueryFilterValue', string?: string | null, float?: number | null, boolean?: boolean | null, stringArray?: Array<string> | null, floatArray?: Array<number> | null, millisFromNow?: number | null, relativeTime?: { __typename?: 'RelativeTime', quantity: number, unit: TimeUnit, direction: ReferenceDirection } | null } }> }> | null, excluded_filters: Array<{ __typename?: 'CustomerSegmentFilter', type: CustomerSegmentFilterType, only_consider_other_rows?: boolean | null, filters: Array<{ __typename?: 'QueryFilter', column: string, filterOp: FilterOp, value: { __typename?: 'QueryFilterValue', string?: string | null, float?: number | null, boolean?: boolean | null, stringArray?: Array<string> | null, floatArray?: Array<number> | null, millisFromNow?: number | null, relativeTime?: { __typename?: 'RelativeTime', quantity: number, unit: TimeUnit, direction: ReferenceDirection } | null } }> }>, all_inclusions?: Array<{ __typename?: 'SegmentFilter', foreign_table?: string | null, group?: string | null, parameters: Array<{ __typename?: 'QueryFilter', column: string, filterOp: FilterOp, value: { __typename?: 'QueryFilterValue', string?: string | null, float?: number | null, boolean?: boolean | null, stringArray?: Array<string> | null, floatArray?: Array<number> | null, millisFromNow?: number | null, relativeTime?: { __typename?: 'RelativeTime', quantity: number, unit: TimeUnit, direction: ReferenceDirection } | null } }> }> | null, any_inclusions?: Array<{ __typename?: 'SegmentFilter', foreign_table?: string | null, group?: string | null, parameters: Array<{ __typename?: 'QueryFilter', column: string, filterOp: FilterOp, value: { __typename?: 'QueryFilterValue', string?: string | null, float?: number | null, boolean?: boolean | null, stringArray?: Array<string> | null, floatArray?: Array<number> | null, millisFromNow?: number | null, relativeTime?: { __typename?: 'RelativeTime', quantity: number, unit: TimeUnit, direction: ReferenceDirection } | null } }> }> | null, any_exclusions?: Array<{ __typename?: 'SegmentFilter', foreign_table?: string | null, group?: string | null, parameters: Array<{ __typename?: 'QueryFilter', column: string, filterOp: FilterOp, value: { __typename?: 'QueryFilterValue', string?: string | null, float?: number | null, boolean?: boolean | null, stringArray?: Array<string> | null, floatArray?: Array<number> | null, millisFromNow?: number | null, relativeTime?: { __typename?: 'RelativeTime', quantity: number, unit: TimeUnit, direction: ReferenceDirection } | null } }> }> | null, any_other_exclusions?: Array<{ __typename?: 'SegmentFilter', foreign_table?: string | null, group?: string | null, parameters: Array<{ __typename?: 'QueryFilter', column: string, filterOp: FilterOp, value: { __typename?: 'QueryFilterValue', string?: string | null, float?: number | null, boolean?: boolean | null, stringArray?: Array<string> | null, floatArray?: Array<number> | null, millisFromNow?: number | null, relativeTime?: { __typename?: 'RelativeTime', quantity: number, unit: TimeUnit, direction: ReferenceDirection } | null } }> }> | null, default_exclusions_options: { __typename?: 'DefaultExclusionsOptions', exclude_cancelled_and_rescheduled_resources?: boolean | null, exclude_euthanasia_and_qol_resources?: boolean | null, exclude_euthanasia_and_qol_in_appt_notes?: boolean | null }, reference_date_params?: { __typename?: 'ReferenceDateParams', field: string, reference_periods?: Array<{ __typename?: 'ReferencePeriod', quantity: number, unit: TimeUnit, direction: ReferenceDirection }> | null } | null, notification_templates?: Array<{ __typename?: 'NotificationTemplate', id: string, name: string, is_active: boolean, is_archived: boolean, message_methods: Array<MessageMethod> }> | null, error_flags?: Array<{ __typename?: 'CustomerSegmentErrorFlag', filter_column: string, filter_index: number, parameter_index: number, message: string }> | null } | null, clinic?: { __typename?: 'Clinic', id: string, name?: string | null } | null, campaign?: { __typename?: 'Campaign', id: string, name: string, color?: string | null, description?: string | null } | null } };

export type DeleteNotificationTemplateMutationVariables = Exact<{
  notificationTemplateId: Scalars['ID']['input'];
}>;


export type DeleteNotificationTemplateMutation = { __typename?: 'Mutation', deleteNotificationTemplate?: any | null };

export type CopyNotificationTemplateAcrossClinicMutationVariables = Exact<{
  notificationTemplateId: Scalars['ID']['input'];
  destinationClinicId: Scalars['ID']['input'];
  options: CopyNotificationTemplateAcrossClinicOptions;
}>;


export type CopyNotificationTemplateAcrossClinicMutation = { __typename?: 'Mutation', copyNotificationTemplateAcrossClinic: { __typename?: 'NotificationTemplate', id: string, name: string, every_x_hours: number, send_time_minutes?: number | null, body?: string | null, email_body?: string | null, email_design?: any | null, email_html?: string | null, repeating_body?: string | null, grouping_method: NotificationGroupingMethod, message_methods: Array<MessageMethod>, is_marketing: boolean, is_active: boolean, is_system: boolean, subject?: string | null, cta_text?: string | null, cta_url?: string | null, default_service_id?: string | null, postcard_template?: string | null, postcard_front_html?: string | null, postcard_back_html?: string | null, is_archived: boolean, is_preview_mode: boolean, updated_at: number, created_at: number, email_template?: { __typename?: 'EmailTemplate', id: string, title: string, subject?: string | null, design?: any | null, html?: string | null, status: EmailTemplateStatus, created_at: number, updated_at: number, clinic?: { __typename?: 'Clinic', id: string } | null, clinic_group?: { __typename?: 'ClinicGroup', id: string, name: string } | null } | null, notif_attachments?: Array<{ __typename?: 'Attachment', id: string, filename: string, type: AttachmentType, url: string }> | null, customer_segment?: { __typename?: 'CustomerSegment', id: string, name: string, trigger_entity?: CustomerSegmentTrigger | null, is_hourly?: boolean | null, group_days_ahead?: number | null, should_include_all_overdue?: boolean | null, included_clients?: Array<string> | null, excluded_clients?: Array<string> | null, other_result_exclusion_entity?: string | null, is_archived: boolean, created_at: number, updated_at: number, filters?: Array<{ __typename?: 'CustomerSegmentFilter', type: CustomerSegmentFilterType, only_consider_other_rows?: boolean | null, filters: Array<{ __typename?: 'QueryFilter', column: string, filterOp: FilterOp, value: { __typename?: 'QueryFilterValue', string?: string | null, float?: number | null, boolean?: boolean | null, stringArray?: Array<string> | null, floatArray?: Array<number> | null, millisFromNow?: number | null, relativeTime?: { __typename?: 'RelativeTime', quantity: number, unit: TimeUnit, direction: ReferenceDirection } | null } }> }> | null, excluded_filters: Array<{ __typename?: 'CustomerSegmentFilter', type: CustomerSegmentFilterType, only_consider_other_rows?: boolean | null, filters: Array<{ __typename?: 'QueryFilter', column: string, filterOp: FilterOp, value: { __typename?: 'QueryFilterValue', string?: string | null, float?: number | null, boolean?: boolean | null, stringArray?: Array<string> | null, floatArray?: Array<number> | null, millisFromNow?: number | null, relativeTime?: { __typename?: 'RelativeTime', quantity: number, unit: TimeUnit, direction: ReferenceDirection } | null } }> }>, all_inclusions?: Array<{ __typename?: 'SegmentFilter', foreign_table?: string | null, group?: string | null, parameters: Array<{ __typename?: 'QueryFilter', column: string, filterOp: FilterOp, value: { __typename?: 'QueryFilterValue', string?: string | null, float?: number | null, boolean?: boolean | null, stringArray?: Array<string> | null, floatArray?: Array<number> | null, millisFromNow?: number | null, relativeTime?: { __typename?: 'RelativeTime', quantity: number, unit: TimeUnit, direction: ReferenceDirection } | null } }> }> | null, any_inclusions?: Array<{ __typename?: 'SegmentFilter', foreign_table?: string | null, group?: string | null, parameters: Array<{ __typename?: 'QueryFilter', column: string, filterOp: FilterOp, value: { __typename?: 'QueryFilterValue', string?: string | null, float?: number | null, boolean?: boolean | null, stringArray?: Array<string> | null, floatArray?: Array<number> | null, millisFromNow?: number | null, relativeTime?: { __typename?: 'RelativeTime', quantity: number, unit: TimeUnit, direction: ReferenceDirection } | null } }> }> | null, any_exclusions?: Array<{ __typename?: 'SegmentFilter', foreign_table?: string | null, group?: string | null, parameters: Array<{ __typename?: 'QueryFilter', column: string, filterOp: FilterOp, value: { __typename?: 'QueryFilterValue', string?: string | null, float?: number | null, boolean?: boolean | null, stringArray?: Array<string> | null, floatArray?: Array<number> | null, millisFromNow?: number | null, relativeTime?: { __typename?: 'RelativeTime', quantity: number, unit: TimeUnit, direction: ReferenceDirection } | null } }> }> | null, any_other_exclusions?: Array<{ __typename?: 'SegmentFilter', foreign_table?: string | null, group?: string | null, parameters: Array<{ __typename?: 'QueryFilter', column: string, filterOp: FilterOp, value: { __typename?: 'QueryFilterValue', string?: string | null, float?: number | null, boolean?: boolean | null, stringArray?: Array<string> | null, floatArray?: Array<number> | null, millisFromNow?: number | null, relativeTime?: { __typename?: 'RelativeTime', quantity: number, unit: TimeUnit, direction: ReferenceDirection } | null } }> }> | null, default_exclusions_options: { __typename?: 'DefaultExclusionsOptions', exclude_cancelled_and_rescheduled_resources?: boolean | null, exclude_euthanasia_and_qol_resources?: boolean | null, exclude_euthanasia_and_qol_in_appt_notes?: boolean | null }, reference_date_params?: { __typename?: 'ReferenceDateParams', field: string, reference_periods?: Array<{ __typename?: 'ReferencePeriod', quantity: number, unit: TimeUnit, direction: ReferenceDirection }> | null } | null, notification_templates?: Array<{ __typename?: 'NotificationTemplate', id: string, name: string, is_active: boolean, is_archived: boolean, message_methods: Array<MessageMethod> }> | null, error_flags?: Array<{ __typename?: 'CustomerSegmentErrorFlag', filter_column: string, filter_index: number, parameter_index: number, message: string }> | null } | null, clinic?: { __typename?: 'Clinic', id: string, name?: string | null } | null, campaign?: { __typename?: 'Campaign', id: string, name: string, color?: string | null, description?: string | null } | null } };

export type UserNotificationFieldsFragment = { __typename?: 'UserNotification', id: string, type: UserNotificationType, title: string, body?: string | null, link_url?: string | null, payload?: any | null, read_at?: number | null, seen_at?: number | null, created_at: number, updated_at: number, created_by_user?: { __typename?: 'User', id: string, avatar_url?: string | null, first_name?: string | null, last_name?: string | null } | null };

export type QueryMyUserNotificationsQueryVariables = Exact<{
  page?: InputMaybe<Scalars['NonNegativeInt']['input']>;
  pageSize?: InputMaybe<Scalars['NonNegativeInt']['input']>;
}>;


export type QueryMyUserNotificationsQuery = { __typename?: 'Query', queryMyUserNotifications: Array<{ __typename?: 'UserNotification', id: string, type: UserNotificationType, title: string, body?: string | null, link_url?: string | null, payload?: any | null, read_at?: number | null, seen_at?: number | null, created_at: number, updated_at: number, created_by_user?: { __typename?: 'User', id: string, avatar_url?: string | null, first_name?: string | null, last_name?: string | null } | null }> };

export type CountMyUnreadUserNotificationsQueryVariables = Exact<{ [key: string]: never; }>;


export type CountMyUnreadUserNotificationsQuery = { __typename?: 'Query', countMyUnreadUserNotifications: number };

export type MarkUserNotificationAsReadMutationVariables = Exact<{
  id: Scalars['ID']['input'];
}>;


export type MarkUserNotificationAsReadMutation = { __typename?: 'Mutation', markUserNotificationAsRead: { __typename?: 'UserNotification', id: string, type: UserNotificationType, title: string, body?: string | null, link_url?: string | null, payload?: any | null, read_at?: number | null, seen_at?: number | null, created_at: number, updated_at: number, created_by_user?: { __typename?: 'User', id: string, avatar_url?: string | null, first_name?: string | null, last_name?: string | null } | null } };

export type MarkAllMyUserNotificationsAsReadMutationVariables = Exact<{ [key: string]: never; }>;


export type MarkAllMyUserNotificationsAsReadMutation = { __typename?: 'Mutation', markAllMyUserNotificationsAsRead: boolean };

export type MarkMyUserNotificationsAsSeenMutationVariables = Exact<{ [key: string]: never; }>;


export type MarkMyUserNotificationsAsSeenMutation = { __typename?: 'Mutation', markMyUserNotificationsAsSeen: boolean };

export type DeleteUserNotificationMutationVariables = Exact<{
  id: Scalars['ID']['input'];
}>;


export type DeleteUserNotificationMutation = { __typename?: 'Mutation', deleteUserNotification: boolean };

export type OrganizationClinicAnalyticsNumbersFieldsFragment = { __typename?: 'OrganizationClinicAnalyticsNumbers', appointments_count: { __typename?: 'IntPercentile', value: number, percentile: number }, no_show_count: { __typename?: 'IntPercentile', value: number, percentile: number }, revenue: { __typename?: 'FloatPercentile', value: number, percentile: number }, transactions_count: { __typename?: 'IntPercentile', value: number, percentile: number }, revenue_per_appointment: { __typename?: 'FloatPercentile', value: number, percentile: number }, new_clients_count: { __typename?: 'IntPercentile', value: number, percentile: number }, new_patients_count: { __typename?: 'IntPercentile', value: number, percentile: number }, new_appointments_count: { __typename?: 'IntPercentile', value: number, percentile: number }, schedule_efficiency: { __typename?: 'FloatPercentile', value: number, percentile: number }, forward_scheduled_patients_count: { __typename?: 'IntPercentile', value: number, percentile: number } };

export type OrganizationAnalyticsFieldsFragment = { __typename?: 'OrganizationAnalytics', clinic: { __typename?: 'Clinic', id: string, name?: string | null, pms: PracticeManagementSystem }, analytics: { __typename?: 'ClinicAnalytics', appointments_count: number, no_show_count: number, revenue: number, transactions_count: number, accounts_receivable: number, clients_with_negative_balances_count: number, monthly_revenue_completed: number, monthly_appointments_scheduled: number, last_month_average_revenue_per_appointment: number, new_clients_count: number, new_patients_count: number, new_appointments_count: number, schedule_efficiency: number, forward_scheduled_patients_count: number, appointments: Array<{ __typename?: 'Appointment', id: string, pms?: PracticeManagementSystem | null, client_pms_id?: string | null, is_new_client?: boolean | null, start_time: number, drop_off_time?: number | null, minutes: number, is_new_patient?: boolean | null, is_clinician_auto_assigned?: boolean | null, patient_pms_id?: string | null, referring_clinic_name?: string | null, client_notes?: string | null, clinic_notes?: string | null, service_name?: string | null, status: AppointmentStatus, is_time_block?: boolean | null, is_confirmed?: boolean | null, origin?: EntityOrigin | null, reason_for_cancellation?: string | null, client_reason_for_cancellation?: string | null, new_client_name?: string | null, new_client_phone?: string | null, new_patient_name?: string | null, new_patient_species?: string | null, confirmed_at?: number | null, widget_source?: string | null, from_widget?: string | null, is_deleted?: boolean | null, created_at: number, updated_at: number, pms_created_at?: number | null, clinic?: { __typename?: 'Clinic', id: string, name?: string | null, slug?: string | null, pms_db?: { __typename?: 'PmsDb', id: string } | null, address?: { __typename?: 'Address', country?: string | null } | null } | null, client?: { __typename?: 'Client', id: string, first_name?: string | null, last_name?: string | null, secondary_first_name?: string | null, secondary_last_name?: string | null, phone?: string | null, email?: string | null, pms?: PracticeManagementSystem | null, pms_id?: string | null, last_appt_time?: number | null, last_contact_time?: number | null, email_enabled: boolean, sms_enabled: boolean, balance?: number | null, is_active?: boolean | null, is_unsubscribed: boolean, created_at: number, updated_at: number, client_phones?: Array<{ __typename?: 'ClientPhone', id: string, phone: string, country_code?: string | null, is_primary: boolean, is_chckup_primary: boolean, is_mobile: boolean, sms_available: boolean, is_unsubscribed: boolean, is_active: boolean, name?: string | null }> | null, client_emails?: Array<{ __typename?: 'ClientEmail', id: string, email: string, is_primary: boolean }> | null, clinic?: { __typename?: 'Clinic', id: string } | null, patients?: Array<{ __typename?: 'Patient', id: string, pms?: PracticeManagementSystem | null, pms_id?: string | null, name?: string | null, breed?: string | null, avatar_url?: string | null, last_appt_time?: number | null, gender?: string | null, fixed_status?: FixedStatus | null, weight?: number | null, birthday?: number | null, is_active?: boolean | null, is_deceased?: boolean | null, pms_created_at?: number | null, created_at: number, updated_at: number, owner?: { __typename?: 'Client', id: string, first_name?: string | null, last_name?: string | null, email?: string | null, phone?: string | null, address?: { __typename?: 'Address', country?: string | null } | null } | null, clinic_species?: { __typename?: 'ClinicSpecies', id: string, pms_id: string, description: string, is_primary: boolean, species: Species, weight_key: string, created_at: number, updated_at: number } | null, clinic?: { __typename?: 'Clinic', id: string } | null, clinic_breed?: { __typename?: 'Breed', id: string, description: string } | null, patient_vaccination_records?: Array<{ __typename?: 'PatientVaccinationRecord', id: string, vaccine_name?: string | null, manufacturer?: string | null, lot_number?: string | null, administered_date?: number | null, due_date?: number | null, rabies_tag?: string | null, is_rabies_vaccine?: boolean | null, is_soc: boolean, is_active: boolean, product?: { __typename?: 'Product', id: string, display_name?: string | null, name: string } | null }> | null, last_appointment?: { __typename?: 'Appointment', clinician?: { __typename?: 'Clinician', name: string, display_name?: string | null } | null } | null }> | null, address?: { __typename?: 'Address', street_a?: string | null, street_b?: string | null, city?: string | null, state?: string | null, zip?: string | null, country?: string | null } | null, user?: { __typename?: 'User', avatar_url?: string | null } | null, loyalty_members?: Array<{ __typename?: 'LoyaltyMember', id: string, available_points: number } | null> | null, settings?: { __typename?: 'ClientSettings', clinic_chckup_notifications_enabled: boolean, clinic_chckup_sms_enabled: boolean, clinic_chckup_email_enabled: boolean, client_chckup_notifications_enabled: boolean, client_chckup_sms_enabled: boolean, client_chckup_email_enabled: boolean, is_unsubscribed_from_marketing: boolean, is_unsubscribed_from_marketing_sms: boolean, is_unsubscribed_from_marketing_email: boolean } | null, last_appointment?: { __typename?: 'Appointment', clinician?: { __typename?: 'Clinician', name: string, display_name?: string | null } | null } | null } | null, clinician?: { __typename?: 'Clinician', id: string, name: string, display_name?: string | null, bio?: string | null, avatar_url?: string | null, initials?: string | null, excluded_species?: Array<Species> | null, excluded_service_ids?: Array<string> | null, authority_level?: AuthorityLevel | null, type: ResourceType, is_active?: boolean | null, is_assignable_in_pms?: boolean | null, does_contribute_to_fill_rate?: boolean | null, pms_id?: string | null, location?: string | null, pms_is_active: boolean, valid_booking_interval_minutes?: Array<number> | null, created_at: number, updated_at: number, clinic?: { __typename?: 'Clinic', id: string, name?: string | null } | null, pms_db?: { __typename?: 'PmsDb', id: string } | null, hours?: { __typename?: 'AvailabilityHours', monday?: Array<{ __typename?: 'TimeInterval', start?: number | null, end?: number | null }> | null, tuesday?: Array<{ __typename?: 'TimeInterval', start?: number | null, end?: number | null }> | null, wednesday?: Array<{ __typename?: 'TimeInterval', start?: number | null, end?: number | null }> | null, thursday?: Array<{ __typename?: 'TimeInterval', start?: number | null, end?: number | null }> | null, friday?: Array<{ __typename?: 'TimeInterval', start?: number | null, end?: number | null }> | null, saturday?: Array<{ __typename?: 'TimeInterval', start?: number | null, end?: number | null }> | null, sunday?: Array<{ __typename?: 'TimeInterval', start?: number | null, end?: number | null }> | null } | null, adjusted_availability?: Array<{ __typename?: 'Availability', date: number, pms_appt_type_pms_id?: string | null, times: Array<{ __typename?: 'TimeInterval', start?: number | null, end?: number | null }>, repeat?: { __typename?: 'RepeatAvailability', daysOfMonth?: Array<number> | null, daysOfWeek?: Array<DayOfWeek> | null, weekOfMonth?: WeekOfMonth | null, frequency: any, unit: RepeatUnit, end_date?: number | null } | null }> | null, pms_adjusted_availability?: Array<{ __typename?: 'Availability', date: number, pms_appt_type_pms_id?: string | null, times: Array<{ __typename?: 'TimeInterval', start?: number | null, end?: number | null }>, repeat?: { __typename?: 'RepeatAvailability', daysOfMonth?: Array<number> | null, daysOfWeek?: Array<DayOfWeek> | null, weekOfMonth?: WeekOfMonth | null, frequency: any, unit: RepeatUnit, end_date?: number | null } | null }> | null } | null, room?: { __typename?: 'Room', id: string, pms_id: string, name: string, display_name?: string | null, description?: string | null, concurrent_patients?: number | null, is_active: boolean, does_contribute_to_fill_rate?: boolean | null, valid_booking_interval_minutes?: Array<number> | null, created_at: number, updated_at: number, clinic?: { __typename?: 'Clinic', pms: PracticeManagementSystem, id: string, name?: string | null, time_zone?: string | null } | null, hours?: { __typename?: 'AvailabilityHours', monday?: Array<{ __typename?: 'TimeInterval', start?: number | null, end?: number | null }> | null, tuesday?: Array<{ __typename?: 'TimeInterval', start?: number | null, end?: number | null }> | null, wednesday?: Array<{ __typename?: 'TimeInterval', start?: number | null, end?: number | null }> | null, thursday?: Array<{ __typename?: 'TimeInterval', start?: number | null, end?: number | null }> | null, friday?: Array<{ __typename?: 'TimeInterval', start?: number | null, end?: number | null }> | null, saturday?: Array<{ __typename?: 'TimeInterval', start?: number | null, end?: number | null }> | null, sunday?: Array<{ __typename?: 'TimeInterval', start?: number | null, end?: number | null }> | null } | null, adjusted_availability?: Array<{ __typename?: 'Availability', date: number, pms_appt_type_pms_id?: string | null, times: Array<{ __typename?: 'TimeInterval', start?: number | null, end?: number | null }>, repeat?: { __typename?: 'RepeatAvailability', daysOfMonth?: Array<number> | null, daysOfWeek?: Array<DayOfWeek> | null, weekOfMonth?: WeekOfMonth | null, frequency: any, unit: RepeatUnit, end_date?: number | null } | null }> | null, pms_adjusted_availability?: Array<{ __typename?: 'Availability', date: number, pms_appt_type_pms_id?: string | null, times: Array<{ __typename?: 'TimeInterval', start?: number | null, end?: number | null }>, repeat?: { __typename?: 'RepeatAvailability', daysOfMonth?: Array<number> | null, daysOfWeek?: Array<DayOfWeek> | null, weekOfMonth?: WeekOfMonth | null, frequency: any, unit: RepeatUnit, end_date?: number | null } | null }> | null } | null, service?: { __typename?: 'Service', id: string, name?: string | null, color?: string | null } | null, patient?: { __typename?: 'Patient', id: string, pms?: PracticeManagementSystem | null, pms_id?: string | null, name?: string | null, breed?: string | null, avatar_url?: string | null, last_appt_time?: number | null, gender?: string | null, fixed_status?: FixedStatus | null, weight?: number | null, birthday?: number | null, is_active?: boolean | null, is_deceased?: boolean | null, pms_created_at?: number | null, created_at: number, updated_at: number, owner?: { __typename?: 'Client', id: string, first_name?: string | null, last_name?: string | null, email?: string | null, phone?: string | null, address?: { __typename?: 'Address', country?: string | null } | null } | null, clinic_species?: { __typename?: 'ClinicSpecies', id: string, pms_id: string, description: string, is_primary: boolean, species: Species, weight_key: string, created_at: number, updated_at: number } | null, clinic?: { __typename?: 'Clinic', id: string } | null, clinic_breed?: { __typename?: 'Breed', id: string, description: string } | null, patient_vaccination_records?: Array<{ __typename?: 'PatientVaccinationRecord', id: string, vaccine_name?: string | null, manufacturer?: string | null, lot_number?: string | null, administered_date?: number | null, due_date?: number | null, rabies_tag?: string | null, is_rabies_vaccine?: boolean | null, is_soc: boolean, is_active: boolean, product?: { __typename?: 'Product', id: string, display_name?: string | null, name: string } | null }> | null, last_appointment?: { __typename?: 'Appointment', clinician?: { __typename?: 'Clinician', name: string, display_name?: string | null } | null } | null } | null, clinic_appt_status?: { __typename?: 'ClinicApptStatus', id: string, description: string, status: AppointmentStatus } | null, client_info?: { __typename?: 'ClientInfo', first_name?: string | null, last_name?: string | null, email?: string | null, phone?: string | null } | null, patient_info?: { __typename?: 'PatientInfo', patient_name?: string | null, patient_breed?: string | null, patient_clinic_species?: string | null, patient_clinic_breed?: string | null } | null, clients_forms?: Array<{ __typename?: 'ClientForm', id: string, client_completed_at?: number | null, clinic_verified_at?: number | null, is_archived: boolean, pms_id?: string | null, created_at: number, updated_at: number, client?: { __typename?: 'Client', id: string, first_name?: string | null, last_name?: string | null, phone?: string | null, email?: string | null, address?: { __typename?: 'Address', street_a?: string | null, city?: string | null, state?: string | null, zip?: string | null, country?: string | null } | null } | null, patient?: { __typename?: 'Patient', id: string, name?: string | null, is_active?: boolean | null, is_deceased?: boolean | null, birthday?: number | null, weight?: number | null, avatar_url?: string | null, gender?: string | null, owner?: { __typename?: 'Client', first_name?: string | null, last_name?: string | null } | null, clinic_species?: { __typename?: 'ClinicSpecies', id: string, species: Species, description: string, weight_key: string } | null, clinic_breed?: { __typename?: 'Breed', id: string, description: string } | null } | null, form: { __typename?: 'Form', id: string, name?: string | null, form_type: FormType, is_writeback_enabled: boolean, form_file_naming_template?: string | null }, form_data: { __typename?: 'FormFields', pages?: Array<{ __typename?: 'FormPage', id: string, title?: string | null, description?: string | null, order?: number | null }> | null, fields?: Array<{ __typename?: 'FormElement', id: string, type?: FormElementType | null, content?: string | null, name?: string | null, column_order?: number | null, row_order?: number | null, page_id?: string | null, options?: Array<string> | null, is_required?: boolean | null, value?: string | null, attachments?: Array<{ __typename?: 'FormFileAttachment', id?: string | null, filename?: string | null, mime_type?: string | null, size_bytes?: number | null, thumbnail_url?: string | null, url: string }> | null, field_updates?: Array<{ __typename?: 'FormFieldUpdate', field: FormFieldUpdateField, boolean_value?: boolean | null, option?: string | null }> | null }> | null }, appointment?: { __typename?: 'Appointment', start_time: number, drop_off_time?: number | null, clinic?: { __typename?: 'Clinic', name?: string | null, slug?: string | null, phone?: string | null, email?: string | null, address?: { __typename?: 'Address', street_a?: string | null, city?: string | null, state?: string | null, zip?: string | null, country?: string | null } | null } | null, clinician?: { __typename?: 'Clinician', name: string, display_name?: string | null } | null, service?: { __typename?: 'Service', name?: string | null } | null } | null }> | null, widget?: { __typename?: 'Widget', id: string, widget_name: string } | null }>, revenue_by_type: Array<{ __typename?: 'RevenueGroup', group: string, amount: number }>, revenue_by_clinician: Array<{ __typename?: 'RevenueGroup', group: string, amount: number }>, clients_with_negative_balances: Array<{ __typename?: 'Client', id: string, first_name?: string | null, last_name?: string | null, secondary_first_name?: string | null, secondary_last_name?: string | null, phone?: string | null, email?: string | null, pms?: PracticeManagementSystem | null, pms_id?: string | null, last_appt_time?: number | null, last_contact_time?: number | null, email_enabled: boolean, sms_enabled: boolean, balance?: number | null, is_active?: boolean | null, is_unsubscribed: boolean, created_at: number, updated_at: number, client_phones?: Array<{ __typename?: 'ClientPhone', id: string, phone: string, country_code?: string | null, is_primary: boolean, is_chckup_primary: boolean, is_mobile: boolean, sms_available: boolean, is_unsubscribed: boolean, is_active: boolean, name?: string | null }> | null, client_emails?: Array<{ __typename?: 'ClientEmail', id: string, email: string, is_primary: boolean }> | null, clinic?: { __typename?: 'Clinic', id: string } | null, patients?: Array<{ __typename?: 'Patient', id: string, pms?: PracticeManagementSystem | null, pms_id?: string | null, name?: string | null, breed?: string | null, avatar_url?: string | null, last_appt_time?: number | null, gender?: string | null, fixed_status?: FixedStatus | null, weight?: number | null, birthday?: number | null, is_active?: boolean | null, is_deceased?: boolean | null, pms_created_at?: number | null, created_at: number, updated_at: number, owner?: { __typename?: 'Client', id: string, first_name?: string | null, last_name?: string | null, email?: string | null, phone?: string | null, address?: { __typename?: 'Address', country?: string | null } | null } | null, clinic_species?: { __typename?: 'ClinicSpecies', id: string, pms_id: string, description: string, is_primary: boolean, species: Species, weight_key: string, created_at: number, updated_at: number } | null, clinic?: { __typename?: 'Clinic', id: string } | null, clinic_breed?: { __typename?: 'Breed', id: string, description: string } | null, patient_vaccination_records?: Array<{ __typename?: 'PatientVaccinationRecord', id: string, vaccine_name?: string | null, manufacturer?: string | null, lot_number?: string | null, administered_date?: number | null, due_date?: number | null, rabies_tag?: string | null, is_rabies_vaccine?: boolean | null, is_soc: boolean, is_active: boolean, product?: { __typename?: 'Product', id: string, display_name?: string | null, name: string } | null }> | null, last_appointment?: { __typename?: 'Appointment', clinician?: { __typename?: 'Clinician', name: string, display_name?: string | null } | null } | null }> | null, address?: { __typename?: 'Address', street_a?: string | null, street_b?: string | null, city?: string | null, state?: string | null, zip?: string | null, country?: string | null } | null, user?: { __typename?: 'User', avatar_url?: string | null } | null, loyalty_members?: Array<{ __typename?: 'LoyaltyMember', id: string, available_points: number } | null> | null, settings?: { __typename?: 'ClientSettings', clinic_chckup_notifications_enabled: boolean, clinic_chckup_sms_enabled: boolean, clinic_chckup_email_enabled: boolean, client_chckup_notifications_enabled: boolean, client_chckup_sms_enabled: boolean, client_chckup_email_enabled: boolean, is_unsubscribed_from_marketing: boolean, is_unsubscribed_from_marketing_sms: boolean, is_unsubscribed_from_marketing_email: boolean } | null, last_appointment?: { __typename?: 'Appointment', clinician?: { __typename?: 'Clinician', name: string, display_name?: string | null } | null } | null }>, patients_without_reschedules: Array<{ __typename?: 'Patient', id: string, pms?: PracticeManagementSystem | null, pms_id?: string | null, name?: string | null, breed?: string | null, avatar_url?: string | null, last_appt_time?: number | null, gender?: string | null, fixed_status?: FixedStatus | null, weight?: number | null, birthday?: number | null, is_active?: boolean | null, is_deceased?: boolean | null, pms_created_at?: number | null, created_at: number, updated_at: number, owner?: { __typename?: 'Client', id: string, first_name?: string | null, last_name?: string | null, email?: string | null, phone?: string | null, address?: { __typename?: 'Address', country?: string | null } | null } | null, clinic_species?: { __typename?: 'ClinicSpecies', id: string, pms_id: string, description: string, is_primary: boolean, species: Species, weight_key: string, created_at: number, updated_at: number } | null, clinic?: { __typename?: 'Clinic', id: string } | null, clinic_breed?: { __typename?: 'Breed', id: string, description: string } | null, patient_vaccination_records?: Array<{ __typename?: 'PatientVaccinationRecord', id: string, vaccine_name?: string | null, manufacturer?: string | null, lot_number?: string | null, administered_date?: number | null, due_date?: number | null, rabies_tag?: string | null, is_rabies_vaccine?: boolean | null, is_soc: boolean, is_active: boolean, product?: { __typename?: 'Product', id: string, display_name?: string | null, name: string } | null }> | null, last_appointment?: { __typename?: 'Appointment', clinician?: { __typename?: 'Clinician', name: string, display_name?: string | null } | null } | null }> } };

export type OrganizationAnalyticsNumbersFieldsFragment = { __typename?: 'OrganizationAnalyticsNumbers', clinic: { __typename?: 'Clinic', id: string, name?: string | null, pms: PracticeManagementSystem }, analytic_numbers: { __typename?: 'OrganizationClinicAnalyticsNumbers', appointments_count: { __typename?: 'IntPercentile', value: number, percentile: number }, no_show_count: { __typename?: 'IntPercentile', value: number, percentile: number }, revenue: { __typename?: 'FloatPercentile', value: number, percentile: number }, transactions_count: { __typename?: 'IntPercentile', value: number, percentile: number }, revenue_per_appointment: { __typename?: 'FloatPercentile', value: number, percentile: number }, new_clients_count: { __typename?: 'IntPercentile', value: number, percentile: number }, new_patients_count: { __typename?: 'IntPercentile', value: number, percentile: number }, new_appointments_count: { __typename?: 'IntPercentile', value: number, percentile: number }, schedule_efficiency: { __typename?: 'FloatPercentile', value: number, percentile: number }, forward_scheduled_patients_count: { __typename?: 'IntPercentile', value: number, percentile: number } } };

export type GetOrganizationAnalyticsQueryVariables = Exact<{
  organizationId: Scalars['ID']['input'];
  fromDate: Scalars['NonNegativeInt']['input'];
  toDate: Scalars['NonNegativeInt']['input'];
}>;


export type GetOrganizationAnalyticsQuery = { __typename?: 'Query', organizationAnalytics: Array<{ __typename?: 'OrganizationAnalytics', clinic: { __typename?: 'Clinic', id: string, name?: string | null, pms: PracticeManagementSystem }, analytics: { __typename?: 'ClinicAnalytics', appointments_count: number, no_show_count: number, revenue: number, transactions_count: number, accounts_receivable: number, clients_with_negative_balances_count: number, monthly_revenue_completed: number, monthly_appointments_scheduled: number, last_month_average_revenue_per_appointment: number, new_clients_count: number, new_patients_count: number, new_appointments_count: number, schedule_efficiency: number, forward_scheduled_patients_count: number, appointments: Array<{ __typename?: 'Appointment', id: string, pms?: PracticeManagementSystem | null, client_pms_id?: string | null, is_new_client?: boolean | null, start_time: number, drop_off_time?: number | null, minutes: number, is_new_patient?: boolean | null, is_clinician_auto_assigned?: boolean | null, patient_pms_id?: string | null, referring_clinic_name?: string | null, client_notes?: string | null, clinic_notes?: string | null, service_name?: string | null, status: AppointmentStatus, is_time_block?: boolean | null, is_confirmed?: boolean | null, origin?: EntityOrigin | null, reason_for_cancellation?: string | null, client_reason_for_cancellation?: string | null, new_client_name?: string | null, new_client_phone?: string | null, new_patient_name?: string | null, new_patient_species?: string | null, confirmed_at?: number | null, widget_source?: string | null, from_widget?: string | null, is_deleted?: boolean | null, created_at: number, updated_at: number, pms_created_at?: number | null, clinic?: { __typename?: 'Clinic', id: string, name?: string | null, slug?: string | null, pms_db?: { __typename?: 'PmsDb', id: string } | null, address?: { __typename?: 'Address', country?: string | null } | null } | null, client?: { __typename?: 'Client', id: string, first_name?: string | null, last_name?: string | null, secondary_first_name?: string | null, secondary_last_name?: string | null, phone?: string | null, email?: string | null, pms?: PracticeManagementSystem | null, pms_id?: string | null, last_appt_time?: number | null, last_contact_time?: number | null, email_enabled: boolean, sms_enabled: boolean, balance?: number | null, is_active?: boolean | null, is_unsubscribed: boolean, created_at: number, updated_at: number, client_phones?: Array<{ __typename?: 'ClientPhone', id: string, phone: string, country_code?: string | null, is_primary: boolean, is_chckup_primary: boolean, is_mobile: boolean, sms_available: boolean, is_unsubscribed: boolean, is_active: boolean, name?: string | null }> | null, client_emails?: Array<{ __typename?: 'ClientEmail', id: string, email: string, is_primary: boolean }> | null, clinic?: { __typename?: 'Clinic', id: string } | null, patients?: Array<{ __typename?: 'Patient', id: string, pms?: PracticeManagementSystem | null, pms_id?: string | null, name?: string | null, breed?: string | null, avatar_url?: string | null, last_appt_time?: number | null, gender?: string | null, fixed_status?: FixedStatus | null, weight?: number | null, birthday?: number | null, is_active?: boolean | null, is_deceased?: boolean | null, pms_created_at?: number | null, created_at: number, updated_at: number, owner?: { __typename?: 'Client', id: string, first_name?: string | null, last_name?: string | null, email?: string | null, phone?: string | null, address?: { __typename?: 'Address', country?: string | null } | null } | null, clinic_species?: { __typename?: 'ClinicSpecies', id: string, pms_id: string, description: string, is_primary: boolean, species: Species, weight_key: string, created_at: number, updated_at: number } | null, clinic?: { __typename?: 'Clinic', id: string } | null, clinic_breed?: { __typename?: 'Breed', id: string, description: string } | null, patient_vaccination_records?: Array<{ __typename?: 'PatientVaccinationRecord', id: string, vaccine_name?: string | null, manufacturer?: string | null, lot_number?: string | null, administered_date?: number | null, due_date?: number | null, rabies_tag?: string | null, is_rabies_vaccine?: boolean | null, is_soc: boolean, is_active: boolean, product?: { __typename?: 'Product', id: string, display_name?: string | null, name: string } | null }> | null, last_appointment?: { __typename?: 'Appointment', clinician?: { __typename?: 'Clinician', name: string, display_name?: string | null } | null } | null }> | null, address?: { __typename?: 'Address', street_a?: string | null, street_b?: string | null, city?: string | null, state?: string | null, zip?: string | null, country?: string | null } | null, user?: { __typename?: 'User', avatar_url?: string | null } | null, loyalty_members?: Array<{ __typename?: 'LoyaltyMember', id: string, available_points: number } | null> | null, settings?: { __typename?: 'ClientSettings', clinic_chckup_notifications_enabled: boolean, clinic_chckup_sms_enabled: boolean, clinic_chckup_email_enabled: boolean, client_chckup_notifications_enabled: boolean, client_chckup_sms_enabled: boolean, client_chckup_email_enabled: boolean, is_unsubscribed_from_marketing: boolean, is_unsubscribed_from_marketing_sms: boolean, is_unsubscribed_from_marketing_email: boolean } | null, last_appointment?: { __typename?: 'Appointment', clinician?: { __typename?: 'Clinician', name: string, display_name?: string | null } | null } | null } | null, clinician?: { __typename?: 'Clinician', id: string, name: string, display_name?: string | null, bio?: string | null, avatar_url?: string | null, initials?: string | null, excluded_species?: Array<Species> | null, excluded_service_ids?: Array<string> | null, authority_level?: AuthorityLevel | null, type: ResourceType, is_active?: boolean | null, is_assignable_in_pms?: boolean | null, does_contribute_to_fill_rate?: boolean | null, pms_id?: string | null, location?: string | null, pms_is_active: boolean, valid_booking_interval_minutes?: Array<number> | null, created_at: number, updated_at: number, clinic?: { __typename?: 'Clinic', id: string, name?: string | null } | null, pms_db?: { __typename?: 'PmsDb', id: string } | null, hours?: { __typename?: 'AvailabilityHours', monday?: Array<{ __typename?: 'TimeInterval', start?: number | null, end?: number | null }> | null, tuesday?: Array<{ __typename?: 'TimeInterval', start?: number | null, end?: number | null }> | null, wednesday?: Array<{ __typename?: 'TimeInterval', start?: number | null, end?: number | null }> | null, thursday?: Array<{ __typename?: 'TimeInterval', start?: number | null, end?: number | null }> | null, friday?: Array<{ __typename?: 'TimeInterval', start?: number | null, end?: number | null }> | null, saturday?: Array<{ __typename?: 'TimeInterval', start?: number | null, end?: number | null }> | null, sunday?: Array<{ __typename?: 'TimeInterval', start?: number | null, end?: number | null }> | null } | null, adjusted_availability?: Array<{ __typename?: 'Availability', date: number, pms_appt_type_pms_id?: string | null, times: Array<{ __typename?: 'TimeInterval', start?: number | null, end?: number | null }>, repeat?: { __typename?: 'RepeatAvailability', daysOfMonth?: Array<number> | null, daysOfWeek?: Array<DayOfWeek> | null, weekOfMonth?: WeekOfMonth | null, frequency: any, unit: RepeatUnit, end_date?: number | null } | null }> | null, pms_adjusted_availability?: Array<{ __typename?: 'Availability', date: number, pms_appt_type_pms_id?: string | null, times: Array<{ __typename?: 'TimeInterval', start?: number | null, end?: number | null }>, repeat?: { __typename?: 'RepeatAvailability', daysOfMonth?: Array<number> | null, daysOfWeek?: Array<DayOfWeek> | null, weekOfMonth?: WeekOfMonth | null, frequency: any, unit: RepeatUnit, end_date?: number | null } | null }> | null } | null, room?: { __typename?: 'Room', id: string, pms_id: string, name: string, display_name?: string | null, description?: string | null, concurrent_patients?: number | null, is_active: boolean, does_contribute_to_fill_rate?: boolean | null, valid_booking_interval_minutes?: Array<number> | null, created_at: number, updated_at: number, clinic?: { __typename?: 'Clinic', pms: PracticeManagementSystem, id: string, name?: string | null, time_zone?: string | null } | null, hours?: { __typename?: 'AvailabilityHours', monday?: Array<{ __typename?: 'TimeInterval', start?: number | null, end?: number | null }> | null, tuesday?: Array<{ __typename?: 'TimeInterval', start?: number | null, end?: number | null }> | null, wednesday?: Array<{ __typename?: 'TimeInterval', start?: number | null, end?: number | null }> | null, thursday?: Array<{ __typename?: 'TimeInterval', start?: number | null, end?: number | null }> | null, friday?: Array<{ __typename?: 'TimeInterval', start?: number | null, end?: number | null }> | null, saturday?: Array<{ __typename?: 'TimeInterval', start?: number | null, end?: number | null }> | null, sunday?: Array<{ __typename?: 'TimeInterval', start?: number | null, end?: number | null }> | null } | null, adjusted_availability?: Array<{ __typename?: 'Availability', date: number, pms_appt_type_pms_id?: string | null, times: Array<{ __typename?: 'TimeInterval', start?: number | null, end?: number | null }>, repeat?: { __typename?: 'RepeatAvailability', daysOfMonth?: Array<number> | null, daysOfWeek?: Array<DayOfWeek> | null, weekOfMonth?: WeekOfMonth | null, frequency: any, unit: RepeatUnit, end_date?: number | null } | null }> | null, pms_adjusted_availability?: Array<{ __typename?: 'Availability', date: number, pms_appt_type_pms_id?: string | null, times: Array<{ __typename?: 'TimeInterval', start?: number | null, end?: number | null }>, repeat?: { __typename?: 'RepeatAvailability', daysOfMonth?: Array<number> | null, daysOfWeek?: Array<DayOfWeek> | null, weekOfMonth?: WeekOfMonth | null, frequency: any, unit: RepeatUnit, end_date?: number | null } | null }> | null } | null, service?: { __typename?: 'Service', id: string, name?: string | null, color?: string | null } | null, patient?: { __typename?: 'Patient', id: string, pms?: PracticeManagementSystem | null, pms_id?: string | null, name?: string | null, breed?: string | null, avatar_url?: string | null, last_appt_time?: number | null, gender?: string | null, fixed_status?: FixedStatus | null, weight?: number | null, birthday?: number | null, is_active?: boolean | null, is_deceased?: boolean | null, pms_created_at?: number | null, created_at: number, updated_at: number, owner?: { __typename?: 'Client', id: string, first_name?: string | null, last_name?: string | null, email?: string | null, phone?: string | null, address?: { __typename?: 'Address', country?: string | null } | null } | null, clinic_species?: { __typename?: 'ClinicSpecies', id: string, pms_id: string, description: string, is_primary: boolean, species: Species, weight_key: string, created_at: number, updated_at: number } | null, clinic?: { __typename?: 'Clinic', id: string } | null, clinic_breed?: { __typename?: 'Breed', id: string, description: string } | null, patient_vaccination_records?: Array<{ __typename?: 'PatientVaccinationRecord', id: string, vaccine_name?: string | null, manufacturer?: string | null, lot_number?: string | null, administered_date?: number | null, due_date?: number | null, rabies_tag?: string | null, is_rabies_vaccine?: boolean | null, is_soc: boolean, is_active: boolean, product?: { __typename?: 'Product', id: string, display_name?: string | null, name: string } | null }> | null, last_appointment?: { __typename?: 'Appointment', clinician?: { __typename?: 'Clinician', name: string, display_name?: string | null } | null } | null } | null, clinic_appt_status?: { __typename?: 'ClinicApptStatus', id: string, description: string, status: AppointmentStatus } | null, client_info?: { __typename?: 'ClientInfo', first_name?: string | null, last_name?: string | null, email?: string | null, phone?: string | null } | null, patient_info?: { __typename?: 'PatientInfo', patient_name?: string | null, patient_breed?: string | null, patient_clinic_species?: string | null, patient_clinic_breed?: string | null } | null, clients_forms?: Array<{ __typename?: 'ClientForm', id: string, client_completed_at?: number | null, clinic_verified_at?: number | null, is_archived: boolean, pms_id?: string | null, created_at: number, updated_at: number, client?: { __typename?: 'Client', id: string, first_name?: string | null, last_name?: string | null, phone?: string | null, email?: string | null, address?: { __typename?: 'Address', street_a?: string | null, city?: string | null, state?: string | null, zip?: string | null, country?: string | null } | null } | null, patient?: { __typename?: 'Patient', id: string, name?: string | null, is_active?: boolean | null, is_deceased?: boolean | null, birthday?: number | null, weight?: number | null, avatar_url?: string | null, gender?: string | null, owner?: { __typename?: 'Client', first_name?: string | null, last_name?: string | null } | null, clinic_species?: { __typename?: 'ClinicSpecies', id: string, species: Species, description: string, weight_key: string } | null, clinic_breed?: { __typename?: 'Breed', id: string, description: string } | null } | null, form: { __typename?: 'Form', id: string, name?: string | null, form_type: FormType, is_writeback_enabled: boolean, form_file_naming_template?: string | null }, form_data: { __typename?: 'FormFields', pages?: Array<{ __typename?: 'FormPage', id: string, title?: string | null, description?: string | null, order?: number | null }> | null, fields?: Array<{ __typename?: 'FormElement', id: string, type?: FormElementType | null, content?: string | null, name?: string | null, column_order?: number | null, row_order?: number | null, page_id?: string | null, options?: Array<string> | null, is_required?: boolean | null, value?: string | null, attachments?: Array<{ __typename?: 'FormFileAttachment', id?: string | null, filename?: string | null, mime_type?: string | null, size_bytes?: number | null, thumbnail_url?: string | null, url: string }> | null, field_updates?: Array<{ __typename?: 'FormFieldUpdate', field: FormFieldUpdateField, boolean_value?: boolean | null, option?: string | null }> | null }> | null }, appointment?: { __typename?: 'Appointment', start_time: number, drop_off_time?: number | null, clinic?: { __typename?: 'Clinic', name?: string | null, slug?: string | null, phone?: string | null, email?: string | null, address?: { __typename?: 'Address', street_a?: string | null, city?: string | null, state?: string | null, zip?: string | null, country?: string | null } | null } | null, clinician?: { __typename?: 'Clinician', name: string, display_name?: string | null } | null, service?: { __typename?: 'Service', name?: string | null } | null } | null }> | null, widget?: { __typename?: 'Widget', id: string, widget_name: string } | null }>, revenue_by_type: Array<{ __typename?: 'RevenueGroup', group: string, amount: number }>, revenue_by_clinician: Array<{ __typename?: 'RevenueGroup', group: string, amount: number }>, clients_with_negative_balances: Array<{ __typename?: 'Client', id: string, first_name?: string | null, last_name?: string | null, secondary_first_name?: string | null, secondary_last_name?: string | null, phone?: string | null, email?: string | null, pms?: PracticeManagementSystem | null, pms_id?: string | null, last_appt_time?: number | null, last_contact_time?: number | null, email_enabled: boolean, sms_enabled: boolean, balance?: number | null, is_active?: boolean | null, is_unsubscribed: boolean, created_at: number, updated_at: number, client_phones?: Array<{ __typename?: 'ClientPhone', id: string, phone: string, country_code?: string | null, is_primary: boolean, is_chckup_primary: boolean, is_mobile: boolean, sms_available: boolean, is_unsubscribed: boolean, is_active: boolean, name?: string | null }> | null, client_emails?: Array<{ __typename?: 'ClientEmail', id: string, email: string, is_primary: boolean }> | null, clinic?: { __typename?: 'Clinic', id: string } | null, patients?: Array<{ __typename?: 'Patient', id: string, pms?: PracticeManagementSystem | null, pms_id?: string | null, name?: string | null, breed?: string | null, avatar_url?: string | null, last_appt_time?: number | null, gender?: string | null, fixed_status?: FixedStatus | null, weight?: number | null, birthday?: number | null, is_active?: boolean | null, is_deceased?: boolean | null, pms_created_at?: number | null, created_at: number, updated_at: number, owner?: { __typename?: 'Client', id: string, first_name?: string | null, last_name?: string | null, email?: string | null, phone?: string | null, address?: { __typename?: 'Address', country?: string | null } | null } | null, clinic_species?: { __typename?: 'ClinicSpecies', id: string, pms_id: string, description: string, is_primary: boolean, species: Species, weight_key: string, created_at: number, updated_at: number } | null, clinic?: { __typename?: 'Clinic', id: string } | null, clinic_breed?: { __typename?: 'Breed', id: string, description: string } | null, patient_vaccination_records?: Array<{ __typename?: 'PatientVaccinationRecord', id: string, vaccine_name?: string | null, manufacturer?: string | null, lot_number?: string | null, administered_date?: number | null, due_date?: number | null, rabies_tag?: string | null, is_rabies_vaccine?: boolean | null, is_soc: boolean, is_active: boolean, product?: { __typename?: 'Product', id: string, display_name?: string | null, name: string } | null }> | null, last_appointment?: { __typename?: 'Appointment', clinician?: { __typename?: 'Clinician', name: string, display_name?: string | null } | null } | null }> | null, address?: { __typename?: 'Address', street_a?: string | null, street_b?: string | null, city?: string | null, state?: string | null, zip?: string | null, country?: string | null } | null, user?: { __typename?: 'User', avatar_url?: string | null } | null, loyalty_members?: Array<{ __typename?: 'LoyaltyMember', id: string, available_points: number } | null> | null, settings?: { __typename?: 'ClientSettings', clinic_chckup_notifications_enabled: boolean, clinic_chckup_sms_enabled: boolean, clinic_chckup_email_enabled: boolean, client_chckup_notifications_enabled: boolean, client_chckup_sms_enabled: boolean, client_chckup_email_enabled: boolean, is_unsubscribed_from_marketing: boolean, is_unsubscribed_from_marketing_sms: boolean, is_unsubscribed_from_marketing_email: boolean } | null, last_appointment?: { __typename?: 'Appointment', clinician?: { __typename?: 'Clinician', name: string, display_name?: string | null } | null } | null }>, patients_without_reschedules: Array<{ __typename?: 'Patient', id: string, pms?: PracticeManagementSystem | null, pms_id?: string | null, name?: string | null, breed?: string | null, avatar_url?: string | null, last_appt_time?: number | null, gender?: string | null, fixed_status?: FixedStatus | null, weight?: number | null, birthday?: number | null, is_active?: boolean | null, is_deceased?: boolean | null, pms_created_at?: number | null, created_at: number, updated_at: number, owner?: { __typename?: 'Client', id: string, first_name?: string | null, last_name?: string | null, email?: string | null, phone?: string | null, address?: { __typename?: 'Address', country?: string | null } | null } | null, clinic_species?: { __typename?: 'ClinicSpecies', id: string, pms_id: string, description: string, is_primary: boolean, species: Species, weight_key: string, created_at: number, updated_at: number } | null, clinic?: { __typename?: 'Clinic', id: string } | null, clinic_breed?: { __typename?: 'Breed', id: string, description: string } | null, patient_vaccination_records?: Array<{ __typename?: 'PatientVaccinationRecord', id: string, vaccine_name?: string | null, manufacturer?: string | null, lot_number?: string | null, administered_date?: number | null, due_date?: number | null, rabies_tag?: string | null, is_rabies_vaccine?: boolean | null, is_soc: boolean, is_active: boolean, product?: { __typename?: 'Product', id: string, display_name?: string | null, name: string } | null }> | null, last_appointment?: { __typename?: 'Appointment', clinician?: { __typename?: 'Clinician', name: string, display_name?: string | null } | null } | null }> } }> };

export type GetOrganizationAnalyticsNumbersQueryVariables = Exact<{
  organizationId: Scalars['ID']['input'];
  fromDate: Scalars['NonNegativeInt']['input'];
  toDate: Scalars['NonNegativeInt']['input'];
}>;


export type GetOrganizationAnalyticsNumbersQuery = { __typename?: 'Query', organizationAnalyticsNumbers: Array<{ __typename?: 'OrganizationAnalyticsNumbers', clinic: { __typename?: 'Clinic', id: string, name?: string | null, pms: PracticeManagementSystem }, analytic_numbers: { __typename?: 'OrganizationClinicAnalyticsNumbers', appointments_count: { __typename?: 'IntPercentile', value: number, percentile: number }, no_show_count: { __typename?: 'IntPercentile', value: number, percentile: number }, revenue: { __typename?: 'FloatPercentile', value: number, percentile: number }, transactions_count: { __typename?: 'IntPercentile', value: number, percentile: number }, revenue_per_appointment: { __typename?: 'FloatPercentile', value: number, percentile: number }, new_clients_count: { __typename?: 'IntPercentile', value: number, percentile: number }, new_patients_count: { __typename?: 'IntPercentile', value: number, percentile: number }, new_appointments_count: { __typename?: 'IntPercentile', value: number, percentile: number }, schedule_efficiency: { __typename?: 'FloatPercentile', value: number, percentile: number }, forward_scheduled_patients_count: { __typename?: 'IntPercentile', value: number, percentile: number } } }> };

export type GetOrganizationScheduleEfficiencyQueryVariables = Exact<{
  organizationId: Scalars['ID']['input'];
  fromDate: Scalars['NonNegativeInt']['input'];
  toDate: Scalars['NonNegativeInt']['input'];
}>;


export type GetOrganizationScheduleEfficiencyQuery = { __typename?: 'Query', organizationScheduleEfficiency: { __typename?: 'OrganizationScheduleEfficiency', average: number, per_clinic: Array<{ __typename?: 'ClinicsScheduleEfficiency', schedule_efficiency: number, clinic: { __typename?: 'Clinic', id: string, name?: string | null } }> } };

export type GetOrganizationAnalyticsNumbersByMonthsQueryVariables = Exact<{
  organizationId: Scalars['ID']['input'];
  numMonths: Scalars['NonNegativeInt']['input'];
}>;


export type GetOrganizationAnalyticsNumbersByMonthsQuery = { __typename?: 'Query', getAnalyticsNumbersByMonthsForOrganization: Array<{ __typename?: 'OrganizationAnalyticsNumbersByMonth', clinic: { __typename?: 'Clinic', id: string, name?: string | null }, analytic_numbers: Array<{ __typename?: 'AnalyticsNumbersByMonth', month: number, year: number, analytics: { __typename?: 'AnalyticsNumbers', appointments_count: number, no_show_count: number, revenue: number, transactions_count: number, revenue_per_appointment: number, new_clients_count: number, new_patients_count: number, new_appointments_count: number, schedule_efficiency: number, forward_scheduled_patients_count: number } }> }> };

export type GetOrganizationRevenueByMonthsQueryVariables = Exact<{
  organizationId: Scalars['ID']['input'];
  numMonths: Scalars['NonNegativeInt']['input'];
}>;


export type GetOrganizationRevenueByMonthsQuery = { __typename?: 'Query', getRevenueByMonthsForOrganization: Array<{ __typename?: 'OrganizationRevenueByMonth', clinic: { __typename?: 'Clinic', id: string, name?: string | null }, revenue: Array<{ __typename?: 'RevenueByMonth', revenue: number, month: number, year: number }> }> };

export type OrganizationClinicFieldsFragment = { __typename?: 'Clinic', id: string, name?: string | null, avatar_url?: string | null, is_archived: boolean, address?: { __typename?: 'Address', street_a?: string | null, street_b?: string | null, city?: string | null, state?: string | null, zip?: string | null } | null };

export type OrganizationAdminFieldsFragment = { __typename?: 'User', id: string, first_name?: string | null, last_name?: string | null, email?: any | null };

export type OrganizationFieldsFragment = { __typename?: 'Organization', id: string, name: string, slug?: string | null, created_at: number, updated_at: number, clinics: Array<{ __typename?: 'Clinic', id: string, name?: string | null, avatar_url?: string | null, is_archived: boolean, address?: { __typename?: 'Address', street_a?: string | null, street_b?: string | null, city?: string | null, state?: string | null, zip?: string | null } | null }>, admins: Array<{ __typename?: 'User', id: string, first_name?: string | null, last_name?: string | null, email?: any | null }>, settings?: { __typename?: 'OrganizationSettings', primary_color?: string | null, accent_color?: string | null, custom_well_description?: string | null, custom_sick_description?: string | null, custom_other_title?: string | null, custom_other_description?: string | null, custom_booking_copy?: { __typename?: 'ClinicBookingCopy', WIDGET_HEADER_TITLE?: string | null, SHOW_CLINIC_HEADER_LOGO?: boolean | null, CLINIC_HEADER_LOGO_HEIGHT?: number | null, SERVICE_TYPE_SECTION_HEADING?: string | null, DEFAULT_WELLNESS_DESCRIPTION?: string | null, DEFAULT_SICK_DESCRIPTION?: string | null, DEFAULT_OTHER_DESCRIPTION?: string | null, RETURNING_PATIENT_QUESTION?: string | null, POSITIVE_RETURNING_PATIENT_ANSWER?: string | null, NEGATIVE_RETURNING_PATIENT_ANSWER?: string | null, RETURNING_CLIENT_QUESTION?: string | null, POSITIVE_RETURNING_CLIENT_ANSWER?: string | null, NEGATIVE_RETURNING_CLIENT_ANSWER?: string | null, CLIENT_INFORMATION_SECTION_TITLE?: string | null, PATIENT_INFORMATION_SECTION_TITLE?: string | null, RETURNING_CLIENT_PATIENT_TITLE?: string | null, RETURNING_CLIENT_PATIENT_DESCRIPTION?: string | null, SERVICE_SECTION_TITLE?: string | null, PREPAID_SERVICES_LABEL?: string | null, STANDARD_SERVICES_LABEL?: string | null, DEPOSIT_FEE_NAME?: string | null, PREVIOUS_OR_REFERRING_CLINIC_QUESTION?: string | null, CONTACT_THE_CLINIC_TEXT?: string | null, CONTACT_THE_CLINIC_TEXT_COLOR?: string | null, CONTACT_THE_CLINIC_TEXT_SIZE?: string | null, SELECT_CLINICIAN_TITLE?: string | null, SELECT_CLINICIAN_POSITIVE_ANSWER?: string | null, SELECT_CLINICIAN_NEGATIVE_ANSWER?: string | null, SELECT_TIME_TITLE?: string | null, REVIEW_TITLE?: string | null, REVIEW_NOTES_PROMPT?: string | null, PAYMENT_INFORMATION_TITLE?: string | null, TRIGGER_WORDS_DETECTED_HEADER?: string | null, TRIGGER_WORDS_DETECTED_DESCRIPTION?: string | null, CONFIRMATION_SCREEN_TITLE?: string | null, CONFIRMATION_SCREEN_DESCRIPTION?: string | null, NEW_CLIENT_BLOCKED_MESSAGE?: string | null, NEW_PATIENT_BLOCKED_MESSAGE?: string | null } | null } | null };

export type OrganizationSettingsFieldsFragment = { __typename?: 'OrganizationSettings', primary_color?: string | null, accent_color?: string | null, custom_well_description?: string | null, custom_sick_description?: string | null, custom_other_title?: string | null, custom_other_description?: string | null, custom_booking_copy?: { __typename?: 'ClinicBookingCopy', WIDGET_HEADER_TITLE?: string | null, SHOW_CLINIC_HEADER_LOGO?: boolean | null, CLINIC_HEADER_LOGO_HEIGHT?: number | null, SERVICE_TYPE_SECTION_HEADING?: string | null, DEFAULT_WELLNESS_DESCRIPTION?: string | null, DEFAULT_SICK_DESCRIPTION?: string | null, DEFAULT_OTHER_DESCRIPTION?: string | null, RETURNING_PATIENT_QUESTION?: string | null, POSITIVE_RETURNING_PATIENT_ANSWER?: string | null, NEGATIVE_RETURNING_PATIENT_ANSWER?: string | null, RETURNING_CLIENT_QUESTION?: string | null, POSITIVE_RETURNING_CLIENT_ANSWER?: string | null, NEGATIVE_RETURNING_CLIENT_ANSWER?: string | null, CLIENT_INFORMATION_SECTION_TITLE?: string | null, PATIENT_INFORMATION_SECTION_TITLE?: string | null, RETURNING_CLIENT_PATIENT_TITLE?: string | null, RETURNING_CLIENT_PATIENT_DESCRIPTION?: string | null, SERVICE_SECTION_TITLE?: string | null, PREPAID_SERVICES_LABEL?: string | null, STANDARD_SERVICES_LABEL?: string | null, DEPOSIT_FEE_NAME?: string | null, PREVIOUS_OR_REFERRING_CLINIC_QUESTION?: string | null, CONTACT_THE_CLINIC_TEXT?: string | null, CONTACT_THE_CLINIC_TEXT_COLOR?: string | null, CONTACT_THE_CLINIC_TEXT_SIZE?: string | null, SELECT_CLINICIAN_TITLE?: string | null, SELECT_CLINICIAN_POSITIVE_ANSWER?: string | null, SELECT_CLINICIAN_NEGATIVE_ANSWER?: string | null, SELECT_TIME_TITLE?: string | null, REVIEW_TITLE?: string | null, REVIEW_NOTES_PROMPT?: string | null, PAYMENT_INFORMATION_TITLE?: string | null, TRIGGER_WORDS_DETECTED_HEADER?: string | null, TRIGGER_WORDS_DETECTED_DESCRIPTION?: string | null, CONFIRMATION_SCREEN_TITLE?: string | null, CONFIRMATION_SCREEN_DESCRIPTION?: string | null, NEW_CLIENT_BLOCKED_MESSAGE?: string | null, NEW_PATIENT_BLOCKED_MESSAGE?: string | null } | null };

export type GetOrganizationQueryVariables = Exact<{
  id: Scalars['ID']['input'];
}>;


export type GetOrganizationQuery = { __typename?: 'Query', organization: { __typename?: 'Organization', id: string, name: string, slug?: string | null, created_at: number, updated_at: number, clinics: Array<{ __typename?: 'Clinic', id: string, name?: string | null, avatar_url?: string | null, is_archived: boolean, address?: { __typename?: 'Address', street_a?: string | null, street_b?: string | null, city?: string | null, state?: string | null, zip?: string | null } | null }>, admins: Array<{ __typename?: 'User', id: string, first_name?: string | null, last_name?: string | null, email?: any | null }>, settings?: { __typename?: 'OrganizationSettings', primary_color?: string | null, accent_color?: string | null, custom_well_description?: string | null, custom_sick_description?: string | null, custom_other_title?: string | null, custom_other_description?: string | null, custom_booking_copy?: { __typename?: 'ClinicBookingCopy', WIDGET_HEADER_TITLE?: string | null, SHOW_CLINIC_HEADER_LOGO?: boolean | null, CLINIC_HEADER_LOGO_HEIGHT?: number | null, SERVICE_TYPE_SECTION_HEADING?: string | null, DEFAULT_WELLNESS_DESCRIPTION?: string | null, DEFAULT_SICK_DESCRIPTION?: string | null, DEFAULT_OTHER_DESCRIPTION?: string | null, RETURNING_PATIENT_QUESTION?: string | null, POSITIVE_RETURNING_PATIENT_ANSWER?: string | null, NEGATIVE_RETURNING_PATIENT_ANSWER?: string | null, RETURNING_CLIENT_QUESTION?: string | null, POSITIVE_RETURNING_CLIENT_ANSWER?: string | null, NEGATIVE_RETURNING_CLIENT_ANSWER?: string | null, CLIENT_INFORMATION_SECTION_TITLE?: string | null, PATIENT_INFORMATION_SECTION_TITLE?: string | null, RETURNING_CLIENT_PATIENT_TITLE?: string | null, RETURNING_CLIENT_PATIENT_DESCRIPTION?: string | null, SERVICE_SECTION_TITLE?: string | null, PREPAID_SERVICES_LABEL?: string | null, STANDARD_SERVICES_LABEL?: string | null, DEPOSIT_FEE_NAME?: string | null, PREVIOUS_OR_REFERRING_CLINIC_QUESTION?: string | null, CONTACT_THE_CLINIC_TEXT?: string | null, CONTACT_THE_CLINIC_TEXT_COLOR?: string | null, CONTACT_THE_CLINIC_TEXT_SIZE?: string | null, SELECT_CLINICIAN_TITLE?: string | null, SELECT_CLINICIAN_POSITIVE_ANSWER?: string | null, SELECT_CLINICIAN_NEGATIVE_ANSWER?: string | null, SELECT_TIME_TITLE?: string | null, REVIEW_TITLE?: string | null, REVIEW_NOTES_PROMPT?: string | null, PAYMENT_INFORMATION_TITLE?: string | null, TRIGGER_WORDS_DETECTED_HEADER?: string | null, TRIGGER_WORDS_DETECTED_DESCRIPTION?: string | null, CONFIRMATION_SCREEN_TITLE?: string | null, CONFIRMATION_SCREEN_DESCRIPTION?: string | null, NEW_CLIENT_BLOCKED_MESSAGE?: string | null, NEW_PATIENT_BLOCKED_MESSAGE?: string | null } | null } | null } };

export type QueryOrganizationsQueryVariables = Exact<{
  where?: InputMaybe<Array<QueryInput> | QueryInput>;
  page?: InputMaybe<Scalars['NonNegativeInt']['input']>;
  pageSize?: InputMaybe<Scalars['NonNegativeInt']['input']>;
  orderBy?: InputMaybe<OrderByInput>;
}>;


export type QueryOrganizationsQuery = { __typename?: 'Query', queryOrganizations: Array<{ __typename?: 'Organization', id: string, name: string, slug?: string | null, created_at: number, updated_at: number, clinics: Array<{ __typename?: 'Clinic', id: string, name?: string | null, avatar_url?: string | null, is_archived: boolean, address?: { __typename?: 'Address', street_a?: string | null, street_b?: string | null, city?: string | null, state?: string | null, zip?: string | null } | null }>, admins: Array<{ __typename?: 'User', id: string, first_name?: string | null, last_name?: string | null, email?: any | null }>, settings?: { __typename?: 'OrganizationSettings', primary_color?: string | null, accent_color?: string | null, custom_well_description?: string | null, custom_sick_description?: string | null, custom_other_title?: string | null, custom_other_description?: string | null, custom_booking_copy?: { __typename?: 'ClinicBookingCopy', WIDGET_HEADER_TITLE?: string | null, SHOW_CLINIC_HEADER_LOGO?: boolean | null, CLINIC_HEADER_LOGO_HEIGHT?: number | null, SERVICE_TYPE_SECTION_HEADING?: string | null, DEFAULT_WELLNESS_DESCRIPTION?: string | null, DEFAULT_SICK_DESCRIPTION?: string | null, DEFAULT_OTHER_DESCRIPTION?: string | null, RETURNING_PATIENT_QUESTION?: string | null, POSITIVE_RETURNING_PATIENT_ANSWER?: string | null, NEGATIVE_RETURNING_PATIENT_ANSWER?: string | null, RETURNING_CLIENT_QUESTION?: string | null, POSITIVE_RETURNING_CLIENT_ANSWER?: string | null, NEGATIVE_RETURNING_CLIENT_ANSWER?: string | null, CLIENT_INFORMATION_SECTION_TITLE?: string | null, PATIENT_INFORMATION_SECTION_TITLE?: string | null, RETURNING_CLIENT_PATIENT_TITLE?: string | null, RETURNING_CLIENT_PATIENT_DESCRIPTION?: string | null, SERVICE_SECTION_TITLE?: string | null, PREPAID_SERVICES_LABEL?: string | null, STANDARD_SERVICES_LABEL?: string | null, DEPOSIT_FEE_NAME?: string | null, PREVIOUS_OR_REFERRING_CLINIC_QUESTION?: string | null, CONTACT_THE_CLINIC_TEXT?: string | null, CONTACT_THE_CLINIC_TEXT_COLOR?: string | null, CONTACT_THE_CLINIC_TEXT_SIZE?: string | null, SELECT_CLINICIAN_TITLE?: string | null, SELECT_CLINICIAN_POSITIVE_ANSWER?: string | null, SELECT_CLINICIAN_NEGATIVE_ANSWER?: string | null, SELECT_TIME_TITLE?: string | null, REVIEW_TITLE?: string | null, REVIEW_NOTES_PROMPT?: string | null, PAYMENT_INFORMATION_TITLE?: string | null, TRIGGER_WORDS_DETECTED_HEADER?: string | null, TRIGGER_WORDS_DETECTED_DESCRIPTION?: string | null, CONFIRMATION_SCREEN_TITLE?: string | null, CONFIRMATION_SCREEN_DESCRIPTION?: string | null, NEW_CLIENT_BLOCKED_MESSAGE?: string | null, NEW_PATIENT_BLOCKED_MESSAGE?: string | null } | null } | null }> };

export type CountOrganizationsQueryVariables = Exact<{
  where?: InputMaybe<Array<QueryInput> | QueryInput>;
}>;


export type CountOrganizationsQuery = { __typename?: 'Query', countOrganizations: number };

export type CreateOrganizationMutationVariables = Exact<{
  data: CreateOrganizationInput;
}>;


export type CreateOrganizationMutation = { __typename?: 'Mutation', createOrganization: { __typename?: 'Organization', id: string, name: string, slug?: string | null, created_at: number, updated_at: number, clinics: Array<{ __typename?: 'Clinic', id: string, name?: string | null, avatar_url?: string | null, is_archived: boolean, address?: { __typename?: 'Address', street_a?: string | null, street_b?: string | null, city?: string | null, state?: string | null, zip?: string | null } | null }>, admins: Array<{ __typename?: 'User', id: string, first_name?: string | null, last_name?: string | null, email?: any | null }>, settings?: { __typename?: 'OrganizationSettings', primary_color?: string | null, accent_color?: string | null, custom_well_description?: string | null, custom_sick_description?: string | null, custom_other_title?: string | null, custom_other_description?: string | null, custom_booking_copy?: { __typename?: 'ClinicBookingCopy', WIDGET_HEADER_TITLE?: string | null, SHOW_CLINIC_HEADER_LOGO?: boolean | null, CLINIC_HEADER_LOGO_HEIGHT?: number | null, SERVICE_TYPE_SECTION_HEADING?: string | null, DEFAULT_WELLNESS_DESCRIPTION?: string | null, DEFAULT_SICK_DESCRIPTION?: string | null, DEFAULT_OTHER_DESCRIPTION?: string | null, RETURNING_PATIENT_QUESTION?: string | null, POSITIVE_RETURNING_PATIENT_ANSWER?: string | null, NEGATIVE_RETURNING_PATIENT_ANSWER?: string | null, RETURNING_CLIENT_QUESTION?: string | null, POSITIVE_RETURNING_CLIENT_ANSWER?: string | null, NEGATIVE_RETURNING_CLIENT_ANSWER?: string | null, CLIENT_INFORMATION_SECTION_TITLE?: string | null, PATIENT_INFORMATION_SECTION_TITLE?: string | null, RETURNING_CLIENT_PATIENT_TITLE?: string | null, RETURNING_CLIENT_PATIENT_DESCRIPTION?: string | null, SERVICE_SECTION_TITLE?: string | null, PREPAID_SERVICES_LABEL?: string | null, STANDARD_SERVICES_LABEL?: string | null, DEPOSIT_FEE_NAME?: string | null, PREVIOUS_OR_REFERRING_CLINIC_QUESTION?: string | null, CONTACT_THE_CLINIC_TEXT?: string | null, CONTACT_THE_CLINIC_TEXT_COLOR?: string | null, CONTACT_THE_CLINIC_TEXT_SIZE?: string | null, SELECT_CLINICIAN_TITLE?: string | null, SELECT_CLINICIAN_POSITIVE_ANSWER?: string | null, SELECT_CLINICIAN_NEGATIVE_ANSWER?: string | null, SELECT_TIME_TITLE?: string | null, REVIEW_TITLE?: string | null, REVIEW_NOTES_PROMPT?: string | null, PAYMENT_INFORMATION_TITLE?: string | null, TRIGGER_WORDS_DETECTED_HEADER?: string | null, TRIGGER_WORDS_DETECTED_DESCRIPTION?: string | null, CONFIRMATION_SCREEN_TITLE?: string | null, CONFIRMATION_SCREEN_DESCRIPTION?: string | null, NEW_CLIENT_BLOCKED_MESSAGE?: string | null, NEW_PATIENT_BLOCKED_MESSAGE?: string | null } | null } | null } };

export type UpdateOrganizationMutationVariables = Exact<{
  id: Scalars['ID']['input'];
  data: UpdateOrganizationInput;
}>;


export type UpdateOrganizationMutation = { __typename?: 'Mutation', updateOrganization: { __typename?: 'Organization', id: string, name: string, slug?: string | null, created_at: number, updated_at: number, clinics: Array<{ __typename?: 'Clinic', id: string, name?: string | null, avatar_url?: string | null, is_archived: boolean, address?: { __typename?: 'Address', street_a?: string | null, street_b?: string | null, city?: string | null, state?: string | null, zip?: string | null } | null }>, admins: Array<{ __typename?: 'User', id: string, first_name?: string | null, last_name?: string | null, email?: any | null }>, settings?: { __typename?: 'OrganizationSettings', primary_color?: string | null, accent_color?: string | null, custom_well_description?: string | null, custom_sick_description?: string | null, custom_other_title?: string | null, custom_other_description?: string | null, custom_booking_copy?: { __typename?: 'ClinicBookingCopy', WIDGET_HEADER_TITLE?: string | null, SHOW_CLINIC_HEADER_LOGO?: boolean | null, CLINIC_HEADER_LOGO_HEIGHT?: number | null, SERVICE_TYPE_SECTION_HEADING?: string | null, DEFAULT_WELLNESS_DESCRIPTION?: string | null, DEFAULT_SICK_DESCRIPTION?: string | null, DEFAULT_OTHER_DESCRIPTION?: string | null, RETURNING_PATIENT_QUESTION?: string | null, POSITIVE_RETURNING_PATIENT_ANSWER?: string | null, NEGATIVE_RETURNING_PATIENT_ANSWER?: string | null, RETURNING_CLIENT_QUESTION?: string | null, POSITIVE_RETURNING_CLIENT_ANSWER?: string | null, NEGATIVE_RETURNING_CLIENT_ANSWER?: string | null, CLIENT_INFORMATION_SECTION_TITLE?: string | null, PATIENT_INFORMATION_SECTION_TITLE?: string | null, RETURNING_CLIENT_PATIENT_TITLE?: string | null, RETURNING_CLIENT_PATIENT_DESCRIPTION?: string | null, SERVICE_SECTION_TITLE?: string | null, PREPAID_SERVICES_LABEL?: string | null, STANDARD_SERVICES_LABEL?: string | null, DEPOSIT_FEE_NAME?: string | null, PREVIOUS_OR_REFERRING_CLINIC_QUESTION?: string | null, CONTACT_THE_CLINIC_TEXT?: string | null, CONTACT_THE_CLINIC_TEXT_COLOR?: string | null, CONTACT_THE_CLINIC_TEXT_SIZE?: string | null, SELECT_CLINICIAN_TITLE?: string | null, SELECT_CLINICIAN_POSITIVE_ANSWER?: string | null, SELECT_CLINICIAN_NEGATIVE_ANSWER?: string | null, SELECT_TIME_TITLE?: string | null, REVIEW_TITLE?: string | null, REVIEW_NOTES_PROMPT?: string | null, PAYMENT_INFORMATION_TITLE?: string | null, TRIGGER_WORDS_DETECTED_HEADER?: string | null, TRIGGER_WORDS_DETECTED_DESCRIPTION?: string | null, CONFIRMATION_SCREEN_TITLE?: string | null, CONFIRMATION_SCREEN_DESCRIPTION?: string | null, NEW_CLIENT_BLOCKED_MESSAGE?: string | null, NEW_PATIENT_BLOCKED_MESSAGE?: string | null } | null } | null } };

export type DeleteOrganizationMutationVariables = Exact<{
  id: Scalars['ID']['input'];
}>;


export type DeleteOrganizationMutation = { __typename?: 'Mutation', deleteOrganization?: any | null };

export type PatientHistoryItemFieldsFragment = { __typename?: 'PatientHistoryItem', id: string, issued_at: number, patient: { __typename?: 'Patient', id: string }, diagnosis?: { __typename?: 'Diagnosis', id: string } | null, product?: { __typename?: 'Product', id: string } | null };

export type PatientPreviewFieldsFragment = { __typename?: 'Patient', id: string, pms_id?: string | null, name?: string | null, breed?: string | null, is_active?: boolean | null, is_deceased?: boolean | null, avatar_url?: string | null, gender?: string | null, fixed_status?: FixedStatus | null, birthday?: number | null, weight?: number | null, owner?: { __typename?: 'Client', id: string, first_name?: string | null, last_name?: string | null, secondary_first_name?: string | null, secondary_last_name?: string | null, phone?: string | null, email?: string | null } | null, clinic_species?: { __typename?: 'ClinicSpecies', id: string, species: Species, description: string, weight_key: string } | null, clinic_breed?: { __typename?: 'Breed', id: string, description: string } | null };

export type PatientDisplayFieldsFragment = { __typename?: 'Patient', id: string, name?: string | null, is_active?: boolean | null, is_deceased?: boolean | null, birthday?: number | null, weight?: number | null, avatar_url?: string | null, gender?: string | null, owner?: { __typename?: 'Client', first_name?: string | null, last_name?: string | null } | null, clinic_species?: { __typename?: 'ClinicSpecies', id: string, species: Species, description: string, weight_key: string } | null, clinic_breed?: { __typename?: 'Breed', id: string, description: string } | null };

export type PatientFieldsFragment = { __typename?: 'Patient', id: string, pms?: PracticeManagementSystem | null, pms_id?: string | null, name?: string | null, breed?: string | null, avatar_url?: string | null, last_appt_time?: number | null, gender?: string | null, fixed_status?: FixedStatus | null, weight?: number | null, birthday?: number | null, is_active?: boolean | null, is_deceased?: boolean | null, pms_created_at?: number | null, created_at: number, updated_at: number, owner?: { __typename?: 'Client', id: string, first_name?: string | null, last_name?: string | null, email?: string | null, phone?: string | null, address?: { __typename?: 'Address', country?: string | null } | null } | null, clinic_species?: { __typename?: 'ClinicSpecies', id: string, pms_id: string, description: string, is_primary: boolean, species: Species, weight_key: string, created_at: number, updated_at: number } | null, clinic?: { __typename?: 'Clinic', id: string } | null, clinic_breed?: { __typename?: 'Breed', id: string, description: string } | null, patient_vaccination_records?: Array<{ __typename?: 'PatientVaccinationRecord', id: string, vaccine_name?: string | null, manufacturer?: string | null, lot_number?: string | null, administered_date?: number | null, due_date?: number | null, rabies_tag?: string | null, is_rabies_vaccine?: boolean | null, is_soc: boolean, is_active: boolean, product?: { __typename?: 'Product', id: string, display_name?: string | null, name: string } | null }> | null, last_appointment?: { __typename?: 'Appointment', clinician?: { __typename?: 'Clinician', name: string, display_name?: string | null } | null } | null };

export type PatientNoteFieldsFragment = { __typename?: 'PatientNote', id: string, text?: string | null, noted_at?: number | null, is_internal: boolean, is_active: boolean, created_at: number, updated_at: number };

export type OverduePatientWithAppointmentFieldsFragment = { __typename?: 'OverduePatient', patient: { __typename?: 'Patient', id: string, pms?: PracticeManagementSystem | null, pms_id?: string | null, name?: string | null, breed?: string | null, avatar_url?: string | null, last_appt_time?: number | null, gender?: string | null, fixed_status?: FixedStatus | null, weight?: number | null, birthday?: number | null, is_active?: boolean | null, is_deceased?: boolean | null, pms_created_at?: number | null, created_at: number, updated_at: number, owner?: { __typename?: 'Client', id: string, first_name?: string | null, last_name?: string | null, email?: string | null, phone?: string | null, address?: { __typename?: 'Address', country?: string | null } | null } | null, clinic_species?: { __typename?: 'ClinicSpecies', id: string, pms_id: string, description: string, is_primary: boolean, species: Species, weight_key: string, created_at: number, updated_at: number } | null, clinic?: { __typename?: 'Clinic', id: string } | null, clinic_breed?: { __typename?: 'Breed', id: string, description: string } | null, patient_vaccination_records?: Array<{ __typename?: 'PatientVaccinationRecord', id: string, vaccine_name?: string | null, manufacturer?: string | null, lot_number?: string | null, administered_date?: number | null, due_date?: number | null, rabies_tag?: string | null, is_rabies_vaccine?: boolean | null, is_soc: boolean, is_active: boolean, product?: { __typename?: 'Product', id: string, display_name?: string | null, name: string } | null }> | null, last_appointment?: { __typename?: 'Appointment', clinician?: { __typename?: 'Clinician', name: string, display_name?: string | null } | null } | null }, last_appointment: { __typename?: 'Appointment', id: string, service_name?: string | null, status: AppointmentStatus, start_time: number, drop_off_time?: number | null, minutes: number, service?: { __typename?: 'Service', name?: string | null } | null, clinician?: { __typename?: 'Clinician', name: string, display_name?: string | null } | null, client?: { __typename?: 'Client', first_name?: string | null, last_name?: string | null } | null, patient?: { __typename?: 'Patient', name?: string | null } | null } };

export type GetPatientQueryVariables = Exact<{
  id: Scalars['ID']['input'];
}>;


export type GetPatientQuery = { __typename?: 'Query', patient: { __typename?: 'Patient', id: string, pms?: PracticeManagementSystem | null, pms_id?: string | null, name?: string | null, breed?: string | null, avatar_url?: string | null, last_appt_time?: number | null, gender?: string | null, fixed_status?: FixedStatus | null, weight?: number | null, birthday?: number | null, is_active?: boolean | null, is_deceased?: boolean | null, pms_created_at?: number | null, created_at: number, updated_at: number, owner?: { __typename?: 'Client', id: string, first_name?: string | null, last_name?: string | null, email?: string | null, phone?: string | null, address?: { __typename?: 'Address', country?: string | null } | null } | null, clinic_species?: { __typename?: 'ClinicSpecies', id: string, pms_id: string, description: string, is_primary: boolean, species: Species, weight_key: string, created_at: number, updated_at: number } | null, clinic?: { __typename?: 'Clinic', id: string } | null, clinic_breed?: { __typename?: 'Breed', id: string, description: string } | null, patient_vaccination_records?: Array<{ __typename?: 'PatientVaccinationRecord', id: string, vaccine_name?: string | null, manufacturer?: string | null, lot_number?: string | null, administered_date?: number | null, due_date?: number | null, rabies_tag?: string | null, is_rabies_vaccine?: boolean | null, is_soc: boolean, is_active: boolean, product?: { __typename?: 'Product', id: string, display_name?: string | null, name: string } | null }> | null, last_appointment?: { __typename?: 'Appointment', clinician?: { __typename?: 'Clinician', name: string, display_name?: string | null } | null } | null } };

export type GetPatientNameQueryVariables = Exact<{
  id: Scalars['ID']['input'];
}>;


export type GetPatientNameQuery = { __typename?: 'Query', patient: { __typename?: 'Patient', id: string, name?: string | null, gender?: string | null, last_appointment?: { __typename?: 'Appointment', clinician?: { __typename?: 'Clinician', name: string, display_name?: string | null } | null } | null } };

export type GetPatientsByClientQueryVariables = Exact<{
  clientId: Scalars['ID']['input'];
}>;


export type GetPatientsByClientQuery = { __typename?: 'Query', getPatientsByClient: Array<{ __typename?: 'Patient', id: string, pms?: PracticeManagementSystem | null, pms_id?: string | null, name?: string | null, breed?: string | null, avatar_url?: string | null, last_appt_time?: number | null, gender?: string | null, fixed_status?: FixedStatus | null, weight?: number | null, birthday?: number | null, is_active?: boolean | null, is_deceased?: boolean | null, pms_created_at?: number | null, created_at: number, updated_at: number, owner?: { __typename?: 'Client', id: string, first_name?: string | null, last_name?: string | null, email?: string | null, phone?: string | null, address?: { __typename?: 'Address', country?: string | null } | null } | null, clinic_species?: { __typename?: 'ClinicSpecies', id: string, pms_id: string, description: string, is_primary: boolean, species: Species, weight_key: string, created_at: number, updated_at: number } | null, clinic?: { __typename?: 'Clinic', id: string } | null, clinic_breed?: { __typename?: 'Breed', id: string, description: string } | null, patient_vaccination_records?: Array<{ __typename?: 'PatientVaccinationRecord', id: string, vaccine_name?: string | null, manufacturer?: string | null, lot_number?: string | null, administered_date?: number | null, due_date?: number | null, rabies_tag?: string | null, is_rabies_vaccine?: boolean | null, is_soc: boolean, is_active: boolean, product?: { __typename?: 'Product', id: string, display_name?: string | null, name: string } | null }> | null, last_appointment?: { __typename?: 'Appointment', clinician?: { __typename?: 'Clinician', name: string, display_name?: string | null } | null } | null }> };

export type GetPatientsByClientsQueryVariables = Exact<{
  clientIds: Array<Scalars['ID']['input']> | Scalars['ID']['input'];
}>;


export type GetPatientsByClientsQuery = { __typename?: 'Query', getPatientsByClients: Array<{ __typename?: 'Patient', id: string, pms?: PracticeManagementSystem | null, pms_id?: string | null, name?: string | null, breed?: string | null, avatar_url?: string | null, last_appt_time?: number | null, gender?: string | null, fixed_status?: FixedStatus | null, weight?: number | null, birthday?: number | null, is_active?: boolean | null, is_deceased?: boolean | null, pms_created_at?: number | null, created_at: number, updated_at: number, owner?: { __typename?: 'Client', id: string, first_name?: string | null, last_name?: string | null, email?: string | null, phone?: string | null, address?: { __typename?: 'Address', country?: string | null } | null } | null, clinic_species?: { __typename?: 'ClinicSpecies', id: string, pms_id: string, description: string, is_primary: boolean, species: Species, weight_key: string, created_at: number, updated_at: number } | null, clinic?: { __typename?: 'Clinic', id: string } | null, clinic_breed?: { __typename?: 'Breed', id: string, description: string } | null, patient_vaccination_records?: Array<{ __typename?: 'PatientVaccinationRecord', id: string, vaccine_name?: string | null, manufacturer?: string | null, lot_number?: string | null, administered_date?: number | null, due_date?: number | null, rabies_tag?: string | null, is_rabies_vaccine?: boolean | null, is_soc: boolean, is_active: boolean, product?: { __typename?: 'Product', id: string, display_name?: string | null, name: string } | null }> | null, last_appointment?: { __typename?: 'Appointment', clinician?: { __typename?: 'Clinician', name: string, display_name?: string | null } | null } | null }> };

export type GetPatientsWithoutRescheduledAppointmentsForTimeRangeQueryVariables = Exact<{
  clinicId: Scalars['ID']['input'];
  start_time: Scalars['NonNegativeInt']['input'];
  end_time: Scalars['NonNegativeInt']['input'];
}>;


export type GetPatientsWithoutRescheduledAppointmentsForTimeRangeQuery = { __typename?: 'Query', getPatientsWithoutRescheduledAppointmentsForTimeRange: Array<{ __typename?: 'Patient', id: string, pms?: PracticeManagementSystem | null, pms_id?: string | null, name?: string | null, breed?: string | null, avatar_url?: string | null, last_appt_time?: number | null, gender?: string | null, fixed_status?: FixedStatus | null, weight?: number | null, birthday?: number | null, is_active?: boolean | null, is_deceased?: boolean | null, pms_created_at?: number | null, created_at: number, updated_at: number, owner?: { __typename?: 'Client', id: string, first_name?: string | null, last_name?: string | null, email?: string | null, phone?: string | null, address?: { __typename?: 'Address', country?: string | null } | null } | null, clinic_species?: { __typename?: 'ClinicSpecies', id: string, pms_id: string, description: string, is_primary: boolean, species: Species, weight_key: string, created_at: number, updated_at: number } | null, clinic?: { __typename?: 'Clinic', id: string } | null, clinic_breed?: { __typename?: 'Breed', id: string, description: string } | null, patient_vaccination_records?: Array<{ __typename?: 'PatientVaccinationRecord', id: string, vaccine_name?: string | null, manufacturer?: string | null, lot_number?: string | null, administered_date?: number | null, due_date?: number | null, rabies_tag?: string | null, is_rabies_vaccine?: boolean | null, is_soc: boolean, is_active: boolean, product?: { __typename?: 'Product', id: string, display_name?: string | null, name: string } | null }> | null, last_appointment?: { __typename?: 'Appointment', clinician?: { __typename?: 'Clinician', name: string, display_name?: string | null } | null } | null }> };

export type QueryPatientsQueryVariables = Exact<{
  where?: InputMaybe<Array<QueryInput> | QueryInput>;
  page?: InputMaybe<Scalars['NonNegativeInt']['input']>;
  pageSize?: InputMaybe<Scalars['NonNegativeInt']['input']>;
  orderBy?: InputMaybe<OrderByInput>;
}>;


export type QueryPatientsQuery = { __typename?: 'Query', queryPatients: Array<{ __typename?: 'Patient', id: string, pms?: PracticeManagementSystem | null, pms_id?: string | null, name?: string | null, breed?: string | null, avatar_url?: string | null, last_appt_time?: number | null, gender?: string | null, fixed_status?: FixedStatus | null, weight?: number | null, birthday?: number | null, is_active?: boolean | null, is_deceased?: boolean | null, pms_created_at?: number | null, created_at: number, updated_at: number, owner?: { __typename?: 'Client', id: string, first_name?: string | null, last_name?: string | null, email?: string | null, phone?: string | null, address?: { __typename?: 'Address', country?: string | null } | null } | null, clinic_species?: { __typename?: 'ClinicSpecies', id: string, pms_id: string, description: string, is_primary: boolean, species: Species, weight_key: string, created_at: number, updated_at: number } | null, clinic?: { __typename?: 'Clinic', id: string } | null, clinic_breed?: { __typename?: 'Breed', id: string, description: string } | null, patient_vaccination_records?: Array<{ __typename?: 'PatientVaccinationRecord', id: string, vaccine_name?: string | null, manufacturer?: string | null, lot_number?: string | null, administered_date?: number | null, due_date?: number | null, rabies_tag?: string | null, is_rabies_vaccine?: boolean | null, is_soc: boolean, is_active: boolean, product?: { __typename?: 'Product', id: string, display_name?: string | null, name: string } | null }> | null, last_appointment?: { __typename?: 'Appointment', clinician?: { __typename?: 'Clinician', name: string, display_name?: string | null } | null } | null }> };

export type CountPatientsQueryVariables = Exact<{
  where?: InputMaybe<Array<QueryInput> | QueryInput>;
}>;


export type CountPatientsQuery = { __typename?: 'Query', countPatients: number };

export type QueryPatientsOwnersQueryVariables = Exact<{
  where?: InputMaybe<Array<QueryInput> | QueryInput>;
  page?: InputMaybe<Scalars['NonNegativeInt']['input']>;
  pageSize?: InputMaybe<Scalars['NonNegativeInt']['input']>;
  orderBy?: InputMaybe<OrderByInput>;
  clinicId: Scalars['ID']['input'];
}>;


export type QueryPatientsOwnersQuery = { __typename?: 'Query', queryPatientsOwners: { __typename?: 'QueryPatientsOwnersResults', count: number, isCountCapped: boolean, patients: Array<{ __typename?: 'Patient', id: string, pms_id?: string | null, name?: string | null, breed?: string | null, is_active?: boolean | null, is_deceased?: boolean | null, avatar_url?: string | null, gender?: string | null, fixed_status?: FixedStatus | null, birthday?: number | null, weight?: number | null, owner?: { __typename?: 'Client', id: string, first_name?: string | null, last_name?: string | null, secondary_first_name?: string | null, secondary_last_name?: string | null, phone?: string | null, email?: string | null } | null, clinic_species?: { __typename?: 'ClinicSpecies', id: string, species: Species, description: string, weight_key: string } | null, clinic_breed?: { __typename?: 'Breed', id: string, description: string } | null }> } };

export type QueryClinicPatientsQueryVariables = Exact<{
  where?: InputMaybe<Array<QueryInput> | QueryInput>;
  page?: InputMaybe<Scalars['NonNegativeInt']['input']>;
  pageSize?: InputMaybe<Scalars['NonNegativeInt']['input']>;
  orderBy?: InputMaybe<OrderByInput>;
  clinicId: Scalars['ID']['input'];
}>;


export type QueryClinicPatientsQuery = { __typename?: 'Query', queryClinicPatients: Array<{ __typename?: 'Patient', id: string, pms?: PracticeManagementSystem | null, pms_id?: string | null, name?: string | null, breed?: string | null, avatar_url?: string | null, last_appt_time?: number | null, gender?: string | null, fixed_status?: FixedStatus | null, weight?: number | null, birthday?: number | null, is_active?: boolean | null, is_deceased?: boolean | null, pms_created_at?: number | null, created_at: number, updated_at: number, owner?: { __typename?: 'Client', id: string, first_name?: string | null, last_name?: string | null, email?: string | null, phone?: string | null, address?: { __typename?: 'Address', country?: string | null } | null } | null, clinic_species?: { __typename?: 'ClinicSpecies', id: string, pms_id: string, description: string, is_primary: boolean, species: Species, weight_key: string, created_at: number, updated_at: number } | null, clinic?: { __typename?: 'Clinic', id: string } | null, clinic_breed?: { __typename?: 'Breed', id: string, description: string } | null, patient_vaccination_records?: Array<{ __typename?: 'PatientVaccinationRecord', id: string, vaccine_name?: string | null, manufacturer?: string | null, lot_number?: string | null, administered_date?: number | null, due_date?: number | null, rabies_tag?: string | null, is_rabies_vaccine?: boolean | null, is_soc: boolean, is_active: boolean, product?: { __typename?: 'Product', id: string, display_name?: string | null, name: string } | null }> | null, last_appointment?: { __typename?: 'Appointment', clinician?: { __typename?: 'Clinician', name: string, display_name?: string | null } | null } | null }> };

export type GetOverduePatientsQueryVariables = Exact<{
  clinicId: Scalars['ID']['input'];
  options?: InputMaybe<OverduePatientOptions>;
}>;


export type GetOverduePatientsQuery = { __typename?: 'Query', getOverduePatients: Array<{ __typename?: 'OverduePatient', patient: { __typename?: 'Patient', id: string, pms?: PracticeManagementSystem | null, pms_id?: string | null, name?: string | null, breed?: string | null, avatar_url?: string | null, last_appt_time?: number | null, gender?: string | null, fixed_status?: FixedStatus | null, weight?: number | null, birthday?: number | null, is_active?: boolean | null, is_deceased?: boolean | null, pms_created_at?: number | null, created_at: number, updated_at: number, owner?: { __typename?: 'Client', id: string, first_name?: string | null, last_name?: string | null, email?: string | null, phone?: string | null, address?: { __typename?: 'Address', country?: string | null } | null } | null, clinic_species?: { __typename?: 'ClinicSpecies', id: string, pms_id: string, description: string, is_primary: boolean, species: Species, weight_key: string, created_at: number, updated_at: number } | null, clinic?: { __typename?: 'Clinic', id: string } | null, clinic_breed?: { __typename?: 'Breed', id: string, description: string } | null, patient_vaccination_records?: Array<{ __typename?: 'PatientVaccinationRecord', id: string, vaccine_name?: string | null, manufacturer?: string | null, lot_number?: string | null, administered_date?: number | null, due_date?: number | null, rabies_tag?: string | null, is_rabies_vaccine?: boolean | null, is_soc: boolean, is_active: boolean, product?: { __typename?: 'Product', id: string, display_name?: string | null, name: string } | null }> | null, last_appointment?: { __typename?: 'Appointment', clinician?: { __typename?: 'Clinician', name: string, display_name?: string | null } | null } | null }, last_appointment: { __typename?: 'Appointment', id: string, service_name?: string | null, status: AppointmentStatus, start_time: number, drop_off_time?: number | null, minutes: number, service?: { __typename?: 'Service', name?: string | null } | null, clinician?: { __typename?: 'Clinician', name: string, display_name?: string | null } | null, client?: { __typename?: 'Client', first_name?: string | null, last_name?: string | null } | null, patient?: { __typename?: 'Patient', name?: string | null } | null } }> };

export type CountOverduePatientsQueryVariables = Exact<{
  clinicId: Scalars['ID']['input'];
  options?: InputMaybe<OverduePatientOptions>;
}>;


export type CountOverduePatientsQuery = { __typename?: 'Query', countOverduePatients: number };

export type CreatePatientMutationVariables = Exact<{
  data: CreatePatientInput;
}>;


export type CreatePatientMutation = { __typename?: 'Mutation', createPatient: { __typename?: 'Patient', id: string, pms?: PracticeManagementSystem | null, pms_id?: string | null, name?: string | null, breed?: string | null, avatar_url?: string | null, last_appt_time?: number | null, gender?: string | null, fixed_status?: FixedStatus | null, weight?: number | null, birthday?: number | null, is_active?: boolean | null, is_deceased?: boolean | null, pms_created_at?: number | null, created_at: number, updated_at: number, owner?: { __typename?: 'Client', id: string, first_name?: string | null, last_name?: string | null, email?: string | null, phone?: string | null, address?: { __typename?: 'Address', country?: string | null } | null } | null, clinic_species?: { __typename?: 'ClinicSpecies', id: string, pms_id: string, description: string, is_primary: boolean, species: Species, weight_key: string, created_at: number, updated_at: number } | null, clinic?: { __typename?: 'Clinic', id: string } | null, clinic_breed?: { __typename?: 'Breed', id: string, description: string } | null, patient_vaccination_records?: Array<{ __typename?: 'PatientVaccinationRecord', id: string, vaccine_name?: string | null, manufacturer?: string | null, lot_number?: string | null, administered_date?: number | null, due_date?: number | null, rabies_tag?: string | null, is_rabies_vaccine?: boolean | null, is_soc: boolean, is_active: boolean, product?: { __typename?: 'Product', id: string, display_name?: string | null, name: string } | null }> | null, last_appointment?: { __typename?: 'Appointment', clinician?: { __typename?: 'Clinician', name: string, display_name?: string | null } | null } | null } };

export type UpdatePatientMutationVariables = Exact<{
  id: Scalars['ID']['input'];
  data: UpdatePatientInput;
}>;


export type UpdatePatientMutation = { __typename?: 'Mutation', updatePatient: { __typename?: 'Patient', id: string, pms?: PracticeManagementSystem | null, pms_id?: string | null, name?: string | null, breed?: string | null, avatar_url?: string | null, last_appt_time?: number | null, gender?: string | null, fixed_status?: FixedStatus | null, weight?: number | null, birthday?: number | null, is_active?: boolean | null, is_deceased?: boolean | null, pms_created_at?: number | null, created_at: number, updated_at: number, owner?: { __typename?: 'Client', id: string, first_name?: string | null, last_name?: string | null, email?: string | null, phone?: string | null, address?: { __typename?: 'Address', country?: string | null } | null } | null, clinic_species?: { __typename?: 'ClinicSpecies', id: string, pms_id: string, description: string, is_primary: boolean, species: Species, weight_key: string, created_at: number, updated_at: number } | null, clinic?: { __typename?: 'Clinic', id: string } | null, clinic_breed?: { __typename?: 'Breed', id: string, description: string } | null, patient_vaccination_records?: Array<{ __typename?: 'PatientVaccinationRecord', id: string, vaccine_name?: string | null, manufacturer?: string | null, lot_number?: string | null, administered_date?: number | null, due_date?: number | null, rabies_tag?: string | null, is_rabies_vaccine?: boolean | null, is_soc: boolean, is_active: boolean, product?: { __typename?: 'Product', id: string, display_name?: string | null, name: string } | null }> | null, last_appointment?: { __typename?: 'Appointment', clinician?: { __typename?: 'Clinician', name: string, display_name?: string | null } | null } | null } };

export type DeletePatientMutationVariables = Exact<{
  id: Scalars['ID']['input'];
}>;


export type DeletePatientMutation = { __typename?: 'Mutation', deletePatient?: any | null };

export type SyncIndividualPatientMutationVariables = Exact<{
  patientId: Scalars['ID']['input'];
  clinicId: Scalars['ID']['input'];
}>;


export type SyncIndividualPatientMutation = { __typename?: 'Mutation', syncIndividualPatient: { __typename?: 'Patient', id: string, pms?: PracticeManagementSystem | null, pms_id?: string | null, name?: string | null, breed?: string | null, avatar_url?: string | null, last_appt_time?: number | null, gender?: string | null, fixed_status?: FixedStatus | null, weight?: number | null, birthday?: number | null, is_active?: boolean | null, is_deceased?: boolean | null, pms_created_at?: number | null, created_at: number, updated_at: number, owner?: { __typename?: 'Client', id: string, first_name?: string | null, last_name?: string | null, email?: string | null, phone?: string | null, address?: { __typename?: 'Address', country?: string | null } | null } | null, clinic_species?: { __typename?: 'ClinicSpecies', id: string, pms_id: string, description: string, is_primary: boolean, species: Species, weight_key: string, created_at: number, updated_at: number } | null, clinic?: { __typename?: 'Clinic', id: string } | null, clinic_breed?: { __typename?: 'Breed', id: string, description: string } | null, patient_vaccination_records?: Array<{ __typename?: 'PatientVaccinationRecord', id: string, vaccine_name?: string | null, manufacturer?: string | null, lot_number?: string | null, administered_date?: number | null, due_date?: number | null, rabies_tag?: string | null, is_rabies_vaccine?: boolean | null, is_soc: boolean, is_active: boolean, product?: { __typename?: 'Product', id: string, display_name?: string | null, name: string } | null }> | null, last_appointment?: { __typename?: 'Appointment', clinician?: { __typename?: 'Clinician', name: string, display_name?: string | null } | null } | null } };

export type PaymentFieldsFragment = { __typename?: 'Payment', id: string, payment_method_id?: string | null, stripe_payment_intent_id?: string | null, stripe_payment_link?: string | null, stripe_payment_id?: string | null, stripe_account_id?: string | null, stripe_checkout_session_url?: string | null, description?: string | null, amount: any, category: PurchaseCategory, status: PaymentStatus, is_entered_in_pims: boolean, amount_refunded?: any | null, refund_issued_at?: number | null, refund_entered_in_pims: boolean, date: number, created_at: number, updated_at: number, appointment?: { __typename?: 'Appointment', id: string, pms_id?: string | null, status: AppointmentStatus, service_name?: string | null, start_time: number, drop_off_time?: number | null, minutes: number, is_deleted?: boolean | null, is_time_block?: boolean | null, is_new_patient?: boolean | null, is_new_client?: boolean | null, is_confirmed?: boolean | null, new_patient_species?: string | null, reason_for_cancellation?: string | null, client_reason_for_cancellation?: string | null, confirmed_at?: number | null, is_clinician_auto_assigned?: boolean | null, client_notes?: string | null, clinic_notes?: string | null, referring_clinic_name?: string | null, widget_source?: string | null, from_widget?: string | null, pms_created_at?: number | null, clinic_appt_status?: { __typename?: 'ClinicApptStatus', id: string, status: AppointmentStatus, description: string } | null, service?: { __typename?: 'Service', id: string, color?: string | null, name?: string | null } | null, clinician?: { __typename?: 'Clinician', id: string, name: string, display_name?: string | null } | null, room?: { __typename?: 'Room', id: string, name: string } | null, clinic?: { __typename?: 'Clinic', id: string, name?: string | null, slug?: string | null, pms_db?: { __typename?: 'PmsDb', id: string } | null } | null, client?: { __typename?: 'Client', id: string, first_name?: string | null, last_name?: string | null, email?: string | null, phone?: string | null, is_active?: boolean | null, address?: { __typename?: 'Address', street_a?: string | null, country?: string | null } | null } | null, patient?: { __typename?: 'Patient', id: string, pms_id?: string | null, name?: string | null, breed?: string | null, is_active?: boolean | null, is_deceased?: boolean | null, avatar_url?: string | null, gender?: string | null, fixed_status?: FixedStatus | null, birthday?: number | null, weight?: number | null, owner?: { __typename?: 'Client', id: string, first_name?: string | null, last_name?: string | null, secondary_first_name?: string | null, secondary_last_name?: string | null, phone?: string | null, email?: string | null } | null, clinic_species?: { __typename?: 'ClinicSpecies', id: string, species: Species, description: string, weight_key: string } | null, clinic_breed?: { __typename?: 'Breed', id: string, description: string } | null } | null, widget?: { __typename?: 'Widget', id: string, widget_name: string } | null } | null, client: { __typename?: 'Client', id: string, first_name?: string | null, last_name?: string | null, phone?: string | null, email?: string | null }, clinic: { __typename?: 'Clinic', id: string } };

export type PaymentPreviewFieldsFragment = { __typename?: 'Payment', id: string, amount: any, status: PaymentStatus, amount_refunded?: any | null, refund_issued_at?: number | null, date: number, created_at: number, client: { __typename?: 'Client', id: string, first_name?: string | null, last_name?: string | null }, appointment?: { __typename?: 'Appointment', id: string, service_name?: string | null, start_time: number, service?: { __typename?: 'Service', name?: string | null } | null } | null };

export type GetPaymentQueryVariables = Exact<{
  id: Scalars['ID']['input'];
}>;


export type GetPaymentQuery = { __typename?: 'Query', payment?: { __typename?: 'Payment', id: string, payment_method_id?: string | null, stripe_payment_intent_id?: string | null, stripe_payment_link?: string | null, stripe_payment_id?: string | null, stripe_account_id?: string | null, stripe_checkout_session_url?: string | null, description?: string | null, amount: any, category: PurchaseCategory, status: PaymentStatus, is_entered_in_pims: boolean, amount_refunded?: any | null, refund_issued_at?: number | null, refund_entered_in_pims: boolean, date: number, created_at: number, updated_at: number, appointment?: { __typename?: 'Appointment', id: string, pms_id?: string | null, status: AppointmentStatus, service_name?: string | null, start_time: number, drop_off_time?: number | null, minutes: number, is_deleted?: boolean | null, is_time_block?: boolean | null, is_new_patient?: boolean | null, is_new_client?: boolean | null, is_confirmed?: boolean | null, new_patient_species?: string | null, reason_for_cancellation?: string | null, client_reason_for_cancellation?: string | null, confirmed_at?: number | null, is_clinician_auto_assigned?: boolean | null, client_notes?: string | null, clinic_notes?: string | null, referring_clinic_name?: string | null, widget_source?: string | null, from_widget?: string | null, pms_created_at?: number | null, clinic_appt_status?: { __typename?: 'ClinicApptStatus', id: string, status: AppointmentStatus, description: string } | null, service?: { __typename?: 'Service', id: string, color?: string | null, name?: string | null } | null, clinician?: { __typename?: 'Clinician', id: string, name: string, display_name?: string | null } | null, room?: { __typename?: 'Room', id: string, name: string } | null, clinic?: { __typename?: 'Clinic', id: string, name?: string | null, slug?: string | null, pms_db?: { __typename?: 'PmsDb', id: string } | null } | null, client?: { __typename?: 'Client', id: string, first_name?: string | null, last_name?: string | null, email?: string | null, phone?: string | null, is_active?: boolean | null, address?: { __typename?: 'Address', street_a?: string | null, country?: string | null } | null } | null, patient?: { __typename?: 'Patient', id: string, pms_id?: string | null, name?: string | null, breed?: string | null, is_active?: boolean | null, is_deceased?: boolean | null, avatar_url?: string | null, gender?: string | null, fixed_status?: FixedStatus | null, birthday?: number | null, weight?: number | null, owner?: { __typename?: 'Client', id: string, first_name?: string | null, last_name?: string | null, secondary_first_name?: string | null, secondary_last_name?: string | null, phone?: string | null, email?: string | null } | null, clinic_species?: { __typename?: 'ClinicSpecies', id: string, species: Species, description: string, weight_key: string } | null, clinic_breed?: { __typename?: 'Breed', id: string, description: string } | null } | null, widget?: { __typename?: 'Widget', id: string, widget_name: string } | null } | null, client: { __typename?: 'Client', id: string, first_name?: string | null, last_name?: string | null, phone?: string | null, email?: string | null }, clinic: { __typename?: 'Clinic', id: string } } | null };

export type GetPaymentsByClinicIdQueryVariables = Exact<{
  clinicId: Scalars['ID']['input'];
}>;


export type GetPaymentsByClinicIdQuery = { __typename?: 'Query', getPaymentsByClinicId: Array<{ __typename?: 'Payment', id: string, payment_method_id?: string | null, stripe_payment_intent_id?: string | null, stripe_payment_link?: string | null, stripe_payment_id?: string | null, stripe_account_id?: string | null, stripe_checkout_session_url?: string | null, description?: string | null, amount: any, category: PurchaseCategory, status: PaymentStatus, is_entered_in_pims: boolean, amount_refunded?: any | null, refund_issued_at?: number | null, refund_entered_in_pims: boolean, date: number, created_at: number, updated_at: number, appointment?: { __typename?: 'Appointment', id: string, pms_id?: string | null, status: AppointmentStatus, service_name?: string | null, start_time: number, drop_off_time?: number | null, minutes: number, is_deleted?: boolean | null, is_time_block?: boolean | null, is_new_patient?: boolean | null, is_new_client?: boolean | null, is_confirmed?: boolean | null, new_patient_species?: string | null, reason_for_cancellation?: string | null, client_reason_for_cancellation?: string | null, confirmed_at?: number | null, is_clinician_auto_assigned?: boolean | null, client_notes?: string | null, clinic_notes?: string | null, referring_clinic_name?: string | null, widget_source?: string | null, from_widget?: string | null, pms_created_at?: number | null, clinic_appt_status?: { __typename?: 'ClinicApptStatus', id: string, status: AppointmentStatus, description: string } | null, service?: { __typename?: 'Service', id: string, color?: string | null, name?: string | null } | null, clinician?: { __typename?: 'Clinician', id: string, name: string, display_name?: string | null } | null, room?: { __typename?: 'Room', id: string, name: string } | null, clinic?: { __typename?: 'Clinic', id: string, name?: string | null, slug?: string | null, pms_db?: { __typename?: 'PmsDb', id: string } | null } | null, client?: { __typename?: 'Client', id: string, first_name?: string | null, last_name?: string | null, email?: string | null, phone?: string | null, is_active?: boolean | null, address?: { __typename?: 'Address', street_a?: string | null, country?: string | null } | null } | null, patient?: { __typename?: 'Patient', id: string, pms_id?: string | null, name?: string | null, breed?: string | null, is_active?: boolean | null, is_deceased?: boolean | null, avatar_url?: string | null, gender?: string | null, fixed_status?: FixedStatus | null, birthday?: number | null, weight?: number | null, owner?: { __typename?: 'Client', id: string, first_name?: string | null, last_name?: string | null, secondary_first_name?: string | null, secondary_last_name?: string | null, phone?: string | null, email?: string | null } | null, clinic_species?: { __typename?: 'ClinicSpecies', id: string, species: Species, description: string, weight_key: string } | null, clinic_breed?: { __typename?: 'Breed', id: string, description: string } | null } | null, widget?: { __typename?: 'Widget', id: string, widget_name: string } | null } | null, client: { __typename?: 'Client', id: string, first_name?: string | null, last_name?: string | null, phone?: string | null, email?: string | null }, clinic: { __typename?: 'Clinic', id: string } }> };

export type QueryPaymentsQueryVariables = Exact<{
  where?: InputMaybe<Array<QueryInput> | QueryInput>;
  page?: InputMaybe<Scalars['NonNegativeInt']['input']>;
  pageSize?: InputMaybe<Scalars['NonNegativeInt']['input']>;
  orderBy?: InputMaybe<OrderByInput>;
}>;


export type QueryPaymentsQuery = { __typename?: 'Query', queryPayments: Array<{ __typename?: 'Payment', id: string, payment_method_id?: string | null, stripe_payment_intent_id?: string | null, stripe_payment_link?: string | null, stripe_payment_id?: string | null, stripe_account_id?: string | null, stripe_checkout_session_url?: string | null, description?: string | null, amount: any, category: PurchaseCategory, status: PaymentStatus, is_entered_in_pims: boolean, amount_refunded?: any | null, refund_issued_at?: number | null, refund_entered_in_pims: boolean, date: number, created_at: number, updated_at: number, appointment?: { __typename?: 'Appointment', id: string, pms_id?: string | null, status: AppointmentStatus, service_name?: string | null, start_time: number, drop_off_time?: number | null, minutes: number, is_deleted?: boolean | null, is_time_block?: boolean | null, is_new_patient?: boolean | null, is_new_client?: boolean | null, is_confirmed?: boolean | null, new_patient_species?: string | null, reason_for_cancellation?: string | null, client_reason_for_cancellation?: string | null, confirmed_at?: number | null, is_clinician_auto_assigned?: boolean | null, client_notes?: string | null, clinic_notes?: string | null, referring_clinic_name?: string | null, widget_source?: string | null, from_widget?: string | null, pms_created_at?: number | null, clinic_appt_status?: { __typename?: 'ClinicApptStatus', id: string, status: AppointmentStatus, description: string } | null, service?: { __typename?: 'Service', id: string, color?: string | null, name?: string | null } | null, clinician?: { __typename?: 'Clinician', id: string, name: string, display_name?: string | null } | null, room?: { __typename?: 'Room', id: string, name: string } | null, clinic?: { __typename?: 'Clinic', id: string, name?: string | null, slug?: string | null, pms_db?: { __typename?: 'PmsDb', id: string } | null } | null, client?: { __typename?: 'Client', id: string, first_name?: string | null, last_name?: string | null, email?: string | null, phone?: string | null, is_active?: boolean | null, address?: { __typename?: 'Address', street_a?: string | null, country?: string | null } | null } | null, patient?: { __typename?: 'Patient', id: string, pms_id?: string | null, name?: string | null, breed?: string | null, is_active?: boolean | null, is_deceased?: boolean | null, avatar_url?: string | null, gender?: string | null, fixed_status?: FixedStatus | null, birthday?: number | null, weight?: number | null, owner?: { __typename?: 'Client', id: string, first_name?: string | null, last_name?: string | null, secondary_first_name?: string | null, secondary_last_name?: string | null, phone?: string | null, email?: string | null } | null, clinic_species?: { __typename?: 'ClinicSpecies', id: string, species: Species, description: string, weight_key: string } | null, clinic_breed?: { __typename?: 'Breed', id: string, description: string } | null } | null, widget?: { __typename?: 'Widget', id: string, widget_name: string } | null } | null, client: { __typename?: 'Client', id: string, first_name?: string | null, last_name?: string | null, phone?: string | null, email?: string | null }, clinic: { __typename?: 'Clinic', id: string } }> };

export type CountPaymentsQueryVariables = Exact<{
  where?: InputMaybe<Array<QueryInput> | QueryInput>;
}>;


export type CountPaymentsQuery = { __typename?: 'Query', countPayments: number };

export type TogglePaymentIsEnteredMutationVariables = Exact<{
  id: Scalars['ID']['input'];
}>;


export type TogglePaymentIsEnteredMutation = { __typename?: 'Mutation', togglePaymentIsEntered: { __typename?: 'Payment', id: string, payment_method_id?: string | null, stripe_payment_intent_id?: string | null, stripe_payment_link?: string | null, stripe_payment_id?: string | null, stripe_account_id?: string | null, stripe_checkout_session_url?: string | null, description?: string | null, amount: any, category: PurchaseCategory, status: PaymentStatus, is_entered_in_pims: boolean, amount_refunded?: any | null, refund_issued_at?: number | null, refund_entered_in_pims: boolean, date: number, created_at: number, updated_at: number, appointment?: { __typename?: 'Appointment', id: string, pms_id?: string | null, status: AppointmentStatus, service_name?: string | null, start_time: number, drop_off_time?: number | null, minutes: number, is_deleted?: boolean | null, is_time_block?: boolean | null, is_new_patient?: boolean | null, is_new_client?: boolean | null, is_confirmed?: boolean | null, new_patient_species?: string | null, reason_for_cancellation?: string | null, client_reason_for_cancellation?: string | null, confirmed_at?: number | null, is_clinician_auto_assigned?: boolean | null, client_notes?: string | null, clinic_notes?: string | null, referring_clinic_name?: string | null, widget_source?: string | null, from_widget?: string | null, pms_created_at?: number | null, clinic_appt_status?: { __typename?: 'ClinicApptStatus', id: string, status: AppointmentStatus, description: string } | null, service?: { __typename?: 'Service', id: string, color?: string | null, name?: string | null } | null, clinician?: { __typename?: 'Clinician', id: string, name: string, display_name?: string | null } | null, room?: { __typename?: 'Room', id: string, name: string } | null, clinic?: { __typename?: 'Clinic', id: string, name?: string | null, slug?: string | null, pms_db?: { __typename?: 'PmsDb', id: string } | null } | null, client?: { __typename?: 'Client', id: string, first_name?: string | null, last_name?: string | null, email?: string | null, phone?: string | null, is_active?: boolean | null, address?: { __typename?: 'Address', street_a?: string | null, country?: string | null } | null } | null, patient?: { __typename?: 'Patient', id: string, pms_id?: string | null, name?: string | null, breed?: string | null, is_active?: boolean | null, is_deceased?: boolean | null, avatar_url?: string | null, gender?: string | null, fixed_status?: FixedStatus | null, birthday?: number | null, weight?: number | null, owner?: { __typename?: 'Client', id: string, first_name?: string | null, last_name?: string | null, secondary_first_name?: string | null, secondary_last_name?: string | null, phone?: string | null, email?: string | null } | null, clinic_species?: { __typename?: 'ClinicSpecies', id: string, species: Species, description: string, weight_key: string } | null, clinic_breed?: { __typename?: 'Breed', id: string, description: string } | null } | null, widget?: { __typename?: 'Widget', id: string, widget_name: string } | null } | null, client: { __typename?: 'Client', id: string, first_name?: string | null, last_name?: string | null, phone?: string | null, email?: string | null }, clinic: { __typename?: 'Clinic', id: string } } };

export type RefundPaymentMutationVariables = Exact<{
  id: Scalars['ID']['input'];
  refundAmount: Scalars['PositiveInt']['input'];
}>;


export type RefundPaymentMutation = { __typename?: 'Mutation', refundPayment: { __typename?: 'Payment', id: string, payment_method_id?: string | null, stripe_payment_intent_id?: string | null, stripe_payment_link?: string | null, stripe_payment_id?: string | null, stripe_account_id?: string | null, stripe_checkout_session_url?: string | null, description?: string | null, amount: any, category: PurchaseCategory, status: PaymentStatus, is_entered_in_pims: boolean, amount_refunded?: any | null, refund_issued_at?: number | null, refund_entered_in_pims: boolean, date: number, created_at: number, updated_at: number, appointment?: { __typename?: 'Appointment', id: string, pms_id?: string | null, status: AppointmentStatus, service_name?: string | null, start_time: number, drop_off_time?: number | null, minutes: number, is_deleted?: boolean | null, is_time_block?: boolean | null, is_new_patient?: boolean | null, is_new_client?: boolean | null, is_confirmed?: boolean | null, new_patient_species?: string | null, reason_for_cancellation?: string | null, client_reason_for_cancellation?: string | null, confirmed_at?: number | null, is_clinician_auto_assigned?: boolean | null, client_notes?: string | null, clinic_notes?: string | null, referring_clinic_name?: string | null, widget_source?: string | null, from_widget?: string | null, pms_created_at?: number | null, clinic_appt_status?: { __typename?: 'ClinicApptStatus', id: string, status: AppointmentStatus, description: string } | null, service?: { __typename?: 'Service', id: string, color?: string | null, name?: string | null } | null, clinician?: { __typename?: 'Clinician', id: string, name: string, display_name?: string | null } | null, room?: { __typename?: 'Room', id: string, name: string } | null, clinic?: { __typename?: 'Clinic', id: string, name?: string | null, slug?: string | null, pms_db?: { __typename?: 'PmsDb', id: string } | null } | null, client?: { __typename?: 'Client', id: string, first_name?: string | null, last_name?: string | null, email?: string | null, phone?: string | null, is_active?: boolean | null, address?: { __typename?: 'Address', street_a?: string | null, country?: string | null } | null } | null, patient?: { __typename?: 'Patient', id: string, pms_id?: string | null, name?: string | null, breed?: string | null, is_active?: boolean | null, is_deceased?: boolean | null, avatar_url?: string | null, gender?: string | null, fixed_status?: FixedStatus | null, birthday?: number | null, weight?: number | null, owner?: { __typename?: 'Client', id: string, first_name?: string | null, last_name?: string | null, secondary_first_name?: string | null, secondary_last_name?: string | null, phone?: string | null, email?: string | null } | null, clinic_species?: { __typename?: 'ClinicSpecies', id: string, species: Species, description: string, weight_key: string } | null, clinic_breed?: { __typename?: 'Breed', id: string, description: string } | null } | null, widget?: { __typename?: 'Widget', id: string, widget_name: string } | null } | null, client: { __typename?: 'Client', id: string, first_name?: string | null, last_name?: string | null, phone?: string | null, email?: string | null }, clinic: { __typename?: 'Clinic', id: string } } };

export type UpdatePaymentMutationVariables = Exact<{
  id: Scalars['ID']['input'];
  data: UpdatePaymentInput;
}>;


export type UpdatePaymentMutation = { __typename?: 'Mutation', updatePayment: { __typename?: 'Payment', id: string, payment_method_id?: string | null, stripe_payment_intent_id?: string | null, stripe_payment_link?: string | null, stripe_payment_id?: string | null, stripe_account_id?: string | null, stripe_checkout_session_url?: string | null, description?: string | null, amount: any, category: PurchaseCategory, status: PaymentStatus, is_entered_in_pims: boolean, amount_refunded?: any | null, refund_issued_at?: number | null, refund_entered_in_pims: boolean, date: number, created_at: number, updated_at: number, appointment?: { __typename?: 'Appointment', id: string, pms_id?: string | null, status: AppointmentStatus, service_name?: string | null, start_time: number, drop_off_time?: number | null, minutes: number, is_deleted?: boolean | null, is_time_block?: boolean | null, is_new_patient?: boolean | null, is_new_client?: boolean | null, is_confirmed?: boolean | null, new_patient_species?: string | null, reason_for_cancellation?: string | null, client_reason_for_cancellation?: string | null, confirmed_at?: number | null, is_clinician_auto_assigned?: boolean | null, client_notes?: string | null, clinic_notes?: string | null, referring_clinic_name?: string | null, widget_source?: string | null, from_widget?: string | null, pms_created_at?: number | null, clinic_appt_status?: { __typename?: 'ClinicApptStatus', id: string, status: AppointmentStatus, description: string } | null, service?: { __typename?: 'Service', id: string, color?: string | null, name?: string | null } | null, clinician?: { __typename?: 'Clinician', id: string, name: string, display_name?: string | null } | null, room?: { __typename?: 'Room', id: string, name: string } | null, clinic?: { __typename?: 'Clinic', id: string, name?: string | null, slug?: string | null, pms_db?: { __typename?: 'PmsDb', id: string } | null } | null, client?: { __typename?: 'Client', id: string, first_name?: string | null, last_name?: string | null, email?: string | null, phone?: string | null, is_active?: boolean | null, address?: { __typename?: 'Address', street_a?: string | null, country?: string | null } | null } | null, patient?: { __typename?: 'Patient', id: string, pms_id?: string | null, name?: string | null, breed?: string | null, is_active?: boolean | null, is_deceased?: boolean | null, avatar_url?: string | null, gender?: string | null, fixed_status?: FixedStatus | null, birthday?: number | null, weight?: number | null, owner?: { __typename?: 'Client', id: string, first_name?: string | null, last_name?: string | null, secondary_first_name?: string | null, secondary_last_name?: string | null, phone?: string | null, email?: string | null } | null, clinic_species?: { __typename?: 'ClinicSpecies', id: string, species: Species, description: string, weight_key: string } | null, clinic_breed?: { __typename?: 'Breed', id: string, description: string } | null } | null, widget?: { __typename?: 'Widget', id: string, widget_name: string } | null } | null, client: { __typename?: 'Client', id: string, first_name?: string | null, last_name?: string | null, phone?: string | null, email?: string | null }, clinic: { __typename?: 'Clinic', id: string } } };

export type SendPaymentReceiptMutationVariables = Exact<{
  id: Scalars['ID']['input'];
}>;


export type SendPaymentReceiptMutation = { __typename?: 'Mutation', sendPaymentReceipt: boolean };

export type CreatePaymentLinkMutationVariables = Exact<{
  data: CreatePaymentLinkInput;
}>;


export type CreatePaymentLinkMutation = { __typename?: 'Mutation', createPaymentLink: { __typename?: 'Payment', id: string, stripe_checkout_session_url?: string | null, description?: string | null, amount: any, status: PaymentStatus } };

export type PatientRecordFieldsFragment = { __typename?: 'PatientRecord', id: string, date?: number | null, assisting_clinicians?: Array<string> | null, master_problem_list?: string | null, subjective?: string | null, objective?: string | null, assessment?: string | null, plan?: string | null, public_notes?: string | null, service?: string | null, patient: { __typename?: 'Patient', id: string, name?: string | null, weight?: number | null, breed?: string | null, birthday?: number | null, avatar_url?: string | null, clinic_species?: { __typename?: 'ClinicSpecies', id: string, pms_id: string, description: string, is_primary: boolean, species: Species, weight_key: string, created_at: number, updated_at: number } | null }, client?: { __typename?: 'Client', id: string, first_name?: string | null, last_name?: string | null } | null, appointment?: { __typename?: 'Appointment', id: string, clinician?: { __typename?: 'Clinician', id: string, name: string } | null, service?: { __typename?: 'Service', id: string, name?: string | null } | null } | null, clinician?: { __typename?: 'Clinician', id: string, name: string } | null, clinic?: { __typename?: 'Clinic', id: string, name?: string | null } | null };

export type GetPatientRecordQueryVariables = Exact<{
  id: Scalars['ID']['input'];
}>;


export type GetPatientRecordQuery = { __typename?: 'Query', patientRecord: { __typename?: 'PatientRecord', id: string, date?: number | null, assisting_clinicians?: Array<string> | null, master_problem_list?: string | null, subjective?: string | null, objective?: string | null, assessment?: string | null, plan?: string | null, public_notes?: string | null, service?: string | null, patient: { __typename?: 'Patient', id: string, name?: string | null, weight?: number | null, breed?: string | null, birthday?: number | null, avatar_url?: string | null, clinic_species?: { __typename?: 'ClinicSpecies', id: string, pms_id: string, description: string, is_primary: boolean, species: Species, weight_key: string, created_at: number, updated_at: number } | null }, client?: { __typename?: 'Client', id: string, first_name?: string | null, last_name?: string | null } | null, appointment?: { __typename?: 'Appointment', id: string, clinician?: { __typename?: 'Clinician', id: string, name: string } | null, service?: { __typename?: 'Service', id: string, name?: string | null } | null } | null, clinician?: { __typename?: 'Clinician', id: string, name: string } | null, clinic?: { __typename?: 'Clinic', id: string, name?: string | null } | null } };

export type PetSelfieFieldsFragment = { __typename?: 'PetSelfie', id: string, submitted_media_url: string, display_media_url?: string | null, media_type: PetSelfieMediaType, mime_type: string, filename?: string | null, size_bytes?: number | null, thumbnail_url?: string | null, pet_name?: string | null, nickname?: string | null, favorite_activity?: string | null, weirdest_thing?: string | null, display_caption?: string | null, allow_public_share: boolean, public_share_authorized_at?: number | null, first_viewed_at?: number | null, first_viewed_by?: string | null, in_slideshow: boolean, in_portal_carousel: boolean, in_gallery: boolean, is_excluded: boolean, is_archived: boolean, reaction_sent_at?: number | null, reaction_message?: string | null, created_at: number, updated_at: number, clinic: { __typename?: 'Clinic', id: string }, client: { __typename?: 'Client', id: string, first_name?: string | null, last_name?: string | null, secondary_first_name?: string | null, secondary_last_name?: string | null, phone?: string | null, email?: string | null, pms_id?: string | null, is_active?: boolean | null, is_unsubscribed: boolean, sms_enabled: boolean, email_enabled: boolean, balance?: number | null, last_appt_time?: number | null, created_at: number, updated_at: number, last_appointment?: { __typename?: 'Appointment', clinician?: { __typename?: 'Clinician', name: string, display_name?: string | null } | null } | null, address?: { __typename?: 'Address', street_a?: string | null, street_b?: string | null, city?: string | null, state?: string | null, zip?: string | null, country?: string | null } | null, clinic?: { __typename?: 'Clinic', id: string } | null, user?: { __typename?: 'User', avatar_url?: string | null } | null, patients?: Array<{ __typename?: 'Patient', id: string, name?: string | null, gender?: string | null, pms_id?: string | null, is_deceased?: boolean | null, is_active?: boolean | null, clinic_species?: { __typename?: 'ClinicSpecies', id: string, species: Species } | null, clinic_breed?: { __typename?: 'Breed', id: string, description: string } | null, last_appointment?: { __typename?: 'Appointment', clinician?: { __typename?: 'Clinician', name: string, display_name?: string | null } | null } | null }> | null, settings?: { __typename?: 'ClientSettings', clinic_chckup_notifications_enabled: boolean, clinic_chckup_sms_enabled: boolean, clinic_chckup_email_enabled: boolean, client_chckup_notifications_enabled: boolean, client_chckup_sms_enabled: boolean, client_chckup_email_enabled: boolean, is_unsubscribed_from_marketing: boolean, is_unsubscribed_from_marketing_sms: boolean, is_unsubscribed_from_marketing_email: boolean } | null }, patient?: { __typename?: 'Patient', id: string, pms_id?: string | null, name?: string | null, breed?: string | null, is_active?: boolean | null, is_deceased?: boolean | null, avatar_url?: string | null, gender?: string | null, fixed_status?: FixedStatus | null, birthday?: number | null, weight?: number | null, owner?: { __typename?: 'Client', id: string, first_name?: string | null, last_name?: string | null, secondary_first_name?: string | null, secondary_last_name?: string | null, phone?: string | null, email?: string | null } | null, clinic_species?: { __typename?: 'ClinicSpecies', id: string, species: Species, description: string, weight_key: string } | null, clinic_breed?: { __typename?: 'Breed', id: string, description: string } | null } | null };

export type QueryPetSelfiesQueryVariables = Exact<{
  where?: InputMaybe<Array<QueryInput> | QueryInput>;
  page?: InputMaybe<Scalars['NonNegativeInt']['input']>;
  pageSize?: InputMaybe<Scalars['NonNegativeInt']['input']>;
  orderBy?: InputMaybe<OrderByInput>;
}>;


export type QueryPetSelfiesQuery = { __typename?: 'Query', queryPetSelfies: Array<{ __typename?: 'PetSelfie', id: string, submitted_media_url: string, display_media_url?: string | null, media_type: PetSelfieMediaType, mime_type: string, filename?: string | null, size_bytes?: number | null, thumbnail_url?: string | null, pet_name?: string | null, nickname?: string | null, favorite_activity?: string | null, weirdest_thing?: string | null, display_caption?: string | null, allow_public_share: boolean, public_share_authorized_at?: number | null, first_viewed_at?: number | null, first_viewed_by?: string | null, in_slideshow: boolean, in_portal_carousel: boolean, in_gallery: boolean, is_excluded: boolean, is_archived: boolean, reaction_sent_at?: number | null, reaction_message?: string | null, created_at: number, updated_at: number, clinic: { __typename?: 'Clinic', id: string }, client: { __typename?: 'Client', id: string, first_name?: string | null, last_name?: string | null, secondary_first_name?: string | null, secondary_last_name?: string | null, phone?: string | null, email?: string | null, pms_id?: string | null, is_active?: boolean | null, is_unsubscribed: boolean, sms_enabled: boolean, email_enabled: boolean, balance?: number | null, last_appt_time?: number | null, created_at: number, updated_at: number, last_appointment?: { __typename?: 'Appointment', clinician?: { __typename?: 'Clinician', name: string, display_name?: string | null } | null } | null, address?: { __typename?: 'Address', street_a?: string | null, street_b?: string | null, city?: string | null, state?: string | null, zip?: string | null, country?: string | null } | null, clinic?: { __typename?: 'Clinic', id: string } | null, user?: { __typename?: 'User', avatar_url?: string | null } | null, patients?: Array<{ __typename?: 'Patient', id: string, name?: string | null, gender?: string | null, pms_id?: string | null, is_deceased?: boolean | null, is_active?: boolean | null, clinic_species?: { __typename?: 'ClinicSpecies', id: string, species: Species } | null, clinic_breed?: { __typename?: 'Breed', id: string, description: string } | null, last_appointment?: { __typename?: 'Appointment', clinician?: { __typename?: 'Clinician', name: string, display_name?: string | null } | null } | null }> | null, settings?: { __typename?: 'ClientSettings', clinic_chckup_notifications_enabled: boolean, clinic_chckup_sms_enabled: boolean, clinic_chckup_email_enabled: boolean, client_chckup_notifications_enabled: boolean, client_chckup_sms_enabled: boolean, client_chckup_email_enabled: boolean, is_unsubscribed_from_marketing: boolean, is_unsubscribed_from_marketing_sms: boolean, is_unsubscribed_from_marketing_email: boolean } | null }, patient?: { __typename?: 'Patient', id: string, pms_id?: string | null, name?: string | null, breed?: string | null, is_active?: boolean | null, is_deceased?: boolean | null, avatar_url?: string | null, gender?: string | null, fixed_status?: FixedStatus | null, birthday?: number | null, weight?: number | null, owner?: { __typename?: 'Client', id: string, first_name?: string | null, last_name?: string | null, secondary_first_name?: string | null, secondary_last_name?: string | null, phone?: string | null, email?: string | null } | null, clinic_species?: { __typename?: 'ClinicSpecies', id: string, species: Species, description: string, weight_key: string } | null, clinic_breed?: { __typename?: 'Breed', id: string, description: string } | null } | null }> };

export type CountPetSelfiesQueryVariables = Exact<{
  where?: InputMaybe<Array<QueryInput> | QueryInput>;
}>;


export type CountPetSelfiesQuery = { __typename?: 'Query', countPetSelfies: number };

export type PetSelfieQueryVariables = Exact<{
  id: Scalars['ID']['input'];
}>;


export type PetSelfieQuery = { __typename?: 'Query', petSelfie: { __typename?: 'PetSelfie', id: string, submitted_media_url: string, display_media_url?: string | null, media_type: PetSelfieMediaType, mime_type: string, filename?: string | null, size_bytes?: number | null, thumbnail_url?: string | null, pet_name?: string | null, nickname?: string | null, favorite_activity?: string | null, weirdest_thing?: string | null, display_caption?: string | null, allow_public_share: boolean, public_share_authorized_at?: number | null, first_viewed_at?: number | null, first_viewed_by?: string | null, in_slideshow: boolean, in_portal_carousel: boolean, in_gallery: boolean, is_excluded: boolean, is_archived: boolean, reaction_sent_at?: number | null, reaction_message?: string | null, created_at: number, updated_at: number, clinic: { __typename?: 'Clinic', id: string }, client: { __typename?: 'Client', id: string, first_name?: string | null, last_name?: string | null, secondary_first_name?: string | null, secondary_last_name?: string | null, phone?: string | null, email?: string | null, pms_id?: string | null, is_active?: boolean | null, is_unsubscribed: boolean, sms_enabled: boolean, email_enabled: boolean, balance?: number | null, last_appt_time?: number | null, created_at: number, updated_at: number, last_appointment?: { __typename?: 'Appointment', clinician?: { __typename?: 'Clinician', name: string, display_name?: string | null } | null } | null, address?: { __typename?: 'Address', street_a?: string | null, street_b?: string | null, city?: string | null, state?: string | null, zip?: string | null, country?: string | null } | null, clinic?: { __typename?: 'Clinic', id: string } | null, user?: { __typename?: 'User', avatar_url?: string | null } | null, patients?: Array<{ __typename?: 'Patient', id: string, name?: string | null, gender?: string | null, pms_id?: string | null, is_deceased?: boolean | null, is_active?: boolean | null, clinic_species?: { __typename?: 'ClinicSpecies', id: string, species: Species } | null, clinic_breed?: { __typename?: 'Breed', id: string, description: string } | null, last_appointment?: { __typename?: 'Appointment', clinician?: { __typename?: 'Clinician', name: string, display_name?: string | null } | null } | null }> | null, settings?: { __typename?: 'ClientSettings', clinic_chckup_notifications_enabled: boolean, clinic_chckup_sms_enabled: boolean, clinic_chckup_email_enabled: boolean, client_chckup_notifications_enabled: boolean, client_chckup_sms_enabled: boolean, client_chckup_email_enabled: boolean, is_unsubscribed_from_marketing: boolean, is_unsubscribed_from_marketing_sms: boolean, is_unsubscribed_from_marketing_email: boolean } | null }, patient?: { __typename?: 'Patient', id: string, pms_id?: string | null, name?: string | null, breed?: string | null, is_active?: boolean | null, is_deceased?: boolean | null, avatar_url?: string | null, gender?: string | null, fixed_status?: FixedStatus | null, birthday?: number | null, weight?: number | null, owner?: { __typename?: 'Client', id: string, first_name?: string | null, last_name?: string | null, secondary_first_name?: string | null, secondary_last_name?: string | null, phone?: string | null, email?: string | null } | null, clinic_species?: { __typename?: 'ClinicSpecies', id: string, species: Species, description: string, weight_key: string } | null, clinic_breed?: { __typename?: 'Breed', id: string, description: string } | null } | null } };

export type UpdatePetSelfieMutationVariables = Exact<{
  id: Scalars['ID']['input'];
  data: UpdatePetSelfieInput;
}>;


export type UpdatePetSelfieMutation = { __typename?: 'Mutation', updatePetSelfie: { __typename?: 'PetSelfie', id: string, submitted_media_url: string, display_media_url?: string | null, media_type: PetSelfieMediaType, mime_type: string, filename?: string | null, size_bytes?: number | null, thumbnail_url?: string | null, pet_name?: string | null, nickname?: string | null, favorite_activity?: string | null, weirdest_thing?: string | null, display_caption?: string | null, allow_public_share: boolean, public_share_authorized_at?: number | null, first_viewed_at?: number | null, first_viewed_by?: string | null, in_slideshow: boolean, in_portal_carousel: boolean, in_gallery: boolean, is_excluded: boolean, is_archived: boolean, reaction_sent_at?: number | null, reaction_message?: string | null, created_at: number, updated_at: number, clinic: { __typename?: 'Clinic', id: string }, client: { __typename?: 'Client', id: string, first_name?: string | null, last_name?: string | null, secondary_first_name?: string | null, secondary_last_name?: string | null, phone?: string | null, email?: string | null, pms_id?: string | null, is_active?: boolean | null, is_unsubscribed: boolean, sms_enabled: boolean, email_enabled: boolean, balance?: number | null, last_appt_time?: number | null, created_at: number, updated_at: number, last_appointment?: { __typename?: 'Appointment', clinician?: { __typename?: 'Clinician', name: string, display_name?: string | null } | null } | null, address?: { __typename?: 'Address', street_a?: string | null, street_b?: string | null, city?: string | null, state?: string | null, zip?: string | null, country?: string | null } | null, clinic?: { __typename?: 'Clinic', id: string } | null, user?: { __typename?: 'User', avatar_url?: string | null } | null, patients?: Array<{ __typename?: 'Patient', id: string, name?: string | null, gender?: string | null, pms_id?: string | null, is_deceased?: boolean | null, is_active?: boolean | null, clinic_species?: { __typename?: 'ClinicSpecies', id: string, species: Species } | null, clinic_breed?: { __typename?: 'Breed', id: string, description: string } | null, last_appointment?: { __typename?: 'Appointment', clinician?: { __typename?: 'Clinician', name: string, display_name?: string | null } | null } | null }> | null, settings?: { __typename?: 'ClientSettings', clinic_chckup_notifications_enabled: boolean, clinic_chckup_sms_enabled: boolean, clinic_chckup_email_enabled: boolean, client_chckup_notifications_enabled: boolean, client_chckup_sms_enabled: boolean, client_chckup_email_enabled: boolean, is_unsubscribed_from_marketing: boolean, is_unsubscribed_from_marketing_sms: boolean, is_unsubscribed_from_marketing_email: boolean } | null }, patient?: { __typename?: 'Patient', id: string, pms_id?: string | null, name?: string | null, breed?: string | null, is_active?: boolean | null, is_deceased?: boolean | null, avatar_url?: string | null, gender?: string | null, fixed_status?: FixedStatus | null, birthday?: number | null, weight?: number | null, owner?: { __typename?: 'Client', id: string, first_name?: string | null, last_name?: string | null, secondary_first_name?: string | null, secondary_last_name?: string | null, phone?: string | null, email?: string | null } | null, clinic_species?: { __typename?: 'ClinicSpecies', id: string, species: Species, description: string, weight_key: string } | null, clinic_breed?: { __typename?: 'Breed', id: string, description: string } | null } | null } };

export type MarkPetSelfieViewedMutationVariables = Exact<{
  id: Scalars['ID']['input'];
}>;


export type MarkPetSelfieViewedMutation = { __typename?: 'Mutation', markPetSelfieViewed: { __typename?: 'PetSelfie', id: string, submitted_media_url: string, display_media_url?: string | null, media_type: PetSelfieMediaType, mime_type: string, filename?: string | null, size_bytes?: number | null, thumbnail_url?: string | null, pet_name?: string | null, nickname?: string | null, favorite_activity?: string | null, weirdest_thing?: string | null, display_caption?: string | null, allow_public_share: boolean, public_share_authorized_at?: number | null, first_viewed_at?: number | null, first_viewed_by?: string | null, in_slideshow: boolean, in_portal_carousel: boolean, in_gallery: boolean, is_excluded: boolean, is_archived: boolean, reaction_sent_at?: number | null, reaction_message?: string | null, created_at: number, updated_at: number, clinic: { __typename?: 'Clinic', id: string }, client: { __typename?: 'Client', id: string, first_name?: string | null, last_name?: string | null, secondary_first_name?: string | null, secondary_last_name?: string | null, phone?: string | null, email?: string | null, pms_id?: string | null, is_active?: boolean | null, is_unsubscribed: boolean, sms_enabled: boolean, email_enabled: boolean, balance?: number | null, last_appt_time?: number | null, created_at: number, updated_at: number, last_appointment?: { __typename?: 'Appointment', clinician?: { __typename?: 'Clinician', name: string, display_name?: string | null } | null } | null, address?: { __typename?: 'Address', street_a?: string | null, street_b?: string | null, city?: string | null, state?: string | null, zip?: string | null, country?: string | null } | null, clinic?: { __typename?: 'Clinic', id: string } | null, user?: { __typename?: 'User', avatar_url?: string | null } | null, patients?: Array<{ __typename?: 'Patient', id: string, name?: string | null, gender?: string | null, pms_id?: string | null, is_deceased?: boolean | null, is_active?: boolean | null, clinic_species?: { __typename?: 'ClinicSpecies', id: string, species: Species } | null, clinic_breed?: { __typename?: 'Breed', id: string, description: string } | null, last_appointment?: { __typename?: 'Appointment', clinician?: { __typename?: 'Clinician', name: string, display_name?: string | null } | null } | null }> | null, settings?: { __typename?: 'ClientSettings', clinic_chckup_notifications_enabled: boolean, clinic_chckup_sms_enabled: boolean, clinic_chckup_email_enabled: boolean, client_chckup_notifications_enabled: boolean, client_chckup_sms_enabled: boolean, client_chckup_email_enabled: boolean, is_unsubscribed_from_marketing: boolean, is_unsubscribed_from_marketing_sms: boolean, is_unsubscribed_from_marketing_email: boolean } | null }, patient?: { __typename?: 'Patient', id: string, pms_id?: string | null, name?: string | null, breed?: string | null, is_active?: boolean | null, is_deceased?: boolean | null, avatar_url?: string | null, gender?: string | null, fixed_status?: FixedStatus | null, birthday?: number | null, weight?: number | null, owner?: { __typename?: 'Client', id: string, first_name?: string | null, last_name?: string | null, secondary_first_name?: string | null, secondary_last_name?: string | null, phone?: string | null, email?: string | null } | null, clinic_species?: { __typename?: 'ClinicSpecies', id: string, species: Species, description: string, weight_key: string } | null, clinic_breed?: { __typename?: 'Breed', id: string, description: string } | null } | null } };

export type PimsLookupPatientFieldsFragment = { __typename?: 'PimsLookupPatient', pms_id: string, name: string, species?: string | null, breed?: string | null, sex?: string | null, birthday?: number | null, is_active: boolean, is_deceased: boolean, patient_id?: string | null };

export type PimsLookupClientFieldsFragment = { __typename?: 'PimsLookupClient', pms_id: string, first_name: string, last_name: string, email?: string | null, phone?: string | null, address?: string | null, is_active: boolean, client_id?: string | null, patients: Array<{ __typename?: 'PimsLookupPatient', pms_id: string, name: string, species?: string | null, breed?: string | null, sex?: string | null, birthday?: number | null, is_active: boolean, is_deceased: boolean, patient_id?: string | null }> };

export type LookupPimsClientsQueryVariables = Exact<{
  clinicId: Scalars['ID']['input'];
  input: PimsLookupInput;
}>;


export type LookupPimsClientsQuery = { __typename?: 'Query', lookupPimsClients: Array<{ __typename?: 'PimsLookupClient', pms_id: string, first_name: string, last_name: string, email?: string | null, phone?: string | null, address?: string | null, is_active: boolean, client_id?: string | null, patients: Array<{ __typename?: 'PimsLookupPatient', pms_id: string, name: string, species?: string | null, breed?: string | null, sex?: string | null, birthday?: number | null, is_active: boolean, is_deceased: boolean, patient_id?: string | null }> }> };

export type SyncPimsClientByPmsIdMutationVariables = Exact<{
  clinicId: Scalars['ID']['input'];
  clientPmsId: Scalars['String']['input'];
}>;


export type SyncPimsClientByPmsIdMutation = { __typename?: 'Mutation', syncPimsClientByPmsId: { __typename?: 'Client', id: string, first_name?: string | null, last_name?: string | null } };

export type PimsReminderPreviewFieldsFragment = { __typename?: 'PimsReminder', id: string, send_date: number, display_due_date?: number | null, reminder_desc?: string | null, reminder_type?: { __typename?: 'PimsReminderType', id: string, display_name?: string | null, is_active: boolean, reminder_type_name: string, all_reminder_names?: Array<string> | null } | null };

export type PimsReminderDisplayFieldsFragment = { __typename?: 'PimsReminder', id: string, send_date: number, display_due_date?: number | null, reminder_desc?: string | null, reminder_type?: { __typename?: 'PimsReminderType', id: string, display_name?: string | null, is_active: boolean, reminder_type_name: string, all_reminder_names?: Array<string> | null } | null, client: { __typename?: 'Client', id: string, first_name?: string | null, last_name?: string | null }, patient?: { __typename?: 'Patient', id: string, name?: string | null } | null };

export type PatientPimsReminderFieldsFragment = { __typename?: 'PimsReminder', id: string, send_date: number, display_due_date?: number | null, is_active: boolean, is_completed: boolean, reminder_desc?: string | null, reminder_type?: { __typename?: 'PimsReminderType', id: string, display_name?: string | null, reminder_type_name: string, is_active: boolean } | null, patient?: { __typename?: 'Patient', id: string, name?: string | null, is_active?: boolean | null, is_deceased?: boolean | null, birthday?: number | null, weight?: number | null, avatar_url?: string | null, gender?: string | null, owner?: { __typename?: 'Client', first_name?: string | null, last_name?: string | null } | null, clinic_species?: { __typename?: 'ClinicSpecies', id: string, species: Species, description: string, weight_key: string } | null, clinic_breed?: { __typename?: 'Breed', id: string, description: string } | null } | null };

export type PimsReminderTypeFieldsFragment = { __typename?: 'PimsReminderType', id: string, display_name?: string | null, is_active: boolean, reminder_type_name: string, all_reminder_names?: Array<string> | null };

export type QueryPimsReminderTypesQueryVariables = Exact<{
  where?: InputMaybe<Array<QueryInput> | QueryInput>;
  page?: InputMaybe<Scalars['NonNegativeInt']['input']>;
  pageSize?: InputMaybe<Scalars['NonNegativeInt']['input']>;
  orderBy?: InputMaybe<OrderByInput>;
}>;


export type QueryPimsReminderTypesQuery = { __typename?: 'Query', queryPimsReminderTypes: Array<{ __typename?: 'PimsReminderType', id: string, display_name?: string | null, is_active: boolean, reminder_type_name: string, all_reminder_names?: Array<string> | null }> };

export type CountPimsReminderTypesQueryVariables = Exact<{
  where?: InputMaybe<Array<QueryInput> | QueryInput>;
}>;


export type CountPimsReminderTypesQuery = { __typename?: 'Query', countPimsReminderTypes: number };

export type GetPimsRemindersByPatientQueryVariables = Exact<{
  clinicId: Scalars['ID']['input'];
  patientPmsId: Scalars['String']['input'];
  page?: InputMaybe<Scalars['NonNegativeInt']['input']>;
  pageSize?: InputMaybe<Scalars['NonNegativeInt']['input']>;
  orderBy?: InputMaybe<OrderByInput>;
}>;


export type GetPimsRemindersByPatientQuery = { __typename?: 'Query', pimsRemindersByPatient: Array<{ __typename?: 'PimsReminder', id: string, send_date: number, display_due_date?: number | null, is_active: boolean, is_completed: boolean, reminder_desc?: string | null, reminder_type?: { __typename?: 'PimsReminderType', id: string, display_name?: string | null, reminder_type_name: string, is_active: boolean } | null, patient?: { __typename?: 'Patient', id: string, name?: string | null, is_active?: boolean | null, is_deceased?: boolean | null, birthday?: number | null, weight?: number | null, avatar_url?: string | null, gender?: string | null, owner?: { __typename?: 'Client', first_name?: string | null, last_name?: string | null } | null, clinic_species?: { __typename?: 'ClinicSpecies', id: string, species: Species, description: string, weight_key: string } | null, clinic_breed?: { __typename?: 'Breed', id: string, description: string } | null } | null }> };

export type CountPimsRemindersByPatientQueryVariables = Exact<{
  clinicId: Scalars['ID']['input'];
  patientPmsId: Scalars['String']['input'];
}>;


export type CountPimsRemindersByPatientQuery = { __typename?: 'Query', countPimsRemindersByPatient: number };

export type QueryDistinctPimsReminderTypeNamesQueryVariables = Exact<{
  where?: InputMaybe<Array<QueryInput> | QueryInput>;
  page?: InputMaybe<Scalars['NonNegativeInt']['input']>;
  pageSize?: InputMaybe<Scalars['NonNegativeInt']['input']>;
  orderBy?: InputMaybe<OrderByInput>;
}>;


export type QueryDistinctPimsReminderTypeNamesQuery = { __typename?: 'Query', queryDistinctPimsReminderTypeNames: Array<string> };

export type SearchPimsReminderTypesForClinicQueryVariables = Exact<{
  clinicId: Scalars['ID']['input'];
  options?: InputMaybe<SearchPimsReminderTypesForClinicOptions>;
}>;


export type SearchPimsReminderTypesForClinicQuery = { __typename?: 'Query', searchPimsReminderTypesForClinic: { __typename?: 'PimsReminderTypeSearchResult', count: number, pims_reminder_types: Array<{ __typename?: 'PimsReminderType', id: string, display_name?: string | null, is_active: boolean, reminder_type_name: string, all_reminder_names?: Array<string> | null }> } };

export type UpdatePimsReminderTypeMutationVariables = Exact<{
  id: Scalars['ID']['input'];
  input: UpdatePimsReminderTypeInput;
}>;


export type UpdatePimsReminderTypeMutation = { __typename?: 'Mutation', updatePimsReminderType: { __typename?: 'PimsReminderType', id: string, display_name?: string | null, is_active: boolean, reminder_type_name: string, all_reminder_names?: Array<string> | null } };

export type QueryPimsRemindersQueryVariables = Exact<{
  where?: InputMaybe<Array<QueryInput> | QueryInput>;
  page?: InputMaybe<Scalars['NonNegativeInt']['input']>;
  pageSize?: InputMaybe<Scalars['NonNegativeInt']['input']>;
  orderBy?: InputMaybe<OrderByInput>;
}>;


export type QueryPimsRemindersQuery = { __typename?: 'Query', queryPimsReminders: Array<{ __typename?: 'PimsReminder', id: string, send_date: number, display_due_date?: number | null, is_active: boolean, is_completed: boolean, reminder_desc?: string | null, reminder_type?: { __typename?: 'PimsReminderType', id: string, display_name?: string | null, reminder_type_name: string, is_active: boolean } | null, patient?: { __typename?: 'Patient', id: string, name?: string | null, is_active?: boolean | null, is_deceased?: boolean | null, birthday?: number | null, weight?: number | null, avatar_url?: string | null, gender?: string | null, owner?: { __typename?: 'Client', first_name?: string | null, last_name?: string | null } | null, clinic_species?: { __typename?: 'ClinicSpecies', id: string, species: Species, description: string, weight_key: string } | null, clinic_breed?: { __typename?: 'Breed', id: string, description: string } | null } | null }> };

export type GetActivePimsRemindersByPatientsQueryVariables = Exact<{
  patientIds: Array<Scalars['ID']['input']> | Scalars['ID']['input'];
}>;


export type GetActivePimsRemindersByPatientsQuery = { __typename?: 'Query', getActivePimsRemindersByPatients: Array<{ __typename?: 'PimsReminder', id: string, send_date: number, display_due_date?: number | null, is_active: boolean, is_completed: boolean, reminder_desc?: string | null, reminder_type?: { __typename?: 'PimsReminderType', id: string, display_name?: string | null, reminder_type_name: string, is_active: boolean } | null, patient?: { __typename?: 'Patient', id: string, name?: string | null, is_active?: boolean | null, is_deceased?: boolean | null, birthday?: number | null, weight?: number | null, avatar_url?: string | null, gender?: string | null, owner?: { __typename?: 'Client', first_name?: string | null, last_name?: string | null } | null, clinic_species?: { __typename?: 'ClinicSpecies', id: string, species: Species, description: string, weight_key: string } | null, clinic_breed?: { __typename?: 'Breed', id: string, description: string } | null } | null }> };

export type CountPimsRemindersQueryVariables = Exact<{
  where?: InputMaybe<Array<QueryInput> | QueryInput>;
}>;


export type CountPimsRemindersQuery = { __typename?: 'Query', countPimsReminders: number };

export type QueryComplianceRemindersQueryVariables = Exact<{
  clinicIds: Array<Scalars['ID']['input']> | Scalars['ID']['input'];
  startDate: Scalars['NonNegativeInt']['input'];
  endDate: Scalars['NonNegativeInt']['input'];
  page?: InputMaybe<Scalars['NonNegativeInt']['input']>;
  pageSize?: InputMaybe<Scalars['NonNegativeInt']['input']>;
  searchQuery?: InputMaybe<Scalars['String']['input']>;
  excludeFutureAppts?: InputMaybe<Scalars['Boolean']['input']>;
  includeInactiveClients?: InputMaybe<Scalars['Boolean']['input']>;
  includeInactiveReminders?: InputMaybe<Scalars['Boolean']['input']>;
  excludeDeceasedPatients?: InputMaybe<Scalars['Boolean']['input']>;
  orderColumn?: InputMaybe<Scalars['String']['input']>;
  orderAsc?: InputMaybe<Scalars['Boolean']['input']>;
  complianceStatuses?: InputMaybe<Array<Scalars['String']['input']> | Scalars['String']['input']>;
  assigneeIds?: InputMaybe<Array<Scalars['ID']['input']> | Scalars['ID']['input']>;
  lastSeenAfter?: InputMaybe<Scalars['NonNegativeInt']['input']>;
  reminderTypeIds?: InputMaybe<Array<Scalars['ID']['input']> | Scalars['ID']['input']>;
  includeUnsetComplianceStatus?: InputMaybe<Scalars['Boolean']['input']>;
  statusUpdatedBefore?: InputMaybe<Scalars['NonNegativeInt']['input']>;
}>;


export type QueryComplianceRemindersQuery = { __typename?: 'Query', queryComplianceReminders: { __typename?: 'ComplianceReminderResults', count: number, results: Array<{ __typename?: 'ComplianceReminderResult', client: { __typename?: 'Client', id: string, first_name?: string | null, last_name?: string | null, secondary_first_name?: string | null, secondary_last_name?: string | null, phone?: string | null, email?: string | null, pms_id?: string | null, is_active?: boolean | null, is_unsubscribed: boolean, sms_enabled: boolean, email_enabled: boolean, balance?: number | null, last_appt_time?: number | null, created_at: number, updated_at: number, last_appointment?: { __typename?: 'Appointment', clinician?: { __typename?: 'Clinician', name: string, display_name?: string | null } | null } | null, address?: { __typename?: 'Address', street_a?: string | null, street_b?: string | null, city?: string | null, state?: string | null, zip?: string | null, country?: string | null } | null, clinic?: { __typename?: 'Clinic', id: string } | null, user?: { __typename?: 'User', avatar_url?: string | null } | null, patients?: Array<{ __typename?: 'Patient', id: string, name?: string | null, gender?: string | null, pms_id?: string | null, is_deceased?: boolean | null, is_active?: boolean | null, clinic_species?: { __typename?: 'ClinicSpecies', id: string, species: Species } | null, clinic_breed?: { __typename?: 'Breed', id: string, description: string } | null, last_appointment?: { __typename?: 'Appointment', clinician?: { __typename?: 'Clinician', name: string, display_name?: string | null } | null } | null }> | null, settings?: { __typename?: 'ClientSettings', clinic_chckup_notifications_enabled: boolean, clinic_chckup_sms_enabled: boolean, clinic_chckup_email_enabled: boolean, client_chckup_notifications_enabled: boolean, client_chckup_sms_enabled: boolean, client_chckup_email_enabled: boolean, is_unsubscribed_from_marketing: boolean, is_unsubscribed_from_marketing_sms: boolean, is_unsubscribed_from_marketing_email: boolean } | null }, reminders: Array<{ __typename?: 'PatientReminder', patient?: { __typename?: 'Patient', id: string, name?: string | null, pms_id?: string | null, is_deceased?: boolean | null, is_active?: boolean | null, clinic_species?: { __typename?: 'ClinicSpecies', id: string, species: Species } | null } | null, pims_reminder: { __typename?: 'PimsReminder', is_active: boolean, is_completed: boolean, id: string, send_date: number, display_due_date?: number | null, reminder_desc?: string | null, reminder_type?: { __typename?: 'PimsReminderType', id: string, display_name?: string | null, is_active: boolean, reminder_type_name: string, all_reminder_names?: Array<string> | null } | null } }>, chat?: { __typename?: 'Chat', id: string, compliance_status?: string | null, compliance_status_updated_at?: number | null, last_message?: string | null, last_message_time: number, compliance_status_updated_by?: { __typename?: 'User', id: string, avatar_url?: string | null, first_name?: string | null, last_name?: string | null } | null, assignee?: { __typename?: 'User', id: string, avatar_url?: string | null, first_name?: string | null, last_name?: string | null } | null } | null }> } };

export type SyncPimsRemindersForPatientMutationVariables = Exact<{
  patientId: Scalars['ID']['input'];
}>;


export type SyncPimsRemindersForPatientMutation = { __typename?: 'Mutation', syncPimsRemindersForPatient: boolean };

export type ComplianceStatusActivityQueryVariables = Exact<{
  clinicIds: Array<Scalars['ID']['input']> | Scalars['ID']['input'];
  startDate: Scalars['NonNegativeInt']['input'];
  endDate: Scalars['NonNegativeInt']['input'];
}>;


export type ComplianceStatusActivityQuery = { __typename?: 'Query', complianceStatusActivity: Array<{ __typename?: 'ComplianceStatusActivityRow', day: string, user?: string | null, first_name?: string | null, last_name?: string | null, compliance_status: string, count: number }> };

export type PimsSettingsFieldsFragment = { __typename?: 'PimsSettings', username?: string | null, password?: string | null, pin?: string | null, api_key?: string | null, additional_key?: string | null, api_clinic_id?: string | null, api_subdomain?: string | null, pulse_sales_report_id?: string | null, pulse_ar_report_id?: string | null, pulse_reminders_report_id?: string | null, ezyvet_client_id?: string | null, ezyvet_client_secret?: string | null, ezyvet_site_uid?: string | null, ezyvet_scopes?: string | null, entered_by_pms_id?: string | null, payment_type_pms_id?: string | null, should_sync_clinician_hours?: boolean | null, clinic?: { __typename?: 'Clinic', id: string, name?: string | null } | null };

export type OnDemandPaymentTypeFieldsFragment = { __typename?: 'OnDemandPaymentType', pms_id: string, description?: string | null, is_credit_card?: boolean | null, is_inactive?: boolean | null };

export type GetPimsSettingsQueryVariables = Exact<{
  clinicId: Scalars['ID']['input'];
}>;


export type GetPimsSettingsQuery = { __typename?: 'Query', pimsSettings: { __typename?: 'PimsSettings', username?: string | null, password?: string | null, pin?: string | null, api_key?: string | null, additional_key?: string | null, api_clinic_id?: string | null, api_subdomain?: string | null, pulse_sales_report_id?: string | null, pulse_ar_report_id?: string | null, pulse_reminders_report_id?: string | null, ezyvet_client_id?: string | null, ezyvet_client_secret?: string | null, ezyvet_site_uid?: string | null, ezyvet_scopes?: string | null, entered_by_pms_id?: string | null, payment_type_pms_id?: string | null, should_sync_clinician_hours?: boolean | null, clinic?: { __typename?: 'Clinic', id: string, name?: string | null } | null } };

export type CreatePimsSettingsMutationVariables = Exact<{
  data: CreatePimsSettingsInput;
}>;


export type CreatePimsSettingsMutation = { __typename?: 'Mutation', createPimsSettings: boolean };

export type UpdatePimsSettingsMutationVariables = Exact<{
  clinicId: Scalars['ID']['input'];
  data: UpdatePimsSettingsInput;
}>;


export type UpdatePimsSettingsMutation = { __typename?: 'Mutation', updatePimsSettings: boolean };

export type GetOnDemandPaymentTypesForClinicQueryVariables = Exact<{
  clinicId: Scalars['ID']['input'];
}>;


export type GetOnDemandPaymentTypesForClinicQuery = { __typename?: 'Query', getOnDemandPaymentTypesForClinic: Array<{ __typename?: 'OnDemandPaymentType', pms_id: string, description?: string | null, is_credit_card?: boolean | null, is_inactive?: boolean | null }> };

export type PmsApptTypeFieldsFragment = { __typename?: 'PmsApptType', id: string, name: string, pms_id: string, description?: string | null, color?: any | null, pms_is_active: boolean };

export type GetPmsApptTypeQueryVariables = Exact<{
  clinidId: Scalars['ID']['input'];
  pmsApptTypeId: Scalars['ID']['input'];
}>;


export type GetPmsApptTypeQuery = { __typename?: 'Query', pmsApptType: { __typename?: 'PmsApptType', id: string, name: string, pms_id: string, description?: string | null, color?: any | null, pms_is_active: boolean } };

export type GetPmsApptTypesForClinicQueryVariables = Exact<{
  clinicId: Scalars['ID']['input'];
}>;


export type GetPmsApptTypesForClinicQuery = { __typename?: 'Query', getPmsApptTypesForClinic: Array<{ __typename?: 'PmsApptType', id: string, name: string, pms_id: string, description?: string | null, color?: any | null, pms_is_active: boolean }> };

export type QueryPmsApptTypesQueryVariables = Exact<{
  where?: InputMaybe<Array<QueryInput> | QueryInput>;
  page?: InputMaybe<Scalars['NonNegativeInt']['input']>;
  pageSize?: InputMaybe<Scalars['NonNegativeInt']['input']>;
  orderBy?: InputMaybe<OrderByInput>;
}>;


export type QueryPmsApptTypesQuery = { __typename?: 'Query', queryPmsApptTypes: Array<{ __typename?: 'PmsApptType', id: string, name: string, pms_id: string, description?: string | null, color?: any | null, pms_is_active: boolean }> };

export type QueryPmsApptTypesWithClinicQueryVariables = Exact<{
  where?: InputMaybe<Array<QueryInput> | QueryInput>;
  page?: InputMaybe<Scalars['NonNegativeInt']['input']>;
  pageSize?: InputMaybe<Scalars['NonNegativeInt']['input']>;
  orderBy?: InputMaybe<OrderByInput>;
}>;


export type QueryPmsApptTypesWithClinicQuery = { __typename?: 'Query', queryPmsApptTypes: Array<{ __typename?: 'PmsApptType', id: string, name: string, pms_id: string, description?: string | null, color?: any | null, pms_is_active: boolean, clinic?: { __typename?: 'Clinic', id: string, name?: string | null } | null }> };

export type PmsDbFieldsFragment = { __typename?: 'PmsDb', id: string, name: string, pms: PracticeManagementSystem, time_zone?: string | null, created_at: number, updated_at: number, last_sync_times?: { __typename?: 'LastSyncTimes', last_full_sync?: number | null, last_sync_appointments?: number | null, last_sync_clients?: number | null, last_sync_patients?: number | null, last_sync_clinicians?: number | null, last_sync_services?: number | null, last_sync_transactions?: number | null, last_sync_invoices?: number | null, last_sync_history_items?: number | null, last_sync_diagnoses?: number | null, last_sync_prescriptions?: number | null, last_sync_products?: number | null, last_sync_rooms?: number | null, last_sync_species?: number | null, last_sync_breeds?: number | null, last_sync_reminders?: number | null, last_sync_reminder_types?: number | null, last_sync_vaccination_records?: number | null, last_sync_clinic_sexes?: number | null, last_sync_appt_statuses?: number | null, last_sync_blockoffs?: number | null, last_sync_invoice_items?: number | null } | null };

export type GetSyncedCloudPmsDbsQueryVariables = Exact<{ [key: string]: never; }>;


export type GetSyncedCloudPmsDbsQuery = { __typename?: 'Query', getSyncedCloudPmsDbs: Array<{ __typename?: 'PmsDb', id: string, name: string, pms: PracticeManagementSystem, time_zone?: string | null, created_at: number, updated_at: number, last_sync_times?: { __typename?: 'LastSyncTimes', last_full_sync?: number | null, last_sync_appointments?: number | null, last_sync_clients?: number | null, last_sync_patients?: number | null, last_sync_clinicians?: number | null, last_sync_services?: number | null, last_sync_transactions?: number | null, last_sync_invoices?: number | null, last_sync_history_items?: number | null, last_sync_diagnoses?: number | null, last_sync_prescriptions?: number | null, last_sync_products?: number | null, last_sync_rooms?: number | null, last_sync_species?: number | null, last_sync_breeds?: number | null, last_sync_reminders?: number | null, last_sync_reminder_types?: number | null, last_sync_vaccination_records?: number | null, last_sync_clinic_sexes?: number | null, last_sync_appt_statuses?: number | null, last_sync_blockoffs?: number | null, last_sync_invoice_items?: number | null } | null }> };

export type QueryPmsDbsQueryVariables = Exact<{
  where?: InputMaybe<Array<QueryInput> | QueryInput>;
  page?: InputMaybe<Scalars['NonNegativeInt']['input']>;
  pageSize?: InputMaybe<Scalars['NonNegativeInt']['input']>;
  orderBy?: InputMaybe<OrderByInput>;
}>;


export type QueryPmsDbsQuery = { __typename?: 'Query', queryPmsDbs: Array<{ __typename?: 'PmsDb', id: string, name: string, pms: PracticeManagementSystem, time_zone?: string | null, created_at: number, updated_at: number, last_sync_times?: { __typename?: 'LastSyncTimes', last_full_sync?: number | null, last_sync_appointments?: number | null, last_sync_clients?: number | null, last_sync_patients?: number | null, last_sync_clinicians?: number | null, last_sync_services?: number | null, last_sync_transactions?: number | null, last_sync_invoices?: number | null, last_sync_history_items?: number | null, last_sync_diagnoses?: number | null, last_sync_prescriptions?: number | null, last_sync_products?: number | null, last_sync_rooms?: number | null, last_sync_species?: number | null, last_sync_breeds?: number | null, last_sync_reminders?: number | null, last_sync_reminder_types?: number | null, last_sync_vaccination_records?: number | null, last_sync_clinic_sexes?: number | null, last_sync_appt_statuses?: number | null, last_sync_blockoffs?: number | null, last_sync_invoice_items?: number | null } | null }> };

export type CountPmsDbsQueryVariables = Exact<{
  where?: InputMaybe<Array<QueryInput> | QueryInput>;
}>;


export type CountPmsDbsQuery = { __typename?: 'Query', countPmsDbs: number };

export type GetPmsDbQueryVariables = Exact<{
  id: Scalars['ID']['input'];
}>;


export type GetPmsDbQuery = { __typename?: 'Query', pmsDb: { __typename?: 'PmsDb', id: string, name: string, pms: PracticeManagementSystem, time_zone?: string | null, created_at: number, updated_at: number, last_sync_times?: { __typename?: 'LastSyncTimes', last_full_sync?: number | null, last_sync_appointments?: number | null, last_sync_clients?: number | null, last_sync_patients?: number | null, last_sync_clinicians?: number | null, last_sync_services?: number | null, last_sync_transactions?: number | null, last_sync_invoices?: number | null, last_sync_history_items?: number | null, last_sync_diagnoses?: number | null, last_sync_prescriptions?: number | null, last_sync_products?: number | null, last_sync_rooms?: number | null, last_sync_species?: number | null, last_sync_breeds?: number | null, last_sync_reminders?: number | null, last_sync_reminder_types?: number | null, last_sync_vaccination_records?: number | null, last_sync_clinic_sexes?: number | null, last_sync_appt_statuses?: number | null, last_sync_blockoffs?: number | null, last_sync_invoice_items?: number | null } | null } };

export type CreatePmsDbMutationVariables = Exact<{
  data: CreatePmsDbInput;
  shouldCreateWidget?: InputMaybe<Scalars['Boolean']['input']>;
}>;


export type CreatePmsDbMutation = { __typename?: 'Mutation', createPmsDb: { __typename?: 'PmsDb', id: string, name: string, pms: PracticeManagementSystem, time_zone?: string | null, created_at: number, updated_at: number, last_sync_times?: { __typename?: 'LastSyncTimes', last_full_sync?: number | null, last_sync_appointments?: number | null, last_sync_clients?: number | null, last_sync_patients?: number | null, last_sync_clinicians?: number | null, last_sync_services?: number | null, last_sync_transactions?: number | null, last_sync_invoices?: number | null, last_sync_history_items?: number | null, last_sync_diagnoses?: number | null, last_sync_prescriptions?: number | null, last_sync_products?: number | null, last_sync_rooms?: number | null, last_sync_species?: number | null, last_sync_breeds?: number | null, last_sync_reminders?: number | null, last_sync_reminder_types?: number | null, last_sync_vaccination_records?: number | null, last_sync_clinic_sexes?: number | null, last_sync_appt_statuses?: number | null, last_sync_blockoffs?: number | null, last_sync_invoice_items?: number | null } | null } };

export type PmsTagCategoryFieldsFragment = { __typename?: 'PmsTagCategory', id: string, name: string, pms_id: string, pms_created_at?: number | null, pms_is_active: boolean, last_synced_time?: number | null, created_at: number, updated_at: number };

export type PmsTagFieldsFragment = { __typename?: 'PmsTag', id: string, name: string, pms_id: string, pms_created_at?: number | null, pms_is_active: boolean, last_synced_time?: number | null, created_at: number, updated_at: number, pms_tag_category?: { __typename?: 'PmsTagCategory', id: string, name: string, pms_id: string, pms_created_at?: number | null, pms_is_active: boolean, last_synced_time?: number | null, created_at: number, updated_at: number } | null };

export type GetPmsTagQueryVariables = Exact<{
  id: Scalars['ID']['input'];
}>;


export type GetPmsTagQuery = { __typename?: 'Query', pmsTag: { __typename?: 'PmsTag', id: string, name: string, pms_id: string, pms_created_at?: number | null, pms_is_active: boolean, last_synced_time?: number | null, created_at: number, updated_at: number, pms_tag_category?: { __typename?: 'PmsTagCategory', id: string, name: string, pms_id: string, pms_created_at?: number | null, pms_is_active: boolean, last_synced_time?: number | null, created_at: number, updated_at: number } | null } };

export type QueryPmsTagsQueryVariables = Exact<{
  where?: InputMaybe<Array<QueryInput> | QueryInput>;
  page?: InputMaybe<Scalars['NonNegativeInt']['input']>;
  pageSize?: InputMaybe<Scalars['NonNegativeInt']['input']>;
  orderBy?: InputMaybe<OrderByInput>;
}>;


export type QueryPmsTagsQuery = { __typename?: 'Query', queryPmsTags: Array<{ __typename?: 'PmsTag', id: string, name: string, pms_id: string, pms_created_at?: number | null, pms_is_active: boolean, last_synced_time?: number | null, created_at: number, updated_at: number, pms_tag_category?: { __typename?: 'PmsTagCategory', id: string, name: string, pms_id: string, pms_created_at?: number | null, pms_is_active: boolean, last_synced_time?: number | null, created_at: number, updated_at: number } | null }> };

export type CountPmsTagsQueryVariables = Exact<{
  where?: InputMaybe<Array<QueryInput> | QueryInput>;
}>;


export type CountPmsTagsQuery = { __typename?: 'Query', countPmsTags: number };

export type QueryPmsTagCategoriesQueryVariables = Exact<{
  where?: InputMaybe<Array<QueryInput> | QueryInput>;
  page?: InputMaybe<Scalars['NonNegativeInt']['input']>;
  pageSize?: InputMaybe<Scalars['NonNegativeInt']['input']>;
  orderBy?: InputMaybe<OrderByInput>;
}>;


export type QueryPmsTagCategoriesQuery = { __typename?: 'Query', queryPmsTagCategories: Array<{ __typename?: 'PmsTagCategory', id: string, name: string, pms_id: string, pms_created_at?: number | null, pms_is_active: boolean, last_synced_time?: number | null, created_at: number, updated_at: number }> };

export type CountPmsTagCategoriesQueryVariables = Exact<{
  where?: InputMaybe<Array<QueryInput> | QueryInput>;
}>;


export type CountPmsTagCategoriesQuery = { __typename?: 'Query', countPmsTagCategories: number };

export type PrescriptionRefillRequestFieldsFragment = { __typename?: 'PrescriptionRefillRequest', id: string, pickup_time?: number | null, stripe_payment_intent_id?: string | null, amount?: number | null, status: PrescriptionRefillRequestStatus, type: PrescriptionRefillRequestType, notes?: string | null, denial_reason?: string | null, approved_at?: number | null, denied_at?: number | null, created_at: number, updated_at: number, clinic: { __typename?: 'Clinic', id: string }, client: { __typename?: 'Client', id: string, first_name?: string | null, last_name?: string | null, secondary_first_name?: string | null, secondary_last_name?: string | null, phone?: string | null, email?: string | null, pms_id?: string | null, is_active?: boolean | null, is_unsubscribed: boolean, sms_enabled: boolean, email_enabled: boolean, balance?: number | null, last_appt_time?: number | null, created_at: number, updated_at: number, last_appointment?: { __typename?: 'Appointment', clinician?: { __typename?: 'Clinician', name: string, display_name?: string | null } | null } | null, address?: { __typename?: 'Address', street_a?: string | null, street_b?: string | null, city?: string | null, state?: string | null, zip?: string | null, country?: string | null } | null, clinic?: { __typename?: 'Clinic', id: string } | null, user?: { __typename?: 'User', avatar_url?: string | null } | null, patients?: Array<{ __typename?: 'Patient', id: string, name?: string | null, gender?: string | null, pms_id?: string | null, is_deceased?: boolean | null, is_active?: boolean | null, clinic_species?: { __typename?: 'ClinicSpecies', id: string, species: Species } | null, clinic_breed?: { __typename?: 'Breed', id: string, description: string } | null, last_appointment?: { __typename?: 'Appointment', clinician?: { __typename?: 'Clinician', name: string, display_name?: string | null } | null } | null }> | null, settings?: { __typename?: 'ClientSettings', clinic_chckup_notifications_enabled: boolean, clinic_chckup_sms_enabled: boolean, clinic_chckup_email_enabled: boolean, client_chckup_notifications_enabled: boolean, client_chckup_sms_enabled: boolean, client_chckup_email_enabled: boolean, is_unsubscribed_from_marketing: boolean, is_unsubscribed_from_marketing_sms: boolean, is_unsubscribed_from_marketing_email: boolean } | null }, patient?: { __typename?: 'Patient', id: string, pms_id?: string | null, name?: string | null, breed?: string | null, is_active?: boolean | null, is_deceased?: boolean | null, avatar_url?: string | null, gender?: string | null, fixed_status?: FixedStatus | null, birthday?: number | null, weight?: number | null, owner?: { __typename?: 'Client', id: string, first_name?: string | null, last_name?: string | null, secondary_first_name?: string | null, secondary_last_name?: string | null, phone?: string | null, email?: string | null } | null, clinic_species?: { __typename?: 'ClinicSpecies', id: string, species: Species, description: string, weight_key: string } | null, clinic_breed?: { __typename?: 'Breed', id: string, description: string } | null } | null, prescription?: { __typename?: 'Prescription', id: string, name?: string | null, product_name?: string | null, quantity?: number | null, refill_count?: number | null, refill_limit?: number | null, product?: { __typename?: 'Product', id: string, name: string, price: number, chckvet_price?: number | null, unit?: string | null, volume?: string | null, additional_fees?: Array<{ __typename?: 'AdditionalFees', name: string, amount: number }> | null } | null } | null, appointment?: { __typename?: 'Appointment', id: string, start_time: number, status: AppointmentStatus } | null };

export type QueryPrescriptionRefillRequestsQueryVariables = Exact<{
  where?: InputMaybe<Array<QueryInput> | QueryInput>;
  page?: InputMaybe<Scalars['NonNegativeInt']['input']>;
  pageSize?: InputMaybe<Scalars['NonNegativeInt']['input']>;
  orderBy?: InputMaybe<OrderByInput>;
}>;


export type QueryPrescriptionRefillRequestsQuery = { __typename?: 'Query', queryPrescriptionRefillRequests: Array<{ __typename?: 'PrescriptionRefillRequest', id: string, pickup_time?: number | null, stripe_payment_intent_id?: string | null, amount?: number | null, status: PrescriptionRefillRequestStatus, type: PrescriptionRefillRequestType, notes?: string | null, denial_reason?: string | null, approved_at?: number | null, denied_at?: number | null, created_at: number, updated_at: number, clinic: { __typename?: 'Clinic', id: string }, client: { __typename?: 'Client', id: string, first_name?: string | null, last_name?: string | null, secondary_first_name?: string | null, secondary_last_name?: string | null, phone?: string | null, email?: string | null, pms_id?: string | null, is_active?: boolean | null, is_unsubscribed: boolean, sms_enabled: boolean, email_enabled: boolean, balance?: number | null, last_appt_time?: number | null, created_at: number, updated_at: number, last_appointment?: { __typename?: 'Appointment', clinician?: { __typename?: 'Clinician', name: string, display_name?: string | null } | null } | null, address?: { __typename?: 'Address', street_a?: string | null, street_b?: string | null, city?: string | null, state?: string | null, zip?: string | null, country?: string | null } | null, clinic?: { __typename?: 'Clinic', id: string } | null, user?: { __typename?: 'User', avatar_url?: string | null } | null, patients?: Array<{ __typename?: 'Patient', id: string, name?: string | null, gender?: string | null, pms_id?: string | null, is_deceased?: boolean | null, is_active?: boolean | null, clinic_species?: { __typename?: 'ClinicSpecies', id: string, species: Species } | null, clinic_breed?: { __typename?: 'Breed', id: string, description: string } | null, last_appointment?: { __typename?: 'Appointment', clinician?: { __typename?: 'Clinician', name: string, display_name?: string | null } | null } | null }> | null, settings?: { __typename?: 'ClientSettings', clinic_chckup_notifications_enabled: boolean, clinic_chckup_sms_enabled: boolean, clinic_chckup_email_enabled: boolean, client_chckup_notifications_enabled: boolean, client_chckup_sms_enabled: boolean, client_chckup_email_enabled: boolean, is_unsubscribed_from_marketing: boolean, is_unsubscribed_from_marketing_sms: boolean, is_unsubscribed_from_marketing_email: boolean } | null }, patient?: { __typename?: 'Patient', id: string, pms_id?: string | null, name?: string | null, breed?: string | null, is_active?: boolean | null, is_deceased?: boolean | null, avatar_url?: string | null, gender?: string | null, fixed_status?: FixedStatus | null, birthday?: number | null, weight?: number | null, owner?: { __typename?: 'Client', id: string, first_name?: string | null, last_name?: string | null, secondary_first_name?: string | null, secondary_last_name?: string | null, phone?: string | null, email?: string | null } | null, clinic_species?: { __typename?: 'ClinicSpecies', id: string, species: Species, description: string, weight_key: string } | null, clinic_breed?: { __typename?: 'Breed', id: string, description: string } | null } | null, prescription?: { __typename?: 'Prescription', id: string, name?: string | null, product_name?: string | null, quantity?: number | null, refill_count?: number | null, refill_limit?: number | null, product?: { __typename?: 'Product', id: string, name: string, price: number, chckvet_price?: number | null, unit?: string | null, volume?: string | null, additional_fees?: Array<{ __typename?: 'AdditionalFees', name: string, amount: number }> | null } | null } | null, appointment?: { __typename?: 'Appointment', id: string, start_time: number, status: AppointmentStatus } | null }> };

export type CountPrescriptionRefillRequestsQueryVariables = Exact<{
  where?: InputMaybe<Array<QueryInput> | QueryInput>;
}>;


export type CountPrescriptionRefillRequestsQuery = { __typename?: 'Query', countPrescriptionRefillRequests: number };

export type ApprovePrescriptionRefillRequestMutationVariables = Exact<{
  id: Scalars['ID']['input'];
  actionItemId?: InputMaybe<Scalars['ID']['input']>;
}>;


export type ApprovePrescriptionRefillRequestMutation = { __typename?: 'Mutation', approvePrescriptionRefillRequest: { __typename?: 'PrescriptionRefillRequest', id: string, pickup_time?: number | null, stripe_payment_intent_id?: string | null, amount?: number | null, status: PrescriptionRefillRequestStatus, type: PrescriptionRefillRequestType, notes?: string | null, denial_reason?: string | null, approved_at?: number | null, denied_at?: number | null, created_at: number, updated_at: number, clinic: { __typename?: 'Clinic', id: string }, client: { __typename?: 'Client', id: string, first_name?: string | null, last_name?: string | null, secondary_first_name?: string | null, secondary_last_name?: string | null, phone?: string | null, email?: string | null, pms_id?: string | null, is_active?: boolean | null, is_unsubscribed: boolean, sms_enabled: boolean, email_enabled: boolean, balance?: number | null, last_appt_time?: number | null, created_at: number, updated_at: number, last_appointment?: { __typename?: 'Appointment', clinician?: { __typename?: 'Clinician', name: string, display_name?: string | null } | null } | null, address?: { __typename?: 'Address', street_a?: string | null, street_b?: string | null, city?: string | null, state?: string | null, zip?: string | null, country?: string | null } | null, clinic?: { __typename?: 'Clinic', id: string } | null, user?: { __typename?: 'User', avatar_url?: string | null } | null, patients?: Array<{ __typename?: 'Patient', id: string, name?: string | null, gender?: string | null, pms_id?: string | null, is_deceased?: boolean | null, is_active?: boolean | null, clinic_species?: { __typename?: 'ClinicSpecies', id: string, species: Species } | null, clinic_breed?: { __typename?: 'Breed', id: string, description: string } | null, last_appointment?: { __typename?: 'Appointment', clinician?: { __typename?: 'Clinician', name: string, display_name?: string | null } | null } | null }> | null, settings?: { __typename?: 'ClientSettings', clinic_chckup_notifications_enabled: boolean, clinic_chckup_sms_enabled: boolean, clinic_chckup_email_enabled: boolean, client_chckup_notifications_enabled: boolean, client_chckup_sms_enabled: boolean, client_chckup_email_enabled: boolean, is_unsubscribed_from_marketing: boolean, is_unsubscribed_from_marketing_sms: boolean, is_unsubscribed_from_marketing_email: boolean } | null }, patient?: { __typename?: 'Patient', id: string, pms_id?: string | null, name?: string | null, breed?: string | null, is_active?: boolean | null, is_deceased?: boolean | null, avatar_url?: string | null, gender?: string | null, fixed_status?: FixedStatus | null, birthday?: number | null, weight?: number | null, owner?: { __typename?: 'Client', id: string, first_name?: string | null, last_name?: string | null, secondary_first_name?: string | null, secondary_last_name?: string | null, phone?: string | null, email?: string | null } | null, clinic_species?: { __typename?: 'ClinicSpecies', id: string, species: Species, description: string, weight_key: string } | null, clinic_breed?: { __typename?: 'Breed', id: string, description: string } | null } | null, prescription?: { __typename?: 'Prescription', id: string, name?: string | null, product_name?: string | null, quantity?: number | null, refill_count?: number | null, refill_limit?: number | null, product?: { __typename?: 'Product', id: string, name: string, price: number, chckvet_price?: number | null, unit?: string | null, volume?: string | null, additional_fees?: Array<{ __typename?: 'AdditionalFees', name: string, amount: number }> | null } | null } | null, appointment?: { __typename?: 'Appointment', id: string, start_time: number, status: AppointmentStatus } | null } };

export type DenyPrescriptionRefillRequestMutationVariables = Exact<{
  id: Scalars['ID']['input'];
  reason: Scalars['String']['input'];
  actionItemId?: InputMaybe<Scalars['ID']['input']>;
}>;


export type DenyPrescriptionRefillRequestMutation = { __typename?: 'Mutation', denyPrescriptionRefillRequest: { __typename?: 'PrescriptionRefillRequest', id: string, pickup_time?: number | null, stripe_payment_intent_id?: string | null, amount?: number | null, status: PrescriptionRefillRequestStatus, type: PrescriptionRefillRequestType, notes?: string | null, denial_reason?: string | null, approved_at?: number | null, denied_at?: number | null, created_at: number, updated_at: number, clinic: { __typename?: 'Clinic', id: string }, client: { __typename?: 'Client', id: string, first_name?: string | null, last_name?: string | null, secondary_first_name?: string | null, secondary_last_name?: string | null, phone?: string | null, email?: string | null, pms_id?: string | null, is_active?: boolean | null, is_unsubscribed: boolean, sms_enabled: boolean, email_enabled: boolean, balance?: number | null, last_appt_time?: number | null, created_at: number, updated_at: number, last_appointment?: { __typename?: 'Appointment', clinician?: { __typename?: 'Clinician', name: string, display_name?: string | null } | null } | null, address?: { __typename?: 'Address', street_a?: string | null, street_b?: string | null, city?: string | null, state?: string | null, zip?: string | null, country?: string | null } | null, clinic?: { __typename?: 'Clinic', id: string } | null, user?: { __typename?: 'User', avatar_url?: string | null } | null, patients?: Array<{ __typename?: 'Patient', id: string, name?: string | null, gender?: string | null, pms_id?: string | null, is_deceased?: boolean | null, is_active?: boolean | null, clinic_species?: { __typename?: 'ClinicSpecies', id: string, species: Species } | null, clinic_breed?: { __typename?: 'Breed', id: string, description: string } | null, last_appointment?: { __typename?: 'Appointment', clinician?: { __typename?: 'Clinician', name: string, display_name?: string | null } | null } | null }> | null, settings?: { __typename?: 'ClientSettings', clinic_chckup_notifications_enabled: boolean, clinic_chckup_sms_enabled: boolean, clinic_chckup_email_enabled: boolean, client_chckup_notifications_enabled: boolean, client_chckup_sms_enabled: boolean, client_chckup_email_enabled: boolean, is_unsubscribed_from_marketing: boolean, is_unsubscribed_from_marketing_sms: boolean, is_unsubscribed_from_marketing_email: boolean } | null }, patient?: { __typename?: 'Patient', id: string, pms_id?: string | null, name?: string | null, breed?: string | null, is_active?: boolean | null, is_deceased?: boolean | null, avatar_url?: string | null, gender?: string | null, fixed_status?: FixedStatus | null, birthday?: number | null, weight?: number | null, owner?: { __typename?: 'Client', id: string, first_name?: string | null, last_name?: string | null, secondary_first_name?: string | null, secondary_last_name?: string | null, phone?: string | null, email?: string | null } | null, clinic_species?: { __typename?: 'ClinicSpecies', id: string, species: Species, description: string, weight_key: string } | null, clinic_breed?: { __typename?: 'Breed', id: string, description: string } | null } | null, prescription?: { __typename?: 'Prescription', id: string, name?: string | null, product_name?: string | null, quantity?: number | null, refill_count?: number | null, refill_limit?: number | null, product?: { __typename?: 'Product', id: string, name: string, price: number, chckvet_price?: number | null, unit?: string | null, volume?: string | null, additional_fees?: Array<{ __typename?: 'AdditionalFees', name: string, amount: number }> | null } | null } | null, appointment?: { __typename?: 'Appointment', id: string, start_time: number, status: AppointmentStatus } | null } };

export type CancelPrescriptionRefillRequestMutationVariables = Exact<{
  id: Scalars['ID']['input'];
  actionItemId?: InputMaybe<Scalars['ID']['input']>;
}>;


export type CancelPrescriptionRefillRequestMutation = { __typename?: 'Mutation', cancelPrescriptionRefillRequest: { __typename?: 'PrescriptionRefillRequest', id: string, pickup_time?: number | null, stripe_payment_intent_id?: string | null, amount?: number | null, status: PrescriptionRefillRequestStatus, type: PrescriptionRefillRequestType, notes?: string | null, denial_reason?: string | null, approved_at?: number | null, denied_at?: number | null, created_at: number, updated_at: number, clinic: { __typename?: 'Clinic', id: string }, client: { __typename?: 'Client', id: string, first_name?: string | null, last_name?: string | null, secondary_first_name?: string | null, secondary_last_name?: string | null, phone?: string | null, email?: string | null, pms_id?: string | null, is_active?: boolean | null, is_unsubscribed: boolean, sms_enabled: boolean, email_enabled: boolean, balance?: number | null, last_appt_time?: number | null, created_at: number, updated_at: number, last_appointment?: { __typename?: 'Appointment', clinician?: { __typename?: 'Clinician', name: string, display_name?: string | null } | null } | null, address?: { __typename?: 'Address', street_a?: string | null, street_b?: string | null, city?: string | null, state?: string | null, zip?: string | null, country?: string | null } | null, clinic?: { __typename?: 'Clinic', id: string } | null, user?: { __typename?: 'User', avatar_url?: string | null } | null, patients?: Array<{ __typename?: 'Patient', id: string, name?: string | null, gender?: string | null, pms_id?: string | null, is_deceased?: boolean | null, is_active?: boolean | null, clinic_species?: { __typename?: 'ClinicSpecies', id: string, species: Species } | null, clinic_breed?: { __typename?: 'Breed', id: string, description: string } | null, last_appointment?: { __typename?: 'Appointment', clinician?: { __typename?: 'Clinician', name: string, display_name?: string | null } | null } | null }> | null, settings?: { __typename?: 'ClientSettings', clinic_chckup_notifications_enabled: boolean, clinic_chckup_sms_enabled: boolean, clinic_chckup_email_enabled: boolean, client_chckup_notifications_enabled: boolean, client_chckup_sms_enabled: boolean, client_chckup_email_enabled: boolean, is_unsubscribed_from_marketing: boolean, is_unsubscribed_from_marketing_sms: boolean, is_unsubscribed_from_marketing_email: boolean } | null }, patient?: { __typename?: 'Patient', id: string, pms_id?: string | null, name?: string | null, breed?: string | null, is_active?: boolean | null, is_deceased?: boolean | null, avatar_url?: string | null, gender?: string | null, fixed_status?: FixedStatus | null, birthday?: number | null, weight?: number | null, owner?: { __typename?: 'Client', id: string, first_name?: string | null, last_name?: string | null, secondary_first_name?: string | null, secondary_last_name?: string | null, phone?: string | null, email?: string | null } | null, clinic_species?: { __typename?: 'ClinicSpecies', id: string, species: Species, description: string, weight_key: string } | null, clinic_breed?: { __typename?: 'Breed', id: string, description: string } | null } | null, prescription?: { __typename?: 'Prescription', id: string, name?: string | null, product_name?: string | null, quantity?: number | null, refill_count?: number | null, refill_limit?: number | null, product?: { __typename?: 'Product', id: string, name: string, price: number, chckvet_price?: number | null, unit?: string | null, volume?: string | null, additional_fees?: Array<{ __typename?: 'AdditionalFees', name: string, amount: number }> | null } | null } | null, appointment?: { __typename?: 'Appointment', id: string, start_time: number, status: AppointmentStatus } | null } };

export type PrescriptionFieldsFragment = { __typename?: 'Prescription', id: string, name?: string | null, description?: string | null, product_name?: string | null, quantity?: number | null, remaining?: number | null, last_refill_time?: number | null, is_active: boolean, expiration_date?: number | null, refill_count?: number | null, refill_limit?: number | null, created_at: number, updated_at: number, clinic?: { __typename?: 'Clinic', id: string } | null, patient: { __typename?: 'Patient', id: string, name?: string | null, owner?: { __typename?: 'Client', id: string, first_name?: string | null, last_name?: string | null } | null }, product?: { __typename?: 'Product', id: string, name: string, description?: string | null, category: ProductCategory, unit?: string | null, volume?: string | null } | null };

export type QueryPrescriptionsQueryVariables = Exact<{
  where?: InputMaybe<Array<QueryInput> | QueryInput>;
  page?: InputMaybe<Scalars['NonNegativeInt']['input']>;
  pageSize?: InputMaybe<Scalars['NonNegativeInt']['input']>;
  orderBy?: InputMaybe<OrderByInput>;
}>;


export type QueryPrescriptionsQuery = { __typename?: 'Query', queryPrescriptions: Array<{ __typename?: 'Prescription', id: string, name?: string | null, description?: string | null, product_name?: string | null, quantity?: number | null, remaining?: number | null, last_refill_time?: number | null, is_active: boolean, expiration_date?: number | null, refill_count?: number | null, refill_limit?: number | null, created_at: number, updated_at: number, clinic?: { __typename?: 'Clinic', id: string } | null, patient: { __typename?: 'Patient', id: string, name?: string | null, owner?: { __typename?: 'Client', id: string, first_name?: string | null, last_name?: string | null } | null }, product?: { __typename?: 'Product', id: string, name: string, description?: string | null, category: ProductCategory, unit?: string | null, volume?: string | null } | null }> };

export type CountPrescriptionsQueryVariables = Exact<{
  where?: InputMaybe<Array<QueryInput> | QueryInput>;
}>;


export type CountPrescriptionsQuery = { __typename?: 'Query', countPrescriptions: number };

export type PressItemFieldsFragment = { __typename?: 'PressItem', id: string, title?: string | null, description?: string | null, image?: string | null, created_at: number, updated_at: number, links?: Array<{ __typename?: 'Link', url?: string | null, type?: LinkType | null }> | null };

export type GetPressItemQueryVariables = Exact<{
  id: Scalars['ID']['input'];
}>;


export type GetPressItemQuery = { __typename?: 'Query', pressItem: { __typename?: 'PressItem', id: string, title?: string | null, description?: string | null, image?: string | null, created_at: number, updated_at: number, links?: Array<{ __typename?: 'Link', url?: string | null, type?: LinkType | null }> | null } };

export type CreatePressItemMutationVariables = Exact<{
  data: CreatePressItemInput;
}>;


export type CreatePressItemMutation = { __typename?: 'Mutation', createPressItem: { __typename?: 'PressItem', id: string, title?: string | null, description?: string | null, image?: string | null, created_at: number, updated_at: number, links?: Array<{ __typename?: 'Link', url?: string | null, type?: LinkType | null }> | null } };

export type UpdatePressItemMutationVariables = Exact<{
  id: Scalars['ID']['input'];
  data: UpdatePressItemInput;
}>;


export type UpdatePressItemMutation = { __typename?: 'Mutation', updatePressItem: { __typename?: 'PressItem', id: string, title?: string | null, description?: string | null, image?: string | null, created_at: number, updated_at: number, links?: Array<{ __typename?: 'Link', url?: string | null, type?: LinkType | null }> | null } };

export type DeletePressItemMutationVariables = Exact<{
  id: Scalars['ID']['input'];
}>;


export type DeletePressItemMutation = { __typename?: 'Mutation', deletePressItem?: any | null };

export type ProductFieldsFragment = { __typename?: 'Product', id: string, pms_id: string, name: string, display_name?: string | null, description?: string | null, price: number, chckvet_price?: number | null, cost?: number | null, prescription_fee_split_override?: number | null, category: ProductCategory, pims_category?: string | null, code?: string | null, is_active: boolean, is_controlled: boolean, unit?: string | null, volume?: string | null, created_at: number, updated_at: number, clinic?: { __typename?: 'Clinic', id: string, name?: string | null } | null, additional_fees?: Array<{ __typename?: 'AdditionalFees', name: string, amount: number }> | null };

export type PrescriptionPricingFieldsFragment = { __typename?: 'PrescriptionPricing', productId: string, units: number, unitPrice: number, chckvetFeeSplitPercentage: number, chckvetFeeTotal: number, chckvetFeeClientPortion: number, chckvetFeeClinicPortion: number, stripeFee: number, isStripeFeeChargedToClient: boolean, amountBeforeStripeFee: number, subtotal: number, items: Array<{ __typename?: 'PrescriptionPricingItem', kind: PrescriptionPricingItemKind, label: string, amount: number }> };

export type GetPrescriptionPricingQueryVariables = Exact<{
  productId: Scalars['ID']['input'];
  units: Scalars['NonNegativeFloat']['input'];
  clinicId?: InputMaybe<Scalars['ID']['input']>;
  unitPriceOverride?: InputMaybe<Scalars['NonNegativeInt']['input']>;
  feeSplitPercentageOverride?: InputMaybe<Scalars['Float']['input']>;
}>;


export type GetPrescriptionPricingQuery = { __typename?: 'Query', prescriptionPricing: { __typename?: 'PrescriptionPricing', productId: string, units: number, unitPrice: number, chckvetFeeSplitPercentage: number, chckvetFeeTotal: number, chckvetFeeClientPortion: number, chckvetFeeClinicPortion: number, stripeFee: number, isStripeFeeChargedToClient: boolean, amountBeforeStripeFee: number, subtotal: number, items: Array<{ __typename?: 'PrescriptionPricingItem', kind: PrescriptionPricingItemKind, label: string, amount: number }> } };

export type QueryProductsQueryVariables = Exact<{
  where?: InputMaybe<Array<QueryInput> | QueryInput>;
  page?: InputMaybe<Scalars['NonNegativeInt']['input']>;
  pageSize?: InputMaybe<Scalars['NonNegativeInt']['input']>;
  orderBy?: InputMaybe<OrderByInput>;
}>;


export type QueryProductsQuery = { __typename?: 'Query', queryProducts: Array<{ __typename?: 'Product', id: string, pms_id: string, name: string, display_name?: string | null, description?: string | null, price: number, chckvet_price?: number | null, cost?: number | null, prescription_fee_split_override?: number | null, category: ProductCategory, pims_category?: string | null, code?: string | null, is_active: boolean, is_controlled: boolean, unit?: string | null, volume?: string | null, created_at: number, updated_at: number, clinic?: { __typename?: 'Clinic', id: string, name?: string | null } | null, additional_fees?: Array<{ __typename?: 'AdditionalFees', name: string, amount: number }> | null }> };

export type CountProductsQueryVariables = Exact<{
  where?: InputMaybe<Array<QueryInput> | QueryInput>;
}>;


export type CountProductsQuery = { __typename?: 'Query', countProducts: number };

export type UpdateProductMutationVariables = Exact<{
  productId: Scalars['ID']['input'];
  data: UpdateProductInput;
}>;


export type UpdateProductMutation = { __typename?: 'Mutation', updateProduct: { __typename?: 'Product', id: string, pms_id: string, name: string, display_name?: string | null, description?: string | null, price: number, chckvet_price?: number | null, cost?: number | null, prescription_fee_split_override?: number | null, category: ProductCategory, pims_category?: string | null, code?: string | null, is_active: boolean, is_controlled: boolean, unit?: string | null, volume?: string | null, created_at: number, updated_at: number, clinic?: { __typename?: 'Clinic', id: string, name?: string | null } | null, additional_fees?: Array<{ __typename?: 'AdditionalFees', name: string, amount: number }> | null } };

export type SearchClinicProductsQueryVariables = Exact<{
  clinicId: Scalars['ID']['input'];
  options: SearchClinicProductsOptions;
}>;


export type SearchClinicProductsQuery = { __typename?: 'Query', searchClinicProducts: { __typename?: 'SearchClinicProductsResult', count: number, products: Array<{ __typename?: 'Product', id: string, pms_id: string, name: string, display_name?: string | null, description?: string | null, price: number, chckvet_price?: number | null, cost?: number | null, prescription_fee_split_override?: number | null, category: ProductCategory, pims_category?: string | null, code?: string | null, is_active: boolean, is_controlled: boolean, unit?: string | null, volume?: string | null, created_at: number, updated_at: number, clinic?: { __typename?: 'Clinic', id: string, name?: string | null } | null, additional_fees?: Array<{ __typename?: 'AdditionalFees', name: string, amount: number }> | null }> } };

export type PmsCodeFieldsFragment = { __typename?: 'PmsCode', pms_id: string, code_name: string, description: string, type: string };

export type GetPmsCodesForClinicQueryVariables = Exact<{
  clinicId: Scalars['ID']['input'];
  query?: InputMaybe<Scalars['String']['input']>;
}>;


export type GetPmsCodesForClinicQuery = { __typename?: 'Query', getPmsCodesForClinic: Array<{ __typename?: 'PmsCode', pms_id: string, code_name: string, description: string, type: string }> };

export type ExecuteApprovedChangeMutationVariables = Exact<{
  input: ExecuteApprovedChangeInput;
}>;


export type ExecuteApprovedChangeMutation = { __typename?: 'Mutation', executeApprovedChange: { __typename?: 'ExecuteApprovedChangeResult', success: boolean, operation: ProposedChangeOperation, target_entity_type: string, target_entity_id: string, applied_fields: Array<string>, message: string } };

export type TriggerSyncForClinicMutationVariables = Exact<{
  clinicId: Scalars['ID']['input'];
  isFullSync: Scalars['Boolean']['input'];
}>;


export type TriggerSyncForClinicMutation = { __typename?: 'Mutation', triggerSyncForClinic: boolean };

export type RescheduleAppointmentFieldsFragment = { __typename?: 'Appointment', id: string, service_name?: string | null, start_time: number, minutes: number, service?: { __typename?: 'Service', name?: string | null } | null, clinician?: { __typename?: 'Clinician', name: string } | null, client?: { __typename?: 'Client', first_name?: string | null, last_name?: string | null } | null, patient?: { __typename?: 'Patient', name?: string | null, clinic_species?: { __typename?: 'ClinicSpecies', species: Species } | null } | null };

export type RescheduleFieldsFragment = { __typename?: 'Reschedule', id: string, requested_start_time?: number | null, original_start_time?: number | null, clinic_notes?: string | null, client_notes?: string | null, reason_for_denial?: string | null, status: RescheduleStatus, initiated_by: RescheduleInitiatedBy, confirmed_at?: number | null, created_at: number, updated_at: number, appointment: { __typename?: 'Appointment', id: string, pms?: PracticeManagementSystem | null, client_pms_id?: string | null, is_new_client?: boolean | null, start_time: number, drop_off_time?: number | null, minutes: number, is_new_patient?: boolean | null, is_clinician_auto_assigned?: boolean | null, patient_pms_id?: string | null, referring_clinic_name?: string | null, client_notes?: string | null, clinic_notes?: string | null, service_name?: string | null, status: AppointmentStatus, is_time_block?: boolean | null, is_confirmed?: boolean | null, origin?: EntityOrigin | null, reason_for_cancellation?: string | null, client_reason_for_cancellation?: string | null, new_client_name?: string | null, new_client_phone?: string | null, new_patient_name?: string | null, new_patient_species?: string | null, confirmed_at?: number | null, widget_source?: string | null, from_widget?: string | null, is_deleted?: boolean | null, created_at: number, updated_at: number, pms_created_at?: number | null, clinic?: { __typename?: 'Clinic', id: string, name?: string | null, slug?: string | null, pms_db?: { __typename?: 'PmsDb', id: string } | null, address?: { __typename?: 'Address', country?: string | null } | null } | null, client?: { __typename?: 'Client', id: string, first_name?: string | null, last_name?: string | null, secondary_first_name?: string | null, secondary_last_name?: string | null, phone?: string | null, email?: string | null, pms?: PracticeManagementSystem | null, pms_id?: string | null, last_appt_time?: number | null, last_contact_time?: number | null, email_enabled: boolean, sms_enabled: boolean, balance?: number | null, is_active?: boolean | null, is_unsubscribed: boolean, created_at: number, updated_at: number, client_phones?: Array<{ __typename?: 'ClientPhone', id: string, phone: string, country_code?: string | null, is_primary: boolean, is_chckup_primary: boolean, is_mobile: boolean, sms_available: boolean, is_unsubscribed: boolean, is_active: boolean, name?: string | null }> | null, client_emails?: Array<{ __typename?: 'ClientEmail', id: string, email: string, is_primary: boolean }> | null, clinic?: { __typename?: 'Clinic', id: string } | null, patients?: Array<{ __typename?: 'Patient', id: string, pms?: PracticeManagementSystem | null, pms_id?: string | null, name?: string | null, breed?: string | null, avatar_url?: string | null, last_appt_time?: number | null, gender?: string | null, fixed_status?: FixedStatus | null, weight?: number | null, birthday?: number | null, is_active?: boolean | null, is_deceased?: boolean | null, pms_created_at?: number | null, created_at: number, updated_at: number, owner?: { __typename?: 'Client', id: string, first_name?: string | null, last_name?: string | null, email?: string | null, phone?: string | null, address?: { __typename?: 'Address', country?: string | null } | null } | null, clinic_species?: { __typename?: 'ClinicSpecies', id: string, pms_id: string, description: string, is_primary: boolean, species: Species, weight_key: string, created_at: number, updated_at: number } | null, clinic?: { __typename?: 'Clinic', id: string } | null, clinic_breed?: { __typename?: 'Breed', id: string, description: string } | null, patient_vaccination_records?: Array<{ __typename?: 'PatientVaccinationRecord', id: string, vaccine_name?: string | null, manufacturer?: string | null, lot_number?: string | null, administered_date?: number | null, due_date?: number | null, rabies_tag?: string | null, is_rabies_vaccine?: boolean | null, is_soc: boolean, is_active: boolean, product?: { __typename?: 'Product', id: string, display_name?: string | null, name: string } | null }> | null, last_appointment?: { __typename?: 'Appointment', clinician?: { __typename?: 'Clinician', name: string, display_name?: string | null } | null } | null }> | null, address?: { __typename?: 'Address', street_a?: string | null, street_b?: string | null, city?: string | null, state?: string | null, zip?: string | null, country?: string | null } | null, user?: { __typename?: 'User', avatar_url?: string | null } | null, loyalty_members?: Array<{ __typename?: 'LoyaltyMember', id: string, available_points: number } | null> | null, settings?: { __typename?: 'ClientSettings', clinic_chckup_notifications_enabled: boolean, clinic_chckup_sms_enabled: boolean, clinic_chckup_email_enabled: boolean, client_chckup_notifications_enabled: boolean, client_chckup_sms_enabled: boolean, client_chckup_email_enabled: boolean, is_unsubscribed_from_marketing: boolean, is_unsubscribed_from_marketing_sms: boolean, is_unsubscribed_from_marketing_email: boolean } | null, last_appointment?: { __typename?: 'Appointment', clinician?: { __typename?: 'Clinician', name: string, display_name?: string | null } | null } | null } | null, clinician?: { __typename?: 'Clinician', id: string, name: string, display_name?: string | null, bio?: string | null, avatar_url?: string | null, initials?: string | null, excluded_species?: Array<Species> | null, excluded_service_ids?: Array<string> | null, authority_level?: AuthorityLevel | null, type: ResourceType, is_active?: boolean | null, is_assignable_in_pms?: boolean | null, does_contribute_to_fill_rate?: boolean | null, pms_id?: string | null, location?: string | null, pms_is_active: boolean, valid_booking_interval_minutes?: Array<number> | null, created_at: number, updated_at: number, clinic?: { __typename?: 'Clinic', id: string, name?: string | null } | null, pms_db?: { __typename?: 'PmsDb', id: string } | null, hours?: { __typename?: 'AvailabilityHours', monday?: Array<{ __typename?: 'TimeInterval', start?: number | null, end?: number | null }> | null, tuesday?: Array<{ __typename?: 'TimeInterval', start?: number | null, end?: number | null }> | null, wednesday?: Array<{ __typename?: 'TimeInterval', start?: number | null, end?: number | null }> | null, thursday?: Array<{ __typename?: 'TimeInterval', start?: number | null, end?: number | null }> | null, friday?: Array<{ __typename?: 'TimeInterval', start?: number | null, end?: number | null }> | null, saturday?: Array<{ __typename?: 'TimeInterval', start?: number | null, end?: number | null }> | null, sunday?: Array<{ __typename?: 'TimeInterval', start?: number | null, end?: number | null }> | null } | null, adjusted_availability?: Array<{ __typename?: 'Availability', date: number, pms_appt_type_pms_id?: string | null, times: Array<{ __typename?: 'TimeInterval', start?: number | null, end?: number | null }>, repeat?: { __typename?: 'RepeatAvailability', daysOfMonth?: Array<number> | null, daysOfWeek?: Array<DayOfWeek> | null, weekOfMonth?: WeekOfMonth | null, frequency: any, unit: RepeatUnit, end_date?: number | null } | null }> | null, pms_adjusted_availability?: Array<{ __typename?: 'Availability', date: number, pms_appt_type_pms_id?: string | null, times: Array<{ __typename?: 'TimeInterval', start?: number | null, end?: number | null }>, repeat?: { __typename?: 'RepeatAvailability', daysOfMonth?: Array<number> | null, daysOfWeek?: Array<DayOfWeek> | null, weekOfMonth?: WeekOfMonth | null, frequency: any, unit: RepeatUnit, end_date?: number | null } | null }> | null } | null, room?: { __typename?: 'Room', id: string, pms_id: string, name: string, display_name?: string | null, description?: string | null, concurrent_patients?: number | null, is_active: boolean, does_contribute_to_fill_rate?: boolean | null, valid_booking_interval_minutes?: Array<number> | null, created_at: number, updated_at: number, clinic?: { __typename?: 'Clinic', pms: PracticeManagementSystem, id: string, name?: string | null, time_zone?: string | null } | null, hours?: { __typename?: 'AvailabilityHours', monday?: Array<{ __typename?: 'TimeInterval', start?: number | null, end?: number | null }> | null, tuesday?: Array<{ __typename?: 'TimeInterval', start?: number | null, end?: number | null }> | null, wednesday?: Array<{ __typename?: 'TimeInterval', start?: number | null, end?: number | null }> | null, thursday?: Array<{ __typename?: 'TimeInterval', start?: number | null, end?: number | null }> | null, friday?: Array<{ __typename?: 'TimeInterval', start?: number | null, end?: number | null }> | null, saturday?: Array<{ __typename?: 'TimeInterval', start?: number | null, end?: number | null }> | null, sunday?: Array<{ __typename?: 'TimeInterval', start?: number | null, end?: number | null }> | null } | null, adjusted_availability?: Array<{ __typename?: 'Availability', date: number, pms_appt_type_pms_id?: string | null, times: Array<{ __typename?: 'TimeInterval', start?: number | null, end?: number | null }>, repeat?: { __typename?: 'RepeatAvailability', daysOfMonth?: Array<number> | null, daysOfWeek?: Array<DayOfWeek> | null, weekOfMonth?: WeekOfMonth | null, frequency: any, unit: RepeatUnit, end_date?: number | null } | null }> | null, pms_adjusted_availability?: Array<{ __typename?: 'Availability', date: number, pms_appt_type_pms_id?: string | null, times: Array<{ __typename?: 'TimeInterval', start?: number | null, end?: number | null }>, repeat?: { __typename?: 'RepeatAvailability', daysOfMonth?: Array<number> | null, daysOfWeek?: Array<DayOfWeek> | null, weekOfMonth?: WeekOfMonth | null, frequency: any, unit: RepeatUnit, end_date?: number | null } | null }> | null } | null, service?: { __typename?: 'Service', id: string, name?: string | null, color?: string | null } | null, patient?: { __typename?: 'Patient', id: string, pms?: PracticeManagementSystem | null, pms_id?: string | null, name?: string | null, breed?: string | null, avatar_url?: string | null, last_appt_time?: number | null, gender?: string | null, fixed_status?: FixedStatus | null, weight?: number | null, birthday?: number | null, is_active?: boolean | null, is_deceased?: boolean | null, pms_created_at?: number | null, created_at: number, updated_at: number, owner?: { __typename?: 'Client', id: string, first_name?: string | null, last_name?: string | null, email?: string | null, phone?: string | null, address?: { __typename?: 'Address', country?: string | null } | null } | null, clinic_species?: { __typename?: 'ClinicSpecies', id: string, pms_id: string, description: string, is_primary: boolean, species: Species, weight_key: string, created_at: number, updated_at: number } | null, clinic?: { __typename?: 'Clinic', id: string } | null, clinic_breed?: { __typename?: 'Breed', id: string, description: string } | null, patient_vaccination_records?: Array<{ __typename?: 'PatientVaccinationRecord', id: string, vaccine_name?: string | null, manufacturer?: string | null, lot_number?: string | null, administered_date?: number | null, due_date?: number | null, rabies_tag?: string | null, is_rabies_vaccine?: boolean | null, is_soc: boolean, is_active: boolean, product?: { __typename?: 'Product', id: string, display_name?: string | null, name: string } | null }> | null, last_appointment?: { __typename?: 'Appointment', clinician?: { __typename?: 'Clinician', name: string, display_name?: string | null } | null } | null } | null, clinic_appt_status?: { __typename?: 'ClinicApptStatus', id: string, description: string, status: AppointmentStatus } | null, client_info?: { __typename?: 'ClientInfo', first_name?: string | null, last_name?: string | null, email?: string | null, phone?: string | null } | null, patient_info?: { __typename?: 'PatientInfo', patient_name?: string | null, patient_breed?: string | null, patient_clinic_species?: string | null, patient_clinic_breed?: string | null } | null, clients_forms?: Array<{ __typename?: 'ClientForm', id: string, client_completed_at?: number | null, clinic_verified_at?: number | null, is_archived: boolean, pms_id?: string | null, created_at: number, updated_at: number, client?: { __typename?: 'Client', id: string, first_name?: string | null, last_name?: string | null, phone?: string | null, email?: string | null, address?: { __typename?: 'Address', street_a?: string | null, city?: string | null, state?: string | null, zip?: string | null, country?: string | null } | null } | null, patient?: { __typename?: 'Patient', id: string, name?: string | null, is_active?: boolean | null, is_deceased?: boolean | null, birthday?: number | null, weight?: number | null, avatar_url?: string | null, gender?: string | null, owner?: { __typename?: 'Client', first_name?: string | null, last_name?: string | null } | null, clinic_species?: { __typename?: 'ClinicSpecies', id: string, species: Species, description: string, weight_key: string } | null, clinic_breed?: { __typename?: 'Breed', id: string, description: string } | null } | null, form: { __typename?: 'Form', id: string, name?: string | null, form_type: FormType, is_writeback_enabled: boolean, form_file_naming_template?: string | null }, form_data: { __typename?: 'FormFields', pages?: Array<{ __typename?: 'FormPage', id: string, title?: string | null, description?: string | null, order?: number | null }> | null, fields?: Array<{ __typename?: 'FormElement', id: string, type?: FormElementType | null, content?: string | null, name?: string | null, column_order?: number | null, row_order?: number | null, page_id?: string | null, options?: Array<string> | null, is_required?: boolean | null, value?: string | null, attachments?: Array<{ __typename?: 'FormFileAttachment', id?: string | null, filename?: string | null, mime_type?: string | null, size_bytes?: number | null, thumbnail_url?: string | null, url: string }> | null, field_updates?: Array<{ __typename?: 'FormFieldUpdate', field: FormFieldUpdateField, boolean_value?: boolean | null, option?: string | null }> | null }> | null }, appointment?: { __typename?: 'Appointment', start_time: number, drop_off_time?: number | null, clinic?: { __typename?: 'Clinic', name?: string | null, slug?: string | null, phone?: string | null, email?: string | null, address?: { __typename?: 'Address', street_a?: string | null, city?: string | null, state?: string | null, zip?: string | null, country?: string | null } | null } | null, clinician?: { __typename?: 'Clinician', name: string, display_name?: string | null } | null, service?: { __typename?: 'Service', name?: string | null } | null } | null }> | null, widget?: { __typename?: 'Widget', id: string, widget_name: string } | null }, requested_clinician?: { __typename?: 'Clinician', id: string, name: string } | null, original_clinician?: { __typename?: 'Clinician', id: string, name: string } | null };

export type QueryReschedulesQueryVariables = Exact<{
  where?: InputMaybe<Array<QueryInput> | QueryInput>;
  page?: InputMaybe<Scalars['NonNegativeInt']['input']>;
  pageSize?: InputMaybe<Scalars['NonNegativeInt']['input']>;
  orderBy?: InputMaybe<OrderByInput>;
}>;


export type QueryReschedulesQuery = { __typename?: 'Query', queryReschedules: Array<{ __typename?: 'Reschedule', id: string, requested_start_time?: number | null, original_start_time?: number | null, clinic_notes?: string | null, client_notes?: string | null, reason_for_denial?: string | null, status: RescheduleStatus, initiated_by: RescheduleInitiatedBy, confirmed_at?: number | null, created_at: number, updated_at: number, appointment: { __typename?: 'Appointment', id: string, pms?: PracticeManagementSystem | null, client_pms_id?: string | null, is_new_client?: boolean | null, start_time: number, drop_off_time?: number | null, minutes: number, is_new_patient?: boolean | null, is_clinician_auto_assigned?: boolean | null, patient_pms_id?: string | null, referring_clinic_name?: string | null, client_notes?: string | null, clinic_notes?: string | null, service_name?: string | null, status: AppointmentStatus, is_time_block?: boolean | null, is_confirmed?: boolean | null, origin?: EntityOrigin | null, reason_for_cancellation?: string | null, client_reason_for_cancellation?: string | null, new_client_name?: string | null, new_client_phone?: string | null, new_patient_name?: string | null, new_patient_species?: string | null, confirmed_at?: number | null, widget_source?: string | null, from_widget?: string | null, is_deleted?: boolean | null, created_at: number, updated_at: number, pms_created_at?: number | null, clinic?: { __typename?: 'Clinic', id: string, name?: string | null, slug?: string | null, pms_db?: { __typename?: 'PmsDb', id: string } | null, address?: { __typename?: 'Address', country?: string | null } | null } | null, client?: { __typename?: 'Client', id: string, first_name?: string | null, last_name?: string | null, secondary_first_name?: string | null, secondary_last_name?: string | null, phone?: string | null, email?: string | null, pms?: PracticeManagementSystem | null, pms_id?: string | null, last_appt_time?: number | null, last_contact_time?: number | null, email_enabled: boolean, sms_enabled: boolean, balance?: number | null, is_active?: boolean | null, is_unsubscribed: boolean, created_at: number, updated_at: number, client_phones?: Array<{ __typename?: 'ClientPhone', id: string, phone: string, country_code?: string | null, is_primary: boolean, is_chckup_primary: boolean, is_mobile: boolean, sms_available: boolean, is_unsubscribed: boolean, is_active: boolean, name?: string | null }> | null, client_emails?: Array<{ __typename?: 'ClientEmail', id: string, email: string, is_primary: boolean }> | null, clinic?: { __typename?: 'Clinic', id: string } | null, patients?: Array<{ __typename?: 'Patient', id: string, pms?: PracticeManagementSystem | null, pms_id?: string | null, name?: string | null, breed?: string | null, avatar_url?: string | null, last_appt_time?: number | null, gender?: string | null, fixed_status?: FixedStatus | null, weight?: number | null, birthday?: number | null, is_active?: boolean | null, is_deceased?: boolean | null, pms_created_at?: number | null, created_at: number, updated_at: number, owner?: { __typename?: 'Client', id: string, first_name?: string | null, last_name?: string | null, email?: string | null, phone?: string | null, address?: { __typename?: 'Address', country?: string | null } | null } | null, clinic_species?: { __typename?: 'ClinicSpecies', id: string, pms_id: string, description: string, is_primary: boolean, species: Species, weight_key: string, created_at: number, updated_at: number } | null, clinic?: { __typename?: 'Clinic', id: string } | null, clinic_breed?: { __typename?: 'Breed', id: string, description: string } | null, patient_vaccination_records?: Array<{ __typename?: 'PatientVaccinationRecord', id: string, vaccine_name?: string | null, manufacturer?: string | null, lot_number?: string | null, administered_date?: number | null, due_date?: number | null, rabies_tag?: string | null, is_rabies_vaccine?: boolean | null, is_soc: boolean, is_active: boolean, product?: { __typename?: 'Product', id: string, display_name?: string | null, name: string } | null }> | null, last_appointment?: { __typename?: 'Appointment', clinician?: { __typename?: 'Clinician', name: string, display_name?: string | null } | null } | null }> | null, address?: { __typename?: 'Address', street_a?: string | null, street_b?: string | null, city?: string | null, state?: string | null, zip?: string | null, country?: string | null } | null, user?: { __typename?: 'User', avatar_url?: string | null } | null, loyalty_members?: Array<{ __typename?: 'LoyaltyMember', id: string, available_points: number } | null> | null, settings?: { __typename?: 'ClientSettings', clinic_chckup_notifications_enabled: boolean, clinic_chckup_sms_enabled: boolean, clinic_chckup_email_enabled: boolean, client_chckup_notifications_enabled: boolean, client_chckup_sms_enabled: boolean, client_chckup_email_enabled: boolean, is_unsubscribed_from_marketing: boolean, is_unsubscribed_from_marketing_sms: boolean, is_unsubscribed_from_marketing_email: boolean } | null, last_appointment?: { __typename?: 'Appointment', clinician?: { __typename?: 'Clinician', name: string, display_name?: string | null } | null } | null } | null, clinician?: { __typename?: 'Clinician', id: string, name: string, display_name?: string | null, bio?: string | null, avatar_url?: string | null, initials?: string | null, excluded_species?: Array<Species> | null, excluded_service_ids?: Array<string> | null, authority_level?: AuthorityLevel | null, type: ResourceType, is_active?: boolean | null, is_assignable_in_pms?: boolean | null, does_contribute_to_fill_rate?: boolean | null, pms_id?: string | null, location?: string | null, pms_is_active: boolean, valid_booking_interval_minutes?: Array<number> | null, created_at: number, updated_at: number, clinic?: { __typename?: 'Clinic', id: string, name?: string | null } | null, pms_db?: { __typename?: 'PmsDb', id: string } | null, hours?: { __typename?: 'AvailabilityHours', monday?: Array<{ __typename?: 'TimeInterval', start?: number | null, end?: number | null }> | null, tuesday?: Array<{ __typename?: 'TimeInterval', start?: number | null, end?: number | null }> | null, wednesday?: Array<{ __typename?: 'TimeInterval', start?: number | null, end?: number | null }> | null, thursday?: Array<{ __typename?: 'TimeInterval', start?: number | null, end?: number | null }> | null, friday?: Array<{ __typename?: 'TimeInterval', start?: number | null, end?: number | null }> | null, saturday?: Array<{ __typename?: 'TimeInterval', start?: number | null, end?: number | null }> | null, sunday?: Array<{ __typename?: 'TimeInterval', start?: number | null, end?: number | null }> | null } | null, adjusted_availability?: Array<{ __typename?: 'Availability', date: number, pms_appt_type_pms_id?: string | null, times: Array<{ __typename?: 'TimeInterval', start?: number | null, end?: number | null }>, repeat?: { __typename?: 'RepeatAvailability', daysOfMonth?: Array<number> | null, daysOfWeek?: Array<DayOfWeek> | null, weekOfMonth?: WeekOfMonth | null, frequency: any, unit: RepeatUnit, end_date?: number | null } | null }> | null, pms_adjusted_availability?: Array<{ __typename?: 'Availability', date: number, pms_appt_type_pms_id?: string | null, times: Array<{ __typename?: 'TimeInterval', start?: number | null, end?: number | null }>, repeat?: { __typename?: 'RepeatAvailability', daysOfMonth?: Array<number> | null, daysOfWeek?: Array<DayOfWeek> | null, weekOfMonth?: WeekOfMonth | null, frequency: any, unit: RepeatUnit, end_date?: number | null } | null }> | null } | null, room?: { __typename?: 'Room', id: string, pms_id: string, name: string, display_name?: string | null, description?: string | null, concurrent_patients?: number | null, is_active: boolean, does_contribute_to_fill_rate?: boolean | null, valid_booking_interval_minutes?: Array<number> | null, created_at: number, updated_at: number, clinic?: { __typename?: 'Clinic', pms: PracticeManagementSystem, id: string, name?: string | null, time_zone?: string | null } | null, hours?: { __typename?: 'AvailabilityHours', monday?: Array<{ __typename?: 'TimeInterval', start?: number | null, end?: number | null }> | null, tuesday?: Array<{ __typename?: 'TimeInterval', start?: number | null, end?: number | null }> | null, wednesday?: Array<{ __typename?: 'TimeInterval', start?: number | null, end?: number | null }> | null, thursday?: Array<{ __typename?: 'TimeInterval', start?: number | null, end?: number | null }> | null, friday?: Array<{ __typename?: 'TimeInterval', start?: number | null, end?: number | null }> | null, saturday?: Array<{ __typename?: 'TimeInterval', start?: number | null, end?: number | null }> | null, sunday?: Array<{ __typename?: 'TimeInterval', start?: number | null, end?: number | null }> | null } | null, adjusted_availability?: Array<{ __typename?: 'Availability', date: number, pms_appt_type_pms_id?: string | null, times: Array<{ __typename?: 'TimeInterval', start?: number | null, end?: number | null }>, repeat?: { __typename?: 'RepeatAvailability', daysOfMonth?: Array<number> | null, daysOfWeek?: Array<DayOfWeek> | null, weekOfMonth?: WeekOfMonth | null, frequency: any, unit: RepeatUnit, end_date?: number | null } | null }> | null, pms_adjusted_availability?: Array<{ __typename?: 'Availability', date: number, pms_appt_type_pms_id?: string | null, times: Array<{ __typename?: 'TimeInterval', start?: number | null, end?: number | null }>, repeat?: { __typename?: 'RepeatAvailability', daysOfMonth?: Array<number> | null, daysOfWeek?: Array<DayOfWeek> | null, weekOfMonth?: WeekOfMonth | null, frequency: any, unit: RepeatUnit, end_date?: number | null } | null }> | null } | null, service?: { __typename?: 'Service', id: string, name?: string | null, color?: string | null } | null, patient?: { __typename?: 'Patient', id: string, pms?: PracticeManagementSystem | null, pms_id?: string | null, name?: string | null, breed?: string | null, avatar_url?: string | null, last_appt_time?: number | null, gender?: string | null, fixed_status?: FixedStatus | null, weight?: number | null, birthday?: number | null, is_active?: boolean | null, is_deceased?: boolean | null, pms_created_at?: number | null, created_at: number, updated_at: number, owner?: { __typename?: 'Client', id: string, first_name?: string | null, last_name?: string | null, email?: string | null, phone?: string | null, address?: { __typename?: 'Address', country?: string | null } | null } | null, clinic_species?: { __typename?: 'ClinicSpecies', id: string, pms_id: string, description: string, is_primary: boolean, species: Species, weight_key: string, created_at: number, updated_at: number } | null, clinic?: { __typename?: 'Clinic', id: string } | null, clinic_breed?: { __typename?: 'Breed', id: string, description: string } | null, patient_vaccination_records?: Array<{ __typename?: 'PatientVaccinationRecord', id: string, vaccine_name?: string | null, manufacturer?: string | null, lot_number?: string | null, administered_date?: number | null, due_date?: number | null, rabies_tag?: string | null, is_rabies_vaccine?: boolean | null, is_soc: boolean, is_active: boolean, product?: { __typename?: 'Product', id: string, display_name?: string | null, name: string } | null }> | null, last_appointment?: { __typename?: 'Appointment', clinician?: { __typename?: 'Clinician', name: string, display_name?: string | null } | null } | null } | null, clinic_appt_status?: { __typename?: 'ClinicApptStatus', id: string, description: string, status: AppointmentStatus } | null, client_info?: { __typename?: 'ClientInfo', first_name?: string | null, last_name?: string | null, email?: string | null, phone?: string | null } | null, patient_info?: { __typename?: 'PatientInfo', patient_name?: string | null, patient_breed?: string | null, patient_clinic_species?: string | null, patient_clinic_breed?: string | null } | null, clients_forms?: Array<{ __typename?: 'ClientForm', id: string, client_completed_at?: number | null, clinic_verified_at?: number | null, is_archived: boolean, pms_id?: string | null, created_at: number, updated_at: number, client?: { __typename?: 'Client', id: string, first_name?: string | null, last_name?: string | null, phone?: string | null, email?: string | null, address?: { __typename?: 'Address', street_a?: string | null, city?: string | null, state?: string | null, zip?: string | null, country?: string | null } | null } | null, patient?: { __typename?: 'Patient', id: string, name?: string | null, is_active?: boolean | null, is_deceased?: boolean | null, birthday?: number | null, weight?: number | null, avatar_url?: string | null, gender?: string | null, owner?: { __typename?: 'Client', first_name?: string | null, last_name?: string | null } | null, clinic_species?: { __typename?: 'ClinicSpecies', id: string, species: Species, description: string, weight_key: string } | null, clinic_breed?: { __typename?: 'Breed', id: string, description: string } | null } | null, form: { __typename?: 'Form', id: string, name?: string | null, form_type: FormType, is_writeback_enabled: boolean, form_file_naming_template?: string | null }, form_data: { __typename?: 'FormFields', pages?: Array<{ __typename?: 'FormPage', id: string, title?: string | null, description?: string | null, order?: number | null }> | null, fields?: Array<{ __typename?: 'FormElement', id: string, type?: FormElementType | null, content?: string | null, name?: string | null, column_order?: number | null, row_order?: number | null, page_id?: string | null, options?: Array<string> | null, is_required?: boolean | null, value?: string | null, attachments?: Array<{ __typename?: 'FormFileAttachment', id?: string | null, filename?: string | null, mime_type?: string | null, size_bytes?: number | null, thumbnail_url?: string | null, url: string }> | null, field_updates?: Array<{ __typename?: 'FormFieldUpdate', field: FormFieldUpdateField, boolean_value?: boolean | null, option?: string | null }> | null }> | null }, appointment?: { __typename?: 'Appointment', start_time: number, drop_off_time?: number | null, clinic?: { __typename?: 'Clinic', name?: string | null, slug?: string | null, phone?: string | null, email?: string | null, address?: { __typename?: 'Address', street_a?: string | null, city?: string | null, state?: string | null, zip?: string | null, country?: string | null } | null } | null, clinician?: { __typename?: 'Clinician', name: string, display_name?: string | null } | null, service?: { __typename?: 'Service', name?: string | null } | null } | null }> | null, widget?: { __typename?: 'Widget', id: string, widget_name: string } | null }, requested_clinician?: { __typename?: 'Clinician', id: string, name: string } | null, original_clinician?: { __typename?: 'Clinician', id: string, name: string } | null }> };

export type UpdateRescheduleMutationVariables = Exact<{
  id: Scalars['ID']['input'];
  data: UpdateRescheduleInput;
}>;


export type UpdateRescheduleMutation = { __typename?: 'Mutation', updateReschedule: { __typename?: 'Reschedule', id: string, requested_start_time?: number | null, original_start_time?: number | null, clinic_notes?: string | null, client_notes?: string | null, reason_for_denial?: string | null, status: RescheduleStatus, initiated_by: RescheduleInitiatedBy, confirmed_at?: number | null, created_at: number, updated_at: number, appointment: { __typename?: 'Appointment', id: string, pms?: PracticeManagementSystem | null, client_pms_id?: string | null, is_new_client?: boolean | null, start_time: number, drop_off_time?: number | null, minutes: number, is_new_patient?: boolean | null, is_clinician_auto_assigned?: boolean | null, patient_pms_id?: string | null, referring_clinic_name?: string | null, client_notes?: string | null, clinic_notes?: string | null, service_name?: string | null, status: AppointmentStatus, is_time_block?: boolean | null, is_confirmed?: boolean | null, origin?: EntityOrigin | null, reason_for_cancellation?: string | null, client_reason_for_cancellation?: string | null, new_client_name?: string | null, new_client_phone?: string | null, new_patient_name?: string | null, new_patient_species?: string | null, confirmed_at?: number | null, widget_source?: string | null, from_widget?: string | null, is_deleted?: boolean | null, created_at: number, updated_at: number, pms_created_at?: number | null, clinic?: { __typename?: 'Clinic', id: string, name?: string | null, slug?: string | null, pms_db?: { __typename?: 'PmsDb', id: string } | null, address?: { __typename?: 'Address', country?: string | null } | null } | null, client?: { __typename?: 'Client', id: string, first_name?: string | null, last_name?: string | null, secondary_first_name?: string | null, secondary_last_name?: string | null, phone?: string | null, email?: string | null, pms?: PracticeManagementSystem | null, pms_id?: string | null, last_appt_time?: number | null, last_contact_time?: number | null, email_enabled: boolean, sms_enabled: boolean, balance?: number | null, is_active?: boolean | null, is_unsubscribed: boolean, created_at: number, updated_at: number, client_phones?: Array<{ __typename?: 'ClientPhone', id: string, phone: string, country_code?: string | null, is_primary: boolean, is_chckup_primary: boolean, is_mobile: boolean, sms_available: boolean, is_unsubscribed: boolean, is_active: boolean, name?: string | null }> | null, client_emails?: Array<{ __typename?: 'ClientEmail', id: string, email: string, is_primary: boolean }> | null, clinic?: { __typename?: 'Clinic', id: string } | null, patients?: Array<{ __typename?: 'Patient', id: string, pms?: PracticeManagementSystem | null, pms_id?: string | null, name?: string | null, breed?: string | null, avatar_url?: string | null, last_appt_time?: number | null, gender?: string | null, fixed_status?: FixedStatus | null, weight?: number | null, birthday?: number | null, is_active?: boolean | null, is_deceased?: boolean | null, pms_created_at?: number | null, created_at: number, updated_at: number, owner?: { __typename?: 'Client', id: string, first_name?: string | null, last_name?: string | null, email?: string | null, phone?: string | null, address?: { __typename?: 'Address', country?: string | null } | null } | null, clinic_species?: { __typename?: 'ClinicSpecies', id: string, pms_id: string, description: string, is_primary: boolean, species: Species, weight_key: string, created_at: number, updated_at: number } | null, clinic?: { __typename?: 'Clinic', id: string } | null, clinic_breed?: { __typename?: 'Breed', id: string, description: string } | null, patient_vaccination_records?: Array<{ __typename?: 'PatientVaccinationRecord', id: string, vaccine_name?: string | null, manufacturer?: string | null, lot_number?: string | null, administered_date?: number | null, due_date?: number | null, rabies_tag?: string | null, is_rabies_vaccine?: boolean | null, is_soc: boolean, is_active: boolean, product?: { __typename?: 'Product', id: string, display_name?: string | null, name: string } | null }> | null, last_appointment?: { __typename?: 'Appointment', clinician?: { __typename?: 'Clinician', name: string, display_name?: string | null } | null } | null }> | null, address?: { __typename?: 'Address', street_a?: string | null, street_b?: string | null, city?: string | null, state?: string | null, zip?: string | null, country?: string | null } | null, user?: { __typename?: 'User', avatar_url?: string | null } | null, loyalty_members?: Array<{ __typename?: 'LoyaltyMember', id: string, available_points: number } | null> | null, settings?: { __typename?: 'ClientSettings', clinic_chckup_notifications_enabled: boolean, clinic_chckup_sms_enabled: boolean, clinic_chckup_email_enabled: boolean, client_chckup_notifications_enabled: boolean, client_chckup_sms_enabled: boolean, client_chckup_email_enabled: boolean, is_unsubscribed_from_marketing: boolean, is_unsubscribed_from_marketing_sms: boolean, is_unsubscribed_from_marketing_email: boolean } | null, last_appointment?: { __typename?: 'Appointment', clinician?: { __typename?: 'Clinician', name: string, display_name?: string | null } | null } | null } | null, clinician?: { __typename?: 'Clinician', id: string, name: string, display_name?: string | null, bio?: string | null, avatar_url?: string | null, initials?: string | null, excluded_species?: Array<Species> | null, excluded_service_ids?: Array<string> | null, authority_level?: AuthorityLevel | null, type: ResourceType, is_active?: boolean | null, is_assignable_in_pms?: boolean | null, does_contribute_to_fill_rate?: boolean | null, pms_id?: string | null, location?: string | null, pms_is_active: boolean, valid_booking_interval_minutes?: Array<number> | null, created_at: number, updated_at: number, clinic?: { __typename?: 'Clinic', id: string, name?: string | null } | null, pms_db?: { __typename?: 'PmsDb', id: string } | null, hours?: { __typename?: 'AvailabilityHours', monday?: Array<{ __typename?: 'TimeInterval', start?: number | null, end?: number | null }> | null, tuesday?: Array<{ __typename?: 'TimeInterval', start?: number | null, end?: number | null }> | null, wednesday?: Array<{ __typename?: 'TimeInterval', start?: number | null, end?: number | null }> | null, thursday?: Array<{ __typename?: 'TimeInterval', start?: number | null, end?: number | null }> | null, friday?: Array<{ __typename?: 'TimeInterval', start?: number | null, end?: number | null }> | null, saturday?: Array<{ __typename?: 'TimeInterval', start?: number | null, end?: number | null }> | null, sunday?: Array<{ __typename?: 'TimeInterval', start?: number | null, end?: number | null }> | null } | null, adjusted_availability?: Array<{ __typename?: 'Availability', date: number, pms_appt_type_pms_id?: string | null, times: Array<{ __typename?: 'TimeInterval', start?: number | null, end?: number | null }>, repeat?: { __typename?: 'RepeatAvailability', daysOfMonth?: Array<number> | null, daysOfWeek?: Array<DayOfWeek> | null, weekOfMonth?: WeekOfMonth | null, frequency: any, unit: RepeatUnit, end_date?: number | null } | null }> | null, pms_adjusted_availability?: Array<{ __typename?: 'Availability', date: number, pms_appt_type_pms_id?: string | null, times: Array<{ __typename?: 'TimeInterval', start?: number | null, end?: number | null }>, repeat?: { __typename?: 'RepeatAvailability', daysOfMonth?: Array<number> | null, daysOfWeek?: Array<DayOfWeek> | null, weekOfMonth?: WeekOfMonth | null, frequency: any, unit: RepeatUnit, end_date?: number | null } | null }> | null } | null, room?: { __typename?: 'Room', id: string, pms_id: string, name: string, display_name?: string | null, description?: string | null, concurrent_patients?: number | null, is_active: boolean, does_contribute_to_fill_rate?: boolean | null, valid_booking_interval_minutes?: Array<number> | null, created_at: number, updated_at: number, clinic?: { __typename?: 'Clinic', pms: PracticeManagementSystem, id: string, name?: string | null, time_zone?: string | null } | null, hours?: { __typename?: 'AvailabilityHours', monday?: Array<{ __typename?: 'TimeInterval', start?: number | null, end?: number | null }> | null, tuesday?: Array<{ __typename?: 'TimeInterval', start?: number | null, end?: number | null }> | null, wednesday?: Array<{ __typename?: 'TimeInterval', start?: number | null, end?: number | null }> | null, thursday?: Array<{ __typename?: 'TimeInterval', start?: number | null, end?: number | null }> | null, friday?: Array<{ __typename?: 'TimeInterval', start?: number | null, end?: number | null }> | null, saturday?: Array<{ __typename?: 'TimeInterval', start?: number | null, end?: number | null }> | null, sunday?: Array<{ __typename?: 'TimeInterval', start?: number | null, end?: number | null }> | null } | null, adjusted_availability?: Array<{ __typename?: 'Availability', date: number, pms_appt_type_pms_id?: string | null, times: Array<{ __typename?: 'TimeInterval', start?: number | null, end?: number | null }>, repeat?: { __typename?: 'RepeatAvailability', daysOfMonth?: Array<number> | null, daysOfWeek?: Array<DayOfWeek> | null, weekOfMonth?: WeekOfMonth | null, frequency: any, unit: RepeatUnit, end_date?: number | null } | null }> | null, pms_adjusted_availability?: Array<{ __typename?: 'Availability', date: number, pms_appt_type_pms_id?: string | null, times: Array<{ __typename?: 'TimeInterval', start?: number | null, end?: number | null }>, repeat?: { __typename?: 'RepeatAvailability', daysOfMonth?: Array<number> | null, daysOfWeek?: Array<DayOfWeek> | null, weekOfMonth?: WeekOfMonth | null, frequency: any, unit: RepeatUnit, end_date?: number | null } | null }> | null } | null, service?: { __typename?: 'Service', id: string, name?: string | null, color?: string | null } | null, patient?: { __typename?: 'Patient', id: string, pms?: PracticeManagementSystem | null, pms_id?: string | null, name?: string | null, breed?: string | null, avatar_url?: string | null, last_appt_time?: number | null, gender?: string | null, fixed_status?: FixedStatus | null, weight?: number | null, birthday?: number | null, is_active?: boolean | null, is_deceased?: boolean | null, pms_created_at?: number | null, created_at: number, updated_at: number, owner?: { __typename?: 'Client', id: string, first_name?: string | null, last_name?: string | null, email?: string | null, phone?: string | null, address?: { __typename?: 'Address', country?: string | null } | null } | null, clinic_species?: { __typename?: 'ClinicSpecies', id: string, pms_id: string, description: string, is_primary: boolean, species: Species, weight_key: string, created_at: number, updated_at: number } | null, clinic?: { __typename?: 'Clinic', id: string } | null, clinic_breed?: { __typename?: 'Breed', id: string, description: string } | null, patient_vaccination_records?: Array<{ __typename?: 'PatientVaccinationRecord', id: string, vaccine_name?: string | null, manufacturer?: string | null, lot_number?: string | null, administered_date?: number | null, due_date?: number | null, rabies_tag?: string | null, is_rabies_vaccine?: boolean | null, is_soc: boolean, is_active: boolean, product?: { __typename?: 'Product', id: string, display_name?: string | null, name: string } | null }> | null, last_appointment?: { __typename?: 'Appointment', clinician?: { __typename?: 'Clinician', name: string, display_name?: string | null } | null } | null } | null, clinic_appt_status?: { __typename?: 'ClinicApptStatus', id: string, description: string, status: AppointmentStatus } | null, client_info?: { __typename?: 'ClientInfo', first_name?: string | null, last_name?: string | null, email?: string | null, phone?: string | null } | null, patient_info?: { __typename?: 'PatientInfo', patient_name?: string | null, patient_breed?: string | null, patient_clinic_species?: string | null, patient_clinic_breed?: string | null } | null, clients_forms?: Array<{ __typename?: 'ClientForm', id: string, client_completed_at?: number | null, clinic_verified_at?: number | null, is_archived: boolean, pms_id?: string | null, created_at: number, updated_at: number, client?: { __typename?: 'Client', id: string, first_name?: string | null, last_name?: string | null, phone?: string | null, email?: string | null, address?: { __typename?: 'Address', street_a?: string | null, city?: string | null, state?: string | null, zip?: string | null, country?: string | null } | null } | null, patient?: { __typename?: 'Patient', id: string, name?: string | null, is_active?: boolean | null, is_deceased?: boolean | null, birthday?: number | null, weight?: number | null, avatar_url?: string | null, gender?: string | null, owner?: { __typename?: 'Client', first_name?: string | null, last_name?: string | null } | null, clinic_species?: { __typename?: 'ClinicSpecies', id: string, species: Species, description: string, weight_key: string } | null, clinic_breed?: { __typename?: 'Breed', id: string, description: string } | null } | null, form: { __typename?: 'Form', id: string, name?: string | null, form_type: FormType, is_writeback_enabled: boolean, form_file_naming_template?: string | null }, form_data: { __typename?: 'FormFields', pages?: Array<{ __typename?: 'FormPage', id: string, title?: string | null, description?: string | null, order?: number | null }> | null, fields?: Array<{ __typename?: 'FormElement', id: string, type?: FormElementType | null, content?: string | null, name?: string | null, column_order?: number | null, row_order?: number | null, page_id?: string | null, options?: Array<string> | null, is_required?: boolean | null, value?: string | null, attachments?: Array<{ __typename?: 'FormFileAttachment', id?: string | null, filename?: string | null, mime_type?: string | null, size_bytes?: number | null, thumbnail_url?: string | null, url: string }> | null, field_updates?: Array<{ __typename?: 'FormFieldUpdate', field: FormFieldUpdateField, boolean_value?: boolean | null, option?: string | null }> | null }> | null }, appointment?: { __typename?: 'Appointment', start_time: number, drop_off_time?: number | null, clinic?: { __typename?: 'Clinic', name?: string | null, slug?: string | null, phone?: string | null, email?: string | null, address?: { __typename?: 'Address', street_a?: string | null, city?: string | null, state?: string | null, zip?: string | null, country?: string | null } | null } | null, clinician?: { __typename?: 'Clinician', name: string, display_name?: string | null } | null, service?: { __typename?: 'Service', name?: string | null } | null } | null }> | null, widget?: { __typename?: 'Widget', id: string, widget_name: string } | null }, requested_clinician?: { __typename?: 'Clinician', id: string, name: string } | null, original_clinician?: { __typename?: 'Clinician', id: string, name: string } | null } };

export type ApproveRescheduleMutationVariables = Exact<{
  id: Scalars['ID']['input'];
  skipSchedulingDateBounds?: InputMaybe<Scalars['Boolean']['input']>;
}>;


export type ApproveRescheduleMutation = { __typename?: 'Mutation', approveReschedule: { __typename?: 'Reschedule', id: string, requested_start_time?: number | null, original_start_time?: number | null, clinic_notes?: string | null, client_notes?: string | null, reason_for_denial?: string | null, status: RescheduleStatus, initiated_by: RescheduleInitiatedBy, confirmed_at?: number | null, created_at: number, updated_at: number, appointment: { __typename?: 'Appointment', id: string, pms?: PracticeManagementSystem | null, client_pms_id?: string | null, is_new_client?: boolean | null, start_time: number, drop_off_time?: number | null, minutes: number, is_new_patient?: boolean | null, is_clinician_auto_assigned?: boolean | null, patient_pms_id?: string | null, referring_clinic_name?: string | null, client_notes?: string | null, clinic_notes?: string | null, service_name?: string | null, status: AppointmentStatus, is_time_block?: boolean | null, is_confirmed?: boolean | null, origin?: EntityOrigin | null, reason_for_cancellation?: string | null, client_reason_for_cancellation?: string | null, new_client_name?: string | null, new_client_phone?: string | null, new_patient_name?: string | null, new_patient_species?: string | null, confirmed_at?: number | null, widget_source?: string | null, from_widget?: string | null, is_deleted?: boolean | null, created_at: number, updated_at: number, pms_created_at?: number | null, clinic?: { __typename?: 'Clinic', id: string, name?: string | null, slug?: string | null, pms_db?: { __typename?: 'PmsDb', id: string } | null, address?: { __typename?: 'Address', country?: string | null } | null } | null, client?: { __typename?: 'Client', id: string, first_name?: string | null, last_name?: string | null, secondary_first_name?: string | null, secondary_last_name?: string | null, phone?: string | null, email?: string | null, pms?: PracticeManagementSystem | null, pms_id?: string | null, last_appt_time?: number | null, last_contact_time?: number | null, email_enabled: boolean, sms_enabled: boolean, balance?: number | null, is_active?: boolean | null, is_unsubscribed: boolean, created_at: number, updated_at: number, client_phones?: Array<{ __typename?: 'ClientPhone', id: string, phone: string, country_code?: string | null, is_primary: boolean, is_chckup_primary: boolean, is_mobile: boolean, sms_available: boolean, is_unsubscribed: boolean, is_active: boolean, name?: string | null }> | null, client_emails?: Array<{ __typename?: 'ClientEmail', id: string, email: string, is_primary: boolean }> | null, clinic?: { __typename?: 'Clinic', id: string } | null, patients?: Array<{ __typename?: 'Patient', id: string, pms?: PracticeManagementSystem | null, pms_id?: string | null, name?: string | null, breed?: string | null, avatar_url?: string | null, last_appt_time?: number | null, gender?: string | null, fixed_status?: FixedStatus | null, weight?: number | null, birthday?: number | null, is_active?: boolean | null, is_deceased?: boolean | null, pms_created_at?: number | null, created_at: number, updated_at: number, owner?: { __typename?: 'Client', id: string, first_name?: string | null, last_name?: string | null, email?: string | null, phone?: string | null, address?: { __typename?: 'Address', country?: string | null } | null } | null, clinic_species?: { __typename?: 'ClinicSpecies', id: string, pms_id: string, description: string, is_primary: boolean, species: Species, weight_key: string, created_at: number, updated_at: number } | null, clinic?: { __typename?: 'Clinic', id: string } | null, clinic_breed?: { __typename?: 'Breed', id: string, description: string } | null, patient_vaccination_records?: Array<{ __typename?: 'PatientVaccinationRecord', id: string, vaccine_name?: string | null, manufacturer?: string | null, lot_number?: string | null, administered_date?: number | null, due_date?: number | null, rabies_tag?: string | null, is_rabies_vaccine?: boolean | null, is_soc: boolean, is_active: boolean, product?: { __typename?: 'Product', id: string, display_name?: string | null, name: string } | null }> | null, last_appointment?: { __typename?: 'Appointment', clinician?: { __typename?: 'Clinician', name: string, display_name?: string | null } | null } | null }> | null, address?: { __typename?: 'Address', street_a?: string | null, street_b?: string | null, city?: string | null, state?: string | null, zip?: string | null, country?: string | null } | null, user?: { __typename?: 'User', avatar_url?: string | null } | null, loyalty_members?: Array<{ __typename?: 'LoyaltyMember', id: string, available_points: number } | null> | null, settings?: { __typename?: 'ClientSettings', clinic_chckup_notifications_enabled: boolean, clinic_chckup_sms_enabled: boolean, clinic_chckup_email_enabled: boolean, client_chckup_notifications_enabled: boolean, client_chckup_sms_enabled: boolean, client_chckup_email_enabled: boolean, is_unsubscribed_from_marketing: boolean, is_unsubscribed_from_marketing_sms: boolean, is_unsubscribed_from_marketing_email: boolean } | null, last_appointment?: { __typename?: 'Appointment', clinician?: { __typename?: 'Clinician', name: string, display_name?: string | null } | null } | null } | null, clinician?: { __typename?: 'Clinician', id: string, name: string, display_name?: string | null, bio?: string | null, avatar_url?: string | null, initials?: string | null, excluded_species?: Array<Species> | null, excluded_service_ids?: Array<string> | null, authority_level?: AuthorityLevel | null, type: ResourceType, is_active?: boolean | null, is_assignable_in_pms?: boolean | null, does_contribute_to_fill_rate?: boolean | null, pms_id?: string | null, location?: string | null, pms_is_active: boolean, valid_booking_interval_minutes?: Array<number> | null, created_at: number, updated_at: number, clinic?: { __typename?: 'Clinic', id: string, name?: string | null } | null, pms_db?: { __typename?: 'PmsDb', id: string } | null, hours?: { __typename?: 'AvailabilityHours', monday?: Array<{ __typename?: 'TimeInterval', start?: number | null, end?: number | null }> | null, tuesday?: Array<{ __typename?: 'TimeInterval', start?: number | null, end?: number | null }> | null, wednesday?: Array<{ __typename?: 'TimeInterval', start?: number | null, end?: number | null }> | null, thursday?: Array<{ __typename?: 'TimeInterval', start?: number | null, end?: number | null }> | null, friday?: Array<{ __typename?: 'TimeInterval', start?: number | null, end?: number | null }> | null, saturday?: Array<{ __typename?: 'TimeInterval', start?: number | null, end?: number | null }> | null, sunday?: Array<{ __typename?: 'TimeInterval', start?: number | null, end?: number | null }> | null } | null, adjusted_availability?: Array<{ __typename?: 'Availability', date: number, pms_appt_type_pms_id?: string | null, times: Array<{ __typename?: 'TimeInterval', start?: number | null, end?: number | null }>, repeat?: { __typename?: 'RepeatAvailability', daysOfMonth?: Array<number> | null, daysOfWeek?: Array<DayOfWeek> | null, weekOfMonth?: WeekOfMonth | null, frequency: any, unit: RepeatUnit, end_date?: number | null } | null }> | null, pms_adjusted_availability?: Array<{ __typename?: 'Availability', date: number, pms_appt_type_pms_id?: string | null, times: Array<{ __typename?: 'TimeInterval', start?: number | null, end?: number | null }>, repeat?: { __typename?: 'RepeatAvailability', daysOfMonth?: Array<number> | null, daysOfWeek?: Array<DayOfWeek> | null, weekOfMonth?: WeekOfMonth | null, frequency: any, unit: RepeatUnit, end_date?: number | null } | null }> | null } | null, room?: { __typename?: 'Room', id: string, pms_id: string, name: string, display_name?: string | null, description?: string | null, concurrent_patients?: number | null, is_active: boolean, does_contribute_to_fill_rate?: boolean | null, valid_booking_interval_minutes?: Array<number> | null, created_at: number, updated_at: number, clinic?: { __typename?: 'Clinic', pms: PracticeManagementSystem, id: string, name?: string | null, time_zone?: string | null } | null, hours?: { __typename?: 'AvailabilityHours', monday?: Array<{ __typename?: 'TimeInterval', start?: number | null, end?: number | null }> | null, tuesday?: Array<{ __typename?: 'TimeInterval', start?: number | null, end?: number | null }> | null, wednesday?: Array<{ __typename?: 'TimeInterval', start?: number | null, end?: number | null }> | null, thursday?: Array<{ __typename?: 'TimeInterval', start?: number | null, end?: number | null }> | null, friday?: Array<{ __typename?: 'TimeInterval', start?: number | null, end?: number | null }> | null, saturday?: Array<{ __typename?: 'TimeInterval', start?: number | null, end?: number | null }> | null, sunday?: Array<{ __typename?: 'TimeInterval', start?: number | null, end?: number | null }> | null } | null, adjusted_availability?: Array<{ __typename?: 'Availability', date: number, pms_appt_type_pms_id?: string | null, times: Array<{ __typename?: 'TimeInterval', start?: number | null, end?: number | null }>, repeat?: { __typename?: 'RepeatAvailability', daysOfMonth?: Array<number> | null, daysOfWeek?: Array<DayOfWeek> | null, weekOfMonth?: WeekOfMonth | null, frequency: any, unit: RepeatUnit, end_date?: number | null } | null }> | null, pms_adjusted_availability?: Array<{ __typename?: 'Availability', date: number, pms_appt_type_pms_id?: string | null, times: Array<{ __typename?: 'TimeInterval', start?: number | null, end?: number | null }>, repeat?: { __typename?: 'RepeatAvailability', daysOfMonth?: Array<number> | null, daysOfWeek?: Array<DayOfWeek> | null, weekOfMonth?: WeekOfMonth | null, frequency: any, unit: RepeatUnit, end_date?: number | null } | null }> | null } | null, service?: { __typename?: 'Service', id: string, name?: string | null, color?: string | null } | null, patient?: { __typename?: 'Patient', id: string, pms?: PracticeManagementSystem | null, pms_id?: string | null, name?: string | null, breed?: string | null, avatar_url?: string | null, last_appt_time?: number | null, gender?: string | null, fixed_status?: FixedStatus | null, weight?: number | null, birthday?: number | null, is_active?: boolean | null, is_deceased?: boolean | null, pms_created_at?: number | null, created_at: number, updated_at: number, owner?: { __typename?: 'Client', id: string, first_name?: string | null, last_name?: string | null, email?: string | null, phone?: string | null, address?: { __typename?: 'Address', country?: string | null } | null } | null, clinic_species?: { __typename?: 'ClinicSpecies', id: string, pms_id: string, description: string, is_primary: boolean, species: Species, weight_key: string, created_at: number, updated_at: number } | null, clinic?: { __typename?: 'Clinic', id: string } | null, clinic_breed?: { __typename?: 'Breed', id: string, description: string } | null, patient_vaccination_records?: Array<{ __typename?: 'PatientVaccinationRecord', id: string, vaccine_name?: string | null, manufacturer?: string | null, lot_number?: string | null, administered_date?: number | null, due_date?: number | null, rabies_tag?: string | null, is_rabies_vaccine?: boolean | null, is_soc: boolean, is_active: boolean, product?: { __typename?: 'Product', id: string, display_name?: string | null, name: string } | null }> | null, last_appointment?: { __typename?: 'Appointment', clinician?: { __typename?: 'Clinician', name: string, display_name?: string | null } | null } | null } | null, clinic_appt_status?: { __typename?: 'ClinicApptStatus', id: string, description: string, status: AppointmentStatus } | null, client_info?: { __typename?: 'ClientInfo', first_name?: string | null, last_name?: string | null, email?: string | null, phone?: string | null } | null, patient_info?: { __typename?: 'PatientInfo', patient_name?: string | null, patient_breed?: string | null, patient_clinic_species?: string | null, patient_clinic_breed?: string | null } | null, clients_forms?: Array<{ __typename?: 'ClientForm', id: string, client_completed_at?: number | null, clinic_verified_at?: number | null, is_archived: boolean, pms_id?: string | null, created_at: number, updated_at: number, client?: { __typename?: 'Client', id: string, first_name?: string | null, last_name?: string | null, phone?: string | null, email?: string | null, address?: { __typename?: 'Address', street_a?: string | null, city?: string | null, state?: string | null, zip?: string | null, country?: string | null } | null } | null, patient?: { __typename?: 'Patient', id: string, name?: string | null, is_active?: boolean | null, is_deceased?: boolean | null, birthday?: number | null, weight?: number | null, avatar_url?: string | null, gender?: string | null, owner?: { __typename?: 'Client', first_name?: string | null, last_name?: string | null } | null, clinic_species?: { __typename?: 'ClinicSpecies', id: string, species: Species, description: string, weight_key: string } | null, clinic_breed?: { __typename?: 'Breed', id: string, description: string } | null } | null, form: { __typename?: 'Form', id: string, name?: string | null, form_type: FormType, is_writeback_enabled: boolean, form_file_naming_template?: string | null }, form_data: { __typename?: 'FormFields', pages?: Array<{ __typename?: 'FormPage', id: string, title?: string | null, description?: string | null, order?: number | null }> | null, fields?: Array<{ __typename?: 'FormElement', id: string, type?: FormElementType | null, content?: string | null, name?: string | null, column_order?: number | null, row_order?: number | null, page_id?: string | null, options?: Array<string> | null, is_required?: boolean | null, value?: string | null, attachments?: Array<{ __typename?: 'FormFileAttachment', id?: string | null, filename?: string | null, mime_type?: string | null, size_bytes?: number | null, thumbnail_url?: string | null, url: string }> | null, field_updates?: Array<{ __typename?: 'FormFieldUpdate', field: FormFieldUpdateField, boolean_value?: boolean | null, option?: string | null }> | null }> | null }, appointment?: { __typename?: 'Appointment', start_time: number, drop_off_time?: number | null, clinic?: { __typename?: 'Clinic', name?: string | null, slug?: string | null, phone?: string | null, email?: string | null, address?: { __typename?: 'Address', street_a?: string | null, city?: string | null, state?: string | null, zip?: string | null, country?: string | null } | null } | null, clinician?: { __typename?: 'Clinician', name: string, display_name?: string | null } | null, service?: { __typename?: 'Service', name?: string | null } | null } | null }> | null, widget?: { __typename?: 'Widget', id: string, widget_name: string } | null }, requested_clinician?: { __typename?: 'Clinician', id: string, name: string } | null, original_clinician?: { __typename?: 'Clinician', id: string, name: string } | null } };

export type DenyRescheduleMutationVariables = Exact<{
  id: Scalars['ID']['input'];
  reason: Scalars['String']['input'];
}>;


export type DenyRescheduleMutation = { __typename?: 'Mutation', denyReschedule: { __typename?: 'Reschedule', id: string, requested_start_time?: number | null, original_start_time?: number | null, clinic_notes?: string | null, client_notes?: string | null, reason_for_denial?: string | null, status: RescheduleStatus, initiated_by: RescheduleInitiatedBy, confirmed_at?: number | null, created_at: number, updated_at: number, appointment: { __typename?: 'Appointment', id: string, pms?: PracticeManagementSystem | null, client_pms_id?: string | null, is_new_client?: boolean | null, start_time: number, drop_off_time?: number | null, minutes: number, is_new_patient?: boolean | null, is_clinician_auto_assigned?: boolean | null, patient_pms_id?: string | null, referring_clinic_name?: string | null, client_notes?: string | null, clinic_notes?: string | null, service_name?: string | null, status: AppointmentStatus, is_time_block?: boolean | null, is_confirmed?: boolean | null, origin?: EntityOrigin | null, reason_for_cancellation?: string | null, client_reason_for_cancellation?: string | null, new_client_name?: string | null, new_client_phone?: string | null, new_patient_name?: string | null, new_patient_species?: string | null, confirmed_at?: number | null, widget_source?: string | null, from_widget?: string | null, is_deleted?: boolean | null, created_at: number, updated_at: number, pms_created_at?: number | null, clinic?: { __typename?: 'Clinic', id: string, name?: string | null, slug?: string | null, pms_db?: { __typename?: 'PmsDb', id: string } | null, address?: { __typename?: 'Address', country?: string | null } | null } | null, client?: { __typename?: 'Client', id: string, first_name?: string | null, last_name?: string | null, secondary_first_name?: string | null, secondary_last_name?: string | null, phone?: string | null, email?: string | null, pms?: PracticeManagementSystem | null, pms_id?: string | null, last_appt_time?: number | null, last_contact_time?: number | null, email_enabled: boolean, sms_enabled: boolean, balance?: number | null, is_active?: boolean | null, is_unsubscribed: boolean, created_at: number, updated_at: number, client_phones?: Array<{ __typename?: 'ClientPhone', id: string, phone: string, country_code?: string | null, is_primary: boolean, is_chckup_primary: boolean, is_mobile: boolean, sms_available: boolean, is_unsubscribed: boolean, is_active: boolean, name?: string | null }> | null, client_emails?: Array<{ __typename?: 'ClientEmail', id: string, email: string, is_primary: boolean }> | null, clinic?: { __typename?: 'Clinic', id: string } | null, patients?: Array<{ __typename?: 'Patient', id: string, pms?: PracticeManagementSystem | null, pms_id?: string | null, name?: string | null, breed?: string | null, avatar_url?: string | null, last_appt_time?: number | null, gender?: string | null, fixed_status?: FixedStatus | null, weight?: number | null, birthday?: number | null, is_active?: boolean | null, is_deceased?: boolean | null, pms_created_at?: number | null, created_at: number, updated_at: number, owner?: { __typename?: 'Client', id: string, first_name?: string | null, last_name?: string | null, email?: string | null, phone?: string | null, address?: { __typename?: 'Address', country?: string | null } | null } | null, clinic_species?: { __typename?: 'ClinicSpecies', id: string, pms_id: string, description: string, is_primary: boolean, species: Species, weight_key: string, created_at: number, updated_at: number } | null, clinic?: { __typename?: 'Clinic', id: string } | null, clinic_breed?: { __typename?: 'Breed', id: string, description: string } | null, patient_vaccination_records?: Array<{ __typename?: 'PatientVaccinationRecord', id: string, vaccine_name?: string | null, manufacturer?: string | null, lot_number?: string | null, administered_date?: number | null, due_date?: number | null, rabies_tag?: string | null, is_rabies_vaccine?: boolean | null, is_soc: boolean, is_active: boolean, product?: { __typename?: 'Product', id: string, display_name?: string | null, name: string } | null }> | null, last_appointment?: { __typename?: 'Appointment', clinician?: { __typename?: 'Clinician', name: string, display_name?: string | null } | null } | null }> | null, address?: { __typename?: 'Address', street_a?: string | null, street_b?: string | null, city?: string | null, state?: string | null, zip?: string | null, country?: string | null } | null, user?: { __typename?: 'User', avatar_url?: string | null } | null, loyalty_members?: Array<{ __typename?: 'LoyaltyMember', id: string, available_points: number } | null> | null, settings?: { __typename?: 'ClientSettings', clinic_chckup_notifications_enabled: boolean, clinic_chckup_sms_enabled: boolean, clinic_chckup_email_enabled: boolean, client_chckup_notifications_enabled: boolean, client_chckup_sms_enabled: boolean, client_chckup_email_enabled: boolean, is_unsubscribed_from_marketing: boolean, is_unsubscribed_from_marketing_sms: boolean, is_unsubscribed_from_marketing_email: boolean } | null, last_appointment?: { __typename?: 'Appointment', clinician?: { __typename?: 'Clinician', name: string, display_name?: string | null } | null } | null } | null, clinician?: { __typename?: 'Clinician', id: string, name: string, display_name?: string | null, bio?: string | null, avatar_url?: string | null, initials?: string | null, excluded_species?: Array<Species> | null, excluded_service_ids?: Array<string> | null, authority_level?: AuthorityLevel | null, type: ResourceType, is_active?: boolean | null, is_assignable_in_pms?: boolean | null, does_contribute_to_fill_rate?: boolean | null, pms_id?: string | null, location?: string | null, pms_is_active: boolean, valid_booking_interval_minutes?: Array<number> | null, created_at: number, updated_at: number, clinic?: { __typename?: 'Clinic', id: string, name?: string | null } | null, pms_db?: { __typename?: 'PmsDb', id: string } | null, hours?: { __typename?: 'AvailabilityHours', monday?: Array<{ __typename?: 'TimeInterval', start?: number | null, end?: number | null }> | null, tuesday?: Array<{ __typename?: 'TimeInterval', start?: number | null, end?: number | null }> | null, wednesday?: Array<{ __typename?: 'TimeInterval', start?: number | null, end?: number | null }> | null, thursday?: Array<{ __typename?: 'TimeInterval', start?: number | null, end?: number | null }> | null, friday?: Array<{ __typename?: 'TimeInterval', start?: number | null, end?: number | null }> | null, saturday?: Array<{ __typename?: 'TimeInterval', start?: number | null, end?: number | null }> | null, sunday?: Array<{ __typename?: 'TimeInterval', start?: number | null, end?: number | null }> | null } | null, adjusted_availability?: Array<{ __typename?: 'Availability', date: number, pms_appt_type_pms_id?: string | null, times: Array<{ __typename?: 'TimeInterval', start?: number | null, end?: number | null }>, repeat?: { __typename?: 'RepeatAvailability', daysOfMonth?: Array<number> | null, daysOfWeek?: Array<DayOfWeek> | null, weekOfMonth?: WeekOfMonth | null, frequency: any, unit: RepeatUnit, end_date?: number | null } | null }> | null, pms_adjusted_availability?: Array<{ __typename?: 'Availability', date: number, pms_appt_type_pms_id?: string | null, times: Array<{ __typename?: 'TimeInterval', start?: number | null, end?: number | null }>, repeat?: { __typename?: 'RepeatAvailability', daysOfMonth?: Array<number> | null, daysOfWeek?: Array<DayOfWeek> | null, weekOfMonth?: WeekOfMonth | null, frequency: any, unit: RepeatUnit, end_date?: number | null } | null }> | null } | null, room?: { __typename?: 'Room', id: string, pms_id: string, name: string, display_name?: string | null, description?: string | null, concurrent_patients?: number | null, is_active: boolean, does_contribute_to_fill_rate?: boolean | null, valid_booking_interval_minutes?: Array<number> | null, created_at: number, updated_at: number, clinic?: { __typename?: 'Clinic', pms: PracticeManagementSystem, id: string, name?: string | null, time_zone?: string | null } | null, hours?: { __typename?: 'AvailabilityHours', monday?: Array<{ __typename?: 'TimeInterval', start?: number | null, end?: number | null }> | null, tuesday?: Array<{ __typename?: 'TimeInterval', start?: number | null, end?: number | null }> | null, wednesday?: Array<{ __typename?: 'TimeInterval', start?: number | null, end?: number | null }> | null, thursday?: Array<{ __typename?: 'TimeInterval', start?: number | null, end?: number | null }> | null, friday?: Array<{ __typename?: 'TimeInterval', start?: number | null, end?: number | null }> | null, saturday?: Array<{ __typename?: 'TimeInterval', start?: number | null, end?: number | null }> | null, sunday?: Array<{ __typename?: 'TimeInterval', start?: number | null, end?: number | null }> | null } | null, adjusted_availability?: Array<{ __typename?: 'Availability', date: number, pms_appt_type_pms_id?: string | null, times: Array<{ __typename?: 'TimeInterval', start?: number | null, end?: number | null }>, repeat?: { __typename?: 'RepeatAvailability', daysOfMonth?: Array<number> | null, daysOfWeek?: Array<DayOfWeek> | null, weekOfMonth?: WeekOfMonth | null, frequency: any, unit: RepeatUnit, end_date?: number | null } | null }> | null, pms_adjusted_availability?: Array<{ __typename?: 'Availability', date: number, pms_appt_type_pms_id?: string | null, times: Array<{ __typename?: 'TimeInterval', start?: number | null, end?: number | null }>, repeat?: { __typename?: 'RepeatAvailability', daysOfMonth?: Array<number> | null, daysOfWeek?: Array<DayOfWeek> | null, weekOfMonth?: WeekOfMonth | null, frequency: any, unit: RepeatUnit, end_date?: number | null } | null }> | null } | null, service?: { __typename?: 'Service', id: string, name?: string | null, color?: string | null } | null, patient?: { __typename?: 'Patient', id: string, pms?: PracticeManagementSystem | null, pms_id?: string | null, name?: string | null, breed?: string | null, avatar_url?: string | null, last_appt_time?: number | null, gender?: string | null, fixed_status?: FixedStatus | null, weight?: number | null, birthday?: number | null, is_active?: boolean | null, is_deceased?: boolean | null, pms_created_at?: number | null, created_at: number, updated_at: number, owner?: { __typename?: 'Client', id: string, first_name?: string | null, last_name?: string | null, email?: string | null, phone?: string | null, address?: { __typename?: 'Address', country?: string | null } | null } | null, clinic_species?: { __typename?: 'ClinicSpecies', id: string, pms_id: string, description: string, is_primary: boolean, species: Species, weight_key: string, created_at: number, updated_at: number } | null, clinic?: { __typename?: 'Clinic', id: string } | null, clinic_breed?: { __typename?: 'Breed', id: string, description: string } | null, patient_vaccination_records?: Array<{ __typename?: 'PatientVaccinationRecord', id: string, vaccine_name?: string | null, manufacturer?: string | null, lot_number?: string | null, administered_date?: number | null, due_date?: number | null, rabies_tag?: string | null, is_rabies_vaccine?: boolean | null, is_soc: boolean, is_active: boolean, product?: { __typename?: 'Product', id: string, display_name?: string | null, name: string } | null }> | null, last_appointment?: { __typename?: 'Appointment', clinician?: { __typename?: 'Clinician', name: string, display_name?: string | null } | null } | null } | null, clinic_appt_status?: { __typename?: 'ClinicApptStatus', id: string, description: string, status: AppointmentStatus } | null, client_info?: { __typename?: 'ClientInfo', first_name?: string | null, last_name?: string | null, email?: string | null, phone?: string | null } | null, patient_info?: { __typename?: 'PatientInfo', patient_name?: string | null, patient_breed?: string | null, patient_clinic_species?: string | null, patient_clinic_breed?: string | null } | null, clients_forms?: Array<{ __typename?: 'ClientForm', id: string, client_completed_at?: number | null, clinic_verified_at?: number | null, is_archived: boolean, pms_id?: string | null, created_at: number, updated_at: number, client?: { __typename?: 'Client', id: string, first_name?: string | null, last_name?: string | null, phone?: string | null, email?: string | null, address?: { __typename?: 'Address', street_a?: string | null, city?: string | null, state?: string | null, zip?: string | null, country?: string | null } | null } | null, patient?: { __typename?: 'Patient', id: string, name?: string | null, is_active?: boolean | null, is_deceased?: boolean | null, birthday?: number | null, weight?: number | null, avatar_url?: string | null, gender?: string | null, owner?: { __typename?: 'Client', first_name?: string | null, last_name?: string | null } | null, clinic_species?: { __typename?: 'ClinicSpecies', id: string, species: Species, description: string, weight_key: string } | null, clinic_breed?: { __typename?: 'Breed', id: string, description: string } | null } | null, form: { __typename?: 'Form', id: string, name?: string | null, form_type: FormType, is_writeback_enabled: boolean, form_file_naming_template?: string | null }, form_data: { __typename?: 'FormFields', pages?: Array<{ __typename?: 'FormPage', id: string, title?: string | null, description?: string | null, order?: number | null }> | null, fields?: Array<{ __typename?: 'FormElement', id: string, type?: FormElementType | null, content?: string | null, name?: string | null, column_order?: number | null, row_order?: number | null, page_id?: string | null, options?: Array<string> | null, is_required?: boolean | null, value?: string | null, attachments?: Array<{ __typename?: 'FormFileAttachment', id?: string | null, filename?: string | null, mime_type?: string | null, size_bytes?: number | null, thumbnail_url?: string | null, url: string }> | null, field_updates?: Array<{ __typename?: 'FormFieldUpdate', field: FormFieldUpdateField, boolean_value?: boolean | null, option?: string | null }> | null }> | null }, appointment?: { __typename?: 'Appointment', start_time: number, drop_off_time?: number | null, clinic?: { __typename?: 'Clinic', name?: string | null, slug?: string | null, phone?: string | null, email?: string | null, address?: { __typename?: 'Address', street_a?: string | null, city?: string | null, state?: string | null, zip?: string | null, country?: string | null } | null } | null, clinician?: { __typename?: 'Clinician', name: string, display_name?: string | null } | null, service?: { __typename?: 'Service', name?: string | null } | null } | null }> | null, widget?: { __typename?: 'Widget', id: string, widget_name: string } | null }, requested_clinician?: { __typename?: 'Clinician', id: string, name: string } | null, original_clinician?: { __typename?: 'Clinician', id: string, name: string } | null } };

export type ReviewFieldsFragment = { __typename?: 'Review', id: string, description?: string | null, overall_rating: number, is_anonymous?: boolean | null, review_submitted_at?: number | null, review_source: ReviewSource, external_id?: string | null, external_author_name?: string | null, external_author_image?: string | null, external_rating?: number | null, external_text?: string | null, external_timestamp?: number | null, external_review_url?: string | null, external_owner_response?: string | null, external_owner_response_timestamp?: number | null, created_at: number, updated_at: number, client?: { __typename?: 'Client', id: string, first_name?: string | null, last_name?: string | null, email?: string | null, phone?: string | null, address?: { __typename?: 'Address', street_a?: string | null, street_b?: string | null, city?: string | null, state?: string | null, zip?: string | null, country?: string | null } | null } | null, appointment?: { __typename?: 'Appointment', id: string } | null, clinic: { __typename?: 'Clinic', id: string, name?: string | null, address?: { __typename?: 'Address', street_a?: string | null, street_b?: string | null, city?: string | null, state?: string | null, zip?: string | null, country?: string | null } | null, settings?: { __typename?: 'ClinicSettings', review_google_id?: string | null, review_facebook_id?: string | null } | null } };

export type ReviewPreviewFieldsFragment = { __typename?: 'Review', id: string, description?: string | null, overall_rating: number, is_anonymous?: boolean | null, review_source: ReviewSource, created_at: number, client?: { __typename?: 'Client', id: string, first_name?: string | null, last_name?: string | null } | null, appointment?: { __typename?: 'Appointment', id: string, service_name?: string | null, start_time: number } | null };

export type GetReviewsForClinicQueryVariables = Exact<{
  clinicId: Scalars['ID']['input'];
}>;


export type GetReviewsForClinicQuery = { __typename?: 'Query', getReviewsForClinic: Array<{ __typename?: 'Review', id: string, description?: string | null, overall_rating: number, is_anonymous?: boolean | null, review_submitted_at?: number | null, review_source: ReviewSource, external_id?: string | null, external_author_name?: string | null, external_author_image?: string | null, external_rating?: number | null, external_text?: string | null, external_timestamp?: number | null, external_review_url?: string | null, external_owner_response?: string | null, external_owner_response_timestamp?: number | null, created_at: number, updated_at: number, client?: { __typename?: 'Client', id: string, first_name?: string | null, last_name?: string | null, email?: string | null, phone?: string | null, address?: { __typename?: 'Address', street_a?: string | null, street_b?: string | null, city?: string | null, state?: string | null, zip?: string | null, country?: string | null } | null } | null, appointment?: { __typename?: 'Appointment', id: string } | null, clinic: { __typename?: 'Clinic', id: string, name?: string | null, address?: { __typename?: 'Address', street_a?: string | null, street_b?: string | null, city?: string | null, state?: string | null, zip?: string | null, country?: string | null } | null, settings?: { __typename?: 'ClinicSettings', review_google_id?: string | null, review_facebook_id?: string | null } | null } }> };

export type QueryReviewsQueryVariables = Exact<{
  where?: InputMaybe<Array<QueryInput> | QueryInput>;
  page?: InputMaybe<Scalars['NonNegativeInt']['input']>;
  pageSize?: InputMaybe<Scalars['NonNegativeInt']['input']>;
  orderBy?: InputMaybe<OrderByInput>;
}>;


export type QueryReviewsQuery = { __typename?: 'Query', queryReviews: Array<{ __typename?: 'Review', id: string, description?: string | null, overall_rating: number, is_anonymous?: boolean | null, review_submitted_at?: number | null, review_source: ReviewSource, external_id?: string | null, external_author_name?: string | null, external_author_image?: string | null, external_rating?: number | null, external_text?: string | null, external_timestamp?: number | null, external_review_url?: string | null, external_owner_response?: string | null, external_owner_response_timestamp?: number | null, created_at: number, updated_at: number, client?: { __typename?: 'Client', id: string, first_name?: string | null, last_name?: string | null, email?: string | null, phone?: string | null, address?: { __typename?: 'Address', street_a?: string | null, street_b?: string | null, city?: string | null, state?: string | null, zip?: string | null, country?: string | null } | null } | null, appointment?: { __typename?: 'Appointment', id: string } | null, clinic: { __typename?: 'Clinic', id: string, name?: string | null, address?: { __typename?: 'Address', street_a?: string | null, street_b?: string | null, city?: string | null, state?: string | null, zip?: string | null, country?: string | null } | null, settings?: { __typename?: 'ClinicSettings', review_google_id?: string | null, review_facebook_id?: string | null } | null } }> };

export type GetAverageRatingForRecentReviewsQueryVariables = Exact<{
  clinicId: Scalars['ID']['input'];
  maxCount?: InputMaybe<Scalars['PositiveInt']['input']>;
}>;


export type GetAverageRatingForRecentReviewsQuery = { __typename?: 'Query', getAverageRatingForRecentReviews: { __typename?: 'ReviewTotals', count: number, total: number } };

export type GetAverageRatingForRecentReviewsForClinicsQueryVariables = Exact<{
  clinicIds: Array<Scalars['ID']['input']> | Scalars['ID']['input'];
  maxCount?: InputMaybe<Scalars['PositiveInt']['input']>;
}>;


export type GetAverageRatingForRecentReviewsForClinicsQuery = { __typename?: 'Query', getAverageRatingForRecentReviewsForClinics: { __typename?: 'ReviewTotals', count: number, total: number } };

export type CountReviewsQueryVariables = Exact<{
  where?: InputMaybe<Array<QueryInput> | QueryInput>;
}>;


export type CountReviewsQuery = { __typename?: 'Query', countReviews: number };

export type ReviewAnalyticsFieldsFragment = { __typename?: 'ReviewAnalytics', review_count: number, average_rating: number, sources: Array<{ __typename?: 'ReviewSourceStats', review_source: ReviewSource, review_count: number, average_rating: number }>, request_conversion: { __typename?: 'ReviewRequestConversion', clients_requested: number, clients_reviewed: number, conversion_rate: number } };

export type ReviewAnalyticsQueryVariables = Exact<{
  clinicIds: Array<Scalars['ID']['input']> | Scalars['ID']['input'];
}>;


export type ReviewAnalyticsQuery = { __typename?: 'Query', reviewAnalytics: { __typename?: 'ReviewAnalytics', review_count: number, average_rating: number, sources: Array<{ __typename?: 'ReviewSourceStats', review_source: ReviewSource, review_count: number, average_rating: number }>, request_conversion: { __typename?: 'ReviewRequestConversion', clients_requested: number, clients_reviewed: number, conversion_rate: number } } };

export type RoomServiceFieldsFragment = { __typename?: 'RoomService', id: string, duration_override?: number | null, created_at: number, updated_at: number, room: { __typename?: 'Room', id: string, name: string, display_name?: string | null }, service: { __typename?: 'Service', id: string } };

export type GetRoomServicesByServiceQueryVariables = Exact<{
  serviceId: Scalars['ID']['input'];
}>;


export type GetRoomServicesByServiceQuery = { __typename?: 'Query', getRoomServicesByService: Array<{ __typename?: 'RoomService', id: string, duration_override?: number | null, created_at: number, updated_at: number, room: { __typename?: 'Room', id: string, name: string, display_name?: string | null }, service: { __typename?: 'Service', id: string } }> };

export type CreateRoomServiceMutationVariables = Exact<{
  data: CreateRoomServiceInput;
}>;


export type CreateRoomServiceMutation = { __typename?: 'Mutation', createRoomService: { __typename?: 'RoomService', id: string, duration_override?: number | null, created_at: number, updated_at: number, room: { __typename?: 'Room', id: string, name: string, display_name?: string | null }, service: { __typename?: 'Service', id: string } } };

export type UpdateRoomServiceMutationVariables = Exact<{
  id: Scalars['ID']['input'];
  data: UpdateRoomServiceInput;
}>;


export type UpdateRoomServiceMutation = { __typename?: 'Mutation', updateRoomService: { __typename?: 'RoomService', id: string, duration_override?: number | null, created_at: number, updated_at: number, room: { __typename?: 'Room', id: string, name: string, display_name?: string | null }, service: { __typename?: 'Service', id: string } } };

export type DeleteRoomServiceMutationVariables = Exact<{
  id: Scalars['ID']['input'];
}>;


export type DeleteRoomServiceMutation = { __typename?: 'Mutation', deleteRoomService?: any | null };

export type RoomFieldsFragment = { __typename?: 'Room', id: string, pms_id: string, name: string, display_name?: string | null, description?: string | null, concurrent_patients?: number | null, is_active: boolean, does_contribute_to_fill_rate?: boolean | null, valid_booking_interval_minutes?: Array<number> | null, created_at: number, updated_at: number, clinic?: { __typename?: 'Clinic', pms: PracticeManagementSystem, id: string, name?: string | null, time_zone?: string | null } | null, hours?: { __typename?: 'AvailabilityHours', monday?: Array<{ __typename?: 'TimeInterval', start?: number | null, end?: number | null }> | null, tuesday?: Array<{ __typename?: 'TimeInterval', start?: number | null, end?: number | null }> | null, wednesday?: Array<{ __typename?: 'TimeInterval', start?: number | null, end?: number | null }> | null, thursday?: Array<{ __typename?: 'TimeInterval', start?: number | null, end?: number | null }> | null, friday?: Array<{ __typename?: 'TimeInterval', start?: number | null, end?: number | null }> | null, saturday?: Array<{ __typename?: 'TimeInterval', start?: number | null, end?: number | null }> | null, sunday?: Array<{ __typename?: 'TimeInterval', start?: number | null, end?: number | null }> | null } | null, adjusted_availability?: Array<{ __typename?: 'Availability', date: number, pms_appt_type_pms_id?: string | null, times: Array<{ __typename?: 'TimeInterval', start?: number | null, end?: number | null }>, repeat?: { __typename?: 'RepeatAvailability', daysOfMonth?: Array<number> | null, daysOfWeek?: Array<DayOfWeek> | null, weekOfMonth?: WeekOfMonth | null, frequency: any, unit: RepeatUnit, end_date?: number | null } | null }> | null, pms_adjusted_availability?: Array<{ __typename?: 'Availability', date: number, pms_appt_type_pms_id?: string | null, times: Array<{ __typename?: 'TimeInterval', start?: number | null, end?: number | null }>, repeat?: { __typename?: 'RepeatAvailability', daysOfMonth?: Array<number> | null, daysOfWeek?: Array<DayOfWeek> | null, weekOfMonth?: WeekOfMonth | null, frequency: any, unit: RepeatUnit, end_date?: number | null } | null }> | null };

export type RoomPreviewFieldsFragment = { __typename?: 'Room', id: string, name: string, display_name?: string | null };

export type GetRoomQueryVariables = Exact<{
  roomId: Scalars['ID']['input'];
}>;


export type GetRoomQuery = { __typename?: 'Query', room: { __typename?: 'Room', id: string, pms_id: string, name: string, display_name?: string | null, description?: string | null, concurrent_patients?: number | null, is_active: boolean, does_contribute_to_fill_rate?: boolean | null, valid_booking_interval_minutes?: Array<number> | null, created_at: number, updated_at: number, clinic?: { __typename?: 'Clinic', pms: PracticeManagementSystem, id: string, name?: string | null, time_zone?: string | null } | null, hours?: { __typename?: 'AvailabilityHours', monday?: Array<{ __typename?: 'TimeInterval', start?: number | null, end?: number | null }> | null, tuesday?: Array<{ __typename?: 'TimeInterval', start?: number | null, end?: number | null }> | null, wednesday?: Array<{ __typename?: 'TimeInterval', start?: number | null, end?: number | null }> | null, thursday?: Array<{ __typename?: 'TimeInterval', start?: number | null, end?: number | null }> | null, friday?: Array<{ __typename?: 'TimeInterval', start?: number | null, end?: number | null }> | null, saturday?: Array<{ __typename?: 'TimeInterval', start?: number | null, end?: number | null }> | null, sunday?: Array<{ __typename?: 'TimeInterval', start?: number | null, end?: number | null }> | null } | null, adjusted_availability?: Array<{ __typename?: 'Availability', date: number, pms_appt_type_pms_id?: string | null, times: Array<{ __typename?: 'TimeInterval', start?: number | null, end?: number | null }>, repeat?: { __typename?: 'RepeatAvailability', daysOfMonth?: Array<number> | null, daysOfWeek?: Array<DayOfWeek> | null, weekOfMonth?: WeekOfMonth | null, frequency: any, unit: RepeatUnit, end_date?: number | null } | null }> | null, pms_adjusted_availability?: Array<{ __typename?: 'Availability', date: number, pms_appt_type_pms_id?: string | null, times: Array<{ __typename?: 'TimeInterval', start?: number | null, end?: number | null }>, repeat?: { __typename?: 'RepeatAvailability', daysOfMonth?: Array<number> | null, daysOfWeek?: Array<DayOfWeek> | null, weekOfMonth?: WeekOfMonth | null, frequency: any, unit: RepeatUnit, end_date?: number | null } | null }> | null } };

export type QueryRoomsQueryVariables = Exact<{
  where?: InputMaybe<Array<QueryInput> | QueryInput>;
  page?: InputMaybe<Scalars['NonNegativeInt']['input']>;
  pageSize?: InputMaybe<Scalars['NonNegativeInt']['input']>;
  orderBy?: InputMaybe<OrderByInput>;
}>;


export type QueryRoomsQuery = { __typename?: 'Query', queryRooms: Array<{ __typename?: 'Room', id: string, pms_id: string, name: string, display_name?: string | null, description?: string | null, concurrent_patients?: number | null, is_active: boolean, does_contribute_to_fill_rate?: boolean | null, valid_booking_interval_minutes?: Array<number> | null, created_at: number, updated_at: number, clinic?: { __typename?: 'Clinic', pms: PracticeManagementSystem, id: string, name?: string | null, time_zone?: string | null } | null, hours?: { __typename?: 'AvailabilityHours', monday?: Array<{ __typename?: 'TimeInterval', start?: number | null, end?: number | null }> | null, tuesday?: Array<{ __typename?: 'TimeInterval', start?: number | null, end?: number | null }> | null, wednesday?: Array<{ __typename?: 'TimeInterval', start?: number | null, end?: number | null }> | null, thursday?: Array<{ __typename?: 'TimeInterval', start?: number | null, end?: number | null }> | null, friday?: Array<{ __typename?: 'TimeInterval', start?: number | null, end?: number | null }> | null, saturday?: Array<{ __typename?: 'TimeInterval', start?: number | null, end?: number | null }> | null, sunday?: Array<{ __typename?: 'TimeInterval', start?: number | null, end?: number | null }> | null } | null, adjusted_availability?: Array<{ __typename?: 'Availability', date: number, pms_appt_type_pms_id?: string | null, times: Array<{ __typename?: 'TimeInterval', start?: number | null, end?: number | null }>, repeat?: { __typename?: 'RepeatAvailability', daysOfMonth?: Array<number> | null, daysOfWeek?: Array<DayOfWeek> | null, weekOfMonth?: WeekOfMonth | null, frequency: any, unit: RepeatUnit, end_date?: number | null } | null }> | null, pms_adjusted_availability?: Array<{ __typename?: 'Availability', date: number, pms_appt_type_pms_id?: string | null, times: Array<{ __typename?: 'TimeInterval', start?: number | null, end?: number | null }>, repeat?: { __typename?: 'RepeatAvailability', daysOfMonth?: Array<number> | null, daysOfWeek?: Array<DayOfWeek> | null, weekOfMonth?: WeekOfMonth | null, frequency: any, unit: RepeatUnit, end_date?: number | null } | null }> | null }> };

export type QueryPreviewRoomsQueryVariables = Exact<{
  where?: InputMaybe<Array<QueryInput> | QueryInput>;
  page?: InputMaybe<Scalars['NonNegativeInt']['input']>;
  pageSize?: InputMaybe<Scalars['NonNegativeInt']['input']>;
  orderBy?: InputMaybe<OrderByInput>;
}>;


export type QueryPreviewRoomsQuery = { __typename?: 'Query', queryRooms: Array<{ __typename?: 'Room', id: string, name: string, display_name?: string | null }> };

export type CountRoomsQueryVariables = Exact<{
  where?: InputMaybe<Array<QueryInput> | QueryInput>;
}>;


export type CountRoomsQuery = { __typename?: 'Query', countRooms: number };

export type GetRoomsForClinicQueryVariables = Exact<{
  clinicId: Scalars['ID']['input'];
}>;


export type GetRoomsForClinicQuery = { __typename?: 'Query', getRoomsByClinic: Array<{ __typename?: 'Room', id: string, pms_id: string, name: string, display_name?: string | null, description?: string | null, concurrent_patients?: number | null, is_active: boolean, does_contribute_to_fill_rate?: boolean | null, valid_booking_interval_minutes?: Array<number> | null, created_at: number, updated_at: number, clinic?: { __typename?: 'Clinic', pms: PracticeManagementSystem, id: string, name?: string | null, time_zone?: string | null } | null, hours?: { __typename?: 'AvailabilityHours', monday?: Array<{ __typename?: 'TimeInterval', start?: number | null, end?: number | null }> | null, tuesday?: Array<{ __typename?: 'TimeInterval', start?: number | null, end?: number | null }> | null, wednesday?: Array<{ __typename?: 'TimeInterval', start?: number | null, end?: number | null }> | null, thursday?: Array<{ __typename?: 'TimeInterval', start?: number | null, end?: number | null }> | null, friday?: Array<{ __typename?: 'TimeInterval', start?: number | null, end?: number | null }> | null, saturday?: Array<{ __typename?: 'TimeInterval', start?: number | null, end?: number | null }> | null, sunday?: Array<{ __typename?: 'TimeInterval', start?: number | null, end?: number | null }> | null } | null, adjusted_availability?: Array<{ __typename?: 'Availability', date: number, pms_appt_type_pms_id?: string | null, times: Array<{ __typename?: 'TimeInterval', start?: number | null, end?: number | null }>, repeat?: { __typename?: 'RepeatAvailability', daysOfMonth?: Array<number> | null, daysOfWeek?: Array<DayOfWeek> | null, weekOfMonth?: WeekOfMonth | null, frequency: any, unit: RepeatUnit, end_date?: number | null } | null }> | null, pms_adjusted_availability?: Array<{ __typename?: 'Availability', date: number, pms_appt_type_pms_id?: string | null, times: Array<{ __typename?: 'TimeInterval', start?: number | null, end?: number | null }>, repeat?: { __typename?: 'RepeatAvailability', daysOfMonth?: Array<number> | null, daysOfWeek?: Array<DayOfWeek> | null, weekOfMonth?: WeekOfMonth | null, frequency: any, unit: RepeatUnit, end_date?: number | null } | null }> | null }> };

export type UpdateRoomMutationVariables = Exact<{
  roomId: Scalars['ID']['input'];
  data: UpdateRoomInput;
}>;


export type UpdateRoomMutation = { __typename?: 'Mutation', updateRoom: { __typename?: 'Room', id: string, pms_id: string, name: string, display_name?: string | null, description?: string | null, concurrent_patients?: number | null, is_active: boolean, does_contribute_to_fill_rate?: boolean | null, valid_booking_interval_minutes?: Array<number> | null, created_at: number, updated_at: number, clinic?: { __typename?: 'Clinic', pms: PracticeManagementSystem, id: string, name?: string | null, time_zone?: string | null } | null, hours?: { __typename?: 'AvailabilityHours', monday?: Array<{ __typename?: 'TimeInterval', start?: number | null, end?: number | null }> | null, tuesday?: Array<{ __typename?: 'TimeInterval', start?: number | null, end?: number | null }> | null, wednesday?: Array<{ __typename?: 'TimeInterval', start?: number | null, end?: number | null }> | null, thursday?: Array<{ __typename?: 'TimeInterval', start?: number | null, end?: number | null }> | null, friday?: Array<{ __typename?: 'TimeInterval', start?: number | null, end?: number | null }> | null, saturday?: Array<{ __typename?: 'TimeInterval', start?: number | null, end?: number | null }> | null, sunday?: Array<{ __typename?: 'TimeInterval', start?: number | null, end?: number | null }> | null } | null, adjusted_availability?: Array<{ __typename?: 'Availability', date: number, pms_appt_type_pms_id?: string | null, times: Array<{ __typename?: 'TimeInterval', start?: number | null, end?: number | null }>, repeat?: { __typename?: 'RepeatAvailability', daysOfMonth?: Array<number> | null, daysOfWeek?: Array<DayOfWeek> | null, weekOfMonth?: WeekOfMonth | null, frequency: any, unit: RepeatUnit, end_date?: number | null } | null }> | null, pms_adjusted_availability?: Array<{ __typename?: 'Availability', date: number, pms_appt_type_pms_id?: string | null, times: Array<{ __typename?: 'TimeInterval', start?: number | null, end?: number | null }>, repeat?: { __typename?: 'RepeatAvailability', daysOfMonth?: Array<number> | null, daysOfWeek?: Array<DayOfWeek> | null, weekOfMonth?: WeekOfMonth | null, frequency: any, unit: RepeatUnit, end_date?: number | null } | null }> | null } };

export type ScheduledBulkMessageFieldsFragment = { __typename?: 'ScheduledBulkMessage', id: string, name: string, send_time?: number | null, subject?: string | null, body?: string | null, email_body?: string | null, email_design?: any | null, email_html?: string | null, message_methods: Array<MessageMethod>, included_clients?: Array<string> | null, excluded_clients?: Array<string> | null, started_at?: number | null, is_active: boolean, is_system: boolean, is_completed: boolean, is_archived: boolean, is_marketing: boolean, cta_url?: string | null, cta_text?: string | null, updated_at: number, created_at: number, clinic?: { __typename?: 'Clinic', id: string } | null, clinic_group?: { __typename?: 'ClinicGroup', id: string, name: string } | null, campaign?: { __typename?: 'Campaign', id: string, name: string, color?: string | null, description?: string | null } | null, email_template?: { __typename?: 'EmailTemplate', id: string, title: string, subject?: string | null, design?: any | null, html?: string | null, status: EmailTemplateStatus, created_at: number, updated_at: number, clinic?: { __typename?: 'Clinic', id: string } | null, clinic_group?: { __typename?: 'ClinicGroup', id: string, name: string } | null } | null, notif_attachments?: Array<{ __typename?: 'Attachment', id: string, filename: string, url: string, type: AttachmentType }> | null, customer_segment?: { __typename?: 'CustomerSegment', id: string, name: string, trigger_entity?: CustomerSegmentTrigger | null, is_hourly?: boolean | null, group_days_ahead?: number | null, should_include_all_overdue?: boolean | null, included_clients?: Array<string> | null, excluded_clients?: Array<string> | null, other_result_exclusion_entity?: string | null, is_archived: boolean, created_at: number, updated_at: number, filters?: Array<{ __typename?: 'CustomerSegmentFilter', type: CustomerSegmentFilterType, only_consider_other_rows?: boolean | null, filters: Array<{ __typename?: 'QueryFilter', column: string, filterOp: FilterOp, value: { __typename?: 'QueryFilterValue', string?: string | null, float?: number | null, boolean?: boolean | null, stringArray?: Array<string> | null, floatArray?: Array<number> | null, millisFromNow?: number | null, relativeTime?: { __typename?: 'RelativeTime', quantity: number, unit: TimeUnit, direction: ReferenceDirection } | null } }> }> | null, excluded_filters: Array<{ __typename?: 'CustomerSegmentFilter', type: CustomerSegmentFilterType, only_consider_other_rows?: boolean | null, filters: Array<{ __typename?: 'QueryFilter', column: string, filterOp: FilterOp, value: { __typename?: 'QueryFilterValue', string?: string | null, float?: number | null, boolean?: boolean | null, stringArray?: Array<string> | null, floatArray?: Array<number> | null, millisFromNow?: number | null, relativeTime?: { __typename?: 'RelativeTime', quantity: number, unit: TimeUnit, direction: ReferenceDirection } | null } }> }>, all_inclusions?: Array<{ __typename?: 'SegmentFilter', foreign_table?: string | null, group?: string | null, parameters: Array<{ __typename?: 'QueryFilter', column: string, filterOp: FilterOp, value: { __typename?: 'QueryFilterValue', string?: string | null, float?: number | null, boolean?: boolean | null, stringArray?: Array<string> | null, floatArray?: Array<number> | null, millisFromNow?: number | null, relativeTime?: { __typename?: 'RelativeTime', quantity: number, unit: TimeUnit, direction: ReferenceDirection } | null } }> }> | null, any_inclusions?: Array<{ __typename?: 'SegmentFilter', foreign_table?: string | null, group?: string | null, parameters: Array<{ __typename?: 'QueryFilter', column: string, filterOp: FilterOp, value: { __typename?: 'QueryFilterValue', string?: string | null, float?: number | null, boolean?: boolean | null, stringArray?: Array<string> | null, floatArray?: Array<number> | null, millisFromNow?: number | null, relativeTime?: { __typename?: 'RelativeTime', quantity: number, unit: TimeUnit, direction: ReferenceDirection } | null } }> }> | null, any_exclusions?: Array<{ __typename?: 'SegmentFilter', foreign_table?: string | null, group?: string | null, parameters: Array<{ __typename?: 'QueryFilter', column: string, filterOp: FilterOp, value: { __typename?: 'QueryFilterValue', string?: string | null, float?: number | null, boolean?: boolean | null, stringArray?: Array<string> | null, floatArray?: Array<number> | null, millisFromNow?: number | null, relativeTime?: { __typename?: 'RelativeTime', quantity: number, unit: TimeUnit, direction: ReferenceDirection } | null } }> }> | null, any_other_exclusions?: Array<{ __typename?: 'SegmentFilter', foreign_table?: string | null, group?: string | null, parameters: Array<{ __typename?: 'QueryFilter', column: string, filterOp: FilterOp, value: { __typename?: 'QueryFilterValue', string?: string | null, float?: number | null, boolean?: boolean | null, stringArray?: Array<string> | null, floatArray?: Array<number> | null, millisFromNow?: number | null, relativeTime?: { __typename?: 'RelativeTime', quantity: number, unit: TimeUnit, direction: ReferenceDirection } | null } }> }> | null, default_exclusions_options: { __typename?: 'DefaultExclusionsOptions', exclude_cancelled_and_rescheduled_resources?: boolean | null, exclude_euthanasia_and_qol_resources?: boolean | null, exclude_euthanasia_and_qol_in_appt_notes?: boolean | null }, reference_date_params?: { __typename?: 'ReferenceDateParams', field: string, reference_periods?: Array<{ __typename?: 'ReferencePeriod', quantity: number, unit: TimeUnit, direction: ReferenceDirection }> | null } | null, notification_templates?: Array<{ __typename?: 'NotificationTemplate', id: string, name: string, is_active: boolean, is_archived: boolean, message_methods: Array<MessageMethod> }> | null, error_flags?: Array<{ __typename?: 'CustomerSegmentErrorFlag', filter_column: string, filter_index: number, parameter_index: number, message: string }> | null } | null };

export type ScheduledBulkMessageQueryVariables = Exact<{
  scheduledBulkMessageId: Scalars['ID']['input'];
}>;


export type ScheduledBulkMessageQuery = { __typename?: 'Query', scheduledBulkMessage: { __typename?: 'ScheduledBulkMessage', id: string, name: string, send_time?: number | null, subject?: string | null, body?: string | null, email_body?: string | null, email_design?: any | null, email_html?: string | null, message_methods: Array<MessageMethod>, included_clients?: Array<string> | null, excluded_clients?: Array<string> | null, started_at?: number | null, is_active: boolean, is_system: boolean, is_completed: boolean, is_archived: boolean, is_marketing: boolean, cta_url?: string | null, cta_text?: string | null, updated_at: number, created_at: number, clinic?: { __typename?: 'Clinic', id: string } | null, clinic_group?: { __typename?: 'ClinicGroup', id: string, name: string } | null, campaign?: { __typename?: 'Campaign', id: string, name: string, color?: string | null, description?: string | null } | null, email_template?: { __typename?: 'EmailTemplate', id: string, title: string, subject?: string | null, design?: any | null, html?: string | null, status: EmailTemplateStatus, created_at: number, updated_at: number, clinic?: { __typename?: 'Clinic', id: string } | null, clinic_group?: { __typename?: 'ClinicGroup', id: string, name: string } | null } | null, notif_attachments?: Array<{ __typename?: 'Attachment', id: string, filename: string, url: string, type: AttachmentType }> | null, customer_segment?: { __typename?: 'CustomerSegment', id: string, name: string, trigger_entity?: CustomerSegmentTrigger | null, is_hourly?: boolean | null, group_days_ahead?: number | null, should_include_all_overdue?: boolean | null, included_clients?: Array<string> | null, excluded_clients?: Array<string> | null, other_result_exclusion_entity?: string | null, is_archived: boolean, created_at: number, updated_at: number, filters?: Array<{ __typename?: 'CustomerSegmentFilter', type: CustomerSegmentFilterType, only_consider_other_rows?: boolean | null, filters: Array<{ __typename?: 'QueryFilter', column: string, filterOp: FilterOp, value: { __typename?: 'QueryFilterValue', string?: string | null, float?: number | null, boolean?: boolean | null, stringArray?: Array<string> | null, floatArray?: Array<number> | null, millisFromNow?: number | null, relativeTime?: { __typename?: 'RelativeTime', quantity: number, unit: TimeUnit, direction: ReferenceDirection } | null } }> }> | null, excluded_filters: Array<{ __typename?: 'CustomerSegmentFilter', type: CustomerSegmentFilterType, only_consider_other_rows?: boolean | null, filters: Array<{ __typename?: 'QueryFilter', column: string, filterOp: FilterOp, value: { __typename?: 'QueryFilterValue', string?: string | null, float?: number | null, boolean?: boolean | null, stringArray?: Array<string> | null, floatArray?: Array<number> | null, millisFromNow?: number | null, relativeTime?: { __typename?: 'RelativeTime', quantity: number, unit: TimeUnit, direction: ReferenceDirection } | null } }> }>, all_inclusions?: Array<{ __typename?: 'SegmentFilter', foreign_table?: string | null, group?: string | null, parameters: Array<{ __typename?: 'QueryFilter', column: string, filterOp: FilterOp, value: { __typename?: 'QueryFilterValue', string?: string | null, float?: number | null, boolean?: boolean | null, stringArray?: Array<string> | null, floatArray?: Array<number> | null, millisFromNow?: number | null, relativeTime?: { __typename?: 'RelativeTime', quantity: number, unit: TimeUnit, direction: ReferenceDirection } | null } }> }> | null, any_inclusions?: Array<{ __typename?: 'SegmentFilter', foreign_table?: string | null, group?: string | null, parameters: Array<{ __typename?: 'QueryFilter', column: string, filterOp: FilterOp, value: { __typename?: 'QueryFilterValue', string?: string | null, float?: number | null, boolean?: boolean | null, stringArray?: Array<string> | null, floatArray?: Array<number> | null, millisFromNow?: number | null, relativeTime?: { __typename?: 'RelativeTime', quantity: number, unit: TimeUnit, direction: ReferenceDirection } | null } }> }> | null, any_exclusions?: Array<{ __typename?: 'SegmentFilter', foreign_table?: string | null, group?: string | null, parameters: Array<{ __typename?: 'QueryFilter', column: string, filterOp: FilterOp, value: { __typename?: 'QueryFilterValue', string?: string | null, float?: number | null, boolean?: boolean | null, stringArray?: Array<string> | null, floatArray?: Array<number> | null, millisFromNow?: number | null, relativeTime?: { __typename?: 'RelativeTime', quantity: number, unit: TimeUnit, direction: ReferenceDirection } | null } }> }> | null, any_other_exclusions?: Array<{ __typename?: 'SegmentFilter', foreign_table?: string | null, group?: string | null, parameters: Array<{ __typename?: 'QueryFilter', column: string, filterOp: FilterOp, value: { __typename?: 'QueryFilterValue', string?: string | null, float?: number | null, boolean?: boolean | null, stringArray?: Array<string> | null, floatArray?: Array<number> | null, millisFromNow?: number | null, relativeTime?: { __typename?: 'RelativeTime', quantity: number, unit: TimeUnit, direction: ReferenceDirection } | null } }> }> | null, default_exclusions_options: { __typename?: 'DefaultExclusionsOptions', exclude_cancelled_and_rescheduled_resources?: boolean | null, exclude_euthanasia_and_qol_resources?: boolean | null, exclude_euthanasia_and_qol_in_appt_notes?: boolean | null }, reference_date_params?: { __typename?: 'ReferenceDateParams', field: string, reference_periods?: Array<{ __typename?: 'ReferencePeriod', quantity: number, unit: TimeUnit, direction: ReferenceDirection }> | null } | null, notification_templates?: Array<{ __typename?: 'NotificationTemplate', id: string, name: string, is_active: boolean, is_archived: boolean, message_methods: Array<MessageMethod> }> | null, error_flags?: Array<{ __typename?: 'CustomerSegmentErrorFlag', filter_column: string, filter_index: number, parameter_index: number, message: string }> | null } | null } };

export type GetScheduledBulkMessagesByClinicIdQueryVariables = Exact<{
  clinicId: Scalars['ID']['input'];
}>;


export type GetScheduledBulkMessagesByClinicIdQuery = { __typename?: 'Query', getScheduledBulkMessagesByClinicId: Array<{ __typename?: 'ScheduledBulkMessage', id: string, name: string, send_time?: number | null, subject?: string | null, body?: string | null, email_body?: string | null, email_design?: any | null, email_html?: string | null, message_methods: Array<MessageMethod>, included_clients?: Array<string> | null, excluded_clients?: Array<string> | null, started_at?: number | null, is_active: boolean, is_system: boolean, is_completed: boolean, is_archived: boolean, is_marketing: boolean, cta_url?: string | null, cta_text?: string | null, updated_at: number, created_at: number, clinic?: { __typename?: 'Clinic', id: string } | null, clinic_group?: { __typename?: 'ClinicGroup', id: string, name: string } | null, campaign?: { __typename?: 'Campaign', id: string, name: string, color?: string | null, description?: string | null } | null, email_template?: { __typename?: 'EmailTemplate', id: string, title: string, subject?: string | null, design?: any | null, html?: string | null, status: EmailTemplateStatus, created_at: number, updated_at: number, clinic?: { __typename?: 'Clinic', id: string } | null, clinic_group?: { __typename?: 'ClinicGroup', id: string, name: string } | null } | null, notif_attachments?: Array<{ __typename?: 'Attachment', id: string, filename: string, url: string, type: AttachmentType }> | null, customer_segment?: { __typename?: 'CustomerSegment', id: string, name: string, trigger_entity?: CustomerSegmentTrigger | null, is_hourly?: boolean | null, group_days_ahead?: number | null, should_include_all_overdue?: boolean | null, included_clients?: Array<string> | null, excluded_clients?: Array<string> | null, other_result_exclusion_entity?: string | null, is_archived: boolean, created_at: number, updated_at: number, filters?: Array<{ __typename?: 'CustomerSegmentFilter', type: CustomerSegmentFilterType, only_consider_other_rows?: boolean | null, filters: Array<{ __typename?: 'QueryFilter', column: string, filterOp: FilterOp, value: { __typename?: 'QueryFilterValue', string?: string | null, float?: number | null, boolean?: boolean | null, stringArray?: Array<string> | null, floatArray?: Array<number> | null, millisFromNow?: number | null, relativeTime?: { __typename?: 'RelativeTime', quantity: number, unit: TimeUnit, direction: ReferenceDirection } | null } }> }> | null, excluded_filters: Array<{ __typename?: 'CustomerSegmentFilter', type: CustomerSegmentFilterType, only_consider_other_rows?: boolean | null, filters: Array<{ __typename?: 'QueryFilter', column: string, filterOp: FilterOp, value: { __typename?: 'QueryFilterValue', string?: string | null, float?: number | null, boolean?: boolean | null, stringArray?: Array<string> | null, floatArray?: Array<number> | null, millisFromNow?: number | null, relativeTime?: { __typename?: 'RelativeTime', quantity: number, unit: TimeUnit, direction: ReferenceDirection } | null } }> }>, all_inclusions?: Array<{ __typename?: 'SegmentFilter', foreign_table?: string | null, group?: string | null, parameters: Array<{ __typename?: 'QueryFilter', column: string, filterOp: FilterOp, value: { __typename?: 'QueryFilterValue', string?: string | null, float?: number | null, boolean?: boolean | null, stringArray?: Array<string> | null, floatArray?: Array<number> | null, millisFromNow?: number | null, relativeTime?: { __typename?: 'RelativeTime', quantity: number, unit: TimeUnit, direction: ReferenceDirection } | null } }> }> | null, any_inclusions?: Array<{ __typename?: 'SegmentFilter', foreign_table?: string | null, group?: string | null, parameters: Array<{ __typename?: 'QueryFilter', column: string, filterOp: FilterOp, value: { __typename?: 'QueryFilterValue', string?: string | null, float?: number | null, boolean?: boolean | null, stringArray?: Array<string> | null, floatArray?: Array<number> | null, millisFromNow?: number | null, relativeTime?: { __typename?: 'RelativeTime', quantity: number, unit: TimeUnit, direction: ReferenceDirection } | null } }> }> | null, any_exclusions?: Array<{ __typename?: 'SegmentFilter', foreign_table?: string | null, group?: string | null, parameters: Array<{ __typename?: 'QueryFilter', column: string, filterOp: FilterOp, value: { __typename?: 'QueryFilterValue', string?: string | null, float?: number | null, boolean?: boolean | null, stringArray?: Array<string> | null, floatArray?: Array<number> | null, millisFromNow?: number | null, relativeTime?: { __typename?: 'RelativeTime', quantity: number, unit: TimeUnit, direction: ReferenceDirection } | null } }> }> | null, any_other_exclusions?: Array<{ __typename?: 'SegmentFilter', foreign_table?: string | null, group?: string | null, parameters: Array<{ __typename?: 'QueryFilter', column: string, filterOp: FilterOp, value: { __typename?: 'QueryFilterValue', string?: string | null, float?: number | null, boolean?: boolean | null, stringArray?: Array<string> | null, floatArray?: Array<number> | null, millisFromNow?: number | null, relativeTime?: { __typename?: 'RelativeTime', quantity: number, unit: TimeUnit, direction: ReferenceDirection } | null } }> }> | null, default_exclusions_options: { __typename?: 'DefaultExclusionsOptions', exclude_cancelled_and_rescheduled_resources?: boolean | null, exclude_euthanasia_and_qol_resources?: boolean | null, exclude_euthanasia_and_qol_in_appt_notes?: boolean | null }, reference_date_params?: { __typename?: 'ReferenceDateParams', field: string, reference_periods?: Array<{ __typename?: 'ReferencePeriod', quantity: number, unit: TimeUnit, direction: ReferenceDirection }> | null } | null, notification_templates?: Array<{ __typename?: 'NotificationTemplate', id: string, name: string, is_active: boolean, is_archived: boolean, message_methods: Array<MessageMethod> }> | null, error_flags?: Array<{ __typename?: 'CustomerSegmentErrorFlag', filter_column: string, filter_index: number, parameter_index: number, message: string }> | null } | null }> };

export type QueryScheduledBulkMessagesQueryVariables = Exact<{
  where?: InputMaybe<Array<QueryInput> | QueryInput>;
  orderBy?: InputMaybe<OrderByInput>;
  page?: InputMaybe<Scalars['NonNegativeInt']['input']>;
  pageSize?: InputMaybe<Scalars['NonNegativeInt']['input']>;
}>;


export type QueryScheduledBulkMessagesQuery = { __typename?: 'Query', queryScheduledBulkMessages: Array<{ __typename?: 'ScheduledBulkMessage', id: string, name: string, send_time?: number | null, subject?: string | null, body?: string | null, email_body?: string | null, email_design?: any | null, email_html?: string | null, message_methods: Array<MessageMethod>, included_clients?: Array<string> | null, excluded_clients?: Array<string> | null, started_at?: number | null, is_active: boolean, is_system: boolean, is_completed: boolean, is_archived: boolean, is_marketing: boolean, cta_url?: string | null, cta_text?: string | null, updated_at: number, created_at: number, clinic?: { __typename?: 'Clinic', id: string } | null, clinic_group?: { __typename?: 'ClinicGroup', id: string, name: string } | null, campaign?: { __typename?: 'Campaign', id: string, name: string, color?: string | null, description?: string | null } | null, email_template?: { __typename?: 'EmailTemplate', id: string, title: string, subject?: string | null, design?: any | null, html?: string | null, status: EmailTemplateStatus, created_at: number, updated_at: number, clinic?: { __typename?: 'Clinic', id: string } | null, clinic_group?: { __typename?: 'ClinicGroup', id: string, name: string } | null } | null, notif_attachments?: Array<{ __typename?: 'Attachment', id: string, filename: string, url: string, type: AttachmentType }> | null, customer_segment?: { __typename?: 'CustomerSegment', id: string, name: string, trigger_entity?: CustomerSegmentTrigger | null, is_hourly?: boolean | null, group_days_ahead?: number | null, should_include_all_overdue?: boolean | null, included_clients?: Array<string> | null, excluded_clients?: Array<string> | null, other_result_exclusion_entity?: string | null, is_archived: boolean, created_at: number, updated_at: number, filters?: Array<{ __typename?: 'CustomerSegmentFilter', type: CustomerSegmentFilterType, only_consider_other_rows?: boolean | null, filters: Array<{ __typename?: 'QueryFilter', column: string, filterOp: FilterOp, value: { __typename?: 'QueryFilterValue', string?: string | null, float?: number | null, boolean?: boolean | null, stringArray?: Array<string> | null, floatArray?: Array<number> | null, millisFromNow?: number | null, relativeTime?: { __typename?: 'RelativeTime', quantity: number, unit: TimeUnit, direction: ReferenceDirection } | null } }> }> | null, excluded_filters: Array<{ __typename?: 'CustomerSegmentFilter', type: CustomerSegmentFilterType, only_consider_other_rows?: boolean | null, filters: Array<{ __typename?: 'QueryFilter', column: string, filterOp: FilterOp, value: { __typename?: 'QueryFilterValue', string?: string | null, float?: number | null, boolean?: boolean | null, stringArray?: Array<string> | null, floatArray?: Array<number> | null, millisFromNow?: number | null, relativeTime?: { __typename?: 'RelativeTime', quantity: number, unit: TimeUnit, direction: ReferenceDirection } | null } }> }>, all_inclusions?: Array<{ __typename?: 'SegmentFilter', foreign_table?: string | null, group?: string | null, parameters: Array<{ __typename?: 'QueryFilter', column: string, filterOp: FilterOp, value: { __typename?: 'QueryFilterValue', string?: string | null, float?: number | null, boolean?: boolean | null, stringArray?: Array<string> | null, floatArray?: Array<number> | null, millisFromNow?: number | null, relativeTime?: { __typename?: 'RelativeTime', quantity: number, unit: TimeUnit, direction: ReferenceDirection } | null } }> }> | null, any_inclusions?: Array<{ __typename?: 'SegmentFilter', foreign_table?: string | null, group?: string | null, parameters: Array<{ __typename?: 'QueryFilter', column: string, filterOp: FilterOp, value: { __typename?: 'QueryFilterValue', string?: string | null, float?: number | null, boolean?: boolean | null, stringArray?: Array<string> | null, floatArray?: Array<number> | null, millisFromNow?: number | null, relativeTime?: { __typename?: 'RelativeTime', quantity: number, unit: TimeUnit, direction: ReferenceDirection } | null } }> }> | null, any_exclusions?: Array<{ __typename?: 'SegmentFilter', foreign_table?: string | null, group?: string | null, parameters: Array<{ __typename?: 'QueryFilter', column: string, filterOp: FilterOp, value: { __typename?: 'QueryFilterValue', string?: string | null, float?: number | null, boolean?: boolean | null, stringArray?: Array<string> | null, floatArray?: Array<number> | null, millisFromNow?: number | null, relativeTime?: { __typename?: 'RelativeTime', quantity: number, unit: TimeUnit, direction: ReferenceDirection } | null } }> }> | null, any_other_exclusions?: Array<{ __typename?: 'SegmentFilter', foreign_table?: string | null, group?: string | null, parameters: Array<{ __typename?: 'QueryFilter', column: string, filterOp: FilterOp, value: { __typename?: 'QueryFilterValue', string?: string | null, float?: number | null, boolean?: boolean | null, stringArray?: Array<string> | null, floatArray?: Array<number> | null, millisFromNow?: number | null, relativeTime?: { __typename?: 'RelativeTime', quantity: number, unit: TimeUnit, direction: ReferenceDirection } | null } }> }> | null, default_exclusions_options: { __typename?: 'DefaultExclusionsOptions', exclude_cancelled_and_rescheduled_resources?: boolean | null, exclude_euthanasia_and_qol_resources?: boolean | null, exclude_euthanasia_and_qol_in_appt_notes?: boolean | null }, reference_date_params?: { __typename?: 'ReferenceDateParams', field: string, reference_periods?: Array<{ __typename?: 'ReferencePeriod', quantity: number, unit: TimeUnit, direction: ReferenceDirection }> | null } | null, notification_templates?: Array<{ __typename?: 'NotificationTemplate', id: string, name: string, is_active: boolean, is_archived: boolean, message_methods: Array<MessageMethod> }> | null, error_flags?: Array<{ __typename?: 'CustomerSegmentErrorFlag', filter_column: string, filter_index: number, parameter_index: number, message: string }> | null } | null }> };

export type CountScheduledBulkMessagesQueryVariables = Exact<{
  where?: InputMaybe<Array<QueryInput> | QueryInput>;
}>;


export type CountScheduledBulkMessagesQuery = { __typename?: 'Query', countScheduledBulkMessages: number };

export type GetScheduledBulkMessageStatsQueryVariables = Exact<{
  id: Scalars['ID']['input'];
}>;


export type GetScheduledBulkMessageStatsQuery = { __typename?: 'Query', scheduledBulkMessageTrackingStats: { __typename?: 'ScheduledBulkMessageTrackingStats', unique_clients: number, messages_sent: number, emails_sent: number, sms_sent: number, email_opens: number, email_open_rate: number, email_unique_opens: number, email_unique_open_rate: number, email_clicks: number, email_click_rate: number, email_unique_clicks: number, email_unique_click_rate: number, sms_clicks: number, sms_click_rate: number, sms_unique_clicks: number, sms_unique_click_rate: number, conversion_rate: number, direct_appointments: number, indirect_appointments: number, revenue_by_appt: number } };

export type BulkMessageAudienceEstimateQueryVariables = Exact<{
  data: BulkMessageAudienceEstimateInput;
}>;


export type BulkMessageAudienceEstimateQuery = { __typename?: 'Query', bulkMessageAudienceEstimate: { __typename?: 'BulkMessageAudienceEstimate', total_unique_clients: number, eligible_clients: number, filtered_clients: number, estimated_sms_segments: number, estimated_sms_cost_cents: number, min_sms_segments_per_client: number, max_sms_segments_per_client: number, average_sms_segments_per_client: number } };

export type CreateScheduledBulkMessageMutationVariables = Exact<{
  data: CreateScheduledBulkMessageInput;
}>;


export type CreateScheduledBulkMessageMutation = { __typename?: 'Mutation', createScheduledBulkMessage: { __typename?: 'ScheduledBulkMessage', id: string, name: string, send_time?: number | null, subject?: string | null, body?: string | null, email_body?: string | null, email_design?: any | null, email_html?: string | null, message_methods: Array<MessageMethod>, included_clients?: Array<string> | null, excluded_clients?: Array<string> | null, started_at?: number | null, is_active: boolean, is_system: boolean, is_completed: boolean, is_archived: boolean, is_marketing: boolean, cta_url?: string | null, cta_text?: string | null, updated_at: number, created_at: number, clinic?: { __typename?: 'Clinic', id: string } | null, clinic_group?: { __typename?: 'ClinicGroup', id: string, name: string } | null, campaign?: { __typename?: 'Campaign', id: string, name: string, color?: string | null, description?: string | null } | null, email_template?: { __typename?: 'EmailTemplate', id: string, title: string, subject?: string | null, design?: any | null, html?: string | null, status: EmailTemplateStatus, created_at: number, updated_at: number, clinic?: { __typename?: 'Clinic', id: string } | null, clinic_group?: { __typename?: 'ClinicGroup', id: string, name: string } | null } | null, notif_attachments?: Array<{ __typename?: 'Attachment', id: string, filename: string, url: string, type: AttachmentType }> | null, customer_segment?: { __typename?: 'CustomerSegment', id: string, name: string, trigger_entity?: CustomerSegmentTrigger | null, is_hourly?: boolean | null, group_days_ahead?: number | null, should_include_all_overdue?: boolean | null, included_clients?: Array<string> | null, excluded_clients?: Array<string> | null, other_result_exclusion_entity?: string | null, is_archived: boolean, created_at: number, updated_at: number, filters?: Array<{ __typename?: 'CustomerSegmentFilter', type: CustomerSegmentFilterType, only_consider_other_rows?: boolean | null, filters: Array<{ __typename?: 'QueryFilter', column: string, filterOp: FilterOp, value: { __typename?: 'QueryFilterValue', string?: string | null, float?: number | null, boolean?: boolean | null, stringArray?: Array<string> | null, floatArray?: Array<number> | null, millisFromNow?: number | null, relativeTime?: { __typename?: 'RelativeTime', quantity: number, unit: TimeUnit, direction: ReferenceDirection } | null } }> }> | null, excluded_filters: Array<{ __typename?: 'CustomerSegmentFilter', type: CustomerSegmentFilterType, only_consider_other_rows?: boolean | null, filters: Array<{ __typename?: 'QueryFilter', column: string, filterOp: FilterOp, value: { __typename?: 'QueryFilterValue', string?: string | null, float?: number | null, boolean?: boolean | null, stringArray?: Array<string> | null, floatArray?: Array<number> | null, millisFromNow?: number | null, relativeTime?: { __typename?: 'RelativeTime', quantity: number, unit: TimeUnit, direction: ReferenceDirection } | null } }> }>, all_inclusions?: Array<{ __typename?: 'SegmentFilter', foreign_table?: string | null, group?: string | null, parameters: Array<{ __typename?: 'QueryFilter', column: string, filterOp: FilterOp, value: { __typename?: 'QueryFilterValue', string?: string | null, float?: number | null, boolean?: boolean | null, stringArray?: Array<string> | null, floatArray?: Array<number> | null, millisFromNow?: number | null, relativeTime?: { __typename?: 'RelativeTime', quantity: number, unit: TimeUnit, direction: ReferenceDirection } | null } }> }> | null, any_inclusions?: Array<{ __typename?: 'SegmentFilter', foreign_table?: string | null, group?: string | null, parameters: Array<{ __typename?: 'QueryFilter', column: string, filterOp: FilterOp, value: { __typename?: 'QueryFilterValue', string?: string | null, float?: number | null, boolean?: boolean | null, stringArray?: Array<string> | null, floatArray?: Array<number> | null, millisFromNow?: number | null, relativeTime?: { __typename?: 'RelativeTime', quantity: number, unit: TimeUnit, direction: ReferenceDirection } | null } }> }> | null, any_exclusions?: Array<{ __typename?: 'SegmentFilter', foreign_table?: string | null, group?: string | null, parameters: Array<{ __typename?: 'QueryFilter', column: string, filterOp: FilterOp, value: { __typename?: 'QueryFilterValue', string?: string | null, float?: number | null, boolean?: boolean | null, stringArray?: Array<string> | null, floatArray?: Array<number> | null, millisFromNow?: number | null, relativeTime?: { __typename?: 'RelativeTime', quantity: number, unit: TimeUnit, direction: ReferenceDirection } | null } }> }> | null, any_other_exclusions?: Array<{ __typename?: 'SegmentFilter', foreign_table?: string | null, group?: string | null, parameters: Array<{ __typename?: 'QueryFilter', column: string, filterOp: FilterOp, value: { __typename?: 'QueryFilterValue', string?: string | null, float?: number | null, boolean?: boolean | null, stringArray?: Array<string> | null, floatArray?: Array<number> | null, millisFromNow?: number | null, relativeTime?: { __typename?: 'RelativeTime', quantity: number, unit: TimeUnit, direction: ReferenceDirection } | null } }> }> | null, default_exclusions_options: { __typename?: 'DefaultExclusionsOptions', exclude_cancelled_and_rescheduled_resources?: boolean | null, exclude_euthanasia_and_qol_resources?: boolean | null, exclude_euthanasia_and_qol_in_appt_notes?: boolean | null }, reference_date_params?: { __typename?: 'ReferenceDateParams', field: string, reference_periods?: Array<{ __typename?: 'ReferencePeriod', quantity: number, unit: TimeUnit, direction: ReferenceDirection }> | null } | null, notification_templates?: Array<{ __typename?: 'NotificationTemplate', id: string, name: string, is_active: boolean, is_archived: boolean, message_methods: Array<MessageMethod> }> | null, error_flags?: Array<{ __typename?: 'CustomerSegmentErrorFlag', filter_column: string, filter_index: number, parameter_index: number, message: string }> | null } | null } };

export type UpdateScheduledBulkMessageMutationVariables = Exact<{
  scheduledBulkMessageId: Scalars['ID']['input'];
  data: UpdateScheduledBulkMessageInput;
}>;


export type UpdateScheduledBulkMessageMutation = { __typename?: 'Mutation', updateScheduledBulkMessage: { __typename?: 'ScheduledBulkMessage', id: string, name: string, send_time?: number | null, subject?: string | null, body?: string | null, email_body?: string | null, email_design?: any | null, email_html?: string | null, message_methods: Array<MessageMethod>, included_clients?: Array<string> | null, excluded_clients?: Array<string> | null, started_at?: number | null, is_active: boolean, is_system: boolean, is_completed: boolean, is_archived: boolean, is_marketing: boolean, cta_url?: string | null, cta_text?: string | null, updated_at: number, created_at: number, clinic?: { __typename?: 'Clinic', id: string } | null, clinic_group?: { __typename?: 'ClinicGroup', id: string, name: string } | null, campaign?: { __typename?: 'Campaign', id: string, name: string, color?: string | null, description?: string | null } | null, email_template?: { __typename?: 'EmailTemplate', id: string, title: string, subject?: string | null, design?: any | null, html?: string | null, status: EmailTemplateStatus, created_at: number, updated_at: number, clinic?: { __typename?: 'Clinic', id: string } | null, clinic_group?: { __typename?: 'ClinicGroup', id: string, name: string } | null } | null, notif_attachments?: Array<{ __typename?: 'Attachment', id: string, filename: string, url: string, type: AttachmentType }> | null, customer_segment?: { __typename?: 'CustomerSegment', id: string, name: string, trigger_entity?: CustomerSegmentTrigger | null, is_hourly?: boolean | null, group_days_ahead?: number | null, should_include_all_overdue?: boolean | null, included_clients?: Array<string> | null, excluded_clients?: Array<string> | null, other_result_exclusion_entity?: string | null, is_archived: boolean, created_at: number, updated_at: number, filters?: Array<{ __typename?: 'CustomerSegmentFilter', type: CustomerSegmentFilterType, only_consider_other_rows?: boolean | null, filters: Array<{ __typename?: 'QueryFilter', column: string, filterOp: FilterOp, value: { __typename?: 'QueryFilterValue', string?: string | null, float?: number | null, boolean?: boolean | null, stringArray?: Array<string> | null, floatArray?: Array<number> | null, millisFromNow?: number | null, relativeTime?: { __typename?: 'RelativeTime', quantity: number, unit: TimeUnit, direction: ReferenceDirection } | null } }> }> | null, excluded_filters: Array<{ __typename?: 'CustomerSegmentFilter', type: CustomerSegmentFilterType, only_consider_other_rows?: boolean | null, filters: Array<{ __typename?: 'QueryFilter', column: string, filterOp: FilterOp, value: { __typename?: 'QueryFilterValue', string?: string | null, float?: number | null, boolean?: boolean | null, stringArray?: Array<string> | null, floatArray?: Array<number> | null, millisFromNow?: number | null, relativeTime?: { __typename?: 'RelativeTime', quantity: number, unit: TimeUnit, direction: ReferenceDirection } | null } }> }>, all_inclusions?: Array<{ __typename?: 'SegmentFilter', foreign_table?: string | null, group?: string | null, parameters: Array<{ __typename?: 'QueryFilter', column: string, filterOp: FilterOp, value: { __typename?: 'QueryFilterValue', string?: string | null, float?: number | null, boolean?: boolean | null, stringArray?: Array<string> | null, floatArray?: Array<number> | null, millisFromNow?: number | null, relativeTime?: { __typename?: 'RelativeTime', quantity: number, unit: TimeUnit, direction: ReferenceDirection } | null } }> }> | null, any_inclusions?: Array<{ __typename?: 'SegmentFilter', foreign_table?: string | null, group?: string | null, parameters: Array<{ __typename?: 'QueryFilter', column: string, filterOp: FilterOp, value: { __typename?: 'QueryFilterValue', string?: string | null, float?: number | null, boolean?: boolean | null, stringArray?: Array<string> | null, floatArray?: Array<number> | null, millisFromNow?: number | null, relativeTime?: { __typename?: 'RelativeTime', quantity: number, unit: TimeUnit, direction: ReferenceDirection } | null } }> }> | null, any_exclusions?: Array<{ __typename?: 'SegmentFilter', foreign_table?: string | null, group?: string | null, parameters: Array<{ __typename?: 'QueryFilter', column: string, filterOp: FilterOp, value: { __typename?: 'QueryFilterValue', string?: string | null, float?: number | null, boolean?: boolean | null, stringArray?: Array<string> | null, floatArray?: Array<number> | null, millisFromNow?: number | null, relativeTime?: { __typename?: 'RelativeTime', quantity: number, unit: TimeUnit, direction: ReferenceDirection } | null } }> }> | null, any_other_exclusions?: Array<{ __typename?: 'SegmentFilter', foreign_table?: string | null, group?: string | null, parameters: Array<{ __typename?: 'QueryFilter', column: string, filterOp: FilterOp, value: { __typename?: 'QueryFilterValue', string?: string | null, float?: number | null, boolean?: boolean | null, stringArray?: Array<string> | null, floatArray?: Array<number> | null, millisFromNow?: number | null, relativeTime?: { __typename?: 'RelativeTime', quantity: number, unit: TimeUnit, direction: ReferenceDirection } | null } }> }> | null, default_exclusions_options: { __typename?: 'DefaultExclusionsOptions', exclude_cancelled_and_rescheduled_resources?: boolean | null, exclude_euthanasia_and_qol_resources?: boolean | null, exclude_euthanasia_and_qol_in_appt_notes?: boolean | null }, reference_date_params?: { __typename?: 'ReferenceDateParams', field: string, reference_periods?: Array<{ __typename?: 'ReferencePeriod', quantity: number, unit: TimeUnit, direction: ReferenceDirection }> | null } | null, notification_templates?: Array<{ __typename?: 'NotificationTemplate', id: string, name: string, is_active: boolean, is_archived: boolean, message_methods: Array<MessageMethod> }> | null, error_flags?: Array<{ __typename?: 'CustomerSegmentErrorFlag', filter_column: string, filter_index: number, parameter_index: number, message: string }> | null } | null } };

export type ArchiveScheduledBulkMessageMutationVariables = Exact<{
  scheduledBulkMessageId: Scalars['ID']['input'];
}>;


export type ArchiveScheduledBulkMessageMutation = { __typename?: 'Mutation', archiveScheduledBulkMessage: { __typename?: 'ScheduledBulkMessage', id: string, name: string, send_time?: number | null, subject?: string | null, body?: string | null, email_body?: string | null, email_design?: any | null, email_html?: string | null, message_methods: Array<MessageMethod>, included_clients?: Array<string> | null, excluded_clients?: Array<string> | null, started_at?: number | null, is_active: boolean, is_system: boolean, is_completed: boolean, is_archived: boolean, is_marketing: boolean, cta_url?: string | null, cta_text?: string | null, updated_at: number, created_at: number, clinic?: { __typename?: 'Clinic', id: string } | null, clinic_group?: { __typename?: 'ClinicGroup', id: string, name: string } | null, campaign?: { __typename?: 'Campaign', id: string, name: string, color?: string | null, description?: string | null } | null, email_template?: { __typename?: 'EmailTemplate', id: string, title: string, subject?: string | null, design?: any | null, html?: string | null, status: EmailTemplateStatus, created_at: number, updated_at: number, clinic?: { __typename?: 'Clinic', id: string } | null, clinic_group?: { __typename?: 'ClinicGroup', id: string, name: string } | null } | null, notif_attachments?: Array<{ __typename?: 'Attachment', id: string, filename: string, url: string, type: AttachmentType }> | null, customer_segment?: { __typename?: 'CustomerSegment', id: string, name: string, trigger_entity?: CustomerSegmentTrigger | null, is_hourly?: boolean | null, group_days_ahead?: number | null, should_include_all_overdue?: boolean | null, included_clients?: Array<string> | null, excluded_clients?: Array<string> | null, other_result_exclusion_entity?: string | null, is_archived: boolean, created_at: number, updated_at: number, filters?: Array<{ __typename?: 'CustomerSegmentFilter', type: CustomerSegmentFilterType, only_consider_other_rows?: boolean | null, filters: Array<{ __typename?: 'QueryFilter', column: string, filterOp: FilterOp, value: { __typename?: 'QueryFilterValue', string?: string | null, float?: number | null, boolean?: boolean | null, stringArray?: Array<string> | null, floatArray?: Array<number> | null, millisFromNow?: number | null, relativeTime?: { __typename?: 'RelativeTime', quantity: number, unit: TimeUnit, direction: ReferenceDirection } | null } }> }> | null, excluded_filters: Array<{ __typename?: 'CustomerSegmentFilter', type: CustomerSegmentFilterType, only_consider_other_rows?: boolean | null, filters: Array<{ __typename?: 'QueryFilter', column: string, filterOp: FilterOp, value: { __typename?: 'QueryFilterValue', string?: string | null, float?: number | null, boolean?: boolean | null, stringArray?: Array<string> | null, floatArray?: Array<number> | null, millisFromNow?: number | null, relativeTime?: { __typename?: 'RelativeTime', quantity: number, unit: TimeUnit, direction: ReferenceDirection } | null } }> }>, all_inclusions?: Array<{ __typename?: 'SegmentFilter', foreign_table?: string | null, group?: string | null, parameters: Array<{ __typename?: 'QueryFilter', column: string, filterOp: FilterOp, value: { __typename?: 'QueryFilterValue', string?: string | null, float?: number | null, boolean?: boolean | null, stringArray?: Array<string> | null, floatArray?: Array<number> | null, millisFromNow?: number | null, relativeTime?: { __typename?: 'RelativeTime', quantity: number, unit: TimeUnit, direction: ReferenceDirection } | null } }> }> | null, any_inclusions?: Array<{ __typename?: 'SegmentFilter', foreign_table?: string | null, group?: string | null, parameters: Array<{ __typename?: 'QueryFilter', column: string, filterOp: FilterOp, value: { __typename?: 'QueryFilterValue', string?: string | null, float?: number | null, boolean?: boolean | null, stringArray?: Array<string> | null, floatArray?: Array<number> | null, millisFromNow?: number | null, relativeTime?: { __typename?: 'RelativeTime', quantity: number, unit: TimeUnit, direction: ReferenceDirection } | null } }> }> | null, any_exclusions?: Array<{ __typename?: 'SegmentFilter', foreign_table?: string | null, group?: string | null, parameters: Array<{ __typename?: 'QueryFilter', column: string, filterOp: FilterOp, value: { __typename?: 'QueryFilterValue', string?: string | null, float?: number | null, boolean?: boolean | null, stringArray?: Array<string> | null, floatArray?: Array<number> | null, millisFromNow?: number | null, relativeTime?: { __typename?: 'RelativeTime', quantity: number, unit: TimeUnit, direction: ReferenceDirection } | null } }> }> | null, any_other_exclusions?: Array<{ __typename?: 'SegmentFilter', foreign_table?: string | null, group?: string | null, parameters: Array<{ __typename?: 'QueryFilter', column: string, filterOp: FilterOp, value: { __typename?: 'QueryFilterValue', string?: string | null, float?: number | null, boolean?: boolean | null, stringArray?: Array<string> | null, floatArray?: Array<number> | null, millisFromNow?: number | null, relativeTime?: { __typename?: 'RelativeTime', quantity: number, unit: TimeUnit, direction: ReferenceDirection } | null } }> }> | null, default_exclusions_options: { __typename?: 'DefaultExclusionsOptions', exclude_cancelled_and_rescheduled_resources?: boolean | null, exclude_euthanasia_and_qol_resources?: boolean | null, exclude_euthanasia_and_qol_in_appt_notes?: boolean | null }, reference_date_params?: { __typename?: 'ReferenceDateParams', field: string, reference_periods?: Array<{ __typename?: 'ReferencePeriod', quantity: number, unit: TimeUnit, direction: ReferenceDirection }> | null } | null, notification_templates?: Array<{ __typename?: 'NotificationTemplate', id: string, name: string, is_active: boolean, is_archived: boolean, message_methods: Array<MessageMethod> }> | null, error_flags?: Array<{ __typename?: 'CustomerSegmentErrorFlag', filter_column: string, filter_index: number, parameter_index: number, message: string }> | null } | null } };

export type DeleteScheduledBulkMessageMutationVariables = Exact<{
  scheduledBulkMessageId: Scalars['ID']['input'];
}>;


export type DeleteScheduledBulkMessageMutation = { __typename?: 'Mutation', deleteScheduledBulkMessage?: any | null };

export type BulkUpdateScheduledBulkMessagesMutationVariables = Exact<{
  ids: Array<Scalars['ID']['input']> | Scalars['ID']['input'];
  data: BulkUpdateScheduledBulkMessagesInput;
}>;


export type BulkUpdateScheduledBulkMessagesMutation = { __typename?: 'Mutation', bulkUpdateScheduledBulkMessages: Array<{ __typename?: 'ScheduledBulkMessage', id: string, is_active: boolean, is_archived: boolean, updated_at: number }> };

export type LinkedBulkMessageChildFieldsFragment = { __typename?: 'ScheduledBulkMessage', id: string, is_active: boolean, is_archived: boolean, send_time?: number | null, started_at?: number | null, is_completed: boolean, clinic?: { __typename?: 'Clinic', id: string } | null, customer_segment?: { __typename?: 'CustomerSegment', id: string, name: string } | null };

export type LinkedScheduledBulkMessageChildrenQueryVariables = Exact<{
  where?: InputMaybe<Array<QueryInput> | QueryInput>;
  pageSize?: InputMaybe<Scalars['NonNegativeInt']['input']>;
}>;


export type LinkedScheduledBulkMessageChildrenQuery = { __typename?: 'Query', queryScheduledBulkMessages: Array<{ __typename?: 'ScheduledBulkMessage', id: string, is_active: boolean, is_archived: boolean, send_time?: number | null, started_at?: number | null, is_completed: boolean, clinic?: { __typename?: 'Clinic', id: string } | null, customer_segment?: { __typename?: 'CustomerSegment', id: string, name: string } | null }> };

export type ScheduledMessageFieldsFragment = { __typename?: 'ScheduledMessage', id: string, text: string, email_text?: string | null, subject?: string | null, message_methods: Array<MessageMethod>, cta_url?: string | null, cta_text?: string | null, send_time: number, status: ScheduledMessageStatus, sent_at?: number | null, sent_message?: string | null, error?: string | null, cancelled_at?: number | null, cancelled_by?: string | null, created_at: number, updated_at: number, clinic: { __typename?: 'Clinic', id: string }, created_by: { __typename?: 'User', id: string, first_name?: string | null, last_name?: string | null }, chat: { __typename?: 'Chat', id: string }, client?: { __typename?: 'Client', id: string, first_name?: string | null, last_name?: string | null } | null, message_attachments?: Array<{ __typename?: 'Attachment', id: string, filename: string, url: string, type: AttachmentType }> | null };

export type CreateScheduledMessageMutationVariables = Exact<{
  data: CreateScheduledMessageInput;
}>;


export type CreateScheduledMessageMutation = { __typename?: 'Mutation', createScheduledMessage: { __typename?: 'ScheduledMessage', id: string, text: string, email_text?: string | null, subject?: string | null, message_methods: Array<MessageMethod>, cta_url?: string | null, cta_text?: string | null, send_time: number, status: ScheduledMessageStatus, sent_at?: number | null, sent_message?: string | null, error?: string | null, cancelled_at?: number | null, cancelled_by?: string | null, created_at: number, updated_at: number, clinic: { __typename?: 'Clinic', id: string }, created_by: { __typename?: 'User', id: string, first_name?: string | null, last_name?: string | null }, chat: { __typename?: 'Chat', id: string }, client?: { __typename?: 'Client', id: string, first_name?: string | null, last_name?: string | null } | null, message_attachments?: Array<{ __typename?: 'Attachment', id: string, filename: string, url: string, type: AttachmentType }> | null } };

export type UpdateScheduledMessageMutationVariables = Exact<{
  scheduledMessageId: Scalars['ID']['input'];
  data: UpdateScheduledMessageInput;
}>;


export type UpdateScheduledMessageMutation = { __typename?: 'Mutation', updateScheduledMessage: { __typename?: 'ScheduledMessage', id: string, text: string, email_text?: string | null, subject?: string | null, message_methods: Array<MessageMethod>, cta_url?: string | null, cta_text?: string | null, send_time: number, status: ScheduledMessageStatus, sent_at?: number | null, sent_message?: string | null, error?: string | null, cancelled_at?: number | null, cancelled_by?: string | null, created_at: number, updated_at: number, clinic: { __typename?: 'Clinic', id: string }, created_by: { __typename?: 'User', id: string, first_name?: string | null, last_name?: string | null }, chat: { __typename?: 'Chat', id: string }, client?: { __typename?: 'Client', id: string, first_name?: string | null, last_name?: string | null } | null, message_attachments?: Array<{ __typename?: 'Attachment', id: string, filename: string, url: string, type: AttachmentType }> | null } };

export type CancelScheduledMessageMutationVariables = Exact<{
  scheduledMessageId: Scalars['ID']['input'];
  cancelledBy: Scalars['ID']['input'];
}>;


export type CancelScheduledMessageMutation = { __typename?: 'Mutation', cancelScheduledMessage: { __typename?: 'ScheduledMessage', id: string, text: string, email_text?: string | null, subject?: string | null, message_methods: Array<MessageMethod>, cta_url?: string | null, cta_text?: string | null, send_time: number, status: ScheduledMessageStatus, sent_at?: number | null, sent_message?: string | null, error?: string | null, cancelled_at?: number | null, cancelled_by?: string | null, created_at: number, updated_at: number, clinic: { __typename?: 'Clinic', id: string }, created_by: { __typename?: 'User', id: string, first_name?: string | null, last_name?: string | null }, chat: { __typename?: 'Chat', id: string }, client?: { __typename?: 'Client', id: string, first_name?: string | null, last_name?: string | null } | null, message_attachments?: Array<{ __typename?: 'Attachment', id: string, filename: string, url: string, type: AttachmentType }> | null } };

export type DeleteScheduledMessageMutationVariables = Exact<{
  scheduledMessageId: Scalars['ID']['input'];
}>;


export type DeleteScheduledMessageMutation = { __typename?: 'Mutation', deleteScheduledMessage?: any | null };

export type QueryScheduledMessagesQueryVariables = Exact<{
  where?: InputMaybe<Array<QueryInput> | QueryInput>;
  page?: InputMaybe<Scalars['NonNegativeInt']['input']>;
  pageSize?: InputMaybe<Scalars['NonNegativeInt']['input']>;
  orderBy?: InputMaybe<OrderByInput>;
}>;


export type QueryScheduledMessagesQuery = { __typename?: 'Query', queryScheduledMessages: Array<{ __typename?: 'ScheduledMessage', id: string, text: string, email_text?: string | null, subject?: string | null, message_methods: Array<MessageMethod>, cta_url?: string | null, cta_text?: string | null, send_time: number, status: ScheduledMessageStatus, sent_at?: number | null, sent_message?: string | null, error?: string | null, cancelled_at?: number | null, cancelled_by?: string | null, created_at: number, updated_at: number, clinic: { __typename?: 'Clinic', id: string }, created_by: { __typename?: 'User', id: string, first_name?: string | null, last_name?: string | null }, chat: { __typename?: 'Chat', id: string }, client?: { __typename?: 'Client', id: string, first_name?: string | null, last_name?: string | null } | null, message_attachments?: Array<{ __typename?: 'Attachment', id: string, filename: string, url: string, type: AttachmentType }> | null }> };

export type CountScheduledMessagesQueryVariables = Exact<{
  where?: InputMaybe<Array<QueryInput> | QueryInput>;
}>;


export type CountScheduledMessagesQuery = { __typename?: 'Query', countScheduledMessages: number };

export type SchedulingRulesFieldsFragment = { __typename?: 'SchedulingRules', id: string, max_per_rule?: number | null, is_active: boolean, patient_type?: PatientTypeEnum | null, client_type?: ClientTypeEnum | null, patient_gender?: AnimalGender | null, fixed_status?: FixedStatus | null, only_modifier?: OnlyModifierEnum | null, is_simple_rule: boolean, created_at: number, updated_at: number, clinic?: { __typename?: 'Clinic', id: string } | null, widget?: { __typename?: 'Widget', id: string } | null, included_clinicians?: Array<{ __typename?: 'Clinician', id: string, name: string, display_name?: string | null, clinic?: { __typename?: 'Clinic', name?: string | null } | null }> | null, included_species?: Array<{ __typename?: 'ClinicSpecies', id: string, species: Species }> | null, included_services?: Array<{ __typename?: 'Service', id: string, name?: string | null, clinic?: { __typename?: 'Clinic', name?: string | null } | null }> | null, included_rooms?: Array<{ __typename?: 'Room', id: string, name: string, display_name?: string | null, clinic?: { __typename?: 'Clinic', name?: string | null } | null }> | null, included_client_audiences?: Array<{ __typename?: 'CustomerSegment', id: string, name: string, trigger_entity?: CustomerSegmentTrigger | null, is_archived: boolean }> | null, included_patient_audiences?: Array<{ __typename?: 'CustomerSegment', id: string, name: string, trigger_entity?: CustomerSegmentTrigger | null, is_archived: boolean }> | null, availability?: { __typename?: 'AvailabilityHours', monday?: Array<{ __typename?: 'TimeInterval', start?: number | null, end?: number | null }> | null, tuesday?: Array<{ __typename?: 'TimeInterval', start?: number | null, end?: number | null }> | null, wednesday?: Array<{ __typename?: 'TimeInterval', start?: number | null, end?: number | null }> | null, thursday?: Array<{ __typename?: 'TimeInterval', start?: number | null, end?: number | null }> | null, friday?: Array<{ __typename?: 'TimeInterval', start?: number | null, end?: number | null }> | null, saturday?: Array<{ __typename?: 'TimeInterval', start?: number | null, end?: number | null }> | null, sunday?: Array<{ __typename?: 'TimeInterval', start?: number | null, end?: number | null }> | null } | null, adjusted_availability?: Array<{ __typename?: 'Availability', date: number, pms_appt_type_pms_id?: string | null, times: Array<{ __typename?: 'TimeInterval', start?: number | null, end?: number | null }>, repeat?: { __typename?: 'RepeatAvailability', daysOfMonth?: Array<number> | null, daysOfWeek?: Array<DayOfWeek> | null, weekOfMonth?: WeekOfMonth | null, frequency: any, unit: RepeatUnit, end_date?: number | null } | null }> | null };

export type SchedulingRulesCategorizedFieldsFragment = { __typename?: 'SchedulingRulesCategorized', not_applicable_rule_ids: Array<string>, applicable_but_not_passed_rule_ids: Array<string>, passed_rule_ids: Array<string> };

export type GetSchedulingRulesCategorizedQueryVariables = Exact<{
  clinicId: Scalars['ID']['input'];
  params: SchedulingRulesCategorizedParams;
  widgetId?: InputMaybe<Scalars['ID']['input']>;
}>;


export type GetSchedulingRulesCategorizedQuery = { __typename?: 'Query', getSchedulingRulesCategorized: { __typename?: 'SchedulingRulesCategorized', not_applicable_rule_ids: Array<string>, applicable_but_not_passed_rule_ids: Array<string>, passed_rule_ids: Array<string> } };

export type SchedulingRuleQueryVariables = Exact<{
  schedulingRulesId: Scalars['ID']['input'];
}>;


export type SchedulingRuleQuery = { __typename?: 'Query', schedulingRule?: { __typename?: 'SchedulingRules', id: string, max_per_rule?: number | null, is_active: boolean, patient_type?: PatientTypeEnum | null, client_type?: ClientTypeEnum | null, patient_gender?: AnimalGender | null, fixed_status?: FixedStatus | null, only_modifier?: OnlyModifierEnum | null, is_simple_rule: boolean, created_at: number, updated_at: number, clinic?: { __typename?: 'Clinic', id: string } | null, widget?: { __typename?: 'Widget', id: string } | null, included_clinicians?: Array<{ __typename?: 'Clinician', id: string, name: string, display_name?: string | null, clinic?: { __typename?: 'Clinic', name?: string | null } | null }> | null, included_species?: Array<{ __typename?: 'ClinicSpecies', id: string, species: Species }> | null, included_services?: Array<{ __typename?: 'Service', id: string, name?: string | null, clinic?: { __typename?: 'Clinic', name?: string | null } | null }> | null, included_rooms?: Array<{ __typename?: 'Room', id: string, name: string, display_name?: string | null, clinic?: { __typename?: 'Clinic', name?: string | null } | null }> | null, included_client_audiences?: Array<{ __typename?: 'CustomerSegment', id: string, name: string, trigger_entity?: CustomerSegmentTrigger | null, is_archived: boolean }> | null, included_patient_audiences?: Array<{ __typename?: 'CustomerSegment', id: string, name: string, trigger_entity?: CustomerSegmentTrigger | null, is_archived: boolean }> | null, availability?: { __typename?: 'AvailabilityHours', monday?: Array<{ __typename?: 'TimeInterval', start?: number | null, end?: number | null }> | null, tuesday?: Array<{ __typename?: 'TimeInterval', start?: number | null, end?: number | null }> | null, wednesday?: Array<{ __typename?: 'TimeInterval', start?: number | null, end?: number | null }> | null, thursday?: Array<{ __typename?: 'TimeInterval', start?: number | null, end?: number | null }> | null, friday?: Array<{ __typename?: 'TimeInterval', start?: number | null, end?: number | null }> | null, saturday?: Array<{ __typename?: 'TimeInterval', start?: number | null, end?: number | null }> | null, sunday?: Array<{ __typename?: 'TimeInterval', start?: number | null, end?: number | null }> | null } | null, adjusted_availability?: Array<{ __typename?: 'Availability', date: number, pms_appt_type_pms_id?: string | null, times: Array<{ __typename?: 'TimeInterval', start?: number | null, end?: number | null }>, repeat?: { __typename?: 'RepeatAvailability', daysOfMonth?: Array<number> | null, daysOfWeek?: Array<DayOfWeek> | null, weekOfMonth?: WeekOfMonth | null, frequency: any, unit: RepeatUnit, end_date?: number | null } | null }> | null } | null };

export type GetSchedulingRulesForClinicQueryVariables = Exact<{
  clinicId: Scalars['ID']['input'];
  page?: InputMaybe<Scalars['NonNegativeInt']['input']>;
  pageSize?: InputMaybe<Scalars['NonNegativeInt']['input']>;
}>;


export type GetSchedulingRulesForClinicQuery = { __typename?: 'Query', schedulingRulesForClinic?: Array<{ __typename?: 'SchedulingRules', id: string, max_per_rule?: number | null, is_active: boolean, patient_type?: PatientTypeEnum | null, client_type?: ClientTypeEnum | null, patient_gender?: AnimalGender | null, fixed_status?: FixedStatus | null, only_modifier?: OnlyModifierEnum | null, is_simple_rule: boolean, created_at: number, updated_at: number, clinic?: { __typename?: 'Clinic', id: string } | null, widget?: { __typename?: 'Widget', id: string } | null, included_clinicians?: Array<{ __typename?: 'Clinician', id: string, name: string, display_name?: string | null, clinic?: { __typename?: 'Clinic', name?: string | null } | null }> | null, included_species?: Array<{ __typename?: 'ClinicSpecies', id: string, species: Species }> | null, included_services?: Array<{ __typename?: 'Service', id: string, name?: string | null, clinic?: { __typename?: 'Clinic', name?: string | null } | null }> | null, included_rooms?: Array<{ __typename?: 'Room', id: string, name: string, display_name?: string | null, clinic?: { __typename?: 'Clinic', name?: string | null } | null }> | null, included_client_audiences?: Array<{ __typename?: 'CustomerSegment', id: string, name: string, trigger_entity?: CustomerSegmentTrigger | null, is_archived: boolean }> | null, included_patient_audiences?: Array<{ __typename?: 'CustomerSegment', id: string, name: string, trigger_entity?: CustomerSegmentTrigger | null, is_archived: boolean }> | null, availability?: { __typename?: 'AvailabilityHours', monday?: Array<{ __typename?: 'TimeInterval', start?: number | null, end?: number | null }> | null, tuesday?: Array<{ __typename?: 'TimeInterval', start?: number | null, end?: number | null }> | null, wednesday?: Array<{ __typename?: 'TimeInterval', start?: number | null, end?: number | null }> | null, thursday?: Array<{ __typename?: 'TimeInterval', start?: number | null, end?: number | null }> | null, friday?: Array<{ __typename?: 'TimeInterval', start?: number | null, end?: number | null }> | null, saturday?: Array<{ __typename?: 'TimeInterval', start?: number | null, end?: number | null }> | null, sunday?: Array<{ __typename?: 'TimeInterval', start?: number | null, end?: number | null }> | null } | null, adjusted_availability?: Array<{ __typename?: 'Availability', date: number, pms_appt_type_pms_id?: string | null, times: Array<{ __typename?: 'TimeInterval', start?: number | null, end?: number | null }>, repeat?: { __typename?: 'RepeatAvailability', daysOfMonth?: Array<number> | null, daysOfWeek?: Array<DayOfWeek> | null, weekOfMonth?: WeekOfMonth | null, frequency: any, unit: RepeatUnit, end_date?: number | null } | null }> | null }> | null };

export type QuerySchedulingRulesQueryVariables = Exact<{
  where?: InputMaybe<Array<QueryInput> | QueryInput>;
  page?: InputMaybe<Scalars['NonNegativeInt']['input']>;
  pageSize?: InputMaybe<Scalars['NonNegativeInt']['input']>;
  orderBy?: InputMaybe<OrderByInput>;
}>;


export type QuerySchedulingRulesQuery = { __typename?: 'Query', querySchedulingRules: Array<{ __typename?: 'SchedulingRules', id: string, max_per_rule?: number | null, is_active: boolean, patient_type?: PatientTypeEnum | null, client_type?: ClientTypeEnum | null, patient_gender?: AnimalGender | null, fixed_status?: FixedStatus | null, only_modifier?: OnlyModifierEnum | null, is_simple_rule: boolean, created_at: number, updated_at: number, clinic?: { __typename?: 'Clinic', id: string } | null, widget?: { __typename?: 'Widget', id: string } | null, included_clinicians?: Array<{ __typename?: 'Clinician', id: string, name: string, display_name?: string | null, clinic?: { __typename?: 'Clinic', name?: string | null } | null }> | null, included_species?: Array<{ __typename?: 'ClinicSpecies', id: string, species: Species }> | null, included_services?: Array<{ __typename?: 'Service', id: string, name?: string | null, clinic?: { __typename?: 'Clinic', name?: string | null } | null }> | null, included_rooms?: Array<{ __typename?: 'Room', id: string, name: string, display_name?: string | null, clinic?: { __typename?: 'Clinic', name?: string | null } | null }> | null, included_client_audiences?: Array<{ __typename?: 'CustomerSegment', id: string, name: string, trigger_entity?: CustomerSegmentTrigger | null, is_archived: boolean }> | null, included_patient_audiences?: Array<{ __typename?: 'CustomerSegment', id: string, name: string, trigger_entity?: CustomerSegmentTrigger | null, is_archived: boolean }> | null, availability?: { __typename?: 'AvailabilityHours', monday?: Array<{ __typename?: 'TimeInterval', start?: number | null, end?: number | null }> | null, tuesday?: Array<{ __typename?: 'TimeInterval', start?: number | null, end?: number | null }> | null, wednesday?: Array<{ __typename?: 'TimeInterval', start?: number | null, end?: number | null }> | null, thursday?: Array<{ __typename?: 'TimeInterval', start?: number | null, end?: number | null }> | null, friday?: Array<{ __typename?: 'TimeInterval', start?: number | null, end?: number | null }> | null, saturday?: Array<{ __typename?: 'TimeInterval', start?: number | null, end?: number | null }> | null, sunday?: Array<{ __typename?: 'TimeInterval', start?: number | null, end?: number | null }> | null } | null, adjusted_availability?: Array<{ __typename?: 'Availability', date: number, pms_appt_type_pms_id?: string | null, times: Array<{ __typename?: 'TimeInterval', start?: number | null, end?: number | null }>, repeat?: { __typename?: 'RepeatAvailability', daysOfMonth?: Array<number> | null, daysOfWeek?: Array<DayOfWeek> | null, weekOfMonth?: WeekOfMonth | null, frequency: any, unit: RepeatUnit, end_date?: number | null } | null }> | null }> };

export type CountSchedulingRulesQueryVariables = Exact<{
  where?: InputMaybe<Array<QueryInput> | QueryInput>;
}>;


export type CountSchedulingRulesQuery = { __typename?: 'Query', countSchedulingRules: number };

export type CountSchedulingRulesForClinicQueryVariables = Exact<{
  clinicId: Scalars['ID']['input'];
}>;


export type CountSchedulingRulesForClinicQuery = { __typename?: 'Query', countSchedulingRulesForClinic: number };

export type GetSchedulingRulesForWidgetQueryVariables = Exact<{
  widgetId: Scalars['ID']['input'];
}>;


export type GetSchedulingRulesForWidgetQuery = { __typename?: 'Query', schedulingRulesForWidget?: Array<{ __typename?: 'SchedulingRules', id: string, max_per_rule?: number | null, is_active: boolean, patient_type?: PatientTypeEnum | null, client_type?: ClientTypeEnum | null, patient_gender?: AnimalGender | null, fixed_status?: FixedStatus | null, only_modifier?: OnlyModifierEnum | null, is_simple_rule: boolean, created_at: number, updated_at: number, clinic?: { __typename?: 'Clinic', id: string } | null, widget?: { __typename?: 'Widget', id: string } | null, included_clinicians?: Array<{ __typename?: 'Clinician', id: string, name: string, display_name?: string | null, clinic?: { __typename?: 'Clinic', name?: string | null } | null }> | null, included_species?: Array<{ __typename?: 'ClinicSpecies', id: string, species: Species }> | null, included_services?: Array<{ __typename?: 'Service', id: string, name?: string | null, clinic?: { __typename?: 'Clinic', name?: string | null } | null }> | null, included_rooms?: Array<{ __typename?: 'Room', id: string, name: string, display_name?: string | null, clinic?: { __typename?: 'Clinic', name?: string | null } | null }> | null, included_client_audiences?: Array<{ __typename?: 'CustomerSegment', id: string, name: string, trigger_entity?: CustomerSegmentTrigger | null, is_archived: boolean }> | null, included_patient_audiences?: Array<{ __typename?: 'CustomerSegment', id: string, name: string, trigger_entity?: CustomerSegmentTrigger | null, is_archived: boolean }> | null, availability?: { __typename?: 'AvailabilityHours', monday?: Array<{ __typename?: 'TimeInterval', start?: number | null, end?: number | null }> | null, tuesday?: Array<{ __typename?: 'TimeInterval', start?: number | null, end?: number | null }> | null, wednesday?: Array<{ __typename?: 'TimeInterval', start?: number | null, end?: number | null }> | null, thursday?: Array<{ __typename?: 'TimeInterval', start?: number | null, end?: number | null }> | null, friday?: Array<{ __typename?: 'TimeInterval', start?: number | null, end?: number | null }> | null, saturday?: Array<{ __typename?: 'TimeInterval', start?: number | null, end?: number | null }> | null, sunday?: Array<{ __typename?: 'TimeInterval', start?: number | null, end?: number | null }> | null } | null, adjusted_availability?: Array<{ __typename?: 'Availability', date: number, pms_appt_type_pms_id?: string | null, times: Array<{ __typename?: 'TimeInterval', start?: number | null, end?: number | null }>, repeat?: { __typename?: 'RepeatAvailability', daysOfMonth?: Array<number> | null, daysOfWeek?: Array<DayOfWeek> | null, weekOfMonth?: WeekOfMonth | null, frequency: any, unit: RepeatUnit, end_date?: number | null } | null }> | null }> | null };

export type UpdateSchedulingRulesMutationVariables = Exact<{
  schedulingRulesId: Scalars['ID']['input'];
  data: UpdateSchedulingRulesInput;
}>;


export type UpdateSchedulingRulesMutation = { __typename?: 'Mutation', updateSchedulingRules: { __typename?: 'SchedulingRules', id: string, max_per_rule?: number | null, is_active: boolean, patient_type?: PatientTypeEnum | null, client_type?: ClientTypeEnum | null, patient_gender?: AnimalGender | null, fixed_status?: FixedStatus | null, only_modifier?: OnlyModifierEnum | null, is_simple_rule: boolean, created_at: number, updated_at: number, clinic?: { __typename?: 'Clinic', id: string } | null, widget?: { __typename?: 'Widget', id: string } | null, included_clinicians?: Array<{ __typename?: 'Clinician', id: string, name: string, display_name?: string | null, clinic?: { __typename?: 'Clinic', name?: string | null } | null }> | null, included_species?: Array<{ __typename?: 'ClinicSpecies', id: string, species: Species }> | null, included_services?: Array<{ __typename?: 'Service', id: string, name?: string | null, clinic?: { __typename?: 'Clinic', name?: string | null } | null }> | null, included_rooms?: Array<{ __typename?: 'Room', id: string, name: string, display_name?: string | null, clinic?: { __typename?: 'Clinic', name?: string | null } | null }> | null, included_client_audiences?: Array<{ __typename?: 'CustomerSegment', id: string, name: string, trigger_entity?: CustomerSegmentTrigger | null, is_archived: boolean }> | null, included_patient_audiences?: Array<{ __typename?: 'CustomerSegment', id: string, name: string, trigger_entity?: CustomerSegmentTrigger | null, is_archived: boolean }> | null, availability?: { __typename?: 'AvailabilityHours', monday?: Array<{ __typename?: 'TimeInterval', start?: number | null, end?: number | null }> | null, tuesday?: Array<{ __typename?: 'TimeInterval', start?: number | null, end?: number | null }> | null, wednesday?: Array<{ __typename?: 'TimeInterval', start?: number | null, end?: number | null }> | null, thursday?: Array<{ __typename?: 'TimeInterval', start?: number | null, end?: number | null }> | null, friday?: Array<{ __typename?: 'TimeInterval', start?: number | null, end?: number | null }> | null, saturday?: Array<{ __typename?: 'TimeInterval', start?: number | null, end?: number | null }> | null, sunday?: Array<{ __typename?: 'TimeInterval', start?: number | null, end?: number | null }> | null } | null, adjusted_availability?: Array<{ __typename?: 'Availability', date: number, pms_appt_type_pms_id?: string | null, times: Array<{ __typename?: 'TimeInterval', start?: number | null, end?: number | null }>, repeat?: { __typename?: 'RepeatAvailability', daysOfMonth?: Array<number> | null, daysOfWeek?: Array<DayOfWeek> | null, weekOfMonth?: WeekOfMonth | null, frequency: any, unit: RepeatUnit, end_date?: number | null } | null }> | null } };

export type CreateSchedulingRulesMutationVariables = Exact<{
  data: CreateSchedulingRulesInput;
}>;


export type CreateSchedulingRulesMutation = { __typename?: 'Mutation', createSchedulingRules: { __typename?: 'SchedulingRules', id: string, max_per_rule?: number | null, is_active: boolean, patient_type?: PatientTypeEnum | null, client_type?: ClientTypeEnum | null, patient_gender?: AnimalGender | null, fixed_status?: FixedStatus | null, only_modifier?: OnlyModifierEnum | null, is_simple_rule: boolean, created_at: number, updated_at: number, clinic?: { __typename?: 'Clinic', id: string } | null, widget?: { __typename?: 'Widget', id: string } | null, included_clinicians?: Array<{ __typename?: 'Clinician', id: string, name: string, display_name?: string | null, clinic?: { __typename?: 'Clinic', name?: string | null } | null }> | null, included_species?: Array<{ __typename?: 'ClinicSpecies', id: string, species: Species }> | null, included_services?: Array<{ __typename?: 'Service', id: string, name?: string | null, clinic?: { __typename?: 'Clinic', name?: string | null } | null }> | null, included_rooms?: Array<{ __typename?: 'Room', id: string, name: string, display_name?: string | null, clinic?: { __typename?: 'Clinic', name?: string | null } | null }> | null, included_client_audiences?: Array<{ __typename?: 'CustomerSegment', id: string, name: string, trigger_entity?: CustomerSegmentTrigger | null, is_archived: boolean }> | null, included_patient_audiences?: Array<{ __typename?: 'CustomerSegment', id: string, name: string, trigger_entity?: CustomerSegmentTrigger | null, is_archived: boolean }> | null, availability?: { __typename?: 'AvailabilityHours', monday?: Array<{ __typename?: 'TimeInterval', start?: number | null, end?: number | null }> | null, tuesday?: Array<{ __typename?: 'TimeInterval', start?: number | null, end?: number | null }> | null, wednesday?: Array<{ __typename?: 'TimeInterval', start?: number | null, end?: number | null }> | null, thursday?: Array<{ __typename?: 'TimeInterval', start?: number | null, end?: number | null }> | null, friday?: Array<{ __typename?: 'TimeInterval', start?: number | null, end?: number | null }> | null, saturday?: Array<{ __typename?: 'TimeInterval', start?: number | null, end?: number | null }> | null, sunday?: Array<{ __typename?: 'TimeInterval', start?: number | null, end?: number | null }> | null } | null, adjusted_availability?: Array<{ __typename?: 'Availability', date: number, pms_appt_type_pms_id?: string | null, times: Array<{ __typename?: 'TimeInterval', start?: number | null, end?: number | null }>, repeat?: { __typename?: 'RepeatAvailability', daysOfMonth?: Array<number> | null, daysOfWeek?: Array<DayOfWeek> | null, weekOfMonth?: WeekOfMonth | null, frequency: any, unit: RepeatUnit, end_date?: number | null } | null }> | null } };

export type DeleteSchedulingRuleMutationVariables = Exact<{
  schedulingRulesId: Scalars['ID']['input'];
}>;


export type DeleteSchedulingRuleMutation = { __typename?: 'Mutation', deleteSchedulingRules?: any | null };

export type ServiceCategoryFieldsFragment = { __typename?: 'ServiceCategory', id: string, order: number, icon?: ServiceCategoryIcon | null, title: string, description: string, requires_confirmation: boolean, confirmation_message?: string | null, created_at: number, updated_at: number };

export type ServiceServiceCategoryFieldsFragment = { __typename?: 'ServiceServiceCategory', service_category: { __typename?: 'ServiceCategory', id: string, order: number, icon?: ServiceCategoryIcon | null, title: string, description: string, requires_confirmation: boolean, confirmation_message?: string | null, created_at: number, updated_at: number } };

export type ServiceCategoryQueryVariables = Exact<{
  id: Scalars['ID']['input'];
}>;


export type ServiceCategoryQuery = { __typename?: 'Query', serviceCategory: { __typename?: 'ServiceCategory', id: string, order: number, icon?: ServiceCategoryIcon | null, title: string, description: string, requires_confirmation: boolean, confirmation_message?: string | null, created_at: number, updated_at: number } };

export type ServiceCategoriesQueryVariables = Exact<{
  clinicId: Scalars['ID']['input'];
}>;


export type ServiceCategoriesQuery = { __typename?: 'Query', serviceCategories: Array<{ __typename?: 'ServiceCategory', id: string, order: number, icon?: ServiceCategoryIcon | null, title: string, description: string, requires_confirmation: boolean, confirmation_message?: string | null, created_at: number, updated_at: number }> };

export type CreateServiceCategoryMutationVariables = Exact<{
  data: CreateServiceCategoryInput;
}>;


export type CreateServiceCategoryMutation = { __typename?: 'Mutation', createServiceCategory: { __typename?: 'ServiceCategory', id: string, order: number, icon?: ServiceCategoryIcon | null, title: string, description: string, requires_confirmation: boolean, confirmation_message?: string | null, created_at: number, updated_at: number } };

export type UpdateServiceCategoryMutationVariables = Exact<{
  id: Scalars['ID']['input'];
  clinicId: Scalars['ID']['input'];
  data: UpdateServiceCategoryInput;
}>;


export type UpdateServiceCategoryMutation = { __typename?: 'Mutation', updateServiceCategory: { __typename?: 'ServiceCategory', id: string, order: number, icon?: ServiceCategoryIcon | null, title: string, description: string, requires_confirmation: boolean, confirmation_message?: string | null, created_at: number, updated_at: number } };

export type DeleteServiceCategoryMutationVariables = Exact<{
  id: Scalars['ID']['input'];
  clinicId: Scalars['ID']['input'];
}>;


export type DeleteServiceCategoryMutation = { __typename?: 'Mutation', deleteServiceCategory?: any | null };

export type ServiceFormFieldsFragment = { __typename?: 'ServiceForm', id: string, is_required_before_booking: boolean, is_required_before_confirming: boolean, client_type?: ClientTypeEnum | null, created_at: number, updated_at: number, form: { __typename?: 'Form', id: string, name?: string | null, form_type: FormType, is_public: boolean, is_active: boolean, is_archived: boolean, does_require_client: boolean, does_require_patient: boolean, writeback_to_strictest_entity: boolean, is_writeback_enabled: boolean, writeback_code_pms_id?: string | null, writeback_code_name?: string | null, form_file_naming_template?: string | null, created_at: number, updated_at: number, clinic?: { __typename?: 'Clinic', id: string } | null, form_fields: { __typename?: 'FormFields', pages?: Array<{ __typename?: 'FormPage', id: string, title?: string | null, description?: string | null, order?: number | null }> | null, fields?: Array<{ __typename?: 'FormElement', id: string, type?: FormElementType | null, content?: string | null, name?: string | null, column_order?: number | null, row_order?: number | null, page_id?: string | null, options?: Array<string> | null, is_required?: boolean | null, value?: string | null, attachments?: Array<{ __typename?: 'FormFileAttachment', id?: string | null, filename?: string | null, mime_type?: string | null, size_bytes?: number | null, thumbnail_url?: string | null, url: string }> | null, field_updates?: Array<{ __typename?: 'FormFieldUpdate', field: FormFieldUpdateField, boolean_value?: boolean | null, option?: string | null }> | null }> | null } }, service: { __typename?: 'Service', id: string, name?: string | null } };

export type CreateServiceFormMutationVariables = Exact<{
  data: CreateServiceFormInput;
}>;


export type CreateServiceFormMutation = { __typename?: 'Mutation', createServiceForm: { __typename?: 'ServiceForm', id: string, is_required_before_booking: boolean, is_required_before_confirming: boolean, client_type?: ClientTypeEnum | null, created_at: number, updated_at: number, form: { __typename?: 'Form', id: string, name?: string | null, form_type: FormType, is_public: boolean, is_active: boolean, is_archived: boolean, does_require_client: boolean, does_require_patient: boolean, writeback_to_strictest_entity: boolean, is_writeback_enabled: boolean, writeback_code_pms_id?: string | null, writeback_code_name?: string | null, form_file_naming_template?: string | null, created_at: number, updated_at: number, clinic?: { __typename?: 'Clinic', id: string } | null, form_fields: { __typename?: 'FormFields', pages?: Array<{ __typename?: 'FormPage', id: string, title?: string | null, description?: string | null, order?: number | null }> | null, fields?: Array<{ __typename?: 'FormElement', id: string, type?: FormElementType | null, content?: string | null, name?: string | null, column_order?: number | null, row_order?: number | null, page_id?: string | null, options?: Array<string> | null, is_required?: boolean | null, value?: string | null, attachments?: Array<{ __typename?: 'FormFileAttachment', id?: string | null, filename?: string | null, mime_type?: string | null, size_bytes?: number | null, thumbnail_url?: string | null, url: string }> | null, field_updates?: Array<{ __typename?: 'FormFieldUpdate', field: FormFieldUpdateField, boolean_value?: boolean | null, option?: string | null }> | null }> | null } }, service: { __typename?: 'Service', id: string, name?: string | null } } };

export type UpdateServiceFormMutationVariables = Exact<{
  id: Scalars['ID']['input'];
  data: UpdateServiceFormInput;
}>;


export type UpdateServiceFormMutation = { __typename?: 'Mutation', updateServiceForm: { __typename?: 'ServiceForm', id: string, is_required_before_booking: boolean, is_required_before_confirming: boolean, client_type?: ClientTypeEnum | null, created_at: number, updated_at: number, form: { __typename?: 'Form', id: string, name?: string | null, form_type: FormType, is_public: boolean, is_active: boolean, is_archived: boolean, does_require_client: boolean, does_require_patient: boolean, writeback_to_strictest_entity: boolean, is_writeback_enabled: boolean, writeback_code_pms_id?: string | null, writeback_code_name?: string | null, form_file_naming_template?: string | null, created_at: number, updated_at: number, clinic?: { __typename?: 'Clinic', id: string } | null, form_fields: { __typename?: 'FormFields', pages?: Array<{ __typename?: 'FormPage', id: string, title?: string | null, description?: string | null, order?: number | null }> | null, fields?: Array<{ __typename?: 'FormElement', id: string, type?: FormElementType | null, content?: string | null, name?: string | null, column_order?: number | null, row_order?: number | null, page_id?: string | null, options?: Array<string> | null, is_required?: boolean | null, value?: string | null, attachments?: Array<{ __typename?: 'FormFileAttachment', id?: string | null, filename?: string | null, mime_type?: string | null, size_bytes?: number | null, thumbnail_url?: string | null, url: string }> | null, field_updates?: Array<{ __typename?: 'FormFieldUpdate', field: FormFieldUpdateField, boolean_value?: boolean | null, option?: string | null }> | null }> | null } }, service: { __typename?: 'Service', id: string, name?: string | null } } };

export type DeleteServiceFormMutationVariables = Exact<{
  serviceId: Scalars['ID']['input'];
  formId: Scalars['ID']['input'];
}>;


export type DeleteServiceFormMutation = { __typename?: 'Mutation', deleteServiceFormByServiceAndForm?: any | null };

export type GetServiceFormQueryVariables = Exact<{
  serviceId: Scalars['ID']['input'];
  formId: Scalars['ID']['input'];
}>;


export type GetServiceFormQuery = { __typename?: 'Query', serviceFormByServiceAndForm?: { __typename?: 'ServiceForm', id: string, is_required_before_booking: boolean, is_required_before_confirming: boolean, client_type?: ClientTypeEnum | null, created_at: number, updated_at: number, form: { __typename?: 'Form', id: string, name?: string | null, form_type: FormType, is_public: boolean, is_active: boolean, is_archived: boolean, does_require_client: boolean, does_require_patient: boolean, writeback_to_strictest_entity: boolean, is_writeback_enabled: boolean, writeback_code_pms_id?: string | null, writeback_code_name?: string | null, form_file_naming_template?: string | null, created_at: number, updated_at: number, clinic?: { __typename?: 'Clinic', id: string } | null, form_fields: { __typename?: 'FormFields', pages?: Array<{ __typename?: 'FormPage', id: string, title?: string | null, description?: string | null, order?: number | null }> | null, fields?: Array<{ __typename?: 'FormElement', id: string, type?: FormElementType | null, content?: string | null, name?: string | null, column_order?: number | null, row_order?: number | null, page_id?: string | null, options?: Array<string> | null, is_required?: boolean | null, value?: string | null, attachments?: Array<{ __typename?: 'FormFileAttachment', id?: string | null, filename?: string | null, mime_type?: string | null, size_bytes?: number | null, thumbnail_url?: string | null, url: string }> | null, field_updates?: Array<{ __typename?: 'FormFieldUpdate', field: FormFieldUpdateField, boolean_value?: boolean | null, option?: string | null }> | null }> | null } }, service: { __typename?: 'Service', id: string, name?: string | null } } | null };

export type QueryServiceFormsQueryVariables = Exact<{
  where?: InputMaybe<Array<QueryInput> | QueryInput>;
  page?: InputMaybe<Scalars['NonNegativeInt']['input']>;
  pageSize?: InputMaybe<Scalars['NonNegativeInt']['input']>;
  orderBy?: InputMaybe<OrderByInput>;
}>;


export type QueryServiceFormsQuery = { __typename?: 'Query', queryServiceForms: Array<{ __typename?: 'ServiceForm', id: string, is_required_before_booking: boolean, is_required_before_confirming: boolean, client_type?: ClientTypeEnum | null, created_at: number, updated_at: number, form: { __typename?: 'Form', id: string, name?: string | null, form_type: FormType, is_public: boolean, is_active: boolean, is_archived: boolean, does_require_client: boolean, does_require_patient: boolean, writeback_to_strictest_entity: boolean, is_writeback_enabled: boolean, writeback_code_pms_id?: string | null, writeback_code_name?: string | null, form_file_naming_template?: string | null, created_at: number, updated_at: number, clinic?: { __typename?: 'Clinic', id: string } | null, form_fields: { __typename?: 'FormFields', pages?: Array<{ __typename?: 'FormPage', id: string, title?: string | null, description?: string | null, order?: number | null }> | null, fields?: Array<{ __typename?: 'FormElement', id: string, type?: FormElementType | null, content?: string | null, name?: string | null, column_order?: number | null, row_order?: number | null, page_id?: string | null, options?: Array<string> | null, is_required?: boolean | null, value?: string | null, attachments?: Array<{ __typename?: 'FormFileAttachment', id?: string | null, filename?: string | null, mime_type?: string | null, size_bytes?: number | null, thumbnail_url?: string | null, url: string }> | null, field_updates?: Array<{ __typename?: 'FormFieldUpdate', field: FormFieldUpdateField, boolean_value?: boolean | null, option?: string | null }> | null }> | null } }, service: { __typename?: 'Service', id: string, name?: string | null } }> };

export type CountServiceFormsQueryVariables = Exact<{
  where?: InputMaybe<Array<QueryInput> | QueryInput>;
}>;


export type CountServiceFormsQuery = { __typename?: 'Query', countServiceForms: number };

export type PricingFieldsFragment = { __typename?: 'ServicePricing', price: any, currency: any, type: ServicePricingType, client_type?: ClientTypeEnum | null };

export type ServicePreConfirmationItemFieldsFragment = { __typename?: 'ServicePreConfirmationItem', title: string, description?: string | null, required?: boolean | null };

export type ServiceFieldsFragment = { __typename?: 'Service', id: string, name?: string | null, order?: number | null, keywords?: string | null, service_types: Array<ServiceType>, is_active?: boolean | null, allow_new?: boolean | null, color?: string | null, description?: string | null, duration?: number | null, allow_returning?: boolean | null, max_per_day?: number | null, max_per_hour?: number | null, excluded_species?: Array<Species> | null, reserved_per_day?: number | null, authorized_levels?: Array<AuthorityLevel> | null, scheduling_buffer_minutes?: number | null, scheduling_min_minutes_away?: number | null, scheduling_max_minutes_away?: number | null, minimum_patient_age_in_days?: number | null, maximum_patient_age_in_days?: number | null, more_info?: string | null, more_info_action_required?: string | null, action_required_acknowledgement_text?: string | null, points: number, drop_off_time?: string | null, pick_up_time?: string | null, is_blocking: boolean, is_reschedule_allowed: boolean, is_cancellation_allowed: boolean, is_primary_for_appt_type: boolean, hide_clinician_preference: boolean, use_previous_doctor: boolean, allowed_appt_type_pms_ids?: Array<string> | null, valid_booking_interval_minutes?: Array<number> | null, only_use_adj_avail_guides: boolean, exclude_from_portal: boolean, created_at: number, updated_at: number, clinic?: { __typename?: 'Clinic', id: string, name?: string | null } | null, service_service_categories?: Array<{ __typename?: 'ServiceServiceCategory', service_category: { __typename?: 'ServiceCategory', id: string, order: number, icon?: ServiceCategoryIcon | null, title: string, description: string, requires_confirmation: boolean, confirmation_message?: string | null, created_at: number, updated_at: number } }> | null, pricing?: { __typename?: 'ServicePricing', price: any, currency: any, type: ServicePricingType, client_type?: ClientTypeEnum | null } | null, pms_appt_type?: { __typename?: 'PmsApptType', id: string, name: string, pms_id: string, description?: string | null, color?: any | null, pms_is_active: boolean } | null, required_room?: { __typename?: 'Room', id: string, pms_id: string, name: string, display_name?: string | null, description?: string | null, concurrent_patients?: number | null, is_active: boolean, does_contribute_to_fill_rate?: boolean | null, valid_booking_interval_minutes?: Array<number> | null, created_at: number, updated_at: number, clinic?: { __typename?: 'Clinic', pms: PracticeManagementSystem, id: string, name?: string | null, time_zone?: string | null } | null, hours?: { __typename?: 'AvailabilityHours', monday?: Array<{ __typename?: 'TimeInterval', start?: number | null, end?: number | null }> | null, tuesday?: Array<{ __typename?: 'TimeInterval', start?: number | null, end?: number | null }> | null, wednesday?: Array<{ __typename?: 'TimeInterval', start?: number | null, end?: number | null }> | null, thursday?: Array<{ __typename?: 'TimeInterval', start?: number | null, end?: number | null }> | null, friday?: Array<{ __typename?: 'TimeInterval', start?: number | null, end?: number | null }> | null, saturday?: Array<{ __typename?: 'TimeInterval', start?: number | null, end?: number | null }> | null, sunday?: Array<{ __typename?: 'TimeInterval', start?: number | null, end?: number | null }> | null } | null, adjusted_availability?: Array<{ __typename?: 'Availability', date: number, pms_appt_type_pms_id?: string | null, times: Array<{ __typename?: 'TimeInterval', start?: number | null, end?: number | null }>, repeat?: { __typename?: 'RepeatAvailability', daysOfMonth?: Array<number> | null, daysOfWeek?: Array<DayOfWeek> | null, weekOfMonth?: WeekOfMonth | null, frequency: any, unit: RepeatUnit, end_date?: number | null } | null }> | null, pms_adjusted_availability?: Array<{ __typename?: 'Availability', date: number, pms_appt_type_pms_id?: string | null, times: Array<{ __typename?: 'TimeInterval', start?: number | null, end?: number | null }>, repeat?: { __typename?: 'RepeatAvailability', daysOfMonth?: Array<number> | null, daysOfWeek?: Array<DayOfWeek> | null, weekOfMonth?: WeekOfMonth | null, frequency: any, unit: RepeatUnit, end_date?: number | null } | null }> | null } | null, default_room?: { __typename?: 'Room', id: string, pms_id: string, name: string, display_name?: string | null, description?: string | null, concurrent_patients?: number | null, is_active: boolean, does_contribute_to_fill_rate?: boolean | null, valid_booking_interval_minutes?: Array<number> | null, created_at: number, updated_at: number, clinic?: { __typename?: 'Clinic', pms: PracticeManagementSystem, id: string, name?: string | null, time_zone?: string | null } | null, hours?: { __typename?: 'AvailabilityHours', monday?: Array<{ __typename?: 'TimeInterval', start?: number | null, end?: number | null }> | null, tuesday?: Array<{ __typename?: 'TimeInterval', start?: number | null, end?: number | null }> | null, wednesday?: Array<{ __typename?: 'TimeInterval', start?: number | null, end?: number | null }> | null, thursday?: Array<{ __typename?: 'TimeInterval', start?: number | null, end?: number | null }> | null, friday?: Array<{ __typename?: 'TimeInterval', start?: number | null, end?: number | null }> | null, saturday?: Array<{ __typename?: 'TimeInterval', start?: number | null, end?: number | null }> | null, sunday?: Array<{ __typename?: 'TimeInterval', start?: number | null, end?: number | null }> | null } | null, adjusted_availability?: Array<{ __typename?: 'Availability', date: number, pms_appt_type_pms_id?: string | null, times: Array<{ __typename?: 'TimeInterval', start?: number | null, end?: number | null }>, repeat?: { __typename?: 'RepeatAvailability', daysOfMonth?: Array<number> | null, daysOfWeek?: Array<DayOfWeek> | null, weekOfMonth?: WeekOfMonth | null, frequency: any, unit: RepeatUnit, end_date?: number | null } | null }> | null, pms_adjusted_availability?: Array<{ __typename?: 'Availability', date: number, pms_appt_type_pms_id?: string | null, times: Array<{ __typename?: 'TimeInterval', start?: number | null, end?: number | null }>, repeat?: { __typename?: 'RepeatAvailability', daysOfMonth?: Array<number> | null, daysOfWeek?: Array<DayOfWeek> | null, weekOfMonth?: WeekOfMonth | null, frequency: any, unit: RepeatUnit, end_date?: number | null } | null }> | null } | null, availability?: { __typename?: 'AvailabilityHours', monday?: Array<{ __typename?: 'TimeInterval', start?: number | null, end?: number | null }> | null, tuesday?: Array<{ __typename?: 'TimeInterval', start?: number | null, end?: number | null }> | null, wednesday?: Array<{ __typename?: 'TimeInterval', start?: number | null, end?: number | null }> | null, thursday?: Array<{ __typename?: 'TimeInterval', start?: number | null, end?: number | null }> | null, friday?: Array<{ __typename?: 'TimeInterval', start?: number | null, end?: number | null }> | null, saturday?: Array<{ __typename?: 'TimeInterval', start?: number | null, end?: number | null }> | null, sunday?: Array<{ __typename?: 'TimeInterval', start?: number | null, end?: number | null }> | null } | null, drop_off_hours?: { __typename?: 'AvailabilityHours', monday?: Array<{ __typename?: 'TimeInterval', start?: number | null, end?: number | null }> | null, tuesday?: Array<{ __typename?: 'TimeInterval', start?: number | null, end?: number | null }> | null, wednesday?: Array<{ __typename?: 'TimeInterval', start?: number | null, end?: number | null }> | null, thursday?: Array<{ __typename?: 'TimeInterval', start?: number | null, end?: number | null }> | null, friday?: Array<{ __typename?: 'TimeInterval', start?: number | null, end?: number | null }> | null, saturday?: Array<{ __typename?: 'TimeInterval', start?: number | null, end?: number | null }> | null, sunday?: Array<{ __typename?: 'TimeInterval', start?: number | null, end?: number | null }> | null } | null, pre_confirmation_checklist?: Array<{ __typename?: 'ServicePreConfirmationItem', title: string, description?: string | null, required?: boolean | null }> | null };

export type ServicePreviewFieldsFragment = { __typename?: 'Service', id: string, name?: string | null, duration?: number | null };

export type GetAllServicesByClinicIdQueryVariables = Exact<{
  clinicId: Scalars['ID']['input'];
}>;


export type GetAllServicesByClinicIdQuery = { __typename?: 'Query', allServicesByClinicId: Array<{ __typename?: 'Service', id: string, name?: string | null, order?: number | null, keywords?: string | null, service_types: Array<ServiceType>, is_active?: boolean | null, allow_new?: boolean | null, color?: string | null, description?: string | null, duration?: number | null, allow_returning?: boolean | null, max_per_day?: number | null, max_per_hour?: number | null, excluded_species?: Array<Species> | null, reserved_per_day?: number | null, authorized_levels?: Array<AuthorityLevel> | null, scheduling_buffer_minutes?: number | null, scheduling_min_minutes_away?: number | null, scheduling_max_minutes_away?: number | null, minimum_patient_age_in_days?: number | null, maximum_patient_age_in_days?: number | null, more_info?: string | null, more_info_action_required?: string | null, action_required_acknowledgement_text?: string | null, points: number, drop_off_time?: string | null, pick_up_time?: string | null, is_blocking: boolean, is_reschedule_allowed: boolean, is_cancellation_allowed: boolean, is_primary_for_appt_type: boolean, hide_clinician_preference: boolean, use_previous_doctor: boolean, allowed_appt_type_pms_ids?: Array<string> | null, valid_booking_interval_minutes?: Array<number> | null, only_use_adj_avail_guides: boolean, exclude_from_portal: boolean, created_at: number, updated_at: number, clinic?: { __typename?: 'Clinic', id: string, name?: string | null } | null, service_service_categories?: Array<{ __typename?: 'ServiceServiceCategory', service_category: { __typename?: 'ServiceCategory', id: string, order: number, icon?: ServiceCategoryIcon | null, title: string, description: string, requires_confirmation: boolean, confirmation_message?: string | null, created_at: number, updated_at: number } }> | null, pricing?: { __typename?: 'ServicePricing', price: any, currency: any, type: ServicePricingType, client_type?: ClientTypeEnum | null } | null, pms_appt_type?: { __typename?: 'PmsApptType', id: string, name: string, pms_id: string, description?: string | null, color?: any | null, pms_is_active: boolean } | null, required_room?: { __typename?: 'Room', id: string, pms_id: string, name: string, display_name?: string | null, description?: string | null, concurrent_patients?: number | null, is_active: boolean, does_contribute_to_fill_rate?: boolean | null, valid_booking_interval_minutes?: Array<number> | null, created_at: number, updated_at: number, clinic?: { __typename?: 'Clinic', pms: PracticeManagementSystem, id: string, name?: string | null, time_zone?: string | null } | null, hours?: { __typename?: 'AvailabilityHours', monday?: Array<{ __typename?: 'TimeInterval', start?: number | null, end?: number | null }> | null, tuesday?: Array<{ __typename?: 'TimeInterval', start?: number | null, end?: number | null }> | null, wednesday?: Array<{ __typename?: 'TimeInterval', start?: number | null, end?: number | null }> | null, thursday?: Array<{ __typename?: 'TimeInterval', start?: number | null, end?: number | null }> | null, friday?: Array<{ __typename?: 'TimeInterval', start?: number | null, end?: number | null }> | null, saturday?: Array<{ __typename?: 'TimeInterval', start?: number | null, end?: number | null }> | null, sunday?: Array<{ __typename?: 'TimeInterval', start?: number | null, end?: number | null }> | null } | null, adjusted_availability?: Array<{ __typename?: 'Availability', date: number, pms_appt_type_pms_id?: string | null, times: Array<{ __typename?: 'TimeInterval', start?: number | null, end?: number | null }>, repeat?: { __typename?: 'RepeatAvailability', daysOfMonth?: Array<number> | null, daysOfWeek?: Array<DayOfWeek> | null, weekOfMonth?: WeekOfMonth | null, frequency: any, unit: RepeatUnit, end_date?: number | null } | null }> | null, pms_adjusted_availability?: Array<{ __typename?: 'Availability', date: number, pms_appt_type_pms_id?: string | null, times: Array<{ __typename?: 'TimeInterval', start?: number | null, end?: number | null }>, repeat?: { __typename?: 'RepeatAvailability', daysOfMonth?: Array<number> | null, daysOfWeek?: Array<DayOfWeek> | null, weekOfMonth?: WeekOfMonth | null, frequency: any, unit: RepeatUnit, end_date?: number | null } | null }> | null } | null, default_room?: { __typename?: 'Room', id: string, pms_id: string, name: string, display_name?: string | null, description?: string | null, concurrent_patients?: number | null, is_active: boolean, does_contribute_to_fill_rate?: boolean | null, valid_booking_interval_minutes?: Array<number> | null, created_at: number, updated_at: number, clinic?: { __typename?: 'Clinic', pms: PracticeManagementSystem, id: string, name?: string | null, time_zone?: string | null } | null, hours?: { __typename?: 'AvailabilityHours', monday?: Array<{ __typename?: 'TimeInterval', start?: number | null, end?: number | null }> | null, tuesday?: Array<{ __typename?: 'TimeInterval', start?: number | null, end?: number | null }> | null, wednesday?: Array<{ __typename?: 'TimeInterval', start?: number | null, end?: number | null }> | null, thursday?: Array<{ __typename?: 'TimeInterval', start?: number | null, end?: number | null }> | null, friday?: Array<{ __typename?: 'TimeInterval', start?: number | null, end?: number | null }> | null, saturday?: Array<{ __typename?: 'TimeInterval', start?: number | null, end?: number | null }> | null, sunday?: Array<{ __typename?: 'TimeInterval', start?: number | null, end?: number | null }> | null } | null, adjusted_availability?: Array<{ __typename?: 'Availability', date: number, pms_appt_type_pms_id?: string | null, times: Array<{ __typename?: 'TimeInterval', start?: number | null, end?: number | null }>, repeat?: { __typename?: 'RepeatAvailability', daysOfMonth?: Array<number> | null, daysOfWeek?: Array<DayOfWeek> | null, weekOfMonth?: WeekOfMonth | null, frequency: any, unit: RepeatUnit, end_date?: number | null } | null }> | null, pms_adjusted_availability?: Array<{ __typename?: 'Availability', date: number, pms_appt_type_pms_id?: string | null, times: Array<{ __typename?: 'TimeInterval', start?: number | null, end?: number | null }>, repeat?: { __typename?: 'RepeatAvailability', daysOfMonth?: Array<number> | null, daysOfWeek?: Array<DayOfWeek> | null, weekOfMonth?: WeekOfMonth | null, frequency: any, unit: RepeatUnit, end_date?: number | null } | null }> | null } | null, availability?: { __typename?: 'AvailabilityHours', monday?: Array<{ __typename?: 'TimeInterval', start?: number | null, end?: number | null }> | null, tuesday?: Array<{ __typename?: 'TimeInterval', start?: number | null, end?: number | null }> | null, wednesday?: Array<{ __typename?: 'TimeInterval', start?: number | null, end?: number | null }> | null, thursday?: Array<{ __typename?: 'TimeInterval', start?: number | null, end?: number | null }> | null, friday?: Array<{ __typename?: 'TimeInterval', start?: number | null, end?: number | null }> | null, saturday?: Array<{ __typename?: 'TimeInterval', start?: number | null, end?: number | null }> | null, sunday?: Array<{ __typename?: 'TimeInterval', start?: number | null, end?: number | null }> | null } | null, drop_off_hours?: { __typename?: 'AvailabilityHours', monday?: Array<{ __typename?: 'TimeInterval', start?: number | null, end?: number | null }> | null, tuesday?: Array<{ __typename?: 'TimeInterval', start?: number | null, end?: number | null }> | null, wednesday?: Array<{ __typename?: 'TimeInterval', start?: number | null, end?: number | null }> | null, thursday?: Array<{ __typename?: 'TimeInterval', start?: number | null, end?: number | null }> | null, friday?: Array<{ __typename?: 'TimeInterval', start?: number | null, end?: number | null }> | null, saturday?: Array<{ __typename?: 'TimeInterval', start?: number | null, end?: number | null }> | null, sunday?: Array<{ __typename?: 'TimeInterval', start?: number | null, end?: number | null }> | null } | null, pre_confirmation_checklist?: Array<{ __typename?: 'ServicePreConfirmationItem', title: string, description?: string | null, required?: boolean | null }> | null }> };

export type QueryServicesQueryVariables = Exact<{
  where?: InputMaybe<Array<QueryInput> | QueryInput>;
  page?: InputMaybe<Scalars['NonNegativeInt']['input']>;
  pageSize?: InputMaybe<Scalars['NonNegativeInt']['input']>;
  orderBy?: InputMaybe<OrderByInput>;
}>;


export type QueryServicesQuery = { __typename?: 'Query', queryServices: Array<{ __typename?: 'Service', id: string, name?: string | null, order?: number | null, keywords?: string | null, service_types: Array<ServiceType>, is_active?: boolean | null, allow_new?: boolean | null, color?: string | null, description?: string | null, duration?: number | null, allow_returning?: boolean | null, max_per_day?: number | null, max_per_hour?: number | null, excluded_species?: Array<Species> | null, reserved_per_day?: number | null, authorized_levels?: Array<AuthorityLevel> | null, scheduling_buffer_minutes?: number | null, scheduling_min_minutes_away?: number | null, scheduling_max_minutes_away?: number | null, minimum_patient_age_in_days?: number | null, maximum_patient_age_in_days?: number | null, more_info?: string | null, more_info_action_required?: string | null, action_required_acknowledgement_text?: string | null, points: number, drop_off_time?: string | null, pick_up_time?: string | null, is_blocking: boolean, is_reschedule_allowed: boolean, is_cancellation_allowed: boolean, is_primary_for_appt_type: boolean, hide_clinician_preference: boolean, use_previous_doctor: boolean, allowed_appt_type_pms_ids?: Array<string> | null, valid_booking_interval_minutes?: Array<number> | null, only_use_adj_avail_guides: boolean, exclude_from_portal: boolean, created_at: number, updated_at: number, clinic?: { __typename?: 'Clinic', id: string, name?: string | null } | null, service_service_categories?: Array<{ __typename?: 'ServiceServiceCategory', service_category: { __typename?: 'ServiceCategory', id: string, order: number, icon?: ServiceCategoryIcon | null, title: string, description: string, requires_confirmation: boolean, confirmation_message?: string | null, created_at: number, updated_at: number } }> | null, pricing?: { __typename?: 'ServicePricing', price: any, currency: any, type: ServicePricingType, client_type?: ClientTypeEnum | null } | null, pms_appt_type?: { __typename?: 'PmsApptType', id: string, name: string, pms_id: string, description?: string | null, color?: any | null, pms_is_active: boolean } | null, required_room?: { __typename?: 'Room', id: string, pms_id: string, name: string, display_name?: string | null, description?: string | null, concurrent_patients?: number | null, is_active: boolean, does_contribute_to_fill_rate?: boolean | null, valid_booking_interval_minutes?: Array<number> | null, created_at: number, updated_at: number, clinic?: { __typename?: 'Clinic', pms: PracticeManagementSystem, id: string, name?: string | null, time_zone?: string | null } | null, hours?: { __typename?: 'AvailabilityHours', monday?: Array<{ __typename?: 'TimeInterval', start?: number | null, end?: number | null }> | null, tuesday?: Array<{ __typename?: 'TimeInterval', start?: number | null, end?: number | null }> | null, wednesday?: Array<{ __typename?: 'TimeInterval', start?: number | null, end?: number | null }> | null, thursday?: Array<{ __typename?: 'TimeInterval', start?: number | null, end?: number | null }> | null, friday?: Array<{ __typename?: 'TimeInterval', start?: number | null, end?: number | null }> | null, saturday?: Array<{ __typename?: 'TimeInterval', start?: number | null, end?: number | null }> | null, sunday?: Array<{ __typename?: 'TimeInterval', start?: number | null, end?: number | null }> | null } | null, adjusted_availability?: Array<{ __typename?: 'Availability', date: number, pms_appt_type_pms_id?: string | null, times: Array<{ __typename?: 'TimeInterval', start?: number | null, end?: number | null }>, repeat?: { __typename?: 'RepeatAvailability', daysOfMonth?: Array<number> | null, daysOfWeek?: Array<DayOfWeek> | null, weekOfMonth?: WeekOfMonth | null, frequency: any, unit: RepeatUnit, end_date?: number | null } | null }> | null, pms_adjusted_availability?: Array<{ __typename?: 'Availability', date: number, pms_appt_type_pms_id?: string | null, times: Array<{ __typename?: 'TimeInterval', start?: number | null, end?: number | null }>, repeat?: { __typename?: 'RepeatAvailability', daysOfMonth?: Array<number> | null, daysOfWeek?: Array<DayOfWeek> | null, weekOfMonth?: WeekOfMonth | null, frequency: any, unit: RepeatUnit, end_date?: number | null } | null }> | null } | null, default_room?: { __typename?: 'Room', id: string, pms_id: string, name: string, display_name?: string | null, description?: string | null, concurrent_patients?: number | null, is_active: boolean, does_contribute_to_fill_rate?: boolean | null, valid_booking_interval_minutes?: Array<number> | null, created_at: number, updated_at: number, clinic?: { __typename?: 'Clinic', pms: PracticeManagementSystem, id: string, name?: string | null, time_zone?: string | null } | null, hours?: { __typename?: 'AvailabilityHours', monday?: Array<{ __typename?: 'TimeInterval', start?: number | null, end?: number | null }> | null, tuesday?: Array<{ __typename?: 'TimeInterval', start?: number | null, end?: number | null }> | null, wednesday?: Array<{ __typename?: 'TimeInterval', start?: number | null, end?: number | null }> | null, thursday?: Array<{ __typename?: 'TimeInterval', start?: number | null, end?: number | null }> | null, friday?: Array<{ __typename?: 'TimeInterval', start?: number | null, end?: number | null }> | null, saturday?: Array<{ __typename?: 'TimeInterval', start?: number | null, end?: number | null }> | null, sunday?: Array<{ __typename?: 'TimeInterval', start?: number | null, end?: number | null }> | null } | null, adjusted_availability?: Array<{ __typename?: 'Availability', date: number, pms_appt_type_pms_id?: string | null, times: Array<{ __typename?: 'TimeInterval', start?: number | null, end?: number | null }>, repeat?: { __typename?: 'RepeatAvailability', daysOfMonth?: Array<number> | null, daysOfWeek?: Array<DayOfWeek> | null, weekOfMonth?: WeekOfMonth | null, frequency: any, unit: RepeatUnit, end_date?: number | null } | null }> | null, pms_adjusted_availability?: Array<{ __typename?: 'Availability', date: number, pms_appt_type_pms_id?: string | null, times: Array<{ __typename?: 'TimeInterval', start?: number | null, end?: number | null }>, repeat?: { __typename?: 'RepeatAvailability', daysOfMonth?: Array<number> | null, daysOfWeek?: Array<DayOfWeek> | null, weekOfMonth?: WeekOfMonth | null, frequency: any, unit: RepeatUnit, end_date?: number | null } | null }> | null } | null, availability?: { __typename?: 'AvailabilityHours', monday?: Array<{ __typename?: 'TimeInterval', start?: number | null, end?: number | null }> | null, tuesday?: Array<{ __typename?: 'TimeInterval', start?: number | null, end?: number | null }> | null, wednesday?: Array<{ __typename?: 'TimeInterval', start?: number | null, end?: number | null }> | null, thursday?: Array<{ __typename?: 'TimeInterval', start?: number | null, end?: number | null }> | null, friday?: Array<{ __typename?: 'TimeInterval', start?: number | null, end?: number | null }> | null, saturday?: Array<{ __typename?: 'TimeInterval', start?: number | null, end?: number | null }> | null, sunday?: Array<{ __typename?: 'TimeInterval', start?: number | null, end?: number | null }> | null } | null, drop_off_hours?: { __typename?: 'AvailabilityHours', monday?: Array<{ __typename?: 'TimeInterval', start?: number | null, end?: number | null }> | null, tuesday?: Array<{ __typename?: 'TimeInterval', start?: number | null, end?: number | null }> | null, wednesday?: Array<{ __typename?: 'TimeInterval', start?: number | null, end?: number | null }> | null, thursday?: Array<{ __typename?: 'TimeInterval', start?: number | null, end?: number | null }> | null, friday?: Array<{ __typename?: 'TimeInterval', start?: number | null, end?: number | null }> | null, saturday?: Array<{ __typename?: 'TimeInterval', start?: number | null, end?: number | null }> | null, sunday?: Array<{ __typename?: 'TimeInterval', start?: number | null, end?: number | null }> | null } | null, pre_confirmation_checklist?: Array<{ __typename?: 'ServicePreConfirmationItem', title: string, description?: string | null, required?: boolean | null }> | null }> };

export type QueryPreviewServicesQueryVariables = Exact<{
  where?: InputMaybe<Array<QueryInput> | QueryInput>;
  page?: InputMaybe<Scalars['NonNegativeInt']['input']>;
  pageSize?: InputMaybe<Scalars['NonNegativeInt']['input']>;
  orderBy?: InputMaybe<OrderByInput>;
}>;


export type QueryPreviewServicesQuery = { __typename?: 'Query', queryServices: Array<{ __typename?: 'Service', id: string, name?: string | null, duration?: number | null }> };

export type CountServicesQueryVariables = Exact<{
  where?: InputMaybe<Array<QueryInput> | QueryInput>;
}>;


export type CountServicesQuery = { __typename?: 'Query', countServices: number };

export type GetServiceQueryVariables = Exact<{
  id: Scalars['ID']['input'];
}>;


export type GetServiceQuery = { __typename?: 'Query', service: { __typename?: 'Service', id: string, name?: string | null, order?: number | null, keywords?: string | null, service_types: Array<ServiceType>, is_active?: boolean | null, allow_new?: boolean | null, color?: string | null, description?: string | null, duration?: number | null, allow_returning?: boolean | null, max_per_day?: number | null, max_per_hour?: number | null, excluded_species?: Array<Species> | null, reserved_per_day?: number | null, authorized_levels?: Array<AuthorityLevel> | null, scheduling_buffer_minutes?: number | null, scheduling_min_minutes_away?: number | null, scheduling_max_minutes_away?: number | null, minimum_patient_age_in_days?: number | null, maximum_patient_age_in_days?: number | null, more_info?: string | null, more_info_action_required?: string | null, action_required_acknowledgement_text?: string | null, points: number, drop_off_time?: string | null, pick_up_time?: string | null, is_blocking: boolean, is_reschedule_allowed: boolean, is_cancellation_allowed: boolean, is_primary_for_appt_type: boolean, hide_clinician_preference: boolean, use_previous_doctor: boolean, allowed_appt_type_pms_ids?: Array<string> | null, valid_booking_interval_minutes?: Array<number> | null, only_use_adj_avail_guides: boolean, exclude_from_portal: boolean, created_at: number, updated_at: number, clinic?: { __typename?: 'Clinic', id: string, name?: string | null } | null, service_service_categories?: Array<{ __typename?: 'ServiceServiceCategory', service_category: { __typename?: 'ServiceCategory', id: string, order: number, icon?: ServiceCategoryIcon | null, title: string, description: string, requires_confirmation: boolean, confirmation_message?: string | null, created_at: number, updated_at: number } }> | null, pricing?: { __typename?: 'ServicePricing', price: any, currency: any, type: ServicePricingType, client_type?: ClientTypeEnum | null } | null, pms_appt_type?: { __typename?: 'PmsApptType', id: string, name: string, pms_id: string, description?: string | null, color?: any | null, pms_is_active: boolean } | null, required_room?: { __typename?: 'Room', id: string, pms_id: string, name: string, display_name?: string | null, description?: string | null, concurrent_patients?: number | null, is_active: boolean, does_contribute_to_fill_rate?: boolean | null, valid_booking_interval_minutes?: Array<number> | null, created_at: number, updated_at: number, clinic?: { __typename?: 'Clinic', pms: PracticeManagementSystem, id: string, name?: string | null, time_zone?: string | null } | null, hours?: { __typename?: 'AvailabilityHours', monday?: Array<{ __typename?: 'TimeInterval', start?: number | null, end?: number | null }> | null, tuesday?: Array<{ __typename?: 'TimeInterval', start?: number | null, end?: number | null }> | null, wednesday?: Array<{ __typename?: 'TimeInterval', start?: number | null, end?: number | null }> | null, thursday?: Array<{ __typename?: 'TimeInterval', start?: number | null, end?: number | null }> | null, friday?: Array<{ __typename?: 'TimeInterval', start?: number | null, end?: number | null }> | null, saturday?: Array<{ __typename?: 'TimeInterval', start?: number | null, end?: number | null }> | null, sunday?: Array<{ __typename?: 'TimeInterval', start?: number | null, end?: number | null }> | null } | null, adjusted_availability?: Array<{ __typename?: 'Availability', date: number, pms_appt_type_pms_id?: string | null, times: Array<{ __typename?: 'TimeInterval', start?: number | null, end?: number | null }>, repeat?: { __typename?: 'RepeatAvailability', daysOfMonth?: Array<number> | null, daysOfWeek?: Array<DayOfWeek> | null, weekOfMonth?: WeekOfMonth | null, frequency: any, unit: RepeatUnit, end_date?: number | null } | null }> | null, pms_adjusted_availability?: Array<{ __typename?: 'Availability', date: number, pms_appt_type_pms_id?: string | null, times: Array<{ __typename?: 'TimeInterval', start?: number | null, end?: number | null }>, repeat?: { __typename?: 'RepeatAvailability', daysOfMonth?: Array<number> | null, daysOfWeek?: Array<DayOfWeek> | null, weekOfMonth?: WeekOfMonth | null, frequency: any, unit: RepeatUnit, end_date?: number | null } | null }> | null } | null, default_room?: { __typename?: 'Room', id: string, pms_id: string, name: string, display_name?: string | null, description?: string | null, concurrent_patients?: number | null, is_active: boolean, does_contribute_to_fill_rate?: boolean | null, valid_booking_interval_minutes?: Array<number> | null, created_at: number, updated_at: number, clinic?: { __typename?: 'Clinic', pms: PracticeManagementSystem, id: string, name?: string | null, time_zone?: string | null } | null, hours?: { __typename?: 'AvailabilityHours', monday?: Array<{ __typename?: 'TimeInterval', start?: number | null, end?: number | null }> | null, tuesday?: Array<{ __typename?: 'TimeInterval', start?: number | null, end?: number | null }> | null, wednesday?: Array<{ __typename?: 'TimeInterval', start?: number | null, end?: number | null }> | null, thursday?: Array<{ __typename?: 'TimeInterval', start?: number | null, end?: number | null }> | null, friday?: Array<{ __typename?: 'TimeInterval', start?: number | null, end?: number | null }> | null, saturday?: Array<{ __typename?: 'TimeInterval', start?: number | null, end?: number | null }> | null, sunday?: Array<{ __typename?: 'TimeInterval', start?: number | null, end?: number | null }> | null } | null, adjusted_availability?: Array<{ __typename?: 'Availability', date: number, pms_appt_type_pms_id?: string | null, times: Array<{ __typename?: 'TimeInterval', start?: number | null, end?: number | null }>, repeat?: { __typename?: 'RepeatAvailability', daysOfMonth?: Array<number> | null, daysOfWeek?: Array<DayOfWeek> | null, weekOfMonth?: WeekOfMonth | null, frequency: any, unit: RepeatUnit, end_date?: number | null } | null }> | null, pms_adjusted_availability?: Array<{ __typename?: 'Availability', date: number, pms_appt_type_pms_id?: string | null, times: Array<{ __typename?: 'TimeInterval', start?: number | null, end?: number | null }>, repeat?: { __typename?: 'RepeatAvailability', daysOfMonth?: Array<number> | null, daysOfWeek?: Array<DayOfWeek> | null, weekOfMonth?: WeekOfMonth | null, frequency: any, unit: RepeatUnit, end_date?: number | null } | null }> | null } | null, availability?: { __typename?: 'AvailabilityHours', monday?: Array<{ __typename?: 'TimeInterval', start?: number | null, end?: number | null }> | null, tuesday?: Array<{ __typename?: 'TimeInterval', start?: number | null, end?: number | null }> | null, wednesday?: Array<{ __typename?: 'TimeInterval', start?: number | null, end?: number | null }> | null, thursday?: Array<{ __typename?: 'TimeInterval', start?: number | null, end?: number | null }> | null, friday?: Array<{ __typename?: 'TimeInterval', start?: number | null, end?: number | null }> | null, saturday?: Array<{ __typename?: 'TimeInterval', start?: number | null, end?: number | null }> | null, sunday?: Array<{ __typename?: 'TimeInterval', start?: number | null, end?: number | null }> | null } | null, drop_off_hours?: { __typename?: 'AvailabilityHours', monday?: Array<{ __typename?: 'TimeInterval', start?: number | null, end?: number | null }> | null, tuesday?: Array<{ __typename?: 'TimeInterval', start?: number | null, end?: number | null }> | null, wednesday?: Array<{ __typename?: 'TimeInterval', start?: number | null, end?: number | null }> | null, thursday?: Array<{ __typename?: 'TimeInterval', start?: number | null, end?: number | null }> | null, friday?: Array<{ __typename?: 'TimeInterval', start?: number | null, end?: number | null }> | null, saturday?: Array<{ __typename?: 'TimeInterval', start?: number | null, end?: number | null }> | null, sunday?: Array<{ __typename?: 'TimeInterval', start?: number | null, end?: number | null }> | null } | null, pre_confirmation_checklist?: Array<{ __typename?: 'ServicePreConfirmationItem', title: string, description?: string | null, required?: boolean | null }> | null } };

export type PaymentIntentFromServiceQueryVariables = Exact<{
  clinicId: Scalars['ID']['input'];
  serviceId: Scalars['ID']['input'];
  customerInfo: CustomerInfoInput;
}>;


export type PaymentIntentFromServiceQuery = { __typename?: 'Query', paymentIntentFromService: { __typename?: 'StripePaymentIntent', id: string, amount: number, client_secret?: string | null } };

export type CreateServiceMutationVariables = Exact<{
  data: CreateServiceInput;
}>;


export type CreateServiceMutation = { __typename?: 'Mutation', createService: { __typename?: 'Service', id: string, name?: string | null, order?: number | null, keywords?: string | null, service_types: Array<ServiceType>, is_active?: boolean | null, allow_new?: boolean | null, color?: string | null, description?: string | null, duration?: number | null, allow_returning?: boolean | null, max_per_day?: number | null, max_per_hour?: number | null, excluded_species?: Array<Species> | null, reserved_per_day?: number | null, authorized_levels?: Array<AuthorityLevel> | null, scheduling_buffer_minutes?: number | null, scheduling_min_minutes_away?: number | null, scheduling_max_minutes_away?: number | null, minimum_patient_age_in_days?: number | null, maximum_patient_age_in_days?: number | null, more_info?: string | null, more_info_action_required?: string | null, action_required_acknowledgement_text?: string | null, points: number, drop_off_time?: string | null, pick_up_time?: string | null, is_blocking: boolean, is_reschedule_allowed: boolean, is_cancellation_allowed: boolean, is_primary_for_appt_type: boolean, hide_clinician_preference: boolean, use_previous_doctor: boolean, allowed_appt_type_pms_ids?: Array<string> | null, valid_booking_interval_minutes?: Array<number> | null, only_use_adj_avail_guides: boolean, exclude_from_portal: boolean, created_at: number, updated_at: number, clinic?: { __typename?: 'Clinic', id: string, name?: string | null } | null, service_service_categories?: Array<{ __typename?: 'ServiceServiceCategory', service_category: { __typename?: 'ServiceCategory', id: string, order: number, icon?: ServiceCategoryIcon | null, title: string, description: string, requires_confirmation: boolean, confirmation_message?: string | null, created_at: number, updated_at: number } }> | null, pricing?: { __typename?: 'ServicePricing', price: any, currency: any, type: ServicePricingType, client_type?: ClientTypeEnum | null } | null, pms_appt_type?: { __typename?: 'PmsApptType', id: string, name: string, pms_id: string, description?: string | null, color?: any | null, pms_is_active: boolean } | null, required_room?: { __typename?: 'Room', id: string, pms_id: string, name: string, display_name?: string | null, description?: string | null, concurrent_patients?: number | null, is_active: boolean, does_contribute_to_fill_rate?: boolean | null, valid_booking_interval_minutes?: Array<number> | null, created_at: number, updated_at: number, clinic?: { __typename?: 'Clinic', pms: PracticeManagementSystem, id: string, name?: string | null, time_zone?: string | null } | null, hours?: { __typename?: 'AvailabilityHours', monday?: Array<{ __typename?: 'TimeInterval', start?: number | null, end?: number | null }> | null, tuesday?: Array<{ __typename?: 'TimeInterval', start?: number | null, end?: number | null }> | null, wednesday?: Array<{ __typename?: 'TimeInterval', start?: number | null, end?: number | null }> | null, thursday?: Array<{ __typename?: 'TimeInterval', start?: number | null, end?: number | null }> | null, friday?: Array<{ __typename?: 'TimeInterval', start?: number | null, end?: number | null }> | null, saturday?: Array<{ __typename?: 'TimeInterval', start?: number | null, end?: number | null }> | null, sunday?: Array<{ __typename?: 'TimeInterval', start?: number | null, end?: number | null }> | null } | null, adjusted_availability?: Array<{ __typename?: 'Availability', date: number, pms_appt_type_pms_id?: string | null, times: Array<{ __typename?: 'TimeInterval', start?: number | null, end?: number | null }>, repeat?: { __typename?: 'RepeatAvailability', daysOfMonth?: Array<number> | null, daysOfWeek?: Array<DayOfWeek> | null, weekOfMonth?: WeekOfMonth | null, frequency: any, unit: RepeatUnit, end_date?: number | null } | null }> | null, pms_adjusted_availability?: Array<{ __typename?: 'Availability', date: number, pms_appt_type_pms_id?: string | null, times: Array<{ __typename?: 'TimeInterval', start?: number | null, end?: number | null }>, repeat?: { __typename?: 'RepeatAvailability', daysOfMonth?: Array<number> | null, daysOfWeek?: Array<DayOfWeek> | null, weekOfMonth?: WeekOfMonth | null, frequency: any, unit: RepeatUnit, end_date?: number | null } | null }> | null } | null, default_room?: { __typename?: 'Room', id: string, pms_id: string, name: string, display_name?: string | null, description?: string | null, concurrent_patients?: number | null, is_active: boolean, does_contribute_to_fill_rate?: boolean | null, valid_booking_interval_minutes?: Array<number> | null, created_at: number, updated_at: number, clinic?: { __typename?: 'Clinic', pms: PracticeManagementSystem, id: string, name?: string | null, time_zone?: string | null } | null, hours?: { __typename?: 'AvailabilityHours', monday?: Array<{ __typename?: 'TimeInterval', start?: number | null, end?: number | null }> | null, tuesday?: Array<{ __typename?: 'TimeInterval', start?: number | null, end?: number | null }> | null, wednesday?: Array<{ __typename?: 'TimeInterval', start?: number | null, end?: number | null }> | null, thursday?: Array<{ __typename?: 'TimeInterval', start?: number | null, end?: number | null }> | null, friday?: Array<{ __typename?: 'TimeInterval', start?: number | null, end?: number | null }> | null, saturday?: Array<{ __typename?: 'TimeInterval', start?: number | null, end?: number | null }> | null, sunday?: Array<{ __typename?: 'TimeInterval', start?: number | null, end?: number | null }> | null } | null, adjusted_availability?: Array<{ __typename?: 'Availability', date: number, pms_appt_type_pms_id?: string | null, times: Array<{ __typename?: 'TimeInterval', start?: number | null, end?: number | null }>, repeat?: { __typename?: 'RepeatAvailability', daysOfMonth?: Array<number> | null, daysOfWeek?: Array<DayOfWeek> | null, weekOfMonth?: WeekOfMonth | null, frequency: any, unit: RepeatUnit, end_date?: number | null } | null }> | null, pms_adjusted_availability?: Array<{ __typename?: 'Availability', date: number, pms_appt_type_pms_id?: string | null, times: Array<{ __typename?: 'TimeInterval', start?: number | null, end?: number | null }>, repeat?: { __typename?: 'RepeatAvailability', daysOfMonth?: Array<number> | null, daysOfWeek?: Array<DayOfWeek> | null, weekOfMonth?: WeekOfMonth | null, frequency: any, unit: RepeatUnit, end_date?: number | null } | null }> | null } | null, availability?: { __typename?: 'AvailabilityHours', monday?: Array<{ __typename?: 'TimeInterval', start?: number | null, end?: number | null }> | null, tuesday?: Array<{ __typename?: 'TimeInterval', start?: number | null, end?: number | null }> | null, wednesday?: Array<{ __typename?: 'TimeInterval', start?: number | null, end?: number | null }> | null, thursday?: Array<{ __typename?: 'TimeInterval', start?: number | null, end?: number | null }> | null, friday?: Array<{ __typename?: 'TimeInterval', start?: number | null, end?: number | null }> | null, saturday?: Array<{ __typename?: 'TimeInterval', start?: number | null, end?: number | null }> | null, sunday?: Array<{ __typename?: 'TimeInterval', start?: number | null, end?: number | null }> | null } | null, drop_off_hours?: { __typename?: 'AvailabilityHours', monday?: Array<{ __typename?: 'TimeInterval', start?: number | null, end?: number | null }> | null, tuesday?: Array<{ __typename?: 'TimeInterval', start?: number | null, end?: number | null }> | null, wednesday?: Array<{ __typename?: 'TimeInterval', start?: number | null, end?: number | null }> | null, thursday?: Array<{ __typename?: 'TimeInterval', start?: number | null, end?: number | null }> | null, friday?: Array<{ __typename?: 'TimeInterval', start?: number | null, end?: number | null }> | null, saturday?: Array<{ __typename?: 'TimeInterval', start?: number | null, end?: number | null }> | null, sunday?: Array<{ __typename?: 'TimeInterval', start?: number | null, end?: number | null }> | null } | null, pre_confirmation_checklist?: Array<{ __typename?: 'ServicePreConfirmationItem', title: string, description?: string | null, required?: boolean | null }> | null } };

export type CreateClinicServiceMutationVariables = Exact<{
  clinicId: Scalars['ID']['input'];
  data: CreateServiceInput;
}>;


export type CreateClinicServiceMutation = { __typename?: 'Mutation', createClinicService: { __typename?: 'Service', id: string, name?: string | null, order?: number | null, keywords?: string | null, service_types: Array<ServiceType>, is_active?: boolean | null, allow_new?: boolean | null, color?: string | null, description?: string | null, duration?: number | null, allow_returning?: boolean | null, max_per_day?: number | null, max_per_hour?: number | null, excluded_species?: Array<Species> | null, reserved_per_day?: number | null, authorized_levels?: Array<AuthorityLevel> | null, scheduling_buffer_minutes?: number | null, scheduling_min_minutes_away?: number | null, scheduling_max_minutes_away?: number | null, minimum_patient_age_in_days?: number | null, maximum_patient_age_in_days?: number | null, more_info?: string | null, more_info_action_required?: string | null, action_required_acknowledgement_text?: string | null, points: number, drop_off_time?: string | null, pick_up_time?: string | null, is_blocking: boolean, is_reschedule_allowed: boolean, is_cancellation_allowed: boolean, is_primary_for_appt_type: boolean, hide_clinician_preference: boolean, use_previous_doctor: boolean, allowed_appt_type_pms_ids?: Array<string> | null, valid_booking_interval_minutes?: Array<number> | null, only_use_adj_avail_guides: boolean, exclude_from_portal: boolean, created_at: number, updated_at: number, clinic?: { __typename?: 'Clinic', id: string, name?: string | null } | null, service_service_categories?: Array<{ __typename?: 'ServiceServiceCategory', service_category: { __typename?: 'ServiceCategory', id: string, order: number, icon?: ServiceCategoryIcon | null, title: string, description: string, requires_confirmation: boolean, confirmation_message?: string | null, created_at: number, updated_at: number } }> | null, pricing?: { __typename?: 'ServicePricing', price: any, currency: any, type: ServicePricingType, client_type?: ClientTypeEnum | null } | null, pms_appt_type?: { __typename?: 'PmsApptType', id: string, name: string, pms_id: string, description?: string | null, color?: any | null, pms_is_active: boolean } | null, required_room?: { __typename?: 'Room', id: string, pms_id: string, name: string, display_name?: string | null, description?: string | null, concurrent_patients?: number | null, is_active: boolean, does_contribute_to_fill_rate?: boolean | null, valid_booking_interval_minutes?: Array<number> | null, created_at: number, updated_at: number, clinic?: { __typename?: 'Clinic', pms: PracticeManagementSystem, id: string, name?: string | null, time_zone?: string | null } | null, hours?: { __typename?: 'AvailabilityHours', monday?: Array<{ __typename?: 'TimeInterval', start?: number | null, end?: number | null }> | null, tuesday?: Array<{ __typename?: 'TimeInterval', start?: number | null, end?: number | null }> | null, wednesday?: Array<{ __typename?: 'TimeInterval', start?: number | null, end?: number | null }> | null, thursday?: Array<{ __typename?: 'TimeInterval', start?: number | null, end?: number | null }> | null, friday?: Array<{ __typename?: 'TimeInterval', start?: number | null, end?: number | null }> | null, saturday?: Array<{ __typename?: 'TimeInterval', start?: number | null, end?: number | null }> | null, sunday?: Array<{ __typename?: 'TimeInterval', start?: number | null, end?: number | null }> | null } | null, adjusted_availability?: Array<{ __typename?: 'Availability', date: number, pms_appt_type_pms_id?: string | null, times: Array<{ __typename?: 'TimeInterval', start?: number | null, end?: number | null }>, repeat?: { __typename?: 'RepeatAvailability', daysOfMonth?: Array<number> | null, daysOfWeek?: Array<DayOfWeek> | null, weekOfMonth?: WeekOfMonth | null, frequency: any, unit: RepeatUnit, end_date?: number | null } | null }> | null, pms_adjusted_availability?: Array<{ __typename?: 'Availability', date: number, pms_appt_type_pms_id?: string | null, times: Array<{ __typename?: 'TimeInterval', start?: number | null, end?: number | null }>, repeat?: { __typename?: 'RepeatAvailability', daysOfMonth?: Array<number> | null, daysOfWeek?: Array<DayOfWeek> | null, weekOfMonth?: WeekOfMonth | null, frequency: any, unit: RepeatUnit, end_date?: number | null } | null }> | null } | null, default_room?: { __typename?: 'Room', id: string, pms_id: string, name: string, display_name?: string | null, description?: string | null, concurrent_patients?: number | null, is_active: boolean, does_contribute_to_fill_rate?: boolean | null, valid_booking_interval_minutes?: Array<number> | null, created_at: number, updated_at: number, clinic?: { __typename?: 'Clinic', pms: PracticeManagementSystem, id: string, name?: string | null, time_zone?: string | null } | null, hours?: { __typename?: 'AvailabilityHours', monday?: Array<{ __typename?: 'TimeInterval', start?: number | null, end?: number | null }> | null, tuesday?: Array<{ __typename?: 'TimeInterval', start?: number | null, end?: number | null }> | null, wednesday?: Array<{ __typename?: 'TimeInterval', start?: number | null, end?: number | null }> | null, thursday?: Array<{ __typename?: 'TimeInterval', start?: number | null, end?: number | null }> | null, friday?: Array<{ __typename?: 'TimeInterval', start?: number | null, end?: number | null }> | null, saturday?: Array<{ __typename?: 'TimeInterval', start?: number | null, end?: number | null }> | null, sunday?: Array<{ __typename?: 'TimeInterval', start?: number | null, end?: number | null }> | null } | null, adjusted_availability?: Array<{ __typename?: 'Availability', date: number, pms_appt_type_pms_id?: string | null, times: Array<{ __typename?: 'TimeInterval', start?: number | null, end?: number | null }>, repeat?: { __typename?: 'RepeatAvailability', daysOfMonth?: Array<number> | null, daysOfWeek?: Array<DayOfWeek> | null, weekOfMonth?: WeekOfMonth | null, frequency: any, unit: RepeatUnit, end_date?: number | null } | null }> | null, pms_adjusted_availability?: Array<{ __typename?: 'Availability', date: number, pms_appt_type_pms_id?: string | null, times: Array<{ __typename?: 'TimeInterval', start?: number | null, end?: number | null }>, repeat?: { __typename?: 'RepeatAvailability', daysOfMonth?: Array<number> | null, daysOfWeek?: Array<DayOfWeek> | null, weekOfMonth?: WeekOfMonth | null, frequency: any, unit: RepeatUnit, end_date?: number | null } | null }> | null } | null, availability?: { __typename?: 'AvailabilityHours', monday?: Array<{ __typename?: 'TimeInterval', start?: number | null, end?: number | null }> | null, tuesday?: Array<{ __typename?: 'TimeInterval', start?: number | null, end?: number | null }> | null, wednesday?: Array<{ __typename?: 'TimeInterval', start?: number | null, end?: number | null }> | null, thursday?: Array<{ __typename?: 'TimeInterval', start?: number | null, end?: number | null }> | null, friday?: Array<{ __typename?: 'TimeInterval', start?: number | null, end?: number | null }> | null, saturday?: Array<{ __typename?: 'TimeInterval', start?: number | null, end?: number | null }> | null, sunday?: Array<{ __typename?: 'TimeInterval', start?: number | null, end?: number | null }> | null } | null, drop_off_hours?: { __typename?: 'AvailabilityHours', monday?: Array<{ __typename?: 'TimeInterval', start?: number | null, end?: number | null }> | null, tuesday?: Array<{ __typename?: 'TimeInterval', start?: number | null, end?: number | null }> | null, wednesday?: Array<{ __typename?: 'TimeInterval', start?: number | null, end?: number | null }> | null, thursday?: Array<{ __typename?: 'TimeInterval', start?: number | null, end?: number | null }> | null, friday?: Array<{ __typename?: 'TimeInterval', start?: number | null, end?: number | null }> | null, saturday?: Array<{ __typename?: 'TimeInterval', start?: number | null, end?: number | null }> | null, sunday?: Array<{ __typename?: 'TimeInterval', start?: number | null, end?: number | null }> | null } | null, pre_confirmation_checklist?: Array<{ __typename?: 'ServicePreConfirmationItem', title: string, description?: string | null, required?: boolean | null }> | null } };

export type UpdateServiceMutationVariables = Exact<{
  id: Scalars['ID']['input'];
  data: UpdateServiceInput;
}>;


export type UpdateServiceMutation = { __typename?: 'Mutation', updateService: { __typename?: 'Service', id: string, name?: string | null, order?: number | null, keywords?: string | null, service_types: Array<ServiceType>, is_active?: boolean | null, allow_new?: boolean | null, color?: string | null, description?: string | null, duration?: number | null, allow_returning?: boolean | null, max_per_day?: number | null, max_per_hour?: number | null, excluded_species?: Array<Species> | null, reserved_per_day?: number | null, authorized_levels?: Array<AuthorityLevel> | null, scheduling_buffer_minutes?: number | null, scheduling_min_minutes_away?: number | null, scheduling_max_minutes_away?: number | null, minimum_patient_age_in_days?: number | null, maximum_patient_age_in_days?: number | null, more_info?: string | null, more_info_action_required?: string | null, action_required_acknowledgement_text?: string | null, points: number, drop_off_time?: string | null, pick_up_time?: string | null, is_blocking: boolean, is_reschedule_allowed: boolean, is_cancellation_allowed: boolean, is_primary_for_appt_type: boolean, hide_clinician_preference: boolean, use_previous_doctor: boolean, allowed_appt_type_pms_ids?: Array<string> | null, valid_booking_interval_minutes?: Array<number> | null, only_use_adj_avail_guides: boolean, exclude_from_portal: boolean, created_at: number, updated_at: number, clinic?: { __typename?: 'Clinic', id: string, name?: string | null } | null, service_service_categories?: Array<{ __typename?: 'ServiceServiceCategory', service_category: { __typename?: 'ServiceCategory', id: string, order: number, icon?: ServiceCategoryIcon | null, title: string, description: string, requires_confirmation: boolean, confirmation_message?: string | null, created_at: number, updated_at: number } }> | null, pricing?: { __typename?: 'ServicePricing', price: any, currency: any, type: ServicePricingType, client_type?: ClientTypeEnum | null } | null, pms_appt_type?: { __typename?: 'PmsApptType', id: string, name: string, pms_id: string, description?: string | null, color?: any | null, pms_is_active: boolean } | null, required_room?: { __typename?: 'Room', id: string, pms_id: string, name: string, display_name?: string | null, description?: string | null, concurrent_patients?: number | null, is_active: boolean, does_contribute_to_fill_rate?: boolean | null, valid_booking_interval_minutes?: Array<number> | null, created_at: number, updated_at: number, clinic?: { __typename?: 'Clinic', pms: PracticeManagementSystem, id: string, name?: string | null, time_zone?: string | null } | null, hours?: { __typename?: 'AvailabilityHours', monday?: Array<{ __typename?: 'TimeInterval', start?: number | null, end?: number | null }> | null, tuesday?: Array<{ __typename?: 'TimeInterval', start?: number | null, end?: number | null }> | null, wednesday?: Array<{ __typename?: 'TimeInterval', start?: number | null, end?: number | null }> | null, thursday?: Array<{ __typename?: 'TimeInterval', start?: number | null, end?: number | null }> | null, friday?: Array<{ __typename?: 'TimeInterval', start?: number | null, end?: number | null }> | null, saturday?: Array<{ __typename?: 'TimeInterval', start?: number | null, end?: number | null }> | null, sunday?: Array<{ __typename?: 'TimeInterval', start?: number | null, end?: number | null }> | null } | null, adjusted_availability?: Array<{ __typename?: 'Availability', date: number, pms_appt_type_pms_id?: string | null, times: Array<{ __typename?: 'TimeInterval', start?: number | null, end?: number | null }>, repeat?: { __typename?: 'RepeatAvailability', daysOfMonth?: Array<number> | null, daysOfWeek?: Array<DayOfWeek> | null, weekOfMonth?: WeekOfMonth | null, frequency: any, unit: RepeatUnit, end_date?: number | null } | null }> | null, pms_adjusted_availability?: Array<{ __typename?: 'Availability', date: number, pms_appt_type_pms_id?: string | null, times: Array<{ __typename?: 'TimeInterval', start?: number | null, end?: number | null }>, repeat?: { __typename?: 'RepeatAvailability', daysOfMonth?: Array<number> | null, daysOfWeek?: Array<DayOfWeek> | null, weekOfMonth?: WeekOfMonth | null, frequency: any, unit: RepeatUnit, end_date?: number | null } | null }> | null } | null, default_room?: { __typename?: 'Room', id: string, pms_id: string, name: string, display_name?: string | null, description?: string | null, concurrent_patients?: number | null, is_active: boolean, does_contribute_to_fill_rate?: boolean | null, valid_booking_interval_minutes?: Array<number> | null, created_at: number, updated_at: number, clinic?: { __typename?: 'Clinic', pms: PracticeManagementSystem, id: string, name?: string | null, time_zone?: string | null } | null, hours?: { __typename?: 'AvailabilityHours', monday?: Array<{ __typename?: 'TimeInterval', start?: number | null, end?: number | null }> | null, tuesday?: Array<{ __typename?: 'TimeInterval', start?: number | null, end?: number | null }> | null, wednesday?: Array<{ __typename?: 'TimeInterval', start?: number | null, end?: number | null }> | null, thursday?: Array<{ __typename?: 'TimeInterval', start?: number | null, end?: number | null }> | null, friday?: Array<{ __typename?: 'TimeInterval', start?: number | null, end?: number | null }> | null, saturday?: Array<{ __typename?: 'TimeInterval', start?: number | null, end?: number | null }> | null, sunday?: Array<{ __typename?: 'TimeInterval', start?: number | null, end?: number | null }> | null } | null, adjusted_availability?: Array<{ __typename?: 'Availability', date: number, pms_appt_type_pms_id?: string | null, times: Array<{ __typename?: 'TimeInterval', start?: number | null, end?: number | null }>, repeat?: { __typename?: 'RepeatAvailability', daysOfMonth?: Array<number> | null, daysOfWeek?: Array<DayOfWeek> | null, weekOfMonth?: WeekOfMonth | null, frequency: any, unit: RepeatUnit, end_date?: number | null } | null }> | null, pms_adjusted_availability?: Array<{ __typename?: 'Availability', date: number, pms_appt_type_pms_id?: string | null, times: Array<{ __typename?: 'TimeInterval', start?: number | null, end?: number | null }>, repeat?: { __typename?: 'RepeatAvailability', daysOfMonth?: Array<number> | null, daysOfWeek?: Array<DayOfWeek> | null, weekOfMonth?: WeekOfMonth | null, frequency: any, unit: RepeatUnit, end_date?: number | null } | null }> | null } | null, availability?: { __typename?: 'AvailabilityHours', monday?: Array<{ __typename?: 'TimeInterval', start?: number | null, end?: number | null }> | null, tuesday?: Array<{ __typename?: 'TimeInterval', start?: number | null, end?: number | null }> | null, wednesday?: Array<{ __typename?: 'TimeInterval', start?: number | null, end?: number | null }> | null, thursday?: Array<{ __typename?: 'TimeInterval', start?: number | null, end?: number | null }> | null, friday?: Array<{ __typename?: 'TimeInterval', start?: number | null, end?: number | null }> | null, saturday?: Array<{ __typename?: 'TimeInterval', start?: number | null, end?: number | null }> | null, sunday?: Array<{ __typename?: 'TimeInterval', start?: number | null, end?: number | null }> | null } | null, drop_off_hours?: { __typename?: 'AvailabilityHours', monday?: Array<{ __typename?: 'TimeInterval', start?: number | null, end?: number | null }> | null, tuesday?: Array<{ __typename?: 'TimeInterval', start?: number | null, end?: number | null }> | null, wednesday?: Array<{ __typename?: 'TimeInterval', start?: number | null, end?: number | null }> | null, thursday?: Array<{ __typename?: 'TimeInterval', start?: number | null, end?: number | null }> | null, friday?: Array<{ __typename?: 'TimeInterval', start?: number | null, end?: number | null }> | null, saturday?: Array<{ __typename?: 'TimeInterval', start?: number | null, end?: number | null }> | null, sunday?: Array<{ __typename?: 'TimeInterval', start?: number | null, end?: number | null }> | null } | null, pre_confirmation_checklist?: Array<{ __typename?: 'ServicePreConfirmationItem', title: string, description?: string | null, required?: boolean | null }> | null } };

export type UpdateClinicServiceMutationVariables = Exact<{
  serviceId: Scalars['ID']['input'];
  clinicId: Scalars['ID']['input'];
  data: UpdateServiceInput;
}>;


export type UpdateClinicServiceMutation = { __typename?: 'Mutation', updateClinicService: { __typename?: 'Service', id: string, name?: string | null, order?: number | null, keywords?: string | null, service_types: Array<ServiceType>, is_active?: boolean | null, allow_new?: boolean | null, color?: string | null, description?: string | null, duration?: number | null, allow_returning?: boolean | null, max_per_day?: number | null, max_per_hour?: number | null, excluded_species?: Array<Species> | null, reserved_per_day?: number | null, authorized_levels?: Array<AuthorityLevel> | null, scheduling_buffer_minutes?: number | null, scheduling_min_minutes_away?: number | null, scheduling_max_minutes_away?: number | null, minimum_patient_age_in_days?: number | null, maximum_patient_age_in_days?: number | null, more_info?: string | null, more_info_action_required?: string | null, action_required_acknowledgement_text?: string | null, points: number, drop_off_time?: string | null, pick_up_time?: string | null, is_blocking: boolean, is_reschedule_allowed: boolean, is_cancellation_allowed: boolean, is_primary_for_appt_type: boolean, hide_clinician_preference: boolean, use_previous_doctor: boolean, allowed_appt_type_pms_ids?: Array<string> | null, valid_booking_interval_minutes?: Array<number> | null, only_use_adj_avail_guides: boolean, exclude_from_portal: boolean, created_at: number, updated_at: number, clinic?: { __typename?: 'Clinic', id: string, name?: string | null } | null, service_service_categories?: Array<{ __typename?: 'ServiceServiceCategory', service_category: { __typename?: 'ServiceCategory', id: string, order: number, icon?: ServiceCategoryIcon | null, title: string, description: string, requires_confirmation: boolean, confirmation_message?: string | null, created_at: number, updated_at: number } }> | null, pricing?: { __typename?: 'ServicePricing', price: any, currency: any, type: ServicePricingType, client_type?: ClientTypeEnum | null } | null, pms_appt_type?: { __typename?: 'PmsApptType', id: string, name: string, pms_id: string, description?: string | null, color?: any | null, pms_is_active: boolean } | null, required_room?: { __typename?: 'Room', id: string, pms_id: string, name: string, display_name?: string | null, description?: string | null, concurrent_patients?: number | null, is_active: boolean, does_contribute_to_fill_rate?: boolean | null, valid_booking_interval_minutes?: Array<number> | null, created_at: number, updated_at: number, clinic?: { __typename?: 'Clinic', pms: PracticeManagementSystem, id: string, name?: string | null, time_zone?: string | null } | null, hours?: { __typename?: 'AvailabilityHours', monday?: Array<{ __typename?: 'TimeInterval', start?: number | null, end?: number | null }> | null, tuesday?: Array<{ __typename?: 'TimeInterval', start?: number | null, end?: number | null }> | null, wednesday?: Array<{ __typename?: 'TimeInterval', start?: number | null, end?: number | null }> | null, thursday?: Array<{ __typename?: 'TimeInterval', start?: number | null, end?: number | null }> | null, friday?: Array<{ __typename?: 'TimeInterval', start?: number | null, end?: number | null }> | null, saturday?: Array<{ __typename?: 'TimeInterval', start?: number | null, end?: number | null }> | null, sunday?: Array<{ __typename?: 'TimeInterval', start?: number | null, end?: number | null }> | null } | null, adjusted_availability?: Array<{ __typename?: 'Availability', date: number, pms_appt_type_pms_id?: string | null, times: Array<{ __typename?: 'TimeInterval', start?: number | null, end?: number | null }>, repeat?: { __typename?: 'RepeatAvailability', daysOfMonth?: Array<number> | null, daysOfWeek?: Array<DayOfWeek> | null, weekOfMonth?: WeekOfMonth | null, frequency: any, unit: RepeatUnit, end_date?: number | null } | null }> | null, pms_adjusted_availability?: Array<{ __typename?: 'Availability', date: number, pms_appt_type_pms_id?: string | null, times: Array<{ __typename?: 'TimeInterval', start?: number | null, end?: number | null }>, repeat?: { __typename?: 'RepeatAvailability', daysOfMonth?: Array<number> | null, daysOfWeek?: Array<DayOfWeek> | null, weekOfMonth?: WeekOfMonth | null, frequency: any, unit: RepeatUnit, end_date?: number | null } | null }> | null } | null, default_room?: { __typename?: 'Room', id: string, pms_id: string, name: string, display_name?: string | null, description?: string | null, concurrent_patients?: number | null, is_active: boolean, does_contribute_to_fill_rate?: boolean | null, valid_booking_interval_minutes?: Array<number> | null, created_at: number, updated_at: number, clinic?: { __typename?: 'Clinic', pms: PracticeManagementSystem, id: string, name?: string | null, time_zone?: string | null } | null, hours?: { __typename?: 'AvailabilityHours', monday?: Array<{ __typename?: 'TimeInterval', start?: number | null, end?: number | null }> | null, tuesday?: Array<{ __typename?: 'TimeInterval', start?: number | null, end?: number | null }> | null, wednesday?: Array<{ __typename?: 'TimeInterval', start?: number | null, end?: number | null }> | null, thursday?: Array<{ __typename?: 'TimeInterval', start?: number | null, end?: number | null }> | null, friday?: Array<{ __typename?: 'TimeInterval', start?: number | null, end?: number | null }> | null, saturday?: Array<{ __typename?: 'TimeInterval', start?: number | null, end?: number | null }> | null, sunday?: Array<{ __typename?: 'TimeInterval', start?: number | null, end?: number | null }> | null } | null, adjusted_availability?: Array<{ __typename?: 'Availability', date: number, pms_appt_type_pms_id?: string | null, times: Array<{ __typename?: 'TimeInterval', start?: number | null, end?: number | null }>, repeat?: { __typename?: 'RepeatAvailability', daysOfMonth?: Array<number> | null, daysOfWeek?: Array<DayOfWeek> | null, weekOfMonth?: WeekOfMonth | null, frequency: any, unit: RepeatUnit, end_date?: number | null } | null }> | null, pms_adjusted_availability?: Array<{ __typename?: 'Availability', date: number, pms_appt_type_pms_id?: string | null, times: Array<{ __typename?: 'TimeInterval', start?: number | null, end?: number | null }>, repeat?: { __typename?: 'RepeatAvailability', daysOfMonth?: Array<number> | null, daysOfWeek?: Array<DayOfWeek> | null, weekOfMonth?: WeekOfMonth | null, frequency: any, unit: RepeatUnit, end_date?: number | null } | null }> | null } | null, availability?: { __typename?: 'AvailabilityHours', monday?: Array<{ __typename?: 'TimeInterval', start?: number | null, end?: number | null }> | null, tuesday?: Array<{ __typename?: 'TimeInterval', start?: number | null, end?: number | null }> | null, wednesday?: Array<{ __typename?: 'TimeInterval', start?: number | null, end?: number | null }> | null, thursday?: Array<{ __typename?: 'TimeInterval', start?: number | null, end?: number | null }> | null, friday?: Array<{ __typename?: 'TimeInterval', start?: number | null, end?: number | null }> | null, saturday?: Array<{ __typename?: 'TimeInterval', start?: number | null, end?: number | null }> | null, sunday?: Array<{ __typename?: 'TimeInterval', start?: number | null, end?: number | null }> | null } | null, drop_off_hours?: { __typename?: 'AvailabilityHours', monday?: Array<{ __typename?: 'TimeInterval', start?: number | null, end?: number | null }> | null, tuesday?: Array<{ __typename?: 'TimeInterval', start?: number | null, end?: number | null }> | null, wednesday?: Array<{ __typename?: 'TimeInterval', start?: number | null, end?: number | null }> | null, thursday?: Array<{ __typename?: 'TimeInterval', start?: number | null, end?: number | null }> | null, friday?: Array<{ __typename?: 'TimeInterval', start?: number | null, end?: number | null }> | null, saturday?: Array<{ __typename?: 'TimeInterval', start?: number | null, end?: number | null }> | null, sunday?: Array<{ __typename?: 'TimeInterval', start?: number | null, end?: number | null }> | null } | null, pre_confirmation_checklist?: Array<{ __typename?: 'ServicePreConfirmationItem', title: string, description?: string | null, required?: boolean | null }> | null } };

export type DeleteServiceMutationVariables = Exact<{
  id: Scalars['ID']['input'];
}>;


export type DeleteServiceMutation = { __typename?: 'Mutation', deleteService?: any | null };

export type DeleteClinicServiceMutationVariables = Exact<{
  serviceId: Scalars['ID']['input'];
  clinicId: Scalars['ID']['input'];
}>;


export type DeleteClinicServiceMutation = { __typename?: 'Mutation', deleteClinicService?: any | null };

export type StripeAccountInfoFieldsFragment = { __typename?: 'StripeAccountInfo', onboarding_link?: any | null, login_link?: any | null, is_onboarded: boolean, requirements?: { __typename?: 'StripeAccountRequirements', current_deadline?: number | null, currently_due?: Array<string | null> | null, disabled_reason?: string | null, eventually_due?: Array<string | null> | null, past_due?: Array<string | null> | null, pending_verification?: Array<string | null> | null } | null, future_requirements?: { __typename?: 'StripeAccountRequirements', current_deadline?: number | null, currently_due?: Array<string | null> | null, disabled_reason?: string | null, eventually_due?: Array<string | null> | null, past_due?: Array<string | null> | null, pending_verification?: Array<string | null> | null } | null };

export type StripeAccountInfoQueryVariables = Exact<{
  clinicId: Scalars['ID']['input'];
  callbackUrls: AccountOnboardLinkInput;
  accountType?: InputMaybe<StripeAccountType>;
}>;


export type StripeAccountInfoQuery = { __typename?: 'Query', stripeAccountInfo: { __typename?: 'StripeAccountInfo', onboarding_link?: any | null, login_link?: any | null, is_onboarded: boolean, requirements?: { __typename?: 'StripeAccountRequirements', current_deadline?: number | null, currently_due?: Array<string | null> | null, disabled_reason?: string | null, eventually_due?: Array<string | null> | null, past_due?: Array<string | null> | null, pending_verification?: Array<string | null> | null } | null, future_requirements?: { __typename?: 'StripeAccountRequirements', current_deadline?: number | null, currently_due?: Array<string | null> | null, disabled_reason?: string | null, eventually_due?: Array<string | null> | null, past_due?: Array<string | null> | null, pending_verification?: Array<string | null> | null } | null } };

export type SupportBotMessageAttachmentFieldsFragment = { __typename?: 'SupportBotMessageAttachment', url: string, kind: SupportBotAttachmentKind, mimeType: string, width?: number | null, height?: number | null, filename?: string | null };

export type SupportBotMessageFieldsFragment = { __typename?: 'SupportBotMessage', role: SupportBotMessageRole, content: string, timestamp: number, status?: SupportBotMessageStatus | null, cutoffReason?: string | null, attachments: Array<{ __typename?: 'SupportBotMessageAttachment', url: string, kind: SupportBotAttachmentKind, mimeType: string, width?: number | null, height?: number | null, filename?: string | null }> };

export type SupportBotConversationOwnerFieldsFragment = { __typename?: 'SupportBotConversationOwner', id: string, name?: string | null, email?: string | null };

export type SupportBotConversationFieldsFragment = { __typename?: 'SupportBotConversation', id: string, title: string, createdAt: number, updatedAt: number, pendingRunId?: string | null, owner?: { __typename?: 'SupportBotConversationOwner', id: string, name?: string | null, email?: string | null } | null, messages: Array<{ __typename?: 'SupportBotMessage', role: SupportBotMessageRole, content: string, timestamp: number, status?: SupportBotMessageStatus | null, cutoffReason?: string | null, attachments: Array<{ __typename?: 'SupportBotMessageAttachment', url: string, kind: SupportBotAttachmentKind, mimeType: string, width?: number | null, height?: number | null, filename?: string | null }> }> };

export type SupportBotRunSnapshotFieldsFragment = { __typename?: 'SupportBotRunSnapshot', runId: string, conversationId: string, status: SupportBotRunStatus, startedAt: number, assistantTextSoFar: string, toolCallCount: number, approxTokens: number, finishedAt?: number | null, durationMs?: number | null, response?: string | null, cutoffReason?: string | null, errorMessage?: string | null, cursorRunId?: string | null, conversation?: { __typename?: 'SupportBotConversation', id: string, title: string, createdAt: number, updatedAt: number, pendingRunId?: string | null, owner?: { __typename?: 'SupportBotConversationOwner', id: string, name?: string | null, email?: string | null } | null, messages: Array<{ __typename?: 'SupportBotMessage', role: SupportBotMessageRole, content: string, timestamp: number, status?: SupportBotMessageStatus | null, cutoffReason?: string | null, attachments: Array<{ __typename?: 'SupportBotMessageAttachment', url: string, kind: SupportBotAttachmentKind, mimeType: string, width?: number | null, height?: number | null, filename?: string | null }> }> } | null };

export type MySupportBotConversationsQueryVariables = Exact<{
  limit?: InputMaybe<Scalars['NonNegativeInt']['input']>;
}>;


export type MySupportBotConversationsQuery = { __typename?: 'Query', mySupportBotConversations: Array<{ __typename?: 'SupportBotConversation', id: string, title: string, createdAt: number, updatedAt: number, pendingRunId?: string | null, owner?: { __typename?: 'SupportBotConversationOwner', id: string, name?: string | null, email?: string | null } | null, messages: Array<{ __typename?: 'SupportBotMessage', role: SupportBotMessageRole, content: string, timestamp: number, status?: SupportBotMessageStatus | null, cutoffReason?: string | null, attachments: Array<{ __typename?: 'SupportBotMessageAttachment', url: string, kind: SupportBotAttachmentKind, mimeType: string, width?: number | null, height?: number | null, filename?: string | null }> }> }> };

export type SupportBotConversationsQueryVariables = Exact<{
  filterUserId?: InputMaybe<Scalars['ID']['input']>;
  limit?: InputMaybe<Scalars['NonNegativeInt']['input']>;
  offset?: InputMaybe<Scalars['NonNegativeInt']['input']>;
}>;


export type SupportBotConversationsQuery = { __typename?: 'Query', supportBotConversations: Array<{ __typename?: 'SupportBotConversation', id: string, title: string, createdAt: number, updatedAt: number, pendingRunId?: string | null, owner?: { __typename?: 'SupportBotConversationOwner', id: string, name?: string | null, email?: string | null } | null, messages: Array<{ __typename?: 'SupportBotMessage', role: SupportBotMessageRole, content: string, timestamp: number, status?: SupportBotMessageStatus | null, cutoffReason?: string | null, attachments: Array<{ __typename?: 'SupportBotMessageAttachment', url: string, kind: SupportBotAttachmentKind, mimeType: string, width?: number | null, height?: number | null, filename?: string | null }> }> }> };

export type SupportBotConversationOwnersQueryVariables = Exact<{ [key: string]: never; }>;


export type SupportBotConversationOwnersQuery = { __typename?: 'Query', supportBotConversationOwners: Array<{ __typename?: 'SupportBotConversationOwner', id: string, name?: string | null, email?: string | null }> };

export type SupportBotConversationQueryVariables = Exact<{
  id: Scalars['ID']['input'];
}>;


export type SupportBotConversationQuery = { __typename?: 'Query', supportBotConversation?: { __typename?: 'SupportBotConversation', id: string, title: string, createdAt: number, updatedAt: number, pendingRunId?: string | null, owner?: { __typename?: 'SupportBotConversationOwner', id: string, name?: string | null, email?: string | null } | null, messages: Array<{ __typename?: 'SupportBotMessage', role: SupportBotMessageRole, content: string, timestamp: number, status?: SupportBotMessageStatus | null, cutoffReason?: string | null, attachments: Array<{ __typename?: 'SupportBotMessageAttachment', url: string, kind: SupportBotAttachmentKind, mimeType: string, width?: number | null, height?: number | null, filename?: string | null }> }> } | null };

export type SupportBotRunStatusQueryVariables = Exact<{
  runId: Scalars['ID']['input'];
}>;


export type SupportBotRunStatusQuery = { __typename?: 'Query', supportBotRunStatus: { __typename?: 'SupportBotRunSnapshot', runId: string, conversationId: string, status: SupportBotRunStatus, startedAt: number, assistantTextSoFar: string, toolCallCount: number, approxTokens: number, finishedAt?: number | null, durationMs?: number | null, response?: string | null, cutoffReason?: string | null, errorMessage?: string | null, cursorRunId?: string | null, conversation?: { __typename?: 'SupportBotConversation', id: string, title: string, createdAt: number, updatedAt: number, pendingRunId?: string | null, owner?: { __typename?: 'SupportBotConversationOwner', id: string, name?: string | null, email?: string | null } | null, messages: Array<{ __typename?: 'SupportBotMessage', role: SupportBotMessageRole, content: string, timestamp: number, status?: SupportBotMessageStatus | null, cutoffReason?: string | null, attachments: Array<{ __typename?: 'SupportBotMessageAttachment', url: string, kind: SupportBotAttachmentKind, mimeType: string, width?: number | null, height?: number | null, filename?: string | null }> }> } | null } };

export type SendSupportBotMessageMutationVariables = Exact<{
  input: SendSupportBotMessageInput;
}>;


export type SendSupportBotMessageMutation = { __typename?: 'Mutation', sendSupportBotMessage: { __typename?: 'SupportBotMessageStarted', runId: string, conversationId: string, status: SupportBotRunStatus, conversation: { __typename?: 'SupportBotConversation', id: string, title: string, createdAt: number, updatedAt: number, pendingRunId?: string | null, owner?: { __typename?: 'SupportBotConversationOwner', id: string, name?: string | null, email?: string | null } | null, messages: Array<{ __typename?: 'SupportBotMessage', role: SupportBotMessageRole, content: string, timestamp: number, status?: SupportBotMessageStatus | null, cutoffReason?: string | null, attachments: Array<{ __typename?: 'SupportBotMessageAttachment', url: string, kind: SupportBotAttachmentKind, mimeType: string, width?: number | null, height?: number | null, filename?: string | null }> }> } } };

export type FillRateResultFieldsFragment = { __typename?: 'FillRateResult', clinic_id?: string | null, clinician_id?: string | null, room_id?: string | null, fill_rate: number, open_minutes: number, working_minutes: number };

export type GetFillRateForTimeRangeQueryVariables = Exact<{
  clinicId: Scalars['ID']['input'];
  startTime: Scalars['NonNegativeInt']['input'];
  endTime: Scalars['NonNegativeInt']['input'];
}>;


export type GetFillRateForTimeRangeQuery = { __typename?: 'Query', getFillRateForTimeRange: { __typename?: 'ClinicFillRateResult', clinic_fill_rate?: { __typename?: 'FillRateResult', clinic_id?: string | null, clinician_id?: string | null, room_id?: string | null, fill_rate: number, open_minutes: number, working_minutes: number } | null, clinician_fill_rates: Array<{ __typename?: 'FillRateResult', clinic_id?: string | null, clinician_id?: string | null, room_id?: string | null, fill_rate: number, open_minutes: number, working_minutes: number }>, room_fill_rates: Array<{ __typename?: 'FillRateResult', clinic_id?: string | null, clinician_id?: string | null, room_id?: string | null, fill_rate: number, open_minutes: number, working_minutes: number }> } };

export type GetFillRateForClinicianTimeRangeQueryVariables = Exact<{
  clinicianId: Scalars['ID']['input'];
  startTime: Scalars['NonNegativeInt']['input'];
  endTime: Scalars['NonNegativeInt']['input'];
}>;


export type GetFillRateForClinicianTimeRangeQuery = { __typename?: 'Query', getFillRateForClinicianTimeRange: { __typename?: 'FillRateResult', clinic_id?: string | null, clinician_id?: string | null, room_id?: string | null, fill_rate: number, open_minutes: number, working_minutes: number } };

export type TransactionFieldsFragment = { __typename?: 'Transaction', id: string, clinic_id: string, date?: number | null, amount?: string | null, type?: TransactionType | null };

export type GetTransactionsByClinicAndRangeQueryVariables = Exact<{
  clinicId: Scalars['ID']['input'];
  pms?: InputMaybe<PracticeManagementSystem>;
  start_time: Scalars['NonNegativeInt']['input'];
  end_time: Scalars['NonNegativeInt']['input'];
}>;


export type GetTransactionsByClinicAndRangeQuery = { __typename?: 'Query', getTransactionsByClinicAndRange: Array<{ __typename?: 'Transaction', id: string, clinic_id: string, date?: number | null, amount?: string | null, type?: TransactionType | null }> };

export type UserTrackingMetricFieldsFragment = { __typename?: 'UserTrackingMetricResult', metric: UserTrackingMetric, numerator_count: number, denominator_count: number, percentage?: number | null };

export type GetUserTrackingSummaryQueryVariables = Exact<{
  clinicId: Scalars['ID']['input'];
}>;


export type GetUserTrackingSummaryQuery = { __typename?: 'Query', userTrackingSummary: { __typename?: 'UserTrackingSummary', portal_adoption: { __typename?: 'UserTrackingMetricResult', metric: UserTrackingMetric, numerator_count: number, denominator_count: number, percentage?: number | null }, app_conversion: { __typename?: 'UserTrackingMetricResult', metric: UserTrackingMetric, numerator_count: number, denominator_count: number, percentage?: number | null }, app_adoption: { __typename?: 'UserTrackingMetricResult', metric: UserTrackingMetric, numerator_count: number, denominator_count: number, percentage?: number | null } } };

export type GetUserTrackingClientsQueryVariables = Exact<{
  clinicId: Scalars['ID']['input'];
  metric: UserTrackingMetric;
  membership: UserTrackingMembership;
  search?: InputMaybe<Scalars['String']['input']>;
  page?: InputMaybe<Scalars['NonNegativeInt']['input']>;
  pageSize?: InputMaybe<Scalars['NonNegativeInt']['input']>;
}>;


export type GetUserTrackingClientsQuery = { __typename?: 'Query', userTrackingClients: { __typename?: 'UserTrackingClientPage', count: number, results: Array<{ __typename?: 'UserTrackingClient', has_portal_account: boolean, has_mobile_app: boolean, client: { __typename?: 'Client', id: string, first_name?: string | null, last_name?: string | null, email?: string | null, phone?: string | null, address?: { __typename?: 'Address', country?: string | null } | null } }> } };

export type CreateUserTrackingBulkMessageMutationVariables = Exact<{
  clinicId: Scalars['ID']['input'];
  metric: UserTrackingMetric;
  membership: UserTrackingMembership;
}>;


export type CreateUserTrackingBulkMessageMutation = { __typename?: 'Mutation', createUserTrackingBulkMessage: { __typename?: 'ScheduledBulkMessage', id: string } };

export type UserFieldsFragment = { __typename?: 'User', id: string, first_name?: string | null, last_name?: string | null, email?: any | null, phone?: string | null, phone_country?: string | null, avatar_url?: string | null, role?: AuthRoles | null, enabled_notification_sounds?: Array<UserNotificationSound> | null, notify_email_on?: Array<NotifyClinicOn> | null, notify_sound_on?: Array<NotifyClinicOn> | null, notify_desktop_on?: Array<NotifyClinicOn> | null, must_reset_password?: boolean | null, invitation_status?: UserInvitationStatus | null, invited_at?: number | null, created_at: number, updated_at: number };

export type GetUserQueryVariables = Exact<{
  id: Scalars['ID']['input'];
}>;


export type GetUserQuery = { __typename?: 'Query', user?: { __typename?: 'User', id: string, first_name?: string | null, last_name?: string | null, email?: any | null, phone?: string | null, phone_country?: string | null, avatar_url?: string | null, role?: AuthRoles | null, enabled_notification_sounds?: Array<UserNotificationSound> | null, notify_email_on?: Array<NotifyClinicOn> | null, notify_sound_on?: Array<NotifyClinicOn> | null, notify_desktop_on?: Array<NotifyClinicOn> | null, must_reset_password?: boolean | null, invitation_status?: UserInvitationStatus | null, invited_at?: number | null, created_at: number, updated_at: number } | null };

export type GenerateIntercomJwtQueryVariables = Exact<{ [key: string]: never; }>;


export type GenerateIntercomJwtQuery = { __typename?: 'Query', generateIntercomJwt?: string | null };

export type SearchUsersQueryVariables = Exact<{
  roles?: InputMaybe<Array<AuthRoles> | AuthRoles>;
  limit?: InputMaybe<Scalars['NonNegativeInt']['input']>;
  startAtId?: InputMaybe<Scalars['String']['input']>;
}>;


export type SearchUsersQuery = { __typename?: 'Query', searchUsers: Array<{ __typename?: 'User', id: string, first_name?: string | null, last_name?: string | null, email?: any | null, phone?: string | null, phone_country?: string | null, avatar_url?: string | null, role?: AuthRoles | null, enabled_notification_sounds?: Array<UserNotificationSound> | null, notify_email_on?: Array<NotifyClinicOn> | null, notify_sound_on?: Array<NotifyClinicOn> | null, notify_desktop_on?: Array<NotifyClinicOn> | null, must_reset_password?: boolean | null, invitation_status?: UserInvitationStatus | null, invited_at?: number | null, created_at: number, updated_at: number }> };

export type QueryUsersQueryVariables = Exact<{
  where?: InputMaybe<Array<QueryInput> | QueryInput>;
  page?: InputMaybe<Scalars['NonNegativeInt']['input']>;
  pageSize?: InputMaybe<Scalars['NonNegativeInt']['input']>;
  orderBy?: InputMaybe<OrderByInput>;
}>;


export type QueryUsersQuery = { __typename?: 'Query', queryUsers: Array<{ __typename?: 'User', id: string, first_name?: string | null, last_name?: string | null, email?: any | null, phone?: string | null, phone_country?: string | null, avatar_url?: string | null, role?: AuthRoles | null, enabled_notification_sounds?: Array<UserNotificationSound> | null, notify_email_on?: Array<NotifyClinicOn> | null, notify_sound_on?: Array<NotifyClinicOn> | null, notify_desktop_on?: Array<NotifyClinicOn> | null, must_reset_password?: boolean | null, invitation_status?: UserInvitationStatus | null, invited_at?: number | null, created_at: number, updated_at: number }> };

export type CountUsersQueryVariables = Exact<{
  where?: InputMaybe<Array<QueryInput> | QueryInput>;
}>;


export type CountUsersQuery = { __typename?: 'Query', countUsers: number };

export type CheckForUserByEmailQueryVariables = Exact<{
  email: Scalars['String']['input'];
}>;


export type CheckForUserByEmailQuery = { __typename?: 'Query', checkForUserByEmail?: Array<{ __typename?: 'User', id: string, first_name?: string | null, last_name?: string | null, email?: any | null, phone?: string | null, phone_country?: string | null, avatar_url?: string | null, role?: AuthRoles | null, enabled_notification_sounds?: Array<UserNotificationSound> | null, notify_email_on?: Array<NotifyClinicOn> | null, notify_sound_on?: Array<NotifyClinicOn> | null, notify_desktop_on?: Array<NotifyClinicOn> | null, must_reset_password?: boolean | null, invitation_status?: UserInvitationStatus | null, invited_at?: number | null, created_at: number, updated_at: number }> | null };

export type CheckUserDesktopNotificationTokenQueryVariables = Exact<{
  id: Scalars['ID']['input'];
  token: Scalars['String']['input'];
}>;


export type CheckUserDesktopNotificationTokenQuery = { __typename?: 'Query', checkUserDesktopNotificationToken?: boolean | null };

export type UpdateUserDesktopNotificationTokenMutationVariables = Exact<{
  id: Scalars['ID']['input'];
  token: Scalars['String']['input'];
}>;


export type UpdateUserDesktopNotificationTokenMutation = { __typename?: 'Mutation', updateUserDesktopNotificationToken?: any | null };

export type CreateUserMutationVariables = Exact<{
  email: Scalars['String']['input'];
  password: Scalars['String']['input'];
  data: CreateUserInput;
  role?: InputMaybe<Scalars['String']['input']>;
}>;


export type CreateUserMutation = { __typename?: 'Mutation', createUser: { __typename?: 'User', id: string, first_name?: string | null, last_name?: string | null, email?: any | null, phone?: string | null, phone_country?: string | null, avatar_url?: string | null, role?: AuthRoles | null, enabled_notification_sounds?: Array<UserNotificationSound> | null, notify_email_on?: Array<NotifyClinicOn> | null, notify_sound_on?: Array<NotifyClinicOn> | null, notify_desktop_on?: Array<NotifyClinicOn> | null, must_reset_password?: boolean | null, invitation_status?: UserInvitationStatus | null, invited_at?: number | null, created_at: number, updated_at: number } };

export type UpdateUserMutationVariables = Exact<{
  updateUserId: Scalars['ID']['input'];
  data: UpdateUserInput;
}>;


export type UpdateUserMutation = { __typename?: 'Mutation', updateUser: { __typename?: 'User', id: string, first_name?: string | null, last_name?: string | null, email?: any | null, phone?: string | null, phone_country?: string | null, avatar_url?: string | null, role?: AuthRoles | null, enabled_notification_sounds?: Array<UserNotificationSound> | null, notify_email_on?: Array<NotifyClinicOn> | null, notify_sound_on?: Array<NotifyClinicOn> | null, notify_desktop_on?: Array<NotifyClinicOn> | null, must_reset_password?: boolean | null, invitation_status?: UserInvitationStatus | null, invited_at?: number | null, created_at: number, updated_at: number } };

export type BulkCreateUsersMutationVariables = Exact<{
  users: Array<BulkCreateUserInput> | BulkCreateUserInput;
}>;


export type BulkCreateUsersMutation = { __typename?: 'Mutation', bulkCreateUsers: Array<{ __typename?: 'User', id: string, first_name?: string | null, last_name?: string | null, email?: any | null, phone?: string | null, phone_country?: string | null, avatar_url?: string | null, role?: AuthRoles | null, enabled_notification_sounds?: Array<UserNotificationSound> | null, notify_email_on?: Array<NotifyClinicOn> | null, notify_sound_on?: Array<NotifyClinicOn> | null, notify_desktop_on?: Array<NotifyClinicOn> | null, must_reset_password?: boolean | null, invitation_status?: UserInvitationStatus | null, invited_at?: number | null, created_at: number, updated_at: number }> };

export type ForcePasswordResetMutationVariables = Exact<{
  userId: Scalars['ID']['input'];
  clinicId?: InputMaybe<Scalars['ID']['input']>;
  clinicGroupId?: InputMaybe<Scalars['ID']['input']>;
}>;


export type ForcePasswordResetMutation = { __typename?: 'Mutation', forcePasswordReset?: any | null };

export type ResendInviteEmailMutationVariables = Exact<{
  userId: Scalars['ID']['input'];
  clinicId?: InputMaybe<Scalars['ID']['input']>;
  clinicGroupId?: InputMaybe<Scalars['ID']['input']>;
}>;


export type ResendInviteEmailMutation = { __typename?: 'Mutation', resendInviteEmail: boolean };

export type UpdateUserAuthInfoMutationVariables = Exact<{
  id: Scalars['ID']['input'];
  data: UpdateUserAuthInfoInput;
}>;


export type UpdateUserAuthInfoMutation = { __typename?: 'Mutation', updateUserAuthInfo?: any | null };

export type PatientVaccinationRecordFieldsFragment = { __typename?: 'PatientVaccinationRecord', id: string, vaccine_name?: string | null, manufacturer?: string | null, lot_number?: string | null, administered_date?: number | null, due_date?: number | null, rabies_tag?: string | null, is_rabies_vaccine?: boolean | null, is_soc: boolean, is_active: boolean, product?: { __typename?: 'Product', id: string, display_name?: string | null, name: string } | null };

export type QueryPatientVaccinationRecordsQueryVariables = Exact<{
  where?: InputMaybe<Array<QueryInput> | QueryInput>;
  page?: InputMaybe<Scalars['NonNegativeInt']['input']>;
  pageSize?: InputMaybe<Scalars['PositiveInt']['input']>;
  orderBy?: InputMaybe<OrderByInput>;
}>;


export type QueryPatientVaccinationRecordsQuery = { __typename?: 'Query', queryPatientVaccinationRecords: Array<{ __typename?: 'PatientVaccinationRecord', id: string, vaccine_name?: string | null, manufacturer?: string | null, lot_number?: string | null, administered_date?: number | null, due_date?: number | null, rabies_tag?: string | null, is_rabies_vaccine?: boolean | null, is_soc: boolean, is_active: boolean, product?: { __typename?: 'Product', id: string, display_name?: string | null, name: string } | null }> };

export type CountPatientVaccinationRecordsQueryVariables = Exact<{
  where?: InputMaybe<Array<QueryInput> | QueryInput>;
}>;


export type CountPatientVaccinationRecordsQuery = { __typename?: 'Query', countPatientVaccinationRecords: number };

export type ShareVaccineRecordsMutationVariables = Exact<{
  input: ShareVaccineRecordsInput;
}>;


export type ShareVaccineRecordsMutation = { __typename?: 'Mutation', shareVaccineRecords: { __typename?: 'ShareVaccineRecordsResult', status: string, channel?: string | null, record_count?: number | null, overdue_count?: number | null } };

export type WebhookConfigFieldsFragment = { __typename?: 'WebhookConfig', id: string, name: string, url: string, events: Array<WebhookEventType>, secret?: string | null, enabled: boolean };

export type TriggerWebhookTestMutationVariables = Exact<{
  data: TriggerWebhookInput;
}>;


export type TriggerWebhookTestMutation = { __typename?: 'Mutation', triggerWebhookTest: { __typename?: 'TriggerWebhookResult', success: boolean, webhooks_triggered: number } };

export type WidgetOptionsFieldsFragment = { __typename?: 'WidgetOptions', id: string, enabled: boolean, widget_access_start_time?: number | null, widget_access_end_time?: number | null, booking_avail_start?: number | null, booking_avail_end?: number | null, redirect_after_booking_url?: string | null, redirect_countdown_seconds?: number | null, scheduling_buffer_minutes?: number | null, scheduling_min_minutes_away?: number | null, scheduling_max_minutes_away?: number | null, hide_clinician_preference?: boolean | null, default_trigger_words?: Array<string> | null, custom_well_description?: string | null, custom_sick_description?: string | null, custom_other_title?: string | null, custom_other_description?: string | null, should_allow_new_clients?: boolean | null, should_allow_new_patients?: boolean | null, should_allow_returning_clients?: boolean | null, should_allow_returning_patients?: boolean | null, widget_referral_code?: string | null, gtm_container_id?: string | null, primary_clinic_group_id?: string | null, should_suggest_nearby_clinics?: boolean | null, created_at: number, updated_at: number, widget: { __typename?: 'Widget', id: string }, custom_booking_copy?: { __typename?: 'ClinicBookingCopy', WIDGET_HEADER_TITLE?: string | null, SHOW_CLINIC_HEADER_LOGO?: boolean | null, CLINIC_HEADER_LOGO_HEIGHT?: number | null, SERVICE_TYPE_SECTION_HEADING?: string | null, DEFAULT_WELLNESS_DESCRIPTION?: string | null, DEFAULT_SICK_DESCRIPTION?: string | null, DEFAULT_OTHER_DESCRIPTION?: string | null, RETURNING_PATIENT_QUESTION?: string | null, POSITIVE_RETURNING_PATIENT_ANSWER?: string | null, NEGATIVE_RETURNING_PATIENT_ANSWER?: string | null, RETURNING_CLIENT_QUESTION?: string | null, POSITIVE_RETURNING_CLIENT_ANSWER?: string | null, NEGATIVE_RETURNING_CLIENT_ANSWER?: string | null, CLIENT_INFORMATION_SECTION_TITLE?: string | null, PATIENT_INFORMATION_SECTION_TITLE?: string | null, RETURNING_CLIENT_PATIENT_TITLE?: string | null, RETURNING_CLIENT_PATIENT_DESCRIPTION?: string | null, SERVICE_SECTION_TITLE?: string | null, PREPAID_SERVICES_LABEL?: string | null, STANDARD_SERVICES_LABEL?: string | null, DEPOSIT_FEE_NAME?: string | null, PREVIOUS_OR_REFERRING_CLINIC_QUESTION?: string | null, CONTACT_THE_CLINIC_TEXT?: string | null, CONTACT_THE_CLINIC_TEXT_COLOR?: string | null, CONTACT_THE_CLINIC_TEXT_SIZE?: string | null, SELECT_CLINICIAN_TITLE?: string | null, SELECT_CLINICIAN_POSITIVE_ANSWER?: string | null, SELECT_CLINICIAN_NEGATIVE_ANSWER?: string | null, SELECT_TIME_TITLE?: string | null, REVIEW_TITLE?: string | null, REVIEW_NOTES_PROMPT?: string | null, PAYMENT_INFORMATION_TITLE?: string | null, TRIGGER_WORDS_DETECTED_HEADER?: string | null, TRIGGER_WORDS_DETECTED_DESCRIPTION?: string | null, CONFIRMATION_SCREEN_TITLE?: string | null, CONFIRMATION_SCREEN_DESCRIPTION?: string | null, NEW_CLIENT_BLOCKED_MESSAGE?: string | null, NEW_PATIENT_BLOCKED_MESSAGE?: string | null } | null, times_first_filter_config?: { __typename?: 'TimesFirstFilterConfig', service?: BookingFilterDisplayMode | null, clinician?: BookingFilterDisplayMode | null, species?: BookingFilterDisplayMode | null, client_status?: BookingFilterDisplayMode | null, patient_status?: BookingFilterDisplayMode | null, patient_gender?: BookingFilterDisplayMode | null, fixed_status?: BookingFilterDisplayMode | null } | null };

export type WidgetStylesFieldsFragment = { __typename?: 'WidgetStyles', header_color?: string | null, header_text_color?: string | null, footer_color?: string | null, footer_text_color?: string | null, floating_margin_bottom?: number | null, floating_margin_right?: number | null, include_service_categories_with_custom_order?: boolean | null, heading_color?: string | null, heading_font?: WidgetHeadingFont | null, background_color?: string | null, card_color?: string | null, button_color?: string | null, button_text_color?: string | null, text_color?: string | null, reviews_name_color?: string | null, reviews_stars_color?: string | null, reviews_date_color?: string | null, reviews_text_color?: string | null, reviews_arrow_background?: string | null, reviews_arrow_color?: string | null, reviews_title_text?: string | null, clinic_order?: Array<{ __typename?: 'ClinicOrder', clinic_id: string, order: number }> | null, service_order?: Array<{ __typename?: 'ServiceOrder', service_id: string, order: number }> | null, clinic_image_map?: Array<{ __typename?: 'ClinicImageMap', clinic_id: string, image_url: string }> | null };

export type ClinicImageMapFieldsFragment = { __typename?: 'ClinicImageMap', clinic_id: string, image_url: string };

export type WidgetOptionsByWidgetQueryVariables = Exact<{
  widgetId: Scalars['ID']['input'];
}>;


export type WidgetOptionsByWidgetQuery = { __typename?: 'Query', widgetOptionsForWidget?: { __typename?: 'WidgetOptions', id: string, enabled: boolean, widget_access_start_time?: number | null, widget_access_end_time?: number | null, booking_avail_start?: number | null, booking_avail_end?: number | null, redirect_after_booking_url?: string | null, redirect_countdown_seconds?: number | null, scheduling_buffer_minutes?: number | null, scheduling_min_minutes_away?: number | null, scheduling_max_minutes_away?: number | null, hide_clinician_preference?: boolean | null, default_trigger_words?: Array<string> | null, custom_well_description?: string | null, custom_sick_description?: string | null, custom_other_title?: string | null, custom_other_description?: string | null, should_allow_new_clients?: boolean | null, should_allow_new_patients?: boolean | null, should_allow_returning_clients?: boolean | null, should_allow_returning_patients?: boolean | null, widget_referral_code?: string | null, gtm_container_id?: string | null, primary_clinic_group_id?: string | null, should_suggest_nearby_clinics?: boolean | null, created_at: number, updated_at: number, widget: { __typename?: 'Widget', id: string }, custom_booking_copy?: { __typename?: 'ClinicBookingCopy', WIDGET_HEADER_TITLE?: string | null, SHOW_CLINIC_HEADER_LOGO?: boolean | null, CLINIC_HEADER_LOGO_HEIGHT?: number | null, SERVICE_TYPE_SECTION_HEADING?: string | null, DEFAULT_WELLNESS_DESCRIPTION?: string | null, DEFAULT_SICK_DESCRIPTION?: string | null, DEFAULT_OTHER_DESCRIPTION?: string | null, RETURNING_PATIENT_QUESTION?: string | null, POSITIVE_RETURNING_PATIENT_ANSWER?: string | null, NEGATIVE_RETURNING_PATIENT_ANSWER?: string | null, RETURNING_CLIENT_QUESTION?: string | null, POSITIVE_RETURNING_CLIENT_ANSWER?: string | null, NEGATIVE_RETURNING_CLIENT_ANSWER?: string | null, CLIENT_INFORMATION_SECTION_TITLE?: string | null, PATIENT_INFORMATION_SECTION_TITLE?: string | null, RETURNING_CLIENT_PATIENT_TITLE?: string | null, RETURNING_CLIENT_PATIENT_DESCRIPTION?: string | null, SERVICE_SECTION_TITLE?: string | null, PREPAID_SERVICES_LABEL?: string | null, STANDARD_SERVICES_LABEL?: string | null, DEPOSIT_FEE_NAME?: string | null, PREVIOUS_OR_REFERRING_CLINIC_QUESTION?: string | null, CONTACT_THE_CLINIC_TEXT?: string | null, CONTACT_THE_CLINIC_TEXT_COLOR?: string | null, CONTACT_THE_CLINIC_TEXT_SIZE?: string | null, SELECT_CLINICIAN_TITLE?: string | null, SELECT_CLINICIAN_POSITIVE_ANSWER?: string | null, SELECT_CLINICIAN_NEGATIVE_ANSWER?: string | null, SELECT_TIME_TITLE?: string | null, REVIEW_TITLE?: string | null, REVIEW_NOTES_PROMPT?: string | null, PAYMENT_INFORMATION_TITLE?: string | null, TRIGGER_WORDS_DETECTED_HEADER?: string | null, TRIGGER_WORDS_DETECTED_DESCRIPTION?: string | null, CONFIRMATION_SCREEN_TITLE?: string | null, CONFIRMATION_SCREEN_DESCRIPTION?: string | null, NEW_CLIENT_BLOCKED_MESSAGE?: string | null, NEW_PATIENT_BLOCKED_MESSAGE?: string | null } | null, times_first_filter_config?: { __typename?: 'TimesFirstFilterConfig', service?: BookingFilterDisplayMode | null, clinician?: BookingFilterDisplayMode | null, species?: BookingFilterDisplayMode | null, client_status?: BookingFilterDisplayMode | null, patient_status?: BookingFilterDisplayMode | null, patient_gender?: BookingFilterDisplayMode | null, fixed_status?: BookingFilterDisplayMode | null } | null } | null };

export type CreateWidgetOptionsMutationVariables = Exact<{
  data: CreateWidgetOptionsInput;
}>;


export type CreateWidgetOptionsMutation = { __typename?: 'Mutation', createWidgetOptions: { __typename?: 'WidgetOptions', id: string, enabled: boolean, widget_access_start_time?: number | null, widget_access_end_time?: number | null, booking_avail_start?: number | null, booking_avail_end?: number | null, redirect_after_booking_url?: string | null, redirect_countdown_seconds?: number | null, scheduling_buffer_minutes?: number | null, scheduling_min_minutes_away?: number | null, scheduling_max_minutes_away?: number | null, hide_clinician_preference?: boolean | null, default_trigger_words?: Array<string> | null, custom_well_description?: string | null, custom_sick_description?: string | null, custom_other_title?: string | null, custom_other_description?: string | null, should_allow_new_clients?: boolean | null, should_allow_new_patients?: boolean | null, should_allow_returning_clients?: boolean | null, should_allow_returning_patients?: boolean | null, widget_referral_code?: string | null, gtm_container_id?: string | null, primary_clinic_group_id?: string | null, should_suggest_nearby_clinics?: boolean | null, created_at: number, updated_at: number, widget: { __typename?: 'Widget', id: string }, custom_booking_copy?: { __typename?: 'ClinicBookingCopy', WIDGET_HEADER_TITLE?: string | null, SHOW_CLINIC_HEADER_LOGO?: boolean | null, CLINIC_HEADER_LOGO_HEIGHT?: number | null, SERVICE_TYPE_SECTION_HEADING?: string | null, DEFAULT_WELLNESS_DESCRIPTION?: string | null, DEFAULT_SICK_DESCRIPTION?: string | null, DEFAULT_OTHER_DESCRIPTION?: string | null, RETURNING_PATIENT_QUESTION?: string | null, POSITIVE_RETURNING_PATIENT_ANSWER?: string | null, NEGATIVE_RETURNING_PATIENT_ANSWER?: string | null, RETURNING_CLIENT_QUESTION?: string | null, POSITIVE_RETURNING_CLIENT_ANSWER?: string | null, NEGATIVE_RETURNING_CLIENT_ANSWER?: string | null, CLIENT_INFORMATION_SECTION_TITLE?: string | null, PATIENT_INFORMATION_SECTION_TITLE?: string | null, RETURNING_CLIENT_PATIENT_TITLE?: string | null, RETURNING_CLIENT_PATIENT_DESCRIPTION?: string | null, SERVICE_SECTION_TITLE?: string | null, PREPAID_SERVICES_LABEL?: string | null, STANDARD_SERVICES_LABEL?: string | null, DEPOSIT_FEE_NAME?: string | null, PREVIOUS_OR_REFERRING_CLINIC_QUESTION?: string | null, CONTACT_THE_CLINIC_TEXT?: string | null, CONTACT_THE_CLINIC_TEXT_COLOR?: string | null, CONTACT_THE_CLINIC_TEXT_SIZE?: string | null, SELECT_CLINICIAN_TITLE?: string | null, SELECT_CLINICIAN_POSITIVE_ANSWER?: string | null, SELECT_CLINICIAN_NEGATIVE_ANSWER?: string | null, SELECT_TIME_TITLE?: string | null, REVIEW_TITLE?: string | null, REVIEW_NOTES_PROMPT?: string | null, PAYMENT_INFORMATION_TITLE?: string | null, TRIGGER_WORDS_DETECTED_HEADER?: string | null, TRIGGER_WORDS_DETECTED_DESCRIPTION?: string | null, CONFIRMATION_SCREEN_TITLE?: string | null, CONFIRMATION_SCREEN_DESCRIPTION?: string | null, NEW_CLIENT_BLOCKED_MESSAGE?: string | null, NEW_PATIENT_BLOCKED_MESSAGE?: string | null } | null, times_first_filter_config?: { __typename?: 'TimesFirstFilterConfig', service?: BookingFilterDisplayMode | null, clinician?: BookingFilterDisplayMode | null, species?: BookingFilterDisplayMode | null, client_status?: BookingFilterDisplayMode | null, patient_status?: BookingFilterDisplayMode | null, patient_gender?: BookingFilterDisplayMode | null, fixed_status?: BookingFilterDisplayMode | null } | null } };

export type UpdateWidgetOptionsMutationVariables = Exact<{
  widgetId: Scalars['ID']['input'];
  data: UpdateWidgetOptionsInput;
}>;


export type UpdateWidgetOptionsMutation = { __typename?: 'Mutation', updateWidgetOptions: { __typename?: 'WidgetOptions', id: string, enabled: boolean, widget_access_start_time?: number | null, widget_access_end_time?: number | null, booking_avail_start?: number | null, booking_avail_end?: number | null, redirect_after_booking_url?: string | null, redirect_countdown_seconds?: number | null, scheduling_buffer_minutes?: number | null, scheduling_min_minutes_away?: number | null, scheduling_max_minutes_away?: number | null, hide_clinician_preference?: boolean | null, default_trigger_words?: Array<string> | null, custom_well_description?: string | null, custom_sick_description?: string | null, custom_other_title?: string | null, custom_other_description?: string | null, should_allow_new_clients?: boolean | null, should_allow_new_patients?: boolean | null, should_allow_returning_clients?: boolean | null, should_allow_returning_patients?: boolean | null, widget_referral_code?: string | null, gtm_container_id?: string | null, primary_clinic_group_id?: string | null, should_suggest_nearby_clinics?: boolean | null, created_at: number, updated_at: number, widget: { __typename?: 'Widget', id: string }, custom_booking_copy?: { __typename?: 'ClinicBookingCopy', WIDGET_HEADER_TITLE?: string | null, SHOW_CLINIC_HEADER_LOGO?: boolean | null, CLINIC_HEADER_LOGO_HEIGHT?: number | null, SERVICE_TYPE_SECTION_HEADING?: string | null, DEFAULT_WELLNESS_DESCRIPTION?: string | null, DEFAULT_SICK_DESCRIPTION?: string | null, DEFAULT_OTHER_DESCRIPTION?: string | null, RETURNING_PATIENT_QUESTION?: string | null, POSITIVE_RETURNING_PATIENT_ANSWER?: string | null, NEGATIVE_RETURNING_PATIENT_ANSWER?: string | null, RETURNING_CLIENT_QUESTION?: string | null, POSITIVE_RETURNING_CLIENT_ANSWER?: string | null, NEGATIVE_RETURNING_CLIENT_ANSWER?: string | null, CLIENT_INFORMATION_SECTION_TITLE?: string | null, PATIENT_INFORMATION_SECTION_TITLE?: string | null, RETURNING_CLIENT_PATIENT_TITLE?: string | null, RETURNING_CLIENT_PATIENT_DESCRIPTION?: string | null, SERVICE_SECTION_TITLE?: string | null, PREPAID_SERVICES_LABEL?: string | null, STANDARD_SERVICES_LABEL?: string | null, DEPOSIT_FEE_NAME?: string | null, PREVIOUS_OR_REFERRING_CLINIC_QUESTION?: string | null, CONTACT_THE_CLINIC_TEXT?: string | null, CONTACT_THE_CLINIC_TEXT_COLOR?: string | null, CONTACT_THE_CLINIC_TEXT_SIZE?: string | null, SELECT_CLINICIAN_TITLE?: string | null, SELECT_CLINICIAN_POSITIVE_ANSWER?: string | null, SELECT_CLINICIAN_NEGATIVE_ANSWER?: string | null, SELECT_TIME_TITLE?: string | null, REVIEW_TITLE?: string | null, REVIEW_NOTES_PROMPT?: string | null, PAYMENT_INFORMATION_TITLE?: string | null, TRIGGER_WORDS_DETECTED_HEADER?: string | null, TRIGGER_WORDS_DETECTED_DESCRIPTION?: string | null, CONFIRMATION_SCREEN_TITLE?: string | null, CONFIRMATION_SCREEN_DESCRIPTION?: string | null, NEW_CLIENT_BLOCKED_MESSAGE?: string | null, NEW_PATIENT_BLOCKED_MESSAGE?: string | null } | null, times_first_filter_config?: { __typename?: 'TimesFirstFilterConfig', service?: BookingFilterDisplayMode | null, clinician?: BookingFilterDisplayMode | null, species?: BookingFilterDisplayMode | null, client_status?: BookingFilterDisplayMode | null, patient_status?: BookingFilterDisplayMode | null, patient_gender?: BookingFilterDisplayMode | null, fixed_status?: BookingFilterDisplayMode | null } | null } };

export type WidgetServiceFieldsFragment = { __typename?: 'WidgetService', id: string, is_active: boolean, created_at: number, updated_at: number, widget: { __typename?: 'Widget', id: string }, service: { __typename?: 'Service', id: string, name?: string | null, order?: number | null, keywords?: string | null, service_types: Array<ServiceType>, is_active?: boolean | null, allow_new?: boolean | null, color?: string | null, description?: string | null, duration?: number | null, allow_returning?: boolean | null, max_per_day?: number | null, max_per_hour?: number | null, excluded_species?: Array<Species> | null, reserved_per_day?: number | null, authorized_levels?: Array<AuthorityLevel> | null, scheduling_buffer_minutes?: number | null, scheduling_min_minutes_away?: number | null, scheduling_max_minutes_away?: number | null, minimum_patient_age_in_days?: number | null, maximum_patient_age_in_days?: number | null, more_info?: string | null, more_info_action_required?: string | null, action_required_acknowledgement_text?: string | null, points: number, drop_off_time?: string | null, pick_up_time?: string | null, is_blocking: boolean, is_reschedule_allowed: boolean, is_cancellation_allowed: boolean, is_primary_for_appt_type: boolean, hide_clinician_preference: boolean, use_previous_doctor: boolean, allowed_appt_type_pms_ids?: Array<string> | null, valid_booking_interval_minutes?: Array<number> | null, only_use_adj_avail_guides: boolean, exclude_from_portal: boolean, created_at: number, updated_at: number, clinic?: { __typename?: 'Clinic', id: string, name?: string | null } | null, service_service_categories?: Array<{ __typename?: 'ServiceServiceCategory', service_category: { __typename?: 'ServiceCategory', id: string, order: number, icon?: ServiceCategoryIcon | null, title: string, description: string, requires_confirmation: boolean, confirmation_message?: string | null, created_at: number, updated_at: number } }> | null, pricing?: { __typename?: 'ServicePricing', price: any, currency: any, type: ServicePricingType, client_type?: ClientTypeEnum | null } | null, pms_appt_type?: { __typename?: 'PmsApptType', id: string, name: string, pms_id: string, description?: string | null, color?: any | null, pms_is_active: boolean } | null, required_room?: { __typename?: 'Room', id: string, pms_id: string, name: string, display_name?: string | null, description?: string | null, concurrent_patients?: number | null, is_active: boolean, does_contribute_to_fill_rate?: boolean | null, valid_booking_interval_minutes?: Array<number> | null, created_at: number, updated_at: number, clinic?: { __typename?: 'Clinic', pms: PracticeManagementSystem, id: string, name?: string | null, time_zone?: string | null } | null, hours?: { __typename?: 'AvailabilityHours', monday?: Array<{ __typename?: 'TimeInterval', start?: number | null, end?: number | null }> | null, tuesday?: Array<{ __typename?: 'TimeInterval', start?: number | null, end?: number | null }> | null, wednesday?: Array<{ __typename?: 'TimeInterval', start?: number | null, end?: number | null }> | null, thursday?: Array<{ __typename?: 'TimeInterval', start?: number | null, end?: number | null }> | null, friday?: Array<{ __typename?: 'TimeInterval', start?: number | null, end?: number | null }> | null, saturday?: Array<{ __typename?: 'TimeInterval', start?: number | null, end?: number | null }> | null, sunday?: Array<{ __typename?: 'TimeInterval', start?: number | null, end?: number | null }> | null } | null, adjusted_availability?: Array<{ __typename?: 'Availability', date: number, pms_appt_type_pms_id?: string | null, times: Array<{ __typename?: 'TimeInterval', start?: number | null, end?: number | null }>, repeat?: { __typename?: 'RepeatAvailability', daysOfMonth?: Array<number> | null, daysOfWeek?: Array<DayOfWeek> | null, weekOfMonth?: WeekOfMonth | null, frequency: any, unit: RepeatUnit, end_date?: number | null } | null }> | null, pms_adjusted_availability?: Array<{ __typename?: 'Availability', date: number, pms_appt_type_pms_id?: string | null, times: Array<{ __typename?: 'TimeInterval', start?: number | null, end?: number | null }>, repeat?: { __typename?: 'RepeatAvailability', daysOfMonth?: Array<number> | null, daysOfWeek?: Array<DayOfWeek> | null, weekOfMonth?: WeekOfMonth | null, frequency: any, unit: RepeatUnit, end_date?: number | null } | null }> | null } | null, default_room?: { __typename?: 'Room', id: string, pms_id: string, name: string, display_name?: string | null, description?: string | null, concurrent_patients?: number | null, is_active: boolean, does_contribute_to_fill_rate?: boolean | null, valid_booking_interval_minutes?: Array<number> | null, created_at: number, updated_at: number, clinic?: { __typename?: 'Clinic', pms: PracticeManagementSystem, id: string, name?: string | null, time_zone?: string | null } | null, hours?: { __typename?: 'AvailabilityHours', monday?: Array<{ __typename?: 'TimeInterval', start?: number | null, end?: number | null }> | null, tuesday?: Array<{ __typename?: 'TimeInterval', start?: number | null, end?: number | null }> | null, wednesday?: Array<{ __typename?: 'TimeInterval', start?: number | null, end?: number | null }> | null, thursday?: Array<{ __typename?: 'TimeInterval', start?: number | null, end?: number | null }> | null, friday?: Array<{ __typename?: 'TimeInterval', start?: number | null, end?: number | null }> | null, saturday?: Array<{ __typename?: 'TimeInterval', start?: number | null, end?: number | null }> | null, sunday?: Array<{ __typename?: 'TimeInterval', start?: number | null, end?: number | null }> | null } | null, adjusted_availability?: Array<{ __typename?: 'Availability', date: number, pms_appt_type_pms_id?: string | null, times: Array<{ __typename?: 'TimeInterval', start?: number | null, end?: number | null }>, repeat?: { __typename?: 'RepeatAvailability', daysOfMonth?: Array<number> | null, daysOfWeek?: Array<DayOfWeek> | null, weekOfMonth?: WeekOfMonth | null, frequency: any, unit: RepeatUnit, end_date?: number | null } | null }> | null, pms_adjusted_availability?: Array<{ __typename?: 'Availability', date: number, pms_appt_type_pms_id?: string | null, times: Array<{ __typename?: 'TimeInterval', start?: number | null, end?: number | null }>, repeat?: { __typename?: 'RepeatAvailability', daysOfMonth?: Array<number> | null, daysOfWeek?: Array<DayOfWeek> | null, weekOfMonth?: WeekOfMonth | null, frequency: any, unit: RepeatUnit, end_date?: number | null } | null }> | null } | null, availability?: { __typename?: 'AvailabilityHours', monday?: Array<{ __typename?: 'TimeInterval', start?: number | null, end?: number | null }> | null, tuesday?: Array<{ __typename?: 'TimeInterval', start?: number | null, end?: number | null }> | null, wednesday?: Array<{ __typename?: 'TimeInterval', start?: number | null, end?: number | null }> | null, thursday?: Array<{ __typename?: 'TimeInterval', start?: number | null, end?: number | null }> | null, friday?: Array<{ __typename?: 'TimeInterval', start?: number | null, end?: number | null }> | null, saturday?: Array<{ __typename?: 'TimeInterval', start?: number | null, end?: number | null }> | null, sunday?: Array<{ __typename?: 'TimeInterval', start?: number | null, end?: number | null }> | null } | null, drop_off_hours?: { __typename?: 'AvailabilityHours', monday?: Array<{ __typename?: 'TimeInterval', start?: number | null, end?: number | null }> | null, tuesday?: Array<{ __typename?: 'TimeInterval', start?: number | null, end?: number | null }> | null, wednesday?: Array<{ __typename?: 'TimeInterval', start?: number | null, end?: number | null }> | null, thursday?: Array<{ __typename?: 'TimeInterval', start?: number | null, end?: number | null }> | null, friday?: Array<{ __typename?: 'TimeInterval', start?: number | null, end?: number | null }> | null, saturday?: Array<{ __typename?: 'TimeInterval', start?: number | null, end?: number | null }> | null, sunday?: Array<{ __typename?: 'TimeInterval', start?: number | null, end?: number | null }> | null } | null, pre_confirmation_checklist?: Array<{ __typename?: 'ServicePreConfirmationItem', title: string, description?: string | null, required?: boolean | null }> | null } };

export type WidgetServiceQueryVariables = Exact<{
  widgetId: Scalars['ID']['input'];
}>;


export type WidgetServiceQuery = { __typename?: 'Query', widgetService: { __typename?: 'WidgetService', id: string, is_active: boolean, created_at: number, updated_at: number, widget: { __typename?: 'Widget', id: string }, service: { __typename?: 'Service', id: string, name?: string | null, order?: number | null, keywords?: string | null, service_types: Array<ServiceType>, is_active?: boolean | null, allow_new?: boolean | null, color?: string | null, description?: string | null, duration?: number | null, allow_returning?: boolean | null, max_per_day?: number | null, max_per_hour?: number | null, excluded_species?: Array<Species> | null, reserved_per_day?: number | null, authorized_levels?: Array<AuthorityLevel> | null, scheduling_buffer_minutes?: number | null, scheduling_min_minutes_away?: number | null, scheduling_max_minutes_away?: number | null, minimum_patient_age_in_days?: number | null, maximum_patient_age_in_days?: number | null, more_info?: string | null, more_info_action_required?: string | null, action_required_acknowledgement_text?: string | null, points: number, drop_off_time?: string | null, pick_up_time?: string | null, is_blocking: boolean, is_reschedule_allowed: boolean, is_cancellation_allowed: boolean, is_primary_for_appt_type: boolean, hide_clinician_preference: boolean, use_previous_doctor: boolean, allowed_appt_type_pms_ids?: Array<string> | null, valid_booking_interval_minutes?: Array<number> | null, only_use_adj_avail_guides: boolean, exclude_from_portal: boolean, created_at: number, updated_at: number, clinic?: { __typename?: 'Clinic', id: string, name?: string | null } | null, service_service_categories?: Array<{ __typename?: 'ServiceServiceCategory', service_category: { __typename?: 'ServiceCategory', id: string, order: number, icon?: ServiceCategoryIcon | null, title: string, description: string, requires_confirmation: boolean, confirmation_message?: string | null, created_at: number, updated_at: number } }> | null, pricing?: { __typename?: 'ServicePricing', price: any, currency: any, type: ServicePricingType, client_type?: ClientTypeEnum | null } | null, pms_appt_type?: { __typename?: 'PmsApptType', id: string, name: string, pms_id: string, description?: string | null, color?: any | null, pms_is_active: boolean } | null, required_room?: { __typename?: 'Room', id: string, pms_id: string, name: string, display_name?: string | null, description?: string | null, concurrent_patients?: number | null, is_active: boolean, does_contribute_to_fill_rate?: boolean | null, valid_booking_interval_minutes?: Array<number> | null, created_at: number, updated_at: number, clinic?: { __typename?: 'Clinic', pms: PracticeManagementSystem, id: string, name?: string | null, time_zone?: string | null } | null, hours?: { __typename?: 'AvailabilityHours', monday?: Array<{ __typename?: 'TimeInterval', start?: number | null, end?: number | null }> | null, tuesday?: Array<{ __typename?: 'TimeInterval', start?: number | null, end?: number | null }> | null, wednesday?: Array<{ __typename?: 'TimeInterval', start?: number | null, end?: number | null }> | null, thursday?: Array<{ __typename?: 'TimeInterval', start?: number | null, end?: number | null }> | null, friday?: Array<{ __typename?: 'TimeInterval', start?: number | null, end?: number | null }> | null, saturday?: Array<{ __typename?: 'TimeInterval', start?: number | null, end?: number | null }> | null, sunday?: Array<{ __typename?: 'TimeInterval', start?: number | null, end?: number | null }> | null } | null, adjusted_availability?: Array<{ __typename?: 'Availability', date: number, pms_appt_type_pms_id?: string | null, times: Array<{ __typename?: 'TimeInterval', start?: number | null, end?: number | null }>, repeat?: { __typename?: 'RepeatAvailability', daysOfMonth?: Array<number> | null, daysOfWeek?: Array<DayOfWeek> | null, weekOfMonth?: WeekOfMonth | null, frequency: any, unit: RepeatUnit, end_date?: number | null } | null }> | null, pms_adjusted_availability?: Array<{ __typename?: 'Availability', date: number, pms_appt_type_pms_id?: string | null, times: Array<{ __typename?: 'TimeInterval', start?: number | null, end?: number | null }>, repeat?: { __typename?: 'RepeatAvailability', daysOfMonth?: Array<number> | null, daysOfWeek?: Array<DayOfWeek> | null, weekOfMonth?: WeekOfMonth | null, frequency: any, unit: RepeatUnit, end_date?: number | null } | null }> | null } | null, default_room?: { __typename?: 'Room', id: string, pms_id: string, name: string, display_name?: string | null, description?: string | null, concurrent_patients?: number | null, is_active: boolean, does_contribute_to_fill_rate?: boolean | null, valid_booking_interval_minutes?: Array<number> | null, created_at: number, updated_at: number, clinic?: { __typename?: 'Clinic', pms: PracticeManagementSystem, id: string, name?: string | null, time_zone?: string | null } | null, hours?: { __typename?: 'AvailabilityHours', monday?: Array<{ __typename?: 'TimeInterval', start?: number | null, end?: number | null }> | null, tuesday?: Array<{ __typename?: 'TimeInterval', start?: number | null, end?: number | null }> | null, wednesday?: Array<{ __typename?: 'TimeInterval', start?: number | null, end?: number | null }> | null, thursday?: Array<{ __typename?: 'TimeInterval', start?: number | null, end?: number | null }> | null, friday?: Array<{ __typename?: 'TimeInterval', start?: number | null, end?: number | null }> | null, saturday?: Array<{ __typename?: 'TimeInterval', start?: number | null, end?: number | null }> | null, sunday?: Array<{ __typename?: 'TimeInterval', start?: number | null, end?: number | null }> | null } | null, adjusted_availability?: Array<{ __typename?: 'Availability', date: number, pms_appt_type_pms_id?: string | null, times: Array<{ __typename?: 'TimeInterval', start?: number | null, end?: number | null }>, repeat?: { __typename?: 'RepeatAvailability', daysOfMonth?: Array<number> | null, daysOfWeek?: Array<DayOfWeek> | null, weekOfMonth?: WeekOfMonth | null, frequency: any, unit: RepeatUnit, end_date?: number | null } | null }> | null, pms_adjusted_availability?: Array<{ __typename?: 'Availability', date: number, pms_appt_type_pms_id?: string | null, times: Array<{ __typename?: 'TimeInterval', start?: number | null, end?: number | null }>, repeat?: { __typename?: 'RepeatAvailability', daysOfMonth?: Array<number> | null, daysOfWeek?: Array<DayOfWeek> | null, weekOfMonth?: WeekOfMonth | null, frequency: any, unit: RepeatUnit, end_date?: number | null } | null }> | null } | null, availability?: { __typename?: 'AvailabilityHours', monday?: Array<{ __typename?: 'TimeInterval', start?: number | null, end?: number | null }> | null, tuesday?: Array<{ __typename?: 'TimeInterval', start?: number | null, end?: number | null }> | null, wednesday?: Array<{ __typename?: 'TimeInterval', start?: number | null, end?: number | null }> | null, thursday?: Array<{ __typename?: 'TimeInterval', start?: number | null, end?: number | null }> | null, friday?: Array<{ __typename?: 'TimeInterval', start?: number | null, end?: number | null }> | null, saturday?: Array<{ __typename?: 'TimeInterval', start?: number | null, end?: number | null }> | null, sunday?: Array<{ __typename?: 'TimeInterval', start?: number | null, end?: number | null }> | null } | null, drop_off_hours?: { __typename?: 'AvailabilityHours', monday?: Array<{ __typename?: 'TimeInterval', start?: number | null, end?: number | null }> | null, tuesday?: Array<{ __typename?: 'TimeInterval', start?: number | null, end?: number | null }> | null, wednesday?: Array<{ __typename?: 'TimeInterval', start?: number | null, end?: number | null }> | null, thursday?: Array<{ __typename?: 'TimeInterval', start?: number | null, end?: number | null }> | null, friday?: Array<{ __typename?: 'TimeInterval', start?: number | null, end?: number | null }> | null, saturday?: Array<{ __typename?: 'TimeInterval', start?: number | null, end?: number | null }> | null, sunday?: Array<{ __typename?: 'TimeInterval', start?: number | null, end?: number | null }> | null } | null, pre_confirmation_checklist?: Array<{ __typename?: 'ServicePreConfirmationItem', title: string, description?: string | null, required?: boolean | null }> | null } } };

export type WidgetServicesForWidgetQueryVariables = Exact<{
  widgetId: Scalars['ID']['input'];
}>;


export type WidgetServicesForWidgetQuery = { __typename?: 'Query', widgetServicesForWidget: Array<{ __typename?: 'WidgetService', id: string, is_active: boolean, created_at: number, updated_at: number, widget: { __typename?: 'Widget', id: string }, service: { __typename?: 'Service', id: string, name?: string | null, order?: number | null, keywords?: string | null, service_types: Array<ServiceType>, is_active?: boolean | null, allow_new?: boolean | null, color?: string | null, description?: string | null, duration?: number | null, allow_returning?: boolean | null, max_per_day?: number | null, max_per_hour?: number | null, excluded_species?: Array<Species> | null, reserved_per_day?: number | null, authorized_levels?: Array<AuthorityLevel> | null, scheduling_buffer_minutes?: number | null, scheduling_min_minutes_away?: number | null, scheduling_max_minutes_away?: number | null, minimum_patient_age_in_days?: number | null, maximum_patient_age_in_days?: number | null, more_info?: string | null, more_info_action_required?: string | null, action_required_acknowledgement_text?: string | null, points: number, drop_off_time?: string | null, pick_up_time?: string | null, is_blocking: boolean, is_reschedule_allowed: boolean, is_cancellation_allowed: boolean, is_primary_for_appt_type: boolean, hide_clinician_preference: boolean, use_previous_doctor: boolean, allowed_appt_type_pms_ids?: Array<string> | null, valid_booking_interval_minutes?: Array<number> | null, only_use_adj_avail_guides: boolean, exclude_from_portal: boolean, created_at: number, updated_at: number, clinic?: { __typename?: 'Clinic', id: string, name?: string | null } | null, service_service_categories?: Array<{ __typename?: 'ServiceServiceCategory', service_category: { __typename?: 'ServiceCategory', id: string, order: number, icon?: ServiceCategoryIcon | null, title: string, description: string, requires_confirmation: boolean, confirmation_message?: string | null, created_at: number, updated_at: number } }> | null, pricing?: { __typename?: 'ServicePricing', price: any, currency: any, type: ServicePricingType, client_type?: ClientTypeEnum | null } | null, pms_appt_type?: { __typename?: 'PmsApptType', id: string, name: string, pms_id: string, description?: string | null, color?: any | null, pms_is_active: boolean } | null, required_room?: { __typename?: 'Room', id: string, pms_id: string, name: string, display_name?: string | null, description?: string | null, concurrent_patients?: number | null, is_active: boolean, does_contribute_to_fill_rate?: boolean | null, valid_booking_interval_minutes?: Array<number> | null, created_at: number, updated_at: number, clinic?: { __typename?: 'Clinic', pms: PracticeManagementSystem, id: string, name?: string | null, time_zone?: string | null } | null, hours?: { __typename?: 'AvailabilityHours', monday?: Array<{ __typename?: 'TimeInterval', start?: number | null, end?: number | null }> | null, tuesday?: Array<{ __typename?: 'TimeInterval', start?: number | null, end?: number | null }> | null, wednesday?: Array<{ __typename?: 'TimeInterval', start?: number | null, end?: number | null }> | null, thursday?: Array<{ __typename?: 'TimeInterval', start?: number | null, end?: number | null }> | null, friday?: Array<{ __typename?: 'TimeInterval', start?: number | null, end?: number | null }> | null, saturday?: Array<{ __typename?: 'TimeInterval', start?: number | null, end?: number | null }> | null, sunday?: Array<{ __typename?: 'TimeInterval', start?: number | null, end?: number | null }> | null } | null, adjusted_availability?: Array<{ __typename?: 'Availability', date: number, pms_appt_type_pms_id?: string | null, times: Array<{ __typename?: 'TimeInterval', start?: number | null, end?: number | null }>, repeat?: { __typename?: 'RepeatAvailability', daysOfMonth?: Array<number> | null, daysOfWeek?: Array<DayOfWeek> | null, weekOfMonth?: WeekOfMonth | null, frequency: any, unit: RepeatUnit, end_date?: number | null } | null }> | null, pms_adjusted_availability?: Array<{ __typename?: 'Availability', date: number, pms_appt_type_pms_id?: string | null, times: Array<{ __typename?: 'TimeInterval', start?: number | null, end?: number | null }>, repeat?: { __typename?: 'RepeatAvailability', daysOfMonth?: Array<number> | null, daysOfWeek?: Array<DayOfWeek> | null, weekOfMonth?: WeekOfMonth | null, frequency: any, unit: RepeatUnit, end_date?: number | null } | null }> | null } | null, default_room?: { __typename?: 'Room', id: string, pms_id: string, name: string, display_name?: string | null, description?: string | null, concurrent_patients?: number | null, is_active: boolean, does_contribute_to_fill_rate?: boolean | null, valid_booking_interval_minutes?: Array<number> | null, created_at: number, updated_at: number, clinic?: { __typename?: 'Clinic', pms: PracticeManagementSystem, id: string, name?: string | null, time_zone?: string | null } | null, hours?: { __typename?: 'AvailabilityHours', monday?: Array<{ __typename?: 'TimeInterval', start?: number | null, end?: number | null }> | null, tuesday?: Array<{ __typename?: 'TimeInterval', start?: number | null, end?: number | null }> | null, wednesday?: Array<{ __typename?: 'TimeInterval', start?: number | null, end?: number | null }> | null, thursday?: Array<{ __typename?: 'TimeInterval', start?: number | null, end?: number | null }> | null, friday?: Array<{ __typename?: 'TimeInterval', start?: number | null, end?: number | null }> | null, saturday?: Array<{ __typename?: 'TimeInterval', start?: number | null, end?: number | null }> | null, sunday?: Array<{ __typename?: 'TimeInterval', start?: number | null, end?: number | null }> | null } | null, adjusted_availability?: Array<{ __typename?: 'Availability', date: number, pms_appt_type_pms_id?: string | null, times: Array<{ __typename?: 'TimeInterval', start?: number | null, end?: number | null }>, repeat?: { __typename?: 'RepeatAvailability', daysOfMonth?: Array<number> | null, daysOfWeek?: Array<DayOfWeek> | null, weekOfMonth?: WeekOfMonth | null, frequency: any, unit: RepeatUnit, end_date?: number | null } | null }> | null, pms_adjusted_availability?: Array<{ __typename?: 'Availability', date: number, pms_appt_type_pms_id?: string | null, times: Array<{ __typename?: 'TimeInterval', start?: number | null, end?: number | null }>, repeat?: { __typename?: 'RepeatAvailability', daysOfMonth?: Array<number> | null, daysOfWeek?: Array<DayOfWeek> | null, weekOfMonth?: WeekOfMonth | null, frequency: any, unit: RepeatUnit, end_date?: number | null } | null }> | null } | null, availability?: { __typename?: 'AvailabilityHours', monday?: Array<{ __typename?: 'TimeInterval', start?: number | null, end?: number | null }> | null, tuesday?: Array<{ __typename?: 'TimeInterval', start?: number | null, end?: number | null }> | null, wednesday?: Array<{ __typename?: 'TimeInterval', start?: number | null, end?: number | null }> | null, thursday?: Array<{ __typename?: 'TimeInterval', start?: number | null, end?: number | null }> | null, friday?: Array<{ __typename?: 'TimeInterval', start?: number | null, end?: number | null }> | null, saturday?: Array<{ __typename?: 'TimeInterval', start?: number | null, end?: number | null }> | null, sunday?: Array<{ __typename?: 'TimeInterval', start?: number | null, end?: number | null }> | null } | null, drop_off_hours?: { __typename?: 'AvailabilityHours', monday?: Array<{ __typename?: 'TimeInterval', start?: number | null, end?: number | null }> | null, tuesday?: Array<{ __typename?: 'TimeInterval', start?: number | null, end?: number | null }> | null, wednesday?: Array<{ __typename?: 'TimeInterval', start?: number | null, end?: number | null }> | null, thursday?: Array<{ __typename?: 'TimeInterval', start?: number | null, end?: number | null }> | null, friday?: Array<{ __typename?: 'TimeInterval', start?: number | null, end?: number | null }> | null, saturday?: Array<{ __typename?: 'TimeInterval', start?: number | null, end?: number | null }> | null, sunday?: Array<{ __typename?: 'TimeInterval', start?: number | null, end?: number | null }> | null } | null, pre_confirmation_checklist?: Array<{ __typename?: 'ServicePreConfirmationItem', title: string, description?: string | null, required?: boolean | null }> | null } }> };

export type CreateWidgetServiceMutationVariables = Exact<{
  data: CreateWidgetServiceInput;
}>;


export type CreateWidgetServiceMutation = { __typename?: 'Mutation', createWidgetService: { __typename?: 'WidgetService', id: string, is_active: boolean, created_at: number, updated_at: number, widget: { __typename?: 'Widget', id: string }, service: { __typename?: 'Service', id: string, name?: string | null, order?: number | null, keywords?: string | null, service_types: Array<ServiceType>, is_active?: boolean | null, allow_new?: boolean | null, color?: string | null, description?: string | null, duration?: number | null, allow_returning?: boolean | null, max_per_day?: number | null, max_per_hour?: number | null, excluded_species?: Array<Species> | null, reserved_per_day?: number | null, authorized_levels?: Array<AuthorityLevel> | null, scheduling_buffer_minutes?: number | null, scheduling_min_minutes_away?: number | null, scheduling_max_minutes_away?: number | null, minimum_patient_age_in_days?: number | null, maximum_patient_age_in_days?: number | null, more_info?: string | null, more_info_action_required?: string | null, action_required_acknowledgement_text?: string | null, points: number, drop_off_time?: string | null, pick_up_time?: string | null, is_blocking: boolean, is_reschedule_allowed: boolean, is_cancellation_allowed: boolean, is_primary_for_appt_type: boolean, hide_clinician_preference: boolean, use_previous_doctor: boolean, allowed_appt_type_pms_ids?: Array<string> | null, valid_booking_interval_minutes?: Array<number> | null, only_use_adj_avail_guides: boolean, exclude_from_portal: boolean, created_at: number, updated_at: number, clinic?: { __typename?: 'Clinic', id: string, name?: string | null } | null, service_service_categories?: Array<{ __typename?: 'ServiceServiceCategory', service_category: { __typename?: 'ServiceCategory', id: string, order: number, icon?: ServiceCategoryIcon | null, title: string, description: string, requires_confirmation: boolean, confirmation_message?: string | null, created_at: number, updated_at: number } }> | null, pricing?: { __typename?: 'ServicePricing', price: any, currency: any, type: ServicePricingType, client_type?: ClientTypeEnum | null } | null, pms_appt_type?: { __typename?: 'PmsApptType', id: string, name: string, pms_id: string, description?: string | null, color?: any | null, pms_is_active: boolean } | null, required_room?: { __typename?: 'Room', id: string, pms_id: string, name: string, display_name?: string | null, description?: string | null, concurrent_patients?: number | null, is_active: boolean, does_contribute_to_fill_rate?: boolean | null, valid_booking_interval_minutes?: Array<number> | null, created_at: number, updated_at: number, clinic?: { __typename?: 'Clinic', pms: PracticeManagementSystem, id: string, name?: string | null, time_zone?: string | null } | null, hours?: { __typename?: 'AvailabilityHours', monday?: Array<{ __typename?: 'TimeInterval', start?: number | null, end?: number | null }> | null, tuesday?: Array<{ __typename?: 'TimeInterval', start?: number | null, end?: number | null }> | null, wednesday?: Array<{ __typename?: 'TimeInterval', start?: number | null, end?: number | null }> | null, thursday?: Array<{ __typename?: 'TimeInterval', start?: number | null, end?: number | null }> | null, friday?: Array<{ __typename?: 'TimeInterval', start?: number | null, end?: number | null }> | null, saturday?: Array<{ __typename?: 'TimeInterval', start?: number | null, end?: number | null }> | null, sunday?: Array<{ __typename?: 'TimeInterval', start?: number | null, end?: number | null }> | null } | null, adjusted_availability?: Array<{ __typename?: 'Availability', date: number, pms_appt_type_pms_id?: string | null, times: Array<{ __typename?: 'TimeInterval', start?: number | null, end?: number | null }>, repeat?: { __typename?: 'RepeatAvailability', daysOfMonth?: Array<number> | null, daysOfWeek?: Array<DayOfWeek> | null, weekOfMonth?: WeekOfMonth | null, frequency: any, unit: RepeatUnit, end_date?: number | null } | null }> | null, pms_adjusted_availability?: Array<{ __typename?: 'Availability', date: number, pms_appt_type_pms_id?: string | null, times: Array<{ __typename?: 'TimeInterval', start?: number | null, end?: number | null }>, repeat?: { __typename?: 'RepeatAvailability', daysOfMonth?: Array<number> | null, daysOfWeek?: Array<DayOfWeek> | null, weekOfMonth?: WeekOfMonth | null, frequency: any, unit: RepeatUnit, end_date?: number | null } | null }> | null } | null, default_room?: { __typename?: 'Room', id: string, pms_id: string, name: string, display_name?: string | null, description?: string | null, concurrent_patients?: number | null, is_active: boolean, does_contribute_to_fill_rate?: boolean | null, valid_booking_interval_minutes?: Array<number> | null, created_at: number, updated_at: number, clinic?: { __typename?: 'Clinic', pms: PracticeManagementSystem, id: string, name?: string | null, time_zone?: string | null } | null, hours?: { __typename?: 'AvailabilityHours', monday?: Array<{ __typename?: 'TimeInterval', start?: number | null, end?: number | null }> | null, tuesday?: Array<{ __typename?: 'TimeInterval', start?: number | null, end?: number | null }> | null, wednesday?: Array<{ __typename?: 'TimeInterval', start?: number | null, end?: number | null }> | null, thursday?: Array<{ __typename?: 'TimeInterval', start?: number | null, end?: number | null }> | null, friday?: Array<{ __typename?: 'TimeInterval', start?: number | null, end?: number | null }> | null, saturday?: Array<{ __typename?: 'TimeInterval', start?: number | null, end?: number | null }> | null, sunday?: Array<{ __typename?: 'TimeInterval', start?: number | null, end?: number | null }> | null } | null, adjusted_availability?: Array<{ __typename?: 'Availability', date: number, pms_appt_type_pms_id?: string | null, times: Array<{ __typename?: 'TimeInterval', start?: number | null, end?: number | null }>, repeat?: { __typename?: 'RepeatAvailability', daysOfMonth?: Array<number> | null, daysOfWeek?: Array<DayOfWeek> | null, weekOfMonth?: WeekOfMonth | null, frequency: any, unit: RepeatUnit, end_date?: number | null } | null }> | null, pms_adjusted_availability?: Array<{ __typename?: 'Availability', date: number, pms_appt_type_pms_id?: string | null, times: Array<{ __typename?: 'TimeInterval', start?: number | null, end?: number | null }>, repeat?: { __typename?: 'RepeatAvailability', daysOfMonth?: Array<number> | null, daysOfWeek?: Array<DayOfWeek> | null, weekOfMonth?: WeekOfMonth | null, frequency: any, unit: RepeatUnit, end_date?: number | null } | null }> | null } | null, availability?: { __typename?: 'AvailabilityHours', monday?: Array<{ __typename?: 'TimeInterval', start?: number | null, end?: number | null }> | null, tuesday?: Array<{ __typename?: 'TimeInterval', start?: number | null, end?: number | null }> | null, wednesday?: Array<{ __typename?: 'TimeInterval', start?: number | null, end?: number | null }> | null, thursday?: Array<{ __typename?: 'TimeInterval', start?: number | null, end?: number | null }> | null, friday?: Array<{ __typename?: 'TimeInterval', start?: number | null, end?: number | null }> | null, saturday?: Array<{ __typename?: 'TimeInterval', start?: number | null, end?: number | null }> | null, sunday?: Array<{ __typename?: 'TimeInterval', start?: number | null, end?: number | null }> | null } | null, drop_off_hours?: { __typename?: 'AvailabilityHours', monday?: Array<{ __typename?: 'TimeInterval', start?: number | null, end?: number | null }> | null, tuesday?: Array<{ __typename?: 'TimeInterval', start?: number | null, end?: number | null }> | null, wednesday?: Array<{ __typename?: 'TimeInterval', start?: number | null, end?: number | null }> | null, thursday?: Array<{ __typename?: 'TimeInterval', start?: number | null, end?: number | null }> | null, friday?: Array<{ __typename?: 'TimeInterval', start?: number | null, end?: number | null }> | null, saturday?: Array<{ __typename?: 'TimeInterval', start?: number | null, end?: number | null }> | null, sunday?: Array<{ __typename?: 'TimeInterval', start?: number | null, end?: number | null }> | null } | null, pre_confirmation_checklist?: Array<{ __typename?: 'ServicePreConfirmationItem', title: string, description?: string | null, required?: boolean | null }> | null } } };

export type UpdateWidgetServiceMutationVariables = Exact<{
  widgetId: Scalars['ID']['input'];
  data: UpdateWidgetServiceInput;
}>;


export type UpdateWidgetServiceMutation = { __typename?: 'Mutation', updateWidgetService: { __typename?: 'WidgetService', id: string, is_active: boolean, created_at: number, updated_at: number, widget: { __typename?: 'Widget', id: string }, service: { __typename?: 'Service', id: string, name?: string | null, order?: number | null, keywords?: string | null, service_types: Array<ServiceType>, is_active?: boolean | null, allow_new?: boolean | null, color?: string | null, description?: string | null, duration?: number | null, allow_returning?: boolean | null, max_per_day?: number | null, max_per_hour?: number | null, excluded_species?: Array<Species> | null, reserved_per_day?: number | null, authorized_levels?: Array<AuthorityLevel> | null, scheduling_buffer_minutes?: number | null, scheduling_min_minutes_away?: number | null, scheduling_max_minutes_away?: number | null, minimum_patient_age_in_days?: number | null, maximum_patient_age_in_days?: number | null, more_info?: string | null, more_info_action_required?: string | null, action_required_acknowledgement_text?: string | null, points: number, drop_off_time?: string | null, pick_up_time?: string | null, is_blocking: boolean, is_reschedule_allowed: boolean, is_cancellation_allowed: boolean, is_primary_for_appt_type: boolean, hide_clinician_preference: boolean, use_previous_doctor: boolean, allowed_appt_type_pms_ids?: Array<string> | null, valid_booking_interval_minutes?: Array<number> | null, only_use_adj_avail_guides: boolean, exclude_from_portal: boolean, created_at: number, updated_at: number, clinic?: { __typename?: 'Clinic', id: string, name?: string | null } | null, service_service_categories?: Array<{ __typename?: 'ServiceServiceCategory', service_category: { __typename?: 'ServiceCategory', id: string, order: number, icon?: ServiceCategoryIcon | null, title: string, description: string, requires_confirmation: boolean, confirmation_message?: string | null, created_at: number, updated_at: number } }> | null, pricing?: { __typename?: 'ServicePricing', price: any, currency: any, type: ServicePricingType, client_type?: ClientTypeEnum | null } | null, pms_appt_type?: { __typename?: 'PmsApptType', id: string, name: string, pms_id: string, description?: string | null, color?: any | null, pms_is_active: boolean } | null, required_room?: { __typename?: 'Room', id: string, pms_id: string, name: string, display_name?: string | null, description?: string | null, concurrent_patients?: number | null, is_active: boolean, does_contribute_to_fill_rate?: boolean | null, valid_booking_interval_minutes?: Array<number> | null, created_at: number, updated_at: number, clinic?: { __typename?: 'Clinic', pms: PracticeManagementSystem, id: string, name?: string | null, time_zone?: string | null } | null, hours?: { __typename?: 'AvailabilityHours', monday?: Array<{ __typename?: 'TimeInterval', start?: number | null, end?: number | null }> | null, tuesday?: Array<{ __typename?: 'TimeInterval', start?: number | null, end?: number | null }> | null, wednesday?: Array<{ __typename?: 'TimeInterval', start?: number | null, end?: number | null }> | null, thursday?: Array<{ __typename?: 'TimeInterval', start?: number | null, end?: number | null }> | null, friday?: Array<{ __typename?: 'TimeInterval', start?: number | null, end?: number | null }> | null, saturday?: Array<{ __typename?: 'TimeInterval', start?: number | null, end?: number | null }> | null, sunday?: Array<{ __typename?: 'TimeInterval', start?: number | null, end?: number | null }> | null } | null, adjusted_availability?: Array<{ __typename?: 'Availability', date: number, pms_appt_type_pms_id?: string | null, times: Array<{ __typename?: 'TimeInterval', start?: number | null, end?: number | null }>, repeat?: { __typename?: 'RepeatAvailability', daysOfMonth?: Array<number> | null, daysOfWeek?: Array<DayOfWeek> | null, weekOfMonth?: WeekOfMonth | null, frequency: any, unit: RepeatUnit, end_date?: number | null } | null }> | null, pms_adjusted_availability?: Array<{ __typename?: 'Availability', date: number, pms_appt_type_pms_id?: string | null, times: Array<{ __typename?: 'TimeInterval', start?: number | null, end?: number | null }>, repeat?: { __typename?: 'RepeatAvailability', daysOfMonth?: Array<number> | null, daysOfWeek?: Array<DayOfWeek> | null, weekOfMonth?: WeekOfMonth | null, frequency: any, unit: RepeatUnit, end_date?: number | null } | null }> | null } | null, default_room?: { __typename?: 'Room', id: string, pms_id: string, name: string, display_name?: string | null, description?: string | null, concurrent_patients?: number | null, is_active: boolean, does_contribute_to_fill_rate?: boolean | null, valid_booking_interval_minutes?: Array<number> | null, created_at: number, updated_at: number, clinic?: { __typename?: 'Clinic', pms: PracticeManagementSystem, id: string, name?: string | null, time_zone?: string | null } | null, hours?: { __typename?: 'AvailabilityHours', monday?: Array<{ __typename?: 'TimeInterval', start?: number | null, end?: number | null }> | null, tuesday?: Array<{ __typename?: 'TimeInterval', start?: number | null, end?: number | null }> | null, wednesday?: Array<{ __typename?: 'TimeInterval', start?: number | null, end?: number | null }> | null, thursday?: Array<{ __typename?: 'TimeInterval', start?: number | null, end?: number | null }> | null, friday?: Array<{ __typename?: 'TimeInterval', start?: number | null, end?: number | null }> | null, saturday?: Array<{ __typename?: 'TimeInterval', start?: number | null, end?: number | null }> | null, sunday?: Array<{ __typename?: 'TimeInterval', start?: number | null, end?: number | null }> | null } | null, adjusted_availability?: Array<{ __typename?: 'Availability', date: number, pms_appt_type_pms_id?: string | null, times: Array<{ __typename?: 'TimeInterval', start?: number | null, end?: number | null }>, repeat?: { __typename?: 'RepeatAvailability', daysOfMonth?: Array<number> | null, daysOfWeek?: Array<DayOfWeek> | null, weekOfMonth?: WeekOfMonth | null, frequency: any, unit: RepeatUnit, end_date?: number | null } | null }> | null, pms_adjusted_availability?: Array<{ __typename?: 'Availability', date: number, pms_appt_type_pms_id?: string | null, times: Array<{ __typename?: 'TimeInterval', start?: number | null, end?: number | null }>, repeat?: { __typename?: 'RepeatAvailability', daysOfMonth?: Array<number> | null, daysOfWeek?: Array<DayOfWeek> | null, weekOfMonth?: WeekOfMonth | null, frequency: any, unit: RepeatUnit, end_date?: number | null } | null }> | null } | null, availability?: { __typename?: 'AvailabilityHours', monday?: Array<{ __typename?: 'TimeInterval', start?: number | null, end?: number | null }> | null, tuesday?: Array<{ __typename?: 'TimeInterval', start?: number | null, end?: number | null }> | null, wednesday?: Array<{ __typename?: 'TimeInterval', start?: number | null, end?: number | null }> | null, thursday?: Array<{ __typename?: 'TimeInterval', start?: number | null, end?: number | null }> | null, friday?: Array<{ __typename?: 'TimeInterval', start?: number | null, end?: number | null }> | null, saturday?: Array<{ __typename?: 'TimeInterval', start?: number | null, end?: number | null }> | null, sunday?: Array<{ __typename?: 'TimeInterval', start?: number | null, end?: number | null }> | null } | null, drop_off_hours?: { __typename?: 'AvailabilityHours', monday?: Array<{ __typename?: 'TimeInterval', start?: number | null, end?: number | null }> | null, tuesday?: Array<{ __typename?: 'TimeInterval', start?: number | null, end?: number | null }> | null, wednesday?: Array<{ __typename?: 'TimeInterval', start?: number | null, end?: number | null }> | null, thursday?: Array<{ __typename?: 'TimeInterval', start?: number | null, end?: number | null }> | null, friday?: Array<{ __typename?: 'TimeInterval', start?: number | null, end?: number | null }> | null, saturday?: Array<{ __typename?: 'TimeInterval', start?: number | null, end?: number | null }> | null, sunday?: Array<{ __typename?: 'TimeInterval', start?: number | null, end?: number | null }> | null } | null, pre_confirmation_checklist?: Array<{ __typename?: 'ServicePreConfirmationItem', title: string, description?: string | null, required?: boolean | null }> | null } } };

export type DeleteWidgetServiceMutationVariables = Exact<{
  widgetId: Scalars['ID']['input'];
}>;


export type DeleteWidgetServiceMutation = { __typename?: 'Mutation', deleteWidgetService?: any | null };

export type WidgetFieldsFragment = { __typename?: 'Widget', id: string, widget_name: string, type: WidgetType, trigger_type: WidgetTriggerType, button_color?: string | null, button_text?: string | null, text_color?: string | null, is_external: boolean, is_active: boolean, is_archived: boolean, is_default_portal: boolean, enabled_chat_buttons?: Array<WidgetMenuButtonType> | null, average_chat_response_time?: string | null, source?: string | null, created_at: number, updated_at: number, clinic?: { __typename?: 'Clinic', id: string, name?: string | null, slug?: string | null } | null, organization?: { __typename?: 'Organization', id: string, name: string, slug?: string | null } | null, clinic_group?: { __typename?: 'ClinicGroup', id: string, name: string, slug: string, clinic_group_clinics: Array<{ __typename?: 'ClinicGroupClinic', id: string, created_at: number, clinic: { __typename?: 'Clinic', id: string, name?: string | null, slug?: string | null, avatar_url?: string | null, time_zone?: string | null, is_archived: boolean, address?: { __typename?: 'Address', street_a?: string | null, street_b?: string | null, city?: string | null, state?: string | null, zip?: string | null, country?: string | null } | null, pms_db?: { __typename?: 'PmsDb', id: string } | null } }> } | null, campaign?: { __typename?: 'Campaign', id: string, name: string, color?: string | null, description?: string | null } | null, widget_styles?: { __typename?: 'WidgetStyles', header_color?: string | null, header_text_color?: string | null, footer_color?: string | null, footer_text_color?: string | null, floating_margin_bottom?: number | null, floating_margin_right?: number | null, include_service_categories_with_custom_order?: boolean | null, heading_color?: string | null, heading_font?: WidgetHeadingFont | null, background_color?: string | null, card_color?: string | null, button_color?: string | null, button_text_color?: string | null, text_color?: string | null, reviews_name_color?: string | null, reviews_stars_color?: string | null, reviews_date_color?: string | null, reviews_text_color?: string | null, reviews_arrow_background?: string | null, reviews_arrow_color?: string | null, reviews_title_text?: string | null, clinic_order?: Array<{ __typename?: 'ClinicOrder', clinic_id: string, order: number }> | null, service_order?: Array<{ __typename?: 'ServiceOrder', service_id: string, order: number }> | null, clinic_image_map?: Array<{ __typename?: 'ClinicImageMap', clinic_id: string, image_url: string }> | null } | null, featured_reviews?: Array<{ __typename?: 'FeaturedReview', order: number, review: { __typename?: 'Review', id: string, description?: string | null, overall_rating: number, is_anonymous?: boolean | null, review_submitted_at?: number | null, review_source: ReviewSource, external_id?: string | null, external_author_name?: string | null, external_author_image?: string | null, external_rating?: number | null, external_text?: string | null, external_timestamp?: number | null, external_review_url?: string | null, external_owner_response?: string | null, external_owner_response_timestamp?: number | null, created_at: number, updated_at: number, client?: { __typename?: 'Client', id: string, first_name?: string | null, last_name?: string | null, email?: string | null, phone?: string | null, address?: { __typename?: 'Address', street_a?: string | null, street_b?: string | null, city?: string | null, state?: string | null, zip?: string | null, country?: string | null } | null } | null, appointment?: { __typename?: 'Appointment', id: string } | null, clinic: { __typename?: 'Clinic', id: string, name?: string | null, address?: { __typename?: 'Address', street_a?: string | null, street_b?: string | null, city?: string | null, state?: string | null, zip?: string | null, country?: string | null } | null, settings?: { __typename?: 'ClinicSettings', review_google_id?: string | null, review_facebook_id?: string | null } | null } } }> | null };

export type WidgetPreviewFieldsFragment = { __typename?: 'Widget', id: string, widget_name: string, type: WidgetType, widget_options?: { __typename?: 'WidgetOptions', should_allow_new_clients?: boolean | null, should_allow_new_patients?: boolean | null, should_allow_returning_clients?: boolean | null, should_allow_returning_patients?: boolean | null, widget_access_start_time?: number | null, widget_access_end_time?: number | null, booking_avail_end?: number | null, scheduling_min_minutes_away?: number | null, scheduling_max_minutes_away?: number | null, enabled: boolean } | null };

export type WidgetFeaturedReviewFieldsFragment = { __typename?: 'FeaturedReview', order: number, review: { __typename?: 'Review', id: string, description?: string | null, overall_rating: number, is_anonymous?: boolean | null, review_submitted_at?: number | null, review_source: ReviewSource, external_id?: string | null, external_author_name?: string | null, external_author_image?: string | null, external_rating?: number | null, external_text?: string | null, external_timestamp?: number | null, external_review_url?: string | null, external_owner_response?: string | null, external_owner_response_timestamp?: number | null, created_at: number, updated_at: number, client?: { __typename?: 'Client', id: string, first_name?: string | null, last_name?: string | null, email?: string | null, phone?: string | null, address?: { __typename?: 'Address', street_a?: string | null, street_b?: string | null, city?: string | null, state?: string | null, zip?: string | null, country?: string | null } | null } | null, appointment?: { __typename?: 'Appointment', id: string } | null, clinic: { __typename?: 'Clinic', id: string, name?: string | null, address?: { __typename?: 'Address', street_a?: string | null, street_b?: string | null, city?: string | null, state?: string | null, zip?: string | null, country?: string | null } | null, settings?: { __typename?: 'ClinicSettings', review_google_id?: string | null, review_facebook_id?: string | null } | null } } };

export type WidgetWithServicesFieldsFragment = { __typename?: 'Widget', id: string, widget_name: string, type: WidgetType, trigger_type: WidgetTriggerType, button_color?: string | null, button_text?: string | null, text_color?: string | null, is_external: boolean, is_active: boolean, is_archived: boolean, is_default_portal: boolean, enabled_chat_buttons?: Array<WidgetMenuButtonType> | null, average_chat_response_time?: string | null, source?: string | null, created_at: number, updated_at: number, widgets_services?: Array<{ __typename?: 'WidgetService', service: { __typename?: 'Service', id: string, name?: string | null, order?: number | null, keywords?: string | null, service_types: Array<ServiceType>, is_active?: boolean | null, allow_new?: boolean | null, color?: string | null, description?: string | null, duration?: number | null, allow_returning?: boolean | null, max_per_day?: number | null, max_per_hour?: number | null, excluded_species?: Array<Species> | null, reserved_per_day?: number | null, authorized_levels?: Array<AuthorityLevel> | null, scheduling_buffer_minutes?: number | null, scheduling_min_minutes_away?: number | null, scheduling_max_minutes_away?: number | null, minimum_patient_age_in_days?: number | null, maximum_patient_age_in_days?: number | null, more_info?: string | null, more_info_action_required?: string | null, action_required_acknowledgement_text?: string | null, points: number, drop_off_time?: string | null, pick_up_time?: string | null, is_blocking: boolean, is_reschedule_allowed: boolean, is_cancellation_allowed: boolean, is_primary_for_appt_type: boolean, hide_clinician_preference: boolean, use_previous_doctor: boolean, allowed_appt_type_pms_ids?: Array<string> | null, valid_booking_interval_minutes?: Array<number> | null, only_use_adj_avail_guides: boolean, exclude_from_portal: boolean, created_at: number, updated_at: number, clinic?: { __typename?: 'Clinic', id: string, name?: string | null } | null, service_service_categories?: Array<{ __typename?: 'ServiceServiceCategory', service_category: { __typename?: 'ServiceCategory', id: string, order: number, icon?: ServiceCategoryIcon | null, title: string, description: string, requires_confirmation: boolean, confirmation_message?: string | null, created_at: number, updated_at: number } }> | null, pricing?: { __typename?: 'ServicePricing', price: any, currency: any, type: ServicePricingType, client_type?: ClientTypeEnum | null } | null, pms_appt_type?: { __typename?: 'PmsApptType', id: string, name: string, pms_id: string, description?: string | null, color?: any | null, pms_is_active: boolean } | null, required_room?: { __typename?: 'Room', id: string, pms_id: string, name: string, display_name?: string | null, description?: string | null, concurrent_patients?: number | null, is_active: boolean, does_contribute_to_fill_rate?: boolean | null, valid_booking_interval_minutes?: Array<number> | null, created_at: number, updated_at: number, clinic?: { __typename?: 'Clinic', pms: PracticeManagementSystem, id: string, name?: string | null, time_zone?: string | null } | null, hours?: { __typename?: 'AvailabilityHours', monday?: Array<{ __typename?: 'TimeInterval', start?: number | null, end?: number | null }> | null, tuesday?: Array<{ __typename?: 'TimeInterval', start?: number | null, end?: number | null }> | null, wednesday?: Array<{ __typename?: 'TimeInterval', start?: number | null, end?: number | null }> | null, thursday?: Array<{ __typename?: 'TimeInterval', start?: number | null, end?: number | null }> | null, friday?: Array<{ __typename?: 'TimeInterval', start?: number | null, end?: number | null }> | null, saturday?: Array<{ __typename?: 'TimeInterval', start?: number | null, end?: number | null }> | null, sunday?: Array<{ __typename?: 'TimeInterval', start?: number | null, end?: number | null }> | null } | null, adjusted_availability?: Array<{ __typename?: 'Availability', date: number, pms_appt_type_pms_id?: string | null, times: Array<{ __typename?: 'TimeInterval', start?: number | null, end?: number | null }>, repeat?: { __typename?: 'RepeatAvailability', daysOfMonth?: Array<number> | null, daysOfWeek?: Array<DayOfWeek> | null, weekOfMonth?: WeekOfMonth | null, frequency: any, unit: RepeatUnit, end_date?: number | null } | null }> | null, pms_adjusted_availability?: Array<{ __typename?: 'Availability', date: number, pms_appt_type_pms_id?: string | null, times: Array<{ __typename?: 'TimeInterval', start?: number | null, end?: number | null }>, repeat?: { __typename?: 'RepeatAvailability', daysOfMonth?: Array<number> | null, daysOfWeek?: Array<DayOfWeek> | null, weekOfMonth?: WeekOfMonth | null, frequency: any, unit: RepeatUnit, end_date?: number | null } | null }> | null } | null, default_room?: { __typename?: 'Room', id: string, pms_id: string, name: string, display_name?: string | null, description?: string | null, concurrent_patients?: number | null, is_active: boolean, does_contribute_to_fill_rate?: boolean | null, valid_booking_interval_minutes?: Array<number> | null, created_at: number, updated_at: number, clinic?: { __typename?: 'Clinic', pms: PracticeManagementSystem, id: string, name?: string | null, time_zone?: string | null } | null, hours?: { __typename?: 'AvailabilityHours', monday?: Array<{ __typename?: 'TimeInterval', start?: number | null, end?: number | null }> | null, tuesday?: Array<{ __typename?: 'TimeInterval', start?: number | null, end?: number | null }> | null, wednesday?: Array<{ __typename?: 'TimeInterval', start?: number | null, end?: number | null }> | null, thursday?: Array<{ __typename?: 'TimeInterval', start?: number | null, end?: number | null }> | null, friday?: Array<{ __typename?: 'TimeInterval', start?: number | null, end?: number | null }> | null, saturday?: Array<{ __typename?: 'TimeInterval', start?: number | null, end?: number | null }> | null, sunday?: Array<{ __typename?: 'TimeInterval', start?: number | null, end?: number | null }> | null } | null, adjusted_availability?: Array<{ __typename?: 'Availability', date: number, pms_appt_type_pms_id?: string | null, times: Array<{ __typename?: 'TimeInterval', start?: number | null, end?: number | null }>, repeat?: { __typename?: 'RepeatAvailability', daysOfMonth?: Array<number> | null, daysOfWeek?: Array<DayOfWeek> | null, weekOfMonth?: WeekOfMonth | null, frequency: any, unit: RepeatUnit, end_date?: number | null } | null }> | null, pms_adjusted_availability?: Array<{ __typename?: 'Availability', date: number, pms_appt_type_pms_id?: string | null, times: Array<{ __typename?: 'TimeInterval', start?: number | null, end?: number | null }>, repeat?: { __typename?: 'RepeatAvailability', daysOfMonth?: Array<number> | null, daysOfWeek?: Array<DayOfWeek> | null, weekOfMonth?: WeekOfMonth | null, frequency: any, unit: RepeatUnit, end_date?: number | null } | null }> | null } | null, availability?: { __typename?: 'AvailabilityHours', monday?: Array<{ __typename?: 'TimeInterval', start?: number | null, end?: number | null }> | null, tuesday?: Array<{ __typename?: 'TimeInterval', start?: number | null, end?: number | null }> | null, wednesday?: Array<{ __typename?: 'TimeInterval', start?: number | null, end?: number | null }> | null, thursday?: Array<{ __typename?: 'TimeInterval', start?: number | null, end?: number | null }> | null, friday?: Array<{ __typename?: 'TimeInterval', start?: number | null, end?: number | null }> | null, saturday?: Array<{ __typename?: 'TimeInterval', start?: number | null, end?: number | null }> | null, sunday?: Array<{ __typename?: 'TimeInterval', start?: number | null, end?: number | null }> | null } | null, drop_off_hours?: { __typename?: 'AvailabilityHours', monday?: Array<{ __typename?: 'TimeInterval', start?: number | null, end?: number | null }> | null, tuesday?: Array<{ __typename?: 'TimeInterval', start?: number | null, end?: number | null }> | null, wednesday?: Array<{ __typename?: 'TimeInterval', start?: number | null, end?: number | null }> | null, thursday?: Array<{ __typename?: 'TimeInterval', start?: number | null, end?: number | null }> | null, friday?: Array<{ __typename?: 'TimeInterval', start?: number | null, end?: number | null }> | null, saturday?: Array<{ __typename?: 'TimeInterval', start?: number | null, end?: number | null }> | null, sunday?: Array<{ __typename?: 'TimeInterval', start?: number | null, end?: number | null }> | null } | null, pre_confirmation_checklist?: Array<{ __typename?: 'ServicePreConfirmationItem', title: string, description?: string | null, required?: boolean | null }> | null } }> | null, clinic?: { __typename?: 'Clinic', id: string, name?: string | null, slug?: string | null } | null, organization?: { __typename?: 'Organization', id: string, name: string, slug?: string | null } | null, clinic_group?: { __typename?: 'ClinicGroup', id: string, name: string, slug: string, clinic_group_clinics: Array<{ __typename?: 'ClinicGroupClinic', id: string, created_at: number, clinic: { __typename?: 'Clinic', id: string, name?: string | null, slug?: string | null, avatar_url?: string | null, time_zone?: string | null, is_archived: boolean, address?: { __typename?: 'Address', street_a?: string | null, street_b?: string | null, city?: string | null, state?: string | null, zip?: string | null, country?: string | null } | null, pms_db?: { __typename?: 'PmsDb', id: string } | null } }> } | null, campaign?: { __typename?: 'Campaign', id: string, name: string, color?: string | null, description?: string | null } | null, widget_styles?: { __typename?: 'WidgetStyles', header_color?: string | null, header_text_color?: string | null, footer_color?: string | null, footer_text_color?: string | null, floating_margin_bottom?: number | null, floating_margin_right?: number | null, include_service_categories_with_custom_order?: boolean | null, heading_color?: string | null, heading_font?: WidgetHeadingFont | null, background_color?: string | null, card_color?: string | null, button_color?: string | null, button_text_color?: string | null, text_color?: string | null, reviews_name_color?: string | null, reviews_stars_color?: string | null, reviews_date_color?: string | null, reviews_text_color?: string | null, reviews_arrow_background?: string | null, reviews_arrow_color?: string | null, reviews_title_text?: string | null, clinic_order?: Array<{ __typename?: 'ClinicOrder', clinic_id: string, order: number }> | null, service_order?: Array<{ __typename?: 'ServiceOrder', service_id: string, order: number }> | null, clinic_image_map?: Array<{ __typename?: 'ClinicImageMap', clinic_id: string, image_url: string }> | null } | null, featured_reviews?: Array<{ __typename?: 'FeaturedReview', order: number, review: { __typename?: 'Review', id: string, description?: string | null, overall_rating: number, is_anonymous?: boolean | null, review_submitted_at?: number | null, review_source: ReviewSource, external_id?: string | null, external_author_name?: string | null, external_author_image?: string | null, external_rating?: number | null, external_text?: string | null, external_timestamp?: number | null, external_review_url?: string | null, external_owner_response?: string | null, external_owner_response_timestamp?: number | null, created_at: number, updated_at: number, client?: { __typename?: 'Client', id: string, first_name?: string | null, last_name?: string | null, email?: string | null, phone?: string | null, address?: { __typename?: 'Address', street_a?: string | null, street_b?: string | null, city?: string | null, state?: string | null, zip?: string | null, country?: string | null } | null } | null, appointment?: { __typename?: 'Appointment', id: string } | null, clinic: { __typename?: 'Clinic', id: string, name?: string | null, address?: { __typename?: 'Address', street_a?: string | null, street_b?: string | null, city?: string | null, state?: string | null, zip?: string | null, country?: string | null } | null, settings?: { __typename?: 'ClinicSettings', review_google_id?: string | null, review_facebook_id?: string | null } | null } } }> | null };

export type GetWidgetQueryVariables = Exact<{
  id: Scalars['ID']['input'];
}>;


export type GetWidgetQuery = { __typename?: 'Query', widget: { __typename?: 'Widget', id: string, widget_name: string, type: WidgetType, trigger_type: WidgetTriggerType, button_color?: string | null, button_text?: string | null, text_color?: string | null, is_external: boolean, is_active: boolean, is_archived: boolean, is_default_portal: boolean, enabled_chat_buttons?: Array<WidgetMenuButtonType> | null, average_chat_response_time?: string | null, source?: string | null, created_at: number, updated_at: number, clinic?: { __typename?: 'Clinic', id: string, name?: string | null, slug?: string | null } | null, organization?: { __typename?: 'Organization', id: string, name: string, slug?: string | null } | null, clinic_group?: { __typename?: 'ClinicGroup', id: string, name: string, slug: string, clinic_group_clinics: Array<{ __typename?: 'ClinicGroupClinic', id: string, created_at: number, clinic: { __typename?: 'Clinic', id: string, name?: string | null, slug?: string | null, avatar_url?: string | null, time_zone?: string | null, is_archived: boolean, address?: { __typename?: 'Address', street_a?: string | null, street_b?: string | null, city?: string | null, state?: string | null, zip?: string | null, country?: string | null } | null, pms_db?: { __typename?: 'PmsDb', id: string } | null } }> } | null, campaign?: { __typename?: 'Campaign', id: string, name: string, color?: string | null, description?: string | null } | null, widget_styles?: { __typename?: 'WidgetStyles', header_color?: string | null, header_text_color?: string | null, footer_color?: string | null, footer_text_color?: string | null, floating_margin_bottom?: number | null, floating_margin_right?: number | null, include_service_categories_with_custom_order?: boolean | null, heading_color?: string | null, heading_font?: WidgetHeadingFont | null, background_color?: string | null, card_color?: string | null, button_color?: string | null, button_text_color?: string | null, text_color?: string | null, reviews_name_color?: string | null, reviews_stars_color?: string | null, reviews_date_color?: string | null, reviews_text_color?: string | null, reviews_arrow_background?: string | null, reviews_arrow_color?: string | null, reviews_title_text?: string | null, clinic_order?: Array<{ __typename?: 'ClinicOrder', clinic_id: string, order: number }> | null, service_order?: Array<{ __typename?: 'ServiceOrder', service_id: string, order: number }> | null, clinic_image_map?: Array<{ __typename?: 'ClinicImageMap', clinic_id: string, image_url: string }> | null } | null, featured_reviews?: Array<{ __typename?: 'FeaturedReview', order: number, review: { __typename?: 'Review', id: string, description?: string | null, overall_rating: number, is_anonymous?: boolean | null, review_submitted_at?: number | null, review_source: ReviewSource, external_id?: string | null, external_author_name?: string | null, external_author_image?: string | null, external_rating?: number | null, external_text?: string | null, external_timestamp?: number | null, external_review_url?: string | null, external_owner_response?: string | null, external_owner_response_timestamp?: number | null, created_at: number, updated_at: number, client?: { __typename?: 'Client', id: string, first_name?: string | null, last_name?: string | null, email?: string | null, phone?: string | null, address?: { __typename?: 'Address', street_a?: string | null, street_b?: string | null, city?: string | null, state?: string | null, zip?: string | null, country?: string | null } | null } | null, appointment?: { __typename?: 'Appointment', id: string } | null, clinic: { __typename?: 'Clinic', id: string, name?: string | null, address?: { __typename?: 'Address', street_a?: string | null, street_b?: string | null, city?: string | null, state?: string | null, zip?: string | null, country?: string | null } | null, settings?: { __typename?: 'ClinicSettings', review_google_id?: string | null, review_facebook_id?: string | null } | null } } }> | null } };

export type EnsureDefaultPortalWidgetQueryVariables = Exact<{
  clinicId: Scalars['ID']['input'];
}>;


export type EnsureDefaultPortalWidgetQuery = { __typename?: 'Query', ensureDefaultPortalWidget: { __typename?: 'Widget', id: string, widget_name: string, type: WidgetType, trigger_type: WidgetTriggerType, button_color?: string | null, button_text?: string | null, text_color?: string | null, is_external: boolean, is_active: boolean, is_archived: boolean, is_default_portal: boolean, enabled_chat_buttons?: Array<WidgetMenuButtonType> | null, average_chat_response_time?: string | null, source?: string | null, created_at: number, updated_at: number, clinic?: { __typename?: 'Clinic', id: string, name?: string | null, slug?: string | null } | null, organization?: { __typename?: 'Organization', id: string, name: string, slug?: string | null } | null, clinic_group?: { __typename?: 'ClinicGroup', id: string, name: string, slug: string, clinic_group_clinics: Array<{ __typename?: 'ClinicGroupClinic', id: string, created_at: number, clinic: { __typename?: 'Clinic', id: string, name?: string | null, slug?: string | null, avatar_url?: string | null, time_zone?: string | null, is_archived: boolean, address?: { __typename?: 'Address', street_a?: string | null, street_b?: string | null, city?: string | null, state?: string | null, zip?: string | null, country?: string | null } | null, pms_db?: { __typename?: 'PmsDb', id: string } | null } }> } | null, campaign?: { __typename?: 'Campaign', id: string, name: string, color?: string | null, description?: string | null } | null, widget_styles?: { __typename?: 'WidgetStyles', header_color?: string | null, header_text_color?: string | null, footer_color?: string | null, footer_text_color?: string | null, floating_margin_bottom?: number | null, floating_margin_right?: number | null, include_service_categories_with_custom_order?: boolean | null, heading_color?: string | null, heading_font?: WidgetHeadingFont | null, background_color?: string | null, card_color?: string | null, button_color?: string | null, button_text_color?: string | null, text_color?: string | null, reviews_name_color?: string | null, reviews_stars_color?: string | null, reviews_date_color?: string | null, reviews_text_color?: string | null, reviews_arrow_background?: string | null, reviews_arrow_color?: string | null, reviews_title_text?: string | null, clinic_order?: Array<{ __typename?: 'ClinicOrder', clinic_id: string, order: number }> | null, service_order?: Array<{ __typename?: 'ServiceOrder', service_id: string, order: number }> | null, clinic_image_map?: Array<{ __typename?: 'ClinicImageMap', clinic_id: string, image_url: string }> | null } | null, featured_reviews?: Array<{ __typename?: 'FeaturedReview', order: number, review: { __typename?: 'Review', id: string, description?: string | null, overall_rating: number, is_anonymous?: boolean | null, review_submitted_at?: number | null, review_source: ReviewSource, external_id?: string | null, external_author_name?: string | null, external_author_image?: string | null, external_rating?: number | null, external_text?: string | null, external_timestamp?: number | null, external_review_url?: string | null, external_owner_response?: string | null, external_owner_response_timestamp?: number | null, created_at: number, updated_at: number, client?: { __typename?: 'Client', id: string, first_name?: string | null, last_name?: string | null, email?: string | null, phone?: string | null, address?: { __typename?: 'Address', street_a?: string | null, street_b?: string | null, city?: string | null, state?: string | null, zip?: string | null, country?: string | null } | null } | null, appointment?: { __typename?: 'Appointment', id: string } | null, clinic: { __typename?: 'Clinic', id: string, name?: string | null, address?: { __typename?: 'Address', street_a?: string | null, street_b?: string | null, city?: string | null, state?: string | null, zip?: string | null, country?: string | null } | null, settings?: { __typename?: 'ClinicSettings', review_google_id?: string | null, review_facebook_id?: string | null } | null } } }> | null } };

export type GetWidgetWithServicesQueryVariables = Exact<{
  id: Scalars['ID']['input'];
}>;


export type GetWidgetWithServicesQuery = { __typename?: 'Query', widget: { __typename?: 'Widget', id: string, widget_name: string, type: WidgetType, trigger_type: WidgetTriggerType, button_color?: string | null, button_text?: string | null, text_color?: string | null, is_external: boolean, is_active: boolean, is_archived: boolean, is_default_portal: boolean, enabled_chat_buttons?: Array<WidgetMenuButtonType> | null, average_chat_response_time?: string | null, source?: string | null, created_at: number, updated_at: number, widgets_services?: Array<{ __typename?: 'WidgetService', service: { __typename?: 'Service', id: string, name?: string | null, order?: number | null, keywords?: string | null, service_types: Array<ServiceType>, is_active?: boolean | null, allow_new?: boolean | null, color?: string | null, description?: string | null, duration?: number | null, allow_returning?: boolean | null, max_per_day?: number | null, max_per_hour?: number | null, excluded_species?: Array<Species> | null, reserved_per_day?: number | null, authorized_levels?: Array<AuthorityLevel> | null, scheduling_buffer_minutes?: number | null, scheduling_min_minutes_away?: number | null, scheduling_max_minutes_away?: number | null, minimum_patient_age_in_days?: number | null, maximum_patient_age_in_days?: number | null, more_info?: string | null, more_info_action_required?: string | null, action_required_acknowledgement_text?: string | null, points: number, drop_off_time?: string | null, pick_up_time?: string | null, is_blocking: boolean, is_reschedule_allowed: boolean, is_cancellation_allowed: boolean, is_primary_for_appt_type: boolean, hide_clinician_preference: boolean, use_previous_doctor: boolean, allowed_appt_type_pms_ids?: Array<string> | null, valid_booking_interval_minutes?: Array<number> | null, only_use_adj_avail_guides: boolean, exclude_from_portal: boolean, created_at: number, updated_at: number, clinic?: { __typename?: 'Clinic', id: string, name?: string | null } | null, service_service_categories?: Array<{ __typename?: 'ServiceServiceCategory', service_category: { __typename?: 'ServiceCategory', id: string, order: number, icon?: ServiceCategoryIcon | null, title: string, description: string, requires_confirmation: boolean, confirmation_message?: string | null, created_at: number, updated_at: number } }> | null, pricing?: { __typename?: 'ServicePricing', price: any, currency: any, type: ServicePricingType, client_type?: ClientTypeEnum | null } | null, pms_appt_type?: { __typename?: 'PmsApptType', id: string, name: string, pms_id: string, description?: string | null, color?: any | null, pms_is_active: boolean } | null, required_room?: { __typename?: 'Room', id: string, pms_id: string, name: string, display_name?: string | null, description?: string | null, concurrent_patients?: number | null, is_active: boolean, does_contribute_to_fill_rate?: boolean | null, valid_booking_interval_minutes?: Array<number> | null, created_at: number, updated_at: number, clinic?: { __typename?: 'Clinic', pms: PracticeManagementSystem, id: string, name?: string | null, time_zone?: string | null } | null, hours?: { __typename?: 'AvailabilityHours', monday?: Array<{ __typename?: 'TimeInterval', start?: number | null, end?: number | null }> | null, tuesday?: Array<{ __typename?: 'TimeInterval', start?: number | null, end?: number | null }> | null, wednesday?: Array<{ __typename?: 'TimeInterval', start?: number | null, end?: number | null }> | null, thursday?: Array<{ __typename?: 'TimeInterval', start?: number | null, end?: number | null }> | null, friday?: Array<{ __typename?: 'TimeInterval', start?: number | null, end?: number | null }> | null, saturday?: Array<{ __typename?: 'TimeInterval', start?: number | null, end?: number | null }> | null, sunday?: Array<{ __typename?: 'TimeInterval', start?: number | null, end?: number | null }> | null } | null, adjusted_availability?: Array<{ __typename?: 'Availability', date: number, pms_appt_type_pms_id?: string | null, times: Array<{ __typename?: 'TimeInterval', start?: number | null, end?: number | null }>, repeat?: { __typename?: 'RepeatAvailability', daysOfMonth?: Array<number> | null, daysOfWeek?: Array<DayOfWeek> | null, weekOfMonth?: WeekOfMonth | null, frequency: any, unit: RepeatUnit, end_date?: number | null } | null }> | null, pms_adjusted_availability?: Array<{ __typename?: 'Availability', date: number, pms_appt_type_pms_id?: string | null, times: Array<{ __typename?: 'TimeInterval', start?: number | null, end?: number | null }>, repeat?: { __typename?: 'RepeatAvailability', daysOfMonth?: Array<number> | null, daysOfWeek?: Array<DayOfWeek> | null, weekOfMonth?: WeekOfMonth | null, frequency: any, unit: RepeatUnit, end_date?: number | null } | null }> | null } | null, default_room?: { __typename?: 'Room', id: string, pms_id: string, name: string, display_name?: string | null, description?: string | null, concurrent_patients?: number | null, is_active: boolean, does_contribute_to_fill_rate?: boolean | null, valid_booking_interval_minutes?: Array<number> | null, created_at: number, updated_at: number, clinic?: { __typename?: 'Clinic', pms: PracticeManagementSystem, id: string, name?: string | null, time_zone?: string | null } | null, hours?: { __typename?: 'AvailabilityHours', monday?: Array<{ __typename?: 'TimeInterval', start?: number | null, end?: number | null }> | null, tuesday?: Array<{ __typename?: 'TimeInterval', start?: number | null, end?: number | null }> | null, wednesday?: Array<{ __typename?: 'TimeInterval', start?: number | null, end?: number | null }> | null, thursday?: Array<{ __typename?: 'TimeInterval', start?: number | null, end?: number | null }> | null, friday?: Array<{ __typename?: 'TimeInterval', start?: number | null, end?: number | null }> | null, saturday?: Array<{ __typename?: 'TimeInterval', start?: number | null, end?: number | null }> | null, sunday?: Array<{ __typename?: 'TimeInterval', start?: number | null, end?: number | null }> | null } | null, adjusted_availability?: Array<{ __typename?: 'Availability', date: number, pms_appt_type_pms_id?: string | null, times: Array<{ __typename?: 'TimeInterval', start?: number | null, end?: number | null }>, repeat?: { __typename?: 'RepeatAvailability', daysOfMonth?: Array<number> | null, daysOfWeek?: Array<DayOfWeek> | null, weekOfMonth?: WeekOfMonth | null, frequency: any, unit: RepeatUnit, end_date?: number | null } | null }> | null, pms_adjusted_availability?: Array<{ __typename?: 'Availability', date: number, pms_appt_type_pms_id?: string | null, times: Array<{ __typename?: 'TimeInterval', start?: number | null, end?: number | null }>, repeat?: { __typename?: 'RepeatAvailability', daysOfMonth?: Array<number> | null, daysOfWeek?: Array<DayOfWeek> | null, weekOfMonth?: WeekOfMonth | null, frequency: any, unit: RepeatUnit, end_date?: number | null } | null }> | null } | null, availability?: { __typename?: 'AvailabilityHours', monday?: Array<{ __typename?: 'TimeInterval', start?: number | null, end?: number | null }> | null, tuesday?: Array<{ __typename?: 'TimeInterval', start?: number | null, end?: number | null }> | null, wednesday?: Array<{ __typename?: 'TimeInterval', start?: number | null, end?: number | null }> | null, thursday?: Array<{ __typename?: 'TimeInterval', start?: number | null, end?: number | null }> | null, friday?: Array<{ __typename?: 'TimeInterval', start?: number | null, end?: number | null }> | null, saturday?: Array<{ __typename?: 'TimeInterval', start?: number | null, end?: number | null }> | null, sunday?: Array<{ __typename?: 'TimeInterval', start?: number | null, end?: number | null }> | null } | null, drop_off_hours?: { __typename?: 'AvailabilityHours', monday?: Array<{ __typename?: 'TimeInterval', start?: number | null, end?: number | null }> | null, tuesday?: Array<{ __typename?: 'TimeInterval', start?: number | null, end?: number | null }> | null, wednesday?: Array<{ __typename?: 'TimeInterval', start?: number | null, end?: number | null }> | null, thursday?: Array<{ __typename?: 'TimeInterval', start?: number | null, end?: number | null }> | null, friday?: Array<{ __typename?: 'TimeInterval', start?: number | null, end?: number | null }> | null, saturday?: Array<{ __typename?: 'TimeInterval', start?: number | null, end?: number | null }> | null, sunday?: Array<{ __typename?: 'TimeInterval', start?: number | null, end?: number | null }> | null } | null, pre_confirmation_checklist?: Array<{ __typename?: 'ServicePreConfirmationItem', title: string, description?: string | null, required?: boolean | null }> | null } }> | null, clinic?: { __typename?: 'Clinic', id: string, name?: string | null, slug?: string | null } | null, organization?: { __typename?: 'Organization', id: string, name: string, slug?: string | null } | null, clinic_group?: { __typename?: 'ClinicGroup', id: string, name: string, slug: string, clinic_group_clinics: Array<{ __typename?: 'ClinicGroupClinic', id: string, created_at: number, clinic: { __typename?: 'Clinic', id: string, name?: string | null, slug?: string | null, avatar_url?: string | null, time_zone?: string | null, is_archived: boolean, address?: { __typename?: 'Address', street_a?: string | null, street_b?: string | null, city?: string | null, state?: string | null, zip?: string | null, country?: string | null } | null, pms_db?: { __typename?: 'PmsDb', id: string } | null } }> } | null, campaign?: { __typename?: 'Campaign', id: string, name: string, color?: string | null, description?: string | null } | null, widget_styles?: { __typename?: 'WidgetStyles', header_color?: string | null, header_text_color?: string | null, footer_color?: string | null, footer_text_color?: string | null, floating_margin_bottom?: number | null, floating_margin_right?: number | null, include_service_categories_with_custom_order?: boolean | null, heading_color?: string | null, heading_font?: WidgetHeadingFont | null, background_color?: string | null, card_color?: string | null, button_color?: string | null, button_text_color?: string | null, text_color?: string | null, reviews_name_color?: string | null, reviews_stars_color?: string | null, reviews_date_color?: string | null, reviews_text_color?: string | null, reviews_arrow_background?: string | null, reviews_arrow_color?: string | null, reviews_title_text?: string | null, clinic_order?: Array<{ __typename?: 'ClinicOrder', clinic_id: string, order: number }> | null, service_order?: Array<{ __typename?: 'ServiceOrder', service_id: string, order: number }> | null, clinic_image_map?: Array<{ __typename?: 'ClinicImageMap', clinic_id: string, image_url: string }> | null } | null, featured_reviews?: Array<{ __typename?: 'FeaturedReview', order: number, review: { __typename?: 'Review', id: string, description?: string | null, overall_rating: number, is_anonymous?: boolean | null, review_submitted_at?: number | null, review_source: ReviewSource, external_id?: string | null, external_author_name?: string | null, external_author_image?: string | null, external_rating?: number | null, external_text?: string | null, external_timestamp?: number | null, external_review_url?: string | null, external_owner_response?: string | null, external_owner_response_timestamp?: number | null, created_at: number, updated_at: number, client?: { __typename?: 'Client', id: string, first_name?: string | null, last_name?: string | null, email?: string | null, phone?: string | null, address?: { __typename?: 'Address', street_a?: string | null, street_b?: string | null, city?: string | null, state?: string | null, zip?: string | null, country?: string | null } | null } | null, appointment?: { __typename?: 'Appointment', id: string } | null, clinic: { __typename?: 'Clinic', id: string, name?: string | null, address?: { __typename?: 'Address', street_a?: string | null, street_b?: string | null, city?: string | null, state?: string | null, zip?: string | null, country?: string | null } | null, settings?: { __typename?: 'ClinicSettings', review_google_id?: string | null, review_facebook_id?: string | null } | null } } }> | null } };

export type GetWidgetsByClinicQueryVariables = Exact<{
  clinicId: Scalars['ID']['input'];
}>;


export type GetWidgetsByClinicQuery = { __typename?: 'Query', getWidgetsByClinic: Array<{ __typename?: 'Widget', id: string, widget_name: string, type: WidgetType, trigger_type: WidgetTriggerType, button_color?: string | null, button_text?: string | null, text_color?: string | null, is_external: boolean, is_active: boolean, is_archived: boolean, is_default_portal: boolean, enabled_chat_buttons?: Array<WidgetMenuButtonType> | null, average_chat_response_time?: string | null, source?: string | null, created_at: number, updated_at: number, clinic?: { __typename?: 'Clinic', id: string, name?: string | null, slug?: string | null } | null, organization?: { __typename?: 'Organization', id: string, name: string, slug?: string | null } | null, clinic_group?: { __typename?: 'ClinicGroup', id: string, name: string, slug: string, clinic_group_clinics: Array<{ __typename?: 'ClinicGroupClinic', id: string, created_at: number, clinic: { __typename?: 'Clinic', id: string, name?: string | null, slug?: string | null, avatar_url?: string | null, time_zone?: string | null, is_archived: boolean, address?: { __typename?: 'Address', street_a?: string | null, street_b?: string | null, city?: string | null, state?: string | null, zip?: string | null, country?: string | null } | null, pms_db?: { __typename?: 'PmsDb', id: string } | null } }> } | null, campaign?: { __typename?: 'Campaign', id: string, name: string, color?: string | null, description?: string | null } | null, widget_styles?: { __typename?: 'WidgetStyles', header_color?: string | null, header_text_color?: string | null, footer_color?: string | null, footer_text_color?: string | null, floating_margin_bottom?: number | null, floating_margin_right?: number | null, include_service_categories_with_custom_order?: boolean | null, heading_color?: string | null, heading_font?: WidgetHeadingFont | null, background_color?: string | null, card_color?: string | null, button_color?: string | null, button_text_color?: string | null, text_color?: string | null, reviews_name_color?: string | null, reviews_stars_color?: string | null, reviews_date_color?: string | null, reviews_text_color?: string | null, reviews_arrow_background?: string | null, reviews_arrow_color?: string | null, reviews_title_text?: string | null, clinic_order?: Array<{ __typename?: 'ClinicOrder', clinic_id: string, order: number }> | null, service_order?: Array<{ __typename?: 'ServiceOrder', service_id: string, order: number }> | null, clinic_image_map?: Array<{ __typename?: 'ClinicImageMap', clinic_id: string, image_url: string }> | null } | null, featured_reviews?: Array<{ __typename?: 'FeaturedReview', order: number, review: { __typename?: 'Review', id: string, description?: string | null, overall_rating: number, is_anonymous?: boolean | null, review_submitted_at?: number | null, review_source: ReviewSource, external_id?: string | null, external_author_name?: string | null, external_author_image?: string | null, external_rating?: number | null, external_text?: string | null, external_timestamp?: number | null, external_review_url?: string | null, external_owner_response?: string | null, external_owner_response_timestamp?: number | null, created_at: number, updated_at: number, client?: { __typename?: 'Client', id: string, first_name?: string | null, last_name?: string | null, email?: string | null, phone?: string | null, address?: { __typename?: 'Address', street_a?: string | null, street_b?: string | null, city?: string | null, state?: string | null, zip?: string | null, country?: string | null } | null } | null, appointment?: { __typename?: 'Appointment', id: string } | null, clinic: { __typename?: 'Clinic', id: string, name?: string | null, address?: { __typename?: 'Address', street_a?: string | null, street_b?: string | null, city?: string | null, state?: string | null, zip?: string | null, country?: string | null } | null, settings?: { __typename?: 'ClinicSettings', review_google_id?: string | null, review_facebook_id?: string | null } | null } } }> | null }> };

export type GetWidgetsByOrganizationQueryVariables = Exact<{
  organizationId: Scalars['ID']['input'];
}>;


export type GetWidgetsByOrganizationQuery = { __typename?: 'Query', getWidgetsByOrganization?: Array<{ __typename?: 'Widget', id: string, widget_name: string, type: WidgetType, trigger_type: WidgetTriggerType, button_color?: string | null, button_text?: string | null, text_color?: string | null, is_external: boolean, is_active: boolean, is_archived: boolean, is_default_portal: boolean, enabled_chat_buttons?: Array<WidgetMenuButtonType> | null, average_chat_response_time?: string | null, source?: string | null, created_at: number, updated_at: number, clinic?: { __typename?: 'Clinic', id: string, name?: string | null, slug?: string | null } | null, organization?: { __typename?: 'Organization', id: string, name: string, slug?: string | null } | null, clinic_group?: { __typename?: 'ClinicGroup', id: string, name: string, slug: string, clinic_group_clinics: Array<{ __typename?: 'ClinicGroupClinic', id: string, created_at: number, clinic: { __typename?: 'Clinic', id: string, name?: string | null, slug?: string | null, avatar_url?: string | null, time_zone?: string | null, is_archived: boolean, address?: { __typename?: 'Address', street_a?: string | null, street_b?: string | null, city?: string | null, state?: string | null, zip?: string | null, country?: string | null } | null, pms_db?: { __typename?: 'PmsDb', id: string } | null } }> } | null, campaign?: { __typename?: 'Campaign', id: string, name: string, color?: string | null, description?: string | null } | null, widget_styles?: { __typename?: 'WidgetStyles', header_color?: string | null, header_text_color?: string | null, footer_color?: string | null, footer_text_color?: string | null, floating_margin_bottom?: number | null, floating_margin_right?: number | null, include_service_categories_with_custom_order?: boolean | null, heading_color?: string | null, heading_font?: WidgetHeadingFont | null, background_color?: string | null, card_color?: string | null, button_color?: string | null, button_text_color?: string | null, text_color?: string | null, reviews_name_color?: string | null, reviews_stars_color?: string | null, reviews_date_color?: string | null, reviews_text_color?: string | null, reviews_arrow_background?: string | null, reviews_arrow_color?: string | null, reviews_title_text?: string | null, clinic_order?: Array<{ __typename?: 'ClinicOrder', clinic_id: string, order: number }> | null, service_order?: Array<{ __typename?: 'ServiceOrder', service_id: string, order: number }> | null, clinic_image_map?: Array<{ __typename?: 'ClinicImageMap', clinic_id: string, image_url: string }> | null } | null, featured_reviews?: Array<{ __typename?: 'FeaturedReview', order: number, review: { __typename?: 'Review', id: string, description?: string | null, overall_rating: number, is_anonymous?: boolean | null, review_submitted_at?: number | null, review_source: ReviewSource, external_id?: string | null, external_author_name?: string | null, external_author_image?: string | null, external_rating?: number | null, external_text?: string | null, external_timestamp?: number | null, external_review_url?: string | null, external_owner_response?: string | null, external_owner_response_timestamp?: number | null, created_at: number, updated_at: number, client?: { __typename?: 'Client', id: string, first_name?: string | null, last_name?: string | null, email?: string | null, phone?: string | null, address?: { __typename?: 'Address', street_a?: string | null, street_b?: string | null, city?: string | null, state?: string | null, zip?: string | null, country?: string | null } | null } | null, appointment?: { __typename?: 'Appointment', id: string } | null, clinic: { __typename?: 'Clinic', id: string, name?: string | null, address?: { __typename?: 'Address', street_a?: string | null, street_b?: string | null, city?: string | null, state?: string | null, zip?: string | null, country?: string | null } | null, settings?: { __typename?: 'ClinicSettings', review_google_id?: string | null, review_facebook_id?: string | null } | null } } }> | null }> | null };

export type GetWidgetsByClinicGroupQueryVariables = Exact<{
  clinicGroupId: Scalars['ID']['input'];
  includeSubgroups?: InputMaybe<Scalars['Boolean']['input']>;
}>;


export type GetWidgetsByClinicGroupQuery = { __typename?: 'Query', getWidgetsByClinicGroup: Array<{ __typename?: 'Widget', id: string, widget_name: string, type: WidgetType, trigger_type: WidgetTriggerType, button_color?: string | null, button_text?: string | null, text_color?: string | null, is_external: boolean, is_active: boolean, is_archived: boolean, is_default_portal: boolean, enabled_chat_buttons?: Array<WidgetMenuButtonType> | null, average_chat_response_time?: string | null, source?: string | null, created_at: number, updated_at: number, clinic?: { __typename?: 'Clinic', id: string, name?: string | null, slug?: string | null } | null, organization?: { __typename?: 'Organization', id: string, name: string, slug?: string | null } | null, clinic_group?: { __typename?: 'ClinicGroup', id: string, name: string, slug: string, clinic_group_clinics: Array<{ __typename?: 'ClinicGroupClinic', id: string, created_at: number, clinic: { __typename?: 'Clinic', id: string, name?: string | null, slug?: string | null, avatar_url?: string | null, time_zone?: string | null, is_archived: boolean, address?: { __typename?: 'Address', street_a?: string | null, street_b?: string | null, city?: string | null, state?: string | null, zip?: string | null, country?: string | null } | null, pms_db?: { __typename?: 'PmsDb', id: string } | null } }> } | null, campaign?: { __typename?: 'Campaign', id: string, name: string, color?: string | null, description?: string | null } | null, widget_styles?: { __typename?: 'WidgetStyles', header_color?: string | null, header_text_color?: string | null, footer_color?: string | null, footer_text_color?: string | null, floating_margin_bottom?: number | null, floating_margin_right?: number | null, include_service_categories_with_custom_order?: boolean | null, heading_color?: string | null, heading_font?: WidgetHeadingFont | null, background_color?: string | null, card_color?: string | null, button_color?: string | null, button_text_color?: string | null, text_color?: string | null, reviews_name_color?: string | null, reviews_stars_color?: string | null, reviews_date_color?: string | null, reviews_text_color?: string | null, reviews_arrow_background?: string | null, reviews_arrow_color?: string | null, reviews_title_text?: string | null, clinic_order?: Array<{ __typename?: 'ClinicOrder', clinic_id: string, order: number }> | null, service_order?: Array<{ __typename?: 'ServiceOrder', service_id: string, order: number }> | null, clinic_image_map?: Array<{ __typename?: 'ClinicImageMap', clinic_id: string, image_url: string }> | null } | null, featured_reviews?: Array<{ __typename?: 'FeaturedReview', order: number, review: { __typename?: 'Review', id: string, description?: string | null, overall_rating: number, is_anonymous?: boolean | null, review_submitted_at?: number | null, review_source: ReviewSource, external_id?: string | null, external_author_name?: string | null, external_author_image?: string | null, external_rating?: number | null, external_text?: string | null, external_timestamp?: number | null, external_review_url?: string | null, external_owner_response?: string | null, external_owner_response_timestamp?: number | null, created_at: number, updated_at: number, client?: { __typename?: 'Client', id: string, first_name?: string | null, last_name?: string | null, email?: string | null, phone?: string | null, address?: { __typename?: 'Address', street_a?: string | null, street_b?: string | null, city?: string | null, state?: string | null, zip?: string | null, country?: string | null } | null } | null, appointment?: { __typename?: 'Appointment', id: string } | null, clinic: { __typename?: 'Clinic', id: string, name?: string | null, address?: { __typename?: 'Address', street_a?: string | null, street_b?: string | null, city?: string | null, state?: string | null, zip?: string | null, country?: string | null } | null, settings?: { __typename?: 'ClinicSettings', review_google_id?: string | null, review_facebook_id?: string | null } | null } } }> | null }> };

export type GetAppointmentCountByWidgetSourceQueryVariables = Exact<{
  clinicId: Scalars['ID']['input'];
  widgetSource: Scalars['String']['input'];
}>;


export type GetAppointmentCountByWidgetSourceQuery = { __typename?: 'Query', getAppointmentCountByWidgetSource: number };

export type GetAppointmentCountByWidgetIdQueryVariables = Exact<{
  clinicId: Scalars['ID']['input'];
  widgetId: Scalars['String']['input'];
}>;


export type GetAppointmentCountByWidgetIdQuery = { __typename?: 'Query', getAppointmentCountByWidgetId: number };

export type QueryWidgetsQueryVariables = Exact<{
  where?: InputMaybe<Array<QueryInput> | QueryInput>;
  page?: InputMaybe<Scalars['NonNegativeInt']['input']>;
  pageSize?: InputMaybe<Scalars['NonNegativeInt']['input']>;
  orderBy?: InputMaybe<OrderByInput>;
}>;


export type QueryWidgetsQuery = { __typename?: 'Query', queryWidgets: Array<{ __typename?: 'Widget', id: string, widget_name: string, type: WidgetType, trigger_type: WidgetTriggerType, button_color?: string | null, button_text?: string | null, text_color?: string | null, is_external: boolean, is_active: boolean, is_archived: boolean, is_default_portal: boolean, enabled_chat_buttons?: Array<WidgetMenuButtonType> | null, average_chat_response_time?: string | null, source?: string | null, created_at: number, updated_at: number, clinic?: { __typename?: 'Clinic', id: string, name?: string | null, slug?: string | null } | null, organization?: { __typename?: 'Organization', id: string, name: string, slug?: string | null } | null, clinic_group?: { __typename?: 'ClinicGroup', id: string, name: string, slug: string, clinic_group_clinics: Array<{ __typename?: 'ClinicGroupClinic', id: string, created_at: number, clinic: { __typename?: 'Clinic', id: string, name?: string | null, slug?: string | null, avatar_url?: string | null, time_zone?: string | null, is_archived: boolean, address?: { __typename?: 'Address', street_a?: string | null, street_b?: string | null, city?: string | null, state?: string | null, zip?: string | null, country?: string | null } | null, pms_db?: { __typename?: 'PmsDb', id: string } | null } }> } | null, campaign?: { __typename?: 'Campaign', id: string, name: string, color?: string | null, description?: string | null } | null, widget_styles?: { __typename?: 'WidgetStyles', header_color?: string | null, header_text_color?: string | null, footer_color?: string | null, footer_text_color?: string | null, floating_margin_bottom?: number | null, floating_margin_right?: number | null, include_service_categories_with_custom_order?: boolean | null, heading_color?: string | null, heading_font?: WidgetHeadingFont | null, background_color?: string | null, card_color?: string | null, button_color?: string | null, button_text_color?: string | null, text_color?: string | null, reviews_name_color?: string | null, reviews_stars_color?: string | null, reviews_date_color?: string | null, reviews_text_color?: string | null, reviews_arrow_background?: string | null, reviews_arrow_color?: string | null, reviews_title_text?: string | null, clinic_order?: Array<{ __typename?: 'ClinicOrder', clinic_id: string, order: number }> | null, service_order?: Array<{ __typename?: 'ServiceOrder', service_id: string, order: number }> | null, clinic_image_map?: Array<{ __typename?: 'ClinicImageMap', clinic_id: string, image_url: string }> | null } | null, featured_reviews?: Array<{ __typename?: 'FeaturedReview', order: number, review: { __typename?: 'Review', id: string, description?: string | null, overall_rating: number, is_anonymous?: boolean | null, review_submitted_at?: number | null, review_source: ReviewSource, external_id?: string | null, external_author_name?: string | null, external_author_image?: string | null, external_rating?: number | null, external_text?: string | null, external_timestamp?: number | null, external_review_url?: string | null, external_owner_response?: string | null, external_owner_response_timestamp?: number | null, created_at: number, updated_at: number, client?: { __typename?: 'Client', id: string, first_name?: string | null, last_name?: string | null, email?: string | null, phone?: string | null, address?: { __typename?: 'Address', street_a?: string | null, street_b?: string | null, city?: string | null, state?: string | null, zip?: string | null, country?: string | null } | null } | null, appointment?: { __typename?: 'Appointment', id: string } | null, clinic: { __typename?: 'Clinic', id: string, name?: string | null, address?: { __typename?: 'Address', street_a?: string | null, street_b?: string | null, city?: string | null, state?: string | null, zip?: string | null, country?: string | null } | null, settings?: { __typename?: 'ClinicSettings', review_google_id?: string | null, review_facebook_id?: string | null } | null } } }> | null }> };

export type QueryPreviewWidgetsQueryVariables = Exact<{
  where?: InputMaybe<Array<QueryInput> | QueryInput>;
  page?: InputMaybe<Scalars['NonNegativeInt']['input']>;
  pageSize?: InputMaybe<Scalars['NonNegativeInt']['input']>;
  orderBy?: InputMaybe<OrderByInput>;
}>;


export type QueryPreviewWidgetsQuery = { __typename?: 'Query', queryWidgets: Array<{ __typename?: 'Widget', id: string, widget_name: string, type: WidgetType, widget_options?: { __typename?: 'WidgetOptions', should_allow_new_clients?: boolean | null, should_allow_new_patients?: boolean | null, should_allow_returning_clients?: boolean | null, should_allow_returning_patients?: boolean | null, widget_access_start_time?: number | null, widget_access_end_time?: number | null, booking_avail_end?: number | null, scheduling_min_minutes_away?: number | null, scheduling_max_minutes_away?: number | null, enabled: boolean } | null }> };

export type CreateWidgetMutationVariables = Exact<{
  data: CreateWidgetInput;
}>;


export type CreateWidgetMutation = { __typename?: 'Mutation', createWidget: { __typename?: 'Widget', id: string, widget_name: string, type: WidgetType, trigger_type: WidgetTriggerType, button_color?: string | null, button_text?: string | null, text_color?: string | null, is_external: boolean, is_active: boolean, is_archived: boolean, is_default_portal: boolean, enabled_chat_buttons?: Array<WidgetMenuButtonType> | null, average_chat_response_time?: string | null, source?: string | null, created_at: number, updated_at: number, clinic?: { __typename?: 'Clinic', id: string, name?: string | null, slug?: string | null } | null, organization?: { __typename?: 'Organization', id: string, name: string, slug?: string | null } | null, clinic_group?: { __typename?: 'ClinicGroup', id: string, name: string, slug: string, clinic_group_clinics: Array<{ __typename?: 'ClinicGroupClinic', id: string, created_at: number, clinic: { __typename?: 'Clinic', id: string, name?: string | null, slug?: string | null, avatar_url?: string | null, time_zone?: string | null, is_archived: boolean, address?: { __typename?: 'Address', street_a?: string | null, street_b?: string | null, city?: string | null, state?: string | null, zip?: string | null, country?: string | null } | null, pms_db?: { __typename?: 'PmsDb', id: string } | null } }> } | null, campaign?: { __typename?: 'Campaign', id: string, name: string, color?: string | null, description?: string | null } | null, widget_styles?: { __typename?: 'WidgetStyles', header_color?: string | null, header_text_color?: string | null, footer_color?: string | null, footer_text_color?: string | null, floating_margin_bottom?: number | null, floating_margin_right?: number | null, include_service_categories_with_custom_order?: boolean | null, heading_color?: string | null, heading_font?: WidgetHeadingFont | null, background_color?: string | null, card_color?: string | null, button_color?: string | null, button_text_color?: string | null, text_color?: string | null, reviews_name_color?: string | null, reviews_stars_color?: string | null, reviews_date_color?: string | null, reviews_text_color?: string | null, reviews_arrow_background?: string | null, reviews_arrow_color?: string | null, reviews_title_text?: string | null, clinic_order?: Array<{ __typename?: 'ClinicOrder', clinic_id: string, order: number }> | null, service_order?: Array<{ __typename?: 'ServiceOrder', service_id: string, order: number }> | null, clinic_image_map?: Array<{ __typename?: 'ClinicImageMap', clinic_id: string, image_url: string }> | null } | null, featured_reviews?: Array<{ __typename?: 'FeaturedReview', order: number, review: { __typename?: 'Review', id: string, description?: string | null, overall_rating: number, is_anonymous?: boolean | null, review_submitted_at?: number | null, review_source: ReviewSource, external_id?: string | null, external_author_name?: string | null, external_author_image?: string | null, external_rating?: number | null, external_text?: string | null, external_timestamp?: number | null, external_review_url?: string | null, external_owner_response?: string | null, external_owner_response_timestamp?: number | null, created_at: number, updated_at: number, client?: { __typename?: 'Client', id: string, first_name?: string | null, last_name?: string | null, email?: string | null, phone?: string | null, address?: { __typename?: 'Address', street_a?: string | null, street_b?: string | null, city?: string | null, state?: string | null, zip?: string | null, country?: string | null } | null } | null, appointment?: { __typename?: 'Appointment', id: string } | null, clinic: { __typename?: 'Clinic', id: string, name?: string | null, address?: { __typename?: 'Address', street_a?: string | null, street_b?: string | null, city?: string | null, state?: string | null, zip?: string | null, country?: string | null } | null, settings?: { __typename?: 'ClinicSettings', review_google_id?: string | null, review_facebook_id?: string | null } | null } } }> | null } };

export type UpdateWidgetMutationVariables = Exact<{
  id: Scalars['ID']['input'];
  data: UpdateWidgetInput;
}>;


export type UpdateWidgetMutation = { __typename?: 'Mutation', updateWidget: { __typename?: 'Widget', id: string, widget_name: string, type: WidgetType, trigger_type: WidgetTriggerType, button_color?: string | null, button_text?: string | null, text_color?: string | null, is_external: boolean, is_active: boolean, is_archived: boolean, is_default_portal: boolean, enabled_chat_buttons?: Array<WidgetMenuButtonType> | null, average_chat_response_time?: string | null, source?: string | null, created_at: number, updated_at: number, clinic?: { __typename?: 'Clinic', id: string, name?: string | null, slug?: string | null } | null, organization?: { __typename?: 'Organization', id: string, name: string, slug?: string | null } | null, clinic_group?: { __typename?: 'ClinicGroup', id: string, name: string, slug: string, clinic_group_clinics: Array<{ __typename?: 'ClinicGroupClinic', id: string, created_at: number, clinic: { __typename?: 'Clinic', id: string, name?: string | null, slug?: string | null, avatar_url?: string | null, time_zone?: string | null, is_archived: boolean, address?: { __typename?: 'Address', street_a?: string | null, street_b?: string | null, city?: string | null, state?: string | null, zip?: string | null, country?: string | null } | null, pms_db?: { __typename?: 'PmsDb', id: string } | null } }> } | null, campaign?: { __typename?: 'Campaign', id: string, name: string, color?: string | null, description?: string | null } | null, widget_styles?: { __typename?: 'WidgetStyles', header_color?: string | null, header_text_color?: string | null, footer_color?: string | null, footer_text_color?: string | null, floating_margin_bottom?: number | null, floating_margin_right?: number | null, include_service_categories_with_custom_order?: boolean | null, heading_color?: string | null, heading_font?: WidgetHeadingFont | null, background_color?: string | null, card_color?: string | null, button_color?: string | null, button_text_color?: string | null, text_color?: string | null, reviews_name_color?: string | null, reviews_stars_color?: string | null, reviews_date_color?: string | null, reviews_text_color?: string | null, reviews_arrow_background?: string | null, reviews_arrow_color?: string | null, reviews_title_text?: string | null, clinic_order?: Array<{ __typename?: 'ClinicOrder', clinic_id: string, order: number }> | null, service_order?: Array<{ __typename?: 'ServiceOrder', service_id: string, order: number }> | null, clinic_image_map?: Array<{ __typename?: 'ClinicImageMap', clinic_id: string, image_url: string }> | null } | null, featured_reviews?: Array<{ __typename?: 'FeaturedReview', order: number, review: { __typename?: 'Review', id: string, description?: string | null, overall_rating: number, is_anonymous?: boolean | null, review_submitted_at?: number | null, review_source: ReviewSource, external_id?: string | null, external_author_name?: string | null, external_author_image?: string | null, external_rating?: number | null, external_text?: string | null, external_timestamp?: number | null, external_review_url?: string | null, external_owner_response?: string | null, external_owner_response_timestamp?: number | null, created_at: number, updated_at: number, client?: { __typename?: 'Client', id: string, first_name?: string | null, last_name?: string | null, email?: string | null, phone?: string | null, address?: { __typename?: 'Address', street_a?: string | null, street_b?: string | null, city?: string | null, state?: string | null, zip?: string | null, country?: string | null } | null } | null, appointment?: { __typename?: 'Appointment', id: string } | null, clinic: { __typename?: 'Clinic', id: string, name?: string | null, address?: { __typename?: 'Address', street_a?: string | null, street_b?: string | null, city?: string | null, state?: string | null, zip?: string | null, country?: string | null } | null, settings?: { __typename?: 'ClinicSettings', review_google_id?: string | null, review_facebook_id?: string | null } | null } } }> | null } };

export type DeleteWidgetMutationVariables = Exact<{
  id: Scalars['ID']['input'];
}>;


export type DeleteWidgetMutation = { __typename?: 'Mutation', deleteWidget?: any | null };

export const UserBasicInfoFragmentDoc = gql`
    fragment UserBasicInfo on User {
  id
  avatar_url
  first_name
  last_name
}
    `;
export const ActionItemBaseFieldsFragmentDoc = gql`
    fragment ActionItemBaseFields on ActionItem {
  id
  type
  status
  description
  assignee {
    ...UserBasicInfo
  }
  clinic {
    id
  }
  created_at
  updated_at
}
    ${UserBasicInfoFragmentDoc}`;
export const ClientInfoFieldsFragmentDoc = gql`
    fragment ClientInfoFields on ClientInfo {
  first_name
  last_name
  email
  phone
}
    `;
export const PatientInfoFieldsFragmentDoc = gql`
    fragment PatientInfoFields on PatientInfo {
  patient_name
  patient_breed
  patient_clinic_species
  patient_clinic_breed
}
    `;
export const PendingAppointmentPreviewFieldsFragmentDoc = gql`
    fragment PendingAppointmentPreviewFields on Appointment {
  id
  pms_id
  pms
  clinic {
    id
    name
    slug
    address {
      country
    }
    pms_db {
      id
    }
  }
  client {
    id
    first_name
    last_name
    phone
    email
    is_active
    address {
      street_a
      street_b
      city
      state
      zip
      country
    }
  }
  client_pms_id
  clinician {
    id
    name
    display_name
    avatar_url
    initials
  }
  is_new_client
  room {
    id
    name
  }
  start_time
  drop_off_time
  minutes
  service {
    id
    name
    color
  }
  patient {
    id
    name
    breed
    avatar_url
    birthday
    weight
    gender
    fixed_status
    is_active
    is_deceased
    clinic_species {
      id
      species
      description
    }
    clinic_breed {
      id
      description
    }
  }
  is_new_patient
  is_clinician_auto_assigned
  patient_pms_id
  referring_clinic_name
  client_notes
  clinic_notes
  service_name
  clinic_appt_status {
    id
    description
    status
  }
  status
  is_time_block
  is_confirmed
  origin
  reason_for_cancellation
  client_reason_for_cancellation
  new_client_name
  new_client_phone
  new_patient_name
  new_patient_species
  client_info {
    ...ClientInfoFields
  }
  patient_info {
    ...PatientInfoFields
  }
  confirmed_at
  widget_source
  from_widget
  is_deleted
  created_at
  updated_at
  pms_created_at
}
    ${ClientInfoFieldsFragmentDoc}
${PatientInfoFieldsFragmentDoc}`;
export const ActionItemRescheduleFieldsFragmentDoc = gql`
    fragment ActionItemRescheduleFields on Reschedule {
  id
  appointment {
    ...PendingAppointmentPreviewFields
  }
  requested_clinician {
    id
    name
  }
  original_clinician {
    id
    name
  }
  requested_start_time
  original_start_time
  clinic_notes
  client_notes
  reason_for_denial
  status
  initiated_by
  confirmed_at
  created_at
  updated_at
}
    ${PendingAppointmentPreviewFieldsFragmentDoc}`;
export const ChatPreviewFieldsFragmentDoc = gql`
    fragment ChatPreviewFields on Chat {
  id
  title
  clinic {
    id
    pms
    name
  }
  client {
    id
    first_name
    last_name
    patients {
      id
      name
      pms_id
      is_deceased
      is_active
    }
  }
  assignee {
    ...UserBasicInfo
  }
  clinic_unread_count
  last_message
  last_message_time
  client_last_message
  client_last_message_time
  client_message_count
  clinic_last_message
  clinic_last_message_time
  non_system_last_message
  non_system_last_message_time
  system_last_message
  system_last_message_time
  status
  is_pinned
  chat_status {
    id
    name
    color
  }
}
    ${UserBasicInfoFragmentDoc}`;
export const PatientDisplayFieldsFragmentDoc = gql`
    fragment PatientDisplayFields on Patient {
  id
  name
  owner {
    first_name
    last_name
  }
  clinic_species {
    id
    species
    description
    weight_key
  }
  clinic_breed {
    id
    description
  }
  is_active
  is_deceased
  birthday
  weight
  avatar_url
  gender
}
    `;
export const FormPageFieldsFragmentDoc = gql`
    fragment FormPageFields on FormPage {
  id
  title
  description
  order
}
    `;
export const FormElementFieldsFragmentDoc = gql`
    fragment FormElementFields on FormElement {
  id
  type
  content
  name
  column_order
  row_order
  page_id
  options
  is_required
  value
  attachments {
    id
    filename
    mime_type
    size_bytes
    thumbnail_url
    url
  }
  field_updates {
    field
    boolean_value
    option
  }
}
    `;
export const ClientFormFieldsFragmentDoc = gql`
    fragment ClientFormFields on ClientForm {
  id
  client {
    id
    first_name
    last_name
    phone
    email
    address {
      street_a
      city
      state
      zip
      country
    }
  }
  patient {
    ...PatientDisplayFields
  }
  form {
    id
    name
    form_type
    is_writeback_enabled
    form_file_naming_template
  }
  form_data {
    pages {
      ...FormPageFields
    }
    fields {
      ...FormElementFields
    }
  }
  appointment {
    start_time
    drop_off_time
    clinic {
      name
      slug
      phone
      email
      address {
        street_a
        city
        state
        zip
        country
      }
    }
    clinician {
      name
      display_name
    }
    service {
      name
    }
  }
  client_completed_at
  clinic_verified_at
  is_archived
  pms_id
  created_at
  updated_at
}
    ${PatientDisplayFieldsFragmentDoc}
${FormPageFieldsFragmentDoc}
${FormElementFieldsFragmentDoc}`;
export const ClientSettingsFieldsFragmentDoc = gql`
    fragment ClientSettingsFields on ClientSettings {
  clinic_chckup_notifications_enabled
  clinic_chckup_sms_enabled
  clinic_chckup_email_enabled
  client_chckup_notifications_enabled
  client_chckup_sms_enabled
  client_chckup_email_enabled
  is_unsubscribed_from_marketing
  is_unsubscribed_from_marketing_sms
  is_unsubscribed_from_marketing_email
}
    `;
export const ClientPreviewFieldsFragmentDoc = gql`
    fragment ClientPreviewFields on Client {
  id
  first_name
  last_name
  secondary_first_name
  secondary_last_name
  phone
  email
  pms_id
  last_appointment {
    clinician {
      name
      display_name
    }
  }
  is_active
  is_unsubscribed
  address {
    street_a
    street_b
    city
    state
    zip
    country
  }
  clinic {
    id
  }
  user {
    avatar_url
  }
  patients {
    id
    name
    gender
    clinic_species {
      id
      species
    }
    clinic_breed {
      id
      description
    }
    pms_id
    last_appointment {
      clinician {
        name
        display_name
      }
    }
    is_deceased
    is_active
  }
  settings {
    ...ClientSettingsFields
  }
  sms_enabled
  email_enabled
  balance
  last_appt_time
  created_at
  updated_at
}
    ${ClientSettingsFieldsFragmentDoc}`;
export const PatientPreviewFieldsFragmentDoc = gql`
    fragment PatientPreviewFields on Patient {
  id
  pms_id
  name
  breed
  is_active
  is_deceased
  avatar_url
  gender
  fixed_status
  avatar_url
  birthday
  weight
  owner {
    id
    first_name
    last_name
    secondary_first_name
    secondary_last_name
    phone
    email
  }
  clinic_species {
    id
    species
    description
    weight_key
  }
  clinic_breed {
    id
    description
  }
}
    `;
export const PrescriptionRefillRequestFieldsFragmentDoc = gql`
    fragment PrescriptionRefillRequestFields on PrescriptionRefillRequest {
  id
  clinic {
    id
  }
  client {
    ...ClientPreviewFields
  }
  patient {
    ...PatientPreviewFields
  }
  prescription {
    id
    name
    product_name
    quantity
    refill_count
    refill_limit
    product {
      id
      name
      price
      chckvet_price
      additional_fees {
        name
        amount
      }
      unit
      volume
    }
  }
  appointment {
    id
    start_time
    status
  }
  pickup_time
  stripe_payment_intent_id
  amount
  status
  type
  notes
  denial_reason
  approved_at
  denied_at
  created_at
  updated_at
}
    ${ClientPreviewFieldsFragmentDoc}
${PatientPreviewFieldsFragmentDoc}`;
export const PetSelfieFieldsFragmentDoc = gql`
    fragment PetSelfieFields on PetSelfie {
  id
  clinic {
    id
  }
  client {
    ...ClientPreviewFields
  }
  patient {
    ...PatientPreviewFields
  }
  submitted_media_url
  display_media_url
  media_type
  mime_type
  filename
  size_bytes
  thumbnail_url
  pet_name
  nickname
  favorite_activity
  weirdest_thing
  display_caption
  allow_public_share
  public_share_authorized_at
  first_viewed_at
  first_viewed_by
  in_slideshow
  in_portal_carousel
  in_gallery
  is_excluded
  is_archived
  reaction_sent_at
  reaction_message
  created_at
  updated_at
}
    ${ClientPreviewFieldsFragmentDoc}
${PatientPreviewFieldsFragmentDoc}`;
export const CallFieldsFragmentDoc = gql`
    fragment CallFields on Call {
  id
  status
  direction
  is_automated
  caller_name
  caller_phone
  to_phone
  duration
  recording_url
  transcription_full_text
  transcription_summary
  notes
  score
  score_reasoning
  sentiment_customer
  sentiment_agent
  client {
    first_name
    last_name
    phone
  }
  created_at
  updated_at
}
    `;
export const ActionItemFieldsFragmentDoc = gql`
    fragment ActionItemFields on ActionItem {
  ...ActionItemBaseFields
  pending_appointment {
    ...PendingAppointmentPreviewFields
  }
  reschedule {
    ...ActionItemRescheduleFields
  }
  chat {
    ...ChatPreviewFields
  }
  client_form {
    ...ClientFormFields
  }
  prescription_refill_request {
    ...PrescriptionRefillRequestFields
  }
  pet_selfie {
    ...PetSelfieFields
  }
  originating_call {
    ...CallFields
  }
}
    ${ActionItemBaseFieldsFragmentDoc}
${PendingAppointmentPreviewFieldsFragmentDoc}
${ActionItemRescheduleFieldsFragmentDoc}
${ChatPreviewFieldsFragmentDoc}
${ClientFormFieldsFragmentDoc}
${PrescriptionRefillRequestFieldsFragmentDoc}
${PetSelfieFieldsFragmentDoc}
${CallFieldsFragmentDoc}`;
export const AppointmentWithActionItemsFieldsFragmentDoc = gql`
    fragment AppointmentWithActionItemsFields on Appointment {
  action_items {
    ...ActionItemBaseFields
    pending_appointment {
      ...PendingAppointmentPreviewFields
    }
  }
}
    ${ActionItemBaseFieldsFragmentDoc}
${PendingAppointmentPreviewFieldsFragmentDoc}`;
export const ClientPhoneFieldsFragmentDoc = gql`
    fragment ClientPhoneFields on ClientPhone {
  id
  phone
  country_code
  is_primary
  is_chckup_primary
  is_mobile
  sms_available
  is_unsubscribed
  is_active
  name
}
    `;
export const ClientEmailFieldsFragmentDoc = gql`
    fragment ClientEmailFields on ClientEmail {
  id
  email
  is_primary
}
    `;
export const ClinicSpeciesFieldsFragmentDoc = gql`
    fragment ClinicSpeciesFields on ClinicSpecies {
  id
  pms_id
  description
  is_primary
  species
  weight_key
  created_at
  updated_at
}
    `;
export const PatientVaccinationRecordFieldsFragmentDoc = gql`
    fragment PatientVaccinationRecordFields on PatientVaccinationRecord {
  id
  vaccine_name
  manufacturer
  lot_number
  administered_date
  due_date
  rabies_tag
  is_rabies_vaccine
  is_soc
  is_active
  product {
    id
    display_name
    name
  }
}
    `;
export const PatientFieldsFragmentDoc = gql`
    fragment PatientFields on Patient {
  id
  owner {
    id
    first_name
    last_name
    email
    phone
    address {
      country
    }
  }
  clinic_species {
    ...ClinicSpeciesFields
  }
  clinic {
    id
  }
  pms
  pms_id
  name
  breed
  clinic_breed {
    id
    description
  }
  patient_vaccination_records {
    ...PatientVaccinationRecordFields
  }
  avatar_url
  last_appt_time
  last_appointment {
    clinician {
      name
      display_name
    }
  }
  gender
  fixed_status
  weight
  birthday
  is_active
  is_deceased
  pms_created_at
  created_at
  updated_at
}
    ${ClinicSpeciesFieldsFragmentDoc}
${PatientVaccinationRecordFieldsFragmentDoc}`;
export const ClientLoyaltyMemberFieldsFragmentDoc = gql`
    fragment ClientLoyaltyMemberFields on LoyaltyMember {
  id
  available_points
}
    `;
export const ClientFieldsFragmentDoc = gql`
    fragment ClientFields on Client {
  id
  first_name
  last_name
  secondary_first_name
  secondary_last_name
  phone
  client_phones {
    ...ClientPhoneFields
  }
  client_emails {
    ...ClientEmailFields
  }
  email
  clinic {
    id
  }
  patients {
    ...PatientFields
  }
  address {
    street_a
    street_b
    city
    state
    zip
    country
  }
  user {
    avatar_url
  }
  loyalty_members {
    ...ClientLoyaltyMemberFields
  }
  settings {
    ...ClientSettingsFields
  }
  pms
  pms_id
  last_appt_time
  last_appointment {
    clinician {
      name
      display_name
    }
  }
  last_contact_time
  email_enabled
  sms_enabled
  balance
  is_active
  is_unsubscribed
  created_at
  updated_at
}
    ${ClientPhoneFieldsFragmentDoc}
${ClientEmailFieldsFragmentDoc}
${PatientFieldsFragmentDoc}
${ClientLoyaltyMemberFieldsFragmentDoc}
${ClientSettingsFieldsFragmentDoc}`;
export const AvailabilityDayFieldsFragmentDoc = gql`
    fragment AvailabilityDayFields on AvailabilityHours {
  monday {
    start
    end
  }
  tuesday {
    start
    end
  }
  wednesday {
    start
    end
  }
  thursday {
    start
    end
  }
  friday {
    start
    end
  }
  saturday {
    start
    end
  }
  sunday {
    start
    end
  }
}
    `;
export const AdjustedAvailabilityFieldsFragmentDoc = gql`
    fragment AdjustedAvailabilityFields on Availability {
  date
  times {
    start
    end
  }
  repeat {
    daysOfMonth
    daysOfWeek
    weekOfMonth
    frequency
    unit
    end_date
  }
  pms_appt_type_pms_id
}
    `;
export const ClinicianFieldsFragmentDoc = gql`
    fragment ClinicianFields on Clinician {
  id
  name
  display_name
  clinic {
    id
    name
  }
  pms_db {
    id
  }
  bio
  avatar_url
  initials
  hours {
    ...AvailabilityDayFields
  }
  adjusted_availability {
    ...AdjustedAvailabilityFields
  }
  pms_adjusted_availability {
    ...AdjustedAvailabilityFields
  }
  excluded_species
  excluded_service_ids
  authority_level
  type
  is_active
  is_assignable_in_pms
  does_contribute_to_fill_rate
  pms_id
  location
  pms_is_active
  valid_booking_interval_minutes
  created_at
  updated_at
}
    ${AvailabilityDayFieldsFragmentDoc}
${AdjustedAvailabilityFieldsFragmentDoc}`;
export const ClinicBasicInfoFieldsFragmentDoc = gql`
    fragment ClinicBasicInfoFields on Clinic {
  id
  name
  time_zone
}
    `;
export const RoomFieldsFragmentDoc = gql`
    fragment RoomFields on Room {
  id
  clinic {
    ...ClinicBasicInfoFields
    pms
  }
  pms_id
  name
  display_name
  description
  concurrent_patients
  is_active
  does_contribute_to_fill_rate
  hours {
    ...AvailabilityDayFields
  }
  adjusted_availability {
    ...AdjustedAvailabilityFields
  }
  pms_adjusted_availability {
    ...AdjustedAvailabilityFields
  }
  valid_booking_interval_minutes
  created_at
  updated_at
}
    ${ClinicBasicInfoFieldsFragmentDoc}
${AvailabilityDayFieldsFragmentDoc}
${AdjustedAvailabilityFieldsFragmentDoc}`;
export const AppointmentFieldsFragmentDoc = gql`
    fragment AppointmentFields on Appointment {
  id
  clinic {
    id
    name
    slug
    pms_db {
      id
    }
    address {
      country
    }
  }
  pms
  client {
    ...ClientFields
  }
  client_pms_id
  clinician {
    ...ClinicianFields
  }
  is_new_client
  room {
    ...RoomFields
  }
  start_time
  drop_off_time
  minutes
  service {
    id
    name
    color
  }
  patient {
    ...PatientFields
  }
  is_new_patient
  is_clinician_auto_assigned
  patient_pms_id
  referring_clinic_name
  client_notes
  clinic_notes
  service_name
  clinic_appt_status {
    id
    description
    status
  }
  status
  is_time_block
  is_confirmed
  origin
  reason_for_cancellation
  client_reason_for_cancellation
  new_client_name
  new_client_phone
  new_patient_name
  new_patient_species
  client_info {
    ...ClientInfoFields
  }
  patient_info {
    ...PatientInfoFields
  }
  clients_forms {
    ...ClientFormFields
  }
  confirmed_at
  widget_source
  from_widget
  widget {
    id
    widget_name
  }
  is_deleted
  created_at
  updated_at
  pms_created_at
}
    ${ClientFieldsFragmentDoc}
${ClinicianFieldsFragmentDoc}
${RoomFieldsFragmentDoc}
${PatientFieldsFragmentDoc}
${ClientInfoFieldsFragmentDoc}
${PatientInfoFieldsFragmentDoc}
${ClientFormFieldsFragmentDoc}`;
export const RescheduleFieldsFragmentDoc = gql`
    fragment RescheduleFields on Reschedule {
  id
  appointment {
    ...AppointmentFields
  }
  requested_clinician {
    id
    name
  }
  original_clinician {
    id
    name
  }
  requested_start_time
  original_start_time
  clinic_notes
  client_notes
  reason_for_denial
  status
  initiated_by
  confirmed_at
  created_at
  updated_at
}
    ${AppointmentFieldsFragmentDoc}`;
export const RescheduleWithActionItemsFieldsFragmentDoc = gql`
    fragment RescheduleWithActionItemsFields on Reschedule {
  action_items {
    ...ActionItemBaseFields
    reschedule {
      ...RescheduleFields
    }
  }
}
    ${ActionItemBaseFieldsFragmentDoc}
${RescheduleFieldsFragmentDoc}`;
export const AiVoiceOptionFieldsFragmentDoc = gql`
    fragment AiVoiceOptionFields on AiVoiceOption {
  voice_id
  voice_name
  voice_gender
  voice_accent
  voice_age
  voice_preview_url
  avatar_url
}
    `;
export const AiAgentPromptFieldsFragmentDoc = gql`
    fragment AiAgentPromptFields on AiAgentPrompt {
  clinic_id
  agent_type
  playbook
  is_default_playbook
  default_playbook
  playbook_max_chars
  general_prompt
  is_legacy_prompt
  available_dynamic_variables
}
    `;
export const AiImprovementItemFieldsFragmentDoc = gql`
    fragment AiImprovementItemFields on AiImprovementItem {
  id
  clinic_id
  kind
  title
  suggestion
  draft_instruction
  impact
  priority_score
  occurrence_count
  first_seen_at
  last_seen_at
  status
  resolved_at
  recent_evidence {
    call_id
    call_started_at
    evidence
  }
}
    `;
export const AnimalFieldsFragmentDoc = gql`
    fragment AnimalFields on Animal {
  id
  name
  image
  created_at
  updated_at
}
    `;
export const ServiceCategoryFieldsFragmentDoc = gql`
    fragment ServiceCategoryFields on ServiceCategory {
  id
  order
  icon
  title
  description
  requires_confirmation
  confirmation_message
  created_at
  updated_at
}
    `;
export const ServiceServiceCategoryFieldsFragmentDoc = gql`
    fragment ServiceServiceCategoryFields on ServiceServiceCategory {
  service_category {
    ...ServiceCategoryFields
  }
}
    ${ServiceCategoryFieldsFragmentDoc}`;
export const PricingFieldsFragmentDoc = gql`
    fragment PricingFields on ServicePricing {
  price
  currency
  type
  client_type
}
    `;
export const PmsApptTypeFieldsFragmentDoc = gql`
    fragment PmsApptTypeFields on PmsApptType {
  id
  name
  pms_id
  description
  color
  pms_is_active
}
    `;
export const ServicePreConfirmationItemFieldsFragmentDoc = gql`
    fragment ServicePreConfirmationItemFields on ServicePreConfirmationItem {
  title
  description
  required
}
    `;
export const ServiceFieldsFragmentDoc = gql`
    fragment ServiceFields on Service {
  id
  name
  order
  clinic {
    id
    name
  }
  keywords
  service_types
  service_service_categories {
    ...ServiceServiceCategoryFields
  }
  is_active
  allow_new
  color
  description
  pricing {
    ...PricingFields
  }
  pms_appt_type {
    ...PmsApptTypeFields
  }
  required_room {
    ...RoomFields
  }
  default_room {
    ...RoomFields
  }
  duration
  allow_returning
  max_per_day
  max_per_hour
  excluded_species
  availability {
    ...AvailabilityDayFields
  }
  drop_off_hours {
    ...AvailabilityDayFields
  }
  reserved_per_day
  authorized_levels
  scheduling_buffer_minutes
  scheduling_min_minutes_away
  scheduling_max_minutes_away
  minimum_patient_age_in_days
  maximum_patient_age_in_days
  more_info
  more_info_action_required
  pre_confirmation_checklist {
    ...ServicePreConfirmationItemFields
  }
  action_required_acknowledgement_text
  points
  drop_off_time
  pick_up_time
  is_blocking
  is_reschedule_allowed
  is_cancellation_allowed
  is_primary_for_appt_type
  hide_clinician_preference
  use_previous_doctor
  allowed_appt_type_pms_ids
  valid_booking_interval_minutes
  only_use_adj_avail_guides
  exclude_from_portal
  created_at
  updated_at
}
    ${ServiceServiceCategoryFieldsFragmentDoc}
${PricingFieldsFragmentDoc}
${PmsApptTypeFieldsFragmentDoc}
${RoomFieldsFragmentDoc}
${AvailabilityDayFieldsFragmentDoc}
${ServicePreConfirmationItemFieldsFragmentDoc}`;
export const AppointmentPromptFieldsFragmentDoc = gql`
    fragment AppointmentPromptFields on AppointmentPrompt {
  id
  clinic {
    id
    name
  }
  client {
    ...ClientFields
  }
  clinician {
    ...ClinicianFields
  }
  patient {
    ...PatientFields
  }
  service {
    ...ServiceFields
  }
  client_notes
  clinic_notes
  confirmed_at
  minutes
  reason_for_denial
  service_name
  start_time
  type
  created_at
  updated_at
}
    ${ClientFieldsFragmentDoc}
${ClinicianFieldsFragmentDoc}
${PatientFieldsFragmentDoc}
${ServiceFieldsFragmentDoc}`;
export const AppointmentBaseFieldsFragmentDoc = gql`
    fragment AppointmentBaseFields on Appointment {
  id
}
    `;
export const AppointmentSchedulePreviewFieldsFragmentDoc = gql`
    fragment AppointmentSchedulePreviewFields on Appointment {
  id
  service_name
  service {
    id
    color
    name
  }
  clinician {
    id
    name
    display_name
    pms_id
  }
  reason_for_cancellation
  room {
    id
    name
  }
  client {
    id
    first_name
    last_name
    email
    phone
  }
  patient {
    id
    name
    avatar_url
    clinic_breed {
      id
      description
    }
  }
  clinic {
    address {
      country
    }
  }
  start_time
  drop_off_time
  minutes
  client_notes
  status
  is_deleted
  is_time_block
  is_clinician_auto_assigned
  client_pms_id
  patient_pms_id
  is_new_client
  is_new_patient
  new_client_name
  new_client_phone
  new_patient_name
  is_new_patient
  pms_created_at
  clinic_appt_status {
    id
    description
    status
  }
}
    `;
export const PublicAppointmentTimeFieldsFragmentDoc = gql`
    fragment PublicAppointmentTimeFields on PublicAppointmentTime {
  start_time
  minutes
  clinician_id
  room_id
  is_time_block
}
    `;
export const TimeSlotClinicianFieldsFragmentDoc = gql`
    fragment TimeSlotClinicianFields on Clinician {
  id
  name
}
    `;
export const TimeSlotFieldsFragmentDoc = gql`
    fragment TimeSlotFields on OpenSlot {
  start_time
  clinicians {
    ...TimeSlotClinicianFields
  }
}
    ${TimeSlotClinicianFieldsFragmentDoc}`;
export const TimeSlotSchedulingFieldsFragmentDoc = gql`
    fragment TimeSlotSchedulingFields on TimeSlot {
  start_time
  display_time
  selections {
    clinicians {
      ...TimeSlotClinicianFields
    }
    rooms {
      id
      name
    }
    service_id
  }
}
    ${TimeSlotClinicianFieldsFragmentDoc}`;
export const ClinicGroupAppointmentFieldsFragmentDoc = gql`
    fragment ClinicGroupAppointmentFields on Appointment {
  id
  clinic {
    id
    name
  }
  client {
    id
    first_name
    last_name
    email
    phone
    address {
      street_a
      street_b
      city
      state
      zip
    }
  }
  patient {
    id
    name
  }
  service {
    id
    name
  }
  clinician {
    id
    name
    display_name
  }
  room {
    id
    name
  }
  widget {
    id
    widget_name
  }
  start_time
  created_at
  origin
  status
  minutes
  is_new_client
  is_new_patient
  client_notes
  clinic_notes
  clinic_appt_status {
    id
    status
    description
  }
  acquisition_source {
    utm_source
    utm_medium
    utm_campaign
    utm_term
    utm_content
    gclid
    gbraid
    wbraid
    gad_source
    gad_campaignid
    fbclid
    msclkid
    ttclid
    li_fat_id
    twclid
    yclid
    referrer_url
    landing_page_url
    first_touch_at
    last_touch_at
  }
  notif_template
  bulk_message
}
    `;
export const AppointmentCsvExportFieldsFragmentDoc = gql`
    fragment AppointmentCsvExportFields on Appointment {
  id
  clinic {
    id
    name
  }
  client {
    id
    first_name
    last_name
    phone
    email
    address {
      street_a
      street_b
      city
      state
      zip
      country
    }
  }
  patient {
    id
    name
    birthday
    gender
    clinic_species {
      species
    }
    clinic_breed {
      description
    }
  }
  service {
    id
    name
  }
  clinician {
    id
    name
    display_name
  }
  start_time
  status
  created_at
  updated_at
}
    `;
export const BookingFlowFunnelStepFieldsFragmentDoc = gql`
    fragment BookingFlowFunnelStepFields on BookingFlowFunnelStep {
  step
  count
}
    `;
export const WidgetBookingSourceStatsFieldsFragmentDoc = gql`
    fragment WidgetBookingSourceStatsFields on WidgetBookingSourceStats {
  widget {
    id
    widget_name
    type
    is_active
    is_archived
    is_default_portal
    clinic {
      id
      name
    }
    clinic_group {
      id
      name
    }
  }
  sessions_started
  appointments_booked
  conversion_rate
}
    `;
export const ClinicBookingSourceStatsFieldsFragmentDoc = gql`
    fragment ClinicBookingSourceStatsFields on ClinicBookingSourceStats {
  clinic {
    id
    name
  }
  sessions_started
  appointments_booked
  conversion_rate
}
    `;
export const BookingAttributionStatsFieldsFragmentDoc = gql`
    fragment BookingAttributionStatsFields on BookingAttributionStats {
  value
  appointments_booked
  new_client_appointments
}
    `;
export const BreedFieldsFragmentDoc = gql`
    fragment BreedFields on Breed {
  id
  pms_id
  species
  description
}
    `;
export const BreedDisplayFieldsFragmentDoc = gql`
    fragment BreedDisplayFields on Breed {
  id
  species_foreign {
    id
    description
  }
  species
  description
}
    `;
export const CampaignStatsFieldsFragmentDoc = gql`
    fragment CampaignStatsFields on CampaignStats {
  total_revenue
  total_appointments
  total_unique_patients
  total_messages_sent
  total_email_message_opens
  total_link_clicks
  avg_conversion_rate
  avg_interactions_per_message
  total_widget_views
  total_interactions
  active_widgets
  active_bulk_messages
  active_notif_templates
}
    `;
export const CampaignWidgetStatFieldsFragmentDoc = gql`
    fragment CampaignWidgetStatFields on CampaignWidgetStats {
  total_appointments
  total_unique_clients
  total_unique_patients
  direct_invoice_amt_total
  conversion_rate
  avg_booking_value
  total_views
  bounce_rate
  avg_time_to_book
  peak_booking_hour
  most_popular_service
  repeat_booking_rate
}
    `;
export const CampaignNotificationStatFieldsFragmentDoc = gql`
    fragment CampaignNotificationStatFields on CampaignNotificationStats {
  total_recipients
  messages_sent
  delivery_rate
  bounce_rate
  open_rate
  avg_open_time
}
    `;
export const CampaignBulkMessageStatFieldsFragmentDoc = gql`
    fragment CampaignBulkMessageStatFields on CampaignScheduledBulkMessageStats {
  total_recipients
  messages_sent
  delivery_rate
  bounce_rate
  open_rate
  avg_open_time
}
    `;
export const CampaignFieldsFragmentDoc = gql`
    fragment CampaignFields on Campaign {
  id
  name
  description
  start_time
  end_time
  is_active
  is_archived
  clinic {
    id
    name
  }
  clinic_group {
    id
    name
  }
  widgets {
    id
    widget_name
  }
  notification_templates {
    id
    name
  }
  scheduled_bulk_messages {
    id
    name
  }
  featured_stats
  widget_featured_stats
  notification_featured_stats
  scheduled_bulk_message_featured_stats
  created_at
  updated_at
}
    `;
export const ChangeLogFieldsFragmentDoc = gql`
    fragment ChangeLogFields on ChangeLog {
  id
  user {
    id
    first_name
    last_name
  }
  old_values
  new_values
  created_at
}
    `;
export const ChatStatusFieldsFragmentDoc = gql`
    fragment ChatStatusFields on ChatStatusConfig {
  id
  clinic {
    id
  }
  clinic_group {
    id
  }
  name
  color
  sort_order
  is_archived
  created_at
  updated_at
}
    `;
export const AddressFieldsFragmentDoc = gql`
    fragment AddressFields on Address {
  street_a
  street_b
  city
  state
  zip
  country
}
    `;
export const PortalLinkFieldsFragmentDoc = gql`
    fragment PortalLinkFields on PortalLink {
  label
  url
}
    `;
export const ChatClinicFieldsFragmentDoc = gql`
    fragment ChatClinicFields on Clinic {
  id
  name
  slug
  phone
  email
  address {
    ...AddressFields
  }
  website
  avatar_url
  settings {
    id
    primary_color
    portal_links {
      ...PortalLinkFields
    }
  }
  time_zone
  pms
  pms_db {
    id
  }
  tmp_feature_flags
}
    ${AddressFieldsFragmentDoc}
${PortalLinkFieldsFragmentDoc}`;
export const ChatFieldsFragmentDoc = gql`
    fragment ChatFields on Chat {
  id
  title
  clinic {
    ...ChatClinicFields
  }
  client {
    ...ClientPreviewFields
    client_phones {
      ...ClientPhoneFields
    }
    email_enabled
    sms_enabled
  }
  assignee {
    ...UserBasicInfo
  }
  client_last_message
  client_last_read
  client_last_read_count
  client_unread_count
  client_message_count
  client_last_message_time
  clinic_last_message
  clinic_unread_count
  clinic_last_read
  clinic_last_read_count
  clinic_message_count
  clinic_last_message_time
  non_system_last_message
  non_system_last_message_time
  system_message_count
  system_last_message
  system_last_message_time
  message_count
  last_message
  last_message_time
  status
  is_hidden
  is_pinned
  compliance_status
  chat_status {
    id
    name
    color
  }
  created_at
  updated_at
}
    ${ChatClinicFieldsFragmentDoc}
${ClientPreviewFieldsFragmentDoc}
${ClientPhoneFieldsFragmentDoc}
${UserBasicInfoFragmentDoc}`;
export const ChatBasicInfoFieldsFragmentDoc = gql`
    fragment ChatBasicInfoFields on Chat {
  id
  client {
    id
  }
}
    `;
export const CheckInFieldsFragmentDoc = gql`
    fragment CheckInFields on CheckIn {
  id
  user {
    id
    first_name
    last_name
    avatar_url
  }
  clinic {
    id
    name
    avatar_url
  }
  status
  vehicle
  visit_reason
  created_at
  updated_at
}
    `;
export const ClientFormBasicInfoFieldsFragmentDoc = gql`
    fragment ClientFormBasicInfoFields on ClientForm {
  id
  client {
    id
    first_name
    last_name
  }
  patient {
    id
    name
  }
  form {
    id
    name
  }
  client_completed_at
  created_at
}
    `;
export const ClientBasicInfoFieldsFragmentDoc = gql`
    fragment ClientBasicInfoFields on Client {
  id
  first_name
  last_name
  phone
  email
  address {
    ...AddressFields
  }
}
    ${AddressFieldsFragmentDoc}`;
export const ClientNoteFieldsFragmentDoc = gql`
    fragment ClientNoteFields on ClientNote {
  id
  text
  noted_at
  is_active
  created_at
  updated_at
}
    `;
export const ClinicPreviewFieldsFragmentDoc = gql`
    fragment ClinicPreviewFields on Clinic {
  id
  name
  slug
  avatar_url
  is_verified
  is_archived
  description
  pms
  last_sync_times {
    last_full_sync
  }
  clinic_admins {
    id
  }
  organization {
    id
  }
  address {
    street_a
    street_b
    city
    state
    zip
    country
    lat
    lng
  }
  time_zone
}
    `;
export const UserFieldsFragmentDoc = gql`
    fragment UserFields on User {
  id
  first_name
  last_name
  email
  phone
  phone_country
  avatar_url
  role
  enabled_notification_sounds
  notify_email_on
  notify_sound_on
  notify_desktop_on
  must_reset_password
  invitation_status
  invited_at
  created_at
  updated_at
}
    `;
export const ClinicAdminPermissionFieldsFragmentDoc = gql`
    fragment ClinicAdminPermissionFields on ClinicAdminPermission {
  feature
  access_level
}
    `;
export const ClinicAdminFieldsFragmentDoc = gql`
    fragment ClinicAdminFields on ClinicAdmin {
  id
  clinic {
    ...ClinicPreviewFields
  }
  user {
    ...UserFields
  }
  role
  custom_role {
    id
    name
  }
  permissions {
    ...ClinicAdminPermissionFields
  }
  are_email_notifications_enabled
  are_sms_notifications_enabled
  are_desktop_notifications_enabled
  should_hide_daily_huddle_financials
  created_at
  updated_at
}
    ${ClinicPreviewFieldsFragmentDoc}
${UserFieldsFragmentDoc}
${ClinicAdminPermissionFieldsFragmentDoc}`;
export const ClinicBookingCopyFieldsFragmentDoc = gql`
    fragment ClinicBookingCopyFields on ClinicBookingCopy {
  WIDGET_HEADER_TITLE
  SHOW_CLINIC_HEADER_LOGO
  CLINIC_HEADER_LOGO_HEIGHT
  SERVICE_TYPE_SECTION_HEADING
  DEFAULT_WELLNESS_DESCRIPTION
  DEFAULT_SICK_DESCRIPTION
  DEFAULT_OTHER_DESCRIPTION
  RETURNING_PATIENT_QUESTION
  POSITIVE_RETURNING_PATIENT_ANSWER
  NEGATIVE_RETURNING_PATIENT_ANSWER
  RETURNING_CLIENT_QUESTION
  POSITIVE_RETURNING_CLIENT_ANSWER
  NEGATIVE_RETURNING_CLIENT_ANSWER
  CLIENT_INFORMATION_SECTION_TITLE
  PATIENT_INFORMATION_SECTION_TITLE
  RETURNING_CLIENT_PATIENT_TITLE
  RETURNING_CLIENT_PATIENT_DESCRIPTION
  SERVICE_SECTION_TITLE
  PREPAID_SERVICES_LABEL
  STANDARD_SERVICES_LABEL
  DEPOSIT_FEE_NAME
  PREVIOUS_OR_REFERRING_CLINIC_QUESTION
  CONTACT_THE_CLINIC_TEXT
  CONTACT_THE_CLINIC_TEXT_COLOR
  CONTACT_THE_CLINIC_TEXT_SIZE
  SELECT_CLINICIAN_TITLE
  SELECT_CLINICIAN_POSITIVE_ANSWER
  SELECT_CLINICIAN_NEGATIVE_ANSWER
  SELECT_TIME_TITLE
  REVIEW_TITLE
  REVIEW_NOTES_PROMPT
  PAYMENT_INFORMATION_TITLE
  TRIGGER_WORDS_DETECTED_HEADER
  TRIGGER_WORDS_DETECTED_DESCRIPTION
  CONFIRMATION_SCREEN_TITLE
  CONFIRMATION_SCREEN_DESCRIPTION
  NEW_CLIENT_BLOCKED_MESSAGE
  NEW_PATIENT_BLOCKED_MESSAGE
}
    `;
export const ClinicReviewsCopyFieldsFragmentDoc = gql`
    fragment ClinicReviewsCopyFields on ClinicReviewsCopy {
  REVIEW_METHOD_PAGE_TITLE
  REVIEW_METHOD_PAGE_DESCRIPTION
  PRIVATE_REVIEW_BUTTON_HELP_TEXT
  PRIVATE_REVIEW_BUTTON_TEXT
  REVIEW_PAGE_TITLE
  REVIEW_PAGE_SUBTITLE
  REVIEW_SCORE_LABEL
  REVIEW_MESSAGE_LABEL
  REVIEW_SUBMIT_BUTTON_TEXT
}
    `;
export const NotificationTemplatePreviewFieldsFragmentDoc = gql`
    fragment NotificationTemplatePreviewFields on NotificationTemplate {
  id
  name
  is_active
  is_archived
  message_methods
}
    `;
export const CustomerSegmentErrorFlagFieldsFragmentDoc = gql`
    fragment CustomerSegmentErrorFlagFields on CustomerSegmentErrorFlag {
  filter_column
  filter_index
  parameter_index
  message
}
    `;
export const QueryFilterFieldsFragmentDoc = gql`
    fragment QueryFilterFields on QueryFilter {
  column
  filterOp
  value {
    string
    float
    boolean
    stringArray
    floatArray
    millisFromNow
    relativeTime {
      quantity
      unit
      direction
    }
  }
}
    `;
export const SegmentFilterFieldsFragmentDoc = gql`
    fragment SegmentFilterFields on SegmentFilter {
  foreign_table
  group
  parameters {
    ...QueryFilterFields
  }
}
    ${QueryFilterFieldsFragmentDoc}`;
export const CustomerSegmentPreviewFieldsFragmentDoc = gql`
    fragment CustomerSegmentPreviewFields on CustomerSegment {
  id
  name
  trigger_entity
  is_archived
  updated_at
  notification_templates {
    ...NotificationTemplatePreviewFields
  }
  error_flags {
    ...CustomerSegmentErrorFlagFields
  }
  all_inclusions {
    ...SegmentFilterFields
  }
  any_inclusions {
    ...SegmentFilterFields
  }
  any_exclusions {
    ...SegmentFilterFields
  }
  any_other_exclusions {
    ...SegmentFilterFields
  }
  filters {
    filters {
      ...QueryFilterFields
    }
  }
  excluded_filters {
    filters {
      ...QueryFilterFields
    }
  }
}
    ${NotificationTemplatePreviewFieldsFragmentDoc}
${CustomerSegmentErrorFlagFieldsFragmentDoc}
${SegmentFilterFieldsFragmentDoc}
${QueryFilterFieldsFragmentDoc}`;
export const WebhookConfigFieldsFragmentDoc = gql`
    fragment WebhookConfigFields on WebhookConfig {
  id
  name
  url
  events
  secret
  enabled
}
    `;
export const ClinicSettingsFieldsFragmentDoc = gql`
    fragment ClinicSettingsFields on ClinicSettings {
  id
  does_require_verification
  does_use_automatic_reschedule
  reset_status_to_booked_on_reschedule
  is_using_detailed_services
  hide_review_step
  is_using_rooms
  pms_start_time
  pms_end_time
  primary_color
  accent_color
  secondary_color
  new_appt_requested_msg
  new_appt_approved_msg
  new_appt_approved_sms_msg
  new_appt_denied_msg
  schedule_method
  scheduling_buffer_minutes
  base_schedule_duration
  does_require_referral
  appointment_entry_method
  scheduling_min_minutes_away
  scheduling_max_minutes_away
  included_species
  max_patients_per_visit
  should_complete_sync
  server_syncing_only
  confirmation_days_before
  send_confirmations_to
  send_new_appt_email
  send_reviews_to
  max_review_rating_for_notif
  google_review_link
  facebook_review_link
  non_blocking_services
  yesterday_revenue
  this_month_revenue
  hide_clinician_preference
  does_use_rooms_to_schedule
  primary_room_pms_id
  should_default_pims_emails_on
  should_default_pims_sms_on
  should_default_marketing_sms_on
  should_default_marketing_email_on
  does_use_clinicians_to_schedule
  time_slot_minutes
  sync_interval_minutes
  long_sync_interval_hours
  primary_clinician_pms_id
  cancellation_clinician_pms_id
  cancellation_service_pms_id
  allow_first_appt_per_day
  custom_well_description
  custom_sick_description
  custom_other_title
  custom_other_description
  custom_booking_copy {
    ...ClinicBookingCopyFields
  }
  default_trigger_words
  should_use_private_reviews
  notify_clinic_on
  reminder_send_time_minutes
  does_require_new_client_address
  does_require_new_client_birthday
  should_allow_new_clients
  should_allow_new_patients
  should_create_clients
  should_create_patients
  msgs_auto_priority
  booking_match_procedure
  urgency_type
  max_booking_columns
  hide_closed_days_from_scheduling
  should_sync_reminders
  auto_reply_enabled
  auto_reply_message
  auto_reply_hours {
    ...AvailabilityDayFields
  }
  unreplied_message_alert_enabled
  unreplied_message_alert_minutes
  comms_writeback_enabled
  comms_should_daily_writeback
  comms_use_pdf_for_writeback
  comms_writeback_buffer_minutes
  comms_writeback_before_appt_mins
  comms_should_writeback_on_send
  comms_should_writeback_on_receive
  comms_should_writeback_notifs
  comms_should_use_ai_writeback
  form_writeback_enabled
  should_award_loyalty_for_invoices
  invoice_loyalty_points_per_dollar
  app_download_loyalty_points
  referrer_loyalty_points
  referred_loyalty_points
  custom_appointment_notes_template
  custom_new_client_notes_template
  custom_new_patient_notes_template
  max_inactivity_duration
  hide_portal_vaccinations
  hide_portal_reminders
  hide_portal_prescriptions
  hide_portal_weight
  hide_soc_vaccinations
  hide_historic_vaccinations
  should_hide_daily_huddle_financials
  patient_details_tab_order
  portal_links {
    ...PortalLinkFields
  }
  clinic_hours_display
  reschedule_buffer_minutes
  cancellation_buffer_minutes
  require_reason_for_cancellation
  should_automatically_assign_patient
  payment_writeback_enabled
  auto_refund_on_cancel
  status_set_on_payment_completed_pms_id
  max_booking_notes_length
  min_booking_notes_length
  primary_clinic_group_id
  should_suggest_nearby_clinics
  sms_block_list
  exclude_message_wrapper
  should_charge_client_stripe_fees
  chckvet_prescription_fee_split_percentage
  gtm_container_id
  review_google_id
  review_facebook_id
  custom_reviews_copy {
    ...ClinicReviewsCopyFields
  }
  waitlist_customer_segment {
    ...CustomerSegmentPreviewFields
  }
  blocklist_customer_segment {
    ...CustomerSegmentPreviewFields
  }
  referral_customer_segment {
    ...CustomerSegmentPreviewFields
  }
  only_use_adj_avail_guides
  use_basic_timeslots
  valid_booking_interval_minutes
  webhooks {
    ...WebhookConfigFields
  }
  should_disable_online_scheduling
  simple_scheduling_rules_enabled
  times_first_filter_config {
    service
    clinician
    species
    client_status
    patient_status
    patient_gender
    fixed_status
  }
  compliance_statuses
  should_use_instant_prescription_requests
  prescription_pickup_service_id
  default_reminder_service_id
  ai_calls_provider
  ai_calls_phone_number
  ai_calls_voice_id
  ai_calls_agent_id
  ai_agent_style
  ai_agent_custom_instructions
  ai_calls_ambient_sound
  ai_calls_voice_speed
  ai_calls_interruption_sensitivity
  ai_calls_enable_dynamic_voice_speed
  usage_spending_caps
  custom_merge_tags
}
    ${ClinicBookingCopyFieldsFragmentDoc}
${AvailabilityDayFieldsFragmentDoc}
${PortalLinkFieldsFragmentDoc}
${ClinicReviewsCopyFieldsFragmentDoc}
${CustomerSegmentPreviewFieldsFragmentDoc}
${WebhookConfigFieldsFragmentDoc}`;
export const ClinicFeatureFieldsFragmentDoc = gql`
    fragment ClinicFeatureFields on ClinicFeatures {
  scheduling_enabled
  huddle_enabled
  payments_enabled
  messaging_enabled
  reviews_enabled
  loyalty_enabled
  notifs_enabled
  forms_enabled
  help_enabled
  bulk_messaging_enabled
  portal_enabled
  calls_enabled
  teamchat_enabled
  prescriptions_enabled
  medical_history_enabled
  pet_selfies_enabled
}
    `;
export const ClinicFieldsFragmentDoc = gql`
    fragment ClinicFields on Clinic {
  id
  slug
  name
  description
  email
  phone
  send_from_phone
  send_from_email
  reply_to_email
  website
  pms
  pms_connector
  pms_db {
    id
    name
    last_sync_times {
      last_full_sync
      last_sync_appointments
      last_sync_clients
      last_sync_patients
      last_sync_clinicians
      last_sync_services
      last_sync_transactions
      last_sync_invoices
      last_sync_history_items
      last_sync_diagnoses
      last_sync_prescriptions
      last_sync_products
      last_sync_rooms
      last_sync_species
      last_sync_breeds
      last_sync_reminders
      last_sync_reminder_types
      last_sync_vaccination_records
      last_sync_clinic_sexes
      last_sync_appt_statuses
      last_sync_blockoffs
      last_sync_invoice_items
    }
  }
  pms_api_key
  pms_additional_key
  office_emails
  stripe_accounts_enabled
  stripe_account_type
  stripe_customer_id
  clinic_admins {
    ...ClinicAdminFields
  }
  address {
    ...AddressFields
  }
  services {
    id
    name
  }
  settings {
    ...ClinicSettingsFields
  }
  onboarding {
    has_set_hours
    has_synced_pms
  }
  organization {
    id
  }
  features {
    ...ClinicFeatureFields
  }
  avatar_url
  hours {
    ...AvailabilityDayFields
  }
  clinic_hours {
    ...AvailabilityDayFields
  }
  adjusted_availability {
    ...AdjustedAvailabilityFields
  }
  pms_adjusted_availability {
    ...AdjustedAvailabilityFields
  }
  last_sync_times {
    last_full_sync
    last_sync_appointments
    last_sync_clients
    last_sync_patients
    last_sync_clinicians
    last_sync_services
    last_sync_transactions
    last_sync_invoices
    last_sync_history_items
    last_sync_diagnoses
    last_sync_prescriptions
    last_sync_products
    last_sync_rooms
    last_sync_species
    last_sync_breeds
    last_sync_reminders
    last_sync_reminder_types
    last_sync_vaccination_records
    last_sync_clinic_sexes
    last_sync_appt_statuses
    last_sync_blockoffs
    last_sync_invoice_items
  }
  organization {
    id
  }
  pims_settings {
    ezyvet_integration_mode
    entered_by_pms_id
  }
  go_live_date
  time_zone
  is_archived
  location
  tmp_feature_flags
  mute_until
  created_at
  updated_at
}
    ${ClinicAdminFieldsFragmentDoc}
${AddressFieldsFragmentDoc}
${ClinicSettingsFieldsFragmentDoc}
${ClinicFeatureFieldsFragmentDoc}
${AvailabilityDayFieldsFragmentDoc}
${AdjustedAvailabilityFieldsFragmentDoc}`;
export const ClinicAdminFieldsForLoginFragmentDoc = gql`
    fragment ClinicAdminFieldsForLogin on ClinicAdmin {
  id
  clinic {
    ...ClinicFields
  }
}
    ${ClinicFieldsFragmentDoc}`;
export const AppointmentDailyHuddleFieldsFragmentDoc = gql`
    fragment AppointmentDailyHuddleFields on Appointment {
  id
  pms_id
  status
  clinic_appt_status {
    id
    status
    description
  }
  service_name
  service {
    id
    color
    name
  }
  clinician {
    id
    name
    display_name
  }
  room {
    id
    name
  }
  clinic {
    id
    name
    slug
    pms_db {
      id
    }
  }
  client {
    id
    first_name
    last_name
    email
    phone
    is_active
    address {
      street_a
      country
    }
  }
  patient {
    ...PatientPreviewFields
  }
  start_time
  drop_off_time
  minutes
  is_deleted
  is_time_block
  is_new_patient
  is_new_client
  is_confirmed
  new_patient_species
  reason_for_cancellation
  client_reason_for_cancellation
  confirmed_at
  is_clinician_auto_assigned
  client_notes
  clinic_notes
  referring_clinic_name
  widget_source
  from_widget
  widget {
    id
    widget_name
  }
  pms_created_at
}
    ${PatientPreviewFieldsFragmentDoc}`;
export const RevenueByClinicianFieldsFragmentDoc = gql`
    fragment RevenueByClinicianFields on RevenueByClinician {
  clinician {
    id
    name
  }
  revenue
}
    `;
export const YesterdayAnalyticsFieldsFragmentDoc = gql`
    fragment YesterdayAnalyticsFields on YesterdayAnalytics {
  appointments {
    ...AppointmentDailyHuddleFields
  }
  non_forward_scheduled_patients {
    ...PatientFields
  }
  revenue
  revenue_by_clinician {
    ...RevenueByClinicianFields
  }
  new_clients_count
  new_patients_count
  schedule_efficiency
  monthly_revenue_completed
  monthly_appointments_scheduled
  last_month_average_revenue_per_appointment
}
    ${AppointmentDailyHuddleFieldsFragmentDoc}
${PatientFieldsFragmentDoc}
${RevenueByClinicianFieldsFragmentDoc}`;
export const ClientPortalAppFieldsFragmentDoc = gql`
    fragment ClientPortalAppFields on Client {
  has_portal_account
  has_mobile_app
}
    `;
export const AppointmentDailyHuddleUserTrackingFieldsFragmentDoc = gql`
    fragment AppointmentDailyHuddleUserTrackingFields on Appointment {
  client {
    id
    ...ClientPortalAppFields
  }
}
    ${ClientPortalAppFieldsFragmentDoc}`;
export const TodayAnalyticsFieldsFragmentDoc = gql`
    fragment TodayAnalyticsFields on TodayAnalytics {
  appointments {
    ...AppointmentDailyHuddleFields
    ...AppointmentDailyHuddleUserTrackingFields
  }
  unpaid_invoices_total
  unpaid_invoices_count
}
    ${AppointmentDailyHuddleFieldsFragmentDoc}
${AppointmentDailyHuddleUserTrackingFieldsFragmentDoc}`;
export const TomorrowAnalyticsFieldsFragmentDoc = gql`
    fragment TomorrowAnalyticsFields on TomorrowAnalytics {
  appointments {
    ...AppointmentDailyHuddleFields
    ...AppointmentDailyHuddleUserTrackingFields
  }
}
    ${AppointmentDailyHuddleFieldsFragmentDoc}
${AppointmentDailyHuddleUserTrackingFieldsFragmentDoc}`;
export const AnalyticsNumbersFieldsFragmentDoc = gql`
    fragment AnalyticsNumbersFields on AnalyticsNumbers {
  appointments_count
  no_show_count
  revenue
  transactions_count
  revenue_per_appointment
  new_clients_count
  new_patients_count
  new_appointments_count
  schedule_efficiency
  forward_scheduled_patients_count
}
    `;
export const ClinicApptStatusFieldsFragmentDoc = gql`
    fragment ClinicApptStatusFields on ClinicApptStatus {
  id
  clinic {
    ...ClinicBasicInfoFields
  }
  pms_id
  is_primary
  description
  status
  created_at
  updated_at
}
    ${ClinicBasicInfoFieldsFragmentDoc}`;
export const ClinicApptStatusBasicInfoFieldsFragmentDoc = gql`
    fragment ClinicApptStatusBasicInfoFields on ClinicApptStatus {
  id
  description
  is_primary
  status
  created_at
}
    `;
export const CgcClinicFieldsFragmentDoc = gql`
    fragment CGCClinicFields on Clinic {
  id
  name
  slug
  avatar_url
  address {
    ...AddressFields
  }
  time_zone
  is_archived
  pms_db {
    id
  }
}
    ${AddressFieldsFragmentDoc}`;
export const ClinicGroupClinicFieldsFragmentDoc = gql`
    fragment ClinicGroupClinicFields on ClinicGroupClinic {
  id
  clinic {
    ...CGCClinicFields
  }
  created_at
}
    ${CgcClinicFieldsFragmentDoc}`;
export const CguUserFieldsFragmentDoc = gql`
    fragment CGUUserFields on User {
  id
  email
  first_name
  last_name
  avatar_url
  invitation_status
}
    `;
export const ClinicGroupUserFieldsFragmentDoc = gql`
    fragment ClinicGroupUserFields on ClinicGroupUser {
  id
  clinic_group {
    id
  }
  user {
    ...CGUUserFields
  }
  role
  custom_role {
    id
    name
  }
  permissions {
    ...ClinicAdminPermissionFields
  }
  are_email_notifications_enabled
  are_sms_notifications_enabled
  are_desktop_notifications_enabled
  created_at
}
    ${CguUserFieldsFragmentDoc}
${ClinicAdminPermissionFieldsFragmentDoc}`;
export const SubClinicGroupFieldsFragmentDoc = gql`
    fragment SubClinicGroupFields on ClinicGroup {
  id
  name
  slug
  is_archived
  clinic_group_clinics {
    ...ClinicGroupClinicFields
  }
}
    ${ClinicGroupClinicFieldsFragmentDoc}`;
export const ClinicGroupFieldsFragmentDoc = gql`
    fragment ClinicGroupFields on ClinicGroup {
  id
  name
  slug
  settings {
    ...ClinicSettingsFields
  }
  clinic_group_clinics {
    ...ClinicGroupClinicFields
  }
  clinic_group_users {
    ...ClinicGroupUserFields
  }
  parent_clinic_group {
    id
    name
  }
  clinic_groups {
    ...SubClinicGroupFields
  }
  is_archived
  created_at
  updated_at
}
    ${ClinicSettingsFieldsFragmentDoc}
${ClinicGroupClinicFieldsFragmentDoc}
${ClinicGroupUserFieldsFragmentDoc}
${SubClinicGroupFieldsFragmentDoc}`;
export const ClinicSexFieldsFragmentDoc = gql`
    fragment ClinicSexFields on ClinicSex {
  id
  pms_id
  name
  description
  animal_gender
  fixed_statuses
  included_species
  is_active
}
    `;
export const ClinicianServiceFieldsFragmentDoc = gql`
    fragment ClinicianServiceFields on ClinicianService {
  id
  clinician {
    id
    name
  }
  service {
    id
  }
  duration_override
  created_at
  updated_at
}
    `;
export const ClinicianPreviewFieldsFragmentDoc = gql`
    fragment ClinicianPreviewFields on Clinician {
  id
  display_name
  name
  initials
  avatar_url
}
    `;
export const OnDemandClinicianFieldsFragmentDoc = gql`
    fragment OnDemandClinicianFields on OnDemandClinician {
  pms_id
  display_name
  first_name
  last_name
}
    `;
export const ClinicUsageFieldsFragmentDoc = gql`
    fragment ClinicUsageFields on Clinic {
  id
  name
  last_sync_times {
    last_sync_appointments
    last_sync_clients
    last_sync_patients
    last_full_sync
  }
}
    `;
export const UsageCountsFieldsFragmentDoc = gql`
    fragment UsageCountsFields on UsageCounts {
  last_24h
  last_week
  previous_week
  last_month
  previous_month
  all_time
}
    `;
export const LastSyncTimesFieldsFragmentDoc = gql`
    fragment LastSyncTimesFields on LastSyncTimes {
  last_full_sync
  last_sync_appointments
  last_sync_clients
  last_sync_patients
}
    `;
export const ClinicUsageStatsFieldsFragmentDoc = gql`
    fragment ClinicUsageStatsFields on ClinicUsageStats {
  clinic {
    id
    name
    pms
    mute_until
  }
  appointment_counts {
    ...UsageCountsFields
  }
  message_counts {
    ...UsageCountsFields
  }
  last_sync_times {
    ...LastSyncTimesFields
  }
  pms_db_last_sync_times {
    ...LastSyncTimesFields
  }
  concerns
}
    ${UsageCountsFieldsFragmentDoc}
${LastSyncTimesFieldsFragmentDoc}`;
export const ClinicStatsFieldsFragmentDoc = gql`
    fragment ClinicStatsFields on ClinicStats {
  completed_appointments
  confirmed_appointments
  booked_appointments
  pending_appointments
  cancelled_appointments
  denied_appointments
  expired_appointments
  total_appointments
  total_website_appointments
  total_widget_appointments
}
    `;
export const ClinicOnboardingClinicFieldsFragmentDoc = gql`
    fragment ClinicOnboardingClinicFields on Clinic {
  name
  pms
  avatar_url
  email
  phone
  send_from_phone
  office_emails
  settings {
    appointment_entry_method
    booking_match_procedure
    is_using_detailed_services
    does_use_rooms_to_schedule
    does_use_clinicians_to_schedule
    should_allow_new_clients
    should_allow_new_patients
    urgency_type
    should_sync_reminders
    primary_color
    primary_clinician_pms_id
    primary_room_pms_id
    allow_first_appt_per_day
  }
  last_sync_times {
    last_full_sync
  }
}
    `;
export const ClinicOnboardingFieldsFragmentDoc = gql`
    fragment ClinicOnboardingFields on ClinicOnboarding {
  clinic {
    ...ClinicOnboardingClinicFields
  }
  has_test_appointment
}
    ${ClinicOnboardingClinicFieldsFragmentDoc}`;
export const ConnectInstallationFieldsFragmentDoc = gql`
    fragment ConnectInstallationFields on ConnectInstallation {
  id
  computer_name
  last_ping
  is_server
  version
  connect_ui_version
  connect_server_version
  created_at
  updated_at
}
    `;
export const CustomRoleFieldsFragmentDoc = gql`
    fragment CustomRoleFields on CustomRole {
  id
  name
  description
  permissions {
    ...ClinicAdminPermissionFields
  }
  is_default
  is_active
  created_at
  updated_at
}
    ${ClinicAdminPermissionFieldsFragmentDoc}`;
export const CustomRoleWithRelationsFieldsFragmentDoc = gql`
    fragment CustomRoleWithRelationsFields on CustomRole {
  ...CustomRoleFields
  clinic {
    id
    name
  }
  clinic_group {
    id
    name
  }
}
    ${CustomRoleFieldsFragmentDoc}`;
export const AppointmentPreviewFieldsFragmentDoc = gql`
    fragment AppointmentPreviewFields on Appointment {
  id
  service_name
  service {
    name
  }
  clinician {
    name
    display_name
  }
  client {
    first_name
    last_name
  }
  patient {
    name
  }
  status
  start_time
  drop_off_time
  minutes
}
    `;
export const PimsReminderTypeFieldsFragmentDoc = gql`
    fragment PimsReminderTypeFields on PimsReminderType {
  id
  display_name
  is_active
  reminder_type_name
  all_reminder_names
}
    `;
export const PimsReminderPreviewFieldsFragmentDoc = gql`
    fragment PimsReminderPreviewFields on PimsReminder {
  id
  send_date
  display_due_date
  reminder_desc
  reminder_type {
    ...PimsReminderTypeFields
  }
}
    ${PimsReminderTypeFieldsFragmentDoc}`;
export const LeadContactPreviewFieldsFragmentDoc = gql`
    fragment LeadContactPreviewFields on LeadContact {
  id
  first_name
  last_name
  email
  phone
  source
  created_at
}
    `;
export const BookingFlowSessionPreviewFieldsFragmentDoc = gql`
    fragment BookingFlowSessionPreviewFields on BookingFlowSession {
  id
  source
  furthest_step
  last_step
  service_name
  is_new_client
  updated_at
}
    `;
export const CustomerSegmentResultFieldsFragmentDoc = gql`
    fragment CustomerSegmentResultFields on CustSegResult {
  client {
    ...ClientPreviewFields
  }
  appointment {
    ...AppointmentPreviewFields
  }
  patient {
    ...PatientPreviewFields
  }
  pims_reminder {
    ...PimsReminderPreviewFields
  }
  lead_contact {
    ...LeadContactPreviewFields
  }
  booking_flow_session {
    ...BookingFlowSessionPreviewFields
  }
}
    ${ClientPreviewFieldsFragmentDoc}
${AppointmentPreviewFieldsFragmentDoc}
${PatientPreviewFieldsFragmentDoc}
${PimsReminderPreviewFieldsFragmentDoc}
${LeadContactPreviewFieldsFragmentDoc}
${BookingFlowSessionPreviewFieldsFragmentDoc}`;
export const DailyHuddleFieldsFragmentDoc = gql`
    fragment DailyHuddleFields on DailyHuddle {
  id
  notes
  start_time
  end_time
  leader {
    id
    name
  }
  attendees {
    id
    name
  }
  created_at
  updated_at
}
    `;
export const DataChatPreviewFieldsFragmentDoc = gql`
    fragment DataChatPreviewFields on DataChat {
  id
  name
  last_prompt_message
  updated_at
}
    `;
export const DataChatResponseAppointmentFieldsFragmentDoc = gql`
    fragment DataChatResponseAppointmentFields on Appointment {
  id
  start_time
  status
  service {
    id
    name
  }
  patient {
    id
    name
  }
  client {
    id
  }
  clinician {
    id
    name
  }
}
    `;
export const DataChatResponseClientFieldsFragmentDoc = gql`
    fragment DataChatResponseClientFields on Client {
  id
  first_name
  last_name
  phone
  email
}
    `;
export const DataChatResponseRowFieldsFragmentDoc = gql`
    fragment DataChatResponseRowFields on DataChatResponseRow {
  appointment {
    ...DataChatResponseAppointmentFields
  }
  client {
    ...DataChatResponseClientFields
  }
  additional_info {
    name
    value
  }
}
    ${DataChatResponseAppointmentFieldsFragmentDoc}
${DataChatResponseClientFieldsFragmentDoc}`;
export const DataChatPromptFieldsFragmentDoc = gql`
    fragment DataChatPromptFields on DataChatPrompt {
  id
  prompt
  response_message
  response_data {
    ...DataChatResponseRowFields
  }
  created_at
}
    ${DataChatResponseRowFieldsFragmentDoc}`;
export const DataChatFieldsFragmentDoc = gql`
    fragment DataChatFields on DataChat {
  id
  name
  data_chat_prompts {
    ...DataChatPromptFields
  }
}
    ${DataChatPromptFieldsFragmentDoc}`;
export const DiagnosisFieldsFragmentDoc = gql`
    fragment DiagnosisFields on Diagnosis {
  id
  pms_id
  name
}
    `;
export const ClinicGroupOnboardingStepFieldsFragmentDoc = gql`
    fragment ClinicGroupOnboardingStepFields on ClinicGroupOnboardingStep {
  key
  options
  phase
  value_kind
}
    `;
export const ClinicGroupOnboardingTrancheFieldsFragmentDoc = gql`
    fragment ClinicGroupOnboardingTrancheFields on ClinicGroupOnboardingTranche {
  key
  is_complete
  clinic_ids
}
    `;
export const ClinicGroupOnboardingColumnConfigFieldsFragmentDoc = gql`
    fragment ClinicGroupOnboardingColumnConfigFields on ClinicGroupOnboardingColumnConfig {
  column_id
  is_scored
  is_hidden
  criterion {
    type
    value
  }
}
    `;
export const ClinicGroupOnboardingCellNoteChangeFieldsFragmentDoc = gql`
    fragment ClinicGroupOnboardingCellNoteChangeFields on ClinicGroupOnboardingCellNoteChange {
  note
  is_accepted
  waiting_on
  assigned_to
  assigned_to_name
  created_by
  created_by_name
  created_at
}
    `;
export const ClinicGroupOnboardingCellNoteFieldsFragmentDoc = gql`
    fragment ClinicGroupOnboardingCellNoteFields on ClinicGroupOnboardingCellNote {
  column_id
  clinic_id
  note
  is_accepted
  waiting_on
  assigned_to
  assigned_to_name
  created_by
  created_by_name
  created_at
  history {
    ...ClinicGroupOnboardingCellNoteChangeFields
  }
}
    ${ClinicGroupOnboardingCellNoteChangeFieldsFragmentDoc}`;
export const OnboardingClinicSettingsFieldsFragmentDoc = gql`
    fragment OnboardingClinicSettingsFields on ClinicSettings {
  google_review_link
  facebook_review_link
  review_google_id
  review_facebook_id
  send_reviews_to
  review_message_methods
  max_review_rating_for_notif
  should_use_private_reviews
  should_disable_online_scheduling
  appointment_entry_method
  schedule_method
  is_using_detailed_services
  is_using_rooms
  does_use_rooms_to_schedule
  does_use_clinicians_to_schedule
  hide_clinician_preference
  allow_first_appt_per_day
  allow_double_booking
  base_schedule_duration
  time_slot_minutes
  use_basic_timeslots
  valid_booking_interval_minutes
  should_fit_last_conflict
  only_use_adj_avail_guides
  should_use_pms_availability
  scheduling_buffer_minutes
  cancellation_buffer_minutes
  reschedule_buffer_minutes
  scheduling_min_minutes_away
  scheduling_max_minutes_away
  max_patients_per_visit
  max_booking_columns
  max_booking_notes_length
  min_booking_notes_length
  simple_scheduling_rules_enabled
  hide_closed_days_from_scheduling
  should_suggest_nearby_clinics
  nearby_clinic_min_total_slots
  nearby_clinic_min_day_slots
  included_species
  non_blocking_services
  does_require_verification
  does_require_referral
  should_automatically_assign_patient
  allow_reschedule
  reschedule_minutes_before
  reschedule_fee
  does_use_automatic_reschedule
  require_reason_for_cancellation
  cancellation_service_pms_id
  cancellation_clinician_pms_id
  should_allow_new_clients
  should_allow_new_patients
  should_create_clients
  should_create_patients
  does_require_new_client_address
  does_require_new_client_birthday
  does_require_new_client_title
  does_require_patient_color
  does_require_patient_weight
  does_require_patient_resuscitate
  booking_match_procedure
  urgency_type
  send_confirmations_to
  confirmation_days_before
  allow_confirmation_days_before
  send_new_appt_email
  notify_clinic_on
  is_using_notifications
  reminder_send_time_minutes
  should_sync_reminders
  default_reminder_service_id
  msgs_auto_priority
  auto_reply_enabled
  auto_reply_message
  exclude_message_wrapper
  default_trigger_words
  sms_block_list
  comms_writeback_enabled
  comms_should_daily_writeback
  comms_use_pdf_for_writeback
  comms_writeback_buffer_minutes
  comms_writeback_before_appt_mins
  comms_should_writeback_on_send
  comms_should_writeback_on_receive
  comms_should_writeback_notifs
  comms_should_use_ai_writeback
  form_writeback_enabled
  payment_writeback_enabled
  should_complete_sync
  server_syncing_only
  sync_interval_minutes
  long_sync_interval_hours
  pms_start_time
  pms_end_time
  should_default_pims_emails_on
  should_default_pims_sms_on
  should_default_marketing_sms_on
  should_default_marketing_email_on
  primary_clinician_pms_id
  primary_room_pms_id
  weight_key_pms_id
  status_set_on_payment_completed_pms_id
  primary_color
  accent_color
  custom_well_description
  custom_sick_description
  custom_other_title
  custom_other_description
  custom_appointment_notes_template
  custom_new_client_notes_template
  custom_new_patient_notes_template
  new_appt_requested_msg
  new_appt_approved_msg
  new_appt_approved_sms_msg
  new_appt_denied_msg
  clinic_hours_display
  hide_portal_vaccinations
  hide_portal_reminders
  hide_portal_prescriptions
  hide_portal_weight
  hide_soc_vaccinations
  hide_historic_vaccinations
  patient_details_tab_order
  should_award_loyalty_for_invoices
  invoice_loyalty_points_per_dollar
  app_download_loyalty_points
  referrer_loyalty_points
  referred_loyalty_points
  should_charge_client_stripe_fees
  chckvet_prescription_fee_split_percentage
  should_use_instant_prescription_requests
  prescription_pickup_service_id
  usage_spending_caps
  gtm_container_id
  ga_measurement_id
  facebook_pixel_id
  phone_provider
  ai_calls_provider
  ai_calls_phone_number
  ai_calls_voice_id
  ai_calls_agent_id
  ai_calls_outbound_agent_id
  ai_calls_cooldown_minutes
  ai_agent_style
  ai_agent_custom_instructions
  ai_calls_ambient_sound
  ai_calls_voice_speed
  ai_calls_interruption_sensitivity
  ai_calls_enable_dynamic_voice_speed
  should_hide_daily_huddle_financials
  max_inactivity_duration
  compliance_statuses
  primary_clinic_group_id
  custom_merge_tags
}
    `;
export const OnboardingClinicFeatureFieldsFragmentDoc = gql`
    fragment OnboardingClinicFeatureFields on ClinicFeatures {
  scheduling_enabled
  huddle_enabled
  payments_enabled
  telehealth_enabled
  messaging_enabled
  reviews_enabled
  loyalty_enabled
  forms_enabled
  help_enabled
  notifs_enabled
  bulk_messaging_enabled
  portal_enabled
  calls_enabled
  teamchat_enabled
  prescriptions_enabled
  medical_history_enabled
}
    `;
export const EnterpriseOnboardingRowFieldsFragmentDoc = gql`
    fragment EnterpriseOnboardingRowFields on EnterpriseOnboardingClinicRow {
  clinic {
    id
    name
    pms
    slug
    go_live_date
    address {
      street_a
      city
      zip
    }
    tmp_feature_flags
    settings {
      ...OnboardingClinicSettingsFields
    }
    features {
      ...OnboardingClinicFeatureFields
    }
  }
  step_statuses
  active_services_count
  active_scheduling_rules_count
  active_clinicians_count
  settings_unlinked_fields
  notifications_linked_count
  notifications_unlinked_count
  audiences_linked_count
  audiences_unlinked_count
  forms_linked_count
  forms_unlinked_count
  message_templates_linked_count
  message_templates_unlinked_count
  email_templates_linked_count
  email_templates_unlinked_count
}
    ${OnboardingClinicSettingsFieldsFragmentDoc}
${OnboardingClinicFeatureFieldsFragmentDoc}`;
export const InvoiceFieldsFragmentDoc = gql`
    fragment InvoiceFields on Invoice {
  id
  clinic {
    id
    name
  }
  pms_id
  status
  appointment {
    ...AppointmentPreviewFields
  }
  previous_appt {
    ...AppointmentPreviewFields
  }
  client {
    id
    first_name
    last_name
    email
    phone
  }
  patient {
    id
    name
  }
  clinician {
    id
    name
  }
  entered_by_name
  description
  discount
  discount_reason
  subtotal
  tax
  total
  total_paid
  balance
  currency
  pims_created_at
  paid_at
  created_at
  updated_at
}
    ${AppointmentPreviewFieldsFragmentDoc}`;
export const InvoiceItemFieldsFragmentDoc = gql`
    fragment InvoiceItemFields on InvoiceItem {
  id
  description
  quantity
  price
  total
  subtotal
  tax
  discount
  pims_created_at
  clinician {
    id
    name
  }
  invoice {
    id
    total
    client {
      id
      first_name
      last_name
    }
  }
}
    `;
export const DrilldownRowFieldsFragmentDoc = gql`
    fragment DrilldownRowFields on DrilldownRow {
  appointment {
    ...AppointmentFields
  }
  client {
    ...ClientFields
  }
  patient {
    ...PatientFields
  }
  clinician {
    ...ClinicianFields
  }
  invoice {
    ...InvoiceFields
  }
  invoice_item {
    ...InvoiceItemFields
  }
}
    ${AppointmentFieldsFragmentDoc}
${ClientFieldsFragmentDoc}
${PatientFieldsFragmentDoc}
${ClinicianFieldsFragmentDoc}
${InvoiceFieldsFragmentDoc}
${InvoiceItemFieldsFragmentDoc}`;
export const InitiativePreviewFieldsFragmentDoc = gql`
    fragment InitiativePreviewFields on Initiative {
  id
  name
  description
  start_time
  is_archived
}
    `;
export const TimeParamFieldsFragmentDoc = gql`
    fragment TimeParamFields on TimeParams {
  type
  from_millis_ago
  to_millis_ago
  period_type
  from_periods_ago
  to_periods_ago
  start
  end
}
    `;
export const ReportMetricModifierFieldsFragmentDoc = gql`
    fragment ReportMetricModifierFields on ReportMetricModifier {
  category
  column
  not
  filterOp
  value {
    string
    stringArray
    float
    boolean
  }
}
    `;
export const MetricValueParamsFieldsFragmentDoc = gql`
    fragment MetricValueParamsFields on MetricValueParams {
  custom_label
  value_type
}
    `;
export const ReportTemplatePreviewFieldsFragmentDoc = gql`
    fragment ReportTemplatePreviewFields on ReportTemplate {
  id
  name
  description
  is_active
}
    `;
export const KpiGroupPreviewFieldsFragmentDoc = gql`
    fragment KpiGroupPreviewFields on KpiGroup {
  id
  name
  description
}
    `;
export const ReportMetricFieldsFragmentDoc = gql`
    fragment ReportMetricFields on ReportMetric {
  id
  key
  type
  name
  description
  definition_override
  custom_query
  time_params_overrides {
    ...TimeParamFields
  }
  special_modifier
  field_modifiers {
    ...ReportMetricModifierFields
  }
  inverse_percentile
  format
  value_types {
    ...MetricValueParamsFields
  }
  time_field_override
  aggregate_field_override
  order
  is_archived
  report_template_metrics {
    id
    report_template {
      ...ReportTemplatePreviewFields
    }
  }
  initiative_metrics {
    id
    initiative {
      ...InitiativePreviewFields
    }
  }
  kpi_group_metrics {
    id
    kpi_group {
      ...KpiGroupPreviewFields
    }
  }
}
    ${TimeParamFieldsFragmentDoc}
${ReportMetricModifierFieldsFragmentDoc}
${MetricValueParamsFieldsFragmentDoc}
${ReportTemplatePreviewFieldsFragmentDoc}
${InitiativePreviewFieldsFragmentDoc}
${KpiGroupPreviewFieldsFragmentDoc}`;
export const InitiativeMetricFieldsFragmentDoc = gql`
    fragment InitiativeMetricFields on InitiativeMetric {
  id
  initiative {
    ...InitiativePreviewFields
  }
  report_metric {
    ...ReportMetricFields
  }
  order
}
    ${InitiativePreviewFieldsFragmentDoc}
${ReportMetricFieldsFragmentDoc}`;
export const InitiativeFieldsFragmentDoc = gql`
    fragment InitiativeFields on Initiative {
  id
  name
  description
  start_time
  initiative_metrics {
    ...InitiativeMetricFields
  }
  is_archived
  created_at
  updated_at
}
    ${InitiativeMetricFieldsFragmentDoc}`;
export const ReportMetricPreviewFieldsFragmentDoc = gql`
    fragment ReportMetricPreviewFields on ReportMetric {
  id
  name
  type
  inverse_percentile
  format
}
    `;
export const TrendTimeRangeFieldsFragmentDoc = gql`
    fragment TrendTimeRangeFields on TrendTimeRange {
  label
  start_time
  end_time
}
    `;
export const InitiativeMetricSegmentFieldsFragmentDoc = gql`
    fragment InitiativeMetricSegmentFields on InitiativeMetricSegment {
  time_range {
    ...TrendTimeRangeFields
  }
  values
}
    ${TrendTimeRangeFieldsFragmentDoc}`;
export const InitiativeMetricResultFieldsFragmentDoc = gql`
    fragment InitiativeMetricResultFields on InitiativeMetricResult {
  metric {
    id
    report_metric {
      ...ReportMetricPreviewFields
      custom_query
    }
    order
  }
  initiative_metric_segments {
    ...InitiativeMetricSegmentFields
  }
}
    ${ReportMetricPreviewFieldsFragmentDoc}
${InitiativeMetricSegmentFieldsFragmentDoc}`;
export const InitiativeResultFieldsFragmentDoc = gql`
    fragment InitiativeResultFields on InitiativeResult {
  scope
  initiative_metric_results {
    ...InitiativeMetricResultFields
  }
}
    ${InitiativeMetricResultFieldsFragmentDoc}`;
export const KpiGroupMetricFieldsFragmentDoc = gql`
    fragment KpiGroupMetricFields on KpiGroupMetric {
  id
  goal
  kpi_group {
    ...KpiGroupPreviewFields
  }
  report_metric {
    ...ReportMetricFields
  }
  order
}
    ${KpiGroupPreviewFieldsFragmentDoc}
${ReportMetricFieldsFragmentDoc}`;
export const KpiGroupFieldsFragmentDoc = gql`
    fragment KpiGroupFields on KpiGroup {
  id
  name
  description
  kpi_group_metrics {
    ...KpiGroupMetricFields
  }
  created_at
  updated_at
}
    ${KpiGroupMetricFieldsFragmentDoc}`;
export const KpiGroupResultValueFieldsFragmentDoc = gql`
    fragment KpiGroupResultValueFields on KpiGroupResultValue {
  current_value
}
    `;
export const KpiGroupResultFieldsFragmentDoc = gql`
    fragment KpiGroupResultFields on KpiGroupResult {
  metric {
    id
    report_metric {
      ...ReportMetricPreviewFields
      custom_query
    }
    goal
    order
  }
  value {
    ...KpiGroupResultValueFields
  }
}
    ${ReportMetricPreviewFieldsFragmentDoc}
${KpiGroupResultValueFieldsFragmentDoc}`;
export const ClinicDisplayFieldsFragmentDoc = gql`
    fragment ClinicDisplayFields on Clinic {
  id
  name
}
    `;
export const KpiGroupMetricResultFieldsFragmentDoc = gql`
    fragment KpiGroupMetricResultFields on KpiGroupMetricResult {
  clinic {
    ...ClinicDisplayFields
  }
  value {
    ...KpiGroupResultValueFields
  }
}
    ${ClinicDisplayFieldsFragmentDoc}
${KpiGroupResultValueFieldsFragmentDoc}`;
export const ReportClinicClinicFieldsFragmentDoc = gql`
    fragment ReportClinicClinicFields on Clinic {
  id
  name
  slug
  address {
    street_a
    street_b
    city
    state
    zip
    country
  }
}
    `;
export const ReportClinicFieldsFragmentDoc = gql`
    fragment ReportClinicFields on ReportClinic {
  id
  clinic {
    ...ReportClinicClinicFields
  }
}
    ${ReportClinicClinicFieldsFragmentDoc}`;
export const SecondChildReportEntityFieldsFragmentDoc = gql`
    fragment SecondChildReportEntityFields on ReportEntity {
  entity_type
  child_entities {
    entity_type
  }
}
    `;
export const ChildReportEntityFieldsFragmentDoc = gql`
    fragment ChildReportEntityFields on ReportEntity {
  entity_type
  child_entities {
    ...SecondChildReportEntityFields
  }
}
    ${SecondChildReportEntityFieldsFragmentDoc}`;
export const ReportEntityFieldsFragmentDoc = gql`
    fragment ReportEntityFields on ReportEntity {
  entity_type
  child_entities {
    ...ChildReportEntityFields
  }
}
    ${ChildReportEntityFieldsFragmentDoc}`;
export const TemplateClinicClinicFieldsFragmentDoc = gql`
    fragment TemplateClinicClinicFields on Clinic {
  id
  name
  time_zone
  slug
  address {
    street_a
    street_b
    city
    state
    zip
    country
  }
  hours {
    ...AvailabilityDayFields
  }
}
    ${AvailabilityDayFieldsFragmentDoc}`;
export const EntityReportClinicianFieldsFragmentDoc = gql`
    fragment EntityReportClinicianFields on Clinician {
  id
  pms_id
  name
}
    `;
export const EntityReportServiceFieldsFragmentDoc = gql`
    fragment EntityReportServiceFields on Service {
  id
  name
}
    `;
export const EntityReportProductFieldsFragmentDoc = gql`
    fragment EntityReportProductFields on Product {
  id
  name
}
    `;
export const ReportValueFieldsFragmentDoc = gql`
    fragment ReportValueFields on ReportValue {
  metric
  key
  column_values {
    value
    percentile
    value_params {
      ...MetricValueParamsFields
    }
  }
}
    ${MetricValueParamsFieldsFragmentDoc}`;
export const EntityReportSharedFieldsFragmentDoc = gql`
    fragment EntityReportSharedFields on EntityReport {
  id
  entity_type
  clinic {
    ...TemplateClinicClinicFields
  }
  clinician {
    ...EntityReportClinicianFields
  }
  service {
    ...EntityReportServiceFields
  }
  product {
    ...EntityReportProductFields
  }
  values {
    ...ReportValueFields
  }
}
    ${TemplateClinicClinicFieldsFragmentDoc}
${EntityReportClinicianFieldsFragmentDoc}
${EntityReportServiceFieldsFragmentDoc}
${EntityReportProductFieldsFragmentDoc}
${ReportValueFieldsFragmentDoc}`;
export const SecondChildReportFieldsFragmentDoc = gql`
    fragment SecondChildReportFields on EntityReport {
  ...EntityReportSharedFields
}
    ${EntityReportSharedFieldsFragmentDoc}`;
export const FirstChildReportFieldsFragmentDoc = gql`
    fragment FirstChildReportFields on EntityReport {
  ...EntityReportSharedFields
  entity_reports {
    ...SecondChildReportFields
  }
}
    ${EntityReportSharedFieldsFragmentDoc}
${SecondChildReportFieldsFragmentDoc}`;
export const EntityReportFieldsFragmentDoc = gql`
    fragment EntityReportFields on EntityReport {
  ...EntityReportSharedFields
  entity_reports {
    ...FirstChildReportFields
  }
}
    ${EntityReportSharedFieldsFragmentDoc}
${FirstChildReportFieldsFragmentDoc}`;
export const OrganizationReportFieldsFragmentDoc = gql`
    fragment OrganizationReportFields on OrganizationReport {
  id
  organization {
    id
    name
  }
  name
  description
  preferred_view_type
  report_clinics {
    ...ReportClinicFields
  }
  report_metrics {
    ...ReportMetricFields
  }
  entity_structure {
    ...ReportEntityFields
  }
  entity_reports {
    ...EntityReportFields
  }
  report_template {
    id
  }
  time_params {
    ...TimeParamFields
  }
  is_hidden
  created_at
  updated_at
}
    ${ReportClinicFieldsFragmentDoc}
${ReportMetricFieldsFragmentDoc}
${ReportEntityFieldsFragmentDoc}
${EntityReportFieldsFragmentDoc}
${TimeParamFieldsFragmentDoc}`;
export const OrganizationReportPreviewFieldsFragmentDoc = gql`
    fragment OrganizationReportPreviewFields on OrganizationReport {
  id
  name
  description
  report_clinics {
    id
    clinic {
      name
    }
  }
  report_metrics {
    id
    name
    type
  }
  report_template {
    id
    name
  }
  is_hidden
  created_at
}
    `;
export const ReportTemplateResultFieldsFragmentDoc = gql`
    fragment ReportTemplateResultFields on ReportTemplateResult {
  metric {
    report_metric {
      ...ReportMetricPreviewFields
    }
    order
  }
  values
}
    ${ReportMetricPreviewFieldsFragmentDoc}`;
export const TemplateClinicFieldsFragmentDoc = gql`
    fragment TemplateClinicFields on TemplateClinic {
  id
  clinic {
    ...TemplateClinicClinicFields
  }
}
    ${TemplateClinicClinicFieldsFragmentDoc}`;
export const ReportTemplateMetricFieldsFragmentDoc = gql`
    fragment ReportTemplateMetricFields on ReportTemplateMetric {
  id
  report_template {
    ...ReportTemplatePreviewFields
  }
  report_metric {
    ...ReportMetricFields
  }
  order
}
    ${ReportTemplatePreviewFieldsFragmentDoc}
${ReportMetricFieldsFragmentDoc}`;
export const RepeatParamsFieldsFragmentDoc = gql`
    fragment RepeatParamsFields on RepeatParams {
  frequency
  unit
  daysOfWeek
  daysOfMonth
  weekOfMonth
}
    `;
export const ReportTemplateFieldsFragmentDoc = gql`
    fragment ReportTemplateFields on ReportTemplate {
  id
  name
  description
  organization {
    id
  }
  template_clinics {
    ...TemplateClinicFields
  }
  report_template_metrics {
    ...ReportTemplateMetricFields
  }
  preferred_view_type
  entity_structure
  last_run
  next_run
  repeat {
    ...RepeatParamsFields
  }
  organization_reports {
    id
  }
  time_params {
    ...TimeParamFields
  }
  is_active
  created_at
  updated_at
}
    ${TemplateClinicFieldsFragmentDoc}
${ReportTemplateMetricFieldsFragmentDoc}
${RepeatParamsFieldsFragmentDoc}
${TimeParamFieldsFragmentDoc}`;
export const ClinicReportTemplateFieldsFragmentDoc = gql`
    fragment ClinicReportTemplateFields on TemplateClinic {
  report_template {
    ...ReportTemplateFields
  }
}
    ${ReportTemplateFieldsFragmentDoc}`;
export const TrendSegmentFieldsFragmentDoc = gql`
    fragment TrendSegmentFields on TrendSegment {
  time_range {
    ...TrendTimeRangeFields
  }
  values
}
    ${TrendTimeRangeFieldsFragmentDoc}`;
export const TrendReportFieldsFragmentDoc = gql`
    fragment TrendReportFields on TrendReport {
  scope
  trend_segments {
    ...TrendSegmentFields
  }
}
    ${TrendSegmentFieldsFragmentDoc}`;
export const EntityLinkFieldsFragmentDoc = gql`
    fragment EntityLinkFields on EntityLink {
  id
  entity_type
  clinic
  parent_id
  child_id
  unlinked_at
  unlinked_by
  unlinked_fields
  created_at
  updated_at
}
    `;
export const FormPreviewFieldsFragmentDoc = gql`
    fragment FormPreviewFields on Form {
  id
  name
}
    `;
export const FormAnalyticsFieldsFragmentDoc = gql`
    fragment FormAnalyticsFields on FormAnalytics {
  form {
    ...FormPreviewFields
  }
  field_analytics {
    element_id
    element_name
    type
    value_counts {
      value
      count
    }
  }
}
    ${FormPreviewFieldsFragmentDoc}`;
export const GoalsFieldsFragmentDoc = gql`
    fragment GoalsFields on Goal {
  id
  clinic {
    id
  }
  description
  created_at
  is_active
  is_chckup_modifier
  is_new_modifier
  is_system
  last_synced_time
  metric_current_amount
  metric_entity
  metric_target_amount
  metric_timespan
  status
  updated_at
}
    `;
export const InternalChatMessageAttachmentFieldsFragmentDoc = gql`
    fragment InternalChatMessageAttachmentFields on InternalChatMessageAttachment {
  id
  url
  filename
  type
}
    `;
export const InternalChatMessageFieldsFragmentDoc = gql`
    fragment InternalChatMessageFields on InternalChatMessage {
  id
  internal_chat {
    id
    title
  }
  sender {
    user {
      id
      first_name
      last_name
      email
      phone
      avatar_url
    }
    internal_chat {
      id
    }
  }
  text
  internal_chat_messages_attachments {
    ...InternalChatMessageAttachmentFields
  }
  created_at
  updated_at
}
    ${InternalChatMessageAttachmentFieldsFragmentDoc}`;
export const InternalChatUserPreviewFieldsFragmentDoc = gql`
    fragment InternalChatUserPreviewFields on InternalChatUser {
  id
  user {
    id
    first_name
    last_name
    avatar_url
  }
  last_read_time
  last_message_time
  unread_message_count
  is_removed
  created_at
  updated_at
}
    `;
export const InternalChatFieldsFragmentDoc = gql`
    fragment InternalChatFields on InternalChat {
  id
  clinic {
    id
    name
    avatar_url
  }
  clinicGroup {
    id
    name
  }
  internal_chat_users {
    ...InternalChatUserPreviewFields
  }
  title
  message_count
  last_message
  last_message_time
  is_deleted
  created_at
  updated_at
}
    ${InternalChatUserPreviewFieldsFragmentDoc}`;
export const InternalChatUserFieldsFragmentDoc = gql`
    fragment InternalChatUserFields on InternalChatUser {
  id
  user {
    id
    first_name
    last_name
    email
    phone
    avatar_url
  }
  internal_chat {
    ...InternalChatFields
  }
  last_read_time
  last_message_time
  unread_message_count
  is_removed
  created_at
  updated_at
}
    ${InternalChatFieldsFragmentDoc}`;
export const InternalUsageEventFieldsFragmentDoc = gql`
    fragment InternalUsageEventFields on InternalUsageEvent {
  id
  action_type
  clinic_id
  user_id
  widget_id
  instance_id
  metadata
  created_at
}
    `;
export const InternalUsageClinicFieldsFragmentDoc = gql`
    fragment InternalUsageClinicFields on Clinic {
  id
  name
  avatar_url
}
    `;
export const InternalUsageUserFieldsFragmentDoc = gql`
    fragment InternalUsageUserFields on User {
  id
  first_name
  last_name
  email
}
    `;
export const InvoicePreviewFieldsFragmentDoc = gql`
    fragment InvoicePreviewFields on Invoice {
  id
  status
  client {
    id
    first_name
    last_name
  }
  clinician {
    id
    name
  }
  discount
  total
  total_paid
  balance
  paid_at
  pims_created_at
}
    `;
export const DetailedInvoiceFieldsFragmentDoc = gql`
    fragment DetailedInvoiceFields on Invoice {
  ...InvoiceFields
  invoice_items {
    id
    description
    quantity
    price
    total
  }
  client {
    ...ClientFields
  }
  patient {
    ...PatientFields
  }
}
    ${InvoiceFieldsFragmentDoc}
${ClientFieldsFragmentDoc}
${PatientFieldsFragmentDoc}`;
export const LoyaltyClientFieldsFragmentDoc = gql`
    fragment LoyaltyClientFields on Client {
  id
  first_name
  last_name
  phone
  address {
    country
  }
}
    `;
export const LoyaltyMemberFieldsFragmentDoc = gql`
    fragment LoyaltyMemberFields on LoyaltyMember {
  id
  client {
    ...LoyaltyClientFields
  }
  available_points
  all_time_points
}
    ${LoyaltyClientFieldsFragmentDoc}`;
export const LoyaltyRewardFieldsFragmentDoc = gql`
    fragment LoyaltyRewardFields on LoyaltyReward {
  id
  name
  description
  points_required
  is_active
  image_url
  created_at
  updated_at
}
    `;
export const LoyaltyRedemptionFieldsFragmentDoc = gql`
    fragment LoyaltyRedemptionFields on LoyaltyRedemption {
  id
  status
  member {
    ...LoyaltyMemberFields
  }
  reward {
    ...LoyaltyRewardFields
  }
  created_at
  updated_at
}
    ${LoyaltyMemberFieldsFragmentDoc}
${LoyaltyRewardFieldsFragmentDoc}`;
export const LoyaltyEarningFieldsFragmentDoc = gql`
    fragment LoyaltyEarningFields on LoyaltyEarning {
  id
  member {
    ...LoyaltyMemberFields
  }
  invoice {
    id
    pims_created_at
  }
  points_earned
  created_at
}
    ${LoyaltyMemberFieldsFragmentDoc}`;
export const BookingSourceBreakdownFieldsFragmentDoc = gql`
    fragment BookingSourceBreakdownFields on BookingSourceBreakdownEntry {
  source
  count
  percent
}
    `;
export const MarketingSummaryStatsFieldsFragmentDoc = gql`
    fragment MarketingSummaryStatsFields on MarketingSummaryStats {
  total_appointments
  online_booking_appointments
  new_client_appointments
  existing_client_appointments
  total_messages_sent
  total_notification_sends
  total_bulk_message_sends
  successful_email_sends
  total_email_opens
  email_open_rate
  direct_attributed_bookings
  indirect_attributed_bookings
  total_attributed_bookings
  response_rate
  total_attributed_revenue
  attribution_window_days
  attribution_row_limit_hit
  booking_source_breakdown {
    ...BookingSourceBreakdownFields
  }
}
    ${BookingSourceBreakdownFieldsFragmentDoc}`;
export const OrgCampaignStatsFieldsFragmentDoc = gql`
    fragment OrgCampaignStatsFields on OrgCampaignStats {
  campaign_id
  campaign_name
  clinic_id
  clinic_group_id
  total_messages_sent
  successful_email_sends
  total_email_opens
  email_open_rate
  direct_attributed_bookings
  indirect_attributed_bookings
  total_attributed_bookings
  total_attributed_revenue
}
    `;
export const OrgNotificationStatsFieldsFragmentDoc = gql`
    fragment OrgNotificationStatsFields on OrgNotificationStats {
  notif_template_id
  notif_template_name
  clinic_id
  campaign_id
  is_active
  total_messages_sent
  successful_email_sends
  total_email_opens
  email_open_rate
  response_rate
  direct_attributed_bookings
  indirect_attributed_bookings
  total_attributed_bookings
  total_attributed_revenue
}
    `;
export const OrgBulkMessageStatsFieldsFragmentDoc = gql`
    fragment OrgBulkMessageStatsFields on OrgBulkMessageStats {
  bulk_message_id
  bulk_message_name
  clinic_id
  campaign_id
  is_active
  total_messages_sent
  successful_email_sends
  total_email_opens
  email_open_rate
  response_rate
  direct_attributed_bookings
  indirect_attributed_bookings
  total_attributed_bookings
  total_attributed_revenue
}
    `;
export const ReminderAttributedAppointmentIdsFieldsFragmentDoc = gql`
    fragment ReminderAttributedAppointmentIdsFields on ReminderAttributedAppointmentIds {
  appointment_ids
  limit_hit
}
    `;
export const MessageTemplateFieldsFragmentDoc = gql`
    fragment MessageTemplateFields on MessageTemplate {
  id
  name
  body
  created_at
  updated_at
}
    `;
export const MessagePatientFieldsFragmentDoc = gql`
    fragment MessagePatientFields on Patient {
  id
  name
  pms_id
}
    `;
export const AttachmentFieldsFragmentDoc = gql`
    fragment AttachmentFields on Attachment {
  id
  url
  filename
  type
}
    `;
export const MessageNotificationTemplateFieldsFragmentDoc = gql`
    fragment MessageNotificationTemplateFields on MessageNotificationTemplate {
  notification_template {
    id
    name
    email_body
    body
    subject
    postcard_template
    postcard_front_html
    postcard_back_html
  }
}
    `;
export const MessageFieldsFragmentDoc = gql`
    fragment MessageFields on Message {
  id
  client {
    id
    first_name
    last_name
    phone
    email
  }
  chat {
    id
    client {
      id
      first_name
      last_name
      phone
      email
    }
    clinic {
      id
      address {
        ...AddressFields
      }
    }
  }
  patient {
    ...MessagePatientFields
  }
  patients {
    ...MessagePatientFields
  }
  clinic_user {
    id
    first_name
    last_name
  }
  text
  email_text
  postcard_template
  attachments {
    ...AttachmentFields
  }
  notification {
    id
    name
    subject
    body
    email_body
    postcard_template
    postcard_front_html
    postcard_back_html
  }
  bulk_message {
    id
    name
    subject
    body
    email_body
  }
  message_notification_templates {
    ...MessageNotificationTemplateFields
  }
  client_phone {
    ...ClientPhoneFields
  }
  message_methods
  message_type
  message_origin
  hidden_for_client
  cta_text
  cta_url
  email_error
  sms_error
  push_error
  postcard_error
  other_errors
  is_preview
  written_back_at
  template_data
  created_at
  updated_at
}
    ${AddressFieldsFragmentDoc}
${MessagePatientFieldsFragmentDoc}
${AttachmentFieldsFragmentDoc}
${MessageNotificationTemplateFieldsFragmentDoc}
${ClientPhoneFieldsFragmentDoc}`;
export const NotificationLogMessageFieldsFragmentDoc = gql`
    fragment NotificationLogMessageFields on Message {
  id
  client {
    id
  }
  chat {
    id
    client {
      id
      first_name
      last_name
    }
  }
  text
  postcard_template
  notification {
    id
    name
    postcard_template
  }
  bulk_message {
    id
    name
  }
  message_notification_templates {
    notification_template {
      id
      name
      postcard_template
    }
  }
  message_methods
  message_type
  email_error
  sms_error
  postcard_error
  other_errors
  is_preview
  template_data
  created_at
}
    `;
export const ChatMessageFieldsFragmentDoc = gql`
    fragment ChatMessageFields on Message {
  id
  client {
    id
    first_name
    last_name
    phone
    email
  }
  chat {
    id
    clinic {
      id
      name
    }
  }
  patient {
    ...MessagePatientFields
  }
  patients {
    ...MessagePatientFields
  }
  clinic_user {
    id
    first_name
    last_name
  }
  notification {
    id
    name
    subject
    body
    email_body
    postcard_template
    postcard_front_html
    postcard_back_html
  }
  bulk_message {
    id
    name
    subject
    body
    email_body
  }
  call {
    ...CallFields
  }
  text
  email_text
  postcard_template
  attachments {
    ...AttachmentFields
  }
  client_phone {
    ...ClientPhoneFields
  }
  message_notification_templates {
    ...MessageNotificationTemplateFields
  }
  message_methods
  message_type
  message_origin
  hidden_for_client
  cta_text
  cta_url
  email_error
  sms_error
  push_error
  postcard_error
  other_errors
  is_preview
  written_back_at
  template_data
  created_at
  updated_at
}
    ${MessagePatientFieldsFragmentDoc}
${CallFieldsFragmentDoc}
${AttachmentFieldsFragmentDoc}
${ClientPhoneFieldsFragmentDoc}
${MessageNotificationTemplateFieldsFragmentDoc}`;
export const MsgTrackingEventFieldsFragmentDoc = gql`
    fragment MsgTrackingEventFields on MsgTrackingEvent {
  id
  message_id
  clinic_id
  event_type
  event_value
  click_id
  notif_template_id
  bulk_message_id
  client_id
  message_method
  redirect_url
  created_at
  updated_at
}
    `;
export const NotificationEngagementStatsFieldsFragmentDoc = gql`
    fragment NotificationEngagementStatsFields on NotificationEngagementStats {
  messages_sent
  emails_sent
  sms_sent
  email_unique_opens
  unique_clicks
  open_rate
  click_rate
}
    `;
export const NotificationEngagementFieldsFragmentDoc = gql`
    fragment NotificationEngagementFields on NotificationEngagement {
  notification_template_id
  name
  clinic_id
  message_methods
  audience_name
  category
  stats {
    ...NotificationEngagementStatsFields
  }
}
    ${NotificationEngagementStatsFieldsFragmentDoc}`;
export const NotificationCategoryEngagementFieldsFragmentDoc = gql`
    fragment NotificationCategoryEngagementFields on NotificationCategoryEngagement {
  category
  notification_count
  stats {
    ...NotificationEngagementStatsFields
  }
}
    ${NotificationEngagementStatsFieldsFragmentDoc}`;
export const MedicalReminderFunnelCountsFieldsFragmentDoc = gql`
    fragment MedicalReminderFunnelCountsFields on MedicalReminderFunnelCounts {
  clients_sent
  clients_opened
  clients_clicked
  clients_booked
  direct_appointments
  indirect_appointments
  direct_revenue_cents
  indirect_revenue_cents
}
    `;
export const MedicalReminderNotificationFunnelFieldsFragmentDoc = gql`
    fragment MedicalReminderNotificationFunnelFields on MedicalReminderNotificationFunnel {
  notification_template_id
  name
  clinic_id
  counts {
    ...MedicalReminderFunnelCountsFields
  }
}
    ${MedicalReminderFunnelCountsFieldsFragmentDoc}`;
export const MedicalReminderFunnelFieldsFragmentDoc = gql`
    fragment MedicalReminderFunnelFields on MedicalReminderFunnel {
  attribution_window_days
  revenue_lookback_days
  notification_count
  counts {
    ...MedicalReminderFunnelCountsFields
  }
  notifications {
    ...MedicalReminderNotificationFunnelFields
  }
}
    ${MedicalReminderFunnelCountsFieldsFragmentDoc}
${MedicalReminderNotificationFunnelFieldsFragmentDoc}`;
export const EmailTemplateFieldsFragmentDoc = gql`
    fragment EmailTemplateFields on EmailTemplate {
  id
  clinic {
    id
  }
  clinic_group {
    id
    name
  }
  title
  subject
  design
  html
  status
  created_at
  updated_at
}
    `;
export const ReferencePeriodFieldsFragmentDoc = gql`
    fragment ReferencePeriodFields on ReferencePeriod {
  quantity
  unit
  direction
}
    `;
export const ReferenceDateParamsFieldsFragmentDoc = gql`
    fragment ReferenceDateParamsFields on ReferenceDateParams {
  field
  reference_periods {
    ...ReferencePeriodFields
  }
}
    ${ReferencePeriodFieldsFragmentDoc}`;
export const CustomerSegmentFieldsFragmentDoc = gql`
    fragment CustomerSegmentFields on CustomerSegment {
  id
  name
  filters {
    type
    only_consider_other_rows
    filters {
      ...QueryFilterFields
    }
  }
  excluded_filters {
    type
    only_consider_other_rows
    filters {
      ...QueryFilterFields
    }
  }
  trigger_entity
  all_inclusions {
    ...SegmentFilterFields
  }
  any_inclusions {
    ...SegmentFilterFields
  }
  any_exclusions {
    ...SegmentFilterFields
  }
  any_other_exclusions {
    ...SegmentFilterFields
  }
  default_exclusions_options {
    exclude_cancelled_and_rescheduled_resources
    exclude_euthanasia_and_qol_resources
    exclude_euthanasia_and_qol_in_appt_notes
  }
  is_hourly
  reference_date_params {
    ...ReferenceDateParamsFields
  }
  group_days_ahead
  should_include_all_overdue
  included_clients
  excluded_clients
  other_result_exclusion_entity
  notification_templates {
    ...NotificationTemplatePreviewFields
  }
  error_flags {
    ...CustomerSegmentErrorFlagFields
  }
  is_archived
  created_at
  updated_at
}
    ${QueryFilterFieldsFragmentDoc}
${SegmentFilterFieldsFragmentDoc}
${ReferenceDateParamsFieldsFragmentDoc}
${NotificationTemplatePreviewFieldsFragmentDoc}
${CustomerSegmentErrorFlagFieldsFragmentDoc}`;
export const CampaignPreviewFieldsFragmentDoc = gql`
    fragment CampaignPreviewFields on Campaign {
  id
  name
  color
  description
}
    `;
export const NotificationTemplateFieldsFragmentDoc = gql`
    fragment NotificationTemplateFields on NotificationTemplate {
  id
  email_template {
    ...EmailTemplateFields
  }
  name
  every_x_hours
  send_time_minutes
  body
  email_body
  email_design
  email_html
  repeating_body
  grouping_method
  message_methods
  notif_attachments {
    id
    filename
    type
    url
  }
  customer_segment {
    ...CustomerSegmentFields
  }
  clinic {
    id
    name
  }
  campaign {
    ...CampaignPreviewFields
  }
  is_marketing
  is_active
  is_system
  subject
  cta_text
  cta_url
  default_service_id
  postcard_template
  postcard_front_html
  postcard_back_html
  is_archived
  is_preview_mode
  updated_at
  created_at
}
    ${EmailTemplateFieldsFragmentDoc}
${CustomerSegmentFieldsFragmentDoc}
${CampaignPreviewFieldsFragmentDoc}`;
export const UserNotificationFieldsFragmentDoc = gql`
    fragment UserNotificationFields on UserNotification {
  id
  type
  title
  body
  link_url
  payload
  read_at
  seen_at
  created_at
  updated_at
  created_by_user {
    ...UserBasicInfo
  }
}
    ${UserBasicInfoFragmentDoc}`;
export const ClinicAnalyticsFieldsFragmentDoc = gql`
    fragment ClinicAnalyticsFields on ClinicAnalytics {
  appointments {
    ...AppointmentFields
  }
  appointments_count
  no_show_count
  revenue
  transactions_count
  revenue_by_type {
    group
    amount
  }
  revenue_by_clinician {
    group
    amount
  }
  accounts_receivable
  clients_with_negative_balances {
    ...ClientFields
  }
  clients_with_negative_balances_count
  patients_without_reschedules {
    ...PatientFields
  }
  monthly_revenue_completed
  monthly_appointments_scheduled
  last_month_average_revenue_per_appointment
  new_clients_count
  new_patients_count
  new_appointments_count
  schedule_efficiency
  forward_scheduled_patients_count
}
    ${AppointmentFieldsFragmentDoc}
${ClientFieldsFragmentDoc}
${PatientFieldsFragmentDoc}`;
export const OrganizationAnalyticsFieldsFragmentDoc = gql`
    fragment OrganizationAnalyticsFields on OrganizationAnalytics {
  clinic {
    id
    name
    pms
  }
  analytics {
    ...ClinicAnalyticsFields
  }
}
    ${ClinicAnalyticsFieldsFragmentDoc}`;
export const OrganizationClinicAnalyticsNumbersFieldsFragmentDoc = gql`
    fragment OrganizationClinicAnalyticsNumbersFields on OrganizationClinicAnalyticsNumbers {
  appointments_count {
    value
    percentile
  }
  no_show_count {
    value
    percentile
  }
  revenue {
    value
    percentile
  }
  transactions_count {
    value
    percentile
  }
  revenue_per_appointment {
    value
    percentile
  }
  new_clients_count {
    value
    percentile
  }
  new_patients_count {
    value
    percentile
  }
  new_appointments_count {
    value
    percentile
  }
  schedule_efficiency {
    value
    percentile
  }
  forward_scheduled_patients_count {
    value
    percentile
  }
}
    `;
export const OrganizationAnalyticsNumbersFieldsFragmentDoc = gql`
    fragment OrganizationAnalyticsNumbersFields on OrganizationAnalyticsNumbers {
  clinic {
    id
    name
    pms
  }
  analytic_numbers {
    ...OrganizationClinicAnalyticsNumbersFields
  }
}
    ${OrganizationClinicAnalyticsNumbersFieldsFragmentDoc}`;
export const OrganizationClinicFieldsFragmentDoc = gql`
    fragment OrganizationClinicFields on Clinic {
  id
  name
  avatar_url
  address {
    street_a
    street_b
    city
    state
    zip
  }
  is_archived
}
    `;
export const OrganizationAdminFieldsFragmentDoc = gql`
    fragment OrganizationAdminFields on User {
  id
  first_name
  last_name
  email
}
    `;
export const OrganizationSettingsFieldsFragmentDoc = gql`
    fragment OrganizationSettingsFields on OrganizationSettings {
  primary_color
  accent_color
  custom_well_description
  custom_sick_description
  custom_other_title
  custom_other_description
  custom_booking_copy {
    ...ClinicBookingCopyFields
  }
}
    ${ClinicBookingCopyFieldsFragmentDoc}`;
export const OrganizationFieldsFragmentDoc = gql`
    fragment OrganizationFields on Organization {
  id
  name
  slug
  clinics {
    ...OrganizationClinicFields
  }
  admins {
    ...OrganizationAdminFields
  }
  settings {
    ...OrganizationSettingsFields
  }
  created_at
  updated_at
}
    ${OrganizationClinicFieldsFragmentDoc}
${OrganizationAdminFieldsFragmentDoc}
${OrganizationSettingsFieldsFragmentDoc}`;
export const PatientHistoryItemFieldsFragmentDoc = gql`
    fragment PatientHistoryItemFields on PatientHistoryItem {
  id
  patient {
    id
  }
  diagnosis {
    id
  }
  product {
    id
  }
  issued_at
}
    `;
export const PatientNoteFieldsFragmentDoc = gql`
    fragment PatientNoteFields on PatientNote {
  id
  text
  noted_at
  is_internal
  is_active
  created_at
  updated_at
}
    `;
export const OverduePatientWithAppointmentFieldsFragmentDoc = gql`
    fragment OverduePatientWithAppointmentFields on OverduePatient {
  patient {
    ...PatientFields
  }
  last_appointment {
    ...AppointmentPreviewFields
  }
}
    ${PatientFieldsFragmentDoc}
${AppointmentPreviewFieldsFragmentDoc}`;
export const PaymentFieldsFragmentDoc = gql`
    fragment PaymentFields on Payment {
  id
  appointment {
    ...AppointmentDailyHuddleFields
  }
  client {
    id
    first_name
    last_name
    phone
    email
  }
  clinic {
    id
  }
  payment_method_id
  stripe_payment_intent_id
  stripe_payment_link
  stripe_payment_id
  stripe_account_id
  stripe_checkout_session_url
  description
  amount
  category
  status
  is_entered_in_pims
  amount_refunded
  refund_issued_at
  refund_entered_in_pims
  date
  created_at
  updated_at
}
    ${AppointmentDailyHuddleFieldsFragmentDoc}`;
export const PaymentPreviewFieldsFragmentDoc = gql`
    fragment PaymentPreviewFields on Payment {
  id
  amount
  client {
    id
    first_name
    last_name
  }
  appointment {
    id
    service_name
    service {
      name
    }
    start_time
  }
  status
  amount_refunded
  refund_issued_at
  date
  created_at
}
    `;
export const PatientRecordFieldsFragmentDoc = gql`
    fragment PatientRecordFields on PatientRecord {
  id
  patient {
    id
    name
    clinic_species {
      ...ClinicSpeciesFields
    }
    weight
    breed
    birthday
    avatar_url
  }
  client {
    id
    first_name
    last_name
  }
  appointment {
    id
    clinician {
      id
      name
    }
    service {
      id
      name
    }
  }
  clinician {
    id
    name
  }
  date
  assisting_clinicians
  master_problem_list
  subjective
  objective
  assessment
  plan
  public_notes
  service
  clinic {
    id
    name
  }
}
    ${ClinicSpeciesFieldsFragmentDoc}`;
export const PimsLookupPatientFieldsFragmentDoc = gql`
    fragment PimsLookupPatientFields on PimsLookupPatient {
  pms_id
  name
  species
  breed
  sex
  birthday
  is_active
  is_deceased
  patient_id
}
    `;
export const PimsLookupClientFieldsFragmentDoc = gql`
    fragment PimsLookupClientFields on PimsLookupClient {
  pms_id
  first_name
  last_name
  email
  phone
  address
  is_active
  client_id
  patients {
    ...PimsLookupPatientFields
  }
}
    ${PimsLookupPatientFieldsFragmentDoc}`;
export const PimsReminderDisplayFieldsFragmentDoc = gql`
    fragment PimsReminderDisplayFields on PimsReminder {
  id
  send_date
  display_due_date
  reminder_desc
  reminder_type {
    ...PimsReminderTypeFields
  }
  client {
    id
    first_name
    last_name
  }
  patient {
    id
    name
  }
}
    ${PimsReminderTypeFieldsFragmentDoc}`;
export const PatientPimsReminderFieldsFragmentDoc = gql`
    fragment PatientPimsReminderFields on PimsReminder {
  id
  send_date
  display_due_date
  is_active
  is_completed
  reminder_desc
  reminder_type {
    id
    display_name
    reminder_type_name
    is_active
  }
  patient {
    ...PatientDisplayFields
  }
}
    ${PatientDisplayFieldsFragmentDoc}`;
export const PimsSettingsFieldsFragmentDoc = gql`
    fragment PimsSettingsFields on PimsSettings {
  clinic {
    id
    name
  }
  username
  password
  pin
  api_key
  additional_key
  api_clinic_id
  api_subdomain
  pulse_sales_report_id
  pulse_ar_report_id
  pulse_reminders_report_id
  ezyvet_client_id
  ezyvet_client_secret
  ezyvet_site_uid
  ezyvet_scopes
  entered_by_pms_id
  payment_type_pms_id
  should_sync_clinician_hours
}
    `;
export const OnDemandPaymentTypeFieldsFragmentDoc = gql`
    fragment OnDemandPaymentTypeFields on OnDemandPaymentType {
  pms_id
  description
  is_credit_card
  is_inactive
}
    `;
export const PmsDbFieldsFragmentDoc = gql`
    fragment PmsDbFields on PmsDb {
  id
  name
  pms
  time_zone
  last_sync_times {
    last_full_sync
    last_sync_appointments
    last_sync_clients
    last_sync_patients
    last_sync_clinicians
    last_sync_services
    last_sync_transactions
    last_sync_invoices
    last_sync_history_items
    last_sync_diagnoses
    last_sync_prescriptions
    last_sync_products
    last_sync_rooms
    last_sync_species
    last_sync_breeds
    last_sync_reminders
    last_sync_reminder_types
    last_sync_vaccination_records
    last_sync_clinic_sexes
    last_sync_appt_statuses
    last_sync_blockoffs
    last_sync_invoice_items
  }
  created_at
  updated_at
}
    `;
export const PmsTagCategoryFieldsFragmentDoc = gql`
    fragment PmsTagCategoryFields on PmsTagCategory {
  id
  name
  pms_id
  pms_created_at
  pms_is_active
  last_synced_time
  created_at
  updated_at
}
    `;
export const PmsTagFieldsFragmentDoc = gql`
    fragment PmsTagFields on PmsTag {
  id
  pms_tag_category {
    ...PmsTagCategoryFields
  }
  name
  pms_id
  pms_created_at
  pms_is_active
  last_synced_time
  created_at
  updated_at
}
    ${PmsTagCategoryFieldsFragmentDoc}`;
export const PrescriptionFieldsFragmentDoc = gql`
    fragment PrescriptionFields on Prescription {
  id
  clinic {
    id
  }
  patient {
    id
    name
    owner {
      id
      first_name
      last_name
    }
  }
  name
  description
  product {
    id
    name
    description
    category
    unit
    volume
  }
  product_name
  quantity
  remaining
  last_refill_time
  is_active
  expiration_date
  refill_count
  refill_limit
  created_at
  updated_at
}
    `;
export const PressItemFieldsFragmentDoc = gql`
    fragment PressItemFields on PressItem {
  id
  title
  description
  image
  links {
    url
    type
  }
  created_at
  updated_at
}
    `;
export const ProductFieldsFragmentDoc = gql`
    fragment ProductFields on Product {
  id
  clinic {
    id
    name
  }
  pms_id
  name
  display_name
  description
  price
  chckvet_price
  cost
  additional_fees {
    name
    amount
  }
  prescription_fee_split_override
  category
  pims_category
  code
  is_active
  is_controlled
  unit
  volume
  created_at
  updated_at
}
    `;
export const PrescriptionPricingFieldsFragmentDoc = gql`
    fragment PrescriptionPricingFields on PrescriptionPricing {
  productId
  units
  unitPrice
  chckvetFeeSplitPercentage
  chckvetFeeTotal
  chckvetFeeClientPortion
  chckvetFeeClinicPortion
  stripeFee
  isStripeFeeChargedToClient
  amountBeforeStripeFee
  subtotal
  items {
    kind
    label
    amount
  }
}
    `;
export const PmsCodeFieldsFragmentDoc = gql`
    fragment PmsCodeFields on PmsCode {
  pms_id
  code_name
  description
  type
}
    `;
export const RescheduleAppointmentFieldsFragmentDoc = gql`
    fragment RescheduleAppointmentFields on Appointment {
  id
  service {
    name
  }
  service_name
  clinician {
    name
  }
  client {
    first_name
    last_name
  }
  patient {
    name
    clinic_species {
      species
    }
  }
  start_time
  minutes
}
    `;
export const ReviewPreviewFieldsFragmentDoc = gql`
    fragment ReviewPreviewFields on Review {
  id
  client {
    id
    first_name
    last_name
  }
  appointment {
    id
    service_name
    start_time
  }
  description
  overall_rating
  is_anonymous
  review_source
  created_at
}
    `;
export const ReviewAnalyticsFieldsFragmentDoc = gql`
    fragment ReviewAnalyticsFields on ReviewAnalytics {
  review_count
  average_rating
  sources {
    review_source
    review_count
    average_rating
  }
  request_conversion {
    clients_requested
    clients_reviewed
    conversion_rate
  }
}
    `;
export const RoomServiceFieldsFragmentDoc = gql`
    fragment RoomServiceFields on RoomService {
  id
  room {
    id
    name
    display_name
  }
  service {
    id
  }
  duration_override
  created_at
  updated_at
}
    `;
export const RoomPreviewFieldsFragmentDoc = gql`
    fragment RoomPreviewFields on Room {
  id
  name
  display_name
}
    `;
export const ScheduledBulkMessageFieldsFragmentDoc = gql`
    fragment ScheduledBulkMessageFields on ScheduledBulkMessage {
  id
  name
  clinic {
    id
  }
  clinic_group {
    id
    name
  }
  campaign {
    ...CampaignPreviewFields
  }
  email_template {
    ...EmailTemplateFields
  }
  send_time
  subject
  body
  email_body
  email_design
  email_html
  message_methods
  notif_attachments {
    id
    filename
    url
    type
  }
  customer_segment {
    ...CustomerSegmentFields
  }
  included_clients
  excluded_clients
  started_at
  is_active
  is_system
  is_completed
  is_archived
  is_marketing
  cta_url
  cta_text
  updated_at
  created_at
}
    ${CampaignPreviewFieldsFragmentDoc}
${EmailTemplateFieldsFragmentDoc}
${CustomerSegmentFieldsFragmentDoc}`;
export const LinkedBulkMessageChildFieldsFragmentDoc = gql`
    fragment LinkedBulkMessageChildFields on ScheduledBulkMessage {
  id
  is_active
  is_archived
  send_time
  started_at
  is_completed
  clinic {
    id
  }
  customer_segment {
    id
    name
  }
}
    `;
export const ScheduledMessageFieldsFragmentDoc = gql`
    fragment ScheduledMessageFields on ScheduledMessage {
  id
  clinic {
    id
  }
  created_by {
    id
    first_name
    last_name
  }
  chat {
    id
  }
  client {
    id
    first_name
    last_name
  }
  text
  email_text
  subject
  message_methods
  cta_url
  cta_text
  message_attachments {
    id
    filename
    url
    type
  }
  send_time
  status
  sent_at
  sent_message
  error
  cancelled_at
  cancelled_by
  created_at
  updated_at
}
    `;
export const CustomerSegmentBaseInfoFieldsFragmentDoc = gql`
    fragment CustomerSegmentBaseInfoFields on CustomerSegment {
  id
  name
  trigger_entity
  is_archived
}
    `;
export const SchedulingRulesFieldsFragmentDoc = gql`
    fragment SchedulingRulesFields on SchedulingRules {
  id
  clinic {
    id
  }
  widget {
    id
  }
  included_clinicians {
    id
    name
    display_name
    clinic {
      name
    }
  }
  included_species {
    id
    species
  }
  included_services {
    id
    name
    clinic {
      name
    }
  }
  included_rooms {
    id
    name
    display_name
    clinic {
      name
    }
  }
  included_client_audiences {
    ...CustomerSegmentBaseInfoFields
  }
  included_patient_audiences {
    ...CustomerSegmentBaseInfoFields
  }
  max_per_rule
  is_active
  patient_type
  client_type
  patient_gender
  fixed_status
  availability {
    ...AvailabilityDayFields
  }
  adjusted_availability {
    ...AdjustedAvailabilityFields
  }
  only_modifier
  is_simple_rule
  created_at
  updated_at
}
    ${CustomerSegmentBaseInfoFieldsFragmentDoc}
${AvailabilityDayFieldsFragmentDoc}
${AdjustedAvailabilityFieldsFragmentDoc}`;
export const SchedulingRulesCategorizedFieldsFragmentDoc = gql`
    fragment SchedulingRulesCategorizedFields on SchedulingRulesCategorized {
  not_applicable_rule_ids
  applicable_but_not_passed_rule_ids
  passed_rule_ids
}
    `;
export const FormFieldsFragmentDoc = gql`
    fragment FormFields on Form {
  id
  name
  form_type
  clinic {
    id
  }
  form_fields {
    pages {
      ...FormPageFields
    }
    fields {
      ...FormElementFields
    }
  }
  is_public
  is_active
  is_archived
  does_require_client
  does_require_patient
  writeback_to_strictest_entity
  is_writeback_enabled
  writeback_code_pms_id
  writeback_code_name
  form_file_naming_template
  created_at
  updated_at
}
    ${FormPageFieldsFragmentDoc}
${FormElementFieldsFragmentDoc}`;
export const ServiceFormFieldsFragmentDoc = gql`
    fragment ServiceFormFields on ServiceForm {
  id
  form {
    ...FormFields
  }
  service {
    id
    name
  }
  is_required_before_booking
  is_required_before_confirming
  client_type
  created_at
  updated_at
}
    ${FormFieldsFragmentDoc}`;
export const ServicePreviewFieldsFragmentDoc = gql`
    fragment ServicePreviewFields on Service {
  id
  name
  duration
}
    `;
export const StripeAccountInfoFieldsFragmentDoc = gql`
    fragment StripeAccountInfoFields on StripeAccountInfo {
  onboarding_link
  login_link
  is_onboarded
  requirements {
    current_deadline
    currently_due
    disabled_reason
    eventually_due
    past_due
    pending_verification
  }
  future_requirements {
    current_deadline
    currently_due
    disabled_reason
    eventually_due
    past_due
    pending_verification
  }
}
    `;
export const SupportBotConversationOwnerFieldsFragmentDoc = gql`
    fragment SupportBotConversationOwnerFields on SupportBotConversationOwner {
  id
  name
  email
}
    `;
export const SupportBotMessageAttachmentFieldsFragmentDoc = gql`
    fragment SupportBotMessageAttachmentFields on SupportBotMessageAttachment {
  url
  kind
  mimeType
  width
  height
  filename
}
    `;
export const SupportBotMessageFieldsFragmentDoc = gql`
    fragment SupportBotMessageFields on SupportBotMessage {
  role
  content
  timestamp
  status
  cutoffReason
  attachments {
    ...SupportBotMessageAttachmentFields
  }
}
    ${SupportBotMessageAttachmentFieldsFragmentDoc}`;
export const SupportBotConversationFieldsFragmentDoc = gql`
    fragment SupportBotConversationFields on SupportBotConversation {
  id
  title
  createdAt
  updatedAt
  pendingRunId
  owner {
    ...SupportBotConversationOwnerFields
  }
  messages {
    ...SupportBotMessageFields
  }
}
    ${SupportBotConversationOwnerFieldsFragmentDoc}
${SupportBotMessageFieldsFragmentDoc}`;
export const SupportBotRunSnapshotFieldsFragmentDoc = gql`
    fragment SupportBotRunSnapshotFields on SupportBotRunSnapshot {
  runId
  conversationId
  status
  startedAt
  assistantTextSoFar
  toolCallCount
  approxTokens
  finishedAt
  durationMs
  response
  cutoffReason
  errorMessage
  cursorRunId
  conversation {
    ...SupportBotConversationFields
  }
}
    ${SupportBotConversationFieldsFragmentDoc}`;
export const FillRateResultFieldsFragmentDoc = gql`
    fragment FillRateResultFields on FillRateResult {
  clinic_id
  clinician_id
  room_id
  fill_rate
  open_minutes
  working_minutes
}
    `;
export const TransactionFieldsFragmentDoc = gql`
    fragment TransactionFields on Transaction {
  id
  clinic_id
  date
  amount
  type
}
    `;
export const UserTrackingMetricFieldsFragmentDoc = gql`
    fragment UserTrackingMetricFields on UserTrackingMetricResult {
  metric
  numerator_count
  denominator_count
  percentage
}
    `;
export const WidgetOptionsFieldsFragmentDoc = gql`
    fragment WidgetOptionsFields on WidgetOptions {
  id
  widget {
    id
  }
  enabled
  widget_access_start_time
  widget_access_end_time
  booking_avail_start
  booking_avail_end
  redirect_after_booking_url
  redirect_countdown_seconds
  scheduling_buffer_minutes
  scheduling_min_minutes_away
  scheduling_max_minutes_away
  hide_clinician_preference
  default_trigger_words
  custom_well_description
  custom_sick_description
  custom_other_title
  custom_other_description
  custom_booking_copy {
    ...ClinicBookingCopyFields
  }
  should_allow_new_clients
  should_allow_new_patients
  should_allow_returning_clients
  should_allow_returning_patients
  widget_referral_code
  gtm_container_id
  primary_clinic_group_id
  should_suggest_nearby_clinics
  times_first_filter_config {
    service
    clinician
    species
    client_status
    patient_status
    patient_gender
    fixed_status
  }
  created_at
  updated_at
}
    ${ClinicBookingCopyFieldsFragmentDoc}`;
export const WidgetServiceFieldsFragmentDoc = gql`
    fragment WidgetServiceFields on WidgetService {
  id
  widget {
    id
  }
  service {
    ...ServiceFields
  }
  is_active
  created_at
  updated_at
}
    ${ServiceFieldsFragmentDoc}`;
export const WidgetPreviewFieldsFragmentDoc = gql`
    fragment WidgetPreviewFields on Widget {
  id
  widget_name
  type
  widget_options {
    should_allow_new_clients
    should_allow_new_patients
    should_allow_returning_clients
    should_allow_returning_patients
    widget_access_start_time
    widget_access_end_time
    booking_avail_end
    scheduling_min_minutes_away
    scheduling_max_minutes_away
    enabled
  }
}
    `;
export const ClinicGroupPreviewFieldsFragmentDoc = gql`
    fragment ClinicGroupPreviewFields on ClinicGroup {
  id
  name
  slug
  clinic_group_clinics {
    ...ClinicGroupClinicFields
  }
}
    ${ClinicGroupClinicFieldsFragmentDoc}`;
export const ClinicImageMapFieldsFragmentDoc = gql`
    fragment ClinicImageMapFields on ClinicImageMap {
  clinic_id
  image_url
}
    `;
export const WidgetStylesFieldsFragmentDoc = gql`
    fragment WidgetStylesFields on WidgetStyles {
  header_color
  header_text_color
  footer_color
  footer_text_color
  floating_margin_bottom
  floating_margin_right
  clinic_order {
    clinic_id
    order
  }
  service_order {
    service_id
    order
  }
  include_service_categories_with_custom_order
  heading_color
  heading_font
  background_color
  card_color
  button_color
  button_text_color
  clinic_image_map {
    ...ClinicImageMapFields
  }
  text_color
  reviews_name_color
  reviews_stars_color
  reviews_date_color
  reviews_text_color
  reviews_arrow_background
  reviews_arrow_color
  reviews_title_text
}
    ${ClinicImageMapFieldsFragmentDoc}`;
export const ReviewFieldsFragmentDoc = gql`
    fragment ReviewFields on Review {
  id
  client {
    id
    first_name
    last_name
    email
    phone
    address {
      ...AddressFields
    }
  }
  appointment {
    id
  }
  clinic {
    id
    name
    address {
      ...AddressFields
    }
    settings {
      review_google_id
      review_facebook_id
    }
  }
  description
  overall_rating
  is_anonymous
  review_submitted_at
  review_source
  external_id
  external_author_name
  external_author_image
  external_rating
  external_text
  external_timestamp
  external_review_url
  external_owner_response
  external_owner_response_timestamp
  created_at
  updated_at
}
    ${AddressFieldsFragmentDoc}`;
export const WidgetFeaturedReviewFieldsFragmentDoc = gql`
    fragment WidgetFeaturedReviewFields on FeaturedReview {
  review {
    ...ReviewFields
  }
  order
}
    ${ReviewFieldsFragmentDoc}`;
export const WidgetFieldsFragmentDoc = gql`
    fragment WidgetFields on Widget {
  id
  clinic {
    id
    name
    slug
  }
  organization {
    id
    name
    slug
  }
  clinic_group {
    ...ClinicGroupPreviewFields
  }
  campaign {
    ...CampaignPreviewFields
  }
  widget_name
  type
  trigger_type
  button_color
  button_text
  text_color
  is_external
  is_active
  is_archived
  is_default_portal
  enabled_chat_buttons
  average_chat_response_time
  source
  widget_styles {
    ...WidgetStylesFields
  }
  featured_reviews {
    ...WidgetFeaturedReviewFields
  }
  created_at
  updated_at
}
    ${ClinicGroupPreviewFieldsFragmentDoc}
${CampaignPreviewFieldsFragmentDoc}
${WidgetStylesFieldsFragmentDoc}
${WidgetFeaturedReviewFieldsFragmentDoc}`;
export const WidgetWithServicesFieldsFragmentDoc = gql`
    fragment WidgetWithServicesFields on Widget {
  ...WidgetFields
  widgets_services {
    service {
      ...ServiceFields
    }
  }
}
    ${WidgetFieldsFragmentDoc}
${ServiceFieldsFragmentDoc}`;
export const GetActionItemDocument = gql`
    query getActionItem($id: ID!) {
  actionItem(id: $id) {
    ...ActionItemFields
  }
}
    ${ActionItemFieldsFragmentDoc}`;

/**
 * __useGetActionItemQuery__
 *
 * To run a query within a React component, call `useGetActionItemQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetActionItemQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetActionItemQuery({
 *   variables: {
 *      id: // value for 'id'
 *   },
 * });
 */
export function useGetActionItemQuery(baseOptions: Apollo.QueryHookOptions<GetActionItemQuery, GetActionItemQueryVariables> & ({ variables: GetActionItemQueryVariables; skip?: boolean; } | { skip: boolean; }) ) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<GetActionItemQuery, GetActionItemQueryVariables>(GetActionItemDocument, options);
      }
export function useGetActionItemLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<GetActionItemQuery, GetActionItemQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<GetActionItemQuery, GetActionItemQueryVariables>(GetActionItemDocument, options);
        }
export function useGetActionItemSuspenseQuery(baseOptions?: Apollo.SuspenseQueryHookOptions<GetActionItemQuery, GetActionItemQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useSuspenseQuery<GetActionItemQuery, GetActionItemQueryVariables>(GetActionItemDocument, options);
        }
export type GetActionItemQueryHookResult = ReturnType<typeof useGetActionItemQuery>;
export type GetActionItemLazyQueryHookResult = ReturnType<typeof useGetActionItemLazyQuery>;
export type GetActionItemSuspenseQueryHookResult = ReturnType<typeof useGetActionItemSuspenseQuery>;
export type GetActionItemQueryResult = Apollo.QueryResult<GetActionItemQuery, GetActionItemQueryVariables>;
export const QueryActionItemsDocument = gql`
    query queryActionItems($where: [QueryInput!], $page: NonNegativeInt, $pageSize: NonNegativeInt, $orderBy: OrderByInput) {
  queryActionItems(
    where: $where
    page: $page
    pageSize: $pageSize
    orderBy: $orderBy
  ) {
    ...ActionItemFields
  }
}
    ${ActionItemFieldsFragmentDoc}`;

/**
 * __useQueryActionItemsQuery__
 *
 * To run a query within a React component, call `useQueryActionItemsQuery` and pass it any options that fit your needs.
 * When your component renders, `useQueryActionItemsQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useQueryActionItemsQuery({
 *   variables: {
 *      where: // value for 'where'
 *      page: // value for 'page'
 *      pageSize: // value for 'pageSize'
 *      orderBy: // value for 'orderBy'
 *   },
 * });
 */
export function useQueryActionItemsQuery(baseOptions?: Apollo.QueryHookOptions<QueryActionItemsQuery, QueryActionItemsQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<QueryActionItemsQuery, QueryActionItemsQueryVariables>(QueryActionItemsDocument, options);
      }
export function useQueryActionItemsLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<QueryActionItemsQuery, QueryActionItemsQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<QueryActionItemsQuery, QueryActionItemsQueryVariables>(QueryActionItemsDocument, options);
        }
export function useQueryActionItemsSuspenseQuery(baseOptions?: Apollo.SuspenseQueryHookOptions<QueryActionItemsQuery, QueryActionItemsQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useSuspenseQuery<QueryActionItemsQuery, QueryActionItemsQueryVariables>(QueryActionItemsDocument, options);
        }
export type QueryActionItemsQueryHookResult = ReturnType<typeof useQueryActionItemsQuery>;
export type QueryActionItemsLazyQueryHookResult = ReturnType<typeof useQueryActionItemsLazyQuery>;
export type QueryActionItemsSuspenseQueryHookResult = ReturnType<typeof useQueryActionItemsSuspenseQuery>;
export type QueryActionItemsQueryResult = Apollo.QueryResult<QueryActionItemsQuery, QueryActionItemsQueryVariables>;
export const CountActionItemsDocument = gql`
    query countActionItems($where: [QueryInput!]) {
  countActionItems(where: $where)
}
    `;

/**
 * __useCountActionItemsQuery__
 *
 * To run a query within a React component, call `useCountActionItemsQuery` and pass it any options that fit your needs.
 * When your component renders, `useCountActionItemsQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useCountActionItemsQuery({
 *   variables: {
 *      where: // value for 'where'
 *   },
 * });
 */
export function useCountActionItemsQuery(baseOptions?: Apollo.QueryHookOptions<CountActionItemsQuery, CountActionItemsQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<CountActionItemsQuery, CountActionItemsQueryVariables>(CountActionItemsDocument, options);
      }
export function useCountActionItemsLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<CountActionItemsQuery, CountActionItemsQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<CountActionItemsQuery, CountActionItemsQueryVariables>(CountActionItemsDocument, options);
        }
export function useCountActionItemsSuspenseQuery(baseOptions?: Apollo.SuspenseQueryHookOptions<CountActionItemsQuery, CountActionItemsQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useSuspenseQuery<CountActionItemsQuery, CountActionItemsQueryVariables>(CountActionItemsDocument, options);
        }
export type CountActionItemsQueryHookResult = ReturnType<typeof useCountActionItemsQuery>;
export type CountActionItemsLazyQueryHookResult = ReturnType<typeof useCountActionItemsLazyQuery>;
export type CountActionItemsSuspenseQueryHookResult = ReturnType<typeof useCountActionItemsSuspenseQuery>;
export type CountActionItemsQueryResult = Apollo.QueryResult<CountActionItemsQuery, CountActionItemsQueryVariables>;
export const QueryAppointmentActionItemsDocument = gql`
    query queryAppointmentActionItems($where: [QueryInput!], $page: NonNegativeInt, $pageSize: NonNegativeInt, $orderBy: OrderByInput) {
  queryAppointments(
    where: $where
    page: $page
    pageSize: $pageSize
    orderBy: $orderBy
  ) {
    ...AppointmentWithActionItemsFields
  }
}
    ${AppointmentWithActionItemsFieldsFragmentDoc}`;

/**
 * __useQueryAppointmentActionItemsQuery__
 *
 * To run a query within a React component, call `useQueryAppointmentActionItemsQuery` and pass it any options that fit your needs.
 * When your component renders, `useQueryAppointmentActionItemsQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useQueryAppointmentActionItemsQuery({
 *   variables: {
 *      where: // value for 'where'
 *      page: // value for 'page'
 *      pageSize: // value for 'pageSize'
 *      orderBy: // value for 'orderBy'
 *   },
 * });
 */
export function useQueryAppointmentActionItemsQuery(baseOptions?: Apollo.QueryHookOptions<QueryAppointmentActionItemsQuery, QueryAppointmentActionItemsQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<QueryAppointmentActionItemsQuery, QueryAppointmentActionItemsQueryVariables>(QueryAppointmentActionItemsDocument, options);
      }
export function useQueryAppointmentActionItemsLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<QueryAppointmentActionItemsQuery, QueryAppointmentActionItemsQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<QueryAppointmentActionItemsQuery, QueryAppointmentActionItemsQueryVariables>(QueryAppointmentActionItemsDocument, options);
        }
export function useQueryAppointmentActionItemsSuspenseQuery(baseOptions?: Apollo.SuspenseQueryHookOptions<QueryAppointmentActionItemsQuery, QueryAppointmentActionItemsQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useSuspenseQuery<QueryAppointmentActionItemsQuery, QueryAppointmentActionItemsQueryVariables>(QueryAppointmentActionItemsDocument, options);
        }
export type QueryAppointmentActionItemsQueryHookResult = ReturnType<typeof useQueryAppointmentActionItemsQuery>;
export type QueryAppointmentActionItemsLazyQueryHookResult = ReturnType<typeof useQueryAppointmentActionItemsLazyQuery>;
export type QueryAppointmentActionItemsSuspenseQueryHookResult = ReturnType<typeof useQueryAppointmentActionItemsSuspenseQuery>;
export type QueryAppointmentActionItemsQueryResult = Apollo.QueryResult<QueryAppointmentActionItemsQuery, QueryAppointmentActionItemsQueryVariables>;
export const QueryRescheduleActionItemsDocument = gql`
    query queryRescheduleActionItems($where: [QueryInput!], $page: NonNegativeInt, $pageSize: NonNegativeInt, $orderBy: OrderByInput) {
  queryReschedules(
    where: $where
    page: $page
    pageSize: $pageSize
    orderBy: $orderBy
  ) {
    ...RescheduleWithActionItemsFields
  }
}
    ${RescheduleWithActionItemsFieldsFragmentDoc}`;

/**
 * __useQueryRescheduleActionItemsQuery__
 *
 * To run a query within a React component, call `useQueryRescheduleActionItemsQuery` and pass it any options that fit your needs.
 * When your component renders, `useQueryRescheduleActionItemsQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useQueryRescheduleActionItemsQuery({
 *   variables: {
 *      where: // value for 'where'
 *      page: // value for 'page'
 *      pageSize: // value for 'pageSize'
 *      orderBy: // value for 'orderBy'
 *   },
 * });
 */
export function useQueryRescheduleActionItemsQuery(baseOptions?: Apollo.QueryHookOptions<QueryRescheduleActionItemsQuery, QueryRescheduleActionItemsQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<QueryRescheduleActionItemsQuery, QueryRescheduleActionItemsQueryVariables>(QueryRescheduleActionItemsDocument, options);
      }
export function useQueryRescheduleActionItemsLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<QueryRescheduleActionItemsQuery, QueryRescheduleActionItemsQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<QueryRescheduleActionItemsQuery, QueryRescheduleActionItemsQueryVariables>(QueryRescheduleActionItemsDocument, options);
        }
export function useQueryRescheduleActionItemsSuspenseQuery(baseOptions?: Apollo.SuspenseQueryHookOptions<QueryRescheduleActionItemsQuery, QueryRescheduleActionItemsQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useSuspenseQuery<QueryRescheduleActionItemsQuery, QueryRescheduleActionItemsQueryVariables>(QueryRescheduleActionItemsDocument, options);
        }
export type QueryRescheduleActionItemsQueryHookResult = ReturnType<typeof useQueryRescheduleActionItemsQuery>;
export type QueryRescheduleActionItemsLazyQueryHookResult = ReturnType<typeof useQueryRescheduleActionItemsLazyQuery>;
export type QueryRescheduleActionItemsSuspenseQueryHookResult = ReturnType<typeof useQueryRescheduleActionItemsSuspenseQuery>;
export type QueryRescheduleActionItemsQueryResult = Apollo.QueryResult<QueryRescheduleActionItemsQuery, QueryRescheduleActionItemsQueryVariables>;
export const UpdateActionItemDocument = gql`
    mutation updateActionItem($id: ID!, $data: UpdateActionItemInput!) {
  updateActionItem(id: $id, data: $data) {
    ...ActionItemFields
  }
}
    ${ActionItemFieldsFragmentDoc}`;
export type UpdateActionItemMutationFn = Apollo.MutationFunction<UpdateActionItemMutation, UpdateActionItemMutationVariables>;

/**
 * __useUpdateActionItemMutation__
 *
 * To run a mutation, you first call `useUpdateActionItemMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useUpdateActionItemMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [updateActionItemMutation, { data, loading, error }] = useUpdateActionItemMutation({
 *   variables: {
 *      id: // value for 'id'
 *      data: // value for 'data'
 *   },
 * });
 */
export function useUpdateActionItemMutation(baseOptions?: Apollo.MutationHookOptions<UpdateActionItemMutation, UpdateActionItemMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<UpdateActionItemMutation, UpdateActionItemMutationVariables>(UpdateActionItemDocument, options);
      }
export type UpdateActionItemMutationHookResult = ReturnType<typeof useUpdateActionItemMutation>;
export type UpdateActionItemMutationResult = Apollo.MutationResult<UpdateActionItemMutation>;
export type UpdateActionItemMutationOptions = Apollo.BaseMutationOptions<UpdateActionItemMutation, UpdateActionItemMutationVariables>;
export const ListAiVoiceOptionsDocument = gql`
    query listAiVoiceOptions {
  listAiVoiceOptions {
    ...AiVoiceOptionFields
  }
}
    ${AiVoiceOptionFieldsFragmentDoc}`;

/**
 * __useListAiVoiceOptionsQuery__
 *
 * To run a query within a React component, call `useListAiVoiceOptionsQuery` and pass it any options that fit your needs.
 * When your component renders, `useListAiVoiceOptionsQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useListAiVoiceOptionsQuery({
 *   variables: {
 *   },
 * });
 */
export function useListAiVoiceOptionsQuery(baseOptions?: Apollo.QueryHookOptions<ListAiVoiceOptionsQuery, ListAiVoiceOptionsQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<ListAiVoiceOptionsQuery, ListAiVoiceOptionsQueryVariables>(ListAiVoiceOptionsDocument, options);
      }
export function useListAiVoiceOptionsLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<ListAiVoiceOptionsQuery, ListAiVoiceOptionsQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<ListAiVoiceOptionsQuery, ListAiVoiceOptionsQueryVariables>(ListAiVoiceOptionsDocument, options);
        }
export function useListAiVoiceOptionsSuspenseQuery(baseOptions?: Apollo.SuspenseQueryHookOptions<ListAiVoiceOptionsQuery, ListAiVoiceOptionsQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useSuspenseQuery<ListAiVoiceOptionsQuery, ListAiVoiceOptionsQueryVariables>(ListAiVoiceOptionsDocument, options);
        }
export type ListAiVoiceOptionsQueryHookResult = ReturnType<typeof useListAiVoiceOptionsQuery>;
export type ListAiVoiceOptionsLazyQueryHookResult = ReturnType<typeof useListAiVoiceOptionsLazyQuery>;
export type ListAiVoiceOptionsSuspenseQueryHookResult = ReturnType<typeof useListAiVoiceOptionsSuspenseQuery>;
export type ListAiVoiceOptionsQueryResult = Apollo.QueryResult<ListAiVoiceOptionsQuery, ListAiVoiceOptionsQueryVariables>;
export const GetAiAgentPromptForClinicDocument = gql`
    query getAiAgentPromptForClinic($clinicId: ID!) {
  getAiAgentPromptForClinic(clinicId: $clinicId) {
    ...AiAgentPromptFields
  }
}
    ${AiAgentPromptFieldsFragmentDoc}`;

/**
 * __useGetAiAgentPromptForClinicQuery__
 *
 * To run a query within a React component, call `useGetAiAgentPromptForClinicQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetAiAgentPromptForClinicQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetAiAgentPromptForClinicQuery({
 *   variables: {
 *      clinicId: // value for 'clinicId'
 *   },
 * });
 */
export function useGetAiAgentPromptForClinicQuery(baseOptions: Apollo.QueryHookOptions<GetAiAgentPromptForClinicQuery, GetAiAgentPromptForClinicQueryVariables> & ({ variables: GetAiAgentPromptForClinicQueryVariables; skip?: boolean; } | { skip: boolean; }) ) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<GetAiAgentPromptForClinicQuery, GetAiAgentPromptForClinicQueryVariables>(GetAiAgentPromptForClinicDocument, options);
      }
export function useGetAiAgentPromptForClinicLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<GetAiAgentPromptForClinicQuery, GetAiAgentPromptForClinicQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<GetAiAgentPromptForClinicQuery, GetAiAgentPromptForClinicQueryVariables>(GetAiAgentPromptForClinicDocument, options);
        }
export function useGetAiAgentPromptForClinicSuspenseQuery(baseOptions?: Apollo.SuspenseQueryHookOptions<GetAiAgentPromptForClinicQuery, GetAiAgentPromptForClinicQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useSuspenseQuery<GetAiAgentPromptForClinicQuery, GetAiAgentPromptForClinicQueryVariables>(GetAiAgentPromptForClinicDocument, options);
        }
export type GetAiAgentPromptForClinicQueryHookResult = ReturnType<typeof useGetAiAgentPromptForClinicQuery>;
export type GetAiAgentPromptForClinicLazyQueryHookResult = ReturnType<typeof useGetAiAgentPromptForClinicLazyQuery>;
export type GetAiAgentPromptForClinicSuspenseQueryHookResult = ReturnType<typeof useGetAiAgentPromptForClinicSuspenseQuery>;
export type GetAiAgentPromptForClinicQueryResult = Apollo.QueryResult<GetAiAgentPromptForClinicQuery, GetAiAgentPromptForClinicQueryVariables>;
export const UpdateAiAgentPlaybookForClinicDocument = gql`
    mutation updateAiAgentPlaybookForClinic($clinicId: ID!, $playbook: String) {
  updateAiAgentPlaybookForClinic(clinicId: $clinicId, playbook: $playbook) {
    ...AiAgentPromptFields
  }
}
    ${AiAgentPromptFieldsFragmentDoc}`;
export type UpdateAiAgentPlaybookForClinicMutationFn = Apollo.MutationFunction<UpdateAiAgentPlaybookForClinicMutation, UpdateAiAgentPlaybookForClinicMutationVariables>;

/**
 * __useUpdateAiAgentPlaybookForClinicMutation__
 *
 * To run a mutation, you first call `useUpdateAiAgentPlaybookForClinicMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useUpdateAiAgentPlaybookForClinicMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [updateAiAgentPlaybookForClinicMutation, { data, loading, error }] = useUpdateAiAgentPlaybookForClinicMutation({
 *   variables: {
 *      clinicId: // value for 'clinicId'
 *      playbook: // value for 'playbook'
 *   },
 * });
 */
export function useUpdateAiAgentPlaybookForClinicMutation(baseOptions?: Apollo.MutationHookOptions<UpdateAiAgentPlaybookForClinicMutation, UpdateAiAgentPlaybookForClinicMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<UpdateAiAgentPlaybookForClinicMutation, UpdateAiAgentPlaybookForClinicMutationVariables>(UpdateAiAgentPlaybookForClinicDocument, options);
      }
export type UpdateAiAgentPlaybookForClinicMutationHookResult = ReturnType<typeof useUpdateAiAgentPlaybookForClinicMutation>;
export type UpdateAiAgentPlaybookForClinicMutationResult = Apollo.MutationResult<UpdateAiAgentPlaybookForClinicMutation>;
export type UpdateAiAgentPlaybookForClinicMutationOptions = Apollo.BaseMutationOptions<UpdateAiAgentPlaybookForClinicMutation, UpdateAiAgentPlaybookForClinicMutationVariables>;
export const SuggestAiAgentPlaybookEditDocument = gql`
    mutation suggestAiAgentPlaybookEdit($clinicId: ID!, $instruction: String!, $currentPlaybook: String!) {
  suggestAiAgentPlaybookEdit(
    clinicId: $clinicId
    instruction: $instruction
    currentPlaybook: $currentPlaybook
  ) {
    proposed_playbook
    summary
    warnings
  }
}
    `;
export type SuggestAiAgentPlaybookEditMutationFn = Apollo.MutationFunction<SuggestAiAgentPlaybookEditMutation, SuggestAiAgentPlaybookEditMutationVariables>;

/**
 * __useSuggestAiAgentPlaybookEditMutation__
 *
 * To run a mutation, you first call `useSuggestAiAgentPlaybookEditMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useSuggestAiAgentPlaybookEditMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [suggestAiAgentPlaybookEditMutation, { data, loading, error }] = useSuggestAiAgentPlaybookEditMutation({
 *   variables: {
 *      clinicId: // value for 'clinicId'
 *      instruction: // value for 'instruction'
 *      currentPlaybook: // value for 'currentPlaybook'
 *   },
 * });
 */
export function useSuggestAiAgentPlaybookEditMutation(baseOptions?: Apollo.MutationHookOptions<SuggestAiAgentPlaybookEditMutation, SuggestAiAgentPlaybookEditMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<SuggestAiAgentPlaybookEditMutation, SuggestAiAgentPlaybookEditMutationVariables>(SuggestAiAgentPlaybookEditDocument, options);
      }
export type SuggestAiAgentPlaybookEditMutationHookResult = ReturnType<typeof useSuggestAiAgentPlaybookEditMutation>;
export type SuggestAiAgentPlaybookEditMutationResult = Apollo.MutationResult<SuggestAiAgentPlaybookEditMutation>;
export type SuggestAiAgentPlaybookEditMutationOptions = Apollo.BaseMutationOptions<SuggestAiAgentPlaybookEditMutation, SuggestAiAgentPlaybookEditMutationVariables>;
export const GetAiPromptSuggestionsForClinicDocument = gql`
    query getAiPromptSuggestionsForClinic($clinicId: ID!, $status: AiImprovementStatus) {
  getAiPromptSuggestionsForClinic(clinicId: $clinicId, status: $status) {
    agent_type
    items {
      ...AiImprovementItemFields
    }
  }
}
    ${AiImprovementItemFieldsFragmentDoc}`;

/**
 * __useGetAiPromptSuggestionsForClinicQuery__
 *
 * To run a query within a React component, call `useGetAiPromptSuggestionsForClinicQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetAiPromptSuggestionsForClinicQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetAiPromptSuggestionsForClinicQuery({
 *   variables: {
 *      clinicId: // value for 'clinicId'
 *      status: // value for 'status'
 *   },
 * });
 */
export function useGetAiPromptSuggestionsForClinicQuery(baseOptions: Apollo.QueryHookOptions<GetAiPromptSuggestionsForClinicQuery, GetAiPromptSuggestionsForClinicQueryVariables> & ({ variables: GetAiPromptSuggestionsForClinicQueryVariables; skip?: boolean; } | { skip: boolean; }) ) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<GetAiPromptSuggestionsForClinicQuery, GetAiPromptSuggestionsForClinicQueryVariables>(GetAiPromptSuggestionsForClinicDocument, options);
      }
export function useGetAiPromptSuggestionsForClinicLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<GetAiPromptSuggestionsForClinicQuery, GetAiPromptSuggestionsForClinicQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<GetAiPromptSuggestionsForClinicQuery, GetAiPromptSuggestionsForClinicQueryVariables>(GetAiPromptSuggestionsForClinicDocument, options);
        }
export function useGetAiPromptSuggestionsForClinicSuspenseQuery(baseOptions?: Apollo.SuspenseQueryHookOptions<GetAiPromptSuggestionsForClinicQuery, GetAiPromptSuggestionsForClinicQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useSuspenseQuery<GetAiPromptSuggestionsForClinicQuery, GetAiPromptSuggestionsForClinicQueryVariables>(GetAiPromptSuggestionsForClinicDocument, options);
        }
export type GetAiPromptSuggestionsForClinicQueryHookResult = ReturnType<typeof useGetAiPromptSuggestionsForClinicQuery>;
export type GetAiPromptSuggestionsForClinicLazyQueryHookResult = ReturnType<typeof useGetAiPromptSuggestionsForClinicLazyQuery>;
export type GetAiPromptSuggestionsForClinicSuspenseQueryHookResult = ReturnType<typeof useGetAiPromptSuggestionsForClinicSuspenseQuery>;
export type GetAiPromptSuggestionsForClinicQueryResult = Apollo.QueryResult<GetAiPromptSuggestionsForClinicQuery, GetAiPromptSuggestionsForClinicQueryVariables>;
export const PreviewAiImprovementItemDocument = gql`
    mutation previewAiImprovementItem($itemId: ID!, $answer: String!) {
  previewAiImprovementItem(itemId: $itemId, answer: $answer) {
    current_playbook
    proposed_playbook
    summary
    warnings
  }
}
    `;
export type PreviewAiImprovementItemMutationFn = Apollo.MutationFunction<PreviewAiImprovementItemMutation, PreviewAiImprovementItemMutationVariables>;

/**
 * __usePreviewAiImprovementItemMutation__
 *
 * To run a mutation, you first call `usePreviewAiImprovementItemMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `usePreviewAiImprovementItemMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [previewAiImprovementItemMutation, { data, loading, error }] = usePreviewAiImprovementItemMutation({
 *   variables: {
 *      itemId: // value for 'itemId'
 *      answer: // value for 'answer'
 *   },
 * });
 */
export function usePreviewAiImprovementItemMutation(baseOptions?: Apollo.MutationHookOptions<PreviewAiImprovementItemMutation, PreviewAiImprovementItemMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<PreviewAiImprovementItemMutation, PreviewAiImprovementItemMutationVariables>(PreviewAiImprovementItemDocument, options);
      }
export type PreviewAiImprovementItemMutationHookResult = ReturnType<typeof usePreviewAiImprovementItemMutation>;
export type PreviewAiImprovementItemMutationResult = Apollo.MutationResult<PreviewAiImprovementItemMutation>;
export type PreviewAiImprovementItemMutationOptions = Apollo.BaseMutationOptions<PreviewAiImprovementItemMutation, PreviewAiImprovementItemMutationVariables>;
export const ApplyAiImprovementItemDocument = gql`
    mutation applyAiImprovementItem($itemId: ID!) {
  applyAiImprovementItem(itemId: $itemId) {
    ...AiImprovementItemFields
  }
}
    ${AiImprovementItemFieldsFragmentDoc}`;
export type ApplyAiImprovementItemMutationFn = Apollo.MutationFunction<ApplyAiImprovementItemMutation, ApplyAiImprovementItemMutationVariables>;

/**
 * __useApplyAiImprovementItemMutation__
 *
 * To run a mutation, you first call `useApplyAiImprovementItemMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useApplyAiImprovementItemMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [applyAiImprovementItemMutation, { data, loading, error }] = useApplyAiImprovementItemMutation({
 *   variables: {
 *      itemId: // value for 'itemId'
 *   },
 * });
 */
export function useApplyAiImprovementItemMutation(baseOptions?: Apollo.MutationHookOptions<ApplyAiImprovementItemMutation, ApplyAiImprovementItemMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<ApplyAiImprovementItemMutation, ApplyAiImprovementItemMutationVariables>(ApplyAiImprovementItemDocument, options);
      }
export type ApplyAiImprovementItemMutationHookResult = ReturnType<typeof useApplyAiImprovementItemMutation>;
export type ApplyAiImprovementItemMutationResult = Apollo.MutationResult<ApplyAiImprovementItemMutation>;
export type ApplyAiImprovementItemMutationOptions = Apollo.BaseMutationOptions<ApplyAiImprovementItemMutation, ApplyAiImprovementItemMutationVariables>;
export const DismissAiImprovementItemDocument = gql`
    mutation dismissAiImprovementItem($itemId: ID!) {
  dismissAiImprovementItem(itemId: $itemId) {
    ...AiImprovementItemFields
  }
}
    ${AiImprovementItemFieldsFragmentDoc}`;
export type DismissAiImprovementItemMutationFn = Apollo.MutationFunction<DismissAiImprovementItemMutation, DismissAiImprovementItemMutationVariables>;

/**
 * __useDismissAiImprovementItemMutation__
 *
 * To run a mutation, you first call `useDismissAiImprovementItemMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useDismissAiImprovementItemMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [dismissAiImprovementItemMutation, { data, loading, error }] = useDismissAiImprovementItemMutation({
 *   variables: {
 *      itemId: // value for 'itemId'
 *   },
 * });
 */
export function useDismissAiImprovementItemMutation(baseOptions?: Apollo.MutationHookOptions<DismissAiImprovementItemMutation, DismissAiImprovementItemMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<DismissAiImprovementItemMutation, DismissAiImprovementItemMutationVariables>(DismissAiImprovementItemDocument, options);
      }
export type DismissAiImprovementItemMutationHookResult = ReturnType<typeof useDismissAiImprovementItemMutation>;
export type DismissAiImprovementItemMutationResult = Apollo.MutationResult<DismissAiImprovementItemMutation>;
export type DismissAiImprovementItemMutationOptions = Apollo.BaseMutationOptions<DismissAiImprovementItemMutation, DismissAiImprovementItemMutationVariables>;
export const AddAiAgentInstructionForClinicDocument = gql`
    mutation addAiAgentInstructionForClinic($clinicId: ID!, $instruction: String!) {
  addAiAgentInstructionForClinic(clinicId: $clinicId, instruction: $instruction)
}
    `;
export type AddAiAgentInstructionForClinicMutationFn = Apollo.MutationFunction<AddAiAgentInstructionForClinicMutation, AddAiAgentInstructionForClinicMutationVariables>;

/**
 * __useAddAiAgentInstructionForClinicMutation__
 *
 * To run a mutation, you first call `useAddAiAgentInstructionForClinicMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useAddAiAgentInstructionForClinicMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [addAiAgentInstructionForClinicMutation, { data, loading, error }] = useAddAiAgentInstructionForClinicMutation({
 *   variables: {
 *      clinicId: // value for 'clinicId'
 *      instruction: // value for 'instruction'
 *   },
 * });
 */
export function useAddAiAgentInstructionForClinicMutation(baseOptions?: Apollo.MutationHookOptions<AddAiAgentInstructionForClinicMutation, AddAiAgentInstructionForClinicMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<AddAiAgentInstructionForClinicMutation, AddAiAgentInstructionForClinicMutationVariables>(AddAiAgentInstructionForClinicDocument, options);
      }
export type AddAiAgentInstructionForClinicMutationHookResult = ReturnType<typeof useAddAiAgentInstructionForClinicMutation>;
export type AddAiAgentInstructionForClinicMutationResult = Apollo.MutationResult<AddAiAgentInstructionForClinicMutation>;
export type AddAiAgentInstructionForClinicMutationOptions = Apollo.BaseMutationOptions<AddAiAgentInstructionForClinicMutation, AddAiAgentInstructionForClinicMutationVariables>;
export const InitializeAiAgentForClinicDocument = gql`
    mutation initializeAiAgentForClinic($clinicId: ID!, $agentType: AiCallsAgentType) {
  initializeAiAgentForClinic(clinicId: $clinicId, agentType: $agentType)
}
    `;
export type InitializeAiAgentForClinicMutationFn = Apollo.MutationFunction<InitializeAiAgentForClinicMutation, InitializeAiAgentForClinicMutationVariables>;

/**
 * __useInitializeAiAgentForClinicMutation__
 *
 * To run a mutation, you first call `useInitializeAiAgentForClinicMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useInitializeAiAgentForClinicMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [initializeAiAgentForClinicMutation, { data, loading, error }] = useInitializeAiAgentForClinicMutation({
 *   variables: {
 *      clinicId: // value for 'clinicId'
 *      agentType: // value for 'agentType'
 *   },
 * });
 */
export function useInitializeAiAgentForClinicMutation(baseOptions?: Apollo.MutationHookOptions<InitializeAiAgentForClinicMutation, InitializeAiAgentForClinicMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<InitializeAiAgentForClinicMutation, InitializeAiAgentForClinicMutationVariables>(InitializeAiAgentForClinicDocument, options);
      }
export type InitializeAiAgentForClinicMutationHookResult = ReturnType<typeof useInitializeAiAgentForClinicMutation>;
export type InitializeAiAgentForClinicMutationResult = Apollo.MutationResult<InitializeAiAgentForClinicMutation>;
export type InitializeAiAgentForClinicMutationOptions = Apollo.BaseMutationOptions<InitializeAiAgentForClinicMutation, InitializeAiAgentForClinicMutationVariables>;
export const CreateAnimalDocument = gql`
    mutation createAnimal($data: CreateAnimalInput!) {
  createAnimal(data: $data) {
    ...AnimalFields
  }
}
    ${AnimalFieldsFragmentDoc}`;
export type CreateAnimalMutationFn = Apollo.MutationFunction<CreateAnimalMutation, CreateAnimalMutationVariables>;

/**
 * __useCreateAnimalMutation__
 *
 * To run a mutation, you first call `useCreateAnimalMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useCreateAnimalMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [createAnimalMutation, { data, loading, error }] = useCreateAnimalMutation({
 *   variables: {
 *      data: // value for 'data'
 *   },
 * });
 */
export function useCreateAnimalMutation(baseOptions?: Apollo.MutationHookOptions<CreateAnimalMutation, CreateAnimalMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<CreateAnimalMutation, CreateAnimalMutationVariables>(CreateAnimalDocument, options);
      }
export type CreateAnimalMutationHookResult = ReturnType<typeof useCreateAnimalMutation>;
export type CreateAnimalMutationResult = Apollo.MutationResult<CreateAnimalMutation>;
export type CreateAnimalMutationOptions = Apollo.BaseMutationOptions<CreateAnimalMutation, CreateAnimalMutationVariables>;
export const UpdateAnimalDocument = gql`
    mutation updateAnimal($id: ID!, $data: UpdateAnimalInput!) {
  updateAnimal(id: $id, data: $data) {
    ...AnimalFields
  }
}
    ${AnimalFieldsFragmentDoc}`;
export type UpdateAnimalMutationFn = Apollo.MutationFunction<UpdateAnimalMutation, UpdateAnimalMutationVariables>;

/**
 * __useUpdateAnimalMutation__
 *
 * To run a mutation, you first call `useUpdateAnimalMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useUpdateAnimalMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [updateAnimalMutation, { data, loading, error }] = useUpdateAnimalMutation({
 *   variables: {
 *      id: // value for 'id'
 *      data: // value for 'data'
 *   },
 * });
 */
export function useUpdateAnimalMutation(baseOptions?: Apollo.MutationHookOptions<UpdateAnimalMutation, UpdateAnimalMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<UpdateAnimalMutation, UpdateAnimalMutationVariables>(UpdateAnimalDocument, options);
      }
export type UpdateAnimalMutationHookResult = ReturnType<typeof useUpdateAnimalMutation>;
export type UpdateAnimalMutationResult = Apollo.MutationResult<UpdateAnimalMutation>;
export type UpdateAnimalMutationOptions = Apollo.BaseMutationOptions<UpdateAnimalMutation, UpdateAnimalMutationVariables>;
export const DeleteAnimalDocument = gql`
    mutation deleteAnimal($id: ID!) {
  deleteAnimal(id: $id)
}
    `;
export type DeleteAnimalMutationFn = Apollo.MutationFunction<DeleteAnimalMutation, DeleteAnimalMutationVariables>;

/**
 * __useDeleteAnimalMutation__
 *
 * To run a mutation, you first call `useDeleteAnimalMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useDeleteAnimalMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [deleteAnimalMutation, { data, loading, error }] = useDeleteAnimalMutation({
 *   variables: {
 *      id: // value for 'id'
 *   },
 * });
 */
export function useDeleteAnimalMutation(baseOptions?: Apollo.MutationHookOptions<DeleteAnimalMutation, DeleteAnimalMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<DeleteAnimalMutation, DeleteAnimalMutationVariables>(DeleteAnimalDocument, options);
      }
export type DeleteAnimalMutationHookResult = ReturnType<typeof useDeleteAnimalMutation>;
export type DeleteAnimalMutationResult = Apollo.MutationResult<DeleteAnimalMutation>;
export type DeleteAnimalMutationOptions = Apollo.BaseMutationOptions<DeleteAnimalMutation, DeleteAnimalMutationVariables>;
export const GetAppointmentPromptDocument = gql`
    query getAppointmentPrompt($id: ID!) {
  appointmentPrompt(id: $id) {
    ...AppointmentPromptFields
  }
}
    ${AppointmentPromptFieldsFragmentDoc}`;

/**
 * __useGetAppointmentPromptQuery__
 *
 * To run a query within a React component, call `useGetAppointmentPromptQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetAppointmentPromptQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetAppointmentPromptQuery({
 *   variables: {
 *      id: // value for 'id'
 *   },
 * });
 */
export function useGetAppointmentPromptQuery(baseOptions: Apollo.QueryHookOptions<GetAppointmentPromptQuery, GetAppointmentPromptQueryVariables> & ({ variables: GetAppointmentPromptQueryVariables; skip?: boolean; } | { skip: boolean; }) ) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<GetAppointmentPromptQuery, GetAppointmentPromptQueryVariables>(GetAppointmentPromptDocument, options);
      }
export function useGetAppointmentPromptLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<GetAppointmentPromptQuery, GetAppointmentPromptQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<GetAppointmentPromptQuery, GetAppointmentPromptQueryVariables>(GetAppointmentPromptDocument, options);
        }
export function useGetAppointmentPromptSuspenseQuery(baseOptions?: Apollo.SuspenseQueryHookOptions<GetAppointmentPromptQuery, GetAppointmentPromptQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useSuspenseQuery<GetAppointmentPromptQuery, GetAppointmentPromptQueryVariables>(GetAppointmentPromptDocument, options);
        }
export type GetAppointmentPromptQueryHookResult = ReturnType<typeof useGetAppointmentPromptQuery>;
export type GetAppointmentPromptLazyQueryHookResult = ReturnType<typeof useGetAppointmentPromptLazyQuery>;
export type GetAppointmentPromptSuspenseQueryHookResult = ReturnType<typeof useGetAppointmentPromptSuspenseQuery>;
export type GetAppointmentPromptQueryResult = Apollo.QueryResult<GetAppointmentPromptQuery, GetAppointmentPromptQueryVariables>;
export const QueryAppointmentPromptsDocument = gql`
    query queryAppointmentPrompts($where: [QueryInput!], $page: NonNegativeInt, $pageSize: NonNegativeInt, $orderBy: OrderByInput) {
  queryAppointmentPrompts(
    where: $where
    page: $page
    pageSize: $pageSize
    orderBy: $orderBy
  ) {
    ...AppointmentPromptFields
  }
}
    ${AppointmentPromptFieldsFragmentDoc}`;

/**
 * __useQueryAppointmentPromptsQuery__
 *
 * To run a query within a React component, call `useQueryAppointmentPromptsQuery` and pass it any options that fit your needs.
 * When your component renders, `useQueryAppointmentPromptsQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useQueryAppointmentPromptsQuery({
 *   variables: {
 *      where: // value for 'where'
 *      page: // value for 'page'
 *      pageSize: // value for 'pageSize'
 *      orderBy: // value for 'orderBy'
 *   },
 * });
 */
export function useQueryAppointmentPromptsQuery(baseOptions?: Apollo.QueryHookOptions<QueryAppointmentPromptsQuery, QueryAppointmentPromptsQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<QueryAppointmentPromptsQuery, QueryAppointmentPromptsQueryVariables>(QueryAppointmentPromptsDocument, options);
      }
export function useQueryAppointmentPromptsLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<QueryAppointmentPromptsQuery, QueryAppointmentPromptsQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<QueryAppointmentPromptsQuery, QueryAppointmentPromptsQueryVariables>(QueryAppointmentPromptsDocument, options);
        }
export function useQueryAppointmentPromptsSuspenseQuery(baseOptions?: Apollo.SuspenseQueryHookOptions<QueryAppointmentPromptsQuery, QueryAppointmentPromptsQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useSuspenseQuery<QueryAppointmentPromptsQuery, QueryAppointmentPromptsQueryVariables>(QueryAppointmentPromptsDocument, options);
        }
export type QueryAppointmentPromptsQueryHookResult = ReturnType<typeof useQueryAppointmentPromptsQuery>;
export type QueryAppointmentPromptsLazyQueryHookResult = ReturnType<typeof useQueryAppointmentPromptsLazyQuery>;
export type QueryAppointmentPromptsSuspenseQueryHookResult = ReturnType<typeof useQueryAppointmentPromptsSuspenseQuery>;
export type QueryAppointmentPromptsQueryResult = Apollo.QueryResult<QueryAppointmentPromptsQuery, QueryAppointmentPromptsQueryVariables>;
export const CreateAppointmentPromptDocument = gql`
    mutation createAppointmentPrompt($data: CreateAppointmentPromptInput!) {
  createAppointmentPrompt(data: $data) {
    ...AppointmentPromptFields
  }
}
    ${AppointmentPromptFieldsFragmentDoc}`;
export type CreateAppointmentPromptMutationFn = Apollo.MutationFunction<CreateAppointmentPromptMutation, CreateAppointmentPromptMutationVariables>;

/**
 * __useCreateAppointmentPromptMutation__
 *
 * To run a mutation, you first call `useCreateAppointmentPromptMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useCreateAppointmentPromptMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [createAppointmentPromptMutation, { data, loading, error }] = useCreateAppointmentPromptMutation({
 *   variables: {
 *      data: // value for 'data'
 *   },
 * });
 */
export function useCreateAppointmentPromptMutation(baseOptions?: Apollo.MutationHookOptions<CreateAppointmentPromptMutation, CreateAppointmentPromptMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<CreateAppointmentPromptMutation, CreateAppointmentPromptMutationVariables>(CreateAppointmentPromptDocument, options);
      }
export type CreateAppointmentPromptMutationHookResult = ReturnType<typeof useCreateAppointmentPromptMutation>;
export type CreateAppointmentPromptMutationResult = Apollo.MutationResult<CreateAppointmentPromptMutation>;
export type CreateAppointmentPromptMutationOptions = Apollo.BaseMutationOptions<CreateAppointmentPromptMutation, CreateAppointmentPromptMutationVariables>;
export const SendAppointmentPromptDocument = gql`
    mutation sendAppointmentPrompt($data: CreateAppointmentPromptInput!) {
  sendAppointmentPrompt(data: $data) {
    ...AppointmentPromptFields
  }
}
    ${AppointmentPromptFieldsFragmentDoc}`;
export type SendAppointmentPromptMutationFn = Apollo.MutationFunction<SendAppointmentPromptMutation, SendAppointmentPromptMutationVariables>;

/**
 * __useSendAppointmentPromptMutation__
 *
 * To run a mutation, you first call `useSendAppointmentPromptMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useSendAppointmentPromptMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [sendAppointmentPromptMutation, { data, loading, error }] = useSendAppointmentPromptMutation({
 *   variables: {
 *      data: // value for 'data'
 *   },
 * });
 */
export function useSendAppointmentPromptMutation(baseOptions?: Apollo.MutationHookOptions<SendAppointmentPromptMutation, SendAppointmentPromptMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<SendAppointmentPromptMutation, SendAppointmentPromptMutationVariables>(SendAppointmentPromptDocument, options);
      }
export type SendAppointmentPromptMutationHookResult = ReturnType<typeof useSendAppointmentPromptMutation>;
export type SendAppointmentPromptMutationResult = Apollo.MutationResult<SendAppointmentPromptMutation>;
export type SendAppointmentPromptMutationOptions = Apollo.BaseMutationOptions<SendAppointmentPromptMutation, SendAppointmentPromptMutationVariables>;
export const UpdateAppointmentPromptDocument = gql`
    mutation updateAppointmentPrompt($id: ID!, $data: UpdateAppointmentPromptInput!) {
  updateAppointmentPrompt(id: $id, data: $data) {
    ...AppointmentPromptFields
  }
}
    ${AppointmentPromptFieldsFragmentDoc}`;
export type UpdateAppointmentPromptMutationFn = Apollo.MutationFunction<UpdateAppointmentPromptMutation, UpdateAppointmentPromptMutationVariables>;

/**
 * __useUpdateAppointmentPromptMutation__
 *
 * To run a mutation, you first call `useUpdateAppointmentPromptMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useUpdateAppointmentPromptMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [updateAppointmentPromptMutation, { data, loading, error }] = useUpdateAppointmentPromptMutation({
 *   variables: {
 *      id: // value for 'id'
 *      data: // value for 'data'
 *   },
 * });
 */
export function useUpdateAppointmentPromptMutation(baseOptions?: Apollo.MutationHookOptions<UpdateAppointmentPromptMutation, UpdateAppointmentPromptMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<UpdateAppointmentPromptMutation, UpdateAppointmentPromptMutationVariables>(UpdateAppointmentPromptDocument, options);
      }
export type UpdateAppointmentPromptMutationHookResult = ReturnType<typeof useUpdateAppointmentPromptMutation>;
export type UpdateAppointmentPromptMutationResult = Apollo.MutationResult<UpdateAppointmentPromptMutation>;
export type UpdateAppointmentPromptMutationOptions = Apollo.BaseMutationOptions<UpdateAppointmentPromptMutation, UpdateAppointmentPromptMutationVariables>;
export const GetPublicAppointmentTimesDocument = gql`
    query getPublicAppointmentTimes($searchInput: SearchAppointmentsInput!) {
  publicAppointmentTimes(searchInput: $searchInput) {
    ...PublicAppointmentTimeFields
  }
}
    ${PublicAppointmentTimeFieldsFragmentDoc}`;

/**
 * __useGetPublicAppointmentTimesQuery__
 *
 * To run a query within a React component, call `useGetPublicAppointmentTimesQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetPublicAppointmentTimesQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetPublicAppointmentTimesQuery({
 *   variables: {
 *      searchInput: // value for 'searchInput'
 *   },
 * });
 */
export function useGetPublicAppointmentTimesQuery(baseOptions: Apollo.QueryHookOptions<GetPublicAppointmentTimesQuery, GetPublicAppointmentTimesQueryVariables> & ({ variables: GetPublicAppointmentTimesQueryVariables; skip?: boolean; } | { skip: boolean; }) ) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<GetPublicAppointmentTimesQuery, GetPublicAppointmentTimesQueryVariables>(GetPublicAppointmentTimesDocument, options);
      }
export function useGetPublicAppointmentTimesLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<GetPublicAppointmentTimesQuery, GetPublicAppointmentTimesQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<GetPublicAppointmentTimesQuery, GetPublicAppointmentTimesQueryVariables>(GetPublicAppointmentTimesDocument, options);
        }
export function useGetPublicAppointmentTimesSuspenseQuery(baseOptions?: Apollo.SuspenseQueryHookOptions<GetPublicAppointmentTimesQuery, GetPublicAppointmentTimesQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useSuspenseQuery<GetPublicAppointmentTimesQuery, GetPublicAppointmentTimesQueryVariables>(GetPublicAppointmentTimesDocument, options);
        }
export type GetPublicAppointmentTimesQueryHookResult = ReturnType<typeof useGetPublicAppointmentTimesQuery>;
export type GetPublicAppointmentTimesLazyQueryHookResult = ReturnType<typeof useGetPublicAppointmentTimesLazyQuery>;
export type GetPublicAppointmentTimesSuspenseQueryHookResult = ReturnType<typeof useGetPublicAppointmentTimesSuspenseQuery>;
export type GetPublicAppointmentTimesQueryResult = Apollo.QueryResult<GetPublicAppointmentTimesQuery, GetPublicAppointmentTimesQueryVariables>;
export const GetAppointmentDocument = gql`
    query getAppointment($id: ID!) {
  appointment(id: $id) {
    ...AppointmentFields
  }
}
    ${AppointmentFieldsFragmentDoc}`;

/**
 * __useGetAppointmentQuery__
 *
 * To run a query within a React component, call `useGetAppointmentQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetAppointmentQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetAppointmentQuery({
 *   variables: {
 *      id: // value for 'id'
 *   },
 * });
 */
export function useGetAppointmentQuery(baseOptions: Apollo.QueryHookOptions<GetAppointmentQuery, GetAppointmentQueryVariables> & ({ variables: GetAppointmentQueryVariables; skip?: boolean; } | { skip: boolean; }) ) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<GetAppointmentQuery, GetAppointmentQueryVariables>(GetAppointmentDocument, options);
      }
export function useGetAppointmentLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<GetAppointmentQuery, GetAppointmentQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<GetAppointmentQuery, GetAppointmentQueryVariables>(GetAppointmentDocument, options);
        }
export function useGetAppointmentSuspenseQuery(baseOptions?: Apollo.SuspenseQueryHookOptions<GetAppointmentQuery, GetAppointmentQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useSuspenseQuery<GetAppointmentQuery, GetAppointmentQueryVariables>(GetAppointmentDocument, options);
        }
export type GetAppointmentQueryHookResult = ReturnType<typeof useGetAppointmentQuery>;
export type GetAppointmentLazyQueryHookResult = ReturnType<typeof useGetAppointmentLazyQuery>;
export type GetAppointmentSuspenseQueryHookResult = ReturnType<typeof useGetAppointmentSuspenseQuery>;
export type GetAppointmentQueryResult = Apollo.QueryResult<GetAppointmentQuery, GetAppointmentQueryVariables>;
export const SearchAppointmentsDocument = gql`
    query searchAppointments($searchInput: SearchAppointmentsInput!) {
  searchAppointments(searchInput: $searchInput) {
    ...AppointmentFields
  }
}
    ${AppointmentFieldsFragmentDoc}`;

/**
 * __useSearchAppointmentsQuery__
 *
 * To run a query within a React component, call `useSearchAppointmentsQuery` and pass it any options that fit your needs.
 * When your component renders, `useSearchAppointmentsQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useSearchAppointmentsQuery({
 *   variables: {
 *      searchInput: // value for 'searchInput'
 *   },
 * });
 */
export function useSearchAppointmentsQuery(baseOptions: Apollo.QueryHookOptions<SearchAppointmentsQuery, SearchAppointmentsQueryVariables> & ({ variables: SearchAppointmentsQueryVariables; skip?: boolean; } | { skip: boolean; }) ) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<SearchAppointmentsQuery, SearchAppointmentsQueryVariables>(SearchAppointmentsDocument, options);
      }
export function useSearchAppointmentsLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<SearchAppointmentsQuery, SearchAppointmentsQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<SearchAppointmentsQuery, SearchAppointmentsQueryVariables>(SearchAppointmentsDocument, options);
        }
export function useSearchAppointmentsSuspenseQuery(baseOptions?: Apollo.SuspenseQueryHookOptions<SearchAppointmentsQuery, SearchAppointmentsQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useSuspenseQuery<SearchAppointmentsQuery, SearchAppointmentsQueryVariables>(SearchAppointmentsDocument, options);
        }
export type SearchAppointmentsQueryHookResult = ReturnType<typeof useSearchAppointmentsQuery>;
export type SearchAppointmentsLazyQueryHookResult = ReturnType<typeof useSearchAppointmentsLazyQuery>;
export type SearchAppointmentsSuspenseQueryHookResult = ReturnType<typeof useSearchAppointmentsSuspenseQuery>;
export type SearchAppointmentsQueryResult = Apollo.QueryResult<SearchAppointmentsQuery, SearchAppointmentsQueryVariables>;
export const QueryAppointmentsDocument = gql`
    query queryAppointments($where: [QueryInput!], $page: NonNegativeInt, $pageSize: NonNegativeInt, $orderBy: OrderByInput) {
  queryAppointments(
    where: $where
    page: $page
    pageSize: $pageSize
    orderBy: $orderBy
  ) {
    ...AppointmentFields
  }
}
    ${AppointmentFieldsFragmentDoc}`;

/**
 * __useQueryAppointmentsQuery__
 *
 * To run a query within a React component, call `useQueryAppointmentsQuery` and pass it any options that fit your needs.
 * When your component renders, `useQueryAppointmentsQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useQueryAppointmentsQuery({
 *   variables: {
 *      where: // value for 'where'
 *      page: // value for 'page'
 *      pageSize: // value for 'pageSize'
 *      orderBy: // value for 'orderBy'
 *   },
 * });
 */
export function useQueryAppointmentsQuery(baseOptions?: Apollo.QueryHookOptions<QueryAppointmentsQuery, QueryAppointmentsQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<QueryAppointmentsQuery, QueryAppointmentsQueryVariables>(QueryAppointmentsDocument, options);
      }
export function useQueryAppointmentsLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<QueryAppointmentsQuery, QueryAppointmentsQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<QueryAppointmentsQuery, QueryAppointmentsQueryVariables>(QueryAppointmentsDocument, options);
        }
export function useQueryAppointmentsSuspenseQuery(baseOptions?: Apollo.SuspenseQueryHookOptions<QueryAppointmentsQuery, QueryAppointmentsQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useSuspenseQuery<QueryAppointmentsQuery, QueryAppointmentsQueryVariables>(QueryAppointmentsDocument, options);
        }
export type QueryAppointmentsQueryHookResult = ReturnType<typeof useQueryAppointmentsQuery>;
export type QueryAppointmentsLazyQueryHookResult = ReturnType<typeof useQueryAppointmentsLazyQuery>;
export type QueryAppointmentsSuspenseQueryHookResult = ReturnType<typeof useQueryAppointmentsSuspenseQuery>;
export type QueryAppointmentsQueryResult = Apollo.QueryResult<QueryAppointmentsQuery, QueryAppointmentsQueryVariables>;
export const QueryAppointmentScheduleDocument = gql`
    query queryAppointmentSchedule($where: [QueryInput!], $page: NonNegativeInt, $pageSize: NonNegativeInt, $orderBy: OrderByInput) {
  queryAppointments(
    where: $where
    page: $page
    pageSize: $pageSize
    orderBy: $orderBy
  ) {
    ...AppointmentSchedulePreviewFields
  }
}
    ${AppointmentSchedulePreviewFieldsFragmentDoc}`;

/**
 * __useQueryAppointmentScheduleQuery__
 *
 * To run a query within a React component, call `useQueryAppointmentScheduleQuery` and pass it any options that fit your needs.
 * When your component renders, `useQueryAppointmentScheduleQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useQueryAppointmentScheduleQuery({
 *   variables: {
 *      where: // value for 'where'
 *      page: // value for 'page'
 *      pageSize: // value for 'pageSize'
 *      orderBy: // value for 'orderBy'
 *   },
 * });
 */
export function useQueryAppointmentScheduleQuery(baseOptions?: Apollo.QueryHookOptions<QueryAppointmentScheduleQuery, QueryAppointmentScheduleQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<QueryAppointmentScheduleQuery, QueryAppointmentScheduleQueryVariables>(QueryAppointmentScheduleDocument, options);
      }
export function useQueryAppointmentScheduleLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<QueryAppointmentScheduleQuery, QueryAppointmentScheduleQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<QueryAppointmentScheduleQuery, QueryAppointmentScheduleQueryVariables>(QueryAppointmentScheduleDocument, options);
        }
export function useQueryAppointmentScheduleSuspenseQuery(baseOptions?: Apollo.SuspenseQueryHookOptions<QueryAppointmentScheduleQuery, QueryAppointmentScheduleQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useSuspenseQuery<QueryAppointmentScheduleQuery, QueryAppointmentScheduleQueryVariables>(QueryAppointmentScheduleDocument, options);
        }
export type QueryAppointmentScheduleQueryHookResult = ReturnType<typeof useQueryAppointmentScheduleQuery>;
export type QueryAppointmentScheduleLazyQueryHookResult = ReturnType<typeof useQueryAppointmentScheduleLazyQuery>;
export type QueryAppointmentScheduleSuspenseQueryHookResult = ReturnType<typeof useQueryAppointmentScheduleSuspenseQuery>;
export type QueryAppointmentScheduleQueryResult = Apollo.QueryResult<QueryAppointmentScheduleQuery, QueryAppointmentScheduleQueryVariables>;
export const QueryClinicAppointmentsDocument = gql`
    query queryClinicAppointments($where: [QueryInput!], $page: NonNegativeInt, $pageSize: NonNegativeInt, $orderBy: OrderByInput, $clinicId: ID!) {
  queryClinicAppointments(
    where: $where
    page: $page
    pageSize: $pageSize
    orderBy: $orderBy
    clinicId: $clinicId
  ) {
    ...AppointmentFields
  }
}
    ${AppointmentFieldsFragmentDoc}`;

/**
 * __useQueryClinicAppointmentsQuery__
 *
 * To run a query within a React component, call `useQueryClinicAppointmentsQuery` and pass it any options that fit your needs.
 * When your component renders, `useQueryClinicAppointmentsQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useQueryClinicAppointmentsQuery({
 *   variables: {
 *      where: // value for 'where'
 *      page: // value for 'page'
 *      pageSize: // value for 'pageSize'
 *      orderBy: // value for 'orderBy'
 *      clinicId: // value for 'clinicId'
 *   },
 * });
 */
export function useQueryClinicAppointmentsQuery(baseOptions: Apollo.QueryHookOptions<QueryClinicAppointmentsQuery, QueryClinicAppointmentsQueryVariables> & ({ variables: QueryClinicAppointmentsQueryVariables; skip?: boolean; } | { skip: boolean; }) ) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<QueryClinicAppointmentsQuery, QueryClinicAppointmentsQueryVariables>(QueryClinicAppointmentsDocument, options);
      }
export function useQueryClinicAppointmentsLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<QueryClinicAppointmentsQuery, QueryClinicAppointmentsQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<QueryClinicAppointmentsQuery, QueryClinicAppointmentsQueryVariables>(QueryClinicAppointmentsDocument, options);
        }
export function useQueryClinicAppointmentsSuspenseQuery(baseOptions?: Apollo.SuspenseQueryHookOptions<QueryClinicAppointmentsQuery, QueryClinicAppointmentsQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useSuspenseQuery<QueryClinicAppointmentsQuery, QueryClinicAppointmentsQueryVariables>(QueryClinicAppointmentsDocument, options);
        }
export type QueryClinicAppointmentsQueryHookResult = ReturnType<typeof useQueryClinicAppointmentsQuery>;
export type QueryClinicAppointmentsLazyQueryHookResult = ReturnType<typeof useQueryClinicAppointmentsLazyQuery>;
export type QueryClinicAppointmentsSuspenseQueryHookResult = ReturnType<typeof useQueryClinicAppointmentsSuspenseQuery>;
export type QueryClinicAppointmentsQueryResult = Apollo.QueryResult<QueryClinicAppointmentsQuery, QueryClinicAppointmentsQueryVariables>;
export const CountAppointmentsDocument = gql`
    query countAppointments($where: [QueryInput!]) {
  countAppointments(where: $where)
}
    `;

/**
 * __useCountAppointmentsQuery__
 *
 * To run a query within a React component, call `useCountAppointmentsQuery` and pass it any options that fit your needs.
 * When your component renders, `useCountAppointmentsQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useCountAppointmentsQuery({
 *   variables: {
 *      where: // value for 'where'
 *   },
 * });
 */
export function useCountAppointmentsQuery(baseOptions?: Apollo.QueryHookOptions<CountAppointmentsQuery, CountAppointmentsQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<CountAppointmentsQuery, CountAppointmentsQueryVariables>(CountAppointmentsDocument, options);
      }
export function useCountAppointmentsLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<CountAppointmentsQuery, CountAppointmentsQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<CountAppointmentsQuery, CountAppointmentsQueryVariables>(CountAppointmentsDocument, options);
        }
export function useCountAppointmentsSuspenseQuery(baseOptions?: Apollo.SuspenseQueryHookOptions<CountAppointmentsQuery, CountAppointmentsQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useSuspenseQuery<CountAppointmentsQuery, CountAppointmentsQueryVariables>(CountAppointmentsDocument, options);
        }
export type CountAppointmentsQueryHookResult = ReturnType<typeof useCountAppointmentsQuery>;
export type CountAppointmentsLazyQueryHookResult = ReturnType<typeof useCountAppointmentsLazyQuery>;
export type CountAppointmentsSuspenseQueryHookResult = ReturnType<typeof useCountAppointmentsSuspenseQuery>;
export type CountAppointmentsQueryResult = Apollo.QueryResult<CountAppointmentsQuery, CountAppointmentsQueryVariables>;
export const SearchAppointmentsStatusDocument = gql`
    query searchAppointmentsStatus($searchInput: SearchAppointmentsInput!) {
  searchAppointments(searchInput: $searchInput) {
    id
    status
  }
}
    `;

/**
 * __useSearchAppointmentsStatusQuery__
 *
 * To run a query within a React component, call `useSearchAppointmentsStatusQuery` and pass it any options that fit your needs.
 * When your component renders, `useSearchAppointmentsStatusQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useSearchAppointmentsStatusQuery({
 *   variables: {
 *      searchInput: // value for 'searchInput'
 *   },
 * });
 */
export function useSearchAppointmentsStatusQuery(baseOptions: Apollo.QueryHookOptions<SearchAppointmentsStatusQuery, SearchAppointmentsStatusQueryVariables> & ({ variables: SearchAppointmentsStatusQueryVariables; skip?: boolean; } | { skip: boolean; }) ) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<SearchAppointmentsStatusQuery, SearchAppointmentsStatusQueryVariables>(SearchAppointmentsStatusDocument, options);
      }
export function useSearchAppointmentsStatusLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<SearchAppointmentsStatusQuery, SearchAppointmentsStatusQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<SearchAppointmentsStatusQuery, SearchAppointmentsStatusQueryVariables>(SearchAppointmentsStatusDocument, options);
        }
export function useSearchAppointmentsStatusSuspenseQuery(baseOptions?: Apollo.SuspenseQueryHookOptions<SearchAppointmentsStatusQuery, SearchAppointmentsStatusQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useSuspenseQuery<SearchAppointmentsStatusQuery, SearchAppointmentsStatusQueryVariables>(SearchAppointmentsStatusDocument, options);
        }
export type SearchAppointmentsStatusQueryHookResult = ReturnType<typeof useSearchAppointmentsStatusQuery>;
export type SearchAppointmentsStatusLazyQueryHookResult = ReturnType<typeof useSearchAppointmentsStatusLazyQuery>;
export type SearchAppointmentsStatusSuspenseQueryHookResult = ReturnType<typeof useSearchAppointmentsStatusSuspenseQuery>;
export type SearchAppointmentsStatusQueryResult = Apollo.QueryResult<SearchAppointmentsStatusQuery, SearchAppointmentsStatusQueryVariables>;
export const GetNewAppointmentsForClinicDocument = gql`
    query getNewAppointmentsForClinic($clinicId: ID!, $fromPmsCreatedAt: NonNegativeInt!, $toPmsCreatedAt: NonNegativeInt!) {
  getNewAppointmentsForClinic(
    clinicId: $clinicId
    fromPmsCreatedAt: $fromPmsCreatedAt
    toPmsCreatedAt: $toPmsCreatedAt
  )
}
    `;

/**
 * __useGetNewAppointmentsForClinicQuery__
 *
 * To run a query within a React component, call `useGetNewAppointmentsForClinicQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetNewAppointmentsForClinicQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetNewAppointmentsForClinicQuery({
 *   variables: {
 *      clinicId: // value for 'clinicId'
 *      fromPmsCreatedAt: // value for 'fromPmsCreatedAt'
 *      toPmsCreatedAt: // value for 'toPmsCreatedAt'
 *   },
 * });
 */
export function useGetNewAppointmentsForClinicQuery(baseOptions: Apollo.QueryHookOptions<GetNewAppointmentsForClinicQuery, GetNewAppointmentsForClinicQueryVariables> & ({ variables: GetNewAppointmentsForClinicQueryVariables; skip?: boolean; } | { skip: boolean; }) ) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<GetNewAppointmentsForClinicQuery, GetNewAppointmentsForClinicQueryVariables>(GetNewAppointmentsForClinicDocument, options);
      }
export function useGetNewAppointmentsForClinicLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<GetNewAppointmentsForClinicQuery, GetNewAppointmentsForClinicQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<GetNewAppointmentsForClinicQuery, GetNewAppointmentsForClinicQueryVariables>(GetNewAppointmentsForClinicDocument, options);
        }
export function useGetNewAppointmentsForClinicSuspenseQuery(baseOptions?: Apollo.SuspenseQueryHookOptions<GetNewAppointmentsForClinicQuery, GetNewAppointmentsForClinicQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useSuspenseQuery<GetNewAppointmentsForClinicQuery, GetNewAppointmentsForClinicQueryVariables>(GetNewAppointmentsForClinicDocument, options);
        }
export type GetNewAppointmentsForClinicQueryHookResult = ReturnType<typeof useGetNewAppointmentsForClinicQuery>;
export type GetNewAppointmentsForClinicLazyQueryHookResult = ReturnType<typeof useGetNewAppointmentsForClinicLazyQuery>;
export type GetNewAppointmentsForClinicSuspenseQueryHookResult = ReturnType<typeof useGetNewAppointmentsForClinicSuspenseQuery>;
export type GetNewAppointmentsForClinicQueryResult = Apollo.QueryResult<GetNewAppointmentsForClinicQuery, GetNewAppointmentsForClinicQueryVariables>;
export const GetAppointmentsByClinicAndRangeDocument = gql`
    query getAppointmentsByClinicAndRange($clinicId: ID!, $start_time: NonNegativeInt!, $end_time: NonNegativeInt!) {
  appointmentsByClinicAndRange(
    clinicId: $clinicId
    start_time: $start_time
    end_time: $end_time
  ) {
    ...AppointmentFields
  }
}
    ${AppointmentFieldsFragmentDoc}`;

/**
 * __useGetAppointmentsByClinicAndRangeQuery__
 *
 * To run a query within a React component, call `useGetAppointmentsByClinicAndRangeQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetAppointmentsByClinicAndRangeQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetAppointmentsByClinicAndRangeQuery({
 *   variables: {
 *      clinicId: // value for 'clinicId'
 *      start_time: // value for 'start_time'
 *      end_time: // value for 'end_time'
 *   },
 * });
 */
export function useGetAppointmentsByClinicAndRangeQuery(baseOptions: Apollo.QueryHookOptions<GetAppointmentsByClinicAndRangeQuery, GetAppointmentsByClinicAndRangeQueryVariables> & ({ variables: GetAppointmentsByClinicAndRangeQueryVariables; skip?: boolean; } | { skip: boolean; }) ) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<GetAppointmentsByClinicAndRangeQuery, GetAppointmentsByClinicAndRangeQueryVariables>(GetAppointmentsByClinicAndRangeDocument, options);
      }
export function useGetAppointmentsByClinicAndRangeLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<GetAppointmentsByClinicAndRangeQuery, GetAppointmentsByClinicAndRangeQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<GetAppointmentsByClinicAndRangeQuery, GetAppointmentsByClinicAndRangeQueryVariables>(GetAppointmentsByClinicAndRangeDocument, options);
        }
export function useGetAppointmentsByClinicAndRangeSuspenseQuery(baseOptions?: Apollo.SuspenseQueryHookOptions<GetAppointmentsByClinicAndRangeQuery, GetAppointmentsByClinicAndRangeQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useSuspenseQuery<GetAppointmentsByClinicAndRangeQuery, GetAppointmentsByClinicAndRangeQueryVariables>(GetAppointmentsByClinicAndRangeDocument, options);
        }
export type GetAppointmentsByClinicAndRangeQueryHookResult = ReturnType<typeof useGetAppointmentsByClinicAndRangeQuery>;
export type GetAppointmentsByClinicAndRangeLazyQueryHookResult = ReturnType<typeof useGetAppointmentsByClinicAndRangeLazyQuery>;
export type GetAppointmentsByClinicAndRangeSuspenseQueryHookResult = ReturnType<typeof useGetAppointmentsByClinicAndRangeSuspenseQuery>;
export type GetAppointmentsByClinicAndRangeQueryResult = Apollo.QueryResult<GetAppointmentsByClinicAndRangeQuery, GetAppointmentsByClinicAndRangeQueryVariables>;
export const GetTimeSlotsForClinicForDayDocument = gql`
    query getTimeSlotsForClinicForDay($clinicId: ID!, $date: NonNegativeInt!) {
  getTimeSlotsForClinicForDay(clinicId: $clinicId, date: $date) {
    ...TimeSlotFields
  }
}
    ${TimeSlotFieldsFragmentDoc}`;

/**
 * __useGetTimeSlotsForClinicForDayQuery__
 *
 * To run a query within a React component, call `useGetTimeSlotsForClinicForDayQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetTimeSlotsForClinicForDayQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetTimeSlotsForClinicForDayQuery({
 *   variables: {
 *      clinicId: // value for 'clinicId'
 *      date: // value for 'date'
 *   },
 * });
 */
export function useGetTimeSlotsForClinicForDayQuery(baseOptions: Apollo.QueryHookOptions<GetTimeSlotsForClinicForDayQuery, GetTimeSlotsForClinicForDayQueryVariables> & ({ variables: GetTimeSlotsForClinicForDayQueryVariables; skip?: boolean; } | { skip: boolean; }) ) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<GetTimeSlotsForClinicForDayQuery, GetTimeSlotsForClinicForDayQueryVariables>(GetTimeSlotsForClinicForDayDocument, options);
      }
export function useGetTimeSlotsForClinicForDayLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<GetTimeSlotsForClinicForDayQuery, GetTimeSlotsForClinicForDayQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<GetTimeSlotsForClinicForDayQuery, GetTimeSlotsForClinicForDayQueryVariables>(GetTimeSlotsForClinicForDayDocument, options);
        }
export function useGetTimeSlotsForClinicForDaySuspenseQuery(baseOptions?: Apollo.SuspenseQueryHookOptions<GetTimeSlotsForClinicForDayQuery, GetTimeSlotsForClinicForDayQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useSuspenseQuery<GetTimeSlotsForClinicForDayQuery, GetTimeSlotsForClinicForDayQueryVariables>(GetTimeSlotsForClinicForDayDocument, options);
        }
export type GetTimeSlotsForClinicForDayQueryHookResult = ReturnType<typeof useGetTimeSlotsForClinicForDayQuery>;
export type GetTimeSlotsForClinicForDayLazyQueryHookResult = ReturnType<typeof useGetTimeSlotsForClinicForDayLazyQuery>;
export type GetTimeSlotsForClinicForDaySuspenseQueryHookResult = ReturnType<typeof useGetTimeSlotsForClinicForDaySuspenseQuery>;
export type GetTimeSlotsForClinicForDayQueryResult = Apollo.QueryResult<GetTimeSlotsForClinicForDayQuery, GetTimeSlotsForClinicForDayQueryVariables>;
export const GetTimeSlotsForSchedulingDaysDocument = gql`
    query getTimeSlotsForSchedulingDays($clinicId: ID!, $params: GetTimeSlotForSchedulingDaysParams!) {
  getTimeSlotsForSchedulingDays(clinicId: $clinicId, params: $params) {
    ...TimeSlotSchedulingFields
  }
}
    ${TimeSlotSchedulingFieldsFragmentDoc}`;

/**
 * __useGetTimeSlotsForSchedulingDaysQuery__
 *
 * To run a query within a React component, call `useGetTimeSlotsForSchedulingDaysQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetTimeSlotsForSchedulingDaysQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetTimeSlotsForSchedulingDaysQuery({
 *   variables: {
 *      clinicId: // value for 'clinicId'
 *      params: // value for 'params'
 *   },
 * });
 */
export function useGetTimeSlotsForSchedulingDaysQuery(baseOptions: Apollo.QueryHookOptions<GetTimeSlotsForSchedulingDaysQuery, GetTimeSlotsForSchedulingDaysQueryVariables> & ({ variables: GetTimeSlotsForSchedulingDaysQueryVariables; skip?: boolean; } | { skip: boolean; }) ) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<GetTimeSlotsForSchedulingDaysQuery, GetTimeSlotsForSchedulingDaysQueryVariables>(GetTimeSlotsForSchedulingDaysDocument, options);
      }
export function useGetTimeSlotsForSchedulingDaysLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<GetTimeSlotsForSchedulingDaysQuery, GetTimeSlotsForSchedulingDaysQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<GetTimeSlotsForSchedulingDaysQuery, GetTimeSlotsForSchedulingDaysQueryVariables>(GetTimeSlotsForSchedulingDaysDocument, options);
        }
export function useGetTimeSlotsForSchedulingDaysSuspenseQuery(baseOptions?: Apollo.SuspenseQueryHookOptions<GetTimeSlotsForSchedulingDaysQuery, GetTimeSlotsForSchedulingDaysQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useSuspenseQuery<GetTimeSlotsForSchedulingDaysQuery, GetTimeSlotsForSchedulingDaysQueryVariables>(GetTimeSlotsForSchedulingDaysDocument, options);
        }
export type GetTimeSlotsForSchedulingDaysQueryHookResult = ReturnType<typeof useGetTimeSlotsForSchedulingDaysQuery>;
export type GetTimeSlotsForSchedulingDaysLazyQueryHookResult = ReturnType<typeof useGetTimeSlotsForSchedulingDaysLazyQuery>;
export type GetTimeSlotsForSchedulingDaysSuspenseQueryHookResult = ReturnType<typeof useGetTimeSlotsForSchedulingDaysSuspenseQuery>;
export type GetTimeSlotsForSchedulingDaysQueryResult = Apollo.QueryResult<GetTimeSlotsForSchedulingDaysQuery, GetTimeSlotsForSchedulingDaysQueryVariables>;
export const GetAppointmentsCountByClinicDocument = gql`
    query getAppointmentsCountByClinic($where: [QueryInput!]) {
  appointmentsCountByClinic(where: $where) {
    clinic {
      ...ClinicUsageFields
    }
    count
  }
}
    ${ClinicUsageFieldsFragmentDoc}`;

/**
 * __useGetAppointmentsCountByClinicQuery__
 *
 * To run a query within a React component, call `useGetAppointmentsCountByClinicQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetAppointmentsCountByClinicQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetAppointmentsCountByClinicQuery({
 *   variables: {
 *      where: // value for 'where'
 *   },
 * });
 */
export function useGetAppointmentsCountByClinicQuery(baseOptions?: Apollo.QueryHookOptions<GetAppointmentsCountByClinicQuery, GetAppointmentsCountByClinicQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<GetAppointmentsCountByClinicQuery, GetAppointmentsCountByClinicQueryVariables>(GetAppointmentsCountByClinicDocument, options);
      }
export function useGetAppointmentsCountByClinicLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<GetAppointmentsCountByClinicQuery, GetAppointmentsCountByClinicQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<GetAppointmentsCountByClinicQuery, GetAppointmentsCountByClinicQueryVariables>(GetAppointmentsCountByClinicDocument, options);
        }
export function useGetAppointmentsCountByClinicSuspenseQuery(baseOptions?: Apollo.SuspenseQueryHookOptions<GetAppointmentsCountByClinicQuery, GetAppointmentsCountByClinicQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useSuspenseQuery<GetAppointmentsCountByClinicQuery, GetAppointmentsCountByClinicQueryVariables>(GetAppointmentsCountByClinicDocument, options);
        }
export type GetAppointmentsCountByClinicQueryHookResult = ReturnType<typeof useGetAppointmentsCountByClinicQuery>;
export type GetAppointmentsCountByClinicLazyQueryHookResult = ReturnType<typeof useGetAppointmentsCountByClinicLazyQuery>;
export type GetAppointmentsCountByClinicSuspenseQueryHookResult = ReturnType<typeof useGetAppointmentsCountByClinicSuspenseQuery>;
export type GetAppointmentsCountByClinicQueryResult = Apollo.QueryResult<GetAppointmentsCountByClinicQuery, GetAppointmentsCountByClinicQueryVariables>;
export const CreateAppointmentDocument = gql`
    mutation createAppointment($data: CreateAppointmentInput!) {
  createAppointment(data: $data) {
    ...AppointmentFields
  }
}
    ${AppointmentFieldsFragmentDoc}`;
export type CreateAppointmentMutationFn = Apollo.MutationFunction<CreateAppointmentMutation, CreateAppointmentMutationVariables>;

/**
 * __useCreateAppointmentMutation__
 *
 * To run a mutation, you first call `useCreateAppointmentMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useCreateAppointmentMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [createAppointmentMutation, { data, loading, error }] = useCreateAppointmentMutation({
 *   variables: {
 *      data: // value for 'data'
 *   },
 * });
 */
export function useCreateAppointmentMutation(baseOptions?: Apollo.MutationHookOptions<CreateAppointmentMutation, CreateAppointmentMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<CreateAppointmentMutation, CreateAppointmentMutationVariables>(CreateAppointmentDocument, options);
      }
export type CreateAppointmentMutationHookResult = ReturnType<typeof useCreateAppointmentMutation>;
export type CreateAppointmentMutationResult = Apollo.MutationResult<CreateAppointmentMutation>;
export type CreateAppointmentMutationOptions = Apollo.BaseMutationOptions<CreateAppointmentMutation, CreateAppointmentMutationVariables>;
export const UpdateAppointmentDocument = gql`
    mutation updateAppointment($id: ID!, $data: UpdateAppointmentInput!) {
  updateAppointment(id: $id, data: $data) {
    ...AppointmentFields
  }
}
    ${AppointmentFieldsFragmentDoc}`;
export type UpdateAppointmentMutationFn = Apollo.MutationFunction<UpdateAppointmentMutation, UpdateAppointmentMutationVariables>;

/**
 * __useUpdateAppointmentMutation__
 *
 * To run a mutation, you first call `useUpdateAppointmentMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useUpdateAppointmentMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [updateAppointmentMutation, { data, loading, error }] = useUpdateAppointmentMutation({
 *   variables: {
 *      id: // value for 'id'
 *      data: // value for 'data'
 *   },
 * });
 */
export function useUpdateAppointmentMutation(baseOptions?: Apollo.MutationHookOptions<UpdateAppointmentMutation, UpdateAppointmentMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<UpdateAppointmentMutation, UpdateAppointmentMutationVariables>(UpdateAppointmentDocument, options);
      }
export type UpdateAppointmentMutationHookResult = ReturnType<typeof useUpdateAppointmentMutation>;
export type UpdateAppointmentMutationResult = Apollo.MutationResult<UpdateAppointmentMutation>;
export type UpdateAppointmentMutationOptions = Apollo.BaseMutationOptions<UpdateAppointmentMutation, UpdateAppointmentMutationVariables>;
export const MarkAppointmentAsResolvedDocument = gql`
    mutation markAppointmentAsResolved($id: ID!, $reason: ResolveReason) {
  markAppointmentAsResolved(id: $id, reason: $reason) {
    ...AppointmentFields
  }
}
    ${AppointmentFieldsFragmentDoc}`;
export type MarkAppointmentAsResolvedMutationFn = Apollo.MutationFunction<MarkAppointmentAsResolvedMutation, MarkAppointmentAsResolvedMutationVariables>;

/**
 * __useMarkAppointmentAsResolvedMutation__
 *
 * To run a mutation, you first call `useMarkAppointmentAsResolvedMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useMarkAppointmentAsResolvedMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [markAppointmentAsResolvedMutation, { data, loading, error }] = useMarkAppointmentAsResolvedMutation({
 *   variables: {
 *      id: // value for 'id'
 *      reason: // value for 'reason'
 *   },
 * });
 */
export function useMarkAppointmentAsResolvedMutation(baseOptions?: Apollo.MutationHookOptions<MarkAppointmentAsResolvedMutation, MarkAppointmentAsResolvedMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<MarkAppointmentAsResolvedMutation, MarkAppointmentAsResolvedMutationVariables>(MarkAppointmentAsResolvedDocument, options);
      }
export type MarkAppointmentAsResolvedMutationHookResult = ReturnType<typeof useMarkAppointmentAsResolvedMutation>;
export type MarkAppointmentAsResolvedMutationResult = Apollo.MutationResult<MarkAppointmentAsResolvedMutation>;
export type MarkAppointmentAsResolvedMutationOptions = Apollo.BaseMutationOptions<MarkAppointmentAsResolvedMutation, MarkAppointmentAsResolvedMutationVariables>;
export const ConfirmAppointmentDocument = gql`
    mutation confirmAppointment($id: ID!) {
  confirmAppointment(id: $id)
}
    `;
export type ConfirmAppointmentMutationFn = Apollo.MutationFunction<ConfirmAppointmentMutation, ConfirmAppointmentMutationVariables>;

/**
 * __useConfirmAppointmentMutation__
 *
 * To run a mutation, you first call `useConfirmAppointmentMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useConfirmAppointmentMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [confirmAppointmentMutation, { data, loading, error }] = useConfirmAppointmentMutation({
 *   variables: {
 *      id: // value for 'id'
 *   },
 * });
 */
export function useConfirmAppointmentMutation(baseOptions?: Apollo.MutationHookOptions<ConfirmAppointmentMutation, ConfirmAppointmentMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<ConfirmAppointmentMutation, ConfirmAppointmentMutationVariables>(ConfirmAppointmentDocument, options);
      }
export type ConfirmAppointmentMutationHookResult = ReturnType<typeof useConfirmAppointmentMutation>;
export type ConfirmAppointmentMutationResult = Apollo.MutationResult<ConfirmAppointmentMutation>;
export type ConfirmAppointmentMutationOptions = Apollo.BaseMutationOptions<ConfirmAppointmentMutation, ConfirmAppointmentMutationVariables>;
export const UpdateAppointmentClientPatientDocument = gql`
    mutation updateAppointmentClientPatient($id: ID!, $clientId: ID, $patientId: ID) {
  updateAppointmentClientPatient(
    id: $id
    clientId: $clientId
    patientId: $patientId
  ) {
    ...AppointmentFields
  }
}
    ${AppointmentFieldsFragmentDoc}`;
export type UpdateAppointmentClientPatientMutationFn = Apollo.MutationFunction<UpdateAppointmentClientPatientMutation, UpdateAppointmentClientPatientMutationVariables>;

/**
 * __useUpdateAppointmentClientPatientMutation__
 *
 * To run a mutation, you first call `useUpdateAppointmentClientPatientMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useUpdateAppointmentClientPatientMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [updateAppointmentClientPatientMutation, { data, loading, error }] = useUpdateAppointmentClientPatientMutation({
 *   variables: {
 *      id: // value for 'id'
 *      clientId: // value for 'clientId'
 *      patientId: // value for 'patientId'
 *   },
 * });
 */
export function useUpdateAppointmentClientPatientMutation(baseOptions?: Apollo.MutationHookOptions<UpdateAppointmentClientPatientMutation, UpdateAppointmentClientPatientMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<UpdateAppointmentClientPatientMutation, UpdateAppointmentClientPatientMutationVariables>(UpdateAppointmentClientPatientDocument, options);
      }
export type UpdateAppointmentClientPatientMutationHookResult = ReturnType<typeof useUpdateAppointmentClientPatientMutation>;
export type UpdateAppointmentClientPatientMutationResult = Apollo.MutationResult<UpdateAppointmentClientPatientMutation>;
export type UpdateAppointmentClientPatientMutationOptions = Apollo.BaseMutationOptions<UpdateAppointmentClientPatientMutation, UpdateAppointmentClientPatientMutationVariables>;
export const ClientConfirmAppointmentDocument = gql`
    mutation clientConfirmAppointment($id: ID!) {
  clientConfirmAppointment(id: $id) {
    ...AppointmentFields
  }
}
    ${AppointmentFieldsFragmentDoc}`;
export type ClientConfirmAppointmentMutationFn = Apollo.MutationFunction<ClientConfirmAppointmentMutation, ClientConfirmAppointmentMutationVariables>;

/**
 * __useClientConfirmAppointmentMutation__
 *
 * To run a mutation, you first call `useClientConfirmAppointmentMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useClientConfirmAppointmentMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [clientConfirmAppointmentMutation, { data, loading, error }] = useClientConfirmAppointmentMutation({
 *   variables: {
 *      id: // value for 'id'
 *   },
 * });
 */
export function useClientConfirmAppointmentMutation(baseOptions?: Apollo.MutationHookOptions<ClientConfirmAppointmentMutation, ClientConfirmAppointmentMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<ClientConfirmAppointmentMutation, ClientConfirmAppointmentMutationVariables>(ClientConfirmAppointmentDocument, options);
      }
export type ClientConfirmAppointmentMutationHookResult = ReturnType<typeof useClientConfirmAppointmentMutation>;
export type ClientConfirmAppointmentMutationResult = Apollo.MutationResult<ClientConfirmAppointmentMutation>;
export type ClientConfirmAppointmentMutationOptions = Apollo.BaseMutationOptions<ClientConfirmAppointmentMutation, ClientConfirmAppointmentMutationVariables>;
export const DeleteAppointmentDocument = gql`
    mutation deleteAppointment($id: ID!) {
  deleteAppointment(id: $id)
}
    `;
export type DeleteAppointmentMutationFn = Apollo.MutationFunction<DeleteAppointmentMutation, DeleteAppointmentMutationVariables>;

/**
 * __useDeleteAppointmentMutation__
 *
 * To run a mutation, you first call `useDeleteAppointmentMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useDeleteAppointmentMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [deleteAppointmentMutation, { data, loading, error }] = useDeleteAppointmentMutation({
 *   variables: {
 *      id: // value for 'id'
 *   },
 * });
 */
export function useDeleteAppointmentMutation(baseOptions?: Apollo.MutationHookOptions<DeleteAppointmentMutation, DeleteAppointmentMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<DeleteAppointmentMutation, DeleteAppointmentMutationVariables>(DeleteAppointmentDocument, options);
      }
export type DeleteAppointmentMutationHookResult = ReturnType<typeof useDeleteAppointmentMutation>;
export type DeleteAppointmentMutationResult = Apollo.MutationResult<DeleteAppointmentMutation>;
export type DeleteAppointmentMutationOptions = Apollo.BaseMutationOptions<DeleteAppointmentMutation, DeleteAppointmentMutationVariables>;
export const DenyPendingAppointmentDocument = gql`
    mutation denyPendingAppointment($appointmentId: ID!, $message: String!) {
  denyPendingAppointment(appointmentId: $appointmentId, message: $message) {
    id
  }
}
    `;
export type DenyPendingAppointmentMutationFn = Apollo.MutationFunction<DenyPendingAppointmentMutation, DenyPendingAppointmentMutationVariables>;

/**
 * __useDenyPendingAppointmentMutation__
 *
 * To run a mutation, you first call `useDenyPendingAppointmentMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useDenyPendingAppointmentMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [denyPendingAppointmentMutation, { data, loading, error }] = useDenyPendingAppointmentMutation({
 *   variables: {
 *      appointmentId: // value for 'appointmentId'
 *      message: // value for 'message'
 *   },
 * });
 */
export function useDenyPendingAppointmentMutation(baseOptions?: Apollo.MutationHookOptions<DenyPendingAppointmentMutation, DenyPendingAppointmentMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<DenyPendingAppointmentMutation, DenyPendingAppointmentMutationVariables>(DenyPendingAppointmentDocument, options);
      }
export type DenyPendingAppointmentMutationHookResult = ReturnType<typeof useDenyPendingAppointmentMutation>;
export type DenyPendingAppointmentMutationResult = Apollo.MutationResult<DenyPendingAppointmentMutation>;
export type DenyPendingAppointmentMutationOptions = Apollo.BaseMutationOptions<DenyPendingAppointmentMutation, DenyPendingAppointmentMutationVariables>;
export const RequestChangeForPendingAppointmentDocument = gql`
    mutation requestChangeForPendingAppointment($appointmentId: ID!, $message: String!) {
  requestChangeForPendingAppointment(
    appointmentId: $appointmentId
    message: $message
  ) {
    id
  }
}
    `;
export type RequestChangeForPendingAppointmentMutationFn = Apollo.MutationFunction<RequestChangeForPendingAppointmentMutation, RequestChangeForPendingAppointmentMutationVariables>;

/**
 * __useRequestChangeForPendingAppointmentMutation__
 *
 * To run a mutation, you first call `useRequestChangeForPendingAppointmentMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useRequestChangeForPendingAppointmentMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [requestChangeForPendingAppointmentMutation, { data, loading, error }] = useRequestChangeForPendingAppointmentMutation({
 *   variables: {
 *      appointmentId: // value for 'appointmentId'
 *      message: // value for 'message'
 *   },
 * });
 */
export function useRequestChangeForPendingAppointmentMutation(baseOptions?: Apollo.MutationHookOptions<RequestChangeForPendingAppointmentMutation, RequestChangeForPendingAppointmentMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<RequestChangeForPendingAppointmentMutation, RequestChangeForPendingAppointmentMutationVariables>(RequestChangeForPendingAppointmentDocument, options);
      }
export type RequestChangeForPendingAppointmentMutationHookResult = ReturnType<typeof useRequestChangeForPendingAppointmentMutation>;
export type RequestChangeForPendingAppointmentMutationResult = Apollo.MutationResult<RequestChangeForPendingAppointmentMutation>;
export type RequestChangeForPendingAppointmentMutationOptions = Apollo.BaseMutationOptions<RequestChangeForPendingAppointmentMutation, RequestChangeForPendingAppointmentMutationVariables>;
export const QueryClinicGroupAppointmentsDocument = gql`
    query queryClinicGroupAppointments($where: [QueryInput!], $page: NonNegativeInt, $pageSize: NonNegativeInt, $orderBy: OrderByInput) {
  queryAppointments(
    where: $where
    page: $page
    pageSize: $pageSize
    orderBy: $orderBy
  ) {
    ...ClinicGroupAppointmentFields
  }
}
    ${ClinicGroupAppointmentFieldsFragmentDoc}`;

/**
 * __useQueryClinicGroupAppointmentsQuery__
 *
 * To run a query within a React component, call `useQueryClinicGroupAppointmentsQuery` and pass it any options that fit your needs.
 * When your component renders, `useQueryClinicGroupAppointmentsQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useQueryClinicGroupAppointmentsQuery({
 *   variables: {
 *      where: // value for 'where'
 *      page: // value for 'page'
 *      pageSize: // value for 'pageSize'
 *      orderBy: // value for 'orderBy'
 *   },
 * });
 */
export function useQueryClinicGroupAppointmentsQuery(baseOptions?: Apollo.QueryHookOptions<QueryClinicGroupAppointmentsQuery, QueryClinicGroupAppointmentsQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<QueryClinicGroupAppointmentsQuery, QueryClinicGroupAppointmentsQueryVariables>(QueryClinicGroupAppointmentsDocument, options);
      }
export function useQueryClinicGroupAppointmentsLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<QueryClinicGroupAppointmentsQuery, QueryClinicGroupAppointmentsQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<QueryClinicGroupAppointmentsQuery, QueryClinicGroupAppointmentsQueryVariables>(QueryClinicGroupAppointmentsDocument, options);
        }
export function useQueryClinicGroupAppointmentsSuspenseQuery(baseOptions?: Apollo.SuspenseQueryHookOptions<QueryClinicGroupAppointmentsQuery, QueryClinicGroupAppointmentsQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useSuspenseQuery<QueryClinicGroupAppointmentsQuery, QueryClinicGroupAppointmentsQueryVariables>(QueryClinicGroupAppointmentsDocument, options);
        }
export type QueryClinicGroupAppointmentsQueryHookResult = ReturnType<typeof useQueryClinicGroupAppointmentsQuery>;
export type QueryClinicGroupAppointmentsLazyQueryHookResult = ReturnType<typeof useQueryClinicGroupAppointmentsLazyQuery>;
export type QueryClinicGroupAppointmentsSuspenseQueryHookResult = ReturnType<typeof useQueryClinicGroupAppointmentsSuspenseQuery>;
export type QueryClinicGroupAppointmentsQueryResult = Apollo.QueryResult<QueryClinicGroupAppointmentsQuery, QueryClinicGroupAppointmentsQueryVariables>;
export const QueryAppointmentsForCsvExportDocument = gql`
    query queryAppointmentsForCsvExport($where: [QueryInput!], $page: NonNegativeInt, $pageSize: NonNegativeInt, $orderBy: OrderByInput) {
  queryAppointments(
    where: $where
    page: $page
    pageSize: $pageSize
    orderBy: $orderBy
  ) {
    ...AppointmentCsvExportFields
  }
}
    ${AppointmentCsvExportFieldsFragmentDoc}`;

/**
 * __useQueryAppointmentsForCsvExportQuery__
 *
 * To run a query within a React component, call `useQueryAppointmentsForCsvExportQuery` and pass it any options that fit your needs.
 * When your component renders, `useQueryAppointmentsForCsvExportQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useQueryAppointmentsForCsvExportQuery({
 *   variables: {
 *      where: // value for 'where'
 *      page: // value for 'page'
 *      pageSize: // value for 'pageSize'
 *      orderBy: // value for 'orderBy'
 *   },
 * });
 */
export function useQueryAppointmentsForCsvExportQuery(baseOptions?: Apollo.QueryHookOptions<QueryAppointmentsForCsvExportQuery, QueryAppointmentsForCsvExportQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<QueryAppointmentsForCsvExportQuery, QueryAppointmentsForCsvExportQueryVariables>(QueryAppointmentsForCsvExportDocument, options);
      }
export function useQueryAppointmentsForCsvExportLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<QueryAppointmentsForCsvExportQuery, QueryAppointmentsForCsvExportQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<QueryAppointmentsForCsvExportQuery, QueryAppointmentsForCsvExportQueryVariables>(QueryAppointmentsForCsvExportDocument, options);
        }
export function useQueryAppointmentsForCsvExportSuspenseQuery(baseOptions?: Apollo.SuspenseQueryHookOptions<QueryAppointmentsForCsvExportQuery, QueryAppointmentsForCsvExportQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useSuspenseQuery<QueryAppointmentsForCsvExportQuery, QueryAppointmentsForCsvExportQueryVariables>(QueryAppointmentsForCsvExportDocument, options);
        }
export type QueryAppointmentsForCsvExportQueryHookResult = ReturnType<typeof useQueryAppointmentsForCsvExportQuery>;
export type QueryAppointmentsForCsvExportLazyQueryHookResult = ReturnType<typeof useQueryAppointmentsForCsvExportLazyQuery>;
export type QueryAppointmentsForCsvExportSuspenseQueryHookResult = ReturnType<typeof useQueryAppointmentsForCsvExportSuspenseQuery>;
export type QueryAppointmentsForCsvExportQueryResult = Apollo.QueryResult<QueryAppointmentsForCsvExportQuery, QueryAppointmentsForCsvExportQueryVariables>;
export const GetBillableUsageStatsByTypeDocument = gql`
    query getBillableUsageStatsByType($clinicId: ID!, $startDate: NonNegativeInt, $endDate: NonNegativeInt) {
  billableUsageStatsByType(
    clinicId: $clinicId
    startDate: $startDate
    endDate: $endDate
  ) {
    entity_type
    current_billing_period_usage
    all_time_usage
  }
}
    `;

/**
 * __useGetBillableUsageStatsByTypeQuery__
 *
 * To run a query within a React component, call `useGetBillableUsageStatsByTypeQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetBillableUsageStatsByTypeQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetBillableUsageStatsByTypeQuery({
 *   variables: {
 *      clinicId: // value for 'clinicId'
 *      startDate: // value for 'startDate'
 *      endDate: // value for 'endDate'
 *   },
 * });
 */
export function useGetBillableUsageStatsByTypeQuery(baseOptions: Apollo.QueryHookOptions<GetBillableUsageStatsByTypeQuery, GetBillableUsageStatsByTypeQueryVariables> & ({ variables: GetBillableUsageStatsByTypeQueryVariables; skip?: boolean; } | { skip: boolean; }) ) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<GetBillableUsageStatsByTypeQuery, GetBillableUsageStatsByTypeQueryVariables>(GetBillableUsageStatsByTypeDocument, options);
      }
export function useGetBillableUsageStatsByTypeLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<GetBillableUsageStatsByTypeQuery, GetBillableUsageStatsByTypeQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<GetBillableUsageStatsByTypeQuery, GetBillableUsageStatsByTypeQueryVariables>(GetBillableUsageStatsByTypeDocument, options);
        }
export function useGetBillableUsageStatsByTypeSuspenseQuery(baseOptions?: Apollo.SuspenseQueryHookOptions<GetBillableUsageStatsByTypeQuery, GetBillableUsageStatsByTypeQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useSuspenseQuery<GetBillableUsageStatsByTypeQuery, GetBillableUsageStatsByTypeQueryVariables>(GetBillableUsageStatsByTypeDocument, options);
        }
export type GetBillableUsageStatsByTypeQueryHookResult = ReturnType<typeof useGetBillableUsageStatsByTypeQuery>;
export type GetBillableUsageStatsByTypeLazyQueryHookResult = ReturnType<typeof useGetBillableUsageStatsByTypeLazyQuery>;
export type GetBillableUsageStatsByTypeSuspenseQueryHookResult = ReturnType<typeof useGetBillableUsageStatsByTypeSuspenseQuery>;
export type GetBillableUsageStatsByTypeQueryResult = Apollo.QueryResult<GetBillableUsageStatsByTypeQuery, GetBillableUsageStatsByTypeQueryVariables>;
export const GetBookingFlowFunnelDocument = gql`
    query getBookingFlowFunnel($filters: BookingFlowFunnelFilters!) {
  bookingFlowFunnel(filters: $filters) {
    ...BookingFlowFunnelStepFields
  }
}
    ${BookingFlowFunnelStepFieldsFragmentDoc}`;

/**
 * __useGetBookingFlowFunnelQuery__
 *
 * To run a query within a React component, call `useGetBookingFlowFunnelQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetBookingFlowFunnelQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetBookingFlowFunnelQuery({
 *   variables: {
 *      filters: // value for 'filters'
 *   },
 * });
 */
export function useGetBookingFlowFunnelQuery(baseOptions: Apollo.QueryHookOptions<GetBookingFlowFunnelQuery, GetBookingFlowFunnelQueryVariables> & ({ variables: GetBookingFlowFunnelQueryVariables; skip?: boolean; } | { skip: boolean; }) ) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<GetBookingFlowFunnelQuery, GetBookingFlowFunnelQueryVariables>(GetBookingFlowFunnelDocument, options);
      }
export function useGetBookingFlowFunnelLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<GetBookingFlowFunnelQuery, GetBookingFlowFunnelQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<GetBookingFlowFunnelQuery, GetBookingFlowFunnelQueryVariables>(GetBookingFlowFunnelDocument, options);
        }
export function useGetBookingFlowFunnelSuspenseQuery(baseOptions?: Apollo.SuspenseQueryHookOptions<GetBookingFlowFunnelQuery, GetBookingFlowFunnelQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useSuspenseQuery<GetBookingFlowFunnelQuery, GetBookingFlowFunnelQueryVariables>(GetBookingFlowFunnelDocument, options);
        }
export type GetBookingFlowFunnelQueryHookResult = ReturnType<typeof useGetBookingFlowFunnelQuery>;
export type GetBookingFlowFunnelLazyQueryHookResult = ReturnType<typeof useGetBookingFlowFunnelLazyQuery>;
export type GetBookingFlowFunnelSuspenseQueryHookResult = ReturnType<typeof useGetBookingFlowFunnelSuspenseQuery>;
export type GetBookingFlowFunnelQueryResult = Apollo.QueryResult<GetBookingFlowFunnelQuery, GetBookingFlowFunnelQueryVariables>;
export const GetBookingSourceAnalyticsDocument = gql`
    query getBookingSourceAnalytics($clinicGroupId: ID!, $range: UsageTimeRangeInput!) {
  bookingSourceAnalytics(clinic_group_id: $clinicGroupId, range: $range) {
    widgets {
      ...WidgetBookingSourceStatsFields
    }
    portal_without_widget {
      ...ClinicBookingSourceStatsFields
    }
    clinics {
      ...ClinicBookingSourceStatsFields
    }
  }
}
    ${WidgetBookingSourceStatsFieldsFragmentDoc}
${ClinicBookingSourceStatsFieldsFragmentDoc}`;

/**
 * __useGetBookingSourceAnalyticsQuery__
 *
 * To run a query within a React component, call `useGetBookingSourceAnalyticsQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetBookingSourceAnalyticsQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetBookingSourceAnalyticsQuery({
 *   variables: {
 *      clinicGroupId: // value for 'clinicGroupId'
 *      range: // value for 'range'
 *   },
 * });
 */
export function useGetBookingSourceAnalyticsQuery(baseOptions: Apollo.QueryHookOptions<GetBookingSourceAnalyticsQuery, GetBookingSourceAnalyticsQueryVariables> & ({ variables: GetBookingSourceAnalyticsQueryVariables; skip?: boolean; } | { skip: boolean; }) ) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<GetBookingSourceAnalyticsQuery, GetBookingSourceAnalyticsQueryVariables>(GetBookingSourceAnalyticsDocument, options);
      }
export function useGetBookingSourceAnalyticsLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<GetBookingSourceAnalyticsQuery, GetBookingSourceAnalyticsQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<GetBookingSourceAnalyticsQuery, GetBookingSourceAnalyticsQueryVariables>(GetBookingSourceAnalyticsDocument, options);
        }
export function useGetBookingSourceAnalyticsSuspenseQuery(baseOptions?: Apollo.SuspenseQueryHookOptions<GetBookingSourceAnalyticsQuery, GetBookingSourceAnalyticsQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useSuspenseQuery<GetBookingSourceAnalyticsQuery, GetBookingSourceAnalyticsQueryVariables>(GetBookingSourceAnalyticsDocument, options);
        }
export type GetBookingSourceAnalyticsQueryHookResult = ReturnType<typeof useGetBookingSourceAnalyticsQuery>;
export type GetBookingSourceAnalyticsLazyQueryHookResult = ReturnType<typeof useGetBookingSourceAnalyticsLazyQuery>;
export type GetBookingSourceAnalyticsSuspenseQueryHookResult = ReturnType<typeof useGetBookingSourceAnalyticsSuspenseQuery>;
export type GetBookingSourceAnalyticsQueryResult = Apollo.QueryResult<GetBookingSourceAnalyticsQuery, GetBookingSourceAnalyticsQueryVariables>;
export const GetClinicBookingSourceAnalyticsDocument = gql`
    query getClinicBookingSourceAnalytics($clinicId: ID!, $range: UsageTimeRangeInput!) {
  clinicBookingSourceAnalytics(clinic_id: $clinicId, range: $range) {
    widgets {
      ...WidgetBookingSourceStatsFields
    }
    portal_without_widget {
      ...ClinicBookingSourceStatsFields
    }
    clinics {
      ...ClinicBookingSourceStatsFields
    }
  }
}
    ${WidgetBookingSourceStatsFieldsFragmentDoc}
${ClinicBookingSourceStatsFieldsFragmentDoc}`;

/**
 * __useGetClinicBookingSourceAnalyticsQuery__
 *
 * To run a query within a React component, call `useGetClinicBookingSourceAnalyticsQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetClinicBookingSourceAnalyticsQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetClinicBookingSourceAnalyticsQuery({
 *   variables: {
 *      clinicId: // value for 'clinicId'
 *      range: // value for 'range'
 *   },
 * });
 */
export function useGetClinicBookingSourceAnalyticsQuery(baseOptions: Apollo.QueryHookOptions<GetClinicBookingSourceAnalyticsQuery, GetClinicBookingSourceAnalyticsQueryVariables> & ({ variables: GetClinicBookingSourceAnalyticsQueryVariables; skip?: boolean; } | { skip: boolean; }) ) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<GetClinicBookingSourceAnalyticsQuery, GetClinicBookingSourceAnalyticsQueryVariables>(GetClinicBookingSourceAnalyticsDocument, options);
      }
export function useGetClinicBookingSourceAnalyticsLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<GetClinicBookingSourceAnalyticsQuery, GetClinicBookingSourceAnalyticsQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<GetClinicBookingSourceAnalyticsQuery, GetClinicBookingSourceAnalyticsQueryVariables>(GetClinicBookingSourceAnalyticsDocument, options);
        }
export function useGetClinicBookingSourceAnalyticsSuspenseQuery(baseOptions?: Apollo.SuspenseQueryHookOptions<GetClinicBookingSourceAnalyticsQuery, GetClinicBookingSourceAnalyticsQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useSuspenseQuery<GetClinicBookingSourceAnalyticsQuery, GetClinicBookingSourceAnalyticsQueryVariables>(GetClinicBookingSourceAnalyticsDocument, options);
        }
export type GetClinicBookingSourceAnalyticsQueryHookResult = ReturnType<typeof useGetClinicBookingSourceAnalyticsQuery>;
export type GetClinicBookingSourceAnalyticsLazyQueryHookResult = ReturnType<typeof useGetClinicBookingSourceAnalyticsLazyQuery>;
export type GetClinicBookingSourceAnalyticsSuspenseQueryHookResult = ReturnType<typeof useGetClinicBookingSourceAnalyticsSuspenseQuery>;
export type GetClinicBookingSourceAnalyticsQueryResult = Apollo.QueryResult<GetClinicBookingSourceAnalyticsQuery, GetClinicBookingSourceAnalyticsQueryVariables>;
export const GetBookingAttributionAnalyticsDocument = gql`
    query getBookingAttributionAnalytics($clinicGroupId: ID!, $range: UsageTimeRangeInput!, $dimension: BookingAttributionDimension!) {
  bookingAttributionAnalytics(
    clinic_group_id: $clinicGroupId
    range: $range
    dimension: $dimension
  ) {
    ...BookingAttributionStatsFields
  }
}
    ${BookingAttributionStatsFieldsFragmentDoc}`;

/**
 * __useGetBookingAttributionAnalyticsQuery__
 *
 * To run a query within a React component, call `useGetBookingAttributionAnalyticsQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetBookingAttributionAnalyticsQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetBookingAttributionAnalyticsQuery({
 *   variables: {
 *      clinicGroupId: // value for 'clinicGroupId'
 *      range: // value for 'range'
 *      dimension: // value for 'dimension'
 *   },
 * });
 */
export function useGetBookingAttributionAnalyticsQuery(baseOptions: Apollo.QueryHookOptions<GetBookingAttributionAnalyticsQuery, GetBookingAttributionAnalyticsQueryVariables> & ({ variables: GetBookingAttributionAnalyticsQueryVariables; skip?: boolean; } | { skip: boolean; }) ) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<GetBookingAttributionAnalyticsQuery, GetBookingAttributionAnalyticsQueryVariables>(GetBookingAttributionAnalyticsDocument, options);
      }
export function useGetBookingAttributionAnalyticsLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<GetBookingAttributionAnalyticsQuery, GetBookingAttributionAnalyticsQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<GetBookingAttributionAnalyticsQuery, GetBookingAttributionAnalyticsQueryVariables>(GetBookingAttributionAnalyticsDocument, options);
        }
export function useGetBookingAttributionAnalyticsSuspenseQuery(baseOptions?: Apollo.SuspenseQueryHookOptions<GetBookingAttributionAnalyticsQuery, GetBookingAttributionAnalyticsQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useSuspenseQuery<GetBookingAttributionAnalyticsQuery, GetBookingAttributionAnalyticsQueryVariables>(GetBookingAttributionAnalyticsDocument, options);
        }
export type GetBookingAttributionAnalyticsQueryHookResult = ReturnType<typeof useGetBookingAttributionAnalyticsQuery>;
export type GetBookingAttributionAnalyticsLazyQueryHookResult = ReturnType<typeof useGetBookingAttributionAnalyticsLazyQuery>;
export type GetBookingAttributionAnalyticsSuspenseQueryHookResult = ReturnType<typeof useGetBookingAttributionAnalyticsSuspenseQuery>;
export type GetBookingAttributionAnalyticsQueryResult = Apollo.QueryResult<GetBookingAttributionAnalyticsQuery, GetBookingAttributionAnalyticsQueryVariables>;
export const GetClinicBookingAttributionAnalyticsDocument = gql`
    query getClinicBookingAttributionAnalytics($clinicId: ID!, $range: UsageTimeRangeInput!, $dimension: BookingAttributionDimension!) {
  clinicBookingAttributionAnalytics(
    clinic_id: $clinicId
    range: $range
    dimension: $dimension
  ) {
    ...BookingAttributionStatsFields
  }
}
    ${BookingAttributionStatsFieldsFragmentDoc}`;

/**
 * __useGetClinicBookingAttributionAnalyticsQuery__
 *
 * To run a query within a React component, call `useGetClinicBookingAttributionAnalyticsQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetClinicBookingAttributionAnalyticsQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetClinicBookingAttributionAnalyticsQuery({
 *   variables: {
 *      clinicId: // value for 'clinicId'
 *      range: // value for 'range'
 *      dimension: // value for 'dimension'
 *   },
 * });
 */
export function useGetClinicBookingAttributionAnalyticsQuery(baseOptions: Apollo.QueryHookOptions<GetClinicBookingAttributionAnalyticsQuery, GetClinicBookingAttributionAnalyticsQueryVariables> & ({ variables: GetClinicBookingAttributionAnalyticsQueryVariables; skip?: boolean; } | { skip: boolean; }) ) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<GetClinicBookingAttributionAnalyticsQuery, GetClinicBookingAttributionAnalyticsQueryVariables>(GetClinicBookingAttributionAnalyticsDocument, options);
      }
export function useGetClinicBookingAttributionAnalyticsLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<GetClinicBookingAttributionAnalyticsQuery, GetClinicBookingAttributionAnalyticsQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<GetClinicBookingAttributionAnalyticsQuery, GetClinicBookingAttributionAnalyticsQueryVariables>(GetClinicBookingAttributionAnalyticsDocument, options);
        }
export function useGetClinicBookingAttributionAnalyticsSuspenseQuery(baseOptions?: Apollo.SuspenseQueryHookOptions<GetClinicBookingAttributionAnalyticsQuery, GetClinicBookingAttributionAnalyticsQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useSuspenseQuery<GetClinicBookingAttributionAnalyticsQuery, GetClinicBookingAttributionAnalyticsQueryVariables>(GetClinicBookingAttributionAnalyticsDocument, options);
        }
export type GetClinicBookingAttributionAnalyticsQueryHookResult = ReturnType<typeof useGetClinicBookingAttributionAnalyticsQuery>;
export type GetClinicBookingAttributionAnalyticsLazyQueryHookResult = ReturnType<typeof useGetClinicBookingAttributionAnalyticsLazyQuery>;
export type GetClinicBookingAttributionAnalyticsSuspenseQueryHookResult = ReturnType<typeof useGetClinicBookingAttributionAnalyticsSuspenseQuery>;
export type GetClinicBookingAttributionAnalyticsQueryResult = Apollo.QueryResult<GetClinicBookingAttributionAnalyticsQuery, GetClinicBookingAttributionAnalyticsQueryVariables>;
export const GetBreedsByClinicDocument = gql`
    query getBreedsByClinic($clinicId: ID!) {
  getBreedsByClinic(clinicId: $clinicId) {
    ...BreedFields
  }
}
    ${BreedFieldsFragmentDoc}`;

/**
 * __useGetBreedsByClinicQuery__
 *
 * To run a query within a React component, call `useGetBreedsByClinicQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetBreedsByClinicQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetBreedsByClinicQuery({
 *   variables: {
 *      clinicId: // value for 'clinicId'
 *   },
 * });
 */
export function useGetBreedsByClinicQuery(baseOptions: Apollo.QueryHookOptions<GetBreedsByClinicQuery, GetBreedsByClinicQueryVariables> & ({ variables: GetBreedsByClinicQueryVariables; skip?: boolean; } | { skip: boolean; }) ) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<GetBreedsByClinicQuery, GetBreedsByClinicQueryVariables>(GetBreedsByClinicDocument, options);
      }
export function useGetBreedsByClinicLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<GetBreedsByClinicQuery, GetBreedsByClinicQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<GetBreedsByClinicQuery, GetBreedsByClinicQueryVariables>(GetBreedsByClinicDocument, options);
        }
export function useGetBreedsByClinicSuspenseQuery(baseOptions?: Apollo.SuspenseQueryHookOptions<GetBreedsByClinicQuery, GetBreedsByClinicQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useSuspenseQuery<GetBreedsByClinicQuery, GetBreedsByClinicQueryVariables>(GetBreedsByClinicDocument, options);
        }
export type GetBreedsByClinicQueryHookResult = ReturnType<typeof useGetBreedsByClinicQuery>;
export type GetBreedsByClinicLazyQueryHookResult = ReturnType<typeof useGetBreedsByClinicLazyQuery>;
export type GetBreedsByClinicSuspenseQueryHookResult = ReturnType<typeof useGetBreedsByClinicSuspenseQuery>;
export type GetBreedsByClinicQueryResult = Apollo.QueryResult<GetBreedsByClinicQuery, GetBreedsByClinicQueryVariables>;
export const QueryBreedsDocument = gql`
    query queryBreeds($where: [QueryInput!], $page: NonNegativeInt, $pageSize: NonNegativeInt, $orderBy: OrderByInput) {
  queryBreeds(where: $where, page: $page, pageSize: $pageSize, orderBy: $orderBy) {
    ...BreedFields
  }
}
    ${BreedFieldsFragmentDoc}`;

/**
 * __useQueryBreedsQuery__
 *
 * To run a query within a React component, call `useQueryBreedsQuery` and pass it any options that fit your needs.
 * When your component renders, `useQueryBreedsQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useQueryBreedsQuery({
 *   variables: {
 *      where: // value for 'where'
 *      page: // value for 'page'
 *      pageSize: // value for 'pageSize'
 *      orderBy: // value for 'orderBy'
 *   },
 * });
 */
export function useQueryBreedsQuery(baseOptions?: Apollo.QueryHookOptions<QueryBreedsQuery, QueryBreedsQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<QueryBreedsQuery, QueryBreedsQueryVariables>(QueryBreedsDocument, options);
      }
export function useQueryBreedsLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<QueryBreedsQuery, QueryBreedsQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<QueryBreedsQuery, QueryBreedsQueryVariables>(QueryBreedsDocument, options);
        }
export function useQueryBreedsSuspenseQuery(baseOptions?: Apollo.SuspenseQueryHookOptions<QueryBreedsQuery, QueryBreedsQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useSuspenseQuery<QueryBreedsQuery, QueryBreedsQueryVariables>(QueryBreedsDocument, options);
        }
export type QueryBreedsQueryHookResult = ReturnType<typeof useQueryBreedsQuery>;
export type QueryBreedsLazyQueryHookResult = ReturnType<typeof useQueryBreedsLazyQuery>;
export type QueryBreedsSuspenseQueryHookResult = ReturnType<typeof useQueryBreedsSuspenseQuery>;
export type QueryBreedsQueryResult = Apollo.QueryResult<QueryBreedsQuery, QueryBreedsQueryVariables>;
export const QueryClinicCallsDocument = gql`
    query queryClinicCalls($where: [QueryInput!], $page: NonNegativeInt, $pageSize: NonNegativeInt, $orderBy: OrderByInput, $clinicId: ID!) {
  queryClinicCalls(
    where: $where
    page: $page
    pageSize: $pageSize
    orderBy: $orderBy
    clinicId: $clinicId
  ) {
    ...CallFields
  }
}
    ${CallFieldsFragmentDoc}`;

/**
 * __useQueryClinicCallsQuery__
 *
 * To run a query within a React component, call `useQueryClinicCallsQuery` and pass it any options that fit your needs.
 * When your component renders, `useQueryClinicCallsQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useQueryClinicCallsQuery({
 *   variables: {
 *      where: // value for 'where'
 *      page: // value for 'page'
 *      pageSize: // value for 'pageSize'
 *      orderBy: // value for 'orderBy'
 *      clinicId: // value for 'clinicId'
 *   },
 * });
 */
export function useQueryClinicCallsQuery(baseOptions: Apollo.QueryHookOptions<QueryClinicCallsQuery, QueryClinicCallsQueryVariables> & ({ variables: QueryClinicCallsQueryVariables; skip?: boolean; } | { skip: boolean; }) ) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<QueryClinicCallsQuery, QueryClinicCallsQueryVariables>(QueryClinicCallsDocument, options);
      }
export function useQueryClinicCallsLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<QueryClinicCallsQuery, QueryClinicCallsQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<QueryClinicCallsQuery, QueryClinicCallsQueryVariables>(QueryClinicCallsDocument, options);
        }
export function useQueryClinicCallsSuspenseQuery(baseOptions?: Apollo.SuspenseQueryHookOptions<QueryClinicCallsQuery, QueryClinicCallsQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useSuspenseQuery<QueryClinicCallsQuery, QueryClinicCallsQueryVariables>(QueryClinicCallsDocument, options);
        }
export type QueryClinicCallsQueryHookResult = ReturnType<typeof useQueryClinicCallsQuery>;
export type QueryClinicCallsLazyQueryHookResult = ReturnType<typeof useQueryClinicCallsLazyQuery>;
export type QueryClinicCallsSuspenseQueryHookResult = ReturnType<typeof useQueryClinicCallsSuspenseQuery>;
export type QueryClinicCallsQueryResult = Apollo.QueryResult<QueryClinicCallsQuery, QueryClinicCallsQueryVariables>;
export const CountCallsDocument = gql`
    query countCalls($where: [QueryInput!]) {
  countCalls(where: $where)
}
    `;

/**
 * __useCountCallsQuery__
 *
 * To run a query within a React component, call `useCountCallsQuery` and pass it any options that fit your needs.
 * When your component renders, `useCountCallsQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useCountCallsQuery({
 *   variables: {
 *      where: // value for 'where'
 *   },
 * });
 */
export function useCountCallsQuery(baseOptions?: Apollo.QueryHookOptions<CountCallsQuery, CountCallsQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<CountCallsQuery, CountCallsQueryVariables>(CountCallsDocument, options);
      }
export function useCountCallsLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<CountCallsQuery, CountCallsQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<CountCallsQuery, CountCallsQueryVariables>(CountCallsDocument, options);
        }
export function useCountCallsSuspenseQuery(baseOptions?: Apollo.SuspenseQueryHookOptions<CountCallsQuery, CountCallsQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useSuspenseQuery<CountCallsQuery, CountCallsQueryVariables>(CountCallsDocument, options);
        }
export type CountCallsQueryHookResult = ReturnType<typeof useCountCallsQuery>;
export type CountCallsLazyQueryHookResult = ReturnType<typeof useCountCallsLazyQuery>;
export type CountCallsSuspenseQueryHookResult = ReturnType<typeof useCountCallsSuspenseQuery>;
export type CountCallsQueryResult = Apollo.QueryResult<CountCallsQuery, CountCallsQueryVariables>;
export const ClinicCallStatsDocument = gql`
    query clinicCallStats($clinicId: ID!, $where: [QueryInput!]) {
  clinicCallStats(clinicId: $clinicId, where: $where) {
    total_calls
    automated_calls
    appointments_booked
    revenue_created_cents
    time_saved_minutes
    average_score
    average_sentiment
  }
}
    `;

/**
 * __useClinicCallStatsQuery__
 *
 * To run a query within a React component, call `useClinicCallStatsQuery` and pass it any options that fit your needs.
 * When your component renders, `useClinicCallStatsQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useClinicCallStatsQuery({
 *   variables: {
 *      clinicId: // value for 'clinicId'
 *      where: // value for 'where'
 *   },
 * });
 */
export function useClinicCallStatsQuery(baseOptions: Apollo.QueryHookOptions<ClinicCallStatsQuery, ClinicCallStatsQueryVariables> & ({ variables: ClinicCallStatsQueryVariables; skip?: boolean; } | { skip: boolean; }) ) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<ClinicCallStatsQuery, ClinicCallStatsQueryVariables>(ClinicCallStatsDocument, options);
      }
export function useClinicCallStatsLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<ClinicCallStatsQuery, ClinicCallStatsQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<ClinicCallStatsQuery, ClinicCallStatsQueryVariables>(ClinicCallStatsDocument, options);
        }
export function useClinicCallStatsSuspenseQuery(baseOptions?: Apollo.SuspenseQueryHookOptions<ClinicCallStatsQuery, ClinicCallStatsQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useSuspenseQuery<ClinicCallStatsQuery, ClinicCallStatsQueryVariables>(ClinicCallStatsDocument, options);
        }
export type ClinicCallStatsQueryHookResult = ReturnType<typeof useClinicCallStatsQuery>;
export type ClinicCallStatsLazyQueryHookResult = ReturnType<typeof useClinicCallStatsLazyQuery>;
export type ClinicCallStatsSuspenseQueryHookResult = ReturnType<typeof useClinicCallStatsSuspenseQuery>;
export type ClinicCallStatsQueryResult = Apollo.QueryResult<ClinicCallStatsQuery, ClinicCallStatsQueryVariables>;
export const UpdateCallDocument = gql`
    mutation updateCall($id: ID!, $input: UpdateCallInput!) {
  updateCall(id: $id, input: $input) {
    ...CallFields
  }
}
    ${CallFieldsFragmentDoc}`;
export type UpdateCallMutationFn = Apollo.MutationFunction<UpdateCallMutation, UpdateCallMutationVariables>;

/**
 * __useUpdateCallMutation__
 *
 * To run a mutation, you first call `useUpdateCallMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useUpdateCallMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [updateCallMutation, { data, loading, error }] = useUpdateCallMutation({
 *   variables: {
 *      id: // value for 'id'
 *      input: // value for 'input'
 *   },
 * });
 */
export function useUpdateCallMutation(baseOptions?: Apollo.MutationHookOptions<UpdateCallMutation, UpdateCallMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<UpdateCallMutation, UpdateCallMutationVariables>(UpdateCallDocument, options);
      }
export type UpdateCallMutationHookResult = ReturnType<typeof useUpdateCallMutation>;
export type UpdateCallMutationResult = Apollo.MutationResult<UpdateCallMutation>;
export type UpdateCallMutationOptions = Apollo.BaseMutationOptions<UpdateCallMutation, UpdateCallMutationVariables>;
export const CampaignStatsDocument = gql`
    query campaignStats($clinicId: ID!, $campaignId: ID!) {
  campaignStats(clinicId: $clinicId, campaignId: $campaignId) {
    ...CampaignStatsFields
  }
}
    ${CampaignStatsFieldsFragmentDoc}`;

/**
 * __useCampaignStatsQuery__
 *
 * To run a query within a React component, call `useCampaignStatsQuery` and pass it any options that fit your needs.
 * When your component renders, `useCampaignStatsQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useCampaignStatsQuery({
 *   variables: {
 *      clinicId: // value for 'clinicId'
 *      campaignId: // value for 'campaignId'
 *   },
 * });
 */
export function useCampaignStatsQuery(baseOptions: Apollo.QueryHookOptions<CampaignStatsQuery, CampaignStatsQueryVariables> & ({ variables: CampaignStatsQueryVariables; skip?: boolean; } | { skip: boolean; }) ) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<CampaignStatsQuery, CampaignStatsQueryVariables>(CampaignStatsDocument, options);
      }
export function useCampaignStatsLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<CampaignStatsQuery, CampaignStatsQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<CampaignStatsQuery, CampaignStatsQueryVariables>(CampaignStatsDocument, options);
        }
export function useCampaignStatsSuspenseQuery(baseOptions?: Apollo.SuspenseQueryHookOptions<CampaignStatsQuery, CampaignStatsQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useSuspenseQuery<CampaignStatsQuery, CampaignStatsQueryVariables>(CampaignStatsDocument, options);
        }
export type CampaignStatsQueryHookResult = ReturnType<typeof useCampaignStatsQuery>;
export type CampaignStatsLazyQueryHookResult = ReturnType<typeof useCampaignStatsLazyQuery>;
export type CampaignStatsSuspenseQueryHookResult = ReturnType<typeof useCampaignStatsSuspenseQuery>;
export type CampaignStatsQueryResult = Apollo.QueryResult<CampaignStatsQuery, CampaignStatsQueryVariables>;
export const GetCampaignWidgetStatsDocument = gql`
    query getCampaignWidgetStats($clinicId: ID!, $widgetId: ID!) {
  campaignWidgetStats(clinicId: $clinicId, widgetId: $widgetId) {
    ...CampaignWidgetStatFields
  }
}
    ${CampaignWidgetStatFieldsFragmentDoc}`;

/**
 * __useGetCampaignWidgetStatsQuery__
 *
 * To run a query within a React component, call `useGetCampaignWidgetStatsQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetCampaignWidgetStatsQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetCampaignWidgetStatsQuery({
 *   variables: {
 *      clinicId: // value for 'clinicId'
 *      widgetId: // value for 'widgetId'
 *   },
 * });
 */
export function useGetCampaignWidgetStatsQuery(baseOptions: Apollo.QueryHookOptions<GetCampaignWidgetStatsQuery, GetCampaignWidgetStatsQueryVariables> & ({ variables: GetCampaignWidgetStatsQueryVariables; skip?: boolean; } | { skip: boolean; }) ) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<GetCampaignWidgetStatsQuery, GetCampaignWidgetStatsQueryVariables>(GetCampaignWidgetStatsDocument, options);
      }
export function useGetCampaignWidgetStatsLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<GetCampaignWidgetStatsQuery, GetCampaignWidgetStatsQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<GetCampaignWidgetStatsQuery, GetCampaignWidgetStatsQueryVariables>(GetCampaignWidgetStatsDocument, options);
        }
export function useGetCampaignWidgetStatsSuspenseQuery(baseOptions?: Apollo.SuspenseQueryHookOptions<GetCampaignWidgetStatsQuery, GetCampaignWidgetStatsQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useSuspenseQuery<GetCampaignWidgetStatsQuery, GetCampaignWidgetStatsQueryVariables>(GetCampaignWidgetStatsDocument, options);
        }
export type GetCampaignWidgetStatsQueryHookResult = ReturnType<typeof useGetCampaignWidgetStatsQuery>;
export type GetCampaignWidgetStatsLazyQueryHookResult = ReturnType<typeof useGetCampaignWidgetStatsLazyQuery>;
export type GetCampaignWidgetStatsSuspenseQueryHookResult = ReturnType<typeof useGetCampaignWidgetStatsSuspenseQuery>;
export type GetCampaignWidgetStatsQueryResult = Apollo.QueryResult<GetCampaignWidgetStatsQuery, GetCampaignWidgetStatsQueryVariables>;
export const GetCampaignNotificationStatsDocument = gql`
    query getCampaignNotificationStats($clinicId: ID!, $notificationId: ID!) {
  campaignNotificationStats(clinicId: $clinicId, notificationId: $notificationId) {
    ...CampaignNotificationStatFields
  }
}
    ${CampaignNotificationStatFieldsFragmentDoc}`;

/**
 * __useGetCampaignNotificationStatsQuery__
 *
 * To run a query within a React component, call `useGetCampaignNotificationStatsQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetCampaignNotificationStatsQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetCampaignNotificationStatsQuery({
 *   variables: {
 *      clinicId: // value for 'clinicId'
 *      notificationId: // value for 'notificationId'
 *   },
 * });
 */
export function useGetCampaignNotificationStatsQuery(baseOptions: Apollo.QueryHookOptions<GetCampaignNotificationStatsQuery, GetCampaignNotificationStatsQueryVariables> & ({ variables: GetCampaignNotificationStatsQueryVariables; skip?: boolean; } | { skip: boolean; }) ) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<GetCampaignNotificationStatsQuery, GetCampaignNotificationStatsQueryVariables>(GetCampaignNotificationStatsDocument, options);
      }
export function useGetCampaignNotificationStatsLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<GetCampaignNotificationStatsQuery, GetCampaignNotificationStatsQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<GetCampaignNotificationStatsQuery, GetCampaignNotificationStatsQueryVariables>(GetCampaignNotificationStatsDocument, options);
        }
export function useGetCampaignNotificationStatsSuspenseQuery(baseOptions?: Apollo.SuspenseQueryHookOptions<GetCampaignNotificationStatsQuery, GetCampaignNotificationStatsQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useSuspenseQuery<GetCampaignNotificationStatsQuery, GetCampaignNotificationStatsQueryVariables>(GetCampaignNotificationStatsDocument, options);
        }
export type GetCampaignNotificationStatsQueryHookResult = ReturnType<typeof useGetCampaignNotificationStatsQuery>;
export type GetCampaignNotificationStatsLazyQueryHookResult = ReturnType<typeof useGetCampaignNotificationStatsLazyQuery>;
export type GetCampaignNotificationStatsSuspenseQueryHookResult = ReturnType<typeof useGetCampaignNotificationStatsSuspenseQuery>;
export type GetCampaignNotificationStatsQueryResult = Apollo.QueryResult<GetCampaignNotificationStatsQuery, GetCampaignNotificationStatsQueryVariables>;
export const GetCampaignBulkMessageStatsDocument = gql`
    query getCampaignBulkMessageStats($clinicId: ID!, $bulkMessageId: ID!) {
  campaignScheduledBulkMessageStats(
    clinicId: $clinicId
    bulkMessageId: $bulkMessageId
  ) {
    ...CampaignBulkMessageStatFields
  }
}
    ${CampaignBulkMessageStatFieldsFragmentDoc}`;

/**
 * __useGetCampaignBulkMessageStatsQuery__
 *
 * To run a query within a React component, call `useGetCampaignBulkMessageStatsQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetCampaignBulkMessageStatsQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetCampaignBulkMessageStatsQuery({
 *   variables: {
 *      clinicId: // value for 'clinicId'
 *      bulkMessageId: // value for 'bulkMessageId'
 *   },
 * });
 */
export function useGetCampaignBulkMessageStatsQuery(baseOptions: Apollo.QueryHookOptions<GetCampaignBulkMessageStatsQuery, GetCampaignBulkMessageStatsQueryVariables> & ({ variables: GetCampaignBulkMessageStatsQueryVariables; skip?: boolean; } | { skip: boolean; }) ) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<GetCampaignBulkMessageStatsQuery, GetCampaignBulkMessageStatsQueryVariables>(GetCampaignBulkMessageStatsDocument, options);
      }
export function useGetCampaignBulkMessageStatsLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<GetCampaignBulkMessageStatsQuery, GetCampaignBulkMessageStatsQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<GetCampaignBulkMessageStatsQuery, GetCampaignBulkMessageStatsQueryVariables>(GetCampaignBulkMessageStatsDocument, options);
        }
export function useGetCampaignBulkMessageStatsSuspenseQuery(baseOptions?: Apollo.SuspenseQueryHookOptions<GetCampaignBulkMessageStatsQuery, GetCampaignBulkMessageStatsQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useSuspenseQuery<GetCampaignBulkMessageStatsQuery, GetCampaignBulkMessageStatsQueryVariables>(GetCampaignBulkMessageStatsDocument, options);
        }
export type GetCampaignBulkMessageStatsQueryHookResult = ReturnType<typeof useGetCampaignBulkMessageStatsQuery>;
export type GetCampaignBulkMessageStatsLazyQueryHookResult = ReturnType<typeof useGetCampaignBulkMessageStatsLazyQuery>;
export type GetCampaignBulkMessageStatsSuspenseQueryHookResult = ReturnType<typeof useGetCampaignBulkMessageStatsSuspenseQuery>;
export type GetCampaignBulkMessageStatsQueryResult = Apollo.QueryResult<GetCampaignBulkMessageStatsQuery, GetCampaignBulkMessageStatsQueryVariables>;
export const GetCampaignDocument = gql`
    query getCampaign($id: ID!) {
  campaign(id: $id) {
    ...CampaignFields
  }
}
    ${CampaignFieldsFragmentDoc}`;

/**
 * __useGetCampaignQuery__
 *
 * To run a query within a React component, call `useGetCampaignQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetCampaignQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetCampaignQuery({
 *   variables: {
 *      id: // value for 'id'
 *   },
 * });
 */
export function useGetCampaignQuery(baseOptions: Apollo.QueryHookOptions<GetCampaignQuery, GetCampaignQueryVariables> & ({ variables: GetCampaignQueryVariables; skip?: boolean; } | { skip: boolean; }) ) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<GetCampaignQuery, GetCampaignQueryVariables>(GetCampaignDocument, options);
      }
export function useGetCampaignLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<GetCampaignQuery, GetCampaignQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<GetCampaignQuery, GetCampaignQueryVariables>(GetCampaignDocument, options);
        }
export function useGetCampaignSuspenseQuery(baseOptions?: Apollo.SuspenseQueryHookOptions<GetCampaignQuery, GetCampaignQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useSuspenseQuery<GetCampaignQuery, GetCampaignQueryVariables>(GetCampaignDocument, options);
        }
export type GetCampaignQueryHookResult = ReturnType<typeof useGetCampaignQuery>;
export type GetCampaignLazyQueryHookResult = ReturnType<typeof useGetCampaignLazyQuery>;
export type GetCampaignSuspenseQueryHookResult = ReturnType<typeof useGetCampaignSuspenseQuery>;
export type GetCampaignQueryResult = Apollo.QueryResult<GetCampaignQuery, GetCampaignQueryVariables>;
export const QueryCampaignsDocument = gql`
    query queryCampaigns($where: [QueryInput!], $page: NonNegativeInt, $pageSize: NonNegativeInt, $orderBy: OrderByInput) {
  queryCampaigns(
    where: $where
    page: $page
    pageSize: $pageSize
    orderBy: $orderBy
  ) {
    ...CampaignFields
  }
}
    ${CampaignFieldsFragmentDoc}`;

/**
 * __useQueryCampaignsQuery__
 *
 * To run a query within a React component, call `useQueryCampaignsQuery` and pass it any options that fit your needs.
 * When your component renders, `useQueryCampaignsQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useQueryCampaignsQuery({
 *   variables: {
 *      where: // value for 'where'
 *      page: // value for 'page'
 *      pageSize: // value for 'pageSize'
 *      orderBy: // value for 'orderBy'
 *   },
 * });
 */
export function useQueryCampaignsQuery(baseOptions?: Apollo.QueryHookOptions<QueryCampaignsQuery, QueryCampaignsQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<QueryCampaignsQuery, QueryCampaignsQueryVariables>(QueryCampaignsDocument, options);
      }
export function useQueryCampaignsLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<QueryCampaignsQuery, QueryCampaignsQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<QueryCampaignsQuery, QueryCampaignsQueryVariables>(QueryCampaignsDocument, options);
        }
export function useQueryCampaignsSuspenseQuery(baseOptions?: Apollo.SuspenseQueryHookOptions<QueryCampaignsQuery, QueryCampaignsQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useSuspenseQuery<QueryCampaignsQuery, QueryCampaignsQueryVariables>(QueryCampaignsDocument, options);
        }
export type QueryCampaignsQueryHookResult = ReturnType<typeof useQueryCampaignsQuery>;
export type QueryCampaignsLazyQueryHookResult = ReturnType<typeof useQueryCampaignsLazyQuery>;
export type QueryCampaignsSuspenseQueryHookResult = ReturnType<typeof useQueryCampaignsSuspenseQuery>;
export type QueryCampaignsQueryResult = Apollo.QueryResult<QueryCampaignsQuery, QueryCampaignsQueryVariables>;
export const CountCampaignsDocument = gql`
    query countCampaigns($where: [QueryInput!]) {
  countCampaigns(where: $where)
}
    `;

/**
 * __useCountCampaignsQuery__
 *
 * To run a query within a React component, call `useCountCampaignsQuery` and pass it any options that fit your needs.
 * When your component renders, `useCountCampaignsQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useCountCampaignsQuery({
 *   variables: {
 *      where: // value for 'where'
 *   },
 * });
 */
export function useCountCampaignsQuery(baseOptions?: Apollo.QueryHookOptions<CountCampaignsQuery, CountCampaignsQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<CountCampaignsQuery, CountCampaignsQueryVariables>(CountCampaignsDocument, options);
      }
export function useCountCampaignsLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<CountCampaignsQuery, CountCampaignsQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<CountCampaignsQuery, CountCampaignsQueryVariables>(CountCampaignsDocument, options);
        }
export function useCountCampaignsSuspenseQuery(baseOptions?: Apollo.SuspenseQueryHookOptions<CountCampaignsQuery, CountCampaignsQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useSuspenseQuery<CountCampaignsQuery, CountCampaignsQueryVariables>(CountCampaignsDocument, options);
        }
export type CountCampaignsQueryHookResult = ReturnType<typeof useCountCampaignsQuery>;
export type CountCampaignsLazyQueryHookResult = ReturnType<typeof useCountCampaignsLazyQuery>;
export type CountCampaignsSuspenseQueryHookResult = ReturnType<typeof useCountCampaignsSuspenseQuery>;
export type CountCampaignsQueryResult = Apollo.QueryResult<CountCampaignsQuery, CountCampaignsQueryVariables>;
export const CreateCampaignDocument = gql`
    mutation createCampaign($data: CreateCampaignInput!) {
  createCampaign(data: $data) {
    ...CampaignFields
  }
}
    ${CampaignFieldsFragmentDoc}`;
export type CreateCampaignMutationFn = Apollo.MutationFunction<CreateCampaignMutation, CreateCampaignMutationVariables>;

/**
 * __useCreateCampaignMutation__
 *
 * To run a mutation, you first call `useCreateCampaignMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useCreateCampaignMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [createCampaignMutation, { data, loading, error }] = useCreateCampaignMutation({
 *   variables: {
 *      data: // value for 'data'
 *   },
 * });
 */
export function useCreateCampaignMutation(baseOptions?: Apollo.MutationHookOptions<CreateCampaignMutation, CreateCampaignMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<CreateCampaignMutation, CreateCampaignMutationVariables>(CreateCampaignDocument, options);
      }
export type CreateCampaignMutationHookResult = ReturnType<typeof useCreateCampaignMutation>;
export type CreateCampaignMutationResult = Apollo.MutationResult<CreateCampaignMutation>;
export type CreateCampaignMutationOptions = Apollo.BaseMutationOptions<CreateCampaignMutation, CreateCampaignMutationVariables>;
export const UpdateCampaignDocument = gql`
    mutation updateCampaign($id: ID!, $data: UpdateCampaignInput!) {
  updateCampaign(id: $id, data: $data) {
    ...CampaignFields
  }
}
    ${CampaignFieldsFragmentDoc}`;
export type UpdateCampaignMutationFn = Apollo.MutationFunction<UpdateCampaignMutation, UpdateCampaignMutationVariables>;

/**
 * __useUpdateCampaignMutation__
 *
 * To run a mutation, you first call `useUpdateCampaignMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useUpdateCampaignMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [updateCampaignMutation, { data, loading, error }] = useUpdateCampaignMutation({
 *   variables: {
 *      id: // value for 'id'
 *      data: // value for 'data'
 *   },
 * });
 */
export function useUpdateCampaignMutation(baseOptions?: Apollo.MutationHookOptions<UpdateCampaignMutation, UpdateCampaignMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<UpdateCampaignMutation, UpdateCampaignMutationVariables>(UpdateCampaignDocument, options);
      }
export type UpdateCampaignMutationHookResult = ReturnType<typeof useUpdateCampaignMutation>;
export type UpdateCampaignMutationResult = Apollo.MutationResult<UpdateCampaignMutation>;
export type UpdateCampaignMutationOptions = Apollo.BaseMutationOptions<UpdateCampaignMutation, UpdateCampaignMutationVariables>;
export const UpdateCampaignFeaturedStatsDocument = gql`
    mutation updateCampaignFeaturedStats($id: ID!, $featured: [String!]!) {
  updateCampaignFeaturedStats(id: $id, featured: $featured) {
    ...CampaignFields
  }
}
    ${CampaignFieldsFragmentDoc}`;
export type UpdateCampaignFeaturedStatsMutationFn = Apollo.MutationFunction<UpdateCampaignFeaturedStatsMutation, UpdateCampaignFeaturedStatsMutationVariables>;

/**
 * __useUpdateCampaignFeaturedStatsMutation__
 *
 * To run a mutation, you first call `useUpdateCampaignFeaturedStatsMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useUpdateCampaignFeaturedStatsMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [updateCampaignFeaturedStatsMutation, { data, loading, error }] = useUpdateCampaignFeaturedStatsMutation({
 *   variables: {
 *      id: // value for 'id'
 *      featured: // value for 'featured'
 *   },
 * });
 */
export function useUpdateCampaignFeaturedStatsMutation(baseOptions?: Apollo.MutationHookOptions<UpdateCampaignFeaturedStatsMutation, UpdateCampaignFeaturedStatsMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<UpdateCampaignFeaturedStatsMutation, UpdateCampaignFeaturedStatsMutationVariables>(UpdateCampaignFeaturedStatsDocument, options);
      }
export type UpdateCampaignFeaturedStatsMutationHookResult = ReturnType<typeof useUpdateCampaignFeaturedStatsMutation>;
export type UpdateCampaignFeaturedStatsMutationResult = Apollo.MutationResult<UpdateCampaignFeaturedStatsMutation>;
export type UpdateCampaignFeaturedStatsMutationOptions = Apollo.BaseMutationOptions<UpdateCampaignFeaturedStatsMutation, UpdateCampaignFeaturedStatsMutationVariables>;
export const UpdateCampaignWidgetFeaturedStatsDocument = gql`
    mutation updateCampaignWidgetFeaturedStats($id: ID!, $featured: [String!]!) {
  updateCampaignWidgetFeaturedStats(id: $id, featured: $featured) {
    ...CampaignFields
  }
}
    ${CampaignFieldsFragmentDoc}`;
export type UpdateCampaignWidgetFeaturedStatsMutationFn = Apollo.MutationFunction<UpdateCampaignWidgetFeaturedStatsMutation, UpdateCampaignWidgetFeaturedStatsMutationVariables>;

/**
 * __useUpdateCampaignWidgetFeaturedStatsMutation__
 *
 * To run a mutation, you first call `useUpdateCampaignWidgetFeaturedStatsMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useUpdateCampaignWidgetFeaturedStatsMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [updateCampaignWidgetFeaturedStatsMutation, { data, loading, error }] = useUpdateCampaignWidgetFeaturedStatsMutation({
 *   variables: {
 *      id: // value for 'id'
 *      featured: // value for 'featured'
 *   },
 * });
 */
export function useUpdateCampaignWidgetFeaturedStatsMutation(baseOptions?: Apollo.MutationHookOptions<UpdateCampaignWidgetFeaturedStatsMutation, UpdateCampaignWidgetFeaturedStatsMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<UpdateCampaignWidgetFeaturedStatsMutation, UpdateCampaignWidgetFeaturedStatsMutationVariables>(UpdateCampaignWidgetFeaturedStatsDocument, options);
      }
export type UpdateCampaignWidgetFeaturedStatsMutationHookResult = ReturnType<typeof useUpdateCampaignWidgetFeaturedStatsMutation>;
export type UpdateCampaignWidgetFeaturedStatsMutationResult = Apollo.MutationResult<UpdateCampaignWidgetFeaturedStatsMutation>;
export type UpdateCampaignWidgetFeaturedStatsMutationOptions = Apollo.BaseMutationOptions<UpdateCampaignWidgetFeaturedStatsMutation, UpdateCampaignWidgetFeaturedStatsMutationVariables>;
export const UpdateCampaignNotificationFeaturedStatsDocument = gql`
    mutation updateCampaignNotificationFeaturedStats($id: ID!, $featured: [String!]!) {
  updateCampaignNotificationFeaturedStats(id: $id, featured: $featured) {
    ...CampaignFields
  }
}
    ${CampaignFieldsFragmentDoc}`;
export type UpdateCampaignNotificationFeaturedStatsMutationFn = Apollo.MutationFunction<UpdateCampaignNotificationFeaturedStatsMutation, UpdateCampaignNotificationFeaturedStatsMutationVariables>;

/**
 * __useUpdateCampaignNotificationFeaturedStatsMutation__
 *
 * To run a mutation, you first call `useUpdateCampaignNotificationFeaturedStatsMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useUpdateCampaignNotificationFeaturedStatsMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [updateCampaignNotificationFeaturedStatsMutation, { data, loading, error }] = useUpdateCampaignNotificationFeaturedStatsMutation({
 *   variables: {
 *      id: // value for 'id'
 *      featured: // value for 'featured'
 *   },
 * });
 */
export function useUpdateCampaignNotificationFeaturedStatsMutation(baseOptions?: Apollo.MutationHookOptions<UpdateCampaignNotificationFeaturedStatsMutation, UpdateCampaignNotificationFeaturedStatsMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<UpdateCampaignNotificationFeaturedStatsMutation, UpdateCampaignNotificationFeaturedStatsMutationVariables>(UpdateCampaignNotificationFeaturedStatsDocument, options);
      }
export type UpdateCampaignNotificationFeaturedStatsMutationHookResult = ReturnType<typeof useUpdateCampaignNotificationFeaturedStatsMutation>;
export type UpdateCampaignNotificationFeaturedStatsMutationResult = Apollo.MutationResult<UpdateCampaignNotificationFeaturedStatsMutation>;
export type UpdateCampaignNotificationFeaturedStatsMutationOptions = Apollo.BaseMutationOptions<UpdateCampaignNotificationFeaturedStatsMutation, UpdateCampaignNotificationFeaturedStatsMutationVariables>;
export const UpdateCampaignScheduledBulkMessageFeaturedStatsDocument = gql`
    mutation updateCampaignScheduledBulkMessageFeaturedStats($id: ID!, $featured: [String!]!) {
  updateCampaignScheduledBulkMessageFeaturedStats(id: $id, featured: $featured) {
    ...CampaignFields
  }
}
    ${CampaignFieldsFragmentDoc}`;
export type UpdateCampaignScheduledBulkMessageFeaturedStatsMutationFn = Apollo.MutationFunction<UpdateCampaignScheduledBulkMessageFeaturedStatsMutation, UpdateCampaignScheduledBulkMessageFeaturedStatsMutationVariables>;

/**
 * __useUpdateCampaignScheduledBulkMessageFeaturedStatsMutation__
 *
 * To run a mutation, you first call `useUpdateCampaignScheduledBulkMessageFeaturedStatsMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useUpdateCampaignScheduledBulkMessageFeaturedStatsMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [updateCampaignScheduledBulkMessageFeaturedStatsMutation, { data, loading, error }] = useUpdateCampaignScheduledBulkMessageFeaturedStatsMutation({
 *   variables: {
 *      id: // value for 'id'
 *      featured: // value for 'featured'
 *   },
 * });
 */
export function useUpdateCampaignScheduledBulkMessageFeaturedStatsMutation(baseOptions?: Apollo.MutationHookOptions<UpdateCampaignScheduledBulkMessageFeaturedStatsMutation, UpdateCampaignScheduledBulkMessageFeaturedStatsMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<UpdateCampaignScheduledBulkMessageFeaturedStatsMutation, UpdateCampaignScheduledBulkMessageFeaturedStatsMutationVariables>(UpdateCampaignScheduledBulkMessageFeaturedStatsDocument, options);
      }
export type UpdateCampaignScheduledBulkMessageFeaturedStatsMutationHookResult = ReturnType<typeof useUpdateCampaignScheduledBulkMessageFeaturedStatsMutation>;
export type UpdateCampaignScheduledBulkMessageFeaturedStatsMutationResult = Apollo.MutationResult<UpdateCampaignScheduledBulkMessageFeaturedStatsMutation>;
export type UpdateCampaignScheduledBulkMessageFeaturedStatsMutationOptions = Apollo.BaseMutationOptions<UpdateCampaignScheduledBulkMessageFeaturedStatsMutation, UpdateCampaignScheduledBulkMessageFeaturedStatsMutationVariables>;
export const GetChangeLogsByEntityIdDocument = gql`
    query getChangeLogsByEntityId($entityId: String!, $params: PaginationParams) {
  getChangeLogsByEntityId(entityId: $entityId, params: $params) {
    ...ChangeLogFields
  }
}
    ${ChangeLogFieldsFragmentDoc}`;

/**
 * __useGetChangeLogsByEntityIdQuery__
 *
 * To run a query within a React component, call `useGetChangeLogsByEntityIdQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetChangeLogsByEntityIdQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetChangeLogsByEntityIdQuery({
 *   variables: {
 *      entityId: // value for 'entityId'
 *      params: // value for 'params'
 *   },
 * });
 */
export function useGetChangeLogsByEntityIdQuery(baseOptions: Apollo.QueryHookOptions<GetChangeLogsByEntityIdQuery, GetChangeLogsByEntityIdQueryVariables> & ({ variables: GetChangeLogsByEntityIdQueryVariables; skip?: boolean; } | { skip: boolean; }) ) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<GetChangeLogsByEntityIdQuery, GetChangeLogsByEntityIdQueryVariables>(GetChangeLogsByEntityIdDocument, options);
      }
export function useGetChangeLogsByEntityIdLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<GetChangeLogsByEntityIdQuery, GetChangeLogsByEntityIdQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<GetChangeLogsByEntityIdQuery, GetChangeLogsByEntityIdQueryVariables>(GetChangeLogsByEntityIdDocument, options);
        }
export function useGetChangeLogsByEntityIdSuspenseQuery(baseOptions?: Apollo.SuspenseQueryHookOptions<GetChangeLogsByEntityIdQuery, GetChangeLogsByEntityIdQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useSuspenseQuery<GetChangeLogsByEntityIdQuery, GetChangeLogsByEntityIdQueryVariables>(GetChangeLogsByEntityIdDocument, options);
        }
export type GetChangeLogsByEntityIdQueryHookResult = ReturnType<typeof useGetChangeLogsByEntityIdQuery>;
export type GetChangeLogsByEntityIdLazyQueryHookResult = ReturnType<typeof useGetChangeLogsByEntityIdLazyQuery>;
export type GetChangeLogsByEntityIdSuspenseQueryHookResult = ReturnType<typeof useGetChangeLogsByEntityIdSuspenseQuery>;
export type GetChangeLogsByEntityIdQueryResult = Apollo.QueryResult<GetChangeLogsByEntityIdQuery, GetChangeLogsByEntityIdQueryVariables>;
export const ChatStatusesDocument = gql`
    query chatStatuses($clinicId: ID!) {
  chatStatuses(clinicId: $clinicId) {
    ...ChatStatusFields
  }
}
    ${ChatStatusFieldsFragmentDoc}`;

/**
 * __useChatStatusesQuery__
 *
 * To run a query within a React component, call `useChatStatusesQuery` and pass it any options that fit your needs.
 * When your component renders, `useChatStatusesQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useChatStatusesQuery({
 *   variables: {
 *      clinicId: // value for 'clinicId'
 *   },
 * });
 */
export function useChatStatusesQuery(baseOptions: Apollo.QueryHookOptions<ChatStatusesQuery, ChatStatusesQueryVariables> & ({ variables: ChatStatusesQueryVariables; skip?: boolean; } | { skip: boolean; }) ) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<ChatStatusesQuery, ChatStatusesQueryVariables>(ChatStatusesDocument, options);
      }
export function useChatStatusesLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<ChatStatusesQuery, ChatStatusesQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<ChatStatusesQuery, ChatStatusesQueryVariables>(ChatStatusesDocument, options);
        }
export function useChatStatusesSuspenseQuery(baseOptions?: Apollo.SuspenseQueryHookOptions<ChatStatusesQuery, ChatStatusesQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useSuspenseQuery<ChatStatusesQuery, ChatStatusesQueryVariables>(ChatStatusesDocument, options);
        }
export type ChatStatusesQueryHookResult = ReturnType<typeof useChatStatusesQuery>;
export type ChatStatusesLazyQueryHookResult = ReturnType<typeof useChatStatusesLazyQuery>;
export type ChatStatusesSuspenseQueryHookResult = ReturnType<typeof useChatStatusesSuspenseQuery>;
export type ChatStatusesQueryResult = Apollo.QueryResult<ChatStatusesQuery, ChatStatusesQueryVariables>;
export const CreateChatStatusDocument = gql`
    mutation createChatStatus($data: CreateChatStatusInput!) {
  createChatStatus(data: $data) {
    ...ChatStatusFields
  }
}
    ${ChatStatusFieldsFragmentDoc}`;
export type CreateChatStatusMutationFn = Apollo.MutationFunction<CreateChatStatusMutation, CreateChatStatusMutationVariables>;

/**
 * __useCreateChatStatusMutation__
 *
 * To run a mutation, you first call `useCreateChatStatusMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useCreateChatStatusMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [createChatStatusMutation, { data, loading, error }] = useCreateChatStatusMutation({
 *   variables: {
 *      data: // value for 'data'
 *   },
 * });
 */
export function useCreateChatStatusMutation(baseOptions?: Apollo.MutationHookOptions<CreateChatStatusMutation, CreateChatStatusMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<CreateChatStatusMutation, CreateChatStatusMutationVariables>(CreateChatStatusDocument, options);
      }
export type CreateChatStatusMutationHookResult = ReturnType<typeof useCreateChatStatusMutation>;
export type CreateChatStatusMutationResult = Apollo.MutationResult<CreateChatStatusMutation>;
export type CreateChatStatusMutationOptions = Apollo.BaseMutationOptions<CreateChatStatusMutation, CreateChatStatusMutationVariables>;
export const UpdateChatStatusDocument = gql`
    mutation updateChatStatus($id: ID!, $data: UpdateChatStatusInput!) {
  updateChatStatus(id: $id, data: $data) {
    ...ChatStatusFields
  }
}
    ${ChatStatusFieldsFragmentDoc}`;
export type UpdateChatStatusMutationFn = Apollo.MutationFunction<UpdateChatStatusMutation, UpdateChatStatusMutationVariables>;

/**
 * __useUpdateChatStatusMutation__
 *
 * To run a mutation, you first call `useUpdateChatStatusMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useUpdateChatStatusMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [updateChatStatusMutation, { data, loading, error }] = useUpdateChatStatusMutation({
 *   variables: {
 *      id: // value for 'id'
 *      data: // value for 'data'
 *   },
 * });
 */
export function useUpdateChatStatusMutation(baseOptions?: Apollo.MutationHookOptions<UpdateChatStatusMutation, UpdateChatStatusMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<UpdateChatStatusMutation, UpdateChatStatusMutationVariables>(UpdateChatStatusDocument, options);
      }
export type UpdateChatStatusMutationHookResult = ReturnType<typeof useUpdateChatStatusMutation>;
export type UpdateChatStatusMutationResult = Apollo.MutationResult<UpdateChatStatusMutation>;
export type UpdateChatStatusMutationOptions = Apollo.BaseMutationOptions<UpdateChatStatusMutation, UpdateChatStatusMutationVariables>;
export const DeleteChatStatusDocument = gql`
    mutation deleteChatStatus($id: ID!) {
  deleteChatStatus(id: $id)
}
    `;
export type DeleteChatStatusMutationFn = Apollo.MutationFunction<DeleteChatStatusMutation, DeleteChatStatusMutationVariables>;

/**
 * __useDeleteChatStatusMutation__
 *
 * To run a mutation, you first call `useDeleteChatStatusMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useDeleteChatStatusMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [deleteChatStatusMutation, { data, loading, error }] = useDeleteChatStatusMutation({
 *   variables: {
 *      id: // value for 'id'
 *   },
 * });
 */
export function useDeleteChatStatusMutation(baseOptions?: Apollo.MutationHookOptions<DeleteChatStatusMutation, DeleteChatStatusMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<DeleteChatStatusMutation, DeleteChatStatusMutationVariables>(DeleteChatStatusDocument, options);
      }
export type DeleteChatStatusMutationHookResult = ReturnType<typeof useDeleteChatStatusMutation>;
export type DeleteChatStatusMutationResult = Apollo.MutationResult<DeleteChatStatusMutation>;
export type DeleteChatStatusMutationOptions = Apollo.BaseMutationOptions<DeleteChatStatusMutation, DeleteChatStatusMutationVariables>;
export const GetChatDocument = gql`
    query getChat($id: ID!) {
  chat(id: $id) {
    ...ChatFields
  }
}
    ${ChatFieldsFragmentDoc}`;

/**
 * __useGetChatQuery__
 *
 * To run a query within a React component, call `useGetChatQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetChatQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetChatQuery({
 *   variables: {
 *      id: // value for 'id'
 *   },
 * });
 */
export function useGetChatQuery(baseOptions: Apollo.QueryHookOptions<GetChatQuery, GetChatQueryVariables> & ({ variables: GetChatQueryVariables; skip?: boolean; } | { skip: boolean; }) ) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<GetChatQuery, GetChatQueryVariables>(GetChatDocument, options);
      }
export function useGetChatLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<GetChatQuery, GetChatQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<GetChatQuery, GetChatQueryVariables>(GetChatDocument, options);
        }
export function useGetChatSuspenseQuery(baseOptions?: Apollo.SuspenseQueryHookOptions<GetChatQuery, GetChatQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useSuspenseQuery<GetChatQuery, GetChatQueryVariables>(GetChatDocument, options);
        }
export type GetChatQueryHookResult = ReturnType<typeof useGetChatQuery>;
export type GetChatLazyQueryHookResult = ReturnType<typeof useGetChatLazyQuery>;
export type GetChatSuspenseQueryHookResult = ReturnType<typeof useGetChatSuspenseQuery>;
export type GetChatQueryResult = Apollo.QueryResult<GetChatQuery, GetChatQueryVariables>;
export const GetChatsByClientIdDocument = gql`
    query getChatsByClientId($clientId: ID!) {
  getChatsByClientId(clientId: $clientId) {
    ...ChatFields
  }
}
    ${ChatFieldsFragmentDoc}`;

/**
 * __useGetChatsByClientIdQuery__
 *
 * To run a query within a React component, call `useGetChatsByClientIdQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetChatsByClientIdQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetChatsByClientIdQuery({
 *   variables: {
 *      clientId: // value for 'clientId'
 *   },
 * });
 */
export function useGetChatsByClientIdQuery(baseOptions: Apollo.QueryHookOptions<GetChatsByClientIdQuery, GetChatsByClientIdQueryVariables> & ({ variables: GetChatsByClientIdQueryVariables; skip?: boolean; } | { skip: boolean; }) ) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<GetChatsByClientIdQuery, GetChatsByClientIdQueryVariables>(GetChatsByClientIdDocument, options);
      }
export function useGetChatsByClientIdLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<GetChatsByClientIdQuery, GetChatsByClientIdQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<GetChatsByClientIdQuery, GetChatsByClientIdQueryVariables>(GetChatsByClientIdDocument, options);
        }
export function useGetChatsByClientIdSuspenseQuery(baseOptions?: Apollo.SuspenseQueryHookOptions<GetChatsByClientIdQuery, GetChatsByClientIdQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useSuspenseQuery<GetChatsByClientIdQuery, GetChatsByClientIdQueryVariables>(GetChatsByClientIdDocument, options);
        }
export type GetChatsByClientIdQueryHookResult = ReturnType<typeof useGetChatsByClientIdQuery>;
export type GetChatsByClientIdLazyQueryHookResult = ReturnType<typeof useGetChatsByClientIdLazyQuery>;
export type GetChatsByClientIdSuspenseQueryHookResult = ReturnType<typeof useGetChatsByClientIdSuspenseQuery>;
export type GetChatsByClientIdQueryResult = Apollo.QueryResult<GetChatsByClientIdQuery, GetChatsByClientIdQueryVariables>;
export const GetChatsByClinicIdDocument = gql`
    query getChatsByClinicId($clinicId: ID!, $page: NonNegativeInt, $pageSize: NonNegativeInt) {
  getChatsByClinicId(clinicId: $clinicId, page: $page, pageSize: $pageSize) {
    ...ChatFields
  }
}
    ${ChatFieldsFragmentDoc}`;

/**
 * __useGetChatsByClinicIdQuery__
 *
 * To run a query within a React component, call `useGetChatsByClinicIdQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetChatsByClinicIdQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetChatsByClinicIdQuery({
 *   variables: {
 *      clinicId: // value for 'clinicId'
 *      page: // value for 'page'
 *      pageSize: // value for 'pageSize'
 *   },
 * });
 */
export function useGetChatsByClinicIdQuery(baseOptions: Apollo.QueryHookOptions<GetChatsByClinicIdQuery, GetChatsByClinicIdQueryVariables> & ({ variables: GetChatsByClinicIdQueryVariables; skip?: boolean; } | { skip: boolean; }) ) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<GetChatsByClinicIdQuery, GetChatsByClinicIdQueryVariables>(GetChatsByClinicIdDocument, options);
      }
export function useGetChatsByClinicIdLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<GetChatsByClinicIdQuery, GetChatsByClinicIdQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<GetChatsByClinicIdQuery, GetChatsByClinicIdQueryVariables>(GetChatsByClinicIdDocument, options);
        }
export function useGetChatsByClinicIdSuspenseQuery(baseOptions?: Apollo.SuspenseQueryHookOptions<GetChatsByClinicIdQuery, GetChatsByClinicIdQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useSuspenseQuery<GetChatsByClinicIdQuery, GetChatsByClinicIdQueryVariables>(GetChatsByClinicIdDocument, options);
        }
export type GetChatsByClinicIdQueryHookResult = ReturnType<typeof useGetChatsByClinicIdQuery>;
export type GetChatsByClinicIdLazyQueryHookResult = ReturnType<typeof useGetChatsByClinicIdLazyQuery>;
export type GetChatsByClinicIdSuspenseQueryHookResult = ReturnType<typeof useGetChatsByClinicIdSuspenseQuery>;
export type GetChatsByClinicIdQueryResult = Apollo.QueryResult<GetChatsByClinicIdQuery, GetChatsByClinicIdQueryVariables>;
export const QueryChatsDocument = gql`
    query queryChats($where: [QueryInput!], $page: NonNegativeInt, $pageSize: NonNegativeInt, $orderBy: OrderByInput) {
  queryChats(where: $where, page: $page, pageSize: $pageSize, orderBy: $orderBy) {
    ...ChatFields
  }
}
    ${ChatFieldsFragmentDoc}`;

/**
 * __useQueryChatsQuery__
 *
 * To run a query within a React component, call `useQueryChatsQuery` and pass it any options that fit your needs.
 * When your component renders, `useQueryChatsQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useQueryChatsQuery({
 *   variables: {
 *      where: // value for 'where'
 *      page: // value for 'page'
 *      pageSize: // value for 'pageSize'
 *      orderBy: // value for 'orderBy'
 *   },
 * });
 */
export function useQueryChatsQuery(baseOptions?: Apollo.QueryHookOptions<QueryChatsQuery, QueryChatsQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<QueryChatsQuery, QueryChatsQueryVariables>(QueryChatsDocument, options);
      }
export function useQueryChatsLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<QueryChatsQuery, QueryChatsQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<QueryChatsQuery, QueryChatsQueryVariables>(QueryChatsDocument, options);
        }
export function useQueryChatsSuspenseQuery(baseOptions?: Apollo.SuspenseQueryHookOptions<QueryChatsQuery, QueryChatsQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useSuspenseQuery<QueryChatsQuery, QueryChatsQueryVariables>(QueryChatsDocument, options);
        }
export type QueryChatsQueryHookResult = ReturnType<typeof useQueryChatsQuery>;
export type QueryChatsLazyQueryHookResult = ReturnType<typeof useQueryChatsLazyQuery>;
export type QueryChatsSuspenseQueryHookResult = ReturnType<typeof useQueryChatsSuspenseQuery>;
export type QueryChatsQueryResult = Apollo.QueryResult<QueryChatsQuery, QueryChatsQueryVariables>;
export const QueryChatPreviewsDocument = gql`
    query queryChatPreviews($where: [QueryInput!], $page: NonNegativeInt, $pageSize: NonNegativeInt, $orderBy: OrderByInput) {
  queryChats(where: $where, page: $page, pageSize: $pageSize, orderBy: $orderBy) {
    ...ChatPreviewFields
  }
}
    ${ChatPreviewFieldsFragmentDoc}`;

/**
 * __useQueryChatPreviewsQuery__
 *
 * To run a query within a React component, call `useQueryChatPreviewsQuery` and pass it any options that fit your needs.
 * When your component renders, `useQueryChatPreviewsQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useQueryChatPreviewsQuery({
 *   variables: {
 *      where: // value for 'where'
 *      page: // value for 'page'
 *      pageSize: // value for 'pageSize'
 *      orderBy: // value for 'orderBy'
 *   },
 * });
 */
export function useQueryChatPreviewsQuery(baseOptions?: Apollo.QueryHookOptions<QueryChatPreviewsQuery, QueryChatPreviewsQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<QueryChatPreviewsQuery, QueryChatPreviewsQueryVariables>(QueryChatPreviewsDocument, options);
      }
export function useQueryChatPreviewsLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<QueryChatPreviewsQuery, QueryChatPreviewsQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<QueryChatPreviewsQuery, QueryChatPreviewsQueryVariables>(QueryChatPreviewsDocument, options);
        }
export function useQueryChatPreviewsSuspenseQuery(baseOptions?: Apollo.SuspenseQueryHookOptions<QueryChatPreviewsQuery, QueryChatPreviewsQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useSuspenseQuery<QueryChatPreviewsQuery, QueryChatPreviewsQueryVariables>(QueryChatPreviewsDocument, options);
        }
export type QueryChatPreviewsQueryHookResult = ReturnType<typeof useQueryChatPreviewsQuery>;
export type QueryChatPreviewsLazyQueryHookResult = ReturnType<typeof useQueryChatPreviewsLazyQuery>;
export type QueryChatPreviewsSuspenseQueryHookResult = ReturnType<typeof useQueryChatPreviewsSuspenseQuery>;
export type QueryChatPreviewsQueryResult = Apollo.QueryResult<QueryChatPreviewsQuery, QueryChatPreviewsQueryVariables>;
export const QueryClinicChatsDocument = gql`
    query queryClinicChats($where: [QueryInput!], $page: NonNegativeInt, $pageSize: NonNegativeInt, $orderBy: OrderByInput, $clinicId: ID!) {
  queryClinicChats(
    where: $where
    page: $page
    pageSize: $pageSize
    orderBy: $orderBy
    clinicId: $clinicId
  ) {
    ...ChatFields
  }
}
    ${ChatFieldsFragmentDoc}`;

/**
 * __useQueryClinicChatsQuery__
 *
 * To run a query within a React component, call `useQueryClinicChatsQuery` and pass it any options that fit your needs.
 * When your component renders, `useQueryClinicChatsQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useQueryClinicChatsQuery({
 *   variables: {
 *      where: // value for 'where'
 *      page: // value for 'page'
 *      pageSize: // value for 'pageSize'
 *      orderBy: // value for 'orderBy'
 *      clinicId: // value for 'clinicId'
 *   },
 * });
 */
export function useQueryClinicChatsQuery(baseOptions: Apollo.QueryHookOptions<QueryClinicChatsQuery, QueryClinicChatsQueryVariables> & ({ variables: QueryClinicChatsQueryVariables; skip?: boolean; } | { skip: boolean; }) ) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<QueryClinicChatsQuery, QueryClinicChatsQueryVariables>(QueryClinicChatsDocument, options);
      }
export function useQueryClinicChatsLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<QueryClinicChatsQuery, QueryClinicChatsQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<QueryClinicChatsQuery, QueryClinicChatsQueryVariables>(QueryClinicChatsDocument, options);
        }
export function useQueryClinicChatsSuspenseQuery(baseOptions?: Apollo.SuspenseQueryHookOptions<QueryClinicChatsQuery, QueryClinicChatsQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useSuspenseQuery<QueryClinicChatsQuery, QueryClinicChatsQueryVariables>(QueryClinicChatsDocument, options);
        }
export type QueryClinicChatsQueryHookResult = ReturnType<typeof useQueryClinicChatsQuery>;
export type QueryClinicChatsLazyQueryHookResult = ReturnType<typeof useQueryClinicChatsLazyQuery>;
export type QueryClinicChatsSuspenseQueryHookResult = ReturnType<typeof useQueryClinicChatsSuspenseQuery>;
export type QueryClinicChatsQueryResult = Apollo.QueryResult<QueryClinicChatsQuery, QueryClinicChatsQueryVariables>;
export const QueryClinicChatPreviewsDocument = gql`
    query queryClinicChatPreviews($where: [QueryInput!], $page: NonNegativeInt, $pageSize: NonNegativeInt, $orderBy: OrderByInput, $clinicId: ID!) {
  queryClinicChats(
    where: $where
    page: $page
    pageSize: $pageSize
    orderBy: $orderBy
    clinicId: $clinicId
  ) {
    ...ChatPreviewFields
  }
}
    ${ChatPreviewFieldsFragmentDoc}`;

/**
 * __useQueryClinicChatPreviewsQuery__
 *
 * To run a query within a React component, call `useQueryClinicChatPreviewsQuery` and pass it any options that fit your needs.
 * When your component renders, `useQueryClinicChatPreviewsQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useQueryClinicChatPreviewsQuery({
 *   variables: {
 *      where: // value for 'where'
 *      page: // value for 'page'
 *      pageSize: // value for 'pageSize'
 *      orderBy: // value for 'orderBy'
 *      clinicId: // value for 'clinicId'
 *   },
 * });
 */
export function useQueryClinicChatPreviewsQuery(baseOptions: Apollo.QueryHookOptions<QueryClinicChatPreviewsQuery, QueryClinicChatPreviewsQueryVariables> & ({ variables: QueryClinicChatPreviewsQueryVariables; skip?: boolean; } | { skip: boolean; }) ) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<QueryClinicChatPreviewsQuery, QueryClinicChatPreviewsQueryVariables>(QueryClinicChatPreviewsDocument, options);
      }
export function useQueryClinicChatPreviewsLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<QueryClinicChatPreviewsQuery, QueryClinicChatPreviewsQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<QueryClinicChatPreviewsQuery, QueryClinicChatPreviewsQueryVariables>(QueryClinicChatPreviewsDocument, options);
        }
export function useQueryClinicChatPreviewsSuspenseQuery(baseOptions?: Apollo.SuspenseQueryHookOptions<QueryClinicChatPreviewsQuery, QueryClinicChatPreviewsQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useSuspenseQuery<QueryClinicChatPreviewsQuery, QueryClinicChatPreviewsQueryVariables>(QueryClinicChatPreviewsDocument, options);
        }
export type QueryClinicChatPreviewsQueryHookResult = ReturnType<typeof useQueryClinicChatPreviewsQuery>;
export type QueryClinicChatPreviewsLazyQueryHookResult = ReturnType<typeof useQueryClinicChatPreviewsLazyQuery>;
export type QueryClinicChatPreviewsSuspenseQueryHookResult = ReturnType<typeof useQueryClinicChatPreviewsSuspenseQuery>;
export type QueryClinicChatPreviewsQueryResult = Apollo.QueryResult<QueryClinicChatPreviewsQuery, QueryClinicChatPreviewsQueryVariables>;
export const CountChatsDocument = gql`
    query countChats($where: [QueryInput!]) {
  countChats(where: $where)
}
    `;

/**
 * __useCountChatsQuery__
 *
 * To run a query within a React component, call `useCountChatsQuery` and pass it any options that fit your needs.
 * When your component renders, `useCountChatsQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useCountChatsQuery({
 *   variables: {
 *      where: // value for 'where'
 *   },
 * });
 */
export function useCountChatsQuery(baseOptions?: Apollo.QueryHookOptions<CountChatsQuery, CountChatsQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<CountChatsQuery, CountChatsQueryVariables>(CountChatsDocument, options);
      }
export function useCountChatsLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<CountChatsQuery, CountChatsQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<CountChatsQuery, CountChatsQueryVariables>(CountChatsDocument, options);
        }
export function useCountChatsSuspenseQuery(baseOptions?: Apollo.SuspenseQueryHookOptions<CountChatsQuery, CountChatsQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useSuspenseQuery<CountChatsQuery, CountChatsQueryVariables>(CountChatsDocument, options);
        }
export type CountChatsQueryHookResult = ReturnType<typeof useCountChatsQuery>;
export type CountChatsLazyQueryHookResult = ReturnType<typeof useCountChatsLazyQuery>;
export type CountChatsSuspenseQueryHookResult = ReturnType<typeof useCountChatsSuspenseQuery>;
export type CountChatsQueryResult = Apollo.QueryResult<CountChatsQuery, CountChatsQueryVariables>;
export const GetChatByClientAndClinicDocument = gql`
    query getChatByClientAndClinic($clientId: ID!, $clinicId: ID!) {
  getChatByClientAndClinic(clientId: $clientId, clinicId: $clinicId) {
    ...ChatFields
  }
}
    ${ChatFieldsFragmentDoc}`;

/**
 * __useGetChatByClientAndClinicQuery__
 *
 * To run a query within a React component, call `useGetChatByClientAndClinicQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetChatByClientAndClinicQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetChatByClientAndClinicQuery({
 *   variables: {
 *      clientId: // value for 'clientId'
 *      clinicId: // value for 'clinicId'
 *   },
 * });
 */
export function useGetChatByClientAndClinicQuery(baseOptions: Apollo.QueryHookOptions<GetChatByClientAndClinicQuery, GetChatByClientAndClinicQueryVariables> & ({ variables: GetChatByClientAndClinicQueryVariables; skip?: boolean; } | { skip: boolean; }) ) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<GetChatByClientAndClinicQuery, GetChatByClientAndClinicQueryVariables>(GetChatByClientAndClinicDocument, options);
      }
export function useGetChatByClientAndClinicLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<GetChatByClientAndClinicQuery, GetChatByClientAndClinicQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<GetChatByClientAndClinicQuery, GetChatByClientAndClinicQueryVariables>(GetChatByClientAndClinicDocument, options);
        }
export function useGetChatByClientAndClinicSuspenseQuery(baseOptions?: Apollo.SuspenseQueryHookOptions<GetChatByClientAndClinicQuery, GetChatByClientAndClinicQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useSuspenseQuery<GetChatByClientAndClinicQuery, GetChatByClientAndClinicQueryVariables>(GetChatByClientAndClinicDocument, options);
        }
export type GetChatByClientAndClinicQueryHookResult = ReturnType<typeof useGetChatByClientAndClinicQuery>;
export type GetChatByClientAndClinicLazyQueryHookResult = ReturnType<typeof useGetChatByClientAndClinicLazyQuery>;
export type GetChatByClientAndClinicSuspenseQueryHookResult = ReturnType<typeof useGetChatByClientAndClinicSuspenseQuery>;
export type GetChatByClientAndClinicQueryResult = Apollo.QueryResult<GetChatByClientAndClinicQuery, GetChatByClientAndClinicQueryVariables>;
export const GetChatIdByClientAndClinicDocument = gql`
    query getChatIdByClientAndClinic($clientId: ID!, $clinicId: ID!) {
  getChatByClientAndClinic(clientId: $clientId, clinicId: $clinicId) {
    id
  }
}
    `;

/**
 * __useGetChatIdByClientAndClinicQuery__
 *
 * To run a query within a React component, call `useGetChatIdByClientAndClinicQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetChatIdByClientAndClinicQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetChatIdByClientAndClinicQuery({
 *   variables: {
 *      clientId: // value for 'clientId'
 *      clinicId: // value for 'clinicId'
 *   },
 * });
 */
export function useGetChatIdByClientAndClinicQuery(baseOptions: Apollo.QueryHookOptions<GetChatIdByClientAndClinicQuery, GetChatIdByClientAndClinicQueryVariables> & ({ variables: GetChatIdByClientAndClinicQueryVariables; skip?: boolean; } | { skip: boolean; }) ) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<GetChatIdByClientAndClinicQuery, GetChatIdByClientAndClinicQueryVariables>(GetChatIdByClientAndClinicDocument, options);
      }
export function useGetChatIdByClientAndClinicLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<GetChatIdByClientAndClinicQuery, GetChatIdByClientAndClinicQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<GetChatIdByClientAndClinicQuery, GetChatIdByClientAndClinicQueryVariables>(GetChatIdByClientAndClinicDocument, options);
        }
export function useGetChatIdByClientAndClinicSuspenseQuery(baseOptions?: Apollo.SuspenseQueryHookOptions<GetChatIdByClientAndClinicQuery, GetChatIdByClientAndClinicQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useSuspenseQuery<GetChatIdByClientAndClinicQuery, GetChatIdByClientAndClinicQueryVariables>(GetChatIdByClientAndClinicDocument, options);
        }
export type GetChatIdByClientAndClinicQueryHookResult = ReturnType<typeof useGetChatIdByClientAndClinicQuery>;
export type GetChatIdByClientAndClinicLazyQueryHookResult = ReturnType<typeof useGetChatIdByClientAndClinicLazyQuery>;
export type GetChatIdByClientAndClinicSuspenseQueryHookResult = ReturnType<typeof useGetChatIdByClientAndClinicSuspenseQuery>;
export type GetChatIdByClientAndClinicQueryResult = Apollo.QueryResult<GetChatIdByClientAndClinicQuery, GetChatIdByClientAndClinicQueryVariables>;
export const CreateChatDocument = gql`
    mutation createChat($data: CreateChatInput!) {
  createChat(data: $data) {
    ...ChatFields
  }
}
    ${ChatFieldsFragmentDoc}`;
export type CreateChatMutationFn = Apollo.MutationFunction<CreateChatMutation, CreateChatMutationVariables>;

/**
 * __useCreateChatMutation__
 *
 * To run a mutation, you first call `useCreateChatMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useCreateChatMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [createChatMutation, { data, loading, error }] = useCreateChatMutation({
 *   variables: {
 *      data: // value for 'data'
 *   },
 * });
 */
export function useCreateChatMutation(baseOptions?: Apollo.MutationHookOptions<CreateChatMutation, CreateChatMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<CreateChatMutation, CreateChatMutationVariables>(CreateChatDocument, options);
      }
export type CreateChatMutationHookResult = ReturnType<typeof useCreateChatMutation>;
export type CreateChatMutationResult = Apollo.MutationResult<CreateChatMutation>;
export type CreateChatMutationOptions = Apollo.BaseMutationOptions<CreateChatMutation, CreateChatMutationVariables>;
export const CreateChatWithNonClientDocument = gql`
    mutation createChatWithNonClient($data: CreateChatWithNonClientInput!) {
  createChatWithNonClient(data: $data) {
    ...ChatBasicInfoFields
  }
}
    ${ChatBasicInfoFieldsFragmentDoc}`;
export type CreateChatWithNonClientMutationFn = Apollo.MutationFunction<CreateChatWithNonClientMutation, CreateChatWithNonClientMutationVariables>;

/**
 * __useCreateChatWithNonClientMutation__
 *
 * To run a mutation, you first call `useCreateChatWithNonClientMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useCreateChatWithNonClientMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [createChatWithNonClientMutation, { data, loading, error }] = useCreateChatWithNonClientMutation({
 *   variables: {
 *      data: // value for 'data'
 *   },
 * });
 */
export function useCreateChatWithNonClientMutation(baseOptions?: Apollo.MutationHookOptions<CreateChatWithNonClientMutation, CreateChatWithNonClientMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<CreateChatWithNonClientMutation, CreateChatWithNonClientMutationVariables>(CreateChatWithNonClientDocument, options);
      }
export type CreateChatWithNonClientMutationHookResult = ReturnType<typeof useCreateChatWithNonClientMutation>;
export type CreateChatWithNonClientMutationResult = Apollo.MutationResult<CreateChatWithNonClientMutation>;
export type CreateChatWithNonClientMutationOptions = Apollo.BaseMutationOptions<CreateChatWithNonClientMutation, CreateChatWithNonClientMutationVariables>;
export const UpdateChatDocument = gql`
    mutation updateChat($id: ID!, $data: UpdateChatInput!) {
  updateChat(id: $id, data: $data) {
    ...ChatFields
    compliance_status_updated_at
    compliance_status_updated_by {
      ...UserBasicInfo
    }
  }
}
    ${ChatFieldsFragmentDoc}
${UserBasicInfoFragmentDoc}`;
export type UpdateChatMutationFn = Apollo.MutationFunction<UpdateChatMutation, UpdateChatMutationVariables>;

/**
 * __useUpdateChatMutation__
 *
 * To run a mutation, you first call `useUpdateChatMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useUpdateChatMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [updateChatMutation, { data, loading, error }] = useUpdateChatMutation({
 *   variables: {
 *      id: // value for 'id'
 *      data: // value for 'data'
 *   },
 * });
 */
export function useUpdateChatMutation(baseOptions?: Apollo.MutationHookOptions<UpdateChatMutation, UpdateChatMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<UpdateChatMutation, UpdateChatMutationVariables>(UpdateChatDocument, options);
      }
export type UpdateChatMutationHookResult = ReturnType<typeof useUpdateChatMutation>;
export type UpdateChatMutationResult = Apollo.MutationResult<UpdateChatMutation>;
export type UpdateChatMutationOptions = Apollo.BaseMutationOptions<UpdateChatMutation, UpdateChatMutationVariables>;
export const UploadAttachmentDocument = gql`
    mutation uploadAttachment($clinicId: ID!, $data: AttachmentInput!) {
  uploadAttachment(clinicId: $clinicId, data: $data)
}
    `;
export type UploadAttachmentMutationFn = Apollo.MutationFunction<UploadAttachmentMutation, UploadAttachmentMutationVariables>;

/**
 * __useUploadAttachmentMutation__
 *
 * To run a mutation, you first call `useUploadAttachmentMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useUploadAttachmentMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [uploadAttachmentMutation, { data, loading, error }] = useUploadAttachmentMutation({
 *   variables: {
 *      clinicId: // value for 'clinicId'
 *      data: // value for 'data'
 *   },
 * });
 */
export function useUploadAttachmentMutation(baseOptions?: Apollo.MutationHookOptions<UploadAttachmentMutation, UploadAttachmentMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<UploadAttachmentMutation, UploadAttachmentMutationVariables>(UploadAttachmentDocument, options);
      }
export type UploadAttachmentMutationHookResult = ReturnType<typeof useUploadAttachmentMutation>;
export type UploadAttachmentMutationResult = Apollo.MutationResult<UploadAttachmentMutation>;
export type UploadAttachmentMutationOptions = Apollo.BaseMutationOptions<UploadAttachmentMutation, UploadAttachmentMutationVariables>;
export const WritebackChatDocument = gql`
    mutation writebackChat($chatId: ID!, $messageIds: [ID!]!, $isManualWriteback: Boolean) {
  writebackChat(
    chatId: $chatId
    messageIds: $messageIds
    isManualWriteback: $isManualWriteback
  )
}
    `;
export type WritebackChatMutationFn = Apollo.MutationFunction<WritebackChatMutation, WritebackChatMutationVariables>;

/**
 * __useWritebackChatMutation__
 *
 * To run a mutation, you first call `useWritebackChatMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useWritebackChatMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [writebackChatMutation, { data, loading, error }] = useWritebackChatMutation({
 *   variables: {
 *      chatId: // value for 'chatId'
 *      messageIds: // value for 'messageIds'
 *      isManualWriteback: // value for 'isManualWriteback'
 *   },
 * });
 */
export function useWritebackChatMutation(baseOptions?: Apollo.MutationHookOptions<WritebackChatMutation, WritebackChatMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<WritebackChatMutation, WritebackChatMutationVariables>(WritebackChatDocument, options);
      }
export type WritebackChatMutationHookResult = ReturnType<typeof useWritebackChatMutation>;
export type WritebackChatMutationResult = Apollo.MutationResult<WritebackChatMutation>;
export type WritebackChatMutationOptions = Apollo.BaseMutationOptions<WritebackChatMutation, WritebackChatMutationVariables>;
export const MergeChatDocument = gql`
    mutation mergeChat($mergeFromChatId: ID!, $mergeIntoChatId: ID!) {
  mergeChat(mergeFromChatId: $mergeFromChatId, mergeIntoChatId: $mergeIntoChatId) {
    ...ChatBasicInfoFields
  }
}
    ${ChatBasicInfoFieldsFragmentDoc}`;
export type MergeChatMutationFn = Apollo.MutationFunction<MergeChatMutation, MergeChatMutationVariables>;

/**
 * __useMergeChatMutation__
 *
 * To run a mutation, you first call `useMergeChatMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useMergeChatMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [mergeChatMutation, { data, loading, error }] = useMergeChatMutation({
 *   variables: {
 *      mergeFromChatId: // value for 'mergeFromChatId'
 *      mergeIntoChatId: // value for 'mergeIntoChatId'
 *   },
 * });
 */
export function useMergeChatMutation(baseOptions?: Apollo.MutationHookOptions<MergeChatMutation, MergeChatMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<MergeChatMutation, MergeChatMutationVariables>(MergeChatDocument, options);
      }
export type MergeChatMutationHookResult = ReturnType<typeof useMergeChatMutation>;
export type MergeChatMutationResult = Apollo.MutationResult<MergeChatMutation>;
export type MergeChatMutationOptions = Apollo.BaseMutationOptions<MergeChatMutation, MergeChatMutationVariables>;
export const GetCheckInDocument = gql`
    query getCheckIn($id: ID!) {
  checkIn(id: $id) {
    ...CheckInFields
  }
}
    ${CheckInFieldsFragmentDoc}`;

/**
 * __useGetCheckInQuery__
 *
 * To run a query within a React component, call `useGetCheckInQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetCheckInQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetCheckInQuery({
 *   variables: {
 *      id: // value for 'id'
 *   },
 * });
 */
export function useGetCheckInQuery(baseOptions: Apollo.QueryHookOptions<GetCheckInQuery, GetCheckInQueryVariables> & ({ variables: GetCheckInQueryVariables; skip?: boolean; } | { skip: boolean; }) ) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<GetCheckInQuery, GetCheckInQueryVariables>(GetCheckInDocument, options);
      }
export function useGetCheckInLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<GetCheckInQuery, GetCheckInQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<GetCheckInQuery, GetCheckInQueryVariables>(GetCheckInDocument, options);
        }
export function useGetCheckInSuspenseQuery(baseOptions?: Apollo.SuspenseQueryHookOptions<GetCheckInQuery, GetCheckInQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useSuspenseQuery<GetCheckInQuery, GetCheckInQueryVariables>(GetCheckInDocument, options);
        }
export type GetCheckInQueryHookResult = ReturnType<typeof useGetCheckInQuery>;
export type GetCheckInLazyQueryHookResult = ReturnType<typeof useGetCheckInLazyQuery>;
export type GetCheckInSuspenseQueryHookResult = ReturnType<typeof useGetCheckInSuspenseQuery>;
export type GetCheckInQueryResult = Apollo.QueryResult<GetCheckInQuery, GetCheckInQueryVariables>;
export const GetCheckInsByUserDocument = gql`
    query getCheckInsByUser($userId: ID!) {
  getCheckInsByUser(userId: $userId) {
    ...CheckInFields
  }
}
    ${CheckInFieldsFragmentDoc}`;

/**
 * __useGetCheckInsByUserQuery__
 *
 * To run a query within a React component, call `useGetCheckInsByUserQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetCheckInsByUserQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetCheckInsByUserQuery({
 *   variables: {
 *      userId: // value for 'userId'
 *   },
 * });
 */
export function useGetCheckInsByUserQuery(baseOptions: Apollo.QueryHookOptions<GetCheckInsByUserQuery, GetCheckInsByUserQueryVariables> & ({ variables: GetCheckInsByUserQueryVariables; skip?: boolean; } | { skip: boolean; }) ) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<GetCheckInsByUserQuery, GetCheckInsByUserQueryVariables>(GetCheckInsByUserDocument, options);
      }
export function useGetCheckInsByUserLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<GetCheckInsByUserQuery, GetCheckInsByUserQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<GetCheckInsByUserQuery, GetCheckInsByUserQueryVariables>(GetCheckInsByUserDocument, options);
        }
export function useGetCheckInsByUserSuspenseQuery(baseOptions?: Apollo.SuspenseQueryHookOptions<GetCheckInsByUserQuery, GetCheckInsByUserQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useSuspenseQuery<GetCheckInsByUserQuery, GetCheckInsByUserQueryVariables>(GetCheckInsByUserDocument, options);
        }
export type GetCheckInsByUserQueryHookResult = ReturnType<typeof useGetCheckInsByUserQuery>;
export type GetCheckInsByUserLazyQueryHookResult = ReturnType<typeof useGetCheckInsByUserLazyQuery>;
export type GetCheckInsByUserSuspenseQueryHookResult = ReturnType<typeof useGetCheckInsByUserSuspenseQuery>;
export type GetCheckInsByUserQueryResult = Apollo.QueryResult<GetCheckInsByUserQuery, GetCheckInsByUserQueryVariables>;
export const GetCheckInsByClinicDocument = gql`
    query getCheckInsByClinic($clinicId: ID!) {
  getCheckInsByClinic(clinicId: $clinicId) {
    ...CheckInFields
  }
}
    ${CheckInFieldsFragmentDoc}`;

/**
 * __useGetCheckInsByClinicQuery__
 *
 * To run a query within a React component, call `useGetCheckInsByClinicQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetCheckInsByClinicQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetCheckInsByClinicQuery({
 *   variables: {
 *      clinicId: // value for 'clinicId'
 *   },
 * });
 */
export function useGetCheckInsByClinicQuery(baseOptions: Apollo.QueryHookOptions<GetCheckInsByClinicQuery, GetCheckInsByClinicQueryVariables> & ({ variables: GetCheckInsByClinicQueryVariables; skip?: boolean; } | { skip: boolean; }) ) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<GetCheckInsByClinicQuery, GetCheckInsByClinicQueryVariables>(GetCheckInsByClinicDocument, options);
      }
export function useGetCheckInsByClinicLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<GetCheckInsByClinicQuery, GetCheckInsByClinicQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<GetCheckInsByClinicQuery, GetCheckInsByClinicQueryVariables>(GetCheckInsByClinicDocument, options);
        }
export function useGetCheckInsByClinicSuspenseQuery(baseOptions?: Apollo.SuspenseQueryHookOptions<GetCheckInsByClinicQuery, GetCheckInsByClinicQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useSuspenseQuery<GetCheckInsByClinicQuery, GetCheckInsByClinicQueryVariables>(GetCheckInsByClinicDocument, options);
        }
export type GetCheckInsByClinicQueryHookResult = ReturnType<typeof useGetCheckInsByClinicQuery>;
export type GetCheckInsByClinicLazyQueryHookResult = ReturnType<typeof useGetCheckInsByClinicLazyQuery>;
export type GetCheckInsByClinicSuspenseQueryHookResult = ReturnType<typeof useGetCheckInsByClinicSuspenseQuery>;
export type GetCheckInsByClinicQueryResult = Apollo.QueryResult<GetCheckInsByClinicQuery, GetCheckInsByClinicQueryVariables>;
export const CreateCheckInDocument = gql`
    mutation createCheckIn($data: CreateCheckInInput!) {
  createCheckIn(data: $data) {
    ...CheckInFields
  }
}
    ${CheckInFieldsFragmentDoc}`;
export type CreateCheckInMutationFn = Apollo.MutationFunction<CreateCheckInMutation, CreateCheckInMutationVariables>;

/**
 * __useCreateCheckInMutation__
 *
 * To run a mutation, you first call `useCreateCheckInMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useCreateCheckInMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [createCheckInMutation, { data, loading, error }] = useCreateCheckInMutation({
 *   variables: {
 *      data: // value for 'data'
 *   },
 * });
 */
export function useCreateCheckInMutation(baseOptions?: Apollo.MutationHookOptions<CreateCheckInMutation, CreateCheckInMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<CreateCheckInMutation, CreateCheckInMutationVariables>(CreateCheckInDocument, options);
      }
export type CreateCheckInMutationHookResult = ReturnType<typeof useCreateCheckInMutation>;
export type CreateCheckInMutationResult = Apollo.MutationResult<CreateCheckInMutation>;
export type CreateCheckInMutationOptions = Apollo.BaseMutationOptions<CreateCheckInMutation, CreateCheckInMutationVariables>;
export const UpdateCheckInDocument = gql`
    mutation updateCheckIn($id: ID!, $data: UpdateCheckInInput!) {
  updateCheckIn(id: $id, data: $data) {
    ...CheckInFields
  }
}
    ${CheckInFieldsFragmentDoc}`;
export type UpdateCheckInMutationFn = Apollo.MutationFunction<UpdateCheckInMutation, UpdateCheckInMutationVariables>;

/**
 * __useUpdateCheckInMutation__
 *
 * To run a mutation, you first call `useUpdateCheckInMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useUpdateCheckInMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [updateCheckInMutation, { data, loading, error }] = useUpdateCheckInMutation({
 *   variables: {
 *      id: // value for 'id'
 *      data: // value for 'data'
 *   },
 * });
 */
export function useUpdateCheckInMutation(baseOptions?: Apollo.MutationHookOptions<UpdateCheckInMutation, UpdateCheckInMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<UpdateCheckInMutation, UpdateCheckInMutationVariables>(UpdateCheckInDocument, options);
      }
export type UpdateCheckInMutationHookResult = ReturnType<typeof useUpdateCheckInMutation>;
export type UpdateCheckInMutationResult = Apollo.MutationResult<UpdateCheckInMutation>;
export type UpdateCheckInMutationOptions = Apollo.BaseMutationOptions<UpdateCheckInMutation, UpdateCheckInMutationVariables>;
export const ClientFormDocument = gql`
    query clientForm($id: ID!) {
  clientForm(id: $id) {
    ...ClientFormFields
  }
}
    ${ClientFormFieldsFragmentDoc}`;

/**
 * __useClientFormQuery__
 *
 * To run a query within a React component, call `useClientFormQuery` and pass it any options that fit your needs.
 * When your component renders, `useClientFormQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useClientFormQuery({
 *   variables: {
 *      id: // value for 'id'
 *   },
 * });
 */
export function useClientFormQuery(baseOptions: Apollo.QueryHookOptions<ClientFormQuery, ClientFormQueryVariables> & ({ variables: ClientFormQueryVariables; skip?: boolean; } | { skip: boolean; }) ) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<ClientFormQuery, ClientFormQueryVariables>(ClientFormDocument, options);
      }
export function useClientFormLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<ClientFormQuery, ClientFormQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<ClientFormQuery, ClientFormQueryVariables>(ClientFormDocument, options);
        }
export function useClientFormSuspenseQuery(baseOptions?: Apollo.SuspenseQueryHookOptions<ClientFormQuery, ClientFormQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useSuspenseQuery<ClientFormQuery, ClientFormQueryVariables>(ClientFormDocument, options);
        }
export type ClientFormQueryHookResult = ReturnType<typeof useClientFormQuery>;
export type ClientFormLazyQueryHookResult = ReturnType<typeof useClientFormLazyQuery>;
export type ClientFormSuspenseQueryHookResult = ReturnType<typeof useClientFormSuspenseQuery>;
export type ClientFormQueryResult = Apollo.QueryResult<ClientFormQuery, ClientFormQueryVariables>;
export const QueryClientFormsDocument = gql`
    query queryClientForms($where: [QueryInput!], $page: NonNegativeInt, $pageSize: NonNegativeInt, $orderBy: OrderByInput) {
  queryClientForms(
    where: $where
    page: $page
    pageSize: $pageSize
    orderBy: $orderBy
  ) {
    ...ClientFormFields
  }
}
    ${ClientFormFieldsFragmentDoc}`;

/**
 * __useQueryClientFormsQuery__
 *
 * To run a query within a React component, call `useQueryClientFormsQuery` and pass it any options that fit your needs.
 * When your component renders, `useQueryClientFormsQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useQueryClientFormsQuery({
 *   variables: {
 *      where: // value for 'where'
 *      page: // value for 'page'
 *      pageSize: // value for 'pageSize'
 *      orderBy: // value for 'orderBy'
 *   },
 * });
 */
export function useQueryClientFormsQuery(baseOptions?: Apollo.QueryHookOptions<QueryClientFormsQuery, QueryClientFormsQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<QueryClientFormsQuery, QueryClientFormsQueryVariables>(QueryClientFormsDocument, options);
      }
export function useQueryClientFormsLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<QueryClientFormsQuery, QueryClientFormsQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<QueryClientFormsQuery, QueryClientFormsQueryVariables>(QueryClientFormsDocument, options);
        }
export function useQueryClientFormsSuspenseQuery(baseOptions?: Apollo.SuspenseQueryHookOptions<QueryClientFormsQuery, QueryClientFormsQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useSuspenseQuery<QueryClientFormsQuery, QueryClientFormsQueryVariables>(QueryClientFormsDocument, options);
        }
export type QueryClientFormsQueryHookResult = ReturnType<typeof useQueryClientFormsQuery>;
export type QueryClientFormsLazyQueryHookResult = ReturnType<typeof useQueryClientFormsLazyQuery>;
export type QueryClientFormsSuspenseQueryHookResult = ReturnType<typeof useQueryClientFormsSuspenseQuery>;
export type QueryClientFormsQueryResult = Apollo.QueryResult<QueryClientFormsQuery, QueryClientFormsQueryVariables>;
export const CountClientFormsDocument = gql`
    query countClientForms($where: [QueryInput!]) {
  countClientForms(where: $where)
}
    `;

/**
 * __useCountClientFormsQuery__
 *
 * To run a query within a React component, call `useCountClientFormsQuery` and pass it any options that fit your needs.
 * When your component renders, `useCountClientFormsQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useCountClientFormsQuery({
 *   variables: {
 *      where: // value for 'where'
 *   },
 * });
 */
export function useCountClientFormsQuery(baseOptions?: Apollo.QueryHookOptions<CountClientFormsQuery, CountClientFormsQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<CountClientFormsQuery, CountClientFormsQueryVariables>(CountClientFormsDocument, options);
      }
export function useCountClientFormsLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<CountClientFormsQuery, CountClientFormsQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<CountClientFormsQuery, CountClientFormsQueryVariables>(CountClientFormsDocument, options);
        }
export function useCountClientFormsSuspenseQuery(baseOptions?: Apollo.SuspenseQueryHookOptions<CountClientFormsQuery, CountClientFormsQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useSuspenseQuery<CountClientFormsQuery, CountClientFormsQueryVariables>(CountClientFormsDocument, options);
        }
export type CountClientFormsQueryHookResult = ReturnType<typeof useCountClientFormsQuery>;
export type CountClientFormsLazyQueryHookResult = ReturnType<typeof useCountClientFormsLazyQuery>;
export type CountClientFormsSuspenseQueryHookResult = ReturnType<typeof useCountClientFormsSuspenseQuery>;
export type CountClientFormsQueryResult = Apollo.QueryResult<CountClientFormsQuery, CountClientFormsQueryVariables>;
export const GetPdfUrlForClientFormDocument = gql`
    query getPdfUrlForClientForm($clientFormId: ID!) {
  getPdfUrlForClientForm(clientFormId: $clientFormId)
}
    `;

/**
 * __useGetPdfUrlForClientFormQuery__
 *
 * To run a query within a React component, call `useGetPdfUrlForClientFormQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetPdfUrlForClientFormQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetPdfUrlForClientFormQuery({
 *   variables: {
 *      clientFormId: // value for 'clientFormId'
 *   },
 * });
 */
export function useGetPdfUrlForClientFormQuery(baseOptions: Apollo.QueryHookOptions<GetPdfUrlForClientFormQuery, GetPdfUrlForClientFormQueryVariables> & ({ variables: GetPdfUrlForClientFormQueryVariables; skip?: boolean; } | { skip: boolean; }) ) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<GetPdfUrlForClientFormQuery, GetPdfUrlForClientFormQueryVariables>(GetPdfUrlForClientFormDocument, options);
      }
export function useGetPdfUrlForClientFormLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<GetPdfUrlForClientFormQuery, GetPdfUrlForClientFormQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<GetPdfUrlForClientFormQuery, GetPdfUrlForClientFormQueryVariables>(GetPdfUrlForClientFormDocument, options);
        }
export function useGetPdfUrlForClientFormSuspenseQuery(baseOptions?: Apollo.SuspenseQueryHookOptions<GetPdfUrlForClientFormQuery, GetPdfUrlForClientFormQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useSuspenseQuery<GetPdfUrlForClientFormQuery, GetPdfUrlForClientFormQueryVariables>(GetPdfUrlForClientFormDocument, options);
        }
export type GetPdfUrlForClientFormQueryHookResult = ReturnType<typeof useGetPdfUrlForClientFormQuery>;
export type GetPdfUrlForClientFormLazyQueryHookResult = ReturnType<typeof useGetPdfUrlForClientFormLazyQuery>;
export type GetPdfUrlForClientFormSuspenseQueryHookResult = ReturnType<typeof useGetPdfUrlForClientFormSuspenseQuery>;
export type GetPdfUrlForClientFormQueryResult = Apollo.QueryResult<GetPdfUrlForClientFormQuery, GetPdfUrlForClientFormQueryVariables>;
export const CreateClientFormDocument = gql`
    mutation createClientForm($data: CreateClientFormInput!) {
  createClientForm(data: $data) {
    ...ClientFormFields
  }
}
    ${ClientFormFieldsFragmentDoc}`;
export type CreateClientFormMutationFn = Apollo.MutationFunction<CreateClientFormMutation, CreateClientFormMutationVariables>;

/**
 * __useCreateClientFormMutation__
 *
 * To run a mutation, you first call `useCreateClientFormMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useCreateClientFormMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [createClientFormMutation, { data, loading, error }] = useCreateClientFormMutation({
 *   variables: {
 *      data: // value for 'data'
 *   },
 * });
 */
export function useCreateClientFormMutation(baseOptions?: Apollo.MutationHookOptions<CreateClientFormMutation, CreateClientFormMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<CreateClientFormMutation, CreateClientFormMutationVariables>(CreateClientFormDocument, options);
      }
export type CreateClientFormMutationHookResult = ReturnType<typeof useCreateClientFormMutation>;
export type CreateClientFormMutationResult = Apollo.MutationResult<CreateClientFormMutation>;
export type CreateClientFormMutationOptions = Apollo.BaseMutationOptions<CreateClientFormMutation, CreateClientFormMutationVariables>;
export const UpdateClientFormDocument = gql`
    mutation updateClientForm($id: ID!, $data: UpdateClientFormInput!) {
  updateClientForm(id: $id, data: $data) {
    ...ClientFormFields
  }
}
    ${ClientFormFieldsFragmentDoc}`;
export type UpdateClientFormMutationFn = Apollo.MutationFunction<UpdateClientFormMutation, UpdateClientFormMutationVariables>;

/**
 * __useUpdateClientFormMutation__
 *
 * To run a mutation, you first call `useUpdateClientFormMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useUpdateClientFormMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [updateClientFormMutation, { data, loading, error }] = useUpdateClientFormMutation({
 *   variables: {
 *      id: // value for 'id'
 *      data: // value for 'data'
 *   },
 * });
 */
export function useUpdateClientFormMutation(baseOptions?: Apollo.MutationHookOptions<UpdateClientFormMutation, UpdateClientFormMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<UpdateClientFormMutation, UpdateClientFormMutationVariables>(UpdateClientFormDocument, options);
      }
export type UpdateClientFormMutationHookResult = ReturnType<typeof useUpdateClientFormMutation>;
export type UpdateClientFormMutationResult = Apollo.MutationResult<UpdateClientFormMutation>;
export type UpdateClientFormMutationOptions = Apollo.BaseMutationOptions<UpdateClientFormMutation, UpdateClientFormMutationVariables>;
export const AssignClientFormToClientDocument = gql`
    mutation assignClientFormToClient($id: ID!, $clientId: ID!) {
  assignClientFormToClient(id: $id, clientId: $clientId) {
    ...ClientFormFields
  }
}
    ${ClientFormFieldsFragmentDoc}`;
export type AssignClientFormToClientMutationFn = Apollo.MutationFunction<AssignClientFormToClientMutation, AssignClientFormToClientMutationVariables>;

/**
 * __useAssignClientFormToClientMutation__
 *
 * To run a mutation, you first call `useAssignClientFormToClientMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useAssignClientFormToClientMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [assignClientFormToClientMutation, { data, loading, error }] = useAssignClientFormToClientMutation({
 *   variables: {
 *      id: // value for 'id'
 *      clientId: // value for 'clientId'
 *   },
 * });
 */
export function useAssignClientFormToClientMutation(baseOptions?: Apollo.MutationHookOptions<AssignClientFormToClientMutation, AssignClientFormToClientMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<AssignClientFormToClientMutation, AssignClientFormToClientMutationVariables>(AssignClientFormToClientDocument, options);
      }
export type AssignClientFormToClientMutationHookResult = ReturnType<typeof useAssignClientFormToClientMutation>;
export type AssignClientFormToClientMutationResult = Apollo.MutationResult<AssignClientFormToClientMutation>;
export type AssignClientFormToClientMutationOptions = Apollo.BaseMutationOptions<AssignClientFormToClientMutation, AssignClientFormToClientMutationVariables>;
export const AssignClientFormToPatientDocument = gql`
    mutation assignClientFormToPatient($id: ID!, $patientId: ID!) {
  assignClientFormToPatient(id: $id, patientId: $patientId) {
    ...ClientFormFields
  }
}
    ${ClientFormFieldsFragmentDoc}`;
export type AssignClientFormToPatientMutationFn = Apollo.MutationFunction<AssignClientFormToPatientMutation, AssignClientFormToPatientMutationVariables>;

/**
 * __useAssignClientFormToPatientMutation__
 *
 * To run a mutation, you first call `useAssignClientFormToPatientMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useAssignClientFormToPatientMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [assignClientFormToPatientMutation, { data, loading, error }] = useAssignClientFormToPatientMutation({
 *   variables: {
 *      id: // value for 'id'
 *      patientId: // value for 'patientId'
 *   },
 * });
 */
export function useAssignClientFormToPatientMutation(baseOptions?: Apollo.MutationHookOptions<AssignClientFormToPatientMutation, AssignClientFormToPatientMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<AssignClientFormToPatientMutation, AssignClientFormToPatientMutationVariables>(AssignClientFormToPatientDocument, options);
      }
export type AssignClientFormToPatientMutationHookResult = ReturnType<typeof useAssignClientFormToPatientMutation>;
export type AssignClientFormToPatientMutationResult = Apollo.MutationResult<AssignClientFormToPatientMutation>;
export type AssignClientFormToPatientMutationOptions = Apollo.BaseMutationOptions<AssignClientFormToPatientMutation, AssignClientFormToPatientMutationVariables>;
export const WritebackClientFormDocument = gql`
    mutation writebackClientForm($id: ID!, $isManualWriteback: Boolean) {
  writebackClientForm(id: $id, isManualWriteback: $isManualWriteback)
}
    `;
export type WritebackClientFormMutationFn = Apollo.MutationFunction<WritebackClientFormMutation, WritebackClientFormMutationVariables>;

/**
 * __useWritebackClientFormMutation__
 *
 * To run a mutation, you first call `useWritebackClientFormMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useWritebackClientFormMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [writebackClientFormMutation, { data, loading, error }] = useWritebackClientFormMutation({
 *   variables: {
 *      id: // value for 'id'
 *      isManualWriteback: // value for 'isManualWriteback'
 *   },
 * });
 */
export function useWritebackClientFormMutation(baseOptions?: Apollo.MutationHookOptions<WritebackClientFormMutation, WritebackClientFormMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<WritebackClientFormMutation, WritebackClientFormMutationVariables>(WritebackClientFormDocument, options);
      }
export type WritebackClientFormMutationHookResult = ReturnType<typeof useWritebackClientFormMutation>;
export type WritebackClientFormMutationResult = Apollo.MutationResult<WritebackClientFormMutation>;
export type WritebackClientFormMutationOptions = Apollo.BaseMutationOptions<WritebackClientFormMutation, WritebackClientFormMutationVariables>;
export const GetClientDocument = gql`
    query getClient($id: ID!) {
  client(id: $id) {
    ...ClientFields
    ...ClientPortalAppFields
  }
}
    ${ClientFieldsFragmentDoc}
${ClientPortalAppFieldsFragmentDoc}`;

/**
 * __useGetClientQuery__
 *
 * To run a query within a React component, call `useGetClientQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetClientQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetClientQuery({
 *   variables: {
 *      id: // value for 'id'
 *   },
 * });
 */
export function useGetClientQuery(baseOptions: Apollo.QueryHookOptions<GetClientQuery, GetClientQueryVariables> & ({ variables: GetClientQueryVariables; skip?: boolean; } | { skip: boolean; }) ) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<GetClientQuery, GetClientQueryVariables>(GetClientDocument, options);
      }
export function useGetClientLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<GetClientQuery, GetClientQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<GetClientQuery, GetClientQueryVariables>(GetClientDocument, options);
        }
export function useGetClientSuspenseQuery(baseOptions?: Apollo.SuspenseQueryHookOptions<GetClientQuery, GetClientQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useSuspenseQuery<GetClientQuery, GetClientQueryVariables>(GetClientDocument, options);
        }
export type GetClientQueryHookResult = ReturnType<typeof useGetClientQuery>;
export type GetClientLazyQueryHookResult = ReturnType<typeof useGetClientLazyQuery>;
export type GetClientSuspenseQueryHookResult = ReturnType<typeof useGetClientSuspenseQuery>;
export type GetClientQueryResult = Apollo.QueryResult<GetClientQuery, GetClientQueryVariables>;
export const GetClientNotesDocument = gql`
    query getClientNotes($id: ID!) {
  client(id: $id) {
    id
    client_notes {
      ...ClientNoteFields
    }
    patients {
      id
      name
      patient_notes {
        ...PatientNoteFields
      }
    }
  }
}
    ${ClientNoteFieldsFragmentDoc}
${PatientNoteFieldsFragmentDoc}`;

/**
 * __useGetClientNotesQuery__
 *
 * To run a query within a React component, call `useGetClientNotesQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetClientNotesQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetClientNotesQuery({
 *   variables: {
 *      id: // value for 'id'
 *   },
 * });
 */
export function useGetClientNotesQuery(baseOptions: Apollo.QueryHookOptions<GetClientNotesQuery, GetClientNotesQueryVariables> & ({ variables: GetClientNotesQueryVariables; skip?: boolean; } | { skip: boolean; }) ) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<GetClientNotesQuery, GetClientNotesQueryVariables>(GetClientNotesDocument, options);
      }
export function useGetClientNotesLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<GetClientNotesQuery, GetClientNotesQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<GetClientNotesQuery, GetClientNotesQueryVariables>(GetClientNotesDocument, options);
        }
export function useGetClientNotesSuspenseQuery(baseOptions?: Apollo.SuspenseQueryHookOptions<GetClientNotesQuery, GetClientNotesQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useSuspenseQuery<GetClientNotesQuery, GetClientNotesQueryVariables>(GetClientNotesDocument, options);
        }
export type GetClientNotesQueryHookResult = ReturnType<typeof useGetClientNotesQuery>;
export type GetClientNotesLazyQueryHookResult = ReturnType<typeof useGetClientNotesLazyQuery>;
export type GetClientNotesSuspenseQueryHookResult = ReturnType<typeof useGetClientNotesSuspenseQuery>;
export type GetClientNotesQueryResult = Apollo.QueryResult<GetClientNotesQuery, GetClientNotesQueryVariables>;
export const GetClientsDocument = gql`
    query getClients($clinicId: String!, $clientIds: [ID!]!) {
  getClients(clinicId: $clinicId, clientIds: $clientIds) {
    ...ClientPreviewFields
  }
}
    ${ClientPreviewFieldsFragmentDoc}`;

/**
 * __useGetClientsQuery__
 *
 * To run a query within a React component, call `useGetClientsQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetClientsQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetClientsQuery({
 *   variables: {
 *      clinicId: // value for 'clinicId'
 *      clientIds: // value for 'clientIds'
 *   },
 * });
 */
export function useGetClientsQuery(baseOptions: Apollo.QueryHookOptions<GetClientsQuery, GetClientsQueryVariables> & ({ variables: GetClientsQueryVariables; skip?: boolean; } | { skip: boolean; }) ) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<GetClientsQuery, GetClientsQueryVariables>(GetClientsDocument, options);
      }
export function useGetClientsLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<GetClientsQuery, GetClientsQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<GetClientsQuery, GetClientsQueryVariables>(GetClientsDocument, options);
        }
export function useGetClientsSuspenseQuery(baseOptions?: Apollo.SuspenseQueryHookOptions<GetClientsQuery, GetClientsQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useSuspenseQuery<GetClientsQuery, GetClientsQueryVariables>(GetClientsDocument, options);
        }
export type GetClientsQueryHookResult = ReturnType<typeof useGetClientsQuery>;
export type GetClientsLazyQueryHookResult = ReturnType<typeof useGetClientsLazyQuery>;
export type GetClientsSuspenseQueryHookResult = ReturnType<typeof useGetClientsSuspenseQuery>;
export type GetClientsQueryResult = Apollo.QueryResult<GetClientsQuery, GetClientsQueryVariables>;
export const CheckExistingClientsDocument = gql`
    query checkExistingClients($email: String, $phone: String) {
  checkExistingClients(email: $email, phone: $phone) {
    ...ClientFields
  }
}
    ${ClientFieldsFragmentDoc}`;

/**
 * __useCheckExistingClientsQuery__
 *
 * To run a query within a React component, call `useCheckExistingClientsQuery` and pass it any options that fit your needs.
 * When your component renders, `useCheckExistingClientsQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useCheckExistingClientsQuery({
 *   variables: {
 *      email: // value for 'email'
 *      phone: // value for 'phone'
 *   },
 * });
 */
export function useCheckExistingClientsQuery(baseOptions?: Apollo.QueryHookOptions<CheckExistingClientsQuery, CheckExistingClientsQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<CheckExistingClientsQuery, CheckExistingClientsQueryVariables>(CheckExistingClientsDocument, options);
      }
export function useCheckExistingClientsLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<CheckExistingClientsQuery, CheckExistingClientsQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<CheckExistingClientsQuery, CheckExistingClientsQueryVariables>(CheckExistingClientsDocument, options);
        }
export function useCheckExistingClientsSuspenseQuery(baseOptions?: Apollo.SuspenseQueryHookOptions<CheckExistingClientsQuery, CheckExistingClientsQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useSuspenseQuery<CheckExistingClientsQuery, CheckExistingClientsQueryVariables>(CheckExistingClientsDocument, options);
        }
export type CheckExistingClientsQueryHookResult = ReturnType<typeof useCheckExistingClientsQuery>;
export type CheckExistingClientsLazyQueryHookResult = ReturnType<typeof useCheckExistingClientsLazyQuery>;
export type CheckExistingClientsSuspenseQueryHookResult = ReturnType<typeof useCheckExistingClientsSuspenseQuery>;
export type CheckExistingClientsQueryResult = Apollo.QueryResult<CheckExistingClientsQuery, CheckExistingClientsQueryVariables>;
export const CheckExistingClientDocument = gql`
    query checkExistingClient($clinicId: ID!, $firstName: String!, $lastName: String!, $email: String, $phone: String!) {
  checkExistingClient(
    clinicId: $clinicId
    firstName: $firstName
    lastName: $lastName
    email: $email
    phone: $phone
  ) {
    ...ClientFields
  }
}
    ${ClientFieldsFragmentDoc}`;

/**
 * __useCheckExistingClientQuery__
 *
 * To run a query within a React component, call `useCheckExistingClientQuery` and pass it any options that fit your needs.
 * When your component renders, `useCheckExistingClientQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useCheckExistingClientQuery({
 *   variables: {
 *      clinicId: // value for 'clinicId'
 *      firstName: // value for 'firstName'
 *      lastName: // value for 'lastName'
 *      email: // value for 'email'
 *      phone: // value for 'phone'
 *   },
 * });
 */
export function useCheckExistingClientQuery(baseOptions: Apollo.QueryHookOptions<CheckExistingClientQuery, CheckExistingClientQueryVariables> & ({ variables: CheckExistingClientQueryVariables; skip?: boolean; } | { skip: boolean; }) ) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<CheckExistingClientQuery, CheckExistingClientQueryVariables>(CheckExistingClientDocument, options);
      }
export function useCheckExistingClientLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<CheckExistingClientQuery, CheckExistingClientQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<CheckExistingClientQuery, CheckExistingClientQueryVariables>(CheckExistingClientDocument, options);
        }
export function useCheckExistingClientSuspenseQuery(baseOptions?: Apollo.SuspenseQueryHookOptions<CheckExistingClientQuery, CheckExistingClientQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useSuspenseQuery<CheckExistingClientQuery, CheckExistingClientQueryVariables>(CheckExistingClientDocument, options);
        }
export type CheckExistingClientQueryHookResult = ReturnType<typeof useCheckExistingClientQuery>;
export type CheckExistingClientLazyQueryHookResult = ReturnType<typeof useCheckExistingClientLazyQuery>;
export type CheckExistingClientSuspenseQueryHookResult = ReturnType<typeof useCheckExistingClientSuspenseQuery>;
export type CheckExistingClientQueryResult = Apollo.QueryResult<CheckExistingClientQuery, CheckExistingClientQueryVariables>;
export const GetMaybeClientsDocument = gql`
    query getMaybeClients($clinicId: ID!, $input: MaybeClientInput!) {
  getMaybeClients(clinicId: $clinicId, input: $input) {
    ...ClientFields
  }
}
    ${ClientFieldsFragmentDoc}`;

/**
 * __useGetMaybeClientsQuery__
 *
 * To run a query within a React component, call `useGetMaybeClientsQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetMaybeClientsQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetMaybeClientsQuery({
 *   variables: {
 *      clinicId: // value for 'clinicId'
 *      input: // value for 'input'
 *   },
 * });
 */
export function useGetMaybeClientsQuery(baseOptions: Apollo.QueryHookOptions<GetMaybeClientsQuery, GetMaybeClientsQueryVariables> & ({ variables: GetMaybeClientsQueryVariables; skip?: boolean; } | { skip: boolean; }) ) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<GetMaybeClientsQuery, GetMaybeClientsQueryVariables>(GetMaybeClientsDocument, options);
      }
export function useGetMaybeClientsLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<GetMaybeClientsQuery, GetMaybeClientsQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<GetMaybeClientsQuery, GetMaybeClientsQueryVariables>(GetMaybeClientsDocument, options);
        }
export function useGetMaybeClientsSuspenseQuery(baseOptions?: Apollo.SuspenseQueryHookOptions<GetMaybeClientsQuery, GetMaybeClientsQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useSuspenseQuery<GetMaybeClientsQuery, GetMaybeClientsQueryVariables>(GetMaybeClientsDocument, options);
        }
export type GetMaybeClientsQueryHookResult = ReturnType<typeof useGetMaybeClientsQuery>;
export type GetMaybeClientsLazyQueryHookResult = ReturnType<typeof useGetMaybeClientsLazyQuery>;
export type GetMaybeClientsSuspenseQueryHookResult = ReturnType<typeof useGetMaybeClientsSuspenseQuery>;
export type GetMaybeClientsQueryResult = Apollo.QueryResult<GetMaybeClientsQuery, GetMaybeClientsQueryVariables>;
export const GetClientsWithNegativeBalancesForClinicDocument = gql`
    query getClientsWithNegativeBalancesForClinic($clinicId: ID!) {
  getClientsWithNegativeBalancesForClinic(clinicId: $clinicId) {
    ...ClientFields
  }
}
    ${ClientFieldsFragmentDoc}`;

/**
 * __useGetClientsWithNegativeBalancesForClinicQuery__
 *
 * To run a query within a React component, call `useGetClientsWithNegativeBalancesForClinicQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetClientsWithNegativeBalancesForClinicQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetClientsWithNegativeBalancesForClinicQuery({
 *   variables: {
 *      clinicId: // value for 'clinicId'
 *   },
 * });
 */
export function useGetClientsWithNegativeBalancesForClinicQuery(baseOptions: Apollo.QueryHookOptions<GetClientsWithNegativeBalancesForClinicQuery, GetClientsWithNegativeBalancesForClinicQueryVariables> & ({ variables: GetClientsWithNegativeBalancesForClinicQueryVariables; skip?: boolean; } | { skip: boolean; }) ) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<GetClientsWithNegativeBalancesForClinicQuery, GetClientsWithNegativeBalancesForClinicQueryVariables>(GetClientsWithNegativeBalancesForClinicDocument, options);
      }
export function useGetClientsWithNegativeBalancesForClinicLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<GetClientsWithNegativeBalancesForClinicQuery, GetClientsWithNegativeBalancesForClinicQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<GetClientsWithNegativeBalancesForClinicQuery, GetClientsWithNegativeBalancesForClinicQueryVariables>(GetClientsWithNegativeBalancesForClinicDocument, options);
        }
export function useGetClientsWithNegativeBalancesForClinicSuspenseQuery(baseOptions?: Apollo.SuspenseQueryHookOptions<GetClientsWithNegativeBalancesForClinicQuery, GetClientsWithNegativeBalancesForClinicQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useSuspenseQuery<GetClientsWithNegativeBalancesForClinicQuery, GetClientsWithNegativeBalancesForClinicQueryVariables>(GetClientsWithNegativeBalancesForClinicDocument, options);
        }
export type GetClientsWithNegativeBalancesForClinicQueryHookResult = ReturnType<typeof useGetClientsWithNegativeBalancesForClinicQuery>;
export type GetClientsWithNegativeBalancesForClinicLazyQueryHookResult = ReturnType<typeof useGetClientsWithNegativeBalancesForClinicLazyQuery>;
export type GetClientsWithNegativeBalancesForClinicSuspenseQueryHookResult = ReturnType<typeof useGetClientsWithNegativeBalancesForClinicSuspenseQuery>;
export type GetClientsWithNegativeBalancesForClinicQueryResult = Apollo.QueryResult<GetClientsWithNegativeBalancesForClinicQuery, GetClientsWithNegativeBalancesForClinicQueryVariables>;
export const GetClientsWithoutApptOverDaysForClinicDocument = gql`
    query getClientsWithoutApptOverDaysForClinic($clinicId: ID!, $days: NonNegativeInt!) {
  getClientsWithoutApptOverDaysForClinic(clinicId: $clinicId, days: $days) {
    ...ClientFields
  }
}
    ${ClientFieldsFragmentDoc}`;

/**
 * __useGetClientsWithoutApptOverDaysForClinicQuery__
 *
 * To run a query within a React component, call `useGetClientsWithoutApptOverDaysForClinicQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetClientsWithoutApptOverDaysForClinicQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetClientsWithoutApptOverDaysForClinicQuery({
 *   variables: {
 *      clinicId: // value for 'clinicId'
 *      days: // value for 'days'
 *   },
 * });
 */
export function useGetClientsWithoutApptOverDaysForClinicQuery(baseOptions: Apollo.QueryHookOptions<GetClientsWithoutApptOverDaysForClinicQuery, GetClientsWithoutApptOverDaysForClinicQueryVariables> & ({ variables: GetClientsWithoutApptOverDaysForClinicQueryVariables; skip?: boolean; } | { skip: boolean; }) ) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<GetClientsWithoutApptOverDaysForClinicQuery, GetClientsWithoutApptOverDaysForClinicQueryVariables>(GetClientsWithoutApptOverDaysForClinicDocument, options);
      }
export function useGetClientsWithoutApptOverDaysForClinicLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<GetClientsWithoutApptOverDaysForClinicQuery, GetClientsWithoutApptOverDaysForClinicQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<GetClientsWithoutApptOverDaysForClinicQuery, GetClientsWithoutApptOverDaysForClinicQueryVariables>(GetClientsWithoutApptOverDaysForClinicDocument, options);
        }
export function useGetClientsWithoutApptOverDaysForClinicSuspenseQuery(baseOptions?: Apollo.SuspenseQueryHookOptions<GetClientsWithoutApptOverDaysForClinicQuery, GetClientsWithoutApptOverDaysForClinicQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useSuspenseQuery<GetClientsWithoutApptOverDaysForClinicQuery, GetClientsWithoutApptOverDaysForClinicQueryVariables>(GetClientsWithoutApptOverDaysForClinicDocument, options);
        }
export type GetClientsWithoutApptOverDaysForClinicQueryHookResult = ReturnType<typeof useGetClientsWithoutApptOverDaysForClinicQuery>;
export type GetClientsWithoutApptOverDaysForClinicLazyQueryHookResult = ReturnType<typeof useGetClientsWithoutApptOverDaysForClinicLazyQuery>;
export type GetClientsWithoutApptOverDaysForClinicSuspenseQueryHookResult = ReturnType<typeof useGetClientsWithoutApptOverDaysForClinicSuspenseQuery>;
export type GetClientsWithoutApptOverDaysForClinicQueryResult = Apollo.QueryResult<GetClientsWithoutApptOverDaysForClinicQuery, GetClientsWithoutApptOverDaysForClinicQueryVariables>;
export const GetOutstandingBalanceForClinicDocument = gql`
    query getOutstandingBalanceForClinic($clinicId: ID!, $activeClientsOnly: Boolean) {
  getOutstandingBalanceForClinic(
    clinicId: $clinicId
    activeClientsOnly: $activeClientsOnly
  )
}
    `;

/**
 * __useGetOutstandingBalanceForClinicQuery__
 *
 * To run a query within a React component, call `useGetOutstandingBalanceForClinicQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetOutstandingBalanceForClinicQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetOutstandingBalanceForClinicQuery({
 *   variables: {
 *      clinicId: // value for 'clinicId'
 *      activeClientsOnly: // value for 'activeClientsOnly'
 *   },
 * });
 */
export function useGetOutstandingBalanceForClinicQuery(baseOptions: Apollo.QueryHookOptions<GetOutstandingBalanceForClinicQuery, GetOutstandingBalanceForClinicQueryVariables> & ({ variables: GetOutstandingBalanceForClinicQueryVariables; skip?: boolean; } | { skip: boolean; }) ) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<GetOutstandingBalanceForClinicQuery, GetOutstandingBalanceForClinicQueryVariables>(GetOutstandingBalanceForClinicDocument, options);
      }
export function useGetOutstandingBalanceForClinicLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<GetOutstandingBalanceForClinicQuery, GetOutstandingBalanceForClinicQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<GetOutstandingBalanceForClinicQuery, GetOutstandingBalanceForClinicQueryVariables>(GetOutstandingBalanceForClinicDocument, options);
        }
export function useGetOutstandingBalanceForClinicSuspenseQuery(baseOptions?: Apollo.SuspenseQueryHookOptions<GetOutstandingBalanceForClinicQuery, GetOutstandingBalanceForClinicQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useSuspenseQuery<GetOutstandingBalanceForClinicQuery, GetOutstandingBalanceForClinicQueryVariables>(GetOutstandingBalanceForClinicDocument, options);
        }
export type GetOutstandingBalanceForClinicQueryHookResult = ReturnType<typeof useGetOutstandingBalanceForClinicQuery>;
export type GetOutstandingBalanceForClinicLazyQueryHookResult = ReturnType<typeof useGetOutstandingBalanceForClinicLazyQuery>;
export type GetOutstandingBalanceForClinicSuspenseQueryHookResult = ReturnType<typeof useGetOutstandingBalanceForClinicSuspenseQuery>;
export type GetOutstandingBalanceForClinicQueryResult = Apollo.QueryResult<GetOutstandingBalanceForClinicQuery, GetOutstandingBalanceForClinicQueryVariables>;
export const GetNewClientsForClinicDocument = gql`
    query getNewClientsForClinic($clinicId: ID!, $fromPmsCreatedAt: NonNegativeInt!, $toPmsCreatedAt: NonNegativeInt!) {
  getNewClientsForClinic(
    clinicId: $clinicId
    fromPmsCreatedAt: $fromPmsCreatedAt
    toPmsCreatedAt: $toPmsCreatedAt
  )
}
    `;

/**
 * __useGetNewClientsForClinicQuery__
 *
 * To run a query within a React component, call `useGetNewClientsForClinicQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetNewClientsForClinicQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetNewClientsForClinicQuery({
 *   variables: {
 *      clinicId: // value for 'clinicId'
 *      fromPmsCreatedAt: // value for 'fromPmsCreatedAt'
 *      toPmsCreatedAt: // value for 'toPmsCreatedAt'
 *   },
 * });
 */
export function useGetNewClientsForClinicQuery(baseOptions: Apollo.QueryHookOptions<GetNewClientsForClinicQuery, GetNewClientsForClinicQueryVariables> & ({ variables: GetNewClientsForClinicQueryVariables; skip?: boolean; } | { skip: boolean; }) ) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<GetNewClientsForClinicQuery, GetNewClientsForClinicQueryVariables>(GetNewClientsForClinicDocument, options);
      }
export function useGetNewClientsForClinicLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<GetNewClientsForClinicQuery, GetNewClientsForClinicQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<GetNewClientsForClinicQuery, GetNewClientsForClinicQueryVariables>(GetNewClientsForClinicDocument, options);
        }
export function useGetNewClientsForClinicSuspenseQuery(baseOptions?: Apollo.SuspenseQueryHookOptions<GetNewClientsForClinicQuery, GetNewClientsForClinicQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useSuspenseQuery<GetNewClientsForClinicQuery, GetNewClientsForClinicQueryVariables>(GetNewClientsForClinicDocument, options);
        }
export type GetNewClientsForClinicQueryHookResult = ReturnType<typeof useGetNewClientsForClinicQuery>;
export type GetNewClientsForClinicLazyQueryHookResult = ReturnType<typeof useGetNewClientsForClinicLazyQuery>;
export type GetNewClientsForClinicSuspenseQueryHookResult = ReturnType<typeof useGetNewClientsForClinicSuspenseQuery>;
export type GetNewClientsForClinicQueryResult = Apollo.QueryResult<GetNewClientsForClinicQuery, GetNewClientsForClinicQueryVariables>;
export const QueryClientsDocument = gql`
    query queryClients($where: [QueryInput!], $page: NonNegativeInt, $pageSize: NonNegativeInt, $orderBy: OrderByInput) {
  queryClients(where: $where, page: $page, pageSize: $pageSize, orderBy: $orderBy) {
    ...ClientPreviewFields
  }
}
    ${ClientPreviewFieldsFragmentDoc}`;

/**
 * __useQueryClientsQuery__
 *
 * To run a query within a React component, call `useQueryClientsQuery` and pass it any options that fit your needs.
 * When your component renders, `useQueryClientsQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useQueryClientsQuery({
 *   variables: {
 *      where: // value for 'where'
 *      page: // value for 'page'
 *      pageSize: // value for 'pageSize'
 *      orderBy: // value for 'orderBy'
 *   },
 * });
 */
export function useQueryClientsQuery(baseOptions?: Apollo.QueryHookOptions<QueryClientsQuery, QueryClientsQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<QueryClientsQuery, QueryClientsQueryVariables>(QueryClientsDocument, options);
      }
export function useQueryClientsLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<QueryClientsQuery, QueryClientsQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<QueryClientsQuery, QueryClientsQueryVariables>(QueryClientsDocument, options);
        }
export function useQueryClientsSuspenseQuery(baseOptions?: Apollo.SuspenseQueryHookOptions<QueryClientsQuery, QueryClientsQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useSuspenseQuery<QueryClientsQuery, QueryClientsQueryVariables>(QueryClientsDocument, options);
        }
export type QueryClientsQueryHookResult = ReturnType<typeof useQueryClientsQuery>;
export type QueryClientsLazyQueryHookResult = ReturnType<typeof useQueryClientsLazyQuery>;
export type QueryClientsSuspenseQueryHookResult = ReturnType<typeof useQueryClientsSuspenseQuery>;
export type QueryClientsQueryResult = Apollo.QueryResult<QueryClientsQuery, QueryClientsQueryVariables>;
export const QueryClinicClientsDocument = gql`
    query queryClinicClients($where: [QueryInput!], $page: NonNegativeInt, $pageSize: NonNegativeInt, $orderBy: OrderByInput, $clinicId: ID!) {
  queryClinicClients(
    where: $where
    page: $page
    pageSize: $pageSize
    orderBy: $orderBy
    clinicId: $clinicId
  ) {
    ...ClientPreviewFields
  }
}
    ${ClientPreviewFieldsFragmentDoc}`;

/**
 * __useQueryClinicClientsQuery__
 *
 * To run a query within a React component, call `useQueryClinicClientsQuery` and pass it any options that fit your needs.
 * When your component renders, `useQueryClinicClientsQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useQueryClinicClientsQuery({
 *   variables: {
 *      where: // value for 'where'
 *      page: // value for 'page'
 *      pageSize: // value for 'pageSize'
 *      orderBy: // value for 'orderBy'
 *      clinicId: // value for 'clinicId'
 *   },
 * });
 */
export function useQueryClinicClientsQuery(baseOptions: Apollo.QueryHookOptions<QueryClinicClientsQuery, QueryClinicClientsQueryVariables> & ({ variables: QueryClinicClientsQueryVariables; skip?: boolean; } | { skip: boolean; }) ) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<QueryClinicClientsQuery, QueryClinicClientsQueryVariables>(QueryClinicClientsDocument, options);
      }
export function useQueryClinicClientsLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<QueryClinicClientsQuery, QueryClinicClientsQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<QueryClinicClientsQuery, QueryClinicClientsQueryVariables>(QueryClinicClientsDocument, options);
        }
export function useQueryClinicClientsSuspenseQuery(baseOptions?: Apollo.SuspenseQueryHookOptions<QueryClinicClientsQuery, QueryClinicClientsQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useSuspenseQuery<QueryClinicClientsQuery, QueryClinicClientsQueryVariables>(QueryClinicClientsDocument, options);
        }
export type QueryClinicClientsQueryHookResult = ReturnType<typeof useQueryClinicClientsQuery>;
export type QueryClinicClientsLazyQueryHookResult = ReturnType<typeof useQueryClinicClientsLazyQuery>;
export type QueryClinicClientsSuspenseQueryHookResult = ReturnType<typeof useQueryClinicClientsSuspenseQuery>;
export type QueryClinicClientsQueryResult = Apollo.QueryResult<QueryClinicClientsQuery, QueryClinicClientsQueryVariables>;
export const QueryClientsPatientsDocument = gql`
    query queryClientsPatients($where: [QueryInput!], $page: NonNegativeInt, $pageSize: NonNegativeInt, $orderBy: OrderByInput, $clinicId: ID!) {
  queryClientsPatients(
    where: $where
    page: $page
    pageSize: $pageSize
    orderBy: $orderBy
    clinicId: $clinicId
  ) {
    results {
      client {
        ...ClientPreviewFields
        ...ClientPortalAppFields
      }
      patients {
        id
        name
        pms_id
        is_deceased
        is_active
      }
    }
    count
  }
}
    ${ClientPreviewFieldsFragmentDoc}
${ClientPortalAppFieldsFragmentDoc}`;

/**
 * __useQueryClientsPatientsQuery__
 *
 * To run a query within a React component, call `useQueryClientsPatientsQuery` and pass it any options that fit your needs.
 * When your component renders, `useQueryClientsPatientsQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useQueryClientsPatientsQuery({
 *   variables: {
 *      where: // value for 'where'
 *      page: // value for 'page'
 *      pageSize: // value for 'pageSize'
 *      orderBy: // value for 'orderBy'
 *      clinicId: // value for 'clinicId'
 *   },
 * });
 */
export function useQueryClientsPatientsQuery(baseOptions: Apollo.QueryHookOptions<QueryClientsPatientsQuery, QueryClientsPatientsQueryVariables> & ({ variables: QueryClientsPatientsQueryVariables; skip?: boolean; } | { skip: boolean; }) ) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<QueryClientsPatientsQuery, QueryClientsPatientsQueryVariables>(QueryClientsPatientsDocument, options);
      }
export function useQueryClientsPatientsLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<QueryClientsPatientsQuery, QueryClientsPatientsQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<QueryClientsPatientsQuery, QueryClientsPatientsQueryVariables>(QueryClientsPatientsDocument, options);
        }
export function useQueryClientsPatientsSuspenseQuery(baseOptions?: Apollo.SuspenseQueryHookOptions<QueryClientsPatientsQuery, QueryClientsPatientsQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useSuspenseQuery<QueryClientsPatientsQuery, QueryClientsPatientsQueryVariables>(QueryClientsPatientsDocument, options);
        }
export type QueryClientsPatientsQueryHookResult = ReturnType<typeof useQueryClientsPatientsQuery>;
export type QueryClientsPatientsLazyQueryHookResult = ReturnType<typeof useQueryClientsPatientsLazyQuery>;
export type QueryClientsPatientsSuspenseQueryHookResult = ReturnType<typeof useQueryClientsPatientsSuspenseQuery>;
export type QueryClientsPatientsQueryResult = Apollo.QueryResult<QueryClientsPatientsQuery, QueryClientsPatientsQueryVariables>;
export const CountClinicClientsDocument = gql`
    query countClinicClients($clinicId: ID!, $where: [QueryInput!]) {
  countClinicClients(clinicId: $clinicId, where: $where)
}
    `;

/**
 * __useCountClinicClientsQuery__
 *
 * To run a query within a React component, call `useCountClinicClientsQuery` and pass it any options that fit your needs.
 * When your component renders, `useCountClinicClientsQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useCountClinicClientsQuery({
 *   variables: {
 *      clinicId: // value for 'clinicId'
 *      where: // value for 'where'
 *   },
 * });
 */
export function useCountClinicClientsQuery(baseOptions: Apollo.QueryHookOptions<CountClinicClientsQuery, CountClinicClientsQueryVariables> & ({ variables: CountClinicClientsQueryVariables; skip?: boolean; } | { skip: boolean; }) ) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<CountClinicClientsQuery, CountClinicClientsQueryVariables>(CountClinicClientsDocument, options);
      }
export function useCountClinicClientsLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<CountClinicClientsQuery, CountClinicClientsQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<CountClinicClientsQuery, CountClinicClientsQueryVariables>(CountClinicClientsDocument, options);
        }
export function useCountClinicClientsSuspenseQuery(baseOptions?: Apollo.SuspenseQueryHookOptions<CountClinicClientsQuery, CountClinicClientsQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useSuspenseQuery<CountClinicClientsQuery, CountClinicClientsQueryVariables>(CountClinicClientsDocument, options);
        }
export type CountClinicClientsQueryHookResult = ReturnType<typeof useCountClinicClientsQuery>;
export type CountClinicClientsLazyQueryHookResult = ReturnType<typeof useCountClinicClientsLazyQuery>;
export type CountClinicClientsSuspenseQueryHookResult = ReturnType<typeof useCountClinicClientsSuspenseQuery>;
export type CountClinicClientsQueryResult = Apollo.QueryResult<CountClinicClientsQuery, CountClinicClientsQueryVariables>;
export const CountClientsDocument = gql`
    query countClients($where: [QueryInput!]) {
  countClients(where: $where)
}
    `;

/**
 * __useCountClientsQuery__
 *
 * To run a query within a React component, call `useCountClientsQuery` and pass it any options that fit your needs.
 * When your component renders, `useCountClientsQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useCountClientsQuery({
 *   variables: {
 *      where: // value for 'where'
 *   },
 * });
 */
export function useCountClientsQuery(baseOptions?: Apollo.QueryHookOptions<CountClientsQuery, CountClientsQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<CountClientsQuery, CountClientsQueryVariables>(CountClientsDocument, options);
      }
export function useCountClientsLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<CountClientsQuery, CountClientsQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<CountClientsQuery, CountClientsQueryVariables>(CountClientsDocument, options);
        }
export function useCountClientsSuspenseQuery(baseOptions?: Apollo.SuspenseQueryHookOptions<CountClientsQuery, CountClientsQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useSuspenseQuery<CountClientsQuery, CountClientsQueryVariables>(CountClientsDocument, options);
        }
export type CountClientsQueryHookResult = ReturnType<typeof useCountClientsQuery>;
export type CountClientsLazyQueryHookResult = ReturnType<typeof useCountClientsLazyQuery>;
export type CountClientsSuspenseQueryHookResult = ReturnType<typeof useCountClientsSuspenseQuery>;
export type CountClientsQueryResult = Apollo.QueryResult<CountClientsQuery, CountClientsQueryVariables>;
export const CreateClientDocument = gql`
    mutation createClient($data: CreateClientInput!) {
  createClient(data: $data) {
    ...ClientFields
  }
}
    ${ClientFieldsFragmentDoc}`;
export type CreateClientMutationFn = Apollo.MutationFunction<CreateClientMutation, CreateClientMutationVariables>;

/**
 * __useCreateClientMutation__
 *
 * To run a mutation, you first call `useCreateClientMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useCreateClientMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [createClientMutation, { data, loading, error }] = useCreateClientMutation({
 *   variables: {
 *      data: // value for 'data'
 *   },
 * });
 */
export function useCreateClientMutation(baseOptions?: Apollo.MutationHookOptions<CreateClientMutation, CreateClientMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<CreateClientMutation, CreateClientMutationVariables>(CreateClientDocument, options);
      }
export type CreateClientMutationHookResult = ReturnType<typeof useCreateClientMutation>;
export type CreateClientMutationResult = Apollo.MutationResult<CreateClientMutation>;
export type CreateClientMutationOptions = Apollo.BaseMutationOptions<CreateClientMutation, CreateClientMutationVariables>;
export const UpdateClientDocument = gql`
    mutation updateClient($id: ID!, $data: UpdateClientInput!) {
  updateClient(id: $id, data: $data) {
    ...ClientFields
  }
}
    ${ClientFieldsFragmentDoc}`;
export type UpdateClientMutationFn = Apollo.MutationFunction<UpdateClientMutation, UpdateClientMutationVariables>;

/**
 * __useUpdateClientMutation__
 *
 * To run a mutation, you first call `useUpdateClientMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useUpdateClientMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [updateClientMutation, { data, loading, error }] = useUpdateClientMutation({
 *   variables: {
 *      id: // value for 'id'
 *      data: // value for 'data'
 *   },
 * });
 */
export function useUpdateClientMutation(baseOptions?: Apollo.MutationHookOptions<UpdateClientMutation, UpdateClientMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<UpdateClientMutation, UpdateClientMutationVariables>(UpdateClientDocument, options);
      }
export type UpdateClientMutationHookResult = ReturnType<typeof useUpdateClientMutation>;
export type UpdateClientMutationResult = Apollo.MutationResult<UpdateClientMutation>;
export type UpdateClientMutationOptions = Apollo.BaseMutationOptions<UpdateClientMutation, UpdateClientMutationVariables>;
export const DeleteClientDocument = gql`
    mutation deleteClient($id: ID!) {
  deleteClient(id: $id)
}
    `;
export type DeleteClientMutationFn = Apollo.MutationFunction<DeleteClientMutation, DeleteClientMutationVariables>;

/**
 * __useDeleteClientMutation__
 *
 * To run a mutation, you first call `useDeleteClientMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useDeleteClientMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [deleteClientMutation, { data, loading, error }] = useDeleteClientMutation({
 *   variables: {
 *      id: // value for 'id'
 *   },
 * });
 */
export function useDeleteClientMutation(baseOptions?: Apollo.MutationHookOptions<DeleteClientMutation, DeleteClientMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<DeleteClientMutation, DeleteClientMutationVariables>(DeleteClientDocument, options);
      }
export type DeleteClientMutationHookResult = ReturnType<typeof useDeleteClientMutation>;
export type DeleteClientMutationResult = Apollo.MutationResult<DeleteClientMutation>;
export type DeleteClientMutationOptions = Apollo.BaseMutationOptions<DeleteClientMutation, DeleteClientMutationVariables>;
export const AddClinicToClientDocument = gql`
    mutation addClinicToClient($clinicId: ID!, $clientId: ID!) {
  addClinicToClient(clinicId: $clinicId, clientId: $clientId) {
    ...ClientFields
  }
}
    ${ClientFieldsFragmentDoc}`;
export type AddClinicToClientMutationFn = Apollo.MutationFunction<AddClinicToClientMutation, AddClinicToClientMutationVariables>;

/**
 * __useAddClinicToClientMutation__
 *
 * To run a mutation, you first call `useAddClinicToClientMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useAddClinicToClientMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [addClinicToClientMutation, { data, loading, error }] = useAddClinicToClientMutation({
 *   variables: {
 *      clinicId: // value for 'clinicId'
 *      clientId: // value for 'clientId'
 *   },
 * });
 */
export function useAddClinicToClientMutation(baseOptions?: Apollo.MutationHookOptions<AddClinicToClientMutation, AddClinicToClientMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<AddClinicToClientMutation, AddClinicToClientMutationVariables>(AddClinicToClientDocument, options);
      }
export type AddClinicToClientMutationHookResult = ReturnType<typeof useAddClinicToClientMutation>;
export type AddClinicToClientMutationResult = Apollo.MutationResult<AddClinicToClientMutation>;
export type AddClinicToClientMutationOptions = Apollo.BaseMutationOptions<AddClinicToClientMutation, AddClinicToClientMutationVariables>;
export const MakeClientPhonePrimaryDocument = gql`
    mutation makeClientPhonePrimary($clinicId: ID!, $clientId: ID!, $phoneId: ID!) {
  makeClientPhonePrimary(
    clinicId: $clinicId
    clientId: $clientId
    phoneId: $phoneId
  ) {
    ...ClientFields
  }
}
    ${ClientFieldsFragmentDoc}`;
export type MakeClientPhonePrimaryMutationFn = Apollo.MutationFunction<MakeClientPhonePrimaryMutation, MakeClientPhonePrimaryMutationVariables>;

/**
 * __useMakeClientPhonePrimaryMutation__
 *
 * To run a mutation, you first call `useMakeClientPhonePrimaryMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useMakeClientPhonePrimaryMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [makeClientPhonePrimaryMutation, { data, loading, error }] = useMakeClientPhonePrimaryMutation({
 *   variables: {
 *      clinicId: // value for 'clinicId'
 *      clientId: // value for 'clientId'
 *      phoneId: // value for 'phoneId'
 *   },
 * });
 */
export function useMakeClientPhonePrimaryMutation(baseOptions?: Apollo.MutationHookOptions<MakeClientPhonePrimaryMutation, MakeClientPhonePrimaryMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<MakeClientPhonePrimaryMutation, MakeClientPhonePrimaryMutationVariables>(MakeClientPhonePrimaryDocument, options);
      }
export type MakeClientPhonePrimaryMutationHookResult = ReturnType<typeof useMakeClientPhonePrimaryMutation>;
export type MakeClientPhonePrimaryMutationResult = Apollo.MutationResult<MakeClientPhonePrimaryMutation>;
export type MakeClientPhonePrimaryMutationOptions = Apollo.BaseMutationOptions<MakeClientPhonePrimaryMutation, MakeClientPhonePrimaryMutationVariables>;
export const SyncIndividualClientDocument = gql`
    mutation syncIndividualClient($clientId: ID!, $clinicId: ID!) {
  syncIndividualClient(clientId: $clientId, clinicId: $clinicId) {
    ...ClientFields
  }
}
    ${ClientFieldsFragmentDoc}`;
export type SyncIndividualClientMutationFn = Apollo.MutationFunction<SyncIndividualClientMutation, SyncIndividualClientMutationVariables>;

/**
 * __useSyncIndividualClientMutation__
 *
 * To run a mutation, you first call `useSyncIndividualClientMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useSyncIndividualClientMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [syncIndividualClientMutation, { data, loading, error }] = useSyncIndividualClientMutation({
 *   variables: {
 *      clientId: // value for 'clientId'
 *      clinicId: // value for 'clinicId'
 *   },
 * });
 */
export function useSyncIndividualClientMutation(baseOptions?: Apollo.MutationHookOptions<SyncIndividualClientMutation, SyncIndividualClientMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<SyncIndividualClientMutation, SyncIndividualClientMutationVariables>(SyncIndividualClientDocument, options);
      }
export type SyncIndividualClientMutationHookResult = ReturnType<typeof useSyncIndividualClientMutation>;
export type SyncIndividualClientMutationResult = Apollo.MutationResult<SyncIndividualClientMutation>;
export type SyncIndividualClientMutationOptions = Apollo.BaseMutationOptions<SyncIndividualClientMutation, SyncIndividualClientMutationVariables>;
export const GetClientAiSummaryDocument = gql`
    query getClientAISummary($clientId: ID!, $includeReviews: Boolean, $includeCalls: Boolean) {
  getClientAISummary(
    clientId: $clientId
    includeReviews: $includeReviews
    includeCalls: $includeCalls
  ) {
    summary
    hasData
  }
}
    `;

/**
 * __useGetClientAiSummaryQuery__
 *
 * To run a query within a React component, call `useGetClientAiSummaryQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetClientAiSummaryQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetClientAiSummaryQuery({
 *   variables: {
 *      clientId: // value for 'clientId'
 *      includeReviews: // value for 'includeReviews'
 *      includeCalls: // value for 'includeCalls'
 *   },
 * });
 */
export function useGetClientAiSummaryQuery(baseOptions: Apollo.QueryHookOptions<GetClientAiSummaryQuery, GetClientAiSummaryQueryVariables> & ({ variables: GetClientAiSummaryQueryVariables; skip?: boolean; } | { skip: boolean; }) ) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<GetClientAiSummaryQuery, GetClientAiSummaryQueryVariables>(GetClientAiSummaryDocument, options);
      }
export function useGetClientAiSummaryLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<GetClientAiSummaryQuery, GetClientAiSummaryQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<GetClientAiSummaryQuery, GetClientAiSummaryQueryVariables>(GetClientAiSummaryDocument, options);
        }
export function useGetClientAiSummarySuspenseQuery(baseOptions?: Apollo.SuspenseQueryHookOptions<GetClientAiSummaryQuery, GetClientAiSummaryQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useSuspenseQuery<GetClientAiSummaryQuery, GetClientAiSummaryQueryVariables>(GetClientAiSummaryDocument, options);
        }
export type GetClientAiSummaryQueryHookResult = ReturnType<typeof useGetClientAiSummaryQuery>;
export type GetClientAiSummaryLazyQueryHookResult = ReturnType<typeof useGetClientAiSummaryLazyQuery>;
export type GetClientAiSummarySuspenseQueryHookResult = ReturnType<typeof useGetClientAiSummarySuspenseQuery>;
export type GetClientAiSummaryQueryResult = Apollo.QueryResult<GetClientAiSummaryQuery, GetClientAiSummaryQueryVariables>;
export const GetClinicAdminByIdDocument = gql`
    query getClinicAdminById($id: ID!) {
  clinicAdmin(id: $id) {
    ...ClinicAdminFields
  }
}
    ${ClinicAdminFieldsFragmentDoc}`;

/**
 * __useGetClinicAdminByIdQuery__
 *
 * To run a query within a React component, call `useGetClinicAdminByIdQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetClinicAdminByIdQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetClinicAdminByIdQuery({
 *   variables: {
 *      id: // value for 'id'
 *   },
 * });
 */
export function useGetClinicAdminByIdQuery(baseOptions: Apollo.QueryHookOptions<GetClinicAdminByIdQuery, GetClinicAdminByIdQueryVariables> & ({ variables: GetClinicAdminByIdQueryVariables; skip?: boolean; } | { skip: boolean; }) ) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<GetClinicAdminByIdQuery, GetClinicAdminByIdQueryVariables>(GetClinicAdminByIdDocument, options);
      }
export function useGetClinicAdminByIdLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<GetClinicAdminByIdQuery, GetClinicAdminByIdQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<GetClinicAdminByIdQuery, GetClinicAdminByIdQueryVariables>(GetClinicAdminByIdDocument, options);
        }
export function useGetClinicAdminByIdSuspenseQuery(baseOptions?: Apollo.SuspenseQueryHookOptions<GetClinicAdminByIdQuery, GetClinicAdminByIdQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useSuspenseQuery<GetClinicAdminByIdQuery, GetClinicAdminByIdQueryVariables>(GetClinicAdminByIdDocument, options);
        }
export type GetClinicAdminByIdQueryHookResult = ReturnType<typeof useGetClinicAdminByIdQuery>;
export type GetClinicAdminByIdLazyQueryHookResult = ReturnType<typeof useGetClinicAdminByIdLazyQuery>;
export type GetClinicAdminByIdSuspenseQueryHookResult = ReturnType<typeof useGetClinicAdminByIdSuspenseQuery>;
export type GetClinicAdminByIdQueryResult = Apollo.QueryResult<GetClinicAdminByIdQuery, GetClinicAdminByIdQueryVariables>;
export const GetClinicAdminDocument = gql`
    query getClinicAdmin($clinicId: ID!, $userId: ID!) {
  getClinicAdmin(clinicId: $clinicId, userId: $userId) {
    ...ClinicAdminFields
  }
}
    ${ClinicAdminFieldsFragmentDoc}`;

/**
 * __useGetClinicAdminQuery__
 *
 * To run a query within a React component, call `useGetClinicAdminQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetClinicAdminQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetClinicAdminQuery({
 *   variables: {
 *      clinicId: // value for 'clinicId'
 *      userId: // value for 'userId'
 *   },
 * });
 */
export function useGetClinicAdminQuery(baseOptions: Apollo.QueryHookOptions<GetClinicAdminQuery, GetClinicAdminQueryVariables> & ({ variables: GetClinicAdminQueryVariables; skip?: boolean; } | { skip: boolean; }) ) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<GetClinicAdminQuery, GetClinicAdminQueryVariables>(GetClinicAdminDocument, options);
      }
export function useGetClinicAdminLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<GetClinicAdminQuery, GetClinicAdminQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<GetClinicAdminQuery, GetClinicAdminQueryVariables>(GetClinicAdminDocument, options);
        }
export function useGetClinicAdminSuspenseQuery(baseOptions?: Apollo.SuspenseQueryHookOptions<GetClinicAdminQuery, GetClinicAdminQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useSuspenseQuery<GetClinicAdminQuery, GetClinicAdminQueryVariables>(GetClinicAdminDocument, options);
        }
export type GetClinicAdminQueryHookResult = ReturnType<typeof useGetClinicAdminQuery>;
export type GetClinicAdminLazyQueryHookResult = ReturnType<typeof useGetClinicAdminLazyQuery>;
export type GetClinicAdminSuspenseQueryHookResult = ReturnType<typeof useGetClinicAdminSuspenseQuery>;
export type GetClinicAdminQueryResult = Apollo.QueryResult<GetClinicAdminQuery, GetClinicAdminQueryVariables>;
export const GetClinicAdminsByClinicDocument = gql`
    query getClinicAdminsByClinic($clinicId: ID!) {
  getClinicAdminsByClinic(clinicId: $clinicId) {
    ...ClinicAdminFields
  }
}
    ${ClinicAdminFieldsFragmentDoc}`;

/**
 * __useGetClinicAdminsByClinicQuery__
 *
 * To run a query within a React component, call `useGetClinicAdminsByClinicQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetClinicAdminsByClinicQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetClinicAdminsByClinicQuery({
 *   variables: {
 *      clinicId: // value for 'clinicId'
 *   },
 * });
 */
export function useGetClinicAdminsByClinicQuery(baseOptions: Apollo.QueryHookOptions<GetClinicAdminsByClinicQuery, GetClinicAdminsByClinicQueryVariables> & ({ variables: GetClinicAdminsByClinicQueryVariables; skip?: boolean; } | { skip: boolean; }) ) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<GetClinicAdminsByClinicQuery, GetClinicAdminsByClinicQueryVariables>(GetClinicAdminsByClinicDocument, options);
      }
export function useGetClinicAdminsByClinicLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<GetClinicAdminsByClinicQuery, GetClinicAdminsByClinicQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<GetClinicAdminsByClinicQuery, GetClinicAdminsByClinicQueryVariables>(GetClinicAdminsByClinicDocument, options);
        }
export function useGetClinicAdminsByClinicSuspenseQuery(baseOptions?: Apollo.SuspenseQueryHookOptions<GetClinicAdminsByClinicQuery, GetClinicAdminsByClinicQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useSuspenseQuery<GetClinicAdminsByClinicQuery, GetClinicAdminsByClinicQueryVariables>(GetClinicAdminsByClinicDocument, options);
        }
export type GetClinicAdminsByClinicQueryHookResult = ReturnType<typeof useGetClinicAdminsByClinicQuery>;
export type GetClinicAdminsByClinicLazyQueryHookResult = ReturnType<typeof useGetClinicAdminsByClinicLazyQuery>;
export type GetClinicAdminsByClinicSuspenseQueryHookResult = ReturnType<typeof useGetClinicAdminsByClinicSuspenseQuery>;
export type GetClinicAdminsByClinicQueryResult = Apollo.QueryResult<GetClinicAdminsByClinicQuery, GetClinicAdminsByClinicQueryVariables>;
export const GetClinicAdminsAssigneeOptionsDocument = gql`
    query getClinicAdminsAssigneeOptions($clinicId: ID!) {
  getClinicAdminsByClinic(clinicId: $clinicId) {
    user {
      ...UserBasicInfo
    }
  }
}
    ${UserBasicInfoFragmentDoc}`;

/**
 * __useGetClinicAdminsAssigneeOptionsQuery__
 *
 * To run a query within a React component, call `useGetClinicAdminsAssigneeOptionsQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetClinicAdminsAssigneeOptionsQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetClinicAdminsAssigneeOptionsQuery({
 *   variables: {
 *      clinicId: // value for 'clinicId'
 *   },
 * });
 */
export function useGetClinicAdminsAssigneeOptionsQuery(baseOptions: Apollo.QueryHookOptions<GetClinicAdminsAssigneeOptionsQuery, GetClinicAdminsAssigneeOptionsQueryVariables> & ({ variables: GetClinicAdminsAssigneeOptionsQueryVariables; skip?: boolean; } | { skip: boolean; }) ) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<GetClinicAdminsAssigneeOptionsQuery, GetClinicAdminsAssigneeOptionsQueryVariables>(GetClinicAdminsAssigneeOptionsDocument, options);
      }
export function useGetClinicAdminsAssigneeOptionsLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<GetClinicAdminsAssigneeOptionsQuery, GetClinicAdminsAssigneeOptionsQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<GetClinicAdminsAssigneeOptionsQuery, GetClinicAdminsAssigneeOptionsQueryVariables>(GetClinicAdminsAssigneeOptionsDocument, options);
        }
export function useGetClinicAdminsAssigneeOptionsSuspenseQuery(baseOptions?: Apollo.SuspenseQueryHookOptions<GetClinicAdminsAssigneeOptionsQuery, GetClinicAdminsAssigneeOptionsQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useSuspenseQuery<GetClinicAdminsAssigneeOptionsQuery, GetClinicAdminsAssigneeOptionsQueryVariables>(GetClinicAdminsAssigneeOptionsDocument, options);
        }
export type GetClinicAdminsAssigneeOptionsQueryHookResult = ReturnType<typeof useGetClinicAdminsAssigneeOptionsQuery>;
export type GetClinicAdminsAssigneeOptionsLazyQueryHookResult = ReturnType<typeof useGetClinicAdminsAssigneeOptionsLazyQuery>;
export type GetClinicAdminsAssigneeOptionsSuspenseQueryHookResult = ReturnType<typeof useGetClinicAdminsAssigneeOptionsSuspenseQuery>;
export type GetClinicAdminsAssigneeOptionsQueryResult = Apollo.QueryResult<GetClinicAdminsAssigneeOptionsQuery, GetClinicAdminsAssigneeOptionsQueryVariables>;
export const GetClinicAdminsByUserDocument = gql`
    query getClinicAdminsByUser($userId: ID!) {
  getClinicAdminsByUser(userId: $userId) {
    ...ClinicAdminFields
  }
}
    ${ClinicAdminFieldsFragmentDoc}`;

/**
 * __useGetClinicAdminsByUserQuery__
 *
 * To run a query within a React component, call `useGetClinicAdminsByUserQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetClinicAdminsByUserQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetClinicAdminsByUserQuery({
 *   variables: {
 *      userId: // value for 'userId'
 *   },
 * });
 */
export function useGetClinicAdminsByUserQuery(baseOptions: Apollo.QueryHookOptions<GetClinicAdminsByUserQuery, GetClinicAdminsByUserQueryVariables> & ({ variables: GetClinicAdminsByUserQueryVariables; skip?: boolean; } | { skip: boolean; }) ) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<GetClinicAdminsByUserQuery, GetClinicAdminsByUserQueryVariables>(GetClinicAdminsByUserDocument, options);
      }
export function useGetClinicAdminsByUserLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<GetClinicAdminsByUserQuery, GetClinicAdminsByUserQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<GetClinicAdminsByUserQuery, GetClinicAdminsByUserQueryVariables>(GetClinicAdminsByUserDocument, options);
        }
export function useGetClinicAdminsByUserSuspenseQuery(baseOptions?: Apollo.SuspenseQueryHookOptions<GetClinicAdminsByUserQuery, GetClinicAdminsByUserQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useSuspenseQuery<GetClinicAdminsByUserQuery, GetClinicAdminsByUserQueryVariables>(GetClinicAdminsByUserDocument, options);
        }
export type GetClinicAdminsByUserQueryHookResult = ReturnType<typeof useGetClinicAdminsByUserQuery>;
export type GetClinicAdminsByUserLazyQueryHookResult = ReturnType<typeof useGetClinicAdminsByUserLazyQuery>;
export type GetClinicAdminsByUserSuspenseQueryHookResult = ReturnType<typeof useGetClinicAdminsByUserSuspenseQuery>;
export type GetClinicAdminsByUserQueryResult = Apollo.QueryResult<GetClinicAdminsByUserQuery, GetClinicAdminsByUserQueryVariables>;
export const GetClinicAdminsForLoginDocument = gql`
    query getClinicAdminsForLogin($userId: ID!) {
  getClinicAdminsByUser(userId: $userId) {
    ...ClinicAdminFieldsForLogin
  }
}
    ${ClinicAdminFieldsForLoginFragmentDoc}`;

/**
 * __useGetClinicAdminsForLoginQuery__
 *
 * To run a query within a React component, call `useGetClinicAdminsForLoginQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetClinicAdminsForLoginQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetClinicAdminsForLoginQuery({
 *   variables: {
 *      userId: // value for 'userId'
 *   },
 * });
 */
export function useGetClinicAdminsForLoginQuery(baseOptions: Apollo.QueryHookOptions<GetClinicAdminsForLoginQuery, GetClinicAdminsForLoginQueryVariables> & ({ variables: GetClinicAdminsForLoginQueryVariables; skip?: boolean; } | { skip: boolean; }) ) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<GetClinicAdminsForLoginQuery, GetClinicAdminsForLoginQueryVariables>(GetClinicAdminsForLoginDocument, options);
      }
export function useGetClinicAdminsForLoginLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<GetClinicAdminsForLoginQuery, GetClinicAdminsForLoginQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<GetClinicAdminsForLoginQuery, GetClinicAdminsForLoginQueryVariables>(GetClinicAdminsForLoginDocument, options);
        }
export function useGetClinicAdminsForLoginSuspenseQuery(baseOptions?: Apollo.SuspenseQueryHookOptions<GetClinicAdminsForLoginQuery, GetClinicAdminsForLoginQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useSuspenseQuery<GetClinicAdminsForLoginQuery, GetClinicAdminsForLoginQueryVariables>(GetClinicAdminsForLoginDocument, options);
        }
export type GetClinicAdminsForLoginQueryHookResult = ReturnType<typeof useGetClinicAdminsForLoginQuery>;
export type GetClinicAdminsForLoginLazyQueryHookResult = ReturnType<typeof useGetClinicAdminsForLoginLazyQuery>;
export type GetClinicAdminsForLoginSuspenseQueryHookResult = ReturnType<typeof useGetClinicAdminsForLoginSuspenseQuery>;
export type GetClinicAdminsForLoginQueryResult = Apollo.QueryResult<GetClinicAdminsForLoginQuery, GetClinicAdminsForLoginQueryVariables>;
export const QueryClinicAdminsDocument = gql`
    query queryClinicAdmins($clinicId: ID!, $where: [QueryInput!], $page: NonNegativeInt, $pageSize: NonNegativeInt, $orderBy: OrderByInput) {
  queryClinicAdmins(
    clinicId: $clinicId
    where: $where
    page: $page
    pageSize: $pageSize
    orderBy: $orderBy
  ) {
    ...ClinicAdminFields
  }
}
    ${ClinicAdminFieldsFragmentDoc}`;

/**
 * __useQueryClinicAdminsQuery__
 *
 * To run a query within a React component, call `useQueryClinicAdminsQuery` and pass it any options that fit your needs.
 * When your component renders, `useQueryClinicAdminsQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useQueryClinicAdminsQuery({
 *   variables: {
 *      clinicId: // value for 'clinicId'
 *      where: // value for 'where'
 *      page: // value for 'page'
 *      pageSize: // value for 'pageSize'
 *      orderBy: // value for 'orderBy'
 *   },
 * });
 */
export function useQueryClinicAdminsQuery(baseOptions: Apollo.QueryHookOptions<QueryClinicAdminsQuery, QueryClinicAdminsQueryVariables> & ({ variables: QueryClinicAdminsQueryVariables; skip?: boolean; } | { skip: boolean; }) ) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<QueryClinicAdminsQuery, QueryClinicAdminsQueryVariables>(QueryClinicAdminsDocument, options);
      }
export function useQueryClinicAdminsLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<QueryClinicAdminsQuery, QueryClinicAdminsQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<QueryClinicAdminsQuery, QueryClinicAdminsQueryVariables>(QueryClinicAdminsDocument, options);
        }
export function useQueryClinicAdminsSuspenseQuery(baseOptions?: Apollo.SuspenseQueryHookOptions<QueryClinicAdminsQuery, QueryClinicAdminsQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useSuspenseQuery<QueryClinicAdminsQuery, QueryClinicAdminsQueryVariables>(QueryClinicAdminsDocument, options);
        }
export type QueryClinicAdminsQueryHookResult = ReturnType<typeof useQueryClinicAdminsQuery>;
export type QueryClinicAdminsLazyQueryHookResult = ReturnType<typeof useQueryClinicAdminsLazyQuery>;
export type QueryClinicAdminsSuspenseQueryHookResult = ReturnType<typeof useQueryClinicAdminsSuspenseQuery>;
export type QueryClinicAdminsQueryResult = Apollo.QueryResult<QueryClinicAdminsQuery, QueryClinicAdminsQueryVariables>;
export const QueryAllClinicAdminsDocument = gql`
    query queryAllClinicAdmins($where: [QueryInput!], $page: NonNegativeInt, $pageSize: NonNegativeInt, $orderBy: OrderByInput) {
  queryAllClinicAdmins(
    where: $where
    page: $page
    pageSize: $pageSize
    orderBy: $orderBy
  ) {
    ...ClinicAdminFields
  }
}
    ${ClinicAdminFieldsFragmentDoc}`;

/**
 * __useQueryAllClinicAdminsQuery__
 *
 * To run a query within a React component, call `useQueryAllClinicAdminsQuery` and pass it any options that fit your needs.
 * When your component renders, `useQueryAllClinicAdminsQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useQueryAllClinicAdminsQuery({
 *   variables: {
 *      where: // value for 'where'
 *      page: // value for 'page'
 *      pageSize: // value for 'pageSize'
 *      orderBy: // value for 'orderBy'
 *   },
 * });
 */
export function useQueryAllClinicAdminsQuery(baseOptions?: Apollo.QueryHookOptions<QueryAllClinicAdminsQuery, QueryAllClinicAdminsQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<QueryAllClinicAdminsQuery, QueryAllClinicAdminsQueryVariables>(QueryAllClinicAdminsDocument, options);
      }
export function useQueryAllClinicAdminsLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<QueryAllClinicAdminsQuery, QueryAllClinicAdminsQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<QueryAllClinicAdminsQuery, QueryAllClinicAdminsQueryVariables>(QueryAllClinicAdminsDocument, options);
        }
export function useQueryAllClinicAdminsSuspenseQuery(baseOptions?: Apollo.SuspenseQueryHookOptions<QueryAllClinicAdminsQuery, QueryAllClinicAdminsQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useSuspenseQuery<QueryAllClinicAdminsQuery, QueryAllClinicAdminsQueryVariables>(QueryAllClinicAdminsDocument, options);
        }
export type QueryAllClinicAdminsQueryHookResult = ReturnType<typeof useQueryAllClinicAdminsQuery>;
export type QueryAllClinicAdminsLazyQueryHookResult = ReturnType<typeof useQueryAllClinicAdminsLazyQuery>;
export type QueryAllClinicAdminsSuspenseQueryHookResult = ReturnType<typeof useQueryAllClinicAdminsSuspenseQuery>;
export type QueryAllClinicAdminsQueryResult = Apollo.QueryResult<QueryAllClinicAdminsQuery, QueryAllClinicAdminsQueryVariables>;
export const CountAllClinicAdminsDocument = gql`
    query countAllClinicAdmins($where: [QueryInput!]) {
  countAllClinicAdmins(where: $where)
}
    `;

/**
 * __useCountAllClinicAdminsQuery__
 *
 * To run a query within a React component, call `useCountAllClinicAdminsQuery` and pass it any options that fit your needs.
 * When your component renders, `useCountAllClinicAdminsQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useCountAllClinicAdminsQuery({
 *   variables: {
 *      where: // value for 'where'
 *   },
 * });
 */
export function useCountAllClinicAdminsQuery(baseOptions?: Apollo.QueryHookOptions<CountAllClinicAdminsQuery, CountAllClinicAdminsQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<CountAllClinicAdminsQuery, CountAllClinicAdminsQueryVariables>(CountAllClinicAdminsDocument, options);
      }
export function useCountAllClinicAdminsLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<CountAllClinicAdminsQuery, CountAllClinicAdminsQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<CountAllClinicAdminsQuery, CountAllClinicAdminsQueryVariables>(CountAllClinicAdminsDocument, options);
        }
export function useCountAllClinicAdminsSuspenseQuery(baseOptions?: Apollo.SuspenseQueryHookOptions<CountAllClinicAdminsQuery, CountAllClinicAdminsQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useSuspenseQuery<CountAllClinicAdminsQuery, CountAllClinicAdminsQueryVariables>(CountAllClinicAdminsDocument, options);
        }
export type CountAllClinicAdminsQueryHookResult = ReturnType<typeof useCountAllClinicAdminsQuery>;
export type CountAllClinicAdminsLazyQueryHookResult = ReturnType<typeof useCountAllClinicAdminsLazyQuery>;
export type CountAllClinicAdminsSuspenseQueryHookResult = ReturnType<typeof useCountAllClinicAdminsSuspenseQuery>;
export type CountAllClinicAdminsQueryResult = Apollo.QueryResult<CountAllClinicAdminsQuery, CountAllClinicAdminsQueryVariables>;
export const CountClinicAdminsDocument = gql`
    query countClinicAdmins($clinicId: ID!, $where: [QueryInput!]) {
  countClinicAdmins(clinicId: $clinicId, where: $where)
}
    `;

/**
 * __useCountClinicAdminsQuery__
 *
 * To run a query within a React component, call `useCountClinicAdminsQuery` and pass it any options that fit your needs.
 * When your component renders, `useCountClinicAdminsQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useCountClinicAdminsQuery({
 *   variables: {
 *      clinicId: // value for 'clinicId'
 *      where: // value for 'where'
 *   },
 * });
 */
export function useCountClinicAdminsQuery(baseOptions: Apollo.QueryHookOptions<CountClinicAdminsQuery, CountClinicAdminsQueryVariables> & ({ variables: CountClinicAdminsQueryVariables; skip?: boolean; } | { skip: boolean; }) ) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<CountClinicAdminsQuery, CountClinicAdminsQueryVariables>(CountClinicAdminsDocument, options);
      }
export function useCountClinicAdminsLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<CountClinicAdminsQuery, CountClinicAdminsQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<CountClinicAdminsQuery, CountClinicAdminsQueryVariables>(CountClinicAdminsDocument, options);
        }
export function useCountClinicAdminsSuspenseQuery(baseOptions?: Apollo.SuspenseQueryHookOptions<CountClinicAdminsQuery, CountClinicAdminsQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useSuspenseQuery<CountClinicAdminsQuery, CountClinicAdminsQueryVariables>(CountClinicAdminsDocument, options);
        }
export type CountClinicAdminsQueryHookResult = ReturnType<typeof useCountClinicAdminsQuery>;
export type CountClinicAdminsLazyQueryHookResult = ReturnType<typeof useCountClinicAdminsLazyQuery>;
export type CountClinicAdminsSuspenseQueryHookResult = ReturnType<typeof useCountClinicAdminsSuspenseQuery>;
export type CountClinicAdminsQueryResult = Apollo.QueryResult<CountClinicAdminsQuery, CountClinicAdminsQueryVariables>;
export const CreateClinicAdminDocument = gql`
    mutation createClinicAdmin($data: CreateClinicAdminInput!) {
  createClinicAdmin(data: $data) {
    ...ClinicAdminFields
  }
}
    ${ClinicAdminFieldsFragmentDoc}`;
export type CreateClinicAdminMutationFn = Apollo.MutationFunction<CreateClinicAdminMutation, CreateClinicAdminMutationVariables>;

/**
 * __useCreateClinicAdminMutation__
 *
 * To run a mutation, you first call `useCreateClinicAdminMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useCreateClinicAdminMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [createClinicAdminMutation, { data, loading, error }] = useCreateClinicAdminMutation({
 *   variables: {
 *      data: // value for 'data'
 *   },
 * });
 */
export function useCreateClinicAdminMutation(baseOptions?: Apollo.MutationHookOptions<CreateClinicAdminMutation, CreateClinicAdminMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<CreateClinicAdminMutation, CreateClinicAdminMutationVariables>(CreateClinicAdminDocument, options);
      }
export type CreateClinicAdminMutationHookResult = ReturnType<typeof useCreateClinicAdminMutation>;
export type CreateClinicAdminMutationResult = Apollo.MutationResult<CreateClinicAdminMutation>;
export type CreateClinicAdminMutationOptions = Apollo.BaseMutationOptions<CreateClinicAdminMutation, CreateClinicAdminMutationVariables>;
export const UpdateClinicAdminDocument = gql`
    mutation updateClinicAdmin($clinicId: ID!, $userId: ID!, $data: UpdateClinicAdminInput!) {
  updateClinicAdmin(clinicId: $clinicId, userId: $userId, data: $data) {
    ...ClinicAdminFields
  }
}
    ${ClinicAdminFieldsFragmentDoc}`;
export type UpdateClinicAdminMutationFn = Apollo.MutationFunction<UpdateClinicAdminMutation, UpdateClinicAdminMutationVariables>;

/**
 * __useUpdateClinicAdminMutation__
 *
 * To run a mutation, you first call `useUpdateClinicAdminMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useUpdateClinicAdminMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [updateClinicAdminMutation, { data, loading, error }] = useUpdateClinicAdminMutation({
 *   variables: {
 *      clinicId: // value for 'clinicId'
 *      userId: // value for 'userId'
 *      data: // value for 'data'
 *   },
 * });
 */
export function useUpdateClinicAdminMutation(baseOptions?: Apollo.MutationHookOptions<UpdateClinicAdminMutation, UpdateClinicAdminMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<UpdateClinicAdminMutation, UpdateClinicAdminMutationVariables>(UpdateClinicAdminDocument, options);
      }
export type UpdateClinicAdminMutationHookResult = ReturnType<typeof useUpdateClinicAdminMutation>;
export type UpdateClinicAdminMutationResult = Apollo.MutationResult<UpdateClinicAdminMutation>;
export type UpdateClinicAdminMutationOptions = Apollo.BaseMutationOptions<UpdateClinicAdminMutation, UpdateClinicAdminMutationVariables>;
export const DeleteClinicAdminDocument = gql`
    mutation deleteClinicAdmin($clinicId: ID!, $userId: ID!) {
  deleteClinicAdmin(clinicId: $clinicId, userId: $userId)
}
    `;
export type DeleteClinicAdminMutationFn = Apollo.MutationFunction<DeleteClinicAdminMutation, DeleteClinicAdminMutationVariables>;

/**
 * __useDeleteClinicAdminMutation__
 *
 * To run a mutation, you first call `useDeleteClinicAdminMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useDeleteClinicAdminMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [deleteClinicAdminMutation, { data, loading, error }] = useDeleteClinicAdminMutation({
 *   variables: {
 *      clinicId: // value for 'clinicId'
 *      userId: // value for 'userId'
 *   },
 * });
 */
export function useDeleteClinicAdminMutation(baseOptions?: Apollo.MutationHookOptions<DeleteClinicAdminMutation, DeleteClinicAdminMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<DeleteClinicAdminMutation, DeleteClinicAdminMutationVariables>(DeleteClinicAdminDocument, options);
      }
export type DeleteClinicAdminMutationHookResult = ReturnType<typeof useDeleteClinicAdminMutation>;
export type DeleteClinicAdminMutationResult = Apollo.MutationResult<DeleteClinicAdminMutation>;
export type DeleteClinicAdminMutationOptions = Apollo.BaseMutationOptions<DeleteClinicAdminMutation, DeleteClinicAdminMutationVariables>;
export const AddUserToClinicsAndClinicGroupsDocument = gql`
    mutation addUserToClinicsAndClinicGroups($data: AddUserToClinicsAndClinicGroupsInput!) {
  addUserToClinicsAndClinicGroups(data: $data)
}
    `;
export type AddUserToClinicsAndClinicGroupsMutationFn = Apollo.MutationFunction<AddUserToClinicsAndClinicGroupsMutation, AddUserToClinicsAndClinicGroupsMutationVariables>;

/**
 * __useAddUserToClinicsAndClinicGroupsMutation__
 *
 * To run a mutation, you first call `useAddUserToClinicsAndClinicGroupsMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useAddUserToClinicsAndClinicGroupsMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [addUserToClinicsAndClinicGroupsMutation, { data, loading, error }] = useAddUserToClinicsAndClinicGroupsMutation({
 *   variables: {
 *      data: // value for 'data'
 *   },
 * });
 */
export function useAddUserToClinicsAndClinicGroupsMutation(baseOptions?: Apollo.MutationHookOptions<AddUserToClinicsAndClinicGroupsMutation, AddUserToClinicsAndClinicGroupsMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<AddUserToClinicsAndClinicGroupsMutation, AddUserToClinicsAndClinicGroupsMutationVariables>(AddUserToClinicsAndClinicGroupsDocument, options);
      }
export type AddUserToClinicsAndClinicGroupsMutationHookResult = ReturnType<typeof useAddUserToClinicsAndClinicGroupsMutation>;
export type AddUserToClinicsAndClinicGroupsMutationResult = Apollo.MutationResult<AddUserToClinicsAndClinicGroupsMutation>;
export type AddUserToClinicsAndClinicGroupsMutationOptions = Apollo.BaseMutationOptions<AddUserToClinicsAndClinicGroupsMutation, AddUserToClinicsAndClinicGroupsMutationVariables>;
export const QueryClinicAdminClinicsDocument = gql`
    query queryClinicAdminClinics($userId: ID!, $where: [QueryInput!], $page: NonNegativeInt, $pageSize: NonNegativeInt, $orderBy: OrderByInput) {
  queryClinicAdminClinics(
    userId: $userId
    where: $where
    page: $page
    pageSize: $pageSize
    orderBy: $orderBy
  ) {
    ...ClinicFields
  }
}
    ${ClinicFieldsFragmentDoc}`;

/**
 * __useQueryClinicAdminClinicsQuery__
 *
 * To run a query within a React component, call `useQueryClinicAdminClinicsQuery` and pass it any options that fit your needs.
 * When your component renders, `useQueryClinicAdminClinicsQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useQueryClinicAdminClinicsQuery({
 *   variables: {
 *      userId: // value for 'userId'
 *      where: // value for 'where'
 *      page: // value for 'page'
 *      pageSize: // value for 'pageSize'
 *      orderBy: // value for 'orderBy'
 *   },
 * });
 */
export function useQueryClinicAdminClinicsQuery(baseOptions: Apollo.QueryHookOptions<QueryClinicAdminClinicsQuery, QueryClinicAdminClinicsQueryVariables> & ({ variables: QueryClinicAdminClinicsQueryVariables; skip?: boolean; } | { skip: boolean; }) ) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<QueryClinicAdminClinicsQuery, QueryClinicAdminClinicsQueryVariables>(QueryClinicAdminClinicsDocument, options);
      }
export function useQueryClinicAdminClinicsLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<QueryClinicAdminClinicsQuery, QueryClinicAdminClinicsQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<QueryClinicAdminClinicsQuery, QueryClinicAdminClinicsQueryVariables>(QueryClinicAdminClinicsDocument, options);
        }
export function useQueryClinicAdminClinicsSuspenseQuery(baseOptions?: Apollo.SuspenseQueryHookOptions<QueryClinicAdminClinicsQuery, QueryClinicAdminClinicsQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useSuspenseQuery<QueryClinicAdminClinicsQuery, QueryClinicAdminClinicsQueryVariables>(QueryClinicAdminClinicsDocument, options);
        }
export type QueryClinicAdminClinicsQueryHookResult = ReturnType<typeof useQueryClinicAdminClinicsQuery>;
export type QueryClinicAdminClinicsLazyQueryHookResult = ReturnType<typeof useQueryClinicAdminClinicsLazyQuery>;
export type QueryClinicAdminClinicsSuspenseQueryHookResult = ReturnType<typeof useQueryClinicAdminClinicsSuspenseQuery>;
export type QueryClinicAdminClinicsQueryResult = Apollo.QueryResult<QueryClinicAdminClinicsQuery, QueryClinicAdminClinicsQueryVariables>;
export const CountClinicAdminClinicsDocument = gql`
    query countClinicAdminClinics($userId: ID!, $where: [QueryInput!]) {
  countClinicAdminClinics(userId: $userId, where: $where)
}
    `;

/**
 * __useCountClinicAdminClinicsQuery__
 *
 * To run a query within a React component, call `useCountClinicAdminClinicsQuery` and pass it any options that fit your needs.
 * When your component renders, `useCountClinicAdminClinicsQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useCountClinicAdminClinicsQuery({
 *   variables: {
 *      userId: // value for 'userId'
 *      where: // value for 'where'
 *   },
 * });
 */
export function useCountClinicAdminClinicsQuery(baseOptions: Apollo.QueryHookOptions<CountClinicAdminClinicsQuery, CountClinicAdminClinicsQueryVariables> & ({ variables: CountClinicAdminClinicsQueryVariables; skip?: boolean; } | { skip: boolean; }) ) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<CountClinicAdminClinicsQuery, CountClinicAdminClinicsQueryVariables>(CountClinicAdminClinicsDocument, options);
      }
export function useCountClinicAdminClinicsLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<CountClinicAdminClinicsQuery, CountClinicAdminClinicsQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<CountClinicAdminClinicsQuery, CountClinicAdminClinicsQueryVariables>(CountClinicAdminClinicsDocument, options);
        }
export function useCountClinicAdminClinicsSuspenseQuery(baseOptions?: Apollo.SuspenseQueryHookOptions<CountClinicAdminClinicsQuery, CountClinicAdminClinicsQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useSuspenseQuery<CountClinicAdminClinicsQuery, CountClinicAdminClinicsQueryVariables>(CountClinicAdminClinicsDocument, options);
        }
export type CountClinicAdminClinicsQueryHookResult = ReturnType<typeof useCountClinicAdminClinicsQuery>;
export type CountClinicAdminClinicsLazyQueryHookResult = ReturnType<typeof useCountClinicAdminClinicsLazyQuery>;
export type CountClinicAdminClinicsSuspenseQueryHookResult = ReturnType<typeof useCountClinicAdminClinicsSuspenseQuery>;
export type CountClinicAdminClinicsQueryResult = Apollo.QueryResult<CountClinicAdminClinicsQuery, CountClinicAdminClinicsQueryVariables>;
export const GetClinicAccessForUserDocument = gql`
    query getClinicAccessForUser($clinicId: ID!, $userId: ID!) {
  clinicAccessForUser(clinicId: $clinicId, userId: $userId) {
    role
    source
    permissions {
      ...ClinicAdminPermissionFields
    }
  }
}
    ${ClinicAdminPermissionFieldsFragmentDoc}`;

/**
 * __useGetClinicAccessForUserQuery__
 *
 * To run a query within a React component, call `useGetClinicAccessForUserQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetClinicAccessForUserQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetClinicAccessForUserQuery({
 *   variables: {
 *      clinicId: // value for 'clinicId'
 *      userId: // value for 'userId'
 *   },
 * });
 */
export function useGetClinicAccessForUserQuery(baseOptions: Apollo.QueryHookOptions<GetClinicAccessForUserQuery, GetClinicAccessForUserQueryVariables> & ({ variables: GetClinicAccessForUserQueryVariables; skip?: boolean; } | { skip: boolean; }) ) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<GetClinicAccessForUserQuery, GetClinicAccessForUserQueryVariables>(GetClinicAccessForUserDocument, options);
      }
export function useGetClinicAccessForUserLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<GetClinicAccessForUserQuery, GetClinicAccessForUserQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<GetClinicAccessForUserQuery, GetClinicAccessForUserQueryVariables>(GetClinicAccessForUserDocument, options);
        }
export function useGetClinicAccessForUserSuspenseQuery(baseOptions?: Apollo.SuspenseQueryHookOptions<GetClinicAccessForUserQuery, GetClinicAccessForUserQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useSuspenseQuery<GetClinicAccessForUserQuery, GetClinicAccessForUserQueryVariables>(GetClinicAccessForUserDocument, options);
        }
export type GetClinicAccessForUserQueryHookResult = ReturnType<typeof useGetClinicAccessForUserQuery>;
export type GetClinicAccessForUserLazyQueryHookResult = ReturnType<typeof useGetClinicAccessForUserLazyQuery>;
export type GetClinicAccessForUserSuspenseQueryHookResult = ReturnType<typeof useGetClinicAccessForUserSuspenseQuery>;
export type GetClinicAccessForUserQueryResult = Apollo.QueryResult<GetClinicAccessForUserQuery, GetClinicAccessForUserQueryVariables>;
export const ClinicAgentEnabledDocument = gql`
    query clinicAgentEnabled($clinicId: ID!) {
  clinicAgentEnabled(clinicId: $clinicId)
}
    `;

/**
 * __useClinicAgentEnabledQuery__
 *
 * To run a query within a React component, call `useClinicAgentEnabledQuery` and pass it any options that fit your needs.
 * When your component renders, `useClinicAgentEnabledQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useClinicAgentEnabledQuery({
 *   variables: {
 *      clinicId: // value for 'clinicId'
 *   },
 * });
 */
export function useClinicAgentEnabledQuery(baseOptions: Apollo.QueryHookOptions<ClinicAgentEnabledQuery, ClinicAgentEnabledQueryVariables> & ({ variables: ClinicAgentEnabledQueryVariables; skip?: boolean; } | { skip: boolean; }) ) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<ClinicAgentEnabledQuery, ClinicAgentEnabledQueryVariables>(ClinicAgentEnabledDocument, options);
      }
export function useClinicAgentEnabledLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<ClinicAgentEnabledQuery, ClinicAgentEnabledQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<ClinicAgentEnabledQuery, ClinicAgentEnabledQueryVariables>(ClinicAgentEnabledDocument, options);
        }
export function useClinicAgentEnabledSuspenseQuery(baseOptions?: Apollo.SuspenseQueryHookOptions<ClinicAgentEnabledQuery, ClinicAgentEnabledQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useSuspenseQuery<ClinicAgentEnabledQuery, ClinicAgentEnabledQueryVariables>(ClinicAgentEnabledDocument, options);
        }
export type ClinicAgentEnabledQueryHookResult = ReturnType<typeof useClinicAgentEnabledQuery>;
export type ClinicAgentEnabledLazyQueryHookResult = ReturnType<typeof useClinicAgentEnabledLazyQuery>;
export type ClinicAgentEnabledSuspenseQueryHookResult = ReturnType<typeof useClinicAgentEnabledSuspenseQuery>;
export type ClinicAgentEnabledQueryResult = Apollo.QueryResult<ClinicAgentEnabledQuery, ClinicAgentEnabledQueryVariables>;
export const MyClinicAgentConversationsDocument = gql`
    query myClinicAgentConversations($clinicId: ID!, $limit: NonNegativeInt) {
  myClinicAgentConversations(clinicId: $clinicId, limit: $limit) {
    ...SupportBotConversationFields
  }
}
    ${SupportBotConversationFieldsFragmentDoc}`;

/**
 * __useMyClinicAgentConversationsQuery__
 *
 * To run a query within a React component, call `useMyClinicAgentConversationsQuery` and pass it any options that fit your needs.
 * When your component renders, `useMyClinicAgentConversationsQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useMyClinicAgentConversationsQuery({
 *   variables: {
 *      clinicId: // value for 'clinicId'
 *      limit: // value for 'limit'
 *   },
 * });
 */
export function useMyClinicAgentConversationsQuery(baseOptions: Apollo.QueryHookOptions<MyClinicAgentConversationsQuery, MyClinicAgentConversationsQueryVariables> & ({ variables: MyClinicAgentConversationsQueryVariables; skip?: boolean; } | { skip: boolean; }) ) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<MyClinicAgentConversationsQuery, MyClinicAgentConversationsQueryVariables>(MyClinicAgentConversationsDocument, options);
      }
export function useMyClinicAgentConversationsLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<MyClinicAgentConversationsQuery, MyClinicAgentConversationsQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<MyClinicAgentConversationsQuery, MyClinicAgentConversationsQueryVariables>(MyClinicAgentConversationsDocument, options);
        }
export function useMyClinicAgentConversationsSuspenseQuery(baseOptions?: Apollo.SuspenseQueryHookOptions<MyClinicAgentConversationsQuery, MyClinicAgentConversationsQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useSuspenseQuery<MyClinicAgentConversationsQuery, MyClinicAgentConversationsQueryVariables>(MyClinicAgentConversationsDocument, options);
        }
export type MyClinicAgentConversationsQueryHookResult = ReturnType<typeof useMyClinicAgentConversationsQuery>;
export type MyClinicAgentConversationsLazyQueryHookResult = ReturnType<typeof useMyClinicAgentConversationsLazyQuery>;
export type MyClinicAgentConversationsSuspenseQueryHookResult = ReturnType<typeof useMyClinicAgentConversationsSuspenseQuery>;
export type MyClinicAgentConversationsQueryResult = Apollo.QueryResult<MyClinicAgentConversationsQuery, MyClinicAgentConversationsQueryVariables>;
export const ClinicAgentConversationDocument = gql`
    query clinicAgentConversation($clinicId: ID!, $id: ID!) {
  clinicAgentConversation(clinicId: $clinicId, id: $id) {
    ...SupportBotConversationFields
  }
}
    ${SupportBotConversationFieldsFragmentDoc}`;

/**
 * __useClinicAgentConversationQuery__
 *
 * To run a query within a React component, call `useClinicAgentConversationQuery` and pass it any options that fit your needs.
 * When your component renders, `useClinicAgentConversationQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useClinicAgentConversationQuery({
 *   variables: {
 *      clinicId: // value for 'clinicId'
 *      id: // value for 'id'
 *   },
 * });
 */
export function useClinicAgentConversationQuery(baseOptions: Apollo.QueryHookOptions<ClinicAgentConversationQuery, ClinicAgentConversationQueryVariables> & ({ variables: ClinicAgentConversationQueryVariables; skip?: boolean; } | { skip: boolean; }) ) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<ClinicAgentConversationQuery, ClinicAgentConversationQueryVariables>(ClinicAgentConversationDocument, options);
      }
export function useClinicAgentConversationLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<ClinicAgentConversationQuery, ClinicAgentConversationQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<ClinicAgentConversationQuery, ClinicAgentConversationQueryVariables>(ClinicAgentConversationDocument, options);
        }
export function useClinicAgentConversationSuspenseQuery(baseOptions?: Apollo.SuspenseQueryHookOptions<ClinicAgentConversationQuery, ClinicAgentConversationQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useSuspenseQuery<ClinicAgentConversationQuery, ClinicAgentConversationQueryVariables>(ClinicAgentConversationDocument, options);
        }
export type ClinicAgentConversationQueryHookResult = ReturnType<typeof useClinicAgentConversationQuery>;
export type ClinicAgentConversationLazyQueryHookResult = ReturnType<typeof useClinicAgentConversationLazyQuery>;
export type ClinicAgentConversationSuspenseQueryHookResult = ReturnType<typeof useClinicAgentConversationSuspenseQuery>;
export type ClinicAgentConversationQueryResult = Apollo.QueryResult<ClinicAgentConversationQuery, ClinicAgentConversationQueryVariables>;
export const ClinicAgentRunStatusDocument = gql`
    query clinicAgentRunStatus($clinicId: ID!, $runId: ID!) {
  clinicAgentRunStatus(clinicId: $clinicId, runId: $runId) {
    ...SupportBotRunSnapshotFields
  }
}
    ${SupportBotRunSnapshotFieldsFragmentDoc}`;

/**
 * __useClinicAgentRunStatusQuery__
 *
 * To run a query within a React component, call `useClinicAgentRunStatusQuery` and pass it any options that fit your needs.
 * When your component renders, `useClinicAgentRunStatusQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useClinicAgentRunStatusQuery({
 *   variables: {
 *      clinicId: // value for 'clinicId'
 *      runId: // value for 'runId'
 *   },
 * });
 */
export function useClinicAgentRunStatusQuery(baseOptions: Apollo.QueryHookOptions<ClinicAgentRunStatusQuery, ClinicAgentRunStatusQueryVariables> & ({ variables: ClinicAgentRunStatusQueryVariables; skip?: boolean; } | { skip: boolean; }) ) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<ClinicAgentRunStatusQuery, ClinicAgentRunStatusQueryVariables>(ClinicAgentRunStatusDocument, options);
      }
export function useClinicAgentRunStatusLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<ClinicAgentRunStatusQuery, ClinicAgentRunStatusQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<ClinicAgentRunStatusQuery, ClinicAgentRunStatusQueryVariables>(ClinicAgentRunStatusDocument, options);
        }
export function useClinicAgentRunStatusSuspenseQuery(baseOptions?: Apollo.SuspenseQueryHookOptions<ClinicAgentRunStatusQuery, ClinicAgentRunStatusQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useSuspenseQuery<ClinicAgentRunStatusQuery, ClinicAgentRunStatusQueryVariables>(ClinicAgentRunStatusDocument, options);
        }
export type ClinicAgentRunStatusQueryHookResult = ReturnType<typeof useClinicAgentRunStatusQuery>;
export type ClinicAgentRunStatusLazyQueryHookResult = ReturnType<typeof useClinicAgentRunStatusLazyQuery>;
export type ClinicAgentRunStatusSuspenseQueryHookResult = ReturnType<typeof useClinicAgentRunStatusSuspenseQuery>;
export type ClinicAgentRunStatusQueryResult = Apollo.QueryResult<ClinicAgentRunStatusQuery, ClinicAgentRunStatusQueryVariables>;
export const MintClinicAgentSessionDocument = gql`
    mutation mintClinicAgentSession($clinicId: ID!) {
  mintClinicAgentSession(clinicId: $clinicId) {
    token
    expiresAt
  }
}
    `;
export type MintClinicAgentSessionMutationFn = Apollo.MutationFunction<MintClinicAgentSessionMutation, MintClinicAgentSessionMutationVariables>;

/**
 * __useMintClinicAgentSessionMutation__
 *
 * To run a mutation, you first call `useMintClinicAgentSessionMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useMintClinicAgentSessionMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [mintClinicAgentSessionMutation, { data, loading, error }] = useMintClinicAgentSessionMutation({
 *   variables: {
 *      clinicId: // value for 'clinicId'
 *   },
 * });
 */
export function useMintClinicAgentSessionMutation(baseOptions?: Apollo.MutationHookOptions<MintClinicAgentSessionMutation, MintClinicAgentSessionMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<MintClinicAgentSessionMutation, MintClinicAgentSessionMutationVariables>(MintClinicAgentSessionDocument, options);
      }
export type MintClinicAgentSessionMutationHookResult = ReturnType<typeof useMintClinicAgentSessionMutation>;
export type MintClinicAgentSessionMutationResult = Apollo.MutationResult<MintClinicAgentSessionMutation>;
export type MintClinicAgentSessionMutationOptions = Apollo.BaseMutationOptions<MintClinicAgentSessionMutation, MintClinicAgentSessionMutationVariables>;
export const SendClinicAgentMessageDocument = gql`
    mutation sendClinicAgentMessage($input: SendClinicAgentMessageInput!) {
  sendClinicAgentMessage(input: $input) {
    runId
    conversationId
    status
    conversation {
      ...SupportBotConversationFields
    }
  }
}
    ${SupportBotConversationFieldsFragmentDoc}`;
export type SendClinicAgentMessageMutationFn = Apollo.MutationFunction<SendClinicAgentMessageMutation, SendClinicAgentMessageMutationVariables>;

/**
 * __useSendClinicAgentMessageMutation__
 *
 * To run a mutation, you first call `useSendClinicAgentMessageMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useSendClinicAgentMessageMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [sendClinicAgentMessageMutation, { data, loading, error }] = useSendClinicAgentMessageMutation({
 *   variables: {
 *      input: // value for 'input'
 *   },
 * });
 */
export function useSendClinicAgentMessageMutation(baseOptions?: Apollo.MutationHookOptions<SendClinicAgentMessageMutation, SendClinicAgentMessageMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<SendClinicAgentMessageMutation, SendClinicAgentMessageMutationVariables>(SendClinicAgentMessageDocument, options);
      }
export type SendClinicAgentMessageMutationHookResult = ReturnType<typeof useSendClinicAgentMessageMutation>;
export type SendClinicAgentMessageMutationResult = Apollo.MutationResult<SendClinicAgentMessageMutation>;
export type SendClinicAgentMessageMutationOptions = Apollo.BaseMutationOptions<SendClinicAgentMessageMutation, SendClinicAgentMessageMutationVariables>;
export const GetYesterdayAnalyticsDocument = gql`
    query getYesterdayAnalytics($clinicId: ID!, $fromDate: NonNegativeInt!, $toDate: NonNegativeInt!) {
  yesterdayAnalytics(clinicId: $clinicId, fromDate: $fromDate, toDate: $toDate) {
    ...YesterdayAnalyticsFields
  }
}
    ${YesterdayAnalyticsFieldsFragmentDoc}`;

/**
 * __useGetYesterdayAnalyticsQuery__
 *
 * To run a query within a React component, call `useGetYesterdayAnalyticsQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetYesterdayAnalyticsQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetYesterdayAnalyticsQuery({
 *   variables: {
 *      clinicId: // value for 'clinicId'
 *      fromDate: // value for 'fromDate'
 *      toDate: // value for 'toDate'
 *   },
 * });
 */
export function useGetYesterdayAnalyticsQuery(baseOptions: Apollo.QueryHookOptions<GetYesterdayAnalyticsQuery, GetYesterdayAnalyticsQueryVariables> & ({ variables: GetYesterdayAnalyticsQueryVariables; skip?: boolean; } | { skip: boolean; }) ) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<GetYesterdayAnalyticsQuery, GetYesterdayAnalyticsQueryVariables>(GetYesterdayAnalyticsDocument, options);
      }
export function useGetYesterdayAnalyticsLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<GetYesterdayAnalyticsQuery, GetYesterdayAnalyticsQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<GetYesterdayAnalyticsQuery, GetYesterdayAnalyticsQueryVariables>(GetYesterdayAnalyticsDocument, options);
        }
export function useGetYesterdayAnalyticsSuspenseQuery(baseOptions?: Apollo.SuspenseQueryHookOptions<GetYesterdayAnalyticsQuery, GetYesterdayAnalyticsQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useSuspenseQuery<GetYesterdayAnalyticsQuery, GetYesterdayAnalyticsQueryVariables>(GetYesterdayAnalyticsDocument, options);
        }
export type GetYesterdayAnalyticsQueryHookResult = ReturnType<typeof useGetYesterdayAnalyticsQuery>;
export type GetYesterdayAnalyticsLazyQueryHookResult = ReturnType<typeof useGetYesterdayAnalyticsLazyQuery>;
export type GetYesterdayAnalyticsSuspenseQueryHookResult = ReturnType<typeof useGetYesterdayAnalyticsSuspenseQuery>;
export type GetYesterdayAnalyticsQueryResult = Apollo.QueryResult<GetYesterdayAnalyticsQuery, GetYesterdayAnalyticsQueryVariables>;
export const GetTodayAnalyticsDocument = gql`
    query getTodayAnalytics($clinicId: ID!, $fromDate: NonNegativeInt!, $toDate: NonNegativeInt!) {
  todayAnalytics(clinicId: $clinicId, fromDate: $fromDate, toDate: $toDate) {
    ...TodayAnalyticsFields
  }
}
    ${TodayAnalyticsFieldsFragmentDoc}`;

/**
 * __useGetTodayAnalyticsQuery__
 *
 * To run a query within a React component, call `useGetTodayAnalyticsQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetTodayAnalyticsQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetTodayAnalyticsQuery({
 *   variables: {
 *      clinicId: // value for 'clinicId'
 *      fromDate: // value for 'fromDate'
 *      toDate: // value for 'toDate'
 *   },
 * });
 */
export function useGetTodayAnalyticsQuery(baseOptions: Apollo.QueryHookOptions<GetTodayAnalyticsQuery, GetTodayAnalyticsQueryVariables> & ({ variables: GetTodayAnalyticsQueryVariables; skip?: boolean; } | { skip: boolean; }) ) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<GetTodayAnalyticsQuery, GetTodayAnalyticsQueryVariables>(GetTodayAnalyticsDocument, options);
      }
export function useGetTodayAnalyticsLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<GetTodayAnalyticsQuery, GetTodayAnalyticsQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<GetTodayAnalyticsQuery, GetTodayAnalyticsQueryVariables>(GetTodayAnalyticsDocument, options);
        }
export function useGetTodayAnalyticsSuspenseQuery(baseOptions?: Apollo.SuspenseQueryHookOptions<GetTodayAnalyticsQuery, GetTodayAnalyticsQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useSuspenseQuery<GetTodayAnalyticsQuery, GetTodayAnalyticsQueryVariables>(GetTodayAnalyticsDocument, options);
        }
export type GetTodayAnalyticsQueryHookResult = ReturnType<typeof useGetTodayAnalyticsQuery>;
export type GetTodayAnalyticsLazyQueryHookResult = ReturnType<typeof useGetTodayAnalyticsLazyQuery>;
export type GetTodayAnalyticsSuspenseQueryHookResult = ReturnType<typeof useGetTodayAnalyticsSuspenseQuery>;
export type GetTodayAnalyticsQueryResult = Apollo.QueryResult<GetTodayAnalyticsQuery, GetTodayAnalyticsQueryVariables>;
export const GetTomorrowAnalyticsDocument = gql`
    query getTomorrowAnalytics($clinicId: ID!, $fromDate: NonNegativeInt!, $toDate: NonNegativeInt!) {
  tomorrowAnalytics(clinicId: $clinicId, fromDate: $fromDate, toDate: $toDate) {
    ...TomorrowAnalyticsFields
  }
}
    ${TomorrowAnalyticsFieldsFragmentDoc}`;

/**
 * __useGetTomorrowAnalyticsQuery__
 *
 * To run a query within a React component, call `useGetTomorrowAnalyticsQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetTomorrowAnalyticsQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetTomorrowAnalyticsQuery({
 *   variables: {
 *      clinicId: // value for 'clinicId'
 *      fromDate: // value for 'fromDate'
 *      toDate: // value for 'toDate'
 *   },
 * });
 */
export function useGetTomorrowAnalyticsQuery(baseOptions: Apollo.QueryHookOptions<GetTomorrowAnalyticsQuery, GetTomorrowAnalyticsQueryVariables> & ({ variables: GetTomorrowAnalyticsQueryVariables; skip?: boolean; } | { skip: boolean; }) ) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<GetTomorrowAnalyticsQuery, GetTomorrowAnalyticsQueryVariables>(GetTomorrowAnalyticsDocument, options);
      }
export function useGetTomorrowAnalyticsLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<GetTomorrowAnalyticsQuery, GetTomorrowAnalyticsQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<GetTomorrowAnalyticsQuery, GetTomorrowAnalyticsQueryVariables>(GetTomorrowAnalyticsDocument, options);
        }
export function useGetTomorrowAnalyticsSuspenseQuery(baseOptions?: Apollo.SuspenseQueryHookOptions<GetTomorrowAnalyticsQuery, GetTomorrowAnalyticsQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useSuspenseQuery<GetTomorrowAnalyticsQuery, GetTomorrowAnalyticsQueryVariables>(GetTomorrowAnalyticsDocument, options);
        }
export type GetTomorrowAnalyticsQueryHookResult = ReturnType<typeof useGetTomorrowAnalyticsQuery>;
export type GetTomorrowAnalyticsLazyQueryHookResult = ReturnType<typeof useGetTomorrowAnalyticsLazyQuery>;
export type GetTomorrowAnalyticsSuspenseQueryHookResult = ReturnType<typeof useGetTomorrowAnalyticsSuspenseQuery>;
export type GetTomorrowAnalyticsQueryResult = Apollo.QueryResult<GetTomorrowAnalyticsQuery, GetTomorrowAnalyticsQueryVariables>;
export const GetRevenueByMonthsForClinicDocument = gql`
    query getRevenueByMonthsForClinic($clinicId: ID!, $numMonths: NonNegativeInt!) {
  getRevenueByMonthsForClinic(clinicId: $clinicId, numMonths: $numMonths) {
    month
    year
    revenue
  }
}
    `;

/**
 * __useGetRevenueByMonthsForClinicQuery__
 *
 * To run a query within a React component, call `useGetRevenueByMonthsForClinicQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetRevenueByMonthsForClinicQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetRevenueByMonthsForClinicQuery({
 *   variables: {
 *      clinicId: // value for 'clinicId'
 *      numMonths: // value for 'numMonths'
 *   },
 * });
 */
export function useGetRevenueByMonthsForClinicQuery(baseOptions: Apollo.QueryHookOptions<GetRevenueByMonthsForClinicQuery, GetRevenueByMonthsForClinicQueryVariables> & ({ variables: GetRevenueByMonthsForClinicQueryVariables; skip?: boolean; } | { skip: boolean; }) ) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<GetRevenueByMonthsForClinicQuery, GetRevenueByMonthsForClinicQueryVariables>(GetRevenueByMonthsForClinicDocument, options);
      }
export function useGetRevenueByMonthsForClinicLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<GetRevenueByMonthsForClinicQuery, GetRevenueByMonthsForClinicQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<GetRevenueByMonthsForClinicQuery, GetRevenueByMonthsForClinicQueryVariables>(GetRevenueByMonthsForClinicDocument, options);
        }
export function useGetRevenueByMonthsForClinicSuspenseQuery(baseOptions?: Apollo.SuspenseQueryHookOptions<GetRevenueByMonthsForClinicQuery, GetRevenueByMonthsForClinicQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useSuspenseQuery<GetRevenueByMonthsForClinicQuery, GetRevenueByMonthsForClinicQueryVariables>(GetRevenueByMonthsForClinicDocument, options);
        }
export type GetRevenueByMonthsForClinicQueryHookResult = ReturnType<typeof useGetRevenueByMonthsForClinicQuery>;
export type GetRevenueByMonthsForClinicLazyQueryHookResult = ReturnType<typeof useGetRevenueByMonthsForClinicLazyQuery>;
export type GetRevenueByMonthsForClinicSuspenseQueryHookResult = ReturnType<typeof useGetRevenueByMonthsForClinicSuspenseQuery>;
export type GetRevenueByMonthsForClinicQueryResult = Apollo.QueryResult<GetRevenueByMonthsForClinicQuery, GetRevenueByMonthsForClinicQueryVariables>;
export const GetClinicApptStatusesByClinicDocument = gql`
    query getClinicApptStatusesByClinic($clinicId: ID!) {
  getClinicApptStatusesByClinic(clinicId: $clinicId) {
    ...ClinicApptStatusFields
  }
}
    ${ClinicApptStatusFieldsFragmentDoc}`;

/**
 * __useGetClinicApptStatusesByClinicQuery__
 *
 * To run a query within a React component, call `useGetClinicApptStatusesByClinicQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetClinicApptStatusesByClinicQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetClinicApptStatusesByClinicQuery({
 *   variables: {
 *      clinicId: // value for 'clinicId'
 *   },
 * });
 */
export function useGetClinicApptStatusesByClinicQuery(baseOptions: Apollo.QueryHookOptions<GetClinicApptStatusesByClinicQuery, GetClinicApptStatusesByClinicQueryVariables> & ({ variables: GetClinicApptStatusesByClinicQueryVariables; skip?: boolean; } | { skip: boolean; }) ) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<GetClinicApptStatusesByClinicQuery, GetClinicApptStatusesByClinicQueryVariables>(GetClinicApptStatusesByClinicDocument, options);
      }
export function useGetClinicApptStatusesByClinicLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<GetClinicApptStatusesByClinicQuery, GetClinicApptStatusesByClinicQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<GetClinicApptStatusesByClinicQuery, GetClinicApptStatusesByClinicQueryVariables>(GetClinicApptStatusesByClinicDocument, options);
        }
export function useGetClinicApptStatusesByClinicSuspenseQuery(baseOptions?: Apollo.SuspenseQueryHookOptions<GetClinicApptStatusesByClinicQuery, GetClinicApptStatusesByClinicQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useSuspenseQuery<GetClinicApptStatusesByClinicQuery, GetClinicApptStatusesByClinicQueryVariables>(GetClinicApptStatusesByClinicDocument, options);
        }
export type GetClinicApptStatusesByClinicQueryHookResult = ReturnType<typeof useGetClinicApptStatusesByClinicQuery>;
export type GetClinicApptStatusesByClinicLazyQueryHookResult = ReturnType<typeof useGetClinicApptStatusesByClinicLazyQuery>;
export type GetClinicApptStatusesByClinicSuspenseQueryHookResult = ReturnType<typeof useGetClinicApptStatusesByClinicSuspenseQuery>;
export type GetClinicApptStatusesByClinicQueryResult = Apollo.QueryResult<GetClinicApptStatusesByClinicQuery, GetClinicApptStatusesByClinicQueryVariables>;
export const QueryClinicApptStatusesDocument = gql`
    query queryClinicApptStatuses($where: [QueryInput!], $page: NonNegativeInt, $pageSize: NonNegativeInt, $orderBy: OrderByInput) {
  queryClinicApptStatuses(
    where: $where
    page: $page
    pageSize: $pageSize
    orderBy: $orderBy
  ) {
    ...ClinicApptStatusFields
  }
}
    ${ClinicApptStatusFieldsFragmentDoc}`;

/**
 * __useQueryClinicApptStatusesQuery__
 *
 * To run a query within a React component, call `useQueryClinicApptStatusesQuery` and pass it any options that fit your needs.
 * When your component renders, `useQueryClinicApptStatusesQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useQueryClinicApptStatusesQuery({
 *   variables: {
 *      where: // value for 'where'
 *      page: // value for 'page'
 *      pageSize: // value for 'pageSize'
 *      orderBy: // value for 'orderBy'
 *   },
 * });
 */
export function useQueryClinicApptStatusesQuery(baseOptions?: Apollo.QueryHookOptions<QueryClinicApptStatusesQuery, QueryClinicApptStatusesQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<QueryClinicApptStatusesQuery, QueryClinicApptStatusesQueryVariables>(QueryClinicApptStatusesDocument, options);
      }
export function useQueryClinicApptStatusesLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<QueryClinicApptStatusesQuery, QueryClinicApptStatusesQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<QueryClinicApptStatusesQuery, QueryClinicApptStatusesQueryVariables>(QueryClinicApptStatusesDocument, options);
        }
export function useQueryClinicApptStatusesSuspenseQuery(baseOptions?: Apollo.SuspenseQueryHookOptions<QueryClinicApptStatusesQuery, QueryClinicApptStatusesQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useSuspenseQuery<QueryClinicApptStatusesQuery, QueryClinicApptStatusesQueryVariables>(QueryClinicApptStatusesDocument, options);
        }
export type QueryClinicApptStatusesQueryHookResult = ReturnType<typeof useQueryClinicApptStatusesQuery>;
export type QueryClinicApptStatusesLazyQueryHookResult = ReturnType<typeof useQueryClinicApptStatusesLazyQuery>;
export type QueryClinicApptStatusesSuspenseQueryHookResult = ReturnType<typeof useQueryClinicApptStatusesSuspenseQuery>;
export type QueryClinicApptStatusesQueryResult = Apollo.QueryResult<QueryClinicApptStatusesQuery, QueryClinicApptStatusesQueryVariables>;
export const CountClinicApptStatusesDocument = gql`
    query countClinicApptStatuses($where: [QueryInput!]) {
  countClinicApptStatuses(where: $where)
}
    `;

/**
 * __useCountClinicApptStatusesQuery__
 *
 * To run a query within a React component, call `useCountClinicApptStatusesQuery` and pass it any options that fit your needs.
 * When your component renders, `useCountClinicApptStatusesQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useCountClinicApptStatusesQuery({
 *   variables: {
 *      where: // value for 'where'
 *   },
 * });
 */
export function useCountClinicApptStatusesQuery(baseOptions?: Apollo.QueryHookOptions<CountClinicApptStatusesQuery, CountClinicApptStatusesQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<CountClinicApptStatusesQuery, CountClinicApptStatusesQueryVariables>(CountClinicApptStatusesDocument, options);
      }
export function useCountClinicApptStatusesLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<CountClinicApptStatusesQuery, CountClinicApptStatusesQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<CountClinicApptStatusesQuery, CountClinicApptStatusesQueryVariables>(CountClinicApptStatusesDocument, options);
        }
export function useCountClinicApptStatusesSuspenseQuery(baseOptions?: Apollo.SuspenseQueryHookOptions<CountClinicApptStatusesQuery, CountClinicApptStatusesQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useSuspenseQuery<CountClinicApptStatusesQuery, CountClinicApptStatusesQueryVariables>(CountClinicApptStatusesDocument, options);
        }
export type CountClinicApptStatusesQueryHookResult = ReturnType<typeof useCountClinicApptStatusesQuery>;
export type CountClinicApptStatusesLazyQueryHookResult = ReturnType<typeof useCountClinicApptStatusesLazyQuery>;
export type CountClinicApptStatusesSuspenseQueryHookResult = ReturnType<typeof useCountClinicApptStatusesSuspenseQuery>;
export type CountClinicApptStatusesQueryResult = Apollo.QueryResult<CountClinicApptStatusesQuery, CountClinicApptStatusesQueryVariables>;
export const ReassignClinicApptStatusDocument = gql`
    mutation reassignClinicApptStatus($clinicId: ID!, $statusId: ID!, $newStatus: AppointmentStatus!) {
  reassignClinicApptStatus(
    clinicId: $clinicId
    apptStatusId: $statusId
    newStatus: $newStatus
  ) {
    ...ClinicApptStatusFields
  }
}
    ${ClinicApptStatusFieldsFragmentDoc}`;
export type ReassignClinicApptStatusMutationFn = Apollo.MutationFunction<ReassignClinicApptStatusMutation, ReassignClinicApptStatusMutationVariables>;

/**
 * __useReassignClinicApptStatusMutation__
 *
 * To run a mutation, you first call `useReassignClinicApptStatusMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useReassignClinicApptStatusMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [reassignClinicApptStatusMutation, { data, loading, error }] = useReassignClinicApptStatusMutation({
 *   variables: {
 *      clinicId: // value for 'clinicId'
 *      statusId: // value for 'statusId'
 *      newStatus: // value for 'newStatus'
 *   },
 * });
 */
export function useReassignClinicApptStatusMutation(baseOptions?: Apollo.MutationHookOptions<ReassignClinicApptStatusMutation, ReassignClinicApptStatusMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<ReassignClinicApptStatusMutation, ReassignClinicApptStatusMutationVariables>(ReassignClinicApptStatusDocument, options);
      }
export type ReassignClinicApptStatusMutationHookResult = ReturnType<typeof useReassignClinicApptStatusMutation>;
export type ReassignClinicApptStatusMutationResult = Apollo.MutationResult<ReassignClinicApptStatusMutation>;
export type ReassignClinicApptStatusMutationOptions = Apollo.BaseMutationOptions<ReassignClinicApptStatusMutation, ReassignClinicApptStatusMutationVariables>;
export const MakePrimaryClinicApptStatusDocument = gql`
    mutation makePrimaryClinicApptStatus($clinicId: ID!, $statusId: ID!) {
  makePrimaryClinicApptStatus(clinicId: $clinicId, apptStatusId: $statusId) {
    ...ClinicApptStatusFields
  }
}
    ${ClinicApptStatusFieldsFragmentDoc}`;
export type MakePrimaryClinicApptStatusMutationFn = Apollo.MutationFunction<MakePrimaryClinicApptStatusMutation, MakePrimaryClinicApptStatusMutationVariables>;

/**
 * __useMakePrimaryClinicApptStatusMutation__
 *
 * To run a mutation, you first call `useMakePrimaryClinicApptStatusMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useMakePrimaryClinicApptStatusMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [makePrimaryClinicApptStatusMutation, { data, loading, error }] = useMakePrimaryClinicApptStatusMutation({
 *   variables: {
 *      clinicId: // value for 'clinicId'
 *      statusId: // value for 'statusId'
 *   },
 * });
 */
export function useMakePrimaryClinicApptStatusMutation(baseOptions?: Apollo.MutationHookOptions<MakePrimaryClinicApptStatusMutation, MakePrimaryClinicApptStatusMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<MakePrimaryClinicApptStatusMutation, MakePrimaryClinicApptStatusMutationVariables>(MakePrimaryClinicApptStatusDocument, options);
      }
export type MakePrimaryClinicApptStatusMutationHookResult = ReturnType<typeof useMakePrimaryClinicApptStatusMutation>;
export type MakePrimaryClinicApptStatusMutationResult = Apollo.MutationResult<MakePrimaryClinicApptStatusMutation>;
export type MakePrimaryClinicApptStatusMutationOptions = Apollo.BaseMutationOptions<MakePrimaryClinicApptStatusMutation, MakePrimaryClinicApptStatusMutationVariables>;
export const UpdateClinicApptStatusDocument = gql`
    mutation updateClinicApptStatus($clinicId: ID!, $statusId: ID!, $data: UpdateClinicApptStatusInput!) {
  updateClinicApptStatus(
    clinicId: $clinicId
    apptStatusId: $statusId
    data: $data
  ) {
    ...ClinicApptStatusFields
  }
}
    ${ClinicApptStatusFieldsFragmentDoc}`;
export type UpdateClinicApptStatusMutationFn = Apollo.MutationFunction<UpdateClinicApptStatusMutation, UpdateClinicApptStatusMutationVariables>;

/**
 * __useUpdateClinicApptStatusMutation__
 *
 * To run a mutation, you first call `useUpdateClinicApptStatusMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useUpdateClinicApptStatusMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [updateClinicApptStatusMutation, { data, loading, error }] = useUpdateClinicApptStatusMutation({
 *   variables: {
 *      clinicId: // value for 'clinicId'
 *      statusId: // value for 'statusId'
 *      data: // value for 'data'
 *   },
 * });
 */
export function useUpdateClinicApptStatusMutation(baseOptions?: Apollo.MutationHookOptions<UpdateClinicApptStatusMutation, UpdateClinicApptStatusMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<UpdateClinicApptStatusMutation, UpdateClinicApptStatusMutationVariables>(UpdateClinicApptStatusDocument, options);
      }
export type UpdateClinicApptStatusMutationHookResult = ReturnType<typeof useUpdateClinicApptStatusMutation>;
export type UpdateClinicApptStatusMutationResult = Apollo.MutationResult<UpdateClinicApptStatusMutation>;
export type UpdateClinicApptStatusMutationOptions = Apollo.BaseMutationOptions<UpdateClinicApptStatusMutation, UpdateClinicApptStatusMutationVariables>;
export const GetClinicGroupDocument = gql`
    query getClinicGroup($id: ID!) {
  clinicGroup(id: $id) {
    ...ClinicGroupFields
  }
}
    ${ClinicGroupFieldsFragmentDoc}`;

/**
 * __useGetClinicGroupQuery__
 *
 * To run a query within a React component, call `useGetClinicGroupQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetClinicGroupQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetClinicGroupQuery({
 *   variables: {
 *      id: // value for 'id'
 *   },
 * });
 */
export function useGetClinicGroupQuery(baseOptions: Apollo.QueryHookOptions<GetClinicGroupQuery, GetClinicGroupQueryVariables> & ({ variables: GetClinicGroupQueryVariables; skip?: boolean; } | { skip: boolean; }) ) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<GetClinicGroupQuery, GetClinicGroupQueryVariables>(GetClinicGroupDocument, options);
      }
export function useGetClinicGroupLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<GetClinicGroupQuery, GetClinicGroupQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<GetClinicGroupQuery, GetClinicGroupQueryVariables>(GetClinicGroupDocument, options);
        }
export function useGetClinicGroupSuspenseQuery(baseOptions?: Apollo.SuspenseQueryHookOptions<GetClinicGroupQuery, GetClinicGroupQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useSuspenseQuery<GetClinicGroupQuery, GetClinicGroupQueryVariables>(GetClinicGroupDocument, options);
        }
export type GetClinicGroupQueryHookResult = ReturnType<typeof useGetClinicGroupQuery>;
export type GetClinicGroupLazyQueryHookResult = ReturnType<typeof useGetClinicGroupLazyQuery>;
export type GetClinicGroupSuspenseQueryHookResult = ReturnType<typeof useGetClinicGroupSuspenseQuery>;
export type GetClinicGroupQueryResult = Apollo.QueryResult<GetClinicGroupQuery, GetClinicGroupQueryVariables>;
export const GetClinicGroupUsersDocument = gql`
    query getClinicGroupUsers($id: ID!) {
  clinicGroup(id: $id) {
    clinic_group_users {
      ...ClinicGroupUserFields
    }
  }
}
    ${ClinicGroupUserFieldsFragmentDoc}`;

/**
 * __useGetClinicGroupUsersQuery__
 *
 * To run a query within a React component, call `useGetClinicGroupUsersQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetClinicGroupUsersQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetClinicGroupUsersQuery({
 *   variables: {
 *      id: // value for 'id'
 *   },
 * });
 */
export function useGetClinicGroupUsersQuery(baseOptions: Apollo.QueryHookOptions<GetClinicGroupUsersQuery, GetClinicGroupUsersQueryVariables> & ({ variables: GetClinicGroupUsersQueryVariables; skip?: boolean; } | { skip: boolean; }) ) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<GetClinicGroupUsersQuery, GetClinicGroupUsersQueryVariables>(GetClinicGroupUsersDocument, options);
      }
export function useGetClinicGroupUsersLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<GetClinicGroupUsersQuery, GetClinicGroupUsersQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<GetClinicGroupUsersQuery, GetClinicGroupUsersQueryVariables>(GetClinicGroupUsersDocument, options);
        }
export function useGetClinicGroupUsersSuspenseQuery(baseOptions?: Apollo.SuspenseQueryHookOptions<GetClinicGroupUsersQuery, GetClinicGroupUsersQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useSuspenseQuery<GetClinicGroupUsersQuery, GetClinicGroupUsersQueryVariables>(GetClinicGroupUsersDocument, options);
        }
export type GetClinicGroupUsersQueryHookResult = ReturnType<typeof useGetClinicGroupUsersQuery>;
export type GetClinicGroupUsersLazyQueryHookResult = ReturnType<typeof useGetClinicGroupUsersLazyQuery>;
export type GetClinicGroupUsersSuspenseQueryHookResult = ReturnType<typeof useGetClinicGroupUsersSuspenseQuery>;
export type GetClinicGroupUsersQueryResult = Apollo.QueryResult<GetClinicGroupUsersQuery, GetClinicGroupUsersQueryVariables>;
export const GetClinicGroupUserDocument = gql`
    query getClinicGroupUser($id: ID!) {
  clinicGroupUser(id: $id) {
    ...ClinicGroupUserFields
  }
}
    ${ClinicGroupUserFieldsFragmentDoc}`;

/**
 * __useGetClinicGroupUserQuery__
 *
 * To run a query within a React component, call `useGetClinicGroupUserQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetClinicGroupUserQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetClinicGroupUserQuery({
 *   variables: {
 *      id: // value for 'id'
 *   },
 * });
 */
export function useGetClinicGroupUserQuery(baseOptions: Apollo.QueryHookOptions<GetClinicGroupUserQuery, GetClinicGroupUserQueryVariables> & ({ variables: GetClinicGroupUserQueryVariables; skip?: boolean; } | { skip: boolean; }) ) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<GetClinicGroupUserQuery, GetClinicGroupUserQueryVariables>(GetClinicGroupUserDocument, options);
      }
export function useGetClinicGroupUserLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<GetClinicGroupUserQuery, GetClinicGroupUserQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<GetClinicGroupUserQuery, GetClinicGroupUserQueryVariables>(GetClinicGroupUserDocument, options);
        }
export function useGetClinicGroupUserSuspenseQuery(baseOptions?: Apollo.SuspenseQueryHookOptions<GetClinicGroupUserQuery, GetClinicGroupUserQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useSuspenseQuery<GetClinicGroupUserQuery, GetClinicGroupUserQueryVariables>(GetClinicGroupUserDocument, options);
        }
export type GetClinicGroupUserQueryHookResult = ReturnType<typeof useGetClinicGroupUserQuery>;
export type GetClinicGroupUserLazyQueryHookResult = ReturnType<typeof useGetClinicGroupUserLazyQuery>;
export type GetClinicGroupUserSuspenseQueryHookResult = ReturnType<typeof useGetClinicGroupUserSuspenseQuery>;
export type GetClinicGroupUserQueryResult = Apollo.QueryResult<GetClinicGroupUserQuery, GetClinicGroupUserQueryVariables>;
export const GetClinicGroupUserByGroupAndUserDocument = gql`
    query getClinicGroupUserByGroupAndUser($clinicGroupId: ID!, $userId: ID!) {
  clinicGroupUserByGroupAndUser(clinicGroupId: $clinicGroupId, userId: $userId) {
    ...ClinicGroupUserFields
  }
}
    ${ClinicGroupUserFieldsFragmentDoc}`;

/**
 * __useGetClinicGroupUserByGroupAndUserQuery__
 *
 * To run a query within a React component, call `useGetClinicGroupUserByGroupAndUserQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetClinicGroupUserByGroupAndUserQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetClinicGroupUserByGroupAndUserQuery({
 *   variables: {
 *      clinicGroupId: // value for 'clinicGroupId'
 *      userId: // value for 'userId'
 *   },
 * });
 */
export function useGetClinicGroupUserByGroupAndUserQuery(baseOptions: Apollo.QueryHookOptions<GetClinicGroupUserByGroupAndUserQuery, GetClinicGroupUserByGroupAndUserQueryVariables> & ({ variables: GetClinicGroupUserByGroupAndUserQueryVariables; skip?: boolean; } | { skip: boolean; }) ) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<GetClinicGroupUserByGroupAndUserQuery, GetClinicGroupUserByGroupAndUserQueryVariables>(GetClinicGroupUserByGroupAndUserDocument, options);
      }
export function useGetClinicGroupUserByGroupAndUserLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<GetClinicGroupUserByGroupAndUserQuery, GetClinicGroupUserByGroupAndUserQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<GetClinicGroupUserByGroupAndUserQuery, GetClinicGroupUserByGroupAndUserQueryVariables>(GetClinicGroupUserByGroupAndUserDocument, options);
        }
export function useGetClinicGroupUserByGroupAndUserSuspenseQuery(baseOptions?: Apollo.SuspenseQueryHookOptions<GetClinicGroupUserByGroupAndUserQuery, GetClinicGroupUserByGroupAndUserQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useSuspenseQuery<GetClinicGroupUserByGroupAndUserQuery, GetClinicGroupUserByGroupAndUserQueryVariables>(GetClinicGroupUserByGroupAndUserDocument, options);
        }
export type GetClinicGroupUserByGroupAndUserQueryHookResult = ReturnType<typeof useGetClinicGroupUserByGroupAndUserQuery>;
export type GetClinicGroupUserByGroupAndUserLazyQueryHookResult = ReturnType<typeof useGetClinicGroupUserByGroupAndUserLazyQuery>;
export type GetClinicGroupUserByGroupAndUserSuspenseQueryHookResult = ReturnType<typeof useGetClinicGroupUserByGroupAndUserSuspenseQuery>;
export type GetClinicGroupUserByGroupAndUserQueryResult = Apollo.QueryResult<GetClinicGroupUserByGroupAndUserQuery, GetClinicGroupUserByGroupAndUserQueryVariables>;
export const QueryClinicGroupUsersDocument = gql`
    query queryClinicGroupUsers($clinicGroupId: ID!, $where: [QueryInput!], $page: NonNegativeInt, $pageSize: NonNegativeInt, $orderBy: OrderByInput) {
  queryClinicGroupUsers(
    clinicGroupId: $clinicGroupId
    where: $where
    page: $page
    pageSize: $pageSize
    orderBy: $orderBy
  ) {
    ...ClinicGroupUserFields
  }
}
    ${ClinicGroupUserFieldsFragmentDoc}`;

/**
 * __useQueryClinicGroupUsersQuery__
 *
 * To run a query within a React component, call `useQueryClinicGroupUsersQuery` and pass it any options that fit your needs.
 * When your component renders, `useQueryClinicGroupUsersQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useQueryClinicGroupUsersQuery({
 *   variables: {
 *      clinicGroupId: // value for 'clinicGroupId'
 *      where: // value for 'where'
 *      page: // value for 'page'
 *      pageSize: // value for 'pageSize'
 *      orderBy: // value for 'orderBy'
 *   },
 * });
 */
export function useQueryClinicGroupUsersQuery(baseOptions: Apollo.QueryHookOptions<QueryClinicGroupUsersQuery, QueryClinicGroupUsersQueryVariables> & ({ variables: QueryClinicGroupUsersQueryVariables; skip?: boolean; } | { skip: boolean; }) ) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<QueryClinicGroupUsersQuery, QueryClinicGroupUsersQueryVariables>(QueryClinicGroupUsersDocument, options);
      }
export function useQueryClinicGroupUsersLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<QueryClinicGroupUsersQuery, QueryClinicGroupUsersQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<QueryClinicGroupUsersQuery, QueryClinicGroupUsersQueryVariables>(QueryClinicGroupUsersDocument, options);
        }
export function useQueryClinicGroupUsersSuspenseQuery(baseOptions?: Apollo.SuspenseQueryHookOptions<QueryClinicGroupUsersQuery, QueryClinicGroupUsersQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useSuspenseQuery<QueryClinicGroupUsersQuery, QueryClinicGroupUsersQueryVariables>(QueryClinicGroupUsersDocument, options);
        }
export type QueryClinicGroupUsersQueryHookResult = ReturnType<typeof useQueryClinicGroupUsersQuery>;
export type QueryClinicGroupUsersLazyQueryHookResult = ReturnType<typeof useQueryClinicGroupUsersLazyQuery>;
export type QueryClinicGroupUsersSuspenseQueryHookResult = ReturnType<typeof useQueryClinicGroupUsersSuspenseQuery>;
export type QueryClinicGroupUsersQueryResult = Apollo.QueryResult<QueryClinicGroupUsersQuery, QueryClinicGroupUsersQueryVariables>;
export const CountClinicGroupUsersDocument = gql`
    query countClinicGroupUsers($clinicGroupId: ID!, $where: [QueryInput!]) {
  countClinicGroupUsers(clinicGroupId: $clinicGroupId, where: $where)
}
    `;

/**
 * __useCountClinicGroupUsersQuery__
 *
 * To run a query within a React component, call `useCountClinicGroupUsersQuery` and pass it any options that fit your needs.
 * When your component renders, `useCountClinicGroupUsersQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useCountClinicGroupUsersQuery({
 *   variables: {
 *      clinicGroupId: // value for 'clinicGroupId'
 *      where: // value for 'where'
 *   },
 * });
 */
export function useCountClinicGroupUsersQuery(baseOptions: Apollo.QueryHookOptions<CountClinicGroupUsersQuery, CountClinicGroupUsersQueryVariables> & ({ variables: CountClinicGroupUsersQueryVariables; skip?: boolean; } | { skip: boolean; }) ) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<CountClinicGroupUsersQuery, CountClinicGroupUsersQueryVariables>(CountClinicGroupUsersDocument, options);
      }
export function useCountClinicGroupUsersLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<CountClinicGroupUsersQuery, CountClinicGroupUsersQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<CountClinicGroupUsersQuery, CountClinicGroupUsersQueryVariables>(CountClinicGroupUsersDocument, options);
        }
export function useCountClinicGroupUsersSuspenseQuery(baseOptions?: Apollo.SuspenseQueryHookOptions<CountClinicGroupUsersQuery, CountClinicGroupUsersQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useSuspenseQuery<CountClinicGroupUsersQuery, CountClinicGroupUsersQueryVariables>(CountClinicGroupUsersDocument, options);
        }
export type CountClinicGroupUsersQueryHookResult = ReturnType<typeof useCountClinicGroupUsersQuery>;
export type CountClinicGroupUsersLazyQueryHookResult = ReturnType<typeof useCountClinicGroupUsersLazyQuery>;
export type CountClinicGroupUsersSuspenseQueryHookResult = ReturnType<typeof useCountClinicGroupUsersSuspenseQuery>;
export type CountClinicGroupUsersQueryResult = Apollo.QueryResult<CountClinicGroupUsersQuery, CountClinicGroupUsersQueryVariables>;
export const QueryClinicGroupClinicsDocument = gql`
    query queryClinicGroupClinics($where: [QueryInput!], $page: NonNegativeInt, $pageSize: NonNegativeInt, $orderBy: OrderByInput) {
  queryClinicGroupClinics(
    where: $where
    page: $page
    pageSize: $pageSize
    orderBy: $orderBy
  ) {
    ...ClinicGroupClinicFields
    clinic_group {
      ...ClinicGroupPreviewFields
    }
  }
}
    ${ClinicGroupClinicFieldsFragmentDoc}
${ClinicGroupPreviewFieldsFragmentDoc}`;

/**
 * __useQueryClinicGroupClinicsQuery__
 *
 * To run a query within a React component, call `useQueryClinicGroupClinicsQuery` and pass it any options that fit your needs.
 * When your component renders, `useQueryClinicGroupClinicsQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useQueryClinicGroupClinicsQuery({
 *   variables: {
 *      where: // value for 'where'
 *      page: // value for 'page'
 *      pageSize: // value for 'pageSize'
 *      orderBy: // value for 'orderBy'
 *   },
 * });
 */
export function useQueryClinicGroupClinicsQuery(baseOptions?: Apollo.QueryHookOptions<QueryClinicGroupClinicsQuery, QueryClinicGroupClinicsQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<QueryClinicGroupClinicsQuery, QueryClinicGroupClinicsQueryVariables>(QueryClinicGroupClinicsDocument, options);
      }
export function useQueryClinicGroupClinicsLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<QueryClinicGroupClinicsQuery, QueryClinicGroupClinicsQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<QueryClinicGroupClinicsQuery, QueryClinicGroupClinicsQueryVariables>(QueryClinicGroupClinicsDocument, options);
        }
export function useQueryClinicGroupClinicsSuspenseQuery(baseOptions?: Apollo.SuspenseQueryHookOptions<QueryClinicGroupClinicsQuery, QueryClinicGroupClinicsQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useSuspenseQuery<QueryClinicGroupClinicsQuery, QueryClinicGroupClinicsQueryVariables>(QueryClinicGroupClinicsDocument, options);
        }
export type QueryClinicGroupClinicsQueryHookResult = ReturnType<typeof useQueryClinicGroupClinicsQuery>;
export type QueryClinicGroupClinicsLazyQueryHookResult = ReturnType<typeof useQueryClinicGroupClinicsLazyQuery>;
export type QueryClinicGroupClinicsSuspenseQueryHookResult = ReturnType<typeof useQueryClinicGroupClinicsSuspenseQuery>;
export type QueryClinicGroupClinicsQueryResult = Apollo.QueryResult<QueryClinicGroupClinicsQuery, QueryClinicGroupClinicsQueryVariables>;
export const CountClinicGroupClinicsDocument = gql`
    query countClinicGroupClinics($where: [QueryInput!]) {
  countClinicGroupClinics(where: $where)
}
    `;

/**
 * __useCountClinicGroupClinicsQuery__
 *
 * To run a query within a React component, call `useCountClinicGroupClinicsQuery` and pass it any options that fit your needs.
 * When your component renders, `useCountClinicGroupClinicsQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useCountClinicGroupClinicsQuery({
 *   variables: {
 *      where: // value for 'where'
 *   },
 * });
 */
export function useCountClinicGroupClinicsQuery(baseOptions?: Apollo.QueryHookOptions<CountClinicGroupClinicsQuery, CountClinicGroupClinicsQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<CountClinicGroupClinicsQuery, CountClinicGroupClinicsQueryVariables>(CountClinicGroupClinicsDocument, options);
      }
export function useCountClinicGroupClinicsLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<CountClinicGroupClinicsQuery, CountClinicGroupClinicsQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<CountClinicGroupClinicsQuery, CountClinicGroupClinicsQueryVariables>(CountClinicGroupClinicsDocument, options);
        }
export function useCountClinicGroupClinicsSuspenseQuery(baseOptions?: Apollo.SuspenseQueryHookOptions<CountClinicGroupClinicsQuery, CountClinicGroupClinicsQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useSuspenseQuery<CountClinicGroupClinicsQuery, CountClinicGroupClinicsQueryVariables>(CountClinicGroupClinicsDocument, options);
        }
export type CountClinicGroupClinicsQueryHookResult = ReturnType<typeof useCountClinicGroupClinicsQuery>;
export type CountClinicGroupClinicsLazyQueryHookResult = ReturnType<typeof useCountClinicGroupClinicsLazyQuery>;
export type CountClinicGroupClinicsSuspenseQueryHookResult = ReturnType<typeof useCountClinicGroupClinicsSuspenseQuery>;
export type CountClinicGroupClinicsQueryResult = Apollo.QueryResult<CountClinicGroupClinicsQuery, CountClinicGroupClinicsQueryVariables>;
export const GetClinicGroupsForUserDocument = gql`
    query getClinicGroupsForUser($userId: ID!, $page: NonNegativeInt, $pageSize: NonNegativeInt) {
  getClinicGroupsForUser(userId: $userId, page: $page, pageSize: $pageSize) {
    ...ClinicGroupFields
  }
}
    ${ClinicGroupFieldsFragmentDoc}`;

/**
 * __useGetClinicGroupsForUserQuery__
 *
 * To run a query within a React component, call `useGetClinicGroupsForUserQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetClinicGroupsForUserQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetClinicGroupsForUserQuery({
 *   variables: {
 *      userId: // value for 'userId'
 *      page: // value for 'page'
 *      pageSize: // value for 'pageSize'
 *   },
 * });
 */
export function useGetClinicGroupsForUserQuery(baseOptions: Apollo.QueryHookOptions<GetClinicGroupsForUserQuery, GetClinicGroupsForUserQueryVariables> & ({ variables: GetClinicGroupsForUserQueryVariables; skip?: boolean; } | { skip: boolean; }) ) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<GetClinicGroupsForUserQuery, GetClinicGroupsForUserQueryVariables>(GetClinicGroupsForUserDocument, options);
      }
export function useGetClinicGroupsForUserLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<GetClinicGroupsForUserQuery, GetClinicGroupsForUserQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<GetClinicGroupsForUserQuery, GetClinicGroupsForUserQueryVariables>(GetClinicGroupsForUserDocument, options);
        }
export function useGetClinicGroupsForUserSuspenseQuery(baseOptions?: Apollo.SuspenseQueryHookOptions<GetClinicGroupsForUserQuery, GetClinicGroupsForUserQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useSuspenseQuery<GetClinicGroupsForUserQuery, GetClinicGroupsForUserQueryVariables>(GetClinicGroupsForUserDocument, options);
        }
export type GetClinicGroupsForUserQueryHookResult = ReturnType<typeof useGetClinicGroupsForUserQuery>;
export type GetClinicGroupsForUserLazyQueryHookResult = ReturnType<typeof useGetClinicGroupsForUserLazyQuery>;
export type GetClinicGroupsForUserSuspenseQueryHookResult = ReturnType<typeof useGetClinicGroupsForUserSuspenseQuery>;
export type GetClinicGroupsForUserQueryResult = Apollo.QueryResult<GetClinicGroupsForUserQuery, GetClinicGroupsForUserQueryVariables>;
export const QueryClinicGroupsForUserDocument = gql`
    query queryClinicGroupsForUser($userId: ID!, $where: [QueryInput!], $page: NonNegativeInt, $pageSize: NonNegativeInt, $orderBy: OrderByInput) {
  queryClinicGroupsForUser(
    userId: $userId
    where: $where
    page: $page
    pageSize: $pageSize
    orderBy: $orderBy
  ) {
    ...ClinicGroupFields
  }
}
    ${ClinicGroupFieldsFragmentDoc}`;

/**
 * __useQueryClinicGroupsForUserQuery__
 *
 * To run a query within a React component, call `useQueryClinicGroupsForUserQuery` and pass it any options that fit your needs.
 * When your component renders, `useQueryClinicGroupsForUserQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useQueryClinicGroupsForUserQuery({
 *   variables: {
 *      userId: // value for 'userId'
 *      where: // value for 'where'
 *      page: // value for 'page'
 *      pageSize: // value for 'pageSize'
 *      orderBy: // value for 'orderBy'
 *   },
 * });
 */
export function useQueryClinicGroupsForUserQuery(baseOptions: Apollo.QueryHookOptions<QueryClinicGroupsForUserQuery, QueryClinicGroupsForUserQueryVariables> & ({ variables: QueryClinicGroupsForUserQueryVariables; skip?: boolean; } | { skip: boolean; }) ) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<QueryClinicGroupsForUserQuery, QueryClinicGroupsForUserQueryVariables>(QueryClinicGroupsForUserDocument, options);
      }
export function useQueryClinicGroupsForUserLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<QueryClinicGroupsForUserQuery, QueryClinicGroupsForUserQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<QueryClinicGroupsForUserQuery, QueryClinicGroupsForUserQueryVariables>(QueryClinicGroupsForUserDocument, options);
        }
export function useQueryClinicGroupsForUserSuspenseQuery(baseOptions?: Apollo.SuspenseQueryHookOptions<QueryClinicGroupsForUserQuery, QueryClinicGroupsForUserQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useSuspenseQuery<QueryClinicGroupsForUserQuery, QueryClinicGroupsForUserQueryVariables>(QueryClinicGroupsForUserDocument, options);
        }
export type QueryClinicGroupsForUserQueryHookResult = ReturnType<typeof useQueryClinicGroupsForUserQuery>;
export type QueryClinicGroupsForUserLazyQueryHookResult = ReturnType<typeof useQueryClinicGroupsForUserLazyQuery>;
export type QueryClinicGroupsForUserSuspenseQueryHookResult = ReturnType<typeof useQueryClinicGroupsForUserSuspenseQuery>;
export type QueryClinicGroupsForUserQueryResult = Apollo.QueryResult<QueryClinicGroupsForUserQuery, QueryClinicGroupsForUserQueryVariables>;
export const CountClinicGroupsForUserDocument = gql`
    query countClinicGroupsForUser($userId: ID!, $where: [QueryInput!]) {
  countClinicGroupsForUser(userId: $userId, where: $where)
}
    `;

/**
 * __useCountClinicGroupsForUserQuery__
 *
 * To run a query within a React component, call `useCountClinicGroupsForUserQuery` and pass it any options that fit your needs.
 * When your component renders, `useCountClinicGroupsForUserQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useCountClinicGroupsForUserQuery({
 *   variables: {
 *      userId: // value for 'userId'
 *      where: // value for 'where'
 *   },
 * });
 */
export function useCountClinicGroupsForUserQuery(baseOptions: Apollo.QueryHookOptions<CountClinicGroupsForUserQuery, CountClinicGroupsForUserQueryVariables> & ({ variables: CountClinicGroupsForUserQueryVariables; skip?: boolean; } | { skip: boolean; }) ) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<CountClinicGroupsForUserQuery, CountClinicGroupsForUserQueryVariables>(CountClinicGroupsForUserDocument, options);
      }
export function useCountClinicGroupsForUserLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<CountClinicGroupsForUserQuery, CountClinicGroupsForUserQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<CountClinicGroupsForUserQuery, CountClinicGroupsForUserQueryVariables>(CountClinicGroupsForUserDocument, options);
        }
export function useCountClinicGroupsForUserSuspenseQuery(baseOptions?: Apollo.SuspenseQueryHookOptions<CountClinicGroupsForUserQuery, CountClinicGroupsForUserQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useSuspenseQuery<CountClinicGroupsForUserQuery, CountClinicGroupsForUserQueryVariables>(CountClinicGroupsForUserDocument, options);
        }
export type CountClinicGroupsForUserQueryHookResult = ReturnType<typeof useCountClinicGroupsForUserQuery>;
export type CountClinicGroupsForUserLazyQueryHookResult = ReturnType<typeof useCountClinicGroupsForUserLazyQuery>;
export type CountClinicGroupsForUserSuspenseQueryHookResult = ReturnType<typeof useCountClinicGroupsForUserSuspenseQuery>;
export type CountClinicGroupsForUserQueryResult = Apollo.QueryResult<CountClinicGroupsForUserQuery, CountClinicGroupsForUserQueryVariables>;
export const CountClinicGroupsDocument = gql`
    query countClinicGroups($where: [QueryInput!]) {
  countClinicGroups(where: $where)
}
    `;

/**
 * __useCountClinicGroupsQuery__
 *
 * To run a query within a React component, call `useCountClinicGroupsQuery` and pass it any options that fit your needs.
 * When your component renders, `useCountClinicGroupsQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useCountClinicGroupsQuery({
 *   variables: {
 *      where: // value for 'where'
 *   },
 * });
 */
export function useCountClinicGroupsQuery(baseOptions?: Apollo.QueryHookOptions<CountClinicGroupsQuery, CountClinicGroupsQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<CountClinicGroupsQuery, CountClinicGroupsQueryVariables>(CountClinicGroupsDocument, options);
      }
export function useCountClinicGroupsLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<CountClinicGroupsQuery, CountClinicGroupsQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<CountClinicGroupsQuery, CountClinicGroupsQueryVariables>(CountClinicGroupsDocument, options);
        }
export function useCountClinicGroupsSuspenseQuery(baseOptions?: Apollo.SuspenseQueryHookOptions<CountClinicGroupsQuery, CountClinicGroupsQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useSuspenseQuery<CountClinicGroupsQuery, CountClinicGroupsQueryVariables>(CountClinicGroupsDocument, options);
        }
export type CountClinicGroupsQueryHookResult = ReturnType<typeof useCountClinicGroupsQuery>;
export type CountClinicGroupsLazyQueryHookResult = ReturnType<typeof useCountClinicGroupsLazyQuery>;
export type CountClinicGroupsSuspenseQueryHookResult = ReturnType<typeof useCountClinicGroupsSuspenseQuery>;
export type CountClinicGroupsQueryResult = Apollo.QueryResult<CountClinicGroupsQuery, CountClinicGroupsQueryVariables>;
export const QueryClinicGroupsDocument = gql`
    query queryClinicGroups($where: [QueryInput!], $page: NonNegativeInt, $pageSize: NonNegativeInt, $orderBy: OrderByInput) {
  queryClinicGroups(
    where: $where
    page: $page
    pageSize: $pageSize
    orderBy: $orderBy
  ) {
    ...ClinicGroupFields
  }
}
    ${ClinicGroupFieldsFragmentDoc}`;

/**
 * __useQueryClinicGroupsQuery__
 *
 * To run a query within a React component, call `useQueryClinicGroupsQuery` and pass it any options that fit your needs.
 * When your component renders, `useQueryClinicGroupsQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useQueryClinicGroupsQuery({
 *   variables: {
 *      where: // value for 'where'
 *      page: // value for 'page'
 *      pageSize: // value for 'pageSize'
 *      orderBy: // value for 'orderBy'
 *   },
 * });
 */
export function useQueryClinicGroupsQuery(baseOptions?: Apollo.QueryHookOptions<QueryClinicGroupsQuery, QueryClinicGroupsQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<QueryClinicGroupsQuery, QueryClinicGroupsQueryVariables>(QueryClinicGroupsDocument, options);
      }
export function useQueryClinicGroupsLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<QueryClinicGroupsQuery, QueryClinicGroupsQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<QueryClinicGroupsQuery, QueryClinicGroupsQueryVariables>(QueryClinicGroupsDocument, options);
        }
export function useQueryClinicGroupsSuspenseQuery(baseOptions?: Apollo.SuspenseQueryHookOptions<QueryClinicGroupsQuery, QueryClinicGroupsQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useSuspenseQuery<QueryClinicGroupsQuery, QueryClinicGroupsQueryVariables>(QueryClinicGroupsDocument, options);
        }
export type QueryClinicGroupsQueryHookResult = ReturnType<typeof useQueryClinicGroupsQuery>;
export type QueryClinicGroupsLazyQueryHookResult = ReturnType<typeof useQueryClinicGroupsLazyQuery>;
export type QueryClinicGroupsSuspenseQueryHookResult = ReturnType<typeof useQueryClinicGroupsSuspenseQuery>;
export type QueryClinicGroupsQueryResult = Apollo.QueryResult<QueryClinicGroupsQuery, QueryClinicGroupsQueryVariables>;
export const CreateClinicGroupDocument = gql`
    mutation createClinicGroup($data: CreateClinicGroupInput!) {
  createClinicGroup(data: $data) {
    ...ClinicGroupFields
  }
}
    ${ClinicGroupFieldsFragmentDoc}`;
export type CreateClinicGroupMutationFn = Apollo.MutationFunction<CreateClinicGroupMutation, CreateClinicGroupMutationVariables>;

/**
 * __useCreateClinicGroupMutation__
 *
 * To run a mutation, you first call `useCreateClinicGroupMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useCreateClinicGroupMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [createClinicGroupMutation, { data, loading, error }] = useCreateClinicGroupMutation({
 *   variables: {
 *      data: // value for 'data'
 *   },
 * });
 */
export function useCreateClinicGroupMutation(baseOptions?: Apollo.MutationHookOptions<CreateClinicGroupMutation, CreateClinicGroupMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<CreateClinicGroupMutation, CreateClinicGroupMutationVariables>(CreateClinicGroupDocument, options);
      }
export type CreateClinicGroupMutationHookResult = ReturnType<typeof useCreateClinicGroupMutation>;
export type CreateClinicGroupMutationResult = Apollo.MutationResult<CreateClinicGroupMutation>;
export type CreateClinicGroupMutationOptions = Apollo.BaseMutationOptions<CreateClinicGroupMutation, CreateClinicGroupMutationVariables>;
export const UpdateClinicGroupDocument = gql`
    mutation updateClinicGroup($id: ID!, $data: UpdateClinicGroupInput!) {
  updateClinicGroup(id: $id, data: $data) {
    ...ClinicGroupFields
  }
}
    ${ClinicGroupFieldsFragmentDoc}`;
export type UpdateClinicGroupMutationFn = Apollo.MutationFunction<UpdateClinicGroupMutation, UpdateClinicGroupMutationVariables>;

/**
 * __useUpdateClinicGroupMutation__
 *
 * To run a mutation, you first call `useUpdateClinicGroupMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useUpdateClinicGroupMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [updateClinicGroupMutation, { data, loading, error }] = useUpdateClinicGroupMutation({
 *   variables: {
 *      id: // value for 'id'
 *      data: // value for 'data'
 *   },
 * });
 */
export function useUpdateClinicGroupMutation(baseOptions?: Apollo.MutationHookOptions<UpdateClinicGroupMutation, UpdateClinicGroupMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<UpdateClinicGroupMutation, UpdateClinicGroupMutationVariables>(UpdateClinicGroupDocument, options);
      }
export type UpdateClinicGroupMutationHookResult = ReturnType<typeof useUpdateClinicGroupMutation>;
export type UpdateClinicGroupMutationResult = Apollo.MutationResult<UpdateClinicGroupMutation>;
export type UpdateClinicGroupMutationOptions = Apollo.BaseMutationOptions<UpdateClinicGroupMutation, UpdateClinicGroupMutationVariables>;
export const UpdateClinicGroupSettingsDocument = gql`
    mutation updateClinicGroupSettings($clinicGroupId: ID!, $settings: ClinicSettingsInput!) {
  updateClinicGroupSettings(clinicGroupId: $clinicGroupId, settings: $settings) {
    ...ClinicSettingsFields
  }
}
    ${ClinicSettingsFieldsFragmentDoc}`;
export type UpdateClinicGroupSettingsMutationFn = Apollo.MutationFunction<UpdateClinicGroupSettingsMutation, UpdateClinicGroupSettingsMutationVariables>;

/**
 * __useUpdateClinicGroupSettingsMutation__
 *
 * To run a mutation, you first call `useUpdateClinicGroupSettingsMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useUpdateClinicGroupSettingsMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [updateClinicGroupSettingsMutation, { data, loading, error }] = useUpdateClinicGroupSettingsMutation({
 *   variables: {
 *      clinicGroupId: // value for 'clinicGroupId'
 *      settings: // value for 'settings'
 *   },
 * });
 */
export function useUpdateClinicGroupSettingsMutation(baseOptions?: Apollo.MutationHookOptions<UpdateClinicGroupSettingsMutation, UpdateClinicGroupSettingsMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<UpdateClinicGroupSettingsMutation, UpdateClinicGroupSettingsMutationVariables>(UpdateClinicGroupSettingsDocument, options);
      }
export type UpdateClinicGroupSettingsMutationHookResult = ReturnType<typeof useUpdateClinicGroupSettingsMutation>;
export type UpdateClinicGroupSettingsMutationResult = Apollo.MutationResult<UpdateClinicGroupSettingsMutation>;
export type UpdateClinicGroupSettingsMutationOptions = Apollo.BaseMutationOptions<UpdateClinicGroupSettingsMutation, UpdateClinicGroupSettingsMutationVariables>;
export const CreateClinicGroupClinicDocument = gql`
    mutation createClinicGroupClinic($data: CreateClinicGroupClinicInput!) {
  createClinicGroupClinic(data: $data) {
    id
  }
}
    `;
export type CreateClinicGroupClinicMutationFn = Apollo.MutationFunction<CreateClinicGroupClinicMutation, CreateClinicGroupClinicMutationVariables>;

/**
 * __useCreateClinicGroupClinicMutation__
 *
 * To run a mutation, you first call `useCreateClinicGroupClinicMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useCreateClinicGroupClinicMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [createClinicGroupClinicMutation, { data, loading, error }] = useCreateClinicGroupClinicMutation({
 *   variables: {
 *      data: // value for 'data'
 *   },
 * });
 */
export function useCreateClinicGroupClinicMutation(baseOptions?: Apollo.MutationHookOptions<CreateClinicGroupClinicMutation, CreateClinicGroupClinicMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<CreateClinicGroupClinicMutation, CreateClinicGroupClinicMutationVariables>(CreateClinicGroupClinicDocument, options);
      }
export type CreateClinicGroupClinicMutationHookResult = ReturnType<typeof useCreateClinicGroupClinicMutation>;
export type CreateClinicGroupClinicMutationResult = Apollo.MutationResult<CreateClinicGroupClinicMutation>;
export type CreateClinicGroupClinicMutationOptions = Apollo.BaseMutationOptions<CreateClinicGroupClinicMutation, CreateClinicGroupClinicMutationVariables>;
export const DeleteClinicGroupClinicDocument = gql`
    mutation deleteClinicGroupClinic($clinicGroupClinicId: ID!) {
  deleteClinicGroupClinic(clinicGroupClinicId: $clinicGroupClinicId)
}
    `;
export type DeleteClinicGroupClinicMutationFn = Apollo.MutationFunction<DeleteClinicGroupClinicMutation, DeleteClinicGroupClinicMutationVariables>;

/**
 * __useDeleteClinicGroupClinicMutation__
 *
 * To run a mutation, you first call `useDeleteClinicGroupClinicMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useDeleteClinicGroupClinicMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [deleteClinicGroupClinicMutation, { data, loading, error }] = useDeleteClinicGroupClinicMutation({
 *   variables: {
 *      clinicGroupClinicId: // value for 'clinicGroupClinicId'
 *   },
 * });
 */
export function useDeleteClinicGroupClinicMutation(baseOptions?: Apollo.MutationHookOptions<DeleteClinicGroupClinicMutation, DeleteClinicGroupClinicMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<DeleteClinicGroupClinicMutation, DeleteClinicGroupClinicMutationVariables>(DeleteClinicGroupClinicDocument, options);
      }
export type DeleteClinicGroupClinicMutationHookResult = ReturnType<typeof useDeleteClinicGroupClinicMutation>;
export type DeleteClinicGroupClinicMutationResult = Apollo.MutationResult<DeleteClinicGroupClinicMutation>;
export type DeleteClinicGroupClinicMutationOptions = Apollo.BaseMutationOptions<DeleteClinicGroupClinicMutation, DeleteClinicGroupClinicMutationVariables>;
export const CreateClinicGroupUserDocument = gql`
    mutation createClinicGroupUser($data: CreateClinicGroupUserInput!) {
  createClinicGroupUser(data: $data) {
    id
  }
}
    `;
export type CreateClinicGroupUserMutationFn = Apollo.MutationFunction<CreateClinicGroupUserMutation, CreateClinicGroupUserMutationVariables>;

/**
 * __useCreateClinicGroupUserMutation__
 *
 * To run a mutation, you first call `useCreateClinicGroupUserMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useCreateClinicGroupUserMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [createClinicGroupUserMutation, { data, loading, error }] = useCreateClinicGroupUserMutation({
 *   variables: {
 *      data: // value for 'data'
 *   },
 * });
 */
export function useCreateClinicGroupUserMutation(baseOptions?: Apollo.MutationHookOptions<CreateClinicGroupUserMutation, CreateClinicGroupUserMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<CreateClinicGroupUserMutation, CreateClinicGroupUserMutationVariables>(CreateClinicGroupUserDocument, options);
      }
export type CreateClinicGroupUserMutationHookResult = ReturnType<typeof useCreateClinicGroupUserMutation>;
export type CreateClinicGroupUserMutationResult = Apollo.MutationResult<CreateClinicGroupUserMutation>;
export type CreateClinicGroupUserMutationOptions = Apollo.BaseMutationOptions<CreateClinicGroupUserMutation, CreateClinicGroupUserMutationVariables>;
export const UpdateClinicGroupUserDocument = gql`
    mutation updateClinicGroupUser($clinicGroupUserId: ID!, $data: UpdateClinicGroupUserInput!) {
  updateClinicGroupUser(clinicGroupUserId: $clinicGroupUserId, data: $data) {
    id
  }
}
    `;
export type UpdateClinicGroupUserMutationFn = Apollo.MutationFunction<UpdateClinicGroupUserMutation, UpdateClinicGroupUserMutationVariables>;

/**
 * __useUpdateClinicGroupUserMutation__
 *
 * To run a mutation, you first call `useUpdateClinicGroupUserMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useUpdateClinicGroupUserMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [updateClinicGroupUserMutation, { data, loading, error }] = useUpdateClinicGroupUserMutation({
 *   variables: {
 *      clinicGroupUserId: // value for 'clinicGroupUserId'
 *      data: // value for 'data'
 *   },
 * });
 */
export function useUpdateClinicGroupUserMutation(baseOptions?: Apollo.MutationHookOptions<UpdateClinicGroupUserMutation, UpdateClinicGroupUserMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<UpdateClinicGroupUserMutation, UpdateClinicGroupUserMutationVariables>(UpdateClinicGroupUserDocument, options);
      }
export type UpdateClinicGroupUserMutationHookResult = ReturnType<typeof useUpdateClinicGroupUserMutation>;
export type UpdateClinicGroupUserMutationResult = Apollo.MutationResult<UpdateClinicGroupUserMutation>;
export type UpdateClinicGroupUserMutationOptions = Apollo.BaseMutationOptions<UpdateClinicGroupUserMutation, UpdateClinicGroupUserMutationVariables>;
export const DeleteClinicGroupUserDocument = gql`
    mutation deleteClinicGroupUser($clinicGroupUserId: ID!) {
  deleteClinicGroupUser(clinicGroupUserId: $clinicGroupUserId)
}
    `;
export type DeleteClinicGroupUserMutationFn = Apollo.MutationFunction<DeleteClinicGroupUserMutation, DeleteClinicGroupUserMutationVariables>;

/**
 * __useDeleteClinicGroupUserMutation__
 *
 * To run a mutation, you first call `useDeleteClinicGroupUserMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useDeleteClinicGroupUserMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [deleteClinicGroupUserMutation, { data, loading, error }] = useDeleteClinicGroupUserMutation({
 *   variables: {
 *      clinicGroupUserId: // value for 'clinicGroupUserId'
 *   },
 * });
 */
export function useDeleteClinicGroupUserMutation(baseOptions?: Apollo.MutationHookOptions<DeleteClinicGroupUserMutation, DeleteClinicGroupUserMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<DeleteClinicGroupUserMutation, DeleteClinicGroupUserMutationVariables>(DeleteClinicGroupUserDocument, options);
      }
export type DeleteClinicGroupUserMutationHookResult = ReturnType<typeof useDeleteClinicGroupUserMutation>;
export type DeleteClinicGroupUserMutationResult = Apollo.MutationResult<DeleteClinicGroupUserMutation>;
export type DeleteClinicGroupUserMutationOptions = Apollo.BaseMutationOptions<DeleteClinicGroupUserMutation, DeleteClinicGroupUserMutationVariables>;
export const QueryClinicSexesDocument = gql`
    query queryClinicSexes($where: [QueryInput!], $page: NonNegativeInt, $pageSize: NonNegativeInt, $orderBy: OrderByInput) {
  queryClinicSexes(
    where: $where
    page: $page
    pageSize: $pageSize
    orderBy: $orderBy
  ) {
    ...ClinicSexFields
  }
}
    ${ClinicSexFieldsFragmentDoc}`;

/**
 * __useQueryClinicSexesQuery__
 *
 * To run a query within a React component, call `useQueryClinicSexesQuery` and pass it any options that fit your needs.
 * When your component renders, `useQueryClinicSexesQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useQueryClinicSexesQuery({
 *   variables: {
 *      where: // value for 'where'
 *      page: // value for 'page'
 *      pageSize: // value for 'pageSize'
 *      orderBy: // value for 'orderBy'
 *   },
 * });
 */
export function useQueryClinicSexesQuery(baseOptions?: Apollo.QueryHookOptions<QueryClinicSexesQuery, QueryClinicSexesQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<QueryClinicSexesQuery, QueryClinicSexesQueryVariables>(QueryClinicSexesDocument, options);
      }
export function useQueryClinicSexesLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<QueryClinicSexesQuery, QueryClinicSexesQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<QueryClinicSexesQuery, QueryClinicSexesQueryVariables>(QueryClinicSexesDocument, options);
        }
export function useQueryClinicSexesSuspenseQuery(baseOptions?: Apollo.SuspenseQueryHookOptions<QueryClinicSexesQuery, QueryClinicSexesQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useSuspenseQuery<QueryClinicSexesQuery, QueryClinicSexesQueryVariables>(QueryClinicSexesDocument, options);
        }
export type QueryClinicSexesQueryHookResult = ReturnType<typeof useQueryClinicSexesQuery>;
export type QueryClinicSexesLazyQueryHookResult = ReturnType<typeof useQueryClinicSexesLazyQuery>;
export type QueryClinicSexesSuspenseQueryHookResult = ReturnType<typeof useQueryClinicSexesSuspenseQuery>;
export type QueryClinicSexesQueryResult = Apollo.QueryResult<QueryClinicSexesQuery, QueryClinicSexesQueryVariables>;
export const CountClinicSexesDocument = gql`
    query countClinicSexes($where: [QueryInput!]) {
  countClinicSexes(where: $where)
}
    `;

/**
 * __useCountClinicSexesQuery__
 *
 * To run a query within a React component, call `useCountClinicSexesQuery` and pass it any options that fit your needs.
 * When your component renders, `useCountClinicSexesQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useCountClinicSexesQuery({
 *   variables: {
 *      where: // value for 'where'
 *   },
 * });
 */
export function useCountClinicSexesQuery(baseOptions?: Apollo.QueryHookOptions<CountClinicSexesQuery, CountClinicSexesQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<CountClinicSexesQuery, CountClinicSexesQueryVariables>(CountClinicSexesDocument, options);
      }
export function useCountClinicSexesLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<CountClinicSexesQuery, CountClinicSexesQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<CountClinicSexesQuery, CountClinicSexesQueryVariables>(CountClinicSexesDocument, options);
        }
export function useCountClinicSexesSuspenseQuery(baseOptions?: Apollo.SuspenseQueryHookOptions<CountClinicSexesQuery, CountClinicSexesQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useSuspenseQuery<CountClinicSexesQuery, CountClinicSexesQueryVariables>(CountClinicSexesDocument, options);
        }
export type CountClinicSexesQueryHookResult = ReturnType<typeof useCountClinicSexesQuery>;
export type CountClinicSexesLazyQueryHookResult = ReturnType<typeof useCountClinicSexesLazyQuery>;
export type CountClinicSexesSuspenseQueryHookResult = ReturnType<typeof useCountClinicSexesSuspenseQuery>;
export type CountClinicSexesQueryResult = Apollo.QueryResult<CountClinicSexesQuery, CountClinicSexesQueryVariables>;
export const UpdateClinicSexDocument = gql`
    mutation updateClinicSex($id: ID!, $data: UpdateClinicSexInput!) {
  updateClinicSex(id: $id, data: $data) {
    ...ClinicSexFields
  }
}
    ${ClinicSexFieldsFragmentDoc}`;
export type UpdateClinicSexMutationFn = Apollo.MutationFunction<UpdateClinicSexMutation, UpdateClinicSexMutationVariables>;

/**
 * __useUpdateClinicSexMutation__
 *
 * To run a mutation, you first call `useUpdateClinicSexMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useUpdateClinicSexMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [updateClinicSexMutation, { data, loading, error }] = useUpdateClinicSexMutation({
 *   variables: {
 *      id: // value for 'id'
 *      data: // value for 'data'
 *   },
 * });
 */
export function useUpdateClinicSexMutation(baseOptions?: Apollo.MutationHookOptions<UpdateClinicSexMutation, UpdateClinicSexMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<UpdateClinicSexMutation, UpdateClinicSexMutationVariables>(UpdateClinicSexDocument, options);
      }
export type UpdateClinicSexMutationHookResult = ReturnType<typeof useUpdateClinicSexMutation>;
export type UpdateClinicSexMutationResult = Apollo.MutationResult<UpdateClinicSexMutation>;
export type UpdateClinicSexMutationOptions = Apollo.BaseMutationOptions<UpdateClinicSexMutation, UpdateClinicSexMutationVariables>;
export const GetClinicSpeciesByClinicDocument = gql`
    query getClinicSpeciesByClinic($clinicId: ID!) {
  getClinicSpeciesByClinic(clinicId: $clinicId) {
    ...ClinicSpeciesFields
  }
}
    ${ClinicSpeciesFieldsFragmentDoc}`;

/**
 * __useGetClinicSpeciesByClinicQuery__
 *
 * To run a query within a React component, call `useGetClinicSpeciesByClinicQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetClinicSpeciesByClinicQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetClinicSpeciesByClinicQuery({
 *   variables: {
 *      clinicId: // value for 'clinicId'
 *   },
 * });
 */
export function useGetClinicSpeciesByClinicQuery(baseOptions: Apollo.QueryHookOptions<GetClinicSpeciesByClinicQuery, GetClinicSpeciesByClinicQueryVariables> & ({ variables: GetClinicSpeciesByClinicQueryVariables; skip?: boolean; } | { skip: boolean; }) ) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<GetClinicSpeciesByClinicQuery, GetClinicSpeciesByClinicQueryVariables>(GetClinicSpeciesByClinicDocument, options);
      }
export function useGetClinicSpeciesByClinicLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<GetClinicSpeciesByClinicQuery, GetClinicSpeciesByClinicQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<GetClinicSpeciesByClinicQuery, GetClinicSpeciesByClinicQueryVariables>(GetClinicSpeciesByClinicDocument, options);
        }
export function useGetClinicSpeciesByClinicSuspenseQuery(baseOptions?: Apollo.SuspenseQueryHookOptions<GetClinicSpeciesByClinicQuery, GetClinicSpeciesByClinicQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useSuspenseQuery<GetClinicSpeciesByClinicQuery, GetClinicSpeciesByClinicQueryVariables>(GetClinicSpeciesByClinicDocument, options);
        }
export type GetClinicSpeciesByClinicQueryHookResult = ReturnType<typeof useGetClinicSpeciesByClinicQuery>;
export type GetClinicSpeciesByClinicLazyQueryHookResult = ReturnType<typeof useGetClinicSpeciesByClinicLazyQuery>;
export type GetClinicSpeciesByClinicSuspenseQueryHookResult = ReturnType<typeof useGetClinicSpeciesByClinicSuspenseQuery>;
export type GetClinicSpeciesByClinicQueryResult = Apollo.QueryResult<GetClinicSpeciesByClinicQuery, GetClinicSpeciesByClinicQueryVariables>;
export const QueryClinicSpeciesDocument = gql`
    query queryClinicSpecies($where: [QueryInput!], $page: NonNegativeInt, $pageSize: NonNegativeInt, $orderBy: OrderByInput) {
  queryClinicSpecies(
    where: $where
    page: $page
    pageSize: $pageSize
    orderBy: $orderBy
  ) {
    ...ClinicSpeciesFields
  }
}
    ${ClinicSpeciesFieldsFragmentDoc}`;

/**
 * __useQueryClinicSpeciesQuery__
 *
 * To run a query within a React component, call `useQueryClinicSpeciesQuery` and pass it any options that fit your needs.
 * When your component renders, `useQueryClinicSpeciesQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useQueryClinicSpeciesQuery({
 *   variables: {
 *      where: // value for 'where'
 *      page: // value for 'page'
 *      pageSize: // value for 'pageSize'
 *      orderBy: // value for 'orderBy'
 *   },
 * });
 */
export function useQueryClinicSpeciesQuery(baseOptions?: Apollo.QueryHookOptions<QueryClinicSpeciesQuery, QueryClinicSpeciesQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<QueryClinicSpeciesQuery, QueryClinicSpeciesQueryVariables>(QueryClinicSpeciesDocument, options);
      }
export function useQueryClinicSpeciesLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<QueryClinicSpeciesQuery, QueryClinicSpeciesQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<QueryClinicSpeciesQuery, QueryClinicSpeciesQueryVariables>(QueryClinicSpeciesDocument, options);
        }
export function useQueryClinicSpeciesSuspenseQuery(baseOptions?: Apollo.SuspenseQueryHookOptions<QueryClinicSpeciesQuery, QueryClinicSpeciesQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useSuspenseQuery<QueryClinicSpeciesQuery, QueryClinicSpeciesQueryVariables>(QueryClinicSpeciesDocument, options);
        }
export type QueryClinicSpeciesQueryHookResult = ReturnType<typeof useQueryClinicSpeciesQuery>;
export type QueryClinicSpeciesLazyQueryHookResult = ReturnType<typeof useQueryClinicSpeciesLazyQuery>;
export type QueryClinicSpeciesSuspenseQueryHookResult = ReturnType<typeof useQueryClinicSpeciesSuspenseQuery>;
export type QueryClinicSpeciesQueryResult = Apollo.QueryResult<QueryClinicSpeciesQuery, QueryClinicSpeciesQueryVariables>;
export const MakePrimaryClinicSpeciesDocument = gql`
    mutation makePrimaryClinicSpecies($clinicId: ID!, $speciesId: ID!) {
  makePrimaryClinicSpecies(clinicId: $clinicId, speciesId: $speciesId) {
    ...ClinicSpeciesFields
  }
}
    ${ClinicSpeciesFieldsFragmentDoc}`;
export type MakePrimaryClinicSpeciesMutationFn = Apollo.MutationFunction<MakePrimaryClinicSpeciesMutation, MakePrimaryClinicSpeciesMutationVariables>;

/**
 * __useMakePrimaryClinicSpeciesMutation__
 *
 * To run a mutation, you first call `useMakePrimaryClinicSpeciesMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useMakePrimaryClinicSpeciesMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [makePrimaryClinicSpeciesMutation, { data, loading, error }] = useMakePrimaryClinicSpeciesMutation({
 *   variables: {
 *      clinicId: // value for 'clinicId'
 *      speciesId: // value for 'speciesId'
 *   },
 * });
 */
export function useMakePrimaryClinicSpeciesMutation(baseOptions?: Apollo.MutationHookOptions<MakePrimaryClinicSpeciesMutation, MakePrimaryClinicSpeciesMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<MakePrimaryClinicSpeciesMutation, MakePrimaryClinicSpeciesMutationVariables>(MakePrimaryClinicSpeciesDocument, options);
      }
export type MakePrimaryClinicSpeciesMutationHookResult = ReturnType<typeof useMakePrimaryClinicSpeciesMutation>;
export type MakePrimaryClinicSpeciesMutationResult = Apollo.MutationResult<MakePrimaryClinicSpeciesMutation>;
export type MakePrimaryClinicSpeciesMutationOptions = Apollo.BaseMutationOptions<MakePrimaryClinicSpeciesMutation, MakePrimaryClinicSpeciesMutationVariables>;
export const UpdateClinicSpeciesDocument = gql`
    mutation updateClinicSpecies($clinicId: ID!, $speciesId: ID!, $data: UpdateClinicSpeciesInput!) {
  updateClinicSpecies(clinicId: $clinicId, speciesId: $speciesId, data: $data) {
    ...ClinicSpeciesFields
  }
}
    ${ClinicSpeciesFieldsFragmentDoc}`;
export type UpdateClinicSpeciesMutationFn = Apollo.MutationFunction<UpdateClinicSpeciesMutation, UpdateClinicSpeciesMutationVariables>;

/**
 * __useUpdateClinicSpeciesMutation__
 *
 * To run a mutation, you first call `useUpdateClinicSpeciesMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useUpdateClinicSpeciesMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [updateClinicSpeciesMutation, { data, loading, error }] = useUpdateClinicSpeciesMutation({
 *   variables: {
 *      clinicId: // value for 'clinicId'
 *      speciesId: // value for 'speciesId'
 *      data: // value for 'data'
 *   },
 * });
 */
export function useUpdateClinicSpeciesMutation(baseOptions?: Apollo.MutationHookOptions<UpdateClinicSpeciesMutation, UpdateClinicSpeciesMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<UpdateClinicSpeciesMutation, UpdateClinicSpeciesMutationVariables>(UpdateClinicSpeciesDocument, options);
      }
export type UpdateClinicSpeciesMutationHookResult = ReturnType<typeof useUpdateClinicSpeciesMutation>;
export type UpdateClinicSpeciesMutationResult = Apollo.MutationResult<UpdateClinicSpeciesMutation>;
export type UpdateClinicSpeciesMutationOptions = Apollo.BaseMutationOptions<UpdateClinicSpeciesMutation, UpdateClinicSpeciesMutationVariables>;
export const GetRevenueForTimeRangeDocument = gql`
    query getRevenueForTimeRange($clinicId: ID!, $start_time: NonNegativeInt!, $end_time: NonNegativeInt!) {
  getRevenueForTimeRange(
    clinicId: $clinicId
    start_time: $start_time
    end_time: $end_time
  )
}
    `;

/**
 * __useGetRevenueForTimeRangeQuery__
 *
 * To run a query within a React component, call `useGetRevenueForTimeRangeQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetRevenueForTimeRangeQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetRevenueForTimeRangeQuery({
 *   variables: {
 *      clinicId: // value for 'clinicId'
 *      start_time: // value for 'start_time'
 *      end_time: // value for 'end_time'
 *   },
 * });
 */
export function useGetRevenueForTimeRangeQuery(baseOptions: Apollo.QueryHookOptions<GetRevenueForTimeRangeQuery, GetRevenueForTimeRangeQueryVariables> & ({ variables: GetRevenueForTimeRangeQueryVariables; skip?: boolean; } | { skip: boolean; }) ) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<GetRevenueForTimeRangeQuery, GetRevenueForTimeRangeQueryVariables>(GetRevenueForTimeRangeDocument, options);
      }
export function useGetRevenueForTimeRangeLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<GetRevenueForTimeRangeQuery, GetRevenueForTimeRangeQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<GetRevenueForTimeRangeQuery, GetRevenueForTimeRangeQueryVariables>(GetRevenueForTimeRangeDocument, options);
        }
export function useGetRevenueForTimeRangeSuspenseQuery(baseOptions?: Apollo.SuspenseQueryHookOptions<GetRevenueForTimeRangeQuery, GetRevenueForTimeRangeQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useSuspenseQuery<GetRevenueForTimeRangeQuery, GetRevenueForTimeRangeQueryVariables>(GetRevenueForTimeRangeDocument, options);
        }
export type GetRevenueForTimeRangeQueryHookResult = ReturnType<typeof useGetRevenueForTimeRangeQuery>;
export type GetRevenueForTimeRangeLazyQueryHookResult = ReturnType<typeof useGetRevenueForTimeRangeLazyQuery>;
export type GetRevenueForTimeRangeSuspenseQueryHookResult = ReturnType<typeof useGetRevenueForTimeRangeSuspenseQuery>;
export type GetRevenueForTimeRangeQueryResult = Apollo.QueryResult<GetRevenueForTimeRangeQuery, GetRevenueForTimeRangeQueryVariables>;
export const GetRevenuesByTypeForTimeRangeDocument = gql`
    query getRevenuesByTypeForTimeRange($clinicId: ID!, $start_time: NonNegativeInt!, $end_time: NonNegativeInt!) {
  getRevenuesByTypeForTimeRange(
    clinicId: $clinicId
    start_time: $start_time
    end_time: $end_time
  ) {
    group
    amount
  }
}
    `;

/**
 * __useGetRevenuesByTypeForTimeRangeQuery__
 *
 * To run a query within a React component, call `useGetRevenuesByTypeForTimeRangeQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetRevenuesByTypeForTimeRangeQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetRevenuesByTypeForTimeRangeQuery({
 *   variables: {
 *      clinicId: // value for 'clinicId'
 *      start_time: // value for 'start_time'
 *      end_time: // value for 'end_time'
 *   },
 * });
 */
export function useGetRevenuesByTypeForTimeRangeQuery(baseOptions: Apollo.QueryHookOptions<GetRevenuesByTypeForTimeRangeQuery, GetRevenuesByTypeForTimeRangeQueryVariables> & ({ variables: GetRevenuesByTypeForTimeRangeQueryVariables; skip?: boolean; } | { skip: boolean; }) ) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<GetRevenuesByTypeForTimeRangeQuery, GetRevenuesByTypeForTimeRangeQueryVariables>(GetRevenuesByTypeForTimeRangeDocument, options);
      }
export function useGetRevenuesByTypeForTimeRangeLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<GetRevenuesByTypeForTimeRangeQuery, GetRevenuesByTypeForTimeRangeQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<GetRevenuesByTypeForTimeRangeQuery, GetRevenuesByTypeForTimeRangeQueryVariables>(GetRevenuesByTypeForTimeRangeDocument, options);
        }
export function useGetRevenuesByTypeForTimeRangeSuspenseQuery(baseOptions?: Apollo.SuspenseQueryHookOptions<GetRevenuesByTypeForTimeRangeQuery, GetRevenuesByTypeForTimeRangeQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useSuspenseQuery<GetRevenuesByTypeForTimeRangeQuery, GetRevenuesByTypeForTimeRangeQueryVariables>(GetRevenuesByTypeForTimeRangeDocument, options);
        }
export type GetRevenuesByTypeForTimeRangeQueryHookResult = ReturnType<typeof useGetRevenuesByTypeForTimeRangeQuery>;
export type GetRevenuesByTypeForTimeRangeLazyQueryHookResult = ReturnType<typeof useGetRevenuesByTypeForTimeRangeLazyQuery>;
export type GetRevenuesByTypeForTimeRangeSuspenseQueryHookResult = ReturnType<typeof useGetRevenuesByTypeForTimeRangeSuspenseQuery>;
export type GetRevenuesByTypeForTimeRangeQueryResult = Apollo.QueryResult<GetRevenuesByTypeForTimeRangeQuery, GetRevenuesByTypeForTimeRangeQueryVariables>;
export const GetRevenuesByClinicianForTimeRangeDocument = gql`
    query getRevenuesByClinicianForTimeRange($clinicId: ID!, $start_time: NonNegativeInt!, $end_time: NonNegativeInt!) {
  getRevenuesByClinicianForTimeRange(
    clinicId: $clinicId
    start_time: $start_time
    end_time: $end_time
  ) {
    group
    amount
  }
}
    `;

/**
 * __useGetRevenuesByClinicianForTimeRangeQuery__
 *
 * To run a query within a React component, call `useGetRevenuesByClinicianForTimeRangeQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetRevenuesByClinicianForTimeRangeQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetRevenuesByClinicianForTimeRangeQuery({
 *   variables: {
 *      clinicId: // value for 'clinicId'
 *      start_time: // value for 'start_time'
 *      end_time: // value for 'end_time'
 *   },
 * });
 */
export function useGetRevenuesByClinicianForTimeRangeQuery(baseOptions: Apollo.QueryHookOptions<GetRevenuesByClinicianForTimeRangeQuery, GetRevenuesByClinicianForTimeRangeQueryVariables> & ({ variables: GetRevenuesByClinicianForTimeRangeQueryVariables; skip?: boolean; } | { skip: boolean; }) ) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<GetRevenuesByClinicianForTimeRangeQuery, GetRevenuesByClinicianForTimeRangeQueryVariables>(GetRevenuesByClinicianForTimeRangeDocument, options);
      }
export function useGetRevenuesByClinicianForTimeRangeLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<GetRevenuesByClinicianForTimeRangeQuery, GetRevenuesByClinicianForTimeRangeQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<GetRevenuesByClinicianForTimeRangeQuery, GetRevenuesByClinicianForTimeRangeQueryVariables>(GetRevenuesByClinicianForTimeRangeDocument, options);
        }
export function useGetRevenuesByClinicianForTimeRangeSuspenseQuery(baseOptions?: Apollo.SuspenseQueryHookOptions<GetRevenuesByClinicianForTimeRangeQuery, GetRevenuesByClinicianForTimeRangeQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useSuspenseQuery<GetRevenuesByClinicianForTimeRangeQuery, GetRevenuesByClinicianForTimeRangeQueryVariables>(GetRevenuesByClinicianForTimeRangeDocument, options);
        }
export type GetRevenuesByClinicianForTimeRangeQueryHookResult = ReturnType<typeof useGetRevenuesByClinicianForTimeRangeQuery>;
export type GetRevenuesByClinicianForTimeRangeLazyQueryHookResult = ReturnType<typeof useGetRevenuesByClinicianForTimeRangeLazyQuery>;
export type GetRevenuesByClinicianForTimeRangeSuspenseQueryHookResult = ReturnType<typeof useGetRevenuesByClinicianForTimeRangeSuspenseQuery>;
export type GetRevenuesByClinicianForTimeRangeQueryResult = Apollo.QueryResult<GetRevenuesByClinicianForTimeRangeQuery, GetRevenuesByClinicianForTimeRangeQueryVariables>;
export const GetAccountsReceivableDocument = gql`
    query getAccountsReceivable($clinicId: ID!) {
  getAccountsReceivable(clinicId: $clinicId)
}
    `;

/**
 * __useGetAccountsReceivableQuery__
 *
 * To run a query within a React component, call `useGetAccountsReceivableQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetAccountsReceivableQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetAccountsReceivableQuery({
 *   variables: {
 *      clinicId: // value for 'clinicId'
 *   },
 * });
 */
export function useGetAccountsReceivableQuery(baseOptions: Apollo.QueryHookOptions<GetAccountsReceivableQuery, GetAccountsReceivableQueryVariables> & ({ variables: GetAccountsReceivableQueryVariables; skip?: boolean; } | { skip: boolean; }) ) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<GetAccountsReceivableQuery, GetAccountsReceivableQueryVariables>(GetAccountsReceivableDocument, options);
      }
export function useGetAccountsReceivableLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<GetAccountsReceivableQuery, GetAccountsReceivableQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<GetAccountsReceivableQuery, GetAccountsReceivableQueryVariables>(GetAccountsReceivableDocument, options);
        }
export function useGetAccountsReceivableSuspenseQuery(baseOptions?: Apollo.SuspenseQueryHookOptions<GetAccountsReceivableQuery, GetAccountsReceivableQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useSuspenseQuery<GetAccountsReceivableQuery, GetAccountsReceivableQueryVariables>(GetAccountsReceivableDocument, options);
        }
export type GetAccountsReceivableQueryHookResult = ReturnType<typeof useGetAccountsReceivableQuery>;
export type GetAccountsReceivableLazyQueryHookResult = ReturnType<typeof useGetAccountsReceivableLazyQuery>;
export type GetAccountsReceivableSuspenseQueryHookResult = ReturnType<typeof useGetAccountsReceivableSuspenseQuery>;
export type GetAccountsReceivableQueryResult = Apollo.QueryResult<GetAccountsReceivableQuery, GetAccountsReceivableQueryVariables>;
export const GetClinicianServicesByServiceDocument = gql`
    query getClinicianServicesByService($serviceId: ID!) {
  getClinicianServicesByService(serviceId: $serviceId) {
    ...ClinicianServiceFields
  }
}
    ${ClinicianServiceFieldsFragmentDoc}`;

/**
 * __useGetClinicianServicesByServiceQuery__
 *
 * To run a query within a React component, call `useGetClinicianServicesByServiceQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetClinicianServicesByServiceQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetClinicianServicesByServiceQuery({
 *   variables: {
 *      serviceId: // value for 'serviceId'
 *   },
 * });
 */
export function useGetClinicianServicesByServiceQuery(baseOptions: Apollo.QueryHookOptions<GetClinicianServicesByServiceQuery, GetClinicianServicesByServiceQueryVariables> & ({ variables: GetClinicianServicesByServiceQueryVariables; skip?: boolean; } | { skip: boolean; }) ) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<GetClinicianServicesByServiceQuery, GetClinicianServicesByServiceQueryVariables>(GetClinicianServicesByServiceDocument, options);
      }
export function useGetClinicianServicesByServiceLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<GetClinicianServicesByServiceQuery, GetClinicianServicesByServiceQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<GetClinicianServicesByServiceQuery, GetClinicianServicesByServiceQueryVariables>(GetClinicianServicesByServiceDocument, options);
        }
export function useGetClinicianServicesByServiceSuspenseQuery(baseOptions?: Apollo.SuspenseQueryHookOptions<GetClinicianServicesByServiceQuery, GetClinicianServicesByServiceQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useSuspenseQuery<GetClinicianServicesByServiceQuery, GetClinicianServicesByServiceQueryVariables>(GetClinicianServicesByServiceDocument, options);
        }
export type GetClinicianServicesByServiceQueryHookResult = ReturnType<typeof useGetClinicianServicesByServiceQuery>;
export type GetClinicianServicesByServiceLazyQueryHookResult = ReturnType<typeof useGetClinicianServicesByServiceLazyQuery>;
export type GetClinicianServicesByServiceSuspenseQueryHookResult = ReturnType<typeof useGetClinicianServicesByServiceSuspenseQuery>;
export type GetClinicianServicesByServiceQueryResult = Apollo.QueryResult<GetClinicianServicesByServiceQuery, GetClinicianServicesByServiceQueryVariables>;
export const CreateClinicianServiceDocument = gql`
    mutation createClinicianService($data: CreateClinicianServiceInput!) {
  createClinicianService(data: $data) {
    ...ClinicianServiceFields
  }
}
    ${ClinicianServiceFieldsFragmentDoc}`;
export type CreateClinicianServiceMutationFn = Apollo.MutationFunction<CreateClinicianServiceMutation, CreateClinicianServiceMutationVariables>;

/**
 * __useCreateClinicianServiceMutation__
 *
 * To run a mutation, you first call `useCreateClinicianServiceMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useCreateClinicianServiceMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [createClinicianServiceMutation, { data, loading, error }] = useCreateClinicianServiceMutation({
 *   variables: {
 *      data: // value for 'data'
 *   },
 * });
 */
export function useCreateClinicianServiceMutation(baseOptions?: Apollo.MutationHookOptions<CreateClinicianServiceMutation, CreateClinicianServiceMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<CreateClinicianServiceMutation, CreateClinicianServiceMutationVariables>(CreateClinicianServiceDocument, options);
      }
export type CreateClinicianServiceMutationHookResult = ReturnType<typeof useCreateClinicianServiceMutation>;
export type CreateClinicianServiceMutationResult = Apollo.MutationResult<CreateClinicianServiceMutation>;
export type CreateClinicianServiceMutationOptions = Apollo.BaseMutationOptions<CreateClinicianServiceMutation, CreateClinicianServiceMutationVariables>;
export const UpdateClinicianServiceDocument = gql`
    mutation updateClinicianService($id: ID!, $data: UpdateClinicianServiceInput!) {
  updateClinicianService(id: $id, data: $data) {
    ...ClinicianServiceFields
  }
}
    ${ClinicianServiceFieldsFragmentDoc}`;
export type UpdateClinicianServiceMutationFn = Apollo.MutationFunction<UpdateClinicianServiceMutation, UpdateClinicianServiceMutationVariables>;

/**
 * __useUpdateClinicianServiceMutation__
 *
 * To run a mutation, you first call `useUpdateClinicianServiceMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useUpdateClinicianServiceMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [updateClinicianServiceMutation, { data, loading, error }] = useUpdateClinicianServiceMutation({
 *   variables: {
 *      id: // value for 'id'
 *      data: // value for 'data'
 *   },
 * });
 */
export function useUpdateClinicianServiceMutation(baseOptions?: Apollo.MutationHookOptions<UpdateClinicianServiceMutation, UpdateClinicianServiceMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<UpdateClinicianServiceMutation, UpdateClinicianServiceMutationVariables>(UpdateClinicianServiceDocument, options);
      }
export type UpdateClinicianServiceMutationHookResult = ReturnType<typeof useUpdateClinicianServiceMutation>;
export type UpdateClinicianServiceMutationResult = Apollo.MutationResult<UpdateClinicianServiceMutation>;
export type UpdateClinicianServiceMutationOptions = Apollo.BaseMutationOptions<UpdateClinicianServiceMutation, UpdateClinicianServiceMutationVariables>;
export const DeleteClinicianServiceDocument = gql`
    mutation deleteClinicianService($id: ID!) {
  deleteClinicianService(id: $id)
}
    `;
export type DeleteClinicianServiceMutationFn = Apollo.MutationFunction<DeleteClinicianServiceMutation, DeleteClinicianServiceMutationVariables>;

/**
 * __useDeleteClinicianServiceMutation__
 *
 * To run a mutation, you first call `useDeleteClinicianServiceMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useDeleteClinicianServiceMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [deleteClinicianServiceMutation, { data, loading, error }] = useDeleteClinicianServiceMutation({
 *   variables: {
 *      id: // value for 'id'
 *   },
 * });
 */
export function useDeleteClinicianServiceMutation(baseOptions?: Apollo.MutationHookOptions<DeleteClinicianServiceMutation, DeleteClinicianServiceMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<DeleteClinicianServiceMutation, DeleteClinicianServiceMutationVariables>(DeleteClinicianServiceDocument, options);
      }
export type DeleteClinicianServiceMutationHookResult = ReturnType<typeof useDeleteClinicianServiceMutation>;
export type DeleteClinicianServiceMutationResult = Apollo.MutationResult<DeleteClinicianServiceMutation>;
export type DeleteClinicianServiceMutationOptions = Apollo.BaseMutationOptions<DeleteClinicianServiceMutation, DeleteClinicianServiceMutationVariables>;
export const GetClinicianDocument = gql`
    query getClinician($id: ID!) {
  clinician(id: $id) {
    ...ClinicianFields
  }
}
    ${ClinicianFieldsFragmentDoc}`;

/**
 * __useGetClinicianQuery__
 *
 * To run a query within a React component, call `useGetClinicianQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetClinicianQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetClinicianQuery({
 *   variables: {
 *      id: // value for 'id'
 *   },
 * });
 */
export function useGetClinicianQuery(baseOptions: Apollo.QueryHookOptions<GetClinicianQuery, GetClinicianQueryVariables> & ({ variables: GetClinicianQueryVariables; skip?: boolean; } | { skip: boolean; }) ) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<GetClinicianQuery, GetClinicianQueryVariables>(GetClinicianDocument, options);
      }
export function useGetClinicianLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<GetClinicianQuery, GetClinicianQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<GetClinicianQuery, GetClinicianQueryVariables>(GetClinicianDocument, options);
        }
export function useGetClinicianSuspenseQuery(baseOptions?: Apollo.SuspenseQueryHookOptions<GetClinicianQuery, GetClinicianQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useSuspenseQuery<GetClinicianQuery, GetClinicianQueryVariables>(GetClinicianDocument, options);
        }
export type GetClinicianQueryHookResult = ReturnType<typeof useGetClinicianQuery>;
export type GetClinicianLazyQueryHookResult = ReturnType<typeof useGetClinicianLazyQuery>;
export type GetClinicianSuspenseQueryHookResult = ReturnType<typeof useGetClinicianSuspenseQuery>;
export type GetClinicianQueryResult = Apollo.QueryResult<GetClinicianQuery, GetClinicianQueryVariables>;
export const GetCliniciansByClinicDocument = gql`
    query getCliniciansByClinic($clinicId: ID!, $onlyAvailable: Boolean) {
  getCliniciansByClinic(clinicId: $clinicId, onlyAvailable: $onlyAvailable) {
    ...ClinicianFields
  }
}
    ${ClinicianFieldsFragmentDoc}`;

/**
 * __useGetCliniciansByClinicQuery__
 *
 * To run a query within a React component, call `useGetCliniciansByClinicQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetCliniciansByClinicQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetCliniciansByClinicQuery({
 *   variables: {
 *      clinicId: // value for 'clinicId'
 *      onlyAvailable: // value for 'onlyAvailable'
 *   },
 * });
 */
export function useGetCliniciansByClinicQuery(baseOptions: Apollo.QueryHookOptions<GetCliniciansByClinicQuery, GetCliniciansByClinicQueryVariables> & ({ variables: GetCliniciansByClinicQueryVariables; skip?: boolean; } | { skip: boolean; }) ) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<GetCliniciansByClinicQuery, GetCliniciansByClinicQueryVariables>(GetCliniciansByClinicDocument, options);
      }
export function useGetCliniciansByClinicLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<GetCliniciansByClinicQuery, GetCliniciansByClinicQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<GetCliniciansByClinicQuery, GetCliniciansByClinicQueryVariables>(GetCliniciansByClinicDocument, options);
        }
export function useGetCliniciansByClinicSuspenseQuery(baseOptions?: Apollo.SuspenseQueryHookOptions<GetCliniciansByClinicQuery, GetCliniciansByClinicQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useSuspenseQuery<GetCliniciansByClinicQuery, GetCliniciansByClinicQueryVariables>(GetCliniciansByClinicDocument, options);
        }
export type GetCliniciansByClinicQueryHookResult = ReturnType<typeof useGetCliniciansByClinicQuery>;
export type GetCliniciansByClinicLazyQueryHookResult = ReturnType<typeof useGetCliniciansByClinicLazyQuery>;
export type GetCliniciansByClinicSuspenseQueryHookResult = ReturnType<typeof useGetCliniciansByClinicSuspenseQuery>;
export type GetCliniciansByClinicQueryResult = Apollo.QueryResult<GetCliniciansByClinicQuery, GetCliniciansByClinicQueryVariables>;
export const QueryCliniciansDocument = gql`
    query queryClinicians($where: [QueryInput!], $page: NonNegativeInt, $pageSize: NonNegativeInt, $orderBy: OrderByInput) {
  queryClinicians(
    where: $where
    page: $page
    pageSize: $pageSize
    orderBy: $orderBy
  ) {
    ...ClinicianFields
  }
}
    ${ClinicianFieldsFragmentDoc}`;

/**
 * __useQueryCliniciansQuery__
 *
 * To run a query within a React component, call `useQueryCliniciansQuery` and pass it any options that fit your needs.
 * When your component renders, `useQueryCliniciansQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useQueryCliniciansQuery({
 *   variables: {
 *      where: // value for 'where'
 *      page: // value for 'page'
 *      pageSize: // value for 'pageSize'
 *      orderBy: // value for 'orderBy'
 *   },
 * });
 */
export function useQueryCliniciansQuery(baseOptions?: Apollo.QueryHookOptions<QueryCliniciansQuery, QueryCliniciansQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<QueryCliniciansQuery, QueryCliniciansQueryVariables>(QueryCliniciansDocument, options);
      }
export function useQueryCliniciansLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<QueryCliniciansQuery, QueryCliniciansQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<QueryCliniciansQuery, QueryCliniciansQueryVariables>(QueryCliniciansDocument, options);
        }
export function useQueryCliniciansSuspenseQuery(baseOptions?: Apollo.SuspenseQueryHookOptions<QueryCliniciansQuery, QueryCliniciansQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useSuspenseQuery<QueryCliniciansQuery, QueryCliniciansQueryVariables>(QueryCliniciansDocument, options);
        }
export type QueryCliniciansQueryHookResult = ReturnType<typeof useQueryCliniciansQuery>;
export type QueryCliniciansLazyQueryHookResult = ReturnType<typeof useQueryCliniciansLazyQuery>;
export type QueryCliniciansSuspenseQueryHookResult = ReturnType<typeof useQueryCliniciansSuspenseQuery>;
export type QueryCliniciansQueryResult = Apollo.QueryResult<QueryCliniciansQuery, QueryCliniciansQueryVariables>;
export const QueryPreviewCliniciansDocument = gql`
    query queryPreviewClinicians($where: [QueryInput!], $page: NonNegativeInt, $pageSize: NonNegativeInt, $orderBy: OrderByInput) {
  queryClinicians(
    where: $where
    page: $page
    pageSize: $pageSize
    orderBy: $orderBy
  ) {
    ...ClinicianPreviewFields
  }
}
    ${ClinicianPreviewFieldsFragmentDoc}`;

/**
 * __useQueryPreviewCliniciansQuery__
 *
 * To run a query within a React component, call `useQueryPreviewCliniciansQuery` and pass it any options that fit your needs.
 * When your component renders, `useQueryPreviewCliniciansQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useQueryPreviewCliniciansQuery({
 *   variables: {
 *      where: // value for 'where'
 *      page: // value for 'page'
 *      pageSize: // value for 'pageSize'
 *      orderBy: // value for 'orderBy'
 *   },
 * });
 */
export function useQueryPreviewCliniciansQuery(baseOptions?: Apollo.QueryHookOptions<QueryPreviewCliniciansQuery, QueryPreviewCliniciansQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<QueryPreviewCliniciansQuery, QueryPreviewCliniciansQueryVariables>(QueryPreviewCliniciansDocument, options);
      }
export function useQueryPreviewCliniciansLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<QueryPreviewCliniciansQuery, QueryPreviewCliniciansQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<QueryPreviewCliniciansQuery, QueryPreviewCliniciansQueryVariables>(QueryPreviewCliniciansDocument, options);
        }
export function useQueryPreviewCliniciansSuspenseQuery(baseOptions?: Apollo.SuspenseQueryHookOptions<QueryPreviewCliniciansQuery, QueryPreviewCliniciansQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useSuspenseQuery<QueryPreviewCliniciansQuery, QueryPreviewCliniciansQueryVariables>(QueryPreviewCliniciansDocument, options);
        }
export type QueryPreviewCliniciansQueryHookResult = ReturnType<typeof useQueryPreviewCliniciansQuery>;
export type QueryPreviewCliniciansLazyQueryHookResult = ReturnType<typeof useQueryPreviewCliniciansLazyQuery>;
export type QueryPreviewCliniciansSuspenseQueryHookResult = ReturnType<typeof useQueryPreviewCliniciansSuspenseQuery>;
export type QueryPreviewCliniciansQueryResult = Apollo.QueryResult<QueryPreviewCliniciansQuery, QueryPreviewCliniciansQueryVariables>;
export const CountCliniciansDocument = gql`
    query countClinicians($where: [QueryInput!]) {
  countClinicians(where: $where)
}
    `;

/**
 * __useCountCliniciansQuery__
 *
 * To run a query within a React component, call `useCountCliniciansQuery` and pass it any options that fit your needs.
 * When your component renders, `useCountCliniciansQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useCountCliniciansQuery({
 *   variables: {
 *      where: // value for 'where'
 *   },
 * });
 */
export function useCountCliniciansQuery(baseOptions?: Apollo.QueryHookOptions<CountCliniciansQuery, CountCliniciansQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<CountCliniciansQuery, CountCliniciansQueryVariables>(CountCliniciansDocument, options);
      }
export function useCountCliniciansLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<CountCliniciansQuery, CountCliniciansQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<CountCliniciansQuery, CountCliniciansQueryVariables>(CountCliniciansDocument, options);
        }
export function useCountCliniciansSuspenseQuery(baseOptions?: Apollo.SuspenseQueryHookOptions<CountCliniciansQuery, CountCliniciansQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useSuspenseQuery<CountCliniciansQuery, CountCliniciansQueryVariables>(CountCliniciansDocument, options);
        }
export type CountCliniciansQueryHookResult = ReturnType<typeof useCountCliniciansQuery>;
export type CountCliniciansLazyQueryHookResult = ReturnType<typeof useCountCliniciansLazyQuery>;
export type CountCliniciansSuspenseQueryHookResult = ReturnType<typeof useCountCliniciansSuspenseQuery>;
export type CountCliniciansQueryResult = Apollo.QueryResult<CountCliniciansQuery, CountCliniciansQueryVariables>;
export const GetOnDemandCliniciansForClinicDocument = gql`
    query getOnDemandCliniciansForClinic($clinicId: ID!) {
  getOnDemandCliniciansForClinic(clinicId: $clinicId) {
    ...OnDemandClinicianFields
  }
}
    ${OnDemandClinicianFieldsFragmentDoc}`;

/**
 * __useGetOnDemandCliniciansForClinicQuery__
 *
 * To run a query within a React component, call `useGetOnDemandCliniciansForClinicQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetOnDemandCliniciansForClinicQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetOnDemandCliniciansForClinicQuery({
 *   variables: {
 *      clinicId: // value for 'clinicId'
 *   },
 * });
 */
export function useGetOnDemandCliniciansForClinicQuery(baseOptions: Apollo.QueryHookOptions<GetOnDemandCliniciansForClinicQuery, GetOnDemandCliniciansForClinicQueryVariables> & ({ variables: GetOnDemandCliniciansForClinicQueryVariables; skip?: boolean; } | { skip: boolean; }) ) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<GetOnDemandCliniciansForClinicQuery, GetOnDemandCliniciansForClinicQueryVariables>(GetOnDemandCliniciansForClinicDocument, options);
      }
export function useGetOnDemandCliniciansForClinicLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<GetOnDemandCliniciansForClinicQuery, GetOnDemandCliniciansForClinicQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<GetOnDemandCliniciansForClinicQuery, GetOnDemandCliniciansForClinicQueryVariables>(GetOnDemandCliniciansForClinicDocument, options);
        }
export function useGetOnDemandCliniciansForClinicSuspenseQuery(baseOptions?: Apollo.SuspenseQueryHookOptions<GetOnDemandCliniciansForClinicQuery, GetOnDemandCliniciansForClinicQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useSuspenseQuery<GetOnDemandCliniciansForClinicQuery, GetOnDemandCliniciansForClinicQueryVariables>(GetOnDemandCliniciansForClinicDocument, options);
        }
export type GetOnDemandCliniciansForClinicQueryHookResult = ReturnType<typeof useGetOnDemandCliniciansForClinicQuery>;
export type GetOnDemandCliniciansForClinicLazyQueryHookResult = ReturnType<typeof useGetOnDemandCliniciansForClinicLazyQuery>;
export type GetOnDemandCliniciansForClinicSuspenseQueryHookResult = ReturnType<typeof useGetOnDemandCliniciansForClinicSuspenseQuery>;
export type GetOnDemandCliniciansForClinicQueryResult = Apollo.QueryResult<GetOnDemandCliniciansForClinicQuery, GetOnDemandCliniciansForClinicQueryVariables>;
export const CreateClinicianDocument = gql`
    mutation createClinician($data: CreateClinicianInput!) {
  createClinician(data: $data) {
    ...ClinicianFields
  }
}
    ${ClinicianFieldsFragmentDoc}`;
export type CreateClinicianMutationFn = Apollo.MutationFunction<CreateClinicianMutation, CreateClinicianMutationVariables>;

/**
 * __useCreateClinicianMutation__
 *
 * To run a mutation, you first call `useCreateClinicianMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useCreateClinicianMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [createClinicianMutation, { data, loading, error }] = useCreateClinicianMutation({
 *   variables: {
 *      data: // value for 'data'
 *   },
 * });
 */
export function useCreateClinicianMutation(baseOptions?: Apollo.MutationHookOptions<CreateClinicianMutation, CreateClinicianMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<CreateClinicianMutation, CreateClinicianMutationVariables>(CreateClinicianDocument, options);
      }
export type CreateClinicianMutationHookResult = ReturnType<typeof useCreateClinicianMutation>;
export type CreateClinicianMutationResult = Apollo.MutationResult<CreateClinicianMutation>;
export type CreateClinicianMutationOptions = Apollo.BaseMutationOptions<CreateClinicianMutation, CreateClinicianMutationVariables>;
export const UpdateClinicianDocument = gql`
    mutation updateClinician($id: ID!, $data: UpdateClinicianInput!) {
  updateClinician(id: $id, data: $data) {
    ...ClinicianFields
  }
}
    ${ClinicianFieldsFragmentDoc}`;
export type UpdateClinicianMutationFn = Apollo.MutationFunction<UpdateClinicianMutation, UpdateClinicianMutationVariables>;

/**
 * __useUpdateClinicianMutation__
 *
 * To run a mutation, you first call `useUpdateClinicianMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useUpdateClinicianMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [updateClinicianMutation, { data, loading, error }] = useUpdateClinicianMutation({
 *   variables: {
 *      id: // value for 'id'
 *      data: // value for 'data'
 *   },
 * });
 */
export function useUpdateClinicianMutation(baseOptions?: Apollo.MutationHookOptions<UpdateClinicianMutation, UpdateClinicianMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<UpdateClinicianMutation, UpdateClinicianMutationVariables>(UpdateClinicianDocument, options);
      }
export type UpdateClinicianMutationHookResult = ReturnType<typeof useUpdateClinicianMutation>;
export type UpdateClinicianMutationResult = Apollo.MutationResult<UpdateClinicianMutation>;
export type UpdateClinicianMutationOptions = Apollo.BaseMutationOptions<UpdateClinicianMutation, UpdateClinicianMutationVariables>;
export const DeleteClinicianDocument = gql`
    mutation deleteClinician($id: ID!) {
  deleteClinician(id: $id)
}
    `;
export type DeleteClinicianMutationFn = Apollo.MutationFunction<DeleteClinicianMutation, DeleteClinicianMutationVariables>;

/**
 * __useDeleteClinicianMutation__
 *
 * To run a mutation, you first call `useDeleteClinicianMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useDeleteClinicianMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [deleteClinicianMutation, { data, loading, error }] = useDeleteClinicianMutation({
 *   variables: {
 *      id: // value for 'id'
 *   },
 * });
 */
export function useDeleteClinicianMutation(baseOptions?: Apollo.MutationHookOptions<DeleteClinicianMutation, DeleteClinicianMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<DeleteClinicianMutation, DeleteClinicianMutationVariables>(DeleteClinicianDocument, options);
      }
export type DeleteClinicianMutationHookResult = ReturnType<typeof useDeleteClinicianMutation>;
export type DeleteClinicianMutationResult = Apollo.MutationResult<DeleteClinicianMutation>;
export type DeleteClinicianMutationOptions = Apollo.BaseMutationOptions<DeleteClinicianMutation, DeleteClinicianMutationVariables>;
export const GetClinicUsageStatsDocument = gql`
    query getClinicUsageStats($where: [QueryInput!], $page: NonNegativeInt, $pageSize: NonNegativeInt, $orderBy: OrderByInput) {
  getClinicUsageStats(
    where: $where
    page: $page
    pageSize: $pageSize
    orderBy: $orderBy
  ) {
    ...ClinicUsageStatsFields
  }
}
    ${ClinicUsageStatsFieldsFragmentDoc}`;

/**
 * __useGetClinicUsageStatsQuery__
 *
 * To run a query within a React component, call `useGetClinicUsageStatsQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetClinicUsageStatsQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetClinicUsageStatsQuery({
 *   variables: {
 *      where: // value for 'where'
 *      page: // value for 'page'
 *      pageSize: // value for 'pageSize'
 *      orderBy: // value for 'orderBy'
 *   },
 * });
 */
export function useGetClinicUsageStatsQuery(baseOptions?: Apollo.QueryHookOptions<GetClinicUsageStatsQuery, GetClinicUsageStatsQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<GetClinicUsageStatsQuery, GetClinicUsageStatsQueryVariables>(GetClinicUsageStatsDocument, options);
      }
export function useGetClinicUsageStatsLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<GetClinicUsageStatsQuery, GetClinicUsageStatsQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<GetClinicUsageStatsQuery, GetClinicUsageStatsQueryVariables>(GetClinicUsageStatsDocument, options);
        }
export function useGetClinicUsageStatsSuspenseQuery(baseOptions?: Apollo.SuspenseQueryHookOptions<GetClinicUsageStatsQuery, GetClinicUsageStatsQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useSuspenseQuery<GetClinicUsageStatsQuery, GetClinicUsageStatsQueryVariables>(GetClinicUsageStatsDocument, options);
        }
export type GetClinicUsageStatsQueryHookResult = ReturnType<typeof useGetClinicUsageStatsQuery>;
export type GetClinicUsageStatsLazyQueryHookResult = ReturnType<typeof useGetClinicUsageStatsLazyQuery>;
export type GetClinicUsageStatsSuspenseQueryHookResult = ReturnType<typeof useGetClinicUsageStatsSuspenseQuery>;
export type GetClinicUsageStatsQueryResult = Apollo.QueryResult<GetClinicUsageStatsQuery, GetClinicUsageStatsQueryVariables>;
export const GetClinicsWithConcernsDocument = gql`
    query getClinicsWithConcerns($wowApptWarning: Int, $momApptWarning: Int, $wowNotifWarning: Int, $momNotifWarning: Int) {
  getClinicsWithConcerns(
    wowApptWarning: $wowApptWarning
    momApptWarning: $momApptWarning
    wowNotifWarning: $wowNotifWarning
    momNotifWarning: $momNotifWarning
  ) {
    ...ClinicUsageStatsFields
  }
}
    ${ClinicUsageStatsFieldsFragmentDoc}`;

/**
 * __useGetClinicsWithConcernsQuery__
 *
 * To run a query within a React component, call `useGetClinicsWithConcernsQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetClinicsWithConcernsQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetClinicsWithConcernsQuery({
 *   variables: {
 *      wowApptWarning: // value for 'wowApptWarning'
 *      momApptWarning: // value for 'momApptWarning'
 *      wowNotifWarning: // value for 'wowNotifWarning'
 *      momNotifWarning: // value for 'momNotifWarning'
 *   },
 * });
 */
export function useGetClinicsWithConcernsQuery(baseOptions?: Apollo.QueryHookOptions<GetClinicsWithConcernsQuery, GetClinicsWithConcernsQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<GetClinicsWithConcernsQuery, GetClinicsWithConcernsQueryVariables>(GetClinicsWithConcernsDocument, options);
      }
export function useGetClinicsWithConcernsLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<GetClinicsWithConcernsQuery, GetClinicsWithConcernsQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<GetClinicsWithConcernsQuery, GetClinicsWithConcernsQueryVariables>(GetClinicsWithConcernsDocument, options);
        }
export function useGetClinicsWithConcernsSuspenseQuery(baseOptions?: Apollo.SuspenseQueryHookOptions<GetClinicsWithConcernsQuery, GetClinicsWithConcernsQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useSuspenseQuery<GetClinicsWithConcernsQuery, GetClinicsWithConcernsQueryVariables>(GetClinicsWithConcernsDocument, options);
        }
export type GetClinicsWithConcernsQueryHookResult = ReturnType<typeof useGetClinicsWithConcernsQuery>;
export type GetClinicsWithConcernsLazyQueryHookResult = ReturnType<typeof useGetClinicsWithConcernsLazyQuery>;
export type GetClinicsWithConcernsSuspenseQueryHookResult = ReturnType<typeof useGetClinicsWithConcernsSuspenseQuery>;
export type GetClinicsWithConcernsQueryResult = Apollo.QueryResult<GetClinicsWithConcernsQuery, GetClinicsWithConcernsQueryVariables>;
export const GetClinicDocument = gql`
    query getClinic($id: ID!) {
  clinic(id: $id) {
    ...ClinicFields
  }
}
    ${ClinicFieldsFragmentDoc}`;

/**
 * __useGetClinicQuery__
 *
 * To run a query within a React component, call `useGetClinicQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetClinicQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetClinicQuery({
 *   variables: {
 *      id: // value for 'id'
 *   },
 * });
 */
export function useGetClinicQuery(baseOptions: Apollo.QueryHookOptions<GetClinicQuery, GetClinicQueryVariables> & ({ variables: GetClinicQueryVariables; skip?: boolean; } | { skip: boolean; }) ) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<GetClinicQuery, GetClinicQueryVariables>(GetClinicDocument, options);
      }
export function useGetClinicLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<GetClinicQuery, GetClinicQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<GetClinicQuery, GetClinicQueryVariables>(GetClinicDocument, options);
        }
export function useGetClinicSuspenseQuery(baseOptions?: Apollo.SuspenseQueryHookOptions<GetClinicQuery, GetClinicQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useSuspenseQuery<GetClinicQuery, GetClinicQueryVariables>(GetClinicDocument, options);
        }
export type GetClinicQueryHookResult = ReturnType<typeof useGetClinicQuery>;
export type GetClinicLazyQueryHookResult = ReturnType<typeof useGetClinicLazyQuery>;
export type GetClinicSuspenseQueryHookResult = ReturnType<typeof useGetClinicSuspenseQuery>;
export type GetClinicQueryResult = Apollo.QueryResult<GetClinicQuery, GetClinicQueryVariables>;
export const GetSupportedPmsConnectorsDocument = gql`
    query getSupportedPmsConnectors($pms: PracticeManagementSystem!) {
  supportedPmsConnectors(pms: $pms)
}
    `;

/**
 * __useGetSupportedPmsConnectorsQuery__
 *
 * To run a query within a React component, call `useGetSupportedPmsConnectorsQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetSupportedPmsConnectorsQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetSupportedPmsConnectorsQuery({
 *   variables: {
 *      pms: // value for 'pms'
 *   },
 * });
 */
export function useGetSupportedPmsConnectorsQuery(baseOptions: Apollo.QueryHookOptions<GetSupportedPmsConnectorsQuery, GetSupportedPmsConnectorsQueryVariables> & ({ variables: GetSupportedPmsConnectorsQueryVariables; skip?: boolean; } | { skip: boolean; }) ) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<GetSupportedPmsConnectorsQuery, GetSupportedPmsConnectorsQueryVariables>(GetSupportedPmsConnectorsDocument, options);
      }
export function useGetSupportedPmsConnectorsLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<GetSupportedPmsConnectorsQuery, GetSupportedPmsConnectorsQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<GetSupportedPmsConnectorsQuery, GetSupportedPmsConnectorsQueryVariables>(GetSupportedPmsConnectorsDocument, options);
        }
export function useGetSupportedPmsConnectorsSuspenseQuery(baseOptions?: Apollo.SuspenseQueryHookOptions<GetSupportedPmsConnectorsQuery, GetSupportedPmsConnectorsQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useSuspenseQuery<GetSupportedPmsConnectorsQuery, GetSupportedPmsConnectorsQueryVariables>(GetSupportedPmsConnectorsDocument, options);
        }
export type GetSupportedPmsConnectorsQueryHookResult = ReturnType<typeof useGetSupportedPmsConnectorsQuery>;
export type GetSupportedPmsConnectorsLazyQueryHookResult = ReturnType<typeof useGetSupportedPmsConnectorsLazyQuery>;
export type GetSupportedPmsConnectorsSuspenseQueryHookResult = ReturnType<typeof useGetSupportedPmsConnectorsSuspenseQuery>;
export type GetSupportedPmsConnectorsQueryResult = Apollo.QueryResult<GetSupportedPmsConnectorsQuery, GetSupportedPmsConnectorsQueryVariables>;
export const GetClientsForClinicDocument = gql`
    query getClientsForClinic($clinicId: ID!, $page: NonNegativeInt, $pageSize: NonNegativeInt) {
  getClientsForClinic(clinicId: $clinicId, page: $page, pageSize: $pageSize) {
    ...ClientFields
  }
}
    ${ClientFieldsFragmentDoc}`;

/**
 * __useGetClientsForClinicQuery__
 *
 * To run a query within a React component, call `useGetClientsForClinicQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetClientsForClinicQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetClientsForClinicQuery({
 *   variables: {
 *      clinicId: // value for 'clinicId'
 *      page: // value for 'page'
 *      pageSize: // value for 'pageSize'
 *   },
 * });
 */
export function useGetClientsForClinicQuery(baseOptions: Apollo.QueryHookOptions<GetClientsForClinicQuery, GetClientsForClinicQueryVariables> & ({ variables: GetClientsForClinicQueryVariables; skip?: boolean; } | { skip: boolean; }) ) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<GetClientsForClinicQuery, GetClientsForClinicQueryVariables>(GetClientsForClinicDocument, options);
      }
export function useGetClientsForClinicLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<GetClientsForClinicQuery, GetClientsForClinicQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<GetClientsForClinicQuery, GetClientsForClinicQueryVariables>(GetClientsForClinicDocument, options);
        }
export function useGetClientsForClinicSuspenseQuery(baseOptions?: Apollo.SuspenseQueryHookOptions<GetClientsForClinicQuery, GetClientsForClinicQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useSuspenseQuery<GetClientsForClinicQuery, GetClientsForClinicQueryVariables>(GetClientsForClinicDocument, options);
        }
export type GetClientsForClinicQueryHookResult = ReturnType<typeof useGetClientsForClinicQuery>;
export type GetClientsForClinicLazyQueryHookResult = ReturnType<typeof useGetClientsForClinicLazyQuery>;
export type GetClientsForClinicSuspenseQueryHookResult = ReturnType<typeof useGetClientsForClinicSuspenseQuery>;
export type GetClientsForClinicQueryResult = Apollo.QueryResult<GetClientsForClinicQuery, GetClientsForClinicQueryVariables>;
export const GetClientCountForClinicDocument = gql`
    query getClientCountForClinic($clinicId: ID!) {
  getClientCountForClinic(clinicId: $clinicId)
}
    `;

/**
 * __useGetClientCountForClinicQuery__
 *
 * To run a query within a React component, call `useGetClientCountForClinicQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetClientCountForClinicQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetClientCountForClinicQuery({
 *   variables: {
 *      clinicId: // value for 'clinicId'
 *   },
 * });
 */
export function useGetClientCountForClinicQuery(baseOptions: Apollo.QueryHookOptions<GetClientCountForClinicQuery, GetClientCountForClinicQueryVariables> & ({ variables: GetClientCountForClinicQueryVariables; skip?: boolean; } | { skip: boolean; }) ) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<GetClientCountForClinicQuery, GetClientCountForClinicQueryVariables>(GetClientCountForClinicDocument, options);
      }
export function useGetClientCountForClinicLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<GetClientCountForClinicQuery, GetClientCountForClinicQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<GetClientCountForClinicQuery, GetClientCountForClinicQueryVariables>(GetClientCountForClinicDocument, options);
        }
export function useGetClientCountForClinicSuspenseQuery(baseOptions?: Apollo.SuspenseQueryHookOptions<GetClientCountForClinicQuery, GetClientCountForClinicQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useSuspenseQuery<GetClientCountForClinicQuery, GetClientCountForClinicQueryVariables>(GetClientCountForClinicDocument, options);
        }
export type GetClientCountForClinicQueryHookResult = ReturnType<typeof useGetClientCountForClinicQuery>;
export type GetClientCountForClinicLazyQueryHookResult = ReturnType<typeof useGetClientCountForClinicLazyQuery>;
export type GetClientCountForClinicSuspenseQueryHookResult = ReturnType<typeof useGetClientCountForClinicSuspenseQuery>;
export type GetClientCountForClinicQueryResult = Apollo.QueryResult<GetClientCountForClinicQuery, GetClientCountForClinicQueryVariables>;
export const GetClinicsForUserAdminDocument = gql`
    query getClinicsForUserAdmin($userId: ID!) {
  getClinicsForUserAdmin(userId: $userId) {
    ...ClinicFields
  }
}
    ${ClinicFieldsFragmentDoc}`;

/**
 * __useGetClinicsForUserAdminQuery__
 *
 * To run a query within a React component, call `useGetClinicsForUserAdminQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetClinicsForUserAdminQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetClinicsForUserAdminQuery({
 *   variables: {
 *      userId: // value for 'userId'
 *   },
 * });
 */
export function useGetClinicsForUserAdminQuery(baseOptions: Apollo.QueryHookOptions<GetClinicsForUserAdminQuery, GetClinicsForUserAdminQueryVariables> & ({ variables: GetClinicsForUserAdminQueryVariables; skip?: boolean; } | { skip: boolean; }) ) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<GetClinicsForUserAdminQuery, GetClinicsForUserAdminQueryVariables>(GetClinicsForUserAdminDocument, options);
      }
export function useGetClinicsForUserAdminLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<GetClinicsForUserAdminQuery, GetClinicsForUserAdminQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<GetClinicsForUserAdminQuery, GetClinicsForUserAdminQueryVariables>(GetClinicsForUserAdminDocument, options);
        }
export function useGetClinicsForUserAdminSuspenseQuery(baseOptions?: Apollo.SuspenseQueryHookOptions<GetClinicsForUserAdminQuery, GetClinicsForUserAdminQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useSuspenseQuery<GetClinicsForUserAdminQuery, GetClinicsForUserAdminQueryVariables>(GetClinicsForUserAdminDocument, options);
        }
export type GetClinicsForUserAdminQueryHookResult = ReturnType<typeof useGetClinicsForUserAdminQuery>;
export type GetClinicsForUserAdminLazyQueryHookResult = ReturnType<typeof useGetClinicsForUserAdminLazyQuery>;
export type GetClinicsForUserAdminSuspenseQueryHookResult = ReturnType<typeof useGetClinicsForUserAdminSuspenseQuery>;
export type GetClinicsForUserAdminQueryResult = Apollo.QueryResult<GetClinicsForUserAdminQuery, GetClinicsForUserAdminQueryVariables>;
export const CountClinicsForUserAdminDocument = gql`
    query countClinicsForUserAdmin($userId: ID!) {
  countClinicsForUserAdmin(userId: $userId)
}
    `;

/**
 * __useCountClinicsForUserAdminQuery__
 *
 * To run a query within a React component, call `useCountClinicsForUserAdminQuery` and pass it any options that fit your needs.
 * When your component renders, `useCountClinicsForUserAdminQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useCountClinicsForUserAdminQuery({
 *   variables: {
 *      userId: // value for 'userId'
 *   },
 * });
 */
export function useCountClinicsForUserAdminQuery(baseOptions: Apollo.QueryHookOptions<CountClinicsForUserAdminQuery, CountClinicsForUserAdminQueryVariables> & ({ variables: CountClinicsForUserAdminQueryVariables; skip?: boolean; } | { skip: boolean; }) ) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<CountClinicsForUserAdminQuery, CountClinicsForUserAdminQueryVariables>(CountClinicsForUserAdminDocument, options);
      }
export function useCountClinicsForUserAdminLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<CountClinicsForUserAdminQuery, CountClinicsForUserAdminQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<CountClinicsForUserAdminQuery, CountClinicsForUserAdminQueryVariables>(CountClinicsForUserAdminDocument, options);
        }
export function useCountClinicsForUserAdminSuspenseQuery(baseOptions?: Apollo.SuspenseQueryHookOptions<CountClinicsForUserAdminQuery, CountClinicsForUserAdminQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useSuspenseQuery<CountClinicsForUserAdminQuery, CountClinicsForUserAdminQueryVariables>(CountClinicsForUserAdminDocument, options);
        }
export type CountClinicsForUserAdminQueryHookResult = ReturnType<typeof useCountClinicsForUserAdminQuery>;
export type CountClinicsForUserAdminLazyQueryHookResult = ReturnType<typeof useCountClinicsForUserAdminLazyQuery>;
export type CountClinicsForUserAdminSuspenseQueryHookResult = ReturnType<typeof useCountClinicsForUserAdminSuspenseQuery>;
export type CountClinicsForUserAdminQueryResult = Apollo.QueryResult<CountClinicsForUserAdminQuery, CountClinicsForUserAdminQueryVariables>;
export const QueryClinicsDocument = gql`
    query queryClinics($where: [QueryInput!], $page: NonNegativeInt, $pageSize: NonNegativeInt, $orderBy: OrderByInput) {
  queryClinics(where: $where, page: $page, pageSize: $pageSize, orderBy: $orderBy) {
    ...ClinicFields
  }
}
    ${ClinicFieldsFragmentDoc}`;

/**
 * __useQueryClinicsQuery__
 *
 * To run a query within a React component, call `useQueryClinicsQuery` and pass it any options that fit your needs.
 * When your component renders, `useQueryClinicsQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useQueryClinicsQuery({
 *   variables: {
 *      where: // value for 'where'
 *      page: // value for 'page'
 *      pageSize: // value for 'pageSize'
 *      orderBy: // value for 'orderBy'
 *   },
 * });
 */
export function useQueryClinicsQuery(baseOptions?: Apollo.QueryHookOptions<QueryClinicsQuery, QueryClinicsQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<QueryClinicsQuery, QueryClinicsQueryVariables>(QueryClinicsDocument, options);
      }
export function useQueryClinicsLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<QueryClinicsQuery, QueryClinicsQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<QueryClinicsQuery, QueryClinicsQueryVariables>(QueryClinicsDocument, options);
        }
export function useQueryClinicsSuspenseQuery(baseOptions?: Apollo.SuspenseQueryHookOptions<QueryClinicsQuery, QueryClinicsQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useSuspenseQuery<QueryClinicsQuery, QueryClinicsQueryVariables>(QueryClinicsDocument, options);
        }
export type QueryClinicsQueryHookResult = ReturnType<typeof useQueryClinicsQuery>;
export type QueryClinicsLazyQueryHookResult = ReturnType<typeof useQueryClinicsLazyQuery>;
export type QueryClinicsSuspenseQueryHookResult = ReturnType<typeof useQueryClinicsSuspenseQuery>;
export type QueryClinicsQueryResult = Apollo.QueryResult<QueryClinicsQuery, QueryClinicsQueryVariables>;
export const CountClinicsDocument = gql`
    query countClinics($where: [QueryInput!]) {
  countClinics(where: $where)
}
    `;

/**
 * __useCountClinicsQuery__
 *
 * To run a query within a React component, call `useCountClinicsQuery` and pass it any options that fit your needs.
 * When your component renders, `useCountClinicsQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useCountClinicsQuery({
 *   variables: {
 *      where: // value for 'where'
 *   },
 * });
 */
export function useCountClinicsQuery(baseOptions?: Apollo.QueryHookOptions<CountClinicsQuery, CountClinicsQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<CountClinicsQuery, CountClinicsQueryVariables>(CountClinicsDocument, options);
      }
export function useCountClinicsLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<CountClinicsQuery, CountClinicsQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<CountClinicsQuery, CountClinicsQueryVariables>(CountClinicsDocument, options);
        }
export function useCountClinicsSuspenseQuery(baseOptions?: Apollo.SuspenseQueryHookOptions<CountClinicsQuery, CountClinicsQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useSuspenseQuery<CountClinicsQuery, CountClinicsQueryVariables>(CountClinicsDocument, options);
        }
export type CountClinicsQueryHookResult = ReturnType<typeof useCountClinicsQuery>;
export type CountClinicsLazyQueryHookResult = ReturnType<typeof useCountClinicsLazyQuery>;
export type CountClinicsSuspenseQueryHookResult = ReturnType<typeof useCountClinicsSuspenseQuery>;
export type CountClinicsQueryResult = Apollo.QueryResult<CountClinicsQuery, CountClinicsQueryVariables>;
export const ClinicStatsDocument = gql`
    query clinicStats($clinicId: ID!) {
  clinicStats(clinicId: $clinicId) {
    ...ClinicStatsFields
  }
}
    ${ClinicStatsFieldsFragmentDoc}`;

/**
 * __useClinicStatsQuery__
 *
 * To run a query within a React component, call `useClinicStatsQuery` and pass it any options that fit your needs.
 * When your component renders, `useClinicStatsQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useClinicStatsQuery({
 *   variables: {
 *      clinicId: // value for 'clinicId'
 *   },
 * });
 */
export function useClinicStatsQuery(baseOptions: Apollo.QueryHookOptions<ClinicStatsQuery, ClinicStatsQueryVariables> & ({ variables: ClinicStatsQueryVariables; skip?: boolean; } | { skip: boolean; }) ) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<ClinicStatsQuery, ClinicStatsQueryVariables>(ClinicStatsDocument, options);
      }
export function useClinicStatsLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<ClinicStatsQuery, ClinicStatsQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<ClinicStatsQuery, ClinicStatsQueryVariables>(ClinicStatsDocument, options);
        }
export function useClinicStatsSuspenseQuery(baseOptions?: Apollo.SuspenseQueryHookOptions<ClinicStatsQuery, ClinicStatsQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useSuspenseQuery<ClinicStatsQuery, ClinicStatsQueryVariables>(ClinicStatsDocument, options);
        }
export type ClinicStatsQueryHookResult = ReturnType<typeof useClinicStatsQuery>;
export type ClinicStatsLazyQueryHookResult = ReturnType<typeof useClinicStatsLazyQuery>;
export type ClinicStatsSuspenseQueryHookResult = ReturnType<typeof useClinicStatsSuspenseQuery>;
export type ClinicStatsQueryResult = Apollo.QueryResult<ClinicStatsQuery, ClinicStatsQueryVariables>;
export const GetTotalRevenueForClinicBetweenTimesDocument = gql`
    query getTotalRevenueForClinicBetweenTimes($clinicId: ID!, $endTime: NonNegativeInt!, $startTime: NonNegativeInt!) {
  getTotalRevenueForClinicBetweenTimes(
    clinicId: $clinicId
    endTime: $endTime
    startTime: $startTime
  )
}
    `;

/**
 * __useGetTotalRevenueForClinicBetweenTimesQuery__
 *
 * To run a query within a React component, call `useGetTotalRevenueForClinicBetweenTimesQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetTotalRevenueForClinicBetweenTimesQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetTotalRevenueForClinicBetweenTimesQuery({
 *   variables: {
 *      clinicId: // value for 'clinicId'
 *      endTime: // value for 'endTime'
 *      startTime: // value for 'startTime'
 *   },
 * });
 */
export function useGetTotalRevenueForClinicBetweenTimesQuery(baseOptions: Apollo.QueryHookOptions<GetTotalRevenueForClinicBetweenTimesQuery, GetTotalRevenueForClinicBetweenTimesQueryVariables> & ({ variables: GetTotalRevenueForClinicBetweenTimesQueryVariables; skip?: boolean; } | { skip: boolean; }) ) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<GetTotalRevenueForClinicBetweenTimesQuery, GetTotalRevenueForClinicBetweenTimesQueryVariables>(GetTotalRevenueForClinicBetweenTimesDocument, options);
      }
export function useGetTotalRevenueForClinicBetweenTimesLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<GetTotalRevenueForClinicBetweenTimesQuery, GetTotalRevenueForClinicBetweenTimesQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<GetTotalRevenueForClinicBetweenTimesQuery, GetTotalRevenueForClinicBetweenTimesQueryVariables>(GetTotalRevenueForClinicBetweenTimesDocument, options);
        }
export function useGetTotalRevenueForClinicBetweenTimesSuspenseQuery(baseOptions?: Apollo.SuspenseQueryHookOptions<GetTotalRevenueForClinicBetweenTimesQuery, GetTotalRevenueForClinicBetweenTimesQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useSuspenseQuery<GetTotalRevenueForClinicBetweenTimesQuery, GetTotalRevenueForClinicBetweenTimesQueryVariables>(GetTotalRevenueForClinicBetweenTimesDocument, options);
        }
export type GetTotalRevenueForClinicBetweenTimesQueryHookResult = ReturnType<typeof useGetTotalRevenueForClinicBetweenTimesQuery>;
export type GetTotalRevenueForClinicBetweenTimesLazyQueryHookResult = ReturnType<typeof useGetTotalRevenueForClinicBetweenTimesLazyQuery>;
export type GetTotalRevenueForClinicBetweenTimesSuspenseQueryHookResult = ReturnType<typeof useGetTotalRevenueForClinicBetweenTimesSuspenseQuery>;
export type GetTotalRevenueForClinicBetweenTimesQueryResult = Apollo.QueryResult<GetTotalRevenueForClinicBetweenTimesQuery, GetTotalRevenueForClinicBetweenTimesQueryVariables>;
export const GetClinicOnboardingDocument = gql`
    query getClinicOnboarding($clinicId: ID!) {
  clinicOnboarding(clinicId: $clinicId) {
    ...ClinicOnboardingFields
  }
}
    ${ClinicOnboardingFieldsFragmentDoc}`;

/**
 * __useGetClinicOnboardingQuery__
 *
 * To run a query within a React component, call `useGetClinicOnboardingQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetClinicOnboardingQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetClinicOnboardingQuery({
 *   variables: {
 *      clinicId: // value for 'clinicId'
 *   },
 * });
 */
export function useGetClinicOnboardingQuery(baseOptions: Apollo.QueryHookOptions<GetClinicOnboardingQuery, GetClinicOnboardingQueryVariables> & ({ variables: GetClinicOnboardingQueryVariables; skip?: boolean; } | { skip: boolean; }) ) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<GetClinicOnboardingQuery, GetClinicOnboardingQueryVariables>(GetClinicOnboardingDocument, options);
      }
export function useGetClinicOnboardingLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<GetClinicOnboardingQuery, GetClinicOnboardingQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<GetClinicOnboardingQuery, GetClinicOnboardingQueryVariables>(GetClinicOnboardingDocument, options);
        }
export function useGetClinicOnboardingSuspenseQuery(baseOptions?: Apollo.SuspenseQueryHookOptions<GetClinicOnboardingQuery, GetClinicOnboardingQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useSuspenseQuery<GetClinicOnboardingQuery, GetClinicOnboardingQueryVariables>(GetClinicOnboardingDocument, options);
        }
export type GetClinicOnboardingQueryHookResult = ReturnType<typeof useGetClinicOnboardingQuery>;
export type GetClinicOnboardingLazyQueryHookResult = ReturnType<typeof useGetClinicOnboardingLazyQuery>;
export type GetClinicOnboardingSuspenseQueryHookResult = ReturnType<typeof useGetClinicOnboardingSuspenseQuery>;
export type GetClinicOnboardingQueryResult = Apollo.QueryResult<GetClinicOnboardingQuery, GetClinicOnboardingQueryVariables>;
export const GetOnboardingWizardProgressDocument = gql`
    query getOnboardingWizardProgress($clinicId: ID!) {
  clinicOnboarding(clinicId: $clinicId) {
    wizard_progress
  }
}
    `;

/**
 * __useGetOnboardingWizardProgressQuery__
 *
 * To run a query within a React component, call `useGetOnboardingWizardProgressQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetOnboardingWizardProgressQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetOnboardingWizardProgressQuery({
 *   variables: {
 *      clinicId: // value for 'clinicId'
 *   },
 * });
 */
export function useGetOnboardingWizardProgressQuery(baseOptions: Apollo.QueryHookOptions<GetOnboardingWizardProgressQuery, GetOnboardingWizardProgressQueryVariables> & ({ variables: GetOnboardingWizardProgressQueryVariables; skip?: boolean; } | { skip: boolean; }) ) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<GetOnboardingWizardProgressQuery, GetOnboardingWizardProgressQueryVariables>(GetOnboardingWizardProgressDocument, options);
      }
export function useGetOnboardingWizardProgressLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<GetOnboardingWizardProgressQuery, GetOnboardingWizardProgressQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<GetOnboardingWizardProgressQuery, GetOnboardingWizardProgressQueryVariables>(GetOnboardingWizardProgressDocument, options);
        }
export function useGetOnboardingWizardProgressSuspenseQuery(baseOptions?: Apollo.SuspenseQueryHookOptions<GetOnboardingWizardProgressQuery, GetOnboardingWizardProgressQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useSuspenseQuery<GetOnboardingWizardProgressQuery, GetOnboardingWizardProgressQueryVariables>(GetOnboardingWizardProgressDocument, options);
        }
export type GetOnboardingWizardProgressQueryHookResult = ReturnType<typeof useGetOnboardingWizardProgressQuery>;
export type GetOnboardingWizardProgressLazyQueryHookResult = ReturnType<typeof useGetOnboardingWizardProgressLazyQuery>;
export type GetOnboardingWizardProgressSuspenseQueryHookResult = ReturnType<typeof useGetOnboardingWizardProgressSuspenseQuery>;
export type GetOnboardingWizardProgressQueryResult = Apollo.QueryResult<GetOnboardingWizardProgressQuery, GetOnboardingWizardProgressQueryVariables>;
export const SaveOnboardingWizardProgressDocument = gql`
    mutation saveOnboardingWizardProgress($clinicId: ID!, $progress: JSON) {
  updateClinic(id: $clinicId, data: {onboarding: {wizard_progress: $progress}}) {
    id
  }
}
    `;
export type SaveOnboardingWizardProgressMutationFn = Apollo.MutationFunction<SaveOnboardingWizardProgressMutation, SaveOnboardingWizardProgressMutationVariables>;

/**
 * __useSaveOnboardingWizardProgressMutation__
 *
 * To run a mutation, you first call `useSaveOnboardingWizardProgressMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useSaveOnboardingWizardProgressMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [saveOnboardingWizardProgressMutation, { data, loading, error }] = useSaveOnboardingWizardProgressMutation({
 *   variables: {
 *      clinicId: // value for 'clinicId'
 *      progress: // value for 'progress'
 *   },
 * });
 */
export function useSaveOnboardingWizardProgressMutation(baseOptions?: Apollo.MutationHookOptions<SaveOnboardingWizardProgressMutation, SaveOnboardingWizardProgressMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<SaveOnboardingWizardProgressMutation, SaveOnboardingWizardProgressMutationVariables>(SaveOnboardingWizardProgressDocument, options);
      }
export type SaveOnboardingWizardProgressMutationHookResult = ReturnType<typeof useSaveOnboardingWizardProgressMutation>;
export type SaveOnboardingWizardProgressMutationResult = Apollo.MutationResult<SaveOnboardingWizardProgressMutation>;
export type SaveOnboardingWizardProgressMutationOptions = Apollo.BaseMutationOptions<SaveOnboardingWizardProgressMutation, SaveOnboardingWizardProgressMutationVariables>;
export const CreateClinicDocument = gql`
    mutation createClinic($data: CreateClinicInput!, $shouldCreateWidget: Boolean) {
  createClinic(data: $data, shouldCreateWidget: $shouldCreateWidget) {
    ...ClinicFields
  }
}
    ${ClinicFieldsFragmentDoc}`;
export type CreateClinicMutationFn = Apollo.MutationFunction<CreateClinicMutation, CreateClinicMutationVariables>;

/**
 * __useCreateClinicMutation__
 *
 * To run a mutation, you first call `useCreateClinicMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useCreateClinicMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [createClinicMutation, { data, loading, error }] = useCreateClinicMutation({
 *   variables: {
 *      data: // value for 'data'
 *      shouldCreateWidget: // value for 'shouldCreateWidget'
 *   },
 * });
 */
export function useCreateClinicMutation(baseOptions?: Apollo.MutationHookOptions<CreateClinicMutation, CreateClinicMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<CreateClinicMutation, CreateClinicMutationVariables>(CreateClinicDocument, options);
      }
export type CreateClinicMutationHookResult = ReturnType<typeof useCreateClinicMutation>;
export type CreateClinicMutationResult = Apollo.MutationResult<CreateClinicMutation>;
export type CreateClinicMutationOptions = Apollo.BaseMutationOptions<CreateClinicMutation, CreateClinicMutationVariables>;
export const SetClinicGoLiveDateDocument = gql`
    mutation setClinicGoLiveDate($clinicId: ID!, $goLiveDate: String) {
  setClinicGoLiveDate(clinicId: $clinicId, go_live_date: $goLiveDate)
}
    `;
export type SetClinicGoLiveDateMutationFn = Apollo.MutationFunction<SetClinicGoLiveDateMutation, SetClinicGoLiveDateMutationVariables>;

/**
 * __useSetClinicGoLiveDateMutation__
 *
 * To run a mutation, you first call `useSetClinicGoLiveDateMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useSetClinicGoLiveDateMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [setClinicGoLiveDateMutation, { data, loading, error }] = useSetClinicGoLiveDateMutation({
 *   variables: {
 *      clinicId: // value for 'clinicId'
 *      goLiveDate: // value for 'goLiveDate'
 *   },
 * });
 */
export function useSetClinicGoLiveDateMutation(baseOptions?: Apollo.MutationHookOptions<SetClinicGoLiveDateMutation, SetClinicGoLiveDateMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<SetClinicGoLiveDateMutation, SetClinicGoLiveDateMutationVariables>(SetClinicGoLiveDateDocument, options);
      }
export type SetClinicGoLiveDateMutationHookResult = ReturnType<typeof useSetClinicGoLiveDateMutation>;
export type SetClinicGoLiveDateMutationResult = Apollo.MutationResult<SetClinicGoLiveDateMutation>;
export type SetClinicGoLiveDateMutationOptions = Apollo.BaseMutationOptions<SetClinicGoLiveDateMutation, SetClinicGoLiveDateMutationVariables>;
export const UpdateClinicDocument = gql`
    mutation updateClinic($id: ID!, $data: UpdateClinicInput!) {
  updateClinic(id: $id, data: $data) {
    ...ClinicFields
  }
}
    ${ClinicFieldsFragmentDoc}`;
export type UpdateClinicMutationFn = Apollo.MutationFunction<UpdateClinicMutation, UpdateClinicMutationVariables>;

/**
 * __useUpdateClinicMutation__
 *
 * To run a mutation, you first call `useUpdateClinicMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useUpdateClinicMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [updateClinicMutation, { data, loading, error }] = useUpdateClinicMutation({
 *   variables: {
 *      id: // value for 'id'
 *      data: // value for 'data'
 *   },
 * });
 */
export function useUpdateClinicMutation(baseOptions?: Apollo.MutationHookOptions<UpdateClinicMutation, UpdateClinicMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<UpdateClinicMutation, UpdateClinicMutationVariables>(UpdateClinicDocument, options);
      }
export type UpdateClinicMutationHookResult = ReturnType<typeof useUpdateClinicMutation>;
export type UpdateClinicMutationResult = Apollo.MutationResult<UpdateClinicMutation>;
export type UpdateClinicMutationOptions = Apollo.BaseMutationOptions<UpdateClinicMutation, UpdateClinicMutationVariables>;
export const DeleteClinicDocument = gql`
    mutation deleteClinic($id: ID!) {
  deleteClinic(id: $id)
}
    `;
export type DeleteClinicMutationFn = Apollo.MutationFunction<DeleteClinicMutation, DeleteClinicMutationVariables>;

/**
 * __useDeleteClinicMutation__
 *
 * To run a mutation, you first call `useDeleteClinicMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useDeleteClinicMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [deleteClinicMutation, { data, loading, error }] = useDeleteClinicMutation({
 *   variables: {
 *      id: // value for 'id'
 *   },
 * });
 */
export function useDeleteClinicMutation(baseOptions?: Apollo.MutationHookOptions<DeleteClinicMutation, DeleteClinicMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<DeleteClinicMutation, DeleteClinicMutationVariables>(DeleteClinicDocument, options);
      }
export type DeleteClinicMutationHookResult = ReturnType<typeof useDeleteClinicMutation>;
export type DeleteClinicMutationResult = Apollo.MutationResult<DeleteClinicMutation>;
export type DeleteClinicMutationOptions = Apollo.BaseMutationOptions<DeleteClinicMutation, DeleteClinicMutationVariables>;
export const GetConnectInstallationDocument = gql`
    query getConnectInstallation($clinicId: ID!, $installationId: ID!) {
  connectInstallation(clinicId: $clinicId, installationId: $installationId) {
    ...ConnectInstallationFields
  }
}
    ${ConnectInstallationFieldsFragmentDoc}`;

/**
 * __useGetConnectInstallationQuery__
 *
 * To run a query within a React component, call `useGetConnectInstallationQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetConnectInstallationQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetConnectInstallationQuery({
 *   variables: {
 *      clinicId: // value for 'clinicId'
 *      installationId: // value for 'installationId'
 *   },
 * });
 */
export function useGetConnectInstallationQuery(baseOptions: Apollo.QueryHookOptions<GetConnectInstallationQuery, GetConnectInstallationQueryVariables> & ({ variables: GetConnectInstallationQueryVariables; skip?: boolean; } | { skip: boolean; }) ) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<GetConnectInstallationQuery, GetConnectInstallationQueryVariables>(GetConnectInstallationDocument, options);
      }
export function useGetConnectInstallationLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<GetConnectInstallationQuery, GetConnectInstallationQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<GetConnectInstallationQuery, GetConnectInstallationQueryVariables>(GetConnectInstallationDocument, options);
        }
export function useGetConnectInstallationSuspenseQuery(baseOptions?: Apollo.SuspenseQueryHookOptions<GetConnectInstallationQuery, GetConnectInstallationQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useSuspenseQuery<GetConnectInstallationQuery, GetConnectInstallationQueryVariables>(GetConnectInstallationDocument, options);
        }
export type GetConnectInstallationQueryHookResult = ReturnType<typeof useGetConnectInstallationQuery>;
export type GetConnectInstallationLazyQueryHookResult = ReturnType<typeof useGetConnectInstallationLazyQuery>;
export type GetConnectInstallationSuspenseQueryHookResult = ReturnType<typeof useGetConnectInstallationSuspenseQuery>;
export type GetConnectInstallationQueryResult = Apollo.QueryResult<GetConnectInstallationQuery, GetConnectInstallationQueryVariables>;
export const GetConnectInstallationsByClinicDocument = gql`
    query getConnectInstallationsByClinic($clinicId: ID!) {
  getConnectInstallationsByClinic(clinicId: $clinicId) {
    ...ConnectInstallationFields
  }
}
    ${ConnectInstallationFieldsFragmentDoc}`;

/**
 * __useGetConnectInstallationsByClinicQuery__
 *
 * To run a query within a React component, call `useGetConnectInstallationsByClinicQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetConnectInstallationsByClinicQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetConnectInstallationsByClinicQuery({
 *   variables: {
 *      clinicId: // value for 'clinicId'
 *   },
 * });
 */
export function useGetConnectInstallationsByClinicQuery(baseOptions: Apollo.QueryHookOptions<GetConnectInstallationsByClinicQuery, GetConnectInstallationsByClinicQueryVariables> & ({ variables: GetConnectInstallationsByClinicQueryVariables; skip?: boolean; } | { skip: boolean; }) ) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<GetConnectInstallationsByClinicQuery, GetConnectInstallationsByClinicQueryVariables>(GetConnectInstallationsByClinicDocument, options);
      }
export function useGetConnectInstallationsByClinicLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<GetConnectInstallationsByClinicQuery, GetConnectInstallationsByClinicQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<GetConnectInstallationsByClinicQuery, GetConnectInstallationsByClinicQueryVariables>(GetConnectInstallationsByClinicDocument, options);
        }
export function useGetConnectInstallationsByClinicSuspenseQuery(baseOptions?: Apollo.SuspenseQueryHookOptions<GetConnectInstallationsByClinicQuery, GetConnectInstallationsByClinicQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useSuspenseQuery<GetConnectInstallationsByClinicQuery, GetConnectInstallationsByClinicQueryVariables>(GetConnectInstallationsByClinicDocument, options);
        }
export type GetConnectInstallationsByClinicQueryHookResult = ReturnType<typeof useGetConnectInstallationsByClinicQuery>;
export type GetConnectInstallationsByClinicLazyQueryHookResult = ReturnType<typeof useGetConnectInstallationsByClinicLazyQuery>;
export type GetConnectInstallationsByClinicSuspenseQueryHookResult = ReturnType<typeof useGetConnectInstallationsByClinicSuspenseQuery>;
export type GetConnectInstallationsByClinicQueryResult = Apollo.QueryResult<GetConnectInstallationsByClinicQuery, GetConnectInstallationsByClinicQueryVariables>;
export const CheckIfServerRunningDocument = gql`
    query checkIfServerRunning($clinicId: ID!) {
  checkIfServerRunning(clinicId: $clinicId)
}
    `;

/**
 * __useCheckIfServerRunningQuery__
 *
 * To run a query within a React component, call `useCheckIfServerRunningQuery` and pass it any options that fit your needs.
 * When your component renders, `useCheckIfServerRunningQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useCheckIfServerRunningQuery({
 *   variables: {
 *      clinicId: // value for 'clinicId'
 *   },
 * });
 */
export function useCheckIfServerRunningQuery(baseOptions: Apollo.QueryHookOptions<CheckIfServerRunningQuery, CheckIfServerRunningQueryVariables> & ({ variables: CheckIfServerRunningQueryVariables; skip?: boolean; } | { skip: boolean; }) ) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<CheckIfServerRunningQuery, CheckIfServerRunningQueryVariables>(CheckIfServerRunningDocument, options);
      }
export function useCheckIfServerRunningLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<CheckIfServerRunningQuery, CheckIfServerRunningQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<CheckIfServerRunningQuery, CheckIfServerRunningQueryVariables>(CheckIfServerRunningDocument, options);
        }
export function useCheckIfServerRunningSuspenseQuery(baseOptions?: Apollo.SuspenseQueryHookOptions<CheckIfServerRunningQuery, CheckIfServerRunningQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useSuspenseQuery<CheckIfServerRunningQuery, CheckIfServerRunningQueryVariables>(CheckIfServerRunningDocument, options);
        }
export type CheckIfServerRunningQueryHookResult = ReturnType<typeof useCheckIfServerRunningQuery>;
export type CheckIfServerRunningLazyQueryHookResult = ReturnType<typeof useCheckIfServerRunningLazyQuery>;
export type CheckIfServerRunningSuspenseQueryHookResult = ReturnType<typeof useCheckIfServerRunningSuspenseQuery>;
export type CheckIfServerRunningQueryResult = Apollo.QueryResult<CheckIfServerRunningQuery, CheckIfServerRunningQueryVariables>;
export const GetLastServerHeartbeatForClinicDocument = gql`
    query getLastServerHeartbeatForClinic($clinicId: ID!) {
  getLastServerHeartbeatForClinic(clinicId: $clinicId) {
    version
    last_ping
  }
}
    `;

/**
 * __useGetLastServerHeartbeatForClinicQuery__
 *
 * To run a query within a React component, call `useGetLastServerHeartbeatForClinicQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetLastServerHeartbeatForClinicQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetLastServerHeartbeatForClinicQuery({
 *   variables: {
 *      clinicId: // value for 'clinicId'
 *   },
 * });
 */
export function useGetLastServerHeartbeatForClinicQuery(baseOptions: Apollo.QueryHookOptions<GetLastServerHeartbeatForClinicQuery, GetLastServerHeartbeatForClinicQueryVariables> & ({ variables: GetLastServerHeartbeatForClinicQueryVariables; skip?: boolean; } | { skip: boolean; }) ) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<GetLastServerHeartbeatForClinicQuery, GetLastServerHeartbeatForClinicQueryVariables>(GetLastServerHeartbeatForClinicDocument, options);
      }
export function useGetLastServerHeartbeatForClinicLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<GetLastServerHeartbeatForClinicQuery, GetLastServerHeartbeatForClinicQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<GetLastServerHeartbeatForClinicQuery, GetLastServerHeartbeatForClinicQueryVariables>(GetLastServerHeartbeatForClinicDocument, options);
        }
export function useGetLastServerHeartbeatForClinicSuspenseQuery(baseOptions?: Apollo.SuspenseQueryHookOptions<GetLastServerHeartbeatForClinicQuery, GetLastServerHeartbeatForClinicQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useSuspenseQuery<GetLastServerHeartbeatForClinicQuery, GetLastServerHeartbeatForClinicQueryVariables>(GetLastServerHeartbeatForClinicDocument, options);
        }
export type GetLastServerHeartbeatForClinicQueryHookResult = ReturnType<typeof useGetLastServerHeartbeatForClinicQuery>;
export type GetLastServerHeartbeatForClinicLazyQueryHookResult = ReturnType<typeof useGetLastServerHeartbeatForClinicLazyQuery>;
export type GetLastServerHeartbeatForClinicSuspenseQueryHookResult = ReturnType<typeof useGetLastServerHeartbeatForClinicSuspenseQuery>;
export type GetLastServerHeartbeatForClinicQueryResult = Apollo.QueryResult<GetLastServerHeartbeatForClinicQuery, GetLastServerHeartbeatForClinicQueryVariables>;
export const TriggerServiceUpdateDocument = gql`
    mutation triggerServiceUpdate($clinicId: ID!) {
  triggerServiceUpdateForClinic(clinicId: $clinicId)
}
    `;
export type TriggerServiceUpdateMutationFn = Apollo.MutationFunction<TriggerServiceUpdateMutation, TriggerServiceUpdateMutationVariables>;

/**
 * __useTriggerServiceUpdateMutation__
 *
 * To run a mutation, you first call `useTriggerServiceUpdateMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useTriggerServiceUpdateMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [triggerServiceUpdateMutation, { data, loading, error }] = useTriggerServiceUpdateMutation({
 *   variables: {
 *      clinicId: // value for 'clinicId'
 *   },
 * });
 */
export function useTriggerServiceUpdateMutation(baseOptions?: Apollo.MutationHookOptions<TriggerServiceUpdateMutation, TriggerServiceUpdateMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<TriggerServiceUpdateMutation, TriggerServiceUpdateMutationVariables>(TriggerServiceUpdateDocument, options);
      }
export type TriggerServiceUpdateMutationHookResult = ReturnType<typeof useTriggerServiceUpdateMutation>;
export type TriggerServiceUpdateMutationResult = Apollo.MutationResult<TriggerServiceUpdateMutation>;
export type TriggerServiceUpdateMutationOptions = Apollo.BaseMutationOptions<TriggerServiceUpdateMutation, TriggerServiceUpdateMutationVariables>;
export const CreateConnectInstallationDocument = gql`
    mutation createConnectInstallation($clinicId: ID!, $installationId: ID!, $data: CreateConnectInstallationInput!) {
  createConnectInstallation(
    clinicId: $clinicId
    installationId: $installationId
    data: $data
  ) {
    ...ConnectInstallationFields
  }
}
    ${ConnectInstallationFieldsFragmentDoc}`;
export type CreateConnectInstallationMutationFn = Apollo.MutationFunction<CreateConnectInstallationMutation, CreateConnectInstallationMutationVariables>;

/**
 * __useCreateConnectInstallationMutation__
 *
 * To run a mutation, you first call `useCreateConnectInstallationMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useCreateConnectInstallationMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [createConnectInstallationMutation, { data, loading, error }] = useCreateConnectInstallationMutation({
 *   variables: {
 *      clinicId: // value for 'clinicId'
 *      installationId: // value for 'installationId'
 *      data: // value for 'data'
 *   },
 * });
 */
export function useCreateConnectInstallationMutation(baseOptions?: Apollo.MutationHookOptions<CreateConnectInstallationMutation, CreateConnectInstallationMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<CreateConnectInstallationMutation, CreateConnectInstallationMutationVariables>(CreateConnectInstallationDocument, options);
      }
export type CreateConnectInstallationMutationHookResult = ReturnType<typeof useCreateConnectInstallationMutation>;
export type CreateConnectInstallationMutationResult = Apollo.MutationResult<CreateConnectInstallationMutation>;
export type CreateConnectInstallationMutationOptions = Apollo.BaseMutationOptions<CreateConnectInstallationMutation, CreateConnectInstallationMutationVariables>;
export const UpdateConnectInstallationDocument = gql`
    mutation updateConnectInstallation($clinicId: ID!, $installationId: ID!, $data: UpdateConnectInstallationInput!) {
  updateConnectInstallation(
    clinicId: $clinicId
    installationId: $installationId
    data: $data
  ) {
    ...ConnectInstallationFields
  }
}
    ${ConnectInstallationFieldsFragmentDoc}`;
export type UpdateConnectInstallationMutationFn = Apollo.MutationFunction<UpdateConnectInstallationMutation, UpdateConnectInstallationMutationVariables>;

/**
 * __useUpdateConnectInstallationMutation__
 *
 * To run a mutation, you first call `useUpdateConnectInstallationMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useUpdateConnectInstallationMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [updateConnectInstallationMutation, { data, loading, error }] = useUpdateConnectInstallationMutation({
 *   variables: {
 *      clinicId: // value for 'clinicId'
 *      installationId: // value for 'installationId'
 *      data: // value for 'data'
 *   },
 * });
 */
export function useUpdateConnectInstallationMutation(baseOptions?: Apollo.MutationHookOptions<UpdateConnectInstallationMutation, UpdateConnectInstallationMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<UpdateConnectInstallationMutation, UpdateConnectInstallationMutationVariables>(UpdateConnectInstallationDocument, options);
      }
export type UpdateConnectInstallationMutationHookResult = ReturnType<typeof useUpdateConnectInstallationMutation>;
export type UpdateConnectInstallationMutationResult = Apollo.MutationResult<UpdateConnectInstallationMutation>;
export type UpdateConnectInstallationMutationOptions = Apollo.BaseMutationOptions<UpdateConnectInstallationMutation, UpdateConnectInstallationMutationVariables>;
export const DeleteConnectInstallationDocument = gql`
    mutation deleteConnectInstallation($clinicId: ID!, $installationId: ID!) {
  deleteConnectInstallation(clinicId: $clinicId, installationId: $installationId)
}
    `;
export type DeleteConnectInstallationMutationFn = Apollo.MutationFunction<DeleteConnectInstallationMutation, DeleteConnectInstallationMutationVariables>;

/**
 * __useDeleteConnectInstallationMutation__
 *
 * To run a mutation, you first call `useDeleteConnectInstallationMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useDeleteConnectInstallationMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [deleteConnectInstallationMutation, { data, loading, error }] = useDeleteConnectInstallationMutation({
 *   variables: {
 *      clinicId: // value for 'clinicId'
 *      installationId: // value for 'installationId'
 *   },
 * });
 */
export function useDeleteConnectInstallationMutation(baseOptions?: Apollo.MutationHookOptions<DeleteConnectInstallationMutation, DeleteConnectInstallationMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<DeleteConnectInstallationMutation, DeleteConnectInstallationMutationVariables>(DeleteConnectInstallationDocument, options);
      }
export type DeleteConnectInstallationMutationHookResult = ReturnType<typeof useDeleteConnectInstallationMutation>;
export type DeleteConnectInstallationMutationResult = Apollo.MutationResult<DeleteConnectInstallationMutation>;
export type DeleteConnectInstallationMutationOptions = Apollo.BaseMutationOptions<DeleteConnectInstallationMutation, DeleteConnectInstallationMutationVariables>;
export const CustomRoleDocument = gql`
    query customRole($id: ID!) {
  customRole(id: $id) {
    ...CustomRoleWithRelationsFields
  }
}
    ${CustomRoleWithRelationsFieldsFragmentDoc}`;

/**
 * __useCustomRoleQuery__
 *
 * To run a query within a React component, call `useCustomRoleQuery` and pass it any options that fit your needs.
 * When your component renders, `useCustomRoleQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useCustomRoleQuery({
 *   variables: {
 *      id: // value for 'id'
 *   },
 * });
 */
export function useCustomRoleQuery(baseOptions: Apollo.QueryHookOptions<CustomRoleQuery, CustomRoleQueryVariables> & ({ variables: CustomRoleQueryVariables; skip?: boolean; } | { skip: boolean; }) ) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<CustomRoleQuery, CustomRoleQueryVariables>(CustomRoleDocument, options);
      }
export function useCustomRoleLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<CustomRoleQuery, CustomRoleQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<CustomRoleQuery, CustomRoleQueryVariables>(CustomRoleDocument, options);
        }
export function useCustomRoleSuspenseQuery(baseOptions?: Apollo.SuspenseQueryHookOptions<CustomRoleQuery, CustomRoleQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useSuspenseQuery<CustomRoleQuery, CustomRoleQueryVariables>(CustomRoleDocument, options);
        }
export type CustomRoleQueryHookResult = ReturnType<typeof useCustomRoleQuery>;
export type CustomRoleLazyQueryHookResult = ReturnType<typeof useCustomRoleLazyQuery>;
export type CustomRoleSuspenseQueryHookResult = ReturnType<typeof useCustomRoleSuspenseQuery>;
export type CustomRoleQueryResult = Apollo.QueryResult<CustomRoleQuery, CustomRoleQueryVariables>;
export const GetCustomRolesByClinicDocument = gql`
    query getCustomRolesByClinic($clinicId: ID!) {
  getCustomRolesByClinic(clinicId: $clinicId) {
    ...CustomRoleFields
  }
}
    ${CustomRoleFieldsFragmentDoc}`;

/**
 * __useGetCustomRolesByClinicQuery__
 *
 * To run a query within a React component, call `useGetCustomRolesByClinicQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetCustomRolesByClinicQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetCustomRolesByClinicQuery({
 *   variables: {
 *      clinicId: // value for 'clinicId'
 *   },
 * });
 */
export function useGetCustomRolesByClinicQuery(baseOptions: Apollo.QueryHookOptions<GetCustomRolesByClinicQuery, GetCustomRolesByClinicQueryVariables> & ({ variables: GetCustomRolesByClinicQueryVariables; skip?: boolean; } | { skip: boolean; }) ) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<GetCustomRolesByClinicQuery, GetCustomRolesByClinicQueryVariables>(GetCustomRolesByClinicDocument, options);
      }
export function useGetCustomRolesByClinicLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<GetCustomRolesByClinicQuery, GetCustomRolesByClinicQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<GetCustomRolesByClinicQuery, GetCustomRolesByClinicQueryVariables>(GetCustomRolesByClinicDocument, options);
        }
export function useGetCustomRolesByClinicSuspenseQuery(baseOptions?: Apollo.SuspenseQueryHookOptions<GetCustomRolesByClinicQuery, GetCustomRolesByClinicQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useSuspenseQuery<GetCustomRolesByClinicQuery, GetCustomRolesByClinicQueryVariables>(GetCustomRolesByClinicDocument, options);
        }
export type GetCustomRolesByClinicQueryHookResult = ReturnType<typeof useGetCustomRolesByClinicQuery>;
export type GetCustomRolesByClinicLazyQueryHookResult = ReturnType<typeof useGetCustomRolesByClinicLazyQuery>;
export type GetCustomRolesByClinicSuspenseQueryHookResult = ReturnType<typeof useGetCustomRolesByClinicSuspenseQuery>;
export type GetCustomRolesByClinicQueryResult = Apollo.QueryResult<GetCustomRolesByClinicQuery, GetCustomRolesByClinicQueryVariables>;
export const GetCustomRolesByClinicGroupDocument = gql`
    query getCustomRolesByClinicGroup($clinicGroupId: ID!) {
  getCustomRolesByClinicGroup(clinicGroupId: $clinicGroupId) {
    ...CustomRoleFields
  }
}
    ${CustomRoleFieldsFragmentDoc}`;

/**
 * __useGetCustomRolesByClinicGroupQuery__
 *
 * To run a query within a React component, call `useGetCustomRolesByClinicGroupQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetCustomRolesByClinicGroupQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetCustomRolesByClinicGroupQuery({
 *   variables: {
 *      clinicGroupId: // value for 'clinicGroupId'
 *   },
 * });
 */
export function useGetCustomRolesByClinicGroupQuery(baseOptions: Apollo.QueryHookOptions<GetCustomRolesByClinicGroupQuery, GetCustomRolesByClinicGroupQueryVariables> & ({ variables: GetCustomRolesByClinicGroupQueryVariables; skip?: boolean; } | { skip: boolean; }) ) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<GetCustomRolesByClinicGroupQuery, GetCustomRolesByClinicGroupQueryVariables>(GetCustomRolesByClinicGroupDocument, options);
      }
export function useGetCustomRolesByClinicGroupLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<GetCustomRolesByClinicGroupQuery, GetCustomRolesByClinicGroupQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<GetCustomRolesByClinicGroupQuery, GetCustomRolesByClinicGroupQueryVariables>(GetCustomRolesByClinicGroupDocument, options);
        }
export function useGetCustomRolesByClinicGroupSuspenseQuery(baseOptions?: Apollo.SuspenseQueryHookOptions<GetCustomRolesByClinicGroupQuery, GetCustomRolesByClinicGroupQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useSuspenseQuery<GetCustomRolesByClinicGroupQuery, GetCustomRolesByClinicGroupQueryVariables>(GetCustomRolesByClinicGroupDocument, options);
        }
export type GetCustomRolesByClinicGroupQueryHookResult = ReturnType<typeof useGetCustomRolesByClinicGroupQuery>;
export type GetCustomRolesByClinicGroupLazyQueryHookResult = ReturnType<typeof useGetCustomRolesByClinicGroupLazyQuery>;
export type GetCustomRolesByClinicGroupSuspenseQueryHookResult = ReturnType<typeof useGetCustomRolesByClinicGroupSuspenseQuery>;
export type GetCustomRolesByClinicGroupQueryResult = Apollo.QueryResult<GetCustomRolesByClinicGroupQuery, GetCustomRolesByClinicGroupQueryVariables>;
export const CreateCustomRoleDocument = gql`
    mutation createCustomRole($data: CreateCustomRoleInput!) {
  createCustomRole(data: $data) {
    ...CustomRoleFields
  }
}
    ${CustomRoleFieldsFragmentDoc}`;
export type CreateCustomRoleMutationFn = Apollo.MutationFunction<CreateCustomRoleMutation, CreateCustomRoleMutationVariables>;

/**
 * __useCreateCustomRoleMutation__
 *
 * To run a mutation, you first call `useCreateCustomRoleMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useCreateCustomRoleMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [createCustomRoleMutation, { data, loading, error }] = useCreateCustomRoleMutation({
 *   variables: {
 *      data: // value for 'data'
 *   },
 * });
 */
export function useCreateCustomRoleMutation(baseOptions?: Apollo.MutationHookOptions<CreateCustomRoleMutation, CreateCustomRoleMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<CreateCustomRoleMutation, CreateCustomRoleMutationVariables>(CreateCustomRoleDocument, options);
      }
export type CreateCustomRoleMutationHookResult = ReturnType<typeof useCreateCustomRoleMutation>;
export type CreateCustomRoleMutationResult = Apollo.MutationResult<CreateCustomRoleMutation>;
export type CreateCustomRoleMutationOptions = Apollo.BaseMutationOptions<CreateCustomRoleMutation, CreateCustomRoleMutationVariables>;
export const UpdateCustomRoleDocument = gql`
    mutation updateCustomRole($id: ID!, $data: UpdateCustomRoleInput!) {
  updateCustomRole(id: $id, data: $data) {
    ...CustomRoleFields
  }
}
    ${CustomRoleFieldsFragmentDoc}`;
export type UpdateCustomRoleMutationFn = Apollo.MutationFunction<UpdateCustomRoleMutation, UpdateCustomRoleMutationVariables>;

/**
 * __useUpdateCustomRoleMutation__
 *
 * To run a mutation, you first call `useUpdateCustomRoleMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useUpdateCustomRoleMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [updateCustomRoleMutation, { data, loading, error }] = useUpdateCustomRoleMutation({
 *   variables: {
 *      id: // value for 'id'
 *      data: // value for 'data'
 *   },
 * });
 */
export function useUpdateCustomRoleMutation(baseOptions?: Apollo.MutationHookOptions<UpdateCustomRoleMutation, UpdateCustomRoleMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<UpdateCustomRoleMutation, UpdateCustomRoleMutationVariables>(UpdateCustomRoleDocument, options);
      }
export type UpdateCustomRoleMutationHookResult = ReturnType<typeof useUpdateCustomRoleMutation>;
export type UpdateCustomRoleMutationResult = Apollo.MutationResult<UpdateCustomRoleMutation>;
export type UpdateCustomRoleMutationOptions = Apollo.BaseMutationOptions<UpdateCustomRoleMutation, UpdateCustomRoleMutationVariables>;
export const DeleteCustomRoleDocument = gql`
    mutation deleteCustomRole($id: ID!) {
  deleteCustomRole(id: $id)
}
    `;
export type DeleteCustomRoleMutationFn = Apollo.MutationFunction<DeleteCustomRoleMutation, DeleteCustomRoleMutationVariables>;

/**
 * __useDeleteCustomRoleMutation__
 *
 * To run a mutation, you first call `useDeleteCustomRoleMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useDeleteCustomRoleMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [deleteCustomRoleMutation, { data, loading, error }] = useDeleteCustomRoleMutation({
 *   variables: {
 *      id: // value for 'id'
 *   },
 * });
 */
export function useDeleteCustomRoleMutation(baseOptions?: Apollo.MutationHookOptions<DeleteCustomRoleMutation, DeleteCustomRoleMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<DeleteCustomRoleMutation, DeleteCustomRoleMutationVariables>(DeleteCustomRoleDocument, options);
      }
export type DeleteCustomRoleMutationHookResult = ReturnType<typeof useDeleteCustomRoleMutation>;
export type DeleteCustomRoleMutationResult = Apollo.MutationResult<DeleteCustomRoleMutation>;
export type DeleteCustomRoleMutationOptions = Apollo.BaseMutationOptions<DeleteCustomRoleMutation, DeleteCustomRoleMutationVariables>;
export const CustomerSegmentDocument = gql`
    query customerSegment($id: ID!) {
  customerSegment(id: $id) {
    ...CustomerSegmentFields
  }
}
    ${CustomerSegmentFieldsFragmentDoc}`;

/**
 * __useCustomerSegmentQuery__
 *
 * To run a query within a React component, call `useCustomerSegmentQuery` and pass it any options that fit your needs.
 * When your component renders, `useCustomerSegmentQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useCustomerSegmentQuery({
 *   variables: {
 *      id: // value for 'id'
 *   },
 * });
 */
export function useCustomerSegmentQuery(baseOptions: Apollo.QueryHookOptions<CustomerSegmentQuery, CustomerSegmentQueryVariables> & ({ variables: CustomerSegmentQueryVariables; skip?: boolean; } | { skip: boolean; }) ) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<CustomerSegmentQuery, CustomerSegmentQueryVariables>(CustomerSegmentDocument, options);
      }
export function useCustomerSegmentLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<CustomerSegmentQuery, CustomerSegmentQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<CustomerSegmentQuery, CustomerSegmentQueryVariables>(CustomerSegmentDocument, options);
        }
export function useCustomerSegmentSuspenseQuery(baseOptions?: Apollo.SuspenseQueryHookOptions<CustomerSegmentQuery, CustomerSegmentQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useSuspenseQuery<CustomerSegmentQuery, CustomerSegmentQueryVariables>(CustomerSegmentDocument, options);
        }
export type CustomerSegmentQueryHookResult = ReturnType<typeof useCustomerSegmentQuery>;
export type CustomerSegmentLazyQueryHookResult = ReturnType<typeof useCustomerSegmentLazyQuery>;
export type CustomerSegmentSuspenseQueryHookResult = ReturnType<typeof useCustomerSegmentSuspenseQuery>;
export type CustomerSegmentQueryResult = Apollo.QueryResult<CustomerSegmentQuery, CustomerSegmentQueryVariables>;
export const GetCustomerSegmentsForClinicDocument = gql`
    query getCustomerSegmentsForClinic($clinicId: ID!, $page: NonNegativeInt, $pageSize: NonNegativeInt) {
  getCustomerSegmentsForClinic(
    clinicId: $clinicId
    page: $page
    pageSize: $pageSize
  ) {
    ...CustomerSegmentPreviewFields
  }
}
    ${CustomerSegmentPreviewFieldsFragmentDoc}`;

/**
 * __useGetCustomerSegmentsForClinicQuery__
 *
 * To run a query within a React component, call `useGetCustomerSegmentsForClinicQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetCustomerSegmentsForClinicQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetCustomerSegmentsForClinicQuery({
 *   variables: {
 *      clinicId: // value for 'clinicId'
 *      page: // value for 'page'
 *      pageSize: // value for 'pageSize'
 *   },
 * });
 */
export function useGetCustomerSegmentsForClinicQuery(baseOptions: Apollo.QueryHookOptions<GetCustomerSegmentsForClinicQuery, GetCustomerSegmentsForClinicQueryVariables> & ({ variables: GetCustomerSegmentsForClinicQueryVariables; skip?: boolean; } | { skip: boolean; }) ) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<GetCustomerSegmentsForClinicQuery, GetCustomerSegmentsForClinicQueryVariables>(GetCustomerSegmentsForClinicDocument, options);
      }
export function useGetCustomerSegmentsForClinicLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<GetCustomerSegmentsForClinicQuery, GetCustomerSegmentsForClinicQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<GetCustomerSegmentsForClinicQuery, GetCustomerSegmentsForClinicQueryVariables>(GetCustomerSegmentsForClinicDocument, options);
        }
export function useGetCustomerSegmentsForClinicSuspenseQuery(baseOptions?: Apollo.SuspenseQueryHookOptions<GetCustomerSegmentsForClinicQuery, GetCustomerSegmentsForClinicQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useSuspenseQuery<GetCustomerSegmentsForClinicQuery, GetCustomerSegmentsForClinicQueryVariables>(GetCustomerSegmentsForClinicDocument, options);
        }
export type GetCustomerSegmentsForClinicQueryHookResult = ReturnType<typeof useGetCustomerSegmentsForClinicQuery>;
export type GetCustomerSegmentsForClinicLazyQueryHookResult = ReturnType<typeof useGetCustomerSegmentsForClinicLazyQuery>;
export type GetCustomerSegmentsForClinicSuspenseQueryHookResult = ReturnType<typeof useGetCustomerSegmentsForClinicSuspenseQuery>;
export type GetCustomerSegmentsForClinicQueryResult = Apollo.QueryResult<GetCustomerSegmentsForClinicQuery, GetCustomerSegmentsForClinicQueryVariables>;
export const QueryCustomerSegmentsDocument = gql`
    query queryCustomerSegments($where: [QueryInput!], $page: NonNegativeInt, $pageSize: NonNegativeInt, $orderBy: OrderByInput) {
  queryCustomerSegments(
    where: $where
    page: $page
    pageSize: $pageSize
    orderBy: $orderBy
  ) {
    ...CustomerSegmentPreviewFields
  }
}
    ${CustomerSegmentPreviewFieldsFragmentDoc}`;

/**
 * __useQueryCustomerSegmentsQuery__
 *
 * To run a query within a React component, call `useQueryCustomerSegmentsQuery` and pass it any options that fit your needs.
 * When your component renders, `useQueryCustomerSegmentsQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useQueryCustomerSegmentsQuery({
 *   variables: {
 *      where: // value for 'where'
 *      page: // value for 'page'
 *      pageSize: // value for 'pageSize'
 *      orderBy: // value for 'orderBy'
 *   },
 * });
 */
export function useQueryCustomerSegmentsQuery(baseOptions?: Apollo.QueryHookOptions<QueryCustomerSegmentsQuery, QueryCustomerSegmentsQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<QueryCustomerSegmentsQuery, QueryCustomerSegmentsQueryVariables>(QueryCustomerSegmentsDocument, options);
      }
export function useQueryCustomerSegmentsLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<QueryCustomerSegmentsQuery, QueryCustomerSegmentsQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<QueryCustomerSegmentsQuery, QueryCustomerSegmentsQueryVariables>(QueryCustomerSegmentsDocument, options);
        }
export function useQueryCustomerSegmentsSuspenseQuery(baseOptions?: Apollo.SuspenseQueryHookOptions<QueryCustomerSegmentsQuery, QueryCustomerSegmentsQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useSuspenseQuery<QueryCustomerSegmentsQuery, QueryCustomerSegmentsQueryVariables>(QueryCustomerSegmentsDocument, options);
        }
export type QueryCustomerSegmentsQueryHookResult = ReturnType<typeof useQueryCustomerSegmentsQuery>;
export type QueryCustomerSegmentsLazyQueryHookResult = ReturnType<typeof useQueryCustomerSegmentsLazyQuery>;
export type QueryCustomerSegmentsSuspenseQueryHookResult = ReturnType<typeof useQueryCustomerSegmentsSuspenseQuery>;
export type QueryCustomerSegmentsQueryResult = Apollo.QueryResult<QueryCustomerSegmentsQuery, QueryCustomerSegmentsQueryVariables>;
export const GetClientsByCustomerSegmentRpcDocument = gql`
    query getClientsByCustomerSegmentRPC($id: ID!, $page: NonNegativeInt, $pageSize: NonNegativeInt, $notificationTemplateId: ID, $startingDateOverride: NonNegativeInt) {
  getClientsByCustomerSegmentRPC(
    id: $id
    page: $page
    pageSize: $pageSize
    notificationTemplateId: $notificationTemplateId
    startingDateOverride: $startingDateOverride
  ) {
    results {
      ...CustomerSegmentResultFields
    }
    count
  }
}
    ${CustomerSegmentResultFieldsFragmentDoc}`;

/**
 * __useGetClientsByCustomerSegmentRpcQuery__
 *
 * To run a query within a React component, call `useGetClientsByCustomerSegmentRpcQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetClientsByCustomerSegmentRpcQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetClientsByCustomerSegmentRpcQuery({
 *   variables: {
 *      id: // value for 'id'
 *      page: // value for 'page'
 *      pageSize: // value for 'pageSize'
 *      notificationTemplateId: // value for 'notificationTemplateId'
 *      startingDateOverride: // value for 'startingDateOverride'
 *   },
 * });
 */
export function useGetClientsByCustomerSegmentRpcQuery(baseOptions: Apollo.QueryHookOptions<GetClientsByCustomerSegmentRpcQuery, GetClientsByCustomerSegmentRpcQueryVariables> & ({ variables: GetClientsByCustomerSegmentRpcQueryVariables; skip?: boolean; } | { skip: boolean; }) ) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<GetClientsByCustomerSegmentRpcQuery, GetClientsByCustomerSegmentRpcQueryVariables>(GetClientsByCustomerSegmentRpcDocument, options);
      }
export function useGetClientsByCustomerSegmentRpcLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<GetClientsByCustomerSegmentRpcQuery, GetClientsByCustomerSegmentRpcQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<GetClientsByCustomerSegmentRpcQuery, GetClientsByCustomerSegmentRpcQueryVariables>(GetClientsByCustomerSegmentRpcDocument, options);
        }
export function useGetClientsByCustomerSegmentRpcSuspenseQuery(baseOptions?: Apollo.SuspenseQueryHookOptions<GetClientsByCustomerSegmentRpcQuery, GetClientsByCustomerSegmentRpcQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useSuspenseQuery<GetClientsByCustomerSegmentRpcQuery, GetClientsByCustomerSegmentRpcQueryVariables>(GetClientsByCustomerSegmentRpcDocument, options);
        }
export type GetClientsByCustomerSegmentRpcQueryHookResult = ReturnType<typeof useGetClientsByCustomerSegmentRpcQuery>;
export type GetClientsByCustomerSegmentRpcLazyQueryHookResult = ReturnType<typeof useGetClientsByCustomerSegmentRpcLazyQuery>;
export type GetClientsByCustomerSegmentRpcSuspenseQueryHookResult = ReturnType<typeof useGetClientsByCustomerSegmentRpcSuspenseQuery>;
export type GetClientsByCustomerSegmentRpcQueryResult = Apollo.QueryResult<GetClientsByCustomerSegmentRpcQuery, GetClientsByCustomerSegmentRpcQueryVariables>;
export const CreateCustomerSegmentDocument = gql`
    mutation createCustomerSegment($data: CreateCustomerSegmentInput!) {
  createCustomerSegment(data: $data) {
    ...CustomerSegmentFields
  }
}
    ${CustomerSegmentFieldsFragmentDoc}`;
export type CreateCustomerSegmentMutationFn = Apollo.MutationFunction<CreateCustomerSegmentMutation, CreateCustomerSegmentMutationVariables>;

/**
 * __useCreateCustomerSegmentMutation__
 *
 * To run a mutation, you first call `useCreateCustomerSegmentMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useCreateCustomerSegmentMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [createCustomerSegmentMutation, { data, loading, error }] = useCreateCustomerSegmentMutation({
 *   variables: {
 *      data: // value for 'data'
 *   },
 * });
 */
export function useCreateCustomerSegmentMutation(baseOptions?: Apollo.MutationHookOptions<CreateCustomerSegmentMutation, CreateCustomerSegmentMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<CreateCustomerSegmentMutation, CreateCustomerSegmentMutationVariables>(CreateCustomerSegmentDocument, options);
      }
export type CreateCustomerSegmentMutationHookResult = ReturnType<typeof useCreateCustomerSegmentMutation>;
export type CreateCustomerSegmentMutationResult = Apollo.MutationResult<CreateCustomerSegmentMutation>;
export type CreateCustomerSegmentMutationOptions = Apollo.BaseMutationOptions<CreateCustomerSegmentMutation, CreateCustomerSegmentMutationVariables>;
export const UpdateCustomerSegmentDocument = gql`
    mutation updateCustomerSegment($id: ID!, $data: UpdateCustomerSegmentInput!) {
  updateCustomerSegment(id: $id, data: $data) {
    ...CustomerSegmentFields
  }
}
    ${CustomerSegmentFieldsFragmentDoc}`;
export type UpdateCustomerSegmentMutationFn = Apollo.MutationFunction<UpdateCustomerSegmentMutation, UpdateCustomerSegmentMutationVariables>;

/**
 * __useUpdateCustomerSegmentMutation__
 *
 * To run a mutation, you first call `useUpdateCustomerSegmentMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useUpdateCustomerSegmentMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [updateCustomerSegmentMutation, { data, loading, error }] = useUpdateCustomerSegmentMutation({
 *   variables: {
 *      id: // value for 'id'
 *      data: // value for 'data'
 *   },
 * });
 */
export function useUpdateCustomerSegmentMutation(baseOptions?: Apollo.MutationHookOptions<UpdateCustomerSegmentMutation, UpdateCustomerSegmentMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<UpdateCustomerSegmentMutation, UpdateCustomerSegmentMutationVariables>(UpdateCustomerSegmentDocument, options);
      }
export type UpdateCustomerSegmentMutationHookResult = ReturnType<typeof useUpdateCustomerSegmentMutation>;
export type UpdateCustomerSegmentMutationResult = Apollo.MutationResult<UpdateCustomerSegmentMutation>;
export type UpdateCustomerSegmentMutationOptions = Apollo.BaseMutationOptions<UpdateCustomerSegmentMutation, UpdateCustomerSegmentMutationVariables>;
export const ArchiveCustomerSegmentDocument = gql`
    mutation archiveCustomerSegment($id: ID!) {
  archiveCustomerSegment(id: $id) {
    ...CustomerSegmentFields
  }
}
    ${CustomerSegmentFieldsFragmentDoc}`;
export type ArchiveCustomerSegmentMutationFn = Apollo.MutationFunction<ArchiveCustomerSegmentMutation, ArchiveCustomerSegmentMutationVariables>;

/**
 * __useArchiveCustomerSegmentMutation__
 *
 * To run a mutation, you first call `useArchiveCustomerSegmentMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useArchiveCustomerSegmentMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [archiveCustomerSegmentMutation, { data, loading, error }] = useArchiveCustomerSegmentMutation({
 *   variables: {
 *      id: // value for 'id'
 *   },
 * });
 */
export function useArchiveCustomerSegmentMutation(baseOptions?: Apollo.MutationHookOptions<ArchiveCustomerSegmentMutation, ArchiveCustomerSegmentMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<ArchiveCustomerSegmentMutation, ArchiveCustomerSegmentMutationVariables>(ArchiveCustomerSegmentDocument, options);
      }
export type ArchiveCustomerSegmentMutationHookResult = ReturnType<typeof useArchiveCustomerSegmentMutation>;
export type ArchiveCustomerSegmentMutationResult = Apollo.MutationResult<ArchiveCustomerSegmentMutation>;
export type ArchiveCustomerSegmentMutationOptions = Apollo.BaseMutationOptions<ArchiveCustomerSegmentMutation, ArchiveCustomerSegmentMutationVariables>;
export const DeleteCustomerSegmentDocument = gql`
    mutation deleteCustomerSegment($id: ID!) {
  deleteCustomerSegment(id: $id)
}
    `;
export type DeleteCustomerSegmentMutationFn = Apollo.MutationFunction<DeleteCustomerSegmentMutation, DeleteCustomerSegmentMutationVariables>;

/**
 * __useDeleteCustomerSegmentMutation__
 *
 * To run a mutation, you first call `useDeleteCustomerSegmentMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useDeleteCustomerSegmentMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [deleteCustomerSegmentMutation, { data, loading, error }] = useDeleteCustomerSegmentMutation({
 *   variables: {
 *      id: // value for 'id'
 *   },
 * });
 */
export function useDeleteCustomerSegmentMutation(baseOptions?: Apollo.MutationHookOptions<DeleteCustomerSegmentMutation, DeleteCustomerSegmentMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<DeleteCustomerSegmentMutation, DeleteCustomerSegmentMutationVariables>(DeleteCustomerSegmentDocument, options);
      }
export type DeleteCustomerSegmentMutationHookResult = ReturnType<typeof useDeleteCustomerSegmentMutation>;
export type DeleteCustomerSegmentMutationResult = Apollo.MutationResult<DeleteCustomerSegmentMutation>;
export type DeleteCustomerSegmentMutationOptions = Apollo.BaseMutationOptions<DeleteCustomerSegmentMutation, DeleteCustomerSegmentMutationVariables>;
export const CopyCustomerSegmentAcrossClinicDocument = gql`
    mutation copyCustomerSegmentAcrossClinic($id: ID!, $destinationClinicId: ID!) {
  copyCustomerSegmentAcrossClinic(
    id: $id
    destinationClinicId: $destinationClinicId
  ) {
    ...CustomerSegmentFields
  }
}
    ${CustomerSegmentFieldsFragmentDoc}`;
export type CopyCustomerSegmentAcrossClinicMutationFn = Apollo.MutationFunction<CopyCustomerSegmentAcrossClinicMutation, CopyCustomerSegmentAcrossClinicMutationVariables>;

/**
 * __useCopyCustomerSegmentAcrossClinicMutation__
 *
 * To run a mutation, you first call `useCopyCustomerSegmentAcrossClinicMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useCopyCustomerSegmentAcrossClinicMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [copyCustomerSegmentAcrossClinicMutation, { data, loading, error }] = useCopyCustomerSegmentAcrossClinicMutation({
 *   variables: {
 *      id: // value for 'id'
 *      destinationClinicId: // value for 'destinationClinicId'
 *   },
 * });
 */
export function useCopyCustomerSegmentAcrossClinicMutation(baseOptions?: Apollo.MutationHookOptions<CopyCustomerSegmentAcrossClinicMutation, CopyCustomerSegmentAcrossClinicMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<CopyCustomerSegmentAcrossClinicMutation, CopyCustomerSegmentAcrossClinicMutationVariables>(CopyCustomerSegmentAcrossClinicDocument, options);
      }
export type CopyCustomerSegmentAcrossClinicMutationHookResult = ReturnType<typeof useCopyCustomerSegmentAcrossClinicMutation>;
export type CopyCustomerSegmentAcrossClinicMutationResult = Apollo.MutationResult<CopyCustomerSegmentAcrossClinicMutation>;
export type CopyCustomerSegmentAcrossClinicMutationOptions = Apollo.BaseMutationOptions<CopyCustomerSegmentAcrossClinicMutation, CopyCustomerSegmentAcrossClinicMutationVariables>;
export const GetDailyHuddleDocument = gql`
    query getDailyHuddle($clinicId: ID!, $dailyHuddleId: ID!) {
  dailyHuddle(clinicId: $clinicId, dailyHuddleId: $dailyHuddleId) {
    ...DailyHuddleFields
  }
}
    ${DailyHuddleFieldsFragmentDoc}`;

/**
 * __useGetDailyHuddleQuery__
 *
 * To run a query within a React component, call `useGetDailyHuddleQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetDailyHuddleQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetDailyHuddleQuery({
 *   variables: {
 *      clinicId: // value for 'clinicId'
 *      dailyHuddleId: // value for 'dailyHuddleId'
 *   },
 * });
 */
export function useGetDailyHuddleQuery(baseOptions: Apollo.QueryHookOptions<GetDailyHuddleQuery, GetDailyHuddleQueryVariables> & ({ variables: GetDailyHuddleQueryVariables; skip?: boolean; } | { skip: boolean; }) ) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<GetDailyHuddleQuery, GetDailyHuddleQueryVariables>(GetDailyHuddleDocument, options);
      }
export function useGetDailyHuddleLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<GetDailyHuddleQuery, GetDailyHuddleQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<GetDailyHuddleQuery, GetDailyHuddleQueryVariables>(GetDailyHuddleDocument, options);
        }
export function useGetDailyHuddleSuspenseQuery(baseOptions?: Apollo.SuspenseQueryHookOptions<GetDailyHuddleQuery, GetDailyHuddleQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useSuspenseQuery<GetDailyHuddleQuery, GetDailyHuddleQueryVariables>(GetDailyHuddleDocument, options);
        }
export type GetDailyHuddleQueryHookResult = ReturnType<typeof useGetDailyHuddleQuery>;
export type GetDailyHuddleLazyQueryHookResult = ReturnType<typeof useGetDailyHuddleLazyQuery>;
export type GetDailyHuddleSuspenseQueryHookResult = ReturnType<typeof useGetDailyHuddleSuspenseQuery>;
export type GetDailyHuddleQueryResult = Apollo.QueryResult<GetDailyHuddleQuery, GetDailyHuddleQueryVariables>;
export const GetDailyHuddlesByClinicDocument = gql`
    query getDailyHuddlesByClinic($clinicId: ID!) {
  getDailyHuddlesByClinic(clinicId: $clinicId) {
    ...DailyHuddleFields
  }
}
    ${DailyHuddleFieldsFragmentDoc}`;

/**
 * __useGetDailyHuddlesByClinicQuery__
 *
 * To run a query within a React component, call `useGetDailyHuddlesByClinicQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetDailyHuddlesByClinicQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetDailyHuddlesByClinicQuery({
 *   variables: {
 *      clinicId: // value for 'clinicId'
 *   },
 * });
 */
export function useGetDailyHuddlesByClinicQuery(baseOptions: Apollo.QueryHookOptions<GetDailyHuddlesByClinicQuery, GetDailyHuddlesByClinicQueryVariables> & ({ variables: GetDailyHuddlesByClinicQueryVariables; skip?: boolean; } | { skip: boolean; }) ) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<GetDailyHuddlesByClinicQuery, GetDailyHuddlesByClinicQueryVariables>(GetDailyHuddlesByClinicDocument, options);
      }
export function useGetDailyHuddlesByClinicLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<GetDailyHuddlesByClinicQuery, GetDailyHuddlesByClinicQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<GetDailyHuddlesByClinicQuery, GetDailyHuddlesByClinicQueryVariables>(GetDailyHuddlesByClinicDocument, options);
        }
export function useGetDailyHuddlesByClinicSuspenseQuery(baseOptions?: Apollo.SuspenseQueryHookOptions<GetDailyHuddlesByClinicQuery, GetDailyHuddlesByClinicQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useSuspenseQuery<GetDailyHuddlesByClinicQuery, GetDailyHuddlesByClinicQueryVariables>(GetDailyHuddlesByClinicDocument, options);
        }
export type GetDailyHuddlesByClinicQueryHookResult = ReturnType<typeof useGetDailyHuddlesByClinicQuery>;
export type GetDailyHuddlesByClinicLazyQueryHookResult = ReturnType<typeof useGetDailyHuddlesByClinicLazyQuery>;
export type GetDailyHuddlesByClinicSuspenseQueryHookResult = ReturnType<typeof useGetDailyHuddlesByClinicSuspenseQuery>;
export type GetDailyHuddlesByClinicQueryResult = Apollo.QueryResult<GetDailyHuddlesByClinicQuery, GetDailyHuddlesByClinicQueryVariables>;
export const CreateDailyHuddleDocument = gql`
    mutation createDailyHuddle($clinicId: ID!, $data: CreateDailyHuddleInput!) {
  createDailyHuddle(clinicId: $clinicId, data: $data) {
    ...DailyHuddleFields
  }
}
    ${DailyHuddleFieldsFragmentDoc}`;
export type CreateDailyHuddleMutationFn = Apollo.MutationFunction<CreateDailyHuddleMutation, CreateDailyHuddleMutationVariables>;

/**
 * __useCreateDailyHuddleMutation__
 *
 * To run a mutation, you first call `useCreateDailyHuddleMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useCreateDailyHuddleMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [createDailyHuddleMutation, { data, loading, error }] = useCreateDailyHuddleMutation({
 *   variables: {
 *      clinicId: // value for 'clinicId'
 *      data: // value for 'data'
 *   },
 * });
 */
export function useCreateDailyHuddleMutation(baseOptions?: Apollo.MutationHookOptions<CreateDailyHuddleMutation, CreateDailyHuddleMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<CreateDailyHuddleMutation, CreateDailyHuddleMutationVariables>(CreateDailyHuddleDocument, options);
      }
export type CreateDailyHuddleMutationHookResult = ReturnType<typeof useCreateDailyHuddleMutation>;
export type CreateDailyHuddleMutationResult = Apollo.MutationResult<CreateDailyHuddleMutation>;
export type CreateDailyHuddleMutationOptions = Apollo.BaseMutationOptions<CreateDailyHuddleMutation, CreateDailyHuddleMutationVariables>;
export const UpdateDailyHuddleDocument = gql`
    mutation updateDailyHuddle($clinicId: ID!, $dailyHuddleId: ID!, $data: UpdateDailyHuddleInput!) {
  updateDailyHuddle(
    clinicId: $clinicId
    dailyHuddleId: $dailyHuddleId
    data: $data
  ) {
    ...DailyHuddleFields
  }
}
    ${DailyHuddleFieldsFragmentDoc}`;
export type UpdateDailyHuddleMutationFn = Apollo.MutationFunction<UpdateDailyHuddleMutation, UpdateDailyHuddleMutationVariables>;

/**
 * __useUpdateDailyHuddleMutation__
 *
 * To run a mutation, you first call `useUpdateDailyHuddleMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useUpdateDailyHuddleMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [updateDailyHuddleMutation, { data, loading, error }] = useUpdateDailyHuddleMutation({
 *   variables: {
 *      clinicId: // value for 'clinicId'
 *      dailyHuddleId: // value for 'dailyHuddleId'
 *      data: // value for 'data'
 *   },
 * });
 */
export function useUpdateDailyHuddleMutation(baseOptions?: Apollo.MutationHookOptions<UpdateDailyHuddleMutation, UpdateDailyHuddleMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<UpdateDailyHuddleMutation, UpdateDailyHuddleMutationVariables>(UpdateDailyHuddleDocument, options);
      }
export type UpdateDailyHuddleMutationHookResult = ReturnType<typeof useUpdateDailyHuddleMutation>;
export type UpdateDailyHuddleMutationResult = Apollo.MutationResult<UpdateDailyHuddleMutation>;
export type UpdateDailyHuddleMutationOptions = Apollo.BaseMutationOptions<UpdateDailyHuddleMutation, UpdateDailyHuddleMutationVariables>;
export const GetDataChatDocument = gql`
    query getDataChat($id: ID!) {
  dataChat(id: $id) {
    ...DataChatFields
  }
}
    ${DataChatFieldsFragmentDoc}`;

/**
 * __useGetDataChatQuery__
 *
 * To run a query within a React component, call `useGetDataChatQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetDataChatQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetDataChatQuery({
 *   variables: {
 *      id: // value for 'id'
 *   },
 * });
 */
export function useGetDataChatQuery(baseOptions: Apollo.QueryHookOptions<GetDataChatQuery, GetDataChatQueryVariables> & ({ variables: GetDataChatQueryVariables; skip?: boolean; } | { skip: boolean; }) ) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<GetDataChatQuery, GetDataChatQueryVariables>(GetDataChatDocument, options);
      }
export function useGetDataChatLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<GetDataChatQuery, GetDataChatQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<GetDataChatQuery, GetDataChatQueryVariables>(GetDataChatDocument, options);
        }
export function useGetDataChatSuspenseQuery(baseOptions?: Apollo.SuspenseQueryHookOptions<GetDataChatQuery, GetDataChatQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useSuspenseQuery<GetDataChatQuery, GetDataChatQueryVariables>(GetDataChatDocument, options);
        }
export type GetDataChatQueryHookResult = ReturnType<typeof useGetDataChatQuery>;
export type GetDataChatLazyQueryHookResult = ReturnType<typeof useGetDataChatLazyQuery>;
export type GetDataChatSuspenseQueryHookResult = ReturnType<typeof useGetDataChatSuspenseQuery>;
export type GetDataChatQueryResult = Apollo.QueryResult<GetDataChatQuery, GetDataChatQueryVariables>;
export const QueryClinicDataChatsDocument = gql`
    query queryClinicDataChats($clinicId: ID!, $params: QueryParams) {
  queryClinicDataChats(clinicId: $clinicId, params: $params) {
    ...DataChatPreviewFields
  }
}
    ${DataChatPreviewFieldsFragmentDoc}`;

/**
 * __useQueryClinicDataChatsQuery__
 *
 * To run a query within a React component, call `useQueryClinicDataChatsQuery` and pass it any options that fit your needs.
 * When your component renders, `useQueryClinicDataChatsQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useQueryClinicDataChatsQuery({
 *   variables: {
 *      clinicId: // value for 'clinicId'
 *      params: // value for 'params'
 *   },
 * });
 */
export function useQueryClinicDataChatsQuery(baseOptions: Apollo.QueryHookOptions<QueryClinicDataChatsQuery, QueryClinicDataChatsQueryVariables> & ({ variables: QueryClinicDataChatsQueryVariables; skip?: boolean; } | { skip: boolean; }) ) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<QueryClinicDataChatsQuery, QueryClinicDataChatsQueryVariables>(QueryClinicDataChatsDocument, options);
      }
export function useQueryClinicDataChatsLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<QueryClinicDataChatsQuery, QueryClinicDataChatsQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<QueryClinicDataChatsQuery, QueryClinicDataChatsQueryVariables>(QueryClinicDataChatsDocument, options);
        }
export function useQueryClinicDataChatsSuspenseQuery(baseOptions?: Apollo.SuspenseQueryHookOptions<QueryClinicDataChatsQuery, QueryClinicDataChatsQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useSuspenseQuery<QueryClinicDataChatsQuery, QueryClinicDataChatsQueryVariables>(QueryClinicDataChatsDocument, options);
        }
export type QueryClinicDataChatsQueryHookResult = ReturnType<typeof useQueryClinicDataChatsQuery>;
export type QueryClinicDataChatsLazyQueryHookResult = ReturnType<typeof useQueryClinicDataChatsLazyQuery>;
export type QueryClinicDataChatsSuspenseQueryHookResult = ReturnType<typeof useQueryClinicDataChatsSuspenseQuery>;
export type QueryClinicDataChatsQueryResult = Apollo.QueryResult<QueryClinicDataChatsQuery, QueryClinicDataChatsQueryVariables>;
export const CreateDataChatDocument = gql`
    mutation createDataChat($data: CreateDataChatInput!) {
  createDataChat(data: $data) {
    ...DataChatFields
  }
}
    ${DataChatFieldsFragmentDoc}`;
export type CreateDataChatMutationFn = Apollo.MutationFunction<CreateDataChatMutation, CreateDataChatMutationVariables>;

/**
 * __useCreateDataChatMutation__
 *
 * To run a mutation, you first call `useCreateDataChatMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useCreateDataChatMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [createDataChatMutation, { data, loading, error }] = useCreateDataChatMutation({
 *   variables: {
 *      data: // value for 'data'
 *   },
 * });
 */
export function useCreateDataChatMutation(baseOptions?: Apollo.MutationHookOptions<CreateDataChatMutation, CreateDataChatMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<CreateDataChatMutation, CreateDataChatMutationVariables>(CreateDataChatDocument, options);
      }
export type CreateDataChatMutationHookResult = ReturnType<typeof useCreateDataChatMutation>;
export type CreateDataChatMutationResult = Apollo.MutationResult<CreateDataChatMutation>;
export type CreateDataChatMutationOptions = Apollo.BaseMutationOptions<CreateDataChatMutation, CreateDataChatMutationVariables>;
export const UpdateDataChatDocument = gql`
    mutation updateDataChat($id: ID!, $data: UpdateDataChatInput!) {
  updateDataChat(id: $id, data: $data) {
    ...DataChatFields
  }
}
    ${DataChatFieldsFragmentDoc}`;
export type UpdateDataChatMutationFn = Apollo.MutationFunction<UpdateDataChatMutation, UpdateDataChatMutationVariables>;

/**
 * __useUpdateDataChatMutation__
 *
 * To run a mutation, you first call `useUpdateDataChatMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useUpdateDataChatMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [updateDataChatMutation, { data, loading, error }] = useUpdateDataChatMutation({
 *   variables: {
 *      id: // value for 'id'
 *      data: // value for 'data'
 *   },
 * });
 */
export function useUpdateDataChatMutation(baseOptions?: Apollo.MutationHookOptions<UpdateDataChatMutation, UpdateDataChatMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<UpdateDataChatMutation, UpdateDataChatMutationVariables>(UpdateDataChatDocument, options);
      }
export type UpdateDataChatMutationHookResult = ReturnType<typeof useUpdateDataChatMutation>;
export type UpdateDataChatMutationResult = Apollo.MutationResult<UpdateDataChatMutation>;
export type UpdateDataChatMutationOptions = Apollo.BaseMutationOptions<UpdateDataChatMutation, UpdateDataChatMutationVariables>;
export const SendDataChatPromptDocument = gql`
    mutation sendDataChatPrompt($data: DataChatPromptInput!) {
  sendDataChatPrompt(data: $data) {
    ...DataChatFields
  }
}
    ${DataChatFieldsFragmentDoc}`;
export type SendDataChatPromptMutationFn = Apollo.MutationFunction<SendDataChatPromptMutation, SendDataChatPromptMutationVariables>;

/**
 * __useSendDataChatPromptMutation__
 *
 * To run a mutation, you first call `useSendDataChatPromptMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useSendDataChatPromptMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [sendDataChatPromptMutation, { data, loading, error }] = useSendDataChatPromptMutation({
 *   variables: {
 *      data: // value for 'data'
 *   },
 * });
 */
export function useSendDataChatPromptMutation(baseOptions?: Apollo.MutationHookOptions<SendDataChatPromptMutation, SendDataChatPromptMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<SendDataChatPromptMutation, SendDataChatPromptMutationVariables>(SendDataChatPromptDocument, options);
      }
export type SendDataChatPromptMutationHookResult = ReturnType<typeof useSendDataChatPromptMutation>;
export type SendDataChatPromptMutationResult = Apollo.MutationResult<SendDataChatPromptMutation>;
export type SendDataChatPromptMutationOptions = Apollo.BaseMutationOptions<SendDataChatPromptMutation, SendDataChatPromptMutationVariables>;
export const EmailCustomerSegmentCsvDocument = gql`
    mutation emailCustomerSegmentCsv($data: EmailCustomerSegmentCsvInput!) {
  emailCustomerSegmentCsv(data: $data)
}
    `;
export type EmailCustomerSegmentCsvMutationFn = Apollo.MutationFunction<EmailCustomerSegmentCsvMutation, EmailCustomerSegmentCsvMutationVariables>;

/**
 * __useEmailCustomerSegmentCsvMutation__
 *
 * To run a mutation, you first call `useEmailCustomerSegmentCsvMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useEmailCustomerSegmentCsvMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [emailCustomerSegmentCsvMutation, { data, loading, error }] = useEmailCustomerSegmentCsvMutation({
 *   variables: {
 *      data: // value for 'data'
 *   },
 * });
 */
export function useEmailCustomerSegmentCsvMutation(baseOptions?: Apollo.MutationHookOptions<EmailCustomerSegmentCsvMutation, EmailCustomerSegmentCsvMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<EmailCustomerSegmentCsvMutation, EmailCustomerSegmentCsvMutationVariables>(EmailCustomerSegmentCsvDocument, options);
      }
export type EmailCustomerSegmentCsvMutationHookResult = ReturnType<typeof useEmailCustomerSegmentCsvMutation>;
export type EmailCustomerSegmentCsvMutationResult = Apollo.MutationResult<EmailCustomerSegmentCsvMutation>;
export type EmailCustomerSegmentCsvMutationOptions = Apollo.BaseMutationOptions<EmailCustomerSegmentCsvMutation, EmailCustomerSegmentCsvMutationVariables>;
export const QueryDiagnosesDocument = gql`
    query queryDiagnoses($where: [QueryInput!], $page: NonNegativeInt, $pageSize: NonNegativeInt, $orderBy: OrderByInput) {
  queryDiagnoses(
    where: $where
    page: $page
    pageSize: $pageSize
    orderBy: $orderBy
  ) {
    ...DiagnosisFields
  }
}
    ${DiagnosisFieldsFragmentDoc}`;

/**
 * __useQueryDiagnosesQuery__
 *
 * To run a query within a React component, call `useQueryDiagnosesQuery` and pass it any options that fit your needs.
 * When your component renders, `useQueryDiagnosesQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useQueryDiagnosesQuery({
 *   variables: {
 *      where: // value for 'where'
 *      page: // value for 'page'
 *      pageSize: // value for 'pageSize'
 *      orderBy: // value for 'orderBy'
 *   },
 * });
 */
export function useQueryDiagnosesQuery(baseOptions?: Apollo.QueryHookOptions<QueryDiagnosesQuery, QueryDiagnosesQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<QueryDiagnosesQuery, QueryDiagnosesQueryVariables>(QueryDiagnosesDocument, options);
      }
export function useQueryDiagnosesLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<QueryDiagnosesQuery, QueryDiagnosesQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<QueryDiagnosesQuery, QueryDiagnosesQueryVariables>(QueryDiagnosesDocument, options);
        }
export function useQueryDiagnosesSuspenseQuery(baseOptions?: Apollo.SuspenseQueryHookOptions<QueryDiagnosesQuery, QueryDiagnosesQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useSuspenseQuery<QueryDiagnosesQuery, QueryDiagnosesQueryVariables>(QueryDiagnosesDocument, options);
        }
export type QueryDiagnosesQueryHookResult = ReturnType<typeof useQueryDiagnosesQuery>;
export type QueryDiagnosesLazyQueryHookResult = ReturnType<typeof useQueryDiagnosesLazyQuery>;
export type QueryDiagnosesSuspenseQueryHookResult = ReturnType<typeof useQueryDiagnosesSuspenseQuery>;
export type QueryDiagnosesQueryResult = Apollo.QueryResult<QueryDiagnosesQuery, QueryDiagnosesQueryVariables>;
export const GetEmailTemplateDocument = gql`
    query getEmailTemplate($id: ID!) {
  emailTemplate(id: $id) {
    ...EmailTemplateFields
  }
}
    ${EmailTemplateFieldsFragmentDoc}`;

/**
 * __useGetEmailTemplateQuery__
 *
 * To run a query within a React component, call `useGetEmailTemplateQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetEmailTemplateQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetEmailTemplateQuery({
 *   variables: {
 *      id: // value for 'id'
 *   },
 * });
 */
export function useGetEmailTemplateQuery(baseOptions: Apollo.QueryHookOptions<GetEmailTemplateQuery, GetEmailTemplateQueryVariables> & ({ variables: GetEmailTemplateQueryVariables; skip?: boolean; } | { skip: boolean; }) ) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<GetEmailTemplateQuery, GetEmailTemplateQueryVariables>(GetEmailTemplateDocument, options);
      }
export function useGetEmailTemplateLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<GetEmailTemplateQuery, GetEmailTemplateQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<GetEmailTemplateQuery, GetEmailTemplateQueryVariables>(GetEmailTemplateDocument, options);
        }
export function useGetEmailTemplateSuspenseQuery(baseOptions?: Apollo.SuspenseQueryHookOptions<GetEmailTemplateQuery, GetEmailTemplateQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useSuspenseQuery<GetEmailTemplateQuery, GetEmailTemplateQueryVariables>(GetEmailTemplateDocument, options);
        }
export type GetEmailTemplateQueryHookResult = ReturnType<typeof useGetEmailTemplateQuery>;
export type GetEmailTemplateLazyQueryHookResult = ReturnType<typeof useGetEmailTemplateLazyQuery>;
export type GetEmailTemplateSuspenseQueryHookResult = ReturnType<typeof useGetEmailTemplateSuspenseQuery>;
export type GetEmailTemplateQueryResult = Apollo.QueryResult<GetEmailTemplateQuery, GetEmailTemplateQueryVariables>;
export const GetEmailTemplatesForClinicDocument = gql`
    query getEmailTemplatesForClinic($clinic: ID!, $status: [EmailTemplateStatus!]) {
  emailTemplatesForClinic(clinic: $clinic, status: $status) {
    ...EmailTemplateFields
  }
}
    ${EmailTemplateFieldsFragmentDoc}`;

/**
 * __useGetEmailTemplatesForClinicQuery__
 *
 * To run a query within a React component, call `useGetEmailTemplatesForClinicQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetEmailTemplatesForClinicQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetEmailTemplatesForClinicQuery({
 *   variables: {
 *      clinic: // value for 'clinic'
 *      status: // value for 'status'
 *   },
 * });
 */
export function useGetEmailTemplatesForClinicQuery(baseOptions: Apollo.QueryHookOptions<GetEmailTemplatesForClinicQuery, GetEmailTemplatesForClinicQueryVariables> & ({ variables: GetEmailTemplatesForClinicQueryVariables; skip?: boolean; } | { skip: boolean; }) ) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<GetEmailTemplatesForClinicQuery, GetEmailTemplatesForClinicQueryVariables>(GetEmailTemplatesForClinicDocument, options);
      }
export function useGetEmailTemplatesForClinicLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<GetEmailTemplatesForClinicQuery, GetEmailTemplatesForClinicQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<GetEmailTemplatesForClinicQuery, GetEmailTemplatesForClinicQueryVariables>(GetEmailTemplatesForClinicDocument, options);
        }
export function useGetEmailTemplatesForClinicSuspenseQuery(baseOptions?: Apollo.SuspenseQueryHookOptions<GetEmailTemplatesForClinicQuery, GetEmailTemplatesForClinicQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useSuspenseQuery<GetEmailTemplatesForClinicQuery, GetEmailTemplatesForClinicQueryVariables>(GetEmailTemplatesForClinicDocument, options);
        }
export type GetEmailTemplatesForClinicQueryHookResult = ReturnType<typeof useGetEmailTemplatesForClinicQuery>;
export type GetEmailTemplatesForClinicLazyQueryHookResult = ReturnType<typeof useGetEmailTemplatesForClinicLazyQuery>;
export type GetEmailTemplatesForClinicSuspenseQueryHookResult = ReturnType<typeof useGetEmailTemplatesForClinicSuspenseQuery>;
export type GetEmailTemplatesForClinicQueryResult = Apollo.QueryResult<GetEmailTemplatesForClinicQuery, GetEmailTemplatesForClinicQueryVariables>;
export const QueryClinicEmailTemplatesDocument = gql`
    query queryClinicEmailTemplates($clinicId: ID!, $where: [QueryInput!], $page: NonNegativeInt, $pageSize: NonNegativeInt, $orderBy: OrderByInput) {
  queryClinicEmailTemplates(
    clinicId: $clinicId
    where: $where
    page: $page
    pageSize: $pageSize
    orderBy: $orderBy
  ) {
    ...EmailTemplateFields
  }
}
    ${EmailTemplateFieldsFragmentDoc}`;

/**
 * __useQueryClinicEmailTemplatesQuery__
 *
 * To run a query within a React component, call `useQueryClinicEmailTemplatesQuery` and pass it any options that fit your needs.
 * When your component renders, `useQueryClinicEmailTemplatesQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useQueryClinicEmailTemplatesQuery({
 *   variables: {
 *      clinicId: // value for 'clinicId'
 *      where: // value for 'where'
 *      page: // value for 'page'
 *      pageSize: // value for 'pageSize'
 *      orderBy: // value for 'orderBy'
 *   },
 * });
 */
export function useQueryClinicEmailTemplatesQuery(baseOptions: Apollo.QueryHookOptions<QueryClinicEmailTemplatesQuery, QueryClinicEmailTemplatesQueryVariables> & ({ variables: QueryClinicEmailTemplatesQueryVariables; skip?: boolean; } | { skip: boolean; }) ) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<QueryClinicEmailTemplatesQuery, QueryClinicEmailTemplatesQueryVariables>(QueryClinicEmailTemplatesDocument, options);
      }
export function useQueryClinicEmailTemplatesLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<QueryClinicEmailTemplatesQuery, QueryClinicEmailTemplatesQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<QueryClinicEmailTemplatesQuery, QueryClinicEmailTemplatesQueryVariables>(QueryClinicEmailTemplatesDocument, options);
        }
export function useQueryClinicEmailTemplatesSuspenseQuery(baseOptions?: Apollo.SuspenseQueryHookOptions<QueryClinicEmailTemplatesQuery, QueryClinicEmailTemplatesQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useSuspenseQuery<QueryClinicEmailTemplatesQuery, QueryClinicEmailTemplatesQueryVariables>(QueryClinicEmailTemplatesDocument, options);
        }
export type QueryClinicEmailTemplatesQueryHookResult = ReturnType<typeof useQueryClinicEmailTemplatesQuery>;
export type QueryClinicEmailTemplatesLazyQueryHookResult = ReturnType<typeof useQueryClinicEmailTemplatesLazyQuery>;
export type QueryClinicEmailTemplatesSuspenseQueryHookResult = ReturnType<typeof useQueryClinicEmailTemplatesSuspenseQuery>;
export type QueryClinicEmailTemplatesQueryResult = Apollo.QueryResult<QueryClinicEmailTemplatesQuery, QueryClinicEmailTemplatesQueryVariables>;
export const CountClinicEmailTemplatesDocument = gql`
    query countClinicEmailTemplates($clinicId: ID!, $where: [QueryInput!]) {
  countClinicEmailTemplates(clinicId: $clinicId, where: $where)
}
    `;

/**
 * __useCountClinicEmailTemplatesQuery__
 *
 * To run a query within a React component, call `useCountClinicEmailTemplatesQuery` and pass it any options that fit your needs.
 * When your component renders, `useCountClinicEmailTemplatesQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useCountClinicEmailTemplatesQuery({
 *   variables: {
 *      clinicId: // value for 'clinicId'
 *      where: // value for 'where'
 *   },
 * });
 */
export function useCountClinicEmailTemplatesQuery(baseOptions: Apollo.QueryHookOptions<CountClinicEmailTemplatesQuery, CountClinicEmailTemplatesQueryVariables> & ({ variables: CountClinicEmailTemplatesQueryVariables; skip?: boolean; } | { skip: boolean; }) ) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<CountClinicEmailTemplatesQuery, CountClinicEmailTemplatesQueryVariables>(CountClinicEmailTemplatesDocument, options);
      }
export function useCountClinicEmailTemplatesLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<CountClinicEmailTemplatesQuery, CountClinicEmailTemplatesQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<CountClinicEmailTemplatesQuery, CountClinicEmailTemplatesQueryVariables>(CountClinicEmailTemplatesDocument, options);
        }
export function useCountClinicEmailTemplatesSuspenseQuery(baseOptions?: Apollo.SuspenseQueryHookOptions<CountClinicEmailTemplatesQuery, CountClinicEmailTemplatesQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useSuspenseQuery<CountClinicEmailTemplatesQuery, CountClinicEmailTemplatesQueryVariables>(CountClinicEmailTemplatesDocument, options);
        }
export type CountClinicEmailTemplatesQueryHookResult = ReturnType<typeof useCountClinicEmailTemplatesQuery>;
export type CountClinicEmailTemplatesLazyQueryHookResult = ReturnType<typeof useCountClinicEmailTemplatesLazyQuery>;
export type CountClinicEmailTemplatesSuspenseQueryHookResult = ReturnType<typeof useCountClinicEmailTemplatesSuspenseQuery>;
export type CountClinicEmailTemplatesQueryResult = Apollo.QueryResult<CountClinicEmailTemplatesQuery, CountClinicEmailTemplatesQueryVariables>;
export const QueryClinicGroupEmailTemplatesDocument = gql`
    query queryClinicGroupEmailTemplates($clinicGroupId: ID!, $where: [QueryInput!], $page: NonNegativeInt, $pageSize: NonNegativeInt, $orderBy: OrderByInput) {
  queryClinicGroupEmailTemplates(
    clinicGroupId: $clinicGroupId
    where: $where
    page: $page
    pageSize: $pageSize
    orderBy: $orderBy
  ) {
    ...EmailTemplateFields
  }
}
    ${EmailTemplateFieldsFragmentDoc}`;

/**
 * __useQueryClinicGroupEmailTemplatesQuery__
 *
 * To run a query within a React component, call `useQueryClinicGroupEmailTemplatesQuery` and pass it any options that fit your needs.
 * When your component renders, `useQueryClinicGroupEmailTemplatesQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useQueryClinicGroupEmailTemplatesQuery({
 *   variables: {
 *      clinicGroupId: // value for 'clinicGroupId'
 *      where: // value for 'where'
 *      page: // value for 'page'
 *      pageSize: // value for 'pageSize'
 *      orderBy: // value for 'orderBy'
 *   },
 * });
 */
export function useQueryClinicGroupEmailTemplatesQuery(baseOptions: Apollo.QueryHookOptions<QueryClinicGroupEmailTemplatesQuery, QueryClinicGroupEmailTemplatesQueryVariables> & ({ variables: QueryClinicGroupEmailTemplatesQueryVariables; skip?: boolean; } | { skip: boolean; }) ) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<QueryClinicGroupEmailTemplatesQuery, QueryClinicGroupEmailTemplatesQueryVariables>(QueryClinicGroupEmailTemplatesDocument, options);
      }
export function useQueryClinicGroupEmailTemplatesLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<QueryClinicGroupEmailTemplatesQuery, QueryClinicGroupEmailTemplatesQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<QueryClinicGroupEmailTemplatesQuery, QueryClinicGroupEmailTemplatesQueryVariables>(QueryClinicGroupEmailTemplatesDocument, options);
        }
export function useQueryClinicGroupEmailTemplatesSuspenseQuery(baseOptions?: Apollo.SuspenseQueryHookOptions<QueryClinicGroupEmailTemplatesQuery, QueryClinicGroupEmailTemplatesQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useSuspenseQuery<QueryClinicGroupEmailTemplatesQuery, QueryClinicGroupEmailTemplatesQueryVariables>(QueryClinicGroupEmailTemplatesDocument, options);
        }
export type QueryClinicGroupEmailTemplatesQueryHookResult = ReturnType<typeof useQueryClinicGroupEmailTemplatesQuery>;
export type QueryClinicGroupEmailTemplatesLazyQueryHookResult = ReturnType<typeof useQueryClinicGroupEmailTemplatesLazyQuery>;
export type QueryClinicGroupEmailTemplatesSuspenseQueryHookResult = ReturnType<typeof useQueryClinicGroupEmailTemplatesSuspenseQuery>;
export type QueryClinicGroupEmailTemplatesQueryResult = Apollo.QueryResult<QueryClinicGroupEmailTemplatesQuery, QueryClinicGroupEmailTemplatesQueryVariables>;
export const CountClinicGroupEmailTemplatesDocument = gql`
    query countClinicGroupEmailTemplates($clinicGroupId: ID!, $where: [QueryInput!]) {
  countClinicGroupEmailTemplates(clinicGroupId: $clinicGroupId, where: $where)
}
    `;

/**
 * __useCountClinicGroupEmailTemplatesQuery__
 *
 * To run a query within a React component, call `useCountClinicGroupEmailTemplatesQuery` and pass it any options that fit your needs.
 * When your component renders, `useCountClinicGroupEmailTemplatesQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useCountClinicGroupEmailTemplatesQuery({
 *   variables: {
 *      clinicGroupId: // value for 'clinicGroupId'
 *      where: // value for 'where'
 *   },
 * });
 */
export function useCountClinicGroupEmailTemplatesQuery(baseOptions: Apollo.QueryHookOptions<CountClinicGroupEmailTemplatesQuery, CountClinicGroupEmailTemplatesQueryVariables> & ({ variables: CountClinicGroupEmailTemplatesQueryVariables; skip?: boolean; } | { skip: boolean; }) ) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<CountClinicGroupEmailTemplatesQuery, CountClinicGroupEmailTemplatesQueryVariables>(CountClinicGroupEmailTemplatesDocument, options);
      }
export function useCountClinicGroupEmailTemplatesLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<CountClinicGroupEmailTemplatesQuery, CountClinicGroupEmailTemplatesQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<CountClinicGroupEmailTemplatesQuery, CountClinicGroupEmailTemplatesQueryVariables>(CountClinicGroupEmailTemplatesDocument, options);
        }
export function useCountClinicGroupEmailTemplatesSuspenseQuery(baseOptions?: Apollo.SuspenseQueryHookOptions<CountClinicGroupEmailTemplatesQuery, CountClinicGroupEmailTemplatesQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useSuspenseQuery<CountClinicGroupEmailTemplatesQuery, CountClinicGroupEmailTemplatesQueryVariables>(CountClinicGroupEmailTemplatesDocument, options);
        }
export type CountClinicGroupEmailTemplatesQueryHookResult = ReturnType<typeof useCountClinicGroupEmailTemplatesQuery>;
export type CountClinicGroupEmailTemplatesLazyQueryHookResult = ReturnType<typeof useCountClinicGroupEmailTemplatesLazyQuery>;
export type CountClinicGroupEmailTemplatesSuspenseQueryHookResult = ReturnType<typeof useCountClinicGroupEmailTemplatesSuspenseQuery>;
export type CountClinicGroupEmailTemplatesQueryResult = Apollo.QueryResult<CountClinicGroupEmailTemplatesQuery, CountClinicGroupEmailTemplatesQueryVariables>;
export const CreateEmailTemplateDocument = gql`
    mutation createEmailTemplate($clinic: ID, $clinicGroup: ID) {
  createEmailTemplate(clinic: $clinic, clinicGroup: $clinicGroup) {
    ...EmailTemplateFields
  }
}
    ${EmailTemplateFieldsFragmentDoc}`;
export type CreateEmailTemplateMutationFn = Apollo.MutationFunction<CreateEmailTemplateMutation, CreateEmailTemplateMutationVariables>;

/**
 * __useCreateEmailTemplateMutation__
 *
 * To run a mutation, you first call `useCreateEmailTemplateMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useCreateEmailTemplateMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [createEmailTemplateMutation, { data, loading, error }] = useCreateEmailTemplateMutation({
 *   variables: {
 *      clinic: // value for 'clinic'
 *      clinicGroup: // value for 'clinicGroup'
 *   },
 * });
 */
export function useCreateEmailTemplateMutation(baseOptions?: Apollo.MutationHookOptions<CreateEmailTemplateMutation, CreateEmailTemplateMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<CreateEmailTemplateMutation, CreateEmailTemplateMutationVariables>(CreateEmailTemplateDocument, options);
      }
export type CreateEmailTemplateMutationHookResult = ReturnType<typeof useCreateEmailTemplateMutation>;
export type CreateEmailTemplateMutationResult = Apollo.MutationResult<CreateEmailTemplateMutation>;
export type CreateEmailTemplateMutationOptions = Apollo.BaseMutationOptions<CreateEmailTemplateMutation, CreateEmailTemplateMutationVariables>;
export const DuplicateEmailTemplateDocument = gql`
    mutation duplicateEmailTemplate($id: ID!) {
  duplicateEmailTemplate(id: $id) {
    ...EmailTemplateFields
  }
}
    ${EmailTemplateFieldsFragmentDoc}`;
export type DuplicateEmailTemplateMutationFn = Apollo.MutationFunction<DuplicateEmailTemplateMutation, DuplicateEmailTemplateMutationVariables>;

/**
 * __useDuplicateEmailTemplateMutation__
 *
 * To run a mutation, you first call `useDuplicateEmailTemplateMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useDuplicateEmailTemplateMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [duplicateEmailTemplateMutation, { data, loading, error }] = useDuplicateEmailTemplateMutation({
 *   variables: {
 *      id: // value for 'id'
 *   },
 * });
 */
export function useDuplicateEmailTemplateMutation(baseOptions?: Apollo.MutationHookOptions<DuplicateEmailTemplateMutation, DuplicateEmailTemplateMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<DuplicateEmailTemplateMutation, DuplicateEmailTemplateMutationVariables>(DuplicateEmailTemplateDocument, options);
      }
export type DuplicateEmailTemplateMutationHookResult = ReturnType<typeof useDuplicateEmailTemplateMutation>;
export type DuplicateEmailTemplateMutationResult = Apollo.MutationResult<DuplicateEmailTemplateMutation>;
export type DuplicateEmailTemplateMutationOptions = Apollo.BaseMutationOptions<DuplicateEmailTemplateMutation, DuplicateEmailTemplateMutationVariables>;
export const UpdateEmailTemplateDocument = gql`
    mutation updateEmailTemplate($id: ID!, $input: UpdateEmailTemplateInput!) {
  updateEmailTemplate(id: $id, input: $input) {
    ...EmailTemplateFields
  }
}
    ${EmailTemplateFieldsFragmentDoc}`;
export type UpdateEmailTemplateMutationFn = Apollo.MutationFunction<UpdateEmailTemplateMutation, UpdateEmailTemplateMutationVariables>;

/**
 * __useUpdateEmailTemplateMutation__
 *
 * To run a mutation, you first call `useUpdateEmailTemplateMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useUpdateEmailTemplateMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [updateEmailTemplateMutation, { data, loading, error }] = useUpdateEmailTemplateMutation({
 *   variables: {
 *      id: // value for 'id'
 *      input: // value for 'input'
 *   },
 * });
 */
export function useUpdateEmailTemplateMutation(baseOptions?: Apollo.MutationHookOptions<UpdateEmailTemplateMutation, UpdateEmailTemplateMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<UpdateEmailTemplateMutation, UpdateEmailTemplateMutationVariables>(UpdateEmailTemplateDocument, options);
      }
export type UpdateEmailTemplateMutationHookResult = ReturnType<typeof useUpdateEmailTemplateMutation>;
export type UpdateEmailTemplateMutationResult = Apollo.MutationResult<UpdateEmailTemplateMutation>;
export type UpdateEmailTemplateMutationOptions = Apollo.BaseMutationOptions<UpdateEmailTemplateMutation, UpdateEmailTemplateMutationVariables>;
export const DeleteEmailTemplateDocument = gql`
    mutation deleteEmailTemplate($id: ID!) {
  deleteEmailTemplate(id: $id)
}
    `;
export type DeleteEmailTemplateMutationFn = Apollo.MutationFunction<DeleteEmailTemplateMutation, DeleteEmailTemplateMutationVariables>;

/**
 * __useDeleteEmailTemplateMutation__
 *
 * To run a mutation, you first call `useDeleteEmailTemplateMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useDeleteEmailTemplateMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [deleteEmailTemplateMutation, { data, loading, error }] = useDeleteEmailTemplateMutation({
 *   variables: {
 *      id: // value for 'id'
 *   },
 * });
 */
export function useDeleteEmailTemplateMutation(baseOptions?: Apollo.MutationHookOptions<DeleteEmailTemplateMutation, DeleteEmailTemplateMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<DeleteEmailTemplateMutation, DeleteEmailTemplateMutationVariables>(DeleteEmailTemplateDocument, options);
      }
export type DeleteEmailTemplateMutationHookResult = ReturnType<typeof useDeleteEmailTemplateMutation>;
export type DeleteEmailTemplateMutationResult = Apollo.MutationResult<DeleteEmailTemplateMutation>;
export type DeleteEmailTemplateMutationOptions = Apollo.BaseMutationOptions<DeleteEmailTemplateMutation, DeleteEmailTemplateMutationVariables>;
export const SendTestEmailDocument = gql`
    mutation sendTestEmail($clinicId: ID!, $emails: [String!]!, $content: SendTestEmailContent!) {
  sendTestEmail(clinicId: $clinicId, emails: $emails, content: $content)
}
    `;
export type SendTestEmailMutationFn = Apollo.MutationFunction<SendTestEmailMutation, SendTestEmailMutationVariables>;

/**
 * __useSendTestEmailMutation__
 *
 * To run a mutation, you first call `useSendTestEmailMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useSendTestEmailMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [sendTestEmailMutation, { data, loading, error }] = useSendTestEmailMutation({
 *   variables: {
 *      clinicId: // value for 'clinicId'
 *      emails: // value for 'emails'
 *      content: // value for 'content'
 *   },
 * });
 */
export function useSendTestEmailMutation(baseOptions?: Apollo.MutationHookOptions<SendTestEmailMutation, SendTestEmailMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<SendTestEmailMutation, SendTestEmailMutationVariables>(SendTestEmailDocument, options);
      }
export type SendTestEmailMutationHookResult = ReturnType<typeof useSendTestEmailMutation>;
export type SendTestEmailMutationResult = Apollo.MutationResult<SendTestEmailMutation>;
export type SendTestEmailMutationOptions = Apollo.BaseMutationOptions<SendTestEmailMutation, SendTestEmailMutationVariables>;
export const CopyEmailTemplateAcrossClinicDocument = gql`
    mutation copyEmailTemplateAcrossClinic($id: ID!, $destinationClinicId: ID!) {
  copyEmailTemplateAcrossClinic(
    id: $id
    destinationClinicId: $destinationClinicId
  ) {
    ...EmailTemplateFields
  }
}
    ${EmailTemplateFieldsFragmentDoc}`;
export type CopyEmailTemplateAcrossClinicMutationFn = Apollo.MutationFunction<CopyEmailTemplateAcrossClinicMutation, CopyEmailTemplateAcrossClinicMutationVariables>;

/**
 * __useCopyEmailTemplateAcrossClinicMutation__
 *
 * To run a mutation, you first call `useCopyEmailTemplateAcrossClinicMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useCopyEmailTemplateAcrossClinicMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [copyEmailTemplateAcrossClinicMutation, { data, loading, error }] = useCopyEmailTemplateAcrossClinicMutation({
 *   variables: {
 *      id: // value for 'id'
 *      destinationClinicId: // value for 'destinationClinicId'
 *   },
 * });
 */
export function useCopyEmailTemplateAcrossClinicMutation(baseOptions?: Apollo.MutationHookOptions<CopyEmailTemplateAcrossClinicMutation, CopyEmailTemplateAcrossClinicMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<CopyEmailTemplateAcrossClinicMutation, CopyEmailTemplateAcrossClinicMutationVariables>(CopyEmailTemplateAcrossClinicDocument, options);
      }
export type CopyEmailTemplateAcrossClinicMutationHookResult = ReturnType<typeof useCopyEmailTemplateAcrossClinicMutation>;
export type CopyEmailTemplateAcrossClinicMutationResult = Apollo.MutationResult<CopyEmailTemplateAcrossClinicMutation>;
export type CopyEmailTemplateAcrossClinicMutationOptions = Apollo.BaseMutationOptions<CopyEmailTemplateAcrossClinicMutation, CopyEmailTemplateAcrossClinicMutationVariables>;
export const GetEnterpriseOnboardingReportDocument = gql`
    query getEnterpriseOnboardingReport($clinicGroupId: ID!, $trancheKey: String) {
  enterpriseOnboardingReport(
    clinic_group_id: $clinicGroupId
    tranche_key: $trancheKey
  ) {
    clinic_group_id
    steps {
      ...ClinicGroupOnboardingStepFields
    }
    tranches {
      ...ClinicGroupOnboardingTrancheFields
    }
    cell_notes {
      ...ClinicGroupOnboardingCellNoteFields
    }
    column_config {
      ...ClinicGroupOnboardingColumnConfigFields
    }
    expected_merge_tags
    rows {
      ...EnterpriseOnboardingRowFields
    }
  }
}
    ${ClinicGroupOnboardingStepFieldsFragmentDoc}
${ClinicGroupOnboardingTrancheFieldsFragmentDoc}
${ClinicGroupOnboardingCellNoteFieldsFragmentDoc}
${ClinicGroupOnboardingColumnConfigFieldsFragmentDoc}
${EnterpriseOnboardingRowFieldsFragmentDoc}`;

/**
 * __useGetEnterpriseOnboardingReportQuery__
 *
 * To run a query within a React component, call `useGetEnterpriseOnboardingReportQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetEnterpriseOnboardingReportQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetEnterpriseOnboardingReportQuery({
 *   variables: {
 *      clinicGroupId: // value for 'clinicGroupId'
 *      trancheKey: // value for 'trancheKey'
 *   },
 * });
 */
export function useGetEnterpriseOnboardingReportQuery(baseOptions: Apollo.QueryHookOptions<GetEnterpriseOnboardingReportQuery, GetEnterpriseOnboardingReportQueryVariables> & ({ variables: GetEnterpriseOnboardingReportQueryVariables; skip?: boolean; } | { skip: boolean; }) ) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<GetEnterpriseOnboardingReportQuery, GetEnterpriseOnboardingReportQueryVariables>(GetEnterpriseOnboardingReportDocument, options);
      }
export function useGetEnterpriseOnboardingReportLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<GetEnterpriseOnboardingReportQuery, GetEnterpriseOnboardingReportQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<GetEnterpriseOnboardingReportQuery, GetEnterpriseOnboardingReportQueryVariables>(GetEnterpriseOnboardingReportDocument, options);
        }
export function useGetEnterpriseOnboardingReportSuspenseQuery(baseOptions?: Apollo.SuspenseQueryHookOptions<GetEnterpriseOnboardingReportQuery, GetEnterpriseOnboardingReportQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useSuspenseQuery<GetEnterpriseOnboardingReportQuery, GetEnterpriseOnboardingReportQueryVariables>(GetEnterpriseOnboardingReportDocument, options);
        }
export type GetEnterpriseOnboardingReportQueryHookResult = ReturnType<typeof useGetEnterpriseOnboardingReportQuery>;
export type GetEnterpriseOnboardingReportLazyQueryHookResult = ReturnType<typeof useGetEnterpriseOnboardingReportLazyQuery>;
export type GetEnterpriseOnboardingReportSuspenseQueryHookResult = ReturnType<typeof useGetEnterpriseOnboardingReportSuspenseQuery>;
export type GetEnterpriseOnboardingReportQueryResult = Apollo.QueryResult<GetEnterpriseOnboardingReportQuery, GetEnterpriseOnboardingReportQueryVariables>;
export const GetEnterpriseOnboardingEntitiesDocument = gql`
    query getEnterpriseOnboardingEntities($clinicGroupId: ID!, $clinicId: ID!, $entityType: EntityLinkType!) {
  enterpriseOnboardingEntities(
    clinic_group_id: $clinicGroupId
    clinic_id: $clinicId
    entity_type: $entityType
  ) {
    id
    name
    is_standardized
  }
}
    `;

/**
 * __useGetEnterpriseOnboardingEntitiesQuery__
 *
 * To run a query within a React component, call `useGetEnterpriseOnboardingEntitiesQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetEnterpriseOnboardingEntitiesQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetEnterpriseOnboardingEntitiesQuery({
 *   variables: {
 *      clinicGroupId: // value for 'clinicGroupId'
 *      clinicId: // value for 'clinicId'
 *      entityType: // value for 'entityType'
 *   },
 * });
 */
export function useGetEnterpriseOnboardingEntitiesQuery(baseOptions: Apollo.QueryHookOptions<GetEnterpriseOnboardingEntitiesQuery, GetEnterpriseOnboardingEntitiesQueryVariables> & ({ variables: GetEnterpriseOnboardingEntitiesQueryVariables; skip?: boolean; } | { skip: boolean; }) ) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<GetEnterpriseOnboardingEntitiesQuery, GetEnterpriseOnboardingEntitiesQueryVariables>(GetEnterpriseOnboardingEntitiesDocument, options);
      }
export function useGetEnterpriseOnboardingEntitiesLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<GetEnterpriseOnboardingEntitiesQuery, GetEnterpriseOnboardingEntitiesQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<GetEnterpriseOnboardingEntitiesQuery, GetEnterpriseOnboardingEntitiesQueryVariables>(GetEnterpriseOnboardingEntitiesDocument, options);
        }
export function useGetEnterpriseOnboardingEntitiesSuspenseQuery(baseOptions?: Apollo.SuspenseQueryHookOptions<GetEnterpriseOnboardingEntitiesQuery, GetEnterpriseOnboardingEntitiesQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useSuspenseQuery<GetEnterpriseOnboardingEntitiesQuery, GetEnterpriseOnboardingEntitiesQueryVariables>(GetEnterpriseOnboardingEntitiesDocument, options);
        }
export type GetEnterpriseOnboardingEntitiesQueryHookResult = ReturnType<typeof useGetEnterpriseOnboardingEntitiesQuery>;
export type GetEnterpriseOnboardingEntitiesLazyQueryHookResult = ReturnType<typeof useGetEnterpriseOnboardingEntitiesLazyQuery>;
export type GetEnterpriseOnboardingEntitiesSuspenseQueryHookResult = ReturnType<typeof useGetEnterpriseOnboardingEntitiesSuspenseQuery>;
export type GetEnterpriseOnboardingEntitiesQueryResult = Apollo.QueryResult<GetEnterpriseOnboardingEntitiesQuery, GetEnterpriseOnboardingEntitiesQueryVariables>;
export const GetEnterpriseOnboardingSetupEntitiesDocument = gql`
    query getEnterpriseOnboardingSetupEntities($clinicGroupId: ID!, $clinicId: ID!, $kind: EnterpriseOnboardingSetupKind!) {
  enterpriseOnboardingSetupEntities(
    clinic_group_id: $clinicGroupId
    clinic_id: $clinicId
    kind: $kind
  ) {
    id
    name
  }
}
    `;

/**
 * __useGetEnterpriseOnboardingSetupEntitiesQuery__
 *
 * To run a query within a React component, call `useGetEnterpriseOnboardingSetupEntitiesQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetEnterpriseOnboardingSetupEntitiesQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetEnterpriseOnboardingSetupEntitiesQuery({
 *   variables: {
 *      clinicGroupId: // value for 'clinicGroupId'
 *      clinicId: // value for 'clinicId'
 *      kind: // value for 'kind'
 *   },
 * });
 */
export function useGetEnterpriseOnboardingSetupEntitiesQuery(baseOptions: Apollo.QueryHookOptions<GetEnterpriseOnboardingSetupEntitiesQuery, GetEnterpriseOnboardingSetupEntitiesQueryVariables> & ({ variables: GetEnterpriseOnboardingSetupEntitiesQueryVariables; skip?: boolean; } | { skip: boolean; }) ) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<GetEnterpriseOnboardingSetupEntitiesQuery, GetEnterpriseOnboardingSetupEntitiesQueryVariables>(GetEnterpriseOnboardingSetupEntitiesDocument, options);
      }
export function useGetEnterpriseOnboardingSetupEntitiesLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<GetEnterpriseOnboardingSetupEntitiesQuery, GetEnterpriseOnboardingSetupEntitiesQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<GetEnterpriseOnboardingSetupEntitiesQuery, GetEnterpriseOnboardingSetupEntitiesQueryVariables>(GetEnterpriseOnboardingSetupEntitiesDocument, options);
        }
export function useGetEnterpriseOnboardingSetupEntitiesSuspenseQuery(baseOptions?: Apollo.SuspenseQueryHookOptions<GetEnterpriseOnboardingSetupEntitiesQuery, GetEnterpriseOnboardingSetupEntitiesQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useSuspenseQuery<GetEnterpriseOnboardingSetupEntitiesQuery, GetEnterpriseOnboardingSetupEntitiesQueryVariables>(GetEnterpriseOnboardingSetupEntitiesDocument, options);
        }
export type GetEnterpriseOnboardingSetupEntitiesQueryHookResult = ReturnType<typeof useGetEnterpriseOnboardingSetupEntitiesQuery>;
export type GetEnterpriseOnboardingSetupEntitiesLazyQueryHookResult = ReturnType<typeof useGetEnterpriseOnboardingSetupEntitiesLazyQuery>;
export type GetEnterpriseOnboardingSetupEntitiesSuspenseQueryHookResult = ReturnType<typeof useGetEnterpriseOnboardingSetupEntitiesSuspenseQuery>;
export type GetEnterpriseOnboardingSetupEntitiesQueryResult = Apollo.QueryResult<GetEnterpriseOnboardingSetupEntitiesQuery, GetEnterpriseOnboardingSetupEntitiesQueryVariables>;
export const UpdateClinicGroupOnboardingStepsDocument = gql`
    mutation updateClinicGroupOnboardingSteps($clinicGroupId: ID!, $steps: [ClinicGroupOnboardingStepInput!]!) {
  updateClinicGroupOnboardingSteps(clinic_group_id: $clinicGroupId, steps: $steps) {
    id
    onboarding_steps {
      ...ClinicGroupOnboardingStepFields
    }
  }
}
    ${ClinicGroupOnboardingStepFieldsFragmentDoc}`;
export type UpdateClinicGroupOnboardingStepsMutationFn = Apollo.MutationFunction<UpdateClinicGroupOnboardingStepsMutation, UpdateClinicGroupOnboardingStepsMutationVariables>;

/**
 * __useUpdateClinicGroupOnboardingStepsMutation__
 *
 * To run a mutation, you first call `useUpdateClinicGroupOnboardingStepsMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useUpdateClinicGroupOnboardingStepsMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [updateClinicGroupOnboardingStepsMutation, { data, loading, error }] = useUpdateClinicGroupOnboardingStepsMutation({
 *   variables: {
 *      clinicGroupId: // value for 'clinicGroupId'
 *      steps: // value for 'steps'
 *   },
 * });
 */
export function useUpdateClinicGroupOnboardingStepsMutation(baseOptions?: Apollo.MutationHookOptions<UpdateClinicGroupOnboardingStepsMutation, UpdateClinicGroupOnboardingStepsMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<UpdateClinicGroupOnboardingStepsMutation, UpdateClinicGroupOnboardingStepsMutationVariables>(UpdateClinicGroupOnboardingStepsDocument, options);
      }
export type UpdateClinicGroupOnboardingStepsMutationHookResult = ReturnType<typeof useUpdateClinicGroupOnboardingStepsMutation>;
export type UpdateClinicGroupOnboardingStepsMutationResult = Apollo.MutationResult<UpdateClinicGroupOnboardingStepsMutation>;
export type UpdateClinicGroupOnboardingStepsMutationOptions = Apollo.BaseMutationOptions<UpdateClinicGroupOnboardingStepsMutation, UpdateClinicGroupOnboardingStepsMutationVariables>;
export const UpdateClinicGroupOnboardingTranchesDocument = gql`
    mutation updateClinicGroupOnboardingTranches($clinicGroupId: ID!, $tranches: [ClinicGroupOnboardingTrancheInput!]!) {
  updateClinicGroupOnboardingTranches(
    clinic_group_id: $clinicGroupId
    tranches: $tranches
  ) {
    id
    onboarding_tranches {
      ...ClinicGroupOnboardingTrancheFields
    }
  }
}
    ${ClinicGroupOnboardingTrancheFieldsFragmentDoc}`;
export type UpdateClinicGroupOnboardingTranchesMutationFn = Apollo.MutationFunction<UpdateClinicGroupOnboardingTranchesMutation, UpdateClinicGroupOnboardingTranchesMutationVariables>;

/**
 * __useUpdateClinicGroupOnboardingTranchesMutation__
 *
 * To run a mutation, you first call `useUpdateClinicGroupOnboardingTranchesMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useUpdateClinicGroupOnboardingTranchesMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [updateClinicGroupOnboardingTranchesMutation, { data, loading, error }] = useUpdateClinicGroupOnboardingTranchesMutation({
 *   variables: {
 *      clinicGroupId: // value for 'clinicGroupId'
 *      tranches: // value for 'tranches'
 *   },
 * });
 */
export function useUpdateClinicGroupOnboardingTranchesMutation(baseOptions?: Apollo.MutationHookOptions<UpdateClinicGroupOnboardingTranchesMutation, UpdateClinicGroupOnboardingTranchesMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<UpdateClinicGroupOnboardingTranchesMutation, UpdateClinicGroupOnboardingTranchesMutationVariables>(UpdateClinicGroupOnboardingTranchesDocument, options);
      }
export type UpdateClinicGroupOnboardingTranchesMutationHookResult = ReturnType<typeof useUpdateClinicGroupOnboardingTranchesMutation>;
export type UpdateClinicGroupOnboardingTranchesMutationResult = Apollo.MutationResult<UpdateClinicGroupOnboardingTranchesMutation>;
export type UpdateClinicGroupOnboardingTranchesMutationOptions = Apollo.BaseMutationOptions<UpdateClinicGroupOnboardingTranchesMutation, UpdateClinicGroupOnboardingTranchesMutationVariables>;
export const SetClinicGroupTrancheCompleteDocument = gql`
    mutation setClinicGroupTrancheComplete($clinicGroupId: ID!, $trancheKey: String!, $isComplete: Boolean!) {
  setClinicGroupTrancheComplete(
    clinic_group_id: $clinicGroupId
    tranche_key: $trancheKey
    is_complete: $isComplete
  ) {
    id
    onboarding_tranches {
      ...ClinicGroupOnboardingTrancheFields
    }
  }
}
    ${ClinicGroupOnboardingTrancheFieldsFragmentDoc}`;
export type SetClinicGroupTrancheCompleteMutationFn = Apollo.MutationFunction<SetClinicGroupTrancheCompleteMutation, SetClinicGroupTrancheCompleteMutationVariables>;

/**
 * __useSetClinicGroupTrancheCompleteMutation__
 *
 * To run a mutation, you first call `useSetClinicGroupTrancheCompleteMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useSetClinicGroupTrancheCompleteMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [setClinicGroupTrancheCompleteMutation, { data, loading, error }] = useSetClinicGroupTrancheCompleteMutation({
 *   variables: {
 *      clinicGroupId: // value for 'clinicGroupId'
 *      trancheKey: // value for 'trancheKey'
 *      isComplete: // value for 'isComplete'
 *   },
 * });
 */
export function useSetClinicGroupTrancheCompleteMutation(baseOptions?: Apollo.MutationHookOptions<SetClinicGroupTrancheCompleteMutation, SetClinicGroupTrancheCompleteMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<SetClinicGroupTrancheCompleteMutation, SetClinicGroupTrancheCompleteMutationVariables>(SetClinicGroupTrancheCompleteDocument, options);
      }
export type SetClinicGroupTrancheCompleteMutationHookResult = ReturnType<typeof useSetClinicGroupTrancheCompleteMutation>;
export type SetClinicGroupTrancheCompleteMutationResult = Apollo.MutationResult<SetClinicGroupTrancheCompleteMutation>;
export type SetClinicGroupTrancheCompleteMutationOptions = Apollo.BaseMutationOptions<SetClinicGroupTrancheCompleteMutation, SetClinicGroupTrancheCompleteMutationVariables>;
export const GetClinicGroupExpectedMergeTagsDocument = gql`
    query getClinicGroupExpectedMergeTags($clinicGroupId: ID!) {
  clinicGroup(id: $clinicGroupId) {
    id
    name
    onboarding_expected_merge_tags
  }
}
    `;

/**
 * __useGetClinicGroupExpectedMergeTagsQuery__
 *
 * To run a query within a React component, call `useGetClinicGroupExpectedMergeTagsQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetClinicGroupExpectedMergeTagsQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetClinicGroupExpectedMergeTagsQuery({
 *   variables: {
 *      clinicGroupId: // value for 'clinicGroupId'
 *   },
 * });
 */
export function useGetClinicGroupExpectedMergeTagsQuery(baseOptions: Apollo.QueryHookOptions<GetClinicGroupExpectedMergeTagsQuery, GetClinicGroupExpectedMergeTagsQueryVariables> & ({ variables: GetClinicGroupExpectedMergeTagsQueryVariables; skip?: boolean; } | { skip: boolean; }) ) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<GetClinicGroupExpectedMergeTagsQuery, GetClinicGroupExpectedMergeTagsQueryVariables>(GetClinicGroupExpectedMergeTagsDocument, options);
      }
export function useGetClinicGroupExpectedMergeTagsLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<GetClinicGroupExpectedMergeTagsQuery, GetClinicGroupExpectedMergeTagsQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<GetClinicGroupExpectedMergeTagsQuery, GetClinicGroupExpectedMergeTagsQueryVariables>(GetClinicGroupExpectedMergeTagsDocument, options);
        }
export function useGetClinicGroupExpectedMergeTagsSuspenseQuery(baseOptions?: Apollo.SuspenseQueryHookOptions<GetClinicGroupExpectedMergeTagsQuery, GetClinicGroupExpectedMergeTagsQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useSuspenseQuery<GetClinicGroupExpectedMergeTagsQuery, GetClinicGroupExpectedMergeTagsQueryVariables>(GetClinicGroupExpectedMergeTagsDocument, options);
        }
export type GetClinicGroupExpectedMergeTagsQueryHookResult = ReturnType<typeof useGetClinicGroupExpectedMergeTagsQuery>;
export type GetClinicGroupExpectedMergeTagsLazyQueryHookResult = ReturnType<typeof useGetClinicGroupExpectedMergeTagsLazyQuery>;
export type GetClinicGroupExpectedMergeTagsSuspenseQueryHookResult = ReturnType<typeof useGetClinicGroupExpectedMergeTagsSuspenseQuery>;
export type GetClinicGroupExpectedMergeTagsQueryResult = Apollo.QueryResult<GetClinicGroupExpectedMergeTagsQuery, GetClinicGroupExpectedMergeTagsQueryVariables>;
export const GetClinicGroupMergeTagEditorDocument = gql`
    query getClinicGroupMergeTagEditor($clinicGroupId: ID!) {
  clinicGroup(id: $clinicGroupId) {
    id
    name
    onboarding_expected_merge_tags
    clinic_group_clinics {
      id
      clinic {
        id
        name
        is_archived
        settings {
          custom_merge_tags
        }
      }
    }
  }
}
    `;

/**
 * __useGetClinicGroupMergeTagEditorQuery__
 *
 * To run a query within a React component, call `useGetClinicGroupMergeTagEditorQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetClinicGroupMergeTagEditorQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetClinicGroupMergeTagEditorQuery({
 *   variables: {
 *      clinicGroupId: // value for 'clinicGroupId'
 *   },
 * });
 */
export function useGetClinicGroupMergeTagEditorQuery(baseOptions: Apollo.QueryHookOptions<GetClinicGroupMergeTagEditorQuery, GetClinicGroupMergeTagEditorQueryVariables> & ({ variables: GetClinicGroupMergeTagEditorQueryVariables; skip?: boolean; } | { skip: boolean; }) ) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<GetClinicGroupMergeTagEditorQuery, GetClinicGroupMergeTagEditorQueryVariables>(GetClinicGroupMergeTagEditorDocument, options);
      }
export function useGetClinicGroupMergeTagEditorLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<GetClinicGroupMergeTagEditorQuery, GetClinicGroupMergeTagEditorQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<GetClinicGroupMergeTagEditorQuery, GetClinicGroupMergeTagEditorQueryVariables>(GetClinicGroupMergeTagEditorDocument, options);
        }
export function useGetClinicGroupMergeTagEditorSuspenseQuery(baseOptions?: Apollo.SuspenseQueryHookOptions<GetClinicGroupMergeTagEditorQuery, GetClinicGroupMergeTagEditorQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useSuspenseQuery<GetClinicGroupMergeTagEditorQuery, GetClinicGroupMergeTagEditorQueryVariables>(GetClinicGroupMergeTagEditorDocument, options);
        }
export type GetClinicGroupMergeTagEditorQueryHookResult = ReturnType<typeof useGetClinicGroupMergeTagEditorQuery>;
export type GetClinicGroupMergeTagEditorLazyQueryHookResult = ReturnType<typeof useGetClinicGroupMergeTagEditorLazyQuery>;
export type GetClinicGroupMergeTagEditorSuspenseQueryHookResult = ReturnType<typeof useGetClinicGroupMergeTagEditorSuspenseQuery>;
export type GetClinicGroupMergeTagEditorQueryResult = Apollo.QueryResult<GetClinicGroupMergeTagEditorQuery, GetClinicGroupMergeTagEditorQueryVariables>;
export const UpdateClinicCustomMergeTagsDocument = gql`
    mutation updateClinicCustomMergeTags($clinicId: ID!, $customMergeTags: JSON!) {
  updateClinic(
    id: $clinicId
    data: {settings: {custom_merge_tags: $customMergeTags}}
  ) {
    id
    settings {
      custom_merge_tags
    }
  }
}
    `;
export type UpdateClinicCustomMergeTagsMutationFn = Apollo.MutationFunction<UpdateClinicCustomMergeTagsMutation, UpdateClinicCustomMergeTagsMutationVariables>;

/**
 * __useUpdateClinicCustomMergeTagsMutation__
 *
 * To run a mutation, you first call `useUpdateClinicCustomMergeTagsMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useUpdateClinicCustomMergeTagsMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [updateClinicCustomMergeTagsMutation, { data, loading, error }] = useUpdateClinicCustomMergeTagsMutation({
 *   variables: {
 *      clinicId: // value for 'clinicId'
 *      customMergeTags: // value for 'customMergeTags'
 *   },
 * });
 */
export function useUpdateClinicCustomMergeTagsMutation(baseOptions?: Apollo.MutationHookOptions<UpdateClinicCustomMergeTagsMutation, UpdateClinicCustomMergeTagsMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<UpdateClinicCustomMergeTagsMutation, UpdateClinicCustomMergeTagsMutationVariables>(UpdateClinicCustomMergeTagsDocument, options);
      }
export type UpdateClinicCustomMergeTagsMutationHookResult = ReturnType<typeof useUpdateClinicCustomMergeTagsMutation>;
export type UpdateClinicCustomMergeTagsMutationResult = Apollo.MutationResult<UpdateClinicCustomMergeTagsMutation>;
export type UpdateClinicCustomMergeTagsMutationOptions = Apollo.BaseMutationOptions<UpdateClinicCustomMergeTagsMutation, UpdateClinicCustomMergeTagsMutationVariables>;
export const UpdateClinicGroupExpectedMergeTagsDocument = gql`
    mutation updateClinicGroupExpectedMergeTags($clinicGroupId: ID!, $mergeTags: [String!]!) {
  updateClinicGroupExpectedMergeTags(
    clinic_group_id: $clinicGroupId
    merge_tags: $mergeTags
  ) {
    id
    onboarding_expected_merge_tags
  }
}
    `;
export type UpdateClinicGroupExpectedMergeTagsMutationFn = Apollo.MutationFunction<UpdateClinicGroupExpectedMergeTagsMutation, UpdateClinicGroupExpectedMergeTagsMutationVariables>;

/**
 * __useUpdateClinicGroupExpectedMergeTagsMutation__
 *
 * To run a mutation, you first call `useUpdateClinicGroupExpectedMergeTagsMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useUpdateClinicGroupExpectedMergeTagsMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [updateClinicGroupExpectedMergeTagsMutation, { data, loading, error }] = useUpdateClinicGroupExpectedMergeTagsMutation({
 *   variables: {
 *      clinicGroupId: // value for 'clinicGroupId'
 *      mergeTags: // value for 'mergeTags'
 *   },
 * });
 */
export function useUpdateClinicGroupExpectedMergeTagsMutation(baseOptions?: Apollo.MutationHookOptions<UpdateClinicGroupExpectedMergeTagsMutation, UpdateClinicGroupExpectedMergeTagsMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<UpdateClinicGroupExpectedMergeTagsMutation, UpdateClinicGroupExpectedMergeTagsMutationVariables>(UpdateClinicGroupExpectedMergeTagsDocument, options);
      }
export type UpdateClinicGroupExpectedMergeTagsMutationHookResult = ReturnType<typeof useUpdateClinicGroupExpectedMergeTagsMutation>;
export type UpdateClinicGroupExpectedMergeTagsMutationResult = Apollo.MutationResult<UpdateClinicGroupExpectedMergeTagsMutation>;
export type UpdateClinicGroupExpectedMergeTagsMutationOptions = Apollo.BaseMutationOptions<UpdateClinicGroupExpectedMergeTagsMutation, UpdateClinicGroupExpectedMergeTagsMutationVariables>;
export const SetClinicGroupOnboardingCellNoteDocument = gql`
    mutation setClinicGroupOnboardingCellNote($clinicGroupId: ID!, $clinicId: ID!, $columnId: String!, $note: String, $isAccepted: Boolean, $waitingOn: ClinicGroupOnboardingWaitingOn, $assignedTo: ID) {
  setClinicGroupOnboardingCellNote(
    clinic_group_id: $clinicGroupId
    clinic_id: $clinicId
    column_id: $columnId
    note: $note
    is_accepted: $isAccepted
    waiting_on: $waitingOn
    assigned_to: $assignedTo
  ) {
    ...ClinicGroupOnboardingCellNoteFields
  }
}
    ${ClinicGroupOnboardingCellNoteFieldsFragmentDoc}`;
export type SetClinicGroupOnboardingCellNoteMutationFn = Apollo.MutationFunction<SetClinicGroupOnboardingCellNoteMutation, SetClinicGroupOnboardingCellNoteMutationVariables>;

/**
 * __useSetClinicGroupOnboardingCellNoteMutation__
 *
 * To run a mutation, you first call `useSetClinicGroupOnboardingCellNoteMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useSetClinicGroupOnboardingCellNoteMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [setClinicGroupOnboardingCellNoteMutation, { data, loading, error }] = useSetClinicGroupOnboardingCellNoteMutation({
 *   variables: {
 *      clinicGroupId: // value for 'clinicGroupId'
 *      clinicId: // value for 'clinicId'
 *      columnId: // value for 'columnId'
 *      note: // value for 'note'
 *      isAccepted: // value for 'isAccepted'
 *      waitingOn: // value for 'waitingOn'
 *      assignedTo: // value for 'assignedTo'
 *   },
 * });
 */
export function useSetClinicGroupOnboardingCellNoteMutation(baseOptions?: Apollo.MutationHookOptions<SetClinicGroupOnboardingCellNoteMutation, SetClinicGroupOnboardingCellNoteMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<SetClinicGroupOnboardingCellNoteMutation, SetClinicGroupOnboardingCellNoteMutationVariables>(SetClinicGroupOnboardingCellNoteDocument, options);
      }
export type SetClinicGroupOnboardingCellNoteMutationHookResult = ReturnType<typeof useSetClinicGroupOnboardingCellNoteMutation>;
export type SetClinicGroupOnboardingCellNoteMutationResult = Apollo.MutationResult<SetClinicGroupOnboardingCellNoteMutation>;
export type SetClinicGroupOnboardingCellNoteMutationOptions = Apollo.BaseMutationOptions<SetClinicGroupOnboardingCellNoteMutation, SetClinicGroupOnboardingCellNoteMutationVariables>;
export const ClearClinicGroupOnboardingCellNoteDocument = gql`
    mutation clearClinicGroupOnboardingCellNote($clinicGroupId: ID!, $clinicId: ID!, $columnId: String!) {
  clearClinicGroupOnboardingCellNote(
    clinic_group_id: $clinicGroupId
    clinic_id: $clinicId
    column_id: $columnId
  ) {
    ...ClinicGroupOnboardingCellNoteFields
  }
}
    ${ClinicGroupOnboardingCellNoteFieldsFragmentDoc}`;
export type ClearClinicGroupOnboardingCellNoteMutationFn = Apollo.MutationFunction<ClearClinicGroupOnboardingCellNoteMutation, ClearClinicGroupOnboardingCellNoteMutationVariables>;

/**
 * __useClearClinicGroupOnboardingCellNoteMutation__
 *
 * To run a mutation, you first call `useClearClinicGroupOnboardingCellNoteMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useClearClinicGroupOnboardingCellNoteMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [clearClinicGroupOnboardingCellNoteMutation, { data, loading, error }] = useClearClinicGroupOnboardingCellNoteMutation({
 *   variables: {
 *      clinicGroupId: // value for 'clinicGroupId'
 *      clinicId: // value for 'clinicId'
 *      columnId: // value for 'columnId'
 *   },
 * });
 */
export function useClearClinicGroupOnboardingCellNoteMutation(baseOptions?: Apollo.MutationHookOptions<ClearClinicGroupOnboardingCellNoteMutation, ClearClinicGroupOnboardingCellNoteMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<ClearClinicGroupOnboardingCellNoteMutation, ClearClinicGroupOnboardingCellNoteMutationVariables>(ClearClinicGroupOnboardingCellNoteDocument, options);
      }
export type ClearClinicGroupOnboardingCellNoteMutationHookResult = ReturnType<typeof useClearClinicGroupOnboardingCellNoteMutation>;
export type ClearClinicGroupOnboardingCellNoteMutationResult = Apollo.MutationResult<ClearClinicGroupOnboardingCellNoteMutation>;
export type ClearClinicGroupOnboardingCellNoteMutationOptions = Apollo.BaseMutationOptions<ClearClinicGroupOnboardingCellNoteMutation, ClearClinicGroupOnboardingCellNoteMutationVariables>;
export const SetClinicGroupOnboardingColumnsHiddenDocument = gql`
    mutation setClinicGroupOnboardingColumnsHidden($clinicGroupId: ID!, $columnIds: [String!]!, $isHidden: Boolean!) {
  setClinicGroupOnboardingColumnsHidden(
    clinic_group_id: $clinicGroupId
    column_ids: $columnIds
    is_hidden: $isHidden
  ) {
    ...ClinicGroupOnboardingColumnConfigFields
  }
}
    ${ClinicGroupOnboardingColumnConfigFieldsFragmentDoc}`;
export type SetClinicGroupOnboardingColumnsHiddenMutationFn = Apollo.MutationFunction<SetClinicGroupOnboardingColumnsHiddenMutation, SetClinicGroupOnboardingColumnsHiddenMutationVariables>;

/**
 * __useSetClinicGroupOnboardingColumnsHiddenMutation__
 *
 * To run a mutation, you first call `useSetClinicGroupOnboardingColumnsHiddenMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useSetClinicGroupOnboardingColumnsHiddenMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [setClinicGroupOnboardingColumnsHiddenMutation, { data, loading, error }] = useSetClinicGroupOnboardingColumnsHiddenMutation({
 *   variables: {
 *      clinicGroupId: // value for 'clinicGroupId'
 *      columnIds: // value for 'columnIds'
 *      isHidden: // value for 'isHidden'
 *   },
 * });
 */
export function useSetClinicGroupOnboardingColumnsHiddenMutation(baseOptions?: Apollo.MutationHookOptions<SetClinicGroupOnboardingColumnsHiddenMutation, SetClinicGroupOnboardingColumnsHiddenMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<SetClinicGroupOnboardingColumnsHiddenMutation, SetClinicGroupOnboardingColumnsHiddenMutationVariables>(SetClinicGroupOnboardingColumnsHiddenDocument, options);
      }
export type SetClinicGroupOnboardingColumnsHiddenMutationHookResult = ReturnType<typeof useSetClinicGroupOnboardingColumnsHiddenMutation>;
export type SetClinicGroupOnboardingColumnsHiddenMutationResult = Apollo.MutationResult<SetClinicGroupOnboardingColumnsHiddenMutation>;
export type SetClinicGroupOnboardingColumnsHiddenMutationOptions = Apollo.BaseMutationOptions<SetClinicGroupOnboardingColumnsHiddenMutation, SetClinicGroupOnboardingColumnsHiddenMutationVariables>;
export const SetClinicGroupOnboardingColumnsScoredDocument = gql`
    mutation setClinicGroupOnboardingColumnsScored($clinicGroupId: ID!, $columnIds: [String!]!, $isScored: Boolean!) {
  setClinicGroupOnboardingColumnsScored(
    clinic_group_id: $clinicGroupId
    column_ids: $columnIds
    is_scored: $isScored
  ) {
    ...ClinicGroupOnboardingColumnConfigFields
  }
}
    ${ClinicGroupOnboardingColumnConfigFieldsFragmentDoc}`;
export type SetClinicGroupOnboardingColumnsScoredMutationFn = Apollo.MutationFunction<SetClinicGroupOnboardingColumnsScoredMutation, SetClinicGroupOnboardingColumnsScoredMutationVariables>;

/**
 * __useSetClinicGroupOnboardingColumnsScoredMutation__
 *
 * To run a mutation, you first call `useSetClinicGroupOnboardingColumnsScoredMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useSetClinicGroupOnboardingColumnsScoredMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [setClinicGroupOnboardingColumnsScoredMutation, { data, loading, error }] = useSetClinicGroupOnboardingColumnsScoredMutation({
 *   variables: {
 *      clinicGroupId: // value for 'clinicGroupId'
 *      columnIds: // value for 'columnIds'
 *      isScored: // value for 'isScored'
 *   },
 * });
 */
export function useSetClinicGroupOnboardingColumnsScoredMutation(baseOptions?: Apollo.MutationHookOptions<SetClinicGroupOnboardingColumnsScoredMutation, SetClinicGroupOnboardingColumnsScoredMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<SetClinicGroupOnboardingColumnsScoredMutation, SetClinicGroupOnboardingColumnsScoredMutationVariables>(SetClinicGroupOnboardingColumnsScoredDocument, options);
      }
export type SetClinicGroupOnboardingColumnsScoredMutationHookResult = ReturnType<typeof useSetClinicGroupOnboardingColumnsScoredMutation>;
export type SetClinicGroupOnboardingColumnsScoredMutationResult = Apollo.MutationResult<SetClinicGroupOnboardingColumnsScoredMutation>;
export type SetClinicGroupOnboardingColumnsScoredMutationOptions = Apollo.BaseMutationOptions<SetClinicGroupOnboardingColumnsScoredMutation, SetClinicGroupOnboardingColumnsScoredMutationVariables>;
export const SetClinicGroupOnboardingColumnCriterionDocument = gql`
    mutation setClinicGroupOnboardingColumnCriterion($clinicGroupId: ID!, $columnId: String!, $criterion: ClinicGroupOnboardingCriterionInput) {
  setClinicGroupOnboardingColumnCriterion(
    clinic_group_id: $clinicGroupId
    column_id: $columnId
    criterion: $criterion
  ) {
    ...ClinicGroupOnboardingColumnConfigFields
  }
}
    ${ClinicGroupOnboardingColumnConfigFieldsFragmentDoc}`;
export type SetClinicGroupOnboardingColumnCriterionMutationFn = Apollo.MutationFunction<SetClinicGroupOnboardingColumnCriterionMutation, SetClinicGroupOnboardingColumnCriterionMutationVariables>;

/**
 * __useSetClinicGroupOnboardingColumnCriterionMutation__
 *
 * To run a mutation, you first call `useSetClinicGroupOnboardingColumnCriterionMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useSetClinicGroupOnboardingColumnCriterionMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [setClinicGroupOnboardingColumnCriterionMutation, { data, loading, error }] = useSetClinicGroupOnboardingColumnCriterionMutation({
 *   variables: {
 *      clinicGroupId: // value for 'clinicGroupId'
 *      columnId: // value for 'columnId'
 *      criterion: // value for 'criterion'
 *   },
 * });
 */
export function useSetClinicGroupOnboardingColumnCriterionMutation(baseOptions?: Apollo.MutationHookOptions<SetClinicGroupOnboardingColumnCriterionMutation, SetClinicGroupOnboardingColumnCriterionMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<SetClinicGroupOnboardingColumnCriterionMutation, SetClinicGroupOnboardingColumnCriterionMutationVariables>(SetClinicGroupOnboardingColumnCriterionDocument, options);
      }
export type SetClinicGroupOnboardingColumnCriterionMutationHookResult = ReturnType<typeof useSetClinicGroupOnboardingColumnCriterionMutation>;
export type SetClinicGroupOnboardingColumnCriterionMutationResult = Apollo.MutationResult<SetClinicGroupOnboardingColumnCriterionMutation>;
export type SetClinicGroupOnboardingColumnCriterionMutationOptions = Apollo.BaseMutationOptions<SetClinicGroupOnboardingColumnCriterionMutation, SetClinicGroupOnboardingColumnCriterionMutationVariables>;
export const SetClinicGroupOnboardingStepStatusDocument = gql`
    mutation setClinicGroupOnboardingStepStatus($clinicGroupId: ID!, $clinicId: ID!, $stepKey: String!, $value: String) {
  setClinicGroupOnboardingStepStatus(
    clinic_group_id: $clinicGroupId
    clinic_id: $clinicId
    step_key: $stepKey
    value: $value
  ) {
    clinic_id
    clinic_group_id
    step_statuses
  }
}
    `;
export type SetClinicGroupOnboardingStepStatusMutationFn = Apollo.MutationFunction<SetClinicGroupOnboardingStepStatusMutation, SetClinicGroupOnboardingStepStatusMutationVariables>;

/**
 * __useSetClinicGroupOnboardingStepStatusMutation__
 *
 * To run a mutation, you first call `useSetClinicGroupOnboardingStepStatusMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useSetClinicGroupOnboardingStepStatusMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [setClinicGroupOnboardingStepStatusMutation, { data, loading, error }] = useSetClinicGroupOnboardingStepStatusMutation({
 *   variables: {
 *      clinicGroupId: // value for 'clinicGroupId'
 *      clinicId: // value for 'clinicId'
 *      stepKey: // value for 'stepKey'
 *      value: // value for 'value'
 *   },
 * });
 */
export function useSetClinicGroupOnboardingStepStatusMutation(baseOptions?: Apollo.MutationHookOptions<SetClinicGroupOnboardingStepStatusMutation, SetClinicGroupOnboardingStepStatusMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<SetClinicGroupOnboardingStepStatusMutation, SetClinicGroupOnboardingStepStatusMutationVariables>(SetClinicGroupOnboardingStepStatusDocument, options);
      }
export type SetClinicGroupOnboardingStepStatusMutationHookResult = ReturnType<typeof useSetClinicGroupOnboardingStepStatusMutation>;
export type SetClinicGroupOnboardingStepStatusMutationResult = Apollo.MutationResult<SetClinicGroupOnboardingStepStatusMutation>;
export type SetClinicGroupOnboardingStepStatusMutationOptions = Apollo.BaseMutationOptions<SetClinicGroupOnboardingStepStatusMutation, SetClinicGroupOnboardingStepStatusMutationVariables>;
export const SetClinicGroupOnboardingGoLiveDateDocument = gql`
    mutation setClinicGroupOnboardingGoLiveDate($clinicGroupId: ID!, $clinicId: ID!, $goLiveDate: String) {
  setClinicGroupOnboardingGoLiveDate(
    clinic_group_id: $clinicGroupId
    clinic_id: $clinicId
    go_live_date: $goLiveDate
  ) {
    clinic_id
    go_live_date
  }
}
    `;
export type SetClinicGroupOnboardingGoLiveDateMutationFn = Apollo.MutationFunction<SetClinicGroupOnboardingGoLiveDateMutation, SetClinicGroupOnboardingGoLiveDateMutationVariables>;

/**
 * __useSetClinicGroupOnboardingGoLiveDateMutation__
 *
 * To run a mutation, you first call `useSetClinicGroupOnboardingGoLiveDateMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useSetClinicGroupOnboardingGoLiveDateMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [setClinicGroupOnboardingGoLiveDateMutation, { data, loading, error }] = useSetClinicGroupOnboardingGoLiveDateMutation({
 *   variables: {
 *      clinicGroupId: // value for 'clinicGroupId'
 *      clinicId: // value for 'clinicId'
 *      goLiveDate: // value for 'goLiveDate'
 *   },
 * });
 */
export function useSetClinicGroupOnboardingGoLiveDateMutation(baseOptions?: Apollo.MutationHookOptions<SetClinicGroupOnboardingGoLiveDateMutation, SetClinicGroupOnboardingGoLiveDateMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<SetClinicGroupOnboardingGoLiveDateMutation, SetClinicGroupOnboardingGoLiveDateMutationVariables>(SetClinicGroupOnboardingGoLiveDateDocument, options);
      }
export type SetClinicGroupOnboardingGoLiveDateMutationHookResult = ReturnType<typeof useSetClinicGroupOnboardingGoLiveDateMutation>;
export type SetClinicGroupOnboardingGoLiveDateMutationResult = Apollo.MutationResult<SetClinicGroupOnboardingGoLiveDateMutation>;
export type SetClinicGroupOnboardingGoLiveDateMutationOptions = Apollo.BaseMutationOptions<SetClinicGroupOnboardingGoLiveDateMutation, SetClinicGroupOnboardingGoLiveDateMutationVariables>;
export const CountDrilldownEntitiesDocument = gql`
    query countDrilldownEntities($metricId: ID!, $params: GetDrilldownEntitiesParams!) {
  countDrilldownEntities(metricId: $metricId, params: $params)
}
    `;

/**
 * __useCountDrilldownEntitiesQuery__
 *
 * To run a query within a React component, call `useCountDrilldownEntitiesQuery` and pass it any options that fit your needs.
 * When your component renders, `useCountDrilldownEntitiesQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useCountDrilldownEntitiesQuery({
 *   variables: {
 *      metricId: // value for 'metricId'
 *      params: // value for 'params'
 *   },
 * });
 */
export function useCountDrilldownEntitiesQuery(baseOptions: Apollo.QueryHookOptions<CountDrilldownEntitiesQuery, CountDrilldownEntitiesQueryVariables> & ({ variables: CountDrilldownEntitiesQueryVariables; skip?: boolean; } | { skip: boolean; }) ) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<CountDrilldownEntitiesQuery, CountDrilldownEntitiesQueryVariables>(CountDrilldownEntitiesDocument, options);
      }
export function useCountDrilldownEntitiesLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<CountDrilldownEntitiesQuery, CountDrilldownEntitiesQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<CountDrilldownEntitiesQuery, CountDrilldownEntitiesQueryVariables>(CountDrilldownEntitiesDocument, options);
        }
export function useCountDrilldownEntitiesSuspenseQuery(baseOptions?: Apollo.SuspenseQueryHookOptions<CountDrilldownEntitiesQuery, CountDrilldownEntitiesQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useSuspenseQuery<CountDrilldownEntitiesQuery, CountDrilldownEntitiesQueryVariables>(CountDrilldownEntitiesDocument, options);
        }
export type CountDrilldownEntitiesQueryHookResult = ReturnType<typeof useCountDrilldownEntitiesQuery>;
export type CountDrilldownEntitiesLazyQueryHookResult = ReturnType<typeof useCountDrilldownEntitiesLazyQuery>;
export type CountDrilldownEntitiesSuspenseQueryHookResult = ReturnType<typeof useCountDrilldownEntitiesSuspenseQuery>;
export type CountDrilldownEntitiesQueryResult = Apollo.QueryResult<CountDrilldownEntitiesQuery, CountDrilldownEntitiesQueryVariables>;
export const GetDrilldownEntitiesDocument = gql`
    query getDrilldownEntities($metricId: ID!, $params: GetDrilldownEntitiesParams!) {
  getDrilldownEntities(metricId: $metricId, params: $params) {
    ...DrilldownRowFields
  }
}
    ${DrilldownRowFieldsFragmentDoc}`;

/**
 * __useGetDrilldownEntitiesQuery__
 *
 * To run a query within a React component, call `useGetDrilldownEntitiesQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetDrilldownEntitiesQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetDrilldownEntitiesQuery({
 *   variables: {
 *      metricId: // value for 'metricId'
 *      params: // value for 'params'
 *   },
 * });
 */
export function useGetDrilldownEntitiesQuery(baseOptions: Apollo.QueryHookOptions<GetDrilldownEntitiesQuery, GetDrilldownEntitiesQueryVariables> & ({ variables: GetDrilldownEntitiesQueryVariables; skip?: boolean; } | { skip: boolean; }) ) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<GetDrilldownEntitiesQuery, GetDrilldownEntitiesQueryVariables>(GetDrilldownEntitiesDocument, options);
      }
export function useGetDrilldownEntitiesLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<GetDrilldownEntitiesQuery, GetDrilldownEntitiesQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<GetDrilldownEntitiesQuery, GetDrilldownEntitiesQueryVariables>(GetDrilldownEntitiesDocument, options);
        }
export function useGetDrilldownEntitiesSuspenseQuery(baseOptions?: Apollo.SuspenseQueryHookOptions<GetDrilldownEntitiesQuery, GetDrilldownEntitiesQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useSuspenseQuery<GetDrilldownEntitiesQuery, GetDrilldownEntitiesQueryVariables>(GetDrilldownEntitiesDocument, options);
        }
export type GetDrilldownEntitiesQueryHookResult = ReturnType<typeof useGetDrilldownEntitiesQuery>;
export type GetDrilldownEntitiesLazyQueryHookResult = ReturnType<typeof useGetDrilldownEntitiesLazyQuery>;
export type GetDrilldownEntitiesSuspenseQueryHookResult = ReturnType<typeof useGetDrilldownEntitiesSuspenseQuery>;
export type GetDrilldownEntitiesQueryResult = Apollo.QueryResult<GetDrilldownEntitiesQuery, GetDrilldownEntitiesQueryVariables>;
export const QueryEntityReportsDocument = gql`
    query queryEntityReports($where: [QueryInput!], $page: NonNegativeInt, $pageSize: NonNegativeInt, $orderBy: OrderByInput) {
  queryEntityReports(
    where: $where
    page: $page
    pageSize: $pageSize
    orderBy: $orderBy
  ) {
    ...EntityReportFields
  }
}
    ${EntityReportFieldsFragmentDoc}`;

/**
 * __useQueryEntityReportsQuery__
 *
 * To run a query within a React component, call `useQueryEntityReportsQuery` and pass it any options that fit your needs.
 * When your component renders, `useQueryEntityReportsQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useQueryEntityReportsQuery({
 *   variables: {
 *      where: // value for 'where'
 *      page: // value for 'page'
 *      pageSize: // value for 'pageSize'
 *      orderBy: // value for 'orderBy'
 *   },
 * });
 */
export function useQueryEntityReportsQuery(baseOptions?: Apollo.QueryHookOptions<QueryEntityReportsQuery, QueryEntityReportsQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<QueryEntityReportsQuery, QueryEntityReportsQueryVariables>(QueryEntityReportsDocument, options);
      }
export function useQueryEntityReportsLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<QueryEntityReportsQuery, QueryEntityReportsQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<QueryEntityReportsQuery, QueryEntityReportsQueryVariables>(QueryEntityReportsDocument, options);
        }
export function useQueryEntityReportsSuspenseQuery(baseOptions?: Apollo.SuspenseQueryHookOptions<QueryEntityReportsQuery, QueryEntityReportsQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useSuspenseQuery<QueryEntityReportsQuery, QueryEntityReportsQueryVariables>(QueryEntityReportsDocument, options);
        }
export type QueryEntityReportsQueryHookResult = ReturnType<typeof useQueryEntityReportsQuery>;
export type QueryEntityReportsLazyQueryHookResult = ReturnType<typeof useQueryEntityReportsLazyQuery>;
export type QueryEntityReportsSuspenseQueryHookResult = ReturnType<typeof useQueryEntityReportsSuspenseQuery>;
export type QueryEntityReportsQueryResult = Apollo.QueryResult<QueryEntityReportsQuery, QueryEntityReportsQueryVariables>;
export const QueryInitiativesDocument = gql`
    query queryInitiatives($where: [QueryInput!], $page: NonNegativeInt, $pageSize: NonNegativeInt, $orderBy: OrderByInput) {
  queryInitiatives(
    where: $where
    page: $page
    pageSize: $pageSize
    orderBy: $orderBy
  ) {
    ...InitiativeFields
  }
}
    ${InitiativeFieldsFragmentDoc}`;

/**
 * __useQueryInitiativesQuery__
 *
 * To run a query within a React component, call `useQueryInitiativesQuery` and pass it any options that fit your needs.
 * When your component renders, `useQueryInitiativesQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useQueryInitiativesQuery({
 *   variables: {
 *      where: // value for 'where'
 *      page: // value for 'page'
 *      pageSize: // value for 'pageSize'
 *      orderBy: // value for 'orderBy'
 *   },
 * });
 */
export function useQueryInitiativesQuery(baseOptions?: Apollo.QueryHookOptions<QueryInitiativesQuery, QueryInitiativesQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<QueryInitiativesQuery, QueryInitiativesQueryVariables>(QueryInitiativesDocument, options);
      }
export function useQueryInitiativesLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<QueryInitiativesQuery, QueryInitiativesQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<QueryInitiativesQuery, QueryInitiativesQueryVariables>(QueryInitiativesDocument, options);
        }
export function useQueryInitiativesSuspenseQuery(baseOptions?: Apollo.SuspenseQueryHookOptions<QueryInitiativesQuery, QueryInitiativesQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useSuspenseQuery<QueryInitiativesQuery, QueryInitiativesQueryVariables>(QueryInitiativesDocument, options);
        }
export type QueryInitiativesQueryHookResult = ReturnType<typeof useQueryInitiativesQuery>;
export type QueryInitiativesLazyQueryHookResult = ReturnType<typeof useQueryInitiativesLazyQuery>;
export type QueryInitiativesSuspenseQueryHookResult = ReturnType<typeof useQueryInitiativesSuspenseQuery>;
export type QueryInitiativesQueryResult = Apollo.QueryResult<QueryInitiativesQuery, QueryInitiativesQueryVariables>;
export const CreateInitiativeDocument = gql`
    mutation createInitiative($data: CreateInitiativeInput!) {
  createInitiative(data: $data) {
    ...InitiativeFields
  }
}
    ${InitiativeFieldsFragmentDoc}`;
export type CreateInitiativeMutationFn = Apollo.MutationFunction<CreateInitiativeMutation, CreateInitiativeMutationVariables>;

/**
 * __useCreateInitiativeMutation__
 *
 * To run a mutation, you first call `useCreateInitiativeMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useCreateInitiativeMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [createInitiativeMutation, { data, loading, error }] = useCreateInitiativeMutation({
 *   variables: {
 *      data: // value for 'data'
 *   },
 * });
 */
export function useCreateInitiativeMutation(baseOptions?: Apollo.MutationHookOptions<CreateInitiativeMutation, CreateInitiativeMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<CreateInitiativeMutation, CreateInitiativeMutationVariables>(CreateInitiativeDocument, options);
      }
export type CreateInitiativeMutationHookResult = ReturnType<typeof useCreateInitiativeMutation>;
export type CreateInitiativeMutationResult = Apollo.MutationResult<CreateInitiativeMutation>;
export type CreateInitiativeMutationOptions = Apollo.BaseMutationOptions<CreateInitiativeMutation, CreateInitiativeMutationVariables>;
export const UpdateInitiativeDocument = gql`
    mutation updateInitiative($id: ID!, $data: UpdateInitiativeInput!) {
  updateInitiative(id: $id, data: $data) {
    ...InitiativeFields
  }
}
    ${InitiativeFieldsFragmentDoc}`;
export type UpdateInitiativeMutationFn = Apollo.MutationFunction<UpdateInitiativeMutation, UpdateInitiativeMutationVariables>;

/**
 * __useUpdateInitiativeMutation__
 *
 * To run a mutation, you first call `useUpdateInitiativeMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useUpdateInitiativeMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [updateInitiativeMutation, { data, loading, error }] = useUpdateInitiativeMutation({
 *   variables: {
 *      id: // value for 'id'
 *      data: // value for 'data'
 *   },
 * });
 */
export function useUpdateInitiativeMutation(baseOptions?: Apollo.MutationHookOptions<UpdateInitiativeMutation, UpdateInitiativeMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<UpdateInitiativeMutation, UpdateInitiativeMutationVariables>(UpdateInitiativeDocument, options);
      }
export type UpdateInitiativeMutationHookResult = ReturnType<typeof useUpdateInitiativeMutation>;
export type UpdateInitiativeMutationResult = Apollo.MutationResult<UpdateInitiativeMutation>;
export type UpdateInitiativeMutationOptions = Apollo.BaseMutationOptions<UpdateInitiativeMutation, UpdateInitiativeMutationVariables>;
export const GetInitiativeDocument = gql`
    query getInitiative($id: ID!) {
  initiative(id: $id) {
    ...InitiativeFields
  }
}
    ${InitiativeFieldsFragmentDoc}`;

/**
 * __useGetInitiativeQuery__
 *
 * To run a query within a React component, call `useGetInitiativeQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetInitiativeQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetInitiativeQuery({
 *   variables: {
 *      id: // value for 'id'
 *   },
 * });
 */
export function useGetInitiativeQuery(baseOptions: Apollo.QueryHookOptions<GetInitiativeQuery, GetInitiativeQueryVariables> & ({ variables: GetInitiativeQueryVariables; skip?: boolean; } | { skip: boolean; }) ) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<GetInitiativeQuery, GetInitiativeQueryVariables>(GetInitiativeDocument, options);
      }
export function useGetInitiativeLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<GetInitiativeQuery, GetInitiativeQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<GetInitiativeQuery, GetInitiativeQueryVariables>(GetInitiativeDocument, options);
        }
export function useGetInitiativeSuspenseQuery(baseOptions?: Apollo.SuspenseQueryHookOptions<GetInitiativeQuery, GetInitiativeQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useSuspenseQuery<GetInitiativeQuery, GetInitiativeQueryVariables>(GetInitiativeDocument, options);
        }
export type GetInitiativeQueryHookResult = ReturnType<typeof useGetInitiativeQuery>;
export type GetInitiativeLazyQueryHookResult = ReturnType<typeof useGetInitiativeLazyQuery>;
export type GetInitiativeSuspenseQueryHookResult = ReturnType<typeof useGetInitiativeSuspenseQuery>;
export type GetInitiativeQueryResult = Apollo.QueryResult<GetInitiativeQuery, GetInitiativeQueryVariables>;
export const ComputeInitiativeValuesDocument = gql`
    query computeInitiativeValues($id: ID!, $params: ComputeInitiativeValuesParams!) {
  computeInitiativeValues(id: $id, params: $params) {
    ...InitiativeResultFields
  }
}
    ${InitiativeResultFieldsFragmentDoc}`;

/**
 * __useComputeInitiativeValuesQuery__
 *
 * To run a query within a React component, call `useComputeInitiativeValuesQuery` and pass it any options that fit your needs.
 * When your component renders, `useComputeInitiativeValuesQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useComputeInitiativeValuesQuery({
 *   variables: {
 *      id: // value for 'id'
 *      params: // value for 'params'
 *   },
 * });
 */
export function useComputeInitiativeValuesQuery(baseOptions: Apollo.QueryHookOptions<ComputeInitiativeValuesQuery, ComputeInitiativeValuesQueryVariables> & ({ variables: ComputeInitiativeValuesQueryVariables; skip?: boolean; } | { skip: boolean; }) ) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<ComputeInitiativeValuesQuery, ComputeInitiativeValuesQueryVariables>(ComputeInitiativeValuesDocument, options);
      }
export function useComputeInitiativeValuesLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<ComputeInitiativeValuesQuery, ComputeInitiativeValuesQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<ComputeInitiativeValuesQuery, ComputeInitiativeValuesQueryVariables>(ComputeInitiativeValuesDocument, options);
        }
export function useComputeInitiativeValuesSuspenseQuery(baseOptions?: Apollo.SuspenseQueryHookOptions<ComputeInitiativeValuesQuery, ComputeInitiativeValuesQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useSuspenseQuery<ComputeInitiativeValuesQuery, ComputeInitiativeValuesQueryVariables>(ComputeInitiativeValuesDocument, options);
        }
export type ComputeInitiativeValuesQueryHookResult = ReturnType<typeof useComputeInitiativeValuesQuery>;
export type ComputeInitiativeValuesLazyQueryHookResult = ReturnType<typeof useComputeInitiativeValuesLazyQuery>;
export type ComputeInitiativeValuesSuspenseQueryHookResult = ReturnType<typeof useComputeInitiativeValuesSuspenseQuery>;
export type ComputeInitiativeValuesQueryResult = Apollo.QueryResult<ComputeInitiativeValuesQuery, ComputeInitiativeValuesQueryVariables>;
export const GetKpiGroupDocument = gql`
    query getKpiGroup($id: ID!) {
  kpiGroup(id: $id) {
    ...KpiGroupFields
  }
}
    ${KpiGroupFieldsFragmentDoc}`;

/**
 * __useGetKpiGroupQuery__
 *
 * To run a query within a React component, call `useGetKpiGroupQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetKpiGroupQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetKpiGroupQuery({
 *   variables: {
 *      id: // value for 'id'
 *   },
 * });
 */
export function useGetKpiGroupQuery(baseOptions: Apollo.QueryHookOptions<GetKpiGroupQuery, GetKpiGroupQueryVariables> & ({ variables: GetKpiGroupQueryVariables; skip?: boolean; } | { skip: boolean; }) ) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<GetKpiGroupQuery, GetKpiGroupQueryVariables>(GetKpiGroupDocument, options);
      }
export function useGetKpiGroupLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<GetKpiGroupQuery, GetKpiGroupQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<GetKpiGroupQuery, GetKpiGroupQueryVariables>(GetKpiGroupDocument, options);
        }
export function useGetKpiGroupSuspenseQuery(baseOptions?: Apollo.SuspenseQueryHookOptions<GetKpiGroupQuery, GetKpiGroupQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useSuspenseQuery<GetKpiGroupQuery, GetKpiGroupQueryVariables>(GetKpiGroupDocument, options);
        }
export type GetKpiGroupQueryHookResult = ReturnType<typeof useGetKpiGroupQuery>;
export type GetKpiGroupLazyQueryHookResult = ReturnType<typeof useGetKpiGroupLazyQuery>;
export type GetKpiGroupSuspenseQueryHookResult = ReturnType<typeof useGetKpiGroupSuspenseQuery>;
export type GetKpiGroupQueryResult = Apollo.QueryResult<GetKpiGroupQuery, GetKpiGroupQueryVariables>;
export const QueryKpiGroupsDocument = gql`
    query queryKpiGroups($where: [QueryInput!], $page: NonNegativeInt, $pageSize: NonNegativeInt, $orderBy: OrderByInput) {
  queryKpiGroups(
    where: $where
    page: $page
    pageSize: $pageSize
    orderBy: $orderBy
  ) {
    ...KpiGroupFields
  }
}
    ${KpiGroupFieldsFragmentDoc}`;

/**
 * __useQueryKpiGroupsQuery__
 *
 * To run a query within a React component, call `useQueryKpiGroupsQuery` and pass it any options that fit your needs.
 * When your component renders, `useQueryKpiGroupsQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useQueryKpiGroupsQuery({
 *   variables: {
 *      where: // value for 'where'
 *      page: // value for 'page'
 *      pageSize: // value for 'pageSize'
 *      orderBy: // value for 'orderBy'
 *   },
 * });
 */
export function useQueryKpiGroupsQuery(baseOptions?: Apollo.QueryHookOptions<QueryKpiGroupsQuery, QueryKpiGroupsQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<QueryKpiGroupsQuery, QueryKpiGroupsQueryVariables>(QueryKpiGroupsDocument, options);
      }
export function useQueryKpiGroupsLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<QueryKpiGroupsQuery, QueryKpiGroupsQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<QueryKpiGroupsQuery, QueryKpiGroupsQueryVariables>(QueryKpiGroupsDocument, options);
        }
export function useQueryKpiGroupsSuspenseQuery(baseOptions?: Apollo.SuspenseQueryHookOptions<QueryKpiGroupsQuery, QueryKpiGroupsQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useSuspenseQuery<QueryKpiGroupsQuery, QueryKpiGroupsQueryVariables>(QueryKpiGroupsDocument, options);
        }
export type QueryKpiGroupsQueryHookResult = ReturnType<typeof useQueryKpiGroupsQuery>;
export type QueryKpiGroupsLazyQueryHookResult = ReturnType<typeof useQueryKpiGroupsLazyQuery>;
export type QueryKpiGroupsSuspenseQueryHookResult = ReturnType<typeof useQueryKpiGroupsSuspenseQuery>;
export type QueryKpiGroupsQueryResult = Apollo.QueryResult<QueryKpiGroupsQuery, QueryKpiGroupsQueryVariables>;
export const CountKpiGroupsDocument = gql`
    query countKpiGroups($where: [QueryInput!]) {
  countKpiGroups(where: $where)
}
    `;

/**
 * __useCountKpiGroupsQuery__
 *
 * To run a query within a React component, call `useCountKpiGroupsQuery` and pass it any options that fit your needs.
 * When your component renders, `useCountKpiGroupsQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useCountKpiGroupsQuery({
 *   variables: {
 *      where: // value for 'where'
 *   },
 * });
 */
export function useCountKpiGroupsQuery(baseOptions?: Apollo.QueryHookOptions<CountKpiGroupsQuery, CountKpiGroupsQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<CountKpiGroupsQuery, CountKpiGroupsQueryVariables>(CountKpiGroupsDocument, options);
      }
export function useCountKpiGroupsLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<CountKpiGroupsQuery, CountKpiGroupsQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<CountKpiGroupsQuery, CountKpiGroupsQueryVariables>(CountKpiGroupsDocument, options);
        }
export function useCountKpiGroupsSuspenseQuery(baseOptions?: Apollo.SuspenseQueryHookOptions<CountKpiGroupsQuery, CountKpiGroupsQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useSuspenseQuery<CountKpiGroupsQuery, CountKpiGroupsQueryVariables>(CountKpiGroupsDocument, options);
        }
export type CountKpiGroupsQueryHookResult = ReturnType<typeof useCountKpiGroupsQuery>;
export type CountKpiGroupsLazyQueryHookResult = ReturnType<typeof useCountKpiGroupsLazyQuery>;
export type CountKpiGroupsSuspenseQueryHookResult = ReturnType<typeof useCountKpiGroupsSuspenseQuery>;
export type CountKpiGroupsQueryResult = Apollo.QueryResult<CountKpiGroupsQuery, CountKpiGroupsQueryVariables>;
export const CreateKpiGroupDocument = gql`
    mutation createKpiGroup($data: CreateKpiGroupInput!) {
  createKpiGroup(data: $data) {
    ...KpiGroupFields
  }
}
    ${KpiGroupFieldsFragmentDoc}`;
export type CreateKpiGroupMutationFn = Apollo.MutationFunction<CreateKpiGroupMutation, CreateKpiGroupMutationVariables>;

/**
 * __useCreateKpiGroupMutation__
 *
 * To run a mutation, you first call `useCreateKpiGroupMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useCreateKpiGroupMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [createKpiGroupMutation, { data, loading, error }] = useCreateKpiGroupMutation({
 *   variables: {
 *      data: // value for 'data'
 *   },
 * });
 */
export function useCreateKpiGroupMutation(baseOptions?: Apollo.MutationHookOptions<CreateKpiGroupMutation, CreateKpiGroupMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<CreateKpiGroupMutation, CreateKpiGroupMutationVariables>(CreateKpiGroupDocument, options);
      }
export type CreateKpiGroupMutationHookResult = ReturnType<typeof useCreateKpiGroupMutation>;
export type CreateKpiGroupMutationResult = Apollo.MutationResult<CreateKpiGroupMutation>;
export type CreateKpiGroupMutationOptions = Apollo.BaseMutationOptions<CreateKpiGroupMutation, CreateKpiGroupMutationVariables>;
export const UpdateKpiGroupDocument = gql`
    mutation updateKpiGroup($id: ID!, $data: UpdateKpiGroupInput!) {
  updateKpiGroup(id: $id, data: $data) {
    ...KpiGroupFields
  }
}
    ${KpiGroupFieldsFragmentDoc}`;
export type UpdateKpiGroupMutationFn = Apollo.MutationFunction<UpdateKpiGroupMutation, UpdateKpiGroupMutationVariables>;

/**
 * __useUpdateKpiGroupMutation__
 *
 * To run a mutation, you first call `useUpdateKpiGroupMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useUpdateKpiGroupMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [updateKpiGroupMutation, { data, loading, error }] = useUpdateKpiGroupMutation({
 *   variables: {
 *      id: // value for 'id'
 *      data: // value for 'data'
 *   },
 * });
 */
export function useUpdateKpiGroupMutation(baseOptions?: Apollo.MutationHookOptions<UpdateKpiGroupMutation, UpdateKpiGroupMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<UpdateKpiGroupMutation, UpdateKpiGroupMutationVariables>(UpdateKpiGroupDocument, options);
      }
export type UpdateKpiGroupMutationHookResult = ReturnType<typeof useUpdateKpiGroupMutation>;
export type UpdateKpiGroupMutationResult = Apollo.MutationResult<UpdateKpiGroupMutation>;
export type UpdateKpiGroupMutationOptions = Apollo.BaseMutationOptions<UpdateKpiGroupMutation, UpdateKpiGroupMutationVariables>;
export const UpdateKpiGroupMetricDocument = gql`
    mutation updateKpiGroupMetric($id: ID!, $data: UpdateKpiGroupMetricInput!) {
  updateKpiGroupMetric(id: $id, data: $data) {
    ...KpiGroupMetricFields
  }
}
    ${KpiGroupMetricFieldsFragmentDoc}`;
export type UpdateKpiGroupMetricMutationFn = Apollo.MutationFunction<UpdateKpiGroupMetricMutation, UpdateKpiGroupMetricMutationVariables>;

/**
 * __useUpdateKpiGroupMetricMutation__
 *
 * To run a mutation, you first call `useUpdateKpiGroupMetricMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useUpdateKpiGroupMetricMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [updateKpiGroupMetricMutation, { data, loading, error }] = useUpdateKpiGroupMetricMutation({
 *   variables: {
 *      id: // value for 'id'
 *      data: // value for 'data'
 *   },
 * });
 */
export function useUpdateKpiGroupMetricMutation(baseOptions?: Apollo.MutationHookOptions<UpdateKpiGroupMetricMutation, UpdateKpiGroupMetricMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<UpdateKpiGroupMetricMutation, UpdateKpiGroupMetricMutationVariables>(UpdateKpiGroupMetricDocument, options);
      }
export type UpdateKpiGroupMetricMutationHookResult = ReturnType<typeof useUpdateKpiGroupMetricMutation>;
export type UpdateKpiGroupMetricMutationResult = Apollo.MutationResult<UpdateKpiGroupMetricMutation>;
export type UpdateKpiGroupMetricMutationOptions = Apollo.BaseMutationOptions<UpdateKpiGroupMetricMutation, UpdateKpiGroupMetricMutationVariables>;
export const ComputeKpiGroupValuesDocument = gql`
    query computeKpiGroupValues($id: ID!, $options: ComputeKpiGroupValuesOptions) {
  computeKpiGroupValues(id: $id, options: $options) {
    ...KpiGroupResultFields
  }
}
    ${KpiGroupResultFieldsFragmentDoc}`;

/**
 * __useComputeKpiGroupValuesQuery__
 *
 * To run a query within a React component, call `useComputeKpiGroupValuesQuery` and pass it any options that fit your needs.
 * When your component renders, `useComputeKpiGroupValuesQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useComputeKpiGroupValuesQuery({
 *   variables: {
 *      id: // value for 'id'
 *      options: // value for 'options'
 *   },
 * });
 */
export function useComputeKpiGroupValuesQuery(baseOptions: Apollo.QueryHookOptions<ComputeKpiGroupValuesQuery, ComputeKpiGroupValuesQueryVariables> & ({ variables: ComputeKpiGroupValuesQueryVariables; skip?: boolean; } | { skip: boolean; }) ) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<ComputeKpiGroupValuesQuery, ComputeKpiGroupValuesQueryVariables>(ComputeKpiGroupValuesDocument, options);
      }
export function useComputeKpiGroupValuesLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<ComputeKpiGroupValuesQuery, ComputeKpiGroupValuesQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<ComputeKpiGroupValuesQuery, ComputeKpiGroupValuesQueryVariables>(ComputeKpiGroupValuesDocument, options);
        }
export function useComputeKpiGroupValuesSuspenseQuery(baseOptions?: Apollo.SuspenseQueryHookOptions<ComputeKpiGroupValuesQuery, ComputeKpiGroupValuesQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useSuspenseQuery<ComputeKpiGroupValuesQuery, ComputeKpiGroupValuesQueryVariables>(ComputeKpiGroupValuesDocument, options);
        }
export type ComputeKpiGroupValuesQueryHookResult = ReturnType<typeof useComputeKpiGroupValuesQuery>;
export type ComputeKpiGroupValuesLazyQueryHookResult = ReturnType<typeof useComputeKpiGroupValuesLazyQuery>;
export type ComputeKpiGroupValuesSuspenseQueryHookResult = ReturnType<typeof useComputeKpiGroupValuesSuspenseQuery>;
export type ComputeKpiGroupValuesQueryResult = Apollo.QueryResult<ComputeKpiGroupValuesQuery, ComputeKpiGroupValuesQueryVariables>;
export const CalculateClinicValuesForKpiGroupMetricDocument = gql`
    query calculateClinicValuesForKpiGroupMetric($id: ID!, $options: ComputeKpiGroupValuesOptions) {
  calculateClinicValuesForKpiGroupMetric(id: $id, options: $options) {
    ...KpiGroupMetricResultFields
  }
}
    ${KpiGroupMetricResultFieldsFragmentDoc}`;

/**
 * __useCalculateClinicValuesForKpiGroupMetricQuery__
 *
 * To run a query within a React component, call `useCalculateClinicValuesForKpiGroupMetricQuery` and pass it any options that fit your needs.
 * When your component renders, `useCalculateClinicValuesForKpiGroupMetricQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useCalculateClinicValuesForKpiGroupMetricQuery({
 *   variables: {
 *      id: // value for 'id'
 *      options: // value for 'options'
 *   },
 * });
 */
export function useCalculateClinicValuesForKpiGroupMetricQuery(baseOptions: Apollo.QueryHookOptions<CalculateClinicValuesForKpiGroupMetricQuery, CalculateClinicValuesForKpiGroupMetricQueryVariables> & ({ variables: CalculateClinicValuesForKpiGroupMetricQueryVariables; skip?: boolean; } | { skip: boolean; }) ) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<CalculateClinicValuesForKpiGroupMetricQuery, CalculateClinicValuesForKpiGroupMetricQueryVariables>(CalculateClinicValuesForKpiGroupMetricDocument, options);
      }
export function useCalculateClinicValuesForKpiGroupMetricLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<CalculateClinicValuesForKpiGroupMetricQuery, CalculateClinicValuesForKpiGroupMetricQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<CalculateClinicValuesForKpiGroupMetricQuery, CalculateClinicValuesForKpiGroupMetricQueryVariables>(CalculateClinicValuesForKpiGroupMetricDocument, options);
        }
export function useCalculateClinicValuesForKpiGroupMetricSuspenseQuery(baseOptions?: Apollo.SuspenseQueryHookOptions<CalculateClinicValuesForKpiGroupMetricQuery, CalculateClinicValuesForKpiGroupMetricQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useSuspenseQuery<CalculateClinicValuesForKpiGroupMetricQuery, CalculateClinicValuesForKpiGroupMetricQueryVariables>(CalculateClinicValuesForKpiGroupMetricDocument, options);
        }
export type CalculateClinicValuesForKpiGroupMetricQueryHookResult = ReturnType<typeof useCalculateClinicValuesForKpiGroupMetricQuery>;
export type CalculateClinicValuesForKpiGroupMetricLazyQueryHookResult = ReturnType<typeof useCalculateClinicValuesForKpiGroupMetricLazyQuery>;
export type CalculateClinicValuesForKpiGroupMetricSuspenseQueryHookResult = ReturnType<typeof useCalculateClinicValuesForKpiGroupMetricSuspenseQuery>;
export type CalculateClinicValuesForKpiGroupMetricQueryResult = Apollo.QueryResult<CalculateClinicValuesForKpiGroupMetricQuery, CalculateClinicValuesForKpiGroupMetricQueryVariables>;
export const GetOrganizationReportDocument = gql`
    query getOrganizationReport($id: ID!) {
  organizationReport(id: $id) {
    ...OrganizationReportFields
  }
}
    ${OrganizationReportFieldsFragmentDoc}`;

/**
 * __useGetOrganizationReportQuery__
 *
 * To run a query within a React component, call `useGetOrganizationReportQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetOrganizationReportQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetOrganizationReportQuery({
 *   variables: {
 *      id: // value for 'id'
 *   },
 * });
 */
export function useGetOrganizationReportQuery(baseOptions: Apollo.QueryHookOptions<GetOrganizationReportQuery, GetOrganizationReportQueryVariables> & ({ variables: GetOrganizationReportQueryVariables; skip?: boolean; } | { skip: boolean; }) ) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<GetOrganizationReportQuery, GetOrganizationReportQueryVariables>(GetOrganizationReportDocument, options);
      }
export function useGetOrganizationReportLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<GetOrganizationReportQuery, GetOrganizationReportQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<GetOrganizationReportQuery, GetOrganizationReportQueryVariables>(GetOrganizationReportDocument, options);
        }
export function useGetOrganizationReportSuspenseQuery(baseOptions?: Apollo.SuspenseQueryHookOptions<GetOrganizationReportQuery, GetOrganizationReportQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useSuspenseQuery<GetOrganizationReportQuery, GetOrganizationReportQueryVariables>(GetOrganizationReportDocument, options);
        }
export type GetOrganizationReportQueryHookResult = ReturnType<typeof useGetOrganizationReportQuery>;
export type GetOrganizationReportLazyQueryHookResult = ReturnType<typeof useGetOrganizationReportLazyQuery>;
export type GetOrganizationReportSuspenseQueryHookResult = ReturnType<typeof useGetOrganizationReportSuspenseQuery>;
export type GetOrganizationReportQueryResult = Apollo.QueryResult<GetOrganizationReportQuery, GetOrganizationReportQueryVariables>;
export const GetRealTimeReportDocument = gql`
    query getRealTimeReport($params: RealTimeReportParams!) {
  getRealTimeReport(params: $params) {
    ...OrganizationReportFields
  }
}
    ${OrganizationReportFieldsFragmentDoc}`;

/**
 * __useGetRealTimeReportQuery__
 *
 * To run a query within a React component, call `useGetRealTimeReportQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetRealTimeReportQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetRealTimeReportQuery({
 *   variables: {
 *      params: // value for 'params'
 *   },
 * });
 */
export function useGetRealTimeReportQuery(baseOptions: Apollo.QueryHookOptions<GetRealTimeReportQuery, GetRealTimeReportQueryVariables> & ({ variables: GetRealTimeReportQueryVariables; skip?: boolean; } | { skip: boolean; }) ) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<GetRealTimeReportQuery, GetRealTimeReportQueryVariables>(GetRealTimeReportDocument, options);
      }
export function useGetRealTimeReportLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<GetRealTimeReportQuery, GetRealTimeReportQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<GetRealTimeReportQuery, GetRealTimeReportQueryVariables>(GetRealTimeReportDocument, options);
        }
export function useGetRealTimeReportSuspenseQuery(baseOptions?: Apollo.SuspenseQueryHookOptions<GetRealTimeReportQuery, GetRealTimeReportQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useSuspenseQuery<GetRealTimeReportQuery, GetRealTimeReportQueryVariables>(GetRealTimeReportDocument, options);
        }
export type GetRealTimeReportQueryHookResult = ReturnType<typeof useGetRealTimeReportQuery>;
export type GetRealTimeReportLazyQueryHookResult = ReturnType<typeof useGetRealTimeReportLazyQuery>;
export type GetRealTimeReportSuspenseQueryHookResult = ReturnType<typeof useGetRealTimeReportSuspenseQuery>;
export type GetRealTimeReportQueryResult = Apollo.QueryResult<GetRealTimeReportQuery, GetRealTimeReportQueryVariables>;
export const QueryOrganizationReportsDocument = gql`
    query queryOrganizationReports($where: [QueryInput!], $page: NonNegativeInt, $pageSize: NonNegativeInt, $orderBy: OrderByInput) {
  queryOrganizationReports(
    where: $where
    page: $page
    pageSize: $pageSize
    orderBy: $orderBy
  ) {
    ...OrganizationReportFields
  }
}
    ${OrganizationReportFieldsFragmentDoc}`;

/**
 * __useQueryOrganizationReportsQuery__
 *
 * To run a query within a React component, call `useQueryOrganizationReportsQuery` and pass it any options that fit your needs.
 * When your component renders, `useQueryOrganizationReportsQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useQueryOrganizationReportsQuery({
 *   variables: {
 *      where: // value for 'where'
 *      page: // value for 'page'
 *      pageSize: // value for 'pageSize'
 *      orderBy: // value for 'orderBy'
 *   },
 * });
 */
export function useQueryOrganizationReportsQuery(baseOptions?: Apollo.QueryHookOptions<QueryOrganizationReportsQuery, QueryOrganizationReportsQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<QueryOrganizationReportsQuery, QueryOrganizationReportsQueryVariables>(QueryOrganizationReportsDocument, options);
      }
export function useQueryOrganizationReportsLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<QueryOrganizationReportsQuery, QueryOrganizationReportsQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<QueryOrganizationReportsQuery, QueryOrganizationReportsQueryVariables>(QueryOrganizationReportsDocument, options);
        }
export function useQueryOrganizationReportsSuspenseQuery(baseOptions?: Apollo.SuspenseQueryHookOptions<QueryOrganizationReportsQuery, QueryOrganizationReportsQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useSuspenseQuery<QueryOrganizationReportsQuery, QueryOrganizationReportsQueryVariables>(QueryOrganizationReportsDocument, options);
        }
export type QueryOrganizationReportsQueryHookResult = ReturnType<typeof useQueryOrganizationReportsQuery>;
export type QueryOrganizationReportsLazyQueryHookResult = ReturnType<typeof useQueryOrganizationReportsLazyQuery>;
export type QueryOrganizationReportsSuspenseQueryHookResult = ReturnType<typeof useQueryOrganizationReportsSuspenseQuery>;
export type QueryOrganizationReportsQueryResult = Apollo.QueryResult<QueryOrganizationReportsQuery, QueryOrganizationReportsQueryVariables>;
export const QueryOrganizationReportPreviewsDocument = gql`
    query queryOrganizationReportPreviews($where: [QueryInput!], $page: NonNegativeInt, $pageSize: NonNegativeInt, $orderBy: OrderByInput) {
  queryOrganizationReports(
    where: $where
    page: $page
    pageSize: $pageSize
    orderBy: $orderBy
  ) {
    ...OrganizationReportPreviewFields
  }
}
    ${OrganizationReportPreviewFieldsFragmentDoc}`;

/**
 * __useQueryOrganizationReportPreviewsQuery__
 *
 * To run a query within a React component, call `useQueryOrganizationReportPreviewsQuery` and pass it any options that fit your needs.
 * When your component renders, `useQueryOrganizationReportPreviewsQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useQueryOrganizationReportPreviewsQuery({
 *   variables: {
 *      where: // value for 'where'
 *      page: // value for 'page'
 *      pageSize: // value for 'pageSize'
 *      orderBy: // value for 'orderBy'
 *   },
 * });
 */
export function useQueryOrganizationReportPreviewsQuery(baseOptions?: Apollo.QueryHookOptions<QueryOrganizationReportPreviewsQuery, QueryOrganizationReportPreviewsQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<QueryOrganizationReportPreviewsQuery, QueryOrganizationReportPreviewsQueryVariables>(QueryOrganizationReportPreviewsDocument, options);
      }
export function useQueryOrganizationReportPreviewsLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<QueryOrganizationReportPreviewsQuery, QueryOrganizationReportPreviewsQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<QueryOrganizationReportPreviewsQuery, QueryOrganizationReportPreviewsQueryVariables>(QueryOrganizationReportPreviewsDocument, options);
        }
export function useQueryOrganizationReportPreviewsSuspenseQuery(baseOptions?: Apollo.SuspenseQueryHookOptions<QueryOrganizationReportPreviewsQuery, QueryOrganizationReportPreviewsQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useSuspenseQuery<QueryOrganizationReportPreviewsQuery, QueryOrganizationReportPreviewsQueryVariables>(QueryOrganizationReportPreviewsDocument, options);
        }
export type QueryOrganizationReportPreviewsQueryHookResult = ReturnType<typeof useQueryOrganizationReportPreviewsQuery>;
export type QueryOrganizationReportPreviewsLazyQueryHookResult = ReturnType<typeof useQueryOrganizationReportPreviewsLazyQuery>;
export type QueryOrganizationReportPreviewsSuspenseQueryHookResult = ReturnType<typeof useQueryOrganizationReportPreviewsSuspenseQuery>;
export type QueryOrganizationReportPreviewsQueryResult = Apollo.QueryResult<QueryOrganizationReportPreviewsQuery, QueryOrganizationReportPreviewsQueryVariables>;
export const CreateReportClinicDocument = gql`
    mutation createReportClinic($data: CreateReportClinicInput!) {
  createReportClinic(data: $data) {
    ...ReportClinicFields
  }
}
    ${ReportClinicFieldsFragmentDoc}`;
export type CreateReportClinicMutationFn = Apollo.MutationFunction<CreateReportClinicMutation, CreateReportClinicMutationVariables>;

/**
 * __useCreateReportClinicMutation__
 *
 * To run a mutation, you first call `useCreateReportClinicMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useCreateReportClinicMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [createReportClinicMutation, { data, loading, error }] = useCreateReportClinicMutation({
 *   variables: {
 *      data: // value for 'data'
 *   },
 * });
 */
export function useCreateReportClinicMutation(baseOptions?: Apollo.MutationHookOptions<CreateReportClinicMutation, CreateReportClinicMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<CreateReportClinicMutation, CreateReportClinicMutationVariables>(CreateReportClinicDocument, options);
      }
export type CreateReportClinicMutationHookResult = ReturnType<typeof useCreateReportClinicMutation>;
export type CreateReportClinicMutationResult = Apollo.MutationResult<CreateReportClinicMutation>;
export type CreateReportClinicMutationOptions = Apollo.BaseMutationOptions<CreateReportClinicMutation, CreateReportClinicMutationVariables>;
export const DeleteReportClinicDocument = gql`
    mutation deleteReportClinic($id: ID!) {
  deleteReportClinic(id: $id)
}
    `;
export type DeleteReportClinicMutationFn = Apollo.MutationFunction<DeleteReportClinicMutation, DeleteReportClinicMutationVariables>;

/**
 * __useDeleteReportClinicMutation__
 *
 * To run a mutation, you first call `useDeleteReportClinicMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useDeleteReportClinicMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [deleteReportClinicMutation, { data, loading, error }] = useDeleteReportClinicMutation({
 *   variables: {
 *      id: // value for 'id'
 *   },
 * });
 */
export function useDeleteReportClinicMutation(baseOptions?: Apollo.MutationHookOptions<DeleteReportClinicMutation, DeleteReportClinicMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<DeleteReportClinicMutation, DeleteReportClinicMutationVariables>(DeleteReportClinicDocument, options);
      }
export type DeleteReportClinicMutationHookResult = ReturnType<typeof useDeleteReportClinicMutation>;
export type DeleteReportClinicMutationResult = Apollo.MutationResult<DeleteReportClinicMutation>;
export type DeleteReportClinicMutationOptions = Apollo.BaseMutationOptions<DeleteReportClinicMutation, DeleteReportClinicMutationVariables>;
export const GetReportMetricDocument = gql`
    query getReportMetric($id: ID!) {
  reportMetric(id: $id) {
    ...ReportMetricFields
  }
}
    ${ReportMetricFieldsFragmentDoc}`;

/**
 * __useGetReportMetricQuery__
 *
 * To run a query within a React component, call `useGetReportMetricQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetReportMetricQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetReportMetricQuery({
 *   variables: {
 *      id: // value for 'id'
 *   },
 * });
 */
export function useGetReportMetricQuery(baseOptions: Apollo.QueryHookOptions<GetReportMetricQuery, GetReportMetricQueryVariables> & ({ variables: GetReportMetricQueryVariables; skip?: boolean; } | { skip: boolean; }) ) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<GetReportMetricQuery, GetReportMetricQueryVariables>(GetReportMetricDocument, options);
      }
export function useGetReportMetricLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<GetReportMetricQuery, GetReportMetricQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<GetReportMetricQuery, GetReportMetricQueryVariables>(GetReportMetricDocument, options);
        }
export function useGetReportMetricSuspenseQuery(baseOptions?: Apollo.SuspenseQueryHookOptions<GetReportMetricQuery, GetReportMetricQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useSuspenseQuery<GetReportMetricQuery, GetReportMetricQueryVariables>(GetReportMetricDocument, options);
        }
export type GetReportMetricQueryHookResult = ReturnType<typeof useGetReportMetricQuery>;
export type GetReportMetricLazyQueryHookResult = ReturnType<typeof useGetReportMetricLazyQuery>;
export type GetReportMetricSuspenseQueryHookResult = ReturnType<typeof useGetReportMetricSuspenseQuery>;
export type GetReportMetricQueryResult = Apollo.QueryResult<GetReportMetricQuery, GetReportMetricQueryVariables>;
export const QueryReportMetricsDocument = gql`
    query queryReportMetrics($where: [QueryInput!], $page: NonNegativeInt, $pageSize: NonNegativeInt, $orderBy: OrderByInput) {
  queryReportMetrics(
    where: $where
    page: $page
    pageSize: $pageSize
    orderBy: $orderBy
  ) {
    ...ReportMetricFields
  }
}
    ${ReportMetricFieldsFragmentDoc}`;

/**
 * __useQueryReportMetricsQuery__
 *
 * To run a query within a React component, call `useQueryReportMetricsQuery` and pass it any options that fit your needs.
 * When your component renders, `useQueryReportMetricsQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useQueryReportMetricsQuery({
 *   variables: {
 *      where: // value for 'where'
 *      page: // value for 'page'
 *      pageSize: // value for 'pageSize'
 *      orderBy: // value for 'orderBy'
 *   },
 * });
 */
export function useQueryReportMetricsQuery(baseOptions?: Apollo.QueryHookOptions<QueryReportMetricsQuery, QueryReportMetricsQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<QueryReportMetricsQuery, QueryReportMetricsQueryVariables>(QueryReportMetricsDocument, options);
      }
export function useQueryReportMetricsLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<QueryReportMetricsQuery, QueryReportMetricsQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<QueryReportMetricsQuery, QueryReportMetricsQueryVariables>(QueryReportMetricsDocument, options);
        }
export function useQueryReportMetricsSuspenseQuery(baseOptions?: Apollo.SuspenseQueryHookOptions<QueryReportMetricsQuery, QueryReportMetricsQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useSuspenseQuery<QueryReportMetricsQuery, QueryReportMetricsQueryVariables>(QueryReportMetricsDocument, options);
        }
export type QueryReportMetricsQueryHookResult = ReturnType<typeof useQueryReportMetricsQuery>;
export type QueryReportMetricsLazyQueryHookResult = ReturnType<typeof useQueryReportMetricsLazyQuery>;
export type QueryReportMetricsSuspenseQueryHookResult = ReturnType<typeof useQueryReportMetricsSuspenseQuery>;
export type QueryReportMetricsQueryResult = Apollo.QueryResult<QueryReportMetricsQuery, QueryReportMetricsQueryVariables>;
export const CountReportMetricsDocument = gql`
    query countReportMetrics($where: [QueryInput!]) {
  countReportMetrics(where: $where)
}
    `;

/**
 * __useCountReportMetricsQuery__
 *
 * To run a query within a React component, call `useCountReportMetricsQuery` and pass it any options that fit your needs.
 * When your component renders, `useCountReportMetricsQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useCountReportMetricsQuery({
 *   variables: {
 *      where: // value for 'where'
 *   },
 * });
 */
export function useCountReportMetricsQuery(baseOptions?: Apollo.QueryHookOptions<CountReportMetricsQuery, CountReportMetricsQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<CountReportMetricsQuery, CountReportMetricsQueryVariables>(CountReportMetricsDocument, options);
      }
export function useCountReportMetricsLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<CountReportMetricsQuery, CountReportMetricsQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<CountReportMetricsQuery, CountReportMetricsQueryVariables>(CountReportMetricsDocument, options);
        }
export function useCountReportMetricsSuspenseQuery(baseOptions?: Apollo.SuspenseQueryHookOptions<CountReportMetricsQuery, CountReportMetricsQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useSuspenseQuery<CountReportMetricsQuery, CountReportMetricsQueryVariables>(CountReportMetricsDocument, options);
        }
export type CountReportMetricsQueryHookResult = ReturnType<typeof useCountReportMetricsQuery>;
export type CountReportMetricsLazyQueryHookResult = ReturnType<typeof useCountReportMetricsLazyQuery>;
export type CountReportMetricsSuspenseQueryHookResult = ReturnType<typeof useCountReportMetricsSuspenseQuery>;
export type CountReportMetricsQueryResult = Apollo.QueryResult<CountReportMetricsQuery, CountReportMetricsQueryVariables>;
export const CreateReportMetricDocument = gql`
    mutation createReportMetric($data: CreateReportMetricInput!) {
  createReportMetric(data: $data) {
    ...ReportMetricFields
  }
}
    ${ReportMetricFieldsFragmentDoc}`;
export type CreateReportMetricMutationFn = Apollo.MutationFunction<CreateReportMetricMutation, CreateReportMetricMutationVariables>;

/**
 * __useCreateReportMetricMutation__
 *
 * To run a mutation, you first call `useCreateReportMetricMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useCreateReportMetricMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [createReportMetricMutation, { data, loading, error }] = useCreateReportMetricMutation({
 *   variables: {
 *      data: // value for 'data'
 *   },
 * });
 */
export function useCreateReportMetricMutation(baseOptions?: Apollo.MutationHookOptions<CreateReportMetricMutation, CreateReportMetricMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<CreateReportMetricMutation, CreateReportMetricMutationVariables>(CreateReportMetricDocument, options);
      }
export type CreateReportMetricMutationHookResult = ReturnType<typeof useCreateReportMetricMutation>;
export type CreateReportMetricMutationResult = Apollo.MutationResult<CreateReportMetricMutation>;
export type CreateReportMetricMutationOptions = Apollo.BaseMutationOptions<CreateReportMetricMutation, CreateReportMetricMutationVariables>;
export const UpdateReportMetricDocument = gql`
    mutation updateReportMetric($id: ID!, $data: UpdateReportMetricInput!) {
  updateReportMetric(id: $id, data: $data) {
    ...ReportMetricFields
  }
}
    ${ReportMetricFieldsFragmentDoc}`;
export type UpdateReportMetricMutationFn = Apollo.MutationFunction<UpdateReportMetricMutation, UpdateReportMetricMutationVariables>;

/**
 * __useUpdateReportMetricMutation__
 *
 * To run a mutation, you first call `useUpdateReportMetricMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useUpdateReportMetricMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [updateReportMetricMutation, { data, loading, error }] = useUpdateReportMetricMutation({
 *   variables: {
 *      id: // value for 'id'
 *      data: // value for 'data'
 *   },
 * });
 */
export function useUpdateReportMetricMutation(baseOptions?: Apollo.MutationHookOptions<UpdateReportMetricMutation, UpdateReportMetricMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<UpdateReportMetricMutation, UpdateReportMetricMutationVariables>(UpdateReportMetricDocument, options);
      }
export type UpdateReportMetricMutationHookResult = ReturnType<typeof useUpdateReportMetricMutation>;
export type UpdateReportMetricMutationResult = Apollo.MutationResult<UpdateReportMetricMutation>;
export type UpdateReportMetricMutationOptions = Apollo.BaseMutationOptions<UpdateReportMetricMutation, UpdateReportMetricMutationVariables>;
export const GetReportTemplateDocument = gql`
    query getReportTemplate($id: ID!) {
  reportTemplate(id: $id) {
    ...ReportTemplateFields
  }
}
    ${ReportTemplateFieldsFragmentDoc}`;

/**
 * __useGetReportTemplateQuery__
 *
 * To run a query within a React component, call `useGetReportTemplateQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetReportTemplateQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetReportTemplateQuery({
 *   variables: {
 *      id: // value for 'id'
 *   },
 * });
 */
export function useGetReportTemplateQuery(baseOptions: Apollo.QueryHookOptions<GetReportTemplateQuery, GetReportTemplateQueryVariables> & ({ variables: GetReportTemplateQueryVariables; skip?: boolean; } | { skip: boolean; }) ) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<GetReportTemplateQuery, GetReportTemplateQueryVariables>(GetReportTemplateDocument, options);
      }
export function useGetReportTemplateLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<GetReportTemplateQuery, GetReportTemplateQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<GetReportTemplateQuery, GetReportTemplateQueryVariables>(GetReportTemplateDocument, options);
        }
export function useGetReportTemplateSuspenseQuery(baseOptions?: Apollo.SuspenseQueryHookOptions<GetReportTemplateQuery, GetReportTemplateQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useSuspenseQuery<GetReportTemplateQuery, GetReportTemplateQueryVariables>(GetReportTemplateDocument, options);
        }
export type GetReportTemplateQueryHookResult = ReturnType<typeof useGetReportTemplateQuery>;
export type GetReportTemplateLazyQueryHookResult = ReturnType<typeof useGetReportTemplateLazyQuery>;
export type GetReportTemplateSuspenseQueryHookResult = ReturnType<typeof useGetReportTemplateSuspenseQuery>;
export type GetReportTemplateQueryResult = Apollo.QueryResult<GetReportTemplateQuery, GetReportTemplateQueryVariables>;
export const QueryReportTemplatesDocument = gql`
    query queryReportTemplates($where: [QueryInput!], $page: NonNegativeInt, $pageSize: NonNegativeInt, $orderBy: OrderByInput) {
  queryReportTemplates(
    where: $where
    page: $page
    pageSize: $pageSize
    orderBy: $orderBy
  ) {
    ...ReportTemplateFields
  }
}
    ${ReportTemplateFieldsFragmentDoc}`;

/**
 * __useQueryReportTemplatesQuery__
 *
 * To run a query within a React component, call `useQueryReportTemplatesQuery` and pass it any options that fit your needs.
 * When your component renders, `useQueryReportTemplatesQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useQueryReportTemplatesQuery({
 *   variables: {
 *      where: // value for 'where'
 *      page: // value for 'page'
 *      pageSize: // value for 'pageSize'
 *      orderBy: // value for 'orderBy'
 *   },
 * });
 */
export function useQueryReportTemplatesQuery(baseOptions?: Apollo.QueryHookOptions<QueryReportTemplatesQuery, QueryReportTemplatesQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<QueryReportTemplatesQuery, QueryReportTemplatesQueryVariables>(QueryReportTemplatesDocument, options);
      }
export function useQueryReportTemplatesLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<QueryReportTemplatesQuery, QueryReportTemplatesQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<QueryReportTemplatesQuery, QueryReportTemplatesQueryVariables>(QueryReportTemplatesDocument, options);
        }
export function useQueryReportTemplatesSuspenseQuery(baseOptions?: Apollo.SuspenseQueryHookOptions<QueryReportTemplatesQuery, QueryReportTemplatesQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useSuspenseQuery<QueryReportTemplatesQuery, QueryReportTemplatesQueryVariables>(QueryReportTemplatesDocument, options);
        }
export type QueryReportTemplatesQueryHookResult = ReturnType<typeof useQueryReportTemplatesQuery>;
export type QueryReportTemplatesLazyQueryHookResult = ReturnType<typeof useQueryReportTemplatesLazyQuery>;
export type QueryReportTemplatesSuspenseQueryHookResult = ReturnType<typeof useQueryReportTemplatesSuspenseQuery>;
export type QueryReportTemplatesQueryResult = Apollo.QueryResult<QueryReportTemplatesQuery, QueryReportTemplatesQueryVariables>;
export const ComputeReportTemplateValuesDocument = gql`
    query computeReportTemplateValues($id: ID!, $options: ComputeReportTemplateValuesOptions) {
  computeReportTemplateValues(id: $id, options: $options) {
    ...ReportTemplateResultFields
  }
}
    ${ReportTemplateResultFieldsFragmentDoc}`;

/**
 * __useComputeReportTemplateValuesQuery__
 *
 * To run a query within a React component, call `useComputeReportTemplateValuesQuery` and pass it any options that fit your needs.
 * When your component renders, `useComputeReportTemplateValuesQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useComputeReportTemplateValuesQuery({
 *   variables: {
 *      id: // value for 'id'
 *      options: // value for 'options'
 *   },
 * });
 */
export function useComputeReportTemplateValuesQuery(baseOptions: Apollo.QueryHookOptions<ComputeReportTemplateValuesQuery, ComputeReportTemplateValuesQueryVariables> & ({ variables: ComputeReportTemplateValuesQueryVariables; skip?: boolean; } | { skip: boolean; }) ) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<ComputeReportTemplateValuesQuery, ComputeReportTemplateValuesQueryVariables>(ComputeReportTemplateValuesDocument, options);
      }
export function useComputeReportTemplateValuesLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<ComputeReportTemplateValuesQuery, ComputeReportTemplateValuesQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<ComputeReportTemplateValuesQuery, ComputeReportTemplateValuesQueryVariables>(ComputeReportTemplateValuesDocument, options);
        }
export function useComputeReportTemplateValuesSuspenseQuery(baseOptions?: Apollo.SuspenseQueryHookOptions<ComputeReportTemplateValuesQuery, ComputeReportTemplateValuesQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useSuspenseQuery<ComputeReportTemplateValuesQuery, ComputeReportTemplateValuesQueryVariables>(ComputeReportTemplateValuesDocument, options);
        }
export type ComputeReportTemplateValuesQueryHookResult = ReturnType<typeof useComputeReportTemplateValuesQuery>;
export type ComputeReportTemplateValuesLazyQueryHookResult = ReturnType<typeof useComputeReportTemplateValuesLazyQuery>;
export type ComputeReportTemplateValuesSuspenseQueryHookResult = ReturnType<typeof useComputeReportTemplateValuesSuspenseQuery>;
export type ComputeReportTemplateValuesQueryResult = Apollo.QueryResult<ComputeReportTemplateValuesQuery, ComputeReportTemplateValuesQueryVariables>;
export const CreateReportTemplateDocument = gql`
    mutation createReportTemplate($data: CreateReportTemplateInput!) {
  createReportTemplate(data: $data) {
    ...ReportTemplateFields
  }
}
    ${ReportTemplateFieldsFragmentDoc}`;
export type CreateReportTemplateMutationFn = Apollo.MutationFunction<CreateReportTemplateMutation, CreateReportTemplateMutationVariables>;

/**
 * __useCreateReportTemplateMutation__
 *
 * To run a mutation, you first call `useCreateReportTemplateMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useCreateReportTemplateMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [createReportTemplateMutation, { data, loading, error }] = useCreateReportTemplateMutation({
 *   variables: {
 *      data: // value for 'data'
 *   },
 * });
 */
export function useCreateReportTemplateMutation(baseOptions?: Apollo.MutationHookOptions<CreateReportTemplateMutation, CreateReportTemplateMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<CreateReportTemplateMutation, CreateReportTemplateMutationVariables>(CreateReportTemplateDocument, options);
      }
export type CreateReportTemplateMutationHookResult = ReturnType<typeof useCreateReportTemplateMutation>;
export type CreateReportTemplateMutationResult = Apollo.MutationResult<CreateReportTemplateMutation>;
export type CreateReportTemplateMutationOptions = Apollo.BaseMutationOptions<CreateReportTemplateMutation, CreateReportTemplateMutationVariables>;
export const UpdateReportTemplateDocument = gql`
    mutation updateReportTemplate($id: ID!, $data: UpdateReportTemplateInput!) {
  updateReportTemplate(id: $id, data: $data) {
    ...ReportTemplateFields
  }
}
    ${ReportTemplateFieldsFragmentDoc}`;
export type UpdateReportTemplateMutationFn = Apollo.MutationFunction<UpdateReportTemplateMutation, UpdateReportTemplateMutationVariables>;

/**
 * __useUpdateReportTemplateMutation__
 *
 * To run a mutation, you first call `useUpdateReportTemplateMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useUpdateReportTemplateMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [updateReportTemplateMutation, { data, loading, error }] = useUpdateReportTemplateMutation({
 *   variables: {
 *      id: // value for 'id'
 *      data: // value for 'data'
 *   },
 * });
 */
export function useUpdateReportTemplateMutation(baseOptions?: Apollo.MutationHookOptions<UpdateReportTemplateMutation, UpdateReportTemplateMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<UpdateReportTemplateMutation, UpdateReportTemplateMutationVariables>(UpdateReportTemplateDocument, options);
      }
export type UpdateReportTemplateMutationHookResult = ReturnType<typeof useUpdateReportTemplateMutation>;
export type UpdateReportTemplateMutationResult = Apollo.MutationResult<UpdateReportTemplateMutation>;
export type UpdateReportTemplateMutationOptions = Apollo.BaseMutationOptions<UpdateReportTemplateMutation, UpdateReportTemplateMutationVariables>;
export const GetTemplatesForClinicReportsDocument = gql`
    query getTemplatesForClinicReports($clinic: ID!) {
  getTemplatesForClinicReports(clinic: $clinic) {
    ...ClinicReportTemplateFields
  }
}
    ${ClinicReportTemplateFieldsFragmentDoc}`;

/**
 * __useGetTemplatesForClinicReportsQuery__
 *
 * To run a query within a React component, call `useGetTemplatesForClinicReportsQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetTemplatesForClinicReportsQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetTemplatesForClinicReportsQuery({
 *   variables: {
 *      clinic: // value for 'clinic'
 *   },
 * });
 */
export function useGetTemplatesForClinicReportsQuery(baseOptions: Apollo.QueryHookOptions<GetTemplatesForClinicReportsQuery, GetTemplatesForClinicReportsQueryVariables> & ({ variables: GetTemplatesForClinicReportsQueryVariables; skip?: boolean; } | { skip: boolean; }) ) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<GetTemplatesForClinicReportsQuery, GetTemplatesForClinicReportsQueryVariables>(GetTemplatesForClinicReportsDocument, options);
      }
export function useGetTemplatesForClinicReportsLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<GetTemplatesForClinicReportsQuery, GetTemplatesForClinicReportsQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<GetTemplatesForClinicReportsQuery, GetTemplatesForClinicReportsQueryVariables>(GetTemplatesForClinicReportsDocument, options);
        }
export function useGetTemplatesForClinicReportsSuspenseQuery(baseOptions?: Apollo.SuspenseQueryHookOptions<GetTemplatesForClinicReportsQuery, GetTemplatesForClinicReportsQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useSuspenseQuery<GetTemplatesForClinicReportsQuery, GetTemplatesForClinicReportsQueryVariables>(GetTemplatesForClinicReportsDocument, options);
        }
export type GetTemplatesForClinicReportsQueryHookResult = ReturnType<typeof useGetTemplatesForClinicReportsQuery>;
export type GetTemplatesForClinicReportsLazyQueryHookResult = ReturnType<typeof useGetTemplatesForClinicReportsLazyQuery>;
export type GetTemplatesForClinicReportsSuspenseQueryHookResult = ReturnType<typeof useGetTemplatesForClinicReportsSuspenseQuery>;
export type GetTemplatesForClinicReportsQueryResult = Apollo.QueryResult<GetTemplatesForClinicReportsQuery, GetTemplatesForClinicReportsQueryVariables>;
export const CreateTemplateClinicDocument = gql`
    mutation createTemplateClinic($data: CreateTemplateClinicInput!) {
  createTemplateClinic(data: $data) {
    ...TemplateClinicFields
  }
}
    ${TemplateClinicFieldsFragmentDoc}`;
export type CreateTemplateClinicMutationFn = Apollo.MutationFunction<CreateTemplateClinicMutation, CreateTemplateClinicMutationVariables>;

/**
 * __useCreateTemplateClinicMutation__
 *
 * To run a mutation, you first call `useCreateTemplateClinicMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useCreateTemplateClinicMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [createTemplateClinicMutation, { data, loading, error }] = useCreateTemplateClinicMutation({
 *   variables: {
 *      data: // value for 'data'
 *   },
 * });
 */
export function useCreateTemplateClinicMutation(baseOptions?: Apollo.MutationHookOptions<CreateTemplateClinicMutation, CreateTemplateClinicMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<CreateTemplateClinicMutation, CreateTemplateClinicMutationVariables>(CreateTemplateClinicDocument, options);
      }
export type CreateTemplateClinicMutationHookResult = ReturnType<typeof useCreateTemplateClinicMutation>;
export type CreateTemplateClinicMutationResult = Apollo.MutationResult<CreateTemplateClinicMutation>;
export type CreateTemplateClinicMutationOptions = Apollo.BaseMutationOptions<CreateTemplateClinicMutation, CreateTemplateClinicMutationVariables>;
export const DeleteTemplateClinicDocument = gql`
    mutation deleteTemplateClinic($id: ID!) {
  deleteTemplateClinic(id: $id)
}
    `;
export type DeleteTemplateClinicMutationFn = Apollo.MutationFunction<DeleteTemplateClinicMutation, DeleteTemplateClinicMutationVariables>;

/**
 * __useDeleteTemplateClinicMutation__
 *
 * To run a mutation, you first call `useDeleteTemplateClinicMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useDeleteTemplateClinicMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [deleteTemplateClinicMutation, { data, loading, error }] = useDeleteTemplateClinicMutation({
 *   variables: {
 *      id: // value for 'id'
 *   },
 * });
 */
export function useDeleteTemplateClinicMutation(baseOptions?: Apollo.MutationHookOptions<DeleteTemplateClinicMutation, DeleteTemplateClinicMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<DeleteTemplateClinicMutation, DeleteTemplateClinicMutationVariables>(DeleteTemplateClinicDocument, options);
      }
export type DeleteTemplateClinicMutationHookResult = ReturnType<typeof useDeleteTemplateClinicMutation>;
export type DeleteTemplateClinicMutationResult = Apollo.MutationResult<DeleteTemplateClinicMutation>;
export type DeleteTemplateClinicMutationOptions = Apollo.BaseMutationOptions<DeleteTemplateClinicMutation, DeleteTemplateClinicMutationVariables>;
export const GetTrendReportDocument = gql`
    query getTrendReport($params: TrendReportParams!) {
  getTrendReport(params: $params) {
    ...TrendReportFields
  }
}
    ${TrendReportFieldsFragmentDoc}`;

/**
 * __useGetTrendReportQuery__
 *
 * To run a query within a React component, call `useGetTrendReportQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetTrendReportQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetTrendReportQuery({
 *   variables: {
 *      params: // value for 'params'
 *   },
 * });
 */
export function useGetTrendReportQuery(baseOptions: Apollo.QueryHookOptions<GetTrendReportQuery, GetTrendReportQueryVariables> & ({ variables: GetTrendReportQueryVariables; skip?: boolean; } | { skip: boolean; }) ) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<GetTrendReportQuery, GetTrendReportQueryVariables>(GetTrendReportDocument, options);
      }
export function useGetTrendReportLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<GetTrendReportQuery, GetTrendReportQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<GetTrendReportQuery, GetTrendReportQueryVariables>(GetTrendReportDocument, options);
        }
export function useGetTrendReportSuspenseQuery(baseOptions?: Apollo.SuspenseQueryHookOptions<GetTrendReportQuery, GetTrendReportQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useSuspenseQuery<GetTrendReportQuery, GetTrendReportQueryVariables>(GetTrendReportDocument, options);
        }
export type GetTrendReportQueryHookResult = ReturnType<typeof useGetTrendReportQuery>;
export type GetTrendReportLazyQueryHookResult = ReturnType<typeof useGetTrendReportLazyQuery>;
export type GetTrendReportSuspenseQueryHookResult = ReturnType<typeof useGetTrendReportSuspenseQuery>;
export type GetTrendReportQueryResult = Apollo.QueryResult<GetTrendReportQuery, GetTrendReportQueryVariables>;
export const GetTrendClinicItemDocument = gql`
    query getTrendClinicItem($id: ID!) {
  clinic(id: $id) {
    id
    name
    slug
  }
}
    `;

/**
 * __useGetTrendClinicItemQuery__
 *
 * To run a query within a React component, call `useGetTrendClinicItemQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetTrendClinicItemQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetTrendClinicItemQuery({
 *   variables: {
 *      id: // value for 'id'
 *   },
 * });
 */
export function useGetTrendClinicItemQuery(baseOptions: Apollo.QueryHookOptions<GetTrendClinicItemQuery, GetTrendClinicItemQueryVariables> & ({ variables: GetTrendClinicItemQueryVariables; skip?: boolean; } | { skip: boolean; }) ) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<GetTrendClinicItemQuery, GetTrendClinicItemQueryVariables>(GetTrendClinicItemDocument, options);
      }
export function useGetTrendClinicItemLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<GetTrendClinicItemQuery, GetTrendClinicItemQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<GetTrendClinicItemQuery, GetTrendClinicItemQueryVariables>(GetTrendClinicItemDocument, options);
        }
export function useGetTrendClinicItemSuspenseQuery(baseOptions?: Apollo.SuspenseQueryHookOptions<GetTrendClinicItemQuery, GetTrendClinicItemQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useSuspenseQuery<GetTrendClinicItemQuery, GetTrendClinicItemQueryVariables>(GetTrendClinicItemDocument, options);
        }
export type GetTrendClinicItemQueryHookResult = ReturnType<typeof useGetTrendClinicItemQuery>;
export type GetTrendClinicItemLazyQueryHookResult = ReturnType<typeof useGetTrendClinicItemLazyQuery>;
export type GetTrendClinicItemSuspenseQueryHookResult = ReturnType<typeof useGetTrendClinicItemSuspenseQuery>;
export type GetTrendClinicItemQueryResult = Apollo.QueryResult<GetTrendClinicItemQuery, GetTrendClinicItemQueryVariables>;
export const EntityLinksForParentDocument = gql`
    query entityLinksForParent($entityType: EntityLinkType!, $parentId: ID!) {
  entityLinksForParent(entityType: $entityType, parentId: $parentId) {
    ...EntityLinkFields
  }
}
    ${EntityLinkFieldsFragmentDoc}`;

/**
 * __useEntityLinksForParentQuery__
 *
 * To run a query within a React component, call `useEntityLinksForParentQuery` and pass it any options that fit your needs.
 * When your component renders, `useEntityLinksForParentQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useEntityLinksForParentQuery({
 *   variables: {
 *      entityType: // value for 'entityType'
 *      parentId: // value for 'parentId'
 *   },
 * });
 */
export function useEntityLinksForParentQuery(baseOptions: Apollo.QueryHookOptions<EntityLinksForParentQuery, EntityLinksForParentQueryVariables> & ({ variables: EntityLinksForParentQueryVariables; skip?: boolean; } | { skip: boolean; }) ) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<EntityLinksForParentQuery, EntityLinksForParentQueryVariables>(EntityLinksForParentDocument, options);
      }
export function useEntityLinksForParentLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<EntityLinksForParentQuery, EntityLinksForParentQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<EntityLinksForParentQuery, EntityLinksForParentQueryVariables>(EntityLinksForParentDocument, options);
        }
export function useEntityLinksForParentSuspenseQuery(baseOptions?: Apollo.SuspenseQueryHookOptions<EntityLinksForParentQuery, EntityLinksForParentQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useSuspenseQuery<EntityLinksForParentQuery, EntityLinksForParentQueryVariables>(EntityLinksForParentDocument, options);
        }
export type EntityLinksForParentQueryHookResult = ReturnType<typeof useEntityLinksForParentQuery>;
export type EntityLinksForParentLazyQueryHookResult = ReturnType<typeof useEntityLinksForParentLazyQuery>;
export type EntityLinksForParentSuspenseQueryHookResult = ReturnType<typeof useEntityLinksForParentSuspenseQuery>;
export type EntityLinksForParentQueryResult = Apollo.QueryResult<EntityLinksForParentQuery, EntityLinksForParentQueryVariables>;
export const EntityLinkSummaryDocument = gql`
    query entityLinkSummary($entityType: EntityLinkType!, $parentId: ID!) {
  entityLinkSummary(entityType: $entityType, parentId: $parentId) {
    linked_count
    unlinked_count
    never_linked_clinic_ids
  }
}
    `;

/**
 * __useEntityLinkSummaryQuery__
 *
 * To run a query within a React component, call `useEntityLinkSummaryQuery` and pass it any options that fit your needs.
 * When your component renders, `useEntityLinkSummaryQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useEntityLinkSummaryQuery({
 *   variables: {
 *      entityType: // value for 'entityType'
 *      parentId: // value for 'parentId'
 *   },
 * });
 */
export function useEntityLinkSummaryQuery(baseOptions: Apollo.QueryHookOptions<EntityLinkSummaryQuery, EntityLinkSummaryQueryVariables> & ({ variables: EntityLinkSummaryQueryVariables; skip?: boolean; } | { skip: boolean; }) ) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<EntityLinkSummaryQuery, EntityLinkSummaryQueryVariables>(EntityLinkSummaryDocument, options);
      }
export function useEntityLinkSummaryLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<EntityLinkSummaryQuery, EntityLinkSummaryQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<EntityLinkSummaryQuery, EntityLinkSummaryQueryVariables>(EntityLinkSummaryDocument, options);
        }
export function useEntityLinkSummarySuspenseQuery(baseOptions?: Apollo.SuspenseQueryHookOptions<EntityLinkSummaryQuery, EntityLinkSummaryQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useSuspenseQuery<EntityLinkSummaryQuery, EntityLinkSummaryQueryVariables>(EntityLinkSummaryDocument, options);
        }
export type EntityLinkSummaryQueryHookResult = ReturnType<typeof useEntityLinkSummaryQuery>;
export type EntityLinkSummaryLazyQueryHookResult = ReturnType<typeof useEntityLinkSummaryLazyQuery>;
export type EntityLinkSummarySuspenseQueryHookResult = ReturnType<typeof useEntityLinkSummarySuspenseQuery>;
export type EntityLinkSummaryQueryResult = Apollo.QueryResult<EntityLinkSummaryQuery, EntityLinkSummaryQueryVariables>;
export const EntityLinkForChildDocument = gql`
    query entityLinkForChild($entityType: EntityLinkType!, $childId: ID!) {
  entityLinkForChild(entityType: $entityType, childId: $childId) {
    ...EntityLinkFields
  }
}
    ${EntityLinkFieldsFragmentDoc}`;

/**
 * __useEntityLinkForChildQuery__
 *
 * To run a query within a React component, call `useEntityLinkForChildQuery` and pass it any options that fit your needs.
 * When your component renders, `useEntityLinkForChildQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useEntityLinkForChildQuery({
 *   variables: {
 *      entityType: // value for 'entityType'
 *      childId: // value for 'childId'
 *   },
 * });
 */
export function useEntityLinkForChildQuery(baseOptions: Apollo.QueryHookOptions<EntityLinkForChildQuery, EntityLinkForChildQueryVariables> & ({ variables: EntityLinkForChildQueryVariables; skip?: boolean; } | { skip: boolean; }) ) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<EntityLinkForChildQuery, EntityLinkForChildQueryVariables>(EntityLinkForChildDocument, options);
      }
export function useEntityLinkForChildLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<EntityLinkForChildQuery, EntityLinkForChildQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<EntityLinkForChildQuery, EntityLinkForChildQueryVariables>(EntityLinkForChildDocument, options);
        }
export function useEntityLinkForChildSuspenseQuery(baseOptions?: Apollo.SuspenseQueryHookOptions<EntityLinkForChildQuery, EntityLinkForChildQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useSuspenseQuery<EntityLinkForChildQuery, EntityLinkForChildQueryVariables>(EntityLinkForChildDocument, options);
        }
export type EntityLinkForChildQueryHookResult = ReturnType<typeof useEntityLinkForChildQuery>;
export type EntityLinkForChildLazyQueryHookResult = ReturnType<typeof useEntityLinkForChildLazyQuery>;
export type EntityLinkForChildSuspenseQueryHookResult = ReturnType<typeof useEntityLinkForChildSuspenseQuery>;
export type EntityLinkForChildQueryResult = Apollo.QueryResult<EntityLinkForChildQuery, EntityLinkForChildQueryVariables>;
export const EntityLinkFieldsChangedByUpdateDocument = gql`
    query entityLinkFieldsChangedByUpdate($entityType: EntityLinkType!, $childId: ID!, $data: JSON!) {
  entityLinkFieldsChangedByUpdate(
    entityType: $entityType
    childId: $childId
    data: $data
  )
}
    `;

/**
 * __useEntityLinkFieldsChangedByUpdateQuery__
 *
 * To run a query within a React component, call `useEntityLinkFieldsChangedByUpdateQuery` and pass it any options that fit your needs.
 * When your component renders, `useEntityLinkFieldsChangedByUpdateQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useEntityLinkFieldsChangedByUpdateQuery({
 *   variables: {
 *      entityType: // value for 'entityType'
 *      childId: // value for 'childId'
 *      data: // value for 'data'
 *   },
 * });
 */
export function useEntityLinkFieldsChangedByUpdateQuery(baseOptions: Apollo.QueryHookOptions<EntityLinkFieldsChangedByUpdateQuery, EntityLinkFieldsChangedByUpdateQueryVariables> & ({ variables: EntityLinkFieldsChangedByUpdateQueryVariables; skip?: boolean; } | { skip: boolean; }) ) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<EntityLinkFieldsChangedByUpdateQuery, EntityLinkFieldsChangedByUpdateQueryVariables>(EntityLinkFieldsChangedByUpdateDocument, options);
      }
export function useEntityLinkFieldsChangedByUpdateLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<EntityLinkFieldsChangedByUpdateQuery, EntityLinkFieldsChangedByUpdateQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<EntityLinkFieldsChangedByUpdateQuery, EntityLinkFieldsChangedByUpdateQueryVariables>(EntityLinkFieldsChangedByUpdateDocument, options);
        }
export function useEntityLinkFieldsChangedByUpdateSuspenseQuery(baseOptions?: Apollo.SuspenseQueryHookOptions<EntityLinkFieldsChangedByUpdateQuery, EntityLinkFieldsChangedByUpdateQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useSuspenseQuery<EntityLinkFieldsChangedByUpdateQuery, EntityLinkFieldsChangedByUpdateQueryVariables>(EntityLinkFieldsChangedByUpdateDocument, options);
        }
export type EntityLinkFieldsChangedByUpdateQueryHookResult = ReturnType<typeof useEntityLinkFieldsChangedByUpdateQuery>;
export type EntityLinkFieldsChangedByUpdateLazyQueryHookResult = ReturnType<typeof useEntityLinkFieldsChangedByUpdateLazyQuery>;
export type EntityLinkFieldsChangedByUpdateSuspenseQueryHookResult = ReturnType<typeof useEntityLinkFieldsChangedByUpdateSuspenseQuery>;
export type EntityLinkFieldsChangedByUpdateQueryResult = Apollo.QueryResult<EntityLinkFieldsChangedByUpdateQuery, EntityLinkFieldsChangedByUpdateQueryVariables>;
export const EntityLinksForClinicDocument = gql`
    query entityLinksForClinic($entityType: EntityLinkType!, $clinicId: ID!) {
  entityLinksForClinic(entityType: $entityType, clinicId: $clinicId) {
    ...EntityLinkFields
  }
}
    ${EntityLinkFieldsFragmentDoc}`;

/**
 * __useEntityLinksForClinicQuery__
 *
 * To run a query within a React component, call `useEntityLinksForClinicQuery` and pass it any options that fit your needs.
 * When your component renders, `useEntityLinksForClinicQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useEntityLinksForClinicQuery({
 *   variables: {
 *      entityType: // value for 'entityType'
 *      clinicId: // value for 'clinicId'
 *   },
 * });
 */
export function useEntityLinksForClinicQuery(baseOptions: Apollo.QueryHookOptions<EntityLinksForClinicQuery, EntityLinksForClinicQueryVariables> & ({ variables: EntityLinksForClinicQueryVariables; skip?: boolean; } | { skip: boolean; }) ) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<EntityLinksForClinicQuery, EntityLinksForClinicQueryVariables>(EntityLinksForClinicDocument, options);
      }
export function useEntityLinksForClinicLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<EntityLinksForClinicQuery, EntityLinksForClinicQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<EntityLinksForClinicQuery, EntityLinksForClinicQueryVariables>(EntityLinksForClinicDocument, options);
        }
export function useEntityLinksForClinicSuspenseQuery(baseOptions?: Apollo.SuspenseQueryHookOptions<EntityLinksForClinicQuery, EntityLinksForClinicQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useSuspenseQuery<EntityLinksForClinicQuery, EntityLinksForClinicQueryVariables>(EntityLinksForClinicDocument, options);
        }
export type EntityLinksForClinicQueryHookResult = ReturnType<typeof useEntityLinksForClinicQuery>;
export type EntityLinksForClinicLazyQueryHookResult = ReturnType<typeof useEntityLinksForClinicLazyQuery>;
export type EntityLinksForClinicSuspenseQueryHookResult = ReturnType<typeof useEntityLinksForClinicSuspenseQuery>;
export type EntityLinksForClinicQueryResult = Apollo.QueryResult<EntityLinksForClinicQuery, EntityLinksForClinicQueryVariables>;
export const EntityLinkFieldPoliciesDocument = gql`
    query entityLinkFieldPolicies {
  entityLinkFieldPolicies {
    entity_type
    governed_fields
    locally_assignable_fields
    remapped_fields
    unlinks_per_field
    link_categories {
      key
      label
      fields
    }
  }
}
    `;

/**
 * __useEntityLinkFieldPoliciesQuery__
 *
 * To run a query within a React component, call `useEntityLinkFieldPoliciesQuery` and pass it any options that fit your needs.
 * When your component renders, `useEntityLinkFieldPoliciesQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useEntityLinkFieldPoliciesQuery({
 *   variables: {
 *   },
 * });
 */
export function useEntityLinkFieldPoliciesQuery(baseOptions?: Apollo.QueryHookOptions<EntityLinkFieldPoliciesQuery, EntityLinkFieldPoliciesQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<EntityLinkFieldPoliciesQuery, EntityLinkFieldPoliciesQueryVariables>(EntityLinkFieldPoliciesDocument, options);
      }
export function useEntityLinkFieldPoliciesLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<EntityLinkFieldPoliciesQuery, EntityLinkFieldPoliciesQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<EntityLinkFieldPoliciesQuery, EntityLinkFieldPoliciesQueryVariables>(EntityLinkFieldPoliciesDocument, options);
        }
export function useEntityLinkFieldPoliciesSuspenseQuery(baseOptions?: Apollo.SuspenseQueryHookOptions<EntityLinkFieldPoliciesQuery, EntityLinkFieldPoliciesQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useSuspenseQuery<EntityLinkFieldPoliciesQuery, EntityLinkFieldPoliciesQueryVariables>(EntityLinkFieldPoliciesDocument, options);
        }
export type EntityLinkFieldPoliciesQueryHookResult = ReturnType<typeof useEntityLinkFieldPoliciesQuery>;
export type EntityLinkFieldPoliciesLazyQueryHookResult = ReturnType<typeof useEntityLinkFieldPoliciesLazyQuery>;
export type EntityLinkFieldPoliciesSuspenseQueryHookResult = ReturnType<typeof useEntityLinkFieldPoliciesSuspenseQuery>;
export type EntityLinkFieldPoliciesQueryResult = Apollo.QueryResult<EntityLinkFieldPoliciesQuery, EntityLinkFieldPoliciesQueryVariables>;
export const ClinicSettingsFieldValuesForClinicGroupDocument = gql`
    query clinicSettingsFieldValuesForClinicGroup($clinicGroupId: ID!, $fields: [String!]!) {
  clinicSettingsFieldValuesForClinicGroup(
    clinicGroupId: $clinicGroupId
    fields: $fields
  ) {
    clinic_id
    values
  }
}
    `;

/**
 * __useClinicSettingsFieldValuesForClinicGroupQuery__
 *
 * To run a query within a React component, call `useClinicSettingsFieldValuesForClinicGroupQuery` and pass it any options that fit your needs.
 * When your component renders, `useClinicSettingsFieldValuesForClinicGroupQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useClinicSettingsFieldValuesForClinicGroupQuery({
 *   variables: {
 *      clinicGroupId: // value for 'clinicGroupId'
 *      fields: // value for 'fields'
 *   },
 * });
 */
export function useClinicSettingsFieldValuesForClinicGroupQuery(baseOptions: Apollo.QueryHookOptions<ClinicSettingsFieldValuesForClinicGroupQuery, ClinicSettingsFieldValuesForClinicGroupQueryVariables> & ({ variables: ClinicSettingsFieldValuesForClinicGroupQueryVariables; skip?: boolean; } | { skip: boolean; }) ) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<ClinicSettingsFieldValuesForClinicGroupQuery, ClinicSettingsFieldValuesForClinicGroupQueryVariables>(ClinicSettingsFieldValuesForClinicGroupDocument, options);
      }
export function useClinicSettingsFieldValuesForClinicGroupLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<ClinicSettingsFieldValuesForClinicGroupQuery, ClinicSettingsFieldValuesForClinicGroupQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<ClinicSettingsFieldValuesForClinicGroupQuery, ClinicSettingsFieldValuesForClinicGroupQueryVariables>(ClinicSettingsFieldValuesForClinicGroupDocument, options);
        }
export function useClinicSettingsFieldValuesForClinicGroupSuspenseQuery(baseOptions?: Apollo.SuspenseQueryHookOptions<ClinicSettingsFieldValuesForClinicGroupQuery, ClinicSettingsFieldValuesForClinicGroupQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useSuspenseQuery<ClinicSettingsFieldValuesForClinicGroupQuery, ClinicSettingsFieldValuesForClinicGroupQueryVariables>(ClinicSettingsFieldValuesForClinicGroupDocument, options);
        }
export type ClinicSettingsFieldValuesForClinicGroupQueryHookResult = ReturnType<typeof useClinicSettingsFieldValuesForClinicGroupQuery>;
export type ClinicSettingsFieldValuesForClinicGroupLazyQueryHookResult = ReturnType<typeof useClinicSettingsFieldValuesForClinicGroupLazyQuery>;
export type ClinicSettingsFieldValuesForClinicGroupSuspenseQueryHookResult = ReturnType<typeof useClinicSettingsFieldValuesForClinicGroupSuspenseQuery>;
export type ClinicSettingsFieldValuesForClinicGroupQueryResult = Apollo.QueryResult<ClinicSettingsFieldValuesForClinicGroupQuery, ClinicSettingsFieldValuesForClinicGroupQueryVariables>;
export const EntityLinkCoverageForClinicGroupDocument = gql`
    query entityLinkCoverageForClinicGroup($clinicGroupId: ID!) {
  entityLinkCoverageForClinicGroup(clinicGroupId: $clinicGroupId) {
    clinic_id
    clinic_name
    total_linked
    total_parents
    has_settings_link
    types {
      entity_type
      parent_count
      linked_count
      unlinked_count
    }
  }
}
    `;

/**
 * __useEntityLinkCoverageForClinicGroupQuery__
 *
 * To run a query within a React component, call `useEntityLinkCoverageForClinicGroupQuery` and pass it any options that fit your needs.
 * When your component renders, `useEntityLinkCoverageForClinicGroupQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useEntityLinkCoverageForClinicGroupQuery({
 *   variables: {
 *      clinicGroupId: // value for 'clinicGroupId'
 *   },
 * });
 */
export function useEntityLinkCoverageForClinicGroupQuery(baseOptions: Apollo.QueryHookOptions<EntityLinkCoverageForClinicGroupQuery, EntityLinkCoverageForClinicGroupQueryVariables> & ({ variables: EntityLinkCoverageForClinicGroupQueryVariables; skip?: boolean; } | { skip: boolean; }) ) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<EntityLinkCoverageForClinicGroupQuery, EntityLinkCoverageForClinicGroupQueryVariables>(EntityLinkCoverageForClinicGroupDocument, options);
      }
export function useEntityLinkCoverageForClinicGroupLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<EntityLinkCoverageForClinicGroupQuery, EntityLinkCoverageForClinicGroupQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<EntityLinkCoverageForClinicGroupQuery, EntityLinkCoverageForClinicGroupQueryVariables>(EntityLinkCoverageForClinicGroupDocument, options);
        }
export function useEntityLinkCoverageForClinicGroupSuspenseQuery(baseOptions?: Apollo.SuspenseQueryHookOptions<EntityLinkCoverageForClinicGroupQuery, EntityLinkCoverageForClinicGroupQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useSuspenseQuery<EntityLinkCoverageForClinicGroupQuery, EntityLinkCoverageForClinicGroupQueryVariables>(EntityLinkCoverageForClinicGroupDocument, options);
        }
export type EntityLinkCoverageForClinicGroupQueryHookResult = ReturnType<typeof useEntityLinkCoverageForClinicGroupQuery>;
export type EntityLinkCoverageForClinicGroupLazyQueryHookResult = ReturnType<typeof useEntityLinkCoverageForClinicGroupLazyQuery>;
export type EntityLinkCoverageForClinicGroupSuspenseQueryHookResult = ReturnType<typeof useEntityLinkCoverageForClinicGroupSuspenseQuery>;
export type EntityLinkCoverageForClinicGroupQueryResult = Apollo.QueryResult<EntityLinkCoverageForClinicGroupQuery, EntityLinkCoverageForClinicGroupQueryVariables>;
export const EntityLinkCoverageDetailsForClinicDocument = gql`
    query entityLinkCoverageDetailsForClinic($clinicGroupId: ID!, $clinicId: ID!, $entityTypes: [EntityLinkType!]) {
  entityLinkCoverageDetailsForClinic(
    clinicGroupId: $clinicGroupId
    clinicId: $clinicId
    entityTypes: $entityTypes
  ) {
    entity_type
    parent_id
    parent_name
    status
    unlinked_fields
    child_id
  }
}
    `;

/**
 * __useEntityLinkCoverageDetailsForClinicQuery__
 *
 * To run a query within a React component, call `useEntityLinkCoverageDetailsForClinicQuery` and pass it any options that fit your needs.
 * When your component renders, `useEntityLinkCoverageDetailsForClinicQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useEntityLinkCoverageDetailsForClinicQuery({
 *   variables: {
 *      clinicGroupId: // value for 'clinicGroupId'
 *      clinicId: // value for 'clinicId'
 *      entityTypes: // value for 'entityTypes'
 *   },
 * });
 */
export function useEntityLinkCoverageDetailsForClinicQuery(baseOptions: Apollo.QueryHookOptions<EntityLinkCoverageDetailsForClinicQuery, EntityLinkCoverageDetailsForClinicQueryVariables> & ({ variables: EntityLinkCoverageDetailsForClinicQueryVariables; skip?: boolean; } | { skip: boolean; }) ) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<EntityLinkCoverageDetailsForClinicQuery, EntityLinkCoverageDetailsForClinicQueryVariables>(EntityLinkCoverageDetailsForClinicDocument, options);
      }
export function useEntityLinkCoverageDetailsForClinicLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<EntityLinkCoverageDetailsForClinicQuery, EntityLinkCoverageDetailsForClinicQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<EntityLinkCoverageDetailsForClinicQuery, EntityLinkCoverageDetailsForClinicQueryVariables>(EntityLinkCoverageDetailsForClinicDocument, options);
        }
export function useEntityLinkCoverageDetailsForClinicSuspenseQuery(baseOptions?: Apollo.SuspenseQueryHookOptions<EntityLinkCoverageDetailsForClinicQuery, EntityLinkCoverageDetailsForClinicQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useSuspenseQuery<EntityLinkCoverageDetailsForClinicQuery, EntityLinkCoverageDetailsForClinicQueryVariables>(EntityLinkCoverageDetailsForClinicDocument, options);
        }
export type EntityLinkCoverageDetailsForClinicQueryHookResult = ReturnType<typeof useEntityLinkCoverageDetailsForClinicQuery>;
export type EntityLinkCoverageDetailsForClinicLazyQueryHookResult = ReturnType<typeof useEntityLinkCoverageDetailsForClinicLazyQuery>;
export type EntityLinkCoverageDetailsForClinicSuspenseQueryHookResult = ReturnType<typeof useEntityLinkCoverageDetailsForClinicSuspenseQuery>;
export type EntityLinkCoverageDetailsForClinicQueryResult = Apollo.QueryResult<EntityLinkCoverageDetailsForClinicQuery, EntityLinkCoverageDetailsForClinicQueryVariables>;
export const UnlinkEntityDocument = gql`
    mutation unlinkEntity($entityType: EntityLinkType!, $childId: ID!) {
  unlinkEntity(entityType: $entityType, childId: $childId) {
    ...EntityLinkFields
  }
}
    ${EntityLinkFieldsFragmentDoc}`;
export type UnlinkEntityMutationFn = Apollo.MutationFunction<UnlinkEntityMutation, UnlinkEntityMutationVariables>;

/**
 * __useUnlinkEntityMutation__
 *
 * To run a mutation, you first call `useUnlinkEntityMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useUnlinkEntityMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [unlinkEntityMutation, { data, loading, error }] = useUnlinkEntityMutation({
 *   variables: {
 *      entityType: // value for 'entityType'
 *      childId: // value for 'childId'
 *   },
 * });
 */
export function useUnlinkEntityMutation(baseOptions?: Apollo.MutationHookOptions<UnlinkEntityMutation, UnlinkEntityMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<UnlinkEntityMutation, UnlinkEntityMutationVariables>(UnlinkEntityDocument, options);
      }
export type UnlinkEntityMutationHookResult = ReturnType<typeof useUnlinkEntityMutation>;
export type UnlinkEntityMutationResult = Apollo.MutationResult<UnlinkEntityMutation>;
export type UnlinkEntityMutationOptions = Apollo.BaseMutationOptions<UnlinkEntityMutation, UnlinkEntityMutationVariables>;
export const RelinkEntityDocument = gql`
    mutation relinkEntity($entityType: EntityLinkType!, $childId: ID!) {
  relinkEntity(entityType: $entityType, childId: $childId) {
    ...EntityLinkFields
  }
}
    ${EntityLinkFieldsFragmentDoc}`;
export type RelinkEntityMutationFn = Apollo.MutationFunction<RelinkEntityMutation, RelinkEntityMutationVariables>;

/**
 * __useRelinkEntityMutation__
 *
 * To run a mutation, you first call `useRelinkEntityMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useRelinkEntityMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [relinkEntityMutation, { data, loading, error }] = useRelinkEntityMutation({
 *   variables: {
 *      entityType: // value for 'entityType'
 *      childId: // value for 'childId'
 *   },
 * });
 */
export function useRelinkEntityMutation(baseOptions?: Apollo.MutationHookOptions<RelinkEntityMutation, RelinkEntityMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<RelinkEntityMutation, RelinkEntityMutationVariables>(RelinkEntityDocument, options);
      }
export type RelinkEntityMutationHookResult = ReturnType<typeof useRelinkEntityMutation>;
export type RelinkEntityMutationResult = Apollo.MutationResult<RelinkEntityMutation>;
export type RelinkEntityMutationOptions = Apollo.BaseMutationOptions<RelinkEntityMutation, RelinkEntityMutationVariables>;
export const UnlinkEntityFieldsDocument = gql`
    mutation unlinkEntityFields($entityType: EntityLinkType!, $childId: ID!, $fields: [String!]!) {
  unlinkEntityFields(entityType: $entityType, childId: $childId, fields: $fields) {
    ...EntityLinkFields
  }
}
    ${EntityLinkFieldsFragmentDoc}`;
export type UnlinkEntityFieldsMutationFn = Apollo.MutationFunction<UnlinkEntityFieldsMutation, UnlinkEntityFieldsMutationVariables>;

/**
 * __useUnlinkEntityFieldsMutation__
 *
 * To run a mutation, you first call `useUnlinkEntityFieldsMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useUnlinkEntityFieldsMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [unlinkEntityFieldsMutation, { data, loading, error }] = useUnlinkEntityFieldsMutation({
 *   variables: {
 *      entityType: // value for 'entityType'
 *      childId: // value for 'childId'
 *      fields: // value for 'fields'
 *   },
 * });
 */
export function useUnlinkEntityFieldsMutation(baseOptions?: Apollo.MutationHookOptions<UnlinkEntityFieldsMutation, UnlinkEntityFieldsMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<UnlinkEntityFieldsMutation, UnlinkEntityFieldsMutationVariables>(UnlinkEntityFieldsDocument, options);
      }
export type UnlinkEntityFieldsMutationHookResult = ReturnType<typeof useUnlinkEntityFieldsMutation>;
export type UnlinkEntityFieldsMutationResult = Apollo.MutationResult<UnlinkEntityFieldsMutation>;
export type UnlinkEntityFieldsMutationOptions = Apollo.BaseMutationOptions<UnlinkEntityFieldsMutation, UnlinkEntityFieldsMutationVariables>;
export const RelinkEntityFieldsDocument = gql`
    mutation relinkEntityFields($entityType: EntityLinkType!, $childId: ID!, $fields: [String!]!) {
  relinkEntityFields(entityType: $entityType, childId: $childId, fields: $fields) {
    ...EntityLinkFields
  }
}
    ${EntityLinkFieldsFragmentDoc}`;
export type RelinkEntityFieldsMutationFn = Apollo.MutationFunction<RelinkEntityFieldsMutation, RelinkEntityFieldsMutationVariables>;

/**
 * __useRelinkEntityFieldsMutation__
 *
 * To run a mutation, you first call `useRelinkEntityFieldsMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useRelinkEntityFieldsMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [relinkEntityFieldsMutation, { data, loading, error }] = useRelinkEntityFieldsMutation({
 *   variables: {
 *      entityType: // value for 'entityType'
 *      childId: // value for 'childId'
 *      fields: // value for 'fields'
 *   },
 * });
 */
export function useRelinkEntityFieldsMutation(baseOptions?: Apollo.MutationHookOptions<RelinkEntityFieldsMutation, RelinkEntityFieldsMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<RelinkEntityFieldsMutation, RelinkEntityFieldsMutationVariables>(RelinkEntityFieldsDocument, options);
      }
export type RelinkEntityFieldsMutationHookResult = ReturnType<typeof useRelinkEntityFieldsMutation>;
export type RelinkEntityFieldsMutationResult = Apollo.MutationResult<RelinkEntityFieldsMutation>;
export type RelinkEntityFieldsMutationOptions = Apollo.BaseMutationOptions<RelinkEntityFieldsMutation, RelinkEntityFieldsMutationVariables>;
export const PopulateEntityLinkChildrenDocument = gql`
    mutation populateEntityLinkChildren($entityType: EntityLinkType!, $parentId: ID!, $clinicIds: [ID!], $linkedFields: [String!]) {
  populateEntityLinkChildren(
    entityType: $entityType
    parentId: $parentId
    clinicIds: $clinicIds
    linkedFields: $linkedFields
  ) {
    ...EntityLinkFields
  }
}
    ${EntityLinkFieldsFragmentDoc}`;
export type PopulateEntityLinkChildrenMutationFn = Apollo.MutationFunction<PopulateEntityLinkChildrenMutation, PopulateEntityLinkChildrenMutationVariables>;

/**
 * __usePopulateEntityLinkChildrenMutation__
 *
 * To run a mutation, you first call `usePopulateEntityLinkChildrenMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `usePopulateEntityLinkChildrenMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [populateEntityLinkChildrenMutation, { data, loading, error }] = usePopulateEntityLinkChildrenMutation({
 *   variables: {
 *      entityType: // value for 'entityType'
 *      parentId: // value for 'parentId'
 *      clinicIds: // value for 'clinicIds'
 *      linkedFields: // value for 'linkedFields'
 *   },
 * });
 */
export function usePopulateEntityLinkChildrenMutation(baseOptions?: Apollo.MutationHookOptions<PopulateEntityLinkChildrenMutation, PopulateEntityLinkChildrenMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<PopulateEntityLinkChildrenMutation, PopulateEntityLinkChildrenMutationVariables>(PopulateEntityLinkChildrenDocument, options);
      }
export type PopulateEntityLinkChildrenMutationHookResult = ReturnType<typeof usePopulateEntityLinkChildrenMutation>;
export type PopulateEntityLinkChildrenMutationResult = Apollo.MutationResult<PopulateEntityLinkChildrenMutation>;
export type PopulateEntityLinkChildrenMutationOptions = Apollo.BaseMutationOptions<PopulateEntityLinkChildrenMutation, PopulateEntityLinkChildrenMutationVariables>;
export const ExpandEntityLinkFieldsForClinicsDocument = gql`
    mutation expandEntityLinkFieldsForClinics($entityType: EntityLinkType!, $parentId: ID!, $clinicIds: [ID!]!, $fields: [String!]!) {
  expandEntityLinkFieldsForClinics(
    entityType: $entityType
    parentId: $parentId
    clinicIds: $clinicIds
    fields: $fields
  ) {
    ...EntityLinkFields
  }
}
    ${EntityLinkFieldsFragmentDoc}`;
export type ExpandEntityLinkFieldsForClinicsMutationFn = Apollo.MutationFunction<ExpandEntityLinkFieldsForClinicsMutation, ExpandEntityLinkFieldsForClinicsMutationVariables>;

/**
 * __useExpandEntityLinkFieldsForClinicsMutation__
 *
 * To run a mutation, you first call `useExpandEntityLinkFieldsForClinicsMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useExpandEntityLinkFieldsForClinicsMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [expandEntityLinkFieldsForClinicsMutation, { data, loading, error }] = useExpandEntityLinkFieldsForClinicsMutation({
 *   variables: {
 *      entityType: // value for 'entityType'
 *      parentId: // value for 'parentId'
 *      clinicIds: // value for 'clinicIds'
 *      fields: // value for 'fields'
 *   },
 * });
 */
export function useExpandEntityLinkFieldsForClinicsMutation(baseOptions?: Apollo.MutationHookOptions<ExpandEntityLinkFieldsForClinicsMutation, ExpandEntityLinkFieldsForClinicsMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<ExpandEntityLinkFieldsForClinicsMutation, ExpandEntityLinkFieldsForClinicsMutationVariables>(ExpandEntityLinkFieldsForClinicsDocument, options);
      }
export type ExpandEntityLinkFieldsForClinicsMutationHookResult = ReturnType<typeof useExpandEntityLinkFieldsForClinicsMutation>;
export type ExpandEntityLinkFieldsForClinicsMutationResult = Apollo.MutationResult<ExpandEntityLinkFieldsForClinicsMutation>;
export type ExpandEntityLinkFieldsForClinicsMutationOptions = Apollo.BaseMutationOptions<ExpandEntityLinkFieldsForClinicsMutation, ExpandEntityLinkFieldsForClinicsMutationVariables>;
export const UnlinkEntityFieldsForClinicsDocument = gql`
    mutation unlinkEntityFieldsForClinics($entityType: EntityLinkType!, $parentId: ID!, $clinicIds: [ID!]!, $fields: [String!]!) {
  unlinkEntityFieldsForClinics(
    entityType: $entityType
    parentId: $parentId
    clinicIds: $clinicIds
    fields: $fields
  ) {
    ...EntityLinkFields
  }
}
    ${EntityLinkFieldsFragmentDoc}`;
export type UnlinkEntityFieldsForClinicsMutationFn = Apollo.MutationFunction<UnlinkEntityFieldsForClinicsMutation, UnlinkEntityFieldsForClinicsMutationVariables>;

/**
 * __useUnlinkEntityFieldsForClinicsMutation__
 *
 * To run a mutation, you first call `useUnlinkEntityFieldsForClinicsMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useUnlinkEntityFieldsForClinicsMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [unlinkEntityFieldsForClinicsMutation, { data, loading, error }] = useUnlinkEntityFieldsForClinicsMutation({
 *   variables: {
 *      entityType: // value for 'entityType'
 *      parentId: // value for 'parentId'
 *      clinicIds: // value for 'clinicIds'
 *      fields: // value for 'fields'
 *   },
 * });
 */
export function useUnlinkEntityFieldsForClinicsMutation(baseOptions?: Apollo.MutationHookOptions<UnlinkEntityFieldsForClinicsMutation, UnlinkEntityFieldsForClinicsMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<UnlinkEntityFieldsForClinicsMutation, UnlinkEntityFieldsForClinicsMutationVariables>(UnlinkEntityFieldsForClinicsDocument, options);
      }
export type UnlinkEntityFieldsForClinicsMutationHookResult = ReturnType<typeof useUnlinkEntityFieldsForClinicsMutation>;
export type UnlinkEntityFieldsForClinicsMutationResult = Apollo.MutationResult<UnlinkEntityFieldsForClinicsMutation>;
export type UnlinkEntityFieldsForClinicsMutationOptions = Apollo.BaseMutationOptions<UnlinkEntityFieldsForClinicsMutation, UnlinkEntityFieldsForClinicsMutationVariables>;
export const InitializeEntityLinksForClinicDocument = gql`
    mutation initializeEntityLinksForClinic($clinicGroupId: ID!, $clinicId: ID!, $entityTypes: [EntityLinkType!]) {
  initializeEntityLinksForClinic(
    clinicGroupId: $clinicGroupId
    clinicId: $clinicId
    entityTypes: $entityTypes
  ) {
    ...EntityLinkFields
  }
}
    ${EntityLinkFieldsFragmentDoc}`;
export type InitializeEntityLinksForClinicMutationFn = Apollo.MutationFunction<InitializeEntityLinksForClinicMutation, InitializeEntityLinksForClinicMutationVariables>;

/**
 * __useInitializeEntityLinksForClinicMutation__
 *
 * To run a mutation, you first call `useInitializeEntityLinksForClinicMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useInitializeEntityLinksForClinicMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [initializeEntityLinksForClinicMutation, { data, loading, error }] = useInitializeEntityLinksForClinicMutation({
 *   variables: {
 *      clinicGroupId: // value for 'clinicGroupId'
 *      clinicId: // value for 'clinicId'
 *      entityTypes: // value for 'entityTypes'
 *   },
 * });
 */
export function useInitializeEntityLinksForClinicMutation(baseOptions?: Apollo.MutationHookOptions<InitializeEntityLinksForClinicMutation, InitializeEntityLinksForClinicMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<InitializeEntityLinksForClinicMutation, InitializeEntityLinksForClinicMutationVariables>(InitializeEntityLinksForClinicDocument, options);
      }
export type InitializeEntityLinksForClinicMutationHookResult = ReturnType<typeof useInitializeEntityLinksForClinicMutation>;
export type InitializeEntityLinksForClinicMutationResult = Apollo.MutationResult<InitializeEntityLinksForClinicMutation>;
export type InitializeEntityLinksForClinicMutationOptions = Apollo.BaseMutationOptions<InitializeEntityLinksForClinicMutation, InitializeEntityLinksForClinicMutationVariables>;
export const InitializeEntityLinksForEntityTypeDocument = gql`
    mutation initializeEntityLinksForEntityType($clinicGroupId: ID!, $entityType: EntityLinkType!, $clinicIds: [ID!]) {
  initializeEntityLinksForEntityType(
    clinicGroupId: $clinicGroupId
    entityType: $entityType
    clinicIds: $clinicIds
  ) {
    ...EntityLinkFields
  }
}
    ${EntityLinkFieldsFragmentDoc}`;
export type InitializeEntityLinksForEntityTypeMutationFn = Apollo.MutationFunction<InitializeEntityLinksForEntityTypeMutation, InitializeEntityLinksForEntityTypeMutationVariables>;

/**
 * __useInitializeEntityLinksForEntityTypeMutation__
 *
 * To run a mutation, you first call `useInitializeEntityLinksForEntityTypeMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useInitializeEntityLinksForEntityTypeMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [initializeEntityLinksForEntityTypeMutation, { data, loading, error }] = useInitializeEntityLinksForEntityTypeMutation({
 *   variables: {
 *      clinicGroupId: // value for 'clinicGroupId'
 *      entityType: // value for 'entityType'
 *      clinicIds: // value for 'clinicIds'
 *   },
 * });
 */
export function useInitializeEntityLinksForEntityTypeMutation(baseOptions?: Apollo.MutationHookOptions<InitializeEntityLinksForEntityTypeMutation, InitializeEntityLinksForEntityTypeMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<InitializeEntityLinksForEntityTypeMutation, InitializeEntityLinksForEntityTypeMutationVariables>(InitializeEntityLinksForEntityTypeDocument, options);
      }
export type InitializeEntityLinksForEntityTypeMutationHookResult = ReturnType<typeof useInitializeEntityLinksForEntityTypeMutation>;
export type InitializeEntityLinksForEntityTypeMutationResult = Apollo.MutationResult<InitializeEntityLinksForEntityTypeMutation>;
export type InitializeEntityLinksForEntityTypeMutationOptions = Apollo.BaseMutationOptions<InitializeEntityLinksForEntityTypeMutation, InitializeEntityLinksForEntityTypeMutationVariables>;
export const GetFormDocument = gql`
    query getForm($id: ID!) {
  form(id: $id) {
    ...FormFields
  }
}
    ${FormFieldsFragmentDoc}`;

/**
 * __useGetFormQuery__
 *
 * To run a query within a React component, call `useGetFormQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetFormQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetFormQuery({
 *   variables: {
 *      id: // value for 'id'
 *   },
 * });
 */
export function useGetFormQuery(baseOptions: Apollo.QueryHookOptions<GetFormQuery, GetFormQueryVariables> & ({ variables: GetFormQueryVariables; skip?: boolean; } | { skip: boolean; }) ) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<GetFormQuery, GetFormQueryVariables>(GetFormDocument, options);
      }
export function useGetFormLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<GetFormQuery, GetFormQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<GetFormQuery, GetFormQueryVariables>(GetFormDocument, options);
        }
export function useGetFormSuspenseQuery(baseOptions?: Apollo.SuspenseQueryHookOptions<GetFormQuery, GetFormQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useSuspenseQuery<GetFormQuery, GetFormQueryVariables>(GetFormDocument, options);
        }
export type GetFormQueryHookResult = ReturnType<typeof useGetFormQuery>;
export type GetFormLazyQueryHookResult = ReturnType<typeof useGetFormLazyQuery>;
export type GetFormSuspenseQueryHookResult = ReturnType<typeof useGetFormSuspenseQuery>;
export type GetFormQueryResult = Apollo.QueryResult<GetFormQuery, GetFormQueryVariables>;
export const QueryFormsDocument = gql`
    query queryForms($where: [QueryInput!], $page: NonNegativeInt, $pageSize: NonNegativeInt, $orderBy: OrderByInput) {
  queryForms(where: $where, page: $page, pageSize: $pageSize, orderBy: $orderBy) {
    ...FormFields
  }
}
    ${FormFieldsFragmentDoc}`;

/**
 * __useQueryFormsQuery__
 *
 * To run a query within a React component, call `useQueryFormsQuery` and pass it any options that fit your needs.
 * When your component renders, `useQueryFormsQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useQueryFormsQuery({
 *   variables: {
 *      where: // value for 'where'
 *      page: // value for 'page'
 *      pageSize: // value for 'pageSize'
 *      orderBy: // value for 'orderBy'
 *   },
 * });
 */
export function useQueryFormsQuery(baseOptions?: Apollo.QueryHookOptions<QueryFormsQuery, QueryFormsQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<QueryFormsQuery, QueryFormsQueryVariables>(QueryFormsDocument, options);
      }
export function useQueryFormsLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<QueryFormsQuery, QueryFormsQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<QueryFormsQuery, QueryFormsQueryVariables>(QueryFormsDocument, options);
        }
export function useQueryFormsSuspenseQuery(baseOptions?: Apollo.SuspenseQueryHookOptions<QueryFormsQuery, QueryFormsQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useSuspenseQuery<QueryFormsQuery, QueryFormsQueryVariables>(QueryFormsDocument, options);
        }
export type QueryFormsQueryHookResult = ReturnType<typeof useQueryFormsQuery>;
export type QueryFormsLazyQueryHookResult = ReturnType<typeof useQueryFormsLazyQuery>;
export type QueryFormsSuspenseQueryHookResult = ReturnType<typeof useQueryFormsSuspenseQuery>;
export type QueryFormsQueryResult = Apollo.QueryResult<QueryFormsQuery, QueryFormsQueryVariables>;
export const CountFormsDocument = gql`
    query countForms($where: [QueryInput!]) {
  countForms(where: $where)
}
    `;

/**
 * __useCountFormsQuery__
 *
 * To run a query within a React component, call `useCountFormsQuery` and pass it any options that fit your needs.
 * When your component renders, `useCountFormsQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useCountFormsQuery({
 *   variables: {
 *      where: // value for 'where'
 *   },
 * });
 */
export function useCountFormsQuery(baseOptions?: Apollo.QueryHookOptions<CountFormsQuery, CountFormsQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<CountFormsQuery, CountFormsQueryVariables>(CountFormsDocument, options);
      }
export function useCountFormsLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<CountFormsQuery, CountFormsQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<CountFormsQuery, CountFormsQueryVariables>(CountFormsDocument, options);
        }
export function useCountFormsSuspenseQuery(baseOptions?: Apollo.SuspenseQueryHookOptions<CountFormsQuery, CountFormsQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useSuspenseQuery<CountFormsQuery, CountFormsQueryVariables>(CountFormsDocument, options);
        }
export type CountFormsQueryHookResult = ReturnType<typeof useCountFormsQuery>;
export type CountFormsLazyQueryHookResult = ReturnType<typeof useCountFormsLazyQuery>;
export type CountFormsSuspenseQueryHookResult = ReturnType<typeof useCountFormsSuspenseQuery>;
export type CountFormsQueryResult = Apollo.QueryResult<CountFormsQuery, CountFormsQueryVariables>;
export const GetPdfUrlForFormDocument = gql`
    query getPdfUrlForForm($formId: ID!) {
  getPdfUrlForForm(formId: $formId)
}
    `;

/**
 * __useGetPdfUrlForFormQuery__
 *
 * To run a query within a React component, call `useGetPdfUrlForFormQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetPdfUrlForFormQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetPdfUrlForFormQuery({
 *   variables: {
 *      formId: // value for 'formId'
 *   },
 * });
 */
export function useGetPdfUrlForFormQuery(baseOptions: Apollo.QueryHookOptions<GetPdfUrlForFormQuery, GetPdfUrlForFormQueryVariables> & ({ variables: GetPdfUrlForFormQueryVariables; skip?: boolean; } | { skip: boolean; }) ) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<GetPdfUrlForFormQuery, GetPdfUrlForFormQueryVariables>(GetPdfUrlForFormDocument, options);
      }
export function useGetPdfUrlForFormLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<GetPdfUrlForFormQuery, GetPdfUrlForFormQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<GetPdfUrlForFormQuery, GetPdfUrlForFormQueryVariables>(GetPdfUrlForFormDocument, options);
        }
export function useGetPdfUrlForFormSuspenseQuery(baseOptions?: Apollo.SuspenseQueryHookOptions<GetPdfUrlForFormQuery, GetPdfUrlForFormQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useSuspenseQuery<GetPdfUrlForFormQuery, GetPdfUrlForFormQueryVariables>(GetPdfUrlForFormDocument, options);
        }
export type GetPdfUrlForFormQueryHookResult = ReturnType<typeof useGetPdfUrlForFormQuery>;
export type GetPdfUrlForFormLazyQueryHookResult = ReturnType<typeof useGetPdfUrlForFormLazyQuery>;
export type GetPdfUrlForFormSuspenseQueryHookResult = ReturnType<typeof useGetPdfUrlForFormSuspenseQuery>;
export type GetPdfUrlForFormQueryResult = Apollo.QueryResult<GetPdfUrlForFormQuery, GetPdfUrlForFormQueryVariables>;
export const CreateFormDocument = gql`
    mutation createForm($data: CreateFormInput!) {
  createForm(data: $data) {
    ...FormFields
  }
}
    ${FormFieldsFragmentDoc}`;
export type CreateFormMutationFn = Apollo.MutationFunction<CreateFormMutation, CreateFormMutationVariables>;

/**
 * __useCreateFormMutation__
 *
 * To run a mutation, you first call `useCreateFormMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useCreateFormMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [createFormMutation, { data, loading, error }] = useCreateFormMutation({
 *   variables: {
 *      data: // value for 'data'
 *   },
 * });
 */
export function useCreateFormMutation(baseOptions?: Apollo.MutationHookOptions<CreateFormMutation, CreateFormMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<CreateFormMutation, CreateFormMutationVariables>(CreateFormDocument, options);
      }
export type CreateFormMutationHookResult = ReturnType<typeof useCreateFormMutation>;
export type CreateFormMutationResult = Apollo.MutationResult<CreateFormMutation>;
export type CreateFormMutationOptions = Apollo.BaseMutationOptions<CreateFormMutation, CreateFormMutationVariables>;
export const UpdateFormDocument = gql`
    mutation updateForm($id: ID!, $data: UpdateFormInput!) {
  updateForm(id: $id, data: $data) {
    ...FormFields
  }
}
    ${FormFieldsFragmentDoc}`;
export type UpdateFormMutationFn = Apollo.MutationFunction<UpdateFormMutation, UpdateFormMutationVariables>;

/**
 * __useUpdateFormMutation__
 *
 * To run a mutation, you first call `useUpdateFormMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useUpdateFormMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [updateFormMutation, { data, loading, error }] = useUpdateFormMutation({
 *   variables: {
 *      id: // value for 'id'
 *      data: // value for 'data'
 *   },
 * });
 */
export function useUpdateFormMutation(baseOptions?: Apollo.MutationHookOptions<UpdateFormMutation, UpdateFormMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<UpdateFormMutation, UpdateFormMutationVariables>(UpdateFormDocument, options);
      }
export type UpdateFormMutationHookResult = ReturnType<typeof useUpdateFormMutation>;
export type UpdateFormMutationResult = Apollo.MutationResult<UpdateFormMutation>;
export type UpdateFormMutationOptions = Apollo.BaseMutationOptions<UpdateFormMutation, UpdateFormMutationVariables>;
export const GetFormsForClinicDocument = gql`
    query getFormsForClinic($clinicId: ID!) {
  getFormsForClinic(clinicId: $clinicId) {
    ...FormFields
  }
}
    ${FormFieldsFragmentDoc}`;

/**
 * __useGetFormsForClinicQuery__
 *
 * To run a query within a React component, call `useGetFormsForClinicQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetFormsForClinicQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetFormsForClinicQuery({
 *   variables: {
 *      clinicId: // value for 'clinicId'
 *   },
 * });
 */
export function useGetFormsForClinicQuery(baseOptions: Apollo.QueryHookOptions<GetFormsForClinicQuery, GetFormsForClinicQueryVariables> & ({ variables: GetFormsForClinicQueryVariables; skip?: boolean; } | { skip: boolean; }) ) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<GetFormsForClinicQuery, GetFormsForClinicQueryVariables>(GetFormsForClinicDocument, options);
      }
export function useGetFormsForClinicLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<GetFormsForClinicQuery, GetFormsForClinicQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<GetFormsForClinicQuery, GetFormsForClinicQueryVariables>(GetFormsForClinicDocument, options);
        }
export function useGetFormsForClinicSuspenseQuery(baseOptions?: Apollo.SuspenseQueryHookOptions<GetFormsForClinicQuery, GetFormsForClinicQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useSuspenseQuery<GetFormsForClinicQuery, GetFormsForClinicQueryVariables>(GetFormsForClinicDocument, options);
        }
export type GetFormsForClinicQueryHookResult = ReturnType<typeof useGetFormsForClinicQuery>;
export type GetFormsForClinicLazyQueryHookResult = ReturnType<typeof useGetFormsForClinicLazyQuery>;
export type GetFormsForClinicSuspenseQueryHookResult = ReturnType<typeof useGetFormsForClinicSuspenseQuery>;
export type GetFormsForClinicQueryResult = Apollo.QueryResult<GetFormsForClinicQuery, GetFormsForClinicQueryVariables>;
export const GetAnalyticsForFormsDocument = gql`
    query getAnalyticsForForms($formIds: [ID!]!, $params: FormAnalyticsParams) {
  getAnalyticsForForms(formIds: $formIds, params: $params) {
    ...FormAnalyticsFields
  }
}
    ${FormAnalyticsFieldsFragmentDoc}`;

/**
 * __useGetAnalyticsForFormsQuery__
 *
 * To run a query within a React component, call `useGetAnalyticsForFormsQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetAnalyticsForFormsQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetAnalyticsForFormsQuery({
 *   variables: {
 *      formIds: // value for 'formIds'
 *      params: // value for 'params'
 *   },
 * });
 */
export function useGetAnalyticsForFormsQuery(baseOptions: Apollo.QueryHookOptions<GetAnalyticsForFormsQuery, GetAnalyticsForFormsQueryVariables> & ({ variables: GetAnalyticsForFormsQueryVariables; skip?: boolean; } | { skip: boolean; }) ) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<GetAnalyticsForFormsQuery, GetAnalyticsForFormsQueryVariables>(GetAnalyticsForFormsDocument, options);
      }
export function useGetAnalyticsForFormsLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<GetAnalyticsForFormsQuery, GetAnalyticsForFormsQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<GetAnalyticsForFormsQuery, GetAnalyticsForFormsQueryVariables>(GetAnalyticsForFormsDocument, options);
        }
export function useGetAnalyticsForFormsSuspenseQuery(baseOptions?: Apollo.SuspenseQueryHookOptions<GetAnalyticsForFormsQuery, GetAnalyticsForFormsQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useSuspenseQuery<GetAnalyticsForFormsQuery, GetAnalyticsForFormsQueryVariables>(GetAnalyticsForFormsDocument, options);
        }
export type GetAnalyticsForFormsQueryHookResult = ReturnType<typeof useGetAnalyticsForFormsQuery>;
export type GetAnalyticsForFormsLazyQueryHookResult = ReturnType<typeof useGetAnalyticsForFormsLazyQuery>;
export type GetAnalyticsForFormsSuspenseQueryHookResult = ReturnType<typeof useGetAnalyticsForFormsSuspenseQuery>;
export type GetAnalyticsForFormsQueryResult = Apollo.QueryResult<GetAnalyticsForFormsQuery, GetAnalyticsForFormsQueryVariables>;
export const ConvertPdfToFormElementsDocument = gql`
    mutation convertPdfToFormElements($data: ConvertPdfToFormInput!) {
  convertPdfToFormElements(data: $data) {
    success
    elements {
      ...FormElementFields
    }
    error
  }
}
    ${FormElementFieldsFragmentDoc}`;
export type ConvertPdfToFormElementsMutationFn = Apollo.MutationFunction<ConvertPdfToFormElementsMutation, ConvertPdfToFormElementsMutationVariables>;

/**
 * __useConvertPdfToFormElementsMutation__
 *
 * To run a mutation, you first call `useConvertPdfToFormElementsMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useConvertPdfToFormElementsMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [convertPdfToFormElementsMutation, { data, loading, error }] = useConvertPdfToFormElementsMutation({
 *   variables: {
 *      data: // value for 'data'
 *   },
 * });
 */
export function useConvertPdfToFormElementsMutation(baseOptions?: Apollo.MutationHookOptions<ConvertPdfToFormElementsMutation, ConvertPdfToFormElementsMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<ConvertPdfToFormElementsMutation, ConvertPdfToFormElementsMutationVariables>(ConvertPdfToFormElementsDocument, options);
      }
export type ConvertPdfToFormElementsMutationHookResult = ReturnType<typeof useConvertPdfToFormElementsMutation>;
export type ConvertPdfToFormElementsMutationResult = Apollo.MutationResult<ConvertPdfToFormElementsMutation>;
export type ConvertPdfToFormElementsMutationOptions = Apollo.BaseMutationOptions<ConvertPdfToFormElementsMutation, ConvertPdfToFormElementsMutationVariables>;
export const GetGoalByClinicAndIdDocument = gql`
    query getGoalByClinicAndId($clinicId: ID!, $goalId: ID!) {
  goal(clinicId: $clinicId, goalId: $goalId) {
    ...GoalsFields
  }
}
    ${GoalsFieldsFragmentDoc}`;

/**
 * __useGetGoalByClinicAndIdQuery__
 *
 * To run a query within a React component, call `useGetGoalByClinicAndIdQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetGoalByClinicAndIdQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetGoalByClinicAndIdQuery({
 *   variables: {
 *      clinicId: // value for 'clinicId'
 *      goalId: // value for 'goalId'
 *   },
 * });
 */
export function useGetGoalByClinicAndIdQuery(baseOptions: Apollo.QueryHookOptions<GetGoalByClinicAndIdQuery, GetGoalByClinicAndIdQueryVariables> & ({ variables: GetGoalByClinicAndIdQueryVariables; skip?: boolean; } | { skip: boolean; }) ) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<GetGoalByClinicAndIdQuery, GetGoalByClinicAndIdQueryVariables>(GetGoalByClinicAndIdDocument, options);
      }
export function useGetGoalByClinicAndIdLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<GetGoalByClinicAndIdQuery, GetGoalByClinicAndIdQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<GetGoalByClinicAndIdQuery, GetGoalByClinicAndIdQueryVariables>(GetGoalByClinicAndIdDocument, options);
        }
export function useGetGoalByClinicAndIdSuspenseQuery(baseOptions?: Apollo.SuspenseQueryHookOptions<GetGoalByClinicAndIdQuery, GetGoalByClinicAndIdQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useSuspenseQuery<GetGoalByClinicAndIdQuery, GetGoalByClinicAndIdQueryVariables>(GetGoalByClinicAndIdDocument, options);
        }
export type GetGoalByClinicAndIdQueryHookResult = ReturnType<typeof useGetGoalByClinicAndIdQuery>;
export type GetGoalByClinicAndIdLazyQueryHookResult = ReturnType<typeof useGetGoalByClinicAndIdLazyQuery>;
export type GetGoalByClinicAndIdSuspenseQueryHookResult = ReturnType<typeof useGetGoalByClinicAndIdSuspenseQuery>;
export type GetGoalByClinicAndIdQueryResult = Apollo.QueryResult<GetGoalByClinicAndIdQuery, GetGoalByClinicAndIdQueryVariables>;
export const GetGoalsByClinicDocument = gql`
    query getGoalsByClinic($clinicId: ID!) {
  getGoalsByClinic(clinicId: $clinicId) {
    ...GoalsFields
  }
}
    ${GoalsFieldsFragmentDoc}`;

/**
 * __useGetGoalsByClinicQuery__
 *
 * To run a query within a React component, call `useGetGoalsByClinicQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetGoalsByClinicQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetGoalsByClinicQuery({
 *   variables: {
 *      clinicId: // value for 'clinicId'
 *   },
 * });
 */
export function useGetGoalsByClinicQuery(baseOptions: Apollo.QueryHookOptions<GetGoalsByClinicQuery, GetGoalsByClinicQueryVariables> & ({ variables: GetGoalsByClinicQueryVariables; skip?: boolean; } | { skip: boolean; }) ) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<GetGoalsByClinicQuery, GetGoalsByClinicQueryVariables>(GetGoalsByClinicDocument, options);
      }
export function useGetGoalsByClinicLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<GetGoalsByClinicQuery, GetGoalsByClinicQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<GetGoalsByClinicQuery, GetGoalsByClinicQueryVariables>(GetGoalsByClinicDocument, options);
        }
export function useGetGoalsByClinicSuspenseQuery(baseOptions?: Apollo.SuspenseQueryHookOptions<GetGoalsByClinicQuery, GetGoalsByClinicQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useSuspenseQuery<GetGoalsByClinicQuery, GetGoalsByClinicQueryVariables>(GetGoalsByClinicDocument, options);
        }
export type GetGoalsByClinicQueryHookResult = ReturnType<typeof useGetGoalsByClinicQuery>;
export type GetGoalsByClinicLazyQueryHookResult = ReturnType<typeof useGetGoalsByClinicLazyQuery>;
export type GetGoalsByClinicSuspenseQueryHookResult = ReturnType<typeof useGetGoalsByClinicSuspenseQuery>;
export type GetGoalsByClinicQueryResult = Apollo.QueryResult<GetGoalsByClinicQuery, GetGoalsByClinicQueryVariables>;
export const CreateGoalDocument = gql`
    mutation createGoal($clinicId: ID!, $data: CreateGoalInput!) {
  createGoal(clinicId: $clinicId, data: $data) {
    ...GoalsFields
  }
}
    ${GoalsFieldsFragmentDoc}`;
export type CreateGoalMutationFn = Apollo.MutationFunction<CreateGoalMutation, CreateGoalMutationVariables>;

/**
 * __useCreateGoalMutation__
 *
 * To run a mutation, you first call `useCreateGoalMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useCreateGoalMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [createGoalMutation, { data, loading, error }] = useCreateGoalMutation({
 *   variables: {
 *      clinicId: // value for 'clinicId'
 *      data: // value for 'data'
 *   },
 * });
 */
export function useCreateGoalMutation(baseOptions?: Apollo.MutationHookOptions<CreateGoalMutation, CreateGoalMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<CreateGoalMutation, CreateGoalMutationVariables>(CreateGoalDocument, options);
      }
export type CreateGoalMutationHookResult = ReturnType<typeof useCreateGoalMutation>;
export type CreateGoalMutationResult = Apollo.MutationResult<CreateGoalMutation>;
export type CreateGoalMutationOptions = Apollo.BaseMutationOptions<CreateGoalMutation, CreateGoalMutationVariables>;
export const UpdateGoalDocument = gql`
    mutation updateGoal($clinicId: ID!, $goalId: ID!, $data: UpdateGoalInput!) {
  updateGoal(clinicId: $clinicId, goalId: $goalId, data: $data) {
    ...GoalsFields
  }
}
    ${GoalsFieldsFragmentDoc}`;
export type UpdateGoalMutationFn = Apollo.MutationFunction<UpdateGoalMutation, UpdateGoalMutationVariables>;

/**
 * __useUpdateGoalMutation__
 *
 * To run a mutation, you first call `useUpdateGoalMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useUpdateGoalMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [updateGoalMutation, { data, loading, error }] = useUpdateGoalMutation({
 *   variables: {
 *      clinicId: // value for 'clinicId'
 *      goalId: // value for 'goalId'
 *      data: // value for 'data'
 *   },
 * });
 */
export function useUpdateGoalMutation(baseOptions?: Apollo.MutationHookOptions<UpdateGoalMutation, UpdateGoalMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<UpdateGoalMutation, UpdateGoalMutationVariables>(UpdateGoalDocument, options);
      }
export type UpdateGoalMutationHookResult = ReturnType<typeof useUpdateGoalMutation>;
export type UpdateGoalMutationResult = Apollo.MutationResult<UpdateGoalMutation>;
export type UpdateGoalMutationOptions = Apollo.BaseMutationOptions<UpdateGoalMutation, UpdateGoalMutationVariables>;
export const DeleteGoalDocument = gql`
    mutation deleteGoal($clinicId: ID!, $goalId: ID!) {
  deleteGoal(clinicId: $clinicId, goalId: $goalId)
}
    `;
export type DeleteGoalMutationFn = Apollo.MutationFunction<DeleteGoalMutation, DeleteGoalMutationVariables>;

/**
 * __useDeleteGoalMutation__
 *
 * To run a mutation, you first call `useDeleteGoalMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useDeleteGoalMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [deleteGoalMutation, { data, loading, error }] = useDeleteGoalMutation({
 *   variables: {
 *      clinicId: // value for 'clinicId'
 *      goalId: // value for 'goalId'
 *   },
 * });
 */
export function useDeleteGoalMutation(baseOptions?: Apollo.MutationHookOptions<DeleteGoalMutation, DeleteGoalMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<DeleteGoalMutation, DeleteGoalMutationVariables>(DeleteGoalDocument, options);
      }
export type DeleteGoalMutationHookResult = ReturnType<typeof useDeleteGoalMutation>;
export type DeleteGoalMutationResult = Apollo.MutationResult<DeleteGoalMutation>;
export type DeleteGoalMutationOptions = Apollo.BaseMutationOptions<DeleteGoalMutation, DeleteGoalMutationVariables>;
export const InternalChatMessagesDocument = gql`
    query internalChatMessages($chatId: ID!, $page: NonNegativeInt, $pageSize: NonNegativeInt) {
  internalChatMessages(chatId: $chatId, page: $page, pageSize: $pageSize) {
    ...InternalChatMessageFields
  }
}
    ${InternalChatMessageFieldsFragmentDoc}`;

/**
 * __useInternalChatMessagesQuery__
 *
 * To run a query within a React component, call `useInternalChatMessagesQuery` and pass it any options that fit your needs.
 * When your component renders, `useInternalChatMessagesQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useInternalChatMessagesQuery({
 *   variables: {
 *      chatId: // value for 'chatId'
 *      page: // value for 'page'
 *      pageSize: // value for 'pageSize'
 *   },
 * });
 */
export function useInternalChatMessagesQuery(baseOptions: Apollo.QueryHookOptions<InternalChatMessagesQuery, InternalChatMessagesQueryVariables> & ({ variables: InternalChatMessagesQueryVariables; skip?: boolean; } | { skip: boolean; }) ) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<InternalChatMessagesQuery, InternalChatMessagesQueryVariables>(InternalChatMessagesDocument, options);
      }
export function useInternalChatMessagesLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<InternalChatMessagesQuery, InternalChatMessagesQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<InternalChatMessagesQuery, InternalChatMessagesQueryVariables>(InternalChatMessagesDocument, options);
        }
export function useInternalChatMessagesSuspenseQuery(baseOptions?: Apollo.SuspenseQueryHookOptions<InternalChatMessagesQuery, InternalChatMessagesQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useSuspenseQuery<InternalChatMessagesQuery, InternalChatMessagesQueryVariables>(InternalChatMessagesDocument, options);
        }
export type InternalChatMessagesQueryHookResult = ReturnType<typeof useInternalChatMessagesQuery>;
export type InternalChatMessagesLazyQueryHookResult = ReturnType<typeof useInternalChatMessagesLazyQuery>;
export type InternalChatMessagesSuspenseQueryHookResult = ReturnType<typeof useInternalChatMessagesSuspenseQuery>;
export type InternalChatMessagesQueryResult = Apollo.QueryResult<InternalChatMessagesQuery, InternalChatMessagesQueryVariables>;
export const CreateInternalChatMessageDocument = gql`
    mutation createInternalChatMessage($data: CreateInternalChatMessageInput!) {
  createInternalChatMessage(data: $data) {
    ...InternalChatMessageFields
  }
}
    ${InternalChatMessageFieldsFragmentDoc}`;
export type CreateInternalChatMessageMutationFn = Apollo.MutationFunction<CreateInternalChatMessageMutation, CreateInternalChatMessageMutationVariables>;

/**
 * __useCreateInternalChatMessageMutation__
 *
 * To run a mutation, you first call `useCreateInternalChatMessageMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useCreateInternalChatMessageMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [createInternalChatMessageMutation, { data, loading, error }] = useCreateInternalChatMessageMutation({
 *   variables: {
 *      data: // value for 'data'
 *   },
 * });
 */
export function useCreateInternalChatMessageMutation(baseOptions?: Apollo.MutationHookOptions<CreateInternalChatMessageMutation, CreateInternalChatMessageMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<CreateInternalChatMessageMutation, CreateInternalChatMessageMutationVariables>(CreateInternalChatMessageDocument, options);
      }
export type CreateInternalChatMessageMutationHookResult = ReturnType<typeof useCreateInternalChatMessageMutation>;
export type CreateInternalChatMessageMutationResult = Apollo.MutationResult<CreateInternalChatMessageMutation>;
export type CreateInternalChatMessageMutationOptions = Apollo.BaseMutationOptions<CreateInternalChatMessageMutation, CreateInternalChatMessageMutationVariables>;
export const UpdateInternalChatMessageDocument = gql`
    mutation updateInternalChatMessage($id: ID!, $data: UpdateInternalChatMessageInput!) {
  updateInternalChatMessage(id: $id, data: $data) {
    ...InternalChatMessageFields
  }
}
    ${InternalChatMessageFieldsFragmentDoc}`;
export type UpdateInternalChatMessageMutationFn = Apollo.MutationFunction<UpdateInternalChatMessageMutation, UpdateInternalChatMessageMutationVariables>;

/**
 * __useUpdateInternalChatMessageMutation__
 *
 * To run a mutation, you first call `useUpdateInternalChatMessageMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useUpdateInternalChatMessageMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [updateInternalChatMessageMutation, { data, loading, error }] = useUpdateInternalChatMessageMutation({
 *   variables: {
 *      id: // value for 'id'
 *      data: // value for 'data'
 *   },
 * });
 */
export function useUpdateInternalChatMessageMutation(baseOptions?: Apollo.MutationHookOptions<UpdateInternalChatMessageMutation, UpdateInternalChatMessageMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<UpdateInternalChatMessageMutation, UpdateInternalChatMessageMutationVariables>(UpdateInternalChatMessageDocument, options);
      }
export type UpdateInternalChatMessageMutationHookResult = ReturnType<typeof useUpdateInternalChatMessageMutation>;
export type UpdateInternalChatMessageMutationResult = Apollo.MutationResult<UpdateInternalChatMessageMutation>;
export type UpdateInternalChatMessageMutationOptions = Apollo.BaseMutationOptions<UpdateInternalChatMessageMutation, UpdateInternalChatMessageMutationVariables>;
export const DeleteInternalChatMessageDocument = gql`
    mutation deleteInternalChatMessage($id: ID!) {
  deleteInternalChatMessage(id: $id)
}
    `;
export type DeleteInternalChatMessageMutationFn = Apollo.MutationFunction<DeleteInternalChatMessageMutation, DeleteInternalChatMessageMutationVariables>;

/**
 * __useDeleteInternalChatMessageMutation__
 *
 * To run a mutation, you first call `useDeleteInternalChatMessageMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useDeleteInternalChatMessageMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [deleteInternalChatMessageMutation, { data, loading, error }] = useDeleteInternalChatMessageMutation({
 *   variables: {
 *      id: // value for 'id'
 *   },
 * });
 */
export function useDeleteInternalChatMessageMutation(baseOptions?: Apollo.MutationHookOptions<DeleteInternalChatMessageMutation, DeleteInternalChatMessageMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<DeleteInternalChatMessageMutation, DeleteInternalChatMessageMutationVariables>(DeleteInternalChatMessageDocument, options);
      }
export type DeleteInternalChatMessageMutationHookResult = ReturnType<typeof useDeleteInternalChatMessageMutation>;
export type DeleteInternalChatMessageMutationResult = Apollo.MutationResult<DeleteInternalChatMessageMutation>;
export type DeleteInternalChatMessageMutationOptions = Apollo.BaseMutationOptions<DeleteInternalChatMessageMutation, DeleteInternalChatMessageMutationVariables>;
export const InternalChatUsersDocument = gql`
    query internalChatUsers($chatId: ID!) {
  internalChatUsers(chatId: $chatId) {
    ...InternalChatUserFields
  }
}
    ${InternalChatUserFieldsFragmentDoc}`;

/**
 * __useInternalChatUsersQuery__
 *
 * To run a query within a React component, call `useInternalChatUsersQuery` and pass it any options that fit your needs.
 * When your component renders, `useInternalChatUsersQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useInternalChatUsersQuery({
 *   variables: {
 *      chatId: // value for 'chatId'
 *   },
 * });
 */
export function useInternalChatUsersQuery(baseOptions: Apollo.QueryHookOptions<InternalChatUsersQuery, InternalChatUsersQueryVariables> & ({ variables: InternalChatUsersQueryVariables; skip?: boolean; } | { skip: boolean; }) ) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<InternalChatUsersQuery, InternalChatUsersQueryVariables>(InternalChatUsersDocument, options);
      }
export function useInternalChatUsersLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<InternalChatUsersQuery, InternalChatUsersQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<InternalChatUsersQuery, InternalChatUsersQueryVariables>(InternalChatUsersDocument, options);
        }
export function useInternalChatUsersSuspenseQuery(baseOptions?: Apollo.SuspenseQueryHookOptions<InternalChatUsersQuery, InternalChatUsersQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useSuspenseQuery<InternalChatUsersQuery, InternalChatUsersQueryVariables>(InternalChatUsersDocument, options);
        }
export type InternalChatUsersQueryHookResult = ReturnType<typeof useInternalChatUsersQuery>;
export type InternalChatUsersLazyQueryHookResult = ReturnType<typeof useInternalChatUsersLazyQuery>;
export type InternalChatUsersSuspenseQueryHookResult = ReturnType<typeof useInternalChatUsersSuspenseQuery>;
export type InternalChatUsersQueryResult = Apollo.QueryResult<InternalChatUsersQuery, InternalChatUsersQueryVariables>;
export const QueryInternalChatUsersDocument = gql`
    query queryInternalChatUsers($where: [QueryInput!], $page: NonNegativeInt, $pageSize: NonNegativeInt, $orderBy: OrderByInput) {
  queryInternalChatUsers(
    where: $where
    page: $page
    pageSize: $pageSize
    orderBy: $orderBy
  ) {
    ...InternalChatUserFields
  }
}
    ${InternalChatUserFieldsFragmentDoc}`;

/**
 * __useQueryInternalChatUsersQuery__
 *
 * To run a query within a React component, call `useQueryInternalChatUsersQuery` and pass it any options that fit your needs.
 * When your component renders, `useQueryInternalChatUsersQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useQueryInternalChatUsersQuery({
 *   variables: {
 *      where: // value for 'where'
 *      page: // value for 'page'
 *      pageSize: // value for 'pageSize'
 *      orderBy: // value for 'orderBy'
 *   },
 * });
 */
export function useQueryInternalChatUsersQuery(baseOptions?: Apollo.QueryHookOptions<QueryInternalChatUsersQuery, QueryInternalChatUsersQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<QueryInternalChatUsersQuery, QueryInternalChatUsersQueryVariables>(QueryInternalChatUsersDocument, options);
      }
export function useQueryInternalChatUsersLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<QueryInternalChatUsersQuery, QueryInternalChatUsersQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<QueryInternalChatUsersQuery, QueryInternalChatUsersQueryVariables>(QueryInternalChatUsersDocument, options);
        }
export function useQueryInternalChatUsersSuspenseQuery(baseOptions?: Apollo.SuspenseQueryHookOptions<QueryInternalChatUsersQuery, QueryInternalChatUsersQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useSuspenseQuery<QueryInternalChatUsersQuery, QueryInternalChatUsersQueryVariables>(QueryInternalChatUsersDocument, options);
        }
export type QueryInternalChatUsersQueryHookResult = ReturnType<typeof useQueryInternalChatUsersQuery>;
export type QueryInternalChatUsersLazyQueryHookResult = ReturnType<typeof useQueryInternalChatUsersLazyQuery>;
export type QueryInternalChatUsersSuspenseQueryHookResult = ReturnType<typeof useQueryInternalChatUsersSuspenseQuery>;
export type QueryInternalChatUsersQueryResult = Apollo.QueryResult<QueryInternalChatUsersQuery, QueryInternalChatUsersQueryVariables>;
export const CountInternalChatUsersDocument = gql`
    query countInternalChatUsers($where: [QueryInput!]) {
  countInternalChatUsers(where: $where)
}
    `;

/**
 * __useCountInternalChatUsersQuery__
 *
 * To run a query within a React component, call `useCountInternalChatUsersQuery` and pass it any options that fit your needs.
 * When your component renders, `useCountInternalChatUsersQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useCountInternalChatUsersQuery({
 *   variables: {
 *      where: // value for 'where'
 *   },
 * });
 */
export function useCountInternalChatUsersQuery(baseOptions?: Apollo.QueryHookOptions<CountInternalChatUsersQuery, CountInternalChatUsersQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<CountInternalChatUsersQuery, CountInternalChatUsersQueryVariables>(CountInternalChatUsersDocument, options);
      }
export function useCountInternalChatUsersLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<CountInternalChatUsersQuery, CountInternalChatUsersQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<CountInternalChatUsersQuery, CountInternalChatUsersQueryVariables>(CountInternalChatUsersDocument, options);
        }
export function useCountInternalChatUsersSuspenseQuery(baseOptions?: Apollo.SuspenseQueryHookOptions<CountInternalChatUsersQuery, CountInternalChatUsersQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useSuspenseQuery<CountInternalChatUsersQuery, CountInternalChatUsersQueryVariables>(CountInternalChatUsersDocument, options);
        }
export type CountInternalChatUsersQueryHookResult = ReturnType<typeof useCountInternalChatUsersQuery>;
export type CountInternalChatUsersLazyQueryHookResult = ReturnType<typeof useCountInternalChatUsersLazyQuery>;
export type CountInternalChatUsersSuspenseQueryHookResult = ReturnType<typeof useCountInternalChatUsersSuspenseQuery>;
export type CountInternalChatUsersQueryResult = Apollo.QueryResult<CountInternalChatUsersQuery, CountInternalChatUsersQueryVariables>;
export const CreateInternalChatUserDocument = gql`
    mutation createInternalChatUser($chatId: ID!, $userId: ID!) {
  createInternalChatUser(chatId: $chatId, userId: $userId) {
    ...InternalChatUserFields
  }
}
    ${InternalChatUserFieldsFragmentDoc}`;
export type CreateInternalChatUserMutationFn = Apollo.MutationFunction<CreateInternalChatUserMutation, CreateInternalChatUserMutationVariables>;

/**
 * __useCreateInternalChatUserMutation__
 *
 * To run a mutation, you first call `useCreateInternalChatUserMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useCreateInternalChatUserMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [createInternalChatUserMutation, { data, loading, error }] = useCreateInternalChatUserMutation({
 *   variables: {
 *      chatId: // value for 'chatId'
 *      userId: // value for 'userId'
 *   },
 * });
 */
export function useCreateInternalChatUserMutation(baseOptions?: Apollo.MutationHookOptions<CreateInternalChatUserMutation, CreateInternalChatUserMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<CreateInternalChatUserMutation, CreateInternalChatUserMutationVariables>(CreateInternalChatUserDocument, options);
      }
export type CreateInternalChatUserMutationHookResult = ReturnType<typeof useCreateInternalChatUserMutation>;
export type CreateInternalChatUserMutationResult = Apollo.MutationResult<CreateInternalChatUserMutation>;
export type CreateInternalChatUserMutationOptions = Apollo.BaseMutationOptions<CreateInternalChatUserMutation, CreateInternalChatUserMutationVariables>;
export const UpdateInternalChatUserDocument = gql`
    mutation updateInternalChatUser($id: ID!, $data: UpdateInternalChatUserInput!) {
  updateInternalChatUser(id: $id, data: $data) {
    ...InternalChatUserFields
  }
}
    ${InternalChatUserFieldsFragmentDoc}`;
export type UpdateInternalChatUserMutationFn = Apollo.MutationFunction<UpdateInternalChatUserMutation, UpdateInternalChatUserMutationVariables>;

/**
 * __useUpdateInternalChatUserMutation__
 *
 * To run a mutation, you first call `useUpdateInternalChatUserMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useUpdateInternalChatUserMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [updateInternalChatUserMutation, { data, loading, error }] = useUpdateInternalChatUserMutation({
 *   variables: {
 *      id: // value for 'id'
 *      data: // value for 'data'
 *   },
 * });
 */
export function useUpdateInternalChatUserMutation(baseOptions?: Apollo.MutationHookOptions<UpdateInternalChatUserMutation, UpdateInternalChatUserMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<UpdateInternalChatUserMutation, UpdateInternalChatUserMutationVariables>(UpdateInternalChatUserDocument, options);
      }
export type UpdateInternalChatUserMutationHookResult = ReturnType<typeof useUpdateInternalChatUserMutation>;
export type UpdateInternalChatUserMutationResult = Apollo.MutationResult<UpdateInternalChatUserMutation>;
export type UpdateInternalChatUserMutationOptions = Apollo.BaseMutationOptions<UpdateInternalChatUserMutation, UpdateInternalChatUserMutationVariables>;
export const UpdateInternalChatUserLastReadDocument = gql`
    mutation updateInternalChatUserLastRead($chatId: ID!, $userId: ID!, $lastReadTime: NonNegativeInt!) {
  updateInternalChatUserLastRead(
    chatId: $chatId
    userId: $userId
    lastReadTime: $lastReadTime
  ) {
    ...InternalChatUserFields
  }
}
    ${InternalChatUserFieldsFragmentDoc}`;
export type UpdateInternalChatUserLastReadMutationFn = Apollo.MutationFunction<UpdateInternalChatUserLastReadMutation, UpdateInternalChatUserLastReadMutationVariables>;

/**
 * __useUpdateInternalChatUserLastReadMutation__
 *
 * To run a mutation, you first call `useUpdateInternalChatUserLastReadMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useUpdateInternalChatUserLastReadMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [updateInternalChatUserLastReadMutation, { data, loading, error }] = useUpdateInternalChatUserLastReadMutation({
 *   variables: {
 *      chatId: // value for 'chatId'
 *      userId: // value for 'userId'
 *      lastReadTime: // value for 'lastReadTime'
 *   },
 * });
 */
export function useUpdateInternalChatUserLastReadMutation(baseOptions?: Apollo.MutationHookOptions<UpdateInternalChatUserLastReadMutation, UpdateInternalChatUserLastReadMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<UpdateInternalChatUserLastReadMutation, UpdateInternalChatUserLastReadMutationVariables>(UpdateInternalChatUserLastReadDocument, options);
      }
export type UpdateInternalChatUserLastReadMutationHookResult = ReturnType<typeof useUpdateInternalChatUserLastReadMutation>;
export type UpdateInternalChatUserLastReadMutationResult = Apollo.MutationResult<UpdateInternalChatUserLastReadMutation>;
export type UpdateInternalChatUserLastReadMutationOptions = Apollo.BaseMutationOptions<UpdateInternalChatUserLastReadMutation, UpdateInternalChatUserLastReadMutationVariables>;
export const DeleteInternalChatUserDocument = gql`
    mutation deleteInternalChatUser($id: ID!) {
  deleteInternalChatUser(id: $id)
}
    `;
export type DeleteInternalChatUserMutationFn = Apollo.MutationFunction<DeleteInternalChatUserMutation, DeleteInternalChatUserMutationVariables>;

/**
 * __useDeleteInternalChatUserMutation__
 *
 * To run a mutation, you first call `useDeleteInternalChatUserMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useDeleteInternalChatUserMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [deleteInternalChatUserMutation, { data, loading, error }] = useDeleteInternalChatUserMutation({
 *   variables: {
 *      id: // value for 'id'
 *   },
 * });
 */
export function useDeleteInternalChatUserMutation(baseOptions?: Apollo.MutationHookOptions<DeleteInternalChatUserMutation, DeleteInternalChatUserMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<DeleteInternalChatUserMutation, DeleteInternalChatUserMutationVariables>(DeleteInternalChatUserDocument, options);
      }
export type DeleteInternalChatUserMutationHookResult = ReturnType<typeof useDeleteInternalChatUserMutation>;
export type DeleteInternalChatUserMutationResult = Apollo.MutationResult<DeleteInternalChatUserMutation>;
export type DeleteInternalChatUserMutationOptions = Apollo.BaseMutationOptions<DeleteInternalChatUserMutation, DeleteInternalChatUserMutationVariables>;
export const InternalChatDocument = gql`
    query internalChat($id: ID!) {
  internalChat(id: $id) {
    ...InternalChatFields
  }
}
    ${InternalChatFieldsFragmentDoc}`;

/**
 * __useInternalChatQuery__
 *
 * To run a query within a React component, call `useInternalChatQuery` and pass it any options that fit your needs.
 * When your component renders, `useInternalChatQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useInternalChatQuery({
 *   variables: {
 *      id: // value for 'id'
 *   },
 * });
 */
export function useInternalChatQuery(baseOptions: Apollo.QueryHookOptions<InternalChatQuery, InternalChatQueryVariables> & ({ variables: InternalChatQueryVariables; skip?: boolean; } | { skip: boolean; }) ) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<InternalChatQuery, InternalChatQueryVariables>(InternalChatDocument, options);
      }
export function useInternalChatLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<InternalChatQuery, InternalChatQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<InternalChatQuery, InternalChatQueryVariables>(InternalChatDocument, options);
        }
export function useInternalChatSuspenseQuery(baseOptions?: Apollo.SuspenseQueryHookOptions<InternalChatQuery, InternalChatQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useSuspenseQuery<InternalChatQuery, InternalChatQueryVariables>(InternalChatDocument, options);
        }
export type InternalChatQueryHookResult = ReturnType<typeof useInternalChatQuery>;
export type InternalChatLazyQueryHookResult = ReturnType<typeof useInternalChatLazyQuery>;
export type InternalChatSuspenseQueryHookResult = ReturnType<typeof useInternalChatSuspenseQuery>;
export type InternalChatQueryResult = Apollo.QueryResult<InternalChatQuery, InternalChatQueryVariables>;
export const CreateInternalChatDocument = gql`
    mutation createInternalChat($data: CreateInternalChatInput!) {
  createInternalChat(data: $data) {
    ...InternalChatFields
  }
}
    ${InternalChatFieldsFragmentDoc}`;
export type CreateInternalChatMutationFn = Apollo.MutationFunction<CreateInternalChatMutation, CreateInternalChatMutationVariables>;

/**
 * __useCreateInternalChatMutation__
 *
 * To run a mutation, you first call `useCreateInternalChatMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useCreateInternalChatMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [createInternalChatMutation, { data, loading, error }] = useCreateInternalChatMutation({
 *   variables: {
 *      data: // value for 'data'
 *   },
 * });
 */
export function useCreateInternalChatMutation(baseOptions?: Apollo.MutationHookOptions<CreateInternalChatMutation, CreateInternalChatMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<CreateInternalChatMutation, CreateInternalChatMutationVariables>(CreateInternalChatDocument, options);
      }
export type CreateInternalChatMutationHookResult = ReturnType<typeof useCreateInternalChatMutation>;
export type CreateInternalChatMutationResult = Apollo.MutationResult<CreateInternalChatMutation>;
export type CreateInternalChatMutationOptions = Apollo.BaseMutationOptions<CreateInternalChatMutation, CreateInternalChatMutationVariables>;
export const UpdateInternalChatDocument = gql`
    mutation updateInternalChat($id: ID!, $data: UpdateInternalChatInput!) {
  updateInternalChat(id: $id, data: $data) {
    ...InternalChatFields
  }
}
    ${InternalChatFieldsFragmentDoc}`;
export type UpdateInternalChatMutationFn = Apollo.MutationFunction<UpdateInternalChatMutation, UpdateInternalChatMutationVariables>;

/**
 * __useUpdateInternalChatMutation__
 *
 * To run a mutation, you first call `useUpdateInternalChatMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useUpdateInternalChatMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [updateInternalChatMutation, { data, loading, error }] = useUpdateInternalChatMutation({
 *   variables: {
 *      id: // value for 'id'
 *      data: // value for 'data'
 *   },
 * });
 */
export function useUpdateInternalChatMutation(baseOptions?: Apollo.MutationHookOptions<UpdateInternalChatMutation, UpdateInternalChatMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<UpdateInternalChatMutation, UpdateInternalChatMutationVariables>(UpdateInternalChatDocument, options);
      }
export type UpdateInternalChatMutationHookResult = ReturnType<typeof useUpdateInternalChatMutation>;
export type UpdateInternalChatMutationResult = Apollo.MutationResult<UpdateInternalChatMutation>;
export type UpdateInternalChatMutationOptions = Apollo.BaseMutationOptions<UpdateInternalChatMutation, UpdateInternalChatMutationVariables>;
export const DeleteInternalChatDocument = gql`
    mutation deleteInternalChat($id: ID!) {
  deleteInternalChat(id: $id)
}
    `;
export type DeleteInternalChatMutationFn = Apollo.MutationFunction<DeleteInternalChatMutation, DeleteInternalChatMutationVariables>;

/**
 * __useDeleteInternalChatMutation__
 *
 * To run a mutation, you first call `useDeleteInternalChatMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useDeleteInternalChatMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [deleteInternalChatMutation, { data, loading, error }] = useDeleteInternalChatMutation({
 *   variables: {
 *      id: // value for 'id'
 *   },
 * });
 */
export function useDeleteInternalChatMutation(baseOptions?: Apollo.MutationHookOptions<DeleteInternalChatMutation, DeleteInternalChatMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<DeleteInternalChatMutation, DeleteInternalChatMutationVariables>(DeleteInternalChatDocument, options);
      }
export type DeleteInternalChatMutationHookResult = ReturnType<typeof useDeleteInternalChatMutation>;
export type DeleteInternalChatMutationResult = Apollo.MutationResult<DeleteInternalChatMutation>;
export type DeleteInternalChatMutationOptions = Apollo.BaseMutationOptions<DeleteInternalChatMutation, DeleteInternalChatMutationVariables>;
export const GetInternalUsageEventsDocument = gql`
    query getInternalUsageEvents($filters: InternalUsageEventFilters!) {
  internalUsageEvents(filters: $filters) {
    ...InternalUsageEventFields
  }
}
    ${InternalUsageEventFieldsFragmentDoc}`;

/**
 * __useGetInternalUsageEventsQuery__
 *
 * To run a query within a React component, call `useGetInternalUsageEventsQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetInternalUsageEventsQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetInternalUsageEventsQuery({
 *   variables: {
 *      filters: // value for 'filters'
 *   },
 * });
 */
export function useGetInternalUsageEventsQuery(baseOptions: Apollo.QueryHookOptions<GetInternalUsageEventsQuery, GetInternalUsageEventsQueryVariables> & ({ variables: GetInternalUsageEventsQueryVariables; skip?: boolean; } | { skip: boolean; }) ) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<GetInternalUsageEventsQuery, GetInternalUsageEventsQueryVariables>(GetInternalUsageEventsDocument, options);
      }
export function useGetInternalUsageEventsLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<GetInternalUsageEventsQuery, GetInternalUsageEventsQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<GetInternalUsageEventsQuery, GetInternalUsageEventsQueryVariables>(GetInternalUsageEventsDocument, options);
        }
export function useGetInternalUsageEventsSuspenseQuery(baseOptions?: Apollo.SuspenseQueryHookOptions<GetInternalUsageEventsQuery, GetInternalUsageEventsQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useSuspenseQuery<GetInternalUsageEventsQuery, GetInternalUsageEventsQueryVariables>(GetInternalUsageEventsDocument, options);
        }
export type GetInternalUsageEventsQueryHookResult = ReturnType<typeof useGetInternalUsageEventsQuery>;
export type GetInternalUsageEventsLazyQueryHookResult = ReturnType<typeof useGetInternalUsageEventsLazyQuery>;
export type GetInternalUsageEventsSuspenseQueryHookResult = ReturnType<typeof useGetInternalUsageEventsSuspenseQuery>;
export type GetInternalUsageEventsQueryResult = Apollo.QueryResult<GetInternalUsageEventsQuery, GetInternalUsageEventsQueryVariables>;
export const CountInternalUsageEventsDocument = gql`
    query countInternalUsageEvents($filters: InternalUsageEventFilters!) {
  countInternalUsageEvents(filters: $filters)
}
    `;

/**
 * __useCountInternalUsageEventsQuery__
 *
 * To run a query within a React component, call `useCountInternalUsageEventsQuery` and pass it any options that fit your needs.
 * When your component renders, `useCountInternalUsageEventsQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useCountInternalUsageEventsQuery({
 *   variables: {
 *      filters: // value for 'filters'
 *   },
 * });
 */
export function useCountInternalUsageEventsQuery(baseOptions: Apollo.QueryHookOptions<CountInternalUsageEventsQuery, CountInternalUsageEventsQueryVariables> & ({ variables: CountInternalUsageEventsQueryVariables; skip?: boolean; } | { skip: boolean; }) ) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<CountInternalUsageEventsQuery, CountInternalUsageEventsQueryVariables>(CountInternalUsageEventsDocument, options);
      }
export function useCountInternalUsageEventsLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<CountInternalUsageEventsQuery, CountInternalUsageEventsQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<CountInternalUsageEventsQuery, CountInternalUsageEventsQueryVariables>(CountInternalUsageEventsDocument, options);
        }
export function useCountInternalUsageEventsSuspenseQuery(baseOptions?: Apollo.SuspenseQueryHookOptions<CountInternalUsageEventsQuery, CountInternalUsageEventsQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useSuspenseQuery<CountInternalUsageEventsQuery, CountInternalUsageEventsQueryVariables>(CountInternalUsageEventsDocument, options);
        }
export type CountInternalUsageEventsQueryHookResult = ReturnType<typeof useCountInternalUsageEventsQuery>;
export type CountInternalUsageEventsLazyQueryHookResult = ReturnType<typeof useCountInternalUsageEventsLazyQuery>;
export type CountInternalUsageEventsSuspenseQueryHookResult = ReturnType<typeof useCountInternalUsageEventsSuspenseQuery>;
export type CountInternalUsageEventsQueryResult = Apollo.QueryResult<CountInternalUsageEventsQuery, CountInternalUsageEventsQueryVariables>;
export const ClinicForInternalUsageEventDocument = gql`
    query clinicForInternalUsageEvent($clinicId: ID!) {
  clinic(id: $clinicId) {
    ...InternalUsageClinicFields
  }
}
    ${InternalUsageClinicFieldsFragmentDoc}`;

/**
 * __useClinicForInternalUsageEventQuery__
 *
 * To run a query within a React component, call `useClinicForInternalUsageEventQuery` and pass it any options that fit your needs.
 * When your component renders, `useClinicForInternalUsageEventQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useClinicForInternalUsageEventQuery({
 *   variables: {
 *      clinicId: // value for 'clinicId'
 *   },
 * });
 */
export function useClinicForInternalUsageEventQuery(baseOptions: Apollo.QueryHookOptions<ClinicForInternalUsageEventQuery, ClinicForInternalUsageEventQueryVariables> & ({ variables: ClinicForInternalUsageEventQueryVariables; skip?: boolean; } | { skip: boolean; }) ) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<ClinicForInternalUsageEventQuery, ClinicForInternalUsageEventQueryVariables>(ClinicForInternalUsageEventDocument, options);
      }
export function useClinicForInternalUsageEventLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<ClinicForInternalUsageEventQuery, ClinicForInternalUsageEventQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<ClinicForInternalUsageEventQuery, ClinicForInternalUsageEventQueryVariables>(ClinicForInternalUsageEventDocument, options);
        }
export function useClinicForInternalUsageEventSuspenseQuery(baseOptions?: Apollo.SuspenseQueryHookOptions<ClinicForInternalUsageEventQuery, ClinicForInternalUsageEventQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useSuspenseQuery<ClinicForInternalUsageEventQuery, ClinicForInternalUsageEventQueryVariables>(ClinicForInternalUsageEventDocument, options);
        }
export type ClinicForInternalUsageEventQueryHookResult = ReturnType<typeof useClinicForInternalUsageEventQuery>;
export type ClinicForInternalUsageEventLazyQueryHookResult = ReturnType<typeof useClinicForInternalUsageEventLazyQuery>;
export type ClinicForInternalUsageEventSuspenseQueryHookResult = ReturnType<typeof useClinicForInternalUsageEventSuspenseQuery>;
export type ClinicForInternalUsageEventQueryResult = Apollo.QueryResult<ClinicForInternalUsageEventQuery, ClinicForInternalUsageEventQueryVariables>;
export const UserForInternalUsageEventDocument = gql`
    query userForInternalUsageEvent($userId: ID!) {
  user(id: $userId) {
    ...InternalUsageUserFields
  }
}
    ${InternalUsageUserFieldsFragmentDoc}`;

/**
 * __useUserForInternalUsageEventQuery__
 *
 * To run a query within a React component, call `useUserForInternalUsageEventQuery` and pass it any options that fit your needs.
 * When your component renders, `useUserForInternalUsageEventQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useUserForInternalUsageEventQuery({
 *   variables: {
 *      userId: // value for 'userId'
 *   },
 * });
 */
export function useUserForInternalUsageEventQuery(baseOptions: Apollo.QueryHookOptions<UserForInternalUsageEventQuery, UserForInternalUsageEventQueryVariables> & ({ variables: UserForInternalUsageEventQueryVariables; skip?: boolean; } | { skip: boolean; }) ) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<UserForInternalUsageEventQuery, UserForInternalUsageEventQueryVariables>(UserForInternalUsageEventDocument, options);
      }
export function useUserForInternalUsageEventLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<UserForInternalUsageEventQuery, UserForInternalUsageEventQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<UserForInternalUsageEventQuery, UserForInternalUsageEventQueryVariables>(UserForInternalUsageEventDocument, options);
        }
export function useUserForInternalUsageEventSuspenseQuery(baseOptions?: Apollo.SuspenseQueryHookOptions<UserForInternalUsageEventQuery, UserForInternalUsageEventQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useSuspenseQuery<UserForInternalUsageEventQuery, UserForInternalUsageEventQueryVariables>(UserForInternalUsageEventDocument, options);
        }
export type UserForInternalUsageEventQueryHookResult = ReturnType<typeof useUserForInternalUsageEventQuery>;
export type UserForInternalUsageEventLazyQueryHookResult = ReturnType<typeof useUserForInternalUsageEventLazyQuery>;
export type UserForInternalUsageEventSuspenseQueryHookResult = ReturnType<typeof useUserForInternalUsageEventSuspenseQuery>;
export type UserForInternalUsageEventQueryResult = Apollo.QueryResult<UserForInternalUsageEventQuery, UserForInternalUsageEventQueryVariables>;
export const CreateInternalUsageEventDocument = gql`
    mutation createInternalUsageEvent($data: InternalUsageEventInput!) {
  createInternalUsageEvent(data: $data) {
    ...InternalUsageEventFields
  }
}
    ${InternalUsageEventFieldsFragmentDoc}`;
export type CreateInternalUsageEventMutationFn = Apollo.MutationFunction<CreateInternalUsageEventMutation, CreateInternalUsageEventMutationVariables>;

/**
 * __useCreateInternalUsageEventMutation__
 *
 * To run a mutation, you first call `useCreateInternalUsageEventMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useCreateInternalUsageEventMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [createInternalUsageEventMutation, { data, loading, error }] = useCreateInternalUsageEventMutation({
 *   variables: {
 *      data: // value for 'data'
 *   },
 * });
 */
export function useCreateInternalUsageEventMutation(baseOptions?: Apollo.MutationHookOptions<CreateInternalUsageEventMutation, CreateInternalUsageEventMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<CreateInternalUsageEventMutation, CreateInternalUsageEventMutationVariables>(CreateInternalUsageEventDocument, options);
      }
export type CreateInternalUsageEventMutationHookResult = ReturnType<typeof useCreateInternalUsageEventMutation>;
export type CreateInternalUsageEventMutationResult = Apollo.MutationResult<CreateInternalUsageEventMutation>;
export type CreateInternalUsageEventMutationOptions = Apollo.BaseMutationOptions<CreateInternalUsageEventMutation, CreateInternalUsageEventMutationVariables>;
export const QueryInvoicesDocument = gql`
    query queryInvoices($where: [QueryInput!], $page: NonNegativeInt, $pageSize: NonNegativeInt, $orderBy: OrderByInput) {
  queryInvoices(
    where: $where
    page: $page
    pageSize: $pageSize
    orderBy: $orderBy
  ) {
    ...InvoiceFields
  }
}
    ${InvoiceFieldsFragmentDoc}`;

/**
 * __useQueryInvoicesQuery__
 *
 * To run a query within a React component, call `useQueryInvoicesQuery` and pass it any options that fit your needs.
 * When your component renders, `useQueryInvoicesQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useQueryInvoicesQuery({
 *   variables: {
 *      where: // value for 'where'
 *      page: // value for 'page'
 *      pageSize: // value for 'pageSize'
 *      orderBy: // value for 'orderBy'
 *   },
 * });
 */
export function useQueryInvoicesQuery(baseOptions?: Apollo.QueryHookOptions<QueryInvoicesQuery, QueryInvoicesQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<QueryInvoicesQuery, QueryInvoicesQueryVariables>(QueryInvoicesDocument, options);
      }
export function useQueryInvoicesLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<QueryInvoicesQuery, QueryInvoicesQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<QueryInvoicesQuery, QueryInvoicesQueryVariables>(QueryInvoicesDocument, options);
        }
export function useQueryInvoicesSuspenseQuery(baseOptions?: Apollo.SuspenseQueryHookOptions<QueryInvoicesQuery, QueryInvoicesQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useSuspenseQuery<QueryInvoicesQuery, QueryInvoicesQueryVariables>(QueryInvoicesDocument, options);
        }
export type QueryInvoicesQueryHookResult = ReturnType<typeof useQueryInvoicesQuery>;
export type QueryInvoicesLazyQueryHookResult = ReturnType<typeof useQueryInvoicesLazyQuery>;
export type QueryInvoicesSuspenseQueryHookResult = ReturnType<typeof useQueryInvoicesSuspenseQuery>;
export type QueryInvoicesQueryResult = Apollo.QueryResult<QueryInvoicesQuery, QueryInvoicesQueryVariables>;
export const CountInvoicesDocument = gql`
    query countInvoices($where: [QueryInput!]) {
  countInvoices(where: $where)
}
    `;

/**
 * __useCountInvoicesQuery__
 *
 * To run a query within a React component, call `useCountInvoicesQuery` and pass it any options that fit your needs.
 * When your component renders, `useCountInvoicesQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useCountInvoicesQuery({
 *   variables: {
 *      where: // value for 'where'
 *   },
 * });
 */
export function useCountInvoicesQuery(baseOptions?: Apollo.QueryHookOptions<CountInvoicesQuery, CountInvoicesQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<CountInvoicesQuery, CountInvoicesQueryVariables>(CountInvoicesDocument, options);
      }
export function useCountInvoicesLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<CountInvoicesQuery, CountInvoicesQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<CountInvoicesQuery, CountInvoicesQueryVariables>(CountInvoicesDocument, options);
        }
export function useCountInvoicesSuspenseQuery(baseOptions?: Apollo.SuspenseQueryHookOptions<CountInvoicesQuery, CountInvoicesQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useSuspenseQuery<CountInvoicesQuery, CountInvoicesQueryVariables>(CountInvoicesDocument, options);
        }
export type CountInvoicesQueryHookResult = ReturnType<typeof useCountInvoicesQuery>;
export type CountInvoicesLazyQueryHookResult = ReturnType<typeof useCountInvoicesLazyQuery>;
export type CountInvoicesSuspenseQueryHookResult = ReturnType<typeof useCountInvoicesSuspenseQuery>;
export type CountInvoicesQueryResult = Apollo.QueryResult<CountInvoicesQuery, CountInvoicesQueryVariables>;
export const GetAppointmentInvoiceTotalsDocument = gql`
    query getAppointmentInvoiceTotals($appointmentIds: [ID!]!) {
  getAppointmentInvoiceTotals(appointmentIds: $appointmentIds) {
    appointment
    total
    total_paid
    invoice_count
  }
}
    `;

/**
 * __useGetAppointmentInvoiceTotalsQuery__
 *
 * To run a query within a React component, call `useGetAppointmentInvoiceTotalsQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetAppointmentInvoiceTotalsQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetAppointmentInvoiceTotalsQuery({
 *   variables: {
 *      appointmentIds: // value for 'appointmentIds'
 *   },
 * });
 */
export function useGetAppointmentInvoiceTotalsQuery(baseOptions: Apollo.QueryHookOptions<GetAppointmentInvoiceTotalsQuery, GetAppointmentInvoiceTotalsQueryVariables> & ({ variables: GetAppointmentInvoiceTotalsQueryVariables; skip?: boolean; } | { skip: boolean; }) ) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<GetAppointmentInvoiceTotalsQuery, GetAppointmentInvoiceTotalsQueryVariables>(GetAppointmentInvoiceTotalsDocument, options);
      }
export function useGetAppointmentInvoiceTotalsLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<GetAppointmentInvoiceTotalsQuery, GetAppointmentInvoiceTotalsQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<GetAppointmentInvoiceTotalsQuery, GetAppointmentInvoiceTotalsQueryVariables>(GetAppointmentInvoiceTotalsDocument, options);
        }
export function useGetAppointmentInvoiceTotalsSuspenseQuery(baseOptions?: Apollo.SuspenseQueryHookOptions<GetAppointmentInvoiceTotalsQuery, GetAppointmentInvoiceTotalsQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useSuspenseQuery<GetAppointmentInvoiceTotalsQuery, GetAppointmentInvoiceTotalsQueryVariables>(GetAppointmentInvoiceTotalsDocument, options);
        }
export type GetAppointmentInvoiceTotalsQueryHookResult = ReturnType<typeof useGetAppointmentInvoiceTotalsQuery>;
export type GetAppointmentInvoiceTotalsLazyQueryHookResult = ReturnType<typeof useGetAppointmentInvoiceTotalsLazyQuery>;
export type GetAppointmentInvoiceTotalsSuspenseQueryHookResult = ReturnType<typeof useGetAppointmentInvoiceTotalsSuspenseQuery>;
export type GetAppointmentInvoiceTotalsQueryResult = Apollo.QueryResult<GetAppointmentInvoiceTotalsQuery, GetAppointmentInvoiceTotalsQueryVariables>;
export const GetInvoiceDocument = gql`
    query getInvoice($id: ID!) {
  invoice(id: $id) {
    ...DetailedInvoiceFields
  }
}
    ${DetailedInvoiceFieldsFragmentDoc}`;

/**
 * __useGetInvoiceQuery__
 *
 * To run a query within a React component, call `useGetInvoiceQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetInvoiceQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetInvoiceQuery({
 *   variables: {
 *      id: // value for 'id'
 *   },
 * });
 */
export function useGetInvoiceQuery(baseOptions: Apollo.QueryHookOptions<GetInvoiceQuery, GetInvoiceQueryVariables> & ({ variables: GetInvoiceQueryVariables; skip?: boolean; } | { skip: boolean; }) ) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<GetInvoiceQuery, GetInvoiceQueryVariables>(GetInvoiceDocument, options);
      }
export function useGetInvoiceLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<GetInvoiceQuery, GetInvoiceQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<GetInvoiceQuery, GetInvoiceQueryVariables>(GetInvoiceDocument, options);
        }
export function useGetInvoiceSuspenseQuery(baseOptions?: Apollo.SuspenseQueryHookOptions<GetInvoiceQuery, GetInvoiceQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useSuspenseQuery<GetInvoiceQuery, GetInvoiceQueryVariables>(GetInvoiceDocument, options);
        }
export type GetInvoiceQueryHookResult = ReturnType<typeof useGetInvoiceQuery>;
export type GetInvoiceLazyQueryHookResult = ReturnType<typeof useGetInvoiceLazyQuery>;
export type GetInvoiceSuspenseQueryHookResult = ReturnType<typeof useGetInvoiceSuspenseQuery>;
export type GetInvoiceQueryResult = Apollo.QueryResult<GetInvoiceQuery, GetInvoiceQueryVariables>;
export const GetLoyaltyRewardsForClinicDocument = gql`
    query getLoyaltyRewardsForClinic($clinicId: ID!, $showInactive: Boolean) {
  getLoyaltyRewardsForClinic(clinicId: $clinicId, showInactive: $showInactive) {
    ...LoyaltyRewardFields
  }
}
    ${LoyaltyRewardFieldsFragmentDoc}`;

/**
 * __useGetLoyaltyRewardsForClinicQuery__
 *
 * To run a query within a React component, call `useGetLoyaltyRewardsForClinicQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetLoyaltyRewardsForClinicQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetLoyaltyRewardsForClinicQuery({
 *   variables: {
 *      clinicId: // value for 'clinicId'
 *      showInactive: // value for 'showInactive'
 *   },
 * });
 */
export function useGetLoyaltyRewardsForClinicQuery(baseOptions: Apollo.QueryHookOptions<GetLoyaltyRewardsForClinicQuery, GetLoyaltyRewardsForClinicQueryVariables> & ({ variables: GetLoyaltyRewardsForClinicQueryVariables; skip?: boolean; } | { skip: boolean; }) ) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<GetLoyaltyRewardsForClinicQuery, GetLoyaltyRewardsForClinicQueryVariables>(GetLoyaltyRewardsForClinicDocument, options);
      }
export function useGetLoyaltyRewardsForClinicLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<GetLoyaltyRewardsForClinicQuery, GetLoyaltyRewardsForClinicQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<GetLoyaltyRewardsForClinicQuery, GetLoyaltyRewardsForClinicQueryVariables>(GetLoyaltyRewardsForClinicDocument, options);
        }
export function useGetLoyaltyRewardsForClinicSuspenseQuery(baseOptions?: Apollo.SuspenseQueryHookOptions<GetLoyaltyRewardsForClinicQuery, GetLoyaltyRewardsForClinicQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useSuspenseQuery<GetLoyaltyRewardsForClinicQuery, GetLoyaltyRewardsForClinicQueryVariables>(GetLoyaltyRewardsForClinicDocument, options);
        }
export type GetLoyaltyRewardsForClinicQueryHookResult = ReturnType<typeof useGetLoyaltyRewardsForClinicQuery>;
export type GetLoyaltyRewardsForClinicLazyQueryHookResult = ReturnType<typeof useGetLoyaltyRewardsForClinicLazyQuery>;
export type GetLoyaltyRewardsForClinicSuspenseQueryHookResult = ReturnType<typeof useGetLoyaltyRewardsForClinicSuspenseQuery>;
export type GetLoyaltyRewardsForClinicQueryResult = Apollo.QueryResult<GetLoyaltyRewardsForClinicQuery, GetLoyaltyRewardsForClinicQueryVariables>;
export const GetLoyaltyMemberFromClientDocument = gql`
    query getLoyaltyMemberFromClient($clientId: ID!) {
  client(id: $clientId) {
    loyalty_members {
      id
      available_points
      all_time_points
    }
  }
}
    `;

/**
 * __useGetLoyaltyMemberFromClientQuery__
 *
 * To run a query within a React component, call `useGetLoyaltyMemberFromClientQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetLoyaltyMemberFromClientQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetLoyaltyMemberFromClientQuery({
 *   variables: {
 *      clientId: // value for 'clientId'
 *   },
 * });
 */
export function useGetLoyaltyMemberFromClientQuery(baseOptions: Apollo.QueryHookOptions<GetLoyaltyMemberFromClientQuery, GetLoyaltyMemberFromClientQueryVariables> & ({ variables: GetLoyaltyMemberFromClientQueryVariables; skip?: boolean; } | { skip: boolean; }) ) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<GetLoyaltyMemberFromClientQuery, GetLoyaltyMemberFromClientQueryVariables>(GetLoyaltyMemberFromClientDocument, options);
      }
export function useGetLoyaltyMemberFromClientLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<GetLoyaltyMemberFromClientQuery, GetLoyaltyMemberFromClientQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<GetLoyaltyMemberFromClientQuery, GetLoyaltyMemberFromClientQueryVariables>(GetLoyaltyMemberFromClientDocument, options);
        }
export function useGetLoyaltyMemberFromClientSuspenseQuery(baseOptions?: Apollo.SuspenseQueryHookOptions<GetLoyaltyMemberFromClientQuery, GetLoyaltyMemberFromClientQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useSuspenseQuery<GetLoyaltyMemberFromClientQuery, GetLoyaltyMemberFromClientQueryVariables>(GetLoyaltyMemberFromClientDocument, options);
        }
export type GetLoyaltyMemberFromClientQueryHookResult = ReturnType<typeof useGetLoyaltyMemberFromClientQuery>;
export type GetLoyaltyMemberFromClientLazyQueryHookResult = ReturnType<typeof useGetLoyaltyMemberFromClientLazyQuery>;
export type GetLoyaltyMemberFromClientSuspenseQueryHookResult = ReturnType<typeof useGetLoyaltyMemberFromClientSuspenseQuery>;
export type GetLoyaltyMemberFromClientQueryResult = Apollo.QueryResult<GetLoyaltyMemberFromClientQuery, GetLoyaltyMemberFromClientQueryVariables>;
export const GetLoyaltyMemberDocument = gql`
    query getLoyaltyMember($id: ID!) {
  loyaltyMember(id: $id) {
    ...LoyaltyMemberFields
  }
}
    ${LoyaltyMemberFieldsFragmentDoc}`;

/**
 * __useGetLoyaltyMemberQuery__
 *
 * To run a query within a React component, call `useGetLoyaltyMemberQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetLoyaltyMemberQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetLoyaltyMemberQuery({
 *   variables: {
 *      id: // value for 'id'
 *   },
 * });
 */
export function useGetLoyaltyMemberQuery(baseOptions: Apollo.QueryHookOptions<GetLoyaltyMemberQuery, GetLoyaltyMemberQueryVariables> & ({ variables: GetLoyaltyMemberQueryVariables; skip?: boolean; } | { skip: boolean; }) ) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<GetLoyaltyMemberQuery, GetLoyaltyMemberQueryVariables>(GetLoyaltyMemberDocument, options);
      }
export function useGetLoyaltyMemberLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<GetLoyaltyMemberQuery, GetLoyaltyMemberQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<GetLoyaltyMemberQuery, GetLoyaltyMemberQueryVariables>(GetLoyaltyMemberDocument, options);
        }
export function useGetLoyaltyMemberSuspenseQuery(baseOptions?: Apollo.SuspenseQueryHookOptions<GetLoyaltyMemberQuery, GetLoyaltyMemberQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useSuspenseQuery<GetLoyaltyMemberQuery, GetLoyaltyMemberQueryVariables>(GetLoyaltyMemberDocument, options);
        }
export type GetLoyaltyMemberQueryHookResult = ReturnType<typeof useGetLoyaltyMemberQuery>;
export type GetLoyaltyMemberLazyQueryHookResult = ReturnType<typeof useGetLoyaltyMemberLazyQuery>;
export type GetLoyaltyMemberSuspenseQueryHookResult = ReturnType<typeof useGetLoyaltyMemberSuspenseQuery>;
export type GetLoyaltyMemberQueryResult = Apollo.QueryResult<GetLoyaltyMemberQuery, GetLoyaltyMemberQueryVariables>;
export const GetLoyaltyRewardDocument = gql`
    query getLoyaltyReward($id: ID!) {
  loyaltyReward(id: $id) {
    ...LoyaltyRewardFields
  }
}
    ${LoyaltyRewardFieldsFragmentDoc}`;

/**
 * __useGetLoyaltyRewardQuery__
 *
 * To run a query within a React component, call `useGetLoyaltyRewardQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetLoyaltyRewardQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetLoyaltyRewardQuery({
 *   variables: {
 *      id: // value for 'id'
 *   },
 * });
 */
export function useGetLoyaltyRewardQuery(baseOptions: Apollo.QueryHookOptions<GetLoyaltyRewardQuery, GetLoyaltyRewardQueryVariables> & ({ variables: GetLoyaltyRewardQueryVariables; skip?: boolean; } | { skip: boolean; }) ) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<GetLoyaltyRewardQuery, GetLoyaltyRewardQueryVariables>(GetLoyaltyRewardDocument, options);
      }
export function useGetLoyaltyRewardLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<GetLoyaltyRewardQuery, GetLoyaltyRewardQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<GetLoyaltyRewardQuery, GetLoyaltyRewardQueryVariables>(GetLoyaltyRewardDocument, options);
        }
export function useGetLoyaltyRewardSuspenseQuery(baseOptions?: Apollo.SuspenseQueryHookOptions<GetLoyaltyRewardQuery, GetLoyaltyRewardQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useSuspenseQuery<GetLoyaltyRewardQuery, GetLoyaltyRewardQueryVariables>(GetLoyaltyRewardDocument, options);
        }
export type GetLoyaltyRewardQueryHookResult = ReturnType<typeof useGetLoyaltyRewardQuery>;
export type GetLoyaltyRewardLazyQueryHookResult = ReturnType<typeof useGetLoyaltyRewardLazyQuery>;
export type GetLoyaltyRewardSuspenseQueryHookResult = ReturnType<typeof useGetLoyaltyRewardSuspenseQuery>;
export type GetLoyaltyRewardQueryResult = Apollo.QueryResult<GetLoyaltyRewardQuery, GetLoyaltyRewardQueryVariables>;
export const CreateLoyaltyRewardDocument = gql`
    mutation createLoyaltyReward($data: CreateLoyaltyRewardInput!) {
  createLoyaltyReward(data: $data) {
    ...LoyaltyRewardFields
  }
}
    ${LoyaltyRewardFieldsFragmentDoc}`;
export type CreateLoyaltyRewardMutationFn = Apollo.MutationFunction<CreateLoyaltyRewardMutation, CreateLoyaltyRewardMutationVariables>;

/**
 * __useCreateLoyaltyRewardMutation__
 *
 * To run a mutation, you first call `useCreateLoyaltyRewardMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useCreateLoyaltyRewardMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [createLoyaltyRewardMutation, { data, loading, error }] = useCreateLoyaltyRewardMutation({
 *   variables: {
 *      data: // value for 'data'
 *   },
 * });
 */
export function useCreateLoyaltyRewardMutation(baseOptions?: Apollo.MutationHookOptions<CreateLoyaltyRewardMutation, CreateLoyaltyRewardMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<CreateLoyaltyRewardMutation, CreateLoyaltyRewardMutationVariables>(CreateLoyaltyRewardDocument, options);
      }
export type CreateLoyaltyRewardMutationHookResult = ReturnType<typeof useCreateLoyaltyRewardMutation>;
export type CreateLoyaltyRewardMutationResult = Apollo.MutationResult<CreateLoyaltyRewardMutation>;
export type CreateLoyaltyRewardMutationOptions = Apollo.BaseMutationOptions<CreateLoyaltyRewardMutation, CreateLoyaltyRewardMutationVariables>;
export const UpdateLoyaltyRewardDocument = gql`
    mutation updateLoyaltyReward($id: ID!, $data: UpdateLoyaltyRewardInput!) {
  updateLoyaltyReward(id: $id, data: $data) {
    ...LoyaltyRewardFields
  }
}
    ${LoyaltyRewardFieldsFragmentDoc}`;
export type UpdateLoyaltyRewardMutationFn = Apollo.MutationFunction<UpdateLoyaltyRewardMutation, UpdateLoyaltyRewardMutationVariables>;

/**
 * __useUpdateLoyaltyRewardMutation__
 *
 * To run a mutation, you first call `useUpdateLoyaltyRewardMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useUpdateLoyaltyRewardMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [updateLoyaltyRewardMutation, { data, loading, error }] = useUpdateLoyaltyRewardMutation({
 *   variables: {
 *      id: // value for 'id'
 *      data: // value for 'data'
 *   },
 * });
 */
export function useUpdateLoyaltyRewardMutation(baseOptions?: Apollo.MutationHookOptions<UpdateLoyaltyRewardMutation, UpdateLoyaltyRewardMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<UpdateLoyaltyRewardMutation, UpdateLoyaltyRewardMutationVariables>(UpdateLoyaltyRewardDocument, options);
      }
export type UpdateLoyaltyRewardMutationHookResult = ReturnType<typeof useUpdateLoyaltyRewardMutation>;
export type UpdateLoyaltyRewardMutationResult = Apollo.MutationResult<UpdateLoyaltyRewardMutation>;
export type UpdateLoyaltyRewardMutationOptions = Apollo.BaseMutationOptions<UpdateLoyaltyRewardMutation, UpdateLoyaltyRewardMutationVariables>;
export const DeleteLoyaltyRewardDocument = gql`
    mutation deleteLoyaltyReward($id: ID!) {
  deleteLoyaltyReward(id: $id)
}
    `;
export type DeleteLoyaltyRewardMutationFn = Apollo.MutationFunction<DeleteLoyaltyRewardMutation, DeleteLoyaltyRewardMutationVariables>;

/**
 * __useDeleteLoyaltyRewardMutation__
 *
 * To run a mutation, you first call `useDeleteLoyaltyRewardMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useDeleteLoyaltyRewardMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [deleteLoyaltyRewardMutation, { data, loading, error }] = useDeleteLoyaltyRewardMutation({
 *   variables: {
 *      id: // value for 'id'
 *   },
 * });
 */
export function useDeleteLoyaltyRewardMutation(baseOptions?: Apollo.MutationHookOptions<DeleteLoyaltyRewardMutation, DeleteLoyaltyRewardMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<DeleteLoyaltyRewardMutation, DeleteLoyaltyRewardMutationVariables>(DeleteLoyaltyRewardDocument, options);
      }
export type DeleteLoyaltyRewardMutationHookResult = ReturnType<typeof useDeleteLoyaltyRewardMutation>;
export type DeleteLoyaltyRewardMutationResult = Apollo.MutationResult<DeleteLoyaltyRewardMutation>;
export type DeleteLoyaltyRewardMutationOptions = Apollo.BaseMutationOptions<DeleteLoyaltyRewardMutation, DeleteLoyaltyRewardMutationVariables>;
export const CreateLoyaltyMemberDocument = gql`
    mutation createLoyaltyMember($data: CreateLoyaltyMemberInput!) {
  createLoyaltyMember(data: $data) {
    ...LoyaltyMemberFields
  }
}
    ${LoyaltyMemberFieldsFragmentDoc}`;
export type CreateLoyaltyMemberMutationFn = Apollo.MutationFunction<CreateLoyaltyMemberMutation, CreateLoyaltyMemberMutationVariables>;

/**
 * __useCreateLoyaltyMemberMutation__
 *
 * To run a mutation, you first call `useCreateLoyaltyMemberMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useCreateLoyaltyMemberMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [createLoyaltyMemberMutation, { data, loading, error }] = useCreateLoyaltyMemberMutation({
 *   variables: {
 *      data: // value for 'data'
 *   },
 * });
 */
export function useCreateLoyaltyMemberMutation(baseOptions?: Apollo.MutationHookOptions<CreateLoyaltyMemberMutation, CreateLoyaltyMemberMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<CreateLoyaltyMemberMutation, CreateLoyaltyMemberMutationVariables>(CreateLoyaltyMemberDocument, options);
      }
export type CreateLoyaltyMemberMutationHookResult = ReturnType<typeof useCreateLoyaltyMemberMutation>;
export type CreateLoyaltyMemberMutationResult = Apollo.MutationResult<CreateLoyaltyMemberMutation>;
export type CreateLoyaltyMemberMutationOptions = Apollo.BaseMutationOptions<CreateLoyaltyMemberMutation, CreateLoyaltyMemberMutationVariables>;
export const UpdateLoyaltyMemberDocument = gql`
    mutation updateLoyaltyMember($id: ID!, $data: UpdateLoyaltyMemberInput!) {
  updateLoyaltyMember(id: $id, data: $data) {
    ...LoyaltyMemberFields
  }
}
    ${LoyaltyMemberFieldsFragmentDoc}`;
export type UpdateLoyaltyMemberMutationFn = Apollo.MutationFunction<UpdateLoyaltyMemberMutation, UpdateLoyaltyMemberMutationVariables>;

/**
 * __useUpdateLoyaltyMemberMutation__
 *
 * To run a mutation, you first call `useUpdateLoyaltyMemberMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useUpdateLoyaltyMemberMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [updateLoyaltyMemberMutation, { data, loading, error }] = useUpdateLoyaltyMemberMutation({
 *   variables: {
 *      id: // value for 'id'
 *      data: // value for 'data'
 *   },
 * });
 */
export function useUpdateLoyaltyMemberMutation(baseOptions?: Apollo.MutationHookOptions<UpdateLoyaltyMemberMutation, UpdateLoyaltyMemberMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<UpdateLoyaltyMemberMutation, UpdateLoyaltyMemberMutationVariables>(UpdateLoyaltyMemberDocument, options);
      }
export type UpdateLoyaltyMemberMutationHookResult = ReturnType<typeof useUpdateLoyaltyMemberMutation>;
export type UpdateLoyaltyMemberMutationResult = Apollo.MutationResult<UpdateLoyaltyMemberMutation>;
export type UpdateLoyaltyMemberMutationOptions = Apollo.BaseMutationOptions<UpdateLoyaltyMemberMutation, UpdateLoyaltyMemberMutationVariables>;
export const AddPointsToLoyaltyMemberDocument = gql`
    mutation addPointsToLoyaltyMember($id: ID!, $points: NonNegativeInt!) {
  addPointsToLoyaltyMember(id: $id, points: $points) {
    ...LoyaltyMemberFields
  }
}
    ${LoyaltyMemberFieldsFragmentDoc}`;
export type AddPointsToLoyaltyMemberMutationFn = Apollo.MutationFunction<AddPointsToLoyaltyMemberMutation, AddPointsToLoyaltyMemberMutationVariables>;

/**
 * __useAddPointsToLoyaltyMemberMutation__
 *
 * To run a mutation, you first call `useAddPointsToLoyaltyMemberMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useAddPointsToLoyaltyMemberMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [addPointsToLoyaltyMemberMutation, { data, loading, error }] = useAddPointsToLoyaltyMemberMutation({
 *   variables: {
 *      id: // value for 'id'
 *      points: // value for 'points'
 *   },
 * });
 */
export function useAddPointsToLoyaltyMemberMutation(baseOptions?: Apollo.MutationHookOptions<AddPointsToLoyaltyMemberMutation, AddPointsToLoyaltyMemberMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<AddPointsToLoyaltyMemberMutation, AddPointsToLoyaltyMemberMutationVariables>(AddPointsToLoyaltyMemberDocument, options);
      }
export type AddPointsToLoyaltyMemberMutationHookResult = ReturnType<typeof useAddPointsToLoyaltyMemberMutation>;
export type AddPointsToLoyaltyMemberMutationResult = Apollo.MutationResult<AddPointsToLoyaltyMemberMutation>;
export type AddPointsToLoyaltyMemberMutationOptions = Apollo.BaseMutationOptions<AddPointsToLoyaltyMemberMutation, AddPointsToLoyaltyMemberMutationVariables>;
export const QueryLoyaltyRedemptionsDocument = gql`
    query queryLoyaltyRedemptions($where: [QueryInput!], $page: NonNegativeInt, $pageSize: NonNegativeInt, $orderBy: OrderByInput) {
  queryLoyaltyRedemptions(
    where: $where
    page: $page
    pageSize: $pageSize
    orderBy: $orderBy
  ) {
    ...LoyaltyRedemptionFields
  }
}
    ${LoyaltyRedemptionFieldsFragmentDoc}`;

/**
 * __useQueryLoyaltyRedemptionsQuery__
 *
 * To run a query within a React component, call `useQueryLoyaltyRedemptionsQuery` and pass it any options that fit your needs.
 * When your component renders, `useQueryLoyaltyRedemptionsQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useQueryLoyaltyRedemptionsQuery({
 *   variables: {
 *      where: // value for 'where'
 *      page: // value for 'page'
 *      pageSize: // value for 'pageSize'
 *      orderBy: // value for 'orderBy'
 *   },
 * });
 */
export function useQueryLoyaltyRedemptionsQuery(baseOptions?: Apollo.QueryHookOptions<QueryLoyaltyRedemptionsQuery, QueryLoyaltyRedemptionsQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<QueryLoyaltyRedemptionsQuery, QueryLoyaltyRedemptionsQueryVariables>(QueryLoyaltyRedemptionsDocument, options);
      }
export function useQueryLoyaltyRedemptionsLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<QueryLoyaltyRedemptionsQuery, QueryLoyaltyRedemptionsQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<QueryLoyaltyRedemptionsQuery, QueryLoyaltyRedemptionsQueryVariables>(QueryLoyaltyRedemptionsDocument, options);
        }
export function useQueryLoyaltyRedemptionsSuspenseQuery(baseOptions?: Apollo.SuspenseQueryHookOptions<QueryLoyaltyRedemptionsQuery, QueryLoyaltyRedemptionsQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useSuspenseQuery<QueryLoyaltyRedemptionsQuery, QueryLoyaltyRedemptionsQueryVariables>(QueryLoyaltyRedemptionsDocument, options);
        }
export type QueryLoyaltyRedemptionsQueryHookResult = ReturnType<typeof useQueryLoyaltyRedemptionsQuery>;
export type QueryLoyaltyRedemptionsLazyQueryHookResult = ReturnType<typeof useQueryLoyaltyRedemptionsLazyQuery>;
export type QueryLoyaltyRedemptionsSuspenseQueryHookResult = ReturnType<typeof useQueryLoyaltyRedemptionsSuspenseQuery>;
export type QueryLoyaltyRedemptionsQueryResult = Apollo.QueryResult<QueryLoyaltyRedemptionsQuery, QueryLoyaltyRedemptionsQueryVariables>;
export const CountLoyaltyRedemptionsDocument = gql`
    query countLoyaltyRedemptions($where: [QueryInput!]) {
  countLoyaltyRedemptions(where: $where)
}
    `;

/**
 * __useCountLoyaltyRedemptionsQuery__
 *
 * To run a query within a React component, call `useCountLoyaltyRedemptionsQuery` and pass it any options that fit your needs.
 * When your component renders, `useCountLoyaltyRedemptionsQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useCountLoyaltyRedemptionsQuery({
 *   variables: {
 *      where: // value for 'where'
 *   },
 * });
 */
export function useCountLoyaltyRedemptionsQuery(baseOptions?: Apollo.QueryHookOptions<CountLoyaltyRedemptionsQuery, CountLoyaltyRedemptionsQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<CountLoyaltyRedemptionsQuery, CountLoyaltyRedemptionsQueryVariables>(CountLoyaltyRedemptionsDocument, options);
      }
export function useCountLoyaltyRedemptionsLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<CountLoyaltyRedemptionsQuery, CountLoyaltyRedemptionsQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<CountLoyaltyRedemptionsQuery, CountLoyaltyRedemptionsQueryVariables>(CountLoyaltyRedemptionsDocument, options);
        }
export function useCountLoyaltyRedemptionsSuspenseQuery(baseOptions?: Apollo.SuspenseQueryHookOptions<CountLoyaltyRedemptionsQuery, CountLoyaltyRedemptionsQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useSuspenseQuery<CountLoyaltyRedemptionsQuery, CountLoyaltyRedemptionsQueryVariables>(CountLoyaltyRedemptionsDocument, options);
        }
export type CountLoyaltyRedemptionsQueryHookResult = ReturnType<typeof useCountLoyaltyRedemptionsQuery>;
export type CountLoyaltyRedemptionsLazyQueryHookResult = ReturnType<typeof useCountLoyaltyRedemptionsLazyQuery>;
export type CountLoyaltyRedemptionsSuspenseQueryHookResult = ReturnType<typeof useCountLoyaltyRedemptionsSuspenseQuery>;
export type CountLoyaltyRedemptionsQueryResult = Apollo.QueryResult<CountLoyaltyRedemptionsQuery, CountLoyaltyRedemptionsQueryVariables>;
export const CreateLoyaltyRedemptionDocument = gql`
    mutation createLoyaltyRedemption($data: CreateLoyaltyRedemptionInput!) {
  createLoyaltyRedemption(data: $data) {
    ...LoyaltyRedemptionFields
  }
}
    ${LoyaltyRedemptionFieldsFragmentDoc}`;
export type CreateLoyaltyRedemptionMutationFn = Apollo.MutationFunction<CreateLoyaltyRedemptionMutation, CreateLoyaltyRedemptionMutationVariables>;

/**
 * __useCreateLoyaltyRedemptionMutation__
 *
 * To run a mutation, you first call `useCreateLoyaltyRedemptionMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useCreateLoyaltyRedemptionMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [createLoyaltyRedemptionMutation, { data, loading, error }] = useCreateLoyaltyRedemptionMutation({
 *   variables: {
 *      data: // value for 'data'
 *   },
 * });
 */
export function useCreateLoyaltyRedemptionMutation(baseOptions?: Apollo.MutationHookOptions<CreateLoyaltyRedemptionMutation, CreateLoyaltyRedemptionMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<CreateLoyaltyRedemptionMutation, CreateLoyaltyRedemptionMutationVariables>(CreateLoyaltyRedemptionDocument, options);
      }
export type CreateLoyaltyRedemptionMutationHookResult = ReturnType<typeof useCreateLoyaltyRedemptionMutation>;
export type CreateLoyaltyRedemptionMutationResult = Apollo.MutationResult<CreateLoyaltyRedemptionMutation>;
export type CreateLoyaltyRedemptionMutationOptions = Apollo.BaseMutationOptions<CreateLoyaltyRedemptionMutation, CreateLoyaltyRedemptionMutationVariables>;
export const ApproveRedemptionRequestDocument = gql`
    mutation approveRedemptionRequest($id: ID!) {
  approveRedemptionRequest(id: $id) {
    ...LoyaltyRedemptionFields
  }
}
    ${LoyaltyRedemptionFieldsFragmentDoc}`;
export type ApproveRedemptionRequestMutationFn = Apollo.MutationFunction<ApproveRedemptionRequestMutation, ApproveRedemptionRequestMutationVariables>;

/**
 * __useApproveRedemptionRequestMutation__
 *
 * To run a mutation, you first call `useApproveRedemptionRequestMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useApproveRedemptionRequestMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [approveRedemptionRequestMutation, { data, loading, error }] = useApproveRedemptionRequestMutation({
 *   variables: {
 *      id: // value for 'id'
 *   },
 * });
 */
export function useApproveRedemptionRequestMutation(baseOptions?: Apollo.MutationHookOptions<ApproveRedemptionRequestMutation, ApproveRedemptionRequestMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<ApproveRedemptionRequestMutation, ApproveRedemptionRequestMutationVariables>(ApproveRedemptionRequestDocument, options);
      }
export type ApproveRedemptionRequestMutationHookResult = ReturnType<typeof useApproveRedemptionRequestMutation>;
export type ApproveRedemptionRequestMutationResult = Apollo.MutationResult<ApproveRedemptionRequestMutation>;
export type ApproveRedemptionRequestMutationOptions = Apollo.BaseMutationOptions<ApproveRedemptionRequestMutation, ApproveRedemptionRequestMutationVariables>;
export const CancelRedemptionRequestDocument = gql`
    mutation cancelRedemptionRequest($id: ID!) {
  cancelRedemptionRequest(id: $id) {
    ...LoyaltyRedemptionFields
  }
}
    ${LoyaltyRedemptionFieldsFragmentDoc}`;
export type CancelRedemptionRequestMutationFn = Apollo.MutationFunction<CancelRedemptionRequestMutation, CancelRedemptionRequestMutationVariables>;

/**
 * __useCancelRedemptionRequestMutation__
 *
 * To run a mutation, you first call `useCancelRedemptionRequestMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useCancelRedemptionRequestMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [cancelRedemptionRequestMutation, { data, loading, error }] = useCancelRedemptionRequestMutation({
 *   variables: {
 *      id: // value for 'id'
 *   },
 * });
 */
export function useCancelRedemptionRequestMutation(baseOptions?: Apollo.MutationHookOptions<CancelRedemptionRequestMutation, CancelRedemptionRequestMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<CancelRedemptionRequestMutation, CancelRedemptionRequestMutationVariables>(CancelRedemptionRequestDocument, options);
      }
export type CancelRedemptionRequestMutationHookResult = ReturnType<typeof useCancelRedemptionRequestMutation>;
export type CancelRedemptionRequestMutationResult = Apollo.MutationResult<CancelRedemptionRequestMutation>;
export type CancelRedemptionRequestMutationOptions = Apollo.BaseMutationOptions<CancelRedemptionRequestMutation, CancelRedemptionRequestMutationVariables>;
export const QueryLoyaltyEarningsDocument = gql`
    query queryLoyaltyEarnings($where: [QueryInput!], $page: NonNegativeInt, $pageSize: NonNegativeInt, $orderBy: OrderByInput) {
  queryLoyaltyEarnings(
    where: $where
    page: $page
    pageSize: $pageSize
    orderBy: $orderBy
  ) {
    ...LoyaltyEarningFields
  }
}
    ${LoyaltyEarningFieldsFragmentDoc}`;

/**
 * __useQueryLoyaltyEarningsQuery__
 *
 * To run a query within a React component, call `useQueryLoyaltyEarningsQuery` and pass it any options that fit your needs.
 * When your component renders, `useQueryLoyaltyEarningsQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useQueryLoyaltyEarningsQuery({
 *   variables: {
 *      where: // value for 'where'
 *      page: // value for 'page'
 *      pageSize: // value for 'pageSize'
 *      orderBy: // value for 'orderBy'
 *   },
 * });
 */
export function useQueryLoyaltyEarningsQuery(baseOptions?: Apollo.QueryHookOptions<QueryLoyaltyEarningsQuery, QueryLoyaltyEarningsQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<QueryLoyaltyEarningsQuery, QueryLoyaltyEarningsQueryVariables>(QueryLoyaltyEarningsDocument, options);
      }
export function useQueryLoyaltyEarningsLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<QueryLoyaltyEarningsQuery, QueryLoyaltyEarningsQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<QueryLoyaltyEarningsQuery, QueryLoyaltyEarningsQueryVariables>(QueryLoyaltyEarningsDocument, options);
        }
export function useQueryLoyaltyEarningsSuspenseQuery(baseOptions?: Apollo.SuspenseQueryHookOptions<QueryLoyaltyEarningsQuery, QueryLoyaltyEarningsQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useSuspenseQuery<QueryLoyaltyEarningsQuery, QueryLoyaltyEarningsQueryVariables>(QueryLoyaltyEarningsDocument, options);
        }
export type QueryLoyaltyEarningsQueryHookResult = ReturnType<typeof useQueryLoyaltyEarningsQuery>;
export type QueryLoyaltyEarningsLazyQueryHookResult = ReturnType<typeof useQueryLoyaltyEarningsLazyQuery>;
export type QueryLoyaltyEarningsSuspenseQueryHookResult = ReturnType<typeof useQueryLoyaltyEarningsSuspenseQuery>;
export type QueryLoyaltyEarningsQueryResult = Apollo.QueryResult<QueryLoyaltyEarningsQuery, QueryLoyaltyEarningsQueryVariables>;
export const CountLoyaltyEarningsDocument = gql`
    query countLoyaltyEarnings($where: [QueryInput!]) {
  countLoyaltyEarnings(where: $where)
}
    `;

/**
 * __useCountLoyaltyEarningsQuery__
 *
 * To run a query within a React component, call `useCountLoyaltyEarningsQuery` and pass it any options that fit your needs.
 * When your component renders, `useCountLoyaltyEarningsQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useCountLoyaltyEarningsQuery({
 *   variables: {
 *      where: // value for 'where'
 *   },
 * });
 */
export function useCountLoyaltyEarningsQuery(baseOptions?: Apollo.QueryHookOptions<CountLoyaltyEarningsQuery, CountLoyaltyEarningsQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<CountLoyaltyEarningsQuery, CountLoyaltyEarningsQueryVariables>(CountLoyaltyEarningsDocument, options);
      }
export function useCountLoyaltyEarningsLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<CountLoyaltyEarningsQuery, CountLoyaltyEarningsQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<CountLoyaltyEarningsQuery, CountLoyaltyEarningsQueryVariables>(CountLoyaltyEarningsDocument, options);
        }
export function useCountLoyaltyEarningsSuspenseQuery(baseOptions?: Apollo.SuspenseQueryHookOptions<CountLoyaltyEarningsQuery, CountLoyaltyEarningsQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useSuspenseQuery<CountLoyaltyEarningsQuery, CountLoyaltyEarningsQueryVariables>(CountLoyaltyEarningsDocument, options);
        }
export type CountLoyaltyEarningsQueryHookResult = ReturnType<typeof useCountLoyaltyEarningsQuery>;
export type CountLoyaltyEarningsLazyQueryHookResult = ReturnType<typeof useCountLoyaltyEarningsLazyQuery>;
export type CountLoyaltyEarningsSuspenseQueryHookResult = ReturnType<typeof useCountLoyaltyEarningsSuspenseQuery>;
export type CountLoyaltyEarningsQueryResult = Apollo.QueryResult<CountLoyaltyEarningsQuery, CountLoyaltyEarningsQueryVariables>;
export const GetMarketingSummaryStatsDocument = gql`
    query getMarketingSummaryStats($filters: MarketingFiltersInput!) {
  marketingSummaryStats(filters: $filters) {
    ...MarketingSummaryStatsFields
  }
}
    ${MarketingSummaryStatsFieldsFragmentDoc}`;

/**
 * __useGetMarketingSummaryStatsQuery__
 *
 * To run a query within a React component, call `useGetMarketingSummaryStatsQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetMarketingSummaryStatsQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetMarketingSummaryStatsQuery({
 *   variables: {
 *      filters: // value for 'filters'
 *   },
 * });
 */
export function useGetMarketingSummaryStatsQuery(baseOptions: Apollo.QueryHookOptions<GetMarketingSummaryStatsQuery, GetMarketingSummaryStatsQueryVariables> & ({ variables: GetMarketingSummaryStatsQueryVariables; skip?: boolean; } | { skip: boolean; }) ) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<GetMarketingSummaryStatsQuery, GetMarketingSummaryStatsQueryVariables>(GetMarketingSummaryStatsDocument, options);
      }
export function useGetMarketingSummaryStatsLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<GetMarketingSummaryStatsQuery, GetMarketingSummaryStatsQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<GetMarketingSummaryStatsQuery, GetMarketingSummaryStatsQueryVariables>(GetMarketingSummaryStatsDocument, options);
        }
export function useGetMarketingSummaryStatsSuspenseQuery(baseOptions?: Apollo.SuspenseQueryHookOptions<GetMarketingSummaryStatsQuery, GetMarketingSummaryStatsQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useSuspenseQuery<GetMarketingSummaryStatsQuery, GetMarketingSummaryStatsQueryVariables>(GetMarketingSummaryStatsDocument, options);
        }
export type GetMarketingSummaryStatsQueryHookResult = ReturnType<typeof useGetMarketingSummaryStatsQuery>;
export type GetMarketingSummaryStatsLazyQueryHookResult = ReturnType<typeof useGetMarketingSummaryStatsLazyQuery>;
export type GetMarketingSummaryStatsSuspenseQueryHookResult = ReturnType<typeof useGetMarketingSummaryStatsSuspenseQuery>;
export type GetMarketingSummaryStatsQueryResult = Apollo.QueryResult<GetMarketingSummaryStatsQuery, GetMarketingSummaryStatsQueryVariables>;
export const GetOrganizationCampaignStatsDocument = gql`
    query getOrganizationCampaignStats($filters: MarketingFiltersInput!) {
  organizationCampaignStats(filters: $filters) {
    ...OrgCampaignStatsFields
  }
}
    ${OrgCampaignStatsFieldsFragmentDoc}`;

/**
 * __useGetOrganizationCampaignStatsQuery__
 *
 * To run a query within a React component, call `useGetOrganizationCampaignStatsQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetOrganizationCampaignStatsQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetOrganizationCampaignStatsQuery({
 *   variables: {
 *      filters: // value for 'filters'
 *   },
 * });
 */
export function useGetOrganizationCampaignStatsQuery(baseOptions: Apollo.QueryHookOptions<GetOrganizationCampaignStatsQuery, GetOrganizationCampaignStatsQueryVariables> & ({ variables: GetOrganizationCampaignStatsQueryVariables; skip?: boolean; } | { skip: boolean; }) ) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<GetOrganizationCampaignStatsQuery, GetOrganizationCampaignStatsQueryVariables>(GetOrganizationCampaignStatsDocument, options);
      }
export function useGetOrganizationCampaignStatsLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<GetOrganizationCampaignStatsQuery, GetOrganizationCampaignStatsQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<GetOrganizationCampaignStatsQuery, GetOrganizationCampaignStatsQueryVariables>(GetOrganizationCampaignStatsDocument, options);
        }
export function useGetOrganizationCampaignStatsSuspenseQuery(baseOptions?: Apollo.SuspenseQueryHookOptions<GetOrganizationCampaignStatsQuery, GetOrganizationCampaignStatsQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useSuspenseQuery<GetOrganizationCampaignStatsQuery, GetOrganizationCampaignStatsQueryVariables>(GetOrganizationCampaignStatsDocument, options);
        }
export type GetOrganizationCampaignStatsQueryHookResult = ReturnType<typeof useGetOrganizationCampaignStatsQuery>;
export type GetOrganizationCampaignStatsLazyQueryHookResult = ReturnType<typeof useGetOrganizationCampaignStatsLazyQuery>;
export type GetOrganizationCampaignStatsSuspenseQueryHookResult = ReturnType<typeof useGetOrganizationCampaignStatsSuspenseQuery>;
export type GetOrganizationCampaignStatsQueryResult = Apollo.QueryResult<GetOrganizationCampaignStatsQuery, GetOrganizationCampaignStatsQueryVariables>;
export const GetOrganizationNotificationStatsDocument = gql`
    query getOrganizationNotificationStats($filters: MarketingFiltersInput!) {
  organizationNotificationStats(filters: $filters) {
    ...OrgNotificationStatsFields
  }
}
    ${OrgNotificationStatsFieldsFragmentDoc}`;

/**
 * __useGetOrganizationNotificationStatsQuery__
 *
 * To run a query within a React component, call `useGetOrganizationNotificationStatsQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetOrganizationNotificationStatsQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetOrganizationNotificationStatsQuery({
 *   variables: {
 *      filters: // value for 'filters'
 *   },
 * });
 */
export function useGetOrganizationNotificationStatsQuery(baseOptions: Apollo.QueryHookOptions<GetOrganizationNotificationStatsQuery, GetOrganizationNotificationStatsQueryVariables> & ({ variables: GetOrganizationNotificationStatsQueryVariables; skip?: boolean; } | { skip: boolean; }) ) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<GetOrganizationNotificationStatsQuery, GetOrganizationNotificationStatsQueryVariables>(GetOrganizationNotificationStatsDocument, options);
      }
export function useGetOrganizationNotificationStatsLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<GetOrganizationNotificationStatsQuery, GetOrganizationNotificationStatsQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<GetOrganizationNotificationStatsQuery, GetOrganizationNotificationStatsQueryVariables>(GetOrganizationNotificationStatsDocument, options);
        }
export function useGetOrganizationNotificationStatsSuspenseQuery(baseOptions?: Apollo.SuspenseQueryHookOptions<GetOrganizationNotificationStatsQuery, GetOrganizationNotificationStatsQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useSuspenseQuery<GetOrganizationNotificationStatsQuery, GetOrganizationNotificationStatsQueryVariables>(GetOrganizationNotificationStatsDocument, options);
        }
export type GetOrganizationNotificationStatsQueryHookResult = ReturnType<typeof useGetOrganizationNotificationStatsQuery>;
export type GetOrganizationNotificationStatsLazyQueryHookResult = ReturnType<typeof useGetOrganizationNotificationStatsLazyQuery>;
export type GetOrganizationNotificationStatsSuspenseQueryHookResult = ReturnType<typeof useGetOrganizationNotificationStatsSuspenseQuery>;
export type GetOrganizationNotificationStatsQueryResult = Apollo.QueryResult<GetOrganizationNotificationStatsQuery, GetOrganizationNotificationStatsQueryVariables>;
export const GetOrganizationBulkMessageStatsDocument = gql`
    query getOrganizationBulkMessageStats($filters: MarketingFiltersInput!) {
  organizationBulkMessageStats(filters: $filters) {
    ...OrgBulkMessageStatsFields
  }
}
    ${OrgBulkMessageStatsFieldsFragmentDoc}`;

/**
 * __useGetOrganizationBulkMessageStatsQuery__
 *
 * To run a query within a React component, call `useGetOrganizationBulkMessageStatsQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetOrganizationBulkMessageStatsQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetOrganizationBulkMessageStatsQuery({
 *   variables: {
 *      filters: // value for 'filters'
 *   },
 * });
 */
export function useGetOrganizationBulkMessageStatsQuery(baseOptions: Apollo.QueryHookOptions<GetOrganizationBulkMessageStatsQuery, GetOrganizationBulkMessageStatsQueryVariables> & ({ variables: GetOrganizationBulkMessageStatsQueryVariables; skip?: boolean; } | { skip: boolean; }) ) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<GetOrganizationBulkMessageStatsQuery, GetOrganizationBulkMessageStatsQueryVariables>(GetOrganizationBulkMessageStatsDocument, options);
      }
export function useGetOrganizationBulkMessageStatsLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<GetOrganizationBulkMessageStatsQuery, GetOrganizationBulkMessageStatsQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<GetOrganizationBulkMessageStatsQuery, GetOrganizationBulkMessageStatsQueryVariables>(GetOrganizationBulkMessageStatsDocument, options);
        }
export function useGetOrganizationBulkMessageStatsSuspenseQuery(baseOptions?: Apollo.SuspenseQueryHookOptions<GetOrganizationBulkMessageStatsQuery, GetOrganizationBulkMessageStatsQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useSuspenseQuery<GetOrganizationBulkMessageStatsQuery, GetOrganizationBulkMessageStatsQueryVariables>(GetOrganizationBulkMessageStatsDocument, options);
        }
export type GetOrganizationBulkMessageStatsQueryHookResult = ReturnType<typeof useGetOrganizationBulkMessageStatsQuery>;
export type GetOrganizationBulkMessageStatsLazyQueryHookResult = ReturnType<typeof useGetOrganizationBulkMessageStatsLazyQuery>;
export type GetOrganizationBulkMessageStatsSuspenseQueryHookResult = ReturnType<typeof useGetOrganizationBulkMessageStatsSuspenseQuery>;
export type GetOrganizationBulkMessageStatsQueryResult = Apollo.QueryResult<GetOrganizationBulkMessageStatsQuery, GetOrganizationBulkMessageStatsQueryVariables>;
export const GetReminderAttributedAppointmentIdsDocument = gql`
    query getReminderAttributedAppointmentIds($filters: MarketingFiltersInput!) {
  reminderAttributedAppointmentIds(filters: $filters) {
    ...ReminderAttributedAppointmentIdsFields
  }
}
    ${ReminderAttributedAppointmentIdsFieldsFragmentDoc}`;

/**
 * __useGetReminderAttributedAppointmentIdsQuery__
 *
 * To run a query within a React component, call `useGetReminderAttributedAppointmentIdsQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetReminderAttributedAppointmentIdsQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetReminderAttributedAppointmentIdsQuery({
 *   variables: {
 *      filters: // value for 'filters'
 *   },
 * });
 */
export function useGetReminderAttributedAppointmentIdsQuery(baseOptions: Apollo.QueryHookOptions<GetReminderAttributedAppointmentIdsQuery, GetReminderAttributedAppointmentIdsQueryVariables> & ({ variables: GetReminderAttributedAppointmentIdsQueryVariables; skip?: boolean; } | { skip: boolean; }) ) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<GetReminderAttributedAppointmentIdsQuery, GetReminderAttributedAppointmentIdsQueryVariables>(GetReminderAttributedAppointmentIdsDocument, options);
      }
export function useGetReminderAttributedAppointmentIdsLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<GetReminderAttributedAppointmentIdsQuery, GetReminderAttributedAppointmentIdsQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<GetReminderAttributedAppointmentIdsQuery, GetReminderAttributedAppointmentIdsQueryVariables>(GetReminderAttributedAppointmentIdsDocument, options);
        }
export function useGetReminderAttributedAppointmentIdsSuspenseQuery(baseOptions?: Apollo.SuspenseQueryHookOptions<GetReminderAttributedAppointmentIdsQuery, GetReminderAttributedAppointmentIdsQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useSuspenseQuery<GetReminderAttributedAppointmentIdsQuery, GetReminderAttributedAppointmentIdsQueryVariables>(GetReminderAttributedAppointmentIdsDocument, options);
        }
export type GetReminderAttributedAppointmentIdsQueryHookResult = ReturnType<typeof useGetReminderAttributedAppointmentIdsQuery>;
export type GetReminderAttributedAppointmentIdsLazyQueryHookResult = ReturnType<typeof useGetReminderAttributedAppointmentIdsLazyQuery>;
export type GetReminderAttributedAppointmentIdsSuspenseQueryHookResult = ReturnType<typeof useGetReminderAttributedAppointmentIdsSuspenseQuery>;
export type GetReminderAttributedAppointmentIdsQueryResult = Apollo.QueryResult<GetReminderAttributedAppointmentIdsQuery, GetReminderAttributedAppointmentIdsQueryVariables>;
export const GetMessageTemplateDocument = gql`
    query getMessageTemplate($id: ID!) {
  messageTemplate(id: $id) {
    ...MessageTemplateFields
  }
}
    ${MessageTemplateFieldsFragmentDoc}`;

/**
 * __useGetMessageTemplateQuery__
 *
 * To run a query within a React component, call `useGetMessageTemplateQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetMessageTemplateQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetMessageTemplateQuery({
 *   variables: {
 *      id: // value for 'id'
 *   },
 * });
 */
export function useGetMessageTemplateQuery(baseOptions: Apollo.QueryHookOptions<GetMessageTemplateQuery, GetMessageTemplateQueryVariables> & ({ variables: GetMessageTemplateQueryVariables; skip?: boolean; } | { skip: boolean; }) ) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<GetMessageTemplateQuery, GetMessageTemplateQueryVariables>(GetMessageTemplateDocument, options);
      }
export function useGetMessageTemplateLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<GetMessageTemplateQuery, GetMessageTemplateQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<GetMessageTemplateQuery, GetMessageTemplateQueryVariables>(GetMessageTemplateDocument, options);
        }
export function useGetMessageTemplateSuspenseQuery(baseOptions?: Apollo.SuspenseQueryHookOptions<GetMessageTemplateQuery, GetMessageTemplateQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useSuspenseQuery<GetMessageTemplateQuery, GetMessageTemplateQueryVariables>(GetMessageTemplateDocument, options);
        }
export type GetMessageTemplateQueryHookResult = ReturnType<typeof useGetMessageTemplateQuery>;
export type GetMessageTemplateLazyQueryHookResult = ReturnType<typeof useGetMessageTemplateLazyQuery>;
export type GetMessageTemplateSuspenseQueryHookResult = ReturnType<typeof useGetMessageTemplateSuspenseQuery>;
export type GetMessageTemplateQueryResult = Apollo.QueryResult<GetMessageTemplateQuery, GetMessageTemplateQueryVariables>;
export const QueryClinicMessageTemplatesDocument = gql`
    query queryClinicMessageTemplates($clinicId: ID!, $where: [QueryInput!], $page: NonNegativeInt, $pageSize: NonNegativeInt, $orderBy: OrderByInput) {
  queryClinicMessageTemplates(
    clinicId: $clinicId
    where: $where
    page: $page
    pageSize: $pageSize
    orderBy: $orderBy
  ) {
    ...MessageTemplateFields
  }
}
    ${MessageTemplateFieldsFragmentDoc}`;

/**
 * __useQueryClinicMessageTemplatesQuery__
 *
 * To run a query within a React component, call `useQueryClinicMessageTemplatesQuery` and pass it any options that fit your needs.
 * When your component renders, `useQueryClinicMessageTemplatesQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useQueryClinicMessageTemplatesQuery({
 *   variables: {
 *      clinicId: // value for 'clinicId'
 *      where: // value for 'where'
 *      page: // value for 'page'
 *      pageSize: // value for 'pageSize'
 *      orderBy: // value for 'orderBy'
 *   },
 * });
 */
export function useQueryClinicMessageTemplatesQuery(baseOptions: Apollo.QueryHookOptions<QueryClinicMessageTemplatesQuery, QueryClinicMessageTemplatesQueryVariables> & ({ variables: QueryClinicMessageTemplatesQueryVariables; skip?: boolean; } | { skip: boolean; }) ) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<QueryClinicMessageTemplatesQuery, QueryClinicMessageTemplatesQueryVariables>(QueryClinicMessageTemplatesDocument, options);
      }
export function useQueryClinicMessageTemplatesLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<QueryClinicMessageTemplatesQuery, QueryClinicMessageTemplatesQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<QueryClinicMessageTemplatesQuery, QueryClinicMessageTemplatesQueryVariables>(QueryClinicMessageTemplatesDocument, options);
        }
export function useQueryClinicMessageTemplatesSuspenseQuery(baseOptions?: Apollo.SuspenseQueryHookOptions<QueryClinicMessageTemplatesQuery, QueryClinicMessageTemplatesQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useSuspenseQuery<QueryClinicMessageTemplatesQuery, QueryClinicMessageTemplatesQueryVariables>(QueryClinicMessageTemplatesDocument, options);
        }
export type QueryClinicMessageTemplatesQueryHookResult = ReturnType<typeof useQueryClinicMessageTemplatesQuery>;
export type QueryClinicMessageTemplatesLazyQueryHookResult = ReturnType<typeof useQueryClinicMessageTemplatesLazyQuery>;
export type QueryClinicMessageTemplatesSuspenseQueryHookResult = ReturnType<typeof useQueryClinicMessageTemplatesSuspenseQuery>;
export type QueryClinicMessageTemplatesQueryResult = Apollo.QueryResult<QueryClinicMessageTemplatesQuery, QueryClinicMessageTemplatesQueryVariables>;
export const CountClinicMessageTemplatesDocument = gql`
    query countClinicMessageTemplates($clinicId: ID!, $where: [QueryInput!]) {
  countClinicMessageTemplates(clinicId: $clinicId, where: $where)
}
    `;

/**
 * __useCountClinicMessageTemplatesQuery__
 *
 * To run a query within a React component, call `useCountClinicMessageTemplatesQuery` and pass it any options that fit your needs.
 * When your component renders, `useCountClinicMessageTemplatesQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useCountClinicMessageTemplatesQuery({
 *   variables: {
 *      clinicId: // value for 'clinicId'
 *      where: // value for 'where'
 *   },
 * });
 */
export function useCountClinicMessageTemplatesQuery(baseOptions: Apollo.QueryHookOptions<CountClinicMessageTemplatesQuery, CountClinicMessageTemplatesQueryVariables> & ({ variables: CountClinicMessageTemplatesQueryVariables; skip?: boolean; } | { skip: boolean; }) ) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<CountClinicMessageTemplatesQuery, CountClinicMessageTemplatesQueryVariables>(CountClinicMessageTemplatesDocument, options);
      }
export function useCountClinicMessageTemplatesLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<CountClinicMessageTemplatesQuery, CountClinicMessageTemplatesQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<CountClinicMessageTemplatesQuery, CountClinicMessageTemplatesQueryVariables>(CountClinicMessageTemplatesDocument, options);
        }
export function useCountClinicMessageTemplatesSuspenseQuery(baseOptions?: Apollo.SuspenseQueryHookOptions<CountClinicMessageTemplatesQuery, CountClinicMessageTemplatesQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useSuspenseQuery<CountClinicMessageTemplatesQuery, CountClinicMessageTemplatesQueryVariables>(CountClinicMessageTemplatesDocument, options);
        }
export type CountClinicMessageTemplatesQueryHookResult = ReturnType<typeof useCountClinicMessageTemplatesQuery>;
export type CountClinicMessageTemplatesLazyQueryHookResult = ReturnType<typeof useCountClinicMessageTemplatesLazyQuery>;
export type CountClinicMessageTemplatesSuspenseQueryHookResult = ReturnType<typeof useCountClinicMessageTemplatesSuspenseQuery>;
export type CountClinicMessageTemplatesQueryResult = Apollo.QueryResult<CountClinicMessageTemplatesQuery, CountClinicMessageTemplatesQueryVariables>;
export const QueryClinicGroupMessageTemplatesDocument = gql`
    query queryClinicGroupMessageTemplates($clinicGroupId: ID!, $where: [QueryInput!], $page: NonNegativeInt, $pageSize: NonNegativeInt, $orderBy: OrderByInput) {
  queryClinicGroupMessageTemplates(
    clinicGroupId: $clinicGroupId
    where: $where
    page: $page
    pageSize: $pageSize
    orderBy: $orderBy
  ) {
    ...MessageTemplateFields
  }
}
    ${MessageTemplateFieldsFragmentDoc}`;

/**
 * __useQueryClinicGroupMessageTemplatesQuery__
 *
 * To run a query within a React component, call `useQueryClinicGroupMessageTemplatesQuery` and pass it any options that fit your needs.
 * When your component renders, `useQueryClinicGroupMessageTemplatesQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useQueryClinicGroupMessageTemplatesQuery({
 *   variables: {
 *      clinicGroupId: // value for 'clinicGroupId'
 *      where: // value for 'where'
 *      page: // value for 'page'
 *      pageSize: // value for 'pageSize'
 *      orderBy: // value for 'orderBy'
 *   },
 * });
 */
export function useQueryClinicGroupMessageTemplatesQuery(baseOptions: Apollo.QueryHookOptions<QueryClinicGroupMessageTemplatesQuery, QueryClinicGroupMessageTemplatesQueryVariables> & ({ variables: QueryClinicGroupMessageTemplatesQueryVariables; skip?: boolean; } | { skip: boolean; }) ) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<QueryClinicGroupMessageTemplatesQuery, QueryClinicGroupMessageTemplatesQueryVariables>(QueryClinicGroupMessageTemplatesDocument, options);
      }
export function useQueryClinicGroupMessageTemplatesLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<QueryClinicGroupMessageTemplatesQuery, QueryClinicGroupMessageTemplatesQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<QueryClinicGroupMessageTemplatesQuery, QueryClinicGroupMessageTemplatesQueryVariables>(QueryClinicGroupMessageTemplatesDocument, options);
        }
export function useQueryClinicGroupMessageTemplatesSuspenseQuery(baseOptions?: Apollo.SuspenseQueryHookOptions<QueryClinicGroupMessageTemplatesQuery, QueryClinicGroupMessageTemplatesQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useSuspenseQuery<QueryClinicGroupMessageTemplatesQuery, QueryClinicGroupMessageTemplatesQueryVariables>(QueryClinicGroupMessageTemplatesDocument, options);
        }
export type QueryClinicGroupMessageTemplatesQueryHookResult = ReturnType<typeof useQueryClinicGroupMessageTemplatesQuery>;
export type QueryClinicGroupMessageTemplatesLazyQueryHookResult = ReturnType<typeof useQueryClinicGroupMessageTemplatesLazyQuery>;
export type QueryClinicGroupMessageTemplatesSuspenseQueryHookResult = ReturnType<typeof useQueryClinicGroupMessageTemplatesSuspenseQuery>;
export type QueryClinicGroupMessageTemplatesQueryResult = Apollo.QueryResult<QueryClinicGroupMessageTemplatesQuery, QueryClinicGroupMessageTemplatesQueryVariables>;
export const CountClinicGroupMessageTemplatesDocument = gql`
    query countClinicGroupMessageTemplates($clinicGroupId: ID!, $where: [QueryInput!]) {
  countClinicGroupMessageTemplates(clinicGroupId: $clinicGroupId, where: $where)
}
    `;

/**
 * __useCountClinicGroupMessageTemplatesQuery__
 *
 * To run a query within a React component, call `useCountClinicGroupMessageTemplatesQuery` and pass it any options that fit your needs.
 * When your component renders, `useCountClinicGroupMessageTemplatesQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useCountClinicGroupMessageTemplatesQuery({
 *   variables: {
 *      clinicGroupId: // value for 'clinicGroupId'
 *      where: // value for 'where'
 *   },
 * });
 */
export function useCountClinicGroupMessageTemplatesQuery(baseOptions: Apollo.QueryHookOptions<CountClinicGroupMessageTemplatesQuery, CountClinicGroupMessageTemplatesQueryVariables> & ({ variables: CountClinicGroupMessageTemplatesQueryVariables; skip?: boolean; } | { skip: boolean; }) ) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<CountClinicGroupMessageTemplatesQuery, CountClinicGroupMessageTemplatesQueryVariables>(CountClinicGroupMessageTemplatesDocument, options);
      }
export function useCountClinicGroupMessageTemplatesLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<CountClinicGroupMessageTemplatesQuery, CountClinicGroupMessageTemplatesQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<CountClinicGroupMessageTemplatesQuery, CountClinicGroupMessageTemplatesQueryVariables>(CountClinicGroupMessageTemplatesDocument, options);
        }
export function useCountClinicGroupMessageTemplatesSuspenseQuery(baseOptions?: Apollo.SuspenseQueryHookOptions<CountClinicGroupMessageTemplatesQuery, CountClinicGroupMessageTemplatesQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useSuspenseQuery<CountClinicGroupMessageTemplatesQuery, CountClinicGroupMessageTemplatesQueryVariables>(CountClinicGroupMessageTemplatesDocument, options);
        }
export type CountClinicGroupMessageTemplatesQueryHookResult = ReturnType<typeof useCountClinicGroupMessageTemplatesQuery>;
export type CountClinicGroupMessageTemplatesLazyQueryHookResult = ReturnType<typeof useCountClinicGroupMessageTemplatesLazyQuery>;
export type CountClinicGroupMessageTemplatesSuspenseQueryHookResult = ReturnType<typeof useCountClinicGroupMessageTemplatesSuspenseQuery>;
export type CountClinicGroupMessageTemplatesQueryResult = Apollo.QueryResult<CountClinicGroupMessageTemplatesQuery, CountClinicGroupMessageTemplatesQueryVariables>;
export const CreateMessageTemplateDocument = gql`
    mutation createMessageTemplate($input: CreateMessageTemplateInput!) {
  createMessageTemplate(input: $input) {
    ...MessageTemplateFields
  }
}
    ${MessageTemplateFieldsFragmentDoc}`;
export type CreateMessageTemplateMutationFn = Apollo.MutationFunction<CreateMessageTemplateMutation, CreateMessageTemplateMutationVariables>;

/**
 * __useCreateMessageTemplateMutation__
 *
 * To run a mutation, you first call `useCreateMessageTemplateMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useCreateMessageTemplateMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [createMessageTemplateMutation, { data, loading, error }] = useCreateMessageTemplateMutation({
 *   variables: {
 *      input: // value for 'input'
 *   },
 * });
 */
export function useCreateMessageTemplateMutation(baseOptions?: Apollo.MutationHookOptions<CreateMessageTemplateMutation, CreateMessageTemplateMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<CreateMessageTemplateMutation, CreateMessageTemplateMutationVariables>(CreateMessageTemplateDocument, options);
      }
export type CreateMessageTemplateMutationHookResult = ReturnType<typeof useCreateMessageTemplateMutation>;
export type CreateMessageTemplateMutationResult = Apollo.MutationResult<CreateMessageTemplateMutation>;
export type CreateMessageTemplateMutationOptions = Apollo.BaseMutationOptions<CreateMessageTemplateMutation, CreateMessageTemplateMutationVariables>;
export const UpdateMessageTemplateDocument = gql`
    mutation updateMessageTemplate($id: ID!, $input: UpdateMessageTemplateInput!) {
  updateMessageTemplate(id: $id, input: $input) {
    ...MessageTemplateFields
  }
}
    ${MessageTemplateFieldsFragmentDoc}`;
export type UpdateMessageTemplateMutationFn = Apollo.MutationFunction<UpdateMessageTemplateMutation, UpdateMessageTemplateMutationVariables>;

/**
 * __useUpdateMessageTemplateMutation__
 *
 * To run a mutation, you first call `useUpdateMessageTemplateMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useUpdateMessageTemplateMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [updateMessageTemplateMutation, { data, loading, error }] = useUpdateMessageTemplateMutation({
 *   variables: {
 *      id: // value for 'id'
 *      input: // value for 'input'
 *   },
 * });
 */
export function useUpdateMessageTemplateMutation(baseOptions?: Apollo.MutationHookOptions<UpdateMessageTemplateMutation, UpdateMessageTemplateMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<UpdateMessageTemplateMutation, UpdateMessageTemplateMutationVariables>(UpdateMessageTemplateDocument, options);
      }
export type UpdateMessageTemplateMutationHookResult = ReturnType<typeof useUpdateMessageTemplateMutation>;
export type UpdateMessageTemplateMutationResult = Apollo.MutationResult<UpdateMessageTemplateMutation>;
export type UpdateMessageTemplateMutationOptions = Apollo.BaseMutationOptions<UpdateMessageTemplateMutation, UpdateMessageTemplateMutationVariables>;
export const DeleteMessageTemplateDocument = gql`
    mutation deleteMessageTemplate($id: ID!) {
  deleteMessageTemplate(id: $id)
}
    `;
export type DeleteMessageTemplateMutationFn = Apollo.MutationFunction<DeleteMessageTemplateMutation, DeleteMessageTemplateMutationVariables>;

/**
 * __useDeleteMessageTemplateMutation__
 *
 * To run a mutation, you first call `useDeleteMessageTemplateMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useDeleteMessageTemplateMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [deleteMessageTemplateMutation, { data, loading, error }] = useDeleteMessageTemplateMutation({
 *   variables: {
 *      id: // value for 'id'
 *   },
 * });
 */
export function useDeleteMessageTemplateMutation(baseOptions?: Apollo.MutationHookOptions<DeleteMessageTemplateMutation, DeleteMessageTemplateMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<DeleteMessageTemplateMutation, DeleteMessageTemplateMutationVariables>(DeleteMessageTemplateDocument, options);
      }
export type DeleteMessageTemplateMutationHookResult = ReturnType<typeof useDeleteMessageTemplateMutation>;
export type DeleteMessageTemplateMutationResult = Apollo.MutationResult<DeleteMessageTemplateMutation>;
export type DeleteMessageTemplateMutationOptions = Apollo.BaseMutationOptions<DeleteMessageTemplateMutation, DeleteMessageTemplateMutationVariables>;
export const GetMessagesByChatIdDocument = gql`
    query getMessagesByChatId($chatId: ID!, $page: NonNegativeInt, $pageSize: NonNegativeInt, $patientIds: [ID!]) {
  getMessagesByChatId(
    chatId: $chatId
    page: $page
    pageSize: $pageSize
    patientIds: $patientIds
  ) {
    ...ChatMessageFields
  }
}
    ${ChatMessageFieldsFragmentDoc}`;

/**
 * __useGetMessagesByChatIdQuery__
 *
 * To run a query within a React component, call `useGetMessagesByChatIdQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetMessagesByChatIdQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetMessagesByChatIdQuery({
 *   variables: {
 *      chatId: // value for 'chatId'
 *      page: // value for 'page'
 *      pageSize: // value for 'pageSize'
 *      patientIds: // value for 'patientIds'
 *   },
 * });
 */
export function useGetMessagesByChatIdQuery(baseOptions: Apollo.QueryHookOptions<GetMessagesByChatIdQuery, GetMessagesByChatIdQueryVariables> & ({ variables: GetMessagesByChatIdQueryVariables; skip?: boolean; } | { skip: boolean; }) ) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<GetMessagesByChatIdQuery, GetMessagesByChatIdQueryVariables>(GetMessagesByChatIdDocument, options);
      }
export function useGetMessagesByChatIdLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<GetMessagesByChatIdQuery, GetMessagesByChatIdQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<GetMessagesByChatIdQuery, GetMessagesByChatIdQueryVariables>(GetMessagesByChatIdDocument, options);
        }
export function useGetMessagesByChatIdSuspenseQuery(baseOptions?: Apollo.SuspenseQueryHookOptions<GetMessagesByChatIdQuery, GetMessagesByChatIdQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useSuspenseQuery<GetMessagesByChatIdQuery, GetMessagesByChatIdQueryVariables>(GetMessagesByChatIdDocument, options);
        }
export type GetMessagesByChatIdQueryHookResult = ReturnType<typeof useGetMessagesByChatIdQuery>;
export type GetMessagesByChatIdLazyQueryHookResult = ReturnType<typeof useGetMessagesByChatIdLazyQuery>;
export type GetMessagesByChatIdSuspenseQueryHookResult = ReturnType<typeof useGetMessagesByChatIdSuspenseQuery>;
export type GetMessagesByChatIdQueryResult = Apollo.QueryResult<GetMessagesByChatIdQuery, GetMessagesByChatIdQueryVariables>;
export const GetChatMessagesByChatIdDocument = gql`
    query getChatMessagesByChatId($chatId: ID!, $page: NonNegativeInt, $pageSize: NonNegativeInt, $patientIds: [ID!], $showSystemMessages: Boolean) {
  getChatMessagesByChatId(
    chatId: $chatId
    page: $page
    pageSize: $pageSize
    patientIds: $patientIds
    showSystemMessages: $showSystemMessages
  ) {
    ...ChatMessageFields
  }
}
    ${ChatMessageFieldsFragmentDoc}`;

/**
 * __useGetChatMessagesByChatIdQuery__
 *
 * To run a query within a React component, call `useGetChatMessagesByChatIdQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetChatMessagesByChatIdQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetChatMessagesByChatIdQuery({
 *   variables: {
 *      chatId: // value for 'chatId'
 *      page: // value for 'page'
 *      pageSize: // value for 'pageSize'
 *      patientIds: // value for 'patientIds'
 *      showSystemMessages: // value for 'showSystemMessages'
 *   },
 * });
 */
export function useGetChatMessagesByChatIdQuery(baseOptions: Apollo.QueryHookOptions<GetChatMessagesByChatIdQuery, GetChatMessagesByChatIdQueryVariables> & ({ variables: GetChatMessagesByChatIdQueryVariables; skip?: boolean; } | { skip: boolean; }) ) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<GetChatMessagesByChatIdQuery, GetChatMessagesByChatIdQueryVariables>(GetChatMessagesByChatIdDocument, options);
      }
export function useGetChatMessagesByChatIdLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<GetChatMessagesByChatIdQuery, GetChatMessagesByChatIdQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<GetChatMessagesByChatIdQuery, GetChatMessagesByChatIdQueryVariables>(GetChatMessagesByChatIdDocument, options);
        }
export function useGetChatMessagesByChatIdSuspenseQuery(baseOptions?: Apollo.SuspenseQueryHookOptions<GetChatMessagesByChatIdQuery, GetChatMessagesByChatIdQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useSuspenseQuery<GetChatMessagesByChatIdQuery, GetChatMessagesByChatIdQueryVariables>(GetChatMessagesByChatIdDocument, options);
        }
export type GetChatMessagesByChatIdQueryHookResult = ReturnType<typeof useGetChatMessagesByChatIdQuery>;
export type GetChatMessagesByChatIdLazyQueryHookResult = ReturnType<typeof useGetChatMessagesByChatIdLazyQuery>;
export type GetChatMessagesByChatIdSuspenseQueryHookResult = ReturnType<typeof useGetChatMessagesByChatIdSuspenseQuery>;
export type GetChatMessagesByChatIdQueryResult = Apollo.QueryResult<GetChatMessagesByChatIdQuery, GetChatMessagesByChatIdQueryVariables>;
export const QueryMessagesDocument = gql`
    query queryMessages($where: [QueryInput!], $page: NonNegativeInt, $pageSize: NonNegativeInt, $orderBy: OrderByInput) {
  queryMessages(
    where: $where
    page: $page
    pageSize: $pageSize
    orderBy: $orderBy
  ) {
    ...ChatMessageFields
  }
}
    ${ChatMessageFieldsFragmentDoc}`;

/**
 * __useQueryMessagesQuery__
 *
 * To run a query within a React component, call `useQueryMessagesQuery` and pass it any options that fit your needs.
 * When your component renders, `useQueryMessagesQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useQueryMessagesQuery({
 *   variables: {
 *      where: // value for 'where'
 *      page: // value for 'page'
 *      pageSize: // value for 'pageSize'
 *      orderBy: // value for 'orderBy'
 *   },
 * });
 */
export function useQueryMessagesQuery(baseOptions?: Apollo.QueryHookOptions<QueryMessagesQuery, QueryMessagesQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<QueryMessagesQuery, QueryMessagesQueryVariables>(QueryMessagesDocument, options);
      }
export function useQueryMessagesLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<QueryMessagesQuery, QueryMessagesQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<QueryMessagesQuery, QueryMessagesQueryVariables>(QueryMessagesDocument, options);
        }
export function useQueryMessagesSuspenseQuery(baseOptions?: Apollo.SuspenseQueryHookOptions<QueryMessagesQuery, QueryMessagesQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useSuspenseQuery<QueryMessagesQuery, QueryMessagesQueryVariables>(QueryMessagesDocument, options);
        }
export type QueryMessagesQueryHookResult = ReturnType<typeof useQueryMessagesQuery>;
export type QueryMessagesLazyQueryHookResult = ReturnType<typeof useQueryMessagesLazyQuery>;
export type QueryMessagesSuspenseQueryHookResult = ReturnType<typeof useQueryMessagesSuspenseQuery>;
export type QueryMessagesQueryResult = Apollo.QueryResult<QueryMessagesQuery, QueryMessagesQueryVariables>;
export const QueryClinicMessagesDocument = gql`
    query queryClinicMessages($clinicId: ID!, $where: [QueryInput!], $page: NonNegativeInt, $pageSize: NonNegativeInt, $orderBy: OrderByInput, $notificationTemplateIds: [ID!], $patientIds: [ID!]) {
  queryClinicMessages(
    clinicId: $clinicId
    where: $where
    page: $page
    pageSize: $pageSize
    orderBy: $orderBy
    notificationTemplateIds: $notificationTemplateIds
    patientIds: $patientIds
  ) {
    ...MessageFields
  }
}
    ${MessageFieldsFragmentDoc}`;

/**
 * __useQueryClinicMessagesQuery__
 *
 * To run a query within a React component, call `useQueryClinicMessagesQuery` and pass it any options that fit your needs.
 * When your component renders, `useQueryClinicMessagesQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useQueryClinicMessagesQuery({
 *   variables: {
 *      clinicId: // value for 'clinicId'
 *      where: // value for 'where'
 *      page: // value for 'page'
 *      pageSize: // value for 'pageSize'
 *      orderBy: // value for 'orderBy'
 *      notificationTemplateIds: // value for 'notificationTemplateIds'
 *      patientIds: // value for 'patientIds'
 *   },
 * });
 */
export function useQueryClinicMessagesQuery(baseOptions: Apollo.QueryHookOptions<QueryClinicMessagesQuery, QueryClinicMessagesQueryVariables> & ({ variables: QueryClinicMessagesQueryVariables; skip?: boolean; } | { skip: boolean; }) ) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<QueryClinicMessagesQuery, QueryClinicMessagesQueryVariables>(QueryClinicMessagesDocument, options);
      }
export function useQueryClinicMessagesLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<QueryClinicMessagesQuery, QueryClinicMessagesQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<QueryClinicMessagesQuery, QueryClinicMessagesQueryVariables>(QueryClinicMessagesDocument, options);
        }
export function useQueryClinicMessagesSuspenseQuery(baseOptions?: Apollo.SuspenseQueryHookOptions<QueryClinicMessagesQuery, QueryClinicMessagesQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useSuspenseQuery<QueryClinicMessagesQuery, QueryClinicMessagesQueryVariables>(QueryClinicMessagesDocument, options);
        }
export type QueryClinicMessagesQueryHookResult = ReturnType<typeof useQueryClinicMessagesQuery>;
export type QueryClinicMessagesLazyQueryHookResult = ReturnType<typeof useQueryClinicMessagesLazyQuery>;
export type QueryClinicMessagesSuspenseQueryHookResult = ReturnType<typeof useQueryClinicMessagesSuspenseQuery>;
export type QueryClinicMessagesQueryResult = Apollo.QueryResult<QueryClinicMessagesQuery, QueryClinicMessagesQueryVariables>;
export const QueryClinicNotificationLogMessagesDocument = gql`
    query queryClinicNotificationLogMessages($clinicId: ID!, $where: [QueryInput!], $page: NonNegativeInt, $pageSize: NonNegativeInt, $orderBy: OrderByInput, $notificationTemplateIds: [ID!]) {
  queryClinicMessages(
    clinicId: $clinicId
    where: $where
    page: $page
    pageSize: $pageSize
    orderBy: $orderBy
    notificationTemplateIds: $notificationTemplateIds
  ) {
    ...NotificationLogMessageFields
  }
}
    ${NotificationLogMessageFieldsFragmentDoc}`;

/**
 * __useQueryClinicNotificationLogMessagesQuery__
 *
 * To run a query within a React component, call `useQueryClinicNotificationLogMessagesQuery` and pass it any options that fit your needs.
 * When your component renders, `useQueryClinicNotificationLogMessagesQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useQueryClinicNotificationLogMessagesQuery({
 *   variables: {
 *      clinicId: // value for 'clinicId'
 *      where: // value for 'where'
 *      page: // value for 'page'
 *      pageSize: // value for 'pageSize'
 *      orderBy: // value for 'orderBy'
 *      notificationTemplateIds: // value for 'notificationTemplateIds'
 *   },
 * });
 */
export function useQueryClinicNotificationLogMessagesQuery(baseOptions: Apollo.QueryHookOptions<QueryClinicNotificationLogMessagesQuery, QueryClinicNotificationLogMessagesQueryVariables> & ({ variables: QueryClinicNotificationLogMessagesQueryVariables; skip?: boolean; } | { skip: boolean; }) ) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<QueryClinicNotificationLogMessagesQuery, QueryClinicNotificationLogMessagesQueryVariables>(QueryClinicNotificationLogMessagesDocument, options);
      }
export function useQueryClinicNotificationLogMessagesLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<QueryClinicNotificationLogMessagesQuery, QueryClinicNotificationLogMessagesQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<QueryClinicNotificationLogMessagesQuery, QueryClinicNotificationLogMessagesQueryVariables>(QueryClinicNotificationLogMessagesDocument, options);
        }
export function useQueryClinicNotificationLogMessagesSuspenseQuery(baseOptions?: Apollo.SuspenseQueryHookOptions<QueryClinicNotificationLogMessagesQuery, QueryClinicNotificationLogMessagesQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useSuspenseQuery<QueryClinicNotificationLogMessagesQuery, QueryClinicNotificationLogMessagesQueryVariables>(QueryClinicNotificationLogMessagesDocument, options);
        }
export type QueryClinicNotificationLogMessagesQueryHookResult = ReturnType<typeof useQueryClinicNotificationLogMessagesQuery>;
export type QueryClinicNotificationLogMessagesLazyQueryHookResult = ReturnType<typeof useQueryClinicNotificationLogMessagesLazyQuery>;
export type QueryClinicNotificationLogMessagesSuspenseQueryHookResult = ReturnType<typeof useQueryClinicNotificationLogMessagesSuspenseQuery>;
export type QueryClinicNotificationLogMessagesQueryResult = Apollo.QueryResult<QueryClinicNotificationLogMessagesQuery, QueryClinicNotificationLogMessagesQueryVariables>;
export const CountMessagesDocument = gql`
    query countMessages($clinicId: ID!, $where: [QueryInput!], $notificationTemplateIds: [ID!], $patientIds: [ID!]) {
  countMessages(
    clinicId: $clinicId
    where: $where
    notificationTemplateIds: $notificationTemplateIds
    patientIds: $patientIds
  )
}
    `;

/**
 * __useCountMessagesQuery__
 *
 * To run a query within a React component, call `useCountMessagesQuery` and pass it any options that fit your needs.
 * When your component renders, `useCountMessagesQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useCountMessagesQuery({
 *   variables: {
 *      clinicId: // value for 'clinicId'
 *      where: // value for 'where'
 *      notificationTemplateIds: // value for 'notificationTemplateIds'
 *      patientIds: // value for 'patientIds'
 *   },
 * });
 */
export function useCountMessagesQuery(baseOptions: Apollo.QueryHookOptions<CountMessagesQuery, CountMessagesQueryVariables> & ({ variables: CountMessagesQueryVariables; skip?: boolean; } | { skip: boolean; }) ) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<CountMessagesQuery, CountMessagesQueryVariables>(CountMessagesDocument, options);
      }
export function useCountMessagesLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<CountMessagesQuery, CountMessagesQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<CountMessagesQuery, CountMessagesQueryVariables>(CountMessagesDocument, options);
        }
export function useCountMessagesSuspenseQuery(baseOptions?: Apollo.SuspenseQueryHookOptions<CountMessagesQuery, CountMessagesQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useSuspenseQuery<CountMessagesQuery, CountMessagesQueryVariables>(CountMessagesDocument, options);
        }
export type CountMessagesQueryHookResult = ReturnType<typeof useCountMessagesQuery>;
export type CountMessagesLazyQueryHookResult = ReturnType<typeof useCountMessagesLazyQuery>;
export type CountMessagesSuspenseQueryHookResult = ReturnType<typeof useCountMessagesSuspenseQuery>;
export type CountMessagesQueryResult = Apollo.QueryResult<CountMessagesQuery, CountMessagesQueryVariables>;
export const SuggestChatResponseDocument = gql`
    query suggestChatResponse($chatId: ID!, $existingText: String) {
  suggestChatResponse(chatId: $chatId, existingText: $existingText) {
    response
    responses_left
  }
}
    `;

/**
 * __useSuggestChatResponseQuery__
 *
 * To run a query within a React component, call `useSuggestChatResponseQuery` and pass it any options that fit your needs.
 * When your component renders, `useSuggestChatResponseQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useSuggestChatResponseQuery({
 *   variables: {
 *      chatId: // value for 'chatId'
 *      existingText: // value for 'existingText'
 *   },
 * });
 */
export function useSuggestChatResponseQuery(baseOptions: Apollo.QueryHookOptions<SuggestChatResponseQuery, SuggestChatResponseQueryVariables> & ({ variables: SuggestChatResponseQueryVariables; skip?: boolean; } | { skip: boolean; }) ) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<SuggestChatResponseQuery, SuggestChatResponseQueryVariables>(SuggestChatResponseDocument, options);
      }
export function useSuggestChatResponseLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<SuggestChatResponseQuery, SuggestChatResponseQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<SuggestChatResponseQuery, SuggestChatResponseQueryVariables>(SuggestChatResponseDocument, options);
        }
export function useSuggestChatResponseSuspenseQuery(baseOptions?: Apollo.SuspenseQueryHookOptions<SuggestChatResponseQuery, SuggestChatResponseQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useSuspenseQuery<SuggestChatResponseQuery, SuggestChatResponseQueryVariables>(SuggestChatResponseDocument, options);
        }
export type SuggestChatResponseQueryHookResult = ReturnType<typeof useSuggestChatResponseQuery>;
export type SuggestChatResponseLazyQueryHookResult = ReturnType<typeof useSuggestChatResponseLazyQuery>;
export type SuggestChatResponseSuspenseQueryHookResult = ReturnType<typeof useSuggestChatResponseSuspenseQuery>;
export type SuggestChatResponseQueryResult = Apollo.QueryResult<SuggestChatResponseQuery, SuggestChatResponseQueryVariables>;
export const CreateMessageDocument = gql`
    mutation createMessage($chatId: ID!, $data: CreateMessageInput!) {
  createMessage(chatId: $chatId, data: $data) {
    ...MessageFields
  }
}
    ${MessageFieldsFragmentDoc}`;
export type CreateMessageMutationFn = Apollo.MutationFunction<CreateMessageMutation, CreateMessageMutationVariables>;

/**
 * __useCreateMessageMutation__
 *
 * To run a mutation, you first call `useCreateMessageMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useCreateMessageMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [createMessageMutation, { data, loading, error }] = useCreateMessageMutation({
 *   variables: {
 *      chatId: // value for 'chatId'
 *      data: // value for 'data'
 *   },
 * });
 */
export function useCreateMessageMutation(baseOptions?: Apollo.MutationHookOptions<CreateMessageMutation, CreateMessageMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<CreateMessageMutation, CreateMessageMutationVariables>(CreateMessageDocument, options);
      }
export type CreateMessageMutationHookResult = ReturnType<typeof useCreateMessageMutation>;
export type CreateMessageMutationResult = Apollo.MutationResult<CreateMessageMutation>;
export type CreateMessageMutationOptions = Apollo.BaseMutationOptions<CreateMessageMutation, CreateMessageMutationVariables>;
export const UpdateMessageDocument = gql`
    mutation updateMessage($chatId: ID!, $messageId: ID!, $data: UpdateMessageInput!) {
  updateMessage(chatId: $chatId, messageId: $messageId, data: $data) {
    ...MessageFields
  }
}
    ${MessageFieldsFragmentDoc}`;
export type UpdateMessageMutationFn = Apollo.MutationFunction<UpdateMessageMutation, UpdateMessageMutationVariables>;

/**
 * __useUpdateMessageMutation__
 *
 * To run a mutation, you first call `useUpdateMessageMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useUpdateMessageMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [updateMessageMutation, { data, loading, error }] = useUpdateMessageMutation({
 *   variables: {
 *      chatId: // value for 'chatId'
 *      messageId: // value for 'messageId'
 *      data: // value for 'data'
 *   },
 * });
 */
export function useUpdateMessageMutation(baseOptions?: Apollo.MutationHookOptions<UpdateMessageMutation, UpdateMessageMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<UpdateMessageMutation, UpdateMessageMutationVariables>(UpdateMessageDocument, options);
      }
export type UpdateMessageMutationHookResult = ReturnType<typeof useUpdateMessageMutation>;
export type UpdateMessageMutationResult = Apollo.MutationResult<UpdateMessageMutation>;
export type UpdateMessageMutationOptions = Apollo.BaseMutationOptions<UpdateMessageMutation, UpdateMessageMutationVariables>;
export const DeleteMessageDocument = gql`
    mutation deleteMessage($chatId: ID!, $messageId: ID!) {
  deleteMessage(chatId: $chatId, messageId: $messageId)
}
    `;
export type DeleteMessageMutationFn = Apollo.MutationFunction<DeleteMessageMutation, DeleteMessageMutationVariables>;

/**
 * __useDeleteMessageMutation__
 *
 * To run a mutation, you first call `useDeleteMessageMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useDeleteMessageMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [deleteMessageMutation, { data, loading, error }] = useDeleteMessageMutation({
 *   variables: {
 *      chatId: // value for 'chatId'
 *      messageId: // value for 'messageId'
 *   },
 * });
 */
export function useDeleteMessageMutation(baseOptions?: Apollo.MutationHookOptions<DeleteMessageMutation, DeleteMessageMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<DeleteMessageMutation, DeleteMessageMutationVariables>(DeleteMessageDocument, options);
      }
export type DeleteMessageMutationHookResult = ReturnType<typeof useDeleteMessageMutation>;
export type DeleteMessageMutationResult = Apollo.MutationResult<DeleteMessageMutation>;
export type DeleteMessageMutationOptions = Apollo.BaseMutationOptions<DeleteMessageMutation, DeleteMessageMutationVariables>;
export const QueryMsgTrackingEventsDocument = gql`
    query queryMsgTrackingEvents($where: [QueryInput!], $page: NonNegativeInt, $pageSize: NonNegativeInt, $orderBy: OrderByInput) {
  queryMsgTrackingEvents(
    where: $where
    page: $page
    pageSize: $pageSize
    orderBy: $orderBy
  ) {
    ...MsgTrackingEventFields
  }
}
    ${MsgTrackingEventFieldsFragmentDoc}`;

/**
 * __useQueryMsgTrackingEventsQuery__
 *
 * To run a query within a React component, call `useQueryMsgTrackingEventsQuery` and pass it any options that fit your needs.
 * When your component renders, `useQueryMsgTrackingEventsQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useQueryMsgTrackingEventsQuery({
 *   variables: {
 *      where: // value for 'where'
 *      page: // value for 'page'
 *      pageSize: // value for 'pageSize'
 *      orderBy: // value for 'orderBy'
 *   },
 * });
 */
export function useQueryMsgTrackingEventsQuery(baseOptions?: Apollo.QueryHookOptions<QueryMsgTrackingEventsQuery, QueryMsgTrackingEventsQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<QueryMsgTrackingEventsQuery, QueryMsgTrackingEventsQueryVariables>(QueryMsgTrackingEventsDocument, options);
      }
export function useQueryMsgTrackingEventsLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<QueryMsgTrackingEventsQuery, QueryMsgTrackingEventsQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<QueryMsgTrackingEventsQuery, QueryMsgTrackingEventsQueryVariables>(QueryMsgTrackingEventsDocument, options);
        }
export function useQueryMsgTrackingEventsSuspenseQuery(baseOptions?: Apollo.SuspenseQueryHookOptions<QueryMsgTrackingEventsQuery, QueryMsgTrackingEventsQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useSuspenseQuery<QueryMsgTrackingEventsQuery, QueryMsgTrackingEventsQueryVariables>(QueryMsgTrackingEventsDocument, options);
        }
export type QueryMsgTrackingEventsQueryHookResult = ReturnType<typeof useQueryMsgTrackingEventsQuery>;
export type QueryMsgTrackingEventsLazyQueryHookResult = ReturnType<typeof useQueryMsgTrackingEventsLazyQuery>;
export type QueryMsgTrackingEventsSuspenseQueryHookResult = ReturnType<typeof useQueryMsgTrackingEventsSuspenseQuery>;
export type QueryMsgTrackingEventsQueryResult = Apollo.QueryResult<QueryMsgTrackingEventsQuery, QueryMsgTrackingEventsQueryVariables>;
export const CountMsgTrackingEventsDocument = gql`
    query countMsgTrackingEvents($where: [QueryInput!]) {
  countMsgTrackingEvents(where: $where)
}
    `;

/**
 * __useCountMsgTrackingEventsQuery__
 *
 * To run a query within a React component, call `useCountMsgTrackingEventsQuery` and pass it any options that fit your needs.
 * When your component renders, `useCountMsgTrackingEventsQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useCountMsgTrackingEventsQuery({
 *   variables: {
 *      where: // value for 'where'
 *   },
 * });
 */
export function useCountMsgTrackingEventsQuery(baseOptions?: Apollo.QueryHookOptions<CountMsgTrackingEventsQuery, CountMsgTrackingEventsQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<CountMsgTrackingEventsQuery, CountMsgTrackingEventsQueryVariables>(CountMsgTrackingEventsDocument, options);
      }
export function useCountMsgTrackingEventsLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<CountMsgTrackingEventsQuery, CountMsgTrackingEventsQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<CountMsgTrackingEventsQuery, CountMsgTrackingEventsQueryVariables>(CountMsgTrackingEventsDocument, options);
        }
export function useCountMsgTrackingEventsSuspenseQuery(baseOptions?: Apollo.SuspenseQueryHookOptions<CountMsgTrackingEventsQuery, CountMsgTrackingEventsQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useSuspenseQuery<CountMsgTrackingEventsQuery, CountMsgTrackingEventsQueryVariables>(CountMsgTrackingEventsDocument, options);
        }
export type CountMsgTrackingEventsQueryHookResult = ReturnType<typeof useCountMsgTrackingEventsQuery>;
export type CountMsgTrackingEventsLazyQueryHookResult = ReturnType<typeof useCountMsgTrackingEventsLazyQuery>;
export type CountMsgTrackingEventsSuspenseQueryHookResult = ReturnType<typeof useCountMsgTrackingEventsSuspenseQuery>;
export type CountMsgTrackingEventsQueryResult = Apollo.QueryResult<CountMsgTrackingEventsQuery, CountMsgTrackingEventsQueryVariables>;
export const GetClinicGroupNotificationAnalyticsDocument = gql`
    query getClinicGroupNotificationAnalytics($clinicGroupId: ID!, $clinicIds: [ID!], $range: UsageTimeRangeInput!) {
  clinicGroupNotificationAnalytics(
    clinic_group_id: $clinicGroupId
    clinic_ids: $clinicIds
    range: $range
  ) {
    categories {
      ...NotificationCategoryEngagementFields
    }
    notifications {
      ...NotificationEngagementFields
    }
  }
}
    ${NotificationCategoryEngagementFieldsFragmentDoc}
${NotificationEngagementFieldsFragmentDoc}`;

/**
 * __useGetClinicGroupNotificationAnalyticsQuery__
 *
 * To run a query within a React component, call `useGetClinicGroupNotificationAnalyticsQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetClinicGroupNotificationAnalyticsQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetClinicGroupNotificationAnalyticsQuery({
 *   variables: {
 *      clinicGroupId: // value for 'clinicGroupId'
 *      clinicIds: // value for 'clinicIds'
 *      range: // value for 'range'
 *   },
 * });
 */
export function useGetClinicGroupNotificationAnalyticsQuery(baseOptions: Apollo.QueryHookOptions<GetClinicGroupNotificationAnalyticsQuery, GetClinicGroupNotificationAnalyticsQueryVariables> & ({ variables: GetClinicGroupNotificationAnalyticsQueryVariables; skip?: boolean; } | { skip: boolean; }) ) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<GetClinicGroupNotificationAnalyticsQuery, GetClinicGroupNotificationAnalyticsQueryVariables>(GetClinicGroupNotificationAnalyticsDocument, options);
      }
export function useGetClinicGroupNotificationAnalyticsLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<GetClinicGroupNotificationAnalyticsQuery, GetClinicGroupNotificationAnalyticsQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<GetClinicGroupNotificationAnalyticsQuery, GetClinicGroupNotificationAnalyticsQueryVariables>(GetClinicGroupNotificationAnalyticsDocument, options);
        }
export function useGetClinicGroupNotificationAnalyticsSuspenseQuery(baseOptions?: Apollo.SuspenseQueryHookOptions<GetClinicGroupNotificationAnalyticsQuery, GetClinicGroupNotificationAnalyticsQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useSuspenseQuery<GetClinicGroupNotificationAnalyticsQuery, GetClinicGroupNotificationAnalyticsQueryVariables>(GetClinicGroupNotificationAnalyticsDocument, options);
        }
export type GetClinicGroupNotificationAnalyticsQueryHookResult = ReturnType<typeof useGetClinicGroupNotificationAnalyticsQuery>;
export type GetClinicGroupNotificationAnalyticsLazyQueryHookResult = ReturnType<typeof useGetClinicGroupNotificationAnalyticsLazyQuery>;
export type GetClinicGroupNotificationAnalyticsSuspenseQueryHookResult = ReturnType<typeof useGetClinicGroupNotificationAnalyticsSuspenseQuery>;
export type GetClinicGroupNotificationAnalyticsQueryResult = Apollo.QueryResult<GetClinicGroupNotificationAnalyticsQuery, GetClinicGroupNotificationAnalyticsQueryVariables>;
export const GetClinicNotificationAnalyticsDocument = gql`
    query getClinicNotificationAnalytics($clinicId: ID!, $range: UsageTimeRangeInput!) {
  clinicNotificationAnalytics(clinic_id: $clinicId, range: $range) {
    categories {
      ...NotificationCategoryEngagementFields
    }
    notifications {
      ...NotificationEngagementFields
    }
  }
}
    ${NotificationCategoryEngagementFieldsFragmentDoc}
${NotificationEngagementFieldsFragmentDoc}`;

/**
 * __useGetClinicNotificationAnalyticsQuery__
 *
 * To run a query within a React component, call `useGetClinicNotificationAnalyticsQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetClinicNotificationAnalyticsQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetClinicNotificationAnalyticsQuery({
 *   variables: {
 *      clinicId: // value for 'clinicId'
 *      range: // value for 'range'
 *   },
 * });
 */
export function useGetClinicNotificationAnalyticsQuery(baseOptions: Apollo.QueryHookOptions<GetClinicNotificationAnalyticsQuery, GetClinicNotificationAnalyticsQueryVariables> & ({ variables: GetClinicNotificationAnalyticsQueryVariables; skip?: boolean; } | { skip: boolean; }) ) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<GetClinicNotificationAnalyticsQuery, GetClinicNotificationAnalyticsQueryVariables>(GetClinicNotificationAnalyticsDocument, options);
      }
export function useGetClinicNotificationAnalyticsLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<GetClinicNotificationAnalyticsQuery, GetClinicNotificationAnalyticsQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<GetClinicNotificationAnalyticsQuery, GetClinicNotificationAnalyticsQueryVariables>(GetClinicNotificationAnalyticsDocument, options);
        }
export function useGetClinicNotificationAnalyticsSuspenseQuery(baseOptions?: Apollo.SuspenseQueryHookOptions<GetClinicNotificationAnalyticsQuery, GetClinicNotificationAnalyticsQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useSuspenseQuery<GetClinicNotificationAnalyticsQuery, GetClinicNotificationAnalyticsQueryVariables>(GetClinicNotificationAnalyticsDocument, options);
        }
export type GetClinicNotificationAnalyticsQueryHookResult = ReturnType<typeof useGetClinicNotificationAnalyticsQuery>;
export type GetClinicNotificationAnalyticsLazyQueryHookResult = ReturnType<typeof useGetClinicNotificationAnalyticsLazyQuery>;
export type GetClinicNotificationAnalyticsSuspenseQueryHookResult = ReturnType<typeof useGetClinicNotificationAnalyticsSuspenseQuery>;
export type GetClinicNotificationAnalyticsQueryResult = Apollo.QueryResult<GetClinicNotificationAnalyticsQuery, GetClinicNotificationAnalyticsQueryVariables>;
export const GetClinicGroupMedicalReminderFunnelDocument = gql`
    query getClinicGroupMedicalReminderFunnel($clinicGroupId: ID!, $clinicIds: [ID!], $range: UsageTimeRangeInput!, $includeNotificationBreakdown: Boolean = false) {
  clinicGroupMedicalReminderFunnel(
    clinic_group_id: $clinicGroupId
    clinic_ids: $clinicIds
    range: $range
    include_notification_breakdown: $includeNotificationBreakdown
  ) {
    ...MedicalReminderFunnelFields
  }
}
    ${MedicalReminderFunnelFieldsFragmentDoc}`;

/**
 * __useGetClinicGroupMedicalReminderFunnelQuery__
 *
 * To run a query within a React component, call `useGetClinicGroupMedicalReminderFunnelQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetClinicGroupMedicalReminderFunnelQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetClinicGroupMedicalReminderFunnelQuery({
 *   variables: {
 *      clinicGroupId: // value for 'clinicGroupId'
 *      clinicIds: // value for 'clinicIds'
 *      range: // value for 'range'
 *      includeNotificationBreakdown: // value for 'includeNotificationBreakdown'
 *   },
 * });
 */
export function useGetClinicGroupMedicalReminderFunnelQuery(baseOptions: Apollo.QueryHookOptions<GetClinicGroupMedicalReminderFunnelQuery, GetClinicGroupMedicalReminderFunnelQueryVariables> & ({ variables: GetClinicGroupMedicalReminderFunnelQueryVariables; skip?: boolean; } | { skip: boolean; }) ) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<GetClinicGroupMedicalReminderFunnelQuery, GetClinicGroupMedicalReminderFunnelQueryVariables>(GetClinicGroupMedicalReminderFunnelDocument, options);
      }
export function useGetClinicGroupMedicalReminderFunnelLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<GetClinicGroupMedicalReminderFunnelQuery, GetClinicGroupMedicalReminderFunnelQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<GetClinicGroupMedicalReminderFunnelQuery, GetClinicGroupMedicalReminderFunnelQueryVariables>(GetClinicGroupMedicalReminderFunnelDocument, options);
        }
export function useGetClinicGroupMedicalReminderFunnelSuspenseQuery(baseOptions?: Apollo.SuspenseQueryHookOptions<GetClinicGroupMedicalReminderFunnelQuery, GetClinicGroupMedicalReminderFunnelQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useSuspenseQuery<GetClinicGroupMedicalReminderFunnelQuery, GetClinicGroupMedicalReminderFunnelQueryVariables>(GetClinicGroupMedicalReminderFunnelDocument, options);
        }
export type GetClinicGroupMedicalReminderFunnelQueryHookResult = ReturnType<typeof useGetClinicGroupMedicalReminderFunnelQuery>;
export type GetClinicGroupMedicalReminderFunnelLazyQueryHookResult = ReturnType<typeof useGetClinicGroupMedicalReminderFunnelLazyQuery>;
export type GetClinicGroupMedicalReminderFunnelSuspenseQueryHookResult = ReturnType<typeof useGetClinicGroupMedicalReminderFunnelSuspenseQuery>;
export type GetClinicGroupMedicalReminderFunnelQueryResult = Apollo.QueryResult<GetClinicGroupMedicalReminderFunnelQuery, GetClinicGroupMedicalReminderFunnelQueryVariables>;
export const GetClinicMedicalReminderFunnelDocument = gql`
    query getClinicMedicalReminderFunnel($clinicId: ID!, $range: UsageTimeRangeInput!, $includeNotificationBreakdown: Boolean = false) {
  clinicMedicalReminderFunnel(
    clinic_id: $clinicId
    range: $range
    include_notification_breakdown: $includeNotificationBreakdown
  ) {
    ...MedicalReminderFunnelFields
  }
}
    ${MedicalReminderFunnelFieldsFragmentDoc}`;

/**
 * __useGetClinicMedicalReminderFunnelQuery__
 *
 * To run a query within a React component, call `useGetClinicMedicalReminderFunnelQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetClinicMedicalReminderFunnelQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetClinicMedicalReminderFunnelQuery({
 *   variables: {
 *      clinicId: // value for 'clinicId'
 *      range: // value for 'range'
 *      includeNotificationBreakdown: // value for 'includeNotificationBreakdown'
 *   },
 * });
 */
export function useGetClinicMedicalReminderFunnelQuery(baseOptions: Apollo.QueryHookOptions<GetClinicMedicalReminderFunnelQuery, GetClinicMedicalReminderFunnelQueryVariables> & ({ variables: GetClinicMedicalReminderFunnelQueryVariables; skip?: boolean; } | { skip: boolean; }) ) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<GetClinicMedicalReminderFunnelQuery, GetClinicMedicalReminderFunnelQueryVariables>(GetClinicMedicalReminderFunnelDocument, options);
      }
export function useGetClinicMedicalReminderFunnelLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<GetClinicMedicalReminderFunnelQuery, GetClinicMedicalReminderFunnelQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<GetClinicMedicalReminderFunnelQuery, GetClinicMedicalReminderFunnelQueryVariables>(GetClinicMedicalReminderFunnelDocument, options);
        }
export function useGetClinicMedicalReminderFunnelSuspenseQuery(baseOptions?: Apollo.SuspenseQueryHookOptions<GetClinicMedicalReminderFunnelQuery, GetClinicMedicalReminderFunnelQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useSuspenseQuery<GetClinicMedicalReminderFunnelQuery, GetClinicMedicalReminderFunnelQueryVariables>(GetClinicMedicalReminderFunnelDocument, options);
        }
export type GetClinicMedicalReminderFunnelQueryHookResult = ReturnType<typeof useGetClinicMedicalReminderFunnelQuery>;
export type GetClinicMedicalReminderFunnelLazyQueryHookResult = ReturnType<typeof useGetClinicMedicalReminderFunnelLazyQuery>;
export type GetClinicMedicalReminderFunnelSuspenseQueryHookResult = ReturnType<typeof useGetClinicMedicalReminderFunnelSuspenseQuery>;
export type GetClinicMedicalReminderFunnelQueryResult = Apollo.QueryResult<GetClinicMedicalReminderFunnelQuery, GetClinicMedicalReminderFunnelQueryVariables>;
export const NotificationTemplateDocument = gql`
    query notificationTemplate($notificationTemplateId: ID!) {
  notificationTemplate(notificationTemplateId: $notificationTemplateId) {
    ...NotificationTemplateFields
  }
}
    ${NotificationTemplateFieldsFragmentDoc}`;

/**
 * __useNotificationTemplateQuery__
 *
 * To run a query within a React component, call `useNotificationTemplateQuery` and pass it any options that fit your needs.
 * When your component renders, `useNotificationTemplateQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useNotificationTemplateQuery({
 *   variables: {
 *      notificationTemplateId: // value for 'notificationTemplateId'
 *   },
 * });
 */
export function useNotificationTemplateQuery(baseOptions: Apollo.QueryHookOptions<NotificationTemplateQuery, NotificationTemplateQueryVariables> & ({ variables: NotificationTemplateQueryVariables; skip?: boolean; } | { skip: boolean; }) ) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<NotificationTemplateQuery, NotificationTemplateQueryVariables>(NotificationTemplateDocument, options);
      }
export function useNotificationTemplateLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<NotificationTemplateQuery, NotificationTemplateQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<NotificationTemplateQuery, NotificationTemplateQueryVariables>(NotificationTemplateDocument, options);
        }
export function useNotificationTemplateSuspenseQuery(baseOptions?: Apollo.SuspenseQueryHookOptions<NotificationTemplateQuery, NotificationTemplateQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useSuspenseQuery<NotificationTemplateQuery, NotificationTemplateQueryVariables>(NotificationTemplateDocument, options);
        }
export type NotificationTemplateQueryHookResult = ReturnType<typeof useNotificationTemplateQuery>;
export type NotificationTemplateLazyQueryHookResult = ReturnType<typeof useNotificationTemplateLazyQuery>;
export type NotificationTemplateSuspenseQueryHookResult = ReturnType<typeof useNotificationTemplateSuspenseQuery>;
export type NotificationTemplateQueryResult = Apollo.QueryResult<NotificationTemplateQuery, NotificationTemplateQueryVariables>;
export const GetNotificationTemplatesByClinicIdDocument = gql`
    query getNotificationTemplatesByClinicId($clinicId: ID!) {
  getNotificationTemplatesByClinicId(clinicId: $clinicId) {
    ...NotificationTemplateFields
  }
}
    ${NotificationTemplateFieldsFragmentDoc}`;

/**
 * __useGetNotificationTemplatesByClinicIdQuery__
 *
 * To run a query within a React component, call `useGetNotificationTemplatesByClinicIdQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetNotificationTemplatesByClinicIdQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetNotificationTemplatesByClinicIdQuery({
 *   variables: {
 *      clinicId: // value for 'clinicId'
 *   },
 * });
 */
export function useGetNotificationTemplatesByClinicIdQuery(baseOptions: Apollo.QueryHookOptions<GetNotificationTemplatesByClinicIdQuery, GetNotificationTemplatesByClinicIdQueryVariables> & ({ variables: GetNotificationTemplatesByClinicIdQueryVariables; skip?: boolean; } | { skip: boolean; }) ) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<GetNotificationTemplatesByClinicIdQuery, GetNotificationTemplatesByClinicIdQueryVariables>(GetNotificationTemplatesByClinicIdDocument, options);
      }
export function useGetNotificationTemplatesByClinicIdLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<GetNotificationTemplatesByClinicIdQuery, GetNotificationTemplatesByClinicIdQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<GetNotificationTemplatesByClinicIdQuery, GetNotificationTemplatesByClinicIdQueryVariables>(GetNotificationTemplatesByClinicIdDocument, options);
        }
export function useGetNotificationTemplatesByClinicIdSuspenseQuery(baseOptions?: Apollo.SuspenseQueryHookOptions<GetNotificationTemplatesByClinicIdQuery, GetNotificationTemplatesByClinicIdQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useSuspenseQuery<GetNotificationTemplatesByClinicIdQuery, GetNotificationTemplatesByClinicIdQueryVariables>(GetNotificationTemplatesByClinicIdDocument, options);
        }
export type GetNotificationTemplatesByClinicIdQueryHookResult = ReturnType<typeof useGetNotificationTemplatesByClinicIdQuery>;
export type GetNotificationTemplatesByClinicIdLazyQueryHookResult = ReturnType<typeof useGetNotificationTemplatesByClinicIdLazyQuery>;
export type GetNotificationTemplatesByClinicIdSuspenseQueryHookResult = ReturnType<typeof useGetNotificationTemplatesByClinicIdSuspenseQuery>;
export type GetNotificationTemplatesByClinicIdQueryResult = Apollo.QueryResult<GetNotificationTemplatesByClinicIdQuery, GetNotificationTemplatesByClinicIdQueryVariables>;
export const QueryNotificationTemplatesDocument = gql`
    query queryNotificationTemplates($where: [QueryInput!], $page: NonNegativeInt, $pageSize: NonNegativeInt, $orderBy: OrderByInput) {
  queryNotificationTemplates(
    where: $where
    page: $page
    pageSize: $pageSize
    orderBy: $orderBy
  ) {
    ...NotificationTemplateFields
  }
}
    ${NotificationTemplateFieldsFragmentDoc}`;

/**
 * __useQueryNotificationTemplatesQuery__
 *
 * To run a query within a React component, call `useQueryNotificationTemplatesQuery` and pass it any options that fit your needs.
 * When your component renders, `useQueryNotificationTemplatesQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useQueryNotificationTemplatesQuery({
 *   variables: {
 *      where: // value for 'where'
 *      page: // value for 'page'
 *      pageSize: // value for 'pageSize'
 *      orderBy: // value for 'orderBy'
 *   },
 * });
 */
export function useQueryNotificationTemplatesQuery(baseOptions?: Apollo.QueryHookOptions<QueryNotificationTemplatesQuery, QueryNotificationTemplatesQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<QueryNotificationTemplatesQuery, QueryNotificationTemplatesQueryVariables>(QueryNotificationTemplatesDocument, options);
      }
export function useQueryNotificationTemplatesLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<QueryNotificationTemplatesQuery, QueryNotificationTemplatesQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<QueryNotificationTemplatesQuery, QueryNotificationTemplatesQueryVariables>(QueryNotificationTemplatesDocument, options);
        }
export function useQueryNotificationTemplatesSuspenseQuery(baseOptions?: Apollo.SuspenseQueryHookOptions<QueryNotificationTemplatesQuery, QueryNotificationTemplatesQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useSuspenseQuery<QueryNotificationTemplatesQuery, QueryNotificationTemplatesQueryVariables>(QueryNotificationTemplatesDocument, options);
        }
export type QueryNotificationTemplatesQueryHookResult = ReturnType<typeof useQueryNotificationTemplatesQuery>;
export type QueryNotificationTemplatesLazyQueryHookResult = ReturnType<typeof useQueryNotificationTemplatesLazyQuery>;
export type QueryNotificationTemplatesSuspenseQueryHookResult = ReturnType<typeof useQueryNotificationTemplatesSuspenseQuery>;
export type QueryNotificationTemplatesQueryResult = Apollo.QueryResult<QueryNotificationTemplatesQuery, QueryNotificationTemplatesQueryVariables>;
export const CountNotificationTemplatesDocument = gql`
    query countNotificationTemplates($where: [QueryInput!]) {
  countNotificationTemplates(where: $where)
}
    `;

/**
 * __useCountNotificationTemplatesQuery__
 *
 * To run a query within a React component, call `useCountNotificationTemplatesQuery` and pass it any options that fit your needs.
 * When your component renders, `useCountNotificationTemplatesQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useCountNotificationTemplatesQuery({
 *   variables: {
 *      where: // value for 'where'
 *   },
 * });
 */
export function useCountNotificationTemplatesQuery(baseOptions?: Apollo.QueryHookOptions<CountNotificationTemplatesQuery, CountNotificationTemplatesQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<CountNotificationTemplatesQuery, CountNotificationTemplatesQueryVariables>(CountNotificationTemplatesDocument, options);
      }
export function useCountNotificationTemplatesLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<CountNotificationTemplatesQuery, CountNotificationTemplatesQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<CountNotificationTemplatesQuery, CountNotificationTemplatesQueryVariables>(CountNotificationTemplatesDocument, options);
        }
export function useCountNotificationTemplatesSuspenseQuery(baseOptions?: Apollo.SuspenseQueryHookOptions<CountNotificationTemplatesQuery, CountNotificationTemplatesQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useSuspenseQuery<CountNotificationTemplatesQuery, CountNotificationTemplatesQueryVariables>(CountNotificationTemplatesDocument, options);
        }
export type CountNotificationTemplatesQueryHookResult = ReturnType<typeof useCountNotificationTemplatesQuery>;
export type CountNotificationTemplatesLazyQueryHookResult = ReturnType<typeof useCountNotificationTemplatesLazyQuery>;
export type CountNotificationTemplatesSuspenseQueryHookResult = ReturnType<typeof useCountNotificationTemplatesSuspenseQuery>;
export type CountNotificationTemplatesQueryResult = Apollo.QueryResult<CountNotificationTemplatesQuery, CountNotificationTemplatesQueryVariables>;
export const GetNotificationTemplateStatsDocument = gql`
    query getNotificationTemplateStats($id: ID!) {
  notificationTemplateTrackingStats(notificationTemplateId: $id) {
    unique_clients
    messages_sent
    emails_sent
    sms_sent
    email_opens
    email_open_rate
    email_unique_opens
    email_unique_open_rate
    email_clicks
    email_click_rate
    email_unique_clicks
    email_unique_click_rate
    sms_clicks
    sms_click_rate
    sms_unique_clicks
    sms_unique_click_rate
    conversion_rate
    direct_appointments
    indirect_appointments
    revenue_by_appt
    postcards_sent
    postcards_failed
    postcard_qr_scans
    postcard_unique_qr_scans
    postcard_spend_cents
    postcard_direct_appointments
    postcard_indirect_appointments
    postcard_direct_revenue_cents
    postcard_indirect_revenue_cents
    postcard_revenue_cents
    postcard_roi
  }
}
    `;

/**
 * __useGetNotificationTemplateStatsQuery__
 *
 * To run a query within a React component, call `useGetNotificationTemplateStatsQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetNotificationTemplateStatsQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetNotificationTemplateStatsQuery({
 *   variables: {
 *      id: // value for 'id'
 *   },
 * });
 */
export function useGetNotificationTemplateStatsQuery(baseOptions: Apollo.QueryHookOptions<GetNotificationTemplateStatsQuery, GetNotificationTemplateStatsQueryVariables> & ({ variables: GetNotificationTemplateStatsQueryVariables; skip?: boolean; } | { skip: boolean; }) ) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<GetNotificationTemplateStatsQuery, GetNotificationTemplateStatsQueryVariables>(GetNotificationTemplateStatsDocument, options);
      }
export function useGetNotificationTemplateStatsLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<GetNotificationTemplateStatsQuery, GetNotificationTemplateStatsQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<GetNotificationTemplateStatsQuery, GetNotificationTemplateStatsQueryVariables>(GetNotificationTemplateStatsDocument, options);
        }
export function useGetNotificationTemplateStatsSuspenseQuery(baseOptions?: Apollo.SuspenseQueryHookOptions<GetNotificationTemplateStatsQuery, GetNotificationTemplateStatsQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useSuspenseQuery<GetNotificationTemplateStatsQuery, GetNotificationTemplateStatsQueryVariables>(GetNotificationTemplateStatsDocument, options);
        }
export type GetNotificationTemplateStatsQueryHookResult = ReturnType<typeof useGetNotificationTemplateStatsQuery>;
export type GetNotificationTemplateStatsLazyQueryHookResult = ReturnType<typeof useGetNotificationTemplateStatsLazyQuery>;
export type GetNotificationTemplateStatsSuspenseQueryHookResult = ReturnType<typeof useGetNotificationTemplateStatsSuspenseQuery>;
export type GetNotificationTemplateStatsQueryResult = Apollo.QueryResult<GetNotificationTemplateStatsQuery, GetNotificationTemplateStatsQueryVariables>;
export const NotificationMessagesByReferencePeriodDocument = gql`
    query notificationMessagesByReferencePeriod($notificationId: ID!, $startDate: NonNegativeInt!, $endDate: NonNegativeInt!, $includePreview: Boolean = false) {
  notificationMessagesByReferencePeriod(
    notificationId: $notificationId
    startDate: $startDate
    endDate: $endDate
    includePreview: $includePreview
  ) {
    notification_id
    start_date
    end_date
    total_messages
    buckets {
      reference_period {
        quantity
        unit
        direction
      }
      reference_period_key
      count
      message_ids
      emails_sent
      sms_sent
      email_opens
      email_open_rate
      email_unique_opens
      email_unique_open_rate
      email_clicks
      email_click_rate
      email_unique_clicks
      email_unique_click_rate
      sms_clicks
      sms_click_rate
      sms_unique_clicks
      sms_unique_click_rate
    }
  }
}
    `;

/**
 * __useNotificationMessagesByReferencePeriodQuery__
 *
 * To run a query within a React component, call `useNotificationMessagesByReferencePeriodQuery` and pass it any options that fit your needs.
 * When your component renders, `useNotificationMessagesByReferencePeriodQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useNotificationMessagesByReferencePeriodQuery({
 *   variables: {
 *      notificationId: // value for 'notificationId'
 *      startDate: // value for 'startDate'
 *      endDate: // value for 'endDate'
 *      includePreview: // value for 'includePreview'
 *   },
 * });
 */
export function useNotificationMessagesByReferencePeriodQuery(baseOptions: Apollo.QueryHookOptions<NotificationMessagesByReferencePeriodQuery, NotificationMessagesByReferencePeriodQueryVariables> & ({ variables: NotificationMessagesByReferencePeriodQueryVariables; skip?: boolean; } | { skip: boolean; }) ) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<NotificationMessagesByReferencePeriodQuery, NotificationMessagesByReferencePeriodQueryVariables>(NotificationMessagesByReferencePeriodDocument, options);
      }
export function useNotificationMessagesByReferencePeriodLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<NotificationMessagesByReferencePeriodQuery, NotificationMessagesByReferencePeriodQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<NotificationMessagesByReferencePeriodQuery, NotificationMessagesByReferencePeriodQueryVariables>(NotificationMessagesByReferencePeriodDocument, options);
        }
export function useNotificationMessagesByReferencePeriodSuspenseQuery(baseOptions?: Apollo.SuspenseQueryHookOptions<NotificationMessagesByReferencePeriodQuery, NotificationMessagesByReferencePeriodQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useSuspenseQuery<NotificationMessagesByReferencePeriodQuery, NotificationMessagesByReferencePeriodQueryVariables>(NotificationMessagesByReferencePeriodDocument, options);
        }
export type NotificationMessagesByReferencePeriodQueryHookResult = ReturnType<typeof useNotificationMessagesByReferencePeriodQuery>;
export type NotificationMessagesByReferencePeriodLazyQueryHookResult = ReturnType<typeof useNotificationMessagesByReferencePeriodLazyQuery>;
export type NotificationMessagesByReferencePeriodSuspenseQueryHookResult = ReturnType<typeof useNotificationMessagesByReferencePeriodSuspenseQuery>;
export type NotificationMessagesByReferencePeriodQueryResult = Apollo.QueryResult<NotificationMessagesByReferencePeriodQuery, NotificationMessagesByReferencePeriodQueryVariables>;
export const CreateNotificationTemplateDocument = gql`
    mutation createNotificationTemplate($data: CreateNotificationTemplateInput!) {
  createNotificationTemplate(data: $data) {
    ...NotificationTemplateFields
  }
}
    ${NotificationTemplateFieldsFragmentDoc}`;
export type CreateNotificationTemplateMutationFn = Apollo.MutationFunction<CreateNotificationTemplateMutation, CreateNotificationTemplateMutationVariables>;

/**
 * __useCreateNotificationTemplateMutation__
 *
 * To run a mutation, you first call `useCreateNotificationTemplateMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useCreateNotificationTemplateMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [createNotificationTemplateMutation, { data, loading, error }] = useCreateNotificationTemplateMutation({
 *   variables: {
 *      data: // value for 'data'
 *   },
 * });
 */
export function useCreateNotificationTemplateMutation(baseOptions?: Apollo.MutationHookOptions<CreateNotificationTemplateMutation, CreateNotificationTemplateMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<CreateNotificationTemplateMutation, CreateNotificationTemplateMutationVariables>(CreateNotificationTemplateDocument, options);
      }
export type CreateNotificationTemplateMutationHookResult = ReturnType<typeof useCreateNotificationTemplateMutation>;
export type CreateNotificationTemplateMutationResult = Apollo.MutationResult<CreateNotificationTemplateMutation>;
export type CreateNotificationTemplateMutationOptions = Apollo.BaseMutationOptions<CreateNotificationTemplateMutation, CreateNotificationTemplateMutationVariables>;
export const UpdateNotificationTemplateDocument = gql`
    mutation updateNotificationTemplate($notificationTemplateId: ID!, $data: UpdateNotificationTemplateInput!) {
  updateNotificationTemplate(
    notificationTemplateId: $notificationTemplateId
    data: $data
  ) {
    ...NotificationTemplateFields
  }
}
    ${NotificationTemplateFieldsFragmentDoc}`;
export type UpdateNotificationTemplateMutationFn = Apollo.MutationFunction<UpdateNotificationTemplateMutation, UpdateNotificationTemplateMutationVariables>;

/**
 * __useUpdateNotificationTemplateMutation__
 *
 * To run a mutation, you first call `useUpdateNotificationTemplateMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useUpdateNotificationTemplateMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [updateNotificationTemplateMutation, { data, loading, error }] = useUpdateNotificationTemplateMutation({
 *   variables: {
 *      notificationTemplateId: // value for 'notificationTemplateId'
 *      data: // value for 'data'
 *   },
 * });
 */
export function useUpdateNotificationTemplateMutation(baseOptions?: Apollo.MutationHookOptions<UpdateNotificationTemplateMutation, UpdateNotificationTemplateMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<UpdateNotificationTemplateMutation, UpdateNotificationTemplateMutationVariables>(UpdateNotificationTemplateDocument, options);
      }
export type UpdateNotificationTemplateMutationHookResult = ReturnType<typeof useUpdateNotificationTemplateMutation>;
export type UpdateNotificationTemplateMutationResult = Apollo.MutationResult<UpdateNotificationTemplateMutation>;
export type UpdateNotificationTemplateMutationOptions = Apollo.BaseMutationOptions<UpdateNotificationTemplateMutation, UpdateNotificationTemplateMutationVariables>;
export const BulkUpdateNotificationTemplatesDocument = gql`
    mutation bulkUpdateNotificationTemplates($ids: [ID!]!, $data: BulkUpdateNotificationTemplateInput!) {
  bulkUpdateNotificationTemplates(ids: $ids, data: $data) {
    ...NotificationTemplateFields
  }
}
    ${NotificationTemplateFieldsFragmentDoc}`;
export type BulkUpdateNotificationTemplatesMutationFn = Apollo.MutationFunction<BulkUpdateNotificationTemplatesMutation, BulkUpdateNotificationTemplatesMutationVariables>;

/**
 * __useBulkUpdateNotificationTemplatesMutation__
 *
 * To run a mutation, you first call `useBulkUpdateNotificationTemplatesMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useBulkUpdateNotificationTemplatesMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [bulkUpdateNotificationTemplatesMutation, { data, loading, error }] = useBulkUpdateNotificationTemplatesMutation({
 *   variables: {
 *      ids: // value for 'ids'
 *      data: // value for 'data'
 *   },
 * });
 */
export function useBulkUpdateNotificationTemplatesMutation(baseOptions?: Apollo.MutationHookOptions<BulkUpdateNotificationTemplatesMutation, BulkUpdateNotificationTemplatesMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<BulkUpdateNotificationTemplatesMutation, BulkUpdateNotificationTemplatesMutationVariables>(BulkUpdateNotificationTemplatesDocument, options);
      }
export type BulkUpdateNotificationTemplatesMutationHookResult = ReturnType<typeof useBulkUpdateNotificationTemplatesMutation>;
export type BulkUpdateNotificationTemplatesMutationResult = Apollo.MutationResult<BulkUpdateNotificationTemplatesMutation>;
export type BulkUpdateNotificationTemplatesMutationOptions = Apollo.BaseMutationOptions<BulkUpdateNotificationTemplatesMutation, BulkUpdateNotificationTemplatesMutationVariables>;
export const ArchiveNotificationTemplateDocument = gql`
    mutation archiveNotificationTemplate($notificationTemplateId: ID!) {
  archiveNotificationTemplate(notificationTemplateId: $notificationTemplateId) {
    ...NotificationTemplateFields
  }
}
    ${NotificationTemplateFieldsFragmentDoc}`;
export type ArchiveNotificationTemplateMutationFn = Apollo.MutationFunction<ArchiveNotificationTemplateMutation, ArchiveNotificationTemplateMutationVariables>;

/**
 * __useArchiveNotificationTemplateMutation__
 *
 * To run a mutation, you first call `useArchiveNotificationTemplateMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useArchiveNotificationTemplateMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [archiveNotificationTemplateMutation, { data, loading, error }] = useArchiveNotificationTemplateMutation({
 *   variables: {
 *      notificationTemplateId: // value for 'notificationTemplateId'
 *   },
 * });
 */
export function useArchiveNotificationTemplateMutation(baseOptions?: Apollo.MutationHookOptions<ArchiveNotificationTemplateMutation, ArchiveNotificationTemplateMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<ArchiveNotificationTemplateMutation, ArchiveNotificationTemplateMutationVariables>(ArchiveNotificationTemplateDocument, options);
      }
export type ArchiveNotificationTemplateMutationHookResult = ReturnType<typeof useArchiveNotificationTemplateMutation>;
export type ArchiveNotificationTemplateMutationResult = Apollo.MutationResult<ArchiveNotificationTemplateMutation>;
export type ArchiveNotificationTemplateMutationOptions = Apollo.BaseMutationOptions<ArchiveNotificationTemplateMutation, ArchiveNotificationTemplateMutationVariables>;
export const DeleteNotificationTemplateDocument = gql`
    mutation deleteNotificationTemplate($notificationTemplateId: ID!) {
  deleteNotificationTemplate(notificationTemplateId: $notificationTemplateId)
}
    `;
export type DeleteNotificationTemplateMutationFn = Apollo.MutationFunction<DeleteNotificationTemplateMutation, DeleteNotificationTemplateMutationVariables>;

/**
 * __useDeleteNotificationTemplateMutation__
 *
 * To run a mutation, you first call `useDeleteNotificationTemplateMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useDeleteNotificationTemplateMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [deleteNotificationTemplateMutation, { data, loading, error }] = useDeleteNotificationTemplateMutation({
 *   variables: {
 *      notificationTemplateId: // value for 'notificationTemplateId'
 *   },
 * });
 */
export function useDeleteNotificationTemplateMutation(baseOptions?: Apollo.MutationHookOptions<DeleteNotificationTemplateMutation, DeleteNotificationTemplateMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<DeleteNotificationTemplateMutation, DeleteNotificationTemplateMutationVariables>(DeleteNotificationTemplateDocument, options);
      }
export type DeleteNotificationTemplateMutationHookResult = ReturnType<typeof useDeleteNotificationTemplateMutation>;
export type DeleteNotificationTemplateMutationResult = Apollo.MutationResult<DeleteNotificationTemplateMutation>;
export type DeleteNotificationTemplateMutationOptions = Apollo.BaseMutationOptions<DeleteNotificationTemplateMutation, DeleteNotificationTemplateMutationVariables>;
export const CopyNotificationTemplateAcrossClinicDocument = gql`
    mutation copyNotificationTemplateAcrossClinic($notificationTemplateId: ID!, $destinationClinicId: ID!, $options: CopyNotificationTemplateAcrossClinicOptions!) {
  copyNotificationTemplateAcrossClinic(
    notificationTemplateId: $notificationTemplateId
    destinationClinicId: $destinationClinicId
    options: $options
  ) {
    ...NotificationTemplateFields
  }
}
    ${NotificationTemplateFieldsFragmentDoc}`;
export type CopyNotificationTemplateAcrossClinicMutationFn = Apollo.MutationFunction<CopyNotificationTemplateAcrossClinicMutation, CopyNotificationTemplateAcrossClinicMutationVariables>;

/**
 * __useCopyNotificationTemplateAcrossClinicMutation__
 *
 * To run a mutation, you first call `useCopyNotificationTemplateAcrossClinicMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useCopyNotificationTemplateAcrossClinicMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [copyNotificationTemplateAcrossClinicMutation, { data, loading, error }] = useCopyNotificationTemplateAcrossClinicMutation({
 *   variables: {
 *      notificationTemplateId: // value for 'notificationTemplateId'
 *      destinationClinicId: // value for 'destinationClinicId'
 *      options: // value for 'options'
 *   },
 * });
 */
export function useCopyNotificationTemplateAcrossClinicMutation(baseOptions?: Apollo.MutationHookOptions<CopyNotificationTemplateAcrossClinicMutation, CopyNotificationTemplateAcrossClinicMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<CopyNotificationTemplateAcrossClinicMutation, CopyNotificationTemplateAcrossClinicMutationVariables>(CopyNotificationTemplateAcrossClinicDocument, options);
      }
export type CopyNotificationTemplateAcrossClinicMutationHookResult = ReturnType<typeof useCopyNotificationTemplateAcrossClinicMutation>;
export type CopyNotificationTemplateAcrossClinicMutationResult = Apollo.MutationResult<CopyNotificationTemplateAcrossClinicMutation>;
export type CopyNotificationTemplateAcrossClinicMutationOptions = Apollo.BaseMutationOptions<CopyNotificationTemplateAcrossClinicMutation, CopyNotificationTemplateAcrossClinicMutationVariables>;
export const QueryMyUserNotificationsDocument = gql`
    query queryMyUserNotifications($page: NonNegativeInt, $pageSize: NonNegativeInt) {
  queryMyUserNotifications(page: $page, pageSize: $pageSize) {
    ...UserNotificationFields
  }
}
    ${UserNotificationFieldsFragmentDoc}`;

/**
 * __useQueryMyUserNotificationsQuery__
 *
 * To run a query within a React component, call `useQueryMyUserNotificationsQuery` and pass it any options that fit your needs.
 * When your component renders, `useQueryMyUserNotificationsQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useQueryMyUserNotificationsQuery({
 *   variables: {
 *      page: // value for 'page'
 *      pageSize: // value for 'pageSize'
 *   },
 * });
 */
export function useQueryMyUserNotificationsQuery(baseOptions?: Apollo.QueryHookOptions<QueryMyUserNotificationsQuery, QueryMyUserNotificationsQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<QueryMyUserNotificationsQuery, QueryMyUserNotificationsQueryVariables>(QueryMyUserNotificationsDocument, options);
      }
export function useQueryMyUserNotificationsLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<QueryMyUserNotificationsQuery, QueryMyUserNotificationsQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<QueryMyUserNotificationsQuery, QueryMyUserNotificationsQueryVariables>(QueryMyUserNotificationsDocument, options);
        }
export function useQueryMyUserNotificationsSuspenseQuery(baseOptions?: Apollo.SuspenseQueryHookOptions<QueryMyUserNotificationsQuery, QueryMyUserNotificationsQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useSuspenseQuery<QueryMyUserNotificationsQuery, QueryMyUserNotificationsQueryVariables>(QueryMyUserNotificationsDocument, options);
        }
export type QueryMyUserNotificationsQueryHookResult = ReturnType<typeof useQueryMyUserNotificationsQuery>;
export type QueryMyUserNotificationsLazyQueryHookResult = ReturnType<typeof useQueryMyUserNotificationsLazyQuery>;
export type QueryMyUserNotificationsSuspenseQueryHookResult = ReturnType<typeof useQueryMyUserNotificationsSuspenseQuery>;
export type QueryMyUserNotificationsQueryResult = Apollo.QueryResult<QueryMyUserNotificationsQuery, QueryMyUserNotificationsQueryVariables>;
export const CountMyUnreadUserNotificationsDocument = gql`
    query countMyUnreadUserNotifications {
  countMyUnreadUserNotifications
}
    `;

/**
 * __useCountMyUnreadUserNotificationsQuery__
 *
 * To run a query within a React component, call `useCountMyUnreadUserNotificationsQuery` and pass it any options that fit your needs.
 * When your component renders, `useCountMyUnreadUserNotificationsQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useCountMyUnreadUserNotificationsQuery({
 *   variables: {
 *   },
 * });
 */
export function useCountMyUnreadUserNotificationsQuery(baseOptions?: Apollo.QueryHookOptions<CountMyUnreadUserNotificationsQuery, CountMyUnreadUserNotificationsQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<CountMyUnreadUserNotificationsQuery, CountMyUnreadUserNotificationsQueryVariables>(CountMyUnreadUserNotificationsDocument, options);
      }
export function useCountMyUnreadUserNotificationsLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<CountMyUnreadUserNotificationsQuery, CountMyUnreadUserNotificationsQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<CountMyUnreadUserNotificationsQuery, CountMyUnreadUserNotificationsQueryVariables>(CountMyUnreadUserNotificationsDocument, options);
        }
export function useCountMyUnreadUserNotificationsSuspenseQuery(baseOptions?: Apollo.SuspenseQueryHookOptions<CountMyUnreadUserNotificationsQuery, CountMyUnreadUserNotificationsQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useSuspenseQuery<CountMyUnreadUserNotificationsQuery, CountMyUnreadUserNotificationsQueryVariables>(CountMyUnreadUserNotificationsDocument, options);
        }
export type CountMyUnreadUserNotificationsQueryHookResult = ReturnType<typeof useCountMyUnreadUserNotificationsQuery>;
export type CountMyUnreadUserNotificationsLazyQueryHookResult = ReturnType<typeof useCountMyUnreadUserNotificationsLazyQuery>;
export type CountMyUnreadUserNotificationsSuspenseQueryHookResult = ReturnType<typeof useCountMyUnreadUserNotificationsSuspenseQuery>;
export type CountMyUnreadUserNotificationsQueryResult = Apollo.QueryResult<CountMyUnreadUserNotificationsQuery, CountMyUnreadUserNotificationsQueryVariables>;
export const MarkUserNotificationAsReadDocument = gql`
    mutation markUserNotificationAsRead($id: ID!) {
  markUserNotificationAsRead(id: $id) {
    ...UserNotificationFields
  }
}
    ${UserNotificationFieldsFragmentDoc}`;
export type MarkUserNotificationAsReadMutationFn = Apollo.MutationFunction<MarkUserNotificationAsReadMutation, MarkUserNotificationAsReadMutationVariables>;

/**
 * __useMarkUserNotificationAsReadMutation__
 *
 * To run a mutation, you first call `useMarkUserNotificationAsReadMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useMarkUserNotificationAsReadMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [markUserNotificationAsReadMutation, { data, loading, error }] = useMarkUserNotificationAsReadMutation({
 *   variables: {
 *      id: // value for 'id'
 *   },
 * });
 */
export function useMarkUserNotificationAsReadMutation(baseOptions?: Apollo.MutationHookOptions<MarkUserNotificationAsReadMutation, MarkUserNotificationAsReadMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<MarkUserNotificationAsReadMutation, MarkUserNotificationAsReadMutationVariables>(MarkUserNotificationAsReadDocument, options);
      }
export type MarkUserNotificationAsReadMutationHookResult = ReturnType<typeof useMarkUserNotificationAsReadMutation>;
export type MarkUserNotificationAsReadMutationResult = Apollo.MutationResult<MarkUserNotificationAsReadMutation>;
export type MarkUserNotificationAsReadMutationOptions = Apollo.BaseMutationOptions<MarkUserNotificationAsReadMutation, MarkUserNotificationAsReadMutationVariables>;
export const MarkAllMyUserNotificationsAsReadDocument = gql`
    mutation markAllMyUserNotificationsAsRead {
  markAllMyUserNotificationsAsRead
}
    `;
export type MarkAllMyUserNotificationsAsReadMutationFn = Apollo.MutationFunction<MarkAllMyUserNotificationsAsReadMutation, MarkAllMyUserNotificationsAsReadMutationVariables>;

/**
 * __useMarkAllMyUserNotificationsAsReadMutation__
 *
 * To run a mutation, you first call `useMarkAllMyUserNotificationsAsReadMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useMarkAllMyUserNotificationsAsReadMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [markAllMyUserNotificationsAsReadMutation, { data, loading, error }] = useMarkAllMyUserNotificationsAsReadMutation({
 *   variables: {
 *   },
 * });
 */
export function useMarkAllMyUserNotificationsAsReadMutation(baseOptions?: Apollo.MutationHookOptions<MarkAllMyUserNotificationsAsReadMutation, MarkAllMyUserNotificationsAsReadMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<MarkAllMyUserNotificationsAsReadMutation, MarkAllMyUserNotificationsAsReadMutationVariables>(MarkAllMyUserNotificationsAsReadDocument, options);
      }
export type MarkAllMyUserNotificationsAsReadMutationHookResult = ReturnType<typeof useMarkAllMyUserNotificationsAsReadMutation>;
export type MarkAllMyUserNotificationsAsReadMutationResult = Apollo.MutationResult<MarkAllMyUserNotificationsAsReadMutation>;
export type MarkAllMyUserNotificationsAsReadMutationOptions = Apollo.BaseMutationOptions<MarkAllMyUserNotificationsAsReadMutation, MarkAllMyUserNotificationsAsReadMutationVariables>;
export const MarkMyUserNotificationsAsSeenDocument = gql`
    mutation markMyUserNotificationsAsSeen {
  markMyUserNotificationsAsSeen
}
    `;
export type MarkMyUserNotificationsAsSeenMutationFn = Apollo.MutationFunction<MarkMyUserNotificationsAsSeenMutation, MarkMyUserNotificationsAsSeenMutationVariables>;

/**
 * __useMarkMyUserNotificationsAsSeenMutation__
 *
 * To run a mutation, you first call `useMarkMyUserNotificationsAsSeenMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useMarkMyUserNotificationsAsSeenMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [markMyUserNotificationsAsSeenMutation, { data, loading, error }] = useMarkMyUserNotificationsAsSeenMutation({
 *   variables: {
 *   },
 * });
 */
export function useMarkMyUserNotificationsAsSeenMutation(baseOptions?: Apollo.MutationHookOptions<MarkMyUserNotificationsAsSeenMutation, MarkMyUserNotificationsAsSeenMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<MarkMyUserNotificationsAsSeenMutation, MarkMyUserNotificationsAsSeenMutationVariables>(MarkMyUserNotificationsAsSeenDocument, options);
      }
export type MarkMyUserNotificationsAsSeenMutationHookResult = ReturnType<typeof useMarkMyUserNotificationsAsSeenMutation>;
export type MarkMyUserNotificationsAsSeenMutationResult = Apollo.MutationResult<MarkMyUserNotificationsAsSeenMutation>;
export type MarkMyUserNotificationsAsSeenMutationOptions = Apollo.BaseMutationOptions<MarkMyUserNotificationsAsSeenMutation, MarkMyUserNotificationsAsSeenMutationVariables>;
export const DeleteUserNotificationDocument = gql`
    mutation deleteUserNotification($id: ID!) {
  deleteUserNotification(id: $id)
}
    `;
export type DeleteUserNotificationMutationFn = Apollo.MutationFunction<DeleteUserNotificationMutation, DeleteUserNotificationMutationVariables>;

/**
 * __useDeleteUserNotificationMutation__
 *
 * To run a mutation, you first call `useDeleteUserNotificationMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useDeleteUserNotificationMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [deleteUserNotificationMutation, { data, loading, error }] = useDeleteUserNotificationMutation({
 *   variables: {
 *      id: // value for 'id'
 *   },
 * });
 */
export function useDeleteUserNotificationMutation(baseOptions?: Apollo.MutationHookOptions<DeleteUserNotificationMutation, DeleteUserNotificationMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<DeleteUserNotificationMutation, DeleteUserNotificationMutationVariables>(DeleteUserNotificationDocument, options);
      }
export type DeleteUserNotificationMutationHookResult = ReturnType<typeof useDeleteUserNotificationMutation>;
export type DeleteUserNotificationMutationResult = Apollo.MutationResult<DeleteUserNotificationMutation>;
export type DeleteUserNotificationMutationOptions = Apollo.BaseMutationOptions<DeleteUserNotificationMutation, DeleteUserNotificationMutationVariables>;
export const GetOrganizationAnalyticsDocument = gql`
    query getOrganizationAnalytics($organizationId: ID!, $fromDate: NonNegativeInt!, $toDate: NonNegativeInt!) {
  organizationAnalytics(
    organizationId: $organizationId
    fromDate: $fromDate
    toDate: $toDate
  ) {
    ...OrganizationAnalyticsFields
  }
}
    ${OrganizationAnalyticsFieldsFragmentDoc}`;

/**
 * __useGetOrganizationAnalyticsQuery__
 *
 * To run a query within a React component, call `useGetOrganizationAnalyticsQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetOrganizationAnalyticsQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetOrganizationAnalyticsQuery({
 *   variables: {
 *      organizationId: // value for 'organizationId'
 *      fromDate: // value for 'fromDate'
 *      toDate: // value for 'toDate'
 *   },
 * });
 */
export function useGetOrganizationAnalyticsQuery(baseOptions: Apollo.QueryHookOptions<GetOrganizationAnalyticsQuery, GetOrganizationAnalyticsQueryVariables> & ({ variables: GetOrganizationAnalyticsQueryVariables; skip?: boolean; } | { skip: boolean; }) ) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<GetOrganizationAnalyticsQuery, GetOrganizationAnalyticsQueryVariables>(GetOrganizationAnalyticsDocument, options);
      }
export function useGetOrganizationAnalyticsLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<GetOrganizationAnalyticsQuery, GetOrganizationAnalyticsQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<GetOrganizationAnalyticsQuery, GetOrganizationAnalyticsQueryVariables>(GetOrganizationAnalyticsDocument, options);
        }
export function useGetOrganizationAnalyticsSuspenseQuery(baseOptions?: Apollo.SuspenseQueryHookOptions<GetOrganizationAnalyticsQuery, GetOrganizationAnalyticsQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useSuspenseQuery<GetOrganizationAnalyticsQuery, GetOrganizationAnalyticsQueryVariables>(GetOrganizationAnalyticsDocument, options);
        }
export type GetOrganizationAnalyticsQueryHookResult = ReturnType<typeof useGetOrganizationAnalyticsQuery>;
export type GetOrganizationAnalyticsLazyQueryHookResult = ReturnType<typeof useGetOrganizationAnalyticsLazyQuery>;
export type GetOrganizationAnalyticsSuspenseQueryHookResult = ReturnType<typeof useGetOrganizationAnalyticsSuspenseQuery>;
export type GetOrganizationAnalyticsQueryResult = Apollo.QueryResult<GetOrganizationAnalyticsQuery, GetOrganizationAnalyticsQueryVariables>;
export const GetOrganizationAnalyticsNumbersDocument = gql`
    query getOrganizationAnalyticsNumbers($organizationId: ID!, $fromDate: NonNegativeInt!, $toDate: NonNegativeInt!) {
  organizationAnalyticsNumbers(
    organizationId: $organizationId
    fromDate: $fromDate
    toDate: $toDate
  ) {
    ...OrganizationAnalyticsNumbersFields
  }
}
    ${OrganizationAnalyticsNumbersFieldsFragmentDoc}`;

/**
 * __useGetOrganizationAnalyticsNumbersQuery__
 *
 * To run a query within a React component, call `useGetOrganizationAnalyticsNumbersQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetOrganizationAnalyticsNumbersQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetOrganizationAnalyticsNumbersQuery({
 *   variables: {
 *      organizationId: // value for 'organizationId'
 *      fromDate: // value for 'fromDate'
 *      toDate: // value for 'toDate'
 *   },
 * });
 */
export function useGetOrganizationAnalyticsNumbersQuery(baseOptions: Apollo.QueryHookOptions<GetOrganizationAnalyticsNumbersQuery, GetOrganizationAnalyticsNumbersQueryVariables> & ({ variables: GetOrganizationAnalyticsNumbersQueryVariables; skip?: boolean; } | { skip: boolean; }) ) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<GetOrganizationAnalyticsNumbersQuery, GetOrganizationAnalyticsNumbersQueryVariables>(GetOrganizationAnalyticsNumbersDocument, options);
      }
export function useGetOrganizationAnalyticsNumbersLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<GetOrganizationAnalyticsNumbersQuery, GetOrganizationAnalyticsNumbersQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<GetOrganizationAnalyticsNumbersQuery, GetOrganizationAnalyticsNumbersQueryVariables>(GetOrganizationAnalyticsNumbersDocument, options);
        }
export function useGetOrganizationAnalyticsNumbersSuspenseQuery(baseOptions?: Apollo.SuspenseQueryHookOptions<GetOrganizationAnalyticsNumbersQuery, GetOrganizationAnalyticsNumbersQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useSuspenseQuery<GetOrganizationAnalyticsNumbersQuery, GetOrganizationAnalyticsNumbersQueryVariables>(GetOrganizationAnalyticsNumbersDocument, options);
        }
export type GetOrganizationAnalyticsNumbersQueryHookResult = ReturnType<typeof useGetOrganizationAnalyticsNumbersQuery>;
export type GetOrganizationAnalyticsNumbersLazyQueryHookResult = ReturnType<typeof useGetOrganizationAnalyticsNumbersLazyQuery>;
export type GetOrganizationAnalyticsNumbersSuspenseQueryHookResult = ReturnType<typeof useGetOrganizationAnalyticsNumbersSuspenseQuery>;
export type GetOrganizationAnalyticsNumbersQueryResult = Apollo.QueryResult<GetOrganizationAnalyticsNumbersQuery, GetOrganizationAnalyticsNumbersQueryVariables>;
export const GetOrganizationScheduleEfficiencyDocument = gql`
    query getOrganizationScheduleEfficiency($organizationId: ID!, $fromDate: NonNegativeInt!, $toDate: NonNegativeInt!) {
  organizationScheduleEfficiency(
    organizationId: $organizationId
    fromDate: $fromDate
    toDate: $toDate
  ) {
    average
    per_clinic {
      clinic {
        id
        name
      }
      schedule_efficiency
    }
  }
}
    `;

/**
 * __useGetOrganizationScheduleEfficiencyQuery__
 *
 * To run a query within a React component, call `useGetOrganizationScheduleEfficiencyQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetOrganizationScheduleEfficiencyQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetOrganizationScheduleEfficiencyQuery({
 *   variables: {
 *      organizationId: // value for 'organizationId'
 *      fromDate: // value for 'fromDate'
 *      toDate: // value for 'toDate'
 *   },
 * });
 */
export function useGetOrganizationScheduleEfficiencyQuery(baseOptions: Apollo.QueryHookOptions<GetOrganizationScheduleEfficiencyQuery, GetOrganizationScheduleEfficiencyQueryVariables> & ({ variables: GetOrganizationScheduleEfficiencyQueryVariables; skip?: boolean; } | { skip: boolean; }) ) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<GetOrganizationScheduleEfficiencyQuery, GetOrganizationScheduleEfficiencyQueryVariables>(GetOrganizationScheduleEfficiencyDocument, options);
      }
export function useGetOrganizationScheduleEfficiencyLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<GetOrganizationScheduleEfficiencyQuery, GetOrganizationScheduleEfficiencyQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<GetOrganizationScheduleEfficiencyQuery, GetOrganizationScheduleEfficiencyQueryVariables>(GetOrganizationScheduleEfficiencyDocument, options);
        }
export function useGetOrganizationScheduleEfficiencySuspenseQuery(baseOptions?: Apollo.SuspenseQueryHookOptions<GetOrganizationScheduleEfficiencyQuery, GetOrganizationScheduleEfficiencyQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useSuspenseQuery<GetOrganizationScheduleEfficiencyQuery, GetOrganizationScheduleEfficiencyQueryVariables>(GetOrganizationScheduleEfficiencyDocument, options);
        }
export type GetOrganizationScheduleEfficiencyQueryHookResult = ReturnType<typeof useGetOrganizationScheduleEfficiencyQuery>;
export type GetOrganizationScheduleEfficiencyLazyQueryHookResult = ReturnType<typeof useGetOrganizationScheduleEfficiencyLazyQuery>;
export type GetOrganizationScheduleEfficiencySuspenseQueryHookResult = ReturnType<typeof useGetOrganizationScheduleEfficiencySuspenseQuery>;
export type GetOrganizationScheduleEfficiencyQueryResult = Apollo.QueryResult<GetOrganizationScheduleEfficiencyQuery, GetOrganizationScheduleEfficiencyQueryVariables>;
export const GetOrganizationAnalyticsNumbersByMonthsDocument = gql`
    query getOrganizationAnalyticsNumbersByMonths($organizationId: ID!, $numMonths: NonNegativeInt!) {
  getAnalyticsNumbersByMonthsForOrganization(
    organizationId: $organizationId
    numMonths: $numMonths
  ) {
    clinic {
      id
      name
    }
    analytic_numbers {
      analytics {
        ...AnalyticsNumbersFields
      }
      month
      year
    }
  }
}
    ${AnalyticsNumbersFieldsFragmentDoc}`;

/**
 * __useGetOrganizationAnalyticsNumbersByMonthsQuery__
 *
 * To run a query within a React component, call `useGetOrganizationAnalyticsNumbersByMonthsQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetOrganizationAnalyticsNumbersByMonthsQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetOrganizationAnalyticsNumbersByMonthsQuery({
 *   variables: {
 *      organizationId: // value for 'organizationId'
 *      numMonths: // value for 'numMonths'
 *   },
 * });
 */
export function useGetOrganizationAnalyticsNumbersByMonthsQuery(baseOptions: Apollo.QueryHookOptions<GetOrganizationAnalyticsNumbersByMonthsQuery, GetOrganizationAnalyticsNumbersByMonthsQueryVariables> & ({ variables: GetOrganizationAnalyticsNumbersByMonthsQueryVariables; skip?: boolean; } | { skip: boolean; }) ) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<GetOrganizationAnalyticsNumbersByMonthsQuery, GetOrganizationAnalyticsNumbersByMonthsQueryVariables>(GetOrganizationAnalyticsNumbersByMonthsDocument, options);
      }
export function useGetOrganizationAnalyticsNumbersByMonthsLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<GetOrganizationAnalyticsNumbersByMonthsQuery, GetOrganizationAnalyticsNumbersByMonthsQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<GetOrganizationAnalyticsNumbersByMonthsQuery, GetOrganizationAnalyticsNumbersByMonthsQueryVariables>(GetOrganizationAnalyticsNumbersByMonthsDocument, options);
        }
export function useGetOrganizationAnalyticsNumbersByMonthsSuspenseQuery(baseOptions?: Apollo.SuspenseQueryHookOptions<GetOrganizationAnalyticsNumbersByMonthsQuery, GetOrganizationAnalyticsNumbersByMonthsQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useSuspenseQuery<GetOrganizationAnalyticsNumbersByMonthsQuery, GetOrganizationAnalyticsNumbersByMonthsQueryVariables>(GetOrganizationAnalyticsNumbersByMonthsDocument, options);
        }
export type GetOrganizationAnalyticsNumbersByMonthsQueryHookResult = ReturnType<typeof useGetOrganizationAnalyticsNumbersByMonthsQuery>;
export type GetOrganizationAnalyticsNumbersByMonthsLazyQueryHookResult = ReturnType<typeof useGetOrganizationAnalyticsNumbersByMonthsLazyQuery>;
export type GetOrganizationAnalyticsNumbersByMonthsSuspenseQueryHookResult = ReturnType<typeof useGetOrganizationAnalyticsNumbersByMonthsSuspenseQuery>;
export type GetOrganizationAnalyticsNumbersByMonthsQueryResult = Apollo.QueryResult<GetOrganizationAnalyticsNumbersByMonthsQuery, GetOrganizationAnalyticsNumbersByMonthsQueryVariables>;
export const GetOrganizationRevenueByMonthsDocument = gql`
    query getOrganizationRevenueByMonths($organizationId: ID!, $numMonths: NonNegativeInt!) {
  getRevenueByMonthsForOrganization(
    organizationId: $organizationId
    numMonths: $numMonths
  ) {
    clinic {
      id
      name
    }
    revenue {
      revenue
      month
      year
    }
  }
}
    `;

/**
 * __useGetOrganizationRevenueByMonthsQuery__
 *
 * To run a query within a React component, call `useGetOrganizationRevenueByMonthsQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetOrganizationRevenueByMonthsQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetOrganizationRevenueByMonthsQuery({
 *   variables: {
 *      organizationId: // value for 'organizationId'
 *      numMonths: // value for 'numMonths'
 *   },
 * });
 */
export function useGetOrganizationRevenueByMonthsQuery(baseOptions: Apollo.QueryHookOptions<GetOrganizationRevenueByMonthsQuery, GetOrganizationRevenueByMonthsQueryVariables> & ({ variables: GetOrganizationRevenueByMonthsQueryVariables; skip?: boolean; } | { skip: boolean; }) ) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<GetOrganizationRevenueByMonthsQuery, GetOrganizationRevenueByMonthsQueryVariables>(GetOrganizationRevenueByMonthsDocument, options);
      }
export function useGetOrganizationRevenueByMonthsLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<GetOrganizationRevenueByMonthsQuery, GetOrganizationRevenueByMonthsQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<GetOrganizationRevenueByMonthsQuery, GetOrganizationRevenueByMonthsQueryVariables>(GetOrganizationRevenueByMonthsDocument, options);
        }
export function useGetOrganizationRevenueByMonthsSuspenseQuery(baseOptions?: Apollo.SuspenseQueryHookOptions<GetOrganizationRevenueByMonthsQuery, GetOrganizationRevenueByMonthsQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useSuspenseQuery<GetOrganizationRevenueByMonthsQuery, GetOrganizationRevenueByMonthsQueryVariables>(GetOrganizationRevenueByMonthsDocument, options);
        }
export type GetOrganizationRevenueByMonthsQueryHookResult = ReturnType<typeof useGetOrganizationRevenueByMonthsQuery>;
export type GetOrganizationRevenueByMonthsLazyQueryHookResult = ReturnType<typeof useGetOrganizationRevenueByMonthsLazyQuery>;
export type GetOrganizationRevenueByMonthsSuspenseQueryHookResult = ReturnType<typeof useGetOrganizationRevenueByMonthsSuspenseQuery>;
export type GetOrganizationRevenueByMonthsQueryResult = Apollo.QueryResult<GetOrganizationRevenueByMonthsQuery, GetOrganizationRevenueByMonthsQueryVariables>;
export const GetOrganizationDocument = gql`
    query getOrganization($id: ID!) {
  organization(id: $id) {
    ...OrganizationFields
  }
}
    ${OrganizationFieldsFragmentDoc}`;

/**
 * __useGetOrganizationQuery__
 *
 * To run a query within a React component, call `useGetOrganizationQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetOrganizationQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetOrganizationQuery({
 *   variables: {
 *      id: // value for 'id'
 *   },
 * });
 */
export function useGetOrganizationQuery(baseOptions: Apollo.QueryHookOptions<GetOrganizationQuery, GetOrganizationQueryVariables> & ({ variables: GetOrganizationQueryVariables; skip?: boolean; } | { skip: boolean; }) ) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<GetOrganizationQuery, GetOrganizationQueryVariables>(GetOrganizationDocument, options);
      }
export function useGetOrganizationLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<GetOrganizationQuery, GetOrganizationQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<GetOrganizationQuery, GetOrganizationQueryVariables>(GetOrganizationDocument, options);
        }
export function useGetOrganizationSuspenseQuery(baseOptions?: Apollo.SuspenseQueryHookOptions<GetOrganizationQuery, GetOrganizationQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useSuspenseQuery<GetOrganizationQuery, GetOrganizationQueryVariables>(GetOrganizationDocument, options);
        }
export type GetOrganizationQueryHookResult = ReturnType<typeof useGetOrganizationQuery>;
export type GetOrganizationLazyQueryHookResult = ReturnType<typeof useGetOrganizationLazyQuery>;
export type GetOrganizationSuspenseQueryHookResult = ReturnType<typeof useGetOrganizationSuspenseQuery>;
export type GetOrganizationQueryResult = Apollo.QueryResult<GetOrganizationQuery, GetOrganizationQueryVariables>;
export const QueryOrganizationsDocument = gql`
    query queryOrganizations($where: [QueryInput!], $page: NonNegativeInt, $pageSize: NonNegativeInt, $orderBy: OrderByInput) {
  queryOrganizations(
    where: $where
    page: $page
    pageSize: $pageSize
    orderBy: $orderBy
  ) {
    ...OrganizationFields
  }
}
    ${OrganizationFieldsFragmentDoc}`;

/**
 * __useQueryOrganizationsQuery__
 *
 * To run a query within a React component, call `useQueryOrganizationsQuery` and pass it any options that fit your needs.
 * When your component renders, `useQueryOrganizationsQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useQueryOrganizationsQuery({
 *   variables: {
 *      where: // value for 'where'
 *      page: // value for 'page'
 *      pageSize: // value for 'pageSize'
 *      orderBy: // value for 'orderBy'
 *   },
 * });
 */
export function useQueryOrganizationsQuery(baseOptions?: Apollo.QueryHookOptions<QueryOrganizationsQuery, QueryOrganizationsQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<QueryOrganizationsQuery, QueryOrganizationsQueryVariables>(QueryOrganizationsDocument, options);
      }
export function useQueryOrganizationsLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<QueryOrganizationsQuery, QueryOrganizationsQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<QueryOrganizationsQuery, QueryOrganizationsQueryVariables>(QueryOrganizationsDocument, options);
        }
export function useQueryOrganizationsSuspenseQuery(baseOptions?: Apollo.SuspenseQueryHookOptions<QueryOrganizationsQuery, QueryOrganizationsQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useSuspenseQuery<QueryOrganizationsQuery, QueryOrganizationsQueryVariables>(QueryOrganizationsDocument, options);
        }
export type QueryOrganizationsQueryHookResult = ReturnType<typeof useQueryOrganizationsQuery>;
export type QueryOrganizationsLazyQueryHookResult = ReturnType<typeof useQueryOrganizationsLazyQuery>;
export type QueryOrganizationsSuspenseQueryHookResult = ReturnType<typeof useQueryOrganizationsSuspenseQuery>;
export type QueryOrganizationsQueryResult = Apollo.QueryResult<QueryOrganizationsQuery, QueryOrganizationsQueryVariables>;
export const CountOrganizationsDocument = gql`
    query countOrganizations($where: [QueryInput!]) {
  countOrganizations(where: $where)
}
    `;

/**
 * __useCountOrganizationsQuery__
 *
 * To run a query within a React component, call `useCountOrganizationsQuery` and pass it any options that fit your needs.
 * When your component renders, `useCountOrganizationsQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useCountOrganizationsQuery({
 *   variables: {
 *      where: // value for 'where'
 *   },
 * });
 */
export function useCountOrganizationsQuery(baseOptions?: Apollo.QueryHookOptions<CountOrganizationsQuery, CountOrganizationsQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<CountOrganizationsQuery, CountOrganizationsQueryVariables>(CountOrganizationsDocument, options);
      }
export function useCountOrganizationsLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<CountOrganizationsQuery, CountOrganizationsQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<CountOrganizationsQuery, CountOrganizationsQueryVariables>(CountOrganizationsDocument, options);
        }
export function useCountOrganizationsSuspenseQuery(baseOptions?: Apollo.SuspenseQueryHookOptions<CountOrganizationsQuery, CountOrganizationsQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useSuspenseQuery<CountOrganizationsQuery, CountOrganizationsQueryVariables>(CountOrganizationsDocument, options);
        }
export type CountOrganizationsQueryHookResult = ReturnType<typeof useCountOrganizationsQuery>;
export type CountOrganizationsLazyQueryHookResult = ReturnType<typeof useCountOrganizationsLazyQuery>;
export type CountOrganizationsSuspenseQueryHookResult = ReturnType<typeof useCountOrganizationsSuspenseQuery>;
export type CountOrganizationsQueryResult = Apollo.QueryResult<CountOrganizationsQuery, CountOrganizationsQueryVariables>;
export const CreateOrganizationDocument = gql`
    mutation createOrganization($data: CreateOrganizationInput!) {
  createOrganization(data: $data) {
    ...OrganizationFields
  }
}
    ${OrganizationFieldsFragmentDoc}`;
export type CreateOrganizationMutationFn = Apollo.MutationFunction<CreateOrganizationMutation, CreateOrganizationMutationVariables>;

/**
 * __useCreateOrganizationMutation__
 *
 * To run a mutation, you first call `useCreateOrganizationMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useCreateOrganizationMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [createOrganizationMutation, { data, loading, error }] = useCreateOrganizationMutation({
 *   variables: {
 *      data: // value for 'data'
 *   },
 * });
 */
export function useCreateOrganizationMutation(baseOptions?: Apollo.MutationHookOptions<CreateOrganizationMutation, CreateOrganizationMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<CreateOrganizationMutation, CreateOrganizationMutationVariables>(CreateOrganizationDocument, options);
      }
export type CreateOrganizationMutationHookResult = ReturnType<typeof useCreateOrganizationMutation>;
export type CreateOrganizationMutationResult = Apollo.MutationResult<CreateOrganizationMutation>;
export type CreateOrganizationMutationOptions = Apollo.BaseMutationOptions<CreateOrganizationMutation, CreateOrganizationMutationVariables>;
export const UpdateOrganizationDocument = gql`
    mutation updateOrganization($id: ID!, $data: UpdateOrganizationInput!) {
  updateOrganization(id: $id, data: $data) {
    ...OrganizationFields
  }
}
    ${OrganizationFieldsFragmentDoc}`;
export type UpdateOrganizationMutationFn = Apollo.MutationFunction<UpdateOrganizationMutation, UpdateOrganizationMutationVariables>;

/**
 * __useUpdateOrganizationMutation__
 *
 * To run a mutation, you first call `useUpdateOrganizationMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useUpdateOrganizationMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [updateOrganizationMutation, { data, loading, error }] = useUpdateOrganizationMutation({
 *   variables: {
 *      id: // value for 'id'
 *      data: // value for 'data'
 *   },
 * });
 */
export function useUpdateOrganizationMutation(baseOptions?: Apollo.MutationHookOptions<UpdateOrganizationMutation, UpdateOrganizationMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<UpdateOrganizationMutation, UpdateOrganizationMutationVariables>(UpdateOrganizationDocument, options);
      }
export type UpdateOrganizationMutationHookResult = ReturnType<typeof useUpdateOrganizationMutation>;
export type UpdateOrganizationMutationResult = Apollo.MutationResult<UpdateOrganizationMutation>;
export type UpdateOrganizationMutationOptions = Apollo.BaseMutationOptions<UpdateOrganizationMutation, UpdateOrganizationMutationVariables>;
export const DeleteOrganizationDocument = gql`
    mutation deleteOrganization($id: ID!) {
  deleteOrganization(id: $id)
}
    `;
export type DeleteOrganizationMutationFn = Apollo.MutationFunction<DeleteOrganizationMutation, DeleteOrganizationMutationVariables>;

/**
 * __useDeleteOrganizationMutation__
 *
 * To run a mutation, you first call `useDeleteOrganizationMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useDeleteOrganizationMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [deleteOrganizationMutation, { data, loading, error }] = useDeleteOrganizationMutation({
 *   variables: {
 *      id: // value for 'id'
 *   },
 * });
 */
export function useDeleteOrganizationMutation(baseOptions?: Apollo.MutationHookOptions<DeleteOrganizationMutation, DeleteOrganizationMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<DeleteOrganizationMutation, DeleteOrganizationMutationVariables>(DeleteOrganizationDocument, options);
      }
export type DeleteOrganizationMutationHookResult = ReturnType<typeof useDeleteOrganizationMutation>;
export type DeleteOrganizationMutationResult = Apollo.MutationResult<DeleteOrganizationMutation>;
export type DeleteOrganizationMutationOptions = Apollo.BaseMutationOptions<DeleteOrganizationMutation, DeleteOrganizationMutationVariables>;
export const GetPatientDocument = gql`
    query getPatient($id: ID!) {
  patient(id: $id) {
    ...PatientFields
  }
}
    ${PatientFieldsFragmentDoc}`;

/**
 * __useGetPatientQuery__
 *
 * To run a query within a React component, call `useGetPatientQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetPatientQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetPatientQuery({
 *   variables: {
 *      id: // value for 'id'
 *   },
 * });
 */
export function useGetPatientQuery(baseOptions: Apollo.QueryHookOptions<GetPatientQuery, GetPatientQueryVariables> & ({ variables: GetPatientQueryVariables; skip?: boolean; } | { skip: boolean; }) ) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<GetPatientQuery, GetPatientQueryVariables>(GetPatientDocument, options);
      }
export function useGetPatientLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<GetPatientQuery, GetPatientQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<GetPatientQuery, GetPatientQueryVariables>(GetPatientDocument, options);
        }
export function useGetPatientSuspenseQuery(baseOptions?: Apollo.SuspenseQueryHookOptions<GetPatientQuery, GetPatientQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useSuspenseQuery<GetPatientQuery, GetPatientQueryVariables>(GetPatientDocument, options);
        }
export type GetPatientQueryHookResult = ReturnType<typeof useGetPatientQuery>;
export type GetPatientLazyQueryHookResult = ReturnType<typeof useGetPatientLazyQuery>;
export type GetPatientSuspenseQueryHookResult = ReturnType<typeof useGetPatientSuspenseQuery>;
export type GetPatientQueryResult = Apollo.QueryResult<GetPatientQuery, GetPatientQueryVariables>;
export const GetPatientNameDocument = gql`
    query getPatientName($id: ID!) {
  patient(id: $id) {
    id
    name
    gender
    last_appointment {
      clinician {
        name
        display_name
      }
    }
  }
}
    `;

/**
 * __useGetPatientNameQuery__
 *
 * To run a query within a React component, call `useGetPatientNameQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetPatientNameQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetPatientNameQuery({
 *   variables: {
 *      id: // value for 'id'
 *   },
 * });
 */
export function useGetPatientNameQuery(baseOptions: Apollo.QueryHookOptions<GetPatientNameQuery, GetPatientNameQueryVariables> & ({ variables: GetPatientNameQueryVariables; skip?: boolean; } | { skip: boolean; }) ) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<GetPatientNameQuery, GetPatientNameQueryVariables>(GetPatientNameDocument, options);
      }
export function useGetPatientNameLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<GetPatientNameQuery, GetPatientNameQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<GetPatientNameQuery, GetPatientNameQueryVariables>(GetPatientNameDocument, options);
        }
export function useGetPatientNameSuspenseQuery(baseOptions?: Apollo.SuspenseQueryHookOptions<GetPatientNameQuery, GetPatientNameQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useSuspenseQuery<GetPatientNameQuery, GetPatientNameQueryVariables>(GetPatientNameDocument, options);
        }
export type GetPatientNameQueryHookResult = ReturnType<typeof useGetPatientNameQuery>;
export type GetPatientNameLazyQueryHookResult = ReturnType<typeof useGetPatientNameLazyQuery>;
export type GetPatientNameSuspenseQueryHookResult = ReturnType<typeof useGetPatientNameSuspenseQuery>;
export type GetPatientNameQueryResult = Apollo.QueryResult<GetPatientNameQuery, GetPatientNameQueryVariables>;
export const GetPatientsByClientDocument = gql`
    query getPatientsByClient($clientId: ID!) {
  getPatientsByClient(clientId: $clientId) {
    ...PatientFields
  }
}
    ${PatientFieldsFragmentDoc}`;

/**
 * __useGetPatientsByClientQuery__
 *
 * To run a query within a React component, call `useGetPatientsByClientQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetPatientsByClientQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetPatientsByClientQuery({
 *   variables: {
 *      clientId: // value for 'clientId'
 *   },
 * });
 */
export function useGetPatientsByClientQuery(baseOptions: Apollo.QueryHookOptions<GetPatientsByClientQuery, GetPatientsByClientQueryVariables> & ({ variables: GetPatientsByClientQueryVariables; skip?: boolean; } | { skip: boolean; }) ) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<GetPatientsByClientQuery, GetPatientsByClientQueryVariables>(GetPatientsByClientDocument, options);
      }
export function useGetPatientsByClientLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<GetPatientsByClientQuery, GetPatientsByClientQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<GetPatientsByClientQuery, GetPatientsByClientQueryVariables>(GetPatientsByClientDocument, options);
        }
export function useGetPatientsByClientSuspenseQuery(baseOptions?: Apollo.SuspenseQueryHookOptions<GetPatientsByClientQuery, GetPatientsByClientQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useSuspenseQuery<GetPatientsByClientQuery, GetPatientsByClientQueryVariables>(GetPatientsByClientDocument, options);
        }
export type GetPatientsByClientQueryHookResult = ReturnType<typeof useGetPatientsByClientQuery>;
export type GetPatientsByClientLazyQueryHookResult = ReturnType<typeof useGetPatientsByClientLazyQuery>;
export type GetPatientsByClientSuspenseQueryHookResult = ReturnType<typeof useGetPatientsByClientSuspenseQuery>;
export type GetPatientsByClientQueryResult = Apollo.QueryResult<GetPatientsByClientQuery, GetPatientsByClientQueryVariables>;
export const GetPatientsByClientsDocument = gql`
    query getPatientsByClients($clientIds: [ID!]!) {
  getPatientsByClients(clientIds: $clientIds) {
    ...PatientFields
  }
}
    ${PatientFieldsFragmentDoc}`;

/**
 * __useGetPatientsByClientsQuery__
 *
 * To run a query within a React component, call `useGetPatientsByClientsQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetPatientsByClientsQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetPatientsByClientsQuery({
 *   variables: {
 *      clientIds: // value for 'clientIds'
 *   },
 * });
 */
export function useGetPatientsByClientsQuery(baseOptions: Apollo.QueryHookOptions<GetPatientsByClientsQuery, GetPatientsByClientsQueryVariables> & ({ variables: GetPatientsByClientsQueryVariables; skip?: boolean; } | { skip: boolean; }) ) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<GetPatientsByClientsQuery, GetPatientsByClientsQueryVariables>(GetPatientsByClientsDocument, options);
      }
export function useGetPatientsByClientsLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<GetPatientsByClientsQuery, GetPatientsByClientsQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<GetPatientsByClientsQuery, GetPatientsByClientsQueryVariables>(GetPatientsByClientsDocument, options);
        }
export function useGetPatientsByClientsSuspenseQuery(baseOptions?: Apollo.SuspenseQueryHookOptions<GetPatientsByClientsQuery, GetPatientsByClientsQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useSuspenseQuery<GetPatientsByClientsQuery, GetPatientsByClientsQueryVariables>(GetPatientsByClientsDocument, options);
        }
export type GetPatientsByClientsQueryHookResult = ReturnType<typeof useGetPatientsByClientsQuery>;
export type GetPatientsByClientsLazyQueryHookResult = ReturnType<typeof useGetPatientsByClientsLazyQuery>;
export type GetPatientsByClientsSuspenseQueryHookResult = ReturnType<typeof useGetPatientsByClientsSuspenseQuery>;
export type GetPatientsByClientsQueryResult = Apollo.QueryResult<GetPatientsByClientsQuery, GetPatientsByClientsQueryVariables>;
export const GetPatientsWithoutRescheduledAppointmentsForTimeRangeDocument = gql`
    query getPatientsWithoutRescheduledAppointmentsForTimeRange($clinicId: ID!, $start_time: NonNegativeInt!, $end_time: NonNegativeInt!) {
  getPatientsWithoutRescheduledAppointmentsForTimeRange(
    clinicId: $clinicId
    start_time: $start_time
    end_time: $end_time
  ) {
    ...PatientFields
  }
}
    ${PatientFieldsFragmentDoc}`;

/**
 * __useGetPatientsWithoutRescheduledAppointmentsForTimeRangeQuery__
 *
 * To run a query within a React component, call `useGetPatientsWithoutRescheduledAppointmentsForTimeRangeQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetPatientsWithoutRescheduledAppointmentsForTimeRangeQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetPatientsWithoutRescheduledAppointmentsForTimeRangeQuery({
 *   variables: {
 *      clinicId: // value for 'clinicId'
 *      start_time: // value for 'start_time'
 *      end_time: // value for 'end_time'
 *   },
 * });
 */
export function useGetPatientsWithoutRescheduledAppointmentsForTimeRangeQuery(baseOptions: Apollo.QueryHookOptions<GetPatientsWithoutRescheduledAppointmentsForTimeRangeQuery, GetPatientsWithoutRescheduledAppointmentsForTimeRangeQueryVariables> & ({ variables: GetPatientsWithoutRescheduledAppointmentsForTimeRangeQueryVariables; skip?: boolean; } | { skip: boolean; }) ) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<GetPatientsWithoutRescheduledAppointmentsForTimeRangeQuery, GetPatientsWithoutRescheduledAppointmentsForTimeRangeQueryVariables>(GetPatientsWithoutRescheduledAppointmentsForTimeRangeDocument, options);
      }
export function useGetPatientsWithoutRescheduledAppointmentsForTimeRangeLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<GetPatientsWithoutRescheduledAppointmentsForTimeRangeQuery, GetPatientsWithoutRescheduledAppointmentsForTimeRangeQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<GetPatientsWithoutRescheduledAppointmentsForTimeRangeQuery, GetPatientsWithoutRescheduledAppointmentsForTimeRangeQueryVariables>(GetPatientsWithoutRescheduledAppointmentsForTimeRangeDocument, options);
        }
export function useGetPatientsWithoutRescheduledAppointmentsForTimeRangeSuspenseQuery(baseOptions?: Apollo.SuspenseQueryHookOptions<GetPatientsWithoutRescheduledAppointmentsForTimeRangeQuery, GetPatientsWithoutRescheduledAppointmentsForTimeRangeQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useSuspenseQuery<GetPatientsWithoutRescheduledAppointmentsForTimeRangeQuery, GetPatientsWithoutRescheduledAppointmentsForTimeRangeQueryVariables>(GetPatientsWithoutRescheduledAppointmentsForTimeRangeDocument, options);
        }
export type GetPatientsWithoutRescheduledAppointmentsForTimeRangeQueryHookResult = ReturnType<typeof useGetPatientsWithoutRescheduledAppointmentsForTimeRangeQuery>;
export type GetPatientsWithoutRescheduledAppointmentsForTimeRangeLazyQueryHookResult = ReturnType<typeof useGetPatientsWithoutRescheduledAppointmentsForTimeRangeLazyQuery>;
export type GetPatientsWithoutRescheduledAppointmentsForTimeRangeSuspenseQueryHookResult = ReturnType<typeof useGetPatientsWithoutRescheduledAppointmentsForTimeRangeSuspenseQuery>;
export type GetPatientsWithoutRescheduledAppointmentsForTimeRangeQueryResult = Apollo.QueryResult<GetPatientsWithoutRescheduledAppointmentsForTimeRangeQuery, GetPatientsWithoutRescheduledAppointmentsForTimeRangeQueryVariables>;
export const QueryPatientsDocument = gql`
    query queryPatients($where: [QueryInput!], $page: NonNegativeInt, $pageSize: NonNegativeInt, $orderBy: OrderByInput) {
  queryPatients(
    where: $where
    page: $page
    pageSize: $pageSize
    orderBy: $orderBy
  ) {
    ...PatientFields
  }
}
    ${PatientFieldsFragmentDoc}`;

/**
 * __useQueryPatientsQuery__
 *
 * To run a query within a React component, call `useQueryPatientsQuery` and pass it any options that fit your needs.
 * When your component renders, `useQueryPatientsQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useQueryPatientsQuery({
 *   variables: {
 *      where: // value for 'where'
 *      page: // value for 'page'
 *      pageSize: // value for 'pageSize'
 *      orderBy: // value for 'orderBy'
 *   },
 * });
 */
export function useQueryPatientsQuery(baseOptions?: Apollo.QueryHookOptions<QueryPatientsQuery, QueryPatientsQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<QueryPatientsQuery, QueryPatientsQueryVariables>(QueryPatientsDocument, options);
      }
export function useQueryPatientsLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<QueryPatientsQuery, QueryPatientsQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<QueryPatientsQuery, QueryPatientsQueryVariables>(QueryPatientsDocument, options);
        }
export function useQueryPatientsSuspenseQuery(baseOptions?: Apollo.SuspenseQueryHookOptions<QueryPatientsQuery, QueryPatientsQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useSuspenseQuery<QueryPatientsQuery, QueryPatientsQueryVariables>(QueryPatientsDocument, options);
        }
export type QueryPatientsQueryHookResult = ReturnType<typeof useQueryPatientsQuery>;
export type QueryPatientsLazyQueryHookResult = ReturnType<typeof useQueryPatientsLazyQuery>;
export type QueryPatientsSuspenseQueryHookResult = ReturnType<typeof useQueryPatientsSuspenseQuery>;
export type QueryPatientsQueryResult = Apollo.QueryResult<QueryPatientsQuery, QueryPatientsQueryVariables>;
export const CountPatientsDocument = gql`
    query countPatients($where: [QueryInput!]) {
  countPatients(where: $where)
}
    `;

/**
 * __useCountPatientsQuery__
 *
 * To run a query within a React component, call `useCountPatientsQuery` and pass it any options that fit your needs.
 * When your component renders, `useCountPatientsQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useCountPatientsQuery({
 *   variables: {
 *      where: // value for 'where'
 *   },
 * });
 */
export function useCountPatientsQuery(baseOptions?: Apollo.QueryHookOptions<CountPatientsQuery, CountPatientsQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<CountPatientsQuery, CountPatientsQueryVariables>(CountPatientsDocument, options);
      }
export function useCountPatientsLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<CountPatientsQuery, CountPatientsQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<CountPatientsQuery, CountPatientsQueryVariables>(CountPatientsDocument, options);
        }
export function useCountPatientsSuspenseQuery(baseOptions?: Apollo.SuspenseQueryHookOptions<CountPatientsQuery, CountPatientsQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useSuspenseQuery<CountPatientsQuery, CountPatientsQueryVariables>(CountPatientsDocument, options);
        }
export type CountPatientsQueryHookResult = ReturnType<typeof useCountPatientsQuery>;
export type CountPatientsLazyQueryHookResult = ReturnType<typeof useCountPatientsLazyQuery>;
export type CountPatientsSuspenseQueryHookResult = ReturnType<typeof useCountPatientsSuspenseQuery>;
export type CountPatientsQueryResult = Apollo.QueryResult<CountPatientsQuery, CountPatientsQueryVariables>;
export const QueryPatientsOwnersDocument = gql`
    query queryPatientsOwners($where: [QueryInput!], $page: NonNegativeInt, $pageSize: NonNegativeInt, $orderBy: OrderByInput, $clinicId: ID!) {
  queryPatientsOwners(
    where: $where
    page: $page
    pageSize: $pageSize
    orderBy: $orderBy
    clinicId: $clinicId
  ) {
    patients {
      ...PatientPreviewFields
    }
    count
    isCountCapped
  }
}
    ${PatientPreviewFieldsFragmentDoc}`;

/**
 * __useQueryPatientsOwnersQuery__
 *
 * To run a query within a React component, call `useQueryPatientsOwnersQuery` and pass it any options that fit your needs.
 * When your component renders, `useQueryPatientsOwnersQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useQueryPatientsOwnersQuery({
 *   variables: {
 *      where: // value for 'where'
 *      page: // value for 'page'
 *      pageSize: // value for 'pageSize'
 *      orderBy: // value for 'orderBy'
 *      clinicId: // value for 'clinicId'
 *   },
 * });
 */
export function useQueryPatientsOwnersQuery(baseOptions: Apollo.QueryHookOptions<QueryPatientsOwnersQuery, QueryPatientsOwnersQueryVariables> & ({ variables: QueryPatientsOwnersQueryVariables; skip?: boolean; } | { skip: boolean; }) ) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<QueryPatientsOwnersQuery, QueryPatientsOwnersQueryVariables>(QueryPatientsOwnersDocument, options);
      }
export function useQueryPatientsOwnersLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<QueryPatientsOwnersQuery, QueryPatientsOwnersQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<QueryPatientsOwnersQuery, QueryPatientsOwnersQueryVariables>(QueryPatientsOwnersDocument, options);
        }
export function useQueryPatientsOwnersSuspenseQuery(baseOptions?: Apollo.SuspenseQueryHookOptions<QueryPatientsOwnersQuery, QueryPatientsOwnersQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useSuspenseQuery<QueryPatientsOwnersQuery, QueryPatientsOwnersQueryVariables>(QueryPatientsOwnersDocument, options);
        }
export type QueryPatientsOwnersQueryHookResult = ReturnType<typeof useQueryPatientsOwnersQuery>;
export type QueryPatientsOwnersLazyQueryHookResult = ReturnType<typeof useQueryPatientsOwnersLazyQuery>;
export type QueryPatientsOwnersSuspenseQueryHookResult = ReturnType<typeof useQueryPatientsOwnersSuspenseQuery>;
export type QueryPatientsOwnersQueryResult = Apollo.QueryResult<QueryPatientsOwnersQuery, QueryPatientsOwnersQueryVariables>;
export const QueryClinicPatientsDocument = gql`
    query queryClinicPatients($where: [QueryInput!], $page: NonNegativeInt, $pageSize: NonNegativeInt, $orderBy: OrderByInput, $clinicId: ID!) {
  queryClinicPatients(
    where: $where
    page: $page
    pageSize: $pageSize
    orderBy: $orderBy
    clinicId: $clinicId
  ) {
    ...PatientFields
  }
}
    ${PatientFieldsFragmentDoc}`;

/**
 * __useQueryClinicPatientsQuery__
 *
 * To run a query within a React component, call `useQueryClinicPatientsQuery` and pass it any options that fit your needs.
 * When your component renders, `useQueryClinicPatientsQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useQueryClinicPatientsQuery({
 *   variables: {
 *      where: // value for 'where'
 *      page: // value for 'page'
 *      pageSize: // value for 'pageSize'
 *      orderBy: // value for 'orderBy'
 *      clinicId: // value for 'clinicId'
 *   },
 * });
 */
export function useQueryClinicPatientsQuery(baseOptions: Apollo.QueryHookOptions<QueryClinicPatientsQuery, QueryClinicPatientsQueryVariables> & ({ variables: QueryClinicPatientsQueryVariables; skip?: boolean; } | { skip: boolean; }) ) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<QueryClinicPatientsQuery, QueryClinicPatientsQueryVariables>(QueryClinicPatientsDocument, options);
      }
export function useQueryClinicPatientsLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<QueryClinicPatientsQuery, QueryClinicPatientsQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<QueryClinicPatientsQuery, QueryClinicPatientsQueryVariables>(QueryClinicPatientsDocument, options);
        }
export function useQueryClinicPatientsSuspenseQuery(baseOptions?: Apollo.SuspenseQueryHookOptions<QueryClinicPatientsQuery, QueryClinicPatientsQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useSuspenseQuery<QueryClinicPatientsQuery, QueryClinicPatientsQueryVariables>(QueryClinicPatientsDocument, options);
        }
export type QueryClinicPatientsQueryHookResult = ReturnType<typeof useQueryClinicPatientsQuery>;
export type QueryClinicPatientsLazyQueryHookResult = ReturnType<typeof useQueryClinicPatientsLazyQuery>;
export type QueryClinicPatientsSuspenseQueryHookResult = ReturnType<typeof useQueryClinicPatientsSuspenseQuery>;
export type QueryClinicPatientsQueryResult = Apollo.QueryResult<QueryClinicPatientsQuery, QueryClinicPatientsQueryVariables>;
export const GetOverduePatientsDocument = gql`
    query getOverduePatients($clinicId: ID!, $options: OverduePatientOptions) {
  getOverduePatients(clinicId: $clinicId, options: $options) {
    ...OverduePatientWithAppointmentFields
  }
}
    ${OverduePatientWithAppointmentFieldsFragmentDoc}`;

/**
 * __useGetOverduePatientsQuery__
 *
 * To run a query within a React component, call `useGetOverduePatientsQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetOverduePatientsQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetOverduePatientsQuery({
 *   variables: {
 *      clinicId: // value for 'clinicId'
 *      options: // value for 'options'
 *   },
 * });
 */
export function useGetOverduePatientsQuery(baseOptions: Apollo.QueryHookOptions<GetOverduePatientsQuery, GetOverduePatientsQueryVariables> & ({ variables: GetOverduePatientsQueryVariables; skip?: boolean; } | { skip: boolean; }) ) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<GetOverduePatientsQuery, GetOverduePatientsQueryVariables>(GetOverduePatientsDocument, options);
      }
export function useGetOverduePatientsLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<GetOverduePatientsQuery, GetOverduePatientsQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<GetOverduePatientsQuery, GetOverduePatientsQueryVariables>(GetOverduePatientsDocument, options);
        }
export function useGetOverduePatientsSuspenseQuery(baseOptions?: Apollo.SuspenseQueryHookOptions<GetOverduePatientsQuery, GetOverduePatientsQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useSuspenseQuery<GetOverduePatientsQuery, GetOverduePatientsQueryVariables>(GetOverduePatientsDocument, options);
        }
export type GetOverduePatientsQueryHookResult = ReturnType<typeof useGetOverduePatientsQuery>;
export type GetOverduePatientsLazyQueryHookResult = ReturnType<typeof useGetOverduePatientsLazyQuery>;
export type GetOverduePatientsSuspenseQueryHookResult = ReturnType<typeof useGetOverduePatientsSuspenseQuery>;
export type GetOverduePatientsQueryResult = Apollo.QueryResult<GetOverduePatientsQuery, GetOverduePatientsQueryVariables>;
export const CountOverduePatientsDocument = gql`
    query countOverduePatients($clinicId: ID!, $options: OverduePatientOptions) {
  countOverduePatients(clinicId: $clinicId, options: $options)
}
    `;

/**
 * __useCountOverduePatientsQuery__
 *
 * To run a query within a React component, call `useCountOverduePatientsQuery` and pass it any options that fit your needs.
 * When your component renders, `useCountOverduePatientsQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useCountOverduePatientsQuery({
 *   variables: {
 *      clinicId: // value for 'clinicId'
 *      options: // value for 'options'
 *   },
 * });
 */
export function useCountOverduePatientsQuery(baseOptions: Apollo.QueryHookOptions<CountOverduePatientsQuery, CountOverduePatientsQueryVariables> & ({ variables: CountOverduePatientsQueryVariables; skip?: boolean; } | { skip: boolean; }) ) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<CountOverduePatientsQuery, CountOverduePatientsQueryVariables>(CountOverduePatientsDocument, options);
      }
export function useCountOverduePatientsLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<CountOverduePatientsQuery, CountOverduePatientsQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<CountOverduePatientsQuery, CountOverduePatientsQueryVariables>(CountOverduePatientsDocument, options);
        }
export function useCountOverduePatientsSuspenseQuery(baseOptions?: Apollo.SuspenseQueryHookOptions<CountOverduePatientsQuery, CountOverduePatientsQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useSuspenseQuery<CountOverduePatientsQuery, CountOverduePatientsQueryVariables>(CountOverduePatientsDocument, options);
        }
export type CountOverduePatientsQueryHookResult = ReturnType<typeof useCountOverduePatientsQuery>;
export type CountOverduePatientsLazyQueryHookResult = ReturnType<typeof useCountOverduePatientsLazyQuery>;
export type CountOverduePatientsSuspenseQueryHookResult = ReturnType<typeof useCountOverduePatientsSuspenseQuery>;
export type CountOverduePatientsQueryResult = Apollo.QueryResult<CountOverduePatientsQuery, CountOverduePatientsQueryVariables>;
export const CreatePatientDocument = gql`
    mutation createPatient($data: CreatePatientInput!) {
  createPatient(data: $data) {
    ...PatientFields
  }
}
    ${PatientFieldsFragmentDoc}`;
export type CreatePatientMutationFn = Apollo.MutationFunction<CreatePatientMutation, CreatePatientMutationVariables>;

/**
 * __useCreatePatientMutation__
 *
 * To run a mutation, you first call `useCreatePatientMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useCreatePatientMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [createPatientMutation, { data, loading, error }] = useCreatePatientMutation({
 *   variables: {
 *      data: // value for 'data'
 *   },
 * });
 */
export function useCreatePatientMutation(baseOptions?: Apollo.MutationHookOptions<CreatePatientMutation, CreatePatientMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<CreatePatientMutation, CreatePatientMutationVariables>(CreatePatientDocument, options);
      }
export type CreatePatientMutationHookResult = ReturnType<typeof useCreatePatientMutation>;
export type CreatePatientMutationResult = Apollo.MutationResult<CreatePatientMutation>;
export type CreatePatientMutationOptions = Apollo.BaseMutationOptions<CreatePatientMutation, CreatePatientMutationVariables>;
export const UpdatePatientDocument = gql`
    mutation updatePatient($id: ID!, $data: UpdatePatientInput!) {
  updatePatient(id: $id, data: $data) {
    ...PatientFields
  }
}
    ${PatientFieldsFragmentDoc}`;
export type UpdatePatientMutationFn = Apollo.MutationFunction<UpdatePatientMutation, UpdatePatientMutationVariables>;

/**
 * __useUpdatePatientMutation__
 *
 * To run a mutation, you first call `useUpdatePatientMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useUpdatePatientMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [updatePatientMutation, { data, loading, error }] = useUpdatePatientMutation({
 *   variables: {
 *      id: // value for 'id'
 *      data: // value for 'data'
 *   },
 * });
 */
export function useUpdatePatientMutation(baseOptions?: Apollo.MutationHookOptions<UpdatePatientMutation, UpdatePatientMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<UpdatePatientMutation, UpdatePatientMutationVariables>(UpdatePatientDocument, options);
      }
export type UpdatePatientMutationHookResult = ReturnType<typeof useUpdatePatientMutation>;
export type UpdatePatientMutationResult = Apollo.MutationResult<UpdatePatientMutation>;
export type UpdatePatientMutationOptions = Apollo.BaseMutationOptions<UpdatePatientMutation, UpdatePatientMutationVariables>;
export const DeletePatientDocument = gql`
    mutation deletePatient($id: ID!) {
  deletePatient(id: $id)
}
    `;
export type DeletePatientMutationFn = Apollo.MutationFunction<DeletePatientMutation, DeletePatientMutationVariables>;

/**
 * __useDeletePatientMutation__
 *
 * To run a mutation, you first call `useDeletePatientMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useDeletePatientMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [deletePatientMutation, { data, loading, error }] = useDeletePatientMutation({
 *   variables: {
 *      id: // value for 'id'
 *   },
 * });
 */
export function useDeletePatientMutation(baseOptions?: Apollo.MutationHookOptions<DeletePatientMutation, DeletePatientMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<DeletePatientMutation, DeletePatientMutationVariables>(DeletePatientDocument, options);
      }
export type DeletePatientMutationHookResult = ReturnType<typeof useDeletePatientMutation>;
export type DeletePatientMutationResult = Apollo.MutationResult<DeletePatientMutation>;
export type DeletePatientMutationOptions = Apollo.BaseMutationOptions<DeletePatientMutation, DeletePatientMutationVariables>;
export const SyncIndividualPatientDocument = gql`
    mutation syncIndividualPatient($patientId: ID!, $clinicId: ID!) {
  syncIndividualPatient(patientId: $patientId, clinicId: $clinicId) {
    ...PatientFields
  }
}
    ${PatientFieldsFragmentDoc}`;
export type SyncIndividualPatientMutationFn = Apollo.MutationFunction<SyncIndividualPatientMutation, SyncIndividualPatientMutationVariables>;

/**
 * __useSyncIndividualPatientMutation__
 *
 * To run a mutation, you first call `useSyncIndividualPatientMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useSyncIndividualPatientMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [syncIndividualPatientMutation, { data, loading, error }] = useSyncIndividualPatientMutation({
 *   variables: {
 *      patientId: // value for 'patientId'
 *      clinicId: // value for 'clinicId'
 *   },
 * });
 */
export function useSyncIndividualPatientMutation(baseOptions?: Apollo.MutationHookOptions<SyncIndividualPatientMutation, SyncIndividualPatientMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<SyncIndividualPatientMutation, SyncIndividualPatientMutationVariables>(SyncIndividualPatientDocument, options);
      }
export type SyncIndividualPatientMutationHookResult = ReturnType<typeof useSyncIndividualPatientMutation>;
export type SyncIndividualPatientMutationResult = Apollo.MutationResult<SyncIndividualPatientMutation>;
export type SyncIndividualPatientMutationOptions = Apollo.BaseMutationOptions<SyncIndividualPatientMutation, SyncIndividualPatientMutationVariables>;
export const GetPaymentDocument = gql`
    query getPayment($id: ID!) {
  payment(id: $id) {
    ...PaymentFields
  }
}
    ${PaymentFieldsFragmentDoc}`;

/**
 * __useGetPaymentQuery__
 *
 * To run a query within a React component, call `useGetPaymentQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetPaymentQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetPaymentQuery({
 *   variables: {
 *      id: // value for 'id'
 *   },
 * });
 */
export function useGetPaymentQuery(baseOptions: Apollo.QueryHookOptions<GetPaymentQuery, GetPaymentQueryVariables> & ({ variables: GetPaymentQueryVariables; skip?: boolean; } | { skip: boolean; }) ) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<GetPaymentQuery, GetPaymentQueryVariables>(GetPaymentDocument, options);
      }
export function useGetPaymentLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<GetPaymentQuery, GetPaymentQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<GetPaymentQuery, GetPaymentQueryVariables>(GetPaymentDocument, options);
        }
export function useGetPaymentSuspenseQuery(baseOptions?: Apollo.SuspenseQueryHookOptions<GetPaymentQuery, GetPaymentQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useSuspenseQuery<GetPaymentQuery, GetPaymentQueryVariables>(GetPaymentDocument, options);
        }
export type GetPaymentQueryHookResult = ReturnType<typeof useGetPaymentQuery>;
export type GetPaymentLazyQueryHookResult = ReturnType<typeof useGetPaymentLazyQuery>;
export type GetPaymentSuspenseQueryHookResult = ReturnType<typeof useGetPaymentSuspenseQuery>;
export type GetPaymentQueryResult = Apollo.QueryResult<GetPaymentQuery, GetPaymentQueryVariables>;
export const GetPaymentsByClinicIdDocument = gql`
    query getPaymentsByClinicId($clinicId: ID!) {
  getPaymentsByClinicId(clinicId: $clinicId) {
    ...PaymentFields
  }
}
    ${PaymentFieldsFragmentDoc}`;

/**
 * __useGetPaymentsByClinicIdQuery__
 *
 * To run a query within a React component, call `useGetPaymentsByClinicIdQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetPaymentsByClinicIdQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetPaymentsByClinicIdQuery({
 *   variables: {
 *      clinicId: // value for 'clinicId'
 *   },
 * });
 */
export function useGetPaymentsByClinicIdQuery(baseOptions: Apollo.QueryHookOptions<GetPaymentsByClinicIdQuery, GetPaymentsByClinicIdQueryVariables> & ({ variables: GetPaymentsByClinicIdQueryVariables; skip?: boolean; } | { skip: boolean; }) ) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<GetPaymentsByClinicIdQuery, GetPaymentsByClinicIdQueryVariables>(GetPaymentsByClinicIdDocument, options);
      }
export function useGetPaymentsByClinicIdLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<GetPaymentsByClinicIdQuery, GetPaymentsByClinicIdQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<GetPaymentsByClinicIdQuery, GetPaymentsByClinicIdQueryVariables>(GetPaymentsByClinicIdDocument, options);
        }
export function useGetPaymentsByClinicIdSuspenseQuery(baseOptions?: Apollo.SuspenseQueryHookOptions<GetPaymentsByClinicIdQuery, GetPaymentsByClinicIdQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useSuspenseQuery<GetPaymentsByClinicIdQuery, GetPaymentsByClinicIdQueryVariables>(GetPaymentsByClinicIdDocument, options);
        }
export type GetPaymentsByClinicIdQueryHookResult = ReturnType<typeof useGetPaymentsByClinicIdQuery>;
export type GetPaymentsByClinicIdLazyQueryHookResult = ReturnType<typeof useGetPaymentsByClinicIdLazyQuery>;
export type GetPaymentsByClinicIdSuspenseQueryHookResult = ReturnType<typeof useGetPaymentsByClinicIdSuspenseQuery>;
export type GetPaymentsByClinicIdQueryResult = Apollo.QueryResult<GetPaymentsByClinicIdQuery, GetPaymentsByClinicIdQueryVariables>;
export const QueryPaymentsDocument = gql`
    query queryPayments($where: [QueryInput!], $page: NonNegativeInt, $pageSize: NonNegativeInt, $orderBy: OrderByInput) {
  queryPayments(
    where: $where
    page: $page
    pageSize: $pageSize
    orderBy: $orderBy
  ) {
    ...PaymentFields
  }
}
    ${PaymentFieldsFragmentDoc}`;

/**
 * __useQueryPaymentsQuery__
 *
 * To run a query within a React component, call `useQueryPaymentsQuery` and pass it any options that fit your needs.
 * When your component renders, `useQueryPaymentsQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useQueryPaymentsQuery({
 *   variables: {
 *      where: // value for 'where'
 *      page: // value for 'page'
 *      pageSize: // value for 'pageSize'
 *      orderBy: // value for 'orderBy'
 *   },
 * });
 */
export function useQueryPaymentsQuery(baseOptions?: Apollo.QueryHookOptions<QueryPaymentsQuery, QueryPaymentsQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<QueryPaymentsQuery, QueryPaymentsQueryVariables>(QueryPaymentsDocument, options);
      }
export function useQueryPaymentsLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<QueryPaymentsQuery, QueryPaymentsQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<QueryPaymentsQuery, QueryPaymentsQueryVariables>(QueryPaymentsDocument, options);
        }
export function useQueryPaymentsSuspenseQuery(baseOptions?: Apollo.SuspenseQueryHookOptions<QueryPaymentsQuery, QueryPaymentsQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useSuspenseQuery<QueryPaymentsQuery, QueryPaymentsQueryVariables>(QueryPaymentsDocument, options);
        }
export type QueryPaymentsQueryHookResult = ReturnType<typeof useQueryPaymentsQuery>;
export type QueryPaymentsLazyQueryHookResult = ReturnType<typeof useQueryPaymentsLazyQuery>;
export type QueryPaymentsSuspenseQueryHookResult = ReturnType<typeof useQueryPaymentsSuspenseQuery>;
export type QueryPaymentsQueryResult = Apollo.QueryResult<QueryPaymentsQuery, QueryPaymentsQueryVariables>;
export const CountPaymentsDocument = gql`
    query countPayments($where: [QueryInput!]) {
  countPayments(where: $where)
}
    `;

/**
 * __useCountPaymentsQuery__
 *
 * To run a query within a React component, call `useCountPaymentsQuery` and pass it any options that fit your needs.
 * When your component renders, `useCountPaymentsQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useCountPaymentsQuery({
 *   variables: {
 *      where: // value for 'where'
 *   },
 * });
 */
export function useCountPaymentsQuery(baseOptions?: Apollo.QueryHookOptions<CountPaymentsQuery, CountPaymentsQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<CountPaymentsQuery, CountPaymentsQueryVariables>(CountPaymentsDocument, options);
      }
export function useCountPaymentsLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<CountPaymentsQuery, CountPaymentsQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<CountPaymentsQuery, CountPaymentsQueryVariables>(CountPaymentsDocument, options);
        }
export function useCountPaymentsSuspenseQuery(baseOptions?: Apollo.SuspenseQueryHookOptions<CountPaymentsQuery, CountPaymentsQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useSuspenseQuery<CountPaymentsQuery, CountPaymentsQueryVariables>(CountPaymentsDocument, options);
        }
export type CountPaymentsQueryHookResult = ReturnType<typeof useCountPaymentsQuery>;
export type CountPaymentsLazyQueryHookResult = ReturnType<typeof useCountPaymentsLazyQuery>;
export type CountPaymentsSuspenseQueryHookResult = ReturnType<typeof useCountPaymentsSuspenseQuery>;
export type CountPaymentsQueryResult = Apollo.QueryResult<CountPaymentsQuery, CountPaymentsQueryVariables>;
export const TogglePaymentIsEnteredDocument = gql`
    mutation togglePaymentIsEntered($id: ID!) {
  togglePaymentIsEntered(id: $id) {
    ...PaymentFields
  }
}
    ${PaymentFieldsFragmentDoc}`;
export type TogglePaymentIsEnteredMutationFn = Apollo.MutationFunction<TogglePaymentIsEnteredMutation, TogglePaymentIsEnteredMutationVariables>;

/**
 * __useTogglePaymentIsEnteredMutation__
 *
 * To run a mutation, you first call `useTogglePaymentIsEnteredMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useTogglePaymentIsEnteredMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [togglePaymentIsEnteredMutation, { data, loading, error }] = useTogglePaymentIsEnteredMutation({
 *   variables: {
 *      id: // value for 'id'
 *   },
 * });
 */
export function useTogglePaymentIsEnteredMutation(baseOptions?: Apollo.MutationHookOptions<TogglePaymentIsEnteredMutation, TogglePaymentIsEnteredMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<TogglePaymentIsEnteredMutation, TogglePaymentIsEnteredMutationVariables>(TogglePaymentIsEnteredDocument, options);
      }
export type TogglePaymentIsEnteredMutationHookResult = ReturnType<typeof useTogglePaymentIsEnteredMutation>;
export type TogglePaymentIsEnteredMutationResult = Apollo.MutationResult<TogglePaymentIsEnteredMutation>;
export type TogglePaymentIsEnteredMutationOptions = Apollo.BaseMutationOptions<TogglePaymentIsEnteredMutation, TogglePaymentIsEnteredMutationVariables>;
export const RefundPaymentDocument = gql`
    mutation refundPayment($id: ID!, $refundAmount: PositiveInt!) {
  refundPayment(id: $id, refundAmount: $refundAmount) {
    ...PaymentFields
  }
}
    ${PaymentFieldsFragmentDoc}`;
export type RefundPaymentMutationFn = Apollo.MutationFunction<RefundPaymentMutation, RefundPaymentMutationVariables>;

/**
 * __useRefundPaymentMutation__
 *
 * To run a mutation, you first call `useRefundPaymentMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useRefundPaymentMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [refundPaymentMutation, { data, loading, error }] = useRefundPaymentMutation({
 *   variables: {
 *      id: // value for 'id'
 *      refundAmount: // value for 'refundAmount'
 *   },
 * });
 */
export function useRefundPaymentMutation(baseOptions?: Apollo.MutationHookOptions<RefundPaymentMutation, RefundPaymentMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<RefundPaymentMutation, RefundPaymentMutationVariables>(RefundPaymentDocument, options);
      }
export type RefundPaymentMutationHookResult = ReturnType<typeof useRefundPaymentMutation>;
export type RefundPaymentMutationResult = Apollo.MutationResult<RefundPaymentMutation>;
export type RefundPaymentMutationOptions = Apollo.BaseMutationOptions<RefundPaymentMutation, RefundPaymentMutationVariables>;
export const UpdatePaymentDocument = gql`
    mutation updatePayment($id: ID!, $data: UpdatePaymentInput!) {
  updatePayment(id: $id, data: $data) {
    ...PaymentFields
  }
}
    ${PaymentFieldsFragmentDoc}`;
export type UpdatePaymentMutationFn = Apollo.MutationFunction<UpdatePaymentMutation, UpdatePaymentMutationVariables>;

/**
 * __useUpdatePaymentMutation__
 *
 * To run a mutation, you first call `useUpdatePaymentMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useUpdatePaymentMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [updatePaymentMutation, { data, loading, error }] = useUpdatePaymentMutation({
 *   variables: {
 *      id: // value for 'id'
 *      data: // value for 'data'
 *   },
 * });
 */
export function useUpdatePaymentMutation(baseOptions?: Apollo.MutationHookOptions<UpdatePaymentMutation, UpdatePaymentMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<UpdatePaymentMutation, UpdatePaymentMutationVariables>(UpdatePaymentDocument, options);
      }
export type UpdatePaymentMutationHookResult = ReturnType<typeof useUpdatePaymentMutation>;
export type UpdatePaymentMutationResult = Apollo.MutationResult<UpdatePaymentMutation>;
export type UpdatePaymentMutationOptions = Apollo.BaseMutationOptions<UpdatePaymentMutation, UpdatePaymentMutationVariables>;
export const SendPaymentReceiptDocument = gql`
    mutation sendPaymentReceipt($id: ID!) {
  sendPaymentReceipt(id: $id)
}
    `;
export type SendPaymentReceiptMutationFn = Apollo.MutationFunction<SendPaymentReceiptMutation, SendPaymentReceiptMutationVariables>;

/**
 * __useSendPaymentReceiptMutation__
 *
 * To run a mutation, you first call `useSendPaymentReceiptMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useSendPaymentReceiptMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [sendPaymentReceiptMutation, { data, loading, error }] = useSendPaymentReceiptMutation({
 *   variables: {
 *      id: // value for 'id'
 *   },
 * });
 */
export function useSendPaymentReceiptMutation(baseOptions?: Apollo.MutationHookOptions<SendPaymentReceiptMutation, SendPaymentReceiptMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<SendPaymentReceiptMutation, SendPaymentReceiptMutationVariables>(SendPaymentReceiptDocument, options);
      }
export type SendPaymentReceiptMutationHookResult = ReturnType<typeof useSendPaymentReceiptMutation>;
export type SendPaymentReceiptMutationResult = Apollo.MutationResult<SendPaymentReceiptMutation>;
export type SendPaymentReceiptMutationOptions = Apollo.BaseMutationOptions<SendPaymentReceiptMutation, SendPaymentReceiptMutationVariables>;
export const CreatePaymentLinkDocument = gql`
    mutation createPaymentLink($data: CreatePaymentLinkInput!) {
  createPaymentLink(data: $data) {
    id
    stripe_checkout_session_url
    description
    amount
    status
  }
}
    `;
export type CreatePaymentLinkMutationFn = Apollo.MutationFunction<CreatePaymentLinkMutation, CreatePaymentLinkMutationVariables>;

/**
 * __useCreatePaymentLinkMutation__
 *
 * To run a mutation, you first call `useCreatePaymentLinkMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useCreatePaymentLinkMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [createPaymentLinkMutation, { data, loading, error }] = useCreatePaymentLinkMutation({
 *   variables: {
 *      data: // value for 'data'
 *   },
 * });
 */
export function useCreatePaymentLinkMutation(baseOptions?: Apollo.MutationHookOptions<CreatePaymentLinkMutation, CreatePaymentLinkMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<CreatePaymentLinkMutation, CreatePaymentLinkMutationVariables>(CreatePaymentLinkDocument, options);
      }
export type CreatePaymentLinkMutationHookResult = ReturnType<typeof useCreatePaymentLinkMutation>;
export type CreatePaymentLinkMutationResult = Apollo.MutationResult<CreatePaymentLinkMutation>;
export type CreatePaymentLinkMutationOptions = Apollo.BaseMutationOptions<CreatePaymentLinkMutation, CreatePaymentLinkMutationVariables>;
export const GetPatientRecordDocument = gql`
    query getPatientRecord($id: ID!) {
  patientRecord(id: $id) {
    ...PatientRecordFields
  }
}
    ${PatientRecordFieldsFragmentDoc}`;

/**
 * __useGetPatientRecordQuery__
 *
 * To run a query within a React component, call `useGetPatientRecordQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetPatientRecordQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetPatientRecordQuery({
 *   variables: {
 *      id: // value for 'id'
 *   },
 * });
 */
export function useGetPatientRecordQuery(baseOptions: Apollo.QueryHookOptions<GetPatientRecordQuery, GetPatientRecordQueryVariables> & ({ variables: GetPatientRecordQueryVariables; skip?: boolean; } | { skip: boolean; }) ) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<GetPatientRecordQuery, GetPatientRecordQueryVariables>(GetPatientRecordDocument, options);
      }
export function useGetPatientRecordLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<GetPatientRecordQuery, GetPatientRecordQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<GetPatientRecordQuery, GetPatientRecordQueryVariables>(GetPatientRecordDocument, options);
        }
export function useGetPatientRecordSuspenseQuery(baseOptions?: Apollo.SuspenseQueryHookOptions<GetPatientRecordQuery, GetPatientRecordQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useSuspenseQuery<GetPatientRecordQuery, GetPatientRecordQueryVariables>(GetPatientRecordDocument, options);
        }
export type GetPatientRecordQueryHookResult = ReturnType<typeof useGetPatientRecordQuery>;
export type GetPatientRecordLazyQueryHookResult = ReturnType<typeof useGetPatientRecordLazyQuery>;
export type GetPatientRecordSuspenseQueryHookResult = ReturnType<typeof useGetPatientRecordSuspenseQuery>;
export type GetPatientRecordQueryResult = Apollo.QueryResult<GetPatientRecordQuery, GetPatientRecordQueryVariables>;
export const QueryPetSelfiesDocument = gql`
    query queryPetSelfies($where: [QueryInput!], $page: NonNegativeInt, $pageSize: NonNegativeInt, $orderBy: OrderByInput) {
  queryPetSelfies(
    where: $where
    page: $page
    pageSize: $pageSize
    orderBy: $orderBy
  ) {
    ...PetSelfieFields
  }
}
    ${PetSelfieFieldsFragmentDoc}`;

/**
 * __useQueryPetSelfiesQuery__
 *
 * To run a query within a React component, call `useQueryPetSelfiesQuery` and pass it any options that fit your needs.
 * When your component renders, `useQueryPetSelfiesQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useQueryPetSelfiesQuery({
 *   variables: {
 *      where: // value for 'where'
 *      page: // value for 'page'
 *      pageSize: // value for 'pageSize'
 *      orderBy: // value for 'orderBy'
 *   },
 * });
 */
export function useQueryPetSelfiesQuery(baseOptions?: Apollo.QueryHookOptions<QueryPetSelfiesQuery, QueryPetSelfiesQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<QueryPetSelfiesQuery, QueryPetSelfiesQueryVariables>(QueryPetSelfiesDocument, options);
      }
export function useQueryPetSelfiesLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<QueryPetSelfiesQuery, QueryPetSelfiesQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<QueryPetSelfiesQuery, QueryPetSelfiesQueryVariables>(QueryPetSelfiesDocument, options);
        }
export function useQueryPetSelfiesSuspenseQuery(baseOptions?: Apollo.SuspenseQueryHookOptions<QueryPetSelfiesQuery, QueryPetSelfiesQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useSuspenseQuery<QueryPetSelfiesQuery, QueryPetSelfiesQueryVariables>(QueryPetSelfiesDocument, options);
        }
export type QueryPetSelfiesQueryHookResult = ReturnType<typeof useQueryPetSelfiesQuery>;
export type QueryPetSelfiesLazyQueryHookResult = ReturnType<typeof useQueryPetSelfiesLazyQuery>;
export type QueryPetSelfiesSuspenseQueryHookResult = ReturnType<typeof useQueryPetSelfiesSuspenseQuery>;
export type QueryPetSelfiesQueryResult = Apollo.QueryResult<QueryPetSelfiesQuery, QueryPetSelfiesQueryVariables>;
export const CountPetSelfiesDocument = gql`
    query countPetSelfies($where: [QueryInput!]) {
  countPetSelfies(where: $where)
}
    `;

/**
 * __useCountPetSelfiesQuery__
 *
 * To run a query within a React component, call `useCountPetSelfiesQuery` and pass it any options that fit your needs.
 * When your component renders, `useCountPetSelfiesQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useCountPetSelfiesQuery({
 *   variables: {
 *      where: // value for 'where'
 *   },
 * });
 */
export function useCountPetSelfiesQuery(baseOptions?: Apollo.QueryHookOptions<CountPetSelfiesQuery, CountPetSelfiesQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<CountPetSelfiesQuery, CountPetSelfiesQueryVariables>(CountPetSelfiesDocument, options);
      }
export function useCountPetSelfiesLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<CountPetSelfiesQuery, CountPetSelfiesQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<CountPetSelfiesQuery, CountPetSelfiesQueryVariables>(CountPetSelfiesDocument, options);
        }
export function useCountPetSelfiesSuspenseQuery(baseOptions?: Apollo.SuspenseQueryHookOptions<CountPetSelfiesQuery, CountPetSelfiesQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useSuspenseQuery<CountPetSelfiesQuery, CountPetSelfiesQueryVariables>(CountPetSelfiesDocument, options);
        }
export type CountPetSelfiesQueryHookResult = ReturnType<typeof useCountPetSelfiesQuery>;
export type CountPetSelfiesLazyQueryHookResult = ReturnType<typeof useCountPetSelfiesLazyQuery>;
export type CountPetSelfiesSuspenseQueryHookResult = ReturnType<typeof useCountPetSelfiesSuspenseQuery>;
export type CountPetSelfiesQueryResult = Apollo.QueryResult<CountPetSelfiesQuery, CountPetSelfiesQueryVariables>;
export const PetSelfieDocument = gql`
    query petSelfie($id: ID!) {
  petSelfie(id: $id) {
    ...PetSelfieFields
  }
}
    ${PetSelfieFieldsFragmentDoc}`;

/**
 * __usePetSelfieQuery__
 *
 * To run a query within a React component, call `usePetSelfieQuery` and pass it any options that fit your needs.
 * When your component renders, `usePetSelfieQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = usePetSelfieQuery({
 *   variables: {
 *      id: // value for 'id'
 *   },
 * });
 */
export function usePetSelfieQuery(baseOptions: Apollo.QueryHookOptions<PetSelfieQuery, PetSelfieQueryVariables> & ({ variables: PetSelfieQueryVariables; skip?: boolean; } | { skip: boolean; }) ) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<PetSelfieQuery, PetSelfieQueryVariables>(PetSelfieDocument, options);
      }
export function usePetSelfieLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<PetSelfieQuery, PetSelfieQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<PetSelfieQuery, PetSelfieQueryVariables>(PetSelfieDocument, options);
        }
export function usePetSelfieSuspenseQuery(baseOptions?: Apollo.SuspenseQueryHookOptions<PetSelfieQuery, PetSelfieQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useSuspenseQuery<PetSelfieQuery, PetSelfieQueryVariables>(PetSelfieDocument, options);
        }
export type PetSelfieQueryHookResult = ReturnType<typeof usePetSelfieQuery>;
export type PetSelfieLazyQueryHookResult = ReturnType<typeof usePetSelfieLazyQuery>;
export type PetSelfieSuspenseQueryHookResult = ReturnType<typeof usePetSelfieSuspenseQuery>;
export type PetSelfieQueryResult = Apollo.QueryResult<PetSelfieQuery, PetSelfieQueryVariables>;
export const UpdatePetSelfieDocument = gql`
    mutation updatePetSelfie($id: ID!, $data: UpdatePetSelfieInput!) {
  updatePetSelfie(id: $id, data: $data) {
    ...PetSelfieFields
  }
}
    ${PetSelfieFieldsFragmentDoc}`;
export type UpdatePetSelfieMutationFn = Apollo.MutationFunction<UpdatePetSelfieMutation, UpdatePetSelfieMutationVariables>;

/**
 * __useUpdatePetSelfieMutation__
 *
 * To run a mutation, you first call `useUpdatePetSelfieMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useUpdatePetSelfieMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [updatePetSelfieMutation, { data, loading, error }] = useUpdatePetSelfieMutation({
 *   variables: {
 *      id: // value for 'id'
 *      data: // value for 'data'
 *   },
 * });
 */
export function useUpdatePetSelfieMutation(baseOptions?: Apollo.MutationHookOptions<UpdatePetSelfieMutation, UpdatePetSelfieMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<UpdatePetSelfieMutation, UpdatePetSelfieMutationVariables>(UpdatePetSelfieDocument, options);
      }
export type UpdatePetSelfieMutationHookResult = ReturnType<typeof useUpdatePetSelfieMutation>;
export type UpdatePetSelfieMutationResult = Apollo.MutationResult<UpdatePetSelfieMutation>;
export type UpdatePetSelfieMutationOptions = Apollo.BaseMutationOptions<UpdatePetSelfieMutation, UpdatePetSelfieMutationVariables>;
export const MarkPetSelfieViewedDocument = gql`
    mutation markPetSelfieViewed($id: ID!) {
  markPetSelfieViewed(id: $id) {
    ...PetSelfieFields
  }
}
    ${PetSelfieFieldsFragmentDoc}`;
export type MarkPetSelfieViewedMutationFn = Apollo.MutationFunction<MarkPetSelfieViewedMutation, MarkPetSelfieViewedMutationVariables>;

/**
 * __useMarkPetSelfieViewedMutation__
 *
 * To run a mutation, you first call `useMarkPetSelfieViewedMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useMarkPetSelfieViewedMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [markPetSelfieViewedMutation, { data, loading, error }] = useMarkPetSelfieViewedMutation({
 *   variables: {
 *      id: // value for 'id'
 *   },
 * });
 */
export function useMarkPetSelfieViewedMutation(baseOptions?: Apollo.MutationHookOptions<MarkPetSelfieViewedMutation, MarkPetSelfieViewedMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<MarkPetSelfieViewedMutation, MarkPetSelfieViewedMutationVariables>(MarkPetSelfieViewedDocument, options);
      }
export type MarkPetSelfieViewedMutationHookResult = ReturnType<typeof useMarkPetSelfieViewedMutation>;
export type MarkPetSelfieViewedMutationResult = Apollo.MutationResult<MarkPetSelfieViewedMutation>;
export type MarkPetSelfieViewedMutationOptions = Apollo.BaseMutationOptions<MarkPetSelfieViewedMutation, MarkPetSelfieViewedMutationVariables>;
export const LookupPimsClientsDocument = gql`
    query lookupPimsClients($clinicId: ID!, $input: PimsLookupInput!) {
  lookupPimsClients(clinicId: $clinicId, input: $input) {
    ...PimsLookupClientFields
  }
}
    ${PimsLookupClientFieldsFragmentDoc}`;

/**
 * __useLookupPimsClientsQuery__
 *
 * To run a query within a React component, call `useLookupPimsClientsQuery` and pass it any options that fit your needs.
 * When your component renders, `useLookupPimsClientsQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useLookupPimsClientsQuery({
 *   variables: {
 *      clinicId: // value for 'clinicId'
 *      input: // value for 'input'
 *   },
 * });
 */
export function useLookupPimsClientsQuery(baseOptions: Apollo.QueryHookOptions<LookupPimsClientsQuery, LookupPimsClientsQueryVariables> & ({ variables: LookupPimsClientsQueryVariables; skip?: boolean; } | { skip: boolean; }) ) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<LookupPimsClientsQuery, LookupPimsClientsQueryVariables>(LookupPimsClientsDocument, options);
      }
export function useLookupPimsClientsLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<LookupPimsClientsQuery, LookupPimsClientsQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<LookupPimsClientsQuery, LookupPimsClientsQueryVariables>(LookupPimsClientsDocument, options);
        }
export function useLookupPimsClientsSuspenseQuery(baseOptions?: Apollo.SuspenseQueryHookOptions<LookupPimsClientsQuery, LookupPimsClientsQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useSuspenseQuery<LookupPimsClientsQuery, LookupPimsClientsQueryVariables>(LookupPimsClientsDocument, options);
        }
export type LookupPimsClientsQueryHookResult = ReturnType<typeof useLookupPimsClientsQuery>;
export type LookupPimsClientsLazyQueryHookResult = ReturnType<typeof useLookupPimsClientsLazyQuery>;
export type LookupPimsClientsSuspenseQueryHookResult = ReturnType<typeof useLookupPimsClientsSuspenseQuery>;
export type LookupPimsClientsQueryResult = Apollo.QueryResult<LookupPimsClientsQuery, LookupPimsClientsQueryVariables>;
export const SyncPimsClientByPmsIdDocument = gql`
    mutation syncPimsClientByPmsId($clinicId: ID!, $clientPmsId: String!) {
  syncPimsClientByPmsId(clinicId: $clinicId, clientPmsId: $clientPmsId) {
    id
    first_name
    last_name
  }
}
    `;
export type SyncPimsClientByPmsIdMutationFn = Apollo.MutationFunction<SyncPimsClientByPmsIdMutation, SyncPimsClientByPmsIdMutationVariables>;

/**
 * __useSyncPimsClientByPmsIdMutation__
 *
 * To run a mutation, you first call `useSyncPimsClientByPmsIdMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useSyncPimsClientByPmsIdMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [syncPimsClientByPmsIdMutation, { data, loading, error }] = useSyncPimsClientByPmsIdMutation({
 *   variables: {
 *      clinicId: // value for 'clinicId'
 *      clientPmsId: // value for 'clientPmsId'
 *   },
 * });
 */
export function useSyncPimsClientByPmsIdMutation(baseOptions?: Apollo.MutationHookOptions<SyncPimsClientByPmsIdMutation, SyncPimsClientByPmsIdMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<SyncPimsClientByPmsIdMutation, SyncPimsClientByPmsIdMutationVariables>(SyncPimsClientByPmsIdDocument, options);
      }
export type SyncPimsClientByPmsIdMutationHookResult = ReturnType<typeof useSyncPimsClientByPmsIdMutation>;
export type SyncPimsClientByPmsIdMutationResult = Apollo.MutationResult<SyncPimsClientByPmsIdMutation>;
export type SyncPimsClientByPmsIdMutationOptions = Apollo.BaseMutationOptions<SyncPimsClientByPmsIdMutation, SyncPimsClientByPmsIdMutationVariables>;
export const QueryPimsReminderTypesDocument = gql`
    query queryPimsReminderTypes($where: [QueryInput!], $page: NonNegativeInt, $pageSize: NonNegativeInt, $orderBy: OrderByInput) {
  queryPimsReminderTypes(
    where: $where
    page: $page
    pageSize: $pageSize
    orderBy: $orderBy
  ) {
    ...PimsReminderTypeFields
  }
}
    ${PimsReminderTypeFieldsFragmentDoc}`;

/**
 * __useQueryPimsReminderTypesQuery__
 *
 * To run a query within a React component, call `useQueryPimsReminderTypesQuery` and pass it any options that fit your needs.
 * When your component renders, `useQueryPimsReminderTypesQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useQueryPimsReminderTypesQuery({
 *   variables: {
 *      where: // value for 'where'
 *      page: // value for 'page'
 *      pageSize: // value for 'pageSize'
 *      orderBy: // value for 'orderBy'
 *   },
 * });
 */
export function useQueryPimsReminderTypesQuery(baseOptions?: Apollo.QueryHookOptions<QueryPimsReminderTypesQuery, QueryPimsReminderTypesQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<QueryPimsReminderTypesQuery, QueryPimsReminderTypesQueryVariables>(QueryPimsReminderTypesDocument, options);
      }
export function useQueryPimsReminderTypesLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<QueryPimsReminderTypesQuery, QueryPimsReminderTypesQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<QueryPimsReminderTypesQuery, QueryPimsReminderTypesQueryVariables>(QueryPimsReminderTypesDocument, options);
        }
export function useQueryPimsReminderTypesSuspenseQuery(baseOptions?: Apollo.SuspenseQueryHookOptions<QueryPimsReminderTypesQuery, QueryPimsReminderTypesQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useSuspenseQuery<QueryPimsReminderTypesQuery, QueryPimsReminderTypesQueryVariables>(QueryPimsReminderTypesDocument, options);
        }
export type QueryPimsReminderTypesQueryHookResult = ReturnType<typeof useQueryPimsReminderTypesQuery>;
export type QueryPimsReminderTypesLazyQueryHookResult = ReturnType<typeof useQueryPimsReminderTypesLazyQuery>;
export type QueryPimsReminderTypesSuspenseQueryHookResult = ReturnType<typeof useQueryPimsReminderTypesSuspenseQuery>;
export type QueryPimsReminderTypesQueryResult = Apollo.QueryResult<QueryPimsReminderTypesQuery, QueryPimsReminderTypesQueryVariables>;
export const CountPimsReminderTypesDocument = gql`
    query countPimsReminderTypes($where: [QueryInput!]) {
  countPimsReminderTypes(where: $where)
}
    `;

/**
 * __useCountPimsReminderTypesQuery__
 *
 * To run a query within a React component, call `useCountPimsReminderTypesQuery` and pass it any options that fit your needs.
 * When your component renders, `useCountPimsReminderTypesQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useCountPimsReminderTypesQuery({
 *   variables: {
 *      where: // value for 'where'
 *   },
 * });
 */
export function useCountPimsReminderTypesQuery(baseOptions?: Apollo.QueryHookOptions<CountPimsReminderTypesQuery, CountPimsReminderTypesQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<CountPimsReminderTypesQuery, CountPimsReminderTypesQueryVariables>(CountPimsReminderTypesDocument, options);
      }
export function useCountPimsReminderTypesLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<CountPimsReminderTypesQuery, CountPimsReminderTypesQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<CountPimsReminderTypesQuery, CountPimsReminderTypesQueryVariables>(CountPimsReminderTypesDocument, options);
        }
export function useCountPimsReminderTypesSuspenseQuery(baseOptions?: Apollo.SuspenseQueryHookOptions<CountPimsReminderTypesQuery, CountPimsReminderTypesQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useSuspenseQuery<CountPimsReminderTypesQuery, CountPimsReminderTypesQueryVariables>(CountPimsReminderTypesDocument, options);
        }
export type CountPimsReminderTypesQueryHookResult = ReturnType<typeof useCountPimsReminderTypesQuery>;
export type CountPimsReminderTypesLazyQueryHookResult = ReturnType<typeof useCountPimsReminderTypesLazyQuery>;
export type CountPimsReminderTypesSuspenseQueryHookResult = ReturnType<typeof useCountPimsReminderTypesSuspenseQuery>;
export type CountPimsReminderTypesQueryResult = Apollo.QueryResult<CountPimsReminderTypesQuery, CountPimsReminderTypesQueryVariables>;
export const GetPimsRemindersByPatientDocument = gql`
    query getPimsRemindersByPatient($clinicId: ID!, $patientPmsId: String!, $page: NonNegativeInt, $pageSize: NonNegativeInt, $orderBy: OrderByInput) {
  pimsRemindersByPatient(
    clinicId: $clinicId
    patientPmsId: $patientPmsId
    page: $page
    pageSize: $pageSize
    orderBy: $orderBy
  ) {
    ...PatientPimsReminderFields
  }
}
    ${PatientPimsReminderFieldsFragmentDoc}`;

/**
 * __useGetPimsRemindersByPatientQuery__
 *
 * To run a query within a React component, call `useGetPimsRemindersByPatientQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetPimsRemindersByPatientQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetPimsRemindersByPatientQuery({
 *   variables: {
 *      clinicId: // value for 'clinicId'
 *      patientPmsId: // value for 'patientPmsId'
 *      page: // value for 'page'
 *      pageSize: // value for 'pageSize'
 *      orderBy: // value for 'orderBy'
 *   },
 * });
 */
export function useGetPimsRemindersByPatientQuery(baseOptions: Apollo.QueryHookOptions<GetPimsRemindersByPatientQuery, GetPimsRemindersByPatientQueryVariables> & ({ variables: GetPimsRemindersByPatientQueryVariables; skip?: boolean; } | { skip: boolean; }) ) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<GetPimsRemindersByPatientQuery, GetPimsRemindersByPatientQueryVariables>(GetPimsRemindersByPatientDocument, options);
      }
export function useGetPimsRemindersByPatientLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<GetPimsRemindersByPatientQuery, GetPimsRemindersByPatientQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<GetPimsRemindersByPatientQuery, GetPimsRemindersByPatientQueryVariables>(GetPimsRemindersByPatientDocument, options);
        }
export function useGetPimsRemindersByPatientSuspenseQuery(baseOptions?: Apollo.SuspenseQueryHookOptions<GetPimsRemindersByPatientQuery, GetPimsRemindersByPatientQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useSuspenseQuery<GetPimsRemindersByPatientQuery, GetPimsRemindersByPatientQueryVariables>(GetPimsRemindersByPatientDocument, options);
        }
export type GetPimsRemindersByPatientQueryHookResult = ReturnType<typeof useGetPimsRemindersByPatientQuery>;
export type GetPimsRemindersByPatientLazyQueryHookResult = ReturnType<typeof useGetPimsRemindersByPatientLazyQuery>;
export type GetPimsRemindersByPatientSuspenseQueryHookResult = ReturnType<typeof useGetPimsRemindersByPatientSuspenseQuery>;
export type GetPimsRemindersByPatientQueryResult = Apollo.QueryResult<GetPimsRemindersByPatientQuery, GetPimsRemindersByPatientQueryVariables>;
export const CountPimsRemindersByPatientDocument = gql`
    query countPimsRemindersByPatient($clinicId: ID!, $patientPmsId: String!) {
  countPimsRemindersByPatient(clinicId: $clinicId, patientPmsId: $patientPmsId)
}
    `;

/**
 * __useCountPimsRemindersByPatientQuery__
 *
 * To run a query within a React component, call `useCountPimsRemindersByPatientQuery` and pass it any options that fit your needs.
 * When your component renders, `useCountPimsRemindersByPatientQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useCountPimsRemindersByPatientQuery({
 *   variables: {
 *      clinicId: // value for 'clinicId'
 *      patientPmsId: // value for 'patientPmsId'
 *   },
 * });
 */
export function useCountPimsRemindersByPatientQuery(baseOptions: Apollo.QueryHookOptions<CountPimsRemindersByPatientQuery, CountPimsRemindersByPatientQueryVariables> & ({ variables: CountPimsRemindersByPatientQueryVariables; skip?: boolean; } | { skip: boolean; }) ) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<CountPimsRemindersByPatientQuery, CountPimsRemindersByPatientQueryVariables>(CountPimsRemindersByPatientDocument, options);
      }
export function useCountPimsRemindersByPatientLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<CountPimsRemindersByPatientQuery, CountPimsRemindersByPatientQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<CountPimsRemindersByPatientQuery, CountPimsRemindersByPatientQueryVariables>(CountPimsRemindersByPatientDocument, options);
        }
export function useCountPimsRemindersByPatientSuspenseQuery(baseOptions?: Apollo.SuspenseQueryHookOptions<CountPimsRemindersByPatientQuery, CountPimsRemindersByPatientQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useSuspenseQuery<CountPimsRemindersByPatientQuery, CountPimsRemindersByPatientQueryVariables>(CountPimsRemindersByPatientDocument, options);
        }
export type CountPimsRemindersByPatientQueryHookResult = ReturnType<typeof useCountPimsRemindersByPatientQuery>;
export type CountPimsRemindersByPatientLazyQueryHookResult = ReturnType<typeof useCountPimsRemindersByPatientLazyQuery>;
export type CountPimsRemindersByPatientSuspenseQueryHookResult = ReturnType<typeof useCountPimsRemindersByPatientSuspenseQuery>;
export type CountPimsRemindersByPatientQueryResult = Apollo.QueryResult<CountPimsRemindersByPatientQuery, CountPimsRemindersByPatientQueryVariables>;
export const QueryDistinctPimsReminderTypeNamesDocument = gql`
    query queryDistinctPimsReminderTypeNames($where: [QueryInput!], $page: NonNegativeInt, $pageSize: NonNegativeInt, $orderBy: OrderByInput) {
  queryDistinctPimsReminderTypeNames(
    where: $where
    page: $page
    pageSize: $pageSize
    orderBy: $orderBy
  )
}
    `;

/**
 * __useQueryDistinctPimsReminderTypeNamesQuery__
 *
 * To run a query within a React component, call `useQueryDistinctPimsReminderTypeNamesQuery` and pass it any options that fit your needs.
 * When your component renders, `useQueryDistinctPimsReminderTypeNamesQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useQueryDistinctPimsReminderTypeNamesQuery({
 *   variables: {
 *      where: // value for 'where'
 *      page: // value for 'page'
 *      pageSize: // value for 'pageSize'
 *      orderBy: // value for 'orderBy'
 *   },
 * });
 */
export function useQueryDistinctPimsReminderTypeNamesQuery(baseOptions?: Apollo.QueryHookOptions<QueryDistinctPimsReminderTypeNamesQuery, QueryDistinctPimsReminderTypeNamesQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<QueryDistinctPimsReminderTypeNamesQuery, QueryDistinctPimsReminderTypeNamesQueryVariables>(QueryDistinctPimsReminderTypeNamesDocument, options);
      }
export function useQueryDistinctPimsReminderTypeNamesLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<QueryDistinctPimsReminderTypeNamesQuery, QueryDistinctPimsReminderTypeNamesQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<QueryDistinctPimsReminderTypeNamesQuery, QueryDistinctPimsReminderTypeNamesQueryVariables>(QueryDistinctPimsReminderTypeNamesDocument, options);
        }
export function useQueryDistinctPimsReminderTypeNamesSuspenseQuery(baseOptions?: Apollo.SuspenseQueryHookOptions<QueryDistinctPimsReminderTypeNamesQuery, QueryDistinctPimsReminderTypeNamesQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useSuspenseQuery<QueryDistinctPimsReminderTypeNamesQuery, QueryDistinctPimsReminderTypeNamesQueryVariables>(QueryDistinctPimsReminderTypeNamesDocument, options);
        }
export type QueryDistinctPimsReminderTypeNamesQueryHookResult = ReturnType<typeof useQueryDistinctPimsReminderTypeNamesQuery>;
export type QueryDistinctPimsReminderTypeNamesLazyQueryHookResult = ReturnType<typeof useQueryDistinctPimsReminderTypeNamesLazyQuery>;
export type QueryDistinctPimsReminderTypeNamesSuspenseQueryHookResult = ReturnType<typeof useQueryDistinctPimsReminderTypeNamesSuspenseQuery>;
export type QueryDistinctPimsReminderTypeNamesQueryResult = Apollo.QueryResult<QueryDistinctPimsReminderTypeNamesQuery, QueryDistinctPimsReminderTypeNamesQueryVariables>;
export const SearchPimsReminderTypesForClinicDocument = gql`
    query searchPimsReminderTypesForClinic($clinicId: ID!, $options: SearchPimsReminderTypesForClinicOptions) {
  searchPimsReminderTypesForClinic(clinicId: $clinicId, options: $options) {
    pims_reminder_types {
      ...PimsReminderTypeFields
    }
    count
  }
}
    ${PimsReminderTypeFieldsFragmentDoc}`;

/**
 * __useSearchPimsReminderTypesForClinicQuery__
 *
 * To run a query within a React component, call `useSearchPimsReminderTypesForClinicQuery` and pass it any options that fit your needs.
 * When your component renders, `useSearchPimsReminderTypesForClinicQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useSearchPimsReminderTypesForClinicQuery({
 *   variables: {
 *      clinicId: // value for 'clinicId'
 *      options: // value for 'options'
 *   },
 * });
 */
export function useSearchPimsReminderTypesForClinicQuery(baseOptions: Apollo.QueryHookOptions<SearchPimsReminderTypesForClinicQuery, SearchPimsReminderTypesForClinicQueryVariables> & ({ variables: SearchPimsReminderTypesForClinicQueryVariables; skip?: boolean; } | { skip: boolean; }) ) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<SearchPimsReminderTypesForClinicQuery, SearchPimsReminderTypesForClinicQueryVariables>(SearchPimsReminderTypesForClinicDocument, options);
      }
export function useSearchPimsReminderTypesForClinicLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<SearchPimsReminderTypesForClinicQuery, SearchPimsReminderTypesForClinicQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<SearchPimsReminderTypesForClinicQuery, SearchPimsReminderTypesForClinicQueryVariables>(SearchPimsReminderTypesForClinicDocument, options);
        }
export function useSearchPimsReminderTypesForClinicSuspenseQuery(baseOptions?: Apollo.SuspenseQueryHookOptions<SearchPimsReminderTypesForClinicQuery, SearchPimsReminderTypesForClinicQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useSuspenseQuery<SearchPimsReminderTypesForClinicQuery, SearchPimsReminderTypesForClinicQueryVariables>(SearchPimsReminderTypesForClinicDocument, options);
        }
export type SearchPimsReminderTypesForClinicQueryHookResult = ReturnType<typeof useSearchPimsReminderTypesForClinicQuery>;
export type SearchPimsReminderTypesForClinicLazyQueryHookResult = ReturnType<typeof useSearchPimsReminderTypesForClinicLazyQuery>;
export type SearchPimsReminderTypesForClinicSuspenseQueryHookResult = ReturnType<typeof useSearchPimsReminderTypesForClinicSuspenseQuery>;
export type SearchPimsReminderTypesForClinicQueryResult = Apollo.QueryResult<SearchPimsReminderTypesForClinicQuery, SearchPimsReminderTypesForClinicQueryVariables>;
export const UpdatePimsReminderTypeDocument = gql`
    mutation updatePimsReminderType($id: ID!, $input: UpdatePimsReminderTypeInput!) {
  updatePimsReminderType(id: $id, input: $input) {
    ...PimsReminderTypeFields
  }
}
    ${PimsReminderTypeFieldsFragmentDoc}`;
export type UpdatePimsReminderTypeMutationFn = Apollo.MutationFunction<UpdatePimsReminderTypeMutation, UpdatePimsReminderTypeMutationVariables>;

/**
 * __useUpdatePimsReminderTypeMutation__
 *
 * To run a mutation, you first call `useUpdatePimsReminderTypeMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useUpdatePimsReminderTypeMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [updatePimsReminderTypeMutation, { data, loading, error }] = useUpdatePimsReminderTypeMutation({
 *   variables: {
 *      id: // value for 'id'
 *      input: // value for 'input'
 *   },
 * });
 */
export function useUpdatePimsReminderTypeMutation(baseOptions?: Apollo.MutationHookOptions<UpdatePimsReminderTypeMutation, UpdatePimsReminderTypeMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<UpdatePimsReminderTypeMutation, UpdatePimsReminderTypeMutationVariables>(UpdatePimsReminderTypeDocument, options);
      }
export type UpdatePimsReminderTypeMutationHookResult = ReturnType<typeof useUpdatePimsReminderTypeMutation>;
export type UpdatePimsReminderTypeMutationResult = Apollo.MutationResult<UpdatePimsReminderTypeMutation>;
export type UpdatePimsReminderTypeMutationOptions = Apollo.BaseMutationOptions<UpdatePimsReminderTypeMutation, UpdatePimsReminderTypeMutationVariables>;
export const QueryPimsRemindersDocument = gql`
    query queryPimsReminders($where: [QueryInput!], $page: NonNegativeInt, $pageSize: NonNegativeInt, $orderBy: OrderByInput) {
  queryPimsReminders(
    where: $where
    page: $page
    pageSize: $pageSize
    orderBy: $orderBy
  ) {
    ...PatientPimsReminderFields
  }
}
    ${PatientPimsReminderFieldsFragmentDoc}`;

/**
 * __useQueryPimsRemindersQuery__
 *
 * To run a query within a React component, call `useQueryPimsRemindersQuery` and pass it any options that fit your needs.
 * When your component renders, `useQueryPimsRemindersQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useQueryPimsRemindersQuery({
 *   variables: {
 *      where: // value for 'where'
 *      page: // value for 'page'
 *      pageSize: // value for 'pageSize'
 *      orderBy: // value for 'orderBy'
 *   },
 * });
 */
export function useQueryPimsRemindersQuery(baseOptions?: Apollo.QueryHookOptions<QueryPimsRemindersQuery, QueryPimsRemindersQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<QueryPimsRemindersQuery, QueryPimsRemindersQueryVariables>(QueryPimsRemindersDocument, options);
      }
export function useQueryPimsRemindersLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<QueryPimsRemindersQuery, QueryPimsRemindersQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<QueryPimsRemindersQuery, QueryPimsRemindersQueryVariables>(QueryPimsRemindersDocument, options);
        }
export function useQueryPimsRemindersSuspenseQuery(baseOptions?: Apollo.SuspenseQueryHookOptions<QueryPimsRemindersQuery, QueryPimsRemindersQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useSuspenseQuery<QueryPimsRemindersQuery, QueryPimsRemindersQueryVariables>(QueryPimsRemindersDocument, options);
        }
export type QueryPimsRemindersQueryHookResult = ReturnType<typeof useQueryPimsRemindersQuery>;
export type QueryPimsRemindersLazyQueryHookResult = ReturnType<typeof useQueryPimsRemindersLazyQuery>;
export type QueryPimsRemindersSuspenseQueryHookResult = ReturnType<typeof useQueryPimsRemindersSuspenseQuery>;
export type QueryPimsRemindersQueryResult = Apollo.QueryResult<QueryPimsRemindersQuery, QueryPimsRemindersQueryVariables>;
export const GetActivePimsRemindersByPatientsDocument = gql`
    query getActivePimsRemindersByPatients($patientIds: [ID!]!) {
  getActivePimsRemindersByPatients(patientIds: $patientIds) {
    ...PatientPimsReminderFields
  }
}
    ${PatientPimsReminderFieldsFragmentDoc}`;

/**
 * __useGetActivePimsRemindersByPatientsQuery__
 *
 * To run a query within a React component, call `useGetActivePimsRemindersByPatientsQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetActivePimsRemindersByPatientsQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetActivePimsRemindersByPatientsQuery({
 *   variables: {
 *      patientIds: // value for 'patientIds'
 *   },
 * });
 */
export function useGetActivePimsRemindersByPatientsQuery(baseOptions: Apollo.QueryHookOptions<GetActivePimsRemindersByPatientsQuery, GetActivePimsRemindersByPatientsQueryVariables> & ({ variables: GetActivePimsRemindersByPatientsQueryVariables; skip?: boolean; } | { skip: boolean; }) ) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<GetActivePimsRemindersByPatientsQuery, GetActivePimsRemindersByPatientsQueryVariables>(GetActivePimsRemindersByPatientsDocument, options);
      }
export function useGetActivePimsRemindersByPatientsLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<GetActivePimsRemindersByPatientsQuery, GetActivePimsRemindersByPatientsQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<GetActivePimsRemindersByPatientsQuery, GetActivePimsRemindersByPatientsQueryVariables>(GetActivePimsRemindersByPatientsDocument, options);
        }
export function useGetActivePimsRemindersByPatientsSuspenseQuery(baseOptions?: Apollo.SuspenseQueryHookOptions<GetActivePimsRemindersByPatientsQuery, GetActivePimsRemindersByPatientsQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useSuspenseQuery<GetActivePimsRemindersByPatientsQuery, GetActivePimsRemindersByPatientsQueryVariables>(GetActivePimsRemindersByPatientsDocument, options);
        }
export type GetActivePimsRemindersByPatientsQueryHookResult = ReturnType<typeof useGetActivePimsRemindersByPatientsQuery>;
export type GetActivePimsRemindersByPatientsLazyQueryHookResult = ReturnType<typeof useGetActivePimsRemindersByPatientsLazyQuery>;
export type GetActivePimsRemindersByPatientsSuspenseQueryHookResult = ReturnType<typeof useGetActivePimsRemindersByPatientsSuspenseQuery>;
export type GetActivePimsRemindersByPatientsQueryResult = Apollo.QueryResult<GetActivePimsRemindersByPatientsQuery, GetActivePimsRemindersByPatientsQueryVariables>;
export const CountPimsRemindersDocument = gql`
    query countPimsReminders($where: [QueryInput!]) {
  countPimsReminders(where: $where)
}
    `;

/**
 * __useCountPimsRemindersQuery__
 *
 * To run a query within a React component, call `useCountPimsRemindersQuery` and pass it any options that fit your needs.
 * When your component renders, `useCountPimsRemindersQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useCountPimsRemindersQuery({
 *   variables: {
 *      where: // value for 'where'
 *   },
 * });
 */
export function useCountPimsRemindersQuery(baseOptions?: Apollo.QueryHookOptions<CountPimsRemindersQuery, CountPimsRemindersQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<CountPimsRemindersQuery, CountPimsRemindersQueryVariables>(CountPimsRemindersDocument, options);
      }
export function useCountPimsRemindersLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<CountPimsRemindersQuery, CountPimsRemindersQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<CountPimsRemindersQuery, CountPimsRemindersQueryVariables>(CountPimsRemindersDocument, options);
        }
export function useCountPimsRemindersSuspenseQuery(baseOptions?: Apollo.SuspenseQueryHookOptions<CountPimsRemindersQuery, CountPimsRemindersQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useSuspenseQuery<CountPimsRemindersQuery, CountPimsRemindersQueryVariables>(CountPimsRemindersDocument, options);
        }
export type CountPimsRemindersQueryHookResult = ReturnType<typeof useCountPimsRemindersQuery>;
export type CountPimsRemindersLazyQueryHookResult = ReturnType<typeof useCountPimsRemindersLazyQuery>;
export type CountPimsRemindersSuspenseQueryHookResult = ReturnType<typeof useCountPimsRemindersSuspenseQuery>;
export type CountPimsRemindersQueryResult = Apollo.QueryResult<CountPimsRemindersQuery, CountPimsRemindersQueryVariables>;
export const QueryComplianceRemindersDocument = gql`
    query queryComplianceReminders($clinicIds: [ID!]!, $startDate: NonNegativeInt!, $endDate: NonNegativeInt!, $page: NonNegativeInt, $pageSize: NonNegativeInt, $searchQuery: String, $excludeFutureAppts: Boolean, $includeInactiveClients: Boolean, $includeInactiveReminders: Boolean, $excludeDeceasedPatients: Boolean, $orderColumn: String, $orderAsc: Boolean, $complianceStatuses: [String!], $assigneeIds: [ID!], $lastSeenAfter: NonNegativeInt, $reminderTypeIds: [ID!], $includeUnsetComplianceStatus: Boolean, $statusUpdatedBefore: NonNegativeInt) {
  queryComplianceReminders(
    clinicIds: $clinicIds
    startDate: $startDate
    endDate: $endDate
    page: $page
    pageSize: $pageSize
    searchQuery: $searchQuery
    excludeFutureAppts: $excludeFutureAppts
    includeInactiveClients: $includeInactiveClients
    includeInactiveReminders: $includeInactiveReminders
    excludeDeceasedPatients: $excludeDeceasedPatients
    orderColumn: $orderColumn
    orderAsc: $orderAsc
    complianceStatuses: $complianceStatuses
    assigneeIds: $assigneeIds
    lastSeenAfter: $lastSeenAfter
    reminderTypeIds: $reminderTypeIds
    includeUnsetComplianceStatus: $includeUnsetComplianceStatus
    statusUpdatedBefore: $statusUpdatedBefore
  ) {
    results {
      client {
        ...ClientPreviewFields
      }
      reminders {
        patient {
          id
          name
          pms_id
          is_deceased
          is_active
          clinic_species {
            id
            species
          }
        }
        pims_reminder {
          ...PimsReminderPreviewFields
          is_active
          is_completed
        }
      }
      chat {
        id
        compliance_status
        compliance_status_updated_at
        compliance_status_updated_by {
          ...UserBasicInfo
        }
        last_message
        last_message_time
        assignee {
          ...UserBasicInfo
        }
      }
    }
    count
  }
}
    ${ClientPreviewFieldsFragmentDoc}
${PimsReminderPreviewFieldsFragmentDoc}
${UserBasicInfoFragmentDoc}`;

/**
 * __useQueryComplianceRemindersQuery__
 *
 * To run a query within a React component, call `useQueryComplianceRemindersQuery` and pass it any options that fit your needs.
 * When your component renders, `useQueryComplianceRemindersQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useQueryComplianceRemindersQuery({
 *   variables: {
 *      clinicIds: // value for 'clinicIds'
 *      startDate: // value for 'startDate'
 *      endDate: // value for 'endDate'
 *      page: // value for 'page'
 *      pageSize: // value for 'pageSize'
 *      searchQuery: // value for 'searchQuery'
 *      excludeFutureAppts: // value for 'excludeFutureAppts'
 *      includeInactiveClients: // value for 'includeInactiveClients'
 *      includeInactiveReminders: // value for 'includeInactiveReminders'
 *      excludeDeceasedPatients: // value for 'excludeDeceasedPatients'
 *      orderColumn: // value for 'orderColumn'
 *      orderAsc: // value for 'orderAsc'
 *      complianceStatuses: // value for 'complianceStatuses'
 *      assigneeIds: // value for 'assigneeIds'
 *      lastSeenAfter: // value for 'lastSeenAfter'
 *      reminderTypeIds: // value for 'reminderTypeIds'
 *      includeUnsetComplianceStatus: // value for 'includeUnsetComplianceStatus'
 *      statusUpdatedBefore: // value for 'statusUpdatedBefore'
 *   },
 * });
 */
export function useQueryComplianceRemindersQuery(baseOptions: Apollo.QueryHookOptions<QueryComplianceRemindersQuery, QueryComplianceRemindersQueryVariables> & ({ variables: QueryComplianceRemindersQueryVariables; skip?: boolean; } | { skip: boolean; }) ) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<QueryComplianceRemindersQuery, QueryComplianceRemindersQueryVariables>(QueryComplianceRemindersDocument, options);
      }
export function useQueryComplianceRemindersLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<QueryComplianceRemindersQuery, QueryComplianceRemindersQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<QueryComplianceRemindersQuery, QueryComplianceRemindersQueryVariables>(QueryComplianceRemindersDocument, options);
        }
export function useQueryComplianceRemindersSuspenseQuery(baseOptions?: Apollo.SuspenseQueryHookOptions<QueryComplianceRemindersQuery, QueryComplianceRemindersQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useSuspenseQuery<QueryComplianceRemindersQuery, QueryComplianceRemindersQueryVariables>(QueryComplianceRemindersDocument, options);
        }
export type QueryComplianceRemindersQueryHookResult = ReturnType<typeof useQueryComplianceRemindersQuery>;
export type QueryComplianceRemindersLazyQueryHookResult = ReturnType<typeof useQueryComplianceRemindersLazyQuery>;
export type QueryComplianceRemindersSuspenseQueryHookResult = ReturnType<typeof useQueryComplianceRemindersSuspenseQuery>;
export type QueryComplianceRemindersQueryResult = Apollo.QueryResult<QueryComplianceRemindersQuery, QueryComplianceRemindersQueryVariables>;
export const SyncPimsRemindersForPatientDocument = gql`
    mutation syncPimsRemindersForPatient($patientId: ID!) {
  syncPimsRemindersForPatient(patientId: $patientId)
}
    `;
export type SyncPimsRemindersForPatientMutationFn = Apollo.MutationFunction<SyncPimsRemindersForPatientMutation, SyncPimsRemindersForPatientMutationVariables>;

/**
 * __useSyncPimsRemindersForPatientMutation__
 *
 * To run a mutation, you first call `useSyncPimsRemindersForPatientMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useSyncPimsRemindersForPatientMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [syncPimsRemindersForPatientMutation, { data, loading, error }] = useSyncPimsRemindersForPatientMutation({
 *   variables: {
 *      patientId: // value for 'patientId'
 *   },
 * });
 */
export function useSyncPimsRemindersForPatientMutation(baseOptions?: Apollo.MutationHookOptions<SyncPimsRemindersForPatientMutation, SyncPimsRemindersForPatientMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<SyncPimsRemindersForPatientMutation, SyncPimsRemindersForPatientMutationVariables>(SyncPimsRemindersForPatientDocument, options);
      }
export type SyncPimsRemindersForPatientMutationHookResult = ReturnType<typeof useSyncPimsRemindersForPatientMutation>;
export type SyncPimsRemindersForPatientMutationResult = Apollo.MutationResult<SyncPimsRemindersForPatientMutation>;
export type SyncPimsRemindersForPatientMutationOptions = Apollo.BaseMutationOptions<SyncPimsRemindersForPatientMutation, SyncPimsRemindersForPatientMutationVariables>;
export const ComplianceStatusActivityDocument = gql`
    query complianceStatusActivity($clinicIds: [ID!]!, $startDate: NonNegativeInt!, $endDate: NonNegativeInt!) {
  complianceStatusActivity(
    clinicIds: $clinicIds
    startDate: $startDate
    endDate: $endDate
  ) {
    day
    user
    first_name
    last_name
    compliance_status
    count
  }
}
    `;

/**
 * __useComplianceStatusActivityQuery__
 *
 * To run a query within a React component, call `useComplianceStatusActivityQuery` and pass it any options that fit your needs.
 * When your component renders, `useComplianceStatusActivityQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useComplianceStatusActivityQuery({
 *   variables: {
 *      clinicIds: // value for 'clinicIds'
 *      startDate: // value for 'startDate'
 *      endDate: // value for 'endDate'
 *   },
 * });
 */
export function useComplianceStatusActivityQuery(baseOptions: Apollo.QueryHookOptions<ComplianceStatusActivityQuery, ComplianceStatusActivityQueryVariables> & ({ variables: ComplianceStatusActivityQueryVariables; skip?: boolean; } | { skip: boolean; }) ) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<ComplianceStatusActivityQuery, ComplianceStatusActivityQueryVariables>(ComplianceStatusActivityDocument, options);
      }
export function useComplianceStatusActivityLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<ComplianceStatusActivityQuery, ComplianceStatusActivityQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<ComplianceStatusActivityQuery, ComplianceStatusActivityQueryVariables>(ComplianceStatusActivityDocument, options);
        }
export function useComplianceStatusActivitySuspenseQuery(baseOptions?: Apollo.SuspenseQueryHookOptions<ComplianceStatusActivityQuery, ComplianceStatusActivityQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useSuspenseQuery<ComplianceStatusActivityQuery, ComplianceStatusActivityQueryVariables>(ComplianceStatusActivityDocument, options);
        }
export type ComplianceStatusActivityQueryHookResult = ReturnType<typeof useComplianceStatusActivityQuery>;
export type ComplianceStatusActivityLazyQueryHookResult = ReturnType<typeof useComplianceStatusActivityLazyQuery>;
export type ComplianceStatusActivitySuspenseQueryHookResult = ReturnType<typeof useComplianceStatusActivitySuspenseQuery>;
export type ComplianceStatusActivityQueryResult = Apollo.QueryResult<ComplianceStatusActivityQuery, ComplianceStatusActivityQueryVariables>;
export const GetPimsSettingsDocument = gql`
    query getPimsSettings($clinicId: ID!) {
  pimsSettings(clinicId: $clinicId) {
    ...PimsSettingsFields
  }
}
    ${PimsSettingsFieldsFragmentDoc}`;

/**
 * __useGetPimsSettingsQuery__
 *
 * To run a query within a React component, call `useGetPimsSettingsQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetPimsSettingsQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetPimsSettingsQuery({
 *   variables: {
 *      clinicId: // value for 'clinicId'
 *   },
 * });
 */
export function useGetPimsSettingsQuery(baseOptions: Apollo.QueryHookOptions<GetPimsSettingsQuery, GetPimsSettingsQueryVariables> & ({ variables: GetPimsSettingsQueryVariables; skip?: boolean; } | { skip: boolean; }) ) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<GetPimsSettingsQuery, GetPimsSettingsQueryVariables>(GetPimsSettingsDocument, options);
      }
export function useGetPimsSettingsLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<GetPimsSettingsQuery, GetPimsSettingsQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<GetPimsSettingsQuery, GetPimsSettingsQueryVariables>(GetPimsSettingsDocument, options);
        }
export function useGetPimsSettingsSuspenseQuery(baseOptions?: Apollo.SuspenseQueryHookOptions<GetPimsSettingsQuery, GetPimsSettingsQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useSuspenseQuery<GetPimsSettingsQuery, GetPimsSettingsQueryVariables>(GetPimsSettingsDocument, options);
        }
export type GetPimsSettingsQueryHookResult = ReturnType<typeof useGetPimsSettingsQuery>;
export type GetPimsSettingsLazyQueryHookResult = ReturnType<typeof useGetPimsSettingsLazyQuery>;
export type GetPimsSettingsSuspenseQueryHookResult = ReturnType<typeof useGetPimsSettingsSuspenseQuery>;
export type GetPimsSettingsQueryResult = Apollo.QueryResult<GetPimsSettingsQuery, GetPimsSettingsQueryVariables>;
export const CreatePimsSettingsDocument = gql`
    mutation createPimsSettings($data: CreatePimsSettingsInput!) {
  createPimsSettings(data: $data)
}
    `;
export type CreatePimsSettingsMutationFn = Apollo.MutationFunction<CreatePimsSettingsMutation, CreatePimsSettingsMutationVariables>;

/**
 * __useCreatePimsSettingsMutation__
 *
 * To run a mutation, you first call `useCreatePimsSettingsMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useCreatePimsSettingsMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [createPimsSettingsMutation, { data, loading, error }] = useCreatePimsSettingsMutation({
 *   variables: {
 *      data: // value for 'data'
 *   },
 * });
 */
export function useCreatePimsSettingsMutation(baseOptions?: Apollo.MutationHookOptions<CreatePimsSettingsMutation, CreatePimsSettingsMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<CreatePimsSettingsMutation, CreatePimsSettingsMutationVariables>(CreatePimsSettingsDocument, options);
      }
export type CreatePimsSettingsMutationHookResult = ReturnType<typeof useCreatePimsSettingsMutation>;
export type CreatePimsSettingsMutationResult = Apollo.MutationResult<CreatePimsSettingsMutation>;
export type CreatePimsSettingsMutationOptions = Apollo.BaseMutationOptions<CreatePimsSettingsMutation, CreatePimsSettingsMutationVariables>;
export const UpdatePimsSettingsDocument = gql`
    mutation updatePimsSettings($clinicId: ID!, $data: UpdatePimsSettingsInput!) {
  updatePimsSettings(clinicId: $clinicId, data: $data)
}
    `;
export type UpdatePimsSettingsMutationFn = Apollo.MutationFunction<UpdatePimsSettingsMutation, UpdatePimsSettingsMutationVariables>;

/**
 * __useUpdatePimsSettingsMutation__
 *
 * To run a mutation, you first call `useUpdatePimsSettingsMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useUpdatePimsSettingsMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [updatePimsSettingsMutation, { data, loading, error }] = useUpdatePimsSettingsMutation({
 *   variables: {
 *      clinicId: // value for 'clinicId'
 *      data: // value for 'data'
 *   },
 * });
 */
export function useUpdatePimsSettingsMutation(baseOptions?: Apollo.MutationHookOptions<UpdatePimsSettingsMutation, UpdatePimsSettingsMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<UpdatePimsSettingsMutation, UpdatePimsSettingsMutationVariables>(UpdatePimsSettingsDocument, options);
      }
export type UpdatePimsSettingsMutationHookResult = ReturnType<typeof useUpdatePimsSettingsMutation>;
export type UpdatePimsSettingsMutationResult = Apollo.MutationResult<UpdatePimsSettingsMutation>;
export type UpdatePimsSettingsMutationOptions = Apollo.BaseMutationOptions<UpdatePimsSettingsMutation, UpdatePimsSettingsMutationVariables>;
export const GetOnDemandPaymentTypesForClinicDocument = gql`
    query getOnDemandPaymentTypesForClinic($clinicId: ID!) {
  getOnDemandPaymentTypesForClinic(clinicId: $clinicId) {
    ...OnDemandPaymentTypeFields
  }
}
    ${OnDemandPaymentTypeFieldsFragmentDoc}`;

/**
 * __useGetOnDemandPaymentTypesForClinicQuery__
 *
 * To run a query within a React component, call `useGetOnDemandPaymentTypesForClinicQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetOnDemandPaymentTypesForClinicQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetOnDemandPaymentTypesForClinicQuery({
 *   variables: {
 *      clinicId: // value for 'clinicId'
 *   },
 * });
 */
export function useGetOnDemandPaymentTypesForClinicQuery(baseOptions: Apollo.QueryHookOptions<GetOnDemandPaymentTypesForClinicQuery, GetOnDemandPaymentTypesForClinicQueryVariables> & ({ variables: GetOnDemandPaymentTypesForClinicQueryVariables; skip?: boolean; } | { skip: boolean; }) ) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<GetOnDemandPaymentTypesForClinicQuery, GetOnDemandPaymentTypesForClinicQueryVariables>(GetOnDemandPaymentTypesForClinicDocument, options);
      }
export function useGetOnDemandPaymentTypesForClinicLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<GetOnDemandPaymentTypesForClinicQuery, GetOnDemandPaymentTypesForClinicQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<GetOnDemandPaymentTypesForClinicQuery, GetOnDemandPaymentTypesForClinicQueryVariables>(GetOnDemandPaymentTypesForClinicDocument, options);
        }
export function useGetOnDemandPaymentTypesForClinicSuspenseQuery(baseOptions?: Apollo.SuspenseQueryHookOptions<GetOnDemandPaymentTypesForClinicQuery, GetOnDemandPaymentTypesForClinicQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useSuspenseQuery<GetOnDemandPaymentTypesForClinicQuery, GetOnDemandPaymentTypesForClinicQueryVariables>(GetOnDemandPaymentTypesForClinicDocument, options);
        }
export type GetOnDemandPaymentTypesForClinicQueryHookResult = ReturnType<typeof useGetOnDemandPaymentTypesForClinicQuery>;
export type GetOnDemandPaymentTypesForClinicLazyQueryHookResult = ReturnType<typeof useGetOnDemandPaymentTypesForClinicLazyQuery>;
export type GetOnDemandPaymentTypesForClinicSuspenseQueryHookResult = ReturnType<typeof useGetOnDemandPaymentTypesForClinicSuspenseQuery>;
export type GetOnDemandPaymentTypesForClinicQueryResult = Apollo.QueryResult<GetOnDemandPaymentTypesForClinicQuery, GetOnDemandPaymentTypesForClinicQueryVariables>;
export const GetPmsApptTypeDocument = gql`
    query getPmsApptType($clinidId: ID!, $pmsApptTypeId: ID!) {
  pmsApptType(clinicId: $clinidId, pmsApptTypeId: $pmsApptTypeId) {
    ...PmsApptTypeFields
  }
}
    ${PmsApptTypeFieldsFragmentDoc}`;

/**
 * __useGetPmsApptTypeQuery__
 *
 * To run a query within a React component, call `useGetPmsApptTypeQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetPmsApptTypeQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetPmsApptTypeQuery({
 *   variables: {
 *      clinidId: // value for 'clinidId'
 *      pmsApptTypeId: // value for 'pmsApptTypeId'
 *   },
 * });
 */
export function useGetPmsApptTypeQuery(baseOptions: Apollo.QueryHookOptions<GetPmsApptTypeQuery, GetPmsApptTypeQueryVariables> & ({ variables: GetPmsApptTypeQueryVariables; skip?: boolean; } | { skip: boolean; }) ) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<GetPmsApptTypeQuery, GetPmsApptTypeQueryVariables>(GetPmsApptTypeDocument, options);
      }
export function useGetPmsApptTypeLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<GetPmsApptTypeQuery, GetPmsApptTypeQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<GetPmsApptTypeQuery, GetPmsApptTypeQueryVariables>(GetPmsApptTypeDocument, options);
        }
export function useGetPmsApptTypeSuspenseQuery(baseOptions?: Apollo.SuspenseQueryHookOptions<GetPmsApptTypeQuery, GetPmsApptTypeQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useSuspenseQuery<GetPmsApptTypeQuery, GetPmsApptTypeQueryVariables>(GetPmsApptTypeDocument, options);
        }
export type GetPmsApptTypeQueryHookResult = ReturnType<typeof useGetPmsApptTypeQuery>;
export type GetPmsApptTypeLazyQueryHookResult = ReturnType<typeof useGetPmsApptTypeLazyQuery>;
export type GetPmsApptTypeSuspenseQueryHookResult = ReturnType<typeof useGetPmsApptTypeSuspenseQuery>;
export type GetPmsApptTypeQueryResult = Apollo.QueryResult<GetPmsApptTypeQuery, GetPmsApptTypeQueryVariables>;
export const GetPmsApptTypesForClinicDocument = gql`
    query getPmsApptTypesForClinic($clinicId: ID!) {
  getPmsApptTypesForClinic(clinicId: $clinicId) {
    ...PmsApptTypeFields
  }
}
    ${PmsApptTypeFieldsFragmentDoc}`;

/**
 * __useGetPmsApptTypesForClinicQuery__
 *
 * To run a query within a React component, call `useGetPmsApptTypesForClinicQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetPmsApptTypesForClinicQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetPmsApptTypesForClinicQuery({
 *   variables: {
 *      clinicId: // value for 'clinicId'
 *   },
 * });
 */
export function useGetPmsApptTypesForClinicQuery(baseOptions: Apollo.QueryHookOptions<GetPmsApptTypesForClinicQuery, GetPmsApptTypesForClinicQueryVariables> & ({ variables: GetPmsApptTypesForClinicQueryVariables; skip?: boolean; } | { skip: boolean; }) ) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<GetPmsApptTypesForClinicQuery, GetPmsApptTypesForClinicQueryVariables>(GetPmsApptTypesForClinicDocument, options);
      }
export function useGetPmsApptTypesForClinicLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<GetPmsApptTypesForClinicQuery, GetPmsApptTypesForClinicQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<GetPmsApptTypesForClinicQuery, GetPmsApptTypesForClinicQueryVariables>(GetPmsApptTypesForClinicDocument, options);
        }
export function useGetPmsApptTypesForClinicSuspenseQuery(baseOptions?: Apollo.SuspenseQueryHookOptions<GetPmsApptTypesForClinicQuery, GetPmsApptTypesForClinicQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useSuspenseQuery<GetPmsApptTypesForClinicQuery, GetPmsApptTypesForClinicQueryVariables>(GetPmsApptTypesForClinicDocument, options);
        }
export type GetPmsApptTypesForClinicQueryHookResult = ReturnType<typeof useGetPmsApptTypesForClinicQuery>;
export type GetPmsApptTypesForClinicLazyQueryHookResult = ReturnType<typeof useGetPmsApptTypesForClinicLazyQuery>;
export type GetPmsApptTypesForClinicSuspenseQueryHookResult = ReturnType<typeof useGetPmsApptTypesForClinicSuspenseQuery>;
export type GetPmsApptTypesForClinicQueryResult = Apollo.QueryResult<GetPmsApptTypesForClinicQuery, GetPmsApptTypesForClinicQueryVariables>;
export const QueryPmsApptTypesDocument = gql`
    query queryPmsApptTypes($where: [QueryInput!], $page: NonNegativeInt, $pageSize: NonNegativeInt, $orderBy: OrderByInput) {
  queryPmsApptTypes(
    where: $where
    page: $page
    pageSize: $pageSize
    orderBy: $orderBy
  ) {
    ...PmsApptTypeFields
  }
}
    ${PmsApptTypeFieldsFragmentDoc}`;

/**
 * __useQueryPmsApptTypesQuery__
 *
 * To run a query within a React component, call `useQueryPmsApptTypesQuery` and pass it any options that fit your needs.
 * When your component renders, `useQueryPmsApptTypesQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useQueryPmsApptTypesQuery({
 *   variables: {
 *      where: // value for 'where'
 *      page: // value for 'page'
 *      pageSize: // value for 'pageSize'
 *      orderBy: // value for 'orderBy'
 *   },
 * });
 */
export function useQueryPmsApptTypesQuery(baseOptions?: Apollo.QueryHookOptions<QueryPmsApptTypesQuery, QueryPmsApptTypesQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<QueryPmsApptTypesQuery, QueryPmsApptTypesQueryVariables>(QueryPmsApptTypesDocument, options);
      }
export function useQueryPmsApptTypesLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<QueryPmsApptTypesQuery, QueryPmsApptTypesQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<QueryPmsApptTypesQuery, QueryPmsApptTypesQueryVariables>(QueryPmsApptTypesDocument, options);
        }
export function useQueryPmsApptTypesSuspenseQuery(baseOptions?: Apollo.SuspenseQueryHookOptions<QueryPmsApptTypesQuery, QueryPmsApptTypesQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useSuspenseQuery<QueryPmsApptTypesQuery, QueryPmsApptTypesQueryVariables>(QueryPmsApptTypesDocument, options);
        }
export type QueryPmsApptTypesQueryHookResult = ReturnType<typeof useQueryPmsApptTypesQuery>;
export type QueryPmsApptTypesLazyQueryHookResult = ReturnType<typeof useQueryPmsApptTypesLazyQuery>;
export type QueryPmsApptTypesSuspenseQueryHookResult = ReturnType<typeof useQueryPmsApptTypesSuspenseQuery>;
export type QueryPmsApptTypesQueryResult = Apollo.QueryResult<QueryPmsApptTypesQuery, QueryPmsApptTypesQueryVariables>;
export const QueryPmsApptTypesWithClinicDocument = gql`
    query queryPmsApptTypesWithClinic($where: [QueryInput!], $page: NonNegativeInt, $pageSize: NonNegativeInt, $orderBy: OrderByInput) {
  queryPmsApptTypes(
    where: $where
    page: $page
    pageSize: $pageSize
    orderBy: $orderBy
  ) {
    ...PmsApptTypeFields
    clinic {
      id
      name
    }
  }
}
    ${PmsApptTypeFieldsFragmentDoc}`;

/**
 * __useQueryPmsApptTypesWithClinicQuery__
 *
 * To run a query within a React component, call `useQueryPmsApptTypesWithClinicQuery` and pass it any options that fit your needs.
 * When your component renders, `useQueryPmsApptTypesWithClinicQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useQueryPmsApptTypesWithClinicQuery({
 *   variables: {
 *      where: // value for 'where'
 *      page: // value for 'page'
 *      pageSize: // value for 'pageSize'
 *      orderBy: // value for 'orderBy'
 *   },
 * });
 */
export function useQueryPmsApptTypesWithClinicQuery(baseOptions?: Apollo.QueryHookOptions<QueryPmsApptTypesWithClinicQuery, QueryPmsApptTypesWithClinicQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<QueryPmsApptTypesWithClinicQuery, QueryPmsApptTypesWithClinicQueryVariables>(QueryPmsApptTypesWithClinicDocument, options);
      }
export function useQueryPmsApptTypesWithClinicLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<QueryPmsApptTypesWithClinicQuery, QueryPmsApptTypesWithClinicQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<QueryPmsApptTypesWithClinicQuery, QueryPmsApptTypesWithClinicQueryVariables>(QueryPmsApptTypesWithClinicDocument, options);
        }
export function useQueryPmsApptTypesWithClinicSuspenseQuery(baseOptions?: Apollo.SuspenseQueryHookOptions<QueryPmsApptTypesWithClinicQuery, QueryPmsApptTypesWithClinicQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useSuspenseQuery<QueryPmsApptTypesWithClinicQuery, QueryPmsApptTypesWithClinicQueryVariables>(QueryPmsApptTypesWithClinicDocument, options);
        }
export type QueryPmsApptTypesWithClinicQueryHookResult = ReturnType<typeof useQueryPmsApptTypesWithClinicQuery>;
export type QueryPmsApptTypesWithClinicLazyQueryHookResult = ReturnType<typeof useQueryPmsApptTypesWithClinicLazyQuery>;
export type QueryPmsApptTypesWithClinicSuspenseQueryHookResult = ReturnType<typeof useQueryPmsApptTypesWithClinicSuspenseQuery>;
export type QueryPmsApptTypesWithClinicQueryResult = Apollo.QueryResult<QueryPmsApptTypesWithClinicQuery, QueryPmsApptTypesWithClinicQueryVariables>;
export const GetSyncedCloudPmsDbsDocument = gql`
    query getSyncedCloudPmsDbs {
  getSyncedCloudPmsDbs {
    ...PmsDbFields
  }
}
    ${PmsDbFieldsFragmentDoc}`;

/**
 * __useGetSyncedCloudPmsDbsQuery__
 *
 * To run a query within a React component, call `useGetSyncedCloudPmsDbsQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetSyncedCloudPmsDbsQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetSyncedCloudPmsDbsQuery({
 *   variables: {
 *   },
 * });
 */
export function useGetSyncedCloudPmsDbsQuery(baseOptions?: Apollo.QueryHookOptions<GetSyncedCloudPmsDbsQuery, GetSyncedCloudPmsDbsQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<GetSyncedCloudPmsDbsQuery, GetSyncedCloudPmsDbsQueryVariables>(GetSyncedCloudPmsDbsDocument, options);
      }
export function useGetSyncedCloudPmsDbsLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<GetSyncedCloudPmsDbsQuery, GetSyncedCloudPmsDbsQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<GetSyncedCloudPmsDbsQuery, GetSyncedCloudPmsDbsQueryVariables>(GetSyncedCloudPmsDbsDocument, options);
        }
export function useGetSyncedCloudPmsDbsSuspenseQuery(baseOptions?: Apollo.SuspenseQueryHookOptions<GetSyncedCloudPmsDbsQuery, GetSyncedCloudPmsDbsQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useSuspenseQuery<GetSyncedCloudPmsDbsQuery, GetSyncedCloudPmsDbsQueryVariables>(GetSyncedCloudPmsDbsDocument, options);
        }
export type GetSyncedCloudPmsDbsQueryHookResult = ReturnType<typeof useGetSyncedCloudPmsDbsQuery>;
export type GetSyncedCloudPmsDbsLazyQueryHookResult = ReturnType<typeof useGetSyncedCloudPmsDbsLazyQuery>;
export type GetSyncedCloudPmsDbsSuspenseQueryHookResult = ReturnType<typeof useGetSyncedCloudPmsDbsSuspenseQuery>;
export type GetSyncedCloudPmsDbsQueryResult = Apollo.QueryResult<GetSyncedCloudPmsDbsQuery, GetSyncedCloudPmsDbsQueryVariables>;
export const QueryPmsDbsDocument = gql`
    query queryPmsDbs($where: [QueryInput!], $page: NonNegativeInt, $pageSize: NonNegativeInt, $orderBy: OrderByInput) {
  queryPmsDbs(where: $where, page: $page, pageSize: $pageSize, orderBy: $orderBy) {
    ...PmsDbFields
  }
}
    ${PmsDbFieldsFragmentDoc}`;

/**
 * __useQueryPmsDbsQuery__
 *
 * To run a query within a React component, call `useQueryPmsDbsQuery` and pass it any options that fit your needs.
 * When your component renders, `useQueryPmsDbsQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useQueryPmsDbsQuery({
 *   variables: {
 *      where: // value for 'where'
 *      page: // value for 'page'
 *      pageSize: // value for 'pageSize'
 *      orderBy: // value for 'orderBy'
 *   },
 * });
 */
export function useQueryPmsDbsQuery(baseOptions?: Apollo.QueryHookOptions<QueryPmsDbsQuery, QueryPmsDbsQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<QueryPmsDbsQuery, QueryPmsDbsQueryVariables>(QueryPmsDbsDocument, options);
      }
export function useQueryPmsDbsLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<QueryPmsDbsQuery, QueryPmsDbsQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<QueryPmsDbsQuery, QueryPmsDbsQueryVariables>(QueryPmsDbsDocument, options);
        }
export function useQueryPmsDbsSuspenseQuery(baseOptions?: Apollo.SuspenseQueryHookOptions<QueryPmsDbsQuery, QueryPmsDbsQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useSuspenseQuery<QueryPmsDbsQuery, QueryPmsDbsQueryVariables>(QueryPmsDbsDocument, options);
        }
export type QueryPmsDbsQueryHookResult = ReturnType<typeof useQueryPmsDbsQuery>;
export type QueryPmsDbsLazyQueryHookResult = ReturnType<typeof useQueryPmsDbsLazyQuery>;
export type QueryPmsDbsSuspenseQueryHookResult = ReturnType<typeof useQueryPmsDbsSuspenseQuery>;
export type QueryPmsDbsQueryResult = Apollo.QueryResult<QueryPmsDbsQuery, QueryPmsDbsQueryVariables>;
export const CountPmsDbsDocument = gql`
    query countPmsDbs($where: [QueryInput!]) {
  countPmsDbs(where: $where)
}
    `;

/**
 * __useCountPmsDbsQuery__
 *
 * To run a query within a React component, call `useCountPmsDbsQuery` and pass it any options that fit your needs.
 * When your component renders, `useCountPmsDbsQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useCountPmsDbsQuery({
 *   variables: {
 *      where: // value for 'where'
 *   },
 * });
 */
export function useCountPmsDbsQuery(baseOptions?: Apollo.QueryHookOptions<CountPmsDbsQuery, CountPmsDbsQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<CountPmsDbsQuery, CountPmsDbsQueryVariables>(CountPmsDbsDocument, options);
      }
export function useCountPmsDbsLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<CountPmsDbsQuery, CountPmsDbsQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<CountPmsDbsQuery, CountPmsDbsQueryVariables>(CountPmsDbsDocument, options);
        }
export function useCountPmsDbsSuspenseQuery(baseOptions?: Apollo.SuspenseQueryHookOptions<CountPmsDbsQuery, CountPmsDbsQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useSuspenseQuery<CountPmsDbsQuery, CountPmsDbsQueryVariables>(CountPmsDbsDocument, options);
        }
export type CountPmsDbsQueryHookResult = ReturnType<typeof useCountPmsDbsQuery>;
export type CountPmsDbsLazyQueryHookResult = ReturnType<typeof useCountPmsDbsLazyQuery>;
export type CountPmsDbsSuspenseQueryHookResult = ReturnType<typeof useCountPmsDbsSuspenseQuery>;
export type CountPmsDbsQueryResult = Apollo.QueryResult<CountPmsDbsQuery, CountPmsDbsQueryVariables>;
export const GetPmsDbDocument = gql`
    query getPmsDb($id: ID!) {
  pmsDb(id: $id) {
    ...PmsDbFields
  }
}
    ${PmsDbFieldsFragmentDoc}`;

/**
 * __useGetPmsDbQuery__
 *
 * To run a query within a React component, call `useGetPmsDbQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetPmsDbQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetPmsDbQuery({
 *   variables: {
 *      id: // value for 'id'
 *   },
 * });
 */
export function useGetPmsDbQuery(baseOptions: Apollo.QueryHookOptions<GetPmsDbQuery, GetPmsDbQueryVariables> & ({ variables: GetPmsDbQueryVariables; skip?: boolean; } | { skip: boolean; }) ) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<GetPmsDbQuery, GetPmsDbQueryVariables>(GetPmsDbDocument, options);
      }
export function useGetPmsDbLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<GetPmsDbQuery, GetPmsDbQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<GetPmsDbQuery, GetPmsDbQueryVariables>(GetPmsDbDocument, options);
        }
export function useGetPmsDbSuspenseQuery(baseOptions?: Apollo.SuspenseQueryHookOptions<GetPmsDbQuery, GetPmsDbQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useSuspenseQuery<GetPmsDbQuery, GetPmsDbQueryVariables>(GetPmsDbDocument, options);
        }
export type GetPmsDbQueryHookResult = ReturnType<typeof useGetPmsDbQuery>;
export type GetPmsDbLazyQueryHookResult = ReturnType<typeof useGetPmsDbLazyQuery>;
export type GetPmsDbSuspenseQueryHookResult = ReturnType<typeof useGetPmsDbSuspenseQuery>;
export type GetPmsDbQueryResult = Apollo.QueryResult<GetPmsDbQuery, GetPmsDbQueryVariables>;
export const CreatePmsDbDocument = gql`
    mutation createPmsDb($data: CreatePmsDbInput!, $shouldCreateWidget: Boolean) {
  createPmsDb(data: $data, shouldCreateWidget: $shouldCreateWidget) {
    ...PmsDbFields
  }
}
    ${PmsDbFieldsFragmentDoc}`;
export type CreatePmsDbMutationFn = Apollo.MutationFunction<CreatePmsDbMutation, CreatePmsDbMutationVariables>;

/**
 * __useCreatePmsDbMutation__
 *
 * To run a mutation, you first call `useCreatePmsDbMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useCreatePmsDbMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [createPmsDbMutation, { data, loading, error }] = useCreatePmsDbMutation({
 *   variables: {
 *      data: // value for 'data'
 *      shouldCreateWidget: // value for 'shouldCreateWidget'
 *   },
 * });
 */
export function useCreatePmsDbMutation(baseOptions?: Apollo.MutationHookOptions<CreatePmsDbMutation, CreatePmsDbMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<CreatePmsDbMutation, CreatePmsDbMutationVariables>(CreatePmsDbDocument, options);
      }
export type CreatePmsDbMutationHookResult = ReturnType<typeof useCreatePmsDbMutation>;
export type CreatePmsDbMutationResult = Apollo.MutationResult<CreatePmsDbMutation>;
export type CreatePmsDbMutationOptions = Apollo.BaseMutationOptions<CreatePmsDbMutation, CreatePmsDbMutationVariables>;
export const GetPmsTagDocument = gql`
    query getPmsTag($id: ID!) {
  pmsTag(id: $id) {
    ...PmsTagFields
  }
}
    ${PmsTagFieldsFragmentDoc}`;

/**
 * __useGetPmsTagQuery__
 *
 * To run a query within a React component, call `useGetPmsTagQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetPmsTagQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetPmsTagQuery({
 *   variables: {
 *      id: // value for 'id'
 *   },
 * });
 */
export function useGetPmsTagQuery(baseOptions: Apollo.QueryHookOptions<GetPmsTagQuery, GetPmsTagQueryVariables> & ({ variables: GetPmsTagQueryVariables; skip?: boolean; } | { skip: boolean; }) ) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<GetPmsTagQuery, GetPmsTagQueryVariables>(GetPmsTagDocument, options);
      }
export function useGetPmsTagLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<GetPmsTagQuery, GetPmsTagQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<GetPmsTagQuery, GetPmsTagQueryVariables>(GetPmsTagDocument, options);
        }
export function useGetPmsTagSuspenseQuery(baseOptions?: Apollo.SuspenseQueryHookOptions<GetPmsTagQuery, GetPmsTagQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useSuspenseQuery<GetPmsTagQuery, GetPmsTagQueryVariables>(GetPmsTagDocument, options);
        }
export type GetPmsTagQueryHookResult = ReturnType<typeof useGetPmsTagQuery>;
export type GetPmsTagLazyQueryHookResult = ReturnType<typeof useGetPmsTagLazyQuery>;
export type GetPmsTagSuspenseQueryHookResult = ReturnType<typeof useGetPmsTagSuspenseQuery>;
export type GetPmsTagQueryResult = Apollo.QueryResult<GetPmsTagQuery, GetPmsTagQueryVariables>;
export const QueryPmsTagsDocument = gql`
    query queryPmsTags($where: [QueryInput!], $page: NonNegativeInt, $pageSize: NonNegativeInt, $orderBy: OrderByInput) {
  queryPmsTags(where: $where, page: $page, pageSize: $pageSize, orderBy: $orderBy) {
    ...PmsTagFields
  }
}
    ${PmsTagFieldsFragmentDoc}`;

/**
 * __useQueryPmsTagsQuery__
 *
 * To run a query within a React component, call `useQueryPmsTagsQuery` and pass it any options that fit your needs.
 * When your component renders, `useQueryPmsTagsQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useQueryPmsTagsQuery({
 *   variables: {
 *      where: // value for 'where'
 *      page: // value for 'page'
 *      pageSize: // value for 'pageSize'
 *      orderBy: // value for 'orderBy'
 *   },
 * });
 */
export function useQueryPmsTagsQuery(baseOptions?: Apollo.QueryHookOptions<QueryPmsTagsQuery, QueryPmsTagsQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<QueryPmsTagsQuery, QueryPmsTagsQueryVariables>(QueryPmsTagsDocument, options);
      }
export function useQueryPmsTagsLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<QueryPmsTagsQuery, QueryPmsTagsQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<QueryPmsTagsQuery, QueryPmsTagsQueryVariables>(QueryPmsTagsDocument, options);
        }
export function useQueryPmsTagsSuspenseQuery(baseOptions?: Apollo.SuspenseQueryHookOptions<QueryPmsTagsQuery, QueryPmsTagsQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useSuspenseQuery<QueryPmsTagsQuery, QueryPmsTagsQueryVariables>(QueryPmsTagsDocument, options);
        }
export type QueryPmsTagsQueryHookResult = ReturnType<typeof useQueryPmsTagsQuery>;
export type QueryPmsTagsLazyQueryHookResult = ReturnType<typeof useQueryPmsTagsLazyQuery>;
export type QueryPmsTagsSuspenseQueryHookResult = ReturnType<typeof useQueryPmsTagsSuspenseQuery>;
export type QueryPmsTagsQueryResult = Apollo.QueryResult<QueryPmsTagsQuery, QueryPmsTagsQueryVariables>;
export const CountPmsTagsDocument = gql`
    query countPmsTags($where: [QueryInput!]) {
  countPmsTags(where: $where)
}
    `;

/**
 * __useCountPmsTagsQuery__
 *
 * To run a query within a React component, call `useCountPmsTagsQuery` and pass it any options that fit your needs.
 * When your component renders, `useCountPmsTagsQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useCountPmsTagsQuery({
 *   variables: {
 *      where: // value for 'where'
 *   },
 * });
 */
export function useCountPmsTagsQuery(baseOptions?: Apollo.QueryHookOptions<CountPmsTagsQuery, CountPmsTagsQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<CountPmsTagsQuery, CountPmsTagsQueryVariables>(CountPmsTagsDocument, options);
      }
export function useCountPmsTagsLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<CountPmsTagsQuery, CountPmsTagsQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<CountPmsTagsQuery, CountPmsTagsQueryVariables>(CountPmsTagsDocument, options);
        }
export function useCountPmsTagsSuspenseQuery(baseOptions?: Apollo.SuspenseQueryHookOptions<CountPmsTagsQuery, CountPmsTagsQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useSuspenseQuery<CountPmsTagsQuery, CountPmsTagsQueryVariables>(CountPmsTagsDocument, options);
        }
export type CountPmsTagsQueryHookResult = ReturnType<typeof useCountPmsTagsQuery>;
export type CountPmsTagsLazyQueryHookResult = ReturnType<typeof useCountPmsTagsLazyQuery>;
export type CountPmsTagsSuspenseQueryHookResult = ReturnType<typeof useCountPmsTagsSuspenseQuery>;
export type CountPmsTagsQueryResult = Apollo.QueryResult<CountPmsTagsQuery, CountPmsTagsQueryVariables>;
export const QueryPmsTagCategoriesDocument = gql`
    query queryPmsTagCategories($where: [QueryInput!], $page: NonNegativeInt, $pageSize: NonNegativeInt, $orderBy: OrderByInput) {
  queryPmsTagCategories(
    where: $where
    page: $page
    pageSize: $pageSize
    orderBy: $orderBy
  ) {
    ...PmsTagCategoryFields
  }
}
    ${PmsTagCategoryFieldsFragmentDoc}`;

/**
 * __useQueryPmsTagCategoriesQuery__
 *
 * To run a query within a React component, call `useQueryPmsTagCategoriesQuery` and pass it any options that fit your needs.
 * When your component renders, `useQueryPmsTagCategoriesQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useQueryPmsTagCategoriesQuery({
 *   variables: {
 *      where: // value for 'where'
 *      page: // value for 'page'
 *      pageSize: // value for 'pageSize'
 *      orderBy: // value for 'orderBy'
 *   },
 * });
 */
export function useQueryPmsTagCategoriesQuery(baseOptions?: Apollo.QueryHookOptions<QueryPmsTagCategoriesQuery, QueryPmsTagCategoriesQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<QueryPmsTagCategoriesQuery, QueryPmsTagCategoriesQueryVariables>(QueryPmsTagCategoriesDocument, options);
      }
export function useQueryPmsTagCategoriesLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<QueryPmsTagCategoriesQuery, QueryPmsTagCategoriesQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<QueryPmsTagCategoriesQuery, QueryPmsTagCategoriesQueryVariables>(QueryPmsTagCategoriesDocument, options);
        }
export function useQueryPmsTagCategoriesSuspenseQuery(baseOptions?: Apollo.SuspenseQueryHookOptions<QueryPmsTagCategoriesQuery, QueryPmsTagCategoriesQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useSuspenseQuery<QueryPmsTagCategoriesQuery, QueryPmsTagCategoriesQueryVariables>(QueryPmsTagCategoriesDocument, options);
        }
export type QueryPmsTagCategoriesQueryHookResult = ReturnType<typeof useQueryPmsTagCategoriesQuery>;
export type QueryPmsTagCategoriesLazyQueryHookResult = ReturnType<typeof useQueryPmsTagCategoriesLazyQuery>;
export type QueryPmsTagCategoriesSuspenseQueryHookResult = ReturnType<typeof useQueryPmsTagCategoriesSuspenseQuery>;
export type QueryPmsTagCategoriesQueryResult = Apollo.QueryResult<QueryPmsTagCategoriesQuery, QueryPmsTagCategoriesQueryVariables>;
export const CountPmsTagCategoriesDocument = gql`
    query countPmsTagCategories($where: [QueryInput!]) {
  countPmsTagCategories(where: $where)
}
    `;

/**
 * __useCountPmsTagCategoriesQuery__
 *
 * To run a query within a React component, call `useCountPmsTagCategoriesQuery` and pass it any options that fit your needs.
 * When your component renders, `useCountPmsTagCategoriesQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useCountPmsTagCategoriesQuery({
 *   variables: {
 *      where: // value for 'where'
 *   },
 * });
 */
export function useCountPmsTagCategoriesQuery(baseOptions?: Apollo.QueryHookOptions<CountPmsTagCategoriesQuery, CountPmsTagCategoriesQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<CountPmsTagCategoriesQuery, CountPmsTagCategoriesQueryVariables>(CountPmsTagCategoriesDocument, options);
      }
export function useCountPmsTagCategoriesLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<CountPmsTagCategoriesQuery, CountPmsTagCategoriesQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<CountPmsTagCategoriesQuery, CountPmsTagCategoriesQueryVariables>(CountPmsTagCategoriesDocument, options);
        }
export function useCountPmsTagCategoriesSuspenseQuery(baseOptions?: Apollo.SuspenseQueryHookOptions<CountPmsTagCategoriesQuery, CountPmsTagCategoriesQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useSuspenseQuery<CountPmsTagCategoriesQuery, CountPmsTagCategoriesQueryVariables>(CountPmsTagCategoriesDocument, options);
        }
export type CountPmsTagCategoriesQueryHookResult = ReturnType<typeof useCountPmsTagCategoriesQuery>;
export type CountPmsTagCategoriesLazyQueryHookResult = ReturnType<typeof useCountPmsTagCategoriesLazyQuery>;
export type CountPmsTagCategoriesSuspenseQueryHookResult = ReturnType<typeof useCountPmsTagCategoriesSuspenseQuery>;
export type CountPmsTagCategoriesQueryResult = Apollo.QueryResult<CountPmsTagCategoriesQuery, CountPmsTagCategoriesQueryVariables>;
export const QueryPrescriptionRefillRequestsDocument = gql`
    query queryPrescriptionRefillRequests($where: [QueryInput!], $page: NonNegativeInt, $pageSize: NonNegativeInt, $orderBy: OrderByInput) {
  queryPrescriptionRefillRequests(
    where: $where
    page: $page
    pageSize: $pageSize
    orderBy: $orderBy
  ) {
    ...PrescriptionRefillRequestFields
  }
}
    ${PrescriptionRefillRequestFieldsFragmentDoc}`;

/**
 * __useQueryPrescriptionRefillRequestsQuery__
 *
 * To run a query within a React component, call `useQueryPrescriptionRefillRequestsQuery` and pass it any options that fit your needs.
 * When your component renders, `useQueryPrescriptionRefillRequestsQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useQueryPrescriptionRefillRequestsQuery({
 *   variables: {
 *      where: // value for 'where'
 *      page: // value for 'page'
 *      pageSize: // value for 'pageSize'
 *      orderBy: // value for 'orderBy'
 *   },
 * });
 */
export function useQueryPrescriptionRefillRequestsQuery(baseOptions?: Apollo.QueryHookOptions<QueryPrescriptionRefillRequestsQuery, QueryPrescriptionRefillRequestsQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<QueryPrescriptionRefillRequestsQuery, QueryPrescriptionRefillRequestsQueryVariables>(QueryPrescriptionRefillRequestsDocument, options);
      }
export function useQueryPrescriptionRefillRequestsLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<QueryPrescriptionRefillRequestsQuery, QueryPrescriptionRefillRequestsQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<QueryPrescriptionRefillRequestsQuery, QueryPrescriptionRefillRequestsQueryVariables>(QueryPrescriptionRefillRequestsDocument, options);
        }
export function useQueryPrescriptionRefillRequestsSuspenseQuery(baseOptions?: Apollo.SuspenseQueryHookOptions<QueryPrescriptionRefillRequestsQuery, QueryPrescriptionRefillRequestsQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useSuspenseQuery<QueryPrescriptionRefillRequestsQuery, QueryPrescriptionRefillRequestsQueryVariables>(QueryPrescriptionRefillRequestsDocument, options);
        }
export type QueryPrescriptionRefillRequestsQueryHookResult = ReturnType<typeof useQueryPrescriptionRefillRequestsQuery>;
export type QueryPrescriptionRefillRequestsLazyQueryHookResult = ReturnType<typeof useQueryPrescriptionRefillRequestsLazyQuery>;
export type QueryPrescriptionRefillRequestsSuspenseQueryHookResult = ReturnType<typeof useQueryPrescriptionRefillRequestsSuspenseQuery>;
export type QueryPrescriptionRefillRequestsQueryResult = Apollo.QueryResult<QueryPrescriptionRefillRequestsQuery, QueryPrescriptionRefillRequestsQueryVariables>;
export const CountPrescriptionRefillRequestsDocument = gql`
    query countPrescriptionRefillRequests($where: [QueryInput!]) {
  countPrescriptionRefillRequests(where: $where)
}
    `;

/**
 * __useCountPrescriptionRefillRequestsQuery__
 *
 * To run a query within a React component, call `useCountPrescriptionRefillRequestsQuery` and pass it any options that fit your needs.
 * When your component renders, `useCountPrescriptionRefillRequestsQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useCountPrescriptionRefillRequestsQuery({
 *   variables: {
 *      where: // value for 'where'
 *   },
 * });
 */
export function useCountPrescriptionRefillRequestsQuery(baseOptions?: Apollo.QueryHookOptions<CountPrescriptionRefillRequestsQuery, CountPrescriptionRefillRequestsQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<CountPrescriptionRefillRequestsQuery, CountPrescriptionRefillRequestsQueryVariables>(CountPrescriptionRefillRequestsDocument, options);
      }
export function useCountPrescriptionRefillRequestsLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<CountPrescriptionRefillRequestsQuery, CountPrescriptionRefillRequestsQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<CountPrescriptionRefillRequestsQuery, CountPrescriptionRefillRequestsQueryVariables>(CountPrescriptionRefillRequestsDocument, options);
        }
export function useCountPrescriptionRefillRequestsSuspenseQuery(baseOptions?: Apollo.SuspenseQueryHookOptions<CountPrescriptionRefillRequestsQuery, CountPrescriptionRefillRequestsQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useSuspenseQuery<CountPrescriptionRefillRequestsQuery, CountPrescriptionRefillRequestsQueryVariables>(CountPrescriptionRefillRequestsDocument, options);
        }
export type CountPrescriptionRefillRequestsQueryHookResult = ReturnType<typeof useCountPrescriptionRefillRequestsQuery>;
export type CountPrescriptionRefillRequestsLazyQueryHookResult = ReturnType<typeof useCountPrescriptionRefillRequestsLazyQuery>;
export type CountPrescriptionRefillRequestsSuspenseQueryHookResult = ReturnType<typeof useCountPrescriptionRefillRequestsSuspenseQuery>;
export type CountPrescriptionRefillRequestsQueryResult = Apollo.QueryResult<CountPrescriptionRefillRequestsQuery, CountPrescriptionRefillRequestsQueryVariables>;
export const ApprovePrescriptionRefillRequestDocument = gql`
    mutation approvePrescriptionRefillRequest($id: ID!, $actionItemId: ID) {
  approvePrescriptionRefillRequest(id: $id, actionItemId: $actionItemId) {
    ...PrescriptionRefillRequestFields
  }
}
    ${PrescriptionRefillRequestFieldsFragmentDoc}`;
export type ApprovePrescriptionRefillRequestMutationFn = Apollo.MutationFunction<ApprovePrescriptionRefillRequestMutation, ApprovePrescriptionRefillRequestMutationVariables>;

/**
 * __useApprovePrescriptionRefillRequestMutation__
 *
 * To run a mutation, you first call `useApprovePrescriptionRefillRequestMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useApprovePrescriptionRefillRequestMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [approvePrescriptionRefillRequestMutation, { data, loading, error }] = useApprovePrescriptionRefillRequestMutation({
 *   variables: {
 *      id: // value for 'id'
 *      actionItemId: // value for 'actionItemId'
 *   },
 * });
 */
export function useApprovePrescriptionRefillRequestMutation(baseOptions?: Apollo.MutationHookOptions<ApprovePrescriptionRefillRequestMutation, ApprovePrescriptionRefillRequestMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<ApprovePrescriptionRefillRequestMutation, ApprovePrescriptionRefillRequestMutationVariables>(ApprovePrescriptionRefillRequestDocument, options);
      }
export type ApprovePrescriptionRefillRequestMutationHookResult = ReturnType<typeof useApprovePrescriptionRefillRequestMutation>;
export type ApprovePrescriptionRefillRequestMutationResult = Apollo.MutationResult<ApprovePrescriptionRefillRequestMutation>;
export type ApprovePrescriptionRefillRequestMutationOptions = Apollo.BaseMutationOptions<ApprovePrescriptionRefillRequestMutation, ApprovePrescriptionRefillRequestMutationVariables>;
export const DenyPrescriptionRefillRequestDocument = gql`
    mutation denyPrescriptionRefillRequest($id: ID!, $reason: String!, $actionItemId: ID) {
  denyPrescriptionRefillRequest(
    id: $id
    reason: $reason
    actionItemId: $actionItemId
  ) {
    ...PrescriptionRefillRequestFields
  }
}
    ${PrescriptionRefillRequestFieldsFragmentDoc}`;
export type DenyPrescriptionRefillRequestMutationFn = Apollo.MutationFunction<DenyPrescriptionRefillRequestMutation, DenyPrescriptionRefillRequestMutationVariables>;

/**
 * __useDenyPrescriptionRefillRequestMutation__
 *
 * To run a mutation, you first call `useDenyPrescriptionRefillRequestMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useDenyPrescriptionRefillRequestMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [denyPrescriptionRefillRequestMutation, { data, loading, error }] = useDenyPrescriptionRefillRequestMutation({
 *   variables: {
 *      id: // value for 'id'
 *      reason: // value for 'reason'
 *      actionItemId: // value for 'actionItemId'
 *   },
 * });
 */
export function useDenyPrescriptionRefillRequestMutation(baseOptions?: Apollo.MutationHookOptions<DenyPrescriptionRefillRequestMutation, DenyPrescriptionRefillRequestMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<DenyPrescriptionRefillRequestMutation, DenyPrescriptionRefillRequestMutationVariables>(DenyPrescriptionRefillRequestDocument, options);
      }
export type DenyPrescriptionRefillRequestMutationHookResult = ReturnType<typeof useDenyPrescriptionRefillRequestMutation>;
export type DenyPrescriptionRefillRequestMutationResult = Apollo.MutationResult<DenyPrescriptionRefillRequestMutation>;
export type DenyPrescriptionRefillRequestMutationOptions = Apollo.BaseMutationOptions<DenyPrescriptionRefillRequestMutation, DenyPrescriptionRefillRequestMutationVariables>;
export const CancelPrescriptionRefillRequestDocument = gql`
    mutation cancelPrescriptionRefillRequest($id: ID!, $actionItemId: ID) {
  cancelPrescriptionRefillRequest(id: $id, actionItemId: $actionItemId) {
    ...PrescriptionRefillRequestFields
  }
}
    ${PrescriptionRefillRequestFieldsFragmentDoc}`;
export type CancelPrescriptionRefillRequestMutationFn = Apollo.MutationFunction<CancelPrescriptionRefillRequestMutation, CancelPrescriptionRefillRequestMutationVariables>;

/**
 * __useCancelPrescriptionRefillRequestMutation__
 *
 * To run a mutation, you first call `useCancelPrescriptionRefillRequestMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useCancelPrescriptionRefillRequestMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [cancelPrescriptionRefillRequestMutation, { data, loading, error }] = useCancelPrescriptionRefillRequestMutation({
 *   variables: {
 *      id: // value for 'id'
 *      actionItemId: // value for 'actionItemId'
 *   },
 * });
 */
export function useCancelPrescriptionRefillRequestMutation(baseOptions?: Apollo.MutationHookOptions<CancelPrescriptionRefillRequestMutation, CancelPrescriptionRefillRequestMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<CancelPrescriptionRefillRequestMutation, CancelPrescriptionRefillRequestMutationVariables>(CancelPrescriptionRefillRequestDocument, options);
      }
export type CancelPrescriptionRefillRequestMutationHookResult = ReturnType<typeof useCancelPrescriptionRefillRequestMutation>;
export type CancelPrescriptionRefillRequestMutationResult = Apollo.MutationResult<CancelPrescriptionRefillRequestMutation>;
export type CancelPrescriptionRefillRequestMutationOptions = Apollo.BaseMutationOptions<CancelPrescriptionRefillRequestMutation, CancelPrescriptionRefillRequestMutationVariables>;
export const QueryPrescriptionsDocument = gql`
    query queryPrescriptions($where: [QueryInput!], $page: NonNegativeInt, $pageSize: NonNegativeInt, $orderBy: OrderByInput) {
  queryPrescriptions(
    where: $where
    page: $page
    pageSize: $pageSize
    orderBy: $orderBy
  ) {
    ...PrescriptionFields
  }
}
    ${PrescriptionFieldsFragmentDoc}`;

/**
 * __useQueryPrescriptionsQuery__
 *
 * To run a query within a React component, call `useQueryPrescriptionsQuery` and pass it any options that fit your needs.
 * When your component renders, `useQueryPrescriptionsQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useQueryPrescriptionsQuery({
 *   variables: {
 *      where: // value for 'where'
 *      page: // value for 'page'
 *      pageSize: // value for 'pageSize'
 *      orderBy: // value for 'orderBy'
 *   },
 * });
 */
export function useQueryPrescriptionsQuery(baseOptions?: Apollo.QueryHookOptions<QueryPrescriptionsQuery, QueryPrescriptionsQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<QueryPrescriptionsQuery, QueryPrescriptionsQueryVariables>(QueryPrescriptionsDocument, options);
      }
export function useQueryPrescriptionsLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<QueryPrescriptionsQuery, QueryPrescriptionsQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<QueryPrescriptionsQuery, QueryPrescriptionsQueryVariables>(QueryPrescriptionsDocument, options);
        }
export function useQueryPrescriptionsSuspenseQuery(baseOptions?: Apollo.SuspenseQueryHookOptions<QueryPrescriptionsQuery, QueryPrescriptionsQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useSuspenseQuery<QueryPrescriptionsQuery, QueryPrescriptionsQueryVariables>(QueryPrescriptionsDocument, options);
        }
export type QueryPrescriptionsQueryHookResult = ReturnType<typeof useQueryPrescriptionsQuery>;
export type QueryPrescriptionsLazyQueryHookResult = ReturnType<typeof useQueryPrescriptionsLazyQuery>;
export type QueryPrescriptionsSuspenseQueryHookResult = ReturnType<typeof useQueryPrescriptionsSuspenseQuery>;
export type QueryPrescriptionsQueryResult = Apollo.QueryResult<QueryPrescriptionsQuery, QueryPrescriptionsQueryVariables>;
export const CountPrescriptionsDocument = gql`
    query countPrescriptions($where: [QueryInput!]) {
  countPrescriptions(where: $where)
}
    `;

/**
 * __useCountPrescriptionsQuery__
 *
 * To run a query within a React component, call `useCountPrescriptionsQuery` and pass it any options that fit your needs.
 * When your component renders, `useCountPrescriptionsQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useCountPrescriptionsQuery({
 *   variables: {
 *      where: // value for 'where'
 *   },
 * });
 */
export function useCountPrescriptionsQuery(baseOptions?: Apollo.QueryHookOptions<CountPrescriptionsQuery, CountPrescriptionsQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<CountPrescriptionsQuery, CountPrescriptionsQueryVariables>(CountPrescriptionsDocument, options);
      }
export function useCountPrescriptionsLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<CountPrescriptionsQuery, CountPrescriptionsQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<CountPrescriptionsQuery, CountPrescriptionsQueryVariables>(CountPrescriptionsDocument, options);
        }
export function useCountPrescriptionsSuspenseQuery(baseOptions?: Apollo.SuspenseQueryHookOptions<CountPrescriptionsQuery, CountPrescriptionsQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useSuspenseQuery<CountPrescriptionsQuery, CountPrescriptionsQueryVariables>(CountPrescriptionsDocument, options);
        }
export type CountPrescriptionsQueryHookResult = ReturnType<typeof useCountPrescriptionsQuery>;
export type CountPrescriptionsLazyQueryHookResult = ReturnType<typeof useCountPrescriptionsLazyQuery>;
export type CountPrescriptionsSuspenseQueryHookResult = ReturnType<typeof useCountPrescriptionsSuspenseQuery>;
export type CountPrescriptionsQueryResult = Apollo.QueryResult<CountPrescriptionsQuery, CountPrescriptionsQueryVariables>;
export const GetPressItemDocument = gql`
    query getPressItem($id: ID!) {
  pressItem(id: $id) {
    ...PressItemFields
  }
}
    ${PressItemFieldsFragmentDoc}`;

/**
 * __useGetPressItemQuery__
 *
 * To run a query within a React component, call `useGetPressItemQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetPressItemQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetPressItemQuery({
 *   variables: {
 *      id: // value for 'id'
 *   },
 * });
 */
export function useGetPressItemQuery(baseOptions: Apollo.QueryHookOptions<GetPressItemQuery, GetPressItemQueryVariables> & ({ variables: GetPressItemQueryVariables; skip?: boolean; } | { skip: boolean; }) ) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<GetPressItemQuery, GetPressItemQueryVariables>(GetPressItemDocument, options);
      }
export function useGetPressItemLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<GetPressItemQuery, GetPressItemQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<GetPressItemQuery, GetPressItemQueryVariables>(GetPressItemDocument, options);
        }
export function useGetPressItemSuspenseQuery(baseOptions?: Apollo.SuspenseQueryHookOptions<GetPressItemQuery, GetPressItemQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useSuspenseQuery<GetPressItemQuery, GetPressItemQueryVariables>(GetPressItemDocument, options);
        }
export type GetPressItemQueryHookResult = ReturnType<typeof useGetPressItemQuery>;
export type GetPressItemLazyQueryHookResult = ReturnType<typeof useGetPressItemLazyQuery>;
export type GetPressItemSuspenseQueryHookResult = ReturnType<typeof useGetPressItemSuspenseQuery>;
export type GetPressItemQueryResult = Apollo.QueryResult<GetPressItemQuery, GetPressItemQueryVariables>;
export const CreatePressItemDocument = gql`
    mutation createPressItem($data: CreatePressItemInput!) {
  createPressItem(data: $data) {
    ...PressItemFields
  }
}
    ${PressItemFieldsFragmentDoc}`;
export type CreatePressItemMutationFn = Apollo.MutationFunction<CreatePressItemMutation, CreatePressItemMutationVariables>;

/**
 * __useCreatePressItemMutation__
 *
 * To run a mutation, you first call `useCreatePressItemMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useCreatePressItemMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [createPressItemMutation, { data, loading, error }] = useCreatePressItemMutation({
 *   variables: {
 *      data: // value for 'data'
 *   },
 * });
 */
export function useCreatePressItemMutation(baseOptions?: Apollo.MutationHookOptions<CreatePressItemMutation, CreatePressItemMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<CreatePressItemMutation, CreatePressItemMutationVariables>(CreatePressItemDocument, options);
      }
export type CreatePressItemMutationHookResult = ReturnType<typeof useCreatePressItemMutation>;
export type CreatePressItemMutationResult = Apollo.MutationResult<CreatePressItemMutation>;
export type CreatePressItemMutationOptions = Apollo.BaseMutationOptions<CreatePressItemMutation, CreatePressItemMutationVariables>;
export const UpdatePressItemDocument = gql`
    mutation updatePressItem($id: ID!, $data: UpdatePressItemInput!) {
  updatePressItem(id: $id, data: $data) {
    ...PressItemFields
  }
}
    ${PressItemFieldsFragmentDoc}`;
export type UpdatePressItemMutationFn = Apollo.MutationFunction<UpdatePressItemMutation, UpdatePressItemMutationVariables>;

/**
 * __useUpdatePressItemMutation__
 *
 * To run a mutation, you first call `useUpdatePressItemMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useUpdatePressItemMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [updatePressItemMutation, { data, loading, error }] = useUpdatePressItemMutation({
 *   variables: {
 *      id: // value for 'id'
 *      data: // value for 'data'
 *   },
 * });
 */
export function useUpdatePressItemMutation(baseOptions?: Apollo.MutationHookOptions<UpdatePressItemMutation, UpdatePressItemMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<UpdatePressItemMutation, UpdatePressItemMutationVariables>(UpdatePressItemDocument, options);
      }
export type UpdatePressItemMutationHookResult = ReturnType<typeof useUpdatePressItemMutation>;
export type UpdatePressItemMutationResult = Apollo.MutationResult<UpdatePressItemMutation>;
export type UpdatePressItemMutationOptions = Apollo.BaseMutationOptions<UpdatePressItemMutation, UpdatePressItemMutationVariables>;
export const DeletePressItemDocument = gql`
    mutation deletePressItem($id: ID!) {
  deletePressItem(id: $id)
}
    `;
export type DeletePressItemMutationFn = Apollo.MutationFunction<DeletePressItemMutation, DeletePressItemMutationVariables>;

/**
 * __useDeletePressItemMutation__
 *
 * To run a mutation, you first call `useDeletePressItemMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useDeletePressItemMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [deletePressItemMutation, { data, loading, error }] = useDeletePressItemMutation({
 *   variables: {
 *      id: // value for 'id'
 *   },
 * });
 */
export function useDeletePressItemMutation(baseOptions?: Apollo.MutationHookOptions<DeletePressItemMutation, DeletePressItemMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<DeletePressItemMutation, DeletePressItemMutationVariables>(DeletePressItemDocument, options);
      }
export type DeletePressItemMutationHookResult = ReturnType<typeof useDeletePressItemMutation>;
export type DeletePressItemMutationResult = Apollo.MutationResult<DeletePressItemMutation>;
export type DeletePressItemMutationOptions = Apollo.BaseMutationOptions<DeletePressItemMutation, DeletePressItemMutationVariables>;
export const GetPrescriptionPricingDocument = gql`
    query getPrescriptionPricing($productId: ID!, $units: NonNegativeFloat!, $clinicId: ID, $unitPriceOverride: NonNegativeInt, $feeSplitPercentageOverride: Float) {
  prescriptionPricing(
    productId: $productId
    units: $units
    clinicId: $clinicId
    unitPriceOverride: $unitPriceOverride
    feeSplitPercentageOverride: $feeSplitPercentageOverride
  ) {
    ...PrescriptionPricingFields
  }
}
    ${PrescriptionPricingFieldsFragmentDoc}`;

/**
 * __useGetPrescriptionPricingQuery__
 *
 * To run a query within a React component, call `useGetPrescriptionPricingQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetPrescriptionPricingQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetPrescriptionPricingQuery({
 *   variables: {
 *      productId: // value for 'productId'
 *      units: // value for 'units'
 *      clinicId: // value for 'clinicId'
 *      unitPriceOverride: // value for 'unitPriceOverride'
 *      feeSplitPercentageOverride: // value for 'feeSplitPercentageOverride'
 *   },
 * });
 */
export function useGetPrescriptionPricingQuery(baseOptions: Apollo.QueryHookOptions<GetPrescriptionPricingQuery, GetPrescriptionPricingQueryVariables> & ({ variables: GetPrescriptionPricingQueryVariables; skip?: boolean; } | { skip: boolean; }) ) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<GetPrescriptionPricingQuery, GetPrescriptionPricingQueryVariables>(GetPrescriptionPricingDocument, options);
      }
export function useGetPrescriptionPricingLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<GetPrescriptionPricingQuery, GetPrescriptionPricingQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<GetPrescriptionPricingQuery, GetPrescriptionPricingQueryVariables>(GetPrescriptionPricingDocument, options);
        }
export function useGetPrescriptionPricingSuspenseQuery(baseOptions?: Apollo.SuspenseQueryHookOptions<GetPrescriptionPricingQuery, GetPrescriptionPricingQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useSuspenseQuery<GetPrescriptionPricingQuery, GetPrescriptionPricingQueryVariables>(GetPrescriptionPricingDocument, options);
        }
export type GetPrescriptionPricingQueryHookResult = ReturnType<typeof useGetPrescriptionPricingQuery>;
export type GetPrescriptionPricingLazyQueryHookResult = ReturnType<typeof useGetPrescriptionPricingLazyQuery>;
export type GetPrescriptionPricingSuspenseQueryHookResult = ReturnType<typeof useGetPrescriptionPricingSuspenseQuery>;
export type GetPrescriptionPricingQueryResult = Apollo.QueryResult<GetPrescriptionPricingQuery, GetPrescriptionPricingQueryVariables>;
export const QueryProductsDocument = gql`
    query queryProducts($where: [QueryInput!], $page: NonNegativeInt, $pageSize: NonNegativeInt, $orderBy: OrderByInput) {
  queryProducts(
    where: $where
    page: $page
    pageSize: $pageSize
    orderBy: $orderBy
  ) {
    ...ProductFields
  }
}
    ${ProductFieldsFragmentDoc}`;

/**
 * __useQueryProductsQuery__
 *
 * To run a query within a React component, call `useQueryProductsQuery` and pass it any options that fit your needs.
 * When your component renders, `useQueryProductsQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useQueryProductsQuery({
 *   variables: {
 *      where: // value for 'where'
 *      page: // value for 'page'
 *      pageSize: // value for 'pageSize'
 *      orderBy: // value for 'orderBy'
 *   },
 * });
 */
export function useQueryProductsQuery(baseOptions?: Apollo.QueryHookOptions<QueryProductsQuery, QueryProductsQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<QueryProductsQuery, QueryProductsQueryVariables>(QueryProductsDocument, options);
      }
export function useQueryProductsLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<QueryProductsQuery, QueryProductsQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<QueryProductsQuery, QueryProductsQueryVariables>(QueryProductsDocument, options);
        }
export function useQueryProductsSuspenseQuery(baseOptions?: Apollo.SuspenseQueryHookOptions<QueryProductsQuery, QueryProductsQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useSuspenseQuery<QueryProductsQuery, QueryProductsQueryVariables>(QueryProductsDocument, options);
        }
export type QueryProductsQueryHookResult = ReturnType<typeof useQueryProductsQuery>;
export type QueryProductsLazyQueryHookResult = ReturnType<typeof useQueryProductsLazyQuery>;
export type QueryProductsSuspenseQueryHookResult = ReturnType<typeof useQueryProductsSuspenseQuery>;
export type QueryProductsQueryResult = Apollo.QueryResult<QueryProductsQuery, QueryProductsQueryVariables>;
export const CountProductsDocument = gql`
    query countProducts($where: [QueryInput!]) {
  countProducts(where: $where)
}
    `;

/**
 * __useCountProductsQuery__
 *
 * To run a query within a React component, call `useCountProductsQuery` and pass it any options that fit your needs.
 * When your component renders, `useCountProductsQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useCountProductsQuery({
 *   variables: {
 *      where: // value for 'where'
 *   },
 * });
 */
export function useCountProductsQuery(baseOptions?: Apollo.QueryHookOptions<CountProductsQuery, CountProductsQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<CountProductsQuery, CountProductsQueryVariables>(CountProductsDocument, options);
      }
export function useCountProductsLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<CountProductsQuery, CountProductsQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<CountProductsQuery, CountProductsQueryVariables>(CountProductsDocument, options);
        }
export function useCountProductsSuspenseQuery(baseOptions?: Apollo.SuspenseQueryHookOptions<CountProductsQuery, CountProductsQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useSuspenseQuery<CountProductsQuery, CountProductsQueryVariables>(CountProductsDocument, options);
        }
export type CountProductsQueryHookResult = ReturnType<typeof useCountProductsQuery>;
export type CountProductsLazyQueryHookResult = ReturnType<typeof useCountProductsLazyQuery>;
export type CountProductsSuspenseQueryHookResult = ReturnType<typeof useCountProductsSuspenseQuery>;
export type CountProductsQueryResult = Apollo.QueryResult<CountProductsQuery, CountProductsQueryVariables>;
export const UpdateProductDocument = gql`
    mutation updateProduct($productId: ID!, $data: UpdateProductInput!) {
  updateProduct(productId: $productId, data: $data) {
    ...ProductFields
  }
}
    ${ProductFieldsFragmentDoc}`;
export type UpdateProductMutationFn = Apollo.MutationFunction<UpdateProductMutation, UpdateProductMutationVariables>;

/**
 * __useUpdateProductMutation__
 *
 * To run a mutation, you first call `useUpdateProductMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useUpdateProductMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [updateProductMutation, { data, loading, error }] = useUpdateProductMutation({
 *   variables: {
 *      productId: // value for 'productId'
 *      data: // value for 'data'
 *   },
 * });
 */
export function useUpdateProductMutation(baseOptions?: Apollo.MutationHookOptions<UpdateProductMutation, UpdateProductMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<UpdateProductMutation, UpdateProductMutationVariables>(UpdateProductDocument, options);
      }
export type UpdateProductMutationHookResult = ReturnType<typeof useUpdateProductMutation>;
export type UpdateProductMutationResult = Apollo.MutationResult<UpdateProductMutation>;
export type UpdateProductMutationOptions = Apollo.BaseMutationOptions<UpdateProductMutation, UpdateProductMutationVariables>;
export const SearchClinicProductsDocument = gql`
    query searchClinicProducts($clinicId: ID!, $options: SearchClinicProductsOptions!) {
  searchClinicProducts(clinicId: $clinicId, options: $options) {
    products {
      ...ProductFields
    }
    count
  }
}
    ${ProductFieldsFragmentDoc}`;

/**
 * __useSearchClinicProductsQuery__
 *
 * To run a query within a React component, call `useSearchClinicProductsQuery` and pass it any options that fit your needs.
 * When your component renders, `useSearchClinicProductsQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useSearchClinicProductsQuery({
 *   variables: {
 *      clinicId: // value for 'clinicId'
 *      options: // value for 'options'
 *   },
 * });
 */
export function useSearchClinicProductsQuery(baseOptions: Apollo.QueryHookOptions<SearchClinicProductsQuery, SearchClinicProductsQueryVariables> & ({ variables: SearchClinicProductsQueryVariables; skip?: boolean; } | { skip: boolean; }) ) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<SearchClinicProductsQuery, SearchClinicProductsQueryVariables>(SearchClinicProductsDocument, options);
      }
export function useSearchClinicProductsLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<SearchClinicProductsQuery, SearchClinicProductsQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<SearchClinicProductsQuery, SearchClinicProductsQueryVariables>(SearchClinicProductsDocument, options);
        }
export function useSearchClinicProductsSuspenseQuery(baseOptions?: Apollo.SuspenseQueryHookOptions<SearchClinicProductsQuery, SearchClinicProductsQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useSuspenseQuery<SearchClinicProductsQuery, SearchClinicProductsQueryVariables>(SearchClinicProductsDocument, options);
        }
export type SearchClinicProductsQueryHookResult = ReturnType<typeof useSearchClinicProductsQuery>;
export type SearchClinicProductsLazyQueryHookResult = ReturnType<typeof useSearchClinicProductsLazyQuery>;
export type SearchClinicProductsSuspenseQueryHookResult = ReturnType<typeof useSearchClinicProductsSuspenseQuery>;
export type SearchClinicProductsQueryResult = Apollo.QueryResult<SearchClinicProductsQuery, SearchClinicProductsQueryVariables>;
export const GetPmsCodesForClinicDocument = gql`
    query getPmsCodesForClinic($clinicId: ID!, $query: String) {
  getPmsCodesForClinic(clinicId: $clinicId, query: $query) {
    ...PmsCodeFields
  }
}
    ${PmsCodeFieldsFragmentDoc}`;

/**
 * __useGetPmsCodesForClinicQuery__
 *
 * To run a query within a React component, call `useGetPmsCodesForClinicQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetPmsCodesForClinicQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetPmsCodesForClinicQuery({
 *   variables: {
 *      clinicId: // value for 'clinicId'
 *      query: // value for 'query'
 *   },
 * });
 */
export function useGetPmsCodesForClinicQuery(baseOptions: Apollo.QueryHookOptions<GetPmsCodesForClinicQuery, GetPmsCodesForClinicQueryVariables> & ({ variables: GetPmsCodesForClinicQueryVariables; skip?: boolean; } | { skip: boolean; }) ) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<GetPmsCodesForClinicQuery, GetPmsCodesForClinicQueryVariables>(GetPmsCodesForClinicDocument, options);
      }
export function useGetPmsCodesForClinicLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<GetPmsCodesForClinicQuery, GetPmsCodesForClinicQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<GetPmsCodesForClinicQuery, GetPmsCodesForClinicQueryVariables>(GetPmsCodesForClinicDocument, options);
        }
export function useGetPmsCodesForClinicSuspenseQuery(baseOptions?: Apollo.SuspenseQueryHookOptions<GetPmsCodesForClinicQuery, GetPmsCodesForClinicQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useSuspenseQuery<GetPmsCodesForClinicQuery, GetPmsCodesForClinicQueryVariables>(GetPmsCodesForClinicDocument, options);
        }
export type GetPmsCodesForClinicQueryHookResult = ReturnType<typeof useGetPmsCodesForClinicQuery>;
export type GetPmsCodesForClinicLazyQueryHookResult = ReturnType<typeof useGetPmsCodesForClinicLazyQuery>;
export type GetPmsCodesForClinicSuspenseQueryHookResult = ReturnType<typeof useGetPmsCodesForClinicSuspenseQuery>;
export type GetPmsCodesForClinicQueryResult = Apollo.QueryResult<GetPmsCodesForClinicQuery, GetPmsCodesForClinicQueryVariables>;
export const ExecuteApprovedChangeDocument = gql`
    mutation executeApprovedChange($input: ExecuteApprovedChangeInput!) {
  executeApprovedChange(input: $input) {
    success
    operation
    target_entity_type
    target_entity_id
    applied_fields
    message
  }
}
    `;
export type ExecuteApprovedChangeMutationFn = Apollo.MutationFunction<ExecuteApprovedChangeMutation, ExecuteApprovedChangeMutationVariables>;

/**
 * __useExecuteApprovedChangeMutation__
 *
 * To run a mutation, you first call `useExecuteApprovedChangeMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useExecuteApprovedChangeMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [executeApprovedChangeMutation, { data, loading, error }] = useExecuteApprovedChangeMutation({
 *   variables: {
 *      input: // value for 'input'
 *   },
 * });
 */
export function useExecuteApprovedChangeMutation(baseOptions?: Apollo.MutationHookOptions<ExecuteApprovedChangeMutation, ExecuteApprovedChangeMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<ExecuteApprovedChangeMutation, ExecuteApprovedChangeMutationVariables>(ExecuteApprovedChangeDocument, options);
      }
export type ExecuteApprovedChangeMutationHookResult = ReturnType<typeof useExecuteApprovedChangeMutation>;
export type ExecuteApprovedChangeMutationResult = Apollo.MutationResult<ExecuteApprovedChangeMutation>;
export type ExecuteApprovedChangeMutationOptions = Apollo.BaseMutationOptions<ExecuteApprovedChangeMutation, ExecuteApprovedChangeMutationVariables>;
export const TriggerSyncForClinicDocument = gql`
    mutation triggerSyncForClinic($clinicId: ID!, $isFullSync: Boolean!) {
  triggerSyncForClinic(clinicId: $clinicId, isFullSync: $isFullSync)
}
    `;
export type TriggerSyncForClinicMutationFn = Apollo.MutationFunction<TriggerSyncForClinicMutation, TriggerSyncForClinicMutationVariables>;

/**
 * __useTriggerSyncForClinicMutation__
 *
 * To run a mutation, you first call `useTriggerSyncForClinicMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useTriggerSyncForClinicMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [triggerSyncForClinicMutation, { data, loading, error }] = useTriggerSyncForClinicMutation({
 *   variables: {
 *      clinicId: // value for 'clinicId'
 *      isFullSync: // value for 'isFullSync'
 *   },
 * });
 */
export function useTriggerSyncForClinicMutation(baseOptions?: Apollo.MutationHookOptions<TriggerSyncForClinicMutation, TriggerSyncForClinicMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<TriggerSyncForClinicMutation, TriggerSyncForClinicMutationVariables>(TriggerSyncForClinicDocument, options);
      }
export type TriggerSyncForClinicMutationHookResult = ReturnType<typeof useTriggerSyncForClinicMutation>;
export type TriggerSyncForClinicMutationResult = Apollo.MutationResult<TriggerSyncForClinicMutation>;
export type TriggerSyncForClinicMutationOptions = Apollo.BaseMutationOptions<TriggerSyncForClinicMutation, TriggerSyncForClinicMutationVariables>;
export const QueryReschedulesDocument = gql`
    query queryReschedules($where: [QueryInput!], $page: NonNegativeInt, $pageSize: NonNegativeInt, $orderBy: OrderByInput) {
  queryReschedules(
    where: $where
    page: $page
    pageSize: $pageSize
    orderBy: $orderBy
  ) {
    ...RescheduleFields
  }
}
    ${RescheduleFieldsFragmentDoc}`;

/**
 * __useQueryReschedulesQuery__
 *
 * To run a query within a React component, call `useQueryReschedulesQuery` and pass it any options that fit your needs.
 * When your component renders, `useQueryReschedulesQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useQueryReschedulesQuery({
 *   variables: {
 *      where: // value for 'where'
 *      page: // value for 'page'
 *      pageSize: // value for 'pageSize'
 *      orderBy: // value for 'orderBy'
 *   },
 * });
 */
export function useQueryReschedulesQuery(baseOptions?: Apollo.QueryHookOptions<QueryReschedulesQuery, QueryReschedulesQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<QueryReschedulesQuery, QueryReschedulesQueryVariables>(QueryReschedulesDocument, options);
      }
export function useQueryReschedulesLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<QueryReschedulesQuery, QueryReschedulesQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<QueryReschedulesQuery, QueryReschedulesQueryVariables>(QueryReschedulesDocument, options);
        }
export function useQueryReschedulesSuspenseQuery(baseOptions?: Apollo.SuspenseQueryHookOptions<QueryReschedulesQuery, QueryReschedulesQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useSuspenseQuery<QueryReschedulesQuery, QueryReschedulesQueryVariables>(QueryReschedulesDocument, options);
        }
export type QueryReschedulesQueryHookResult = ReturnType<typeof useQueryReschedulesQuery>;
export type QueryReschedulesLazyQueryHookResult = ReturnType<typeof useQueryReschedulesLazyQuery>;
export type QueryReschedulesSuspenseQueryHookResult = ReturnType<typeof useQueryReschedulesSuspenseQuery>;
export type QueryReschedulesQueryResult = Apollo.QueryResult<QueryReschedulesQuery, QueryReschedulesQueryVariables>;
export const UpdateRescheduleDocument = gql`
    mutation updateReschedule($id: ID!, $data: UpdateRescheduleInput!) {
  updateReschedule(id: $id, data: $data) {
    ...RescheduleFields
  }
}
    ${RescheduleFieldsFragmentDoc}`;
export type UpdateRescheduleMutationFn = Apollo.MutationFunction<UpdateRescheduleMutation, UpdateRescheduleMutationVariables>;

/**
 * __useUpdateRescheduleMutation__
 *
 * To run a mutation, you first call `useUpdateRescheduleMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useUpdateRescheduleMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [updateRescheduleMutation, { data, loading, error }] = useUpdateRescheduleMutation({
 *   variables: {
 *      id: // value for 'id'
 *      data: // value for 'data'
 *   },
 * });
 */
export function useUpdateRescheduleMutation(baseOptions?: Apollo.MutationHookOptions<UpdateRescheduleMutation, UpdateRescheduleMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<UpdateRescheduleMutation, UpdateRescheduleMutationVariables>(UpdateRescheduleDocument, options);
      }
export type UpdateRescheduleMutationHookResult = ReturnType<typeof useUpdateRescheduleMutation>;
export type UpdateRescheduleMutationResult = Apollo.MutationResult<UpdateRescheduleMutation>;
export type UpdateRescheduleMutationOptions = Apollo.BaseMutationOptions<UpdateRescheduleMutation, UpdateRescheduleMutationVariables>;
export const ApproveRescheduleDocument = gql`
    mutation approveReschedule($id: ID!, $skipSchedulingDateBounds: Boolean) {
  approveReschedule(id: $id, skipSchedulingDateBounds: $skipSchedulingDateBounds) {
    ...RescheduleFields
  }
}
    ${RescheduleFieldsFragmentDoc}`;
export type ApproveRescheduleMutationFn = Apollo.MutationFunction<ApproveRescheduleMutation, ApproveRescheduleMutationVariables>;

/**
 * __useApproveRescheduleMutation__
 *
 * To run a mutation, you first call `useApproveRescheduleMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useApproveRescheduleMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [approveRescheduleMutation, { data, loading, error }] = useApproveRescheduleMutation({
 *   variables: {
 *      id: // value for 'id'
 *      skipSchedulingDateBounds: // value for 'skipSchedulingDateBounds'
 *   },
 * });
 */
export function useApproveRescheduleMutation(baseOptions?: Apollo.MutationHookOptions<ApproveRescheduleMutation, ApproveRescheduleMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<ApproveRescheduleMutation, ApproveRescheduleMutationVariables>(ApproveRescheduleDocument, options);
      }
export type ApproveRescheduleMutationHookResult = ReturnType<typeof useApproveRescheduleMutation>;
export type ApproveRescheduleMutationResult = Apollo.MutationResult<ApproveRescheduleMutation>;
export type ApproveRescheduleMutationOptions = Apollo.BaseMutationOptions<ApproveRescheduleMutation, ApproveRescheduleMutationVariables>;
export const DenyRescheduleDocument = gql`
    mutation denyReschedule($id: ID!, $reason: String!) {
  denyReschedule(id: $id, reason: $reason) {
    ...RescheduleFields
  }
}
    ${RescheduleFieldsFragmentDoc}`;
export type DenyRescheduleMutationFn = Apollo.MutationFunction<DenyRescheduleMutation, DenyRescheduleMutationVariables>;

/**
 * __useDenyRescheduleMutation__
 *
 * To run a mutation, you first call `useDenyRescheduleMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useDenyRescheduleMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [denyRescheduleMutation, { data, loading, error }] = useDenyRescheduleMutation({
 *   variables: {
 *      id: // value for 'id'
 *      reason: // value for 'reason'
 *   },
 * });
 */
export function useDenyRescheduleMutation(baseOptions?: Apollo.MutationHookOptions<DenyRescheduleMutation, DenyRescheduleMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<DenyRescheduleMutation, DenyRescheduleMutationVariables>(DenyRescheduleDocument, options);
      }
export type DenyRescheduleMutationHookResult = ReturnType<typeof useDenyRescheduleMutation>;
export type DenyRescheduleMutationResult = Apollo.MutationResult<DenyRescheduleMutation>;
export type DenyRescheduleMutationOptions = Apollo.BaseMutationOptions<DenyRescheduleMutation, DenyRescheduleMutationVariables>;
export const GetReviewsForClinicDocument = gql`
    query getReviewsForClinic($clinicId: ID!) {
  getReviewsForClinic(clinicId: $clinicId) {
    ...ReviewFields
  }
}
    ${ReviewFieldsFragmentDoc}`;

/**
 * __useGetReviewsForClinicQuery__
 *
 * To run a query within a React component, call `useGetReviewsForClinicQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetReviewsForClinicQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetReviewsForClinicQuery({
 *   variables: {
 *      clinicId: // value for 'clinicId'
 *   },
 * });
 */
export function useGetReviewsForClinicQuery(baseOptions: Apollo.QueryHookOptions<GetReviewsForClinicQuery, GetReviewsForClinicQueryVariables> & ({ variables: GetReviewsForClinicQueryVariables; skip?: boolean; } | { skip: boolean; }) ) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<GetReviewsForClinicQuery, GetReviewsForClinicQueryVariables>(GetReviewsForClinicDocument, options);
      }
export function useGetReviewsForClinicLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<GetReviewsForClinicQuery, GetReviewsForClinicQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<GetReviewsForClinicQuery, GetReviewsForClinicQueryVariables>(GetReviewsForClinicDocument, options);
        }
export function useGetReviewsForClinicSuspenseQuery(baseOptions?: Apollo.SuspenseQueryHookOptions<GetReviewsForClinicQuery, GetReviewsForClinicQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useSuspenseQuery<GetReviewsForClinicQuery, GetReviewsForClinicQueryVariables>(GetReviewsForClinicDocument, options);
        }
export type GetReviewsForClinicQueryHookResult = ReturnType<typeof useGetReviewsForClinicQuery>;
export type GetReviewsForClinicLazyQueryHookResult = ReturnType<typeof useGetReviewsForClinicLazyQuery>;
export type GetReviewsForClinicSuspenseQueryHookResult = ReturnType<typeof useGetReviewsForClinicSuspenseQuery>;
export type GetReviewsForClinicQueryResult = Apollo.QueryResult<GetReviewsForClinicQuery, GetReviewsForClinicQueryVariables>;
export const QueryReviewsDocument = gql`
    query queryReviews($where: [QueryInput!], $page: NonNegativeInt, $pageSize: NonNegativeInt, $orderBy: OrderByInput) {
  queryReviews(where: $where, page: $page, pageSize: $pageSize, orderBy: $orderBy) {
    ...ReviewFields
  }
}
    ${ReviewFieldsFragmentDoc}`;

/**
 * __useQueryReviewsQuery__
 *
 * To run a query within a React component, call `useQueryReviewsQuery` and pass it any options that fit your needs.
 * When your component renders, `useQueryReviewsQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useQueryReviewsQuery({
 *   variables: {
 *      where: // value for 'where'
 *      page: // value for 'page'
 *      pageSize: // value for 'pageSize'
 *      orderBy: // value for 'orderBy'
 *   },
 * });
 */
export function useQueryReviewsQuery(baseOptions?: Apollo.QueryHookOptions<QueryReviewsQuery, QueryReviewsQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<QueryReviewsQuery, QueryReviewsQueryVariables>(QueryReviewsDocument, options);
      }
export function useQueryReviewsLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<QueryReviewsQuery, QueryReviewsQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<QueryReviewsQuery, QueryReviewsQueryVariables>(QueryReviewsDocument, options);
        }
export function useQueryReviewsSuspenseQuery(baseOptions?: Apollo.SuspenseQueryHookOptions<QueryReviewsQuery, QueryReviewsQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useSuspenseQuery<QueryReviewsQuery, QueryReviewsQueryVariables>(QueryReviewsDocument, options);
        }
export type QueryReviewsQueryHookResult = ReturnType<typeof useQueryReviewsQuery>;
export type QueryReviewsLazyQueryHookResult = ReturnType<typeof useQueryReviewsLazyQuery>;
export type QueryReviewsSuspenseQueryHookResult = ReturnType<typeof useQueryReviewsSuspenseQuery>;
export type QueryReviewsQueryResult = Apollo.QueryResult<QueryReviewsQuery, QueryReviewsQueryVariables>;
export const GetAverageRatingForRecentReviewsDocument = gql`
    query getAverageRatingForRecentReviews($clinicId: ID!, $maxCount: PositiveInt) {
  getAverageRatingForRecentReviews(clinicId: $clinicId, maxCount: $maxCount) {
    count
    total
  }
}
    `;

/**
 * __useGetAverageRatingForRecentReviewsQuery__
 *
 * To run a query within a React component, call `useGetAverageRatingForRecentReviewsQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetAverageRatingForRecentReviewsQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetAverageRatingForRecentReviewsQuery({
 *   variables: {
 *      clinicId: // value for 'clinicId'
 *      maxCount: // value for 'maxCount'
 *   },
 * });
 */
export function useGetAverageRatingForRecentReviewsQuery(baseOptions: Apollo.QueryHookOptions<GetAverageRatingForRecentReviewsQuery, GetAverageRatingForRecentReviewsQueryVariables> & ({ variables: GetAverageRatingForRecentReviewsQueryVariables; skip?: boolean; } | { skip: boolean; }) ) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<GetAverageRatingForRecentReviewsQuery, GetAverageRatingForRecentReviewsQueryVariables>(GetAverageRatingForRecentReviewsDocument, options);
      }
export function useGetAverageRatingForRecentReviewsLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<GetAverageRatingForRecentReviewsQuery, GetAverageRatingForRecentReviewsQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<GetAverageRatingForRecentReviewsQuery, GetAverageRatingForRecentReviewsQueryVariables>(GetAverageRatingForRecentReviewsDocument, options);
        }
export function useGetAverageRatingForRecentReviewsSuspenseQuery(baseOptions?: Apollo.SuspenseQueryHookOptions<GetAverageRatingForRecentReviewsQuery, GetAverageRatingForRecentReviewsQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useSuspenseQuery<GetAverageRatingForRecentReviewsQuery, GetAverageRatingForRecentReviewsQueryVariables>(GetAverageRatingForRecentReviewsDocument, options);
        }
export type GetAverageRatingForRecentReviewsQueryHookResult = ReturnType<typeof useGetAverageRatingForRecentReviewsQuery>;
export type GetAverageRatingForRecentReviewsLazyQueryHookResult = ReturnType<typeof useGetAverageRatingForRecentReviewsLazyQuery>;
export type GetAverageRatingForRecentReviewsSuspenseQueryHookResult = ReturnType<typeof useGetAverageRatingForRecentReviewsSuspenseQuery>;
export type GetAverageRatingForRecentReviewsQueryResult = Apollo.QueryResult<GetAverageRatingForRecentReviewsQuery, GetAverageRatingForRecentReviewsQueryVariables>;
export const GetAverageRatingForRecentReviewsForClinicsDocument = gql`
    query getAverageRatingForRecentReviewsForClinics($clinicIds: [ID!]!, $maxCount: PositiveInt) {
  getAverageRatingForRecentReviewsForClinics(
    clinicIds: $clinicIds
    maxCount: $maxCount
  ) {
    count
    total
  }
}
    `;

/**
 * __useGetAverageRatingForRecentReviewsForClinicsQuery__
 *
 * To run a query within a React component, call `useGetAverageRatingForRecentReviewsForClinicsQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetAverageRatingForRecentReviewsForClinicsQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetAverageRatingForRecentReviewsForClinicsQuery({
 *   variables: {
 *      clinicIds: // value for 'clinicIds'
 *      maxCount: // value for 'maxCount'
 *   },
 * });
 */
export function useGetAverageRatingForRecentReviewsForClinicsQuery(baseOptions: Apollo.QueryHookOptions<GetAverageRatingForRecentReviewsForClinicsQuery, GetAverageRatingForRecentReviewsForClinicsQueryVariables> & ({ variables: GetAverageRatingForRecentReviewsForClinicsQueryVariables; skip?: boolean; } | { skip: boolean; }) ) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<GetAverageRatingForRecentReviewsForClinicsQuery, GetAverageRatingForRecentReviewsForClinicsQueryVariables>(GetAverageRatingForRecentReviewsForClinicsDocument, options);
      }
export function useGetAverageRatingForRecentReviewsForClinicsLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<GetAverageRatingForRecentReviewsForClinicsQuery, GetAverageRatingForRecentReviewsForClinicsQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<GetAverageRatingForRecentReviewsForClinicsQuery, GetAverageRatingForRecentReviewsForClinicsQueryVariables>(GetAverageRatingForRecentReviewsForClinicsDocument, options);
        }
export function useGetAverageRatingForRecentReviewsForClinicsSuspenseQuery(baseOptions?: Apollo.SuspenseQueryHookOptions<GetAverageRatingForRecentReviewsForClinicsQuery, GetAverageRatingForRecentReviewsForClinicsQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useSuspenseQuery<GetAverageRatingForRecentReviewsForClinicsQuery, GetAverageRatingForRecentReviewsForClinicsQueryVariables>(GetAverageRatingForRecentReviewsForClinicsDocument, options);
        }
export type GetAverageRatingForRecentReviewsForClinicsQueryHookResult = ReturnType<typeof useGetAverageRatingForRecentReviewsForClinicsQuery>;
export type GetAverageRatingForRecentReviewsForClinicsLazyQueryHookResult = ReturnType<typeof useGetAverageRatingForRecentReviewsForClinicsLazyQuery>;
export type GetAverageRatingForRecentReviewsForClinicsSuspenseQueryHookResult = ReturnType<typeof useGetAverageRatingForRecentReviewsForClinicsSuspenseQuery>;
export type GetAverageRatingForRecentReviewsForClinicsQueryResult = Apollo.QueryResult<GetAverageRatingForRecentReviewsForClinicsQuery, GetAverageRatingForRecentReviewsForClinicsQueryVariables>;
export const CountReviewsDocument = gql`
    query countReviews($where: [QueryInput!]) {
  countReviews(where: $where)
}
    `;

/**
 * __useCountReviewsQuery__
 *
 * To run a query within a React component, call `useCountReviewsQuery` and pass it any options that fit your needs.
 * When your component renders, `useCountReviewsQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useCountReviewsQuery({
 *   variables: {
 *      where: // value for 'where'
 *   },
 * });
 */
export function useCountReviewsQuery(baseOptions?: Apollo.QueryHookOptions<CountReviewsQuery, CountReviewsQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<CountReviewsQuery, CountReviewsQueryVariables>(CountReviewsDocument, options);
      }
export function useCountReviewsLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<CountReviewsQuery, CountReviewsQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<CountReviewsQuery, CountReviewsQueryVariables>(CountReviewsDocument, options);
        }
export function useCountReviewsSuspenseQuery(baseOptions?: Apollo.SuspenseQueryHookOptions<CountReviewsQuery, CountReviewsQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useSuspenseQuery<CountReviewsQuery, CountReviewsQueryVariables>(CountReviewsDocument, options);
        }
export type CountReviewsQueryHookResult = ReturnType<typeof useCountReviewsQuery>;
export type CountReviewsLazyQueryHookResult = ReturnType<typeof useCountReviewsLazyQuery>;
export type CountReviewsSuspenseQueryHookResult = ReturnType<typeof useCountReviewsSuspenseQuery>;
export type CountReviewsQueryResult = Apollo.QueryResult<CountReviewsQuery, CountReviewsQueryVariables>;
export const ReviewAnalyticsDocument = gql`
    query reviewAnalytics($clinicIds: [ID!]!) {
  reviewAnalytics(clinicIds: $clinicIds) {
    ...ReviewAnalyticsFields
  }
}
    ${ReviewAnalyticsFieldsFragmentDoc}`;

/**
 * __useReviewAnalyticsQuery__
 *
 * To run a query within a React component, call `useReviewAnalyticsQuery` and pass it any options that fit your needs.
 * When your component renders, `useReviewAnalyticsQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useReviewAnalyticsQuery({
 *   variables: {
 *      clinicIds: // value for 'clinicIds'
 *   },
 * });
 */
export function useReviewAnalyticsQuery(baseOptions: Apollo.QueryHookOptions<ReviewAnalyticsQuery, ReviewAnalyticsQueryVariables> & ({ variables: ReviewAnalyticsQueryVariables; skip?: boolean; } | { skip: boolean; }) ) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<ReviewAnalyticsQuery, ReviewAnalyticsQueryVariables>(ReviewAnalyticsDocument, options);
      }
export function useReviewAnalyticsLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<ReviewAnalyticsQuery, ReviewAnalyticsQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<ReviewAnalyticsQuery, ReviewAnalyticsQueryVariables>(ReviewAnalyticsDocument, options);
        }
export function useReviewAnalyticsSuspenseQuery(baseOptions?: Apollo.SuspenseQueryHookOptions<ReviewAnalyticsQuery, ReviewAnalyticsQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useSuspenseQuery<ReviewAnalyticsQuery, ReviewAnalyticsQueryVariables>(ReviewAnalyticsDocument, options);
        }
export type ReviewAnalyticsQueryHookResult = ReturnType<typeof useReviewAnalyticsQuery>;
export type ReviewAnalyticsLazyQueryHookResult = ReturnType<typeof useReviewAnalyticsLazyQuery>;
export type ReviewAnalyticsSuspenseQueryHookResult = ReturnType<typeof useReviewAnalyticsSuspenseQuery>;
export type ReviewAnalyticsQueryResult = Apollo.QueryResult<ReviewAnalyticsQuery, ReviewAnalyticsQueryVariables>;
export const GetRoomServicesByServiceDocument = gql`
    query getRoomServicesByService($serviceId: ID!) {
  getRoomServicesByService(serviceId: $serviceId) {
    ...RoomServiceFields
  }
}
    ${RoomServiceFieldsFragmentDoc}`;

/**
 * __useGetRoomServicesByServiceQuery__
 *
 * To run a query within a React component, call `useGetRoomServicesByServiceQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetRoomServicesByServiceQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetRoomServicesByServiceQuery({
 *   variables: {
 *      serviceId: // value for 'serviceId'
 *   },
 * });
 */
export function useGetRoomServicesByServiceQuery(baseOptions: Apollo.QueryHookOptions<GetRoomServicesByServiceQuery, GetRoomServicesByServiceQueryVariables> & ({ variables: GetRoomServicesByServiceQueryVariables; skip?: boolean; } | { skip: boolean; }) ) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<GetRoomServicesByServiceQuery, GetRoomServicesByServiceQueryVariables>(GetRoomServicesByServiceDocument, options);
      }
export function useGetRoomServicesByServiceLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<GetRoomServicesByServiceQuery, GetRoomServicesByServiceQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<GetRoomServicesByServiceQuery, GetRoomServicesByServiceQueryVariables>(GetRoomServicesByServiceDocument, options);
        }
export function useGetRoomServicesByServiceSuspenseQuery(baseOptions?: Apollo.SuspenseQueryHookOptions<GetRoomServicesByServiceQuery, GetRoomServicesByServiceQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useSuspenseQuery<GetRoomServicesByServiceQuery, GetRoomServicesByServiceQueryVariables>(GetRoomServicesByServiceDocument, options);
        }
export type GetRoomServicesByServiceQueryHookResult = ReturnType<typeof useGetRoomServicesByServiceQuery>;
export type GetRoomServicesByServiceLazyQueryHookResult = ReturnType<typeof useGetRoomServicesByServiceLazyQuery>;
export type GetRoomServicesByServiceSuspenseQueryHookResult = ReturnType<typeof useGetRoomServicesByServiceSuspenseQuery>;
export type GetRoomServicesByServiceQueryResult = Apollo.QueryResult<GetRoomServicesByServiceQuery, GetRoomServicesByServiceQueryVariables>;
export const CreateRoomServiceDocument = gql`
    mutation createRoomService($data: CreateRoomServiceInput!) {
  createRoomService(data: $data) {
    ...RoomServiceFields
  }
}
    ${RoomServiceFieldsFragmentDoc}`;
export type CreateRoomServiceMutationFn = Apollo.MutationFunction<CreateRoomServiceMutation, CreateRoomServiceMutationVariables>;

/**
 * __useCreateRoomServiceMutation__
 *
 * To run a mutation, you first call `useCreateRoomServiceMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useCreateRoomServiceMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [createRoomServiceMutation, { data, loading, error }] = useCreateRoomServiceMutation({
 *   variables: {
 *      data: // value for 'data'
 *   },
 * });
 */
export function useCreateRoomServiceMutation(baseOptions?: Apollo.MutationHookOptions<CreateRoomServiceMutation, CreateRoomServiceMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<CreateRoomServiceMutation, CreateRoomServiceMutationVariables>(CreateRoomServiceDocument, options);
      }
export type CreateRoomServiceMutationHookResult = ReturnType<typeof useCreateRoomServiceMutation>;
export type CreateRoomServiceMutationResult = Apollo.MutationResult<CreateRoomServiceMutation>;
export type CreateRoomServiceMutationOptions = Apollo.BaseMutationOptions<CreateRoomServiceMutation, CreateRoomServiceMutationVariables>;
export const UpdateRoomServiceDocument = gql`
    mutation updateRoomService($id: ID!, $data: UpdateRoomServiceInput!) {
  updateRoomService(id: $id, data: $data) {
    ...RoomServiceFields
  }
}
    ${RoomServiceFieldsFragmentDoc}`;
export type UpdateRoomServiceMutationFn = Apollo.MutationFunction<UpdateRoomServiceMutation, UpdateRoomServiceMutationVariables>;

/**
 * __useUpdateRoomServiceMutation__
 *
 * To run a mutation, you first call `useUpdateRoomServiceMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useUpdateRoomServiceMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [updateRoomServiceMutation, { data, loading, error }] = useUpdateRoomServiceMutation({
 *   variables: {
 *      id: // value for 'id'
 *      data: // value for 'data'
 *   },
 * });
 */
export function useUpdateRoomServiceMutation(baseOptions?: Apollo.MutationHookOptions<UpdateRoomServiceMutation, UpdateRoomServiceMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<UpdateRoomServiceMutation, UpdateRoomServiceMutationVariables>(UpdateRoomServiceDocument, options);
      }
export type UpdateRoomServiceMutationHookResult = ReturnType<typeof useUpdateRoomServiceMutation>;
export type UpdateRoomServiceMutationResult = Apollo.MutationResult<UpdateRoomServiceMutation>;
export type UpdateRoomServiceMutationOptions = Apollo.BaseMutationOptions<UpdateRoomServiceMutation, UpdateRoomServiceMutationVariables>;
export const DeleteRoomServiceDocument = gql`
    mutation deleteRoomService($id: ID!) {
  deleteRoomService(id: $id)
}
    `;
export type DeleteRoomServiceMutationFn = Apollo.MutationFunction<DeleteRoomServiceMutation, DeleteRoomServiceMutationVariables>;

/**
 * __useDeleteRoomServiceMutation__
 *
 * To run a mutation, you first call `useDeleteRoomServiceMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useDeleteRoomServiceMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [deleteRoomServiceMutation, { data, loading, error }] = useDeleteRoomServiceMutation({
 *   variables: {
 *      id: // value for 'id'
 *   },
 * });
 */
export function useDeleteRoomServiceMutation(baseOptions?: Apollo.MutationHookOptions<DeleteRoomServiceMutation, DeleteRoomServiceMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<DeleteRoomServiceMutation, DeleteRoomServiceMutationVariables>(DeleteRoomServiceDocument, options);
      }
export type DeleteRoomServiceMutationHookResult = ReturnType<typeof useDeleteRoomServiceMutation>;
export type DeleteRoomServiceMutationResult = Apollo.MutationResult<DeleteRoomServiceMutation>;
export type DeleteRoomServiceMutationOptions = Apollo.BaseMutationOptions<DeleteRoomServiceMutation, DeleteRoomServiceMutationVariables>;
export const GetRoomDocument = gql`
    query getRoom($roomId: ID!) {
  room(roomId: $roomId) {
    ...RoomFields
  }
}
    ${RoomFieldsFragmentDoc}`;

/**
 * __useGetRoomQuery__
 *
 * To run a query within a React component, call `useGetRoomQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetRoomQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetRoomQuery({
 *   variables: {
 *      roomId: // value for 'roomId'
 *   },
 * });
 */
export function useGetRoomQuery(baseOptions: Apollo.QueryHookOptions<GetRoomQuery, GetRoomQueryVariables> & ({ variables: GetRoomQueryVariables; skip?: boolean; } | { skip: boolean; }) ) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<GetRoomQuery, GetRoomQueryVariables>(GetRoomDocument, options);
      }
export function useGetRoomLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<GetRoomQuery, GetRoomQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<GetRoomQuery, GetRoomQueryVariables>(GetRoomDocument, options);
        }
export function useGetRoomSuspenseQuery(baseOptions?: Apollo.SuspenseQueryHookOptions<GetRoomQuery, GetRoomQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useSuspenseQuery<GetRoomQuery, GetRoomQueryVariables>(GetRoomDocument, options);
        }
export type GetRoomQueryHookResult = ReturnType<typeof useGetRoomQuery>;
export type GetRoomLazyQueryHookResult = ReturnType<typeof useGetRoomLazyQuery>;
export type GetRoomSuspenseQueryHookResult = ReturnType<typeof useGetRoomSuspenseQuery>;
export type GetRoomQueryResult = Apollo.QueryResult<GetRoomQuery, GetRoomQueryVariables>;
export const QueryRoomsDocument = gql`
    query queryRooms($where: [QueryInput!], $page: NonNegativeInt, $pageSize: NonNegativeInt, $orderBy: OrderByInput) {
  queryRooms(where: $where, page: $page, pageSize: $pageSize, orderBy: $orderBy) {
    ...RoomFields
  }
}
    ${RoomFieldsFragmentDoc}`;

/**
 * __useQueryRoomsQuery__
 *
 * To run a query within a React component, call `useQueryRoomsQuery` and pass it any options that fit your needs.
 * When your component renders, `useQueryRoomsQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useQueryRoomsQuery({
 *   variables: {
 *      where: // value for 'where'
 *      page: // value for 'page'
 *      pageSize: // value for 'pageSize'
 *      orderBy: // value for 'orderBy'
 *   },
 * });
 */
export function useQueryRoomsQuery(baseOptions?: Apollo.QueryHookOptions<QueryRoomsQuery, QueryRoomsQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<QueryRoomsQuery, QueryRoomsQueryVariables>(QueryRoomsDocument, options);
      }
export function useQueryRoomsLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<QueryRoomsQuery, QueryRoomsQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<QueryRoomsQuery, QueryRoomsQueryVariables>(QueryRoomsDocument, options);
        }
export function useQueryRoomsSuspenseQuery(baseOptions?: Apollo.SuspenseQueryHookOptions<QueryRoomsQuery, QueryRoomsQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useSuspenseQuery<QueryRoomsQuery, QueryRoomsQueryVariables>(QueryRoomsDocument, options);
        }
export type QueryRoomsQueryHookResult = ReturnType<typeof useQueryRoomsQuery>;
export type QueryRoomsLazyQueryHookResult = ReturnType<typeof useQueryRoomsLazyQuery>;
export type QueryRoomsSuspenseQueryHookResult = ReturnType<typeof useQueryRoomsSuspenseQuery>;
export type QueryRoomsQueryResult = Apollo.QueryResult<QueryRoomsQuery, QueryRoomsQueryVariables>;
export const QueryPreviewRoomsDocument = gql`
    query queryPreviewRooms($where: [QueryInput!], $page: NonNegativeInt, $pageSize: NonNegativeInt, $orderBy: OrderByInput) {
  queryRooms(where: $where, page: $page, pageSize: $pageSize, orderBy: $orderBy) {
    ...RoomPreviewFields
  }
}
    ${RoomPreviewFieldsFragmentDoc}`;

/**
 * __useQueryPreviewRoomsQuery__
 *
 * To run a query within a React component, call `useQueryPreviewRoomsQuery` and pass it any options that fit your needs.
 * When your component renders, `useQueryPreviewRoomsQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useQueryPreviewRoomsQuery({
 *   variables: {
 *      where: // value for 'where'
 *      page: // value for 'page'
 *      pageSize: // value for 'pageSize'
 *      orderBy: // value for 'orderBy'
 *   },
 * });
 */
export function useQueryPreviewRoomsQuery(baseOptions?: Apollo.QueryHookOptions<QueryPreviewRoomsQuery, QueryPreviewRoomsQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<QueryPreviewRoomsQuery, QueryPreviewRoomsQueryVariables>(QueryPreviewRoomsDocument, options);
      }
export function useQueryPreviewRoomsLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<QueryPreviewRoomsQuery, QueryPreviewRoomsQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<QueryPreviewRoomsQuery, QueryPreviewRoomsQueryVariables>(QueryPreviewRoomsDocument, options);
        }
export function useQueryPreviewRoomsSuspenseQuery(baseOptions?: Apollo.SuspenseQueryHookOptions<QueryPreviewRoomsQuery, QueryPreviewRoomsQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useSuspenseQuery<QueryPreviewRoomsQuery, QueryPreviewRoomsQueryVariables>(QueryPreviewRoomsDocument, options);
        }
export type QueryPreviewRoomsQueryHookResult = ReturnType<typeof useQueryPreviewRoomsQuery>;
export type QueryPreviewRoomsLazyQueryHookResult = ReturnType<typeof useQueryPreviewRoomsLazyQuery>;
export type QueryPreviewRoomsSuspenseQueryHookResult = ReturnType<typeof useQueryPreviewRoomsSuspenseQuery>;
export type QueryPreviewRoomsQueryResult = Apollo.QueryResult<QueryPreviewRoomsQuery, QueryPreviewRoomsQueryVariables>;
export const CountRoomsDocument = gql`
    query countRooms($where: [QueryInput!]) {
  countRooms(where: $where)
}
    `;

/**
 * __useCountRoomsQuery__
 *
 * To run a query within a React component, call `useCountRoomsQuery` and pass it any options that fit your needs.
 * When your component renders, `useCountRoomsQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useCountRoomsQuery({
 *   variables: {
 *      where: // value for 'where'
 *   },
 * });
 */
export function useCountRoomsQuery(baseOptions?: Apollo.QueryHookOptions<CountRoomsQuery, CountRoomsQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<CountRoomsQuery, CountRoomsQueryVariables>(CountRoomsDocument, options);
      }
export function useCountRoomsLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<CountRoomsQuery, CountRoomsQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<CountRoomsQuery, CountRoomsQueryVariables>(CountRoomsDocument, options);
        }
export function useCountRoomsSuspenseQuery(baseOptions?: Apollo.SuspenseQueryHookOptions<CountRoomsQuery, CountRoomsQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useSuspenseQuery<CountRoomsQuery, CountRoomsQueryVariables>(CountRoomsDocument, options);
        }
export type CountRoomsQueryHookResult = ReturnType<typeof useCountRoomsQuery>;
export type CountRoomsLazyQueryHookResult = ReturnType<typeof useCountRoomsLazyQuery>;
export type CountRoomsSuspenseQueryHookResult = ReturnType<typeof useCountRoomsSuspenseQuery>;
export type CountRoomsQueryResult = Apollo.QueryResult<CountRoomsQuery, CountRoomsQueryVariables>;
export const GetRoomsForClinicDocument = gql`
    query getRoomsForClinic($clinicId: ID!) {
  getRoomsByClinic(clinicId: $clinicId) {
    ...RoomFields
  }
}
    ${RoomFieldsFragmentDoc}`;

/**
 * __useGetRoomsForClinicQuery__
 *
 * To run a query within a React component, call `useGetRoomsForClinicQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetRoomsForClinicQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetRoomsForClinicQuery({
 *   variables: {
 *      clinicId: // value for 'clinicId'
 *   },
 * });
 */
export function useGetRoomsForClinicQuery(baseOptions: Apollo.QueryHookOptions<GetRoomsForClinicQuery, GetRoomsForClinicQueryVariables> & ({ variables: GetRoomsForClinicQueryVariables; skip?: boolean; } | { skip: boolean; }) ) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<GetRoomsForClinicQuery, GetRoomsForClinicQueryVariables>(GetRoomsForClinicDocument, options);
      }
export function useGetRoomsForClinicLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<GetRoomsForClinicQuery, GetRoomsForClinicQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<GetRoomsForClinicQuery, GetRoomsForClinicQueryVariables>(GetRoomsForClinicDocument, options);
        }
export function useGetRoomsForClinicSuspenseQuery(baseOptions?: Apollo.SuspenseQueryHookOptions<GetRoomsForClinicQuery, GetRoomsForClinicQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useSuspenseQuery<GetRoomsForClinicQuery, GetRoomsForClinicQueryVariables>(GetRoomsForClinicDocument, options);
        }
export type GetRoomsForClinicQueryHookResult = ReturnType<typeof useGetRoomsForClinicQuery>;
export type GetRoomsForClinicLazyQueryHookResult = ReturnType<typeof useGetRoomsForClinicLazyQuery>;
export type GetRoomsForClinicSuspenseQueryHookResult = ReturnType<typeof useGetRoomsForClinicSuspenseQuery>;
export type GetRoomsForClinicQueryResult = Apollo.QueryResult<GetRoomsForClinicQuery, GetRoomsForClinicQueryVariables>;
export const UpdateRoomDocument = gql`
    mutation updateRoom($roomId: ID!, $data: UpdateRoomInput!) {
  updateRoom(roomId: $roomId, data: $data) {
    ...RoomFields
  }
}
    ${RoomFieldsFragmentDoc}`;
export type UpdateRoomMutationFn = Apollo.MutationFunction<UpdateRoomMutation, UpdateRoomMutationVariables>;

/**
 * __useUpdateRoomMutation__
 *
 * To run a mutation, you first call `useUpdateRoomMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useUpdateRoomMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [updateRoomMutation, { data, loading, error }] = useUpdateRoomMutation({
 *   variables: {
 *      roomId: // value for 'roomId'
 *      data: // value for 'data'
 *   },
 * });
 */
export function useUpdateRoomMutation(baseOptions?: Apollo.MutationHookOptions<UpdateRoomMutation, UpdateRoomMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<UpdateRoomMutation, UpdateRoomMutationVariables>(UpdateRoomDocument, options);
      }
export type UpdateRoomMutationHookResult = ReturnType<typeof useUpdateRoomMutation>;
export type UpdateRoomMutationResult = Apollo.MutationResult<UpdateRoomMutation>;
export type UpdateRoomMutationOptions = Apollo.BaseMutationOptions<UpdateRoomMutation, UpdateRoomMutationVariables>;
export const ScheduledBulkMessageDocument = gql`
    query scheduledBulkMessage($scheduledBulkMessageId: ID!) {
  scheduledBulkMessage(scheduledBulkMessageId: $scheduledBulkMessageId) {
    ...ScheduledBulkMessageFields
  }
}
    ${ScheduledBulkMessageFieldsFragmentDoc}`;

/**
 * __useScheduledBulkMessageQuery__
 *
 * To run a query within a React component, call `useScheduledBulkMessageQuery` and pass it any options that fit your needs.
 * When your component renders, `useScheduledBulkMessageQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useScheduledBulkMessageQuery({
 *   variables: {
 *      scheduledBulkMessageId: // value for 'scheduledBulkMessageId'
 *   },
 * });
 */
export function useScheduledBulkMessageQuery(baseOptions: Apollo.QueryHookOptions<ScheduledBulkMessageQuery, ScheduledBulkMessageQueryVariables> & ({ variables: ScheduledBulkMessageQueryVariables; skip?: boolean; } | { skip: boolean; }) ) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<ScheduledBulkMessageQuery, ScheduledBulkMessageQueryVariables>(ScheduledBulkMessageDocument, options);
      }
export function useScheduledBulkMessageLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<ScheduledBulkMessageQuery, ScheduledBulkMessageQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<ScheduledBulkMessageQuery, ScheduledBulkMessageQueryVariables>(ScheduledBulkMessageDocument, options);
        }
export function useScheduledBulkMessageSuspenseQuery(baseOptions?: Apollo.SuspenseQueryHookOptions<ScheduledBulkMessageQuery, ScheduledBulkMessageQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useSuspenseQuery<ScheduledBulkMessageQuery, ScheduledBulkMessageQueryVariables>(ScheduledBulkMessageDocument, options);
        }
export type ScheduledBulkMessageQueryHookResult = ReturnType<typeof useScheduledBulkMessageQuery>;
export type ScheduledBulkMessageLazyQueryHookResult = ReturnType<typeof useScheduledBulkMessageLazyQuery>;
export type ScheduledBulkMessageSuspenseQueryHookResult = ReturnType<typeof useScheduledBulkMessageSuspenseQuery>;
export type ScheduledBulkMessageQueryResult = Apollo.QueryResult<ScheduledBulkMessageQuery, ScheduledBulkMessageQueryVariables>;
export const GetScheduledBulkMessagesByClinicIdDocument = gql`
    query getScheduledBulkMessagesByClinicId($clinicId: ID!) {
  getScheduledBulkMessagesByClinicId(clinicId: $clinicId) {
    ...ScheduledBulkMessageFields
  }
}
    ${ScheduledBulkMessageFieldsFragmentDoc}`;

/**
 * __useGetScheduledBulkMessagesByClinicIdQuery__
 *
 * To run a query within a React component, call `useGetScheduledBulkMessagesByClinicIdQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetScheduledBulkMessagesByClinicIdQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetScheduledBulkMessagesByClinicIdQuery({
 *   variables: {
 *      clinicId: // value for 'clinicId'
 *   },
 * });
 */
export function useGetScheduledBulkMessagesByClinicIdQuery(baseOptions: Apollo.QueryHookOptions<GetScheduledBulkMessagesByClinicIdQuery, GetScheduledBulkMessagesByClinicIdQueryVariables> & ({ variables: GetScheduledBulkMessagesByClinicIdQueryVariables; skip?: boolean; } | { skip: boolean; }) ) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<GetScheduledBulkMessagesByClinicIdQuery, GetScheduledBulkMessagesByClinicIdQueryVariables>(GetScheduledBulkMessagesByClinicIdDocument, options);
      }
export function useGetScheduledBulkMessagesByClinicIdLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<GetScheduledBulkMessagesByClinicIdQuery, GetScheduledBulkMessagesByClinicIdQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<GetScheduledBulkMessagesByClinicIdQuery, GetScheduledBulkMessagesByClinicIdQueryVariables>(GetScheduledBulkMessagesByClinicIdDocument, options);
        }
export function useGetScheduledBulkMessagesByClinicIdSuspenseQuery(baseOptions?: Apollo.SuspenseQueryHookOptions<GetScheduledBulkMessagesByClinicIdQuery, GetScheduledBulkMessagesByClinicIdQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useSuspenseQuery<GetScheduledBulkMessagesByClinicIdQuery, GetScheduledBulkMessagesByClinicIdQueryVariables>(GetScheduledBulkMessagesByClinicIdDocument, options);
        }
export type GetScheduledBulkMessagesByClinicIdQueryHookResult = ReturnType<typeof useGetScheduledBulkMessagesByClinicIdQuery>;
export type GetScheduledBulkMessagesByClinicIdLazyQueryHookResult = ReturnType<typeof useGetScheduledBulkMessagesByClinicIdLazyQuery>;
export type GetScheduledBulkMessagesByClinicIdSuspenseQueryHookResult = ReturnType<typeof useGetScheduledBulkMessagesByClinicIdSuspenseQuery>;
export type GetScheduledBulkMessagesByClinicIdQueryResult = Apollo.QueryResult<GetScheduledBulkMessagesByClinicIdQuery, GetScheduledBulkMessagesByClinicIdQueryVariables>;
export const QueryScheduledBulkMessagesDocument = gql`
    query queryScheduledBulkMessages($where: [QueryInput!], $orderBy: OrderByInput, $page: NonNegativeInt, $pageSize: NonNegativeInt) {
  queryScheduledBulkMessages(
    where: $where
    orderBy: $orderBy
    page: $page
    pageSize: $pageSize
  ) {
    ...ScheduledBulkMessageFields
  }
}
    ${ScheduledBulkMessageFieldsFragmentDoc}`;

/**
 * __useQueryScheduledBulkMessagesQuery__
 *
 * To run a query within a React component, call `useQueryScheduledBulkMessagesQuery` and pass it any options that fit your needs.
 * When your component renders, `useQueryScheduledBulkMessagesQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useQueryScheduledBulkMessagesQuery({
 *   variables: {
 *      where: // value for 'where'
 *      orderBy: // value for 'orderBy'
 *      page: // value for 'page'
 *      pageSize: // value for 'pageSize'
 *   },
 * });
 */
export function useQueryScheduledBulkMessagesQuery(baseOptions?: Apollo.QueryHookOptions<QueryScheduledBulkMessagesQuery, QueryScheduledBulkMessagesQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<QueryScheduledBulkMessagesQuery, QueryScheduledBulkMessagesQueryVariables>(QueryScheduledBulkMessagesDocument, options);
      }
export function useQueryScheduledBulkMessagesLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<QueryScheduledBulkMessagesQuery, QueryScheduledBulkMessagesQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<QueryScheduledBulkMessagesQuery, QueryScheduledBulkMessagesQueryVariables>(QueryScheduledBulkMessagesDocument, options);
        }
export function useQueryScheduledBulkMessagesSuspenseQuery(baseOptions?: Apollo.SuspenseQueryHookOptions<QueryScheduledBulkMessagesQuery, QueryScheduledBulkMessagesQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useSuspenseQuery<QueryScheduledBulkMessagesQuery, QueryScheduledBulkMessagesQueryVariables>(QueryScheduledBulkMessagesDocument, options);
        }
export type QueryScheduledBulkMessagesQueryHookResult = ReturnType<typeof useQueryScheduledBulkMessagesQuery>;
export type QueryScheduledBulkMessagesLazyQueryHookResult = ReturnType<typeof useQueryScheduledBulkMessagesLazyQuery>;
export type QueryScheduledBulkMessagesSuspenseQueryHookResult = ReturnType<typeof useQueryScheduledBulkMessagesSuspenseQuery>;
export type QueryScheduledBulkMessagesQueryResult = Apollo.QueryResult<QueryScheduledBulkMessagesQuery, QueryScheduledBulkMessagesQueryVariables>;
export const CountScheduledBulkMessagesDocument = gql`
    query countScheduledBulkMessages($where: [QueryInput!]) {
  countScheduledBulkMessages(where: $where)
}
    `;

/**
 * __useCountScheduledBulkMessagesQuery__
 *
 * To run a query within a React component, call `useCountScheduledBulkMessagesQuery` and pass it any options that fit your needs.
 * When your component renders, `useCountScheduledBulkMessagesQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useCountScheduledBulkMessagesQuery({
 *   variables: {
 *      where: // value for 'where'
 *   },
 * });
 */
export function useCountScheduledBulkMessagesQuery(baseOptions?: Apollo.QueryHookOptions<CountScheduledBulkMessagesQuery, CountScheduledBulkMessagesQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<CountScheduledBulkMessagesQuery, CountScheduledBulkMessagesQueryVariables>(CountScheduledBulkMessagesDocument, options);
      }
export function useCountScheduledBulkMessagesLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<CountScheduledBulkMessagesQuery, CountScheduledBulkMessagesQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<CountScheduledBulkMessagesQuery, CountScheduledBulkMessagesQueryVariables>(CountScheduledBulkMessagesDocument, options);
        }
export function useCountScheduledBulkMessagesSuspenseQuery(baseOptions?: Apollo.SuspenseQueryHookOptions<CountScheduledBulkMessagesQuery, CountScheduledBulkMessagesQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useSuspenseQuery<CountScheduledBulkMessagesQuery, CountScheduledBulkMessagesQueryVariables>(CountScheduledBulkMessagesDocument, options);
        }
export type CountScheduledBulkMessagesQueryHookResult = ReturnType<typeof useCountScheduledBulkMessagesQuery>;
export type CountScheduledBulkMessagesLazyQueryHookResult = ReturnType<typeof useCountScheduledBulkMessagesLazyQuery>;
export type CountScheduledBulkMessagesSuspenseQueryHookResult = ReturnType<typeof useCountScheduledBulkMessagesSuspenseQuery>;
export type CountScheduledBulkMessagesQueryResult = Apollo.QueryResult<CountScheduledBulkMessagesQuery, CountScheduledBulkMessagesQueryVariables>;
export const GetScheduledBulkMessageStatsDocument = gql`
    query getScheduledBulkMessageStats($id: ID!) {
  scheduledBulkMessageTrackingStats(scheduledBulkMessageId: $id) {
    unique_clients
    messages_sent
    emails_sent
    sms_sent
    email_opens
    email_open_rate
    email_unique_opens
    email_unique_open_rate
    email_clicks
    email_click_rate
    email_unique_clicks
    email_unique_click_rate
    sms_clicks
    sms_click_rate
    sms_unique_clicks
    sms_unique_click_rate
    conversion_rate
    direct_appointments
    indirect_appointments
    revenue_by_appt
  }
}
    `;

/**
 * __useGetScheduledBulkMessageStatsQuery__
 *
 * To run a query within a React component, call `useGetScheduledBulkMessageStatsQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetScheduledBulkMessageStatsQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetScheduledBulkMessageStatsQuery({
 *   variables: {
 *      id: // value for 'id'
 *   },
 * });
 */
export function useGetScheduledBulkMessageStatsQuery(baseOptions: Apollo.QueryHookOptions<GetScheduledBulkMessageStatsQuery, GetScheduledBulkMessageStatsQueryVariables> & ({ variables: GetScheduledBulkMessageStatsQueryVariables; skip?: boolean; } | { skip: boolean; }) ) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<GetScheduledBulkMessageStatsQuery, GetScheduledBulkMessageStatsQueryVariables>(GetScheduledBulkMessageStatsDocument, options);
      }
export function useGetScheduledBulkMessageStatsLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<GetScheduledBulkMessageStatsQuery, GetScheduledBulkMessageStatsQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<GetScheduledBulkMessageStatsQuery, GetScheduledBulkMessageStatsQueryVariables>(GetScheduledBulkMessageStatsDocument, options);
        }
export function useGetScheduledBulkMessageStatsSuspenseQuery(baseOptions?: Apollo.SuspenseQueryHookOptions<GetScheduledBulkMessageStatsQuery, GetScheduledBulkMessageStatsQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useSuspenseQuery<GetScheduledBulkMessageStatsQuery, GetScheduledBulkMessageStatsQueryVariables>(GetScheduledBulkMessageStatsDocument, options);
        }
export type GetScheduledBulkMessageStatsQueryHookResult = ReturnType<typeof useGetScheduledBulkMessageStatsQuery>;
export type GetScheduledBulkMessageStatsLazyQueryHookResult = ReturnType<typeof useGetScheduledBulkMessageStatsLazyQuery>;
export type GetScheduledBulkMessageStatsSuspenseQueryHookResult = ReturnType<typeof useGetScheduledBulkMessageStatsSuspenseQuery>;
export type GetScheduledBulkMessageStatsQueryResult = Apollo.QueryResult<GetScheduledBulkMessageStatsQuery, GetScheduledBulkMessageStatsQueryVariables>;
export const BulkMessageAudienceEstimateDocument = gql`
    query bulkMessageAudienceEstimate($data: BulkMessageAudienceEstimateInput!) {
  bulkMessageAudienceEstimate(data: $data) {
    total_unique_clients
    eligible_clients
    filtered_clients
    estimated_sms_segments
    estimated_sms_cost_cents
    min_sms_segments_per_client
    max_sms_segments_per_client
    average_sms_segments_per_client
  }
}
    `;

/**
 * __useBulkMessageAudienceEstimateQuery__
 *
 * To run a query within a React component, call `useBulkMessageAudienceEstimateQuery` and pass it any options that fit your needs.
 * When your component renders, `useBulkMessageAudienceEstimateQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useBulkMessageAudienceEstimateQuery({
 *   variables: {
 *      data: // value for 'data'
 *   },
 * });
 */
export function useBulkMessageAudienceEstimateQuery(baseOptions: Apollo.QueryHookOptions<BulkMessageAudienceEstimateQuery, BulkMessageAudienceEstimateQueryVariables> & ({ variables: BulkMessageAudienceEstimateQueryVariables; skip?: boolean; } | { skip: boolean; }) ) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<BulkMessageAudienceEstimateQuery, BulkMessageAudienceEstimateQueryVariables>(BulkMessageAudienceEstimateDocument, options);
      }
export function useBulkMessageAudienceEstimateLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<BulkMessageAudienceEstimateQuery, BulkMessageAudienceEstimateQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<BulkMessageAudienceEstimateQuery, BulkMessageAudienceEstimateQueryVariables>(BulkMessageAudienceEstimateDocument, options);
        }
export function useBulkMessageAudienceEstimateSuspenseQuery(baseOptions?: Apollo.SuspenseQueryHookOptions<BulkMessageAudienceEstimateQuery, BulkMessageAudienceEstimateQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useSuspenseQuery<BulkMessageAudienceEstimateQuery, BulkMessageAudienceEstimateQueryVariables>(BulkMessageAudienceEstimateDocument, options);
        }
export type BulkMessageAudienceEstimateQueryHookResult = ReturnType<typeof useBulkMessageAudienceEstimateQuery>;
export type BulkMessageAudienceEstimateLazyQueryHookResult = ReturnType<typeof useBulkMessageAudienceEstimateLazyQuery>;
export type BulkMessageAudienceEstimateSuspenseQueryHookResult = ReturnType<typeof useBulkMessageAudienceEstimateSuspenseQuery>;
export type BulkMessageAudienceEstimateQueryResult = Apollo.QueryResult<BulkMessageAudienceEstimateQuery, BulkMessageAudienceEstimateQueryVariables>;
export const CreateScheduledBulkMessageDocument = gql`
    mutation createScheduledBulkMessage($data: CreateScheduledBulkMessageInput!) {
  createScheduledBulkMessage(data: $data) {
    ...ScheduledBulkMessageFields
  }
}
    ${ScheduledBulkMessageFieldsFragmentDoc}`;
export type CreateScheduledBulkMessageMutationFn = Apollo.MutationFunction<CreateScheduledBulkMessageMutation, CreateScheduledBulkMessageMutationVariables>;

/**
 * __useCreateScheduledBulkMessageMutation__
 *
 * To run a mutation, you first call `useCreateScheduledBulkMessageMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useCreateScheduledBulkMessageMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [createScheduledBulkMessageMutation, { data, loading, error }] = useCreateScheduledBulkMessageMutation({
 *   variables: {
 *      data: // value for 'data'
 *   },
 * });
 */
export function useCreateScheduledBulkMessageMutation(baseOptions?: Apollo.MutationHookOptions<CreateScheduledBulkMessageMutation, CreateScheduledBulkMessageMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<CreateScheduledBulkMessageMutation, CreateScheduledBulkMessageMutationVariables>(CreateScheduledBulkMessageDocument, options);
      }
export type CreateScheduledBulkMessageMutationHookResult = ReturnType<typeof useCreateScheduledBulkMessageMutation>;
export type CreateScheduledBulkMessageMutationResult = Apollo.MutationResult<CreateScheduledBulkMessageMutation>;
export type CreateScheduledBulkMessageMutationOptions = Apollo.BaseMutationOptions<CreateScheduledBulkMessageMutation, CreateScheduledBulkMessageMutationVariables>;
export const UpdateScheduledBulkMessageDocument = gql`
    mutation updateScheduledBulkMessage($scheduledBulkMessageId: ID!, $data: UpdateScheduledBulkMessageInput!) {
  updateScheduledBulkMessage(
    scheduledBulkMessageId: $scheduledBulkMessageId
    data: $data
  ) {
    ...ScheduledBulkMessageFields
  }
}
    ${ScheduledBulkMessageFieldsFragmentDoc}`;
export type UpdateScheduledBulkMessageMutationFn = Apollo.MutationFunction<UpdateScheduledBulkMessageMutation, UpdateScheduledBulkMessageMutationVariables>;

/**
 * __useUpdateScheduledBulkMessageMutation__
 *
 * To run a mutation, you first call `useUpdateScheduledBulkMessageMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useUpdateScheduledBulkMessageMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [updateScheduledBulkMessageMutation, { data, loading, error }] = useUpdateScheduledBulkMessageMutation({
 *   variables: {
 *      scheduledBulkMessageId: // value for 'scheduledBulkMessageId'
 *      data: // value for 'data'
 *   },
 * });
 */
export function useUpdateScheduledBulkMessageMutation(baseOptions?: Apollo.MutationHookOptions<UpdateScheduledBulkMessageMutation, UpdateScheduledBulkMessageMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<UpdateScheduledBulkMessageMutation, UpdateScheduledBulkMessageMutationVariables>(UpdateScheduledBulkMessageDocument, options);
      }
export type UpdateScheduledBulkMessageMutationHookResult = ReturnType<typeof useUpdateScheduledBulkMessageMutation>;
export type UpdateScheduledBulkMessageMutationResult = Apollo.MutationResult<UpdateScheduledBulkMessageMutation>;
export type UpdateScheduledBulkMessageMutationOptions = Apollo.BaseMutationOptions<UpdateScheduledBulkMessageMutation, UpdateScheduledBulkMessageMutationVariables>;
export const ArchiveScheduledBulkMessageDocument = gql`
    mutation archiveScheduledBulkMessage($scheduledBulkMessageId: ID!) {
  archiveScheduledBulkMessage(scheduledBulkMessageId: $scheduledBulkMessageId) {
    ...ScheduledBulkMessageFields
  }
}
    ${ScheduledBulkMessageFieldsFragmentDoc}`;
export type ArchiveScheduledBulkMessageMutationFn = Apollo.MutationFunction<ArchiveScheduledBulkMessageMutation, ArchiveScheduledBulkMessageMutationVariables>;

/**
 * __useArchiveScheduledBulkMessageMutation__
 *
 * To run a mutation, you first call `useArchiveScheduledBulkMessageMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useArchiveScheduledBulkMessageMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [archiveScheduledBulkMessageMutation, { data, loading, error }] = useArchiveScheduledBulkMessageMutation({
 *   variables: {
 *      scheduledBulkMessageId: // value for 'scheduledBulkMessageId'
 *   },
 * });
 */
export function useArchiveScheduledBulkMessageMutation(baseOptions?: Apollo.MutationHookOptions<ArchiveScheduledBulkMessageMutation, ArchiveScheduledBulkMessageMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<ArchiveScheduledBulkMessageMutation, ArchiveScheduledBulkMessageMutationVariables>(ArchiveScheduledBulkMessageDocument, options);
      }
export type ArchiveScheduledBulkMessageMutationHookResult = ReturnType<typeof useArchiveScheduledBulkMessageMutation>;
export type ArchiveScheduledBulkMessageMutationResult = Apollo.MutationResult<ArchiveScheduledBulkMessageMutation>;
export type ArchiveScheduledBulkMessageMutationOptions = Apollo.BaseMutationOptions<ArchiveScheduledBulkMessageMutation, ArchiveScheduledBulkMessageMutationVariables>;
export const DeleteScheduledBulkMessageDocument = gql`
    mutation deleteScheduledBulkMessage($scheduledBulkMessageId: ID!) {
  deleteScheduledBulkMessage(scheduledBulkMessageId: $scheduledBulkMessageId)
}
    `;
export type DeleteScheduledBulkMessageMutationFn = Apollo.MutationFunction<DeleteScheduledBulkMessageMutation, DeleteScheduledBulkMessageMutationVariables>;

/**
 * __useDeleteScheduledBulkMessageMutation__
 *
 * To run a mutation, you first call `useDeleteScheduledBulkMessageMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useDeleteScheduledBulkMessageMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [deleteScheduledBulkMessageMutation, { data, loading, error }] = useDeleteScheduledBulkMessageMutation({
 *   variables: {
 *      scheduledBulkMessageId: // value for 'scheduledBulkMessageId'
 *   },
 * });
 */
export function useDeleteScheduledBulkMessageMutation(baseOptions?: Apollo.MutationHookOptions<DeleteScheduledBulkMessageMutation, DeleteScheduledBulkMessageMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<DeleteScheduledBulkMessageMutation, DeleteScheduledBulkMessageMutationVariables>(DeleteScheduledBulkMessageDocument, options);
      }
export type DeleteScheduledBulkMessageMutationHookResult = ReturnType<typeof useDeleteScheduledBulkMessageMutation>;
export type DeleteScheduledBulkMessageMutationResult = Apollo.MutationResult<DeleteScheduledBulkMessageMutation>;
export type DeleteScheduledBulkMessageMutationOptions = Apollo.BaseMutationOptions<DeleteScheduledBulkMessageMutation, DeleteScheduledBulkMessageMutationVariables>;
export const BulkUpdateScheduledBulkMessagesDocument = gql`
    mutation bulkUpdateScheduledBulkMessages($ids: [ID!]!, $data: BulkUpdateScheduledBulkMessagesInput!) {
  bulkUpdateScheduledBulkMessages(ids: $ids, data: $data) {
    id
    is_active
    is_archived
    updated_at
  }
}
    `;
export type BulkUpdateScheduledBulkMessagesMutationFn = Apollo.MutationFunction<BulkUpdateScheduledBulkMessagesMutation, BulkUpdateScheduledBulkMessagesMutationVariables>;

/**
 * __useBulkUpdateScheduledBulkMessagesMutation__
 *
 * To run a mutation, you first call `useBulkUpdateScheduledBulkMessagesMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useBulkUpdateScheduledBulkMessagesMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [bulkUpdateScheduledBulkMessagesMutation, { data, loading, error }] = useBulkUpdateScheduledBulkMessagesMutation({
 *   variables: {
 *      ids: // value for 'ids'
 *      data: // value for 'data'
 *   },
 * });
 */
export function useBulkUpdateScheduledBulkMessagesMutation(baseOptions?: Apollo.MutationHookOptions<BulkUpdateScheduledBulkMessagesMutation, BulkUpdateScheduledBulkMessagesMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<BulkUpdateScheduledBulkMessagesMutation, BulkUpdateScheduledBulkMessagesMutationVariables>(BulkUpdateScheduledBulkMessagesDocument, options);
      }
export type BulkUpdateScheduledBulkMessagesMutationHookResult = ReturnType<typeof useBulkUpdateScheduledBulkMessagesMutation>;
export type BulkUpdateScheduledBulkMessagesMutationResult = Apollo.MutationResult<BulkUpdateScheduledBulkMessagesMutation>;
export type BulkUpdateScheduledBulkMessagesMutationOptions = Apollo.BaseMutationOptions<BulkUpdateScheduledBulkMessagesMutation, BulkUpdateScheduledBulkMessagesMutationVariables>;
export const LinkedScheduledBulkMessageChildrenDocument = gql`
    query linkedScheduledBulkMessageChildren($where: [QueryInput!], $pageSize: NonNegativeInt) {
  queryScheduledBulkMessages(where: $where, page: 0, pageSize: $pageSize) {
    ...LinkedBulkMessageChildFields
  }
}
    ${LinkedBulkMessageChildFieldsFragmentDoc}`;

/**
 * __useLinkedScheduledBulkMessageChildrenQuery__
 *
 * To run a query within a React component, call `useLinkedScheduledBulkMessageChildrenQuery` and pass it any options that fit your needs.
 * When your component renders, `useLinkedScheduledBulkMessageChildrenQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useLinkedScheduledBulkMessageChildrenQuery({
 *   variables: {
 *      where: // value for 'where'
 *      pageSize: // value for 'pageSize'
 *   },
 * });
 */
export function useLinkedScheduledBulkMessageChildrenQuery(baseOptions?: Apollo.QueryHookOptions<LinkedScheduledBulkMessageChildrenQuery, LinkedScheduledBulkMessageChildrenQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<LinkedScheduledBulkMessageChildrenQuery, LinkedScheduledBulkMessageChildrenQueryVariables>(LinkedScheduledBulkMessageChildrenDocument, options);
      }
export function useLinkedScheduledBulkMessageChildrenLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<LinkedScheduledBulkMessageChildrenQuery, LinkedScheduledBulkMessageChildrenQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<LinkedScheduledBulkMessageChildrenQuery, LinkedScheduledBulkMessageChildrenQueryVariables>(LinkedScheduledBulkMessageChildrenDocument, options);
        }
export function useLinkedScheduledBulkMessageChildrenSuspenseQuery(baseOptions?: Apollo.SuspenseQueryHookOptions<LinkedScheduledBulkMessageChildrenQuery, LinkedScheduledBulkMessageChildrenQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useSuspenseQuery<LinkedScheduledBulkMessageChildrenQuery, LinkedScheduledBulkMessageChildrenQueryVariables>(LinkedScheduledBulkMessageChildrenDocument, options);
        }
export type LinkedScheduledBulkMessageChildrenQueryHookResult = ReturnType<typeof useLinkedScheduledBulkMessageChildrenQuery>;
export type LinkedScheduledBulkMessageChildrenLazyQueryHookResult = ReturnType<typeof useLinkedScheduledBulkMessageChildrenLazyQuery>;
export type LinkedScheduledBulkMessageChildrenSuspenseQueryHookResult = ReturnType<typeof useLinkedScheduledBulkMessageChildrenSuspenseQuery>;
export type LinkedScheduledBulkMessageChildrenQueryResult = Apollo.QueryResult<LinkedScheduledBulkMessageChildrenQuery, LinkedScheduledBulkMessageChildrenQueryVariables>;
export const CreateScheduledMessageDocument = gql`
    mutation createScheduledMessage($data: CreateScheduledMessageInput!) {
  createScheduledMessage(data: $data) {
    ...ScheduledMessageFields
  }
}
    ${ScheduledMessageFieldsFragmentDoc}`;
export type CreateScheduledMessageMutationFn = Apollo.MutationFunction<CreateScheduledMessageMutation, CreateScheduledMessageMutationVariables>;

/**
 * __useCreateScheduledMessageMutation__
 *
 * To run a mutation, you first call `useCreateScheduledMessageMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useCreateScheduledMessageMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [createScheduledMessageMutation, { data, loading, error }] = useCreateScheduledMessageMutation({
 *   variables: {
 *      data: // value for 'data'
 *   },
 * });
 */
export function useCreateScheduledMessageMutation(baseOptions?: Apollo.MutationHookOptions<CreateScheduledMessageMutation, CreateScheduledMessageMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<CreateScheduledMessageMutation, CreateScheduledMessageMutationVariables>(CreateScheduledMessageDocument, options);
      }
export type CreateScheduledMessageMutationHookResult = ReturnType<typeof useCreateScheduledMessageMutation>;
export type CreateScheduledMessageMutationResult = Apollo.MutationResult<CreateScheduledMessageMutation>;
export type CreateScheduledMessageMutationOptions = Apollo.BaseMutationOptions<CreateScheduledMessageMutation, CreateScheduledMessageMutationVariables>;
export const UpdateScheduledMessageDocument = gql`
    mutation updateScheduledMessage($scheduledMessageId: ID!, $data: UpdateScheduledMessageInput!) {
  updateScheduledMessage(scheduledMessageId: $scheduledMessageId, data: $data) {
    ...ScheduledMessageFields
  }
}
    ${ScheduledMessageFieldsFragmentDoc}`;
export type UpdateScheduledMessageMutationFn = Apollo.MutationFunction<UpdateScheduledMessageMutation, UpdateScheduledMessageMutationVariables>;

/**
 * __useUpdateScheduledMessageMutation__
 *
 * To run a mutation, you first call `useUpdateScheduledMessageMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useUpdateScheduledMessageMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [updateScheduledMessageMutation, { data, loading, error }] = useUpdateScheduledMessageMutation({
 *   variables: {
 *      scheduledMessageId: // value for 'scheduledMessageId'
 *      data: // value for 'data'
 *   },
 * });
 */
export function useUpdateScheduledMessageMutation(baseOptions?: Apollo.MutationHookOptions<UpdateScheduledMessageMutation, UpdateScheduledMessageMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<UpdateScheduledMessageMutation, UpdateScheduledMessageMutationVariables>(UpdateScheduledMessageDocument, options);
      }
export type UpdateScheduledMessageMutationHookResult = ReturnType<typeof useUpdateScheduledMessageMutation>;
export type UpdateScheduledMessageMutationResult = Apollo.MutationResult<UpdateScheduledMessageMutation>;
export type UpdateScheduledMessageMutationOptions = Apollo.BaseMutationOptions<UpdateScheduledMessageMutation, UpdateScheduledMessageMutationVariables>;
export const CancelScheduledMessageDocument = gql`
    mutation cancelScheduledMessage($scheduledMessageId: ID!, $cancelledBy: ID!) {
  cancelScheduledMessage(
    scheduledMessageId: $scheduledMessageId
    cancelledBy: $cancelledBy
  ) {
    ...ScheduledMessageFields
  }
}
    ${ScheduledMessageFieldsFragmentDoc}`;
export type CancelScheduledMessageMutationFn = Apollo.MutationFunction<CancelScheduledMessageMutation, CancelScheduledMessageMutationVariables>;

/**
 * __useCancelScheduledMessageMutation__
 *
 * To run a mutation, you first call `useCancelScheduledMessageMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useCancelScheduledMessageMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [cancelScheduledMessageMutation, { data, loading, error }] = useCancelScheduledMessageMutation({
 *   variables: {
 *      scheduledMessageId: // value for 'scheduledMessageId'
 *      cancelledBy: // value for 'cancelledBy'
 *   },
 * });
 */
export function useCancelScheduledMessageMutation(baseOptions?: Apollo.MutationHookOptions<CancelScheduledMessageMutation, CancelScheduledMessageMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<CancelScheduledMessageMutation, CancelScheduledMessageMutationVariables>(CancelScheduledMessageDocument, options);
      }
export type CancelScheduledMessageMutationHookResult = ReturnType<typeof useCancelScheduledMessageMutation>;
export type CancelScheduledMessageMutationResult = Apollo.MutationResult<CancelScheduledMessageMutation>;
export type CancelScheduledMessageMutationOptions = Apollo.BaseMutationOptions<CancelScheduledMessageMutation, CancelScheduledMessageMutationVariables>;
export const DeleteScheduledMessageDocument = gql`
    mutation deleteScheduledMessage($scheduledMessageId: ID!) {
  deleteScheduledMessage(scheduledMessageId: $scheduledMessageId)
}
    `;
export type DeleteScheduledMessageMutationFn = Apollo.MutationFunction<DeleteScheduledMessageMutation, DeleteScheduledMessageMutationVariables>;

/**
 * __useDeleteScheduledMessageMutation__
 *
 * To run a mutation, you first call `useDeleteScheduledMessageMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useDeleteScheduledMessageMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [deleteScheduledMessageMutation, { data, loading, error }] = useDeleteScheduledMessageMutation({
 *   variables: {
 *      scheduledMessageId: // value for 'scheduledMessageId'
 *   },
 * });
 */
export function useDeleteScheduledMessageMutation(baseOptions?: Apollo.MutationHookOptions<DeleteScheduledMessageMutation, DeleteScheduledMessageMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<DeleteScheduledMessageMutation, DeleteScheduledMessageMutationVariables>(DeleteScheduledMessageDocument, options);
      }
export type DeleteScheduledMessageMutationHookResult = ReturnType<typeof useDeleteScheduledMessageMutation>;
export type DeleteScheduledMessageMutationResult = Apollo.MutationResult<DeleteScheduledMessageMutation>;
export type DeleteScheduledMessageMutationOptions = Apollo.BaseMutationOptions<DeleteScheduledMessageMutation, DeleteScheduledMessageMutationVariables>;
export const QueryScheduledMessagesDocument = gql`
    query queryScheduledMessages($where: [QueryInput!], $page: NonNegativeInt, $pageSize: NonNegativeInt, $orderBy: OrderByInput) {
  queryScheduledMessages(
    where: $where
    page: $page
    pageSize: $pageSize
    orderBy: $orderBy
  ) {
    ...ScheduledMessageFields
  }
}
    ${ScheduledMessageFieldsFragmentDoc}`;

/**
 * __useQueryScheduledMessagesQuery__
 *
 * To run a query within a React component, call `useQueryScheduledMessagesQuery` and pass it any options that fit your needs.
 * When your component renders, `useQueryScheduledMessagesQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useQueryScheduledMessagesQuery({
 *   variables: {
 *      where: // value for 'where'
 *      page: // value for 'page'
 *      pageSize: // value for 'pageSize'
 *      orderBy: // value for 'orderBy'
 *   },
 * });
 */
export function useQueryScheduledMessagesQuery(baseOptions?: Apollo.QueryHookOptions<QueryScheduledMessagesQuery, QueryScheduledMessagesQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<QueryScheduledMessagesQuery, QueryScheduledMessagesQueryVariables>(QueryScheduledMessagesDocument, options);
      }
export function useQueryScheduledMessagesLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<QueryScheduledMessagesQuery, QueryScheduledMessagesQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<QueryScheduledMessagesQuery, QueryScheduledMessagesQueryVariables>(QueryScheduledMessagesDocument, options);
        }
export function useQueryScheduledMessagesSuspenseQuery(baseOptions?: Apollo.SuspenseQueryHookOptions<QueryScheduledMessagesQuery, QueryScheduledMessagesQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useSuspenseQuery<QueryScheduledMessagesQuery, QueryScheduledMessagesQueryVariables>(QueryScheduledMessagesDocument, options);
        }
export type QueryScheduledMessagesQueryHookResult = ReturnType<typeof useQueryScheduledMessagesQuery>;
export type QueryScheduledMessagesLazyQueryHookResult = ReturnType<typeof useQueryScheduledMessagesLazyQuery>;
export type QueryScheduledMessagesSuspenseQueryHookResult = ReturnType<typeof useQueryScheduledMessagesSuspenseQuery>;
export type QueryScheduledMessagesQueryResult = Apollo.QueryResult<QueryScheduledMessagesQuery, QueryScheduledMessagesQueryVariables>;
export const CountScheduledMessagesDocument = gql`
    query countScheduledMessages($where: [QueryInput!]) {
  countScheduledMessages(where: $where)
}
    `;

/**
 * __useCountScheduledMessagesQuery__
 *
 * To run a query within a React component, call `useCountScheduledMessagesQuery` and pass it any options that fit your needs.
 * When your component renders, `useCountScheduledMessagesQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useCountScheduledMessagesQuery({
 *   variables: {
 *      where: // value for 'where'
 *   },
 * });
 */
export function useCountScheduledMessagesQuery(baseOptions?: Apollo.QueryHookOptions<CountScheduledMessagesQuery, CountScheduledMessagesQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<CountScheduledMessagesQuery, CountScheduledMessagesQueryVariables>(CountScheduledMessagesDocument, options);
      }
export function useCountScheduledMessagesLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<CountScheduledMessagesQuery, CountScheduledMessagesQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<CountScheduledMessagesQuery, CountScheduledMessagesQueryVariables>(CountScheduledMessagesDocument, options);
        }
export function useCountScheduledMessagesSuspenseQuery(baseOptions?: Apollo.SuspenseQueryHookOptions<CountScheduledMessagesQuery, CountScheduledMessagesQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useSuspenseQuery<CountScheduledMessagesQuery, CountScheduledMessagesQueryVariables>(CountScheduledMessagesDocument, options);
        }
export type CountScheduledMessagesQueryHookResult = ReturnType<typeof useCountScheduledMessagesQuery>;
export type CountScheduledMessagesLazyQueryHookResult = ReturnType<typeof useCountScheduledMessagesLazyQuery>;
export type CountScheduledMessagesSuspenseQueryHookResult = ReturnType<typeof useCountScheduledMessagesSuspenseQuery>;
export type CountScheduledMessagesQueryResult = Apollo.QueryResult<CountScheduledMessagesQuery, CountScheduledMessagesQueryVariables>;
export const GetSchedulingRulesCategorizedDocument = gql`
    query getSchedulingRulesCategorized($clinicId: ID!, $params: SchedulingRulesCategorizedParams!, $widgetId: ID) {
  getSchedulingRulesCategorized(
    clinicId: $clinicId
    params: $params
    widgetId: $widgetId
  ) {
    ...SchedulingRulesCategorizedFields
  }
}
    ${SchedulingRulesCategorizedFieldsFragmentDoc}`;

/**
 * __useGetSchedulingRulesCategorizedQuery__
 *
 * To run a query within a React component, call `useGetSchedulingRulesCategorizedQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetSchedulingRulesCategorizedQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetSchedulingRulesCategorizedQuery({
 *   variables: {
 *      clinicId: // value for 'clinicId'
 *      params: // value for 'params'
 *      widgetId: // value for 'widgetId'
 *   },
 * });
 */
export function useGetSchedulingRulesCategorizedQuery(baseOptions: Apollo.QueryHookOptions<GetSchedulingRulesCategorizedQuery, GetSchedulingRulesCategorizedQueryVariables> & ({ variables: GetSchedulingRulesCategorizedQueryVariables; skip?: boolean; } | { skip: boolean; }) ) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<GetSchedulingRulesCategorizedQuery, GetSchedulingRulesCategorizedQueryVariables>(GetSchedulingRulesCategorizedDocument, options);
      }
export function useGetSchedulingRulesCategorizedLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<GetSchedulingRulesCategorizedQuery, GetSchedulingRulesCategorizedQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<GetSchedulingRulesCategorizedQuery, GetSchedulingRulesCategorizedQueryVariables>(GetSchedulingRulesCategorizedDocument, options);
        }
export function useGetSchedulingRulesCategorizedSuspenseQuery(baseOptions?: Apollo.SuspenseQueryHookOptions<GetSchedulingRulesCategorizedQuery, GetSchedulingRulesCategorizedQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useSuspenseQuery<GetSchedulingRulesCategorizedQuery, GetSchedulingRulesCategorizedQueryVariables>(GetSchedulingRulesCategorizedDocument, options);
        }
export type GetSchedulingRulesCategorizedQueryHookResult = ReturnType<typeof useGetSchedulingRulesCategorizedQuery>;
export type GetSchedulingRulesCategorizedLazyQueryHookResult = ReturnType<typeof useGetSchedulingRulesCategorizedLazyQuery>;
export type GetSchedulingRulesCategorizedSuspenseQueryHookResult = ReturnType<typeof useGetSchedulingRulesCategorizedSuspenseQuery>;
export type GetSchedulingRulesCategorizedQueryResult = Apollo.QueryResult<GetSchedulingRulesCategorizedQuery, GetSchedulingRulesCategorizedQueryVariables>;
export const SchedulingRuleDocument = gql`
    query schedulingRule($schedulingRulesId: ID!) {
  schedulingRule(schedulingRulesId: $schedulingRulesId) {
    ...SchedulingRulesFields
  }
}
    ${SchedulingRulesFieldsFragmentDoc}`;

/**
 * __useSchedulingRuleQuery__
 *
 * To run a query within a React component, call `useSchedulingRuleQuery` and pass it any options that fit your needs.
 * When your component renders, `useSchedulingRuleQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useSchedulingRuleQuery({
 *   variables: {
 *      schedulingRulesId: // value for 'schedulingRulesId'
 *   },
 * });
 */
export function useSchedulingRuleQuery(baseOptions: Apollo.QueryHookOptions<SchedulingRuleQuery, SchedulingRuleQueryVariables> & ({ variables: SchedulingRuleQueryVariables; skip?: boolean; } | { skip: boolean; }) ) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<SchedulingRuleQuery, SchedulingRuleQueryVariables>(SchedulingRuleDocument, options);
      }
export function useSchedulingRuleLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<SchedulingRuleQuery, SchedulingRuleQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<SchedulingRuleQuery, SchedulingRuleQueryVariables>(SchedulingRuleDocument, options);
        }
export function useSchedulingRuleSuspenseQuery(baseOptions?: Apollo.SuspenseQueryHookOptions<SchedulingRuleQuery, SchedulingRuleQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useSuspenseQuery<SchedulingRuleQuery, SchedulingRuleQueryVariables>(SchedulingRuleDocument, options);
        }
export type SchedulingRuleQueryHookResult = ReturnType<typeof useSchedulingRuleQuery>;
export type SchedulingRuleLazyQueryHookResult = ReturnType<typeof useSchedulingRuleLazyQuery>;
export type SchedulingRuleSuspenseQueryHookResult = ReturnType<typeof useSchedulingRuleSuspenseQuery>;
export type SchedulingRuleQueryResult = Apollo.QueryResult<SchedulingRuleQuery, SchedulingRuleQueryVariables>;
export const GetSchedulingRulesForClinicDocument = gql`
    query getSchedulingRulesForClinic($clinicId: ID!, $page: NonNegativeInt, $pageSize: NonNegativeInt) {
  schedulingRulesForClinic(clinicId: $clinicId, page: $page, pageSize: $pageSize) {
    ...SchedulingRulesFields
  }
}
    ${SchedulingRulesFieldsFragmentDoc}`;

/**
 * __useGetSchedulingRulesForClinicQuery__
 *
 * To run a query within a React component, call `useGetSchedulingRulesForClinicQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetSchedulingRulesForClinicQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetSchedulingRulesForClinicQuery({
 *   variables: {
 *      clinicId: // value for 'clinicId'
 *      page: // value for 'page'
 *      pageSize: // value for 'pageSize'
 *   },
 * });
 */
export function useGetSchedulingRulesForClinicQuery(baseOptions: Apollo.QueryHookOptions<GetSchedulingRulesForClinicQuery, GetSchedulingRulesForClinicQueryVariables> & ({ variables: GetSchedulingRulesForClinicQueryVariables; skip?: boolean; } | { skip: boolean; }) ) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<GetSchedulingRulesForClinicQuery, GetSchedulingRulesForClinicQueryVariables>(GetSchedulingRulesForClinicDocument, options);
      }
export function useGetSchedulingRulesForClinicLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<GetSchedulingRulesForClinicQuery, GetSchedulingRulesForClinicQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<GetSchedulingRulesForClinicQuery, GetSchedulingRulesForClinicQueryVariables>(GetSchedulingRulesForClinicDocument, options);
        }
export function useGetSchedulingRulesForClinicSuspenseQuery(baseOptions?: Apollo.SuspenseQueryHookOptions<GetSchedulingRulesForClinicQuery, GetSchedulingRulesForClinicQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useSuspenseQuery<GetSchedulingRulesForClinicQuery, GetSchedulingRulesForClinicQueryVariables>(GetSchedulingRulesForClinicDocument, options);
        }
export type GetSchedulingRulesForClinicQueryHookResult = ReturnType<typeof useGetSchedulingRulesForClinicQuery>;
export type GetSchedulingRulesForClinicLazyQueryHookResult = ReturnType<typeof useGetSchedulingRulesForClinicLazyQuery>;
export type GetSchedulingRulesForClinicSuspenseQueryHookResult = ReturnType<typeof useGetSchedulingRulesForClinicSuspenseQuery>;
export type GetSchedulingRulesForClinicQueryResult = Apollo.QueryResult<GetSchedulingRulesForClinicQuery, GetSchedulingRulesForClinicQueryVariables>;
export const QuerySchedulingRulesDocument = gql`
    query querySchedulingRules($where: [QueryInput!], $page: NonNegativeInt, $pageSize: NonNegativeInt, $orderBy: OrderByInput) {
  querySchedulingRules(
    where: $where
    page: $page
    pageSize: $pageSize
    orderBy: $orderBy
  ) {
    ...SchedulingRulesFields
  }
}
    ${SchedulingRulesFieldsFragmentDoc}`;

/**
 * __useQuerySchedulingRulesQuery__
 *
 * To run a query within a React component, call `useQuerySchedulingRulesQuery` and pass it any options that fit your needs.
 * When your component renders, `useQuerySchedulingRulesQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useQuerySchedulingRulesQuery({
 *   variables: {
 *      where: // value for 'where'
 *      page: // value for 'page'
 *      pageSize: // value for 'pageSize'
 *      orderBy: // value for 'orderBy'
 *   },
 * });
 */
export function useQuerySchedulingRulesQuery(baseOptions?: Apollo.QueryHookOptions<QuerySchedulingRulesQuery, QuerySchedulingRulesQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<QuerySchedulingRulesQuery, QuerySchedulingRulesQueryVariables>(QuerySchedulingRulesDocument, options);
      }
export function useQuerySchedulingRulesLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<QuerySchedulingRulesQuery, QuerySchedulingRulesQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<QuerySchedulingRulesQuery, QuerySchedulingRulesQueryVariables>(QuerySchedulingRulesDocument, options);
        }
export function useQuerySchedulingRulesSuspenseQuery(baseOptions?: Apollo.SuspenseQueryHookOptions<QuerySchedulingRulesQuery, QuerySchedulingRulesQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useSuspenseQuery<QuerySchedulingRulesQuery, QuerySchedulingRulesQueryVariables>(QuerySchedulingRulesDocument, options);
        }
export type QuerySchedulingRulesQueryHookResult = ReturnType<typeof useQuerySchedulingRulesQuery>;
export type QuerySchedulingRulesLazyQueryHookResult = ReturnType<typeof useQuerySchedulingRulesLazyQuery>;
export type QuerySchedulingRulesSuspenseQueryHookResult = ReturnType<typeof useQuerySchedulingRulesSuspenseQuery>;
export type QuerySchedulingRulesQueryResult = Apollo.QueryResult<QuerySchedulingRulesQuery, QuerySchedulingRulesQueryVariables>;
export const CountSchedulingRulesDocument = gql`
    query countSchedulingRules($where: [QueryInput!]) {
  countSchedulingRules(where: $where)
}
    `;

/**
 * __useCountSchedulingRulesQuery__
 *
 * To run a query within a React component, call `useCountSchedulingRulesQuery` and pass it any options that fit your needs.
 * When your component renders, `useCountSchedulingRulesQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useCountSchedulingRulesQuery({
 *   variables: {
 *      where: // value for 'where'
 *   },
 * });
 */
export function useCountSchedulingRulesQuery(baseOptions?: Apollo.QueryHookOptions<CountSchedulingRulesQuery, CountSchedulingRulesQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<CountSchedulingRulesQuery, CountSchedulingRulesQueryVariables>(CountSchedulingRulesDocument, options);
      }
export function useCountSchedulingRulesLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<CountSchedulingRulesQuery, CountSchedulingRulesQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<CountSchedulingRulesQuery, CountSchedulingRulesQueryVariables>(CountSchedulingRulesDocument, options);
        }
export function useCountSchedulingRulesSuspenseQuery(baseOptions?: Apollo.SuspenseQueryHookOptions<CountSchedulingRulesQuery, CountSchedulingRulesQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useSuspenseQuery<CountSchedulingRulesQuery, CountSchedulingRulesQueryVariables>(CountSchedulingRulesDocument, options);
        }
export type CountSchedulingRulesQueryHookResult = ReturnType<typeof useCountSchedulingRulesQuery>;
export type CountSchedulingRulesLazyQueryHookResult = ReturnType<typeof useCountSchedulingRulesLazyQuery>;
export type CountSchedulingRulesSuspenseQueryHookResult = ReturnType<typeof useCountSchedulingRulesSuspenseQuery>;
export type CountSchedulingRulesQueryResult = Apollo.QueryResult<CountSchedulingRulesQuery, CountSchedulingRulesQueryVariables>;
export const CountSchedulingRulesForClinicDocument = gql`
    query countSchedulingRulesForClinic($clinicId: ID!) {
  countSchedulingRulesForClinic(clinicId: $clinicId)
}
    `;

/**
 * __useCountSchedulingRulesForClinicQuery__
 *
 * To run a query within a React component, call `useCountSchedulingRulesForClinicQuery` and pass it any options that fit your needs.
 * When your component renders, `useCountSchedulingRulesForClinicQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useCountSchedulingRulesForClinicQuery({
 *   variables: {
 *      clinicId: // value for 'clinicId'
 *   },
 * });
 */
export function useCountSchedulingRulesForClinicQuery(baseOptions: Apollo.QueryHookOptions<CountSchedulingRulesForClinicQuery, CountSchedulingRulesForClinicQueryVariables> & ({ variables: CountSchedulingRulesForClinicQueryVariables; skip?: boolean; } | { skip: boolean; }) ) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<CountSchedulingRulesForClinicQuery, CountSchedulingRulesForClinicQueryVariables>(CountSchedulingRulesForClinicDocument, options);
      }
export function useCountSchedulingRulesForClinicLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<CountSchedulingRulesForClinicQuery, CountSchedulingRulesForClinicQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<CountSchedulingRulesForClinicQuery, CountSchedulingRulesForClinicQueryVariables>(CountSchedulingRulesForClinicDocument, options);
        }
export function useCountSchedulingRulesForClinicSuspenseQuery(baseOptions?: Apollo.SuspenseQueryHookOptions<CountSchedulingRulesForClinicQuery, CountSchedulingRulesForClinicQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useSuspenseQuery<CountSchedulingRulesForClinicQuery, CountSchedulingRulesForClinicQueryVariables>(CountSchedulingRulesForClinicDocument, options);
        }
export type CountSchedulingRulesForClinicQueryHookResult = ReturnType<typeof useCountSchedulingRulesForClinicQuery>;
export type CountSchedulingRulesForClinicLazyQueryHookResult = ReturnType<typeof useCountSchedulingRulesForClinicLazyQuery>;
export type CountSchedulingRulesForClinicSuspenseQueryHookResult = ReturnType<typeof useCountSchedulingRulesForClinicSuspenseQuery>;
export type CountSchedulingRulesForClinicQueryResult = Apollo.QueryResult<CountSchedulingRulesForClinicQuery, CountSchedulingRulesForClinicQueryVariables>;
export const GetSchedulingRulesForWidgetDocument = gql`
    query getSchedulingRulesForWidget($widgetId: ID!) {
  schedulingRulesForWidget(widgetId: $widgetId) {
    ...SchedulingRulesFields
  }
}
    ${SchedulingRulesFieldsFragmentDoc}`;

/**
 * __useGetSchedulingRulesForWidgetQuery__
 *
 * To run a query within a React component, call `useGetSchedulingRulesForWidgetQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetSchedulingRulesForWidgetQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetSchedulingRulesForWidgetQuery({
 *   variables: {
 *      widgetId: // value for 'widgetId'
 *   },
 * });
 */
export function useGetSchedulingRulesForWidgetQuery(baseOptions: Apollo.QueryHookOptions<GetSchedulingRulesForWidgetQuery, GetSchedulingRulesForWidgetQueryVariables> & ({ variables: GetSchedulingRulesForWidgetQueryVariables; skip?: boolean; } | { skip: boolean; }) ) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<GetSchedulingRulesForWidgetQuery, GetSchedulingRulesForWidgetQueryVariables>(GetSchedulingRulesForWidgetDocument, options);
      }
export function useGetSchedulingRulesForWidgetLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<GetSchedulingRulesForWidgetQuery, GetSchedulingRulesForWidgetQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<GetSchedulingRulesForWidgetQuery, GetSchedulingRulesForWidgetQueryVariables>(GetSchedulingRulesForWidgetDocument, options);
        }
export function useGetSchedulingRulesForWidgetSuspenseQuery(baseOptions?: Apollo.SuspenseQueryHookOptions<GetSchedulingRulesForWidgetQuery, GetSchedulingRulesForWidgetQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useSuspenseQuery<GetSchedulingRulesForWidgetQuery, GetSchedulingRulesForWidgetQueryVariables>(GetSchedulingRulesForWidgetDocument, options);
        }
export type GetSchedulingRulesForWidgetQueryHookResult = ReturnType<typeof useGetSchedulingRulesForWidgetQuery>;
export type GetSchedulingRulesForWidgetLazyQueryHookResult = ReturnType<typeof useGetSchedulingRulesForWidgetLazyQuery>;
export type GetSchedulingRulesForWidgetSuspenseQueryHookResult = ReturnType<typeof useGetSchedulingRulesForWidgetSuspenseQuery>;
export type GetSchedulingRulesForWidgetQueryResult = Apollo.QueryResult<GetSchedulingRulesForWidgetQuery, GetSchedulingRulesForWidgetQueryVariables>;
export const UpdateSchedulingRulesDocument = gql`
    mutation updateSchedulingRules($schedulingRulesId: ID!, $data: UpdateSchedulingRulesInput!) {
  updateSchedulingRules(schedulingRulesId: $schedulingRulesId, data: $data) {
    ...SchedulingRulesFields
  }
}
    ${SchedulingRulesFieldsFragmentDoc}`;
export type UpdateSchedulingRulesMutationFn = Apollo.MutationFunction<UpdateSchedulingRulesMutation, UpdateSchedulingRulesMutationVariables>;

/**
 * __useUpdateSchedulingRulesMutation__
 *
 * To run a mutation, you first call `useUpdateSchedulingRulesMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useUpdateSchedulingRulesMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [updateSchedulingRulesMutation, { data, loading, error }] = useUpdateSchedulingRulesMutation({
 *   variables: {
 *      schedulingRulesId: // value for 'schedulingRulesId'
 *      data: // value for 'data'
 *   },
 * });
 */
export function useUpdateSchedulingRulesMutation(baseOptions?: Apollo.MutationHookOptions<UpdateSchedulingRulesMutation, UpdateSchedulingRulesMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<UpdateSchedulingRulesMutation, UpdateSchedulingRulesMutationVariables>(UpdateSchedulingRulesDocument, options);
      }
export type UpdateSchedulingRulesMutationHookResult = ReturnType<typeof useUpdateSchedulingRulesMutation>;
export type UpdateSchedulingRulesMutationResult = Apollo.MutationResult<UpdateSchedulingRulesMutation>;
export type UpdateSchedulingRulesMutationOptions = Apollo.BaseMutationOptions<UpdateSchedulingRulesMutation, UpdateSchedulingRulesMutationVariables>;
export const CreateSchedulingRulesDocument = gql`
    mutation createSchedulingRules($data: CreateSchedulingRulesInput!) {
  createSchedulingRules(data: $data) {
    ...SchedulingRulesFields
  }
}
    ${SchedulingRulesFieldsFragmentDoc}`;
export type CreateSchedulingRulesMutationFn = Apollo.MutationFunction<CreateSchedulingRulesMutation, CreateSchedulingRulesMutationVariables>;

/**
 * __useCreateSchedulingRulesMutation__
 *
 * To run a mutation, you first call `useCreateSchedulingRulesMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useCreateSchedulingRulesMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [createSchedulingRulesMutation, { data, loading, error }] = useCreateSchedulingRulesMutation({
 *   variables: {
 *      data: // value for 'data'
 *   },
 * });
 */
export function useCreateSchedulingRulesMutation(baseOptions?: Apollo.MutationHookOptions<CreateSchedulingRulesMutation, CreateSchedulingRulesMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<CreateSchedulingRulesMutation, CreateSchedulingRulesMutationVariables>(CreateSchedulingRulesDocument, options);
      }
export type CreateSchedulingRulesMutationHookResult = ReturnType<typeof useCreateSchedulingRulesMutation>;
export type CreateSchedulingRulesMutationResult = Apollo.MutationResult<CreateSchedulingRulesMutation>;
export type CreateSchedulingRulesMutationOptions = Apollo.BaseMutationOptions<CreateSchedulingRulesMutation, CreateSchedulingRulesMutationVariables>;
export const DeleteSchedulingRuleDocument = gql`
    mutation deleteSchedulingRule($schedulingRulesId: ID!) {
  deleteSchedulingRules(schedulingRulesId: $schedulingRulesId)
}
    `;
export type DeleteSchedulingRuleMutationFn = Apollo.MutationFunction<DeleteSchedulingRuleMutation, DeleteSchedulingRuleMutationVariables>;

/**
 * __useDeleteSchedulingRuleMutation__
 *
 * To run a mutation, you first call `useDeleteSchedulingRuleMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useDeleteSchedulingRuleMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [deleteSchedulingRuleMutation, { data, loading, error }] = useDeleteSchedulingRuleMutation({
 *   variables: {
 *      schedulingRulesId: // value for 'schedulingRulesId'
 *   },
 * });
 */
export function useDeleteSchedulingRuleMutation(baseOptions?: Apollo.MutationHookOptions<DeleteSchedulingRuleMutation, DeleteSchedulingRuleMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<DeleteSchedulingRuleMutation, DeleteSchedulingRuleMutationVariables>(DeleteSchedulingRuleDocument, options);
      }
export type DeleteSchedulingRuleMutationHookResult = ReturnType<typeof useDeleteSchedulingRuleMutation>;
export type DeleteSchedulingRuleMutationResult = Apollo.MutationResult<DeleteSchedulingRuleMutation>;
export type DeleteSchedulingRuleMutationOptions = Apollo.BaseMutationOptions<DeleteSchedulingRuleMutation, DeleteSchedulingRuleMutationVariables>;
export const ServiceCategoryDocument = gql`
    query serviceCategory($id: ID!) {
  serviceCategory(id: $id) {
    ...ServiceCategoryFields
  }
}
    ${ServiceCategoryFieldsFragmentDoc}`;

/**
 * __useServiceCategoryQuery__
 *
 * To run a query within a React component, call `useServiceCategoryQuery` and pass it any options that fit your needs.
 * When your component renders, `useServiceCategoryQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useServiceCategoryQuery({
 *   variables: {
 *      id: // value for 'id'
 *   },
 * });
 */
export function useServiceCategoryQuery(baseOptions: Apollo.QueryHookOptions<ServiceCategoryQuery, ServiceCategoryQueryVariables> & ({ variables: ServiceCategoryQueryVariables; skip?: boolean; } | { skip: boolean; }) ) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<ServiceCategoryQuery, ServiceCategoryQueryVariables>(ServiceCategoryDocument, options);
      }
export function useServiceCategoryLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<ServiceCategoryQuery, ServiceCategoryQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<ServiceCategoryQuery, ServiceCategoryQueryVariables>(ServiceCategoryDocument, options);
        }
export function useServiceCategorySuspenseQuery(baseOptions?: Apollo.SuspenseQueryHookOptions<ServiceCategoryQuery, ServiceCategoryQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useSuspenseQuery<ServiceCategoryQuery, ServiceCategoryQueryVariables>(ServiceCategoryDocument, options);
        }
export type ServiceCategoryQueryHookResult = ReturnType<typeof useServiceCategoryQuery>;
export type ServiceCategoryLazyQueryHookResult = ReturnType<typeof useServiceCategoryLazyQuery>;
export type ServiceCategorySuspenseQueryHookResult = ReturnType<typeof useServiceCategorySuspenseQuery>;
export type ServiceCategoryQueryResult = Apollo.QueryResult<ServiceCategoryQuery, ServiceCategoryQueryVariables>;
export const ServiceCategoriesDocument = gql`
    query serviceCategories($clinicId: ID!) {
  serviceCategories(clinicId: $clinicId) {
    ...ServiceCategoryFields
  }
}
    ${ServiceCategoryFieldsFragmentDoc}`;

/**
 * __useServiceCategoriesQuery__
 *
 * To run a query within a React component, call `useServiceCategoriesQuery` and pass it any options that fit your needs.
 * When your component renders, `useServiceCategoriesQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useServiceCategoriesQuery({
 *   variables: {
 *      clinicId: // value for 'clinicId'
 *   },
 * });
 */
export function useServiceCategoriesQuery(baseOptions: Apollo.QueryHookOptions<ServiceCategoriesQuery, ServiceCategoriesQueryVariables> & ({ variables: ServiceCategoriesQueryVariables; skip?: boolean; } | { skip: boolean; }) ) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<ServiceCategoriesQuery, ServiceCategoriesQueryVariables>(ServiceCategoriesDocument, options);
      }
export function useServiceCategoriesLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<ServiceCategoriesQuery, ServiceCategoriesQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<ServiceCategoriesQuery, ServiceCategoriesQueryVariables>(ServiceCategoriesDocument, options);
        }
export function useServiceCategoriesSuspenseQuery(baseOptions?: Apollo.SuspenseQueryHookOptions<ServiceCategoriesQuery, ServiceCategoriesQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useSuspenseQuery<ServiceCategoriesQuery, ServiceCategoriesQueryVariables>(ServiceCategoriesDocument, options);
        }
export type ServiceCategoriesQueryHookResult = ReturnType<typeof useServiceCategoriesQuery>;
export type ServiceCategoriesLazyQueryHookResult = ReturnType<typeof useServiceCategoriesLazyQuery>;
export type ServiceCategoriesSuspenseQueryHookResult = ReturnType<typeof useServiceCategoriesSuspenseQuery>;
export type ServiceCategoriesQueryResult = Apollo.QueryResult<ServiceCategoriesQuery, ServiceCategoriesQueryVariables>;
export const CreateServiceCategoryDocument = gql`
    mutation createServiceCategory($data: CreateServiceCategoryInput!) {
  createServiceCategory(data: $data) {
    ...ServiceCategoryFields
  }
}
    ${ServiceCategoryFieldsFragmentDoc}`;
export type CreateServiceCategoryMutationFn = Apollo.MutationFunction<CreateServiceCategoryMutation, CreateServiceCategoryMutationVariables>;

/**
 * __useCreateServiceCategoryMutation__
 *
 * To run a mutation, you first call `useCreateServiceCategoryMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useCreateServiceCategoryMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [createServiceCategoryMutation, { data, loading, error }] = useCreateServiceCategoryMutation({
 *   variables: {
 *      data: // value for 'data'
 *   },
 * });
 */
export function useCreateServiceCategoryMutation(baseOptions?: Apollo.MutationHookOptions<CreateServiceCategoryMutation, CreateServiceCategoryMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<CreateServiceCategoryMutation, CreateServiceCategoryMutationVariables>(CreateServiceCategoryDocument, options);
      }
export type CreateServiceCategoryMutationHookResult = ReturnType<typeof useCreateServiceCategoryMutation>;
export type CreateServiceCategoryMutationResult = Apollo.MutationResult<CreateServiceCategoryMutation>;
export type CreateServiceCategoryMutationOptions = Apollo.BaseMutationOptions<CreateServiceCategoryMutation, CreateServiceCategoryMutationVariables>;
export const UpdateServiceCategoryDocument = gql`
    mutation updateServiceCategory($id: ID!, $clinicId: ID!, $data: UpdateServiceCategoryInput!) {
  updateServiceCategory(id: $id, clinicId: $clinicId, data: $data) {
    ...ServiceCategoryFields
  }
}
    ${ServiceCategoryFieldsFragmentDoc}`;
export type UpdateServiceCategoryMutationFn = Apollo.MutationFunction<UpdateServiceCategoryMutation, UpdateServiceCategoryMutationVariables>;

/**
 * __useUpdateServiceCategoryMutation__
 *
 * To run a mutation, you first call `useUpdateServiceCategoryMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useUpdateServiceCategoryMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [updateServiceCategoryMutation, { data, loading, error }] = useUpdateServiceCategoryMutation({
 *   variables: {
 *      id: // value for 'id'
 *      clinicId: // value for 'clinicId'
 *      data: // value for 'data'
 *   },
 * });
 */
export function useUpdateServiceCategoryMutation(baseOptions?: Apollo.MutationHookOptions<UpdateServiceCategoryMutation, UpdateServiceCategoryMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<UpdateServiceCategoryMutation, UpdateServiceCategoryMutationVariables>(UpdateServiceCategoryDocument, options);
      }
export type UpdateServiceCategoryMutationHookResult = ReturnType<typeof useUpdateServiceCategoryMutation>;
export type UpdateServiceCategoryMutationResult = Apollo.MutationResult<UpdateServiceCategoryMutation>;
export type UpdateServiceCategoryMutationOptions = Apollo.BaseMutationOptions<UpdateServiceCategoryMutation, UpdateServiceCategoryMutationVariables>;
export const DeleteServiceCategoryDocument = gql`
    mutation deleteServiceCategory($id: ID!, $clinicId: ID!) {
  deleteServiceCategory(id: $id, clinicId: $clinicId)
}
    `;
export type DeleteServiceCategoryMutationFn = Apollo.MutationFunction<DeleteServiceCategoryMutation, DeleteServiceCategoryMutationVariables>;

/**
 * __useDeleteServiceCategoryMutation__
 *
 * To run a mutation, you first call `useDeleteServiceCategoryMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useDeleteServiceCategoryMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [deleteServiceCategoryMutation, { data, loading, error }] = useDeleteServiceCategoryMutation({
 *   variables: {
 *      id: // value for 'id'
 *      clinicId: // value for 'clinicId'
 *   },
 * });
 */
export function useDeleteServiceCategoryMutation(baseOptions?: Apollo.MutationHookOptions<DeleteServiceCategoryMutation, DeleteServiceCategoryMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<DeleteServiceCategoryMutation, DeleteServiceCategoryMutationVariables>(DeleteServiceCategoryDocument, options);
      }
export type DeleteServiceCategoryMutationHookResult = ReturnType<typeof useDeleteServiceCategoryMutation>;
export type DeleteServiceCategoryMutationResult = Apollo.MutationResult<DeleteServiceCategoryMutation>;
export type DeleteServiceCategoryMutationOptions = Apollo.BaseMutationOptions<DeleteServiceCategoryMutation, DeleteServiceCategoryMutationVariables>;
export const CreateServiceFormDocument = gql`
    mutation createServiceForm($data: CreateServiceFormInput!) {
  createServiceForm(data: $data) {
    ...ServiceFormFields
  }
}
    ${ServiceFormFieldsFragmentDoc}`;
export type CreateServiceFormMutationFn = Apollo.MutationFunction<CreateServiceFormMutation, CreateServiceFormMutationVariables>;

/**
 * __useCreateServiceFormMutation__
 *
 * To run a mutation, you first call `useCreateServiceFormMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useCreateServiceFormMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [createServiceFormMutation, { data, loading, error }] = useCreateServiceFormMutation({
 *   variables: {
 *      data: // value for 'data'
 *   },
 * });
 */
export function useCreateServiceFormMutation(baseOptions?: Apollo.MutationHookOptions<CreateServiceFormMutation, CreateServiceFormMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<CreateServiceFormMutation, CreateServiceFormMutationVariables>(CreateServiceFormDocument, options);
      }
export type CreateServiceFormMutationHookResult = ReturnType<typeof useCreateServiceFormMutation>;
export type CreateServiceFormMutationResult = Apollo.MutationResult<CreateServiceFormMutation>;
export type CreateServiceFormMutationOptions = Apollo.BaseMutationOptions<CreateServiceFormMutation, CreateServiceFormMutationVariables>;
export const UpdateServiceFormDocument = gql`
    mutation updateServiceForm($id: ID!, $data: UpdateServiceFormInput!) {
  updateServiceForm(id: $id, data: $data) {
    ...ServiceFormFields
  }
}
    ${ServiceFormFieldsFragmentDoc}`;
export type UpdateServiceFormMutationFn = Apollo.MutationFunction<UpdateServiceFormMutation, UpdateServiceFormMutationVariables>;

/**
 * __useUpdateServiceFormMutation__
 *
 * To run a mutation, you first call `useUpdateServiceFormMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useUpdateServiceFormMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [updateServiceFormMutation, { data, loading, error }] = useUpdateServiceFormMutation({
 *   variables: {
 *      id: // value for 'id'
 *      data: // value for 'data'
 *   },
 * });
 */
export function useUpdateServiceFormMutation(baseOptions?: Apollo.MutationHookOptions<UpdateServiceFormMutation, UpdateServiceFormMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<UpdateServiceFormMutation, UpdateServiceFormMutationVariables>(UpdateServiceFormDocument, options);
      }
export type UpdateServiceFormMutationHookResult = ReturnType<typeof useUpdateServiceFormMutation>;
export type UpdateServiceFormMutationResult = Apollo.MutationResult<UpdateServiceFormMutation>;
export type UpdateServiceFormMutationOptions = Apollo.BaseMutationOptions<UpdateServiceFormMutation, UpdateServiceFormMutationVariables>;
export const DeleteServiceFormDocument = gql`
    mutation deleteServiceForm($serviceId: ID!, $formId: ID!) {
  deleteServiceFormByServiceAndForm(serviceId: $serviceId, formId: $formId)
}
    `;
export type DeleteServiceFormMutationFn = Apollo.MutationFunction<DeleteServiceFormMutation, DeleteServiceFormMutationVariables>;

/**
 * __useDeleteServiceFormMutation__
 *
 * To run a mutation, you first call `useDeleteServiceFormMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useDeleteServiceFormMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [deleteServiceFormMutation, { data, loading, error }] = useDeleteServiceFormMutation({
 *   variables: {
 *      serviceId: // value for 'serviceId'
 *      formId: // value for 'formId'
 *   },
 * });
 */
export function useDeleteServiceFormMutation(baseOptions?: Apollo.MutationHookOptions<DeleteServiceFormMutation, DeleteServiceFormMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<DeleteServiceFormMutation, DeleteServiceFormMutationVariables>(DeleteServiceFormDocument, options);
      }
export type DeleteServiceFormMutationHookResult = ReturnType<typeof useDeleteServiceFormMutation>;
export type DeleteServiceFormMutationResult = Apollo.MutationResult<DeleteServiceFormMutation>;
export type DeleteServiceFormMutationOptions = Apollo.BaseMutationOptions<DeleteServiceFormMutation, DeleteServiceFormMutationVariables>;
export const GetServiceFormDocument = gql`
    query getServiceForm($serviceId: ID!, $formId: ID!) {
  serviceFormByServiceAndForm(serviceId: $serviceId, formId: $formId) {
    ...ServiceFormFields
  }
}
    ${ServiceFormFieldsFragmentDoc}`;

/**
 * __useGetServiceFormQuery__
 *
 * To run a query within a React component, call `useGetServiceFormQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetServiceFormQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetServiceFormQuery({
 *   variables: {
 *      serviceId: // value for 'serviceId'
 *      formId: // value for 'formId'
 *   },
 * });
 */
export function useGetServiceFormQuery(baseOptions: Apollo.QueryHookOptions<GetServiceFormQuery, GetServiceFormQueryVariables> & ({ variables: GetServiceFormQueryVariables; skip?: boolean; } | { skip: boolean; }) ) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<GetServiceFormQuery, GetServiceFormQueryVariables>(GetServiceFormDocument, options);
      }
export function useGetServiceFormLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<GetServiceFormQuery, GetServiceFormQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<GetServiceFormQuery, GetServiceFormQueryVariables>(GetServiceFormDocument, options);
        }
export function useGetServiceFormSuspenseQuery(baseOptions?: Apollo.SuspenseQueryHookOptions<GetServiceFormQuery, GetServiceFormQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useSuspenseQuery<GetServiceFormQuery, GetServiceFormQueryVariables>(GetServiceFormDocument, options);
        }
export type GetServiceFormQueryHookResult = ReturnType<typeof useGetServiceFormQuery>;
export type GetServiceFormLazyQueryHookResult = ReturnType<typeof useGetServiceFormLazyQuery>;
export type GetServiceFormSuspenseQueryHookResult = ReturnType<typeof useGetServiceFormSuspenseQuery>;
export type GetServiceFormQueryResult = Apollo.QueryResult<GetServiceFormQuery, GetServiceFormQueryVariables>;
export const QueryServiceFormsDocument = gql`
    query queryServiceForms($where: [QueryInput!], $page: NonNegativeInt, $pageSize: NonNegativeInt, $orderBy: OrderByInput) {
  queryServiceForms(
    where: $where
    page: $page
    pageSize: $pageSize
    orderBy: $orderBy
  ) {
    ...ServiceFormFields
  }
}
    ${ServiceFormFieldsFragmentDoc}`;

/**
 * __useQueryServiceFormsQuery__
 *
 * To run a query within a React component, call `useQueryServiceFormsQuery` and pass it any options that fit your needs.
 * When your component renders, `useQueryServiceFormsQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useQueryServiceFormsQuery({
 *   variables: {
 *      where: // value for 'where'
 *      page: // value for 'page'
 *      pageSize: // value for 'pageSize'
 *      orderBy: // value for 'orderBy'
 *   },
 * });
 */
export function useQueryServiceFormsQuery(baseOptions?: Apollo.QueryHookOptions<QueryServiceFormsQuery, QueryServiceFormsQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<QueryServiceFormsQuery, QueryServiceFormsQueryVariables>(QueryServiceFormsDocument, options);
      }
export function useQueryServiceFormsLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<QueryServiceFormsQuery, QueryServiceFormsQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<QueryServiceFormsQuery, QueryServiceFormsQueryVariables>(QueryServiceFormsDocument, options);
        }
export function useQueryServiceFormsSuspenseQuery(baseOptions?: Apollo.SuspenseQueryHookOptions<QueryServiceFormsQuery, QueryServiceFormsQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useSuspenseQuery<QueryServiceFormsQuery, QueryServiceFormsQueryVariables>(QueryServiceFormsDocument, options);
        }
export type QueryServiceFormsQueryHookResult = ReturnType<typeof useQueryServiceFormsQuery>;
export type QueryServiceFormsLazyQueryHookResult = ReturnType<typeof useQueryServiceFormsLazyQuery>;
export type QueryServiceFormsSuspenseQueryHookResult = ReturnType<typeof useQueryServiceFormsSuspenseQuery>;
export type QueryServiceFormsQueryResult = Apollo.QueryResult<QueryServiceFormsQuery, QueryServiceFormsQueryVariables>;
export const CountServiceFormsDocument = gql`
    query countServiceForms($where: [QueryInput!]) {
  countServiceForms(where: $where)
}
    `;

/**
 * __useCountServiceFormsQuery__
 *
 * To run a query within a React component, call `useCountServiceFormsQuery` and pass it any options that fit your needs.
 * When your component renders, `useCountServiceFormsQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useCountServiceFormsQuery({
 *   variables: {
 *      where: // value for 'where'
 *   },
 * });
 */
export function useCountServiceFormsQuery(baseOptions?: Apollo.QueryHookOptions<CountServiceFormsQuery, CountServiceFormsQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<CountServiceFormsQuery, CountServiceFormsQueryVariables>(CountServiceFormsDocument, options);
      }
export function useCountServiceFormsLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<CountServiceFormsQuery, CountServiceFormsQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<CountServiceFormsQuery, CountServiceFormsQueryVariables>(CountServiceFormsDocument, options);
        }
export function useCountServiceFormsSuspenseQuery(baseOptions?: Apollo.SuspenseQueryHookOptions<CountServiceFormsQuery, CountServiceFormsQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useSuspenseQuery<CountServiceFormsQuery, CountServiceFormsQueryVariables>(CountServiceFormsDocument, options);
        }
export type CountServiceFormsQueryHookResult = ReturnType<typeof useCountServiceFormsQuery>;
export type CountServiceFormsLazyQueryHookResult = ReturnType<typeof useCountServiceFormsLazyQuery>;
export type CountServiceFormsSuspenseQueryHookResult = ReturnType<typeof useCountServiceFormsSuspenseQuery>;
export type CountServiceFormsQueryResult = Apollo.QueryResult<CountServiceFormsQuery, CountServiceFormsQueryVariables>;
export const GetAllServicesByClinicIdDocument = gql`
    query getAllServicesByClinicId($clinicId: ID!) {
  allServicesByClinicId(id: $clinicId) {
    ...ServiceFields
  }
}
    ${ServiceFieldsFragmentDoc}`;

/**
 * __useGetAllServicesByClinicIdQuery__
 *
 * To run a query within a React component, call `useGetAllServicesByClinicIdQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetAllServicesByClinicIdQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetAllServicesByClinicIdQuery({
 *   variables: {
 *      clinicId: // value for 'clinicId'
 *   },
 * });
 */
export function useGetAllServicesByClinicIdQuery(baseOptions: Apollo.QueryHookOptions<GetAllServicesByClinicIdQuery, GetAllServicesByClinicIdQueryVariables> & ({ variables: GetAllServicesByClinicIdQueryVariables; skip?: boolean; } | { skip: boolean; }) ) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<GetAllServicesByClinicIdQuery, GetAllServicesByClinicIdQueryVariables>(GetAllServicesByClinicIdDocument, options);
      }
export function useGetAllServicesByClinicIdLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<GetAllServicesByClinicIdQuery, GetAllServicesByClinicIdQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<GetAllServicesByClinicIdQuery, GetAllServicesByClinicIdQueryVariables>(GetAllServicesByClinicIdDocument, options);
        }
export function useGetAllServicesByClinicIdSuspenseQuery(baseOptions?: Apollo.SuspenseQueryHookOptions<GetAllServicesByClinicIdQuery, GetAllServicesByClinicIdQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useSuspenseQuery<GetAllServicesByClinicIdQuery, GetAllServicesByClinicIdQueryVariables>(GetAllServicesByClinicIdDocument, options);
        }
export type GetAllServicesByClinicIdQueryHookResult = ReturnType<typeof useGetAllServicesByClinicIdQuery>;
export type GetAllServicesByClinicIdLazyQueryHookResult = ReturnType<typeof useGetAllServicesByClinicIdLazyQuery>;
export type GetAllServicesByClinicIdSuspenseQueryHookResult = ReturnType<typeof useGetAllServicesByClinicIdSuspenseQuery>;
export type GetAllServicesByClinicIdQueryResult = Apollo.QueryResult<GetAllServicesByClinicIdQuery, GetAllServicesByClinicIdQueryVariables>;
export const QueryServicesDocument = gql`
    query queryServices($where: [QueryInput!], $page: NonNegativeInt, $pageSize: NonNegativeInt, $orderBy: OrderByInput) {
  queryServices(
    where: $where
    page: $page
    pageSize: $pageSize
    orderBy: $orderBy
  ) {
    ...ServiceFields
  }
}
    ${ServiceFieldsFragmentDoc}`;

/**
 * __useQueryServicesQuery__
 *
 * To run a query within a React component, call `useQueryServicesQuery` and pass it any options that fit your needs.
 * When your component renders, `useQueryServicesQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useQueryServicesQuery({
 *   variables: {
 *      where: // value for 'where'
 *      page: // value for 'page'
 *      pageSize: // value for 'pageSize'
 *      orderBy: // value for 'orderBy'
 *   },
 * });
 */
export function useQueryServicesQuery(baseOptions?: Apollo.QueryHookOptions<QueryServicesQuery, QueryServicesQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<QueryServicesQuery, QueryServicesQueryVariables>(QueryServicesDocument, options);
      }
export function useQueryServicesLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<QueryServicesQuery, QueryServicesQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<QueryServicesQuery, QueryServicesQueryVariables>(QueryServicesDocument, options);
        }
export function useQueryServicesSuspenseQuery(baseOptions?: Apollo.SuspenseQueryHookOptions<QueryServicesQuery, QueryServicesQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useSuspenseQuery<QueryServicesQuery, QueryServicesQueryVariables>(QueryServicesDocument, options);
        }
export type QueryServicesQueryHookResult = ReturnType<typeof useQueryServicesQuery>;
export type QueryServicesLazyQueryHookResult = ReturnType<typeof useQueryServicesLazyQuery>;
export type QueryServicesSuspenseQueryHookResult = ReturnType<typeof useQueryServicesSuspenseQuery>;
export type QueryServicesQueryResult = Apollo.QueryResult<QueryServicesQuery, QueryServicesQueryVariables>;
export const QueryPreviewServicesDocument = gql`
    query queryPreviewServices($where: [QueryInput!], $page: NonNegativeInt, $pageSize: NonNegativeInt, $orderBy: OrderByInput) {
  queryServices(
    where: $where
    page: $page
    pageSize: $pageSize
    orderBy: $orderBy
  ) {
    ...ServicePreviewFields
  }
}
    ${ServicePreviewFieldsFragmentDoc}`;

/**
 * __useQueryPreviewServicesQuery__
 *
 * To run a query within a React component, call `useQueryPreviewServicesQuery` and pass it any options that fit your needs.
 * When your component renders, `useQueryPreviewServicesQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useQueryPreviewServicesQuery({
 *   variables: {
 *      where: // value for 'where'
 *      page: // value for 'page'
 *      pageSize: // value for 'pageSize'
 *      orderBy: // value for 'orderBy'
 *   },
 * });
 */
export function useQueryPreviewServicesQuery(baseOptions?: Apollo.QueryHookOptions<QueryPreviewServicesQuery, QueryPreviewServicesQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<QueryPreviewServicesQuery, QueryPreviewServicesQueryVariables>(QueryPreviewServicesDocument, options);
      }
export function useQueryPreviewServicesLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<QueryPreviewServicesQuery, QueryPreviewServicesQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<QueryPreviewServicesQuery, QueryPreviewServicesQueryVariables>(QueryPreviewServicesDocument, options);
        }
export function useQueryPreviewServicesSuspenseQuery(baseOptions?: Apollo.SuspenseQueryHookOptions<QueryPreviewServicesQuery, QueryPreviewServicesQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useSuspenseQuery<QueryPreviewServicesQuery, QueryPreviewServicesQueryVariables>(QueryPreviewServicesDocument, options);
        }
export type QueryPreviewServicesQueryHookResult = ReturnType<typeof useQueryPreviewServicesQuery>;
export type QueryPreviewServicesLazyQueryHookResult = ReturnType<typeof useQueryPreviewServicesLazyQuery>;
export type QueryPreviewServicesSuspenseQueryHookResult = ReturnType<typeof useQueryPreviewServicesSuspenseQuery>;
export type QueryPreviewServicesQueryResult = Apollo.QueryResult<QueryPreviewServicesQuery, QueryPreviewServicesQueryVariables>;
export const CountServicesDocument = gql`
    query countServices($where: [QueryInput!]) {
  countServices(where: $where)
}
    `;

/**
 * __useCountServicesQuery__
 *
 * To run a query within a React component, call `useCountServicesQuery` and pass it any options that fit your needs.
 * When your component renders, `useCountServicesQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useCountServicesQuery({
 *   variables: {
 *      where: // value for 'where'
 *   },
 * });
 */
export function useCountServicesQuery(baseOptions?: Apollo.QueryHookOptions<CountServicesQuery, CountServicesQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<CountServicesQuery, CountServicesQueryVariables>(CountServicesDocument, options);
      }
export function useCountServicesLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<CountServicesQuery, CountServicesQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<CountServicesQuery, CountServicesQueryVariables>(CountServicesDocument, options);
        }
export function useCountServicesSuspenseQuery(baseOptions?: Apollo.SuspenseQueryHookOptions<CountServicesQuery, CountServicesQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useSuspenseQuery<CountServicesQuery, CountServicesQueryVariables>(CountServicesDocument, options);
        }
export type CountServicesQueryHookResult = ReturnType<typeof useCountServicesQuery>;
export type CountServicesLazyQueryHookResult = ReturnType<typeof useCountServicesLazyQuery>;
export type CountServicesSuspenseQueryHookResult = ReturnType<typeof useCountServicesSuspenseQuery>;
export type CountServicesQueryResult = Apollo.QueryResult<CountServicesQuery, CountServicesQueryVariables>;
export const GetServiceDocument = gql`
    query getService($id: ID!) {
  service(id: $id) {
    ...ServiceFields
  }
}
    ${ServiceFieldsFragmentDoc}`;

/**
 * __useGetServiceQuery__
 *
 * To run a query within a React component, call `useGetServiceQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetServiceQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetServiceQuery({
 *   variables: {
 *      id: // value for 'id'
 *   },
 * });
 */
export function useGetServiceQuery(baseOptions: Apollo.QueryHookOptions<GetServiceQuery, GetServiceQueryVariables> & ({ variables: GetServiceQueryVariables; skip?: boolean; } | { skip: boolean; }) ) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<GetServiceQuery, GetServiceQueryVariables>(GetServiceDocument, options);
      }
export function useGetServiceLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<GetServiceQuery, GetServiceQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<GetServiceQuery, GetServiceQueryVariables>(GetServiceDocument, options);
        }
export function useGetServiceSuspenseQuery(baseOptions?: Apollo.SuspenseQueryHookOptions<GetServiceQuery, GetServiceQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useSuspenseQuery<GetServiceQuery, GetServiceQueryVariables>(GetServiceDocument, options);
        }
export type GetServiceQueryHookResult = ReturnType<typeof useGetServiceQuery>;
export type GetServiceLazyQueryHookResult = ReturnType<typeof useGetServiceLazyQuery>;
export type GetServiceSuspenseQueryHookResult = ReturnType<typeof useGetServiceSuspenseQuery>;
export type GetServiceQueryResult = Apollo.QueryResult<GetServiceQuery, GetServiceQueryVariables>;
export const PaymentIntentFromServiceDocument = gql`
    query paymentIntentFromService($clinicId: ID!, $serviceId: ID!, $customerInfo: CustomerInfoInput!) {
  paymentIntentFromService(
    clinicId: $clinicId
    serviceId: $serviceId
    customerInfo: $customerInfo
  ) {
    id
    amount
    client_secret
  }
}
    `;

/**
 * __usePaymentIntentFromServiceQuery__
 *
 * To run a query within a React component, call `usePaymentIntentFromServiceQuery` and pass it any options that fit your needs.
 * When your component renders, `usePaymentIntentFromServiceQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = usePaymentIntentFromServiceQuery({
 *   variables: {
 *      clinicId: // value for 'clinicId'
 *      serviceId: // value for 'serviceId'
 *      customerInfo: // value for 'customerInfo'
 *   },
 * });
 */
export function usePaymentIntentFromServiceQuery(baseOptions: Apollo.QueryHookOptions<PaymentIntentFromServiceQuery, PaymentIntentFromServiceQueryVariables> & ({ variables: PaymentIntentFromServiceQueryVariables; skip?: boolean; } | { skip: boolean; }) ) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<PaymentIntentFromServiceQuery, PaymentIntentFromServiceQueryVariables>(PaymentIntentFromServiceDocument, options);
      }
export function usePaymentIntentFromServiceLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<PaymentIntentFromServiceQuery, PaymentIntentFromServiceQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<PaymentIntentFromServiceQuery, PaymentIntentFromServiceQueryVariables>(PaymentIntentFromServiceDocument, options);
        }
export function usePaymentIntentFromServiceSuspenseQuery(baseOptions?: Apollo.SuspenseQueryHookOptions<PaymentIntentFromServiceQuery, PaymentIntentFromServiceQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useSuspenseQuery<PaymentIntentFromServiceQuery, PaymentIntentFromServiceQueryVariables>(PaymentIntentFromServiceDocument, options);
        }
export type PaymentIntentFromServiceQueryHookResult = ReturnType<typeof usePaymentIntentFromServiceQuery>;
export type PaymentIntentFromServiceLazyQueryHookResult = ReturnType<typeof usePaymentIntentFromServiceLazyQuery>;
export type PaymentIntentFromServiceSuspenseQueryHookResult = ReturnType<typeof usePaymentIntentFromServiceSuspenseQuery>;
export type PaymentIntentFromServiceQueryResult = Apollo.QueryResult<PaymentIntentFromServiceQuery, PaymentIntentFromServiceQueryVariables>;
export const CreateServiceDocument = gql`
    mutation createService($data: CreateServiceInput!) {
  createService(data: $data) {
    ...ServiceFields
  }
}
    ${ServiceFieldsFragmentDoc}`;
export type CreateServiceMutationFn = Apollo.MutationFunction<CreateServiceMutation, CreateServiceMutationVariables>;

/**
 * __useCreateServiceMutation__
 *
 * To run a mutation, you first call `useCreateServiceMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useCreateServiceMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [createServiceMutation, { data, loading, error }] = useCreateServiceMutation({
 *   variables: {
 *      data: // value for 'data'
 *   },
 * });
 */
export function useCreateServiceMutation(baseOptions?: Apollo.MutationHookOptions<CreateServiceMutation, CreateServiceMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<CreateServiceMutation, CreateServiceMutationVariables>(CreateServiceDocument, options);
      }
export type CreateServiceMutationHookResult = ReturnType<typeof useCreateServiceMutation>;
export type CreateServiceMutationResult = Apollo.MutationResult<CreateServiceMutation>;
export type CreateServiceMutationOptions = Apollo.BaseMutationOptions<CreateServiceMutation, CreateServiceMutationVariables>;
export const CreateClinicServiceDocument = gql`
    mutation createClinicService($clinicId: ID!, $data: CreateServiceInput!) {
  createClinicService(clinicId: $clinicId, data: $data) {
    ...ServiceFields
  }
}
    ${ServiceFieldsFragmentDoc}`;
export type CreateClinicServiceMutationFn = Apollo.MutationFunction<CreateClinicServiceMutation, CreateClinicServiceMutationVariables>;

/**
 * __useCreateClinicServiceMutation__
 *
 * To run a mutation, you first call `useCreateClinicServiceMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useCreateClinicServiceMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [createClinicServiceMutation, { data, loading, error }] = useCreateClinicServiceMutation({
 *   variables: {
 *      clinicId: // value for 'clinicId'
 *      data: // value for 'data'
 *   },
 * });
 */
export function useCreateClinicServiceMutation(baseOptions?: Apollo.MutationHookOptions<CreateClinicServiceMutation, CreateClinicServiceMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<CreateClinicServiceMutation, CreateClinicServiceMutationVariables>(CreateClinicServiceDocument, options);
      }
export type CreateClinicServiceMutationHookResult = ReturnType<typeof useCreateClinicServiceMutation>;
export type CreateClinicServiceMutationResult = Apollo.MutationResult<CreateClinicServiceMutation>;
export type CreateClinicServiceMutationOptions = Apollo.BaseMutationOptions<CreateClinicServiceMutation, CreateClinicServiceMutationVariables>;
export const UpdateServiceDocument = gql`
    mutation updateService($id: ID!, $data: UpdateServiceInput!) {
  updateService(id: $id, data: $data) {
    ...ServiceFields
  }
}
    ${ServiceFieldsFragmentDoc}`;
export type UpdateServiceMutationFn = Apollo.MutationFunction<UpdateServiceMutation, UpdateServiceMutationVariables>;

/**
 * __useUpdateServiceMutation__
 *
 * To run a mutation, you first call `useUpdateServiceMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useUpdateServiceMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [updateServiceMutation, { data, loading, error }] = useUpdateServiceMutation({
 *   variables: {
 *      id: // value for 'id'
 *      data: // value for 'data'
 *   },
 * });
 */
export function useUpdateServiceMutation(baseOptions?: Apollo.MutationHookOptions<UpdateServiceMutation, UpdateServiceMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<UpdateServiceMutation, UpdateServiceMutationVariables>(UpdateServiceDocument, options);
      }
export type UpdateServiceMutationHookResult = ReturnType<typeof useUpdateServiceMutation>;
export type UpdateServiceMutationResult = Apollo.MutationResult<UpdateServiceMutation>;
export type UpdateServiceMutationOptions = Apollo.BaseMutationOptions<UpdateServiceMutation, UpdateServiceMutationVariables>;
export const UpdateClinicServiceDocument = gql`
    mutation updateClinicService($serviceId: ID!, $clinicId: ID!, $data: UpdateServiceInput!) {
  updateClinicService(id: $serviceId, clinicId: $clinicId, data: $data) {
    ...ServiceFields
  }
}
    ${ServiceFieldsFragmentDoc}`;
export type UpdateClinicServiceMutationFn = Apollo.MutationFunction<UpdateClinicServiceMutation, UpdateClinicServiceMutationVariables>;

/**
 * __useUpdateClinicServiceMutation__
 *
 * To run a mutation, you first call `useUpdateClinicServiceMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useUpdateClinicServiceMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [updateClinicServiceMutation, { data, loading, error }] = useUpdateClinicServiceMutation({
 *   variables: {
 *      serviceId: // value for 'serviceId'
 *      clinicId: // value for 'clinicId'
 *      data: // value for 'data'
 *   },
 * });
 */
export function useUpdateClinicServiceMutation(baseOptions?: Apollo.MutationHookOptions<UpdateClinicServiceMutation, UpdateClinicServiceMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<UpdateClinicServiceMutation, UpdateClinicServiceMutationVariables>(UpdateClinicServiceDocument, options);
      }
export type UpdateClinicServiceMutationHookResult = ReturnType<typeof useUpdateClinicServiceMutation>;
export type UpdateClinicServiceMutationResult = Apollo.MutationResult<UpdateClinicServiceMutation>;
export type UpdateClinicServiceMutationOptions = Apollo.BaseMutationOptions<UpdateClinicServiceMutation, UpdateClinicServiceMutationVariables>;
export const DeleteServiceDocument = gql`
    mutation deleteService($id: ID!) {
  deleteService(id: $id)
}
    `;
export type DeleteServiceMutationFn = Apollo.MutationFunction<DeleteServiceMutation, DeleteServiceMutationVariables>;

/**
 * __useDeleteServiceMutation__
 *
 * To run a mutation, you first call `useDeleteServiceMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useDeleteServiceMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [deleteServiceMutation, { data, loading, error }] = useDeleteServiceMutation({
 *   variables: {
 *      id: // value for 'id'
 *   },
 * });
 */
export function useDeleteServiceMutation(baseOptions?: Apollo.MutationHookOptions<DeleteServiceMutation, DeleteServiceMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<DeleteServiceMutation, DeleteServiceMutationVariables>(DeleteServiceDocument, options);
      }
export type DeleteServiceMutationHookResult = ReturnType<typeof useDeleteServiceMutation>;
export type DeleteServiceMutationResult = Apollo.MutationResult<DeleteServiceMutation>;
export type DeleteServiceMutationOptions = Apollo.BaseMutationOptions<DeleteServiceMutation, DeleteServiceMutationVariables>;
export const DeleteClinicServiceDocument = gql`
    mutation deleteClinicService($serviceId: ID!, $clinicId: ID!) {
  deleteClinicService(id: $serviceId, clinicId: $clinicId)
}
    `;
export type DeleteClinicServiceMutationFn = Apollo.MutationFunction<DeleteClinicServiceMutation, DeleteClinicServiceMutationVariables>;

/**
 * __useDeleteClinicServiceMutation__
 *
 * To run a mutation, you first call `useDeleteClinicServiceMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useDeleteClinicServiceMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [deleteClinicServiceMutation, { data, loading, error }] = useDeleteClinicServiceMutation({
 *   variables: {
 *      serviceId: // value for 'serviceId'
 *      clinicId: // value for 'clinicId'
 *   },
 * });
 */
export function useDeleteClinicServiceMutation(baseOptions?: Apollo.MutationHookOptions<DeleteClinicServiceMutation, DeleteClinicServiceMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<DeleteClinicServiceMutation, DeleteClinicServiceMutationVariables>(DeleteClinicServiceDocument, options);
      }
export type DeleteClinicServiceMutationHookResult = ReturnType<typeof useDeleteClinicServiceMutation>;
export type DeleteClinicServiceMutationResult = Apollo.MutationResult<DeleteClinicServiceMutation>;
export type DeleteClinicServiceMutationOptions = Apollo.BaseMutationOptions<DeleteClinicServiceMutation, DeleteClinicServiceMutationVariables>;
export const StripeAccountInfoDocument = gql`
    query stripeAccountInfo($clinicId: ID!, $callbackUrls: AccountOnboardLinkInput!, $accountType: StripeAccountType) {
  stripeAccountInfo(
    clinicId: $clinicId
    callbackUrls: $callbackUrls
    accountType: $accountType
  ) {
    ...StripeAccountInfoFields
  }
}
    ${StripeAccountInfoFieldsFragmentDoc}`;

/**
 * __useStripeAccountInfoQuery__
 *
 * To run a query within a React component, call `useStripeAccountInfoQuery` and pass it any options that fit your needs.
 * When your component renders, `useStripeAccountInfoQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useStripeAccountInfoQuery({
 *   variables: {
 *      clinicId: // value for 'clinicId'
 *      callbackUrls: // value for 'callbackUrls'
 *      accountType: // value for 'accountType'
 *   },
 * });
 */
export function useStripeAccountInfoQuery(baseOptions: Apollo.QueryHookOptions<StripeAccountInfoQuery, StripeAccountInfoQueryVariables> & ({ variables: StripeAccountInfoQueryVariables; skip?: boolean; } | { skip: boolean; }) ) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<StripeAccountInfoQuery, StripeAccountInfoQueryVariables>(StripeAccountInfoDocument, options);
      }
export function useStripeAccountInfoLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<StripeAccountInfoQuery, StripeAccountInfoQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<StripeAccountInfoQuery, StripeAccountInfoQueryVariables>(StripeAccountInfoDocument, options);
        }
export function useStripeAccountInfoSuspenseQuery(baseOptions?: Apollo.SuspenseQueryHookOptions<StripeAccountInfoQuery, StripeAccountInfoQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useSuspenseQuery<StripeAccountInfoQuery, StripeAccountInfoQueryVariables>(StripeAccountInfoDocument, options);
        }
export type StripeAccountInfoQueryHookResult = ReturnType<typeof useStripeAccountInfoQuery>;
export type StripeAccountInfoLazyQueryHookResult = ReturnType<typeof useStripeAccountInfoLazyQuery>;
export type StripeAccountInfoSuspenseQueryHookResult = ReturnType<typeof useStripeAccountInfoSuspenseQuery>;
export type StripeAccountInfoQueryResult = Apollo.QueryResult<StripeAccountInfoQuery, StripeAccountInfoQueryVariables>;
export const MySupportBotConversationsDocument = gql`
    query mySupportBotConversations($limit: NonNegativeInt) {
  mySupportBotConversations(limit: $limit) {
    ...SupportBotConversationFields
  }
}
    ${SupportBotConversationFieldsFragmentDoc}`;

/**
 * __useMySupportBotConversationsQuery__
 *
 * To run a query within a React component, call `useMySupportBotConversationsQuery` and pass it any options that fit your needs.
 * When your component renders, `useMySupportBotConversationsQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useMySupportBotConversationsQuery({
 *   variables: {
 *      limit: // value for 'limit'
 *   },
 * });
 */
export function useMySupportBotConversationsQuery(baseOptions?: Apollo.QueryHookOptions<MySupportBotConversationsQuery, MySupportBotConversationsQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<MySupportBotConversationsQuery, MySupportBotConversationsQueryVariables>(MySupportBotConversationsDocument, options);
      }
export function useMySupportBotConversationsLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<MySupportBotConversationsQuery, MySupportBotConversationsQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<MySupportBotConversationsQuery, MySupportBotConversationsQueryVariables>(MySupportBotConversationsDocument, options);
        }
export function useMySupportBotConversationsSuspenseQuery(baseOptions?: Apollo.SuspenseQueryHookOptions<MySupportBotConversationsQuery, MySupportBotConversationsQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useSuspenseQuery<MySupportBotConversationsQuery, MySupportBotConversationsQueryVariables>(MySupportBotConversationsDocument, options);
        }
export type MySupportBotConversationsQueryHookResult = ReturnType<typeof useMySupportBotConversationsQuery>;
export type MySupportBotConversationsLazyQueryHookResult = ReturnType<typeof useMySupportBotConversationsLazyQuery>;
export type MySupportBotConversationsSuspenseQueryHookResult = ReturnType<typeof useMySupportBotConversationsSuspenseQuery>;
export type MySupportBotConversationsQueryResult = Apollo.QueryResult<MySupportBotConversationsQuery, MySupportBotConversationsQueryVariables>;
export const SupportBotConversationsDocument = gql`
    query supportBotConversations($filterUserId: ID, $limit: NonNegativeInt, $offset: NonNegativeInt) {
  supportBotConversations(
    filterUserId: $filterUserId
    limit: $limit
    offset: $offset
  ) {
    ...SupportBotConversationFields
  }
}
    ${SupportBotConversationFieldsFragmentDoc}`;

/**
 * __useSupportBotConversationsQuery__
 *
 * To run a query within a React component, call `useSupportBotConversationsQuery` and pass it any options that fit your needs.
 * When your component renders, `useSupportBotConversationsQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useSupportBotConversationsQuery({
 *   variables: {
 *      filterUserId: // value for 'filterUserId'
 *      limit: // value for 'limit'
 *      offset: // value for 'offset'
 *   },
 * });
 */
export function useSupportBotConversationsQuery(baseOptions?: Apollo.QueryHookOptions<SupportBotConversationsQuery, SupportBotConversationsQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<SupportBotConversationsQuery, SupportBotConversationsQueryVariables>(SupportBotConversationsDocument, options);
      }
export function useSupportBotConversationsLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<SupportBotConversationsQuery, SupportBotConversationsQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<SupportBotConversationsQuery, SupportBotConversationsQueryVariables>(SupportBotConversationsDocument, options);
        }
export function useSupportBotConversationsSuspenseQuery(baseOptions?: Apollo.SuspenseQueryHookOptions<SupportBotConversationsQuery, SupportBotConversationsQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useSuspenseQuery<SupportBotConversationsQuery, SupportBotConversationsQueryVariables>(SupportBotConversationsDocument, options);
        }
export type SupportBotConversationsQueryHookResult = ReturnType<typeof useSupportBotConversationsQuery>;
export type SupportBotConversationsLazyQueryHookResult = ReturnType<typeof useSupportBotConversationsLazyQuery>;
export type SupportBotConversationsSuspenseQueryHookResult = ReturnType<typeof useSupportBotConversationsSuspenseQuery>;
export type SupportBotConversationsQueryResult = Apollo.QueryResult<SupportBotConversationsQuery, SupportBotConversationsQueryVariables>;
export const SupportBotConversationOwnersDocument = gql`
    query supportBotConversationOwners {
  supportBotConversationOwners {
    ...SupportBotConversationOwnerFields
  }
}
    ${SupportBotConversationOwnerFieldsFragmentDoc}`;

/**
 * __useSupportBotConversationOwnersQuery__
 *
 * To run a query within a React component, call `useSupportBotConversationOwnersQuery` and pass it any options that fit your needs.
 * When your component renders, `useSupportBotConversationOwnersQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useSupportBotConversationOwnersQuery({
 *   variables: {
 *   },
 * });
 */
export function useSupportBotConversationOwnersQuery(baseOptions?: Apollo.QueryHookOptions<SupportBotConversationOwnersQuery, SupportBotConversationOwnersQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<SupportBotConversationOwnersQuery, SupportBotConversationOwnersQueryVariables>(SupportBotConversationOwnersDocument, options);
      }
export function useSupportBotConversationOwnersLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<SupportBotConversationOwnersQuery, SupportBotConversationOwnersQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<SupportBotConversationOwnersQuery, SupportBotConversationOwnersQueryVariables>(SupportBotConversationOwnersDocument, options);
        }
export function useSupportBotConversationOwnersSuspenseQuery(baseOptions?: Apollo.SuspenseQueryHookOptions<SupportBotConversationOwnersQuery, SupportBotConversationOwnersQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useSuspenseQuery<SupportBotConversationOwnersQuery, SupportBotConversationOwnersQueryVariables>(SupportBotConversationOwnersDocument, options);
        }
export type SupportBotConversationOwnersQueryHookResult = ReturnType<typeof useSupportBotConversationOwnersQuery>;
export type SupportBotConversationOwnersLazyQueryHookResult = ReturnType<typeof useSupportBotConversationOwnersLazyQuery>;
export type SupportBotConversationOwnersSuspenseQueryHookResult = ReturnType<typeof useSupportBotConversationOwnersSuspenseQuery>;
export type SupportBotConversationOwnersQueryResult = Apollo.QueryResult<SupportBotConversationOwnersQuery, SupportBotConversationOwnersQueryVariables>;
export const SupportBotConversationDocument = gql`
    query supportBotConversation($id: ID!) {
  supportBotConversation(id: $id) {
    ...SupportBotConversationFields
  }
}
    ${SupportBotConversationFieldsFragmentDoc}`;

/**
 * __useSupportBotConversationQuery__
 *
 * To run a query within a React component, call `useSupportBotConversationQuery` and pass it any options that fit your needs.
 * When your component renders, `useSupportBotConversationQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useSupportBotConversationQuery({
 *   variables: {
 *      id: // value for 'id'
 *   },
 * });
 */
export function useSupportBotConversationQuery(baseOptions: Apollo.QueryHookOptions<SupportBotConversationQuery, SupportBotConversationQueryVariables> & ({ variables: SupportBotConversationQueryVariables; skip?: boolean; } | { skip: boolean; }) ) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<SupportBotConversationQuery, SupportBotConversationQueryVariables>(SupportBotConversationDocument, options);
      }
export function useSupportBotConversationLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<SupportBotConversationQuery, SupportBotConversationQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<SupportBotConversationQuery, SupportBotConversationQueryVariables>(SupportBotConversationDocument, options);
        }
export function useSupportBotConversationSuspenseQuery(baseOptions?: Apollo.SuspenseQueryHookOptions<SupportBotConversationQuery, SupportBotConversationQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useSuspenseQuery<SupportBotConversationQuery, SupportBotConversationQueryVariables>(SupportBotConversationDocument, options);
        }
export type SupportBotConversationQueryHookResult = ReturnType<typeof useSupportBotConversationQuery>;
export type SupportBotConversationLazyQueryHookResult = ReturnType<typeof useSupportBotConversationLazyQuery>;
export type SupportBotConversationSuspenseQueryHookResult = ReturnType<typeof useSupportBotConversationSuspenseQuery>;
export type SupportBotConversationQueryResult = Apollo.QueryResult<SupportBotConversationQuery, SupportBotConversationQueryVariables>;
export const SupportBotRunStatusDocument = gql`
    query supportBotRunStatus($runId: ID!) {
  supportBotRunStatus(runId: $runId) {
    ...SupportBotRunSnapshotFields
  }
}
    ${SupportBotRunSnapshotFieldsFragmentDoc}`;

/**
 * __useSupportBotRunStatusQuery__
 *
 * To run a query within a React component, call `useSupportBotRunStatusQuery` and pass it any options that fit your needs.
 * When your component renders, `useSupportBotRunStatusQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useSupportBotRunStatusQuery({
 *   variables: {
 *      runId: // value for 'runId'
 *   },
 * });
 */
export function useSupportBotRunStatusQuery(baseOptions: Apollo.QueryHookOptions<SupportBotRunStatusQuery, SupportBotRunStatusQueryVariables> & ({ variables: SupportBotRunStatusQueryVariables; skip?: boolean; } | { skip: boolean; }) ) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<SupportBotRunStatusQuery, SupportBotRunStatusQueryVariables>(SupportBotRunStatusDocument, options);
      }
export function useSupportBotRunStatusLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<SupportBotRunStatusQuery, SupportBotRunStatusQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<SupportBotRunStatusQuery, SupportBotRunStatusQueryVariables>(SupportBotRunStatusDocument, options);
        }
export function useSupportBotRunStatusSuspenseQuery(baseOptions?: Apollo.SuspenseQueryHookOptions<SupportBotRunStatusQuery, SupportBotRunStatusQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useSuspenseQuery<SupportBotRunStatusQuery, SupportBotRunStatusQueryVariables>(SupportBotRunStatusDocument, options);
        }
export type SupportBotRunStatusQueryHookResult = ReturnType<typeof useSupportBotRunStatusQuery>;
export type SupportBotRunStatusLazyQueryHookResult = ReturnType<typeof useSupportBotRunStatusLazyQuery>;
export type SupportBotRunStatusSuspenseQueryHookResult = ReturnType<typeof useSupportBotRunStatusSuspenseQuery>;
export type SupportBotRunStatusQueryResult = Apollo.QueryResult<SupportBotRunStatusQuery, SupportBotRunStatusQueryVariables>;
export const SendSupportBotMessageDocument = gql`
    mutation sendSupportBotMessage($input: SendSupportBotMessageInput!) {
  sendSupportBotMessage(input: $input) {
    runId
    conversationId
    status
    conversation {
      ...SupportBotConversationFields
    }
  }
}
    ${SupportBotConversationFieldsFragmentDoc}`;
export type SendSupportBotMessageMutationFn = Apollo.MutationFunction<SendSupportBotMessageMutation, SendSupportBotMessageMutationVariables>;

/**
 * __useSendSupportBotMessageMutation__
 *
 * To run a mutation, you first call `useSendSupportBotMessageMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useSendSupportBotMessageMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [sendSupportBotMessageMutation, { data, loading, error }] = useSendSupportBotMessageMutation({
 *   variables: {
 *      input: // value for 'input'
 *   },
 * });
 */
export function useSendSupportBotMessageMutation(baseOptions?: Apollo.MutationHookOptions<SendSupportBotMessageMutation, SendSupportBotMessageMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<SendSupportBotMessageMutation, SendSupportBotMessageMutationVariables>(SendSupportBotMessageDocument, options);
      }
export type SendSupportBotMessageMutationHookResult = ReturnType<typeof useSendSupportBotMessageMutation>;
export type SendSupportBotMessageMutationResult = Apollo.MutationResult<SendSupportBotMessageMutation>;
export type SendSupportBotMessageMutationOptions = Apollo.BaseMutationOptions<SendSupportBotMessageMutation, SendSupportBotMessageMutationVariables>;
export const GetFillRateForTimeRangeDocument = gql`
    query getFillRateForTimeRange($clinicId: ID!, $startTime: NonNegativeInt!, $endTime: NonNegativeInt!) {
  getFillRateForTimeRange(
    clinicId: $clinicId
    startTime: $startTime
    endTime: $endTime
  ) {
    clinic_fill_rate {
      ...FillRateResultFields
    }
    clinician_fill_rates {
      ...FillRateResultFields
    }
    room_fill_rates {
      ...FillRateResultFields
    }
  }
}
    ${FillRateResultFieldsFragmentDoc}`;

/**
 * __useGetFillRateForTimeRangeQuery__
 *
 * To run a query within a React component, call `useGetFillRateForTimeRangeQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetFillRateForTimeRangeQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetFillRateForTimeRangeQuery({
 *   variables: {
 *      clinicId: // value for 'clinicId'
 *      startTime: // value for 'startTime'
 *      endTime: // value for 'endTime'
 *   },
 * });
 */
export function useGetFillRateForTimeRangeQuery(baseOptions: Apollo.QueryHookOptions<GetFillRateForTimeRangeQuery, GetFillRateForTimeRangeQueryVariables> & ({ variables: GetFillRateForTimeRangeQueryVariables; skip?: boolean; } | { skip: boolean; }) ) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<GetFillRateForTimeRangeQuery, GetFillRateForTimeRangeQueryVariables>(GetFillRateForTimeRangeDocument, options);
      }
export function useGetFillRateForTimeRangeLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<GetFillRateForTimeRangeQuery, GetFillRateForTimeRangeQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<GetFillRateForTimeRangeQuery, GetFillRateForTimeRangeQueryVariables>(GetFillRateForTimeRangeDocument, options);
        }
export function useGetFillRateForTimeRangeSuspenseQuery(baseOptions?: Apollo.SuspenseQueryHookOptions<GetFillRateForTimeRangeQuery, GetFillRateForTimeRangeQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useSuspenseQuery<GetFillRateForTimeRangeQuery, GetFillRateForTimeRangeQueryVariables>(GetFillRateForTimeRangeDocument, options);
        }
export type GetFillRateForTimeRangeQueryHookResult = ReturnType<typeof useGetFillRateForTimeRangeQuery>;
export type GetFillRateForTimeRangeLazyQueryHookResult = ReturnType<typeof useGetFillRateForTimeRangeLazyQuery>;
export type GetFillRateForTimeRangeSuspenseQueryHookResult = ReturnType<typeof useGetFillRateForTimeRangeSuspenseQuery>;
export type GetFillRateForTimeRangeQueryResult = Apollo.QueryResult<GetFillRateForTimeRangeQuery, GetFillRateForTimeRangeQueryVariables>;
export const GetFillRateForClinicianTimeRangeDocument = gql`
    query getFillRateForClinicianTimeRange($clinicianId: ID!, $startTime: NonNegativeInt!, $endTime: NonNegativeInt!) {
  getFillRateForClinicianTimeRange(
    clinicianId: $clinicianId
    startTime: $startTime
    endTime: $endTime
  ) {
    ...FillRateResultFields
  }
}
    ${FillRateResultFieldsFragmentDoc}`;

/**
 * __useGetFillRateForClinicianTimeRangeQuery__
 *
 * To run a query within a React component, call `useGetFillRateForClinicianTimeRangeQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetFillRateForClinicianTimeRangeQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetFillRateForClinicianTimeRangeQuery({
 *   variables: {
 *      clinicianId: // value for 'clinicianId'
 *      startTime: // value for 'startTime'
 *      endTime: // value for 'endTime'
 *   },
 * });
 */
export function useGetFillRateForClinicianTimeRangeQuery(baseOptions: Apollo.QueryHookOptions<GetFillRateForClinicianTimeRangeQuery, GetFillRateForClinicianTimeRangeQueryVariables> & ({ variables: GetFillRateForClinicianTimeRangeQueryVariables; skip?: boolean; } | { skip: boolean; }) ) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<GetFillRateForClinicianTimeRangeQuery, GetFillRateForClinicianTimeRangeQueryVariables>(GetFillRateForClinicianTimeRangeDocument, options);
      }
export function useGetFillRateForClinicianTimeRangeLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<GetFillRateForClinicianTimeRangeQuery, GetFillRateForClinicianTimeRangeQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<GetFillRateForClinicianTimeRangeQuery, GetFillRateForClinicianTimeRangeQueryVariables>(GetFillRateForClinicianTimeRangeDocument, options);
        }
export function useGetFillRateForClinicianTimeRangeSuspenseQuery(baseOptions?: Apollo.SuspenseQueryHookOptions<GetFillRateForClinicianTimeRangeQuery, GetFillRateForClinicianTimeRangeQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useSuspenseQuery<GetFillRateForClinicianTimeRangeQuery, GetFillRateForClinicianTimeRangeQueryVariables>(GetFillRateForClinicianTimeRangeDocument, options);
        }
export type GetFillRateForClinicianTimeRangeQueryHookResult = ReturnType<typeof useGetFillRateForClinicianTimeRangeQuery>;
export type GetFillRateForClinicianTimeRangeLazyQueryHookResult = ReturnType<typeof useGetFillRateForClinicianTimeRangeLazyQuery>;
export type GetFillRateForClinicianTimeRangeSuspenseQueryHookResult = ReturnType<typeof useGetFillRateForClinicianTimeRangeSuspenseQuery>;
export type GetFillRateForClinicianTimeRangeQueryResult = Apollo.QueryResult<GetFillRateForClinicianTimeRangeQuery, GetFillRateForClinicianTimeRangeQueryVariables>;
export const GetTransactionsByClinicAndRangeDocument = gql`
    query getTransactionsByClinicAndRange($clinicId: ID!, $pms: PracticeManagementSystem, $start_time: NonNegativeInt!, $end_time: NonNegativeInt!) {
  getTransactionsByClinicAndRange(
    clinicId: $clinicId
    pms: $pms
    start_time: $start_time
    end_time: $end_time
  ) {
    ...TransactionFields
  }
}
    ${TransactionFieldsFragmentDoc}`;

/**
 * __useGetTransactionsByClinicAndRangeQuery__
 *
 * To run a query within a React component, call `useGetTransactionsByClinicAndRangeQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetTransactionsByClinicAndRangeQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetTransactionsByClinicAndRangeQuery({
 *   variables: {
 *      clinicId: // value for 'clinicId'
 *      pms: // value for 'pms'
 *      start_time: // value for 'start_time'
 *      end_time: // value for 'end_time'
 *   },
 * });
 */
export function useGetTransactionsByClinicAndRangeQuery(baseOptions: Apollo.QueryHookOptions<GetTransactionsByClinicAndRangeQuery, GetTransactionsByClinicAndRangeQueryVariables> & ({ variables: GetTransactionsByClinicAndRangeQueryVariables; skip?: boolean; } | { skip: boolean; }) ) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<GetTransactionsByClinicAndRangeQuery, GetTransactionsByClinicAndRangeQueryVariables>(GetTransactionsByClinicAndRangeDocument, options);
      }
export function useGetTransactionsByClinicAndRangeLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<GetTransactionsByClinicAndRangeQuery, GetTransactionsByClinicAndRangeQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<GetTransactionsByClinicAndRangeQuery, GetTransactionsByClinicAndRangeQueryVariables>(GetTransactionsByClinicAndRangeDocument, options);
        }
export function useGetTransactionsByClinicAndRangeSuspenseQuery(baseOptions?: Apollo.SuspenseQueryHookOptions<GetTransactionsByClinicAndRangeQuery, GetTransactionsByClinicAndRangeQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useSuspenseQuery<GetTransactionsByClinicAndRangeQuery, GetTransactionsByClinicAndRangeQueryVariables>(GetTransactionsByClinicAndRangeDocument, options);
        }
export type GetTransactionsByClinicAndRangeQueryHookResult = ReturnType<typeof useGetTransactionsByClinicAndRangeQuery>;
export type GetTransactionsByClinicAndRangeLazyQueryHookResult = ReturnType<typeof useGetTransactionsByClinicAndRangeLazyQuery>;
export type GetTransactionsByClinicAndRangeSuspenseQueryHookResult = ReturnType<typeof useGetTransactionsByClinicAndRangeSuspenseQuery>;
export type GetTransactionsByClinicAndRangeQueryResult = Apollo.QueryResult<GetTransactionsByClinicAndRangeQuery, GetTransactionsByClinicAndRangeQueryVariables>;
export const GetUserTrackingSummaryDocument = gql`
    query getUserTrackingSummary($clinicId: ID!) {
  userTrackingSummary(clinicId: $clinicId) {
    portal_adoption {
      ...UserTrackingMetricFields
    }
    app_conversion {
      ...UserTrackingMetricFields
    }
    app_adoption {
      ...UserTrackingMetricFields
    }
  }
}
    ${UserTrackingMetricFieldsFragmentDoc}`;

/**
 * __useGetUserTrackingSummaryQuery__
 *
 * To run a query within a React component, call `useGetUserTrackingSummaryQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetUserTrackingSummaryQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetUserTrackingSummaryQuery({
 *   variables: {
 *      clinicId: // value for 'clinicId'
 *   },
 * });
 */
export function useGetUserTrackingSummaryQuery(baseOptions: Apollo.QueryHookOptions<GetUserTrackingSummaryQuery, GetUserTrackingSummaryQueryVariables> & ({ variables: GetUserTrackingSummaryQueryVariables; skip?: boolean; } | { skip: boolean; }) ) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<GetUserTrackingSummaryQuery, GetUserTrackingSummaryQueryVariables>(GetUserTrackingSummaryDocument, options);
      }
export function useGetUserTrackingSummaryLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<GetUserTrackingSummaryQuery, GetUserTrackingSummaryQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<GetUserTrackingSummaryQuery, GetUserTrackingSummaryQueryVariables>(GetUserTrackingSummaryDocument, options);
        }
export function useGetUserTrackingSummarySuspenseQuery(baseOptions?: Apollo.SuspenseQueryHookOptions<GetUserTrackingSummaryQuery, GetUserTrackingSummaryQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useSuspenseQuery<GetUserTrackingSummaryQuery, GetUserTrackingSummaryQueryVariables>(GetUserTrackingSummaryDocument, options);
        }
export type GetUserTrackingSummaryQueryHookResult = ReturnType<typeof useGetUserTrackingSummaryQuery>;
export type GetUserTrackingSummaryLazyQueryHookResult = ReturnType<typeof useGetUserTrackingSummaryLazyQuery>;
export type GetUserTrackingSummarySuspenseQueryHookResult = ReturnType<typeof useGetUserTrackingSummarySuspenseQuery>;
export type GetUserTrackingSummaryQueryResult = Apollo.QueryResult<GetUserTrackingSummaryQuery, GetUserTrackingSummaryQueryVariables>;
export const GetUserTrackingClientsDocument = gql`
    query getUserTrackingClients($clinicId: ID!, $metric: UserTrackingMetric!, $membership: UserTrackingMembership!, $search: String, $page: NonNegativeInt, $pageSize: NonNegativeInt) {
  userTrackingClients(
    clinicId: $clinicId
    metric: $metric
    membership: $membership
    search: $search
    page: $page
    pageSize: $pageSize
  ) {
    count
    results {
      client {
        id
        first_name
        last_name
        email
        phone
        address {
          country
        }
      }
      has_portal_account
      has_mobile_app
    }
  }
}
    `;

/**
 * __useGetUserTrackingClientsQuery__
 *
 * To run a query within a React component, call `useGetUserTrackingClientsQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetUserTrackingClientsQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetUserTrackingClientsQuery({
 *   variables: {
 *      clinicId: // value for 'clinicId'
 *      metric: // value for 'metric'
 *      membership: // value for 'membership'
 *      search: // value for 'search'
 *      page: // value for 'page'
 *      pageSize: // value for 'pageSize'
 *   },
 * });
 */
export function useGetUserTrackingClientsQuery(baseOptions: Apollo.QueryHookOptions<GetUserTrackingClientsQuery, GetUserTrackingClientsQueryVariables> & ({ variables: GetUserTrackingClientsQueryVariables; skip?: boolean; } | { skip: boolean; }) ) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<GetUserTrackingClientsQuery, GetUserTrackingClientsQueryVariables>(GetUserTrackingClientsDocument, options);
      }
export function useGetUserTrackingClientsLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<GetUserTrackingClientsQuery, GetUserTrackingClientsQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<GetUserTrackingClientsQuery, GetUserTrackingClientsQueryVariables>(GetUserTrackingClientsDocument, options);
        }
export function useGetUserTrackingClientsSuspenseQuery(baseOptions?: Apollo.SuspenseQueryHookOptions<GetUserTrackingClientsQuery, GetUserTrackingClientsQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useSuspenseQuery<GetUserTrackingClientsQuery, GetUserTrackingClientsQueryVariables>(GetUserTrackingClientsDocument, options);
        }
export type GetUserTrackingClientsQueryHookResult = ReturnType<typeof useGetUserTrackingClientsQuery>;
export type GetUserTrackingClientsLazyQueryHookResult = ReturnType<typeof useGetUserTrackingClientsLazyQuery>;
export type GetUserTrackingClientsSuspenseQueryHookResult = ReturnType<typeof useGetUserTrackingClientsSuspenseQuery>;
export type GetUserTrackingClientsQueryResult = Apollo.QueryResult<GetUserTrackingClientsQuery, GetUserTrackingClientsQueryVariables>;
export const CreateUserTrackingBulkMessageDocument = gql`
    mutation createUserTrackingBulkMessage($clinicId: ID!, $metric: UserTrackingMetric!, $membership: UserTrackingMembership!) {
  createUserTrackingBulkMessage(
    clinicId: $clinicId
    metric: $metric
    membership: $membership
  ) {
    id
  }
}
    `;
export type CreateUserTrackingBulkMessageMutationFn = Apollo.MutationFunction<CreateUserTrackingBulkMessageMutation, CreateUserTrackingBulkMessageMutationVariables>;

/**
 * __useCreateUserTrackingBulkMessageMutation__
 *
 * To run a mutation, you first call `useCreateUserTrackingBulkMessageMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useCreateUserTrackingBulkMessageMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [createUserTrackingBulkMessageMutation, { data, loading, error }] = useCreateUserTrackingBulkMessageMutation({
 *   variables: {
 *      clinicId: // value for 'clinicId'
 *      metric: // value for 'metric'
 *      membership: // value for 'membership'
 *   },
 * });
 */
export function useCreateUserTrackingBulkMessageMutation(baseOptions?: Apollo.MutationHookOptions<CreateUserTrackingBulkMessageMutation, CreateUserTrackingBulkMessageMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<CreateUserTrackingBulkMessageMutation, CreateUserTrackingBulkMessageMutationVariables>(CreateUserTrackingBulkMessageDocument, options);
      }
export type CreateUserTrackingBulkMessageMutationHookResult = ReturnType<typeof useCreateUserTrackingBulkMessageMutation>;
export type CreateUserTrackingBulkMessageMutationResult = Apollo.MutationResult<CreateUserTrackingBulkMessageMutation>;
export type CreateUserTrackingBulkMessageMutationOptions = Apollo.BaseMutationOptions<CreateUserTrackingBulkMessageMutation, CreateUserTrackingBulkMessageMutationVariables>;
export const GetUserDocument = gql`
    query getUser($id: ID!) {
  user(id: $id) {
    ...UserFields
  }
}
    ${UserFieldsFragmentDoc}`;

/**
 * __useGetUserQuery__
 *
 * To run a query within a React component, call `useGetUserQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetUserQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetUserQuery({
 *   variables: {
 *      id: // value for 'id'
 *   },
 * });
 */
export function useGetUserQuery(baseOptions: Apollo.QueryHookOptions<GetUserQuery, GetUserQueryVariables> & ({ variables: GetUserQueryVariables; skip?: boolean; } | { skip: boolean; }) ) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<GetUserQuery, GetUserQueryVariables>(GetUserDocument, options);
      }
export function useGetUserLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<GetUserQuery, GetUserQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<GetUserQuery, GetUserQueryVariables>(GetUserDocument, options);
        }
export function useGetUserSuspenseQuery(baseOptions?: Apollo.SuspenseQueryHookOptions<GetUserQuery, GetUserQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useSuspenseQuery<GetUserQuery, GetUserQueryVariables>(GetUserDocument, options);
        }
export type GetUserQueryHookResult = ReturnType<typeof useGetUserQuery>;
export type GetUserLazyQueryHookResult = ReturnType<typeof useGetUserLazyQuery>;
export type GetUserSuspenseQueryHookResult = ReturnType<typeof useGetUserSuspenseQuery>;
export type GetUserQueryResult = Apollo.QueryResult<GetUserQuery, GetUserQueryVariables>;
export const GenerateIntercomJwtDocument = gql`
    query generateIntercomJwt {
  generateIntercomJwt
}
    `;

/**
 * __useGenerateIntercomJwtQuery__
 *
 * To run a query within a React component, call `useGenerateIntercomJwtQuery` and pass it any options that fit your needs.
 * When your component renders, `useGenerateIntercomJwtQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGenerateIntercomJwtQuery({
 *   variables: {
 *   },
 * });
 */
export function useGenerateIntercomJwtQuery(baseOptions?: Apollo.QueryHookOptions<GenerateIntercomJwtQuery, GenerateIntercomJwtQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<GenerateIntercomJwtQuery, GenerateIntercomJwtQueryVariables>(GenerateIntercomJwtDocument, options);
      }
export function useGenerateIntercomJwtLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<GenerateIntercomJwtQuery, GenerateIntercomJwtQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<GenerateIntercomJwtQuery, GenerateIntercomJwtQueryVariables>(GenerateIntercomJwtDocument, options);
        }
export function useGenerateIntercomJwtSuspenseQuery(baseOptions?: Apollo.SuspenseQueryHookOptions<GenerateIntercomJwtQuery, GenerateIntercomJwtQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useSuspenseQuery<GenerateIntercomJwtQuery, GenerateIntercomJwtQueryVariables>(GenerateIntercomJwtDocument, options);
        }
export type GenerateIntercomJwtQueryHookResult = ReturnType<typeof useGenerateIntercomJwtQuery>;
export type GenerateIntercomJwtLazyQueryHookResult = ReturnType<typeof useGenerateIntercomJwtLazyQuery>;
export type GenerateIntercomJwtSuspenseQueryHookResult = ReturnType<typeof useGenerateIntercomJwtSuspenseQuery>;
export type GenerateIntercomJwtQueryResult = Apollo.QueryResult<GenerateIntercomJwtQuery, GenerateIntercomJwtQueryVariables>;
export const SearchUsersDocument = gql`
    query searchUsers($roles: [AuthRoles!], $limit: NonNegativeInt, $startAtId: String) {
  searchUsers(roles: $roles, limit: $limit, startAtId: $startAtId) {
    ...UserFields
  }
}
    ${UserFieldsFragmentDoc}`;

/**
 * __useSearchUsersQuery__
 *
 * To run a query within a React component, call `useSearchUsersQuery` and pass it any options that fit your needs.
 * When your component renders, `useSearchUsersQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useSearchUsersQuery({
 *   variables: {
 *      roles: // value for 'roles'
 *      limit: // value for 'limit'
 *      startAtId: // value for 'startAtId'
 *   },
 * });
 */
export function useSearchUsersQuery(baseOptions?: Apollo.QueryHookOptions<SearchUsersQuery, SearchUsersQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<SearchUsersQuery, SearchUsersQueryVariables>(SearchUsersDocument, options);
      }
export function useSearchUsersLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<SearchUsersQuery, SearchUsersQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<SearchUsersQuery, SearchUsersQueryVariables>(SearchUsersDocument, options);
        }
export function useSearchUsersSuspenseQuery(baseOptions?: Apollo.SuspenseQueryHookOptions<SearchUsersQuery, SearchUsersQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useSuspenseQuery<SearchUsersQuery, SearchUsersQueryVariables>(SearchUsersDocument, options);
        }
export type SearchUsersQueryHookResult = ReturnType<typeof useSearchUsersQuery>;
export type SearchUsersLazyQueryHookResult = ReturnType<typeof useSearchUsersLazyQuery>;
export type SearchUsersSuspenseQueryHookResult = ReturnType<typeof useSearchUsersSuspenseQuery>;
export type SearchUsersQueryResult = Apollo.QueryResult<SearchUsersQuery, SearchUsersQueryVariables>;
export const QueryUsersDocument = gql`
    query queryUsers($where: [QueryInput!], $page: NonNegativeInt, $pageSize: NonNegativeInt, $orderBy: OrderByInput) {
  queryUsers(where: $where, page: $page, pageSize: $pageSize, orderBy: $orderBy) {
    ...UserFields
  }
}
    ${UserFieldsFragmentDoc}`;

/**
 * __useQueryUsersQuery__
 *
 * To run a query within a React component, call `useQueryUsersQuery` and pass it any options that fit your needs.
 * When your component renders, `useQueryUsersQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useQueryUsersQuery({
 *   variables: {
 *      where: // value for 'where'
 *      page: // value for 'page'
 *      pageSize: // value for 'pageSize'
 *      orderBy: // value for 'orderBy'
 *   },
 * });
 */
export function useQueryUsersQuery(baseOptions?: Apollo.QueryHookOptions<QueryUsersQuery, QueryUsersQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<QueryUsersQuery, QueryUsersQueryVariables>(QueryUsersDocument, options);
      }
export function useQueryUsersLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<QueryUsersQuery, QueryUsersQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<QueryUsersQuery, QueryUsersQueryVariables>(QueryUsersDocument, options);
        }
export function useQueryUsersSuspenseQuery(baseOptions?: Apollo.SuspenseQueryHookOptions<QueryUsersQuery, QueryUsersQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useSuspenseQuery<QueryUsersQuery, QueryUsersQueryVariables>(QueryUsersDocument, options);
        }
export type QueryUsersQueryHookResult = ReturnType<typeof useQueryUsersQuery>;
export type QueryUsersLazyQueryHookResult = ReturnType<typeof useQueryUsersLazyQuery>;
export type QueryUsersSuspenseQueryHookResult = ReturnType<typeof useQueryUsersSuspenseQuery>;
export type QueryUsersQueryResult = Apollo.QueryResult<QueryUsersQuery, QueryUsersQueryVariables>;
export const CountUsersDocument = gql`
    query countUsers($where: [QueryInput!]) {
  countUsers(where: $where)
}
    `;

/**
 * __useCountUsersQuery__
 *
 * To run a query within a React component, call `useCountUsersQuery` and pass it any options that fit your needs.
 * When your component renders, `useCountUsersQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useCountUsersQuery({
 *   variables: {
 *      where: // value for 'where'
 *   },
 * });
 */
export function useCountUsersQuery(baseOptions?: Apollo.QueryHookOptions<CountUsersQuery, CountUsersQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<CountUsersQuery, CountUsersQueryVariables>(CountUsersDocument, options);
      }
export function useCountUsersLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<CountUsersQuery, CountUsersQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<CountUsersQuery, CountUsersQueryVariables>(CountUsersDocument, options);
        }
export function useCountUsersSuspenseQuery(baseOptions?: Apollo.SuspenseQueryHookOptions<CountUsersQuery, CountUsersQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useSuspenseQuery<CountUsersQuery, CountUsersQueryVariables>(CountUsersDocument, options);
        }
export type CountUsersQueryHookResult = ReturnType<typeof useCountUsersQuery>;
export type CountUsersLazyQueryHookResult = ReturnType<typeof useCountUsersLazyQuery>;
export type CountUsersSuspenseQueryHookResult = ReturnType<typeof useCountUsersSuspenseQuery>;
export type CountUsersQueryResult = Apollo.QueryResult<CountUsersQuery, CountUsersQueryVariables>;
export const CheckForUserByEmailDocument = gql`
    query checkForUserByEmail($email: String!) {
  checkForUserByEmail(email: $email) {
    ...UserFields
  }
}
    ${UserFieldsFragmentDoc}`;

/**
 * __useCheckForUserByEmailQuery__
 *
 * To run a query within a React component, call `useCheckForUserByEmailQuery` and pass it any options that fit your needs.
 * When your component renders, `useCheckForUserByEmailQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useCheckForUserByEmailQuery({
 *   variables: {
 *      email: // value for 'email'
 *   },
 * });
 */
export function useCheckForUserByEmailQuery(baseOptions: Apollo.QueryHookOptions<CheckForUserByEmailQuery, CheckForUserByEmailQueryVariables> & ({ variables: CheckForUserByEmailQueryVariables; skip?: boolean; } | { skip: boolean; }) ) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<CheckForUserByEmailQuery, CheckForUserByEmailQueryVariables>(CheckForUserByEmailDocument, options);
      }
export function useCheckForUserByEmailLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<CheckForUserByEmailQuery, CheckForUserByEmailQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<CheckForUserByEmailQuery, CheckForUserByEmailQueryVariables>(CheckForUserByEmailDocument, options);
        }
export function useCheckForUserByEmailSuspenseQuery(baseOptions?: Apollo.SuspenseQueryHookOptions<CheckForUserByEmailQuery, CheckForUserByEmailQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useSuspenseQuery<CheckForUserByEmailQuery, CheckForUserByEmailQueryVariables>(CheckForUserByEmailDocument, options);
        }
export type CheckForUserByEmailQueryHookResult = ReturnType<typeof useCheckForUserByEmailQuery>;
export type CheckForUserByEmailLazyQueryHookResult = ReturnType<typeof useCheckForUserByEmailLazyQuery>;
export type CheckForUserByEmailSuspenseQueryHookResult = ReturnType<typeof useCheckForUserByEmailSuspenseQuery>;
export type CheckForUserByEmailQueryResult = Apollo.QueryResult<CheckForUserByEmailQuery, CheckForUserByEmailQueryVariables>;
export const CheckUserDesktopNotificationTokenDocument = gql`
    query checkUserDesktopNotificationToken($id: ID!, $token: String!) {
  checkUserDesktopNotificationToken(id: $id, token: $token)
}
    `;

/**
 * __useCheckUserDesktopNotificationTokenQuery__
 *
 * To run a query within a React component, call `useCheckUserDesktopNotificationTokenQuery` and pass it any options that fit your needs.
 * When your component renders, `useCheckUserDesktopNotificationTokenQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useCheckUserDesktopNotificationTokenQuery({
 *   variables: {
 *      id: // value for 'id'
 *      token: // value for 'token'
 *   },
 * });
 */
export function useCheckUserDesktopNotificationTokenQuery(baseOptions: Apollo.QueryHookOptions<CheckUserDesktopNotificationTokenQuery, CheckUserDesktopNotificationTokenQueryVariables> & ({ variables: CheckUserDesktopNotificationTokenQueryVariables; skip?: boolean; } | { skip: boolean; }) ) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<CheckUserDesktopNotificationTokenQuery, CheckUserDesktopNotificationTokenQueryVariables>(CheckUserDesktopNotificationTokenDocument, options);
      }
export function useCheckUserDesktopNotificationTokenLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<CheckUserDesktopNotificationTokenQuery, CheckUserDesktopNotificationTokenQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<CheckUserDesktopNotificationTokenQuery, CheckUserDesktopNotificationTokenQueryVariables>(CheckUserDesktopNotificationTokenDocument, options);
        }
export function useCheckUserDesktopNotificationTokenSuspenseQuery(baseOptions?: Apollo.SuspenseQueryHookOptions<CheckUserDesktopNotificationTokenQuery, CheckUserDesktopNotificationTokenQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useSuspenseQuery<CheckUserDesktopNotificationTokenQuery, CheckUserDesktopNotificationTokenQueryVariables>(CheckUserDesktopNotificationTokenDocument, options);
        }
export type CheckUserDesktopNotificationTokenQueryHookResult = ReturnType<typeof useCheckUserDesktopNotificationTokenQuery>;
export type CheckUserDesktopNotificationTokenLazyQueryHookResult = ReturnType<typeof useCheckUserDesktopNotificationTokenLazyQuery>;
export type CheckUserDesktopNotificationTokenSuspenseQueryHookResult = ReturnType<typeof useCheckUserDesktopNotificationTokenSuspenseQuery>;
export type CheckUserDesktopNotificationTokenQueryResult = Apollo.QueryResult<CheckUserDesktopNotificationTokenQuery, CheckUserDesktopNotificationTokenQueryVariables>;
export const UpdateUserDesktopNotificationTokenDocument = gql`
    mutation updateUserDesktopNotificationToken($id: ID!, $token: String!) {
  updateUserDesktopNotificationToken(id: $id, token: $token)
}
    `;
export type UpdateUserDesktopNotificationTokenMutationFn = Apollo.MutationFunction<UpdateUserDesktopNotificationTokenMutation, UpdateUserDesktopNotificationTokenMutationVariables>;

/**
 * __useUpdateUserDesktopNotificationTokenMutation__
 *
 * To run a mutation, you first call `useUpdateUserDesktopNotificationTokenMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useUpdateUserDesktopNotificationTokenMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [updateUserDesktopNotificationTokenMutation, { data, loading, error }] = useUpdateUserDesktopNotificationTokenMutation({
 *   variables: {
 *      id: // value for 'id'
 *      token: // value for 'token'
 *   },
 * });
 */
export function useUpdateUserDesktopNotificationTokenMutation(baseOptions?: Apollo.MutationHookOptions<UpdateUserDesktopNotificationTokenMutation, UpdateUserDesktopNotificationTokenMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<UpdateUserDesktopNotificationTokenMutation, UpdateUserDesktopNotificationTokenMutationVariables>(UpdateUserDesktopNotificationTokenDocument, options);
      }
export type UpdateUserDesktopNotificationTokenMutationHookResult = ReturnType<typeof useUpdateUserDesktopNotificationTokenMutation>;
export type UpdateUserDesktopNotificationTokenMutationResult = Apollo.MutationResult<UpdateUserDesktopNotificationTokenMutation>;
export type UpdateUserDesktopNotificationTokenMutationOptions = Apollo.BaseMutationOptions<UpdateUserDesktopNotificationTokenMutation, UpdateUserDesktopNotificationTokenMutationVariables>;
export const CreateUserDocument = gql`
    mutation createUser($email: String!, $password: String!, $data: CreateUserInput!, $role: String) {
  createUser(email: $email, password: $password, data: $data, role: $role) {
    ...UserFields
  }
}
    ${UserFieldsFragmentDoc}`;
export type CreateUserMutationFn = Apollo.MutationFunction<CreateUserMutation, CreateUserMutationVariables>;

/**
 * __useCreateUserMutation__
 *
 * To run a mutation, you first call `useCreateUserMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useCreateUserMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [createUserMutation, { data, loading, error }] = useCreateUserMutation({
 *   variables: {
 *      email: // value for 'email'
 *      password: // value for 'password'
 *      data: // value for 'data'
 *      role: // value for 'role'
 *   },
 * });
 */
export function useCreateUserMutation(baseOptions?: Apollo.MutationHookOptions<CreateUserMutation, CreateUserMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<CreateUserMutation, CreateUserMutationVariables>(CreateUserDocument, options);
      }
export type CreateUserMutationHookResult = ReturnType<typeof useCreateUserMutation>;
export type CreateUserMutationResult = Apollo.MutationResult<CreateUserMutation>;
export type CreateUserMutationOptions = Apollo.BaseMutationOptions<CreateUserMutation, CreateUserMutationVariables>;
export const UpdateUserDocument = gql`
    mutation updateUser($updateUserId: ID!, $data: UpdateUserInput!) {
  updateUser(id: $updateUserId, data: $data) {
    ...UserFields
  }
}
    ${UserFieldsFragmentDoc}`;
export type UpdateUserMutationFn = Apollo.MutationFunction<UpdateUserMutation, UpdateUserMutationVariables>;

/**
 * __useUpdateUserMutation__
 *
 * To run a mutation, you first call `useUpdateUserMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useUpdateUserMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [updateUserMutation, { data, loading, error }] = useUpdateUserMutation({
 *   variables: {
 *      updateUserId: // value for 'updateUserId'
 *      data: // value for 'data'
 *   },
 * });
 */
export function useUpdateUserMutation(baseOptions?: Apollo.MutationHookOptions<UpdateUserMutation, UpdateUserMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<UpdateUserMutation, UpdateUserMutationVariables>(UpdateUserDocument, options);
      }
export type UpdateUserMutationHookResult = ReturnType<typeof useUpdateUserMutation>;
export type UpdateUserMutationResult = Apollo.MutationResult<UpdateUserMutation>;
export type UpdateUserMutationOptions = Apollo.BaseMutationOptions<UpdateUserMutation, UpdateUserMutationVariables>;
export const BulkCreateUsersDocument = gql`
    mutation bulkCreateUsers($users: [BulkCreateUserInput!]!) {
  bulkCreateUsers(users: $users) {
    ...UserFields
  }
}
    ${UserFieldsFragmentDoc}`;
export type BulkCreateUsersMutationFn = Apollo.MutationFunction<BulkCreateUsersMutation, BulkCreateUsersMutationVariables>;

/**
 * __useBulkCreateUsersMutation__
 *
 * To run a mutation, you first call `useBulkCreateUsersMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useBulkCreateUsersMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [bulkCreateUsersMutation, { data, loading, error }] = useBulkCreateUsersMutation({
 *   variables: {
 *      users: // value for 'users'
 *   },
 * });
 */
export function useBulkCreateUsersMutation(baseOptions?: Apollo.MutationHookOptions<BulkCreateUsersMutation, BulkCreateUsersMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<BulkCreateUsersMutation, BulkCreateUsersMutationVariables>(BulkCreateUsersDocument, options);
      }
export type BulkCreateUsersMutationHookResult = ReturnType<typeof useBulkCreateUsersMutation>;
export type BulkCreateUsersMutationResult = Apollo.MutationResult<BulkCreateUsersMutation>;
export type BulkCreateUsersMutationOptions = Apollo.BaseMutationOptions<BulkCreateUsersMutation, BulkCreateUsersMutationVariables>;
export const ForcePasswordResetDocument = gql`
    mutation forcePasswordReset($userId: ID!, $clinicId: ID, $clinicGroupId: ID) {
  forcePasswordReset(
    userId: $userId
    clinicId: $clinicId
    clinicGroupId: $clinicGroupId
  )
}
    `;
export type ForcePasswordResetMutationFn = Apollo.MutationFunction<ForcePasswordResetMutation, ForcePasswordResetMutationVariables>;

/**
 * __useForcePasswordResetMutation__
 *
 * To run a mutation, you first call `useForcePasswordResetMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useForcePasswordResetMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [forcePasswordResetMutation, { data, loading, error }] = useForcePasswordResetMutation({
 *   variables: {
 *      userId: // value for 'userId'
 *      clinicId: // value for 'clinicId'
 *      clinicGroupId: // value for 'clinicGroupId'
 *   },
 * });
 */
export function useForcePasswordResetMutation(baseOptions?: Apollo.MutationHookOptions<ForcePasswordResetMutation, ForcePasswordResetMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<ForcePasswordResetMutation, ForcePasswordResetMutationVariables>(ForcePasswordResetDocument, options);
      }
export type ForcePasswordResetMutationHookResult = ReturnType<typeof useForcePasswordResetMutation>;
export type ForcePasswordResetMutationResult = Apollo.MutationResult<ForcePasswordResetMutation>;
export type ForcePasswordResetMutationOptions = Apollo.BaseMutationOptions<ForcePasswordResetMutation, ForcePasswordResetMutationVariables>;
export const ResendInviteEmailDocument = gql`
    mutation resendInviteEmail($userId: ID!, $clinicId: ID, $clinicGroupId: ID) {
  resendInviteEmail(
    userId: $userId
    clinicId: $clinicId
    clinicGroupId: $clinicGroupId
  )
}
    `;
export type ResendInviteEmailMutationFn = Apollo.MutationFunction<ResendInviteEmailMutation, ResendInviteEmailMutationVariables>;

/**
 * __useResendInviteEmailMutation__
 *
 * To run a mutation, you first call `useResendInviteEmailMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useResendInviteEmailMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [resendInviteEmailMutation, { data, loading, error }] = useResendInviteEmailMutation({
 *   variables: {
 *      userId: // value for 'userId'
 *      clinicId: // value for 'clinicId'
 *      clinicGroupId: // value for 'clinicGroupId'
 *   },
 * });
 */
export function useResendInviteEmailMutation(baseOptions?: Apollo.MutationHookOptions<ResendInviteEmailMutation, ResendInviteEmailMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<ResendInviteEmailMutation, ResendInviteEmailMutationVariables>(ResendInviteEmailDocument, options);
      }
export type ResendInviteEmailMutationHookResult = ReturnType<typeof useResendInviteEmailMutation>;
export type ResendInviteEmailMutationResult = Apollo.MutationResult<ResendInviteEmailMutation>;
export type ResendInviteEmailMutationOptions = Apollo.BaseMutationOptions<ResendInviteEmailMutation, ResendInviteEmailMutationVariables>;
export const UpdateUserAuthInfoDocument = gql`
    mutation updateUserAuthInfo($id: ID!, $data: UpdateUserAuthInfoInput!) {
  updateUserAuthInfo(id: $id, data: $data)
}
    `;
export type UpdateUserAuthInfoMutationFn = Apollo.MutationFunction<UpdateUserAuthInfoMutation, UpdateUserAuthInfoMutationVariables>;

/**
 * __useUpdateUserAuthInfoMutation__
 *
 * To run a mutation, you first call `useUpdateUserAuthInfoMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useUpdateUserAuthInfoMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [updateUserAuthInfoMutation, { data, loading, error }] = useUpdateUserAuthInfoMutation({
 *   variables: {
 *      id: // value for 'id'
 *      data: // value for 'data'
 *   },
 * });
 */
export function useUpdateUserAuthInfoMutation(baseOptions?: Apollo.MutationHookOptions<UpdateUserAuthInfoMutation, UpdateUserAuthInfoMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<UpdateUserAuthInfoMutation, UpdateUserAuthInfoMutationVariables>(UpdateUserAuthInfoDocument, options);
      }
export type UpdateUserAuthInfoMutationHookResult = ReturnType<typeof useUpdateUserAuthInfoMutation>;
export type UpdateUserAuthInfoMutationResult = Apollo.MutationResult<UpdateUserAuthInfoMutation>;
export type UpdateUserAuthInfoMutationOptions = Apollo.BaseMutationOptions<UpdateUserAuthInfoMutation, UpdateUserAuthInfoMutationVariables>;
export const QueryPatientVaccinationRecordsDocument = gql`
    query queryPatientVaccinationRecords($where: [QueryInput!], $page: NonNegativeInt, $pageSize: PositiveInt, $orderBy: OrderByInput) {
  queryPatientVaccinationRecords(
    where: $where
    page: $page
    pageSize: $pageSize
    orderBy: $orderBy
  ) {
    ...PatientVaccinationRecordFields
  }
}
    ${PatientVaccinationRecordFieldsFragmentDoc}`;

/**
 * __useQueryPatientVaccinationRecordsQuery__
 *
 * To run a query within a React component, call `useQueryPatientVaccinationRecordsQuery` and pass it any options that fit your needs.
 * When your component renders, `useQueryPatientVaccinationRecordsQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useQueryPatientVaccinationRecordsQuery({
 *   variables: {
 *      where: // value for 'where'
 *      page: // value for 'page'
 *      pageSize: // value for 'pageSize'
 *      orderBy: // value for 'orderBy'
 *   },
 * });
 */
export function useQueryPatientVaccinationRecordsQuery(baseOptions?: Apollo.QueryHookOptions<QueryPatientVaccinationRecordsQuery, QueryPatientVaccinationRecordsQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<QueryPatientVaccinationRecordsQuery, QueryPatientVaccinationRecordsQueryVariables>(QueryPatientVaccinationRecordsDocument, options);
      }
export function useQueryPatientVaccinationRecordsLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<QueryPatientVaccinationRecordsQuery, QueryPatientVaccinationRecordsQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<QueryPatientVaccinationRecordsQuery, QueryPatientVaccinationRecordsQueryVariables>(QueryPatientVaccinationRecordsDocument, options);
        }
export function useQueryPatientVaccinationRecordsSuspenseQuery(baseOptions?: Apollo.SuspenseQueryHookOptions<QueryPatientVaccinationRecordsQuery, QueryPatientVaccinationRecordsQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useSuspenseQuery<QueryPatientVaccinationRecordsQuery, QueryPatientVaccinationRecordsQueryVariables>(QueryPatientVaccinationRecordsDocument, options);
        }
export type QueryPatientVaccinationRecordsQueryHookResult = ReturnType<typeof useQueryPatientVaccinationRecordsQuery>;
export type QueryPatientVaccinationRecordsLazyQueryHookResult = ReturnType<typeof useQueryPatientVaccinationRecordsLazyQuery>;
export type QueryPatientVaccinationRecordsSuspenseQueryHookResult = ReturnType<typeof useQueryPatientVaccinationRecordsSuspenseQuery>;
export type QueryPatientVaccinationRecordsQueryResult = Apollo.QueryResult<QueryPatientVaccinationRecordsQuery, QueryPatientVaccinationRecordsQueryVariables>;
export const CountPatientVaccinationRecordsDocument = gql`
    query countPatientVaccinationRecords($where: [QueryInput!]) {
  countPatientVaccinationRecords(where: $where)
}
    `;

/**
 * __useCountPatientVaccinationRecordsQuery__
 *
 * To run a query within a React component, call `useCountPatientVaccinationRecordsQuery` and pass it any options that fit your needs.
 * When your component renders, `useCountPatientVaccinationRecordsQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useCountPatientVaccinationRecordsQuery({
 *   variables: {
 *      where: // value for 'where'
 *   },
 * });
 */
export function useCountPatientVaccinationRecordsQuery(baseOptions?: Apollo.QueryHookOptions<CountPatientVaccinationRecordsQuery, CountPatientVaccinationRecordsQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<CountPatientVaccinationRecordsQuery, CountPatientVaccinationRecordsQueryVariables>(CountPatientVaccinationRecordsDocument, options);
      }
export function useCountPatientVaccinationRecordsLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<CountPatientVaccinationRecordsQuery, CountPatientVaccinationRecordsQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<CountPatientVaccinationRecordsQuery, CountPatientVaccinationRecordsQueryVariables>(CountPatientVaccinationRecordsDocument, options);
        }
export function useCountPatientVaccinationRecordsSuspenseQuery(baseOptions?: Apollo.SuspenseQueryHookOptions<CountPatientVaccinationRecordsQuery, CountPatientVaccinationRecordsQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useSuspenseQuery<CountPatientVaccinationRecordsQuery, CountPatientVaccinationRecordsQueryVariables>(CountPatientVaccinationRecordsDocument, options);
        }
export type CountPatientVaccinationRecordsQueryHookResult = ReturnType<typeof useCountPatientVaccinationRecordsQuery>;
export type CountPatientVaccinationRecordsLazyQueryHookResult = ReturnType<typeof useCountPatientVaccinationRecordsLazyQuery>;
export type CountPatientVaccinationRecordsSuspenseQueryHookResult = ReturnType<typeof useCountPatientVaccinationRecordsSuspenseQuery>;
export type CountPatientVaccinationRecordsQueryResult = Apollo.QueryResult<CountPatientVaccinationRecordsQuery, CountPatientVaccinationRecordsQueryVariables>;
export const ShareVaccineRecordsDocument = gql`
    mutation shareVaccineRecords($input: ShareVaccineRecordsInput!) {
  shareVaccineRecords(input: $input) {
    status
    channel
    record_count
    overdue_count
  }
}
    `;
export type ShareVaccineRecordsMutationFn = Apollo.MutationFunction<ShareVaccineRecordsMutation, ShareVaccineRecordsMutationVariables>;

/**
 * __useShareVaccineRecordsMutation__
 *
 * To run a mutation, you first call `useShareVaccineRecordsMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useShareVaccineRecordsMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [shareVaccineRecordsMutation, { data, loading, error }] = useShareVaccineRecordsMutation({
 *   variables: {
 *      input: // value for 'input'
 *   },
 * });
 */
export function useShareVaccineRecordsMutation(baseOptions?: Apollo.MutationHookOptions<ShareVaccineRecordsMutation, ShareVaccineRecordsMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<ShareVaccineRecordsMutation, ShareVaccineRecordsMutationVariables>(ShareVaccineRecordsDocument, options);
      }
export type ShareVaccineRecordsMutationHookResult = ReturnType<typeof useShareVaccineRecordsMutation>;
export type ShareVaccineRecordsMutationResult = Apollo.MutationResult<ShareVaccineRecordsMutation>;
export type ShareVaccineRecordsMutationOptions = Apollo.BaseMutationOptions<ShareVaccineRecordsMutation, ShareVaccineRecordsMutationVariables>;
export const TriggerWebhookTestDocument = gql`
    mutation triggerWebhookTest($data: TriggerWebhookInput!) {
  triggerWebhookTest(data: $data) {
    success
    webhooks_triggered
  }
}
    `;
export type TriggerWebhookTestMutationFn = Apollo.MutationFunction<TriggerWebhookTestMutation, TriggerWebhookTestMutationVariables>;

/**
 * __useTriggerWebhookTestMutation__
 *
 * To run a mutation, you first call `useTriggerWebhookTestMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useTriggerWebhookTestMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [triggerWebhookTestMutation, { data, loading, error }] = useTriggerWebhookTestMutation({
 *   variables: {
 *      data: // value for 'data'
 *   },
 * });
 */
export function useTriggerWebhookTestMutation(baseOptions?: Apollo.MutationHookOptions<TriggerWebhookTestMutation, TriggerWebhookTestMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<TriggerWebhookTestMutation, TriggerWebhookTestMutationVariables>(TriggerWebhookTestDocument, options);
      }
export type TriggerWebhookTestMutationHookResult = ReturnType<typeof useTriggerWebhookTestMutation>;
export type TriggerWebhookTestMutationResult = Apollo.MutationResult<TriggerWebhookTestMutation>;
export type TriggerWebhookTestMutationOptions = Apollo.BaseMutationOptions<TriggerWebhookTestMutation, TriggerWebhookTestMutationVariables>;
export const WidgetOptionsByWidgetDocument = gql`
    query widgetOptionsByWidget($widgetId: ID!) {
  widgetOptionsForWidget(widgetId: $widgetId) {
    ...WidgetOptionsFields
  }
}
    ${WidgetOptionsFieldsFragmentDoc}`;

/**
 * __useWidgetOptionsByWidgetQuery__
 *
 * To run a query within a React component, call `useWidgetOptionsByWidgetQuery` and pass it any options that fit your needs.
 * When your component renders, `useWidgetOptionsByWidgetQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useWidgetOptionsByWidgetQuery({
 *   variables: {
 *      widgetId: // value for 'widgetId'
 *   },
 * });
 */
export function useWidgetOptionsByWidgetQuery(baseOptions: Apollo.QueryHookOptions<WidgetOptionsByWidgetQuery, WidgetOptionsByWidgetQueryVariables> & ({ variables: WidgetOptionsByWidgetQueryVariables; skip?: boolean; } | { skip: boolean; }) ) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<WidgetOptionsByWidgetQuery, WidgetOptionsByWidgetQueryVariables>(WidgetOptionsByWidgetDocument, options);
      }
export function useWidgetOptionsByWidgetLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<WidgetOptionsByWidgetQuery, WidgetOptionsByWidgetQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<WidgetOptionsByWidgetQuery, WidgetOptionsByWidgetQueryVariables>(WidgetOptionsByWidgetDocument, options);
        }
export function useWidgetOptionsByWidgetSuspenseQuery(baseOptions?: Apollo.SuspenseQueryHookOptions<WidgetOptionsByWidgetQuery, WidgetOptionsByWidgetQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useSuspenseQuery<WidgetOptionsByWidgetQuery, WidgetOptionsByWidgetQueryVariables>(WidgetOptionsByWidgetDocument, options);
        }
export type WidgetOptionsByWidgetQueryHookResult = ReturnType<typeof useWidgetOptionsByWidgetQuery>;
export type WidgetOptionsByWidgetLazyQueryHookResult = ReturnType<typeof useWidgetOptionsByWidgetLazyQuery>;
export type WidgetOptionsByWidgetSuspenseQueryHookResult = ReturnType<typeof useWidgetOptionsByWidgetSuspenseQuery>;
export type WidgetOptionsByWidgetQueryResult = Apollo.QueryResult<WidgetOptionsByWidgetQuery, WidgetOptionsByWidgetQueryVariables>;
export const CreateWidgetOptionsDocument = gql`
    mutation createWidgetOptions($data: CreateWidgetOptionsInput!) {
  createWidgetOptions(data: $data) {
    ...WidgetOptionsFields
  }
}
    ${WidgetOptionsFieldsFragmentDoc}`;
export type CreateWidgetOptionsMutationFn = Apollo.MutationFunction<CreateWidgetOptionsMutation, CreateWidgetOptionsMutationVariables>;

/**
 * __useCreateWidgetOptionsMutation__
 *
 * To run a mutation, you first call `useCreateWidgetOptionsMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useCreateWidgetOptionsMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [createWidgetOptionsMutation, { data, loading, error }] = useCreateWidgetOptionsMutation({
 *   variables: {
 *      data: // value for 'data'
 *   },
 * });
 */
export function useCreateWidgetOptionsMutation(baseOptions?: Apollo.MutationHookOptions<CreateWidgetOptionsMutation, CreateWidgetOptionsMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<CreateWidgetOptionsMutation, CreateWidgetOptionsMutationVariables>(CreateWidgetOptionsDocument, options);
      }
export type CreateWidgetOptionsMutationHookResult = ReturnType<typeof useCreateWidgetOptionsMutation>;
export type CreateWidgetOptionsMutationResult = Apollo.MutationResult<CreateWidgetOptionsMutation>;
export type CreateWidgetOptionsMutationOptions = Apollo.BaseMutationOptions<CreateWidgetOptionsMutation, CreateWidgetOptionsMutationVariables>;
export const UpdateWidgetOptionsDocument = gql`
    mutation updateWidgetOptions($widgetId: ID!, $data: UpdateWidgetOptionsInput!) {
  updateWidgetOptions(widgetId: $widgetId, data: $data) {
    ...WidgetOptionsFields
  }
}
    ${WidgetOptionsFieldsFragmentDoc}`;
export type UpdateWidgetOptionsMutationFn = Apollo.MutationFunction<UpdateWidgetOptionsMutation, UpdateWidgetOptionsMutationVariables>;

/**
 * __useUpdateWidgetOptionsMutation__
 *
 * To run a mutation, you first call `useUpdateWidgetOptionsMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useUpdateWidgetOptionsMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [updateWidgetOptionsMutation, { data, loading, error }] = useUpdateWidgetOptionsMutation({
 *   variables: {
 *      widgetId: // value for 'widgetId'
 *      data: // value for 'data'
 *   },
 * });
 */
export function useUpdateWidgetOptionsMutation(baseOptions?: Apollo.MutationHookOptions<UpdateWidgetOptionsMutation, UpdateWidgetOptionsMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<UpdateWidgetOptionsMutation, UpdateWidgetOptionsMutationVariables>(UpdateWidgetOptionsDocument, options);
      }
export type UpdateWidgetOptionsMutationHookResult = ReturnType<typeof useUpdateWidgetOptionsMutation>;
export type UpdateWidgetOptionsMutationResult = Apollo.MutationResult<UpdateWidgetOptionsMutation>;
export type UpdateWidgetOptionsMutationOptions = Apollo.BaseMutationOptions<UpdateWidgetOptionsMutation, UpdateWidgetOptionsMutationVariables>;
export const WidgetServiceDocument = gql`
    query widgetService($widgetId: ID!) {
  widgetService(id: $widgetId) {
    ...WidgetServiceFields
  }
}
    ${WidgetServiceFieldsFragmentDoc}`;

/**
 * __useWidgetServiceQuery__
 *
 * To run a query within a React component, call `useWidgetServiceQuery` and pass it any options that fit your needs.
 * When your component renders, `useWidgetServiceQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useWidgetServiceQuery({
 *   variables: {
 *      widgetId: // value for 'widgetId'
 *   },
 * });
 */
export function useWidgetServiceQuery(baseOptions: Apollo.QueryHookOptions<WidgetServiceQuery, WidgetServiceQueryVariables> & ({ variables: WidgetServiceQueryVariables; skip?: boolean; } | { skip: boolean; }) ) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<WidgetServiceQuery, WidgetServiceQueryVariables>(WidgetServiceDocument, options);
      }
export function useWidgetServiceLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<WidgetServiceQuery, WidgetServiceQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<WidgetServiceQuery, WidgetServiceQueryVariables>(WidgetServiceDocument, options);
        }
export function useWidgetServiceSuspenseQuery(baseOptions?: Apollo.SuspenseQueryHookOptions<WidgetServiceQuery, WidgetServiceQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useSuspenseQuery<WidgetServiceQuery, WidgetServiceQueryVariables>(WidgetServiceDocument, options);
        }
export type WidgetServiceQueryHookResult = ReturnType<typeof useWidgetServiceQuery>;
export type WidgetServiceLazyQueryHookResult = ReturnType<typeof useWidgetServiceLazyQuery>;
export type WidgetServiceSuspenseQueryHookResult = ReturnType<typeof useWidgetServiceSuspenseQuery>;
export type WidgetServiceQueryResult = Apollo.QueryResult<WidgetServiceQuery, WidgetServiceQueryVariables>;
export const WidgetServicesForWidgetDocument = gql`
    query widgetServicesForWidget($widgetId: ID!) {
  widgetServicesForWidget(widgetId: $widgetId) {
    ...WidgetServiceFields
  }
}
    ${WidgetServiceFieldsFragmentDoc}`;

/**
 * __useWidgetServicesForWidgetQuery__
 *
 * To run a query within a React component, call `useWidgetServicesForWidgetQuery` and pass it any options that fit your needs.
 * When your component renders, `useWidgetServicesForWidgetQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useWidgetServicesForWidgetQuery({
 *   variables: {
 *      widgetId: // value for 'widgetId'
 *   },
 * });
 */
export function useWidgetServicesForWidgetQuery(baseOptions: Apollo.QueryHookOptions<WidgetServicesForWidgetQuery, WidgetServicesForWidgetQueryVariables> & ({ variables: WidgetServicesForWidgetQueryVariables; skip?: boolean; } | { skip: boolean; }) ) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<WidgetServicesForWidgetQuery, WidgetServicesForWidgetQueryVariables>(WidgetServicesForWidgetDocument, options);
      }
export function useWidgetServicesForWidgetLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<WidgetServicesForWidgetQuery, WidgetServicesForWidgetQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<WidgetServicesForWidgetQuery, WidgetServicesForWidgetQueryVariables>(WidgetServicesForWidgetDocument, options);
        }
export function useWidgetServicesForWidgetSuspenseQuery(baseOptions?: Apollo.SuspenseQueryHookOptions<WidgetServicesForWidgetQuery, WidgetServicesForWidgetQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useSuspenseQuery<WidgetServicesForWidgetQuery, WidgetServicesForWidgetQueryVariables>(WidgetServicesForWidgetDocument, options);
        }
export type WidgetServicesForWidgetQueryHookResult = ReturnType<typeof useWidgetServicesForWidgetQuery>;
export type WidgetServicesForWidgetLazyQueryHookResult = ReturnType<typeof useWidgetServicesForWidgetLazyQuery>;
export type WidgetServicesForWidgetSuspenseQueryHookResult = ReturnType<typeof useWidgetServicesForWidgetSuspenseQuery>;
export type WidgetServicesForWidgetQueryResult = Apollo.QueryResult<WidgetServicesForWidgetQuery, WidgetServicesForWidgetQueryVariables>;
export const CreateWidgetServiceDocument = gql`
    mutation createWidgetService($data: CreateWidgetServiceInput!) {
  createWidgetService(data: $data) {
    ...WidgetServiceFields
  }
}
    ${WidgetServiceFieldsFragmentDoc}`;
export type CreateWidgetServiceMutationFn = Apollo.MutationFunction<CreateWidgetServiceMutation, CreateWidgetServiceMutationVariables>;

/**
 * __useCreateWidgetServiceMutation__
 *
 * To run a mutation, you first call `useCreateWidgetServiceMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useCreateWidgetServiceMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [createWidgetServiceMutation, { data, loading, error }] = useCreateWidgetServiceMutation({
 *   variables: {
 *      data: // value for 'data'
 *   },
 * });
 */
export function useCreateWidgetServiceMutation(baseOptions?: Apollo.MutationHookOptions<CreateWidgetServiceMutation, CreateWidgetServiceMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<CreateWidgetServiceMutation, CreateWidgetServiceMutationVariables>(CreateWidgetServiceDocument, options);
      }
export type CreateWidgetServiceMutationHookResult = ReturnType<typeof useCreateWidgetServiceMutation>;
export type CreateWidgetServiceMutationResult = Apollo.MutationResult<CreateWidgetServiceMutation>;
export type CreateWidgetServiceMutationOptions = Apollo.BaseMutationOptions<CreateWidgetServiceMutation, CreateWidgetServiceMutationVariables>;
export const UpdateWidgetServiceDocument = gql`
    mutation updateWidgetService($widgetId: ID!, $data: UpdateWidgetServiceInput!) {
  updateWidgetService(id: $widgetId, data: $data) {
    ...WidgetServiceFields
  }
}
    ${WidgetServiceFieldsFragmentDoc}`;
export type UpdateWidgetServiceMutationFn = Apollo.MutationFunction<UpdateWidgetServiceMutation, UpdateWidgetServiceMutationVariables>;

/**
 * __useUpdateWidgetServiceMutation__
 *
 * To run a mutation, you first call `useUpdateWidgetServiceMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useUpdateWidgetServiceMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [updateWidgetServiceMutation, { data, loading, error }] = useUpdateWidgetServiceMutation({
 *   variables: {
 *      widgetId: // value for 'widgetId'
 *      data: // value for 'data'
 *   },
 * });
 */
export function useUpdateWidgetServiceMutation(baseOptions?: Apollo.MutationHookOptions<UpdateWidgetServiceMutation, UpdateWidgetServiceMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<UpdateWidgetServiceMutation, UpdateWidgetServiceMutationVariables>(UpdateWidgetServiceDocument, options);
      }
export type UpdateWidgetServiceMutationHookResult = ReturnType<typeof useUpdateWidgetServiceMutation>;
export type UpdateWidgetServiceMutationResult = Apollo.MutationResult<UpdateWidgetServiceMutation>;
export type UpdateWidgetServiceMutationOptions = Apollo.BaseMutationOptions<UpdateWidgetServiceMutation, UpdateWidgetServiceMutationVariables>;
export const DeleteWidgetServiceDocument = gql`
    mutation deleteWidgetService($widgetId: ID!) {
  deleteWidgetService(id: $widgetId)
}
    `;
export type DeleteWidgetServiceMutationFn = Apollo.MutationFunction<DeleteWidgetServiceMutation, DeleteWidgetServiceMutationVariables>;

/**
 * __useDeleteWidgetServiceMutation__
 *
 * To run a mutation, you first call `useDeleteWidgetServiceMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useDeleteWidgetServiceMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [deleteWidgetServiceMutation, { data, loading, error }] = useDeleteWidgetServiceMutation({
 *   variables: {
 *      widgetId: // value for 'widgetId'
 *   },
 * });
 */
export function useDeleteWidgetServiceMutation(baseOptions?: Apollo.MutationHookOptions<DeleteWidgetServiceMutation, DeleteWidgetServiceMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<DeleteWidgetServiceMutation, DeleteWidgetServiceMutationVariables>(DeleteWidgetServiceDocument, options);
      }
export type DeleteWidgetServiceMutationHookResult = ReturnType<typeof useDeleteWidgetServiceMutation>;
export type DeleteWidgetServiceMutationResult = Apollo.MutationResult<DeleteWidgetServiceMutation>;
export type DeleteWidgetServiceMutationOptions = Apollo.BaseMutationOptions<DeleteWidgetServiceMutation, DeleteWidgetServiceMutationVariables>;
export const GetWidgetDocument = gql`
    query getWidget($id: ID!) {
  widget(id: $id) {
    ...WidgetFields
  }
}
    ${WidgetFieldsFragmentDoc}`;

/**
 * __useGetWidgetQuery__
 *
 * To run a query within a React component, call `useGetWidgetQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetWidgetQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetWidgetQuery({
 *   variables: {
 *      id: // value for 'id'
 *   },
 * });
 */
export function useGetWidgetQuery(baseOptions: Apollo.QueryHookOptions<GetWidgetQuery, GetWidgetQueryVariables> & ({ variables: GetWidgetQueryVariables; skip?: boolean; } | { skip: boolean; }) ) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<GetWidgetQuery, GetWidgetQueryVariables>(GetWidgetDocument, options);
      }
export function useGetWidgetLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<GetWidgetQuery, GetWidgetQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<GetWidgetQuery, GetWidgetQueryVariables>(GetWidgetDocument, options);
        }
export function useGetWidgetSuspenseQuery(baseOptions?: Apollo.SuspenseQueryHookOptions<GetWidgetQuery, GetWidgetQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useSuspenseQuery<GetWidgetQuery, GetWidgetQueryVariables>(GetWidgetDocument, options);
        }
export type GetWidgetQueryHookResult = ReturnType<typeof useGetWidgetQuery>;
export type GetWidgetLazyQueryHookResult = ReturnType<typeof useGetWidgetLazyQuery>;
export type GetWidgetSuspenseQueryHookResult = ReturnType<typeof useGetWidgetSuspenseQuery>;
export type GetWidgetQueryResult = Apollo.QueryResult<GetWidgetQuery, GetWidgetQueryVariables>;
export const EnsureDefaultPortalWidgetDocument = gql`
    query ensureDefaultPortalWidget($clinicId: ID!) {
  ensureDefaultPortalWidget(clinicId: $clinicId) {
    ...WidgetFields
  }
}
    ${WidgetFieldsFragmentDoc}`;

/**
 * __useEnsureDefaultPortalWidgetQuery__
 *
 * To run a query within a React component, call `useEnsureDefaultPortalWidgetQuery` and pass it any options that fit your needs.
 * When your component renders, `useEnsureDefaultPortalWidgetQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useEnsureDefaultPortalWidgetQuery({
 *   variables: {
 *      clinicId: // value for 'clinicId'
 *   },
 * });
 */
export function useEnsureDefaultPortalWidgetQuery(baseOptions: Apollo.QueryHookOptions<EnsureDefaultPortalWidgetQuery, EnsureDefaultPortalWidgetQueryVariables> & ({ variables: EnsureDefaultPortalWidgetQueryVariables; skip?: boolean; } | { skip: boolean; }) ) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<EnsureDefaultPortalWidgetQuery, EnsureDefaultPortalWidgetQueryVariables>(EnsureDefaultPortalWidgetDocument, options);
      }
export function useEnsureDefaultPortalWidgetLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<EnsureDefaultPortalWidgetQuery, EnsureDefaultPortalWidgetQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<EnsureDefaultPortalWidgetQuery, EnsureDefaultPortalWidgetQueryVariables>(EnsureDefaultPortalWidgetDocument, options);
        }
export function useEnsureDefaultPortalWidgetSuspenseQuery(baseOptions?: Apollo.SuspenseQueryHookOptions<EnsureDefaultPortalWidgetQuery, EnsureDefaultPortalWidgetQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useSuspenseQuery<EnsureDefaultPortalWidgetQuery, EnsureDefaultPortalWidgetQueryVariables>(EnsureDefaultPortalWidgetDocument, options);
        }
export type EnsureDefaultPortalWidgetQueryHookResult = ReturnType<typeof useEnsureDefaultPortalWidgetQuery>;
export type EnsureDefaultPortalWidgetLazyQueryHookResult = ReturnType<typeof useEnsureDefaultPortalWidgetLazyQuery>;
export type EnsureDefaultPortalWidgetSuspenseQueryHookResult = ReturnType<typeof useEnsureDefaultPortalWidgetSuspenseQuery>;
export type EnsureDefaultPortalWidgetQueryResult = Apollo.QueryResult<EnsureDefaultPortalWidgetQuery, EnsureDefaultPortalWidgetQueryVariables>;
export const GetWidgetWithServicesDocument = gql`
    query getWidgetWithServices($id: ID!) {
  widget(id: $id) {
    ...WidgetWithServicesFields
  }
}
    ${WidgetWithServicesFieldsFragmentDoc}`;

/**
 * __useGetWidgetWithServicesQuery__
 *
 * To run a query within a React component, call `useGetWidgetWithServicesQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetWidgetWithServicesQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetWidgetWithServicesQuery({
 *   variables: {
 *      id: // value for 'id'
 *   },
 * });
 */
export function useGetWidgetWithServicesQuery(baseOptions: Apollo.QueryHookOptions<GetWidgetWithServicesQuery, GetWidgetWithServicesQueryVariables> & ({ variables: GetWidgetWithServicesQueryVariables; skip?: boolean; } | { skip: boolean; }) ) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<GetWidgetWithServicesQuery, GetWidgetWithServicesQueryVariables>(GetWidgetWithServicesDocument, options);
      }
export function useGetWidgetWithServicesLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<GetWidgetWithServicesQuery, GetWidgetWithServicesQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<GetWidgetWithServicesQuery, GetWidgetWithServicesQueryVariables>(GetWidgetWithServicesDocument, options);
        }
export function useGetWidgetWithServicesSuspenseQuery(baseOptions?: Apollo.SuspenseQueryHookOptions<GetWidgetWithServicesQuery, GetWidgetWithServicesQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useSuspenseQuery<GetWidgetWithServicesQuery, GetWidgetWithServicesQueryVariables>(GetWidgetWithServicesDocument, options);
        }
export type GetWidgetWithServicesQueryHookResult = ReturnType<typeof useGetWidgetWithServicesQuery>;
export type GetWidgetWithServicesLazyQueryHookResult = ReturnType<typeof useGetWidgetWithServicesLazyQuery>;
export type GetWidgetWithServicesSuspenseQueryHookResult = ReturnType<typeof useGetWidgetWithServicesSuspenseQuery>;
export type GetWidgetWithServicesQueryResult = Apollo.QueryResult<GetWidgetWithServicesQuery, GetWidgetWithServicesQueryVariables>;
export const GetWidgetsByClinicDocument = gql`
    query getWidgetsByClinic($clinicId: ID!) {
  getWidgetsByClinic(clinicId: $clinicId) {
    ...WidgetFields
  }
}
    ${WidgetFieldsFragmentDoc}`;

/**
 * __useGetWidgetsByClinicQuery__
 *
 * To run a query within a React component, call `useGetWidgetsByClinicQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetWidgetsByClinicQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetWidgetsByClinicQuery({
 *   variables: {
 *      clinicId: // value for 'clinicId'
 *   },
 * });
 */
export function useGetWidgetsByClinicQuery(baseOptions: Apollo.QueryHookOptions<GetWidgetsByClinicQuery, GetWidgetsByClinicQueryVariables> & ({ variables: GetWidgetsByClinicQueryVariables; skip?: boolean; } | { skip: boolean; }) ) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<GetWidgetsByClinicQuery, GetWidgetsByClinicQueryVariables>(GetWidgetsByClinicDocument, options);
      }
export function useGetWidgetsByClinicLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<GetWidgetsByClinicQuery, GetWidgetsByClinicQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<GetWidgetsByClinicQuery, GetWidgetsByClinicQueryVariables>(GetWidgetsByClinicDocument, options);
        }
export function useGetWidgetsByClinicSuspenseQuery(baseOptions?: Apollo.SuspenseQueryHookOptions<GetWidgetsByClinicQuery, GetWidgetsByClinicQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useSuspenseQuery<GetWidgetsByClinicQuery, GetWidgetsByClinicQueryVariables>(GetWidgetsByClinicDocument, options);
        }
export type GetWidgetsByClinicQueryHookResult = ReturnType<typeof useGetWidgetsByClinicQuery>;
export type GetWidgetsByClinicLazyQueryHookResult = ReturnType<typeof useGetWidgetsByClinicLazyQuery>;
export type GetWidgetsByClinicSuspenseQueryHookResult = ReturnType<typeof useGetWidgetsByClinicSuspenseQuery>;
export type GetWidgetsByClinicQueryResult = Apollo.QueryResult<GetWidgetsByClinicQuery, GetWidgetsByClinicQueryVariables>;
export const GetWidgetsByOrganizationDocument = gql`
    query getWidgetsByOrganization($organizationId: ID!) {
  getWidgetsByOrganization(organizationId: $organizationId) {
    ...WidgetFields
  }
}
    ${WidgetFieldsFragmentDoc}`;

/**
 * __useGetWidgetsByOrganizationQuery__
 *
 * To run a query within a React component, call `useGetWidgetsByOrganizationQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetWidgetsByOrganizationQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetWidgetsByOrganizationQuery({
 *   variables: {
 *      organizationId: // value for 'organizationId'
 *   },
 * });
 */
export function useGetWidgetsByOrganizationQuery(baseOptions: Apollo.QueryHookOptions<GetWidgetsByOrganizationQuery, GetWidgetsByOrganizationQueryVariables> & ({ variables: GetWidgetsByOrganizationQueryVariables; skip?: boolean; } | { skip: boolean; }) ) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<GetWidgetsByOrganizationQuery, GetWidgetsByOrganizationQueryVariables>(GetWidgetsByOrganizationDocument, options);
      }
export function useGetWidgetsByOrganizationLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<GetWidgetsByOrganizationQuery, GetWidgetsByOrganizationQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<GetWidgetsByOrganizationQuery, GetWidgetsByOrganizationQueryVariables>(GetWidgetsByOrganizationDocument, options);
        }
export function useGetWidgetsByOrganizationSuspenseQuery(baseOptions?: Apollo.SuspenseQueryHookOptions<GetWidgetsByOrganizationQuery, GetWidgetsByOrganizationQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useSuspenseQuery<GetWidgetsByOrganizationQuery, GetWidgetsByOrganizationQueryVariables>(GetWidgetsByOrganizationDocument, options);
        }
export type GetWidgetsByOrganizationQueryHookResult = ReturnType<typeof useGetWidgetsByOrganizationQuery>;
export type GetWidgetsByOrganizationLazyQueryHookResult = ReturnType<typeof useGetWidgetsByOrganizationLazyQuery>;
export type GetWidgetsByOrganizationSuspenseQueryHookResult = ReturnType<typeof useGetWidgetsByOrganizationSuspenseQuery>;
export type GetWidgetsByOrganizationQueryResult = Apollo.QueryResult<GetWidgetsByOrganizationQuery, GetWidgetsByOrganizationQueryVariables>;
export const GetWidgetsByClinicGroupDocument = gql`
    query getWidgetsByClinicGroup($clinicGroupId: ID!, $includeSubgroups: Boolean = false) {
  getWidgetsByClinicGroup(
    clinicGroupId: $clinicGroupId
    includeSubgroups: $includeSubgroups
  ) {
    ...WidgetFields
  }
}
    ${WidgetFieldsFragmentDoc}`;

/**
 * __useGetWidgetsByClinicGroupQuery__
 *
 * To run a query within a React component, call `useGetWidgetsByClinicGroupQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetWidgetsByClinicGroupQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetWidgetsByClinicGroupQuery({
 *   variables: {
 *      clinicGroupId: // value for 'clinicGroupId'
 *      includeSubgroups: // value for 'includeSubgroups'
 *   },
 * });
 */
export function useGetWidgetsByClinicGroupQuery(baseOptions: Apollo.QueryHookOptions<GetWidgetsByClinicGroupQuery, GetWidgetsByClinicGroupQueryVariables> & ({ variables: GetWidgetsByClinicGroupQueryVariables; skip?: boolean; } | { skip: boolean; }) ) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<GetWidgetsByClinicGroupQuery, GetWidgetsByClinicGroupQueryVariables>(GetWidgetsByClinicGroupDocument, options);
      }
export function useGetWidgetsByClinicGroupLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<GetWidgetsByClinicGroupQuery, GetWidgetsByClinicGroupQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<GetWidgetsByClinicGroupQuery, GetWidgetsByClinicGroupQueryVariables>(GetWidgetsByClinicGroupDocument, options);
        }
export function useGetWidgetsByClinicGroupSuspenseQuery(baseOptions?: Apollo.SuspenseQueryHookOptions<GetWidgetsByClinicGroupQuery, GetWidgetsByClinicGroupQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useSuspenseQuery<GetWidgetsByClinicGroupQuery, GetWidgetsByClinicGroupQueryVariables>(GetWidgetsByClinicGroupDocument, options);
        }
export type GetWidgetsByClinicGroupQueryHookResult = ReturnType<typeof useGetWidgetsByClinicGroupQuery>;
export type GetWidgetsByClinicGroupLazyQueryHookResult = ReturnType<typeof useGetWidgetsByClinicGroupLazyQuery>;
export type GetWidgetsByClinicGroupSuspenseQueryHookResult = ReturnType<typeof useGetWidgetsByClinicGroupSuspenseQuery>;
export type GetWidgetsByClinicGroupQueryResult = Apollo.QueryResult<GetWidgetsByClinicGroupQuery, GetWidgetsByClinicGroupQueryVariables>;
export const GetAppointmentCountByWidgetSourceDocument = gql`
    query getAppointmentCountByWidgetSource($clinicId: ID!, $widgetSource: String!) {
  getAppointmentCountByWidgetSource(
    clinicId: $clinicId
    widgetSource: $widgetSource
  )
}
    `;

/**
 * __useGetAppointmentCountByWidgetSourceQuery__
 *
 * To run a query within a React component, call `useGetAppointmentCountByWidgetSourceQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetAppointmentCountByWidgetSourceQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetAppointmentCountByWidgetSourceQuery({
 *   variables: {
 *      clinicId: // value for 'clinicId'
 *      widgetSource: // value for 'widgetSource'
 *   },
 * });
 */
export function useGetAppointmentCountByWidgetSourceQuery(baseOptions: Apollo.QueryHookOptions<GetAppointmentCountByWidgetSourceQuery, GetAppointmentCountByWidgetSourceQueryVariables> & ({ variables: GetAppointmentCountByWidgetSourceQueryVariables; skip?: boolean; } | { skip: boolean; }) ) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<GetAppointmentCountByWidgetSourceQuery, GetAppointmentCountByWidgetSourceQueryVariables>(GetAppointmentCountByWidgetSourceDocument, options);
      }
export function useGetAppointmentCountByWidgetSourceLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<GetAppointmentCountByWidgetSourceQuery, GetAppointmentCountByWidgetSourceQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<GetAppointmentCountByWidgetSourceQuery, GetAppointmentCountByWidgetSourceQueryVariables>(GetAppointmentCountByWidgetSourceDocument, options);
        }
export function useGetAppointmentCountByWidgetSourceSuspenseQuery(baseOptions?: Apollo.SuspenseQueryHookOptions<GetAppointmentCountByWidgetSourceQuery, GetAppointmentCountByWidgetSourceQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useSuspenseQuery<GetAppointmentCountByWidgetSourceQuery, GetAppointmentCountByWidgetSourceQueryVariables>(GetAppointmentCountByWidgetSourceDocument, options);
        }
export type GetAppointmentCountByWidgetSourceQueryHookResult = ReturnType<typeof useGetAppointmentCountByWidgetSourceQuery>;
export type GetAppointmentCountByWidgetSourceLazyQueryHookResult = ReturnType<typeof useGetAppointmentCountByWidgetSourceLazyQuery>;
export type GetAppointmentCountByWidgetSourceSuspenseQueryHookResult = ReturnType<typeof useGetAppointmentCountByWidgetSourceSuspenseQuery>;
export type GetAppointmentCountByWidgetSourceQueryResult = Apollo.QueryResult<GetAppointmentCountByWidgetSourceQuery, GetAppointmentCountByWidgetSourceQueryVariables>;
export const GetAppointmentCountByWidgetIdDocument = gql`
    query getAppointmentCountByWidgetId($clinicId: ID!, $widgetId: String!) {
  getAppointmentCountByWidgetId(clinicId: $clinicId, widgetId: $widgetId)
}
    `;

/**
 * __useGetAppointmentCountByWidgetIdQuery__
 *
 * To run a query within a React component, call `useGetAppointmentCountByWidgetIdQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetAppointmentCountByWidgetIdQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetAppointmentCountByWidgetIdQuery({
 *   variables: {
 *      clinicId: // value for 'clinicId'
 *      widgetId: // value for 'widgetId'
 *   },
 * });
 */
export function useGetAppointmentCountByWidgetIdQuery(baseOptions: Apollo.QueryHookOptions<GetAppointmentCountByWidgetIdQuery, GetAppointmentCountByWidgetIdQueryVariables> & ({ variables: GetAppointmentCountByWidgetIdQueryVariables; skip?: boolean; } | { skip: boolean; }) ) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<GetAppointmentCountByWidgetIdQuery, GetAppointmentCountByWidgetIdQueryVariables>(GetAppointmentCountByWidgetIdDocument, options);
      }
export function useGetAppointmentCountByWidgetIdLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<GetAppointmentCountByWidgetIdQuery, GetAppointmentCountByWidgetIdQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<GetAppointmentCountByWidgetIdQuery, GetAppointmentCountByWidgetIdQueryVariables>(GetAppointmentCountByWidgetIdDocument, options);
        }
export function useGetAppointmentCountByWidgetIdSuspenseQuery(baseOptions?: Apollo.SuspenseQueryHookOptions<GetAppointmentCountByWidgetIdQuery, GetAppointmentCountByWidgetIdQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useSuspenseQuery<GetAppointmentCountByWidgetIdQuery, GetAppointmentCountByWidgetIdQueryVariables>(GetAppointmentCountByWidgetIdDocument, options);
        }
export type GetAppointmentCountByWidgetIdQueryHookResult = ReturnType<typeof useGetAppointmentCountByWidgetIdQuery>;
export type GetAppointmentCountByWidgetIdLazyQueryHookResult = ReturnType<typeof useGetAppointmentCountByWidgetIdLazyQuery>;
export type GetAppointmentCountByWidgetIdSuspenseQueryHookResult = ReturnType<typeof useGetAppointmentCountByWidgetIdSuspenseQuery>;
export type GetAppointmentCountByWidgetIdQueryResult = Apollo.QueryResult<GetAppointmentCountByWidgetIdQuery, GetAppointmentCountByWidgetIdQueryVariables>;
export const QueryWidgetsDocument = gql`
    query queryWidgets($where: [QueryInput!], $page: NonNegativeInt, $pageSize: NonNegativeInt, $orderBy: OrderByInput) {
  queryWidgets(where: $where, page: $page, pageSize: $pageSize, orderBy: $orderBy) {
    ...WidgetFields
  }
}
    ${WidgetFieldsFragmentDoc}`;

/**
 * __useQueryWidgetsQuery__
 *
 * To run a query within a React component, call `useQueryWidgetsQuery` and pass it any options that fit your needs.
 * When your component renders, `useQueryWidgetsQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useQueryWidgetsQuery({
 *   variables: {
 *      where: // value for 'where'
 *      page: // value for 'page'
 *      pageSize: // value for 'pageSize'
 *      orderBy: // value for 'orderBy'
 *   },
 * });
 */
export function useQueryWidgetsQuery(baseOptions?: Apollo.QueryHookOptions<QueryWidgetsQuery, QueryWidgetsQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<QueryWidgetsQuery, QueryWidgetsQueryVariables>(QueryWidgetsDocument, options);
      }
export function useQueryWidgetsLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<QueryWidgetsQuery, QueryWidgetsQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<QueryWidgetsQuery, QueryWidgetsQueryVariables>(QueryWidgetsDocument, options);
        }
export function useQueryWidgetsSuspenseQuery(baseOptions?: Apollo.SuspenseQueryHookOptions<QueryWidgetsQuery, QueryWidgetsQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useSuspenseQuery<QueryWidgetsQuery, QueryWidgetsQueryVariables>(QueryWidgetsDocument, options);
        }
export type QueryWidgetsQueryHookResult = ReturnType<typeof useQueryWidgetsQuery>;
export type QueryWidgetsLazyQueryHookResult = ReturnType<typeof useQueryWidgetsLazyQuery>;
export type QueryWidgetsSuspenseQueryHookResult = ReturnType<typeof useQueryWidgetsSuspenseQuery>;
export type QueryWidgetsQueryResult = Apollo.QueryResult<QueryWidgetsQuery, QueryWidgetsQueryVariables>;
export const QueryPreviewWidgetsDocument = gql`
    query queryPreviewWidgets($where: [QueryInput!], $page: NonNegativeInt, $pageSize: NonNegativeInt, $orderBy: OrderByInput) {
  queryWidgets(where: $where, page: $page, pageSize: $pageSize, orderBy: $orderBy) {
    ...WidgetPreviewFields
  }
}
    ${WidgetPreviewFieldsFragmentDoc}`;

/**
 * __useQueryPreviewWidgetsQuery__
 *
 * To run a query within a React component, call `useQueryPreviewWidgetsQuery` and pass it any options that fit your needs.
 * When your component renders, `useQueryPreviewWidgetsQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useQueryPreviewWidgetsQuery({
 *   variables: {
 *      where: // value for 'where'
 *      page: // value for 'page'
 *      pageSize: // value for 'pageSize'
 *      orderBy: // value for 'orderBy'
 *   },
 * });
 */
export function useQueryPreviewWidgetsQuery(baseOptions?: Apollo.QueryHookOptions<QueryPreviewWidgetsQuery, QueryPreviewWidgetsQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<QueryPreviewWidgetsQuery, QueryPreviewWidgetsQueryVariables>(QueryPreviewWidgetsDocument, options);
      }
export function useQueryPreviewWidgetsLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<QueryPreviewWidgetsQuery, QueryPreviewWidgetsQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<QueryPreviewWidgetsQuery, QueryPreviewWidgetsQueryVariables>(QueryPreviewWidgetsDocument, options);
        }
export function useQueryPreviewWidgetsSuspenseQuery(baseOptions?: Apollo.SuspenseQueryHookOptions<QueryPreviewWidgetsQuery, QueryPreviewWidgetsQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useSuspenseQuery<QueryPreviewWidgetsQuery, QueryPreviewWidgetsQueryVariables>(QueryPreviewWidgetsDocument, options);
        }
export type QueryPreviewWidgetsQueryHookResult = ReturnType<typeof useQueryPreviewWidgetsQuery>;
export type QueryPreviewWidgetsLazyQueryHookResult = ReturnType<typeof useQueryPreviewWidgetsLazyQuery>;
export type QueryPreviewWidgetsSuspenseQueryHookResult = ReturnType<typeof useQueryPreviewWidgetsSuspenseQuery>;
export type QueryPreviewWidgetsQueryResult = Apollo.QueryResult<QueryPreviewWidgetsQuery, QueryPreviewWidgetsQueryVariables>;
export const CreateWidgetDocument = gql`
    mutation createWidget($data: CreateWidgetInput!) {
  createWidget(data: $data) {
    ...WidgetFields
  }
}
    ${WidgetFieldsFragmentDoc}`;
export type CreateWidgetMutationFn = Apollo.MutationFunction<CreateWidgetMutation, CreateWidgetMutationVariables>;

/**
 * __useCreateWidgetMutation__
 *
 * To run a mutation, you first call `useCreateWidgetMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useCreateWidgetMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [createWidgetMutation, { data, loading, error }] = useCreateWidgetMutation({
 *   variables: {
 *      data: // value for 'data'
 *   },
 * });
 */
export function useCreateWidgetMutation(baseOptions?: Apollo.MutationHookOptions<CreateWidgetMutation, CreateWidgetMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<CreateWidgetMutation, CreateWidgetMutationVariables>(CreateWidgetDocument, options);
      }
export type CreateWidgetMutationHookResult = ReturnType<typeof useCreateWidgetMutation>;
export type CreateWidgetMutationResult = Apollo.MutationResult<CreateWidgetMutation>;
export type CreateWidgetMutationOptions = Apollo.BaseMutationOptions<CreateWidgetMutation, CreateWidgetMutationVariables>;
export const UpdateWidgetDocument = gql`
    mutation updateWidget($id: ID!, $data: UpdateWidgetInput!) {
  updateWidget(id: $id, data: $data) {
    ...WidgetFields
  }
}
    ${WidgetFieldsFragmentDoc}`;
export type UpdateWidgetMutationFn = Apollo.MutationFunction<UpdateWidgetMutation, UpdateWidgetMutationVariables>;

/**
 * __useUpdateWidgetMutation__
 *
 * To run a mutation, you first call `useUpdateWidgetMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useUpdateWidgetMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [updateWidgetMutation, { data, loading, error }] = useUpdateWidgetMutation({
 *   variables: {
 *      id: // value for 'id'
 *      data: // value for 'data'
 *   },
 * });
 */
export function useUpdateWidgetMutation(baseOptions?: Apollo.MutationHookOptions<UpdateWidgetMutation, UpdateWidgetMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<UpdateWidgetMutation, UpdateWidgetMutationVariables>(UpdateWidgetDocument, options);
      }
export type UpdateWidgetMutationHookResult = ReturnType<typeof useUpdateWidgetMutation>;
export type UpdateWidgetMutationResult = Apollo.MutationResult<UpdateWidgetMutation>;
export type UpdateWidgetMutationOptions = Apollo.BaseMutationOptions<UpdateWidgetMutation, UpdateWidgetMutationVariables>;
export const DeleteWidgetDocument = gql`
    mutation deleteWidget($id: ID!) {
  deleteWidget(id: $id)
}
    `;
export type DeleteWidgetMutationFn = Apollo.MutationFunction<DeleteWidgetMutation, DeleteWidgetMutationVariables>;

/**
 * __useDeleteWidgetMutation__
 *
 * To run a mutation, you first call `useDeleteWidgetMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useDeleteWidgetMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [deleteWidgetMutation, { data, loading, error }] = useDeleteWidgetMutation({
 *   variables: {
 *      id: // value for 'id'
 *   },
 * });
 */
export function useDeleteWidgetMutation(baseOptions?: Apollo.MutationHookOptions<DeleteWidgetMutation, DeleteWidgetMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<DeleteWidgetMutation, DeleteWidgetMutationVariables>(DeleteWidgetDocument, options);
      }
export type DeleteWidgetMutationHookResult = ReturnType<typeof useDeleteWidgetMutation>;
export type DeleteWidgetMutationResult = Apollo.MutationResult<DeleteWidgetMutation>;
export type DeleteWidgetMutationOptions = Apollo.BaseMutationOptions<DeleteWidgetMutation, DeleteWidgetMutationVariables>;
export const namedOperations = {
  Query: {
    getActionItem: 'getActionItem',
    queryActionItems: 'queryActionItems',
    countActionItems: 'countActionItems',
    queryAppointmentActionItems: 'queryAppointmentActionItems',
    queryRescheduleActionItems: 'queryRescheduleActionItems',
    listAiVoiceOptions: 'listAiVoiceOptions',
    getAiAgentPromptForClinic: 'getAiAgentPromptForClinic',
    getAiPromptSuggestionsForClinic: 'getAiPromptSuggestionsForClinic',
    getAppointmentPrompt: 'getAppointmentPrompt',
    queryAppointmentPrompts: 'queryAppointmentPrompts',
    getPublicAppointmentTimes: 'getPublicAppointmentTimes',
    getAppointment: 'getAppointment',
    searchAppointments: 'searchAppointments',
    queryAppointments: 'queryAppointments',
    queryAppointmentSchedule: 'queryAppointmentSchedule',
    queryClinicAppointments: 'queryClinicAppointments',
    countAppointments: 'countAppointments',
    searchAppointmentsStatus: 'searchAppointmentsStatus',
    getNewAppointmentsForClinic: 'getNewAppointmentsForClinic',
    getAppointmentsByClinicAndRange: 'getAppointmentsByClinicAndRange',
    getTimeSlotsForClinicForDay: 'getTimeSlotsForClinicForDay',
    getTimeSlotsForSchedulingDays: 'getTimeSlotsForSchedulingDays',
    getAppointmentsCountByClinic: 'getAppointmentsCountByClinic',
    queryClinicGroupAppointments: 'queryClinicGroupAppointments',
    queryAppointmentsForCsvExport: 'queryAppointmentsForCsvExport',
    getBillableUsageStatsByType: 'getBillableUsageStatsByType',
    getBookingFlowFunnel: 'getBookingFlowFunnel',
    getBookingSourceAnalytics: 'getBookingSourceAnalytics',
    getClinicBookingSourceAnalytics: 'getClinicBookingSourceAnalytics',
    getBookingAttributionAnalytics: 'getBookingAttributionAnalytics',
    getClinicBookingAttributionAnalytics: 'getClinicBookingAttributionAnalytics',
    getBreedsByClinic: 'getBreedsByClinic',
    queryBreeds: 'queryBreeds',
    queryClinicCalls: 'queryClinicCalls',
    countCalls: 'countCalls',
    clinicCallStats: 'clinicCallStats',
    campaignStats: 'campaignStats',
    getCampaignWidgetStats: 'getCampaignWidgetStats',
    getCampaignNotificationStats: 'getCampaignNotificationStats',
    getCampaignBulkMessageStats: 'getCampaignBulkMessageStats',
    getCampaign: 'getCampaign',
    queryCampaigns: 'queryCampaigns',
    countCampaigns: 'countCampaigns',
    getChangeLogsByEntityId: 'getChangeLogsByEntityId',
    chatStatuses: 'chatStatuses',
    getChat: 'getChat',
    getChatsByClientId: 'getChatsByClientId',
    getChatsByClinicId: 'getChatsByClinicId',
    queryChats: 'queryChats',
    queryChatPreviews: 'queryChatPreviews',
    queryClinicChats: 'queryClinicChats',
    queryClinicChatPreviews: 'queryClinicChatPreviews',
    countChats: 'countChats',
    getChatByClientAndClinic: 'getChatByClientAndClinic',
    getChatIdByClientAndClinic: 'getChatIdByClientAndClinic',
    getCheckIn: 'getCheckIn',
    getCheckInsByUser: 'getCheckInsByUser',
    getCheckInsByClinic: 'getCheckInsByClinic',
    clientForm: 'clientForm',
    queryClientForms: 'queryClientForms',
    countClientForms: 'countClientForms',
    getPdfUrlForClientForm: 'getPdfUrlForClientForm',
    getClient: 'getClient',
    getClientNotes: 'getClientNotes',
    getClients: 'getClients',
    checkExistingClients: 'checkExistingClients',
    checkExistingClient: 'checkExistingClient',
    getMaybeClients: 'getMaybeClients',
    getClientsWithNegativeBalancesForClinic: 'getClientsWithNegativeBalancesForClinic',
    getClientsWithoutApptOverDaysForClinic: 'getClientsWithoutApptOverDaysForClinic',
    getOutstandingBalanceForClinic: 'getOutstandingBalanceForClinic',
    getNewClientsForClinic: 'getNewClientsForClinic',
    queryClients: 'queryClients',
    queryClinicClients: 'queryClinicClients',
    queryClientsPatients: 'queryClientsPatients',
    countClinicClients: 'countClinicClients',
    countClients: 'countClients',
    getClientAISummary: 'getClientAISummary',
    getClinicAdminById: 'getClinicAdminById',
    getClinicAdmin: 'getClinicAdmin',
    getClinicAdminsByClinic: 'getClinicAdminsByClinic',
    getClinicAdminsAssigneeOptions: 'getClinicAdminsAssigneeOptions',
    getClinicAdminsByUser: 'getClinicAdminsByUser',
    getClinicAdminsForLogin: 'getClinicAdminsForLogin',
    queryClinicAdmins: 'queryClinicAdmins',
    queryAllClinicAdmins: 'queryAllClinicAdmins',
    countAllClinicAdmins: 'countAllClinicAdmins',
    countClinicAdmins: 'countClinicAdmins',
    queryClinicAdminClinics: 'queryClinicAdminClinics',
    countClinicAdminClinics: 'countClinicAdminClinics',
    getClinicAccessForUser: 'getClinicAccessForUser',
    clinicAgentEnabled: 'clinicAgentEnabled',
    myClinicAgentConversations: 'myClinicAgentConversations',
    clinicAgentConversation: 'clinicAgentConversation',
    clinicAgentRunStatus: 'clinicAgentRunStatus',
    getYesterdayAnalytics: 'getYesterdayAnalytics',
    getTodayAnalytics: 'getTodayAnalytics',
    getTomorrowAnalytics: 'getTomorrowAnalytics',
    getRevenueByMonthsForClinic: 'getRevenueByMonthsForClinic',
    getClinicApptStatusesByClinic: 'getClinicApptStatusesByClinic',
    queryClinicApptStatuses: 'queryClinicApptStatuses',
    countClinicApptStatuses: 'countClinicApptStatuses',
    getClinicGroup: 'getClinicGroup',
    getClinicGroupUsers: 'getClinicGroupUsers',
    getClinicGroupUser: 'getClinicGroupUser',
    getClinicGroupUserByGroupAndUser: 'getClinicGroupUserByGroupAndUser',
    queryClinicGroupUsers: 'queryClinicGroupUsers',
    countClinicGroupUsers: 'countClinicGroupUsers',
    queryClinicGroupClinics: 'queryClinicGroupClinics',
    countClinicGroupClinics: 'countClinicGroupClinics',
    getClinicGroupsForUser: 'getClinicGroupsForUser',
    queryClinicGroupsForUser: 'queryClinicGroupsForUser',
    countClinicGroupsForUser: 'countClinicGroupsForUser',
    countClinicGroups: 'countClinicGroups',
    queryClinicGroups: 'queryClinicGroups',
    queryClinicSexes: 'queryClinicSexes',
    countClinicSexes: 'countClinicSexes',
    getClinicSpeciesByClinic: 'getClinicSpeciesByClinic',
    queryClinicSpecies: 'queryClinicSpecies',
    getRevenueForTimeRange: 'getRevenueForTimeRange',
    getRevenuesByTypeForTimeRange: 'getRevenuesByTypeForTimeRange',
    getRevenuesByClinicianForTimeRange: 'getRevenuesByClinicianForTimeRange',
    getAccountsReceivable: 'getAccountsReceivable',
    getClinicianServicesByService: 'getClinicianServicesByService',
    getClinician: 'getClinician',
    getCliniciansByClinic: 'getCliniciansByClinic',
    queryClinicians: 'queryClinicians',
    queryPreviewClinicians: 'queryPreviewClinicians',
    countClinicians: 'countClinicians',
    getOnDemandCliniciansForClinic: 'getOnDemandCliniciansForClinic',
    getClinicUsageStats: 'getClinicUsageStats',
    getClinicsWithConcerns: 'getClinicsWithConcerns',
    getClinic: 'getClinic',
    getSupportedPmsConnectors: 'getSupportedPmsConnectors',
    getClientsForClinic: 'getClientsForClinic',
    getClientCountForClinic: 'getClientCountForClinic',
    getClinicsForUserAdmin: 'getClinicsForUserAdmin',
    countClinicsForUserAdmin: 'countClinicsForUserAdmin',
    queryClinics: 'queryClinics',
    countClinics: 'countClinics',
    clinicStats: 'clinicStats',
    getTotalRevenueForClinicBetweenTimes: 'getTotalRevenueForClinicBetweenTimes',
    getClinicOnboarding: 'getClinicOnboarding',
    getOnboardingWizardProgress: 'getOnboardingWizardProgress',
    getConnectInstallation: 'getConnectInstallation',
    getConnectInstallationsByClinic: 'getConnectInstallationsByClinic',
    checkIfServerRunning: 'checkIfServerRunning',
    getLastServerHeartbeatForClinic: 'getLastServerHeartbeatForClinic',
    customRole: 'customRole',
    getCustomRolesByClinic: 'getCustomRolesByClinic',
    getCustomRolesByClinicGroup: 'getCustomRolesByClinicGroup',
    customerSegment: 'customerSegment',
    getCustomerSegmentsForClinic: 'getCustomerSegmentsForClinic',
    queryCustomerSegments: 'queryCustomerSegments',
    getClientsByCustomerSegmentRPC: 'getClientsByCustomerSegmentRPC',
    getDailyHuddle: 'getDailyHuddle',
    getDailyHuddlesByClinic: 'getDailyHuddlesByClinic',
    getDataChat: 'getDataChat',
    queryClinicDataChats: 'queryClinicDataChats',
    queryDiagnoses: 'queryDiagnoses',
    getEmailTemplate: 'getEmailTemplate',
    getEmailTemplatesForClinic: 'getEmailTemplatesForClinic',
    queryClinicEmailTemplates: 'queryClinicEmailTemplates',
    countClinicEmailTemplates: 'countClinicEmailTemplates',
    queryClinicGroupEmailTemplates: 'queryClinicGroupEmailTemplates',
    countClinicGroupEmailTemplates: 'countClinicGroupEmailTemplates',
    getEnterpriseOnboardingReport: 'getEnterpriseOnboardingReport',
    getEnterpriseOnboardingEntities: 'getEnterpriseOnboardingEntities',
    getEnterpriseOnboardingSetupEntities: 'getEnterpriseOnboardingSetupEntities',
    getClinicGroupExpectedMergeTags: 'getClinicGroupExpectedMergeTags',
    getClinicGroupMergeTagEditor: 'getClinicGroupMergeTagEditor',
    countDrilldownEntities: 'countDrilldownEntities',
    getDrilldownEntities: 'getDrilldownEntities',
    queryEntityReports: 'queryEntityReports',
    queryInitiatives: 'queryInitiatives',
    getInitiative: 'getInitiative',
    computeInitiativeValues: 'computeInitiativeValues',
    getKpiGroup: 'getKpiGroup',
    queryKpiGroups: 'queryKpiGroups',
    countKpiGroups: 'countKpiGroups',
    computeKpiGroupValues: 'computeKpiGroupValues',
    calculateClinicValuesForKpiGroupMetric: 'calculateClinicValuesForKpiGroupMetric',
    getOrganizationReport: 'getOrganizationReport',
    getRealTimeReport: 'getRealTimeReport',
    queryOrganizationReports: 'queryOrganizationReports',
    queryOrganizationReportPreviews: 'queryOrganizationReportPreviews',
    getReportMetric: 'getReportMetric',
    queryReportMetrics: 'queryReportMetrics',
    countReportMetrics: 'countReportMetrics',
    getReportTemplate: 'getReportTemplate',
    queryReportTemplates: 'queryReportTemplates',
    computeReportTemplateValues: 'computeReportTemplateValues',
    getTemplatesForClinicReports: 'getTemplatesForClinicReports',
    getTrendReport: 'getTrendReport',
    getTrendClinicItem: 'getTrendClinicItem',
    entityLinksForParent: 'entityLinksForParent',
    entityLinkSummary: 'entityLinkSummary',
    entityLinkForChild: 'entityLinkForChild',
    entityLinkFieldsChangedByUpdate: 'entityLinkFieldsChangedByUpdate',
    entityLinksForClinic: 'entityLinksForClinic',
    entityLinkFieldPolicies: 'entityLinkFieldPolicies',
    clinicSettingsFieldValuesForClinicGroup: 'clinicSettingsFieldValuesForClinicGroup',
    entityLinkCoverageForClinicGroup: 'entityLinkCoverageForClinicGroup',
    entityLinkCoverageDetailsForClinic: 'entityLinkCoverageDetailsForClinic',
    getForm: 'getForm',
    queryForms: 'queryForms',
    countForms: 'countForms',
    getPdfUrlForForm: 'getPdfUrlForForm',
    getFormsForClinic: 'getFormsForClinic',
    getAnalyticsForForms: 'getAnalyticsForForms',
    getGoalByClinicAndId: 'getGoalByClinicAndId',
    getGoalsByClinic: 'getGoalsByClinic',
    internalChatMessages: 'internalChatMessages',
    internalChatUsers: 'internalChatUsers',
    queryInternalChatUsers: 'queryInternalChatUsers',
    countInternalChatUsers: 'countInternalChatUsers',
    internalChat: 'internalChat',
    getInternalUsageEvents: 'getInternalUsageEvents',
    countInternalUsageEvents: 'countInternalUsageEvents',
    clinicForInternalUsageEvent: 'clinicForInternalUsageEvent',
    userForInternalUsageEvent: 'userForInternalUsageEvent',
    queryInvoices: 'queryInvoices',
    countInvoices: 'countInvoices',
    getAppointmentInvoiceTotals: 'getAppointmentInvoiceTotals',
    getInvoice: 'getInvoice',
    getLoyaltyRewardsForClinic: 'getLoyaltyRewardsForClinic',
    getLoyaltyMemberFromClient: 'getLoyaltyMemberFromClient',
    getLoyaltyMember: 'getLoyaltyMember',
    getLoyaltyReward: 'getLoyaltyReward',
    queryLoyaltyRedemptions: 'queryLoyaltyRedemptions',
    countLoyaltyRedemptions: 'countLoyaltyRedemptions',
    queryLoyaltyEarnings: 'queryLoyaltyEarnings',
    countLoyaltyEarnings: 'countLoyaltyEarnings',
    getMarketingSummaryStats: 'getMarketingSummaryStats',
    getOrganizationCampaignStats: 'getOrganizationCampaignStats',
    getOrganizationNotificationStats: 'getOrganizationNotificationStats',
    getOrganizationBulkMessageStats: 'getOrganizationBulkMessageStats',
    getReminderAttributedAppointmentIds: 'getReminderAttributedAppointmentIds',
    getMessageTemplate: 'getMessageTemplate',
    queryClinicMessageTemplates: 'queryClinicMessageTemplates',
    countClinicMessageTemplates: 'countClinicMessageTemplates',
    queryClinicGroupMessageTemplates: 'queryClinicGroupMessageTemplates',
    countClinicGroupMessageTemplates: 'countClinicGroupMessageTemplates',
    getMessagesByChatId: 'getMessagesByChatId',
    getChatMessagesByChatId: 'getChatMessagesByChatId',
    queryMessages: 'queryMessages',
    queryClinicMessages: 'queryClinicMessages',
    queryClinicNotificationLogMessages: 'queryClinicNotificationLogMessages',
    countMessages: 'countMessages',
    suggestChatResponse: 'suggestChatResponse',
    queryMsgTrackingEvents: 'queryMsgTrackingEvents',
    countMsgTrackingEvents: 'countMsgTrackingEvents',
    getClinicGroupNotificationAnalytics: 'getClinicGroupNotificationAnalytics',
    getClinicNotificationAnalytics: 'getClinicNotificationAnalytics',
    getClinicGroupMedicalReminderFunnel: 'getClinicGroupMedicalReminderFunnel',
    getClinicMedicalReminderFunnel: 'getClinicMedicalReminderFunnel',
    notificationTemplate: 'notificationTemplate',
    getNotificationTemplatesByClinicId: 'getNotificationTemplatesByClinicId',
    queryNotificationTemplates: 'queryNotificationTemplates',
    countNotificationTemplates: 'countNotificationTemplates',
    getNotificationTemplateStats: 'getNotificationTemplateStats',
    notificationMessagesByReferencePeriod: 'notificationMessagesByReferencePeriod',
    queryMyUserNotifications: 'queryMyUserNotifications',
    countMyUnreadUserNotifications: 'countMyUnreadUserNotifications',
    getOrganizationAnalytics: 'getOrganizationAnalytics',
    getOrganizationAnalyticsNumbers: 'getOrganizationAnalyticsNumbers',
    getOrganizationScheduleEfficiency: 'getOrganizationScheduleEfficiency',
    getOrganizationAnalyticsNumbersByMonths: 'getOrganizationAnalyticsNumbersByMonths',
    getOrganizationRevenueByMonths: 'getOrganizationRevenueByMonths',
    getOrganization: 'getOrganization',
    queryOrganizations: 'queryOrganizations',
    countOrganizations: 'countOrganizations',
    getPatient: 'getPatient',
    getPatientName: 'getPatientName',
    getPatientsByClient: 'getPatientsByClient',
    getPatientsByClients: 'getPatientsByClients',
    getPatientsWithoutRescheduledAppointmentsForTimeRange: 'getPatientsWithoutRescheduledAppointmentsForTimeRange',
    queryPatients: 'queryPatients',
    countPatients: 'countPatients',
    queryPatientsOwners: 'queryPatientsOwners',
    queryClinicPatients: 'queryClinicPatients',
    getOverduePatients: 'getOverduePatients',
    countOverduePatients: 'countOverduePatients',
    getPayment: 'getPayment',
    getPaymentsByClinicId: 'getPaymentsByClinicId',
    queryPayments: 'queryPayments',
    countPayments: 'countPayments',
    getPatientRecord: 'getPatientRecord',
    queryPetSelfies: 'queryPetSelfies',
    countPetSelfies: 'countPetSelfies',
    petSelfie: 'petSelfie',
    lookupPimsClients: 'lookupPimsClients',
    queryPimsReminderTypes: 'queryPimsReminderTypes',
    countPimsReminderTypes: 'countPimsReminderTypes',
    getPimsRemindersByPatient: 'getPimsRemindersByPatient',
    countPimsRemindersByPatient: 'countPimsRemindersByPatient',
    queryDistinctPimsReminderTypeNames: 'queryDistinctPimsReminderTypeNames',
    searchPimsReminderTypesForClinic: 'searchPimsReminderTypesForClinic',
    queryPimsReminders: 'queryPimsReminders',
    getActivePimsRemindersByPatients: 'getActivePimsRemindersByPatients',
    countPimsReminders: 'countPimsReminders',
    queryComplianceReminders: 'queryComplianceReminders',
    complianceStatusActivity: 'complianceStatusActivity',
    getPimsSettings: 'getPimsSettings',
    getOnDemandPaymentTypesForClinic: 'getOnDemandPaymentTypesForClinic',
    getPmsApptType: 'getPmsApptType',
    getPmsApptTypesForClinic: 'getPmsApptTypesForClinic',
    queryPmsApptTypes: 'queryPmsApptTypes',
    queryPmsApptTypesWithClinic: 'queryPmsApptTypesWithClinic',
    getSyncedCloudPmsDbs: 'getSyncedCloudPmsDbs',
    queryPmsDbs: 'queryPmsDbs',
    countPmsDbs: 'countPmsDbs',
    getPmsDb: 'getPmsDb',
    getPmsTag: 'getPmsTag',
    queryPmsTags: 'queryPmsTags',
    countPmsTags: 'countPmsTags',
    queryPmsTagCategories: 'queryPmsTagCategories',
    countPmsTagCategories: 'countPmsTagCategories',
    queryPrescriptionRefillRequests: 'queryPrescriptionRefillRequests',
    countPrescriptionRefillRequests: 'countPrescriptionRefillRequests',
    queryPrescriptions: 'queryPrescriptions',
    countPrescriptions: 'countPrescriptions',
    getPressItem: 'getPressItem',
    getPrescriptionPricing: 'getPrescriptionPricing',
    queryProducts: 'queryProducts',
    countProducts: 'countProducts',
    searchClinicProducts: 'searchClinicProducts',
    getPmsCodesForClinic: 'getPmsCodesForClinic',
    queryReschedules: 'queryReschedules',
    getReviewsForClinic: 'getReviewsForClinic',
    queryReviews: 'queryReviews',
    getAverageRatingForRecentReviews: 'getAverageRatingForRecentReviews',
    getAverageRatingForRecentReviewsForClinics: 'getAverageRatingForRecentReviewsForClinics',
    countReviews: 'countReviews',
    reviewAnalytics: 'reviewAnalytics',
    getRoomServicesByService: 'getRoomServicesByService',
    getRoom: 'getRoom',
    queryRooms: 'queryRooms',
    queryPreviewRooms: 'queryPreviewRooms',
    countRooms: 'countRooms',
    getRoomsForClinic: 'getRoomsForClinic',
    scheduledBulkMessage: 'scheduledBulkMessage',
    getScheduledBulkMessagesByClinicId: 'getScheduledBulkMessagesByClinicId',
    queryScheduledBulkMessages: 'queryScheduledBulkMessages',
    countScheduledBulkMessages: 'countScheduledBulkMessages',
    getScheduledBulkMessageStats: 'getScheduledBulkMessageStats',
    bulkMessageAudienceEstimate: 'bulkMessageAudienceEstimate',
    linkedScheduledBulkMessageChildren: 'linkedScheduledBulkMessageChildren',
    queryScheduledMessages: 'queryScheduledMessages',
    countScheduledMessages: 'countScheduledMessages',
    getSchedulingRulesCategorized: 'getSchedulingRulesCategorized',
    schedulingRule: 'schedulingRule',
    getSchedulingRulesForClinic: 'getSchedulingRulesForClinic',
    querySchedulingRules: 'querySchedulingRules',
    countSchedulingRules: 'countSchedulingRules',
    countSchedulingRulesForClinic: 'countSchedulingRulesForClinic',
    getSchedulingRulesForWidget: 'getSchedulingRulesForWidget',
    serviceCategory: 'serviceCategory',
    serviceCategories: 'serviceCategories',
    getServiceForm: 'getServiceForm',
    queryServiceForms: 'queryServiceForms',
    countServiceForms: 'countServiceForms',
    getAllServicesByClinicId: 'getAllServicesByClinicId',
    queryServices: 'queryServices',
    queryPreviewServices: 'queryPreviewServices',
    countServices: 'countServices',
    getService: 'getService',
    paymentIntentFromService: 'paymentIntentFromService',
    stripeAccountInfo: 'stripeAccountInfo',
    mySupportBotConversations: 'mySupportBotConversations',
    supportBotConversations: 'supportBotConversations',
    supportBotConversationOwners: 'supportBotConversationOwners',
    supportBotConversation: 'supportBotConversation',
    supportBotRunStatus: 'supportBotRunStatus',
    getFillRateForTimeRange: 'getFillRateForTimeRange',
    getFillRateForClinicianTimeRange: 'getFillRateForClinicianTimeRange',
    getTransactionsByClinicAndRange: 'getTransactionsByClinicAndRange',
    getUserTrackingSummary: 'getUserTrackingSummary',
    getUserTrackingClients: 'getUserTrackingClients',
    getUser: 'getUser',
    generateIntercomJwt: 'generateIntercomJwt',
    searchUsers: 'searchUsers',
    queryUsers: 'queryUsers',
    countUsers: 'countUsers',
    checkForUserByEmail: 'checkForUserByEmail',
    checkUserDesktopNotificationToken: 'checkUserDesktopNotificationToken',
    queryPatientVaccinationRecords: 'queryPatientVaccinationRecords',
    countPatientVaccinationRecords: 'countPatientVaccinationRecords',
    widgetOptionsByWidget: 'widgetOptionsByWidget',
    widgetService: 'widgetService',
    widgetServicesForWidget: 'widgetServicesForWidget',
    getWidget: 'getWidget',
    ensureDefaultPortalWidget: 'ensureDefaultPortalWidget',
    getWidgetWithServices: 'getWidgetWithServices',
    getWidgetsByClinic: 'getWidgetsByClinic',
    getWidgetsByOrganization: 'getWidgetsByOrganization',
    getWidgetsByClinicGroup: 'getWidgetsByClinicGroup',
    getAppointmentCountByWidgetSource: 'getAppointmentCountByWidgetSource',
    getAppointmentCountByWidgetId: 'getAppointmentCountByWidgetId',
    queryWidgets: 'queryWidgets',
    queryPreviewWidgets: 'queryPreviewWidgets'
  },
  Mutation: {
    updateActionItem: 'updateActionItem',
    updateAiAgentPlaybookForClinic: 'updateAiAgentPlaybookForClinic',
    suggestAiAgentPlaybookEdit: 'suggestAiAgentPlaybookEdit',
    previewAiImprovementItem: 'previewAiImprovementItem',
    applyAiImprovementItem: 'applyAiImprovementItem',
    dismissAiImprovementItem: 'dismissAiImprovementItem',
    addAiAgentInstructionForClinic: 'addAiAgentInstructionForClinic',
    initializeAiAgentForClinic: 'initializeAiAgentForClinic',
    createAnimal: 'createAnimal',
    updateAnimal: 'updateAnimal',
    deleteAnimal: 'deleteAnimal',
    createAppointmentPrompt: 'createAppointmentPrompt',
    sendAppointmentPrompt: 'sendAppointmentPrompt',
    updateAppointmentPrompt: 'updateAppointmentPrompt',
    createAppointment: 'createAppointment',
    updateAppointment: 'updateAppointment',
    markAppointmentAsResolved: 'markAppointmentAsResolved',
    confirmAppointment: 'confirmAppointment',
    updateAppointmentClientPatient: 'updateAppointmentClientPatient',
    clientConfirmAppointment: 'clientConfirmAppointment',
    deleteAppointment: 'deleteAppointment',
    denyPendingAppointment: 'denyPendingAppointment',
    requestChangeForPendingAppointment: 'requestChangeForPendingAppointment',
    updateCall: 'updateCall',
    createCampaign: 'createCampaign',
    updateCampaign: 'updateCampaign',
    updateCampaignFeaturedStats: 'updateCampaignFeaturedStats',
    updateCampaignWidgetFeaturedStats: 'updateCampaignWidgetFeaturedStats',
    updateCampaignNotificationFeaturedStats: 'updateCampaignNotificationFeaturedStats',
    updateCampaignScheduledBulkMessageFeaturedStats: 'updateCampaignScheduledBulkMessageFeaturedStats',
    createChatStatus: 'createChatStatus',
    updateChatStatus: 'updateChatStatus',
    deleteChatStatus: 'deleteChatStatus',
    createChat: 'createChat',
    createChatWithNonClient: 'createChatWithNonClient',
    updateChat: 'updateChat',
    uploadAttachment: 'uploadAttachment',
    writebackChat: 'writebackChat',
    mergeChat: 'mergeChat',
    createCheckIn: 'createCheckIn',
    updateCheckIn: 'updateCheckIn',
    createClientForm: 'createClientForm',
    updateClientForm: 'updateClientForm',
    assignClientFormToClient: 'assignClientFormToClient',
    assignClientFormToPatient: 'assignClientFormToPatient',
    writebackClientForm: 'writebackClientForm',
    createClient: 'createClient',
    updateClient: 'updateClient',
    deleteClient: 'deleteClient',
    addClinicToClient: 'addClinicToClient',
    makeClientPhonePrimary: 'makeClientPhonePrimary',
    syncIndividualClient: 'syncIndividualClient',
    createClinicAdmin: 'createClinicAdmin',
    updateClinicAdmin: 'updateClinicAdmin',
    deleteClinicAdmin: 'deleteClinicAdmin',
    addUserToClinicsAndClinicGroups: 'addUserToClinicsAndClinicGroups',
    mintClinicAgentSession: 'mintClinicAgentSession',
    sendClinicAgentMessage: 'sendClinicAgentMessage',
    reassignClinicApptStatus: 'reassignClinicApptStatus',
    makePrimaryClinicApptStatus: 'makePrimaryClinicApptStatus',
    updateClinicApptStatus: 'updateClinicApptStatus',
    createClinicGroup: 'createClinicGroup',
    updateClinicGroup: 'updateClinicGroup',
    updateClinicGroupSettings: 'updateClinicGroupSettings',
    createClinicGroupClinic: 'createClinicGroupClinic',
    deleteClinicGroupClinic: 'deleteClinicGroupClinic',
    createClinicGroupUser: 'createClinicGroupUser',
    updateClinicGroupUser: 'updateClinicGroupUser',
    deleteClinicGroupUser: 'deleteClinicGroupUser',
    updateClinicSex: 'updateClinicSex',
    makePrimaryClinicSpecies: 'makePrimaryClinicSpecies',
    updateClinicSpecies: 'updateClinicSpecies',
    createClinicianService: 'createClinicianService',
    updateClinicianService: 'updateClinicianService',
    deleteClinicianService: 'deleteClinicianService',
    createClinician: 'createClinician',
    updateClinician: 'updateClinician',
    deleteClinician: 'deleteClinician',
    saveOnboardingWizardProgress: 'saveOnboardingWizardProgress',
    createClinic: 'createClinic',
    setClinicGoLiveDate: 'setClinicGoLiveDate',
    updateClinic: 'updateClinic',
    deleteClinic: 'deleteClinic',
    triggerServiceUpdate: 'triggerServiceUpdate',
    createConnectInstallation: 'createConnectInstallation',
    updateConnectInstallation: 'updateConnectInstallation',
    deleteConnectInstallation: 'deleteConnectInstallation',
    createCustomRole: 'createCustomRole',
    updateCustomRole: 'updateCustomRole',
    deleteCustomRole: 'deleteCustomRole',
    createCustomerSegment: 'createCustomerSegment',
    updateCustomerSegment: 'updateCustomerSegment',
    archiveCustomerSegment: 'archiveCustomerSegment',
    deleteCustomerSegment: 'deleteCustomerSegment',
    copyCustomerSegmentAcrossClinic: 'copyCustomerSegmentAcrossClinic',
    createDailyHuddle: 'createDailyHuddle',
    updateDailyHuddle: 'updateDailyHuddle',
    createDataChat: 'createDataChat',
    updateDataChat: 'updateDataChat',
    sendDataChatPrompt: 'sendDataChatPrompt',
    emailCustomerSegmentCsv: 'emailCustomerSegmentCsv',
    createEmailTemplate: 'createEmailTemplate',
    duplicateEmailTemplate: 'duplicateEmailTemplate',
    updateEmailTemplate: 'updateEmailTemplate',
    deleteEmailTemplate: 'deleteEmailTemplate',
    sendTestEmail: 'sendTestEmail',
    copyEmailTemplateAcrossClinic: 'copyEmailTemplateAcrossClinic',
    updateClinicGroupOnboardingSteps: 'updateClinicGroupOnboardingSteps',
    updateClinicGroupOnboardingTranches: 'updateClinicGroupOnboardingTranches',
    setClinicGroupTrancheComplete: 'setClinicGroupTrancheComplete',
    updateClinicCustomMergeTags: 'updateClinicCustomMergeTags',
    updateClinicGroupExpectedMergeTags: 'updateClinicGroupExpectedMergeTags',
    setClinicGroupOnboardingCellNote: 'setClinicGroupOnboardingCellNote',
    clearClinicGroupOnboardingCellNote: 'clearClinicGroupOnboardingCellNote',
    setClinicGroupOnboardingColumnsHidden: 'setClinicGroupOnboardingColumnsHidden',
    setClinicGroupOnboardingColumnsScored: 'setClinicGroupOnboardingColumnsScored',
    setClinicGroupOnboardingColumnCriterion: 'setClinicGroupOnboardingColumnCriterion',
    setClinicGroupOnboardingStepStatus: 'setClinicGroupOnboardingStepStatus',
    setClinicGroupOnboardingGoLiveDate: 'setClinicGroupOnboardingGoLiveDate',
    createInitiative: 'createInitiative',
    updateInitiative: 'updateInitiative',
    createKpiGroup: 'createKpiGroup',
    updateKpiGroup: 'updateKpiGroup',
    updateKpiGroupMetric: 'updateKpiGroupMetric',
    createReportClinic: 'createReportClinic',
    deleteReportClinic: 'deleteReportClinic',
    createReportMetric: 'createReportMetric',
    updateReportMetric: 'updateReportMetric',
    createReportTemplate: 'createReportTemplate',
    updateReportTemplate: 'updateReportTemplate',
    createTemplateClinic: 'createTemplateClinic',
    deleteTemplateClinic: 'deleteTemplateClinic',
    unlinkEntity: 'unlinkEntity',
    relinkEntity: 'relinkEntity',
    unlinkEntityFields: 'unlinkEntityFields',
    relinkEntityFields: 'relinkEntityFields',
    populateEntityLinkChildren: 'populateEntityLinkChildren',
    expandEntityLinkFieldsForClinics: 'expandEntityLinkFieldsForClinics',
    unlinkEntityFieldsForClinics: 'unlinkEntityFieldsForClinics',
    initializeEntityLinksForClinic: 'initializeEntityLinksForClinic',
    initializeEntityLinksForEntityType: 'initializeEntityLinksForEntityType',
    createForm: 'createForm',
    updateForm: 'updateForm',
    convertPdfToFormElements: 'convertPdfToFormElements',
    createGoal: 'createGoal',
    updateGoal: 'updateGoal',
    deleteGoal: 'deleteGoal',
    createInternalChatMessage: 'createInternalChatMessage',
    updateInternalChatMessage: 'updateInternalChatMessage',
    deleteInternalChatMessage: 'deleteInternalChatMessage',
    createInternalChatUser: 'createInternalChatUser',
    updateInternalChatUser: 'updateInternalChatUser',
    updateInternalChatUserLastRead: 'updateInternalChatUserLastRead',
    deleteInternalChatUser: 'deleteInternalChatUser',
    createInternalChat: 'createInternalChat',
    updateInternalChat: 'updateInternalChat',
    deleteInternalChat: 'deleteInternalChat',
    createInternalUsageEvent: 'createInternalUsageEvent',
    createLoyaltyReward: 'createLoyaltyReward',
    updateLoyaltyReward: 'updateLoyaltyReward',
    deleteLoyaltyReward: 'deleteLoyaltyReward',
    createLoyaltyMember: 'createLoyaltyMember',
    updateLoyaltyMember: 'updateLoyaltyMember',
    addPointsToLoyaltyMember: 'addPointsToLoyaltyMember',
    createLoyaltyRedemption: 'createLoyaltyRedemption',
    approveRedemptionRequest: 'approveRedemptionRequest',
    cancelRedemptionRequest: 'cancelRedemptionRequest',
    createMessageTemplate: 'createMessageTemplate',
    updateMessageTemplate: 'updateMessageTemplate',
    deleteMessageTemplate: 'deleteMessageTemplate',
    createMessage: 'createMessage',
    updateMessage: 'updateMessage',
    deleteMessage: 'deleteMessage',
    createNotificationTemplate: 'createNotificationTemplate',
    updateNotificationTemplate: 'updateNotificationTemplate',
    bulkUpdateNotificationTemplates: 'bulkUpdateNotificationTemplates',
    archiveNotificationTemplate: 'archiveNotificationTemplate',
    deleteNotificationTemplate: 'deleteNotificationTemplate',
    copyNotificationTemplateAcrossClinic: 'copyNotificationTemplateAcrossClinic',
    markUserNotificationAsRead: 'markUserNotificationAsRead',
    markAllMyUserNotificationsAsRead: 'markAllMyUserNotificationsAsRead',
    markMyUserNotificationsAsSeen: 'markMyUserNotificationsAsSeen',
    deleteUserNotification: 'deleteUserNotification',
    createOrganization: 'createOrganization',
    updateOrganization: 'updateOrganization',
    deleteOrganization: 'deleteOrganization',
    createPatient: 'createPatient',
    updatePatient: 'updatePatient',
    deletePatient: 'deletePatient',
    syncIndividualPatient: 'syncIndividualPatient',
    togglePaymentIsEntered: 'togglePaymentIsEntered',
    refundPayment: 'refundPayment',
    updatePayment: 'updatePayment',
    sendPaymentReceipt: 'sendPaymentReceipt',
    createPaymentLink: 'createPaymentLink',
    updatePetSelfie: 'updatePetSelfie',
    markPetSelfieViewed: 'markPetSelfieViewed',
    syncPimsClientByPmsId: 'syncPimsClientByPmsId',
    updatePimsReminderType: 'updatePimsReminderType',
    syncPimsRemindersForPatient: 'syncPimsRemindersForPatient',
    createPimsSettings: 'createPimsSettings',
    updatePimsSettings: 'updatePimsSettings',
    createPmsDb: 'createPmsDb',
    approvePrescriptionRefillRequest: 'approvePrescriptionRefillRequest',
    denyPrescriptionRefillRequest: 'denyPrescriptionRefillRequest',
    cancelPrescriptionRefillRequest: 'cancelPrescriptionRefillRequest',
    createPressItem: 'createPressItem',
    updatePressItem: 'updatePressItem',
    deletePressItem: 'deletePressItem',
    updateProduct: 'updateProduct',
    executeApprovedChange: 'executeApprovedChange',
    triggerSyncForClinic: 'triggerSyncForClinic',
    updateReschedule: 'updateReschedule',
    approveReschedule: 'approveReschedule',
    denyReschedule: 'denyReschedule',
    createRoomService: 'createRoomService',
    updateRoomService: 'updateRoomService',
    deleteRoomService: 'deleteRoomService',
    updateRoom: 'updateRoom',
    createScheduledBulkMessage: 'createScheduledBulkMessage',
    updateScheduledBulkMessage: 'updateScheduledBulkMessage',
    archiveScheduledBulkMessage: 'archiveScheduledBulkMessage',
    deleteScheduledBulkMessage: 'deleteScheduledBulkMessage',
    bulkUpdateScheduledBulkMessages: 'bulkUpdateScheduledBulkMessages',
    createScheduledMessage: 'createScheduledMessage',
    updateScheduledMessage: 'updateScheduledMessage',
    cancelScheduledMessage: 'cancelScheduledMessage',
    deleteScheduledMessage: 'deleteScheduledMessage',
    updateSchedulingRules: 'updateSchedulingRules',
    createSchedulingRules: 'createSchedulingRules',
    deleteSchedulingRule: 'deleteSchedulingRule',
    createServiceCategory: 'createServiceCategory',
    updateServiceCategory: 'updateServiceCategory',
    deleteServiceCategory: 'deleteServiceCategory',
    createServiceForm: 'createServiceForm',
    updateServiceForm: 'updateServiceForm',
    deleteServiceForm: 'deleteServiceForm',
    createService: 'createService',
    createClinicService: 'createClinicService',
    updateService: 'updateService',
    updateClinicService: 'updateClinicService',
    deleteService: 'deleteService',
    deleteClinicService: 'deleteClinicService',
    sendSupportBotMessage: 'sendSupportBotMessage',
    createUserTrackingBulkMessage: 'createUserTrackingBulkMessage',
    updateUserDesktopNotificationToken: 'updateUserDesktopNotificationToken',
    createUser: 'createUser',
    updateUser: 'updateUser',
    bulkCreateUsers: 'bulkCreateUsers',
    forcePasswordReset: 'forcePasswordReset',
    resendInviteEmail: 'resendInviteEmail',
    updateUserAuthInfo: 'updateUserAuthInfo',
    shareVaccineRecords: 'shareVaccineRecords',
    triggerWebhookTest: 'triggerWebhookTest',
    createWidgetOptions: 'createWidgetOptions',
    updateWidgetOptions: 'updateWidgetOptions',
    createWidgetService: 'createWidgetService',
    updateWidgetService: 'updateWidgetService',
    deleteWidgetService: 'deleteWidgetService',
    createWidget: 'createWidget',
    updateWidget: 'updateWidget',
    deleteWidget: 'deleteWidget'
  },
  Fragment: {
    UserBasicInfo: 'UserBasicInfo',
    ActionItemBaseFields: 'ActionItemBaseFields',
    ActionItemFields: 'ActionItemFields',
    ActionItemRescheduleFields: 'ActionItemRescheduleFields',
    PendingAppointmentPreviewFields: 'PendingAppointmentPreviewFields',
    AppointmentWithActionItemsFields: 'AppointmentWithActionItemsFields',
    RescheduleWithActionItemsFields: 'RescheduleWithActionItemsFields',
    AiVoiceOptionFields: 'AiVoiceOptionFields',
    AiAgentPromptFields: 'AiAgentPromptFields',
    AiImprovementItemFields: 'AiImprovementItemFields',
    AnimalFields: 'AnimalFields',
    AppointmentPromptFields: 'AppointmentPromptFields',
    AppointmentBaseFields: 'AppointmentBaseFields',
    AppointmentPreviewFields: 'AppointmentPreviewFields',
    AppointmentDailyHuddleFields: 'AppointmentDailyHuddleFields',
    AppointmentDailyHuddleUserTrackingFields: 'AppointmentDailyHuddleUserTrackingFields',
    AppointmentSchedulePreviewFields: 'AppointmentSchedulePreviewFields',
    AppointmentFields: 'AppointmentFields',
    PublicAppointmentTimeFields: 'PublicAppointmentTimeFields',
    TimeSlotClinicianFields: 'TimeSlotClinicianFields',
    TimeSlotFields: 'TimeSlotFields',
    ClientInfoFields: 'ClientInfoFields',
    PatientInfoFields: 'PatientInfoFields',
    TimeSlotSchedulingFields: 'TimeSlotSchedulingFields',
    ClinicGroupAppointmentFields: 'ClinicGroupAppointmentFields',
    AppointmentCsvExportFields: 'AppointmentCsvExportFields',
    BookingFlowFunnelStepFields: 'BookingFlowFunnelStepFields',
    WidgetBookingSourceStatsFields: 'WidgetBookingSourceStatsFields',
    ClinicBookingSourceStatsFields: 'ClinicBookingSourceStatsFields',
    BookingAttributionStatsFields: 'BookingAttributionStatsFields',
    BreedFields: 'BreedFields',
    BreedDisplayFields: 'BreedDisplayFields',
    CallFields: 'CallFields',
    CampaignStatsFields: 'CampaignStatsFields',
    CampaignWidgetStatFields: 'CampaignWidgetStatFields',
    CampaignNotificationStatFields: 'CampaignNotificationStatFields',
    CampaignBulkMessageStatFields: 'CampaignBulkMessageStatFields',
    CampaignFields: 'CampaignFields',
    CampaignPreviewFields: 'CampaignPreviewFields',
    ChangeLogFields: 'ChangeLogFields',
    ChatStatusFields: 'ChatStatusFields',
    ChatFields: 'ChatFields',
    ChatClinicFields: 'ChatClinicFields',
    ChatPreviewFields: 'ChatPreviewFields',
    ChatBasicInfoFields: 'ChatBasicInfoFields',
    CheckInFields: 'CheckInFields',
    ClientFormFields: 'ClientFormFields',
    ClientFormBasicInfoFields: 'ClientFormBasicInfoFields',
    ClientFields: 'ClientFields',
    ClientPortalAppFields: 'ClientPortalAppFields',
    ClientPreviewFields: 'ClientPreviewFields',
    ClientBasicInfoFields: 'ClientBasicInfoFields',
    ClientSettingsFields: 'ClientSettingsFields',
    ClientLoyaltyMemberFields: 'ClientLoyaltyMemberFields',
    ClientPhoneFields: 'ClientPhoneFields',
    ClientEmailFields: 'ClientEmailFields',
    ClientNoteFields: 'ClientNoteFields',
    ClinicAdminFields: 'ClinicAdminFields',
    ClinicAdminPermissionFields: 'ClinicAdminPermissionFields',
    ClinicAdminFieldsForLogin: 'ClinicAdminFieldsForLogin',
    YesterdayAnalyticsFields: 'YesterdayAnalyticsFields',
    RevenueByClinicianFields: 'RevenueByClinicianFields',
    TodayAnalyticsFields: 'TodayAnalyticsFields',
    TomorrowAnalyticsFields: 'TomorrowAnalyticsFields',
    ClinicAnalyticsFields: 'ClinicAnalyticsFields',
    AnalyticsNumbersFields: 'AnalyticsNumbersFields',
    ClinicApptStatusFields: 'ClinicApptStatusFields',
    ClinicApptStatusBasicInfoFields: 'ClinicApptStatusBasicInfoFields',
    ClinicGroupPreviewFields: 'ClinicGroupPreviewFields',
    CGCClinicFields: 'CGCClinicFields',
    ClinicGroupClinicFields: 'ClinicGroupClinicFields',
    CGUUserFields: 'CGUUserFields',
    ClinicGroupUserFields: 'ClinicGroupUserFields',
    SubClinicGroupFields: 'SubClinicGroupFields',
    ClinicGroupFields: 'ClinicGroupFields',
    ClinicSexFields: 'ClinicSexFields',
    ClinicSpeciesFields: 'ClinicSpeciesFields',
    ClinicianServiceFields: 'ClinicianServiceFields',
    AvailabilityDayFields: 'AvailabilityDayFields',
    AdjustedAvailabilityFields: 'AdjustedAvailabilityFields',
    ClinicianFields: 'ClinicianFields',
    ClinicianPreviewFields: 'ClinicianPreviewFields',
    OnDemandClinicianFields: 'OnDemandClinicianFields',
    AddressFields: 'AddressFields',
    ClinicFields: 'ClinicFields',
    ClinicFeatureFields: 'ClinicFeatureFields',
    ClinicSettingsFields: 'ClinicSettingsFields',
    PortalLinkFields: 'PortalLinkFields',
    ClinicBookingCopyFields: 'ClinicBookingCopyFields',
    ClinicReviewsCopyFields: 'ClinicReviewsCopyFields',
    ClinicPreviewFields: 'ClinicPreviewFields',
    ClinicDisplayFields: 'ClinicDisplayFields',
    ClinicUsageFields: 'ClinicUsageFields',
    UsageCountsFields: 'UsageCountsFields',
    LastSyncTimesFields: 'LastSyncTimesFields',
    ClinicUsageStatsFields: 'ClinicUsageStatsFields',
    ClinicStatsFields: 'ClinicStatsFields',
    ClinicOnboardingClinicFields: 'ClinicOnboardingClinicFields',
    ClinicBasicInfoFields: 'ClinicBasicInfoFields',
    ClinicOnboardingFields: 'ClinicOnboardingFields',
    ConnectInstallationFields: 'ConnectInstallationFields',
    CustomRoleFields: 'CustomRoleFields',
    CustomRoleWithRelationsFields: 'CustomRoleWithRelationsFields',
    QueryFilterFields: 'QueryFilterFields',
    CustomerSegmentPreviewFields: 'CustomerSegmentPreviewFields',
    CustomerSegmentBaseInfoFields: 'CustomerSegmentBaseInfoFields',
    CustomerSegmentFields: 'CustomerSegmentFields',
    CustomerSegmentErrorFlagFields: 'CustomerSegmentErrorFlagFields',
    SegmentFilterFields: 'SegmentFilterFields',
    ReferenceDateParamsFields: 'ReferenceDateParamsFields',
    ReferencePeriodFields: 'ReferencePeriodFields',
    CustomerSegmentResultFields: 'CustomerSegmentResultFields',
    LeadContactPreviewFields: 'LeadContactPreviewFields',
    BookingFlowSessionPreviewFields: 'BookingFlowSessionPreviewFields',
    DailyHuddleFields: 'DailyHuddleFields',
    DataChatPreviewFields: 'DataChatPreviewFields',
    DataChatFields: 'DataChatFields',
    DataChatPromptFields: 'DataChatPromptFields',
    DataChatResponseRowFields: 'DataChatResponseRowFields',
    DataChatResponseAppointmentFields: 'DataChatResponseAppointmentFields',
    DataChatResponseClientFields: 'DataChatResponseClientFields',
    DiagnosisFields: 'DiagnosisFields',
    EmailTemplateFields: 'EmailTemplateFields',
    ClinicGroupOnboardingStepFields: 'ClinicGroupOnboardingStepFields',
    ClinicGroupOnboardingTrancheFields: 'ClinicGroupOnboardingTrancheFields',
    ClinicGroupOnboardingColumnConfigFields: 'ClinicGroupOnboardingColumnConfigFields',
    ClinicGroupOnboardingCellNoteChangeFields: 'ClinicGroupOnboardingCellNoteChangeFields',
    ClinicGroupOnboardingCellNoteFields: 'ClinicGroupOnboardingCellNoteFields',
    OnboardingClinicSettingsFields: 'OnboardingClinicSettingsFields',
    OnboardingClinicFeatureFields: 'OnboardingClinicFeatureFields',
    EnterpriseOnboardingRowFields: 'EnterpriseOnboardingRowFields',
    DrilldownRowFields: 'DrilldownRowFields',
    EntityReportSharedFields: 'EntityReportSharedFields',
    EntityReportFields: 'EntityReportFields',
    FirstChildReportFields: 'FirstChildReportFields',
    SecondChildReportFields: 'SecondChildReportFields',
    ReportValueFields: 'ReportValueFields',
    EntityReportClinicianFields: 'EntityReportClinicianFields',
    EntityReportServiceFields: 'EntityReportServiceFields',
    EntityReportProductFields: 'EntityReportProductFields',
    InitiativeFields: 'InitiativeFields',
    InitiativePreviewFields: 'InitiativePreviewFields',
    InitiativeMetricFields: 'InitiativeMetricFields',
    InitiativeResultFields: 'InitiativeResultFields',
    InitiativeMetricResultFields: 'InitiativeMetricResultFields',
    InitiativeMetricSegmentFields: 'InitiativeMetricSegmentFields',
    KpiGroupPreviewFields: 'KpiGroupPreviewFields',
    KpiGroupFields: 'KpiGroupFields',
    KpiGroupMetricFields: 'KpiGroupMetricFields',
    KpiGroupResultValueFields: 'KpiGroupResultValueFields',
    KpiGroupResultFields: 'KpiGroupResultFields',
    KpiGroupMetricResultFields: 'KpiGroupMetricResultFields',
    OrganizationReportFields: 'OrganizationReportFields',
    OrganizationReportPreviewFields: 'OrganizationReportPreviewFields',
    ReportClinicClinicFields: 'ReportClinicClinicFields',
    ReportClinicFields: 'ReportClinicFields',
    ReportMetricFields: 'ReportMetricFields',
    ReportMetricPreviewFields: 'ReportMetricPreviewFields',
    TimeParamFields: 'TimeParamFields',
    MetricValueParamsFields: 'MetricValueParamsFields',
    ReportMetricModifierFields: 'ReportMetricModifierFields',
    ReportTemplateFields: 'ReportTemplateFields',
    ReportTemplatePreviewFields: 'ReportTemplatePreviewFields',
    ReportTemplateMetricFields: 'ReportTemplateMetricFields',
    ReportEntityFields: 'ReportEntityFields',
    ChildReportEntityFields: 'ChildReportEntityFields',
    SecondChildReportEntityFields: 'SecondChildReportEntityFields',
    RepeatParamsFields: 'RepeatParamsFields',
    ReportTemplateResultFields: 'ReportTemplateResultFields',
    TemplateClinicClinicFields: 'TemplateClinicClinicFields',
    TemplateClinicFields: 'TemplateClinicFields',
    ClinicReportTemplateFields: 'ClinicReportTemplateFields',
    TrendReportFields: 'TrendReportFields',
    TrendTimeRangeFields: 'TrendTimeRangeFields',
    TrendSegmentFields: 'TrendSegmentFields',
    EntityLinkFields: 'EntityLinkFields',
    FormElementFields: 'FormElementFields',
    FormPageFields: 'FormPageFields',
    FormFields: 'FormFields',
    FormPreviewFields: 'FormPreviewFields',
    FormAnalyticsFields: 'FormAnalyticsFields',
    GoalsFields: 'GoalsFields',
    InternalChatMessageAttachmentFields: 'InternalChatMessageAttachmentFields',
    InternalChatMessageFields: 'InternalChatMessageFields',
    InternalChatUserFields: 'InternalChatUserFields',
    InternalChatUserPreviewFields: 'InternalChatUserPreviewFields',
    InternalChatFields: 'InternalChatFields',
    InternalUsageEventFields: 'InternalUsageEventFields',
    InternalUsageClinicFields: 'InternalUsageClinicFields',
    InternalUsageUserFields: 'InternalUsageUserFields',
    InvoiceFields: 'InvoiceFields',
    InvoicePreviewFields: 'InvoicePreviewFields',
    InvoiceItemFields: 'InvoiceItemFields',
    DetailedInvoiceFields: 'DetailedInvoiceFields',
    LoyaltyClientFields: 'LoyaltyClientFields',
    LoyaltyMemberFields: 'LoyaltyMemberFields',
    LoyaltyRewardFields: 'LoyaltyRewardFields',
    LoyaltyRedemptionFields: 'LoyaltyRedemptionFields',
    LoyaltyEarningFields: 'LoyaltyEarningFields',
    BookingSourceBreakdownFields: 'BookingSourceBreakdownFields',
    MarketingSummaryStatsFields: 'MarketingSummaryStatsFields',
    OrgCampaignStatsFields: 'OrgCampaignStatsFields',
    OrgNotificationStatsFields: 'OrgNotificationStatsFields',
    OrgBulkMessageStatsFields: 'OrgBulkMessageStatsFields',
    ReminderAttributedAppointmentIdsFields: 'ReminderAttributedAppointmentIdsFields',
    MessageTemplateFields: 'MessageTemplateFields',
    AttachmentFields: 'AttachmentFields',
    MessagePatientFields: 'MessagePatientFields',
    MessageNotificationTemplateFields: 'MessageNotificationTemplateFields',
    MessageFields: 'MessageFields',
    NotificationLogMessageFields: 'NotificationLogMessageFields',
    ChatMessageFields: 'ChatMessageFields',
    MsgTrackingEventFields: 'MsgTrackingEventFields',
    NotificationEngagementStatsFields: 'NotificationEngagementStatsFields',
    NotificationEngagementFields: 'NotificationEngagementFields',
    NotificationCategoryEngagementFields: 'NotificationCategoryEngagementFields',
    MedicalReminderFunnelCountsFields: 'MedicalReminderFunnelCountsFields',
    MedicalReminderNotificationFunnelFields: 'MedicalReminderNotificationFunnelFields',
    MedicalReminderFunnelFields: 'MedicalReminderFunnelFields',
    NotificationTemplateFields: 'NotificationTemplateFields',
    NotificationTemplatePreviewFields: 'NotificationTemplatePreviewFields',
    UserNotificationFields: 'UserNotificationFields',
    OrganizationClinicAnalyticsNumbersFields: 'OrganizationClinicAnalyticsNumbersFields',
    OrganizationAnalyticsFields: 'OrganizationAnalyticsFields',
    OrganizationAnalyticsNumbersFields: 'OrganizationAnalyticsNumbersFields',
    OrganizationClinicFields: 'OrganizationClinicFields',
    OrganizationAdminFields: 'OrganizationAdminFields',
    OrganizationFields: 'OrganizationFields',
    OrganizationSettingsFields: 'OrganizationSettingsFields',
    PatientHistoryItemFields: 'PatientHistoryItemFields',
    PatientPreviewFields: 'PatientPreviewFields',
    PatientDisplayFields: 'PatientDisplayFields',
    PatientFields: 'PatientFields',
    PatientNoteFields: 'PatientNoteFields',
    OverduePatientWithAppointmentFields: 'OverduePatientWithAppointmentFields',
    PaymentFields: 'PaymentFields',
    PaymentPreviewFields: 'PaymentPreviewFields',
    PatientRecordFields: 'PatientRecordFields',
    PetSelfieFields: 'PetSelfieFields',
    PimsLookupPatientFields: 'PimsLookupPatientFields',
    PimsLookupClientFields: 'PimsLookupClientFields',
    PimsReminderPreviewFields: 'PimsReminderPreviewFields',
    PimsReminderDisplayFields: 'PimsReminderDisplayFields',
    PatientPimsReminderFields: 'PatientPimsReminderFields',
    PimsReminderTypeFields: 'PimsReminderTypeFields',
    PimsSettingsFields: 'PimsSettingsFields',
    OnDemandPaymentTypeFields: 'OnDemandPaymentTypeFields',
    PmsApptTypeFields: 'PmsApptTypeFields',
    PmsDbFields: 'PmsDbFields',
    PmsTagCategoryFields: 'PmsTagCategoryFields',
    PmsTagFields: 'PmsTagFields',
    PrescriptionRefillRequestFields: 'PrescriptionRefillRequestFields',
    PrescriptionFields: 'PrescriptionFields',
    PressItemFields: 'PressItemFields',
    ProductFields: 'ProductFields',
    PrescriptionPricingFields: 'PrescriptionPricingFields',
    PmsCodeFields: 'PmsCodeFields',
    RescheduleAppointmentFields: 'RescheduleAppointmentFields',
    RescheduleFields: 'RescheduleFields',
    ReviewFields: 'ReviewFields',
    ReviewPreviewFields: 'ReviewPreviewFields',
    ReviewAnalyticsFields: 'ReviewAnalyticsFields',
    RoomServiceFields: 'RoomServiceFields',
    RoomFields: 'RoomFields',
    RoomPreviewFields: 'RoomPreviewFields',
    ScheduledBulkMessageFields: 'ScheduledBulkMessageFields',
    LinkedBulkMessageChildFields: 'LinkedBulkMessageChildFields',
    ScheduledMessageFields: 'ScheduledMessageFields',
    SchedulingRulesFields: 'SchedulingRulesFields',
    SchedulingRulesCategorizedFields: 'SchedulingRulesCategorizedFields',
    ServiceCategoryFields: 'ServiceCategoryFields',
    ServiceServiceCategoryFields: 'ServiceServiceCategoryFields',
    ServiceFormFields: 'ServiceFormFields',
    PricingFields: 'PricingFields',
    ServicePreConfirmationItemFields: 'ServicePreConfirmationItemFields',
    ServiceFields: 'ServiceFields',
    ServicePreviewFields: 'ServicePreviewFields',
    StripeAccountInfoFields: 'StripeAccountInfoFields',
    SupportBotMessageAttachmentFields: 'SupportBotMessageAttachmentFields',
    SupportBotMessageFields: 'SupportBotMessageFields',
    SupportBotConversationOwnerFields: 'SupportBotConversationOwnerFields',
    SupportBotConversationFields: 'SupportBotConversationFields',
    SupportBotRunSnapshotFields: 'SupportBotRunSnapshotFields',
    FillRateResultFields: 'FillRateResultFields',
    TransactionFields: 'TransactionFields',
    UserTrackingMetricFields: 'UserTrackingMetricFields',
    UserFields: 'UserFields',
    PatientVaccinationRecordFields: 'PatientVaccinationRecordFields',
    WebhookConfigFields: 'WebhookConfigFields',
    WidgetOptionsFields: 'WidgetOptionsFields',
    WidgetStylesFields: 'WidgetStylesFields',
    ClinicImageMapFields: 'ClinicImageMapFields',
    WidgetServiceFields: 'WidgetServiceFields',
    WidgetFields: 'WidgetFields',
    WidgetPreviewFields: 'WidgetPreviewFields',
    WidgetFeaturedReviewFields: 'WidgetFeaturedReviewFields',
    WidgetWithServicesFields: 'WidgetWithServicesFields'
  }
}